/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				var _m = moreModules[moduleId];
/******/
/******/ 				// Check if module is deduplicated
/******/ 				switch(typeof _m) {
/******/ 				case "object":
/******/ 					// Module can be created from a template
/******/ 					modules[moduleId] = (function(_m) {
/******/ 						var args = _m.slice(1), templateId = _m[0];
/******/ 						return function (a,b,c) {
/******/ 							modules[templateId].apply(this, [a,b,c].concat(args));
/******/ 						};
/******/ 					}(_m));
/******/ 					break;
/******/ 				case "function":
/******/ 					// Normal module
/******/ 					modules[moduleId] = _m;
/******/ 					break;
/******/ 				default:
/******/ 					// Module is a copy of another module
/******/ 					modules[moduleId] = modules[_m];
/******/ 					break;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		1:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + ({"0":"app"}[chunkId]||chunkId) + "." + "450ec589350894d91302" + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1026);
	__webpack_require__(1068);
	__webpack_require__(1010);
	__webpack_require__(1014);
	__webpack_require__(1076);
	__webpack_require__(1078);
	__webpack_require__(1080);
	__webpack_require__(1082);
	__webpack_require__(1084);
	__webpack_require__(1091);
	__webpack_require__(1100);
	__webpack_require__(1108);
	__webpack_require__(1112);
	__webpack_require__(1116);
	__webpack_require__(1120);
	__webpack_require__(981);
	__webpack_require__(1248);
	__webpack_require__(988);
	__webpack_require__(990);
	__webpack_require__(994);
	__webpack_require__(998);
	__webpack_require__(1000);
	__webpack_require__(1002);
	__webpack_require__(1004);
	__webpack_require__(1008);
	__webpack_require__(1010);
	__webpack_require__(1018);
	__webpack_require__(1020);
	__webpack_require__(1024);
	__webpack_require__(1030);
	__webpack_require__(1032);
	__webpack_require__(1034);
	module.exports = __webpack_require__(1037);


/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(113);

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v2.1.3
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2014-12-18T15:11Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//
	
	var arr = [];
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		// Use the correct document accordingly with window argument (sandbox)
		document = window.document,
	
		version = "2.1.3",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		// (You can seed the arguments with an array of args, but this is
		// only used internally.)
		each: function( callback, args ) {
			return jQuery.each( this, callback, args );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map(this, function( elem, i ) {
				return callback.call( elem, i, elem );
			}));
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor(null);
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[0] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
			// Only deal with non-null/undefined values
			if ( (options = arguments[ i ]) != null ) {
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray(src) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject(src) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend({
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type(obj) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			return !jQuery.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
		},
	
		isPlainObject: function( obj ) {
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			if ( obj.constructor &&
					!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
				return false;
			}
	
			// If the function hasn't returned already, we're confident that
			// |obj| is a plain object, created by {} or constructed with new Object
			return true;
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call(obj) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf("use strict") === 1 ) {
					script = document.createElement("script");
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
				// Otherwise, avoid the DOM node creation, insertion
				// and removal by using an indirect global eval
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		// args is for internal usage only
		each: function( obj, callback, args ) {
			var value,
				i = 0,
				length = obj.length,
				isArray = isArraylike( obj );
	
			if ( args ) {
				if ( isArray ) {
					for ( ; i < length; i++ ) {
						value = callback.apply( obj[ i ], args );
	
						if ( value === false ) {
							break;
						}
					}
				} else {
					for ( i in obj ) {
						value = callback.apply( obj[ i ], args );
	
						if ( value === false ) {
							break;
						}
					}
				}
	
			// A special, fast, case for the most common use of each
			} else {
				if ( isArray ) {
					for ( ; i < length; i++ ) {
						value = callback.call( obj[ i ], i, obj[ i ] );
	
						if ( value === false ) {
							break;
						}
					}
				} else {
					for ( i in obj ) {
						value = callback.call( obj[ i ], i, obj[ i ] );
	
						if ( value === false ) {
							break;
						}
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArraylike( Object(arr) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var value,
				i = 0,
				length = elems.length,
				isArray = isArraylike( elems ),
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	});
	
	// Populate the class2type map
	jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	});
	
	function isArraylike( obj ) {
		var length = obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		if ( obj.nodeType === 1 && length ) {
			return true;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.0-pre
	 * http://sizzlejs.com/
	 *
	 * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2014-12-16
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
		// http://www.w3.org/TR/css3-syntax/#characters
		characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Loosely modeled on CSS identifier characters
		// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
		// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = characterEncoding.replace( "w", "w#" ),
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + characterEncoding + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + characterEncoding + ")" ),
			"CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
			"TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var match, elem, m, nodeType,
			// QSA vars
			i, groups, old, nid, newContext, newSelector;
	
		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
	
		context = context || document;
		results = results || [];
		nodeType = context.nodeType;
	
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		if ( !seed && documentIsHTML ) {
	
			// Try to shortcut find operations when possible (e.g., not under DocumentFragment)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
				// Speed-up: Sizzle("#ID")
				if ( (m = match[1]) ) {
					if ( nodeType === 9 ) {
						elem = context.getElementById( m );
						// Check parentNode to catch when Blackberry 4.6 returns
						// nodes that are no longer in the document (jQuery #6963)
						if ( elem && elem.parentNode ) {
							// Handle the case where IE, Opera, and Webkit return items
							// by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}
					} else {
						// Context is not a document
						if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
							contains( context, elem ) && elem.id === m ) {
							results.push( elem );
							return results;
						}
					}
	
				// Speed-up: Sizzle("TAG")
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;
	
				// Speed-up: Sizzle(".CLASS")
				} else if ( (m = match[3]) && support.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}
	
			// QSA path
			if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
				nid = old = expando;
				newContext = context;
				newSelector = nodeType !== 1 && selector;
	
				// qSA works strangely on Element-rooted queries
				// We can work around this by specifying an extra ID on the root
				// and working up from there (Thanks to Andrew Dupont for the technique)
				// IE 8 doesn't work on object elements
				if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
					groups = tokenize( selector );
	
					if ( (old = context.getAttribute("id")) ) {
						nid = old.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", nid );
					}
					nid = "[id='" + nid + "'] ";
	
					i = groups.length;
					while ( i-- ) {
						groups[i] = nid + toSelector( groups[i] );
					}
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
					newSelector = groups.join(",");
				}
	
				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch(qsaError) {
					} finally {
						if ( !old ) {
							context.removeAttribute("id");
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = attrs.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// If no document and documentElement is available, return
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Set our document
		document = doc;
		docElem = doc.documentElement;
		parent = doc.defaultView;
	
		// Support: IE>8
		// If iframe document is assigned to "document" variable and if iframe has been reloaded,
		// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
		// IE6-8 do not support the defaultView property so parent will be undefined
		if ( parent && parent !== parent.top ) {
			// IE11 does not have attachEvent, so all must suffer
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Support tests
		---------------------------------------------------------------------- */
		documentIsHTML = !isXML( doc );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( doc.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( doc.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document #6963
					return m && m.parentNode ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\f]' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.2+, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.7+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = doc.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully does not implement inclusive descendent
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === doc ? -1 :
					b === doc ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return doc;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, outerCache, node, diff, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || (parent[ expando ] = {});
								cache = outerCache[ type ] || [];
								nodeIndex = cache[0] === dirruns && cache[1];
								diff = cache[0] === dirruns && cache[2];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							// Use previously-cached element index if available
							} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
								diff = cache[1];
	
							// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
							} else {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
										// Cache the index of each encountered element
										if ( useCache ) {
											(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
										}
	
										if ( node === elem ) {
											break;
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
							if ( (oldCache = outerCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context !== document && context;
				}
	
				// Add elements passing elementMatchers directly to results
				// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// Apply set filters to unmatched elements
				matchedCount += i;
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is no seed and only one group
		if ( match.length === 1 ) {
	
			// Take a shortcut and set the context if the root selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[":"] = jQuery.expr.pseudos;
	jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			});
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			});
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) >= 0 ) !== not;
		});
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			}));
	};
	
	jQuery.fn.extend({
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter(function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				}) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow(this, selector || [], false) );
		},
		not: function( selector ) {
			return this.pushStack( winnow(this, selector || [], true) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	});
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[0] === "<" && selector[ selector.length - 1 ] === ">" && selector.length >= 3 ) {
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && (match[1] || !context) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[1] ) {
						context = context instanceof jQuery ? context[0] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[1],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[2] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[0] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || rootjQuery ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[0] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return typeof rootjQuery.ready !== "undefined" ?
					rootjQuery.ready( selector ) :
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.extend({
		dir: function( elem, dir, until ) {
			var matched = [],
				truncate = until !== undefined;
	
			while ( (elem = elem[ dir ]) && elem.nodeType !== 9 ) {
				if ( elem.nodeType === 1 ) {
					if ( truncate && jQuery( elem ).is( until ) ) {
						break;
					}
					matched.push( elem );
				}
			}
			return matched;
		},
	
		sibling: function( n, elem ) {
			var matched = [];
	
			for ( ; n; n = n.nextSibling ) {
				if ( n.nodeType === 1 && n !== elem ) {
					matched.push( n );
				}
			}
	
			return matched;
		}
	});
	
	jQuery.fn.extend({
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter(function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[i] ) ) {
						return true;
					}
				}
			});
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
					// Always skip document fragments
					if ( cur.nodeType < 11 && (pos ?
						pos.index(cur) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector(cur, selectors)) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.unique(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter(selector)
			);
		}
	});
	
	function sibling( cur, dir ) {
		while ( (cur = cur[dir]) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each({
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return jQuery.dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return jQuery.dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return jQuery.dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return jQuery.sibling( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.unique( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	});
	var rnotwhite = (/\S+/g);
	
	
	
	// String to Object options format cache
	var optionsCache = {};
	
	// Convert String-formatted options into Object-formatted ones and store in cache
	function createOptions( options ) {
		var object = optionsCache[ options ] = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		});
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			( optionsCache[ options ] || createOptions( options ) ) :
			jQuery.extend( {}, options );
	
		var // Last fire value (for non-forgettable lists)
			memory,
			// Flag to know if list was already fired
			fired,
			// Flag to know if list is currently firing
			firing,
			// First callback to fire (used internally by add and fireWith)
			firingStart,
			// End of the loop when firing
			firingLength,
			// Index of currently firing callback (modified by remove if needed)
			firingIndex,
			// Actual callback list
			list = [],
			// Stack of fire calls for repeatable lists
			stack = !options.once && [],
			// Fire callbacks
			fire = function( data ) {
				memory = options.memory && data;
				fired = true;
				firingIndex = firingStart || 0;
				firingStart = 0;
				firingLength = list.length;
				firing = true;
				for ( ; list && firingIndex < firingLength; firingIndex++ ) {
					if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
						memory = false; // To prevent further calls using add
						break;
					}
				}
				firing = false;
				if ( list ) {
					if ( stack ) {
						if ( stack.length ) {
							fire( stack.shift() );
						}
					} else if ( memory ) {
						list = [];
					} else {
						self.disable();
					}
				}
			},
			// Actual Callbacks object
			self = {
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
						// First, we save the current length
						var start = list.length;
						(function add( args ) {
							jQuery.each( args, function( _, arg ) {
								var type = jQuery.type( arg );
								if ( type === "function" ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && type !== "string" ) {
									// Inspect recursively
									add( arg );
								}
							});
						})( arguments );
						// Do we need to add the callbacks to the
						// current firing batch?
						if ( firing ) {
							firingLength = list.length;
						// With memory, if we're not firing then
						// we should call right away
						} else if ( memory ) {
							firingStart = start;
							fire( memory );
						}
					}
					return this;
				},
				// Remove a callback from the list
				remove: function() {
					if ( list ) {
						jQuery.each( arguments, function( _, arg ) {
							var index;
							while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
								list.splice( index, 1 );
								// Handle firing indexes
								if ( firing ) {
									if ( index <= firingLength ) {
										firingLength--;
									}
									if ( index <= firingIndex ) {
										firingIndex--;
									}
								}
							}
						});
					}
					return this;
				},
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
				},
				// Remove all callbacks from the list
				empty: function() {
					list = [];
					firingLength = 0;
					return this;
				},
				// Have the list do nothing anymore
				disable: function() {
					list = stack = memory = undefined;
					return this;
				},
				// Is it disabled?
				disabled: function() {
					return !list;
				},
				// Lock the list in its current state
				lock: function() {
					stack = undefined;
					if ( !memory ) {
						self.disable();
					}
					return this;
				},
				// Is it locked?
				locked: function() {
					return !stack;
				},
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( list && ( !fired || stack ) ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						if ( firing ) {
							stack.push( args );
						} else {
							fire( args );
						}
					}
					return this;
				},
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend({
	
		Deferred: function( func ) {
			var tuples = [
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks("memory") ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred(function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[1] ](function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.done( newDefer.resolve )
											.fail( newDefer.reject )
											.progress( newDefer.notify );
									} else {
										newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
									}
								});
							});
							fns = null;
						}).promise();
					},
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[1] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(function() {
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[0] ] = function() {
					deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[0] + "With" ] = list.fireWith;
			});
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred. If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject )
							.progress( updateFunc( i, progressContexts, progressValues ) );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	});
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend({
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	});
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed, false );
		window.removeEventListener( "load", completed, false );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called after the browser event has already occurred.
			// We once tried to use readyState "interactive" here, but it caused issues like the one
			// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
			if ( document.readyState === "complete" ) {
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed, false );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed, false );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[0], key ) : emptyGet;
	};
	
	
	/**
	 * Determines whether an object can have data
	 */
	jQuery.acceptData = function( owner ) {
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	function Data() {
		// Support: Android<4,
		// Old WebKit does not have Object.preventExtensions/freeze method,
		// return new empty object instead with no [[set]] accessor
		Object.defineProperty( this.cache = {}, 0, {
			get: function() {
				return {};
			}
		});
	
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	Data.accepts = jQuery.acceptData;
	
	Data.prototype = {
		key: function( owner ) {
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return the key for a frozen object.
			if ( !Data.accepts( owner ) ) {
				return 0;
			}
	
			var descriptor = {},
				// Check if the owner object already has a cache key
				unlock = owner[ this.expando ];
	
			// If not, create one
			if ( !unlock ) {
				unlock = Data.uid++;
	
				// Secure it in a non-enumerable, non-writable property
				try {
					descriptor[ this.expando ] = { value: unlock };
					Object.defineProperties( owner, descriptor );
	
				// Support: Android<4
				// Fallback to a less secure definition
				} catch ( e ) {
					descriptor[ this.expando ] = unlock;
					jQuery.extend( owner, descriptor );
				}
			}
	
			// Ensure the cache object
			if ( !this.cache[ unlock ] ) {
				this.cache[ unlock ] = {};
			}
	
			return unlock;
		},
		set: function( owner, data, value ) {
			var prop,
				// There may be an unlock assigned to this node,
				// if there is no entry for this "owner", create one inline
				// and set the unlock as though an owner entry had always existed
				unlock = this.key( owner ),
				cache = this.cache[ unlock ];
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
				// Fresh assignments by object are shallow copied
				if ( jQuery.isEmptyObject( cache ) ) {
					jQuery.extend( this.cache[ unlock ], data );
				// Otherwise, copy the properties one-by-one to the cache object
				} else {
					for ( prop in data ) {
						cache[ prop ] = data[ prop ];
					}
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			// Either a valid cache is found, or will be created.
			// New caches will be created and the unlock returned,
			// allowing direct access to the newly created
			// empty data object. A valid owner object must be provided.
			var cache = this.cache[ this.key( owner ) ];
	
			return key === undefined ?
				cache : cache[ key ];
		},
		access: function( owner, key, value ) {
			var stored;
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					((key && typeof key === "string") && value === undefined) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase(key) );
			}
	
			// [*]When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				unlock = this.key( owner ),
				cache = this.cache[ unlock ];
	
			if ( key === undefined ) {
				this.cache[ unlock ] = {};
	
			} else {
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
		},
		hasData: function( owner ) {
			return !jQuery.isEmptyObject(
				this.cache[ owner[ this.expando ] ] || {}
			);
		},
		discard: function( owner ) {
			if ( owner[ this.expando ] ) {
				delete this.cache[ owner[ this.expando ] ];
			}
		}
	};
	var data_priv = new Data();
	
	var data_user = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /([A-Z])/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch( e ) {}
	
				// Make sure we set the data so it isn't changed later
				data_user.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend({
		hasData: function( elem ) {
			return data_user.hasData( elem ) || data_priv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return data_user.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			data_user.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to data_priv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return data_priv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			data_priv.remove( elem, name );
		}
	});
	
	jQuery.fn.extend({
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = data_user.get( elem );
	
					if ( elem.nodeType === 1 && !data_priv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice(5) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						data_priv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each(function() {
					data_user.set( this, key );
				});
			}
	
			return access( this, function( value ) {
				var data,
					camelKey = jQuery.camelCase( key );
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
					// Attempt to get data from the cache
					// with the key as-is
					data = data_user.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to get data from the cache
					// with the key camelized
					data = data_user.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each(function() {
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = data_user.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					data_user.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf("-") !== -1 && data !== undefined ) {
						data_user.set( this, key, value );
					}
				});
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each(function() {
				data_user.remove( this, key );
			});
		}
	});
	
	
	jQuery.extend({
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = data_priv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = data_priv.access( elem, type, jQuery.makeArray(data) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return data_priv.get( elem, key ) || data_priv.access( elem, key, {
				empty: jQuery.Callbacks("once memory").add(function() {
					data_priv.remove( elem, [ type + "queue", key ] );
				})
			});
		}
	});
	
	jQuery.fn.extend({
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[0], type );
			}
	
			return data === undefined ?
				this :
				this.each(function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[0] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				});
		},
		dequeue: function( type ) {
			return this.each(function() {
				jQuery.dequeue( this, type );
			});
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = data_priv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	});
	var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
		};
	
	var rcheckableType = (/^(?:checkbox|radio)$/i);
	
	
	
	(function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	})();
	var strundefined = typeof undefined;
	
	
	
	support.focusinBubbles = "onfocusin" in window;
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
		rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = data_priv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !(events = elemData.events) ) {
				events = elemData.events = {};
			}
			if ( !(eventHandle = elemData.handle) ) {
				eventHandle = elemData.handle = function( e ) {
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== strundefined && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[t] ) || [];
				type = origType = tmp[1];
				namespaces = ( tmp[2] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend({
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join(".")
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !(handlers = events[ type ]) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle, false );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = data_priv.hasData( elem ) && data_priv.get( elem );
	
			if ( !elemData || !(events = elemData.events) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[t] ) || [];
				type = origType = tmp[1];
				namespaces = ( tmp[2] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				delete elemData.handle;
				data_priv.remove( elem, "events" );
			}
		},
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf(".") >= 0 ) {
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split(".");
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf(":") < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join(".");
			event.namespace_re = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === (elem.ownerDocument || document) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( data_priv.get( cur, "events" ) || {} )[ event.type ] && data_priv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
					jQuery.acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( data_priv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[0] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
								.apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( (event.result = ret) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			// Avoid non-left-click bubbling in Firefox (#3861)
			if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.disabled !== true || event.type !== "click" ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) >= 0 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push({ elem: cur, handlers: matches });
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split(" "),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		},
	
		simulate: function( type, elem, event, bubble ) {
			// Piggyback on a donor event to simulate a different one.
			// Fake originalEvent to avoid donor's stopPropagation, but if the
			// simulated event prevents default then we do the same on the donor.
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true,
					originalEvent: {}
				}
			);
			if ( bubble ) {
				jQuery.event.trigger( e, null, elem );
			} else {
				jQuery.event.dispatch.call( elem, e );
			}
			if ( e.isDefaultPrevented() ) {
				event.preventDefault();
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle, false );
		}
	};
	
	jQuery.Event = function( src, props ) {
		// Allow instantiation without the 'new' keyword
		if ( !(this instanceof jQuery.Event) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && e.preventDefault ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && e.stopPropagation ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && e.stopImmediatePropagation ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// Support: Chrome 15+
	jQuery.each({
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mousenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	});
	
	// Support: Firefox, Chrome, Safari
	// Create "bubbling" focus and blur events
	if ( !support.focusinBubbles ) {
		jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
					jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
				};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = data_priv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					data_priv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = data_priv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						data_priv.remove( doc, fix );
	
					} else {
						data_priv.access( doc, fix, attaches );
					}
				}
			};
		});
	}
	
	jQuery.fn.extend({
	
		on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
			var origFn, type;
	
			// Types can be a map of types/handlers
			if ( typeof types === "object" ) {
				// ( types-Object, selector, data )
				if ( typeof selector !== "string" ) {
					// ( types-Object, data )
					data = data || selector;
					selector = undefined;
				}
				for ( type in types ) {
					this.on( type, selector, data, types[ type ], one );
				}
				return this;
			}
	
			if ( data == null && fn == null ) {
				// ( types, fn )
				fn = selector;
				data = selector = undefined;
			} else if ( fn == null ) {
				if ( typeof selector === "string" ) {
					// ( types, selector, fn )
					fn = data;
					data = undefined;
				} else {
					// ( types, data, fn )
					fn = data;
					data = selector;
					selector = undefined;
				}
			}
			if ( fn === false ) {
				fn = returnFalse;
			} else if ( !fn ) {
				return this;
			}
	
			if ( one === 1 ) {
				origFn = fn;
				fn = function( event ) {
					// Can use an empty set, since event contains the info
					jQuery().off( event );
					return origFn.apply( this, arguments );
				};
				// Use same guid so caller can remove using origFn
				fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
			}
			return this.each( function() {
				jQuery.event.add( this, types, fn, data, selector );
			});
		},
		one: function( types, selector, data, fn ) {
			return this.on( types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each(function() {
				jQuery.event.remove( this, types, fn, selector );
			});
		},
	
		trigger: function( type, data ) {
			return this.each(function() {
				jQuery.event.trigger( type, data, this );
			});
		},
		triggerHandler: function( type, data ) {
			var elem = this[0];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	});
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
		rtagName = /<([\w:]+)/,
		rhtml = /<|&#?\w+;/,
		rnoInnerhtml = /<(?:script|style|link)/i,
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptType = /^$|\/(?:java|ecma)script/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
	
		// We have to close these tags to support XHTML (#13200)
		wrapMap = {
	
			// Support: IE9
			option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
			thead: [ 1, "<table>", "</table>" ],
			col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
			tr: [ 2, "<table><tbody>", "</tbody></table>" ],
			td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
			_default: [ 0, "", "" ]
		};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: 1.x compatibility
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName("tbody")[0] ||
				elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute("type");
		}
	
		return elem;
	}
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			data_priv.set(
				elems[ i ], "globalEval", !refElements || data_priv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( data_priv.hasData( src ) ) {
			pdataOld = data_priv.access( src );
			pdataCur = data_priv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( data_user.hasData( src ) ) {
			udataOld = data_user.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			data_user.set( dest, udataCur );
		}
	}
	
	function getAll( context, tag ) {
		var ret = context.getElementsByTagName ? context.getElementsByTagName( tag || "*" ) :
				context.querySelectorAll ? context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	jQuery.extend({
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		buildFragment: function( elems, context, scripts, selection ) {
			var elem, tmp, tag, wrap, contains, j,
				fragment = context.createDocumentFragment(),
				nodes = [],
				i = 0,
				l = elems.length;
	
			for ( ; i < l; i++ ) {
				elem = elems[ i ];
	
				if ( elem || elem === 0 ) {
	
					// Add nodes directly
					if ( jQuery.type( elem ) === "object" ) {
						// Support: QtWebKit, PhantomJS
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
					// Convert non-html into a text node
					} else if ( !rhtml.test( elem ) ) {
						nodes.push( context.createTextNode( elem ) );
	
					// Convert html into DOM nodes
					} else {
						tmp = tmp || fragment.appendChild( context.createElement("div") );
	
						// Deserialize a standard representation
						tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
						wrap = wrapMap[ tag ] || wrapMap._default;
						tmp.innerHTML = wrap[ 1 ] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[ 2 ];
	
						// Descend through wrappers to the right content
						j = wrap[ 0 ];
						while ( j-- ) {
							tmp = tmp.lastChild;
						}
	
						// Support: QtWebKit, PhantomJS
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( nodes, tmp.childNodes );
	
						// Remember the top-level container
						tmp = fragment.firstChild;
	
						// Ensure the created nodes are orphaned (#12392)
						tmp.textContent = "";
					}
				}
			}
	
			// Remove wrapper from fragment
			fragment.textContent = "";
	
			i = 0;
			while ( (elem = nodes[ i++ ]) ) {
	
				// #4087 - If origin and destination elements are the same, and this is
				// that element, do not do anything
				if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
					continue;
				}
	
				contains = jQuery.contains( elem.ownerDocument, elem );
	
				// Append to fragment
				tmp = getAll( fragment.appendChild( elem ), "script" );
	
				// Preserve script evaluation history
				if ( contains ) {
					setGlobalEval( tmp );
				}
	
				// Capture executables
				if ( scripts ) {
					j = 0;
					while ( (elem = tmp[ j++ ]) ) {
						if ( rscriptType.test( elem.type || "" ) ) {
							scripts.push( elem );
						}
					}
				}
			}
	
			return fragment;
		},
	
		cleanData: function( elems ) {
			var data, elem, type, key,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; (elem = elems[ i ]) !== undefined; i++ ) {
				if ( jQuery.acceptData( elem ) ) {
					key = elem[ data_priv.expando ];
	
					if ( key && (data = data_priv.cache[ key ]) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
						if ( data_priv.cache[ key ] ) {
							// Discard any remaining `private` data
							delete data_priv.cache[ key ];
						}
					}
				}
				// Discard any remaining `user` data
				delete data_user.cache[ elem[ data_user.expando ] ];
			}
		}
	});
	
	jQuery.fn.extend({
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each(function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					});
			}, null, value, arguments.length );
		},
	
		append: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			});
		},
	
		prepend: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			});
		},
	
		before: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			});
		},
	
		after: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			});
		},
	
		remove: function( selector, keepData /* Internal Use Only */ ) {
			var elem,
				elems = selector ? jQuery.filter( selector, this ) : this,
				i = 0;
	
			for ( ; (elem = elems[i]) != null; i++ ) {
				if ( !keepData && elem.nodeType === 1 ) {
					jQuery.cleanData( getAll( elem ) );
				}
	
				if ( elem.parentNode ) {
					if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
						setGlobalEval( getAll( elem, "script" ) );
					}
					elem.parentNode.removeChild( elem );
				}
			}
	
			return this;
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; (elem = this[i]) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map(function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			});
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = value.replace( rxhtmlTag, "<$1></$2>" );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var arg = arguments[ 0 ];
	
			// Make the changes, replacing each context element with the new content
			this.domManip( arguments, function( elem ) {
				arg = this.parentNode;
	
				jQuery.cleanData( getAll( this ) );
	
				if ( arg ) {
					arg.replaceChild( elem, this );
				}
			});
	
			// Force removal if there was no new content (e.g., from empty arguments)
			return arg && (arg.length || arg.nodeType) ? this : this.remove();
		},
	
		detach: function( selector ) {
			return this.remove( selector, true );
		},
	
		domManip: function( args, callback ) {
	
			// Flatten any nested arrays
			args = concat.apply( [], args );
	
			var fragment, first, scripts, hasScripts, node, doc,
				i = 0,
				l = this.length,
				set = this,
				iNoClone = l - 1,
				value = args[ 0 ],
				isFunction = jQuery.isFunction( value );
	
			// We can't cloneNode fragments that contain checked, in WebKit
			if ( isFunction ||
					( l > 1 && typeof value === "string" &&
						!support.checkClone && rchecked.test( value ) ) ) {
				return this.each(function( index ) {
					var self = set.eq( index );
					if ( isFunction ) {
						args[ 0 ] = value.call( this, index, self.html() );
					}
					self.domManip( args, callback );
				});
			}
	
			if ( l ) {
				fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
				first = fragment.firstChild;
	
				if ( fragment.childNodes.length === 1 ) {
					fragment = first;
				}
	
				if ( first ) {
					scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
					hasScripts = scripts.length;
	
					// Use the original fragment for the last item instead of the first because it can end up
					// being emptied incorrectly in certain situations (#8070).
					for ( ; i < l; i++ ) {
						node = fragment;
	
						if ( i !== iNoClone ) {
							node = jQuery.clone( node, true, true );
	
							// Keep references to cloned scripts for later restoration
							if ( hasScripts ) {
								// Support: QtWebKit
								// jQuery.merge because push.apply(_, arraylike) throws
								jQuery.merge( scripts, getAll( node, "script" ) );
							}
						}
	
						callback.call( this[ i ], node, i );
					}
	
					if ( hasScripts ) {
						doc = scripts[ scripts.length - 1 ].ownerDocument;
	
						// Reenable scripts
						jQuery.map( scripts, restoreScript );
	
						// Evaluate executable scripts on first document insertion
						for ( i = 0; i < hasScripts; i++ ) {
							node = scripts[ i ];
							if ( rscriptType.test( node.type || "" ) &&
								!data_priv.access( node, "globalEval" ) && jQuery.contains( doc, node ) ) {
	
								if ( node.src ) {
									// Optional AJAX dependency, but won't run scripts if not present
									if ( jQuery._evalUrl ) {
										jQuery._evalUrl( node.src );
									}
								} else {
									jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
								}
							}
						}
					}
				}
			}
	
			return this;
		}
	});
	
	jQuery.each({
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	});
	
	
	var iframe,
		elemdisplay = {};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var style,
			elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			// getDefaultComputedStyle might be reliably used only on attached element
			display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?
	
				// Use of this method is a temporary fix (more like optimization) until something better comes along,
				// since it was removed from specification and supported only in FF
				style.display : jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = (/^margin/);
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			if ( elem.ownerDocument.defaultView.opener ) {
				return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
			}
	
			return window.getComputedStyle( elem, null );
		};
	
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
		}
	
		if ( computed ) {
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// Support: iOS < 6
			// A tribute to the "awesome hack by Dean Edwards"
			// iOS < 6 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
			// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
			if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
			// Support: IE
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return (this.get = hookFn).apply( this, arguments );
			}
		};
	}
	
	
	(function() {
		var pixelPositionVal, boxSizingReliableVal,
			docElem = document.documentElement,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;" +
			"position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computePixelPositionAndBoxSizingReliable() {
			div.style.cssText =
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
				"box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
				"border:1px;padding:1px;width:4px;position:absolute";
			div.innerHTML = "";
			docElem.appendChild( container );
	
			var divStyle = window.getComputedStyle( div, null );
			pixelPositionVal = divStyle.top !== "1%";
			boxSizingReliableVal = divStyle.width === "4px";
	
			docElem.removeChild( container );
		}
	
		// Support: node.js jsdom
		// Don't assume that getComputedStyle is a property of the global object
		if ( window.getComputedStyle ) {
			jQuery.extend( support, {
				pixelPosition: function() {
	
					// This test is executed only once but we still do memoizing
					// since we can use the boxSizingReliable pre-computing.
					// No need to check if the test was already performed, though.
					computePixelPositionAndBoxSizingReliable();
					return pixelPositionVal;
				},
				boxSizingReliable: function() {
					if ( boxSizingReliableVal == null ) {
						computePixelPositionAndBoxSizingReliable();
					}
					return boxSizingReliableVal;
				},
				reliableMarginRight: function() {
	
					// Support: Android 2.3
					// Check if div with explicit width and no margin-right incorrectly
					// gets computed margin-right based on width of container. (#3333)
					// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
					// This support function is only executed once so no memoizing is needed.
					var ret,
						marginDiv = div.appendChild( document.createElement( "div" ) );
	
					// Reset CSS: box-sizing; display; margin; border; padding
					marginDiv.style.cssText = div.style.cssText =
						// Support: Firefox<29, Android 2.3
						// Vendor-prefix box-sizing
						"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
						"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
					marginDiv.style.marginRight = marginDiv.style.width = "0";
					div.style.width = "1px";
					docElem.appendChild( container );
	
					ret = !parseFloat( window.getComputedStyle( marginDiv, null ).marginRight );
	
					docElem.removeChild( container );
					div.removeChild( marginDiv );
	
					return ret;
				}
			});
		}
	})();
	
	
	// A method for quickly swapping in/out CSS properties to get correct calculations.
	jQuery.swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var
		// Swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
		rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( style, name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in style ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[0].toUpperCase() + name.slice(1),
			origName = name,
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in style ) {
				return name;
			}
		}
	
		return origName;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
		var matches = rnumsplit.exec( value );
		return matches ?
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
			// If we already have the right measurement, avoid augmentation
			4 :
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test(val) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = data_priv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = data_priv.access( elem, "olddisplay", defaultDisplay(elem.nodeName) );
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					data_priv.set( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend({
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && (ret = rrelNum.exec( value )) ) {
					value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number, add 'px' to the (except for certain CSS properties)
				if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
					value += "px";
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
					style[ name ] = value;
				}
	
			} else {
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
			}
			return val;
		}
	});
	
	jQuery.each([ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) && elem.offsetWidth === 0 ?
						jQuery.swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						}) :
						getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var styles = extra && getStyles( elem );
				return setPositiveNumber( elem, value, extra ?
					augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					) : 0
				);
			}
		};
	});
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return jQuery.swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each({
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split(" ") : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	});
	
	jQuery.fn.extend({
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each(function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			});
		}
	});
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || "swing";
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				if ( tween.elem[ tween.prop ] != null &&
					(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		}
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
		rrun = /queueHooks$/,
		animationPrefilters = [ defaultPrefilter ],
		tweeners = {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value ),
					target = tween.cur(),
					parts = rfxnum.exec( value ),
					unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
					// Starting value computation is required for potential unit mismatches
					start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
						rfxnum.exec( jQuery.css( tween.elem, prop ) ),
					scale = 1,
					maxIterations = 20;
	
				if ( start && start[ 3 ] !== unit ) {
					// Trust units reported by jQuery.css
					unit = unit || start[ 3 ];
	
					// Make sure we update the tween properties later on
					parts = parts || [];
	
					// Iteratively approximate from a nonzero starting point
					start = +target || 1;
	
					do {
						// If previous iteration zeroed out, double until we get *something*.
						// Use string for doubling so we don't accidentally see scale as unchanged below
						scale = scale || ".5";
	
						// Adjust and apply
						start = start / scale;
						jQuery.style( tween.elem, prop, start + unit );
	
					// Update scale, tolerating zero or NaN from tween.cur(),
					// break the loop if scale is unchanged or perfect, or if we've just had enough
					} while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
				}
	
				// Update tween properties
				if ( parts ) {
					start = tween.start = +start || +target || 0;
					tween.unit = unit;
					// If a +=/-= token was provided, we're doing a relative animation
					tween.end = parts[ 1 ] ?
						start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
						+parts[ 2 ];
				}
	
				return tween;
			} ]
		};
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		setTimeout(function() {
			fxNow = undefined;
		});
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( (tween = collection[ index ].call( animation, prop, value )) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = data_priv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always(function() {
				// Ensure the complete handler is called before this completes
				anim.always(function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				});
			});
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				data_priv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always(function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			});
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = data_priv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done(function() {
					jQuery( elem ).hide();
				});
			}
			anim.done(function() {
				var prop;
	
				data_priv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			});
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = animationPrefilters.length,
			deferred = jQuery.Deferred().always( function() {
				// Don't match elem in the :animated selector
				delete tick.elem;
			}),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ]);
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise({
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, { specialEasing: {} }, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			}),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			})
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.split(" ");
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				tweeners[ prop ] = tweeners[ prop ] || [];
				tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				animationPrefilters.unshift( callback );
			} else {
				animationPrefilters.push( callback );
			}
		}
	});
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
			opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend({
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate({ opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || data_priv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each(function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = data_priv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			});
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each(function() {
				var index,
					data = data_priv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			});
		}
	});
	
	jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	});
	
	// Generate shortcuts for custom animations
	jQuery.each({
		slideDown: genFx("show"),
		slideUp: genFx("hide"),
		slideToggle: genFx("toggle"),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	});
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		clearInterval( timerId );
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = setTimeout( next, time );
			hooks.stop = function() {
				clearTimeout( timeout );
			};
		});
	};
	
	
	(function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	})();
	
	
	var nodeHook, boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend({
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each(function() {
				jQuery.removeAttr( this, name );
			});
		}
	});
	
	jQuery.extend({
		attr: function( elem, name, value ) {
			var hooks, ret,
				nType = elem.nodeType;
	
			// don't get/set attributes on text, comment and attribute nodes
			if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === strundefined ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
			}
	
			if ( value !== undefined ) {
	
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
	
				} else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
					return ret;
	
				} else {
					elem.setAttribute( name, value + "" );
					return value;
				}
	
			} else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
				return ret;
	
			} else {
				ret = jQuery.find.attr( elem, name );
	
				// Non-existent attributes return null, we normalize to undefined
				return ret == null ?
					undefined :
					ret;
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( (name = attrNames[i++]) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		}
	});
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	});
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i;
	
	jQuery.fn.extend({
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each(function() {
				delete this[ jQuery.propFix[ name ] || name ];
			});
		}
	});
	
	jQuery.extend({
		propFix: {
			"for": "htmlFor",
			"class": "className"
		},
	
		prop: function( elem, name, value ) {
			var ret, hooks, notxml,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			notxml = nType !== 1 || !jQuery.isXMLDoc( elem );
	
			if ( notxml ) {
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
					ret :
					( elem[ name ] = value );
	
			} else {
				return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
					ret :
					elem[ name ];
			}
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
					return elem.hasAttribute( "tabindex" ) || rfocusable.test( elem.nodeName ) || elem.href ?
						elem.tabIndex :
						-1;
				}
			}
		}
	});
	
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			}
		};
	}
	
	jQuery.each([
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	});
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	jQuery.fn.extend({
		addClass: function( value ) {
			var classes, elem, cur, clazz, j, finalValue,
				proceed = typeof value === "string" && value,
				i = 0,
				len = this.length;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( j ) {
					jQuery( this ).addClass( value.call( this, j, this.className ) );
				});
			}
	
			if ( proceed ) {
				// The disjunction here is for better compressibility (see removeClass)
				classes = ( value || "" ).match( rnotwhite ) || [];
	
				for ( ; i < len; i++ ) {
					elem = this[ i ];
					cur = elem.nodeType === 1 && ( elem.className ?
						( " " + elem.className + " " ).replace( rclass, " " ) :
						" "
					);
	
					if ( cur ) {
						j = 0;
						while ( (clazz = classes[j++]) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( elem.className !== finalValue ) {
							elem.className = finalValue;
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, clazz, j, finalValue,
				proceed = arguments.length === 0 || typeof value === "string" && value,
				i = 0,
				len = this.length;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( j ) {
					jQuery( this ).removeClass( value.call( this, j, this.className ) );
				});
			}
			if ( proceed ) {
				classes = ( value || "" ).match( rnotwhite ) || [];
	
				for ( ; i < len; i++ ) {
					elem = this[ i ];
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( elem.className ?
						( " " + elem.className + " " ).replace( rclass, " " ) :
						""
					);
	
					if ( cur ) {
						j = 0;
						while ( (clazz = classes[j++]) ) {
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = value ? jQuery.trim( cur ) : "";
						if ( elem.className !== finalValue ) {
							elem.className = finalValue;
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( i ) {
					jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
				});
			}
	
			return this.each(function() {
				if ( type === "string" ) {
					// Toggle individual class names
					var className,
						i = 0,
						self = jQuery( this ),
						classNames = value.match( rnotwhite ) || [];
	
					while ( (className = classNames[ i++ ]) ) {
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( type === strundefined || type === "boolean" ) {
					if ( this.className ) {
						// store className if set
						data_priv.set( this, "__className__", this.className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					this.className = this.className || value === false ? "" : data_priv.get( this, "__className__" ) || "";
				}
			});
		},
	
		hasClass: function( selector ) {
			var className = " " + selector + " ",
				i = 0,
				l = this.length;
			for ( ; i < l; i++ ) {
				if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
					return true;
				}
			}
	
			return false;
		}
	});
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend({
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[0];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
						// Handle most common string cases
						ret.replace(rreturn, "") :
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each(function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					});
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			});
		}
	});
	
	jQuery.extend({
		valHooks: {
			option: {
				get: function( elem ) {
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						jQuery.trim( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE6-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ? !option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( (option.selected = jQuery.inArray( option.value, values ) >= 0) ) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	});
	
	// Radios and checkboxes getter/setter
	jQuery.each([ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute("value") === null ? "on" : elem.value;
			};
		}
	});
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	});
	
	jQuery.fn.extend({
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		},
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
		}
	});
	
	
	var nonce = jQuery.now();
	
	var rquery = (/\?/);
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, tmp;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			tmp = new DOMParser();
			xml = tmp.parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
		rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Document location
		ajaxLocation = window.location.href,
	
		// Segment location into parts
		ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
				// For each dataType in the dataTypeExpression
				while ( (dataType = dataTypes[i++]) ) {
					// Prepend if requested
					if ( dataType[0] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						(structure[ dataType ] = structure[ dataType ] || []).unshift( func );
	
					// Otherwise append
					} else {
						(structure[ dataType ] = structure[ dataType ] || []).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			});
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s[ "throws" ] ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend({
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: ajaxLocation,
			type: "GET",
			isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /xml/,
				html: /html/,
				json: /json/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
				// URL without anti-cache param
				cacheURL,
				// Response headers
				responseHeadersString,
				responseHeaders,
				// timeout handle
				timeoutTimer,
				// Cross-domain detection vars
				parts,
				// To know if global events are to be dispatched
				fireGlobals,
				// Loop variable
				i,
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
				// Callbacks context
				callbackContext = s.context || s,
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks("once memory"),
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
				// The jqXHR state
				state = 0,
				// Default abort message
				strAbort = "canceled",
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( (match = rheaders.exec( responseHeadersString )) ) {
									responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" )
				.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when we have a protocol:host:port mismatch
			if ( s.crossDomain == null ) {
				parts = rurl.exec( s.url.toLowerCase() );
				s.crossDomain = !!( parts &&
					( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
						( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
							( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
				);
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger("ajaxStart");
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
					s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = setTimeout(function() {
						jqXHR.abort("timeout");
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader("Last-Modified");
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader("etag");
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger("ajaxStop");
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	});
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			return jQuery.ajax({
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			});
		};
	});
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax({
			url: url,
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		});
	};
	
	
	jQuery.fn.extend({
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each(function( i ) {
					jQuery( this ).wrapAll( html.call(this, i) );
				});
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map(function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				}).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each(function( i ) {
					jQuery( this ).wrapInner( html.call(this, i) );
				});
			}
	
			return this.each(function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			});
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each(function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
			});
		},
	
		unwrap: function() {
			return this.parent().each(function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			}).end();
		}
	});
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		return elem.offsetWidth <= 0 && elem.offsetHeight <= 0;
	};
	jQuery.expr.filters.visible = function( elem ) {
		return !jQuery.expr.filters.hidden( elem );
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
				}
			});
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			});
	
		} else {
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend({
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map(function() {
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			})
			.filter(function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			})
			.map(function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						}) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			}).get();
		}
	});
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new XMLHttpRequest();
		} catch( e ) {}
	};
	
	var xhrId = 0,
		xhrCallbacks = {},
		xhrSuccessStatus = {
			// file protocol always yields status code 0, assume 200
			0: 200,
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	// Support: IE9
	// Open requests must be manually aborted on unload (#5280)
	// See https://support.microsoft.com/kb/2856746 for more info
	if ( window.attachEvent ) {
		window.attachEvent( "onunload", function() {
			for ( var key in xhrCallbacks ) {
				xhrCallbacks[ key ]();
			}
		});
	}
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport(function( options ) {
		var callback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr(),
						id = ++xhrId;
	
					xhr.open( options.type, options.url, options.async, options.username, options.password );
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers["X-Requested-With"] ) {
						headers["X-Requested-With"] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								delete xhrCallbacks[ id ];
								callback = xhr.onload = xhr.onerror = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
									complete(
										// file: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
										// Support: IE9
										// Accessing binary-data responseText throws an exception
										// (#11426)
										typeof xhr.responseText === "string" ? {
											text: xhr.responseText
										} : undefined,
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					xhr.onerror = callback("error");
	
					// Create the abort callback
					callback = xhrCallbacks[ id ] = callback("abort");
	
					try {
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	});
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup({
		accepts: {
			script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /(?:java|ecma)script/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	});
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	});
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery("<script>").prop({
						async: true,
						charset: s.scriptCharset,
						src: s.url
					}).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	});
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup({
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	});
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters["script json"] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always(function() {
				// Restore preexisting value
				window[ callbackName ] = overwritten;
	
				// Save back as free
				if ( s[ callbackName ] ) {
					// make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			});
	
			// Delegate to script
			return "script";
		}
	});
	
	
	
	
	// data: string of html
	// context (optional): If specified, the fragment will be created in this context, defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[1] ) ];
		}
	
		parsed = jQuery.buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf(" ");
	
		if ( off >= 0 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax({
				url: url,
	
				// if "type" variable is undefined, then "GET" method will be used
				type: type,
				dataType: "html",
				data: params
			}).done(function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			}).complete( callback && function( jqXHR, status ) {
				self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
			});
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	});
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep(jQuery.timers, function( fn ) {
			return elem === fn.elem;
		}).length;
	};
	
	
	
	
	var docElem = window.document.documentElement;
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf("auto") > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
				options = options.call( elem, i, curOffset );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend({
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each(function( i ) {
						jQuery.offset.setOffset( this, options, i );
					});
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			// Support: BlackBerry 5, iOS 3 (original iPhone)
			// If we don't have gBCR, just use 0,0 rather than error
			if ( typeof elem.getBoundingClientRect !== strundefined ) {
				box = elem.getBoundingClientRect();
			}
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		offsetParent: function() {
			return this.map(function() {
				var offsetParent = this.offsetParent || docElem;
	
				while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || docElem;
			});
		}
	});
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : window.pageXOffset,
						top ? val : window.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length, null );
		};
	});
	
	// Support: Safari<7+, Chrome<37+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	});
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		});
	});
	
	
	// The number of elements contained in the matched element set
	jQuery.fn.size = function() {
		return this.length;
	};
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === strundefined ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	
	}));


/***/ }),

/***/ 978:
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(982);
	__webpack_require__(983);
	__webpack_require__(985);
	__webpack_require__(987);
	__webpack_require__(986);

/***/ }),

/***/ 982:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*
	Copyright 2012 Igor Vaynberg
	
	Version: 3.4.8 Timestamp: Thu May  1 09:50:32 EDT 2014
	
	This software is licensed under the Apache License, Version 2.0 (the "Apache License") or the GNU
	General Public License version 2 (the "GPL License"). You may choose either license to govern your
	use of this software only upon the condition that you accept all of the terms of either the Apache
	License or the GPL License.
	
	You may obtain a copy of the Apache License and the GPL License at:
	
	    http://www.apache.org/licenses/LICENSE-2.0
	    http://www.gnu.org/licenses/gpl-2.0.html
	
	Unless required by applicable law or agreed to in writing, software distributed under the
	Apache License or the GPL License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	CONDITIONS OF ANY KIND, either express or implied. See the Apache License and the GPL License for
	the specific language governing permissions and limitations under the Apache License and the GPL License.
	*/
	(function ($) {
	    if(typeof $.fn.each2 == "undefined") {
	        $.extend($.fn, {
	            /*
	            * 4-10 times faster .each replacement
	            * use it carefully, as it overrides jQuery context of element on each iteration
	            */
	            each2 : function (c) {
	                var j = $([0]), i = -1, l = this.length;
	                while (
	                    ++i < l
	                    && (j.context = j[0] = this[i])
	                    && c.call(j[0], i, j) !== false //"this"=DOM, i=index, j=jQuery object
	                );
	                return this;
	            }
	        });
	    }
	})(jQuery);
	
	(function ($, undefined) {
	    "use strict";
	    /*global document, window, jQuery, console */
	
	    if (window.Select2 !== undefined) {
	        return;
	    }
	
	    var KEY, AbstractSelect2, SingleSelect2, MultiSelect2, nextUid, sizer,
	        lastMousePosition={x:0,y:0}, $document, scrollBarDimensions,
	
	    KEY = {
	        TAB: 9,
	        ENTER: 13,
	        ESC: 27,
	        SPACE: 32,
	        LEFT: 37,
	        UP: 38,
	        RIGHT: 39,
	        DOWN: 40,
	        SHIFT: 16,
	        CTRL: 17,
	        ALT: 18,
	        PAGE_UP: 33,
	        PAGE_DOWN: 34,
	        HOME: 36,
	        END: 35,
	        BACKSPACE: 8,
	        DELETE: 46,
	        isArrow: function (k) {
	            k = k.which ? k.which : k;
	            switch (k) {
	            case KEY.LEFT:
	            case KEY.RIGHT:
	            case KEY.UP:
	            case KEY.DOWN:
	                return true;
	            }
	            return false;
	        },
	        isControl: function (e) {
	            var k = e.which;
	            switch (k) {
	            case KEY.SHIFT:
	            case KEY.CTRL:
	            case KEY.ALT:
	                return true;
	            }
	
	            if (e.metaKey) return true;
	
	            return false;
	        },
	        isFunctionKey: function (k) {
	            k = k.which ? k.which : k;
	            return k >= 112 && k <= 123;
	        }
	    },
	    MEASURE_SCROLLBAR_TEMPLATE = "<div class='select2-measure-scrollbar'></div>",
	
	    DIACRITICS = {"\u24B6":"A","\uFF21":"A","\u00C0":"A","\u00C1":"A","\u00C2":"A","\u1EA6":"A","\u1EA4":"A","\u1EAA":"A","\u1EA8":"A","\u00C3":"A","\u0100":"A","\u0102":"A","\u1EB0":"A","\u1EAE":"A","\u1EB4":"A","\u1EB2":"A","\u0226":"A","\u01E0":"A","\u00C4":"A","\u01DE":"A","\u1EA2":"A","\u00C5":"A","\u01FA":"A","\u01CD":"A","\u0200":"A","\u0202":"A","\u1EA0":"A","\u1EAC":"A","\u1EB6":"A","\u1E00":"A","\u0104":"A","\u023A":"A","\u2C6F":"A","\uA732":"AA","\u00C6":"AE","\u01FC":"AE","\u01E2":"AE","\uA734":"AO","\uA736":"AU","\uA738":"AV","\uA73A":"AV","\uA73C":"AY","\u24B7":"B","\uFF22":"B","\u1E02":"B","\u1E04":"B","\u1E06":"B","\u0243":"B","\u0182":"B","\u0181":"B","\u24B8":"C","\uFF23":"C","\u0106":"C","\u0108":"C","\u010A":"C","\u010C":"C","\u00C7":"C","\u1E08":"C","\u0187":"C","\u023B":"C","\uA73E":"C","\u24B9":"D","\uFF24":"D","\u1E0A":"D","\u010E":"D","\u1E0C":"D","\u1E10":"D","\u1E12":"D","\u1E0E":"D","\u0110":"D","\u018B":"D","\u018A":"D","\u0189":"D","\uA779":"D","\u01F1":"DZ","\u01C4":"DZ","\u01F2":"Dz","\u01C5":"Dz","\u24BA":"E","\uFF25":"E","\u00C8":"E","\u00C9":"E","\u00CA":"E","\u1EC0":"E","\u1EBE":"E","\u1EC4":"E","\u1EC2":"E","\u1EBC":"E","\u0112":"E","\u1E14":"E","\u1E16":"E","\u0114":"E","\u0116":"E","\u00CB":"E","\u1EBA":"E","\u011A":"E","\u0204":"E","\u0206":"E","\u1EB8":"E","\u1EC6":"E","\u0228":"E","\u1E1C":"E","\u0118":"E","\u1E18":"E","\u1E1A":"E","\u0190":"E","\u018E":"E","\u24BB":"F","\uFF26":"F","\u1E1E":"F","\u0191":"F","\uA77B":"F","\u24BC":"G","\uFF27":"G","\u01F4":"G","\u011C":"G","\u1E20":"G","\u011E":"G","\u0120":"G","\u01E6":"G","\u0122":"G","\u01E4":"G","\u0193":"G","\uA7A0":"G","\uA77D":"G","\uA77E":"G","\u24BD":"H","\uFF28":"H","\u0124":"H","\u1E22":"H","\u1E26":"H","\u021E":"H","\u1E24":"H","\u1E28":"H","\u1E2A":"H","\u0126":"H","\u2C67":"H","\u2C75":"H","\uA78D":"H","\u24BE":"I","\uFF29":"I","\u00CC":"I","\u00CD":"I","\u00CE":"I","\u0128":"I","\u012A":"I","\u012C":"I","\u0130":"I","\u00CF":"I","\u1E2E":"I","\u1EC8":"I","\u01CF":"I","\u0208":"I","\u020A":"I","\u1ECA":"I","\u012E":"I","\u1E2C":"I","\u0197":"I","\u24BF":"J","\uFF2A":"J","\u0134":"J","\u0248":"J","\u24C0":"K","\uFF2B":"K","\u1E30":"K","\u01E8":"K","\u1E32":"K","\u0136":"K","\u1E34":"K","\u0198":"K","\u2C69":"K","\uA740":"K","\uA742":"K","\uA744":"K","\uA7A2":"K","\u24C1":"L","\uFF2C":"L","\u013F":"L","\u0139":"L","\u013D":"L","\u1E36":"L","\u1E38":"L","\u013B":"L","\u1E3C":"L","\u1E3A":"L","\u0141":"L","\u023D":"L","\u2C62":"L","\u2C60":"L","\uA748":"L","\uA746":"L","\uA780":"L","\u01C7":"LJ","\u01C8":"Lj","\u24C2":"M","\uFF2D":"M","\u1E3E":"M","\u1E40":"M","\u1E42":"M","\u2C6E":"M","\u019C":"M","\u24C3":"N","\uFF2E":"N","\u01F8":"N","\u0143":"N","\u00D1":"N","\u1E44":"N","\u0147":"N","\u1E46":"N","\u0145":"N","\u1E4A":"N","\u1E48":"N","\u0220":"N","\u019D":"N","\uA790":"N","\uA7A4":"N","\u01CA":"NJ","\u01CB":"Nj","\u24C4":"O","\uFF2F":"O","\u00D2":"O","\u00D3":"O","\u00D4":"O","\u1ED2":"O","\u1ED0":"O","\u1ED6":"O","\u1ED4":"O","\u00D5":"O","\u1E4C":"O","\u022C":"O","\u1E4E":"O","\u014C":"O","\u1E50":"O","\u1E52":"O","\u014E":"O","\u022E":"O","\u0230":"O","\u00D6":"O","\u022A":"O","\u1ECE":"O","\u0150":"O","\u01D1":"O","\u020C":"O","\u020E":"O","\u01A0":"O","\u1EDC":"O","\u1EDA":"O","\u1EE0":"O","\u1EDE":"O","\u1EE2":"O","\u1ECC":"O","\u1ED8":"O","\u01EA":"O","\u01EC":"O","\u00D8":"O","\u01FE":"O","\u0186":"O","\u019F":"O","\uA74A":"O","\uA74C":"O","\u01A2":"OI","\uA74E":"OO","\u0222":"OU","\u24C5":"P","\uFF30":"P","\u1E54":"P","\u1E56":"P","\u01A4":"P","\u2C63":"P","\uA750":"P","\uA752":"P","\uA754":"P","\u24C6":"Q","\uFF31":"Q","\uA756":"Q","\uA758":"Q","\u024A":"Q","\u24C7":"R","\uFF32":"R","\u0154":"R","\u1E58":"R","\u0158":"R","\u0210":"R","\u0212":"R","\u1E5A":"R","\u1E5C":"R","\u0156":"R","\u1E5E":"R","\u024C":"R","\u2C64":"R","\uA75A":"R","\uA7A6":"R","\uA782":"R","\u24C8":"S","\uFF33":"S","\u1E9E":"S","\u015A":"S","\u1E64":"S","\u015C":"S","\u1E60":"S","\u0160":"S","\u1E66":"S","\u1E62":"S","\u1E68":"S","\u0218":"S","\u015E":"S","\u2C7E":"S","\uA7A8":"S","\uA784":"S","\u24C9":"T","\uFF34":"T","\u1E6A":"T","\u0164":"T","\u1E6C":"T","\u021A":"T","\u0162":"T","\u1E70":"T","\u1E6E":"T","\u0166":"T","\u01AC":"T","\u01AE":"T","\u023E":"T","\uA786":"T","\uA728":"TZ","\u24CA":"U","\uFF35":"U","\u00D9":"U","\u00DA":"U","\u00DB":"U","\u0168":"U","\u1E78":"U","\u016A":"U","\u1E7A":"U","\u016C":"U","\u00DC":"U","\u01DB":"U","\u01D7":"U","\u01D5":"U","\u01D9":"U","\u1EE6":"U","\u016E":"U","\u0170":"U","\u01D3":"U","\u0214":"U","\u0216":"U","\u01AF":"U","\u1EEA":"U","\u1EE8":"U","\u1EEE":"U","\u1EEC":"U","\u1EF0":"U","\u1EE4":"U","\u1E72":"U","\u0172":"U","\u1E76":"U","\u1E74":"U","\u0244":"U","\u24CB":"V","\uFF36":"V","\u1E7C":"V","\u1E7E":"V","\u01B2":"V","\uA75E":"V","\u0245":"V","\uA760":"VY","\u24CC":"W","\uFF37":"W","\u1E80":"W","\u1E82":"W","\u0174":"W","\u1E86":"W","\u1E84":"W","\u1E88":"W","\u2C72":"W","\u24CD":"X","\uFF38":"X","\u1E8A":"X","\u1E8C":"X","\u24CE":"Y","\uFF39":"Y","\u1EF2":"Y","\u00DD":"Y","\u0176":"Y","\u1EF8":"Y","\u0232":"Y","\u1E8E":"Y","\u0178":"Y","\u1EF6":"Y","\u1EF4":"Y","\u01B3":"Y","\u024E":"Y","\u1EFE":"Y","\u24CF":"Z","\uFF3A":"Z","\u0179":"Z","\u1E90":"Z","\u017B":"Z","\u017D":"Z","\u1E92":"Z","\u1E94":"Z","\u01B5":"Z","\u0224":"Z","\u2C7F":"Z","\u2C6B":"Z","\uA762":"Z","\u24D0":"a","\uFF41":"a","\u1E9A":"a","\u00E0":"a","\u00E1":"a","\u00E2":"a","\u1EA7":"a","\u1EA5":"a","\u1EAB":"a","\u1EA9":"a","\u00E3":"a","\u0101":"a","\u0103":"a","\u1EB1":"a","\u1EAF":"a","\u1EB5":"a","\u1EB3":"a","\u0227":"a","\u01E1":"a","\u00E4":"a","\u01DF":"a","\u1EA3":"a","\u00E5":"a","\u01FB":"a","\u01CE":"a","\u0201":"a","\u0203":"a","\u1EA1":"a","\u1EAD":"a","\u1EB7":"a","\u1E01":"a","\u0105":"a","\u2C65":"a","\u0250":"a","\uA733":"aa","\u00E6":"ae","\u01FD":"ae","\u01E3":"ae","\uA735":"ao","\uA737":"au","\uA739":"av","\uA73B":"av","\uA73D":"ay","\u24D1":"b","\uFF42":"b","\u1E03":"b","\u1E05":"b","\u1E07":"b","\u0180":"b","\u0183":"b","\u0253":"b","\u24D2":"c","\uFF43":"c","\u0107":"c","\u0109":"c","\u010B":"c","\u010D":"c","\u00E7":"c","\u1E09":"c","\u0188":"c","\u023C":"c","\uA73F":"c","\u2184":"c","\u24D3":"d","\uFF44":"d","\u1E0B":"d","\u010F":"d","\u1E0D":"d","\u1E11":"d","\u1E13":"d","\u1E0F":"d","\u0111":"d","\u018C":"d","\u0256":"d","\u0257":"d","\uA77A":"d","\u01F3":"dz","\u01C6":"dz","\u24D4":"e","\uFF45":"e","\u00E8":"e","\u00E9":"e","\u00EA":"e","\u1EC1":"e","\u1EBF":"e","\u1EC5":"e","\u1EC3":"e","\u1EBD":"e","\u0113":"e","\u1E15":"e","\u1E17":"e","\u0115":"e","\u0117":"e","\u00EB":"e","\u1EBB":"e","\u011B":"e","\u0205":"e","\u0207":"e","\u1EB9":"e","\u1EC7":"e","\u0229":"e","\u1E1D":"e","\u0119":"e","\u1E19":"e","\u1E1B":"e","\u0247":"e","\u025B":"e","\u01DD":"e","\u24D5":"f","\uFF46":"f","\u1E1F":"f","\u0192":"f","\uA77C":"f","\u24D6":"g","\uFF47":"g","\u01F5":"g","\u011D":"g","\u1E21":"g","\u011F":"g","\u0121":"g","\u01E7":"g","\u0123":"g","\u01E5":"g","\u0260":"g","\uA7A1":"g","\u1D79":"g","\uA77F":"g","\u24D7":"h","\uFF48":"h","\u0125":"h","\u1E23":"h","\u1E27":"h","\u021F":"h","\u1E25":"h","\u1E29":"h","\u1E2B":"h","\u1E96":"h","\u0127":"h","\u2C68":"h","\u2C76":"h","\u0265":"h","\u0195":"hv","\u24D8":"i","\uFF49":"i","\u00EC":"i","\u00ED":"i","\u00EE":"i","\u0129":"i","\u012B":"i","\u012D":"i","\u00EF":"i","\u1E2F":"i","\u1EC9":"i","\u01D0":"i","\u0209":"i","\u020B":"i","\u1ECB":"i","\u012F":"i","\u1E2D":"i","\u0268":"i","\u0131":"i","\u24D9":"j","\uFF4A":"j","\u0135":"j","\u01F0":"j","\u0249":"j","\u24DA":"k","\uFF4B":"k","\u1E31":"k","\u01E9":"k","\u1E33":"k","\u0137":"k","\u1E35":"k","\u0199":"k","\u2C6A":"k","\uA741":"k","\uA743":"k","\uA745":"k","\uA7A3":"k","\u24DB":"l","\uFF4C":"l","\u0140":"l","\u013A":"l","\u013E":"l","\u1E37":"l","\u1E39":"l","\u013C":"l","\u1E3D":"l","\u1E3B":"l","\u017F":"l","\u0142":"l","\u019A":"l","\u026B":"l","\u2C61":"l","\uA749":"l","\uA781":"l","\uA747":"l","\u01C9":"lj","\u24DC":"m","\uFF4D":"m","\u1E3F":"m","\u1E41":"m","\u1E43":"m","\u0271":"m","\u026F":"m","\u24DD":"n","\uFF4E":"n","\u01F9":"n","\u0144":"n","\u00F1":"n","\u1E45":"n","\u0148":"n","\u1E47":"n","\u0146":"n","\u1E4B":"n","\u1E49":"n","\u019E":"n","\u0272":"n","\u0149":"n","\uA791":"n","\uA7A5":"n","\u01CC":"nj","\u24DE":"o","\uFF4F":"o","\u00F2":"o","\u00F3":"o","\u00F4":"o","\u1ED3":"o","\u1ED1":"o","\u1ED7":"o","\u1ED5":"o","\u00F5":"o","\u1E4D":"o","\u022D":"o","\u1E4F":"o","\u014D":"o","\u1E51":"o","\u1E53":"o","\u014F":"o","\u022F":"o","\u0231":"o","\u00F6":"o","\u022B":"o","\u1ECF":"o","\u0151":"o","\u01D2":"o","\u020D":"o","\u020F":"o","\u01A1":"o","\u1EDD":"o","\u1EDB":"o","\u1EE1":"o","\u1EDF":"o","\u1EE3":"o","\u1ECD":"o","\u1ED9":"o","\u01EB":"o","\u01ED":"o","\u00F8":"o","\u01FF":"o","\u0254":"o","\uA74B":"o","\uA74D":"o","\u0275":"o","\u01A3":"oi","\u0223":"ou","\uA74F":"oo","\u24DF":"p","\uFF50":"p","\u1E55":"p","\u1E57":"p","\u01A5":"p","\u1D7D":"p","\uA751":"p","\uA753":"p","\uA755":"p","\u24E0":"q","\uFF51":"q","\u024B":"q","\uA757":"q","\uA759":"q","\u24E1":"r","\uFF52":"r","\u0155":"r","\u1E59":"r","\u0159":"r","\u0211":"r","\u0213":"r","\u1E5B":"r","\u1E5D":"r","\u0157":"r","\u1E5F":"r","\u024D":"r","\u027D":"r","\uA75B":"r","\uA7A7":"r","\uA783":"r","\u24E2":"s","\uFF53":"s","\u00DF":"s","\u015B":"s","\u1E65":"s","\u015D":"s","\u1E61":"s","\u0161":"s","\u1E67":"s","\u1E63":"s","\u1E69":"s","\u0219":"s","\u015F":"s","\u023F":"s","\uA7A9":"s","\uA785":"s","\u1E9B":"s","\u24E3":"t","\uFF54":"t","\u1E6B":"t","\u1E97":"t","\u0165":"t","\u1E6D":"t","\u021B":"t","\u0163":"t","\u1E71":"t","\u1E6F":"t","\u0167":"t","\u01AD":"t","\u0288":"t","\u2C66":"t","\uA787":"t","\uA729":"tz","\u24E4":"u","\uFF55":"u","\u00F9":"u","\u00FA":"u","\u00FB":"u","\u0169":"u","\u1E79":"u","\u016B":"u","\u1E7B":"u","\u016D":"u","\u00FC":"u","\u01DC":"u","\u01D8":"u","\u01D6":"u","\u01DA":"u","\u1EE7":"u","\u016F":"u","\u0171":"u","\u01D4":"u","\u0215":"u","\u0217":"u","\u01B0":"u","\u1EEB":"u","\u1EE9":"u","\u1EEF":"u","\u1EED":"u","\u1EF1":"u","\u1EE5":"u","\u1E73":"u","\u0173":"u","\u1E77":"u","\u1E75":"u","\u0289":"u","\u24E5":"v","\uFF56":"v","\u1E7D":"v","\u1E7F":"v","\u028B":"v","\uA75F":"v","\u028C":"v","\uA761":"vy","\u24E6":"w","\uFF57":"w","\u1E81":"w","\u1E83":"w","\u0175":"w","\u1E87":"w","\u1E85":"w","\u1E98":"w","\u1E89":"w","\u2C73":"w","\u24E7":"x","\uFF58":"x","\u1E8B":"x","\u1E8D":"x","\u24E8":"y","\uFF59":"y","\u1EF3":"y","\u00FD":"y","\u0177":"y","\u1EF9":"y","\u0233":"y","\u1E8F":"y","\u00FF":"y","\u1EF7":"y","\u1E99":"y","\u1EF5":"y","\u01B4":"y","\u024F":"y","\u1EFF":"y","\u24E9":"z","\uFF5A":"z","\u017A":"z","\u1E91":"z","\u017C":"z","\u017E":"z","\u1E93":"z","\u1E95":"z","\u01B6":"z","\u0225":"z","\u0240":"z","\u2C6C":"z","\uA763":"z"};
	
	    $document = $(document);
	
	    nextUid=(function() { var counter=1; return function() { return counter++; }; }());
	
	
	    function reinsertElement(element) {
	        var placeholder = $(document.createTextNode(''));
	
	        element.before(placeholder);
	        placeholder.before(element);
	        placeholder.remove();
	    }
	
	    function stripDiacritics(str) {
	        // Used 'uni range + named function' from http://jsperf.com/diacritics/18
	        function match(a) {
	            return DIACRITICS[a] || a;
	        }
	
	        return str.replace(/[^\u0000-\u007E]/g, match);
	    }
	
	    function indexOf(value, array) {
	        var i = 0, l = array.length;
	        for (; i < l; i = i + 1) {
	            if (equal(value, array[i])) return i;
	        }
	        return -1;
	    }
	
	    function measureScrollbar () {
	        var $template = $( MEASURE_SCROLLBAR_TEMPLATE );
	        $template.appendTo('body');
	
	        var dim = {
	            width: $template.width() - $template[0].clientWidth,
	            height: $template.height() - $template[0].clientHeight
	        };
	        $template.remove();
	
	        return dim;
	    }
	
	    /**
	     * Compares equality of a and b
	     * @param a
	     * @param b
	     */
	    function equal(a, b) {
	        if (a === b) return true;
	        if (a === undefined || b === undefined) return false;
	        if (a === null || b === null) return false;
	        // Check whether 'a' or 'b' is a string (primitive or object).
	        // The concatenation of an empty string (+'') converts its argument to a string's primitive.
	        if (a.constructor === String) return a+'' === b+''; // a+'' - in case 'a' is a String object
	        if (b.constructor === String) return b+'' === a+''; // b+'' - in case 'b' is a String object
	        return false;
	    }
	
	    /**
	     * Splits the string into an array of values, trimming each value. An empty array is returned for nulls or empty
	     * strings
	     * @param string
	     * @param separator
	     */
	    function splitVal(string, separator) {
	        var val, i, l;
	        if (string === null || string.length < 1) return [];
	        val = string.split(separator);
	        for (i = 0, l = val.length; i < l; i = i + 1) val[i] = $.trim(val[i]);
	        return val;
	    }
	
	    function getSideBorderPadding(element) {
	        return element.outerWidth(false) - element.width();
	    }
	
	    function installKeyUpChangeEvent(element) {
	        var key="keyup-change-value";
	        element.on("keydown", function () {
	            if ($.data(element, key) === undefined) {
	                $.data(element, key, element.val());
	            }
	        });
	        element.on("keyup", function () {
	            var val= $.data(element, key);
	            if (val !== undefined && element.val() !== val) {
	                $.removeData(element, key);
	                element.trigger("keyup-change");
	            }
	        });
	    }
	
	    $document.on("mousemove", function (e) {
	        lastMousePosition.x = e.pageX;
	        lastMousePosition.y = e.pageY;
	    });
	
	    /**
	     * filters mouse events so an event is fired only if the mouse moved.
	     *
	     * filters out mouse events that occur when mouse is stationary but
	     * the elements under the pointer are scrolled.
	     */
	    function installFilteredMouseMove(element) {
	        element.on("mousemove", function (e) {
	            var lastpos = lastMousePosition;
	            if (lastpos === undefined || lastpos.x !== e.pageX || lastpos.y !== e.pageY) {
	                $(e.target).trigger("mousemove-filtered", e);
	            }
	        });
	    }
	
	    /**
	     * Debounces a function. Returns a function that calls the original fn function only if no invocations have been made
	     * within the last quietMillis milliseconds.
	     *
	     * @param quietMillis number of milliseconds to wait before invoking fn
	     * @param fn function to be debounced
	     * @param ctx object to be used as this reference within fn
	     * @return debounced version of fn
	     */
	    function debounce(quietMillis, fn, ctx) {
	        ctx = ctx || undefined;
	        var timeout;
	        return function () {
	            var args = arguments;
	            window.clearTimeout(timeout);
	            timeout = window.setTimeout(function() {
	                fn.apply(ctx, args);
	            }, quietMillis);
	        };
	    }
	
	    function installDebouncedScroll(threshold, element) {
	        var notify = debounce(threshold, function (e) { element.trigger("scroll-debounced", e);});
	        element.on("scroll", function (e) {
	            if (indexOf(e.target, element.get()) >= 0) notify(e);
	        });
	    }
	
	    function focus($el) {
	        if ($el[0] === document.activeElement) return;
	
	        /* set the focus in a 0 timeout - that way the focus is set after the processing
	            of the current event has finished - which seems like the only reliable way
	            to set focus */
	        window.setTimeout(function() {
	            var el=$el[0], pos=$el.val().length, range;
	
	            $el.focus();
	
	            /* make sure el received focus so we do not error out when trying to manipulate the caret.
	                sometimes modals or others listeners may steal it after its set */
	            var isVisible = (el.offsetWidth > 0 || el.offsetHeight > 0);
	            if (isVisible && el === document.activeElement) {
	
	                /* after the focus is set move the caret to the end, necessary when we val()
	                    just before setting focus */
	                if(el.setSelectionRange)
	                {
	                    el.setSelectionRange(pos, pos);
	                }
	                else if (el.createTextRange) {
	                    range = el.createTextRange();
	                    range.collapse(false);
	                    range.select();
	                }
	            }
	        }, 0);
	    }
	
	    function getCursorInfo(el) {
	        el = $(el)[0];
	        var offset = 0;
	        var length = 0;
	        if ('selectionStart' in el) {
	            offset = el.selectionStart;
	            length = el.selectionEnd - offset;
	        } else if ('selection' in document) {
	            el.focus();
	            var sel = document.selection.createRange();
	            length = document.selection.createRange().text.length;
	            sel.moveStart('character', -el.value.length);
	            offset = sel.text.length - length;
	        }
	        return { offset: offset, length: length };
	    }
	
	    function killEvent(event) {
	        event.preventDefault();
	        event.stopPropagation();
	    }
	    function killEventImmediately(event) {
	        event.preventDefault();
	        event.stopImmediatePropagation();
	    }
	
	    function measureTextWidth(e) {
	        if (!sizer){
	            var style = e[0].currentStyle || window.getComputedStyle(e[0], null);
	            sizer = $(document.createElement("div")).css({
	                position: "absolute",
	                left: "-10000px",
	                top: "-10000px",
	                display: "none",
	                fontSize: style.fontSize,
	                fontFamily: style.fontFamily,
	                fontStyle: style.fontStyle,
	                fontWeight: style.fontWeight,
	                letterSpacing: style.letterSpacing,
	                textTransform: style.textTransform,
	                whiteSpace: "nowrap"
	            });
	            sizer.attr("class","select2-sizer");
	            $("body").append(sizer);
	        }
	        sizer.text(e.val());
	        return sizer.width();
	    }
	
	    function syncCssClasses(dest, src, adapter) {
	        var classes, replacements = [], adapted;
	
	        classes = dest.attr("class");
	        if (classes) {
	            classes = '' + classes; // for IE which returns object
	            $(classes.split(" ")).each2(function() {
	                if (this.indexOf("select2-") === 0) {
	                    replacements.push(this);
	                }
	            });
	        }
	        classes = src.attr("class");
	        if (classes) {
	            classes = '' + classes; // for IE which returns object
	            $(classes.split(" ")).each2(function() {
	                if (this.indexOf("select2-") !== 0) {
	                    adapted = adapter(this);
	                    if (adapted) {
	                        replacements.push(adapted);
	                    }
	                }
	            });
	        }
	        dest.attr("class", replacements.join(" "));
	    }
	
	
	    function markMatch(text, term, markup, escapeMarkup) {
	        var match=stripDiacritics(text.toUpperCase()).indexOf(stripDiacritics(term.toUpperCase())),
	            tl=term.length;
	
	        if (match<0) {
	            markup.push(escapeMarkup(text));
	            return;
	        }
	
	        markup.push(escapeMarkup(text.substring(0, match)));
	        markup.push("<span class='select2-match'>");
	        markup.push(escapeMarkup(text.substring(match, match + tl)));
	        markup.push("</span>");
	        markup.push(escapeMarkup(text.substring(match + tl, text.length)));
	    }
	
	    function defaultEscapeMarkup(markup) {
	        var replace_map = {
	            '\\': '&#92;',
	            '&': '&amp;',
	            '<': '&lt;',
	            '>': '&gt;',
	            '"': '&quot;',
	            "'": '&#39;',
	            "/": '&#47;'
	        };
	
	        return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
	            return replace_map[match];
	        });
	    }
	
	    /**
	     * Produces an ajax-based query function
	     *
	     * @param options object containing configuration parameters
	     * @param options.params parameter map for the transport ajax call, can contain such options as cache, jsonpCallback, etc. see $.ajax
	     * @param options.transport function that will be used to execute the ajax request. must be compatible with parameters supported by $.ajax
	     * @param options.url url for the data
	     * @param options.data a function(searchTerm, pageNumber, context) that should return an object containing query string parameters for the above url.
	     * @param options.dataType request data type: ajax, jsonp, other datatypes supported by jQuery's $.ajax function or the transport function if specified
	     * @param options.quietMillis (optional) milliseconds to wait before making the ajaxRequest, helps debounce the ajax function if invoked too often
	     * @param options.results a function(remoteData, pageNumber) that converts data returned form the remote request to the format expected by Select2.
	     *      The expected format is an object containing the following keys:
	     *      results array of objects that will be used as choices
	     *      more (optional) boolean indicating whether there are more results available
	     *      Example: {results:[{id:1, text:'Red'},{id:2, text:'Blue'}], more:true}
	     */
	    function ajax(options) {
	        var timeout, // current scheduled but not yet executed request
	            handler = null,
	            quietMillis = options.quietMillis || 100,
	            ajaxUrl = options.url,
	            self = this;
	
	        return function (query) {
	            window.clearTimeout(timeout);
	            timeout = window.setTimeout(function () {
	                var data = options.data, // ajax data function
	                    url = ajaxUrl, // ajax url string or function
	                    transport = options.transport || $.fn.select2.ajaxDefaults.transport,
	                    // deprecated - to be removed in 4.0  - use params instead
	                    deprecated = {
	                        type: options.type || 'GET', // set type of request (GET or POST)
	                        cache: options.cache || false,
	                        jsonpCallback: options.jsonpCallback||undefined,
	                        dataType: options.dataType||"json"
	                    },
	                    params = $.extend({}, $.fn.select2.ajaxDefaults.params, deprecated);
	
	                data = data ? data.call(self, query.term, query.page, query.context) : null;
	                url = (typeof url === 'function') ? url.call(self, query.term, query.page, query.context) : url;
	
	                if (handler && typeof handler.abort === "function") { handler.abort(); }
	
	                if (options.params) {
	                    if ($.isFunction(options.params)) {
	                        $.extend(params, options.params.call(self));
	                    } else {
	                        $.extend(params, options.params);
	                    }
	                }
	
	                $.extend(params, {
	                    url: url,
	                    dataType: options.dataType,
	                    data: data,
	                    success: function (data) {
	                        // TODO - replace query.page with query so users have access to term, page, etc.
	                        var results = options.results(data, query.page);
	                        query.callback(results);
	                    }
	                });
	                handler = transport.call(self, params);
	            }, quietMillis);
	        };
	    }
	
	    /**
	     * Produces a query function that works with a local array
	     *
	     * @param options object containing configuration parameters. The options parameter can either be an array or an
	     * object.
	     *
	     * If the array form is used it is assumed that it contains objects with 'id' and 'text' keys.
	     *
	     * If the object form is used it is assumed that it contains 'data' and 'text' keys. The 'data' key should contain
	     * an array of objects that will be used as choices. These objects must contain at least an 'id' key. The 'text'
	     * key can either be a String in which case it is expected that each element in the 'data' array has a key with the
	     * value of 'text' which will be used to match choices. Alternatively, text can be a function(item) that can extract
	     * the text.
	     */
	    function local(options) {
	        var data = options, // data elements
	            dataText,
	            tmp,
	            text = function (item) { return ""+item.text; }; // function used to retrieve the text portion of a data item that is matched against the search
	
	         if ($.isArray(data)) {
	            tmp = data;
	            data = { results: tmp };
	        }
	
	         if ($.isFunction(data) === false) {
	            tmp = data;
	            data = function() { return tmp; };
	        }
	
	        var dataItem = data();
	        if (dataItem.text) {
	            text = dataItem.text;
	            // if text is not a function we assume it to be a key name
	            if (!$.isFunction(text)) {
	                dataText = dataItem.text; // we need to store this in a separate variable because in the next step data gets reset and data.text is no longer available
	                text = function (item) { return item[dataText]; };
	            }
	        }
	
	        return function (query) {
	            var t = query.term, filtered = { results: [] }, process;
	            if (t === "") {
	                query.callback(data());
	                return;
	            }
	
	            process = function(datum, collection) {
	                var group, attr;
	                datum = datum[0];
	                if (datum.children) {
	                    group = {};
	                    for (attr in datum) {
	                        if (datum.hasOwnProperty(attr)) group[attr]=datum[attr];
	                    }
	                    group.children=[];
	                    $(datum.children).each2(function(i, childDatum) { process(childDatum, group.children); });
	                    if (group.children.length || query.matcher(t, text(group), datum)) {
	                        collection.push(group);
	                    }
	                } else {
	                    if (query.matcher(t, text(datum), datum)) {
	                        collection.push(datum);
	                    }
	                }
	            };
	
	            $(data().results).each2(function(i, datum) { process(datum, filtered.results); });
	            query.callback(filtered);
	        };
	    }
	
	    // TODO javadoc
	    function tags(data) {
	        var isFunc = $.isFunction(data);
	        return function (query) {
	            var t = query.term, filtered = {results: []};
	            var result = isFunc ? data(query) : data;
	            if ($.isArray(result)) {
	                $(result).each(function () {
	                    var isObject = this.text !== undefined,
	                        text = isObject ? this.text : this;
	                    if (t === "" || query.matcher(t, text)) {
	                        filtered.results.push(isObject ? this : {id: this, text: this});
	                    }
	                });
	                query.callback(filtered);
	            }
	        };
	    }
	
	    /**
	     * Checks if the formatter function should be used.
	     *
	     * Throws an error if it is not a function. Returns true if it should be used,
	     * false if no formatting should be performed.
	     *
	     * @param formatter
	     */
	    function checkFormatter(formatter, formatterName) {
	        if ($.isFunction(formatter)) return true;
	        if (!formatter) return false;
	        if (typeof(formatter) === 'string') return true;
	        throw new Error(formatterName +" must be a string, function, or falsy value");
	    }
	
	    function evaluate(val) {
	        if ($.isFunction(val)) {
	            var args = Array.prototype.slice.call(arguments, 1);
	            return val.apply(null, args);
	        }
	        return val;
	    }
	
	    function countResults(results) {
	        var count = 0;
	        $.each(results, function(i, item) {
	            if (item.children) {
	                count += countResults(item.children);
	            } else {
	                count++;
	            }
	        });
	        return count;
	    }
	
	    /**
	     * Default tokenizer. This function uses breaks the input on substring match of any string from the
	     * opts.tokenSeparators array and uses opts.createSearchChoice to create the choice object. Both of those
	     * two options have to be defined in order for the tokenizer to work.
	     *
	     * @param input text user has typed so far or pasted into the search field
	     * @param selection currently selected choices
	     * @param selectCallback function(choice) callback tho add the choice to selection
	     * @param opts select2's opts
	     * @return undefined/null to leave the current input unchanged, or a string to change the input to the returned value
	     */
	    function defaultTokenizer(input, selection, selectCallback, opts) {
	        var original = input, // store the original so we can compare and know if we need to tell the search to update its text
	            dupe = false, // check for whether a token we extracted represents a duplicate selected choice
	            token, // token
	            index, // position at which the separator was found
	            i, l, // looping variables
	            separator; // the matched separator
	
	        if (!opts.createSearchChoice || !opts.tokenSeparators || opts.tokenSeparators.length < 1) return undefined;
	
	        while (true) {
	            index = -1;
	
	            for (i = 0, l = opts.tokenSeparators.length; i < l; i++) {
	                separator = opts.tokenSeparators[i];
	                index = input.indexOf(separator);
	                if (index >= 0) break;
	            }
	
	            if (index < 0) break; // did not find any token separator in the input string, bail
	
	            token = input.substring(0, index);
	            input = input.substring(index + separator.length);
	
	            if (token.length > 0) {
	                token = opts.createSearchChoice.call(this, token, selection);
	                if (token !== undefined && token !== null && opts.id(token) !== undefined && opts.id(token) !== null) {
	                    dupe = false;
	                    for (i = 0, l = selection.length; i < l; i++) {
	                        if (equal(opts.id(token), opts.id(selection[i]))) {
	                            dupe = true; break;
	                        }
	                    }
	
	                    if (!dupe) selectCallback(token);
	                }
	            }
	        }
	
	        if (original!==input) return input;
	    }
	
	    function cleanupJQueryElements() {
	        var self = this;
	
	        Array.prototype.forEach.call(arguments, function (element) {
	            self[element].remove();
	            self[element] = null;
	        });
	    }
	
	    /**
	     * Creates a new class
	     *
	     * @param superClass
	     * @param methods
	     */
	    function clazz(SuperClass, methods) {
	        var constructor = function () {};
	        constructor.prototype = new SuperClass;
	        constructor.prototype.constructor = constructor;
	        constructor.prototype.parent = SuperClass.prototype;
	        constructor.prototype = $.extend(constructor.prototype, methods);
	        return constructor;
	    }
	
	    AbstractSelect2 = clazz(Object, {
	
	        // abstract
	        bind: function (func) {
	            var self = this;
	            return function () {
	                func.apply(self, arguments);
	            };
	        },
	
	        // abstract
	        init: function (opts) {
	            var results, search, resultsSelector = ".select2-results";
	
	            // prepare options
	            this.opts = opts = this.prepareOpts(opts);
	
	            this.id=opts.id;
	
	            // destroy if called on an existing component
	            if (opts.element.data("select2") !== undefined &&
	                opts.element.data("select2") !== null) {
	                opts.element.data("select2").destroy();
	            }
	
	            this.container = this.createContainer();
	
	            this.liveRegion = $("<span>", {
	                    role: "status",
	                    "aria-live": "polite"
	                })
	                .addClass("select2-hidden-accessible")
	                .appendTo(document.body);
	
	            this.containerId="s2id_"+(opts.element.attr("id") || "autogen"+nextUid());
	            this.containerEventName= this.containerId
	                .replace(/([.])/g, '_')
	                .replace(/([;&,\-\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1');
	            this.container.attr("id", this.containerId);
	
	            this.container.attr("title", opts.element.attr("title"));
	
	            this.body = $("body");
	
	            syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);
	
	            this.container.attr("style", opts.element.attr("style"));
	            this.container.css(evaluate(opts.containerCss));
	            this.container.addClass(evaluate(opts.containerCssClass));
	
	            this.elementTabIndex = this.opts.element.attr("tabindex");
	
	            // swap container for the element
	            this.opts.element
	                .data("select2", this)
	                .attr("tabindex", "-1")
	                .before(this.container)
	                .on("click.select2", killEvent); // do not leak click events
	
	            this.container.data("select2", this);
	
	            this.dropdown = this.container.find(".select2-drop");
	
	            syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);
	
	            this.dropdown.addClass(evaluate(opts.dropdownCssClass));
	            this.dropdown.data("select2", this);
	            this.dropdown.on("click", killEvent);
	
	            this.results = results = this.container.find(resultsSelector);
	            this.search = search = this.container.find("input.select2-input");
	
	            this.queryCount = 0;
	            this.resultsPage = 0;
	            this.context = null;
	
	            // initialize the container
	            this.initContainer();
	
	            this.container.on("click", killEvent);
	
	            installFilteredMouseMove(this.results);
	
	            this.dropdown.on("mousemove-filtered", resultsSelector, this.bind(this.highlightUnderEvent));
	            this.dropdown.on("touchstart touchmove touchend", resultsSelector, this.bind(function (event) {
	                this._touchEvent = true;
	                this.highlightUnderEvent(event);
	            }));
	            this.dropdown.on("touchmove", resultsSelector, this.bind(this.touchMoved));
	            this.dropdown.on("touchstart touchend", resultsSelector, this.bind(this.clearTouchMoved));
	
	            // Waiting for a click event on touch devices to select option and hide dropdown
	            // otherwise click will be triggered on an underlying element
	            this.dropdown.on('click', this.bind(function (event) {
	                if (this._touchEvent) {
	                    this._touchEvent = false;
	                    this.selectHighlighted();
	                }
	            }));
	
	            installDebouncedScroll(80, this.results);
	            this.dropdown.on("scroll-debounced", resultsSelector, this.bind(this.loadMoreIfNeeded));
	
	            // do not propagate change event from the search field out of the component
	            $(this.container).on("change", ".select2-input", function(e) {e.stopPropagation();});
	            $(this.dropdown).on("change", ".select2-input", function(e) {e.stopPropagation();});
	
	            // if jquery.mousewheel plugin is installed we can prevent out-of-bounds scrolling of results via mousewheel
	            if ($.fn.mousewheel) {
	                results.mousewheel(function (e, delta, deltaX, deltaY) {
	                    var top = results.scrollTop();
	                    if (deltaY > 0 && top - deltaY <= 0) {
	                        results.scrollTop(0);
	                        killEvent(e);
	                    } else if (deltaY < 0 && results.get(0).scrollHeight - results.scrollTop() + deltaY <= results.height()) {
	                        results.scrollTop(results.get(0).scrollHeight - results.height());
	                        killEvent(e);
	                    }
	                });
	            }
	
	            installKeyUpChangeEvent(search);
	            search.on("keyup-change input paste", this.bind(this.updateResults));
	            search.on("focus", function () { search.addClass("select2-focused"); });
	            search.on("blur", function () { search.removeClass("select2-focused");});
	
	            this.dropdown.on("mouseup", resultsSelector, this.bind(function (e) {
	                if ($(e.target).closest(".select2-result-selectable").length > 0) {
	                    this.highlightUnderEvent(e);
	                    this.selectHighlighted(e);
	                }
	            }));
	
	            // trap all mouse events from leaving the dropdown. sometimes there may be a modal that is listening
	            // for mouse events outside of itself so it can close itself. since the dropdown is now outside the select2's
	            // dom it will trigger the popup close, which is not what we want
	            // focusin can cause focus wars between modals and select2 since the dropdown is outside the modal.
	            this.dropdown.on("click mouseup mousedown touchstart touchend focusin", function (e) { e.stopPropagation(); });
	
	            this.nextSearchTerm = undefined;
	
	            if ($.isFunction(this.opts.initSelection)) {
	                // initialize selection based on the current value of the source element
	                this.initSelection();
	
	                // if the user has provided a function that can set selection based on the value of the source element
	                // we monitor the change event on the element and trigger it, allowing for two way synchronization
	                this.monitorSource();
	            }
	
	            if (opts.maximumInputLength !== null) {
	                this.search.attr("maxlength", opts.maximumInputLength);
	            }
	
	            var disabled = opts.element.prop("disabled");
	            if (disabled === undefined) disabled = false;
	            this.enable(!disabled);
	
	            var readonly = opts.element.prop("readonly");
	            if (readonly === undefined) readonly = false;
	            this.readonly(readonly);
	
	            // Calculate size of scrollbar
	            scrollBarDimensions = scrollBarDimensions || measureScrollbar();
	
	            this.autofocus = opts.element.prop("autofocus");
	            opts.element.prop("autofocus", false);
	            if (this.autofocus) this.focus();
	
	            this.search.attr("placeholder", opts.searchInputPlaceholder);
	        },
	
	        // abstract
	        destroy: function () {
	            var element=this.opts.element, select2 = element.data("select2");
	
	            this.close();
	
	            if (this.propertyObserver) {
	                this.propertyObserver.disconnect();
	                this.propertyObserver = null;
	            }
	
	            if (select2 !== undefined) {
	                select2.container.remove();
	                select2.liveRegion.remove();
	                select2.dropdown.remove();
	                element
	                    .removeClass("select2-offscreen")
	                    .removeData("select2")
	                    .off(".select2")
	                    .prop("autofocus", this.autofocus || false);
	                if (this.elementTabIndex) {
	                    element.attr({tabindex: this.elementTabIndex});
	                } else {
	                    element.removeAttr("tabindex");
	                }
	                element.show();
	            }
	
	            cleanupJQueryElements.call(this,
	                "container",
	                "liveRegion",
	                "dropdown",
	                "results",
	                "search"
	            );
	        },
	
	        // abstract
	        optionToData: function(element) {
	            if (element.is("option")) {
	                return {
	                    id:element.prop("value"),
	                    text:element.text(),
	                    element: element.get(),
	                    css: element.attr("class"),
	                    disabled: element.prop("disabled"),
	                    locked: equal(element.attr("locked"), "locked") || equal(element.data("locked"), true)
	                };
	            } else if (element.is("optgroup")) {
	                return {
	                    text:element.attr("label"),
	                    children:[],
	                    element: element.get(),
	                    css: element.attr("class")
	                };
	            }
	        },
	
	        // abstract
	        prepareOpts: function (opts) {
	            var element, select, idKey, ajaxUrl, self = this;
	
	            element = opts.element;
	
	            if (element.get(0).tagName.toLowerCase() === "select") {
	                this.select = select = opts.element;
	            }
	
	            if (select) {
	                // these options are not allowed when attached to a select because they are picked up off the element itself
	                $.each(["id", "multiple", "ajax", "query", "createSearchChoice", "initSelection", "data", "tags"], function () {
	                    if (this in opts) {
	                        throw new Error("Option '" + this + "' is not allowed for Select2 when attached to a <select> element.");
	                    }
	                });
	            }
	
	            opts = $.extend({}, {
	                populateResults: function(container, results, query) {
	                    var populate, id=this.opts.id, liveRegion=this.liveRegion;
	
	                    populate=function(results, container, depth) {
	
	                        var i, l, result, selectable, disabled, compound, node, label, innerContainer, formatted;
	
	                        results = opts.sortResults(results, container, query);
	
	                        for (i = 0, l = results.length; i < l; i = i + 1) {
	
	                            result=results[i];
	
	                            disabled = (result.disabled === true);
	                            selectable = (!disabled) && (id(result) !== undefined);
	
	                            compound=result.children && result.children.length > 0;
	
	                            node=$("<li></li>");
	                            node.addClass("select2-results-dept-"+depth);
	                            node.addClass("select2-result");
	                            node.addClass(selectable ? "select2-result-selectable" : "select2-result-unselectable");
	                            if (disabled) { node.addClass("select2-disabled"); }
	                            if (compound) { node.addClass("select2-result-with-children"); }
	                            node.addClass(self.opts.formatResultCssClass(result));
	                            node.attr("role", "presentation");
	
	                            label=$(document.createElement("div"));
	                            label.addClass("select2-result-label");
	                            label.attr("id", "select2-result-label-" + nextUid());
	                            label.attr("role", "option");
	
	                            formatted=opts.formatResult(result, label, query, self.opts.escapeMarkup);
	                            if (formatted!==undefined) {
	                                label.html(formatted);
	                                node.append(label);
	                            }
	
	
	                            if (compound) {
	
	                                innerContainer=$("<ul></ul>");
	                                innerContainer.addClass("select2-result-sub");
	                                populate(result.children, innerContainer, depth+1);
	                                node.append(innerContainer);
	                            }
	
	                            node.data("select2-data", result);
	                            container.append(node);
	                        }
	
	                        liveRegion.text(opts.formatMatches(results.length));
	                    };
	
	                    populate(results, container, 0);
	                }
	            }, $.fn.select2.defaults, opts);
	
	            if (typeof(opts.id) !== "function") {
	                idKey = opts.id;
	                opts.id = function (e) { return e[idKey]; };
	            }
	
	            if ($.isArray(opts.element.data("select2Tags"))) {
	                if ("tags" in opts) {
	                    throw "tags specified as both an attribute 'data-select2-tags' and in options of Select2 " + opts.element.attr("id");
	                }
	                opts.tags=opts.element.data("select2Tags");
	            }
	
	            if (select) {
	                opts.query = this.bind(function (query) {
	                    var data = { results: [], more: false },
	                        term = query.term,
	                        children, placeholderOption, process;
	
	                    process=function(element, collection) {
	                        var group;
	                        if (element.is("option")) {
	                            if (query.matcher(term, element.text(), element)) {
	                                collection.push(self.optionToData(element));
	                            }
	                        } else if (element.is("optgroup")) {
	                            group=self.optionToData(element);
	                            element.children().each2(function(i, elm) { process(elm, group.children); });
	                            if (group.children.length>0) {
	                                collection.push(group);
	                            }
	                        }
	                    };
	
	                    children=element.children();
	
	                    // ignore the placeholder option if there is one
	                    if (this.getPlaceholder() !== undefined && children.length > 0) {
	                        placeholderOption = this.getPlaceholderOption();
	                        if (placeholderOption) {
	                            children=children.not(placeholderOption);
	                        }
	                    }
	
	                    children.each2(function(i, elm) { process(elm, data.results); });
	
	                    query.callback(data);
	                });
	                // this is needed because inside val() we construct choices from options and there id is hardcoded
	                opts.id=function(e) { return e.id; };
	            } else {
	                if (!("query" in opts)) {
	
	                    if ("ajax" in opts) {
	                        ajaxUrl = opts.element.data("ajax-url");
	                        if (ajaxUrl && ajaxUrl.length > 0) {
	                            opts.ajax.url = ajaxUrl;
	                        }
	                        opts.query = ajax.call(opts.element, opts.ajax);
	                    } else if ("data" in opts) {
	                        opts.query = local(opts.data);
	                    } else if ("tags" in opts) {
	                        opts.query = tags(opts.tags);
	                        if (opts.createSearchChoice === undefined) {
	                            opts.createSearchChoice = function (term) { return {id: $.trim(term), text: $.trim(term)}; };
	                        }
	                        if (opts.initSelection === undefined) {
	                            opts.initSelection = function (element, callback) {
	                                var data = [];
	                                $(splitVal(element.val(), opts.separator)).each(function () {
	                                    var obj = { id: this, text: this },
	                                        tags = opts.tags;
	                                    if ($.isFunction(tags)) tags=tags();
	                                    $(tags).each(function() { if (equal(this.id, obj.id)) { obj = this; return false; } });
	                                    data.push(obj);
	                                });
	
	                                callback(data);
	                            };
	                        }
	                    }
	                }
	            }
	            if (typeof(opts.query) !== "function") {
	                throw "query function not defined for Select2 " + opts.element.attr("id");
	            }
	
	            if (opts.createSearchChoicePosition === 'top') {
	                opts.createSearchChoicePosition = function(list, item) { list.unshift(item); };
	            }
	            else if (opts.createSearchChoicePosition === 'bottom') {
	                opts.createSearchChoicePosition = function(list, item) { list.push(item); };
	            }
	            else if (typeof(opts.createSearchChoicePosition) !== "function")  {
	                throw "invalid createSearchChoicePosition option must be 'top', 'bottom' or a custom function";
	            }
	
	            return opts;
	        },
	
	        /**
	         * Monitor the original element for changes and update select2 accordingly
	         */
	        // abstract
	        monitorSource: function () {
	            var el = this.opts.element, sync, observer;
	
	            el.on("change.select2", this.bind(function (e) {
	                if (this.opts.element.data("select2-change-triggered") !== true) {
	                    this.initSelection();
	                }
	            }));
	
	            sync = this.bind(function () {
	
	                // sync enabled state
	                var disabled = el.prop("disabled");
	                if (disabled === undefined) disabled = false;
	                this.enable(!disabled);
	
	                var readonly = el.prop("readonly");
	                if (readonly === undefined) readonly = false;
	                this.readonly(readonly);
	
	                syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);
	                this.container.addClass(evaluate(this.opts.containerCssClass));
	
	                syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);
	                this.dropdown.addClass(evaluate(this.opts.dropdownCssClass));
	
	            });
	
	            // IE8-10 (IE9/10 won't fire propertyChange via attachEventListener)
	            if (el.length && el[0].attachEvent) {
	                el.each(function() {
	                    this.attachEvent("onpropertychange", sync);
	                });
	            }
	            
	            // safari, chrome, firefox, IE11
	            observer = window.MutationObserver || window.WebKitMutationObserver|| window.MozMutationObserver;
	            if (observer !== undefined) {
	                if (this.propertyObserver) { delete this.propertyObserver; this.propertyObserver = null; }
	                this.propertyObserver = new observer(function (mutations) {
	                    mutations.forEach(sync);
	                });
	                this.propertyObserver.observe(el.get(0), { attributes:true, subtree:false });
	            }
	        },
	
	        // abstract
	        triggerSelect: function(data) {
	            var evt = $.Event("select2-selecting", { val: this.id(data), object: data });
	            this.opts.element.trigger(evt);
	            return !evt.isDefaultPrevented();
	        },
	
	        /**
	         * Triggers the change event on the source element
	         */
	        // abstract
	        triggerChange: function (details) {
	
	            details = details || {};
	            details= $.extend({}, details, { type: "change", val: this.val() });
	            // prevents recursive triggering
	            this.opts.element.data("select2-change-triggered", true);
	            this.opts.element.trigger(details);
	            this.opts.element.data("select2-change-triggered", false);
	
	            // some validation frameworks ignore the change event and listen instead to keyup, click for selects
	            // so here we trigger the click event manually
	            this.opts.element.click();
	
	            // ValidationEngine ignores the change event and listens instead to blur
	            // so here we trigger the blur event manually if so desired
	            if (this.opts.blurOnChange)
	                this.opts.element.blur();
	        },
	
	        //abstract
	        isInterfaceEnabled: function()
	        {
	            return this.enabledInterface === true;
	        },
	
	        // abstract
	        enableInterface: function() {
	            var enabled = this._enabled && !this._readonly,
	                disabled = !enabled;
	
	            if (enabled === this.enabledInterface) return false;
	
	            this.container.toggleClass("select2-container-disabled", disabled);
	            this.close();
	            this.enabledInterface = enabled;
	
	            return true;
	        },
	
	        // abstract
	        enable: function(enabled) {
	            if (enabled === undefined) enabled = true;
	            if (this._enabled === enabled) return;
	            this._enabled = enabled;
	
	            this.opts.element.prop("disabled", !enabled);
	            this.enableInterface();
	        },
	
	        // abstract
	        disable: function() {
	            this.enable(false);
	        },
	
	        // abstract
	        readonly: function(enabled) {
	            if (enabled === undefined) enabled = false;
	            if (this._readonly === enabled) return;
	            this._readonly = enabled;
	
	            this.opts.element.prop("readonly", enabled);
	            this.enableInterface();
	        },
	
	        // abstract
	        opened: function () {
	            return this.container.hasClass("select2-dropdown-open");
	        },
	
	        // abstract
	        positionDropdown: function() {
	            var $dropdown = this.dropdown,
	                offset = this.container.offset(),
	                height = this.container.outerHeight(false),
	                width = this.container.outerWidth(false),
	                dropHeight = $dropdown.outerHeight(false),
	                $window = $(window),
	                windowWidth = $window.width(),
	                windowHeight = $window.height(),
	                viewPortRight = $window.scrollLeft() + windowWidth,
	                viewportBottom = $window.scrollTop() + windowHeight,
	                dropTop = offset.top + height,
	                dropLeft = offset.left,
	                enoughRoomBelow = dropTop + dropHeight <= viewportBottom,
	                enoughRoomAbove = (offset.top - dropHeight) >= $window.scrollTop(),
	                dropWidth = $dropdown.outerWidth(false),
	                enoughRoomOnRight = dropLeft + dropWidth <= viewPortRight,
	                aboveNow = $dropdown.hasClass("select2-drop-above"),
	                bodyOffset,
	                above,
	                changeDirection,
	                css,
	                resultsListNode;
	
	            // always prefer the current above/below alignment, unless there is not enough room
	            if (aboveNow) {
	                above = true;
	                if (!enoughRoomAbove && enoughRoomBelow) {
	                    changeDirection = true;
	                    above = false;
	                }
	            } else {
	                above = false;
	                if (!enoughRoomBelow && enoughRoomAbove) {
	                    changeDirection = true;
	                    above = true;
	                }
	            }
	
	            //if we are changing direction we need to get positions when dropdown is hidden;
	            if (changeDirection) {
	                $dropdown.hide();
	                offset = this.container.offset();
	                height = this.container.outerHeight(false);
	                width = this.container.outerWidth(false);
	                dropHeight = $dropdown.outerHeight(false);
	                viewPortRight = $window.scrollLeft() + windowWidth;
	                viewportBottom = $window.scrollTop() + windowHeight;
	                dropTop = offset.top + height;
	                dropLeft = offset.left;
	                dropWidth = $dropdown.outerWidth(false);
	                enoughRoomOnRight = dropLeft + dropWidth <= viewPortRight;
	                $dropdown.show();
	
	                // fix so the cursor does not move to the left within the search-textbox in IE
	                this.focusSearch();
	            }
	
	            if (this.opts.dropdownAutoWidth) {
	                resultsListNode = $('.select2-results', $dropdown)[0];
	                $dropdown.addClass('select2-drop-auto-width');
	                $dropdown.css('width', '');
	                // Add scrollbar width to dropdown if vertical scrollbar is present
	                dropWidth = $dropdown.outerWidth(false) + (resultsListNode.scrollHeight === resultsListNode.clientHeight ? 0 : scrollBarDimensions.width);
	                dropWidth > width ? width = dropWidth : dropWidth = width;
	                dropHeight = $dropdown.outerHeight(false);
	                enoughRoomOnRight = dropLeft + dropWidth <= viewPortRight;
	            }
	            else {
	                this.container.removeClass('select2-drop-auto-width');
	            }
	
	            //console.log("below/ droptop:", dropTop, "dropHeight", dropHeight, "sum", (dropTop+dropHeight)+" viewport bottom", viewportBottom, "enough?", enoughRoomBelow);
	            //console.log("above/ offset.top", offset.top, "dropHeight", dropHeight, "top", (offset.top-dropHeight), "scrollTop", this.body.scrollTop(), "enough?", enoughRoomAbove);
	
	            // fix positioning when body has an offset and is not position: static
	            if (this.body.css('position') !== 'static') {
	                bodyOffset = this.body.offset();
	                dropTop -= bodyOffset.top;
	                dropLeft -= bodyOffset.left;
	            }
	
	            if (!enoughRoomOnRight) {
	                dropLeft = offset.left + this.container.outerWidth(false) - dropWidth;
	            }
	
	            css =  {
	                left: dropLeft,
	                width: width
	            };
	
	            if (above) {
	                css.top = offset.top - dropHeight;
	                css.bottom = 'auto';
	                this.container.addClass("select2-drop-above");
	                $dropdown.addClass("select2-drop-above");
	            }
	            else {
	                css.top = dropTop;
	                css.bottom = 'auto';
	                this.container.removeClass("select2-drop-above");
	                $dropdown.removeClass("select2-drop-above");
	            }
	            css = $.extend(css, evaluate(this.opts.dropdownCss));
	
	            $dropdown.css(css);
	        },
	
	        // abstract
	        shouldOpen: function() {
	            var event;
	
	            if (this.opened()) return false;
	
	            if (this._enabled === false || this._readonly === true) return false;
	
	            event = $.Event("select2-opening");
	            this.opts.element.trigger(event);
	            return !event.isDefaultPrevented();
	        },
	
	        // abstract
	        clearDropdownAlignmentPreference: function() {
	            // clear the classes used to figure out the preference of where the dropdown should be opened
	            this.container.removeClass("select2-drop-above");
	            this.dropdown.removeClass("select2-drop-above");
	        },
	
	        /**
	         * Opens the dropdown
	         *
	         * @return {Boolean} whether or not dropdown was opened. This method will return false if, for example,
	         * the dropdown is already open, or if the 'open' event listener on the element called preventDefault().
	         */
	        // abstract
	        open: function () {
	
	            if (!this.shouldOpen()) return false;
	
	            this.opening();
	
	            return true;
	        },
	
	        /**
	         * Performs the opening of the dropdown
	         */
	        // abstract
	        opening: function() {
	            var cid = this.containerEventName,
	                scroll = "scroll." + cid,
	                resize = "resize."+cid,
	                orient = "orientationchange."+cid,
	                mask;
	
	            this.container.addClass("select2-dropdown-open").addClass("select2-container-active");
	
	            this.clearDropdownAlignmentPreference();
	
	            if(this.dropdown[0] !== this.body.children().last()[0]) {
	                this.dropdown.detach().appendTo(this.body);
	            }
	
	            // create the dropdown mask if doesn't already exist
	            mask = $("#select2-drop-mask");
	            if (mask.length == 0) {
	                mask = $(document.createElement("div"));
	                mask.attr("id","select2-drop-mask").attr("class","select2-drop-mask");
	                mask.hide();
	                mask.appendTo(this.body);
	                mask.on("mousedown touchstart click", function (e) {
	                    // Prevent IE from generating a click event on the body
	                    reinsertElement(mask);
	
	                    var dropdown = $("#select2-drop"), self;
	                    if (dropdown.length > 0) {
	                        self=dropdown.data("select2");
	                        if (self.opts.selectOnBlur) {
	                            self.selectHighlighted({noFocus: true});
	                        }
	                        self.close();
	                        e.preventDefault();
	                        e.stopPropagation();
	                    }
	                });
	            }
	
	            // ensure the mask is always right before the dropdown
	            if (this.dropdown.prev()[0] !== mask[0]) {
	                this.dropdown.before(mask);
	            }
	
	            // move the global id to the correct dropdown
	            $("#select2-drop").removeAttr("id");
	            this.dropdown.attr("id", "select2-drop");
	
	            // show the elements
	            mask.show();
	
	            this.positionDropdown();
	            this.dropdown.show();
	            this.positionDropdown();
	
	            this.dropdown.addClass("select2-drop-active");
	
	            // attach listeners to events that can change the position of the container and thus require
	            // the position of the dropdown to be updated as well so it does not come unglued from the container
	            var that = this;
	            this.container.parents().add(window).each(function () {
	                $(this).on(resize+" "+scroll+" "+orient, function (e) {
	                    if (that.opened()) that.positionDropdown();
	                });
	            });
	
	
	        },
	
	        // abstract
	        close: function () {
	            if (!this.opened()) return;
	
	            var cid = this.containerEventName,
	                scroll = "scroll." + cid,
	                resize = "resize."+cid,
	                orient = "orientationchange."+cid;
	
	            // unbind event listeners
	            this.container.parents().add(window).each(function () { $(this).off(scroll).off(resize).off(orient); });
	
	            this.clearDropdownAlignmentPreference();
	
	            $("#select2-drop-mask").hide();
	            this.dropdown.removeAttr("id"); // only the active dropdown has the select2-drop id
	            this.dropdown.hide();
	            this.container.removeClass("select2-dropdown-open").removeClass("select2-container-active");
	            this.results.empty();
	
	
	            this.clearSearch();
	            this.search.removeClass("select2-active");
	            this.opts.element.trigger($.Event("select2-close"));
	        },
	
	        /**
	         * Opens control, sets input value, and updates results.
	         */
	        // abstract
	        externalSearch: function (term) {
	            this.open();
	            this.search.val(term);
	            this.updateResults(false);
	        },
	
	        // abstract
	        clearSearch: function () {
	
	        },
	
	        //abstract
	        getMaximumSelectionSize: function() {
	            return evaluate(this.opts.maximumSelectionSize);
	        },
	
	        // abstract
	        ensureHighlightVisible: function () {
	            var results = this.results, children, index, child, hb, rb, y, more;
	
	            index = this.highlight();
	
	            if (index < 0) return;
	
	            if (index == 0) {
	
	                // if the first element is highlighted scroll all the way to the top,
	                // that way any unselectable headers above it will also be scrolled
	                // into view
	
	                results.scrollTop(0);
	                return;
	            }
	
	            children = this.findHighlightableChoices().find('.select2-result-label');
	
	            child = $(children[index]);
	
	            hb = child.offset().top + child.outerHeight(true);
	
	            // if this is the last child lets also make sure select2-more-results is visible
	            if (index === children.length - 1) {
	                more = results.find("li.select2-more-results");
	                if (more.length > 0) {
	                    hb = more.offset().top + more.outerHeight(true);
	                }
	            }
	
	            rb = results.offset().top + results.outerHeight(true);
	            if (hb > rb) {
	                results.scrollTop(results.scrollTop() + (hb - rb));
	            }
	            y = child.offset().top - results.offset().top;
	
	            // make sure the top of the element is visible
	            if (y < 0 && child.css('display') != 'none' ) {
	                results.scrollTop(results.scrollTop() + y); // y is negative
	            }
	        },
	
	        // abstract
	        findHighlightableChoices: function() {
	            return this.results.find(".select2-result-selectable:not(.select2-disabled):not(.select2-selected)");
	        },
	
	        // abstract
	        moveHighlight: function (delta) {
	            var choices = this.findHighlightableChoices(),
	                index = this.highlight();
	
	            while (index > -1 && index < choices.length) {
	                index += delta;
	                var choice = $(choices[index]);
	                if (choice.hasClass("select2-result-selectable") && !choice.hasClass("select2-disabled") && !choice.hasClass("select2-selected")) {
	                    this.highlight(index);
	                    break;
	                }
	            }
	        },
	
	        // abstract
	        highlight: function (index) {
	            var choices = this.findHighlightableChoices(),
	                choice,
	                data;
	
	            if (arguments.length === 0) {
	                return indexOf(choices.filter(".select2-highlighted")[0], choices.get());
	            }
	
	            if (index >= choices.length) index = choices.length - 1;
	            if (index < 0) index = 0;
	
	            this.removeHighlight();
	
	            choice = $(choices[index]);
	            choice.addClass("select2-highlighted");
	
	            // ensure assistive technology can determine the active choice
	            this.search.attr("aria-activedescendant", choice.find(".select2-result-label").attr("id"));
	
	            this.ensureHighlightVisible();
	
	            this.liveRegion.text(choice.text());
	
	            data = choice.data("select2-data");
	            if (data) {
	                this.opts.element.trigger({ type: "select2-highlight", val: this.id(data), choice: data });
	            }
	        },
	
	        removeHighlight: function() {
	            this.results.find(".select2-highlighted").removeClass("select2-highlighted");
	        },
	
	        touchMoved: function() {
	            this._touchMoved = true;
	        },
	
	        clearTouchMoved: function() {
	          this._touchMoved = false;
	        },
	
	        // abstract
	        countSelectableResults: function() {
	            return this.findHighlightableChoices().length;
	        },
	
	        // abstract
	        highlightUnderEvent: function (event) {
	            var el = $(event.target).closest(".select2-result-selectable");
	            if (el.length > 0 && !el.is(".select2-highlighted")) {
	                var choices = this.findHighlightableChoices();
	                this.highlight(choices.index(el));
	            } else if (el.length == 0) {
	                // if we are over an unselectable item remove all highlights
	                this.removeHighlight();
	            }
	        },
	
	        // abstract
	        loadMoreIfNeeded: function () {
	            var results = this.results,
	                more = results.find("li.select2-more-results"),
	                below, // pixels the element is below the scroll fold, below==0 is when the element is starting to be visible
	                page = this.resultsPage + 1,
	                self=this,
	                term=this.search.val(),
	                context=this.context;
	
	            if (more.length === 0) return;
	            below = more.offset().top - results.offset().top - results.height();
	
	            if (below <= this.opts.loadMorePadding) {
	                more.addClass("select2-active");
	                this.opts.query({
	                        element: this.opts.element,
	                        term: term,
	                        page: page,
	                        context: context,
	                        matcher: this.opts.matcher,
	                        callback: this.bind(function (data) {
	
	                    // ignore a response if the select2 has been closed before it was received
	                    if (!self.opened()) return;
	
	
	                    self.opts.populateResults.call(this, results, data.results, {term: term, page: page, context:context});
	                    self.postprocessResults(data, false, false);
	
	                    if (data.more===true) {
	                        more.detach().appendTo(results).text(evaluate(self.opts.formatLoadMore, page+1));
	                        window.setTimeout(function() { self.loadMoreIfNeeded(); }, 10);
	                    } else {
	                        more.remove();
	                    }
	                    self.positionDropdown();
	                    self.resultsPage = page;
	                    self.context = data.context;
	                    this.opts.element.trigger({ type: "select2-loaded", items: data });
	                })});
	            }
	        },
	
	        /**
	         * Default tokenizer function which does nothing
	         */
	        tokenize: function() {
	
	        },
	
	        /**
	         * @param initial whether or not this is the call to this method right after the dropdown has been opened
	         */
	        // abstract
	        updateResults: function (initial) {
	            var search = this.search,
	                results = this.results,
	                opts = this.opts,
	                data,
	                self = this,
	                input,
	                term = search.val(),
	                lastTerm = $.data(this.container, "select2-last-term"),
	                // sequence number used to drop out-of-order responses
	                queryNumber;
	
	            // prevent duplicate queries against the same term
	            if (initial !== true && lastTerm && equal(term, lastTerm)) return;
	
	            $.data(this.container, "select2-last-term", term);
	
	            // if the search is currently hidden we do not alter the results
	            if (initial !== true && (this.showSearchInput === false || !this.opened())) {
	                return;
	            }
	
	            function postRender() {
	                search.removeClass("select2-active");
	                self.positionDropdown();
	                if (results.find('.select2-no-results,.select2-selection-limit,.select2-searching').length) {
	                    self.liveRegion.text(results.text());
	                }
	                else {
	                    self.liveRegion.text(self.opts.formatMatches(results.find('.select2-result-selectable').length));
	                }
	            }
	
	            function render(html) {
	                results.html(html);
	                postRender();
	            }
	
	            queryNumber = ++this.queryCount;
	
	            var maxSelSize = this.getMaximumSelectionSize();
	            if (maxSelSize >=1) {
	                data = this.data();
	                if ($.isArray(data) && data.length >= maxSelSize && checkFormatter(opts.formatSelectionTooBig, "formatSelectionTooBig")) {
	                    render("<li class='select2-selection-limit'>" + evaluate(opts.formatSelectionTooBig, maxSelSize) + "</li>");
	                    return;
	                }
	            }
	
	            if (search.val().length < opts.minimumInputLength) {
	                if (checkFormatter(opts.formatInputTooShort, "formatInputTooShort")) {
	                    render("<li class='select2-no-results'>" + evaluate(opts.formatInputTooShort, search.val(), opts.minimumInputLength) + "</li>");
	                } else {
	                    render("");
	                }
	                if (initial && this.showSearch) this.showSearch(true);
	                return;
	            }
	
	            if (opts.maximumInputLength && search.val().length > opts.maximumInputLength) {
	                if (checkFormatter(opts.formatInputTooLong, "formatInputTooLong")) {
	                    render("<li class='select2-no-results'>" + evaluate(opts.formatInputTooLong, search.val(), opts.maximumInputLength) + "</li>");
	                } else {
	                    render("");
	                }
	                return;
	            }
	
	            if (opts.formatSearching && this.findHighlightableChoices().length === 0) {
	                render("<li class='select2-searching'>" + evaluate(opts.formatSearching) + "</li>");
	            }
	
	            search.addClass("select2-active");
	
	            this.removeHighlight();
	
	            // give the tokenizer a chance to pre-process the input
	            input = this.tokenize();
	            if (input != undefined && input != null) {
	                search.val(input);
	            }
	
	            this.resultsPage = 1;
	
	            opts.query({
	                element: opts.element,
	                    term: search.val(),
	                    page: this.resultsPage,
	                    context: null,
	                    matcher: opts.matcher,
	                    callback: this.bind(function (data) {
	                var def; // default choice
	
	                // ignore old responses
	                if (queryNumber != this.queryCount) {
	                  return;
	                }
	
	                // ignore a response if the select2 has been closed before it was received
	                if (!this.opened()) {
	                    this.search.removeClass("select2-active");
	                    return;
	                }
	
	                // save context, if any
	                this.context = (data.context===undefined) ? null : data.context;
	                // create a default choice and prepend it to the list
	                if (this.opts.createSearchChoice && search.val() !== "") {
	                    def = this.opts.createSearchChoice.call(self, search.val(), data.results);
	                    if (def !== undefined && def !== null && self.id(def) !== undefined && self.id(def) !== null) {
	                        if ($(data.results).filter(
	                            function () {
	                                return equal(self.id(this), self.id(def));
	                            }).length === 0) {
	                            this.opts.createSearchChoicePosition(data.results, def);
	                        }
	                    }
	                }
	
	                if (data.results.length === 0 && checkFormatter(opts.formatNoMatches, "formatNoMatches")) {
	                    render("<li class='select2-no-results'>" + evaluate(opts.formatNoMatches, search.val()) + "</li>");
	                    return;
	                }
	
	                results.empty();
	                self.opts.populateResults.call(this, results, data.results, {term: search.val(), page: this.resultsPage, context:null});
	
	                if (data.more === true && checkFormatter(opts.formatLoadMore, "formatLoadMore")) {
	                    results.append("<li class='select2-more-results'>" + self.opts.escapeMarkup(evaluate(opts.formatLoadMore, this.resultsPage)) + "</li>");
	                    window.setTimeout(function() { self.loadMoreIfNeeded(); }, 10);
	                }
	
	                this.postprocessResults(data, initial);
	
	                postRender();
	
	                this.opts.element.trigger({ type: "select2-loaded", items: data });
	            })});
	        },
	
	        // abstract
	        cancel: function () {
	            this.close();
	        },
	
	        // abstract
	        blur: function () {
	            // if selectOnBlur == true, select the currently highlighted option
	            if (this.opts.selectOnBlur)
	                this.selectHighlighted({noFocus: true});
	
	            this.close();
	            this.container.removeClass("select2-container-active");
	            // synonymous to .is(':focus'), which is available in jquery >= 1.6
	            if (this.search[0] === document.activeElement) { this.search.blur(); }
	            this.clearSearch();
	            this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
	        },
	
	        // abstract
	        focusSearch: function () {
	            focus(this.search);
	        },
	
	        // abstract
	        selectHighlighted: function (options) {
	            if (this._touchMoved) {
	              this.clearTouchMoved();
	              return;
	            }
	            var index=this.highlight(),
	                highlighted=this.results.find(".select2-highlighted"),
	                data = highlighted.closest('.select2-result').data("select2-data");
	
	            if (data) {
	                this.highlight(index);
	                this.onSelect(data, options);
	            } else if (options && options.noFocus) {
	                this.close();
	            }
	        },
	
	        // abstract
	        getPlaceholder: function () {
	            var placeholderOption;
	            return this.opts.element.attr("placeholder") ||
	                this.opts.element.attr("data-placeholder") || // jquery 1.4 compat
	                this.opts.element.data("placeholder") ||
	                this.opts.placeholder ||
	                ((placeholderOption = this.getPlaceholderOption()) !== undefined ? placeholderOption.text() : undefined);
	        },
	
	        // abstract
	        getPlaceholderOption: function() {
	            if (this.select) {
	                var firstOption = this.select.children('option').first();
	                if (this.opts.placeholderOption !== undefined ) {
	                    //Determine the placeholder option based on the specified placeholderOption setting
	                    return (this.opts.placeholderOption === "first" && firstOption) ||
	                           (typeof this.opts.placeholderOption === "function" && this.opts.placeholderOption(this.select));
	                } else if ($.trim(firstOption.text()) === "" && firstOption.val() === "") {
	                    //No explicit placeholder option specified, use the first if it's blank
	                    return firstOption;
	                }
	            }
	        },
	
	        /**
	         * Get the desired width for the container element.  This is
	         * derived first from option `width` passed to select2, then
	         * the inline 'style' on the original element, and finally
	         * falls back to the jQuery calculated element width.
	         */
	        // abstract
	        initContainerWidth: function () {
	            function resolveContainerWidth() {
	                var style, attrs, matches, i, l, attr;
	
	                if (this.opts.width === "off") {
	                    return null;
	                } else if (this.opts.width === "element"){
	                    return this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px';
	                } else if (this.opts.width === "copy" || this.opts.width === "resolve") {
	                    // check if there is inline style on the element that contains width
	                    style = this.opts.element.attr('style');
	                    if (style !== undefined) {
	                        attrs = style.split(';');
	                        for (i = 0, l = attrs.length; i < l; i = i + 1) {
	                            attr = attrs[i].replace(/\s/g, '');
	                            matches = attr.match(/^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i);
	                            if (matches !== null && matches.length >= 1)
	                                return matches[1];
	                        }
	                    }
	
	                    if (this.opts.width === "resolve") {
	                        // next check if css('width') can resolve a width that is percent based, this is sometimes possible
	                        // when attached to input type=hidden or elements hidden via css
	                        style = this.opts.element.css('width');
	                        if (style.indexOf("%") > 0) return style;
	
	                        // finally, fallback on the calculated width of the element
	                        return (this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px');
	                    }
	
	                    return null;
	                } else if ($.isFunction(this.opts.width)) {
	                    return this.opts.width();
	                } else {
	                    return this.opts.width;
	               }
	            };
	
	            var width = resolveContainerWidth.call(this);
	            if (width !== null) {
	                this.container.css("width", width);
	            }
	        }
	    });
	
	    SingleSelect2 = clazz(AbstractSelect2, {
	
	        // single
	
	        createContainer: function () {
	            var container = $(document.createElement("div")).attr({
	                "class": "select2-container"
	            }).html([
	                "<a href='javascript:void(0)' class='select2-choice' tabindex='-1'>",
	                "   <span class='select2-chosen'>&#160;</span><abbr class='select2-search-choice-close'></abbr>",
	                "   <span class='select2-arrow' role='presentation'><b role='presentation'></b></span>",
	                "</a>",
	                "<label for='' class='select2-offscreen'></label>",
	                "<input class='select2-focusser select2-offscreen' type='text' aria-haspopup='true' role='button' />",
	                "<div class='select2-drop select2-display-none'>",
	                "   <div class='select2-search'>",
	                "       <label for='' class='select2-offscreen'></label>",
	                "       <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input' role='combobox' aria-expanded='true'",
	                "       aria-autocomplete='list' />",
	                "   </div>",
	                "   <ul class='select2-results' role='listbox'>",
	                "   </ul>",
	                "</div>"].join(""));
	            return container;
	        },
	
	        // single
	        enableInterface: function() {
	            if (this.parent.enableInterface.apply(this, arguments)) {
	                this.focusser.prop("disabled", !this.isInterfaceEnabled());
	            }
	        },
	
	        // single
	        opening: function () {
	            var el, range, len;
	
	            if (this.opts.minimumResultsForSearch >= 0) {
	                this.showSearch(true);
	            }
	
	            this.parent.opening.apply(this, arguments);
	
	            if (this.showSearchInput !== false) {
	                // IE appends focusser.val() at the end of field :/ so we manually insert it at the beginning using a range
	                // all other browsers handle this just fine
	
	                this.search.val(this.focusser.val());
	            }
	            if (this.opts.shouldFocusInput(this)) {
	                this.search.focus();
	                // move the cursor to the end after focussing, otherwise it will be at the beginning and
	                // new text will appear *before* focusser.val()
	                el = this.search.get(0);
	                if (el.createTextRange) {
	                    range = el.createTextRange();
	                    range.collapse(false);
	                    range.select();
	                } else if (el.setSelectionRange) {
	                    len = this.search.val().length;
	                    el.setSelectionRange(len, len);
	                }
	            }
	
	            // initializes search's value with nextSearchTerm (if defined by user)
	            // ignore nextSearchTerm if the dropdown is opened by the user pressing a letter
	            if(this.search.val() === "") {
	                if(this.nextSearchTerm != undefined){
	                    this.search.val(this.nextSearchTerm);
	                    this.search.select();
	                }
	            }
	
	            this.focusser.prop("disabled", true).val("");
	            this.updateResults(true);
	            this.opts.element.trigger($.Event("select2-open"));
	        },
	
	        // single
	        close: function () {
	            if (!this.opened()) return;
	            this.parent.close.apply(this, arguments);
	
	            this.focusser.prop("disabled", false);
	
	            if (this.opts.shouldFocusInput(this)) {
	                this.focusser.focus();
	            }
	        },
	
	        // single
	        focus: function () {
	            if (this.opened()) {
	                this.close();
	            } else {
	                this.focusser.prop("disabled", false);
	                if (this.opts.shouldFocusInput(this)) {
	                    this.focusser.focus();
	                }
	            }
	        },
	
	        // single
	        isFocused: function () {
	            return this.container.hasClass("select2-container-active");
	        },
	
	        // single
	        cancel: function () {
	            this.parent.cancel.apply(this, arguments);
	            this.focusser.prop("disabled", false);
	
	            if (this.opts.shouldFocusInput(this)) {
	                this.focusser.focus();
	            }
	        },
	
	        // single
	        destroy: function() {
	            $("label[for='" + this.focusser.attr('id') + "']")
	                .attr('for', this.opts.element.attr("id"));
	            this.parent.destroy.apply(this, arguments);
	
	            cleanupJQueryElements.call(this,
	                "selection",
	                "focusser"
	            );
	        },
	
	        // single
	        initContainer: function () {
	
	            var selection,
	                container = this.container,
	                dropdown = this.dropdown,
	                idSuffix = nextUid(),
	                elementLabel;
	
	            if (this.opts.minimumResultsForSearch < 0) {
	                this.showSearch(false);
	            } else {
	                this.showSearch(true);
	            }
	
	            this.selection = selection = container.find(".select2-choice");
	
	            this.focusser = container.find(".select2-focusser");
	
	            // add aria associations
	            selection.find(".select2-chosen").attr("id", "select2-chosen-"+idSuffix);
	            this.focusser.attr("aria-labelledby", "select2-chosen-"+idSuffix);
	            this.results.attr("id", "select2-results-"+idSuffix);
	            this.search.attr("aria-owns", "select2-results-"+idSuffix);
	
	            // rewrite labels from original element to focusser
	            this.focusser.attr("id", "s2id_autogen"+idSuffix);
	
	            elementLabel = $("label[for='" + this.opts.element.attr("id") + "']");
	
	            this.focusser.prev()
	                .text(elementLabel.text())
	                .attr('for', this.focusser.attr('id'));
	
	            // Ensure the original element retains an accessible name
	            var originalTitle = this.opts.element.attr("title");
	            this.opts.element.attr("title", (originalTitle || elementLabel.text()));
	
	            this.focusser.attr("tabindex", this.elementTabIndex);
	
	            // write label for search field using the label from the focusser element
	            this.search.attr("id", this.focusser.attr('id') + '_search');
	
	            this.search.prev()
	                .text($("label[for='" + this.focusser.attr('id') + "']").text())
	                .attr('for', this.search.attr('id'));
	
	            this.search.on("keydown", this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;
	
	                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
	                    // prevent the page from scrolling
	                    killEvent(e);
	                    return;
	                }
	
	                switch (e.which) {
	                    case KEY.UP:
	                    case KEY.DOWN:
	                        this.moveHighlight((e.which === KEY.UP) ? -1 : 1);
	                        killEvent(e);
	                        return;
	                    case KEY.ENTER:
	                        this.selectHighlighted();
	                        killEvent(e);
	                        return;
	                    case KEY.TAB:
	                        this.selectHighlighted({noFocus: true});
	                        return;
	                    case KEY.ESC:
	                        this.cancel(e);
	                        killEvent(e);
	                        return;
	                }
	            }));
	
	            this.search.on("blur", this.bind(function(e) {
	                // a workaround for chrome to keep the search field focussed when the scroll bar is used to scroll the dropdown.
	                // without this the search field loses focus which is annoying
	                if (document.activeElement === this.body.get(0)) {
	                    window.setTimeout(this.bind(function() {
	                        if (this.opened()) {
	                            this.search.focus();
	                        }
	                    }), 0);
	                }
	            }));
	
	            this.focusser.on("keydown", this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;
	
	                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	                    return;
	                }
	
	                if (this.opts.openOnEnter === false && e.which === KEY.ENTER) {
	                    killEvent(e);
	                    return;
	                }
	
	                if (e.which == KEY.DOWN || e.which == KEY.UP
	                    || (e.which == KEY.ENTER && this.opts.openOnEnter)) {
	
	                    if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) return;
	
	                    this.open();
	                    killEvent(e);
	                    return;
	                }
	
	                if (e.which == KEY.DELETE || e.which == KEY.BACKSPACE) {
	                    if (this.opts.allowClear) {
	                        this.clear();
	                    }
	                    killEvent(e);
	                    return;
	                }
	            }));
	
	
	            installKeyUpChangeEvent(this.focusser);
	            this.focusser.on("keyup-change input", this.bind(function(e) {
	                if (this.opts.minimumResultsForSearch >= 0) {
	                    e.stopPropagation();
	                    if (this.opened()) return;
	                    this.open();
	                }
	            }));
	
	            selection.on("mousedown touchstart", "abbr", this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;
	                this.clear();
	                killEventImmediately(e);
	                this.close();
	                this.selection.focus();
	            }));
	
	            selection.on("mousedown touchstart", this.bind(function (e) {
	                // Prevent IE from generating a click event on the body
	                reinsertElement(selection);
	
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	
	                if (this.opened()) {
	                    this.close();
	                } else if (this.isInterfaceEnabled()) {
	                    this.open();
	                }
	
	                killEvent(e);
	            }));
	
	            dropdown.on("mousedown touchstart", this.bind(function() {
	                if (this.opts.shouldFocusInput(this)) {
	                    this.search.focus();
	                }
	            }));
	
	            selection.on("focus", this.bind(function(e) {
	                killEvent(e);
	            }));
	
	            this.focusser.on("focus", this.bind(function(){
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	                this.container.addClass("select2-container-active");
	            })).on("blur", this.bind(function() {
	                if (!this.opened()) {
	                    this.container.removeClass("select2-container-active");
	                    this.opts.element.trigger($.Event("select2-blur"));
	                }
	            }));
	            this.search.on("focus", this.bind(function(){
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	                this.container.addClass("select2-container-active");
	            }));
	
	            this.initContainerWidth();
	            this.opts.element.addClass("select2-offscreen");
	            this.setPlaceholder();
	
	        },
	
	        // single
	        clear: function(triggerChange) {
	            var data=this.selection.data("select2-data");
	            if (data) { // guard against queued quick consecutive clicks
	                var evt = $.Event("select2-clearing");
	                this.opts.element.trigger(evt);
	                if (evt.isDefaultPrevented()) {
	                    return;
	                }
	                var placeholderOption = this.getPlaceholderOption();
	                this.opts.element.val(placeholderOption ? placeholderOption.val() : "");
	                this.selection.find(".select2-chosen").empty();
	                this.selection.removeData("select2-data");
	                this.setPlaceholder();
	
	                if (triggerChange !== false){
	                    this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
	                    this.triggerChange({removed:data});
	                }
	            }
	        },
	
	        /**
	         * Sets selection based on source element's value
	         */
	        // single
	        initSelection: function () {
	            var selected;
	            if (this.isPlaceholderOptionSelected()) {
	                this.updateSelection(null);
	                this.close();
	                this.setPlaceholder();
	            } else {
	                var self = this;
	                this.opts.initSelection.call(null, this.opts.element, function(selected){
	                    if (selected !== undefined && selected !== null) {
	                        self.updateSelection(selected);
	                        self.close();
	                        self.setPlaceholder();
	                        self.nextSearchTerm = self.opts.nextSearchTerm(selected, self.search.val());
	                    }
	                });
	            }
	        },
	
	        isPlaceholderOptionSelected: function() {
	            var placeholderOption;
	            if (this.getPlaceholder() === undefined) return false; // no placeholder specified so no option should be considered
	            return ((placeholderOption = this.getPlaceholderOption()) !== undefined && placeholderOption.prop("selected"))
	                || (this.opts.element.val() === "")
	                || (this.opts.element.val() === undefined)
	                || (this.opts.element.val() === null);
	        },
	
	        // single
	        prepareOpts: function () {
	            var opts = this.parent.prepareOpts.apply(this, arguments),
	                self=this;
	
	            if (opts.element.get(0).tagName.toLowerCase() === "select") {
	                // install the selection initializer
	                opts.initSelection = function (element, callback) {
	                    var selected = element.find("option").filter(function() { return this.selected && !this.disabled });
	                    // a single select box always has a value, no need to null check 'selected'
	                    callback(self.optionToData(selected));
	                };
	            } else if ("data" in opts) {
	                // install default initSelection when applied to hidden input and data is local
	                opts.initSelection = opts.initSelection || function (element, callback) {
	                    var id = element.val();
	                    //search in data by id, storing the actual matching item
	                    var match = null;
	                    opts.query({
	                        matcher: function(term, text, el){
	                            var is_match = equal(id, opts.id(el));
	                            if (is_match) {
	                                match = el;
	                            }
	                            return is_match;
	                        },
	                        callback: !$.isFunction(callback) ? $.noop : function() {
	                            callback(match);
	                        }
	                    });
	                };
	            }
	
	            return opts;
	        },
	
	        // single
	        getPlaceholder: function() {
	            // if a placeholder is specified on a single select without a valid placeholder option ignore it
	            if (this.select) {
	                if (this.getPlaceholderOption() === undefined) {
	                    return undefined;
	                }
	            }
	
	            return this.parent.getPlaceholder.apply(this, arguments);
	        },
	
	        // single
	        setPlaceholder: function () {
	            var placeholder = this.getPlaceholder();
	
	            if (this.isPlaceholderOptionSelected() && placeholder !== undefined) {
	
	                // check for a placeholder option if attached to a select
	                if (this.select && this.getPlaceholderOption() === undefined) return;
	
	                this.selection.find(".select2-chosen").html(this.opts.escapeMarkup(placeholder));
	
	                this.selection.addClass("select2-default");
	
	                this.container.removeClass("select2-allowclear");
	            }
	        },
	
	        // single
	        postprocessResults: function (data, initial, noHighlightUpdate) {
	            var selected = 0, self = this, showSearchInput = true;
	
	            // find the selected element in the result list
	
	            this.findHighlightableChoices().each2(function (i, elm) {
	                if (equal(self.id(elm.data("select2-data")), self.opts.element.val())) {
	                    selected = i;
	                    return false;
	                }
	            });
	
	            // and highlight it
	            if (noHighlightUpdate !== false) {
	                if (initial === true && selected >= 0) {
	                    this.highlight(selected);
	                } else {
	                    this.highlight(0);
	                }
	            }
	
	            // hide the search box if this is the first we got the results and there are enough of them for search
	
	            if (initial === true) {
	                var min = this.opts.minimumResultsForSearch;
	                if (min >= 0) {
	                    this.showSearch(countResults(data.results) >= min);
	                }
	            }
	        },
	
	        // single
	        showSearch: function(showSearchInput) {
	            if (this.showSearchInput === showSearchInput) return;
	
	            this.showSearchInput = showSearchInput;
	
	            this.dropdown.find(".select2-search").toggleClass("select2-search-hidden", !showSearchInput);
	            this.dropdown.find(".select2-search").toggleClass("select2-offscreen", !showSearchInput);
	            //add "select2-with-searchbox" to the container if search box is shown
	            $(this.dropdown, this.container).toggleClass("select2-with-searchbox", showSearchInput);
	        },
	
	        // single
	        onSelect: function (data, options) {
	
	            if (!this.triggerSelect(data)) { return; }
	
	            var old = this.opts.element.val(),
	                oldData = this.data();
	
	            this.opts.element.val(this.id(data));
	            this.updateSelection(data);
	
	            this.opts.element.trigger({ type: "select2-selected", val: this.id(data), choice: data });
	
	            this.nextSearchTerm = this.opts.nextSearchTerm(data, this.search.val());
	            this.close();
	
	            if ((!options || !options.noFocus) && this.opts.shouldFocusInput(this)) {
	                this.focusser.focus();
	            }
	
	            if (!equal(old, this.id(data))) {
	                this.triggerChange({ added: data, removed: oldData });
	            }
	        },
	
	        // single
	        updateSelection: function (data) {
	
	            var container=this.selection.find(".select2-chosen"), formatted, cssClass;
	
	            this.selection.data("select2-data", data);
	
	            container.empty();
	            if (data !== null) {
	                formatted=this.opts.formatSelection(data, container, this.opts.escapeMarkup);
	            }
	            if (formatted !== undefined) {
	                container.append(formatted);
	            }
	            cssClass=this.opts.formatSelectionCssClass(data, container);
	            if (cssClass !== undefined) {
	                container.addClass(cssClass);
	            }
	
	            this.selection.removeClass("select2-default");
	
	            if (this.opts.allowClear && this.getPlaceholder() !== undefined) {
	                this.container.addClass("select2-allowclear");
	            }
	        },
	
	        // single
	        val: function () {
	            var val,
	                triggerChange = false,
	                data = null,
	                self = this,
	                oldData = this.data();
	
	            if (arguments.length === 0) {
	                return this.opts.element.val();
	            }
	
	            val = arguments[0];
	
	            if (arguments.length > 1) {
	                triggerChange = arguments[1];
	            }
	
	            if (this.select) {
	                this.select
	                    .val(val)
	                    .find("option").filter(function() { return this.selected }).each2(function (i, elm) {
	                        data = self.optionToData(elm);
	                        return false;
	                    });
	                this.updateSelection(data);
	                this.setPlaceholder();
	                if (triggerChange) {
	                    this.triggerChange({added: data, removed:oldData});
	                }
	            } else {
	                // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
	                if (!val && val !== 0) {
	                    this.clear(triggerChange);
	                    return;
	                }
	                if (this.opts.initSelection === undefined) {
	                    throw new Error("cannot call val() if initSelection() is not defined");
	                }
	                this.opts.element.val(val);
	                this.opts.initSelection(this.opts.element, function(data){
	                    self.opts.element.val(!data ? "" : self.id(data));
	                    self.updateSelection(data);
	                    self.setPlaceholder();
	                    if (triggerChange) {
	                        self.triggerChange({added: data, removed:oldData});
	                    }
	                });
	            }
	        },
	
	        // single
	        clearSearch: function () {
	            this.search.val("");
	            this.focusser.val("");
	        },
	
	        // single
	        data: function(value) {
	            var data,
	                triggerChange = false;
	
	            if (arguments.length === 0) {
	                data = this.selection.data("select2-data");
	                if (data == undefined) data = null;
	                return data;
	            } else {
	                if (arguments.length > 1) {
	                    triggerChange = arguments[1];
	                }
	                if (!value) {
	                    this.clear(triggerChange);
	                } else {
	                    data = this.data();
	                    this.opts.element.val(!value ? "" : this.id(value));
	                    this.updateSelection(value);
	                    if (triggerChange) {
	                        this.triggerChange({added: value, removed:data});
	                    }
	                }
	            }
	        }
	    });
	
	    MultiSelect2 = clazz(AbstractSelect2, {
	
	        // multi
	        createContainer: function () {
	            var container = $(document.createElement("div")).attr({
	                "class": "select2-container select2-container-multi"
	            }).html([
	                "<ul class='select2-choices'>",
	                "  <li class='select2-search-field'>",
	                "    <label for='' class='select2-offscreen'></label>",
	                "    <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input'>",
	                "  </li>",
	                "</ul>",
	                "<div class='select2-drop select2-drop-multi select2-display-none'>",
	                "   <ul class='select2-results'>",
	                "   </ul>",
	                "</div>"].join(""));
	            return container;
	        },
	
	        // multi
	        prepareOpts: function () {
	            var opts = this.parent.prepareOpts.apply(this, arguments),
	                self=this;
	
	            // TODO validate placeholder is a string if specified
	
	            if (opts.element.get(0).tagName.toLowerCase() === "select") {
	                // install the selection initializer
	                opts.initSelection = function (element, callback) {
	
	                    var data = [];
	
	                    element.find("option").filter(function() { return this.selected && !this.disabled }).each2(function (i, elm) {
	                        data.push(self.optionToData(elm));
	                    });
	                    callback(data);
	                };
	            } else if ("data" in opts) {
	                // install default initSelection when applied to hidden input and data is local
	                opts.initSelection = opts.initSelection || function (element, callback) {
	                    var ids = splitVal(element.val(), opts.separator);
	                    //search in data by array of ids, storing matching items in a list
	                    var matches = [];
	                    opts.query({
	                        matcher: function(term, text, el){
	                            var is_match = $.grep(ids, function(id) {
	                                return equal(id, opts.id(el));
	                            }).length;
	                            if (is_match) {
	                                matches.push(el);
	                            }
	                            return is_match;
	                        },
	                        callback: !$.isFunction(callback) ? $.noop : function() {
	                            // reorder matches based on the order they appear in the ids array because right now
	                            // they are in the order in which they appear in data array
	                            var ordered = [];
	                            for (var i = 0; i < ids.length; i++) {
	                                var id = ids[i];
	                                for (var j = 0; j < matches.length; j++) {
	                                    var match = matches[j];
	                                    if (equal(id, opts.id(match))) {
	                                        ordered.push(match);
	                                        matches.splice(j, 1);
	                                        break;
	                                    }
	                                }
	                            }
	                            callback(ordered);
	                        }
	                    });
	                };
	            }
	
	            return opts;
	        },
	
	        // multi
	        selectChoice: function (choice) {
	
	            var selected = this.container.find(".select2-search-choice-focus");
	            if (selected.length && choice && choice[0] == selected[0]) {
	
	            } else {
	                if (selected.length) {
	                    this.opts.element.trigger("choice-deselected", selected);
	                }
	                selected.removeClass("select2-search-choice-focus");
	                if (choice && choice.length) {
	                    this.close();
	                    choice.addClass("select2-search-choice-focus");
	                    this.opts.element.trigger("choice-selected", choice);
	                }
	            }
	        },
	
	        // multi
	        destroy: function() {
	            $("label[for='" + this.search.attr('id') + "']")
	                .attr('for', this.opts.element.attr("id"));
	            this.parent.destroy.apply(this, arguments);
	
	            cleanupJQueryElements.call(this,
	                "searchContainer",
	                "selection"
	            );
	        },
	
	        // multi
	        initContainer: function () {
	
	            var selector = ".select2-choices", selection;
	
	            this.searchContainer = this.container.find(".select2-search-field");
	            this.selection = selection = this.container.find(selector);
	
	            var _this = this;
	            this.selection.on("click", ".select2-search-choice:not(.select2-locked)", function (e) {
	                //killEvent(e);
	                _this.search[0].focus();
	                _this.selectChoice($(this));
	            });
	
	            // rewrite labels from original element to focusser
	            this.search.attr("id", "s2id_autogen"+nextUid());
	
	            this.search.prev()
	                .text($("label[for='" + this.opts.element.attr("id") + "']").text())
	                .attr('for', this.search.attr('id'));
	
	            this.search.on("input paste", this.bind(function() {
	                if (!this.isInterfaceEnabled()) return;
	                if (!this.opened()) {
	                    this.open();
	                }
	            }));
	
	            this.search.attr("tabindex", this.elementTabIndex);
	
	            this.keydowns = 0;
	            this.search.on("keydown", this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;
	
	                ++this.keydowns;
	                var selected = selection.find(".select2-search-choice-focus");
	                var prev = selected.prev(".select2-search-choice:not(.select2-locked)");
	                var next = selected.next(".select2-search-choice:not(.select2-locked)");
	                var pos = getCursorInfo(this.search);
	
	                if (selected.length &&
	                    (e.which == KEY.LEFT || e.which == KEY.RIGHT || e.which == KEY.BACKSPACE || e.which == KEY.DELETE || e.which == KEY.ENTER)) {
	                    var selectedChoice = selected;
	                    if (e.which == KEY.LEFT && prev.length) {
	                        selectedChoice = prev;
	                    }
	                    else if (e.which == KEY.RIGHT) {
	                        selectedChoice = next.length ? next : null;
	                    }
	                    else if (e.which === KEY.BACKSPACE) {
	                        if (this.unselect(selected.first())) {
	                            this.search.width(10);
	                            selectedChoice = prev.length ? prev : next;
	                        }
	                    } else if (e.which == KEY.DELETE) {
	                        if (this.unselect(selected.first())) {
	                            this.search.width(10);
	                            selectedChoice = next.length ? next : null;
	                        }
	                    } else if (e.which == KEY.ENTER) {
	                        selectedChoice = null;
	                    }
	
	                    this.selectChoice(selectedChoice);
	                    killEvent(e);
	                    if (!selectedChoice || !selectedChoice.length) {
	                        this.open();
	                    }
	                    return;
	                } else if (((e.which === KEY.BACKSPACE && this.keydowns == 1)
	                    || e.which == KEY.LEFT) && (pos.offset == 0 && !pos.length)) {
	
	                    this.selectChoice(selection.find(".select2-search-choice:not(.select2-locked)").last());
	                    killEvent(e);
	                    return;
	                } else {
	                    this.selectChoice(null);
	                }
	
	                if (this.opened()) {
	                    switch (e.which) {
	                    case KEY.UP:
	                    case KEY.DOWN:
	                        this.moveHighlight((e.which === KEY.UP) ? -1 : 1);
	                        killEvent(e);
	                        return;
	                    case KEY.ENTER:
	                        this.selectHighlighted();
	                        killEvent(e);
	                        return;
	                    case KEY.TAB:
	                        this.selectHighlighted({noFocus:true});
	                        this.close();
	                        return;
	                    case KEY.ESC:
	                        this.cancel(e);
	                        killEvent(e);
	                        return;
	                    }
	                }
	
	                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e)
	                 || e.which === KEY.BACKSPACE || e.which === KEY.ESC) {
	                    return;
	                }
	
	                if (e.which === KEY.ENTER) {
	                    if (this.opts.openOnEnter === false) {
	                        return;
	                    } else if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) {
	                        return;
	                    }
	                }
	
	                this.open();
	
	                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
	                    // prevent the page from scrolling
	                    killEvent(e);
	                }
	
	                if (e.which === KEY.ENTER) {
	                    // prevent form from being submitted
	                    killEvent(e);
	                }
	
	            }));
	
	            this.search.on("keyup", this.bind(function (e) {
	                this.keydowns = 0;
	                this.resizeSearch();
	            })
	            );
	
	            this.search.on("blur", this.bind(function(e) {
	                this.container.removeClass("select2-container-active");
	                this.search.removeClass("select2-focused");
	                this.selectChoice(null);
	                if (!this.opened()) this.clearSearch();
	                e.stopImmediatePropagation();
	                this.opts.element.trigger($.Event("select2-blur"));
	            }));
	
	            this.container.on("click", selector, this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;
	                if ($(e.target).closest(".select2-search-choice").length > 0) {
	                    // clicked inside a select2 search choice, do not open
	                    return;
	                }
	                this.selectChoice(null);
	                this.clearPlaceholder();
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	                this.open();
	                this.focusSearch();
	                e.preventDefault();
	            }));
	
	            this.container.on("focus", selector, this.bind(function () {
	                if (!this.isInterfaceEnabled()) return;
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	                this.container.addClass("select2-container-active");
	                this.dropdown.addClass("select2-drop-active");
	                this.clearPlaceholder();
	            }));
	
	            this.initContainerWidth();
	            this.opts.element.addClass("select2-offscreen");
	
	            // set the placeholder if necessary
	            this.clearSearch();
	        },
	
	        // multi
	        enableInterface: function() {
	            if (this.parent.enableInterface.apply(this, arguments)) {
	                this.search.prop("disabled", !this.isInterfaceEnabled());
	            }
	        },
	
	        // multi
	        initSelection: function () {
	            var data;
	            if (this.opts.element.val() === "" && this.opts.element.text() === "") {
	                this.updateSelection([]);
	                this.close();
	                // set the placeholder if necessary
	                this.clearSearch();
	            }
	            if (this.select || this.opts.element.val() !== "") {
	                var self = this;
	                this.opts.initSelection.call(null, this.opts.element, function(data){
	                    if (data !== undefined && data !== null) {
	                        self.updateSelection(data);
	                        self.close();
	                        // set the placeholder if necessary
	                        self.clearSearch();
	                    }
	                });
	            }
	        },
	
	        // multi
	        clearSearch: function () {
	            var placeholder = this.getPlaceholder(),
	                maxWidth = this.getMaxSearchWidth();
	
	            if (placeholder !== undefined  && this.getVal().length === 0 && this.search.hasClass("select2-focused") === false) {
	                this.search.val(placeholder).addClass("select2-default");
	                // stretch the search box to full width of the container so as much of the placeholder is visible as possible
	                // we could call this.resizeSearch(), but we do not because that requires a sizer and we do not want to create one so early because of a firefox bug, see #944
	                this.search.width(maxWidth > 0 ? maxWidth : this.container.css("width"));
	            } else {
	                this.search.val("").width(10);
	            }
	        },
	
	        // multi
	        clearPlaceholder: function () {
	            if (this.search.hasClass("select2-default")) {
	                this.search.val("").removeClass("select2-default");
	            }
	        },
	
	        // multi
	        opening: function () {
	            this.clearPlaceholder(); // should be done before super so placeholder is not used to search
	            this.resizeSearch();
	
	            this.parent.opening.apply(this, arguments);
	
	            this.focusSearch();
	
	            // initializes search's value with nextSearchTerm (if defined by user)
	            // ignore nextSearchTerm if the dropdown is opened by the user pressing a letter
	            if(this.search.val() === "") {
	                if(this.nextSearchTerm != undefined){
	                    this.search.val(this.nextSearchTerm);
	                    this.search.select();
	                }
	            }
	
	            this.updateResults(true);
	            if (this.opts.shouldFocusInput(this)) {
	                this.search.focus();
	            }
	            this.opts.element.trigger($.Event("select2-open"));
	        },
	
	        // multi
	        close: function () {
	            if (!this.opened()) return;
	            this.parent.close.apply(this, arguments);
	        },
	
	        // multi
	        focus: function () {
	            this.close();
	            this.search.focus();
	        },
	
	        // multi
	        isFocused: function () {
	            return this.search.hasClass("select2-focused");
	        },
	
	        // multi
	        updateSelection: function (data) {
	            var ids = [], filtered = [], self = this;
	
	            // filter out duplicates
	            $(data).each(function () {
	                if (indexOf(self.id(this), ids) < 0) {
	                    ids.push(self.id(this));
	                    filtered.push(this);
	                }
	            });
	            data = filtered;
	
	            this.selection.find(".select2-search-choice").remove();
	            $(data).each(function () {
	                self.addSelectedChoice(this);
	            });
	            self.postprocessResults();
	        },
	
	        // multi
	        tokenize: function() {
	            var input = this.search.val();
	            input = this.opts.tokenizer.call(this, input, this.data(), this.bind(this.onSelect), this.opts);
	            if (input != null && input != undefined) {
	                this.search.val(input);
	                if (input.length > 0) {
	                    this.open();
	                }
	            }
	
	        },
	
	        // multi
	        onSelect: function (data, options) {
	
	            if (!this.triggerSelect(data)) { return; }
	
	            this.addSelectedChoice(data);
	
	            this.opts.element.trigger({ type: "selected", val: this.id(data), choice: data });
	
	            // keep track of the search's value before it gets cleared
	            this.nextSearchTerm = this.opts.nextSearchTerm(data, this.search.val());
	
	            this.clearSearch();
	            this.updateResults();
	
	            if (this.select || !this.opts.closeOnSelect) this.postprocessResults(data, false, this.opts.closeOnSelect===true);
	
	            if (this.opts.closeOnSelect) {
	                this.close();
	                this.search.width(10);
	            } else {
	                if (this.countSelectableResults()>0) {
	                    this.search.width(10);
	                    this.resizeSearch();
	                    if (this.getMaximumSelectionSize() > 0 && this.val().length >= this.getMaximumSelectionSize()) {
	                        // if we reached max selection size repaint the results so choices
	                        // are replaced with the max selection reached message
	                        this.updateResults(true);
	                    } else {
	                        // initializes search's value with nextSearchTerm and update search result
	                        if(this.nextSearchTerm != undefined){
	                            this.search.val(this.nextSearchTerm);
	                            this.updateResults();
	                            this.search.select();
	                        }
	                    }
	                    this.positionDropdown();
	                } else {
	                    // if nothing left to select close
	                    this.close();
	                    this.search.width(10);
	                }
	            }
	
	            // since its not possible to select an element that has already been
	            // added we do not need to check if this is a new element before firing change
	            this.triggerChange({ added: data });
	
	            if (!options || !options.noFocus)
	                this.focusSearch();
	        },
	
	        // multi
	        cancel: function () {
	            this.close();
	            this.focusSearch();
	        },
	
	        addSelectedChoice: function (data) {
	            var enableChoice = !data.locked,
	                enabledItem = $(
	                    "<li class='select2-search-choice'>" +
	                    "    <div></div>" +
	                    "    <a href='#' class='select2-search-choice-close' tabindex='-1'></a>" +
	                    "</li>"),
	                disabledItem = $(
	                    "<li class='select2-search-choice select2-locked'>" +
	                    "<div></div>" +
	                    "</li>");
	            var choice = enableChoice ? enabledItem : disabledItem,
	                id = this.id(data),
	                val = this.getVal(),
	                formatted,
	                cssClass;
	
	            formatted=this.opts.formatSelection(data, choice.find("div"), this.opts.escapeMarkup);
	            if (formatted != undefined) {
	                choice.find("div").replaceWith("<div>"+formatted+"</div>");
	            }
	            cssClass=this.opts.formatSelectionCssClass(data, choice.find("div"));
	            if (cssClass != undefined) {
	                choice.addClass(cssClass);
	            }
	
	            if(enableChoice){
	              choice.find(".select2-search-choice-close")
	                  .on("mousedown", killEvent)
	                  .on("click dblclick", this.bind(function (e) {
	                  if (!this.isInterfaceEnabled()) return;
	
	                  this.unselect($(e.target));
	                  this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
	                  killEvent(e);
	                  this.close();
	                  this.focusSearch();
	              })).on("focus", this.bind(function () {
	                  if (!this.isInterfaceEnabled()) return;
	                  this.container.addClass("select2-container-active");
	                  this.dropdown.addClass("select2-drop-active");
	              }));
	            }
	
	            choice.data("select2-data", data);
	            choice.insertBefore(this.searchContainer);
	
	            val.push(id);
	            this.setVal(val);
	        },
	
	        // multi
	        unselect: function (selected) {
	            var val = this.getVal(),
	                data,
	                index;
	            selected = selected.closest(".select2-search-choice");
	
	            if (selected.length === 0) {
	                throw "Invalid argument: " + selected + ". Must be .select2-search-choice";
	            }
	
	            data = selected.data("select2-data");
	
	            if (!data) {
	                // prevent a race condition when the 'x' is clicked really fast repeatedly the event can be queued
	                // and invoked on an element already removed
	                return;
	            }
	
	            var evt = $.Event("select2-removing");
	            evt.val = this.id(data);
	            evt.choice = data;
	            this.opts.element.trigger(evt);
	
	            if (evt.isDefaultPrevented()) {
	                return false;
	            }
	
	            while((index = indexOf(this.id(data), val)) >= 0) {
	                val.splice(index, 1);
	                this.setVal(val);
	                if (this.select) this.postprocessResults();
	            }
	
	            selected.remove();
	
	            this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
	            this.triggerChange({ removed: data });
	
	            return true;
	        },
	
	        // multi
	        postprocessResults: function (data, initial, noHighlightUpdate) {
	            var val = this.getVal(),
	                choices = this.results.find(".select2-result"),
	                compound = this.results.find(".select2-result-with-children"),
	                self = this;
	
	            choices.each2(function (i, choice) {
	                var id = self.id(choice.data("select2-data"));
	                if (indexOf(id, val) >= 0) {
	                    choice.addClass("select2-selected");
	                    // mark all children of the selected parent as selected
	                    choice.find(".select2-result-selectable").addClass("select2-selected");
	                }
	            });
	
	            compound.each2(function(i, choice) {
	                // hide an optgroup if it doesn't have any selectable children
	                if (!choice.is('.select2-result-selectable')
	                    && choice.find(".select2-result-selectable:not(.select2-selected)").length === 0) {
	                    choice.addClass("select2-selected");
	                }
	            });
	
	            if (this.highlight() == -1 && noHighlightUpdate !== false){
	                self.highlight(0);
	            }
	
	            //If all results are chosen render formatNoMatches
	            if(!this.opts.createSearchChoice && !choices.filter('.select2-result:not(.select2-selected)').length > 0){
	                if(!data || data && !data.more && this.results.find(".select2-no-results").length === 0) {
	                    if (checkFormatter(self.opts.formatNoMatches, "formatNoMatches")) {
	                        this.results.append("<li class='select2-no-results'>" + evaluate(self.opts.formatNoMatches, self.search.val()) + "</li>");
	                    }
	                }
	            }
	
	        },
	
	        // multi
	        getMaxSearchWidth: function() {
	            return this.selection.width() - getSideBorderPadding(this.search);
	        },
	
	        // multi
	        resizeSearch: function () {
	            var minimumWidth, left, maxWidth, containerLeft, searchWidth,
	                sideBorderPadding = getSideBorderPadding(this.search);
	
	            minimumWidth = measureTextWidth(this.search) + 10;
	
	            left = this.search.offset().left;
	
	            maxWidth = this.selection.width();
	            containerLeft = this.selection.offset().left;
	
	            searchWidth = maxWidth - (left - containerLeft) - sideBorderPadding;
	
	            if (searchWidth < minimumWidth) {
	                searchWidth = maxWidth - sideBorderPadding;
	            }
	
	            if (searchWidth < 40) {
	                searchWidth = maxWidth - sideBorderPadding;
	            }
	
	            if (searchWidth <= 0) {
	              searchWidth = minimumWidth;
	            }
	
	            this.search.width(Math.floor(searchWidth));
	        },
	
	        // multi
	        getVal: function () {
	            var val;
	            if (this.select) {
	                val = this.select.val();
	                return val === null ? [] : val;
	            } else {
	                val = this.opts.element.val();
	                return splitVal(val, this.opts.separator);
	            }
	        },
	
	        // multi
	        setVal: function (val) {
	            var unique;
	            if (this.select) {
	                this.select.val(val);
	            } else {
	                unique = [];
	                // filter out duplicates
	                $(val).each(function () {
	                    if (indexOf(this, unique) < 0) unique.push(this);
	                });
	                this.opts.element.val(unique.length === 0 ? "" : unique.join(this.opts.separator));
	            }
	        },
	
	        // multi
	        buildChangeDetails: function (old, current) {
	            var current = current.slice(0),
	                old = old.slice(0);
	
	            // remove intersection from each array
	            for (var i = 0; i < current.length; i++) {
	                for (var j = 0; j < old.length; j++) {
	                    if (equal(this.opts.id(current[i]), this.opts.id(old[j]))) {
	                        current.splice(i, 1);
	                        if(i>0){
	                        	i--;
	                        }
	                        old.splice(j, 1);
	                        j--;
	                    }
	                }
	            }
	
	            return {added: current, removed: old};
	        },
	
	
	        // multi
	        val: function (val, triggerChange) {
	            var oldData, self=this;
	
	            if (arguments.length === 0) {
	                return this.getVal();
	            }
	
	            oldData=this.data();
	            if (!oldData.length) oldData=[];
	
	            // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
	            if (!val && val !== 0) {
	                this.opts.element.val("");
	                this.updateSelection([]);
	                this.clearSearch();
	                if (triggerChange) {
	                    this.triggerChange({added: this.data(), removed: oldData});
	                }
	                return;
	            }
	
	            // val is a list of ids
	            this.setVal(val);
	
	            if (this.select) {
	                this.opts.initSelection(this.select, this.bind(this.updateSelection));
	                if (triggerChange) {
	                    this.triggerChange(this.buildChangeDetails(oldData, this.data()));
	                }
	            } else {
	                if (this.opts.initSelection === undefined) {
	                    throw new Error("val() cannot be called if initSelection() is not defined");
	                }
	
	                this.opts.initSelection(this.opts.element, function(data){
	                    var ids=$.map(data, self.id);
	                    self.setVal(ids);
	                    self.updateSelection(data);
	                    self.clearSearch();
	                    if (triggerChange) {
	                        self.triggerChange(self.buildChangeDetails(oldData, self.data()));
	                    }
	                });
	            }
	            this.clearSearch();
	        },
	
	        // multi
	        onSortStart: function() {
	            if (this.select) {
	                throw new Error("Sorting of elements is not supported when attached to <select>. Attach to <input type='hidden'/> instead.");
	            }
	
	            // collapse search field into 0 width so its container can be collapsed as well
	            this.search.width(0);
	            // hide the container
	            this.searchContainer.hide();
	        },
	
	        // multi
	        onSortEnd:function() {
	
	            var val=[], self=this;
	
	            // show search and move it to the end of the list
	            this.searchContainer.show();
	            // make sure the search container is the last item in the list
	            this.searchContainer.appendTo(this.searchContainer.parent());
	            // since we collapsed the width in dragStarted, we resize it here
	            this.resizeSearch();
	
	            // update selection
	            this.selection.find(".select2-search-choice").each(function() {
	                val.push(self.opts.id($(this).data("select2-data")));
	            });
	            this.setVal(val);
	            this.triggerChange();
	        },
	
	        // multi
	        data: function(values, triggerChange) {
	            var self=this, ids, old;
	            if (arguments.length === 0) {
	                 return this.selection
	                     .children(".select2-search-choice")
	                     .map(function() { return $(this).data("select2-data"); })
	                     .get();
	            } else {
	                old = this.data();
	                if (!values) { values = []; }
	                ids = $.map(values, function(e) { return self.opts.id(e); });
	                this.setVal(ids);
	                this.updateSelection(values);
	                this.clearSearch();
	                if (triggerChange) {
	                    this.triggerChange(this.buildChangeDetails(old, this.data()));
	                }
	            }
	        }
	    });
	
	    $.fn.select2 = function () {
	
	        var args = Array.prototype.slice.call(arguments, 0),
	            opts,
	            select2,
	            method, value, multiple,
	            allowedMethods = ["val", "destroy", "opened", "open", "close", "focus", "isFocused", "container", "dropdown", "onSortStart", "onSortEnd", "enable", "disable", "readonly", "positionDropdown", "data", "search"],
	            valueMethods = ["opened", "isFocused", "container", "dropdown"],
	            propertyMethods = ["val", "data"],
	            methodsMap = { search: "externalSearch" };
	
	        this.each(function () {
	            if (args.length === 0 || typeof(args[0]) === "object") {
	                opts = args.length === 0 ? {} : $.extend({}, args[0]);
	                opts.element = $(this);
	
	                if (opts.element.get(0).tagName.toLowerCase() === "select") {
	                    multiple = opts.element.prop("multiple");
	                } else {
	                    multiple = opts.multiple || false;
	                    if ("tags" in opts) {opts.multiple = multiple = true;}
	                }
	
	                select2 = multiple ? new window.Select2["class"].multi() : new window.Select2["class"].single();
	                select2.init(opts);
	            } else if (typeof(args[0]) === "string") {
	
	                if (indexOf(args[0], allowedMethods) < 0) {
	                    throw "Unknown method: " + args[0];
	                }
	
	                value = undefined;
	                select2 = $(this).data("select2");
	                if (select2 === undefined) return;
	
	                method=args[0];
	
	                if (method === "container") {
	                    value = select2.container;
	                } else if (method === "dropdown") {
	                    value = select2.dropdown;
	                } else {
	                    if (methodsMap[method]) method = methodsMap[method];
	
	                    value = select2[method].apply(select2, args.slice(1));
	                }
	                if (indexOf(args[0], valueMethods) >= 0
	                    || (indexOf(args[0], propertyMethods) >= 0 && args.length == 1)) {
	                    return false; // abort the iteration, ready to return first matched value
	                }
	            } else {
	                throw "Invalid arguments to select2 plugin: " + args;
	            }
	        });
	        return (value === undefined) ? this : value;
	    };
	
	    // plugin defaults, accessible to users
	    $.fn.select2.defaults = {
	        width: "copy",
	        loadMorePadding: 0,
	        closeOnSelect: true,
	        openOnEnter: true,
	        containerCss: {},
	        dropdownCss: {},
	        containerCssClass: "",
	        dropdownCssClass: "",
	        formatResult: function(result, container, query, escapeMarkup) {
	            var markup=[];
	            markMatch(result.text, query.term, markup, escapeMarkup);
	            return markup.join("");
	        },
	        formatSelection: function (data, container, escapeMarkup) {
	            return data ? escapeMarkup(data.text) : undefined;
	        },
	        sortResults: function (results, container, query) {
	            return results;
	        },
	        formatResultCssClass: function(data) {return data.css;},
	        formatSelectionCssClass: function(data, container) {return undefined;},
	        formatMatches: function (matches) { return matches + " results are available, use up and down arrow keys to navigate."; },
	        formatNoMatches: function () { return "No matches found"; },
	        formatInputTooShort: function (input, min) { var n = min - input.length; return "Please enter " + n + " or more character" + (n == 1? "" : "s"); },
	        formatInputTooLong: function (input, max) { var n = input.length - max; return "Please delete " + n + " character" + (n == 1? "" : "s"); },
	        formatSelectionTooBig: function (limit) { return "You can only select " + limit + " item" + (limit == 1 ? "" : "s"); },
	        formatLoadMore: function (pageNumber) { return "Loading more results…"; },
	        formatSearching: function () { return "Searching…"; },
	        minimumResultsForSearch: 0,
	        minimumInputLength: 0,
	        maximumInputLength: null,
	        maximumSelectionSize: 0,
	        id: function (e) { return e == undefined ? null : e.id; },
	        matcher: function(term, text) {
	            return stripDiacritics(''+text).toUpperCase().indexOf(stripDiacritics(''+term).toUpperCase()) >= 0;
	        },
	        separator: ",",
	        tokenSeparators: [],
	        tokenizer: defaultTokenizer,
	        escapeMarkup: defaultEscapeMarkup,
	        blurOnChange: false,
	        selectOnBlur: false,
	        adaptContainerCssClass: function(c) { return c; },
	        adaptDropdownCssClass: function(c) { return null; },
	        nextSearchTerm: function(selectedObject, currentSearchTerm) { return undefined; },
	        searchInputPlaceholder: '',
	        createSearchChoicePosition: 'top',
	        shouldFocusInput: function (instance) {
	            // Attempt to detect touch devices
	            var supportsTouchEvents = (('ontouchstart' in window) ||
	                                       (navigator.msMaxTouchPoints > 0));
	
	            // Only devices which support touch events should be special cased
	            if (!supportsTouchEvents) {
	                return true;
	            }
	
	            // Never focus the input if search is disabled
	            if (instance.opts.minimumResultsForSearch < 0) {
	                return false;
	            }
	
	            return true;
	        }
	    };
	
	    $.fn.select2.ajaxDefaults = {
	        transport: $.ajax,
	        params: {
	            type: "GET",
	            cache: false,
	            dataType: "json"
	        }
	    };
	
	    // exports
	    window.Select2 = {
	        query: {
	            ajax: ajax,
	            local: local,
	            tags: tags
	        }, util: {
	            debounce: debounce,
	            markMatch: markMatch,
	            escapeMarkup: defaultEscapeMarkup,
	            stripDiacritics: stripDiacritics
	        }, "class": {
	            "abstract": AbstractSelect2,
	            "single": SingleSelect2,
	            "multi": MultiSelect2
	        }
	    };
	
	}(jQuery));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(112)))

/***/ }),

/***/ 983:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 985:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2ca61b76e22053571dd8611e5aac4900.png";

/***/ }),

/***/ 986:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7b9776076d5fceef4993b55c9383dedd.gif";

/***/ }),

/***/ 987:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "49e3f006018662f60f1db2aec0b2cca9.png";

/***/ }),

/***/ 988:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(989);

/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * Enhanced Select2 Dropmenus
	 *
	 * @AJAX Mode - When in this mode, your value will be an object (or array of objects) of the data used by Select2
	 *     This change is so that you do not have to do an additional query yourself on top of Select2's own query
	 * @params [options] {object} The configuration options passed to $.fn.select2(). Refer to the documentation
	 */
	angular.module('ui.select2', []).value('uiSelect2Config', {}).directive('uiSelect2', ['uiSelect2Config', '$timeout', function (uiSelect2Config, $timeout) {
	  var options = {};
	  if (uiSelect2Config) {
	    angular.extend(options, uiSelect2Config);
	  }
	  return {
	    require: 'ngModel',
	    priority: 1,
	    compile: function (tElm, tAttrs) {
	      var watch,
	        repeatOption,
	        repeatAttr,
	        isSelect = tElm.is('select'),
	        isMultiple = angular.isDefined(tAttrs.multiple);
	
	      // Enable watching of the options dataset if in use
	      if (tElm.is('select')) {
	        repeatOption = tElm.find('option[ng-repeat], option[data-ng-repeat]');
	
	        if (repeatOption.length) {
	          repeatAttr = repeatOption.attr('ng-repeat') || repeatOption.attr('data-ng-repeat');
	          watch = jQuery.trim(repeatAttr.split('|')[0]).split(' ').pop();
	        }
	      }
	
	      return function (scope, elm, attrs, controller) {
	        // instance-specific options
	        var opts = angular.extend({}, options, scope.$eval(attrs.uiSelect2));
	
	        /*
	        Convert from Select2 view-model to Angular view-model.
	        */
	        var convertToAngularModel = function(select2_data) {
	          var model;
	          if (opts.simple_tags) {
	            model = [];
	            angular.forEach(select2_data, function(value, index) {
	              model.push(value.id);
	            });
	          } else {
	            model = select2_data;
	          }
	          return model;
	        };
	
	        /*
	        Convert from Angular view-model to Select2 view-model.
	        */
	        var convertToSelect2Model = function(angular_data) {
	          var model = [];
	          if (!angular_data) {
	            return model;
	          }
	
	          if (opts.simple_tags) {
	            model = [];
	            angular.forEach(
	              angular_data,
	              function(value, index) {
	                model.push({'id': value, 'text': value});
	              });
	          } else {
	            model = angular_data;
	          }
	          return model;
	        };
	
	        if (isSelect) {
	          // Use <select multiple> instead
	          delete opts.multiple;
	          delete opts.initSelection;
	        } else if (isMultiple) {
	          opts.multiple = true;
	        }
	
	        if (controller) {
	          // Watch the model for programmatic changes
	           scope.$watch(tAttrs.ngModel, function(current, old) {
	            if (!current) {
	              return;
	            }
	            if (current === old) {
	              return;
	            }
	            controller.$render();
	          }, true);
	          controller.$render = function () {
	            if (isSelect) {
	              elm.select2('val', controller.$viewValue);
	            } else {
	              if (opts.multiple) {
	                var viewValue = controller.$viewValue;
	                if (angular.isString(viewValue)) {
	                  viewValue = viewValue.split(',');
	                }
	                elm.select2(
	                  'data', convertToSelect2Model(viewValue));
	              } else {
	                if (angular.isObject(controller.$viewValue)) {
	                  elm.select2('data', controller.$viewValue);
	                } else if (!controller.$viewValue) {
	                  elm.select2('data', null);
	                } else {
	                  elm.select2('val', controller.$viewValue);
	                }
	              }
	            }
	          };
	
	          // Watch the options dataset for changes
	          if (watch) {
	            scope.$watch(watch, function (newVal, oldVal, scope) {
	              if (angular.equals(newVal, oldVal)) {
	                return;
	              }
	              // Delayed so that the options have time to be rendered
	              $timeout(function () {
	                elm.select2('val', controller.$viewValue);
	                // Refresh angular to remove the superfluous option
	                elm.trigger('change');
	                if(newVal && !oldVal && controller.$setPristine) {
	                  controller.$setPristine(true);
	                }
	              });
	            });
	          }
	
	          // Update valid and dirty statuses
	          controller.$parsers.push(function (value) {
	            var div = elm.prev();
	            div
	              .toggleClass('ng-invalid', !controller.$valid)
	              .toggleClass('ng-valid', controller.$valid)
	              .toggleClass('ng-invalid-required', !controller.$valid)
	              .toggleClass('ng-valid-required', controller.$valid)
	              .toggleClass('ng-dirty', controller.$dirty)
	              .toggleClass('ng-pristine', controller.$pristine);
	            return value;
	          });
	
	          if (!isSelect) {
	            // Set the view and model value and update the angular template manually for the ajax/multiple select2.
	            elm.bind("change", function (e) {
	              e.stopImmediatePropagation();
	              
	              if (scope.$$phase || scope.$root.$$phase) {
	                return;
	              }
	              scope.$apply(function () {
	                controller.$setViewValue(
	                  convertToAngularModel(elm.select2('data')));
	              });
	            });
	
	            if (opts.initSelection) {
	              var initSelection = opts.initSelection;
	              opts.initSelection = function (element, callback) {
	                initSelection(element, function (value) {
	                  controller.$setViewValue(convertToAngularModel(value));
	                  callback(value);
	                });
	              };
	            }
	          }
	        }
	
	        elm.bind("$destroy", function() {
	          elm.select2("destroy");
	        });
	
	        attrs.$observe('disabled', function (value) {
	          elm.select2('enable', !value);
	        });
	
	        attrs.$observe('readonly', function (value) {
	          elm.select2('readonly', !!value);
	        });
	
	        if (attrs.ngMultiple) {
	          scope.$watch(attrs.ngMultiple, function(newVal) {
	            attrs.$set('multiple', !!newVal);
	            elm.select2(opts);
	          });
	        }
	
	        // Initialize the plugin late so that the injected DOM does not disrupt the template compiler
	        $timeout(function () {
	          elm.select2(opts);
	
	          // Set initial value - I'm not sure about this but it seems to need to be there
	          elm.val(controller.$viewValue);
	          // important!
	          controller.$render();
	
	          // Not sure if I should just check for !isSelect OR if I should check for 'tags' key
	          if (!opts.initSelection && !isSelect) {
	            controller.$setViewValue(
	              convertToAngularModel(elm.select2('data'))
	            );
	          }
	        });
	      };
	    }
	  };
	}]);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(112)))

/***/ }),

/***/ 990:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(991);
	__webpack_require__(992);

/***/ }),

/***/ 991:
/***/ (function(module, exports) {

	/*!
	 * ui-select
	 * http://github.com/angular-ui/ui-select
	 * Version: 0.19.7 - 2017-04-15T14:28:36.649Z
	 * License: MIT
	 */
	
	
	(function () { 
	"use strict";
	var KEY = {
	    TAB: 9,
	    ENTER: 13,
	    ESC: 27,
	    SPACE: 32,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    SHIFT: 16,
	    CTRL: 17,
	    ALT: 18,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    HOME: 36,
	    END: 35,
	    BACKSPACE: 8,
	    DELETE: 46,
	    COMMAND: 91,
	
	    MAP: { 91 : "COMMAND", 8 : "BACKSPACE" , 9 : "TAB" , 13 : "ENTER" , 16 : "SHIFT" , 17 : "CTRL" , 18 : "ALT" , 19 : "PAUSEBREAK" , 20 : "CAPSLOCK" , 27 : "ESC" , 32 : "SPACE" , 33 : "PAGE_UP", 34 : "PAGE_DOWN" , 35 : "END" , 36 : "HOME" , 37 : "LEFT" , 38 : "UP" , 39 : "RIGHT" , 40 : "DOWN" , 43 : "+" , 44 : "PRINTSCREEN" , 45 : "INSERT" , 46 : "DELETE", 48 : "0" , 49 : "1" , 50 : "2" , 51 : "3" , 52 : "4" , 53 : "5" , 54 : "6" , 55 : "7" , 56 : "8" , 57 : "9" , 59 : ";", 61 : "=" , 65 : "A" , 66 : "B" , 67 : "C" , 68 : "D" , 69 : "E" , 70 : "F" , 71 : "G" , 72 : "H" , 73 : "I" , 74 : "J" , 75 : "K" , 76 : "L", 77 : "M" , 78 : "N" , 79 : "O" , 80 : "P" , 81 : "Q" , 82 : "R" , 83 : "S" , 84 : "T" , 85 : "U" , 86 : "V" , 87 : "W" , 88 : "X" , 89 : "Y" , 90 : "Z", 96 : "0" , 97 : "1" , 98 : "2" , 99 : "3" , 100 : "4" , 101 : "5" , 102 : "6" , 103 : "7" , 104 : "8" , 105 : "9", 106 : "*" , 107 : "+" , 109 : "-" , 110 : "." , 111 : "/", 112 : "F1" , 113 : "F2" , 114 : "F3" , 115 : "F4" , 116 : "F5" , 117 : "F6" , 118 : "F7" , 119 : "F8" , 120 : "F9" , 121 : "F10" , 122 : "F11" , 123 : "F12", 144 : "NUMLOCK" , 145 : "SCROLLLOCK" , 186 : ";" , 187 : "=" , 188 : "," , 189 : "-" , 190 : "." , 191 : "/" , 192 : "`" , 219 : "[" , 220 : "\\" , 221 : "]" , 222 : "'"
	    },
	
	    isControl: function (e) {
	        var k = e.which;
	        switch (k) {
	        case KEY.COMMAND:
	        case KEY.SHIFT:
	        case KEY.CTRL:
	        case KEY.ALT:
	            return true;
	        }
	
	        if (e.metaKey || e.ctrlKey || e.altKey) return true;
	
	        return false;
	    },
	    isFunctionKey: function (k) {
	        k = k.which ? k.which : k;
	        return k >= 112 && k <= 123;
	    },
	    isVerticalMovement: function (k){
	      return ~[KEY.UP, KEY.DOWN].indexOf(k);
	    },
	    isHorizontalMovement: function (k){
	      return ~[KEY.LEFT,KEY.RIGHT,KEY.BACKSPACE,KEY.DELETE].indexOf(k);
	    },
	    toSeparator: function (k) {
	      var sep = {ENTER:"\n",TAB:"\t",SPACE:" "}[k];
	      if (sep) return sep;
	      // return undefined for special keys other than enter, tab or space.
	      // no way to use them to cut strings.
	      return KEY[k] ? undefined : k;
	    }
	  };
	
	function isNil(value) {
	  return angular.isUndefined(value) || value === null;
	}
	
	/**
	 * Add querySelectorAll() to jqLite.
	 *
	 * jqLite find() is limited to lookups by tag name.
	 * TODO This will change with future versions of AngularJS, to be removed when this happens
	 *
	 * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
	 * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
	 */
	if (angular.element.prototype.querySelectorAll === undefined) {
	  angular.element.prototype.querySelectorAll = function(selector) {
	    return angular.element(this[0].querySelectorAll(selector));
	  };
	}
	
	/**
	 * Add closest() to jqLite.
	 */
	if (angular.element.prototype.closest === undefined) {
	  angular.element.prototype.closest = function( selector) {
	    var elem = this[0];
	    var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
	
	    while (elem) {
	      if (matchesSelector.bind(elem)(selector)) {
	        return elem;
	      } else {
	        elem = elem.parentElement;
	      }
	    }
	    return false;
	  };
	}
	
	var latestId = 0;
	
	var uis = angular.module('ui.select', [])
	
	.constant('uiSelectConfig', {
	  theme: 'bootstrap',
	  searchEnabled: true,
	  sortable: false,
	  placeholder: '', // Empty by default, like HTML tag <select>
	  refreshDelay: 1000, // In milliseconds
	  closeOnSelect: true,
	  skipFocusser: false,
	  dropdownPosition: 'auto',
	  removeSelected: true,
	  resetSearchInput: true,
	  generateId: function() {
	    return latestId++;
	  },
	  appendToBody: false,
	  spinnerEnabled: false,
	  spinnerClass: 'glyphicon glyphicon-refresh ui-select-spin',
	  backspaceReset: true
	})
	
	// See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
	.service('uiSelectMinErr', function() {
	  var minErr = angular.$$minErr('ui.select');
	  return function() {
	    var error = minErr.apply(this, arguments);
	    var message = error.message.replace(new RegExp('\nhttp://errors.angularjs.org/.*'), '');
	    return new Error(message);
	  };
	})
	
	// Recreates old behavior of ng-transclude. Used internally.
	.directive('uisTranscludeAppend', function () {
	  return {
	    link: function (scope, element, attrs, ctrl, transclude) {
	        transclude(scope, function (clone) {
	          element.append(clone);
	        });
	      }
	    };
	})
	
	/**
	 * Highlights text that matches $select.search.
	 *
	 * Taken from AngularUI Bootstrap Typeahead
	 * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
	 */
	.filter('highlight', function() {
	  function escapeRegexp(queryToEscape) {
	    return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	  }
	
	  return function(matchItem, query) {
	    return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
	  };
	})
	
	/**
	 * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
	 *
	 * Taken from AngularUI Bootstrap Position:
	 * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
	 */
	.factory('uisOffset',
	  ['$document', '$window',
	  function ($document, $window) {
	
	  return function(element) {
	    var boundingClientRect = element[0].getBoundingClientRect();
	    return {
	      width: boundingClientRect.width || element.prop('offsetWidth'),
	      height: boundingClientRect.height || element.prop('offsetHeight'),
	      top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	      left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	    };
	  };
	}]);
	
	/**
	 * Debounces functions
	 *
	 * Taken from UI Bootstrap $$debounce source code
	 * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
	 *
	 */
	uis.factory('$$uisDebounce', ['$timeout', function($timeout) {
	  return function(callback, debounceTime) {
	    var timeoutPromise;
	
	    return function() {
	      var self = this;
	      var args = Array.prototype.slice.call(arguments);
	      if (timeoutPromise) {
	        $timeout.cancel(timeoutPromise);
	      }
	
	      timeoutPromise = $timeout(function() {
	        callback.apply(self, args);
	      }, debounceTime);
	    };
	  };
	}]);
	
	uis.directive('uiSelectChoices',
	  ['uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window',
	  function(uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window) {
	
	  return {
	    restrict: 'EA',
	    require: '^uiSelect',
	    replace: true,
	    transclude: true,
	    templateUrl: function(tElement) {
	      // Needed so the uiSelect can detect the transcluded content
	      tElement.addClass('ui-select-choices');
	
	      // Gets theme attribute from parent (ui-select)
	      var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	      return theme + '/choices.tpl.html';
	    },
	
	    compile: function(tElement, tAttrs) {
	
	      if (!tAttrs.repeat) throw uiSelectMinErr('repeat', "Expected 'repeat' expression.");
	
	      // var repeat = RepeatParser.parse(attrs.repeat);
	      var groupByExp = tAttrs.groupBy;
	      var groupFilterExp = tAttrs.groupFilter;
	
	      if (groupByExp) {
	        var groups = tElement.querySelectorAll('.ui-select-choices-group');
	        if (groups.length !== 1) throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
	        groups.attr('ng-repeat', RepeatParser.getGroupNgRepeatExpression());
	      }
	
	      var parserResult = RepeatParser.parse(tAttrs.repeat);
	
	      var choices = tElement.querySelectorAll('.ui-select-choices-row');
	      if (choices.length !== 1) {
	        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
	      }
	
	      choices.attr('ng-repeat', parserResult.repeatExpression(groupByExp))
	             .attr('ng-if', '$select.open'); //Prevent unnecessary watches when dropdown is closed
	
	
	      var rowsInner = tElement.querySelectorAll('.ui-select-choices-row-inner');
	      if (rowsInner.length !== 1) {
	        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
	      }
	      rowsInner.attr('uis-transclude-append', ''); //Adding uisTranscludeAppend directive to row element after choices element has ngRepeat
	
	      // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event.
	      var clickTarget = $window.document.addEventListener ? choices : rowsInner;
	      clickTarget.attr('ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)');
	
	      return function link(scope, element, attrs, $select) {
	
	
	        $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp); //Result ready at $select.parserResult
	        $select.disableChoiceExpression = attrs.uiDisableChoice;
	        $select.onHighlightCallback = attrs.onHighlight;
	        $select.minimumInputLength = parseInt(attrs.minimumInputLength) || 0;
	        $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;
	
	        scope.$watch('$select.search', function(newValue) {
	          if(newValue && !$select.open && $select.multiple) $select.activate(false, true);
	          $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
	          if (!attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength) {
	            $select.refresh(attrs.refresh);
	          } else {
	            $select.items = [];
	          }
	        });
	
	        attrs.$observe('refreshDelay', function() {
	          // $eval() is needed otherwise we get a string instead of a number
	          var refreshDelay = scope.$eval(attrs.refreshDelay);
	          $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
	        });
	
	        scope.$watch('$select.open', function(open) {
	          if (open) {
	            tElement.attr('role', 'listbox');
	            $select.refresh(attrs.refresh);
	          } else {
	            element.removeAttr('role');
	          }
	        });
	      };
	    }
	  };
	}]);
	
	/**
	 * Contains ui-select "intelligence".
	 *
	 * The goal is to limit dependency on the DOM whenever possible and
	 * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
	 */
	uis.controller('uiSelectCtrl',
	  ['$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window',
	  function($scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window) {
	
	  var ctrl = this;
	
	  var EMPTY_SEARCH = '';
	
	  ctrl.placeholder = uiSelectConfig.placeholder;
	  ctrl.searchEnabled = uiSelectConfig.searchEnabled;
	  ctrl.sortable = uiSelectConfig.sortable;
	  ctrl.refreshDelay = uiSelectConfig.refreshDelay;
	  ctrl.paste = uiSelectConfig.paste;
	  ctrl.resetSearchInput = uiSelectConfig.resetSearchInput;
	  ctrl.refreshing = false;
	  ctrl.spinnerEnabled = uiSelectConfig.spinnerEnabled;
	  ctrl.spinnerClass = uiSelectConfig.spinnerClass;
	  ctrl.removeSelected = uiSelectConfig.removeSelected; //If selected item(s) should be removed from dropdown list
	  ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
	  ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
	  ctrl.search = EMPTY_SEARCH;
	
	  ctrl.activeIndex = 0; //Dropdown of choices
	  ctrl.items = []; //All available choices
	
	  ctrl.open = false;
	  ctrl.focus = false;
	  ctrl.disabled = false;
	  ctrl.selected = undefined;
	
	  ctrl.dropdownPosition = 'auto';
	
	  ctrl.focusser = undefined; //Reference to input element used to handle focus events
	  ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
	  ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
	  ctrl.tagging = {isActivated: false, fct: undefined};
	  ctrl.taggingTokens = {isActivated: false, tokens: undefined};
	  ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
	  ctrl.clickTriggeredSelect = false;
	  ctrl.$filter = $filter;
	  ctrl.$element = $element;
	
	  // Use $injector to check for $animate and store a reference to it
	  ctrl.$animate = (function () {
	    try {
	      return $injector.get('$animate');
	    } catch (err) {
	      // $animate does not exist
	      return null;
	    }
	  })();
	
	  ctrl.searchInput = $element.querySelectorAll('input.ui-select-search');
	  if (ctrl.searchInput.length !== 1) {
	    throw uiSelectMinErr('searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
	  }
	
	  ctrl.isEmpty = function() {
	    return isNil(ctrl.selected) || ctrl.selected === '' || (ctrl.multiple && ctrl.selected.length === 0);
	  };
	
	  function _findIndex(collection, predicate, thisArg){
	    if (collection.findIndex){
	      return collection.findIndex(predicate, thisArg);
	    } else {
	      var list = Object(collection);
	      var length = list.length >>> 0;
	      var value;
	
	      for (var i = 0; i < length; i++) {
	        value = list[i];
	        if (predicate.call(thisArg, value, i, list)) {
	          return i;
	        }
	      }
	      return -1;
	    }
	  }
	
	  // Most of the time the user does not want to empty the search input when in typeahead mode
	  function _resetSearchInput() {
	    if (ctrl.resetSearchInput) {
	      ctrl.search = EMPTY_SEARCH;
	      //reset activeIndex
	      if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
	        ctrl.activeIndex = _findIndex(ctrl.items, function(item){
	          return angular.equals(this, item);
	        }, ctrl.selected);
	      }
	    }
	  }
	
	    function _groupsFilter(groups, groupNames) {
	      var i, j, result = [];
	      for(i = 0; i < groupNames.length ;i++){
	        for(j = 0; j < groups.length ;j++){
	          if(groups[j].name == [groupNames[i]]){
	            result.push(groups[j]);
	          }
	        }
	      }
	      return result;
	    }
	
	  // When the user clicks on ui-select, displays the dropdown list
	  ctrl.activate = function(initSearchValue, avoidReset) {
	    if (!ctrl.disabled  && !ctrl.open) {
	      if(!avoidReset) _resetSearchInput();
	
	      $scope.$broadcast('uis:activate');
	      ctrl.open = true;
	      ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;
	      // ensure that the index is set to zero for tagging variants
	      // that where first option is auto-selected
	      if ( ctrl.activeIndex === -1 && ctrl.taggingLabel !== false ) {
	        ctrl.activeIndex = 0;
	      }
	
	      var container = $element.querySelectorAll('.ui-select-choices-content');
	      var searchInput = $element.querySelectorAll('.ui-select-search');
	      if (ctrl.$animate && ctrl.$animate.on && ctrl.$animate.enabled(container[0])) {
	        var animateHandler = function(elem, phase) {
	          if (phase === 'start' && ctrl.items.length === 0) {
	            // Only focus input after the animation has finished
	            ctrl.$animate.off('removeClass', searchInput[0], animateHandler);
	            $timeout(function () {
	              ctrl.focusSearchInput(initSearchValue);
	            });
	          } else if (phase === 'close') {
	            // Only focus input after the animation has finished
	            ctrl.$animate.off('enter', container[0], animateHandler);
	            $timeout(function () {
	              ctrl.focusSearchInput(initSearchValue);
	            });
	          }
	        };
	
	        if (ctrl.items.length > 0) {
	          ctrl.$animate.on('enter', container[0], animateHandler);
	        } else {
	          ctrl.$animate.on('removeClass', searchInput[0], animateHandler);
	        }
	      } else {
	        $timeout(function () {
	          ctrl.focusSearchInput(initSearchValue);
	          if(!ctrl.tagging.isActivated && ctrl.items.length > 1) {
	            _ensureHighlightVisible();
	          }
	        });
	      }
	    }
	    else if (ctrl.open && !ctrl.searchEnabled) {
	      // Close the selection if we don't have search enabled, and we click on the select again
	      ctrl.close();
	    }
	  };
	
	  ctrl.focusSearchInput = function (initSearchValue) {
	    ctrl.search = initSearchValue || ctrl.search;
	    ctrl.searchInput[0].focus();
	  };
	
	  ctrl.findGroupByName = function(name) {
	    return ctrl.groups && ctrl.groups.filter(function(group) {
	      return group.name === name;
	    })[0];
	  };
	
	  ctrl.parseRepeatAttr = function(repeatAttr, groupByExp, groupFilterExp) {
	    function updateGroups(items) {
	      var groupFn = $scope.$eval(groupByExp);
	      ctrl.groups = [];
	      angular.forEach(items, function(item) {
	        var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
	        var group = ctrl.findGroupByName(groupName);
	        if(group) {
	          group.items.push(item);
	        }
	        else {
	          ctrl.groups.push({name: groupName, items: [item]});
	        }
	      });
	      if(groupFilterExp){
	        var groupFilterFn = $scope.$eval(groupFilterExp);
	        if( angular.isFunction(groupFilterFn)){
	          ctrl.groups = groupFilterFn(ctrl.groups);
	        } else if(angular.isArray(groupFilterFn)){
	          ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
	        }
	      }
	      ctrl.items = [];
	      ctrl.groups.forEach(function(group) {
	        ctrl.items = ctrl.items.concat(group.items);
	      });
	    }
	
	    function setPlainItems(items) {
	      ctrl.items = items || [];
	    }
	
	    ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;
	
	    ctrl.parserResult = RepeatParser.parse(repeatAttr);
	
	    ctrl.isGrouped = !!groupByExp;
	    ctrl.itemProperty = ctrl.parserResult.itemName;
	
	    //If collection is an Object, convert it to Array
	
	    var originalSource = ctrl.parserResult.source;
	
	    //When an object is used as source, we better create an array and use it as 'source'
	    var createArrayFromObject = function(){
	      var origSrc = originalSource($scope);
	      $scope.$uisSource = Object.keys(origSrc).map(function(v){
	        var result = {};
	        result[ctrl.parserResult.keyName] = v;
	        result.value = origSrc[v];
	        return result;
	      });
	    };
	
	    if (ctrl.parserResult.keyName){ // Check for (key,value) syntax
	      createArrayFromObject();
	      ctrl.parserResult.source = $parse('$uisSource' + ctrl.parserResult.filters);
	      $scope.$watch(originalSource, function(newVal, oldVal){
	        if (newVal !== oldVal) createArrayFromObject();
	      }, true);
	    }
	
	    ctrl.refreshItems = function (data){
	      data = data || ctrl.parserResult.source($scope);
	      var selectedItems = ctrl.selected;
	      //TODO should implement for single mode removeSelected
	      if (ctrl.isEmpty() || (angular.isArray(selectedItems) && !selectedItems.length) || !ctrl.multiple || !ctrl.removeSelected) {
	        ctrl.setItemsFn(data);
	      }else{
	        if ( data !== undefined && data !== null ) {
	          var filteredItems = data.filter(function(i) {
	            return angular.isArray(selectedItems) ? selectedItems.every(function(selectedItem) {
	              return !angular.equals(i, selectedItem);
	            }) : !angular.equals(i, selectedItems);
	          });
	          ctrl.setItemsFn(filteredItems);
	        }
	      }
	      if (ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up'){
	        $scope.calculateDropdownPos();
	      }
	      $scope.$broadcast('uis:refresh');
	    };
	
	    // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
	    $scope.$watchCollection(ctrl.parserResult.source, function(items) {
	      if (items === undefined || items === null) {
	        // If the user specifies undefined or null => reset the collection
	        // Special case: items can be undefined if the user did not initialized the collection on the scope
	        // i.e $scope.addresses = [] is missing
	        ctrl.items = [];
	      } else {
	        if (!angular.isArray(items)) {
	          throw uiSelectMinErr('items', "Expected an array but got '{0}'.", items);
	        } else {
	          //Remove already selected items (ex: while searching)
	          //TODO Should add a test
	          ctrl.refreshItems(items);
	
	          //update the view value with fresh data from items, if there is a valid model value
	          if(angular.isDefined(ctrl.ngModel.$modelValue)) {
	            ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	          }
	        }
	      }
	    });
	
	  };
	
	  var _refreshDelayPromise;
	
	  /**
	   * Typeahead mode: lets the user refresh the collection using his own function.
	   *
	   * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
	   */
	  ctrl.refresh = function(refreshAttr) {
	    if (refreshAttr !== undefined) {
	      // Debounce
	      // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
	      // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
	      if (_refreshDelayPromise) {
	        $timeout.cancel(_refreshDelayPromise);
	      }
	      _refreshDelayPromise = $timeout(function() {
	        if ($scope.$select.search.length >= $scope.$select.minimumInputLength) {
	          var refreshPromise = $scope.$eval(refreshAttr);
	          if (refreshPromise && angular.isFunction(refreshPromise.then) && !ctrl.refreshing) {
	            ctrl.refreshing = true;
	            refreshPromise.finally(function() {
	              ctrl.refreshing = false;
	            });
	          }
	        }
	      }, ctrl.refreshDelay);
	    }
	  };
	
	  ctrl.isActive = function(itemScope) {
	    if ( !ctrl.open ) {
	      return false;
	    }
	    var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
	    var isActive =  itemIndex == ctrl.activeIndex;
	
	    if ( !isActive || itemIndex < 0 ) {
	      return false;
	    }
	
	    if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
	      itemScope.$eval(ctrl.onHighlightCallback);
	    }
	
	    return isActive;
	  };
	
	  var _isItemSelected = function (item) {
	    return (ctrl.selected && angular.isArray(ctrl.selected) &&
	        ctrl.selected.filter(function (selection) { return angular.equals(selection, item); }).length > 0);
	  };
	
	  var disabledItems = [];
	
	  function _updateItemDisabled(item, isDisabled) {
	    var disabledItemIndex = disabledItems.indexOf(item);
	    if (isDisabled && disabledItemIndex === -1) {
	      disabledItems.push(item);
	    }
	
	    if (!isDisabled && disabledItemIndex > -1) {
	      disabledItems.splice(disabledItemIndex, 1);
	    }
	  }
	
	  function _isItemDisabled(item) {
	    return disabledItems.indexOf(item) > -1;
	  }
	
	  ctrl.isDisabled = function(itemScope) {
	
	    if (!ctrl.open) return;
	
	    var item = itemScope[ctrl.itemProperty];
	    var itemIndex = ctrl.items.indexOf(item);
	    var isDisabled = false;
	
	    if (itemIndex >= 0 && (angular.isDefined(ctrl.disableChoiceExpression) || ctrl.multiple)) {
	
	      if (item.isTag) return false;
	
	      if (ctrl.multiple) {
	        isDisabled = _isItemSelected(item);
	      }
	
	      if (!isDisabled && angular.isDefined(ctrl.disableChoiceExpression)) {
	        isDisabled = !!(itemScope.$eval(ctrl.disableChoiceExpression));
	      }
	
	      _updateItemDisabled(item, isDisabled);
	    }
	
	    return isDisabled;
	  };
	
	
	  // When the user selects an item with ENTER or clicks the dropdown
	  ctrl.select = function(item, skipFocusser, $event) {
	    if (isNil(item) || !_isItemDisabled(item)) {
	
	      if ( ! ctrl.items && ! ctrl.search && ! ctrl.tagging.isActivated) return;
	
	      if (!item || !_isItemDisabled(item)) {
	        // if click is made on existing item, prevent from tagging, ctrl.search does not matter
	        ctrl.clickTriggeredSelect = false;
	        if($event && ($event.type === 'click' || $event.type === 'touchend') && item)
	          ctrl.clickTriggeredSelect = true;
	
	        if(ctrl.tagging.isActivated && ctrl.clickTriggeredSelect === false) {
	          // if taggingLabel is disabled and item is undefined we pull from ctrl.search
	          if ( ctrl.taggingLabel === false ) {
	            if ( ctrl.activeIndex < 0 ) {
	              if (item === undefined) {
	                item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
	              }
	              if (!item || angular.equals( ctrl.items[0], item ) ) {
	                return;
	              }
	            } else {
	              // keyboard nav happened first, user selected from dropdown
	              item = ctrl.items[ctrl.activeIndex];
	            }
	          } else {
	            // tagging always operates at index zero, taggingLabel === false pushes
	            // the ctrl.search value without having it injected
	            if ( ctrl.activeIndex === 0 ) {
	              // ctrl.tagging pushes items to ctrl.items, so we only have empty val
	              // for `item` if it is a detected duplicate
	              if ( item === undefined ) return;
	
	              // create new item on the fly if we don't already have one;
	              // use tagging function if we have one
	              if ( ctrl.tagging.fct !== undefined && typeof item === 'string' ) {
	                item = ctrl.tagging.fct(item);
	                if (!item) return;
	              // if item type is 'string', apply the tagging label
	              } else if ( typeof item === 'string' ) {
	                // trim the trailing space
	                item = item.replace(ctrl.taggingLabel,'').trim();
	              }
	            }
	          }
	          // search ctrl.selected for dupes potentially caused by tagging and return early if found
	          if (_isItemSelected(item)) {
	            ctrl.close(skipFocusser);
	            return;
	          }
	        }
	        _resetSearchInput();
	        $scope.$broadcast('uis:select', item);
	
	        if (ctrl.closeOnSelect) {
	          ctrl.close(skipFocusser);
	        }
	      }
	    }
	  };
	
	  // Closes the dropdown
	  ctrl.close = function(skipFocusser) {
	    if (!ctrl.open) return;
	    if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
	    ctrl.open = false;
	    _resetSearchInput();
	    $scope.$broadcast('uis:close', skipFocusser);
	
	  };
	
	  ctrl.setFocus = function(){
	    if (!ctrl.focus) ctrl.focusInput[0].focus();
	  };
	
	  ctrl.clear = function($event) {
	    ctrl.select(null);
	    $event.stopPropagation();
	    $timeout(function() {
	      ctrl.focusser[0].focus();
	    }, 0, false);
	  };
	
	  // Toggle dropdown
	  ctrl.toggle = function(e) {
	    if (ctrl.open) {
	      ctrl.close();
	      e.preventDefault();
	      e.stopPropagation();
	    } else {
	      ctrl.activate();
	    }
	  };
	
	  // Set default function for locked choices - avoids unnecessary
	  // logic if functionality is not being used
	  ctrl.isLocked = function () {
	    return false;
	  };
	
	  $scope.$watch(function () {
	    return angular.isDefined(ctrl.lockChoiceExpression) && ctrl.lockChoiceExpression !== "";
	  }, _initaliseLockedChoices);
	
	  function _initaliseLockedChoices(doInitalise) {
	    if(!doInitalise) return;
	
	    var lockedItems = [];
	
	    function _updateItemLocked(item, isLocked) {
	      var lockedItemIndex = lockedItems.indexOf(item);
	      if (isLocked && lockedItemIndex === -1) {
	        lockedItems.push(item);
	        }
	
	      if (!isLocked && lockedItemIndex > -1) {
	        lockedItems.splice(lockedItemIndex, 1);
	      }
	    }
	
	    function _isItemlocked(item) {
	      return lockedItems.indexOf(item) > -1;
	    }
	
	    ctrl.isLocked = function (itemScope, itemIndex) {
	      var isLocked = false,
	          item = ctrl.selected[itemIndex];
	
	      if(item) {
	        if (itemScope) {
	          isLocked = !!(itemScope.$eval(ctrl.lockChoiceExpression));
	          _updateItemLocked(item, isLocked);
	        } else {
	          isLocked = _isItemlocked(item);
	        }
	      }
	
	      return isLocked;
	    };
	  }
	
	
	  var sizeWatch = null;
	  var updaterScheduled = false;
	  ctrl.sizeSearchInput = function() {
	
	    var input = ctrl.searchInput[0],
	        container = ctrl.$element[0],
	        calculateContainerWidth = function() {
	          // Return the container width only if the search input is visible
	          return container.clientWidth * !!input.offsetParent;
	        },
	        updateIfVisible = function(containerWidth) {
	          if (containerWidth === 0) {
	            return false;
	          }
	          var inputWidth = containerWidth - input.offsetLeft;
	          if (inputWidth < 50) inputWidth = containerWidth;
	          ctrl.searchInput.css('width', inputWidth+'px');
	          return true;
	        };
	
	    ctrl.searchInput.css('width', '10px');
	    $timeout(function() { //Give tags time to render correctly
	      if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
	        sizeWatch = $scope.$watch(function() {
	          if (!updaterScheduled) {
	            updaterScheduled = true;
	            $scope.$$postDigest(function() {
	              updaterScheduled = false;
	              if (updateIfVisible(calculateContainerWidth())) {
	                sizeWatch();
	                sizeWatch = null;
	              }
	            });
	          }
	        }, angular.noop);
	      }
	    });
	  };
	
	  function _handleDropDownSelection(key) {
	    var processed = true;
	    switch (key) {
	      case KEY.DOWN:
	        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        else if (ctrl.activeIndex < ctrl.items.length - 1) {
	          var idx = ++ctrl.activeIndex;
	          while(_isItemDisabled(ctrl.items[idx]) && idx < ctrl.items.length) {
	            ctrl.activeIndex = ++idx;
	          }
	        }
	        break;
	      case KEY.UP:
	        var minActiveIndex = (ctrl.search.length === 0 && ctrl.tagging.isActivated) ? -1 : 0;
	        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        else if (ctrl.activeIndex > minActiveIndex) {
	          var idxmin = --ctrl.activeIndex;
	          while(_isItemDisabled(ctrl.items[idxmin]) && idxmin > minActiveIndex) {
	            ctrl.activeIndex = --idxmin;
	          }
	        }
	        break;
	      case KEY.TAB:
	        if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
	        break;
	      case KEY.ENTER:
	        if(ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)){
	          ctrl.select(ctrl.items[ctrl.activeIndex], ctrl.skipFocusser); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
	        } else {
	          ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        }
	        break;
	      case KEY.ESC:
	        ctrl.close();
	        break;
	      default:
	        processed = false;
	    }
	    return processed;
	  }
	
	  // Bind to keyboard shortcuts
	  ctrl.searchInput.on('keydown', function(e) {
	
	    var key = e.which;
	
	    if (~[KEY.ENTER,KEY.ESC].indexOf(key)){
	      e.preventDefault();
	      e.stopPropagation();
	    }
	
	    $scope.$apply(function() {
	
	      var tagged = false;
	
	      if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
	        if(!_handleDropDownSelection(key) && !ctrl.searchEnabled) {
	          e.preventDefault();
	          e.stopPropagation();
	        }
	        if ( ctrl.taggingTokens.isActivated ) {
	          for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
	            if ( ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode] ) {
	              // make sure there is a new value to push via tagging
	              if ( ctrl.search.length > 0 ) {
	                tagged = true;
	              }
	            }
	          }
	          if ( tagged ) {
	            $timeout(function() {
	              ctrl.searchInput.triggerHandler('tagged');
	              var newItem = ctrl.search.replace(KEY.MAP[e.keyCode],'').trim();
	              if ( ctrl.tagging.fct ) {
	                newItem = ctrl.tagging.fct( newItem );
	              }
	              if (newItem) ctrl.select(newItem, true);
	            });
	          }
	        }
	      }
	
	    });
	
	    if(KEY.isVerticalMovement(key) && ctrl.items.length > 0){
	      _ensureHighlightVisible();
	    }
	
	    if (key === KEY.ENTER || key === KEY.ESC) {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	
	  });
	
	  ctrl.searchInput.on('paste', function (e) {
	    var data;
	
	    if (window.clipboardData && window.clipboardData.getData) { // IE
	      data = window.clipboardData.getData('Text');
	    } else {
	      data = (e.originalEvent || e).clipboardData.getData('text/plain');
	    }
	
	    // Prepend the current input field text to the paste buffer.
	    data = ctrl.search + data;
	
	    if (data && data.length > 0) {
	      // If tagging try to split by tokens and add items
	      if (ctrl.taggingTokens.isActivated) {
	        var items = [];
	        for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {  // split by first token that is contained in data
	          var separator = KEY.toSeparator(ctrl.taggingTokens.tokens[i]) || ctrl.taggingTokens.tokens[i];
	          if (data.indexOf(separator) > -1) {
	            items = data.split(separator);
	            break;  // only split by one token
	          }
	        }
	        if (items.length === 0) {
	          items = [data];
	        }
	        var oldsearch = ctrl.search;
	        angular.forEach(items, function (item) {
	          var newItem = ctrl.tagging.fct ? ctrl.tagging.fct(item) : item;
	          if (newItem) {
	            ctrl.select(newItem, true);
	          }
	        });
	        ctrl.search = oldsearch || EMPTY_SEARCH;
	        e.preventDefault();
	        e.stopPropagation();
	      } else if (ctrl.paste) {
	        ctrl.paste(data);
	        ctrl.search = EMPTY_SEARCH;
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    }
	  });
	
	  ctrl.searchInput.on('tagged', function() {
	    $timeout(function() {
	      _resetSearchInput();
	    });
	  });
	
	  // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
	  function _ensureHighlightVisible() {
	    var container = $element.querySelectorAll('.ui-select-choices-content');
	    var choices = container.querySelectorAll('.ui-select-choices-row');
	    if (choices.length < 1) {
	      throw uiSelectMinErr('choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
	    }
	
	    if (ctrl.activeIndex < 0) {
	      return;
	    }
	
	    var highlighted = choices[ctrl.activeIndex];
	    var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
	    var height = container[0].offsetHeight;
	
	    if (posY > height) {
	      container[0].scrollTop += posY - height;
	    } else if (posY < highlighted.clientHeight) {
	      if (ctrl.isGrouped && ctrl.activeIndex === 0)
	        container[0].scrollTop = 0; //To make group header visible when going all the way up
	      else
	        container[0].scrollTop -= highlighted.clientHeight - posY;
	    }
	  }
	
	  var onResize = $$uisDebounce(function() {
	    ctrl.sizeSearchInput();
	  }, 50);
	
	  angular.element($window).bind('resize', onResize);
	
	  $scope.$on('$destroy', function() {
	    ctrl.searchInput.off('keyup keydown tagged blur paste');
	    angular.element($window).off('resize', onResize);
	  });
	
	  $scope.$watch('$select.activeIndex', function(activeIndex) {
	    if (activeIndex)
	      $element.find('input').attr(
	        'aria-activedescendant',
	        'ui-select-choices-row-' + ctrl.generatedId + '-' + activeIndex);
	  });
	
	  $scope.$watch('$select.open', function(open) {
	    if (!open)
	      $element.find('input').removeAttr('aria-activedescendant');
	  });
	}]);
	
	uis.directive('uiSelect',
	  ['$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout',
	  function($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {
	
	  return {
	    restrict: 'EA',
	    templateUrl: function(tElement, tAttrs) {
	      var theme = tAttrs.theme || uiSelectConfig.theme;
	      return theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
	    },
	    replace: true,
	    transclude: true,
	    require: ['uiSelect', '^ngModel'],
	    scope: true,
	
	    controller: 'uiSelectCtrl',
	    controllerAs: '$select',
	    compile: function(tElement, tAttrs) {
	
	      // Allow setting ngClass on uiSelect
	      var match = /{(.*)}\s*{(.*)}/.exec(tAttrs.ngClass);
	      if(match) {
	        var combined = '{'+ match[1] +', '+ match[2] +'}';
	        tAttrs.ngClass = combined;
	        tElement.attr('ng-class', combined);
	      }
	
	      //Multiple or Single depending if multiple attribute presence
	      if (angular.isDefined(tAttrs.multiple))
	        tElement.append('<ui-select-multiple/>').removeAttr('multiple');
	      else
	        tElement.append('<ui-select-single/>');
	
	      if (tAttrs.inputId)
	        tElement.querySelectorAll('input.ui-select-search')[0].id = tAttrs.inputId;
	
	      return function(scope, element, attrs, ctrls, transcludeFn) {
	
	        var $select = ctrls[0];
	        var ngModel = ctrls[1];
	
	        $select.generatedId = uiSelectConfig.generateId();
	        $select.baseTitle = attrs.title || 'Select box';
	        $select.focusserTitle = $select.baseTitle + ' focus';
	        $select.focusserId = 'focusser-' + $select.generatedId;
	
	        $select.closeOnSelect = function() {
	          if (angular.isDefined(attrs.closeOnSelect)) {
	            return $parse(attrs.closeOnSelect)();
	          } else {
	            return uiSelectConfig.closeOnSelect;
	          }
	        }();
	
	        scope.$watch('skipFocusser', function() {
	            var skipFocusser = scope.$eval(attrs.skipFocusser);
	            $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
	        });
	
	        $select.onSelectCallback = $parse(attrs.onSelect);
	        $select.onRemoveCallback = $parse(attrs.onRemove);
	
	        //Set reference to ngModel from uiSelectCtrl
	        $select.ngModel = ngModel;
	
	        $select.choiceGrouped = function(group){
	          return $select.isGrouped && group && group.name;
	        };
	
	        if(attrs.tabindex){
	          attrs.$observe('tabindex', function(value) {
	            $select.focusInput.attr('tabindex', value);
	            element.removeAttr('tabindex');
	          });
	        }
	
	        scope.$watch(function () { return scope.$eval(attrs.searchEnabled); }, function(newVal) {
	          $select.searchEnabled = newVal !== undefined ? newVal : uiSelectConfig.searchEnabled;
	        });
	
	        scope.$watch('sortable', function() {
	            var sortable = scope.$eval(attrs.sortable);
	            $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
	        });
	
	        attrs.$observe('backspaceReset', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var backspaceReset = scope.$eval(attrs.backspaceReset);
	          $select.backspaceReset = backspaceReset !== undefined ? backspaceReset : true;
	        });
	
	        attrs.$observe('limit', function() {
	          //Limit the number of selections allowed
	          $select.limit = (angular.isDefined(attrs.limit)) ? parseInt(attrs.limit, 10) : undefined;
	        });
	
	        scope.$watch('removeSelected', function() {
	            var removeSelected = scope.$eval(attrs.removeSelected);
	            $select.removeSelected = removeSelected !== undefined ? removeSelected : uiSelectConfig.removeSelected;
	        });
	
	        attrs.$observe('disabled', function() {
	          // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
	          $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
	        });
	
	        attrs.$observe('resetSearchInput', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var resetSearchInput = scope.$eval(attrs.resetSearchInput);
	          $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
	        });
	
	        attrs.$observe('paste', function() {
	          $select.paste = scope.$eval(attrs.paste);
	        });
	
	        attrs.$observe('tagging', function() {
	          if(attrs.tagging !== undefined)
	          {
	            // $eval() is needed otherwise we get a string instead of a boolean
	            var taggingEval = scope.$eval(attrs.tagging);
	            $select.tagging = {isActivated: true, fct: taggingEval !== true ? taggingEval : undefined};
	          }
	          else
	          {
	            $select.tagging = {isActivated: false, fct: undefined};
	          }
	        });
	
	        attrs.$observe('taggingLabel', function() {
	          if(attrs.tagging !== undefined )
	          {
	            // check eval for FALSE, in this case, we disable the labels
	            // associated with tagging
	            if ( attrs.taggingLabel === 'false' ) {
	              $select.taggingLabel = false;
	            }
	            else
	            {
	              $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
	            }
	          }
	        });
	
	        attrs.$observe('taggingTokens', function() {
	          if (attrs.tagging !== undefined) {
	            var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',','ENTER'];
	            $select.taggingTokens = {isActivated: true, tokens: tokens };
	          }
	        });
	
	        attrs.$observe('spinnerEnabled', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var spinnerEnabled = scope.$eval(attrs.spinnerEnabled);
	          $select.spinnerEnabled = spinnerEnabled !== undefined ? spinnerEnabled : uiSelectConfig.spinnerEnabled;
	        });
	
	        attrs.$observe('spinnerClass', function() {
	          var spinnerClass = attrs.spinnerClass;
	          $select.spinnerClass = spinnerClass !== undefined ? attrs.spinnerClass : uiSelectConfig.spinnerClass;
	        });
	
	        //Automatically gets focus when loaded
	        if (angular.isDefined(attrs.autofocus)){
	          $timeout(function(){
	            $select.setFocus();
	          });
	        }
	
	        //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
	        if (angular.isDefined(attrs.focusOn)){
	          scope.$on(attrs.focusOn, function() {
	              $timeout(function(){
	                $select.setFocus();
	              });
	          });
	        }
	
	        function onDocumentClick(e) {
	          if (!$select.open) return; //Skip it if dropdown is close
	
	          var contains = false;
	
	          if (window.jQuery) {
	            // Firefox 3.6 does not support element.contains()
	            // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
	            contains = window.jQuery.contains(element[0], e.target);
	          } else {
	            contains = element[0].contains(e.target);
	          }
	
	          if (!contains && !$select.clickTriggeredSelect) {
	            var skipFocusser;
	            if (!$select.skipFocusser) {
	              //Will lose focus only with certain targets
	              var focusableControls = ['input','button','textarea','select'];
	              var targetController = angular.element(e.target).controller('uiSelect'); //To check if target is other ui-select
	              skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
	              if (!skipFocusser) skipFocusser =  ~focusableControls.indexOf(e.target.tagName.toLowerCase()); //Check if target is input, button or textarea
	            } else {
	              skipFocusser = true;
	            }
	            $select.close(skipFocusser);
	            scope.$digest();
	          }
	          $select.clickTriggeredSelect = false;
	        }
	
	        // See Click everywhere but here event http://stackoverflow.com/questions/12931369
	        $document.on('click', onDocumentClick);
	
	        scope.$on('$destroy', function() {
	          $document.off('click', onDocumentClick);
	        });
	
	        // Move transcluded elements to their correct position in main template
	        transcludeFn(scope, function(clone) {
	          // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html
	
	          // One day jqLite will be replaced by jQuery and we will be able to write:
	          // var transcludedElement = clone.filter('.my-class')
	          // instead of creating a hackish DOM element:
	          var transcluded = angular.element('<div>').append(clone);
	
	          var transcludedMatch = transcluded.querySelectorAll('.ui-select-match');
	          transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
	          transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes
	          if (transcludedMatch.length !== 1) {
	            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
	          }
	          element.querySelectorAll('.ui-select-match').replaceWith(transcludedMatch);
	
	          var transcludedChoices = transcluded.querySelectorAll('.ui-select-choices');
	          transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
	          transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes
	          if (transcludedChoices.length !== 1) {
	            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
	          }
	          element.querySelectorAll('.ui-select-choices').replaceWith(transcludedChoices);
	
	          var transcludedNoChoice = transcluded.querySelectorAll('.ui-select-no-choice');
	          transcludedNoChoice.removeAttr('ui-select-no-choice'); //To avoid loop in case directive as attr
	          transcludedNoChoice.removeAttr('data-ui-select-no-choice'); // Properly handle HTML5 data-attributes
	          if (transcludedNoChoice.length == 1) {
	            element.querySelectorAll('.ui-select-no-choice').replaceWith(transcludedNoChoice);
	          }
	        });
	
	        // Support for appending the select field to the body when its open
	        var appendToBody = scope.$eval(attrs.appendToBody);
	        if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
	          scope.$watch('$select.open', function(isOpen) {
	            if (isOpen) {
	              positionDropdown();
	            } else {
	              resetDropdown();
	            }
	          });
	
	          // Move the dropdown back to its original location when the scope is destroyed. Otherwise
	          // it might stick around when the user routes away or the select field is otherwise removed
	          scope.$on('$destroy', function() {
	            resetDropdown();
	          });
	        }
	
	        // Hold on to a reference to the .ui-select-container element for appendToBody support
	        var placeholder = null,
	            originalWidth = '';
	
	        function positionDropdown() {
	          // Remember the absolute position of the element
	          var offset = uisOffset(element);
	
	          // Clone the element into a placeholder element to take its original place in the DOM
	          placeholder = angular.element('<div class="ui-select-placeholder"></div>');
	          placeholder[0].style.width = offset.width + 'px';
	          placeholder[0].style.height = offset.height + 'px';
	          element.after(placeholder);
	
	          // Remember the original value of the element width inline style, so it can be restored
	          // when the dropdown is closed
	          originalWidth = element[0].style.width;
	
	          // Now move the actual dropdown element to the end of the body
	          $document.find('body').append(element);
	
	          element[0].style.position = 'absolute';
	          element[0].style.left = offset.left + 'px';
	          element[0].style.top = offset.top + 'px';
	          element[0].style.width = offset.width + 'px';
	        }
	
	        function resetDropdown() {
	          if (placeholder === null) {
	            // The dropdown has not actually been display yet, so there's nothing to reset
	            return;
	          }
	
	          // Move the dropdown element back to its original location in the DOM
	          placeholder.replaceWith(element);
	          placeholder = null;
	
	          element[0].style.position = '';
	          element[0].style.left = '';
	          element[0].style.top = '';
	          element[0].style.width = originalWidth;
	
	          // Set focus back on to the moved element
	          $select.setFocus();
	        }
	
	        // Hold on to a reference to the .ui-select-dropdown element for direction support.
	        var dropdown = null,
	            directionUpClassName = 'direction-up';
	
	        // Support changing the direction of the dropdown if there isn't enough space to render it.
	        scope.$watch('$select.open', function() {
	
	          if ($select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up'){
	            scope.calculateDropdownPos();
	          }
	
	        });
	
	        var setDropdownPosUp = function(offset, offsetDropdown){
	
	          offset = offset || uisOffset(element);
	          offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	          dropdown[0].style.position = 'absolute';
	          dropdown[0].style.top = (offsetDropdown.height * -1) + 'px';
	          element.addClass(directionUpClassName);
	
	        };
	
	        var setDropdownPosDown = function(offset, offsetDropdown){
	
	          element.removeClass(directionUpClassName);
	
	          offset = offset || uisOffset(element);
	          offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	          dropdown[0].style.position = '';
	          dropdown[0].style.top = '';
	
	        };
	
	        var calculateDropdownPosAfterAnimation = function() {
	          // Delay positioning the dropdown until all choices have been added so its height is correct.
	          $timeout(function() {
	            if ($select.dropdownPosition === 'up') {
	              //Go UP
	              setDropdownPosUp();
	            } else {
	              //AUTO
	              element.removeClass(directionUpClassName);
	
	              var offset = uisOffset(element);
	              var offsetDropdown = uisOffset(dropdown);
	
	              //https://code.google.com/p/chromium/issues/detail?id=342307#c4
	              var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).
	
	              // Determine if the direction of the dropdown needs to be changed.
	              if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
	                //Go UP
	                setDropdownPosUp(offset, offsetDropdown);
	              }else{
	                //Go DOWN
	                setDropdownPosDown(offset, offsetDropdown);
	              }
	            }
	
	            // Display the dropdown once it has been positioned.
	            dropdown[0].style.opacity = 1;
	          });
	        };
	
	        var opened = false;
	        
	        scope.calculateDropdownPos = function() {
	          if ($select.open) {
	            dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');
	
	            if (dropdown.length === 0) {
	              return;
	            }
	
	           // Hide the dropdown so there is no flicker until $timeout is done executing.
	           if ($select.search === '' && !opened) {
	              dropdown[0].style.opacity = 0;
	              opened = true;
	           }
	
	            if (!uisOffset(dropdown).height && $select.$animate && $select.$animate.on && $select.$animate.enabled(dropdown)) {
	              var needsCalculated = true;
	
	              $select.$animate.on('enter', dropdown, function (elem, phase) {
	                if (phase === 'close' && needsCalculated) {
	                  calculateDropdownPosAfterAnimation();
	                  needsCalculated = false;
	                }
	              });
	            } else {
	              calculateDropdownPosAfterAnimation();
	            }
	          } else {
	            if (dropdown === null || dropdown.length === 0) {
	              return;
	            }
	
	            // Reset the position of the dropdown.
	            dropdown[0].style.opacity = 0;
	            dropdown[0].style.position = '';
	            dropdown[0].style.top = '';
	            element.removeClass(directionUpClassName);
	          }
	        };
	      };
	    }
	  };
	}]);
	
	uis.directive('uiSelectMatch', ['uiSelectConfig', function(uiSelectConfig) {
	  return {
	    restrict: 'EA',
	    require: '^uiSelect',
	    replace: true,
	    transclude: true,
	    templateUrl: function(tElement) {
	      // Needed so the uiSelect can detect the transcluded content
	      tElement.addClass('ui-select-match');
	
	      var parent = tElement.parent();
	      // Gets theme attribute from parent (ui-select)
	      var theme = getAttribute(parent, 'theme') || uiSelectConfig.theme;
	      var multi = angular.isDefined(getAttribute(parent, 'multiple'));
	
	      return theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');      
	    },
	    link: function(scope, element, attrs, $select) {
	      $select.lockChoiceExpression = attrs.uiLockChoice;
	      attrs.$observe('placeholder', function(placeholder) {
	        $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
	      });
	
	      function setAllowClear(allow) {
	        $select.allowClear = (angular.isDefined(allow)) ? (allow === '') ? true : (allow.toLowerCase() === 'true') : false;
	      }
	
	      attrs.$observe('allowClear', setAllowClear);
	      setAllowClear(attrs.allowClear);
	
	      if($select.multiple){
	        $select.sizeSearchInput();
	      }
	
	    }
	  };
	
	  function getAttribute(elem, attribute) {
	    if (elem[0].hasAttribute(attribute))
	      return elem.attr(attribute);
	
	    if (elem[0].hasAttribute('data-' + attribute))
	      return elem.attr('data-' + attribute);
	
	    if (elem[0].hasAttribute('x-' + attribute))
	      return elem.attr('x-' + attribute);
	  }
	}]);
	
	uis.directive('uiSelectMultiple', ['uiSelectMinErr','$timeout', function(uiSelectMinErr, $timeout) {
	  return {
	    restrict: 'EA',
	    require: ['^uiSelect', '^ngModel'],
	
	    controller: ['$scope','$timeout', function($scope, $timeout){
	
	      var ctrl = this,
	          $select = $scope.$select,
	          ngModel;
	
	      if (angular.isUndefined($select.selected))
	        $select.selected = [];
	
	      //Wait for link fn to inject it
	      $scope.$evalAsync(function(){ ngModel = $scope.ngModel; });
	
	      ctrl.activeMatchIndex = -1;
	
	      ctrl.updateModel = function(){
	        ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes
	        ctrl.refreshComponent();
	      };
	
	      ctrl.refreshComponent = function(){
	        //Remove already selected items
	        //e.g. When user clicks on a selection, the selected array changes and
	        //the dropdown should remove that item
	        if($select.refreshItems){
	          $select.refreshItems();
	        }
	        if($select.sizeSearchInput){
	          $select.sizeSearchInput();
	        }
	      };
	
	      // Remove item from multiple select
	      ctrl.removeChoice = function(index){
	
	        // if the choice is locked, don't remove it
	        if($select.isLocked(null, index)) return false;
	
	        var removedChoice = $select.selected[index];
	
	        var locals = {};
	        locals[$select.parserResult.itemName] = removedChoice;
	
	        $select.selected.splice(index, 1);
	        ctrl.activeMatchIndex = -1;
	        $select.sizeSearchInput();
	
	        // Give some time for scope propagation.
	        $timeout(function(){
	          $select.onRemoveCallback($scope, {
	            $item: removedChoice,
	            $model: $select.parserResult.modelMapper($scope, locals)
	          });
	        });
	
	        ctrl.updateModel();
	
	        return true;
	      };
	
	      ctrl.getPlaceholder = function(){
	        //Refactor single?
	        if($select.selected && $select.selected.length) return;
	        return $select.placeholder;
	      };
	
	
	    }],
	    controllerAs: '$selectMultiple',
	
	    link: function(scope, element, attrs, ctrls) {
	
	      var $select = ctrls[0];
	      var ngModel = scope.ngModel = ctrls[1];
	      var $selectMultiple = scope.$selectMultiple;
	
	      //$select.selected = raw selected objects (ignoring any property binding)
	
	      $select.multiple = true;
	
	      //Input that will handle focus
	      $select.focusInput = $select.searchInput;
	
	      //Properly check for empty if set to multiple
	      ngModel.$isEmpty = function(value) {
	        return !value || value.length === 0;
	      };
	
	      //From view --> model
	      ngModel.$parsers.unshift(function () {
	        var locals = {},
	            result,
	            resultMultiple = [];
	        for (var j = $select.selected.length - 1; j >= 0; j--) {
	          locals = {};
	          locals[$select.parserResult.itemName] = $select.selected[j];
	          result = $select.parserResult.modelMapper(scope, locals);
	          resultMultiple.unshift(result);
	        }
	        return resultMultiple;
	      });
	
	      // From model --> view
	      ngModel.$formatters.unshift(function (inputValue) {
	        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
	            locals = {},
	            result;
	        if (!data) return inputValue;
	        var resultMultiple = [];
	        var checkFnMultiple = function(list, value){
	          if (!list || !list.length) return;
	          for (var p = list.length - 1; p >= 0; p--) {
	            locals[$select.parserResult.itemName] = list[p];
	            result = $select.parserResult.modelMapper(scope, locals);
	            if($select.parserResult.trackByExp){
	                var propsItemNameMatches = /(\w*)\./.exec($select.parserResult.trackByExp);
	                var matches = /\.([^\s]+)/.exec($select.parserResult.trackByExp);
	                if(propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[1] == $select.parserResult.itemName){
	                  if(matches && matches.length>0 && result[matches[1]] == value[matches[1]]){
	                      resultMultiple.unshift(list[p]);
	                      return true;
	                  }
	                }
	            }
	            if (angular.equals(result,value)){
	              resultMultiple.unshift(list[p]);
	              return true;
	            }
	          }
	          return false;
	        };
	        if (!inputValue) return resultMultiple; //If ngModel was undefined
	        for (var k = inputValue.length - 1; k >= 0; k--) {
	          //Check model array of currently selected items
	          if (!checkFnMultiple($select.selected, inputValue[k])){
	            //Check model array of all items available
	            if (!checkFnMultiple(data, inputValue[k])){
	              //If not found on previous lists, just add it directly to resultMultiple
	              resultMultiple.unshift(inputValue[k]);
	            }
	          }
	        }
	        return resultMultiple;
	      });
	
	      //Watch for external model changes
	      scope.$watchCollection(function(){ return ngModel.$modelValue; }, function(newValue, oldValue) {
	        if (oldValue != newValue){
	          //update the view value with fresh data from items, if there is a valid model value
	          if(angular.isDefined(ngModel.$modelValue)) {
	            ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	          }
	          $selectMultiple.refreshComponent();
	        }
	      });
	
	      ngModel.$render = function() {
	        // Make sure that model value is array
	        if(!angular.isArray(ngModel.$viewValue)){
	          // Have tolerance for null or undefined values
	          if (isNil(ngModel.$viewValue)){
	            ngModel.$viewValue = [];
	          } else {
	            throw uiSelectMinErr('multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue);
	          }
	        }
	        $select.selected = ngModel.$viewValue;
	        $selectMultiple.refreshComponent();
	        scope.$evalAsync(); //To force $digest
	      };
	
	      scope.$on('uis:select', function (event, item) {
	        if($select.selected.length >= $select.limit) {
	          return;
	        }
	        $select.selected.push(item);
	        var locals = {};
	        locals[$select.parserResult.itemName] = item;
	
	        $timeout(function(){
	          $select.onSelectCallback(scope, {
	            $item: item,
	            $model: $select.parserResult.modelMapper(scope, locals)
	          });
	        });
	        $selectMultiple.updateModel();
	      });
	
	      scope.$on('uis:activate', function () {
	        $selectMultiple.activeMatchIndex = -1;
	      });
	
	      scope.$watch('$select.disabled', function(newValue, oldValue) {
	        // As the search input field may now become visible, it may be necessary to recompute its size
	        if (oldValue && !newValue) $select.sizeSearchInput();
	      });
	
	      $select.searchInput.on('keydown', function(e) {
	        var key = e.which;
	        scope.$apply(function() {
	          var processed = false;
	          // var tagged = false; //Checkme
	          if(KEY.isHorizontalMovement(key)){
	            processed = _handleMatchSelection(key);
	          }
	          if (processed  && key != KEY.TAB) {
	            //TODO Check si el tab selecciona aun correctamente
	            //Crear test
	            e.preventDefault();
	            e.stopPropagation();
	          }
	        });
	      });
	      function _getCaretPosition(el) {
	        if(angular.isNumber(el.selectionStart)) return el.selectionStart;
	        // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
	        else return el.value.length;
	      }
	      // Handles selected options in "multiple" mode
	      function _handleMatchSelection(key){
	        var caretPosition = _getCaretPosition($select.searchInput[0]),
	            length = $select.selected.length,
	            // none  = -1,
	            first = 0,
	            last  = length-1,
	            curr  = $selectMultiple.activeMatchIndex,
	            next  = $selectMultiple.activeMatchIndex+1,
	            prev  = $selectMultiple.activeMatchIndex-1,
	            newIndex = curr;
	
	        if(caretPosition > 0 || ($select.search.length && key == KEY.RIGHT)) return false;
	
	        $select.close();
	
	        function getNewActiveMatchIndex(){
	          switch(key){
	            case KEY.LEFT:
	              // Select previous/first item
	              if(~$selectMultiple.activeMatchIndex) return prev;
	              // Select last item
	              else return last;
	              break;
	            case KEY.RIGHT:
	              // Open drop-down
	              if(!~$selectMultiple.activeMatchIndex || curr === last){
	                $select.activate();
	                return false;
	              }
	              // Select next/last item
	              else return next;
	              break;
	            case KEY.BACKSPACE:
	              // Remove selected item and select previous/first
	              if(~$selectMultiple.activeMatchIndex){
	                if($selectMultiple.removeChoice(curr)) {
	                  return prev;
	                } else {
	                  return curr;
	                }
	
	              } else {
	                // If nothing yet selected, select last item
	                return last;
	              }
	              break;
	            case KEY.DELETE:
	              // Remove selected item and select next item
	              if(~$selectMultiple.activeMatchIndex){
	                $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
	                return curr;
	              }
	              else return false;
	          }
	        }
	
	        newIndex = getNewActiveMatchIndex();
	
	        if(!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;
	        else $selectMultiple.activeMatchIndex = Math.min(last,Math.max(first,newIndex));
	
	        return true;
	      }
	
	      $select.searchInput.on('keyup', function(e) {
	
	        if ( ! KEY.isVerticalMovement(e.which) ) {
	          scope.$evalAsync( function () {
	            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	          });
	        }
	        // Push a "create new" item into array if there is a search string
	        if ( $select.tagging.isActivated && $select.search.length > 0 ) {
	
	          // return early with these keys
	          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which) ) {
	            return;
	          }
	          // always reset the activeIndex to the first item when tagging
	          $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	          // taggingLabel === false bypasses all of this
	          if ($select.taggingLabel === false) return;
	
	          var items = angular.copy( $select.items );
	          var stashArr = angular.copy( $select.items );
	          var newItem;
	          var item;
	          var hasTag = false;
	          var dupeIndex = -1;
	          var tagItems;
	          var tagItem;
	
	          // case for object tagging via transform `$select.tagging.fct` function
	          if ( $select.tagging.fct !== undefined) {
	            tagItems = $select.$filter('filter')(items,{'isTag': true});
	            if ( tagItems.length > 0 ) {
	              tagItem = tagItems[0];
	            }
	            // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
	            if ( items.length > 0 && tagItem ) {
	              hasTag = true;
	              items = items.slice(1,items.length);
	              stashArr = stashArr.slice(1,stashArr.length);
	            }
	            newItem = $select.tagging.fct($select.search);
	            // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
	            if (
	              stashArr.some(function (origItem) {
	                 return angular.equals(origItem, newItem);
	              }) ||
	              $select.selected.some(function (origItem) {
	                return angular.equals(origItem, newItem);
	              })
	            ) {
	              scope.$evalAsync(function () {
	                $select.activeIndex = 0;
	                $select.items = items;
	              });
	              return;
	            }
	            if (newItem) newItem.isTag = true;
	          // handle newItem string and stripping dupes in tagging string context
	          } else {
	            // find any tagging items already in the $select.items array and store them
	            tagItems = $select.$filter('filter')(items,function (item) {
	              return item.match($select.taggingLabel);
	            });
	            if ( tagItems.length > 0 ) {
	              tagItem = tagItems[0];
	            }
	            item = items[0];
	            // remove existing tag item if found (should only ever be one tag item)
	            if ( item !== undefined && items.length > 0 && tagItem ) {
	              hasTag = true;
	              items = items.slice(1,items.length);
	              stashArr = stashArr.slice(1,stashArr.length);
	            }
	            newItem = $select.search+' '+$select.taggingLabel;
	            if ( _findApproxDupe($select.selected, $select.search) > -1 ) {
	              return;
	            }
	            // verify the the tag doesn't match the value of an existing item from
	            // the searched data set or the items already selected
	            if ( _findCaseInsensitiveDupe(stashArr.concat($select.selected)) ) {
	              // if there is a tag from prev iteration, strip it / queue the change
	              // and return early
	              if ( hasTag ) {
	                items = stashArr;
	                scope.$evalAsync( function () {
	                  $select.activeIndex = 0;
	                  $select.items = items;
	                });
	              }
	              return;
	            }
	            if ( _findCaseInsensitiveDupe(stashArr) ) {
	              // if there is a tag from prev iteration, strip it
	              if ( hasTag ) {
	                $select.items = stashArr.slice(1,stashArr.length);
	              }
	              return;
	            }
	          }
	          if ( hasTag ) dupeIndex = _findApproxDupe($select.selected, newItem);
	          // dupe found, shave the first item
	          if ( dupeIndex > -1 ) {
	            items = items.slice(dupeIndex+1,items.length-1);
	          } else {
	            items = [];
	            if (newItem) items.push(newItem);
	            items = items.concat(stashArr);
	          }
	          scope.$evalAsync( function () {
	            $select.activeIndex = 0;
	            $select.items = items;
	
	            if ($select.isGrouped) {
	              // update item references in groups, so that indexOf will work after angular.copy
	              var itemsWithoutTag = newItem ? items.slice(1) : items;
	              $select.setItemsFn(itemsWithoutTag);
	              if (newItem) {
	                // add tag item as a new group
	                $select.items.unshift(newItem);
	                $select.groups.unshift({name: '', items: [newItem], tagging: true});
	              }
	            }
	          });
	        }
	      });
	      function _findCaseInsensitiveDupe(arr) {
	        if ( arr === undefined || $select.search === undefined ) {
	          return false;
	        }
	        var hasDupe = arr.filter( function (origItem) {
	          if ( $select.search.toUpperCase() === undefined || origItem === undefined ) {
	            return false;
	          }
	          return origItem.toUpperCase() === $select.search.toUpperCase();
	        }).length > 0;
	
	        return hasDupe;
	      }
	      function _findApproxDupe(haystack, needle) {
	        var dupeIndex = -1;
	        if(angular.isArray(haystack)) {
	          var tempArr = angular.copy(haystack);
	          for (var i = 0; i <tempArr.length; i++) {
	            // handle the simple string version of tagging
	            if ( $select.tagging.fct === undefined ) {
	              // search the array for the match
	              if ( tempArr[i]+' '+$select.taggingLabel === needle ) {
	              dupeIndex = i;
	              }
	            // handle the object tagging implementation
	            } else {
	              var mockObj = tempArr[i];
	              if (angular.isObject(mockObj)) {
	                mockObj.isTag = true;
	              }
	              if ( angular.equals(mockObj, needle) ) {
	                dupeIndex = i;
	              }
	            }
	          }
	        }
	        return dupeIndex;
	      }
	
	      $select.searchInput.on('blur', function() {
	        $timeout(function() {
	          $selectMultiple.activeMatchIndex = -1;
	        });
	      });
	
	    }
	  };
	}]);
	
	uis.directive('uiSelectNoChoice',
	    ['uiSelectConfig', function (uiSelectConfig) {
	        return {
	            restrict: 'EA',
	            require: '^uiSelect',
	            replace: true,
	            transclude: true,
	            templateUrl: function (tElement) {
	                // Needed so the uiSelect can detect the transcluded content
	                tElement.addClass('ui-select-no-choice');
	      
	                // Gets theme attribute from parent (ui-select)
	                var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	                return theme + '/no-choice.tpl.html';
	            }
	        };
	    }]);
	
	uis.directive('uiSelectSingle', ['$timeout','$compile', function($timeout, $compile) {
	  return {
	    restrict: 'EA',
	    require: ['^uiSelect', '^ngModel'],
	    link: function(scope, element, attrs, ctrls) {
	
	      var $select = ctrls[0];
	      var ngModel = ctrls[1];
	
	      //From view --> model
	      ngModel.$parsers.unshift(function (inputValue) {
	        // Keep original value for undefined and null
	        if (isNil(inputValue)) {
	          return inputValue;
	        }
	
	        var locals = {},
	            result;
	        locals[$select.parserResult.itemName] = inputValue;
	        result = $select.parserResult.modelMapper(scope, locals);
	        return result;
	      });
	
	      //From model --> view
	      ngModel.$formatters.unshift(function (inputValue) {
	        // Keep original value for undefined and null
	        if (isNil(inputValue)) {
	          return inputValue;
	        }
	
	        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
	            locals = {},
	            result;
	        if (data){
	          var checkFnSingle = function(d){
	            locals[$select.parserResult.itemName] = d;
	            result = $select.parserResult.modelMapper(scope, locals);
	            return result === inputValue;
	          };
	          //If possible pass same object stored in $select.selected
	          if ($select.selected && checkFnSingle($select.selected)) {
	            return $select.selected;
	          }
	          for (var i = data.length - 1; i >= 0; i--) {
	            if (checkFnSingle(data[i])) return data[i];
	          }
	        }
	        return inputValue;
	      });
	
	      //Update viewValue if model change
	      scope.$watch('$select.selected', function(newValue) {
	        if (ngModel.$viewValue !== newValue) {
	          ngModel.$setViewValue(newValue);
	        }
	      });
	
	      ngModel.$render = function() {
	        $select.selected = ngModel.$viewValue;
	      };
	
	      scope.$on('uis:select', function (event, item) {
	        $select.selected = item;
	        var locals = {};
	        locals[$select.parserResult.itemName] = item;
	
	        $timeout(function() {
	          $select.onSelectCallback(scope, {
	            $item: item,
	            $model: isNil(item) ? item : $select.parserResult.modelMapper(scope, locals)
	          });
	        });
	      });
	
	      scope.$on('uis:close', function (event, skipFocusser) {
	        $timeout(function(){
	          $select.focusser.prop('disabled', false);
	          if (!skipFocusser) $select.focusser[0].focus();
	        },0,false);
	      });
	
	      scope.$on('uis:activate', function () {
	        focusser.prop('disabled', true); //Will reactivate it on .close()
	      });
	
	      //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
	      var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
	      $compile(focusser)(scope);
	      $select.focusser = focusser;
	
	      //Input that will handle focus
	      $select.focusInput = focusser;
	
	      element.parent().append(focusser);
	      focusser.bind("focus", function(){
	        scope.$evalAsync(function(){
	          $select.focus = true;
	        });
	      });
	      focusser.bind("blur", function(){
	        scope.$evalAsync(function(){
	          $select.focus = false;
	        });
	      });
	      focusser.bind("keydown", function(e){
	
	        if (e.which === KEY.BACKSPACE && $select.backspaceReset !== false) {
	          e.preventDefault();
	          e.stopPropagation();
	          $select.select(undefined);
	          scope.$apply();
	          return;
	        }
	
	        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	          return;
	        }
	
	        if (e.which == KEY.DOWN  || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE){
	          e.preventDefault();
	          e.stopPropagation();
	          $select.activate();
	        }
	
	        scope.$digest();
	      });
	
	      focusser.bind("keyup input", function(e){
	
	        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
	          return;
	        }
	
	        $select.activate(focusser.val()); //User pressed some regular key, so we pass it to the search input
	        focusser.val('');
	        scope.$digest();
	
	      });
	
	
	    }
	  };
	}]);
	
	// Make multiple matches sortable
	uis.directive('uiSelectSort', ['$timeout', 'uiSelectConfig', 'uiSelectMinErr', function($timeout, uiSelectConfig, uiSelectMinErr) {
	  return {
	    require: ['^^uiSelect', '^ngModel'],
	    link: function(scope, element, attrs, ctrls) {
	      if (scope[attrs.uiSelectSort] === null) {
	        throw uiSelectMinErr('sort', 'Expected a list to sort');
	      }
	
	      var $select = ctrls[0];
	      var $ngModel = ctrls[1];
	
	      var options = angular.extend({
	          axis: 'horizontal'
	        },
	        scope.$eval(attrs.uiSelectSortOptions));
	
	      var axis = options.axis;
	      var draggingClassName = 'dragging';
	      var droppingClassName = 'dropping';
	      var droppingBeforeClassName = 'dropping-before';
	      var droppingAfterClassName = 'dropping-after';
	
	      scope.$watch(function(){
	        return $select.sortable;
	      }, function(newValue){
	        if (newValue) {
	          element.attr('draggable', true);
	        } else {
	          element.removeAttr('draggable');
	        }
	      });
	
	      element.on('dragstart', function(event) {
	        element.addClass(draggingClassName);
	
	        (event.dataTransfer || event.originalEvent.dataTransfer).setData('text', scope.$index.toString());
	      });
	
	      element.on('dragend', function() {
	        removeClass(draggingClassName);
	      });
	
	      var move = function(from, to) {
	        /*jshint validthis: true */
	        this.splice(to, 0, this.splice(from, 1)[0]);
	      };
	
	      var removeClass = function(className) {
	        angular.forEach($select.$element.querySelectorAll('.' + className), function(el){
	          angular.element(el).removeClass(className);
	        });
	      };
	
	      var dragOverHandler = function(event) {
	        event.preventDefault();
	
	        var offset = axis === 'vertical' ? event.offsetY || event.layerY || (event.originalEvent ? event.originalEvent.offsetY : 0) : event.offsetX || event.layerX || (event.originalEvent ? event.originalEvent.offsetX : 0);
	
	        if (offset < (this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2)) {
	          removeClass(droppingAfterClassName);
	          element.addClass(droppingBeforeClassName);
	
	        } else {
	          removeClass(droppingBeforeClassName);
	          element.addClass(droppingAfterClassName);
	        }
	      };
	
	      var dropTimeout;
	
	      var dropHandler = function(event) {
	        event.preventDefault();
	
	        var droppedItemIndex = parseInt((event.dataTransfer || event.originalEvent.dataTransfer).getData('text'), 10);
	
	        // prevent event firing multiple times in firefox
	        $timeout.cancel(dropTimeout);
	        dropTimeout = $timeout(function() {
	          _dropHandler(droppedItemIndex);
	        }, 20);
	      };
	
	      var _dropHandler = function(droppedItemIndex) {
	        var theList = scope.$eval(attrs.uiSelectSort);
	        var itemToMove = theList[droppedItemIndex];
	        var newIndex = null;
	
	        if (element.hasClass(droppingBeforeClassName)) {
	          if (droppedItemIndex < scope.$index) {
	            newIndex = scope.$index - 1;
	          } else {
	            newIndex = scope.$index;
	          }
	        } else {
	          if (droppedItemIndex < scope.$index) {
	            newIndex = scope.$index;
	          } else {
	            newIndex = scope.$index + 1;
	          }
	        }
	
	        move.apply(theList, [droppedItemIndex, newIndex]);
	
	        $ngModel.$setViewValue(Date.now());
	
	        scope.$apply(function() {
	          scope.$emit('uiSelectSort:change', {
	            array: theList,
	            item: itemToMove,
	            from: droppedItemIndex,
	            to: newIndex
	          });
	        });
	
	        removeClass(droppingClassName);
	        removeClass(droppingBeforeClassName);
	        removeClass(droppingAfterClassName);
	
	        element.off('drop', dropHandler);
	      };
	
	      element.on('dragenter', function() {
	        if (element.hasClass(draggingClassName)) {
	          return;
	        }
	
	        element.addClass(droppingClassName);
	
	        element.on('dragover', dragOverHandler);
	        element.on('drop', dropHandler);
	      });
	
	      element.on('dragleave', function(event) {
	        if (event.target != element) {
	          return;
	        }
	
	        removeClass(droppingClassName);
	        removeClass(droppingBeforeClassName);
	        removeClass(droppingAfterClassName);
	
	        element.off('dragover', dragOverHandler);
	        element.off('drop', dropHandler);
	      });
	    }
	  };
	}]);
	
	uis.directive('uisOpenClose', ['$parse', '$timeout', function ($parse, $timeout) {
	  return {
	    restrict: 'A',
	    require: 'uiSelect',
	    link: function (scope, element, attrs, $select) {
	      $select.onOpenCloseCallback = $parse(attrs.uisOpenClose);
	
	      scope.$watch('$select.open', function (isOpen, previousState) {
	        if (isOpen !== previousState) {
	          $timeout(function () {
	            $select.onOpenCloseCallback(scope, {
	              isOpen: isOpen
	            });
	          });
	        }
	      });
	    }
	  };
	}]);
	
	/**
	 * Parses "repeat" attribute.
	 *
	 * Taken from AngularJS ngRepeat source code
	 * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
	 *
	 * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
	 * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
	 */
	
	uis.service('uisRepeatParser', ['uiSelectMinErr','$parse', function(uiSelectMinErr, $parse) {
	  var self = this;
	
	  /**
	   * Example:
	   * expression = "address in addresses | filter: {street: $select.search} track by $index"
	   * itemName = "address",
	   * source = "addresses | filter: {street: $select.search}",
	   * trackByExp = "$index",
	   */
	  self.parse = function(expression) {
	
	
	    var match;
	    //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
	    // If an array is used as collection
	
	    // if (isObjectCollection){
	    // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
	    match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	    // 1 Alias
	    // 2 Item
	    // 3 Key on (key,value)
	    // 4 Value on (key,value)
	    // 5 Source expression (including filters)
	    // 6 Track by
	
	    if (!match) {
	      throw uiSelectMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
	              expression);
	    }
	    
	    var source = match[5], 
	        filters = '';
	
	    // When using (key,value) ui-select requires filters to be extracted, since the object
	    // is converted to an array for $select.items 
	    // (in which case the filters need to be reapplied)
	    if (match[3]) {
	      // Remove any enclosing parenthesis
	      source = match[5].replace(/(^\()|(\)$)/g, '');
	      // match all after | but not after ||
	      var filterMatch = match[5].match(/^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/);
	      if(filterMatch && filterMatch[1].trim()) {
	        filters = filterMatch[1];
	        source = source.replace(filters, '');
	      }      
	    }
	
	    return {
	      itemName: match[4] || match[2], // (lhs) Left-hand side,
	      keyName: match[3], //for (key, value) syntax
	      source: $parse(source),
	      filters: filters,
	      trackByExp: match[6],
	      modelMapper: $parse(match[1] || match[4] || match[2]),
	      repeatExpression: function (grouped) {
	        var expression = this.itemName + ' in ' + (grouped ? '$group.items' : '$select.items');
	        if (this.trackByExp) {
	          expression += ' track by ' + this.trackByExp;
	        }
	        return expression;
	      } 
	    };
	
	  };
	
	  self.getGroupNgRepeatExpression = function() {
	    return '$group in $select.groups track by $group.name';
	  };
	
	}]);
	
	}());
	angular.module("ui.select").run(["$templateCache", function($templateCache) {$templateCache.put("bootstrap/choices.tpl.html","<ul class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\" ng-show=\"$select.open && $select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><span class=\"ui-select-choices-row-inner\"></span></div></li></ul>");
	$templateCache.put("bootstrap/match-multiple.tpl.html","<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected track by $index\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
	$templateCache.put("bootstrap/match.tpl.html","<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
	$templateCache.put("bootstrap/no-choice.tpl.html","<ul class=\"ui-select-no-choice dropdown-menu\" ng-show=\"$select.items.length == 0\"><li ng-transclude=\"\"></li></ul>");
	$templateCache.put("bootstrap/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" role=\"combobox\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{$select.baseTitle}}\" ng-class=\"{\'spinner\': $select.refreshing}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("bootstrap/select.tpl.html","<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><span ng-show=\"$select.open && $select.refreshing && $select.spinnerEnabled\" class=\"ui-select-refreshing {{$select.spinnerClass}}\"></span> <input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" class=\"form-control ui-select-search\" ng-class=\"{ \'ui-select-search-hidden\' : !$select.searchEnabled }\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("select2/choices.tpl.html","<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
	$templateCache.put("select2/match-multiple.tpl.html","<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected track by $index\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
	$templateCache.put("select2/match.tpl.html","<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>");
	$templateCache.put("select2/no-choice.tpl.html","<div class=\"ui-select-no-choice dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	$templateCache.put("select2/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
	$templateCache.put("select2/select.tpl.html","<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"search-container\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled, \'select2-search\':$select.searchEnabled}\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" ng-class=\"{\'select2-active\': $select.refreshing}\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div></div>");
	$templateCache.put("selectize/choices.tpl.html","<div ng-show=\"$select.open\" class=\"ui-select-choices ui-select-dropdown selectize-dropdown\" ng-class=\"{\'single\': !$select.multiple, \'multi\': $select.multiple}\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-bind=\"$group.name\"></div><div role=\"option\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\" data-selectable=\"\"></div></div></div></div></div>");
	$templateCache.put("selectize/match-multiple.tpl.html","<div class=\"ui-select-match\" data-value=\"\" ng-repeat=\"$item in $select.selected track by $index\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'active\':$selectMultiple.activeMatchIndex === $index}\" ui-select-sort=\"$select.selected\"><span class=\"ui-select-match-item\" ng-class=\"{\'select-locked\':$select.isLocked(this, $index)}\"><span uis-transclude-append=\"\"></span> <span class=\"remove ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&times;</span></span></div>");
	$templateCache.put("selectize/match.tpl.html","<div ng-hide=\"$select.searchEnabled && ($select.open || $select.isEmpty())\" class=\"ui-select-match\"><span ng-show=\"!$select.searchEnabled && ($select.isEmpty() || $select.open)\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty() || $select.open\" ng-transclude=\"\"></span></div>");
	$templateCache.put("selectize/no-choice.tpl.html","<div class=\"ui-select-no-choice selectize-dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"selectize-dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	$templateCache.put("selectize/select-multiple.tpl.html","<div class=\"ui-select-container selectize-control multi plugin-remove_button\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-model=\"$select.search\" ng-disabled=\"$select.disabled\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{ $select.baseTitle }}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("selectize/select.tpl.html","<div class=\"ui-select-container selectize-control single\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-hide=\"!$select.isEmpty() && !$select.open\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");}]);

/***/ }),

/***/ 992:
983,

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(995);
	__webpack_require__(996);

/***/ }),

/***/ 995:
/***/ (function(module, exports) {

	/**
	 * @license ng-notify v0.8.0
	 * http://matowens.github.io/ng-notify
	 * (c) 2014-2016 MIT License, MatOwens.com
	 */
	(function() {
	    'use strict';
	
	    /**
	     * @description
	     *
	     * This module provides any AngularJS application with a simple, lightweight
	     * system for displaying notifications of varying degree to it's users.
	     *
	     */
	    var module = angular.module('ngNotify', []);
	
	    /**
	     * Cache template in run block.
	     */
	    module.run(['$templateCache', ngNotifyCache]);
	
	    /**
	     * Notifcation instances, visibility functionality, and post notification cleanup.
	     */
	    module.factory('NgNotifyFactory', ['$interval', ngNotifyFactory]);
	
	    /**
	     * Notification configuration, management, and API exposure.
	     */
	    module.provider('ngNotify', NgNotifyService);
	
	    /**
	     *              _   _       _   _  __
	     *  _ __   __ _| \ | | ___ | |_(_)/ _|_   _
	     * | '_ \ / _` |  \| |/ _ \| __| | |_| | | |
	     * | | | | (_| | |\  | (_) | |_| |  _| |_| |
	     * |_| |_|\__, |_| \_|\___/ \__|_|_|  \__, |
	     *        |___/                       |___/
	     */
	
	    /**
	     * Check to see if the ngSanitize script has been included by the user.
	     * If so, pull it in and allow for it to be used when user has specified.
	     */
	    var hasSanitize = false;
	
	    // Constants...
	
	    var TEMPLATE = 'templates/ng-notify/ng-notify.html';
	
	    var EMPTY = '';
	    var SPACER = ' ';
	    var STICKY_CLASS = 'ngn-sticky';
	    var COMPONENT_CLASS = 'ngn-component';
	    var SELECTOR = 'body';
	    var DEFAULT_DURATION = 3000;
	
	    var FADE_OUT_DURATION = 500;
	    var FADE_INTERVAL = 25;
	    var FADE_IN_MODE = 1;
	    var FADE_OUT_MODE = -1;
	    var FADE_IN_DURATION = 200;
	
	    var OPACITY_MIN = 0;
	    var OPACITY_MAX = 1;
	
	    try {
	
	        /* istanbul ignore else  */
	        if (angular.module('ngSanitize')) {
	
	            // Note on the requires array from module() source code:
	            // Holds the list of modules which the injector will load before the current module is loaded.
	
	            // A sort of lazy load for our dependency on ngSanitize, only if the module exists.
	            angular.module('ngNotify').requires.push('ngSanitize');
	
	            hasSanitize = true;
	        }
	
	    } catch (err) {
	        // Ignore error, we'll disable any sanitize related functionality...
	    }
	
	    /**
	     * Generate ngNotify template and add it to our cache.
	     *
	     * @param {Object} $templateCache -
	     */
	    function ngNotifyCache($templateCache) {
	
	        var html =
	            '<div class="ngn" ng-class="ngNotify.notifyClass">' +
	                '<span ng-if="ngNotify.notifyHtml" class="ngn-message" ng-bind-html="ngNotify.notifyMessage"></span>' + // Display HTML notifications.
	                '<span ng-if="!ngNotify.notifyHtml" class="ngn-message" ng-bind="ngNotify.notifyMessage"></span>' + // Display escaped notifications.
	                '<span ng-show="ngNotify.notifyButton" class="ngn-dismiss" ng-click="dismiss()">&times;</span>' +
	            '</div>';
	
	        $templateCache.put(TEMPLATE, html);
	    }
	
	    /**
	     * Class that handles the visual display of our notificaitons and is
	     * responsible for handling clean up for each notification when
	     * it's time has run it's course.
	     *
	     * @returns {NgNotifyFactory}
	     */
	    function ngNotifyFactory($interval) {
	
	        var notifyInterval;
	
	        function NgNotifyFactory(scope, template, options) {
	            this.scope = scope;
	            this.options = options;
	            this.template = fadeLib(template);
	        }
	
	        NgNotifyFactory.prototype = {
	
	            /**
	             * Triggers a fade in, opacity from 0 to 1.
	             *
	             * @param  {Function} callback - function to invoke once fade has completed.
	             */
	            show: function(callback) {
	                this.template.fadeIn(FADE_IN_DURATION, callback);
	            },
	
	            /**
	             * Triggers a fade out, opacity from 1 to 0.
	             *
	             * @param {Function} callback - function to invoke once fade has completed.
	             */
	            dismiss: function() {
	                this.template.fadeOut(FADE_OUT_DURATION, this.destroy.bind(this));
	            },
	
	            /**
	             * Destroys our notification and triggers the callback if provided.
	             */
	            destroy: function() {
	
	                $interval.cancel(notifyInterval);
	
	                if (this.options && this.options.userCallback) {
	                    this.options.userCallback();
	                }
	
	                if (this.scope) {
	                    this.scope.$destroy();
	                }
	
	                if (this.template) {
	                    this.template.el.remove();
	                }
	
	                this.scope = null;
	                this.options = null;
	                this.template = null;
	            }
	        };
	
	        // Pure JS fade functionality...
	
	        /**
	         * Triggers our constructor to add our fade prototypes to our element.
	         *
	         * @param  {Object} el - an element generated by our own template and bound to it's own scope.
	         *
	         * @return {Object} - our element along with new fade prototype methods.
	         */
	        var fadeLib = function(el) {
	            return new fadeLib.fn(el);
	        };
	
	        /**
	         * Our constructor that will allow us to invoke a fade on our element.
	         *
	         * @param {Object} el - an element generated by our own template and bound to it's own scope.
	         */
	        fadeLib.fn = function(el) {
	            this.el = el;
	        };
	
	        /**
	         * Handles the fading functionality and the duration for each fade.
	         *
	         * @param {Number}   mode     - used to trigger fade in or out, adds or subtracts opacity until visible or hidden.
	         * @param {Number}   opacity  - initial opacity for our element.
	         * @param {Number}   duration - how long the fade should take to complete, in ms.
	         * @param {Function} callback - function to invoke once our fade is complete.
	         */
	        fadeLib.fn.prototype._fade = function(mode, opacity, duration, callback) {
	
	            var gap = FADE_INTERVAL / duration;
	            var el = this.el;
	
	            el.css('opacity', opacity);
	
	            var func = function() {
	
	                opacity = opacity + mode * gap;
	
	                el.css('opacity', opacity);
	
	                if (opacity <= OPACITY_MIN || opacity >= OPACITY_MAX) {
	                    $interval.cancel(notifyInterval);
	
	                    if (opacity <= OPACITY_MIN) {
	                        el.css('display', 'none');
	                    }
	
	                    if (callback) {
	                        callback();
	                    }
	                }
	            };
	
	            notifyInterval = $interval(func, FADE_INTERVAL);
	        };
	
	        /**
	         * Triggers a fade in, opacity from 0 to 1.
	         *
	         * @param  {Number}   duration - how long the fade should take to complete, in ms.
	         * @param  {Function} callback - function to invoke once fade has completed.
	         */
	        fadeLib.fn.prototype.fadeIn = function(duration, callback) {
	            this.el.css('display', 'block');
	            this._fade(FADE_IN_MODE, OPACITY_MIN, duration, callback);
	        };
	
	        /**
	         * Triggers a fade out, opacity from 1 to 0.
	         *
	         * @param {Number}   duration - how long the fade should take to complete, in ms.
	         * @param {Function} callback - function to invoke once fade has completed.
	         */
	        fadeLib.fn.prototype.fadeOut = function(duration, callback) {
	            this._fade(FADE_OUT_MODE, OPACITY_MAX, duration, callback);
	        };
	
	        return NgNotifyFactory;
	    }
	
	    /**
	     * Our notification service that reads our user's configuration options and spins
	     * up new notification instances while providing the API for managing those
	     * notifications within our user's app.
	     */
	    function NgNotifyService() {
	
	        this.$get = ['$document', '$compile', '$log', '$rootScope', '$timeout', '$templateCache', 'NgNotifyFactory',
	
	            function($document, $compile, $log, $rootScope, $timeout, $templateCache, NgNotifyFactory) {
	
	                var notification;
	                var notifyTimeout;
	
	                // Defaults...
	
	                var DEFAULT_OPTIONS = {
	                    theme: 'pure',
	                    position: 'bottom',
	                    duration: DEFAULT_DURATION,
	                    type: 'info',
	                    sticky: false,
	                    button: true,
	                    html: false,
	                    target: SELECTOR
	                };
	
	                var DEFAULT_SCOPE = {
	                    notifyClass: '',
	                    notifyMessage: ''
	                };
	
	                // Options...
	
	                var THEMES = {
	                    pure: EMPTY,
	                    prime: 'ngn-prime',
	                    pastel: 'ngn-pastel',
	                    pitchy: 'ngn-pitchy'
	                };
	
	                var TYPES = {
	                    info: 'ngn-info',
	                    error: 'ngn-error',
	                    success: 'ngn-success',
	                    warn: 'ngn-warn',
	                    grimace: 'ngn-grimace'
	                };
	
	                var POSITIONS = {
	                    bottom: 'ngn-bottom',
	                    top: 'ngn-top'
	                };
	
	                // Private methods...
	
	                /**
	                 * Creates a new scope for our notification.
	                 *
	                 * @returns {Object}
	                 */
	                var scopeInit = function() {
	
	                    var scope = $rootScope.$new();
	
	                    // Setup scope with our default notify* params.
	                    scope.ngNotify = angular.extend({}, DEFAULT_SCOPE);
	
	                    // Adds dismiss functionality to our scope for button click.
	                    scope.dismiss = function() {
	                        dismiss();
	                    };
	
	                    return scope;
	                };
	
	                /**
	                 * Initializes a new Notify object.
	                 *
	                 * @param {String}                   message - the message our notification will display to the user.
	                 * @param {String|Object|undefined}  userOpt - optional parameter that contains the type or an object of options used to configure this notification.
	                 * @param {Function|null}            callback - optional method to fire after we've shown, faded, and removed our notification.
	                 *
	                 * @returns {Notify}
	                 */
	                var notifyInit = function(message, userOpt, callback) {
	
	                    var userOpts = {};
	                    var notifyScope = scopeInit();
	
	                    // User either provides an object of options
	                    // or a string specifying the type.
	                    if (typeof userOpt === 'object') {
	                        userOpts = userOpt;
	                    } else {
	                        userOpts.type = userOpt;
	                    }
	
	                    var notifyTarget = getTarget(userOpts);
	
	                    var notifyOptions = {
	                        isSticky: getSticky(userOpts),
	                        duration: getDuration(userOpts),
	                        userCallback: callback
	                    };
	
	                    angular.extend(notifyScope.ngNotify, {
	                        notifyHtml: getHtml(userOpts),
	                        notifyClass: getClasses(userOpts, notifyOptions.isSticky, notifyTarget.found),
	                        notifyButton: showButton(userOpts, notifyOptions.isSticky),
	                        notifyMessage: message
	                    });
	
	                    var template = $compile(
	                        $templateCache.get(TEMPLATE)
	                    )(notifyScope);
	
	                    notifyTarget.target.append(template);
	
	                    return new NgNotifyFactory(notifyScope, template, notifyOptions);
	                };
	
	                /**
	                 * Gets what type of notification do display, eg, error, warning, etc.
	                 *
	                 * @param {Object} userOpts - object containing user defined options.
	                 *
	                 * @return {String} - the type that will be assigned to this notification.
	                 */
	                var getType = function(userOpts) {
	                    var type = userOpts.type || DEFAULT_OPTIONS.type;
	                    return (TYPES[type] || TYPES.info) + SPACER;
	                };
	
	                /**
	                 * Gets the theme for a notification, eg, pure, pastel, etc.
	                 *
	                 * @param {Object} userOpts - object containing user defined options.
	                 *
	                 * @return {String} - the theme that will be assigned to this notification.
	                 */
	                var getTheme = function(userOpts) {
	                    var theme = userOpts.theme || DEFAULT_OPTIONS.theme;
	                    return (THEMES[theme] || THEMES.pure) + SPACER;
	                };
	
	                /**
	                 * Gets the position of the notification, eg, top or bottom.
	                 *
	                 * @param {Object} userOpts - object containing user defined options.
	                 *
	                 * @return {String} - the position that will be assigned to this notification.
	                 */
	                var getPosition = function(userOpts) {
	                    var position = userOpts.position || DEFAULT_OPTIONS.position;
	                    return (POSITIONS[position] || POSITIONS.bottom) + SPACER;
	                };
	
	                /**
	                 * Gets how long (in ms) to display the notification for.
	                 *
	                 * @param {Object} userOpts - object containing user defined options.
	                 *
	                 * @return {Number} - the number of ms a fade on this notification will last.
	                 */
	                var getDuration = function(userOpts) {
	                    var duration = userOpts.duration || DEFAULT_OPTIONS.duration;
	                    return angular.isNumber(duration) ? duration : DEFAULT_DURATION;
	                };
	
	                /**
	                 * Gets our notification's sticky state, forcing manual dismissal when true.
	                 *
	                 * @param {Object} userOpts - object containing user defined options.
	                 *
	                 * @return {Boolean} - whether we'll be showing a sticky notification or not.
	                 */
	                var getSticky = function(userOpts) {
	                    var sticky = userOpts.sticky !== undefined ? userOpts.sticky : DEFAULT_OPTIONS.sticky;
	                    return sticky ? true : false;
	                };
	
	                /**
	                 * Gets whether or not we'd like to show the close button on our sticky notification.
	                 * Notification is required to be sticky.
	                 *
	                 * @param {Object} userOpts - object containing user defined options.
	                 * @param {Boolean} isSticky - bool whether we'll be showing a sticky notification or not.
	                 *
	                 * @returns {Boolean} - whether or now we should display the close button.
	                 */
	                var showButton = function(userOpts, isSticky) {
	                    var showButton = userOpts.button !== undefined ? userOpts.button : DEFAULT_OPTIONS.button;
	                    return showButton && isSticky;
	                };
	
	                /**
	                 * Gets the selector for where we'd like to place our notification.
	                 *
	                 * @param {Object} userOpts - object containing user defined options.
	                 *
	                 * @returns {String}
	                 */
	                var getSelector = function(userOpts) {
	                    return userOpts.target || DEFAULT_OPTIONS.target;
	                };
	
	                /**
	                 * Gets whether or not to allow HTML binding via ngSanitize.
	                 * Check to make sure ngSanitize is included in the project and warn the user if it's not.
	                 *
	                 * @param {Object} userOpts - object containing user defined options.
	                 *
	                 * @return {Boolean} - whether we'll be using ng-bind-html or not.
	                 */
	                var getHtml = function(userOpts) {
	
	                    /* istanbul ignore if  */
	                    if ((userOpts.html || DEFAULT_OPTIONS.html) && !hasSanitize) {
	
	                        $log.debug(
	                            "ngNotify warning:\nngSanitize couldn't be located.  In order to use the " +
	                            "'html' option, be sure the ngSanitize source is included in your project."
	                        );
	
	                        return false;
	                    }
	
	                    var html = userOpts.html !== undefined ? userOpts.html : DEFAULT_OPTIONS.html;
	                    return html ? true : false;
	                };
	
	                /**
	                 * Grabs all of the classes that our notification will need in order to display properly.
	                 *
	                 * @param {Object}  userOpts - object containing user defined options.
	                 * @param {Boolean} isSticky - optional bool indicating if the message is sticky or not.
	                 * @param {Boolean} foundTarget - optional bool indicating that we've found the user's target container.
	                 *
	                 * @returns {string}
	                 */
	                var getClasses = function(userOpts, isSticky, foundTarget) {
	
	                    var classes = getType(userOpts) +
	                        getTheme(userOpts) +
	                        getPosition(userOpts);
	
	                    classes += isSticky ? STICKY_CLASS + SPACER : EMPTY;
	                    classes += getSelector(userOpts) !== SELECTOR && foundTarget ? COMPONENT_CLASS + SPACER : EMPTY;
	
	                    return classes;
	                };
	
	                /**
	                 * Grabs the element that we'd like to attach our notification to.
	                 *
	                 * @param {Object} userOpts - object containing user defined options.
	                 *
	                 * @returns {Object}
	                 */
	                var getTarget = function(userOpts) {
	
	                    var target = document.querySelector(
	                        getSelector(userOpts)
	                    );
	
	                    if (target) {
	                        return {
	                            target: angular.element(target),
	                            found: true
	                        };
	                    }
	
	                    return {
	                        target: angular.element(
	                            document.querySelector(SELECTOR)
	                        ),
	                        found: false
	                    };
	                };
	
	                /**
	                 * Handles our notification after we've shown it.
	                 */
	                var afterShow = function() {
	
	                    if (notification.options.isSticky) {
	                        return;
	                    }
	
	                    notifyTimeout = $timeout(function() {
	                        notification.dismiss();
	                    }, notification.options.duration);
	                };
	
	                /**
	                 * Dismisses our notification.
	                 */
	                var dismiss = function() {
	
	                    if (!notification) {
	                        return;
	                    }
	
	                    notification.dismiss();
	                };
	
	                /**
	                 * Cleans up an existing notification.
	                 *
	                 * @param {NgNotifyFactory|Null} notification - object containing our notification or false.
	                 */
	                var clearResidue = function(notification) {
	
	                    $timeout.cancel(notifyTimeout);
	
	                    if (!notification) {
	                        return;
	                    }
	
	                    if (notification.scope) {
	                        notification.destroy();
	                    }
	
	                    notification = null;
	                };
	
	                /**
	                 * Our primary object containing all public API methods and allows for all our functionality to be invoked.
	                 *
	                 * @type {Object}
	                 */
	                return {
	
	                    /**
	                     * Merges our user specified options with our default set of options.
	                     *
	                     * @param {Object} params - object of user provided options to configure notifications.
	                     */
	                    config: function(params) {
	                        params = params || {};
	                        angular.extend(DEFAULT_OPTIONS, params);
	                    },
	
	                    /**
	                     * Sets, configures and displays each notification.
	                     *
	                     * @param {String}                   message - the message our notification will display to the user.
	                     * @param {String|Object|undefined}  userOpt - optional parameter that contains the type or an object of options used to configure this notification.
	                     * @param {Function|null}            callback - optional method to fire after we've shown and removed our notification.
	                     */
	                    set: function(message, userOpt, callback) {
	
	                        if (!message) {
	                            return;
	                        }
	
	                        // Clean up any lingering, unfinished notifications.
	                        clearResidue(notification);
	
	                        // Build our new notification.
	                        notification = notifyInit(message, userOpt, callback);
	
	                        // Handle the display of our notification.
	                        notification.show(afterShow);
	                    },
	
	                    /**
	                     * Allows a developer to manually dismiss a notification that may be
	                     * set to sticky, when the message is no longer warranted.
	                     */
	                    dismiss: function() {
	                        dismiss();
	                    },
	
	                    // User customizations...
	
	                    /**
	                     * Adds a new, user specified theme to our notification system
	                     * that they can then use throughout their application.
	                     *
	                     * @param {String} themeName  - the name for this new theme that will be used when applying it via configuration.
	                     * @param {String} themeClass - the class that this theme will use when applying it's styles.
	                     */
	                    addTheme: function(themeName, themeClass) {
	
	                        if (!themeName || !themeClass) {
	                            return;
	                        }
	
	                        THEMES[themeName] = themeClass;
	                    },
	
	                    /**
	                     * Adds a new, user specified notification type that they
	                     * can then use throughout their application.
	                     *
	                     * @param {String} typeName  - the name for this new type that will be used when applying it via configuration.
	                     * @param {String} typeClass - the class that this type will use when applying it's styles.
	                     */
	                    addType: function(typeName, typeClass) {
	
	                        if (!typeName || !typeClass) {
	                            return;
	                        }
	
	                        TYPES[typeName] = typeClass;
	                    }
	                };
	            }
	        ];
	    }
	
	})();


/***/ }),

/***/ 996:
983,

/***/ 998:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(999);

/***/ }),

/***/ 999:
/***/ (function(module, exports) {

	/*!
	 * angular-translate - v2.5.2 - 2014-12-10
	 * http://github.com/angular-translate/angular-translate
	 * Copyright (c) 2014 ; Licensed MIT
	 */
	/**
	 * @ngdoc overview
	 * @name pascalprecht.translate
	 *
	 * @description
	 * The main module which holds everything together.
	 */
	angular.module('pascalprecht.translate', ['ng'])
	
	.run(['$translate', function ($translate) {
	
	  var key = $translate.storageKey(),
	      storage = $translate.storage();
	
	  var fallbackFromIncorrectStorageValue = function() {
	    var preferred = $translate.preferredLanguage();
	    if (angular.isString(preferred)) {
	      $translate.use(preferred);
	      // $translate.use() will also remember the language.
	      // So, we don't need to call storage.put() here.
	    } else {
	      storage.put(key, $translate.use());
	    }
	  };
	
	  if (storage) {
	    if (!storage.get(key)) {
	      fallbackFromIncorrectStorageValue();
	    } else {
	      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
	    }
	  } else if (angular.isString($translate.preferredLanguage())) {
	    $translate.use($translate.preferredLanguage());
	  }
	}]);
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateProvider
	 * @description
	 *
	 * $translateProvider allows developers to register translation-tables, asynchronous loaders
	 * and similar to configure translation behavior directly inside of a module.
	 *
	 */
	angular.module('pascalprecht.translate').provider('$translate', ['$STORAGE_KEY', function ($STORAGE_KEY) {
	
	  var $translationTable = {},
	      $preferredLanguage,
	      $availableLanguageKeys = [],
	      $languageKeyAliases,
	      $fallbackLanguage,
	      $fallbackWasString,
	      $uses,
	      $nextLang,
	      $storageFactory,
	      $storageKey = $STORAGE_KEY,
	      $storagePrefix,
	      $missingTranslationHandlerFactory,
	      $interpolationFactory,
	      $interpolatorFactories = [],
	      $interpolationSanitizationStrategy = false,
	      $loaderFactory,
	      $cloakClassName = 'translate-cloak',
	      $loaderOptions,
	      $notFoundIndicatorLeft,
	      $notFoundIndicatorRight,
	      $postCompilingEnabled = false,
	      NESTED_OBJECT_DELIMITER = '.',
	      loaderCache;
	
	  var version = '2.5.2';
	
	  // tries to determine the browsers language
	  var getFirstBrowserLanguage = function () {
	    var nav = window.navigator,
	        browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
	        i,
	        language;
	
	    // support for HTML 5.1 "navigator.languages"
	    if (angular.isArray(nav.languages)) {
	      for (i = 0; i < nav.languages.length; i++) {
	        language = nav.languages[i];
	        if (language && language.length) {
	          return language;
	        }
	      }
	    }
	
	    // support for other well known properties in browsers
	    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
	      language = nav[browserLanguagePropertyKeys[i]];
	      if (language && language.length) {
	        return language;
	      }
	    }
	
	    return null;
	  };
	  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';
	
	  // tries to determine the browsers locale
	  var getLocale = function () {
	    return (getFirstBrowserLanguage() || '').split('-').join('_');
	  };
	  getLocale.displayName = 'angular-translate/service: getLocale';
	
	  /**
	   * @name indexOf
	   * @private
	   *
	   * @description
	   * indexOf polyfill. Kinda sorta.
	   *
	   * @param {array} array Array to search in.
	   * @param {string} searchElement Element to search for.
	   *
	   * @returns {int} Index of search element.
	   */
	  var indexOf = function(array, searchElement) {
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === searchElement) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function() {
	    return this.replace(/^\s+|\s+$/g, '');
	  };
	
	  var negotiateLocale = function (preferred) {
	
	    var avail = [],
	        locale = angular.lowercase(preferred),
	        i = 0,
	        n = $availableLanguageKeys.length;
	
	    for (; i < n; i++) {
	      avail.push(angular.lowercase($availableLanguageKeys[i]));
	    }
	
	    if (indexOf(avail, locale) > -1) {
	      return preferred;
	    }
	
	    if ($languageKeyAliases) {
	      var alias;
	      for (var langKeyAlias in $languageKeyAliases) {
	        var hasWildcardKey = false;
	        var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
	          angular.lowercase(langKeyAlias) === angular.lowercase(preferred);
	
	        if (langKeyAlias.slice(-1) === '*') {
	          hasWildcardKey = langKeyAlias.slice(0, -1) === preferred.slice(0, langKeyAlias.length-1);
	        }
	        if (hasExactKey || hasWildcardKey) {
	          alias = $languageKeyAliases[langKeyAlias];
	          if (indexOf(avail, angular.lowercase(alias)) > -1) {
	            return alias;
	          }
	        }
	      }
	    }
	
	    var parts = preferred.split('_');
	
	    if (parts.length > 1 && indexOf(avail, angular.lowercase(parts[0])) > -1) {
	      return parts[0];
	    }
	
	    // If everything fails, just return the preferred, unchanged.
	    return preferred;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translations
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a new translation table for specific language key.
	   *
	   * To register a translation table for specific language, pass a defined language
	   * key as first parameter.
	   *
	   * <pre>
	   *  // register translation table for language: 'de_DE'
	   *  $translateProvider.translations('de_DE', {
	   *    'GREETING': 'Hallo Welt!'
	   *  });
	   *
	   *  // register another one
	   *  $translateProvider.translations('en_US', {
	   *    'GREETING': 'Hello world!'
	   *  });
	   * </pre>
	   *
	   * When registering multiple translation tables for for the same language key,
	   * the actual translation table gets extended. This allows you to define module
	   * specific translation which only get added, once a specific module is loaded in
	   * your app.
	   *
	   * Invoking this method with no arguments returns the translation table which was
	   * registered with no language key. Invoking it with a language key returns the
	   * related translation table.
	   *
	   * @param {string} key A language key.
	   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
	   *
	   */
	  var translations = function (langKey, translationTable) {
	
	    if (!langKey && !translationTable) {
	      return $translationTable;
	    }
	
	    if (langKey && !translationTable) {
	      if (angular.isString(langKey)) {
	        return $translationTable[langKey];
	      }
	    } else {
	      if (!angular.isObject($translationTable[langKey])) {
	        $translationTable[langKey] = {};
	      }
	      angular.extend($translationTable[langKey], flatObject(translationTable));
	    }
	    return this;
	  };
	
	  this.translations = translations;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#cloakClassName
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the class name for `translate-cloak` directive.
	   * Default class name is `translate-cloak`.
	   *
	   * @param {string} name translate-cloak class name
	   */
	  this.cloakClassName = function (name) {
	    if (!name) {
	      return $cloakClassName;
	    }
	    $cloakClassName = name;
	    return this;
	  };
	
	  /**
	   * @name flatObject
	   * @private
	   *
	   * @description
	   * Flats an object. This function is used to flatten given translation data with
	   * namespaces, so they are later accessible via dot notation.
	   */
	  var flatObject = function (data, path, result, prevKey) {
	    var key, keyWithPath, keyWithShortPath, val;
	
	    if (!path) {
	      path = [];
	    }
	    if (!result) {
	      result = {};
	    }
	    for (key in data) {
	      if (!Object.prototype.hasOwnProperty.call(data, key)) {
	        continue;
	      }
	      val = data[key];
	      if (angular.isObject(val)) {
	        flatObject(val, path.concat(key), result, key);
	      } else {
	        keyWithPath = path.length ? ('' + path.join(NESTED_OBJECT_DELIMITER) + NESTED_OBJECT_DELIMITER + key) : key;
	        if(path.length && key === prevKey){
	          // Create shortcut path (foo.bar == foo.bar.bar)
	          keyWithShortPath = '' + path.join(NESTED_OBJECT_DELIMITER);
	          // Link it to original path
	          result[keyWithShortPath] = '@:' + keyWithPath;
	        }
	        result[keyWithPath] = val;
	      }
	    }
	    return result;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#addInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Adds interpolation services to angular-translate, so it can manage them.
	   *
	   * @param {object} factory Interpolation service factory
	   */
	  this.addInterpolation = function (factory) {
	    $interpolatorFactories.push(factory);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use interpolation functionality of messageformat.js.
	   * This is useful when having high level pluralization and gender selection.
	   */
	  this.useMessageFormatInterpolation = function () {
	    return this.useInterpolation('$translateMessageFormatInterpolation');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which interpolation style to use as default, application-wide.
	   * Simply pass a factory/service name. The interpolation service has to implement
	   * the correct interface.
	   *
	   * @param {string} factory Interpolation service name.
	   */
	  this.useInterpolation = function (factory) {
	    $interpolationFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Simply sets a sanitation strategy type.
	   *
	   * @param {string} value Strategy type.
	   */
	  this.useSanitizeValueStrategy = function (value) {
	    $interpolationSanitizationStrategy = value;
	    return this;
	  };
	
	 /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#preferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use for translation
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **prefer**.
	   *
	   * @param {string} langKey A language key.
	   *
	   */
	  this.preferredLanguage = function(langKey) {
	    setupPreferredLanguage(langKey);
	    return this;
	
	  };
	  var setupPreferredLanguage = function (langKey) {
	    if (langKey) {
	      $preferredLanguage = langKey;
	    }
	    return $preferredLanguage;
	  };
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found. E.g. when
	   * setting the indicator as 'X' and one tries to translate a translation id
	   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
	   *
	   * Internally this methods sets a left indicator and a right indicator using
	   * `$translateProvider.translationNotFoundIndicatorLeft()` and
	   * `$translateProvider.translationNotFoundIndicatorRight()`.
	   *
	   * **Note**: These methods automatically add a whitespace between the indicators
	   * and the translation id.
	   *
	   * @param {string} indicator An indicator, could be any string.
	   */
	  this.translationNotFoundIndicator = function (indicator) {
	    this.translationNotFoundIndicatorLeft(indicator);
	    this.translationNotFoundIndicatorRight(indicator);
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found left to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorLeft = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorLeft;
	    }
	    $notFoundIndicatorLeft = indicator;
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found right to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorRight = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorRight;
	    }
	    $notFoundIndicatorRight = indicator;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use when missing translations
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **fallback**.
	   *
	   * @param {string||array} langKey A language key.
	   *
	   */
	  this.fallbackLanguage = function (langKey) {
	    fallbackStack(langKey);
	    return this;
	  };
	
	  var fallbackStack = function (langKey) {
	    if (langKey) {
	      if (angular.isString(langKey)) {
	        $fallbackWasString = true;
	        $fallbackLanguage = [ langKey ];
	      } else if (angular.isArray(langKey)) {
	        $fallbackWasString = false;
	        $fallbackLanguage = langKey;
	      }
	      if (angular.isString($preferredLanguage)  && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	        $fallbackLanguage.push($preferredLanguage);
	      }
	
	      return this;
	    } else {
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#use
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Set which translation table to use for translation by given language key. When
	   * trying to 'use' a language which isn't provided, it'll throw an error.
	   *
	   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
	   * does the job too.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.use = function (langKey) {
	    if (langKey) {
	      if (!$translationTable[langKey] && (!$loaderFactory)) {
	        // only throw an error, when not loading translation data asynchronously
	        throw new Error("$translateProvider couldn't find translationTable for langKey: '" + langKey + "'");
	      }
	      $uses = langKey;
	      return this;
	    }
	    return $uses;
	  };
	
	 /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storageKey
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which key must represent the choosed language by a user in the storage.
	   *
	   * @param {string} key A key for the storage.
	   */
	  var storageKey = function(key) {
	    if (!key) {
	      if ($storagePrefix) {
	        return $storagePrefix + $storageKey;
	      }
	      return $storageKey;
	    }
	    $storageKey = key;
	  };
	
	  this.storageKey = storageKey;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useUrlLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
	   *
	   * @param {string} url Url
	   * @param {Object=} options Optional configuration object
	   */
	  this.useUrlLoader = function (url, options) {
	    return this.useLoader('$translateUrlLoader', angular.extend({ url: url }, options));
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
	   *
	   * @param {Object=} options Optional configuration object
	   */
	  this.useStaticFilesLoader = function (options) {
	    return this.useLoader('$translateStaticFilesLoader', options);
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use any other service as loader.
	   *
	   * @param {string} loaderFactory Factory name to use
	   * @param {Object=} options Optional configuration object
	   */
	  this.useLoader = function (loaderFactory, options) {
	    $loaderFactory = loaderFactory;
	    $loaderOptions = options || {};
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLocalStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
	   *
	   */
	  this.useLocalStorage = function () {
	    return this.useStorage('$translateLocalStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useCookieStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
	   */
	  this.useCookieStorage = function () {
	    return this.useStorage('$translateCookieStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use custom service as storage layer.
	   */
	  this.useStorage = function (storageFactory) {
	    $storageFactory = storageFactory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storagePrefix
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets prefix for storage key.
	   *
	   * @param {string} prefix Storage key prefix
	   */
	  this.storagePrefix = function (prefix) {
	    if (!prefix) {
	      return prefix;
	    }
	    $storagePrefix = prefix;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use built-in log handler when trying to translate
	   * a translation Id which doesn't exist.
	   *
	   * This is actually a shortcut method for `useMissingTranslationHandler()`.
	   *
	   */
	  this.useMissingTranslationHandlerLog = function () {
	    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Expects a factory name which later gets instantiated with `$injector`.
	   * This method can be used to tell angular-translate to use a custom
	   * missingTranslationHandler. Just build a factory which returns a function
	   * and expects a translation id as argument.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.useMissingTranslationHandler('customHandler');
	   *  });
	   *
	   *  app.factory('customHandler', function (dep1, dep2) {
	   *    return function (translationId) {
	   *      // something with translationId and dep1 and dep2
	   *    };
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.useMissingTranslationHandler = function (factory) {
	    $missingTranslationHandlerFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#usePostCompiling
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If post compiling is enabled, all translated values will be processed
	   * again with AngularJS' $compile.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.usePostCompiling(true);
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.usePostCompiling = function (value) {
	    $postCompilingEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to try to determine on its own which language key
	   * to set as preferred language. When `fn` is given, angular-translate uses it
	   * to determine a language key, otherwise it uses the built-in `getLocale()`
	   * method.
	   *
	   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
	   * `[lang]` depending on what the browser provides.
	   *
	   * Use this method at your own risk, since not all browsers return a valid
	   * locale.
	   *
	   * @param {object=} fn Function to determine a browser's locale
	   */
	  this.determinePreferredLanguage = function (fn) {
	
	    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();
	
	    if (!$availableLanguageKeys.length) {
	      $preferredLanguage = locale;
	    } else {
	      $preferredLanguage = negotiateLocale(locale);
	    }
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a set of language keys the app will work with. Use this method in
	   * combination with
	   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
	   * When available languages keys are registered, angular-translate
	   * tries to find the best fitting language key depending on the browsers locale,
	   * considering your language key convention.
	   *
	   * @param {object} languageKeys Array of language keys the your app will use
	   * @param {object=} aliases Alias map.
	   */
	  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
	    if (languageKeys) {
	      $availableLanguageKeys = languageKeys;
	      if (aliases) {
	        $languageKeyAliases = aliases;
	      }
	      return this;
	    }
	    return $availableLanguageKeys;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoaderCache
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a cache for internal $http based loaders.
	   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
	   * When false the cache will be disabled (default). When true or undefined
	   * the cache will be a default (see $cacheFactory). When an object it will
	   * be treat as a cache object itself: the usage is $http({cache: cache})
	   *
	   * @param {object} cache boolean, string or cache-object
	   */
	  this.useLoaderCache = function (cache) {
	    if (cache === false) {
	      // disable cache
	      loaderCache = undefined;
	    } else if (cache === true) {
	      // enable cache using AJS defaults
	      loaderCache = true;
	    } else if (typeof(cache) === 'undefined') {
	      // enable cache using default
	      loaderCache = '$translationCache';
	    } else if (cache) {
	      // enable cache using given one (see $cacheFactory)
	      loaderCache = cache;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translate
	   * @requires $interpolate
	   * @requires $log
	   * @requires $rootScope
	   * @requires $q
	   *
	   * @description
	   * The `$translate` service is the actual core of angular-translate. It expects a translation id
	   * and optional interpolate parameters to translate contents.
	   *
	   * <pre>
	   *  $translate('HEADLINE_TEXT').then(function (translation) {
	   *    $scope.translatedText = translation;
	   *  });
	   * </pre>
	   *
	   * @param {string|array} translationId A token which represents a translation id
	   *                                     This can be optionally an array of translation ids which
	   *                                     results that the function returns an object where each key
	   *                                     is the translation id and the value the translation.
	   * @param {object=} interpolateParams An object hash for dynamic values
	   * @param {string} interpolationId The id of the interpolation to use
	   * @returns {object} promise
	   */
	  this.$get = [
	    '$log',
	    '$injector',
	    '$rootScope',
	    '$q',
	    function ($log, $injector, $rootScope, $q) {
	
	      var Storage,
	          defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
	          pendingLoader = false,
	          interpolatorHashMap = {},
	          langPromises = {},
	          fallbackIndex,
	          startFallbackIteration;
	
	      var $translate = function (translationId, interpolateParams, interpolationId) {
	
	        // Duck detection: If the first argument is an array, a bunch of translations was requested.
	        // The result is an object.
	        if (angular.isArray(translationId)) {
	          // Inspired by Q.allSettled by Kris Kowal
	          // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
	          // This transforms all promises regardless resolved or rejected
	          var translateAll = function (translationIds) {
	            var results = {}; // storing the actual results
	            var promises = []; // promises to wait for
	            // Wraps the promise a) being always resolved and b) storing the link id->value
	            var translate = function (translationId) {
	              var deferred = $q.defer();
	              var regardless = function (value) {
	                results[translationId] = value;
	                deferred.resolve([translationId, value]);
	              };
	              // we don't care whether the promise was resolved or rejected; just store the values
	              $translate(translationId, interpolateParams, interpolationId).then(regardless, regardless);
	              return deferred.promise;
	            };
	            for (var i = 0, c = translationIds.length; i < c; i++) {
	              promises.push(translate(translationIds[i]));
	            }
	            // wait for all (including storing to results)
	            return $q.all(promises).then(function () {
	              // return the results
	              return results;
	            });
	          };
	          return translateAll(translationId);
	        }
	
	        var deferred = $q.defer();
	
	        // trim off any whitespace
	        if (translationId) {
	          translationId = trim.apply(translationId);
	        }
	
	        var promiseToWaitFor = (function () {
	          var promise = $preferredLanguage ?
	            langPromises[$preferredLanguage] :
	            langPromises[$uses];
	
	          fallbackIndex = 0;
	
	          if ($storageFactory && !promise) {
	            // looks like there's no pending promise for $preferredLanguage or
	            // $uses. Maybe there's one pending for a language that comes from
	            // storage.
	            var langKey = Storage.get($storageKey);
	            promise = langPromises[langKey];
	
	            if ($fallbackLanguage && $fallbackLanguage.length) {
	                var index = indexOf($fallbackLanguage, langKey);
	                // maybe the language from storage is also defined as fallback language
	                // we increase the fallback language index to not search in that language
	                // as fallback, since it's probably the first used language
	                // in that case the index starts after the first element
	                fallbackIndex = (index === 0) ? 1 : 0;
	
	                // but we can make sure to ALWAYS fallback to preferred language at least
	                if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	                  $fallbackLanguage.push($preferredLanguage);
	                }
	            }
	          }
	          return promise;
	        }());
	
	        if (!promiseToWaitFor) {
	          // no promise to wait for? okay. Then there's no loader registered
	          // nor is a one pending for language that comes from storage.
	          // We can just translate.
	          determineTranslation(translationId, interpolateParams, interpolationId).then(deferred.resolve, deferred.reject);
	        } else {
	          promiseToWaitFor.then(function () {
	            determineTranslation(translationId, interpolateParams, interpolationId).then(deferred.resolve, deferred.reject);
	          }, deferred.reject);
	        }
	        return deferred.promise;
	      };
	
	      /**
	       * @name applyNotFoundIndicators
	       * @private
	       *
	       * @description
	       * Applies not fount indicators to given translation id, if needed.
	       * This function gets only executed, if a translation id doesn't exist,
	       * which is why a translation id is expected as argument.
	       *
	       * @param {string} translationId Translation id.
	       * @returns {string} Same as given translation id but applied with not found
	       * indicators.
	       */
	      var applyNotFoundIndicators = function (translationId) {
	        // applying notFoundIndicators
	        if ($notFoundIndicatorLeft) {
	          translationId = [$notFoundIndicatorLeft, translationId].join(' ');
	        }
	        if ($notFoundIndicatorRight) {
	          translationId = [translationId, $notFoundIndicatorRight].join(' ');
	        }
	        return translationId;
	      };
	
	      /**
	       * @name useLanguage
	       * @private
	       *
	       * @description
	       * Makes actual use of a language by setting a given language key as used
	       * language and informs registered interpolators to also use the given
	       * key as locale.
	       *
	       * @param {key} Locale key.
	       */
	      var useLanguage = function (key) {
	        $uses = key;
	        $rootScope.$emit('$translateChangeSuccess', {language: key});
	
	        if ($storageFactory) {
	          Storage.put($translate.storageKey(), $uses);
	        }
	        // inform default interpolator
	        defaultInterpolator.setLocale($uses);
	        // inform all others too!
	        angular.forEach(interpolatorHashMap, function (interpolator, id) {
	          interpolatorHashMap[id].setLocale($uses);
	        });
	        $rootScope.$emit('$translateChangeEnd', {language: key});
	      };
	
	      /**
	       * @name loadAsync
	       * @private
	       *
	       * @description
	       * Kicks of registered async loader using `$injector` and applies existing
	       * loader options. When resolved, it updates translation tables accordingly
	       * or rejects with given language key.
	       *
	       * @param {string} key Language key.
	       * @return {Promise} A promise.
	       */
	      var loadAsync = function (key) {
	        if (!key) {
	          throw 'No language key specified for loading.';
	        }
	
	        var deferred = $q.defer();
	
	        $rootScope.$emit('$translateLoadingStart', {language: key});
	        pendingLoader = true;
	
	        var cache = loaderCache;
	        if (typeof(cache) === 'string') {
	          // getting on-demand instance of loader
	          cache = $injector.get(cache);
	        }
	
	        var loaderOptions = angular.extend({}, $loaderOptions, {
	          key: key,
	          $http: angular.extend({}, {
	            cache: cache
	          }, $loaderOptions.$http)
	        });
	
	        $injector.get($loaderFactory)(loaderOptions).then(function (data) {
	          var translationTable = {};
	          $rootScope.$emit('$translateLoadingSuccess', {language: key});
	
	          if (angular.isArray(data)) {
	            angular.forEach(data, function (table) {
	              angular.extend(translationTable, flatObject(table));
	            });
	          } else {
	            angular.extend(translationTable, flatObject(data));
	          }
	          pendingLoader = false;
	          deferred.resolve({
	            key: key,
	            table: translationTable
	          });
	          $rootScope.$emit('$translateLoadingEnd', {language: key});
	        }, function (key) {
	          $rootScope.$emit('$translateLoadingError', {language: key});
	          deferred.reject(key);
	          $rootScope.$emit('$translateLoadingEnd', {language: key});
	        });
	        return deferred.promise;
	      };
	
	      if ($storageFactory) {
	        Storage = $injector.get($storageFactory);
	
	        if (!Storage.get || !Storage.put) {
	          throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
	        }
	      }
	
	      // apply additional settings
	      if (angular.isFunction(defaultInterpolator.useSanitizeValueStrategy)) {
	        defaultInterpolator.useSanitizeValueStrategy($interpolationSanitizationStrategy);
	      }
	
	      // if we have additional interpolations that were added via
	      // $translateProvider.addInterpolation(), we have to map'em
	      if ($interpolatorFactories.length) {
	        angular.forEach($interpolatorFactories, function (interpolatorFactory) {
	          var interpolator = $injector.get(interpolatorFactory);
	          // setting initial locale for each interpolation service
	          interpolator.setLocale($preferredLanguage || $uses);
	          // apply additional settings
	          if (angular.isFunction(interpolator.useSanitizeValueStrategy)) {
	            interpolator.useSanitizeValueStrategy($interpolationSanitizationStrategy);
	          }
	          // make'em recognizable through id
	          interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
	        });
	      }
	
	      /**
	       * @name getTranslationTable
	       * @private
	       *
	       * @description
	       * Returns a promise that resolves to the translation table
	       * or is rejected if an error occurred.
	       *
	       * @param langKey
	       * @returns {Q.promise}
	       */
	      var getTranslationTable = function (langKey) {
	        var deferred = $q.defer();
	        if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
	          deferred.resolve($translationTable[langKey]);
	        } else if (langPromises[langKey]) {
	          langPromises[langKey].then(function (data) {
	            translations(data.key, data.table);
	            deferred.resolve(data.table);
	          }, deferred.reject);
	        } else {
	          deferred.reject();
	        }
	        return deferred.promise;
	      };
	
	      /**
	       * @name getFallbackTranslation
	       * @private
	       *
	       * @description
	       * Returns a promise that will resolve to the translation
	       * or be rejected if no translation was found for the language.
	       * This function is currently only used for fallback language translation.
	       *
	       * @param langKey The language to translate to.
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {Q.promise}
	       */
	      var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator) {
	        var deferred = $q.defer();
	
	        getTranslationTable(langKey).then(function (translationTable) {
	          if (Object.prototype.hasOwnProperty.call(translationTable, translationId)) {
	            Interpolator.setLocale(langKey);
	            deferred.resolve(Interpolator.interpolate(translationTable[translationId], interpolateParams));
	            Interpolator.setLocale($uses);
	          } else {
	            deferred.reject();
	          }
	        }, deferred.reject);
	
	        return deferred.promise;
	      };
	
	      /**
	       * @name getFallbackTranslationInstant
	       * @private
	       *
	       * @description
	       * Returns a translation
	       * This function is currently only used for fallback language translation.
	       *
	       * @param langKey The language to translate to.
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {string} translation
	       */
	      var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator) {
	        var result, translationTable = $translationTable[langKey];
	
	        if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId)) {
	          Interpolator.setLocale(langKey);
	          result = Interpolator.interpolate(translationTable[translationId], interpolateParams);
	          Interpolator.setLocale($uses);
	        }
	
	        return result;
	      };
	
	
	      /**
	       * @name translateByHandler
	       * @private
	       *
	       * Translate by missing translation handler.
	       *
	       * @param translationId
	       * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
	       * absent
	       */
	      var translateByHandler = function (translationId) {
	        // If we have a handler factory - we might also call it here to determine if it provides
	        // a default text for a translationid that can't be found anywhere in our tables
	        if ($missingTranslationHandlerFactory) {
	          var resultString = $injector.get($missingTranslationHandlerFactory)(translationId, $uses);
	          if (resultString !== undefined) {
	            return resultString;
	          } else {
	            return translationId;
	          }
	        } else {
	          return translationId;
	        }
	      };
	
	      /**
	       * @name resolveForFallbackLanguage
	       * @private
	       *
	       * Recursive helper function for fallbackTranslation that will sequentially look
	       * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	       *
	       * @param fallbackLanguageIndex
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {Q.promise} Promise that will resolve to the translation.
	       */
	      var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator) {
	        var deferred = $q.defer();
	
	        if (fallbackLanguageIndex < $fallbackLanguage.length) {
	          var langKey = $fallbackLanguage[fallbackLanguageIndex];
	          getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator).then(
	            deferred.resolve,
	            function () {
	              // Look in the next fallback language for a translation.
	              // It delays the resolving by passing another promise to resolve.
	              resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator).then(deferred.resolve);
	            }
	          );
	        } else {
	          // No translation found in any fallback language
	          deferred.resolve(translateByHandler(translationId));
	        }
	        return deferred.promise;
	      };
	
	      /**
	       * @name resolveForFallbackLanguageInstant
	       * @private
	       *
	       * Recursive helper function for fallbackTranslation that will sequentially look
	       * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	       *
	       * @param fallbackLanguageIndex
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {string} translation
	       */
	      var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator) {
	        var result;
	
	        if (fallbackLanguageIndex < $fallbackLanguage.length) {
	          var langKey = $fallbackLanguage[fallbackLanguageIndex];
	          result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator);
	          if (!result) {
	            result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
	          }
	        }
	        return result;
	      };
	
	      /**
	       * Translates with the usage of the fallback languages.
	       *
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {Q.promise} Promise, that resolves to the translation.
	       */
	      var fallbackTranslation = function (translationId, interpolateParams, Interpolator) {
	        // Start with the fallbackLanguage with index 0
	        return resolveForFallbackLanguage((startFallbackIteration>0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator);
	      };
	
	      /**
	       * Translates with the usage of the fallback languages.
	       *
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {String} translation
	       */
	      var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator) {
	        // Start with the fallbackLanguage with index 0
	        return resolveForFallbackLanguageInstant((startFallbackIteration>0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator);
	      };
	
	      var determineTranslation = function (translationId, interpolateParams, interpolationId) {
	
	        var deferred = $q.defer();
	
	        var table = $uses ? $translationTable[$uses] : $translationTable,
	            Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;
	
	        // if the translation id exists, we can just interpolate it
	        if (table && Object.prototype.hasOwnProperty.call(table, translationId)) {
	          var translation = table[translationId];
	
	          // If using link, rerun $translate with linked translationId and return it
	          if (translation.substr(0, 2) === '@:') {
	
	            $translate(translation.substr(2), interpolateParams, interpolationId)
	              .then(deferred.resolve, deferred.reject);
	          } else {
	            deferred.resolve(Interpolator.interpolate(translation, interpolateParams));
	          }
	        } else {
	          var missingTranslationHandlerTranslation;
	          // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId);
	          }
	
	          // since we couldn't translate the inital requested translation id,
	          // we try it now with one or more fallback languages, if fallback language(s) is
	          // configured.
	          if ($uses && $fallbackLanguage && $fallbackLanguage.length) {
	            fallbackTranslation(translationId, interpolateParams, Interpolator)
	                .then(function (translation) {
	                  deferred.resolve(translation);
	                }, function (_translationId) {
	                  deferred.reject(applyNotFoundIndicators(_translationId));
	                });
	          } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            // looks like the requested translation id doesn't exists.
	            // Now, if there is a registered handler for missing translations and no
	            // asyncLoader is pending, we execute the handler
	            deferred.resolve(missingTranslationHandlerTranslation);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	        return deferred.promise;
	      };
	
	      var determineTranslationInstant = function (translationId, interpolateParams, interpolationId) {
	
	        var result, table = $uses ? $translationTable[$uses] : $translationTable,
	            Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;
	
	        // if the translation id exists, we can just interpolate it
	        if (table && Object.prototype.hasOwnProperty.call(table, translationId)) {
	          var translation = table[translationId];
	
	          // If using link, rerun $translate with linked translationId and return it
	          if (translation.substr(0, 2) === '@:') {
	            result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId);
	          } else {
	            result = Interpolator.interpolate(translation, interpolateParams);
	          }
	        } else {
	          var missingTranslationHandlerTranslation;
	          // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId);
	          }
	
	          // since we couldn't translate the inital requested translation id,
	          // we try it now with one or more fallback languages, if fallback language(s) is
	          // configured.
	          if ($uses && $fallbackLanguage && $fallbackLanguage.length) {
	            fallbackIndex = 0;
	            result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator);
	          } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            // looks like the requested translation id doesn't exists.
	            // Now, if there is a registered handler for missing translations and no
	            // asyncLoader is pending, we execute the handler
	            result = missingTranslationHandlerTranslation;
	          } else {
	            result = applyNotFoundIndicators(translationId);
	          }
	        }
	
	        return result;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#preferredLanguage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the language key for the preferred language.
	       *
	       * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
	       *
	       * @return {string} preferred language key
	       */
	      $translate.preferredLanguage = function (langKey) {
	        if(langKey) {
	          setupPreferredLanguage(langKey);
	        }
	        return $preferredLanguage;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#cloakClassName
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the configured class name for `translate-cloak` directive.
	       *
	       * @return {string} cloakClassName
	       */
	      $translate.cloakClassName = function () {
	        return $cloakClassName;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#fallbackLanguage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the language key for the fallback languages or sets a new fallback stack.
	       *
	       * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
	       *
	       * @return {string||array} fallback language key
	       */
	      $translate.fallbackLanguage = function (langKey) {
	        if (langKey !== undefined && langKey !== null) {
	          fallbackStack(langKey);
	
	          // as we might have an async loader initiated and a new translation language might have been defined
	          // we need to add the promise to the stack also. So - iterate.
	          if ($loaderFactory) {
	            if ($fallbackLanguage && $fallbackLanguage.length) {
	              for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	                if (!langPromises[$fallbackLanguage[i]]) {
	                  langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
	                }
	              }
	            }
	          }
	          $translate.use($translate.use());
	        }
	        if ($fallbackWasString) {
	          return $fallbackLanguage[0];
	        } else {
	          return $fallbackLanguage;
	        }
	
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#useFallbackLanguage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Sets the first key of the fallback language stack to be used for translation.
	       * Therefore all languages in the fallback array BEFORE this key will be skipped!
	       *
	       * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
	       * get back to the whole stack
	       */
	      $translate.useFallbackLanguage = function (langKey) {
	        if (langKey !== undefined && langKey !== null) {
	          if (!langKey) {
	            startFallbackIteration = 0;
	          } else {
	            var langKeyPosition = indexOf($fallbackLanguage, langKey);
	            if (langKeyPosition > -1) {
	              startFallbackIteration = langKeyPosition;
	            }
	          }
	
	        }
	
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#proposedLanguage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the language key of language that is currently loaded asynchronously.
	       *
	       * @return {string} language key
	       */
	      $translate.proposedLanguage = function () {
	        return $nextLang;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#storage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns registered storage.
	       *
	       * @return {object} Storage
	       */
	      $translate.storage = function () {
	        return Storage;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#use
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Tells angular-translate which language to use by given language key. This method is
	       * used to change language at runtime. It also takes care of storing the language
	       * key in a configured store to let your app remember the choosed language.
	       *
	       * When trying to 'use' a language which isn't available it tries to load it
	       * asynchronously with registered loaders.
	       *
	       * Returns promise object with loaded language file data
	       * @example
	       * $translate.use("en_US").then(function(data){
	       *   $scope.text = $translate("HELLO");
	       * });
	       *
	       * @param {string} key Language key
	       * @return {string} Language key
	       */
	      $translate.use = function (key) {
	        if (!key) {
	          return $uses;
	        }
	
	        var deferred = $q.defer();
	
	        $rootScope.$emit('$translateChangeStart', {language: key});
	
	        // Try to get the aliased language key
	        var aliasedKey = negotiateLocale(key);
	        if (aliasedKey) {
	          key = aliasedKey;
	        }
	
	        // if there isn't a translation table for the language we've requested,
	        // we load it asynchronously
	        if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
	          $nextLang = key;
	          langPromises[key] = loadAsync(key).then(function (translation) {
	            translations(translation.key, translation.table);
	            deferred.resolve(translation.key);
	
	            useLanguage(translation.key);
	            if ($nextLang === key) {
	              $nextLang = undefined;
	            }
	            return translation;
	          }, function (key) {
	            if ($nextLang === key) {
	              $nextLang = undefined;
	            }
	            $rootScope.$emit('$translateChangeError', {language: key});
	            deferred.reject(key);
	            $rootScope.$emit('$translateChangeEnd', {language: key});
	          });
	        } else {
	          deferred.resolve(key);
	          useLanguage(key);
	        }
	
	        return deferred.promise;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#storageKey
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the key for the storage.
	       *
	       * @return {string} storage key
	       */
	      $translate.storageKey = function () {
	        return storageKey();
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#isPostCompilingEnabled
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns whether post compiling is enabled or not
	       *
	       * @return {bool} storage key
	       */
	      $translate.isPostCompilingEnabled = function () {
	        return $postCompilingEnabled;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#refresh
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
	       * the module will drop all existent translation tables and load new version of those which
	       * are currently in use.
	       *
	       * Refresh means that the module will drop target translation table and try to load it again.
	       *
	       * In case there are no loaders registered the refresh() method will throw an Error.
	       *
	       * If the module is able to refresh translation tables refresh() method will broadcast
	       * $translateRefreshStart and $translateRefreshEnd events.
	       *
	       * @example
	       * // this will drop all currently existent translation tables and reload those which are
	       * // currently in use
	       * $translate.refresh();
	       * // this will refresh a translation table for the en_US language
	       * $translate.refresh('en_US');
	       *
	       * @param {string} langKey A language key of the table, which has to be refreshed
	       *
	       * @return {promise} Promise, which will be resolved in case a translation tables refreshing
	       * process is finished successfully, and reject if not.
	       */
	      $translate.refresh = function (langKey) {
	        if (!$loaderFactory) {
	          throw new Error('Couldn\'t refresh translation table, no loader registered!');
	        }
	
	        var deferred = $q.defer();
	
	        function resolve() {
	          deferred.resolve();
	          $rootScope.$emit('$translateRefreshEnd', {language: langKey});
	        }
	
	        function reject() {
	          deferred.reject();
	          $rootScope.$emit('$translateRefreshEnd', {language: langKey});
	        }
	
	        $rootScope.$emit('$translateRefreshStart', {language: langKey});
	
	        if (!langKey) {
	          // if there's no language key specified we refresh ALL THE THINGS!
	          var tables = [], loadingKeys = {};
	
	          // reload registered fallback languages
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	              tables.push(loadAsync($fallbackLanguage[i]));
	              loadingKeys[$fallbackLanguage[i]] = true;
	            }
	          }
	
	          // reload currently used language
	          if ($uses && !loadingKeys[$uses]) {
	            tables.push(loadAsync($uses));
	          }
	
	          $q.all(tables).then(function (tableData) {
	            angular.forEach(tableData, function (data) {
	              if ($translationTable[data.key]) {
	                delete $translationTable[data.key];
	              }
	              translations(data.key, data.table);
	            });
	            if ($uses) {
	              useLanguage($uses);
	            }
	            resolve();
	          });
	
	        } else if ($translationTable[langKey]) {
	
	          loadAsync(langKey).then(function (data) {
	            translations(data.key, data.table);
	            if (langKey === $uses) {
	              useLanguage($uses);
	            }
	            resolve();
	          }, reject);
	
	        } else {
	          reject();
	        }
	        return deferred.promise;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#instant
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns a translation instantly from the internal state of loaded translation. All rules
	       * regarding the current language, the preferred language of even fallback languages will be
	       * used except any promise handling. If a language was not found, an asynchronous loading
	       * will be invoked in the background.
	       *
	       * @param {string|array} translationId A token which represents a translation id
	       *                                     This can be optionally an array of translation ids which
	       *                                     results that the function's promise returns an object where
	       *                                     each key is the translation id and the value the translation.
	       * @param {object} interpolateParams Params
	       * @param {string} interpolationId The id of the interpolation to use
	       *
	       * @return {string} translation
	       */
	      $translate.instant = function (translationId, interpolateParams, interpolationId) {
	
	        // Detect undefined and null values to shorten the execution and prevent exceptions
	        if (translationId === null || angular.isUndefined(translationId)) {
	          return translationId;
	        }
	
	        // Duck detection: If the first argument is an array, a bunch of translations was requested.
	        // The result is an object.
	        if (angular.isArray(translationId)) {
	          var results = {};
	          for (var i = 0, c = translationId.length; i < c; i++) {
	            results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId);
	          }
	          return results;
	        }
	
	        // We discarded unacceptable values. So we just need to verify if translationId is empty String
	        if (angular.isString(translationId) && translationId.length < 1) {
	          return translationId;
	        }
	
	        // trim off any whitespace
	        if (translationId) {
	          translationId = trim.apply(translationId);
	        }
	
	        var result, possibleLangKeys = [];
	        if ($preferredLanguage) {
	          possibleLangKeys.push($preferredLanguage);
	        }
	        if ($uses) {
	          possibleLangKeys.push($uses);
	        }
	        if ($fallbackLanguage && $fallbackLanguage.length) {
	          possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
	        }
	        for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
	          var possibleLangKey = possibleLangKeys[j];
	          if ($translationTable[possibleLangKey]) {
	            if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
	              result = determineTranslationInstant(translationId, interpolateParams, interpolationId);
	            }
	          }
	          if (typeof result !== 'undefined') {
	            break;
	          }
	        }
	
	        if (!result && result !== '') {
	          // Return translation of default interpolator if not found anything.
	          result = defaultInterpolator.interpolate(translationId, interpolateParams);
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            result = translateByHandler(translationId);
	          }
	        }
	
	        return result;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#versionInfo
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the current version information for the angular-translate library
	       *
	       * @return {string} angular-translate version
	       */
	      $translate.versionInfo = function () {
	        return version;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#loaderCache
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the defined loaderCache.
	       *
	       * @return {boolean|string|object} current value of loaderCache
	       */
	      $translate.loaderCache = function () {
	        return loaderCache;
	      };
	
	      if ($loaderFactory) {
	
	        // If at least one async loader is defined and there are no
	        // (default) translations available we should try to load them.
	        if (angular.equals($translationTable, {})) {
	          $translate.use($translate.use());
	        }
	
	        // Also, if there are any fallback language registered, we start
	        // loading them asynchronously as soon as we can.
	        if ($fallbackLanguage && $fallbackLanguage.length) {
	          var processAsyncResult = function (translation) {
	            translations(translation.key, translation.table);
	            $rootScope.$emit('$translateChangeEnd', { language: translation.key });
	            return translation;
	          };
	          for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	            langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]).then(processAsyncResult);
	          }
	        }
	      }
	
	      return $translate;
	    }
	  ];
	}]);
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateDefaultInterpolation
	 * @requires $interpolate
	 *
	 * @description
	 * Uses angular's `$interpolate` services to interpolate strings against some values.
	 *
	 * @return {object} $translateInterpolator Interpolator service
	 */
	angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', ['$interpolate', function ($interpolate) {
	
	  var $translateInterpolator = {},
	      $locale,
	      $identifier = 'default',
	      $sanitizeValueStrategy = null,
	      // map of all sanitize strategies
	      sanitizeValueStrategies = {
	        escaped: function (params) {
	          var result = {};
	          for (var key in params) {
	            if (Object.prototype.hasOwnProperty.call(params, key)) {
	              result[key] = angular.element('<div></div>').text(params[key]).html();
	            }
	          }
	          return result;
	        }
	      };
	
	  var sanitizeParams = function (params) {
	    var result;
	    if (angular.isFunction(sanitizeValueStrategies[$sanitizeValueStrategy])) {
	      result = sanitizeValueStrategies[$sanitizeValueStrategy](params);
	    } else {
	      result = params;
	    }
	    return result;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Sets current locale (this is currently not use in this interpolation).
	   *
	   * @param {string} locale Language key or locale.
	   */
	  $translateInterpolator.setLocale = function (locale) {
	    $locale = locale;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Returns an identifier for this interpolation service.
	   *
	   * @returns {string} $identifier
	   */
	  $translateInterpolator.getInterpolationIdentifier = function () {
	    return $identifier;
	  };
	
	  $translateInterpolator.useSanitizeValueStrategy = function (value) {
	    $sanitizeValueStrategy = value;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Interpolates given string agains given interpolate params using angulars
	   * `$interpolate` service.
	   *
	   * @returns {string} interpolated string.
	   */
	  $translateInterpolator.interpolate = function (string, interpolateParams) {
	    if ($sanitizeValueStrategy) {
	      interpolateParams = sanitizeParams(interpolateParams);
	    }
	    return $interpolate(string)(interpolateParams || {});
	  };
	
	  return $translateInterpolator;
	}]);
	
	angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate
	 * @requires $compile
	 * @requires $filter
	 * @requires $interpolate
	 * @restrict A
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses `translate` filter to translate translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate Translation id which could be either string or interpolated string.
	 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
	 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
	 * @param {string=} translate-default will be used unless translation was successful
	 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translate#usePostCompiling}
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre translate="TRANSLATION_ID"></pre>
	        <pre translate>TRANSLATION_ID</pre>
	        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
	        <pre translate="{{translationId}}"></pre>
	        <pre translate>{{translationId}}</pre>
	        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
	        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
	        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
	        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}'
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('title')).toBe('Hello there!');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translate', ['$translate', '$q', '$interpolate', '$compile', '$parse', '$rootScope', function ($translate, $q, $interpolate, $compile, $parse, $rootScope) {
	
	  return {
	    restrict: 'AE',
	    scope: true,
	    compile: function (tElement, tAttr) {
	
	      var translateValuesExist = (tAttr.translateValues) ?
	        tAttr.translateValues : undefined;
	
	      var translateInterpolation = (tAttr.translateInterpolation) ?
	        tAttr.translateInterpolation : undefined;
	
	      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);
	
	      var interpolateRegExp = "^(.*)(" + $interpolate.startSymbol() + ".*" + $interpolate.endSymbol() + ")(.*)",
	          watcherRegExp = "^(.*)" + $interpolate.startSymbol() + "(.*)" + $interpolate.endSymbol() + "(.*)";
	
	      return function linkFn(scope, iElement, iAttr) {
	
	        scope.interpolateParams = {};
	        scope.preText = "";
	        scope.postText = "";
	        var translationIds = {};
	
	        // Ensures any change of the attribute "translate" containing the id will
	        // be re-stored to the scope's "translationId".
	        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
	        var observeElementTranslation = function (translationId) {
	          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
	            // Resolve translation id by inner html if required
	            var interpolateMatches = iElement.text().match(interpolateRegExp);
	            // Interpolate translation id if required
	            if (angular.isArray(interpolateMatches)) {
	              scope.preText = interpolateMatches[1];
	              scope.postText = interpolateMatches[3];
	              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
	              watcherMatches = iElement.text().match(watcherRegExp);
	              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
	                scope.$watch(watcherMatches[2], function (newValue) {
	                  translationIds.translate = newValue;
	                  updateTranslations();
	                });
	              }
	            } else {
	              translationIds.translate = iElement.text().replace(/^\s+|\s+$/g,'');
	            }
	          } else {
	            translationIds.translate = translationId;
	          }
	          updateTranslations();
	        };
	
	        var observeAttributeTranslation = function (translateAttr) {
	          iAttr.$observe(translateAttr, function (translationId) {
	            translationIds[translateAttr] = translationId;
	            updateTranslations();
	          });
	        };
	
	        iAttr.$observe('translate', function (translationId) {
	          observeElementTranslation(translationId);
	        });
	
	        for (var translateAttr in iAttr) {
	          if(iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr') {
	            observeAttributeTranslation(translateAttr);
	          }
	        }
	
	        iAttr.$observe('translateDefault', function (value) {
	          scope.defaultText = value;
	        });
	
	        if (translateValuesExist) {
	          iAttr.$observe('translateValues', function (interpolateParams) {
	            if (interpolateParams) {
	              scope.$parent.$watch(function () {
	                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
	              });
	            }
	          });
	        }
	
	        if (translateValueExist) {
	          var observeValueAttribute = function (attrName) {
	            iAttr.$observe(attrName, function (value) {
	              var attributeName = angular.lowercase(attrName.substr(14, 1)) + attrName.substr(15);
	              scope.interpolateParams[attributeName] = value;
	            });
	          };
	          for (var attr in iAttr) {
	            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	              observeValueAttribute(attr);
	            }
	          }
	        }
	
	        // Master update function
	        var updateTranslations = function () {
	          for (var key in translationIds) {
	            if (translationIds.hasOwnProperty(key) && translationIds[key]) {
	              updateTranslation(key, translationIds[key], scope, scope.interpolateParams);
	            }
	          }
	        };
	
	        // Put translation processing function outside loop
	        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams) {
	          $translate(translationId, interpolateParams, translateInterpolation)
	            .then(function (translation) {
	              applyTranslation(translation, scope, true, translateAttr);
	            }, function (translationId) {
	              applyTranslation(translationId, scope, false, translateAttr);
	            });
	        };
	
	        var applyTranslation = function (value, scope, successful, translateAttr) {
	          if (translateAttr === 'translate') {
	            // default translate into innerHTML
	            if (!successful && typeof scope.defaultText !== 'undefined') {
	              value = scope.defaultText;
	            }
	            iElement.html(scope.preText + value + scope.postText);
	            var globallyEnabled = $translate.isPostCompilingEnabled();
	            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
	            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
	            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
	              $compile(iElement.contents())(scope);
	            }
	          } else {
	            // translate attribute
	            if (!successful && typeof scope.defaultText !== 'undefined') {
	              value = scope.defaultText;
	            }
	            var attributeName = iAttr.$attr[translateAttr].substr(15);
	            iElement.attr(attributeName, value);
	          }
	        };
	
	        scope.$watch('interpolateParams', updateTranslations, true);
	
	        // Ensures the text will be refreshed after the current language was changed
	        // w/ $translate.use(...)
	        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	        // ensure translation will be looked up at least one
	        if (iElement.text().length) {
	          observeElementTranslation('');
	        }
	        updateTranslations();
	        scope.$on('$destroy', unbind);
	      };
	    }
	  };
	}]);
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateCloak
	 * @requires $rootScope
	 * @requires $translate
	 * @restrict A
	 *
	 * $description
	 * Adds a `translate-cloak` class name to the given element where this directive
	 * is applied initially and removes it, once a loader has finished loading.
	 *
	 * This directive can be used to prevent initial flickering when loading translation
	 * data asynchronously.
	 *
	 * The class name is defined in
	 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
	 *
	 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
	 *                                  or hiding the cloak. Basically it relies on the translation
	 *                                  resolve.
	 */
	.directive('translateCloak', ['$rootScope', '$translate', function ($rootScope, $translate) {
	
	  return {
	    compile: function (tElement) {
	      var applyCloak = function () {
	        tElement.addClass($translate.cloakClassName());
	      },
	      removeCloak = function () {
	        tElement.removeClass($translate.cloakClassName());
	      },
	      removeListener = $rootScope.$on('$translateChangeEnd', function () {
	        removeCloak();
	        removeListener();
	        removeListener = null;
	      });
	      applyCloak();
	
	      return function linkFn(scope, iElement, iAttr) {
	        // Register a watcher for the defined translation allowing a fine tuned cloak
	        if (iAttr.translateCloak && iAttr.translateCloak.length) {
	          iAttr.$observe('translateCloak', function (translationId) {
	            $translate(translationId).then(removeCloak, applyCloak);
	          });
	        }
	      };
	    }
	  };
	}]);
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc filter
	 * @name pascalprecht.translate.filter:translate
	 * @requires $parse
	 * @requires pascalprecht.translate.$translate
	 * @function
	 *
	 * @description
	 * Uses `$translate` service to translate contents. Accepts interpolate parameters
	 * to pass dynamized values though translation.
	 *
	 * @param {string} translationId A translation id to be translated.
	 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
	 *
	 * @returns {string} Translated text.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
	        <pre>{{ translationId | translate }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en', {
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}'
	        });
	        $translateProvider.preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	   </example>
	 */
	.filter('translate', ['$parse', '$translate', function ($parse, $translate) {
	  var translateFilter = function (translationId, interpolateParams, interpolation) {
	
	    if (!angular.isObject(interpolateParams)) {
	      interpolateParams = $parse(interpolateParams)(this);
	    }
	
	    return $translate.instant(translationId, interpolateParams, interpolation);
	  };
	
	  // Since AngularJS 1.3, filters which are not stateless (depending at the scope)
	  // have to explicit define this behavior.
	  translateFilter.$stateful = true;
	
	  return translateFilter;
	}]);


/***/ }),

/***/ 1000:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1001);

/***/ }),

/***/ 1001:
/***/ (function(module, exports) {

	/*!
	 * angular-translate - v2.5.2 - 2014-12-10
	 * http://github.com/angular-translate/angular-translate
	 * Copyright (c) 2014 ; Licensed MIT
	 */
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateStaticFilesLoader
	 * @requires $q
	 * @requires $http
	 *
	 * @description
	 * Creates a loading function for a typical static file url pattern:
	 * "lang-en_US.json", "lang-de_DE.json", etc. Using this builder,
	 * the response of these urls must be an object of key-value pairs.
	 *
	 * @param {object} options Options object, which gets prefix, suffix and key.
	 */
	.factory('$translateStaticFilesLoader', ['$q', '$http', function ($q, $http) {
	
	  return function (options) {
	
	    if (!options || (!angular.isString(options.prefix) || !angular.isString(options.suffix))) {
	      throw new Error('Couldn\'t load static files, no prefix or suffix specified!');
	    }
	
	    var deferred = $q.defer();
	
	    $http(angular.extend({
	      url: [
	        options.prefix,
	        options.key,
	        options.suffix
	      ].join(''),
	      method: 'GET',
	      params: ''
	    }, options.$http)).success(function (data) {
	      deferred.resolve(data);
	    }).error(function (data) {
	      deferred.reject(options.key);
	    });
	
	    return deferred.promise;
	  };
	}]);


/***/ }),

/***/ 1002:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1003);

/***/ }),

/***/ 1003:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.11
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngCookies
	 * @description
	 *
	 * # ngCookies
	 *
	 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
	 *
	 *
	 * <div doc-module-components="ngCookies"></div>
	 *
	 * See {@link ngCookies.$cookies `$cookies`} for usage.
	 */
	
	
	angular.module('ngCookies', ['ng']).
	  /**
	   * @ngdoc provider
	   * @name $cookiesProvider
	   * @description
	   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
	   * */
	   provider('$cookies', [/** @this */function $CookiesProvider() {
	    /**
	     * @ngdoc property
	     * @name $cookiesProvider#defaults
	     * @description
	     *
	     * Object containing default options to pass when setting cookies.
	     *
	     * The object may have following properties:
	     *
	     * - **path** - `{string}` - The cookie will be available only for this path and its
	     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
	     * - **domain** - `{string}` - The cookie will be available only for this domain and
	     *   its sub-domains. For security reasons the user agent will not accept the cookie
	     *   if the current domain is not a sub-domain of this domain or equal to it.
	     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
	     *   or a Date object indicating the exact date/time this cookie will expire.
	     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
	     *   secured connection.
	     *
	     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
	     * This is important so that cookies will be visible for all routes when html5mode is enabled.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesProviderExample', ['ngCookies'])
	     *   .config(['$cookiesProvider', function($cookiesProvider) {
	     *     // Setting default options
	     *     $cookiesProvider.defaults.domain = 'foo.com';
	     *     $cookiesProvider.defaults.secure = true;
	     *   }]);
	     * ```
	     **/
	    var defaults = this.defaults = {};
	
	    function calcOptions(options) {
	      return options ? angular.extend({}, defaults, options) : defaults;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $cookies
	     *
	     * @description
	     * Provides read/write access to browser's cookies.
	     *
	     * <div class="alert alert-info">
	     * Up until Angular 1.3, `$cookies` exposed properties that represented the
	     * current browser cookie values. In version 1.4, this behavior has changed, and
	     * `$cookies` now provides a standard api of getters, setters etc.
	     * </div>
	     *
	     * Requires the {@link ngCookies `ngCookies`} module to be installed.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesExample', ['ngCookies'])
	     *   .controller('ExampleController', ['$cookies', function($cookies) {
	     *     // Retrieving a cookie
	     *     var favoriteCookie = $cookies.get('myFavorite');
	     *     // Setting a cookie
	     *     $cookies.put('myFavorite', 'oatmeal');
	     *   }]);
	     * ```
	     */
	    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
	      return {
	        /**
	         * @ngdoc method
	         * @name $cookies#get
	         *
	         * @description
	         * Returns the value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {string} Raw cookie value.
	         */
	        get: function(key) {
	          return $$cookieReader()[key];
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getObject
	         *
	         * @description
	         * Returns the deserialized value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {Object} Deserialized cookie value.
	         */
	        getObject: function(key) {
	          var value = this.get(key);
	          return value ? angular.fromJson(value) : value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getAll
	         *
	         * @description
	         * Returns a key value object with all the cookies
	         *
	         * @returns {Object} All cookies
	         */
	        getAll: function() {
	          return $$cookieReader();
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#put
	         *
	         * @description
	         * Sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {string} value Raw value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        put: function(key, value, options) {
	          $$cookieWriter(key, value, calcOptions(options));
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#putObject
	         *
	         * @description
	         * Serializes and sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {Object} value Value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        putObject: function(key, value, options) {
	          this.put(key, angular.toJson(value), options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#remove
	         *
	         * @description
	         * Remove given cookie
	         *
	         * @param {string} key Id of the key-value pair to delete.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        remove: function(key, options) {
	          $$cookieWriter(key, undefined, calcOptions(options));
	        }
	      };
	    }];
	  }]);
	
	angular.module('ngCookies').
	/**
	 * @ngdoc service
	 * @name $cookieStore
	 * @deprecated
	 * sinceVersion="v1.4.0"
	 * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
	 *
	 * @requires $cookies
	 *
	 * @description
	 * Provides a key-value (string-object) storage, that is backed by session cookies.
	 * Objects put or retrieved from this storage are automatically serialized or
	 * deserialized by angular's toJson/fromJson.
	 *
	 * Requires the {@link ngCookies `ngCookies`} module to be installed.
	 *
	 * @example
	 *
	 * ```js
	 * angular.module('cookieStoreExample', ['ngCookies'])
	 *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
	 *     // Put cookie
	 *     $cookieStore.put('myFavorite','oatmeal');
	 *     // Get cookie
	 *     var favoriteCookie = $cookieStore.get('myFavorite');
	 *     // Removing a cookie
	 *     $cookieStore.remove('myFavorite');
	 *   }]);
	 * ```
	 */
	 factory('$cookieStore', ['$cookies', function($cookies) {
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $cookieStore#get
	       *
	       * @description
	       * Returns the value of given cookie key
	       *
	       * @param {string} key Id to use for lookup.
	       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
	       */
	      get: function(key) {
	        return $cookies.getObject(key);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#put
	       *
	       * @description
	       * Sets a value for given cookie key
	       *
	       * @param {string} key Id for the `value`.
	       * @param {Object} value Value to be stored.
	       */
	      put: function(key, value) {
	        $cookies.putObject(key, value);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#remove
	       *
	       * @description
	       * Remove given cookie
	       *
	       * @param {string} key Id of the key-value pair to delete.
	       */
	      remove: function(key) {
	        $cookies.remove(key);
	      }
	    };
	
	  }]);
	
	/**
	 * @name $$cookieWriter
	 * @requires $document
	 *
	 * @description
	 * This is a private service for writing cookies
	 *
	 * @param {string} name Cookie name
	 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
	 * @param {Object=} options Object with options that need to be stored for the cookie.
	 */
	function $$CookieWriter($document, $log, $browser) {
	  var cookiePath = $browser.baseHref();
	  var rawDocument = $document[0];
	
	  function buildCookieString(name, value, options) {
	    var path, expires;
	    options = options || {};
	    expires = options.expires;
	    path = angular.isDefined(options.path) ? options.path : cookiePath;
	    if (angular.isUndefined(value)) {
	      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
	      value = '';
	    }
	    if (angular.isString(expires)) {
	      expires = new Date(expires);
	    }
	
	    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
	    str += path ? ';path=' + path : '';
	    str += options.domain ? ';domain=' + options.domain : '';
	    str += expires ? ';expires=' + expires.toUTCString() : '';
	    str += options.secure ? ';secure' : '';
	
	    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
	    // - 300 cookies
	    // - 20 cookies per unique domain
	    // - 4096 bytes per cookie
	    var cookieLength = str.length + 1;
	    if (cookieLength > 4096) {
	      $log.warn('Cookie \'' + name +
	        '\' possibly not set or overflowed because it was too large (' +
	        cookieLength + ' > 4096 bytes)!');
	    }
	
	    return str;
	  }
	
	  return function(name, value, options) {
	    rawDocument.cookie = buildCookieString(name, value, options);
	  };
	}
	
	$$CookieWriter.$inject = ['$document', '$log', '$browser'];
	
	angular.module('ngCookies').provider('$$cookieWriter', /** @this */ function $$CookieWriterProvider() {
	  this.$get = $$CookieWriter;
	});
	
	
	})(window, window.angular);


/***/ }),

/***/ 1004:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1005);

/***/ }),

/***/ 1005:
/***/ (function(module, exports) {

	/*!
	 * angular-translate - v2.5.2 - 2014-12-10
	 * http://github.com/angular-translate/angular-translate
	 * Copyright (c) 2014 ; Licensed MIT
	 */
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateCookieStorage
	 * @requires $cookieStore
	 *
	 * @description
	 * Abstraction layer for cookieStore. This service is used when telling angular-translate
	 * to use cookieStore as storage.
	 *
	 */
	.factory('$translateCookieStorage', ['$cookieStore', function ($cookieStore) {
	
	  var $translateCookieStorage = {
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateCookieStorage#get
	     * @methodOf pascalprecht.translate.$translateCookieStorage
	     *
	     * @description
	     * Returns an item from cookieStorage by given name.
	     *
	     * @param {string} name Item name
	     * @return {string} Value of item name
	     */
	    get: function (name) {
	      return $cookieStore.get(name);
	    },
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateCookieStorage#set
	     * @methodOf pascalprecht.translate.$translateCookieStorage
	     *
	     * @description
	     * Sets an item in cookieStorage by given name.
	     *
	     * @deprecated use #put
	     *
	     * @param {string} name Item name
	     * @param {string} value Item value
	     */
	    set: function (name, value) {
	      $cookieStore.put(name, value);
	    },
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateCookieStorage#put
	     * @methodOf pascalprecht.translate.$translateCookieStorage
	     *
	     * @description
	     * Sets an item in cookieStorage by given name.
	     *
	     * @param {string} name Item name
	     * @param {string} value Item value
	     */
	    put: function (name, value) {
	      $cookieStore.put(name, value);
	    }
	  };
	
	  return $translateCookieStorage;
	}]);


/***/ }),

/***/ 1008:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1009);

/***/ }),

/***/ 1009:
/***/ (function(module, exports) {

	/*
	 * angular-ui-bootstrap
	 * http://angular-ui.github.io/bootstrap/
	
	 * Version: 0.13.4 - 2015-09-03
	 * License: MIT
	 */
	angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.bindHtml","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.position","ui.bootstrap.datepicker","ui.bootstrap.dropdown","ui.bootstrap.modal","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.transition","ui.bootstrap.typeahead"]);
	angular.module("ui.bootstrap.tpls", ["template/accordion/accordion-group.html","template/accordion/accordion.html","template/alert/alert.html","template/carousel/carousel.html","template/carousel/slide.html","template/datepicker/datepicker.html","template/datepicker/day.html","template/datepicker/month.html","template/datepicker/popup.html","template/datepicker/year.html","template/modal/backdrop.html","template/modal/window.html","template/pagination/pager.html","template/pagination/pagination.html","template/tooltip/tooltip-html-popup.html","template/tooltip/tooltip-html-unsafe-popup.html","template/tooltip/tooltip-popup.html","template/tooltip/tooltip-template-popup.html","template/popover/popover-html.html","template/popover/popover-template.html","template/popover/popover.html","template/progressbar/bar.html","template/progressbar/progress.html","template/progressbar/progressbar.html","template/rating/rating.html","template/tabs/tab.html","template/tabs/tabset.html","template/timepicker/timepicker.html","template/typeahead/typeahead-match.html","template/typeahead/typeahead-popup.html"]);
	angular.module('ui.bootstrap.collapse', [])
	
	  .directive('collapse', ['$animate', function($animate) {
	    return {
	      link: function(scope, element, attrs) {
	        function expand() {
	          element.removeClass('collapse')
	            .addClass('collapsing')
	            .attr('aria-expanded', true)
	            .attr('aria-hidden', false);
	
	          $animate.addClass(element, 'in', {
	            to: { height: element[0].scrollHeight + 'px' }
	          }).then(expandDone);
	        }
	
	        function expandDone() {
	          element.removeClass('collapsing');
	          element.css({height: 'auto'});
	        }
	
	        function collapse() {
	          if (!element.hasClass('collapse') && !element.hasClass('in')) {
	            return collapseDone();
	          }
	
	          element
	            // IMPORTANT: The height must be set before adding "collapsing" class.
	            // Otherwise, the browser attempts to animate from height 0 (in
	            // collapsing class) to the given height here.
	            .css({height: element[0].scrollHeight + 'px'})
	            // initially all panel collapse have the collapse class, this removal
	            // prevents the animation from jumping to collapsed state
	            .removeClass('collapse')
	            .addClass('collapsing')
	            .attr('aria-expanded', false)
	            .attr('aria-hidden', true);
	
	          $animate.removeClass(element, 'in', {
	            to: {height: '0'}
	          }).then(collapseDone);
	        }
	
	        function collapseDone() {
	          element.css({height: '0'}); // Required so that collapse works when animation is disabled
	          element.removeClass('collapsing');
	          element.addClass('collapse');
	        }
	
	        scope.$watch(attrs.collapse, function(shouldCollapse) {
	          if (shouldCollapse) {
	            collapse();
	          } else {
	            expand();
	          }
	        });
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse'])
	
	.constant('accordionConfig', {
	  closeOthers: true
	})
	
	.controller('AccordionController', ['$scope', '$attrs', 'accordionConfig', function($scope, $attrs, accordionConfig) {
	  // This array keeps track of the accordion groups
	  this.groups = [];
	
	  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	  this.closeOthers = function(openGroup) {
	    var closeOthers = angular.isDefined($attrs.closeOthers) ?
	      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
	    if (closeOthers) {
	      angular.forEach(this.groups, function(group) {
	        if (group !== openGroup) {
	          group.isOpen = false;
	        }
	      });
	    }
	  };
	
	  // This is called from the accordion-group directive to add itself to the accordion
	  this.addGroup = function(groupScope) {
	    var that = this;
	    this.groups.push(groupScope);
	
	    groupScope.$on('$destroy', function(event) {
	      that.removeGroup(groupScope);
	    });
	  };
	
	  // This is called from the accordion-group directive when to remove itself
	  this.removeGroup = function(group) {
	    var index = this.groups.indexOf(group);
	    if (index !== -1) {
	      this.groups.splice(index, 1);
	    }
	  };
	
	}])
	
	// The accordion directive simply sets up the directive controller
	// and adds an accordion CSS class to itself element.
	.directive('accordion', function() {
	  return {
	    restrict: 'EA',
	    controller: 'AccordionController',
	    controllerAs: 'accordion',
	    transclude: true,
	    replace: false,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/accordion/accordion.html';
	    }
	  };
	})
	
	// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
	.directive('accordionGroup', function() {
	  return {
	    require: '^accordion',         // We need this directive to be inside an accordion
	    restrict: 'EA',
	    transclude: true,              // It transcludes the contents of the directive into the template
	    replace: true,                // The element containing the directive will be replaced with the template
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/accordion/accordion-group.html';
	    },
	    scope: {
	      heading: '@',               // Interpolate the heading attribute onto this scope
	      isOpen: '=?',
	      isDisabled: '=?'
	    },
	    controller: function() {
	      this.setHeading = function(element) {
	        this.heading = element;
	      };
	    },
	    link: function(scope, element, attrs, accordionCtrl) {
	      accordionCtrl.addGroup(scope);
	
	      scope.openClass = attrs.openClass || 'panel-open';
	      scope.panelClass = attrs.panelClass;
	      scope.$watch('isOpen', function(value) {
	        element.toggleClass(scope.openClass, value);
	        if (value) {
	          accordionCtrl.closeOthers(scope);
	        }
	      });
	
	      scope.toggleOpen = function($event) {
	        if (!scope.isDisabled) {
	          if (!$event || $event.which === 32) {
	            scope.isOpen = !scope.isOpen;
	          }
	        }
	      };
	    }
	  };
	})
	
	// Use accordion-heading below an accordion-group to provide a heading containing HTML
	// <accordion-group>
	//   <accordion-heading>Heading containing HTML - <img src="..."></accordion-heading>
	// </accordion-group>
	.directive('accordionHeading', function() {
	  return {
	    restrict: 'EA',
	    transclude: true,   // Grab the contents to be used as the heading
	    template: '',       // In effect remove this element!
	    replace: true,
	    require: '^accordionGroup',
	    link: function(scope, element, attr, accordionGroupCtrl, transclude) {
	      // Pass the heading to the accordion-group controller
	      // so that it can be transcluded into the right place in the template
	      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
	    }
	  };
	})
	
	// Use in the accordion-group template to indicate where you want the heading to be transcluded
	// You must provide the property on the accordion-group controller that will hold the transcluded element
	// <div class="accordion-group">
	//   <div class="accordion-heading" ><a ... accordion-transclude="heading">...</a></div>
	//   ...
	// </div>
	.directive('accordionTransclude', function() {
	  return {
	    require: '^accordionGroup',
	    link: function(scope, element, attr, controller) {
	      scope.$watch(function() { return controller[attr.accordionTransclude]; }, function(heading) {
	        if (heading) {
	          element.find('span').html('');
	          element.find('span').append(heading);
	        }
	      });
	    }
	  };
	})
	
	;
	
	angular.module('ui.bootstrap.alert', [])
	
	.controller('AlertController', ['$scope', '$attrs', function($scope, $attrs) {
	  $scope.closeable = !!$attrs.close;
	  this.close = $scope.close;
	}])
	
	.directive('alert', function() {
	  return {
	    controller: 'AlertController',
	    controllerAs: 'alert',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/alert/alert.html';
	    },
	    transclude: true,
	    replace: true,
	    scope: {
	      type: '@',
	      close: '&'
	    }
	  };
	})
	
	.directive('dismissOnTimeout', ['$timeout', function($timeout) {
	  return {
	    require: 'alert',
	    link: function(scope, element, attrs, alertCtrl) {
	      $timeout(function() {
	        alertCtrl.close();
	      }, parseInt(attrs.dismissOnTimeout, 10));
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.bindHtml', [])
	
	  .value('$bindHtmlUnsafeSuppressDeprecated', false)
	
	  .directive('bindHtmlUnsafe', ['$log', '$bindHtmlUnsafeSuppressDeprecated', function ($log, $bindHtmlUnsafeSuppressDeprecated) {
	    return function (scope, element, attr) {
	      if (!$bindHtmlUnsafeSuppressDeprecated) {
	        $log.warn('bindHtmlUnsafe is now deprecated. Use ngBindHtml instead');
	      }
	      element.addClass('ng-binding').data('$binding', attr.bindHtmlUnsafe);
	      scope.$watch(attr.bindHtmlUnsafe, function bindHtmlUnsafeWatchAction(value) {
	        element.html(value || '');
	      });
	    };
	  }]);
	angular.module('ui.bootstrap.buttons', [])
	
	.constant('buttonConfig', {
	  activeClass: 'active',
	  toggleEvent: 'click'
	})
	
	.controller('ButtonsController', ['buttonConfig', function(buttonConfig) {
	  this.activeClass = buttonConfig.activeClass || 'active';
	  this.toggleEvent = buttonConfig.toggleEvent || 'click';
	}])
	
	.directive('btnRadio', function() {
	  return {
	    require: ['btnRadio', 'ngModel'],
	    controller: 'ButtonsController',
	    controllerAs: 'buttons',
	    link: function(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      element.find('input').css({display: 'none'});
	
	      //model -> UI
	      ngModelCtrl.$render = function() {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.btnRadio)));
	      };
	
	      //ui->model
	      element.bind(buttonsCtrl.toggleEvent, function() {
	        if (attrs.disabled) {
	          return;
	        }
	
	        var isActive = element.hasClass(buttonsCtrl.activeClass);
	
	        if (!isActive || angular.isDefined(attrs.uncheckable)) {
	          scope.$apply(function() {
	            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.btnRadio));
	            ngModelCtrl.$render();
	          });
	        }
	      });
	    }
	  };
	})
	
	.directive('btnCheckbox', ['$document', function($document) {
	  return {
	    require: ['btnCheckbox', 'ngModel'],
	    controller: 'ButtonsController',
	    controllerAs: 'button',
	    link: function(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      element.find('input').css({display: 'none'});
	
	      function getTrueValue() {
	        return getCheckboxValue(attrs.btnCheckboxTrue, true);
	      }
	
	      function getFalseValue() {
	        return getCheckboxValue(attrs.btnCheckboxFalse, false);
	      }
	
	      function getCheckboxValue(attributeValue, defaultValue) {
	        var val = scope.$eval(attributeValue);
	        return angular.isDefined(val) ? val : defaultValue;
	      }
	
	      //model -> UI
	      ngModelCtrl.$render = function() {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
	      };
	
	      //ui->model
	      element.bind(buttonsCtrl.toggleEvent, function() {
	        if (attrs.disabled) {
	          return;
	        }
	
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	          ngModelCtrl.$render();
	        });
	      });
	
	      //accessibility
	      element.on('keypress', function(e) {
	        if (attrs.disabled || e.which !== 32 || $document[0].activeElement !== element[0]) {
	          return;
	        }
	
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	          ngModelCtrl.$render();
	        });
	      });
	    }
	  };
	}]);
	
	/**
	* @ngdoc overview
	* @name ui.bootstrap.carousel
	*
	* @description
	* AngularJS version of an image carousel.
	*
	*/
	angular.module('ui.bootstrap.carousel', [])
	.controller('CarouselController', ['$scope', '$element', '$interval', '$animate', function ($scope, $element, $interval, $animate) {
	  var self = this,
	    slides = self.slides = $scope.slides = [],
	    NEW_ANIMATE = angular.version.minor >= 4,
	    NO_TRANSITION = 'uib-noTransition',
	    SLIDE_DIRECTION = 'uib-slideDirection',
	    currentIndex = -1,
	    currentInterval, isPlaying;
	  self.currentSlide = null;
	
	  var destroyed = false;
	  /* direction: "prev" or "next" */
	  self.select = $scope.select = function(nextSlide, direction) {
	    var nextIndex = $scope.indexOfSlide(nextSlide);
	    //Decide direction if it's not given
	    if (direction === undefined) {
	      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
	    }
	    //Prevent this user-triggered transition from occurring if there is already one in progress
	    if (nextSlide && nextSlide !== self.currentSlide && !$scope.$currentTransition) {
	      goNext(nextSlide, nextIndex, direction);
	    }
	  };
	
	  function goNext(slide, index, direction) {
	    // Scope has been destroyed, stop here.
	    if (destroyed) { return; }
	
	    angular.extend(slide, {direction: direction, active: true});
	    angular.extend(self.currentSlide || {}, {direction: direction, active: false});
	    if ($animate.enabled() && !$scope.noTransition && !$scope.$currentTransition &&
	      slide.$element && self.slides.length > 1) {
	      slide.$element.data(SLIDE_DIRECTION, slide.direction);
	      if (self.currentSlide && self.currentSlide.$element) {
	        self.currentSlide.$element.data(SLIDE_DIRECTION, slide.direction);
	      }
	
	      $scope.$currentTransition = true;
	      if (NEW_ANIMATE) {
	        $animate.on('addClass', slide.$element, function (element, phase) {
	          if (phase === 'close') {
	            $scope.$currentTransition = null;
	            $animate.off('addClass', element);
	          }
	        });
	      } else {
	        slide.$element.one('$animate:close', function closeFn() {
	          $scope.$currentTransition = null;
	        });
	      }
	    }
	
	    self.currentSlide = slide;
	    currentIndex = index;
	
	    //every time you change slides, reset the timer
	    restartTimer();
	  }
	
	  $scope.$on('$destroy', function () {
	    destroyed = true;
	  });
	
	  function getSlideByIndex(index) {
	    if (angular.isUndefined(slides[index].index)) {
	      return slides[index];
	    }
	    var i, len = slides.length;
	    for (i = 0; i < slides.length; ++i) {
	      if (slides[i].index == index) {
	        return slides[i];
	      }
	    }
	  }
	
	  self.getCurrentIndex = function() {
	    if (self.currentSlide && angular.isDefined(self.currentSlide.index)) {
	      return +self.currentSlide.index;
	    }
	    return currentIndex;
	  };
	
	  /* Allow outside people to call indexOf on slides array */
	  $scope.indexOfSlide = function(slide) {
	    return angular.isDefined(slide.index) ? +slide.index : slides.indexOf(slide);
	  };
	
	  $scope.next = function() {
	    var newIndex = (self.getCurrentIndex() + 1) % slides.length;
	
	    if (newIndex === 0 && $scope.noWrap()) {
	      $scope.pause();
	      return;
	    }
	
	    return self.select(getSlideByIndex(newIndex), 'next');
	  };
	
	  $scope.prev = function() {
	    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;
	
	    if ($scope.noWrap() && newIndex === slides.length - 1){
	      $scope.pause();
	      return;
	    }
	
	    return self.select(getSlideByIndex(newIndex), 'prev');
	  };
	
	  $scope.isActive = function(slide) {
	     return self.currentSlide === slide;
	  };
	
	  $scope.$watch('interval', restartTimer);
	  $scope.$on('$destroy', resetTimer);
	
	  function restartTimer() {
	    resetTimer();
	    var interval = +$scope.interval;
	    if (!isNaN(interval) && interval > 0) {
	      currentInterval = $interval(timerFn, interval);
	    }
	  }
	
	  function resetTimer() {
	    if (currentInterval) {
	      $interval.cancel(currentInterval);
	      currentInterval = null;
	    }
	  }
	
	  function timerFn() {
	    var interval = +$scope.interval;
	    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
	      $scope.next();
	    } else {
	      $scope.pause();
	    }
	  }
	
	  $scope.play = function() {
	    if (!isPlaying) {
	      isPlaying = true;
	      restartTimer();
	    }
	  };
	  $scope.pause = function() {
	    if (!$scope.noPause) {
	      isPlaying = false;
	      resetTimer();
	    }
	  };
	
	  self.addSlide = function(slide, element) {
	    slide.$element = element;
	    slides.push(slide);
	    //if this is the first slide or the slide is set to active, select it
	    if(slides.length === 1 || slide.active) {
	      self.select(slides[slides.length-1]);
	      if (slides.length == 1) {
	        $scope.play();
	      }
	    } else {
	      slide.active = false;
	    }
	  };
	
	  self.removeSlide = function(slide) {
	    if (angular.isDefined(slide.index)) {
	      slides.sort(function(a, b) {
	        return +a.index > +b.index;
	      });
	    }
	    //get the index of the slide inside the carousel
	    var index = slides.indexOf(slide);
	    slides.splice(index, 1);
	    if (slides.length > 0 && slide.active) {
	      if (index >= slides.length) {
	        self.select(slides[index-1]);
	      } else {
	        self.select(slides[index]);
	      }
	    } else if (currentIndex > index) {
	      currentIndex--;
	    }
	    
	    //clean the currentSlide when no more slide
	    if (slides.length === 0) {
	      self.currentSlide = null;
	    }
	  };
	
	  $scope.$watch('noTransition', function(noTransition) {
	    $element.data(NO_TRANSITION, noTransition);
	  });
	
	}])
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.carousel.directive:carousel
	 * @restrict EA
	 *
	 * @description
	 * Carousel is the outer container for a set of image 'slides' to showcase.
	 *
	 * @param {number=} interval The time, in milliseconds, that it will take the carousel to go to the next slide.
	 * @param {boolean=} noTransition Whether to disable transitions on the carousel.
	 * @param {boolean=} noPause Whether to disable pausing on the carousel (by default, the carousel interval pauses on hover).
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <carousel>
	      <slide>
	        <img src="http://placekitten.com/150/150" style="margin:auto;">
	        <div class="carousel-caption">
	          <p>Beautiful!</p>
	        </div>
	      </slide>
	      <slide>
	        <img src="http://placekitten.com/100/150" style="margin:auto;">
	        <div class="carousel-caption">
	          <p>D'aww!</p>
	        </div>
	      </slide>
	    </carousel>
	  </file>
	  <file name="demo.css">
	    .carousel-indicators {
	      top: auto;
	      bottom: 15px;
	    }
	  </file>
	</example>
	 */
	.directive('carousel', [function() {
	  return {
	    restrict: 'EA',
	    transclude: true,
	    replace: true,
	    controller: 'CarouselController',
	    controllerAs: 'carousel',
	    require: 'carousel',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/carousel/carousel.html';
	    },
	    scope: {
	      interval: '=',
	      noTransition: '=',
	      noPause: '=',
	      noWrap: '&'
	    }
	  };
	}])
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.carousel.directive:slide
	 * @restrict EA
	 *
	 * @description
	 * Creates a slide inside a {@link ui.bootstrap.carousel.directive:carousel carousel}.  Must be placed as a child of a carousel element.
	 *
	 * @param {boolean=} active Model binding, whether or not this slide is currently active.
	 * @param {number=} index The index of the slide. The slides will be sorted by this parameter.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	<div ng-controller="CarouselDemoCtrl">
	  <carousel>
	    <slide ng-repeat="slide in slides" active="slide.active" index="$index">
	      <img ng-src="{{slide.image}}" style="margin:auto;">
	      <div class="carousel-caption">
	        <h4>Slide {{$index}}</h4>
	        <p>{{slide.text}}</p>
	      </div>
	    </slide>
	  </carousel>
	  Interval, in milliseconds: <input type="number" ng-model="myInterval">
	  <br />Enter a negative number to stop the interval.
	</div>
	  </file>
	  <file name="script.js">
	function CarouselDemoCtrl($scope) {
	  $scope.myInterval = 5000;
	}
	  </file>
	  <file name="demo.css">
	    .carousel-indicators {
	      top: auto;
	      bottom: 15px;
	    }
	  </file>
	</example>
	*/
	
	.directive('slide', function() {
	  return {
	    require: '^carousel',
	    restrict: 'EA',
	    transclude: true,
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/carousel/slide.html';
	    },
	    scope: {
	      active: '=?',
	      actual: '=?',
	      index: '=?'
	    },
	    link: function (scope, element, attrs, carouselCtrl) {
	      carouselCtrl.addSlide(scope, element);
	      //when the scope is destroyed then remove the slide from the current slides array
	      scope.$on('$destroy', function() {
	        carouselCtrl.removeSlide(scope);
	      });
	
	      scope.$watch('active', function(active) {
	        if (active) {
	          carouselCtrl.select(scope);
	        }
	      });
	    }
	  };
	})
	
	.animation('.item', [
	         '$injector', '$animate',
	function ($injector, $animate) {
	  var NO_TRANSITION = 'uib-noTransition',
	    SLIDE_DIRECTION = 'uib-slideDirection',
	    $animateCss = null;
	
	  if ($injector.has('$animateCss')) {
	    $animateCss = $injector.get('$animateCss');
	  }
	
	  function removeClass(element, className, callback) {
	    element.removeClass(className);
	    if (callback) {
	      callback();
	    }
	  }
	
	  return {
	    beforeAddClass: function (element, className, done) {
	      // Due to transclusion, noTransition property is on parent's scope
	      if (className == 'active' && element.parent() &&
	          !element.parent().data(NO_TRANSITION)) {
	        var stopped = false;
	        var direction = element.data(SLIDE_DIRECTION);
	        var directionClass = direction == 'next' ? 'left' : 'right';
	        var removeClassFn = removeClass.bind(this, element,
	          directionClass + ' ' + direction, done);
	        element.addClass(direction);
	
	        if ($animateCss) {
	          $animateCss(element, {addClass: directionClass})
	            .start()
	            .done(removeClassFn);
	        } else {
	          $animate.addClass(element, directionClass).then(function () {
	            if (!stopped) {
	              removeClassFn();
	            }
	            done();
	          });
	        }
	
	        return function () {
	          stopped = true;
	        };
	      }
	      done();
	    },
	    beforeRemoveClass: function (element, className, done) {
	      // Due to transclusion, noTransition property is on parent's scope
	      if (className === 'active' && element.parent() &&
	          !element.parent().data(NO_TRANSITION)) {
	        var stopped = false;
	        var direction = element.data(SLIDE_DIRECTION);
	        var directionClass = direction == 'next' ? 'left' : 'right';
	        var removeClassFn = removeClass.bind(this, element, directionClass, done);
	
	        if ($animateCss) {
	          $animateCss(element, {addClass: directionClass})
	            .start()
	            .done(removeClassFn);
	        } else {
	          $animate.addClass(element, directionClass).then(function () {
	            if (!stopped) {
	              removeClassFn();
	            }
	            done();
	          });
	        }
	        return function () {
	          stopped = true;
	        };
	      }
	      done();
	    }
	  };
	
	}])
	
	
	;
	
	angular.module('ui.bootstrap.dateparser', [])
	
	.service('dateParser', ['$log', '$locale', 'orderByFilter', function($log, $locale, orderByFilter) {
	  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
	  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	  this.parsers = {};
	
	  var formatCodeToRegex = {
	    'yyyy': {
	      regex: '\\d{4}',
	      apply: function(value) { this.year = +value; }
	    },
	    'yy': {
	      regex: '\\d{2}',
	      apply: function(value) { this.year = +value + 2000; }
	    },
	    'y': {
	      regex: '\\d{1,4}',
	      apply: function(value) { this.year = +value; }
	    },
	    'MMMM': {
	      regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
	      apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); }
	    },
	    'MMM': {
	      regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	      apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); }
	    },
	    'MM': {
	      regex: '0[1-9]|1[0-2]',
	      apply: function(value) { this.month = value - 1; }
	    },
	    'M': {
	      regex: '[1-9]|1[0-2]',
	      apply: function(value) { this.month = value - 1; }
	    },
	    'dd': {
	      regex: '[0-2][0-9]{1}|3[0-1]{1}',
	      apply: function(value) { this.date = +value; }
	    },
	    'd': {
	      regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
	      apply: function(value) { this.date = +value; }
	    },
	    'EEEE': {
	      regex: $locale.DATETIME_FORMATS.DAY.join('|')
	    },
	    'EEE': {
	      regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|')
	    },
	    'HH': {
	      regex: '(?:0|1)[0-9]|2[0-3]',
	      apply: function(value) { this.hours = +value; }
	    },
	    'hh': {
	      regex: '0[0-9]|1[0-2]',
	      apply: function(value) { this.hours = +value; }
	    },
	    'H': {
	      regex: '1?[0-9]|2[0-3]',
	      apply: function(value) { this.hours = +value; }
	    },
	    'h': {
	      regex: '[0-9]|1[0-2]',
	      apply: function(value) { this.hours = +value; }
	    },
	    'mm': {
	      regex: '[0-5][0-9]',
	      apply: function(value) { this.minutes = +value; }
	    },
	    'm': {
	      regex: '[0-9]|[1-5][0-9]',
	      apply: function(value) { this.minutes = +value; }
	    },
	    'sss': {
	      regex: '[0-9][0-9][0-9]',
	      apply: function(value) { this.milliseconds = +value; }
	    },
	    'ss': {
	      regex: '[0-5][0-9]',
	      apply: function(value) { this.seconds = +value; }
	    },
	    's': {
	      regex: '[0-9]|[1-5][0-9]',
	      apply: function(value) { this.seconds = +value; }
	    },
	    'a': {
	      regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
	      apply: function(value) {
	        if (this.hours === 12) {
	          this.hours = 0;
	        }
	
	        if (value === 'PM') {
	          this.hours += 12;
	        }
	      }
	    }
	  };
	
	  function createParser(format) {
	    var map = [], regex = format.split('');
	
	    angular.forEach(formatCodeToRegex, function(data, code) {
	      var index = format.indexOf(code);
	
	      if (index > -1) {
	        format = format.split('');
	
	        regex[index] = '(' + data.regex + ')';
	        format[index] = '$'; // Custom symbol to define consumed part of format
	        for (var i = index + 1, n = index + code.length; i < n; i++) {
	          regex[i] = '';
	          format[i] = '$';
	        }
	        format = format.join('');
	
	        map.push({ index: index, apply: data.apply });
	      }
	    });
	
	    return {
	      regex: new RegExp('^' + regex.join('') + '$'),
	      map: orderByFilter(map, 'index')
	    };
	  }
	
	  this.parse = function(input, format, baseDate) {
	    if (!angular.isString(input) || !format) {
	      return input;
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');
	
	    if (!this.parsers[format]) {
	      this.parsers[format] = createParser(format);
	    }
	
	    var parser = this.parsers[format],
	        regex = parser.regex,
	        map = parser.map,
	        results = input.match(regex);
	
	    if (results && results.length) {
	      var fields, dt;
	      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
	        fields = {
	          year: baseDate.getFullYear(),
	          month: baseDate.getMonth(),
	          date: baseDate.getDate(),
	          hours: baseDate.getHours(),
	          minutes: baseDate.getMinutes(),
	          seconds: baseDate.getSeconds(),
	          milliseconds: baseDate.getMilliseconds()
	        };
	      } else {
	        if (baseDate) {
	          $log.warn('dateparser:', 'baseDate is not a valid date');
	        }
	        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
	      }
	
	      for (var i = 1, n = results.length; i < n; i++) {
	        var mapper = map[i-1];
	        if (mapper.apply) {
	          mapper.apply.call(fields, results[i]);
	        }
	      }
	
	      if (isValid(fields.year, fields.month, fields.date)) {
	        dt = new Date(fields.year, fields.month, fields.date,
	          fields.hours, fields.minutes, fields.seconds,
	          fields.milliseconds || 0);
	      }
	
	      return dt;
	    }
	  };
	
	  // Check if date is valid for specific month (and year for February).
	  // Month: 0 = Jan, 1 = Feb, etc
	  function isValid(year, month, date) {
	    if (date < 1) {
	      return false;
	    }
	
	    if (month === 1 && date > 28) {
	      return date === 29 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
	    }
	
	    if (month === 3 || month === 5 || month === 8 || month === 10) {
	      return date < 31;
	    }
	
	    return true;
	  }
	}]);
	
	angular.module('ui.bootstrap.position', [])
	
	/**
	 * A set of utility methods that can be use to retrieve position of DOM elements.
	 * It is meant to be used where we need to absolute-position DOM elements in
	 * relation to other, existing elements (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	  .factory('$position', ['$document', '$window', function($document, $window) {
	    function getStyle(el, cssprop) {
	      if (el.currentStyle) { //IE
	        return el.currentStyle[cssprop];
	      } else if ($window.getComputedStyle) {
	        return $window.getComputedStyle(el)[cssprop];
	      }
	      // finally try and get inline style
	      return el.style[cssprop];
	    }
	
	    /**
	     * Checks if a given element is statically positioned
	     * @param element - raw DOM element
	     */
	    function isStaticPositioned(element) {
	      return (getStyle(element, 'position') || 'static' ) === 'static';
	    }
	
	    /**
	     * returns the closest, non-statically positioned parentOffset of a given element
	     * @param element
	     */
	    var parentOffsetEl = function(element) {
	      var docDomEl = $document[0];
	      var offsetParent = element.offsetParent || docDomEl;
	      while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent) ) {
	        offsetParent = offsetParent.offsetParent;
	      }
	      return offsetParent || docDomEl;
	    };
	
	    return {
	      /**
	       * Provides read-only equivalent of jQuery's position function:
	       * http://api.jquery.com/position/
	       */
	      position: function(element) {
	        var elBCR = this.offset(element);
	        var offsetParentBCR = { top: 0, left: 0 };
	        var offsetParentEl = parentOffsetEl(element[0]);
	        if (offsetParentEl != $document[0]) {
	          offsetParentBCR = this.offset(angular.element(offsetParentEl));
	          offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
	          offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
	        }
	
	        var boundingClientRect = element[0].getBoundingClientRect();
	        return {
	          width: boundingClientRect.width || element.prop('offsetWidth'),
	          height: boundingClientRect.height || element.prop('offsetHeight'),
	          top: elBCR.top - offsetParentBCR.top,
	          left: elBCR.left - offsetParentBCR.left
	        };
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's offset function:
	       * http://api.jquery.com/offset/
	       */
	      offset: function(element) {
	        var boundingClientRect = element[0].getBoundingClientRect();
	        return {
	          width: boundingClientRect.width || element.prop('offsetWidth'),
	          height: boundingClientRect.height || element.prop('offsetHeight'),
	          top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	          left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	        };
	      },
	
	      /**
	       * Provides coordinates for the targetEl in relation to hostEl
	       */
	      positionElements: function(hostEl, targetEl, positionStr, appendToBody) {
	        var positionStrParts = positionStr.split('-');
	        var pos0 = positionStrParts[0], pos1 = positionStrParts[1] || 'center';
	
	        var hostElPos,
	          targetElWidth,
	          targetElHeight,
	          targetElPos;
	
	        hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);
	
	        targetElWidth = targetEl.prop('offsetWidth');
	        targetElHeight = targetEl.prop('offsetHeight');
	
	        var shiftWidth = {
	          center: function() {
	            return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
	          },
	          left: function() {
	            return hostElPos.left;
	          },
	          right: function() {
	            return hostElPos.left + hostElPos.width;
	          }
	        };
	
	        var shiftHeight = {
	          center: function() {
	            return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
	          },
	          top: function() {
	            return hostElPos.top;
	          },
	          bottom: function() {
	            return hostElPos.top + hostElPos.height;
	          }
	        };
	
	        switch (pos0) {
	          case 'right':
	            targetElPos = {
	              top: shiftHeight[pos1](),
	              left: shiftWidth[pos0]()
	            };
	            break;
	          case 'left':
	            targetElPos = {
	              top: shiftHeight[pos1](),
	              left: hostElPos.left - targetElWidth
	            };
	            break;
	          case 'bottom':
	            targetElPos = {
	              top: shiftHeight[pos0](),
	              left: shiftWidth[pos1]()
	            };
	            break;
	          default:
	            targetElPos = {
	              top: hostElPos.top - targetElHeight,
	              left: shiftWidth[pos1]()
	            };
	            break;
	        }
	
	        return targetElPos;
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.position'])
	
	.value('$datepickerSuppressError', false)
	
	.constant('datepickerConfig', {
	  formatDay: 'dd',
	  formatMonth: 'MMMM',
	  formatYear: 'yyyy',
	  formatDayHeader: 'EEE',
	  formatDayTitle: 'MMMM yyyy',
	  formatMonthTitle: 'yyyy',
	  datepickerMode: 'day',
	  minMode: 'day',
	  maxMode: 'year',
	  showWeeks: true,
	  startingDay: 0,
	  yearRange: 20,
	  minDate: null,
	  maxDate: null,
	  shortcutPropagation: false
	})
	
	.controller('DatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$log', 'dateFilter', 'datepickerConfig', '$datepickerSuppressError', function($scope, $attrs, $parse, $interpolate, $log, dateFilter, datepickerConfig, $datepickerSuppressError) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl;
	
	  // Modes chain
	  this.modes = ['day', 'month', 'year'];
	
	  // Configuration attributes
	  angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
	                   'showWeeks', 'startingDay', 'yearRange', 'shortcutPropagation'], function(key, index) {
	    self[key] = angular.isDefined($attrs[key]) ? (index < 6 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : datepickerConfig[key];
	  });
	
	  // Watchable date attributes
	  angular.forEach(['minDate', 'maxDate'], function(key) {
	    if ($attrs[key]) {
	      $scope.$parent.$watch($parse($attrs[key]), function(value) {
	        self[key] = value ? new Date(value) : null;
	        self.refreshView();
	      });
	    } else {
	      self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
	    }
	  });
	
	  angular.forEach(['minMode', 'maxMode'], function(key) {
	    if ($attrs[key]) {
	      $scope.$parent.$watch($parse($attrs[key]), function(value) {
	        self[key] = angular.isDefined(value) ? value : $attrs[key];
	        $scope[key] = self[key];
	        if ((key == 'minMode' && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key])) || (key == 'maxMode' && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key]))) {
	          $scope.datepickerMode = self[key];
	        }
	      });
	    } else {
	      self[key] = datepickerConfig[key] || null;
	      $scope[key] = self[key];
	    }
	  });
	
	  $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
	  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
	
	  if (angular.isDefined($attrs.initDate)) {
	    this.activeDate = $scope.$parent.$eval($attrs.initDate) || new Date();
	    $scope.$parent.$watch($attrs.initDate, function(initDate) {
	      if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
	        self.activeDate = initDate;
	        self.refreshView();
	      }
	    });
	  } else {
	    this.activeDate = new Date();
	  }
	
	  $scope.isActive = function(dateObject) {
	    if (self.compare(dateObject.date, self.activeDate) === 0) {
	      $scope.activeDateId = dateObject.uid;
	      return true;
	    }
	    return false;
	  };
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	  };
	
	  this.render = function() {
	    if (ngModelCtrl.$viewValue) {
	      var date = new Date(ngModelCtrl.$viewValue),
	          isValid = !isNaN(date);
	
	      if (isValid) {
	        this.activeDate = date;
	      } else if (!$datepickerSuppressError) {
	        $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	      }
	    }
	    this.refreshView();
	  };
	
	  this.refreshView = function() {
	    if (this.element) {
	      this._refreshView();
	
	      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	      ngModelCtrl.$setValidity('dateDisabled', !date || (this.element && !this.isDisabled(date)));
	    }
	  };
	
	  this.createDateObject = function(date, format) {
	    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	    return {
	      date: date,
	      label: dateFilter(date, format),
	      selected: model && this.compare(date, model) === 0,
	      disabled: this.isDisabled(date),
	      current: this.compare(date, new Date()) === 0,
	      customClass: this.customClass(date)
	    };
	  };
	
	  this.isDisabled = function(date) {
	    return ((this.minDate && this.compare(date, this.minDate) < 0) || (this.maxDate && this.compare(date, this.maxDate) > 0) || ($attrs.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode})));
	  };
	
	  this.customClass = function(date) {
	    return $scope.customClass({date: date, mode: $scope.datepickerMode});
	  };
	
	  // Split array into smaller arrays
	  this.split = function(arr, size) {
	    var arrays = [];
	    while (arr.length > 0) {
	      arrays.push(arr.splice(0, size));
	    }
	    return arrays;
	  };
	
	  // Fix a hard-reprodusible bug with timezones
	  // The bug depends on OS, browser, current timezone and current date
	  // i.e.
	  // var date = new Date(2014, 0, 1);
	  // console.log(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours());
	  // can result in "2013 11 31 23" because of the bug.
	  this.fixTimeZone = function(date) {
	    var hours = date.getHours();
	    date.setHours(hours === 23 ? hours + 2 : 0);
	  };
	
	  $scope.select = function(date) {
	    if ($scope.datepickerMode === self.minMode) {
	      var dt = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : new Date(0, 0, 0, 0, 0, 0, 0);
	      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	      ngModelCtrl.$setViewValue(dt);
	      ngModelCtrl.$render();
	    } else {
	      self.activeDate = date;
	      $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];
	    }
	  };
	
	  $scope.move = function(direction) {
	    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
	        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
	    self.activeDate.setFullYear(year, month, 1);
	    self.refreshView();
	  };
	
	  $scope.toggleMode = function(direction) {
	    direction = direction || 1;
	
	    if (($scope.datepickerMode === self.maxMode && direction === 1) || ($scope.datepickerMode === self.minMode && direction === -1)) {
	      return;
	    }
	
	    $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];
	  };
	
	  // Key event mapper
	  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };
	
	  var focusElement = function() {
	    self.element[0].focus();
	  };
	
	  // Listen for focus requests from popup directive
	  $scope.$on('datepicker.focus', focusElement);
	
	  $scope.keydown = function(evt) {
	    var key = $scope.keys[evt.which];
	
	    if (!key || evt.shiftKey || evt.altKey) {
	      return;
	    }
	
	    evt.preventDefault();
	    if (!self.shortcutPropagation) {
	      evt.stopPropagation();
	    }
	
	    if (key === 'enter' || key === 'space') {
	      if (self.isDisabled(self.activeDate)) {
	        return; // do nothing
	      }
	      $scope.select(self.activeDate);
	      focusElement();
	    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
	      $scope.toggleMode(key === 'up' ? 1 : -1);
	      focusElement();
	    } else {
	      self.handleKeyDown(key, evt);
	      self.refreshView();
	    }
	  };
	}])
	
	.directive('datepicker', function() {
	  return {
	    restrict: 'EA',
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/datepicker/datepicker.html';
	    },
	    scope: {
	      datepickerMode: '=?',
	      dateDisabled: '&',
	      customClass: '&',
	      shortcutPropagation: '&?'
	    },
	    require: ['datepicker', '^ngModel'],
	    controller: 'DatepickerController',
	    controllerAs: 'datepicker',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      datepickerCtrl.init(ngModelCtrl);
	    }
	  };
	})
	
	.directive('daypicker', ['dateFilter', function(dateFilter) {
	  return {
	    restrict: 'EA',
	    replace: true,
	    templateUrl: 'template/datepicker/day.html',
	    require: '^datepicker',
	    link: function(scope, element, attrs, ctrl) {
	      scope.showWeeks = ctrl.showWeeks;
	
	      ctrl.step = { months: 1 };
	      ctrl.element = element;
	
	      var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	      function getDaysInMonth(year, month) {
	        return ((month === 1) && (year % 4 === 0) && ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
	      }
	
	      function getDates(startDate, n) {
	        var dates = new Array(n), current = new Date(startDate), i = 0, date;
	        while (i < n) {
	          date = new Date(current);
	          ctrl.fixTimeZone(date);
	          dates[i++] = date;
	          current.setDate(current.getDate() + 1);
	        }
	        return dates;
	      }
	
	      ctrl._refreshView = function() {
	        var year = ctrl.activeDate.getFullYear(),
	          month = ctrl.activeDate.getMonth(),
	          firstDayOfMonth = new Date(year, month, 1),
	          difference = ctrl.startingDay - firstDayOfMonth.getDay(),
	          numDisplayedFromPreviousMonth = (difference > 0) ? 7 - difference : - difference,
	          firstDate = new Date(firstDayOfMonth);
	
	        if (numDisplayedFromPreviousMonth > 0) {
	          firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
	        }
	
	        // 42 is the number of days on a six-month calendar
	        var days = getDates(firstDate, 42);
	        for (var i = 0; i < 42; i ++) {
	          days[i] = angular.extend(ctrl.createDateObject(days[i], ctrl.formatDay), {
	            secondary: days[i].getMonth() !== month,
	            uid: scope.uniqueId + '-' + i
	          });
	        }
	
	        scope.labels = new Array(7);
	        for (var j = 0; j < 7; j++) {
	          scope.labels[j] = {
	            abbr: dateFilter(days[j].date, ctrl.formatDayHeader),
	            full: dateFilter(days[j].date, 'EEEE')
	          };
	        }
	
	        scope.title = dateFilter(ctrl.activeDate, ctrl.formatDayTitle);
	        scope.rows = ctrl.split(days, 7);
	
	        if (scope.showWeeks) {
	          scope.weekNumbers = [];
	          var thursdayIndex = (4 + 7 - ctrl.startingDay) % 7,
	              numWeeks = scope.rows.length;
	          for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
	            scope.weekNumbers.push(
	              getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
	          }
	        }
	      };
	
	      ctrl.compare = function(date1, date2) {
	        return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
	      };
	
	      function getISO8601WeekNumber(date) {
	        var checkDate = new Date(date);
	        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
	        var time = checkDate.getTime();
	        checkDate.setMonth(0); // Compare with Jan 1
	        checkDate.setDate(1);
	        return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	      }
	
	      ctrl.handleKeyDown = function(key, evt) {
	        var date = ctrl.activeDate.getDate();
	
	        if (key === 'left') {
	          date = date - 1;   // up
	        } else if (key === 'up') {
	          date = date - 7;   // down
	        } else if (key === 'right') {
	          date = date + 1;   // down
	        } else if (key === 'down') {
	          date = date + 7;
	        } else if (key === 'pageup' || key === 'pagedown') {
	          var month = ctrl.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
	          ctrl.activeDate.setMonth(month, 1);
	          date = Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth()), date);
	        } else if (key === 'home') {
	          date = 1;
	        } else if (key === 'end') {
	          date = getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth());
	        }
	        ctrl.activeDate.setDate(date);
	      };
	
	      ctrl.refreshView();
	    }
	  };
	}])
	
	.directive('monthpicker', ['dateFilter', function(dateFilter) {
	  return {
	    restrict: 'EA',
	    replace: true,
	    templateUrl: 'template/datepicker/month.html',
	    require: '^datepicker',
	    link: function(scope, element, attrs, ctrl) {
	      ctrl.step = { years: 1 };
	      ctrl.element = element;
	
	      ctrl._refreshView = function() {
	        var months = new Array(12),
	            year = ctrl.activeDate.getFullYear(),
	            date;
	
	        for (var i = 0; i < 12; i++) {
	          date = new Date(year, i, 1);
	          ctrl.fixTimeZone(date);
	          months[i] = angular.extend(ctrl.createDateObject(date, ctrl.formatMonth), {
	            uid: scope.uniqueId + '-' + i
	          });
	        }
	
	        scope.title = dateFilter(ctrl.activeDate, ctrl.formatMonthTitle);
	        scope.rows = ctrl.split(months, 3);
	      };
	
	      ctrl.compare = function(date1, date2) {
	        return new Date(date1.getFullYear(), date1.getMonth()) - new Date(date2.getFullYear(), date2.getMonth());
	      };
	
	      ctrl.handleKeyDown = function(key, evt) {
	        var date = ctrl.activeDate.getMonth();
	
	        if (key === 'left') {
	          date = date - 1;   // up
	        } else if (key === 'up') {
	          date = date - 3;   // down
	        } else if (key === 'right') {
	          date = date + 1;   // down
	        } else if (key === 'down') {
	          date = date + 3;
	        } else if (key === 'pageup' || key === 'pagedown') {
	          var year = ctrl.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
	          ctrl.activeDate.setFullYear(year);
	        } else if (key === 'home') {
	          date = 0;
	        } else if (key === 'end') {
	          date = 11;
	        }
	        ctrl.activeDate.setMonth(date);
	      };
	
	      ctrl.refreshView();
	    }
	  };
	}])
	
	.directive('yearpicker', ['dateFilter', function(dateFilter) {
	  return {
	    restrict: 'EA',
	    replace: true,
	    templateUrl: 'template/datepicker/year.html',
	    require: '^datepicker',
	    link: function(scope, element, attrs, ctrl) {
	      var range = ctrl.yearRange;
	
	      ctrl.step = { years: range };
	      ctrl.element = element;
	
	      function getStartingYear( year ) {
	        return parseInt((year - 1) / range, 10) * range + 1;
	      }
	
	      ctrl._refreshView = function() {
	        var years = new Array(range), date;
	
	        for (var i = 0, start = getStartingYear(ctrl.activeDate.getFullYear()); i < range; i++) {
	          date = new Date(start + i, 0, 1);
	          ctrl.fixTimeZone(date);
	          years[i] = angular.extend(ctrl.createDateObject(date, ctrl.formatYear), {
	            uid: scope.uniqueId + '-' + i
	          });
	        }
	
	        scope.title = [years[0].label, years[range - 1].label].join(' - ');
	        scope.rows = ctrl.split(years, 5);
	      };
	
	      ctrl.compare = function(date1, date2) {
	        return date1.getFullYear() - date2.getFullYear();
	      };
	
	      ctrl.handleKeyDown = function(key, evt) {
	        var date = ctrl.activeDate.getFullYear();
	
	        if (key === 'left') {
	          date = date - 1;   // up
	        } else if (key === 'up') {
	          date = date - 5;   // down
	        } else if (key === 'right') {
	          date = date + 1;   // down
	        } else if (key === 'down') {
	          date = date + 5;
	        } else if (key === 'pageup' || key === 'pagedown') {
	          date += (key === 'pageup' ? - 1 : 1) * ctrl.step.years;
	        } else if (key === 'home') {
	          date = getStartingYear(ctrl.activeDate.getFullYear());
	        } else if (key === 'end') {
	          date = getStartingYear(ctrl.activeDate.getFullYear()) + range - 1;
	        }
	        ctrl.activeDate.setFullYear(date);
	      };
	
	      ctrl.refreshView();
	    }
	  };
	}])
	
	.constant('datepickerPopupConfig', {
	  datepickerPopup: 'yyyy-MM-dd',
	  datepickerPopupTemplateUrl: 'template/datepicker/popup.html',
	  datepickerTemplateUrl: 'template/datepicker/datepicker.html',
	  html5Types: {
	    date: 'yyyy-MM-dd',
	    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
	    'month': 'yyyy-MM'
	  },
	  currentText: 'Today',
	  clearText: 'Clear',
	  closeText: 'Done',
	  closeOnDateSelection: true,
	  appendToBody: false,
	  showButtonBar: true,
	  onOpenFocus: true
	})
	
	.directive('datepickerPopup', ['$compile', '$parse', '$document', '$rootScope', '$position', 'dateFilter', 'dateParser', 'datepickerPopupConfig', '$timeout',
	function($compile, $parse, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout) {
	  return {
	    restrict: 'EA',
	    require: 'ngModel',
	    scope: {
	      isOpen: '=?',
	      currentText: '@',
	      clearText: '@',
	      closeText: '@',
	      dateDisabled: '&',
	      customClass: '&'
	    },
	    link: function(scope, element, attrs, ngModel) {
	      var dateFormat,
	          closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection,
	          appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody,
	          onOpenFocus = angular.isDefined(attrs.onOpenFocus) ? scope.$parent.$eval(attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus,
	          datepickerPopupTemplateUrl = angular.isDefined(attrs.datepickerPopupTemplateUrl) ? attrs.datepickerPopupTemplateUrl : datepickerPopupConfig.datepickerPopupTemplateUrl,
	          datepickerTemplateUrl = angular.isDefined(attrs.datepickerTemplateUrl) ? attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl,
	          cache = {};
	
	      scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;
	
	      scope.getText = function(key) {
	        return scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
	      };
	
	      scope.isDisabled = function(date) {
	        if (date === 'today') {
	          date = new Date();
	        }
	
	        return ((scope.watchData.minDate && scope.compare(date, cache.minDate) < 0) ||
	          (scope.watchData.maxDate && scope.compare(date, cache.maxDate) > 0));
	      };
	
	      scope.compare = function(date1, date2) {
	        return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
	      };
	
	      var isHtml5DateInput = false;
	      if (datepickerPopupConfig.html5Types[attrs.type]) {
	        dateFormat = datepickerPopupConfig.html5Types[attrs.type];
	        isHtml5DateInput = true;
	      } else {
	        dateFormat = attrs.datepickerPopup || datepickerPopupConfig.datepickerPopup;
	        attrs.$observe('datepickerPopup', function(value, oldValue) {
	            var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
	            // Invalidate the $modelValue to ensure that formatters re-run
	            // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
	            if (newDateFormat !== dateFormat) {
	              dateFormat = newDateFormat;
	              ngModel.$modelValue = null;
	
	              if (!dateFormat) {
	                throw new Error('datepickerPopup must have a date format specified.');
	              }
	            }
	        });
	      }
	
	      if (!dateFormat) {
	        throw new Error('datepickerPopup must have a date format specified.');
	      }
	
	      if (isHtml5DateInput && attrs.datepickerPopup) {
	        throw new Error('HTML5 date input types do not support custom formats.');
	      }
	
	      // popup element used to display calendar
	      var popupEl = angular.element('<div datepicker-popup-wrap><div datepicker></div></div>');
	      popupEl.attr({
	        'ng-model': 'date',
	        'ng-change': 'dateSelection(date)',
	        'template-url': datepickerPopupTemplateUrl
	      });
	
	      function cameltoDash(string) {
	        return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
	      }
	
	      // datepicker element
	      var datepickerEl = angular.element(popupEl.children()[0]);
	      datepickerEl.attr('template-url', datepickerTemplateUrl);
	
	      if (isHtml5DateInput) {
	        if (attrs.type === 'month') {
	          datepickerEl.attr('datepicker-mode', '"month"');
	          datepickerEl.attr('min-mode', 'month');
	        }
	      }
	
	      if (attrs.datepickerOptions) {
	        var options = scope.$parent.$eval(attrs.datepickerOptions);
	        if (options && options.initDate) {
	          scope.initDate = options.initDate;
	          datepickerEl.attr('init-date', 'initDate');
	          delete options.initDate;
	        }
	        angular.forEach(options, function(value, option) {
	          datepickerEl.attr( cameltoDash(option), value );
	        });
	      }
	
	      scope.watchData = {};
	      angular.forEach(['minMode', 'maxMode', 'minDate', 'maxDate', 'datepickerMode', 'initDate', 'shortcutPropagation'], function(key) {
	        if (attrs[key]) {
	          var getAttribute = $parse(attrs[key]);
	          scope.$parent.$watch(getAttribute, function(value) {
	            scope.watchData[key] = value;
	            if (key === 'minDate' || key === 'maxDate') {
	              cache[key] = new Date(value);
	            }
	          });
	          datepickerEl.attr(cameltoDash(key), 'watchData.' + key);
	
	          // Propagate changes from datepicker to outside
	          if (key === 'datepickerMode') {
	            var setAttribute = getAttribute.assign;
	            scope.$watch('watchData.' + key, function(value, oldvalue) {
	              if (angular.isFunction(setAttribute) && value !== oldvalue) {
	                setAttribute(scope.$parent, value);
	              }
	            });
	          }
	        }
	      });
	      if (attrs.dateDisabled) {
	        datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
	      }
	
	      if (attrs.showWeeks) {
	        datepickerEl.attr('show-weeks', attrs.showWeeks);
	      }
	
	      if (attrs.customClass) {
	        datepickerEl.attr('custom-class', 'customClass({ date: date, mode: mode })');
	      }
	
	      function parseDate(viewValue) {
	        if (angular.isNumber(viewValue)) {
	          // presumably timestamp to date object
	          viewValue = new Date(viewValue);
	        }
	
	        if (!viewValue) {
	          return null;
	        } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
	          return viewValue;
	        } else if (angular.isString(viewValue)) {
	          var date = dateParser.parse(viewValue, dateFormat, scope.date);
	          if (isNaN(date)) {
	            return undefined;
	          } else {
	            return date;
	          }
	        } else {
	          return undefined;
	        }
	      }
	
	      function validator(modelValue, viewValue) {
	        var value = modelValue || viewValue;
	
	        if (!attrs.ngRequired && !value) {
	          return true;
	        }
	
	        if (angular.isNumber(value)) {
	          value = new Date(value);
	        }
	        if (!value) {
	          return true;
	        } else if (angular.isDate(value) && !isNaN(value)) {
	          return true;
	        } else if (angular.isString(value)) {
	          var date = dateParser.parse(value, dateFormat);
	          return !isNaN(date);
	        } else {
	          return false;
	        }
	      }
	
	      if (!isHtml5DateInput) {
	        // Internal API to maintain the correct ng-invalid-[key] class
	        ngModel.$$parserName = 'date';
	        ngModel.$validators.date = validator;
	        ngModel.$parsers.unshift(parseDate);
	        ngModel.$formatters.push(function(value) {
	          scope.date = value;
	          return ngModel.$isEmpty(value) ? value : dateFilter(value, dateFormat);
	        });
	      } else {
	        ngModel.$formatters.push(function(value) {
	          scope.date = value;
	          return value;
	        });
	      }
	
	      // Inner change
	      scope.dateSelection = function(dt) {
	        if (angular.isDefined(dt)) {
	          scope.date = dt;
	        }
	        var date = scope.date ? dateFilter(scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
	        element.val(date);
	        ngModel.$setViewValue(date);
	
	        if (closeOnDateSelection) {
	          scope.isOpen = false;
	          element[0].focus();
	        }
	      };
	
	      // Detect changes in the view from the text box
	      ngModel.$viewChangeListeners.push(function() {
	        scope.date = dateParser.parse(ngModel.$viewValue, dateFormat, scope.date);
	      });
	
	      var documentClickBind = function(event) {
	        if (scope.isOpen && !(element[0].contains(event.target) || popupEl[0].contains(event.target))) {
	          scope.$apply(function() {
	            scope.isOpen = false;
	          });
	        }
	      };
	
	      var inputKeydownBind = function(evt) {
	        if (evt.which === 27 && scope.isOpen) {
	          evt.preventDefault();
	          evt.stopPropagation();
	          scope.$apply(function() {
	            scope.isOpen = false;
	          });
	          element[0].focus();
	        } else if (evt.which === 40 && !scope.isOpen) {
	          evt.preventDefault();
	          evt.stopPropagation();
	          scope.$apply(function() {
	            scope.isOpen = true;
	          });
	        }
	      };
	      element.bind('keydown', inputKeydownBind);
	
	      scope.keydown = function(evt) {
	        if (evt.which === 27) {
	          scope.isOpen = false;
	          element[0].focus();
	        }
	      };
	
	      scope.$watch('isOpen', function(value) {
	        if (value) {
	          scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	          scope.position.top = scope.position.top + element.prop('offsetHeight');
	
	          $timeout(function() {
	            if (onOpenFocus) {
	              scope.$broadcast('datepicker.focus');
	            }
	            $document.bind('click', documentClickBind);
	          }, 0, false);
	        } else {
	          $document.unbind('click', documentClickBind);
	        }
	      });
	
	      scope.select = function(date) {
	        if (date === 'today') {
	          var today = new Date();
	          if (angular.isDate(scope.date)) {
	            date = new Date(scope.date);
	            date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
	          } else {
	            date = new Date(today.setHours(0, 0, 0, 0));
	          }
	        }
	        scope.dateSelection(date);
	      };
	
	      scope.close = function() {
	        scope.isOpen = false;
	        element[0].focus();
	      };
	
	      var $popup = $compile(popupEl)(scope);
	      // Prevent jQuery cache memory leak (template is now redundant after linking)
	      popupEl.remove();
	
	      if (appendToBody) {
	        $document.find('body').append($popup);
	      } else {
	        element.after($popup);
	      }
	
	      scope.$on('$destroy', function() {
	        if (scope.isOpen === true) {
	          if (!$rootScope.$$phase) {
	            scope.$apply(function() {
	              scope.isOpen = false;
	            });
	          }
	        }
	
	        $popup.remove();
	        element.unbind('keydown', inputKeydownBind);
	        $document.unbind('click', documentClickBind);
	      });
	    }
	  };
	}])
	
	.directive('datepickerPopupWrap', function() {
	  return {
	    restrict:'EA',
	    replace: true,
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/datepicker/popup.html';
	    }
	  };
	});
	
	angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.position'])
	
	.constant('dropdownConfig', {
	  openClass: 'open'
	})
	
	.service('dropdownService', ['$document', '$rootScope', function($document, $rootScope) {
	  var openScope = null;
	
	  this.open = function(dropdownScope) {
	    if (!openScope) {
	      $document.bind('click', closeDropdown);
	      $document.bind('keydown', keybindFilter);
	    }
	
	    if (openScope && openScope !== dropdownScope) {
	      openScope.isOpen = false;
	    }
	
	    openScope = dropdownScope;
	  };
	
	  this.close = function(dropdownScope) {
	    if (openScope === dropdownScope) {
	      openScope = null;
	      $document.unbind('click', closeDropdown);
	      $document.unbind('keydown', keybindFilter);
	    }
	  };
	
	  var closeDropdown = function(evt) {
	    // This method may still be called during the same mouse event that
	    // unbound this event handler. So check openScope before proceeding.
	    if (!openScope) { return; }
	
	    if (evt && openScope.getAutoClose() === 'disabled')  { return ; }
	
	    var toggleElement = openScope.getToggleElement();
	    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    if (evt && openScope.getAutoClose() === 'outsideClick' &&
	      dropdownElement && dropdownElement[0].contains(evt.target)) {
	      return;
	    }
	
	    openScope.isOpen = false;
	
	    if (!$rootScope.$$phase) {
	      openScope.$apply();
	    }
	  };
	
	  var keybindFilter = function(evt) {
	    if (evt.which === 27) {
	      openScope.focusToggleElement();
	      closeDropdown();
	    } else if (openScope.isKeynavEnabled() && /(38|40)/.test(evt.which) && openScope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      openScope.focusDropdownEntry(evt.which);
	    }
	  };
	}])
	
	.controller('DropdownController', ['$scope', '$attrs', '$parse', 'dropdownConfig', 'dropdownService', '$animate', '$position', '$document', '$compile', '$templateRequest', function($scope, $attrs, $parse, dropdownConfig, dropdownService, $animate, $position, $document, $compile, $templateRequest) {
	  var self = this,
	    scope = $scope.$new(), // create a child scope so we are not polluting original one
	    templateScope,
	    openClass = dropdownConfig.openClass,
	    getIsOpen,
	    setIsOpen = angular.noop,
	    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
	    appendToBody = false,
	    keynavEnabled = false,
	    selectedOption = null,
	    body = $document.find('body');
	
	  this.init = function(element) {
	    self.$element = element;
	
	    if ($attrs.isOpen) {
	      getIsOpen = $parse($attrs.isOpen);
	      setIsOpen = getIsOpen.assign;
	
	      $scope.$watch(getIsOpen, function(value) {
	        scope.isOpen = !!value;
	      });
	    }
	
	    appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
	    keynavEnabled = angular.isDefined($attrs.keyboardNav);
	
	    if (appendToBody && self.dropdownMenu) {
	      body.append(self.dropdownMenu);
	      body.addClass('dropdown');
	      element.on('$destroy', function handleDestroyEvent() {
	        self.dropdownMenu.remove();
	      });
	    }
	  };
	
	  this.toggle = function(open) {
	    return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	  };
	
	  // Allow other directives to watch status
	  this.isOpen = function() {
	    return scope.isOpen;
	  };
	
	  scope.getToggleElement = function() {
	    return self.toggleElement;
	  };
	
	  scope.getAutoClose = function() {
	    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
	  };
	
	  scope.getElement = function() {
	    return self.$element;
	  };
	
	  scope.isKeynavEnabled = function() {
	    return keynavEnabled;
	  };
	
	  scope.focusDropdownEntry = function(keyCode) {
	    var elems = self.dropdownMenu ? //If append to body is used.
	      (angular.element(self.dropdownMenu).find('a')) :
	      (angular.element(self.$element).find('ul').eq(0).find('a'));
	
	    switch (keyCode) {
	      case (40): {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = 0;
	        } else {
	          self.selectedOption = (self.selectedOption === elems.length -1 ?
	            self.selectedOption :
	            self.selectedOption + 1);
	        }
	        break;
	      }
	      case (38): {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = elems.length - 1;
	        } else {
	          self.selectedOption = self.selectedOption === 0 ?
	            0 : self.selectedOption - 1;
	        }
	        break;
	      }
	    }
	    elems[self.selectedOption].focus();
	  };
	
	  scope.getDropdownElement = function() {
	    return self.dropdownMenu;
	  };
	
	  scope.focusToggleElement = function() {
	    if (self.toggleElement) {
	      self.toggleElement[0].focus();
	    }
	  };
	
	  scope.$watch('isOpen', function(isOpen, wasOpen) {
	    if (appendToBody && self.dropdownMenu) {
	      var pos = $position.positionElements(self.$element, self.dropdownMenu, 'bottom-left', true);
	      var css = {
	        top: pos.top + 'px',
	        display: isOpen ? 'block' : 'none'
	      };
	
	      var rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
	      if (!rightalign) {
	        css.left = pos.left + 'px';
	        css.right = 'auto';
	      } else {
	        css.left = 'auto';
	        css.right = (window.innerWidth - (pos.left + self.$element.prop('offsetWidth'))) + 'px';
	      }
	
	      self.dropdownMenu.css(css);
	    }
	
	    var openContainer = appendToBody ? body : self.$element;
	
	    $animate[isOpen ? 'addClass' : 'removeClass'](openContainer, openClass).then(function() {
	      if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	        toggleInvoker($scope, { open: !!isOpen });
	      }
	    });
	
	    if (isOpen) {
	      if (self.dropdownMenuTemplateUrl) {
	        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
	          templateScope = scope.$new();
	          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
	            var newEl = dropdownElement;
	            self.dropdownMenu.replaceWith(newEl);
	            self.dropdownMenu = newEl;
	          });
	        });
	      }
	
	      scope.focusToggleElement();
	      dropdownService.open(scope);
	    } else {
	      if (self.dropdownMenuTemplateUrl) {
	        if (templateScope) {
	          templateScope.$destroy();
	        }
	        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
	        self.dropdownMenu.replaceWith(newEl);
	        self.dropdownMenu = newEl;
	      }
	
	      dropdownService.close(scope);
	      self.selectedOption = null;
	    }
	
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen($scope, isOpen);
	    }
	  });
	
	  $scope.$on('$locationChangeSuccess', function() {
	    if (scope.getAutoClose() !== 'disabled') {
	      scope.isOpen = false;
	    }
	  });
	
	  var offDestroy = $scope.$on('$destroy', function() {
	    scope.$destroy();
	  });
	  scope.$on('$destroy', offDestroy);
	}])
	
	.directive('dropdown', function() {
	  return {
	    controller: 'DropdownController',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      dropdownCtrl.init( element );
	      element.addClass('dropdown');
	    }
	  };
	})
	
	.directive('dropdownMenu', function() {
	  return {
	    restrict: 'AC',
	    require: '?^dropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl) {
	        return;
	      }
	      var tplUrl = attrs.templateUrl;
	      if (tplUrl) {
	        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
	      }
	      if (!dropdownCtrl.dropdownMenu) {
	        dropdownCtrl.dropdownMenu = element;
	      }
	    }
	  };
	})
	
	.directive('keyboardNav', function() {
	  return {
	    restrict: 'A',
	    require: '?^dropdown',
	    link: function (scope, element, attrs, dropdownCtrl) {
	
	      element.bind('keydown', function(e) {
	        if ([38, 40].indexOf(e.which) !== -1) {
	          e.preventDefault();
	          e.stopPropagation();
	
	          var elems = dropdownCtrl.dropdownMenu.find('a');
	
	          switch (e.which) {
	            case (40): { // Down
	              if (!angular.isNumber(dropdownCtrl.selectedOption)) {
	                dropdownCtrl.selectedOption = 0;
	              } else {
	                dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === elems.length -1 ?
	                  dropdownCtrl.selectedOption : dropdownCtrl.selectedOption + 1;
	              }
	              break;
	            }
	            case (38): { // Up
	              if (!angular.isNumber(dropdownCtrl.selectedOption)) {
	                dropdownCtrl.selectedOption = elems.length - 1;
	              } else {
	                dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === 0 ?
	                  0 : dropdownCtrl.selectedOption - 1;
	              }
	              break;
	            }
	          }
	          elems[dropdownCtrl.selectedOption].focus();
	        }
	      });
	    }
	  };
	})
	
	.directive('dropdownToggle', function() {
	  return {
	    require: '?^dropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl) {
	        return;
	      }
	
	      element.addClass('dropdown-toggle');
	
	      dropdownCtrl.toggleElement = element;
	
	      var toggleDropdown = function(event) {
	        event.preventDefault();
	
	        if (!element.hasClass('disabled') && !attrs.disabled) {
	          scope.$apply(function() {
	            dropdownCtrl.toggle();
	          });
	        }
	      };
	
	      element.bind('click', toggleDropdown);
	
	      // WAI-ARIA
	      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	      scope.$watch(dropdownCtrl.isOpen, function( isOpen ) {
	        element.attr('aria-expanded', !!isOpen);
	      });
	
	      scope.$on('$destroy', function() {
	        element.unbind('click', toggleDropdown);
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.modal', [])
	
	/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */
	  .factory('$$stackedMap', function() {
	    return {
	      createNew: function() {
	        var stack = [];
	
	        return {
	          add: function(key, value) {
	            stack.push({
	              key: key,
	              value: value
	            });
	          },
	          get: function(key) {
	            for (var i = 0; i < stack.length; i++) {
	              if (key == stack[i].key) {
	                return stack[i];
	              }
	            }
	          },
	          keys: function() {
	            var keys = [];
	            for (var i = 0; i < stack.length; i++) {
	              keys.push(stack[i].key);
	            }
	            return keys;
	          },
	          top: function() {
	            return stack[stack.length - 1];
	          },
	          remove: function(key) {
	            var idx = -1;
	            for (var i = 0; i < stack.length; i++) {
	              if (key == stack[i].key) {
	                idx = i;
	                break;
	              }
	            }
	            return stack.splice(idx, 1)[0];
	          },
	          removeTop: function() {
	            return stack.splice(stack.length - 1, 1)[0];
	          },
	          length: function() {
	            return stack.length;
	          }
	        };
	      }
	    };
	  })
	
	/**
	 * A helper, internal data structure that stores all references attached to key
	 */
	  .factory('$$multiMap', function() {
	    return {
	      createNew: function() {
	        var map = {};
	
	        return {
	          entries: function() {
	            return Object.keys(map).map(function(key) {
	              return {
	                key: key,
	                value: map[key]
	              };
	            });
	          },
	          get: function(key) {
	            return map[key];
	          },
	          hasKey: function(key) {
	            return !!map[key];
	          },
	          keys: function() {
	            return Object.keys(map);
	          },
	          put: function(key, value) {
	            if (!map[key]) {
	              map[key] = [];
	            }
	
	            map[key].push(value);
	          },
	          remove: function(key, value) {
	            var values = map[key];
	
	            if (!values) {
	              return;
	            }
	
	            var idx = values.indexOf(value);
	
	            if (idx !== -1) {
	              values.splice(idx, 1);
	            }
	
	            if (!values.length) {
	              delete map[key];
	            }
	          }
	        };
	      }
	    };
	  })
	
	/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */
	  .directive('modalBackdrop', [
	           '$animate', '$injector', '$modalStack',
	  function($animate ,  $injector,   $modalStack) {
	    var $animateCss = null;
	
	    if ($injector.has('$animateCss')) {
	      $animateCss = $injector.get('$animateCss');
	    }
	
	    return {
	      restrict: 'EA',
	      replace: true,
	      templateUrl: 'template/modal/backdrop.html',
	      compile: function(tElement, tAttrs) {
	        tElement.addClass(tAttrs.backdropClass);
	        return linkFn;
	      }
	    };
	
	    function linkFn(scope, element, attrs) {
	      if (attrs.modalInClass) {
	        if ($animateCss) {
	          $animateCss(element, {
	            addClass: attrs.modalInClass
	          }).start();
	        } else {
	          $animate.addClass(element, attrs.modalInClass);
	        }
	
	        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	          var done = setIsAsync();
	          if ($animateCss) {
	            $animateCss(element, {
	              removeClass: attrs.modalInClass
	            }).start().then(done);
	          } else {
	            $animate.removeClass(element, attrs.modalInClass).then(done);
	          }
	        });
	      }
	    }
	  }])
	
	  .directive('modalWindow', [
	           '$modalStack', '$q', '$animate', '$injector',
	  function($modalStack ,  $q ,  $animate,   $injector) {
	    var $animateCss = null;
	
	    if ($injector.has('$animateCss')) {
	      $animateCss = $injector.get('$animateCss');
	    }
	
	    return {
	      restrict: 'EA',
	      scope: {
	        index: '@'
	      },
	      replace: true,
	      transclude: true,
	      templateUrl: function(tElement, tAttrs) {
	        return tAttrs.templateUrl || 'template/modal/window.html';
	      },
	      link: function(scope, element, attrs) {
	        element.addClass(attrs.windowClass || '');
	        scope.size = attrs.size;
	
	        scope.close = function(evt) {
	          var modal = $modalStack.getTop();
	          if (modal && modal.value.backdrop && modal.value.backdrop !== 'static' && (evt.target === evt.currentTarget)) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            $modalStack.dismiss(modal.key, 'backdrop click');
	          }
	        };
	
	        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	        // We can detect that by using this property in the template associated with this directive and then use
	        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	        scope.$isRendered = true;
	
	        // Deferred object that will be resolved when this modal is render.
	        var modalRenderDeferObj = $q.defer();
	        // Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
	        // In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
	        attrs.$observe('modalRender', function(value) {
	          if (value == 'true') {
	            modalRenderDeferObj.resolve();
	          }
	        });
	
	        modalRenderDeferObj.promise.then(function() {
	          var animationPromise = null;
	
	          if (attrs.modalInClass) {
	            if ($animateCss) {
	              animationPromise = $animateCss(element, {
	                addClass: attrs.modalInClass
	              }).start();
	            } else {
	              animationPromise = $animate.addClass(element, attrs.modalInClass);
	            }
	
	            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	              var done = setIsAsync();
	              if ($animateCss) {
	                $animateCss(element, {
	                  removeClass: attrs.modalInClass
	                }).start().then(done);
	              } else {
	                $animate.removeClass(element, attrs.modalInClass).then(done);
	              }
	            });
	          }
	
	
	          $q.when(animationPromise).then(function() {
	            var inputsWithAutofocus = element[0].querySelectorAll('[autofocus]');
	            /**
	             * Auto-focusing of a freshly-opened modal element causes any child elements
	             * with the autofocus attribute to lose focus. This is an issue on touch
	             * based devices which will show and then hide the onscreen keyboard.
	             * Attempts to refocus the autofocus element via JavaScript will not reopen
	             * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	             * the modal element if the modal does not contain an autofocus element.
	             */
	            if (inputsWithAutofocus.length) {
	              inputsWithAutofocus[0].focus();
	            } else {
	              element[0].focus();
	            }
	          });
	
	          // Notify {@link $modalStack} that modal is rendered.
	          var modal = $modalStack.getTop();
	          if (modal) {
	            $modalStack.modalRendered(modal.key);
	          }
	        });
	      }
	    };
	  }])
	
	  .directive('modalAnimationClass', [
	    function () {
	      return {
	        compile: function(tElement, tAttrs) {
	          if (tAttrs.modalAnimation) {
	            tElement.addClass(tAttrs.modalAnimationClass);
	          }
	        }
	      };
	    }])
	
	  .directive('modalTransclude', function() {
	    return {
	      link: function($scope, $element, $attrs, controller, $transclude) {
	        $transclude($scope.$parent, function(clone) {
	          $element.empty();
	          $element.append(clone);
	        });
	      }
	    };
	  })
	
	  .factory('$modalStack', [
	             '$animate', '$timeout', '$document', '$compile', '$rootScope',
	             '$q',
	             '$injector',
	             '$$multiMap',
	             '$$stackedMap',
	    function($animate ,  $timeout ,  $document ,  $compile ,  $rootScope ,
	              $q,
	              $injector,
	              $$multiMap,
	              $$stackedMap) {
	      var $animateCss = null;
	
	      if ($injector.has('$animateCss')) {
	        $animateCss = $injector.get('$animateCss');
	      }
	
	      var OPENED_MODAL_CLASS = 'modal-open';
	
	      var backdropDomEl, backdropScope;
	      var openedWindows = $$stackedMap.createNew();
	      var openedClasses = $$multiMap.createNew();
	      var $modalStack = {
	        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
	      };
	
	      //Modal focus behavior
	      var focusableElementList;
	      var focusIndex = 0;
	      var tababbleSelector = 'a[href], area[href], input:not([disabled]), ' +
	        'button:not([disabled]),select:not([disabled]), textarea:not([disabled]), ' +
	        'iframe, object, embed, *[tabindex], *[contenteditable=true]';
	
	      function backdropIndex() {
	        var topBackdropIndex = -1;
	        var opened = openedWindows.keys();
	        for (var i = 0; i < opened.length; i++) {
	          if (openedWindows.get(opened[i]).value.backdrop) {
	            topBackdropIndex = i;
	          }
	        }
	        return topBackdropIndex;
	      }
	
	      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
	        if (backdropScope) {
	          backdropScope.index = newBackdropIndex;
	        }
	      });
	
	      function removeModalWindow(modalInstance, elementToReceiveFocus) {
	        var body = $document.find('body').eq(0);
	        var modalWindow = openedWindows.get(modalInstance).value;
	
	        //clean up the stack
	        openedWindows.remove(modalInstance);
	
	        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
	          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
	          openedClasses.remove(modalBodyClass, modalInstance);
	          body.toggleClass(modalBodyClass, openedClasses.hasKey(modalBodyClass));
	        });
	        checkRemoveBackdrop();
	
	        //move focus to specified element if available, or else to body
	        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
	          elementToReceiveFocus.focus();
	        } else {
	          body.focus();
	        }
	      }
	
	      function checkRemoveBackdrop() {
	          //remove backdrop if no longer needed
	          if (backdropDomEl && backdropIndex() == -1) {
	            var backdropScopeRef = backdropScope;
	            removeAfterAnimate(backdropDomEl, backdropScope, function() {
	              backdropScopeRef = null;
	            });
	            backdropDomEl = undefined;
	            backdropScope = undefined;
	          }
	      }
	
	      function removeAfterAnimate(domEl, scope, done) {
	        var asyncDeferred;
	        var asyncPromise = null;
	        var setIsAsync = function() {
	          if (!asyncDeferred) {
	            asyncDeferred = $q.defer();
	            asyncPromise = asyncDeferred.promise;
	          }
	
	          return function asyncDone() {
	            asyncDeferred.resolve();
	          };
	        };
	        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);
	
	        // Note that it's intentional that asyncPromise might be null.
	        // That's when setIsAsync has not been called during the
	        // NOW_CLOSING_EVENT broadcast.
	        return $q.when(asyncPromise).then(afterAnimating);
	
	        function afterAnimating() {
	          if (afterAnimating.done) {
	            return;
	          }
	          afterAnimating.done = true;
	
	          if ($animateCss) {
	            $animateCss(domEl, {
	              event: 'leave'
	            }).start().then(function() {
	              domEl.remove();
	            });
	          } else {
	            $animate.leave(domEl);
	          }
	          scope.$destroy();
	          if (done) {
	            done();
	          }
	        }
	      }
	
	      $document.bind('keydown', function(evt) {
	        if (evt.isDefaultPrevented()) {
	          return evt;
	        }
	
	        var modal = openedWindows.top();
	        if (modal && modal.value.keyboard) {
	          switch (evt.which){
	            case 27: {
	              evt.preventDefault();
	              $rootScope.$apply(function() {
	                $modalStack.dismiss(modal.key, 'escape key press');
	              });
	              break;
	            }
	            case 9: {
	              $modalStack.loadFocusElementList(modal);
	              var focusChanged = false;
	              if (evt.shiftKey) {
	                if ($modalStack.isFocusInFirstItem(evt)) {
	                  focusChanged = $modalStack.focusLastFocusableElement();
	                }
	              } else {
	                if ($modalStack.isFocusInLastItem(evt)) {
	                  focusChanged = $modalStack.focusFirstFocusableElement();
	                }
	              }
	
	              if (focusChanged) {
	                evt.preventDefault();
	                evt.stopPropagation();
	              }
	              break;
	            }
	          }
	        }
	      });
	
	      $modalStack.open = function(modalInstance, modal) {
	        var modalOpener = $document[0].activeElement,
	          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;
	
	        openedWindows.add(modalInstance, {
	          deferred: modal.deferred,
	          renderDeferred: modal.renderDeferred,
	          modalScope: modal.scope,
	          backdrop: modal.backdrop,
	          keyboard: modal.keyboard,
	          openedClass: modal.openedClass
	        });
	
	        openedClasses.put(modalBodyClass, modalInstance);
	
	        var body = $document.find('body').eq(0),
	            currBackdropIndex = backdropIndex();
	
	        if (currBackdropIndex >= 0 && !backdropDomEl) {
	          backdropScope = $rootScope.$new(true);
	          backdropScope.index = currBackdropIndex;
	          var angularBackgroundDomEl = angular.element('<div modal-backdrop="modal-backdrop"></div>');
	          angularBackgroundDomEl.attr('backdrop-class', modal.backdropClass);
	          if (modal.animation) {
	            angularBackgroundDomEl.attr('modal-animation', 'true');
	          }
	          backdropDomEl = $compile(angularBackgroundDomEl)(backdropScope);
	          body.append(backdropDomEl);
	        }
	
	        var angularDomEl = angular.element('<div modal-window="modal-window"></div>');
	        angularDomEl.attr({
	          'template-url': modal.windowTemplateUrl,
	          'window-class': modal.windowClass,
	          'size': modal.size,
	          'index': openedWindows.length() - 1,
	          'animate': 'animate'
	        }).html(modal.content);
	        if (modal.animation) {
	          angularDomEl.attr('modal-animation', 'true');
	        }
	
	        var modalDomEl = $compile(angularDomEl)(modal.scope);
	        openedWindows.top().value.modalDomEl = modalDomEl;
	        openedWindows.top().value.modalOpener = modalOpener;
	        body.append(modalDomEl);
	        body.addClass(modalBodyClass);
	
	        $modalStack.clearFocusListCache();
	      };
	
	      function broadcastClosing(modalWindow, resultOrReason, closing) {
	          return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
	      }
	
	      $modalStack.close = function(modalInstance, result) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.resolve(result);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	        return !modalWindow;
	      };
	
	      $modalStack.dismiss = function(modalInstance, reason) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.reject(reason);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	        return !modalWindow;
	      };
	
	      $modalStack.dismissAll = function(reason) {
	        var topModal = this.getTop();
	        while (topModal && this.dismiss(topModal.key, reason)) {
	          topModal = this.getTop();
	        }
	      };
	
	      $modalStack.getTop = function() {
	        return openedWindows.top();
	      };
	
	      $modalStack.modalRendered = function(modalInstance) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow) {
	          modalWindow.value.renderDeferred.resolve();
	        }
	      };
	
	      $modalStack.focusFirstFocusableElement = function() {
	        if (focusableElementList.length > 0) {
	          focusableElementList[0].focus();
	          return true;
	        }
	        return false;
	      };
	      $modalStack.focusLastFocusableElement = function() {
	        if (focusableElementList.length > 0) {
	          focusableElementList[focusableElementList.length - 1].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInFirstItem = function(evt) {
	        if (focusableElementList.length > 0) {
	          return (evt.target || evt.srcElement) == focusableElementList[0];
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInLastItem = function(evt) {
	        if (focusableElementList.length > 0) {
	          return (evt.target || evt.srcElement) == focusableElementList[focusableElementList.length - 1];
	        }
	        return false;
	      };
	
	      $modalStack.clearFocusListCache = function() {
	        focusableElementList = [];
	        focusIndex = 0;
	      };
	
	      $modalStack.loadFocusElementList = function(modalWindow) {
	        if (focusableElementList === undefined || !focusableElementList.length0) {
	          if (modalWindow) {
	            var modalDomE1 = modalWindow.value.modalDomEl;
	            if (modalDomE1 && modalDomE1.length) {
	              focusableElementList = modalDomE1[0].querySelectorAll(tababbleSelector);
	            }
	          }
	        }
	      };
	
	      return $modalStack;
	    }])
	
	  .provider('$modal', function() {
	    var $modalProvider = {
	      options: {
	        animation: true,
	        backdrop: true, //can also be false or 'static'
	        keyboard: true
	      },
	      $get: ['$injector', '$rootScope', '$q', '$templateRequest', '$controller', '$modalStack',
	        function ($injector, $rootScope, $q, $templateRequest, $controller, $modalStack) {
	          var $modal = {};
	
	          function getTemplatePromise(options) {
	            return options.template ? $q.when(options.template) :
	              $templateRequest(angular.isFunction(options.templateUrl) ? (options.templateUrl)() : options.templateUrl);
	          }
	
	          function getResolvePromises(resolves) {
	            var promisesArr = [];
	            angular.forEach(resolves, function(value) {
	              if (angular.isFunction(value) || angular.isArray(value)) {
	                promisesArr.push($q.when($injector.invoke(value)));
	              } else if (angular.isString(value)) {
	                promisesArr.push($q.when($injector.get(value)));
	              } else {
	                promisesArr.push($q.when(value));
	              }
	            });
	            return promisesArr;
	          }
	
	          var promiseChain = null;
	          $modal.getPromiseChain = function() {
	            return promiseChain;
	          };
	
	          $modal.open = function (modalOptions) {
	
	            var modalResultDeferred = $q.defer();
	            var modalOpenedDeferred = $q.defer();
	            var modalRenderDeferred = $q.defer();
	
	            //prepare an instance of a modal to be injected into controllers and returned to a caller
	            var modalInstance = {
	              result: modalResultDeferred.promise,
	              opened: modalOpenedDeferred.promise,
	              rendered: modalRenderDeferred.promise,
	              close: function (result) {
	                return $modalStack.close(modalInstance, result);
	              },
	              dismiss: function (reason) {
	                return $modalStack.dismiss(modalInstance, reason);
	              }
	            };
	
	            //merge and clean up options
	            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	            modalOptions.resolve = modalOptions.resolve || {};
	
	            //verify options
	            if (!modalOptions.template && !modalOptions.templateUrl) {
	              throw new Error('One of template or templateUrl options is required.');
	            }
	
	            var templateAndResolvePromise =
	              $q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));
	
	            // Wait for the resolution of the existing promise chain.
	            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	            // Then add to $modalStack and resolve opened.
	            // Finally clean up the chain variable if no subsequent modal has overwritten it.
	            var samePromise;
	            samePromise = promiseChain = $q.all([promiseChain])
	              .then(function() { return templateAndResolvePromise; }, function() { return templateAndResolvePromise; })
	              .then(function resolveSuccess(tplAndVars) {
	
	                var modalScope = (modalOptions.scope || $rootScope).$new();
	                modalScope.$close = modalInstance.close;
	                modalScope.$dismiss = modalInstance.dismiss;
	
	                modalScope.$on('$destroy', function() {
	                  if (!modalScope.$$uibDestructionScheduled) {
	                    modalScope.$dismiss('$uibUnscheduledDestruction');
	                  }
	                });
	
	                var ctrlInstance, ctrlLocals = {};
	                var resolveIter = 1;
	
	                //controllers
	                if (modalOptions.controller) {
	                  ctrlLocals.$scope = modalScope;
	                  ctrlLocals.$modalInstance = modalInstance;
	                  angular.forEach(modalOptions.resolve, function(value, key) {
	                    ctrlLocals[key] = tplAndVars[resolveIter++];
	                  });
	
	                  ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
	                  if (modalOptions.controllerAs) {
	                    if (modalOptions.bindToController) {
	                      angular.extend(ctrlInstance, modalScope);
	                    }
	
	                    modalScope[modalOptions.controllerAs] = ctrlInstance;
	                  }
	                }
	
	                $modalStack.open(modalInstance, {
	                  scope: modalScope,
	                  deferred: modalResultDeferred,
	                  renderDeferred: modalRenderDeferred,
	                  content: tplAndVars[0],
	                  animation: modalOptions.animation,
	                  backdrop: modalOptions.backdrop,
	                  keyboard: modalOptions.keyboard,
	                  backdropClass: modalOptions.backdropClass,
	                  windowClass: modalOptions.windowClass,
	                  windowTemplateUrl: modalOptions.windowTemplateUrl,
	                  size: modalOptions.size,
	                  openedClass: modalOptions.openedClass
	                });
	                modalOpenedDeferred.resolve(true);
	
	            }, function resolveError(reason) {
	              modalOpenedDeferred.reject(reason);
	              modalResultDeferred.reject(reason);
	            })
	            .finally(function() {
	              if (promiseChain === samePromise) {
	                promiseChain = null;
	              }
	            });
	
	            return modalInstance;
	          };
	
	          return $modal;
	        }]
	    };
	
	    return $modalProvider;
	  });
	
	angular.module('ui.bootstrap.pagination', [])
	.controller('PaginationController', ['$scope', '$attrs', '$parse', function($scope, $attrs, $parse) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	      setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
	
	  this.init = function(ngModelCtrl_, config) {
	    ngModelCtrl = ngModelCtrl_;
	    this.config = config;
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	
	    if ($attrs.itemsPerPage) {
	      $scope.$parent.$watch($parse($attrs.itemsPerPage), function(value) {
	        self.itemsPerPage = parseInt(value, 10);
	        $scope.totalPages = self.calculateTotalPages();
	      });
	    } else {
	      this.itemsPerPage = config.itemsPerPage;
	    }
	
	    $scope.$watch('totalItems', function() {
	      $scope.totalPages = self.calculateTotalPages();
	    });
	
	    $scope.$watch('totalPages', function(value) {
	      setNumPages($scope.$parent, value); // Readonly variable
	
	      if ( $scope.page > value ) {
	        $scope.selectPage(value);
	      } else {
	        ngModelCtrl.$render();
	      }
	    });
	  };
	
	  this.calculateTotalPages = function() {
	    var totalPages = this.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / this.itemsPerPage);
	    return Math.max(totalPages || 0, 1);
	  };
	
	  this.render = function() {
	    $scope.page = parseInt(ngModelCtrl.$viewValue, 10) || 1;
	  };
	
	  $scope.selectPage = function(page, evt) {
	    if (evt) {
	      evt.preventDefault();
	    }
	
	    var clickAllowed = !$scope.ngDisabled || !evt;
	    if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
	      if (evt && evt.target) {
	        evt.target.blur();
	      }
	      ngModelCtrl.$setViewValue(page);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.getText = function(key) {
	    return $scope[key + 'Text'] || self.config[key + 'Text'];
	  };
	
	  $scope.noPrevious = function() {
	    return $scope.page === 1;
	  };
	
	  $scope.noNext = function() {
	    return $scope.page === $scope.totalPages;
	  };
	}])
	
	.constant('paginationConfig', {
	  itemsPerPage: 10,
	  boundaryLinks: false,
	  directionLinks: true,
	  firstText: 'First',
	  previousText: 'Previous',
	  nextText: 'Next',
	  lastText: 'Last',
	  rotate: true
	})
	
	.directive('pagination', ['$parse', 'paginationConfig', function($parse, paginationConfig) {
	  return {
	    restrict: 'EA',
	    scope: {
	      totalItems: '=',
	      firstText: '@',
	      previousText: '@',
	      nextText: '@',
	      lastText: '@',
	      ngDisabled:'='
	    },
	    require: ['pagination', '?ngModel'],
	    controller: 'PaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/pagination/pagination.html';
	    },
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      // Setup configuration parameters
	      var maxSize = angular.isDefined(attrs.maxSize) ? scope.$parent.$eval(attrs.maxSize) : paginationConfig.maxSize,
	          rotate = angular.isDefined(attrs.rotate) ? scope.$parent.$eval(attrs.rotate) : paginationConfig.rotate;
	      scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : paginationConfig.boundaryLinks;
	      scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : paginationConfig.directionLinks;
	
	      paginationCtrl.init(ngModelCtrl, paginationConfig);
	
	      if (attrs.maxSize) {
	        scope.$parent.$watch($parse(attrs.maxSize), function(value) {
	          maxSize = parseInt(value, 10);
	          paginationCtrl.render();
	        });
	      }
	
	      // Create page object used in template
	      function makePage(number, text, isActive) {
	        return {
	          number: number,
	          text: text,
	          active: isActive
	        };
	      }
	
	      function getPages(currentPage, totalPages) {
	        var pages = [];
	
	        // Default page limits
	        var startPage = 1, endPage = totalPages;
	        var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;
	
	        // recompute if maxSize
	        if (isMaxSized) {
	          if (rotate) {
	            // Current page is displayed in the middle of the visible ones
	            startPage = Math.max(currentPage - Math.floor(maxSize/2), 1);
	            endPage   = startPage + maxSize - 1;
	
	            // Adjust if limit is exceeded
	            if (endPage > totalPages) {
	              endPage   = totalPages;
	              startPage = endPage - maxSize + 1;
	            }
	          } else {
	            // Visible pages are paginated with maxSize
	            startPage = ((Math.ceil(currentPage / maxSize) - 1) * maxSize) + 1;
	
	            // Adjust last page if limit is exceeded
	            endPage = Math.min(startPage + maxSize - 1, totalPages);
	          }
	        }
	
	        // Add page number links
	        for (var number = startPage; number <= endPage; number++) {
	          var page = makePage(number, number, number === currentPage);
	          pages.push(page);
	        }
	
	        // Add links to move between page sets
	        if (isMaxSized && ! rotate) {
	          if (startPage > 1) {
	            var previousPageSet = makePage(startPage - 1, '...', false);
	            pages.unshift(previousPageSet);
	          }
	
	          if (endPage < totalPages) {
	            var nextPageSet = makePage(endPage + 1, '...', false);
	            pages.push(nextPageSet);
	          }
	        }
	
	        return pages;
	      }
	
	      var originalRender = paginationCtrl.render;
	      paginationCtrl.render = function() {
	        originalRender();
	        if (scope.page > 0 && scope.page <= scope.totalPages) {
	          scope.pages = getPages(scope.page, scope.totalPages);
	        }
	      };
	    }
	  };
	}])
	
	.constant('pagerConfig', {
	  itemsPerPage: 10,
	  previousText: '« Previous',
	  nextText: 'Next »',
	  align: true
	})
	
	.directive('pager', ['pagerConfig', function(pagerConfig) {
	  return {
	    restrict: 'EA',
	    scope: {
	      totalItems: '=',
	      previousText: '@',
	      nextText: '@',
	      ngDisabled: '='
	    },
	    require: ['pager', '?ngModel'],
	    controller: 'PaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/pagination/pager.html';
	    },
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      scope.align = angular.isDefined(attrs.align) ? scope.$parent.$eval(attrs.align) : pagerConfig.align;
	      paginationCtrl.init(ngModelCtrl, pagerConfig);
	    }
	  };
	}]);
	
	/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */
	angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.bindHtml'])
	
	/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */
	.provider('$tooltip', function() {
	  // The default options tooltip and popover.
	  var defaultOptions = {
	    placement: 'top',
	    animation: true,
	    popupDelay: 0,
	    useContentExp: false
	  };
	
	  // Default hide triggers for each show trigger
	  var triggerMap = {
	    'mouseenter': 'mouseleave',
	    'click': 'click',
	    'focus': 'blur',
	    'none': ''
	  };
	
	  // The options specified to the provider globally.
	  var globalOptions = {};
	
	  /**
	   * `options({})` allows global configuration of all tooltips in the
	   * application.
	   *
	   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	   *     // place tooltips left instead of top by default
	   *     $tooltipProvider.options( { placement: 'left' } );
	   *   });
	   */
		this.options = function(value) {
			angular.extend(globalOptions, value);
		};
	
	  /**
	   * This allows you to extend the set of trigger mappings available. E.g.:
	   *
	   *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
	   */
	  this.setTriggers = function setTriggers(triggers) {
	    angular.extend(triggerMap, triggers);
	  };
	
	  /**
	   * This is a helper function for translating camel-case to snake-case.
	   */
	  function snake_case(name) {
	    var regexp = /[A-Z]/g;
	    var separator = '-';
	    return name.replace(regexp, function(letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  /**
	   * Returns the actual instance of the $tooltip service.
	   * TODO support multiple triggers
	   */
	  this.$get = ['$window', '$compile', '$timeout', '$document', '$position', '$interpolate', '$rootScope', '$parse', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse) {
	    return function $tooltip(type, prefix, defaultTriggerShow, options) {
	      options = angular.extend({}, defaultOptions, globalOptions, options);
	
	      /**
	       * Returns an object of show and hide triggers.
	       *
	       * If a trigger is supplied,
	       * it is used to show the tooltip; otherwise, it will use the `trigger`
	       * option passed to the `$tooltipProvider.options` method; else it will
	       * default to the trigger supplied to this directive factory.
	       *
	       * The hide trigger is based on the show trigger. If the `trigger` option
	       * was passed to the `$tooltipProvider.options` method, it will use the
	       * mapped trigger from `triggerMap` or the passed trigger if the map is
	       * undefined; otherwise, it uses the `triggerMap` value of the show
	       * trigger; else it will just use the show trigger.
	       */
	      function getTriggers(trigger) {
	        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
	        var hide = show.map(function(trigger) {
	          return triggerMap[trigger] || trigger;
	        });
	        return {
	          show: show,
	          hide: hide
	        };
	      }
	
	      var directiveName = snake_case(type);
	
	      var startSym = $interpolate.startSymbol();
	      var endSym = $interpolate.endSymbol();
	      var template =
	        '<div '+ directiveName +'-popup '+
	          'title="'+startSym+'title'+endSym+'" '+
	          (options.useContentExp ?
	            'content-exp="contentExp()" ' :
	            'content="'+startSym+'content'+endSym+'" ') +
	          'placement="'+startSym+'placement'+endSym+'" '+
	          'popup-class="'+startSym+'popupClass'+endSym+'" '+
	          'animation="animation" '+
	          'is-open="isOpen"'+
	          'origin-scope="origScope" '+
	          '>'+
	        '</div>';
	
	      return {
	        restrict: 'EA',
	        compile: function(tElem, tAttrs) {
	          var tooltipLinker = $compile( template );
	
	          return function link(scope, element, attrs, tooltipCtrl) {
	            var tooltip;
	            var tooltipLinkedScope;
	            var transitionTimeout;
	            var popupTimeout;
	            var positionTimeout;
	            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
	            var triggers = getTriggers(undefined);
	            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
	            var ttScope = scope.$new(true);
	            var repositionScheduled = false;
	            var isOpenExp = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
	
	            var positionTooltip = function() {
	              if (!tooltip) { return; }
	
	              if (!positionTimeout) {
	                positionTimeout = $timeout(function() {
	                  // Reset the positioning and box size for correct width and height values.
	                  tooltip.css({ top: 0, left: 0, width: 'auto', height: 'auto' });
	
	                  var ttBox = $position.position(tooltip);
	                  var ttCss = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
	                  ttCss.top += 'px';
	                  ttCss.left += 'px';
	
	                  ttCss.width = ttBox.width + 'px';
	                  ttCss.height = ttBox.height + 'px';
	
	                  // Now set the calculated positioning and size.
	                  tooltip.css(ttCss);
	
	                  positionTimeout = null;
	
	                }, 0, false);
	              }
	            };
	
	            // Set up the correct scope to allow transclusion later
	            ttScope.origScope = scope;
	
	            // By default, the tooltip is not open.
	            // TODO add ability to start tooltip opened
	            ttScope.isOpen = false;
	
	            function toggleTooltipBind() {
	              if (!ttScope.isOpen) {
	                showTooltipBind();
	              } else {
	                hideTooltipBind();
	              }
	            }
	
	            // Show the tooltip with delay if specified, otherwise show it immediately
	            function showTooltipBind() {
	              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
	                return;
	              }
	
	              prepareTooltip();
	
	              if (ttScope.popupDelay) {
	                // Do nothing if the tooltip was already scheduled to pop-up.
	                // This happens if show is triggered multiple times before any hide is triggered.
	                if (!popupTimeout) {
	                  popupTimeout = $timeout(show, ttScope.popupDelay, false);
	                }
	              } else {
	                show();
	              }
	            }
	
	            function hideTooltipBind () {
	              hide();
	              if (!$rootScope.$$phase) {
	                $rootScope.$digest();
	              }
	            }
	
	            // Show the tooltip popup element.
	            function show() {
	              popupTimeout = null;
	
	              // If there is a pending remove transition, we must cancel it, lest the
	              // tooltip be mysteriously removed.
	              if (transitionTimeout) {
	                $timeout.cancel(transitionTimeout);
	                transitionTimeout = null;
	              }
	
	              // Don't show empty tooltips.
	              if (!(options.useContentExp ? ttScope.contentExp() : ttScope.content)) {
	                return angular.noop;
	              }
	
	              createTooltip();
	
	              // And show the tooltip.
	              ttScope.isOpen = true;
	              if (isOpenExp) {
	                isOpenExp.assign(ttScope.origScope, ttScope.isOpen);
	              }
	
	              if (!$rootScope.$$phase) {
	                ttScope.$apply(); // digest required as $apply is not called
	              }
	
	              tooltip.css({ display: 'block' });
	
	              positionTooltip();
	            }
	
	            // Hide the tooltip popup element.
	            function hide() {
	              // First things first: we don't show it anymore.
	              ttScope.isOpen = false;
	              if (isOpenExp) {
	                isOpenExp.assign(ttScope.origScope, ttScope.isOpen);
	              }
	
	              //if tooltip is going to be shown after delay, we must cancel this
	              $timeout.cancel(popupTimeout);
	              popupTimeout = null;
	
	              $timeout.cancel(positionTimeout);
	              positionTimeout = null;
	
	              // And now we remove it from the DOM. However, if we have animation, we
	              // need to wait for it to expire beforehand.
	              // FIXME: this is a placeholder for a port of the transitions library.
	              if (ttScope.animation) {
	                if (!transitionTimeout) {
	                  transitionTimeout = $timeout(removeTooltip, 500);
	                }
	              } else {
	                removeTooltip();
	              }
	            }
	
	            function createTooltip() {
	              // There can only be one tooltip element per directive shown at once.
	              if (tooltip) {
	                removeTooltip();
	              }
	              tooltipLinkedScope = ttScope.$new();
	              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
	                if (appendToBody) {
	                  $document.find('body').append(tooltip);
	                } else {
	                  element.after(tooltip);
	                }
	              });
	
	              if (options.useContentExp) {
	                tooltipLinkedScope.$watch('contentExp()', function(val) {
	                  if (!val && ttScope.isOpen) {
	                    hide();
	                  }
	                });
	
	                tooltipLinkedScope.$watch(function() {
	                  if (!repositionScheduled) {
	                    repositionScheduled = true;
	                    tooltipLinkedScope.$$postDigest(function() {
	                      repositionScheduled = false;
	                      if (ttScope.isOpen) {
	                        positionTooltip();
	                      }
	                    });
	                  }
	                });
	
	              }
	            }
	
	            function removeTooltip() {
	              transitionTimeout = null;
	              if (tooltip) {
	                tooltip.remove();
	                tooltip = null;
	              }
	              if (tooltipLinkedScope) {
	                tooltipLinkedScope.$destroy();
	                tooltipLinkedScope = null;
	              }
	            }
	
	            function prepareTooltip() {
	              prepPopupClass();
	              prepPlacement();
	              prepPopupDelay();
	            }
	
	            ttScope.contentExp = function() {
	              return scope.$eval(attrs[type]);
	            };
	
	            /**
	             * Observe the relevant attributes.
	             */
	            if (!options.useContentExp) {
	              attrs.$observe(type, function(val) {
	                ttScope.content = val;
	
	                if (!val && ttScope.isOpen) {
	                  hide();
	                } else {
	                  positionTooltip();
	                }
	              });
	            }
	
	            attrs.$observe('disabled', function(val) {
	              if (popupTimeout && val) {
	                $timeout.cancel(popupTimeout);
	                popupTimeout = null;
	              }
	
	              if (val && ttScope.isOpen) {
	                hide();
	              }
	            });
	
	            attrs.$observe(prefix + 'Title', function(val) {
	              ttScope.title = val;
	              positionTooltip();
	            });
	
	            attrs.$observe(prefix + 'Placement', function() {
	              if (ttScope.isOpen) {
	                prepPlacement();
	                positionTooltip();
	              }
	            });
	
	            if (isOpenExp) {
	              scope.$watch(isOpenExp, function(val) {
	                if (val !== ttScope.isOpen) {
	                  toggleTooltipBind();
	                }
	              });
	            }
	
	            function prepPopupClass() {
	              ttScope.popupClass = attrs[prefix + 'Class'];
	            }
	
	            function prepPlacement() {
	              var val = attrs[prefix + 'Placement'];
	              ttScope.placement = angular.isDefined(val) ? val : options.placement;
	            }
	
	            function prepPopupDelay() {
	              var val = attrs[prefix + 'PopupDelay'];
	              var delay = parseInt(val, 10);
	              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
	            }
	
	            var unregisterTriggers = function() {
	              triggers.show.forEach(function(trigger) {
	                element.unbind(trigger, showTooltipBind);
	              });
	              triggers.hide.forEach(function(trigger) {
	                element.unbind(trigger, hideTooltipBind);
	              });
	            };
	
	            function prepTriggers() {
	              var val = attrs[prefix + 'Trigger'];
	              unregisterTriggers();
	
	              triggers = getTriggers(val);
	
	              if (triggers.show !== 'none') {
	                triggers.show.forEach(function(trigger, idx) {
	                  // Using raw addEventListener due to jqLite/jQuery bug - #4060
	                  if (trigger === triggers.hide[idx]) {
	                    element[0].addEventListener(trigger, toggleTooltipBind);
	                  } else if (trigger) {
	                    element[0].addEventListener(trigger, showTooltipBind);
	                    element[0].addEventListener(triggers.hide[idx], hideTooltipBind);
	                  }
	                });
	              }
	            }
	            prepTriggers();
	
	            var animation = scope.$eval(attrs[prefix + 'Animation']);
	            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
	
	            var appendToBodyVal = scope.$eval(attrs[prefix + 'AppendToBody']);
	            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;
	
	            // if a tooltip is attached to <body> we need to remove it on
	            // location change as its parent scope will probably not be destroyed
	            // by the change.
	            if (appendToBody) {
	              scope.$on('$locationChangeSuccess', function closeTooltipOnLocationChangeSuccess() {
	                if (ttScope.isOpen) {
	                  hide();
	                }
	              });
	            }
	
	            // Make sure tooltip is destroyed and removed.
	            scope.$on('$destroy', function onDestroyTooltip() {
	              $timeout.cancel(transitionTimeout);
	              $timeout.cancel(popupTimeout);
	              $timeout.cancel(positionTimeout);
	              unregisterTriggers();
	              removeTooltip();
	              ttScope = null;
	            });
	          };
	        }
	      };
	    };
	  }];
	})
	
	// This is mostly ngInclude code but with a custom scope
	.directive('tooltipTemplateTransclude', [
	         '$animate', '$sce', '$compile', '$templateRequest',
	function ($animate ,  $sce ,  $compile ,  $templateRequest) {
	  return {
	    link: function(scope, elem, attrs) {
	      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
	
	      var changeCounter = 0,
	        currentScope,
	        previousElement,
	        currentElement;
	
	      var cleanupLastIncludeContent = function() {
	        if (previousElement) {
	          previousElement.remove();
	          previousElement = null;
	        }
	        if (currentScope) {
	          currentScope.$destroy();
	          currentScope = null;
	        }
	        if (currentElement) {
	          $animate.leave(currentElement).then(function() {
	            previousElement = null;
	          });
	          previousElement = currentElement;
	          currentElement = null;
	        }
	      };
	
	      scope.$watch($sce.parseAsResourceUrl(attrs.tooltipTemplateTransclude), function(src) {
	        var thisChangeId = ++changeCounter;
	
	        if (src) {
	          //set the 2nd param to true to ignore the template request error so that the inner
	          //contents and scope can be cleaned up.
	          $templateRequest(src, true).then(function(response) {
	            if (thisChangeId !== changeCounter) { return; }
	            var newScope = origScope.$new();
	            var template = response;
	
	            var clone = $compile(template)(newScope, function(clone) {
	              cleanupLastIncludeContent();
	              $animate.enter(clone, elem);
	            });
	
	            currentScope = newScope;
	            currentElement = clone;
	
	            currentScope.$emit('$includeContentLoaded', src);
	          }, function() {
	            if (thisChangeId === changeCounter) {
	              cleanupLastIncludeContent();
	              scope.$emit('$includeContentError', src);
	            }
	          });
	          scope.$emit('$includeContentRequested', src);
	        } else {
	          cleanupLastIncludeContent();
	        }
	      });
	
	      scope.$on('$destroy', cleanupLastIncludeContent);
	    }
	  };
	}])
	
	/**
	 * Note that it's intentional that these classes are *not* applied through $animate.
	 * They must not be animated as they're expected to be present on the tooltip on
	 * initialization.
	 */
	.directive('tooltipClasses', function() {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      if (scope.placement) {
	        element.addClass(scope.placement);
	      }
	      if (scope.popupClass) {
	        element.addClass(scope.popupClass);
	      }
	      if (scope.animation()) {
	        element.addClass(attrs.tooltipAnimationClass);
	      }
	    }
	  };
	})
	
	.directive('tooltipPopup', function() {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/tooltip/tooltip-popup.html'
	  };
	})
	
	.directive('tooltip', [ '$tooltip', function($tooltip) {
	  return $tooltip('tooltip', 'tooltip', 'mouseenter');
	}])
	
	.directive('tooltipTemplatePopup', function() {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
	      originScope: '&' },
	    templateUrl: 'template/tooltip/tooltip-template-popup.html'
	  };
	})
	
	.directive('tooltipTemplate', ['$tooltip', function($tooltip) {
	  return $tooltip('tooltipTemplate', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}])
	
	.directive('tooltipHtmlPopup', function() {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/tooltip/tooltip-html-popup.html'
	  };
	})
	
	.directive('tooltipHtml', ['$tooltip', function($tooltip) {
	  return $tooltip('tooltipHtml', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}])
	
	/*
	Deprecated
	*/
	.directive('tooltipHtmlUnsafePopup', function() {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/tooltip/tooltip-html-unsafe-popup.html'
	  };
	})
	
	.value('tooltipHtmlUnsafeSuppressDeprecated', false)
	.directive('tooltipHtmlUnsafe', [
	          '$tooltip', 'tooltipHtmlUnsafeSuppressDeprecated', '$log',
	function($tooltip ,  tooltipHtmlUnsafeSuppressDeprecated ,  $log) {
	  if (!tooltipHtmlUnsafeSuppressDeprecated) {
	    $log.warn('tooltip-html-unsafe is now deprecated. Use tooltip-html or tooltip-template instead.');
	  }
	  return $tooltip('tooltipHtmlUnsafe', 'tooltip', 'mouseenter');
	}]);
	
	/**
	 * The following features are still outstanding: popup delay, animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, and selector delegatation.
	 */
	angular.module( 'ui.bootstrap.popover', ['ui.bootstrap.tooltip'])
	
	.directive('popoverTemplatePopup', function() {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope: { title: '@', contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
	      originScope: '&' },
	    templateUrl: 'template/popover/popover-template.html'
	  };
	})
	
	.directive('popoverTemplate', ['$tooltip', function($tooltip) {
	  return $tooltip('popoverTemplate', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('popoverHtmlPopup', function() {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope: { contentExp: '&', title: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/popover/popover-html.html'
	  };
	})
	
	.directive('popoverHtml', ['$tooltip', function($tooltip) {
	  return $tooltip( 'popoverHtml', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('popoverPopup', function() {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope: { title: '@', content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/popover/popover.html'
	  };
	})
	
	.directive('popover', ['$tooltip', function($tooltip) {
	  return $tooltip( 'popover', 'popover', 'click' );
	}]);
	
	angular.module('ui.bootstrap.progressbar', [])
	
	.constant('progressConfig', {
	  animate: true,
	  max: 100
	})
	
	.value('$progressSuppressWarning', false)
	
	.controller('ProgressController', ['$scope', '$attrs', 'progressConfig', function($scope, $attrs, progressConfig) {
	  var self = this,
	      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
	
	  this.bars = [];
	  $scope.max = angular.isDefined($scope.max) ? $scope.max : progressConfig.max;
	
	  this.addBar = function(bar, element) {
	    if (!animate) {
	      element.css({'transition': 'none'});
	    }
	
	    this.bars.push(bar);
	
	    bar.max = $scope.max;
	
	    bar.$watch('value', function(value) {
	      bar.recalculatePercentage();
	    });
	
	    bar.recalculatePercentage = function() {
	      bar.percent = +(100 * bar.value / bar.max).toFixed(2);
	
	      var totalPercentage = self.bars.reduce(function(total, bar) {
	        return total + bar.percent;
	      }, 0);
	
	      if (totalPercentage > 100) {
	        bar.percent -= totalPercentage - 100;
	      }
	    };
	
	    bar.$on('$destroy', function() {
	      element = null;
	      self.removeBar(bar);
	    });
	  };
	
	  this.removeBar = function(bar) {
	      this.bars.splice(this.bars.indexOf(bar), 1);
	  };
	
	  $scope.$watch('max', function(max) {
	    self.bars.forEach(function(bar) {
	      bar.max = $scope.max;
	      bar.recalculatePercentage();
	    });
	  });
	}])
	
	.directive('uibProgress', function() {
	  return {
	    restrict: 'EA',
	    replace: true,
	    transclude: true,
	    controller: 'ProgressController',
	    require: 'uibProgress',
	    scope: {
	      max: '=?'
	    },
	    templateUrl: 'template/progressbar/progress.html'
	  };
	})
	
	.directive('progress', ['$log', '$progressSuppressWarning', function($log, $progressSuppressWarning) {
	  return {
	    restrict: 'EA',
	    replace: true,
	    transclude: true,
	    controller: 'ProgressController',
	    require: 'progress',
	    scope: {
	      max: '=?'
	    },
	    templateUrl: 'template/progressbar/progress.html',
	    link: function() {
	      if ($progressSuppressWarning) {
	        $log.warn('progress is now deprecated. Use uib-progress instead');
	      }
	    }
	  };
	}])
	
	.directive('uibBar', function() {
	  return {
	    restrict: 'EA',
	    replace: true,
	    transclude: true,
	    require: '^uibProgress',
	    scope: {
	      value: '=',
	      type: '@'
	    },
	    templateUrl: 'template/progressbar/bar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, element);
	    }
	  };
	})
	
	.directive('bar', ['$log', '$progressSuppressWarning', function($log, $progressSuppressWarning) {
	  return {
	    restrict: 'EA',
	    replace: true,
	    transclude: true,
	    require: '^progress',
	    scope: {
	      value: '=',
	      type: '@'
	    },
	    templateUrl: 'template/progressbar/bar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      if ($progressSuppressWarning) {
	        $log.warn('bar is now deprecated. Use uib-bar instead');
	      }
	      progressCtrl.addBar(scope, element);
	    }
	  };
	}])
	
	.directive('progressbar', function() {
	  return {
	    restrict: 'EA',
	    replace: true,
	    transclude: true,
	    controller: 'ProgressController',
	    scope: {
	      value: '=',
	      max: '=?',
	      type: '@'
	    },
	    templateUrl: 'template/progressbar/progressbar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, angular.element(element.children()[0]));
	    }
	  };
	});
	
	angular.module('ui.bootstrap.rating', [])
	
	.constant('ratingConfig', {
	  max: 5,
	  stateOn: null,
	  stateOff: null,
	  titles : ['one', 'two', 'three', 'four', 'five']
	})
	
	.controller('RatingController', ['$scope', '$attrs', 'ratingConfig', function($scope, $attrs, ratingConfig) {
	  var ngModelCtrl  = { $setViewValue: angular.noop };
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.push(function(value) {
	      if (angular.isNumber(value) && value << 0 !== value) {
	        value = Math.round(value);
	      }
	      return value;
	    });
	
	    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
	    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
	    var tmpTitles = angular.isDefined($attrs.titles)  ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles ;    
	    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
	      tmpTitles : ratingConfig.titles;
	    
	    var ratingStates = angular.isDefined($attrs.ratingStates) ?
	      $scope.$parent.$eval($attrs.ratingStates) :
	      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
	    $scope.range = this.buildTemplateObjects(ratingStates);
	  };
	
	  this.buildTemplateObjects = function(states) {
	    for (var i = 0, n = states.length; i < n; i++) {
	      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
	    }
	    return states;
	  };
	  
	  this.getTitle = function(index) {
	    if (index >= this.titles.length) {
	      return index + 1;
	    } else {
	      return this.titles[index];
	    }
	  };
	  
	  $scope.rate = function(value) {
	    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
	      ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue === value ? 0 : value);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.enter = function(value) {
	    if (!$scope.readonly) {
	      $scope.value = value;
	    }
	    $scope.onHover({value: value});
	  };
	
	  $scope.reset = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	    $scope.onLeave();
	  };
	
	  $scope.onKeydown = function(evt) {
	    if (/(37|38|39|40)/.test(evt.which)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
	    }
	  };
	
	  this.render = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	  };
	}])
	
	.directive('rating', function() {
	  return {
	    restrict: 'EA',
	    require: ['rating', 'ngModel'],
	    scope: {
	      readonly: '=?',
	      onHover: '&',
	      onLeave: '&'
	    },
	    controller: 'RatingController',
	    templateUrl: 'template/rating/rating.html',
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	      ratingCtrl.init( ngModelCtrl );
	    }
	  };
	});
	
	
	/**
	 * @ngdoc overview
	 * @name ui.bootstrap.tabs
	 *
	 * @description
	 * AngularJS version of the tabs directive.
	 */
	
	angular.module('ui.bootstrap.tabs', [])
	
	.controller('TabsetController', ['$scope', function TabsetCtrl($scope) {
	  var ctrl = this,
	      tabs = ctrl.tabs = $scope.tabs = [];
	
	  ctrl.select = function(selectedTab) {
	    angular.forEach(tabs, function(tab) {
	      if (tab.active && tab !== selectedTab) {
	        tab.active = false;
	        tab.onDeselect();
	        selectedTab.selectCalled = false;
	      }
	    });
	    selectedTab.active = true;
	    // only call select if it has not already been called
	    if (!selectedTab.selectCalled) {
	      selectedTab.onSelect();
	      selectedTab.selectCalled = true;
	    }
	  };
	
	  ctrl.addTab = function addTab(tab) {
	    tabs.push(tab);
	    // we can't run the select function on the first tab
	    // since that would select it twice
	    if (tabs.length === 1 && tab.active !== false) {
	      tab.active = true;
	    } else if (tab.active) {
	      ctrl.select(tab);
	    } else {
	      tab.active = false;
	    }
	  };
	
	  ctrl.removeTab = function removeTab(tab) {
	    var index = tabs.indexOf(tab);
	    //Select a new tab if the tab to be removed is selected and not destroyed
	    if (tab.active && tabs.length > 1 && !destroyed) {
	      //If this is the last tab, select the previous tab. else, the next tab.
	      var newActiveIndex = index == tabs.length - 1 ? index - 1 : index + 1;
	      ctrl.select(tabs[newActiveIndex]);
	    }
	    tabs.splice(index, 1);
	  };
	
	  var destroyed;
	  $scope.$on('$destroy', function() {
	    destroyed = true;
	  });
	}])
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.tabs.directive:tabset
	 * @restrict EA
	 *
	 * @description
	 * Tabset is the outer container for the tabs directive
	 *
	 * @param {boolean=} vertical Whether or not to use vertical styling for the tabs.
	 * @param {boolean=} justified Whether or not to use justified styling for the tabs.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <tabset>
	      <tab heading="Tab 1"><b>First</b> Content!</tab>
	      <tab heading="Tab 2"><i>Second</i> Content!</tab>
	    </tabset>
	    <hr />
	    <tabset vertical="true">
	      <tab heading="Vertical Tab 1"><b>First</b> Vertical Content!</tab>
	      <tab heading="Vertical Tab 2"><i>Second</i> Vertical Content!</tab>
	    </tabset>
	    <tabset justified="true">
	      <tab heading="Justified Tab 1"><b>First</b> Justified Content!</tab>
	      <tab heading="Justified Tab 2"><i>Second</i> Justified Content!</tab>
	    </tabset>
	  </file>
	</example>
	 */
	.directive('tabset', function() {
	  return {
	    restrict: 'EA',
	    transclude: true,
	    replace: true,
	    scope: {
	      type: '@'
	    },
	    controller: 'TabsetController',
	    templateUrl: 'template/tabs/tabset.html',
	    link: function(scope, element, attrs) {
	      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
	      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
	    }
	  };
	})
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.tabs.directive:tab
	 * @restrict EA
	 *
	 * @param {string=} heading The visible heading, or title, of the tab. Set HTML headings with {@link ui.bootstrap.tabs.directive:tabHeading tabHeading}.
	 * @param {string=} select An expression to evaluate when the tab is selected.
	 * @param {boolean=} active A binding, telling whether or not this tab is selected.
	 * @param {boolean=} disabled A binding, telling whether or not this tab is disabled.
	 *
	 * @description
	 * Creates a tab with a heading and content. Must be placed within a {@link ui.bootstrap.tabs.directive:tabset tabset}.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <div ng-controller="TabsDemoCtrl">
	      <button class="btn btn-small" ng-click="items[0].active = true">
	        Select item 1, using active binding
	      </button>
	      <button class="btn btn-small" ng-click="items[1].disabled = !items[1].disabled">
	        Enable/disable item 2, using disabled binding
	      </button>
	      <br />
	      <tabset>
	        <tab heading="Tab 1">First Tab</tab>
	        <tab select="alertMe()">
	          <tab-heading><i class="icon-bell"></i> Alert me!</tab-heading>
	          Second Tab, with alert callback and html heading!
	        </tab>
	        <tab ng-repeat="item in items"
	          heading="{{item.title}}"
	          disabled="item.disabled"
	          active="item.active">
	          {{item.content}}
	        </tab>
	      </tabset>
	    </div>
	  </file>
	  <file name="script.js">
	    function TabsDemoCtrl($scope) {
	      $scope.items = [
	        { title:"Dynamic Title 1", content:"Dynamic Item 0" },
	        { title:"Dynamic Title 2", content:"Dynamic Item 1", disabled: true }
	      ];
	
	      $scope.alertMe = function() {
	        setTimeout(function() {
	          alert("You've selected the alert tab!");
	        });
	      };
	    };
	  </file>
	</example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.tabs.directive:tabHeading
	 * @restrict EA
	 *
	 * @description
	 * Creates an HTML heading for a {@link ui.bootstrap.tabs.directive:tab tab}. Must be placed as a child of a tab element.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <tabset>
	      <tab>
	        <tab-heading><b>HTML</b> in my titles?!</tab-heading>
	        And some content, too!
	      </tab>
	      <tab>
	        <tab-heading><i class="icon-heart"></i> Icon heading?!?</tab-heading>
	        That's right.
	      </tab>
	    </tabset>
	  </file>
	</example>
	 */
	.directive('tab', ['$parse', '$log', function($parse, $log) {
	  return {
	    require: '^tabset',
	    restrict: 'EA',
	    replace: true,
	    templateUrl: 'template/tabs/tab.html',
	    transclude: true,
	    scope: {
	      active: '=?',
	      heading: '@',
	      onSelect: '&select', //This callback is called in contentHeadingTransclude
	                          //once it inserts the tab's content into the dom
	      onDeselect: '&deselect'
	    },
	    controller: function() {
	      //Empty controller so other directives can require being 'under' a tab
	    },
	    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
	      scope.$watch('active', function(active) {
	        if (active) {
	          tabsetCtrl.select(scope);
	        }
	      });
	
	      scope.disabled = false;
	      if (attrs.disable) {
	        scope.$parent.$watch($parse(attrs.disable), function(value) {
	          scope.disabled = !! value;
	        });
	      }
	
	      // Deprecation support of "disabled" parameter
	      // fix(tab): IE9 disabled attr renders grey text on enabled tab #2677
	      // This code is duplicated from the lines above to make it easy to remove once
	      // the feature has been completely deprecated
	      if (attrs.disabled) {
	        $log.warn('Use of "disabled" attribute has been deprecated, please use "disable"');
	        scope.$parent.$watch($parse(attrs.disabled), function(value) {
	          scope.disabled = !! value;
	        });
	      }
	
	      scope.select = function() {
	        if (!scope.disabled) {
	          scope.active = true;
	        }
	      };
	
	      tabsetCtrl.addTab(scope);
	      scope.$on('$destroy', function() {
	        tabsetCtrl.removeTab(scope);
	      });
	
	      //We need to transclude later, once the content container is ready.
	      //when this link happens, we're inside a tab heading.
	      scope.$transcludeFn = transclude;
	    }
	  };
	}])
	
	.directive('tabHeadingTransclude', function() {
	  return {
	    restrict: 'A',
	    require: '^tab',
	    link: function(scope, elm, attrs, tabCtrl) {
	      scope.$watch('headingElement', function updateHeadingElement(heading) {
	        if (heading) {
	          elm.html('');
	          elm.append(heading);
	        }
	      });
	    }
	  };
	})
	
	.directive('tabContentTransclude', function() {
	  return {
	    restrict: 'A',
	    require: '^tabset',
	    link: function(scope, elm, attrs) {
	      var tab = scope.$eval(attrs.tabContentTransclude);
	
	      //Now our tab is ready to be transcluded: both the tab heading area
	      //and the tab content area are loaded.  Transclude 'em both.
	      tab.$transcludeFn(tab.$parent, function(contents) {
	        angular.forEach(contents, function(node) {
	          if (isTabHeading(node)) {
	            //Let tabHeadingTransclude know.
	            tab.headingElement = node;
	          } else {
	            elm.append(node);
	          }
	        });
	      });
	    }
	  };
	
	  function isTabHeading(node) {
	    return node.tagName && (
	      node.hasAttribute('tab-heading') ||
	      node.hasAttribute('data-tab-heading') ||
	      node.hasAttribute('x-tab-heading') ||
	      node.tagName.toLowerCase() === 'tab-heading' ||
	      node.tagName.toLowerCase() === 'data-tab-heading' ||
	      node.tagName.toLowerCase() === 'x-tab-heading'
	    );
	  }
	});
	
	angular.module('ui.bootstrap.timepicker', [])
	
	.constant('timepickerConfig', {
	  hourStep: 1,
	  minuteStep: 1,
	  showMeridian: true,
	  meridians: null,
	  readonlyInput: false,
	  mousewheel: true,
	  arrowkeys: true,
	  showSpinners: true
	})
	
	.controller('TimepickerController', ['$scope', '$attrs', '$parse', '$log', '$locale', 'timepickerConfig', function($scope, $attrs, $parse, $log, $locale, timepickerConfig) {
	  var selected = new Date(),
	      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	      meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS;
	
	  this.init = function(ngModelCtrl_, inputs) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.unshift(function(modelValue) {
	      return modelValue ? new Date(modelValue) : null;
	    });
	
	    var hoursInputEl = inputs.eq(0),
	        minutesInputEl = inputs.eq(1);
	
	    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
	    if (mousewheel) {
	      this.setupMousewheelEvents(hoursInputEl, minutesInputEl);
	    }
	
	    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
	    if (arrowkeys) {
	      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl);
	    }
	
	    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
	    this.setupInputEvents(hoursInputEl, minutesInputEl);
	  };
	
	  var hourStep = timepickerConfig.hourStep;
	  if ($attrs.hourStep) {
	    $scope.$parent.$watch($parse($attrs.hourStep), function(value) {
	      hourStep = parseInt(value, 10);
	    });
	  }
	
	  var minuteStep = timepickerConfig.minuteStep;
	  if ($attrs.minuteStep) {
	    $scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
	      minuteStep = parseInt(value, 10);
	    });
	  }
	
	  var min;
	  $scope.$parent.$watch($parse($attrs.min), function(value) {
	    var dt = new Date(value);
	    min = isNaN(dt) ? undefined : dt;
	  });
	
	  var max;
	  $scope.$parent.$watch($parse($attrs.max), function(value) {
	    var dt = new Date(value);
	    max = isNaN(dt) ? undefined : dt;
	  });
	
	  $scope.noIncrementHours = function() {
	    var incrementedSelected = addMinutes(selected, hourStep * 60);
	    return incrementedSelected > max ||
	      (incrementedSelected < selected && incrementedSelected < min);
	  };
	
	  $scope.noDecrementHours = function() {
	    var decrementedSelected = addMinutes(selected, -hourStep * 60);
	    return decrementedSelected < min ||
	      (decrementedSelected > selected && decrementedSelected > max);
	  };
	
	  $scope.noIncrementMinutes = function() {
	    var incrementedSelected = addMinutes(selected, minuteStep);
	    return incrementedSelected > max ||
	      (incrementedSelected < selected && incrementedSelected < min);
	  };
	
	  $scope.noDecrementMinutes = function() {
	    var decrementedSelected = addMinutes(selected, -minuteStep);
	    return decrementedSelected < min ||
	      (decrementedSelected > selected && decrementedSelected > max);
	  };
	
	  $scope.noToggleMeridian = function() {
	    if (selected.getHours() < 13) {
	      return addMinutes(selected, 12 * 60) > max;
	    } else {
	      return addMinutes(selected, -12 * 60) < min;
	    }
	  };
	
	  // 12H / 24H mode
	  $scope.showMeridian = timepickerConfig.showMeridian;
	  if ($attrs.showMeridian) {
	    $scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
	      $scope.showMeridian = !!value;
	
	      if (ngModelCtrl.$error.time) {
	        // Evaluate from template
	        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
	        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	          selected.setHours(hours);
	          refresh();
	        }
	      } else {
	        updateTemplate();
	      }
	    });
	  }
	
	  // Get $scope.hours in 24H mode if valid
	  function getHoursFromTemplate() {
	    var hours = parseInt($scope.hours, 10);
	    var valid = $scope.showMeridian ? (hours > 0 && hours < 13) : (hours >= 0 && hours < 24);
	    if (!valid) {
	      return undefined;
	    }
	
	    if ($scope.showMeridian) {
	      if (hours === 12) {
	        hours = 0;
	      }
	      if ($scope.meridian === meridians[1]) {
	        hours = hours + 12;
	      }
	    }
	    return hours;
	  }
	
	  function getMinutesFromTemplate() {
	    var minutes = parseInt($scope.minutes, 10);
	    return (minutes >= 0 && minutes < 60) ? minutes : undefined;
	  }
	
	  function pad(value) {
	    return (angular.isDefined(value) && value.toString().length < 2) ? '0' + value : value.toString();
	  }
	
	  // Respond on mousewheel spin
	  this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl) {
	    var isScrollingUp = function(e) {
	      if (e.originalEvent) {
	        e = e.originalEvent;
	      }
	      //pick correct delta variable depending on event
	      var delta = (e.wheelDelta) ? e.wheelDelta : -e.deltaY;
	      return (e.detail || delta > 0);
	    };
	
	    hoursInputEl.bind('mousewheel wheel', function(e) {
	      $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
	      e.preventDefault();
	    });
	
	    minutesInputEl.bind('mousewheel wheel', function(e) {
	      $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
	      e.preventDefault();
	    });
	
	  };
	
	  // Respond on up/down arrowkeys
	  this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl) {
	    hoursInputEl.bind('keydown', function(e) {
	      if (e.which === 38) { // up
	        e.preventDefault();
	        $scope.incrementHours();
	        $scope.$apply();
	      } else if (e.which === 40) { // down
	        e.preventDefault();
	        $scope.decrementHours();
	        $scope.$apply();
	      }
	    });
	
	    minutesInputEl.bind('keydown', function(e) {
	      if (e.which === 38) { // up
	        e.preventDefault();
	        $scope.incrementMinutes();
	        $scope.$apply();
	      } else if (e.which === 40) { // down
	        e.preventDefault();
	        $scope.decrementMinutes();
	        $scope.$apply();
	      }
	    });
	  };
	
	  this.setupInputEvents = function(hoursInputEl, minutesInputEl) {
	    if ($scope.readonlyInput) {
	      $scope.updateHours = angular.noop;
	      $scope.updateMinutes = angular.noop;
	      return;
	    }
	
	    var invalidate = function(invalidHours, invalidMinutes) {
	      ngModelCtrl.$setViewValue(null);
	      ngModelCtrl.$setValidity('time', false);
	      if (angular.isDefined(invalidHours)) {
	        $scope.invalidHours = invalidHours;
	      }
	      if (angular.isDefined(invalidMinutes)) {
	        $scope.invalidMinutes = invalidMinutes;
	      }
	    };
	
	    $scope.updateHours = function() {
	      var hours = getHoursFromTemplate(),
	        minutes = getMinutesFromTemplate();
	
	      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	        selected.setHours(hours);
	        if (selected < min || selected > max) {
	          invalidate(true);
	        } else {
	          refresh('h');
	        }
	      } else {
	        invalidate(true);
	      }
	    };
	
	    hoursInputEl.bind('blur', function(e) {
	      if (!$scope.invalidHours && $scope.hours < 10) {
	        $scope.$apply(function() {
	          $scope.hours = pad($scope.hours);
	        });
	      }
	    });
	
	    $scope.updateMinutes = function() {
	      var minutes = getMinutesFromTemplate(),
	        hours = getHoursFromTemplate();
	
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(undefined, true);
	        } else {
	          refresh('m');
	        }
	      } else {
	        invalidate(undefined, true);
	      }
	    };
	
	    minutesInputEl.bind('blur', function(e) {
	      if (!$scope.invalidMinutes && $scope.minutes < 10) {
	        $scope.$apply(function() {
	          $scope.minutes = pad($scope.minutes);
	        });
	      }
	    });
	
	  };
	
	  this.render = function() {
	    var date = ngModelCtrl.$viewValue;
	
	    if (isNaN(date)) {
	      ngModelCtrl.$setValidity('time', false);
	      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	    } else {
	      if (date) {
	        selected = date;
	      }
	
	      if (selected < min || selected > max) {
	        ngModelCtrl.$setValidity('time', false);
	        $scope.invalidHours = true;
	        $scope.invalidMinutes = true;
	      } else {
	        makeValid();
	      }
	      updateTemplate();
	    }
	  };
	
	  // Call internally when we know that model is valid.
	  function refresh(keyboardChange) {
	    makeValid();
	    ngModelCtrl.$setViewValue(new Date(selected));
	    updateTemplate(keyboardChange);
	  }
	
	  function makeValid() {
	    ngModelCtrl.$setValidity('time', true);
	    $scope.invalidHours = false;
	    $scope.invalidMinutes = false;
	  }
	
	  function updateTemplate(keyboardChange) {
	    var hours = selected.getHours(), minutes = selected.getMinutes();
	
	    if ($scope.showMeridian) {
	      hours = (hours === 0 || hours === 12) ? 12 : hours % 12; // Convert 24 to 12 hour system
	    }
	
	    $scope.hours = keyboardChange === 'h' ? hours : pad(hours);
	    if (keyboardChange !== 'm') {
	      $scope.minutes = pad(minutes);
	    }
	    $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	  }
	
	  function addMinutes(date, minutes) {
	    var dt = new Date(date.getTime() + minutes * 60000);
	    var newDate = new Date(date);
	    newDate.setHours(dt.getHours(), dt.getMinutes());
	    return newDate;
	  }
	
	  function addMinutesToSelected(minutes) {
	    selected = addMinutes(selected, minutes);
	    refresh();
	  }
	
	  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
	    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;
	
	  $scope.incrementHours = function() {
	    if (!$scope.noIncrementHours()) {
	      addMinutesToSelected(hourStep * 60);
	    }
	  };
	
	  $scope.decrementHours = function() {
	    if (!$scope.noDecrementHours()) {
	      addMinutesToSelected(-hourStep * 60);
	    }
	  };
	
	  $scope.incrementMinutes = function() {
	    if (!$scope.noIncrementMinutes()) {
	      addMinutesToSelected(minuteStep);
	    }
	  };
	
	  $scope.decrementMinutes = function() {
	    if (!$scope.noDecrementMinutes()) {
	      addMinutesToSelected(-minuteStep);
	    }
	  };
	
	  $scope.toggleMeridian = function() {
	    if (!$scope.noToggleMeridian()) {
	      addMinutesToSelected(12 * 60 * (selected.getHours() < 12 ? 1 : -1));
	    }
	  };
	}])
	
	.directive('timepicker', function() {
	  return {
	    restrict: 'EA',
	    require: ['timepicker', '?^ngModel'],
	    controller:'TimepickerController',
	    controllerAs: 'timepicker',
	    replace: true,
	    scope: {},
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/timepicker/timepicker.html';
	    },
	    link: function(scope, element, attrs, ctrls) {
	      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (ngModelCtrl) {
	        timepickerCtrl.init(ngModelCtrl, element.find('input'));
	      }
	    }
	  };
	});
	
	angular.module('ui.bootstrap.transition', [])
	
	.value('$transitionSuppressDeprecated', false)
	/**
	 * $transition service provides a consistent interface to trigger CSS 3 transitions and to be informed when they complete.
	 * @param  {DOMElement} element  The DOMElement that will be animated.
	 * @param  {string|object|function} trigger  The thing that will cause the transition to start:
	 *   - As a string, it represents the css class to be added to the element.
	 *   - As an object, it represents a hash of style attributes to be applied to the element.
	 *   - As a function, it represents a function to be called that will cause the transition to occur.
	 * @return {Promise}  A promise that is resolved when the transition finishes.
	 */
	.factory('$transition', [
	        '$q', '$timeout', '$rootScope', '$log', '$transitionSuppressDeprecated',
	function($q ,  $timeout ,  $rootScope ,  $log ,  $transitionSuppressDeprecated) {
	
	  if (!$transitionSuppressDeprecated) {
	    $log.warn('$transition is now deprecated. Use $animate from ngAnimate instead.');
	  }
	
	  var $transition = function(element, trigger, options) {
	    options = options || {};
	    var deferred = $q.defer();
	    var endEventName = $transition[options.animation ? 'animationEndEventName' : 'transitionEndEventName'];
	
	    var transitionEndHandler = function(event) {
	      $rootScope.$apply(function() {
	        element.unbind(endEventName, transitionEndHandler);
	        deferred.resolve(element);
	      });
	    };
	
	    if (endEventName) {
	      element.bind(endEventName, transitionEndHandler);
	    }
	
	    // Wrap in a timeout to allow the browser time to update the DOM before the transition is to occur
	    $timeout(function() {
	      if ( angular.isString(trigger) ) {
	        element.addClass(trigger);
	      } else if ( angular.isFunction(trigger) ) {
	        trigger(element);
	      } else if ( angular.isObject(trigger) ) {
	        element.css(trigger);
	      }
	      //If browser does not support transitions, instantly resolve
	      if ( !endEventName ) {
	        deferred.resolve(element);
	      }
	    });
	
	    // Add our custom cancel function to the promise that is returned
	    // We can call this if we are about to run a new transition, which we know will prevent this transition from ending,
	    // i.e. it will therefore never raise a transitionEnd event for that transition
	    deferred.promise.cancel = function() {
	      if ( endEventName ) {
	        element.unbind(endEventName, transitionEndHandler);
	      }
	      deferred.reject('Transition cancelled');
	    };
	
	    return deferred.promise;
	  };
	
	  // Work out the name of the transitionEnd event
	  var transElement = document.createElement('trans');
	  var transitionEndEventNames = {
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'transitionend',
	    'OTransition': 'oTransitionEnd',
	    'transition': 'transitionend'
	  };
	  var animationEndEventNames = {
	    'WebkitTransition': 'webkitAnimationEnd',
	    'MozTransition': 'animationend',
	    'OTransition': 'oAnimationEnd',
	    'transition': 'animationend'
	  };
	  function findEndEventName(endEventNames) {
	    for (var name in endEventNames){
	      if (transElement.style[name] !== undefined) {
	        return endEventNames[name];
	      }
	    }
	  }
	  $transition.transitionEndEventName = findEndEventName(transitionEndEventNames);
	  $transition.animationEndEventName = findEndEventName(animationEndEventNames);
	  return $transition;
	}]);
	
	angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.position'])
	
	/**
	 * A helper service that can parse typeahead's syntax (string provided by users)
	 * Extracted to a separate service for ease of unit testing
	 */
	  .factory('typeaheadParser', ['$parse', function($parse) {
	
	  //                      00000111000000000000022200000000000000003333333333333330000000000044000
	  var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
	
	  return {
	    parse: function(input) {
	      var match = input.match(TYPEAHEAD_REGEXP);
	      if (!match) {
	        throw new Error(
	          'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
	            ' but got "' + input + '".');
	      }
	
	      return {
	        itemName:match[3],
	        source:$parse(match[4]),
	        viewMapper:$parse(match[2] || match[1]),
	        modelMapper:$parse(match[1])
	      };
	    }
	  };
	}])
	
	  .directive('typeahead', ['$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$position', 'typeaheadParser',
	    function($compile, $parse, $q, $timeout, $document, $window, $rootScope, $position, typeaheadParser) {
	    var HOT_KEYS = [9, 13, 27, 38, 40];
	    var eventDebounceTime = 200;
	
	    return {
	      require: ['ngModel', '^?ngModelOptions'],
	      link: function(originalScope, element, attrs, ctrls) {
	        var modelCtrl = ctrls[0];
	        var ngModelOptions = ctrls[1];
	        //SUPPORTED ATTRIBUTES (OPTIONS)
	
	        //minimal no of characters that needs to be entered before typeahead kicks-in
	        var minLength = originalScope.$eval(attrs.typeaheadMinLength);
	        if (!minLength && minLength !== 0) {
	          minLength = 1;
	        }
	
	        //minimal wait time after last character typed before typeahead kicks-in
	        var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;
	
	        //should it restrict model values to the ones selected from the popup only?
	        var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
	
	        //binding to a variable that indicates if matches are being retrieved asynchronously
	        var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;
	
	        //a callback executed when a match is selected
	        var onSelectCallback = $parse(attrs.typeaheadOnSelect);
	
	        //should it select highlighted popup value when losing focus?
	        var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;
	
	        //binding to a variable that indicates if there were no results after the query is completed
	        var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;
	
	        var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;
	
	        var appendToBody =  attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;
	
	        var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;
	
	        //If input matches an item of the list exactly, select it automatically
	        var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;
	
	        //INTERNAL VARIABLES
	
	        //model setter executed upon match selection
	        var parsedModel = $parse(attrs.ngModel);
	        var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
	        var $setModelValue = function(scope, newValue) {
	          if (angular.isFunction(parsedModel(originalScope)) &&
	            ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
	            return invokeModelSetter(scope, {$$$p: newValue});
	          } else {
	            return parsedModel.assign(scope, newValue);
	          }
	        };
	
	        //expressions used by typeahead
	        var parserResult = typeaheadParser.parse(attrs.typeahead);
	
	        var hasFocus;
	
	        //Used to avoid bug in iOS webview where iOS keyboard does not fire
	        //mousedown & mouseup events
	        //Issue #3699
	        var selected;
	
	        //create a child scope for the typeahead directive so we are not polluting original scope
	        //with typeahead-specific data (matches, query etc.)
	        var scope = originalScope.$new();
	        var offDestroy = originalScope.$on('$destroy', function() {
				    scope.$destroy();
	        });
	        scope.$on('$destroy', offDestroy);
	
	        // WAI-ARIA
	        var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	        element.attr({
	          'aria-autocomplete': 'list',
	          'aria-expanded': false,
	          'aria-owns': popupId
	        });
	
	        //pop-up element used to display matches
	        var popUpEl = angular.element('<div typeahead-popup></div>');
	        popUpEl.attr({
	          id: popupId,
	          matches: 'matches',
	          active: 'activeIdx',
	          select: 'select(activeIdx)',
	          'move-in-progress': 'moveInProgress',
	          query: 'query',
	          position: 'position'
	        });
	        //custom item template
	        if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
	          popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
	        }
	
	        if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
	          popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
	        }
	
	        var resetMatches = function() {
	          scope.matches = [];
	          scope.activeIdx = -1;
	          element.attr('aria-expanded', false);
	        };
	
	        var getMatchId = function(index) {
	          return popupId + '-option-' + index;
	        };
	
	        // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
	        // This attribute is added or removed automatically when the `activeIdx` changes.
	        scope.$watch('activeIdx', function(index) {
	          if (index < 0) {
	            element.removeAttr('aria-activedescendant');
	          } else {
	            element.attr('aria-activedescendant', getMatchId(index));
	          }
	        });
	
	        var inputIsExactMatch = function(inputValue, index) {
	          if (scope.matches.length > index && inputValue) {
	            return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
	          }
	
	          return false;
	        };
	
	        var getMatchesAsync = function(inputValue) {
	          var locals = {$viewValue: inputValue};
	          isLoadingSetter(originalScope, true);
	          isNoResultsSetter(originalScope, false);
	          $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
	            //it might happen that several async queries were in progress if a user were typing fast
	            //but we are interested only in responses that correspond to the current view value
	            var onCurrentRequest = (inputValue === modelCtrl.$viewValue);
	            if (onCurrentRequest && hasFocus) {
	              if (matches && matches.length > 0) {
	
	                scope.activeIdx = focusFirst ? 0 : -1;
	                isNoResultsSetter(originalScope, false);
	                scope.matches.length = 0;
	
	                //transform labels
	                for (var i = 0; i < matches.length; i++) {
	                  locals[parserResult.itemName] = matches[i];
	                  scope.matches.push({
	                    id: getMatchId(i),
	                    label: parserResult.viewMapper(scope, locals),
	                    model: matches[i]
	                  });
	                }
	
	                scope.query = inputValue;
	                //position pop-up with matches - we need to re-calculate its position each time we are opening a window
	                //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
	                //due to other elements being rendered
	                recalculatePosition();
	
	                element.attr('aria-expanded', true);
	
	                //Select the single remaining option if user input matches
	                if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
	                  scope.select(0);
	                }
	              } else {
	                resetMatches();
	                isNoResultsSetter(originalScope, true);
	              }
	            }
	            if (onCurrentRequest) {
	              isLoadingSetter(originalScope, false);
	            }
	          }, function() {
	            resetMatches();
	            isLoadingSetter(originalScope, false);
	            isNoResultsSetter(originalScope, true);
	          });
	        };
	
	        // bind events only if appendToBody params exist - performance feature
	        if (appendToBody) {
	          angular.element($window).bind('resize', fireRecalculating);
	          $document.find('body').bind('scroll', fireRecalculating);
	        }
	
	        // Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	        var timeoutEventPromise;
	
	        // Default progress type
	        scope.moveInProgress = false;
	
	        function fireRecalculating() {
	          if (!scope.moveInProgress) {
	            scope.moveInProgress = true;
	            scope.$digest();
	          }
	
	          // Cancel previous timeout
	          if (timeoutEventPromise) {
	            $timeout.cancel(timeoutEventPromise);
	          }
	
	          // Debounced executing recalculate after events fired
	          timeoutEventPromise = $timeout(function() {
	            // if popup is visible
	            if (scope.matches.length) {
	              recalculatePosition();
	            }
	
	            scope.moveInProgress = false;
	            scope.$digest();
	          }, eventDebounceTime);
	        }
	
	        // recalculate actual position and set new values to scope
	        // after digest loop is popup in right position
	        function recalculatePosition() {
	          scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	          scope.position.top += element.prop('offsetHeight');
	        }
	
	        resetMatches();
	
	        //we need to propagate user's query so we can higlight matches
	        scope.query = undefined;
	
	        //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	        var timeoutPromise;
	
	        var scheduleSearchWithTimeout = function(inputValue) {
	          timeoutPromise = $timeout(function() {
	            getMatchesAsync(inputValue);
	          }, waitTime);
	        };
	
	        var cancelPreviousTimeout = function() {
	          if (timeoutPromise) {
	            $timeout.cancel(timeoutPromise);
	          }
	        };
	
	        //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
	        //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
	        modelCtrl.$parsers.unshift(function(inputValue) {
	          hasFocus = true;
	
	          if (minLength === 0 || inputValue && inputValue.length >= minLength) {
	            if (waitTime > 0) {
	              cancelPreviousTimeout();
	              scheduleSearchWithTimeout(inputValue);
	            } else {
	              getMatchesAsync(inputValue);
	            }
	          } else {
	            isLoadingSetter(originalScope, false);
	            cancelPreviousTimeout();
	            resetMatches();
	          }
	
	          if (isEditable) {
	            return inputValue;
	          } else {
	            if (!inputValue) {
	              // Reset in case user had typed something previously.
	              modelCtrl.$setValidity('editable', true);
	              return null;
	            } else {
	              modelCtrl.$setValidity('editable', false);
	              return undefined;
	            }
	          }
	        });
	
	        modelCtrl.$formatters.push(function(modelValue) {
	          var candidateViewValue, emptyViewValue;
	          var locals = {};
	
	          // The validity may be set to false via $parsers (see above) if
	          // the model is restricted to selected values. If the model
	          // is set manually it is considered to be valid.
	          if (!isEditable) {
	            modelCtrl.$setValidity('editable', true);
	          }
	
	          if (inputFormatter) {
	            locals.$model = modelValue;
	            return inputFormatter(originalScope, locals);
	          } else {
	            //it might happen that we don't have enough info to properly render input value
	            //we need to check for this situation and simply return model value if we can't apply custom formatting
	            locals[parserResult.itemName] = modelValue;
	            candidateViewValue = parserResult.viewMapper(originalScope, locals);
	            locals[parserResult.itemName] = undefined;
	            emptyViewValue = parserResult.viewMapper(originalScope, locals);
	
	            return candidateViewValue!== emptyViewValue ? candidateViewValue : modelValue;
	          }
	        });
	
	        scope.select = function(activeIdx) {
	          //called from within the $digest() cycle
	          var locals = {};
	          var model, item;
	
	          selected = true;
	          locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
	          model = parserResult.modelMapper(originalScope, locals);
	          $setModelValue(originalScope, model);
	          modelCtrl.$setValidity('editable', true);
	          modelCtrl.$setValidity('parse', true);
	
	          onSelectCallback(originalScope, {
	            $item: item,
	            $model: model,
	            $label: parserResult.viewMapper(originalScope, locals)
	          });
	
	          resetMatches();
	
	          //return focus to the input element if a match was selected via a mouse click event
	          // use timeout to avoid $rootScope:inprog error
	          if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
	            $timeout(function() { element[0].focus(); }, 0, false);
	          }
	        };
	
	        //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
	        element.bind('keydown', function(evt) {
	          //typeahead is open and an "interesting" key was pressed
	          if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
	            return;
	          }
	
	          // if there's nothing selected (i.e. focusFirst) and enter or tab is hit, clear the results
	          if (scope.activeIdx === -1 && (evt.which === 9 || evt.which === 13)) {
	            resetMatches();
	            scope.$digest();
	            return;
	          }
	
	          evt.preventDefault();
	
	          if (evt.which === 40) {
	            scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
	            scope.$digest();
	
	          } else if (evt.which === 38) {
	            scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
	            scope.$digest();
	
	          } else if (evt.which === 13 || evt.which === 9) {
	            scope.$apply(function () {
	              scope.select(scope.activeIdx);
	            });
	
	          } else if (evt.which === 27) {
	            evt.stopPropagation();
	
	            resetMatches();
	            scope.$digest();
	          }
	        });
	
	        element.bind('blur', function() {
	          if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
	            selected = true;
	            scope.$apply(function() {
	              scope.select(scope.activeIdx);
	            });
	          }
	          hasFocus = false;
	          selected = false;
	        });
	
	        // Keep reference to click handler to unbind it.
	        var dismissClickHandler = function(evt) {
	          // Issue #3973
	          // Firefox treats right click as a click on document
	          if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
	            resetMatches();
	            if (!$rootScope.$$phase) {
	              scope.$digest();
	            }
	          }
	        };
	
	        $document.bind('click', dismissClickHandler);
	
	        originalScope.$on('$destroy', function() {
	          $document.unbind('click', dismissClickHandler);
	          if (appendToBody) {
	            $popup.remove();
	          }
	          // Prevent jQuery cache memory leak
	          popUpEl.remove();
	        });
	
	        var $popup = $compile(popUpEl)(scope);
	
	        if (appendToBody) {
	          $document.find('body').append($popup);
	        } else {
	          element.after($popup);
	        }
	      }
	    };
	
	  }])
	
	  .directive('typeaheadPopup', function() {
	    return {
	      restrict: 'EA',
	      scope: {
	        matches: '=',
	        query: '=',
	        active: '=',
	        position: '&',
	        moveInProgress: '=',
	        select: '&'
	      },
	      replace: true,
	      templateUrl: function(element, attrs) {
	        return attrs.popupTemplateUrl || 'template/typeahead/typeahead-popup.html';
	      },
	      link: function(scope, element, attrs) {
	        scope.templateUrl = attrs.templateUrl;
	
	        scope.isOpen = function() {
	          return scope.matches.length > 0;
	        };
	
	        scope.isActive = function(matchIdx) {
	          return scope.active == matchIdx;
	        };
	
	        scope.selectActive = function(matchIdx) {
	          scope.active = matchIdx;
	        };
	
	        scope.selectMatch = function(activeIdx) {
	          scope.select({activeIdx:activeIdx});
	        };
	      }
	    };
	  })
	
	  .directive('typeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
	    return {
	      restrict: 'EA',
	      scope: {
	        index: '=',
	        match: '=',
	        query: '='
	      },
	      link:function(scope, element, attrs) {
	        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'template/typeahead/typeahead-match.html';
	        $templateRequest(tplUrl).then(function(tplContent) {
	          $compile(tplContent.trim())(scope, function(clonedElement) {
	            element.replaceWith(clonedElement);
	          });
	        });
	      }
	    };
	  }])
	
	  .filter('typeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
	    var isSanitizePresent;
	    isSanitizePresent = $injector.has('$sanitize');
	
	    function escapeRegexp(queryToEscape) {
	      // Regex: capture the whole query string and replace it with the string that will be used to match
	      // the results, for example if the capture is "a" the result will be \a
	      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    }
	
	    function containsHtml(matchItem) {
	      return /<.*>/g.test(matchItem);
	    }
	
	    return function(matchItem, query) {
	      if (!isSanitizePresent && containsHtml(matchItem)) {
	        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
	      }
	      matchItem = query? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
	      if (!isSanitizePresent) {
	        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
	      }
	      return matchItem;
	    };
	  }]);
	
	angular.module("template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/accordion/accordion-group.html",
	    "<div class=\"panel {{panelClass || 'panel-default'}}\">\n" +
	    "  <div class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
	    "    <h4 class=\"panel-title\">\n" +
	    "      <a href tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" accordion-transclude=\"heading\"><span ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
	    "    </h4>\n" +
	    "  </div>\n" +
	    "  <div class=\"panel-collapse collapse\" collapse=\"!isOpen\">\n" +
	    "	  <div class=\"panel-body\" ng-transclude></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/accordion/accordion.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/accordion/accordion.html",
	    "<div class=\"panel-group\" ng-transclude></div>");
	}]);
	
	angular.module("template/alert/alert.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/alert/alert.html",
	    "<div class=\"alert\" ng-class=\"['alert-' + (type || 'warning'), closeable ? 'alert-dismissible' : null]\" role=\"alert\">\n" +
	    "    <button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close($event)\">\n" +
	    "        <span aria-hidden=\"true\">&times;</span>\n" +
	    "        <span class=\"sr-only\">Close</span>\n" +
	    "    </button>\n" +
	    "    <div ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/carousel/carousel.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/carousel/carousel.html",
	    "<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\" ng-swipe-right=\"prev()\" ng-swipe-left=\"next()\">\n" +
	    "    <ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
	    "        <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{active: isActive(slide)}\" ng-click=\"select(slide)\"></li>\n" +
	    "    </ol>\n" +
	    "    <div class=\"carousel-inner\" ng-transclude></div>\n" +
	    "    <a class=\"left carousel-control\" ng-click=\"prev()\" ng-show=\"slides.length > 1\"><span class=\"glyphicon glyphicon-chevron-left\"></span></a>\n" +
	    "    <a class=\"right carousel-control\" ng-click=\"next()\" ng-show=\"slides.length > 1\"><span class=\"glyphicon glyphicon-chevron-right\"></span></a>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/carousel/slide.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/carousel/slide.html",
	    "<div ng-class=\"{\n" +
	    "    'active': active\n" +
	    "  }\" class=\"item text-center\" ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/datepicker.html",
	    "<div ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" +
	    "  <daypicker ng-switch-when=\"day\" tabindex=\"0\"></daypicker>\n" +
	    "  <monthpicker ng-switch-when=\"month\" tabindex=\"0\"></monthpicker>\n" +
	    "  <yearpicker ng-switch-when=\"year\" tabindex=\"0\"></yearpicker>\n" +
	    "</div>");
	}]);
	
	angular.module("template/datepicker/day.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/day.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
	    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
	    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default btn-sm\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/month.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/month.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/popup.html",
	    "<ul class=\"dropdown-menu\" ng-if=\"isOpen\" style=\"display: block\" ng-style=\"{top: position.top+'px', left: position.left+'px'}\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
	    "	<li ng-transclude></li>\n" +
	    "	<li ng-if=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n" +
	    "		<span class=\"btn-group pull-left\">\n" +
	    "			<button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"select('today')\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
	    "			<button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"select(null)\">{{ getText('clear') }}</button>\n" +
	    "		</span>\n" +
	    "		<button type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"close()\">{{ getText('close') }}</button>\n" +
	    "	</li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/year.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/year.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th colspan=\"3\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\">\n" +
	    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/modal/backdrop.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/modal/backdrop.html",
	    "<div class=\"modal-backdrop\"\n" +
	    "     modal-animation-class=\"fade\"\n" +
	    "     modal-in-class=\"in\"\n" +
	    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
	    "></div>\n" +
	    "");
	}]);
	
	angular.module("template/modal/window.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/modal/window.html",
	    "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n" +
	    "    modal-animation-class=\"fade\"\n" +
	    "    modal-in-class=\"in\"\n" +
	    "	ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\" ng-click=\"close($event)\">\n" +
	    "    <div class=\"modal-dialog\" ng-class=\"size ? 'modal-' + size : ''\"><div class=\"modal-content\" modal-transclude></div></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/pagination/pager.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/pagination/pager.html",
	    "<ul class=\"pager\">\n" +
	    "  <li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
	    "  <li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	
	angular.module("template/pagination/pagination.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/pagination/pagination.html",
	    "<ul class=\"pagination\">\n" +
	    "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\">{{::getText('first')}}</a></li>\n" +
	    "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
	    "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\">{{page.text}}</a></li>\n" +
	    "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
	    "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\">{{::getText('last')}}</a></li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	
	angular.module("template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tooltip/tooltip-html-popup.html",
	    "<div class=\"tooltip\"\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/tooltip/tooltip-html-unsafe-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tooltip/tooltip-html-unsafe-popup.html",
	    "<div class=\"tooltip\"\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\" bind-html-unsafe=\"content\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tooltip/tooltip-popup.html",
	    "<div class=\"tooltip\"\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tooltip/tooltip-template-popup.html",
	    "<div class=\"tooltip\"\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\"\n" +
	    "    tooltip-template-transclude=\"contentExp()\"\n" +
	    "    tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/popover/popover-html.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/popover/popover-html.html",
	    "<div class=\"popover\"\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"arrow\"></div>\n" +
	    "\n" +
	    "  <div class=\"popover-inner\">\n" +
	    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
	    "      <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/popover/popover-template.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/popover/popover-template.html",
	    "<div class=\"popover\"\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"arrow\"></div>\n" +
	    "\n" +
	    "  <div class=\"popover-inner\">\n" +
	    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
	    "      <div class=\"popover-content\"\n" +
	    "        tooltip-template-transclude=\"contentExp()\"\n" +
	    "        tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/popover/popover.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/popover/popover.html",
	    "<div class=\"popover\"\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"arrow\"></div>\n" +
	    "\n" +
	    "  <div class=\"popover-inner\">\n" +
	    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
	    "      <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/progressbar/bar.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/progressbar/bar.html",
	    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" style=\"min-width: 0;\" ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("template/progressbar/progress.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/progressbar/progress.html",
	    "<div class=\"progress\" ng-transclude></div>");
	}]);
	
	angular.module("template/progressbar/progressbar.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/progressbar/progressbar.html",
	    "<div class=\"progress\">\n" +
	    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" style=\"min-width: 0;\" ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/rating/rating.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/rating/rating.html",
	    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\">\n" +
	    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
	    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\" ></i>\n" +
	    "</span>\n" +
	    "");
	}]);
	
	angular.module("template/tabs/tab.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tabs/tab.html",
	    "<li ng-class=\"{active: active, disabled: disabled}\">\n" +
	    "  <a href ng-click=\"select()\" tab-heading-transclude>{{heading}}</a>\n" +
	    "</li>\n" +
	    "");
	}]);
	
	angular.module("template/tabs/tabset.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tabs/tabset.html",
	    "<div>\n" +
	    "  <ul class=\"nav nav-{{type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
	    "  <div class=\"tab-content\">\n" +
	    "    <div class=\"tab-pane\" \n" +
	    "         ng-repeat=\"tab in tabs\" \n" +
	    "         ng-class=\"{active: tab.active}\"\n" +
	    "         tab-content-transclude=\"tab\">\n" +
	    "    </div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/timepicker/timepicker.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/timepicker/timepicker.html",
	    "<table>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
	    "      <td><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td>&nbsp;</td>\n" +
	    "      <td><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td ng-show=\"showMeridian\"></td>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <td class=\"form-group\" ng-class=\"{'has-error': invalidHours}\">\n" +
	    "        <input style=\"width:50px;\" type=\"text\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\">\n" +
	    "      </td>\n" +
	    "      <td>:</td>\n" +
	    "      <td class=\"form-group\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
	    "        <input style=\"width:50px;\" type=\"text\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\">\n" +
	    "      </td>\n" +
	    "      <td ng-show=\"showMeridian\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\">{{meridian}}</button></td>\n" +
	    "    </tr>\n" +
	    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
	    "      <td><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td>&nbsp;</td>\n" +
	    "      <td><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td ng-show=\"showMeridian\"></td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/typeahead/typeahead-match.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/typeahead/typeahead-match.html",
	    "<a href tabindex=\"-1\" ng-bind-html=\"match.label | typeaheadHighlight:query\"></a>\n" +
	    "");
	}]);
	
	angular.module("template/typeahead/typeahead-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/typeahead/typeahead-popup.html",
	    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" style=\"display: block;\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
	    "    <li ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.id}}\">\n" +
	    "        <div typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
	    "    </li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	!angular.$$csp() && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>');

/***/ }),

/***/ 1010:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1011);
	__webpack_require__(1012);

/***/ }),

/***/ 1011:
/***/ (function(module, exports) {

	/*! 
	 * angular-loading-bar v0.7.1
	 * https://chieffancypants.github.io/angular-loading-bar
	 * Copyright (c) 2015 Wes Cruver
	 * License: MIT
	 */
	/*
	 * angular-loading-bar
	 *
	 * intercepts XHR requests and creates a loading bar.
	 * Based on the excellent nprogress work by rstacruz (more info in readme)
	 *
	 * (c) 2013 Wes Cruver
	 * License: MIT
	 */
	
	
	(function() {
	
	'use strict';
	
	// Alias the loading bar for various backwards compatibilities since the project has matured:
	angular.module('angular-loading-bar', ['cfp.loadingBarInterceptor']);
	angular.module('chieffancypants.loadingBar', ['cfp.loadingBarInterceptor']);
	
	
	/**
	 * loadingBarInterceptor service
	 *
	 * Registers itself as an Angular interceptor and listens for XHR requests.
	 */
	angular.module('cfp.loadingBarInterceptor', ['cfp.loadingBar'])
	  .config(['$httpProvider', function ($httpProvider) {
	
	    var interceptor = ['$q', '$cacheFactory', '$timeout', '$rootScope', '$log', 'cfpLoadingBar', function ($q, $cacheFactory, $timeout, $rootScope, $log, cfpLoadingBar) {
	
	      /**
	       * The total number of requests made
	       */
	      var reqsTotal = 0;
	
	      /**
	       * The number of requests completed (either successfully or not)
	       */
	      var reqsCompleted = 0;
	
	      /**
	       * The amount of time spent fetching before showing the loading bar
	       */
	      var latencyThreshold = cfpLoadingBar.latencyThreshold;
	
	      /**
	       * $timeout handle for latencyThreshold
	       */
	      var startTimeout;
	
	
	      /**
	       * calls cfpLoadingBar.complete() which removes the
	       * loading bar from the DOM.
	       */
	      function setComplete() {
	        $timeout.cancel(startTimeout);
	        cfpLoadingBar.complete();
	        reqsCompleted = 0;
	        reqsTotal = 0;
	      }
	
	      /**
	       * Determine if the response has already been cached
	       * @param  {Object}  config the config option from the request
	       * @return {Boolean} retrns true if cached, otherwise false
	       */
	      function isCached(config) {
	        var cache;
	        var defaultCache = $cacheFactory.get('$http');
	        var defaults = $httpProvider.defaults;
	
	        // Choose the proper cache source. Borrowed from angular: $http service
	        if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	            cache = angular.isObject(config.cache) ? config.cache
	              : angular.isObject(defaults.cache) ? defaults.cache
	              : defaultCache;
	        }
	
	        var cached = cache !== undefined ?
	          cache.get(config.url) !== undefined : false;
	
	        if (config.cached !== undefined && cached !== config.cached) {
	          return config.cached;
	        }
	        config.cached = cached;
	        return cached;
	      }
	
	
	      return {
	        'request': function(config) {
	          // Check to make sure this request hasn't already been cached and that
	          // the requester didn't explicitly ask us to ignore this request:
	          if (!config.ignoreLoadingBar && !isCached(config)) {
	            $rootScope.$broadcast('cfpLoadingBar:loading', {url: config.url});
	            if (reqsTotal === 0) {
	              startTimeout = $timeout(function() {
	                cfpLoadingBar.start();
	              }, latencyThreshold);
	            }
	            reqsTotal++;
	            cfpLoadingBar.set(reqsCompleted / reqsTotal);
	          }
	          return config;
	        },
	
	        'response': function(response) {
	          if (!response || !response.config) {
	            $log.error('Broken interceptor detected: Config object not supplied in response:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
	            return response;
	          }
	
	          if (!response.config.ignoreLoadingBar && !isCached(response.config)) {
	            reqsCompleted++;
	            $rootScope.$broadcast('cfpLoadingBar:loaded', {url: response.config.url, result: response});
	            if (reqsCompleted >= reqsTotal) {
	              setComplete();
	            } else {
	              cfpLoadingBar.set(reqsCompleted / reqsTotal);
	            }
	          }
	          return response;
	        },
	
	        'responseError': function(rejection) {
	          if (!rejection || !rejection.config) {
	            $log.error('Broken interceptor detected: Config object not supplied in rejection:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
	            return $q.reject(rejection);
	          }
	
	          if (!rejection.config.ignoreLoadingBar && !isCached(rejection.config)) {
	            reqsCompleted++;
	            $rootScope.$broadcast('cfpLoadingBar:loaded', {url: rejection.config.url, result: rejection});
	            if (reqsCompleted >= reqsTotal) {
	              setComplete();
	            } else {
	              cfpLoadingBar.set(reqsCompleted / reqsTotal);
	            }
	          }
	          return $q.reject(rejection);
	        }
	      };
	    }];
	
	    $httpProvider.interceptors.push(interceptor);
	  }]);
	
	
	/**
	 * Loading Bar
	 *
	 * This service handles adding and removing the actual element in the DOM.
	 * Generally, best practices for DOM manipulation is to take place in a
	 * directive, but because the element itself is injected in the DOM only upon
	 * XHR requests, and it's likely needed on every view, the best option is to
	 * use a service.
	 */
	angular.module('cfp.loadingBar', [])
	  .provider('cfpLoadingBar', function() {
	
	    this.includeSpinner = true;
	    this.includeBar = true;
	    this.latencyThreshold = 100;
	    this.startSize = 0.02;
	    this.parentSelector = 'body';
	    this.spinnerTemplate = '<div id="loading-bar-spinner"><div class="spinner-icon"></div></div>';
	    this.loadingBarTemplate = '<div id="loading-bar"><div class="bar"><div class="peg"></div></div></div>';
	
	    this.$get = ['$injector', '$document', '$timeout', '$rootScope', function ($injector, $document, $timeout, $rootScope) {
	      var $animate;
	      var $parentSelector = this.parentSelector,
	        loadingBarContainer = angular.element(this.loadingBarTemplate),
	        loadingBar = loadingBarContainer.find('div').eq(0),
	        spinner = angular.element(this.spinnerTemplate);
	
	      var incTimeout,
	        completeTimeout,
	        started = false,
	        status = 0;
	
	      var includeSpinner = this.includeSpinner;
	      var includeBar = this.includeBar;
	      var startSize = this.startSize;
	
	      /**
	       * Inserts the loading bar element into the dom, and sets it to 2%
	       */
	      function _start() {
	        if (!$animate) {
	          $animate = $injector.get('$animate');
	        }
	
	        var $parent = $document.find($parentSelector).eq(0);
	        $timeout.cancel(completeTimeout);
	
	        // do not continually broadcast the started event:
	        if (started) {
	          return;
	        }
	
	        $rootScope.$broadcast('cfpLoadingBar:started');
	        started = true;
	
	        if (includeBar) {
	          $animate.enter(loadingBarContainer, $parent, angular.element($parent[0].lastChild));
	        }
	
	        if (includeSpinner) {
	          $animate.enter(spinner, $parent, angular.element($parent[0].lastChild));
	        }
	
	        _set(startSize);
	      }
	
	      /**
	       * Set the loading bar's width to a certain percent.
	       *
	       * @param n any value between 0 and 1
	       */
	      function _set(n) {
	        if (!started) {
	          return;
	        }
	        var pct = (n * 100) + '%';
	        loadingBar.css('width', pct);
	        status = n;
	
	        // increment loadingbar to give the illusion that there is always
	        // progress but make sure to cancel the previous timeouts so we don't
	        // have multiple incs running at the same time.
	        $timeout.cancel(incTimeout);
	        incTimeout = $timeout(function() {
	          _inc();
	        }, 250);
	      }
	
	      /**
	       * Increments the loading bar by a random amount
	       * but slows down as it progresses
	       */
	      function _inc() {
	        if (_status() >= 1) {
	          return;
	        }
	
	        var rnd = 0;
	
	        // TODO: do this mathmatically instead of through conditions
	
	        var stat = _status();
	        if (stat >= 0 && stat < 0.25) {
	          // Start out between 3 - 6% increments
	          rnd = (Math.random() * (5 - 3 + 1) + 3) / 100;
	        } else if (stat >= 0.25 && stat < 0.65) {
	          // increment between 0 - 3%
	          rnd = (Math.random() * 3) / 100;
	        } else if (stat >= 0.65 && stat < 0.9) {
	          // increment between 0 - 2%
	          rnd = (Math.random() * 2) / 100;
	        } else if (stat >= 0.9 && stat < 0.99) {
	          // finally, increment it .5 %
	          rnd = 0.005;
	        } else {
	          // after 99%, don't increment:
	          rnd = 0;
	        }
	
	        var pct = _status() + rnd;
	        _set(pct);
	      }
	
	      function _status() {
	        return status;
	      }
	
	      function _completeAnimation() {
	        status = 0;
	        started = false;
	      }
	
	      function _complete() {
	        if (!$animate) {
	          $animate = $injector.get('$animate');
	        }
	
	        $rootScope.$broadcast('cfpLoadingBar:completed');
	        _set(1);
	
	        $timeout.cancel(completeTimeout);
	
	        // Attempt to aggregate any start/complete calls within 500ms:
	        completeTimeout = $timeout(function() {
	          var promise = $animate.leave(loadingBarContainer, _completeAnimation);
	          if (promise && promise.then) {
	            promise.then(_completeAnimation);
	          }
	          $animate.leave(spinner);
	        }, 500);
	      }
	
	      return {
	        start            : _start,
	        set              : _set,
	        status           : _status,
	        inc              : _inc,
	        complete         : _complete,
	        includeSpinner   : this.includeSpinner,
	        latencyThreshold : this.latencyThreshold,
	        parentSelector   : this.parentSelector,
	        startSize        : this.startSize
	      };
	
	
	    }];     //
	  });       // wtf javascript. srsly
	})();       //


/***/ }),

/***/ 1012:
983,

/***/ 1014:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1015);
	__webpack_require__(1016);

/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

	(function() {
	  var module,
	    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	  module = angular.module('angularBootstrapNavTree', []);
	
	  module.directive('abnTree', [
	    '$timeout', function($timeout) {
	      return {
	        restrict: 'E',
	        template: "<ul class=\"nav nav-list nav-pills nav-stacked abn-tree\">\n  <li ng-repeat=\"row in tree_rows | filter:{visible:true} track by row.branch.uid\" ng-animate=\"'abn-tree-animate'\" ng-class=\"'level-' + {{ row.level }} + (row.branch.selected ? ' active':'') + ' ' +row.classes.join(' ')\" class=\"abn-tree-row\"><a ng-click=\"user_clicks_branch(row.branch)\"><i ng-class=\"row.tree_icon\" ng-click=\"row.branch.expanded = !row.branch.expanded\" class=\"indented tree-icon\"> </i><span class=\"indented tree-label\">{{ row.label }} </span></a></li>\n</ul>",
	        replace: true,
	        scope: {
	          treeData: '=',
	          onSelect: '&',
	          initialSelection: '@',
	          treeControl: '='
	        },
	        link: function(scope, element, attrs) {
	          var error, expand_all_parents, expand_level, for_all_ancestors, for_each_branch, get_parent, n, on_treeData_change, select_branch, selected_branch, tree;
	          error = function(s) {
	            console.log('ERROR:' + s);
	            debugger;
	            return void 0;
	          };
	          if (attrs.iconExpand == null) {
	            attrs.iconExpand = 'icon-plus  glyphicon glyphicon-plus  fa fa-plus';
	          }
	          if (attrs.iconCollapse == null) {
	            attrs.iconCollapse = 'icon-minus glyphicon glyphicon-minus fa fa-minus';
	          }
	          if (attrs.iconLeaf == null) {
	            attrs.iconLeaf = 'icon-file  glyphicon glyphicon-file  fa fa-file';
	          }
	          if (attrs.expandLevel == null) {
	            attrs.expandLevel = '3';
	          }
	          expand_level = parseInt(attrs.expandLevel, 10);
	          if (!scope.treeData) {
	            alert('no treeData defined for the tree!');
	            return;
	          }
	          if (scope.treeData.length == null) {
	            if (treeData.label != null) {
	              scope.treeData = [treeData];
	            } else {
	              alert('treeData should be an array of root branches');
	              return;
	            }
	          }
	          for_each_branch = function(f) {
	            var do_f, root_branch, _i, _len, _ref, _results;
	            do_f = function(branch, level) {
	              var child, _i, _len, _ref, _results;
	              f(branch, level);
	              if (branch.children != null) {
	                _ref = branch.children;
	                _results = [];
	                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	                  child = _ref[_i];
	                  _results.push(do_f(child, level + 1));
	                }
	                return _results;
	              }
	            };
	            _ref = scope.treeData;
	            _results = [];
	            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	              root_branch = _ref[_i];
	              _results.push(do_f(root_branch, 1));
	            }
	            return _results;
	          };
	          selected_branch = null;
	          select_branch = function(branch) {
	            if (!branch) {
	              if (selected_branch != null) {
	                selected_branch.selected = false;
	              }
	              selected_branch = null;
	              return;
	            }
	            if (branch !== selected_branch) {
	              if (selected_branch != null) {
	                selected_branch.selected = false;
	              }
	              branch.selected = true;
	              selected_branch = branch;
	              expand_all_parents(branch);
	              if (branch.onSelect != null) {
	                return $timeout(function() {
	                  return branch.onSelect(branch);
	                });
	              } else {
	                if (scope.onSelect != null) {
	                  return $timeout(function() {
	                    return scope.onSelect({
	                      branch: branch
	                    });
	                  });
	                }
	              }
	            }
	          };
	          scope.user_clicks_branch = function(branch) {
	            if (branch !== selected_branch) {
	              return select_branch(branch);
	            }
	          };
	          get_parent = function(child) {
	            var parent;
	            parent = void 0;
	            if (child.parent_uid) {
	              for_each_branch(function(b) {
	                if (b.uid === child.parent_uid) {
	                  return parent = b;
	                }
	              });
	            }
	            return parent;
	          };
	          for_all_ancestors = function(child, fn) {
	            var parent;
	            parent = get_parent(child);
	            if (parent != null) {
	              fn(parent);
	              return for_all_ancestors(parent, fn);
	            }
	          };
	          expand_all_parents = function(child) {
	            return for_all_ancestors(child, function(b) {
	              return b.expanded = true;
	            });
	          };
	          scope.tree_rows = [];
	          on_treeData_change = function() {
	            var add_branch_to_list, root_branch, _i, _len, _ref, _results;
	            for_each_branch(function(b, level) {
	              if (!b.uid) {
	                return b.uid = "" + Math.random();
	              }
	            });
	            for_each_branch(function(b) {
	              var child, _i, _len, _ref, _results;
	              if (angular.isArray(b.children)) {
	                _ref = b.children;
	                _results = [];
	                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	                  child = _ref[_i];
	                  _results.push(child.parent_uid = b.uid);
	                }
	                return _results;
	              }
	            });
	            scope.tree_rows = [];
	            for_each_branch(function(branch) {
	              var child, f;
	              if (branch.children) {
	                if (branch.children.length > 0) {
	                  f = function(e) {
	                    if (typeof e === 'string') {
	                      return {
	                        label: e,
	                        children: []
	                      };
	                    } else {
	                      return e;
	                    }
	                  };
	                  return branch.children = (function() {
	                    var _i, _len, _ref, _results;
	                    _ref = branch.children;
	                    _results = [];
	                    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	                      child = _ref[_i];
	                      _results.push(f(child));
	                    }
	                    return _results;
	                  })();
	                }
	              } else {
	                return branch.children = [];
	              }
	            });
	            add_branch_to_list = function(level, branch, visible) {
	              var child, child_visible, tree_icon, _i, _len, _ref, _results;
	              if (branch.expanded == null) {
	                branch.expanded = false;
	              }
	              if (branch.classes == null) {
	                branch.classes = [];
	              }
	              if (!branch.noLeaf && (!branch.children || branch.children.length === 0)) {
	                tree_icon = attrs.iconLeaf;
	                if (__indexOf.call(branch.classes, "leaf") < 0) {
	                  branch.classes.push("leaf");
	                }
	              } else {
	                if (branch.expanded) {
	                  tree_icon = attrs.iconCollapse;
	                } else {
	                  tree_icon = attrs.iconExpand;
	                }
	              }
	              scope.tree_rows.push({
	                level: level,
	                branch: branch,
	                label: branch.label,
	                classes: branch.classes,
	                tree_icon: tree_icon,
	                visible: visible
	              });
	              if (branch.children != null) {
	                _ref = branch.children;
	                _results = [];
	                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	                  child = _ref[_i];
	                  child_visible = visible && branch.expanded;
	                  _results.push(add_branch_to_list(level + 1, child, child_visible));
	                }
	                return _results;
	              }
	            };
	            _ref = scope.treeData;
	            _results = [];
	            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	              root_branch = _ref[_i];
	              _results.push(add_branch_to_list(1, root_branch, true));
	            }
	            return _results;
	          };
	          scope.$watch('treeData', on_treeData_change, true);
	          if (attrs.initialSelection != null) {
	            for_each_branch(function(b) {
	              if (b.label === attrs.initialSelection) {
	                return $timeout(function() {
	                  return select_branch(b);
	                });
	              }
	            });
	          }
	          n = scope.treeData.length;
	          for_each_branch(function(b, level) {
	            b.level = level;
	            return b.expanded = b.level < expand_level;
	          });
	          if (scope.treeControl != null) {
	            if (angular.isObject(scope.treeControl)) {
	              tree = scope.treeControl;
	              tree.expand_all = function() {
	                return for_each_branch(function(b, level) {
	                  return b.expanded = true;
	                });
	              };
	              tree.collapse_all = function() {
	                return for_each_branch(function(b, level) {
	                  return b.expanded = false;
	                });
	              };
	              tree.get_first_branch = function() {
	                n = scope.treeData.length;
	                if (n > 0) {
	                  return scope.treeData[0];
	                }
	              };
	              tree.select_first_branch = function() {
	                var b;
	                b = tree.get_first_branch();
	                return tree.select_branch(b);
	              };
	              tree.get_selected_branch = function() {
	                return selected_branch;
	              };
	              tree.get_parent_branch = function(b) {
	                return get_parent(b);
	              };
	              tree.select_branch = function(b) {
	                select_branch(b);
	                return b;
	              };
	              tree.get_children = function(b) {
	                return b.children;
	              };
	              tree.select_parent_branch = function(b) {
	                var p;
	                if (b == null) {
	                  b = tree.get_selected_branch();
	                }
	                if (b != null) {
	                  p = tree.get_parent_branch(b);
	                  if (p != null) {
	                    tree.select_branch(p);
	                    return p;
	                  }
	                }
	              };
	              tree.add_branch = function(parent, new_branch) {
	                if (parent != null) {
	                  parent.children.push(new_branch);
	                  parent.expanded = true;
	                } else {
	                  scope.treeData.push(new_branch);
	                }
	                return new_branch;
	              };
	              tree.add_root_branch = function(new_branch) {
	                tree.add_branch(null, new_branch);
	                return new_branch;
	              };
	              tree.expand_branch = function(b) {
	                if (b == null) {
	                  b = tree.get_selected_branch();
	                }
	                if (b != null) {
	                  b.expanded = true;
	                  return b;
	                }
	              };
	              tree.collapse_branch = function(b) {
	                if (b == null) {
	                  b = selected_branch;
	                }
	                if (b != null) {
	                  b.expanded = false;
	                  return b;
	                }
	              };
	              tree.get_siblings = function(b) {
	                var p, siblings;
	                if (b == null) {
	                  b = selected_branch;
	                }
	                if (b != null) {
	                  p = tree.get_parent_branch(b);
	                  if (p) {
	                    siblings = p.children;
	                  } else {
	                    siblings = scope.treeData;
	                  }
	                  return siblings;
	                }
	              };
	              tree.get_next_sibling = function(b) {
	                var i, siblings;
	                if (b == null) {
	                  b = selected_branch;
	                }
	                if (b != null) {
	                  siblings = tree.get_siblings(b);
	                  n = siblings.length;
	                  i = siblings.indexOf(b);
	                  if (i < n) {
	                    return siblings[i + 1];
	                  }
	                }
	              };
	              tree.get_prev_sibling = function(b) {
	                var i, siblings;
	                if (b == null) {
	                  b = selected_branch;
	                }
	                siblings = tree.get_siblings(b);
	                n = siblings.length;
	                i = siblings.indexOf(b);
	                if (i > 0) {
	                  return siblings[i - 1];
	                }
	              };
	              tree.select_next_sibling = function(b) {
	                var next;
	                if (b == null) {
	                  b = selected_branch;
	                }
	                if (b != null) {
	                  next = tree.get_next_sibling(b);
	                  if (next != null) {
	                    return tree.select_branch(next);
	                  }
	                }
	              };
	              tree.select_prev_sibling = function(b) {
	                var prev;
	                if (b == null) {
	                  b = selected_branch;
	                }
	                if (b != null) {
	                  prev = tree.get_prev_sibling(b);
	                  if (prev != null) {
	                    return tree.select_branch(prev);
	                  }
	                }
	              };
	              tree.get_first_child = function(b) {
	                var _ref;
	                if (b == null) {
	                  b = selected_branch;
	                }
	                if (b != null) {
	                  if (((_ref = b.children) != null ? _ref.length : void 0) > 0) {
	                    return b.children[0];
	                  }
	                }
	              };
	              tree.get_closest_ancestor_next_sibling = function(b) {
	                var next, parent;
	                next = tree.get_next_sibling(b);
	                if (next != null) {
	                  return next;
	                } else {
	                  parent = tree.get_parent_branch(b);
	                  return tree.get_closest_ancestor_next_sibling(parent);
	                }
	              };
	              tree.get_next_branch = function(b) {
	                var next;
	                if (b == null) {
	                  b = selected_branch;
	                }
	                if (b != null) {
	                  next = tree.get_first_child(b);
	                  if (next != null) {
	                    return next;
	                  } else {
	                    next = tree.get_closest_ancestor_next_sibling(b);
	                    return next;
	                  }
	                }
	              };
	              tree.select_next_branch = function(b) {
	                var next;
	                if (b == null) {
	                  b = selected_branch;
	                }
	                if (b != null) {
	                  next = tree.get_next_branch(b);
	                  if (next != null) {
	                    tree.select_branch(next);
	                    return next;
	                  }
	                }
	              };
	              tree.last_descendant = function(b) {
	                var last_child;
	                if (b == null) {
	                  debugger;
	                }
	                n = b.children.length;
	                if (n === 0) {
	                  return b;
	                } else {
	                  last_child = b.children[n - 1];
	                  return tree.last_descendant(last_child);
	                }
	              };
	              tree.get_prev_branch = function(b) {
	                var parent, prev_sibling;
	                if (b == null) {
	                  b = selected_branch;
	                }
	                if (b != null) {
	                  prev_sibling = tree.get_prev_sibling(b);
	                  if (prev_sibling != null) {
	                    return tree.last_descendant(prev_sibling);
	                  } else {
	                    parent = tree.get_parent_branch(b);
	                    return parent;
	                  }
	                }
	              };
	              return tree.select_prev_branch = function(b) {
	                var prev;
	                if (b == null) {
	                  b = selected_branch;
	                }
	                if (b != null) {
	                  prev = tree.get_prev_branch(b);
	                  if (prev != null) {
	                    tree.select_branch(prev);
	                    return prev;
	                  }
	                }
	              };
	            }
	          }
	        }
	      };
	    }
	  ]);
	
	}).call(this);


/***/ }),

/***/ 1016:
983,

/***/ 1018:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1019);

/***/ }),

/***/ 1019:
/***/ (function(module, exports) {

	/**
	 * State-based routing for AngularJS
	 * @version v0.2.18
	 * @link http://angular-ui.github.com/
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	/* commonjs package manager support (eg componentjs) */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
	  module.exports = 'ui.router';
	}
	
	(function (window, angular, undefined) {
	/*jshint globalstrict:true*/
	/*global angular:false*/
	'use strict';
	
	var isDefined = angular.isDefined,
	    isFunction = angular.isFunction,
	    isString = angular.isString,
	    isObject = angular.isObject,
	    isArray = angular.isArray,
	    forEach = angular.forEach,
	    extend = angular.extend,
	    copy = angular.copy,
	    toJson = angular.toJson;
	
	function inherit(parent, extra) {
	  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
	}
	
	function merge(dst) {
	  forEach(arguments, function(obj) {
	    if (obj !== dst) {
	      forEach(obj, function(value, key) {
	        if (!dst.hasOwnProperty(key)) dst[key] = value;
	      });
	    }
	  });
	  return dst;
	}
	
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	  var path = [];
	
	  for (var n in first.path) {
	    if (first.path[n] !== second.path[n]) break;
	    path.push(first.path[n]);
	  }
	  return path;
	}
	
	/**
	 * IE8-safe wrapper for `Object.keys()`.
	 *
	 * @param {Object} object A JavaScript object.
	 * @return {Array} Returns the keys of the object as an array.
	 */
	function objectKeys(object) {
	  if (Object.keys) {
	    return Object.keys(object);
	  }
	  var result = [];
	
	  forEach(object, function(val, key) {
	    result.push(key);
	  });
	  return result;
	}
	
	/**
	 * IE8-safe wrapper for `Array.prototype.indexOf()`.
	 *
	 * @param {Array} array A JavaScript array.
	 * @param {*} value A value to search the array for.
	 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
	 */
	function indexOf(array, value) {
	  if (Array.prototype.indexOf) {
	    return array.indexOf(value, Number(arguments[2]) || 0);
	  }
	  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
	  from = (from < 0) ? Math.ceil(from) : Math.floor(from);
	
	  if (from < 0) from += len;
	
	  for (; from < len; from++) {
	    if (from in array && array[from] === value) return from;
	  }
	  return -1;
	}
	
	/**
	 * Merges a set of parameters with all parameters inherited between the common parents of the
	 * current state and a given destination state.
	 *
	 * @param {Object} currentParams The value of the current state parameters ($stateParams).
	 * @param {Object} newParams The set of parameters which will be composited with inherited params.
	 * @param {Object} $current Internal definition of object representing the current state.
	 * @param {Object} $to Internal definition of object representing state to transition to.
	 */
	function inheritParams(currentParams, newParams, $current, $to) {
	  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];
	
	  for (var i in parents) {
	    if (!parents[i] || !parents[i].params) continue;
	    parentParams = objectKeys(parents[i].params);
	    if (!parentParams.length) continue;
	
	    for (var j in parentParams) {
	      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
	      inheritList.push(parentParams[j]);
	      inherited[parentParams[j]] = currentParams[parentParams[j]];
	    }
	  }
	  return extend({}, inherited, newParams);
	}
	
	/**
	 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
	 *
	 * @param {Object} a The first object.
	 * @param {Object} b The second object.
	 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
	 *                     it defaults to the list of keys in `a`.
	 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
	 */
	function equalForKeys(a, b, keys) {
	  if (!keys) {
	    keys = [];
	    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
	  }
	
	  for (var i=0; i<keys.length; i++) {
	    var k = keys[i];
	    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
	  }
	  return true;
	}
	
	/**
	 * Returns the subset of an object, based on a list of keys.
	 *
	 * @param {Array} keys
	 * @param {Object} values
	 * @return {Boolean} Returns a subset of `values`.
	 */
	function filterByKeys(keys, values) {
	  var filtered = {};
	
	  forEach(keys, function (name) {
	    filtered[name] = values[name];
	  });
	  return filtered;
	}
	
	// like _.indexBy
	// when you know that your index values will be unique, or you want last-one-in to win
	function indexBy(array, propName) {
	  var result = {};
	  forEach(array, function(item) {
	    result[item[propName]] = item;
	  });
	  return result;
	}
	
	// extracted from underscore.js
	// Return a copy of the object only containing the whitelisted properties.
	function pick(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  forEach(keys, function(key) {
	    if (key in obj) copy[key] = obj[key];
	  });
	  return copy;
	}
	
	// extracted from underscore.js
	// Return a copy of the object omitting the blacklisted properties.
	function omit(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  for (var key in obj) {
	    if (indexOf(keys, key) == -1) copy[key] = obj[key];
	  }
	  return copy;
	}
	
	function pluck(collection, key) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = isFunction(key) ? key(val) : val[key];
	  });
	  return result;
	}
	
	function filter(collection, callback) {
	  var array = isArray(collection);
	  var result = array ? [] : {};
	  forEach(collection, function(val, i) {
	    if (callback(val, i)) {
	      result[array ? result.length : i] = val;
	    }
	  });
	  return result;
	}
	
	function map(collection, callback) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = callback(val, i);
	  });
	  return result;
	}
	
	/**
	 * @ngdoc overview
	 * @name ui.router.util
	 *
	 * @description
	 * # ui.router.util sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 *
	 */
	angular.module('ui.router.util', ['ng']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.router
	 * 
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.router sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 */
	angular.module('ui.router.router', ['ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.state
	 * 
	 * @requires ui.router.router
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.state sub-module
	 *
	 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 * 
	 */
	angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router
	 *
	 * @requires ui.router.state
	 *
	 * @description
	 * # ui.router
	 * 
	 * ## The main module for ui.router 
	 * There are several sub-modules included with the ui.router module, however only this module is needed
	 * as a dependency within your angular app. The other modules are for organization purposes. 
	 *
	 * The modules are:
	 * * ui.router - the main "umbrella" module
	 * * ui.router.router - 
	 * 
	 * *You'll need to include **only** this module as the dependency within your angular app.*
	 * 
	 * <pre>
	 * <!doctype html>
	 * <html ng-app="myApp">
	 * <head>
	 *   <script src="js/angular.js"></script>
	 *   <!-- Include the ui-router script -->
	 *   <script src="js/angular-ui-router.min.js"></script>
	 *   <script>
	 *     // ...and add 'ui.router' as a dependency
	 *     var myApp = angular.module('myApp', ['ui.router']);
	 *   </script>
	 * </head>
	 * <body>
	 * </body>
	 * </html>
	 * </pre>
	 */
	angular.module('ui.router', ['ui.router.state']);
	
	angular.module('ui.router.compat', ['ui.router']);
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$resolve
	 *
	 * @requires $q
	 * @requires $injector
	 *
	 * @description
	 * Manages resolution of (acyclic) graphs of promises.
	 */
	$Resolve.$inject = ['$q', '$injector'];
	function $Resolve(  $q,    $injector) {
	  
	  var VISIT_IN_PROGRESS = 1,
	      VISIT_DONE = 2,
	      NOTHING = {},
	      NO_DEPENDENCIES = [],
	      NO_LOCALS = NOTHING,
	      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
	  
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#study
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Studies a set of invocables that are likely to be used multiple times.
	   * <pre>
	   * $resolve.study(invocables)(locals, parent, self)
	   * </pre>
	   * is equivalent to
	   * <pre>
	   * $resolve.resolve(invocables, locals, parent, self)
	   * </pre>
	   * but the former is more efficient (in fact `resolve` just calls `study` 
	   * internally).
	   *
	   * @param {object} invocables Invocable objects
	   * @return {function} a function to pass in locals, parent and self
	   */
	  this.study = function (invocables) {
	    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
	    var invocableKeys = objectKeys(invocables || {});
	    
	    // Perform a topological sort of invocables to build an ordered plan
	    var plan = [], cycle = [], visited = {};
	    function visit(value, key) {
	      if (visited[key] === VISIT_DONE) return;
	      
	      cycle.push(key);
	      if (visited[key] === VISIT_IN_PROGRESS) {
	        cycle.splice(0, indexOf(cycle, key));
	        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
	      }
	      visited[key] = VISIT_IN_PROGRESS;
	      
	      if (isString(value)) {
	        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
	      } else {
	        var params = $injector.annotate(value);
	        forEach(params, function (param) {
	          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
	        });
	        plan.push(key, value, params);
	      }
	      
	      cycle.pop();
	      visited[key] = VISIT_DONE;
	    }
	    forEach(invocables, visit);
	    invocables = cycle = visited = null; // plan is all that's required
	    
	    function isResolve(value) {
	      return isObject(value) && value.then && value.$$promises;
	    }
	    
	    return function (locals, parent, self) {
	      if (isResolve(locals) && self === undefined) {
	        self = parent; parent = locals; locals = null;
	      }
	      if (!locals) locals = NO_LOCALS;
	      else if (!isObject(locals)) {
	        throw new Error("'locals' must be an object");
	      }       
	      if (!parent) parent = NO_PARENT;
	      else if (!isResolve(parent)) {
	        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
	      }
	      
	      // To complete the overall resolution, we have to wait for the parent
	      // promise and for the promise for each invokable in our plan.
	      var resolution = $q.defer(),
	          result = resolution.promise,
	          promises = result.$$promises = {},
	          values = extend({}, locals),
	          wait = 1 + plan.length/3,
	          merged = false;
	          
	      function done() {
	        // Merge parent values we haven't got yet and publish our own $$values
	        if (!--wait) {
	          if (!merged) merge(values, parent.$$values); 
	          result.$$values = values;
	          result.$$promises = result.$$promises || true; // keep for isResolve()
	          delete result.$$inheritedValues;
	          resolution.resolve(values);
	        }
	      }
	      
	      function fail(reason) {
	        result.$$failure = reason;
	        resolution.reject(reason);
	      }
	
	      // Short-circuit if parent has already failed
	      if (isDefined(parent.$$failure)) {
	        fail(parent.$$failure);
	        return result;
	      }
	      
	      if (parent.$$inheritedValues) {
	        merge(values, omit(parent.$$inheritedValues, invocableKeys));
	      }
	
	      // Merge parent values if the parent has already resolved, or merge
	      // parent promises and wait if the parent resolve is still in progress.
	      extend(promises, parent.$$promises);
	      if (parent.$$values) {
	        merged = merge(values, omit(parent.$$values, invocableKeys));
	        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
	        done();
	      } else {
	        if (parent.$$inheritedValues) {
	          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
	        }        
	        parent.then(done, fail);
	      }
	      
	      // Process each invocable in the plan, but ignore any where a local of the same name exists.
	      for (var i=0, ii=plan.length; i<ii; i+=3) {
	        if (locals.hasOwnProperty(plan[i])) done();
	        else invoke(plan[i], plan[i+1], plan[i+2]);
	      }
	      
	      function invoke(key, invocable, params) {
	        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
	        var invocation = $q.defer(), waitParams = 0;
	        function onfailure(reason) {
	          invocation.reject(reason);
	          fail(reason);
	        }
	        // Wait for any parameter that we have a promise for (either from parent or from this
	        // resolve; in that case study() will have made sure it's ordered before us in the plan).
	        forEach(params, function (dep) {
	          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
	            waitParams++;
	            promises[dep].then(function (result) {
	              values[dep] = result;
	              if (!(--waitParams)) proceed();
	            }, onfailure);
	          }
	        });
	        if (!waitParams) proceed();
	        function proceed() {
	          if (isDefined(result.$$failure)) return;
	          try {
	            invocation.resolve($injector.invoke(invocable, self, values));
	            invocation.promise.then(function (result) {
	              values[key] = result;
	              done();
	            }, onfailure);
	          } catch (e) {
	            onfailure(e);
	          }
	        }
	        // Publish promise synchronously; invocations further down in the plan may depend on it.
	        promises[key] = invocation.promise;
	      }
	      
	      return result;
	    };
	  };
	  
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#resolve
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Resolves a set of invocables. An invocable is a function to be invoked via 
	   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
	   * An invocable can either return a value directly,
	   * or a `$q` promise. If a promise is returned it will be resolved and the 
	   * resulting value will be used instead. Dependencies of invocables are resolved 
	   * (in this order of precedence)
	   *
	   * - from the specified `locals`
	   * - from another invocable that is part of this `$resolve` call
	   * - from an invocable that is inherited from a `parent` call to `$resolve` 
	   *   (or recursively
	   * - from any ancestor `$resolve` of that parent).
	   *
	   * The return value of `$resolve` is a promise for an object that contains 
	   * (in this order of precedence)
	   *
	   * - any `locals` (if specified)
	   * - the resolved return values of all injectables
	   * - any values inherited from a `parent` call to `$resolve` (if specified)
	   *
	   * The promise will resolve after the `parent` promise (if any) and all promises 
	   * returned by injectables have been resolved. If any invocable 
	   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
	   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
	   * same error. A rejection of a `parent` promise (if specified) will likewise be 
	   * propagated immediately. Once the `$resolve` promise has been rejected, no 
	   * further invocables will be called.
	   * 
	   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
	   * to throw an error. As a special case, an injectable can depend on a parameter 
	   * with the same name as the injectable, which will be fulfilled from the `parent` 
	   * injectable of the same name. This allows inherited values to be decorated. 
	   * Note that in this case any other injectable in the same `$resolve` with the same
	   * dependency would see the decorated value, not the inherited value.
	   *
	   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
	   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
	   * exception.
	   *
	   * Invocables are invoked eagerly as soon as all dependencies are available. 
	   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
	   *
	   * As a special case, an invocable can be a string, in which case it is taken to 
	   * be a service name to be passed to `$injector.get()`. This is supported primarily 
	   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
	   * routes.
	   *
	   * @param {object} invocables functions to invoke or 
	   * `$injector` services to fetch.
	   * @param {object} locals  values to make available to the injectables
	   * @param {object} parent  a promise returned by another call to `$resolve`.
	   * @param {object} self  the `this` for the invoked methods
	   * @return {object} Promise for an object that contains the resolved return value
	   * of all invocables, as well as any inherited and local values.
	   */
	  this.resolve = function (invocables, locals, parent, self) {
	    return this.study(invocables)(locals, parent, self);
	  };
	}
	
	angular.module('ui.router.util').service('$resolve', $Resolve);
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$templateFactory
	 *
	 * @requires $http
	 * @requires $templateCache
	 * @requires $injector
	 *
	 * @description
	 * Service. Manages loading of templates.
	 */
	$TemplateFactory.$inject = ['$http', '$templateCache', '$injector'];
	function $TemplateFactory(  $http,   $templateCache,   $injector) {
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromConfig
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a configuration object. 
	   *
	   * @param {object} config Configuration object for which to load a template. 
	   * The following properties are search in the specified order, and the first one 
	   * that is defined is used to create the template:
	   *
	   * @param {string|object} config.template html string template or function to 
	   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
	   * @param {string|object} config.templateUrl url to load or a function returning 
	   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
	   * @param {Function} config.templateProvider function to invoke via 
	   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
	   * @param {object} params  Parameters to pass to the template function.
	   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
	   * via a `templateProvider`. Defaults to `{ params: params }`.
	   *
	   * @return {string|object}  The template html as a string, or a promise for 
	   * that string,or `null` if no template is configured.
	   */
	  this.fromConfig = function (config, params, locals) {
	    return (
	      isDefined(config.template) ? this.fromString(config.template, params) :
	      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
	      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
	      null
	    );
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromString
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a string or a function returning a string.
	   *
	   * @param {string|object} template html template as a string or function that 
	   * returns an html template as a string.
	   * @param {object} params Parameters to pass to the template function.
	   *
	   * @return {string|object} The template html as a string, or a promise for that 
	   * string.
	   */
	  this.fromString = function (template, params) {
	    return isFunction(template) ? template(params) : template;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromUrl
	   * @methodOf ui.router.util.$templateFactory
	   * 
	   * @description
	   * Loads a template from the a URL via `$http` and `$templateCache`.
	   *
	   * @param {string|Function} url url of the template to load, or a function 
	   * that returns a url.
	   * @param {Object} params Parameters to pass to the url function.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromUrl = function (url, params) {
	    if (isFunction(url)) url = url(params);
	    if (url == null) return null;
	    else return $http
	        .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
	        .then(function(response) { return response.data; });
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromProvider
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template by invoking an injectable provider function.
	   *
	   * @param {Function} provider Function to invoke via `$injector.invoke`
	   * @param {Object} params Parameters for the template.
	   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
	   * `{ params: params }`.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromProvider = function (provider, params, locals) {
	    return $injector.invoke(provider, null, locals || { params: params });
	  };
	}
	
	angular.module('ui.router.util').service('$templateFactory', $TemplateFactory);
	
	var $$UMFP; // reference to $UrlMatcherFactoryProvider
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
	 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
	 *
	 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
	 * syntax, which optionally allows a regular expression for the parameter to be specified:
	 *
	 * * `':'` name - colon placeholder
	 * * `'*'` name - catch-all placeholder
	 * * `'{' name '}'` - curly placeholder
	 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
	 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters). For colon
	 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
	 * number of characters other than '/'. For catch-all placeholders the path parameter matches
	 * any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 * @param {string} pattern  The pattern to compile into a matcher.
	 * @param {Object} config  A configuration object hash:
	 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
	 *   an existing UrlMatcher
	 *
	 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
	 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
	 *
	 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
	 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
	 *   non-null) will start with this prefix.
	 *
	 * @property {string} source  The pattern that was passed into the constructor
	 *
	 * @property {string} sourcePath  The path portion of the source property
	 *
	 * @property {string} sourceSearch  The search portion of the source property
	 *
	 * @property {string} regex  The constructed regex that will be used to match against the url when
	 *   it is time to determine which url will match.
	 *
	 * @returns {Object}  New `UrlMatcher` object
	 */
	function UrlMatcher(pattern, config, parentMatcher) {
	  config = extend({ params: {} }, isObject(config) ? config : {});
	
	  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	  //   '*' name
	  //   ':' name
	  //   '{' name '}'
	  //   '{' name ':' regexp '}'
	  // The regular expression is somewhat complicated due to the need to allow curly braces
	  // inside the regular expression. The placeholder regexp breaks down as follows:
	  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	  //    [^{}\\]+                       - anything other than curly braces or backslash
	  //    \\.                            - a backslash escape
	  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      compiled = '^', last = 0, m,
	      segments = this.segments = [],
	      parentParams = parentMatcher ? parentMatcher.params : {},
	      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
	      paramNames = [];
	
	  function addParameter(id, type, config, location) {
	    paramNames.push(id);
	    if (parentParams[id]) return parentParams[id];
	    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	    params[id] = new $$UMFP.Param(id, type, config, location);
	    return params[id];
	  }
	
	  function quoteRegExp(string, pattern, squash, optional) {
	    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
	    if (!pattern) return result;
	    switch(squash) {
	      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
	      case true:
	        result = result.replace(/\/$/, '');
	        surroundPattern = ['(?:\/(', ')|\/)?'];
	      break;
	      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
	    }
	    return result + surroundPattern[0] + pattern + surroundPattern[1];
	  }
	
	  this.source = pattern;
	
	  // Split into static segments separated by path parameter placeholders.
	  // The number of segments is always 1 more than the number of parameters.
	  function matchDetails(m, isSearch) {
	    var id, regexp, segment, type, cfg, arrayMode;
	    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
	    cfg         = config.params[id];
	    segment     = pattern.substring(last, m.index);
	    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);
	
	    if (regexp) {
	      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
	    }
	
	    return {
	      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
	    };
	  }
	
	  var p, param, segment;
	  while ((m = placeholder.exec(pattern))) {
	    p = matchDetails(m, false);
	    if (p.segment.indexOf('?') >= 0) break; // we're into the search part
	
	    param = addParameter(p.id, p.type, p.cfg, "path");
	    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
	    segments.push(p.segment);
	    last = placeholder.lastIndex;
	  }
	  segment = pattern.substring(last);
	
	  // Find any search parameter names and remove them from the last segment
	  var i = segment.indexOf('?');
	
	  if (i >= 0) {
	    var search = this.sourceSearch = segment.substring(i);
	    segment = segment.substring(0, i);
	    this.sourcePath = pattern.substring(0, last + i);
	
	    if (search.length > 0) {
	      last = 0;
	      while ((m = searchPlaceholder.exec(search))) {
	        p = matchDetails(m, true);
	        param = addParameter(p.id, p.type, p.cfg, "search");
	        last = placeholder.lastIndex;
	        // check if ?&
	      }
	    }
	  } else {
	    this.sourcePath = pattern;
	    this.sourceSearch = '';
	  }
	
	  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
	  segments.push(segment);
	
	  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
	  this.prefix = segments[0];
	  this.$$paramNames = paramNames;
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#concat
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns a new matcher for a pattern constructed by appending the path part and adding the
	 * search parameters of the specified pattern to this pattern. The current pattern is not
	 * modified. This can be understood as creating a pattern for URLs that are relative to (or
	 * suffixes of) the current pattern.
	 *
	 * @example
	 * The following two matchers are equivalent:
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').concat('/details?date');
	 * new UrlMatcher('/user/{id}/details?q&date');
	 * </pre>
	 *
	 * @param {string} pattern  The pattern to append.
	 * @param {Object} config  An object hash of the configuration for the matcher.
	 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
	 */
	UrlMatcher.prototype.concat = function (pattern, config) {
	  // Because order of search parameters is irrelevant, we can add our own search
	  // parameters to the end of the new pattern. Parse the new pattern by itself
	  // and then join the bits together, but it's much easier to do this on a string level.
	  var defaultConfig = {
	    caseInsensitive: $$UMFP.caseInsensitive(),
	    strict: $$UMFP.strictMode(),
	    squash: $$UMFP.defaultSquashPolicy()
	  };
	  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
	};
	
	UrlMatcher.prototype.toString = function () {
	  return this.source;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#exec
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Tests the specified path against this matcher, and returns an object containing the captured
	 * parameter values, or null if the path does not match. The returned object contains the values
	 * of any search parameters that are mentioned in the pattern, but their value may be null if
	 * they are not present in `searchParams`. This means that search parameters are always treated
	 * as optional.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	 *   x: '1', q: 'hello'
	 * });
	 * // returns { id: 'bob', q: 'hello', r: null }
	 * </pre>
	 *
	 * @param {string} path  The URL path to match, e.g. `$location.path()`.
	 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
	 * @returns {Object}  The captured parameter values.
	 */
	UrlMatcher.prototype.exec = function (path, searchParams) {
	  var m = this.regexp.exec(path);
	  if (!m) return null;
	  searchParams = searchParams || {};
	
	  var paramNames = this.parameters(), nTotal = paramNames.length,
	    nPath = this.segments.length - 1,
	    values = {}, i, j, cfg, paramName;
	
	  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");
	
	  function decodePathArray(string) {
	    function reverseString(str) { return str.split("").reverse().join(""); }
	    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }
	
	    var split = reverseString(string).split(/-(?!\\)/);
	    var allReversed = map(split, reverseString);
	    return map(allReversed, unquoteDashes).reverse();
	  }
	
	  var param, paramVal;
	  for (i = 0; i < nPath; i++) {
	    paramName = paramNames[i];
	    param = this.params[paramName];
	    paramVal = m[i+1];
	    // if the param value matches a pre-replace pair, replace the value before decoding.
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	  for (/**/; i < nTotal; i++) {
	    paramName = paramNames[i];
	    values[paramName] = this.params[paramName].value(searchParams[paramName]);
	    param = this.params[paramName];
	    paramVal = searchParams[paramName];
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	
	  return values;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#parameters
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns the names of all path and search parameters of this pattern in an unspecified order.
	 *
	 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
	 *    pattern has no parameters, an empty array is returned.
	 */
	UrlMatcher.prototype.parameters = function (param) {
	  if (!isDefined(param)) return this.$$paramNames;
	  return this.params[param] || null;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#validates
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Checks an object hash of parameters to validate their correctness according to the parameter
	 * types of this `UrlMatcher`.
	 *
	 * @param {Object} params The object hash of parameters to validate.
	 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
	 */
	UrlMatcher.prototype.validates = function (params) {
	  return this.params.$$validates(params);
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#format
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Creates a URL that matches this pattern by substituting the specified values
	 * for the path and search parameters. Null values for path parameters are
	 * treated as empty strings.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	 * // returns '/user/bob?q=yes'
	 * </pre>
	 *
	 * @param {Object} values  the values to substitute for the parameters in this pattern.
	 * @returns {string}  the formatted URL (path and optionally search part).
	 */
	UrlMatcher.prototype.format = function (values) {
	  values = values || {};
	  var segments = this.segments, params = this.parameters(), paramset = this.params;
	  if (!this.validates(values)) return null;
	
	  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];
	
	  function encodeDashes(str) { // Replace dashes with encoded "\-"
	    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
	  }
	
	  for (i = 0; i < nTotal; i++) {
	    var isPathParam = i < nPath;
	    var name = params[i], param = paramset[name], value = param.value(values[name]);
	    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
	    var squash = isDefaultValue ? param.squash : false;
	    var encoded = param.type.encode(value);
	
	    if (isPathParam) {
	      var nextSegment = segments[i + 1];
	      var isFinalPathParam = i + 1 === nPath;
	
	      if (squash === false) {
	        if (encoded != null) {
	          if (isArray(encoded)) {
	            result += map(encoded, encodeDashes).join("-");
	          } else {
	            result += encodeURIComponent(encoded);
	          }
	        }
	        result += nextSegment;
	      } else if (squash === true) {
	        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
	        result += nextSegment.match(capture)[1];
	      } else if (isString(squash)) {
	        result += squash + nextSegment;
	      }
	
	      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
	    } else {
	      if (encoded == null || (isDefaultValue && squash !== false)) continue;
	      if (!isArray(encoded)) encoded = [ encoded ];
	      if (encoded.length === 0) continue;
	      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
	      result += (search ? '&' : '?') + (name + '=' + encoded);
	      search = true;
	    }
	  }
	
	  return result;
	};
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:Type
	 *
	 * @description
	 * Implements an interface to define custom parameter types that can be decoded from and encoded to
	 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
	 * objects when matching or formatting URLs, or comparing or validating parameter values.
	 *
	 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
	 * information on registering custom types.
	 *
	 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
	 *        properties will override the default methods and/or pattern in `Type`'s public interface.
	 * @example
	 * <pre>
	 * {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 * </pre>
	 *
	 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
	 *           coming from a substring of a URL.
	 *
	 * @returns {Object}  Returns a new `Type` object.
	 */
	function Type(config) {
	  extend(this, config);
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#is
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Detects whether a value is of a particular type. Accepts a native (decoded) value
	 * and determines whether it matches the current `Type` object.
	 *
	 * @param {*} val  The value to check.
	 * @param {string} key  Optional. If the type check is happening in the context of a specific
	 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
	 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
	 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
	 */
	Type.prototype.is = function(val, key) {
	  return true;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#encode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
	 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
	 * only needs to be a representation of `val` that has been coerced to a string.
	 *
	 * @param {*} val  The value to encode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
	 */
	Type.prototype.encode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#decode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Converts a parameter value (from URL string or transition param) to a custom/native value.
	 *
	 * @param {string} val  The URL parameter value to decode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {*}  Returns a custom representation of the URL parameter value.
	 */
	Type.prototype.decode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#equals
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Determines whether two decoded values are equivalent.
	 *
	 * @param {*} a  A value to compare against.
	 * @param {*} b  A value to compare against.
	 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
	 */
	Type.prototype.equals = function(a, b) {
	  return a == b;
	};
	
	Type.prototype.$subPattern = function() {
	  var sub = this.pattern.toString();
	  return sub.substr(1, sub.length - 2);
	};
	
	Type.prototype.pattern = /.*/;
	
	Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };
	
	/** Given an encoded string, or a decoded object, returns a decoded object */
	Type.prototype.$normalize = function(val) {
	  return this.is(val) ? val : this.decode(val);
	};
	
	/*
	 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
	 * e.g.:
	 * - urlmatcher pattern "/path?{queryParam[]:int}"
	 * - url: "/path?queryParam=1&queryParam=2
	 * - $stateParams.queryParam will be [1, 2]
	 * if `mode` is "auto", then
	 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	 */
	Type.prototype.$asArray = function(mode, isSearch) {
	  if (!mode) return this;
	  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");
	
	  function ArrayType(type, mode) {
	    function bindTo(type, callbackName) {
	      return function() {
	        return type[callbackName].apply(type, arguments);
	      };
	    }
	
	    // Wrap non-array value as array
	    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	      switch(val.length) {
	        case 0: return undefined;
	        case 1: return mode === "auto" ? val[0] : val;
	        default: return val;
	      }
	    }
	    function falsey(val) { return !val; }
	
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	      return function handleArray(val) {
	        if (isArray(val) && val.length === 0) return val;
	        val = arrayWrap(val);
	        var result = map(val, callback);
	        if (allTruthyMode === true)
	          return filter(result, falsey).length === 0;
	        return arrayUnwrap(result);
	      };
	    }
	
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	      return function handleArray(val1, val2) {
	        var left = arrayWrap(val1), right = arrayWrap(val2);
	        if (left.length !== right.length) return false;
	        for (var i = 0; i < left.length; i++) {
	          if (!callback(left[i], right[i])) return false;
	        }
	        return true;
	      };
	    }
	
	    this.encode = arrayHandler(bindTo(type, 'encode'));
	    this.decode = arrayHandler(bindTo(type, 'decode'));
	    this.is     = arrayHandler(bindTo(type, 'is'), true);
	    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
	    this.pattern = type.pattern;
	    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
	    this.name = type.name;
	    this.$arrayMode = mode;
	  }
	
	  return new ArrayType(this, mode);
	};
	
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$urlMatcherFactory
	 *
	 * @description
	 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
	 * is also available to providers under the name `$urlMatcherFactoryProvider`.
	 */
	function $UrlMatcherFactory() {
	  $$UMFP = this;
	
	  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;
	
	  // Use tildes to pre-encode slashes.
	  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
	  // and bidirectional encoding/decoding fails.
	  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
	  function valToString(val) { return val != null ? val.toString().replace(/~/g, "~~").replace(/\//g, "~2F") : val; }
	  function valFromString(val) { return val != null ? val.toString().replace(/~2F/g, "/").replace(/~~/g, "~") : val; }
	
	  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
	    "string": {
	      encode: valToString,
	      decode: valFromString,
	      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
	      // In 0.2.x, string params are optional by default for backwards compat
	      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
	      pattern: /[^/]*/
	    },
	    "int": {
	      encode: valToString,
	      decode: function(val) { return parseInt(val, 10); },
	      is: function(val) { return isDefined(val) && this.decode(val.toString()) === val; },
	      pattern: /\d+/
	    },
	    "bool": {
	      encode: function(val) { return val ? 1 : 0; },
	      decode: function(val) { return parseInt(val, 10) !== 0; },
	      is: function(val) { return val === true || val === false; },
	      pattern: /0|1/
	    },
	    "date": {
	      encode: function (val) {
	        if (!this.is(val))
	          return undefined;
	        return [ val.getFullYear(),
	          ('0' + (val.getMonth() + 1)).slice(-2),
	          ('0' + val.getDate()).slice(-2)
	        ].join("-");
	      },
	      decode: function (val) {
	        if (this.is(val)) return val;
	        var match = this.capture.exec(val);
	        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	      },
	      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
	      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
	      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
	    },
	    "json": {
	      encode: angular.toJson,
	      decode: angular.fromJson,
	      is: angular.isObject,
	      equals: angular.equals,
	      pattern: /[^/]*/
	    },
	    "any": { // does not encode/decode
	      encode: angular.identity,
	      decode: angular.identity,
	      equals: angular.equals,
	      pattern: /.*/
	    }
	  };
	
	  function getDefaultConfig() {
	    return {
	      strict: isStrictMode,
	      caseInsensitive: isCaseInsensitive
	    };
	  }
	
	  function isInjectable(value) {
	    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
	  }
	
	  /**
	   * [Internal] Get the default value of a parameter, which may be an injectable function.
	   */
	  $UrlMatcherFactory.$$getDefaultValue = function(config) {
	    if (!isInjectable(config.value)) return config.value;
	    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	    return injector.invoke(config.value);
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URL matching should be case sensitive (the default behavior), or not.
	   *
	   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
	   * @returns {boolean} the current value of caseInsensitive
	   */
	  this.caseInsensitive = function(value) {
	    if (isDefined(value))
	      isCaseInsensitive = value;
	    return isCaseInsensitive;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#strictMode
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URLs should match trailing slashes, or not (the default behavior).
	   *
	   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
	   * @returns {boolean} the current value of strictMode
	   */
	  this.strictMode = function(value) {
	    if (isDefined(value))
	      isStrictMode = value;
	    return isStrictMode;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Sets the default behavior when generating or matching URLs with default parameter values.
	   *
	   * @param {string} value A string that defines the default parameter URL squashing behavior.
	   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
	   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	   *             the parameter value from the URL and replace it with this string.
	   */
	  this.defaultSquashPolicy = function(value) {
	    if (!isDefined(value)) return defaultSquashPolicy;
	    if (value !== true && value !== false && !isString(value))
	      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	    defaultSquashPolicy = value;
	    return value;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#compile
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
	   *
	   * @param {string} pattern  The URL pattern.
	   * @param {Object} config  The config object hash.
	   * @returns {UrlMatcher}  The UrlMatcher.
	   */
	  this.compile = function (pattern, config) {
	    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#isMatcher
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
	   *
	   * @param {Object} object  The object to perform the type check against.
	   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
	   *          implementing all the same methods.
	   */
	  this.isMatcher = function (o) {
	    if (!isObject(o)) return false;
	    var result = true;
	
	    forEach(UrlMatcher.prototype, function(val, name) {
	      if (isFunction(val)) {
	        result = result && (isDefined(o[name]) && isFunction(o[name]));
	      }
	    });
	    return result;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#type
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
	   * generate URLs with typed parameters.
	   *
	   * @param {string} name  The type name.
	   * @param {Object|Function} definition   The type definition. See
	   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
	   *        runtime starts.  The result of this function is merged into the existing `definition`.
	   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   *
	   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
	   *
	   * @example
	   * This is a simple example of a custom type that encodes and decodes items from an
	   * array, using the array index as the URL-encoded value:
	   *
	   * <pre>
	   * var list = ['John', 'Paul', 'George', 'Ringo'];
	   *
	   * $urlMatcherFactoryProvider.type('listItem', {
	   *   encode: function(item) {
	   *     // Represent the list item in the URL using its corresponding index
	   *     return list.indexOf(item);
	   *   },
	   *   decode: function(item) {
	   *     // Look up the list item by index
	   *     return list[parseInt(item, 10)];
	   *   },
	   *   is: function(item) {
	   *     // Ensure the item is valid by checking to see that it appears
	   *     // in the list
	   *     return list.indexOf(item) > -1;
	   *   }
	   * });
	   *
	   * $stateProvider.state('list', {
	   *   url: "/list/{item:listItem}",
	   *   controller: function($scope, $stateParams) {
	   *     console.log($stateParams.item);
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * // Changes URL to '/list/3', logs "Ringo" to the console
	   * $state.go('list', { item: "Ringo" });
	   * </pre>
	   *
	   * This is a more complex example of a type that relies on dependency injection to
	   * interact with services, and uses the parameter name from the URL to infer how to
	   * handle encoding and decoding parameter values:
	   *
	   * <pre>
	   * // Defines a custom type that gets a value from a service,
	   * // where each service gets different types of values from
	   * // a backend API:
	   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
	   *
	   *   // Matches up services to URL parameter names
	   *   var services = {
	   *     user: Users,
	   *     post: Posts
	   *   };
	   *
	   *   return {
	   *     encode: function(object) {
	   *       // Represent the object in the URL using its unique ID
	   *       return object.id;
	   *     },
	   *     decode: function(value, key) {
	   *       // Look up the object by ID, using the parameter
	   *       // name (key) to call the correct service
	   *       return services[key].findById(value);
	   *     },
	   *     is: function(object, key) {
	   *       // Check that object is a valid dbObject
	   *       return angular.isObject(object) && object.id && services[key];
	   *     }
	   *     equals: function(a, b) {
	   *       // Check the equality of decoded objects by comparing
	   *       // their unique IDs
	   *       return a.id === b.id;
	   *     }
	   *   };
	   * });
	   *
	   * // In a config() block, you can then attach URLs with
	   * // type-annotated parameters:
	   * $stateProvider.state('users', {
	   *   url: "/users",
	   *   // ...
	   * }).state('users.item', {
	   *   url: "/{user:dbObject}",
	   *   controller: function($scope, $stateParams) {
	   *     // $stateParams.user will now be an object returned from
	   *     // the Users service
	   *   },
	   *   // ...
	   * });
	   * </pre>
	   */
	  this.type = function (name, definition, definitionFn) {
	    if (!isDefined(definition)) return $types[name];
	    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
	
	    $types[name] = new Type(extend({ name: name }, definition));
	    if (definitionFn) {
	      typeQueue.push({ name: name, def: definitionFn });
	      if (!enqueue) flushTypeQueue();
	    }
	    return this;
	  };
	
	  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
	  function flushTypeQueue() {
	    while(typeQueue.length) {
	      var type = typeQueue.shift();
	      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
	      angular.extend($types[type.name], injector.invoke(type.def));
	    }
	  }
	
	  // Register default types. Store them in the prototype of $types.
	  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
	  $types = inherit($types, {});
	
	  /* No need to document $get, since it returns this */
	  this.$get = ['$injector', function ($injector) {
	    injector = $injector;
	    enqueue = false;
	    flushTypeQueue();
	
	    forEach(defaultTypes, function(type, name) {
	      if (!$types[name]) $types[name] = new Type(type);
	    });
	    return this;
	  }];
	
	  this.Param = function Param(id, type, config, location) {
	    var self = this;
	    config = unwrapShorthand(config);
	    type = getType(config, type, location);
	    var arrayMode = getArrayMode();
	    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
	    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
	      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
	    var isOptional = config.value !== undefined;
	    var squash = getSquashPolicy(config, isOptional);
	    var replace = getReplace(config, arrayMode, isOptional, squash);
	
	    function unwrapShorthand(config) {
	      var keys = isObject(config) ? objectKeys(config) : [];
	      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
	                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
	      if (isShorthand) config = { value: config };
	      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
	      return config;
	    }
	
	    function getType(config, urlType, location) {
	      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
	      if (urlType) return urlType;
	      if (!config.type) return (location === "config" ? $types.any : $types.string);
	
	      if (angular.isString(config.type))
	        return $types[config.type];
	      if (config.type instanceof Type)
	        return config.type;
	      return new Type(config.type);
	    }
	
	    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	    function getArrayMode() {
	      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
	      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	      return extend(arrayDefaults, arrayParamNomenclature, config).array;
	    }
	
	    /**
	     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
	     */
	    function getSquashPolicy(config, isOptional) {
	      var squash = config.squash;
	      if (!isOptional || squash === false) return false;
	      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
	      if (squash === true || isString(squash)) return squash;
	      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	    }
	
	    function getReplace(config, arrayMode, isOptional, squash) {
	      var replace, configuredKeys, defaultPolicy = [
	        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
	        { from: null, to: (isOptional || arrayMode ? undefined : "") }
	      ];
	      replace = isArray(config.replace) ? config.replace : [];
	      if (isString(squash))
	        replace.push({ from: squash, to: undefined });
	      configuredKeys = map(replace, function(item) { return item.from; } );
	      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
	    }
	
	    /**
	     * [Internal] Get the default value of a parameter, which may be an injectable function.
	     */
	    function $$getDefaultValue() {
	      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	      var defaultValue = injector.invoke(config.$$fn);
	      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
	        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
	      return defaultValue;
	    }
	
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    function $value(value) {
	      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
	      function $replace(value) {
	        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
	        return replacement.length ? replacement[0] : value;
	      }
	      value = $replace(value);
	      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
	    }
	
	    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }
	
	    extend(this, {
	      id: id,
	      type: type,
	      location: location,
	      array: arrayMode,
	      squash: squash,
	      replace: replace,
	      isOptional: isOptional,
	      value: $value,
	      dynamic: undefined,
	      config: config,
	      toString: toString
	    });
	  };
	
	  function ParamSet(params) {
	    extend(this, params || {});
	  }
	
	  ParamSet.prototype = {
	    $$new: function() {
	      return inherit(this, extend(new ParamSet(), { $$parent: this}));
	    },
	    $$keys: function () {
	      var keys = [], chain = [], parent = this,
	        ignore = objectKeys(ParamSet.prototype);
	      while (parent) { chain.push(parent); parent = parent.$$parent; }
	      chain.reverse();
	      forEach(chain, function(paramset) {
	        forEach(objectKeys(paramset), function(key) {
	            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
	        });
	      });
	      return keys;
	    },
	    $$values: function(paramValues) {
	      var values = {}, self = this;
	      forEach(self.$$keys(), function(key) {
	        values[key] = self[key].value(paramValues && paramValues[key]);
	      });
	      return values;
	    },
	    $$equals: function(paramValues1, paramValues2) {
	      var equal = true, self = this;
	      forEach(self.$$keys(), function(key) {
	        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
	        if (!self[key].type.equals(left, right)) equal = false;
	      });
	      return equal;
	    },
	    $$validates: function $$validate(paramValues) {
	      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
	      for (i = 0; i < keys.length; i++) {
	        param = this[keys[i]];
	        rawVal = paramValues[keys[i]];
	        if ((rawVal === undefined || rawVal === null) && param.isOptional)
	          break; // There was no parameter value, but the param is optional
	        normalized = param.type.$normalize(rawVal);
	        if (!param.type.is(normalized))
	          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
	        encoded = param.type.encode(normalized);
	        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
	          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
	      }
	      return true;
	    },
	    $$parent: undefined
	  };
	
	  this.ParamSet = ParamSet;
	}
	
	// Register as a provider so it's available to other providers
	angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
	angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);
	
	/**
	 * @ngdoc object
	 * @name ui.router.router.$urlRouterProvider
	 *
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 * @requires $locationProvider
	 *
	 * @description
	 * `$urlRouterProvider` has the responsibility of watching `$location`. 
	 * When `$location` changes it runs through a list of rules one by one until a 
	 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
	 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
	 *
	 * There are several methods on `$urlRouterProvider` that make it useful to use directly
	 * in your module config.
	 */
	$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
	function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
	  var rules = [], otherwise = null, interceptDeferred = false, listener;
	
	  // Returns a string that is a prefix of all strings matching the RegExp
	  function regExpPrefix(re) {
	    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
	    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
	  }
	
	  // Interpolates matched values into a String.replace()-style pattern
	  function interpolate(pattern, match) {
	    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
	      return match[what === '$' ? 0 : Number(what)];
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#rule
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines rules that are used by `$urlRouterProvider` to find matches for
	   * specific URLs.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // Here's an example of how you might allow case insensitive urls
	   *   $urlRouterProvider.rule(function ($injector, $location) {
	   *     var path = $location.path(),
	   *         normalized = path.toLowerCase();
	   *
	   *     if (path !== normalized) {
	   *       return normalized;
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {function} rule Handler function that takes `$injector` and `$location`
	   * services as arguments. You can use them to return a valid path as a string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.rule = function (rule) {
	    if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    rules.push(rule);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouterProvider#otherwise
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines a path that is used when an invalid route is requested.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // if the path doesn't match any of the urls you configured
	   *   // otherwise will take care of routing the user to the
	   *   // specified url
	   *   $urlRouterProvider.otherwise('/index');
	   *
	   *   // Example of using function rule as param
	   *   $urlRouterProvider.otherwise(function ($injector, $location) {
	   *     return '/a/valid/url';
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|function} rule The url path you want to redirect to or a function 
	   * rule that returns the url path. The function version is passed two params: 
	   * `$injector` and `$location` services, and must return a url string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.otherwise = function (rule) {
	    if (isString(rule)) {
	      var redirect = rule;
	      rule = function () { return redirect; };
	    }
	    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    otherwise = rule;
	    return this;
	  };
	
	
	  function handleIfMatch($injector, handler, match) {
	    if (!match) return false;
	    var result = $injector.invoke(handler, handler, { $match: match });
	    return isDefined(result) ? result : true;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#when
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Registers a handler for a given url matching. 
	   * 
	   * If the handler is a string, it is
	   * treated as a redirect, and is interpolated according to the syntax of match
	   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	   *
	   * If the handler is a function, it is injectable. It gets invoked if `$location`
	   * matches. You have the option of inject the match object as `$match`.
	   *
	   * The handler can return
	   *
	   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	   *   will continue trying to find another one that matches.
	   * - **string** which is treated as a redirect and passed to `$location.url()`
	   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	   *     if ($state.$current.navigable !== state ||
	   *         !equalForKeys($match, $stateParams) {
	   *      $state.transitionTo(state, $match, false);
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|object} what The incoming path that you want to redirect.
	   * @param {string|function} handler The path you want to redirect your user to.
	   */
	  this.when = function (what, handler) {
	    var redirect, handlerIsString = isString(handler);
	    if (isString(what)) what = $urlMatcherFactory.compile(what);
	
	    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
	      throw new Error("invalid 'handler' in when()");
	
	    var strategies = {
	      matcher: function (what, handler) {
	        if (handlerIsString) {
	          redirect = $urlMatcherFactory.compile(handler);
	          handler = ['$match', function ($match) { return redirect.format($match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
	        }, {
	          prefix: isString(what.prefix) ? what.prefix : ''
	        });
	      },
	      regex: function (what, handler) {
	        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");
	
	        if (handlerIsString) {
	          redirect = handler;
	          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path()));
	        }, {
	          prefix: regExpPrefix(what)
	        });
	      }
	    };
	
	    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };
	
	    for (var n in check) {
	      if (check[n]) return this.rule(strategies[n](what, handler));
	    }
	
	    throw new Error("invalid 'what' in when()");
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#deferIntercept
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Disables (or enables) deferring location change interception.
	   *
	   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
	   * defer a transition but maintain the current URL), call this method at configuration time.
	   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
	   * `$locationChangeSuccess` event handler.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *
	   *   // Prevent $urlRouter from automatically intercepting URL changes;
	   *   // this allows you to configure custom behavior in between
	   *   // location changes and route synchronization:
	   *   $urlRouterProvider.deferIntercept();
	   *
	   * }).run(function ($rootScope, $urlRouter, UserService) {
	   *
	   *   $rootScope.$on('$locationChangeSuccess', function(e) {
	   *     // UserService is an example service for managing user state
	   *     if (UserService.isLoggedIn()) return;
	   *
	   *     // Prevent $urlRouter's default handler from firing
	   *     e.preventDefault();
	   *
	   *     UserService.handleLogin().then(function() {
	   *       // Once the user has logged in, sync the current URL
	   *       // to the router:
	   *       $urlRouter.sync();
	   *     });
	   *   });
	   *
	   *   // Configures $urlRouter's listener *after* your custom listener
	   *   $urlRouter.listen();
	   * });
	   * </pre>
	   *
	   * @param {boolean} defer Indicates whether to defer location change interception. Passing
	            no parameter is equivalent to `true`.
	   */
	  this.deferIntercept = function (defer) {
	    if (defer === undefined) defer = true;
	    interceptDeferred = defer;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouter
	   *
	   * @requires $location
	   * @requires $rootScope
	   * @requires $injector
	   * @requires $browser
	   *
	   * @description
	   *
	   */
	  this.$get = $get;
	  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
	  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {
	
	    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;
	
	    function appendBasePath(url, isHtml5, absolute) {
	      if (baseHref === '/') return url;
	      if (isHtml5) return baseHref.slice(0, -1) + url;
	      if (absolute) return baseHref.slice(1) + url;
	      return url;
	    }
	
	    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
	    function update(evt) {
	      if (evt && evt.defaultPrevented) return;
	      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
	      lastPushedUrl = undefined;
	      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
	      //if (ignoreUpdate) return true;
	
	      function check(rule) {
	        var handled = rule($injector, $location);
	
	        if (!handled) return false;
	        if (isString(handled)) $location.replace().url(handled);
	        return true;
	      }
	      var n = rules.length, i;
	
	      for (i = 0; i < n; i++) {
	        if (check(rules[i])) return;
	      }
	      // always check otherwise last to allow dynamic updates to the set of rules
	      if (otherwise) check(otherwise);
	    }
	
	    function listen() {
	      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
	      return listener;
	    }
	
	    if (!interceptDeferred) listen();
	
	    return {
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#sync
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
	       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
	       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
	       * with the transition by calling `$urlRouter.sync()`.
	       *
	       * @example
	       * <pre>
	       * angular.module('app', ['ui.router'])
	       *   .run(function($rootScope, $urlRouter) {
	       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
	       *       // Halt state change from even starting
	       *       evt.preventDefault();
	       *       // Perform custom logic
	       *       var meetsRequirement = ...
	       *       // Continue with the update and state transition if logic allows
	       *       if (meetsRequirement) $urlRouter.sync();
	       *     });
	       * });
	       * </pre>
	       */
	      sync: function() {
	        update();
	      },
	
	      listen: function() {
	        return listen();
	      },
	
	      update: function(read) {
	        if (read) {
	          location = $location.url();
	          return;
	        }
	        if ($location.url() === location) return;
	
	        $location.url(location);
	        $location.replace();
	      },
	
	      push: function(urlMatcher, params, options) {
	         var url = urlMatcher.format(params || {});
	
	        // Handle the special hash param, if needed
	        if (url !== null && params && params['#']) {
	            url += '#' + params['#'];
	        }
	
	        $location.url(url);
	        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
	        if (options && options.replace) $location.replace();
	      },
	
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#href
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * A URL generation method that returns the compiled URL for a given
	       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
	       *
	       * @example
	       * <pre>
	       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
	       *   person: "bob"
	       * });
	       * // $bob == "/about/bob";
	       * </pre>
	       *
	       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
	       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	       *
	       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	       */
	      href: function(urlMatcher, params, options) {
	        if (!urlMatcher.validates(params)) return null;
	
	        var isHtml5 = $locationProvider.html5Mode();
	        if (angular.isObject(isHtml5)) {
	          isHtml5 = isHtml5.enabled;
	        }
	
	        isHtml5 = isHtml5 && $sniffer.history;
	        
	        var url = urlMatcher.format(params);
	        options = options || {};
	
	        if (!isHtml5 && url !== null) {
	          url = "#" + $locationProvider.hashPrefix() + url;
	        }
	
	        // Handle special hash param, if needed
	        if (url !== null && params && params['#']) {
	          url += '#' + params['#'];
	        }
	
	        url = appendBasePath(url, isHtml5, options.absolute);
	
	        if (!options.absolute || !url) {
	          return url;
	        }
	
	        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
	        port = (port === 80 || port === 443 ? '' : ':' + port);
	
	        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
	      }
	    };
	  }
	}
	
	angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$stateProvider
	 *
	 * @requires ui.router.router.$urlRouterProvider
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 *
	 * @description
	 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	 * on state.
	 *
	 * A state corresponds to a "place" in the application in terms of the overall UI and
	 * navigation. A state describes (via the controller / template / view properties) what
	 * the UI looks like and does at that place.
	 *
	 * States often have things in common, and the primary way of factoring out these
	 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	 * nested states.
	 *
	 * The `$stateProvider` provides interfaces to declare these states for your app.
	 */
	$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
	function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {
	
	  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';
	
	  // Builds state properties from definition passed to registerState()
	  var stateBuilder = {
	
	    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
	    // state.children = [];
	    // if (parent) parent.children.push(state);
	    parent: function(state) {
	      if (isDefined(state.parent) && state.parent) return findState(state.parent);
	      // regex matches any valid composite state name
	      // would match "contact.list" but not "contacts"
	      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
	      return compositeName ? findState(compositeName[1]) : root;
	    },
	
	    // inherit 'data' from parent and override by own values (if any)
	    data: function(state) {
	      if (state.parent && state.parent.data) {
	        state.data = state.self.data = inherit(state.parent.data, state.data);
	      }
	      return state.data;
	    },
	
	    // Build a URLMatcher if necessary, either via a relative or absolute URL
	    url: function(state) {
	      var url = state.url, config = { params: state.params || {} };
	
	      if (isString(url)) {
	        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
	        return (state.parent.navigable || root).url.concat(url, config);
	      }
	
	      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
	      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
	    },
	
	    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	    navigable: function(state) {
	      return state.url ? state : (state.parent ? state.parent.navigable : null);
	    },
	
	    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
	    ownParams: function(state) {
	      var params = state.url && state.url.params || new $$UMFP.ParamSet();
	      forEach(state.params || {}, function(config, id) {
	        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
	      });
	      return params;
	    },
	
	    // Derive parameters for this state and ensure they're a super-set of parent's parameters
	    params: function(state) {
	      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
	      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
	    },
	
	    // If there is no explicit multi-view configuration, make one up so we don't have
	    // to handle both cases in the view directive later. Note that having an explicit
	    // 'views' property will mean the default unnamed view properties are ignored. This
	    // is also a good time to resolve view names to absolute names, so everything is a
	    // straight lookup at link time.
	    views: function(state) {
	      var views = {};
	
	      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
	        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
	        views[name] = view;
	      });
	      return views;
	    },
	
	    // Keep a full path from the root down to this state as this is needed for state activation.
	    path: function(state) {
	      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
	    },
	
	    // Speed up $state.contains() as it's used a lot
	    includes: function(state) {
	      var includes = state.parent ? extend({}, state.parent.includes) : {};
	      includes[state.name] = true;
	      return includes;
	    },
	
	    $delegates: {}
	  };
	
	  function isRelative(stateName) {
	    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
	  }
	
	  function findState(stateOrName, base) {
	    if (!stateOrName) return undefined;
	
	    var isStr = isString(stateOrName),
	        name  = isStr ? stateOrName : stateOrName.name,
	        path  = isRelative(name);
	
	    if (path) {
	      if (!base) throw new Error("No reference point given for path '"  + name + "'");
	      base = findState(base);
	      
	      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;
	
	      for (; i < pathLength; i++) {
	        if (rel[i] === "" && i === 0) {
	          current = base;
	          continue;
	        }
	        if (rel[i] === "^") {
	          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
	          current = current.parent;
	          continue;
	        }
	        break;
	      }
	      rel = rel.slice(i).join(".");
	      name = current.name + (current.name && rel ? "." : "") + rel;
	    }
	    var state = states[name];
	
	    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	      return state;
	    }
	    return undefined;
	  }
	
	  function queueState(parentName, state) {
	    if (!queue[parentName]) {
	      queue[parentName] = [];
	    }
	    queue[parentName].push(state);
	  }
	
	  function flushQueuedChildren(parentName) {
	    var queued = queue[parentName] || [];
	    while(queued.length) {
	      registerState(queued.shift());
	    }
	  }
	
	  function registerState(state) {
	    // Wrap a new object around the state so we can store our private details easily.
	    state = inherit(state, {
	      self: state,
	      resolve: state.resolve || {},
	      toString: function() { return this.name; }
	    });
	
	    var name = state.name;
	    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
	    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");
	
	    // Get parent name
	    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
	        : (isString(state.parent)) ? state.parent
	        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
	        : '';
	
	    // If parent is not registered yet, add state to queue and register later
	    if (parentName && !states[parentName]) {
	      return queueState(parentName, state.self);
	    }
	
	    for (var key in stateBuilder) {
	      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
	    }
	    states[name] = state;
	
	    // Register the state in the global state list and with $urlRouter if necessary.
	    if (!state[abstractKey] && state.url) {
	      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
	        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
	          $state.transitionTo(state, $match, { inherit: true, location: false });
	        }
	      }]);
	    }
	
	    // Register any queued children
	    flushQueuedChildren(name);
	
	    return state;
	  }
	
	  // Checks text to see if it looks like a glob.
	  function isGlob (text) {
	    return text.indexOf('*') > -1;
	  }
	
	  // Returns true if glob matches current $state name.
	  function doesStateMatchGlob (glob) {
	    var globSegments = glob.split('.'),
	        segments = $state.$current.name.split('.');
	
	    //match single stars
	    for (var i = 0, l = globSegments.length; i < l; i++) {
	      if (globSegments[i] === '*') {
	        segments[i] = '*';
	      }
	    }
	
	    //match greedy starts
	    if (globSegments[0] === '**') {
	       segments = segments.slice(indexOf(segments, globSegments[1]));
	       segments.unshift('**');
	    }
	    //match greedy ends
	    if (globSegments[globSegments.length - 1] === '**') {
	       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
	       segments.push('**');
	    }
	
	    if (globSegments.length != segments.length) {
	      return false;
	    }
	
	    return segments.join('') === globSegments.join('');
	  }
	
	
	  // Implicit root state that is always active
	  root = registerState({
	    name: '',
	    url: '^',
	    views: null,
	    'abstract': true
	  });
	  root.navigable = null;
	
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#decorator
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Allows you to extend (carefully) or override (at your own peril) the 
	   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
	   * to add custom functionality to ui-router, for example inferring templateUrl 
	   * based on the state name.
	   *
	   * When passing only a name, it returns the current (original or decorated) builder
	   * function that matches `name`.
	   *
	   * The builder functions that can be decorated are listed below. Though not all
	   * necessarily have a good use case for decoration, that is up to you to decide.
	   *
	   * In addition, users can attach custom decorators, which will generate new 
	   * properties within the state's internal definition. There is currently no clear 
	   * use-case for this beyond accessing internal states (i.e. $state.$current), 
	   * however, expect this to become increasingly relevant as we introduce additional 
	   * meta-programming features.
	   *
	   * **Warning**: Decorators should not be interdependent because the order of 
	   * execution of the builder functions in non-deterministic. Builder functions 
	   * should only be dependent on the state definition object and super function.
	   *
	   *
	   * Existing builder functions and current return values:
	   *
	   * - **parent** `{object}` - returns the parent state object.
	   * - **data** `{object}` - returns state data, including any inherited data that is not
	   *   overridden by own values (if any).
	   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	   *   or `null`.
	   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
	   *   navigable).
	   * - **params** `{object}` - returns an array of state params that are ensured to 
	   *   be a super-set of parent's params.
	   * - **views** `{object}` - returns a views object where each key is an absolute view 
	   *   name (i.e. "viewName@stateName") and each value is the config object 
	   *   (template, controller) for the view. Even when you don't use the views object 
	   *   explicitly on a state config, one is still created for you internally.
	   *   So by decorating this builder function you have access to decorating template 
	   *   and controller properties.
	   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
	   *   not including any params defined by ancestor states.
	   * - **path** `{string}` - returns the full path from the root down to this state. 
	   *   Needed for state activation.
	   * - **includes** `{object}` - returns an object that includes every state that 
	   *   would pass a `$state.includes()` test.
	   *
	   * @example
	   * <pre>
	   * // Override the internal 'views' builder with a function that takes the state
	   * // definition, and a reference to the internal function being overridden:
	   * $stateProvider.decorator('views', function (state, parent) {
	   *   var result = {},
	   *       views = parent(state);
	   *
	   *   angular.forEach(views, function (config, name) {
	   *     var autoName = (state.name + '.' + name).replace('.', '/');
	   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	   *     result[name] = config;
	   *   });
	   *   return result;
	   * });
	   *
	   * $stateProvider.state('home', {
	   *   views: {
	   *     'contact.list': { controller: 'ListController' },
	   *     'contact.item': { controller: 'ItemController' }
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * $state.go('home');
	   * // Auto-populates list and item views with /partials/home/contact/list.html,
	   * // and /partials/home/contact/item.html, respectively.
	   * </pre>
	   *
	   * @param {string} name The name of the builder function to decorate. 
	   * @param {object} func A function that is responsible for decorating the original 
	   * builder function. The function receives two parameters:
	   *
	   *   - `{object}` - state - The state config object.
	   *   - `{object}` - super - The original builder function.
	   *
	   * @return {object} $stateProvider - $stateProvider instance
	   */
	  this.decorator = decorator;
	  function decorator(name, func) {
	    /*jshint validthis: true */
	    if (isString(name) && !isDefined(func)) {
	      return stateBuilder[name];
	    }
	    if (!isFunction(func) || !isString(name)) {
	      return this;
	    }
	    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
	      stateBuilder.$delegates[name] = stateBuilder[name];
	    }
	    stateBuilder[name] = func;
	    return this;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#state
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Registers a state configuration under a given state name. The stateConfig object
	   * has the following acceptable properties.
	   *
	   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
	   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
	   * @param {object} stateConfig State configuration object.
	   * @param {string|function=} stateConfig.template
	   * <a id='template'></a>
	   *   html template as a string or a function that returns
	   *   an html template as a string which should be used by the uiView directives. This property 
	   *   takes precedence over templateUrl.
	   *   
	   *   If `template` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
	   *     applying the current state
	   *
	   * <pre>template:
	   *   "<h1>inline template definition</h1>" +
	   *   "<div ui-view></div>"</pre>
	   * <pre>template: function(params) {
	   *       return "<h1>generated template</h1>"; }</pre>
	   * </div>
	   *
	   * @param {string|function=} stateConfig.templateUrl
	   * <a id='templateUrl'></a>
	   *
	   *   path or function that returns a path to an html
	   *   template that should be used by uiView.
	   *   
	   *   If `templateUrl` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
	   *     applying the current state
	   *
	   * <pre>templateUrl: "home.html"</pre>
	   * <pre>templateUrl: function(params) {
	   *     return myTemplates[params.pageId]; }</pre>
	   *
	   * @param {function=} stateConfig.templateProvider
	   * <a id='templateProvider'></a>
	   *    Provider function that returns HTML content string.
	   * <pre> templateProvider:
	   *       function(MyTemplateService, params) {
	   *         return MyTemplateService.getTemplate(params.pageId);
	   *       }</pre>
	   *
	   * @param {string|function=} stateConfig.controller
	   * <a id='controller'></a>
	   *
	   *  Controller fn that should be associated with newly
	   *   related scope or the name of a registered controller if passed as a string.
	   *   Optionally, the ControllerAs may be declared here.
	   * <pre>controller: "MyRegisteredController"</pre>
	   * <pre>controller:
	   *     "MyRegisteredController as fooCtrl"}</pre>
	   * <pre>controller: function($scope, MyService) {
	   *     $scope.data = MyService.getData(); }</pre>
	   *
	   * @param {function=} stateConfig.controllerProvider
	   * <a id='controllerProvider'></a>
	   *
	   * Injectable provider function that returns the actual controller or string.
	   * <pre>controllerProvider:
	   *   function(MyResolveData) {
	   *     if (MyResolveData.foo)
	   *       return "FooCtrl"
	   *     else if (MyResolveData.bar)
	   *       return "BarCtrl";
	   *     else return function($scope) {
	   *       $scope.baz = "Qux";
	   *     }
	   *   }</pre>
	   *
	   * @param {string=} stateConfig.controllerAs
	   * <a id='controllerAs'></a>
	   * 
	   * A controller alias name. If present the controller will be
	   *   published to scope under the controllerAs name.
	   * <pre>controllerAs: "myCtrl"</pre>
	   *
	   * @param {string|object=} stateConfig.parent
	   * <a id='parent'></a>
	   * Optionally specifies the parent state of this state.
	   *
	   * <pre>parent: 'parentState'</pre>
	   * <pre>parent: parentState // JS variable</pre>
	   *
	   * @param {object=} stateConfig.resolve
	   * <a id='resolve'></a>
	   *
	   * An optional map&lt;string, function&gt; of dependencies which
	   *   should be injected into the controller. If any of these dependencies are promises, 
	   *   the router will wait for them all to be resolved before the controller is instantiated.
	   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
	   *   and the values of the resolved promises are injected into any controllers that reference them.
	   *   If any  of the promises are rejected the $stateChangeError event is fired.
	   *
	   *   The map object is:
	   *   
	   *   - key - {string}: name of dependency to be injected into controller
	   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
	   *     it is injected and return value it treated as dependency. If result is a promise, it is 
	   *     resolved before its value is injected into controller.
	   *
	   * <pre>resolve: {
	   *     myResolve1:
	   *       function($http, $stateParams) {
	   *         return $http.get("/api/foos/"+stateParams.fooID);
	   *       }
	   *     }</pre>
	   *
	   * @param {string=} stateConfig.url
	   * <a id='url'></a>
	   *
	   *   A url fragment with optional parameters. When a state is navigated or
	   *   transitioned to, the `$stateParams` service will be populated with any 
	   *   parameters that were passed.
	   *
	   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
	   *   more details on acceptable patterns )
	   *
	   * examples:
	   * <pre>url: "/home"
	   * url: "/users/:userid"
	   * url: "/books/{bookid:[a-zA-Z_-]}"
	   * url: "/books/{categoryid:int}"
	   * url: "/books/{publishername:string}/{categoryid:int}"
	   * url: "/messages?before&after"
	   * url: "/messages?{before:date}&{after:date}"
	   * url: "/messages/:mailboxid?{before:date}&{after:date}"
	   * </pre>
	   *
	   * @param {object=} stateConfig.views
	   * <a id='views'></a>
	   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
	   * manually/explicitly.
	   *
	   * Examples:
	   *
	   * Targets three named `ui-view`s in the parent state's template
	   * <pre>views: {
	   *     header: {
	   *       controller: "headerCtrl",
	   *       templateUrl: "header.html"
	   *     }, body: {
	   *       controller: "bodyCtrl",
	   *       templateUrl: "body.html"
	   *     }, footer: {
	   *       controller: "footCtrl",
	   *       templateUrl: "footer.html"
	   *     }
	   *   }</pre>
	   *
	   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
	   * <pre>views: {
	   *     'header@top': {
	   *       controller: "msgHeaderCtrl",
	   *       templateUrl: "msgHeader.html"
	   *     }, 'body': {
	   *       controller: "messagesCtrl",
	   *       templateUrl: "messages.html"
	   *     }
	   *   }</pre>
	   *
	   * @param {boolean=} [stateConfig.abstract=false]
	   * <a id='abstract'></a>
	   * An abstract state will never be directly activated,
	   *   but can provide inherited properties to its common children states.
	   * <pre>abstract: true</pre>
	   *
	   * @param {function=} stateConfig.onEnter
	   * <a id='onEnter'></a>
	   *
	   * Callback function for when a state is entered. Good way
	   *   to trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onEnter: function(MyService, $stateParams) {
	   *     MyService.foo($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {function=} stateConfig.onExit
	   * <a id='onExit'></a>
	   *
	   * Callback function for when a state is exited. Good way to
	   *   trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onExit: function(MyService, $stateParams) {
	   *     MyService.cleanup($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {boolean=} [stateConfig.reloadOnSearch=true]
	   * <a id='reloadOnSearch'></a>
	   *
	   * If `false`, will not retrigger the same state
	   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
	   *   Useful for when you'd like to modify $location.search() without triggering a reload.
	   * <pre>reloadOnSearch: false</pre>
	   *
	   * @param {object=} stateConfig.data
	   * <a id='data'></a>
	   *
	   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
	   *   prototypally inherited.  In other words, adding a data property to a state adds it to
	   *   the entire subtree via prototypal inheritance.
	   *
	   * <pre>data: {
	   *     requiredRole: 'foo'
	   * } </pre>
	   *
	   * @param {object=} stateConfig.params
	   * <a id='params'></a>
	   *
	   * A map which optionally configures parameters declared in the `url`, or
	   *   defines additional non-url parameters.  For each parameter being
	   *   configured, add a configuration object keyed to the name of the parameter.
	   *
	   *   Each parameter configuration object may contain the following properties:
	   *
	   *   - ** value ** - {object|function=}: specifies the default value for this
	   *     parameter.  This implicitly sets this parameter as optional.
	   *
	   *     When UI-Router routes to a state and no value is
	   *     specified for this parameter in the URL or transition, the
	   *     default value will be used instead.  If `value` is a function,
	   *     it will be injected and invoked, and the return value used.
	   *
	   *     *Note*: `undefined` is treated as "no default value" while `null`
	   *     is treated as "the default value is `null`".
	   *
	   *     *Shorthand*: If you only need to configure the default value of the
	   *     parameter, you may use a shorthand syntax.   In the **`params`**
	   *     map, instead mapping the param name to a full parameter configuration
	   *     object, simply set map it to the default parameter value, e.g.:
	   *
	   * <pre>// define a parameter's default value
	   * params: {
	   *     param1: { value: "defaultValue" }
	   * }
	   * // shorthand default values
	   * params: {
	   *     param1: "defaultValue",
	   *     param2: "param2Default"
	   * }</pre>
	   *
	   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
	   *     treated as an array of values.  If you specified a Type, the value will be
	   *     treated as an array of the specified Type.  Note: query parameter values
	   *     default to a special `"auto"` mode.
	   *
	   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
	   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
	   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
	   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
	   *     value (e.g.: `{ foo: '1' }`).
	   *
	   * <pre>params: {
	   *     param1: { array: true }
	   * }</pre>
	   *
	   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
	   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
	   *     configured default squash policy.
	   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
	   *
	   *   There are three squash settings:
	   *
	   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
	   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
	   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
	   *       This can allow for cleaner looking URLs.
	   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
	   *
	   * <pre>params: {
	   *     param1: {
	   *       value: "defaultId",
	   *       squash: true
	   * } }
	   * // squash "defaultValue" to "~"
	   * params: {
	   *     param1: {
	   *       value: "defaultValue",
	   *       squash: "~"
	   * } }
	   * </pre>
	   *
	   *
	   * @example
	   * <pre>
	   * // Some state name examples
	   *
	   * // stateName can be a single top-level name (must be unique).
	   * $stateProvider.state("home", {});
	   *
	   * // Or it can be a nested state name. This state is a child of the
	   * // above "home" state.
	   * $stateProvider.state("home.newest", {});
	   *
	   * // Nest states as deeply as needed.
	   * $stateProvider.state("home.newest.abc.xyz.inception", {});
	   *
	   * // state() returns $stateProvider, so you can chain state declarations.
	   * $stateProvider
	   *   .state("home", {})
	   *   .state("about", {})
	   *   .state("contacts", {});
	   * </pre>
	   *
	   */
	  this.state = state;
	  function state(name, definition) {
	    /*jshint validthis: true */
	    if (isObject(name)) definition = name;
	    else definition.name = name;
	    registerState(definition);
	    return this;
	  }
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$state
	   *
	   * @requires $rootScope
	   * @requires $q
	   * @requires ui.router.state.$view
	   * @requires $injector
	   * @requires ui.router.util.$resolve
	   * @requires ui.router.state.$stateParams
	   * @requires ui.router.router.$urlRouter
	   *
	   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
	   * you'd like to test against the current active state.
	   * @property {object} current A reference to the state's config object. However 
	   * you passed it in. Useful for accessing custom data.
	   * @property {object} transition Currently pending transition. A promise that'll 
	   * resolve or reject.
	   *
	   * @description
	   * `$state` service is responsible for representing states as well as transitioning
	   * between them. It also provides interfaces to ask for current state or even states
	   * you're coming from.
	   */
	  this.$get = $get;
	  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
	  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {
	
	    var TransitionSuperseded = $q.reject(new Error('transition superseded'));
	    var TransitionPrevented = $q.reject(new Error('transition prevented'));
	    var TransitionAborted = $q.reject(new Error('transition aborted'));
	    var TransitionFailed = $q.reject(new Error('transition failed'));
	
	    // Handles the case where a state which is the target of a transition is not found, and the user
	    // can optionally retry or defer the transition
	    function handleRedirect(redirect, state, params, options) {
	      /**
	       * @ngdoc event
	       * @name ui.router.state.$state#$stateNotFound
	       * @eventOf ui.router.state.$state
	       * @eventType broadcast on root scope
	       * @description
	       * Fired when a requested state **cannot be found** using the provided state name during transition.
	       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
	       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
	       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
	       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
	       *
	       * @param {Object} event Event object.
	       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
	       * @param {State} fromState Current state object.
	       * @param {Object} fromParams Current state params.
	       *
	       * @example
	       *
	       * <pre>
	       * // somewhere, assume lazy.state has not been defined
	       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
	       *
	       * // somewhere else
	       * $scope.$on('$stateNotFound',
	       * function(event, unfoundState, fromState, fromParams){
	       *     console.log(unfoundState.to); // "lazy.state"
	       *     console.log(unfoundState.toParams); // {a:1, b:2}
	       *     console.log(unfoundState.options); // {inherit:false} + default options
	       * })
	       * </pre>
	       */
	      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);
	
	      if (evt.defaultPrevented) {
	        $urlRouter.update();
	        return TransitionAborted;
	      }
	
	      if (!evt.retry) {
	        return null;
	      }
	
	      // Allow the handler to return a promise to defer state lookup retry
	      if (options.$retry) {
	        $urlRouter.update();
	        return TransitionFailed;
	      }
	      var retryTransition = $state.transition = $q.when(evt.retry);
	
	      retryTransition.then(function() {
	        if (retryTransition !== $state.transition) return TransitionSuperseded;
	        redirect.options.$retry = true;
	        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
	      }, function() {
	        return TransitionAborted;
	      });
	      $urlRouter.update();
	
	      return retryTransition;
	    }
	
	    root.locals = { resolve: null, globals: { $stateParams: {} } };
	
	    $state = {
	      params: {},
	      current: root.self,
	      $current: root,
	      transition: null
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#reload
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method that force reloads the current state. All resolves are re-resolved,
	     * controllers reinstantiated, and events re-fired.
	     *
	     * @example
	     * <pre>
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	     *
	     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
	     * @example
	     * <pre>
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
	     * //and current state is 'contacts.detail.item'
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.reload = function reload(state) {
	      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#go
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Convenience method for transitioning to a new state. `$state.go` calls 
	     * `$state.transitionTo` internally but automatically sets options to 
	     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
	     * This allows you to easily use an absolute or relative to path and specify 
	     * only the parameters you'd like to update (while letting unspecified parameters 
	     * inherit from the currently active ancestor states).
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * </pre>
	     * <img src='../ngdoc_assets/StateGoExamples.png'/>
	     *
	     * @param {string} to Absolute state name or relative state path. Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to a parent state
	     * - `$state.go('^.sibling')` - will go to a sibling state
	     * - `$state.go('.child.grandchild')` - will go to grandchild state
	     *
	     * @param {object=} params A map of the parameters that will be sent to the state, 
	     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
	     * defined parameters. Only parameters specified in the state definition can be overridden, new 
	     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
	     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
	     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
	     * will get you all current parameters, etc.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
	     *    have changed.  It will reload the resolves and views of the current state and parent states.
	     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
	     *    the transition reloads the resolves and views for that matched state, and all its children states.
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     *
	     * Possible success values:
	     *
	     * - $state.current
	     *
	     * <br/>Possible rejection values:
	     *
	     * - 'transition superseded' - when a newer transition has been started after this one
	     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
	     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
	     *   when a `$stateNotFound` `event.retry` promise errors.
	     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
	     * - *resolve error* - when an error has occurred with a `resolve`
	     *
	     */
	    $state.go = function go(to, params, options) {
	      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#transitionTo
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
	     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * </pre>
	     *
	     * @param {string} to State name.
	     * @param {object=} toParams A map of the parameters that will be sent to the state,
	     * will populate $stateParams.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
	     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
	     *    use this when you want to force a reload when *everything* is the same, including search params.
	     *    if String, then will reload the state with the name given in reload, and any children.
	     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
	     *
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.transitionTo = function transitionTo(to, toParams, options) {
	      toParams = toParams || {};
	      options = extend({
	        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
	      }, options || {});
	
	      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
	      var evt, toState = findState(to, options.relative);
	
	      // Store the hash param for later (since it will be stripped out by various methods)
	      var hash = toParams['#'];
	
	      if (!isDefined(toState)) {
	        var redirect = { to: to, toParams: toParams, options: options };
	        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);
	
	        if (redirectResult) {
	          return redirectResult;
	        }
	
	        // Always retry once if the $stateNotFound was not prevented
	        // (handles either redirect changed or state lazy-definition)
	        to = redirect.to;
	        toParams = redirect.toParams;
	        options = redirect.options;
	        toState = findState(to, options.relative);
	
	        if (!isDefined(toState)) {
	          if (!options.relative) throw new Error("No such state '" + to + "'");
	          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
	        }
	      }
	      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
	      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
	      if (!toState.params.$$validates(toParams)) return TransitionFailed;
	
	      toParams = toState.params.$$values(toParams);
	      to = toState;
	
	      var toPath = to.path;
	
	      // Starting from the root of the path, keep all levels that haven't changed
	      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];
	
	      if (!options.reload) {
	        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      } else if (isString(options.reload) || isObject(options.reload)) {
	        if (isObject(options.reload) && !options.reload.name) {
	          throw new Error('Invalid reload state object');
	        }
	        
	        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
	        if (options.reload && !reloadState) {
	          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
	        }
	
	        while (state && state === fromPath[keep] && state !== reloadState) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      }
	
	      // If we're going to the same state and all locals are kept, we've got nothing to do.
	      // But clear 'transition', as we still want to cancel any other pending transitions.
	      // TODO: We may not want to bump 'transition' if we're called from a location change
	      // that we've initiated ourselves, because we might accidentally abort a legitimate
	      // transition initiated from code?
	      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
	        if (hash) toParams['#'] = hash;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
	        if (options.location && to.navigable && to.navigable.url) {
	          $urlRouter.push(to.navigable.url, toParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	          $urlRouter.update(true);
	        }
	        $state.transition = null;
	        return $q.when($state.current);
	      }
	
	      // Filter parameters before we pass them to event handlers etc.
	      toParams = filterByKeys(to.params.$$keys(), toParams || {});
	      
	      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
	      if (hash) toParams['#'] = hash;
	      
	      // Broadcast start event and cancel the transition if requested
	      if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeStart
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when the state transition **begins**. You can use `event.preventDefault()`
	         * to prevent the transition from happening and then the transition promise will be
	         * rejected with a `'transition prevented'` value.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         *
	         * @example
	         *
	         * <pre>
	         * $rootScope.$on('$stateChangeStart',
	         * function(event, toState, toParams, fromState, fromParams){
	         *     event.preventDefault();
	         *     // transitionTo() promise will be rejected with
	         *     // a 'transition prevented' error
	         * })
	         * </pre>
	         */
	        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
	          if ($state.transition == null) $urlRouter.update();
	          return TransitionPrevented;
	        }
	      }
	
	      // Resolve locals for the remaining states, but don't update any global state just
	      // yet -- if anything fails to resolve the current state needs to remain untouched.
	      // We also set up an inheritance chain for the locals here. This allows the view directive
	      // to quickly look up the correct definition for each view in the current state. Even
	      // though we create the locals object itself outside resolveState(), it is initially
	      // empty and gets filled asynchronously. We need to keep track of the promise for the
	      // (fully resolved) current locals, and pass this down the chain.
	      var resolved = $q.when(locals);
	
	      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
	        locals = toLocals[l] = inherit(locals);
	        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
	      }
	
	      // Once everything is resolved, we are ready to perform the actual transition
	      // and return a promise for the new state. We also keep track of what the
	      // current promise is, so that we can detect overlapping transitions and
	      // keep only the outcome of the last transition.
	      var transition = $state.transition = resolved.then(function () {
	        var l, entering, exiting;
	
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        // Exit 'from' states not kept
	        for (l = fromPath.length - 1; l >= keep; l--) {
	          exiting = fromPath[l];
	          if (exiting.self.onExit) {
	            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
	          }
	          exiting.locals = null;
	        }
	
	        // Enter 'to' states not kept
	        for (l = keep; l < toPath.length; l++) {
	          entering = toPath[l];
	          entering.locals = toLocals[l];
	          if (entering.self.onEnter) {
	            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
	          }
	        }
	
	        // Run it again, to catch any transitions in callbacks
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        // Update globals in $state
	        $state.$current = to;
	        $state.current = to.self;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        $state.transition = null;
	
	        if (options.location && to.navigable) {
	          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	        }
	
	        if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeSuccess
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired once the state transition is **complete**.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         */
	          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
	        }
	        $urlRouter.update(true);
	
	        return $state.current;
	      }, function (error) {
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        $state.transition = null;
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeError
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when an **error occurs** during transition. It's important to note that if you
	         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
	         * they will not throw traditionally. You must listen for this $stateChangeError event to
	         * catch **ALL** errors.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         * @param {Error} error The resolve error object.
	         */
	        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);
	
	        if (!evt.defaultPrevented) {
	            $urlRouter.update();
	        }
	
	        return $q.reject(error);
	      });
	
	      return transition;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#is
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
	     * but only checks for the full state name. If params is supplied then it will be
	     * tested for strict equality against the current active params object, so all params
	     * must match with none missing and no extras.
	     *
	     * @example
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     * test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it is the state.
	     */
	    $state.is = function is(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) { return undefined; }
	      if ($state.$current !== state) { return false; }
	      return params ? equalForKeys(state.params.$$values(params), $stateParams) : true;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#includes
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * @example
	     * Partial and relative names
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     *
	     * // Using relative names (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
	     * </pre>
	     *
	     * Basic globbing patterns
	     * <pre>
	     * $state.$current.name = 'contacts.details.item.url';
	     *
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * </pre>
	     *
	     * @param {string} stateOrName A partial name, relative name, or glob pattern
	     * to be searched for within the current state name.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
	     * that you'd like to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
	     * .includes will test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    $state.includes = function includes(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      if (isString(stateOrName) && isGlob(stateOrName)) {
	        if (!doesStateMatchGlob(stateOrName)) {
	          return false;
	        }
	        stateOrName = $state.$current.name;
	      }
	
	      var state = findState(stateOrName, options.relative);
	      if (!isDefined(state)) { return undefined; }
	      if (!isDefined($state.$current.includes[state.name])) { return false; }
	      return params ? equalForKeys(state.params.$$values(params), $stateParams, objectKeys(params)) : true;
	    };
	
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#href
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A url generation method that returns the compiled url for the given state populated with the given params.
	     *
	     * @example
	     * <pre>
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
	     * @param {object=} params An object of parameter values to fill the state's required parameters.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
	     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
	     *    ancestor with a valid url).
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     * 
	     * @returns {string} compiled state url
	     */
	    $state.href = function href(stateOrName, params, options) {
	      options = extend({
	        lossy:    true,
	        inherit:  true,
	        absolute: false,
	        relative: $state.$current
	      }, options || {});
	
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) return null;
	      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
	      
	      var nav = (state && options.lossy) ? state.navigable : state;
	
	      if (!nav || nav.url === undefined || nav.url === null) {
	        return null;
	      }
	      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
	        absolute: options.absolute
	      });
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#get
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Returns the state configuration object for any specific state or all states.
	     *
	     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
	     * the requested state. If not provided, returns an array of ALL state configs.
	     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
	     * @returns {Object|Array} State configuration object or array of all objects.
	     */
	    $state.get = function (stateOrName, context) {
	      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
	      var state = findState(stateOrName, context || $state.$current);
	      return (state && state.self) ? state.self : null;
	    };
	
	    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
	      // Make a restricted $stateParams with only the parameters that apply to this state if
	      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
	      // we also need $stateParams to be available for any $injector calls we make during the
	      // dependency resolution process.
	      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
	      var locals = { $stateParams: $stateParams };
	
	      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
	      // We're also including $stateParams in this; that way the parameters are restricted
	      // to the set that should be visible to the state, and are independent of when we update
	      // the global $state and $stateParams values.
	      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
	      var promises = [dst.resolve.then(function (globals) {
	        dst.globals = globals;
	      })];
	      if (inherited) promises.push(inherited);
	
	      function resolveViews() {
	        var viewsPromises = [];
	
	        // Resolve template and dependencies for all views.
	        forEach(state.views, function (view, name) {
	          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
	          injectables.$template = [ function () {
	            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
	          }];
	
	          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
	            // References to the controller (only instantiated at link time)
	            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
	              var injectLocals = angular.extend({}, injectables, dst.globals);
	              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
	            } else {
	              result.$$controller = view.controller;
	            }
	            // Provide access to the state itself for internal use
	            result.$$state = state;
	            result.$$controllerAs = view.controllerAs;
	            dst[name] = result;
	          }));
	        });
	
	        return $q.all(viewsPromises).then(function(){
	          return dst.globals;
	        });
	      }
	
	      // Wait for all the promises and then return the activation object
	      return $q.all(promises).then(resolveViews).then(function (values) {
	        return dst;
	      });
	    }
	
	    return $state;
	  }
	
	  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
	    // Return true if there are no differences in non-search (path/object) params, false if there are differences
	    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
	      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
	      function notSearchParam(key) {
	        return fromAndToState.params[key].location != "search";
	      }
	      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
	      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
	      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
	      return nonQueryParamSet.$$equals(fromParams, toParams);
	    }
	
	    // If reload was not explicitly requested
	    // and we're transitioning to the same state we're already in
	    // and    the locals didn't change
	    //     or they changed in a way that doesn't merit reloading
	    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
	    // Then return true.
	    if (!options.reload && to === from &&
	      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
	      return true;
	    }
	  }
	}
	
	angular.module('ui.router.state')
	  .factory('$stateParams', function () { return {}; })
	  .provider('$state', $StateProvider);
	
	
	$ViewProvider.$inject = [];
	function $ViewProvider() {
	
	  this.$get = $get;
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$view
	   *
	   * @requires ui.router.util.$templateFactory
	   * @requires $rootScope
	   *
	   * @description
	   *
	   */
	  $get.$inject = ['$rootScope', '$templateFactory'];
	  function $get(   $rootScope,   $templateFactory) {
	    return {
	      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$view#load
	       * @methodOf ui.router.state.$view
	       *
	       * @description
	       *
	       * @param {string} name name
	       * @param {object} options option object.
	       */
	      load: function load(name, options) {
	        var result, defaults = {
	          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
	        };
	        options = extend(defaults, options);
	
	        if (options.view) {
	          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
	        }
	        return result;
	      }
	    };
	  }
	}
	
	angular.module('ui.router.state').provider('$view', $ViewProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$uiViewScrollProvider
	 *
	 * @description
	 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
	 */
	function $ViewScrollProvider() {
	
	  var useAnchorScroll = false;
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
	   * @methodOf ui.router.state.$uiViewScrollProvider
	   *
	   * @description
	   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
	   * scrolling based on the url anchor.
	   */
	  this.useAnchorScroll = function () {
	    useAnchorScroll = true;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$uiViewScroll
	   *
	   * @requires $anchorScroll
	   * @requires $timeout
	   *
	   * @description
	   * When called with a jqLite element, it scrolls the element into view (after a
	   * `$timeout` so the DOM has time to refresh).
	   *
	   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
	   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
	   */
	  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
	    if (useAnchorScroll) {
	      return $anchorScroll;
	    }
	
	    return function ($element) {
	      return $timeout(function () {
	        $element[0].scrollIntoView();
	      }, 0, false);
	    };
	  }];
	}
	
	angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	var ngMajorVer = angular.version.major;
	var ngMinorVer = angular.version.minor;
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-view
	 *
	 * @requires ui.router.state.$state
	 * @requires $compile
	 * @requires $controller
	 * @requires $injector
	 * @requires ui.router.state.$uiViewScroll
	 * @requires $document
	 *
	 * @restrict ECA
	 *
	 * @description
	 * The ui-view directive tells $state where to place your templates.
	 *
	 * @param {string=} name A view name. The name should be unique amongst the other views in the
	 * same state. You can have views of the same name that live in different states.
	 *
	 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
	 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
	 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
	 * scroll ui-view elements into view when they are populated during a state activation.
	 *
	 * @param {string=} noanimation If truthy, the non-animated renderer will be selected (no animations
	 * will be applied to the ui-view)
	 *
	 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
	 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
	 *
	 * @param {string=} onload Expression to evaluate whenever the view updates.
	 * 
	 * @example
	 * A view can be unnamed or named. 
	 * <pre>
	 * <!-- Unnamed -->
	 * <div ui-view></div> 
	 * 
	 * <!-- Named -->
	 * <div ui-view="viewName"></div>
	 * </pre>
	 *
	 * You can only have one unnamed view within any template (or root html). If you are only using a 
	 * single view and it is unnamed then you can populate it like so:
	 * <pre>
	 * <div ui-view></div> 
	 * $stateProvider.state("home", {
	 *   template: "<h1>HELLO!</h1>"
	 * })
	 * </pre>
	 * 
	 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#views `views`}
	 * config property, by name, in this case an empty name:
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 * 
	 * But typically you'll only use the views property if you name your view or have more than one view 
	 * in the same template. There's not really a compelling reason to name a view if its the only one, 
	 * but you could if you wanted, like so:
	 * <pre>
	 * <div ui-view="main"></div>
	 * </pre> 
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "main": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 * 
	 * Really though, you'll use views to set up multiple views:
	 * <pre>
	 * <div ui-view></div>
	 * <div ui-view="chart"></div> 
	 * <div ui-view="data"></div> 
	 * </pre>
	 * 
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     },
	 *     "chart": {
	 *       template: "<chart_thing/>"
	 *     },
	 *     "data": {
	 *       template: "<data_thing/>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * Examples for `autoscroll`:
	 *
	 * <pre>
	 * <!-- If autoscroll present with no expression,
	 *      then scroll ui-view into view -->
	 * <ui-view autoscroll/>
	 *
	 * <!-- If autoscroll present with valid expression,
	 *      then scroll ui-view into view if expression evaluates to true -->
	 * <ui-view autoscroll='true'/>
	 * <ui-view autoscroll='false'/>
	 * <ui-view autoscroll='scopeVariable'/>
	 * </pre>
	 */
	$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate'];
	function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate) {
	
	  function getService() {
	    return ($injector.has) ? function(service) {
	      return $injector.has(service) ? $injector.get(service) : null;
	    } : function(service) {
	      try {
	        return $injector.get(service);
	      } catch (e) {
	        return null;
	      }
	    };
	  }
	
	  var service = getService(),
	      $animator = service('$animator'),
	      $animate = service('$animate');
	
	  // Returns a set of DOM manipulation functions based on which Angular version
	  // it should use
	  function getRenderer(attrs, scope) {
	    var statics = {
	      enter: function (element, target, cb) { target.after(element); cb(); },
	      leave: function (element, cb) { element.remove(); cb(); }
	    };
	
	    if (!!attrs.noanimation) return statics;
	
	    function animEnabled(element) {
	      if (ngMajorVer === 1 && ngMinorVer >= 4) return !!$animate.enabled(element);
	      if (ngMajorVer === 1 && ngMinorVer >= 2) return !!$animate.enabled();
	      return (!!$animator);
	    }
	
	    // ng 1.2+
	    if ($animate) {
	      return {
	        enter: function(element, target, cb) {
	          if (!animEnabled(element)) {
	            statics.enter(element, target, cb);
	          } else if (angular.version.minor > 2) {
	            $animate.enter(element, null, target).then(cb);
	          } else {
	            $animate.enter(element, null, target, cb);
	          }
	        },
	        leave: function(element, cb) {
	          if (!animEnabled(element)) {
	            statics.leave(element, cb);
	          } else if (angular.version.minor > 2) {
	            $animate.leave(element).then(cb);
	          } else {
	            $animate.leave(element, cb);
	          }
	        }
	      };
	    }
	
	    // ng 1.1.5
	    if ($animator) {
	      var animate = $animator && $animator(scope, attrs);
	
	      return {
	        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
	        leave: function(element, cb) { animate.leave(element); cb(); }
	      };
	    }
	
	    return statics;
	  }
	
	  var directive = {
	    restrict: 'ECA',
	    terminal: true,
	    priority: 400,
	    transclude: 'element',
	    compile: function (tElement, tAttrs, $transclude) {
	      return function (scope, $element, attrs) {
	        var previousEl, currentEl, currentScope, latestLocals,
	            onloadExp     = attrs.onload || '',
	            autoScrollExp = attrs.autoscroll,
	            renderer      = getRenderer(attrs, scope);
	
	        scope.$on('$stateChangeSuccess', function() {
	          updateView(false);
	        });
	
	        updateView(true);
	
	        function cleanupLastView() {
	          var _previousEl = previousEl;
	          var _currentScope = currentScope;
	
	          if (_currentScope) {
	            _currentScope._willBeDestroyed = true;
	          }
	
	          function cleanOld() {
	            if (_previousEl) {
	              _previousEl.remove();
	            }
	
	            if (_currentScope) {
	              _currentScope.$destroy();
	            }
	          }
	
	          if (currentEl) {
	            renderer.leave(currentEl, function() {
	              cleanOld();
	              previousEl = null;
	            });
	
	            previousEl = currentEl;
	          } else {
	            cleanOld();
	            previousEl = null;
	          }
	
	          currentEl = null;
	          currentScope = null;
	        }
	
	        function updateView(firstTime) {
	          var newScope,
	              name            = getUiViewName(scope, attrs, $element, $interpolate),
	              previousLocals  = name && $state.$current && $state.$current.locals[name];
	
	          if (!firstTime && previousLocals === latestLocals || scope._willBeDestroyed) return; // nothing to do
	          newScope = scope.$new();
	          latestLocals = $state.$current.locals[name];
	
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoading
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           *
	           * Fired once the view **begins loading**, *before* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          newScope.$emit('$viewContentLoading', name);
	
	          var clone = $transclude(newScope, function(clone) {
	            renderer.enter(clone, $element, function onUiViewEnter() {
	              if(currentScope) {
	                currentScope.$emit('$viewContentAnimationEnded');
	              }
	
	              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
	                $uiViewScroll(clone);
	              }
	            });
	            cleanupLastView();
	          });
	
	          currentEl = clone;
	          currentScope = newScope;
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoaded
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           * Fired once the view is **loaded**, *after* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          currentScope.$emit('$viewContentLoaded', name);
	          currentScope.$eval(onloadExp);
	        }
	      };
	    }
	  };
	
	  return directive;
	}
	
	$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
	function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
	  return {
	    restrict: 'ECA',
	    priority: -400,
	    compile: function (tElement) {
	      var initial = tElement.html();
	      return function (scope, $element, attrs) {
	        var current = $state.$current,
	            name = getUiViewName(scope, attrs, $element, $interpolate),
	            locals  = current && current.locals[name];
	
	        if (! locals) {
	          return;
	        }
	
	        $element.data('$uiView', { name: name, state: locals.$$state });
	        $element.html(locals.$template ? locals.$template : initial);
	
	        var link = $compile($element.contents());
	
	        if (locals.$$controller) {
	          locals.$scope = scope;
	          locals.$element = $element;
	          var controller = $controller(locals.$$controller, locals);
	          if (locals.$$controllerAs) {
	            scope[locals.$$controllerAs] = controller;
	          }
	          $element.data('$ngControllerController', controller);
	          $element.children().data('$ngControllerController', controller);
	        }
	
	        link(scope);
	      };
	    }
	  };
	}
	
	/**
	 * Shared ui-view code for both directives:
	 * Given scope, element, and its attributes, return the view's name
	 */
	function getUiViewName(scope, attrs, element, $interpolate) {
	  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
	  var inherited = element.inheritedData('$uiView');
	  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (inherited ? inherited.state.name : ''));
	}
	
	angular.module('ui.router.state').directive('uiView', $ViewDirective);
	angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	function parseStateRef(ref, current) {
	  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
	  if (preparsed) ref = current + '(' + preparsed[1] + ')';
	  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
	  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
	  return { state: parsed[1], paramExpr: parsed[3] || null };
	}
	
	function stateContext(el) {
	  var stateData = el.parent().inheritedData('$uiView');
	
	  if (stateData && stateData.state && stateData.state.name) {
	    return stateData.state;
	  }
	}
	
	function getTypeInfo(el) {
	  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	  var isForm = el[0].nodeName === "FORM";
	
	  return {
	    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
	    isAnchor: el.prop("tagName").toUpperCase() === "A",
	    clickable: !isForm
	  };
	}
	
	function clickHook(el, $state, $timeout, type, current) {
	  return function(e) {
	    var button = e.which || e.button, target = current();
	
	    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
	      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	      var transition = $timeout(function() {
	        $state.go(target.state, target.params, target.options);
	      });
	      e.preventDefault();
	
	      // if the state has no URL, ignore one preventDefault from the <a> directive.
	      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;
	
	      e.preventDefault = function() {
	        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
	      };
	    }
	  };
	}
	
	function defaultOpts(el, $state) {
	  return { relative: stateContext(el) || $state.$current, inherit: true };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref
	 *
	 * @requires ui.router.state.$state
	 * @requires $timeout
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
	 * URL, the directive will automatically generate & update the `href` attribute via
	 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
	 * the link will trigger a state transition with optional parameters.
	 *
	 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
	 * handled natively by the browser.
	 *
	 * You can also use relative state paths within ui-sref, just like the relative
	 * paths passed to `$state.go()`. You just need to be aware that the path is relative
	 * to the state that the link lives in, in other words the state that loaded the
	 * template containing the link.
	 *
	 * You can specify options to pass to {@link ui.router.state.$state#go $state.go()}
	 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
	 * and `reload`.
	 *
	 * @example
	 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
	 * following template:
	 * <pre>
	 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	 *     </li>
	 * </ul>
	 * </pre>
	 *
	 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
	 * <pre>
	 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	 *     </li>
	 * </ul>
	 *
	 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	 * </pre>
	 *
	 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#go $state.go()}
	 */
	$StateRefDirective.$inject = ['$state', '$timeout'];
	function $StateRefDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
	      var def    = { state: ref.state, href: null, params: null };
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	
	      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});
	
	      var update = function(val) {
	        if (val) def.params = angular.copy(val);
	        def.href = $state.href(ref.state, def.params, def.options);
	
	        if (active) active.$$addStateInfo(ref.state, def.params);
	        if (def.href !== null) attrs.$set(type.attr, def.href);
	      };
	
	      if (ref.paramExpr) {
	        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
	        def.params = angular.copy(scope.$eval(ref.paramExpr));
	      }
	      update();
	
	      if (!type.clickable) return;
	      element.bind("click", clickHook(element, $state, $timeout, type, function() { return def; }));
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-state
	 *
	 * @requires ui.router.state.uiSref
	 *
	 * @restrict A
	 *
	 * @description
	 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
	 * params and override options.
	 *
	 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#href $state.href()}
	 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#go $state.go()}
	 */
	$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
	function $StateRefDynamicDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
	      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
	      var def    = { state: null, params: null, options: null, href: null };
	
	      function runStateRefLink (group) {
	        def.state = group[0]; def.params = group[1]; def.options = group[2];
	        def.href = $state.href(def.state, def.params, def.options);
	
	        if (active) active.$$addStateInfo(def.state, def.params);
	        if (def.href) attrs.$set(type.attr, def.href);
	      }
	
	      scope.$watch(watch, runStateRefLink, true);
	      runStateRefLink(scope.$eval(watch));
	
	      if (!type.clickable) return;
	      element.bind("click", clickHook(element, $state, $timeout, type, function() { return def; }));
	    }
	  };
	}
	
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive working alongside ui-sref to add classes to an element when the
	 * related ui-sref directive's state is active, and removing them when it is inactive.
	 * The primary use-case is to simplify the special appearance of navigation menus
	 * relying on `ui-sref`, by having the "active" state's menu button appear different,
	 * distinguishing it from the inactive menu items.
	 *
	 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
	 * ui-sref-active found at the same level or above the ui-sref will be used.
	 *
	 * Will activate when the ui-sref's target state or any child state is active. If you
	 * need to activate only when the ui-sref target state is active and *not* any of
	 * it's children, then you will use
	 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
	 *
	 * @example
	 * Given the following template:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item">
	 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 *
	 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
	 * the resulting HTML will appear as (note the 'active' class):
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item active">
	 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * The class name is interpolated **once** during the directives link time (any further changes to the
	 * interpolated value are ignored).
	 *
	 * Multiple classes may be specified in a space-separated format:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active='class1 class2 class3'>
	 *     <a ui-sref="app.user">link</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * It is also possible to pass ui-sref-active an expression that evaluates
	 * to an object hash, whose keys represent active class names and whose
	 * values represent the respective state names/globs.
	 * ui-sref-active will match if the current active state **includes** any of
	 * the specified state names/globs, even the abstract ones.
	 *
	 * @Example
	 * Given the following template, with "admin" being an abstract state:
	 * <pre>
	 * <div ui-sref-active="{'active': 'admin.*'}">
	 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	 * </div>
	 * </pre>
	 *
	 * When the current state is "admin.roles" the "active" class will be applied
	 * to both the <div> and <a> elements. It is important to note that the state
	 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active-eq
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
	 * when the exact target state used in the `ui-sref` is active; no child states.
	 *
	 */
	$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
	function $StateRefActiveDirective($state, $stateParams, $interpolate) {
	  return  {
	    restrict: "A",
	    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
	      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;
	
	      // There probably isn't much point in $observing this
	      // uiSrefActive and uiSrefActiveEq share the same directive object with some
	      // slight difference in logic routing
	      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	
	      try {
	        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	      } catch (e) {
	        // Do nothing. uiSrefActive is not a valid expression.
	        // Fall back to using $interpolate below
	      }
	      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	      if (isObject(uiSrefActive)) {
	        forEach(uiSrefActive, function(stateOrName, activeClass) {
	          if (isString(stateOrName)) {
	            var ref = parseStateRef(stateOrName, $state.current.name);
	            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	          }
	        });
	      }
	
	      // Allow uiSref to communicate with uiSrefActive[Equals]
	      this.$$addStateInfo = function (newState, newParams) {
	        // we already got an explicit state provided by ui-sref-active, so we
	        // shadow the one that comes from ui-sref
	        if (isObject(uiSrefActive) && states.length > 0) {
	          return;
	        }
	        addState(newState, newParams, uiSrefActive);
	        update();
	      };
	
	      $scope.$on('$stateChangeSuccess', update);
	
	      function addState(stateName, stateParams, activeClass) {
	        var state = $state.get(stateName, stateContext($element));
	        var stateHash = createStateHash(stateName, stateParams);
	
	        states.push({
	          state: state || { name: stateName },
	          params: stateParams,
	          hash: stateHash
	        });
	
	        activeClasses[stateHash] = activeClass;
	      }
	
	      /**
	       * @param {string} state
	       * @param {Object|string} [params]
	       * @return {string}
	       */
	      function createStateHash(state, params) {
	        if (!isString(state)) {
	          throw new Error('state should be a string');
	        }
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        params = $scope.$eval(params);
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        return state;
	      }
	
	      // Update route state
	      function update() {
	        for (var i = 0; i < states.length; i++) {
	          if (anyMatch(states[i].state, states[i].params)) {
	            addClass($element, activeClasses[states[i].hash]);
	          } else {
	            removeClass($element, activeClasses[states[i].hash]);
	          }
	
	          if (exactMatch(states[i].state, states[i].params)) {
	            addClass($element, activeEqClass);
	          } else {
	            removeClass($element, activeEqClass);
	          }
	        }
	      }
	
	      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
	      function removeClass(el, className) { el.removeClass(className); }
	      function anyMatch(state, params) { return $state.includes(state.name, params); }
	      function exactMatch(state, params) { return $state.is(state.name, params); }
	
	      update();
	    }]
	  };
	}
	
	angular.module('ui.router.state')
	  .directive('uiSref', $StateRefDirective)
	  .directive('uiSrefActive', $StateRefActiveDirective)
	  .directive('uiSrefActiveEq', $StateRefActiveDirective)
	  .directive('uiState', $StateRefDynamicDirective);
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:isState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
	 */
	$IsStateFilter.$inject = ['$state'];
	function $IsStateFilter($state) {
	  var isFilter = function (state, params) {
	    return $state.is(state, params);
	  };
	  isFilter.$stateful = true;
	  return isFilter;
	}
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:includedByState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
	 */
	$IncludedByStateFilter.$inject = ['$state'];
	function $IncludedByStateFilter($state) {
	  var includesFilter = function (state, params, options) {
	    return $state.includes(state, params, options);
	  };
	  includesFilter.$stateful = true;
	  return  includesFilter;
	}
	
	angular.module('ui.router.state')
	  .filter('isState', $IsStateFilter)
	  .filter('includedByState', $IncludedByStateFilter);
	})(window, window.angular);

/***/ }),

/***/ 1020:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1021);

/***/ }),

/***/ 1021:
/***/ (function(module, exports) {

	/**
	 * angular-ui-utils - Swiss-Army-Knife of AngularJS tools (with no external dependencies!)
	 * @version v0.2.3 - 2015-03-30
	 * @link http://angular-ui.github.com
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	angular.module('ui.alias', []).config(['$compileProvider', 'uiAliasConfig', function($compileProvider, uiAliasConfig){
	  'use strict';
	
	  uiAliasConfig = uiAliasConfig || {};
	  angular.forEach(uiAliasConfig, function(config, alias){
	    if (angular.isString(config)) {
	      config = {
	        replace: true,
	        template: config
	      };
	    }
	    $compileProvider.directive(alias, function(){
	      return config;
	    });
	  });
	}]);
	
	/**
	 * General-purpose Event binding. Bind any event not natively supported by Angular
	 * Pass an object with keynames for events to ui-event
	 * Allows $event object and $params object to be passed
	 *
	 * @example <input ui-event="{ focus : 'counter++', blur : 'someCallback()' }">
	 * @example <input ui-event="{ myCustomEvent : 'myEventHandler($event, $params)'}">
	 *
	 * @param ui-event {string|object literal} The event to bind to as a string or a hash of events with their callbacks
	 */
	angular.module('ui.event',[]).directive('uiEvent', ['$parse',
	  function ($parse) {
	    'use strict';
	
	    return function ($scope, elm, attrs) {
	      var events = $scope.$eval(attrs.uiEvent);
	      angular.forEach(events, function (uiEvent, eventName) {
	        var fn = $parse(uiEvent);
	        elm.bind(eventName, function (evt) {
	          var params = Array.prototype.slice.call(arguments);
	          //Take out first paramater (event object);
	          params = params.splice(1);
	          fn($scope, {$event: evt, $params: params});
	          if (!$scope.$$phase) {
	            $scope.$apply();
	          }
	        });
	      });
	    };
	  }]);
	
	/**
	 * A replacement utility for internationalization very similar to sprintf.
	 *
	 * @param replace {mixed} The tokens to replace depends on type
	 *  string: all instances of $0 will be replaced
	 *  array: each instance of $0, $1, $2 etc. will be placed with each array item in corresponding order
	 *  object: all attributes will be iterated through, with :key being replaced with its corresponding value
	 * @return string
	 *
	 * @example: 'Hello :name, how are you :day'.format({ name:'John', day:'Today' })
	 * @example: 'Records $0 to $1 out of $2 total'.format(['10', '20', '3000'])
	 * @example: '$0 agrees to all mentions $0 makes in the event that $0 hits a tree while $0 is driving drunk'.format('Bob')
	 */
	angular.module('ui.format',[]).filter('format', function(){
	  'use strict';
	
	  return function(value, replace) {
	    var target = value;
	    if (angular.isString(target) && replace !== undefined) {
	      if (!angular.isArray(replace) && !angular.isObject(replace)) {
	        replace = [replace];
	      }
	      if (angular.isArray(replace)) {
	        var rlen = replace.length;
	        var rfx = function (str, i) {
	          i = parseInt(i, 10);
	          return (i >= 0 && i < rlen) ? replace[i] : str;
	        };
	        target = target.replace(/\$([0-9]+)/g, rfx);
	      }
	      else {
	        angular.forEach(replace, function(value, key){
	          target = target.split(':' + key).join(value);
	        });
	      }
	    }
	    return target;
	  };
	});
	
	/**
	 * Wraps the
	 * @param text {string} haystack to search through
	 * @param search {string} needle to search for
	 * @param [caseSensitive] {boolean} optional boolean to use case-sensitive searching
	 */
	angular.module('ui.highlight',[]).filter('highlight', function () {
	  'use strict';
	
	  return function (text, search, caseSensitive) {
	    if (text && (search || angular.isNumber(search))) {
	      text = text.toString();
	      search = search.toString();
	      if (caseSensitive) {
	        return text.split(search).join('<span class="ui-match">' + search + '</span>');
	      } else {
	        return text.replace(new RegExp(search, 'gi'), '<span class="ui-match">$&</span>');
	      }
	    } else {
	      return text;
	    }
	  };
	});
	
	// modeled after: angular-1.0.7/src/ng/directive/ngInclude.js
	angular.module('ui.include',[])
	.directive('uiInclude', ['$http', '$templateCache', '$anchorScroll', '$compile',
	                 function($http,   $templateCache,   $anchorScroll,   $compile) {
	  'use strict';
	
	  return {
	    restrict: 'ECA',
	    terminal: true,
	    compile: function(element, attr) {
	      var srcExp = attr.uiInclude || attr.src,
	          fragExp = attr.fragment || '',
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, element) {
	        var changeCounter = 0,
	            childScope;
	
	        var clearContent = function() {
	          if (childScope) {
	            childScope.$destroy();
	            childScope = null;
	          }
	
	          element.html('');
	        };
	
	        function ngIncludeWatchAction() {
	          var thisChangeId = ++changeCounter;
	          var src = scope.$eval(srcExp);
	          var fragment = scope.$eval(fragExp);
	
	          if (src) {
	            $http.get(src, {cache: $templateCache}).success(function(response) {
	              if (thisChangeId !== changeCounter) { return; }
	
	              if (childScope) { childScope.$destroy(); }
	              childScope = scope.$new();
	
	              var contents;
	              if (fragment) {
	                contents = angular.element('<div/>').html(response).find(fragment);
	              }
	              else {
	                contents = angular.element('<div/>').html(response).contents();
	              }
	              element.html(contents);
	              $compile(contents)(childScope);
	
	              if (angular.isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	              }
	
	              childScope.$emit('$includeContentLoaded');
	              scope.$eval(onloadExp);
	            }).error(function() {
	              if (thisChangeId === changeCounter) { clearContent(); }
	            });
	          } else { clearContent(); }
	        }
	
	        scope.$watch(fragExp, ngIncludeWatchAction);
	        scope.$watch(srcExp, ngIncludeWatchAction);
	      };
	    }
	  };
	}]);
	
	/**
	 * Provides an easy way to toggle a checkboxes indeterminate property
	 *
	 * @example <input type="checkbox" ui-indeterminate="isUnkown">
	 */
	angular.module('ui.indeterminate',[]).directive('uiIndeterminate', [
	  function () {
	    'use strict';
	
	    return {
	      compile: function(tElm, tAttrs) {
	        if (!tAttrs.type || tAttrs.type.toLowerCase() !== 'checkbox') {
	          return angular.noop;
	        }
	
	        return function ($scope, elm, attrs) {
	          $scope.$watch(attrs.uiIndeterminate, function(newVal) {
	            elm[0].indeterminate = !!newVal;
	          });
	        };
	      }
	    };
	  }]);
	
	/**
	 * Converts variable-esque naming conventions to something presentational, capitalized words separated by space.
	 * @param {String} value The value to be parsed and prettified.
	 * @param {String} [inflector] The inflector to use. Default: humanize.
	 * @return {String}
	 * @example {{ 'Here Is my_phoneNumber' | inflector:'humanize' }} => Here Is My Phone Number
	 *          {{ 'Here Is my_phoneNumber' | inflector:'underscore' }} => here_is_my_phone_number
	 *          {{ 'Here Is my_phoneNumber' | inflector:'variable' }} => hereIsMyPhoneNumber
	 */
	angular.module('ui.inflector',[]).filter('inflector', function () {
	  'use strict';
	
	  function tokenize(text) {
	    text = text.replace(/([A-Z])|([\-|\_])/g, function(_, $1) { return ' ' + ($1 || ''); });
	    return text.replace(/\s\s+/g, ' ').trim().toLowerCase().split(' ');
	  }
	
	  function capitalizeTokens(tokens) {
	    var result = [];
	    angular.forEach(tokens, function(token) {
	      result.push(token.charAt(0).toUpperCase() + token.substr(1));
	    });
	    return result;
	  }
	
	  var inflectors = {
	    humanize: function (value) {
	      return capitalizeTokens(tokenize(value)).join(' ');
	    },
	    underscore: function (value) {
	      return tokenize(value).join('_');
	    },
	    variable: function (value) {
	      value = tokenize(value);
	      value = value[0] + capitalizeTokens(value.slice(1)).join('');
	      return value;
	    }
	  };
	
	  return function (text, inflector) {
	    if (inflector !== false && angular.isString(text)) {
	      inflector = inflector || 'humanize';
	      return inflectors[inflector](text);
	    } else {
	      return text;
	    }
	  };
	});
	
	/**
	 * General-purpose jQuery wrapper. Simply pass the plugin name as the expression.
	 *
	 * It is possible to specify a default set of parameters for each jQuery plugin.
	 * Under the jq key, namespace each plugin by that which will be passed to ui-jq.
	 * Unfortunately, at this time you can only pre-define the first parameter.
	 * @example { jq : { datepicker : { showOn:'click' } } }
	 *
	 * @param ui-jq {string} The $elm.[pluginName]() to call.
	 * @param [ui-options] {mixed} Expression to be evaluated and passed as options to the function
	 *     Multiple parameters can be separated by commas
	 * @param [ui-refresh] {expression} Watch expression and refire plugin on changes
	 *
	 * @example <input ui-jq="datepicker" ui-options="{showOn:'click'},secondParameter,thirdParameter" ui-refresh="iChange">
	 */
	angular.module('ui.jq',[]).
	  value('uiJqConfig',{}).
	  directive('uiJq', ['uiJqConfig', '$timeout', function uiJqInjectingFunction(uiJqConfig, $timeout) {
	  'use strict';
	
	
	  return {
	    restrict: 'A',
	    compile: function uiJqCompilingFunction(tElm, tAttrs) {
	
	      if (!angular.isFunction(tElm[tAttrs.uiJq])) {
	        throw new Error('ui-jq: The "' + tAttrs.uiJq + '" function does not exist');
	      }
	      var options = uiJqConfig && uiJqConfig[tAttrs.uiJq];
	
	      return function uiJqLinkingFunction(scope, elm, attrs) {
	
	        // If change compatibility is enabled, the form input's "change" event will trigger an "input" event
	        if (attrs.ngModel && elm.is('select,input,textarea')) {
	          elm.bind('change', function() {
	            elm.trigger('input');
	          });
	        }
	
	        function createLinkOptions(){
	          var linkOptions = [];
	
	          // If ui-options are passed, merge (or override) them onto global defaults and pass to the jQuery method
	          if (attrs.uiOptions) {
	            linkOptions = scope.$eval('[' + attrs.uiOptions + ']');
	            if (angular.isObject(options) && angular.isObject(linkOptions[0])) {
	              linkOptions[0] = angular.extend({}, options, linkOptions[0]);
	            }
	          } else if (options) {
	            linkOptions = [options];
	          }
	          return linkOptions;
	        }
	
	        // Call jQuery method and pass relevant options
	        function callPlugin() {
	          $timeout(function() {
	            elm[attrs.uiJq].apply(elm, createLinkOptions());
	          }, 0, false);
	        }
	
	        // If ui-refresh is used, re-fire the the method upon every change
	        if (attrs.uiRefresh) {
	          scope.$watch(attrs.uiRefresh, function() {
	            callPlugin();
	          });
	        }
	        callPlugin();
	      };
	    }
	  };
	}]);
	
	angular.module('ui.keypress',[]).
	factory('keypressHelper', ['$parse', function keypress($parse){
	  'use strict';
	
	  var keysByCode = {
	    8: 'backspace',
	    9: 'tab',
	    13: 'enter',
	    27: 'esc',
	    32: 'space',
	    33: 'pageup',
	    34: 'pagedown',
	    35: 'end',
	    36: 'home',
	    37: 'left',
	    38: 'up',
	    39: 'right',
	    40: 'down',
	    45: 'insert',
	    46: 'delete'
	  };
	
	  var capitaliseFirstLetter = function (string) {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  };
	
	  return function(mode, scope, elm, attrs) {
	    var params, combinations = [];
	    params = scope.$eval(attrs['ui'+capitaliseFirstLetter(mode)]);
	
	    // Prepare combinations for simple checking
	    angular.forEach(params, function (v, k) {
	      var combination, expression;
	      expression = $parse(v);
	
	      angular.forEach(k.split(' '), function(variation) {
	        combination = {
	          expression: expression,
	          keys: {}
	        };
	        angular.forEach(variation.split('-'), function (value) {
	          combination.keys[value] = true;
	        });
	        combinations.push(combination);
	      });
	    });
	
	    // Check only matching of pressed keys one of the conditions
	    elm.bind(mode, function (event) {
	      // No need to do that inside the cycle
	      var metaPressed = !!(event.metaKey && !event.ctrlKey);
	      var altPressed = !!event.altKey;
	      var ctrlPressed = !!event.ctrlKey;
	      var shiftPressed = !!event.shiftKey;
	      var keyCode = event.keyCode;
	
	      // normalize keycodes
	      if (mode === 'keypress' && !shiftPressed && keyCode >= 97 && keyCode <= 122) {
	        keyCode = keyCode - 32;
	      }
	
	      // Iterate over prepared combinations
	      angular.forEach(combinations, function (combination) {
	
	        var mainKeyPressed = combination.keys[keysByCode[keyCode]] || combination.keys[keyCode.toString()];
	
	        var metaRequired = !!combination.keys.meta;
	        var altRequired = !!combination.keys.alt;
	        var ctrlRequired = !!combination.keys.ctrl;
	        var shiftRequired = !!combination.keys.shift;
	
	        if (
	          mainKeyPressed &&
	          ( metaRequired === metaPressed ) &&
	          ( altRequired === altPressed ) &&
	          ( ctrlRequired === ctrlPressed ) &&
	          ( shiftRequired === shiftPressed )
	        ) {
	          // Run the function
	          scope.$apply(function () {
	            combination.expression(scope, { '$event': event });
	          });
	        }
	      });
	    });
	  };
	}]);
	
	/**
	 * Bind one or more handlers to particular keys or their combination
	 * @param hash {mixed} keyBindings Can be an object or string where keybinding expression of keys or keys combinations and AngularJS Exspressions are set. Object syntax: "{ keys1: expression1 [, keys2: expression2 [ , ... ]]}". String syntax: ""expression1 on keys1 [ and expression2 on keys2 [ and ... ]]"". Expression is an AngularJS Expression, and key(s) are dash-separated combinations of keys and modifiers (one or many, if any. Order does not matter). Supported modifiers are 'ctrl', 'shift', 'alt' and key can be used either via its keyCode (13 for Return) or name. Named keys are 'backspace', 'tab', 'enter', 'esc', 'space', 'pageup', 'pagedown', 'end', 'home', 'left', 'up', 'right', 'down', 'insert', 'delete'.
	 * @example <input ui-keypress="{enter:'x = 1', 'ctrl-shift-space':'foo()', 'shift-13':'bar()'}" /> <input ui-keypress="foo = 2 on ctrl-13 and bar('hello') on shift-esc" />
	 **/
	angular.module('ui.keypress').directive('uiKeydown', ['keypressHelper', function(keypressHelper){
	  'use strict';
	
	  return {
	    link: function (scope, elm, attrs) {
	      keypressHelper('keydown', scope, elm, attrs);
	    }
	  };
	}]);
	
	angular.module('ui.keypress').directive('uiKeypress', ['keypressHelper', function(keypressHelper){
	  'use strict';
	
	  return {
	    link: function (scope, elm, attrs) {
	      keypressHelper('keypress', scope, elm, attrs);
	    }
	  };
	}]);
	
	angular.module('ui.keypress').directive('uiKeyup', ['keypressHelper', function(keypressHelper){
	  'use strict';
	
	  return {
	    link: function (scope, elm, attrs) {
	      keypressHelper('keyup', scope, elm, attrs);
	    }
	  };
	}]);
	
	/*
	 Attaches input mask onto input element
	 */
	angular.module('ui.mask', [])
	  .value('uiMaskConfig', {
	    'maskDefinitions': {
	      '9': /\d/,
	      'A': /[a-zA-Z]/,
	      '*': /[a-zA-Z0-9]/
	    },
	    'clearOnBlur': true
	  })
	  .directive('uiMask', ['uiMaskConfig', '$parse', function (maskConfig, $parse) {
	    'use strict';
	
	    return {
	      priority: 100,
	      require: 'ngModel',
	      restrict: 'A',
	      compile: function uiMaskCompilingFunction(){
	        var options = maskConfig;
	
	        return function uiMaskLinkingFunction(scope, iElement, iAttrs, controller){
	          var maskProcessed = false, eventsBound = false,
	            maskCaretMap, maskPatterns, maskPlaceholder, maskComponents,
	          // Minimum required length of the value to be considered valid
	            minRequiredLength,
	            value, valueMasked, isValid,
	          // Vars for initializing/uninitializing
	            originalPlaceholder = iAttrs.placeholder,
	            originalMaxlength = iAttrs.maxlength,
	          // Vars used exclusively in eventHandler()
	            oldValue, oldValueUnmasked, oldCaretPosition, oldSelectionLength;
	
	          function initialize(maskAttr){
	            if (!angular.isDefined(maskAttr)) {
	              return uninitialize();
	            }
	            processRawMask(maskAttr);
	            if (!maskProcessed) {
	              return uninitialize();
	            }
	            initializeElement();
	            bindEventListeners();
	            return true;
	          }
	
	          function initPlaceholder(placeholderAttr) {
	            if(! angular.isDefined(placeholderAttr)) {
	              return;
	            }
	
	            maskPlaceholder = placeholderAttr;
	
	            // If the mask is processed, then we need to update the value
	            if (maskProcessed) {
	              eventHandler();
	            }
	          }
	
	          function formatter(fromModelValue){
	            if (!maskProcessed) {
	              return fromModelValue;
	            }
	            value = unmaskValue(fromModelValue || '');
	            isValid = validateValue(value);
	            controller.$setValidity('mask', isValid);
	            return isValid && value.length ? maskValue(value) : undefined;
	          }
	
	          function parser(fromViewValue){
	            if (!maskProcessed) {
	              return fromViewValue;
	            }
	            value = unmaskValue(fromViewValue || '');
	            isValid = validateValue(value);
	            // We have to set viewValue manually as the reformatting of the input
	            // value performed by eventHandler() doesn't happen until after
	            // this parser is called, which causes what the user sees in the input
	            // to be out-of-sync with what the controller's $viewValue is set to.
	            controller.$viewValue = value.length ? maskValue(value) : '';
	            controller.$setValidity('mask', isValid);
	            if (value === '' && iAttrs.required) {
	                controller.$setValidity('required', !controller.$error.required);
	            }
	            return isValid ? value : undefined;
	          }
	
	          var linkOptions = {};
	
	          if (iAttrs.uiOptions) {
	            linkOptions = scope.$eval('[' + iAttrs.uiOptions + ']');
	            if (angular.isObject(linkOptions[0])) {
	              // we can't use angular.copy nor angular.extend, they lack the power to do a deep merge
	              linkOptions = (function(original, current){
	                for(var i in original) {
	                  if (Object.prototype.hasOwnProperty.call(original, i)) {
	                    if (current[i] === undefined) {
	                      current[i] = angular.copy(original[i]);
	                    } else {
	                      angular.extend(current[i], original[i]);
	                    }
	                  }
	                }
	                return current;
	              })(options, linkOptions[0]);
	            }
	          } else {
	            linkOptions = options;
	          }
	
	          iAttrs.$observe('uiMask', initialize);
	          iAttrs.$observe('placeholder', initPlaceholder);
	          var modelViewValue = false;
	          iAttrs.$observe('modelViewValue', function(val) {
	            if(val === 'true') {
	              modelViewValue = true;
	            }
	          });
	          scope.$watch(iAttrs.ngModel, function(val) {
	            if(modelViewValue && val) {
	              var model = $parse(iAttrs.ngModel);
	              model.assign(scope, controller.$viewValue);
	            }
	          });
	          controller.$formatters.push(formatter);
	          controller.$parsers.push(parser);
	
	          function uninitialize(){
	            maskProcessed = false;
	            unbindEventListeners();
	
	            if (angular.isDefined(originalPlaceholder)) {
	              iElement.attr('placeholder', originalPlaceholder);
	            } else {
	              iElement.removeAttr('placeholder');
	            }
	
	            if (angular.isDefined(originalMaxlength)) {
	              iElement.attr('maxlength', originalMaxlength);
	            } else {
	              iElement.removeAttr('maxlength');
	            }
	
	            iElement.val(controller.$modelValue);
	            controller.$viewValue = controller.$modelValue;
	            return false;
	          }
	
	          function initializeElement(){
	            value = oldValueUnmasked = unmaskValue(controller.$viewValue || '');
	            valueMasked = oldValue = maskValue(value);
	            isValid = validateValue(value);
	            var viewValue = isValid && value.length ? valueMasked : '';
	            if (iAttrs.maxlength) { // Double maxlength to allow pasting new val at end of mask
	              iElement.attr('maxlength', maskCaretMap[maskCaretMap.length - 1] * 2);
	            }
	            iElement.attr('placeholder', maskPlaceholder);
	            iElement.val(viewValue);
	            controller.$viewValue = viewValue;
	            // Not using $setViewValue so we don't clobber the model value and dirty the form
	            // without any kind of user interaction.
	          }
	
	          function bindEventListeners(){
	            if (eventsBound) {
	              return;
	            }
	            iElement.bind('blur', blurHandler);
	            iElement.bind('mousedown mouseup', mouseDownUpHandler);
	            iElement.bind('input keyup click focus', eventHandler);
	            eventsBound = true;
	          }
	
	          function unbindEventListeners(){
	            if (!eventsBound) {
	              return;
	            }
	            iElement.unbind('blur', blurHandler);
	            iElement.unbind('mousedown', mouseDownUpHandler);
	            iElement.unbind('mouseup', mouseDownUpHandler);
	            iElement.unbind('input', eventHandler);
	            iElement.unbind('keyup', eventHandler);
	            iElement.unbind('click', eventHandler);
	            iElement.unbind('focus', eventHandler);
	            eventsBound = false;
	          }
	
	          function validateValue(value){
	            // Zero-length value validity is ngRequired's determination
	            return value.length ? value.length >= minRequiredLength : true;
	          }
	
	          function unmaskValue(value){
	            var valueUnmasked = '',
	              maskPatternsCopy = maskPatterns.slice();
	            // Preprocess by stripping mask components from value
	            value = value.toString();
	            angular.forEach(maskComponents, function (component){
	              value = value.replace(component, '');
	            });
	            angular.forEach(value.split(''), function (chr){
	              if (maskPatternsCopy.length && maskPatternsCopy[0].test(chr)) {
	                valueUnmasked += chr;
	                maskPatternsCopy.shift();
	              }
	            });
	            return valueUnmasked;
	          }
	
	          function maskValue(unmaskedValue){
	            var valueMasked = '',
	                maskCaretMapCopy = maskCaretMap.slice();
	
	            angular.forEach(maskPlaceholder.split(''), function (chr, i){
	              if (unmaskedValue.length && i === maskCaretMapCopy[0]) {
	                valueMasked  += unmaskedValue.charAt(0) || '_';
	                unmaskedValue = unmaskedValue.substr(1);
	                maskCaretMapCopy.shift();
	              }
	              else {
	                valueMasked += chr;
	              }
	            });
	            return valueMasked;
	          }
	
	          function getPlaceholderChar(i) {
	            var placeholder = iAttrs.placeholder;
	
	            if (typeof placeholder !== 'undefined' && placeholder[i]) {
	              return placeholder[i];
	            } else {
	              return '_';
	            }
	          }
	
	          // Generate array of mask components that will be stripped from a masked value
	          // before processing to prevent mask components from being added to the unmasked value.
	          // E.g., a mask pattern of '+7 9999' won't have the 7 bleed into the unmasked value.
	          // If a maskable char is followed by a mask char and has a mask
	          // char behind it, we'll split it into it's own component so if
	          // a user is aggressively deleting in the input and a char ahead
	          // of the maskable char gets deleted, we'll still be able to strip
	          // it in the unmaskValue() preprocessing.
	          function getMaskComponents() {
	            return maskPlaceholder.replace(/[_]+/g, '_').replace(/([^_]+)([a-zA-Z0-9])([^_])/g, '$1$2_$3').split('_');
	          }
	
	          function processRawMask(mask){
	            var characterCount = 0;
	
	            maskCaretMap    = [];
	            maskPatterns    = [];
	            maskPlaceholder = '';
	
	            if (typeof mask === 'string') {
	              minRequiredLength = 0;
	
	              var isOptional = false,
	                  numberOfOptionalCharacters = 0,
	                  splitMask  = mask.split('');
	
	              angular.forEach(splitMask, function (chr, i){
	                if (linkOptions.maskDefinitions[chr]) {
	
	                  maskCaretMap.push(characterCount);
	
	                  maskPlaceholder += getPlaceholderChar(i - numberOfOptionalCharacters);
	                  maskPatterns.push(linkOptions.maskDefinitions[chr]);
	
	                  characterCount++;
	                  if (!isOptional) {
	                    minRequiredLength++;
	                  }
	                }
	                else if (chr === '?') {
	                  isOptional = true;
	                  numberOfOptionalCharacters++;
	                }
	                else {
	                  maskPlaceholder += chr;
	                  characterCount++;
	                }
	              });
	            }
	            // Caret position immediately following last position is valid.
	            maskCaretMap.push(maskCaretMap.slice().pop() + 1);
	
	            maskComponents = getMaskComponents();
	            maskProcessed  = maskCaretMap.length > 1 ? true : false;
	          }
	
	          function blurHandler(){
	            if (linkOptions.clearOnBlur) {
	              oldCaretPosition = 0;
	              oldSelectionLength = 0;
	              if (!isValid || value.length === 0) {
	                valueMasked = '';
	                iElement.val('');
	                scope.$apply(function () {
	                  controller.$setViewValue('');
	                });
	              }
	            }
	          }
	
	          function mouseDownUpHandler(e){
	            if (e.type === 'mousedown') {
	              iElement.bind('mouseout', mouseoutHandler);
	            } else {
	              iElement.unbind('mouseout', mouseoutHandler);
	            }
	          }
	
	          iElement.bind('mousedown mouseup', mouseDownUpHandler);
	
	          function mouseoutHandler(){
	            /*jshint validthis: true */
	            oldSelectionLength = getSelectionLength(this);
	            iElement.unbind('mouseout', mouseoutHandler);
	          }
	
	          function eventHandler(e){
	            /*jshint validthis: true */
	            e = e || {};
	            // Allows more efficient minification
	            var eventWhich = e.which,
	              eventType = e.type;
	
	            // Prevent shift and ctrl from mucking with old values
	            if (eventWhich === 16 || eventWhich === 91) { return;}
	
	            var val = iElement.val(),
	              valOld = oldValue,
	              valMasked,
	              valUnmasked = unmaskValue(val),
	              valUnmaskedOld = oldValueUnmasked,
	              valAltered = false,
	
	              caretPos = getCaretPosition(this) || 0,
	              caretPosOld = oldCaretPosition || 0,
	              caretPosDelta = caretPos - caretPosOld,
	              caretPosMin = maskCaretMap[0],
	              caretPosMax = maskCaretMap[valUnmasked.length] || maskCaretMap.slice().shift(),
	
	              selectionLenOld = oldSelectionLength || 0,
	              isSelected = getSelectionLength(this) > 0,
	              wasSelected = selectionLenOld > 0,
	
	            // Case: Typing a character to overwrite a selection
	              isAddition = (val.length > valOld.length) || (selectionLenOld && val.length > valOld.length - selectionLenOld),
	            // Case: Delete and backspace behave identically on a selection
	              isDeletion = (val.length < valOld.length) || (selectionLenOld && val.length === valOld.length - selectionLenOld),
	              isSelection = (eventWhich >= 37 && eventWhich <= 40) && e.shiftKey, // Arrow key codes
	
	              isKeyLeftArrow = eventWhich === 37,
	            // Necessary due to "input" event not providing a key code
	              isKeyBackspace = eventWhich === 8 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === -1)),
	              isKeyDelete = eventWhich === 46 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === 0 ) && !wasSelected),
	
	            // Handles cases where caret is moved and placed in front of invalid maskCaretMap position. Logic below
	            // ensures that, on click or leftward caret placement, caret is moved leftward until directly right of
	            // non-mask character. Also applied to click since users are (arguably) more likely to backspace
	            // a character when clicking within a filled input.
	              caretBumpBack = (isKeyLeftArrow || isKeyBackspace || eventType === 'click') && caretPos > caretPosMin;
	
	            oldSelectionLength = getSelectionLength(this);
	
	            // These events don't require any action
	            if (isSelection || (isSelected && (eventType === 'click' || eventType === 'keyup'))) {
	              return;
	            }
	
	            // Value Handling
	            // ==============
	
	            // User attempted to delete but raw value was unaffected--correct this grievous offense
	            if ((eventType === 'input') && isDeletion && !wasSelected && valUnmasked === valUnmaskedOld) {
	              while (isKeyBackspace && caretPos > caretPosMin && !isValidCaretPosition(caretPos)) {
	                caretPos--;
	              }
	              while (isKeyDelete && caretPos < caretPosMax && maskCaretMap.indexOf(caretPos) === -1) {
	                caretPos++;
	              }
	              var charIndex = maskCaretMap.indexOf(caretPos);
	              // Strip out non-mask character that user would have deleted if mask hadn't been in the way.
	              valUnmasked = valUnmasked.substring(0, charIndex) + valUnmasked.substring(charIndex + 1);
	              valAltered = true;
	            }
	
	            // Update values
	            valMasked = maskValue(valUnmasked);
	
	            oldValue = valMasked;
	            oldValueUnmasked = valUnmasked;
	            iElement.val(valMasked);
	            if (valAltered) {
	              // We've altered the raw value after it's been $digest'ed, we need to $apply the new value.
	              scope.$apply(function (){
	                controller.$setViewValue(valUnmasked);
	              });
	            }
	
	            // Caret Repositioning
	            // ===================
	
	            // Ensure that typing always places caret ahead of typed character in cases where the first char of
	            // the input is a mask char and the caret is placed at the 0 position.
	            if (isAddition && (caretPos <= caretPosMin)) {
	              caretPos = caretPosMin + 1;
	            }
	
	            if (caretBumpBack) {
	              caretPos--;
	            }
	
	            // Make sure caret is within min and max position limits
	            caretPos = caretPos > caretPosMax ? caretPosMax : caretPos < caretPosMin ? caretPosMin : caretPos;
	
	            // Scoot the caret back or forth until it's in a non-mask position and within min/max position limits
	            while (!isValidCaretPosition(caretPos) && caretPos > caretPosMin && caretPos < caretPosMax) {
	              caretPos += caretBumpBack ? -1 : 1;
	            }
	
	            if ((caretBumpBack && caretPos < caretPosMax) || (isAddition && !isValidCaretPosition(caretPosOld))) {
	              caretPos++;
	            }
	            oldCaretPosition = caretPos;
	            setCaretPosition(this, caretPos);
	          }
	
	          function isValidCaretPosition(pos){ return maskCaretMap.indexOf(pos) > -1; }
	
	          function getCaretPosition(input){
	            if (!input) return 0;
	            if (input.selectionStart !== undefined) {
	              return input.selectionStart;
	            } else if (document.selection) {
	              // Curse you IE
	              input.focus();
	              var selection = document.selection.createRange();
	              selection.moveStart('character', input.value ? -input.value.length : 0);
	              return selection.text.length;
	            }
	            return 0;
	          }
	
	          function setCaretPosition(input, pos){
	            if (!input) return 0;
	            if (input.offsetWidth === 0 || input.offsetHeight === 0) {
	              return; // Input's hidden
	            }
	            if (input.setSelectionRange) {
	              input.focus();
	              input.setSelectionRange(pos, pos);
	            }
	            else if (input.createTextRange) {
	              // Curse you IE
	              var range = input.createTextRange();
	              range.collapse(true);
	              range.moveEnd('character', pos);
	              range.moveStart('character', pos);
	              range.select();
	            }
	          }
	
	          function getSelectionLength(input){
	            if (!input) return 0;
	            if (input.selectionStart !== undefined) {
	              return (input.selectionEnd - input.selectionStart);
	            }
	            if (document.selection) {
	              return (document.selection.createRange().text.length);
	            }
	            return 0;
	          }
	
	          // https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/indexOf
	          if (!Array.prototype.indexOf) {
	            Array.prototype.indexOf = function (searchElement /*, fromIndex */){
	              if (this === null) {
	                throw new TypeError();
	              }
	              var t = Object(this);
	              var len = t.length >>> 0;
	              if (len === 0) {
	                return -1;
	              }
	              var n = 0;
	              if (arguments.length > 1) {
	                n = Number(arguments[1]);
	                if (n !== n) { // shortcut for verifying if it's NaN
	                  n = 0;
	                } else if (n !== 0 && n !== Infinity && n !== -Infinity) {
	                  n = (n > 0 || -1) * Math.floor(Math.abs(n));
	                }
	              }
	              if (n >= len) {
	                return -1;
	              }
	              var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
	              for (; k < len; k++) {
	                if (k in t && t[k] === searchElement) {
	                  return k;
	                }
	              }
	              return -1;
	            };
	          }
	
	        };
	      }
	    };
	  }
	]);
	
	/**
	 * Add a clear button to form inputs to reset their value
	 */
	angular.module('ui.reset',[]).value('uiResetConfig',null).directive('uiReset', ['uiResetConfig', function (uiResetConfig) {
	  'use strict';
	
	  var resetValue = null;
	  if (uiResetConfig !== undefined){
	      resetValue = uiResetConfig;
	  }
	  return {
	    require: 'ngModel',
	    link: function (scope, elm, attrs, ctrl) {
	      var aElement;
	      aElement = angular.element('<a class="ui-reset" />');
	      elm.wrap('<span class="ui-resetwrap" />').after(aElement);
	      aElement.bind('click', function (e) {
	        e.preventDefault();
	        scope.$apply(function () {
	          if (attrs.uiReset){
	            ctrl.$setViewValue(scope.$eval(attrs.uiReset));
	          }else{
	            ctrl.$setViewValue(resetValue);
	          }
	          ctrl.$render();
	        });
	      });
	    }
	  };
	}]);
	
	/**
	 * Set a $uiRoute boolean to see if the current route matches
	 */
	angular.module('ui.route', []).directive('uiRoute', ['$location', '$parse', function ($location, $parse) {
	  'use strict';
	
	  return {
	    restrict: 'AC',
	    scope: true,
	    compile: function(tElement, tAttrs) {
	      var useProperty;
	      if (tAttrs.uiRoute) {
	        useProperty = 'uiRoute';
	      } else if (tAttrs.ngHref) {
	        useProperty = 'ngHref';
	      } else if (tAttrs.href) {
	        useProperty = 'href';
	      } else {
	        throw new Error('uiRoute missing a route or href property on ' + tElement[0]);
	      }
	      return function ($scope, elm, attrs) {
	        var modelSetter = $parse(attrs.ngModel || attrs.routeModel || '$uiRoute').assign;
	        var watcher = angular.noop;
	
	        // Used by href and ngHref
	        function staticWatcher(newVal) {
	          var hash = newVal.indexOf('#');
	          if (hash > -1){
	            newVal = newVal.substr(hash + 1);
	          }
	          watcher = function watchHref() {
	            modelSetter($scope, ($location.path().indexOf(newVal) > -1));
	          };
	          watcher();
	        }
	        // Used by uiRoute
	        function regexWatcher(newVal) {
	          var hash = newVal.indexOf('#');
	          if (hash > -1){
	            newVal = newVal.substr(hash + 1);
	          }
	          watcher = function watchRegex() {
	            var regexp = new RegExp('^' + newVal + '$', ['i']);
	            modelSetter($scope, regexp.test($location.path()));
	          };
	          watcher();
	        }
	
	        switch (useProperty) {
	          case 'uiRoute':
	            // if uiRoute={{}} this will be undefined, otherwise it will have a value and $observe() never gets triggered
	            if (attrs.uiRoute){
	              regexWatcher(attrs.uiRoute);
	            }else{
	              attrs.$observe('uiRoute', regexWatcher);
	            }
	            break;
	          case 'ngHref':
	            // Setup watcher() every time ngHref changes
	            if (attrs.ngHref){
	              staticWatcher(attrs.ngHref);
	            }else{
	              attrs.$observe('ngHref', staticWatcher);
	            }
	            break;
	          case 'href':
	            // Setup watcher()
	            staticWatcher(attrs.href);
	        }
	
	        $scope.$on('$routeChangeSuccess', function(){
	          watcher();
	        });
	
	        //Added for compatibility with ui-router
	        $scope.$on('$stateChangeSuccess', function(){
	          watcher();
	        });
	      };
	    }
	  };
	}]);
	
	angular.module('ui.scroll.jqlite', ['ui.scroll']).service('jqLiteExtras', [
	  '$log', '$window', function(console, window) {
	    'use strict';
	
	    return {
	      registerFor: function(element) {
	        var convertToPx, css, getMeasurements, getStyle, getWidthHeight, isWindow, scrollTo;
	        css = angular.element.prototype.css;
	        element.prototype.css = function(name, value) {
	          var elem, self;
	          self = this;
	          elem = self[0];
	          if (!(!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style)) {
	            return css.call(self, name, value);
	          }
	        };
	        isWindow = function(obj) {
	          return obj && obj.document && obj.location && obj.alert && obj.setInterval;
	        };
	        scrollTo = function(self, direction, value) {
	          var elem, method, preserve, prop, _ref;
	          elem = self[0];
	          _ref = {
	            top: ['scrollTop', 'pageYOffset', 'scrollLeft'],
	            left: ['scrollLeft', 'pageXOffset', 'scrollTop']
	          }[direction], method = _ref[0], prop = _ref[1], preserve = _ref[2];
	          if (isWindow(elem)) {
	            if (angular.isDefined(value)) {
	              return elem.scrollTo(self[preserve].call(self), value);
	            } else {
	              if (prop in elem) {
	                return elem[prop];
	              } else {
	                return elem.document.documentElement[method];
	              }
	            }
	          } else {
	            if (angular.isDefined(value)) {
	              return elem[method] = value;
	            } else {
	              return elem[method];
	            }
	          }
	        };
	        if (window.getComputedStyle) {
	          getStyle = function(elem) {
	            return window.getComputedStyle(elem, null);
	          };
	          convertToPx = function(elem, value) {
	            return parseFloat(value);
	          };
	        } else {
	          getStyle = function(elem) {
	            return elem.currentStyle;
	          };
	          convertToPx = function(elem, value) {
	            var core_pnum, left, result, rnumnonpx, rs, rsLeft, style;
	            core_pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
	            rnumnonpx = new RegExp('^(' + core_pnum + ')(?!px)[a-z%]+$', 'i');
	            if (!rnumnonpx.test(value)) {
	              return parseFloat(value);
	            } else {
	              style = elem.style;
	              left = style.left;
	              rs = elem.runtimeStyle;
	              rsLeft = rs && rs.left;
	              if (rs) {
	                rs.left = style.left;
	              }
	              style.left = value;
	              result = style.pixelLeft;
	              style.left = left;
	              if (rsLeft) {
	                rs.left = rsLeft;
	              }
	              return result;
	            }
	          };
	        }
	        getMeasurements = function(elem, measure) {
	          var base, borderA, borderB, computedMarginA, computedMarginB, computedStyle, dirA, dirB, marginA, marginB, paddingA, paddingB, _ref;
	          if (isWindow(elem)) {
	            base = document.documentElement[{
	              height: 'clientHeight',
	              width: 'clientWidth'
	            }[measure]];
	            return {
	              base: base,
	              padding: 0,
	              border: 0,
	              margin: 0
	            };
	          }
	          _ref = {
	            width: [elem.offsetWidth, 'Left', 'Right'],
	            height: [elem.offsetHeight, 'Top', 'Bottom']
	          }[measure], base = _ref[0], dirA = _ref[1], dirB = _ref[2];
	          computedStyle = getStyle(elem);
	          paddingA = convertToPx(elem, computedStyle['padding' + dirA]) || 0;
	          paddingB = convertToPx(elem, computedStyle['padding' + dirB]) || 0;
	          borderA = convertToPx(elem, computedStyle['border' + dirA + 'Width']) || 0;
	          borderB = convertToPx(elem, computedStyle['border' + dirB + 'Width']) || 0;
	          computedMarginA = computedStyle['margin' + dirA];
	          computedMarginB = computedStyle['margin' + dirB];
	          marginA = convertToPx(elem, computedMarginA) || 0;
	          marginB = convertToPx(elem, computedMarginB) || 0;
	          return {
	            base: base,
	            padding: paddingA + paddingB,
	            border: borderA + borderB,
	            margin: marginA + marginB
	          };
	        };
	        getWidthHeight = function(elem, direction, measure) {
	          var computedStyle, measurements, result;
	          measurements = getMeasurements(elem, direction);
	          if (measurements.base > 0) {
	            return {
	              base: measurements.base - measurements.padding - measurements.border,
	              outer: measurements.base,
	              outerfull: measurements.base + measurements.margin
	            }[measure];
	          } else {
	            computedStyle = getStyle(elem);
	            result = computedStyle[direction];
	            if (result < 0 || result === null) {
	              result = elem.style[direction] || 0;
	            }
	            result = parseFloat(result) || 0;
	            return {
	              base: result - measurements.padding - measurements.border,
	              outer: result,
	              outerfull: result + measurements.padding + measurements.border + measurements.margin
	            }[measure];
	          }
	        };
	        return angular.forEach({
	          before: function(newElem) {
	            var children, elem, i, parent, self, _i, _ref;
	            self = this;
	            elem = self[0];
	            parent = self.parent();
	            children = parent.contents();
	            if (children[0] === elem) {
	              return parent.prepend(newElem);
	            } else {
	              for (i = _i = 1, _ref = children.length - 1; 1 <= _ref ? _i <= _ref : _i >= _ref; i = 1 <= _ref ? ++_i : --_i) {
	                if (children[i] === elem) {
	                  angular.element(children[i - 1]).after(newElem);
	                  return;
	                }
	              }
	              throw new Error('invalid DOM structure ' + elem.outerHTML);
	            }
	          },
	          height: function(value) {
	            var self;
	            self = this;
	            if (angular.isDefined(value)) {
	              if (angular.isNumber(value)) {
	                value = value + 'px';
	              }
	              return css.call(self, 'height', value);
	            } else {
	              return getWidthHeight(this[0], 'height', 'base');
	            }
	          },
	          outerHeight: function(option) {
	            return getWidthHeight(this[0], 'height', option ? 'outerfull' : 'outer');
	          },
	          /*
	          UIScroller no longer relies on jQuery method offset. The jQLite implementation of the method
	          is kept here just for the reference. Also the offset setter method was never implemented
	          */
	
	          offset: function(value) {
	            var box, doc, docElem, elem, self, win;
	            self = this;
	            if (arguments.length) {
	              if (value === void 0) {
	                return self;
	              } else {
	                throw new Error('offset setter method is not implemented');
	              }
	            }
	            box = {
	              top: 0,
	              left: 0
	            };
	            elem = self[0];
	            doc = elem && elem.ownerDocument;
	            if (!doc) {
	              return;
	            }
	            docElem = doc.documentElement;
	            if (elem.getBoundingClientRect != null) {
	              box = elem.getBoundingClientRect();
	            }
	            win = doc.defaultView || doc.parentWindow;
	            return {
	              top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	              left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0)
	            };
	          },
	          scrollTop: function(value) {
	            return scrollTo(this, 'top', value);
	          },
	          scrollLeft: function(value) {
	            return scrollTo(this, 'left', value);
	          }
	        }, function(value, key) {
	          if (!element.prototype[key]) {
	            return element.prototype[key] = value;
	          }
	        });
	      }
	    };
	  }
	]).run([
	  '$log', '$window', 'jqLiteExtras', function(console, window, jqLiteExtras) {
	    'use strict';
	
	    if (!window.jQuery) {
	      return jqLiteExtras.registerFor(angular.element);
	    }
	  }
	]);
	
	/*
	//# sourceURL=src/scripts/ui-scroll-jqlite.js
	*/
	
	
	/*
	 globals: angular, window
	
	 List of used element methods available in JQuery but not in JQuery Lite
	
	 element.before(elem)
	 element.height()
	 element.outerHeight(true)
	 element.height(value) = only for Top/Bottom padding elements
	 element.scrollTop()
	 element.scrollTop(value)
	 */
	
	angular.module('ui.scroll', []).directive('uiScrollViewport', [
	  '$log', function() {
	    'use strict';
	
	    return {
	      controller: [
	        '$scope', '$element', function(scope, element) {
	          this.viewport = element;
	          return this;
	        }
	      ]
	    };
	  }
	]).directive('uiScroll', [
	  '$log', '$injector', '$rootScope', '$timeout', function(console, $injector, $rootScope, $timeout) {
	    'use strict';
	
	    return {
	      require: ['?^uiScrollViewport'],
	      transclude: 'element',
	      priority: 1000,
	      terminal: true,
	      compile: function(elementTemplate, attr, linker) {
	        return function($scope, element, $attr, controllers) {
	          var adapter, adapterOnScope, adjustBuffer, adjustRowHeight, applyUpdate, bof, bottomVisiblePos, buffer, bufferPadding, bufferSize, builder, clipBottom, clipTop, datasource, datasourceName, doAdjustment, doDelete, doInsert, doUpdate, enqueueFetch, eof, eventListener, fetch, finalize, first, getValueChain, hideElementBeforeAppend, insert, isDatasourceValid, itemName, loading, log, match, next, pending, reload, removeFromBuffer, resizeAndScrollHandler, ridActual, scrollHeight, setValueChain, shouldLoadBottom, shouldLoadTop, showElementAfterRender, topVisible, topVisiblePos, viewport, viewportScope, wheelHandler;
	          log = console.debug || console.log;
	          match = $attr.uiScroll.match(/^\s*(\w+)\s+in\s+([\w\.]+)\s*$/);
	          if (!match) {
	            throw new Error('Expected uiScroll in form of \'_item_ in _datasource_\' but got \'' + $attr.uiScroll + '\'');
	          }
	          itemName = match[1];
	          datasourceName = match[2];
	          getValueChain = function(targetScope, target) {
	            var chain;
	            if (!targetScope) {
	              return;
	            }
	            chain = target.match(/^([\w]+)\.(.+)$/);
	            if (!chain || chain.length !== 3) {
	              return targetScope[target];
	            }
	            return getValueChain(targetScope[chain[1]], chain[2]);
	          };
	          setValueChain = function(targetScope, target, value, doNotSet) {
	            var chain;
	            if (!targetScope || !target) {
	              return;
	            }
	            if (!(chain = target.match(/^([\w]+)\.(.+)$/))) {
	              if (target.indexOf('.') !== -1) {
	                return;
	              }
	            }
	            if (!chain || chain.length !== 3) {
	              if (!angular.isObject(targetScope[target]) && !doNotSet) {
	                return targetScope[target] = value;
	              }
	              return targetScope[target] = value;
	            }
	            if (!angular.isObject(targetScope[chain[1]]) && !doNotSet) {
	              targetScope[chain[1]] = {};
	            }
	            return setValueChain(targetScope[chain[1]], chain[2], value, doNotSet);
	          };
	          datasource = getValueChain($scope, datasourceName);
	          isDatasourceValid = function() {
	            return angular.isObject(datasource) && typeof datasource.get === 'function';
	          };
	          if (!isDatasourceValid()) {
	            datasource = $injector.get(datasourceName);
	            if (!isDatasourceValid()) {
	              throw new Error('' + datasourceName + ' is not a valid datasource');
	            }
	          }
	          bufferSize = Math.max(3, +$attr.bufferSize || 10);
	          bufferPadding = function() {
	            return viewport.outerHeight() * Math.max(0.1, +$attr.padding || 0.1);
	          };
	          scrollHeight = function(elem) {
	            var _ref;
	            return (_ref = elem[0].scrollHeight) != null ? _ref : elem[0].document.documentElement.scrollHeight;
	          };
	          builder = null;
	          linker($scope.$new(), function(template) {
	            var bottomPadding, createPadding, padding, repeaterType, topPadding, viewport;
	            repeaterType = template[0].localName;
	            if (repeaterType === 'dl') {
	              throw new Error('ui-scroll directive does not support <' + template[0].localName + '> as a repeating tag: ' + template[0].outerHTML);
	            }
	            if (repeaterType !== 'li' && repeaterType !== 'tr') {
	              repeaterType = 'div';
	            }
	            viewport = controllers[0] && controllers[0].viewport ? controllers[0].viewport : angular.element(window);
	            viewport.css({
	              'overflow-y': 'auto',
	              'display': 'block'
	            });
	            padding = function(repeaterType) {
	              var div, result, table;
	              switch (repeaterType) {
	                case 'tr':
	                  table = angular.element('<table><tr><td><div></div></td></tr></table>');
	                  div = table.find('div');
	                  result = table.find('tr');
	                  result.paddingHeight = function() {
	                    return div.height.apply(div, arguments);
	                  };
	                  return result;
	                default:
	                  result = angular.element('<' + repeaterType + '></' + repeaterType + '>');
	                  result.paddingHeight = result.height;
	                  return result;
	              }
	            };
	            createPadding = function(padding, element, direction) {
	              element[{
	                top: 'before',
	                bottom: 'after'
	              }[direction]](padding);
	              return {
	                paddingHeight: function() {
	                  return padding.paddingHeight.apply(padding, arguments);
	                },
	                insert: function(element) {
	                  return padding[{
	                    top: 'after',
	                    bottom: 'before'
	                  }[direction]](element);
	                }
	              };
	            };
	            topPadding = createPadding(padding(repeaterType), element, 'top');
	            bottomPadding = createPadding(padding(repeaterType), element, 'bottom');
	            $scope.$on('$destroy', template.remove);
	            return builder = {
	              viewport: viewport,
	              topPadding: topPadding.paddingHeight,
	              bottomPadding: bottomPadding.paddingHeight,
	              append: bottomPadding.insert,
	              prepend: topPadding.insert,
	              bottomDataPos: function() {
	                return scrollHeight(viewport) - bottomPadding.paddingHeight();
	              },
	              topDataPos: function() {
	                return topPadding.paddingHeight();
	              }
	            };
	          });
	          viewport = builder.viewport;
	          viewportScope = viewport.scope() || $rootScope;
	          topVisible = function(item) {
	            adapter.topVisible = item.scope[itemName];
	            adapter.topVisibleElement = item.element;
	            adapter.topVisibleScope = item.scope;
	            if ($attr.topVisible) {
	              setValueChain(viewportScope, $attr.topVisible, adapter.topVisible);
	            }
	            if ($attr.topVisibleElement) {
	              setValueChain(viewportScope, $attr.topVisibleElement, adapter.topVisibleElement);
	            }
	            if ($attr.topVisibleScope) {
	              setValueChain(viewportScope, $attr.topVisibleScope, adapter.topVisibleScope);
	            }
	            if (typeof datasource.topVisible === 'function') {
	              return datasource.topVisible(item);
	            }
	          };
	          loading = function(value) {
	            adapter.isLoading = value;
	            if ($attr.isLoading) {
	              setValueChain($scope, $attr.isLoading, value);
	            }
	            if (typeof datasource.loading === 'function') {
	              return datasource.loading(value);
	            }
	          };
	          ridActual = 0;
	          first = 1;
	          next = 1;
	          buffer = [];
	          pending = [];
	          eof = false;
	          bof = false;
	          removeFromBuffer = function(start, stop) {
	            var i, _i;
	            for (i = _i = start; start <= stop ? _i < stop : _i > stop; i = start <= stop ? ++_i : --_i) {
	              buffer[i].scope.$destroy();
	              buffer[i].element.remove();
	            }
	            return buffer.splice(start, stop - start);
	          };
	          reload = function() {
	            ridActual++;
	            first = 1;
	            next = 1;
	            removeFromBuffer(0, buffer.length);
	            builder.topPadding(0);
	            builder.bottomPadding(0);
	            pending = [];
	            eof = false;
	            bof = false;
	            return adjustBuffer(ridActual);
	          };
	          bottomVisiblePos = function() {
	            return viewport.scrollTop() + viewport.outerHeight();
	          };
	          topVisiblePos = function() {
	            return viewport.scrollTop();
	          };
	          shouldLoadBottom = function() {
	            return !eof && builder.bottomDataPos() < bottomVisiblePos() + bufferPadding();
	          };
	          clipBottom = function() {
	            var bottomHeight, i, item, itemHeight, itemTop, newRow, overage, rowTop, _i, _ref;
	            bottomHeight = 0;
	            overage = 0;
	            for (i = _i = _ref = buffer.length - 1; _ref <= 0 ? _i <= 0 : _i >= 0; i = _ref <= 0 ? ++_i : --_i) {
	              item = buffer[i];
	              itemTop = item.element.offset().top;
	              newRow = rowTop !== itemTop;
	              rowTop = itemTop;
	              if (newRow) {
	                itemHeight = item.element.outerHeight(true);
	              }
	              if (builder.bottomDataPos() - bottomHeight - itemHeight > bottomVisiblePos() + bufferPadding()) {
	                if (newRow) {
	                  bottomHeight += itemHeight;
	                }
	                overage++;
	                eof = false;
	              } else {
	                if (newRow) {
	                  break;
	                }
	                overage++;
	              }
	            }
	            if (overage > 0) {
	              builder.bottomPadding(builder.bottomPadding() + bottomHeight);
	              removeFromBuffer(buffer.length - overage, buffer.length);
	              return next -= overage;
	            }
	          };
	          shouldLoadTop = function() {
	            return !bof && (builder.topDataPos() > topVisiblePos() - bufferPadding());
	          };
	          clipTop = function() {
	            var item, itemHeight, itemTop, newRow, overage, rowTop, topHeight, _i, _len;
	            topHeight = 0;
	            overage = 0;
	            for (_i = 0, _len = buffer.length; _i < _len; _i++) {
	              item = buffer[_i];
	              itemTop = item.element.offset().top;
	              newRow = rowTop !== itemTop;
	              rowTop = itemTop;
	              if (newRow) {
	                itemHeight = item.element.outerHeight(true);
	              }
	              if (builder.topDataPos() + topHeight + itemHeight < topVisiblePos() - bufferPadding()) {
	                if (newRow) {
	                  topHeight += itemHeight;
	                }
	                overage++;
	                bof = false;
	              } else {
	                if (newRow) {
	                  break;
	                }
	                overage++;
	              }
	            }
	            if (overage > 0) {
	              builder.topPadding(builder.topPadding() + topHeight);
	              removeFromBuffer(0, overage);
	              return first += overage;
	            }
	          };
	          enqueueFetch = function(rid, direction) {
	            if (!adapter.isLoading) {
	              loading(true);
	            }
	            if (pending.push(direction) === 1) {
	              return fetch(rid);
	            }
	          };
	          hideElementBeforeAppend = function(element) {
	            element.displayTemp = element.css('display');
	            return element.css('display', 'none');
	          };
	          showElementAfterRender = function(element) {
	            if (element.hasOwnProperty('displayTemp')) {
	              return element.css('display', element.displayTemp);
	            }
	          };
	          insert = function(index, item) {
	            var itemScope, toBeAppended, wrapper;
	            itemScope = $scope.$new();
	            itemScope[itemName] = item;
	            toBeAppended = index > first;
	            itemScope.$index = index;
	            if (toBeAppended) {
	              itemScope.$index--;
	            }
	            wrapper = {
	              scope: itemScope
	            };
	            linker(itemScope, function(clone) {
	              wrapper.element = clone;
	              if (toBeAppended) {
	                if (index === next) {
	                  hideElementBeforeAppend(clone);
	                  builder.append(clone);
	                  return buffer.push(wrapper);
	                } else {
	                  buffer[index - first].element.after(clone);
	                  return buffer.splice(index - first + 1, 0, wrapper);
	                }
	              } else {
	                hideElementBeforeAppend(clone);
	                builder.prepend(clone);
	                return buffer.unshift(wrapper);
	              }
	            });
	            return {
	              appended: toBeAppended,
	              wrapper: wrapper
	            };
	          };
	          adjustRowHeight = function(appended, wrapper) {
	            var newHeight;
	            if (appended) {
	              return builder.bottomPadding(Math.max(0, builder.bottomPadding() - wrapper.element.outerHeight(true)));
	            } else {
	              newHeight = builder.topPadding() - wrapper.element.outerHeight(true);
	              if (newHeight >= 0) {
	                return builder.topPadding(newHeight);
	              } else {
	                return viewport.scrollTop(viewport.scrollTop() + wrapper.element.outerHeight(true));
	              }
	            }
	          };
	          doAdjustment = function(rid, finalize) {
	            var item, itemHeight, itemTop, newRow, rowTop, topHeight, _i, _len, _results;
	            if (shouldLoadBottom()) {
	              enqueueFetch(rid, true);
	            } else {
	              if (shouldLoadTop()) {
	                enqueueFetch(rid, false);
	              }
	            }
	            if (finalize) {
	              finalize(rid);
	            }
	            if (pending.length === 0) {
	              topHeight = 0;
	              _results = [];
	              for (_i = 0, _len = buffer.length; _i < _len; _i++) {
	                item = buffer[_i];
	                itemTop = item.element.offset().top;
	                newRow = rowTop !== itemTop;
	                rowTop = itemTop;
	                if (newRow) {
	                  itemHeight = item.element.outerHeight(true);
	                }
	                if (newRow && (builder.topDataPos() + topHeight + itemHeight < topVisiblePos())) {
	                  _results.push(topHeight += itemHeight);
	                } else {
	                  if (newRow) {
	                    topVisible(item);
	                  }
	                  break;
	                }
	              }
	              return _results;
	            }
	          };
	          adjustBuffer = function(rid, newItems, finalize) {
	            if (newItems && newItems.length) {
	              return $timeout(function() {
	                var elt, itemTop, row, rowTop, rows, _i, _j, _len, _len1;
	                rows = [];
	                for (_i = 0, _len = newItems.length; _i < _len; _i++) {
	                  row = newItems[_i];
	                  elt = row.wrapper.element;
	                  showElementAfterRender(elt);
	                  itemTop = elt.offset().top;
	                  if (rowTop !== itemTop) {
	                    rows.push(row);
	                    rowTop = itemTop;
	                  }
	                }
	                for (_j = 0, _len1 = rows.length; _j < _len1; _j++) {
	                  row = rows[_j];
	                  adjustRowHeight(row.appended, row.wrapper);
	                }
	                return doAdjustment(rid, finalize);
	              });
	            } else {
	              return doAdjustment(rid, finalize);
	            }
	          };
	          finalize = function(rid, newItems) {
	            return adjustBuffer(rid, newItems, function() {
	              pending.shift();
	              if (pending.length === 0) {
	                return loading(false);
	              } else {
	                return fetch(rid);
	              }
	            });
	          };
	          fetch = function(rid) {
	            var direction;
	            direction = pending[0];
	            if (direction) {
	              if (buffer.length && !shouldLoadBottom()) {
	                return finalize(rid);
	              } else {
	                return datasource.get(next, bufferSize, function(result) {
	                  var item, newItems, _i, _len;
	                  if ((rid && rid !== ridActual) || $scope.$$destroyed) {
	                    return;
	                  }
	                  newItems = [];
	                  if (result.length < bufferSize) {
	                    eof = true;
	                    builder.bottomPadding(0);
	                  }
	                  if (result.length > 0) {
	                    clipTop();
	                    for (_i = 0, _len = result.length; _i < _len; _i++) {
	                      item = result[_i];
	                      newItems.push(insert(++next, item));
	                    }
	                  }
	                  return finalize(rid, newItems);
	                });
	              }
	            } else {
	              if (buffer.length && !shouldLoadTop()) {
	                return finalize(rid);
	              } else {
	                return datasource.get(first - bufferSize, bufferSize, function(result) {
	                  var i, newItems, _i, _ref;
	                  if ((rid && rid !== ridActual) || $scope.$$destroyed) {
	                    return;
	                  }
	                  newItems = [];
	                  if (result.length < bufferSize) {
	                    bof = true;
	                    builder.topPadding(0);
	                  }
	                  if (result.length > 0) {
	                    if (buffer.length) {
	                      clipBottom();
	                    }
	                    for (i = _i = _ref = result.length - 1; _ref <= 0 ? _i <= 0 : _i >= 0; i = _ref <= 0 ? ++_i : --_i) {
	                      newItems.unshift(insert(--first, result[i]));
	                    }
	                  }
	                  return finalize(rid, newItems);
	                });
	              }
	            }
	          };
	          resizeAndScrollHandler = function() {
	            if (!$rootScope.$$phase && !adapter.isLoading) {
	              adjustBuffer();
	              return $scope.$apply();
	            }
	          };
	          wheelHandler = function(event) {
	            var scrollTop, yMax;
	            scrollTop = viewport[0].scrollTop;
	            yMax = viewport[0].scrollHeight - viewport[0].clientHeight;
	            if ((scrollTop === 0 && !bof) || (scrollTop === yMax && !eof)) {
	              return event.preventDefault();
	            }
	          };
	          viewport.bind('resize', resizeAndScrollHandler);
	          viewport.bind('scroll', resizeAndScrollHandler);
	          viewport.bind('mousewheel', wheelHandler);
	          $scope.$watch(datasource.revision, reload);
	          if (datasource.scope) {
	            eventListener = datasource.scope.$new();
	          } else {
	            eventListener = $scope.$new();
	          }
	          $scope.$on('$destroy', function() {
	            var item, _i, _len;
	            for (_i = 0, _len = buffer.length; _i < _len; _i++) {
	              item = buffer[_i];
	              item.scope.$destroy();
	              item.element.remove();
	            }
	            viewport.unbind('resize', resizeAndScrollHandler);
	            viewport.unbind('scroll', resizeAndScrollHandler);
	            return viewport.unbind('mousewheel', wheelHandler);
	          });
	          adapter = {};
	          adapter.isLoading = false;
	          applyUpdate = function(wrapper, newItems) {
	            var i, inserted, item, ndx, newItem, oldItemNdx, _i, _j, _k, _len, _len1, _len2;
	            inserted = [];
	            if (angular.isArray(newItems)) {
	              if (newItems.length) {
	                if (newItems.length === 1 && newItems[0] === wrapper.scope[itemName]) {
	                  return inserted;
	                } else {
	                  ndx = wrapper.scope.$index;
	                  if (ndx > first) {
	                    oldItemNdx = ndx - first;
	                  } else {
	                    oldItemNdx = 1;
	                  }
	                  for (i = _i = 0, _len = newItems.length; _i < _len; i = ++_i) {
	                    newItem = newItems[i];
	                    inserted.push(insert(ndx + i, newItem));
	                  }
	                  removeFromBuffer(oldItemNdx, oldItemNdx + 1);
	                  for (i = _j = 0, _len1 = buffer.length; _j < _len1; i = ++_j) {
	                    item = buffer[i];
	                    item.scope.$index = first + i;
	                  }
	                }
	              } else {
	                removeFromBuffer(wrapper.scope.$index - first, wrapper.scope.$index - first + 1);
	                next--;
	                for (i = _k = 0, _len2 = buffer.length; _k < _len2; i = ++_k) {
	                  item = buffer[i];
	                  item.scope.$index = first + i;
	                }
	              }
	            }
	            return inserted;
	          };
	          adapter.applyUpdates = function(arg1, arg2) {
	            var inserted, wrapper, _i, _len, _ref, _ref1;
	            inserted = [];
	            ridActual++;
	            if (angular.isFunction(arg1)) {
	              _ref = buffer.slice(0);
	              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	                wrapper = _ref[_i];
	                inserted.concat(inserted, applyUpdate(wrapper, arg1(wrapper.scope[itemName], wrapper.scope, wrapper.element)));
	              }
	            } else {
	              if (arg1 % 1 === 0) {
	                if ((0 <= (_ref1 = arg1 - first - 1) && _ref1 < buffer.length)) {
	                  inserted = applyUpdate(buffer[arg1 - first], arg2);
	                }
	              } else {
	                throw new Error('applyUpdates - ' + arg1 + ' is not a valid index or outside of range');
	              }
	            }
	            return adjustBuffer(ridActual, inserted);
	          };
	          if ($attr.adapter) {
	            adapterOnScope = getValueChain($scope, $attr.adapter);
	            if (!adapterOnScope) {
	              setValueChain($scope, $attr.adapter, {});
	              adapterOnScope = getValueChain($scope, $attr.adapter);
	            }
	            angular.extend(adapterOnScope, adapter);
	            adapter = adapterOnScope;
	          }
	          doUpdate = function(locator, newItem) {
	            var wrapper, _fn, _i, _len, _ref;
	            if (angular.isFunction(locator)) {
	              _fn = function(wrapper) {
	                return locator(wrapper.scope);
	              };
	              for (_i = 0, _len = buffer.length; _i < _len; _i++) {
	                wrapper = buffer[_i];
	                _fn(wrapper);
	              }
	            } else {
	              if ((0 <= (_ref = locator - first - 1) && _ref < buffer.length)) {
	                buffer[locator - first - 1].scope[itemName] = newItem;
	              }
	            }
	            return null;
	          };
	          doDelete = function(locator) {
	            var i, item, temp, wrapper, _fn, _i, _j, _k, _len, _len1, _len2, _ref;
	            if (angular.isFunction(locator)) {
	              temp = [];
	              for (_i = 0, _len = buffer.length; _i < _len; _i++) {
	                item = buffer[_i];
	                temp.unshift(item);
	              }
	              _fn = function(wrapper) {
	                if (locator(wrapper.scope)) {
	                  removeFromBuffer(temp.length - 1 - i, temp.length - i);
	                  return next--;
	                }
	              };
	              for (i = _j = 0, _len1 = temp.length; _j < _len1; i = ++_j) {
	                wrapper = temp[i];
	                _fn(wrapper);
	              }
	            } else {
	              if ((0 <= (_ref = locator - first - 1) && _ref < buffer.length)) {
	                removeFromBuffer(locator - first - 1, locator - first);
	                next--;
	              }
	            }
	            for (i = _k = 0, _len2 = buffer.length; _k < _len2; i = ++_k) {
	              item = buffer[i];
	              item.scope.$index = first + i;
	            }
	            return adjustBuffer();
	          };
	          doInsert = function(locator, item) {
	            var i, inserted, _i, _len, _ref;
	            inserted = [];
	            if (angular.isFunction(locator)) {
	              throw new Error('not implemented - Insert with locator function');
	            } else {
	              if ((0 <= (_ref = locator - first - 1) && _ref < buffer.length)) {
	                inserted.push(insert(locator, item));
	                next++;
	              }
	            }
	            for (i = _i = 0, _len = buffer.length; _i < _len; i = ++_i) {
	              item = buffer[i];
	              item.scope.$index = first + i;
	            }
	            return adjustBuffer(null, inserted);
	          };
	          eventListener.$on('insert.item', function(event, locator, item) {
	            return doInsert(locator, item);
	          });
	          eventListener.$on('update.items', function(event, locator, newItem) {
	            return doUpdate(locator, newItem);
	          });
	          return eventListener.$on('delete.items', function(event, locator) {
	            return doDelete(locator);
	          });
	        };
	      }
	    };
	  }
	]);
	
	/*
	//# sourceURL=src/scripts/ui-scroll.js
	*/
	
	
	/**
	 * Adds a 'ui-scrollfix' class to the element when the page scrolls past it's position.
	 * @param [offset] {int} optional Y-offset to override the detected offset.
	 *   Takes 300 (absolute) or -300 or +300 (relative to detected)
	 */
	angular.module('ui.scrollfix',[]).directive('uiScrollfix', ['$window', function ($window) {
	  'use strict';
	
	  function getWindowScrollTop() {
	    if (angular.isDefined($window.pageYOffset)) {
	      return $window.pageYOffset;
	    } else {
	      var iebody = (document.compatMode && document.compatMode !== 'BackCompat') ? document.documentElement : document.body;
	      return iebody.scrollTop;
	    }
	  }
	  return {
	    require: '^?uiScrollfixTarget',
	    link: function (scope, elm, attrs, uiScrollfixTarget) {
	      var absolute = true,
	          shift = 0,
	          fixLimit,
	          $target = uiScrollfixTarget && uiScrollfixTarget.$element || angular.element($window);
	
	      if (!attrs.uiScrollfix) {
	          absolute = false;
	      } else if (typeof(attrs.uiScrollfix) === 'string') {
	        // charAt is generally faster than indexOf: http://jsperf.com/indexof-vs-charat
	        if (attrs.uiScrollfix.charAt(0) === '-') {
	          absolute = false;
	          shift = - parseFloat(attrs.uiScrollfix.substr(1));
	        } else if (attrs.uiScrollfix.charAt(0) === '+') {
	          absolute = false;
	          shift = parseFloat(attrs.uiScrollfix.substr(1));
	        }
	      }
	
	      fixLimit = absolute ? attrs.uiScrollfix : elm[0].offsetTop + shift;
	
	      function onScroll() {
	
	        var limit = absolute ? attrs.uiScrollfix : elm[0].offsetTop + shift;
	
	        // if pageYOffset is defined use it, otherwise use other crap for IE
	        var offset = uiScrollfixTarget ? $target[0].scrollTop : getWindowScrollTop();
	        if (!elm.hasClass('ui-scrollfix') && offset > limit) {
	          elm.addClass('ui-scrollfix');
	          fixLimit = limit;
	        } else if (elm.hasClass('ui-scrollfix') && offset < fixLimit) {
	          elm.removeClass('ui-scrollfix');
	        }
	      }
	
	      $target.on('scroll', onScroll);
	
	      // Unbind scroll event handler when directive is removed
	      scope.$on('$destroy', function() {
	        $target.off('scroll', onScroll);
	      });
	    }
	  };
	}]).directive('uiScrollfixTarget', [function () {
	  'use strict';
	  return {
	    controller: ['$element', function($element) {
	      this.$element = $element;
	    }]
	  };
	}]);
	
	/**
	 * uiShow Directive
	 *
	 * Adds a 'ui-show' class to the element instead of display:block
	 * Created to allow tighter control  of CSS without bulkier directives
	 *
	 * @param expression {boolean} evaluated expression to determine if the class should be added
	 */
	angular.module('ui.showhide',[])
	.directive('uiShow', [function () {
	  'use strict';
	
	  return function (scope, elm, attrs) {
	    scope.$watch(attrs.uiShow, function (newVal) {
	      if (newVal) {
	        elm.addClass('ui-show');
	      } else {
	        elm.removeClass('ui-show');
	      }
	    });
	  };
	}])
	
	/**
	 * uiHide Directive
	 *
	 * Adds a 'ui-hide' class to the element instead of display:block
	 * Created to allow tighter control  of CSS without bulkier directives
	 *
	 * @param expression {boolean} evaluated expression to determine if the class should be added
	 */
	.directive('uiHide', [function () {
	  'use strict';
	
	  return function (scope, elm, attrs) {
	    scope.$watch(attrs.uiHide, function (newVal) {
	      if (newVal) {
	        elm.addClass('ui-hide');
	      } else {
	        elm.removeClass('ui-hide');
	      }
	    });
	  };
	}])
	
	/**
	 * uiToggle Directive
	 *
	 * Adds a class 'ui-show' if true, and a 'ui-hide' if false to the element instead of display:block/display:none
	 * Created to allow tighter control  of CSS without bulkier directives. This also allows you to override the
	 * default visibility of the element using either class.
	 *
	 * @param expression {boolean} evaluated expression to determine if the class should be added
	 */
	.directive('uiToggle', [function () {
	  'use strict';
	
	  return function (scope, elm, attrs) {
	    scope.$watch(attrs.uiToggle, function (newVal) {
	      if (newVal) {
	        elm.removeClass('ui-hide').addClass('ui-show');
	      } else {
	        elm.removeClass('ui-show').addClass('ui-hide');
	      }
	    });
	  };
	}]);
	
	/**
	 * Filters out all duplicate items from an array by checking the specified key
	 * @param [key] {string} the name of the attribute of each object to compare for uniqueness
	 if the key is empty, the entire object will be compared
	 if the key === false then no filtering will be performed
	 * @return {array}
	 */
	angular.module('ui.unique',[]).filter('unique', ['$parse', function ($parse) {
	  'use strict';
	
	  return function (items, filterOn) {
	
	    if (filterOn === false) {
	      return items;
	    }
	
	    if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
	      var newItems = [],
	        get = angular.isString(filterOn) ? $parse(filterOn) : function (item) { return item; };
	
	      var extractValueToCompare = function (item) {
	        return angular.isObject(item) ? get(item) : item;
	      };
	
	      angular.forEach(items, function (item) {
	        var isDuplicate = false;
	
	        for (var i = 0; i < newItems.length; i++) {
	          if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
	            isDuplicate = true;
	            break;
	          }
	        }
	        if (!isDuplicate) {
	          newItems.push(item);
	        }
	
	      });
	      items = newItems;
	    }
	    return items;
	  };
	}]);
	
	/*
	 * Author: Remy Alain Ticona Carbajal http://realtica.org
	 * Description: The main objective of ng-uploader is to have a user control,
	 * clean, simple, customizable, and above all very easy to implement.
	 * Licence: MIT
	 */
	
	angular.module('ui.uploader', []).service('uiUploader', uiUploader);
	
	uiUploader.$inject = ['$log'];
	
	function uiUploader($log) {
	    'use strict';
	
	    /*jshint validthis: true */
	    var self = this;
	    self.files = [];
	    self.options = {};
	    self.activeUploads = 0;
	    $log.info('uiUploader loaded');
	    
	    function addFiles(files) {
	        for (var i = 0; i < files.length; i++) {
	            self.files.push(files[i]);
	        }
	    }
	
	    function getFiles() {
	        return self.files;
	    }
	
	    function startUpload(options) {
	        self.options = options;
	        for (var i = 0; i < self.files.length; i++) {
	            if (self.activeUploads == self.options.concurrency) {
	                break;
	            }
	            if (self.files[i].active)
	                continue;
	            ajaxUpload(self.files[i], self.options.url);
	        }
	    }
	    
	    function removeFile(file){
	        self.files.splice(self.files.indexOf(file),1);
	    }
	    
	    function removeAll(){
	        self.files.splice(0,self.files.length);
	    }
	    
	    return {
	        addFiles: addFiles,
	        getFiles: getFiles,
	        files: self.files,
	        startUpload: startUpload,
	        removeFile: removeFile,
	        removeAll:removeAll
	    };
	    
	    function getHumanSize(bytes) {
	        var sizes = ['n/a', 'bytes', 'KiB', 'MiB', 'GiB', 'TB', 'PB', 'EiB', 'ZiB', 'YiB'];
	        var i = +Math.floor(Math.log(bytes) / Math.log(1024));
	        return (bytes / Math.pow(1024, i)).toFixed(i ? 1 : 0) + ' ' + sizes[isNaN(bytes) ? 0 : i + 1];
	    }
	
	    function ajaxUpload(file, url) {
	        var xhr, formData, prop, data = '',
	            key = '' || 'file';
	        self.activeUploads += 1;
	        file.active = true;
	        xhr = new window.XMLHttpRequest();
	        formData = new window.FormData();
	        xhr.open('POST', url);
	
	        // Triggered when upload starts:
	        xhr.upload.onloadstart = function() {};
	
	        // Triggered many times during upload:
	        xhr.upload.onprogress = function(event) {
	            if (!event.lengthComputable) {
	                return;
	            }
	            // Update file size because it might be bigger than reported by
	            // the fileSize:
	            //$log.info("progres..");
	            //console.info(event.loaded);
	            file.loaded = event.loaded;
	            file.humanSize = getHumanSize(event.loaded);
	            self.options.onProgress(file);
	        };
	
	        // Triggered when upload is completed:
	        xhr.onload = function() {
	            self.activeUploads -= 1;
	            startUpload(self.options);
	            self.options.onCompleted(file, xhr.responseText);
	        };
	
	        // Triggered when upload fails:
	        xhr.onerror = function() {};
	
	        // Append additional data if provided:
	        if (data) {
	            for (prop in data) {
	                if (data.hasOwnProperty(prop)) {
	                    formData.append(prop, data[prop]);
	                }
	            }
	        }
	
	        // Append file data:
	        formData.append(key, file, file.name);
	
	        // Initiate upload:
	        xhr.send(formData);
	
	        return xhr;
	    }
	
	}
	
	/**
	 * General-purpose validator for ngModel.
	 * angular.js comes with several built-in validation mechanism for input fields (ngRequired, ngPattern etc.) but using
	 * an arbitrary validation function requires creation of a custom formatters and / or parsers.
	 * The ui-validate directive makes it easy to use any function(s) defined in scope as a validator function(s).
	 * A validator function will trigger validation on both model and input changes.
	 *
	 * @example <input ui-validate=" 'myValidatorFunction($value)' ">
	 * @example <input ui-validate="{ foo : '$value > anotherModel', bar : 'validateFoo($value)' }">
	 * @example <input ui-validate="{ foo : '$value > anotherModel' }" ui-validate-watch=" 'anotherModel' ">
	 * @example <input ui-validate="{ foo : '$value > anotherModel', bar : 'validateFoo($value)' }" ui-validate-watch=" { foo : 'anotherModel' } ">
	 *
	 * @param ui-validate {string|object literal} If strings is passed it should be a scope's function to be used as a validator.
	 * If an object literal is passed a key denotes a validation error key while a value should be a validator function.
	 * In both cases validator function should take a value to validate as its argument and should return true/false indicating a validation result.
	 */
	angular.module('ui.validate',[]).directive('uiValidate', function () {
	  'use strict';
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function (scope, elm, attrs, ctrl) {
	      var validateFn, validators = {},
	          validateExpr = scope.$eval(attrs.uiValidate);
	
	      if (!validateExpr){ return;}
	
	      if (angular.isString(validateExpr)) {
	        validateExpr = { validator: validateExpr };
	      }
	
	      angular.forEach(validateExpr, function (exprssn, key) {
	        validateFn = function (valueToValidate) {
	          var expression = scope.$eval(exprssn, { '$value' : valueToValidate });
	          if (angular.isObject(expression) && angular.isFunction(expression.then)) {
	            // expression is a promise
	            expression.then(function(){
	              ctrl.$setValidity(key, true);
	            }, function(){
	              ctrl.$setValidity(key, false);
	            });
	            return valueToValidate;
	          } else if (expression) {
	            // expression is true
	            ctrl.$setValidity(key, true);
	            return valueToValidate;
	          } else {
	            // expression is false
	            ctrl.$setValidity(key, false);
	            return valueToValidate;
	          }
	        };
	        validators[key] = validateFn;
	        ctrl.$formatters.push(validateFn);
	        ctrl.$parsers.push(validateFn);
	      });
	
	      function apply_watch(watch)
	      {
	          //string - update all validators on expression change
	          if (angular.isString(watch))
	          {
	              scope.$watch(watch, function(){
	                  angular.forEach(validators, function(validatorFn){
	                      validatorFn(ctrl.$modelValue);
	                  });
	              });
	              return;
	          }
	
	          //array - update all validators on change of any expression
	          if (angular.isArray(watch))
	          {
	              angular.forEach(watch, function(expression){
	                  scope.$watch(expression, function()
	                  {
	                      angular.forEach(validators, function(validatorFn){
	                          validatorFn(ctrl.$modelValue);
	                      });
	                  });
	              });
	              return;
	          }
	
	          //object - update appropriate validator
	          if (angular.isObject(watch))
	          {
	              angular.forEach(watch, function(expression, validatorKey)
	              {
	                  //value is string - look after one expression
	                  if (angular.isString(expression))
	                  {
	                      scope.$watch(expression, function(){
	                          validators[validatorKey](ctrl.$modelValue);
	                      });
	                  }
	
	                  //value is array - look after all expressions in array
	                  if (angular.isArray(expression))
	                  {
	                      angular.forEach(expression, function(intExpression)
	                      {
	                          scope.$watch(intExpression, function(){
	                              validators[validatorKey](ctrl.$modelValue);
	                          });
	                      });
	                  }
	              });
	          }
	      }
	      // Support for ui-validate-watch
	      if (attrs.uiValidateWatch){
	          apply_watch( scope.$eval(attrs.uiValidateWatch) );
	      }
	    }
	  };
	});
	
	angular.module('ui.utils',  [
	  'ui.event',
	  'ui.format',
	  'ui.highlight',
	  'ui.include',
	  'ui.indeterminate',
	  'ui.inflector',
	  'ui.jq',
	  'ui.keypress',
	  'ui.mask',
	  'ui.reset',
	  'ui.route',
	  'ui.scrollfix',
	  'ui.scroll',
	  'ui.scroll.jqlite',
	  'ui.showhide',
	  'ui.unique',
	  'ui.validate'
	]);


/***/ }),

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1025);

/***/ }),

/***/ 1025:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  'use strict';
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1026)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (root.hasOwnProperty('angular')) {
	    // Browser globals (root is window), we don't register it.
	    factory(root.angular);
	  } else if (typeof exports === 'object') {
	    module.exports = factory(require('angular'));
	  }
	}(this , function (angular) {
	    'use strict';
	
	    // In cases where Angular does not get passed or angular is a truthy value
	    // but misses .module we can fall back to using window.
	    angular = (angular && angular.module ) ? angular : window.angular;
	
	
	    function isStorageSupported($window, storageType) {
	
	      // Some installations of IE, for an unknown reason, throw "SCRIPT5: Error: Access is denied"
	      // when accessing window.localStorage. This happens before you try to do anything with it. Catch
	      // that error and allow execution to continue.
	
	      // fix 'SecurityError: DOM Exception 18' exception in Desktop Safari, Mobile Safari
	      // when "Block cookies": "Always block" is turned on
	      var supported;
	      try {
	        supported = $window[storageType];
	      }
	      catch(err) {
	        supported = false;
	      }
	
	      // When Safari (OS X or iOS) is in private browsing mode, it appears as though localStorage and sessionStorage
	      // is available, but trying to call .setItem throws an exception below:
	      // "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to add something to storage that exceeded the quota."
	      if(supported) {
	        var key = '__' + Math.round(Math.random() * 1e7);
	        try {
	          $window[storageType].setItem(key, key);
	          $window[storageType].removeItem(key, key);
	        }
	        catch(err) {
	          supported = false;
	        }
	      }
	
	      return supported;
	    }
	
	    /**
	     * @ngdoc overview
	     * @name ngStorage
	     */
	
	    return angular.module('ngStorage', [])
	
	    /**
	     * @ngdoc object
	     * @name ngStorage.$localStorage
	     * @requires $rootScope
	     * @requires $window
	     */
	
	    .provider('$localStorage', _storageProvider('localStorage'))
	
	    /**
	     * @ngdoc object
	     * @name ngStorage.$sessionStorage
	     * @requires $rootScope
	     * @requires $window
	     */
	
	    .provider('$sessionStorage', _storageProvider('sessionStorage'));
	
	    function _storageProvider(storageType) {
	        var providerWebStorage = isStorageSupported(window, storageType);
	
	        return function () {
	          var storageKeyPrefix = 'ngStorage-';
	
	          this.setKeyPrefix = function (prefix) {
	            if (typeof prefix !== 'string') {
	              throw new TypeError('[ngStorage] - ' + storageType + 'Provider.setKeyPrefix() expects a String.');
	            }
	            storageKeyPrefix = prefix;
	          };
	
	          var serializer = angular.toJson;
	          var deserializer = angular.fromJson;
	
	          this.setSerializer = function (s) {
	            if (typeof s !== 'function') {
	              throw new TypeError('[ngStorage] - ' + storageType + 'Provider.setSerializer expects a function.');
	            }
	
	            serializer = s;
	          };
	
	          this.setDeserializer = function (d) {
	            if (typeof d !== 'function') {
	              throw new TypeError('[ngStorage] - ' + storageType + 'Provider.setDeserializer expects a function.');
	            }
	
	            deserializer = d;
	          };
	
	          this.supported = function() {
	            return !!providerWebStorage;
	          };
	
	          // Note: This is not very elegant at all.
	          this.get = function (key) {
	            return providerWebStorage && deserializer(providerWebStorage.getItem(storageKeyPrefix + key));
	          };
	
	          // Note: This is not very elegant at all.
	          this.set = function (key, value) {
	            return providerWebStorage && providerWebStorage.setItem(storageKeyPrefix + key, serializer(value));
	          };
	
	          this.remove = function (key) {
	            providerWebStorage && providerWebStorage.removeItem(storageKeyPrefix + key);
	          }
	
	          this.$get = [
	              '$rootScope',
	              '$window',
	              '$log',
	              '$timeout',
	              '$document',
	
	              function(
	                  $rootScope,
	                  $window,
	                  $log,
	                  $timeout,
	                  $document
	              ){
	
	                // The magic number 10 is used which only works for some keyPrefixes...
	                // See https://github.com/gsklee/ngStorage/issues/137
	                var prefixLength = storageKeyPrefix.length;
	
	                // #9: Assign a placeholder object if Web Storage is unavailable to prevent breaking the entire AngularJS app
	                // Note: recheck mainly for testing (so we can use $window[storageType] rather than window[storageType])
	                var isSupported = isStorageSupported($window, storageType),
	                    webStorage = isSupported || ($log.warn('This browser does not support Web Storage!'), {setItem: angular.noop, getItem: angular.noop, removeItem: angular.noop}),
	                    $storage = {
	                        $default: function(items) {
	                            for (var k in items) {
	                                angular.isDefined($storage[k]) || ($storage[k] = angular.copy(items[k]) );
	                            }
	
	                            $storage.$sync();
	                            return $storage;
	                        },
	                        $reset: function(items) {
	                            for (var k in $storage) {
	                                '$' === k[0] || (delete $storage[k] && webStorage.removeItem(storageKeyPrefix + k));
	                            }
	
	                            return $storage.$default(items);
	                        },
	                        $sync: function () {
	                            for (var i = 0, l = webStorage.length, k; i < l; i++) {
	                                // #8, #10: `webStorage.key(i)` may be an empty string (or throw an exception in IE9 if `webStorage` is empty)
	                                (k = webStorage.key(i)) && storageKeyPrefix === k.slice(0, prefixLength) && ($storage[k.slice(prefixLength)] = deserializer(webStorage.getItem(k)));
	                            }
	                        },
	                        $apply: function() {
	                            var temp$storage;
	
	                            _debounce = null;
	
	                            if (!angular.equals($storage, _last$storage)) {
	                                temp$storage = angular.copy(_last$storage);
	                                angular.forEach($storage, function(v, k) {
	                                    if (angular.isDefined(v) && '$' !== k[0]) {
	                                        webStorage.setItem(storageKeyPrefix + k, serializer(v));
	                                        delete temp$storage[k];
	                                    }
	                                });
	
	                                for (var k in temp$storage) {
	                                    webStorage.removeItem(storageKeyPrefix + k);
	                                }
	
	                                _last$storage = angular.copy($storage);
	                            }
	                        },
	                        $supported: function() {
	                            return !!isSupported;
	                        }
	                    },
	                    _last$storage,
	                    _debounce;
	
	                $storage.$sync();
	
	                _last$storage = angular.copy($storage);
	
	                $rootScope.$watch(function() {
	                    _debounce || (_debounce = $timeout($storage.$apply, 100, false));
	                });
	
	                // #6: Use `$window.addEventListener` instead of `angular.element` to avoid the jQuery-specific `event.originalEvent`
	                $window.addEventListener && $window.addEventListener('storage', function(event) {
	                    if (!event.key) {
	                      return;
	                    }
	
	                    // Reference doc.
	                    var doc = $document[0];
	
	                    if ( (!doc.hasFocus || !doc.hasFocus()) && storageKeyPrefix === event.key.slice(0, prefixLength) ) {
	                        event.newValue ? $storage[event.key.slice(prefixLength)] = deserializer(event.newValue) : delete $storage[event.key.slice(prefixLength)];
	
	                        _last$storage = angular.copy($storage);
	
	                        $rootScope.$apply();
	                    }
	                });
	
	                $window.addEventListener && $window.addEventListener('beforeunload', function() {
	                    $storage.$apply();
	                });
	
	                return $storage;
	              }
	          ];
	      };
	    }
	
	}));


/***/ }),

/***/ 1026:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1027);

/***/ }),

/***/ 1027:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.11
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * Angular. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	  return function() {
	    var SKIP_INDEXES = 2;
	
	    var templateArgs = arguments,
	      code = templateArgs[0],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      template = templateArgs[1],
	      paramPrefix, i;
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1),
	        shiftedIndex = index + SKIP_INDEXES;
	
	      if (shiftedIndex < templateArgs.length) {
	        return toDebugString(templateArgs[shiftedIndex]);
	      }
	
	      return match;
	    });
	
	    message += '\nhttp://errors.angularjs.org/1.5.11/' +
	      (module ? module + '/' : '') + code;
	
	    for (i = SKIP_INDEXES, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	      message += paramPrefix + 'p' + (i - SKIP_INDEXES) + '=' +
	        encodeURIComponent(toDebugString(templateArgs[i]));
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell ESLint what variables are being exported */
	/* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  manualLowercase,
	  manualUppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * # ng (core module)
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 * <div doc-module-components="ng"></div>
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var manualLowercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	  /* eslint-enable */
	};
	var manualUppercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	  /* eslint-enable */
	};
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
	if ('i' !== 'I'.toLowerCase()) {
	  lowercase = manualLowercase;
	  uppercase = manualUppercase;
	}
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = 'length' in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) &&
	    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item === 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        // Need to check if hasOwnProperty exists,
	        // as on IE8 the result of querySelectorAll is an object without a hasOwnProperty function
	        if (key !== 'prototype' && key !== 'length' && key !== 'name' && (!obj.hasOwnProperty || obj.hasOwnProperty(key))) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	          baseExtend(dst[key], [src], true);
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
	  // eslint-disable-next-line no-self-compare
	  return num !== num;
	};
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`. Alias of Array.isArray.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	var isArray = Array.isArray;
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s
	    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
	    // eslint-disable-next-line no-control-regex
	    .replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) !== -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>master = {{master | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.master = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.master);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.master);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination) {
	  var stackSource = [];
	  var stackDest = [];
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination);
	  }
	
	  return copyElement(source);
	
	  function copyRecurse(source, destination) {
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i]));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key]);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key]);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key]);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        // Support: IE10
	        if (!source.slice) {
	          // If we're in this case we know the environment supports ArrayBuffer
	          /* eslint-disable no-undef */
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          /* eslint-enable */
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  // eslint-disable-next-line no-self-compare
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 === t2 && t1 === 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) === o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return equals(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() === o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      // eslint-disable-next-line no-new, no-new-func
	      new Function('');
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since angular looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
	    if (el) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since angular uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone();
	  try {
	    // turns out IE does not let you set .html() on elements which
	    // are not allowed to have children. So we just ignore it.
	    element.empty();
	  } catch (e) { /* empty */ }
	  var elemHtml = jqLite('<div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || '').split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query       = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	function allowAutoBootstrap(document) {
	  var script = document.currentScript;
	  var src = script && script.getAttribute('src');
	
	  if (!src) {
	    return true;
	  }
	
	  var link = document.createElement('a');
	  link.href = src;
	
	  if (document.location.origin === link.origin) {
	    // Same-origin resources are always allowed, even for non-whitelisted schemes.
	    return true;
	  }
	  // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	  // This is to prevent angular.js bundled with browser extensions from being used to bypass the
	  // content security policy in web pages and other browser extensions.
	  switch (link.protocol) {
	    case 'http:':
	    case 'https:':
	    case 'ftp:':
	    case 'blob:':
	    case 'file:':
	    case 'data:':
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    if (!isAutoBootstrapAllowed) {
	      window.console.error('Angular: disabling automatic bootstrap. <script> protocol indicates ' +
	          'an extension, document.location.href does not match.');
	      return;
	    }
	    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up angular application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * Angular will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of Angular try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          'App already bootstrapped with this element \'{0}\'',
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of Angular on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: JQLitePrototype.controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	
	    // All nodes removed from the DOM via various jQuery APIs like .remove()
	    // are passed through jQuery.cleanData. Monkey-patch this method to fire
	    // the $destroy event on all removed nodes.
	    originalCleanData = jQuery.cleanData;
	    jQuery.cleanData = function(elems) {
	      var events;
	      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	        events = jQuery._data(elem, 'events');
	        if (events && events.$destroy) {
	          jQuery(elem).triggerHandler('$destroy');
	        }
	      }
	      originalCleanData(elems);
	    };
	  } else {
	    jqLite = JQLite;
	  }
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring angular {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving Angular
	     * modules.
	     * All modules (angular core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
	             'the module name or forgot to load it. If registering a module ensure that you ' +
	             'specify the dependencies as the second argument.', name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid angular expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to register work which needs to be performed on module loading.
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method) {
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            invokeQueue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* global toDebugString: true */
	
	function serializeObject(obj) {
	  var seen = [];
	
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $$HashMapProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  // These placeholder strings will be replaced by grunt's `build` task.
	  // They need to be double- or single-quoted.
	  full: '1.5.11',
	  major: 1,
	  minor: 5,
	  dot: 11,
	  codeName: 'princely-quest'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'lowercase': lowercase,
	    'uppercase': uppercase,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    'reloadWithDebugInfo': reloadWithDebugInfo
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$HashMap: $$HashMapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ]);
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global JQLitePrototype: true,
	  addEventListenerFn: true,
	  removeEventListenerFn: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## Angular's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * Angular also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1,
	    addEventListenerFn = function(element, type, fn) {
	      element.addEventListener(type, fn, false);
	    },
	    removeEventListenerFn = function(element, type, fn) {
	      element.removeEventListener(type, fn, false);
	    };
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;
	var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts snake_case to camelCase.
	 * Also there is special case for Moz prefix starting with upper case letter.
	 * @param name Name to normalize
	 */
	function camelCase(name) {
	  return name.
	    replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    }).
	    replace(MOZ_HACK_REGEXP, 'Moz$1');
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, '', '']
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteCleanData(nodes) {
	  for (var i = 0, ii = nodes.length; i < ii; i++) {
	    jqLiteRemoveData(nodes[i]);
	  }
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement('div'));
	    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = '';
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = '';
	  fragment.innerHTML = ''; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
	  // eslint-disable-next-line no-bitwise
	  return !!(this.compareDocumentPosition(arg) & 16);
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) !== '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants) jqLiteRemoveData(element);
	
	  if (element.querySelectorAll) {
	    var descendants = element.querySelectorAll('*');
	    for (var i = 0, l = descendants.length; i < l; i++) {
	      jqLiteRemoveData(descendants[i]);
	    }
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        removeEventListenerFn(element, type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        removeEventListenerFn(element, type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	      return;
	    }
	
	    if (expandoStore.handle) {
	      if (expandoStore.events.$destroy) {
	        expandoStore.handle({}, '$destroy');
	      }
	      jqLiteOff(element);
	    }
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[key] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[key];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          extend(data, key);
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
	      indexOf(' ' + selector + ' ') > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    forEach(cssClasses.split(' '), function(cssClass) {
	      element.setAttribute('class', trim(
	          (' ' + (element.getAttribute('class') || '') + ' ')
	          .replace(/[\n\t]/g, ' ')
	          .replace(' ' + trim(cssClass) + ' ', ' '))
	      );
	    });
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        existingClasses += cssClass + ' ';
	      }
	    });
	
	    element.setAttribute('class', trim(existingClasses));
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType === NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: function(fn) {
	    var fired = false;
	
	    function trigger() {
	      if (fired) return;
	      fired = true;
	      fn();
	    }
	
	    // check if document is already loaded
	    if (window.document.readyState === 'complete') {
	      window.setTimeout(trigger);
	    } else {
	      this.on('DOMContentLoaded', trigger); // works for modern browsers and IE9
	      // we can not use jqLite since we are not done loading and jQuery could be loaded later.
	      // eslint-disable-next-line new-cap
	      JQLite(window).on('load', trigger); // fallback to window.onload for others
	    }
	  },
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: jqLiteCleanData
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = camelCase(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT) {
	      return;
	    }
	    var lowercasedName = lowercase(name);
	    if (BOOLEAN_ATTR[lowercasedName]) {
	      if (isDefined(value)) {
	        if (value) {
	          element[name] = true;
	          element.setAttribute(name, lowercasedName);
	        } else {
	          element[name] = false;
	          element.removeAttribute(lowercasedName);
	        }
	      } else {
	        return (element[name] ||
	                 (element.attributes.getNamedItem(name) || noop).specified)
	               ? lowercasedName
	               : undefined;
	      }
	    } else if (isDefined(value)) {
	      element.setAttribute(name, value);
	    } else if (element.getAttribute) {
	      // the extra argument "2" is to get the right thing for a.href in IE, see jQuery code
	      // some elements (e.g. Document) don't have get attribute, so return undefined
	      var ret = element.getAttribute(name, 2);
	      // normalize non-existing attributes to undefined (as jQuery)
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result.length === 0 ? null : result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          addEventListenerFn(element, type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	
	    if (parent) {
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	});
	
	// bind legacy bind/unbind to on/off
	JQLite.prototype.bind = JQLite.prototype.on;
	JQLite.prototype.unbind = JQLite.prototype.off;
	
	
	// Provider for private $$jqLite service
	/** @this */
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType === 'function' || (objType === 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	/**
	 * HashMap which can use objects as keys
	 */
	function HashMap(array, isolatedUid) {
	  if (isolatedUid) {
	    var uid = 0;
	    this.nextUid = function() {
	      return ++uid;
	    };
	  }
	  forEach(array, this.put, this);
	}
	HashMap.prototype = {
	  /**
	   * Store key value pair
	   * @param key key to store can be any type
	   * @param value value to store can be any type
	   */
	  put: function(key, value) {
	    this[hashKey(key, this.nextUid)] = value;
	  },
	
	  /**
	   * @param key
	   * @returns {Object} the value for the key
	   */
	  get: function(key) {
	    return this[hashKey(key, this.nextUid)];
	  },
	
	  /**
	   * Remove the key/value pair
	   * @param key
	   */
	  remove: function(key) {
	    var value = this[key = hashKey(key, this.nextUid)];
	    delete this[key];
	    return value;
	  }
	};
	
	var $$HashMapProvider = [/** @this */function() {
	  this.$get = [function() {
	    return HashMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running Angular app
	 * from outside Angular. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^(]+?)=>/;
	var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  // Support: Chrome 50-51 only
	  // Creating a new string by adding `' '` at the end, to hack around some bug in Chrome v50/51
	  // (See https://github.com/angular/angular.js/issues/14487.)
	  // TODO (gkalpak): Remove workaround when Chrome v52 is released
	  return Function.prototype.toString.call(fn) + ' ';
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * # Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ## Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ## `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ## Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * # Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * # The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * # The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An Angular **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new HashMap([], true),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
	    }
	    return (providerCache[name + providerSuffix] = provider_);
	  }
	
	  function enforceReturnValue(name, factory) {
	    return /** @this */ function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.put(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          // eslint-disable-next-line no-ex-assign
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          cache[serviceName] = factory(serviceName, caller);
	          return cache[serviceName];
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie <= 11) {
	        return false;
	      }
	      // Support: Edge 12-13 only
	      // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
	      return typeof func === 'function'
	        && /^(?:class\b|constructor\()/.test(stringifyFn(func));
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      // Allow numeric hashes
	      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash === 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = /** @this */ function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = /** @this */ function() {
	  var postDigestQueue = new HashMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        if (domOperation) {
	          domOperation();
	        }
	
	        options = options || {};
	        if (options.from) {
	          element.css(options.from);
	        }
	        if (options.to) {
	          element.css(options.to);
	        }
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner();
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            if (toAdd) {
	              jqLiteAddClass(elm, toAdd);
	            }
	            if (toRemove) {
	              jqLiteRemoveClass(elm, toRemove);
	            }
	          });
	          postDigestQueue.remove(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.put(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', /** @this */ function($provide) {
	  var provider = this;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      this.$$classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (this.$$classNameFilter) {
	        var reservedRegex = new RegExp('(\\s+|\\/)' + NG_ANIMATE_CLASSNAME + '(\\s+|\\/)');
	        if (reservedRegex.test(this.$$classNameFilter.toString())) {
	          throw $animateMinErr('nongcls','$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	
	        }
	      }
	    }
	    return this.$$classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      if (afterElement) {
	        afterElement.after(element);
	      } else {
	        parentElement.prepend(element);
	      }
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */
	      cancel: function(runner) {
	        if (runner.end) {
	          runner.end();
	        }
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        if (passed) {
	          callback();
	        } else {
	          waitForTick(callback);
	        }
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = /** @this */ function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$document', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $document,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        var doc = $document[0];
	
	        // the document may not be ready or attached
	        // to the module for some internal tests
	        if (doc && doc.hidden) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              if (status === false) {
	                reject();
	              } else {
	                resolve();
	              }
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/* exported $CoreAnimateCssProvider */
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global stripHash: true */
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	  self.isMock = false;
	
	  var outstandingRequestCount = 0;
	  var outstandingRequestCallbacks = [];
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = completeOutstandingRequest;
	  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	  /**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */
	  function completeOutstandingRequest(fn) {
	    try {
	      fn.apply(null, sliceArgs(arguments, 1));
	    } finally {
	      outstandingRequestCount--;
	      if (outstandingRequestCount === 0) {
	        while (outstandingRequestCallbacks.length) {
	          try {
	            outstandingRequestCallbacks.pop()();
	          } catch (e) {
	            $log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function getHash(url) {
	    var index = url.indexOf('#');
	    return index === -1 ? '' : url.substr(index);
	  }
	
	  /**
	   * @private
	   * Note: this method is used only by scenario runner
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */
	  self.notifyWhenNoOutstandingRequests = function(callback) {
	    if (outstandingRequestCount === 0) {
	      callback();
	    } else {
	      outstandingRequestCallbacks.push(callback);
	    }
	  };
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	  lastHistoryState = cachedState;
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	        // Do the assignment again so that those two variables are referentially identical.
	        lastHistoryState = cachedState;
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	      return pendingLocation || location.href.replace(/%27/g,'\'');
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    cacheState();
	    fireUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	    lastCachedState = cachedState;
	  }
	
	  function fireUrlChange() {
	    if (lastBrowserUrl === self.url() && lastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of angular:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in angular apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
	      // don't fire popstate when user change the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of Angular.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay) {
	    var timeoutId;
	    outstandingRequestCount++;
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      completeOutstandingRequest(fn);
	    }, delay || 0);
	    pendingDeferIds[timeoutId] = true;
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds[deferId]) {
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      completeOutstandingRequest(noop);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	/** @this */
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
	       * templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return (caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      });
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry !== freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd === entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry !== prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, or by consuming the
	 * `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
	 * element with ng-app attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 * See {@link ng.$cacheFactory $cacheFactory}.
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by Angular at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by Angular's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with Angular 2 life-cycle hooks
	 * Angular 2 also uses life-cycle hooks for its components. While the Angular 1 life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from Angular 1 to Angular 2:
	 *
	 * * Angular 1 hooks are prefixed with `$`, such as `$onInit`. Angular 2 hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * Angular 1 hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular 2 you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in Angular 1 than you would to
	 *   `ngDoCheck` in Angular 2
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular 2 does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's element. The
	 * 'isolate' scope differs from normal scope in that it does not prototypically inherit from its parent
	 * scope. This is useful when creating reusable components, which should not accidentally read or modify
	 * data in the parent scope.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * <div class="alert alert-warning">
	 * **Deprecation warning:** although bindings for non-ES6 class controllers are currently
	 * bound to `this` before the controller constructor is called, this use is now deprecated. Please place initialization
	 * code that relies upon bindings inside a `$onInit` method on the controller, instead.
	 * </div>
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
	 * specify what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'Angular';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello Angular'.
	       expect(output.getText()).toBe('Hello Angular');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('Angular!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * Angular automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	 *
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	/** @this */
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*([\w$]*)\s*$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            'Invalid {3} for directive \'{0}\'.' +
	            ' Definition: {... {1}: \'{2}\' ...}',
	            directiveName, scopeName, definition,
	            (isController ? 'controller bindings definition' :
	            'isolate scope definition'));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (bindings.bindToController && !directive.controller) {
	      // There is no controller
	      throw $compileMinErr('noctrl',
	            'Cannot bind to controller without directive \'{0}\'s controller.',
	            directiveName);
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  function getDirectiveRestrict(restrict, name) {
	    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
	      throw $compileMinErr('badrestrict',
	          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
	          restrict,
	          name);
	    }
	
	    return restrict || 'EA';
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertArg(name, 'name');
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = getDirectiveRestrict(directive.restrict, name);
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`)
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return /** @this */ function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in Angular looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `$binding` data property containing an array of the binding expressions
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#preAssignBindingsEnabled
	   *
	   * @param {boolean=} enabled update the preAssignBindingsEnabled state if provided, otherwise just return the
	   * current preAssignBindingsEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable whether directive controllers are assigned bindings before
	   * calling the controller's constructor.
	   * If enabled (true), the compiler assigns the value of each of the bindings to the
	   * properties of the controller object before the constructor of this object is called.
	   *
	   * If disabled (false), the compiler calls the constructor first before assigning bindings.
	   *
	   * The default value is true in Angular 1.5.x but will switch to false in Angular 1.6.x.
	   */
	  var preAssignBindingsEnabled = true;
	  this.preAssignBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      preAssignBindingsEnabled = enabled;
	      return this;
	    }
	    return preAssignBindingsEnabled;
	  };
	
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  var commentDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.commentDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      commentDirectivesEnabledConfig = value;
	      return this;
	    }
	    return commentDirectivesEnabledConfig;
	  };
	
	
	  var cssClassDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.cssClassDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      cssClassDirectivesEnabledConfig = value;
	      return this;
	    }
	    return cssClassDirectivesEnabledConfig;
	  };
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
	    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          var errors = [];
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              errors.push(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	          if (errors.length) {
	            throw errors;
	          }
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        //is set through this function since it may cause $updateClass to
	        //become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
	            (nodeName === 'img' && key === 'src')) {
	          // sanitize a[href] and img[src] values
	          this[key] = value = $$sanitizeUri(value, key === 'src');
	        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
	          // sanitize img[srcset] values
	          var result = '';
	
	          // first check if there are spaces because it's not the same pattern
	          var trimmedSrcset = trim(value);
	          //                (   999x   ,|   999w   ,|   ,|,   )
	          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	          // split srcset into tuple of uri and descriptor except for the last item
	          var rawUris = trimmedSrcset.split(pattern);
	
	          // for each tuples
	          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	          for (var i = 0; i < nbrUrisWith2parts; i++) {
	            var innerIdx = i * 2;
	            // sanitize the uri
	            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	            // add the descriptor
	            result += (' ' + trim(rawUris[innerIdx + 1]));
	          }
	
	          // split the last item into uri and descriptor
	          var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	          // sanitize the last uri
	          result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	          // and add the last descriptor if any
	          if (lastTuple.length === 2) {
	            result += (' ' + trim(lastTuple[1]));
	          }
	          this[key] = value = result;
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              this.$$element.attr(attrName, value);
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        if ($$observers) {
	          forEach($$observers[observer], function(fn) {
	            try {
	              fn(value);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	
	      var NOT_EMPTY = /\S+/;
	
	      // We can not compile top level text elements since text nodes can be merged and we will
	      // not be able to attach scope data to them, so we will wrap them in <span>
	      for (var i = 0, len = $compileNodes.length; i < len; i++) {
	        var domNode = $compileNodes[i];
	
	        if (domNode.nodeType === NODE_TYPE_TEXT && domNode.nodeValue.match(NOT_EMPTY) /* non-empty */) {
	          jqLiteWrapNode(domNode, $compileNodes[i] = window.document.createElement('span'));
	        }
	      }
	
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // we must always refer to nodeList[i] since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i += 3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          nodeName,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	
	          nodeName = nodeName_(node);
	
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = trim(attr.value);
	
	            // support ngAttr attribute binding
	            ngAttrName = directiveNormalize(name);
	            isNgAttr = NG_ATTR_BINDING.test(ngAttrName);
	            if (isNgAttr) {
	              name = name.replace(PREFIX_REGEXP, '')
	                .substr(8).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	            }
	
	            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
	            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            nName = directiveNormalize(name.toLowerCase());
	            attrsMap[nName] = name;
	            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	            }
	            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                          attrEndName);
	          }
	
	          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
	            // Hidden input elements can have strange behaviour when navigating back to the page
	            // This tells the browser not to try to cache and reinstate previous values
	            node.setAttribute('autocomplete', 'off');
	          }
	
	          // use class as directive
	          if (!cssClassDirectivesEnabled) break;
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          if (msie === 11) {
	            // Workaround for #11781
	            while (node.parentNode && node.nextSibling && node.nextSibling.nodeType === NODE_TYPE_TEXT) {
	              node.nodeValue = node.nodeValue + node.nextSibling.nodeValue;
	              node.parentNode.removeChild(node.nextSibling);
	            }
	          }
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          if (!commentDirectivesEnabled) break;
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType === NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return /** @this */ function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        directiveValue = directive.scope;
	
	        if (directiveValue) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate('\'' + directiveName + '\' controller',
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        directiveValue = directive.transclude;
	
	        if (directiveValue) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue === 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            // Support: Chrome < 50
	            // https://github.com/angular/angular.js/issues/14041
	
	            // In the versions of V8 prior to Chrome 50, the document fragment that is created
	            // in the `replaceWith` function is improperly garbage collected despite still
	            // being referenced by the `parentNode` property of all of the child nodes.  By adding
	            // a reference to the fragment via a different property, we can avoid that incorrect
	            // behavior.
	            // TODO: remove this line after Chrome 50 has been released
	            $template[0].$$parentNode = $template[0].parentNode;
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            $template = jqLite(jqLiteClone(compileNode)).contents();
	
	            if (isObject(directiveValue)) {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = [];
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || [];
	                  slots[slotName].push(node);
	                } else {
	                  $template.push(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
	                }
	              }
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          // eslint-disable-next-line no-func-assign
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          if (preAssignBindingsEnabled) {
	            if (bindings) {
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            } else {
	              controller.bindingInfo = {};
	            }
	
	            var controllerResult = controller();
	            if (controllerResult !== controller.instance) {
	              // If the controller constructor has a return value, overwrite the instance
	              // from setupControllers
	              controller.instance = controllerResult;
	              $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
	              if (controller.bindingInfo.removeWatches) {
	                controller.bindingInfo.removeWatches();
	              }
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            }
	          } else {
	            controller.instance = controller();
	            $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	        }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        if (childLinkFn) {
	          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	        }
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller === '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	               directive.restrict.indexOf(location) !== -1) {
	            if (startAttrName) {
	              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	            }
	            if (!directive.$$bindings) {
	              var bindings = directive.$$bindings =
	                  parseDirectiveBindings(directive, directive.name);
	              if (isObject(bindings.isolateScope)) {
	                directive.$$isolateBindings = bindings.isolateScope;
	              }
	            }
	            tDirectives.push(directive);
	            match = directive;
	          }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) !== '$') {
	          if (src[key] && src[key] !== value) {
	            value += (key === 'style' ? ';' : ' ') + src[key];
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node === compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedContext(node, attrNormalizedName) {
	      if (attrNormalizedName === 'srcdoc') {
	        return $sce.HTML;
	      }
	      var tag = nodeName_(node);
	      // All tags with src attributes require a RESOURCE_URL value, except for
	      // img and various html5 media tags.
	      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
	        if (['img', 'video', 'audio', 'source', 'track'].indexOf(tag) === -1) {
	          return $sce.RESOURCE_URL;
	        }
	      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	      } else if (attrNormalizedName === 'xlinkHref' ||
	          (tag === 'form' && attrNormalizedName === 'action')
	      ) {
	        return $sce.RESOURCE_URL;
	      }
	    }
	
	
	    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
	      var trustedContext = getTrustedContext(node, name);
	      var mustHaveExpression = !isNgAttr;
	      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
	
	      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	      if (name === 'multiple' && nodeName_(node) === 'select') {
	        throw $compileMinErr('selmulti',
	            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
	            startingTag(node));
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	                  throw $compileMinErr('nodomevents',
	                      'Interpolations for HTML DOM event attributes are disallowed.  Please use the ' +
	                          'ng- versions (such as ng-click instead of onclick) instead.');
	                }
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue !== oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] === firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	
	    // Set up $watches for isolate scope and controller bindings.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              destination[scopeName] = attrs[attrName] = undefined;
	            }
	            removeWatch = attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              // eslint-disable-next-line no-self-compare
	              compare = function simpleCompare(a, b) { return a === b || (a !== a && b !== b); };
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              lastValue = parentValue;
	              return lastValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            var deepWatch = parentGet.literal;
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue || (deepWatch && equals(oldValue, initialValue))) {
	                  return;
	                }
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            }, deepWatch);
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && currentValue !== previousValue &&
	            // eslint-disable-next-line no-self-compare
	            (currentValue === currentValue || previousValue === previousValue)) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return camelCase(name.replace(PREFIX_REGEXP, ''));
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in Angular:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token === tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT ||
	       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
	         splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by Angular to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {},
	      globals = false;
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   *
	   * @deprecated
	   * sinceVersion="v1.3.0"
	   * removeVersion="v1.7.0"
	   * This method of finding controllers has been deprecated.
	   *
	   * @description If called, allows `$controller` to find controller constructors on `window`   *
	   */
	  this.allowGlobals = function() {
	    globals = true;
	  };
	
	
	  this.$get = ['$injector', '$window', function($injector, $window) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            'Badly formed controller string \'{0}\'. ' +
	            'Must match `__name__ as __id__` or `__name__`.', expression);
	        }
	        constructor = match[1];
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	                (globals ? getter($window, constructor, true) : undefined);
	
	        if (!expression) {
	          throw $controllerMinErr('ctrlreg',
	            'The controller with the name \'{0}\' is not registered.', constructor);
	        }
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in angular expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = /** @this */ function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
	var $httpMinErr = minErr('$http');
	var $httpMinErrLegacyFn = function(method) {
	  return function() {
	    throw $httpMinErr('legacy', 'The method `{0}` on the promise returned from `$http` has been disabled.', method);
	  };
	};
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	/** @this */
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	/** @this */
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (toSerialize === null || isUndefined(toSerialize)) return;
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
	        data = fromJson(tempData);
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === undefined) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   **/
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  var useLegacyPromise = true;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useLegacyPromiseExtensions
	   * @description
	   *
	   * @deprecated
	   * sinceVersion="v1.4.4"
	   * removeVersion="v1.6.0"
	   * This method will be removed in v1.6.0 along with the legacy promise methods.
	   *
	   * Configure `$http` service to return promises without the shorthand methods `success` and `error`.
	   * This should be used to make sure that applications work without these methods.
	   *
	   * Defaults to true. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, `$http` will return a promise with the deprecated legacy `success` and `error` methods.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useLegacyPromiseExtensions = function(value) {
	    if (isDefined(value)) {
	      useLegacyPromise = !!value;
	      return this;
	    }
	    return useLegacyPromise;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/
	  var interceptorFactories = this.interceptors = [];
	
	  this.$get = ['$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector',
	      function($httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core Angular service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *
	     * A response status code between 200 and 299 is considered a success status and will result in
	     * the success callback being called. Any response status code outside of that range is
	     * considered an error status and will result in the error callback being called.
	     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
	     * aborted, e.g. using a `config.timeout`.
	     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
	     * that the outcome (success or error) will be determined by the final response status code.
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Deprecation Notice
	     * <div class="alert alert-danger">
	     *   The `$http` legacy promise methods `success` and `error` have been deprecated and will be
	     *   removed in v1.6.0.
	     *   Use the standard `then` method instead.
	     *   If {@link $httpProvider#useLegacyPromiseExtensions `$httpProvider.useLegacyPromiseExtensions`} is set to
	     *   `false` then these methods will throw {@link $http:legacy `$http/legacy`} error.
	     * </div>
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * Angular provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If JSON response is detected, deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * Angular will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * Angular will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	     * The header will not be set for cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple Angular apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string}` – Absolute or relative URL of the resource that is being requested.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?callback=JSON_CALLBACK&name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist&callback=JSON_CALLBACK')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString(requestConfig.url)) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.when(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	
	      if (useLegacyPromise) {
	        promise.success = function(fn) {
	          assertArgFn(fn, 'fn');
	
	          promise.then(function(response) {
	            fn(response.data, response.status, response.headers, config);
	          });
	          return promise;
	        };
	
	        promise.error = function(fn) {
	          assertArgFn(fn, 'fn');
	
	          promise.then(null, function(response) {
	            fn(response.data, response.status, response.headers, config);
	          });
	          return promise;
	        };
	      } else {
	        promise.success = $httpMinErrLegacyFn('success');
	        promise.error = $httpMinErrLegacyFn('error');
	      }
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     * If you would like to customize where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request.
	     *                     The name of the callback should be the string `JSON_CALLBACK`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object
	      * @returns {HttpPromise} Future object
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          url = buildUrl(config.url, config.paramSerializer(config.params));
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	              : isObject(defaults.cache) ? defaults.cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsSameOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    $browser.$$incOutstandingRequestCount();
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, '', text);
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText);
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '');
	      };
	
	      xhr.onerror = requestError;
	      xhr.onabort = requestError;
	      xhr.ontimeout = requestError;
	
	      forEach(eventHandlers, function(value, key) {
	          xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(timeoutRequest, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(timeoutRequest);
	    }
	
	
	    function timeoutRequest() {
	      if (jsonpDone) {
	        jsonpDone();
	      }
	      if (xhr) {
	        xhr.abort();
	      }
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText);
	      $browser.$$completeOutstandingRequest(noop);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      removeEventListenerFn(script, 'load', callback);
	      removeEventListenerFn(script, 'error', callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = 'unknown';
	
	      if (event) {
	        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
	          event = { type: 'error' };
	        }
	        text = event.type;
	        status = event.type === 'error' ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    addEventListenerFn(script, 'load', callback);
	    addEventListenerFn(script, 'error', callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
	      'interpolations that concatenate multiple expressions when a trusted value is ' +
	      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape Angular
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    } else {
	      return startSymbol;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    } else {
	      return endSymbol;
	    }
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    function stringify(value) {
	      if (value == null) { // null || undefined
	        return '';
	      }
	      switch (typeof value) {
	        case 'string':
	          break;
	        case 'number':
	          value = '' + value;
	          break;
	        default:
	          value = toJson(value);
	      }
	
	      return value;
	    }
	
	    // TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'Angular';
	     *   expect(exp(context)).toEqual('Hello Angular!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        var constantInterp;
	        if (!mustHaveExpression) {
	          var unescapedText = unescapeText(text);
	          constantInterp = valueFn(unescapedText);
	          constantInterp.exp = text;
	          constantInterp.expressions = [];
	          constantInterp.$$watchDelegate = constantWatchDelegate;
	        }
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          parseFns.push($parse(exp, parseStringifyInterceptor));
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push('');
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for iframe[src], object[src], etc., we ensure that the value
	      // that's used is assigned or constructed by some JS code somewhere that is more testable or
	      // make it obvious that you bound the value to some user controlled value.  This helps reduce
	      // the load when auditing for XSS issues.
	      if (trustedContext && concat.length > 1) {
	          $interpolateMinErr.throwNoconcat(text);
	      }
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	          return concat.join('');
	        };
	
	        var getValue = function(value) {
	          return trustedContext ?
	            $sce.getTrusted(trustedContext, value) :
	            $sce.valueOf(value);
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              if (isFunction(listener)) {
	                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              }
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          value = getValue(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	/** @this */
	function $IntervalProvider() {
	  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
	       function($rootScope,   $window,   $q,   $$q,   $browser) {
	    var intervals = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	      *   are passed (see below), the function is called with the current iteration count.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration.
	      *
	      * @example
	      * <example module="intervalExample" name="interval-service">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */
	    function interval(fn, delay, count, invokeApply) {
	      var hasParams = arguments.length > 4,
	          args = hasParams ? sliceArgs(arguments, 4) : [],
	          setInterval = $window.setInterval,
	          clearInterval = $window.clearInterval,
	          iteration = 0,
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise;
	
	      count = isDefined(count) ? count : 0;
	
	      promise.$$intervalId = setInterval(function tick() {
	        if (skipApply) {
	          $browser.defer(callback);
	        } else {
	          $rootScope.$evalAsync(callback);
	        }
	        deferred.notify(iteration++);
	
	        if (count > 0 && iteration >= count) {
	          deferred.resolve(iteration);
	          clearInterval(promise.$$intervalId);
	          delete intervals[promise.$$intervalId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	
	      }, delay);
	
	      intervals[promise.$$intervalId] = deferred;
	
	      return promise;
	
	      function callback() {
	        if (!hasParams) {
	          fn(iteration);
	        } else {
	          fn.apply(null, args);
	        }
	      }
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */
	    interval.cancel = function(promise) {
	      if (promise && promise.$$intervalId in intervals) {
	        intervals[promise.$$intervalId].reject('canceled');
	        $window.clearInterval(promise.$$intervalId);
	        delete intervals[promise.$$intervalId];
	        return true;
	      }
	      return false;
	    };
	
	    return interval;
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = /** @this */ function() {
	  this.$get = ['$window', function($window) {
	    var callbacks = $window.angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  }];
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various Angular components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = encodeUriSegment(segments[i]);
	  }
	
	  return segments.join('/');
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
	function parseAppUrl(url, locationObj) {
	
	  if (DOUBLE_SLASH_REGEX.test(url)) {
	    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
	  }
	
	  var prefixed = (url.charAt(0) !== '/');
	  if (prefixed) {
	    url = '/' + url;
	  }
	  var match = urlResolve(url);
	  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
	      match.pathname.substring(1) : match.pathname);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(str, search) {
	  return str.slice(0, search.length) === search;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? url : url.substr(0, index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/(#.+)|#$/, '$1');
	}
	
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  /**
	   * Compose url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the URL starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          this.replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of Angular, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  /**
	   * Compose hashbang URL and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) === stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase === stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    this.$$absUrl = appBase + hashPrefix + this.$$url;
	  };
	
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute URL is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) === '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return /** @this */ function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return /** @this */ function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `''`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          '$location in HTML5 mode requires a <base> tag to be present!');
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      var rewriteLinks = html5Mode.rewriteLinks;
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the angular application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() !== $browser.url()) {
	            $rootScope.$apply();
	            // hack to work around FF6 bug 684208 when scenario runner clicks on links
	            $window.angular['ff-684208-preventDefault'] = true;
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if (trimEmptyHash($location.absUrl()) !== trimEmptyHash(initialUrl)) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (isUndefined(stripBaseUrl(appBaseNoFile, newUrl))) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        newUrl = trimEmptyHash(newUrl);
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      var oldUrl = trimEmptyHash($browser.url());
	      var newUrl = trimEmptyHash($location.absUrl());
	      var oldState = $browser.state();
	      var currentReplace = $location.$$replace;
	      var urlOrStateChanged = oldUrl !== newUrl ||
	        ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	      if (initializing || urlOrStateChanged) {
	        initializing = false;
	
	        $rootScope.$evalAsync(function() {
	          var newUrl = $location.absUrl();
	          var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	              $location.$$state, oldState).defaultPrevented;
	
	          // if the location was changed by a `$locationChangeStart` handler then stop
	          // processing this location change
	          if ($location.absUrl() !== newUrl) return;
	
	          if (defaultPrevented) {
	            $location.$$parse(oldUrl);
	            $location.$$state = oldState;
	          } else {
	            if (urlOrStateChanged) {
	              setBrowserUrlWithFallback(newUrl, currentReplace,
	                                        oldState === $location.$$state ? null : $location.$$state);
	            }
	            afterLocationChange(oldUrl, oldState);
	          }
	        });
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	      return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      })()
	    };
	
	    function formatError(arg) {
	      if (arg instanceof Error) {
	        if (arg.stack) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop,
	          hasApply = false;
	
	      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
	      // The reason behind this is that console.log has type "object" in IE8...
	      try {
	        hasApply = !!logFn.apply;
	      } catch (e) { /* empty */ }
	
	      if (hasApply) {
	        return function() {
	          var args = [];
	          forEach(arguments, function(arg) {
	            args.push(formatError(arg));
	          });
	          return logFn.apply(console, args);
	        };
	      }
	
	      // we are IE which either doesn't have window.console => this is noop and we do nothing,
	      // or we are IE where console.log doesn't have apply so we log at least first 2 args
	      return function(arg1, arg2) {
	        logFn(arg1, arg2 == null ? '' : arg2);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	var ARRAY_CTOR = [].constructor;
	var BOOLEAN_CTOR = (false).constructor;
	var FUNCTION_CTOR = Function.constructor;
	var NUMBER_CTOR = (0).constructor;
	var OBJECT_CTOR = {}.constructor;
	var STRING_CTOR = ''.constructor;
	var ARRAY_CTOR_PROTO = ARRAY_CTOR.prototype;
	var BOOLEAN_CTOR_PROTO = BOOLEAN_CTOR.prototype;
	var FUNCTION_CTOR_PROTO = FUNCTION_CTOR.prototype;
	var NUMBER_CTOR_PROTO = NUMBER_CTOR.prototype;
	var OBJECT_CTOR_PROTO = OBJECT_CTOR.prototype;
	var STRING_CTOR_PROTO = STRING_CTOR.prototype;
	
	var CALL = FUNCTION_CTOR_PROTO.call;
	var APPLY = FUNCTION_CTOR_PROTO.apply;
	var BIND = FUNCTION_CTOR_PROTO.bind;
	
	var objectValueOf = OBJECT_CTOR_PROTO.valueOf;
	
	// Sandboxing Angular Expressions
	// ------------------------------
	// Angular expressions are generally considered safe because these expressions only have direct
	// access to `$scope` and locals. However, one can obtain the ability to execute arbitrary JS code by
	// obtaining a reference to native JS functions such as the Function constructor.
	//
	// As an example, consider the following Angular expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// This sandboxing technique is not perfect and doesn't aim to be. The goal is to prevent exploits
	// against the expression language, but not to prevent exploits that were enabled by exposing
	// sensitive JavaScript or browser APIs on Scope. Exposing such objects on a Scope is never a good
	// practice and therefore we are not even trying to protect against interaction with an object
	// explicitly exposed in this way.
	//
	// In general, it is not possible to access a Window object from an angular expression unless a
	// window or some DOM object that has a reference to window is published onto a Scope.
	// Similarly we prevent invocations of function known to be dangerous, as well as assignments to
	// native objects.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function ensureSafeMemberName(name, fullExpression) {
	  if (name === '__defineGetter__' || name === '__defineSetter__'
	      || name === '__lookupGetter__' || name === '__lookupSetter__'
	      || name === '__proto__') {
	    throw $parseMinErr('isecfld',
	        'Attempting to access a disallowed field in Angular expressions! '
	        + 'Expression: {0}', fullExpression);
	  }
	  return name;
	}
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	function ensureSafeObject(obj, fullExpression) {
	  // nifty check if obj is Function that is fast and works across iframes and other contexts
	  if (obj) {
	    if (obj.constructor === obj) {
	      throw $parseMinErr('isecfn',
	          'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// isWindow(obj)
	        obj.window === obj) {
	      throw $parseMinErr('isecwindow',
	          'Referencing the Window in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// isElement(obj)
	        obj.children && (obj.nodeName || (obj.prop && obj.attr && obj.find))) {
	      throw $parseMinErr('isecdom',
	          'Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// block Object so that we can't get hold of dangerous Object.* methods
	        obj === Object) {
	      throw $parseMinErr('isecobj',
	          'Referencing Object in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    }
	  }
	  return obj;
	}
	
	function ensureSafeFunction(obj, fullExpression) {
	  if (obj) {
	    if (obj.constructor === obj) {
	      throw $parseMinErr('isecfn',
	        'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	        fullExpression);
	    } else if (obj === CALL || obj === APPLY || obj === BIND) {
	      throw $parseMinErr('isecff',
	        'Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}',
	        fullExpression);
	    }
	  }
	}
	
	function ensureSafeAssignContext(obj, fullExpression) {
	  if (obj) {
	    if (obj === ARRAY_CTOR ||
	        obj === BOOLEAN_CTOR ||
	        obj === FUNCTION_CTOR ||
	        obj === NUMBER_CTOR ||
	        obj === OBJECT_CTOR ||
	        obj === STRING_CTOR ||
	        obj === ARRAY_CTOR_PROTO ||
	        obj === BOOLEAN_CTOR_PROTO ||
	        obj === FUNCTION_CTOR_PROTO ||
	        obj === NUMBER_CTOR_PROTO ||
	        obj === OBJECT_CTOR_PROTO ||
	        obj === STRING_CTOR_PROTO) {
	      throw $parseMinErr('isecaf',
	        'Assigning to a constructor or its prototype is disallowed! Expression: {0}',
	        fullExpression);
	    }
	  }
	}
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function Lexer(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === '\'') {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    // eslint-disable-next-line no-bitwise
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch === '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch === 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) === 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) === 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function AST(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    while (this.expect('|')) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      if (!isAssignable(result)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError('invalid key', this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	function findConstantAndWatchExpressions(ast, $filter) {
	  var allConstants;
	  var argsToWatch;
	  var isStatelessFilter;
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter);
	    findConstantAndWatchExpressions(ast.alternate, $filter);
	    findConstantAndWatchExpressions(ast.consequent, $filter);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = [ast];
	    break;
	  case AST.CallExpression:
	    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    allConstants = isStatelessFilter;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter);
	      allConstants = allConstants && property.value.constant && !property.computed;
	      if (!property.value.constant) {
	        argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length !== 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler(astBuilder, $filter) {
	  this.astBuilder = astBuilder;
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(expression, expensiveChecks) {
	    var self = this;
	    var ast = this.astBuilder.ast(expression);
	    this.state = {
	      nextId: 0,
	      filters: {},
	      expensiveChecks: expensiveChecks,
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push(fnKey);
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    // eslint-disable-next-line no-new-func
	    var fn = (new Function('$filter',
	        'ensureSafeMemberName',
	        'ensureSafeObject',
	        'ensureSafeFunction',
	        'getStringValue',
	        'ensureSafeAssignContext',
	        'ifDefined',
	        'plus',
	        'text',
	        fnString))(
	          this.$filter,
	          ensureSafeMemberName,
	          ensureSafeObject,
	          ensureSafeFunction,
	          getStringValue,
	          ensureSafeAssignContext,
	          ifDefined,
	          plusFn,
	          expression);
	    this.state = this.stage = undefined;
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var fns = this.state.inputs;
	    var self = this;
	    forEach(fns, function(name) {
	      result.push('var ' + name + '=' + self.generateFunction(name, 's'));
	    });
	    if (fns.length) {
	      result.push('fn.inputs=[' + fns.join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      ensureSafeMemberName(ast.name);
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.not(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.name)) {
	        self.addEnsureSafeObject(intoId);
	      }
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (create && create !== 1) {
	            self.addEnsureSafeAssignContext(left);
	          }
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            self.addEnsureSafeMemberName(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.ensureSafeObject(self.computedMember(left, right));
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            ensureSafeMemberName(ast.property.name);
	            if (create && create !== 1) {
	              self.if_(self.not(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.property.name)) {
	              expression = self.ensureSafeObject(expression);
	            }
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            self.addEnsureSafeFunction(right);
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, self.nextId(), undefined, function(argument) {
	                args.push(self.ensureSafeObject(argument));
	              });
	            });
	            if (left.name) {
	              if (!self.state.expensiveChecks) {
	                self.addEnsureSafeObject(left.context);
	              }
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            expression = self.ensureSafeObject(expression);
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          self.addEnsureSafeObject(self.member(left.context, left.name, left.computed));
	          self.addEnsureSafeAssignContext(left.context);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn('s');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn('l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn('v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  addEnsureSafeObject: function(item) {
	    this.current().body.push(this.ensureSafeObject(item), ';');
	  },
	
	  addEnsureSafeMemberName: function(item) {
	    this.current().body.push(this.ensureSafeMemberName(item), ';');
	  },
	
	  addEnsureSafeFunction: function(item) {
	    this.current().body.push(this.ensureSafeFunction(item), ';');
	  },
	
	  addEnsureSafeAssignContext: function(item) {
	    this.current().body.push(this.ensureSafeAssignContext(item), ';');
	  },
	
	  ensureSafeObject: function(item) {
	    return 'ensureSafeObject(' + item + ',text)';
	  },
	
	  ensureSafeMemberName: function(item) {
	    return 'ensureSafeMemberName(' + item + ',text)';
	  },
	
	  ensureSafeFunction: function(item) {
	    return 'ensureSafeFunction(' + item + ',text)';
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  ensureSafeAssignContext: function(item) {
	    return 'ensureSafeAssignContext(' + item + ',text)';
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter(astBuilder, $filter) {
	  this.astBuilder = astBuilder;
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(expression, expensiveChecks) {
	    var self = this;
	    var ast = this.astBuilder.ast(expression);
	    this.expression = expression;
	    this.expensiveChecks = expensiveChecks;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      ensureSafeMemberName(ast.name, self.expression);
	      return self.identifier(ast.name,
	                             self.expensiveChecks || isPossiblyDangerousMemberName(ast.name),
	                             context, create, self.expression);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        ensureSafeMemberName(ast.property.name, self.expression);
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create, self.expression) :
	        this.nonComputedMember(left, right, self.expensiveChecks, context, create, self.expression);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            ensureSafeObject(rhs.context, self.expression);
	            ensureSafeFunction(rhs.value, self.expression);
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(ensureSafeObject(args[i](scope, locals, assign, inputs), self.expression));
	            }
	            value = ensureSafeObject(rhs.value.apply(rhs.context, values), self.expression);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        ensureSafeObject(lhs.value, self.expression);
	        ensureSafeAssignContext(lhs.context);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, expensiveChecks, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && !(base[name])) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (expensiveChecks) {
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        ensureSafeMemberName(rhs, expression);
	        if (create && create !== 1) {
	          ensureSafeAssignContext(lhs);
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, expensiveChecks, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        ensureSafeAssignContext(lhs);
	        if (lhs && !(lhs[right])) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (expensiveChecks || isPossiblyDangerousMemberName(right)) {
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	var Parser = function Parser(lexer, $filter, options) {
	  this.lexer = lexer;
	  this.$filter = $filter;
	  this.options = options;
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter(this.ast, $filter) :
	                                   new ASTCompiler(this.ast, $filter);
	};
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    return this.astCompiler.compile(text, this.options.expensiveChecks);
	  }
	};
	
	function isPossiblyDangerousMemberName(name) {
	  return name === 'constructor';
	}
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts Angular {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'angular'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('angular');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cacheDefault = createMap();
	  var cacheExpensive = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in Angular expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          expensiveChecks: false,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        },
	        $parseOptionsExpensive = {
	          csp: noUnsafeEval,
	          expensiveChecks: true,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    var runningChecksEnabled = false;
	
	    $parse.$$runningExpensiveChecks = function() {
	      return runningChecksEnabled;
	    };
	
	    return $parse;
	
	    function $parse(exp, interceptorFn, expensiveChecks) {
	      var parsedExpression, oneTime, cacheKey;
	
	      expensiveChecks = expensiveChecks || runningChecksEnabled;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          var cache = (expensiveChecks ? cacheExpensive : cacheDefault);
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	              oneTime = true;
	              exp = exp.substring(2);
	            }
	            var parseOptions = expensiveChecks ? $parseOptionsExpensive : $parseOptions;
	            var lexer = new Lexer(parseOptions);
	            var parser = new Parser(lexer, $filter, parseOptions);
	            parsedExpression = parser.parse(exp);
	            if (parsedExpression.constant) {
	              parsedExpression.$$watchDelegate = constantWatchDelegate;
	            } else if (oneTime) {
	              parsedExpression.$$watchDelegate = parsedExpression.literal ?
	                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
	            } else if (parsedExpression.inputs) {
	              parsedExpression.$$watchDelegate = inputsWatchDelegate;
	            }
	            if (expensiveChecks) {
	              parsedExpression = expensiveChecksInterceptor(parsedExpression);
	            }
	            cache[cacheKey] = parsedExpression;
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function expensiveChecksInterceptor(fn) {
	      if (!fn) return fn;
	      expensiveCheckFn.$$watchDelegate = fn.$$watchDelegate;
	      expensiveCheckFn.assign = expensiveChecksInterceptor(fn.assign);
	      expensiveCheckFn.constant = fn.constant;
	      expensiveCheckFn.literal = fn.literal;
	      for (var i = 0; fn.inputs && i < fn.inputs.length; ++i) {
	        fn.inputs[i] = expensiveChecksInterceptor(fn.inputs[i]);
	      }
	      expensiveCheckFn.inputs = fn.inputs;
	
	      return expensiveCheckFn;
	
	      function expensiveCheckFn(scope, locals, assign, inputs) {
	        var expensiveCheckOldValue = runningChecksEnabled;
	        runningChecksEnabled = true;
	        try {
	          return fn(scope, locals, assign, inputs);
	        } finally {
	          runningChecksEnabled = expensiveCheckOldValue;
	        }
	      }
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object') {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      // eslint-disable-next-line no-self-compare
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i]))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, /** @this */ function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener.apply(this, arguments);
	        }
	        if (isDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isDefined(lastValue)) {
	              unwatch();
	            }
	          });
	        }
	      }, objectEquality);
	      return unwatch;
	    }
	
	    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, /** @this */ function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener.call(this, value, old, scope);
	        }
	        if (isAllDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isAllDefined(lastValue)) unwatch();
	          });
	        }
	      }, objectEquality);
	
	      return unwatch;
	
	      function isAllDefined(value) {
	        var allDefined = true;
	        forEach(value, function(val) {
	          if (!isDefined(val)) allDefined = false;
	        });
	        return allDefined;
	      }
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	      var watchDelegate = parsedExpression.$$watchDelegate;
	      var useInputs = false;
	
	      var regularWatch =
	          watchDelegate !== oneTimeLiteralWatchDelegate &&
	          watchDelegate !== oneTimeWatchDelegate;
	
	      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value, scope, locals);
	      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
	        var value = parsedExpression(scope, locals, assign, inputs);
	        var result = interceptorFn(value, scope, locals);
	        // we only return the interceptor's result if the
	        // initial value is defined (for bind-once)
	        return isDefined(value) ? result : value;
	      };
	
	      // Propagate $$watchDelegates other then inputsWatchDelegate
	      if (parsedExpression.$$watchDelegate &&
	          parsedExpression.$$watchDelegate !== inputsWatchDelegate) {
	        fn.$$watchDelegate = parsedExpression.$$watchDelegate;
	      } else if (!interceptorFn.$stateful) {
	        // If there is an interceptor, but no watchDelegate then treat the interceptor like
	        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
	        fn.$$watchDelegate = inputsWatchDelegate;
	        useInputs = !parsedExpression.inputs;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	      }
	
	      return fn;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 * @this
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is an implementation of promises/deferred objects inspired by
	 * [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * # $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * # The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * # The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * # Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * # Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in angular, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * # Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	function $QProvider() {
	
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler);
	  }];
	}
	
	/** @this */
	function $$QProvider() {
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler);
	  }];
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler) {
	  var $qMinErr = minErr('$q', TypeError);
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  function defer() {
	    var d = new Deferred();
	    //Necessary to support unbound execution :/
	    d.resolve = simpleBind(d, d.resolve);
	    d.reject = simpleBind(d, d.reject);
	    d.notify = simpleBind(d, d.notify);
	    return d;
	  }
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Deferred();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result.promise;
	    },
	
	    'catch': function(callback) {
	      return this.then(null, callback);
	    },
	
	    'finally': function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, resolve, callback);
	      }, function(error) {
	        return handleCallback(error, reject, callback);
	      }, progressBack);
	    }
	  });
	
	  //Faster, more basic than angular.bind http://jsperf.com/angular-bind-vs-custom-vs-native
	  function simpleBind(context, fn) {
	    return function(value) {
	      fn.call(context, value);
	    };
	  }
	
	  function processQueue(state) {
	    var fn, deferred, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    for (var i = 0, ii = pending.length; i < ii; ++i) {
	      deferred = pending[i][0];
	      fn = pending[i][state.status];
	      try {
	        if (isFunction(fn)) {
	          deferred.resolve(fn(state.value));
	        } else if (state.status === 1) {
	          deferred.resolve(state.value);
	        } else {
	          deferred.reject(state.value);
	        }
	      } catch (e) {
	        deferred.reject(e);
	        exceptionHandler(e);
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function Deferred() {
	    this.promise = new Promise();
	  }
	
	  extend(Deferred.prototype, {
	    resolve: function(val) {
	      if (this.promise.$$state.status) return;
	      if (val === this.promise) {
	        this.$$reject($qMinErr(
	          'qcycle',
	          'Expected promise to be resolved with value other than itself \'{0}\'',
	          val));
	      } else {
	        this.$$resolve(val);
	      }
	
	    },
	
	    $$resolve: function(val) {
	      var then;
	      var that = this;
	      var done = false;
	      try {
	        if ((isObject(val) || isFunction(val))) then = val && val.then;
	        if (isFunction(then)) {
	          this.promise.$$state.status = -1;
	          then.call(val, resolvePromise, rejectPromise, simpleBind(this, this.notify));
	        } else {
	          this.promise.$$state.value = val;
	          this.promise.$$state.status = 1;
	          scheduleProcessQueue(this.promise.$$state);
	        }
	      } catch (e) {
	        rejectPromise(e);
	        exceptionHandler(e);
	      }
	
	      function resolvePromise(val) {
	        if (done) return;
	        done = true;
	        that.$$resolve(val);
	      }
	      function rejectPromise(val) {
	        if (done) return;
	        done = true;
	        that.$$reject(val);
	      }
	    },
	
	    reject: function(reason) {
	      if (this.promise.$$state.status) return;
	      this.$$reject(reason);
	    },
	
	    $$reject: function(reason) {
	      this.promise.$$state.value = reason;
	      this.promise.$$state.status = 2;
	      scheduleProcessQueue(this.promise.$$state);
	    },
	
	    notify: function(progress) {
	      var callbacks = this.promise.$$state.pending;
	
	      if ((this.promise.$$state.status <= 0) && callbacks && callbacks.length) {
	        nextTick(function() {
	          var callback, result;
	          for (var i = 0, ii = callbacks.length; i < ii; i++) {
	            result = callbacks[i][0];
	            callback = callbacks[i][3];
	            try {
	              result.notify(isFunction(callback) ? callback(progress) : progress);
	            } catch (e) {
	              exceptionHandler(e);
	            }
	          }
	        });
	      }
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  function reject(reason) {
	    var result = new Deferred();
	    result.reject(reason);
	    return result.promise;
	  }
	
	  function handleCallback(value, resolver, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return reject(e);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return resolver(value);
	      }, reject);
	    } else {
	      return resolver(value);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  function when(value, callback, errback, progressBack) {
	    var result = new Deferred();
	    result.resolve(value);
	    return result.promise.then(callback, errback, progressBack);
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var deferred = new Deferred(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        results[key] = value;
	        if (!(--counter)) deferred.resolve(results);
	      }, function(reason) {
	        deferred.reject(reason);
	      });
	    });
	
	    if (counter === 0) {
	      deferred.resolve(results);
	    }
	
	    return deferred.promise;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  function $Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
	    }
	
	    var deferred = new Deferred();
	
	    function resolveFn(value) {
	      deferred.resolve(value);
	    }
	
	    function rejectFn(reason) {
	      deferred.reject(reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return deferred.promise;
	  }
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	/** @this */
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        if ($scope.$$childHead) {
	          cleanUpScope($scope.$$childHead);
	        }
	        if ($scope.$$nextSibling) {
	          cleanUpScope($scope.$$nextSibling);
	        }
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * # Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * # Example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: listener,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!isFunction(listener)) {
	          watcher.fn = noop;
	        }
	
	        if (!array) {
	          array = scope.$$watchers = [];
	          array.$$digestWatchIndex = -1;
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        array.$$digestWatchIndex++;
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          var index = arrayRemove(array, watcher);
	          if (index >= 0) {
	            incrementWatchersCount(scope, -1);
	            if (index < array.$$digestWatchIndex) {
	              array.$$digestWatchIndex--;
	            }
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	            newValues[i] = value;
	            oldValues[i] = oldValue;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          if (firstRun) {
	            firstRun = false;
	            listener(newValues, newValues, self);
	          } else {
	            listener(newValues, oldValues, self);
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * # Example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        $watchCollectionInterceptor.$stateful = true;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              // eslint-disable-next-line no-self-compare
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  // eslint-disable-next-line no-self-compare
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * # Example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            dirty, ttl = TTL,
	            next, current, target = this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $applyAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              asyncTask.scope.$eval(asyncTask.expression, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = current.$$watchers)) {
	              // process our watches
	              watchers.$$digestWatchIndex = watchers.length;
	              while (watchers.$$digestWatchIndex--) {
	                try {
	                  watch = watchers[watchers.$$digestWatchIndex];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (isNumberNaN(value) && isNumberNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	      },
	
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating Angular
	       * expressions.
	       *
	       * # Example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          });
	        }
	
	        asyncQueue.push({scope: this, expression: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in angular from outside of the angular
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the angular framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * ## Life cycle
	       *
	       * # Pseudo-Code of `$apply()`
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            // eslint-disable-next-line no-unsafe-finally
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        if (expr) {
	          applyAsyncQueue.push($applyAsyncExpression);
	        }
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            namedListeners[indexOfListener] = null;
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            event.currentScope = null;
	            return event;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        });
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of Angular application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isImage) {
	      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal;
	      normalizedVal = urlResolve(uri).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* exported $SceProvider, $SceDelegateProvider */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  HTML: 'html',
	  CSS: 'css',
	  URL: 'url',
	  // RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
	  // url.  (e.g. ng-include, script src, templateUrl)
	  RESOURCE_URL: 'resourceUrl',
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace(/\\\*\\\*/g, '.*').
	                  replace(/\\\*/g, '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing Angular templates are safe.  Refer {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 *
	 * For the general details about this service in Angular, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *    provided.  This must be an array or null.  A snapshot of this array is used so further
	   *    changes to the array are ignored.
	   *
	   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *    allowed in this array.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** an empty whitelist array will block all URLs!
	   *    </div>
	   *
	   * @return {Array} the currently set whitelist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *    provided.  This must be an array or null.  A snapshot of this array is used so further
	   *    changes to the array are ignored.
	   *
	   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *    allowed in this array.
	   *
	   *    The typical usage for the blacklist is to **block
	   *    [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *    these would otherwise be trusted but actually return content from the redirected domain.
	   *
	   *    Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} the currently set blacklist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns an object that is trusted by angular for use in specified strict
	     * contextual escaping contexts (such as ng-bind-html, ng-include, any src
	     * attribute interpolation, any dom event binding attribute interpolation
	     * such as for onclick,  etc.) that uses the provided value.
	     * See {@link ng.$sce $sce} for enabling strict contextual escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *      call or anything else.
	     * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
	     * returns the originally supplied value if the queried context type is a supertype of the
	     * created type.  If this condition isn't satisfied, throws an exception.
	     *
	     * <div class="alert alert-danger">
	     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
	     * (XSS) vulnerability in your application.
	     * </div>
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call.
	     * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	      // If we get here, then we may only take one of two actions.
	      // 1. sanitize the value for the requested type, or
	      // 2. throw an exception.
	      if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        return htmlSanitizer(maybeTrusted);
	      }
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * # Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
	 * contexts to result in a value that is marked as safe to use for that context.  One example of
	 * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
	 * to these contexts as privileged or SCE contexts.
	 *
	 * As of version 1.2, Angular ships with SCE enabled by default.
	 *
	 * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
	 * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
	 * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
	 * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
	 * to the top of your HTML document.
	 *
	 * SCE assists in writing code in a way that (a) is secure by default and (b) makes auditing for
	 * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV.
	 * In a more realistic example, one may be rendering user comments, blog articles, etc. via
	 * bindings.  (HTML is just one example of a context where rendering user controlled input creates
	 * security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
	 * determine that something explicitly says it's safe to use a value for binding in that
	 * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
	 * for those values that you can easily tell are safe - because they were received from your server,
	 * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
	 * allowing only the files in a specific directory to do this.  Ensuring that the internal API
	 * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * obtain values that will be accepted by SCE / privileged contexts.
	 *
	 *
	 * ## How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
	 * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ## Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, Angular only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ## This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
	 *
	 * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ## What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG`, `VIDEO`, `AUDIO`, `SOURCE`, and `TRACK` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ## Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).success(function(userComments) {
	 *           self.userComments = userComments;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE.
	   * @return {boolean} true if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way.  In some future, we
	   * may not use inheritance anymore.  That is OK because no code outside of
	   * sce.js and sceSpecs.js would need to be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
	     * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The kind of SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
	     * returns an object that is trusted by angular for use in specified strict contextual
	     * escaping contexts (such as ng-bind-html, ng-include, any src attribute
	     * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
	     * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
	     * escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
	     *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
	     *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
	     *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the return
	     *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
	     *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
	     * originally supplied value if the queried context type is a supertype of the created type.
	     * If this condition isn't satisfied, throws an exception.
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
	     *                         call.
	     * @returns {*} The value the was originally provided to
	     *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
	     *              Otherwise, throws an exception.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[camelCase('parse_as_' + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[camelCase('get_trusted_' + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[camelCase('trust_as_' + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/* exported $SnifferProvider */
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`.
	        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	        // (see https://developer.chrome.com/apps/manifest/sandbox).
	        isChromePackagedApp =
	            $window.chrome &&
	            ($window.chrome.app && $window.chrome.app.runtime ||
	                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        vendorPrefix,
	        vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/,
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false,
	        match;
	
	    if (bodyStyle) {
	      for (var prop in bodyStyle) {
	        if ((match = vendorRegex.exec(prop))) {
	          vendorPrefix = match[0];
	          vendorPrefix = vendorPrefix[0].toUpperCase() + vendorPrefix.substr(1);
	          break;
	        }
	      }
	
	      if (!vendorPrefix) {
	        vendorPrefix = ('WebkitOpacity' in bodyStyle) && 'webkit';
	      }
	
	      transitions = !!(('transition' in bodyStyle) || (vendorPrefix + 'Transition' in bodyStyle));
	      animations  = !!(('animation' in bodyStyle) || (vendorPrefix + 'Animation' in bodyStyle));
	
	      if (android && (!transitions ||  !animations)) {
	        transitions = isString(bodyStyle.webkitTransition);
	        animations = isString(bodyStyle.webkitAnimation);
	      }
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      hasEvent: function(event) {
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie <= 11) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      vendorPrefix: vendorPrefix,
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	var $templateRequestMinErr = minErr('$compile');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$templateCache', '$http', '$q', '$sce', function($templateCache, $http, $q, $sce) {
	
	    function handleRequestFn(tpl, ignoreRequestError) {
	      handleRequestFn.totalPendingRequests++;
	
	      // We consider the template cache holds only trusted templates, so
	      // there's no need to go through whitelisting again for keys that already
	      // are included in there. This also makes Angular accept any script
	      // directive, no matter its name. However, we still need to unwrap trusted
	      // types.
	      if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	        tpl = $sce.getTrustedResourceUrl(tpl);
	      }
	
	      var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	      if (isArray(transformResponse)) {
	        transformResponse = transformResponse.filter(function(transformer) {
	          return transformer !== defaultHttpResponseTransform;
	        });
	      } else if (transformResponse === defaultHttpResponseTransform) {
	        transformResponse = null;
	      }
	
	      return $http.get(tpl, extend({
	          cache: $templateCache,
	          transformResponse: transformResponse
	        }, httpOptions)
	        )['finally'](function() {
	          handleRequestFn.totalPendingRequests--;
	        })
	        .then(function(response) {
	          $templateCache.put(tpl, response.data);
	          return response.data;
	        }, handleError);
	
	      function handleError(resp) {
	        if (!ignoreRequestError) {
	          throw $templateRequestMinErr('tpload', 'Failed to load template: {0} (HTTP status: {1} {2})',
	            tpl, resp.status, resp.statusText);
	        }
	        return $q.reject(resp);
	      }
	    }
	
	    handleRequestFn.totalPendingRequests = 0;
	
	    return handleRequestFn;
	  }];
	}
	
	/** @this */
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) !== -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	/** @this */
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	      *   will be resolved with the return value of the `fn` function.
	      *
	      */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        } finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay);
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */
	    timeout.cancel = function(promise) {
	      if (promise && promise.$$timeoutId in deferreds) {
	        deferreds[promise.$$timeoutId].reject('canceled');
	        delete deferreds[promise.$$timeoutId];
	        return $browser.defer.cancel(promise.$$timeoutId);
	      }
	      return false;
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement('a');
	var originUrl = urlResolve(window.location.href);
	
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */
	function urlResolve(url) {
	  var href = url;
	
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	          parsed.host === originUrl.host);
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In angular we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeGetCookie(rawDocument) {
	    try {
	      return rawDocument.cookie || '';
	    } catch (e) {
	      return '';
	    }
	  }
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = safeGetCookie(rawDocument);
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	/** @this */
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how angular filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the Angular Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services.Angular comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	/** @this */
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if the expected value (from the filter expression) and actual value (from
	 *     the object in the array) should be considered a match.
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        // falls through
	      case 'object':
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          if ((key.charAt(0) !== '$') && deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(/\u00A4/g, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }
	
	  if (i === (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset === -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? '+' : '';
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,
	    NUMBER_STRING = /^-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if ((match = string.match(R_ISO8601_STR))) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @see angular.uppercase
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNumberNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, and sorts values of different types by type.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types, compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` values are treated as the string `'null'` (i.e.
	 *           `type: 'string'`, `value: 'null'`). This may cause unexpected sort order relative to
	 *           other values.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An Angular expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return compare(v1.tieBreaker, v2.tieBreaker) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
	          descending = predicate.charAt(0) === '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'string';
	      value = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = type1 < type2 ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * Angular has a chance to replace the `{{hash}}` markup with its
	 * value. Until Angular replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
	        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
	          element(by.model('master')).click();
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Edge, Firefox, and Internet Explorer do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>Show/Hide me</summary>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName === 'multiple') return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set('ngPattern', new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // on IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // we use attr[attrName] value since $set can sanitize the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  };
	});
	
	/* global -nullFormCtrl, -SUBMITTED_CLASS, addSetValidityMethod: true
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop
	},
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $pending True if at least one containing control or form is pending.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $error Is an object hash, containing references to controls or
	 *  forms with failing validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for given error name.
	 *
	 *  Built-in validation tokens:
	 *
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController(element, attrs, $scope, $animate, $interpolate) {
	  var form = this,
	      controls = [];
	
	  // init state
	  form.$error = {};
	  form.$$success = {};
	  form.$pending = undefined;
	  form.$name = $interpolate(attrs.name || attrs.ngForm || '')($scope);
	  form.$dirty = false;
	  form.$pristine = true;
	  form.$valid = true;
	  form.$invalid = false;
	  form.$submitted = false;
	  form.$$parentForm = nullFormCtrl;
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  form.$rollbackViewValue = function() {
	    forEach(controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  form.$commitViewValue = function() {
	    forEach(controls, function(control) {
	      control.$commitViewValue();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  form.$addControl = function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    controls.push(control);
	
	    if (control.$name) {
	      form[control.$name] = control;
	    }
	
	    control.$$parentForm = form;
	  };
	
	  // Private API: rename a form control
	  form.$$renameControl = function(control, newName) {
	    var oldName = control.$name;
	
	    if (form[oldName] === control) {
	      delete form[oldName];
	    }
	    form[newName] = control;
	    control.$name = newName;
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  form.$removeControl = function(control) {
	    if (control.$name && form[control.$name] === control) {
	      delete form[control.$name];
	    }
	    forEach(form.$pending, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	    forEach(form.$error, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	    forEach(form.$$success, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	
	    arrayRemove(controls, control);
	    control.$$parentForm = nullFormCtrl;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setValidity
	   *
	   * @description
	   * Sets the validity of a form control.
	   *
	   * This method will also propagate to parent forms.
	   */
	  addSetValidityMethod({
	    ctrl: this,
	    $element: element,
	    set: function(object, property, controller) {
	      var list = object[property];
	      if (!list) {
	        object[property] = [controller];
	      } else {
	        var index = list.indexOf(controller);
	        if (index === -1) {
	          list.push(controller);
	        }
	      }
	    },
	    unset: function(object, property, controller) {
	      var list = object[property];
	      if (!list) {
	        return;
	      }
	      arrayRemove(list, controller);
	      if (list.length === 0) {
	        delete object[property];
	      }
	    },
	    $animate: $animate
	  });
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  form.$setDirty = function() {
	    $animate.removeClass(element, PRISTINE_CLASS);
	    $animate.addClass(element, DIRTY_CLASS);
	    form.$dirty = true;
	    form.$pristine = false;
	    form.$$parentForm.$setDirty();
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  form.$setPristine = function() {
	    $animate.setClass(element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    form.$dirty = false;
	    form.$pristine = true;
	    form.$submitted = false;
	    forEach(controls, function(control) {
	      control.$setPristine();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  form.$setUntouched = function() {
	    forEach(controls, function(control) {
	      control.$setUntouched();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */
	  form.$setSubmitted = function() {
	    $animate.addClass(element, SUBMITTED_CLASS);
	    form.$submitted = true;
	    form.$$parentForm.$setSubmitted();
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * # Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * # CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * # Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side Angular applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, Angular prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ## Animation Hooks
	 *
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              addEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  removeEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	// eslint-disable-next-line max-len
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise Angular will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * <div class="alert alert-warning">
	   *   <p>
	   *     In v1.5.9+, in order to avoid interfering with already existing, custom directives for
	   *     `input[range]`, you need to let Angular know that you want to enable its built-in support.
	   *     You can do this by adding the `ng-input-range` attribute to the input element. E.g.:
	   *     `<input type="range" ng-input-range ... />`
	   *   </p><br />
	   *   <p>
	   *     Input elements without the `ng-input-range` attibute will continue to be treated the same
	   *     as in previous versions (e.g. their model value will be a string not a number and Angular
	   *     will not take `min`/`max`/`step` attributes and properties into account).
	   *   </p><br />
	   *   <p>
	   *     **Note:** From v1.6.x onwards, the support for `input[range]` will be always enabled and
	   *     the `ng-input-range` attribute will have no effect.
	   *   </p><br />
	   *   <p>
	   *     This documentation page refers to elements which have the built-in support enabled; i.e.
	   *     elements _with_ the `ng-input-range` attribute.
	   *   </p>
	   * </div>
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for Angular:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-input-range ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * Angular will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, Angular will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the Angular will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with `ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param           ngInputRange The presense of this attribute enables the built-in support for
	   *                  `input[range]`.
	   * @param {string}  ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {string=} ngChange Angular expression to be executed when the ngModel value changes due
	   *                  to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" ng-input-range name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" ng-input-range name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */
	  'range': rangeInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputting intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', /** @this */ function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, date) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (date) {
	          map = {
	            yyyy: date.getFullYear(),
	            MM: date.getMonth() + 1,
	            dd: date.getDate(),
	            HH: date.getHours(),
	            mm: date.getMinutes(),
	            ss: date.getSeconds(),
	            sss: date.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    var timezone = ctrl && ctrl.$options && ctrl.$options.timezone;
	    var previousDate;
	
	    ctrl.$$parserName = type;
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        var parsedDate = parseDate(value, previousDate);
	        if (timezone) {
	          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	        }
	        return parsedDate;
	      }
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        if (previousDate && timezone) {
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	        return $filter('date')(value, format, timezone);
	      } else {
	        previousDate = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	      };
	      attr.$observe('min', function(val) {
	        minVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	      };
	      attr.$observe('max', function(val) {
	        maxVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      return validity.badInput || validity.typeMismatch ? undefined : value;
	    });
	  }
	}
	
	function numberFormatterParser(ctrl) {
	  ctrl.$$parserName = 'number';
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	}
	
	function parseNumberAttrVal(val) {
	  if (isDefined(val) && !isNumber(val)) {
	    val = parseFloat(val);
	  }
	  return !isNumberNaN(val) ? val : undefined;
	}
	
	function isNumberInteger(num) {
	  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	  // (minus the assumption that `num` is a number)
	
	  // eslint-disable-next-line no-bitwise
	  return (num | 0) === num;
	}
	
	function countDecimals(num) {
	  var numString = num.toString();
	  var decimalSymbolIndex = numString.indexOf('.');
	
	  if (decimalSymbolIndex === -1) {
	    if (-1 < num && num < 1) {
	      // It may be in the exponential notation format (`1e-X`)
	      var match = /e-(\d+)$/.exec(numString);
	
	      if (match) {
	        return Number(match[1]);
	      }
	    }
	
	    return 0;
	  }
	
	  return numString.length - decimalSymbolIndex - 1;
	}
	
	function isValidForStep(viewValue, stepBase, step) {
	  // At this point `stepBase` and `step` are expected to be non-NaN values
	  // and `viewValue` is expected to be a valid stringified number.
	  var value = Number(viewValue);
	
	  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	  if (!isNumberInteger(value) || !isNumberInteger(stepBase) || !isNumberInteger(step)) {
	    var decimalCount = Math.max(countDecimals(value), countDecimals(stepBase), countDecimals(step));
	    var multiplier = Math.pow(10, decimalCount);
	
	    value = value * multiplier;
	    stepBase = stepBase * multiplier;
	    step = step * multiplier;
	  }
	
	  return (value - stepBase) % step === 0;
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  numberFormatterParser(ctrl);
	
	  var minVal;
	  var maxVal;
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    ctrl.$validators.min = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	    };
	
	    attr.$observe('min', function(val) {
	      minVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    ctrl.$validators.max = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      maxVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	}
	
	function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
	      minVal = supportsRange ? 0 : undefined,
	      maxVal = supportsRange ? 100 : undefined,
	      stepVal = supportsRange ? 1 : undefined,
	      validity = element[0].validity,
	      hasMinAttr = isDefined(attr.min),
	      hasMaxAttr = isDefined(attr.max),
	      hasStepAttr = isDefined(attr.step);
	
	  var originalRender = ctrl.$render;
	
	  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
	    //Browsers that implement range will set these values automatically, but reading the adjusted values after
	    //$render would cause the min / max validators to be applied with the wrong value
	    function rangeRender() {
	      originalRender();
	      ctrl.$setViewValue(element.val());
	    } :
	    originalRender;
	
	  if (hasMinAttr) {
	    ctrl.$validators.min = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMinValidator() { return true; } :
	      // non-support browsers validate the min val
	      function minValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
	      };
	
	    setInitialValueAndObserver('min', minChange);
	  }
	
	  if (hasMaxAttr) {
	    ctrl.$validators.max = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMaxValidator() { return true; } :
	      // non-support browsers validate the max val
	      function maxValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
	      };
	
	    setInitialValueAndObserver('max', maxChange);
	  }
	
	  if (hasStepAttr) {
	    ctrl.$validators.step = supportsRange ?
	      function nativeStepValidator() {
	        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	        // input element value to a valid value). It's possible that other browsers set the stepMismatch
	        // validity error instead, so we can at least report an error in that case.
	        return !validity.stepMismatch;
	      } :
	      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	      function stepValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	               isValidForStep(viewValue, minVal || 0, stepVal);
	      };
	
	    setInitialValueAndObserver('step', stepChange);
	  }
	
	  function setInitialValueAndObserver(htmlAttrName, changeFn) {
	    // interpolated attributes set the attribute value only after a digest, but we need the
	    // attribute value when the input is first rendered, so that the browser can adjust the
	    // input value based on the min/max value
	    element.attr(htmlAttrName, attr[htmlAttrName]);
	    attr.$observe(htmlAttrName, changeFn);
	  }
	
	  function minChange(val) {
	    minVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
	      if (minVal > elVal) {
	        elVal = minVal;
	        element.val(elVal);
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function maxChange(val) {
	    maxVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
	      if (maxVal < elVal) {
	        element.val(maxVal);
	        // IE11 and Chrome don't set the value to the minVal when max < min
	        elVal = maxVal < minVal ? minVal : maxVal;
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function stepChange(val) {
	    stepVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
	    if (supportsRange && ctrl.$viewValue !== element.val()) {
	      ctrl.$setViewValue(element.val());
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'url';
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'email';
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    if (element[0].checked) {
	      ctrl.$setViewValue(attr.value, ev && ev.type);
	    }
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    // We generally use strict comparison. This is behavior we cannot change without a BC.
	    // eslint-disable-next-line eqeqeq
	    element[0].checked = (value == ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with angular data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when Angular tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          var type = lowercase(attr.type);
	          if ((type === 'range') && !attr.hasOwnProperty('ngInputRange')) {
	            type = 'text';
	          }
	          (inputType[type] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 *
	 * @description
	 * Binds the given expression to the value of `<option>` or {@link input[radio] `input[radio]`},
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element is set to
	 * the bound value.
	 *
	 * `ngValue` is useful when dynamically generating lists of radio buttons using
	 * {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * Likewise, `ngValue` can be used to generate `<option>` elements for
	 * the {@link select `select`} element. In that case however, only strings are supported
	 * for the `value `attribute, so the resulting `ngModel` will always be a string.
	 * Support for `select` models with non-string values is available via `ngOptions`.
	 *
	 * @element input
	 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
	 *   of the `input` element
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          attr.$set('value', scope.$eval(attr.ngValue));
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            attr.$set('value', value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element input
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var oldVal;
	
	        attr.$observe('class', function(value) {
	          ngClassWatchAction(scope.$eval(attr[name]));
	        });
	
	
	        if (name !== 'ngClass') {
	          scope.$watch('$index', function($index, old$index) {
	            /* eslint-disable no-bitwise */
	            var mod = $index & 1;
	            if (mod !== (old$index & 1)) {
	              var classes = arrayClasses(oldVal);
	              if (mod === selector) {
	                addClasses(classes);
	              } else {
	                removeClasses(classes);
	              }
	            }
	            /* eslint-enable */
	          });
	        }
	
	        scope.$watch(attr[name], ngClassWatchAction, true);
	
	        function addClasses(classes) {
	          var newClasses = digestClassCounts(classes, 1);
	          attr.$addClass(newClasses);
	        }
	
	        function removeClasses(classes) {
	          var newClasses = digestClassCounts(classes, -1);
	          attr.$removeClass(newClasses);
	        }
	
	        function digestClassCounts(classes, count) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          var classCounts = element.data('$classCounts') || createMap();
	          var classesToUpdate = [];
	          forEach(classes, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	          element.data('$classCounts', classCounts);
	          return classesToUpdate.join(' ');
	        }
	
	        function updateClasses(oldClasses, newClasses) {
	          var toAdd = arrayDifference(newClasses, oldClasses);
	          var toRemove = arrayDifference(oldClasses, newClasses);
	          toAdd = digestClassCounts(toAdd, 1);
	          toRemove = digestClassCounts(toRemove, -1);
	          if (toAdd && toAdd.length) {
	            $animate.addClass(element, toAdd);
	          }
	          if (toRemove && toRemove.length) {
	            $animate.removeClass(element, toRemove);
	          }
	        }
	
	        function ngClassWatchAction(newVal) {
	          // eslint-disable-next-line no-bitwise
	          if (selector === true || (scope.$index & 1) === selector) {
	            var newClasses = arrayClasses(newVal || []);
	            if (!oldVal) {
	              addClasses(newClasses);
	            } else if (!equals(newVal,oldVal)) {
	              var oldClasses = arrayClasses(oldVal);
	              updateClasses(oldClasses, newClasses);
	            }
	          }
	          if (isArray(newVal)) {
	            oldVal = newVal.map(function(v) { return shallowCopy(v); });
	          } else {
	            oldVal = shallowCopy(newVal);
	          }
	        }
	      }
	    };
	
	    function arrayDifference(tokens1, tokens2) {
	      var values = [];
	
	      outer:
	      for (var i = 0; i < tokens1.length; i++) {
	        var token = tokens1[i];
	        for (var j = 0; j < tokens2.length; j++) {
	          if (token === tokens2[j]) continue outer;
	        }
	        values.push(token);
	      }
	      return values;
	    }
	
	    function arrayClasses(classVal) {
	      var classes = [];
	      if (isArray(classVal)) {
	        forEach(classVal, function(v) {
	          classes = classes.concat(arrayClasses(v));
	        });
	        return classes;
	      } else if (isString(classVal)) {
	        return classVal.split(' ');
	      } else if (isObject(classVal)) {
	        forEach(classVal, function(v, k) {
	          if (v) {
	            classes = classes.concat(k.split(' '));
	          }
	        });
	        return classes;
	      }
	      return classVal;
	    }
	  }];
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example Example that demonstrates basic bindings via ngClass directive.
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   ## Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	
	
	   ## ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the angular markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the Angular community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * Angular has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell Angular not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect Angular:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. Angular makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating Angular expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. Angular makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related Angular features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that Angular will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of Angular.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of Angular.
	 *
	 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	  * @example
	      <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	      <example name="example.csp" module="cspExample" ng-csp="true">
	        <file name="index.html">
	          <div ng-controller="MainController as ctrl">
	            <div>
	              <button ng-click="ctrl.inc()" id="inc">Increment</button>
	              <span id="counter">
	                {{ctrl.counter}}
	              </span>
	            </div>
	
	            <div>
	              <button ng-click="ctrl.evil()" id="evil">Evil</button>
	              <span id="evilError">
	                {{ctrl.evilError}}
	              </span>
	            </div>
	          </div>
	        </file>
	        <file name="script.js">
	           angular.module('cspExample', [])
	             .controller('MainController', function MainController() {
	                this.counter = 0;
	                this.inc = function() {
	                  this.counter++;
	                };
	                this.evil = function() {
	                  try {
	                    eval('1+2'); // eslint-disable-line no-eval
	                  } catch (e) {
	                    this.evilError = e.message;
	                  }
	                };
	              });
	        </file>
	        <file name="protractor.js" type="protractor">
	          var util, webdriver;
	
	          var incBtn = element(by.id('inc'));
	          var counter = element(by.id('counter'));
	          var evilBtn = element(by.id('evil'));
	          var evilError = element(by.id('evilError'));
	
	          function getAndClearSevereErrors() {
	            return browser.manage().logs().get('browser').then(function(browserLog) {
	              return browserLog.filter(function(logEntry) {
	                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	              });
	            });
	          }
	
	          function clearErrors() {
	            getAndClearSevereErrors();
	          }
	
	          function expectNoErrors() {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              expect(filteredLog.length).toEqual(0);
	              if (filteredLog.length) {
	                console.log('browser console errors: ' + util.inspect(filteredLog));
	              }
	            });
	          }
	
	          function expectError(regex) {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              var found = false;
	              filteredLog.forEach(function(log) {
	                if (log.message.match(regex)) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                throw new Error('expected an error that matches ' + regex);
	              }
	            });
	          }
	
	          beforeEach(function() {
	            util = require('util');
	            webdriver = require('selenium-webdriver');
	          });
	
	          // For now, we only test on Chrome,
	          // as Safari does not load the page with Protractor's injected scripts,
	          // and Firefox webdriver always disables content security policy (#6358)
	          if (browser.params.browser !== 'chrome') {
	            return;
	          }
	
	          it('should not report errors when the page is loaded', function() {
	            // clear errors so we are not dependent on previous tests
	            clearErrors();
	            // Need to reload the page as the page is already loaded when
	            // we come here
	            browser.driver.getCurrentUrl().then(function(url) {
	              browser.get(url);
	            });
	            expectNoErrors();
	          });
	
	          it('should evaluate expressions', function() {
	            expect(counter.getText()).toEqual('0');
	            incBtn.click();
	            expect(counter.getText()).toEqual('1');
	            expectNoErrors();
	          });
	
	          it('should throw and report an error when using "eval"', function() {
	            evilBtn.click();
	            expect(evilError.getText()).toMatch(/Content Security Policy/);
	            expectError(/Content Security Policy/);
	          });
	        </file>
	      </example>
	  */
	
	// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * angular expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	      return {
	        restrict: 'A',
	        compile: function($element, attr) {
	          // We expose the powerful $event object on the scope that provides access to the Window,
	          // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
	          // checks at the cost of speed since event handler expressions are not executed as
	          // frequently as regular change detection.
	          var fn = $parse(attr[directiveName], /* interceptorFn */ null, /* expensiveChecks */ true);
	          return function ngEventHandler(scope, element) {
	            element.on(eventName, function(event) {
	              var callback = function() {
	                fn(scope, {$event:event});
	              };
	              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                scope.$evalAsync(callback);
	              } else {
	                scope.$apply(callback);
	              }
	            });
	          };
	        }
	      };
	    }];
	  }
	);
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @element ANY
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 *
	 * @description
	 * Enables binding angular expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @element form
	 * @priority 0
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).done(function(response) {
	                if (response !== false) previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 *
	 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).done(function(response) {
	              if (response !== false) previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function(response) {
	            if (response !== false && isDefined(autoScrollExp) &&
	              (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).done(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
	 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
	 * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
	 * rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @priority 450
	 *
	 * @element ANY
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * ### Example with Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Example - splitting on newline
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @element input
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      // We want to control whitespace trimming so we use this convoluted approach
	      // to access the ngList attribute, which doesn't pre-trim the attribute
	      var ngList = element.attr(attr.$attr.ngList) || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true
	*/
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    PENDING_CLASS = 'ng-pending',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 *
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	       the control reads value from the DOM. The functions are called in array order, each passing
	       its return value through to the next. The last return value is forwarded to the
	       {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	`$viewValue`}.
	
	Returning `undefined` from a parser means a parse error occurred. In that case,
	no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	       the model value changes. The functions are called in reverse array order, each passing the value through to the
	       next. The last return value is used as the actual DOM value.
	       Used to format / convert values for display in the control.
	 * ```js
	 * function formatter(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(formatter);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
	 *     view value has changed. It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * Angular provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	var NgModelController = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$rootScope', '$q', '$interpolate',
	    /** @this */ function($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $rootScope, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	
	  var parsedNgModel = $parse($attr.ngModel),
	      parsedNgModelAssign = parsedNgModel.assign,
	      ngModelGet = parsedNgModel,
	      ngModelSet = parsedNgModelAssign,
	      pendingDebounce = null,
	      parserValid,
	      ctrl = this;
	
	  this.$$setOptions = function(options) {
	    ctrl.$options = options;
	    if (options && options.getterSetter) {
	      var invokeModelGetter = $parse($attr.ngModel + '()'),
	          invokeModelSetter = $parse($attr.ngModel + '($$$p)');
	
	      ngModelGet = function($scope) {
	        var modelValue = parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      ngModelSet = function($scope, newValue) {
	        if (isFunction(parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
	          $attr.ngModel, startingTag($element));
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  this.$render = noop;
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  this.$isEmpty = function(value) {
	    // eslint-disable-next-line no-self-compare
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  };
	
	  this.$$updateEmptyClasses = function(value) {
	    if (ctrl.$isEmpty(value)) {
	      $animate.removeClass($element, NOT_EMPTY_CLASS);
	      $animate.addClass($element, EMPTY_CLASS);
	    } else {
	      $animate.removeClass($element, EMPTY_CLASS);
	      $animate.addClass($element, NOT_EMPTY_CLASS);
	    }
	  };
	
	
	  var currentValidationRunId = 0;
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setValidity
	   *
	   * @description
	   * Change the validity state, and notify the form.
	   *
	   * This method can be called within $parsers/$formatters or a custom validation implementation.
	   * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	   * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	   *
	   * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	   *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	   *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	   *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	   *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	   *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
	   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	   *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	   *                          Skipped is used by Angular when validators do not run because of parse errors and
	   *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	   */
	  addSetValidityMethod({
	    ctrl: this,
	    $element: $element,
	    set: function(object, property) {
	      object[property] = true;
	    },
	    unset: function(object, property) {
	      delete object[property];
	    },
	    $animate: $animate
	  });
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  this.$setPristine = function() {
	    ctrl.$dirty = false;
	    ctrl.$pristine = true;
	    $animate.removeClass($element, DIRTY_CLASS);
	    $animate.addClass($element, PRISTINE_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  this.$setDirty = function() {
	    ctrl.$dirty = true;
	    ctrl.$pristine = false;
	    $animate.removeClass($element, PRISTINE_CLASS);
	    $animate.addClass($element, DIRTY_CLASS);
	    ctrl.$$parentForm.$setDirty();
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  this.$setUntouched = function() {
	    ctrl.$touched = false;
	    ctrl.$untouched = true;
	    $animate.setClass($element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  this.$setTouched = function() {
	    ctrl.$touched = true;
	    ctrl.$untouched = false;
	    $animate.setClass($element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because Angular's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  this.$rollbackViewValue = function() {
	    $timeout.cancel(pendingDebounce);
	    ctrl.$viewValue = ctrl.$$lastCommittedViewValue;
	    ctrl.$render();
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  this.$validate = function() {
	    // ignore $validate before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    var viewValue = ctrl.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = ctrl.$$rawModelValue;
	
	    var prevValid = ctrl.$valid;
	    var prevModelValue = ctrl.$modelValue;
	
	    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	
	    ctrl.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check ctrl.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        ctrl.$modelValue = allValid ? modelValue : undefined;
	
	        if (ctrl.$modelValue !== prevModelValue) {
	          ctrl.$$writeModelToScope();
	        }
	      }
	    });
	
	  };
	
	  this.$$runValidators = function(modelValue, viewValue, doneCallback) {
	    currentValidationRunId++;
	    var localValidationRunId = currentValidationRunId;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = ctrl.$$parserName || 'parse';
	      if (isUndefined(parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!parserValid) {
	          forEach(ctrl.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(ctrl.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, parserValid);
	        return parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(ctrl.$validators, function(validator, name) {
	        var result = validator(modelValue, viewValue);
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(ctrl.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(ctrl.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        $q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === currentValidationRunId) {
	        ctrl.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  this.$commitViewValue = function() {
	    var viewValue = ctrl.$viewValue;
	
	    $timeout.cancel(pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (ctrl.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !ctrl.$$hasNativeValidators)) {
	      return;
	    }
	    ctrl.$$updateEmptyClasses(viewValue);
	    ctrl.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (ctrl.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  };
	
	  this.$$parseAndValidate = function() {
	    var viewValue = ctrl.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    parserValid = isUndefined(modelValue) ? undefined : true;
	
	    if (parserValid) {
	      for (var i = 0; i < ctrl.$parsers.length; i++) {
	        modelValue = ctrl.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumberNaN(ctrl.$modelValue)) {
	      // ctrl.$modelValue has not been touched yet...
	      ctrl.$modelValue = ngModelGet($scope);
	    }
	    var prevModelValue = ctrl.$modelValue;
	    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	    ctrl.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      ctrl.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    ctrl.$$runValidators(modelValue, ctrl.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check ctrl.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        ctrl.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (ctrl.$modelValue !== prevModelValue) {
	        ctrl.$$writeModelToScope();
	      }
	    }
	  };
	
	  this.$$writeModelToScope = function() {
	    ngModelSet($scope, ctrl.$modelValue);
	    forEach(ctrl.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        $exceptionHandler(e);
	      }
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value sent directly for processing, finally to be applied to `$modelValue` and then the
	   * **expression** specified in the `ng-model` attribute. Lastly, all the registered change listeners,
	   * in the `$viewChangeListeners` list, are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  this.$setViewValue = function(value, trigger) {
	    ctrl.$viewValue = value;
	    if (!ctrl.$options || ctrl.$options.updateOnDefault) {
	      ctrl.$$debounceViewValueCommit(trigger);
	    }
	  };
	
	  this.$$debounceViewValueCommit = function(trigger) {
	    var debounceDelay = 0,
	        options = ctrl.$options,
	        debounce;
	
	    if (options && isDefined(options.debounce)) {
	      debounce = options.debounce;
	      if (isNumber(debounce)) {
	        debounceDelay = debounce;
	      } else if (isNumber(debounce[trigger])) {
	        debounceDelay = debounce[trigger];
	      } else if (isNumber(debounce['default'])) {
	        debounceDelay = debounce['default'];
	      }
	    }
	
	    $timeout.cancel(pendingDebounce);
	    if (debounceDelay) {
	      pendingDebounce = $timeout(function() {
	        ctrl.$commitViewValue();
	      }, debounceDelay);
	    } else if ($rootScope.$$phase) {
	      ctrl.$commitViewValue();
	    } else {
	      $scope.$apply(function() {
	        ctrl.$commitViewValue();
	      });
	    }
	  };
	
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  $scope.$watch(function ngModelWatch() {
	    var modelValue = ngModelGet($scope);
	
	    // if scope model value and ngModel value are out of sync
	    // TODO(perf): why not move this to the action fn?
	    if (modelValue !== ctrl.$modelValue &&
	       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	        // eslint-disable-next-line no-self-compare
	       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
	      parserValid = undefined;
	
	      var formatters = ctrl.$formatters,
	          idx = formatters.length;
	
	      var viewValue = modelValue;
	      while (idx--) {
	        viewValue = formatters[idx](viewValue);
	      }
	      if (ctrl.$viewValue !== viewValue) {
	        ctrl.$$updateEmptyClasses(viewValue);
	        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
	        ctrl.$render();
	
	        // It is possible that model and view value have been updated during render
	        ctrl.$$runValidators(ctrl.$modelValue, ctrl.$viewValue, noop);
	      }
	    }
	
	    return modelValue;
	  });
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 *
	 * @element input
	 * @priority 1
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * # Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * # CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * ## Animation Hooks
	 *
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * ## Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm;
	
	          modelCtrl.$$setOptions(ctrls[2] && ctrls[2].$options);
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          if (modelCtrl.$options && modelCtrl.$options.updateOn) {
	            element.on(modelCtrl.$options.updateOn, function(ev) {
	              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
	            });
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(modelCtrl.$setTouched);
	            } else {
	              scope.$apply(modelCtrl.$setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	
	
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 *
	 * @description
	 * Allows tuning how model updates are done. Using `ngModelOptions` you can specify a custom list of
	 * events that will trigger a model update and/or a debouncing delay so that the actual update only
	 * takes place when a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController `$rollbackViewValue`} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController `$rollbackViewValue`}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * `ngModelOptions` has an effect on the element it's declared on and its descendants.
	 *
	 * @param {Object} ngModelOptions options to apply to the current model. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging of the control.
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     `ng-model-options="{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }"`
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	       `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date">`, `<input type="time">`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 * @example
	
	  The following example shows how to override immediate updates. Changes on the inputs within the
	  form will update the model only when the control loses focus (blur event). If `escape` key is
	  pressed while the input field is focused, the value is reset to the value in the current model.
	
	  <example name="ngModelOptions-directive-blur" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ updateOn: 'blur' }"
	                   ng-keyup="cancel($event)" />
	          </label><br />
	          <label>Other data:
	            <input type="text" ng-model="user.data" />
	          </label><br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	        <pre>user.data = <span ng-bind="user.data"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'John', data: '' };
	
	          $scope.cancel = function(e) {
	            if (e.keyCode === 27) {
	              $scope.userForm.userName.$rollbackViewValue();
	            }
	          };
	        }]);
	    </file>
	    <file name="protractor.js" type="protractor">
	      var model = element(by.binding('user.name'));
	      var input = element(by.model('user.name'));
	      var other = element(by.model('user.data'));
	
	      it('should allow custom events', function() {
	        input.sendKeys(' Doe');
	        input.click();
	        expect(model.getText()).toEqual('John');
	        other.click();
	        expect(model.getText()).toEqual('John Doe');
	      });
	
	      it('should $rollbackViewValue when model changes', function() {
	        input.sendKeys(' Doe');
	        expect(input.getAttribute('value')).toEqual('John Doe');
	        input.sendKeys(protractor.Key.ESCAPE);
	        expect(input.getAttribute('value')).toEqual('John');
	        other.click();
	        expect(model.getText()).toEqual('John');
	      });
	    </file>
	  </example>
	
	  This one shows how to debounce model changes. Model will be updated only 1 sec after last change.
	  If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	
	  <example name="ngModelOptions-directive-debounce" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ debounce: 1000 }" />
	          </label>
	          <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button>
	          <br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'Igor' };
	        }]);
	    </file>
	  </example>
	
	  This one shows how to bind to getter/setters:
	
	  <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ getterSetter: true }" />
	          </label>
	        </form>
	        <pre>user.name = <span ng-bind="user.name()"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('getterSetterExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          var _name = 'Brian';
	          $scope.user = {
	            name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	            }
	          };
	        }]);
	    </file>
	  </example>
	 */
	var ngModelOptionsDirective = function() {
	  return {
	    restrict: 'A',
	    controller: ['$scope', '$attrs', function NgModelOptionsController($scope, $attrs) {
	      var that = this;
	      this.$options = copy($scope.$eval($attrs.ngModelOptions));
	      // Allow adding/overriding bound events
	      if (isDefined(this.$options.updateOn)) {
	        this.$options.updateOnDefault = false;
	        // extract "default" pseudo-event from list of events that can trigger a model update
	        this.$options.updateOn = trim(this.$options.updateOn.replace(DEFAULT_REGEXP, function() {
	          that.$options.updateOnDefault = true;
	          return ' ';
	        }));
	      } else {
	        this.$options.updateOnDefault = true;
	      }
	    }]
	  };
	};
	
	
	
	// helper methods
	function addSetValidityMethod(context) {
	  var ctrl = context.ctrl,
	      $element = context.$element,
	      classCache = {},
	      set = context.set,
	      unset = context.unset,
	      $animate = context.$animate;
	
	  classCache[INVALID_CLASS] = !(classCache[VALID_CLASS] = $element.hasClass(VALID_CLASS));
	
	  ctrl.$setValidity = setValidity;
	
	  function setValidity(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet('$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup('$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(ctrl.$error, validationErrorKey, controller);
	      unset(ctrl.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(ctrl.$error, validationErrorKey, controller);
	        set(ctrl.$$success, validationErrorKey, controller);
	      } else {
	        set(ctrl.$error, validationErrorKey, controller);
	        unset(ctrl.$$success, validationErrorKey, controller);
	      }
	    }
	    if (ctrl.$pending) {
	      cachedToggleClass(PENDING_CLASS, true);
	      ctrl.$valid = ctrl.$invalid = undefined;
	      toggleValidationCss('', null);
	    } else {
	      cachedToggleClass(PENDING_CLASS, false);
	      ctrl.$valid = isObjectEmpty(ctrl.$error);
	      ctrl.$invalid = !ctrl.$valid;
	      toggleValidationCss('', ctrl.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in ctrl.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (ctrl.$pending && ctrl.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (ctrl.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (ctrl.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(validationErrorKey, combinedState);
	    ctrl.$$parentForm.$setValidity(validationErrorKey, combinedState, ctrl);
	  }
	
	  function createAndSet(name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(className, switchValue) {
	    if (switchValue && !classCache[className]) {
	      $animate.addClass($element, className);
	      classCache[className] = true;
	    } else if (!switchValue && classCache[className]) {
	      $animate.removeClass($element, className);
	      classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 *
	 * @description
	 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
	 * DOM element. This is useful if the element contains what appears to be Angular directives and
	 * bindings but which should be ignored by Angular. This could be the case if you have a site that
	 * displays snippets of code, for instance.
	 *
	 * @element ANY
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	 * @example
	    <example name="ng-non-bindable">
	      <file name="index.html">
	        <div>Normal: {{1 + 2}}</div>
	        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	      </file>
	      <file name="protractor.js" type="protractor">
	       it('should check ng-non-bindable', function() {
	         expect(element(by.binding('1 + 2')).getText()).toContain('3');
	         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	       });
	      </file>
	    </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* exported ngOptionsDirective */
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements
	 * instead of `ngOptions` to achieve a similar result.
	 * However, `ngOptions` provides some benefits such as reducing memory and
	 * increasing speed by not creating a new scope for each repeated instance, as well as providing
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression. `ngOptions` should be used when the `<select>` model needs to be bound
	 *  to a non-string value. This is because an option element can only be bound to string values at
	 * present.
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {comprehension_expression=} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	/* eslint-disable max-len */
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	/* eslint-enable */
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        'Expected expression in form of ' +
	        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
	        ' but got \'{0}\'. Element: {1}',
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // we can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      var emptyOption;
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      var providedEmptyOption = !!emptyOption;
	      var emptyOptionRendered = false;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      var renderEmptyOption = function() {
	        if (!providedEmptyOption) {
	          selectElement.prepend(emptyOption);
	        }
	        selectElement.val('');
	        if (emptyOptionRendered) {
	          emptyOption.prop('selected', true); // needed for IE
	          emptyOption.attr('selected', true);
	        }
	      };
	
	      var removeEmptyOption = function() {
	        if (!providedEmptyOption) {
	          emptyOption.remove();
	        } else if (emptyOptionRendered) {
	          emptyOption.removeAttr('selected');
	        }
	      };
	
	      var renderUnknownOption = function() {
	        selectElement.prepend(unknownOption);
	        selectElement.val('?');
	        unknownOption.prop('selected', true); // needed for IE
	        unknownOption.attr('selected', true);
	      };
	
	      var removeUnknownOption = function() {
	        unknownOption.remove();
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          var selectedOption = options.selectValueMap[selectElement.val()];
	          var option = options.getOptionFromViewValue(value);
	
	          // Make sure to remove the selected attribute from the previously selected option
	          // Otherwise, screen readers might get confused
	          if (selectedOption) selectedOption.element.removeAttribute('selected');
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              removeUnknownOption();
	              removeEmptyOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            if (value === null || providedEmptyOption) {
	              removeUnknownOption();
	              renderEmptyOption();
	            } else {
	              removeEmptyOption();
	              renderUnknownOption();
	            }
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            removeEmptyOption();
	            removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        // FIXME: When a user selects an option, this watch will fire needlessly
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(value) {
	          options.items.forEach(function(option) {
	            option.element.selected = false;
	          });
	
	          if (value) {
	            value.forEach(function(item) {
	              var option = options.getOptionFromViewValue(item);
	              if (option) option.element.selected = true;
	            });
	          }
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	
	      if (providedEmptyOption) {
	
	        // we need to remove it before calling selectElement.empty() because otherwise IE will
	        // remove the label from the element. wtf?
	        emptyOption.remove();
	
	        // compile the element since there might be bindings in it
	        $compile(emptyOption)(scope);
	
	        if (emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
	          // This means the empty option has currently no actual DOM node, probably because
	          // it has been modified by a transclusion directive.
	
	          emptyOptionRendered = false;
	
	          // Redefine the registerOption function, which will catch
	          // options that are added by ngIf etc. (rendering of the node is async because of
	          // lazy transclusion)
	          selectCtrl.registerOption = function(optionScope, optionEl) {
	            if (optionEl.val() === '') {
	              emptyOptionRendered = true;
	              emptyOption = optionEl;
	              emptyOption.removeClass('ng-scope');
	              // This ensures the new empty option is selected if previously no option was selected
	              ngModelCtrl.$render();
	
	              optionEl.on('$destroy', function() {
	                emptyOption = undefined;
	                emptyOptionRendered = false;
	              });
	            }
	          };
	
	        } else {
	          emptyOption.removeClass('ng-scope');
	          emptyOptionRendered = true;
	        }
	
	      } else {
	        emptyOption = jqLite(optionTemplate.cloneNode(false));
	      }
	
	      selectElement.empty();
	
	      // We need to do this here to ensure that the options object is defined
	      // when we first hit it in writeNgOptionsValue
	      updateOptions();
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // NOTE: The label must be set before the value, otherwise IE10/11/EDGE create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        // Ensure that the empty option is always there if it was explicitly provided
	        if (providedEmptyOption) {
	          selectElement.prepend(emptyOption);
	        }
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * # Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in Angular's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * # Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * Angular expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, Angular will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * # Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNumberNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/* exported ngRepeatDirective */
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * # Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so Angular relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * # Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * The default tracking function (which tracks items by their identity) does not allow
	 * duplicate items in arrays. This is because when there are duplicates, it is not possible
	 * to maintain a one-to-one mapping between collection items and DOM elements.
	 *
	 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
	 * with your own using the `track by` expression.
	 *
	 * For example, you may track items by the index of each item in the collection, using the
	 * special scope property `$index`:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * You may also use arbitrary expressions in `track by`, including references to custom functions
	 * on the scope:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-success">
	 * If you are working with objects that have a unique identifier property, you should track
	 * by this identifier instead of the object instance. Should you reload your data later, `ngRepeat`
	 * will not have to rebuild the DOM elements for items it has already rendered, even if the
	 * JavaScript objects in the collection have been substituted for new ones. For large collections,
	 * this significantly improves rendering performance. If you don't have a unique identifier,
	 * `track by $index` can also provide a performance boost.
	 * </div>
	 *
	 * ```html
	 *    <div ng-repeat="model in collection track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 * Avoid using `track by $index` when the repeated template contains
	 * {@link guide/expression#one-time-binding one-time bindings}. In such cases, the `nth` DOM
	 * element will always be matched with the `nth` item of the array, so the bindings on that element
	 * will not be updated even when the corresponding item changes, essentially causing the view to get
	 * out-of-sync with the underlying data.
	 * </div>
	 *
	 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
	 * `$id` function, which tracks items by their identity:
	 * ```html
	 *    <div ng-repeat="obj in collection track by $id(obj)">
	 *      {{obj.prop}}
	 *    </div>
	 * ```
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 * **Note:** `track by` must always be the last expression:
	 * </div>
	 * ```
	 *    <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 *
	 * # Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     Note that the tracking expression must come last, after any filters, and the alias expression.
	 *
	 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
	 *     will be associated by item identity in the array.
	 *
	 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
	 *     element in the same way in the DOM.
	 *
	 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
	 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
	 *     property is same.
	 *
	 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
	 *     to items in conjunction with a tracking expression.
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
	 *     (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true" name="ng-repeat">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // eslint-disable-next-line no-bitwise
	    scope.$odd = !(scope.$even = (index & 1) === 0);
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
	          aliasAs);
	      }
	
	      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	      var hashFnLocals = {$id: hashKey};
	
	      if (trackByExp) {
	        trackByExpGetter = $parse(trackByExp);
	      } else {
	        trackByIdArrayFn = function(key, value) {
	          return hashKey(value);
	        };
	        trackByIdObjFn = function(key) {
	          return key;
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        if (trackByExpGetter) {
	          trackByIdExpFn = function(key, value, index) {
	            // assign key, value, and $index to the locals so that they can be used in hash functions
	            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	            hashFnLocals[valueIdentifier] = value;
	            hashFnLocals.$index = index;
	            return trackByExpGetter($scope, hashFnLocals);
	          };
	        }
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - element: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn(key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) !== nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngShow` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override anything in CSS and the animations will work around the
	 * display style.
	 *
	 * ## A note about animations with `ngShow`
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                        |
	 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is shown/hidden respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element animate-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element funky-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngHide` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the
	 * display style.
	 *
	 * ## A note about animations with `ngHide`
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                     |
	 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
	 *
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is hidden/shown respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element animate-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element funky-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, '');});
	    }
	    if (newStyles) element.css(newStyles);
	  }, true);
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function NgSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function(response) {
	            if (response !== false) array.splice(index, 1);
	          };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	
	        // Start with the last, in case the array is modified during the loop
	        while (previousLeaveAnimations.length) {
	          $animate.cancel(previousLeaveAnimations.pop());
	        }
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
	          runner.done(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	
	    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
	      // Filter duplicate cases
	      function(element, index, array) { return array[index - 1] !== element; }
	    );
	
	    forEach(cases, function(whenCase) {
	      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
	      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
	    });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty, the existing content is left intact. This lets you provide fallback content in the case
	 * that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}">{{text}}</pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    terminal: true,
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type === 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	/* exported selectDirective, optionDirective */
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function chromeHack(optionElement) {
	  // Workaround for https://code.google.com/p/chromium/issues/detail?id=381459
	  // Adding an <option selected="selected"> element to a <select required="required"> should
	  // automatically select the new element
	  if (optionElement[0].hasAttribute('selected')) {
	    optionElement[0].selected = true;
	  }
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 * @description
	 * The controller for the `<select>` directive. This provides support for reading
	 * and writing the selected value(s) of the control and also coordinates dynamically
	 * added `<option>` elements, perhaps by an `ngRepeat` directive.
	 */
	var SelectController =
	        ['$element', '$scope', /** @this */ function($element, $scope) {
	
	  var self = this,
	      optionsMap = new HashMap();
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	  self.renderUnknownOption = function(val) {
	    var unknownVal = '? ' + hashKey(val) + ' ?';
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    $element.val(unknownVal);
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    self.removeUnknownOption();
	    return $element.val();
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	      $element.val(value);
	      if (value === '') self.emptyOption.prop('selected', true); // to make IE9 happy
	    } else {
	      if (value == null && self.emptyOption) {
	        self.removeUnknownOption();
	        $element.val('');
	      } else {
	        self.renderUnknownOption(value);
	      }
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.put(value, count + 1);
	    self.ngModelCtrl.$render();
	    chromeHack(element);
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.remove(value);
	        if (value === '') {
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.put(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, hasDynamicValueAttr, interpolateTextFn) {
	
	    if (hasDynamicValueAttr) {
	      // either "value" is interpolated directly, or set by ngValue
	      var oldVal;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	    optionElement.on('$destroy', function() {
	      self.removeOption(optionAttrs.value);
	      self.ngModelCtrl.$render();
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `SELECT` element with angular data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * For dynamic options, use interpolation inside the `value` attribute or the `textContent`. Using
	 * {@link ngValue ngValue} is also possible (as it sets the `value` attribute), and will take
	 * precedence over `value` and `textContent`.
	 *
	 * <div class="alert alert-warning">
	 * Note that the value of a `select` directive used without `ngOptions` is always a string.
	 * When the model needs to be bound to a non-string value, you must either explicitly convert it
	 * using a directive (see example below) or use `ngOptions` to specify the set of options.
	 * This is because an option element can only be bound to string values at present.
	 * </div>
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * <div class="alert alert-info">
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits, such as
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression, and additionally in reducing memory and increasing speed by not creating
	 * a new scope for each repeated instance.
	 * </div>
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="ngrepeat-select" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.repeatSelect">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>repeatSelect = {{data.repeatSelect}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       repeatSelect: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected) {
	              array.push(option.value);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          var items = new HashMap(value);
	          forEach(element.find('option'), function(option) {
	            option.selected = isDefined(items.get(option.value));
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      var hasDynamicValueAttr, interpolateTextFn;
	
	      if (isDefined(attr.ngValue)) {
	        // If ngValue is defined, then the value attr will be set to the result of the expression,
	        // and the selectCtrl must set up an observer
	        hasDynamicValueAttr = true;
	      } else if (isDefined(attr.value)) {
	        // If the value attr contains an interpolation, the selectCtrl must set up an observer
	        hasDynamicValueAttr = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, hasDynamicValueAttr, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the Angular expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      attr.required = true; // force truthy in case we are on non input element
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !attr.required || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function() {
	        ctrl.$validate();
	      });
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained by evaluating the Angular expression given in the
	 * `ngPattern` attribute value:
	 * * If the expression evaluates to a RegExp object, then this is used directly.
	 * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var regexp, patternExp = attr.ngPattern || attr.pattern;
	      attr.$observe('pattern', function(regex) {
	        if (isString(regex) && regex.length > 0) {
	          regex = new RegExp('^' + regex + '$');
	        }
	
	        if (regex && !regex.test) {
	          throw minErr('ngPattern')('noregexp',
	            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	            regex, startingTag(elm));
	        }
	
	        regexp = regex || undefined;
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.pattern = function(modelValue, viewValue) {
	        // HTML5 pattern constraint validates the input value, so we validate the viewValue
	        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the Angular expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = -1;
	      attr.$observe('maxlength', function(value) {
	        var intVal = toInt(value);
	        maxlength = isNumberNaN(intVal) ? -1 : intVal;
	        ctrl.$validate();
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the Angular expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = 0;
	      attr.$observe('minlength', function(value) {
	        minlength = toInt(value) || 0;
	        ctrl.$validate();
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	      };
	    }
	  };
	};
	
	if (window.angular.bootstrap) {
	  //AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load angular more than once.');
	  }
	  return;
	}
	
	//try to bind to jquery now so that one can write jqLite(document).ready()
	//but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(window.document).ready(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ }),

/***/ 1030:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1031);

/***/ }),

/***/ 1031:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.11
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var $resourceMinErr = angular.$$minErr('$resource');
	
	// Helper functions and regex to lookup a dotted path on an object
	// stopping at undefined/null.  The path must be composed of ASCII
	// identifiers (just like $parse)
	var MEMBER_NAME_REGEX = /^(\.[a-zA-Z_$@][0-9a-zA-Z_$@]*)+$/;
	
	function isValidDottedPath(path) {
	  return (path != null && path !== '' && path !== 'hasOwnProperty' &&
	      MEMBER_NAME_REGEX.test('.' + path));
	}
	
	function lookupDottedPath(obj, path) {
	  if (!isValidDottedPath(path)) {
	    throw $resourceMinErr('badmember', 'Dotted member path "@{0}" is invalid.', path);
	  }
	  var keys = path.split('.');
	  for (var i = 0, ii = keys.length; i < ii && angular.isDefined(obj); i++) {
	    var key = keys[i];
	    obj = (obj !== null) ? obj[key] : undefined;
	  }
	  return obj;
	}
	
	/**
	 * Create a shallow copy of an object and clear other fields from the destination
	 */
	function shallowClearAndCopy(src, dst) {
	  dst = dst || {};
	
	  angular.forEach(dst, function(value, key) {
	    delete dst[key];
	  });
	
	  for (var key in src) {
	    if (src.hasOwnProperty(key) && !(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	      dst[key] = src[key];
	    }
	  }
	
	  return dst;
	}
	
	/**
	 * @ngdoc module
	 * @name ngResource
	 * @description
	 *
	 * # ngResource
	 *
	 * The `ngResource` module provides interaction support with RESTful services
	 * via the $resource service.
	 *
	 *
	 * <div doc-module-components="ngResource"></div>
	 *
	 * See {@link ngResource.$resourceProvider} and {@link ngResource.$resource} for usage.
	 */
	
	/**
	 * @ngdoc provider
	 * @name $resourceProvider
	 *
	 * @description
	 *
	 * Use `$resourceProvider` to change the default behavior of the {@link ngResource.$resource}
	 * service.
	 *
	 * ## Dependencies
	 * Requires the {@link ngResource } module to be installed.
	 *
	 */
	
	/**
	 * @ngdoc service
	 * @name $resource
	 * @requires $http
	 * @requires ng.$log
	 * @requires $q
	 * @requires ng.$timeout
	 *
	 * @description
	 * A factory which creates a resource object that lets you interact with
	 * [RESTful](http://en.wikipedia.org/wiki/Representational_State_Transfer) server-side data sources.
	 *
	 * The returned resource object has action methods which provide high-level behaviors without
	 * the need to interact with the low level {@link ng.$http $http} service.
	 *
	 * Requires the {@link ngResource `ngResource`} module to be installed.
	 *
	 * By default, trailing slashes will be stripped from the calculated URLs,
	 * which can pose problems with server backends that do not expect that
	 * behavior.  This can be disabled by configuring the `$resourceProvider` like
	 * this:
	 *
	 * ```js
	     app.config(['$resourceProvider', function($resourceProvider) {
	       // Don't strip trailing slashes from calculated URLs
	       $resourceProvider.defaults.stripTrailingSlashes = false;
	     }]);
	 * ```
	 *
	 * @param {string} url A parameterized URL template with parameters prefixed by `:` as in
	 *   `/user/:username`. If you are using a URL with a port number (e.g.
	 *   `http://example.com:8080/api`), it will be respected.
	 *
	 *   If you are using a url with a suffix, just add the suffix, like this:
	 *   `$resource('http://example.com/resource.json')` or `$resource('http://example.com/:id.json')`
	 *   or even `$resource('http://example.com/resource/:resource_id.:format')`
	 *   If the parameter before the suffix is empty, :resource_id in this case, then the `/.` will be
	 *   collapsed down to a single `.`.  If you need this sequence to appear and not collapse then you
	 *   can escape it with `/\.`.
	 *
	 * @param {Object=} paramDefaults Default values for `url` parameters. These can be overridden in
	 *   `actions` methods. If a parameter value is a function, it will be called every time
	 *   a param value needs to be obtained for a request (unless the param was overridden). The function
	 *   will be passed the current data value as an argument.
	 *
	 *   Each key value in the parameter object is first bound to url template if present and then any
	 *   excess keys are appended to the url search query after the `?`.
	 *
	 *   Given a template `/path/:verb` and parameter `{verb:'greet', salutation:'Hello'}` results in
	 *   URL `/path/greet?salutation=Hello`.
	 *
	 *   If the parameter value is prefixed with `@`, then the value for that parameter will be
	 *   extracted from the corresponding property on the `data` object (provided when calling a
	 *   "non-GET" action method).
	 *   For example, if the `defaultParam` object is `{someParam: '@someProp'}` then the value of
	 *   `someParam` will be `data.someProp`.
	 *   Note that the parameter will be ignored, when calling a "GET" action method (i.e. an action
	 *   method that does not accept a request body)
	 *
	 * @param {Object.<Object>=} actions Hash with declaration of custom actions that should extend
	 *   the default set of resource actions. The declaration should be created in the format of {@link
	 *   ng.$http#usage $http.config}:
	 *
	 *       {action1: {method:?, params:?, isArray:?, headers:?, ...},
	 *        action2: {method:?, params:?, isArray:?, headers:?, ...},
	 *        ...}
	 *
	 *   Where:
	 *
	 *   - **`action`** – {string} – The name of action. This name becomes the name of the method on
	 *     your resource object.
	 *   - **`method`** – {string} – Case insensitive HTTP method (e.g. `GET`, `POST`, `PUT`,
	 *     `DELETE`, `JSONP`, etc).
	 *   - **`params`** – {Object=} – Optional set of pre-bound parameters for this action. If any of
	 *     the parameter value is a function, it will be called every time when a param value needs to
	 *     be obtained for a request (unless the param was overridden). The function will be passed the
	 *     current data value as an argument.
	 *   - **`url`** – {string} – action specific `url` override. The url templating is supported just
	 *     like for the resource-level urls.
	 *   - **`isArray`** – {boolean=} – If true then the returned object for this action is an array,
	 *     see `returns` section.
	 *   - **`transformRequest`** –
	 *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	 *     transform function or an array of such functions. The transform function takes the http
	 *     request body and headers and returns its transformed (typically serialized) version.
	 *     By default, transformRequest will contain one function that checks if the request data is
	 *     an object and serializes it using `angular.toJson`. To prevent this behavior, set
	 *     `transformRequest` to an empty array: `transformRequest: []`
	 *   - **`transformResponse`** –
	 *     `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	 *     transform function or an array of such functions. The transform function takes the http
	 *     response body, headers and status and returns its transformed (typically deserialized)
	 *     version.
	 *     By default, transformResponse will contain one function that checks if the response looks
	 *     like a JSON string and deserializes it using `angular.fromJson`. To prevent this behavior,
	 *     set `transformResponse` to an empty array: `transformResponse: []`
	 *   - **`cache`** – `{boolean|Cache}` – If true, a default $http cache will be used to cache the
	 *     GET request, otherwise if a cache instance built with
	 *     {@link ng.$cacheFactory $cacheFactory}, this cache will be used for
	 *     caching.
	 *   - **`timeout`** – `{number}` – timeout in milliseconds.<br />
	 *     **Note:** In contrast to {@link ng.$http#usage $http.config}, {@link ng.$q promises} are
	 *     **not** supported in $resource, because the same value would be used for multiple requests.
	 *     If you are looking for a way to cancel requests, you should use the `cancellable` option.
	 *   - **`cancellable`** – `{boolean}` – if set to true, the request made by a "non-instance" call
	 *     will be cancelled (if not already completed) by calling `$cancelRequest()` on the call's
	 *     return value. Calling `$cancelRequest()` for a non-cancellable or an already
	 *     completed/cancelled request will have no effect.<br />
	 *   - **`withCredentials`** - `{boolean}` - whether to set the `withCredentials` flag on the
	 *     XHR object. See
	 *     [requests with credentials](https://developer.mozilla.org/en/http_access_control#section_5)
	 *     for more information.
	 *   - **`responseType`** - `{string}` - see
	 *     [requestType](https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#responseType).
	 *   - **`interceptor`** - `{Object=}` - The interceptor object has two optional methods -
	 *     `response` and `responseError`. Both `response` and `responseError` interceptors get called
	 *     with `http response` object. See {@link ng.$http $http interceptors}.
	 *
	 * @param {Object} options Hash with custom settings that should extend the
	 *   default `$resourceProvider` behavior.  The supported options are:
	 *
	 *   - **`stripTrailingSlashes`** – {boolean} – If true then the trailing
	 *   slashes from any calculated URL will be stripped. (Defaults to true.)
	 *   - **`cancellable`** – {boolean} – If true, the request made by a "non-instance" call will be
	 *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return value.
	 *   This can be overwritten per action. (Defaults to false.)
	 *
	 * @returns {Object} A resource "class" object with methods for the default set of resource actions
	 *   optionally extended with custom `actions`. The default set contains these actions:
	 *   ```js
	 *   { 'get':    {method:'GET'},
	 *     'save':   {method:'POST'},
	 *     'query':  {method:'GET', isArray:true},
	 *     'remove': {method:'DELETE'},
	 *     'delete': {method:'DELETE'} };
	 *   ```
	 *
	 *   Calling these methods invoke an {@link ng.$http} with the specified http method,
	 *   destination and parameters. When the data is returned from the server then the object is an
	 *   instance of the resource class. The actions `save`, `remove` and `delete` are available on it
	 *   as  methods with the `$` prefix. This allows you to easily perform CRUD operations (create,
	 *   read, update, delete) on server-side data like this:
	 *   ```js
	 *   var User = $resource('/user/:userId', {userId:'@id'});
	 *   var user = User.get({userId:123}, function() {
	 *     user.abc = true;
	 *     user.$save();
	 *   });
	 *   ```
	 *
	 *   It is important to realize that invoking a $resource object method immediately returns an
	 *   empty reference (object or array depending on `isArray`). Once the data is returned from the
	 *   server the existing reference is populated with the actual data. This is a useful trick since
	 *   usually the resource is assigned to a model which is then rendered by the view. Having an empty
	 *   object results in no rendering, once the data arrives from the server then the object is
	 *   populated with the data and the view automatically re-renders itself showing the new data. This
	 *   means that in most cases one never has to write a callback function for the action methods.
	 *
	 *   The action methods on the class object or instance object can be invoked with the following
	 *   parameters:
	 *
	 *   - HTTP GET "class" actions: `Resource.action([parameters], [success], [error])`
	 *   - non-GET "class" actions: `Resource.action([parameters], postData, [success], [error])`
	 *   - non-GET instance actions:  `instance.$action([parameters], [success], [error])`
	 *
	 *
	 *   Success callback is called with (value (Object|Array), responseHeaders (Function),
	 *   status (number), statusText (string)) arguments, where the value is the populated resource
	 *   instance or collection object. The error callback is called with (httpResponse) argument.
	 *
	 *   Class actions return empty instance (with additional properties below).
	 *   Instance actions return promise of the action.
	 *
	 *   The Resource instances and collections have these additional properties:
	 *
	 *   - `$promise`: the {@link ng.$q promise} of the original server interaction that created this
	 *     instance or collection.
	 *
	 *     On success, the promise is resolved with the same resource instance or collection object,
	 *     updated with data from server. This makes it easy to use in
	 *     {@link ngRoute.$routeProvider resolve section of $routeProvider.when()} to defer view
	 *     rendering until the resource(s) are loaded.
	 *
	 *     On failure, the promise is rejected with the {@link ng.$http http response} object, without
	 *     the `resource` property.
	 *
	 *     If an interceptor object was provided, the promise will instead be resolved with the value
	 *     returned by the interceptor.
	 *
	 *   - `$resolved`: `true` after first server interaction is completed (either with success or
	 *      rejection), `false` before that. Knowing if the Resource has been resolved is useful in
	 *      data-binding.
	 *
	 *   The Resource instances and collections have these additional methods:
	 *
	 *   - `$cancelRequest`: If there is a cancellable, pending request related to the instance or
	 *      collection, calling this method will abort the request.
	 *
	 *   The Resource instances have these additional methods:
	 *
	 *   - `toJSON`: It returns a simple object without any of the extra properties added as part of
	 *     the Resource API. This object can be serialized through {@link angular.toJson} safely
	 *     without attaching Angular-specific fields. Notice that `JSON.stringify` (and
	 *     `angular.toJson`) automatically use this method when serializing a Resource instance
	 *     (see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#toJSON()_behavior)).
	 *
	 * @example
	 *
	 * # Credit card resource
	 *
	 * ```js
	     // Define CreditCard class
	     var CreditCard = $resource('/user/:userId/card/:cardId',
	      {userId:123, cardId:'@id'}, {
	       charge: {method:'POST', params:{charge:true}}
	      });
	
	     // We can retrieve a collection from the server
	     var cards = CreditCard.query(function() {
	       // GET: /user/123/card
	       // server returns: [ {id:456, number:'1234', name:'Smith'} ];
	
	       var card = cards[0];
	       // each item is an instance of CreditCard
	       expect(card instanceof CreditCard).toEqual(true);
	       card.name = "J. Smith";
	       // non GET methods are mapped onto the instances
	       card.$save();
	       // POST: /user/123/card/456 {id:456, number:'1234', name:'J. Smith'}
	       // server returns: {id:456, number:'1234', name: 'J. Smith'};
	
	       // our custom method is mapped as well.
	       card.$charge({amount:9.99});
	       // POST: /user/123/card/456?amount=9.99&charge=true {id:456, number:'1234', name:'J. Smith'}
	     });
	
	     // we can create an instance as well
	     var newCard = new CreditCard({number:'0123'});
	     newCard.name = "Mike Smith";
	     newCard.$save();
	     // POST: /user/123/card {number:'0123', name:'Mike Smith'}
	     // server returns: {id:789, number:'0123', name: 'Mike Smith'};
	     expect(newCard.id).toEqual(789);
	 * ```
	 *
	 * The object returned from this function execution is a resource "class" which has "static" method
	 * for each action in the definition.
	 *
	 * Calling these methods invoke `$http` on the `url` template with the given `method`, `params` and
	 * `headers`.
	 *
	 * @example
	 *
	 * # User resource
	 *
	 * When the data is returned from the server then the object is an instance of the resource type and
	 * all of the non-GET methods are available with `$` prefix. This allows you to easily support CRUD
	 * operations (create, read, update, delete) on server-side data.
	
	   ```js
	     var User = $resource('/user/:userId', {userId:'@id'});
	     User.get({userId:123}, function(user) {
	       user.abc = true;
	       user.$save();
	     });
	   ```
	 *
	 * It's worth noting that the success callback for `get`, `query` and other methods gets passed
	 * in the response that came from the server as well as $http header getter function, so one
	 * could rewrite the above example and get access to http headers as:
	 *
	   ```js
	     var User = $resource('/user/:userId', {userId:'@id'});
	     User.get({userId:123}, function(user, getResponseHeaders){
	       user.abc = true;
	       user.$save(function(user, putResponseHeaders) {
	         //user => saved user object
	         //putResponseHeaders => $http header getter
	       });
	     });
	   ```
	 *
	 * You can also access the raw `$http` promise via the `$promise` property on the object returned
	 *
	   ```
	     var User = $resource('/user/:userId', {userId:'@id'});
	     User.get({userId:123})
	         .$promise.then(function(user) {
	           $scope.user = user;
	         });
	   ```
	 *
	 * @example
	 *
	 * # Creating a custom 'PUT' request
	 *
	 * In this example we create a custom method on our resource to make a PUT request
	 * ```js
	 *    var app = angular.module('app', ['ngResource', 'ngRoute']);
	 *
	 *    // Some APIs expect a PUT request in the format URL/object/ID
	 *    // Here we are creating an 'update' method
	 *    app.factory('Notes', ['$resource', function($resource) {
	 *    return $resource('/notes/:id', null,
	 *        {
	 *            'update': { method:'PUT' }
	 *        });
	 *    }]);
	 *
	 *    // In our controller we get the ID from the URL using ngRoute and $routeParams
	 *    // We pass in $routeParams and our Notes factory along with $scope
	 *    app.controller('NotesCtrl', ['$scope', '$routeParams', 'Notes',
	                                      function($scope, $routeParams, Notes) {
	 *    // First get a note object from the factory
	 *    var note = Notes.get({ id:$routeParams.id });
	 *    $id = note.id;
	 *
	 *    // Now call update passing in the ID first then the object you are updating
	 *    Notes.update({ id:$id }, note);
	 *
	 *    // This will PUT /notes/ID with the note object in the request payload
	 *    }]);
	 * ```
	 *
	 * @example
	 *
	 * # Cancelling requests
	 *
	 * If an action's configuration specifies that it is cancellable, you can cancel the request related
	 * to an instance or collection (as long as it is a result of a "non-instance" call):
	 *
	   ```js
	     // ...defining the `Hotel` resource...
	     var Hotel = $resource('/api/hotel/:id', {id: '@id'}, {
	       // Let's make the `query()` method cancellable
	       query: {method: 'get', isArray: true, cancellable: true}
	     });
	
	     // ...somewhere in the PlanVacationController...
	     ...
	     this.onDestinationChanged = function onDestinationChanged(destination) {
	       // We don't care about any pending request for hotels
	       // in a different destination any more
	       this.availableHotels.$cancelRequest();
	
	       // Let's query for hotels in '<destination>'
	       // (calls: /api/hotel?location=<destination>)
	       this.availableHotels = Hotel.query({location: destination});
	     };
	   ```
	 *
	 */
	angular.module('ngResource', ['ng']).
	  provider('$resource', function ResourceProvider() {
	    var PROTOCOL_AND_DOMAIN_REGEX = /^https?:\/\/[^/]*/;
	
	    var provider = this;
	
	    /**
	     * @ngdoc property
	     * @name $resourceProvider#defaults
	     * @description
	     * Object containing default options used when creating `$resource` instances.
	     *
	     * The default values satisfy a wide range of usecases, but you may choose to overwrite any of
	     * them to further customize your instances. The available properties are:
	     *
	     * - **stripTrailingSlashes** – `{boolean}` – If true, then the trailing slashes from any
	     *   calculated URL will be stripped.<br />
	     *   (Defaults to true.)
	     * - **cancellable** – `{boolean}` – If true, the request made by a "non-instance" call will be
	     *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return
	     *   value. For more details, see {@link ngResource.$resource}. This can be overwritten per
	     *   resource class or action.<br />
	     *   (Defaults to false.)
	     * - **actions** - `{Object.<Object>}` - A hash with default actions declarations. Actions are
	     *   high-level methods corresponding to RESTful actions/methods on resources. An action may
	     *   specify what HTTP method to use, what URL to hit, if the return value will be a single
	     *   object or a collection (array) of objects etc. For more details, see
	     *   {@link ngResource.$resource}. The actions can also be enhanced or overwritten per resource
	     *   class.<br />
	     *   The default actions are:
	     *   ```js
	     *   {
	     *     get: {method: 'GET'},
	     *     save: {method: 'POST'},
	     *     query: {method: 'GET', isArray: true},
	     *     remove: {method: 'DELETE'},
	     *     delete: {method: 'DELETE'}
	     *   }
	     *   ```
	     *
	     * #### Example
	     *
	     * For example, you can specify a new `update` action that uses the `PUT` HTTP verb:
	     *
	     * ```js
	     *   angular.
	     *     module('myApp').
	     *     config(['$resourceProvider', function ($resourceProvider) {
	     *       $resourceProvider.defaults.actions.update = {
	     *         method: 'PUT'
	     *       };
	     *     });
	     * ```
	     *
	     * Or you can even overwrite the whole `actions` list and specify your own:
	     *
	     * ```js
	     *   angular.
	     *     module('myApp').
	     *     config(['$resourceProvider', function ($resourceProvider) {
	     *       $resourceProvider.defaults.actions = {
	     *         create: {method: 'POST'},
	     *         get:    {method: 'GET'},
	     *         getAll: {method: 'GET', isArray:true},
	     *         update: {method: 'PUT'},
	     *         delete: {method: 'DELETE'}
	     *       };
	     *     });
	     * ```
	     *
	     */
	    this.defaults = {
	      // Strip slashes by default
	      stripTrailingSlashes: true,
	
	      // Make non-instance requests cancellable (via `$cancelRequest()`)
	      cancellable: false,
	
	      // Default actions configuration
	      actions: {
	        'get': {method: 'GET'},
	        'save': {method: 'POST'},
	        'query': {method: 'GET', isArray: true},
	        'remove': {method: 'DELETE'},
	        'delete': {method: 'DELETE'}
	      }
	    };
	
	    this.$get = ['$http', '$log', '$q', '$timeout', function($http, $log, $q, $timeout) {
	
	      var noop = angular.noop,
	        forEach = angular.forEach,
	        extend = angular.extend,
	        copy = angular.copy,
	        isArray = angular.isArray,
	        isDefined = angular.isDefined,
	        isFunction = angular.isFunction,
	        isNumber = angular.isNumber;
	
	      /**
	       * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	       * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set
	       * (pchar) allowed in path segments:
	       *    segment       = *pchar
	       *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	       *    pct-encoded   = "%" HEXDIG HEXDIG
	       *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	       *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	       *                     / "*" / "+" / "," / ";" / "="
	       */
	      function encodeUriSegment(val) {
	        return encodeUriQuery(val, true).
	          replace(/%26/gi, '&').
	          replace(/%3D/gi, '=').
	          replace(/%2B/gi, '+');
	      }
	
	
	      /**
	       * This method is intended for encoding *key* or *value* parts of query component. We need a
	       * custom method because encodeURIComponent is too aggressive and encodes stuff that doesn't
	       * have to be encoded per http://tools.ietf.org/html/rfc3986:
	       *    query       = *( pchar / "/" / "?" )
	       *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	       *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	       *    pct-encoded   = "%" HEXDIG HEXDIG
	       *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	       *                     / "*" / "+" / "," / ";" / "="
	       */
	      function encodeUriQuery(val, pctEncodeSpaces) {
	        return encodeURIComponent(val).
	          replace(/%40/gi, '@').
	          replace(/%3A/gi, ':').
	          replace(/%24/g, '$').
	          replace(/%2C/gi, ',').
	          replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	      }
	
	      function Route(template, defaults) {
	        this.template = template;
	        this.defaults = extend({}, provider.defaults, defaults);
	        this.urlParams = {};
	      }
	
	      Route.prototype = {
	        setUrlParams: function(config, params, actionUrl) {
	          var self = this,
	            url = actionUrl || self.template,
	            val,
	            encodedVal,
	            protocolAndDomain = '';
	
	          var urlParams = self.urlParams = {};
	          forEach(url.split(/\W/), function(param) {
	            if (param === 'hasOwnProperty') {
	              throw $resourceMinErr('badname', 'hasOwnProperty is not a valid parameter name.');
	            }
	            if (!(new RegExp('^\\d+$').test(param)) && param &&
	              (new RegExp('(^|[^\\\\]):' + param + '(\\W|$)').test(url))) {
	              urlParams[param] = {
	                isQueryParamValue: (new RegExp('\\?.*=:' + param + '(?:\\W|$)')).test(url)
	              };
	            }
	          });
	          url = url.replace(/\\:/g, ':');
	          url = url.replace(PROTOCOL_AND_DOMAIN_REGEX, function(match) {
	            protocolAndDomain = match;
	            return '';
	          });
	
	          params = params || {};
	          forEach(self.urlParams, function(paramInfo, urlParam) {
	            val = params.hasOwnProperty(urlParam) ? params[urlParam] : self.defaults[urlParam];
	            if (isDefined(val) && val !== null) {
	              if (paramInfo.isQueryParamValue) {
	                encodedVal = encodeUriQuery(val, true);
	              } else {
	                encodedVal = encodeUriSegment(val);
	              }
	              url = url.replace(new RegExp(':' + urlParam + '(\\W|$)', 'g'), function(match, p1) {
	                return encodedVal + p1;
	              });
	            } else {
	              url = url.replace(new RegExp('(/?):' + urlParam + '(\\W|$)', 'g'), function(match,
	                  leadingSlashes, tail) {
	                if (tail.charAt(0) === '/') {
	                  return tail;
	                } else {
	                  return leadingSlashes + tail;
	                }
	              });
	            }
	          });
	
	          // strip trailing slashes and set the url (unless this behavior is specifically disabled)
	          if (self.defaults.stripTrailingSlashes) {
	            url = url.replace(/\/+$/, '') || '/';
	          }
	
	          // then replace collapse `/.` if found in the last URL path segment before the query
	          // E.g. `http://url.com/id./format?q=x` becomes `http://url.com/id.format?q=x`
	          url = url.replace(/\/\.(?=\w+($|\?))/, '.');
	          // replace escaped `/\.` with `/.`
	          config.url = protocolAndDomain + url.replace(/\/\\\./, '/.');
	
	
	          // set params - delegate param encoding to $http
	          forEach(params, function(value, key) {
	            if (!self.urlParams[key]) {
	              config.params = config.params || {};
	              config.params[key] = value;
	            }
	          });
	        }
	      };
	
	
	      function resourceFactory(url, paramDefaults, actions, options) {
	        var route = new Route(url, options);
	
	        actions = extend({}, provider.defaults.actions, actions);
	
	        function extractParams(data, actionParams) {
	          var ids = {};
	          actionParams = extend({}, paramDefaults, actionParams);
	          forEach(actionParams, function(value, key) {
	            if (isFunction(value)) { value = value(data); }
	            ids[key] = value && value.charAt && value.charAt(0) === '@' ?
	              lookupDottedPath(data, value.substr(1)) : value;
	          });
	          return ids;
	        }
	
	        function defaultResponseInterceptor(response) {
	          return response.resource;
	        }
	
	        function Resource(value) {
	          shallowClearAndCopy(value || {}, this);
	        }
	
	        Resource.prototype.toJSON = function() {
	          var data = extend({}, this);
	          delete data.$promise;
	          delete data.$resolved;
	          delete data.$cancelRequest;
	          return data;
	        };
	
	        forEach(actions, function(action, name) {
	          var hasBody = /^(POST|PUT|PATCH)$/i.test(action.method);
	          var numericTimeout = action.timeout;
	          var cancellable = isDefined(action.cancellable) ?
	              action.cancellable : route.defaults.cancellable;
	
	          if (numericTimeout && !isNumber(numericTimeout)) {
	            $log.debug('ngResource:\n' +
	                       '  Only numeric values are allowed as `timeout`.\n' +
	                       '  Promises are not supported in $resource, because the same value would ' +
	                       'be used for multiple requests. If you are looking for a way to cancel ' +
	                       'requests, you should use the `cancellable` option.');
	            delete action.timeout;
	            numericTimeout = null;
	          }
	
	          Resource[name] = function(a1, a2, a3, a4) {
	            var params = {}, data, success, error;
	
	            switch (arguments.length) {
	              case 4:
	                error = a4;
	                success = a3;
	                // falls through
	              case 3:
	              case 2:
	                if (isFunction(a2)) {
	                  if (isFunction(a1)) {
	                    success = a1;
	                    error = a2;
	                    break;
	                  }
	
	                  success = a2;
	                  error = a3;
	                  // falls through
	                } else {
	                  params = a1;
	                  data = a2;
	                  success = a3;
	                  break;
	                }
	                // falls through
	              case 1:
	                if (isFunction(a1)) success = a1;
	                else if (hasBody) data = a1;
	                else params = a1;
	                break;
	              case 0: break;
	              default:
	                throw $resourceMinErr('badargs',
	                  'Expected up to 4 arguments [params, data, success, error], got {0} arguments',
	                  arguments.length);
	            }
	
	            var isInstanceCall = this instanceof Resource;
	            var value = isInstanceCall ? data : (action.isArray ? [] : new Resource(data));
	            var httpConfig = {};
	            var responseInterceptor = action.interceptor && action.interceptor.response ||
	              defaultResponseInterceptor;
	            var responseErrorInterceptor = action.interceptor && action.interceptor.responseError ||
	              undefined;
	            var timeoutDeferred;
	            var numericTimeoutPromise;
	
	            forEach(action, function(value, key) {
	              switch (key) {
	                default:
	                  httpConfig[key] = copy(value);
	                  break;
	                case 'params':
	                case 'isArray':
	                case 'interceptor':
	                case 'cancellable':
	                  break;
	              }
	            });
	
	            if (!isInstanceCall && cancellable) {
	              timeoutDeferred = $q.defer();
	              httpConfig.timeout = timeoutDeferred.promise;
	
	              if (numericTimeout) {
	                numericTimeoutPromise = $timeout(timeoutDeferred.resolve, numericTimeout);
	              }
	            }
	
	            if (hasBody) httpConfig.data = data;
	            route.setUrlParams(httpConfig,
	              extend({}, extractParams(data, action.params || {}), params),
	              action.url);
	
	            var promise = $http(httpConfig).then(function(response) {
	              var data = response.data;
	
	              if (data) {
	                // Need to convert action.isArray to boolean in case it is undefined
	                if (isArray(data) !== (!!action.isArray)) {
	                  throw $resourceMinErr('badcfg',
	                      'Error in resource configuration for action `{0}`. Expected response to ' +
	                      'contain an {1} but got an {2} (Request: {3} {4})', name, action.isArray ? 'array' : 'object',
	                    isArray(data) ? 'array' : 'object', httpConfig.method, httpConfig.url);
	                }
	                if (action.isArray) {
	                  value.length = 0;
	                  forEach(data, function(item) {
	                    if (typeof item === 'object') {
	                      value.push(new Resource(item));
	                    } else {
	                      // Valid JSON values may be string literals, and these should not be converted
	                      // into objects. These items will not have access to the Resource prototype
	                      // methods, but unfortunately there
	                      value.push(item);
	                    }
	                  });
	                } else {
	                  var promise = value.$promise;     // Save the promise
	                  shallowClearAndCopy(data, value);
	                  value.$promise = promise;         // Restore the promise
	                }
	              }
	              response.resource = value;
	
	              return response;
	            }, function(response) {
	              (error || noop)(response);
	              return $q.reject(response);
	            });
	
	            promise['finally'](function() {
	              value.$resolved = true;
	              if (!isInstanceCall && cancellable) {
	                value.$cancelRequest = noop;
	                $timeout.cancel(numericTimeoutPromise);
	                timeoutDeferred = numericTimeoutPromise = httpConfig.timeout = null;
	              }
	            });
	
	            promise = promise.then(
	              function(response) {
	                var value = responseInterceptor(response);
	                (success || noop)(value, response.headers, response.status, response.statusText);
	                return value;
	              },
	              responseErrorInterceptor);
	
	            if (!isInstanceCall) {
	              // we are creating instance / collection
	              // - set the initial promise
	              // - return the instance / collection
	              value.$promise = promise;
	              value.$resolved = false;
	              if (cancellable) value.$cancelRequest = timeoutDeferred.resolve;
	
	              return value;
	            }
	
	            // instance call
	            return promise;
	          };
	
	
	          Resource.prototype['$' + name] = function(params, success, error) {
	            if (isFunction(params)) {
	              error = success; success = params; params = {};
	            }
	            var result = Resource[name].call(this, params, this, success, error);
	            return result.$promise || result;
	          };
	        });
	
	        Resource.bind = function(additionalParamDefaults) {
	          var extendedParamDefaults = extend({}, paramDefaults, additionalParamDefaults);
	          return resourceFactory(url, extendedParamDefaults, actions, options);
	        };
	
	        return Resource;
	      }
	
	      return resourceFactory;
	    }];
	  });
	
	
	})(window, window.angular);


/***/ }),

/***/ 1032:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1033);

/***/ }),

/***/ 1033:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.11
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	var bind;
	var extend;
	var forEach;
	var isDefined;
	var lowercase;
	var noop;
	var htmlParser;
	var htmlSanitizeWriter;
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The whitelist for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
	 *   `$compileProvider`}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 * @this
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    if (svgEnabled) {
	      extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
	   * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	  // Private stuff
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	
	  bind = angular.bind;
	  extend = angular.extend;
	  forEach = angular.forEach;
	  isDefined = angular.isDefined;
	  lowercase = angular.lowercase;
	  noop = angular.noop;
	
	  htmlParser = htmlParserImpl;
	  htmlSanitizeWriter = htmlSanitizeWriterImpl;
	
	  // Regular Expressions for parsing tags and attributes
	  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	    // Match everything outside of normal chars and " (quote character)
	    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;
	
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = toMap('area,br,col,hr,img,wbr');
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = toMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
	      optionalEndTagInlineElements = toMap('rp,rt'),
	      optionalEndTagElements = extend({},
	                                              optionalEndTagInlineElements,
	                                              optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = extend({}, optionalEndTagBlockElements, toMap('address,article,' +
	          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
	          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));
	
	  // Inline Elements - HTML5
	  var inlineElements = extend({}, optionalEndTagInlineElements, toMap('a,abbr,acronym,b,' +
	          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
	          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	  // They can potentially allow for arbitrary javascript to be executed. See #11290
	  var svgElements = toMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
	          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
	          'radialGradient,rect,stop,svg,switch,text,title,tspan');
	
	  // Blocked Elements (will be stripped)
	  var blockedElements = toMap('script,style');
	
	  var validElements = extend({},
	                                     voidElements,
	                                     blockElements,
	                                     inlineElements,
	                                     optionalEndTagElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = toMap('background,cite,href,longdesc,src,xlink:href');
	
	  var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	      'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	  var validAttrs = extend({},
	                                  uriAttrs,
	                                  svgAttrs,
	                                  htmlAttrs);
	
	  function toMap(str, lowercaseKeys) {
	    var obj = {}, items = str.split(','), i;
	    for (i = 0; i < items.length; i++) {
	      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
	    }
	    return obj;
	  }
	
	  var inertBodyElement;
	  (function(window) {
	    var doc;
	    if (window.document && window.document.implementation) {
	      doc = window.document.implementation.createHTMLDocument('inert');
	    } else {
	      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
	    }
	    var docElement = doc.documentElement || doc.getDocumentElement();
	    var bodyElements = docElement.getElementsByTagName('body');
	
	    // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
	    if (bodyElements.length === 1) {
	      inertBodyElement = bodyElements[0];
	    } else {
	      var html = doc.createElement('html');
	      inertBodyElement = doc.createElement('body');
	      html.appendChild(inertBodyElement);
	      doc.appendChild(html);
	    }
	  })(window);
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParserImpl(html, handler) {
	    if (html === null || html === undefined) {
	      html = '';
	    } else if (typeof html !== 'string') {
	      html = '' + html;
	    }
	    inertBodyElement.innerHTML = html;
	
	    //mXSS protection
	    var mXSSAttempts = 5;
	    do {
	      if (mXSSAttempts === 0) {
	        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
	      }
	      mXSSAttempts--;
	
	      // strip custom-namespaced attributes on IE<=11
	      if (window.document.documentMode) {
	        stripCustomNsAttrs(inertBodyElement);
	      }
	      html = inertBodyElement.innerHTML; //trigger mXSS
	      inertBodyElement.innerHTML = html;
	    } while (html !== inertBodyElement.innerHTML);
	
	    var node = inertBodyElement.firstChild;
	    while (node) {
	      switch (node.nodeType) {
	        case 1: // ELEMENT_NODE
	          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	          break;
	        case 3: // TEXT NODE
	          handler.chars(node.textContent);
	          break;
	      }
	
	      var nextNode;
	      if (!(nextNode = node.firstChild)) {
	      if (node.nodeType === 1) {
	          handler.end(node.nodeName.toLowerCase());
	        }
	        nextNode = node.nextSibling;
	        if (!nextNode) {
	          while (nextNode == null) {
	            node = node.parentNode;
	            if (node === inertBodyElement) break;
	            nextNode = node.nextSibling;
	          if (node.nodeType === 1) {
	              handler.end(node.nodeName.toLowerCase());
	            }
	          }
	        }
	      }
	      node = nextNode;
	    }
	
	    while ((node = inertBodyElement.firstChild)) {
	      inertBodyElement.removeChild(node);
	    }
	  }
	
	  function attrToMap(attrs) {
	    var map = {};
	    for (var i = 0, ii = attrs.length; i < ii; i++) {
	      var attr = attrs[i];
	      map[attr.name] = attr.value;
	    }
	    return map;
	  }
	
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.
	      replace(/&/g, '&amp;').
	      replace(SURROGATE_PAIR_REGEXP, function(value) {
	        var hi = value.charCodeAt(0);
	        var low = value.charCodeAt(1);
	        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	      }).
	      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	        return '&#' + value.charCodeAt(0) + ';';
	      }).
	      replace(/</g, '&lt;').
	      replace(/>/g, '&gt;');
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.join('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriterImpl(buf, uriValidator) {
	    var ignoreCurrentElement = false;
	    var out = bind(buf, buf.push);
	    return {
	      start: function(tag, attrs) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && blockedElements[tag]) {
	          ignoreCurrentElement = tag;
	        }
	        if (!ignoreCurrentElement && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          forEach(attrs, function(value, key) {
	            var lkey = lowercase(key);
	            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	            if (validAttrs[lkey] === true &&
	              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out('>');
	        }
	      },
	      end: function(tag) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        // eslint-disable-next-line eqeqeq
	        if (tag == ignoreCurrentElement) {
	          ignoreCurrentElement = false;
	        }
	      },
	      chars: function(chars) {
	        if (!ignoreCurrentElement) {
	          out(encodeEntities(chars));
	        }
	      }
	    };
	  }
	
	
	  /**
	   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	   * to allow any of these custom attributes. This method strips them all.
	   *
	   * @param node Root element to process
	   */
	  function stripCustomNsAttrs(node) {
	    while (node) {
	      if (node.nodeType === window.Node.ELEMENT_NODE) {
	        var attrs = node.attributes;
	        for (var i = 0, l = attrs.length; i < l; i++) {
	          var attrNode = attrs[i];
	          var attrName = attrNode.name.toLowerCase();
	          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
	            node.removeAttributeNode(attrNode);
	            i--;
	            l--;
	          }
	        }
	      }
	
	      var nextNode = node.firstChild;
	      if (nextNode) {
	        stripCustomNsAttrs(nextNode);
	      }
	
	      node = node.nextSibling;
	    }
	  }
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n' +
	             'http://angularjs.org/,\n' +
	             'mailto:us@somewhere.org,\n' +
	             'another@somewhere.org,\n' +
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isDefined = angular.isDefined;
	  var isFunction = angular.isFunction;
	  var isObject = angular.isObject;
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var attributesFn =
	      isFunction(attributes) ? attributes :
	      isObject(attributes) ? function getAttributesObject() {return attributes;} :
	      function getEmptyAttributesObject() {return {};};
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key, linkAttributes = attributesFn(url);
	      html.push('<a ');
	
	      for (key in linkAttributes) {
	        html.push(key + '="' + linkAttributes[key] + '" ');
	      }
	
	      if (isDefined(target) && !('target' in linkAttributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),

/***/ 1034:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1035);

/***/ }),

/***/ 1035:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * Lo-Dash 2.4.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash -o ./dist/lodash.compat.js`
	 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre ES5 environments */
	  var undefined;
	
	  /** Used to pool arrays and objects used internally */
	  var arrayPool = [],
	      objectPool = [];
	
	  /** Used to generate unique IDs */
	  var idCounter = 0;
	
	  /** Used internally to indicate various things */
	  var indicatorObject = {};
	
	  /** Used to prefix keys to avoid issues with `__proto__` and properties on `Object.prototype` */
	  var keyPrefix = +new Date + '';
	
	  /** Used as the size when optimizations are enabled for large arrays */
	  var largeArraySize = 75;
	
	  /** Used as the max size of the `arrayPool` and `objectPool` */
	  var maxPoolSize = 40;
	
	  /** Used to detect and test whitespace */
	  var whitespace = (
	    // whitespace
	    ' \t\x0B\f\xA0\ufeff' +
	
	    // line terminators
	    '\n\r\u2028\u2029' +
	
	    // unicode category "Zs" space separators
	    '\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000'
	  );
	
	  /** Used to match empty string literals in compiled template source */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /**
	   * Used to match ES6 template delimiters
	   * http://people.mozilla.org/~jorendorff/es6-draft.html#sec-literals-string-literals
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match regexp flags from their coerced string values */
	  var reFlags = /\w*$/;
	
	  /** Used to detected named functions */
	  var reFuncName = /^\s*function[ \n\r\t]+\w/;
	
	  /** Used to match "interpolate" template delimiters */
	  var reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match leading whitespace and zeros to be removed */
	  var reLeadingSpacesAndZeros = RegExp('^[' + whitespace + ']*0+(?=.$)');
	
	  /** Used to ensure capturing order of template delimiters */
	  var reNoMatch = /($^)/;
	
	  /** Used to detect functions containing a `this` reference */
	  var reThis = /\bthis\b/;
	
	  /** Used to match unescaped characters in compiled string literals */
	  var reUnescapedString = /['\n\r\t\u2028\u2029\\]/g;
	
	  /** Used to assign default `context` object properties */
	  var contextProps = [
	    'Array', 'Boolean', 'Date', 'Error', 'Function', 'Math', 'Number', 'Object',
	    'RegExp', 'String', '_', 'attachEvent', 'clearTimeout', 'isFinite', 'isNaN',
	    'parseInt', 'setTimeout'
	  ];
	
	  /** Used to fix the JScript [[DontEnum]] bug */
	  var shadowedProps = [
	    'constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable',
	    'toLocaleString', 'toString', 'valueOf'
	  ];
	
	  /** Used to make template sourceURLs easier to identify */
	  var templateCounter = 0;
	
	  /** `Object#toString` result shortcuts */
	  var argsClass = '[object Arguments]',
	      arrayClass = '[object Array]',
	      boolClass = '[object Boolean]',
	      dateClass = '[object Date]',
	      errorClass = '[object Error]',
	      funcClass = '[object Function]',
	      numberClass = '[object Number]',
	      objectClass = '[object Object]',
	      regexpClass = '[object RegExp]',
	      stringClass = '[object String]';
	
	  /** Used to identify object classifications that `_.clone` supports */
	  var cloneableClasses = {};
	  cloneableClasses[funcClass] = false;
	  cloneableClasses[argsClass] = cloneableClasses[arrayClass] =
	  cloneableClasses[boolClass] = cloneableClasses[dateClass] =
	  cloneableClasses[numberClass] = cloneableClasses[objectClass] =
	  cloneableClasses[regexpClass] = cloneableClasses[stringClass] = true;
	
	  /** Used as an internal `_.debounce` options object */
	  var debounceOptions = {
	    'leading': false,
	    'maxWait': 0,
	    'trailing': false
	  };
	
	  /** Used as the property descriptor for `__bindData__` */
	  var descriptor = {
	    'configurable': false,
	    'enumerable': false,
	    'value': null,
	    'writable': false
	  };
	
	  /** Used as the data object for `iteratorTemplate` */
	  var iteratorData = {
	    'args': '',
	    'array': null,
	    'bottom': '',
	    'firstArg': '',
	    'init': '',
	    'keys': null,
	    'loop': '',
	    'shadowedProps': null,
	    'support': null,
	    'top': '',
	    'useHas': false
	  };
	
	  /** Used to determine if values are of the language type Object */
	  var objectTypes = {
	    'boolean': false,
	    'function': true,
	    'object': true,
	    'number': false,
	    'string': false,
	    'undefined': false
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\t': 't',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Used as a reference to the global object */
	  var root = (objectTypes[typeof window] && window) || this;
	
	  /** Detect free variable `exports` */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module` */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports` */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /** Detect free variable `global` from Node.js or Browserified code and use it as `root` */
	  var freeGlobal = objectTypes[typeof global] && global;
	  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches
	   * or `fromIndex` constraints.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} [fromIndex=0] The index to search from.
	   * @returns {number} Returns the index of the matched value or `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    var index = (fromIndex || 0) - 1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * An implementation of `_.contains` for cache objects that mimics the return
	   * signature of `_.indexOf` by returning `0` if the value is found, else `-1`.
	   *
	   * @private
	   * @param {Object} cache The cache object to inspect.
	   * @param {*} value The value to search for.
	   * @returns {number} Returns `0` if `value` is found, else `-1`.
	   */
	  function cacheIndexOf(cache, value) {
	    var type = typeof value;
	    cache = cache.cache;
	
	    if (type == 'boolean' || value == null) {
	      return cache[value] ? 0 : -1;
	    }
	    if (type != 'number' && type != 'string') {
	      type = 'object';
	    }
	    var key = type == 'number' ? value : keyPrefix + value;
	    cache = (cache = cache[type]) && cache[key];
	
	    return type == 'object'
	      ? (cache && baseIndexOf(cache, value) > -1 ? 0 : -1)
	      : (cache ? 0 : -1);
	  }
	
	  /**
	   * Adds a given value to the corresponding cache object.
	   *
	   * @private
	   * @param {*} value The value to add to the cache.
	   */
	  function cachePush(value) {
	    var cache = this.cache,
	        type = typeof value;
	
	    if (type == 'boolean' || value == null) {
	      cache[value] = true;
	    } else {
	      if (type != 'number' && type != 'string') {
	        type = 'object';
	      }
	      var key = type == 'number' ? value : keyPrefix + value,
	          typeCache = cache[type] || (cache[type] = {});
	
	      if (type == 'object') {
	        (typeCache[key] || (typeCache[key] = [])).push(value);
	      } else {
	        typeCache[key] = true;
	      }
	    }
	  }
	
	  /**
	   * Used by `_.max` and `_.min` as the default callback when a given
	   * collection is a string value.
	   *
	   * @private
	   * @param {string} value The character to inspect.
	   * @returns {number} Returns the code unit of given character.
	   */
	  function charAtCallback(value) {
	    return value.charCodeAt(0);
	  }
	
	  /**
	   * Used by `sortBy` to compare transformed `collection` elements, stable sorting
	   * them in ascending order.
	   *
	   * @private
	   * @param {Object} a The object to compare to `b`.
	   * @param {Object} b The object to compare to `a`.
	   * @returns {number} Returns the sort order indicator of `1` or `-1`.
	   */
	  function compareAscending(a, b) {
	    var ac = a.criteria,
	        bc = b.criteria,
	        index = -1,
	        length = ac.length;
	
	    while (++index < length) {
	      var value = ac[index],
	          other = bc[index];
	
	      if (value !== other) {
	        if (value > other || typeof value == 'undefined') {
	          return 1;
	        }
	        if (value < other || typeof other == 'undefined') {
	          return -1;
	        }
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to return the same value for
	    // `a` and `b`. See https://github.com/jashkenas/underscore/pull/1247
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See http://code.google.com/p/v8/issues/detail?id=90
	    return a.index - b.index;
	  }
	
	  /**
	   * Creates a cache object to optimize linear searches of large arrays.
	   *
	   * @private
	   * @param {Array} [array=[]] The array to search.
	   * @returns {null|Object} Returns the cache object or `null` if caching should not be used.
	   */
	  function createCache(array) {
	    var index = -1,
	        length = array.length,
	        first = array[0],
	        mid = array[(length / 2) | 0],
	        last = array[length - 1];
	
	    if (first && typeof first == 'object' &&
	        mid && typeof mid == 'object' && last && typeof last == 'object') {
	      return false;
	    }
	    var cache = getObject();
	    cache['false'] = cache['null'] = cache['true'] = cache['undefined'] = false;
	
	    var result = getObject();
	    result.array = array;
	    result.cache = cache;
	    result.push = cachePush;
	
	    while (++index < length) {
	      result.push(array[index]);
	    }
	    return result;
	  }
	
	  /**
	   * Used by `template` to escape characters for inclusion in compiled
	   * string literals.
	   *
	   * @private
	   * @param {string} match The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(match) {
	    return '\\' + stringEscapes[match];
	  }
	
	  /**
	   * Gets an array from the array pool or creates a new one if the pool is empty.
	   *
	   * @private
	   * @returns {Array} The array from the pool.
	   */
	  function getArray() {
	    return arrayPool.pop() || [];
	  }
	
	  /**
	   * Gets an object from the object pool or creates a new one if the pool is empty.
	   *
	   * @private
	   * @returns {Object} The object from the pool.
	   */
	  function getObject() {
	    return objectPool.pop() || {
	      'array': null,
	      'cache': null,
	      'criteria': null,
	      'false': false,
	      'index': 0,
	      'null': false,
	      'number': null,
	      'object': null,
	      'push': null,
	      'string': null,
	      'true': false,
	      'undefined': false,
	      'value': null
	    };
	  }
	
	  /**
	   * Checks if `value` is a DOM node in IE < 9.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if the `value` is a DOM node, else `false`.
	   */
	  function isNode(value) {
	    // IE < 9 presents DOM nodes as `Object` objects except they have `toString`
	    // methods that are `typeof` "string" and still can coerce nodes to strings
	    return typeof value.toString != 'function' && typeof (value + '') == 'string';
	  }
	
	  /**
	   * Releases the given array back to the array pool.
	   *
	   * @private
	   * @param {Array} [array] The array to release.
	   */
	  function releaseArray(array) {
	    array.length = 0;
	    if (arrayPool.length < maxPoolSize) {
	      arrayPool.push(array);
	    }
	  }
	
	  /**
	   * Releases the given object back to the object pool.
	   *
	   * @private
	   * @param {Object} [object] The object to release.
	   */
	  function releaseObject(object) {
	    var cache = object.cache;
	    if (cache) {
	      releaseObject(cache);
	    }
	    object.array = object.cache = object.criteria = object.object = object.number = object.string = object.value = null;
	    if (objectPool.length < maxPoolSize) {
	      objectPool.push(object);
	    }
	  }
	
	  /**
	   * Slices the `collection` from the `start` index up to, but not including,
	   * the `end` index.
	   *
	   * Note: This function is used instead of `Array#slice` to support node lists
	   * in IE < 9 and to ensure dense arrays are returned.
	   *
	   * @private
	   * @param {Array|Object|string} collection The collection to slice.
	   * @param {number} start The start index.
	   * @param {number} end The end index.
	   * @returns {Array} Returns the new array.
	   */
	  function slice(array, start, end) {
	    start || (start = 0);
	    if (typeof end == 'undefined') {
	      end = array ? array.length : 0;
	    }
	    var index = -1,
	        length = end - start || 0,
	        result = Array(length < 0 ? 0 : length);
	
	    while (++index < length) {
	      result[index] = array[start + index];
	    }
	    return result;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new `lodash` function using the given context object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utilities
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns the `lodash` function.
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See http://es5.github.io/#x11.1.5.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references */
	    var Array = context.Array,
	        Boolean = context.Boolean,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /**
	     * Used for `Array` method references.
	     *
	     * Normally `Array.prototype` would suffice, however, using an array literal
	     * avoids issues in Narwhal.
	     */
	    var arrayRef = [];
	
	    /** Used for native method references */
	    var errorProto = Error.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to restore the original `_` reference in `noConflict` */
	    var oldDash = context._;
	
	    /** Used to resolve the internal [[Class]] of values */
	    var toString = objectProto.toString;
	
	    /** Used to detect if a method is native */
	    var reNative = RegExp('^' +
	      String(toString)
	        .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
	        .replace(/toString| for [^\]]+/g, '.*?') + '$'
	    );
	
	    /** Native method shortcuts */
	    var ceil = Math.ceil,
	        clearTimeout = context.clearTimeout,
	        floor = Math.floor,
	        fnToString = Function.prototype.toString,
	        getPrototypeOf = isNative(getPrototypeOf = Object.getPrototypeOf) && getPrototypeOf,
	        hasOwnProperty = objectProto.hasOwnProperty,
	        push = arrayRef.push,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        setTimeout = context.setTimeout,
	        splice = arrayRef.splice,
	        unshift = arrayRef.unshift;
	
	    /** Used to set meta data on functions */
	    var defineProperty = (function() {
	      // IE 8 only accepts DOM elements
	      try {
	        var o = {},
	            func = isNative(func = Object.defineProperty) && func,
	            result = func(o, o, o) && func;
	      } catch(e) { }
	      return result;
	    }());
	
	    /* Native method shortcuts for methods with the same name as other `lodash` methods */
	    var nativeCreate = isNative(nativeCreate = Object.create) && nativeCreate,
	        nativeIsArray = isNative(nativeIsArray = Array.isArray) && nativeIsArray,
	        nativeIsFinite = context.isFinite,
	        nativeIsNaN = context.isNaN,
	        nativeKeys = isNative(nativeKeys = Object.keys) && nativeKeys,
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used to lookup a built-in constructor by [[Class]] */
	    var ctorByClass = {};
	    ctorByClass[arrayClass] = Array;
	    ctorByClass[boolClass] = Boolean;
	    ctorByClass[dateClass] = Date;
	    ctorByClass[funcClass] = Function;
	    ctorByClass[objectClass] = Object;
	    ctorByClass[numberClass] = Number;
	    ctorByClass[regexpClass] = RegExp;
	    ctorByClass[stringClass] = String;
	
	    /** Used to avoid iterating non-enumerable properties in IE < 9 */
	    var nonEnumProps = {};
	    nonEnumProps[arrayClass] = nonEnumProps[dateClass] = nonEnumProps[numberClass] = { 'constructor': true, 'toLocaleString': true, 'toString': true, 'valueOf': true };
	    nonEnumProps[boolClass] = nonEnumProps[stringClass] = { 'constructor': true, 'toString': true, 'valueOf': true };
	    nonEnumProps[errorClass] = nonEnumProps[funcClass] = nonEnumProps[regexpClass] = { 'constructor': true, 'toString': true };
	    nonEnumProps[objectClass] = { 'constructor': true };
	
	    (function() {
	      var length = shadowedProps.length;
	      while (length--) {
	        var key = shadowedProps[length];
	        for (var className in nonEnumProps) {
	          if (hasOwnProperty.call(nonEnumProps, className) && !hasOwnProperty.call(nonEnumProps[className], key)) {
	            nonEnumProps[className][key] = false;
	          }
	        }
	      }
	    }());
	
	    /*--------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps the given value to enable intuitive
	     * method chaining.
	     *
	     * In addition to Lo-Dash methods, wrappers also have the following `Array` methods:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`, `splice`,
	     * and `unshift`
	     *
	     * Chaining is supported in custom builds as long as the `value` method is
	     * implicitly or explicitly included in the build.
	     *
	     * The chainable wrapper functions are:
	     * `after`, `assign`, `bind`, `bindAll`, `bindKey`, `chain`, `compact`,
	     * `compose`, `concat`, `countBy`, `create`, `createCallback`, `curry`,
	     * `debounce`, `defaults`, `defer`, `delay`, `difference`, `filter`, `flatten`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `map`, `max`, `memoize`, `merge`, `min`, `object`, `omit`,
	     * `once`, `pairs`, `partial`, `partialRight`, `pick`, `pluck`, `pull`, `push`,
	     * `range`, `reject`, `remove`, `rest`, `reverse`, `shuffle`, `slice`, `sort`,
	     * `sortBy`, `splice`, `tap`, `throttle`, `times`, `toArray`, `transform`,
	     * `union`, `uniq`, `unshift`, `unzip`, `values`, `where`, `without`, `wrap`,
	     * and `zip`
	     *
	     * The non-chainable wrapper functions are:
	     * `clone`, `cloneDeep`, `contains`, `escape`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `has`, `identity`,
	     * `indexOf`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isFinite`, `isFunction`, `isNaN`, `isNull`, `isNumber`,
	     * `isObject`, `isPlainObject`, `isRegExp`, `isString`, `isUndefined`, `join`,
	     * `lastIndexOf`, `mixin`, `noConflict`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `result`, `shift`, `size`, `some`, `sortedIndex`, `runInContext`,
	     * `template`, `unescape`, `uniqueId`, and `value`
	     *
	     * The wrapper functions `first` and `last` return wrapped values when `n` is
	     * provided, otherwise they return unwrapped values.
	     *
	     * Explicit chaining can be enabled by using the `_.chain` method.
	     *
	     * @name _
	     * @constructor
	     * @category Chaining
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns a `lodash` instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(sum, num) {
	     *   return sum + num;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(num) {
	     *   return num * num;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      // don't wrap if already wrapped, even if wrapped by a different `lodash` constructor
	      return (value && typeof value == 'object' && !isArray(value) && hasOwnProperty.call(value, '__wrapped__'))
	       ? value
	       : new lodashWrapper(value);
	    }
	
	    /**
	     * A fast path for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @param {boolean} chainAll A flag to enable chaining for all methods
	     * @returns {Object} Returns a `lodash` instance.
	     */
	    function lodashWrapper(value, chainAll) {
	      this.__chain__ = !!chainAll;
	      this.__wrapped__ = value;
	    }
	    // ensure `new lodashWrapper` is an instance of `lodash`
	    lodashWrapper.prototype = lodash.prototype;
	
	    /**
	     * An object used to flag environments features.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    (function() {
	      var ctor = function() { this.x = 1; },
	          object = { '0': 1, 'length': 1 },
	          props = [];
	
	      ctor.prototype = { 'valueOf': 1, 'y': 1 };
	      for (var key in new ctor) { props.push(key); }
	      for (key in arguments) { }
	
	      /**
	       * Detect if an `arguments` object's [[Class]] is resolvable (all but Firefox < 4, IE < 9).
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.argsClass = toString.call(arguments) == argsClass;
	
	      /**
	       * Detect if `arguments` objects are `Object` objects (all but Narwhal and Opera < 10.5).
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.argsObject = arguments.constructor == Object && !(arguments instanceof Array);
	
	      /**
	       * Detect if `name` or `message` properties of `Error.prototype` are
	       * enumerable by default. (IE < 9, Safari < 5.1)
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.enumErrorProps = propertyIsEnumerable.call(errorProto, 'message') || propertyIsEnumerable.call(errorProto, 'name');
	
	      /**
	       * Detect if `prototype` properties are enumerable by default.
	       *
	       * Firefox < 3.6, Opera > 9.50 - Opera < 11.60, and Safari < 5.1
	       * (if the prototype or a property on the prototype has been set)
	       * incorrectly sets a function's `prototype` property [[Enumerable]]
	       * value to `true`.
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.enumPrototypes = propertyIsEnumerable.call(ctor, 'prototype');
	
	      /**
	       * Detect if functions can be decompiled by `Function#toString`
	       * (all but PS3 and older Opera mobile browsers & avoided in Windows 8 apps).
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.funcDecomp = !isNative(context.WinRTError) && reThis.test(runInContext);
	
	      /**
	       * Detect if `Function#name` is supported (all but IE).
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.funcNames = typeof Function.name == 'string';
	
	      /**
	       * Detect if `arguments` object indexes are non-enumerable
	       * (Firefox < 4, IE < 9, PhantomJS, Safari < 5.1).
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.nonEnumArgs = key != 0;
	
	      /**
	       * Detect if properties shadowing those on `Object.prototype` are non-enumerable.
	       *
	       * In IE < 9 an objects own properties, shadowing non-enumerable ones, are
	       * made non-enumerable as well (a.k.a the JScript [[DontEnum]] bug).
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.nonEnumShadows = !/valueOf/.test(props);
	
	      /**
	       * Detect if own properties are iterated after inherited properties (all but IE < 9).
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.ownLast = props[0] != 'x';
	
	      /**
	       * Detect if `Array#shift` and `Array#splice` augment array-like objects correctly.
	       *
	       * Firefox < 10, IE compatibility mode, and IE < 9 have buggy Array `shift()`
	       * and `splice()` functions that fail to remove the last element, `value[0]`,
	       * of array-like objects even though the `length` property is set to `0`.
	       * The `shift()` method is buggy in IE 8 compatibility mode, while `splice()`
	       * is buggy regardless of mode in IE < 9 and buggy in compatibility mode in IE 9.
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.spliceObjects = (arrayRef.splice.call(object, 0, 1), !object[0]);
	
	      /**
	       * Detect lack of support for accessing string characters by index.
	       *
	       * IE < 8 can't access characters by index and IE 8 can only access
	       * characters by index on string literals.
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.unindexedChars = ('x'[0] + Object('x')[0]) != 'xx';
	
	      /**
	       * Detect if a DOM node's [[Class]] is resolvable (all but IE < 9)
	       * and that the JS engine errors when attempting to coerce an object to
	       * a string without a `toString` function.
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      try {
	        support.nodeClass = !(toString.call(document) == objectClass && !({ 'toString': 0 } + ''));
	      } catch(e) {
	        support.nodeClass = true;
	      }
	    }(1));
	
	    /**
	     * By default, the template delimiters used by Lo-Dash are similar to those in
	     * embedded Ruby (ERB). Change the following template settings to use alternative
	     * delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': /<%-([\s\S]+?)%>/g,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': /<%([\s\S]+?)%>/g,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*--------------------------------------------------------------------------*/
	
	    /**
	     * The template used to create iterator functions.
	     *
	     * @private
	     * @param {Object} data The data object used to populate the text.
	     * @returns {string} Returns the interpolated text.
	     */
	    var iteratorTemplate = function(obj) {
	
	      var __p = 'var index, iterable = ' +
	      (obj.firstArg) +
	      ', result = ' +
	      (obj.init) +
	      ';\nif (!iterable) return result;\n' +
	      (obj.top) +
	      ';';
	       if (obj.array) {
	      __p += '\nvar length = iterable.length; index = -1;\nif (' +
	      (obj.array) +
	      ') {  ';
	       if (support.unindexedChars) {
	      __p += '\n  if (isString(iterable)) {\n    iterable = iterable.split(\'\')\n  }  ';
	       }
	      __p += '\n  while (++index < length) {\n    ' +
	      (obj.loop) +
	      ';\n  }\n}\nelse {  ';
	       } else if (support.nonEnumArgs) {
	      __p += '\n  var length = iterable.length; index = -1;\n  if (length && isArguments(iterable)) {\n    while (++index < length) {\n      index += \'\';\n      ' +
	      (obj.loop) +
	      ';\n    }\n  } else {  ';
	       }
	
	       if (support.enumPrototypes) {
	      __p += '\n  var skipProto = typeof iterable == \'function\';\n  ';
	       }
	
	       if (support.enumErrorProps) {
	      __p += '\n  var skipErrorProps = iterable === errorProto || iterable instanceof Error;\n  ';
	       }
	
	          var conditions = [];    if (support.enumPrototypes) { conditions.push('!(skipProto && index == "prototype")'); }    if (support.enumErrorProps)  { conditions.push('!(skipErrorProps && (index == "message" || index == "name"))'); }
	
	       if (obj.useHas && obj.keys) {
	      __p += '\n  var ownIndex = -1,\n      ownProps = objectTypes[typeof iterable] && keys(iterable),\n      length = ownProps ? ownProps.length : 0;\n\n  while (++ownIndex < length) {\n    index = ownProps[ownIndex];\n';
	          if (conditions.length) {
	      __p += '    if (' +
	      (conditions.join(' && ')) +
	      ') {\n  ';
	       }
	      __p +=
	      (obj.loop) +
	      ';    ';
	       if (conditions.length) {
	      __p += '\n    }';
	       }
	      __p += '\n  }  ';
	       } else {
	      __p += '\n  for (index in iterable) {\n';
	          if (obj.useHas) { conditions.push("hasOwnProperty.call(iterable, index)"); }    if (conditions.length) {
	      __p += '    if (' +
	      (conditions.join(' && ')) +
	      ') {\n  ';
	       }
	      __p +=
	      (obj.loop) +
	      ';    ';
	       if (conditions.length) {
	      __p += '\n    }';
	       }
	      __p += '\n  }    ';
	       if (support.nonEnumShadows) {
	      __p += '\n\n  if (iterable !== objectProto) {\n    var ctor = iterable.constructor,\n        isProto = iterable === (ctor && ctor.prototype),\n        className = iterable === stringProto ? stringClass : iterable === errorProto ? errorClass : toString.call(iterable),\n        nonEnum = nonEnumProps[className];\n      ';
	       for (k = 0; k < 7; k++) {
	      __p += '\n    index = \'' +
	      (obj.shadowedProps[k]) +
	      '\';\n    if ((!(isProto && nonEnum[index]) && hasOwnProperty.call(iterable, index))';
	              if (!obj.useHas) {
	      __p += ' || (!nonEnum[index] && iterable[index] !== objectProto[index])';
	       }
	      __p += ') {\n      ' +
	      (obj.loop) +
	      ';\n    }      ';
	       }
	      __p += '\n  }    ';
	       }
	
	       }
	
	       if (obj.array || support.nonEnumArgs) {
	      __p += '\n}';
	       }
	      __p +=
	      (obj.bottom) +
	      ';\nreturn result';
	
	      return __p
	    };
	
	    /*--------------------------------------------------------------------------*/
	
	    /**
	     * The base implementation of `_.bind` that creates the bound function and
	     * sets its meta data.
	     *
	     * @private
	     * @param {Array} bindData The bind data array.
	     * @returns {Function} Returns the new bound function.
	     */
	    function baseBind(bindData) {
	      var func = bindData[0],
	          partialArgs = bindData[2],
	          thisArg = bindData[4];
	
	      function bound() {
	        // `Function#bind` spec
	        // http://es5.github.io/#x15.3.4.5
	        if (partialArgs) {
	          // avoid `arguments` object deoptimizations by using `slice` instead
	          // of `Array.prototype.slice.call` and not assigning `arguments` to a
	          // variable as a ternary expression
	          var args = slice(partialArgs);
	          push.apply(args, arguments);
	        }
	        // mimic the constructor's `return` behavior
	        // http://es5.github.io/#x13.2.2
	        if (this instanceof bound) {
	          // ensure `new bound` is an instance of `func`
	          var thisBinding = baseCreate(func.prototype),
	              result = func.apply(thisBinding, args || arguments);
	          return isObject(result) ? result : thisBinding;
	        }
	        return func.apply(thisArg, args || arguments);
	      }
	      setBindData(bound, bindData);
	      return bound;
	    }
	
	    /**
	     * The base implementation of `_.clone` without argument juggling or support
	     * for `thisArg` binding.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep=false] Specify a deep clone.
	     * @param {Function} [callback] The function to customize cloning values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, callback, stackA, stackB) {
	      if (callback) {
	        var result = callback(value);
	        if (typeof result != 'undefined') {
	          return result;
	        }
	      }
	      // inspect [[Class]]
	      var isObj = isObject(value);
	      if (isObj) {
	        var className = toString.call(value);
	        if (!cloneableClasses[className] || (!support.nodeClass && isNode(value))) {
	          return value;
	        }
	        var ctor = ctorByClass[className];
	        switch (className) {
	          case boolClass:
	          case dateClass:
	            return new ctor(+value);
	
	          case numberClass:
	          case stringClass:
	            return new ctor(value);
	
	          case regexpClass:
	            result = ctor(value.source, reFlags.exec(value));
	            result.lastIndex = value.lastIndex;
	            return result;
	        }
	      } else {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isDeep) {
	        // check for circular references and return corresponding clone
	        var initedStack = !stackA;
	        stackA || (stackA = getArray());
	        stackB || (stackB = getArray());
	
	        var length = stackA.length;
	        while (length--) {
	          if (stackA[length] == value) {
	            return stackB[length];
	          }
	        }
	        result = isArr ? ctor(value.length) : {};
	      }
	      else {
	        result = isArr ? slice(value) : assign({}, value);
	      }
	      // add array properties assigned by `RegExp#exec`
	      if (isArr) {
	        if (hasOwnProperty.call(value, 'index')) {
	          result.index = value.index;
	        }
	        if (hasOwnProperty.call(value, 'input')) {
	          result.input = value.input;
	        }
	      }
	      // exit for shallow clone
	      if (!isDeep) {
	        return result;
	      }
	      // add the source value to the stack of traversed objects
	      // and associate it with its clone
	      stackA.push(value);
	      stackB.push(result);
	
	      // recursively populate clone (susceptible to call stack limits)
	      (isArr ? baseEach : forOwn)(value, function(objValue, key) {
	        result[key] = baseClone(objValue, isDeep, callback, stackA, stackB);
	      });
	
	      if (initedStack) {
	        releaseArray(stackA);
	        releaseArray(stackB);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    function baseCreate(prototype, properties) {
	      return isObject(prototype) ? nativeCreate(prototype) : {};
	    }
	    // fallback for browsers without `Object.create`
	    if (!nativeCreate) {
	      baseCreate = (function() {
	        function Object() {}
	        return function(prototype) {
	          if (isObject(prototype)) {
	            Object.prototype = prototype;
	            var result = new Object;
	            Object.prototype = null;
	          }
	          return result || context.Object();
	        };
	      }());
	    }
	
	    /**
	     * The base implementation of `_.createCallback` without support for creating
	     * "_.pluck" or "_.where" style callbacks.
	     *
	     * @private
	     * @param {*} [func=identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of the created callback.
	     * @param {number} [argCount] The number of arguments the callback accepts.
	     * @returns {Function} Returns a callback function.
	     */
	    function baseCreateCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      // exit early for no `thisArg` or already bound by `Function#bind`
	      if (typeof thisArg == 'undefined' || !('prototype' in func)) {
	        return func;
	      }
	      var bindData = func.__bindData__;
	      if (typeof bindData == 'undefined') {
	        if (support.funcNames) {
	          bindData = !func.name;
	        }
	        bindData = bindData || !support.funcDecomp;
	        if (!bindData) {
	          var source = fnToString.call(func);
	          if (!support.funcNames) {
	            bindData = !reFuncName.test(source);
	          }
	          if (!bindData) {
	            // checks if `func` references the `this` keyword and stores the result
	            bindData = reThis.test(source);
	            setBindData(func, bindData);
	          }
	        }
	      }
	      // exit early if there are no `this` references or `func` is bound
	      if (bindData === false || (bindData !== true && bindData[1] & 1)) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 2: return function(a, b) {
	          return func.call(thisArg, a, b);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	      }
	      return bind(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `createWrapper` that creates the wrapper and
	     * sets its meta data.
	     *
	     * @private
	     * @param {Array} bindData The bind data array.
	     * @returns {Function} Returns the new function.
	     */
	    function baseCreateWrapper(bindData) {
	      var func = bindData[0],
	          bitmask = bindData[1],
	          partialArgs = bindData[2],
	          partialRightArgs = bindData[3],
	          thisArg = bindData[4],
	          arity = bindData[5];
	
	      var isBind = bitmask & 1,
	          isBindKey = bitmask & 2,
	          isCurry = bitmask & 4,
	          isCurryBound = bitmask & 8,
	          key = func;
	
	      function bound() {
	        var thisBinding = isBind ? thisArg : this;
	        if (partialArgs) {
	          var args = slice(partialArgs);
	          push.apply(args, arguments);
	        }
	        if (partialRightArgs || isCurry) {
	          args || (args = slice(arguments));
	          if (partialRightArgs) {
	            push.apply(args, partialRightArgs);
	          }
	          if (isCurry && args.length < arity) {
	            bitmask |= 16 & ~32;
	            return baseCreateWrapper([func, (isCurryBound ? bitmask : bitmask & ~3), args, null, thisArg, arity]);
	          }
	        }
	        args || (args = arguments);
	        if (isBindKey) {
	          func = thisBinding[key];
	        }
	        if (this instanceof bound) {
	          thisBinding = baseCreate(func.prototype);
	          var result = func.apply(thisBinding, args);
	          return isObject(result) ? result : thisBinding;
	        }
	        return func.apply(thisBinding, args);
	      }
	      setBindData(bound, bindData);
	      return bound;
	    }
	
	    /**
	     * The base implementation of `_.difference` that accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to process.
	     * @param {Array} [values] The array of values to exclude.
	     * @returns {Array} Returns a new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array ? array.length : 0,
	          isLarge = length >= largeArraySize && indexOf === baseIndexOf,
	          result = [];
	
	      if (isLarge) {
	        var cache = createCache(values);
	        if (cache) {
	          indexOf = cacheIndexOf;
	          values = cache;
	        } else {
	          isLarge = false;
	        }
	      }
	      while (++index < length) {
	        var value = array[index];
	        if (indexOf(values, value) < 0) {
	          result.push(value);
	        }
	      }
	      if (isLarge) {
	        releaseObject(values);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` without support for callback
	     * shorthands or `thisArg` binding.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isShallow=false] A flag to restrict flattening to a single level.
	     * @param {boolean} [isStrict=false] A flag to restrict flattening to arrays and `arguments` objects.
	     * @param {number} [fromIndex=0] The index to start from.
	     * @returns {Array} Returns a new flattened array.
	     */
	    function baseFlatten(array, isShallow, isStrict, fromIndex) {
	      var index = (fromIndex || 0) - 1,
	          length = array ? array.length : 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	
	        if (value && typeof value == 'object' && typeof value.length == 'number'
	            && (isArray(value) || isArguments(value))) {
	          // recursively flatten arrays (susceptible to call stack limits)
	          if (!isShallow) {
	            value = baseFlatten(value, isShallow, isStrict);
	          }
	          var valIndex = -1,
	              valLength = value.length,
	              resIndex = result.length;
	
	          result.length += valLength;
	          while (++valIndex < valLength) {
	            result[resIndex++] = value[valIndex];
	          }
	        } else if (!isStrict) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isEqual`, without support for `thisArg` binding,
	     * that allows partial "_.where" style comparisons.
	     *
	     * @private
	     * @param {*} a The value to compare.
	     * @param {*} b The other value to compare.
	     * @param {Function} [callback] The function to customize comparing values.
	     * @param {Function} [isWhere=false] A flag to indicate performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `a` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `b` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(a, b, callback, isWhere, stackA, stackB) {
	      // used to indicate that when comparing objects, `a` has at least the properties of `b`
	      if (callback) {
	        var result = callback(a, b);
	        if (typeof result != 'undefined') {
	          return !!result;
	        }
	      }
	      // exit early for identical values
	      if (a === b) {
	        // treat `+0` vs. `-0` as not equal
	        return a !== 0 || (1 / a == 1 / b);
	      }
	      var type = typeof a,
	          otherType = typeof b;
	
	      // exit early for unlike primitive values
	      if (a === a &&
	          !(a && objectTypes[type]) &&
	          !(b && objectTypes[otherType])) {
	        return false;
	      }
	      // exit early for `null` and `undefined` avoiding ES3's Function#call behavior
	      // http://es5.github.io/#x15.3.4.4
	      if (a == null || b == null) {
	        return a === b;
	      }
	      // compare [[Class]] names
	      var className = toString.call(a),
	          otherClass = toString.call(b);
	
	      if (className == argsClass) {
	        className = objectClass;
	      }
	      if (otherClass == argsClass) {
	        otherClass = objectClass;
	      }
	      if (className != otherClass) {
	        return false;
	      }
	      switch (className) {
	        case boolClass:
	        case dateClass:
	          // coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal
	          return +a == +b;
	
	        case numberClass:
	          // treat `NaN` vs. `NaN` as equal
	          return (a != +a)
	            ? b != +b
	            // but treat `+0` vs. `-0` as not equal
	            : (a == 0 ? (1 / a == 1 / b) : a == +b);
	
	        case regexpClass:
	        case stringClass:
	          // coerce regexes to strings (http://es5.github.io/#x15.10.6.4)
	          // treat string primitives and their corresponding object instances as equal
	          return a == String(b);
	      }
	      var isArr = className == arrayClass;
	      if (!isArr) {
	        // unwrap any `lodash` wrapped values
	        var aWrapped = hasOwnProperty.call(a, '__wrapped__'),
	            bWrapped = hasOwnProperty.call(b, '__wrapped__');
	
	        if (aWrapped || bWrapped) {
	          return baseIsEqual(aWrapped ? a.__wrapped__ : a, bWrapped ? b.__wrapped__ : b, callback, isWhere, stackA, stackB);
	        }
	        // exit for functions and DOM nodes
	        if (className != objectClass || (!support.nodeClass && (isNode(a) || isNode(b)))) {
	          return false;
	        }
	        // in older versions of Opera, `arguments` objects have `Array` constructors
	        var ctorA = !support.argsObject && isArguments(a) ? Object : a.constructor,
	            ctorB = !support.argsObject && isArguments(b) ? Object : b.constructor;
	
	        // non `Object` object instances with different constructors are not equal
	        if (ctorA != ctorB &&
	              !(isFunction(ctorA) && ctorA instanceof ctorA && isFunction(ctorB) && ctorB instanceof ctorB) &&
	              ('constructor' in a && 'constructor' in b)
	            ) {
	          return false;
	        }
	      }
	      // assume cyclic structures are equal
	      // the algorithm for detecting cyclic structures is adapted from ES 5.1
	      // section 15.12.3, abstract operation `JO` (http://es5.github.io/#x15.12.3)
	      var initedStack = !stackA;
	      stackA || (stackA = getArray());
	      stackB || (stackB = getArray());
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == a) {
	          return stackB[length] == b;
	        }
	      }
	      var size = 0;
	      result = true;
	
	      // add `a` and `b` to the stack of traversed objects
	      stackA.push(a);
	      stackB.push(b);
	
	      // recursively compare objects and arrays (susceptible to call stack limits)
	      if (isArr) {
	        // compare lengths to determine if a deep comparison is necessary
	        length = a.length;
	        size = b.length;
	        result = size == length;
	
	        if (result || isWhere) {
	          // deep compare the contents, ignoring non-numeric properties
	          while (size--) {
	            var index = length,
	                value = b[size];
	
	            if (isWhere) {
	              while (index--) {
	                if ((result = baseIsEqual(a[index], value, callback, isWhere, stackA, stackB))) {
	                  break;
	                }
	              }
	            } else if (!(result = baseIsEqual(a[size], value, callback, isWhere, stackA, stackB))) {
	              break;
	            }
	          }
	        }
	      }
	      else {
	        // deep compare objects using `forIn`, instead of `forOwn`, to avoid `Object.keys`
	        // which, in this case, is more costly
	        forIn(b, function(value, key, b) {
	          if (hasOwnProperty.call(b, key)) {
	            // count the number of properties.
	            size++;
	            // deep compare each property value.
	            return (result = hasOwnProperty.call(a, key) && baseIsEqual(a[key], value, callback, isWhere, stackA, stackB));
	          }
	        });
	
	        if (result && !isWhere) {
	          // ensure both objects have the same number of properties
	          forIn(a, function(value, key, a) {
	            if (hasOwnProperty.call(a, key)) {
	              // `size` will be `-1` if `a` has more properties than `b`
	              return (result = --size > -1);
	            }
	          });
	        }
	      }
	      stackA.pop();
	      stackB.pop();
	
	      if (initedStack) {
	        releaseArray(stackA);
	        releaseArray(stackB);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.merge` without argument juggling or support
	     * for `thisArg` binding.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [callback] The function to customize merging properties.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     */
	    function baseMerge(object, source, callback, stackA, stackB) {
	      (isArray(source) ? forEach : forOwn)(source, function(source, key) {
	        var found,
	            isArr,
	            result = source,
	            value = object[key];
	
	        if (source && ((isArr = isArray(source)) || isPlainObject(source))) {
	          // avoid merging previously merged cyclic sources
	          var stackLength = stackA.length;
	          while (stackLength--) {
	            if ((found = stackA[stackLength] == source)) {
	              value = stackB[stackLength];
	              break;
	            }
	          }
	          if (!found) {
	            var isShallow;
	            if (callback) {
	              result = callback(value, source);
	              if ((isShallow = typeof result != 'undefined')) {
	                value = result;
	              }
	            }
	            if (!isShallow) {
	              value = isArr
	                ? (isArray(value) ? value : [])
	                : (isPlainObject(value) ? value : {});
	            }
	            // add `source` and associated `value` to the stack of traversed objects
	            stackA.push(source);
	            stackB.push(value);
	
	            // recursively merge objects and arrays (susceptible to call stack limits)
	            if (!isShallow) {
	              baseMerge(value, source, callback, stackA, stackB);
	            }
	          }
	        }
	        else {
	          if (callback) {
	            result = callback(value, source);
	            if (typeof result == 'undefined') {
	              result = source;
	            }
	          }
	          if (typeof result != 'undefined') {
	            value = result;
	          }
	        }
	        object[key] = value;
	      });
	    }
	
	    /**
	     * The base implementation of `_.random` without argument juggling or support
	     * for returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns a random number.
	     */
	    function baseRandom(min, max) {
	      return min + floor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * or `thisArg` binding.
	     *
	     * @private
	     * @param {Array} array The array to process.
	     * @param {boolean} [isSorted=false] A flag to indicate that `array` is sorted.
	     * @param {Function} [callback] The function called per iteration.
	     * @returns {Array} Returns a duplicate-value-free array.
	     */
	    function baseUniq(array, isSorted, callback) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array ? array.length : 0,
	          result = [];
	
	      var isLarge = !isSorted && length >= largeArraySize && indexOf === baseIndexOf,
	          seen = (callback || isLarge) ? getArray() : result;
	
	      if (isLarge) {
	        var cache = createCache(seen);
	        indexOf = cacheIndexOf;
	        seen = cache;
	      }
	      while (++index < length) {
	        var value = array[index],
	            computed = callback ? callback(value, index, array) : value;
	
	        if (isSorted
	              ? !index || seen[seen.length - 1] !== computed
	              : indexOf(seen, computed) < 0
	            ) {
	          if (callback || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      if (isLarge) {
	        releaseArray(seen.array);
	        releaseObject(seen);
	      } else if (callback) {
	        releaseArray(seen);
	      }
	      return result;
	    }
	
	    /**
	     * Creates a function that aggregates a collection, creating an object composed
	     * of keys generated from the results of running each element of the collection
	     * through a callback. The given `setter` function sets the keys and values
	     * of the composed object.
	     *
	     * @private
	     * @param {Function} setter The setter function.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter) {
	      return function(collection, callback, thisArg) {
	        var result = {};
	        callback = lodash.createCallback(callback, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, callback(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, callback(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that, when called, either curries or invokes `func`
	     * with an optional `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of method flags to compose.
	     *  The bitmask may be composed of the following flags:
	     *  1 - `_.bind`
	     *  2 - `_.bindKey`
	     *  4 - `_.curry`
	     *  8 - `_.curry` (bound)
	     *  16 - `_.partial`
	     *  32 - `_.partialRight`
	     * @param {Array} [partialArgs] An array of arguments to prepend to those
	     *  provided to the new function.
	     * @param {Array} [partialRightArgs] An array of arguments to append to those
	     *  provided to the new function.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new function.
	     */
	    function createWrapper(func, bitmask, partialArgs, partialRightArgs, thisArg, arity) {
	      var isBind = bitmask & 1,
	          isBindKey = bitmask & 2,
	          isCurry = bitmask & 4,
	          isCurryBound = bitmask & 8,
	          isPartial = bitmask & 16,
	          isPartialRight = bitmask & 32;
	
	      if (!isBindKey && !isFunction(func)) {
	        throw new TypeError;
	      }
	      if (isPartial && !partialArgs.length) {
	        bitmask &= ~16;
	        isPartial = partialArgs = false;
	      }
	      if (isPartialRight && !partialRightArgs.length) {
	        bitmask &= ~32;
	        isPartialRight = partialRightArgs = false;
	      }
	      var bindData = func && func.__bindData__;
	      if (bindData && bindData !== true) {
	        // clone `bindData`
	        bindData = slice(bindData);
	        if (bindData[2]) {
	          bindData[2] = slice(bindData[2]);
	        }
	        if (bindData[3]) {
	          bindData[3] = slice(bindData[3]);
	        }
	        // set `thisBinding` is not previously bound
	        if (isBind && !(bindData[1] & 1)) {
	          bindData[4] = thisArg;
	        }
	        // set if previously bound but not currently (subsequent curried functions)
	        if (!isBind && bindData[1] & 1) {
	          bitmask |= 8;
	        }
	        // set curried arity if not yet set
	        if (isCurry && !(bindData[1] & 4)) {
	          bindData[5] = arity;
	        }
	        // append partial left arguments
	        if (isPartial) {
	          push.apply(bindData[2] || (bindData[2] = []), partialArgs);
	        }
	        // append partial right arguments
	        if (isPartialRight) {
	          unshift.apply(bindData[3] || (bindData[3] = []), partialRightArgs);
	        }
	        // merge flags
	        bindData[1] |= bitmask;
	        return createWrapper.apply(null, bindData);
	      }
	      // fast path for `_.bind`
	      var creater = (bitmask == 1 || bitmask === 17) ? baseBind : baseCreateWrapper;
	      return creater([func, bitmask, partialArgs, partialRightArgs, thisArg, arity]);
	    }
	
	    /**
	     * Creates compiled iteration functions.
	     *
	     * @private
	     * @param {...Object} [options] The compile options object(s).
	     * @param {string} [options.array] Code to determine if the iterable is an array or array-like.
	     * @param {boolean} [options.useHas] Specify using `hasOwnProperty` checks in the object loop.
	     * @param {Function} [options.keys] A reference to `_.keys` for use in own property iteration.
	     * @param {string} [options.args] A comma separated string of iteration function arguments.
	     * @param {string} [options.top] Code to execute before the iteration branches.
	     * @param {string} [options.loop] Code to execute in the object loop.
	     * @param {string} [options.bottom] Code to execute after the iteration branches.
	     * @returns {Function} Returns the compiled function.
	     */
	    function createIterator() {
	      // data properties
	      iteratorData.shadowedProps = shadowedProps;
	
	      // iterator options
	      iteratorData.array = iteratorData.bottom = iteratorData.loop = iteratorData.top = '';
	      iteratorData.init = 'iterable';
	      iteratorData.useHas = true;
	
	      // merge options into a template data object
	      for (var object, index = 0; object = arguments[index]; index++) {
	        for (var key in object) {
	          iteratorData[key] = object[key];
	        }
	      }
	      var args = iteratorData.args;
	      iteratorData.firstArg = /^[^,]+/.exec(args)[0];
	
	      // create the function factory
	      var factory = Function(
	          'baseCreateCallback, errorClass, errorProto, hasOwnProperty, ' +
	          'indicatorObject, isArguments, isArray, isString, keys, objectProto, ' +
	          'objectTypes, nonEnumProps, stringClass, stringProto, toString',
	        'return function(' + args + ') {\n' + iteratorTemplate(iteratorData) + '\n}'
	      );
	
	      // return the compiled function
	      return factory(
	        baseCreateCallback, errorClass, errorProto, hasOwnProperty,
	        indicatorObject, isArguments, isArray, isString, iteratorData.keys, objectProto,
	        objectTypes, nonEnumProps, stringClass, stringProto, toString
	      );
	    }
	
	    /**
	     * Used by `escape` to convert characters to HTML entities.
	     *
	     * @private
	     * @param {string} match The matched character to escape.
	     * @returns {string} Returns the escaped character.
	     */
	    function escapeHtmlChar(match) {
	      return htmlEscapes[match];
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized, this method returns the custom method, otherwise it returns
	     * the `baseIndexOf` function.
	     *
	     * @private
	     * @returns {Function} Returns the "indexOf" function.
	     */
	    function getIndexOf() {
	      var result = (result = lodash.indexOf) === indexOf ? baseIndexOf : result;
	      return result;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if the `value` is a native function, else `false`.
	     */
	    function isNative(value) {
	      return typeof value == 'function' && reNative.test(value);
	    }
	
	    /**
	     * Sets `this` binding data on a given function.
	     *
	     * @private
	     * @param {Function} func The function to set data on.
	     * @param {Array} value The data array to set.
	     */
	    var setBindData = !defineProperty ? noop : function(func, value) {
	      descriptor.value = value;
	      defineProperty(func, '__bindData__', descriptor);
	      descriptor.value = null;
	    };
	
	    /**
	     * A fallback implementation of `isPlainObject` which checks if a given value
	     * is an object created by the `Object` constructor, assuming objects created
	     * by the `Object` constructor have no inherited enumerable properties and that
	     * there are no `Object.prototype` extensions.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     */
	    function shimIsPlainObject(value) {
	      var ctor,
	          result;
	
	      // avoid non Object objects, `arguments` objects, and DOM elements
	      if (!(value && toString.call(value) == objectClass) ||
	          (ctor = value.constructor, isFunction(ctor) && !(ctor instanceof ctor)) ||
	          (!support.argsClass && isArguments(value)) ||
	          (!support.nodeClass && isNode(value))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      if (support.ownLast) {
	        forIn(value, function(value, key, object) {
	          result = hasOwnProperty.call(object, key);
	          return false;
	        });
	        return result !== false;
	      }
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      forIn(value, function(value, key) {
	        result = key;
	      });
	      return typeof result == 'undefined' || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Used by `unescape` to convert HTML entities to characters.
	     *
	     * @private
	     * @param {string} match The matched character to unescape.
	     * @returns {string} Returns the unescaped character.
	     */
	    function unescapeHtmlChar(match) {
	      return htmlUnescapes[match];
	    }
	
	    /*--------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `value` is an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if the `value` is an `arguments` object, else `false`.
	     * @example
	     *
	     * (function() { return _.isArguments(arguments); })(1, 2, 3);
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return value && typeof value == 'object' && typeof value.length == 'number' &&
	        toString.call(value) == argsClass || false;
	    }
	    // fallback for browsers that can't detect `arguments` objects by [[Class]]
	    if (!support.argsClass) {
	      isArguments = function(value) {
	        return value && typeof value == 'object' && typeof value.length == 'number' &&
	          hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee') || false;
	      };
	    }
	
	    /**
	     * Checks if `value` is an array.
	     *
	     * @static
	     * @memberOf _
	     * @type Function
	     * @category Objects
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if the `value` is an array, else `false`.
	     * @example
	     *
	     * (function() { return _.isArray(arguments); })();
	     * // => false
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     */
	    var isArray = nativeIsArray || function(value) {
	      return value && typeof value == 'object' && typeof value.length == 'number' &&
	        toString.call(value) == arrayClass || false;
	    };
	
	    /**
	     * A fallback implementation of `Object.keys` which produces an array of the
	     * given object's own enumerable property names.
	     *
	     * @private
	     * @type Function
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns an array of property names.
	     */
	    var shimKeys = createIterator({
	      'args': 'object',
	      'init': '[]',
	      'top': 'if (!(objectTypes[typeof object])) return result',
	      'loop': 'result.push(index)'
	    });
	
	    /**
	     * Creates an array composed of the own enumerable property names of an object.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns an array of property names.
	     * @example
	     *
	     * _.keys({ 'one': 1, 'two': 2, 'three': 3 });
	     * // => ['one', 'two', 'three'] (property order is not guaranteed across environments)
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      if (!isObject(object)) {
	        return [];
	      }
	      if ((support.enumPrototypes && typeof object == 'function') ||
	          (support.nonEnumArgs && object.length && isArguments(object))) {
	        return shimKeys(object);
	      }
	      return nativeKeys(object);
	    };
	
	    /** Reusable iterator options shared by `each`, `forIn`, and `forOwn` */
	    var eachIteratorOptions = {
	      'args': 'collection, callback, thisArg',
	      'top': "callback = callback && typeof thisArg == 'undefined' ? callback : baseCreateCallback(callback, thisArg, 3)",
	      'array': "typeof length == 'number'",
	      'keys': keys,
	      'loop': 'if (callback(iterable[index], index, collection) === false) return result'
	    };
	
	    /** Reusable iterator options for `assign` and `defaults` */
	    var defaultsIteratorOptions = {
	      'args': 'object, source, guard',
	      'top':
	        'var args = arguments,\n' +
	        '    argsIndex = 0,\n' +
	        "    argsLength = typeof guard == 'number' ? 2 : args.length;\n" +
	        'while (++argsIndex < argsLength) {\n' +
	        '  iterable = args[argsIndex];\n' +
	        '  if (iterable && objectTypes[typeof iterable]) {',
	      'keys': keys,
	      'loop': "if (typeof result[index] == 'undefined') result[index] = iterable[index]",
	      'bottom': '  }\n}'
	    };
	
	    /** Reusable iterator options for `forIn` and `forOwn` */
	    var forOwnIteratorOptions = {
	      'top': 'if (!objectTypes[typeof iterable]) return result;\n' + eachIteratorOptions.top,
	      'array': false
	    };
	
	    /**
	     * Used to convert characters to HTML entities:
	     *
	     * Though the `>` character is escaped for symmetry, characters like `>` and `/`
	     * don't require escaping in HTML and have no special meaning unless they're part
	     * of a tag or an unquoted attribute value.
	     * http://mathiasbynens.be/notes/ambiguous-ampersands (under "semi-related fun fact")
	     */
	    var htmlEscapes = {
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '"': '&quot;',
	      "'": '&#39;'
	    };
	
	    /** Used to convert HTML entities to characters */
	    var htmlUnescapes = invert(htmlEscapes);
	
	    /** Used to match HTML entities and HTML characters */
	    var reEscapedHtml = RegExp('(' + keys(htmlUnescapes).join('|') + ')', 'g'),
	        reUnescapedHtml = RegExp('[' + keys(htmlEscapes).join('') + ']', 'g');
	
	    /**
	     * A function compiled to iterate `arguments` objects, arrays, objects, and
	     * strings consistenly across environments, executing the callback for each
	     * element in the collection. The callback is bound to `thisArg` and invoked
	     * with three arguments; (value, index|key, collection). Callbacks may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @type Function
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [callback=identity] The function called per iteration.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createIterator(eachIteratorOptions);
	
	    /*--------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources will overwrite property assignments of previous
	     * sources. If a callback is provided it will be executed to produce the
	     * assigned values. The callback is bound to `thisArg` and invoked with two
	     * arguments; (objectValue, sourceValue).
	     *
	     * @static
	     * @memberOf _
	     * @type Function
	     * @alias extend
	     * @category Objects
	     * @param {Object} object The destination object.
	     * @param {...Object} [source] The source objects.
	     * @param {Function} [callback] The function to customize assigning values.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Object} Returns the destination object.
	     * @example
	     *
	     * _.assign({ 'name': 'fred' }, { 'employer': 'slate' });
	     * // => { 'name': 'fred', 'employer': 'slate' }
	     *
	     * var defaults = _.partialRight(_.assign, function(a, b) {
	     *   return typeof a == 'undefined' ? b : a;
	     * });
	     *
	     * var object = { 'name': 'barney' };
	     * defaults(object, { 'name': 'fred', 'employer': 'slate' });
	     * // => { 'name': 'barney', 'employer': 'slate' }
	     */
	    var assign = createIterator(defaultsIteratorOptions, {
	      'top':
	        defaultsIteratorOptions.top.replace(';',
	          ';\n' +
	          "if (argsLength > 3 && typeof args[argsLength - 2] == 'function') {\n" +
	          '  var callback = baseCreateCallback(args[--argsLength - 1], args[argsLength--], 2);\n' +
	          "} else if (argsLength > 2 && typeof args[argsLength - 1] == 'function') {\n" +
	          '  callback = args[--argsLength];\n' +
	          '}'
	        ),
	      'loop': 'result[index] = callback ? callback(result[index], iterable[index]) : iterable[index]'
	    });
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects will also
	     * be cloned, otherwise they will be assigned by reference. If a callback
	     * is provided it will be executed to produce the cloned values. If the
	     * callback returns `undefined` cloning will be handled by the method instead.
	     * The callback is bound to `thisArg` and invoked with one argument; (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep=false] Specify a deep clone.
	     * @param {Function} [callback] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var characters = [
	     *   { 'name': 'barney', 'age': 36 },
	     *   { 'name': 'fred',   'age': 40 }
	     * ];
	     *
	     * var shallow = _.clone(characters);
	     * shallow[0] === characters[0];
	     * // => true
	     *
	     * var deep = _.clone(characters, true);
	     * deep[0] === characters[0];
	     * // => false
	     *
	     * _.mixin({
	     *   'clone': _.partialRight(_.clone, function(value) {
	     *     return _.isElement(value) ? value.cloneNode(false) : undefined;
	     *   })
	     * });
	     *
	     * var clone = _.clone(document.body);
	     * clone.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, callback, thisArg) {
	      // allows working with "Collections" methods without using their `index`
	      // and `collection` arguments for `isDeep` and `callback`
	      if (typeof isDeep != 'boolean' && isDeep != null) {
	        thisArg = callback;
	        callback = isDeep;
	        isDeep = false;
	      }
	      return baseClone(value, isDeep, typeof callback == 'function' && baseCreateCallback(callback, thisArg, 1));
	    }
	
	    /**
	     * Creates a deep clone of `value`. If a callback is provided it will be
	     * executed to produce the cloned values. If the callback returns `undefined`
	     * cloning will be handled by the method instead. The callback is bound to
	     * `thisArg` and invoked with one argument; (value).
	     *
	     * Note: This method is loosely based on the structured clone algorithm. Functions
	     * and DOM nodes are **not** cloned. The enumerable properties of `arguments` objects and
	     * objects created by constructors other than `Object` are cloned to plain `Object` objects.
	     * See http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} value The value to deep clone.
	     * @param {Function} [callback] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var characters = [
	     *   { 'name': 'barney', 'age': 36 },
	     *   { 'name': 'fred',   'age': 40 }
	     * ];
	     *
	     * var deep = _.cloneDeep(characters);
	     * deep[0] === characters[0];
	     * // => false
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'node': element
	     * };
	     *
	     * var clone = _.cloneDeep(view, function(value) {
	     *   return _.isElement(value) ? value.cloneNode(true) : undefined;
	     * });
	     *
	     * clone.node == view.node;
	     * // => false
	     */
	    function cloneDeep(value, callback, thisArg) {
	      return baseClone(value, true, typeof callback == 'function' && baseCreateCallback(callback, thisArg, 1));
	    }
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, { 'constructor': Circle });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties ? assign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional defaults of the same property will be ignored.
	     *
	     * @static
	     * @memberOf _
	     * @type Function
	     * @category Objects
	     * @param {Object} object The destination object.
	     * @param {...Object} [source] The source objects.
	     * @param- {Object} [guard] Allows working with `_.reduce` without using its
	     *  `key` and `object` arguments as sources.
	     * @returns {Object} Returns the destination object.
	     * @example
	     *
	     * var object = { 'name': 'barney' };
	     * _.defaults(object, { 'name': 'fred', 'employer': 'slate' });
	     * // => { 'name': 'barney', 'employer': 'slate' }
	     */
	    var defaults = createIterator(defaultsIteratorOptions);
	
	    /**
	     * This method is like `_.findIndex` except that it returns the key of the
	     * first element that passes the callback check, instead of the element itself.
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [callback=identity] The function called per
	     *  iteration. If a property name or object is provided it will be used to
	     *  create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {string|undefined} Returns the key of the found element, else `undefined`.
	     * @example
	     *
	     * var characters = {
	     *   'barney': {  'age': 36, 'blocked': false },
	     *   'fred': {    'age': 40, 'blocked': true },
	     *   'pebbles': { 'age': 1,  'blocked': false }
	     * };
	     *
	     * _.findKey(characters, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (property order is not guaranteed across environments)
	     *
	     * // using "_.where" callback shorthand
	     * _.findKey(characters, { 'age': 1 });
	     * // => 'pebbles'
	     *
	     * // using "_.pluck" callback shorthand
	     * _.findKey(characters, 'blocked');
	     * // => 'fred'
	     */
	    function findKey(object, callback, thisArg) {
	      var result;
	      callback = lodash.createCallback(callback, thisArg, 3);
	      forOwn(object, function(value, key, object) {
	        if (callback(value, key, object)) {
	          result = key;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements
	     * of a `collection` in the opposite order.
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [callback=identity] The function called per
	     *  iteration. If a property name or object is provided it will be used to
	     *  create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {string|undefined} Returns the key of the found element, else `undefined`.
	     * @example
	     *
	     * var characters = {
	     *   'barney': {  'age': 36, 'blocked': true },
	     *   'fred': {    'age': 40, 'blocked': false },
	     *   'pebbles': { 'age': 1,  'blocked': true }
	     * };
	     *
	     * _.findLastKey(characters, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles`, assuming `_.findKey` returns `barney`
	     *
	     * // using "_.where" callback shorthand
	     * _.findLastKey(characters, { 'age': 40 });
	     * // => 'fred'
	     *
	     * // using "_.pluck" callback shorthand
	     * _.findLastKey(characters, 'blocked');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, callback, thisArg) {
	      var result;
	      callback = lodash.createCallback(callback, thisArg, 3);
	      forOwnRight(object, function(value, key, object) {
	        if (callback(value, key, object)) {
	          result = key;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object,
	     * executing the callback for each property. The callback is bound to `thisArg`
	     * and invoked with three arguments; (value, key, object). Callbacks may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @type Function
	     * @category Objects
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [callback=identity] The function called per iteration.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * Shape.prototype.move = function(x, y) {
	     *   this.x += x;
	     *   this.y += y;
	     * };
	     *
	     * _.forIn(new Shape, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'x', 'y', and 'move' (property order is not guaranteed across environments)
	     */
	    var forIn = createIterator(eachIteratorOptions, forOwnIteratorOptions, {
	      'useHas': false
	    });
	
	    /**
	     * This method is like `_.forIn` except that it iterates over elements
	     * of a `collection` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [callback=identity] The function called per iteration.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * Shape.prototype.move = function(x, y) {
	     *   this.x += x;
	     *   this.y += y;
	     * };
	     *
	     * _.forInRight(new Shape, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'move', 'y', and 'x' assuming `_.forIn ` logs 'x', 'y', and 'move'
	     */
	    function forInRight(object, callback, thisArg) {
	      var pairs = [];
	
	      forIn(object, function(value, key) {
	        pairs.push(key, value);
	      });
	
	      var length = pairs.length;
	      callback = baseCreateCallback(callback, thisArg, 3);
	      while (length--) {
	        if (callback(pairs[length--], pairs[length], object) === false) {
	          break;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Iterates over own enumerable properties of an object, executing the callback
	     * for each property. The callback is bound to `thisArg` and invoked with three
	     * arguments; (value, key, object). Callbacks may exit iteration early by
	     * explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @type Function
	     * @category Objects
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [callback=identity] The function called per iteration.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.forOwn({ '0': 'zero', '1': 'one', 'length': 2 }, function(num, key) {
	     *   console.log(key);
	     * });
	     * // => logs '0', '1', and 'length' (property order is not guaranteed across environments)
	     */
	    var forOwn = createIterator(eachIteratorOptions, forOwnIteratorOptions);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over elements
	     * of a `collection` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [callback=identity] The function called per iteration.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.forOwnRight({ '0': 'zero', '1': 'one', 'length': 2 }, function(num, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'length', '1', and '0' assuming `_.forOwn` logs '0', '1', and 'length'
	     */
	    function forOwnRight(object, callback, thisArg) {
	      var props = keys(object),
	          length = props.length;
	
	      callback = baseCreateCallback(callback, thisArg, 3);
	      while (length--) {
	        var key = props[length];
	        if (callback(object[key], key, object) === false) {
	          break;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Creates a sorted array of property names of all enumerable properties,
	     * own and inherited, of `object` that have function values.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Objects
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns an array of property names that have function values.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['all', 'any', 'bind', 'bindAll', 'clone', 'compact', 'compose', ...]
	     */
	    function functions(object) {
	      var result = [];
	      forIn(object, function(value, key) {
	        if (isFunction(value)) {
	          result.push(key);
	        }
	      });
	      return result.sort();
	    }
	
	    /**
	     * Checks if the specified property name exists as a direct property of `object`,
	     * instead of an inherited property.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {Object} object The object to inspect.
	     * @param {string} key The name of the property to check.
	     * @returns {boolean} Returns `true` if key is a direct property, else `false`.
	     * @example
	     *
	     * _.has({ 'a': 1, 'b': 2, 'c': 3 }, 'b');
	     * // => true
	     */
	    function has(object, key) {
	      return object ? hasOwnProperty.call(object, key) : false;
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of the given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the created inverted object.
	     * @example
	     *
	     * _.invert({ 'first': 'fred', 'second': 'barney' });
	     * // => { 'fred': 'first', 'barney': 'second' }
	     */
	    function invert(object) {
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        result[object[key]] = key;
	      }
	      return result;
	    }
	
	    /**
	     * Checks if `value` is a boolean value.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if the `value` is a boolean value, else `false`.
	     * @example
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        value && typeof value == 'object' && toString.call(value) == boolClass || false;
	    }
	
	    /**
	     * Checks if `value` is a date.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if the `value` is a date, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     */
	    function isDate(value) {
	      return value && typeof value == 'object' && toString.call(value) == dateClass || false;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if the `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     */
	    function isElement(value) {
	      return value && value.nodeType === 1 || false;
	    }
	
	    /**
	     * Checks if `value` is empty. Arrays, strings, or `arguments` objects with a
	     * length of `0` and objects with no own enumerable properties are considered
	     * "empty".
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if the `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({});
	     * // => true
	     *
	     * _.isEmpty('');
	     * // => true
	     */
	    function isEmpty(value) {
	      var result = true;
	      if (!value) {
	        return result;
	      }
	      var className = toString.call(value),
	          length = value.length;
	
	      if ((className == arrayClass || className == stringClass ||
	          (support.argsClass ? className == argsClass : isArguments(value))) ||
	          (className == objectClass && typeof length == 'number' && isFunction(value.splice))) {
	        return !length;
	      }
	      forOwn(value, function() {
	        return (result = false);
	      });
	      return result;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent to each other. If a callback is provided it will be executed
	     * to compare values. If the callback returns `undefined` comparisons will
	     * be handled by the method instead. The callback is bound to `thisArg` and
	     * invoked with two arguments; (a, b).
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} a The value to compare.
	     * @param {*} b The other value to compare.
	     * @param {Function} [callback] The function to customize comparing values.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'name': 'fred' };
	     * var copy = { 'name': 'fred' };
	     *
	     * object == copy;
	     * // => false
	     *
	     * _.isEqual(object, copy);
	     * // => true
	     *
	     * var words = ['hello', 'goodbye'];
	     * var otherWords = ['hi', 'goodbye'];
	     *
	     * _.isEqual(words, otherWords, function(a, b) {
	     *   var reGreet = /^(?:hello|hi)$/i,
	     *       aGreet = _.isString(a) && reGreet.test(a),
	     *       bGreet = _.isString(b) && reGreet.test(b);
	     *
	     *   return (aGreet || bGreet) ? (aGreet == bGreet) : undefined;
	     * });
	     * // => true
	     */
	    function isEqual(a, b, callback, thisArg) {
	      return baseIsEqual(a, b, typeof callback == 'function' && baseCreateCallback(callback, thisArg, 2));
	    }
	
	    /**
	     * Checks if `value` is, or can be coerced to, a finite number.
	     *
	     * Note: This is not the same as native `isFinite` which will return true for
	     * booleans and empty strings. See http://es5.github.io/#x15.1.2.5.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if the `value` is finite, else `false`.
	     * @example
	     *
	     * _.isFinite(-101);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => true
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite('');
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return nativeIsFinite(value) && !nativeIsNaN(parseFloat(value));
	    }
	
	    /**
	     * Checks if `value` is a function.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if the `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     */
	    function isFunction(value) {
	      return typeof value == 'function';
	    }
	    // fallback for older versions of Chrome and Safari
	    if (isFunction(/x/)) {
	      isFunction = function(value) {
	        return typeof value == 'function' && toString.call(value) == funcClass;
	      };
	    }
	
	    /**
	     * Checks if `value` is the language type of Object.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if the `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // check if the value is the ECMAScript language type of Object
	      // http://es5.github.io/#x8
	      // and avoid a V8 bug
	      // http://code.google.com/p/v8/issues/detail?id=2291
	      return !!(value && objectTypes[typeof value]);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * Note: This is not the same as native `isNaN` which will return `true` for
	     * `undefined` and other non-numeric values. See http://es5.github.io/#x15.1.2.4.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if the `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // `NaN` as a primitive is the only value that is not equal to itself
	      // (perform the [[Class]] check first to avoid errors with some host objects in IE)
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if the `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(undefined);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is a number.
	     *
	     * Note: `NaN` is considered a number. See http://es5.github.io/#x8.5.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if the `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4 * 5);
	     * // => true
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        value && typeof value == 'object' && toString.call(value) == numberClass || false;
	    }
	
	    /**
	     * Checks if `value` is an object created by the `Object` constructor.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * _.isPlainObject(new Shape);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     */
	    var isPlainObject = !getPrototypeOf ? shimIsPlainObject : function(value) {
	      if (!(value && toString.call(value) == objectClass) || (!support.argsClass && isArguments(value))) {
	        return false;
	      }
	      var valueOf = value.valueOf,
	          objProto = isNative(valueOf) && (objProto = getPrototypeOf(valueOf)) && getPrototypeOf(objProto);
	
	      return objProto
	        ? (value == objProto || getPrototypeOf(value) == objProto)
	        : shimIsPlainObject(value);
	    };
	
	    /**
	     * Checks if `value` is a regular expression.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if the `value` is a regular expression, else `false`.
	     * @example
	     *
	     * _.isRegExp(/fred/);
	     * // => true
	     */
	    function isRegExp(value) {
	      return value && objectTypes[typeof value] && toString.call(value) == regexpClass || false;
	    }
	
	    /**
	     * Checks if `value` is a string.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if the `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('fred');
	     * // => true
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        value && typeof value == 'object' && toString.call(value) == stringClass || false;
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if the `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     */
	    function isUndefined(value) {
	      return typeof value == 'undefined';
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through the callback.
	     * The callback is bound to `thisArg` and invoked with three arguments;
	     * (value, key, object).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Array} Returns a new object with values of the results of each `callback` execution.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2, 'c': 3} , function(num) { return num * 3; });
	     * // => { 'a': 3, 'b': 6, 'c': 9 }
	     *
	     * var characters = {
	     *   'fred': { 'name': 'fred', 'age': 40 },
	     *   'pebbles': { 'name': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using "_.pluck" callback shorthand
	     * _.mapValues(characters, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 }
	     */
	    function mapValues(object, callback, thisArg) {
	      var result = {};
	      callback = lodash.createCallback(callback, thisArg, 3);
	
	      forOwn(object, function(value, key, object) {
	        result[key] = callback(value, key, object);
	      });
	      return result;
	    }
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * will overwrite property assignments of previous sources. If a callback is
	     * provided it will be executed to produce the merged values of the destination
	     * and source properties. If the callback returns `undefined` merging will
	     * be handled by the method instead. The callback is bound to `thisArg` and
	     * invoked with two arguments; (objectValue, sourceValue).
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {Object} object The destination object.
	     * @param {...Object} [source] The source objects.
	     * @param {Function} [callback] The function to customize merging properties.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Object} Returns the destination object.
	     * @example
	     *
	     * var names = {
	     *   'characters': [
	     *     { 'name': 'barney' },
	     *     { 'name': 'fred' }
	     *   ]
	     * };
	     *
	     * var ages = {
	     *   'characters': [
	     *     { 'age': 36 },
	     *     { 'age': 40 }
	     *   ]
	     * };
	     *
	     * _.merge(names, ages);
	     * // => { 'characters': [{ 'name': 'barney', 'age': 36 }, { 'name': 'fred', 'age': 40 }] }
	     *
	     * var food = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var otherFood = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(food, otherFood, function(a, b) {
	     *   return _.isArray(a) ? a.concat(b) : undefined;
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot] }
	     */
	    function merge(object) {
	      var args = arguments,
	          length = 2;
	
	      if (!isObject(object)) {
	        return object;
	      }
	      // allows working with `_.reduce` and `_.reduceRight` without using
	      // their `index` and `collection` arguments
	      if (typeof args[2] != 'number') {
	        length = args.length;
	      }
	      if (length > 3 && typeof args[length - 2] == 'function') {
	        var callback = baseCreateCallback(args[--length - 1], args[length--], 2);
	      } else if (length > 2 && typeof args[length - 1] == 'function') {
	        callback = args[--length];
	      }
	      var sources = slice(arguments, 1, length),
	          index = -1,
	          stackA = getArray(),
	          stackB = getArray();
	
	      while (++index < length) {
	        baseMerge(object, sources[index], callback, stackA, stackB);
	      }
	      releaseArray(stackA);
	      releaseArray(stackB);
	      return object;
	    }
	
	    /**
	     * Creates a shallow clone of `object` excluding the specified properties.
	     * Property names may be specified as individual arguments or as arrays of
	     * property names. If a callback is provided it will be executed for each
	     * property of `object` omitting the properties the callback returns truey
	     * for. The callback is bound to `thisArg` and invoked with three arguments;
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {Object} object The source object.
	     * @param {Function|...string|string[]} [callback] The properties to omit or the
	     *  function called per iteration.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Object} Returns an object without the omitted properties.
	     * @example
	     *
	     * _.omit({ 'name': 'fred', 'age': 40 }, 'age');
	     * // => { 'name': 'fred' }
	     *
	     * _.omit({ 'name': 'fred', 'age': 40 }, function(value) {
	     *   return typeof value == 'number';
	     * });
	     * // => { 'name': 'fred' }
	     */
	    function omit(object, callback, thisArg) {
	      var result = {};
	      if (typeof callback != 'function') {
	        var props = [];
	        forIn(object, function(value, key) {
	          props.push(key);
	        });
	        props = baseDifference(props, baseFlatten(arguments, true, false, 1));
	
	        var index = -1,
	            length = props.length;
	
	        while (++index < length) {
	          var key = props[index];
	          result[key] = object[key];
	        }
	      } else {
	        callback = lodash.createCallback(callback, thisArg, 3);
	        forIn(object, function(value, key, object) {
	          if (!callback(value, key, object)) {
	            result[key] = value;
	          }
	        });
	      }
	      return result;
	    }
	
	    /**
	     * Creates a two dimensional array of an object's key-value pairs,
	     * i.e. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (property order is not guaranteed across environments)
	     */
	    function pairs(object) {
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a shallow clone of `object` composed of the specified properties.
	     * Property names may be specified as individual arguments or as arrays of
	     * property names. If a callback is provided it will be executed for each
	     * property of `object` picking the properties the callback returns truey
	     * for. The callback is bound to `thisArg` and invoked with three arguments;
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {Object} object The source object.
	     * @param {Function|...string|string[]} [callback] The function called per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Object} Returns an object composed of the picked properties.
	     * @example
	     *
	     * _.pick({ 'name': 'fred', '_userid': 'fred1' }, 'name');
	     * // => { 'name': 'fred' }
	     *
	     * _.pick({ 'name': 'fred', '_userid': 'fred1' }, function(value, key) {
	     *   return key.charAt(0) != '_';
	     * });
	     * // => { 'name': 'fred' }
	     */
	    function pick(object, callback, thisArg) {
	      var result = {};
	      if (typeof callback != 'function') {
	        var index = -1,
	            props = baseFlatten(arguments, true, false, 1),
	            length = isObject(object) ? props.length : 0;
	
	        while (++index < length) {
	          var key = props[index];
	          if (key in object) {
	            result[key] = object[key];
	          }
	        }
	      } else {
	        callback = lodash.createCallback(callback, thisArg, 3);
	        forIn(object, function(value, key, object) {
	          if (callback(value, key, object)) {
	            result[key] = value;
	          }
	        });
	      }
	      return result;
	    }
	
	    /**
	     * An alternative to `_.reduce` this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable properties through a callback, with each callback execution
	     * potentially mutating the `accumulator` object. The callback is bound to
	     * `thisArg` and invoked with four arguments; (accumulator, value, key, object).
	     * Callbacks may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [callback=identity] The function called per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var squares = _.transform([1, 2, 3, 4, 5, 6, 7, 8, 9, 10], function(result, num) {
	     *   num *= num;
	     *   if (num % 2) {
	     *     return result.push(num) < 3;
	     *   }
	     * });
	     * // => [1, 9, 25]
	     *
	     * var mapped = _.transform({ 'a': 1, 'b': 2, 'c': 3 }, function(result, num, key) {
	     *   result[key] = num * 3;
	     * });
	     * // => { 'a': 3, 'b': 6, 'c': 9 }
	     */
	    function transform(object, callback, accumulator, thisArg) {
	      var isArr = isArray(object);
	      if (accumulator == null) {
	        if (isArr) {
	          accumulator = [];
	        } else {
	          var ctor = object && object.constructor,
	              proto = ctor && ctor.prototype;
	
	          accumulator = baseCreate(proto);
	        }
	      }
	      if (callback) {
	        callback = lodash.createCallback(callback, thisArg, 4);
	        (isArr ? baseEach : forOwn)(object, function(value, index, object) {
	          return callback(accumulator, value, index, object);
	        });
	      }
	      return accumulator;
	    }
	
	    /**
	     * Creates an array composed of the own enumerable property values of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Objects
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns an array of property values.
	     * @example
	     *
	     * _.values({ 'one': 1, 'two': 2, 'three': 3 });
	     * // => [1, 2, 3] (property order is not guaranteed across environments)
	     */
	    function values(object) {
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /*--------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements from the specified indexes, or keys, of the
	     * `collection`. Indexes may be specified as individual arguments or as arrays
	     * of indexes.
	     *
	     * @static
	     * @memberOf _
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [index] The indexes of `collection`
	     *   to retrieve, specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns a new array of elements corresponding to the
	     *  provided indexes.
	     * @example
	     *
	     * _.at(['a', 'b', 'c', 'd', 'e'], [0, 2, 4]);
	     * // => ['a', 'c', 'e']
	     *
	     * _.at(['fred', 'barney', 'pebbles'], 0, 2);
	     * // => ['fred', 'pebbles']
	     */
	    function at(collection) {
	      var args = arguments,
	          index = -1,
	          props = baseFlatten(args, true, false, 1),
	          length = (args[2] && args[2][args[1]] === collection) ? 1 : props.length,
	          result = Array(length);
	
	      if (support.unindexedChars && isString(collection)) {
	        collection = collection.split('');
	      }
	      while(++index < length) {
	        result[index] = collection[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * Checks if a given value is present in a collection using strict equality
	     * for comparisons, i.e. `===`. If `fromIndex` is negative, it is used as the
	     * offset from the end of the collection.
	     *
	     * @static
	     * @memberOf _
	     * @alias include
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {*} target The value to check for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {boolean} Returns `true` if the `target` element is found, else `false`.
	     * @example
	     *
	     * _.contains([1, 2, 3], 1);
	     * // => true
	     *
	     * _.contains([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.contains({ 'name': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.contains('pebbles', 'eb');
	     * // => true
	     */
	    function contains(collection, target, fromIndex) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = collection ? collection.length : 0,
	          result = false;
	
	      fromIndex = (fromIndex < 0 ? nativeMax(0, length + fromIndex) : fromIndex) || 0;
	      if (isArray(collection)) {
	        result = indexOf(collection, target, fromIndex) > -1;
	      } else if (typeof length == 'number') {
	        result = (isString(collection) ? collection.indexOf(target, fromIndex) : indexOf(collection, target, fromIndex)) > -1;
	      } else {
	        baseEach(collection, function(value) {
	          if (++index >= fromIndex) {
	            return !(result = value === target);
	          }
	        });
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through the callback. The corresponding value
	     * of each key is the number of times the key was returned by the callback.
	     * The callback is bound to `thisArg` and invoked with three arguments;
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(num) { return Math.floor(num); });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(num) { return this.floor(num); }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      (hasOwnProperty.call(result, key) ? result[key]++ : result[key] = 1);
	    });
	
	    /**
	     * Checks if the given callback returns truey value for **all** elements of
	     * a collection. The callback is bound to `thisArg` and invoked with three
	     * arguments; (value, index|key, collection).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {boolean} Returns `true` if all elements passed the callback check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes']);
	     * // => false
	     *
	     * var characters = [
	     *   { 'name': 'barney', 'age': 36 },
	     *   { 'name': 'fred',   'age': 40 }
	     * ];
	     *
	     * // using "_.pluck" callback shorthand
	     * _.every(characters, 'age');
	     * // => true
	     *
	     * // using "_.where" callback shorthand
	     * _.every(characters, { 'age': 36 });
	     * // => false
	     */
	    function every(collection, callback, thisArg) {
	      var result = true;
	      callback = lodash.createCallback(callback, thisArg, 3);
	
	      if (isArray(collection)) {
	        var index = -1,
	            length = collection.length;
	
	        while (++index < length) {
	          if (!(result = !!callback(collection[index], index, collection))) {
	            break;
	          }
	        }
	      } else {
	        baseEach(collection, function(value, index, collection) {
	          return (result = !!callback(value, index, collection));
	        });
	      }
	      return result;
	    }
	
	    /**
	     * Iterates over elements of a collection, returning an array of all elements
	     * the callback returns truey for. The callback is bound to `thisArg` and
	     * invoked with three arguments; (value, index|key, collection).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Array} Returns a new array of elements that passed the callback check.
	     * @example
	     *
	     * var evens = _.filter([1, 2, 3, 4, 5, 6], function(num) { return num % 2 == 0; });
	     * // => [2, 4, 6]
	     *
	     * var characters = [
	     *   { 'name': 'barney', 'age': 36, 'blocked': false },
	     *   { 'name': 'fred',   'age': 40, 'blocked': true }
	     * ];
	     *
	     * // using "_.pluck" callback shorthand
	     * _.filter(characters, 'blocked');
	     * // => [{ 'name': 'fred', 'age': 40, 'blocked': true }]
	     *
	     * // using "_.where" callback shorthand
	     * _.filter(characters, { 'age': 36 });
	     * // => [{ 'name': 'barney', 'age': 36, 'blocked': false }]
	     */
	    function filter(collection, callback, thisArg) {
	      var result = [];
	      callback = lodash.createCallback(callback, thisArg, 3);
	
	      if (isArray(collection)) {
	        var index = -1,
	            length = collection.length;
	
	        while (++index < length) {
	          var value = collection[index];
	          if (callback(value, index, collection)) {
	            result.push(value);
	          }
	        }
	      } else {
	        baseEach(collection, function(value, index, collection) {
	          if (callback(value, index, collection)) {
	            result.push(value);
	          }
	        });
	      }
	      return result;
	    }
	
	    /**
	     * Iterates over elements of a collection, returning the first element that
	     * the callback returns truey for. The callback is bound to `thisArg` and
	     * invoked with three arguments; (value, index|key, collection).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect, findWhere
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {*} Returns the found element, else `undefined`.
	     * @example
	     *
	     * var characters = [
	     *   { 'name': 'barney',  'age': 36, 'blocked': false },
	     *   { 'name': 'fred',    'age': 40, 'blocked': true },
	     *   { 'name': 'pebbles', 'age': 1,  'blocked': false }
	     * ];
	     *
	     * _.find(characters, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => { 'name': 'barney', 'age': 36, 'blocked': false }
	     *
	     * // using "_.where" callback shorthand
	     * _.find(characters, { 'age': 1 });
	     * // =>  { 'name': 'pebbles', 'age': 1, 'blocked': false }
	     *
	     * // using "_.pluck" callback shorthand
	     * _.find(characters, 'blocked');
	     * // => { 'name': 'fred', 'age': 40, 'blocked': true }
	     */
	    function find(collection, callback, thisArg) {
	      callback = lodash.createCallback(callback, thisArg, 3);
	
	      if (isArray(collection)) {
	        var index = -1,
	            length = collection.length;
	
	        while (++index < length) {
	          var value = collection[index];
	          if (callback(value, index, collection)) {
	            return value;
	          }
	        }
	      } else {
	        var result;
	        baseEach(collection, function(value, index, collection) {
	          if (callback(value, index, collection)) {
	            result = value;
	            return false;
	          }
	        });
	        return result;
	      }
	    }
	
	    /**
	     * This method is like `_.find` except that it iterates over elements
	     * of a `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {*} Returns the found element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(num) {
	     *   return num % 2 == 1;
	     * });
	     * // => 3
	     */
	    function findLast(collection, callback, thisArg) {
	      var result;
	      callback = lodash.createCallback(callback, thisArg, 3);
	      forEachRight(collection, function(value, index, collection) {
	        if (callback(value, index, collection)) {
	          result = value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Iterates over elements of a collection, executing the callback for each
	     * element. The callback is bound to `thisArg` and invoked with three arguments;
	     * (value, index|key, collection). Callbacks may exit iteration early by
	     * explicitly returning `false`.
	     *
	     * Note: As with other "Collections" methods, objects with a `length` property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [callback=identity] The function called per iteration.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2, 3]).forEach(function(num) { console.log(num); }).join(',');
	     * // => logs each number and returns '1,2,3'
	     *
	     * _.forEach({ 'one': 1, 'two': 2, 'three': 3 }, function(num) { console.log(num); });
	     * // => logs each number and returns the object (property order is not guaranteed across environments)
	     */
	    function forEach(collection, callback, thisArg) {
	      if (callback && typeof thisArg == 'undefined' && isArray(collection)) {
	        var index = -1,
	            length = collection.length;
	
	        while (++index < length) {
	          if (callback(collection[index], index, collection) === false) {
	            break;
	          }
	        }
	      } else {
	        baseEach(collection, callback, thisArg);
	      }
	      return collection;
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements
	     * of a `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [callback=identity] The function called per iteration.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2, 3]).forEachRight(function(num) { console.log(num); }).join(',');
	     * // => logs each number from right to left and returns '3,2,1'
	     */
	    function forEachRight(collection, callback, thisArg) {
	      var iterable = collection,
	          length = collection ? collection.length : 0;
	
	      callback = callback && typeof thisArg == 'undefined' ? callback : baseCreateCallback(callback, thisArg, 3);
	      if (isArray(collection)) {
	        while (length--) {
	          if (callback(collection[length], length, collection) === false) {
	            break;
	          }
	        }
	      } else {
	        if (typeof length != 'number') {
	          var props = keys(collection);
	          length = props.length;
	        } else if (support.unindexedChars && isString(collection)) {
	          iterable = collection.split('');
	        }
	        baseEach(collection, function(value, key, collection) {
	          key = props ? props[--length] : --length;
	          return callback(iterable[key], key, collection);
	        });
	      }
	      return collection;
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of a collection through the callback. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The callback is bound to `thisArg` and invoked with three arguments;
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`
	     *
	     * @static
	     * @memberOf _
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(num) { return Math.floor(num); });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(num) { return this.floor(num); }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using "_.pluck" callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      (hasOwnProperty.call(result, key) ? result[key] : result[key] = []).push(value);
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of the collection through the given callback. The corresponding
	     * value of each key is the last element responsible for generating the key.
	     * The callback is bound to `thisArg` and invoked with three arguments;
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keys = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keys, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keys, function(key) { return String.fromCharCode(key.code); });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(characters, function(key) { this.fromCharCode(key.code); }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method named by `methodName` on each element in the `collection`
	     * returning an array of the results of each invoked method. Additional arguments
	     * will be provided to each invoked method. If `methodName` is a function it
	     * will be invoked for, and `this` bound to, each element in the `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|string} methodName The name of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [arg] Arguments to invoke the method with.
	     * @returns {Array} Returns a new array of the results of each invoked method.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    function invoke(collection, methodName) {
	      var args = slice(arguments, 2),
	          index = -1,
	          isFunc = typeof methodName == 'function',
	          length = collection ? collection.length : 0,
	          result = Array(typeof length == 'number' ? length : 0);
	
	      forEach(collection, function(value) {
	        result[++index] = (isFunc ? methodName : value[methodName]).apply(value, args);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an array of values by running each element in the collection
	     * through the callback. The callback is bound to `thisArg` and invoked with
	     * three arguments; (value, index|key, collection).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Array} Returns a new array of the results of each `callback` execution.
	     * @example
	     *
	     * _.map([1, 2, 3], function(num) { return num * 3; });
	     * // => [3, 6, 9]
	     *
	     * _.map({ 'one': 1, 'two': 2, 'three': 3 }, function(num) { return num * 3; });
	     * // => [3, 6, 9] (property order is not guaranteed across environments)
	     *
	     * var characters = [
	     *   { 'name': 'barney', 'age': 36 },
	     *   { 'name': 'fred',   'age': 40 }
	     * ];
	     *
	     * // using "_.pluck" callback shorthand
	     * _.map(characters, 'name');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, callback, thisArg) {
	      var index = -1,
	          length = collection ? collection.length : 0,
	          result = Array(typeof length == 'number' ? length : 0);
	
	      callback = lodash.createCallback(callback, thisArg, 3);
	      if (isArray(collection)) {
	        while (++index < length) {
	          result[index] = callback(collection[index], index, collection);
	        }
	      } else {
	        baseEach(collection, function(value, key, collection) {
	          result[++index] = callback(value, key, collection);
	        });
	      }
	      return result;
	    }
	
	    /**
	     * Retrieves the maximum value of a collection. If the collection is empty or
	     * falsey `-Infinity` is returned. If a callback is provided it will be executed
	     * for each value in the collection to generate the criterion by which the value
	     * is ranked. The callback is bound to `thisArg` and invoked with three
	     * arguments; (value, index, collection).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * var characters = [
	     *   { 'name': 'barney', 'age': 36 },
	     *   { 'name': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(characters, function(chr) { return chr.age; });
	     * // => { 'name': 'fred', 'age': 40 };
	     *
	     * // using "_.pluck" callback shorthand
	     * _.max(characters, 'age');
	     * // => { 'name': 'fred', 'age': 40 };
	     */
	    function max(collection, callback, thisArg) {
	      var computed = -Infinity,
	          result = computed;
	
	      // allows working with functions like `_.map` without using
	      // their `index` argument as a callback
	      if (typeof callback != 'function' && thisArg && thisArg[callback] === collection) {
	        callback = null;
	      }
	      if (callback == null && isArray(collection)) {
	        var index = -1,
	            length = collection.length;
	
	        while (++index < length) {
	          var value = collection[index];
	          if (value > result) {
	            result = value;
	          }
	        }
	      } else {
	        callback = (callback == null && isString(collection))
	          ? charAtCallback
	          : lodash.createCallback(callback, thisArg, 3);
	
	        baseEach(collection, function(value, index, collection) {
	          var current = callback(value, index, collection);
	          if (current > computed) {
	            computed = current;
	            result = value;
	          }
	        });
	      }
	      return result;
	    }
	
	    /**
	     * Retrieves the minimum value of a collection. If the collection is empty or
	     * falsey `Infinity` is returned. If a callback is provided it will be executed
	     * for each value in the collection to generate the criterion by which the value
	     * is ranked. The callback is bound to `thisArg` and invoked with three
	     * arguments; (value, index, collection).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * var characters = [
	     *   { 'name': 'barney', 'age': 36 },
	     *   { 'name': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(characters, function(chr) { return chr.age; });
	     * // => { 'name': 'barney', 'age': 36 };
	     *
	     * // using "_.pluck" callback shorthand
	     * _.min(characters, 'age');
	     * // => { 'name': 'barney', 'age': 36 };
	     */
	    function min(collection, callback, thisArg) {
	      var computed = Infinity,
	          result = computed;
	
	      // allows working with functions like `_.map` without using
	      // their `index` argument as a callback
	      if (typeof callback != 'function' && thisArg && thisArg[callback] === collection) {
	        callback = null;
	      }
	      if (callback == null && isArray(collection)) {
	        var index = -1,
	            length = collection.length;
	
	        while (++index < length) {
	          var value = collection[index];
	          if (value < result) {
	            result = value;
	          }
	        }
	      } else {
	        callback = (callback == null && isString(collection))
	          ? charAtCallback
	          : lodash.createCallback(callback, thisArg, 3);
	
	        baseEach(collection, function(value, index, collection) {
	          var current = callback(value, index, collection);
	          if (current < computed) {
	            computed = current;
	            result = value;
	          }
	        });
	      }
	      return result;
	    }
	
	    /**
	     * Retrieves the value of a specified property from all elements in the collection.
	     *
	     * @static
	     * @memberOf _
	     * @type Function
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {string} property The name of the property to pluck.
	     * @returns {Array} Returns a new array of property values.
	     * @example
	     *
	     * var characters = [
	     *   { 'name': 'barney', 'age': 36 },
	     *   { 'name': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(characters, 'name');
	     * // => ['barney', 'fred']
	     */
	    var pluck = map;
	
	    /**
	     * Reduces a collection to a value which is the accumulated result of running
	     * each element in the collection through the callback, where each successive
	     * callback execution consumes the return value of the previous execution. If
	     * `accumulator` is not provided the first element of the collection will be
	     * used as the initial `accumulator` value. The callback is bound to `thisArg`
	     * and invoked with four arguments; (accumulator, value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [callback=identity] The function called per iteration.
	     * @param {*} [accumulator] Initial value of the accumulator.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var sum = _.reduce([1, 2, 3], function(sum, num) {
	     *   return sum + num;
	     * });
	     * // => 6
	     *
	     * var mapped = _.reduce({ 'a': 1, 'b': 2, 'c': 3 }, function(result, num, key) {
	     *   result[key] = num * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6, 'c': 9 }
	     */
	    function reduce(collection, callback, accumulator, thisArg) {
	      var noaccum = arguments.length < 3;
	      callback = lodash.createCallback(callback, thisArg, 4);
	
	      if (isArray(collection)) {
	        var index = -1,
	            length = collection.length;
	
	        if (noaccum) {
	          accumulator = collection[++index];
	        }
	        while (++index < length) {
	          accumulator = callback(accumulator, collection[index], index, collection);
	        }
	      } else {
	        baseEach(collection, function(value, index, collection) {
	          accumulator = noaccum
	            ? (noaccum = false, value)
	            : callback(accumulator, value, index, collection)
	        });
	      }
	      return accumulator;
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements
	     * of a `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [callback=identity] The function called per iteration.
	     * @param {*} [accumulator] Initial value of the accumulator.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var list = [[0, 1], [2, 3], [4, 5]];
	     * var flat = _.reduceRight(list, function(a, b) { return a.concat(b); }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, callback, accumulator, thisArg) {
	      var noaccum = arguments.length < 3;
	      callback = lodash.createCallback(callback, thisArg, 4);
	      forEachRight(collection, function(value, index, collection) {
	        accumulator = noaccum
	          ? (noaccum = false, value)
	          : callback(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The opposite of `_.filter` this method returns the elements of a
	     * collection that the callback does **not** return truey for.
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Array} Returns a new array of elements that failed the callback check.
	     * @example
	     *
	     * var odds = _.reject([1, 2, 3, 4, 5, 6], function(num) { return num % 2 == 0; });
	     * // => [1, 3, 5]
	     *
	     * var characters = [
	     *   { 'name': 'barney', 'age': 36, 'blocked': false },
	     *   { 'name': 'fred',   'age': 40, 'blocked': true }
	     * ];
	     *
	     * // using "_.pluck" callback shorthand
	     * _.reject(characters, 'blocked');
	     * // => [{ 'name': 'barney', 'age': 36, 'blocked': false }]
	     *
	     * // using "_.where" callback shorthand
	     * _.reject(characters, { 'age': 36 });
	     * // => [{ 'name': 'fred', 'age': 40, 'blocked': true }]
	     */
	    function reject(collection, callback, thisArg) {
	      callback = lodash.createCallback(callback, thisArg, 3);
	      return filter(collection, function(value, index, collection) {
	        return !callback(value, index, collection);
	      });
	    }
	
	    /**
	     * Retrieves a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Allows working with functions like `_.map`
	     *  without using their `index` arguments as `n`.
	     * @returns {Array} Returns the random sample(s) of `collection`.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (collection && typeof collection.length != 'number') {
	        collection = values(collection);
	      } else if (support.unindexedChars && isString(collection)) {
	        collection = collection.split('');
	      }
	      if (n == null || guard) {
	        return collection ? collection[baseRandom(0, collection.length - 1)] : undefined;
	      }
	      var result = shuffle(collection);
	      result.length = nativeMin(nativeMax(0, n), result.length);
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the Fisher-Yates
	     * shuffle. See http://en.wikipedia.org/wiki/Fisher-Yates_shuffle.
	     *
	     * @static
	     * @memberOf _
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns a new shuffled collection.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4, 5, 6]);
	     * // => [4, 1, 6, 3, 5, 2]
	     */
	    function shuffle(collection) {
	      var index = -1,
	          length = collection ? collection.length : 0,
	          result = Array(typeof length == 'number' ? length : 0);
	
	      forEach(collection, function(value) {
	        var rand = baseRandom(0, ++index);
	        result[index] = result[rand];
	        result[rand] = value;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the size of the `collection` by returning `collection.length` for arrays
	     * and array-like objects or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns `collection.length` or number of own enumerable properties.
	     * @example
	     *
	     * _.size([1, 2]);
	     * // => 2
	     *
	     * _.size({ 'one': 1, 'two': 2, 'three': 3 });
	     * // => 3
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? collection.length : 0;
	      return typeof length == 'number' ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if the callback returns a truey value for **any** element of a
	     * collection. The function returns as soon as it finds a passing value and
	     * does not iterate over the entire collection. The callback is bound to
	     * `thisArg` and invoked with three arguments; (value, index|key, collection).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {boolean} Returns `true` if any element passed the callback check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var characters = [
	     *   { 'name': 'barney', 'age': 36, 'blocked': false },
	     *   { 'name': 'fred',   'age': 40, 'blocked': true }
	     * ];
	     *
	     * // using "_.pluck" callback shorthand
	     * _.some(characters, 'blocked');
	     * // => true
	     *
	     * // using "_.where" callback shorthand
	     * _.some(characters, { 'age': 1 });
	     * // => false
	     */
	    function some(collection, callback, thisArg) {
	      var result;
	      callback = lodash.createCallback(callback, thisArg, 3);
	
	      if (isArray(collection)) {
	        var index = -1,
	            length = collection.length;
	
	        while (++index < length) {
	          if ((result = callback(collection[index], index, collection))) {
	            break;
	          }
	        }
	      } else {
	        baseEach(collection, function(value, index, collection) {
	          return !(result = callback(value, index, collection));
	        });
	      }
	      return !!result;
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through the callback. This method
	     * performs a stable sort, that is, it will preserve the original sort order
	     * of equal elements. The callback is bound to `thisArg` and invoked with
	     * three arguments; (value, index|key, collection).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an array of property names is provided for `callback` the collection
	     * will be sorted by each property value.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Array} Returns a new array of sorted elements.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(num) { return Math.sin(num); });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(num) { return this.sin(num); }, Math);
	     * // => [3, 1, 2]
	     *
	     * var characters = [
	     *   { 'name': 'barney',  'age': 36 },
	     *   { 'name': 'fred',    'age': 40 },
	     *   { 'name': 'barney',  'age': 26 },
	     *   { 'name': 'fred',    'age': 30 }
	     * ];
	     *
	     * // using "_.pluck" callback shorthand
	     * _.map(_.sortBy(characters, 'age'), _.values);
	     * // => [['barney', 26], ['fred', 30], ['barney', 36], ['fred', 40]]
	     *
	     * // sorting by multiple properties
	     * _.map(_.sortBy(characters, ['name', 'age']), _.values);
	     * // = > [['barney', 26], ['barney', 36], ['fred', 30], ['fred', 40]]
	     */
	    function sortBy(collection, callback, thisArg) {
	      var index = -1,
	          isArr = isArray(callback),
	          length = collection ? collection.length : 0,
	          result = Array(typeof length == 'number' ? length : 0);
	
	      if (!isArr) {
	        callback = lodash.createCallback(callback, thisArg, 3);
	      }
	      forEach(collection, function(value, key, collection) {
	        var object = result[++index] = getObject();
	        if (isArr) {
	          object.criteria = map(callback, function(key) { return value[key]; });
	        } else {
	          (object.criteria = getArray())[0] = callback(value, key, collection);
	        }
	        object.index = index;
	        object.value = value;
	      });
	
	      length = result.length;
	      result.sort(compareAscending);
	      while (length--) {
	        var object = result[length];
	        result[length] = object.value;
	        if (!isArr) {
	          releaseArray(object.criteria);
	        }
	        releaseObject(object);
	      }
	      return result;
	    }
	
	    /**
	     * Converts the `collection` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to convert.
	     * @returns {Array} Returns the new converted array.
	     * @example
	     *
	     * (function() { return _.toArray(arguments).slice(1); })(1, 2, 3, 4);
	     * // => [2, 3, 4]
	     */
	    function toArray(collection) {
	      if (collection && typeof collection.length == 'number') {
	        return (support.unindexedChars && isString(collection))
	          ? collection.split('')
	          : slice(collection);
	      }
	      return values(collection);
	    }
	
	    /**
	     * Performs a deep comparison of each element in a `collection` to the given
	     * `properties` object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * @static
	     * @memberOf _
	     * @type Function
	     * @category Collections
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Object} props The object of property values to filter by.
	     * @returns {Array} Returns a new array of elements that have the given properties.
	     * @example
	     *
	     * var characters = [
	     *   { 'name': 'barney', 'age': 36, 'pets': ['hoppy'] },
	     *   { 'name': 'fred',   'age': 40, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.where(characters, { 'age': 36 });
	     * // => [{ 'name': 'barney', 'age': 36, 'pets': ['hoppy'] }]
	     *
	     * _.where(characters, { 'pets': ['dino'] });
	     * // => [{ 'name': 'fred', 'age': 40, 'pets': ['baby puss', 'dino'] }]
	     */
	    var where = filter;
	
	    /*--------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are all falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns a new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array excluding all values of the provided arrays using strict
	     * equality for comparisons, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {Array} array The array to process.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns a new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3, 4, 5], [5, 2, 10]);
	     * // => [1, 3, 4]
	     */
	    function difference(array) {
	      return baseDifference(array, baseFlatten(arguments, true, true, 1));
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element that passes the callback check, instead of the element itself.
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var characters = [
	     *   { 'name': 'barney',  'age': 36, 'blocked': false },
	     *   { 'name': 'fred',    'age': 40, 'blocked': true },
	     *   { 'name': 'pebbles', 'age': 1,  'blocked': false }
	     * ];
	     *
	     * _.findIndex(characters, function(chr) {
	     *   return chr.age < 20;
	     * });
	     * // => 2
	     *
	     * // using "_.where" callback shorthand
	     * _.findIndex(characters, { 'age': 36 });
	     * // => 0
	     *
	     * // using "_.pluck" callback shorthand
	     * _.findIndex(characters, 'blocked');
	     * // => 1
	     */
	    function findIndex(array, callback, thisArg) {
	      var index = -1,
	          length = array ? array.length : 0;
	
	      callback = lodash.createCallback(callback, thisArg, 3);
	      while (++index < length) {
	        if (callback(array[index], index, array)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of a `collection` from right to left.
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var characters = [
	     *   { 'name': 'barney',  'age': 36, 'blocked': true },
	     *   { 'name': 'fred',    'age': 40, 'blocked': false },
	     *   { 'name': 'pebbles', 'age': 1,  'blocked': true }
	     * ];
	     *
	     * _.findLastIndex(characters, function(chr) {
	     *   return chr.age > 30;
	     * });
	     * // => 1
	     *
	     * // using "_.where" callback shorthand
	     * _.findLastIndex(characters, { 'age': 36 });
	     * // => 0
	     *
	     * // using "_.pluck" callback shorthand
	     * _.findLastIndex(characters, 'blocked');
	     * // => 2
	     */
	    function findLastIndex(array, callback, thisArg) {
	      var length = array ? array.length : 0;
	      callback = lodash.createCallback(callback, thisArg, 3);
	      while (length--) {
	        if (callback(array[length], length, array)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Gets the first element or first `n` elements of an array. If a callback
	     * is provided elements at the beginning of the array are returned as long
	     * as the callback returns truey. The callback is bound to `thisArg` and
	     * invoked with three arguments; (value, index, array).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head, take
	     * @category Arrays
	     * @param {Array} array The array to query.
	     * @param {Function|Object|number|string} [callback] The function called
	     *  per element or the number of elements to return. If a property name or
	     *  object is provided it will be used to create a "_.pluck" or "_.where"
	     *  style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {*} Returns the first element(s) of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.first([1, 2, 3], function(num) {
	     *   return num < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var characters = [
	     *   { 'name': 'barney',  'blocked': true,  'employer': 'slate' },
	     *   { 'name': 'fred',    'blocked': false, 'employer': 'slate' },
	     *   { 'name': 'pebbles', 'blocked': true,  'employer': 'na' }
	     * ];
	     *
	     * // using "_.pluck" callback shorthand
	     * _.first(characters, 'blocked');
	     * // => [{ 'name': 'barney', 'blocked': true, 'employer': 'slate' }]
	     *
	     * // using "_.where" callback shorthand
	     * _.pluck(_.first(characters, { 'employer': 'slate' }), 'name');
	     * // => ['barney', 'fred']
	     */
	    function first(array, callback, thisArg) {
	      var n = 0,
	          length = array ? array.length : 0;
	
	      if (typeof callback != 'number' && callback != null) {
	        var index = -1;
	        callback = lodash.createCallback(callback, thisArg, 3);
	        while (++index < length && callback(array[index], index, array)) {
	          n++;
	        }
	      } else {
	        n = callback;
	        if (n == null || thisArg) {
	          return array ? array[0] : undefined;
	        }
	      }
	      return slice(array, 0, nativeMin(nativeMax(0, n), length));
	    }
	
	    /**
	     * Flattens a nested array (the nesting can be to any depth). If `isShallow`
	     * is truey, the array will only be flattened a single level. If a callback
	     * is provided each element of the array is passed through the callback before
	     * flattening. The callback is bound to `thisArg` and invoked with three
	     * arguments; (value, index, array).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isShallow=false] A flag to restrict flattening to a single level.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Array} Returns a new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2], [3, [[4]]]]);
	     * // => [1, 2, 3, 4];
	     *
	     * _.flatten([1, [2], [3, [[4]]]], true);
	     * // => [1, 2, 3, [[4]]];
	     *
	     * var characters = [
	     *   { 'name': 'barney', 'age': 30, 'pets': ['hoppy'] },
	     *   { 'name': 'fred',   'age': 40, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * // using "_.pluck" callback shorthand
	     * _.flatten(characters, 'pets');
	     * // => ['hoppy', 'baby puss', 'dino']
	     */
	    function flatten(array, isShallow, callback, thisArg) {
	      // juggle arguments
	      if (typeof isShallow != 'boolean' && isShallow != null) {
	        thisArg = callback;
	        callback = (typeof isShallow != 'function' && thisArg && thisArg[isShallow] === array) ? null : isShallow;
	        isShallow = false;
	      }
	      if (callback != null) {
	        array = map(array, callback, thisArg);
	      }
	      return baseFlatten(array, isShallow);
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found using
	     * strict equality for comparisons, i.e. `===`. If the array is already sorted
	     * providing `true` for `fromIndex` will run a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value or `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 3, 1, 2, 3], 2);
	     * // => 1
	     *
	     * _.indexOf([1, 2, 3, 1, 2, 3], 2, 3);
	     * // => 4
	     *
	     * _.indexOf([1, 1, 2, 2, 3, 3], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      if (typeof fromIndex == 'number') {
	        var length = array ? array.length : 0;
	        fromIndex = (fromIndex < 0 ? nativeMax(0, length + fromIndex) : fromIndex || 0);
	      } else if (fromIndex) {
	        var index = sortedIndex(array, value);
	        return array[index] === value ? index : -1;
	      }
	      return baseIndexOf(array, value, fromIndex);
	    }
	
	    /**
	     * Gets all but the last element or last `n` elements of an array. If a
	     * callback is provided elements at the end of the array are excluded from
	     * the result as long as the callback returns truey. The callback is bound
	     * to `thisArg` and invoked with three arguments; (value, index, array).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {Array} array The array to query.
	     * @param {Function|Object|number|string} [callback=1] The function called
	     *  per element or the number of elements to exclude. If a property name or
	     *  object is provided it will be used to create a "_.pluck" or "_.where"
	     *  style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Array} Returns a slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.initial([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.initial([1, 2, 3], function(num) {
	     *   return num > 1;
	     * });
	     * // => [1]
	     *
	     * var characters = [
	     *   { 'name': 'barney',  'blocked': false, 'employer': 'slate' },
	     *   { 'name': 'fred',    'blocked': true,  'employer': 'slate' },
	     *   { 'name': 'pebbles', 'blocked': true,  'employer': 'na' }
	     * ];
	     *
	     * // using "_.pluck" callback shorthand
	     * _.initial(characters, 'blocked');
	     * // => [{ 'name': 'barney',  'blocked': false, 'employer': 'slate' }]
	     *
	     * // using "_.where" callback shorthand
	     * _.pluck(_.initial(characters, { 'employer': 'na' }), 'name');
	     * // => ['barney', 'fred']
	     */
	    function initial(array, callback, thisArg) {
	      var n = 0,
	          length = array ? array.length : 0;
	
	      if (typeof callback != 'number' && callback != null) {
	        var index = length;
	        callback = lodash.createCallback(callback, thisArg, 3);
	        while (index-- && callback(array[index], index, array)) {
	          n++;
	        }
	      } else {
	        n = (callback == null || thisArg) ? 1 : callback || n;
	      }
	      return slice(array, 0, nativeMin(nativeMax(0, length - n), length));
	    }
	
	    /**
	     * Creates an array of unique values present in all provided arrays using
	     * strict equality for comparisons, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {...Array} [array] The arrays to inspect.
	     * @returns {Array} Returns an array of shared values.
	     * @example
	     *
	     * _.intersection([1, 2, 3], [5, 2, 1, 4], [2, 1]);
	     * // => [1, 2]
	     */
	    function intersection() {
	      var args = [],
	          argsIndex = -1,
	          argsLength = arguments.length,
	          caches = getArray(),
	          indexOf = getIndexOf(),
	          trustIndexOf = indexOf === baseIndexOf,
	          seen = getArray();
	
	      while (++argsIndex < argsLength) {
	        var value = arguments[argsIndex];
	        if (isArray(value) || isArguments(value)) {
	          args.push(value);
	          caches.push(trustIndexOf && value.length >= largeArraySize &&
	            createCache(argsIndex ? args[argsIndex] : seen));
	        }
	      }
	      var array = args[0],
	          index = -1,
	          length = array ? array.length : 0,
	          result = [];
	
	      outer:
	      while (++index < length) {
	        var cache = caches[0];
	        value = array[index];
	
	        if ((cache ? cacheIndexOf(cache, value) : indexOf(seen, value)) < 0) {
	          argsIndex = argsLength;
	          (cache || seen).push(value);
	          while (--argsIndex) {
	            cache = caches[argsIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(args[argsIndex], value)) < 0) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	      }
	      while (argsLength--) {
	        cache = caches[argsLength];
	        if (cache) {
	          releaseObject(cache);
	        }
	      }
	      releaseArray(caches);
	      releaseArray(seen);
	      return result;
	    }
	
	    /**
	     * Gets the last element or last `n` elements of an array. If a callback is
	     * provided elements at the end of the array are returned as long as the
	     * callback returns truey. The callback is bound to `thisArg` and invoked
	     * with three arguments; (value, index, array).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {Array} array The array to query.
	     * @param {Function|Object|number|string} [callback] The function called
	     *  per element or the number of elements to return. If a property name or
	     *  object is provided it will be used to create a "_.pluck" or "_.where"
	     *  style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {*} Returns the last element(s) of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     *
	     * _.last([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.last([1, 2, 3], function(num) {
	     *   return num > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var characters = [
	     *   { 'name': 'barney',  'blocked': false, 'employer': 'slate' },
	     *   { 'name': 'fred',    'blocked': true,  'employer': 'slate' },
	     *   { 'name': 'pebbles', 'blocked': true,  'employer': 'na' }
	     * ];
	     *
	     * // using "_.pluck" callback shorthand
	     * _.pluck(_.last(characters, 'blocked'), 'name');
	     * // => ['fred', 'pebbles']
	     *
	     * // using "_.where" callback shorthand
	     * _.last(characters, { 'employer': 'na' });
	     * // => [{ 'name': 'pebbles', 'blocked': true, 'employer': 'na' }]
	     */
	    function last(array, callback, thisArg) {
	      var n = 0,
	          length = array ? array.length : 0;
	
	      if (typeof callback != 'number' && callback != null) {
	        var index = length;
	        callback = lodash.createCallback(callback, thisArg, 3);
	        while (index-- && callback(array[index], index, array)) {
	          n++;
	        }
	      } else {
	        n = callback;
	        if (n == null || thisArg) {
	          return array ? array[length - 1] : undefined;
	        }
	      }
	      return slice(array, nativeMax(0, length - n));
	    }
	
	    /**
	     * Gets the index at which the last occurrence of `value` is found using strict
	     * equality for comparisons, i.e. `===`. If `fromIndex` is negative, it is used
	     * as the offset from the end of the collection.
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value or `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 3, 1, 2, 3], 2);
	     * // => 4
	     *
	     * _.lastIndexOf([1, 2, 3, 1, 2, 3], 2, 3);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var index = array ? array.length : 0;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(0, index + fromIndex) : nativeMin(fromIndex, index - 1)) + 1;
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from the given array using strict equality for
	     * comparisons, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {Array} array The array to modify.
	     * @param {...*} [value] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull(array) {
	      var args = arguments,
	          argsIndex = 0,
	          argsLength = args.length,
	          length = array ? array.length : 0;
	
	      while (++argsIndex < argsLength) {
	        var index = -1,
	            value = args[argsIndex];
	        while (++index < length) {
	          if (array[index] === value) {
	            splice.call(array, index--, 1);
	            length--;
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to but not including `end`. If `start` is less than `stop` a
	     * zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns a new range array.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      start = +start || 0;
	      step = typeof step == 'number' ? step : (+step || 1);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      }
	      // use `Array(length)` so engines like Chakra and V8 avoid slower modes
	      // http://youtu.be/XAqIpGU8ZZk#t=17m25s
	      var index = -1,
	          length = nativeMax(0, ceil((end - start) / (step || 1))),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Removes all elements from an array that the callback returns truey for
	     * and returns an array of removed elements. The callback is bound to `thisArg`
	     * and invoked with three arguments; (value, index, array).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Array} Returns a new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4, 5, 6];
	     * var evens = _.remove(array, function(num) { return num % 2 == 0; });
	     *
	     * console.log(array);
	     * // => [1, 3, 5]
	     *
	     * console.log(evens);
	     * // => [2, 4, 6]
	     */
	    function remove(array, callback, thisArg) {
	      var index = -1,
	          length = array ? array.length : 0,
	          result = [];
	
	      callback = lodash.createCallback(callback, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (callback(value, index, array)) {
	          result.push(value);
	          splice.call(array, index--, 1);
	          length--;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.initial` this method gets all but the first element or
	     * first `n` elements of an array. If a callback function is provided elements
	     * at the beginning of the array are excluded from the result as long as the
	     * callback returns truey. The callback is bound to `thisArg` and invoked
	     * with three arguments; (value, index, array).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias drop, tail
	     * @category Arrays
	     * @param {Array} array The array to query.
	     * @param {Function|Object|number|string} [callback=1] The function called
	     *  per element or the number of elements to exclude. If a property name or
	     *  object is provided it will be used to create a "_.pluck" or "_.where"
	     *  style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Array} Returns a slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.rest([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.rest([1, 2, 3], function(num) {
	     *   return num < 3;
	     * });
	     * // => [3]
	     *
	     * var characters = [
	     *   { 'name': 'barney',  'blocked': true,  'employer': 'slate' },
	     *   { 'name': 'fred',    'blocked': false,  'employer': 'slate' },
	     *   { 'name': 'pebbles', 'blocked': true, 'employer': 'na' }
	     * ];
	     *
	     * // using "_.pluck" callback shorthand
	     * _.pluck(_.rest(characters, 'blocked'), 'name');
	     * // => ['fred', 'pebbles']
	     *
	     * // using "_.where" callback shorthand
	     * _.rest(characters, { 'employer': 'slate' });
	     * // => [{ 'name': 'pebbles', 'blocked': true, 'employer': 'na' }]
	     */
	    function rest(array, callback, thisArg) {
	      if (typeof callback != 'number' && callback != null) {
	        var n = 0,
	            index = -1,
	            length = array ? array.length : 0;
	
	        callback = lodash.createCallback(callback, thisArg, 3);
	        while (++index < length && callback(array[index], index, array)) {
	          n++;
	        }
	      } else {
	        n = (callback == null || thisArg) ? 1 : nativeMax(0, callback);
	      }
	      return slice(array, n);
	    }
	
	    /**
	     * Uses a binary search to determine the smallest index at which a value
	     * should be inserted into a given sorted array in order to maintain the sort
	     * order of the array. If a callback is provided it will be executed for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * callback is bound to `thisArg` and invoked with one argument; (value).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([20, 30, 50], 40);
	     * // => 2
	     *
	     * // using "_.pluck" callback shorthand
	     * _.sortedIndex([{ 'x': 20 }, { 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 2
	     *
	     * var dict = {
	     *   'wordToNumber': { 'twenty': 20, 'thirty': 30, 'fourty': 40, 'fifty': 50 }
	     * };
	     *
	     * _.sortedIndex(['twenty', 'thirty', 'fifty'], 'fourty', function(word) {
	     *   return dict.wordToNumber[word];
	     * });
	     * // => 2
	     *
	     * _.sortedIndex(['twenty', 'thirty', 'fifty'], 'fourty', function(word) {
	     *   return this.wordToNumber[word];
	     * }, dict);
	     * // => 2
	     */
	    function sortedIndex(array, value, callback, thisArg) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      // explicitly reference `identity` for better inlining in Firefox
	      callback = callback ? lodash.createCallback(callback, thisArg, 1) : identity;
	      value = callback(value);
	
	      while (low < high) {
	        var mid = (low + high) >>> 1;
	        (callback(array[mid]) < value)
	          ? low = mid + 1
	          : high = mid;
	      }
	      return low;
	    }
	
	    /**
	     * Creates an array of unique values, in order, of the provided arrays using
	     * strict equality for comparisons, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {...Array} [array] The arrays to inspect.
	     * @returns {Array} Returns an array of combined values.
	     * @example
	     *
	     * _.union([1, 2, 3], [5, 2, 1, 4], [2, 1]);
	     * // => [1, 2, 3, 5, 4]
	     */
	    function union() {
	      return baseUniq(baseFlatten(arguments, true, true));
	    }
	
	    /**
	     * Creates a duplicate-value-free version of an array using strict equality
	     * for comparisons, i.e. `===`. If the array is sorted, providing
	     * `true` for `isSorted` will use a faster algorithm. If a callback is provided
	     * each element of `array` is passed through the callback before uniqueness
	     * is computed. The callback is bound to `thisArg` and invoked with three
	     * arguments; (value, index, array).
	     *
	     * If a property name is provided for `callback` the created "_.pluck" style
	     * callback will return the property value of the given element.
	     *
	     * If an object is provided for `callback` the created "_.where" style callback
	     * will return `true` for elements that have the properties of the given object,
	     * else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Arrays
	     * @param {Array} array The array to process.
	     * @param {boolean} [isSorted=false] A flag to indicate that `array` is sorted.
	     * @param {Function|Object|string} [callback=identity] The function called
	     *  per iteration. If a property name or object is provided it will be used
	     *  to create a "_.pluck" or "_.where" style callback, respectively.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Array} Returns a duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([1, 2, 1, 3, 1]);
	     * // => [1, 2, 3]
	     *
	     * _.uniq([1, 1, 2, 2, 3], true);
	     * // => [1, 2, 3]
	     *
	     * _.uniq(['A', 'b', 'C', 'a', 'B', 'c'], function(letter) { return letter.toLowerCase(); });
	     * // => ['A', 'b', 'C']
	     *
	     * _.uniq([1, 2.5, 3, 1.5, 2, 3.5], function(num) { return this.floor(num); }, Math);
	     * // => [1, 2.5, 3]
	     *
	     * // using "_.pluck" callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, callback, thisArg) {
	      // juggle arguments
	      if (typeof isSorted != 'boolean' && isSorted != null) {
	        thisArg = callback;
	        callback = (typeof isSorted != 'function' && thisArg && thisArg[isSorted] === array) ? null : isSorted;
	        isSorted = false;
	      }
	      if (callback != null) {
	        callback = lodash.createCallback(callback, thisArg, 3);
	      }
	      return baseUniq(array, isSorted, callback);
	    }
	
	    /**
	     * Creates an array excluding all provided values using strict equality for
	     * comparisons, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {Array} array The array to filter.
	     * @param {...*} [value] The values to exclude.
	     * @returns {Array} Returns a new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 0, 3, 1, 4], 0, 1);
	     * // => [2, 3, 4]
	     */
	    function without(array) {
	      return baseDifference(array, slice(arguments, 1));
	    }
	
	    /**
	     * Creates an array that is the symmetric difference of the provided arrays.
	     * See http://en.wikipedia.org/wiki/Symmetric_difference.
	     *
	     * @static
	     * @memberOf _
	     * @category Arrays
	     * @param {...Array} [array] The arrays to inspect.
	     * @returns {Array} Returns an array of values.
	     * @example
	     *
	     * _.xor([1, 2, 3], [5, 2, 1, 4]);
	     * // => [3, 5, 4]
	     *
	     * _.xor([1, 2, 5], [2, 3, 5], [3, 4, 5]);
	     * // => [1, 4, 5]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArray(array) || isArguments(array)) {
	          var result = result
	            ? baseUniq(baseDifference(result, array).concat(baseDifference(array, result)))
	            : array;
	        }
	      }
	      return result || [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second
	     * elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @alias unzip
	     * @category Arrays
	     * @param {...Array} [array] Arrays to process.
	     * @returns {Array} Returns a new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    function zip() {
	      var array = arguments.length > 1 ? arguments : arguments[0],
	          index = -1,
	          length = array ? max(pluck(array, 'length')) : 0,
	          result = Array(length < 0 ? 0 : length);
	
	      while (++index < length) {
	        result[index] = pluck(array, index);
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed from arrays of `keys` and `values`. Provide
	     * either a single two dimensional array, i.e. `[[key1, value1], [key2, value2]]`
	     * or two arrays, one of `keys` and one of corresponding `values`.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Arrays
	     * @param {Array} keys The array of keys.
	     * @param {Array} [values=[]] The array of values.
	     * @returns {Object} Returns an object composed of the given keys and
	     *  corresponding values.
	     * @example
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(keys, values) {
	      var index = -1,
	          length = keys ? keys.length : 0,
	          result = {};
	
	      if (!values && length && !isArray(keys[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = keys[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /*--------------------------------------------------------------------------*/
	
	    /**
	     * Creates a function that executes `func`, with  the `this` binding and
	     * arguments of the created function, only after being called `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category Functions
	     * @param {number} n The number of times the function must be called before
	     *  `func` is executed.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('Done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'Done saving!', after all saves have completed
	     */
	    function after(n, func) {
	      if (!isFunction(func)) {
	        throw new TypeError;
	      }
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that, when called, invokes `func` with the `this`
	     * binding of `thisArg` and prepends any additional `bind` arguments to those
	     * provided to the bound function.
	     *
	     * @static
	     * @memberOf _
	     * @category Functions
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {...*} [arg] Arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var func = function(greeting) {
	     *   return greeting + ' ' + this.name;
	     * };
	     *
	     * func = _.bind(func, { 'name': 'fred' }, 'hi');
	     * func();
	     * // => 'hi fred'
	     */
	    function bind(func, thisArg) {
	      return arguments.length > 2
	        ? createWrapper(func, 17, slice(arguments, 2), null, thisArg)
	        : createWrapper(func, 1, null, null, thisArg);
	    }
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all the function properties
	     * of `object` will be bound.
	     *
	     * @static
	     * @memberOf _
	     * @category Functions
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...string} [methodName] The object method names to
	     *  bind, specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() { console.log('clicked ' + this.label); }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs', when the button is clicked
	     */
	    function bindAll(object) {
	      var funcs = arguments.length > 1 ? baseFlatten(arguments, true, false, 1) : functions(object),
	          index = -1,
	          length = funcs.length;
	
	      while (++index < length) {
	        var key = funcs[index];
	        object[key] = createWrapper(object[key], 1, null, null, object);
	      }
	      return object;
	    }
	
	    /**
	     * Creates a function that, when called, invokes the method at `object[key]`
	     * and prepends any additional `bindKey` arguments to those provided to the bound
	     * function. This method differs from `_.bind` by allowing bound functions to
	     * reference methods that will be redefined or don't yet exist.
	     * See http://michaux.ca/articles/lazy-function-definition-pattern.
	     *
	     * @static
	     * @memberOf _
	     * @category Functions
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [arg] Arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'name': 'fred',
	     *   'greet': function(greeting) {
	     *     return greeting + ' ' + this.name;
	     *   }
	     * };
	     *
	     * var func = _.bindKey(object, 'greet', 'hi');
	     * func();
	     * // => 'hi fred'
	     *
	     * object.greet = function(greeting) {
	     *   return greeting + 'ya ' + this.name + '!';
	     * };
	     *
	     * func();
	     * // => 'hiya fred!'
	     */
	    function bindKey(object, key) {
	      return arguments.length > 2
	        ? createWrapper(key, 19, slice(arguments, 2), null, object)
	        : createWrapper(key, 3, null, null, object);
	    }
	
	    /**
	     * Creates a function that is the composition of the provided functions,
	     * where each function consumes the return value of the function that follows.
	     * For example, composing the functions `f()`, `g()`, and `h()` produces `f(g(h()))`.
	     * Each function is executed with the `this` binding of the composed function.
	     *
	     * @static
	     * @memberOf _
	     * @category Functions
	     * @param {...Function} [func] Functions to compose.
	     * @returns {Function} Returns the new composed function.
	     * @example
	     *
	     * var realNameMap = {
	     *   'pebbles': 'penelope'
	     * };
	     *
	     * var format = function(name) {
	     *   name = realNameMap[name.toLowerCase()] || name;
	     *   return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
	     * };
	     *
	     * var greet = function(formatted) {
	     *   return 'Hiya ' + formatted + '!';
	     * };
	     *
	     * var welcome = _.compose(greet, format);
	     * welcome('pebbles');
	     * // => 'Hiya Penelope!'
	     */
	    function compose() {
	      var funcs = arguments,
	          length = funcs.length;
	
	      while (length--) {
	        if (!isFunction(funcs[length])) {
	          throw new TypeError;
	        }
	      }
	      return function() {
	        var args = arguments,
	            length = funcs.length;
	
	        while (length--) {
	          args = [funcs[length].apply(this, args)];
	        }
	        return args[0];
	      };
	    }
	
	    /**
	     * Creates a function which accepts one or more arguments of `func` that when
	     * invoked either executes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` can be specified
	     * if `func.length` is not sufficient.
	     *
	     * @static
	     * @memberOf _
	     * @category Functions
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var curried = _.curry(function(a, b, c) {
	     *   console.log(a + b + c);
	     * });
	     *
	     * curried(1)(2)(3);
	     * // => 6
	     *
	     * curried(1, 2)(3);
	     * // => 6
	     *
	     * curried(1, 2, 3);
	     * // => 6
	     */
	    function curry(func, arity) {
	      arity = typeof arity == 'number' ? arity : (+arity || func.length);
	      return createWrapper(func, 4, null, null, null, arity);
	    }
	
	    /**
	     * Creates a function that will delay the execution of `func` until after
	     * `wait` milliseconds have elapsed since the last time it was invoked.
	     * Provide an options object to indicate that `func` should be invoked on
	     * the leading and/or trailing edge of the `wait` timeout. Subsequent calls
	     * to the debounced function will return the result of the last `func` call.
	     *
	     * Note: If `leading` and `trailing` options are `true` `func` will be called
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * @static
	     * @memberOf _
	     * @category Functions
	     * @param {Function} func The function to debounce.
	     * @param {number} wait The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify execution on the leading edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be delayed before it's called.
	     * @param {boolean} [options.trailing=true] Specify execution on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * var lazyLayout = _.debounce(calculateLayout, 150);
	     * jQuery(window).on('resize', lazyLayout);
	     *
	     * // execute `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * });
	     *
	     * // ensure `batchLog` is executed once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * source.addEventListener('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }, false);
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (!isFunction(func)) {
	        throw new TypeError;
	      }
	      wait = nativeMax(0, wait) || 0;
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = options.leading;
	        maxWait = 'maxWait' in options && (nativeMax(wait, options.maxWait) || 0);
	        trailing = 'trailing' in options ? options.trailing : trailing;
	      }
	      var delayed = function() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0) {
	          if (maxTimeoutId) {
	            clearTimeout(maxTimeoutId);
	          }
	          var isCalled = trailingCall;
	          maxTimeoutId = timeoutId = trailingCall = undefined;
	          if (isCalled) {
	            lastCalled = now();
	            result = func.apply(thisArg, args);
	            if (!timeoutId && !maxTimeoutId) {
	              args = thisArg = null;
	            }
	          }
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      };
	
	      var maxDelayed = function() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (trailing || (maxWait !== wait)) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = null;
	          }
	        }
	      };
	
	      return function() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = null;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Defers executing the `func` function until the current call stack has cleared.
	     * Additional arguments will be provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Functions
	     * @param {Function} func The function to defer.
	     * @param {...*} [arg] Arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) { console.log(text); }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    function defer(func) {
	      if (!isFunction(func)) {
	        throw new TypeError;
	      }
	      var args = slice(arguments, 1);
	      return setTimeout(function() { func.apply(undefined, args); }, 1);
	    }
	
	    /**
	     * Executes the `func` function after `wait` milliseconds. Additional arguments
	     * will be provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Functions
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay execution.
	     * @param {...*} [arg] Arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) { console.log(text); }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    function delay(func, wait) {
	      if (!isFunction(func)) {
	        throw new TypeError;
	      }
	      var args = slice(arguments, 2);
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it will be used to determine the cache key for storing the result
	     * based on the arguments provided to the memoized function. By default, the
	     * first argument provided to the memoized function is used as the cache key.
	     * The `func` is executed with the `this` binding of the memoized function.
	     * The result cache is exposed as the `cache` property on the memoized function.
	     *
	     * @static
	     * @memberOf _
	     * @category Functions
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] A function used to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var fibonacci = _.memoize(function(n) {
	     *   return n < 2 ? n : fibonacci(n - 1) + fibonacci(n - 2);
	     * });
	     *
	     * fibonacci(9)
	     * // => 34
	     *
	     * var data = {
	     *   'fred': { 'name': 'fred', 'age': 40 },
	     *   'pebbles': { 'name': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // modifying the result cache
	     * var get = _.memoize(function(name) { return data[name]; }, _.identity);
	     * get('pebbles');
	     * // => { 'name': 'pebbles', 'age': 1 }
	     *
	     * get.cache.pebbles.name = 'penelope';
	     * get('pebbles');
	     * // => { 'name': 'penelope', 'age': 1 }
	     */
	    function memoize(func, resolver) {
	      if (!isFunction(func)) {
	        throw new TypeError;
	      }
	      var memoized = function() {
	        var cache = memoized.cache,
	            key = resolver ? resolver.apply(this, arguments) : keyPrefix + arguments[0];
	
	        return hasOwnProperty.call(cache, key)
	          ? cache[key]
	          : (cache[key] = func.apply(this, arguments));
	      }
	      memoized.cache = {};
	      return memoized;
	    }
	
	    /**
	     * Creates a function that is restricted to execute `func` once. Repeat calls to
	     * the function will return the value of the first call. The `func` is executed
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Functions
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` executes `createApplication` once
	     */
	    function once(func) {
	      var ran,
	          result;
	
	      if (!isFunction(func)) {
	        throw new TypeError;
	      }
	      return function() {
	        if (ran) {
	          return result;
	        }
	        ran = true;
	        result = func.apply(this, arguments);
	
	        // clear the `func` variable so the function may be garbage collected
	        func = null;
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that, when called, invokes `func` with any additional
	     * `partial` arguments prepended to those provided to the new function. This
	     * method is similar to `_.bind` except it does **not** alter the `this` binding.
	     *
	     * @static
	     * @memberOf _
	     * @category Functions
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [arg] Arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) { return greeting + ' ' + name; };
	     * var hi = _.partial(greet, 'hi');
	     * hi('fred');
	     * // => 'hi fred'
	     */
	    function partial(func) {
	      return createWrapper(func, 16, slice(arguments, 1));
	    }
	
	    /**
	     * This method is like `_.partial` except that `partial` arguments are
	     * appended to those provided to the new function.
	     *
	     * @static
	     * @memberOf _
	     * @category Functions
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [arg] Arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var defaultsDeep = _.partialRight(_.merge, _.defaults);
	     *
	     * var options = {
	     *   'variable': 'data',
	     *   'imports': { 'jq': $ }
	     * };
	     *
	     * defaultsDeep(options, _.templateSettings);
	     *
	     * options.variable
	     * // => 'data'
	     *
	     * options.imports
	     * // => { '_': _, 'jq': $ }
	     */
	    function partialRight(func) {
	      return createWrapper(func, 32, null, slice(arguments, 1));
	    }
	
	    /**
	     * Creates a function that, when executed, will only call the `func` function
	     * at most once per every `wait` milliseconds. Provide an options object to
	     * indicate that `func` should be invoked on the leading and/or trailing edge
	     * of the `wait` timeout. Subsequent calls to the throttled function will
	     * return the result of the last `func` call.
	     *
	     * Note: If `leading` and `trailing` options are `true` `func` will be called
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * @static
	     * @memberOf _
	     * @category Functions
	     * @param {Function} func The function to throttle.
	     * @param {number} wait The number of milliseconds to throttle executions to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify execution on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify execution on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * var throttled = _.throttle(updatePosition, 100);
	     * jQuery(window).on('scroll', throttled);
	     *
	     * // execute `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (!isFunction(func)) {
	        throw new TypeError;
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? options.leading : leading;
	        trailing = 'trailing' in options ? options.trailing : trailing;
	      }
	      debounceOptions.leading = leading;
	      debounceOptions.maxWait = wait;
	      debounceOptions.trailing = trailing;
	
	      return debounce(func, wait, debounceOptions);
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Additional arguments provided to the function are appended
	     * to those provided to the wrapper function. The wrapper is executed with
	     * the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Functions
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('Fred, Wilma, & Pebbles');
	     * // => '<p>Fred, Wilma, &amp; Pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return createWrapper(wrapper, 16, [value]);
	    }
	
	    /*--------------------------------------------------------------------------*/
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utilities
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'name': 'fred' };
	     * var getter = _.constant(object);
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Produces a callback bound to an optional `thisArg`. If `func` is a property
	     * name the created callback will return the property value for a given element.
	     * If `func` is an object the created callback will return `true` for elements
	     * that contain the equivalent object properties, otherwise it will return `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utilities
	     * @param {*} [func=identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of the created callback.
	     * @param {number} [argCount] The number of arguments the callback accepts.
	     * @returns {Function} Returns a callback function.
	     * @example
	     *
	     * var characters = [
	     *   { 'name': 'barney', 'age': 36 },
	     *   { 'name': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.createCallback = _.wrap(_.createCallback, function(func, callback, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(callback);
	     *   return !match ? func(callback, thisArg) : function(object) {
	     *     return match[2] == 'gt' ? object[match[1]] > match[3] : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(characters, 'age__gt38');
	     * // => [{ 'name': 'fred', 'age': 40 }]
	     */
	    function createCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (func == null || type == 'function') {
	        return baseCreateCallback(func, thisArg, argCount);
	      }
	      // handle "_.pluck" style callback shorthands
	      if (type != 'object') {
	        return property(func);
	      }
	      var props = keys(func),
	          key = props[0],
	          a = func[key];
	
	      // handle "_.where" style callback shorthands
	      if (props.length == 1 && a === a && !isObject(a)) {
	        // fast path the common case of providing an object with a single
	        // property containing a primitive value
	        return function(object) {
	          var b = object[key];
	          return a === b && (a !== 0 || (1 / a == 1 / b));
	        };
	      }
	      return function(object) {
	        var length = props.length,
	            result = false;
	
	        while (length--) {
	          if (!(result = baseIsEqual(object[props[length]], func[props[length]], null, true))) {
	            break;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Converts the characters `&`, `<`, `>`, `"`, and `'` in `string` to their
	     * corresponding HTML entities.
	     *
	     * @static
	     * @memberOf _
	     * @category Utilities
	     * @param {string} string The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('Fred, Wilma, & Pebbles');
	     * // => 'Fred, Wilma, &amp; Pebbles'
	     */
	    function escape(string) {
	      return string == null ? '' : String(string).replace(reUnescapedHtml, escapeHtmlChar);
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utilities
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'name': 'fred' };
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Adds function properties of a source object to the destination object.
	     * If `object` is a function methods will be added to its prototype as well.
	     *
	     * @static
	     * @memberOf _
	     * @category Utilities
	     * @param {Function|Object} [object=lodash] object The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added are chainable.
	     * @example
	     *
	     * function capitalize(string) {
	     *   return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
	     * }
	     *
	     * _.mixin({ 'capitalize': capitalize });
	     * _.capitalize('fred');
	     * // => 'Fred'
	     *
	     * _('fred').capitalize().value();
	     * // => 'Fred'
	     *
	     * _.mixin({ 'capitalize': capitalize }, { 'chain': false });
	     * _('fred').capitalize();
	     * // => 'Fred'
	     */
	    function mixin(object, source, options) {
	      var chain = true,
	          methodNames = source && functions(source);
	
	      if (!source || (!options && !methodNames.length)) {
	        if (options == null) {
	          options = source;
	        }
	        ctor = lodashWrapper;
	        source = object;
	        object = lodash;
	        methodNames = functions(source);
	      }
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      var ctor = object,
	          isFunc = isFunction(ctor);
	
	      forEach(methodNames, function(methodName) {
	        var func = object[methodName] = source[methodName];
	        if (isFunc) {
	          ctor.prototype[methodName] = function() {
	            var chainAll = this.__chain__,
	                value = this.__wrapped__,
	                args = [value];
	
	            push.apply(args, arguments);
	            var result = func.apply(object, args);
	            if (chain || chainAll) {
	              if (value === result && isObject(result)) {
	                return this;
	              }
	              result = new ctor(result);
	              result.__chain__ = chainAll;
	            }
	            return result;
	          };
	        }
	      });
	    }
	
	    /**
	     * Reverts the '_' variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utilities
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      context._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utilities
	     * @example
	     *
	     * var object = { 'name': 'fred' };
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // no operation performed
	    }
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Utilities
	     * @example
	     *
	     * var stamp = _.now();
	     * _.defer(function() { console.log(_.now() - stamp); });
	     * // => logs the number of milliseconds it took for the deferred function to be called
	     */
	    var now = isNative(now = Date.now) && now || function() {
	      return new Date().getTime();
	    };
	
	    /**
	     * Converts the given value into an integer of the specified radix.
	     * If `radix` is `undefined` or `0` a `radix` of `10` is used unless the
	     * `value` is a hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * Note: This method avoids differences in native ES3 and ES5 `parseInt`
	     * implementations. See http://es5.github.io/#E.
	     *
	     * @static
	     * @memberOf _
	     * @category Utilities
	     * @param {string} value The value to parse.
	     * @param {number} [radix] The radix used to interpret the value to parse.
	     * @returns {number} Returns the new integer value.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     */
	    var parseInt = nativeParseInt(whitespace + '08') == 8 ? nativeParseInt : function(value, radix) {
	      // Firefox < 21 and Opera < 15 follow the ES3 specified implementation of `parseInt`
	      return nativeParseInt(isString(value) ? value.replace(reLeadingSpacesAndZeros, '') : value, radix || 0);
	    };
	
	    /**
	     * Creates a "_.pluck" style function, which returns the `key` value of a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utilities
	     * @param {string} key The name of the property to retrieve.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var characters = [
	     *   { 'name': 'fred',   'age': 40 },
	     *   { 'name': 'barney', 'age': 36 }
	     * ];
	     *
	     * var getName = _.property('name');
	     *
	     * _.map(characters, getName);
	     * // => ['barney', 'fred']
	     *
	     * _.sortBy(characters, getName);
	     * // => [{ 'name': 'barney', 'age': 36 }, { 'name': 'fred',   'age': 40 }]
	     */
	    function property(key) {
	      return function(object) {
	        return object[key];
	      };
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number will be
	     * returned. If `floating` is truey or either `min` or `max` are floats a
	     * floating-point number will be returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Utilities
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating=false] Specify returning a floating-point number.
	     * @returns {number} Returns a random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (typeof min == 'boolean' && noMax) {
	          floating = min;
	          min = 1;
	        }
	        else if (!noMax && typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand +'').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /**
	     * Resolves the value of property `key` on `object`. If `key` is a function
	     * it will be invoked with the `this` binding of `object` and its result returned,
	     * else the property value is returned. If `object` is falsey then `undefined`
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Utilities
	     * @param {Object} object The object to inspect.
	     * @param {string} key The name of the property to resolve.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = {
	     *   'cheese': 'crumpets',
	     *   'stuff': function() {
	     *     return 'nonsense';
	     *   }
	     * };
	     *
	     * _.result(object, 'cheese');
	     * // => 'crumpets'
	     *
	     * _.result(object, 'stuff');
	     * // => 'nonsense'
	     */
	    function result(object, key) {
	      if (object) {
	        var value = object[key];
	        return isFunction(value) ? object[key]() : value;
	      }
	    }
	
	    /**
	     * A micro-templating method that handles arbitrary delimiters, preserves
	     * whitespace, and correctly escapes quotes within interpolated code.
	     *
	     * Note: In the development build, `_.template` utilizes sourceURLs for easier
	     * debugging. See http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl
	     *
	     * For more information on precompiling templates see:
	     * https://lodash.com/custom-builds
	     *
	     * For more information on Chrome extension sandboxes see:
	     * http://developer.chrome.com/stable/extensions/sandboxingEval.html
	     *
	     * @static
	     * @memberOf _
	     * @category Utilities
	     * @param {string} text The template text.
	     * @param {Object} data The data object used to populate the text.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as local variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [variable] The data object variable name.
	     * @returns {Function|string} Returns a compiled function when no `data` object
	     *  is given, else it returns the interpolated text.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= name %>');
	     * compiled({ 'name': 'fred' });
	     * // => 'hello fred'
	     *
	     * // using the "escape" delimiter to escape HTML in data property values
	     * _.template('<b><%- value %></b>', { 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to generate HTML
	     * var list = '<% _.forEach(people, function(name) { %><li><%- name %></li><% }); %>';
	     * _.template(list, { 'people': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the ES6 delimiter as an alternative to the default "interpolate" delimiter
	     * _.template('hello ${ name }', { 'name': 'pebbles' });
	     * // => 'hello pebbles'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * _.template('<% print("hello " + name); %>!', { 'name': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using a custom template delimiters
	     * _.templateSettings = {
	     *   'interpolate': /{{([\s\S]+?)}}/g
	     * };
	     *
	     * _.template('hello {{ name }}!', { 'name': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using the `imports` option to import jQuery
	     * var list = '<% jq.each(people, function(name) { %><li><%- name %></li><% }); %>';
	     * _.template(list, { 'people': ['fred', 'barney'] }, { 'imports': { 'jq': jQuery } });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= name %>', null, { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.name %>!', null, { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     *   var __t, __p = '', __e = _.escape;
	     *   __p += 'hi ' + ((__t = ( data.name )) == null ? '' : __t) + '!';
	     *   return __p;
	     * }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(text, data, options) {
	      // based on John Resig's `tmpl` implementation
	      // http://ejohn.org/blog/javascript-micro-templating/
	      // and Laura Doktorova's doT.js
	      // https://github.com/olado/doT
	      var settings = lodash.templateSettings;
	      text = String(text || '');
	
	      // avoid missing dependencies when `iteratorTemplate` is not defined
	      options = defaults({}, options, settings);
	
	      var imports = defaults({}, options.imports, settings.imports),
	          importsKeys = keys(imports),
	          importsValues = values(imports);
	
	      var isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // compile the regexp to match each delimiter
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      text.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // escape characters that cannot be included in string literals
	        source += text.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // replace delimiters with snippets
	        if (escapeValue) {
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // the JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value
	        return match;
	      });
	
	      source += "';\n";
	
	      // if `variable` is not specified, wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain
	      var variable = options.variable,
	          hasVariable = variable;
	
	      if (!hasVariable) {
	        variable = 'obj';
	        source = 'with (' + variable + ') {\n' + source + '\n}\n';
	      }
	      // cleanup code by stripping empty strings
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // frame code as the function body
	      source = 'function(' + variable + ') {\n' +
	        (hasVariable ? '' : variable + ' || (' + variable + ' = {});\n') +
	        "var __t, __p = '', __e = _.escape" +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      // Use a sourceURL for easier debugging.
	      // http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl
	      var sourceURL = '\n/*\n//# sourceURL=' + (options.sourceURL || '/lodash/template/source[' + (templateCounter++) + ']') + '\n*/';
	
	      try {
	        var result = Function(importsKeys, 'return ' + source + sourceURL).apply(undefined, importsValues);
	      } catch(e) {
	        e.source = source;
	        throw e;
	      }
	      if (data) {
	        return result(data);
	      }
	      // provide the compiled function's source by its `toString` method, in
	      // supported environments, or the `source` property as a convenience for
	      // inlining compiled templates during the build process
	      result.source = source;
	      return result;
	    }
	
	    /**
	     * Executes the callback `n` times, returning an array of the results
	     * of each callback execution. The callback is bound to `thisArg` and invoked
	     * with one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utilities
	     * @param {number} n The number of times to execute the callback.
	     * @param {Function} callback The function called per iteration.
	     * @param {*} [thisArg] The `this` binding of `callback`.
	     * @returns {Array} Returns an array of the results of each `callback` execution.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) { mage.castSpell(n); });
	     * // => calls `mage.castSpell(n)` three times, passing `n` of `0`, `1`, and `2` respectively
	     *
	     * _.times(3, function(n) { this.cast(n); }, mage);
	     * // => also calls `mage.castSpell(n)` three times
	     */
	    function times(n, callback, thisArg) {
	      n = (n = +n) > -1 ? n : 0;
	      var index = -1,
	          result = Array(n);
	
	      callback = baseCreateCallback(callback, thisArg, 1);
	      while (++index < n) {
	        result[index] = callback(index);
	      }
	      return result;
	    }
	
	    /**
	     * The inverse of `_.escape` this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to their
	     * corresponding characters.
	     *
	     * @static
	     * @memberOf _
	     * @category Utilities
	     * @param {string} string The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('Fred, Barney &amp; Pebbles');
	     * // => 'Fred, Barney & Pebbles'
	     */
	    function unescape(string) {
	      return string == null ? '' : String(string).replace(reEscapedHtml, unescapeHtmlChar);
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID will be appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utilities
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return String(prefix == null ? '' : prefix) + id;
	    }
	
	    /*--------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps the given value with explicit
	     * method chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chaining
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var characters = [
	     *   { 'name': 'barney',  'age': 36 },
	     *   { 'name': 'fred',    'age': 40 },
	     *   { 'name': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(characters)
	     *     .sortBy('age')
	     *     .map(function(chr) { return chr.name + ' is ' + chr.age; })
	     *     .first()
	     *     .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      value = new lodashWrapper(value);
	      value.__chain__ = true;
	      return value;
	    }
	
	    /**
	     * Invokes `interceptor` with the `value` as the first argument and then
	     * returns `value`. The purpose of this method is to "tap into" a method
	     * chain in order to perform operations on intermediate results within
	     * the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chaining
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3, 4])
	     *  .tap(function(array) { array.pop(); })
	     *  .reverse()
	     *  .value();
	     * // => [3, 2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chaining
	     * @returns {*} Returns the wrapper object.
	     * @example
	     *
	     * var characters = [
	     *   { 'name': 'barney', 'age': 36 },
	     *   { 'name': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(characters).first();
	     * // => { 'name': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(characters).chain()
	     *   .first()
	     *   .pick('age')
	     *   .value();
	     * // => { 'age': 36 }
	     */
	    function wrapperChain() {
	      this.__chain__ = true;
	      return this;
	    }
	
	    /**
	     * Produces the `toString` result of the wrapped value.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chaining
	     * @returns {string} Returns the string result.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return String(this.__wrapped__);
	    }
	
	    /**
	     * Extracts the wrapped value.
	     *
	     * @name valueOf
	     * @memberOf _
	     * @alias value
	     * @category Chaining
	     * @returns {*} Returns the wrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).valueOf();
	     * // => [1, 2, 3]
	     */
	    function wrapperValueOf() {
	      return this.__wrapped__;
	    }
	
	    /*--------------------------------------------------------------------------*/
	
	    // add functions that return wrapped values when chaining
	    lodash.after = after;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.chain = chain;
	    lodash.compact = compact;
	    lodash.compose = compose;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.createCallback = createCallback;
	    lodash.curry = curry;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.map = map;
	    lodash.mapValues = mapValues;
	    lodash.max = max;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.min = min;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.pull = pull;
	    lodash.range = range;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.shuffle = shuffle;
	    lodash.sortBy = sortBy;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.values = values;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	
	    // add aliases
	    lodash.collect = map;
	    lodash.drop = rest;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	    lodash.unzip = zip;
	
	    // add functions to `lodash.prototype`
	    mixin(lodash);
	
	    /*--------------------------------------------------------------------------*/
	
	    // add functions that return unwrapped values when chaining
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.contains = contains;
	    lodash.escape = escape;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.indexOf = indexOf;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isNaN = isNaN;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isUndefined = isUndefined;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.mixin = mixin;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.result = result;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.template = template;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	
	    // add aliases
	    lodash.all = every;
	    lodash.any = some;
	    lodash.detect = find;
	    lodash.findWhere = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.include = contains;
	    lodash.inject = reduce;
	
	    mixin(function() {
	      var source = {}
	      forOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }(), false);
	
	    /*--------------------------------------------------------------------------*/
	
	    // add functions capable of returning wrapped and unwrapped values when chaining
	    lodash.first = first;
	    lodash.last = last;
	    lodash.sample = sample;
	
	    // add aliases
	    lodash.take = first;
	    lodash.head = first;
	
	    forOwn(lodash, function(func, methodName) {
	      var callbackable = methodName !== 'sample';
	      if (!lodash.prototype[methodName]) {
	        lodash.prototype[methodName]= function(n, guard) {
	          var chainAll = this.__chain__,
	              result = func(this.__wrapped__, n, guard);
	
	          return !chainAll && (n == null || (guard && !(callbackable && typeof n == 'function')))
	            ? result
	            : new lodashWrapper(result, chainAll);
	        };
	      }
	    });
	
	    /*--------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = '2.4.2';
	
	    // add "Chaining" functions to the wrapper
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.value = wrapperValueOf;
	    lodash.prototype.valueOf = wrapperValueOf;
	
	    // add `Array` functions that return unwrapped values
	    baseEach(['join', 'pop', 'shift'], function(methodName) {
	      var func = arrayRef[methodName];
	      lodash.prototype[methodName] = function() {
	        var chainAll = this.__chain__,
	            result = func.apply(this.__wrapped__, arguments);
	
	        return chainAll
	          ? new lodashWrapper(result, chainAll)
	          : result;
	      };
	    });
	
	    // add `Array` functions that return the existing wrapped value
	    baseEach(['push', 'reverse', 'sort', 'unshift'], function(methodName) {
	      var func = arrayRef[methodName];
	      lodash.prototype[methodName] = function() {
	        func.apply(this.__wrapped__, arguments);
	        return this;
	      };
	    });
	
	    // add `Array` functions that return new wrapped values
	    baseEach(['concat', 'slice', 'splice'], function(methodName) {
	      var func = arrayRef[methodName];
	      lodash.prototype[methodName] = function() {
	        return new lodashWrapper(func.apply(this.__wrapped__, arguments), this.__chain__);
	      };
	    });
	
	    // avoid array-like object bugs with `Array#shift` and `Array#splice`
	    // in IE < 9, Firefox < 10, Narwhal, and RingoJS
	    if (!support.spliceObjects) {
	      baseEach(['pop', 'shift', 'splice'], function(methodName) {
	        var func = arrayRef[methodName],
	            isSplice = methodName == 'splice';
	
	        lodash.prototype[methodName] = function() {
	          var chainAll = this.__chain__,
	              value = this.__wrapped__,
	              result = func.apply(value, arguments);
	
	          if (value.length === 0) {
	            delete value[0];
	          }
	          return (chainAll || isSplice)
	            ? new lodashWrapper(result, chainAll)
	            : result;
	        };
	      });
	    }
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // expose Lo-Dash
	  var _ = runInContext();
	
	  // some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose Lo-Dash to the global object even when an AMD loader is present in
	    // case Lo-Dash is loaded with a RequireJS shim config.
	    // See http://requirejs.org/docs/api.html#config-shim
	    root._ = _;
	
	    // define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // check for `exports` after `define` in case a build optimizer adds an `exports` object
	  else if (freeExports && freeModule) {
	    // in Node.js or RingoJS
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // in Narwhal or Rhino -require
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // in a browser or Rhino
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1036)(module), (function() { return this; }())))

/***/ }),

/***/ 1036:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 1037:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1038);

/***/ }),

/***/ 1038:
/***/ (function(module, exports) {

	/*
	 * @license
	 * angular-socket-io v0.7.0
	 * (c) 2014 Brian Ford http://briantford.com
	 * License: MIT
	 */
	
	angular.module('btford.socket-io', []).
	  provider('socketFactory', function () {
	
	    'use strict';
	
	    // when forwarding events, prefix the event name
	    var defaultPrefix = 'socket:',
	      ioSocket;
	
	    // expose to provider
	    this.$get = ['$rootScope', '$timeout', function ($rootScope, $timeout) {
	
	      var asyncAngularify = function (socket, callback) {
	        return callback ? function () {
	          var args = arguments;
	          $timeout(function () {
	            callback.apply(socket, args);
	          }, 0);
	        } : angular.noop;
	      };
	
	      return function socketFactory (options) {
	        options = options || {};
	        var socket = options.ioSocket || io.connect();
	        var prefix = options.prefix === undefined ? defaultPrefix : options.prefix ;
	        var defaultScope = options.scope || $rootScope;
	
	        var addListener = function (eventName, callback) {
	          socket.on(eventName, callback.__ng = asyncAngularify(socket, callback));
	        };
	
	        var addOnceListener = function (eventName, callback) {
	          socket.once(eventName, callback.__ng = asyncAngularify(socket, callback));
	        };
	
	        var wrappedSocket = {
	          on: addListener,
	          addListener: addListener,
	          once: addOnceListener,
	
	          emit: function (eventName, data, callback) {
	            var lastIndex = arguments.length - 1;
	            var callback = arguments[lastIndex];
	            if(typeof callback == 'function') {
	              callback = asyncAngularify(socket, callback);
	              arguments[lastIndex] = callback;
	            }
	            return socket.emit.apply(socket, arguments);
	          },
	
	          removeListener: function (ev, fn) {
	            if (fn && fn.__ng) {
	              arguments[1] = fn.__ng;
	            }
	            return socket.removeListener.apply(socket, arguments);
	          },
	
	          removeAllListeners: function() {
	            return socket.removeAllListeners.apply(socket, arguments);
	          },
	
	          disconnect: function (close) {
	            return socket.disconnect(close);
	          },
	
	          connect: function() {
	            return socket.connect();
	          },
	
	          // when socket.on('someEvent', fn (data) { ... }),
	          // call scope.$broadcast('someEvent', data)
	          forward: function (events, scope) {
	            if (events instanceof Array === false) {
	              events = [events];
	            }
	            if (!scope) {
	              scope = defaultScope;
	            }
	            events.forEach(function (eventName) {
	              var prefixedEvent = prefix + eventName;
	              var forwardBroadcast = asyncAngularify(socket, function () {
	                Array.prototype.unshift.call(arguments, prefixedEvent);
	                scope.$broadcast.apply(scope, arguments);
	              });
	              scope.$on('$destroy', function () {
	                socket.removeListener(eventName, forwardBroadcast);
	              });
	              socket.on(eventName, forwardBroadcast);
	            });
	          }
	        };
	
	        return wrappedSocket;
	      };
	    }];
	  });


/***/ }),

/***/ 1045:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1046);

/***/ }),

/***/ 1046:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();

/***/ }),

/***/ 1068:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1069);
	__webpack_require__(1070);

/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

	/*!
	 * AngularJS Material Design
	 * https://github.com/angular/material
	 * @license MIT
	 * v1.1.10
	 */
	(function( window, angular, undefined ){
	"use strict";
	
	(function(){
	"use strict";
	
	angular.module('ngMaterial', ["ng","ngAnimate","ngAria","material.core","material.core.gestures","material.core.interaction","material.core.layout","material.core.meta","material.core.theming.palette","material.core.theming","material.core.animate","material.components.autocomplete","material.components.backdrop","material.components.bottomSheet","material.components.button","material.components.card","material.components.checkbox","material.components.chips","material.components.colors","material.components.content","material.components.datepicker","material.components.dialog","material.components.divider","material.components.fabActions","material.components.fabShared","material.components.fabSpeedDial","material.components.fabToolbar","material.components.gridList","material.components.icon","material.components.input","material.components.list","material.components.menu","material.components.menuBar","material.components.navBar","material.components.panel","material.components.progressCircular","material.components.progressLinear","material.components.radioButton","material.components.select","material.components.showHide","material.components.sidenav","material.components.slider","material.components.sticky","material.components.subheader","material.components.swipe","material.components.switch","material.components.tabs","material.components.toast","material.components.toolbar","material.components.tooltip","material.components.truncate","material.components.virtualRepeat","material.components.whiteframe"]);
	})();
	(function(){
	"use strict";
	
	/**
	 * Initialization function that validates environment
	 * requirements.
	 */
	DetectNgTouch.$inject = ["$log", "$injector"];
	MdCoreConfigure.$inject = ["$provide", "$mdThemingProvider"];
	rAFDecorator.$inject = ["$delegate"];
	qDecorator.$inject = ["$delegate"];
	angular
	  .module('material.core', [
	    'ngAnimate',
	    'material.core.animate',
	    'material.core.layout',
	    'material.core.interaction',
	    'material.core.gestures',
	    'material.core.theming'
	  ])
	  .config(MdCoreConfigure)
	  .run(DetectNgTouch);
	
	
	/**
	 * Detect if the ng-Touch module is also being used.
	 * Warn if detected.
	 * @ngInject
	 */
	function DetectNgTouch($log, $injector) {
	  if ( $injector.has('$swipe') ) {
	    var msg = "" +
	      "You are using the ngTouch module. \n" +
	      "AngularJS Material already has mobile click, tap, and swipe support... \n" +
	      "ngTouch is not supported with AngularJS Material!";
	    $log.warn(msg);
	  }
	}
	
	/**
	 * @ngInject
	 */
	function MdCoreConfigure($provide, $mdThemingProvider) {
	
	  $provide.decorator('$$rAF', ['$delegate', rAFDecorator]);
	  $provide.decorator('$q', ['$delegate', qDecorator]);
	
	  $mdThemingProvider.theme('default')
	    .primaryPalette('indigo')
	    .accentPalette('pink')
	    .warnPalette('deep-orange')
	    .backgroundPalette('grey');
	}
	
	/**
	 * @ngInject
	 */
	function rAFDecorator($delegate) {
	  /**
	   * Use this to throttle events that come in often.
	   * The throttled function will always use the *last* invocation before the
	   * coming frame.
	   *
	   * For example, window resize events that fire many times a second:
	   * If we set to use an raf-throttled callback on window resize, then
	   * our callback will only be fired once per frame, with the last resize
	   * event that happened before that frame.
	   *
	   * @param {function} callback function to debounce
	   */
	  $delegate.throttle = function(cb) {
	    var queuedArgs, alreadyQueued, queueCb, context;
	    return function debounced() {
	      queuedArgs = arguments;
	      context = this;
	      queueCb = cb;
	      if (!alreadyQueued) {
	        alreadyQueued = true;
	        $delegate(function() {
	          queueCb.apply(context, Array.prototype.slice.call(queuedArgs));
	          alreadyQueued = false;
	        });
	      }
	    };
	  };
	  return $delegate;
	}
	
	/**
	 * @ngInject
	 */
	function qDecorator($delegate) {
	  /**
	   * Adds a shim for $q.resolve for AngularJS version that don't have it,
	   * so we don't have to think about it.
	   *
	   * via https://github.com/angular/angular.js/pull/11987
	   */
	
	  // TODO(crisbeto): this won't be necessary once we drop AngularJS 1.3
	  if (!$delegate.resolve) {
	    $delegate.resolve = $delegate.when;
	  }
	  return $delegate;
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutofocusDirective.$inject = ["$parse"];angular.module('material.core')
	  .directive('mdAutofocus', MdAutofocusDirective)
	
	  // Support the deprecated md-auto-focus and md-sidenav-focus as well
	  .directive('mdAutoFocus', MdAutofocusDirective)
	  .directive('mdSidenavFocus', MdAutofocusDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdAutofocus
	 * @module material.core.util
	 *
	 * @description
	 *
	 * `[md-autofocus]` provides an optional way to identify the focused element when a `$mdDialog`,
	 * `$mdBottomSheet`, `$mdMenu` or `$mdSidenav` opens or upon page load for input-like elements.
	 *
	 * When one of these opens, it will find the first nested element with the `[md-autofocus]`
	 * attribute directive and optional expression. An expression may be specified as the directive
	 * value to enable conditional activation of the autofocus.
	 *
	 * @usage
	 *
	 * ### Dialog
	 * <hljs lang="html">
	 * <md-dialog>
	 *   <form>
	 *     <md-input-container>
	 *       <label for="testInput">Label</label>
	 *       <input id="testInput" type="text" md-autofocus>
	 *     </md-input-container>
	 *   </form>
	 * </md-dialog>
	 * </hljs>
	 *
	 * ### Bottomsheet
	 * <hljs lang="html">
	 * <md-bottom-sheet class="md-list md-has-header">
	 *  <md-subheader>Comment Actions</md-subheader>
	 *  <md-list>
	 *    <md-list-item ng-repeat="item in items">
	 *
	 *      <md-button md-autofocus="$index == 2">
	 *        <md-icon md-svg-src="{{item.icon}}"></md-icon>
	 *        <span class="md-inline-list-icon-label">{{ item.name }}</span>
	 *      </md-button>
	 *
	 *    </md-list-item>
	 *  </md-list>
	 * </md-bottom-sheet>
	 * </hljs>
	 *
	 * ### Autocomplete
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-autofocus
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 * ### Sidenav
	 * <hljs lang="html">
	 * <div layout="row" ng-controller="MyController">
	 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
	 *     Left Nav!
	 *   </md-sidenav>
	 *
	 *   <md-content>
	 *     Center Content
	 *     <md-button ng-click="openLeftMenu()">
	 *       Open Left Menu
	 *     </md-button>
	 *   </md-content>
	 *
	 *   <md-sidenav md-component-id="right"
	 *     md-is-locked-open="$mdMedia('min-width: 333px')"
	 *     class="md-sidenav-right">
	 *     <form>
	 *       <md-input-container>
	 *         <label for="testInput">Test input</label>
	 *         <input id="testInput" type="text"
	 *                ng-model="data" md-autofocus>
	 *       </md-input-container>
	 *     </form>
	 *   </md-sidenav>
	 * </div>
	 * </hljs>
	 **/
	function MdAutofocusDirective($parse) {
	  return {
	    restrict: 'A',
	    link: {
	      pre: preLink
	    }
	  };
	
	  function preLink(scope, element, attr) {
	    var attrExp = attr.mdAutoFocus || attr.mdAutofocus || attr.mdSidenavFocus;
	
	    // Initially update the expression by manually parsing the expression as per $watch source.
	    updateExpression($parse(attrExp)(scope));
	
	    // Only watch the expression if it is not empty.
	    if (attrExp) {
	      scope.$watch(attrExp, updateExpression);
	    }
	
	    /**
	     * Updates the autofocus class which is used to determine whether the attribute
	     * expression evaluates to true or false.
	     * @param {string|boolean} value Attribute Value
	     */
	    function updateExpression(value) {
	
	      // Rather than passing undefined to the jqLite toggle class function we explicitly set the
	      // value to true. Otherwise the class will be just toggled instead of being forced.
	      if (angular.isUndefined(value)) {
	        value = true;
	      }
	
	      element.toggleClass('md-autofocus', !!value);
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.colorUtil
	 * @description
	 * Color Util
	 */
	angular
	  .module('material.core')
	  .factory('$mdColorUtil', ColorUtilFactory);
	
	function ColorUtilFactory() {
	  /**
	   * Converts hex value to RGBA string
	   * @param color {string}
	   * @returns {string}
	   */
	  function hexToRgba (color) {
	    var hex   = color[ 0 ] === '#' ? color.substr(1) : color,
	      dig   = hex.length / 3,
	      red   = hex.substr(0, dig),
	      green = hex.substr(dig, dig),
	      blue  = hex.substr(dig * 2);
	    if (dig === 1) {
	      red += red;
	      green += green;
	      blue += blue;
	    }
	    return 'rgba(' + parseInt(red, 16) + ',' + parseInt(green, 16) + ',' + parseInt(blue, 16) + ',0.1)';
	  }
	
	  /**
	   * Converts rgba value to hex string
	   * @param color {string}
	   * @returns {string}
	   */
	  function rgbaToHex(color) {
	    color = color.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
	
	    var hex = (color && color.length === 4) ? "#" +
	    ("0" + parseInt(color[1],10).toString(16)).slice(-2) +
	    ("0" + parseInt(color[2],10).toString(16)).slice(-2) +
	    ("0" + parseInt(color[3],10).toString(16)).slice(-2) : '';
	
	    return hex.toUpperCase();
	  }
	
	  /**
	   * Converts an RGB color to RGBA
	   * @param color {string}
	   * @returns {string}
	   */
	  function rgbToRgba (color) {
	    return color.replace(')', ', 0.1)').replace('(', 'a(');
	  }
	
	  /**
	   * Converts an RGBA color to RGB
	   * @param color {string}
	   * @returns {string}
	   */
	  function rgbaToRgb (color) {
	    return color
	      ? color.replace('rgba', 'rgb').replace(/,[^),]+\)/, ')')
	      : 'rgb(0,0,0)';
	  }
	
	  return {
	    rgbaToHex: rgbaToHex,
	    hexToRgba: hexToRgba,
	    rgbToRgba: rgbToRgba,
	    rgbaToRgb: rgbaToRgb
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core')
	.factory('$mdConstant', MdConstantFactory);
	
	/**
	 * Factory function that creates the grab-bag $mdConstant service.
	 * @ngInject
	 */
	function MdConstantFactory() {
	
	  var prefixTestEl = document.createElement('div');
	  var vendorPrefix = getVendorPrefix(prefixTestEl);
	  var isWebkit = /webkit/i.test(vendorPrefix);
	  var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;
	
	  function vendorProperty(name) {
	    // Add a dash between the prefix and name, to be able to transform the string into camelcase.
	    var prefixedName = vendorPrefix + '-' + name;
	    var ucPrefix = camelCase(prefixedName);
	    var lcPrefix = ucPrefix.charAt(0).toLowerCase() + ucPrefix.substring(1);
	
	    return hasStyleProperty(prefixTestEl, name)     ? name     :       // The current browser supports the un-prefixed property
	           hasStyleProperty(prefixTestEl, ucPrefix) ? ucPrefix :       // The current browser only supports the prefixed property.
	           hasStyleProperty(prefixTestEl, lcPrefix) ? lcPrefix : name; // Some browsers are only supporting the prefix in lowercase.
	  }
	
	  function hasStyleProperty(testElement, property) {
	    return angular.isDefined(testElement.style[property]);
	  }
	
	  function camelCase(input) {
	    return input.replace(SPECIAL_CHARS_REGEXP, function(matches, separator, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    });
	  }
	
	  function getVendorPrefix(testElement) {
	    var prop, match;
	    var vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/;
	
	    for (prop in testElement.style) {
	      if (match = vendorRegex.exec(prop)) {
	        return match[0];
	      }
	    }
	  }
	
	  var self = {
	    isInputKey : function(e) { return (e.keyCode >= 31 && e.keyCode <= 90); },
	    isNumPadKey : function(e) { return (3 === e.location && e.keyCode >= 97 && e.keyCode <= 105); },
	    isMetaKey: function(e) { return (e.keyCode >= 91 && e.keyCode <= 93); },
	    isFnLockKey: function(e) { return (e.keyCode >= 112 && e.keyCode <= 145); },
	    isNavigationKey : function(e) {
	      var kc = self.KEY_CODE, NAVIGATION_KEYS =  [kc.SPACE, kc.ENTER, kc.UP_ARROW, kc.DOWN_ARROW];
	      return (NAVIGATION_KEYS.indexOf(e.keyCode) != -1);
	    },
	    hasModifierKey: function(e) {
	      return e.ctrlKey || e.metaKey || e.altKey;
	    },
	
	    /**
	     * Maximum size, in pixels, that can be explicitly set to an element. The actual value varies
	     * between browsers, but IE11 has the very lowest size at a mere 1,533,917px. Ideally we could
	     * compute this value, but Firefox always reports an element to have a size of zero if it
	     * goes over the max, meaning that we'd have to binary search for the value.
	     */
	    ELEMENT_MAX_PIXELS: 1533917,
	
	    /**
	     * Priority for a directive that should run before the directives from ngAria.
	     */
	    BEFORE_NG_ARIA: 210,
	
	    /**
	     * Common Keyboard actions and their associated keycode.
	     */
	    KEY_CODE: {
	      COMMA: 188,
	      SEMICOLON : 186,
	      ENTER: 13,
	      ESCAPE: 27,
	      SPACE: 32,
	      PAGE_UP: 33,
	      PAGE_DOWN: 34,
	      END: 35,
	      HOME: 36,
	      LEFT_ARROW : 37,
	      UP_ARROW : 38,
	      RIGHT_ARROW : 39,
	      DOWN_ARROW : 40,
	      TAB : 9,
	      BACKSPACE: 8,
	      DELETE: 46
	    },
	
	    /**
	     * Vendor prefixed CSS properties to be used to support the given functionality in older browsers
	     * as well.
	     */
	    CSS: {
	      /* Constants */
	      TRANSITIONEND: 'transitionend' + (isWebkit ? ' webkitTransitionEnd' : ''),
	      ANIMATIONEND: 'animationend' + (isWebkit ? ' webkitAnimationEnd' : ''),
	
	      TRANSFORM: vendorProperty('transform'),
	      TRANSFORM_ORIGIN: vendorProperty('transformOrigin'),
	      TRANSITION: vendorProperty('transition'),
	      TRANSITION_DURATION: vendorProperty('transitionDuration'),
	      ANIMATION_PLAY_STATE: vendorProperty('animationPlayState'),
	      ANIMATION_DURATION: vendorProperty('animationDuration'),
	      ANIMATION_NAME: vendorProperty('animationName'),
	      ANIMATION_TIMING: vendorProperty('animationTimingFunction'),
	      ANIMATION_DIRECTION: vendorProperty('animationDirection')
	    },
	
	    /**
	     * As defined in core/style/variables.scss
	     *
	     * $layout-breakpoint-xs:     600px !default;
	     * $layout-breakpoint-sm:     960px !default;
	     * $layout-breakpoint-md:     1280px !default;
	     * $layout-breakpoint-lg:     1920px !default;
	     *
	     */
	    MEDIA: {
	      'xs'        : '(max-width: 599px)'                         ,
	      'gt-xs'     : '(min-width: 600px)'                         ,
	      'sm'        : '(min-width: 600px) and (max-width: 959px)'  ,
	      'gt-sm'     : '(min-width: 960px)'                         ,
	      'md'        : '(min-width: 960px) and (max-width: 1279px)' ,
	      'gt-md'     : '(min-width: 1280px)'                        ,
	      'lg'        : '(min-width: 1280px) and (max-width: 1919px)',
	      'gt-lg'     : '(min-width: 1920px)'                        ,
	      'xl'        : '(min-width: 1920px)'                        ,
	      'landscape' : '(orientation: landscape)'                   ,
	      'portrait'  : '(orientation: portrait)'                    ,
	      'print' : 'print'
	    },
	
	    MEDIA_PRIORITY: [
	      'xl',
	      'gt-lg',
	      'lg',
	      'gt-md',
	      'md',
	      'gt-sm',
	      'sm',
	      'gt-xs',
	      'xs',
	      'landscape',
	      'portrait',
	      'print'
	    ]
	  };
	
	  return self;
	}
	
	})();
	(function(){
	"use strict";
	
	  angular
	    .module('material.core')
	    .config( ["$provide", function($provide){
	       $provide.decorator('$mdUtil', ['$delegate', function ($delegate){
	           /**
	            * Inject the iterator facade to easily support iteration and accessors
	            * @see iterator below
	            */
	           $delegate.iterator = MdIterator;
	
	           return $delegate;
	         }
	       ]);
	     }]);
	
	  /**
	   * iterator is a list facade to easily support iteration and accessors
	   *
	   * @param items Array list which this iterator will enumerate
	   * @param reloop Boolean enables iterator to consider the list as an endless reloop
	   */
	  function MdIterator(items, reloop) {
	    var trueFn = function() { return true; };
	
	    if (items && !angular.isArray(items)) {
	      items = Array.prototype.slice.call(items);
	    }
	
	    reloop = !!reloop;
	    var _items = items || [ ];
	
	    // Published API
	    return {
	      items: getItems,
	      count: count,
	
	      inRange: inRange,
	      contains: contains,
	      indexOf: indexOf,
	      itemAt: itemAt,
	
	      findBy: findBy,
	
	      add: add,
	      remove: remove,
	
	      first: first,
	      last: last,
	      next: angular.bind(null, findSubsequentItem, false),
	      previous: angular.bind(null, findSubsequentItem, true),
	
	      hasPrevious: hasPrevious,
	      hasNext: hasNext
	
	    };
	
	    /**
	     * Publish copy of the enumerable set
	     * @returns {Array|*}
	     */
	    function getItems() {
	      return [].concat(_items);
	    }
	
	    /**
	     * Determine length of the list
	     * @returns {Array.length|*|number}
	     */
	    function count() {
	      return _items.length;
	    }
	
	    /**
	     * Is the index specified valid
	     * @param index
	     * @returns {Array.length|*|number|boolean}
	     */
	    function inRange(index) {
	      return _items.length && ( index > -1 ) && (index < _items.length );
	    }
	
	    /**
	     * Can the iterator proceed to the next item in the list; relative to
	     * the specified item.
	     *
	     * @param item
	     * @returns {Array.length|*|number|boolean}
	     */
	    function hasNext(item) {
	      return item ? inRange(indexOf(item) + 1) : false;
	    }
	
	    /**
	     * Can the iterator proceed to the previous item in the list; relative to
	     * the specified item.
	     *
	     * @param item
	     * @returns {Array.length|*|number|boolean}
	     */
	    function hasPrevious(item) {
	      return item ? inRange(indexOf(item) - 1) : false;
	    }
	
	    /**
	     * Get item at specified index/position
	     * @param index
	     * @returns {*}
	     */
	    function itemAt(index) {
	      return inRange(index) ? _items[index] : null;
	    }
	
	    /**
	     * Find all elements matching the key/value pair
	     * otherwise return null
	     *
	     * @param val
	     * @param key
	     *
	     * @return array
	     */
	    function findBy(key, val) {
	      return _items.filter(function(item) {
	        return item[key] === val;
	      });
	    }
	
	    /**
	     * Add item to list
	     * @param item
	     * @param index
	     * @returns {*}
	     */
	    function add(item, index) {
	      if ( !item ) return -1;
	
	      if (!angular.isNumber(index)) {
	        index = _items.length;
	      }
	
	      _items.splice(index, 0, item);
	
	      return indexOf(item);
	    }
	
	    /**
	     * Remove item from list...
	     * @param item
	     */
	    function remove(item) {
	      if ( contains(item) ){
	        _items.splice(indexOf(item), 1);
	      }
	    }
	
	    /**
	     * Get the zero-based index of the target item
	     * @param item
	     * @returns {*}
	     */
	    function indexOf(item) {
	      return _items.indexOf(item);
	    }
	
	    /**
	     * Boolean existence check
	     * @param item
	     * @returns {boolean}
	     */
	    function contains(item) {
	      return item && (indexOf(item) > -1);
	    }
	
	    /**
	     * Return first item in the list
	     * @returns {*}
	     */
	    function first() {
	      return _items.length ? _items[0] : null;
	    }
	
	    /**
	     * Return last item in the list...
	     * @returns {*}
	     */
	    function last() {
	      return _items.length ? _items[_items.length - 1] : null;
	    }
	
	    /**
	     * Find the next item. If reloop is true and at the end of the list, it will go back to the
	     * first item. If given, the `validate` callback will be used to determine whether the next item
	     * is valid. If not valid, it will try to find the next item again.
	     *
	     * @param {boolean} backwards Specifies the direction of searching (forwards/backwards)
	     * @param {*} item The item whose subsequent item we are looking for
	     * @param {Function=} validate The `validate` function
	     * @param {integer=} limit The recursion limit
	     *
	     * @returns {*} The subsequent item or null
	     */
	    function findSubsequentItem(backwards, item, validate, limit) {
	      validate = validate || trueFn;
	
	      var curIndex = indexOf(item);
	      while (true) {
	        if (!inRange(curIndex)) return null;
	
	        var nextIndex = curIndex + (backwards ? -1 : 1);
	        var foundItem = null;
	        if (inRange(nextIndex)) {
	          foundItem = _items[nextIndex];
	        } else if (reloop) {
	          foundItem = backwards ? last() : first();
	          nextIndex = indexOf(foundItem);
	        }
	
	        if ((foundItem === null) || (nextIndex === limit)) return null;
	        if (validate(foundItem)) return foundItem;
	
	        if (angular.isUndefined(limit)) limit = nextIndex;
	
	        curIndex = nextIndex;
	      }
	    }
	  }
	
	
	})();
	(function(){
	"use strict";
	
	
	mdMediaFactory.$inject = ["$mdConstant", "$rootScope", "$window"];angular.module('material.core')
	.factory('$mdMedia', mdMediaFactory);
	
	/**
	 * @ngdoc service
	 * @name $mdMedia
	 * @module material.core
	 *
	 * @description
	 * `$mdMedia` is used to evaluate whether a given media query is true or false given the
	 * current device's screen / window size. The media query will be re-evaluated on resize, allowing
	 * you to register a watch.
	 *
	 * `$mdMedia` also has pre-programmed support for media queries that match the layout breakpoints:
	 *
	 *  <table class="md-api-table">
	 *    <thead>
	 *    <tr>
	 *      <th>Breakpoint</th>
	 *      <th>mediaQuery</th>
	 *    </tr>
	 *    </thead>
	 *    <tbody>
	 *    <tr>
	 *      <td>xs</td>
	 *      <td>(max-width: 599px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-xs</td>
	 *      <td>(min-width: 600px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>sm</td>
	 *      <td>(min-width: 600px) and (max-width: 959px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-sm</td>
	 *      <td>(min-width: 960px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>md</td>
	 *      <td>(min-width: 960px) and (max-width: 1279px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-md</td>
	 *      <td>(min-width: 1280px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>lg</td>
	 *      <td>(min-width: 1280px) and (max-width: 1919px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-lg</td>
	 *      <td>(min-width: 1920px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>xl</td>
	 *      <td>(min-width: 1920px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>landscape</td>
	 *      <td>landscape</td>
	 *    </tr>
	 *    <tr>
	 *      <td>portrait</td>
	 *      <td>portrait</td>
	 *    </tr>
	 *    <tr>
	 *      <td>print</td>
	 *      <td>print</td>
	 *    </tr>
	 *    </tbody>
	 *  </table>
	 *
	 *  See Material Design's <a href="https://material.google.com/layout/responsive-ui.html">Layout - Adaptive UI</a> for more details.
	 *
	 *  <a href="https://www.google.com/design/spec/layout/adaptive-ui.html">
	 *  <img src="https://material-design.storage.googleapis.com/publish/material_v_4/material_ext_publish/0B8olV15J7abPSGFxemFiQVRtb1k/layout_adaptive_breakpoints_01.png" width="100%" height="100%"></img>
	 *  </a>
	 *
	 * @returns {boolean} a boolean representing whether or not the given media query is true or false.
	 *
	 * @usage
	 * <hljs lang="js">
	 * app.controller('MyController', function($mdMedia, $scope) {
	 *   $scope.$watch(function() { return $mdMedia('lg'); }, function(big) {
	 *     $scope.bigScreen = big;
	 *   });
	 *
	 *   $scope.screenIsSmall = $mdMedia('sm');
	 *   $scope.customQuery = $mdMedia('(min-width: 1234px)');
	 *   $scope.anotherCustom = $mdMedia('max-width: 300px');
	 * });
	 * </hljs>
	 */
	
	/* @ngInject */
	function mdMediaFactory($mdConstant, $rootScope, $window) {
	  var queries = {};
	  var mqls = {};
	  var results = {};
	  var normalizeCache = {};
	
	  $mdMedia.getResponsiveAttribute = getResponsiveAttribute;
	  $mdMedia.getQuery = getQuery;
	  $mdMedia.watchResponsiveAttributes = watchResponsiveAttributes;
	
	  return $mdMedia;
	
	  function $mdMedia(query) {
	    var validated = queries[query];
	    if (angular.isUndefined(validated)) {
	      validated = queries[query] = validate(query);
	    }
	
	    var result = results[validated];
	    if (angular.isUndefined(result)) {
	      result = add(validated);
	    }
	
	    return result;
	  }
	
	  function validate(query) {
	    return $mdConstant.MEDIA[query] ||
	           ((query.charAt(0) !== '(') ? ('(' + query + ')') : query);
	  }
	
	  function add(query) {
	    var result = mqls[query];
	    if ( !result ) {
	      result = mqls[query] = $window.matchMedia(query);
	    }
	
	    result.addListener(onQueryChange);
	    return (results[result.media] = !!result.matches);
	  }
	
	  function onQueryChange(query) {
	    $rootScope.$evalAsync(function() {
	      results[query.media] = !!query.matches;
	    });
	  }
	
	  function getQuery(name) {
	    return mqls[name];
	  }
	
	  function getResponsiveAttribute(attrs, attrName) {
	    for (var i = 0; i < $mdConstant.MEDIA_PRIORITY.length; i++) {
	      var mediaName = $mdConstant.MEDIA_PRIORITY[i];
	      if (!mqls[queries[mediaName]].matches) {
	        continue;
	      }
	
	      var normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
	      if (attrs[normalizedName]) {
	        return attrs[normalizedName];
	      }
	    }
	
	    // fallback on unprefixed
	    return attrs[getNormalizedName(attrs, attrName)];
	  }
	
	  function watchResponsiveAttributes(attrNames, attrs, watchFn) {
	    var unwatchFns = [];
	    attrNames.forEach(function(attrName) {
	      var normalizedName = getNormalizedName(attrs, attrName);
	      if (angular.isDefined(attrs[normalizedName])) {
	        unwatchFns.push(
	            attrs.$observe(normalizedName, angular.bind(void 0, watchFn, null)));
	      }
	
	      for (var mediaName in $mdConstant.MEDIA) {
	        normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
	        if (angular.isDefined(attrs[normalizedName])) {
	          unwatchFns.push(
	              attrs.$observe(normalizedName, angular.bind(void 0, watchFn, mediaName)));
	        }
	      }
	    });
	
	    return function unwatch() {
	      unwatchFns.forEach(function(fn) { fn(); });
	    };
	  }
	
	  // Improves performance dramatically
	  function getNormalizedName(attrs, attrName) {
	    return normalizeCache[attrName] ||
	        (normalizeCache[attrName] = attrs.$normalize(attrName));
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	  .module('material.core')
	  .config( ["$provide", function($provide) {
	    $provide.decorator('$mdUtil', ['$delegate', function ($delegate) {
	
	      // Inject the prefixer into our original $mdUtil service.
	      $delegate.prefixer = MdPrefixer;
	
	      return $delegate;
	    }]);
	  }]);
	
	function MdPrefixer(initialAttributes, buildSelector) {
	  var PREFIXES = ['data', 'x'];
	
	  if (initialAttributes) {
	    // The prefixer also accepts attributes as a parameter, and immediately builds a list or selector for
	    // the specified attributes.
	    return buildSelector ? _buildSelector(initialAttributes) : _buildList(initialAttributes);
	  }
	
	  return {
	    buildList: _buildList,
	    buildSelector: _buildSelector,
	    hasAttribute: _hasAttribute,
	    removeAttribute: _removeAttribute
	  };
	
	  function _buildList(attributes) {
	    attributes = angular.isArray(attributes) ? attributes : [attributes];
	
	    attributes.forEach(function(item) {
	      PREFIXES.forEach(function(prefix) {
	        attributes.push(prefix + '-' + item);
	      });
	    });
	
	    return attributes;
	  }
	
	  function _buildSelector(attributes) {
	    attributes = angular.isArray(attributes) ? attributes : [attributes];
	
	    return _buildList(attributes)
	      .map(function(item) {
	        return '[' + item + ']';
	      })
	      .join(',');
	  }
	
	  function _hasAttribute(element, attribute) {
	    element = _getNativeElement(element);
	
	    if (!element) {
	      return false;
	    }
	
	    var prefixedAttrs = _buildList(attribute);
	
	    for (var i = 0; i < prefixedAttrs.length; i++) {
	      if (element.hasAttribute(prefixedAttrs[i])) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  function _removeAttribute(element, attribute) {
	    element = _getNativeElement(element);
	
	    if (!element) {
	      return;
	    }
	
	    _buildList(attribute).forEach(function(prefixedAttribute) {
	      element.removeAttribute(prefixedAttribute);
	    });
	  }
	
	  /**
	   * Transforms a jqLite or DOM element into a HTML element.
	   * This is useful when supporting jqLite elements and DOM elements at
	   * same time.
	   * @param element {JQLite|Element} Element to be parsed
	   * @returns {HTMLElement} Parsed HTMLElement
	   */
	  function _getNativeElement(element) {
	    element =  element[0] || element;
	
	    if (element.nodeType) {
	      return element;
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/*
	 * This var has to be outside the angular factory, otherwise when
	 * there are multiple material apps on the same page, each app
	 * will create its own instance of this array and the app's IDs
	 * will not be unique.
	 */
	UtilFactory.$inject = ["$document", "$timeout", "$compile", "$rootScope", "$$mdAnimate", "$interpolate", "$log", "$rootElement", "$window", "$$rAF"];
	var nextUniqueId = 0;
	
	/**
	 * @ngdoc module
	 * @name material.core.util
	 * @description
	 * Util
	 */
	angular
	  .module('material.core')
	  .factory('$mdUtil', UtilFactory);
	
	/**
	 * @ngInject
	 */
	function UtilFactory($document, $timeout, $compile, $rootScope, $$mdAnimate, $interpolate, $log, $rootElement, $window, $$rAF) {
	  // Setup some core variables for the processTemplate method
	  var startSymbol = $interpolate.startSymbol(),
	    endSymbol = $interpolate.endSymbol(),
	    usesStandardSymbols = ((startSymbol === '{{') && (endSymbol === '}}'));
	
	  /**
	   * Checks if the target element has the requested style by key
	   * @param {DOMElement|JQLite} target Target element
	   * @param {string} key Style key
	   * @param {string=} expectedVal Optional expected value
	   * @returns {boolean} Whether the target element has the style or not
	   */
	  var hasComputedStyle = function (target, key, expectedVal) {
	    var hasValue = false;
	
	    if ( target && target.length  ) {
	      var computedStyles = $window.getComputedStyle(target[0]);
	      hasValue = angular.isDefined(computedStyles[key]) && (expectedVal ? computedStyles[key] == expectedVal : true);
	    }
	
	    return hasValue;
	  };
	
	  function validateCssValue(value) {
	    return !value       ? '0'   :
	      hasPx(value) || hasPercent(value) ? value : value + 'px';
	  }
	
	  function hasPx(value) {
	    return String(value).indexOf('px') > -1;
	  }
	
	  function hasPercent(value) {
	    return String(value).indexOf('%') > -1;
	
	  }
	
	  var $mdUtil = {
	    dom: {},
	    now: window.performance && window.performance.now ?
	      angular.bind(window.performance, window.performance.now) : Date.now || function() {
	      return new Date().getTime();
	    },
	
	    /**
	     * Cross-version compatibility method to retrieve an option of a ngModel controller,
	     * which supports the breaking changes in the AngularJS snapshot (SHA 87a2ff76af5d0a9268d8eb84db5755077d27c84c).
	     * @param {!angular.ngModelCtrl} ngModelCtrl
	     * @param {!string} optionName
	     * @returns {Object|undefined}
	     */
	    getModelOption: function (ngModelCtrl, optionName) {
	      if (!ngModelCtrl.$options) {
	        return;
	      }
	
	      var $options = ngModelCtrl.$options;
	
	      // The newer versions of AngularJS introduced a `getOption function and made the option values no longer
	      // visible on the $options object.
	      return $options.getOption ? $options.getOption(optionName) : $options[optionName];
	    },
	
	    /**
	     * Bi-directional accessor/mutator used to easily update an element's
	     * property based on the current 'dir'ectional value.
	     */
	    bidi : function(element, property, lValue, rValue) {
	      var ltr = !($document[0].dir == 'rtl' || $document[0].body.dir == 'rtl');
	
	      // If accessor
	      if ( arguments.length == 0 ) return ltr ? 'ltr' : 'rtl';
	
	      // If mutator
	      var elem = angular.element(element);
	
	      if ( ltr && angular.isDefined(lValue)) {
	        elem.css(property, validateCssValue(lValue));
	      }
	      else if ( !ltr && angular.isDefined(rValue)) {
	        elem.css(property, validateCssValue(rValue) );
	      }
	    },
	
	    bidiProperty: function (element, lProperty, rProperty, value) {
	      var ltr = !($document[0].dir == 'rtl' || $document[0].body.dir == 'rtl');
	
	      var elem = angular.element(element);
	
	      if ( ltr && angular.isDefined(lProperty)) {
	        elem.css(lProperty, validateCssValue(value));
	        elem.css(rProperty, '');
	      }
	      else if ( !ltr && angular.isDefined(rProperty)) {
	        elem.css(rProperty, validateCssValue(value) );
	        elem.css(lProperty, '');
	      }
	    },
	
	    clientRect: function(element, offsetParent, isOffsetRect) {
	      var node = getNode(element);
	      offsetParent = getNode(offsetParent || node.offsetParent || document.body);
	      var nodeRect = node.getBoundingClientRect();
	
	      // The user can ask for an offsetRect: a rect relative to the offsetParent,
	      // or a clientRect: a rect relative to the page
	      var offsetRect = isOffsetRect ?
	        offsetParent.getBoundingClientRect() :
	      {left: 0, top: 0, width: 0, height: 0};
	      return {
	        left: nodeRect.left - offsetRect.left,
	        top: nodeRect.top - offsetRect.top,
	        width: nodeRect.width,
	        height: nodeRect.height
	      };
	    },
	    offsetRect: function(element, offsetParent) {
	      return $mdUtil.clientRect(element, offsetParent, true);
	    },
	
	    // Annoying method to copy nodes to an array, thanks to IE
	    nodesToArray: function(nodes) {
	      nodes = nodes || [];
	
	      var results = [];
	      for (var i = 0; i < nodes.length; ++i) {
	        results.push(nodes.item(i));
	      }
	      return results;
	    },
	
	    /**
	     * Determines the absolute position of the viewport.
	     * Useful when making client rectangles absolute.
	     * @returns {number}
	     */
	    getViewportTop: function() {
	      return window.scrollY || window.pageYOffset || 0;
	    },
	
	    /**
	     * Finds the proper focus target by searching the DOM.
	     *
	     * @param containerEl
	     * @param attributeVal
	     * @returns {*}
	     */
	    findFocusTarget: function(containerEl, attributeVal) {
	      var AUTO_FOCUS = this.prefixer('md-autofocus', true);
	      var elToFocus;
	
	      elToFocus = scanForFocusable(containerEl, attributeVal || AUTO_FOCUS);
	
	      if ( !elToFocus && attributeVal != AUTO_FOCUS) {
	        // Scan for deprecated attribute
	        elToFocus = scanForFocusable(containerEl, this.prefixer('md-auto-focus', true));
	
	        if ( !elToFocus ) {
	          // Scan for fallback to 'universal' API
	          elToFocus = scanForFocusable(containerEl, AUTO_FOCUS);
	        }
	      }
	
	      return elToFocus;
	
	      /**
	       * Can target and nested children for specified Selector (attribute)
	       * whose value may be an expression that evaluates to True/False.
	       */
	      function scanForFocusable(target, selector) {
	        var elFound, items = target[0].querySelectorAll(selector);
	
	        // Find the last child element with the focus attribute
	        if ( items && items.length ){
	          items.length && angular.forEach(items, function(it) {
	            it = angular.element(it);
	
	            // Check the element for the md-autofocus class to ensure any associated expression
	            // evaluated to true.
	            var isFocusable = it.hasClass('md-autofocus');
	            if (isFocusable) elFound = it;
	          });
	        }
	        return elFound;
	      }
	    },
	
	    /**
	     * Disables scroll around the passed parent element.
	     * @param element Unused
	     * @param {!Element|!angular.JQLite} parent Element to disable scrolling within.
	     *   Defaults to body if none supplied.
	     * @param options Object of options to modify functionality
	     *   - disableScrollMask Boolean of whether or not to create a scroll mask element or
	     *     use the passed parent element.
	     */
	    disableScrollAround: function(element, parent, options) {
	      options = options || {};
	
	      $mdUtil.disableScrollAround._count = Math.max(0, $mdUtil.disableScrollAround._count || 0);
	      $mdUtil.disableScrollAround._count++;
	
	      if ($mdUtil.disableScrollAround._restoreScroll) {
	        return $mdUtil.disableScrollAround._restoreScroll;
	      }
	
	      var body = $document[0].body;
	      var restoreBody = disableBodyScroll();
	      var restoreElement = disableElementScroll(parent);
	
	      return $mdUtil.disableScrollAround._restoreScroll = function() {
	        if (--$mdUtil.disableScrollAround._count <= 0) {
	          restoreBody();
	          restoreElement();
	          delete $mdUtil.disableScrollAround._restoreScroll;
	        }
	      };
	
	      /**
	       * Creates a virtual scrolling mask to prevent touchmove, keyboard, scrollbar clicking,
	       * and wheel events
	       */
	      function disableElementScroll(element) {
	        element = angular.element(element || body);
	
	        var scrollMask;
	
	        if (options.disableScrollMask) {
	          scrollMask = element;
	        } else {
	          scrollMask = angular.element(
	            '<div class="md-scroll-mask">' +
	            '  <div class="md-scroll-mask-bar"></div>' +
	            '</div>');
	          element.append(scrollMask);
	        }
	
	        scrollMask.on('wheel', preventDefault);
	        scrollMask.on('touchmove', preventDefault);
	
	        return function restoreElementScroll() {
	          scrollMask.off('wheel');
	          scrollMask.off('touchmove');
	
	          if (!options.disableScrollMask && scrollMask[0].parentNode ) {
	            scrollMask[0].parentNode.removeChild(scrollMask[0]);
	          }
	        };
	
	        function preventDefault(e) {
	          e.preventDefault();
	        }
	      }
	
	      // Converts the body to a position fixed block and translate it to the proper scroll position
	      function disableBodyScroll() {
	        var documentElement = $document[0].documentElement;
	
	        var prevDocumentStyle = documentElement.style.cssText || '';
	        var prevBodyStyle = body.style.cssText || '';
	
	        var viewportTop = $mdUtil.getViewportTop();
	        var clientWidth = body.clientWidth;
	        var hasVerticalScrollbar = body.scrollHeight > body.clientHeight + 1;
	
	        // Scroll may be set on <html> element (for example by overflow-y: scroll)
	        // but Chrome is reporting the scrollTop position always on <body>.
	        // scrollElement will allow to restore the scrollTop position to proper target.
	        var scrollElement = documentElement.scrollTop > 0 ? documentElement : body;
	
	        if (hasVerticalScrollbar) {
	          angular.element(body).css({
	            position: 'fixed',
	            width: '100%',
	            top: -viewportTop + 'px'
	          });
	        }
	
	        if (body.clientWidth < clientWidth) {
	          body.style.overflow = 'hidden';
	        }
	
	        // This should be applied after the manipulation to the body, because
	        // adding a scrollbar can potentially resize it, causing the measurement
	        // to change.
	        if (hasVerticalScrollbar) {
	          documentElement.style.overflowY = 'scroll';
	        }
	
	        return function restoreScroll() {
	          // Reset the inline style CSS to the previous.
	          body.style.cssText = prevBodyStyle;
	          documentElement.style.cssText = prevDocumentStyle;
	
	          // The scroll position while being fixed
	          scrollElement.scrollTop = viewportTop;
	        };
	      }
	
	    },
	
	    enableScrolling: function() {
	      var restoreFn = this.disableScrollAround._restoreScroll;
	      restoreFn && restoreFn();
	    },
	
	    floatingScrollbars: function() {
	      if (this.floatingScrollbars.cached === undefined) {
	        var tempNode = angular.element('<div><div></div></div>').css({
	          width: '100%',
	          'z-index': -1,
	          position: 'absolute',
	          height: '35px',
	          'overflow-y': 'scroll'
	        });
	        tempNode.children().css('height', '60px');
	
	        $document[0].body.appendChild(tempNode[0]);
	        this.floatingScrollbars.cached = (tempNode[0].offsetWidth == tempNode[0].childNodes[0].offsetWidth);
	        tempNode.remove();
	      }
	      return this.floatingScrollbars.cached;
	    },
	
	    // Mobile safari only allows you to set focus in click event listeners...
	    forceFocus: function(element) {
	      var node = element[0] || element;
	
	      document.addEventListener('click', function focusOnClick(ev) {
	        if (ev.target === node && ev.$focus) {
	          node.focus();
	          ev.stopImmediatePropagation();
	          ev.preventDefault();
	          node.removeEventListener('click', focusOnClick);
	        }
	      }, true);
	
	      var newEvent = document.createEvent('MouseEvents');
	      newEvent.initMouseEvent('click', false, true, window, {}, 0, 0, 0, 0,
	        false, false, false, false, 0, null);
	      newEvent.$material = true;
	      newEvent.$focus = true;
	      node.dispatchEvent(newEvent);
	    },
	
	    /**
	     * facade to build md-backdrop element with desired styles
	     * NOTE: Use $compile to trigger backdrop postLink function
	     */
	    createBackdrop: function(scope, addClass) {
	      return $compile($mdUtil.supplant('<md-backdrop class="{0}">', [addClass]))(scope);
	    },
	
	    /**
	     * supplant() method from Crockford's `Remedial Javascript`
	     * Equivalent to use of $interpolate; without dependency on
	     * interpolation symbols and scope. Note: the '{<token>}' can
	     * be property names, property chains, or array indices.
	     */
	    supplant: function(template, values, pattern) {
	      pattern = pattern || /\{([^{}]*)\}/g;
	      return template.replace(pattern, function(a, b) {
	        var p = b.split('.'),
	          r = values;
	        try {
	          for (var s in p) {
	            if (p.hasOwnProperty(s) ) {
	              r = r[p[s]];
	            }
	          }
	        } catch (e) {
	          r = a;
	        }
	        return (typeof r === 'string' || typeof r === 'number') ? r : a;
	      });
	    },
	
	    fakeNgModel: function() {
	      return {
	        $fake: true,
	        $setTouched: angular.noop,
	        $setViewValue: function(value) {
	          this.$viewValue = value;
	          this.$render(value);
	          this.$viewChangeListeners.forEach(function(cb) {
	            cb();
	          });
	        },
	        $isEmpty: function(value) {
	          return ('' + value).length === 0;
	        },
	        $parsers: [],
	        $formatters: [],
	        $viewChangeListeners: [],
	        $render: angular.noop
	      };
	    },
	
	    // Returns a function, that, as long as it continues to be invoked, will not
	    // be triggered. The function will be called after it stops being called for
	    // N milliseconds.
	    // @param wait Integer value of msecs to delay (since last debounce reset); default value 10 msecs
	    // @param invokeApply should the $timeout trigger $digest() dirty checking
	    debounce: function(func, wait, scope, invokeApply) {
	      var timer;
	
	      return function debounced() {
	        var context = scope,
	          args = Array.prototype.slice.call(arguments);
	
	        $timeout.cancel(timer);
	        timer = $timeout(function() {
	
	          timer = undefined;
	          func.apply(context, args);
	
	        }, wait || 10, invokeApply);
	      };
	    },
	
	    // Returns a function that can only be triggered every `delay` milliseconds.
	    // In other words, the function will not be called unless it has been more
	    // than `delay` milliseconds since the last call.
	    throttle: function throttle(func, delay) {
	      var recent;
	      return function throttled() {
	        var context = this;
	        var args = arguments;
	        var now = $mdUtil.now();
	
	        if (!recent || (now - recent > delay)) {
	          func.apply(context, args);
	          recent = now;
	        }
	      };
	    },
	
	    /**
	     * Measures the number of milliseconds taken to run the provided callback
	     * function. Uses a high-precision timer if available.
	     */
	    time: function time(cb) {
	      var start = $mdUtil.now();
	      cb();
	      return $mdUtil.now() - start;
	    },
	
	    /**
	     * Create an implicit getter that caches its `getter()`
	     * lookup value
	     */
	    valueOnUse : function (scope, key, getter) {
	      var value = null, args = Array.prototype.slice.call(arguments);
	      var params = (args.length > 3) ? args.slice(3) : [ ];
	
	      Object.defineProperty(scope, key, {
	        get: function () {
	          if (value === null) value = getter.apply(scope, params);
	          return value;
	        }
	      });
	    },
	
	    /**
	     * Get a unique ID.
	     *
	     * @returns {string} an unique numeric string
	     */
	    nextUid: function() {
	      return '' + nextUniqueId++;
	    },
	
	    // Stop watchers and events from firing on a scope without destroying it,
	    // by disconnecting it from its parent and its siblings' linked lists.
	    disconnectScope: function disconnectScope(scope) {
	      if (!scope) return;
	
	      // we can't destroy the root scope or a scope that has been already destroyed
	      if (scope.$root === scope) return;
	      if (scope.$$destroyed) return;
	
	      var parent = scope.$parent;
	      scope.$$disconnected = true;
	
	      // See Scope.$destroy
	      if (parent.$$childHead === scope) parent.$$childHead = scope.$$nextSibling;
	      if (parent.$$childTail === scope) parent.$$childTail = scope.$$prevSibling;
	      if (scope.$$prevSibling) scope.$$prevSibling.$$nextSibling = scope.$$nextSibling;
	      if (scope.$$nextSibling) scope.$$nextSibling.$$prevSibling = scope.$$prevSibling;
	
	      scope.$$nextSibling = scope.$$prevSibling = null;
	
	    },
	
	    // Undo the effects of disconnectScope above.
	    reconnectScope: function reconnectScope(scope) {
	      if (!scope) return;
	
	      // we can't disconnect the root node or scope already disconnected
	      if (scope.$root === scope) return;
	      if (!scope.$$disconnected) return;
	
	      var child = scope;
	
	      var parent = child.$parent;
	      child.$$disconnected = false;
	      // See Scope.$new for this logic...
	      child.$$prevSibling = parent.$$childTail;
	      if (parent.$$childHead) {
	        parent.$$childTail.$$nextSibling = child;
	        parent.$$childTail = child;
	      } else {
	        parent.$$childHead = parent.$$childTail = child;
	      }
	    },
	
	    /*
	     * getClosest replicates jQuery.closest() to walk up the DOM tree until it finds a matching nodeName
	     *
	     * @param el Element to start walking the DOM from
	     * @param check Either a string or a function. If a string is passed, it will be evaluated against
	     * each of the parent nodes' tag name. If a function is passed, the loop will call it with each of
	     * the parents and will use the return value to determine whether the node is a match.
	     * @param onlyParent Only start checking from the parent element, not `el`.
	     */
	    getClosest: function getClosest(el, validateWith, onlyParent) {
	      if ( angular.isString(validateWith) ) {
	        var tagName = validateWith.toUpperCase();
	        validateWith = function(el) {
	          return el.nodeName.toUpperCase() === tagName;
	        };
	      }
	
	      if (el instanceof angular.element) el = el[0];
	      if (onlyParent) el = el.parentNode;
	      if (!el) return null;
	
	      do {
	        if (validateWith(el)) {
	          return el;
	        }
	      } while (el = el.parentNode);
	
	      return null;
	    },
	
	    /**
	     * Build polyfill for the Node.contains feature (if needed)
	     */
	    elementContains: function(node, child) {
	      var hasContains = (window.Node && window.Node.prototype && Node.prototype.contains);
	      var findFn = hasContains ? angular.bind(node, node.contains) : angular.bind(node, function(arg) {
	        // compares the positions of two nodes and returns a bitmask
	        return (node === child) || !!(this.compareDocumentPosition(arg) & 16);
	      });
	
	      return findFn(child);
	    },
	
	    /**
	     * Functional equivalent for $element.filter(‘md-bottom-sheet’)
	     * useful with interimElements where the element and its container are important...
	     *
	     * @param {[]} elements to scan
	     * @param {string} name of node to find (e.g. 'md-dialog')
	     * @param {boolean=} optional flag to allow deep scans; defaults to 'false'.
	     * @param {boolean=} optional flag to enable log warnings; defaults to false
	     */
	    extractElementByName: function(element, nodeName, scanDeep, warnNotFound) {
	      var found = scanTree(element);
	      if (!found && !!warnNotFound) {
	        $log.warn( $mdUtil.supplant("Unable to find node '{0}' in element '{1}'.",[nodeName, element[0].outerHTML]) );
	      }
	
	      return angular.element(found || element);
	
	      /**
	       * Breadth-First tree scan for element with matching `nodeName`
	       */
	      function scanTree(element) {
	        return scanLevel(element) || (scanDeep ? scanChildren(element) : null);
	      }
	
	      /**
	       * Case-insensitive scan of current elements only (do not descend).
	       */
	      function scanLevel(element) {
	        if ( element ) {
	          for (var i = 0, len = element.length; i < len; i++) {
	            if (element[i].nodeName.toLowerCase() === nodeName) {
	              return element[i];
	            }
	          }
	        }
	        return null;
	      }
	
	      /**
	       * Scan children of specified node
	       */
	      function scanChildren(element) {
	        var found;
	        if ( element ) {
	          for (var i = 0, len = element.length; i < len; i++) {
	            var target = element[i];
	            if ( !found ) {
	              for (var j = 0, numChild = target.childNodes.length; j < numChild; j++) {
	                found = found || scanTree([target.childNodes[j]]);
	              }
	            }
	          }
	        }
	        return found;
	      }
	
	    },
	
	    /**
	     * Give optional properties with no value a boolean true if attr provided or false otherwise
	     */
	    initOptionalProperties: function(scope, attr, defaults) {
	      defaults = defaults || {};
	      angular.forEach(scope.$$isolateBindings, function(binding, key) {
	        if (binding.optional && angular.isUndefined(scope[key])) {
	          var attrIsDefined = angular.isDefined(attr[binding.attrName]);
	          scope[key] = angular.isDefined(defaults[key]) ? defaults[key] : attrIsDefined;
	        }
	      });
	    },
	
	    /**
	     * Alternative to $timeout calls with 0 delay.
	     * nextTick() coalesces all calls within a single frame
	     * to minimize $digest thrashing
	     *
	     * @param callback
	     * @param digest
	     * @returns {*}
	     */
	    nextTick: function(callback, digest, scope) {
	      //-- grab function reference for storing state details
	      var nextTick = $mdUtil.nextTick;
	      var timeout = nextTick.timeout;
	      var queue = nextTick.queue || [];
	
	      //-- add callback to the queue
	      queue.push({scope: scope, callback: callback});
	
	      //-- set default value for digest
	      if (digest == null) digest = true;
	
	      //-- store updated digest/queue values
	      nextTick.digest = nextTick.digest || digest;
	      nextTick.queue = queue;
	
	      //-- either return existing timeout or create a new one
	      return timeout || (nextTick.timeout = $timeout(processQueue, 0, false));
	
	      /**
	       * Grab a copy of the current queue
	       * Clear the queue for future use
	       * Process the existing queue
	       * Trigger digest if necessary
	       */
	      function processQueue() {
	        var queue = nextTick.queue;
	        var digest = nextTick.digest;
	
	        nextTick.queue = [];
	        nextTick.timeout = null;
	        nextTick.digest = false;
	
	        queue.forEach(function(queueItem) {
	          var skip = queueItem.scope && queueItem.scope.$$destroyed;
	          if (!skip) {
	            queueItem.callback();
	          }
	        });
	
	        if (digest) $rootScope.$digest();
	      }
	    },
	
	    /**
	     * Processes a template and replaces the start/end symbols if the application has
	     * overriden them.
	     *
	     * @param template The template to process whose start/end tags may be replaced.
	     * @returns {*}
	     */
	    processTemplate: function(template) {
	      if (usesStandardSymbols) {
	        return template;
	      } else {
	        if (!template || !angular.isString(template)) return template;
	        return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	      }
	    },
	
	    /**
	     * Scan up dom hierarchy for enabled parent;
	     */
	    getParentWithPointerEvents: function (element) {
	      var parent = element.parent();
	
	      // jqLite might return a non-null, but still empty, parent; so check for parent and length
	      while (hasComputedStyle(parent, 'pointer-events', 'none')) {
	        parent = parent.parent();
	      }
	
	      return parent;
	    },
	
	    getNearestContentElement: function (element) {
	      var current = element.parent()[0];
	      // Look for the nearest parent md-content, stopping at the rootElement.
	      while (current && current !== $rootElement[0] && current !== document.body && current.nodeName.toUpperCase() !== 'MD-CONTENT') {
	        current = current.parentNode;
	      }
	      return current;
	    },
	
	    /**
	     * Checks if the current browser is natively supporting the `sticky` position.
	     * @returns {string} supported sticky property name
	     */
	    checkStickySupport: function() {
	      var stickyProp;
	      var testEl = angular.element('<div>');
	      $document[0].body.appendChild(testEl[0]);
	
	      var stickyProps = ['sticky', '-webkit-sticky'];
	      for (var i = 0; i < stickyProps.length; ++i) {
	        testEl.css({
	          position: stickyProps[i],
	          top: 0,
	          'z-index': 2
	        });
	
	        if (testEl.css('position') == stickyProps[i]) {
	          stickyProp = stickyProps[i];
	          break;
	        }
	      }
	
	      testEl.remove();
	
	      return stickyProp;
	    },
	
	    /**
	     * Parses an attribute value, mostly a string.
	     * By default checks for negated values and returns `false´ if present.
	     * Negated values are: (native falsy) and negative strings like:
	     * `false` or `0`.
	     * @param value Attribute value which should be parsed.
	     * @param negatedCheck When set to false, won't check for negated values.
	     * @returns {boolean}
	     */
	    parseAttributeBoolean: function(value, negatedCheck) {
	      return value === '' || !!value && (negatedCheck === false || value !== 'false' && value !== '0');
	    },
	
	    hasComputedStyle: hasComputedStyle,
	
	    /**
	     * Returns true if the parent form of the element has been submitted.
	     *
	     * @param element An AngularJS or HTML5 element.
	     *
	     * @returns {boolean}
	     */
	    isParentFormSubmitted: function(element) {
	      var parent = $mdUtil.getClosest(element, 'form');
	      var form = parent ? angular.element(parent).controller('form') : null;
	
	      return form ? form.$submitted : false;
	    },
	
	    /**
	     * Animate the requested element's scrollTop to the requested scrollPosition with basic easing.
	     *
	     * @param {!HTMLElement} element The element to scroll.
	     * @param {number} scrollEnd The new/final scroll position.
	     * @param {number=} duration Duration of the scroll. Default is 1000ms.
	     */
	    animateScrollTo: function(element, scrollEnd, duration) {
	      var scrollStart = element.scrollTop;
	      var scrollChange = scrollEnd - scrollStart;
	      var scrollingDown = scrollStart < scrollEnd;
	      var startTime = $mdUtil.now();
	
	      $$rAF(scrollChunk);
	
	      function scrollChunk() {
	        var newPosition = calculateNewPosition();
	
	        element.scrollTop = newPosition;
	
	        if (scrollingDown ? newPosition < scrollEnd : newPosition > scrollEnd) {
	          $$rAF(scrollChunk);
	        }
	      }
	
	      function calculateNewPosition() {
	        var easeDuration = duration || 1000;
	        var currentTime = $mdUtil.now() - startTime;
	
	        return ease(currentTime, scrollStart, scrollChange, easeDuration);
	      }
	
	      function ease(currentTime, start, change, duration) {
	        // If the duration has passed (which can occur if our app loses focus due to $$rAF), jump
	        // straight to the proper position
	        if (currentTime > duration) {
	          return start + change;
	        }
	
	        var ts = (currentTime /= duration) * currentTime;
	        var tc = ts * currentTime;
	
	        return start + change * (-2 * tc + 3 * ts);
	      }
	    },
	
	    /**
	     * Provides an easy mechanism for removing duplicates from an array.
	     *
	     *    var myArray = [1, 2, 2, 3, 3, 3, 4, 4, 4, 4];
	     *
	     *    $mdUtil.uniq(myArray) => [1, 2, 3, 4]
	     *
	     * @param {array} array The array whose unique values should be returned.
	     *
	     * @returns {array} A copy of the array containing only unique values.
	     */
	    uniq: function(array) {
	      if (!array) { return; }
	
	      return array.filter(function(value, index, self) {
	        return self.indexOf(value) === index;
	      });
	    }
	  };
	
	
	// Instantiate other namespace utility methods
	
	  $mdUtil.dom.animator = $$mdAnimate($mdUtil);
	
	  return $mdUtil;
	
	  function getNode(el) {
	    return el[0] || el;
	  }
	
	}
	
	/*
	 * Since removing jQuery from the demos, some code that uses `element.focus()` is broken.
	 * We need to add `element.focus()`, because it's testable unlike `element[0].focus`.
	 */
	
	angular.element.prototype.focus = angular.element.prototype.focus || function() {
	    if (this.length) {
	      this[0].focus();
	    }
	    return this;
	  };
	angular.element.prototype.blur = angular.element.prototype.blur || function() {
	    if (this.length) {
	      this[0].blur();
	    }
	    return this;
	  };
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.aria
	 * @description
	 * Aria Expectations for AngularJS Material components.
	 */
	MdAriaService.$inject = ["$$rAF", "$log", "$window", "$interpolate"];
	angular
	  .module('material.core')
	  .provider('$mdAria', MdAriaProvider);
	
	/**
	 * @ngdoc service
	 * @name $mdAriaProvider
	 * @module material.core.aria
	 *
	 * @description
	 *
	 * Modify options of the `$mdAria` service, which will be used by most of the AngularJS Material
	 * components.
	 *
	 * You are able to disable `$mdAria` warnings, by using the following markup.
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdAriaProvider) {
	 *     // Globally disables all ARIA warnings.
	 *     $mdAriaProvider.disableWarnings();
	 *   });
	 * </hljs>
	 *
	 */
	function MdAriaProvider() {
	
	  var config = {
	    /** Whether we should show ARIA warnings in the console if labels are missing on the element */
	    showWarnings: true
	  };
	
	  return {
	    disableWarnings: disableWarnings,
	    $get: ["$$rAF", "$log", "$window", "$interpolate", function($$rAF, $log, $window, $interpolate) {
	      return MdAriaService.apply(config, arguments);
	    }]
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdAriaProvider#disableWarnings
	   * @description Disables all ARIA warnings generated by AngularJS Material.
	   */
	  function disableWarnings() {
	    config.showWarnings = false;
	  }
	}
	
	/*
	 * @ngInject
	 */
	function MdAriaService($$rAF, $log, $window, $interpolate) {
	
	  // Load the showWarnings option from the current context and store it inside of a scope variable,
	  // because the context will be probably lost in some function calls.
	  var showWarnings = this.showWarnings;
	
	  return {
	    expect: expect,
	    expectAsync: expectAsync,
	    expectWithText: expectWithText,
	    expectWithoutText: expectWithoutText,
	    getText: getText,
	    hasAriaLabel: hasAriaLabel,
	    parentHasAriaLabel: parentHasAriaLabel
	  };
	
	  /**
	   * Check if expected attribute has been specified on the target element or child
	   * @param element
	   * @param attrName
	   * @param {optional} defaultValue What to set the attr to if no value is found
	   */
	  function expect(element, attrName, defaultValue) {
	
	    var node = angular.element(element)[0] || element;
	
	    // if node exists and neither it nor its children have the attribute
	    if (node &&
	       ((!node.hasAttribute(attrName) ||
	        node.getAttribute(attrName).length === 0) &&
	        !childHasAttribute(node, attrName))) {
	
	      defaultValue = angular.isString(defaultValue) ? defaultValue.trim() : '';
	      if (defaultValue.length) {
	        element.attr(attrName, defaultValue);
	      } else if (showWarnings) {
	        $log.warn('ARIA: Attribute "', attrName, '", required for accessibility, is missing on node:', node);
	      }
	
	    }
	  }
	
	  function expectAsync(element, attrName, defaultValueGetter) {
	    // Problem: when retrieving the element's contents synchronously to find the label,
	    // the text may not be defined yet in the case of a binding.
	    // There is a higher chance that a binding will be defined if we wait one frame.
	    $$rAF(function() {
	        expect(element, attrName, defaultValueGetter());
	    });
	  }
	
	  function expectWithText(element, attrName) {
	    var content = getText(element) || "";
	    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;
	
	    if (hasBinding) {
	      expectAsync(element, attrName, function() {
	        return getText(element);
	      });
	    } else {
	      expect(element, attrName, content);
	    }
	  }
	
	  function expectWithoutText(element, attrName) {
	    var content = getText(element);
	    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;
	
	    if ( !hasBinding && !content) {
	      expect(element, attrName, content);
	    }
	  }
	
	  function getText(element) {
	    element = element[0] || element;
	    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
	    var text = '';
	
	    var node;
	    while (node = walker.nextNode()) {
	      if (!isAriaHiddenNode(node)) {
	        text += node.textContent;
	      }
	    }
	
	    return text.trim() || '';
	
	    function isAriaHiddenNode(node) {
	      while (node.parentNode && (node = node.parentNode) !== element) {
	        if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
	          return true;
	        }
	      }
	    }
	  }
	
	  function childHasAttribute(node, attrName) {
	    var hasChildren = node.hasChildNodes(),
	        hasAttr = false;
	
	    function isHidden(el) {
	      var style = el.currentStyle ? el.currentStyle : $window.getComputedStyle(el);
	      return (style.display === 'none');
	    }
	
	    if (hasChildren) {
	      var children = node.childNodes;
	      for (var i=0; i < children.length; i++) {
	        var child = children[i];
	        if (child.nodeType === 1 && child.hasAttribute(attrName)) {
	          if (!isHidden(child)) {
	            hasAttr = true;
	          }
	        }
	      }
	    }
	    return hasAttr;
	  }
	
	  /**
	   * Check if expected element has aria label attribute
	   * @param element
	   */
	  function hasAriaLabel(element) {
	    var node = angular.element(element)[0] || element;
	
	    /* Check if compatible node type (ie: not HTML Document node) */
	    if (!node.hasAttribute) {
	      return false;
	    }
	
	    /* Check label or description attributes */
	    return node.hasAttribute('aria-label') || node.hasAttribute('aria-labelledby') || node.hasAttribute('aria-describedby');
	  }
	
	  /**
	   * Check if expected element's parent has aria label attribute and has valid role and tagName
	   * @param element
	   * @param {optional} level Number of levels deep search should be performed
	   */
	  function parentHasAriaLabel(element, level) {
	    level = level || 1;
	    var node = angular.element(element)[0] || element;
	    if (!node.parentNode) {
	      return false;
	    }
	    if (performCheck(node.parentNode)) {
	      return true;
	    }
	    level--;
	    if (level) {
	      return parentHasAriaLabel(node.parentNode, level);
	    }
	    return false;
	
	    function performCheck(parentNode) {
	      if (!hasAriaLabel(parentNode)) {
	        return false;
	      }
	      /* Perform role blacklist check */
	      if (parentNode.hasAttribute('role')) {
	        switch(parentNode.getAttribute('role').toLowerCase()) {
	          case 'command':
	          case 'definition':
	          case 'directory':
	          case 'grid':
	          case 'list':
	          case 'listitem':
	          case 'log':
	          case 'marquee':
	          case 'menu':
	          case 'menubar':
	          case 'note':
	          case 'presentation':
	          case 'separator':
	          case 'scrollbar':
	          case 'status':
	          case 'tablist':
	            return false;
	        }
	      }
	      /* Perform tagName blacklist check */
	      switch(parentNode.tagName.toLowerCase()) {
	        case 'abbr':
	        case 'acronym':
	        case 'address':
	        case 'applet':
	        case 'audio':
	        case 'b':
	        case 'bdi':
	        case 'bdo':
	        case 'big':
	        case 'blockquote':
	        case 'br':
	        case 'canvas':
	        case 'caption':
	        case 'center':
	        case 'cite':
	        case 'code':
	        case 'col':
	        case 'data':
	        case 'dd':
	        case 'del':
	        case 'dfn':
	        case 'dir':
	        case 'div':
	        case 'dl':
	        case 'em':
	        case 'embed':
	        case 'fieldset':
	        case 'figcaption':
	        case 'font':
	        case 'h1':
	        case 'h2':
	        case 'h3':
	        case 'h4':
	        case 'h5':
	        case 'h6':
	        case 'hgroup':
	        case 'html':
	        case 'i':
	        case 'ins':
	        case 'isindex':
	        case 'kbd':
	        case 'keygen':
	        case 'label':
	        case 'legend':
	        case 'li':
	        case 'map':
	        case 'mark':
	        case 'menu':
	        case 'object':
	        case 'ol':
	        case 'output':
	        case 'pre':
	        case 'presentation':
	        case 'q':
	        case 'rt':
	        case 'ruby':
	        case 'samp':
	        case 'small':
	        case 'source':
	        case 'span':
	        case 'status':
	        case 'strike':
	        case 'strong':
	        case 'sub':
	        case 'sup':
	        case 'svg':
	        case 'tbody':
	        case 'td':
	        case 'th':
	        case 'thead':
	        case 'time':
	        case 'tr':
	        case 'track':
	        case 'tt':
	        case 'ul':
	        case 'var':
	          return false;
	      }
	      return true;
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.compiler
	 * @description
	 * AngularJS Material template and element compiler.
	 */
	angular
	  .module('material.core')
	  .provider('$mdCompiler', MdCompilerProvider);
	
	/**
	 * @ngdoc service
	 * @name $mdCompilerProvider
	 * @module material.core.compiler
	 * @description
	 * The `$mdCompiler` is able to respect the AngularJS `$compileProvider.preAssignBindingsEnabled`
	 * state when using AngularJS versions greater than or equal to 1.5.10 and less than 1.7.0.
	 * See the [AngularJS documentation for `$compileProvider.preAssignBindingsEnabled`
	 * ](https://code.angularjs.org/1.6.10/docs/api/ng/provider/$compileProvider#preAssignBindingsEnabled)
	 * for more information.
	 *
	 * To enable/disable whether the controllers of dynamic AngularJS Material components
	 * (i.e. dialog, panel, toast, bottomsheet) respect the AngularJS
	 * `$compileProvider.preAssignBindingsEnabled` flag, call the AngularJS Material method:
	 * `$mdCompilerProvider.respectPreAssignBindingsEnabled(boolean)`.
	 *
	 * This AngularJS Material *flag* doesn't affect directives/components created via regular
	 * AngularJS methods. These constitute the majority of AngularJS Material and user-created
	 * components. Only dynamic construction of elements such as Dialogs, Panels, Toasts, BottomSheets,
	 * etc. may be affected. Invoking `$mdCompilerProvider.respectPreAssignBindingsEnabled(true)`
	 * will effect **bindings** in controllers created by AngularJS Material's services like
	 * `$mdDialog`, `$mdPanel`, `$mdToast`, or `$mdBottomSheet`.
	 *
	 * See [$mdCompilerProvider.respectPreAssignBindingsEnabled](#mdcompilerprovider-respectpreassignbindingsenabled-respected)
	 * for the details of how the different versions and settings of AngularJS affect this behavior.
	 *
	 * @usage
	 *
	 * Respect the AngularJS Compiler Setting
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdCompilerProvider) {
	 *     $mdCompilerProvider.respectPreAssignBindingsEnabled(true);
	 *   });
	 * </hljs>
	 *
	 * @example
	 * Using the default (backwards compatible) values for AngularJS 1.6
	 * - AngularJS' `$compileProvider.preAssignBindingsEnabled(false)`
	 * - AngularJS Material's `$mdCompilerProvider.respectPreAssignBindingsEnabled(false)`
	 * <br><br>
	 *
	 * <hljs lang="js">
	 * $mdDialog.show({
	 *   locals: {
	 *     myVar: true
	 *   },
	 *   controller: MyController,
	 *   bindToController: true
	 * }
	 *
	 * function MyController() {
	 *   // Locals from Angular Material are available. e.g myVar is true.
	 * }
	 *
	 * MyController.prototype.$onInit = function() {
	 *   // Bindings are also available in the $onInit lifecycle hook.
	 * }
	 * </hljs>
	 *
	 * Recommended Settings for AngularJS 1.6
	 * - AngularJS' `$compileProvider.preAssignBindingsEnabled(false)`
	 * - AngularJS Material's `$mdCompilerProvider.respectPreAssignBindingsEnabled(true)`
	 * <br><br>
	 *
	 * <hljs lang="js">
	 * $mdDialog.show({
	 *   locals: {
	 *     myVar: true
	 *   },
	 *   controller: MyController,
	 *   bindToController: true
	 * }
	 *
	 * function MyController() {
	 *   // No locals from Angular Material are available. e.g myVar is undefined.
	 * }
	 *
	 * MyController.prototype.$onInit = function() {
	 *   // Bindings are now available in the $onInit lifecycle hook.
	 * }
	 * </hljs>
	 *
	 */
	MdCompilerProvider.$inject = ['$compileProvider'];
	function MdCompilerProvider($compileProvider) {
	
	  var provider = this;
	
	  /**
	   * @ngdoc method
	   * @name $mdCompilerProvider#respectPreAssignBindingsEnabled
	   *
	   * @param {boolean=} respected update the `respectPreAssignBindingsEnabled` state if provided,
	   *  otherwise just return the current Material `respectPreAssignBindingsEnabled` state.
	   * @returns {boolean|MdCompilerProvider} current value, if used as a getter, or itself (chaining)
	   *  if used as a setter.
	   *
	   * @description
	   * Call this method to enable/disable whether Material-specific (dialog/panel/toast/bottomsheet)
	   * controllers respect the AngularJS `$compileProvider.preAssignBindingsEnabled` flag. Note that
	   * this doesn't affect directives/components created via regular AngularJS methods which
	   * constitute most Material and user-created components.
	   *
	   * If disabled (`false`), the compiler assigns the value of each of the bindings to the
	   * properties of the controller object before the constructor of this object is called.
	   * The ability to disable this settings is **deprecated** and will be removed in
	   * AngularJS Material 1.2.0.
	   *
	   * If enabled (`true`) the behavior depends on the AngularJS version used:
	   *
	   * - `<1.5.10`
	   *  - Bindings are pre-assigned.
	   * - `>=1.5.10 <1.7`
	   *  - Respects whatever `$compileProvider.preAssignBindingsEnabled()` reports. If the
	   *    `preAssignBindingsEnabled` flag wasn't set manually, it defaults to pre-assigning bindings
	   *    with AngularJS `1.5` and to calling the constructor first with AngularJS `1.6`.
	   * - `>=1.7`
	   *  - The compiler calls the constructor first before assigning bindings and
	   *    `$compileProvider.preAssignBindingsEnabled()` no longer exists.
	   *
	   * Defaults
	   * - The default value is `false` in AngularJS 1.6 and earlier.
	   *  - It is planned to fix this value to `true` and not allow the `false` value in
	   *    AngularJS Material 1.2.0.
	   *
	   * It is recommended to set this flag to `true` when using AngularJS Material 1.1.x with
	   * AngularJS versions >= 1.5.10. The only reason it's not set that way by default is backwards
	   * compatibility.
	   *
	   * By not setting the flag to `true` when AngularJS' `$compileProvider.preAssignBindingsEnabled()`
	   * is set to `false` (i.e. default behavior in AngularJS 1.6 or newer), unit testing of
	   * Material Dialog/Panel/Toast/BottomSheet controllers using the `$controller` helper
	   * is problematic as it always follows AngularJS' `$compileProvider.preAssignBindingsEnabled()`
	   * value.
	   */
	  var respectPreAssignBindingsEnabled = false;
	  this.respectPreAssignBindingsEnabled = function(respected) {
	    if (angular.isDefined(respected)) {
	      respectPreAssignBindingsEnabled = respected;
	      return this;
	    }
	
	    return respectPreAssignBindingsEnabled;
	  };
	
	  /**
	   * @private
	   * @description
	   * This function returns `true` if AngularJS Material-specific (dialog/panel/toast/bottomsheet)
	   * controllers have bindings pre-assigned in controller constructors and `false` otherwise.
	   *
	   * Note that this doesn't affect directives/components created via regular AngularJS methods
	   * which constitute most Material and user-created components; their behavior can be checked via
	   * `$compileProvider.preAssignBindingsEnabled()` in AngularJS `>=1.5.10 <1.7.0`.
	   *
	   * @returns {*} current preAssignBindingsEnabled state
	   */
	  function getPreAssignBindingsEnabled() {
	    if (!respectPreAssignBindingsEnabled) {
	      // respectPreAssignBindingsEnabled === false
	      // We're ignoring the AngularJS `$compileProvider.preAssignBindingsEnabled()` value in this case.
	      return true;
	    }
	
	    // respectPreAssignBindingsEnabled === true
	
	    // This check is needed because $compileProvider.preAssignBindingsEnabled does not exist prior
	    // to AngularJS 1.5.10, is deprecated in AngularJS 1.6.x, and removed in AngularJS 1.7.x.
	    if (typeof $compileProvider.preAssignBindingsEnabled === 'function') {
	      return $compileProvider.preAssignBindingsEnabled();
	    }
	
	    // Flag respected but not present => apply logic based on AngularJS version used.
	    if (angular.version.major === 1 && angular.version.minor < 6) {
	      // AngularJS <1.5.10
	      return true;
	    }
	
	    // AngularJS >=1.7.0
	    return false;
	  }
	
	  this.$get = ["$q", "$templateRequest", "$injector", "$compile", "$controller",
	    function($q, $templateRequest, $injector, $compile, $controller) {
	      return new MdCompilerService($q, $templateRequest, $injector, $compile, $controller);
	    }];
	
	  /**
	   * @ngdoc service
	   * @name $mdCompiler
	   * @module material.core.compiler
	   * @description
	   * The $mdCompiler service is an abstraction of AngularJS's compiler, that allows developers
	   * to easily compile an element with options like in a Directive Definition Object.
	   *
	   * > The compiler powers a lot of components inside of AngularJS Material.
	   * > Like the `$mdPanel` or `$mdDialog`.
	   *
	   * @usage
	   *
	   * Basic Usage with a template
	   *
	   * <hljs lang="js">
	   *   $mdCompiler.compile({
	   *     templateUrl: 'modal.html',
	   *     controller: 'ModalCtrl',
	   *     locals: {
	   *       modal: myModalInstance;
	   *     }
	   *   }).then(function (compileData) {
	   *     compileData.element; // Compiled DOM element
	   *     compileData.link(myScope); // Instantiate controller and link element to scope.
	   *   });
	   * </hljs>
	   *
	   * Example with a content element
	   *
	   * <hljs lang="js">
	   *
	   *   // Create a virtual element and link it manually.
	   *   // The compiler doesn't need to recompile the element each time.
	   *   var myElement = $compile('<span>Test</span>')(myScope);
	   *
	   *   $mdCompiler.compile({
	   *     contentElement: myElement
	   *   }).then(function (compileData) {
	   *     compileData.element // Content Element (same as above)
	   *     compileData.link // This does nothing when using a contentElement.
	   *   });
	   * </hljs>
	   *
	   * > Content Element is a significant performance improvement when the developer already knows that the
	   * > compiled element will be always the same and the scope will not change either.
	   *
	   * The `contentElement` option also supports DOM elements which will be temporary removed and restored
	   * at its old position.
	   *
	   * <hljs lang="js">
	   *   var domElement = document.querySelector('#myElement');
	   *
	   *   $mdCompiler.compile({
	   *     contentElement: myElement
	   *   }).then(function (compileData) {
	   *     compileData.element // Content Element (same as above)
	   *     compileData.link // This does nothing when using a contentElement.
	   *   });
	   * </hljs>
	   *
	   * The `$mdCompiler` can also query for the element in the DOM itself.
	   *
	   * <hljs lang="js">
	   *   $mdCompiler.compile({
	   *     contentElement: '#myElement'
	   *   }).then(function (compileData) {
	   *     compileData.element // Content Element (same as above)
	   *     compileData.link // This does nothing when using a contentElement.
	   *   });
	   * </hljs>
	   *
	   */
	  function MdCompilerService($q, $templateRequest, $injector, $compile, $controller) {
	
	    /** @private @const {!angular.$q} */
	    this.$q = $q;
	
	    /** @private @const {!angular.$templateRequest} */
	    this.$templateRequest = $templateRequest;
	
	    /** @private @const {!angular.$injector} */
	    this.$injector = $injector;
	
	    /** @private @const {!angular.$compile} */
	    this.$compile = $compile;
	
	    /** @private @const {!angular.$controller} */
	    this.$controller = $controller;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $mdCompiler#compile
	   * @description
	   *
	   * A method to compile a HTML template with the AngularJS compiler.
	   * The `$mdCompiler` is wrapper around the AngularJS compiler and provides extra functionality
	   * like controller instantiation or async resolves.
	   *
	   * @param {!Object} options An options object, with the following properties:
	   *
	   *    - `controller` - `{string|function}` Controller fn that should be associated with
	   *         newly created scope or the name of a registered controller if passed as a string.
	   *    - `controllerAs` - `{string=}` A controller alias name. If present the controller will be
	   *         published to scope under the `controllerAs` name.
	   *    - `contentElement` - `{string|Element}`: Instead of using a template, which will be
	   *         compiled each time, you can also use a DOM element.<br/>
	   *    - `template` - `{string=}` An html template as a string.
	   *    - `templateUrl` - `{string=}` A path to an html template.
	   *    - `transformTemplate` - `{function(template)=}` A function which transforms the template after
	   *        it is loaded. It will be given the template string as a parameter, and should
	   *        return a a new string representing the transformed template.
	   *    - `resolve` - `{Object.<string, function>=}` - An optional map of dependencies which should
	   *        be injected into the controller. If any of these dependencies are promises, the compiler
	   *        will wait for them all to be resolved, or if one is rejected before the controller is
	   *        instantiated `compile()` will fail..
	   *      * `key` - `{string}`: a name of a dependency to be injected into the controller.
	   *      * `factory` - `{string|function}`: If `string` then it is an alias for a service.
	   *        Otherwise if function, then it is injected and the return value is treated as the
	   *        dependency. If the result is a promise, it is resolved before its value is
	   *        injected into the controller.
	   *
	   * @returns {Object} promise A promise, which will be resolved with a `compileData` object.
	   * `compileData` has the following properties:
	   *
	   *   - `element` - `{Element}`: an uncompiled element matching the provided template.
	   *   - `link` - `{function(scope)}`: A link function, which, when called, will compile
	   *     the element and instantiate the provided controller (if given).
	   *   - `locals` - `{Object}`: The locals which will be passed into the controller once `link` is
	   *     called. If `bindToController` is true, they will be copied to the ctrl instead
	   */
	  MdCompilerService.prototype.compile = function(options) {
	
	    if (options.contentElement) {
	      return this._prepareContentElement(options);
	    } else {
	      return this._compileTemplate(options);
	    }
	
	  };
	
	  /**
	   * Instead of compiling any template, the compiler just fetches an existing HTML element from the DOM and
	   * provides a restore function to put the element back it old DOM position.
	   * @param {!Object} options Options to be used for the compiler.
	   */
	  MdCompilerService.prototype._prepareContentElement = function(options) {
	
	    var contentElement = this._fetchContentElement(options);
	
	    return this.$q.resolve({
	      element: contentElement.element,
	      cleanup: contentElement.restore,
	      locals: {},
	      link: function() {
	        return contentElement.element;
	      }
	    });
	
	  };
	
	  /**
	   * Compiles a template by considering all options and waiting for all resolves to be ready.
	   * @param {!Object} options Compile options
	   * @returns {!Object} Compile data with link function.
	   */
	  MdCompilerService.prototype._compileTemplate = function(options) {
	
	    var self = this;
	    var templateUrl = options.templateUrl;
	    var template = options.template || '';
	    var resolve = angular.extend({}, options.resolve);
	    var locals = angular.extend({}, options.locals);
	    var transformTemplate = options.transformTemplate || angular.identity;
	
	    // Take resolve values and invoke them.
	    // Resolves can either be a string (value: 'MyRegisteredAngularConst'),
	    // or an invokable 'factory' of sorts: (value: function ValueGetter($dependency) {})
	    angular.forEach(resolve, function(value, key) {
	      if (angular.isString(value)) {
	        resolve[key] = self.$injector.get(value);
	      } else {
	        resolve[key] = self.$injector.invoke(value);
	      }
	    });
	
	    // Add the locals, which are just straight values to inject
	    // eg locals: { three: 3 }, will inject three into the controller
	    angular.extend(resolve, locals);
	
	    if (templateUrl) {
	      resolve.$$ngTemplate = this.$templateRequest(templateUrl);
	    } else {
	      resolve.$$ngTemplate = this.$q.when(template);
	    }
	
	
	    // Wait for all the resolves to finish if they are promises
	    return this.$q.all(resolve).then(function(locals) {
	
	      var template = transformTemplate(locals.$$ngTemplate, options);
	      var element = options.element || angular.element('<div>').html(template.trim()).contents();
	
	      return self._compileElement(locals, element, options);
	    });
	
	  };
	
	  /**
	   * Method to compile an element with the given options.
	   * @param {!Object} locals Locals to be injected to the controller if present
	   * @param {!JQLite} element Element to be compiled and linked
	   * @param {!Object} options Options to be used for linking.
	   * @returns {!Object} Compile data with link function.
	   */
	  MdCompilerService.prototype._compileElement = function(locals, element, options) {
	    var self = this;
	    var ngLinkFn = this.$compile(element);
	
	    var compileData = {
	      element: element,
	      cleanup: element.remove.bind(element),
	      locals: locals,
	      link: linkFn
	    };
	
	    function linkFn(scope) {
	      locals.$scope = scope;
	
	      // Instantiate controller if the developer provided one.
	      if (options.controller) {
	
	        var injectLocals = angular.extend({}, locals, {
	          $element: element
	        });
	
	        // Create the specified controller instance.
	        var ctrl = self._createController(options, injectLocals, locals);
	
	        // Unique identifier for AngularJS Route ngView controllers.
	        element.data('$ngControllerController', ctrl);
	        element.children().data('$ngControllerController', ctrl);
	
	        // Expose the instantiated controller to the compile data
	        compileData.controller = ctrl;
	      }
	
	      // Invoke the AngularJS $compile link function.
	      return ngLinkFn(scope);
	    }
	
	    return compileData;
	
	  };
	
	  /**
	   * Creates and instantiates a new controller with the specified options.
	   * @param {!Object} options Options that include the controller function or string.
	   * @param {!Object} injectLocals Locals to to be provided in the controller DI.
	   * @param {!Object} locals Locals to be injected to the controller.
	   * @returns {!Object} Created controller instance.
	   */
	  MdCompilerService.prototype._createController = function(options, injectLocals, locals) {
	    var ctrl;
	    var preAssignBindingsEnabled = getPreAssignBindingsEnabled();
	    // The third argument to $controller is considered private and undocumented:
	    // https://github.com/angular/angular.js/blob/v1.6.10/src/ng/controller.js#L102-L109.
	    // TODO remove the use of this third argument in AngularJS Material 1.2.0.
	    // Passing `true` as the third argument causes `$controller` to return a function that
	    // gets the controller instance instead of returning the instance directly. When the
	    // controller is defined as a function, `invokeCtrl.instance` is the *same instance* as
	    // `invokeCtrl()`. However, when the controller is an ES6 class, `invokeCtrl.instance` is a
	    // *different instance* from `invokeCtrl()`.
	    if (preAssignBindingsEnabled) {
	      var invokeCtrl = this.$controller(options.controller, injectLocals, true);
	
	      if (options.bindToController) {
	        angular.extend(invokeCtrl.instance, locals);
	      }
	
	      // Use the private API callback to instantiate and initialize the specified controller.
	      ctrl = invokeCtrl();
	    } else {
	      // If we don't need to pre-assign bindings, avoid using the private API third argument and
	      // related callback.
	      ctrl = this.$controller(options.controller, injectLocals);
	
	      if (options.bindToController) {
	        angular.extend(ctrl, locals);
	      }
	    }
	
	    if (options.controllerAs) {
	      injectLocals.$scope[options.controllerAs] = ctrl;
	    }
	
	    // Call the $onInit hook if it's present on the controller.
	    angular.isFunction(ctrl.$onInit) && ctrl.$onInit();
	
	    return ctrl;
	  };
	
	  /**
	   * Fetches an element removing it from the DOM and using it temporary for the compiler.
	   * Elements which were fetched will be restored after use.
	   * @param {!Object} options Options to be used for the compilation.
	   * @returns {{element: !JQLite, restore: !function}}
	   */
	  MdCompilerService.prototype._fetchContentElement = function(options) {
	
	    var contentEl = options.contentElement;
	    var restoreFn = null;
	
	    if (angular.isString(contentEl)) {
	      contentEl = document.querySelector(contentEl);
	      restoreFn = createRestoreFn(contentEl);
	    } else {
	      contentEl = contentEl[0] || contentEl;
	
	      // When the element is visible in the DOM, then we restore it at close of the dialog.
	      // Otherwise it will be removed from the DOM after close.
	      if (document.contains(contentEl)) {
	        restoreFn = createRestoreFn(contentEl);
	      } else {
	        restoreFn = function() {
	          if (contentEl.parentNode) {
	            contentEl.parentNode.removeChild(contentEl);
	          }
	        };
	      }
	    }
	
	    return {
	      element: angular.element(contentEl),
	      restore: restoreFn
	    };
	
	    function createRestoreFn(element) {
	      var parent = element.parentNode;
	      var nextSibling = element.nextElementSibling;
	
	      return function() {
	        if (!nextSibling) {
	          // When the element didn't had any sibling, then it can be simply appended to the
	          // parent, because it plays no role, which index it had before.
	          parent.appendChild(element);
	        } else {
	          // When the element had a sibling, which marks the previous position of the element
	          // in the DOM, we insert it correctly before the sibling, to have the same index as
	          // before.
	          parent.insertBefore(element, nextSibling);
	        }
	      };
	    }
	  };
	}
	
	
	})();
	(function(){
	"use strict";
	
	
	MdGesture.$inject = ["$$MdGestureHandler", "$$rAF", "$timeout"];
	attachToDocument.$inject = ["$mdGesture", "$$MdGestureHandler"];var HANDLERS = {};
	
	/**
	 * The state of the current 'pointer'. The pointer represents the state of the current touch.
	 * It contains normalized x and y coordinates from DOM events,
	 * as well as other information abstracted from the DOM.
	 */
	var pointer, lastPointer, maxClickDistance = 6;
	var forceSkipClickHijack = false, disableAllGestures = false;
	
	/**
	 * The position of the most recent click if that click was on a label element.
	 * @type {{x: number, y: number}|null}
	 */
	var lastLabelClickPos = null;
	
	// Used to attach event listeners once when multiple ng-apps are running.
	var isInitialized = false;
	
	/**
	 * @ngdoc module
	 * @name material.core.gestures
	 * @description
	 * AngularJS Material Gesture handling for touch devices. This module replaced the usage of the hammerjs library.
	 */
	angular
	  .module('material.core.gestures', [ ])
	  .provider('$mdGesture', MdGestureProvider)
	  .factory('$$MdGestureHandler', MdGestureHandler)
	  .run(attachToDocument);
	
	/**
	 * @ngdoc service
	 * @name $mdGestureProvider
	 * @module material.core.gestures
	 *
	 * @description
	 * In some scenarios on mobile devices (without jQuery), the click events should NOT be hijacked.
	 * `$mdGestureProvider` is used to configure the Gesture module to ignore or skip click hijacking on mobile
	 * devices.
	 *
	 * You can also change the max click distance, `6px` by default, if you have issues on some touch screens.
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdGestureProvider) {
	 *
	 *     // For mobile devices without jQuery loaded, do not
	 *     // intercept click events during the capture phase.
	 *     $mdGestureProvider.skipClickHijack();
	 *
	 *     // If hijacking clicks, you may want to change the default click distance
	 *     $mdGestureProvider.setMaxClickDistance(12);
	 *   });
	 * </hljs>
	 *
	 */
	function MdGestureProvider() { }
	
	MdGestureProvider.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name $mdGestureProvider#disableAll
	   *
	   * @description
	   * Disable all gesture detection. This can be beneficial to application performance
	   * and memory usage.
	   */
	  disableAll: function () {
	    disableAllGestures = true;
	  },
	
	  // Publish access to setter to configure a variable BEFORE the
	  // $mdGesture service is instantiated...
	  /**
	   * @ngdoc method
	   * @name $mdGestureProvider#skipClickHijack
	   *
	   * @description
	   * Tell the AngularJS Material Gesture module to skip (or ignore) click hijacking on mobile devices.
	   */
	  skipClickHijack: function() {
	    return forceSkipClickHijack = true;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $mdGestureProvider#setMaxClickDistance
	   * @param clickDistance {string} Distance in pixels. I.e. `12px`.
	   * @description
	   * Set the max distance from the origin of the touch event to trigger touch handlers.
	   */
	  setMaxClickDistance: function(clickDistance) {
	    maxClickDistance = parseInt(clickDistance);
	  },
	
	  /**
	   * $get is used to build an instance of $mdGesture
	   * @ngInject
	   */
	  $get : ["$$MdGestureHandler", "$$rAF", "$timeout", function($$MdGestureHandler, $$rAF, $timeout) {
	       return new MdGesture($$MdGestureHandler, $$rAF, $timeout);
	  }]
	};
	
	
	
	/**
	 * MdGesture factory construction function
	 * @ngInject
	 */
	function MdGesture($$MdGestureHandler, $$rAF, $timeout) {
	  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	  var isIos = userAgent.match(/ipad|iphone|ipod/i);
	  var isAndroid = userAgent.match(/android/i);
	  var touchActionProperty = getTouchAction();
	  var hasJQuery =  (typeof window.jQuery !== 'undefined') && (angular.element === window.jQuery);
	
	  var self = {
	    handler: addHandler,
	    register: register,
	    isAndroid: isAndroid,
	    isIos: isIos,
	    // On mobile w/out jQuery, we normally intercept clicks. Should we skip that?
	    isHijackingClicks: (isIos || isAndroid) && !hasJQuery && !forceSkipClickHijack
	  };
	
	  if (self.isHijackingClicks) {
	    self.handler('click', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: checkDistanceAndEmit('click')
	    });
	
	    self.handler('focus', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: function(ev, pointer) {
	        if (pointer.distance < this.state.options.maxDistance && canFocus(ev.target)) {
	          this.dispatchEvent(ev, 'focus', pointer);
	          ev.target.focus();
	        }
	      }
	    });
	
	    self.handler('mouseup', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: checkDistanceAndEmit('mouseup')
	    });
	
	    self.handler('mousedown', {
	      onStart: function(ev) {
	        this.dispatchEvent(ev, 'mousedown');
	      }
	    });
	  }
	
	  function checkDistanceAndEmit(eventName) {
	    return function(ev, pointer) {
	      if (pointer.distance < this.state.options.maxDistance) {
	        this.dispatchEvent(ev, eventName, pointer);
	      }
	    };
	  }
	
	  /**
	   * Register an element to listen for a handler.
	   * This allows an element to override the default options for a handler.
	   * Additionally, some handlers like drag and hold only dispatch events if
	   * the domEvent happens inside an element that's registered to listen for these events.
	   *
	   * @see GestureHandler for how overriding of default options works.
	   * @example $mdGesture.register(myElement, 'drag', { minDistance: 20, horizontal: false })
	   */
	  function register(element, handlerName, options) {
	    var handler = HANDLERS[handlerName.replace(/^\$md./, '')];
	    if (!handler) {
	      throw new Error('Failed to register element with handler ' + handlerName + '. ' +
	      'Available handlers: ' + Object.keys(HANDLERS).join(', '));
	    }
	    return handler.registerElement(element, options);
	  }
	
	  /*
	   * add a handler to $mdGesture. see below.
	   */
	  function addHandler(name, definition) {
	    var handler = new $$MdGestureHandler(name);
	    angular.extend(handler, definition);
	    HANDLERS[name] = handler;
	
	    return self;
	  }
	
	  /**
	   * Register handlers. These listen to touch/start/move events, interpret them,
	   * and dispatch gesture events depending on options & conditions. These are all
	   * instances of GestureHandler.
	   * @see GestureHandler
	   */
	  return self
	    /*
	     * The press handler dispatches an event on touchdown/touchend.
	     * It's a simple abstraction of touch/mouse/pointer start and end.
	     */
	    .handler('press', {
	      onStart: function (ev, pointer) {
	        this.dispatchEvent(ev, '$md.pressdown');
	      },
	      onEnd: function (ev, pointer) {
	        this.dispatchEvent(ev, '$md.pressup');
	      }
	    })
	
	    /*
	     * The hold handler dispatches an event if the user keeps their finger within
	     * the same <maxDistance> area for <delay> ms.
	     * The hold handler will only run if a parent of the touch target is registered
	     * to listen for hold events through $mdGesture.register()
	     */
	    .handler('hold', {
	      options: {
	        maxDistance: 6,
	        delay: 500
	      },
	      onCancel: function () {
	        $timeout.cancel(this.state.timeout);
	      },
	      onStart: function (ev, pointer) {
	        // For hold, require a parent to be registered with $mdGesture.register()
	        // Because we prevent scroll events, this is necessary.
	        if (!this.state.registeredParent) return this.cancel();
	
	        this.state.pos = {x: pointer.x, y: pointer.y};
	        this.state.timeout = $timeout(angular.bind(this, function holdDelayFn() {
	          this.dispatchEvent(ev, '$md.hold');
	          this.cancel(); //we're done!
	        }), this.state.options.delay, false);
	      },
	      onMove: function (ev, pointer) {
	        // Don't scroll while waiting for hold.
	        // If we don't preventDefault touchmove events here, Android will assume we don't
	        // want to listen to anymore touch events. It will start scrolling and stop sending
	        // touchmove events.
	        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();
	
	        // If the user moves greater than <maxDistance> pixels, stop the hold timer
	        // set in onStart
	        var dx = this.state.pos.x - pointer.x;
	        var dy = this.state.pos.y - pointer.y;
	        if (Math.sqrt(dx * dx + dy * dy) > this.options.maxDistance) {
	          this.cancel();
	        }
	      },
	      onEnd: function () {
	        this.onCancel();
	      }
	    })
	
	    /*
	     * The drag handler dispatches a drag event if the user holds and moves his finger greater than
	     * <minDistance> px in the x or y direction, depending on options.horizontal.
	     * The drag will be cancelled if the user moves his finger greater than <minDistance>*<cancelMultiplier> in
	     * the perpendicular direction. Eg if the drag is horizontal and the user moves his finger <minDistance>*<cancelMultiplier>
	     * pixels vertically, this handler won't consider the move part of a drag.
	     */
	    .handler('drag', {
	      options: {
	        minDistance: 6,
	        horizontal: true,
	        cancelMultiplier: 1.5
	      },
	      onSetup: function(element, options) {
	        if (touchActionProperty) {
	          // We check for horizontal to be false, because otherwise we would overwrite the default opts.
	          this.oldTouchAction = element[0].style[touchActionProperty];
	          element[0].style[touchActionProperty] = options.horizontal ? 'pan-y' : 'pan-x';
	        }
	      },
	      onCleanup: function(element) {
	        if (this.oldTouchAction) {
	          element[0].style[touchActionProperty] = this.oldTouchAction;
	        }
	      },
	      onStart: function (ev) {
	        // For drag, require a parent to be registered with $mdGesture.register()
	        if (!this.state.registeredParent) this.cancel();
	      },
	      onMove: function (ev, pointer) {
	        var shouldStartDrag, shouldCancel;
	        // Don't scroll while deciding if this touchmove qualifies as a drag event.
	        // If we don't preventDefault touchmove events here, Android will assume we don't
	        // want to listen to anymore touch events. It will start scrolling and stop sending
	        // touchmove events.
	        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();
	
	        if (!this.state.dragPointer) {
	          if (this.state.options.horizontal) {
	            shouldStartDrag = Math.abs(pointer.distanceX) > this.state.options.minDistance;
	            shouldCancel = Math.abs(pointer.distanceY) > this.state.options.minDistance * this.state.options.cancelMultiplier;
	          } else {
	            shouldStartDrag = Math.abs(pointer.distanceY) > this.state.options.minDistance;
	            shouldCancel = Math.abs(pointer.distanceX) > this.state.options.minDistance * this.state.options.cancelMultiplier;
	          }
	
	          if (shouldStartDrag) {
	            // Create a new pointer representing this drag, starting at this point where the drag started.
	            this.state.dragPointer = makeStartPointer(ev);
	            updatePointerState(ev, this.state.dragPointer);
	            this.dispatchEvent(ev, '$md.dragstart', this.state.dragPointer);
	
	          } else if (shouldCancel) {
	            this.cancel();
	          }
	        } else {
	          this.dispatchDragMove(ev);
	        }
	      },
	      // Only dispatch dragmove events every frame; any more is unnecessary
	      dispatchDragMove: $$rAF.throttle(function (ev) {
	        // Make sure the drag didn't stop while waiting for the next frame
	        if (this.state.isRunning) {
	          updatePointerState(ev, this.state.dragPointer);
	          this.dispatchEvent(ev, '$md.drag', this.state.dragPointer);
	        }
	      }),
	      onEnd: function (ev, pointer) {
	        if (this.state.dragPointer) {
	          updatePointerState(ev, this.state.dragPointer);
	          this.dispatchEvent(ev, '$md.dragend', this.state.dragPointer);
	        }
	      }
	    })
	
	    /*
	     * The swipe handler will dispatch a swipe event if, on the end of a touch,
	     * the velocity and distance were high enough.
	     */
	    .handler('swipe', {
	      options: {
	        minVelocity: 0.65,
	        minDistance: 10
	      },
	      onEnd: function (ev, pointer) {
	        var eventType;
	
	        if (Math.abs(pointer.velocityX) > this.state.options.minVelocity &&
	          Math.abs(pointer.distanceX) > this.state.options.minDistance) {
	          eventType = pointer.directionX == 'left' ? '$md.swipeleft' : '$md.swiperight';
	          this.dispatchEvent(ev, eventType);
	        }
	        else if (Math.abs(pointer.velocityY) > this.state.options.minVelocity &&
	          Math.abs(pointer.distanceY) > this.state.options.minDistance) {
	          eventType = pointer.directionY == 'up' ? '$md.swipeup' : '$md.swipedown';
	          this.dispatchEvent(ev, eventType);
	        }
	      }
	    });
	
	  function getTouchAction() {
	    var testEl = document.createElement('div');
	    var vendorPrefixes = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	
	    for (var i = 0; i < vendorPrefixes.length; i++) {
	      var prefix = vendorPrefixes[i];
	      var property = prefix ? prefix + 'TouchAction' : 'touchAction';
	      if (angular.isDefined(testEl.style[property])) {
	        return property;
	      }
	    }
	  }
	
	}
	
	/**
	 * MdGestureHandler
	 * A GestureHandler is an object which is able to dispatch custom dom events
	 * based on native dom {touch,pointer,mouse}{start,move,end} events.
	 *
	 * A gesture will manage its lifecycle through the start,move,end, and cancel
	 * functions, which are called by native dom events.
	 *
	 * A gesture has the concept of 'options' (eg a swipe's required velocity), which can be
	 * overridden by elements registering through $mdGesture.register()
	 */
	function GestureHandler (name) {
	  this.name = name;
	  this.state = {};
	}
	
	function MdGestureHandler() {
	  var hasJQuery =  (typeof window.jQuery !== 'undefined') && (angular.element === window.jQuery);
	
	  GestureHandler.prototype = {
	    options: {},
	    // jQuery listeners don't work with custom DOMEvents, so we have to dispatch events
	    // differently when jQuery is loaded
	    dispatchEvent: hasJQuery ?  jQueryDispatchEvent : nativeDispatchEvent,
	
	    // These are overridden by the registered handler
	    onSetup: angular.noop,
	    onCleanup: angular.noop,
	    onStart: angular.noop,
	    onMove: angular.noop,
	    onEnd: angular.noop,
	    onCancel: angular.noop,
	
	    // onStart sets up a new state for the handler, which includes options from the
	    // nearest registered parent element of ev.target.
	    start: function (ev, pointer) {
	      if (this.state.isRunning) return;
	      var parentTarget = this.getNearestParent(ev.target);
	      // Get the options from the nearest registered parent
	      var parentTargetOptions = parentTarget && parentTarget.$mdGesture[this.name] || {};
	
	      this.state = {
	        isRunning: true,
	        // Override the default options with the nearest registered parent's options
	        options: angular.extend({}, this.options, parentTargetOptions),
	        // Pass in the registered parent node to the state so the onStart listener can use
	        registeredParent: parentTarget
	      };
	      this.onStart(ev, pointer);
	    },
	    move: function (ev, pointer) {
	      if (!this.state.isRunning) return;
	      this.onMove(ev, pointer);
	    },
	    end: function (ev, pointer) {
	      if (!this.state.isRunning) return;
	      this.onEnd(ev, pointer);
	      this.state.isRunning = false;
	    },
	    cancel: function (ev, pointer) {
	      this.onCancel(ev, pointer);
	      this.state = {};
	    },
	
	    // Find and return the nearest parent element that has been registered to
	    // listen for this handler via $mdGesture.register(element, 'handlerName').
	    getNearestParent: function (node) {
	      var current = node;
	      while (current) {
	        if ((current.$mdGesture || {})[this.name]) {
	          return current;
	        }
	        current = current.parentNode;
	      }
	      return null;
	    },
	
	    // Called from $mdGesture.register when an element registers itself with a handler.
	    // Store the options the user gave on the DOMElement itself. These options will
	    // be retrieved with getNearestParent when the handler starts.
	    registerElement: function (element, options) {
	      var self = this;
	      element[0].$mdGesture = element[0].$mdGesture || {};
	      element[0].$mdGesture[this.name] = options || {};
	      element.on('$destroy', onDestroy);
	
	      self.onSetup(element, options || {});
	
	      return onDestroy;
	
	      function onDestroy() {
	        delete element[0].$mdGesture[self.name];
	        element.off('$destroy', onDestroy);
	
	        self.onCleanup(element, options || {});
	      }
	    }
	  };
	
	  return GestureHandler;
	
	  /*
	   * Dispatch an event with jQuery
	   * TODO: Make sure this sends bubbling events
	   *
	   * @param srcEvent the original DOM touch event that started this.
	   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
	   * @param eventPointer the pointer object that matches this event.
	   */
	  function jQueryDispatchEvent(srcEvent, eventType, eventPointer) {
	    eventPointer = eventPointer || pointer;
	    var eventObj = new angular.element.Event(eventType);
	
	    eventObj.$material = true;
	    eventObj.pointer = eventPointer;
	    eventObj.srcEvent = srcEvent;
	
	    angular.extend(eventObj, {
	      clientX: eventPointer.x,
	      clientY: eventPointer.y,
	      screenX: eventPointer.x,
	      screenY: eventPointer.y,
	      pageX: eventPointer.x,
	      pageY: eventPointer.y,
	      ctrlKey: srcEvent.ctrlKey,
	      altKey: srcEvent.altKey,
	      shiftKey: srcEvent.shiftKey,
	      metaKey: srcEvent.metaKey
	    });
	    angular.element(eventPointer.target).trigger(eventObj);
	  }
	
	  /**
	   * NOTE: nativeDispatchEvent is very performance sensitive.
	   * @param srcEvent the original DOM touch event that started this.
	   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
	   * @param eventPointer the pointer object that matches this event.
	   */
	  function nativeDispatchEvent(srcEvent, eventType, eventPointer) {
	    eventPointer = eventPointer || pointer;
	    var eventObj;
	
	    if (eventType === 'click' || eventType === 'mouseup' || eventType === 'mousedown' ) {
	      eventObj = document.createEvent('MouseEvents');
	      eventObj.initMouseEvent(
	        eventType, true, true, window, srcEvent.detail,
	        eventPointer.x, eventPointer.y, eventPointer.x, eventPointer.y,
	        srcEvent.ctrlKey, srcEvent.altKey, srcEvent.shiftKey, srcEvent.metaKey,
	        srcEvent.button, srcEvent.relatedTarget || null
	      );
	
	    } else {
	      eventObj = document.createEvent('CustomEvent');
	      eventObj.initCustomEvent(eventType, true, true, {});
	    }
	    eventObj.$material = true;
	    eventObj.pointer = eventPointer;
	    eventObj.srcEvent = srcEvent;
	    eventPointer.target.dispatchEvent(eventObj);
	  }
	
	}
	
	/**
	 * Attach Gestures: hook document and check shouldHijack clicks
	 * @ngInject
	 */
	function attachToDocument( $mdGesture, $$MdGestureHandler ) {
	  if (disableAllGestures) {
	    return;
	  }
	
	  // Polyfill document.contains for IE11.
	  // TODO: move to util
	  document.contains || (document.contains = function (node) {
	    return document.body.contains(node);
	  });
	
	  if (!isInitialized && $mdGesture.isHijackingClicks ) {
	    /*
	     * If hijack clicks is true, we preventDefault any click that wasn't
	     * sent by AngularJS Material. This is because on older Android & iOS, a false, or 'ghost',
	     * click event will be sent ~400ms after a touchend event happens.
	     * The only way to know if this click is real is to prevent any normal
	     * click events, and add a flag to events sent by material so we know not to prevent those.
	     *
	     * Two exceptions to click events that should be prevented are:
	     *  - click events sent by the keyboard (eg form submit)
	     *  - events that originate from an Ionic app
	     */
	    document.addEventListener('click'    , clickHijacker     , true);
	    document.addEventListener('mouseup'  , mouseInputHijacker, true);
	    document.addEventListener('mousedown', mouseInputHijacker, true);
	    document.addEventListener('focus'    , mouseInputHijacker, true);
	
	    isInitialized = true;
	  }
	
	  function mouseInputHijacker(ev) {
	    var isKeyClick = !ev.clientX && !ev.clientY;
	
	    if (
	      !isKeyClick &&
	      !ev.$material &&
	      !ev.isIonicTap &&
	      !isInputEventFromLabelClick(ev) &&
	      (ev.type !== 'mousedown' || (!canFocus(ev.target) && !canFocus(document.activeElement)))
	    ) {
	      ev.preventDefault();
	      ev.stopPropagation();
	    }
	  }
	
	  function clickHijacker(ev) {
	    var isKeyClick = ev.clientX === 0 && ev.clientY === 0;
	    var isSubmitEvent = ev.target && ev.target.type === 'submit';
	    if (!isKeyClick && !ev.$material && !ev.isIonicTap
	      && !isInputEventFromLabelClick(ev)
	      && !isSubmitEvent) {
	      ev.preventDefault();
	      ev.stopPropagation();
	      lastLabelClickPos = null;
	    } else {
	      lastLabelClickPos = null;
	      if (ev.target.tagName.toLowerCase() == 'label') {
	        lastLabelClickPos = {x: ev.x, y: ev.y};
	      }
	    }
	  }
	
	
	  // Listen to all events to cover all platforms.
	  var START_EVENTS = 'mousedown touchstart pointerdown';
	  var MOVE_EVENTS = 'mousemove touchmove pointermove';
	  var END_EVENTS = 'mouseup mouseleave touchend touchcancel pointerup pointercancel';
	
	  angular.element(document)
	    .on(START_EVENTS, gestureStart)
	    .on(MOVE_EVENTS, gestureMove)
	    .on(END_EVENTS, gestureEnd)
	    // For testing
	    .on('$$mdGestureReset', function gestureClearCache () {
	      lastPointer = pointer = null;
	    });
	
	  /*
	   * When a DOM event happens, run all registered gesture handlers' lifecycle
	   * methods which match the DOM event.
	   * Eg when a 'touchstart' event happens, runHandlers('start') will call and
	   * run `handler.cancel()` and `handler.start()` on all registered handlers.
	   */
	  function runHandlers(handlerEvent, event) {
	    var handler;
	    for (var name in HANDLERS) {
	      handler = HANDLERS[name];
	      if( handler instanceof $$MdGestureHandler ) {
	
	        if (handlerEvent === 'start') {
	          // Run cancel to reset any handlers' state
	          handler.cancel();
	        }
	        handler[handlerEvent](event, pointer);
	
	      }
	    }
	  }
	
	  /*
	   * gestureStart vets if a start event is legitimate (and not part of a 'ghost click' from iOS/Android)
	   * If it is legitimate, we initiate the pointer state and mark the current pointer's type
	   * For example, for a touchstart event, mark the current pointer as a 'touch' pointer, so mouse events
	   * won't effect it.
	   */
	  function gestureStart(ev) {
	    // If we're already touched down, abort
	    if (pointer) return;
	
	    var now = +Date.now();
	
	    // iOS & old android bug: after a touch event, a click event is sent 350 ms later.
	    // If <400ms have passed, don't allow an event of a different type than the previous event
	    if (lastPointer && !typesMatch(ev, lastPointer) && (now - lastPointer.endTime < 1500)) {
	      return;
	    }
	
	    pointer = makeStartPointer(ev);
	
	    runHandlers('start', ev);
	  }
	  /*
	   * If a move event happens of the right type, update the pointer and run all the move handlers.
	   * "of the right type": if a mousemove happens but our pointer started with a touch event, do nothing.
	   */
	  function gestureMove(ev) {
	    if (!pointer || !typesMatch(ev, pointer)) return;
	
	    updatePointerState(ev, pointer);
	    runHandlers('move', ev);
	  }
	  /*
	   * If an end event happens of the right type, update the pointer, run endHandlers, and save the pointer as 'lastPointer'
	   */
	  function gestureEnd(ev) {
	    if (!pointer || !typesMatch(ev, pointer)) return;
	
	    updatePointerState(ev, pointer);
	    pointer.endTime = +Date.now();
	
	    if (ev.type !== 'pointercancel') {
	      runHandlers('end', ev);
	    }
	
	    lastPointer = pointer;
	    pointer = null;
	  }
	
	}
	
	// ********************
	// Module Functions
	// ********************
	
	/*
	 * Initiate the pointer. x, y, and the pointer's type.
	 */
	function makeStartPointer(ev) {
	  var point = getEventPoint(ev);
	  var startPointer = {
	    startTime: +Date.now(),
	    target: ev.target,
	    // 'p' for pointer events, 'm' for mouse, 't' for touch
	    type: ev.type.charAt(0)
	  };
	  startPointer.startX = startPointer.x = point.pageX;
	  startPointer.startY = startPointer.y = point.pageY;
	  return startPointer;
	}
	
	/*
	 * return whether the pointer's type matches the event's type.
	 * Eg if a touch event happens but the pointer has a mouse type, return false.
	 */
	function typesMatch(ev, pointer) {
	  return ev && pointer && ev.type.charAt(0) === pointer.type;
	}
	
	/**
	 * Gets whether the given event is an input event that was caused by clicking on an
	 * associated label element.
	 *
	 * This is necessary because the browser will, upon clicking on a label element, fire an
	 * *extra* click event on its associated input (if any). mdGesture is able to flag the label
	 * click as with `$material` correctly, but not the second input click.
	 *
	 * In order to determine whether an input event is from a label click, we compare the (x, y) for
	 * the event to the (x, y) for the most recent label click (which is cleared whenever a non-label
	 * click occurs). Unfortunately, there are no event properties that tie the input and the label
	 * together (such as relatedTarget).
	 *
	 * @param {MouseEvent} event
	 * @returns {boolean}
	 */
	function isInputEventFromLabelClick(event) {
	  return lastLabelClickPos
	      && lastLabelClickPos.x == event.x
	      && lastLabelClickPos.y == event.y;
	}
	
	/*
	 * Update the given pointer based upon the given DOMEvent.
	 * Distance, velocity, direction, duration, etc
	 */
	function updatePointerState(ev, pointer) {
	  var point = getEventPoint(ev);
	  var x = pointer.x = point.pageX;
	  var y = pointer.y = point.pageY;
	
	  pointer.distanceX = x - pointer.startX;
	  pointer.distanceY = y - pointer.startY;
	  pointer.distance = Math.sqrt(
	    pointer.distanceX * pointer.distanceX + pointer.distanceY * pointer.distanceY
	  );
	
	  pointer.directionX = pointer.distanceX > 0 ? 'right' : pointer.distanceX < 0 ? 'left' : '';
	  pointer.directionY = pointer.distanceY > 0 ? 'down' : pointer.distanceY < 0 ? 'up' : '';
	
	  pointer.duration = +Date.now() - pointer.startTime;
	  pointer.velocityX = pointer.distanceX / pointer.duration;
	  pointer.velocityY = pointer.distanceY / pointer.duration;
	}
	
	/**
	 * Normalize the point where the DOM event happened whether it's touch or mouse.
	 * @returns point event obj with pageX and pageY on it.
	 */
	function getEventPoint(ev) {
	  ev = ev.originalEvent || ev; // support jQuery events
	  return (ev.touches && ev.touches[0]) ||
	    (ev.changedTouches && ev.changedTouches[0]) ||
	    ev;
	}
	
	/** Checks whether an element can be focused. */
	function canFocus(element) {
	  return (
	    !!element &&
	    element.getAttribute('tabindex') !== '-1' &&
	    !element.hasAttribute('disabled') &&
	    (
	      element.hasAttribute('tabindex') ||
	      element.hasAttribute('href') ||
	      element.isContentEditable ||
	      ['INPUT', 'SELECT', 'BUTTON', 'TEXTAREA', 'VIDEO', 'AUDIO'].indexOf(element.nodeName) !== -1
	    )
	  );
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.interaction
	 * @description
	 * User interaction detection to provide proper accessibility.
	 */
	MdInteractionService.$inject = ["$timeout", "$mdUtil"];
	angular
	  .module('material.core.interaction', [])
	  .service('$mdInteraction', MdInteractionService);
	
	
	/**
	 * @ngdoc service
	 * @name $mdInteraction
	 * @module material.core.interaction
	 *
	 * @description
	 *
	 * Service which keeps track of the last interaction type and validates them for several browsers.
	 * The service hooks into the document's body and listens for touch, mouse and keyboard events.
	 *
	 * The most recent interaction type can be retrieved by calling the `getLastInteractionType` method.
	 *
	 * Here is an example markup for using the interaction service.
	 *
	 * <hljs lang="js">
	 *   var lastType = $mdInteraction.getLastInteractionType();
	 *
	 *   if (lastType === 'keyboard') {
	 *     // We only restore the focus for keyboard users.
	 *     restoreFocus();
	 *   }
	 * </hljs>
	 *
	 */
	function MdInteractionService($timeout, $mdUtil) {
	  this.$timeout = $timeout;
	  this.$mdUtil = $mdUtil;
	
	  this.bodyElement = angular.element(document.body);
	  this.isBuffering = false;
	  this.bufferTimeout = null;
	  this.lastInteractionType = null;
	  this.lastInteractionTime = null;
	
	  // Type Mappings for the different events
	  // There will be three three interaction types
	  // `keyboard`, `mouse` and `touch`
	  // type `pointer` will be evaluated in `pointerMap` for IE Browser events
	  this.inputEventMap = {
	    'keydown': 'keyboard',
	    'mousedown': 'mouse',
	    'mouseenter': 'mouse',
	    'touchstart': 'touch',
	    'pointerdown': 'pointer',
	    'MSPointerDown': 'pointer'
	  };
	
	  // IE PointerDown events will be validated in `touch` or `mouse`
	  // Index numbers referenced here: https://msdn.microsoft.com/library/windows/apps/hh466130.aspx
	  this.iePointerMap = {
	    2: 'touch',
	    3: 'touch',
	    4: 'mouse'
	  };
	
	  this.initializeEvents();
	}
	
	/**
	 * Initializes the interaction service, by registering all interaction events to the
	 * body element.
	 */
	MdInteractionService.prototype.initializeEvents = function() {
	  // IE browsers can also trigger pointer events, which also leads to an interaction.
	  var pointerEvent = 'MSPointerEvent' in window ? 'MSPointerDown' : 'PointerEvent' in window ? 'pointerdown' : null;
	
	  this.bodyElement.on('keydown mousedown', this.onInputEvent.bind(this));
	
	  if ('ontouchstart' in document.documentElement) {
	    this.bodyElement.on('touchstart', this.onBufferInputEvent.bind(this));
	  }
	
	  if (pointerEvent) {
	    this.bodyElement.on(pointerEvent, this.onInputEvent.bind(this));
	  }
	
	};
	
	/**
	 * Event listener for normal interaction events, which should be tracked.
	 * @param event {MouseEvent|KeyboardEvent|PointerEvent|TouchEvent}
	 */
	MdInteractionService.prototype.onInputEvent = function(event) {
	  if (this.isBuffering) {
	    return;
	  }
	
	  var type = this.inputEventMap[event.type];
	
	  if (type === 'pointer') {
	    type = this.iePointerMap[event.pointerType] || event.pointerType;
	  }
	
	  this.lastInteractionType = type;
	  this.lastInteractionTime = this.$mdUtil.now();
	};
	
	/**
	 * Event listener for interaction events which should be buffered (touch events).
	 * @param event {TouchEvent}
	 */
	MdInteractionService.prototype.onBufferInputEvent = function(event) {
	  this.$timeout.cancel(this.bufferTimeout);
	
	  this.onInputEvent(event);
	  this.isBuffering = true;
	
	  // The timeout of 650ms is needed to delay the touchstart, because otherwise the touch will call
	  // the `onInput` function multiple times.
	  this.bufferTimeout = this.$timeout(function() {
	    this.isBuffering = false;
	  }.bind(this), 650, false);
	
	};
	
	/**
	 * @ngdoc method
	 * @name $mdInteraction#getLastInteractionType
	 * @description Retrieves the last interaction type triggered in body.
	 * @returns {string|null} Last interaction type.
	 */
	MdInteractionService.prototype.getLastInteractionType = function() {
	  return this.lastInteractionType;
	};
	
	/**
	 * @ngdoc method
	 * @name $mdInteraction#isUserInvoked
	 * @description Method to detect whether any interaction happened recently or not.
	 * @param {number=} checkDelay Time to check for any interaction to have been triggered.
	 * @returns {boolean} Whether there was any interaction or not.
	 */
	MdInteractionService.prototype.isUserInvoked = function(checkDelay) {
	  var delay = angular.isNumber(checkDelay) ? checkDelay : 15;
	
	  // Check for any interaction to be within the specified check time.
	  return this.lastInteractionTime >= this.$mdUtil.now() - delay;
	};
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core')
	  .provider('$$interimElement', InterimElementProvider);
	
	/*
	 * @ngdoc service
	 * @name $$interimElement
	 * @module material.core
	 *
	 * @description
	 *
	 * Factory that constructs `$$interimElement.$service` services.
	 * Used internally in material design for elements that appear on screen temporarily.
	 * The service provides a promise-like API for interacting with the temporary
	 * elements.
	 *
	 * ```js
	 * app.service('$mdToast', function($$interimElement) {
	 *   var $mdToast = $$interimElement(toastDefaultOptions);
	 *   return $mdToast;
	 * });
	 * ```
	 * @param {object=} defaultOptions Options used by default for the `show` method on the service.
	 *
	 * @returns {$$interimElement.$service}
	 *
	 */
	
	function InterimElementProvider() {
	  InterimElementFactory.$inject = ["$document", "$q", "$rootScope", "$timeout", "$rootElement", "$animate", "$mdUtil", "$mdCompiler", "$mdTheming", "$injector", "$exceptionHandler"];
	  createInterimElementProvider.$get = InterimElementFactory;
	  return createInterimElementProvider;
	
	  /**
	   * Returns a new provider which allows configuration of a new interimElement
	   * service. Allows configuration of default options & methods for options,
	   * as well as configuration of 'preset' methods (eg dialog.basic(): basic is a preset method)
	   */
	  function createInterimElementProvider(interimFactoryName) {
	    factory.$inject = ["$$interimElement", "$injector"];
	    var EXPOSED_METHODS = ['onHide', 'onShow', 'onRemove'];
	
	    var customMethods = {};
	    var providerConfig = {
	      presets: {}
	    };
	
	    var provider = {
	      setDefaults: setDefaults,
	      addPreset: addPreset,
	      addMethod: addMethod,
	      $get: factory
	    };
	
	    /**
	     * all interim elements will come with the 'build' preset
	     */
	    provider.addPreset('build', {
	      methods: ['controller', 'controllerAs', 'resolve', 'multiple',
	        'template', 'templateUrl', 'themable', 'transformTemplate', 'parent', 'contentElement']
	    });
	
	    return provider;
	
	    /**
	     * Save the configured defaults to be used when the factory is instantiated
	     */
	    function setDefaults(definition) {
	      providerConfig.optionsFactory = definition.options;
	      providerConfig.methods = (definition.methods || []).concat(EXPOSED_METHODS);
	      return provider;
	    }
	
	    /**
	     * Add a method to the factory that isn't specific to any interim element operations
	     */
	
	    function addMethod(name, fn) {
	      customMethods[name] = fn;
	      return provider;
	    }
	
	    /**
	     * Save the configured preset to be used when the factory is instantiated
	     */
	    function addPreset(name, definition) {
	      definition = definition || {};
	      definition.methods = definition.methods || [];
	      definition.options = definition.options || function() { return {}; };
	
	      if (/^cancel|hide|show$/.test(name)) {
	        throw new Error("Preset '" + name + "' in " + interimFactoryName + " is reserved!");
	      }
	      if (definition.methods.indexOf('_options') > -1) {
	        throw new Error("Method '_options' in " + interimFactoryName + " is reserved!");
	      }
	      providerConfig.presets[name] = {
	        methods: definition.methods.concat(EXPOSED_METHODS),
	        optionsFactory: definition.options,
	        argOption: definition.argOption
	      };
	      return provider;
	    }
	
	    function addPresetMethod(presetName, methodName, method) {
	      providerConfig.presets[presetName][methodName] = method;
	    }
	
	    /**
	     * Create a factory that has the given methods & defaults implementing interimElement
	     */
	    /* @ngInject */
	    function factory($$interimElement, $injector) {
	      var defaultMethods;
	      var defaultOptions;
	      var interimElementService = $$interimElement();
	
	      /*
	       * publicService is what the developer will be using.
	       * It has methods hide(), cancel(), show(), build(), and any other
	       * presets which were set during the config phase.
	       */
	      var publicService = {
	        hide: interimElementService.hide,
	        cancel: interimElementService.cancel,
	        show: showInterimElement,
	
	        // Special internal method to destroy an interim element without animations
	        // used when navigation changes causes a $scope.$destroy() action
	        destroy : destroyInterimElement
	      };
	
	
	      defaultMethods = providerConfig.methods || [];
	      // This must be invoked after the publicService is initialized
	      defaultOptions = invokeFactory(providerConfig.optionsFactory, {});
	
	      // Copy over the simple custom methods
	      angular.forEach(customMethods, function(fn, name) {
	        publicService[name] = fn;
	      });
	
	      angular.forEach(providerConfig.presets, function(definition, name) {
	        var presetDefaults = invokeFactory(definition.optionsFactory, {});
	        var presetMethods = (definition.methods || []).concat(defaultMethods);
	
	        // Every interimElement built with a preset has a field called `$type`,
	        // which matches the name of the preset.
	        // Eg in preset 'confirm', options.$type === 'confirm'
	        angular.extend(presetDefaults, { $type: name });
	
	        // This creates a preset class which has setter methods for every
	        // method given in the `.addPreset()` function, as well as every
	        // method given in the `.setDefaults()` function.
	        //
	        // @example
	        // .setDefaults({
	        //   methods: ['hasBackdrop', 'clickOutsideToClose', 'escapeToClose', 'targetEvent'],
	        //   options: dialogDefaultOptions
	        // })
	        // .addPreset('alert', {
	        //   methods: ['title', 'ok'],
	        //   options: alertDialogOptions
	        // })
	        //
	        // Set values will be passed to the options when interimElement.show() is called.
	        function Preset(opts) {
	          this._options = angular.extend({}, presetDefaults, opts);
	        }
	        angular.forEach(presetMethods, function(name) {
	          Preset.prototype[name] = function(value) {
	            this._options[name] = value;
	            return this;
	          };
	        });
	
	        // Create shortcut method for one-linear methods
	        if (definition.argOption) {
	          var methodName = 'show' + name.charAt(0).toUpperCase() + name.slice(1);
	          publicService[methodName] = function(arg) {
	            var config = publicService[name](arg);
	            return publicService.show(config);
	          };
	        }
	
	        // eg $mdDialog.alert() will return a new alert preset
	        publicService[name] = function(arg) {
	          // If argOption is supplied, eg `argOption: 'content'`, then we assume
	          // if the argument is not an options object then it is the `argOption` option.
	          //
	          // @example `$mdToast.simple('hello')` // sets options.content to hello
	          //                                     // because argOption === 'content'
	          if (arguments.length && definition.argOption &&
	              !angular.isObject(arg) && !angular.isArray(arg))  {
	
	            return (new Preset())[definition.argOption](arg);
	
	          } else {
	            return new Preset(arg);
	          }
	
	        };
	      });
	
	      return publicService;
	
	      /**
	       *
	       */
	      function showInterimElement(opts) {
	        // opts is either a preset which stores its options on an _options field,
	        // or just an object made up of options
	        opts = opts || { };
	        if (opts._options) opts = opts._options;
	
	        return interimElementService.show(
	          angular.extend({}, defaultOptions, opts)
	        );
	      }
	
	      /**
	       *  Special method to hide and destroy an interimElement WITHOUT
	       *  any 'leave` or hide animations ( an immediate force hide/remove )
	       *
	       *  NOTE: This calls the onRemove() subclass method for each component...
	       *  which must have code to respond to `options.$destroy == true`
	       */
	      function destroyInterimElement(opts) {
	          return interimElementService.destroy(opts);
	      }
	
	      /**
	       * Helper to call $injector.invoke with a local of the factory name for
	       * this provider.
	       * If an $mdDialog is providing options for a dialog and tries to inject
	       * $mdDialog, a circular dependency error will happen.
	       * We get around that by manually injecting $mdDialog as a local.
	       */
	      function invokeFactory(factory, defaultVal) {
	        var locals = {};
	        locals[interimFactoryName] = publicService;
	        return $injector.invoke(factory || function() { return defaultVal; }, {}, locals);
	      }
	
	    }
	
	  }
	
	  /* @ngInject */
	  function InterimElementFactory($document, $q, $rootScope, $timeout, $rootElement, $animate,
	                                 $mdUtil, $mdCompiler, $mdTheming, $injector, $exceptionHandler) {
	    return function createInterimElementService() {
	      var SHOW_CANCELLED = false;
	
	      /*
	       * @ngdoc service
	       * @name $$interimElement.$service
	       *
	       * @description
	       * A service used to control inserting and removing an element into the DOM.
	       *
	       */
	
	      var service;
	
	      var showPromises = []; // Promises for the interim's which are currently opening.
	      var hidePromises = []; // Promises for the interim's which are currently hiding.
	      var showingInterims = []; // Interim elements which are currently showing up.
	
	      // Publish instance $$interimElement service;
	      // ... used as $mdDialog, $mdToast, $mdMenu, and $mdSelect
	
	      return service = {
	        show: show,
	        hide: waitForInterim(hide),
	        cancel: waitForInterim(cancel),
	        destroy : destroy,
	        $injector_: $injector
	      };
	
	      /*
	       * @ngdoc method
	       * @name $$interimElement.$service#show
	       * @kind function
	       *
	       * @description
	       * Adds the `$interimElement` to the DOM and returns a special promise that will be resolved or rejected
	       * with hide or cancel, respectively. To external cancel/hide, developers should use the
	       *
	       * @param {*} options is hashMap of settings
	       * @returns a Promise
	       *
	       */
	      function show(options) {
	        options = options || {};
	        var interimElement = new InterimElement(options || {});
	
	        // When an interim element is currently showing, we have to cancel it.
	        // Just hiding it, will resolve the InterimElement's promise, the promise should be
	        // rejected instead.
	        var hideAction = options.multiple ? $q.resolve() : $q.all(showPromises);
	
	        if (!options.multiple) {
	          // Wait for all opening interim's to finish their transition.
	          hideAction = hideAction.then(function() {
	            // Wait for all closing and showing interim's to be completely closed.
	            var promiseArray = hidePromises.concat(showingInterims.map(service.cancel));
	            return $q.all(promiseArray);
	          });
	        }
	
	        var showAction = hideAction.then(function() {
	
	          return interimElement
	            .show()
	            .catch(function(reason) { return reason; })
	            .finally(function() {
	              showPromises.splice(showPromises.indexOf(showAction), 1);
	              showingInterims.push(interimElement);
	            });
	
	        });
	
	        showPromises.push(showAction);
	
	        // In AngularJS 1.6+, exceptions inside promises will cause a rejection. We need to handle
	        // the rejection and only log it if it's an error.
	        interimElement.deferred.promise.catch(function(fault) {
	          if (fault instanceof Error) {
	            $exceptionHandler(fault);
	          }
	
	          return fault;
	        });
	
	        // Return a promise that will be resolved when the interim
	        // element is hidden or cancelled...
	        return interimElement.deferred.promise;
	      }
	
	      /*
	       * @ngdoc method
	       * @name $$interimElement.$service#hide
	       * @kind function
	       *
	       * @description
	       * Removes the `$interimElement` from the DOM and resolves the promise returned from `show`
	       *
	       * @param {*} resolveParam Data to resolve the promise with
	       * @returns a Promise that will be resolved after the element has been removed.
	       *
	       */
	      function hide(reason, options) {
	        options = options || {};
	
	        if (options.closeAll) {
	          // We have to make a shallow copy of the array, because otherwise the map will break.
	          return $q.all(showingInterims.slice().reverse().map(closeElement));
	        } else if (options.closeTo !== undefined) {
	          return $q.all(showingInterims.slice(options.closeTo).map(closeElement));
	        }
	
	        // Hide the latest showing interim element.
	        return closeElement(showingInterims[showingInterims.length - 1]);
	
	        function closeElement(interim) {
	
	          var hideAction = interim
	            .remove(reason, false, options || { })
	            .catch(function(reason) { return reason; })
	            .finally(function() {
	              hidePromises.splice(hidePromises.indexOf(hideAction), 1);
	            });
	
	          showingInterims.splice(showingInterims.indexOf(interim), 1);
	          hidePromises.push(hideAction);
	
	          return interim.deferred.promise;
	        }
	      }
	
	      /*
	       * @ngdoc method
	       * @name $$interimElement.$service#cancel
	       * @kind function
	       *
	       * @description
	       * Removes the `$interimElement` from the DOM and rejects the promise returned from `show`
	       *
	       * @param {*} reason Data to reject the promise with
	       * @returns Promise that will be resolved after the element has been removed.
	       *
	       */
	      function cancel(reason, options) {
	        var interim = showingInterims.pop();
	        if (!interim) {
	          return $q.when(reason);
	        }
	
	        var cancelAction = interim
	          .remove(reason, true, options || {})
	          .catch(function(reason) { return reason; })
	          .finally(function() {
	            hidePromises.splice(hidePromises.indexOf(cancelAction), 1);
	          });
	
	        hidePromises.push(cancelAction);
	
	        // Since AngularJS 1.6.7, promises will be logged to $exceptionHandler when the promise
	        // is not handling the rejection. We create a pseudo catch handler, which will prevent the
	        // promise from being logged to the $exceptionHandler.
	        return interim.deferred.promise.catch(angular.noop);
	      }
	
	      /**
	       * Creates a function to wait for at least one interim element to be available.
	       * @param callbackFn Function to be used as callback
	       * @returns {Function}
	       */
	      function waitForInterim(callbackFn) {
	        return function() {
	          var fnArguments = arguments;
	
	          if (!showingInterims.length) {
	            // When there are still interim's opening, then wait for the first interim element to
	            // finish its open animation.
	            if (showPromises.length) {
	              return showPromises[0].finally(function () {
	                return callbackFn.apply(service, fnArguments);
	              });
	            }
	
	            return $q.when("No interim elements currently showing up.");
	          }
	
	          return callbackFn.apply(service, fnArguments);
	        };
	      }
	
	      /*
	       * Special method to quick-remove the interim element without animations
	       * Note: interim elements are in "interim containers"
	       */
	      function destroy(targetEl) {
	        var interim = !targetEl ? showingInterims.shift() : null;
	
	        var parentEl = angular.element(targetEl).length && angular.element(targetEl)[0].parentNode;
	
	        if (parentEl) {
	          // Try to find the interim in the stack which corresponds to the supplied DOM element.
	          var filtered = showingInterims.filter(function(entry) {
	            return entry.options.element[0] === parentEl;
	          });
	
	          // Note: This function might be called when the element already has been removed,
	          // in which case we won't find any matches.
	          if (filtered.length) {
	            interim = filtered[0];
	            showingInterims.splice(showingInterims.indexOf(interim), 1);
	          }
	        }
	
	        return interim ? interim.remove(SHOW_CANCELLED, false, { '$destroy': true }) :
	                         $q.when(SHOW_CANCELLED);
	      }
	
	      /*
	       * Internal Interim Element Object
	       * Used internally to manage the DOM element and related data
	       */
	      function InterimElement(options) {
	        var self, element, showAction = $q.when(true);
	
	        options = configureScopeAndTransitions(options);
	
	        return self = {
	          options : options,
	          deferred: $q.defer(),
	          show    : createAndTransitionIn,
	          remove  : transitionOutAndRemove
	        };
	
	        /**
	         * Compile, link, and show this interim element
	         * Use optional autoHided and transition-in effects
	         */
	        function createAndTransitionIn() {
	          return $q(function(resolve, reject) {
	
	            // Trigger onCompiling callback before the compilation starts.
	            // This is useful, when modifying options, which can be influenced by developers.
	            options.onCompiling && options.onCompiling(options);
	
	            compileElement(options)
	              .then(function( compiledData ) {
	                element = linkElement( compiledData, options );
	
	                // Expose the cleanup function from the compiler.
	                options.cleanupElement = compiledData.cleanup;
	
	                showAction = showElement(element, options, compiledData.controller)
	                  .then(resolve, rejectAll);
	              }).catch(rejectAll);
	
	            function rejectAll(fault) {
	              // Force the '$md<xxx>.show()' promise to reject
	              self.deferred.reject(fault);
	
	              // Continue rejection propagation
	              reject(fault);
	            }
	          });
	        }
	
	        /**
	         * After the show process has finished/rejected:
	         * - announce 'removing',
	         * - perform the transition-out, and
	         * - perform optional clean up scope.
	         */
	        function transitionOutAndRemove(response, isCancelled, opts) {
	
	          // abort if the show() and compile failed
	          if ( !element ) return $q.when(false);
	
	          options = angular.extend(options || {}, opts || {});
	          options.cancelAutoHide && options.cancelAutoHide();
	          options.element.triggerHandler('$mdInterimElementRemove');
	
	          if ( options.$destroy === true ) {
	
	            return hideElement(options.element, options).then(function(){
	              (isCancelled && rejectAll(response)) || resolveAll(response);
	            });
	
	          } else {
	            $q.when(showAction).finally(function() {
	              hideElement(options.element, options).then(function() {
	                isCancelled ? rejectAll(response) : resolveAll(response);
	              }, rejectAll);
	            });
	
	            return self.deferred.promise;
	          }
	
	
	          /**
	           * The `show()` returns a promise that will be resolved when the interim
	           * element is hidden or cancelled...
	           */
	          function resolveAll(response) {
	            self.deferred.resolve(response);
	          }
	
	          /**
	           * Force the '$md<xxx>.show()' promise to reject
	           */
	          function rejectAll(fault) {
	            self.deferred.reject(fault);
	          }
	        }
	
	        /**
	         * Prepare optional isolated scope and prepare $animate with default enter and leave
	         * transitions for the new element instance.
	         */
	        function configureScopeAndTransitions(options) {
	          options = options || { };
	          if ( options.template ) {
	            options.template = $mdUtil.processTemplate(options.template);
	          }
	
	          return angular.extend({
	            preserveScope: false,
	            cancelAutoHide : angular.noop,
	            scope: options.scope || $rootScope.$new(options.isolateScope),
	
	            /**
	             * Default usage to enable $animate to transition-in; can be easily overridden via 'options'
	             */
	            onShow: function transitionIn(scope, element, options) {
	              return $animate.enter(element, options.parent);
	            },
	
	            /**
	             * Default usage to enable $animate to transition-out; can be easily overridden via 'options'
	             */
	            onRemove: function transitionOut(scope, element) {
	              // Element could be undefined if a new element is shown before
	              // the old one finishes compiling.
	              return element && $animate.leave(element) || $q.when();
	            }
	          }, options );
	
	        }
	
	        /**
	         * Compile an element with a templateUrl, controller, and locals
	         */
	        function compileElement(options) {
	
	          var compiled = !options.skipCompile ? $mdCompiler.compile(options) : null;
	
	          return compiled || $q(function (resolve) {
	              resolve({
	                locals: {},
	                link: function () {
	                  return options.element;
	                }
	              });
	            });
	        }
	
	        /**
	         *  Link an element with compiled configuration
	         */
	        function linkElement(compileData, options){
	          angular.extend(compileData.locals, options);
	
	          var element = compileData.link(options.scope);
	
	          // Search for parent at insertion time, if not specified
	          options.element = element;
	          options.parent = findParent(element, options);
	          if (options.themable) $mdTheming(element);
	
	          return element;
	        }
	
	        /**
	         * Search for parent at insertion time, if not specified
	         */
	        function findParent(element, options) {
	          var parent = options.parent;
	
	          // Search for parent at insertion time, if not specified
	          if (angular.isFunction(parent)) {
	            parent = parent(options.scope, element, options);
	          } else if (angular.isString(parent)) {
	            parent = angular.element($document[0].querySelector(parent));
	          } else {
	            parent = angular.element(parent);
	          }
	
	          // If parent querySelector/getter function fails, or it's just null,
	          // find a default.
	          if (!(parent || {}).length) {
	            var el;
	            if ($rootElement[0] && $rootElement[0].querySelector) {
	              el = $rootElement[0].querySelector(':not(svg) > body');
	            }
	            if (!el) el = $rootElement[0];
	            if (el.nodeName == '#comment') {
	              el = $document[0].body;
	            }
	            return angular.element(el);
	          }
	
	          return parent;
	        }
	
	        /**
	         * If auto-hide is enabled, start timer and prepare cancel function
	         */
	        function startAutoHide() {
	          var autoHideTimer, cancelAutoHide = angular.noop;
	
	          if (options.hideDelay) {
	            autoHideTimer = $timeout(service.hide, options.hideDelay) ;
	            cancelAutoHide = function() {
	              $timeout.cancel(autoHideTimer);
	            };
	          }
	
	          // Cache for subsequent use
	          options.cancelAutoHide = function() {
	            cancelAutoHide();
	            options.cancelAutoHide = undefined;
	          };
	        }
	
	        /**
	         * Show the element ( with transitions), notify complete and start
	         * optional auto-Hide
	         */
	        function showElement(element, options, controller) {
	          // Trigger onShowing callback before the `show()` starts
	          var notifyShowing = options.onShowing || angular.noop;
	          // Trigger onComplete callback when the `show()` finishes
	          var notifyComplete = options.onComplete || angular.noop;
	
	          // Necessary for consistency between AngularJS 1.5 and 1.6.
	          try {
	            notifyShowing(options.scope, element, options, controller);
	          } catch (e) {
	            return $q.reject(e);
	          }
	
	          return $q(function (resolve, reject) {
	            try {
	              // Start transitionIn
	              $q.when(options.onShow(options.scope, element, options, controller))
	                .then(function () {
	                  notifyComplete(options.scope, element, options);
	                  startAutoHide();
	
	                  resolve(element);
	                }, reject);
	
	            } catch (e) {
	              reject(e.message);
	            }
	          });
	        }
	
	        function hideElement(element, options) {
	          var announceRemoving = options.onRemoving || angular.noop;
	
	          return $q(function (resolve, reject) {
	            try {
	              // Start transitionIn
	              var action = $q.when( options.onRemove(options.scope, element, options) || true );
	
	              // Trigger callback *before* the remove operation starts
	              announceRemoving(element, action);
	
	              if (options.$destroy) {
	                // For $destroy, onRemove should be synchronous
	                resolve(element);
	
	                if (!options.preserveScope && options.scope ) {
	                  // scope destroy should still be be done after the current digest is done
	                  action.then( function() { options.scope.$destroy(); });
	                }
	              } else {
	                // Wait until transition-out is done
	                action.then(function () {
	                  if (!options.preserveScope && options.scope ) {
	                    options.scope.$destroy();
	                  }
	
	                  resolve(element);
	                }, reject);
	              }
	            } catch (e) {
	              reject(e.message);
	            }
	          });
	        }
	
	      }
	    };
	
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  var $mdUtil, $interpolate, $log;
	
	  var SUFFIXES = /(-gt)?-(sm|md|lg|print)/g;
	  var WHITESPACE = /\s+/g;
	
	  var FLEX_OPTIONS = ['grow', 'initial', 'auto', 'none', 'noshrink', 'nogrow' ];
	  var LAYOUT_OPTIONS = ['row', 'column'];
	  var ALIGNMENT_MAIN_AXIS= [ "", "start", "center", "end", "stretch", "space-around", "space-between" ];
	  var ALIGNMENT_CROSS_AXIS= [ "", "start", "center", "end", "stretch" ];
	
	  var config = {
	    /**
	     * Enable directive attribute-to-class conversions
	     * Developers can use `<body md-layout-css />` to quickly
	     * disable the Layout directives and prohibit the injection of Layout classNames
	     */
	    enabled: true,
	
	    /**
	     * List of mediaQuery breakpoints and associated suffixes
	     *
	     *   [
	     *    { suffix: "sm", mediaQuery: "screen and (max-width: 599px)" },
	     *    { suffix: "md", mediaQuery: "screen and (min-width: 600px) and (max-width: 959px)" }
	     *   ]
	     */
	    breakpoints: []
	  };
	
	  registerLayoutAPI( angular.module('material.core.layout', ['ng']) );
	
	  /**
	   *   registerLayoutAPI()
	   *
	   *   The original AngularJS Material Layout solution used attribute selectors and CSS.
	   *
	   *  ```html
	   *  <div layout="column"> My Content </div>
	   *  ```
	   *
	   *  ```css
	   *  [layout] {
	   *    box-sizing: border-box;
	   *    display:flex;
	   *  }
	   *  [layout=column] {
	   *    flex-direction : column
	   *  }
	   *  ```
	   *
	   *  Use of attribute selectors creates significant performance impacts in some
	   *  browsers... mainly IE.
	   *
	   *  This module registers directives that allow the same layout attributes to be
	   *  interpreted and converted to class selectors. The directive will add equivalent classes to each element that
	   *  contains a Layout directive.
	   *
	   * ```html
	   *   <div layout="column" class="layout layout-column"> My Content </div>
	   *```
	   *
	   *  ```css
	   *  .layout {
	   *    box-sizing: border-box;
	   *    display:flex;
	   *  }
	   *  .layout-column {
	   *    flex-direction : column
	   *  }
	   *  ```
	   */
	  function registerLayoutAPI(module){
	    var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	    var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;
	
	    // NOTE: these are also defined in constants::MEDIA_PRIORITY and constants::MEDIA
	    var BREAKPOINTS     = [ "", "xs", "gt-xs", "sm", "gt-sm", "md", "gt-md", "lg", "gt-lg", "xl", "print" ];
	    var API_WITH_VALUES = [ "layout", "flex", "flex-order", "flex-offset", "layout-align" ];
	    var API_NO_VALUES   = [ "show", "hide", "layout-padding", "layout-margin" ];
	
	
	    // Build directive registration functions for the standard Layout API... for all breakpoints.
	    angular.forEach(BREAKPOINTS, function(mqb) {
	
	      // Attribute directives with expected, observable value(s)
	      angular.forEach( API_WITH_VALUES, function(name){
	        var fullName = mqb ? name + "-" + mqb : name;
	        module.directive( directiveNormalize(fullName), attributeWithObserve(fullName));
	      });
	
	      // Attribute directives with no expected value(s)
	      angular.forEach( API_NO_VALUES, function(name){
	        var fullName = mqb ? name + "-" + mqb : name;
	        module.directive( directiveNormalize(fullName), attributeWithoutValue(fullName));
	      });
	
	    });
	
	    // Register other, special directive functions for the Layout features:
	    module
	
	      .provider('$$mdLayout'     , function() {
	        // Publish internal service for Layouts
	        return {
	          $get : angular.noop,
	          validateAttributeValue : validateAttributeValue,
	          validateAttributeUsage : validateAttributeUsage,
	          /**
	           * Easy way to disable/enable the Layout API.
	           * When disabled, this stops all attribute-to-classname generations
	           */
	          disableLayouts  : function(isDisabled) {
	            config.enabled =  (isDisabled !== true);
	          }
	        };
	      })
	
	      .directive('mdLayoutCss'        , disableLayoutDirective )
	      .directive('ngCloak'            , buildCloakInterceptor('ng-cloak'))
	
	      .directive('layoutWrap'   , attributeWithoutValue('layout-wrap'))
	      .directive('layoutNowrap' , attributeWithoutValue('layout-nowrap'))
	      .directive('layoutNoWrap' , attributeWithoutValue('layout-no-wrap'))
	      .directive('layoutFill'   , attributeWithoutValue('layout-fill'))
	
	      // !! Deprecated attributes: use the `-lt` (aka less-than) notations
	
	      .directive('layoutLtMd'     , warnAttrNotSupported('layout-lt-md', true))
	      .directive('layoutLtLg'     , warnAttrNotSupported('layout-lt-lg', true))
	      .directive('flexLtMd'       , warnAttrNotSupported('flex-lt-md', true))
	      .directive('flexLtLg'       , warnAttrNotSupported('flex-lt-lg', true))
	
	      .directive('layoutAlignLtMd', warnAttrNotSupported('layout-align-lt-md'))
	      .directive('layoutAlignLtLg', warnAttrNotSupported('layout-align-lt-lg'))
	      .directive('flexOrderLtMd'  , warnAttrNotSupported('flex-order-lt-md'))
	      .directive('flexOrderLtLg'  , warnAttrNotSupported('flex-order-lt-lg'))
	      .directive('offsetLtMd'     , warnAttrNotSupported('flex-offset-lt-md'))
	      .directive('offsetLtLg'     , warnAttrNotSupported('flex-offset-lt-lg'))
	
	      .directive('hideLtMd'       , warnAttrNotSupported('hide-lt-md'))
	      .directive('hideLtLg'       , warnAttrNotSupported('hide-lt-lg'))
	      .directive('showLtMd'       , warnAttrNotSupported('show-lt-md'))
	      .directive('showLtLg'       , warnAttrNotSupported('show-lt-lg'))
	
	      // Determine if
	      .config( detectDisabledLayouts );
	
	    /**
	     * Converts snake_case to camelCase.
	     * Also there is special case for Moz prefix starting with upper case letter.
	     * @param name Name to normalize
	     */
	    function directiveNormalize(name) {
	      return name
	        .replace(PREFIX_REGEXP, '')
	        .replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	          return offset ? letter.toUpperCase() : letter;
	        });
	    }
	
	  }
	
	
	  /**
	    * Detect if any of the HTML tags has a [md-layouts-disabled] attribute;
	    * If yes, then immediately disable all layout API features
	    *
	    * Note: this attribute should be specified on either the HTML or BODY tags
	    */
	   /**
	    * @ngInject
	    */
	   function detectDisabledLayouts() {
	     var isDisabled = !!document.querySelector('[md-layouts-disabled]');
	     config.enabled = !isDisabled;
	   }
	
	  /**
	   * Special directive that will disable ALL Layout conversions of layout
	   * attribute(s) to classname(s).
	   *
	   * <link rel="stylesheet" href="angular-material.min.css">
	   * <link rel="stylesheet" href="angular-material.layout.css">
	   *
	   * <body md-layout-css>
	   *  ...
	   * </body>
	   *
	   * Note: Using md-layout-css directive requires the developer to load the Material
	   * Layout Attribute stylesheet (which only uses attribute selectors):
	   *
	   *       `angular-material.layout.css`
	   *
	   * Another option is to use the LayoutProvider to configure and disable the attribute
	   * conversions; this would obviate the use of the `md-layout-css` directive
	   *
	   */
	  function disableLayoutDirective() {
	    // Return a 1x-only, first-match attribute directive
	    config.enabled = false;
	
	    return {
	      restrict : 'A',
	      priority : '900'
	    };
	  }
	
	  /**
	   * Tail-hook ngCloak to delay the uncloaking while Layout transformers
	   * finish processing. Eliminates flicker with Material.Layouts
	   */
	  function buildCloakInterceptor(className) {
	    return [ '$timeout', function($timeout){
	      return {
	        restrict : 'A',
	        priority : -10,   // run after normal ng-cloak
	        compile  : function( element ) {
	          if (!config.enabled) return angular.noop;
	
	          // Re-add the cloak
	          element.addClass(className);
	
	          return function( scope, element ) {
	            // Wait while layout injectors configure, then uncloak
	            // NOTE: $rAF does not delay enough... and this is a 1x-only event,
	            //       $timeout is acceptable.
	            $timeout( function(){
	              element.removeClass(className);
	            }, 10, false);
	          };
	        }
	      };
	    }];
	  }
	
	
	  // *********************************************************************************
	  //
	  // These functions create registration functions for AngularJS Material Layout attribute directives
	  // This provides easy translation to switch AngularJS Material attribute selectors to
	  // CLASS selectors and directives; which has huge performance implications
	  // for IE Browsers
	  //
	  // *********************************************************************************
	
	  /**
	   * Creates a directive registration function where a possible dynamic attribute
	   * value will be observed/watched.
	   * @param {string} className attribute name; eg `layout-gt-md` with value ="row"
	   */
	  function attributeWithObserve(className) {
	
	    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
	      $mdUtil = _$mdUtil_;
	      $interpolate = _$interpolate_;
	      $log = _$log_;
	
	      return {
	        restrict: 'A',
	        compile: function(element, attr) {
	          var linkFn;
	          if (config.enabled) {
	            // immediately replace static (non-interpolated) invalid values...
	
	            validateAttributeUsage(className, attr, element, $log);
	
	            validateAttributeValue( className,
	              getNormalizedAttrValue(className, attr, ""),
	              buildUpdateFn(element, className, attr)
	            );
	
	            linkFn = translateWithValueToCssClass;
	          }
	
	          // Use for postLink to account for transforms after ng-transclude.
	          return linkFn || angular.noop;
	        }
	      };
	    }];
	
	    /**
	     * Add as transformed class selector(s), then
	     * remove the deprecated attribute selector
	     */
	    function translateWithValueToCssClass(scope, element, attrs) {
	      var updateFn = updateClassWithValue(element, className, attrs);
	      var unwatch = attrs.$observe(attrs.$normalize(className), updateFn);
	
	      updateFn(getNormalizedAttrValue(className, attrs, ""));
	      scope.$on("$destroy", function() { unwatch(); });
	    }
	  }
	
	  /**
	   * Creates a registration function for AngularJS Material Layout attribute directive.
	   * This is a `simple` transpose of attribute usage to class usage; where we ignore
	   * any attribute value
	   */
	  function attributeWithoutValue(className) {
	    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
	      $mdUtil = _$mdUtil_;
	      $interpolate = _$interpolate_;
	      $log = _$log_;
	
	      return {
	        restrict: 'A',
	        compile: function(element, attr) {
	          var linkFn;
	          if (config.enabled) {
	            // immediately replace static (non-interpolated) invalid values...
	
	            validateAttributeValue( className,
	              getNormalizedAttrValue(className, attr, ""),
	              buildUpdateFn(element, className, attr)
	            );
	
	            translateToCssClass(null, element);
	
	            // Use for postLink to account for transforms after ng-transclude.
	            linkFn = translateToCssClass;
	          }
	
	          return linkFn || angular.noop;
	        }
	      };
	    }];
	
	    /**
	     * Add as transformed class selector, then
	     * remove the deprecated attribute selector
	     */
	    function translateToCssClass(scope, element) {
	      element.addClass(className);
	    }
	  }
	
	
	
	  /**
	   * After link-phase, do NOT remove deprecated layout attribute selector.
	   * Instead watch the attribute so interpolated data-bindings to layout
	   * selectors will continue to be supported.
	   *
	   * $observe() the className and update with new class (after removing the last one)
	   *
	   * e.g. `layout="{{layoutDemo.direction}}"` will update...
	   *
	   * NOTE: The value must match one of the specified styles in the CSS.
	   * For example `flex-gt-md="{{size}}`  where `scope.size == 47` will NOT work since
	   * only breakpoints for 0, 5, 10, 15... 100, 33, 34, 66, 67 are defined.
	   *
	   */
	  function updateClassWithValue(element, className) {
	    var lastClass;
	
	    return function updateClassFn(newValue) {
	      var value = validateAttributeValue(className, newValue || "");
	      if ( angular.isDefined(value) ) {
	        if (lastClass) element.removeClass(lastClass);
	        lastClass = !value ? className : className + "-" + value.trim().replace(WHITESPACE, "-");
	        element.addClass(lastClass);
	      }
	    };
	  }
	
	  /**
	   * Provide console warning that this layout attribute has been deprecated
	   *
	   */
	  function warnAttrNotSupported(className) {
	    var parts = className.split("-");
	    return ["$log", function($log) {
	      $log.warn(className + "has been deprecated. Please use a `" + parts[0] + "-gt-<xxx>` variant.");
	      return angular.noop;
	    }];
	  }
	
	  /**
	   * Centralize warnings for known flexbox issues (especially IE-related issues)
	   */
	  function validateAttributeUsage(className, attr, element, $log){
	    var message, usage, url;
	    var nodeName = element[0].nodeName.toLowerCase();
	
	    switch(className.replace(SUFFIXES,"")) {
	      case "flex":
	        if ((nodeName == "md-button") || (nodeName == "fieldset")){
	          // @see https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers
	          // Use <div flex> wrapper inside (preferred) or outside
	
	          usage = "<" + nodeName + " " + className + "></" + nodeName + ">";
	          url = "https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers";
	          message = "Markup '{0}' may not work as expected in IE Browsers. Consult '{1}' for details.";
	
	          $log.warn( $mdUtil.supplant(message, [usage, url]) );
	        }
	    }
	
	  }
	
	
	  /**
	   * For the Layout attribute value, validate or replace with default
	   * fallback value
	   */
	  function validateAttributeValue(className, value, updateFn) {
	    var origValue;
	
	    if (!needsInterpolation(value)) {
	      switch (className.replace(SUFFIXES,"")) {
	        case 'layout'        :
	          if ( !findIn(value, LAYOUT_OPTIONS) ) {
	            value = LAYOUT_OPTIONS[0];    // 'row';
	          }
	          break;
	
	        case 'flex'          :
	          if (!findIn(value, FLEX_OPTIONS)) {
	            if (isNaN(value)) {
	              value = '';
	            }
	          }
	          break;
	
	        case 'flex-offset' :
	        case 'flex-order'    :
	          if (!value || isNaN(+value)) {
	            value = '0';
	          }
	          break;
	
	        case 'layout-align'  :
	          var axis = extractAlignAxis(value);
	          value = $mdUtil.supplant("{main}-{cross}",axis);
	          break;
	
	        case 'layout-padding' :
	        case 'layout-margin'  :
	        case 'layout-fill'    :
	        case 'layout-wrap'    :
	        case 'layout-nowrap' :
	          value = '';
	          break;
	      }
	
	      if (value != origValue) {
	        (updateFn || angular.noop)(value);
	      }
	    }
	
	    return value ? value.trim() : "";
	  }
	
	  /**
	   * Replace current attribute value with fallback value
	   */
	  function buildUpdateFn(element, className, attrs) {
	    return function updateAttrValue(fallback) {
	      if (!needsInterpolation(fallback)) {
	        // Do not modify the element's attribute value; so
	        // uses '<ui-layout layout="/api/sidebar.html" />' will not
	        // be affected. Just update the attrs value.
	        attrs[attrs.$normalize(className)] = fallback;
	      }
	    };
	  }
	
	  /**
	   * See if the original value has interpolation symbols:
	   * e.g.  flex-gt-md="{{triggerPoint}}"
	   */
	  function needsInterpolation(value) {
	    return (value || "").indexOf($interpolate.startSymbol()) > -1;
	  }
	
	  function getNormalizedAttrValue(className, attrs, defaultVal) {
	    var normalizedAttr = attrs.$normalize(className);
	    return attrs[normalizedAttr] ? attrs[normalizedAttr].trim().replace(WHITESPACE, "-") : defaultVal || null;
	  }
	
	  function findIn(item, list, replaceWith) {
	    item = replaceWith && item ? item.replace(WHITESPACE, replaceWith) : item;
	
	    var found = false;
	    if (item) {
	      list.forEach(function(it) {
	        it = replaceWith ? it.replace(WHITESPACE, replaceWith) : it;
	        found = found || (it === item);
	      });
	    }
	    return found;
	  }
	
	  function extractAlignAxis(attrValue) {
	    var axis = {
	      main : "start",
	      cross: "stretch"
	    }, values;
	
	    attrValue = (attrValue || "");
	
	    if ( attrValue.indexOf("-") === 0 || attrValue.indexOf(" ") === 0) {
	      // For missing main-axis values
	      attrValue = "none" + attrValue;
	    }
	
	    values = attrValue.toLowerCase().trim().replace(WHITESPACE, "-").split("-");
	    if ( values.length && (values[0] === "space") ) {
	      // for main-axis values of "space-around" or "space-between"
	      values = [ values[0]+"-"+values[1],values[2] ];
	    }
	
	    if ( values.length > 0 ) axis.main  = values[0] || axis.main;
	    if ( values.length > 1 ) axis.cross = values[1] || axis.cross;
	
	    if ( ALIGNMENT_MAIN_AXIS.indexOf(axis.main) < 0 )   axis.main = "start";
	    if ( ALIGNMENT_CROSS_AXIS.indexOf(axis.cross) < 0 ) axis.cross = "stretch";
	
	    return axis;
	  }
	
	
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.liveannouncer
	 * @description
	 * AngularJS Material Live Announcer to provide accessibility for Voice Readers.
	 */
	MdLiveAnnouncer.$inject = ["$timeout"];
	angular
	  .module('material.core')
	  .service('$mdLiveAnnouncer', MdLiveAnnouncer);
	
	/**
	 * @ngdoc service
	 * @name $mdLiveAnnouncer
	 * @module material.core.liveannouncer
	 *
	 * @description
	 *
	 * Service to announce messages to supported screenreaders.
	 *
	 * > The `$mdLiveAnnouncer` service is internally used for components to provide proper accessibility.
	 *
	 * <hljs lang="js">
	 *   module.controller('AppCtrl', function($mdLiveAnnouncer) {
	 *     // Basic announcement (Polite Mode)
	 *     $mdLiveAnnouncer.announce('Hey Google');
	 *
	 *     // Custom announcement (Assertive Mode)
	 *     $mdLiveAnnouncer.announce('Hey Google', 'assertive');
	 *   });
	 * </hljs>
	 *
	 */
	function MdLiveAnnouncer($timeout) {
	  /** @private @const @type {!angular.$timeout} */
	  this._$timeout = $timeout;
	
	  /** @private @const @type {!HTMLElement} */
	  this._liveElement = this._createLiveElement();
	
	  /** @private @const @type {!number} */
	  this._announceTimeout = 100;
	}
	
	/**
	 * @ngdoc method
	 * @name $mdLiveAnnouncer#announce
	 * @description Announces messages to supported screenreaders.
	 * @param {string} message Message to be announced to the screenreader
	 * @param {'off'|'polite'|'assertive'} politeness The politeness of the announcer element.
	 */
	MdLiveAnnouncer.prototype.announce = function(message, politeness) {
	  if (!politeness) {
	    politeness = 'polite';
	  }
	
	  var self = this;
	
	  self._liveElement.textContent = '';
	  self._liveElement.setAttribute('aria-live', politeness);
	
	  // This 100ms timeout is necessary for some browser + screen-reader combinations:
	  // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
	  // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
	  //   second time without clearing and then using a non-zero delay.
	  // (using JAWS 17 at time of this writing).
	  self._$timeout(function() {
	    self._liveElement.textContent = message;
	  }, self._announceTimeout, false);
	};
	
	/**
	 * Creates a live announcer element, which listens for DOM changes and announces them
	 * to the screenreaders.
	 * @returns {!HTMLElement}
	 * @private
	 */
	MdLiveAnnouncer.prototype._createLiveElement = function() {
	  var liveEl = document.createElement('div');
	
	  liveEl.classList.add('md-visually-hidden');
	  liveEl.setAttribute('role', 'status');
	  liveEl.setAttribute('aria-atomic', 'true');
	  liveEl.setAttribute('aria-live', 'polite');
	
	  document.body.appendChild(liveEl);
	
	  return liveEl;
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc service
	 * @name $$mdMeta
	 * @module material.core.meta
	 *
	 * @description
	 *
	 * A provider and a service that simplifies meta tags access
	 *
	 * Note: This is intended only for use with dynamic meta tags such as browser color and title.
	 * Tags that are only processed when the page is rendered (such as `charset`, and `http-equiv`)
	 * will not work since `$$mdMeta` adds the tags after the page has already been loaded.
	 *
	 * ```js
	 * app.config(function($$mdMetaProvider) {
	 *   var removeMeta = $$mdMetaProvider.setMeta('meta-name', 'content');
	 *   var metaValue  = $$mdMetaProvider.getMeta('meta-name'); // -> 'content'
	 *
	 *   removeMeta();
	 * });
	 *
	 * app.controller('myController', function($$mdMeta) {
	 *   var removeMeta = $$mdMeta.setMeta('meta-name', 'content');
	 *   var metaValue  = $$mdMeta.getMeta('meta-name'); // -> 'content'
	 *
	 *   removeMeta();
	 * });
	 * ```
	 *
	 * @returns {$$mdMeta.$service}
	 *
	 */
	angular.module('material.core.meta', [])
	  .provider('$$mdMeta', function () {
	    var head = angular.element(document.head);
	    var metaElements = {};
	
	    /**
	     * Checks if the requested element was written manually and maps it
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @returns {boolean} returns true if there is an element with the requested name
	     */
	    function mapExistingElement(name) {
	      if (metaElements[name]) {
	        return true;
	      }
	
	      var element = document.getElementsByName(name)[0];
	
	      if (!element) {
	        return false;
	      }
	
	      metaElements[name] = angular.element(element);
	
	      return true;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $$mdMeta#setMeta
	     *
	     * @description
	     * Creates meta element with the 'name' and 'content' attributes,
	     * if the meta tag is already created than we replace the 'content' value
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @param {string} content meta tag 'content' attribute value
	     * @returns {function} remove function
	     *
	     */
	    function setMeta(name, content) {
	      mapExistingElement(name);
	
	      if (!metaElements[name]) {
	        var newMeta = angular.element('<meta name="' + name + '" content="' + content + '"/>');
	        head.append(newMeta);
	        metaElements[name] = newMeta;
	      }
	      else {
	        metaElements[name].attr('content', content);
	      }
	
	      return function () {
	        metaElements[name].attr('content', '');
	        metaElements[name].remove();
	        delete metaElements[name];
	      };
	    }
	
	    /**
	     * @ngdoc method
	     * @name $$mdMeta#getMeta
	     *
	     * @description
	     * Gets the 'content' attribute value of the wanted meta element
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @returns {string} content attribute value
	     */
	    function getMeta(name) {
	      if (!mapExistingElement(name)) {
	        throw Error('$$mdMeta: could not find a meta tag with the name \'' + name + '\'');
	      }
	
	      return metaElements[name].attr('content');
	    }
	
	    var module = {
	      setMeta: setMeta,
	      getMeta: getMeta
	    };
	
	    return angular.extend({}, module, {
	      $get: function () {
	        return module;
	      }
	    });
	  });
	})();
	(function(){
	"use strict";
	
	  /**
	   * @ngdoc module
	   * @name material.core.componentRegistry
	   *
	   * @description
	   * A component instance registration service.
	   * Note: currently this as a private service in the SideNav component.
	   */
	  ComponentRegistry.$inject = ["$log", "$q"];
	  angular.module('material.core')
	    .factory('$mdComponentRegistry', ComponentRegistry);
	
	  /*
	   * @private
	   * @ngdoc factory
	   * @name ComponentRegistry
	   * @module material.core.componentRegistry
	   *
	   */
	  function ComponentRegistry($log, $q) {
	
	    var self;
	    var instances = [ ];
	    var pendings = { };
	
	    return self = {
	      /**
	       * Used to print an error when an instance for a handle isn't found.
	       */
	      notFoundError: function(handle, msgContext) {
	        $log.error( (msgContext || "") + 'No instance found for handle', handle);
	      },
	      /**
	       * Return all registered instances as an array.
	       */
	      getInstances: function() {
	        return instances;
	      },
	
	      /**
	       * Get a registered instance.
	       * @param handle the String handle to look up for a registered instance.
	       */
	      get: function(handle) {
	        if ( !isValidID(handle) ) return null;
	
	        var i, j, instance;
	        for(i = 0, j = instances.length; i < j; i++) {
	          instance = instances[i];
	          if(instance.$$mdHandle === handle) {
	            return instance;
	          }
	        }
	        return null;
	      },
	
	      /**
	       * Register an instance.
	       * @param instance the instance to register
	       * @param handle the handle to identify the instance under.
	       */
	      register: function(instance, handle) {
	        if ( !handle ) return angular.noop;
	
	        instance.$$mdHandle = handle;
	        instances.push(instance);
	        resolveWhen();
	
	        return deregister;
	
	        /**
	         * Remove registration for an instance
	         */
	        function deregister() {
	          var index = instances.indexOf(instance);
	          if (index !== -1) {
	            instances.splice(index, 1);
	          }
	        }
	
	        /**
	         * Resolve any pending promises for this instance
	         */
	        function resolveWhen() {
	          var dfd = pendings[handle];
	          if ( dfd ) {
	            dfd.forEach(function (promise) {
	              promise.resolve(instance);
	            });
	            delete pendings[handle];
	          }
	        }
	      },
	
	      /**
	       * Async accessor to registered component instance
	       * If not available then a promise is created to notify
	       * all listeners when the instance is registered.
	       */
	      when : function(handle) {
	        if ( isValidID(handle) ) {
	          var deferred = $q.defer();
	          var instance = self.get(handle);
	
	          if ( instance )  {
	            deferred.resolve( instance );
	          } else {
	            if (pendings[handle] === undefined) {
	              pendings[handle] = [];
	            }
	            pendings[handle].push(deferred);
	          }
	
	          return deferred.promise;
	        }
	        return $q.reject("Invalid `md-component-id` value.");
	      }
	
	    };
	
	    function isValidID(handle){
	      return handle && (handle !== "");
	    }
	
	  }
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdButtonInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-button.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the default ripple configuration
	   */
	
	  MdButtonInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdButtonInkRipple', MdButtonInkRipple);
	
	  function MdButtonInkRipple($mdInkRipple) {
	    return {
	      attach: function attachRipple(scope, element, options) {
	        options = angular.extend(optionsForElement(element), options);
	
	        return $mdInkRipple.attach(scope, element, options);
	      }
	    };
	
	    function optionsForElement(element) {
	      if (element.hasClass('md-icon-button')) {
	        return {
	          isMenuItem: element.hasClass('md-menu-item'),
	          fitRipple: true,
	          center: true
	        };
	      } else {
	        return {
	          isMenuItem: element.hasClass('md-menu-item'),
	          dimBackground: true
	        };
	      }
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	    /**
	   * @ngdoc service
	   * @name $mdCheckboxInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-checkbox.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdCheckboxInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdCheckboxInkRipple', MdCheckboxInkRipple);
	
	  function MdCheckboxInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: true,
	        dimBackground: false,
	        fitRipple: true
	      }, options));
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdListInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-list.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdListInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdListInkRipple', MdListInkRipple);
	
	  function MdListInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: false,
	        dimBackground: true,
	        outline: false,
	        rippleSize: 'full'
	      }, options));
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.ripple
	 * @description
	 * Ripple
	 */
	InkRippleCtrl.$inject = ["$scope", "$element", "rippleOptions", "$window", "$timeout", "$mdUtil", "$mdColorUtil"];
	InkRippleDirective.$inject = ["$mdButtonInkRipple", "$mdCheckboxInkRipple"];
	angular.module('material.core')
	    .provider('$mdInkRipple', InkRippleProvider)
	    .directive('mdInkRipple', InkRippleDirective)
	    .directive('mdNoInk', attrNoDirective)
	    .directive('mdNoBar', attrNoDirective)
	    .directive('mdNoStretch', attrNoDirective);
	
	var DURATION = 450;
	
	/**
	 * @ngdoc directive
	 * @name mdInkRipple
	 * @module material.core.ripple
	 *
	 * @description
	 * The `md-ink-ripple` directive allows you to specify the ripple color or if a ripple is allowed.
	 *
	 * @param {string|boolean} md-ink-ripple A color string `#FF0000` or boolean (`false` or `0`) for preventing ripple
	 *
	 * @usage
	 * ### String values
	 * <hljs lang="html">
	 *   <ANY md-ink-ripple="#FF0000">
	 *     Ripples in red
	 *   </ANY>
	 *
	 *   <ANY md-ink-ripple="false">
	 *     Not rippling
	 *   </ANY>
	 * </hljs>
	 *
	 * ### Interpolated values
	 * <hljs lang="html">
	 *   <ANY md-ink-ripple="{{ randomColor() }}">
	 *     Ripples with the return value of 'randomColor' function
	 *   </ANY>
	 *
	 *   <ANY md-ink-ripple="{{ canRipple() }}">
	 *     Ripples if 'canRipple' function return value is not 'false' or '0'
	 *   </ANY>
	 * </hljs>
	 */
	function InkRippleDirective ($mdButtonInkRipple, $mdCheckboxInkRipple) {
	  return {
	    controller: angular.noop,
	    link:       function (scope, element, attr) {
	      attr.hasOwnProperty('mdInkRippleCheckbox')
	          ? $mdCheckboxInkRipple.attach(scope, element)
	          : $mdButtonInkRipple.attach(scope, element);
	    }
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $mdInkRipple
	 * @module material.core.ripple
	 *
	 * @description
	 * `$mdInkRipple` is a service for adding ripples to any element
	 *
	 * @usage
	 * <hljs lang="js">
	 * app.factory('$myElementInkRipple', function($mdInkRipple) {
	 *   return {
	 *     attach: function (scope, element, options) {
	 *       return $mdInkRipple.attach(scope, element, angular.extend({
	 *         center: false,
	 *         dimBackground: true
	 *       }, options));
	 *     }
	 *   };
	 * });
	 *
	 * app.controller('myController', function ($scope, $element, $myElementInkRipple) {
	 *   $scope.onClick = function (ev) {
	 *     $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true });
	 *   }
	 * });
	 * </hljs>
	 *
	 * ### Disabling ripples globally
	 * If you want to disable ink ripples globally, for all components, you can call the
	 * `disableInkRipple` method in your app's config.
	 *
	 * <hljs lang="js">
	 * app.config(function ($mdInkRippleProvider) {
	 *   $mdInkRippleProvider.disableInkRipple();
	 * });
	 */
	
	function InkRippleProvider () {
	  var isDisabledGlobally = false;
	
	  return {
	    disableInkRipple: disableInkRipple,
	    $get: ["$injector", function($injector) {
	      return { attach: attach };
	
	      /**
	       * @ngdoc method
	       * @name $mdInkRipple#attach
	       *
	       * @description
	       * Attaching given scope, element and options to inkRipple controller
	       *
	       * @param {object=} scope Scope within the current context
	       * @param {object=} element The element the ripple effect should be applied to
	       * @param {object=} options (Optional) Configuration options to override the defaultRipple configuration
	       * * `center` -  Whether the ripple should start from the center of the container element
	       * * `dimBackground` - Whether the background should be dimmed with the ripple color
	       * * `colorElement` - The element the ripple should take its color from, defined by css property `color`
	       * * `fitRipple` - Whether the ripple should fill the element
	       */
	      function attach (scope, element, options) {
	        if (isDisabledGlobally || element.controller('mdNoInk')) return angular.noop;
	        return $injector.instantiate(InkRippleCtrl, {
	          $scope:        scope,
	          $element:      element,
	          rippleOptions: options
	        });
	      }
	    }]
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdInkRipple#disableInkRipple
	   *
	   * @description
	   * A config-time method that, when called, disables ripples globally.
	   */
	  function disableInkRipple () {
	    isDisabledGlobally = true;
	  }
	}
	
	/**
	 * Controller used by the ripple service in order to apply ripples
	 * @ngInject
	 */
	function InkRippleCtrl ($scope, $element, rippleOptions, $window, $timeout, $mdUtil, $mdColorUtil) {
	  this.$window    = $window;
	  this.$timeout   = $timeout;
	  this.$mdUtil    = $mdUtil;
	  this.$mdColorUtil    = $mdColorUtil;
	  this.$scope     = $scope;
	  this.$element   = $element;
	  this.options    = rippleOptions;
	  this.mousedown  = false;
	  this.ripples    = [];
	  this.timeout    = null; // Stores a reference to the most-recent ripple timeout
	  this.lastRipple = null;
	
	  $mdUtil.valueOnUse(this, 'container', this.createContainer);
	
	  this.$element.addClass('md-ink-ripple');
	
	  // attach method for unit tests
	  ($element.controller('mdInkRipple') || {}).createRipple = angular.bind(this, this.createRipple);
	  ($element.controller('mdInkRipple') || {}).setColor = angular.bind(this, this.color);
	
	  this.bindEvents();
	}
	
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
	 * mouseup or mouseleave event)
	 */
	function autoCleanup (self, cleanupFn) {
	
	  if ( self.mousedown || self.lastRipple ) {
	    self.mousedown = false;
	    self.$mdUtil.nextTick( angular.bind(self, cleanupFn), false);
	  }
	
	}
	
	
	/**
	 * Returns the color that the ripple should be (either based on CSS or hard-coded)
	 * @returns {string}
	 */
	InkRippleCtrl.prototype.color = function (value) {
	  var self = this;
	
	  // If assigning a color value, apply it to background and the ripple color
	  if (angular.isDefined(value)) {
	    self._color = self._parseColor(value);
	  }
	
	  // If color lookup, use assigned, defined, or inherited
	  return self._color || self._parseColor( self.inkRipple() ) || self._parseColor( getElementColor() );
	
	  /**
	   * Finds the color element and returns its text color for use as default ripple color
	   * @returns {string}
	   */
	  function getElementColor () {
	    var items = self.options && self.options.colorElement ? self.options.colorElement : [];
	    var elem =  items.length ? items[ 0 ] : self.$element[ 0 ];
	
	    return elem ? self.$window.getComputedStyle(elem).color : 'rgb(0,0,0)';
	  }
	};
	
	/**
	 * Updating the ripple colors based on the current inkRipple value
	 * or the element's computed style color
	 */
	InkRippleCtrl.prototype.calculateColor = function () {
	  return this.color();
	};
	
	
	/**
	 * Takes a string color and converts it to RGBA format
	 * @param color {string}
	 * @param [multiplier] {int}
	 * @returns {string}
	 */
	
	InkRippleCtrl.prototype._parseColor = function parseColor (color, multiplier) {
	  multiplier = multiplier || 1;
	  var colorUtil = this.$mdColorUtil;
	
	  if (!color) return;
	  if (color.indexOf('rgba') === 0) return color.replace(/\d?\.?\d*\s*\)\s*$/, (0.1 * multiplier).toString() + ')');
	  if (color.indexOf('rgb') === 0) return colorUtil.rgbToRgba(color);
	  if (color.indexOf('#') === 0) return colorUtil.hexToRgba(color);
	
	};
	
	/**
	 * Binds events to the root element for
	 */
	InkRippleCtrl.prototype.bindEvents = function () {
	  this.$element.on('mousedown', angular.bind(this, this.handleMousedown));
	  this.$element.on('mouseup touchend', angular.bind(this, this.handleMouseup));
	  this.$element.on('mouseleave', angular.bind(this, this.handleMouseup));
	  this.$element.on('touchmove', angular.bind(this, this.handleTouchmove));
	};
	
	/**
	 * Create a new ripple on every mousedown event from the root element
	 * @param event {MouseEvent}
	 */
	InkRippleCtrl.prototype.handleMousedown = function (event) {
	  if ( this.mousedown ) return;
	
	  // When jQuery is loaded, we have to get the original event
	  if (event.hasOwnProperty('originalEvent')) event = event.originalEvent;
	  this.mousedown = true;
	  if (this.options.center) {
	    this.createRipple(this.container.prop('clientWidth') / 2, this.container.prop('clientWidth') / 2);
	  } else {
	
	    // We need to calculate the relative coordinates if the target is a sublayer of the ripple element
	    if (event.srcElement !== this.$element[0]) {
	      var layerRect = this.$element[0].getBoundingClientRect();
	      var layerX = event.clientX - layerRect.left;
	      var layerY = event.clientY - layerRect.top;
	
	      this.createRipple(layerX, layerY);
	    } else {
	      this.createRipple(event.offsetX, event.offsetY);
	    }
	  }
	};
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
	 * mouseup, touchend or mouseleave event)
	 */
	InkRippleCtrl.prototype.handleMouseup = function () {
	  this.$timeout(function () {
	    autoCleanup(this, this.clearRipples);
	  }.bind(this));
	};
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (by
	 * touchmove)
	 */
	InkRippleCtrl.prototype.handleTouchmove = function () {
	  autoCleanup(this, this.deleteRipples);
	};
	
	/**
	 * Cycles through all ripples and attempts to remove them.
	 */
	InkRippleCtrl.prototype.deleteRipples = function () {
	  for (var i = 0; i < this.ripples.length; i++) {
	    this.ripples[ i ].remove();
	  }
	};
	
	/**
	 * Cycles through all ripples and attempts to remove them with fade.
	 * Depending on logic within `fadeInComplete`, some removals will be postponed.
	 */
	InkRippleCtrl.prototype.clearRipples = function () {
	  for (var i = 0; i < this.ripples.length; i++) {
	    this.fadeInComplete(this.ripples[ i ]);
	  }
	};
	
	/**
	 * Creates the ripple container element
	 * @returns {*}
	 */
	InkRippleCtrl.prototype.createContainer = function () {
	  var container = angular.element('<div class="md-ripple-container"></div>');
	  this.$element.append(container);
	  return container;
	};
	
	InkRippleCtrl.prototype.clearTimeout = function () {
	  if (this.timeout) {
	    this.$timeout.cancel(this.timeout);
	    this.timeout = null;
	  }
	};
	
	InkRippleCtrl.prototype.isRippleAllowed = function () {
	  var element = this.$element[0];
	  do {
	    if (!element.tagName || element.tagName === 'BODY') break;
	
	    if (element && angular.isFunction(element.hasAttribute)) {
	      if (element.hasAttribute('disabled')) return false;
	      if (this.inkRipple() === 'false' || this.inkRipple() === '0') return false;
	    }
	
	  } while (element = element.parentNode);
	  return true;
	};
	
	/**
	 * The attribute `md-ink-ripple` may be a static or interpolated
	 * color value OR a boolean indicator (used to disable ripples)
	 */
	InkRippleCtrl.prototype.inkRipple = function () {
	  return this.$element.attr('md-ink-ripple');
	};
	
	/**
	 * Creates a new ripple and adds it to the container.  Also tracks ripple in `this.ripples`.
	 * @param left
	 * @param top
	 */
	InkRippleCtrl.prototype.createRipple = function (left, top) {
	  if (!this.isRippleAllowed()) return;
	
	  var ctrl        = this;
	  var colorUtil   = ctrl.$mdColorUtil;
	  var ripple      = angular.element('<div class="md-ripple"></div>');
	  var width       = this.$element.prop('clientWidth');
	  var height      = this.$element.prop('clientHeight');
	  var x           = Math.max(Math.abs(width - left), left) * 2;
	  var y           = Math.max(Math.abs(height - top), top) * 2;
	  var size        = getSize(this.options.fitRipple, x, y);
	  var color       = this.calculateColor();
	
	  ripple.css({
	    left:            left + 'px',
	    top:             top + 'px',
	    background:      'black',
	    width:           size + 'px',
	    height:          size + 'px',
	    backgroundColor: colorUtil.rgbaToRgb(color),
	    borderColor:     colorUtil.rgbaToRgb(color)
	  });
	  this.lastRipple = ripple;
	
	  // we only want one timeout to be running at a time
	  this.clearTimeout();
	  this.timeout    = this.$timeout(function () {
	    ctrl.clearTimeout();
	    if (!ctrl.mousedown) ctrl.fadeInComplete(ripple);
	  }, DURATION * 0.35, false);
	
	  if (this.options.dimBackground) this.container.css({ backgroundColor: color });
	  this.container.append(ripple);
	  this.ripples.push(ripple);
	  ripple.addClass('md-ripple-placed');
	
	  this.$mdUtil.nextTick(function () {
	
	    ripple.addClass('md-ripple-scaled md-ripple-active');
	    ctrl.$timeout(function () {
	      ctrl.clearRipples();
	    }, DURATION, false);
	
	  }, false);
	
	  function getSize (fit, x, y) {
	    return fit
	        ? Math.max(x, y)
	        : Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
	  }
	};
	
	
	
	/**
	 * After fadeIn finishes, either kicks off the fade-out animation or queues the element for removal on mouseup
	 * @param ripple
	 */
	InkRippleCtrl.prototype.fadeInComplete = function (ripple) {
	  if (this.lastRipple === ripple) {
	    if (!this.timeout && !this.mousedown) {
	      this.removeRipple(ripple);
	    }
	  } else {
	    this.removeRipple(ripple);
	  }
	};
	
	/**
	 * Kicks off the animation for removing a ripple
	 * @param ripple {Element}
	 */
	InkRippleCtrl.prototype.removeRipple = function (ripple) {
	  var ctrl  = this;
	  var index = this.ripples.indexOf(ripple);
	  if (index < 0) return;
	  this.ripples.splice(this.ripples.indexOf(ripple), 1);
	  ripple.removeClass('md-ripple-active');
	  ripple.addClass('md-ripple-remove');
	  if (this.ripples.length === 0) this.container.css({ backgroundColor: '' });
	  // use a 2-second timeout in order to allow for the animation to finish
	  // we don't actually care how long the animation takes
	  this.$timeout(function () {
	    ctrl.fadeOutComplete(ripple);
	  }, DURATION, false);
	};
	
	/**
	 * Removes the provided ripple from the DOM
	 * @param ripple
	 */
	InkRippleCtrl.prototype.fadeOutComplete = function (ripple) {
	  ripple.remove();
	  this.lastRipple = null;
	};
	
	/**
	 * Used to create an empty directive.  This is used to track flag-directives whose children may have
	 * functionality based on them.
	 *
	 * Example: `md-no-ink` will potentially be used by all child directives.
	 */
	function attrNoDirective () {
	  return { controller: angular.noop };
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	    /**
	   * @ngdoc service
	   * @name $mdTabInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-tabs.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdTabInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdTabInkRipple', MdTabInkRipple);
	
	  function MdTabInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: false,
	        dimBackground: true,
	        outline: false,
	        rippleSize: 'full'
	      }, options));
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core.theming.palette', [])
	.constant('$mdColorPalette', {
	  'red': {
	    '50': '#ffebee',
	    '100': '#ffcdd2',
	    '200': '#ef9a9a',
	    '300': '#e57373',
	    '400': '#ef5350',
	    '500': '#f44336',
	    '600': '#e53935',
	    '700': '#d32f2f',
	    '800': '#c62828',
	    '900': '#b71c1c',
	    'A100': '#ff8a80',
	    'A200': '#ff5252',
	    'A400': '#ff1744',
	    'A700': '#d50000',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 A100',
	    'contrastStrongLightColors': '400 500 600 700 A200 A400 A700'
	  },
	  'pink': {
	    '50': '#fce4ec',
	    '100': '#f8bbd0',
	    '200': '#f48fb1',
	    '300': '#f06292',
	    '400': '#ec407a',
	    '500': '#e91e63',
	    '600': '#d81b60',
	    '700': '#c2185b',
	    '800': '#ad1457',
	    '900': '#880e4f',
	    'A100': '#ff80ab',
	    'A200': '#ff4081',
	    'A400': '#f50057',
	    'A700': '#c51162',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '500 600 A200 A400 A700'
	  },
	  'purple': {
	    '50': '#f3e5f5',
	    '100': '#e1bee7',
	    '200': '#ce93d8',
	    '300': '#ba68c8',
	    '400': '#ab47bc',
	    '500': '#9c27b0',
	    '600': '#8e24aa',
	    '700': '#7b1fa2',
	    '800': '#6a1b9a',
	    '900': '#4a148c',
	    'A100': '#ea80fc',
	    'A200': '#e040fb',
	    'A400': '#d500f9',
	    'A700': '#aa00ff',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '300 400 A200 A400 A700'
	  },
	  'deep-purple': {
	    '50': '#ede7f6',
	    '100': '#d1c4e9',
	    '200': '#b39ddb',
	    '300': '#9575cd',
	    '400': '#7e57c2',
	    '500': '#673ab7',
	    '600': '#5e35b1',
	    '700': '#512da8',
	    '800': '#4527a0',
	    '900': '#311b92',
	    'A100': '#b388ff',
	    'A200': '#7c4dff',
	    'A400': '#651fff',
	    'A700': '#6200ea',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '300 400 A200'
	  },
	  'indigo': {
	    '50': '#e8eaf6',
	    '100': '#c5cae9',
	    '200': '#9fa8da',
	    '300': '#7986cb',
	    '400': '#5c6bc0',
	    '500': '#3f51b5',
	    '600': '#3949ab',
	    '700': '#303f9f',
	    '800': '#283593',
	    '900': '#1a237e',
	    'A100': '#8c9eff',
	    'A200': '#536dfe',
	    'A400': '#3d5afe',
	    'A700': '#304ffe',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '300 400 A200 A400'
	  },
	  'blue': {
	    '50': '#e3f2fd',
	    '100': '#bbdefb',
	    '200': '#90caf9',
	    '300': '#64b5f6',
	    '400': '#42a5f5',
	    '500': '#2196f3',
	    '600': '#1e88e5',
	    '700': '#1976d2',
	    '800': '#1565c0',
	    '900': '#0d47a1',
	    'A100': '#82b1ff',
	    'A200': '#448aff',
	    'A400': '#2979ff',
	    'A700': '#2962ff',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 400 A100',
	    'contrastStrongLightColors': '500 600 700 A200 A400 A700'
	  },
	  'light-blue': {
	    '50': '#e1f5fe',
	    '100': '#b3e5fc',
	    '200': '#81d4fa',
	    '300': '#4fc3f7',
	    '400': '#29b6f6',
	    '500': '#03a9f4',
	    '600': '#039be5',
	    '700': '#0288d1',
	    '800': '#0277bd',
	    '900': '#01579b',
	    'A100': '#80d8ff',
	    'A200': '#40c4ff',
	    'A400': '#00b0ff',
	    'A700': '#0091ea',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '600 700 800 900 A700',
	    'contrastStrongLightColors': '600 700 800 A700'
	  },
	  'cyan': {
	    '50': '#e0f7fa',
	    '100': '#b2ebf2',
	    '200': '#80deea',
	    '300': '#4dd0e1',
	    '400': '#26c6da',
	    '500': '#00bcd4',
	    '600': '#00acc1',
	    '700': '#0097a7',
	    '800': '#00838f',
	    '900': '#006064',
	    'A100': '#84ffff',
	    'A200': '#18ffff',
	    'A400': '#00e5ff',
	    'A700': '#00b8d4',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '700 800 900',
	    'contrastStrongLightColors': '700 800 900'
	  },
	  'teal': {
	    '50': '#e0f2f1',
	    '100': '#b2dfdb',
	    '200': '#80cbc4',
	    '300': '#4db6ac',
	    '400': '#26a69a',
	    '500': '#009688',
	    '600': '#00897b',
	    '700': '#00796b',
	    '800': '#00695c',
	    '900': '#004d40',
	    'A100': '#a7ffeb',
	    'A200': '#64ffda',
	    'A400': '#1de9b6',
	    'A700': '#00bfa5',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '500 600 700 800 900',
	    'contrastStrongLightColors': '500 600 700'
	  },
	  'green': {
	    '50': '#e8f5e9',
	    '100': '#c8e6c9',
	    '200': '#a5d6a7',
	    '300': '#81c784',
	    '400': '#66bb6a',
	    '500': '#4caf50',
	    '600': '#43a047',
	    '700': '#388e3c',
	    '800': '#2e7d32',
	    '900': '#1b5e20',
	    'A100': '#b9f6ca',
	    'A200': '#69f0ae',
	    'A400': '#00e676',
	    'A700': '#00c853',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '500 600 700 800 900',
	    'contrastStrongLightColors': '500 600 700'
	  },
	  'light-green': {
	    '50': '#f1f8e9',
	    '100': '#dcedc8',
	    '200': '#c5e1a5',
	    '300': '#aed581',
	    '400': '#9ccc65',
	    '500': '#8bc34a',
	    '600': '#7cb342',
	    '700': '#689f38',
	    '800': '#558b2f',
	    '900': '#33691e',
	    'A100': '#ccff90',
	    'A200': '#b2ff59',
	    'A400': '#76ff03',
	    'A700': '#64dd17',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '700 800 900',
	    'contrastStrongLightColors': '700 800 900'
	  },
	  'lime': {
	    '50': '#f9fbe7',
	    '100': '#f0f4c3',
	    '200': '#e6ee9c',
	    '300': '#dce775',
	    '400': '#d4e157',
	    '500': '#cddc39',
	    '600': '#c0ca33',
	    '700': '#afb42b',
	    '800': '#9e9d24',
	    '900': '#827717',
	    'A100': '#f4ff81',
	    'A200': '#eeff41',
	    'A400': '#c6ff00',
	    'A700': '#aeea00',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '900',
	    'contrastStrongLightColors': '900'
	  },
	  'yellow': {
	    '50': '#fffde7',
	    '100': '#fff9c4',
	    '200': '#fff59d',
	    '300': '#fff176',
	    '400': '#ffee58',
	    '500': '#ffeb3b',
	    '600': '#fdd835',
	    '700': '#fbc02d',
	    '800': '#f9a825',
	    '900': '#f57f17',
	    'A100': '#ffff8d',
	    'A200': '#ffff00',
	    'A400': '#ffea00',
	    'A700': '#ffd600',
	    'contrastDefaultColor': 'dark'
	  },
	  'amber': {
	    '50': '#fff8e1',
	    '100': '#ffecb3',
	    '200': '#ffe082',
	    '300': '#ffd54f',
	    '400': '#ffca28',
	    '500': '#ffc107',
	    '600': '#ffb300',
	    '700': '#ffa000',
	    '800': '#ff8f00',
	    '900': '#ff6f00',
	    'A100': '#ffe57f',
	    'A200': '#ffd740',
	    'A400': '#ffc400',
	    'A700': '#ffab00',
	    'contrastDefaultColor': 'dark'
	  },
	  'orange': {
	    '50': '#fff3e0',
	    '100': '#ffe0b2',
	    '200': '#ffcc80',
	    '300': '#ffb74d',
	    '400': '#ffa726',
	    '500': '#ff9800',
	    '600': '#fb8c00',
	    '700': '#f57c00',
	    '800': '#ef6c00',
	    '900': '#e65100',
	    'A100': '#ffd180',
	    'A200': '#ffab40',
	    'A400': '#ff9100',
	    'A700': '#ff6d00',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '800 900',
	    'contrastStrongLightColors': '800 900'
	  },
	  'deep-orange': {
	    '50': '#fbe9e7',
	    '100': '#ffccbc',
	    '200': '#ffab91',
	    '300': '#ff8a65',
	    '400': '#ff7043',
	    '500': '#ff5722',
	    '600': '#f4511e',
	    '700': '#e64a19',
	    '800': '#d84315',
	    '900': '#bf360c',
	    'A100': '#ff9e80',
	    'A200': '#ff6e40',
	    'A400': '#ff3d00',
	    'A700': '#dd2c00',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 400 A100 A200',
	    'contrastStrongLightColors': '500 600 700 800 900 A400 A700'
	  },
	  'brown': {
	    '50': '#efebe9',
	    '100': '#d7ccc8',
	    '200': '#bcaaa4',
	    '300': '#a1887f',
	    '400': '#8d6e63',
	    '500': '#795548',
	    '600': '#6d4c41',
	    '700': '#5d4037',
	    '800': '#4e342e',
	    '900': '#3e2723',
	    'A100': '#d7ccc8',
	    'A200': '#bcaaa4',
	    'A400': '#8d6e63',
	    'A700': '#5d4037',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100 A200',
	    'contrastStrongLightColors': '300 400'
	  },
	  'grey': {
	    '50': '#fafafa',
	    '100': '#f5f5f5',
	    '200': '#eeeeee',
	    '300': '#e0e0e0',
	    '400': '#bdbdbd',
	    '500': '#9e9e9e',
	    '600': '#757575',
	    '700': '#616161',
	    '800': '#424242',
	    '900': '#212121',
	    'A100': '#ffffff',
	    'A200': '#000000',
	    'A400': '#303030',
	    'A700': '#616161',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '600 700 800 900 A200 A400 A700'
	  },
	  'blue-grey': {
	    '50': '#eceff1',
	    '100': '#cfd8dc',
	    '200': '#b0bec5',
	    '300': '#90a4ae',
	    '400': '#78909c',
	    '500': '#607d8b',
	    '600': '#546e7a',
	    '700': '#455a64',
	    '800': '#37474f',
	    '900': '#263238',
	    'A100': '#cfd8dc',
	    'A200': '#b0bec5',
	    'A400': '#78909c',
	    'A700': '#455a64',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 A100 A200',
	    'contrastStrongLightColors': '400 500 700'
	  }
	});
	
	})();
	(function(){
	"use strict";
	
	(function(angular) {
	  'use strict';
	/**
	 * @ngdoc module
	 * @name material.core.theming
	 * @description
	 * Theming
	 */
	detectDisabledThemes.$inject = ["$mdThemingProvider"];
	ThemingDirective.$inject = ["$mdTheming", "$interpolate", "$parse", "$mdUtil", "$q", "$log"];
	ThemableDirective.$inject = ["$mdTheming"];
	ThemingProvider.$inject = ["$mdColorPalette", "$$mdMetaProvider"];
	generateAllThemes.$inject = ["$injector", "$mdTheming"];
	angular.module('material.core.theming', ['material.core.theming.palette', 'material.core.meta'])
	  .directive('mdTheme', ThemingDirective)
	  .directive('mdThemable', ThemableDirective)
	  .directive('mdThemesDisabled', disableThemesDirective )
	  .provider('$mdTheming', ThemingProvider)
	  .config( detectDisabledThemes )
	  .run(generateAllThemes);
	
	/**
	 * Detect if the HTML or the BODY tags has a [md-themes-disabled] attribute
	 * If yes, then immediately disable all theme stylesheet generation and DOM injection
	 */
	/**
	 * @ngInject
	 */
	function detectDisabledThemes($mdThemingProvider) {
	  var isDisabled = !!document.querySelector('[md-themes-disabled]');
	  $mdThemingProvider.disableTheming(isDisabled);
	}
	
	/**
	 * @ngdoc service
	 * @name $mdThemingProvider
	 * @module material.core.theming
	 *
	 * @description Provider to configure the `$mdTheming` service.
	 *
	 * ### Default Theme
	 * The `$mdThemingProvider` uses by default the following theme configuration:
	 *
	 * - Primary Palette: `Blue`
	 * - Accent Palette: `Pink`
	 * - Warn Palette: `Deep-Orange`
	 * - Background Palette: `Grey`
	 *
	 * If you don't want to use the `md-theme` directive on the elements itself, you may want to overwrite
	 * the default theme.<br/>
	 * This can be done by using the following markup.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     $mdThemingProvider
	 *       .theme('default')
	 *       .primaryPalette('blue')
	 *       .accentPalette('teal')
	 *       .warnPalette('red')
	 *       .backgroundPalette('grey');
	 *   });
	 * </hljs>
	 *
	
	 * ### Dynamic Themes
	 *
	 * By default, if you change a theme at runtime, the `$mdTheming` service will not detect those changes.<br/>
	 * If you have an application, which changes its theme on runtime, you have to enable theme watching.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Enable theme watching.
	 *     $mdThemingProvider.alwaysWatchTheme(true);
	 *   });
	 * </hljs>
	 *
	 * ### Custom Theme Styles
	 *
	 * Sometimes you may want to use your own theme styles for some custom components.<br/>
	 * You are able to register your own styles by using the following markup.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Register our custom stylesheet into the theming provider.
	 *     $mdThemingProvider.registerStyles(STYLESHEET);
	 *   });
	 * </hljs>
	 *
	 * The `registerStyles` method only accepts strings as value, so you're actually not able to load an external
	 * stylesheet file into the `$mdThemingProvider`.
	 *
	 * If it's necessary to load an external stylesheet, we suggest using a bundler, which supports including raw content,
	 * like [raw-loader](https://github.com/webpack/raw-loader) for `webpack`.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Register your custom stylesheet into the theming provider.
	 *     $mdThemingProvider.registerStyles(require('../styles/my-component.theme.css'));
	 *   });
	 * </hljs>
	 *
	 * ### Browser color
	 *
	 * Enables browser header coloring
	 * for more info please visit:
	 * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
	 *
	 * Options parameter: <br/>
	 * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
	 * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	 *             'accent', 'background' and 'warn'. Default is `primary`. <br/>
	 * `hue`     - The hue from the selected palette. Default is `800`<br/>
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Enable browser color
	 *     $mdThemingProvider.enableBrowserColor({
	 *       theme: 'myTheme', // Default is 'default'
	 *       palette: 'accent', // Default is 'primary', any basic material palette and extended palettes are available
	 *       hue: '200' // Default is '800'
	 *     });
	 *   });
	 * </hljs>
	 */
	
	/**
	 * Some Example Valid Theming Expressions
	 * =======================================
	 *
	 * Intention group expansion: (valid for primary, accent, warn, background)
	 *
	 * {{primary-100}} - grab shade 100 from the primary palette
	 * {{primary-100-0.7}} - grab shade 100, apply opacity of 0.7
	 * {{primary-100-contrast}} - grab shade 100's contrast color
	 * {{primary-hue-1}} - grab the shade assigned to hue-1 from the primary palette
	 * {{primary-hue-1-0.7}} - apply 0.7 opacity to primary-hue-1
	 * {{primary-color}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured shades set for each hue
	 * {{primary-color-0.7}} - Apply 0.7 opacity to each of the above rules
	 * {{primary-contrast}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured contrast (ie. text) color shades set for each hue
	 * {{primary-contrast-0.7}} - Apply 0.7 opacity to each of the above rules
	 *
	 * Foreground expansion: Applies rgba to black/white foreground text
	 *
	 * {{foreground-1}} - used for primary text
	 * {{foreground-2}} - used for secondary text/divider
	 * {{foreground-3}} - used for disabled text
	 * {{foreground-4}} - used for dividers
	 */
	
	// In memory generated CSS rules; registered by theme.name
	var GENERATED = { };
	
	// In memory storage of defined themes and color palettes (both loaded by CSS, and user specified)
	var PALETTES;
	
	// Text Colors on light and dark backgrounds
	// @see https://www.google.com/design/spec/style/color.html#color-text-background-colors
	var DARK_FOREGROUND = {
	  name: 'dark',
	  '1': 'rgba(0,0,0,0.87)',
	  '2': 'rgba(0,0,0,0.54)',
	  '3': 'rgba(0,0,0,0.38)',
	  '4': 'rgba(0,0,0,0.12)'
	};
	var LIGHT_FOREGROUND = {
	  name: 'light',
	  '1': 'rgba(255,255,255,1.0)',
	  '2': 'rgba(255,255,255,0.7)',
	  '3': 'rgba(255,255,255,0.5)',
	  '4': 'rgba(255,255,255,0.12)'
	};
	
	var DARK_SHADOW = '1px 1px 0px rgba(0,0,0,0.4), -1px -1px 0px rgba(0,0,0,0.4)';
	var LIGHT_SHADOW = '';
	
	var DARK_CONTRAST_COLOR = colorToRgbaArray('rgba(0,0,0,0.87)');
	var LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgba(255,255,255,0.87)');
	var STRONG_LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgb(255,255,255)');
	
	var THEME_COLOR_TYPES = ['primary', 'accent', 'warn', 'background'];
	var DEFAULT_COLOR_TYPE = 'primary';
	
	// A color in a theme will use these hues by default, if not specified by user.
	var LIGHT_DEFAULT_HUES = {
	  'accent': {
	    'default': 'A200',
	    'hue-1': 'A100',
	    'hue-2': 'A400',
	    'hue-3': 'A700'
	  },
	  'background': {
	    'default': '50',
	    'hue-1': 'A100',
	    'hue-2': '100',
	    'hue-3': '300'
	  }
	};
	
	var DARK_DEFAULT_HUES = {
	  'background': {
	    'default': 'A400',
	    'hue-1': '800',
	    'hue-2': '900',
	    'hue-3': 'A200'
	  }
	};
	THEME_COLOR_TYPES.forEach(function(colorType) {
	  // Color types with unspecified default hues will use these default hue values
	  var defaultDefaultHues = {
	    'default': '500',
	    'hue-1': '300',
	    'hue-2': '800',
	    'hue-3': 'A100'
	  };
	  if (!LIGHT_DEFAULT_HUES[colorType]) LIGHT_DEFAULT_HUES[colorType] = defaultDefaultHues;
	  if (!DARK_DEFAULT_HUES[colorType]) DARK_DEFAULT_HUES[colorType] = defaultDefaultHues;
	});
	
	var VALID_HUE_VALUES = [
	  '50', '100', '200', '300', '400', '500', '600',
	  '700', '800', '900', 'A100', 'A200', 'A400', 'A700'
	];
	
	var themeConfig = {
	  disableTheming : false,   // Generate our themes at run time; also disable stylesheet DOM injection
	  generateOnDemand : false, // Whether or not themes are to be generated on-demand (vs. eagerly).
	  registeredStyles : [],    // Custom styles registered to be used in the theming of custom components.
	  nonce : null              // Nonce to be added as an attribute to the generated themes style tags.
	};
	
	/**
	 *
	 */
	function ThemingProvider($mdColorPalette, $$mdMetaProvider) {
	  ThemingService.$inject = ["$rootScope", "$mdUtil", "$q", "$log"];
	  PALETTES = { };
	  var THEMES = { };
	
	  var themingProvider;
	
	  var alwaysWatchTheme = false;
	  var defaultTheme = 'default';
	
	  // Load JS Defined Palettes
	  angular.extend(PALETTES, $mdColorPalette);
	
	  // Default theme defined in core.js
	
	  /**
	   * Adds `theme-color` and `msapplication-navbutton-color` meta tags with the color parameter
	   * @param {string} color Hex value of the wanted browser color
	   * @returns {function} Remove function of the meta tags
	   */
	  var setBrowserColor = function (color) {
	    // Chrome, Firefox OS and Opera
	    var removeChrome = $$mdMetaProvider.setMeta('theme-color', color);
	    // Windows Phone
	    var removeWindows = $$mdMetaProvider.setMeta('msapplication-navbutton-color', color);
	
	    return function () {
	      removeChrome();
	      removeWindows();
	    };
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdThemingProvider#enableBrowserColor
	   * @description
	   * Enables browser header coloring. For more info please visit
	   * <a href="https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color">
	   *   Web Fundamentals</a>.
	   * @param {object=} options Options for the browser color, which include:<br/>
	   * - `theme` - `{string}`: A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
	   * - `palette` - `{string}`:  Can be any one of the basic material design palettes, extended defined palettes, or `primary`,
	   *  `accent`, `background`, and `warn`. Default is `primary`.<br/>
	   * - `hue` -  `{string}`: The hue from the selected palette. Default is `800`.<br/>
	   * @returns {function} Function that removes the browser coloring when called.
	   */
	  var enableBrowserColor = function (options) {
	    options = angular.isObject(options) ? options : {};
	
	    var theme = options.theme || 'default';
	    var hue = options.hue || '800';
	
	    var palette = PALETTES[options.palette] ||
	      PALETTES[THEMES[theme].colors[options.palette || 'primary'].name];
	
	    var color = angular.isObject(palette[hue]) ? palette[hue].hex : palette[hue];
	
	    return setBrowserColor(color);
	  };
	
	  return themingProvider = {
	    definePalette: definePalette,
	    extendPalette: extendPalette,
	    theme: registerTheme,
	
	    /**
	     * return a read-only clone of the current theme configuration
	     */
	    configuration : function() {
	      return angular.extend( { }, themeConfig, {
	        defaultTheme : defaultTheme,
	        alwaysWatchTheme : alwaysWatchTheme,
	        registeredStyles : [].concat(themeConfig.registeredStyles)
	      });
	    },
	
	    /**
	     * @ngdoc method
	     * @name $mdThemingProvider#disableTheming
	     * @description
	     * An easier way to disable theming without having to use `.constant("$MD_THEME_CSS","");`.
	     * This disables all dynamic theme style sheet generations and injections.
	     * @param {boolean=} isDisabled Disable all dynamic theme style sheet generations and injections
	     *  if `true` or `undefined`.
	     */
	    disableTheming: function(isDisabled) {
	      themeConfig.disableTheming = angular.isUndefined(isDisabled) || !!isDisabled;
	    },
	
	    /**
	     * @ngdoc method
	     * @name $mdThemingProvider#registerStyles
	     * @param {string} styles The styles to be appended to AngularJS Material's built in theme CSS.
	     */
	    registerStyles: function(styles) {
	      themeConfig.registeredStyles.push(styles);
	    },
	
	    /**
	     * @ngdoc method
	     * @name $mdThemingProvider#setNonce
	     * @param {string} nonceValue The nonce to be added as an attribute to the theme style tags.
	     * Setting a value allows the use of CSP policy without using the unsafe-inline directive.
	     */
	    setNonce: function(nonceValue) {
	      themeConfig.nonce = nonceValue;
	    },
	
	    generateThemesOnDemand: function(onDemand) {
	      themeConfig.generateOnDemand = onDemand;
	    },
	
	    /**
	     * @ngdoc method
	     * @name $mdThemingProvider#setDefaultTheme
	     * @param {string} theme Default theme name to be applied to elements. Default value is `default`.
	     */
	    setDefaultTheme: function(theme) {
	      defaultTheme = theme;
	    },
	
	    /**
	     * @ngdoc method
	     * @name $mdThemingProvider#alwaysWatchTheme
	     * @param {boolean} alwaysWatch Whether or not to always watch themes for changes and re-apply
	     * classes when they change. Default is `false`. Enabling can reduce performance.
	     */
	    alwaysWatchTheme: function(alwaysWatch) {
	      alwaysWatchTheme = alwaysWatch;
	    },
	
	    enableBrowserColor: enableBrowserColor,
	
	    $get: ThemingService,
	    _LIGHT_DEFAULT_HUES: LIGHT_DEFAULT_HUES,
	    _DARK_DEFAULT_HUES: DARK_DEFAULT_HUES,
	    _PALETTES: PALETTES,
	    _THEMES: THEMES,
	    _parseRules: parseRules,
	    _rgba: rgba
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdThemingProvider#definePalette
	   * @description
	   * In the event that you need to define a custom color palette, you can use this function to
	   * make it available to your theme for use in its intention groups.<br>
	   * Note that you must specify all hues in the definition map.
	   * @param {string} name Name of palette being defined
	   * @param {object} map Palette definition that includes hue definitions and contrast colors:
	   * - `'50'` - `{string}`: HEX color
	   * - `'100'` - `{string}`: HEX color
	   * - `'200'` - `{string}`: HEX color
	   * - `'300'` - `{string}`: HEX color
	   * - `'400'` - `{string}`: HEX color
	   * - `'500'` - `{string}`: HEX color
	   * - `'600'` - `{string}`: HEX color
	   * - `'700'` - `{string}`: HEX color
	   * - `'800'` - `{string}`: HEX color
	   * - `'900'` - `{string}`: HEX color
	   * - `'A100'` - `{string}`: HEX color
	   * - `'A200'` - `{string}`: HEX color
	   * - `'A400'` - `{string}`: HEX color
	   * - `'A700'` - `{string}`: HEX color
	   * - `'contrastDefaultColor'` - `{string}`: `light` or `dark`
	   * - `'contrastDarkColors'` - `{string[]}`: Hues which should use dark contrast colors (i.e. raised button text).
	   *  For example: `['50', '100', '200', '300', '400', 'A100']`.
	   * - `'contrastLightColors'` - `{string[]}`: Hues which should use light contrast colors (i.e. raised button text).
	   *  For example: `['500', '600', '700', '800', '900', 'A200', 'A400', 'A700']`.
	   */
	  function definePalette(name, map) {
	    map = map || {};
	    PALETTES[name] = checkPaletteValid(name, map);
	    return themingProvider;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $mdThemingProvider#extendPalette
	   * @description
	   * Sometimes it is easier to extend an existing color palette and then change a few properties,
	   * rather than defining a whole new palette.
	   * @param {string} name Name of palette being extended
	   * @param {object} map Palette definition that includes optional hue definitions and contrast colors:
	   * - `'50'` - `{string}`: HEX color
	   * - `'100'` - `{string}`: HEX color
	   * - `'200'` - `{string}`: HEX color
	   * - `'300'` - `{string}`: HEX color
	   * - `'400'` - `{string}`: HEX color
	   * - `'500'` - `{string}`: HEX color
	   * - `'600'` - `{string}`: HEX color
	   * - `'700'` - `{string}`: HEX color
	   * - `'800'` - `{string}`: HEX color
	   * - `'900'` - `{string}`: HEX color
	   * - `'A100'` - `{string}`: HEX color
	   * - `'A200'` - `{string}`: HEX color
	   * - `'A400'` - `{string}`: HEX color
	   * - `'A700'` - `{string}`: HEX color
	   * - `'contrastDefaultColor'` - `{string}`: `light` or `dark`
	   * - `'contrastDarkColors'` - `{string[]}`: Hues which should use dark contrast colors (i.e. raised button text).
	   *  For example: `['50', '100', '200', '300', '400', 'A100']`.
	   * - `'contrastLightColors'` - `{string[]}`: Hues which should use light contrast colors (i.e. raised button text).
	   *  For example: `['500', '600', '700', '800', '900', 'A200', 'A400', 'A700']`.
	   *  @returns {object} A new object which is a copy of the given palette, `name`,
	   *    with variables from `map` overwritten.
	   */
	  function extendPalette(name, map) {
	    return checkPaletteValid(name,  angular.extend({}, PALETTES[name] || {}, map) );
	  }
	
	  // Make sure that palette has all required hues
	  function checkPaletteValid(name, map) {
	    var missingColors = VALID_HUE_VALUES.filter(function(field) {
	      return !map[field];
	    });
	    if (missingColors.length) {
	      throw new Error("Missing colors %1 in palette %2!"
	                      .replace('%1', missingColors.join(', '))
	                      .replace('%2', name));
	    }
	
	    return map;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $mdThemingProvider#theme
	   * @description
	   * Register a theme (which is a collection of color palettes); i.e. `warn`, `accent`,
	   * `background`, and `primary`.<br>
	   * Optionally inherit from an existing theme.
	   * @param {string} name Name of theme being registered
	   * @param {string=} inheritFrom Existing theme name to inherit from
	   */
	  function registerTheme(name, inheritFrom) {
	    if (THEMES[name]) return THEMES[name];
	
	    inheritFrom = inheritFrom || 'default';
	
	    var parentTheme = typeof inheritFrom === 'string' ? THEMES[inheritFrom] : inheritFrom;
	    var theme = new Theme(name);
	
	    if (parentTheme) {
	      angular.forEach(parentTheme.colors, function(color, colorType) {
	        theme.colors[colorType] = {
	          name: color.name,
	          // Make sure a COPY of the hues is given to the child color,
	          // not the same reference.
	          hues: angular.extend({}, color.hues)
	        };
	      });
	    }
	    THEMES[name] = theme;
	
	    return theme;
	  }
	
	  function Theme(name) {
	    var self = this;
	    self.name = name;
	    self.colors = {};
	
	    self.dark = setDark;
	    setDark(false);
	
	    function setDark(isDark) {
	      isDark = arguments.length === 0 ? true : !!isDark;
	
	      // If no change, abort
	      if (isDark === self.isDark) return;
	
	      self.isDark = isDark;
	
	      self.foregroundPalette = self.isDark ? LIGHT_FOREGROUND : DARK_FOREGROUND;
	      self.foregroundShadow = self.isDark ? DARK_SHADOW : LIGHT_SHADOW;
	
	      // Light and dark themes have different default hues.
	      // Go through each existing color type for this theme, and for every
	      // hue value that is still the default hue value from the previous light/dark setting,
	      // set it to the default hue value from the new light/dark setting.
	      var newDefaultHues = self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES;
	      var oldDefaultHues = self.isDark ? LIGHT_DEFAULT_HUES : DARK_DEFAULT_HUES;
	      angular.forEach(newDefaultHues, function(newDefaults, colorType) {
	        var color = self.colors[colorType];
	        var oldDefaults = oldDefaultHues[colorType];
	        if (color) {
	          for (var hueName in color.hues) {
	            if (color.hues[hueName] === oldDefaults[hueName]) {
	              color.hues[hueName] = newDefaults[hueName];
	            }
	          }
	        }
	      });
	
	      return self;
	    }
	
	    THEME_COLOR_TYPES.forEach(function(colorType) {
	      var defaultHues = (self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES)[colorType];
	      self[colorType + 'Palette'] = function setPaletteType(paletteName, hues) {
	        var color = self.colors[colorType] = {
	          name: paletteName,
	          hues: angular.extend({}, defaultHues, hues)
	        };
	
	        Object.keys(color.hues).forEach(function(name) {
	          if (!defaultHues[name]) {
	            throw new Error("Invalid hue name '%1' in theme %2's %3 color %4. Available hue names: %4"
	              .replace('%1', name)
	              .replace('%2', self.name)
	              .replace('%3', paletteName)
	              .replace('%4', Object.keys(defaultHues).join(', '))
	            );
	          }
	        });
	        Object.keys(color.hues).map(function(key) {
	          return color.hues[key];
	        }).forEach(function(hueValue) {
	          if (VALID_HUE_VALUES.indexOf(hueValue) == -1) {
	            throw new Error("Invalid hue value '%1' in theme %2's %3 color %4. Available hue values: %5"
	              .replace('%1', hueValue)
	              .replace('%2', self.name)
	              .replace('%3', colorType)
	              .replace('%4', paletteName)
	              .replace('%5', VALID_HUE_VALUES.join(', '))
	            );
	          }
	        });
	        return self;
	      };
	
	      self[colorType + 'Color'] = function() {
	        var args = Array.prototype.slice.call(arguments);
	        // eslint-disable-next-line no-console
	        console.warn('$mdThemingProviderTheme.' + colorType + 'Color() has been deprecated. ' +
	                     'Use $mdThemingProviderTheme.' + colorType + 'Palette() instead.');
	        return self[colorType + 'Palette'].apply(self, args);
	      };
	    });
	  }
	
	  /**
	   * @ngdoc service
	   * @name $mdTheming
	   * @module material.core.theming
	   * @description
	   * Service that makes an element apply theming related <b>classes</b> to itself.
	   *
	   * <hljs lang="js">
	   * // Example component directive that we want to apply theming classes to.
	   * app.directive('myFancyDirective', function($mdTheming) {
	   *   return {
	   *     restrict: 'AE',
	   *     link: function(scope, element, attrs) {
	   *       // Initialize the service using our directive's element
	   *       $mdTheming(element);
	   *
	   *       $mdTheming.defineTheme('myTheme', {
	   *         primary: 'blue',
	   *         accent: 'pink',
	   *         dark: true
	   *       });
	   *       // Your directive's custom code here.
	   *     }
	   *   };
	   * });
	   * </hljs>
	   * @param {element=} element Element that will have theming classes applied to it.
	   */
	
	  /**
	   * @ngdoc property
	   * @name $mdTheming#THEMES
	   * @description
	   * Property to get all the themes defined
	   * @returns {object} All the themes defined with their properties.
	   */
	
	  /**
	   * @ngdoc property
	   * @name $mdTheming#PALETTES
	   * @description
	   * Property to get all the palettes defined
	   * @returns {object} All the palettes defined with their colors.
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#registered
	   * @description
	   * Determine is specified theme name is a valid, registered theme
	   * @param {string} themeName the theme to check if registered
	   * @returns {boolean} whether the theme is registered or not
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#defaultTheme
	   * @description
	   * Returns the default theme
	   * @returns {string} The default theme
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#generateTheme
	   * @description
	   * Lazy generate themes - by default, every theme is generated when defined.
	   * You can disable this in the configuration section using the
	   * `$mdThemingProvider.generateThemesOnDemand(true);`
	   *
	   * The theme name that is passed in must match the name of the theme that was defined as part of the configuration block.
	   *
	   * @param name {string} theme name to generate
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#setBrowserColor
	   * @description
	   * Enables browser header coloring. For more info please visit
	   * <a href="https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color">
	   *   Web Fundamentals</a>.
	   * @param {object=} options Options for the browser color, which include:<br/>
	   * - `theme` - `{string}`: A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
	   * - `palette` - `{string}`:  Can be any one of the basic material design palettes, extended defined palettes, or `primary`,
	   *  `accent`, `background`, and `warn`. Default is `primary`.<br/>
	   * - `hue` -  `{string}`: The hue from the selected palette. Default is `800`.<br/>
	   * @returns {function} Function that removes the browser coloring when called.
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#defineTheme
	   * @description
	   * Dynamically define a theme by using an options object that contains palette names.
	   *
	   * @param {string} name Theme name to define
	   * @param {object} options Theme definition options
	   * Options are:<br/>
	   * - `primary` - `{string}`: The name of the primary palette to use in the theme.<br/>
	   * - `accent` - `{string}`: The name of the accent palette to use in the theme.<br/>
	   * - `warn` - `{string}`: The name of the warn palette to use in the theme.<br/>
	   * - `background` - `{string}`: The name of the background palette to use in the theme.<br/>
	   * - `dark` - `{boolean}`: Indicates if it's a dark theme.<br/>
	   * @returns {Promise<string>} A resolved promise with the new theme name.
	   */
	
	  /* @ngInject */
	  function ThemingService($rootScope, $mdUtil, $q, $log) {
	    // Allow us to be invoked via a linking function signature.
	    var applyTheme = function (scope, el) {
	      if (el === undefined) { el = scope; scope = undefined; }
	      if (scope === undefined) { scope = $rootScope; }
	      applyTheme.inherit(el, el);
	    };
	
	    Object.defineProperty(applyTheme, 'THEMES', {
	      get: function () {
	        return angular.extend({}, THEMES);
	      }
	    });
	    Object.defineProperty(applyTheme, 'PALETTES', {
	      get: function () {
	        return angular.extend({}, PALETTES);
	      }
	    });
	    Object.defineProperty(applyTheme, 'ALWAYS_WATCH', {
	      get: function () {
	        return alwaysWatchTheme;
	      }
	    });
	    applyTheme.inherit = inheritTheme;
	    applyTheme.registered = registered;
	    applyTheme.defaultTheme = function() { return defaultTheme; };
	    applyTheme.generateTheme = function(name) { generateTheme(THEMES[name], name, themeConfig.nonce); };
	    applyTheme.defineTheme = function(name, options) {
	      options = options || {};
	
	      var theme = registerTheme(name);
	
	      if (options.primary) {
	        theme.primaryPalette(options.primary);
	      }
	      if (options.accent) {
	        theme.accentPalette(options.accent);
	      }
	      if (options.warn) {
	        theme.warnPalette(options.warn);
	      }
	      if (options.background) {
	        theme.backgroundPalette(options.background);
	      }
	      if (options.dark){
	        theme.dark();
	      }
	
	      this.generateTheme(name);
	
	      return $q.resolve(name);
	    };
	    applyTheme.setBrowserColor = enableBrowserColor;
	
	    return applyTheme;
	
	    /**
	     * Determine is specified theme name is a valid, registered theme
	     */
	    function registered(themeName) {
	      if (themeName === undefined || themeName === '') return true;
	      return applyTheme.THEMES[themeName] !== undefined;
	    }
	
	    /**
	     * Get theme name for the element, then update with Theme CSS class
	     */
	    function inheritTheme (el, parent) {
	      var ctrl = parent.controller('mdTheme') || el.data('$mdThemeController');
	      var scope = el.scope();
	
	      updateThemeClass(lookupThemeName());
	
	      if (ctrl) {
	        var watchTheme = alwaysWatchTheme ||
	                         ctrl.$shouldWatch ||
	                         $mdUtil.parseAttributeBoolean(el.attr('md-theme-watch'));
	
	        if (watchTheme || ctrl.isAsyncTheme) {
	          var clearNameWatcher = function () {
	            if (unwatch) {
	              unwatch();
	              unwatch = undefined;
	            }
	          };
	
	          var unwatch = ctrl.registerChanges(function(name) {
	            updateThemeClass(name);
	
	            if (!watchTheme) {
	              clearNameWatcher();
	            }
	          });
	
	          if (scope) {
	            scope.$on('$destroy', clearNameWatcher);
	          } else {
	            el.on('$destroy', clearNameWatcher);
	          }
	        }
	      }
	
	      /**
	       * Find the theme name from the parent controller or element data
	       */
	      function lookupThemeName() {
	        // As a few components (dialog) add their controllers later, we should also watch for a controller init.
	        return ctrl && ctrl.$mdTheme || (defaultTheme === 'default' ? '' : defaultTheme);
	      }
	
	      /**
	       * Remove old theme class and apply a new one
	       * NOTE: if not a valid theme name, then the current name is not changed
	       */
	      function updateThemeClass(theme) {
	        if (!theme) return;
	        if (!registered(theme)) {
	          $log.warn('Attempted to use unregistered theme \'' + theme + '\'. ' +
	                    'Register it with $mdThemingProvider.theme().');
	        }
	
	        var oldTheme = el.data('$mdThemeName');
	        if (oldTheme) el.removeClass('md-' + oldTheme +'-theme');
	        el.addClass('md-' + theme + '-theme');
	        el.data('$mdThemeName', theme);
	        if (ctrl) {
	          el.data('$mdThemeController', ctrl);
	        }
	      }
	    }
	
	  }
	}
	
	function ThemingDirective($mdTheming, $interpolate, $parse, $mdUtil, $q, $log) {
	  return {
	    priority: 101, // has to be more than 100 to be before interpolation (issue on IE)
	    link: {
	      pre: function(scope, el, attrs) {
	        var registeredCallbacks = [];
	
	        var startSymbol = $interpolate.startSymbol();
	        var endSymbol = $interpolate.endSymbol();
	
	        var theme = attrs.mdTheme.trim();
	
	        var hasInterpolation =
	          theme.substr(0, startSymbol.length) === startSymbol &&
	          theme.lastIndexOf(endSymbol) === theme.length - endSymbol.length;
	
	        var oneTimeOperator = '::';
	        var oneTimeBind = attrs.mdTheme
	            .split(startSymbol).join('')
	            .split(endSymbol).join('')
	            .trim()
	            .substr(0, oneTimeOperator.length) === oneTimeOperator;
	
	        var getTheme = function () {
	          var interpolation = $interpolate(attrs.mdTheme)(scope);
	          return $parse(interpolation)(scope) || interpolation;
	        };
	
	        var ctrl = {
	          isAsyncTheme: angular.isFunction(getTheme()) || angular.isFunction(getTheme().then),
	          registerChanges: function (cb, context) {
	            if (context) {
	              cb = angular.bind(context, cb);
	            }
	
	            registeredCallbacks.push(cb);
	
	            return function () {
	              var index = registeredCallbacks.indexOf(cb);
	
	              if (index > -1) {
	                registeredCallbacks.splice(index, 1);
	              }
	            };
	          },
	          $setTheme: function (theme) {
	            if (!$mdTheming.registered(theme)) {
	              $log.warn('attempted to use unregistered theme \'' + theme + '\'');
	            }
	
	            ctrl.$mdTheme = theme;
	
	            // Iterating backwards to support unregistering during iteration
	            // http://stackoverflow.com/a/9882349/890293
	            // we don't use `reverse()` of array because it mutates the array and we don't want it
	            // to get re-indexed
	            for (var i = registeredCallbacks.length; i--;) {
	              registeredCallbacks[i](theme);
	            }
	          },
	          $shouldWatch: $mdUtil.parseAttributeBoolean(el.attr('md-theme-watch')) ||
	                        $mdTheming.ALWAYS_WATCH ||
	                        (hasInterpolation && !oneTimeBind)
	        };
	
	        el.data('$mdThemeController', ctrl);
	
	        var setParsedTheme = function (theme) {
	          if (typeof theme === 'string') {
	            return ctrl.$setTheme(theme);
	          }
	
	          $q.when( angular.isFunction(theme) ?  theme() : theme )
	            .then(function(name) {
	              ctrl.$setTheme(name);
	            });
	        };
	
	        setParsedTheme(getTheme());
	
	        var unwatch = scope.$watch(getTheme, function(theme) {
	          if (theme) {
	            setParsedTheme(theme);
	
	            if (!ctrl.$shouldWatch) {
	              unwatch();
	            }
	          }
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Special directive that will disable ALL runtime Theme style generation and DOM injection
	 *
	 * <link rel="stylesheet" href="angular-material.min.css">
	 * <link rel="stylesheet" href="angular-material.themes.css">
	 *
	 * <body md-themes-disabled>
	 *  ...
	 * </body>
	 *
	 * Note: Using md-themes-css directive requires the developer to load external
	 * theme stylesheets; e.g. custom themes from Material-Tools:
	 *
	 *       `angular-material.themes.css`
	 *
	 * Another option is to use the ThemingProvider to configure and disable the attribute
	 * conversions; this would obviate the use of the `md-themes-css` directive
	 *
	 */
	function disableThemesDirective() {
	  themeConfig.disableTheming = true;
	
	  // Return a 1x-only, first-match attribute directive
	  return {
	    restrict : 'A',
	    priority : '900'
	  };
	}
	
	function ThemableDirective($mdTheming) {
	  return $mdTheming;
	}
	
	function parseRules(theme, colorType, rules) {
	  checkValidPalette(theme, colorType);
	
	  rules = rules.replace(/THEME_NAME/g, theme.name);
	  var themeNameRegex = new RegExp('\\.md-' + theme.name + '-theme', 'g');
	  var simpleVariableRegex = /'?"?\{\{\s*([a-zA-Z]+)-(A?\d+|hue-[0-3]|shadow|default)-?(\d\.?\d*)?(contrast)?\s*\}\}'?"?/g;
	
	  // find and replace simple variables where we use a specific hue, not an entire palette
	  // eg. "{{primary-100}}"
	  //\(' + THEME_COLOR_TYPES.join('\|') + '\)'
	  rules = rules.replace(simpleVariableRegex, function(match, colorType, hue, opacity, contrast) {
	    if (colorType === 'foreground') {
	      if (hue == 'shadow') {
	        return theme.foregroundShadow;
	      } else {
	        return theme.foregroundPalette[hue] || theme.foregroundPalette['1'];
	      }
	    }
	
	    // `default` is also accepted as a hue-value, because the background palettes are
	    // using it as a name for the default hue.
	    if (hue.indexOf('hue') === 0 || hue === 'default') {
	      hue = theme.colors[colorType].hues[hue];
	    }
	
	    return rgba( (PALETTES[ theme.colors[colorType].name ][hue] || '')[contrast ? 'contrast' : 'value'], opacity );
	  });
	
	  // Matches '{{ primary-color }}', etc
	  var hueRegex = new RegExp('(\'|")?{{\\s*([a-zA-Z]+)-(color|contrast)-?(\\d\\.?\\d*)?\\s*}}("|\')?','g');
	  var generatedRules = [];
	
	  // For each type, generate rules for each hue (ie. default, md-hue-1, md-hue-2, md-hue-3)
	  angular.forEach(['default', 'hue-1', 'hue-2', 'hue-3'], function(hueName) {
	    var newRule = rules
	      .replace(hueRegex, function(match, _, matchedColorType, hueType, opacity) {
	        var color = theme.colors[matchedColorType];
	        var palette = PALETTES[color.name];
	        var hueValue = color.hues[hueName];
	        return rgba(palette[hueValue][hueType === 'color' ? 'value' : 'contrast'], opacity);
	      });
	    if (hueName !== 'default') {
	      newRule = newRule.replace(themeNameRegex, '.md-' + theme.name + '-theme.md-' + hueName);
	    }
	
	    // Don't apply a selector rule to the default theme, making it easier to override
	    // styles of the base-component
	    if (theme.name == 'default') {
	      var themeRuleRegex = /((?:\s|>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)*)\.md-default-theme((?:\s|>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)*)/g;
	
	      newRule = newRule.replace(themeRuleRegex, function(match, start, end) {
	        return match + ', ' + start + end;
	      });
	    }
	    generatedRules.push(newRule);
	  });
	
	  return generatedRules;
	}
	
	var rulesByType = {};
	
	// Generate our themes at run time given the state of THEMES and PALETTES
	function generateAllThemes($injector, $mdTheming) {
	  var head = document.head;
	  var firstChild = head ? head.firstElementChild : null;
	  var themeCss = !themeConfig.disableTheming && $injector.has('$MD_THEME_CSS') ? $injector.get('$MD_THEME_CSS') : '';
	
	  // Append our custom registered styles to the theme stylesheet.
	  themeCss += themeConfig.registeredStyles.join('');
	
	  if ( !firstChild ) return;
	  if (themeCss.length === 0) return; // no rules, so no point in running this expensive task
	
	  // Expose contrast colors for palettes to ensure that text is always readable
	  angular.forEach(PALETTES, sanitizePalette);
	
	  // MD_THEME_CSS is a string generated by the build process that includes all the themable
	  // components as templates
	
	  // Break the CSS into individual rules
	  var rules = themeCss
	                  .split(/\}(?!(\}|'|"|;))/)
	                  .filter(function(rule) { return rule && rule.trim().length; })
	                  .map(function(rule) { return rule.trim() + '}'; });
	
	  THEME_COLOR_TYPES.forEach(function(type) {
	    rulesByType[type] = '';
	  });
	
	  // Sort the rules based on type, allowing us to do color substitution on a per-type basis
	  rules.forEach(function(rule) {
	    // First: test that if the rule has '.md-accent', it goes into the accent set of rules
	    for (var i = 0, type; type = THEME_COLOR_TYPES[i]; i++) {
	      if (rule.indexOf('.md-' + type) > -1) {
	        return rulesByType[type] += rule;
	      }
	    }
	
	    // If no eg 'md-accent' class is found, try to just find 'accent' in the rule and guess from
	    // there
	    for (i = 0; type = THEME_COLOR_TYPES[i]; i++) {
	      if (rule.indexOf(type) > -1) {
	        return rulesByType[type] += rule;
	      }
	    }
	
	    // Default to the primary array
	    return rulesByType[DEFAULT_COLOR_TYPE] += rule;
	  });
	
	  // If themes are being generated on-demand, quit here. The user will later manually
	  // call generateTheme to do this on a theme-by-theme basis.
	  if (themeConfig.generateOnDemand) return;
	
	  angular.forEach($mdTheming.THEMES, function(theme) {
	    if (!GENERATED[theme.name] && !($mdTheming.defaultTheme() !== 'default' && theme.name === 'default')) {
	      generateTheme(theme, theme.name, themeConfig.nonce);
	    }
	  });
	
	
	  // *************************
	  // Internal functions
	  // *************************
	
	  // The user specifies a 'default' contrast color as either light or dark,
	  // then explicitly lists which hues are the opposite contrast (eg. A100 has dark, A200 has light)
	  function sanitizePalette(palette, name) {
	    var defaultContrast = palette.contrastDefaultColor;
	    var lightColors = palette.contrastLightColors || [];
	    var strongLightColors = palette.contrastStrongLightColors || [];
	    var darkColors = palette.contrastDarkColors || [];
	
	    // These colors are provided as space-separated lists
	    if (typeof lightColors === 'string') lightColors = lightColors.split(' ');
	    if (typeof strongLightColors === 'string') strongLightColors = strongLightColors.split(' ');
	    if (typeof darkColors === 'string') darkColors = darkColors.split(' ');
	
	    // Cleanup after ourselves
	    delete palette.contrastDefaultColor;
	    delete palette.contrastLightColors;
	    delete palette.contrastStrongLightColors;
	    delete palette.contrastDarkColors;
	
	    // Change { 'A100': '#fffeee' } to { 'A100': { value: '#fffeee', contrast:DARK_CONTRAST_COLOR }
	    angular.forEach(palette, function(hueValue, hueName) {
	      if (angular.isObject(hueValue)) return; // Already converted
	      // Map everything to rgb colors
	      var rgbValue = colorToRgbaArray(hueValue);
	      if (!rgbValue) {
	        throw new Error("Color %1, in palette %2's hue %3, is invalid. Hex or rgb(a) color expected."
	                        .replace('%1', hueValue)
	                        .replace('%2', palette.name)
	                        .replace('%3', hueName));
	      }
	
	      palette[hueName] = {
	        hex: palette[hueName],
	        value: rgbValue,
	        contrast: getContrastColor()
	      };
	      function getContrastColor() {
	        if (defaultContrast === 'light') {
	          if (darkColors.indexOf(hueName) > -1) {
	            return DARK_CONTRAST_COLOR;
	          } else {
	            return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
	              : LIGHT_CONTRAST_COLOR;
	          }
	        } else {
	          if (lightColors.indexOf(hueName) > -1) {
	            return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
	              : LIGHT_CONTRAST_COLOR;
	          } else {
	            return DARK_CONTRAST_COLOR;
	          }
	        }
	      }
	    });
	  }
	}
	
	function generateTheme(theme, name, nonce) {
	  var head = document.head;
	  var firstChild = head ? head.firstElementChild : null;
	
	  if (!GENERATED[name]) {
	    // For each theme, use the color palettes specified for
	    // `primary`, `warn` and `accent` to generate CSS rules.
	    THEME_COLOR_TYPES.forEach(function(colorType) {
	      var styleStrings = parseRules(theme, colorType, rulesByType[colorType]);
	      while (styleStrings.length) {
	        var styleContent = styleStrings.shift();
	        if (styleContent) {
	          var style = document.createElement('style');
	          style.setAttribute('md-theme-style', '');
	          if (nonce) {
	            style.setAttribute('nonce', nonce);
	          }
	          style.appendChild(document.createTextNode(styleContent));
	          head.insertBefore(style, firstChild);
	        }
	      }
	    });
	
	    GENERATED[theme.name] = true;
	  }
	
	}
	
	
	function checkValidPalette(theme, colorType) {
	  // If theme attempts to use a palette that doesnt exist, throw error
	  if (!PALETTES[ (theme.colors[colorType] || {}).name ]) {
	    throw new Error(
	      "You supplied an invalid color palette for theme %1's %2 palette. Available palettes: %3"
	                    .replace('%1', theme.name)
	                    .replace('%2', colorType)
	                    .replace('%3', Object.keys(PALETTES).join(', '))
	    );
	  }
	}
	
	function colorToRgbaArray(clr) {
	  if (angular.isArray(clr) && clr.length == 3) return clr;
	  if (/^rgb/.test(clr)) {
	    return clr.replace(/(^\s*rgba?\(|\)\s*$)/g, '').split(',').map(function(value, i) {
	      return i == 3 ? parseFloat(value, 10) : parseInt(value, 10);
	    });
	  }
	  if (clr.charAt(0) == '#') clr = clr.substring(1);
	  if (!/^([a-fA-F0-9]{3}){1,2}$/g.test(clr)) return;
	
	  var dig = clr.length / 3;
	  var red = clr.substr(0, dig);
	  var grn = clr.substr(dig, dig);
	  var blu = clr.substr(dig * 2);
	  if (dig === 1) {
	    red += red;
	    grn += grn;
	    blu += blu;
	  }
	  return [parseInt(red, 16), parseInt(grn, 16), parseInt(blu, 16)];
	}
	
	function rgba(rgbArray, opacity) {
	  if ( !rgbArray ) return "rgb('0,0,0')";
	
	  if (rgbArray.length == 4) {
	    rgbArray = angular.copy(rgbArray);
	    opacity ? rgbArray.pop() : opacity = rgbArray.pop();
	  }
	  return opacity && (typeof opacity == 'number' || (typeof opacity == 'string' && opacity.length)) ?
	    'rgba(' + rgbArray.join(',') + ',' + opacity + ')' :
	    'rgb(' + rgbArray.join(',') + ')';
	}
	
	
	})(window.angular);
	
	})();
	(function(){
	"use strict";
	
	// Polyfill angular < 1.4 (provide $animateCss)
	angular
	  .module('material.core')
	  .factory('$$mdAnimate', ["$q", "$timeout", "$mdConstant", "$animateCss", function($q, $timeout, $mdConstant, $animateCss){
	
	     // Since $$mdAnimate is injected into $mdUtil... use a wrapper function
	     // to subsequently inject $mdUtil as an argument to the AnimateDomUtils
	
	     return function($mdUtil) {
	       return AnimateDomUtils( $mdUtil, $q, $timeout, $mdConstant, $animateCss);
	     };
	   }]);
	
	/**
	 * Factory function that requires special injections
	 */
	function AnimateDomUtils($mdUtil, $q, $timeout, $mdConstant, $animateCss) {
	  var self;
	  return self = {
	    /**
	     *
	     */
	    translate3d : function( target, from, to, options ) {
	      return $animateCss(target, {
	        from: from,
	        to: to,
	        addClass: options.transitionInClass,
	        removeClass: options.transitionOutClass,
	        duration: options.duration
	      })
	      .start()
	      .then(function(){
	          // Resolve with reverser function...
	          return reverseTranslate;
	      });
	
	      /**
	       * Specific reversal of the request translate animation above...
	       */
	      function reverseTranslate (newFrom) {
	        return $animateCss(target, {
	           to: newFrom || from,
	           addClass: options.transitionOutClass,
	           removeClass: options.transitionInClass,
	           duration: options.duration
	        }).start();
	
	      }
	    },
	
	    /**
	     * Listen for transitionEnd event (with optional timeout)
	     * Announce completion or failure via promise handlers
	     */
	    waitTransitionEnd: function (element, opts) {
	      var TIMEOUT = 3000; // fallback is 3 secs
	
	      return $q(function(resolve, reject){
	        opts = opts || { };
	
	        // If there is no transition is found, resolve immediately
	        //
	        // NOTE: using $mdUtil.nextTick() causes delays/issues
	        if (noTransitionFound(opts.cachedTransitionStyles)) {
	          TIMEOUT = 0;
	        }
	
	        var timer = $timeout(finished, opts.timeout || TIMEOUT);
	        element.on($mdConstant.CSS.TRANSITIONEND, finished);
	
	        /**
	         * Upon timeout or transitionEnd, reject or resolve (respectively) this promise.
	         * NOTE: Make sure this transitionEnd didn't bubble up from a child
	         */
	        function finished(ev) {
	          if ( ev && ev.target !== element[0]) return;
	
	          if ( ev  ) $timeout.cancel(timer);
	          element.off($mdConstant.CSS.TRANSITIONEND, finished);
	
	          // Never reject since ngAnimate may cause timeouts due missed transitionEnd events
	          resolve();
	
	        }
	
	        /**
	         * Checks whether or not there is a transition.
	         *
	         * @param styles The cached styles to use for the calculation. If null, getComputedStyle()
	         * will be used.
	         *
	         * @returns {boolean} True if there is no transition/duration; false otherwise.
	         */
	        function noTransitionFound(styles) {
	          styles = styles || window.getComputedStyle(element[0]);
	
	          return styles.transitionDuration == '0s' || (!styles.transition && !styles.transitionProperty);
	        }
	
	      });
	    },
	
	    calculateTransformValues: function (element, originator) {
	      var origin = originator.element;
	      var bounds = originator.bounds;
	
	      if (origin || bounds) {
	        var originBnds = origin ? self.clientRect(origin) || currentBounds() : self.copyRect(bounds);
	        var dialogRect = self.copyRect(element[0].getBoundingClientRect());
	        var dialogCenterPt = self.centerPointFor(dialogRect);
	        var originCenterPt = self.centerPointFor(originBnds);
	
	        return {
	          centerX: originCenterPt.x - dialogCenterPt.x,
	          centerY: originCenterPt.y - dialogCenterPt.y,
	          scaleX: Math.round(100 * Math.min(0.5, originBnds.width / dialogRect.width)) / 100,
	          scaleY: Math.round(100 * Math.min(0.5, originBnds.height / dialogRect.height)) / 100
	        };
	      }
	      return {centerX: 0, centerY: 0, scaleX: 0.5, scaleY: 0.5};
	
	      /**
	       * This is a fallback if the origin information is no longer valid, then the
	       * origin bounds simply becomes the current bounds for the dialogContainer's parent
	       */
	      function currentBounds() {
	        var cntr = element ? element.parent() : null;
	        var parent = cntr ? cntr.parent() : null;
	
	        return parent ? self.clientRect(parent) : null;
	      }
	    },
	
	    /**
	     * Calculate the zoom transform from dialog to origin.
	     *
	     * We use this to set the dialog position immediately;
	     * then the md-transition-in actually translates back to
	     * `translate3d(0,0,0) scale(1.0)`...
	     *
	     * NOTE: all values are rounded to the nearest integer
	     */
	    calculateZoomToOrigin: function (element, originator) {
	      var zoomTemplate = "translate3d( {centerX}px, {centerY}px, 0 ) scale( {scaleX}, {scaleY} )";
	      var buildZoom = angular.bind(null, $mdUtil.supplant, zoomTemplate);
	
	      return buildZoom(self.calculateTransformValues(element, originator));
	    },
	
	    /**
	     * Calculate the slide transform from panel to origin.
	     * NOTE: all values are rounded to the nearest integer
	     */
	    calculateSlideToOrigin: function (element, originator) {
	      var slideTemplate = "translate3d( {centerX}px, {centerY}px, 0 )";
	      var buildSlide = angular.bind(null, $mdUtil.supplant, slideTemplate);
	
	      return buildSlide(self.calculateTransformValues(element, originator));
	    },
	
	    /**
	     * Enhance raw values to represent valid css stylings...
	     */
	    toCss : function( raw ) {
	      var css = { };
	      var lookups = 'left top right bottom width height x y min-width min-height max-width max-height';
	
	      angular.forEach(raw, function(value,key) {
	        if ( angular.isUndefined(value) ) return;
	
	        if ( lookups.indexOf(key) >= 0 ) {
	          css[key] = value + 'px';
	        } else {
	          switch (key) {
	            case 'transition':
	              convertToVendor(key, $mdConstant.CSS.TRANSITION, value);
	              break;
	            case 'transform':
	              convertToVendor(key, $mdConstant.CSS.TRANSFORM, value);
	              break;
	            case 'transformOrigin':
	              convertToVendor(key, $mdConstant.CSS.TRANSFORM_ORIGIN, value);
	              break;
	            case 'font-size':
	              css['font-size'] = value; // font sizes aren't always in px
	              break;
	          }
	        }
	      });
	
	      return css;
	
	      function convertToVendor(key, vendor, value) {
	        angular.forEach(vendor.split(' '), function (key) {
	          css[key] = value;
	        });
	      }
	    },
	
	    /**
	     * Convert the translate CSS value to key/value pair(s).
	     */
	    toTransformCss: function (transform, addTransition, transition) {
	      var css = {};
	      angular.forEach($mdConstant.CSS.TRANSFORM.split(' '), function (key) {
	        css[key] = transform;
	      });
	
	      if (addTransition) {
	        transition = transition || "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1) !important";
	        css.transition = transition;
	      }
	
	      return css;
	    },
	
	    /**
	     *  Clone the Rect and calculate the height/width if needed
	     */
	    copyRect: function (source, destination) {
	      if (!source) return null;
	
	      destination = destination || {};
	
	      angular.forEach('left top right bottom width height'.split(' '), function (key) {
	        destination[key] = Math.round(source[key]);
	      });
	
	      destination.width = destination.width || (destination.right - destination.left);
	      destination.height = destination.height || (destination.bottom - destination.top);
	
	      return destination;
	    },
	
	    /**
	     * Calculate ClientRect of element; return null if hidden or zero size
	     */
	    clientRect: function (element) {
	      var bounds = angular.element(element)[0].getBoundingClientRect();
	      var isPositiveSizeClientRect = function (rect) {
	        return rect && (rect.width > 0) && (rect.height > 0);
	      };
	
	      // If the event origin element has zero size, it has probably been hidden.
	      return isPositiveSizeClientRect(bounds) ? self.copyRect(bounds) : null;
	    },
	
	    /**
	     *  Calculate 'rounded' center point of Rect
	     */
	    centerPointFor: function (targetRect) {
	      return targetRect ? {
	        x: Math.round(targetRect.left + (targetRect.width / 2)),
	        y: Math.round(targetRect.top + (targetRect.height / 2))
	      } : { x : 0, y : 0 };
	    }
	
	  };
	}
	
	
	})();
	(function(){
	"use strict";
	
	if (angular.version.minor >= 4) {
	  angular.module('material.core.animate', []);
	} else {
	(function() {
	  "use strict";
	
	  var forEach = angular.forEach;
	
	  var WEBKIT = angular.isDefined(document.documentElement.style.WebkitAppearance);
	  var TRANSITION_PROP = WEBKIT ? 'WebkitTransition' : 'transition';
	  var ANIMATION_PROP = WEBKIT ? 'WebkitAnimation' : 'animation';
	  var PREFIX = WEBKIT ? '-webkit-' : '';
	
	  var TRANSITION_EVENTS = (WEBKIT ? 'webkitTransitionEnd ' : '') + 'transitionend';
	  var ANIMATION_EVENTS = (WEBKIT ? 'webkitAnimationEnd ' : '') + 'animationend';
	
	  var $$ForceReflowFactory = ['$document', function($document) {
	    return function() {
	      return $document[0].body.clientWidth + 1;
	    };
	  }];
	
	  var $$rAFMutexFactory = ['$$rAF', function($$rAF) {
	    return function() {
	      var passed = false;
	      $$rAF(function() {
	        passed = true;
	      });
	      return function(fn) {
	        passed ? fn() : $$rAF(fn);
	      };
	    };
	  }];
	
	  var $$AnimateRunnerFactory = ['$q', '$$rAFMutex', function($q, $$rAFMutex) {
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      this._doneCallbacks = [];
	      this._runInAnimationFrame = $$rAFMutex();
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: angular.noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              status === false ? reject() : resolve();
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._runInAnimationFrame(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    // Polyfill AnimateRunner.all which is used by input animations
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	
	  angular
	    .module('material.core.animate', [])
	    .factory('$$forceReflow', $$ForceReflowFactory)
	    .factory('$$AnimateRunner', $$AnimateRunnerFactory)
	    .factory('$$rAFMutex', $$rAFMutexFactory)
	    .factory('$animateCss', ['$window', '$$rAF', '$$AnimateRunner', '$$forceReflow', '$$jqLite', '$timeout', '$animate',
	                     function($window,   $$rAF,   $$AnimateRunner,   $$forceReflow,   $$jqLite,   $timeout, $animate) {
	
	      function init(element, options) {
	
	        var temporaryStyles = [];
	        var node = getDomNode(element);
	        var areAnimationsAllowed = node && $animate.enabled();
	
	        var hasCompleteStyles = false;
	        var hasCompleteClasses = false;
	
	        if (areAnimationsAllowed) {
	          if (options.transitionStyle) {
	            temporaryStyles.push([PREFIX + 'transition', options.transitionStyle]);
	          }
	
	          if (options.keyframeStyle) {
	            temporaryStyles.push([PREFIX + 'animation', options.keyframeStyle]);
	          }
	
	          if (options.delay) {
	            temporaryStyles.push([PREFIX + 'transition-delay', options.delay + 's']);
	          }
	
	          if (options.duration) {
	            temporaryStyles.push([PREFIX + 'transition-duration', options.duration + 's']);
	          }
	
	          hasCompleteStyles = options.keyframeStyle ||
	              (options.to && (options.duration > 0 || options.transitionStyle));
	          hasCompleteClasses = !!options.addClass || !!options.removeClass;
	
	          blockTransition(element, true);
	        }
	
	        var hasCompleteAnimation = areAnimationsAllowed && (hasCompleteStyles || hasCompleteClasses);
	
	        applyAnimationFromStyles(element, options);
	
	        var animationClosed = false;
	        var events, eventFn;
	
	        return {
	          close: $window.close,
	          start: function() {
	            var runner = new $$AnimateRunner();
	            waitUntilQuiet(function() {
	              blockTransition(element, false);
	              if (!hasCompleteAnimation) {
	                return close();
	              }
	
	              forEach(temporaryStyles, function(entry) {
	                var key = entry[0];
	                var value = entry[1];
	                node.style[camelCase(key)] = value;
	              });
	
	              applyClasses(element, options);
	
	              var timings = computeTimings(element);
	              if (timings.duration === 0) {
	                return close();
	              }
	
	              var moreStyles = [];
	
	              if (options.easing) {
	                if (timings.transitionDuration) {
	                  moreStyles.push([PREFIX + 'transition-timing-function', options.easing]);
	                }
	                if (timings.animationDuration) {
	                  moreStyles.push([PREFIX + 'animation-timing-function', options.easing]);
	                }
	              }
	
	              if (options.delay && timings.animationDelay) {
	                moreStyles.push([PREFIX + 'animation-delay', options.delay + 's']);
	              }
	
	              if (options.duration && timings.animationDuration) {
	                moreStyles.push([PREFIX + 'animation-duration', options.duration + 's']);
	              }
	
	              forEach(moreStyles, function(entry) {
	                var key = entry[0];
	                var value = entry[1];
	                node.style[camelCase(key)] = value;
	                temporaryStyles.push(entry);
	              });
	
	              var maxDelay = timings.delay;
	              var maxDelayTime = maxDelay * 1000;
	              var maxDuration = timings.duration;
	              var maxDurationTime = maxDuration * 1000;
	              var startTime = Date.now();
	
	              events = [];
	              if (timings.transitionDuration) {
	                events.push(TRANSITION_EVENTS);
	              }
	              if (timings.animationDuration) {
	                events.push(ANIMATION_EVENTS);
	              }
	              events = events.join(' ');
	              eventFn = function(event) {
	                event.stopPropagation();
	                var ev = event.originalEvent || event;
	                var timeStamp = ev.timeStamp || Date.now();
	                var elapsedTime = parseFloat(ev.elapsedTime.toFixed(3));
	                if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	                  close();
	                }
	              };
	              element.on(events, eventFn);
	
	              applyAnimationToStyles(element, options);
	
	              $timeout(close, maxDelayTime + maxDurationTime * 1.5, false);
	            });
	
	            return runner;
	
	            function close() {
	              if (animationClosed) return;
	              animationClosed = true;
	
	              if (events && eventFn) {
	                element.off(events, eventFn);
	              }
	              applyClasses(element, options);
	              applyAnimationStyles(element, options);
	              forEach(temporaryStyles, function(entry) {
	                node.style[camelCase(entry[0])] = '';
	              });
	              runner.complete(true);
	              return runner;
	            }
	          }
	        };
	      }
	
	      function applyClasses(element, options) {
	        if (options.addClass) {
	          $$jqLite.addClass(element, options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          $$jqLite.removeClass(element, options.removeClass);
	          options.removeClass = null;
	        }
	      }
	
	      function computeTimings(element) {
	        var node = getDomNode(element);
	        var cs = $window.getComputedStyle(node);
	        var tdr = parseMaxTime(cs[prop('transitionDuration')]);
	        var adr = parseMaxTime(cs[prop('animationDuration')]);
	        var tdy = parseMaxTime(cs[prop('transitionDelay')]);
	        var ady = parseMaxTime(cs[prop('animationDelay')]);
	
	        adr *= (parseInt(cs[prop('animationIterationCount')], 10) || 1);
	        var duration = Math.max(adr, tdr);
	        var delay = Math.max(ady, tdy);
	
	        return {
	          duration: duration,
	          delay: delay,
	          animationDuration: adr,
	          transitionDuration: tdr,
	          animationDelay: ady,
	          transitionDelay: tdy
	        };
	
	        function prop(key) {
	          return WEBKIT ? 'Webkit' + key.charAt(0).toUpperCase() + key.substr(1)
	                        : key;
	        }
	      }
	
	      function parseMaxTime(str) {
	        var maxValue = 0;
	        var values = (str || "").split(/\s*,\s*/);
	        forEach(values, function(value) {
	          // it's always safe to consider only second values and omit `ms` values since
	          // getComputedStyle will always handle the conversion for us
	          if (value.charAt(value.length - 1) == 's') {
	            value = value.substring(0, value.length - 1);
	          }
	          value = parseFloat(value) || 0;
	          maxValue = maxValue ? Math.max(value, maxValue) : value;
	        });
	        return maxValue;
	      }
	
	      var cancelLastRAFRequest;
	      var rafWaitQueue = [];
	      function waitUntilQuiet(callback) {
	        if (cancelLastRAFRequest) {
	          cancelLastRAFRequest(); //cancels the request
	        }
	        rafWaitQueue.push(callback);
	        cancelLastRAFRequest = $$rAF(function() {
	          cancelLastRAFRequest = null;
	
	          // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	          // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	          var pageWidth = $$forceReflow();
	
	          // we use a for loop to ensure that if the queue is changed
	          // during this looping then it will consider new requests
	          for (var i = 0; i < rafWaitQueue.length; i++) {
	            rafWaitQueue[i](pageWidth);
	          }
	          rafWaitQueue.length = 0;
	        });
	      }
	
	      function applyAnimationStyles(element, options) {
	        applyAnimationFromStyles(element, options);
	        applyAnimationToStyles(element, options);
	      }
	
	      function applyAnimationFromStyles(element, options) {
	        if (options.from) {
	          element.css(options.from);
	          options.from = null;
	        }
	      }
	
	      function applyAnimationToStyles(element, options) {
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	
	      function getDomNode(element) {
	        for (var i = 0; i < element.length; i++) {
	          if (element[i].nodeType === 1) return element[i];
	        }
	      }
	
	      function blockTransition(element, bool) {
	        var node = getDomNode(element);
	        var key = camelCase(PREFIX + 'transition-delay');
	        node.style[key] = bool ? '-9999s' : '';
	      }
	
	      return init;
	    }]);
	
	  /**
	   * Older browsers [FF31] expect camelCase
	   * property keys.
	   * e.g.
	   *  animation-duration --> animationDuration
	   */
	  function camelCase(str) {
	    return str.replace(/-[a-z]/g, function(str) {
	      return str.charAt(1).toUpperCase();
	    });
	  }
	
	})();
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.autocomplete
	 */
	/*
	 * @see js folder for autocomplete implementation
	 */
	angular.module('material.components.autocomplete', [
	  'material.core',
	  'material.components.icon',
	  'material.components.virtualRepeat'
	]);
	
	})();
	(function(){
	"use strict";
	
	/*
	 * @ngdoc module
	 * @name material.components.backdrop
	 * @description Backdrop
	 */
	
	/**
	 * @ngdoc directive
	 * @name mdBackdrop
	 * @module material.components.backdrop
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-backdrop>` is a backdrop element used by other components, such as dialog and bottom sheet.
	 * Apply class `opaque` to make the backdrop use the theme backdrop color.
	 *
	 */
	
	angular
	  .module('material.components.backdrop', ['material.core'])
	  .directive('mdBackdrop', ["$mdTheming", "$mdUtil", "$animate", "$rootElement", "$window", "$log", "$$rAF", "$document", function BackdropDirective($mdTheming, $mdUtil, $animate, $rootElement, $window, $log, $$rAF, $document) {
	    var ERROR_CSS_POSITION = '<md-backdrop> may not work properly in a scrolled, static-positioned parent container.';
	
	    return {
	      restrict: 'E',
	      link: postLink
	    };
	
	    function postLink(scope, element, attrs) {
	      // backdrop may be outside the $rootElement, tell ngAnimate to animate regardless
	      if ($animate.pin) $animate.pin(element, $rootElement);
	
	      var bodyStyles;
	
	      $$rAF(function() {
	        // If body scrolling has been disabled using mdUtil.disableBodyScroll(),
	        // adjust the 'backdrop' height to account for the fixed 'body' top offset.
	        // Note that this can be pretty expensive and is better done inside the $$rAF.
	        bodyStyles = $window.getComputedStyle($document[0].body);
	
	        if (bodyStyles.position === 'fixed') {
	          var resizeHandler = $mdUtil.debounce(function(){
	            bodyStyles = $window.getComputedStyle($document[0].body);
	            resize();
	          }, 60, null, false);
	
	          resize();
	          angular.element($window).on('resize', resizeHandler);
	
	          scope.$on('$destroy', function() {
	            angular.element($window).off('resize', resizeHandler);
	          });
	        }
	
	        // Often $animate.enter() is used to append the backDrop element
	        // so let's wait until $animate is done...
	        var parent = element.parent();
	
	        if (parent.length) {
	          if (parent[0].nodeName === 'BODY') {
	            element.css('position', 'fixed');
	          }
	
	          var styles = $window.getComputedStyle(parent[0]);
	
	          if (styles.position === 'static') {
	            // backdrop uses position:absolute and will not work properly with parent position:static (default)
	            $log.warn(ERROR_CSS_POSITION);
	          }
	
	          // Only inherit the parent if the backdrop has a parent.
	          $mdTheming.inherit(element, parent);
	        }
	      });
	
	      function resize() {
	        var viewportHeight = parseInt(bodyStyles.height, 10) + Math.abs(parseInt(bodyStyles.top, 10));
	        element.css('height', viewportHeight + 'px');
	      }
	    }
	
	  }]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.bottomSheet
	 * @description
	 * BottomSheet
	 */
	MdBottomSheetDirective.$inject = ["$mdBottomSheet"];
	MdBottomSheetProvider.$inject = ["$$interimElementProvider"];
	angular
	  .module('material.components.bottomSheet', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdBottomSheet', MdBottomSheetDirective)
	  .provider('$mdBottomSheet', MdBottomSheetProvider);
	
	/* @ngInject */
	function MdBottomSheetDirective($mdBottomSheet) {
	  return {
	    restrict: 'E',
	    link : function postLink(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      // When navigation force destroys an interimElement, then
	      // listen and $destroy() that interim instance...
	      scope.$on('$destroy', function() {
	        $mdBottomSheet.destroy();
	      });
	    }
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $mdBottomSheet
	 * @module material.components.bottomSheet
	 *
	 * @description
	 * `$mdBottomSheet` opens a bottom sheet over the app and provides a simple promise API.
	 *
	 * ## Restrictions
	 *
	 * - The bottom sheet's template must have an outer `<md-bottom-sheet>` element.
	 * - Add the `md-grid` class to the bottom sheet for a grid layout.
	 * - Add the `md-list` class to the bottom sheet for a list layout.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div ng-controller="MyController">
	 *   <md-button ng-click="openBottomSheet()">
	 *     Open a Bottom Sheet!
	 *   </md-button>
	 * </div>
	 * </hljs>
	 * <hljs lang="js">
	 * var app = angular.module('app', ['ngMaterial']);
	 * app.controller('MyController', function($scope, $mdBottomSheet) {
	 *   $scope.openBottomSheet = function() {
	 *     $mdBottomSheet.show({
	 *       template: '<md-bottom-sheet>' +
	 *       'Hello! <md-button ng-click="closeBottomSheet()">Close</md-button>' +
	 *       '</md-bottom-sheet>'
	 *     })
	 *
	 *     // Fires when the hide() method is used
	 *     .then(function() {
	 *       console.log('You clicked the button to close the bottom sheet!');
	 *     })
	 *
	 *     // Fires when the cancel() method is used
	 *     .catch(function() {
	 *       console.log('You hit escape or clicked the backdrop to close.');
	 *     });
	 *   };
	 *
	 *   $scope.closeBottomSheet = function($scope, $mdBottomSheet) {
	 *     $mdBottomSheet.hide();
	 *   }
	 *
	 * });
	 * </hljs>
	 *
	 * ### Custom Presets
	 * Developers are also able to create their own preset, which can be easily used without repeating
	 * their options each time.
	 *
	 * <hljs lang="js">
	 *   $mdBottomSheetProvider.addPreset('testPreset', {
	 *     options: function() {
	 *       return {
	 *         template:
	 *           '<md-bottom-sheet>' +
	 *             'This is a custom preset' +
	 *           '</md-bottom-sheet>',
	 *         controllerAs: 'bottomSheet',
	 *         bindToController: true,
	 *         clickOutsideToClose: true,
	 *         escapeToClose: true
	 *       };
	 *     }
	 *   });
	 * </hljs>
	 *
	 * After you create your preset during the config phase, you can easily access it.
	 *
	 * <hljs lang="js">
	 *   $mdBottomSheet.show(
	 *     $mdBottomSheet.testPreset()
	 *   );
	 * </hljs>
	 */
	
	 /**
	 * @ngdoc method
	 * @name $mdBottomSheet#show
	 *
	 * @description
	 * Show a bottom sheet with the specified options.
	 *
	 * <em><b>Note:</b> You should <b>always</b> provide a `.catch()` method in case the user hits the
	 * `esc` key or clicks the background to close. In this case, the `cancel()` method will
	 * automatically be called on the bottom sheet which will `reject()` the promise. See the @usage
	 * section above for an example.
	 *
	 * Newer versions of Angular will throw a `Possibly unhandled rejection` exception if you forget
	 * this.</em>
	 *
	 * @param {object} optionsOrPreset Either provide an `$mdBottomSheetPreset` defined during the config phase or
	 * an options object, with the following properties:
	 *
	 *   - `templateUrl` - `{string=}`: The url of an html template file that will
	 *   be used as the content of the bottom sheet. Restrictions: the template must
	 *   have an outer `md-bottom-sheet` element.
	 *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
	 *   template string.
	 *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified, it will create a new child scope.
	 *     This scope will be destroyed when the bottom sheet is removed unless `preserveScope` is set to true.
	 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	 *   - `controller` - `{string=}`: The controller to associate with this bottom sheet.
	 *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will
	 *   be used as names of values to inject into the controller. For example,
	 *   `locals: {three: 3}` would inject `three` into the controller with the value
	 *   of 3.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the bottom sheet to
	 *     close it. Default true.
	 *   - `bindToController` - `{boolean=}`: When set to true, the locals will be bound to the controller instance.
	 *   - `disableBackdrop` - `{boolean=}`: When set to true, the bottomsheet will not show a backdrop.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the bottom sheet.
	 *     Default true.
	 *   - `isLockedOpen` - `{boolean=}`: Disables all default ways of closing the bottom sheet. **Note:** this will override
	 *     the `clickOutsideToClose` and `escapeToClose` options, leaving only the `hide` and `cancel`
	 *     methods as ways of closing the bottom sheet. Defaults to false.
	 *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
	 *   and the bottom sheet will not open until the promises resolve.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	 *   - `parent` - `{element=}`: The element to append the bottom sheet to. The `parent` may be a `function`, `string`,
	 *   `object`, or null. Defaults to appending to the body of the root element (or the root element) of the application.
	 *   e.g. angular.element(document.getElementById('content')) or "#content"
	 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the bottom sheet is open.
	 *     Default true.
	 *
	 * @returns {promise} A promise that can be resolved with `$mdBottomSheet.hide()` or
	 * rejected with `$mdBottomSheet.cancel()`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdBottomSheet#hide
	 *
	 * @description
	 * Hide the existing bottom sheet and resolve the promise returned from
	 * `$mdBottomSheet.show()`. This call will close the most recently opened/current bottomsheet (if
	 * any).
	 *
	 * <em><b>Note:</b> Use a `.then()` on your `.show()` to handle this callback.</em>
	 *
	 * @param {*=} response An argument for the resolved promise.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdBottomSheet#cancel
	 *
	 * @description
	 * Hide the existing bottom sheet and reject the promise returned from
	 * `$mdBottomSheet.show()`.
	 *
	 * <em><b>Note:</b> Use a `.catch()` on your `.show()` to handle this callback.</em>
	 *
	 * @param {*=} response An argument for the rejected promise.
	 *
	 */
	
	function MdBottomSheetProvider($$interimElementProvider) {
	  // how fast we need to flick down to close the sheet, pixels/ms
	  bottomSheetDefaults.$inject = ["$animate", "$mdConstant", "$mdUtil", "$mdTheming", "$mdBottomSheet", "$rootElement", "$mdGesture", "$log"];
	  var CLOSING_VELOCITY = 0.5;
	  var PADDING = 80; // same as css
	
	  return $$interimElementProvider('$mdBottomSheet')
	    .setDefaults({
	      methods: ['disableParentScroll', 'escapeToClose', 'clickOutsideToClose'],
	      options: bottomSheetDefaults
	    });
	
	  /* @ngInject */
	  function bottomSheetDefaults($animate, $mdConstant, $mdUtil, $mdTheming, $mdBottomSheet, $rootElement,
	                               $mdGesture, $log) {
	    var backdrop;
	
	    return {
	      themable: true,
	      onShow: onShow,
	      onRemove: onRemove,
	      disableBackdrop: false,
	      escapeToClose: true,
	      clickOutsideToClose: true,
	      disableParentScroll: true,
	      isLockedOpen: false
	    };
	
	
	    function onShow(scope, element, options, controller) {
	
	      element = $mdUtil.extractElementByName(element, 'md-bottom-sheet');
	
	      // prevent tab focus or click focus on the bottom-sheet container
	      element.attr('tabindex', '-1');
	
	      // Once the md-bottom-sheet has `ng-cloak` applied on his template the opening animation will not work properly.
	      // This is a very common problem, so we have to notify the developer about this.
	      if (element.hasClass('ng-cloak')) {
	        var message = '$mdBottomSheet: using `<md-bottom-sheet ng-cloak>` will affect the bottom-sheet opening animations.';
	        $log.warn( message, element[0] );
	      }
	
	      if (options.isLockedOpen) {
	        options.clickOutsideToClose = false;
	        options.escapeToClose = false;
	      } else {
	        options.cleanupGestures = registerGestures(element, options.parent);
	      }
	
	      if (!options.disableBackdrop) {
	        // Add a backdrop that will close on click
	        backdrop = $mdUtil.createBackdrop(scope, "md-bottom-sheet-backdrop md-opaque");
	
	        // Prevent mouse focus on backdrop; ONLY programatic focus allowed.
	        // This allows clicks on backdrop to propogate to the $rootElement and
	        // ESC key events to be detected properly.
	        backdrop[0].tabIndex = -1;
	
	        if (options.clickOutsideToClose) {
	          backdrop.on('click', function() {
	            $mdUtil.nextTick($mdBottomSheet.cancel,true);
	          });
	        }
	
	        $mdTheming.inherit(backdrop, options.parent);
	
	        $animate.enter(backdrop, options.parent, null);
	      }
	
	      $mdTheming.inherit(element, options.parent);
	
	      if (options.disableParentScroll) {
	        options.restoreScroll = $mdUtil.disableScrollAround(element, options.parent);
	      }
	
	      return $animate.enter(element, options.parent, backdrop)
	        .then(function() {
	          var focusable = $mdUtil.findFocusTarget(element) || angular.element(
	            element[0].querySelector('button') ||
	            element[0].querySelector('a') ||
	            element[0].querySelector($mdUtil.prefixer('ng-click', true))
	          ) || backdrop;
	
	          if (options.escapeToClose) {
	            options.rootElementKeyupCallback = function(e) {
	              if (e.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
	                $mdUtil.nextTick($mdBottomSheet.cancel,true);
	              }
	            };
	
	            $rootElement.on('keyup', options.rootElementKeyupCallback);
	            focusable && focusable.focus();
	          }
	        });
	
	    }
	
	    function onRemove(scope, element, options) {
	      if (!options.disableBackdrop) $animate.leave(backdrop);
	
	      return $animate.leave(element).then(function() {
	        if (options.disableParentScroll) {
	          options.restoreScroll();
	          delete options.restoreScroll;
	        }
	
	        options.cleanupGestures && options.cleanupGestures();
	      });
	    }
	
	    /**
	     * Adds the drag gestures to the bottom sheet.
	     */
	    function registerGestures(element, parent) {
	      var deregister = $mdGesture.register(parent, 'drag', { horizontal: false });
	      parent.on('$md.dragstart', onDragStart)
	        .on('$md.drag', onDrag)
	        .on('$md.dragend', onDragEnd);
	
	      return function cleanupGestures() {
	        deregister();
	        parent.off('$md.dragstart', onDragStart);
	        parent.off('$md.drag', onDrag);
	        parent.off('$md.dragend', onDragEnd);
	      };
	
	      function onDragStart() {
	        // Disable transitions on transform so that it feels fast
	        element.css($mdConstant.CSS.TRANSITION_DURATION, '0ms');
	      }
	
	      function onDrag(ev) {
	        var transform = ev.pointer.distanceY;
	        if (transform < 5) {
	          // Slow down drag when trying to drag up, and stop after PADDING
	          transform = Math.max(-PADDING, transform / 2);
	        }
	        element.css($mdConstant.CSS.TRANSFORM, 'translate3d(0,' + (PADDING + transform) + 'px,0)');
	      }
	
	      function onDragEnd(ev) {
	        if (ev.pointer.distanceY > 0 &&
	            (ev.pointer.distanceY > 20 || Math.abs(ev.pointer.velocityY) > CLOSING_VELOCITY)) {
	          var distanceRemaining = element.prop('offsetHeight') - ev.pointer.distanceY;
	          var transitionDuration = Math.min(distanceRemaining / ev.pointer.velocityY * 0.75, 500);
	          element.css($mdConstant.CSS.TRANSITION_DURATION, transitionDuration + 'ms');
	          $mdUtil.nextTick($mdBottomSheet.cancel,true);
	        } else {
	          element.css($mdConstant.CSS.TRANSITION_DURATION, '');
	          element.css($mdConstant.CSS.TRANSFORM, '');
	        }
	      }
	    }
	
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.button
	 * @description
	 *
	 * Button
	 */
	MdButtonDirective.$inject = ["$mdButtonInkRipple", "$mdTheming", "$mdAria", "$mdInteraction"];
	MdAnchorDirective.$inject = ["$mdTheming"];
	angular
	    .module('material.components.button', [ 'material.core' ])
	    .directive('mdButton', MdButtonDirective)
	    .directive('a', MdAnchorDirective);
	
	
	/**
	 * @private
	 * @restrict E
	 *
	 * @description
	 * `a` is an anchor directive used to inherit theme colors for md-primary, md-accent, etc.
	 *
	 * @usage
	 *
	 * <hljs lang="html">
	 *  <md-content md-theme="myTheme">
	 *    <a href="#chapter1" class="md-accent"></a>
	 *  </md-content>
	 * </hljs>
	 */
	function MdAnchorDirective($mdTheming) {
	  return {
	    restrict : 'E',
	    link : function postLink(scope, element) {
	      // Make sure to inherit theme so stand-alone anchors
	      // support theme colors for md-primary, md-accent, etc.
	      $mdTheming(element);
	    }
	  };
	}
	
	
	/**
	 * @ngdoc directive
	 * @name mdButton
	 * @module material.components.button
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-button>` is a button directive with optional ink ripples (default enabled).
	 *
	 * If you supply a `href` or `ng-href` attribute, it will become an `<a>` element. Otherwise, it
	 * will become a `<button>` element. As per the
	 * [Material Design specifications](https://material.google.com/style/color.html#color-color-palette)
	 * the FAB button background is filled with the accent color [by default]. The primary color palette
	 * may be used with the `md-primary` class.
	 *
	 * Developers can also change the color palette of the button, by using the following classes
	 * - `md-primary`
	 * - `md-accent`
	 * - `md-warn`
	 *
	 * See for example
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-primary">Primary Button</md-button>
	 * </hljs>
	 *
	 * Button can be also raised, which means that they will use the current color palette to fill the button.
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-accent md-raised">Raised and Accent Button</md-button>
	 * </hljs>
	 *
	 * It is also possible to disable the focus effect on the button, by using the following markup.
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-no-focus">No Focus Style</md-button>
	 * </hljs>
	 *
	 * @param {string=} aria-label Adds alternative text to button for accessibility, useful for icon buttons.
	 * If no default text is found, a warning will be logged.
	 * @param {boolean=} md-no-ink If present, disable ink ripple effects.
	 * @param {string=} md-ripple-size Overrides the default ripple size logic. Options: `full`, `partial`, `auto`.
	 * @param {expression=} ng-disabled Disable the button when the expression is truthy.
	 * @param {expression=} ng-blur Expression evaluated when focus is removed from the button.
	 *
	 * @usage
	 *
	 * Regular buttons:
	 *
	 * <hljs lang="html">
	 *  <md-button> Flat Button </md-button>
	 *  <md-button href="http://google.com"> Flat link </md-button>
	 *  <md-button class="md-raised"> Raised Button </md-button>
	 *  <md-button ng-disabled="true"> Disabled Button </md-button>
	 *  <md-button>
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *    Register Now
	 *  </md-button>
	 * </hljs>
	 *
	 * FAB buttons:
	 *
	 * <hljs lang="html">
	 *  <md-button class="md-fab" aria-label="FAB">
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *  </md-button>
	 *  <!-- mini-FAB -->
	 *  <md-button class="md-fab md-mini" aria-label="Mini FAB">
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *  </md-button>
	 *  <!-- Button with SVG Icon -->
	 *  <md-button class="md-icon-button" aria-label="Custom Icon Button">
	 *    <md-icon md-svg-icon="path/to/your.svg"></md-icon>
	 *  </md-button>
	 * </hljs>
	 */
	function MdButtonDirective($mdButtonInkRipple, $mdTheming, $mdAria, $mdInteraction) {
	
	  return {
	    restrict: 'EA',
	    replace: true,
	    transclude: true,
	    template: getTemplate,
	    link: postLink
	  };
	
	  function isAnchor(attr) {
	    return angular.isDefined(attr.href) || angular.isDefined(attr.ngHref) || angular.isDefined(attr.ngLink) || angular.isDefined(attr.uiSref);
	  }
	
	  function getTemplate(element, attr) {
	    if (isAnchor(attr)) {
	      return '<a class="md-button" ng-transclude></a>';
	    } else {
	      //If buttons don't have type="button", they will submit forms automatically.
	      var btnType = (typeof attr.type === 'undefined') ? 'button' : attr.type;
	      return '<button class="md-button" type="' + btnType + '" ng-transclude></button>';
	    }
	  }
	
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	    $mdButtonInkRipple.attach(scope, element);
	
	    // Use async expect to support possible bindings in the button label
	    $mdAria.expectWithoutText(element, 'aria-label');
	
	    // For anchor elements, we have to set tabindex manually when the
	    // element is disabled
	    if (isAnchor(attr) && angular.isDefined(attr.ngDisabled) ) {
	      scope.$watch(attr.ngDisabled, function(isDisabled) {
	        element.attr('tabindex', isDisabled ? -1 : 0);
	      });
	    }
	
	    // disabling click event when disabled is true
	    element.on('click', function(e){
	      if (attr.disabled === true) {
	        e.preventDefault();
	        e.stopImmediatePropagation();
	      }
	    });
	
	    if (!element.hasClass('md-no-focus')) {
	
	      element.on('focus', function() {
	
	        // Only show the focus effect when being focused through keyboard interaction or programmatically
	        if (!$mdInteraction.isUserInvoked() || $mdInteraction.getLastInteractionType() === 'keyboard') {
	          element.addClass('md-focused');
	        }
	
	      });
	
	      element.on('blur', function() {
	        element.removeClass('md-focused');
	      });
	    }
	
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.card
	 *
	 * @description
	 * Card components.
	 */
	mdCardDirective.$inject = ["$mdTheming"];
	angular.module('material.components.card', [
	    'material.core'
	  ])
	  .directive('mdCard', mdCardDirective);
	
	
	/**
	 * @ngdoc directive
	 * @name mdCard
	 * @module material.components.card
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-card>` directive is a container element used within `<md-content>` containers.
	 *
	 * An image included as a direct descendant will fill the card's width. If you want to avoid this,
	 * you can add the `md-image-no-fill` class to the parent element. The `<md-card-content>`
	 * container will wrap text content and provide padding. An `<md-card-footer>` element can be
	 * optionally included to put content flush against the bottom edge of the card.
	 *
	 * Action buttons can be included in an `<md-card-actions>` element, similar to `<md-dialog-actions>`.
	 * You can then position buttons using layout attributes.
	 *
	 * Card is built with:
	 * * `<md-card-header>` - Header for the card, holds avatar, text and squared image
	 *  - `<md-card-avatar>` - Card avatar
	 *    - `md-user-avatar` - Class for user image
	 *    - `<md-icon>`
	 *  - `<md-card-header-text>` - Contains elements for the card description
	 *    - `md-title` - Class for the card title
	 *    - `md-subhead` - Class for the card sub header
	 * * `<img>` - Image for the card
	 * * `<md-card-title>` - Card content title
	 *  - `<md-card-title-text>`
	 *    - `md-headline` - Class for the card content title
	 *    - `md-subhead` - Class for the card content sub header
	 *  - `<md-card-title-media>` - Squared image within the title
	 *    - `md-media-sm` - Class for small image
	 *    - `md-media-md` - Class for medium image
	 *    - `md-media-lg` - Class for large image
	 *    - `md-media-xl` - Class for extra large image
	 * * `<md-card-content>` - Card content
	 * * `<md-card-actions>` - Card actions
	 *  - `<md-card-icon-actions>` - Icon actions
	 *
	 * Cards have constant width and variable heights; where the maximum height is limited to what can
	 * fit within a single view on a platform, but it can temporarily expand as needed.
	 *
	 * @usage
	 * ### Card with optional footer
	 * <hljs lang="html">
	 * <md-card>
	 *  <img src="card-image.png" class="md-card-image" alt="image caption">
	 *  <md-card-content>
	 *    <h2>Card headline</h2>
	 *    <p>Card content</p>
	 *  </md-card-content>
	 *  <md-card-footer>
	 *    Card footer
	 *  </md-card-footer>
	 * </md-card>
	 * </hljs>
	 *
	 * ### Card with actions
	 * <hljs lang="html">
	 * <md-card>
	 *  <img src="card-image.png" class="md-card-image" alt="image caption">
	 *  <md-card-content>
	 *    <h2>Card headline</h2>
	 *    <p>Card content</p>
	 *  </md-card-content>
	 *  <md-card-actions layout="row" layout-align="end center">
	 *    <md-button>Action 1</md-button>
	 *    <md-button>Action 2</md-button>
	 *  </md-card-actions>
	 * </md-card>
	 * </hljs>
	 *
	 * ### Card with header, image, title actions and content
	 * <hljs lang="html">
	 * <md-card>
	 *   <md-card-header>
	 *     <md-card-avatar>
	 *       <img class="md-user-avatar" src="avatar.png"/>
	 *     </md-card-avatar>
	 *     <md-card-header-text>
	 *       <span class="md-title">Title</span>
	 *       <span class="md-subhead">Sub header</span>
	 *     </md-card-header-text>
	 *   </md-card-header>
	 *   <img ng-src="card-image.png" class="md-card-image" alt="image caption">
	 *   <md-card-title>
	 *     <md-card-title-text>
	 *       <span class="md-headline">Card headline</span>
	 *       <span class="md-subhead">Card subheader</span>
	 *     </md-card-title-text>
	 *   </md-card-title>
	 *   <md-card-actions layout="row" layout-align="start center">
	 *     <md-button>Action 1</md-button>
	 *     <md-button>Action 2</md-button>
	 *     <md-card-icon-actions>
	 *       <md-button class="md-icon-button" aria-label="icon">
	 *         <md-icon md-svg-icon="icon"></md-icon>
	 *       </md-button>
	 *     </md-card-icon-actions>
	 *   </md-card-actions>
	 *   <md-card-content>
	 *     <p>
	 *      Card content
	 *     </p>
	 *   </md-card-content>
	 * </md-card>
	 * </hljs>
	 */
	function mdCardDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    link: function ($scope, $element, attr) {
	      $element.addClass('_md');     // private md component indicator for styling
	      $mdTheming($element);
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.checkbox
	 * @description Checkbox module!
	 */
	MdCheckboxDirective.$inject = ["inputDirective", "$mdAria", "$mdConstant", "$mdTheming", "$mdUtil", "$mdInteraction"];
	angular
	  .module('material.components.checkbox', ['material.core'])
	  .directive('mdCheckbox', MdCheckboxDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdCheckbox
	 * @module material.components.checkbox
	 * @restrict E
	 *
	 * @description
	 * The checkbox directive is used like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-color-schemes)
	 * the checkbox is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * @param {expression} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
	 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
	 * @param {expression=} ng-change Expression to be executed when the model value changes.
	 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects
	 * @param {string=} aria-label Adds label to checkbox for accessibility.
	 *     Defaults to checkbox's text. If no default text is found, a warning will be logged.
	 * @param {expression=} md-indeterminate This determines when the checkbox should be rendered as 'indeterminate'.
	 *     If a truthy expression or no value is passed in the checkbox renders in the md-indeterminate state.
	 *     If falsy expression is passed in it just looks like a normal unchecked checkbox.
	 *     The indeterminate, checked, and unchecked states are mutually exclusive. A box cannot be in any two states at the same time.
	 *     Adding the 'md-indeterminate' attribute overrides any checked/unchecked rendering logic.
	 *     When using the 'md-indeterminate' attribute use 'ng-checked' to define rendering logic instead of using 'ng-model'.
	 * @param {expression=} ng-checked If this expression evaluates as truthy, the 'md-checked' css class is added to the checkbox and it
	 *     will appear checked.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-checkbox ng-model="isChecked" aria-label="Finished?">
	 *   Finished ?
	 * </md-checkbox>
	 *
	 * <md-checkbox md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
	 *   No Ink Effects
	 * </md-checkbox>
	 *
	 * <md-checkbox ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
	 *   Disabled
	 * </md-checkbox>
	 *
	 * </hljs>
	 *
	 */
	function MdCheckboxDirective(inputDirective, $mdAria, $mdConstant, $mdTheming, $mdUtil, $mdInteraction) {
	  inputDirective = inputDirective[0];
	
	  return {
	    restrict: 'E',
	    transclude: true,
	    require: ['^?mdInputContainer', '?ngModel', '?^form'],
	    priority: $mdConstant.BEFORE_NG_ARIA,
	    template:
	      '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
	        '<div class="md-icon"></div>' +
	      '</div>' +
	      '<div ng-transclude class="md-label"></div>',
	    compile: compile
	  };
	
	  // **********************************************************
	  // Private Methods
	  // **********************************************************
	
	  function compile (tElement, tAttrs) {
	    tAttrs.$set('tabindex', tAttrs.tabindex || '0');
	    tAttrs.$set('type', 'checkbox');
	    tAttrs.$set('role', tAttrs.type);
	
	    return  {
	      pre: function(scope, element) {
	        // Attach a click handler during preLink, in order to immediately stop propagation
	        // (especially for ng-click) when the checkbox is disabled.
	        element.on('click', function(e) {
	          if (this.hasAttribute('disabled')) {
	            e.stopImmediatePropagation();
	          }
	        });
	      },
	      post: postLink
	    };
	
	    function postLink(scope, element, attr, ctrls) {
	      var isIndeterminate;
	      var containerCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
	      var formCtrl = ctrls[2];
	
	      if (containerCtrl) {
	        var isErrorGetter = containerCtrl.isErrorGetter || function() {
	          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
	        };
	
	        containerCtrl.input = element;
	
	        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	      }
	
	      $mdTheming(element);
	
	      // Redirect focus events to the root element, because IE11 is always focusing the container element instead
	      // of the md-checkbox element. This causes issues when using ngModelOptions: `updateOnBlur`
	      element.children().on('focus', function() {
	        element.focus();
	      });
	
	      if ($mdUtil.parseAttributeBoolean(attr.mdIndeterminate)) {
	        setIndeterminateState();
	        scope.$watch(attr.mdIndeterminate, setIndeterminateState);
	      }
	
	      if (attr.ngChecked) {
	        scope.$watch(scope.$eval.bind(scope, attr.ngChecked), function(value) {
	          ngModelCtrl.$setViewValue(value);
	          ngModelCtrl.$render();
	        });
	      }
	
	      $$watchExpr('ngDisabled', 'tabindex', {
	        true: '-1',
	        false: attr.tabindex
	      });
	
	      $mdAria.expectWithText(element, 'aria-label');
	
	      // Reuse the original input[type=checkbox] directive from AngularJS core.
	      // This is a bit hacky as we need our own event listener and own render
	      // function.
	      inputDirective.link.pre(scope, {
	        on: angular.noop,
	        0: {}
	      }, attr, [ngModelCtrl]);
	
	      element.on('click', listener)
	        .on('keypress', keypressHandler)
	        .on('focus', function() {
	          if ($mdInteraction.getLastInteractionType() === 'keyboard') {
	            element.addClass('md-focused');
	          }
	        })
	        .on('blur', function() {
	          element.removeClass('md-focused');
	        });
	
	      ngModelCtrl.$render = render;
	
	      function $$watchExpr(expr, htmlAttr, valueOpts) {
	        if (attr[expr]) {
	          scope.$watch(attr[expr], function(val) {
	            if (valueOpts[val]) {
	              element.attr(htmlAttr, valueOpts[val]);
	            }
	          });
	        }
	      }
	
	      function keypressHandler(ev) {
	        var keyCode = ev.which || ev.keyCode;
	        if (keyCode === $mdConstant.KEY_CODE.SPACE || keyCode === $mdConstant.KEY_CODE.ENTER) {
	          ev.preventDefault();
	          element.addClass('md-focused');
	          listener(ev);
	        }
	      }
	
	      function listener(ev) {
	        // skipToggle boolean is used by the switch directive to prevent the click event
	        // when releasing the drag. There will be always a click if releasing the drag over the checkbox
	        if (element[0].hasAttribute('disabled') || scope.skipToggle) {
	          return;
	        }
	
	        scope.$apply(function() {
	          // Toggle the checkbox value...
	          var viewValue = attr.ngChecked && attr.ngClick ? attr.checked : !ngModelCtrl.$viewValue;
	
	          ngModelCtrl.$setViewValue(viewValue, ev && ev.type);
	          ngModelCtrl.$render();
	        });
	      }
	
	      function render() {
	        // Cast the $viewValue to a boolean since it could be undefined
	        element.toggleClass('md-checked', !!ngModelCtrl.$viewValue && !isIndeterminate);
	      }
	
	      function setIndeterminateState(newValue) {
	        isIndeterminate = newValue !== false;
	        if (isIndeterminate) {
	          element.attr('aria-checked', 'mixed');
	        }
	        element.toggleClass('md-indeterminate', isIndeterminate);
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.chips
	 */
	/*
	 * @see js folder for chips implementation
	 */
	angular.module('material.components.chips', [
	  'material.core',
	  'material.components.autocomplete'
	]);
	
	})();
	(function(){
	"use strict";
	
	(function () {
	  "use strict";
	
	  /**
	   *  Use a RegExp to check if the `md-colors="<expression>"` is static string
	   *  or one that should be observed and dynamically interpolated.
	   */
	  MdColorsDirective.$inject = ["$mdColors", "$mdUtil", "$log", "$parse"];
	  MdColorsService.$inject = ["$mdTheming", "$mdUtil", "$log"];
	  var STATIC_COLOR_EXPRESSION = /^{((\s|,)*?["'a-zA-Z-]+?\s*?:\s*?('|")[a-zA-Z0-9-.]*('|"))+\s*}$/;
	  var colorPalettes = null;
	
	  /**
	   * @ngdoc module
	   * @name material.components.colors
	   *
	   * @description
	   * Define $mdColors service and a `md-colors=""` attribute directive
	   */
	  angular
	    .module('material.components.colors', ['material.core'])
	    .directive('mdColors', MdColorsDirective)
	    .service('$mdColors', MdColorsService);
	
	  /**
	   * @ngdoc service
	   * @name $mdColors
	   * @module material.components.colors
	   *
	   * @description
	   * With only defining themes, one couldn't get non AngularJS Material elements colored with Material colors,
	   * `$mdColors` service is used by the md-color directive to convert the 1..n color expressions to RGBA values and will apply
	   * those values to element as CSS property values.
	   *
	   *  @usage
	   *  <hljs lang="js">
	   *    angular.controller('myCtrl', function ($mdColors) {
	   *      var color = $mdColors.getThemeColor('myTheme-red-200-0.5');
	   *      ...
	   *    });
	   *  </hljs>
	   *
	   */
	  function MdColorsService($mdTheming, $mdUtil, $log) {
	    colorPalettes = colorPalettes || Object.keys($mdTheming.PALETTES);
	
	    // Publish service instance
	    return {
	      applyThemeColors: applyThemeColors,
	      getThemeColor: getThemeColor,
	      hasTheme: hasTheme
	    };
	
	    // ********************************************
	    // Internal Methods
	    // ********************************************
	
	    /**
	     * @ngdoc method
	     * @name $mdColors#applyThemeColors
	     *
	     * @description
	     * Gets a color json object, keys are css properties and values are string of the wanted color
	     * Then calculate the rgba() values based on the theme color parts
	     *
	     * @param {DOMElement} element the element to apply the styles on.
	     * @param {object} colorExpression json object, keys are css properties and values are string of the wanted color,
	     * for example: `{color: 'red-A200-0.3'}`.
	     *
	     * @usage
	     * <hljs lang="js">
	     *   app.directive('myDirective', function($mdColors) {
	     *     return {
	     *       ...
	     *       link: function (scope, elem) {
	     *         $mdColors.applyThemeColors(elem, {color: 'red'});
	     *       }
	     *    }
	     *   });
	     * </hljs>
	     */
	    function applyThemeColors(element, colorExpression) {
	      try {
	        if (colorExpression) {
	          // Assign the calculate RGBA color values directly as inline CSS
	          element.css(interpolateColors(colorExpression));
	        }
	      } catch (e) {
	        $log.error(e.message);
	      }
	
	    }
	
	    /**
	     * @ngdoc method
	     * @name $mdColors#getThemeColor
	     *
	     * @description
	     * Get parsed color from expression
	     *
	     * @param {string} expression string of a color expression (for instance `'red-700-0.8'`)
	     *
	     * @returns {string} a css color expression (for instance `rgba(211, 47, 47, 0.8)`)
	     *
	     * @usage
	     *  <hljs lang="js">
	     *    angular.controller('myCtrl', function ($mdColors) {
	     *      var color = $mdColors.getThemeColor('myTheme-red-200-0.5');
	     *      ...
	     *    });
	     *  </hljs>
	     */
	    function getThemeColor(expression) {
	      var color = extractColorOptions(expression);
	
	      return parseColor(color);
	    }
	
	    /**
	     * Return the parsed color
	     * @param color hashmap of color definitions
	     * @param contrast whether use contrast color for foreground
	     * @returns rgba color string
	     */
	    function parseColor(color, contrast) {
	      contrast = contrast || false;
	      var rgbValues = $mdTheming.PALETTES[color.palette][color.hue];
	
	      rgbValues = contrast ? rgbValues.contrast : rgbValues.value;
	
	      return $mdUtil.supplant('rgba({0}, {1}, {2}, {3})',
	        [rgbValues[0], rgbValues[1], rgbValues[2], rgbValues[3] || color.opacity]
	      );
	    }
	
	    /**
	     * Convert the color expression into an object with scope-interpolated values
	     * Then calculate the rgba() values based on the theme color parts
	     *
	     * @results Hashmap of CSS properties with associated `rgba( )` string vales
	     *
	     *
	     */
	    function interpolateColors(themeColors) {
	      var rgbColors = {};
	
	      var hasColorProperty = themeColors.hasOwnProperty('color');
	
	      angular.forEach(themeColors, function (value, key) {
	        var color = extractColorOptions(value);
	        var hasBackground = key.indexOf('background') > -1;
	
	        rgbColors[key] = parseColor(color);
	        if (hasBackground && !hasColorProperty) {
	          rgbColors.color = parseColor(color, true);
	        }
	      });
	
	      return rgbColors;
	    }
	
	    /**
	     * Check if expression has defined theme
	     * e.g.
	     * 'myTheme-primary' => true
	     * 'red-800' => false
	     */
	    function hasTheme(expression) {
	      return angular.isDefined($mdTheming.THEMES[expression.split('-')[0]]);
	    }
	
	    /**
	     * For the evaluated expression, extract the color parts into a hash map
	     */
	    function extractColorOptions(expression) {
	      var parts = expression.split('-');
	      var hasTheme = angular.isDefined($mdTheming.THEMES[parts[0]]);
	      var theme = hasTheme ? parts.splice(0, 1)[0] : $mdTheming.defaultTheme();
	
	      return {
	        theme: theme,
	        palette: extractPalette(parts, theme),
	        hue: extractHue(parts, theme),
	        opacity: parts[2] || 1
	      };
	    }
	
	    /**
	     * Calculate the theme palette name
	     */
	    function extractPalette(parts, theme) {
	      // If the next section is one of the palettes we assume it's a two word palette
	      // Two word palette can be also written in camelCase, forming camelCase to dash-case
	
	      var isTwoWord = parts.length > 1 && colorPalettes.indexOf(parts[1]) !== -1;
	      var palette = parts[0].replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	
	      if (isTwoWord)  palette = parts[0] + '-' + parts.splice(1, 1);
	
	      if (colorPalettes.indexOf(palette) === -1) {
	        // If the palette is not in the palette list it's one of primary/accent/warn/background
	        var scheme = $mdTheming.THEMES[theme].colors[palette];
	        if (!scheme) {
	          throw new Error($mdUtil.supplant('mdColors: couldn\'t find \'{palette}\' in the palettes.', {palette: palette}));
	        }
	        palette = scheme.name;
	      }
	
	      return palette;
	    }
	
	    function extractHue(parts, theme) {
	      var themeColors = $mdTheming.THEMES[theme].colors;
	
	      if (parts[1] === 'hue') {
	        var hueNumber = parseInt(parts.splice(2, 1)[0], 10);
	
	        if (hueNumber < 1 || hueNumber > 3) {
	          throw new Error($mdUtil.supplant('mdColors: \'hue-{hueNumber}\' is not a valid hue, can be only \'hue-1\', \'hue-2\' and \'hue-3\'', {hueNumber: hueNumber}));
	        }
	        parts[1] = 'hue-' + hueNumber;
	
	        if (!(parts[0] in themeColors)) {
	          throw new Error($mdUtil.supplant('mdColors: \'hue-x\' can only be used with [{availableThemes}], but was used with \'{usedTheme}\'', {
	            availableThemes: Object.keys(themeColors).join(', '),
	            usedTheme: parts[0]
	          }));
	        }
	
	        return themeColors[parts[0]].hues[parts[1]];
	      }
	
	      return parts[1] || themeColors[parts[0] in themeColors ? parts[0] : 'primary'].hues['default'];
	    }
	  }
	
	  /**
	   * @ngdoc directive
	   * @name mdColors
	   * @module material.components.colors
	   *
	   * @restrict A
	   *
	   * @description
	   * `mdColors` directive will apply the theme-based color expression as RGBA CSS style values.
	   *
	   *   The format will be similar to our color defining in the scss files:
	   *
	   *   ## `[?theme]-[palette]-[?hue]-[?opacity]`
	   *   - [theme]    - default value is the default theme
	   *   - [palette]  - can be either palette name or primary/accent/warn/background
	   *   - [hue]      - default is 500 (hue-x can be used with primary/accent/warn/background)
	   *   - [opacity]  - default is 1
	   *
	   *   > `?` indicates optional parameter
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <div md-colors="{background: 'myTheme-accent-900-0.43'}">
	   *     <div md-colors="{color: 'red-A100', 'border-color': 'primary-600'}">
	   *       <span>Color demo</span>
	   *     </div>
	   *   </div>
	   * </hljs>
	   *
	   * `mdColors` directive will automatically watch for changes in the expression if it recognizes an interpolation
	   * expression or a function. For performance options, you can use `::` prefix to the `md-colors` expression
	   * to indicate a one-time data binding.
	   * <hljs lang="html">
	   *   <md-card md-colors="::{background: '{{theme}}-primary-700'}">
	   *   </md-card>
	   * </hljs>
	   *
	   */
	  function MdColorsDirective($mdColors, $mdUtil, $log, $parse) {
	    return {
	      restrict: 'A',
	      require: ['^?mdTheme'],
	      compile: function (tElem, tAttrs) {
	        var shouldWatch = shouldColorsWatch();
	
	        return function (scope, element, attrs, ctrl) {
	          var mdThemeController = ctrl[0];
	
	          var lastColors = {};
	
	          var parseColors = function (theme) {
	            if (typeof theme !== 'string') {
	              theme = '';
	            }
	
	            if (!attrs.mdColors) {
	              attrs.mdColors = '{}';
	            }
	
	            /**
	             * Json.parse() does not work because the keys are not quoted;
	             * use $parse to convert to a hash map
	             */
	            var colors = $parse(attrs.mdColors)(scope);
	
	            /**
	             * If mdTheme is defined up the DOM tree
	             * we add mdTheme theme to colors who doesn't specified a theme
	             *
	             * # example
	             * <hljs lang="html">
	             *   <div md-theme="myTheme">
	             *     <div md-colors="{background: 'primary-600'}">
	             *       <span md-colors="{background: 'mySecondTheme-accent-200'}">Color demo</span>
	             *     </div>
	             *   </div>
	             * </hljs>
	             *
	             * 'primary-600' will be 'myTheme-primary-600',
	             * but 'mySecondTheme-accent-200' will stay the same cause it has a theme prefix
	             */
	            if (mdThemeController) {
	              Object.keys(colors).forEach(function (prop) {
	                var color = colors[prop];
	                if (!$mdColors.hasTheme(color)) {
	                  colors[prop] = (theme || mdThemeController.$mdTheme) + '-' + color;
	                }
	              });
	            }
	
	            cleanElement(colors);
	
	            return colors;
	          };
	
	          var cleanElement = function (colors) {
	            if (!angular.equals(colors, lastColors)) {
	              var keys = Object.keys(lastColors);
	
	              if (lastColors.background && !keys.color) {
	                keys.push('color');
	              }
	
	              keys.forEach(function (key) {
	                element.css(key, '');
	              });
	            }
	
	            lastColors = colors;
	          };
	
	          /**
	           * Registering for mgTheme changes and asking mdTheme controller run our callback whenever a theme changes
	           */
	          var unregisterChanges = angular.noop;
	
	          if (mdThemeController) {
	            unregisterChanges = mdThemeController.registerChanges(function (theme) {
	              $mdColors.applyThemeColors(element, parseColors(theme));
	            });
	          }
	
	          scope.$on('$destroy', function () {
	            unregisterChanges();
	          });
	
	          try {
	            if (shouldWatch) {
	              scope.$watch(parseColors, angular.bind(this,
	                $mdColors.applyThemeColors, element
	              ), true);
	            }
	            else {
	              $mdColors.applyThemeColors(element, parseColors());
	            }
	
	          }
	          catch (e) {
	            $log.error(e.message);
	          }
	
	        };
	
	        function shouldColorsWatch() {
	          // Simulate 1x binding and mark mdColorsWatch == false
	          var rawColorExpression = tAttrs.mdColors;
	          var bindOnce = rawColorExpression.indexOf('::') > -1;
	          var isStatic = bindOnce ? true : STATIC_COLOR_EXPRESSION.test(tAttrs.mdColors);
	
	          // Remove it for the postLink...
	          tAttrs.mdColors = rawColorExpression.replace('::', '');
	
	          var hasWatchAttr = angular.isDefined(tAttrs.mdColorsWatch);
	
	          return (bindOnce || isStatic) ? false :
	            hasWatchAttr ? $mdUtil.parseAttributeBoolean(tAttrs.mdColorsWatch) : true;
	        }
	      }
	    };
	
	  }
	
	
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.content
	 *
	 * @description
	 * Scrollable content
	 */
	mdContentDirective.$inject = ["$mdTheming"];
	angular.module('material.components.content', [
	  'material.core'
	])
	  .directive('mdContent', mdContentDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdContent
	 * @module material.components.content
	 *
	 * @restrict E
	 *
	 * @description
	 *
	 * The `<md-content>` directive is a container element useful for scrollable content. It achieves
	 * this by setting the CSS `overflow` property to `auto` so that content can properly scroll.
	 *
	 * In general, `<md-content>` components are not designed to be nested inside one another. If
	 * possible, it is better to make them siblings. This often results in a better user experience as
	 * having nested scrollbars may confuse the user.
	 *
	 * ## Troubleshooting
	 *
	 * In some cases, you may wish to apply the `md-no-momentum` class to ensure that Safari's
	 * momentum scrolling is disabled. Momentum scrolling can cause flickering issues while scrolling
	 * SVG icons and some other components.
	 *
	 * Additionally, we now also offer the `md-no-flicker` class which can be applied to any element
	 * and uses a Webkit-specific filter of `blur(0px)` that forces GPU rendering of all elements
	 * inside (which eliminates the flicker on iOS devices).
	 *
	 * _<b>Note:</b> Forcing an element to render on the GPU can have unintended side-effects, especially
	 * related to the z-index of elements. Please use with caution and only on the elements needed._
	 *
	 * @usage
	 *
	 * Add the `[layout-padding]` attribute to make the content padded.
	 *
	 * <hljs lang="html">
	 *  <md-content layout-padding>
	 *      Lorem ipsum dolor sit amet, ne quod novum mei.
	 *  </md-content>
	 * </hljs>
	 */
	
	function mdContentDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    controller: ['$scope', '$element', ContentController],
	    link: function(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      $mdTheming(element);
	      scope.$broadcast('$mdContentLoaded', element);
	
	      iosScrollFix(element[0]);
	    }
	  };
	
	  function ContentController($scope, $element) {
	    this.$scope = $scope;
	    this.$element = $element;
	  }
	}
	
	function iosScrollFix(node) {
	  // IOS FIX:
	  // If we scroll where there is no more room for the webview to scroll,
	  // by default the webview itself will scroll up and down, this looks really
	  // bad.  So if we are scrolling to the very top or bottom, add/subtract one
	  angular.element(node).on('$md.pressdown', function(ev) {
	    // Only touch events
	    if (ev.pointer.type !== 't') return;
	    // Don't let a child content's touchstart ruin it for us.
	    if (ev.$materialScrollFixed) return;
	    ev.$materialScrollFixed = true;
	
	    if (node.scrollTop === 0) {
	      node.scrollTop = 1;
	    } else if (node.scrollHeight === node.scrollTop + node.offsetHeight) {
	      node.scrollTop -= 1;
	    }
	  });
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.datepicker
	 * @description Module for the datepicker component.
	 */
	
	angular.module('material.components.datepicker', [
	  'material.core',
	  'material.components.icon',
	  'material.components.virtualRepeat'
	]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.dialog
	 */
	MdDialogDirective.$inject = ["$$rAF", "$mdTheming", "$mdDialog"];
	MdDialogProvider.$inject = ["$$interimElementProvider"];
	angular
	  .module('material.components.dialog', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdDialog', MdDialogDirective)
	  .provider('$mdDialog', MdDialogProvider);
	
	/**
	 * @ngdoc directive
	 * @name mdDialog
	 * @module material.components.dialog
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-dialog>` - The dialog's template must be inside this element.
	 *
	 * Inside, use an `<md-dialog-content>` element for the dialog's content, and use
	 * an `<md-dialog-actions>` element for the dialog's actions.
	 *
	 * ## CSS
	 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
	 *
	 * ## Notes
	 * - If you specify an `id` for the `<md-dialog>`, the `<md-dialog-content>` will have the same `id`
	 * prefixed with `dialogContent_`.
	 *
	 * @usage
	 * ### Dialog template
	 * <hljs lang="html">
	 * <md-dialog aria-label="List dialog">
	 *   <md-dialog-content>
	 *     <md-list>
	 *       <md-list-item ng-repeat="item in items">
	 *         <p>Number {{item}}</p>
	 *       </md-list-item>
	 *     </md-list>
	 *   </md-dialog-content>
	 *   <md-dialog-actions>
	 *     <md-button ng-click="closeDialog()" class="md-primary">Close Dialog</md-button>
	 *   </md-dialog-actions>
	 * </md-dialog>
	 * </hljs>
	 */
	function MdDialogDirective($$rAF, $mdTheming, $mdDialog) {
	  return {
	    restrict: 'E',
	    link: function(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      $mdTheming(element);
	      $$rAF(function() {
	        var images;
	        var content = element[0].querySelector('md-dialog-content');
	
	        if (content) {
	          images = content.getElementsByTagName('img');
	          addOverflowClass();
	          //-- delayed image loading may impact scroll height, check after images are loaded
	          angular.element(images).on('load', addOverflowClass);
	        }
	
	        scope.$on('$destroy', function() {
	          $mdDialog.destroy(element);
	        });
	
	        /**
	         *
	         */
	        function addOverflowClass() {
	          element.toggleClass('md-content-overflow', content.scrollHeight > content.clientHeight);
	        }
	
	
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $mdDialog
	 * @module material.components.dialog
	 *
	 * @description
	 * `$mdDialog` opens a dialog over the app to inform users about critical information or require
	 *  them to make decisions. There are two approaches for setup: a simple promise API
	 *  and regular object syntax.
	 *
	 * ## Restrictions
	 *
	 * - The dialog is always given an isolate scope.
	 * - The dialog's template must have an outer `<md-dialog>` element.
	 *   Inside, use an `<md-dialog-content>` element for the dialog's content, and use
	 *   an `<md-dialog-actions>` element for the dialog's actions.
	 * - Dialogs must cover the entire application to keep interactions inside of them.
	 * Use the `parent` option to change where dialogs are appended.
	 *
	 * ## Sizing
	 * - Complex dialogs can be sized with `flex="percentage"`, i.e. `flex="66"`.
	 * - Default max-width is 80% of the `rootElement` or `parent`.
	 *
	 * ## CSS
	 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div  ng-app="demoApp" ng-controller="EmployeeController">
	 *   <div>
	 *     <md-button ng-click="showAlert()" class="md-raised md-warn">
	 *       Employee Alert!
	 *       </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="showDialog($event)" class="md-raised">
	 *       Custom Dialog
	 *       </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="closeAlert()" ng-disabled="!hasAlert()" class="md-raised">
	 *       Close Alert
	 *     </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="showGreeting($event)" class="md-raised md-primary" >
	 *       Greet Employee
	 *       </md-button>
	 *   </div>
	 * </div>
	 * </hljs>
	 *
	 * ### JavaScript: object syntax
	 * <hljs lang="js">
	 * (function(angular, undefined){
	 *   "use strict";
	 *
	 *   angular
	 *    .module('demoApp', ['ngMaterial'])
	 *    .controller('AppCtrl', AppController);
	 *
	 *   function AppController($scope, $mdDialog) {
	 *     var alert;
	 *     $scope.showAlert = showAlert;
	 *     $scope.showDialog = showDialog;
	 *     $scope.items = [1, 2, 3];
	 *
	 *     // Internal method
	 *     function showAlert() {
	 *       alert = $mdDialog.alert({
	 *         title: 'Attention',
	 *         textContent: 'This is an example of how easy dialogs can be!',
	 *         ok: 'Close'
	 *       });
	 *
	 *       $mdDialog
	 *         .show( alert )
	 *         .finally(function() {
	 *           alert = undefined;
	 *         });
	 *     }
	 *
	 *     function showDialog($event) {
	 *        var parentEl = angular.element(document.body);
	 *        $mdDialog.show({
	 *          parent: parentEl,
	 *          targetEvent: $event,
	 *          template:
	 *            '<md-dialog aria-label="List dialog">' +
	 *            '  <md-dialog-content>'+
	 *            '    <md-list>'+
	 *            '      <md-list-item ng-repeat="item in items">'+
	 *            '       <p>Number {{item}}</p>' +
	 *            '      </md-item>'+
	 *            '    </md-list>'+
	 *            '  </md-dialog-content>' +
	 *            '  <md-dialog-actions>' +
	 *            '    <md-button ng-click="closeDialog()" class="md-primary">' +
	 *            '      Close Dialog' +
	 *            '    </md-button>' +
	 *            '  </md-dialog-actions>' +
	 *            '</md-dialog>',
	 *          locals: {
	 *            items: $scope.items
	 *          },
	 *          controller: DialogController
	 *       });
	 *       function DialogController($scope, $mdDialog, items) {
	 *         $scope.items = items;
	 *         $scope.closeDialog = function() {
	 *           $mdDialog.hide();
	 *         }
	 *       }
	 *     }
	 *   }
	 * })(angular);
	 * </hljs>
	 *
	 * ### Multiple Dialogs
	 * Using the `multiple` option for the `$mdDialog` service allows developers to show multiple dialogs
	 * at the same time.
	 *
	 * <hljs lang="js">
	 *   // From plain options
	 *   $mdDialog.show({
	 *     multiple: true
	 *   });
	 *
	 *   // From a dialog preset
	 *   $mdDialog.show(
	 *     $mdDialog
	 *       .alert()
	 *       .multiple(true)
	 *   );
	 *
	 * </hljs>
	 *
	 * ### Pre-Rendered Dialogs
	 * By using the `contentElement` option, it is possible to use an already existing element in the DOM.
	 *
	 * > Pre-rendered dialogs will be not linked to any scope and will not instantiate any new controller.<br/>
	 * > You can manually link the elements to a scope or instantiate a controller from the template (`ng-controller`)
	 *
	 * <hljs lang="js">
	 *   $scope.showPrerenderedDialog = function() {
	 *     $mdDialog.show({
	 *       contentElement: '#myStaticDialog',
	 *       parent: angular.element(document.body)
	 *     });
	 *   };
	 * </hljs>
	 *
	 * When using a string as value, `$mdDialog` will automatically query the DOM for the specified CSS selector.
	 *
	 * <hljs lang="html">
	 *   <div style="visibility: hidden">
	 *     <div class="md-dialog-container" id="myStaticDialog">
	 *       <md-dialog>
	 *         This is a pre-rendered dialog.
	 *       </md-dialog>
	 *     </div>
	 *   </div>
	 * </hljs>
	 *
	 * **Notice**: It is important, to use the `.md-dialog-container` as the content element, otherwise the dialog
	 * will not show up.
	 *
	 * It also possible to use a DOM element for the `contentElement` option.
	 * - `contentElement: document.querySelector('#myStaticDialog')`
	 * - `contentElement: angular.element(TEMPLATE)`
	 *
	 * When using a `template` as content element, it will be not compiled upon open.
	 * This allows you to compile the element yourself and use it each time the dialog opens.
	 *
	 * ### Custom Presets
	 * Developers are also able to create their own preset, which can be easily used without repeating
	 * their options each time.
	 *
	 * <hljs lang="js">
	 *   $mdDialogProvider.addPreset('testPreset', {
	 *     options: function() {
	 *       return {
	 *         template:
	 *           '<md-dialog>' +
	 *             'This is a custom preset' +
	 *           '</md-dialog>',
	 *         controllerAs: 'dialog',
	 *         bindToController: true,
	 *         clickOutsideToClose: true,
	 *         escapeToClose: true
	 *       };
	 *     }
	 *   });
	 * </hljs>
	 *
	 * After you created your preset at config phase, you can easily access it.
	 *
	 * <hljs lang="js">
	 *   $mdDialog.show(
	 *     $mdDialog.testPreset()
	 *   );
	 * </hljs>
	 *
	 * ### JavaScript: promise API syntax, custom dialog template
	 * <hljs lang="js">
	 * (function(angular, undefined){
	 *   "use strict";
	 *
	 *   angular
	 *     .module('demoApp', ['ngMaterial'])
	 *     .controller('EmployeeController', EmployeeEditor)
	 *     .controller('GreetingController', GreetingController);
	 *
	 *   // Fictitious Employee Editor to show how to use simple and complex dialogs.
	 *
	 *   function EmployeeEditor($scope, $mdDialog) {
	 *     var alert;
	 *
	 *     $scope.showAlert = showAlert;
	 *     $scope.closeAlert = closeAlert;
	 *     $scope.showGreeting = showCustomGreeting;
	 *
	 *     $scope.hasAlert = function() { return !!alert };
	 *     $scope.userName = $scope.userName || 'Bobby';
	 *
	 *     // Dialog #1 - Show simple alert dialog and cache
	 *     // reference to dialog instance
	 *
	 *     function showAlert() {
	 *       alert = $mdDialog.alert()
	 *         .title('Attention, ' + $scope.userName)
	 *         .textContent('This is an example of how easy dialogs can be!')
	 *         .ok('Close');
	 *
	 *       $mdDialog
	 *           .show( alert )
	 *           .finally(function() {
	 *             alert = undefined;
	 *           });
	 *     }
	 *
	 *     // Close the specified dialog instance and resolve with 'finished' flag
	 *     // Normally this is not needed, just use '$mdDialog.hide()' to close
	 *     // the most recent dialog popup.
	 *
	 *     function closeAlert() {
	 *       $mdDialog.hide( alert, "finished" );
	 *       alert = undefined;
	 *     }
	 *
	 *     // Dialog #2 - Demonstrate more complex dialogs construction and popup.
	 *
	 *     function showCustomGreeting($event) {
	 *         $mdDialog.show({
	 *           targetEvent: $event,
	 *           template:
	 *             '<md-dialog>' +
	 *
	 *             '  <md-dialog-content>Hello {{ employee }}!</md-dialog-content>' +
	 *
	 *             '  <md-dialog-actions>' +
	 *             '    <md-button ng-click="closeDialog()" class="md-primary">' +
	 *             '      Close Greeting' +
	 *             '    </md-button>' +
	 *             '  </md-dialog-actions>' +
	 *             '</md-dialog>',
	 *           controller: 'GreetingController',
	 *           onComplete: afterShowAnimation,
	 *           locals: { employee: $scope.userName }
	 *         });
	 *
	 *         // When the 'enter' animation finishes...
	 *
	 *         function afterShowAnimation(scope, element, options) {
	 *            // post-show code here: DOM element focus, etc.
	 *         }
	 *     }
	 *
	 *     // Dialog #3 - Demonstrate use of ControllerAs and passing $scope to dialog
	 *     //             Here we used ng-controller="GreetingController as vm" and
	 *     //             $scope.vm === <controller instance>
	 *
	 *     function showCustomGreeting() {
	 *
	 *        $mdDialog.show({
	 *           clickOutsideToClose: true,
	 *
	 *           scope: $scope,        // use parent scope in template
	 *           preserveScope: true,  // do not forget this if use parent scope
	
	 *           // Since GreetingController is instantiated with ControllerAs syntax
	 *           // AND we are passing the parent '$scope' to the dialog, we MUST
	 *           // use 'vm.<xxx>' in the template markup
	 *
	 *           template: '<md-dialog>' +
	 *                     '  <md-dialog-content>' +
	 *                     '     Hi There {{vm.employee}}' +
	 *                     '  </md-dialog-content>' +
	 *                     '</md-dialog>',
	 *
	 *           controller: function DialogController($scope, $mdDialog) {
	 *             $scope.closeDialog = function() {
	 *               $mdDialog.hide();
	 *             }
	 *           }
	 *        });
	 *     }
	 *
	 *   }
	 *
	 *   // Greeting controller used with the more complex 'showCustomGreeting()' custom dialog
	 *
	 *   function GreetingController($scope, $mdDialog, employee) {
	 *     // Assigned from construction <code>locals</code> options...
	 *     $scope.employee = employee;
	 *
	 *     $scope.closeDialog = function() {
	 *       // Easily hides most recent dialog shown...
	 *       // no specific instance reference is needed.
	 *       $mdDialog.hide();
	 *     };
	 *   }
	 *
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#alert
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the alert title.
	 * - $mdDialogPreset#textContent(string) - Sets the alert message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the alert message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#ok(string) - Sets the alert "Okay" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the alert dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#confirm
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message. You can call show and the promise returned
	 * will be resolved only if the user clicks the confirm action on the dialog.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * Additionally, it supports the following methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the confirm title.
	 * - $mdDialogPreset#textContent(string) - Sets the confirm message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the confirm message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#ok(string) - Sets the confirm "Okay" button text.
	 * - $mdDialogPreset#cancel(string) - Sets the confirm "Cancel" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the confirm dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#prompt
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message and input box. You can call show and the promise returned
	 * will be resolved only if the user clicks the prompt action on the dialog, passing the input value as the first argument.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * Additionally, it supports the following methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the prompt title.
	 * - $mdDialogPreset#textContent(string) - Sets the prompt message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the prompt message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#placeholder(string) - Sets the placeholder text for the input.
	 * - $mdDialogPreset#required(boolean) - Sets the input required value.
	 * - $mdDialogPreset#initialValue(string) - Sets the initial value for the prompt input.
	 * - $mdDialogPreset#ok(string) - Sets the prompt "Okay" button text.
	 * - $mdDialogPreset#cancel(string) - Sets the prompt "Cancel" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the prompt dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#show
	 *
	 * @description
	 * Show a dialog with the specified options.
	 *
	 * @param {object} optionsOrPreset Either provide an `$mdDialogPreset` returned from `alert()`, and
	 * `confirm()`, or an options object with the following properties:
	 *   - `templateUrl` - `{string=}`: The url of a template that will be used as the content
	 *   of the dialog.
	 *   - `template` - `{string=}`: HTML template to show in the dialog. This **must** be trusted HTML
	 *      with respect to Angular's [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
	 *      This template should **never** be constructed with any kind of user input or user data.
	 *   - `contentElement` - `{string|Element}`: Instead of using a template, which will be compiled each time a
	 *     dialog opens, you can also use a DOM element.<br/>
	 *     * When specifying an element, which is present on the DOM, `$mdDialog` will temporary fetch the element into
	 *       the dialog and restores it at the old DOM position upon close.
	 *     * When specifying a string, the string be used as a CSS selector, to lookup for the element in the DOM.
	 *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template with a
	 *     `<md-dialog>` tag if one is not provided. Defaults to true. Can be disabled if you provide a
	 *     custom dialog directive.
	 *   - `targetEvent` - `{DOMClickEvent=}`: A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *   - `openFrom` - `{string|Element|object}`: The query selector, DOM element or the Rect object
	 *     that is used to determine the bounds (top, left, height, width) from which the Dialog will
	 *     originate.
	 *   - `closeTo` - `{string|Element|object}`: The query selector, DOM element or the Rect object
	 *     that is used to determine the bounds (top, left, height, width) to which the Dialog will
	 *     target.
	 *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified,
	 *     it will create a new isolate scope.
	 *     This scope will be destroyed when the dialog is removed unless `preserveScope` is set to true.
	 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the dialog is open.
	 *     Default true.
	 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop behind the dialog.
	 *     Default true.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the dialog to
	 *     close it. Default false.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the dialog.
	 *     Default true.
	 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on open. Only disable if
	 *     focusing some other way, as focus management is required for dialogs to be accessible.
	 *     Defaults to true.
	 *   - `controller` - `{function|string=}`: The controller to associate with the dialog. The controller
	 *     will be injected with the local `$mdDialog`, which passes along a scope for the dialog.
	 *   - `locals` - `{object=}`: An object containing key/value pairs. The keys will be used as names
	 *     of values to inject into the controller. For example, `locals: {three: 3}` would inject
	 *     `three` into the controller, with the value 3. If `bindToController` is true, they will be
	 *     copied to the controller instead.
	 *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
	 *   - `resolve` - `{function=}`: Similar to locals, except it takes as values functions that return promises, and the
	 *      dialog will not open until all of the promises resolve.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	 *   - `parent` - `{element=}`: The element to append the dialog to. Defaults to appending
	 *     to the root element of the application.
	 *   - `onShowing` - `function(scope, element)`: Callback function used to announce the show() action is
	 *     starting.
	 *   - `onComplete` - `function(scope, element)`: Callback function used to announce when the show() action is
	 *     finished.
	 *   - `onRemoving` - `function(element, removePromise)`: Callback function used to announce the
	 *      close/hide() action is starting. This allows developers to run custom animations
	 *      in parallel with the close animations.
	 *   - `fullscreen` `{boolean=}`: An option to toggle whether the dialog should show in fullscreen
	 *      or not. Defaults to `false`.
	 *   - `multiple` `{boolean=}`: An option to allow this dialog to display over one that's currently open.
	 * @returns {promise} A promise that can be resolved with `$mdDialog.hide()` or
	 * rejected with `$mdDialog.cancel()`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#hide
	 *
	 * @description
	 * Hide an existing dialog and resolve the promise returned from `$mdDialog.show()`.
	 *
	 * @param {*=} response An argument for the resolved promise.
	 *
	 * @returns {promise} A promise that is resolved when the dialog has been closed.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#cancel
	 *
	 * @description
	 * Hide an existing dialog and reject the promise returned from `$mdDialog.show()`.
	 *
	 * @param {*=} response An argument for the rejected promise.
	 *
	 * @returns {promise} A promise that is resolved when the dialog has been closed.
	 */
	
	function MdDialogProvider($$interimElementProvider) {
	  // Elements to capture and redirect focus when the user presses tab at the dialog boundary.
	  MdDialogController.$inject = ["$mdDialog", "$mdConstant"];
	  dialogDefaultOptions.$inject = ["$mdDialog", "$mdAria", "$mdUtil", "$mdConstant", "$animate", "$document", "$window", "$rootElement", "$log", "$injector", "$mdTheming", "$interpolate", "$mdInteraction"];
	  var topFocusTrap, bottomFocusTrap;
	
	  return $$interimElementProvider('$mdDialog')
	    .setDefaults({
	      methods: ['disableParentScroll', 'hasBackdrop', 'clickOutsideToClose', 'escapeToClose',
	          'targetEvent', 'closeTo', 'openFrom', 'parent', 'fullscreen', 'multiple'],
	      options: dialogDefaultOptions
	    })
	    .addPreset('alert', {
	      methods: ['title', 'htmlContent', 'textContent', 'content', 'ariaLabel', 'ok', 'theme',
	          'css'],
	      options: advancedDialogOptions
	    })
	    .addPreset('confirm', {
	      methods: ['title', 'htmlContent', 'textContent', 'content', 'ariaLabel', 'ok', 'cancel',
	          'theme', 'css'],
	      options: advancedDialogOptions
	    })
	    .addPreset('prompt', {
	      methods: ['title', 'htmlContent', 'textContent', 'initialValue', 'content', 'placeholder', 'ariaLabel',
	          'ok', 'cancel', 'theme', 'css', 'required'],
	      options: advancedDialogOptions
	    });
	
	  /* @ngInject */
	  function advancedDialogOptions() {
	    return {
	      template: [
	        '<md-dialog md-theme="{{ dialog.theme || dialog.defaultTheme }}" aria-label="{{ dialog.ariaLabel }}" ng-class="dialog.css">',
	        '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
	        '    <h2 class="md-title">{{ dialog.title }}</h2>',
	        '    <div ng-if="::dialog.mdHtmlContent" class="md-dialog-content-body" ',
	        '        ng-bind-html="::dialog.mdHtmlContent"></div>',
	        '    <div ng-if="::!dialog.mdHtmlContent" class="md-dialog-content-body">',
	        '      <p>{{::dialog.mdTextContent}}</p>',
	        '    </div>',
	        '    <md-input-container md-no-float ng-if="::dialog.$type == \'prompt\'" class="md-prompt-input-container">',
	        '      <input ng-keypress="dialog.keypress($event)" md-autofocus ng-model="dialog.result" ' +
	        '             placeholder="{{::dialog.placeholder}}" ng-required="dialog.required">',
	        '    </md-input-container>',
	        '  </md-dialog-content>',
	        '  <md-dialog-actions>',
	        '    <md-button ng-if="dialog.$type === \'confirm\' || dialog.$type === \'prompt\'"' +
	        '               ng-click="dialog.abort()" class="md-primary md-cancel-button">',
	        '      {{ dialog.cancel }}',
	        '    </md-button>',
	        '    <md-button ng-click="dialog.hide()" class="md-primary md-confirm-button" md-autofocus="dialog.$type===\'alert\'"' +
	        '               ng-disabled="dialog.required && !dialog.result">',
	        '      {{ dialog.ok }}',
	        '    </md-button>',
	        '  </md-dialog-actions>',
	        '</md-dialog>'
	      ].join('').replace(/\s\s+/g, ''),
	      controller: MdDialogController,
	      controllerAs: 'dialog',
	      bindToController: true,
	    };
	  }
	
	  /**
	   * Controller for the md-dialog interim elements
	   * @ngInject
	   */
	  function MdDialogController($mdDialog, $mdConstant) {
	    // For compatibility with AngularJS 1.6+, we should always use the $onInit hook in
	    // interimElements. The $mdCompiler simulates the $onInit hook for all versions.
	    this.$onInit = function() {
	      var isPrompt = this.$type == 'prompt';
	
	      if (isPrompt && this.initialValue) {
	        this.result = this.initialValue;
	      }
	
	      this.hide = function() {
	        $mdDialog.hide(isPrompt ? this.result : true);
	      };
	      this.abort = function() {
	        $mdDialog.cancel();
	      };
	      this.keypress = function($event) {
	        var invalidPrompt = isPrompt && this.required && !angular.isDefined(this.result);
	
	        if ($event.keyCode === $mdConstant.KEY_CODE.ENTER && !invalidPrompt) {
	          $mdDialog.hide(this.result);
	        }
	      };
	    };
	  }
	
	  /* @ngInject */
	  function dialogDefaultOptions($mdDialog, $mdAria, $mdUtil, $mdConstant, $animate, $document, $window, $rootElement,
	                                $log, $injector, $mdTheming, $interpolate, $mdInteraction) {
	
	    return {
	      hasBackdrop: true,
	      isolateScope: true,
	      onCompiling: beforeCompile,
	      onShow: onShow,
	      onShowing: beforeShow,
	      onRemove: onRemove,
	      clickOutsideToClose: false,
	      escapeToClose: true,
	      targetEvent: null,
	      closeTo: null,
	      openFrom: null,
	      focusOnOpen: true,
	      disableParentScroll: true,
	      autoWrap: true,
	      fullscreen: false,
	      transformTemplate: function(template, options) {
	        // Make the dialog container focusable, because otherwise the focus will be always redirected to
	        // an element outside of the container, and the focus trap won't work probably..
	        // Also the tabindex is needed for the `escapeToClose` functionality, because
	        // the keyDown event can't be triggered when the focus is outside of the container.
	        var startSymbol = $interpolate.startSymbol();
	        var endSymbol = $interpolate.endSymbol();
	        var theme = startSymbol + (options.themeWatch ? '' : '::') + 'theme' + endSymbol;
	        var themeAttr = (options.hasTheme) ? 'md-theme="'+theme+'"': '';
	        return '<div class="md-dialog-container" tabindex="-1" ' + themeAttr + '>' + validatedTemplate(template) + '</div>';
	
	        /**
	         * The specified template should contain a <md-dialog> wrapper element....
	         */
	        function validatedTemplate(template) {
	          if (options.autoWrap && !/<\/md-dialog>/g.test(template)) {
	            return '<md-dialog>' + (template || '') + '</md-dialog>';
	          } else {
	            return template || '';
	          }
	        }
	      }
	    };
	
	    function beforeCompile(options) {
	      // Automatically apply the theme, if the user didn't specify a theme explicitly.
	      // Those option changes need to be done, before the compilation has started, because otherwise
	      // the option changes will be not available in the $mdCompilers locales.
	      options.defaultTheme = $mdTheming.defaultTheme();
	
	      detectTheming(options);
	    }
	
	    function beforeShow(scope, element, options, controller) {
	
	      if (controller) {
	        var mdHtmlContent = controller.htmlContent || options.htmlContent || '';
	        var mdTextContent = controller.textContent || options.textContent ||
	            controller.content || options.content || '';
	
	        if (mdHtmlContent && !$injector.has('$sanitize')) {
	          throw Error('The ngSanitize module must be loaded in order to use htmlContent.');
	        }
	
	        if (mdHtmlContent && mdTextContent) {
	          throw Error('md-dialog cannot have both `htmlContent` and `textContent`');
	        }
	
	        // Only assign the content if nothing throws, otherwise it'll still be compiled.
	        controller.mdHtmlContent = mdHtmlContent;
	        controller.mdTextContent = mdTextContent;
	      }
	    }
	
	    /** Show method for dialogs */
	    function onShow(scope, element, options, controller) {
	      angular.element($document[0].body).addClass('md-dialog-is-showing');
	
	      var dialogElement = element.find('md-dialog');
	
	      // Once a dialog has `ng-cloak` applied on his template the dialog animation will not work properly.
	      // This is a very common problem, so we have to notify the developer about this.
	      if (dialogElement.hasClass('ng-cloak')) {
	        var message = '$mdDialog: using `<md-dialog ng-cloak>` will affect the dialog opening animations.';
	        $log.warn( message, element[0] );
	      }
	
	      captureParentAndFromToElements(options);
	      configureAria(dialogElement, options);
	      showBackdrop(scope, element, options);
	      activateListeners(element, options);
	
	      return dialogPopIn(element, options)
	        .then(function() {
	          lockScreenReader(element, options);
	          warnDeprecatedActions();
	          focusOnOpen();
	        });
	
	      /**
	       * Check to see if they used the deprecated .md-actions class and log a warning
	       */
	      function warnDeprecatedActions() {
	        if (element[0].querySelector('.md-actions')) {
	          $log.warn('Using a class of md-actions is deprecated, please use <md-dialog-actions>.');
	        }
	      }
	
	      /**
	       * For alerts, focus on content... otherwise focus on
	       * the close button (or equivalent)
	       */
	      function focusOnOpen() {
	        if (options.focusOnOpen) {
	          var target = $mdUtil.findFocusTarget(element) || findCloseButton() || dialogElement;
	          target.focus();
	        }
	
	        /**
	         * If no element with class dialog-close, try to find the last
	         * button child in md-actions and assume it is a close button.
	         *
	         * If we find no actions at all, log a warning to the console.
	         */
	        function findCloseButton() {
	          return element[0].querySelector('.dialog-close, md-dialog-actions button:last-child');
	        }
	      }
	    }
	
	    /**
	     * Remove function for all dialogs
	     */
	    function onRemove(scope, element, options) {
	      options.deactivateListeners();
	      options.unlockScreenReader();
	      options.hideBackdrop(options.$destroy);
	
	      // Remove the focus traps that we added earlier for keeping focus within the dialog.
	      if (topFocusTrap && topFocusTrap.parentNode) {
	        topFocusTrap.parentNode.removeChild(topFocusTrap);
	      }
	
	      if (bottomFocusTrap && bottomFocusTrap.parentNode) {
	        bottomFocusTrap.parentNode.removeChild(bottomFocusTrap);
	      }
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	      return options.$destroy ? detachAndClean() : animateRemoval().then( detachAndClean );
	
	      /**
	       * For normal closes, animate the removal.
	       * For forced closes (like $destroy events), skip the animations
	       */
	      function animateRemoval() {
	        return dialogPopOut(element, options);
	      }
	
	      /**
	       * Detach the element
	       */
	      function detachAndClean() {
	        angular.element($document[0].body).removeClass('md-dialog-is-showing');
	
	        // Reverse the container stretch if using a content element.
	        if (options.contentElement) {
	          options.reverseContainerStretch();
	        }
	
	        // Exposed cleanup function from the $mdCompiler.
	        options.cleanupElement();
	
	        // Restores the focus to the origin element if the last interaction upon opening was a keyboard.
	        if (!options.$destroy && options.originInteraction === 'keyboard') {
	          options.origin.focus();
	        }
	      }
	    }
	
	    function detectTheming(options) {
	      // Once the user specifies a targetEvent, we will automatically try to find the correct
	      // nested theme.
	      var targetEl;
	      if (options.targetEvent && options.targetEvent.target) {
	        targetEl = angular.element(options.targetEvent.target);
	      }
	
	      var themeCtrl = targetEl && targetEl.controller('mdTheme');
	
	      options.hasTheme = (!!themeCtrl);
	
	      if (!options.hasTheme) {
	        return;
	      }
	
	      options.themeWatch = themeCtrl.$shouldWatch;
	
	      var theme = options.theme || themeCtrl.$mdTheme;
	
	      if (theme) {
	        options.scope.theme = theme;
	      }
	
	      var unwatch = themeCtrl.registerChanges(function (newTheme) {
	        options.scope.theme = newTheme;
	
	        if (!options.themeWatch) {
	          unwatch();
	        }
	      });
	    }
	
	    /**
	     * Capture originator/trigger/from/to element information (if available)
	     * and the parent container for the dialog; defaults to the $rootElement
	     * unless overridden in the options.parent
	     */
	    function captureParentAndFromToElements(options) {
	          options.origin = angular.extend({
	            element: null,
	            bounds: null,
	            focus: angular.noop
	          }, options.origin || {});
	
	          options.parent   = getDomElement(options.parent, $rootElement);
	          options.closeTo  = getBoundingClientRect(getDomElement(options.closeTo));
	          options.openFrom = getBoundingClientRect(getDomElement(options.openFrom));
	
	          if ( options.targetEvent ) {
	            options.origin = getBoundingClientRect(options.targetEvent.target, options.origin);
	            options.originInteraction = $mdInteraction.getLastInteractionType();
	          }
	
	
	          /**
	           * Identify the bounding RECT for the target element
	           *
	           */
	          function getBoundingClientRect (element, orig) {
	            var source = angular.element((element || {}));
	            if (source && source.length) {
	              // Compute and save the target element's bounding rect, so that if the
	              // element is hidden when the dialog closes, we can shrink the dialog
	              // back to the same position it expanded from.
	              //
	              // Checking if the source is a rect object or a DOM element
	              var bounds = {top:0,left:0,height:0,width:0};
	              var hasFn = angular.isFunction(source[0].getBoundingClientRect);
	
	              return angular.extend(orig || {}, {
	                  element : hasFn ? source : undefined,
	                  bounds  : hasFn ? source[0].getBoundingClientRect() : angular.extend({}, bounds, source[0]),
	                  focus   : angular.bind(source, source.focus),
	              });
	            }
	          }
	
	          /**
	           * If the specifier is a simple string selector, then query for
	           * the DOM element.
	           */
	          function getDomElement(element, defaultElement) {
	            if (angular.isString(element)) {
	              element = $document[0].querySelector(element);
	            }
	
	            // If we have a reference to a raw dom element, always wrap it in jqLite
	            return angular.element(element || defaultElement);
	          }
	
	        }
	
	    /**
	     * Listen for escape keys and outside clicks to auto close
	     */
	    function activateListeners(element, options) {
	      var window = angular.element($window);
	      var onWindowResize = $mdUtil.debounce(function() {
	        stretchDialogContainerToViewport(element, options);
	      }, 60);
	
	      var removeListeners = [];
	      var smartClose = function() {
	        // Only 'confirm' dialogs have a cancel button... escape/clickOutside will
	        // cancel or fallback to hide.
	        var closeFn = ( options.$type == 'alert' ) ? $mdDialog.hide : $mdDialog.cancel;
	        $mdUtil.nextTick(closeFn, true);
	      };
	
	      if (options.escapeToClose) {
	        var parentTarget = options.parent;
	        var keyHandlerFn = function(ev) {
	          if (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
	            ev.stopPropagation();
	            ev.preventDefault();
	
	            smartClose();
	          }
	        };
	
	        // Add keydown listeners
	        element.on('keydown', keyHandlerFn);
	        parentTarget.on('keydown', keyHandlerFn);
	
	        // Queue remove listeners function
	        removeListeners.push(function() {
	
	          element.off('keydown', keyHandlerFn);
	          parentTarget.off('keydown', keyHandlerFn);
	
	        });
	      }
	
	      // Register listener to update dialog on window resize
	      window.on('resize', onWindowResize);
	
	      removeListeners.push(function() {
	        window.off('resize', onWindowResize);
	      });
	
	      if (options.clickOutsideToClose) {
	        var target = element;
	        var sourceElem;
	
	        // Keep track of the element on which the mouse originally went down
	        // so that we can only close the backdrop when the 'click' started on it.
	        // A simple 'click' handler does not work,
	        // it sets the target object as the element the mouse went down on.
	        var mousedownHandler = function(ev) {
	          sourceElem = ev.target;
	        };
	
	        // We check if our original element and the target is the backdrop
	        // because if the original was the backdrop and the target was inside the dialog
	        // we don't want to dialog to close.
	        var mouseupHandler = function(ev) {
	          if (sourceElem === target[0] && ev.target === target[0]) {
	            ev.stopPropagation();
	            ev.preventDefault();
	
	            smartClose();
	          }
	        };
	
	        // Add listeners
	        target.on('mousedown', mousedownHandler);
	        target.on('mouseup', mouseupHandler);
	
	        // Queue remove listeners function
	        removeListeners.push(function() {
	          target.off('mousedown', mousedownHandler);
	          target.off('mouseup', mouseupHandler);
	        });
	      }
	
	      // Attach specific `remove` listener handler
	      options.deactivateListeners = function() {
	        removeListeners.forEach(function(removeFn) {
	          removeFn();
	        });
	        options.deactivateListeners = null;
	      };
	    }
	
	    /**
	     * Show modal backdrop element...
	     */
	    function showBackdrop(scope, element, options) {
	
	      if (options.disableParentScroll) {
	        // !! DO this before creating the backdrop; since disableScrollAround()
	        //    configures the scroll offset; which is used by mdBackDrop postLink()
	        options.restoreScroll = $mdUtil.disableScrollAround(element, options.parent);
	      }
	
	      if (options.hasBackdrop) {
	        options.backdrop = $mdUtil.createBackdrop(scope, "md-dialog-backdrop md-opaque");
	        $animate.enter(options.backdrop, options.parent);
	      }
	
	      /**
	       * Hide modal backdrop element...
	       */
	      options.hideBackdrop = function hideBackdrop($destroy) {
	        if (options.backdrop) {
	          if ( $destroy ) options.backdrop.remove();
	          else              $animate.leave(options.backdrop);
	        }
	
	
	        if (options.disableParentScroll) {
	          options.restoreScroll && options.restoreScroll();
	          delete options.restoreScroll;
	        }
	
	        options.hideBackdrop = null;
	      };
	    }
	
	    /**
	     * Inject ARIA-specific attributes appropriate for Dialogs
	     */
	    function configureAria(element, options) {
	
	      var role = (options.$type === 'alert') ? 'alertdialog' : 'dialog';
	      var dialogContent = element.find('md-dialog-content');
	      var existingDialogId = element.attr('id');
	      var dialogContentId = 'dialogContent_' + (existingDialogId || $mdUtil.nextUid());
	
	      element.attr({
	        'role': role,
	        'tabIndex': '-1'
	      });
	
	      if (dialogContent.length === 0) {
	        dialogContent = element;
	        // If the dialog element already had an ID, don't clobber it.
	        if (existingDialogId) {
	          dialogContentId = existingDialogId;
	        }
	      }
	
	      dialogContent.attr('id', dialogContentId);
	      element.attr('aria-describedby', dialogContentId);
	
	      if (options.ariaLabel) {
	        $mdAria.expect(element, 'aria-label', options.ariaLabel);
	      }
	      else {
	        $mdAria.expectAsync(element, 'aria-label', function() {
	          // If dialog title is specified, set aria-label with it
	          // See https://github.com/angular/material/issues/10582
	          if (options.title) {
	            return options.title;
	          } else {
	            var words = dialogContent.text().split(/\s+/);
	            if (words.length > 3) words = words.slice(0, 3).concat('...');
	            return words.join(' ');
	          }
	        });
	      }
	
	      // Set up elements before and after the dialog content to capture focus and
	      // redirect back into the dialog.
	      topFocusTrap = document.createElement('div');
	      topFocusTrap.classList.add('md-dialog-focus-trap');
	      topFocusTrap.tabIndex = 0;
	
	      bottomFocusTrap = topFocusTrap.cloneNode(false);
	
	      // When focus is about to move out of the dialog, we want to intercept it and redirect it
	      // back to the dialog element.
	      var focusHandler = function() {
	        element.focus();
	      };
	      topFocusTrap.addEventListener('focus', focusHandler);
	      bottomFocusTrap.addEventListener('focus', focusHandler);
	
	      // The top focus trap inserted immeidately before the md-dialog element (as a sibling).
	      // The bottom focus trap is inserted at the very end of the md-dialog element (as a child).
	      element[0].parentNode.insertBefore(topFocusTrap, element[0]);
	      element.after(bottomFocusTrap);
	    }
	
	    /**
	     * Prevents screen reader interaction behind modal window
	     * on swipe interfaces
	     */
	    function lockScreenReader(element, options) {
	      var isHidden = true;
	
	      // get raw DOM node
	      walkDOM(element[0]);
	
	      options.unlockScreenReader = function () {
	        isHidden = false;
	        walkDOM(element[0]);
	
	        options.unlockScreenReader = null;
	      };
	
	      /**
	       * Get all of an element's parent elements up the DOM tree
	       * @return {Array} The parent elements
	       */
	      function getParents(element) {
	        var parents = [];
	        while (element.parentNode) {
	          if (element === document.body) {
	            return parents;
	          }
	          var children = element.parentNode.children;
	          for (var i = 0; i < children.length; i++) {
	            // skip over child if it is an ascendant of the dialog
	            // a script or style tag, or a live region.
	            if (element !== children[i] &&
	                !isNodeOneOf(children[i], ['SCRIPT', 'STYLE']) &&
	                !children[i].hasAttribute('aria-live')) {
	              parents.push(children[i]);
	            }
	          }
	          element = element.parentNode;
	        }
	        return parents;
	      }
	
	      /**
	       * Walk DOM to apply or remove aria-hidden on sibling nodes
	       * and parent sibling nodes
	       */
	      function walkDOM(element) {
	        var elements = getParents(element);
	        for (var i = 0; i < elements.length; i++) {
	          elements[i].setAttribute('aria-hidden', isHidden);
	        }
	      }
	    }
	
	    /**
	     * Ensure the dialog container fill-stretches to the viewport
	     */
	    function stretchDialogContainerToViewport(container, options) {
	      var isFixed = $window.getComputedStyle($document[0].body).position == 'fixed';
	      var backdrop = options.backdrop ? $window.getComputedStyle(options.backdrop[0]) : null;
	      var height = backdrop ? Math.min($document[0].body.clientHeight, Math.ceil(Math.abs(parseInt(backdrop.height, 10)))) : 0;
	
	      var previousStyles = {
	        top: container.css('top'),
	        height: container.css('height')
	      };
	
	      // If the body is fixed, determine the distance to the viewport in relative from the parent.
	      var parentTop = Math.abs(options.parent[0].getBoundingClientRect().top);
	
	      container.css({
	        top: (isFixed ? parentTop : 0) + 'px',
	        height: height ? height + 'px' : '100%'
	      });
	
	      return function() {
	        // Reverts the modified styles back to the previous values.
	        // This is needed for contentElements, which should have the same styles after close
	        // as before.
	        container.css(previousStyles);
	      };
	    }
	
	    /**
	     *  Dialog open and pop-in animation
	     */
	    function dialogPopIn(container, options) {
	      // Add the `md-dialog-container` to the DOM
	      options.parent.append(container);
	      options.reverseContainerStretch = stretchDialogContainerToViewport(container, options);
	
	      var dialogEl = container.find('md-dialog');
	      var animator = $mdUtil.dom.animator;
	      var buildTranslateToOrigin = animator.calculateZoomToOrigin;
	      var translateOptions = {transitionInClass: 'md-transition-in', transitionOutClass: 'md-transition-out'};
	      var from = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.openFrom || options.origin));
	      var to = animator.toTransformCss("");  // defaults to center display (or parent or $rootElement)
	
	      dialogEl.toggleClass('md-dialog-fullscreen', !!options.fullscreen);
	
	      return animator
	        .translate3d(dialogEl, from, to, translateOptions)
	        .then(function(animateReversal) {
	
	          // Build a reversal translate function synced to this translation...
	          options.reverseAnimate = function() {
	            delete options.reverseAnimate;
	
	            if (options.closeTo) {
	              // Using the opposite classes to create a close animation to the closeTo element
	              translateOptions = {transitionInClass: 'md-transition-out', transitionOutClass: 'md-transition-in'};
	              from = to;
	              to = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.closeTo));
	
	              return animator
	                .translate3d(dialogEl, from, to,translateOptions);
	            }
	
	            return animateReversal(
	              to = animator.toTransformCss(
	                // in case the origin element has moved or is hidden,
	                // let's recalculate the translateCSS
	                buildTranslateToOrigin(dialogEl, options.origin)
	              )
	            );
	
	          };
	
	          // Function to revert the generated animation styles on the dialog element.
	          // Useful when using a contentElement instead of a template.
	          options.clearAnimate = function() {
	            delete options.clearAnimate;
	
	            // Remove the transition classes, added from $animateCSS, since those can't be removed
	            // by reversely running the animator.
	            dialogEl.removeClass([
	              translateOptions.transitionOutClass,
	              translateOptions.transitionInClass
	            ].join(' '));
	
	            // Run the animation reversely to remove the previous added animation styles.
	            return animator.translate3d(dialogEl, to, animator.toTransformCss(''), {});
	          };
	
	          return true;
	        });
	    }
	
	    /**
	     * Dialog close and pop-out animation
	     */
	    function dialogPopOut(container, options) {
	      return options.reverseAnimate().then(function() {
	        if (options.contentElement) {
	          // When we use a contentElement, we want the element to be the same as before.
	          // That means, that we have to clear all the animation properties, like transform.
	          options.clearAnimate();
	        }
	      });
	    }
	
	    /**
	     * Utility function to filter out raw DOM nodes
	     */
	    function isNodeOneOf(elem, nodeTypeArray) {
	      if (nodeTypeArray.indexOf(elem.nodeName) !== -1) {
	        return true;
	      }
	    }
	
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.divider
	 * @description Divider module!
	 */
	MdDividerDirective.$inject = ["$mdTheming"];
	angular.module('material.components.divider', [
	  'material.core'
	])
	  .directive('mdDivider', MdDividerDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdDivider
	 * @module material.components.divider
	 * @restrict E
	 *
	 * @description
	 * Dividers group and separate content within lists and page layouts using strong visual and spatial distinctions. This divider is a thin rule, lightweight enough to not distract the user from content.
	 *
	 * @param {boolean=} md-inset Add this attribute to activate the inset divider style.
	 * @usage
	 * <hljs lang="html">
	 * <md-divider></md-divider>
	 *
	 * <md-divider md-inset></md-divider>
	 * </hljs>
	 *
	 */
	function MdDividerDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    link: $mdTheming
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabActions
	   */
	  MdFabActionsDirective.$inject = ["$mdUtil"];
	  angular
	    .module('material.components.fabActions', ['material.core'])
	    .directive('mdFabActions', MdFabActionsDirective);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabActions
	   * @module material.components.fabActions
	   *
	   * @restrict E
	   *
	   * @description
	   * The `<md-fab-actions>` directive is used inside of a `<md-fab-speed-dial>` or
	   * `<md-fab-toolbar>` directive to mark an element (or elements) as the actions and setup the
	   * proper event listeners.
	   *
	   * @usage
	   * See the `<md-fab-speed-dial>` or `<md-fab-toolbar>` directives for example usage.
	   */
	  function MdFabActionsDirective($mdUtil) {
	    return {
	      restrict: 'E',
	
	      require: ['^?mdFabSpeedDial', '^?mdFabToolbar'],
	
	      compile: function(element, attributes) {
	        var children = element.children();
	
	        var hasNgRepeat = $mdUtil.prefixer().hasAttribute(children, 'ng-repeat');
	
	        // Support both ng-repeat and static content
	        if (hasNgRepeat) {
	          children.addClass('md-fab-action-item');
	        } else {
	          // Wrap every child in a new div and add a class that we can scale/fling independently
	          children.wrap('<div class="md-fab-action-item">');
	        }
	      }
	    };
	  }
	
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  MdFabController.$inject = ["$scope", "$element", "$animate", "$mdUtil", "$mdConstant", "$timeout"];
	  angular.module('material.components.fabShared', ['material.core'])
	    .controller('MdFabController', MdFabController);
	
	  function MdFabController($scope, $element, $animate, $mdUtil, $mdConstant, $timeout) {
	    var vm = this;
	    var initialAnimationAttempts = 0;
	
	    // NOTE: We use async eval(s) below to avoid conflicts with any existing digest loops
	
	    vm.open = function() {
	      $scope.$evalAsync("vm.isOpen = true");
	    };
	
	    vm.close = function() {
	      // Async eval to avoid conflicts with existing digest loops
	      $scope.$evalAsync("vm.isOpen = false");
	
	      // Focus the trigger when the element closes so users can still tab to the next item
	      $element.find('md-fab-trigger')[0].focus();
	    };
	
	    // Toggle the open/close state when the trigger is clicked
	    vm.toggle = function() {
	      $scope.$evalAsync("vm.isOpen = !vm.isOpen");
	    };
	
	    /*
	     * AngularJS Lifecycle hook for newer AngularJS versions.
	     * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	     */
	    vm.$onInit = function() {
	      setupDefaults();
	      setupListeners();
	      setupWatchers();
	
	      fireInitialAnimations();
	    };
	
	    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	    // manually call the $onInit hook.
	    if (angular.version.major === 1 && angular.version.minor <= 4) {
	      this.$onInit();
	    }
	
	    function setupDefaults() {
	      // Set the default direction to 'down' if none is specified
	      vm.direction = vm.direction || 'down';
	
	      // Set the default to be closed
	      vm.isOpen = vm.isOpen || false;
	
	      // Start the keyboard interaction at the first action
	      resetActionIndex();
	
	      // Add an animations waiting class so we know not to run
	      $element.addClass('md-animations-waiting');
	    }
	
	    function setupListeners() {
	      var eventTypes = [
	        'click', 'focusin', 'focusout'
	      ];
	
	      // Add our listeners
	      angular.forEach(eventTypes, function(eventType) {
	        $element.on(eventType, parseEvents);
	      });
	
	      // Remove our listeners when destroyed
	      $scope.$on('$destroy', function() {
	        angular.forEach(eventTypes, function(eventType) {
	          $element.off(eventType, parseEvents);
	        });
	
	        // remove any attached keyboard handlers in case element is removed while
	        // speed dial is open
	        disableKeyboard();
	      });
	    }
	
	    var closeTimeout;
	    function parseEvents(event) {
	      // If the event is a click, just handle it
	      if (event.type == 'click') {
	        handleItemClick(event);
	      }
	
	      // If we focusout, set a timeout to close the element
	      if (event.type == 'focusout' && !closeTimeout) {
	        closeTimeout = $timeout(function() {
	          vm.close();
	        }, 100, false);
	      }
	
	      // If we see a focusin and there is a timeout about to run, cancel it so we stay open
	      if (event.type == 'focusin' && closeTimeout) {
	        $timeout.cancel(closeTimeout);
	        closeTimeout = null;
	      }
	    }
	
	    function resetActionIndex() {
	      vm.currentActionIndex = -1;
	    }
	
	    function setupWatchers() {
	      // Watch for changes to the direction and update classes/attributes
	      $scope.$watch('vm.direction', function(newDir, oldDir) {
	        // Add the appropriate classes so we can target the direction in the CSS
	        $animate.removeClass($element, 'md-' + oldDir);
	        $animate.addClass($element, 'md-' + newDir);
	
	        // Reset the action index since it may have changed
	        resetActionIndex();
	      });
	
	      var trigger, actions;
	
	      // Watch for changes to md-open
	      $scope.$watch('vm.isOpen', function(isOpen) {
	        // Reset the action index since it may have changed
	        resetActionIndex();
	
	        // We can't get the trigger/actions outside of the watch because the component hasn't been
	        // linked yet, so we wait until the first watch fires to cache them.
	        if (!trigger || !actions) {
	          trigger = getTriggerElement();
	          actions = getActionsElement();
	        }
	
	        if (isOpen) {
	          enableKeyboard();
	        } else {
	          disableKeyboard();
	        }
	
	        var toAdd = isOpen ? 'md-is-open' : '';
	        var toRemove = isOpen ? '' : 'md-is-open';
	
	        // Set the proper ARIA attributes
	        trigger.attr('aria-haspopup', true);
	        trigger.attr('aria-expanded', isOpen);
	        actions.attr('aria-hidden', !isOpen);
	
	        // Animate the CSS classes
	        $animate.setClass($element, toAdd, toRemove);
	      });
	    }
	
	    function fireInitialAnimations() {
	      // If the element is actually visible on the screen
	      if ($element[0].scrollHeight > 0) {
	        // Fire our animation
	        $animate.addClass($element, '_md-animations-ready').then(function() {
	          // Remove the waiting class
	          $element.removeClass('md-animations-waiting');
	        });
	      }
	
	      // Otherwise, try for up to 1 second before giving up
	      else if (initialAnimationAttempts < 10) {
	        $timeout(fireInitialAnimations, 100);
	
	        // Increment our counter
	        initialAnimationAttempts = initialAnimationAttempts + 1;
	      }
	    }
	
	    function enableKeyboard() {
	      $element.on('keydown', keyPressed);
	
	      // On the next tick, setup a check for outside clicks; we do this on the next tick to avoid
	      // clicks/touches that result in the isOpen attribute changing (e.g. a bound radio button)
	      $mdUtil.nextTick(function() {
	        angular.element(document).on('click touchend', checkForOutsideClick);
	      });
	
	      // TODO: On desktop, we should be able to reset the indexes so you cannot tab through, but
	      // this breaks accessibility, especially on mobile, since you have no arrow keys to press
	      //resetActionTabIndexes();
	    }
	
	    function disableKeyboard() {
	      $element.off('keydown', keyPressed);
	      angular.element(document).off('click touchend', checkForOutsideClick);
	    }
	
	    function checkForOutsideClick(event) {
	      if (event.target) {
	        var closestTrigger = $mdUtil.getClosest(event.target, 'md-fab-trigger');
	        var closestActions = $mdUtil.getClosest(event.target, 'md-fab-actions');
	
	        if (!closestTrigger && !closestActions) {
	          vm.close();
	        }
	      }
	    }
	
	    function keyPressed(event) {
	      switch (event.which) {
	        case $mdConstant.KEY_CODE.ESCAPE: vm.close(); event.preventDefault(); return false;
	        case $mdConstant.KEY_CODE.LEFT_ARROW: doKeyLeft(event); return false;
	        case $mdConstant.KEY_CODE.UP_ARROW: doKeyUp(event); return false;
	        case $mdConstant.KEY_CODE.RIGHT_ARROW: doKeyRight(event); return false;
	        case $mdConstant.KEY_CODE.DOWN_ARROW: doKeyDown(event); return false;
	      }
	    }
	
	    function doActionPrev(event) {
	      focusAction(event, -1);
	    }
	
	    function doActionNext(event) {
	      focusAction(event, 1);
	    }
	
	    function focusAction(event, direction) {
	      var actions = resetActionTabIndexes();
	
	      // Increment/decrement the counter with restrictions
	      vm.currentActionIndex = vm.currentActionIndex + direction;
	      vm.currentActionIndex = Math.min(actions.length - 1, vm.currentActionIndex);
	      vm.currentActionIndex = Math.max(0, vm.currentActionIndex);
	
	      // Focus the element
	      var focusElement =  angular.element(actions[vm.currentActionIndex]).children()[0];
	      angular.element(focusElement).attr('tabindex', 0);
	      focusElement.focus();
	
	      // Make sure the event doesn't bubble and cause something else
	      event.preventDefault();
	      event.stopImmediatePropagation();
	    }
	
	    function resetActionTabIndexes() {
	      // Grab all of the actions
	      var actions = getActionsElement()[0].querySelectorAll('.md-fab-action-item');
	
	      // Disable all other actions for tabbing
	      angular.forEach(actions, function(action) {
	        angular.element(angular.element(action).children()[0]).attr('tabindex', -1);
	      });
	
	      return actions;
	    }
	
	    function doKeyLeft(event) {
	      if (vm.direction === 'left') {
	        doActionNext(event);
	      } else {
	        doActionPrev(event);
	      }
	    }
	
	    function doKeyUp(event) {
	      if (vm.direction === 'down') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function doKeyRight(event) {
	      if (vm.direction === 'left') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function doKeyDown(event) {
	      if (vm.direction === 'up') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function isTrigger(element) {
	      return $mdUtil.getClosest(element, 'md-fab-trigger');
	    }
	
	    function isAction(element) {
	      return $mdUtil.getClosest(element, 'md-fab-actions');
	    }
	
	    function handleItemClick(event) {
	      if (isTrigger(event.target)) {
	        vm.toggle();
	      }
	
	      if (isAction(event.target)) {
	        vm.close();
	      }
	    }
	
	    function getTriggerElement() {
	      return $element.find('md-fab-trigger');
	    }
	
	    function getActionsElement() {
	      return $element.find('md-fab-actions');
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * The duration of the CSS animation in milliseconds.
	   *
	   * @type {number}
	   */
	  MdFabSpeedDialFlingAnimation.$inject = ["$timeout"];
	  MdFabSpeedDialScaleAnimation.$inject = ["$timeout"];
	  var cssAnimationDuration = 300;
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabSpeedDial
	   */
	  angular
	    // Declare our module
	    .module('material.components.fabSpeedDial', [
	      'material.core',
	      'material.components.fabShared',
	      'material.components.fabActions'
	    ])
	
	    // Register our directive
	    .directive('mdFabSpeedDial', MdFabSpeedDialDirective)
	
	    // Register our custom animations
	    .animation('.md-fling', MdFabSpeedDialFlingAnimation)
	    .animation('.md-scale', MdFabSpeedDialScaleAnimation)
	
	    // Register a service for each animation so that we can easily inject them into unit tests
	    .service('mdFabSpeedDialFlingAnimation', MdFabSpeedDialFlingAnimation)
	    .service('mdFabSpeedDialScaleAnimation', MdFabSpeedDialScaleAnimation);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabSpeedDial
	   * @module material.components.fabSpeedDial
	   *
	   * @restrict E
	   *
	   * @description
	   * The `<md-fab-speed-dial>` directive is used to present a series of popup elements (usually
	   * `<md-button>`s) for quick access to common actions.
	   *
	   * There are currently two animations available by applying one of the following classes to
	   * the component:
	   *
	   *  - `md-fling` - The speed dial items appear from underneath the trigger and move into their
	   *    appropriate positions.
	   *  - `md-scale` - The speed dial items appear in their proper places by scaling from 0% to 100%.
	   *
	   * You may also easily position the trigger by applying one one of the following classes to the
	   * `<md-fab-speed-dial>` element:
	   *  - `md-fab-top-left`
	   *  - `md-fab-top-right`
	   *  - `md-fab-bottom-left`
	   *  - `md-fab-bottom-right`
	   *
	   * These CSS classes use `position: absolute`, so you need to ensure that the container element
	   * also uses `position: absolute` or `position: relative` in order for them to work.
	   *
	   * Additionally, you may use the standard `ng-mouseenter` and `ng-mouseleave` directives to
	   * open or close the speed dial. However, if you wish to allow users to hover over the empty
	   * space where the actions will appear, you must also add the `md-hover-full` class to the speed
	   * dial element. Without this, the hover effect will only occur on top of the trigger.
	   *
	   * See the demos for more information.
	   *
	   * ## Troubleshooting
	   *
	   * If your speed dial shows the closing animation upon launch, you may need to use `ng-cloak` on
	   * the parent container to ensure that it is only visible once ready. We have plans to remove this
	   * necessity in the future.
	   *
	   * @usage
	   * <hljs lang="html">
	   * <md-fab-speed-dial md-direction="up" class="md-fling">
	   *   <md-fab-trigger>
	   *     <md-button aria-label="Add..."><md-icon md-svg-src="/img/icons/plus.svg"></md-icon></md-button>
	   *   </md-fab-trigger>
	   *
	   *   <md-fab-actions>
	   *     <md-button aria-label="Add User">
	   *       <md-icon md-svg-src="/img/icons/user.svg"></md-icon>
	   *     </md-button>
	   *
	   *     <md-button aria-label="Add Group">
	   *       <md-icon md-svg-src="/img/icons/group.svg"></md-icon>
	   *     </md-button>
	   *   </md-fab-actions>
	   * </md-fab-speed-dial>
	   * </hljs>
	   *
	   * @param {string} md-direction From which direction you would like the speed dial to appear
	   * relative to the trigger element.
	   * @param {expression=} md-open Programmatically control whether or not the speed-dial is visible.
	   */
	  function MdFabSpeedDialDirective() {
	    return {
	      restrict: 'E',
	
	      scope: {
	        direction: '@?mdDirection',
	        isOpen: '=?mdOpen'
	      },
	
	      bindToController: true,
	      controller: 'MdFabController',
	      controllerAs: 'vm',
	
	      link: FabSpeedDialLink
	    };
	
	    function FabSpeedDialLink(scope, element) {
	      // Prepend an element to hold our CSS variables so we can use them in the animations below
	      element.prepend('<div class="_md-css-variables"></div>');
	    }
	  }
	
	  function MdFabSpeedDialFlingAnimation($timeout) {
	    function delayDone(done) { $timeout(done, cssAnimationDuration, false); }
	
	    function runAnimation(element) {
	      // Don't run if we are still waiting and we are not ready
	      if (element.hasClass('md-animations-waiting') && !element.hasClass('_md-animations-ready')) {
	        return;
	      }
	
	      var el = element[0];
	      var ctrl = element.controller('mdFabSpeedDial');
	      var items = el.querySelectorAll('.md-fab-action-item');
	
	      // Grab our trigger element
	      var triggerElement = el.querySelector('md-fab-trigger');
	
	      // Grab our element which stores CSS variables
	      var variablesElement = el.querySelector('._md-css-variables');
	
	      // Setup JS variables based on our CSS variables
	      var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);
	
	      // Always reset the items to their natural position/state
	      angular.forEach(items, function(item, index) {
	        var styles = item.style;
	
	        styles.transform = styles.webkitTransform = '';
	        styles.transitionDelay = '';
	        styles.opacity = 1;
	
	        // Make the items closest to the trigger have the highest z-index
	        styles.zIndex = (items.length - index) + startZIndex;
	      });
	
	      // Set the trigger to be above all of the actions so they disappear behind it.
	      triggerElement.style.zIndex = startZIndex + items.length + 1;
	
	      // If the control is closed, hide the items behind the trigger
	      if (!ctrl.isOpen) {
	        angular.forEach(items, function(item, index) {
	          var newPosition, axis;
	          var styles = item.style;
	
	          // Make sure to account for differences in the dimensions of the trigger verses the items
	          // so that we can properly center everything; this helps hide the item's shadows behind
	          // the trigger.
	          var triggerItemHeightOffset = (triggerElement.clientHeight - item.clientHeight) / 2;
	          var triggerItemWidthOffset = (triggerElement.clientWidth - item.clientWidth) / 2;
	
	          switch (ctrl.direction) {
	            case 'up':
	              newPosition = (item.scrollHeight * (index + 1) + triggerItemHeightOffset);
	              axis = 'Y';
	              break;
	            case 'down':
	              newPosition = -(item.scrollHeight * (index + 1) + triggerItemHeightOffset);
	              axis = 'Y';
	              break;
	            case 'left':
	              newPosition = (item.scrollWidth * (index + 1) + triggerItemWidthOffset);
	              axis = 'X';
	              break;
	            case 'right':
	              newPosition = -(item.scrollWidth * (index + 1) + triggerItemWidthOffset);
	              axis = 'X';
	              break;
	          }
	
	          var newTranslate = 'translate' + axis + '(' + newPosition + 'px)';
	
	          styles.transform = styles.webkitTransform = newTranslate;
	        });
	      }
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        if (element.hasClass('md-fling')) {
	          runAnimation(element);
	          delayDone(done);
	        } else {
	          done();
	        }
	      },
	      removeClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      }
	    };
	  }
	
	  function MdFabSpeedDialScaleAnimation($timeout) {
	    function delayDone(done) { $timeout(done, cssAnimationDuration, false); }
	
	    var delay = 65;
	
	    function runAnimation(element) {
	      var el = element[0];
	      var ctrl = element.controller('mdFabSpeedDial');
	      var items = el.querySelectorAll('.md-fab-action-item');
	
	      // Grab our element which stores CSS variables
	      var variablesElement = el.querySelector('._md-css-variables');
	
	      // Setup JS variables based on our CSS variables
	      var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);
	
	      // Always reset the items to their natural position/state
	      angular.forEach(items, function(item, index) {
	        var styles = item.style,
	          offsetDelay = index * delay;
	
	        styles.opacity = ctrl.isOpen ? 1 : 0;
	        styles.transform = styles.webkitTransform = ctrl.isOpen ? 'scale(1)' : 'scale(0)';
	        styles.transitionDelay = (ctrl.isOpen ? offsetDelay : (items.length - offsetDelay)) + 'ms';
	
	        // Make the items closest to the trigger have the highest z-index
	        styles.zIndex = (items.length - index) + startZIndex;
	      });
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      },
	
	      removeClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      }
	    };
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabToolbar
	   */
	  angular
	    // Declare our module
	    .module('material.components.fabToolbar', [
	      'material.core',
	      'material.components.fabShared',
	      'material.components.fabActions'
	    ])
	
	    // Register our directive
	    .directive('mdFabToolbar', MdFabToolbarDirective)
	
	    // Register our custom animations
	    .animation('.md-fab-toolbar', MdFabToolbarAnimation)
	
	    // Register a service for the animation so that we can easily inject it into unit tests
	    .service('mdFabToolbarAnimation', MdFabToolbarAnimation);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabToolbar
	   * @module material.components.fabToolbar
	   *
	   * @restrict E
	   *
	   * @description
	   *
	   * The `<md-fab-toolbar>` directive is used to present a toolbar of elements (usually `<md-button>`s)
	   * for quick access to common actions when a floating action button is activated (via click or
	   * keyboard navigation).
	   *
	   * You may also easily position the trigger by applying one one of the following classes to the
	   * `<md-fab-toolbar>` element:
	   *  - `md-fab-top-left`
	   *  - `md-fab-top-right`
	   *  - `md-fab-bottom-left`
	   *  - `md-fab-bottom-right`
	   *
	   * These CSS classes use `position: absolute`, so you need to ensure that the container element
	   * also uses `position: absolute` or `position: relative` in order for them to work.
	   *
	   * @usage
	   *
	   * <hljs lang="html">
	   * <md-fab-toolbar md-direction='left'>
	   *   <md-fab-trigger>
	   *     <md-button aria-label="Add..."><md-icon md-svg-src="/img/icons/plus.svg"></md-icon></md-button>
	   *   </md-fab-trigger>
	   *
	   *   <md-toolbar>
	   *    <md-fab-actions>
	   *      <md-button aria-label="Add User">
	   *        <md-icon md-svg-src="/img/icons/user.svg"></md-icon>
	   *      </md-button>
	   *
	   *      <md-button aria-label="Add Group">
	   *        <md-icon md-svg-src="/img/icons/group.svg"></md-icon>
	   *      </md-button>
	   *    </md-fab-actions>
	   *   </md-toolbar>
	   * </md-fab-toolbar>
	   * </hljs>
	   *
	   * @param {string} md-direction From which direction you would like the toolbar items to appear
	   * relative to the trigger element. Supports `left` and `right` directions.
	   * @param {expression=} md-open Programmatically control whether or not the toolbar is visible.
	   */
	  function MdFabToolbarDirective() {
	    return {
	      restrict: 'E',
	      transclude: true,
	      template: '<div class="md-fab-toolbar-wrapper">' +
	      '  <div class="md-fab-toolbar-content" ng-transclude></div>' +
	      '</div>',
	
	      scope: {
	        direction: '@?mdDirection',
	        isOpen: '=?mdOpen'
	      },
	
	      bindToController: true,
	      controller: 'MdFabController',
	      controllerAs: 'vm',
	
	      link: link
	    };
	
	    function link(scope, element, attributes) {
	      // Add the base class for animations
	      element.addClass('md-fab-toolbar');
	
	      // Prepend the background element to the trigger's button
	      element.find('md-fab-trigger').find('button')
	        .prepend('<div class="md-fab-toolbar-background"></div>');
	    }
	  }
	
	  function MdFabToolbarAnimation() {
	
	    function runAnimation(element, className, done) {
	      // If no className was specified, don't do anything
	      if (!className) {
	        return;
	      }
	
	      var el = element[0];
	      var ctrl = element.controller('mdFabToolbar');
	
	      // Grab the relevant child elements
	      var backgroundElement = el.querySelector('.md-fab-toolbar-background');
	      var triggerElement = el.querySelector('md-fab-trigger button');
	      var toolbarElement = el.querySelector('md-toolbar');
	      var iconElement = el.querySelector('md-fab-trigger button md-icon');
	      var actions = element.find('md-fab-actions').children();
	
	      // If we have both elements, use them to position the new background
	      if (triggerElement && backgroundElement) {
	        // Get our variables
	        var color = window.getComputedStyle(triggerElement).getPropertyValue('background-color');
	        var width = el.offsetWidth;
	        var height = el.offsetHeight;
	
	        // Make it twice as big as it should be since we scale from the center
	        var scale = 2 * (width / triggerElement.offsetWidth);
	
	        // Set some basic styles no matter what animation we're doing
	        backgroundElement.style.backgroundColor = color;
	        backgroundElement.style.borderRadius = width + 'px';
	
	        // If we're open
	        if (ctrl.isOpen) {
	          // Turn on toolbar pointer events when closed
	          toolbarElement.style.pointerEvents = 'inherit';
	
	          backgroundElement.style.width = triggerElement.offsetWidth + 'px';
	          backgroundElement.style.height = triggerElement.offsetHeight + 'px';
	          backgroundElement.style.transform = 'scale(' + scale + ')';
	
	          // Set the next close animation to have the proper delays
	          backgroundElement.style.transitionDelay = '0ms';
	          iconElement && (iconElement.style.transitionDelay = '.3s');
	
	          // Apply a transition delay to actions
	          angular.forEach(actions, function(action, index) {
	            action.style.transitionDelay = (actions.length - index) * 25 + 'ms';
	          });
	        } else {
	          // Turn off toolbar pointer events when closed
	          toolbarElement.style.pointerEvents = 'none';
	
	          // Scale it back down to the trigger's size
	          backgroundElement.style.transform = 'scale(1)';
	
	          // Reset the position
	          backgroundElement.style.top = '0';
	
	          if (element.hasClass('md-right')) {
	            backgroundElement.style.left = '0';
	            backgroundElement.style.right = null;
	          }
	
	          if (element.hasClass('md-left')) {
	            backgroundElement.style.right = '0';
	            backgroundElement.style.left = null;
	          }
	
	          // Set the next open animation to have the proper delays
	          backgroundElement.style.transitionDelay = '200ms';
	          iconElement && (iconElement.style.transitionDelay = '0ms');
	
	          // Apply a transition delay to actions
	          angular.forEach(actions, function(action, index) {
	            action.style.transitionDelay = 200 + (index * 25) + 'ms';
	          });
	        }
	      }
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        runAnimation(element, className, done);
	        done();
	      },
	
	      removeClass: function(element, className, done) {
	        runAnimation(element, className, done);
	        done();
	      }
	    };
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.gridList
	 */
	GridListController.$inject = ["$mdUtil"];
	GridLayoutFactory.$inject = ["$mdUtil"];
	GridListDirective.$inject = ["$interpolate", "$mdConstant", "$mdGridLayout", "$mdMedia"];
	GridTileDirective.$inject = ["$mdMedia"];
	angular.module('material.components.gridList', ['material.core'])
	       .directive('mdGridList', GridListDirective)
	       .directive('mdGridTile', GridTileDirective)
	       .directive('mdGridTileFooter', GridTileCaptionDirective)
	       .directive('mdGridTileHeader', GridTileCaptionDirective)
	       .factory('$mdGridLayout', GridLayoutFactory);
	
	/**
	 * @ngdoc directive
	 * @name mdGridList
	 * @module material.components.gridList
	 * @restrict E
	 * @description
	 * Grid lists are an alternative to standard list views. Grid lists are distinct
	 * from grids used for layouts and other visual presentations.
	 *
	 * A grid list is best suited to presenting a homogenous data type, typically
	 * images, and is optimized for visual comprehension and differentiating between
	 * like data types.
	 *
	 * A grid list is a continuous element consisting of tessellated, regular
	 * subdivisions called cells that contain tiles (`md-grid-tile`).
	 *
	 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7OVlEaXZ5YmU1Xzg/components_grids_usage2.png"
	 *    style="width: 300px; height: auto; margin-right: 16px;" alt="Concept of grid explained visually">
	 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7VGhsOE5idWlJWXM/components_grids_usage3.png"
	 *    style="width: 300px; height: auto;" alt="Grid concepts legend">
	 *
	 * Cells are arrayed vertically and horizontally within the grid.
	 *
	 * Tiles hold content and can span one or more cells vertically or horizontally.
	 *
	 * ### Responsive Attributes
	 *
	 * The `md-grid-list` directive supports "responsive" attributes, which allow
	 * different `md-cols`, `md-gutter` and `md-row-height` values depending on the
	 * currently matching media query.
	 *
	 * In order to set a responsive attribute, first define the fallback value with
	 * the standard attribute name, then add additional attributes with the
	 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
	 * (ie. `md-cols-lg="8"`)
	 *
	 * @param {number} md-cols Number of columns in the grid.
	 * @param {string} md-row-height One of
	 * <ul>
	 *   <li>CSS length - Fixed height rows (eg. `8px` or `1rem`)</li>
	 *   <li>`{width}:{height}` - Ratio of width to height (eg.
	 *   `md-row-height="16:9"`)</li>
	 *   <li>`"fit"` - Height will be determined by subdividing the available
	 *   height by the number of rows</li>
	 * </ul>
	 * @param {string=} md-gutter The amount of space between tiles in CSS units
	 *     (default 1px)
	 * @param {expression=} md-on-layout Expression to evaluate after layout. Event
	 *     object is available as `$event`, and contains performance information.
	 *
	 * @usage
	 * Basic:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="5" md-gutter="1em" md-row-height="4:3">
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Fixed-height rows:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="4" md-row-height="200px" ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Fit rows:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="4" md-row-height="fit" style="height: 400px;" ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Using responsive attributes:
	 * <hljs lang="html">
	 * <md-grid-list
	 *     md-cols-sm="2"
	 *     md-cols-md="4"
	 *     md-cols-lg="8"
	 *     md-cols-gt-lg="12"
	 *     ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 */
	function GridListDirective($interpolate, $mdConstant, $mdGridLayout, $mdMedia) {
	  return {
	    restrict: 'E',
	    controller: GridListController,
	    scope: {
	      mdOnLayout: '&'
	    },
	    link: postLink
	  };
	
	  function postLink(scope, element, attrs, ctrl) {
	    element.addClass('_md');     // private md component indicator for styling
	
	    // Apply semantics
	    element.attr('role', 'list');
	
	    // Provide the controller with a way to trigger layouts.
	    ctrl.layoutDelegate = layoutDelegate;
	
	    var invalidateLayout = angular.bind(ctrl, ctrl.invalidateLayout),
	        unwatchAttrs = watchMedia();
	      scope.$on('$destroy', unwatchMedia);
	
	    /**
	     * Watches for changes in media, invalidating layout as necessary.
	     */
	    function watchMedia() {
	      for (var mediaName in $mdConstant.MEDIA) {
	        $mdMedia(mediaName); // initialize
	        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
	            .addListener(invalidateLayout);
	      }
	      return $mdMedia.watchResponsiveAttributes(
	          ['md-cols', 'md-row-height', 'md-gutter'], attrs, layoutIfMediaMatch);
	    }
	
	    function unwatchMedia() {
	      ctrl.layoutDelegate = angular.noop;
	
	      unwatchAttrs();
	      for (var mediaName in $mdConstant.MEDIA) {
	        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
	            .removeListener(invalidateLayout);
	      }
	    }
	
	    /**
	     * Performs grid layout if the provided mediaName matches the currently
	     * active media type.
	     */
	    function layoutIfMediaMatch(mediaName) {
	      if (mediaName == null) {
	        // TODO(shyndman): It would be nice to only layout if we have
	        // instances of attributes using this media type
	        ctrl.invalidateLayout();
	      } else if ($mdMedia(mediaName)) {
	        ctrl.invalidateLayout();
	      }
	    }
	
	    var lastLayoutProps;
	
	    /**
	     * Invokes the layout engine, and uses its results to lay out our
	     * tile elements.
	     *
	     * @param {boolean} tilesInvalidated Whether tiles have been
	     *    added/removed/moved since the last layout. This is to avoid situations
	     *    where tiles are replaced with properties identical to their removed
	     *    counterparts.
	     */
	    function layoutDelegate(tilesInvalidated) {
	      var tiles = getTileElements();
	      var props = {
	        tileSpans: getTileSpans(tiles),
	        colCount: getColumnCount(),
	        rowMode: getRowMode(),
	        rowHeight: getRowHeight(),
	        gutter: getGutter()
	      };
	
	      if (!tilesInvalidated && angular.equals(props, lastLayoutProps)) {
	        return;
	      }
	
	      var performance =
	        $mdGridLayout(props.colCount, props.tileSpans, tiles)
	          .map(function(tilePositions, rowCount) {
	            return {
	              grid: {
	                element: element,
	                style: getGridStyle(props.colCount, rowCount,
	                    props.gutter, props.rowMode, props.rowHeight)
	              },
	              tiles: tilePositions.map(function(ps, i) {
	                return {
	                  element: angular.element(tiles[i]),
	                  style: getTileStyle(ps.position, ps.spans,
	                      props.colCount, rowCount,
	                      props.gutter, props.rowMode, props.rowHeight)
	                };
	              })
	            };
	          })
	          .reflow()
	          .performance();
	
	      // Report layout
	      scope.mdOnLayout({
	        $event: {
	          performance: performance
	        }
	      });
	
	      lastLayoutProps = props;
	    }
	
	    // Use $interpolate to do some simple string interpolation as a convenience.
	
	    var startSymbol = $interpolate.startSymbol();
	    var endSymbol = $interpolate.endSymbol();
	
	    // Returns an expression wrapped in the interpolator's start and end symbols.
	    function expr(exprStr) {
	      return startSymbol + exprStr + endSymbol;
	    }
	
	    // The amount of space a single 1x1 tile would take up (either width or height), used as
	    // a basis for other calculations. This consists of taking the base size percent (as would be
	    // if evenly dividing the size between cells), and then subtracting the size of one gutter.
	    // However, since there are no gutters on the edges, each tile only uses a fration
	    // (gutterShare = numGutters / numCells) of the gutter size. (Imagine having one gutter per
	    // tile, and then breaking up the extra gutter on the edge evenly among the cells).
	    var UNIT = $interpolate(expr('share') + '% - (' + expr('gutter') + ' * ' + expr('gutterShare') + ')');
	
	    // The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
	    // The position comes the size of a 1x1 tile plus gutter for each previous tile in the
	    // row/column (offset).
	    var POSITION  = $interpolate('calc((' + expr('unit') + ' + ' + expr('gutter') + ') * ' + expr('offset') + ')');
	
	    // The actual size of a tile, e.g., width or height, taking rowSpan or colSpan into account.
	    // This is computed by multiplying the base unit by the rowSpan/colSpan, and then adding back
	    // in the space that the gutter would normally have used (which was already accounted for in
	    // the base unit calculation).
	    var DIMENSION = $interpolate('calc((' + expr('unit') + ') * ' + expr('span') + ' + (' + expr('span') + ' - 1) * ' + expr('gutter') + ')');
	
	    /**
	     * Gets the styles applied to a tile element described by the given parameters.
	     * @param {{row: number, col: number}} position The row and column indices of the tile.
	     * @param {{row: number, col: number}} spans The rowSpan and colSpan of the tile.
	     * @param {number} colCount The number of columns.
	     * @param {number} rowCount The number of rows.
	     * @param {string} gutter The amount of space between tiles. This will be something like
	     *     '5px' or '2em'.
	     * @param {string} rowMode The row height mode. Can be one of:
	     *     'fixed': all rows have a fixed size, given by rowHeight,
	     *     'ratio': row height defined as a ratio to width, or
	     *     'fit': fit to the grid-list element height, divinding evenly among rows.
	     * @param {string|number} rowHeight The height of a row. This is only used for 'fixed' mode and
	     *     for 'ratio' mode. For 'ratio' mode, this is the *ratio* of width-to-height (e.g., 0.75).
	     * @returns {Object} Map of CSS properties to be applied to the style element. Will define
	     *     values for top, left, width, height, marginTop, and paddingTop.
	     */
	    function getTileStyle(position, spans, colCount, rowCount, gutter, rowMode, rowHeight) {
	      // TODO(shyndman): There are style caching opportunities here.
	
	      // Percent of the available horizontal space that one column takes up.
	      var hShare = (1 / colCount) * 100;
	
	      // Fraction of the gutter size that each column takes up.
	      var hGutterShare = (colCount - 1) / colCount;
	
	      // Base horizontal size of a column.
	      var hUnit = UNIT({share: hShare, gutterShare: hGutterShare, gutter: gutter});
	
	      // The width and horizontal position of each tile is always calculated the same way, but the
	      // height and vertical position depends on the rowMode.
	      var ltr = document.dir != 'rtl' && document.body.dir != 'rtl';
	      var style = ltr ? {
	          left: POSITION({ unit: hUnit, offset: position.col, gutter: gutter }),
	          width: DIMENSION({ unit: hUnit, span: spans.col, gutter: gutter }),
	          // resets
	          paddingTop: '',
	          marginTop: '',
	          top: '',
	          height: ''
	        } : {
	        right: POSITION({ unit: hUnit, offset: position.col, gutter: gutter }),
	        width: DIMENSION({ unit: hUnit, span: spans.col, gutter: gutter }),
	        // resets
	        paddingTop: '',
	        marginTop: '',
	        top: '',
	        height: ''
	      };
	
	      switch (rowMode) {
	        case 'fixed':
	          // In fixed mode, simply use the given rowHeight.
	          style.top = POSITION({ unit: rowHeight, offset: position.row, gutter: gutter });
	          style.height = DIMENSION({ unit: rowHeight, span: spans.row, gutter: gutter });
	          break;
	
	        case 'ratio':
	          // Percent of the available vertical space that one row takes up. Here, rowHeight holds
	          // the ratio value. For example, if the width:height ratio is 4:3, rowHeight = 1.333.
	          var vShare = hShare / rowHeight;
	
	          // Base veritcal size of a row.
	          var vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });
	
	          // padidngTop and marginTop are used to maintain the given aspect ratio, as
	          // a percentage-based value for these properties is applied to the *width* of the
	          // containing block. See http://www.w3.org/TR/CSS2/box.html#margin-properties
	          style.paddingTop = DIMENSION({ unit: vUnit, span: spans.row, gutter: gutter});
	          style.marginTop = POSITION({ unit: vUnit, offset: position.row, gutter: gutter });
	          break;
	
	        case 'fit':
	          // Fraction of the gutter size that each column takes up.
	          var vGutterShare = (rowCount - 1) / rowCount;
	
	          // Percent of the available vertical space that one row takes up.
	          vShare = (1 / rowCount) * 100;
	
	          // Base vertical size of a row.
	          vUnit = UNIT({share: vShare, gutterShare: vGutterShare, gutter: gutter});
	
	          style.top = POSITION({unit: vUnit, offset: position.row, gutter: gutter});
	          style.height = DIMENSION({unit: vUnit, span: spans.row, gutter: gutter});
	          break;
	      }
	
	      return style;
	    }
	
	    function getGridStyle(colCount, rowCount, gutter, rowMode, rowHeight) {
	      var style = {};
	
	      switch(rowMode) {
	        case 'fixed':
	          style.height = DIMENSION({ unit: rowHeight, span: rowCount, gutter: gutter });
	          style.paddingBottom = '';
	          break;
	
	        case 'ratio':
	          // rowHeight is width / height
	          var hGutterShare = colCount === 1 ? 0 : (colCount - 1) / colCount,
	              hShare = (1 / colCount) * 100,
	              vShare = hShare * (1 / rowHeight),
	              vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });
	
	          style.height = '';
	          style.paddingBottom = DIMENSION({ unit: vUnit, span: rowCount, gutter: gutter});
	          break;
	
	        case 'fit':
	          // noop, as the height is user set
	          break;
	      }
	
	      return style;
	    }
	
	    function getTileElements() {
	      return [].filter.call(element.children(), function(ele) {
	        return ele.tagName == 'MD-GRID-TILE' && !ele.$$mdDestroyed;
	      });
	    }
	
	    /**
	     * Gets an array of objects containing the rowspan and colspan for each tile.
	     * @returns {Array<{row: number, col: number}>}
	     */
	    function getTileSpans(tileElements) {
	      return [].map.call(tileElements, function(ele) {
	        var ctrl = angular.element(ele).controller('mdGridTile');
	        return {
	          row: parseInt(
	              $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-rowspan'), 10) || 1,
	          col: parseInt(
	              $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-colspan'), 10) || 1
	        };
	      });
	    }
	
	    function getColumnCount() {
	      var colCount = parseInt($mdMedia.getResponsiveAttribute(attrs, 'md-cols'), 10);
	      if (isNaN(colCount)) {
	        throw 'md-grid-list: md-cols attribute was not found, or contained a non-numeric value';
	      }
	      return colCount;
	    }
	
	    function getGutter() {
	      return applyDefaultUnit($mdMedia.getResponsiveAttribute(attrs, 'md-gutter') || 1);
	    }
	
	    function getRowHeight() {
	      var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
	      if (!rowHeight) {
	        throw 'md-grid-list: md-row-height attribute was not found';
	      }
	
	      switch (getRowMode()) {
	        case 'fixed':
	          return applyDefaultUnit(rowHeight);
	        case 'ratio':
	          var whRatio = rowHeight.split(':');
	          return parseFloat(whRatio[0]) / parseFloat(whRatio[1]);
	        case 'fit':
	          return 0; // N/A
	      }
	    }
	
	    function getRowMode() {
	      var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
	      if (!rowHeight) {
	        throw 'md-grid-list: md-row-height attribute was not found';
	      }
	
	      if (rowHeight == 'fit') {
	        return 'fit';
	      } else if (rowHeight.indexOf(':') !== -1) {
	        return 'ratio';
	      } else {
	        return 'fixed';
	      }
	    }
	
	    function applyDefaultUnit(val) {
	      return /\D$/.test(val) ? val : val + 'px';
	    }
	  }
	}
	
	/* @ngInject */
	function GridListController($mdUtil) {
	  this.layoutInvalidated = false;
	  this.tilesInvalidated = false;
	  this.$timeout_ = $mdUtil.nextTick;
	  this.layoutDelegate = angular.noop;
	}
	
	GridListController.prototype = {
	  invalidateTiles: function() {
	    this.tilesInvalidated = true;
	    this.invalidateLayout();
	  },
	
	  invalidateLayout: function() {
	    if (this.layoutInvalidated) {
	      return;
	    }
	    this.layoutInvalidated = true;
	    this.$timeout_(angular.bind(this, this.layout));
	  },
	
	  layout: function() {
	    try {
	      this.layoutDelegate(this.tilesInvalidated);
	    } finally {
	      this.layoutInvalidated = false;
	      this.tilesInvalidated = false;
	    }
	  }
	};
	
	
	/* @ngInject */
	function GridLayoutFactory($mdUtil) {
	  var defaultAnimator = GridTileAnimator;
	
	  /**
	   * Set the reflow animator callback
	   */
	  GridLayout.animateWith = function(customAnimator) {
	    defaultAnimator = !angular.isFunction(customAnimator) ? GridTileAnimator : customAnimator;
	  };
	
	  return GridLayout;
	
	  /**
	   * Publish layout function
	   */
	  function GridLayout(colCount, tileSpans) {
	      var self, layoutInfo, gridStyles, layoutTime, mapTime, reflowTime;
	
	      layoutTime = $mdUtil.time(function() {
	        layoutInfo = calculateGridFor(colCount, tileSpans);
	      });
	
	      return self = {
	
	        /**
	         * An array of objects describing each tile's position in the grid.
	         */
	        layoutInfo: function() {
	          return layoutInfo;
	        },
	
	        /**
	         * Maps grid positioning to an element and a set of styles using the
	         * provided updateFn.
	         */
	        map: function(updateFn) {
	          mapTime = $mdUtil.time(function() {
	            var info = self.layoutInfo();
	            gridStyles = updateFn(info.positioning, info.rowCount);
	          });
	          return self;
	        },
	
	        /**
	         * Default animator simply sets the element.css( <styles> ). An alternate
	         * animator can be provided as an argument. The function has the following
	         * signature:
	         *
	         *    function({grid: {element: JQLite, style: Object}, tiles: Array<{element: JQLite, style: Object}>)
	         */
	        reflow: function(animatorFn) {
	          reflowTime = $mdUtil.time(function() {
	            var animator = animatorFn || defaultAnimator;
	            animator(gridStyles.grid, gridStyles.tiles);
	          });
	          return self;
	        },
	
	        /**
	         * Timing for the most recent layout run.
	         */
	        performance: function() {
	          return {
	            tileCount: tileSpans.length,
	            layoutTime: layoutTime,
	            mapTime: mapTime,
	            reflowTime: reflowTime,
	            totalTime: layoutTime + mapTime + reflowTime
	          };
	        }
	      };
	    }
	
	  /**
	   * Default Gridlist animator simple sets the css for each element;
	   * NOTE: any transitions effects must be manually set in the CSS.
	   * e.g.
	   *
	   *  md-grid-tile {
	   *    transition: all 700ms ease-out 50ms;
	   *  }
	   *
	   */
	  function GridTileAnimator(grid, tiles) {
	    grid.element.css(grid.style);
	    tiles.forEach(function(t) {
	      t.element.css(t.style);
	    });
	  }
	
	  /**
	   * Calculates the positions of tiles.
	   *
	   * The algorithm works as follows:
	   *    An Array<Number> with length colCount (spaceTracker) keeps track of
	   *    available tiling positions, where elements of value 0 represents an
	   *    empty position. Space for a tile is reserved by finding a sequence of
	   *    0s with length <= than the tile's colspan. When such a space has been
	   *    found, the occupied tile positions are incremented by the tile's
	   *    rowspan value, as these positions have become unavailable for that
	   *    many rows.
	   *
	   *    If the end of a row has been reached without finding space for the
	   *    tile, spaceTracker's elements are each decremented by 1 to a minimum
	   *    of 0. Rows are searched in this fashion until space is found.
	   */
	  function calculateGridFor(colCount, tileSpans) {
	    var curCol = 0,
	        curRow = 0,
	        spaceTracker = newSpaceTracker();
	
	    return {
	      positioning: tileSpans.map(function(spans, i) {
	        return {
	          spans: spans,
	          position: reserveSpace(spans, i)
	        };
	      }),
	      rowCount: curRow + Math.max.apply(Math, spaceTracker)
	    };
	
	    function reserveSpace(spans, i) {
	      if (spans.col > colCount) {
	        throw 'md-grid-list: Tile at position ' + i + ' has a colspan ' +
	            '(' + spans.col + ') that exceeds the column count ' +
	            '(' + colCount + ')';
	      }
	
	      var start = 0,
	          end = 0;
	
	      // TODO(shyndman): This loop isn't strictly necessary if you can
	      // determine the minimum number of rows before a space opens up. To do
	      // this, recognize that you've iterated across an entire row looking for
	      // space, and if so fast-forward by the minimum rowSpan count. Repeat
	      // until the required space opens up.
	      while (end - start < spans.col) {
	        if (curCol >= colCount) {
	          nextRow();
	          continue;
	        }
	
	        start = spaceTracker.indexOf(0, curCol);
	        if (start === -1 || (end = findEnd(start + 1)) === -1) {
	          start = end = 0;
	          nextRow();
	          continue;
	        }
	
	        curCol = end + 1;
	      }
	
	      adjustRow(start, spans.col, spans.row);
	      curCol = start + spans.col;
	
	      return {
	        col: start,
	        row: curRow
	      };
	    }
	
	    function nextRow() {
	      curCol = 0;
	      curRow++;
	      adjustRow(0, colCount, -1); // Decrement row spans by one
	    }
	
	    function adjustRow(from, cols, by) {
	      for (var i = from; i < from + cols; i++) {
	        spaceTracker[i] = Math.max(spaceTracker[i] + by, 0);
	      }
	    }
	
	    function findEnd(start) {
	      var i;
	      for (i = start; i < spaceTracker.length; i++) {
	        if (spaceTracker[i] !== 0) {
	          return i;
	        }
	      }
	
	      if (i === spaceTracker.length) {
	        return i;
	      }
	    }
	
	    function newSpaceTracker() {
	      var tracker = [];
	      for (var i = 0; i < colCount; i++) {
	        tracker.push(0);
	      }
	      return tracker;
	    }
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name mdGridTile
	 * @module material.components.gridList
	 * @restrict E
	 * @description
	 * Tiles contain the content of an `md-grid-list`. They span one or more grid
	 * cells vertically or horizontally, and use `md-grid-tile-{footer,header}` to
	 * display secondary content.
	 *
	 * ### Responsive Attributes
	 *
	 * The `md-grid-tile` directive supports "responsive" attributes, which allow
	 * different `md-rowspan` and `md-colspan` values depending on the currently
	 * matching media query.
	 *
	 * In order to set a responsive attribute, first define the fallback value with
	 * the standard attribute name, then add additional attributes with the
	 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
	 * (ie. `md-colspan-sm="4"`)
	 *
	 * @param {number=} md-colspan The number of columns to span (default 1). Cannot
	 *    exceed the number of columns in the grid. Supports interpolation.
	 * @param {number=} md-rowspan The number of rows to span (default 1). Supports
	 *     interpolation.
	 *
	 * @usage
	 * With header:
	 * <hljs lang="html">
	 * <md-grid-tile>
	 *   <md-grid-tile-header>
	 *     <h3>This is a header</h3>
	 *   </md-grid-tile-header>
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * With footer:
	 * <hljs lang="html">
	 * <md-grid-tile>
	 *   <md-grid-tile-footer>
	 *     <h3>This is a footer</h3>
	 *   </md-grid-tile-footer>
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * Spanning multiple rows/columns:
	 * <hljs lang="html">
	 * <md-grid-tile md-colspan="2" md-rowspan="3">
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * Responsive attributes:
	 * <hljs lang="html">
	 * <md-grid-tile md-colspan="1" md-colspan-sm="3" md-colspan-md="5">
	 * </md-grid-tile>
	 * </hljs>
	 */
	function GridTileDirective($mdMedia) {
	  return {
	    restrict: 'E',
	    require: '^mdGridList',
	    template: '<figure ng-transclude></figure>',
	    transclude: true,
	    scope: {},
	    // Simple controller that exposes attributes to the grid directive
	    controller: ["$attrs", function($attrs) {
	      this.$attrs = $attrs;
	    }],
	    link: postLink
	  };
	
	  function postLink(scope, element, attrs, gridCtrl) {
	    // Apply semantics
	    element.attr('role', 'listitem');
	
	    // If our colspan or rowspan changes, trigger a layout
	    var unwatchAttrs = $mdMedia.watchResponsiveAttributes(['md-colspan', 'md-rowspan'],
	        attrs, angular.bind(gridCtrl, gridCtrl.invalidateLayout));
	
	    // Tile registration/deregistration
	    gridCtrl.invalidateTiles();
	    scope.$on('$destroy', function() {
	      // Mark the tile as destroyed so it is no longer considered in layout,
	      // even if the DOM element sticks around (like during a leave animation)
	      element[0].$$mdDestroyed = true;
	      unwatchAttrs();
	      gridCtrl.invalidateLayout();
	    });
	
	    if (angular.isDefined(scope.$parent.$index)) {
	      scope.$watch(function() { return scope.$parent.$index; },
	        function indexChanged(newIdx, oldIdx) {
	          if (newIdx === oldIdx) {
	            return;
	          }
	          gridCtrl.invalidateTiles();
	        });
	    }
	  }
	}
	
	
	function GridTileCaptionDirective() {
	  return {
	    template: '<figcaption ng-transclude></figcaption>',
	    transclude: true
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.icon
	 * @description
	 * Icon
	 */
	angular.module('material.components.icon', ['material.core']);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.input
	 */
	mdInputContainerDirective.$inject = ["$mdTheming", "$parse"];
	inputTextareaDirective.$inject = ["$mdUtil", "$window", "$mdAria", "$timeout", "$mdGesture"];
	mdMaxlengthDirective.$inject = ["$animate", "$mdUtil"];
	placeholderDirective.$inject = ["$compile"];
	ngMessageDirective.$inject = ["$mdUtil"];
	mdSelectOnFocusDirective.$inject = ["$document", "$timeout"];
	mdInputInvalidMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
	ngMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
	ngMessageAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
	var inputModule = angular.module('material.components.input', [
	    'material.core'
	  ])
	  .directive('mdInputContainer', mdInputContainerDirective)
	  .directive('label', labelDirective)
	  .directive('input', inputTextareaDirective)
	  .directive('textarea', inputTextareaDirective)
	  .directive('mdMaxlength', mdMaxlengthDirective)
	  .directive('placeholder', placeholderDirective)
	  .directive('ngMessages', ngMessagesDirective)
	  .directive('ngMessage', ngMessageDirective)
	  .directive('ngMessageExp', ngMessageDirective)
	  .directive('mdSelectOnFocus', mdSelectOnFocusDirective)
	
	  .animation('.md-input-invalid', mdInputInvalidMessagesAnimation)
	  .animation('.md-input-messages-animation', ngMessagesAnimation)
	  .animation('.md-input-message-animation', ngMessageAnimation);
	
	// If we are running inside of tests; expose some extra services so that we can test them
	if (window._mdMocksIncluded) {
	  inputModule.service('$$mdInput', function() {
	    return {
	      // special accessor to internals... useful for testing
	      messages: {
	        show        : showInputMessages,
	        hide        : hideInputMessages,
	        getElement  : getMessagesElement
	      }
	    };
	  })
	
	  // Register a service for each animation so that we can easily inject them into unit tests
	  .service('mdInputInvalidAnimation', mdInputInvalidMessagesAnimation)
	  .service('mdInputMessagesAnimation', ngMessagesAnimation)
	  .service('mdInputMessageAnimation', ngMessageAnimation);
	}
	
	/**
	 * @ngdoc directive
	 * @name mdInputContainer
	 * @module material.components.input
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-input-container>` is the parent of any input or textarea element.
	 *
	 * Input and textarea elements will not behave properly unless the md-input-container
	 * parent is provided.
	 *
	 * A single `<md-input-container>` should contain only one `<input>` element, otherwise it will throw an error.
	 *
	 * <b>Exception:</b> Hidden inputs (`<input type="hidden" />`) are ignored and will not throw an error, so
	 * you may combine these with other inputs.
	 *
	 * <b>Note:</b> When using `ngMessages` with your input element, make sure the message and container elements
	 * are *block* elements, otherwise animations applied to the messages will not look as intended. Either use a `div` and
	 * apply the `ng-message` and `ng-messages` classes respectively, or use the `md-block` class on your element.
	 *
	 * @param md-is-error {expression=} When the given expression evaluates to true, the input container
	 *   will go into error state. Defaults to erroring if the input has been touched and is invalid.
	 * @param md-no-float {boolean=} When present, `placeholder` attributes on the input will not be converted to floating
	 *   labels.
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Username</label>
	 *   <input type="text" ng-model="user.name">
	 * </md-input-container>
	 *
	 * <md-input-container>
	 *   <label>Description</label>
	 *   <textarea ng-model="user.description"></textarea>
	 * </md-input-container>
	 *
	 * </hljs>
	 *
	 * <h3>When disabling floating labels</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container md-no-float>
	 *   <input type="text" placeholder="Non-Floating Label">
	 * </md-input-container>
	 *
	 * </hljs>
	 */
	function mdInputContainerDirective($mdTheming, $parse) {
	
	  ContainerCtrl.$inject = ["$scope", "$element", "$attrs", "$animate"];
	  var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT', 'MD-SELECT'];
	
	  var LEFT_SELECTORS = INPUT_TAGS.reduce(function(selectors, isel) {
	    return selectors.concat(['md-icon ~ ' + isel, '.md-icon ~ ' + isel]);
	  }, []).join(",");
	
	  var RIGHT_SELECTORS = INPUT_TAGS.reduce(function(selectors, isel) {
	    return selectors.concat([isel + ' ~ md-icon', isel + ' ~ .md-icon']);
	  }, []).join(",");
	
	  return {
	    restrict: 'E',
	    compile: compile,
	    controller: ContainerCtrl
	  };
	
	  function compile(tElement) {
	    // Check for both a left & right icon
	    var leftIcon = tElement[0].querySelector(LEFT_SELECTORS);
	    var rightIcon = tElement[0].querySelector(RIGHT_SELECTORS);
	
	    if (leftIcon) { tElement.addClass('md-icon-left'); }
	    if (rightIcon) { tElement.addClass('md-icon-right'); }
	
	    return function postLink(scope, element) {
	      $mdTheming(element);
	    };
	  }
	
	  function ContainerCtrl($scope, $element, $attrs, $animate) {
	    var self = this;
	
	    self.isErrorGetter = $attrs.mdIsError && $parse($attrs.mdIsError);
	
	    self.delegateClick = function() {
	      self.input.focus();
	    };
	    self.element = $element;
	    self.setFocused = function(isFocused) {
	      $element.toggleClass('md-input-focused', !!isFocused);
	    };
	    self.setHasValue = function(hasValue) {
	      $element.toggleClass('md-input-has-value', !!hasValue);
	    };
	    self.setHasPlaceholder = function(hasPlaceholder) {
	      $element.toggleClass('md-input-has-placeholder', !!hasPlaceholder);
	    };
	    self.setInvalid = function(isInvalid) {
	      if (isInvalid) {
	        $animate.addClass($element, 'md-input-invalid');
	      } else {
	        $animate.removeClass($element, 'md-input-invalid');
	      }
	    };
	    $scope.$watch(function() {
	      return self.label && self.input;
	    }, function(hasLabelAndInput) {
	      if (hasLabelAndInput && !self.label.attr('for')) {
	        self.label.attr('for', self.input.attr('id'));
	      }
	    });
	  }
	}
	
	function labelDirective() {
	  return {
	    restrict: 'E',
	    require: '^?mdInputContainer',
	    link: function(scope, element, attr, containerCtrl) {
	      if (!containerCtrl || attr.mdNoFloat || element.hasClass('md-container-ignore')) return;
	
	      containerCtrl.label = element;
	      scope.$on('$destroy', function() {
	        containerCtrl.label = null;
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name mdInput
	 * @restrict E
	 * @module material.components.input
	 *
	 * @description
	 * You can use any `<input>` or `<textarea>` element as a child of an `<md-input-container>`. This
	 * allows you to build complex forms for data entry.
	 *
	 * When the input is required and uses a floating label, then the label will automatically contain
	 * an asterisk (`*`).<br/>
	 * This behavior can be disabled by using the `md-no-asterisk` attribute.
	 *
	 * @param {number=} md-maxlength The maximum number of characters allowed in this input. If this is
	 *   specified, a character counter will be shown underneath the input.<br/><br/>
	 *   The purpose of **`md-maxlength`** is exactly to show the max length counter text. If you don't
	 *   want the counter text and only need "plain" validation, you can use the "simple" `ng-maxlength`
	 *   or maxlength attributes.<br/><br/>
	 * @param {boolean=} ng-trim If set to false, the input text will be not trimmed automatically.
	 *     Defaults to true.
	 * @param {string=} aria-label Aria-label is required when no label is present.  A warning message
	 *   will be logged in the console if not present.
	 * @param {string=} placeholder An alternative approach to using aria-label when the label is not
	 *   PRESENT. The placeholder text is copied to the aria-label attribute.
	 * @param md-no-autogrow {boolean=} When present, textareas will not grow automatically.
	 * @param md-no-asterisk {boolean=} When present, an asterisk will not be appended to the inputs floating label
	 * @param md-no-resize {boolean=} Disables the textarea resize handle.
	 * @param {number=} max-rows The maximum amount of rows for a textarea.
	 * @param md-detect-hidden {boolean=} When present, textareas will be sized properly when they are
	 *   revealed after being hidden. This is off by default for performance reasons because it
	 *   guarantees a reflow every digest cycle.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-input-container>
	 *   <label>Color</label>
	 *   <input type="text" ng-model="color" required md-maxlength="10">
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>With Errors</h3>
	 *
	 * `md-input-container` also supports errors using the standard `ng-messages` directives and
	 * animates the messages when they become visible using from the `ngEnter`/`ngLeave` events or
	 * the `ngShow`/`ngHide` events.
	 *
	 * By default, the messages will be hidden until the input is in an error state. This is based off
	 * of the `md-is-error` expression of the `md-input-container`. This gives the user a chance to
	 * fill out the form before the errors become visible.
	 *
	 * <hljs lang="html">
	 * <form name="colorForm">
	 *   <md-input-container>
	 *     <label>Favorite Color</label>
	 *     <input name="favoriteColor" ng-model="favoriteColor" required>
	 *     <div ng-messages="colorForm.favoriteColor.$error">
	 *       <div ng-message="required">This is required!</div>
	 *     </div>
	 *   </md-input-container>
	 * </form>
	 * </hljs>
	 *
	 * We automatically disable this auto-hiding functionality if you provide any of the following
	 * visibility directives on the `ng-messages` container:
	 *
	 *  - `ng-if`
	 *  - `ng-show`/`ng-hide`
	 *  - `ng-switch-when`/`ng-switch-default`
	 *
	 * You can also disable this functionality manually by adding the `md-auto-hide="false"` expression
	 * to the `ng-messages` container. This may be helpful if you always want to see the error messages
	 * or if you are building your own visibilty directive.
	 *
	 * _<b>Note:</b> The `md-auto-hide` attribute is a static string that is  only checked upon
	 * initialization of the `ng-messages` directive to see if it equals the string `false`._
	 *
	 * <hljs lang="html">
	 * <form name="userForm">
	 *   <md-input-container>
	 *     <label>Last Name</label>
	 *     <input name="lastName" ng-model="lastName" required md-maxlength="10" minlength="4">
	 *     <div ng-messages="userForm.lastName.$error" ng-show="userForm.lastName.$dirty">
	 *       <div ng-message="required">This is required!</div>
	 *       <div ng-message="md-maxlength">That's too long!</div>
	 *       <div ng-message="minlength">That's too short!</div>
	 *     </div>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <label>Biography</label>
	 *     <textarea name="bio" ng-model="biography" required md-maxlength="150"></textarea>
	 *     <div ng-messages="userForm.bio.$error" ng-show="userForm.bio.$dirty">
	 *       <div ng-message="required">This is required!</div>
	 *       <div ng-message="md-maxlength">That's too long!</div>
	 *     </div>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <input aria-label='title' ng-model='title'>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <input placeholder='title' ng-model='title'>
	 *   </md-input-container>
	 * </form>
	 * </hljs>
	 *
	 * <h3>Notes</h3>
	 *
	 * - Requires [ngMessages](https://docs.angularjs.org/api/ngMessages).
	 * - Behaves like the [AngularJS input directive](https://docs.angularjs.org/api/ng/directive/input).
	 *
	 * The `md-input` and `md-input-container` directives use very specific positioning to achieve the
	 * error animation effects. Therefore, it is *not* advised to use the Layout system inside of the
	 * `<md-input-container>` tags. Instead, use relative or absolute positioning.
	 *
	 *
	 * <h3>Textarea directive</h3>
	 * The `textarea` element within a `md-input-container` has the following specific behavior:
	 * - By default the `textarea` grows as the user types. This can be disabled via the `md-no-autogrow`
	 * attribute.
	 * - If a `textarea` has the `rows` attribute, it will treat the `rows` as the minimum height and will
	 * continue growing as the user types. For example a textarea with `rows="3"` will be 3 lines of text
	 * high initially. If no rows are specified, the directive defaults to 1.
	 * - The textarea's height gets set on initialization, as well as while the user is typing. In certain situations
	 * (e.g. while animating) the directive might have been initialized, before the element got it's final height. In
	 * those cases, you can trigger a resize manually by broadcasting a `md-resize-textarea` event on the scope.
	 * - If you want a `textarea` to stop growing at a certain point, you can specify the `max-rows` attribute.
	 * - The textarea's bottom border acts as a handle which users can drag, in order to resize the element vertically.
	 * Once the user has resized a `textarea`, the autogrowing functionality becomes disabled. If you don't want a
	 * `textarea` to be resizeable by the user, you can add the `md-no-resize` attribute.
	 */
	
	function inputTextareaDirective($mdUtil, $window, $mdAria, $timeout, $mdGesture) {
	  return {
	    restrict: 'E',
	    require: ['^?mdInputContainer', '?ngModel', '?^form'],
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	
	    var containerCtrl = ctrls[0];
	    var hasNgModel = !!ctrls[1];
	    var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
	    var parentForm = ctrls[2];
	    var isReadonly = angular.isDefined(attr.readonly);
	    var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
	    var tagName = element[0].tagName.toLowerCase();
	
	
	    if (!containerCtrl) return;
	    if (attr.type === 'hidden') {
	      element.attr('aria-hidden', 'true');
	      return;
	    } else if (containerCtrl.input) {
	      if (containerCtrl.input[0].contains(element[0])) {
	        return;
	      } else {
	        throw new Error("<md-input-container> can only have *one* <input>, <textarea> or <md-select> child element!");
	      }
	    }
	    containerCtrl.input = element;
	
	    setupAttributeWatchers();
	
	    // Add an error spacer div after our input to provide space for the char counter and any ng-messages
	    var errorsSpacer = angular.element('<div class="md-errors-spacer">');
	    element.after(errorsSpacer);
	
	    var placeholderText = angular.isString(attr.placeholder) ? attr.placeholder.trim() : '';
	    if (!containerCtrl.label && !placeholderText.length) {
	      $mdAria.expect(element, 'aria-label');
	    }
	
	    element.addClass('md-input');
	    if (!element.attr('id')) {
	      element.attr('id', 'input_' + $mdUtil.nextUid());
	    }
	
	    // This works around a Webkit issue where number inputs, placed in a flexbox, that have
	    // a `min` and `max` will collapse to about 1/3 of their proper width. Please check #7349
	    // for more info. Also note that we don't override the `step` if the user has specified it,
	    // in order to prevent some unexpected behaviour.
	    if (tagName === 'input' && attr.type === 'number' && attr.min && attr.max && !attr.step) {
	      element.attr('step', 'any');
	    } else if (tagName === 'textarea') {
	      setupTextarea();
	    }
	
	    // If the input doesn't have an ngModel, it may have a static value. For that case,
	    // we have to do one initial check to determine if the container should be in the
	    // "has a value" state.
	    if (!hasNgModel) {
	      inputCheckValue();
	    }
	
	    var isErrorGetter = containerCtrl.isErrorGetter || function() {
	      return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (parentForm && parentForm.$submitted));
	    };
	
	    scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	
	    // When the developer uses the ngValue directive for the input, we have to observe the attribute, because
	    // AngularJS's ngValue directive is just setting the `value` attribute.
	    if (attr.ngValue) {
	      attr.$observe('value', inputCheckValue);
	    }
	
	    ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
	    ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);
	
	    element.on('input', inputCheckValue);
	
	    if (!isReadonly) {
	      element
	        .on('focus', function(ev) {
	          $mdUtil.nextTick(function() {
	            containerCtrl.setFocused(true);
	          });
	        })
	        .on('blur', function(ev) {
	          $mdUtil.nextTick(function() {
	            containerCtrl.setFocused(false);
	            inputCheckValue();
	          });
	        });
	    }
	
	    scope.$on('$destroy', function() {
	      containerCtrl.setFocused(false);
	      containerCtrl.setHasValue(false);
	      containerCtrl.input = null;
	    });
	
	    /** Gets run through ngModel's pipeline and set the `has-value` class on the container. */
	    function ngModelPipelineCheckValue(arg) {
	      containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
	      return arg;
	    }
	
	    function setupAttributeWatchers() {
	      if (containerCtrl.label) {
	        attr.$observe('required', function (value) {
	          // We don't need to parse the required value, it's always a boolean because of angular's
	          // required directive.
	          containerCtrl.label.toggleClass('md-required', value && !mdNoAsterisk);
	        });
	      }
	    }
	
	    function inputCheckValue() {
	      // An input's value counts if its length > 0,
	      // or if the input's validity state says it has bad input (eg string in a number input)
	      containerCtrl.setHasValue(element.val().length > 0 || (element[0].validity || {}).badInput);
	    }
	
	    function setupTextarea() {
	      var isAutogrowing = !attr.hasOwnProperty('mdNoAutogrow');
	
	      attachResizeHandle();
	
	      if (!isAutogrowing) return;
	
	      // Can't check if height was or not explicity set,
	      // so rows attribute will take precedence if present
	      var minRows = attr.hasOwnProperty('rows') ? parseInt(attr.rows) : NaN;
	      var maxRows = attr.hasOwnProperty('maxRows') ? parseInt(attr.maxRows) : NaN;
	      var scopeResizeListener = scope.$on('md-resize-textarea', growTextarea);
	      var lineHeight = null;
	      var node = element[0];
	
	      // This timeout is necessary, because the browser needs a little bit
	      // of time to calculate the `clientHeight` and `scrollHeight`.
	      $timeout(function() {
	        $mdUtil.nextTick(growTextarea);
	      }, 10, false);
	
	      // We could leverage ngModel's $parsers here, however it
	      // isn't reliable, because AngularJS trims the input by default,
	      // which means that growTextarea won't fire when newlines and
	      // spaces are added.
	      element.on('input', growTextarea);
	
	      // We should still use the $formatters, because they fire when
	      // the value was changed from outside the textarea.
	      if (hasNgModel) {
	        ngModelCtrl.$formatters.push(formattersListener);
	      }
	
	      if (!minRows) {
	        element.attr('rows', 1);
	      }
	
	      angular.element($window).on('resize', growTextarea);
	      scope.$on('$destroy', disableAutogrow);
	
	      function growTextarea() {
	        // temporarily disables element's flex so its height 'runs free'
	        element
	          .attr('rows', 1)
	          .css('height', 'auto')
	          .addClass('md-no-flex');
	
	        var height = getHeight();
	
	        if (!lineHeight) {
	          // offsetHeight includes padding which can throw off our value
	          var originalPadding = element[0].style.padding || '';
	          lineHeight = element.css('padding', 0).prop('offsetHeight');
	          element[0].style.padding = originalPadding;
	        }
	
	        if (minRows && lineHeight) {
	          height = Math.max(height, lineHeight * minRows);
	        }
	
	        if (maxRows && lineHeight) {
	          var maxHeight = lineHeight * maxRows;
	
	          if (maxHeight < height) {
	            element.attr('md-no-autogrow', '');
	            height = maxHeight;
	          } else {
	            element.removeAttr('md-no-autogrow');
	          }
	        }
	
	        if (lineHeight) {
	          element.attr('rows', Math.round(height / lineHeight));
	        }
	
	        element
	          .css('height', height + 'px')
	          .removeClass('md-no-flex');
	      }
	
	      function getHeight() {
	        var offsetHeight = node.offsetHeight;
	        var line = node.scrollHeight - offsetHeight;
	        return offsetHeight + Math.max(line, 0);
	      }
	
	      function formattersListener(value) {
	        $mdUtil.nextTick(growTextarea);
	        return value;
	      }
	
	      function disableAutogrow() {
	        if (!isAutogrowing) return;
	
	        isAutogrowing = false;
	        angular.element($window).off('resize', growTextarea);
	        scopeResizeListener && scopeResizeListener();
	        element
	          .attr('md-no-autogrow', '')
	          .off('input', growTextarea);
	
	        if (hasNgModel) {
	          var listenerIndex = ngModelCtrl.$formatters.indexOf(formattersListener);
	
	          if (listenerIndex > -1) {
	            ngModelCtrl.$formatters.splice(listenerIndex, 1);
	          }
	        }
	      }
	
	      function attachResizeHandle() {
	        if (attr.hasOwnProperty('mdNoResize')) return;
	
	        var handle = angular.element('<div class="md-resize-handle"></div>');
	        var isDragging = false;
	        var dragStart = null;
	        var startHeight = 0;
	        var container = containerCtrl.element;
	        var dragGestureHandler = $mdGesture.register(handle, 'drag', { horizontal: false });
	
	
	        element.wrap('<div class="md-resize-wrapper">').after(handle);
	        handle.on('mousedown', onMouseDown);
	
	        container
	          .on('$md.dragstart', onDragStart)
	          .on('$md.drag', onDrag)
	          .on('$md.dragend', onDragEnd);
	
	        scope.$on('$destroy', function() {
	          handle
	            .off('mousedown', onMouseDown)
	            .remove();
	
	          container
	            .off('$md.dragstart', onDragStart)
	            .off('$md.drag', onDrag)
	            .off('$md.dragend', onDragEnd);
	
	          dragGestureHandler();
	          handle = null;
	          container = null;
	          dragGestureHandler = null;
	        });
	
	        function onMouseDown(ev) {
	          ev.preventDefault();
	          isDragging = true;
	          dragStart = ev.clientY;
	          startHeight = parseFloat(element.css('height')) || element.prop('offsetHeight');
	        }
	
	        function onDragStart(ev) {
	          if (!isDragging) return;
	          ev.preventDefault();
	          disableAutogrow();
	          container.addClass('md-input-resized');
	        }
	
	        function onDrag(ev) {
	          if (!isDragging) return;
	
	          element.css('height', (startHeight + ev.pointer.distanceY) + 'px');
	        }
	
	        function onDragEnd(ev) {
	          if (!isDragging) return;
	          isDragging = false;
	          container.removeClass('md-input-resized');
	        }
	      }
	
	      // Attach a watcher to detect when the textarea gets shown.
	      if (attr.hasOwnProperty('mdDetectHidden')) {
	
	        var handleHiddenChange = function() {
	          var wasHidden = false;
	
	          return function() {
	            var isHidden = node.offsetHeight === 0;
	
	            if (isHidden === false && wasHidden === true) {
	              growTextarea();
	            }
	
	            wasHidden = isHidden;
	          };
	        }();
	
	        // Check every digest cycle whether the visibility of the textarea has changed.
	        // Queue up to run after the digest cycle is complete.
	        scope.$watch(function() {
	          $mdUtil.nextTick(handleHiddenChange, false);
	          return true;
	        });
	      }
	    }
	  }
	}
	
	function mdMaxlengthDirective($animate, $mdUtil) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^mdInputContainer'],
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	    var maxlength = parseInt(attr.mdMaxlength);
	    if (isNaN(maxlength)) maxlength = -1;
	    var ngModelCtrl = ctrls[0];
	    var containerCtrl = ctrls[1];
	    var charCountEl, errorsSpacer;
	    var ngTrim = angular.isDefined(attr.ngTrim) ? $mdUtil.parseAttributeBoolean(attr.ngTrim) : true;
	    var isPasswordInput = attr.type === 'password';
	
	    ngModelCtrl.$validators['md-maxlength'] = function(modelValue, viewValue) {
	      if (!angular.isNumber(maxlength) || maxlength < 0) {
	        return true;
	      }
	
	      // We always update the char count, when the modelValue has changed.
	      // Using the $validators for triggering the update works very well.
	      renderCharCount();
	
	      var elementVal = element.val() || viewValue;
	      if (elementVal === undefined || elementVal === null) {
	        elementVal = '';
	      }
	      elementVal = ngTrim && !isPasswordInput && angular.isString(elementVal) ? elementVal.trim() : elementVal;
	      // Force the value into a string since it may be a number,
	      // which does not have a length property.
	      return String(elementVal).length <= maxlength;
	    };
	
	    /**
	     * Override the default NgModelController $isEmpty check to take ng-trim, password inputs,
	     * etc. into account.
	     * @param value {*} the input's value
	     * @returns {boolean} true if the input's value should be considered empty, false otherwise
	     */
	    ngModelCtrl.$isEmpty = function(value) {
	      return calculateInputValueLength(value) === 0;
	    };
	
	    // Wait until the next tick to ensure that the input has setup the errors spacer where we will
	    // append our counter
	    $mdUtil.nextTick(function() {
	      errorsSpacer = angular.element(containerCtrl.element[0].querySelector('.md-errors-spacer'));
	      charCountEl = angular.element('<div class="md-char-counter">');
	
	      // Append our character counter inside the errors spacer
	      errorsSpacer.append(charCountEl);
	
	      attr.$observe('ngTrim', function (value) {
	        ngTrim = angular.isDefined(value) ? $mdUtil.parseAttributeBoolean(value) : true;
	      });
	 
	      scope.$watch(attr.mdMaxlength, function(value) {
	        maxlength = value;
	        if (angular.isNumber(value) && value > 0) {
	          if (!charCountEl.parent().length) {
	            $animate.enter(charCountEl, errorsSpacer);
	          }
	          renderCharCount();
	        } else {
	          $animate.leave(charCountEl);
	        }
	      });
	    });
	
	    /**
	     * Calculate the input value's length after coercing it to a string
	     * and trimming it if appropriate.
	     * @param value {*} the input's value
	     * @returns {number} calculated length of the input's value
	     */
	    function calculateInputValueLength(value) {
	      value = ngTrim && !isPasswordInput && angular.isString(value) ? value.trim() : value;
	      if (value === undefined || value === null) {
	        value = '';
	      }
	      return String(value).length;
	    }
	
	    function renderCharCount() {
	      // If we have not been initialized or appended to the body yet; do not render.
	      if (!charCountEl || !charCountEl.parent()) {
	        return;
	      }
	      // Force the value into a string since it may be a number,
	      // which does not have a length property.
	      charCountEl.text(calculateInputValueLength(element.val()) + ' / ' + maxlength);
	    }
	  }
	}
	
	function placeholderDirective($compile) {
	  return {
	    restrict: 'A',
	    require: '^^?mdInputContainer',
	    priority: 200,
	    link: {
	      // Note that we need to do this in the pre-link, as opposed to the post link, if we want to
	      // support data bindings in the placeholder. This is necessary, because we have a case where
	      // we transfer the placeholder value to the `<label>` and we remove it from the original `<input>`.
	      // If we did this in the post-link, AngularJS would have set up the observers already and would be
	      // re-adding the attribute, even though we removed it from the element.
	      pre: preLink
	    }
	  };
	
	  function preLink(scope, element, attr, inputContainer) {
	    // If there is no input container, just return
	    if (!inputContainer) return;
	
	    var label = inputContainer.element.find('label');
	    var noFloat = inputContainer.element.attr('md-no-float');
	
	    // If we have a label, or they specify the md-no-float attribute, just return
	    if ((label && label.length) || noFloat === '' || scope.$eval(noFloat)) {
	      // Add a placeholder class so we can target it in the CSS
	      inputContainer.setHasPlaceholder(true);
	      return;
	    }
	
	    // md-select handles placeholders on it's own
	    if (element[0].nodeName != 'MD-SELECT') {
	      // Move the placeholder expression to the label
	      var newLabel = angular.element('<label ng-click="delegateClick()" tabindex="-1">' + attr.placeholder + '</label>');
	
	      // Note that we unset it via `attr`, in order to get AngularJS
	      // to remove any observers that it might have set up. Otherwise
	      // the attribute will be added on the next digest.
	      attr.$set('placeholder', null);
	
	      // We need to compile the label manually in case it has any bindings.
	      // A gotcha here is that we first add the element to the DOM and we compile
	      // it later. This is necessary, because if we compile the element beforehand,
	      // it won't be able to find the `mdInputContainer` controller.
	      inputContainer.element
	        .addClass('md-icon-float')
	        .prepend(newLabel);
	
	      $compile(newLabel)(scope);
	    }
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name mdSelectOnFocus
	 * @module material.components.input
	 *
	 * @restrict A
	 *
	 * @description
	 * The `md-select-on-focus` directive allows you to automatically select the element's input text on focus.
	 *
	 * <h3>Notes</h3>
	 * - The use of `md-select-on-focus` is restricted to `<input>` and `<textarea>` elements.
	 *
	 * @usage
	 * <h3>Using with an Input</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Auto Select</label>
	 *   <input type="text" md-select-on-focus>
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>Using with a Textarea</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Auto Select</label>
	 *   <textarea md-select-on-focus>This text will be selected on focus.</textarea>
	 * </md-input-container>
	 *
	 * </hljs>
	 */
	function mdSelectOnFocusDirective($document, $timeout) {
	
	  return {
	    restrict: 'A',
	    link: postLink
	  };
	
	  function postLink(scope, element, attr) {
	    if (element[0].nodeName !== 'INPUT' && element[0].nodeName !== "TEXTAREA") return;
	
	    var preventMouseUp = false;
	
	    element
	      .on('focus', onFocus)
	      .on('mouseup', onMouseUp);
	
	    scope.$on('$destroy', function() {
	      element
	        .off('focus', onFocus)
	        .off('mouseup', onMouseUp);
	    });
	
	    function onFocus() {
	      preventMouseUp = true;
	
	      $timeout(function() {
	
	        // Use HTMLInputElement#select to fix firefox select issues.
	        // The debounce is here for Edge's sake, otherwise the selection doesn't work.
	        // Since focus may already have been lost on the input (and because `select()`
	        // will re-focus), make sure the element is still active before applying.
	        if($document[0].activeElement === element[0]) {
	          element[0].select();
	        }
	
	        // This should be reset from inside the `focus`, because the event might
	        // have originated from something different than a click, e.g. a keyboard event.
	        preventMouseUp = false;
	      }, 1, false);
	    }
	
	    // Prevents the default action of the first `mouseup` after a focus.
	    // This is necessary, because browsers fire a `mouseup` right after the element
	    // has been focused. In some browsers (Firefox in particular) this can clear the
	    // selection. There are examples of the problem in issue #7487.
	    function onMouseUp(event) {
	      if (preventMouseUp) {
	        event.preventDefault();
	      }
	    }
	  }
	}
	
	var visibilityDirectives = ['ngIf', 'ngShow', 'ngHide', 'ngSwitchWhen', 'ngSwitchDefault'];
	function ngMessagesDirective() {
	  return {
	    restrict: 'EA',
	    link: postLink,
	
	    // This is optional because we don't want target *all* ngMessage instances, just those inside of
	    // mdInputContainer.
	    require: '^^?mdInputContainer'
	  };
	
	  function postLink(scope, element, attrs, inputContainer) {
	    // If we are not a child of an input container, don't do anything
	    if (!inputContainer) return;
	
	    // Add our animation class
	    element.toggleClass('md-input-messages-animation', true);
	
	    // Add our md-auto-hide class to automatically hide/show messages when container is invalid
	    element.toggleClass('md-auto-hide', true);
	
	    // If we see some known visibility directives, remove the md-auto-hide class
	    if (attrs.mdAutoHide == 'false' || hasVisibiltyDirective(attrs)) {
	      element.toggleClass('md-auto-hide', false);
	    }
	  }
	
	  function hasVisibiltyDirective(attrs) {
	    return visibilityDirectives.some(function(attr) {
	      return attrs[attr];
	    });
	  }
	}
	
	function ngMessageDirective($mdUtil) {
	  return {
	    restrict: 'EA',
	    compile: compile,
	    priority: 100
	  };
	
	  function compile(tElement) {
	    if (!isInsideInputContainer(tElement)) {
	
	      // When the current element is inside of a document fragment, then we need to check for an input-container
	      // in the postLink, because the element will be later added to the DOM and is currently just in a temporary
	      // fragment, which causes the input-container check to fail.
	      if (isInsideFragment()) {
	        return function (scope, element) {
	          if (isInsideInputContainer(element)) {
	            // Inside of the postLink function, a ngMessage directive will be a comment element, because it's
	            // currently hidden. To access the shown element, we need to use the element from the compile function.
	            initMessageElement(tElement);
	          }
	        };
	      }
	    } else {
	      initMessageElement(tElement);
	    }
	
	    function isInsideFragment() {
	      var nextNode = tElement[0];
	      while (nextNode = nextNode.parentNode) {
	        if (nextNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    function isInsideInputContainer(element) {
	      return !!$mdUtil.getClosest(element, "md-input-container");
	    }
	
	    function initMessageElement(element) {
	      // Add our animation class
	      element.toggleClass('md-input-message-animation', true);
	    }
	  }
	}
	
	var $$AnimateRunner, $animateCss, $mdUtil, $log;
	
	function mdInputInvalidMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);
	
	  return {
	    addClass: function(element, className, done) {
	      showInputMessages(element, done);
	    }
	
	    // NOTE: We do not need the removeClass method, because the message ng-leave animation will fire
	  };
	}
	
	function ngMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);
	
	  return {
	    enter: function(element, done) {
	      showInputMessages(element, done);
	    },
	
	    leave: function(element, done) {
	      hideInputMessages(element, done);
	    },
	
	    addClass: function(element, className, done) {
	      if (className == "ng-hide") {
	        hideInputMessages(element, done);
	      } else {
	        done();
	      }
	    },
	
	    removeClass: function(element, className, done) {
	      if (className == "ng-hide") {
	        showInputMessages(element, done);
	      } else {
	        done();
	      }
	    }
	  };
	}
	
	function ngMessageAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);
	
	  return {
	    enter: function(element, done) {
	      var animator = showMessage(element);
	
	      animator.start().done(done);
	    },
	
	    leave: function(element, done) {
	      var animator = hideMessage(element);
	
	      animator.start().done(done);
	    }
	  };
	}
	
	function showInputMessages(element, done) {
	  var animators = [], animator;
	  var messages = getMessagesElement(element);
	  var children = messages.children();
	
	  if (messages.length == 0 || children.length == 0) {
	    $log.warn('mdInput messages show animation called on invalid messages element: ', element);
	    done();
	    return;
	  }
	
	  angular.forEach(children, function(child) {
	    animator = showMessage(angular.element(child));
	
	    animators.push(animator.start());
	  });
	
	  $$AnimateRunner.all(animators, done);
	}
	
	function hideInputMessages(element, done) {
	  var animators = [], animator;
	  var messages = getMessagesElement(element);
	  var children = messages.children();
	
	  if (messages.length == 0 || children.length == 0) {
	    $log.warn('mdInput messages hide animation called on invalid messages element: ', element);
	    done();
	    return;
	  }
	
	  angular.forEach(children, function(child) {
	    animator = hideMessage(angular.element(child));
	
	    animators.push(animator.start());
	  });
	
	  $$AnimateRunner.all(animators, done);
	}
	
	function showMessage(element) {
	  var height = parseInt(window.getComputedStyle(element[0]).height);
	  var topMargin = parseInt(window.getComputedStyle(element[0]).marginTop);
	
	  var messages = getMessagesElement(element);
	  var container = getInputElement(element);
	
	  // Check to see if the message is already visible so we can skip
	  var alreadyVisible = (topMargin > -height);
	
	  // If we have the md-auto-hide class, the md-input-invalid animation will fire, so we can skip
	  if (alreadyVisible || (messages.hasClass('md-auto-hide') && !container.hasClass('md-input-invalid'))) {
	    return $animateCss(element, {});
	  }
	
	  return $animateCss(element, {
	    event: 'enter',
	    structural: true,
	    from: {"opacity": 0, "margin-top": -height + "px"},
	    to: {"opacity": 1, "margin-top": "0"},
	    duration: 0.3
	  });
	}
	
	function hideMessage(element) {
	  var height = element[0].offsetHeight;
	  var styles = window.getComputedStyle(element[0]);
	
	  // If we are already hidden, just return an empty animation
	  if (parseInt(styles.opacity) === 0) {
	    return $animateCss(element, {});
	  }
	
	  // Otherwise, animate
	  return $animateCss(element, {
	    event: 'leave',
	    structural: true,
	    from: {"opacity": 1, "margin-top": 0},
	    to: {"opacity": 0, "margin-top": -height + "px"},
	    duration: 0.3
	  });
	}
	
	function getInputElement(element) {
	  var inputContainer = element.controller('mdInputContainer');
	
	  return inputContainer.element;
	}
	
	function getMessagesElement(element) {
	  // If we ARE the messages element, just return ourself
	  if (element.hasClass('md-input-messages-animation')) {
	    return element;
	  }
	
	  // If we are a ng-message element, we need to traverse up the DOM tree
	  if (element.hasClass('md-input-message-animation')) {
	    return angular.element($mdUtil.getClosest(element, function(node) {
	      return node.classList.contains('md-input-messages-animation');
	    }));
	  }
	
	  // Otherwise, we can traverse down
	  return angular.element(element[0].querySelector('.md-input-messages-animation'));
	}
	
	function saveSharedServices(_$$AnimateRunner_, _$animateCss_, _$mdUtil_, _$log_) {
	  $$AnimateRunner = _$$AnimateRunner_;
	  $animateCss = _$animateCss_;
	  $mdUtil = _$mdUtil_;
	  $log = _$log_;
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.list
	 * @description
	 * List module
	 */
	MdListController.$inject = ["$scope", "$element", "$mdListInkRipple"];
	mdListDirective.$inject = ["$mdTheming"];
	mdListItemDirective.$inject = ["$mdAria", "$mdConstant", "$mdUtil", "$timeout"];
	angular.module('material.components.list', [
	  'material.core'
	])
	  .controller('MdListController', MdListController)
	  .directive('mdList', mdListDirective)
	  .directive('mdListItem', mdListItemDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdList
	 * @module material.components.list
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-list>` directive is a list container for 1..n `<md-list-item>` tags.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-list>
	 *   <md-list-item class="md-2-line" ng-repeat="item in todos">
	 *     <md-checkbox ng-model="item.done"></md-checkbox>
	 *     <div class="md-list-item-text">
	 *       <h3>{{item.title}}</h3>
	 *       <p>{{item.description}}</p>
	 *     </div>
	 *   </md-list-item>
	 * </md-list>
	 * </hljs>
	 */
	
	function mdListDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    compile: function(tEl) {
	      tEl[0].setAttribute('role', 'list');
	      return $mdTheming;
	    }
	  };
	}
	/**
	 * @ngdoc directive
	 * @name mdListItem
	 * @module material.components.list
	 *
	 * @restrict E
	 *
	 * @description
	 * A `md-list-item` element can be used to represent some information in a row.<br/>
	 *
	 * @usage
	 * ### Single Row Item
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Multiple Lines
	 * By using the following markup, you will be able to have two lines inside of one `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-2-line">
	 *     <div class="md-list-item-text" layout="column">
	 *       <p>First Line</p>
	 *       <p>Second Line</p>
	 *     </div>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * It is also possible to have three lines inside of one list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-3-line">
	 *     <div class="md-list-item-text" layout="column">
	 *       <p>First Line</p>
	 *       <p>Second Line</p>
	 *       <p>Third Line</p>
	 *     </div>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Secondary Items
	 * Secondary items are elements which will be aligned at the end of the `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *     <md-button class="md-secondary">
	 *       Secondary Button
	 *     </md-button>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * It also possible to have multiple secondary items inside of one `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *     <md-button class="md-secondary">First Button</md-button>
	 *     <md-button class="md-secondary">Second Button</md-button>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Proxy Item
	 * Proxies are elements, which will execute their specific action on click<br/>
	 * Currently supported proxy items are
	 * - `md-checkbox` (Toggle)
	 * - `md-switch` (Toggle)
	 * - `md-menu` (Open)
	 *
	 * This means, when using a supported proxy item inside of `md-list-item`, the list item will
	 * automatically become clickable and executes the associated action of the proxy element on click.
	 *
	 * It is possible to disable this behavior by applying the `md-no-proxy` class to the list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-no-proxy">
	 *     <span>No Proxy List</span>
	 *     <md-checkbox class="md-secondary"></md-checkbox>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * Here are a few examples of proxy elements inside of a list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>First Line</span>
	 *     <md-checkbox class="md-secondary"></md-checkbox>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The `md-checkbox` element will be automatically detected as a proxy element and will toggle on click.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>First Line</span>
	 *     <md-switch class="md-secondary"></md-switch>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The recognized `md-switch` will toggle its state, when the user clicks on the `md-list-item`.
	 *
	 * It is also possible to have a `md-menu` inside of a `md-list-item`.
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <p>Click anywhere to fire the secondary action</p>
	 *     <md-menu class="md-secondary">
	 *       <md-button class="md-icon-button">
	 *         <md-icon md-svg-icon="communication:message"></md-icon>
	 *       </md-button>
	 *       <md-menu-content width="4">
	 *         <md-menu-item>
	 *           <md-button>
	 *             Redial
	 *           </md-button>
	 *         </md-menu-item>
	 *         <md-menu-item>
	 *           <md-button>
	 *             Check voicemail
	 *           </md-button>
	 *         </md-menu-item>
	 *         <md-menu-divider></md-menu-divider>
	 *         <md-menu-item>
	 *           <md-button>
	 *             Notifications
	 *           </md-button>
	 *         </md-menu-item>
	 *       </md-menu-content>
	 *     </md-menu>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The menu will automatically open, when the users clicks on the `md-list-item`.<br/>
	 *
	 * If the developer didn't specify any position mode on the menu, the `md-list-item` will automatically detect the
	 * position mode and applies it to the `md-menu`.
	 *
	 * ### Avatars
	 * Sometimes you may want to have some avatars inside of the `md-list-item `.<br/>
	 * You are able to create a optimized icon for the list item, by applying the `.md-avatar` class on the `<img>` element.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <img src="my-avatar.png" class="md-avatar">
	 *     <span>Alan Turing</span>
	 * </hljs>
	 *
	 * When using `<md-icon>` for an avatar, you have to use the `.md-avatar-icon` class.
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <md-icon class="md-avatar-icon" md-svg-icon="avatars:timothy"></md-icon>
	 *     <span>Timothy Kopra</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * In cases, you have a `md-list-item`, which doesn't have any avatar,
	 * but you want to align it with the other avatar items, you have to use the `.md-offset` class.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-offset">
	 *     <span>Jon Doe</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### DOM modification
	 * The `md-list-item` component automatically detects if the list item should be clickable.
	 *
	 * ---
	 * If the `md-list-item` is clickable, we wrap all content inside of a `<div>` and create
	 * an overlaying button, which will will execute the given actions (like `ng-href`, `ng-click`)
	 *
	 * We create an overlaying button, instead of wrapping all content inside of the button,
	 * because otherwise some elements may not be clickable inside of the button.
	 *
	 * ---
	 * When using a secondary item inside of your list item, the `md-list-item` component will automatically create
	 * a secondary container at the end of the `md-list-item`, which contains all secondary items.
	 *
	 * The secondary item container is not static, because otherwise the overflow will not work properly on the
	 * list item.
	 *
	 */
	function mdListItemDirective($mdAria, $mdConstant, $mdUtil, $timeout) {
	  var proxiedTypes = ['md-checkbox', 'md-switch', 'md-menu'];
	  return {
	    restrict: 'E',
	    controller: 'MdListController',
	    compile: function(tEl, tAttrs) {
	
	      // Check for proxy controls (no ng-click on parent, and a control inside)
	      var secondaryItems = tEl[0].querySelectorAll('.md-secondary');
	      var hasProxiedElement;
	      var proxyElement;
	      var itemContainer = tEl;
	
	      tEl[0].setAttribute('role', 'listitem');
	
	      if (tAttrs.ngClick || tAttrs.ngDblclick ||  tAttrs.ngHref || tAttrs.href || tAttrs.uiSref || tAttrs.ngAttrUiSref) {
	        wrapIn('button');
	      } else if (!tEl.hasClass('md-no-proxy')) {
	
	        for (var i = 0, type; type = proxiedTypes[i]; ++i) {
	          if (proxyElement = tEl[0].querySelector(type)) {
	            hasProxiedElement = true;
	            break;
	          }
	        }
	
	        if (hasProxiedElement) {
	          wrapIn('div');
	        } else {
	          tEl.addClass('md-no-proxy');
	        }
	
	      }
	
	      wrapSecondaryItems();
	      setupToggleAria();
	
	      if (hasProxiedElement && proxyElement.nodeName === "MD-MENU") {
	        setupProxiedMenu();
	      }
	
	      function setupToggleAria() {
	        var toggleTypes = ['md-switch', 'md-checkbox'];
	        var toggle;
	
	        for (var i = 0, toggleType; toggleType = toggleTypes[i]; ++i) {
	          if (toggle = tEl.find(toggleType)[0]) {
	            if (!toggle.hasAttribute('aria-label')) {
	              var p = tEl.find('p')[0];
	              if (!p) return;
	              toggle.setAttribute('aria-label', 'Toggle ' + p.textContent);
	            }
	          }
	        }
	      }
	
	      function setupProxiedMenu() {
	        var menuEl = angular.element(proxyElement);
	
	        var isEndAligned = menuEl.parent().hasClass('md-secondary-container') ||
	                           proxyElement.parentNode.firstElementChild !== proxyElement;
	
	        var xAxisPosition = 'left';
	
	        if (isEndAligned) {
	          // When the proxy item is aligned at the end of the list, we have to set the origin to the end.
	          xAxisPosition = 'right';
	        }
	
	        // Set the position mode / origin of the proxied menu.
	        if (!menuEl.attr('md-position-mode')) {
	          menuEl.attr('md-position-mode', xAxisPosition + ' target');
	        }
	
	        // Apply menu open binding to menu button
	        var menuOpenButton = menuEl.children().eq(0);
	        if (!hasClickEvent(menuOpenButton[0])) {
	          menuOpenButton.attr('ng-click', '$mdMenu.open($event)');
	        }
	
	        if (!menuOpenButton.attr('aria-label')) {
	          menuOpenButton.attr('aria-label', 'Open List Menu');
	        }
	      }
	
	      function wrapIn(type) {
	        if (type == 'div') {
	          itemContainer = angular.element('<div class="md-no-style md-list-item-inner">');
	          itemContainer.append(tEl.contents());
	          tEl.addClass('md-proxy-focus');
	        } else {
	          // Element which holds the default list-item content.
	          itemContainer = angular.element(
	            '<div class="md-button md-no-style">'+
	            '   <div class="md-list-item-inner"></div>'+
	            '</div>'
	          );
	
	          // Button which shows ripple and executes primary action.
	          var buttonWrap = angular.element(
	            '<md-button class="md-no-style"></md-button>'
	          );
	
	          copyAttributes(tEl[0], buttonWrap[0]);
	
	          // If there is no aria-label set on the button (previously copied over if present)
	          // we determine the label from the content and copy it to the button.
	          if (!buttonWrap.attr('aria-label')) {
	            buttonWrap.attr('aria-label', $mdAria.getText(tEl));
	          }
	
	          // We allow developers to specify the `md-no-focus` class, to disable the focus style
	          // on the button executor. Once more classes should be forwarded, we should probably make the
	          // class forward more generic.
	          if (tEl.hasClass('md-no-focus')) {
	            buttonWrap.addClass('md-no-focus');
	          }
	
	          // Append the button wrap before our list-item content, because it will overlay in relative.
	          itemContainer.prepend(buttonWrap);
	          itemContainer.children().eq(1).append(tEl.contents());
	
	          tEl.addClass('_md-button-wrap');
	        }
	
	        tEl[0].setAttribute('tabindex', '-1');
	        tEl.append(itemContainer);
	      }
	
	      function wrapSecondaryItems() {
	        var secondaryItemsWrapper = angular.element('<div class="md-secondary-container">');
	
	        angular.forEach(secondaryItems, function(secondaryItem) {
	          wrapSecondaryItem(secondaryItem, secondaryItemsWrapper);
	        });
	
	        itemContainer.append(secondaryItemsWrapper);
	      }
	
	      function wrapSecondaryItem(secondaryItem, container) {
	        // If the current secondary item is not a button, but contains a ng-click attribute,
	        // the secondary item will be automatically wrapped inside of a button.
	        if (secondaryItem && !isButton(secondaryItem) && secondaryItem.hasAttribute('ng-click')) {
	
	          $mdAria.expect(secondaryItem, 'aria-label');
	          var buttonWrapper = angular.element('<md-button class="md-secondary md-icon-button">');
	
	          // Copy the attributes from the secondary item to the generated button.
	          // We also support some additional attributes from the secondary item,
	          // because some developers may use a ngIf, ngHide, ngShow on their item.
	          copyAttributes(secondaryItem, buttonWrapper[0], ['ng-if', 'ng-hide', 'ng-show']);
	
	          secondaryItem.setAttribute('tabindex', '-1');
	          buttonWrapper.append(secondaryItem);
	
	          secondaryItem = buttonWrapper[0];
	        }
	
	        if (secondaryItem && (!hasClickEvent(secondaryItem) || (!tAttrs.ngClick && isProxiedElement(secondaryItem)))) {
	          // In this case we remove the secondary class, so we can identify it later, when we searching for the
	          // proxy items.
	          angular.element(secondaryItem).removeClass('md-secondary');
	        }
	
	        tEl.addClass('md-with-secondary');
	        container.append(secondaryItem);
	      }
	
	      /**
	       * Copies attributes from a source element to the destination element
	       * By default the function will copy the most necessary attributes, supported
	       * by the button executor for clickable list items.
	       * @param source Element with the specified attributes
	       * @param destination Element which will retrieve the attributes
	       * @param extraAttrs Additional attributes, which will be copied over.
	       */
	      function copyAttributes(source, destination, extraAttrs) {
	        var copiedAttrs = $mdUtil.prefixer([
	          'ng-if', 'ng-click', 'ng-dblclick', 'aria-label', 'ng-disabled', 'ui-sref',
	          'href', 'ng-href', 'rel', 'target', 'ng-attr-ui-sref', 'ui-sref-opts', 'download'
	        ]);
	
	        if (extraAttrs) {
	          copiedAttrs = copiedAttrs.concat($mdUtil.prefixer(extraAttrs));
	        }
	
	        angular.forEach(copiedAttrs, function(attr) {
	          if (source.hasAttribute(attr)) {
	            destination.setAttribute(attr, source.getAttribute(attr));
	            source.removeAttribute(attr);
	          }
	        });
	      }
	
	      function isProxiedElement(el) {
	        return proxiedTypes.indexOf(el.nodeName.toLowerCase()) != -1;
	      }
	
	      function isButton(el) {
	        var nodeName = el.nodeName.toUpperCase();
	
	        return nodeName == "MD-BUTTON" || nodeName == "BUTTON";
	      }
	
	      function hasClickEvent (element) {
	        var attr = element.attributes;
	        for (var i = 0; i < attr.length; i++) {
	          if (tAttrs.$normalize(attr[i].name) === 'ngClick') return true;
	        }
	        return false;
	      }
	
	      return postLink;
	
	      function postLink($scope, $element, $attr, ctrl) {
	        $element.addClass('_md');     // private md component indicator for styling
	
	        var proxies       = [],
	            firstElement  = $element[0].firstElementChild,
	            isButtonWrap  = $element.hasClass('_md-button-wrap'),
	            clickChild    = isButtonWrap ? firstElement.firstElementChild : firstElement,
	            hasClick      = clickChild && hasClickEvent(clickChild),
	            noProxies     = $element.hasClass('md-no-proxy');
	
	        computeProxies();
	        computeClickable();
	
	        if (proxies.length) {
	          angular.forEach(proxies, function(proxy) {
	            proxy = angular.element(proxy);
	
	            $scope.mouseActive = false;
	            proxy.on('mousedown', function() {
	              $scope.mouseActive = true;
	              $timeout(function(){
	                $scope.mouseActive = false;
	              }, 100);
	            })
	            .on('focus', function() {
	              if ($scope.mouseActive === false) { $element.addClass('md-focused'); }
	              proxy.on('blur', function proxyOnBlur() {
	                $element.removeClass('md-focused');
	                proxy.off('blur', proxyOnBlur);
	              });
	            });
	          });
	        }
	
	
	        function computeProxies() {
	
	          if (firstElement && firstElement.children && !hasClick && !noProxies) {
	
	            angular.forEach(proxiedTypes, function(type) {
	
	              // All elements which are not capable for being used a proxy have the .md-secondary class
	              // applied. These items had been sorted out in the secondary wrap function.
	              angular.forEach(firstElement.querySelectorAll(type + ':not(.md-secondary)'), function(child) {
	                proxies.push(child);
	              });
	            });
	
	          }
	        }
	
	        function computeClickable() {
	          if (proxies.length == 1 || hasClick) {
	            $element.addClass('md-clickable');
	
	            if (!hasClick) {
	              ctrl.attachRipple($scope, angular.element($element[0].querySelector('.md-no-style')));
	            }
	          }
	        }
	
	        function isEventFromControl(event) {
	          var forbiddenControls = ['md-slider'];
	
	          // If there is no path property in the event, then we can assume that the event was not bubbled.
	          if (!event.path) {
	            return forbiddenControls.indexOf(event.target.tagName.toLowerCase()) !== -1;
	          }
	
	          // We iterate the event path up and check for a possible component.
	          // Our maximum index to search, is the list item root.
	          var maxPath = event.path.indexOf($element.children()[0]);
	
	          for (var i = 0; i < maxPath; i++) {
	            if (forbiddenControls.indexOf(event.path[i].tagName.toLowerCase()) !== -1) {
	              return true;
	            }
	          }
	        }
	
	        var clickChildKeypressListener = function(e) {
	          if (e.target.nodeName != 'INPUT' && e.target.nodeName != 'TEXTAREA' && !e.target.isContentEditable) {
	            var keyCode = e.which || e.keyCode;
	            if (keyCode == $mdConstant.KEY_CODE.SPACE) {
	              if (clickChild) {
	                clickChild.click();
	                e.preventDefault();
	                e.stopPropagation();
	              }
	            }
	          }
	        };
	
	        if (!hasClick && !proxies.length) {
	          clickChild && clickChild.addEventListener('keypress', clickChildKeypressListener);
	        }
	
	        $element.off('click');
	        $element.off('keypress');
	
	        if (proxies.length == 1 && clickChild) {
	          $element.children().eq(0).on('click', function(e) {
	            // When the event is coming from an control and it should not trigger the proxied element
	            // then we are skipping.
	            if (isEventFromControl(e)) return;
	
	            var parentButton = $mdUtil.getClosest(e.target, 'BUTTON');
	            if (!parentButton && clickChild.contains(e.target)) {
	              angular.forEach(proxies, function(proxy) {
	                if (e.target !== proxy && !proxy.contains(e.target)) {
	                  if (proxy.nodeName === 'MD-MENU') {
	                    proxy = proxy.children[0];
	                  }
	                  angular.element(proxy).triggerHandler('click');
	                }
	              });
	            }
	          });
	        }
	
	        $scope.$on('$destroy', function () {
	          clickChild && clickChild.removeEventListener('keypress', clickChildKeypressListener);
	        });
	      }
	    }
	  };
	}
	
	/*
	 * @private
	 * @ngdoc controller
	 * @name MdListController
	 * @module material.components.list
	 *
	 */
	function MdListController($scope, $element, $mdListInkRipple) {
	  var ctrl = this;
	  ctrl.attachRipple = attachRipple;
	
	  function attachRipple (scope, element) {
	    var options = {};
	    $mdListInkRipple.attach(scope, element, options);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.menu
	 */
	
	angular.module('material.components.menu', [
	  'material.core',
	  'material.components.backdrop'
	]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.menuBar
	 */
	
	angular.module('material.components.menuBar', [
	  'material.core',
	  'material.components.icon',
	  'material.components.menu'
	]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.navBar
	 */
	
	
	MdNavBarController.$inject = ["$element", "$scope", "$timeout", "$mdConstant"];
	MdNavItem.$inject = ["$mdAria", "$$rAF", "$mdUtil", "$window"];
	MdNavItemController.$inject = ["$element"];
	MdNavBar.$inject = ["$mdAria", "$mdTheming"];
	angular.module('material.components.navBar', ['material.core'])
	    .controller('MdNavBarController', MdNavBarController)
	    .directive('mdNavBar', MdNavBar)
	    .controller('MdNavItemController', MdNavItemController)
	    .directive('mdNavItem', MdNavItem);
	
	
	/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************/
	/**
	 * @ngdoc directive
	 * @name mdNavBar
	 * @module material.components.navBar
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-nav-bar>` directive renders a list of material tabs that can be used
	 * for top-level page navigation. Unlike `<md-tabs>`, it has no concept of a tab
	 * body and no bar pagination.
	 *
	 * Because it deals with page navigation, certain routing concepts are built-in.
	 * Route changes via `ng-href`, `ui-sref`, or `ng-click` events are supported.
	 * Alternatively, the user could simply watch the value of `md-selected-nav-item`
	 * (`currentNavItem` in the below example) for changes.
	 *
	 * Accessibility functionality is implemented as a site navigator with a
	 * listbox, according to the
	 * <a href="https://www.w3.org/TR/2016/WD-wai-aria-practices-1.1-20160317/#Site_Navigator_Tabbed_Style">
	 *   WAI-ARIA Authoring Practices 1.1 Working Draft from March 2016</a>.
	 * We've kept the `role="navigation"` on the `<nav>`, for backwards compatibility, even though
	 *  it is not required in the
	 * <a href="https://www.w3.org/TR/wai-aria-practices/#aria_lh_navigation">
	 *   latest Working Group Note from December 2017</a>.
	 *
	 * @param {string=} md-selected-nav-item The name of the current tab; this must
	 *     match the `name` attribute of `<md-nav-item>`.
	 * @param {boolean=} md-no-ink-bar If set to true, the ink bar will be hidden.
	 * @param {string=} nav-bar-aria-label An `aria-label` applied to the `md-nav-bar`'s listbox
	 * for accessibility.
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-nav-bar md-selected-nav-item="currentNavItem">
	 *    <md-nav-item md-nav-click="goto('page1')" name="page1">
	 *      Page One
	 *    </md-nav-item>
	 *    <md-nav-item md-nav-href="#page2" name="page3">Page Two</md-nav-item>
	 *    <md-nav-item md-nav-sref="page3" name="page2">Page Three</md-nav-item>
	 *    <md-nav-item
	 *      md-nav-sref="app.page4"
	 *      sref-opts="{reload: true, notify: true}"
	 *      name="page4">
	 *      Page Four
	 *    </md-nav-item>
	 *  </md-nav-bar>
	 *</hljs>
	 * <hljs lang="js">
	 * (function() {
	 *   'use strict';
	 *
	 *    $rootScope.$on('$routeChangeSuccess', function(event, current) {
	 *      $scope.currentLink = getCurrentLinkFromRoute(current);
	 *    });
	 * });
	 * </hljs>
	 */
	
	/*****************************************************************************
	 *                            mdNavItem
	 *****************************************************************************/
	/**
	 * @ngdoc directive
	 * @name mdNavItem
	 * @module material.components.navBar
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-nav-item>` describes a page navigation link within the `<md-nav-bar>` component.
	 * It renders an `<md-button>` as the actual link.
	 *
	 * Exactly one of the `md-nav-click`, `md-nav-href`, or `md-nav-sref` attributes are required
	 * to be specified.
	 *
	 * @param {string=} aria-label Adds alternative text for accessibility.
	 * @param {expression=} md-nav-click Expression which will be evaluated when the
	 *     link is clicked to change the page. Renders as an `ng-click`.
	 * @param {string=} md-nav-href url to transition to when this link is clicked.
	 *     Renders as an `ng-href`.
	 * @param {string=} md-nav-sref UI-Router state to transition to when this link is
	 *     clicked. Renders as a `ui-sref`.
	 * @param {string=} name The name of this link. Used by the nav bar to know
	 *     which link is currently selected.
	 * @param {!object=} sref-opts UI-Router options that are passed to the
	 *     `$state.go()` function. See the [UI-Router documentation for details]
	 *     (https://ui-router.github.io/docs/latest/interfaces/transition.transitionoptions.html).
	 *
	 * @usage
	 * See `<md-nav-bar>` for usage.
	 */
	
	
	/*****************************************************************************
	 *                                IMPLEMENTATION                             *
	 *****************************************************************************/
	
	function MdNavBar($mdAria, $mdTheming) {
	  return {
	    restrict: 'E',
	    transclude: true,
	    controller: MdNavBarController,
	    controllerAs: 'ctrl',
	    bindToController: true,
	    scope: {
	      'mdSelectedNavItem': '=?',
	      'mdNoInkBar': '=?',
	      'navBarAriaLabel': '@?',
	    },
	    template:
	      '<div class="md-nav-bar">' +
	        '<nav role="navigation">' +
	          '<ul class="_md-nav-bar-list" ng-transclude role="listbox" ' +
	            'tabindex="0" ' +
	            'ng-focus="ctrl.onFocus()" ' +
	            'ng-keydown="ctrl.onKeydown($event)" ' +
	            'aria-label="{{ctrl.navBarAriaLabel}}">' +
	          '</ul>' +
	        '</nav>' +
	        '<md-nav-ink-bar ng-hide="ctrl.mdNoInkBar"></md-nav-ink-bar>' +
	      '</div>',
	    link: function(scope, element, attrs, ctrl) {
	      $mdTheming(element);
	      if (!ctrl.navBarAriaLabel) {
	        $mdAria.expectAsync(element, 'aria-label', angular.noop);
	      }
	    },
	  };
	}
	
	/**
	 * Controller for the nav-bar component.
	 *
	 * Accessibility functionality is implemented as a site navigator with a
	 * listbox, according to
	 * https://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style
	 * @param {!angular.JQLite} $element
	 * @param {!angular.Scope} $scope
	 * @param {!angular.Timeout} $timeout
	 * @param {!Object} $mdConstant
	 * @constructor
	 * @final
	 * @ngInject
	 */
	function MdNavBarController($element, $scope, $timeout, $mdConstant) {
	  // Injected variables
	  /** @private @const {!angular.Timeout} */
	  this._$timeout = $timeout;
	
	  /** @private @const {!angular.Scope} */
	  this._$scope = $scope;
	
	  /** @private @const {!Object} */
	  this._$mdConstant = $mdConstant;
	
	  // Data-bound variables.
	  /** @type {string} */
	  this.mdSelectedNavItem;
	
	  /** @type {string} */
	  this.navBarAriaLabel;
	
	  // State variables.
	
	  /** @type {?angular.JQLite} */
	  this._navBarEl = $element[0];
	
	  /** @type {?angular.JQLite} */
	  this._inkbar;
	
	  var self = this;
	  // need to wait for transcluded content to be available
	  var deregisterTabWatch = this._$scope.$watch(function() {
	    return self._navBarEl.querySelectorAll('._md-nav-button').length;
	  },
	  function(newLength) {
	    if (newLength > 0) {
	      self._initTabs();
	      deregisterTabWatch();
	    }
	  });
	}
	
	
	
	/**
	 * Initializes the tab components once they exist.
	 * @private
	 */
	MdNavBarController.prototype._initTabs = function() {
	  this._inkbar = angular.element(this._navBarEl.querySelector('md-nav-ink-bar'));
	
	  var self = this;
	  this._$timeout(function() {
	    self._updateTabs(self.mdSelectedNavItem, undefined);
	  });
	
	  this._$scope.$watch('ctrl.mdSelectedNavItem', function(newValue, oldValue) {
	    // Wait a digest before update tabs for products doing
	    // anything dynamic in the template.
	    self._$timeout(function() {
	      self._updateTabs(newValue, oldValue);
	    });
	  });
	};
	
	/**
	 * Set the current tab to be selected.
	 * @param {string|undefined} newValue New current tab name.
	 * @param {string|undefined} oldValue Previous tab name.
	 * @private
	 */
	MdNavBarController.prototype._updateTabs = function(newValue, oldValue) {
	  var self = this;
	  var tabs = this._getTabs();
	
	  // this._getTabs can return null if nav-bar has not yet been initialized
	  if(!tabs)
	    return;
	
	  var oldIndex = -1;
	  var newIndex = -1;
	  var newTab = this._getTabByName(newValue);
	  var oldTab = this._getTabByName(oldValue);
	
	  if (oldTab) {
	    oldTab.setSelected(false);
	    oldIndex = tabs.indexOf(oldTab);
	  }
	
	  if (newTab) {
	    newTab.setSelected(true);
	    newIndex = tabs.indexOf(newTab);
	  }
	
	  this._$timeout(function() {
	    self._updateInkBarStyles(newTab, newIndex, oldIndex);
	  });
	};
	
	/**
	 * Repositions the ink bar to the selected tab.
	 * @private
	 */
	MdNavBarController.prototype._updateInkBarStyles = function(tab, newIndex, oldIndex) {
	  this._inkbar.toggleClass('_md-left', newIndex < oldIndex)
	      .toggleClass('_md-right', newIndex > oldIndex);
	
	  this._inkbar.css({display: newIndex < 0 ? 'none' : ''});
	
	  if (tab) {
	    var tabEl = tab.getButtonEl();
	    var left = tabEl.offsetLeft;
	
	    this._inkbar.css({left: left + 'px', width: tabEl.offsetWidth + 'px'});
	  }
	};
	
	/**
	 * Returns an array of the current tabs.
	 * @return {!Array<!NavItemController>}
	 * @private
	 */
	MdNavBarController.prototype._getTabs = function() {
	  var controllers = Array.prototype.slice.call(
	    this._navBarEl.querySelectorAll('.md-nav-item'))
	    .map(function(el) {
	      return angular.element(el).controller('mdNavItem');
	    });
	  return controllers.indexOf(undefined) ? controllers : null;
	};
	
	/**
	 * Returns the tab with the specified name.
	 * @param {string} name The name of the tab, found in its name attribute.
	 * @return {!NavItemController|undefined}
	 * @private
	 */
	MdNavBarController.prototype._getTabByName = function(name) {
	  return this._findTab(function(tab) {
	    return tab.getName() == name;
	  });
	};
	
	/**
	 * Returns the selected tab.
	 * @return {!NavItemController|undefined}
	 * @private
	 */
	MdNavBarController.prototype._getSelectedTab = function() {
	  return this._findTab(function(tab) {
	    return tab.isSelected();
	  });
	};
	
	/**
	 * Returns the focused tab.
	 * @return {!NavItemController|undefined}
	 */
	MdNavBarController.prototype.getFocusedTab = function() {
	  return this._findTab(function(tab) {
	    return tab.hasFocus();
	  });
	};
	
	/**
	 * Find a tab that matches the specified function.
	 * @private
	 */
	MdNavBarController.prototype._findTab = function(fn) {
	  var tabs = this._getTabs();
	  for (var i = 0; i < tabs.length; i++) {
	    if (fn(tabs[i])) {
	      return tabs[i];
	    }
	  }
	
	  return null;
	};
	
	/**
	 * Direct focus to the selected tab when focus enters the nav bar.
	 */
	MdNavBarController.prototype.onFocus = function() {
	  var tab = this._getSelectedTab();
	  if (tab) {
	    tab.setFocused(true);
	  }
	};
	
	/**
	 * Move focus from oldTab to newTab.
	 * @param {!NavItemController} oldTab
	 * @param {!NavItemController} newTab
	 * @private
	 */
	MdNavBarController.prototype._moveFocus = function(oldTab, newTab) {
	  oldTab.setFocused(false);
	  newTab.setFocused(true);
	};
	
	/**
	 * Responds to keypress events.
	 * @param {!Event} e
	 */
	MdNavBarController.prototype.onKeydown = function(e) {
	  var keyCodes = this._$mdConstant.KEY_CODE;
	  var tabs = this._getTabs();
	  var focusedTab = this.getFocusedTab();
	  if (!focusedTab) return;
	
	  var focusedTabIndex = tabs.indexOf(focusedTab);
	
	  // use arrow keys to navigate between tabs
	  switch (e.keyCode) {
	    case keyCodes.UP_ARROW:
	    case keyCodes.LEFT_ARROW:
	      if (focusedTabIndex > 0) {
	        this._moveFocus(focusedTab, tabs[focusedTabIndex - 1]);
	      }
	      break;
	    case keyCodes.DOWN_ARROW:
	    case keyCodes.RIGHT_ARROW:
	      if (focusedTabIndex < tabs.length - 1) {
	        this._moveFocus(focusedTab, tabs[focusedTabIndex + 1]);
	      }
	      break;
	    case keyCodes.SPACE:
	    case keyCodes.ENTER:
	      // timeout to avoid a "digest already in progress" console error
	      this._$timeout(function() {
	        focusedTab.getButtonEl().click();
	      });
	      break;
	  }
	};
	
	/**
	 * @ngInject
	 */
	function MdNavItem($mdAria, $$rAF, $mdUtil, $window) {
	  return {
	    restrict: 'E',
	    require: ['mdNavItem', '^mdNavBar'],
	    controller: MdNavItemController,
	    bindToController: true,
	    controllerAs: 'ctrl',
	    replace: true,
	    transclude: true,
	    template: function(tElement, tAttrs) {
	      var hasNavClick = tAttrs.mdNavClick;
	      var hasNavHref = tAttrs.mdNavHref;
	      var hasNavSref = tAttrs.mdNavSref;
	      var hasSrefOpts = tAttrs.srefOpts;
	      var navigationAttribute;
	      var navigationOptions;
	      var buttonTemplate;
	
	      // Cannot specify more than one nav attribute
	      if ((hasNavClick ? 1:0) + (hasNavHref ? 1:0) + (hasNavSref ? 1:0) > 1) {
	        throw Error(
	          'Must not specify more than one of the md-nav-click, md-nav-href, ' +
	          'or md-nav-sref attributes per nav-item directive.'
	        );
	      }
	
	      if (hasNavClick) {
	        navigationAttribute = 'ng-click="ctrl.mdNavClick()"';
	      } else if (hasNavHref) {
	        navigationAttribute = 'ng-href="{{ctrl.mdNavHref}}"';
	      } else if (hasNavSref) {
	        navigationAttribute = 'ui-sref="{{ctrl.mdNavSref}}"';
	      }
	
	      navigationOptions = hasSrefOpts ? 'ui-sref-opts="{{ctrl.srefOpts}}" ' : '';
	
	      if (navigationAttribute) {
	        buttonTemplate = '' +
	          '<md-button class="_md-nav-button md-accent" ' +
	            'ng-class="ctrl.getNgClassMap()" ' +
	            'ng-blur="ctrl.setFocused(false)" ' +
	            'ng-disabled="ctrl.disabled" ' +
	            'tabindex="-1" ' +
	            navigationOptions +
	            navigationAttribute + '>' +
	            '<span ng-transclude class="_md-nav-button-text"></span>' +
	          '</md-button>';
	      }
	
	      return '' +
	        '<li class="md-nav-item" ' +
	          'role="option" ' +
	          'aria-selected="{{ctrl.isSelected()}}">' +
	          (buttonTemplate || '') +
	        '</li>';
	    },
	    scope: {
	      'mdNavClick': '&?',
	      'mdNavHref': '@?',
	      'mdNavSref': '@?',
	      'srefOpts': '=?',
	      'name': '@',
	    },
	    link: function(scope, element, attrs, controllers) {
	      var disconnect;
	
	      // When accessing the element's contents synchronously, they
	      // may not be defined yet because of transclusion. There is a higher
	      // chance that it will be accessible if we wait one frame.
	      $$rAF(function() {
	        var mdNavItem = controllers[0];
	        var mdNavBar = controllers[1];
	        var navButton = angular.element(element[0].querySelector('._md-nav-button'));
	
	        if (!mdNavItem.name) {
	          mdNavItem.name = angular.element(element[0]
	              .querySelector('._md-nav-button-text')).text().trim();
	        }
	
	        navButton.on('click', function() {
	          mdNavBar.mdSelectedNavItem = mdNavItem.name;
	          scope.$apply();
	        });
	
	        // Get the disabled attribute value first, then setup observing of value changes
	        mdNavItem.disabled = $mdUtil.parseAttributeBoolean(attrs['disabled'], false);
	        if ('MutationObserver' in $window) {
	          var config = {attributes: true, attributeFilter: ['disabled']};
	          var targetNode = element[0];
	          var mutationCallback = function(mutationList) {
	            $mdUtil.nextTick(function() {
	              mdNavItem.disabled = $mdUtil.parseAttributeBoolean(attrs[mutationList[0].attributeName], false);
	            });
	          };
	          var observer = new MutationObserver(mutationCallback);
	          observer.observe(targetNode, config);
	          disconnect = observer.disconnect.bind(observer);
	        } else {
	          attrs.$observe('disabled', function (value) {
	            mdNavItem.disabled = $mdUtil.parseAttributeBoolean(value, false);
	          });
	        }
	
	        $mdAria.expectWithText(element, 'aria-label');
	      });
	
	      scope.$on('destroy', function() {
	        disconnect();
	      })
	    }
	  };
	}
	
	/**
	 * Controller for the nav-item component.
	 * @param {!angular.JQLite} $element
	 * @constructor
	 * @final
	 * @ngInject
	 */
	function MdNavItemController($element) {
	
	  /** @private @const {!angular.JQLite} */
	  this._$element = $element;
	
	  // Data-bound variables
	
	  /** @const {?Function} */
	  this.mdNavClick;
	
	  /** @const {?string} */
	  this.mdNavHref;
	
	  /** @const {?string} */
	  this.mdNavSref;
	  /** @const {?Object} */
	  this.srefOpts;
	  /** @const {?string} */
	  this.name;
	
	  // State variables
	  /** @private {boolean} */
	  this._selected = false;
	
	  /** @private {boolean} */
	  this._focused = false;
	}
	
	/**
	 * Returns a map of class names and values for use by ng-class.
	 * @return {!Object<string,boolean>}
	 */
	MdNavItemController.prototype.getNgClassMap = function() {
	  return {
	    'md-active': this._selected,
	    'md-primary': this._selected,
	    'md-unselected': !this._selected,
	    'md-focused': this._focused,
	  };
	};
	
	/**
	 * Get the name attribute of the tab.
	 * @return {string}
	 */
	MdNavItemController.prototype.getName = function() {
	  return this.name;
	};
	
	/**
	 * Get the button element associated with the tab.
	 * @return {!Element}
	 */
	MdNavItemController.prototype.getButtonEl = function() {
	  return this._$element[0].querySelector('._md-nav-button');
	};
	
	/**
	 * Set the selected state of the tab.
	 * @param {boolean} isSelected
	 */
	MdNavItemController.prototype.setSelected = function(isSelected) {
	  this._selected = isSelected;
	};
	
	/**
	 * @return {boolean}
	 */
	MdNavItemController.prototype.isSelected = function() {
	  return this._selected;
	};
	
	/**
	 * Set the focused state of the tab.
	 * @param {boolean} isFocused
	 */
	MdNavItemController.prototype.setFocused = function(isFocused) {
	  this._focused = isFocused;
	
	  if (isFocused) {
	    this.getButtonEl().focus();
	  }
	};
	
	/**
	 * @return {boolean}
	 */
	MdNavItemController.prototype.hasFocus = function() {
	  return this._focused;
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.panel
	 */
	MdPanelService.$inject = ["presets", "$rootElement", "$rootScope", "$injector", "$window"];
	angular
	  .module('material.components.panel', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .provider('$mdPanel', MdPanelProvider);
	
	
	/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc service
	 * @name $mdPanelProvider
	 * @module material.components.panel
	 *
	 * @description
	 * `$mdPanelProvider` allows users to create configuration presets that will be
	 * stored within a cached presets object. When the configuration is needed, the
	 * user can request the preset by passing it as the first parameter in the
	 * `$mdPanel.create` or `$mdPanel.open` methods.
	 *
	 * @usage
	 * <hljs lang="js">
	 * (function(angular, undefined) {
	 *   'use strict';
	 *
	 *   angular
	 *       .module('demoApp', ['ngMaterial'])
	 *       .config(DemoConfig)
	 *       .controller('DemoCtrl', DemoCtrl)
	 *       .controller('DemoMenuCtrl', DemoMenuCtrl);
	 *
	 *   function DemoConfig($mdPanelProvider) {
	 *     $mdPanelProvider.definePreset('demoPreset', {
	 *       attachTo: angular.element(document.body),
	 *       controller: DemoMenuCtrl,
	 *       controllerAs: 'ctrl',
	 *       template: '' +
	 *           '<div class="menu-panel" md-whiteframe="4">' +
	 *           '  <div class="menu-content">' +
	 *           '    <div class="menu-item" ng-repeat="item in ctrl.items">' +
	 *           '      <button class="md-button">' +
	 *           '        <span>{{item}}</span>' +
	 *           '      </button>' +
	 *           '    </div>' +
	 *           '    <md-divider></md-divider>' +
	 *           '    <div class="menu-item">' +
	 *           '      <button class="md-button" ng-click="ctrl.closeMenu()">' +
	 *           '        <span>Close Menu</span>' +
	 *           '      </button>' +
	 *           '    </div>' +
	 *           '  </div>' +
	 *           '</div>',
	 *       panelClass: 'menu-panel-container',
	 *       focusOnOpen: false,
	 *       zIndex: 100,
	 *       propagateContainerEvents: true,
	 *       groupName: 'menus'
	 *     });
	 *   }
	 *
	 *   function PanelProviderCtrl($mdPanel) {
	 *     this.navigation = {
	 *       name: 'navigation',
	 *       items: [
	 *         'Home',
	 *         'About',
	 *         'Contact'
	 *       ]
	 *     };
	 *     this.favorites = {
	 *       name: 'favorites',
	 *       items: [
	 *         'Add to Favorites'
	 *       ]
	 *     };
	 *     this.more = {
	 *       name: 'more',
	 *       items: [
	 *         'Account',
	 *         'Sign Out'
	 *       ]
	 *     };
	 *
	 *     $mdPanel.newPanelGroup('menus', {
	 *       maxOpen: 2
	 *     });
	 *
	 *     this.showMenu = function($event, menu) {
	 *       $mdPanel.open('demoPreset', {
	 *         id: 'menu_' + menu.name,
	 *         position: $mdPanel.newPanelPosition()
	 *             .relativeTo($event.target)
	 *             .addPanelPosition(
	 *               $mdPanel.xPosition.ALIGN_START,
	 *               $mdPanel.yPosition.BELOW
	 *             ),
	 *         locals: {
	 *           items: menu.items
	 *         },
	 *         openFrom: $event
	 *       });
	 *     };
	 *   }
	 *
	 *   function PanelMenuCtrl(mdPanelRef) {
	 *     // The controller is provided with an import named 'mdPanelRef'
	 *     this.closeMenu = function() {
	 *       mdPanelRef && mdPanelRef.close();
	 *     };
	 *   }
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanelProvider#definePreset
	 * @description
	 * Takes the passed in preset name and preset configuration object and adds it
	 * to the `_presets` object of the provider. This `_presets` object is then
	 * passed along to the `$mdPanel` service.
	 *
	 * @param {string} name Preset name.
	 * @param {!Object} preset Specific configuration object that can contain any
	 *     and all of the parameters avaialble within the `$mdPanel.create` method.
	 *     However, parameters that pertain to id, position, animation, and user
	 *     interaction are not allowed and will be removed from the preset
	 *     configuration.
	 */
	
	
	/*****************************************************************************
	 *                               MdPanel Service                             *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc service
	 * @name $mdPanel
	 * @module material.components.panel
	 *
	 * @description
	 * `$mdPanel` is a robust, low-level service for creating floating panels on
	 * the screen. It can be used to implement tooltips, dialogs, pop-ups, etc.
	 *
	 * The following types, referenced below, have separate documentation:
	 * - <a href="api/type/MdPanelAnimation">MdPanelAnimation</a> from `$mdPanel.newPanelAnimation()`
	 * - <a href="api/type/MdPanelPosition">MdPanelPosition</a> from `$mdPanel.newPanelPosition()`
	 * - <a href="api/type/MdPanelRef">MdPanelRef</a> from the `$mdPanel.open()` Promise or
	 * injected in the panel's controller
	 *
	 * @usage
	 * <hljs lang="js">
	 * (function(angular, undefined) {
	 *   'use strict';
	 *
	 *   angular
	 *       .module('demoApp', ['ngMaterial'])
	 *       .controller('DemoDialogController', DialogController)
	 *       .controller('DemoCtrl', function($mdPanel) {
	 *
	 *     var panelRef;
	 *
	 *     function showPanel($event) {
	 *       var panelPosition = $mdPanel.newPanelPosition()
	 *           .absolute()
	 *           .top('50%')
	 *           .left('50%');
	 *
	 *       var panelAnimation = $mdPanel.newPanelAnimation()
	 *           .openFrom($event)
	 *           .duration(200)
	 *           .closeTo('.show-button')
	 *           .withAnimation($mdPanel.animation.SCALE);
	 *
	 *       var config = {
	 *         attachTo: angular.element(document.body),
	 *         controller: DialogController,
	 *         controllerAs: 'ctrl',
	 *         position: panelPosition,
	 *         animation: panelAnimation,
	 *         targetEvent: $event,
	 *         templateUrl: 'dialog-template.html',
	 *         clickOutsideToClose: true,
	 *         escapeToClose: true,
	 *         focusOnOpen: true
	 *       };
	 *
	 *       $mdPanel.open(config)
	 *           .then(function(result) {
	 *             panelRef = result;
	 *           });
	 *     }
	 *   }
	 *
	 *   function DialogController(MdPanelRef) {
	 *     function closeDialog() {
	 *       if (MdPanelRef) MdPanelRef.close();
	 *     }
	 *   }
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#create
	 * @description
	 * Creates a panel with the specified options.
	 *
	 * @param config {!Object=} Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `id` - `{string=}`: An ID to track the panel by. When an ID is provided,
	 *     the created panel is added to a tracked panels object. Any subsequent
	 *     requests made to create a panel with that ID are ignored. This is useful
	 *     in having the panel service not open multiple panels from the same user
	 *     interaction when there is no backdrop and events are propagated. Defaults
	 *     to an arbitrary string that is not tracked.
	 *   - `template` - `{string=}`: HTML template to show in the panel. This
	 *     **must** be trusted HTML with respect to AngularJS’s
	 *     [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
	 *   - `templateUrl` - `{string=}`: The URL that will be used as the content of
	 *     the panel.
	 *   - `contentElement` - `{(string|!angular.JQLite|!Element)=}`: Pre-compiled
	 *     element to be used as the panel's content.
	 *   - `controller` - `{(function|string)=}`: The controller to associate with
	 *     the panel. The controller can inject a reference to the returned
	 *     panelRef, which allows the panel to be closed, hidden, and shown. Any
	 *     fields passed in through locals or resolve will be bound to the
	 *     controller.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on
	 *     the scope.
	 *   - `bindToController` - `{boolean=}`: Binds locals to the controller
	 *     instead of passing them in. Defaults to true, as this is a best
	 *     practice.
	 *   - `locals` - `{Object=}`: An object containing key/value pairs. The keys
	 *     will be used as names of values to inject into the controller. For
	 *     example, `locals: {three: 3}` would inject `three` into the controller,
	 *     with the value 3. 'mdPanelRef' is a reserved key, and will always
	 *     be set to the created MdPanelRef instance.
	 *   - `resolve` - `{Object=}`: Similar to locals, except it takes promises as
	 *     values. The panel will not open until all of the promises resolve.
	 *   - `attachTo` - `{(string|!angular.JQLite|!Element)=}`: The element to
	 *     attach the panel to. Defaults to appending to the root element of the
	 *     application.
	 *   - `propagateContainerEvents` - `{boolean=}`: Whether pointer or touch
	 *     events should be allowed to propagate 'go through' the container, aka the
	 *     wrapper, of the panel. Defaults to false.
	 *   - `panelClass` - `{string=}`: A css class to apply to the panel element.
	 *     This class should define any borders, box-shadow, etc. for the panel.
	 *   - `zIndex` - `{number=}`: The z-index to place the panel at.
	 *     Defaults to 80.
	 *   - `position` - `{MdPanelPosition=}`: An MdPanelPosition object that
	 *     specifies the alignment of the panel. For more information, see
	 *     `MdPanelPosition`.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click
	 *     outside the panel to close it. Defaults to false.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to
	 *     close the panel. Defaults to false.
	 *   - `onCloseSuccess` - `{function(!panelRef, string)=}`: Function that is
	 *     called after the close successfully finishes. The first parameter passed
	 *     into this function is the current panelRef and the 2nd is an optional
	 *     string explaining the close reason. The currently supported closeReasons
	 *     can be found in the MdPanelRef.closeReasons enum. These are by default
	 *     passed along by the panel.
	 *   - `trapFocus` - `{boolean=}`: Whether focus should be trapped within the
	 *     panel. If `trapFocus` is true, the user will not be able to interact
	 *     with the rest of the page until the panel is dismissed. Defaults to
	 *     false.
	 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on
	 *     open. Only disable if focusing some other way, as focus management is
	 *     required for panels to be accessible. Defaults to true.
	 *   - `fullscreen` - `{boolean=}`: Whether the panel should be full screen.
	 *     Applies the class `._md-panel-fullscreen` to the panel on open. Defaults
	 *     to false.
	 *   - `animation` - `{MdPanelAnimation=}`: An MdPanelAnimation object that
	 *     specifies the animation of the panel. For more information, see
	 *     `MdPanelAnimation`.
	 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop
	 *     behind the panel. Defaults to false.
	 *   - `disableParentScroll` - `{boolean=}`: Whether the user can scroll the
	 *     page behind the panel. Defaults to false.
	 *   - `onDomAdded` - `{function=}`: Callback function used to announce when
	 *     the panel is added to the DOM.
	 *   - `onOpenComplete` - `{function=}`: Callback function used to announce
	 *     when the open() action is finished.
	 *   - `onRemoving` - `{function=}`: Callback function used to announce the
	 *     close/hide() action is starting.
	 *   - `onDomRemoved` - `{function=}`: Callback function used to announce when
	 *     the panel is removed from the DOM.
	 *   - `origin` - `{(string|!angular.JQLite|!Element)=}`: The element to focus
	 *     on when the panel closes. This is commonly the element which triggered
	 *     the opening of the panel. If you do not use `origin`, you need to control
	 *     the focus manually.
	 *   - `groupName` - `{(string|!Array<string>)=}`: A group name or an array of
	 *     group names. The group name is used for creating a group of panels. The
	 *     group is used for configuring the number of open panels and identifying
	 *     specific behaviors for groups. For instance, all tooltips could be
	 *     identified using the same groupName.
	 *
	 * @returns {!MdPanelRef} panelRef
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#open
	 * @description
	 * Calls the create method above, then opens the panel. This is a shortcut for
	 * creating and then calling open manually. If custom methods need to be
	 * called when the panel is added to the DOM or opened, do not use this method.
	 * Instead create the panel, chain promises on the domAdded and openComplete
	 * methods, and call open from the returned panelRef.
	 *
	 * @param {!Object=} config Specific configuration object that may contain
	 *     the properties defined in `$mdPanel.create`.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} panelRef A promise that resolves
	 *     to an instance of the panel.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelPosition
	 * @description
	 * Returns a new instance of the MdPanelPosition object. Use this to create
	 * the position config object.
	 *
	 * @returns {!MdPanelPosition} panelPosition
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelAnimation
	 * @description
	 * Returns a new instance of the MdPanelAnimation object. Use this to create
	 * the animation config object.
	 *
	 * @returns {!MdPanelAnimation} panelAnimation
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelGroup
	 * @description
	 * Creates a panel group and adds it to a tracked list of panel groups.
	 *
	 * @param {string} groupName Name of the group to create.
	 * @param {!Object=} config Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `maxOpen` - `{number=}`: The maximum number of panels that are allowed to
	 *     be open within a defined panel group.
	 *
	 * @returns {!Object<string,
	 *     {panels: !Array<!MdPanelRef>,
	 *     openPanels: !Array<!MdPanelRef>,
	 *     maxOpen: number}>} panelGroup
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#setGroupMaxOpen
	 * @description
	 * Sets the maximum number of panels in a group that can be opened at a given
	 * time.
	 *
	 * @param {string} groupName The name of the group to configure.
	 * @param {number} maxOpen The maximum number of panels that can be
	 *     opened. Infinity can be passed in to remove the maxOpen limit.
	 */
	
	
	/*****************************************************************************
	 *                                 MdPanelRef                                *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelRef
	 * @module material.components.panel
	 * @description
	 * A reference to a created panel. This reference contains a unique id for the
	 * panel, along with the following properties:
	 *
	 *   - `id` - `{string}`: The unique id for the panel. This id is used to track
	 *     when a panel was interacted with.
	 *   - `config` - `{!Object=}`: The entire config object that was used in
	 *     create.
	 *   - `isAttached` - `{boolean}`: Whether the panel is attached to the DOM.
	 *     Visibility to the user does not factor into isAttached.
	 *   - `panelContainer` - `{angular.JQLite}`: The wrapper element containing the
	 *     panel. This property is added in order to have access to the `addClass`,
	 *     `removeClass`, `toggleClass`, etc methods.
	 *   - `panelEl` - `{angular.JQLite}`: The panel element. This property is added
	 *     in order to have access to the `addClass`, `removeClass`, `toggleClass`,
	 *     etc methods.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#open
	 * @description
	 * Attaches and shows the panel.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     opened.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#close
	 * @description
	 * Hides and detaches the panel. Note that this will **not** destroy the panel.
	 * If you don't intend on using the panel again, call the {@link #destroy
	 * destroy} method afterwards.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     closed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#attach
	 * @description
	 * Create the panel elements and attach them to the DOM. The panel will be
	 * hidden by default.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     attached.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#detach
	 * @description
	 * Removes the panel from the DOM. This will NOT hide the panel before removing
	 * it.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     detached.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#show
	 * @description
	 * Shows the panel.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     shown and animations are completed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#hide
	 * @description
	 * Hides the panel.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     hidden and animations are completed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#destroy
	 * @description
	 * Destroys the panel. The panel cannot be opened again after this is called.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#addClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Adds a class to the panel. DO NOT use this hide/show the panel.
	 *
	 * @param {string} newClass class to be added.
	 * @param {boolean} toElement Whether or not to add the class to the panel
	 *     element instead of the container.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Removes a class from the panel. DO NOT use this to hide/show the panel.
	 *
	 * @param {string} oldClass Class to be removed.
	 * @param {boolean} fromElement Whether or not to remove the class from the
	 *     panel element instead of the container.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#toggleClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Toggles a class on the panel. DO NOT use this to hide/show the panel.
	 *
	 * @param {string} toggleClass Class to be toggled.
	 * @param {boolean} onElement Whether or not to remove the class from the panel
	 *     element instead of the container.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#updatePosition
	 * @description
	 * Updates the position configuration of a panel. Use this to update the
	 * position of a panel that is open, without having to close and re-open the
	 * panel.
	 *
	 * @param {!MdPanelPosition} position
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#addToGroup
	 * @description
	 * Adds a panel to a group if the panel does not exist within the group already.
	 * A panel can only exist within a single group.
	 *
	 * @param {string} groupName The name of the group to add the panel to.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeFromGroup
	 * @description
	 * Removes a panel from a group if the panel exists within that group. The group
	 * must be created ahead of time.
	 *
	 * @param {string} groupName The name of the group.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#registerInterceptor
	 * @description
	 * Registers an interceptor with the panel. The callback should return a promise,
	 * which will allow the action to continue when it gets resolved, or will
	 * prevent an action if it is rejected. The interceptors are called sequentially
	 * and it reverse order. `type` must be one of the following
	 * values available on `$mdPanel.interceptorTypes`:
	 * * `CLOSE` - Gets called before the panel begins closing.
	 *
	 * @param {string} type Type of interceptor.
	 * @param {!angular.$q.Promise<any>} callback Callback to be registered.
	 * @returns {!MdPanelRef}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeInterceptor
	 * @description
	 * Removes a registered interceptor.
	 *
	 * @param {string} type Type of interceptor to be removed.
	 * @param {function(): !angular.$q.Promise<any>} callback Interceptor to be removed.
	 * @returns {!MdPanelRef}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeAllInterceptors
	 * @description
	 * Removes all interceptors. If a type is supplied, only the
	 * interceptors of that type will be cleared.
	 *
	 * @param {string=} type Type of interceptors to be removed.
	 * @returns {!MdPanelRef}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#updateAnimation
	 * @description
	 * Updates the animation configuration for a panel. You can use this to change
	 * the panel's animation without having to re-create it.
	 *
	 * @param {!MdPanelAnimation} animation
	 */
	
	
	/*****************************************************************************
	 *                               MdPanelPosition                            *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelPosition
	 * @module material.components.panel
	 * @description
	 *
	 * Object for configuring the position of the panel.
	 *
	 * @usage
	 *
	 * #### Centering the panel
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition().absolute().center();
	 * </hljs>
	 *
	 * #### Overlapping the panel with an element
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition()
	 *     .relativeTo(someElement)
	 *     .addPanelPosition(
	 *       $mdPanel.xPosition.ALIGN_START,
	 *       $mdPanel.yPosition.ALIGN_TOPS
	 *     );
	 * </hljs>
	 *
	 * #### Aligning the panel with the bottom of an element
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition()
	 *     .relativeTo(someElement)
	 *     .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#absolute
	 * @description
	 * Positions the panel absolutely relative to the parent element. If the parent
	 * is document.body, this is equivalent to positioning the panel absolutely
	 * within the viewport.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#relativeTo
	 * @description
	 * Positions the panel relative to a specific element.
	 *
	 * @param {string|!Element|!angular.JQLite} element Query selector, DOM element,
	 *     or angular element to position the panel with respect to.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#top
	 * @description
	 * Sets the value of `top` for the panel. Clears any previously set vertical
	 * position.
	 *
	 * @param {string=} top Value of `top`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#bottom
	 * @description
	 * Sets the value of `bottom` for the panel. Clears any previously set vertical
	 * position.
	 *
	 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#start
	 * @description
	 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
	 * `rtl`. Clears any previously set horizontal position.
	 *
	 * @param {string=} start Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#end
	 * @description
	 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
	 * Clears any previously set horizontal position.
	 *
	 * @param {string=} end Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#left
	 * @description
	 * Sets the value of `left` for the panel. Clears any previously set
	 * horizontal position.
	 *
	 * @param {string=} left Value of `left`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#right
	 * @description
	 * Sets the value of `right` for the panel. Clears any previously set
	 * horizontal position.
	 *
	 * @param {string=} right Value of `right`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#centerHorizontally
	 * @description
	 * Centers the panel horizontally in the viewport. Clears any previously set
	 * horizontal position.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#centerVertically
	 * @description
	 * Centers the panel vertically in the viewport. Clears any previously set
	 * vertical position.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#center
	 * @description
	 * Centers the panel horizontally and vertically in the viewport. This is
	 * equivalent to calling both `centerHorizontally` and `centerVertically`.
	 * Clears any previously set horizontal and vertical positions.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#addPanelPosition
	 * @description
	 * Sets the x and y position for the panel relative to another element. Can be
	 * called multiple times to specify an ordered list of panel positions. The
	 * first position which allows the panel to be completely on-screen will be
	 * chosen; the last position will be chose whether it is on-screen or not.
	 *
	 * xPosition must be one of the following values available on
	 * $mdPanel.xPosition:
	 *
	 *
	 * CENTER | ALIGN_START | ALIGN_END | OFFSET_START | OFFSET_END
	 *
	 * <pre>
	 *    *************
	 *    *           *
	 *    *   PANEL   *
	 *    *           *
	 *    *************
	 *   A B    C    D E
	 *
	 * A: OFFSET_START (for LTR displays)
	 * B: ALIGN_START (for LTR displays)
	 * C: CENTER
	 * D: ALIGN_END (for LTR displays)
	 * E: OFFSET_END (for LTR displays)
	 * </pre>
	 *
	 * yPosition must be one of the following values available on
	 * $mdPanel.yPosition:
	 *
	 * CENTER | ALIGN_TOPS | ALIGN_BOTTOMS | ABOVE | BELOW
	 *
	 * <pre>
	 *   F
	 *   G *************
	 *     *           *
	 *   H *   PANEL   *
	 *     *           *
	 *   I *************
	 *   J
	 *
	 * F: BELOW
	 * G: ALIGN_TOPS
	 * H: CENTER
	 * I: ALIGN_BOTTOMS
	 * J: ABOVE
	 * </pre>
	 *
	 * @param {string} xPosition
	 * @param {string} yPosition
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#withOffsetX
	 * @description
	 * Sets the value of the offset in the x-direction.
	 *
	 * @param {string|number} offsetX
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#withOffsetY
	 * @description
	 * Sets the value of the offset in the y-direction.
	 *
	 * @param {string|number} offsetY
	 * @returns {!MdPanelPosition}
	 */
	
	
	/*****************************************************************************
	 *                               MdPanelAnimation                            *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelAnimation
	 * @module material.components.panel
	 * @description
	 * Animation configuration object. To use, create an MdPanelAnimation with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * @usage
	 *
	 * <hljs lang="js">
	 * var panelAnimation = new MdPanelAnimation()
	 *     .openFrom(myButtonEl)
	 *     .duration(1337)
	 *     .closeTo('.my-button')
	 *     .withAnimation($mdPanel.animation.SCALE);
	 *
	 * $mdPanel.create({
	 *   animation: panelAnimation
	 * });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#openFrom
	 * @description
	 * Specifies where to start the open animation. `openFrom` accepts a
	 * click event object, query selector, DOM element, or a Rect object that
	 * is used to determine the bounds. When passed a click event, the location
	 * of the click will be used as the position to start the animation.
	 *
	 * @param {string|!Element|!Event|{top: number, left: number}}
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#closeTo
	 * @description
	 * Specifies where to animate the panel close. `closeTo` accepts a
	 * query selector, DOM element, or a Rect object that is used to determine
	 * the bounds.
	 *
	 * @param {string|!Element|{top: number, left: number}}
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#withAnimation
	 * @description
	 * Specifies the animation class.
	 *
	 * There are several default animations that can be used: `$mdPanel.animation.`
	 *  - `SLIDE`: The panel slides in and out from the specified
	 *       elements. It will not fade in or out.
	 *  - `SCALE`: The panel scales in and out. Slide and fade are
	 *       included in this animation.
	 *  - `FADE`: The panel fades in and out.
	 *
	 * Custom classes will by default fade in and out unless
	 * `transition: opacity 1ms` is added to the to custom class.
	 *
	 * @param {string|{open: string, close: string}} cssClass
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#duration
	 * @description
	 * Specifies the duration of the animation in milliseconds. The `duration`
	 * method accepts either a number or an object with separate open and close
	 * durations.
	 *
	 * @param {number|{open: number, close: number}} duration
	 * @returns {!MdPanelAnimation}
	 */
	
	
	/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************/
	
	
	var MD_PANEL_Z_INDEX = 80;
	var MD_PANEL_HIDDEN = '_md-panel-hidden';
	var FOCUS_TRAP_TEMPLATE = angular.element(
	    '<div class="_md-panel-focus-trap" tabindex="0"></div>');
	
	var _presets = {};
	
	
	/**
	 * A provider that is used for creating presets for the panel API.
	 * @final @constructor @ngInject
	 */
	function MdPanelProvider() {
	  return {
	    'definePreset': definePreset,
	    'getAllPresets': getAllPresets,
	    'clearPresets': clearPresets,
	    '$get': $getProvider()
	  };
	}
	
	
	/**
	 * Takes the passed in panel configuration object and adds it to the `_presets`
	 * object at the specified name.
	 * @param {string} name Name of the preset to set.
	 * @param {!Object} preset Specific configuration object that can contain any
	 *     and all of the parameters available within the `$mdPanel.create` method.
	 *     However, parameters that pertain to id, position, animation, and user
	 *     interaction are not allowed and will be removed from the preset
	 *     configuration.
	 */
	function definePreset(name, preset) {
	  if (!name || !preset) {
	    throw new Error('mdPanelProvider: The panel preset definition is ' +
	        'malformed. The name and preset object are required.');
	  } else if (_presets.hasOwnProperty(name)) {
	    throw new Error('mdPanelProvider: The panel preset you have requested ' +
	        'has already been defined.');
	  }
	
	  // Delete any property on the preset that is not allowed.
	  delete preset.id;
	  delete preset.position;
	  delete preset.animation;
	
	  _presets[name] = preset;
	}
	
	
	/**
	 * Gets a clone of the `_presets`.
	 * @return {!Object}
	 */
	function getAllPresets() {
	  return angular.copy(_presets);
	}
	
	
	/**
	 * Clears all of the stored presets.
	 */
	function clearPresets() {
	  _presets = {};
	}
	
	
	/**
	 * Represents the `$get` method of the AngularJS provider. From here, a new
	 * reference to the MdPanelService is returned where the needed arguments are
	 * passed in including the MdPanelProvider `_presets`.
	 * @param {!Object} _presets
	 * @param {!angular.JQLite} $rootElement
	 * @param {!angular.Scope} $rootScope
	 * @param {!angular.$injector} $injector
	 * @param {!angular.$window} $window
	 */
	function $getProvider() {
	  return [
	    '$rootElement', '$rootScope', '$injector', '$window',
	    function($rootElement, $rootScope, $injector, $window) {
	      return new MdPanelService(_presets, $rootElement, $rootScope,
	          $injector, $window);
	    }
	  ];
	}
	
	
	/*****************************************************************************
	 *                               MdPanel Service                             *
	 *****************************************************************************/
	
	
	/**
	 * A service that is used for controlling/displaying panels on the screen.
	 * @param {!Object} presets
	 * @param {!angular.JQLite} $rootElement
	 * @param {!angular.Scope} $rootScope
	 * @param {!angular.$injector} $injector
	 * @param {!angular.$window} $window
	 * @final @constructor @ngInject
	 */
	function MdPanelService(presets, $rootElement, $rootScope, $injector, $window) {
	  /**
	   * Default config options for the panel.
	   * Anything angular related needs to be done later. Therefore
	   *     scope: $rootScope.$new(true),
	   *     attachTo: $rootElement,
	   * are added later.
	   * @private {!Object}
	   */
	  this._defaultConfigOptions = {
	    bindToController: true,
	    clickOutsideToClose: false,
	    disableParentScroll: false,
	    escapeToClose: false,
	    focusOnOpen: true,
	    fullscreen: false,
	    hasBackdrop: false,
	    propagateContainerEvents: false,
	    transformTemplate: angular.bind(this, this._wrapTemplate),
	    trapFocus: false,
	    zIndex: MD_PANEL_Z_INDEX
	  };
	
	  /** @private {!Object} */
	  this._config = {};
	
	  /** @private {!Object} */
	  this._presets = presets;
	
	  /** @private @const */
	  this._$rootElement = $rootElement;
	
	  /** @private @const */
	  this._$rootScope = $rootScope;
	
	  /** @private @const */
	  this._$injector = $injector;
	
	  /** @private @const */
	  this._$window = $window;
	
	  /** @private @const */
	  this._$mdUtil = this._$injector.get('$mdUtil');
	
	  /** @private {!Object<string, !MdPanelRef>} */
	  this._trackedPanels = {};
	
	  /**
	   * @private {!Object<string,
	   *     {panels: !Array<!MdPanelRef>,
	   *     openPanels: !Array<!MdPanelRef>,
	   *     maxOpen: number}>}
	   */
	  this._groups = Object.create(null);
	
	  /**
	   * Default animations that can be used within the panel.
	   * @type {enum}
	   */
	  this.animation = MdPanelAnimation.animation;
	
	  /**
	   * Possible values of xPosition for positioning the panel relative to
	   * another element.
	   * @type {enum}
	   */
	  this.xPosition = MdPanelPosition.xPosition;
	
	  /**
	   * Possible values of yPosition for positioning the panel relative to
	   * another element.
	   * @type {enum}
	   */
	  this.yPosition = MdPanelPosition.yPosition;
	
	  /**
	   * Possible values for the interceptors that can be registered on a panel.
	   * @type {enum}
	   */
	  this.interceptorTypes = MdPanelRef.interceptorTypes;
	
	  /**
	   * Possible values for closing of a panel.
	   * @type {enum}
	   */
	  this.closeReasons = MdPanelRef.closeReasons;
	
	  /**
	   * Possible values of absolute position.
	   * @type {enum}
	   */
	  this.absPosition = MdPanelPosition.absPosition;
	}
	
	
	/**
	 * Creates a panel with the specified options.
	 * @param {string=} preset Name of a preset configuration that can be used to
	 *     extend the panel configuration.
	 * @param {!Object=} config Configuration object for the panel.
	 * @returns {!MdPanelRef}
	 */
	MdPanelService.prototype.create = function(preset, config) {
	  if (typeof preset === 'string') {
	    preset = this._getPresetByName(preset);
	  } else if (typeof preset === 'object' &&
	      (angular.isUndefined(config) || !config)) {
	    config = preset;
	    preset = {};
	  }
	
	  preset = preset || {};
	  config = config || {};
	
	  // If the passed-in config contains an ID and the ID is within _trackedPanels,
	  // return the tracked panel after updating its config with the passed-in
	  // config.
	  if (angular.isDefined(config.id) && this._trackedPanels[config.id]) {
	    var trackedPanel = this._trackedPanels[config.id];
	    angular.extend(trackedPanel.config, config);
	    return trackedPanel;
	  }
	
	  // Combine the passed-in config, the _defaultConfigOptions, and the preset
	  // configuration into the `_config`.
	  this._config = angular.extend({
	    // If no ID is set within the passed-in config, then create an arbitrary ID.
	    id: config.id || 'panel_' + this._$mdUtil.nextUid(),
	    scope: this._$rootScope.$new(true),
	    attachTo: this._$rootElement
	  }, this._defaultConfigOptions, config, preset);
	
	  // Create the panelRef and add it to the `_trackedPanels` object.
	  var panelRef = new MdPanelRef(this._config, this._$injector);
	  this._trackedPanels[config.id] = panelRef;
	
	  // Add the panel to each of its requested groups.
	  if (this._config.groupName) {
	    if (angular.isString(this._config.groupName)) {
	      this._config.groupName = [this._config.groupName];
	    }
	    angular.forEach(this._config.groupName, function(group) {
	      panelRef.addToGroup(group);
	    });
	  }
	
	  this._config.scope.$on('$destroy', angular.bind(panelRef, panelRef.detach));
	
	  return panelRef;
	};
	
	
	/**
	 * Creates and opens a panel with the specified options.
	 * @param {string=} preset Name of a preset configuration that can be used to
	 *     extend the panel configuration.
	 * @param {!Object=} config Configuration object for the panel.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} The panel created from create.
	 */
	MdPanelService.prototype.open = function(preset, config) {
	  var panelRef = this.create(preset, config);
	  return panelRef.open().then(function() {
	    return panelRef;
	  });
	};
	
	
	/**
	 * Gets a specific preset configuration object saved within `_presets`.
	 * @param {string} preset Name of the preset to search for.
	 * @returns {!Object} The preset configuration object.
	 */
	MdPanelService.prototype._getPresetByName = function(preset) {
	  if (!this._presets[preset]) {
	    throw new Error('mdPanel: The panel preset configuration that you ' +
	        'requested does not exist. Use the $mdPanelProvider to create a ' +
	        'preset before requesting one.');
	  }
	  return this._presets[preset];
	};
	
	
	/**
	 * Returns a new instance of the MdPanelPosition. Use this to create the
	 * positioning object.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelService.prototype.newPanelPosition = function() {
	  return new MdPanelPosition(this._$injector);
	};
	
	
	/**
	 * Returns a new instance of the MdPanelAnimation. Use this to create the
	 * animation object.
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelService.prototype.newPanelAnimation = function() {
	  return new MdPanelAnimation(this._$injector);
	};
	
	
	/**
	 * Creates a panel group and adds it to a tracked list of panel groups.
	 * @param groupName {string} Name of the group to create.
	 * @param config {!Object=} Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `maxOpen` - `{number=}`: The maximum number of panels that are allowed
	 *     open within a defined panel group.
	 *
	 * @returns {!Object<string,
	 *     {panels: !Array<!MdPanelRef>,
	 *     openPanels: !Array<!MdPanelRef>,
	 *     maxOpen: number}>} panelGroup
	 */
	MdPanelService.prototype.newPanelGroup = function(groupName, config) {
	  if (!this._groups[groupName]) {
	    config = config || {};
	    var group = {
	      panels: [],
	      openPanels: [],
	      maxOpen: config.maxOpen > 0 ? config.maxOpen : Infinity
	    };
	    this._groups[groupName] = group;
	  }
	  return this._groups[groupName];
	};
	
	
	/**
	 * Sets the maximum number of panels in a group that can be opened at a given
	 * time.
	 * @param {string} groupName The name of the group to configure.
	 * @param {number} maxOpen The maximum number of panels that can be
	 *     opened. Infinity can be passed in to remove the maxOpen limit.
	 */
	MdPanelService.prototype.setGroupMaxOpen = function(groupName, maxOpen) {
	  if (this._groups[groupName]) {
	    this._groups[groupName].maxOpen = maxOpen;
	  } else {
	    throw new Error('mdPanel: Group does not exist yet. Call newPanelGroup().');
	  }
	};
	
	
	/**
	 * Determines if the current number of open panels within a group exceeds the
	 * limit of allowed open panels.
	 * @param {string} groupName The name of the group to check.
	 * @returns {boolean} true if open count does exceed maxOpen and false if not.
	 * @private
	 */
	MdPanelService.prototype._openCountExceedsMaxOpen = function(groupName) {
	  if (this._groups[groupName]) {
	    var group = this._groups[groupName];
	    return group.maxOpen > 0 && group.openPanels.length > group.maxOpen;
	  }
	  return false;
	};
	
	
	/**
	 * Closes the first open panel within a specific group.
	 * @param {string} groupName The name of the group.
	 * @private
	 */
	MdPanelService.prototype._closeFirstOpenedPanel = function(groupName) {
	  this._groups[groupName].openPanels[0].close();
	};
	
	
	/**
	 * Wraps the users template in two elements, md-panel-outer-wrapper, which
	 * covers the entire attachTo element, and md-panel, which contains only the
	 * template. This allows the panel control over positioning, animations,
	 * and similar properties.
	 * @param {string} origTemplate The original template.
	 * @returns {string} The wrapped template.
	 * @private
	 */
	MdPanelService.prototype._wrapTemplate = function(origTemplate) {
	  var template = origTemplate || '';
	
	  // The panel should be initially rendered offscreen so we can calculate
	  // height and width for positioning.
	  return '' +
	      '<div class="md-panel-outer-wrapper">' +
	      '  <div class="md-panel _md-panel-offscreen">' + template + '</div>' +
	      '</div>';
	};
	
	
	/**
	 * Wraps a content element in a md-panel-outer wrapper and
	 * positions it off-screen. Allows for proper control over positoning
	 * and animations.
	 * @param {!angular.JQLite} contentElement Element to be wrapped.
	 * @return {!angular.JQLite} Wrapper element.
	 * @private
	 */
	MdPanelService.prototype._wrapContentElement = function(contentElement) {
	  var wrapper = angular.element('<div class="md-panel-outer-wrapper">');
	
	  contentElement.addClass('md-panel _md-panel-offscreen');
	  wrapper.append(contentElement);
	
	  return wrapper;
	};
	
	
	/*****************************************************************************
	 *                                 MdPanelRef                                *
	 *****************************************************************************/
	
	
	/**
	 * A reference to a created panel. This reference contains a unique id for the
	 * panel, along with properties/functions used to control the panel.
	 * @param {!Object} config
	 * @param {!angular.$injector} $injector
	 * @final @constructor
	 */
	function MdPanelRef(config, $injector) {
	  // Injected variables.
	  /** @private @const {!angular.$q} */
	  this._$q = $injector.get('$q');
	
	  /** @private @const {!angular.$mdCompiler} */
	  this._$mdCompiler = $injector.get('$mdCompiler');
	
	  /** @private @const {!angular.$mdConstant} */
	  this._$mdConstant = $injector.get('$mdConstant');
	
	  /** @private @const {!angular.$mdUtil} */
	  this._$mdUtil = $injector.get('$mdUtil');
	
	  /** @private @const {!angular.$mdTheming} */
	  this._$mdTheming = $injector.get('$mdTheming');
	
	  /** @private @const {!angular.Scope} */
	  this._$rootScope = $injector.get('$rootScope');
	
	  /** @private @const {!angular.$animate} */
	  this._$animate = $injector.get('$animate');
	
	  /** @private @const {!MdPanelRef} */
	  this._$mdPanel = $injector.get('$mdPanel');
	
	  /** @private @const {!angular.$log} */
	  this._$log = $injector.get('$log');
	
	  /** @private @const {!angular.$window} */
	  this._$window = $injector.get('$window');
	
	  /** @private @const {!Function} */
	  this._$$rAF = $injector.get('$$rAF');
	
	  // Public variables.
	  /**
	   * Unique id for the panelRef.
	   * @type {string}
	   */
	  this.id = config.id;
	
	  /** @type {!Object} */
	  this.config = config;
	
	  /** @type {!angular.JQLite|undefined} */
	  this.panelContainer;
	
	  /** @type {!angular.JQLite|undefined} */
	  this.panelEl;
	
	  /**
	   * Whether the panel is attached. This is synchronous. When attach is called,
	   * isAttached is set to true. When detach is called, isAttached is set to
	   * false.
	   * @type {boolean}
	   */
	  this.isAttached = false;
	
	  // Private variables.
	  /** @private {Array<function()>} */
	  this._removeListeners = [];
	
	  /** @private {!angular.JQLite|undefined} */
	  this._topFocusTrap;
	
	  /** @private {!angular.JQLite|undefined} */
	  this._bottomFocusTrap;
	
	  /** @private {!$mdPanel|undefined} */
	  this._backdropRef;
	
	  /** @private {Function?} */
	  this._restoreScroll = null;
	
	  /**
	   * Keeps track of all the panel interceptors.
	   * @private {!Object}
	   */
	  this._interceptors = Object.create(null);
	
	  /**
	   * Cleanup function, provided by `$mdCompiler` and assigned after the element
	   * has been compiled. When `contentElement` is used, the function is used to
	   * restore the element to it's proper place in the DOM.
	   * @private {!Function}
	   */
	  this._compilerCleanup = null;
	
	  /**
	   * Cache for saving and restoring element inline styles, CSS classes etc.
	   * @type {{styles: string, classes: string}}
	   */
	  this._restoreCache = {
	    styles: '',
	    classes: ''
	  };
	}
	
	
	MdPanelRef.interceptorTypes = {
	  CLOSE: 'onClose'
	};
	
	
	/**
	 * Opens an already created and configured panel. If the panel is already
	 * visible, does nothing.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is opened and animations finish.
	 */
	MdPanelRef.prototype.open = function() {
	  var self = this;
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var show = self._simpleBind(self.show, self);
	    var checkGroupMaxOpen = function() {
	      if (self.config.groupName) {
	        angular.forEach(self.config.groupName, function(group) {
	          if (self._$mdPanel._openCountExceedsMaxOpen(group)) {
	            self._$mdPanel._closeFirstOpenedPanel(group);
	          }
	        });
	      }
	    };
	
	    self.attach()
	        .then(show)
	        .then(checkGroupMaxOpen)
	        .then(done)
	        .catch(reject);
	  });
	};
	
	
	/**
	 * Closes the panel.
	 * @param {string} closeReason The event type that triggered the close.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is closed and animations finish.
	 */
	MdPanelRef.prototype.close = function(closeReason) {
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    self._callInterceptors(MdPanelRef.interceptorTypes.CLOSE).then(function() {
	      var done = self._done(resolve, self);
	      var detach = self._simpleBind(self.detach, self);
	      var onCloseSuccess = self.config['onCloseSuccess'] || angular.noop;
	      onCloseSuccess = angular.bind(self, onCloseSuccess, self, closeReason);
	
	      self.hide()
	          .then(detach)
	          .then(done)
	          .then(onCloseSuccess)
	          .catch(reject);
	    }, reject);
	  });
	};
	
	
	/**
	 * Attaches the panel. The panel will be hidden afterwards.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is attached.
	 */
	MdPanelRef.prototype.attach = function() {
	  if (this.isAttached && this.panelEl) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onDomAdded = self.config['onDomAdded'] || angular.noop;
	    var addListeners = function(response) {
	      self.isAttached = true;
	      self._addEventListeners();
	      return response;
	    };
	
	    self._$q.all([
	        self._createBackdrop(),
	        self._createPanel()
	            .then(addListeners)
	            .catch(reject)
	    ]).then(onDomAdded)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Only detaches the panel. Will NOT hide the panel first.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is detached.
	 */
	MdPanelRef.prototype.detach = function() {
	  if (!this.isAttached) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  var onDomRemoved = self.config['onDomRemoved'] || angular.noop;
	
	  var detachFn = function() {
	    self._removeEventListeners();
	
	    // Remove the focus traps that we added earlier for keeping focus within
	    // the panel.
	    if (self._topFocusTrap && self._topFocusTrap.parentNode) {
	      self._topFocusTrap.parentNode.removeChild(self._topFocusTrap);
	    }
	
	    if (self._bottomFocusTrap && self._bottomFocusTrap.parentNode) {
	      self._bottomFocusTrap.parentNode.removeChild(self._bottomFocusTrap);
	    }
	
	    if (self._restoreCache.classes) {
	      self.panelEl[0].className = self._restoreCache.classes;
	    }
	
	    // Either restore the saved styles or clear the ones set by mdPanel.
	    self.panelEl[0].style.cssText = self._restoreCache.styles || '';
	
	    self._compilerCleanup();
	    self.panelContainer.remove();
	    self.isAttached = false;
	    return self._$q.when(self);
	  };
	
	  if (this._restoreScroll) {
	    this._restoreScroll();
	    this._restoreScroll = null;
	  }
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	
	    self._$q.all([
	      detachFn(),
	      self._backdropRef ? self._backdropRef.detach() : true
	    ]).then(onDomRemoved)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Destroys the panel. The Panel cannot be opened again after this.
	 */
	MdPanelRef.prototype.destroy = function() {
	  var self = this;
	  if (this.config.groupName) {
	    angular.forEach(this.config.groupName, function(group) {
	      self.removeFromGroup(group);
	    });
	  }
	  this.config.scope.$destroy();
	  this.config.locals = null;
	  this.config.onDomAdded = null;
	  this.config.onDomRemoved = null;
	  this.config.onRemoving = null;
	  this.config.onOpenComplete = null;
	  this._interceptors = null;
	};
	
	
	/**
	 * Shows the panel.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel has shown and animations finish.
	 */
	MdPanelRef.prototype.show = function() {
	  if (!this.panelContainer) {
	    return this._$q(function(resolve, reject) {
	      reject('mdPanel: Panel does not exist yet. Call open() or attach().');
	    });
	  }
	
	  if (!this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  var animatePromise = function() {
	    self.panelContainer.removeClass(MD_PANEL_HIDDEN);
	    return self._animateOpen();
	  };
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onOpenComplete = self.config['onOpenComplete'] || angular.noop;
	    var addToGroupOpen = function() {
	      if (self.config.groupName) {
	        angular.forEach(self.config.groupName, function(group) {
	          self._$mdPanel._groups[group].openPanels.push(self);
	        });
	      }
	    };
	
	    self._$q.all([
	      self._backdropRef ? self._backdropRef.show() : self,
	      animatePromise().then(function() { self._focusOnOpen(); }, reject)
	    ]).then(onOpenComplete)
	      .then(addToGroupOpen)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Hides the panel.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel has hidden and animations finish.
	 */
	MdPanelRef.prototype.hide = function() {
	  if (!this.panelContainer) {
	    return this._$q(function(resolve, reject) {
	      reject('mdPanel: Panel does not exist yet. Call open() or attach().');
	    });
	  }
	
	  if (this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onRemoving = self.config['onRemoving'] || angular.noop;
	    var hidePanel = function() {
	      self.panelContainer.addClass(MD_PANEL_HIDDEN);
	    };
	    var removeFromGroupOpen = function() {
	      if (self.config.groupName) {
	        var group, index;
	        angular.forEach(self.config.groupName, function(group) {
	          group = self._$mdPanel._groups[group];
	          index = group.openPanels.indexOf(self);
	          if (index > -1) {
	            group.openPanels.splice(index, 1);
	          }
	        });
	      }
	    };
	    var focusOnOrigin = function() {
	      var origin = self.config['origin'];
	      if (origin) {
	        getElement(origin).focus();
	      }
	    };
	
	    self._$q.all([
	      self._backdropRef ? self._backdropRef.hide() : self,
	      self._animateClose()
	          .then(onRemoving)
	          .then(hidePanel)
	          .then(removeFromGroupOpen)
	          .then(focusOnOrigin)
	          .catch(reject)
	    ]).then(done, reject);
	  });
	};
	
	
	/**
	 * Add a class to the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} newClass Class to be added.
	 * @param {boolean} toElement Whether or not to add the class to the panel
	 *     element instead of the container.
	 */
	MdPanelRef.prototype.addClass = function(newClass, toElement) {
	  this._$log.warn(
	      'mdPanel: The addClass method is in the process of being deprecated. ' +
	      'Full deprecation is scheduled for the AngularJS Material 1.2 release. ' +
	      'To achieve the same results, use the panelContainer or panelEl ' +
	      'JQLite elements that are referenced in MdPanelRef.');
	
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  if (!toElement && !this.panelContainer.hasClass(newClass)) {
	    this.panelContainer.addClass(newClass);
	  } else if (toElement && !this.panelEl.hasClass(newClass)) {
	    this.panelEl.addClass(newClass);
	  }
	};
	
	
	/**
	 * Remove a class from the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} oldClass Class to be removed.
	 * @param {boolean} fromElement Whether or not to remove the class from the
	 *     panel element instead of the container.
	 */
	MdPanelRef.prototype.removeClass = function(oldClass, fromElement) {
	  this._$log.warn(
	      'mdPanel: The removeClass method is in the process of being deprecated. ' +
	      'Full deprecation is scheduled for the AngularJS Material 1.2 release. ' +
	      'To achieve the same results, use the panelContainer or panelEl ' +
	      'JQLite elements that are referenced in MdPanelRef.');
	
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  if (!fromElement && this.panelContainer.hasClass(oldClass)) {
	    this.panelContainer.removeClass(oldClass);
	  } else if (fromElement && this.panelEl.hasClass(oldClass)) {
	    this.panelEl.removeClass(oldClass);
	  }
	};
	
	
	/**
	 * Toggle a class on the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} toggleClass The class to toggle.
	 * @param {boolean} onElement Whether or not to toggle the class on the panel
	 *     element instead of the container.
	 */
	MdPanelRef.prototype.toggleClass = function(toggleClass, onElement) {
	  this._$log.warn(
	      'mdPanel: The toggleClass method is in the process of being deprecated. ' +
	      'Full deprecation is scheduled for the AngularJS Material 1.2 release. ' +
	      'To achieve the same results, use the panelContainer or panelEl ' +
	      'JQLite elements that are referenced in MdPanelRef.');
	
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  if (!onElement) {
	    this.panelContainer.toggleClass(toggleClass);
	  } else {
	    this.panelEl.toggleClass(toggleClass);
	  }
	};
	
	
	/**
	 * Compiles the panel, according to the passed in config and appends it to
	 * the DOM. Helps normalize differences in the compilation process between
	 * using a string template and a content element.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} Promise that is resolved when
	 *     the element has been compiled and added to the DOM.
	 * @private
	 */
	MdPanelRef.prototype._compile = function() {
	  var self = this;
	
	  // Compile the element via $mdCompiler. Note that when using a
	  // contentElement, the element isn't actually being compiled, rather the
	  // compiler saves it's place in the DOM and provides a way of restoring it.
	  return self._$mdCompiler.compile(self.config).then(function(compileData) {
	    var config = self.config;
	
	    if (config.contentElement) {
	      var panelEl = compileData.element;
	
	      // Since mdPanel modifies the inline styles and CSS classes, we need
	      // to save them in order to be able to restore on close.
	      self._restoreCache.styles = panelEl[0].style.cssText;
	      self._restoreCache.classes = panelEl[0].className;
	
	      self.panelContainer = self._$mdPanel._wrapContentElement(panelEl);
	      self.panelEl = panelEl;
	    } else {
	      self.panelContainer = compileData.link(config['scope']);
	      self.panelEl = angular.element(
	        self.panelContainer[0].querySelector('.md-panel')
	      );
	    }
	
	    // Save a reference to the cleanup function from the compiler.
	    self._compilerCleanup = compileData.cleanup;
	
	    // Attach the panel to the proper place in the DOM.
	    getElement(self.config['attachTo']).append(self.panelContainer);
	
	    return self;
	  });
	};
	
	
	/**
	 * Creates a panel and adds it to the dom.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     created.
	 * @private
	 */
	MdPanelRef.prototype._createPanel = function() {
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    if (!self.config.locals) {
	      self.config.locals = {};
	    }
	
	    self.config.locals.mdPanelRef = self;
	
	    self._compile().then(function() {
	      if (self.config['disableParentScroll']) {
	        self._restoreScroll = self._$mdUtil.disableScrollAround(
	          null,
	          self.panelContainer,
	          { disableScrollMask: true }
	        );
	      }
	
	      // Add a custom CSS class to the panel element.
	      if (self.config['panelClass']) {
	        self.panelEl.addClass(self.config['panelClass']);
	      }
	
	      // Handle click and touch events for the panel container.
	      if (self.config['propagateContainerEvents']) {
	        self.panelContainer.css('pointer-events', 'none');
	        self.panelEl.css('pointer-events', 'all');
	      }
	
	      // Panel may be outside the $rootElement, tell ngAnimate to animate
	      // regardless.
	      if (self._$animate.pin) {
	        self._$animate.pin(
	          self.panelContainer,
	          getElement(self.config['attachTo'])
	        );
	      }
	
	      self._configureTrapFocus();
	      self._addStyles().then(function() {
	        resolve(self);
	      }, reject);
	    }, reject);
	
	  });
	};
	
	
	/**
	 * Adds the styles for the panel, such as positioning and z-index. Also,
	 * themes the panel element and panel container using `$mdTheming`.
	 * @returns {!angular.$q.Promise<!MdPanelRef>}
	 * @private
	 */
	MdPanelRef.prototype._addStyles = function() {
	  var self = this;
	  return this._$q(function(resolve) {
	    self.panelContainer.css('z-index', self.config['zIndex']);
	    self.panelEl.css('z-index', self.config['zIndex'] + 1);
	
	    var hideAndResolve = function() {
	      // Theme the element and container.
	      self._setTheming();
	
	      // Remove offscreen class and add hidden class.
	      self.panelEl.removeClass('_md-panel-offscreen');
	      self.panelContainer.addClass(MD_PANEL_HIDDEN);
	
	      resolve(self);
	    };
	
	    if (self.config['fullscreen']) {
	      self.panelEl.addClass('_md-panel-fullscreen');
	      hideAndResolve();
	      return; // Don't setup positioning.
	    }
	
	    var positionConfig = self.config['position'];
	    if (!positionConfig) {
	      hideAndResolve();
	      return; // Don't setup positioning.
	    }
	
	    // Wait for angular to finish processing the template
	    self._$rootScope['$$postDigest'](function() {
	      // Position it correctly. This is necessary so that the panel will have a
	      // defined height and width.
	      self._updatePosition(true);
	
	      // Theme the element and container.
	      self._setTheming();
	
	      resolve(self);
	    });
	  });
	};
	
	
	/**
	 * Sets the `$mdTheming` classes on the `panelContainer` and `panelEl`.
	 * @private
	 */
	MdPanelRef.prototype._setTheming = function() {
	  this._$mdTheming(this.panelEl);
	  this._$mdTheming(this.panelContainer);
	};
	
	
	/**
	 * Updates the position configuration of a panel
	 * @param {!MdPanelPosition} position
	 */
	MdPanelRef.prototype.updatePosition = function(position) {
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  this.config['position'] = position;
	  this._updatePosition();
	};
	
	
	/**
	 * Calculates and updates the position of the panel.
	 * @param {boolean=} init
	 * @private
	 */
	MdPanelRef.prototype._updatePosition = function(init) {
	  var positionConfig = this.config['position'];
	
	  if (positionConfig) {
	    positionConfig._setPanelPosition(this.panelEl);
	
	    // Hide the panel now that position is known.
	    if (init) {
	      this.panelEl.removeClass('_md-panel-offscreen');
	      this.panelContainer.addClass(MD_PANEL_HIDDEN);
	    }
	
	    this.panelEl.css(
	      MdPanelPosition.absPosition.TOP,
	      positionConfig.getTop()
	    );
	    this.panelEl.css(
	      MdPanelPosition.absPosition.BOTTOM,
	      positionConfig.getBottom()
	    );
	    this.panelEl.css(
	      MdPanelPosition.absPosition.LEFT,
	      positionConfig.getLeft()
	    );
	    this.panelEl.css(
	      MdPanelPosition.absPosition.RIGHT,
	      positionConfig.getRight()
	    );
	  }
	};
	
	
	/**
	 * Focuses on the panel or the first focus target.
	 * @private
	 */
	MdPanelRef.prototype._focusOnOpen = function() {
	  if (this.config['focusOnOpen']) {
	    // Wait for the template to finish rendering to guarantee md-autofocus has
	    // finished adding the class md-autofocus, otherwise the focusable element
	    // isn't available to focus.
	    var self = this;
	    this._$rootScope['$$postDigest'](function() {
	      var target = self._$mdUtil.findFocusTarget(self.panelEl) ||
	          self.panelEl;
	      target.focus();
	    });
	  }
	};
	
	
	/**
	 * Shows the backdrop.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the backdrop
	 *     is created and attached.
	 * @private
	 */
	MdPanelRef.prototype._createBackdrop = function() {
	  if (this.config.hasBackdrop) {
	    if (!this._backdropRef) {
	      var backdropAnimation = this._$mdPanel.newPanelAnimation()
	          .openFrom(this.config.attachTo)
	          .withAnimation({
	            open: '_md-opaque-enter',
	            close: '_md-opaque-leave'
	          });
	
	      if (this.config.animation) {
	        backdropAnimation.duration(this.config.animation._rawDuration);
	      }
	
	      var backdropConfig = {
	        animation: backdropAnimation,
	        attachTo: this.config.attachTo,
	        focusOnOpen: false,
	        panelClass: '_md-panel-backdrop',
	        zIndex: this.config.zIndex - 1
	      };
	
	      this._backdropRef = this._$mdPanel.create(backdropConfig);
	    }
	    if (!this._backdropRef.isAttached) {
	      return this._backdropRef.attach();
	    }
	  }
	};
	
	
	/**
	 * Listen for escape keys and outside clicks to auto close.
	 * @private
	 */
	MdPanelRef.prototype._addEventListeners = function() {
	  this._configureEscapeToClose();
	  this._configureClickOutsideToClose();
	  this._configureScrollListener();
	};
	
	
	/**
	 * Remove event listeners added in _addEventListeners.
	 * @private
	 */
	MdPanelRef.prototype._removeEventListeners = function() {
	  this._removeListeners && this._removeListeners.forEach(function(removeFn) {
	    removeFn();
	  });
	  this._removeListeners = [];
	};
	
	
	/**
	 * Setup the escapeToClose event listeners.
	 * @private
	 */
	MdPanelRef.prototype._configureEscapeToClose = function() {
	  if (this.config['escapeToClose']) {
	    var parentTarget = getElement(this.config['attachTo']);
	    var self = this;
	
	    var keyHandlerFn = function(ev) {
	      if (ev.keyCode === self._$mdConstant.KEY_CODE.ESCAPE) {
	        ev.stopPropagation();
	        ev.preventDefault();
	
	        self.close(MdPanelRef.closeReasons.ESCAPE);
	      }
	    };
	
	    // Add keydown listeners
	    this.panelContainer.on('keydown', keyHandlerFn);
	    parentTarget.on('keydown', keyHandlerFn);
	
	    // Queue remove listeners function
	    this._removeListeners.push(function() {
	      self.panelContainer.off('keydown', keyHandlerFn);
	      parentTarget.off('keydown', keyHandlerFn);
	    });
	  }
	};
	
	
	/**
	 * Setup the clickOutsideToClose event listeners.
	 * @private
	 */
	MdPanelRef.prototype._configureClickOutsideToClose = function() {
	  if (this.config['clickOutsideToClose']) {
	    var target = this.config['propagateContainerEvents'] ?
	        angular.element(document.body) :
	        this.panelContainer;
	    var sourceEl;
	
	    // Keep track of the element on which the mouse originally went down
	    // so that we can only close the backdrop when the 'click' started on it.
	    // A simple 'click' handler does not work, it sets the target object as the
	    // element the mouse went down on.
	    var mousedownHandler = function(ev) {
	      sourceEl = ev.target;
	    };
	
	    // We check if our original element and the target is the backdrop
	    // because if the original was the backdrop and the target was inside the
	    // panel we don't want to panel to close.
	    var self = this;
	    var mouseupHandler = function(ev) {
	      if (self.config['propagateContainerEvents']) {
	
	        // We check if the sourceEl of the event is the panel element or one
	        // of it's children. If it is not, then close the panel.
	        if (sourceEl !== self.panelEl[0] && !self.panelEl[0].contains(sourceEl)) {
	          self.close();
	        }
	
	      } else if (sourceEl === target[0] && ev.target === target[0]) {
	        ev.stopPropagation();
	        ev.preventDefault();
	
	        self.close(MdPanelRef.closeReasons.CLICK_OUTSIDE);
	      }
	    };
	
	    // Add listeners
	    target.on('mousedown', mousedownHandler);
	    target.on('mouseup', mouseupHandler);
	
	    // Queue remove listeners function
	    this._removeListeners.push(function() {
	      target.off('mousedown', mousedownHandler);
	      target.off('mouseup', mouseupHandler);
	    });
	  }
	};
	
	
	/**
	 * Configures the listeners for updating the panel position on scroll.
	 * @private
	*/
	MdPanelRef.prototype._configureScrollListener = function() {
	  // No need to bind the event if scrolling is disabled.
	  if (!this.config['disableParentScroll']) {
	    var updatePosition = angular.bind(this, this._updatePosition);
	    var debouncedUpdatePosition = this._$$rAF.throttle(updatePosition);
	    var self = this;
	
	    var onScroll = function() {
	      debouncedUpdatePosition();
	    };
	
	    // Add listeners.
	    this._$window.addEventListener('scroll', onScroll, true);
	
	    // Queue remove listeners function.
	    this._removeListeners.push(function() {
	      self._$window.removeEventListener('scroll', onScroll, true);
	    });
	  }
	};
	
	
	/**
	 * Setup the focus traps. These traps will wrap focus when tabbing past the
	 * panel. When shift-tabbing, the focus will stick in place.
	 * @private
	 */
	MdPanelRef.prototype._configureTrapFocus = function() {
	  // Focus doesn't remain inside of the panel without this.
	  this.panelEl.attr('tabIndex', '-1');
	  if (this.config['trapFocus']) {
	    var element = this.panelEl;
	    // Set up elements before and after the panel to capture focus and
	    // redirect back into the panel.
	    this._topFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];
	    this._bottomFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];
	
	    // When focus is about to move out of the panel, we want to intercept it
	    // and redirect it back to the panel element.
	    var focusHandler = function() {
	      element.focus();
	    };
	    this._topFocusTrap.addEventListener('focus', focusHandler);
	    this._bottomFocusTrap.addEventListener('focus', focusHandler);
	
	    // Queue remove listeners function
	    this._removeListeners.push(this._simpleBind(function() {
	      this._topFocusTrap.removeEventListener('focus', focusHandler);
	      this._bottomFocusTrap.removeEventListener('focus', focusHandler);
	    }, this));
	
	    // The top focus trap inserted immediately before the md-panel element (as
	    // a sibling). The bottom focus trap inserted immediately after the
	    // md-panel element (as a sibling).
	    element[0].parentNode.insertBefore(this._topFocusTrap, element[0]);
	    element.after(this._bottomFocusTrap);
	  }
	};
	
	
	/**
	 * Updates the animation of a panel.
	 * @param {!MdPanelAnimation} animation
	 */
	MdPanelRef.prototype.updateAnimation = function(animation) {
	  this.config['animation'] = animation;
	
	  if (this._backdropRef) {
	    this._backdropRef.config.animation.duration(animation._rawDuration);
	  }
	};
	
	
	/**
	 * Animate the panel opening.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     animated open.
	 * @private
	 */
	MdPanelRef.prototype._animateOpen = function() {
	  this.panelContainer.addClass('md-panel-is-showing');
	  var animationConfig = this.config['animation'];
	  if (!animationConfig) {
	    // Promise is in progress, return it.
	    this.panelContainer.addClass('_md-panel-shown');
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  return this._$q(function(resolve) {
	    var done = self._done(resolve, self);
	    var warnAndOpen = function() {
	      self._$log.warn(
	          'mdPanel: MdPanel Animations failed. ' +
	          'Showing panel without animating.');
	      done();
	    };
	
	    animationConfig.animateOpen(self.panelEl)
	        .then(done, warnAndOpen);
	  });
	};
	
	
	/**
	 * Animate the panel closing.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     animated closed.
	 * @private
	 */
	MdPanelRef.prototype._animateClose = function() {
	  var animationConfig = this.config['animation'];
	  if (!animationConfig) {
	    this.panelContainer.removeClass('md-panel-is-showing');
	    this.panelContainer.removeClass('_md-panel-shown');
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  return this._$q(function(resolve) {
	    var done = function() {
	      self.panelContainer.removeClass('md-panel-is-showing');
	      resolve(self);
	    };
	    var warnAndClose = function() {
	      self._$log.warn(
	          'mdPanel: MdPanel Animations failed. ' +
	          'Hiding panel without animating.');
	      done();
	    };
	
	    animationConfig.animateClose(self.panelEl)
	        .then(done, warnAndClose);
	  });
	};
	
	
	/**
	 * Registers a interceptor with the panel. The callback should return a promise,
	 * which will allow the action to continue when it gets resolved, or will
	 * prevent an action if it is rejected.
	 * @param {string} type Type of interceptor.
	 * @param {!angular.$q.Promise<!any>} callback Callback to be registered.
	 * @returns {!MdPanelRef}
	 */
	MdPanelRef.prototype.registerInterceptor = function(type, callback) {
	  var error = null;
	
	  if (!angular.isString(type)) {
	    error = 'Interceptor type must be a string, instead got ' + typeof type;
	  } else if (!angular.isFunction(callback)) {
	    error = 'Interceptor callback must be a function, instead got ' + typeof callback;
	  }
	
	  if (error) {
	    throw new Error('MdPanel: ' + error);
	  }
	
	  var interceptors = this._interceptors[type] = this._interceptors[type] || [];
	
	  if (interceptors.indexOf(callback) === -1) {
	    interceptors.push(callback);
	  }
	
	  return this;
	};
	
	
	/**
	 * Removes a registered interceptor.
	 * @param {string} type Type of interceptor to be removed.
	 * @param {Function} callback Interceptor to be removed.
	 * @returns {!MdPanelRef}
	 */
	MdPanelRef.prototype.removeInterceptor = function(type, callback) {
	  var index = this._interceptors[type] ?
	    this._interceptors[type].indexOf(callback) : -1;
	
	  if (index > -1) {
	    this._interceptors[type].splice(index, 1);
	  }
	
	  return this;
	};
	
	
	/**
	 * Removes all interceptors.
	 * @param {string=} type Type of interceptors to be removed.
	 *     If ommited, all interceptors types will be removed.
	 * @returns {!MdPanelRef}
	 */
	MdPanelRef.prototype.removeAllInterceptors = function(type) {
	  if (type) {
	    this._interceptors[type] = [];
	  } else {
	    this._interceptors = Object.create(null);
	  }
	
	  return this;
	};
	
	
	/**
	 * Invokes all the interceptors of a certain type sequantially in
	 *     reverse order. Works in a similar way to `$q.all`, except it
	 *     respects the order of the functions.
	 * @param {string} type Type of interceptors to be invoked.
	 * @returns {!angular.$q.Promise<!MdPanelRef>}
	 * @private
	 */
	MdPanelRef.prototype._callInterceptors = function(type) {
	  var self = this;
	  var $q = self._$q;
	  var interceptors = self._interceptors && self._interceptors[type] || [];
	
	  return interceptors.reduceRight(function(promise, interceptor) {
	    var isPromiseLike = interceptor && angular.isFunction(interceptor.then);
	    var response = isPromiseLike ? interceptor : null;
	
	    /**
	    * For interceptors to reject/cancel subsequent portions of the chain, simply
	    * return a `$q.reject(<value>)`
	    */
	    return promise.then(function() {
	      if (!response) {
	        try {
	          response = interceptor(self);
	        } catch(e) {
	          response = $q.reject(e);
	        }
	      }
	
	     return response;
	    });
	  }, $q.resolve(self));
	};
	
	
	/**
	 * Faster, more basic than angular.bind
	 * http://jsperf.com/angular-bind-vs-custom-vs-native
	 * @param {function} callback
	 * @param {!Object} self
	 * @return {function} Callback function with a bound self.
	 */
	MdPanelRef.prototype._simpleBind = function(callback, self) {
	  return function(value) {
	    return callback.apply(self, value);
	  };
	};
	
	
	/**
	 * @param {function} callback
	 * @param {!Object} self
	 * @return {function} Callback function with a self param.
	 */
	MdPanelRef.prototype._done = function(callback, self) {
	  return function() {
	    callback(self);
	  };
	};
	
	
	/**
	 * Adds a panel to a group if the panel does not exist within the group already.
	 * A panel can only exist within a single group.
	 * @param {string} groupName The name of the group.
	 */
	MdPanelRef.prototype.addToGroup = function(groupName) {
	  if (!this._$mdPanel._groups[groupName]) {
	    this._$mdPanel.newPanelGroup(groupName);
	  }
	
	  var group = this._$mdPanel._groups[groupName];
	  var index = group.panels.indexOf(this);
	
	  if (index < 0) {
	    group.panels.push(this);
	  }
	};
	
	
	/**
	 * Removes a panel from a group if the panel exists within that group. The group
	 * must be created ahead of time.
	 * @param {string} groupName The name of the group.
	 */
	MdPanelRef.prototype.removeFromGroup = function(groupName) {
	  if (!this._$mdPanel._groups[groupName]) {
	    throw new Error('mdPanel: The group ' + groupName + ' does not exist.');
	  }
	
	  var group = this._$mdPanel._groups[groupName];
	  var index = group.panels.indexOf(this);
	
	  if (index > -1) {
	    group.panels.splice(index, 1);
	  }
	};
	
	
	/**
	 * Possible default closeReasons for the close function.
	 * @enum {string}
	 */
	MdPanelRef.closeReasons = {
	  CLICK_OUTSIDE: 'clickOutsideToClose',
	  ESCAPE: 'escapeToClose',
	};
	
	
	/*****************************************************************************
	 *                               MdPanelPosition                             *
	 *****************************************************************************/
	
	
	/**
	 * Position configuration object. To use, create an MdPanelPosition with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * Example:
	 *
	 * var panelPosition = new MdPanelPosition()
	 *     .relativeTo(myButtonEl)
	 *     .addPanelPosition(
	 *       $mdPanel.xPosition.CENTER,
	 *       $mdPanel.yPosition.ALIGN_TOPS
	 *     );
	 *
	 * $mdPanel.create({
	 *   position: panelPosition
	 * });
	 *
	 * @param {!angular.$injector} $injector
	 * @final @constructor
	 */
	function MdPanelPosition($injector) {
	  /** @private @const {!angular.$window} */
	  this._$window = $injector.get('$window');
	
	  /** @private {boolean} */
	  this._isRTL = $injector.get('$mdUtil').bidi() === 'rtl';
	
	  /** @private @const {!angular.$mdConstant} */
	  this._$mdConstant = $injector.get('$mdConstant');
	
	  /** @private {boolean} */
	  this._absolute = false;
	
	  /** @private {!angular.JQLite} */
	  this._relativeToEl;
	
	  /** @private {string} */
	  this._top = '';
	
	  /** @private {string} */
	  this._bottom = '';
	
	  /** @private {string} */
	  this._left = '';
	
	  /** @private {string} */
	  this._right = '';
	
	  /** @private {!Array<string>} */
	  this._translateX = [];
	
	  /** @private {!Array<string>} */
	  this._translateY = [];
	
	  /** @private {!Array<{x:string, y:string}>} */
	  this._positions = [];
	
	  /** @private {?{x:string, y:string}} */
	  this._actualPosition;
	}
	
	
	/**
	 * Possible values of xPosition.
	 * @enum {string}
	 */
	MdPanelPosition.xPosition = {
	  CENTER: 'center',
	  ALIGN_START: 'align-start',
	  ALIGN_END: 'align-end',
	  OFFSET_START: 'offset-start',
	  OFFSET_END: 'offset-end'
	};
	
	
	/**
	 * Possible values of yPosition.
	 * @enum {string}
	 */
	MdPanelPosition.yPosition = {
	  CENTER: 'center',
	  ALIGN_TOPS: 'align-tops',
	  ALIGN_BOTTOMS: 'align-bottoms',
	  ABOVE: 'above',
	  BELOW: 'below'
	};
	
	
	/**
	 * Possible values of absolute position.
	 * @enum {string}
	 */
	MdPanelPosition.absPosition = {
	  TOP: 'top',
	  RIGHT: 'right',
	  BOTTOM: 'bottom',
	  LEFT: 'left'
	};
	
	/**
	 * Margin between the edges of a panel and the viewport.
	 * @const {number}
	 */
	MdPanelPosition.viewportMargin = 8;
	
	
	/**
	 * Sets absolute positioning for the panel.
	 * @return {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.absolute = function() {
	  this._absolute = true;
	  return this;
	};
	
	
	/**
	 * Sets the value of a position for the panel. Clears any previously set
	 * position.
	 * @param {string} position Position to set
	 * @param {string=} value Value of the position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 * @private
	 */
	MdPanelPosition.prototype._setPosition = function(position, value) {
	  if (position === MdPanelPosition.absPosition.RIGHT ||
	      position === MdPanelPosition.absPosition.LEFT) {
	    this._left = this._right = '';
	  } else if (
	      position === MdPanelPosition.absPosition.BOTTOM ||
	      position === MdPanelPosition.absPosition.TOP) {
	    this._top = this._bottom = '';
	  } else {
	    var positions = Object.keys(MdPanelPosition.absPosition).join()
	        .toLowerCase();
	
	    throw new Error('mdPanel: Position must be one of ' + positions + '.');
	  }
	
	  this['_' +  position] = angular.isString(value) ? value : '0';
	
	  return this;
	};
	
	
	/**
	 * Sets the value of `top` for the panel. Clears any previously set vertical
	 * position.
	 * @param {string=} top Value of `top`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.top = function(top) {
	  return this._setPosition(MdPanelPosition.absPosition.TOP, top);
	};
	
	
	/**
	 * Sets the value of `bottom` for the panel. Clears any previously set vertical
	 * position.
	 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.bottom = function(bottom) {
	  return this._setPosition(MdPanelPosition.absPosition.BOTTOM, bottom);
	};
	
	
	/**
	 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
	 * `rtl`. Clears any previously set horizontal position.
	 * @param {string=} start Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.start = function(start) {
	  var position = this._isRTL ? MdPanelPosition.absPosition.RIGHT : MdPanelPosition.absPosition.LEFT;
	  return this._setPosition(position, start);
	};
	
	
	/**
	 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
	 * Clears any previously set horizontal position.
	 * @param {string=} end Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.end = function(end) {
	  var position = this._isRTL ? MdPanelPosition.absPosition.LEFT : MdPanelPosition.absPosition.RIGHT;
	  return this._setPosition(position, end);
	};
	
	
	/**
	 * Sets the value of `left` for the panel. Clears any previously set
	 * horizontal position.
	 * @param {string=} left Value of `left`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.left = function(left) {
	  return this._setPosition(MdPanelPosition.absPosition.LEFT, left);
	};
	
	
	/**
	 * Sets the value of `right` for the panel. Clears any previously set
	 * horizontal position.
	 * @param {string=} right Value of `right`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	*/
	MdPanelPosition.prototype.right = function(right) {
	  return this._setPosition(MdPanelPosition.absPosition.RIGHT, right);
	};
	
	
	/**
	 * Centers the panel horizontally in the viewport. Clears any previously set
	 * horizontal position.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.centerHorizontally = function() {
	  this._left = '50%';
	  this._right = '';
	  this._translateX = ['-50%'];
	  return this;
	};
	
	
	/**
	 * Centers the panel vertically in the viewport. Clears any previously set
	 * vertical position.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.centerVertically = function() {
	  this._top = '50%';
	  this._bottom = '';
	  this._translateY = ['-50%'];
	  return this;
	};
	
	
	/**
	 * Centers the panel horizontally and vertically in the viewport. This is
	 * equivalent to calling both `centerHorizontally` and `centerVertically`.
	 * Clears any previously set horizontal and vertical positions.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.center = function() {
	  return this.centerHorizontally().centerVertically();
	};
	
	
	/**
	 * Sets element for relative positioning.
	 * @param {string|!Element|!angular.JQLite} element Query selector, DOM element,
	 *     or angular element to set the panel relative to.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.relativeTo = function(element) {
	  this._absolute = false;
	  this._relativeToEl = getElement(element);
	  return this;
	};
	
	
	/**
	 * Sets the x and y positions for the panel relative to another element.
	 * @param {string} xPosition must be one of the MdPanelPosition.xPosition
	 *     values.
	 * @param {string} yPosition must be one of the MdPanelPosition.yPosition
	 *     values.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.addPanelPosition = function(xPosition, yPosition) {
	  if (!this._relativeToEl) {
	    throw new Error('mdPanel: addPanelPosition can only be used with ' +
	        'relative positioning. Set relativeTo first.');
	  }
	
	  this._validateXPosition(xPosition);
	  this._validateYPosition(yPosition);
	
	  this._positions.push({
	      x: xPosition,
	      y: yPosition,
	  });
	  return this;
	};
	
	
	/**
	 * Ensures that yPosition is a valid position name. Throw an exception if not.
	 * @param {string} yPosition
	 */
	MdPanelPosition.prototype._validateYPosition = function(yPosition) {
	  // empty is ok
	  if (yPosition == null) {
	      return;
	  }
	
	  var positionKeys = Object.keys(MdPanelPosition.yPosition);
	  var positionValues = [];
	  for (var key, i = 0; key = positionKeys[i]; i++) {
	    var position = MdPanelPosition.yPosition[key];
	    positionValues.push(position);
	
	    if (position === yPosition) {
	      return;
	    }
	  }
	
	  throw new Error('mdPanel: Panel y position only accepts the following ' +
	      'values:\n' + positionValues.join(' | '));
	};
	
	
	/**
	 * Ensures that xPosition is a valid position name. Throw an exception if not.
	 * @param {string} xPosition
	 */
	MdPanelPosition.prototype._validateXPosition = function(xPosition) {
	  // empty is ok
	  if (xPosition == null) {
	      return;
	  }
	
	  var positionKeys = Object.keys(MdPanelPosition.xPosition);
	  var positionValues = [];
	  for (var key, i = 0; key = positionKeys[i]; i++) {
	    var position = MdPanelPosition.xPosition[key];
	    positionValues.push(position);
	    if (position === xPosition) {
	      return;
	    }
	  }
	
	  throw new Error('mdPanel: Panel x Position only accepts the following ' +
	      'values:\n' + positionValues.join(' | '));
	};
	
	
	/**
	 * Sets the value of the offset in the x-direction. This will add to any
	 * previously set offsets.
	 * @param {string|number|function(MdPanelPosition): string} offsetX
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.withOffsetX = function(offsetX) {
	  this._translateX.push(addUnits(offsetX));
	  return this;
	};
	
	
	/**
	 * Sets the value of the offset in the y-direction. This will add to any
	 * previously set offsets.
	 * @param {string|number|function(MdPanelPosition): string} offsetY
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.withOffsetY = function(offsetY) {
	  this._translateY.push(addUnits(offsetY));
	  return this;
	};
	
	
	/**
	 * Gets the value of `top` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getTop = function() {
	  return this._top;
	};
	
	
	/**
	 * Gets the value of `bottom` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getBottom = function() {
	  return this._bottom;
	};
	
	
	/**
	 * Gets the value of `left` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getLeft = function() {
	  return this._left;
	};
	
	
	/**
	 * Gets the value of `right` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getRight = function() {
	  return this._right;
	};
	
	
	/**
	 * Gets the value of `transform` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getTransform = function() {
	  var translateX = this._reduceTranslateValues('translateX', this._translateX);
	  var translateY = this._reduceTranslateValues('translateY', this._translateY);
	
	  // It's important to trim the result, because the browser will ignore the set
	  // operation if the string contains only whitespace.
	  return (translateX + ' ' + translateY).trim();
	};
	
	
	/**
	 * Sets the `transform` value for a panel element.
	 * @param {!angular.JQLite} panelEl
	 * @returns {!angular.JQLite}
	 * @private
	 */
	MdPanelPosition.prototype._setTransform = function(panelEl) {
	  return panelEl.css(this._$mdConstant.CSS.TRANSFORM, this.getTransform());
	};
	
	
	/**
	 * True if the panel is completely on-screen with this positioning; false
	 * otherwise.
	 * @param {!angular.JQLite} panelEl
	 * @return {boolean}
	 * @private
	 */
	MdPanelPosition.prototype._isOnscreen = function(panelEl) {
	  // this works because we always use fixed positioning for the panel,
	  // which is relative to the viewport.
	  var left = parseInt(this.getLeft());
	  var top = parseInt(this.getTop());
	
	  if (this._translateX.length || this._translateY.length) {
	    var prefixedTransform = this._$mdConstant.CSS.TRANSFORM;
	    var offsets = getComputedTranslations(panelEl, prefixedTransform);
	    left += offsets.x;
	    top += offsets.y;
	  }
	
	  var right = left + panelEl[0].offsetWidth;
	  var bottom = top + panelEl[0].offsetHeight;
	
	  return (left >= 0) &&
	    (top >= 0) &&
	    (bottom <= this._$window.innerHeight) &&
	    (right <= this._$window.innerWidth);
	};
	
	
	/**
	 * Gets the first x/y position that can fit on-screen.
	 * @returns {{x: string, y: string}}
	 */
	MdPanelPosition.prototype.getActualPosition = function() {
	  return this._actualPosition;
	};
	
	
	/**
	 * Reduces a list of translate values to a string that can be used within
	 * transform.
	 * @param {string} translateFn
	 * @param {!Array<string>} values
	 * @returns {string}
	 * @private
	 */
	MdPanelPosition.prototype._reduceTranslateValues =
	    function(translateFn, values) {
	      return values.map(function(translation) {
	        var translationValue = angular.isFunction(translation) ?
	            addUnits(translation(this)) : translation;
	        return translateFn + '(' + translationValue + ')';
	      }, this).join(' ');
	    };
	
	
	/**
	 * Sets the panel position based on the created panel element and best x/y
	 * positioning.
	 * @param {!angular.JQLite} panelEl
	 * @private
	 */
	MdPanelPosition.prototype._setPanelPosition = function(panelEl) {
	  // Remove the "position adjusted" class in case it has been added before.
	  panelEl.removeClass('_md-panel-position-adjusted');
	
	  // Only calculate the position if necessary.
	  if (this._absolute) {
	    this._setTransform(panelEl);
	    return;
	  }
	
	  if (this._actualPosition) {
	    this._calculatePanelPosition(panelEl, this._actualPosition);
	    this._setTransform(panelEl);
	    this._constrainToViewport(panelEl);
	    return;
	  }
	
	  for (var i = 0; i < this._positions.length; i++) {
	    this._actualPosition = this._positions[i];
	    this._calculatePanelPosition(panelEl, this._actualPosition);
	    this._setTransform(panelEl);
	
	    if (this._isOnscreen(panelEl)) {
	      return;
	    }
	  }
	
	  this._constrainToViewport(panelEl);
	};
	
	
	/**
	 * Constrains a panel's position to the viewport.
	 * @param {!angular.JQLite} panelEl
	 * @private
	 */
	MdPanelPosition.prototype._constrainToViewport = function(panelEl) {
	  var margin = MdPanelPosition.viewportMargin;
	  var initialTop = this._top;
	  var initialLeft = this._left;
	
	  if (this.getTop()) {
	    var top = parseInt(this.getTop());
	    var bottom = panelEl[0].offsetHeight + top;
	    var viewportHeight = this._$window.innerHeight;
	
	    if (top < margin) {
	      this._top = margin + 'px';
	    } else if (bottom > viewportHeight) {
	      this._top = top - (bottom - viewportHeight + margin) + 'px';
	    }
	  }
	
	  if (this.getLeft()) {
	    var left = parseInt(this.getLeft());
	    var right = panelEl[0].offsetWidth + left;
	    var viewportWidth = this._$window.innerWidth;
	
	    if (left < margin) {
	      this._left = margin + 'px';
	    } else if (right > viewportWidth) {
	      this._left = left - (right - viewportWidth + margin) + 'px';
	    }
	  }
	
	  // Class that can be used to re-style the panel if it was repositioned.
	  panelEl.toggleClass(
	    '_md-panel-position-adjusted',
	    this._top !== initialTop || this._left !== initialLeft
	  );
	};
	
	
	/**
	 * Switches between 'start' and 'end'.
	 * @param {string} position Horizontal position of the panel
	 * @returns {string} Reversed position
	 * @private
	 */
	MdPanelPosition.prototype._reverseXPosition = function(position) {
	  if (position === MdPanelPosition.xPosition.CENTER) {
	    return position;
	  }
	
	  var start = 'start';
	  var end = 'end';
	
	  return position.indexOf(start) > -1 ? position.replace(start, end) : position.replace(end, start);
	};
	
	
	/**
	 * Handles horizontal positioning in rtl or ltr environments.
	 * @param {string} position Horizontal position of the panel
	 * @returns {string} The correct position according the page direction
	 * @private
	 */
	MdPanelPosition.prototype._bidi = function(position) {
	  return this._isRTL ? this._reverseXPosition(position) : position;
	};
	
	
	/**
	 * Calculates the panel position based on the created panel element and the
	 * provided positioning.
	 * @param {!angular.JQLite} panelEl
	 * @param {!{x:string, y:string}} position
	 * @private
	 */
	MdPanelPosition.prototype._calculatePanelPosition = function(panelEl, position) {
	
	  var panelBounds = panelEl[0].getBoundingClientRect();
	  var panelWidth = Math.max(panelBounds.width, panelEl[0].clientWidth);
	  var panelHeight = Math.max(panelBounds.height, panelEl[0].clientHeight);
	
	  var targetBounds = this._relativeToEl[0].getBoundingClientRect();
	
	  var targetLeft = targetBounds.left;
	  var targetRight = targetBounds.right;
	  var targetWidth = targetBounds.width;
	
	  switch (this._bidi(position.x)) {
	    case MdPanelPosition.xPosition.OFFSET_START:
	      this._left = targetLeft - panelWidth + 'px';
	      break;
	    case MdPanelPosition.xPosition.ALIGN_END:
	      this._left = targetRight - panelWidth + 'px';
	      break;
	    case MdPanelPosition.xPosition.CENTER:
	      var left = targetLeft + (0.5 * targetWidth) - (0.5 * panelWidth);
	      this._left = left + 'px';
	      break;
	    case MdPanelPosition.xPosition.ALIGN_START:
	      this._left = targetLeft + 'px';
	      break;
	    case MdPanelPosition.xPosition.OFFSET_END:
	      this._left = targetRight + 'px';
	      break;
	  }
	
	  var targetTop = targetBounds.top;
	  var targetBottom = targetBounds.bottom;
	  var targetHeight = targetBounds.height;
	
	  switch (position.y) {
	    case MdPanelPosition.yPosition.ABOVE:
	      this._top = targetTop - panelHeight + 'px';
	      break;
	    case MdPanelPosition.yPosition.ALIGN_BOTTOMS:
	      this._top = targetBottom - panelHeight + 'px';
	      break;
	    case MdPanelPosition.yPosition.CENTER:
	      var top = targetTop + (0.5 * targetHeight) - (0.5 * panelHeight);
	      this._top = top + 'px';
	      break;
	    case MdPanelPosition.yPosition.ALIGN_TOPS:
	      this._top = targetTop + 'px';
	      break;
	    case MdPanelPosition.yPosition.BELOW:
	      this._top = targetBottom + 'px';
	      break;
	  }
	};
	
	
	/*****************************************************************************
	 *                               MdPanelAnimation                            *
	 *****************************************************************************/
	
	
	/**
	 * Animation configuration object. To use, create an MdPanelAnimation with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * Example:
	 *
	 * var panelAnimation = new MdPanelAnimation()
	 *     .openFrom(myButtonEl)
	 *     .closeTo('.my-button')
	 *     .withAnimation($mdPanel.animation.SCALE);
	 *
	 * $mdPanel.create({
	 *   animation: panelAnimation
	 * });
	 *
	 * @param {!angular.$injector} $injector
	 * @final @constructor
	 */
	function MdPanelAnimation($injector) {
	  /** @private @const {!angular.$mdUtil} */
	  this._$mdUtil = $injector.get('$mdUtil');
	
	  /**
	   * @private {{element: !angular.JQLite|undefined, bounds: !DOMRect}|
	   *     undefined}
	   */
	  this._openFrom;
	
	  /**
	   * @private {{element: !angular.JQLite|undefined, bounds: !DOMRect}|
	   *     undefined}
	   */
	  this._closeTo;
	
	  /** @private {string|{open: string, close: string}} */
	  this._animationClass = '';
	
	  /** @private {number} */
	  this._openDuration;
	
	  /** @private {number} */
	  this._closeDuration;
	
	  /** @private {number|{open: number, close: number}} */
	  this._rawDuration;
	}
	
	
	/**
	 * Possible default animations.
	 * @enum {string}
	 */
	MdPanelAnimation.animation = {
	  SLIDE: 'md-panel-animate-slide',
	  SCALE: 'md-panel-animate-scale',
	  FADE: 'md-panel-animate-fade'
	};
	
	
	/**
	 * Specifies where to start the open animation. `openFrom` accepts a
	 * click event object, query selector, DOM element, or a Rect object that
	 * is used to determine the bounds. When passed a click event, the location
	 * of the click will be used as the position to start the animation.
	 * @param {string|!Element|!Event|{top: number, left: number}} openFrom
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.openFrom = function(openFrom) {
	  // Check if 'openFrom' is an Event.
	  openFrom = openFrom.target ? openFrom.target : openFrom;
	
	  this._openFrom = this._getPanelAnimationTarget(openFrom);
	
	  if (!this._closeTo) {
	    this._closeTo = this._openFrom;
	  }
	  return this;
	};
	
	
	/**
	 * Specifies where to animate the panel close. `closeTo` accepts a
	 * query selector, DOM element, or a Rect object that is used to determine
	 * the bounds.
	 * @param {string|!Element|{top: number, left: number}} closeTo
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.closeTo = function(closeTo) {
	  this._closeTo = this._getPanelAnimationTarget(closeTo);
	  return this;
	};
	
	
	/**
	 * Specifies the duration of the animation in milliseconds.
	 * @param {number|{open: number, close: number}} duration
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.duration = function(duration) {
	  if (duration) {
	    if (angular.isNumber(duration)) {
	      this._openDuration = this._closeDuration = toSeconds(duration);
	    } else if (angular.isObject(duration)) {
	      this._openDuration = toSeconds(duration.open);
	      this._closeDuration = toSeconds(duration.close);
	    }
	  }
	
	  // Save the original value so it can be passed to the backdrop.
	  this._rawDuration = duration;
	
	  return this;
	
	  function toSeconds(value) {
	    if (angular.isNumber(value)) return value / 1000;
	  }
	};
	
	
	/**
	 * Returns the element and bounds for the animation target.
	 * @param {string|!Element|{top: number, left: number}} location
	 * @returns {{element: !angular.JQLite|undefined, bounds: !DOMRect}}
	 * @private
	 */
	MdPanelAnimation.prototype._getPanelAnimationTarget = function(location) {
	  if (angular.isDefined(location.top) || angular.isDefined(location.left)) {
	    return {
	      element: undefined,
	      bounds: {
	        top: location.top || 0,
	        left: location.left || 0
	      }
	    };
	  } else {
	    return this._getBoundingClientRect(getElement(location));
	  }
	};
	
	
	/**
	 * Specifies the animation class.
	 *
	 * There are several default animations that can be used:
	 * (MdPanelAnimation.animation)
	 *   SLIDE: The panel slides in and out from the specified
	 *        elements.
	 *   SCALE: The panel scales in and out.
	 *   FADE: The panel fades in and out.
	 *
	 * @param {string|{open: string, close: string}} cssClass
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.withAnimation = function(cssClass) {
	  this._animationClass = cssClass;
	  return this;
	};
	
	
	/**
	 * Animate the panel open.
	 * @param {!angular.JQLite} panelEl
	 * @returns {!angular.$q.Promise} A promise that is resolved when the open
	 *     animation is complete.
	 */
	MdPanelAnimation.prototype.animateOpen = function(panelEl) {
	  var animator = this._$mdUtil.dom.animator;
	
	  this._fixBounds(panelEl);
	  var animationOptions = {};
	
	  // Include the panel transformations when calculating the animations.
	  var panelTransform = panelEl[0].style.transform || '';
	
	  var openFrom = animator.toTransformCss(panelTransform);
	  var openTo = animator.toTransformCss(panelTransform);
	
	  switch (this._animationClass) {
	    case MdPanelAnimation.animation.SLIDE:
	      // Slide should start with opacity: 1.
	      panelEl.css('opacity', '1');
	
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter'
	      };
	
	      var openSlide = animator.calculateSlideToOrigin(
	              panelEl, this._openFrom) || '';
	      openFrom = animator.toTransformCss(openSlide + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.SCALE:
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter'
	      };
	
	      var openScale = animator.calculateZoomToOrigin(
	              panelEl, this._openFrom) || '';
	      openFrom = animator.toTransformCss(openScale + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.FADE:
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter'
	      };
	      break;
	
	    default:
	      if (angular.isString(this._animationClass)) {
	        animationOptions = {
	          transitionInClass: this._animationClass
	        };
	      } else {
	        animationOptions = {
	          transitionInClass: this._animationClass['open'],
	          transitionOutClass: this._animationClass['close'],
	        };
	      }
	  }
	
	  animationOptions.duration = this._openDuration;
	
	  return animator
	      .translate3d(panelEl, openFrom, openTo, animationOptions);
	};
	
	
	/**
	 * Animate the panel close.
	 * @param {!angular.JQLite} panelEl
	 * @returns {!angular.$q.Promise} A promise that resolves when the close
	 *     animation is complete.
	 */
	MdPanelAnimation.prototype.animateClose = function(panelEl) {
	  var animator = this._$mdUtil.dom.animator;
	  var reverseAnimationOptions = {};
	
	  // Include the panel transformations when calculating the animations.
	  var panelTransform = panelEl[0].style.transform || '';
	
	  var closeFrom = animator.toTransformCss(panelTransform);
	  var closeTo = animator.toTransformCss(panelTransform);
	
	  switch (this._animationClass) {
	    case MdPanelAnimation.animation.SLIDE:
	      // Slide should start with opacity: 1.
	      panelEl.css('opacity', '1');
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-leave'
	      };
	
	      var closeSlide = animator.calculateSlideToOrigin(
	              panelEl, this._closeTo) || '';
	      closeTo = animator.toTransformCss(closeSlide + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.SCALE:
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-scale-out _md-panel-animate-leave'
	      };
	
	      var closeScale = animator.calculateZoomToOrigin(
	              panelEl, this._closeTo) || '';
	      closeTo = animator.toTransformCss(closeScale + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.FADE:
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-fade-out _md-panel-animate-leave'
	      };
	      break;
	
	    default:
	      if (angular.isString(this._animationClass)) {
	        reverseAnimationOptions = {
	          transitionOutClass: this._animationClass
	        };
	      } else {
	        reverseAnimationOptions = {
	          transitionInClass: this._animationClass['close'],
	          transitionOutClass: this._animationClass['open']
	        };
	      }
	  }
	
	  reverseAnimationOptions.duration = this._closeDuration;
	
	  return animator
	      .translate3d(panelEl, closeFrom, closeTo, reverseAnimationOptions);
	};
	
	
	/**
	 * Set the height and width to match the panel if not provided.
	 * @param {!angular.JQLite} panelEl
	 * @private
	 */
	MdPanelAnimation.prototype._fixBounds = function(panelEl) {
	  var panelWidth = panelEl[0].offsetWidth;
	  var panelHeight = panelEl[0].offsetHeight;
	
	  if (this._openFrom && this._openFrom.bounds.height == null) {
	    this._openFrom.bounds.height = panelHeight;
	  }
	  if (this._openFrom && this._openFrom.bounds.width == null) {
	    this._openFrom.bounds.width = panelWidth;
	  }
	  if (this._closeTo && this._closeTo.bounds.height == null) {
	    this._closeTo.bounds.height = panelHeight;
	  }
	  if (this._closeTo && this._closeTo.bounds.width == null) {
	    this._closeTo.bounds.width = panelWidth;
	  }
	};
	
	
	/**
	 * Identify the bounding RECT for the target element.
	 * @param {!angular.JQLite} element
	 * @returns {{element: !angular.JQLite|undefined, bounds: !DOMRect}}
	 * @private
	 */
	MdPanelAnimation.prototype._getBoundingClientRect = function(element) {
	  if (element instanceof angular.element) {
	    return {
	      element: element,
	      bounds: element[0].getBoundingClientRect()
	    };
	  }
	};
	
	
	/*****************************************************************************
	 *                                Util Methods                               *
	 *****************************************************************************/
	
	
	/**
	 * Returns the angular element associated with a css selector or element.
	 * @param el {string|!angular.JQLite|!Element}
	 * @returns {!angular.JQLite}
	 */
	function getElement(el) {
	  var queryResult = angular.isString(el) ?
	      document.querySelector(el) : el;
	  return angular.element(queryResult);
	}
	
	/**
	 * Gets the computed values for an element's translateX and translateY in px.
	 * @param {!angular.JQLite|!Element} el
	 * @param {string} property
	 * @return {{x: number, y: number}}
	 */
	function getComputedTranslations(el, property) {
	  // The transform being returned by `getComputedStyle` is in the format:
	  // `matrix(a, b, c, d, translateX, translateY)` if defined and `none`
	  // if the element doesn't have a transform.
	  var transform = getComputedStyle(el[0] || el)[property];
	  var openIndex = transform.indexOf('(');
	  var closeIndex = transform.lastIndexOf(')');
	  var output = { x: 0, y: 0 };
	
	  if (openIndex > -1 && closeIndex > -1) {
	    var parsedValues = transform
	      .substring(openIndex + 1, closeIndex)
	      .split(', ')
	      .slice(-2);
	
	    output.x = parseInt(parsedValues[0]);
	    output.y = parseInt(parsedValues[1]);
	  }
	
	  return output;
	}
	
	/**
	 * Adds units to a number value.
	 * @param {string|number} value
	 * @return {string}
	 */
	function addUnits(value) {
	  return angular.isNumber(value) ? value + 'px' : value;
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.progressCircular
	 * @description Module for a circular progressbar
	 */
	
	angular.module('material.components.progressCircular', ['material.core']);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.progressLinear
	 * @description Linear Progress module!
	 */
	MdProgressLinearDirective.$inject = ["$mdTheming", "$mdUtil", "$log"];
	angular.module('material.components.progressLinear', [
	  'material.core'
	])
	  .directive('mdProgressLinear', MdProgressLinearDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdProgressLinear
	 * @module material.components.progressLinear
	 * @restrict E
	 *
	 * @description
	 * The linear progress directive is used to make loading content
	 * in your app as delightful and painless as possible by minimizing
	 * the amount of visual change a user sees before they can view
	 * and interact with content.
	 *
	 * Each operation should only be represented by one activity indicator
	 * For example: one refresh operation should not display both a
	 * refresh bar and an activity circle.
	 *
	 * For operations where the percentage of the operation completed
	 * can be determined, use a determinate indicator. They give users
	 * a quick sense of how long an operation will take.
	 *
	 * For operations where the user is asked to wait a moment while
	 * something finishes up, and it’s not necessary to expose what's
	 * happening behind the scenes and how long it will take, use an
	 * indeterminate indicator.
	 *
	 * @param {string} md-mode Select from one of four modes: determinate, indeterminate, buffer or query.
	 *
	 * Note: if the `md-mode` value is set as undefined or specified as 1 of the four (4) valid modes, then `indeterminate`
	 * will be auto-applied as the mode.
	 *
	 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute. If `value=""` is also specified, however,
	 * then `md-mode="determinate"` would be auto-injected instead.
	 * @param {number=} value In determinate and buffer modes, this number represents the percentage of the primary progress bar. Default: 0
	 * @param {number=} md-buffer-value In the buffer mode, this number represents the percentage of the secondary progress bar. Default: 0
	 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-progress-linear md-mode="determinate" value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="determinate" ng-value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="indeterminate"></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="buffer" value="..." md-buffer-value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="query"></md-progress-linear>
	 * </hljs>
	 */
	function MdProgressLinearDirective($mdTheming, $mdUtil, $log) {
	  var MODE_DETERMINATE = "determinate";
	  var MODE_INDETERMINATE = "indeterminate";
	  var MODE_BUFFER = "buffer";
	  var MODE_QUERY = "query";
	  var DISABLED_CLASS = "_md-progress-linear-disabled";
	
	  return {
	    restrict: 'E',
	    template: '<div class="md-container">' +
	      '<div class="md-dashed"></div>' +
	      '<div class="md-bar md-bar1"></div>' +
	      '<div class="md-bar md-bar2"></div>' +
	      '</div>',
	    compile: compile
	  };
	
	  function compile(tElement, tAttrs, transclude) {
	    tElement.attr('aria-valuemin', 0);
	    tElement.attr('aria-valuemax', 100);
	    tElement.attr('role', 'progressbar');
	
	    return postLink;
	  }
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	
	    var lastMode;
	    var isDisabled = attr.hasOwnProperty('disabled');
	    var toVendorCSS = $mdUtil.dom.animator.toCss;
	    var bar1 = angular.element(element[0].querySelector('.md-bar1'));
	    var bar2 = angular.element(element[0].querySelector('.md-bar2'));
	    var container = angular.element(element[0].querySelector('.md-container'));
	
	    element
	      .attr('md-mode', mode())
	      .toggleClass(DISABLED_CLASS, isDisabled);
	
	    validateMode();
	    watchAttributes();
	
	    /**
	     * Watch the value, md-buffer-value, and md-mode attributes
	     */
	    function watchAttributes() {
	      attr.$observe('value', function(value) {
	        var percentValue = clamp(value);
	        element.attr('aria-valuenow', percentValue);
	
	        if (mode() != MODE_QUERY) animateIndicator(bar2, percentValue);
	      });
	
	      attr.$observe('mdBufferValue', function(value) {
	        animateIndicator(bar1, clamp(value));
	      });
	
	      attr.$observe('disabled', function(value) {
	        if (value === true || value === false) {
	          isDisabled = !!value;
	        } else {
	          isDisabled = angular.isDefined(value);
	        }
	
	        element.toggleClass(DISABLED_CLASS, isDisabled);
	        container.toggleClass(lastMode, !isDisabled);
	      });
	
	      attr.$observe('mdMode', function(mode) {
	        if (lastMode) container.removeClass( lastMode );
	
	        switch( mode ) {
	          case MODE_QUERY:
	          case MODE_BUFFER:
	          case MODE_DETERMINATE:
	          case MODE_INDETERMINATE:
	            container.addClass( lastMode = "md-mode-" + mode );
	            break;
	          default:
	            container.addClass( lastMode = "md-mode-" + MODE_INDETERMINATE );
	            break;
	        }
	      });
	    }
	
	    /**
	     * Auto-defaults the mode to either `determinate` or `indeterminate` mode; if not specified
	     */
	    function validateMode() {
	      if ( angular.isUndefined(attr.mdMode) ) {
	        var hasValue = angular.isDefined(attr.value);
	        var mode = hasValue ? MODE_DETERMINATE : MODE_INDETERMINATE;
	        var info = "Auto-adding the missing md-mode='{0}' to the ProgressLinear element";
	
	        //$log.debug( $mdUtil.supplant(info, [mode]) );
	
	        element.attr("md-mode", mode);
	        attr.mdMode = mode;
	      }
	    }
	
	    /**
	     * Is the md-mode a valid option?
	     */
	    function mode() {
	      var value = (attr.mdMode || "").trim();
	      if ( value ) {
	        switch(value) {
	          case MODE_DETERMINATE:
	          case MODE_INDETERMINATE:
	          case MODE_BUFFER:
	          case MODE_QUERY:
	            break;
	          default:
	            value = MODE_INDETERMINATE;
	            break;
	        }
	      }
	      return value;
	    }
	
	    /**
	     * Manually set CSS to animate the Determinate indicator based on the specified
	     * percentage value (0-100).
	     */
	    function animateIndicator(target, value) {
	      if ( isDisabled || !mode() ) return;
	
	      var to = $mdUtil.supplant("translateX({0}%) scale({1},1)", [ (value-100)/2, value/100 ]);
	      var styles = toVendorCSS({ transform : to });
	      angular.element(target).css( styles );
	    }
	  }
	
	  /**
	   * Clamps the value to be between 0 and 100.
	   * @param {number} value The value to clamp.
	   * @returns {number}
	   */
	  function clamp(value) {
	    return Math.max(0, Math.min(value || 0, 100));
	  }
	}
	
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.radioButton
	 * @description radioButton module!
	 */
	mdRadioGroupDirective.$inject = ["$mdUtil", "$mdConstant", "$mdTheming", "$timeout"];
	mdRadioButtonDirective.$inject = ["$mdAria", "$mdUtil", "$mdTheming"];
	angular.module('material.components.radioButton', [
	  'material.core'
	])
	  .directive('mdRadioGroup', mdRadioGroupDirective)
	  .directive('mdRadioButton', mdRadioButtonDirective);
	
	/**
	 * @ngdoc directive
	 * @module material.components.radioButton
	 * @name mdRadioGroup
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-radio-group>` directive identifies a grouping
	 * container for the 1..n grouped radio buttons; specified using nested
	 * `<md-radio-button>` elements.
	 *
	 * The radio button uses the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * Note: `<md-radio-group>` and `<md-radio-button>` handle `tabindex` differently
	 * than the native `<input type="radio">` controls. Whereas the native controls
	 * force the user to tab through all the radio buttons, `<md-radio-group>`
	 * is focusable and by default the `<md-radio-button>`s are not.
	 *
	 * @param {string} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} ng-change AngularJS expression to be executed when input changes due to user
	 *    interaction.
	 * @param {boolean=} md-no-ink If present, disables ink ripple effects.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-radio-group ng-model="selected">
	 *   <md-radio-button ng-repeat="item in items"
	 *                    ng-value="item.value" aria-label="{{item.label}}">
	 *     {{ item.label }}
	 *   </md-radio-button>
	 * </md-radio-group>
	 * </hljs>
	 */
	function mdRadioGroupDirective($mdUtil, $mdConstant, $mdTheming, $timeout) {
	  RadioGroupController.prototype = createRadioGroupControllerProto();
	
	  return {
	    restrict: 'E',
	    controller: ['$element', RadioGroupController],
	    require: ['mdRadioGroup', '?ngModel'],
	    link: { pre: linkRadioGroup }
	  };
	
	  function linkRadioGroup(scope, element, attr, ctrls) {
	    element.addClass('_md');     // private md component indicator for styling
	    $mdTheming(element);
	
	    var rgCtrl = ctrls[0];
	    var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
	
	    rgCtrl.init(ngModelCtrl);
	
	    scope.mouseActive = false;
	
	    element
	      .attr({
	        'role': 'radiogroup',
	        'tabIndex': element.attr('tabindex') || '0'
	      })
	      .on('keydown', keydownListener)
	      .on('mousedown', function(event) {
	        scope.mouseActive = true;
	        $timeout(function() {
	          scope.mouseActive = false;
	        }, 100);
	      })
	      .on('focus', function() {
	        if(scope.mouseActive === false) {
	          rgCtrl.$element.addClass('md-focused');
	        }
	      })
	      .on('blur', function() {
	        rgCtrl.$element.removeClass('md-focused');
	      });
	
	    /**
	     *
	     */
	    function setFocus() {
	      if (!element.hasClass('md-focused')) { element.addClass('md-focused'); }
	    }
	
	    /**
	     *
	     */
	    function keydownListener(ev) {
	      var keyCode = ev.which || ev.keyCode;
	
	      // Only listen to events that we originated ourselves
	      // so that we don't trigger on things like arrow keys in
	      // inputs.
	
	      if (keyCode != $mdConstant.KEY_CODE.ENTER &&
	          ev.currentTarget != ev.target) {
	        return;
	      }
	
	      switch (keyCode) {
	        case $mdConstant.KEY_CODE.LEFT_ARROW:
	        case $mdConstant.KEY_CODE.UP_ARROW:
	          ev.preventDefault();
	          rgCtrl.selectPrevious();
	          setFocus();
	          break;
	
	        case $mdConstant.KEY_CODE.RIGHT_ARROW:
	        case $mdConstant.KEY_CODE.DOWN_ARROW:
	          ev.preventDefault();
	          rgCtrl.selectNext();
	          setFocus();
	          break;
	
	        case $mdConstant.KEY_CODE.ENTER:
	          var form = angular.element($mdUtil.getClosest(element[0], 'form'));
	          if (form.length > 0) {
	            form.triggerHandler('submit');
	          }
	          break;
	      }
	
	    }
	  }
	
	  function RadioGroupController($element) {
	    this._radioButtonRenderFns = [];
	    this.$element = $element;
	  }
	
	  function createRadioGroupControllerProto() {
	    return {
	      init: function(ngModelCtrl) {
	        this._ngModelCtrl = ngModelCtrl;
	        this._ngModelCtrl.$render = angular.bind(this, this.render);
	      },
	      add: function(rbRender) {
	        this._radioButtonRenderFns.push(rbRender);
	      },
	      remove: function(rbRender) {
	        var index = this._radioButtonRenderFns.indexOf(rbRender);
	        if (index !== -1) {
	          this._radioButtonRenderFns.splice(index, 1);
	        }
	      },
	      render: function() {
	        this._radioButtonRenderFns.forEach(function(rbRender) {
	          rbRender();
	        });
	      },
	      setViewValue: function(value, eventType) {
	        this._ngModelCtrl.$setViewValue(value, eventType);
	        // update the other radio buttons as well
	        this.render();
	      },
	      getViewValue: function() {
	        return this._ngModelCtrl.$viewValue;
	      },
	      selectNext: function() {
	        return changeSelectedButton(this.$element, 1);
	      },
	      selectPrevious: function() {
	        return changeSelectedButton(this.$element, -1);
	      },
	      setActiveDescendant: function (radioId) {
	        this.$element.attr('aria-activedescendant', radioId);
	      },
	      isDisabled: function() {
	        return this.$element[0].hasAttribute('disabled');
	      }
	    };
	  }
	  /**
	   * Change the radio group's selected button by a given increment.
	   * If no button is selected, select the first button.
	   */
	  function changeSelectedButton(parent, increment) {
	    // Coerce all child radio buttons into an array, then wrap then in an iterator
	    var buttons = $mdUtil.iterator(parent[0].querySelectorAll('md-radio-button'), true);
	
	    if (buttons.count()) {
	      var validate = function (button) {
	        // If disabled, then NOT valid
	        return !angular.element(button).attr("disabled");
	      };
	
	      var selected = parent[0].querySelector('md-radio-button.md-checked');
	      var target = buttons[increment < 0 ? 'previous' : 'next'](selected, validate) || buttons.first();
	
	      // Activate radioButton's click listener (triggerHandler won't create a real click event)
	      angular.element(target).triggerHandler('click');
	    }
	  }
	
	}
	
	/**
	 * @ngdoc directive
	 * @module material.components.radioButton
	 * @name mdRadioButton
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-radio-button>`directive is the child directive required to be used within `<md-radio-group>` elements.
	 *
	 * While similar to the `<input type="radio" ng-model="" value="">` directive,
	 * the `<md-radio-button>` directive provides ink effects, ARIA support, and
	 * supports use within named radio groups.
	 *
	 * One of `value` or `ng-value` must be set so that the `md-radio-group`'s model is set properly when the
	 * `md-radio-button` is selected.
	 *
	 * @param {string} value The value to which the model should be set when selected.
	 * @param {string} ng-value AngularJS expression which sets the value to which the model should
	 *    be set when selected.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} aria-label Adds label to radio button for accessibility.
	 *    Defaults to radio button's text. If no text content is available, a warning will be logged.
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-radio-button value="1" aria-label="Label 1">
	 *   Label 1
	 * </md-radio-button>
	 *
	 * <md-radio-button ng-value="specialValue" aria-label="Green">
	 *   Green
	 * </md-radio-button>
	 *
	 * </hljs>
	 *
	 */
	function mdRadioButtonDirective($mdAria, $mdUtil, $mdTheming) {
	
	  var CHECKED_CSS = 'md-checked';
	
	  return {
	    restrict: 'E',
	    require: '^mdRadioGroup',
	    transclude: true,
	    template: '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
	                '<div class="md-off"></div>' +
	                '<div class="md-on"></div>' +
	              '</div>' +
	              '<div ng-transclude class="md-label"></div>',
	    link: link
	  };
	
	  function link(scope, element, attr, rgCtrl) {
	    var lastChecked;
	
	    $mdTheming(element);
	    configureAria(element, scope);
	
	    // ngAria overwrites the aria-checked inside a $watch for ngValue.
	    // We should defer the initialization until all the watches have fired.
	    // This can also be fixed by removing the `lastChecked` check, but that'll
	    // cause more DOM manipulation on each digest.
	    if (attr.ngValue) {
	      $mdUtil.nextTick(initialize, false);
	    } else {
	      initialize();
	    }
	
	    /**
	     * Initializes the component.
	     */
	    function initialize() {
	      if (!rgCtrl) {
	        throw 'RadioButton: No RadioGroupController could be found.';
	      }
	
	      rgCtrl.add(render);
	      attr.$observe('value', render);
	
	      element
	        .on('click', listener)
	        .on('$destroy', function() {
	          rgCtrl.remove(render);
	        });
	    }
	
	    /**
	     * On click functionality.
	     */
	    function listener(ev) {
	      if (element[0].hasAttribute('disabled') || rgCtrl.isDisabled()) return;
	
	      scope.$apply(function() {
	        rgCtrl.setViewValue(attr.value, ev && ev.type);
	      });
	    }
	
	    /**
	     *  Add or remove the `.md-checked` class from the RadioButton (and conditionally its parent).
	     *  Update the `aria-activedescendant` attribute.
	     */
	    function render() {
	      var checked = rgCtrl.getViewValue() == attr.value;
	
	      if (checked === lastChecked) return;
	
	      if (element[0].parentNode.nodeName.toLowerCase() !== 'md-radio-group') {
	        // If the radioButton is inside a div, then add class so highlighting will work
	        element.parent().toggleClass(CHECKED_CSS, checked);
	      }
	
	      if (checked) {
	        rgCtrl.setActiveDescendant(element.attr('id'));
	      }
	
	      lastChecked = checked;
	
	      element
	        .attr('aria-checked', checked)
	        .toggleClass(CHECKED_CSS, checked);
	    }
	
	    /**
	     * Inject ARIA-specific attributes appropriate for each radio button
	     */
	    function configureAria(element, scope){
	      element.attr({
	        id: attr.id || 'radio_' + $mdUtil.nextUid(),
	        role: 'radio',
	        'aria-checked': 'false'
	      });
	
	      $mdAria.expectWithText(element, 'aria-label');
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.select
	 */
	
	/***************************************************
	
	 ### TODO - POST RC1 ###
	 - [ ] Abstract placement logic in $mdSelect service to $mdMenu service
	
	 ***************************************************/
	
	SelectDirective.$inject = ["$mdSelect", "$mdUtil", "$mdConstant", "$mdTheming", "$mdAria", "$parse", "$sce", "$injector"];
	SelectMenuDirective.$inject = ["$parse", "$mdUtil", "$mdConstant", "$mdTheming"];
	OptionDirective.$inject = ["$mdButtonInkRipple", "$mdUtil", "$mdTheming"];
	SelectProvider.$inject = ["$$interimElementProvider"];
	var SELECT_EDGE_MARGIN = 8;
	var selectNextId = 0;
	var CHECKBOX_SELECTION_INDICATOR =
	  angular.element('<div class="md-container"><div class="md-icon"></div></div>');
	
	angular.module('material.components.select', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdSelect', SelectDirective)
	  .directive('mdSelectMenu', SelectMenuDirective)
	  .directive('mdOption', OptionDirective)
	  .directive('mdOptgroup', OptgroupDirective)
	  .directive('mdSelectHeader', SelectHeaderDirective)
	  .provider('$mdSelect', SelectProvider);
	
	/**
	 * @ngdoc directive
	 * @name mdSelect
	 * @restrict E
	 * @module material.components.select
	 *
	 * @description Displays a select box, bound to an ng-model.
	 *
	 * When the select is required and uses a floating label, then the label will automatically contain
	 * an asterisk (`*`). This behavior can be disabled by using the `md-no-asterisk` attribute.
	 *
	 * By default, the select will display with an underline to match other form elements. This can be
	 * disabled by applying the `md-no-underline` CSS class.
	 *
	 * ### Option Params
	 *
	 * When applied, `md-option-empty` will mark the option as "empty" allowing the option to  clear the
	 * select and put it back in it's default state. You may supply this attribute on any option you
	 * wish, however, it is automatically applied to an option whose `value` or `ng-value` are not
	 * defined.
	 *
	 * **Automatically Applied**
	 *
	 *  - `<md-option>`
	 *  - `<md-option value>`
	 *  - `<md-option value="">`
	 *  - `<md-option ng-value>`
	 *  - `<md-option ng-value="">`
	 *
	 * **NOT Automatically Applied**
	 *
	 *  - `<md-option ng-value="1">`
	 *  - `<md-option ng-value="''">`
	 *  - `<md-option ng-value="undefined">`
	 *  - `<md-option value="undefined">` (this evaluates to the string `"undefined"`)
	 *  - <code ng-non-bindable>&lt;md-option ng-value="{{someValueThatMightBeUndefined}}"&gt;</code>
	 *
	 * **Note:** A value of `undefined` ***is considered a valid value*** (and does not auto-apply this
	 * attribute) since you may wish this to be your "Not Available" or "None" option.
	 *
	 * **Note:** Using the `value` attribute (as opposed to `ng-value`) always evaluates to a string, so
	 * `value="null"` will require the test `ng-if="myValue != 'null'"` rather than `ng-if="!myValue"`.
	 *
	 * @param {expression} ng-model Assignable angular expression to data-bind to.
	 * @param {expression=} ng-change Expression to be executed when the model value changes.
	 * @param {boolean=} multiple When present, allows for more than one option to be selected.
	 *  The model is an array with the selected choices. **Note:** This attribute is only evaluated
	 *  once; it is not watched.
	 * @param {expression=} md-on-close Expression to be evaluated when the select is closed.
	 * @param {expression=} md-on-open Expression to be evaluated when opening the select.
	 * Will hide the select options and show a spinner until the evaluated promise resolves.
	 * @param {expression=} md-selected-text Expression to be evaluated that will return a string
	 * to be displayed as a placeholder in the select input box when it is closed. The value
	 * will be treated as *text* (not html).
	 * @param {expression=} md-selected-html Expression to be evaluated that will return a string
	 * to be displayed as a placeholder in the select input box when it is closed. The value
	 * will be treated as *html*. The value must either be explicitly marked as trustedHtml or
	 * the ngSanitize module must be loaded.
	 * @param {string=} placeholder Placeholder hint text.
	 * @param {boolean=} md-no-asterisk When set to true, an asterisk will not be appended to the
	 * floating label. **Note:** This attribute is only evaluated once; it is not watched.
	 * @param {string=} aria-label Optional label for accessibility. Only necessary if no placeholder or
	 * explicit label is present.
	 * @param {string=} md-container-class Class list to get applied to the `.md-select-menu-container`
	 * element (for custom styling).
	 *
	 * @usage
	 * With a placeholder (label and aria-label are added dynamically)
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <md-select
	 *       ng-model="someModel"
	 *       placeholder="Select a state">
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * With an explicit label
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <label>State</label>
	 *     <md-select
	 *       ng-model="someModel">
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * With a select-header
	 *
	 * When a developer needs to put more than just a text label in the
	 * md-select-menu, they should use the md-select-header.
	 * The user can put custom HTML inside of the header and style it to their liking.
	 * One common use case of this would be a sticky search bar.
	 *
	 * When using the md-select-header the labels that would previously be added to the
	 * OptGroupDirective are ignored.
	 *
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <md-select ng-model="someModel">
	 *       <md-select-header>
	 *         <span> Neighborhoods - </span>
	 *       </md-select-header>
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * ## Selects and object equality
	 * When using a `md-select` to pick from a list of objects, it is important to realize how javascript handles
	 * equality. Consider the following example:
	 * <hljs lang="js">
	 * angular.controller('MyCtrl', function($scope) {
	 *   $scope.users = [
	 *     { id: 1, name: 'Bob' },
	 *     { id: 2, name: 'Alice' },
	 *     { id: 3, name: 'Steve' }
	 *   ];
	 *   $scope.selectedUser = { id: 1, name: 'Bob' };
	 * });
	 * </hljs>
	 * <hljs lang="html">
	 * <div ng-controller="MyCtrl">
	 *   <md-select ng-model="selectedUser">
	 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
	 *   </md-select>
	 * </div>
	 * </hljs>
	 *
	 * At first one might expect that the select should be populated with "Bob" as the selected user. However,
	 * this is not true. To determine whether something is selected,
	 * `ngModelController` is looking at whether `$scope.selectedUser == (any user in $scope.users);`;
	 *
	 * Javascript's `==` operator does not check for deep equality (ie. that all properties
	 * on the object are the same), but instead whether the objects are *the same object in memory*.
	 * In this case, we have two instances of identical objects, but they exist in memory as unique
	 * entities. Because of this, the select will have no value populated for a selected user.
	 *
	 * To get around this, `ngModelController` provides a `track by` option that allows us to specify a different
	 * expression which will be used for the equality operator. As such, we can update our `html` to
	 * make use of this by specifying the `ng-model-options="{trackBy: '$value.id'}"` on the `md-select`
	 * element. This converts our equality expression to be
	 * `$scope.selectedUser.id == (any id in $scope.users.map(function(u) { return u.id; }));`
	 * which results in Bob being selected as desired.
	 *
	 * Working HTML:
	 * <hljs lang="html">
	 * <div ng-controller="MyCtrl">
	 *   <md-select ng-model="selectedUser" ng-model-options="{trackBy: '$value.id'}">
	 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
	 *   </md-select>
	 * </div>
	 * </hljs>
	 */
	function SelectDirective($mdSelect, $mdUtil, $mdConstant, $mdTheming, $mdAria, $parse, $sce,
	    $injector) {
	  var keyCodes = $mdConstant.KEY_CODE;
	  var NAVIGATION_KEYS = [keyCodes.SPACE, keyCodes.ENTER, keyCodes.UP_ARROW, keyCodes.DOWN_ARROW];
	
	  return {
	    restrict: 'E',
	    require: ['^?mdInputContainer', 'mdSelect', 'ngModel', '?^form'],
	    compile: compile,
	    controller: function() {
	    } // empty placeholder controller to be initialized in link
	  };
	
	  function compile(element, attr) {
	    // add the select value that will hold our placeholder or selected option value
	    var valueEl = angular.element('<md-select-value><span></span></md-select-value>');
	    valueEl.append('<span class="md-select-icon" aria-hidden="true"></span>');
	    valueEl.addClass('md-select-value');
	    if (!valueEl[0].hasAttribute('id')) {
	      valueEl.attr('id', 'select_value_label_' + $mdUtil.nextUid());
	    }
	
	    // There's got to be an md-content inside. If there's not one, let's add it.
	    var mdContentEl = element.find('md-content');
	    if (!mdContentEl.length) {
	      element.append(angular.element('<md-content>').append(element.contents()));
	    }
	    mdContentEl.attr('role', 'presentation');
	
	
	    // Add progress spinner for md-options-loading
	    if (attr.mdOnOpen) {
	
	      // Show progress indicator while loading async
	      // Use ng-hide for `display:none` so the indicator does not interfere with the options list
	      element
	        .find('md-content')
	        .prepend(angular.element(
	          '<div>' +
	          ' <md-progress-circular md-mode="indeterminate" ng-if="$$loadingAsyncDone === false" md-diameter="25px"></md-progress-circular>' +
	          '</div>'
	        ));
	
	      // Hide list [of item options] while loading async
	      element
	        .find('md-option')
	        .attr('ng-show', '$$loadingAsyncDone');
	    }
	
	    if (attr.name) {
	      var autofillClone = angular.element('<select class="md-visually-hidden"></select>');
	      autofillClone.attr({
	        'name': attr.name,
	        'aria-hidden': 'true',
	        'tabindex': '-1'
	      });
	      var opts = element.find('md-option');
	      angular.forEach(opts, function(el) {
	        var newEl = angular.element('<option>' + el.innerHTML + '</option>');
	        if (el.hasAttribute('ng-value')) newEl.attr('ng-value', el.getAttribute('ng-value'));
	        else if (el.hasAttribute('value')) newEl.attr('value', el.getAttribute('value'));
	        autofillClone.append(newEl);
	      });
	
	      // Adds an extra option that will hold the selected value for the
	      // cases where the select is a part of a non-angular form. This can be done with a ng-model,
	      // however if the `md-option` is being `ng-repeat`-ed, AngularJS seems to insert a similar
	      // `option` node, but with a value of `? string: <value> ?` which would then get submitted.
	      // This also goes around having to prepend a dot to the name attribute.
	      autofillClone.append(
	        '<option ng-value="' + attr.ngModel + '" selected></option>'
	      );
	
	      element.parent().append(autofillClone);
	    }
	
	    var isMultiple = $mdUtil.parseAttributeBoolean(attr.multiple);
	
	    // Use everything that's left inside element.contents() as the contents of the menu
	    var multipleContent = isMultiple ? 'multiple' : '';
	    var selectTemplate = '' +
	      '<div class="md-select-menu-container" aria-hidden="true" role="presentation">' +
	      '<md-select-menu role="presentation" {0}>{1}</md-select-menu>' +
	      '</div>';
	
	    selectTemplate = $mdUtil.supplant(selectTemplate, [multipleContent, element.html()]);
	    element.empty().append(valueEl);
	    element.append(selectTemplate);
	
	    if(!attr.tabindex){
	      attr.$set('tabindex', 0);
	    }
	
	    return function postLink(scope, element, attr, ctrls) {
	      var untouched = true;
	      var isDisabled, ariaLabelBase;
	
	      var containerCtrl = ctrls[0];
	      var mdSelectCtrl = ctrls[1];
	      var ngModelCtrl = ctrls[2];
	      var formCtrl = ctrls[3];
	      // grab a reference to the select menu value label
	      var valueEl = element.find('md-select-value');
	      var isReadonly = angular.isDefined(attr.readonly);
	      var disableAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
	
	      if (disableAsterisk) {
	        element.addClass('md-no-asterisk');
	      }
	
	      if (containerCtrl) {
	        var isErrorGetter = containerCtrl.isErrorGetter || function() {
	          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
	        };
	
	        if (containerCtrl.input) {
	          // We ignore inputs that are in the md-select-header (one
	          // case where this might be useful would be adding as searchbox)
	          if (element.find('md-select-header').find('input')[0] !== containerCtrl.input[0]) {
	            throw new Error("<md-input-container> can only have *one* child <input>, <textarea> or <select> element!");
	          }
	        }
	
	        containerCtrl.input = element;
	        if (!containerCtrl.label) {
	          $mdAria.expect(element, 'aria-label', element.attr('placeholder'));
	        }
	
	        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	      }
	
	      var selectContainer, selectScope, selectMenuCtrl;
	
	      findSelectContainer();
	      $mdTheming(element);
	
	      if (formCtrl && angular.isDefined(attr.multiple)) {
	        $mdUtil.nextTick(function() {
	          var hasModelValue = ngModelCtrl.$modelValue || ngModelCtrl.$viewValue;
	          if (hasModelValue) {
	            formCtrl.$setPristine();
	          }
	        });
	      }
	
	      var originalRender = ngModelCtrl.$render;
	      ngModelCtrl.$render = function() {
	        originalRender();
	        syncLabelText();
	        syncAriaLabel();
	        inputCheckValue();
	      };
	
	      attr.$observe('placeholder', ngModelCtrl.$render);
	
	      if (containerCtrl && containerCtrl.label) {
	        attr.$observe('required', function (value) {
	          // Toggle the md-required class on the input containers label, because the input container is automatically
	          // applying the asterisk indicator on the label.
	          containerCtrl.label.toggleClass('md-required', value && !disableAsterisk);
	        });
	      }
	
	      mdSelectCtrl.setLabelText = function(text) {
	        mdSelectCtrl.setIsPlaceholder(!text);
	
	        // Whether the select label has been given via user content rather than the internal
	        // template of <md-option>
	        var isSelectLabelFromUser = false;
	
	        if (attr.mdSelectedText && attr.mdSelectedHtml) {
	          throw Error('md-select cannot have both `md-selected-text` and `md-selected-html`');
	        }
	
	        if (attr.mdSelectedText || attr.mdSelectedHtml) {
	          text = $parse(attr.mdSelectedText || attr.mdSelectedHtml)(scope);
	          isSelectLabelFromUser = true;
	        } else if (!text) {
	          // Use placeholder attribute, otherwise fallback to the md-input-container label
	          var tmpPlaceholder = attr.placeholder ||
	              (containerCtrl && containerCtrl.label ? containerCtrl.label.text() : '');
	
	          text = tmpPlaceholder || '';
	          isSelectLabelFromUser = true;
	        }
	
	        var target = valueEl.children().eq(0);
	
	        if (attr.mdSelectedHtml) {
	            // Using getTrustedHtml will run the content through $sanitize if it is not already
	            // explicitly trusted. If the ngSanitize module is not loaded, this will
	            // *correctly* throw an sce error.
	            target.html($sce.getTrustedHtml(text));
	        } else if (isSelectLabelFromUser) {
	          target.text(text);
	        } else {
	          // If we've reached this point, the text is not user-provided.
	          target.html(text);
	        }
	      };
	
	      mdSelectCtrl.setIsPlaceholder = function(isPlaceholder) {
	        if (isPlaceholder) {
	          valueEl.addClass('md-select-placeholder');
	          if (containerCtrl && containerCtrl.label) {
	            containerCtrl.label.addClass('md-placeholder');
	          }
	        } else {
	          valueEl.removeClass('md-select-placeholder');
	          if (containerCtrl && containerCtrl.label) {
	            containerCtrl.label.removeClass('md-placeholder');
	          }
	        }
	      };
	
	      if (!isReadonly) {
	        element
	          .on('focus', function(ev) {
	            // Always focus the container (if we have one) so floating labels and other styles are
	            // applied properly
	            containerCtrl && containerCtrl.setFocused(true);
	          });
	
	        // Attach before ngModel's blur listener to stop propagation of blur event
	        // to prevent from setting $touched.
	        element.on('blur', function(event) {
	          if (untouched) {
	            untouched = false;
	            if (selectScope._mdSelectIsOpen) {
	              event.stopImmediatePropagation();
	            }
	          }
	
	          if (selectScope._mdSelectIsOpen) return;
	          containerCtrl && containerCtrl.setFocused(false);
	          inputCheckValue();
	        });
	      }
	
	      mdSelectCtrl.triggerClose = function() {
	        $parse(attr.mdOnClose)(scope);
	      };
	
	      scope.$$postDigest(function() {
	        initAriaLabel();
	        syncLabelText();
	        syncAriaLabel();
	      });
	
	      function initAriaLabel() {
	        var labelText = element.attr('aria-label') || element.attr('placeholder');
	        if (!labelText && containerCtrl && containerCtrl.label) {
	          labelText = containerCtrl.label.text();
	        }
	        ariaLabelBase = labelText;
	        $mdAria.expect(element, 'aria-label', labelText);
	      }
	
	      scope.$watch(function() {
	        return selectMenuCtrl.selectedLabels();
	      }, syncLabelText);
	
	      function syncLabelText() {
	        if (selectContainer) {
	          selectMenuCtrl = selectMenuCtrl || selectContainer.find('md-select-menu').controller('mdSelectMenu');
	          mdSelectCtrl.setLabelText(selectMenuCtrl.selectedLabels());
	        }
	      }
	
	      function syncAriaLabel() {
	        if (!ariaLabelBase) return;
	        var ariaLabels = selectMenuCtrl.selectedLabels({mode: 'aria'});
	        element.attr('aria-label', ariaLabels.length ? ariaLabelBase + ': ' + ariaLabels : ariaLabelBase);
	      }
	
	      var deregisterWatcher;
	      attr.$observe('ngMultiple', function(val) {
	        if (deregisterWatcher) deregisterWatcher();
	        var parser = $parse(val);
	        deregisterWatcher = scope.$watch(function() {
	          return parser(scope);
	        }, function(multiple, prevVal) {
	          if (multiple === undefined && prevVal === undefined) return; // assume compiler did a good job
	          if (multiple) {
	            element.attr('multiple', 'multiple');
	          } else {
	            element.removeAttr('multiple');
	          }
	          element.attr('aria-multiselectable', multiple ? 'true' : 'false');
	          if (selectContainer) {
	            selectMenuCtrl.setMultiple(multiple);
	            originalRender = ngModelCtrl.$render;
	            ngModelCtrl.$render = function() {
	              originalRender();
	              syncLabelText();
	              syncAriaLabel();
	              inputCheckValue();
	            };
	            ngModelCtrl.$render();
	          }
	        });
	      });
	
	      attr.$observe('disabled', function(disabled) {
	        if (angular.isString(disabled)) {
	          disabled = true;
	        }
	        // Prevent click event being registered twice
	        if (isDisabled !== undefined && isDisabled === disabled) {
	          return;
	        }
	        isDisabled = disabled;
	        if (disabled) {
	          element
	            .attr({'aria-disabled': 'true'})
	            .removeAttr('tabindex')
	            .off('click', openSelect)
	            .off('keydown', handleKeypress);
	        } else {
	          element
	            .attr({'tabindex': attr.tabindex, 'aria-disabled': 'false'})
	            .on('click', openSelect)
	            .on('keydown', handleKeypress);
	        }
	      });
	
	      if (!attr.hasOwnProperty('disabled') && !attr.hasOwnProperty('ngDisabled')) {
	        element.attr({'aria-disabled': 'false'});
	        element.on('click', openSelect);
	        element.on('keydown', handleKeypress);
	      }
	
	      var ariaAttrs = {
	        role: 'listbox',
	        'aria-expanded': 'false',
	        'aria-multiselectable': isMultiple && !attr.ngMultiple ? 'true' : 'false'
	      };
	
	      if (!element[0].hasAttribute('id')) {
	        ariaAttrs.id = 'select_' + $mdUtil.nextUid();
	      }
	
	      var containerId = 'select_container_' + $mdUtil.nextUid();
	      selectContainer.attr('id', containerId);
	      // Only add aria-owns if element ownership is NOT represented in the DOM.
	      if (!element.find('md-select-menu').length) {
	        ariaAttrs['aria-owns'] = containerId;
	      }
	      element.attr(ariaAttrs);
	
	      scope.$on('$destroy', function() {
	        $mdSelect
	          .destroy()
	          .finally(function() {
	            if (containerCtrl) {
	              containerCtrl.setFocused(false);
	              containerCtrl.setHasValue(false);
	              containerCtrl.input = null;
	            }
	            ngModelCtrl.$setTouched();
	          });
	      });
	
	
	
	      function inputCheckValue() {
	        // The select counts as having a value if one or more options are selected,
	        // or if the input's validity state says it has bad input (eg string in a number input)
	        containerCtrl && containerCtrl.setHasValue(selectMenuCtrl.selectedLabels().length > 0 || (element[0].validity || {}).badInput);
	      }
	
	      function findSelectContainer() {
	        selectContainer = angular.element(
	          element[0].querySelector('.md-select-menu-container')
	        );
	        selectScope = scope;
	        if (attr.mdContainerClass) {
	          var value = selectContainer[0].getAttribute('class') + ' ' + attr.mdContainerClass;
	          selectContainer[0].setAttribute('class', value);
	        }
	        selectMenuCtrl = selectContainer.find('md-select-menu').controller('mdSelectMenu');
	        selectMenuCtrl.init(ngModelCtrl, attr.ngModel);
	        element.on('$destroy', function() {
	          selectContainer.remove();
	        });
	      }
	
	      function handleKeypress(e) {
	        if ($mdConstant.isNavigationKey(e)) {
	          // prevent page scrolling on interaction
	          e.preventDefault();
	          openSelect(e);
	        } else {
	          if (shouldHandleKey(e, $mdConstant)) {
	            e.preventDefault();
	
	            var node = selectMenuCtrl.optNodeForKeyboardSearch(e);
	            if (!node || node.hasAttribute('disabled')) return;
	            var optionCtrl = angular.element(node).controller('mdOption');
	            if (!selectMenuCtrl.isMultiple) {
	              selectMenuCtrl.deselect(Object.keys(selectMenuCtrl.selected)[0]);
	            }
	            selectMenuCtrl.select(optionCtrl.hashKey, optionCtrl.value);
	            selectMenuCtrl.refreshViewValue();
	          }
	        }
	      }
	
	      function openSelect() {
	        selectScope._mdSelectIsOpen = true;
	        element.attr('aria-expanded', 'true');
	
	        $mdSelect.show({
	          scope: selectScope,
	          preserveScope: true,
	          skipCompile: true,
	          element: selectContainer,
	          target: element[0],
	          selectCtrl: mdSelectCtrl,
	          preserveElement: true,
	          hasBackdrop: true,
	          loadingAsync: attr.mdOnOpen ? scope.$eval(attr.mdOnOpen) || true : false
	        }).finally(function() {
	          selectScope._mdSelectIsOpen = false;
	          element.focus();
	          element.attr('aria-expanded', 'false');
	          ngModelCtrl.$setTouched();
	        });
	      }
	
	    };
	  }
	}
	
	function SelectMenuDirective($parse, $mdUtil, $mdConstant, $mdTheming) {
	  // We want the scope to be set to 'false' so an isolated scope is not created
	  // which would interfere with the md-select-header's access to the
	  // parent scope.
	  SelectMenuController.$inject = ["$scope", "$attrs", "$element"];
	  return {
	    restrict: 'E',
	    require: ['mdSelectMenu'],
	    scope: false,
	    controller: SelectMenuController,
	    link: {pre: preLink}
	  };
	
	  // We use preLink instead of postLink to ensure that the select is initialized before
	  // its child options run postLink.
	  function preLink(scope, element, attr, ctrls) {
	    var selectCtrl = ctrls[0];
	
	    element.addClass('_md');     // private md component indicator for styling
	
	    $mdTheming(element);
	    element.on('click', clickListener);
	    element.on('keypress', keyListener);
	
	    function keyListener(e) {
	      if (e.keyCode == 13 || e.keyCode == 32) {
	        clickListener(e);
	      }
	    }
	
	    function clickListener(ev) {
	      var option = $mdUtil.getClosest(ev.target, 'md-option');
	      var optionCtrl = option && angular.element(option).data('$mdOptionController');
	      if (!option || !optionCtrl) return;
	      if (option.hasAttribute('disabled')) {
	        ev.stopImmediatePropagation();
	        return false;
	      }
	
	      var optionHashKey = selectCtrl.hashGetter(optionCtrl.value);
	      var isSelected = angular.isDefined(selectCtrl.selected[optionHashKey]);
	
	      scope.$apply(function() {
	        if (selectCtrl.isMultiple) {
	          if (isSelected) {
	            selectCtrl.deselect(optionHashKey);
	          } else {
	            selectCtrl.select(optionHashKey, optionCtrl.value);
	          }
	        } else {
	          if (!isSelected) {
	            selectCtrl.deselect(Object.keys(selectCtrl.selected)[0]);
	            selectCtrl.select(optionHashKey, optionCtrl.value);
	          }
	        }
	        selectCtrl.refreshViewValue();
	      });
	    }
	  }
	
	  function SelectMenuController($scope, $attrs, $element) {
	    var self = this;
	    self.isMultiple = angular.isDefined($attrs.multiple);
	    // selected is an object with keys matching all of the selected options' hashed values
	    self.selected = {};
	    // options is an object with keys matching every option's hash value,
	    // and values matching every option's controller.
	    self.options = {};
	
	    $scope.$watchCollection(function() {
	      return self.options;
	    }, function() {
	      self.ngModel.$render();
	    });
	
	    var deregisterCollectionWatch;
	    var defaultIsEmpty;
	    self.setMultiple = function(isMultiple) {
	      var ngModel = self.ngModel;
	      defaultIsEmpty = defaultIsEmpty || ngModel.$isEmpty;
	
	      self.isMultiple = isMultiple;
	      if (deregisterCollectionWatch) deregisterCollectionWatch();
	
	      if (self.isMultiple) {
	        ngModel.$validators['md-multiple'] = validateArray;
	        ngModel.$render = renderMultiple;
	
	        // watchCollection on the model because by default ngModel only watches the model's
	        // reference. This allowed the developer to also push and pop from their array.
	        $scope.$watchCollection(self.modelBinding, function(value) {
	          if (validateArray(value)) renderMultiple(value);
	        });
	
	        ngModel.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	      } else {
	        delete ngModel.$validators['md-multiple'];
	        ngModel.$render = renderSingular;
	      }
	
	      function validateArray(modelValue, viewValue) {
	        // If a value is truthy but not an array, reject it.
	        // If value is undefined/falsy, accept that it's an empty array.
	        return angular.isArray(modelValue || viewValue || []);
	      }
	    };
	
	    var searchStr = '';
	    var clearSearchTimeout, optNodes, optText;
	    var CLEAR_SEARCH_AFTER = 300;
	
	    self.optNodeForKeyboardSearch = function(e) {
	      clearSearchTimeout && clearTimeout(clearSearchTimeout);
	      clearSearchTimeout = setTimeout(function() {
	        clearSearchTimeout = undefined;
	        searchStr = '';
	        optText = undefined;
	        optNodes = undefined;
	      }, CLEAR_SEARCH_AFTER);
	
	      searchStr += e.key;
	      var search = new RegExp('^' + searchStr, 'i');
	      if (!optNodes) {
	        optNodes = $element.find('md-option');
	        optText = new Array(optNodes.length);
	        angular.forEach(optNodes, function(el, i) {
	          optText[i] = el.textContent.trim();
	        });
	      }
	      for (var i = 0; i < optText.length; ++i) {
	        if (search.test(optText[i])) {
	          return optNodes[i];
	        }
	      }
	    };
	
	    self.init = function(ngModel, binding) {
	      self.ngModel = ngModel;
	      self.modelBinding = binding;
	
	      // Setup a more robust version of isEmpty to ensure value is a valid option
	      self.ngModel.$isEmpty = function($viewValue) {
	        // We have to transform the viewValue into the hashKey, because otherwise the
	        // OptionCtrl may not exist. Developers may have specified a trackBy function.
	        return !self.options[self.hashGetter($viewValue)];
	      };
	
	      // Allow users to provide `ng-model="foo" ng-model-options="{trackBy: 'foo.id'}"` so
	      // that we can properly compare objects set on the model to the available options
	      var trackByOption = $mdUtil.getModelOption(ngModel, 'trackBy');
	
	      if (trackByOption) {
	        var trackByLocals = {};
	        var trackByParsed = $parse(trackByOption);
	        self.hashGetter = function(value, valueScope) {
	          trackByLocals.$value = value;
	          return trackByParsed(valueScope || $scope, trackByLocals);
	        };
	        // If the user doesn't provide a trackBy, we automatically generate an id for every
	        // value passed in
	      } else {
	        self.hashGetter = function getHashValue(value) {
	          if (angular.isObject(value)) {
	            return 'object_' + (value.$$mdSelectId || (value.$$mdSelectId = ++selectNextId));
	          }
	          return value;
	        };
	      }
	      self.setMultiple(self.isMultiple);
	    };
	
	    self.selectedLabels = function(opts) {
	      opts = opts || {};
	      var mode = opts.mode || 'html';
	      var selectedOptionEls = $mdUtil.nodesToArray($element[0].querySelectorAll('md-option[selected]'));
	      if (selectedOptionEls.length) {
	        var mapFn;
	
	        if (mode == 'html') {
	          // Map the given element to its innerHTML string. If the element has a child ripple
	          // container remove it from the HTML string, before returning the string.
	          mapFn = function(el) {
	            // If we do not have a `value` or `ng-value`, assume it is an empty option which clears the select
	            if (el.hasAttribute('md-option-empty')) {
	              return '';
	            }
	
	            var html = el.innerHTML;
	
	            // Remove the ripple container from the selected option, copying it would cause a CSP violation.
	            var rippleContainer = el.querySelector('.md-ripple-container');
	            if (rippleContainer) {
	              html = html.replace(rippleContainer.outerHTML, '');
	            }
	
	            // Remove the checkbox container, because it will cause the label to wrap inside of the placeholder.
	            // It should be not displayed inside of the label element.
	            var checkboxContainer = el.querySelector('.md-container');
	            if (checkboxContainer) {
	              html = html.replace(checkboxContainer.outerHTML, '');
	            }
	
	            return html;
	          };
	        } else if (mode == 'aria') {
	          mapFn = function(el) { return el.hasAttribute('aria-label') ? el.getAttribute('aria-label') : el.textContent; };
	        }
	
	        // Ensure there are no duplicates; see https://github.com/angular/material/issues/9442
	        return $mdUtil.uniq(selectedOptionEls.map(mapFn)).join(', ');
	      } else {
	        return '';
	      }
	    };
	
	    self.select = function(hashKey, hashedValue) {
	      var option = self.options[hashKey];
	      option && option.setSelected(true);
	      self.selected[hashKey] = hashedValue;
	    };
	    self.deselect = function(hashKey) {
	      var option = self.options[hashKey];
	      option && option.setSelected(false);
	      delete self.selected[hashKey];
	    };
	
	    self.addOption = function(hashKey, optionCtrl) {
	      if (angular.isDefined(self.options[hashKey])) {
	        throw new Error('Duplicate md-option values are not allowed in a select. ' +
	          'Duplicate value "' + optionCtrl.value + '" found.');
	      }
	
	      self.options[hashKey] = optionCtrl;
	
	      // If this option's value was already in our ngModel, go ahead and select it.
	      if (angular.isDefined(self.selected[hashKey])) {
	        self.select(hashKey, optionCtrl.value);
	
	        // When the current $modelValue of the ngModel Controller is using the same hash as
	        // the current option, which will be added, then we can be sure, that the validation
	        // of the option has occurred before the option was added properly.
	        // This means, that we have to manually trigger a new validation of the current option.
	        if (angular.isDefined(self.ngModel.$modelValue) && self.hashGetter(self.ngModel.$modelValue) === hashKey) {
	          self.ngModel.$validate();
	        }
	
	        self.refreshViewValue();
	      }
	    };
	    self.removeOption = function(hashKey) {
	      delete self.options[hashKey];
	      // Don't deselect an option when it's removed - the user's ngModel should be allowed
	      // to have values that do not match a currently available option.
	    };
	
	    self.refreshViewValue = function() {
	      var values = [];
	      var option;
	      for (var hashKey in self.selected) {
	        // If this hashKey has an associated option, push that option's value to the model.
	        if ((option = self.options[hashKey])) {
	          values.push(option.value);
	        } else {
	          // Otherwise, the given hashKey has no associated option, and we got it
	          // from an ngModel value at an earlier time. Push the unhashed value of
	          // this hashKey to the model.
	          // This allows the developer to put a value in the model that doesn't yet have
	          // an associated option.
	          values.push(self.selected[hashKey]);
	        }
	      }
	      var usingTrackBy = $mdUtil.getModelOption(self.ngModel, 'trackBy');
	
	      var newVal = self.isMultiple ? values : values[0];
	      var prevVal = self.ngModel.$modelValue;
	
	      if (usingTrackBy ? !angular.equals(prevVal, newVal) : (prevVal + '') !== newVal) {
	        self.ngModel.$setViewValue(newVal);
	        self.ngModel.$render();
	      }
	    };
	
	    function renderMultiple() {
	      var newSelectedValues = self.ngModel.$modelValue || self.ngModel.$viewValue || [];
	      if (!angular.isArray(newSelectedValues)) return;
	
	      var oldSelected = Object.keys(self.selected);
	
	      var newSelectedHashes = newSelectedValues.map(self.hashGetter);
	      var deselected = oldSelected.filter(function(hash) {
	        return newSelectedHashes.indexOf(hash) === -1;
	      });
	
	      deselected.forEach(self.deselect);
	      newSelectedHashes.forEach(function(hashKey, i) {
	        self.select(hashKey, newSelectedValues[i]);
	      });
	    }
	
	    function renderSingular() {
	      var value = self.ngModel.$viewValue || self.ngModel.$modelValue;
	      Object.keys(self.selected).forEach(self.deselect);
	      self.select(self.hashGetter(value), value);
	    }
	  }
	
	}
	
	function OptionDirective($mdButtonInkRipple, $mdUtil, $mdTheming) {
	
	  OptionController.$inject = ["$element"];
	  return {
	    restrict: 'E',
	    require: ['mdOption', '^^mdSelectMenu'],
	    controller: OptionController,
	    compile: compile
	  };
	
	  function compile(element, attr) {
	    // Manual transclusion to avoid the extra inner <span> that ng-transclude generates
	    element.append(angular.element('<div class="md-text">').append(element.contents()));
	
	    element.attr('tabindex', attr.tabindex || '0');
	
	    if (!hasDefinedValue(attr)) {
	      element.attr('md-option-empty', '');
	    }
	
	    return postLink;
	  }
	
	  function hasDefinedValue(attr) {
	    var value = attr.value;
	    var ngValue = attr.ngValue;
	
	    return value || ngValue;
	  }
	
	  function postLink(scope, element, attr, ctrls) {
	    var optionCtrl = ctrls[0];
	    var selectCtrl = ctrls[1];
	
	    $mdTheming(element);
	
	    if (selectCtrl.isMultiple) {
	      element.addClass('md-checkbox-enabled');
	      element.prepend(CHECKBOX_SELECTION_INDICATOR.clone());
	    }
	
	    if (angular.isDefined(attr.ngValue)) {
	      scope.$watch(attr.ngValue, setOptionValue);
	    } else if (angular.isDefined(attr.value)) {
	      setOptionValue(attr.value);
	    } else {
	      scope.$watch(function() {
	        return element.text().trim();
	      }, setOptionValue);
	    }
	
	    attr.$observe('disabled', function(disabled) {
	      if (disabled) {
	        element.attr('tabindex', '-1');
	      } else {
	        element.attr('tabindex', '0');
	      }
	    });
	
	    scope.$$postDigest(function() {
	      attr.$observe('selected', function(selected) {
	        if (!angular.isDefined(selected)) return;
	        if (typeof selected == 'string') selected = true;
	        if (selected) {
	          if (!selectCtrl.isMultiple) {
	            selectCtrl.deselect(Object.keys(selectCtrl.selected)[0]);
	          }
	          selectCtrl.select(optionCtrl.hashKey, optionCtrl.value);
	        } else {
	          selectCtrl.deselect(optionCtrl.hashKey);
	        }
	        selectCtrl.refreshViewValue();
	      });
	    });
	
	    $mdButtonInkRipple.attach(scope, element);
	    configureAria();
	
	    function setOptionValue(newValue, oldValue, prevAttempt) {
	      if (!selectCtrl.hashGetter) {
	        if (!prevAttempt) {
	          scope.$$postDigest(function() {
	            setOptionValue(newValue, oldValue, true);
	          });
	        }
	        return;
	      }
	      var oldHashKey = selectCtrl.hashGetter(oldValue, scope);
	      var newHashKey = selectCtrl.hashGetter(newValue, scope);
	
	      optionCtrl.hashKey = newHashKey;
	      optionCtrl.value = newValue;
	
	      selectCtrl.removeOption(oldHashKey, optionCtrl);
	      selectCtrl.addOption(newHashKey, optionCtrl);
	    }
	
	    scope.$on('$destroy', function() {
	      selectCtrl.removeOption(optionCtrl.hashKey, optionCtrl);
	    });
	
	    function configureAria() {
	      var ariaAttrs = {
	        'role': 'option',
	        'aria-selected': 'false'
	      };
	
	      if (!element[0].hasAttribute('id')) {
	        ariaAttrs.id = 'select_option_' + $mdUtil.nextUid();
	      }
	      element.attr(ariaAttrs);
	    }
	  }
	
	  function OptionController($element) {
	    this.selected = false;
	    this.setSelected = function(isSelected) {
	      if (isSelected && !this.selected) {
	        $element.attr({
	          'selected': 'selected',
	          'aria-selected': 'true'
	        });
	      } else if (!isSelected && this.selected) {
	        $element.removeAttr('selected');
	        $element.attr('aria-selected', 'false');
	      }
	      this.selected = isSelected;
	    };
	  }
	
	}
	
	function OptgroupDirective() {
	  return {
	    restrict: 'E',
	    compile: compile
	  };
	  function compile(el, attrs) {
	    // If we have a select header element, we don't want to add the normal label
	    // header.
	    if (!hasSelectHeader()) {
	      setupLabelElement();
	    }
	
	    function hasSelectHeader() {
	      return el.parent().find('md-select-header').length;
	    }
	
	    function setupLabelElement() {
	      var labelElement = el.find('label');
	      if (!labelElement.length) {
	        labelElement = angular.element('<label>');
	        el.prepend(labelElement);
	      }
	      labelElement.addClass('md-container-ignore');
	      labelElement.attr('aria-hidden', 'true');
	      if (attrs.label) labelElement.text(attrs.label);
	    }
	  }
	}
	
	function SelectHeaderDirective() {
	  return {
	    restrict: 'E',
	  };
	}
	
	function SelectProvider($$interimElementProvider) {
	  selectDefaultOptions.$inject = ["$mdSelect", "$mdConstant", "$mdUtil", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$document"];
	  return $$interimElementProvider('$mdSelect')
	    .setDefaults({
	      methods: ['target'],
	      options: selectDefaultOptions
	    });
	
	  /* @ngInject */
	  function selectDefaultOptions($mdSelect, $mdConstant, $mdUtil, $window, $q, $$rAF, $animateCss, $animate, $document) {
	    var ERROR_TARGET_EXPECTED = "$mdSelect.show() expected a target element in options.target but got '{0}'!";
	    var animator = $mdUtil.dom.animator;
	    var keyCodes = $mdConstant.KEY_CODE;
	
	    return {
	      parent: 'body',
	      themable: true,
	      onShow: onShow,
	      onRemove: onRemove,
	      hasBackdrop: true,
	      disableParentScroll: true
	    };
	
	    /**
	     * Interim-element onRemove logic....
	     */
	    function onRemove(scope, element, opts) {
	      var animationRunner = null;
	      var destroyListener = scope.$on('$destroy', function() {
	        // Listen for the case where the element was destroyed while there was an
	        // ongoing close animation. If this happens, we need to end the animation
	        // manually.
	        animationRunner.end();
	      });
	
	      opts = opts || { };
	      opts.cleanupInteraction();
	      opts.cleanupResizing();
	      opts.hideBackdrop();
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	      return (opts.$destroy === true) ? cleanElement() : animateRemoval().then(cleanElement);
	
	      /**
	       * For normal closes (eg clicks), animate the removal.
	       * For forced closes (like $destroy events from navigation),
	       * skip the animations
	       */
	      function animateRemoval() {
	        animationRunner = $animateCss(element, {addClass: 'md-leave'});
	        return animationRunner.start();
	      }
	
	      /**
	       * Restore the element to a closed state
	       */
	      function cleanElement() {
	        destroyListener();
	
	        element
	          .removeClass('md-active')
	          .attr('aria-hidden', 'true')
	          .css('display', 'none');
	        element.parent().find('md-select-value').removeAttr('aria-hidden');
	
	        announceClosed(opts);
	
	        if (!opts.$destroy && opts.restoreFocus) {
	          opts.target.focus();
	        }
	      }
	
	    }
	
	    /**
	     * Interim-element onShow logic....
	     */
	    function onShow(scope, element, opts) {
	
	      watchAsyncLoad();
	      sanitizeAndConfigure(scope, opts);
	
	      opts.hideBackdrop = showBackdrop(scope, element, opts);
	
	      return showDropDown(scope, element, opts)
	        .then(function(response) {
	          element.attr('aria-hidden', 'false');
	          opts.alreadyOpen = true;
	          opts.cleanupInteraction = activateInteraction();
	          opts.cleanupResizing = activateResizing();
	          autoFocus(opts.focusedNode);
	
	          return response;
	        }, opts.hideBackdrop);
	
	      // ************************************
	      // Closure Functions
	      // ************************************
	
	      /**
	       *  Attach the select DOM element(s) and animate to the correct positions
	       *  and scalings...
	       */
	      function showDropDown(scope, element, opts) {
	        if (opts.parent !== element.parent()) {
	          element.parent().attr('aria-owns', element.attr('id'));
	        }
	        element.parent().find('md-select-value').attr('aria-hidden', 'true');
	
	        opts.parent.append(element);
	
	        return $q(function(resolve, reject) {
	
	          try {
	
	            $animateCss(element, {removeClass: 'md-leave', duration: 0})
	              .start()
	              .then(positionAndFocusMenu)
	              .then(resolve);
	
	          } catch (e) {
	            reject(e);
	          }
	
	        });
	      }
	
	      /**
	       * Initialize container and dropDown menu positions/scale, then animate
	       * to show.
	       */
	      function positionAndFocusMenu() {
	        return $q(function(resolve) {
	          if (opts.isRemoved) return $q.reject(false);
	
	          var info = calculateMenuPositions(scope, element, opts);
	
	          info.container.element.css(animator.toCss(info.container.styles));
	          info.dropDown.element.css(animator.toCss(info.dropDown.styles));
	
	          $$rAF(function() {
	            element.addClass('md-active');
	            info.dropDown.element.css(animator.toCss({transform: ''}));
	
	            resolve();
	          });
	
	        });
	      }
	
	      /**
	       * Show modal backdrop element...
	       */
	      function showBackdrop(scope, element, options) {
	
	        // If we are not within a dialog...
	        if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
	          // !! DO this before creating the backdrop; since disableScrollAround()
	          //    configures the scroll offset; which is used by mdBackDrop postLink()
	          options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
	        } else {
	          options.disableParentScroll = false;
	        }
	
	        if (options.hasBackdrop) {
	          // Override duration to immediately show invisible backdrop
	          options.backdrop = $mdUtil.createBackdrop(scope, "md-select-backdrop md-click-catcher");
	          $animate.enter(options.backdrop, $document[0].body, null, {duration: 0});
	        }
	
	        /**
	         * Hide modal backdrop element...
	         */
	        return function hideBackdrop() {
	          if (options.backdrop) options.backdrop.remove();
	          if (options.disableParentScroll) options.restoreScroll();
	
	          delete options.restoreScroll;
	        };
	      }
	
	      /**
	       *
	       */
	      function autoFocus(focusedNode) {
	        if (focusedNode && !focusedNode.hasAttribute('disabled')) {
	          focusedNode.focus();
	        }
	      }
	
	      /**
	       * Check for valid opts and set some sane defaults
	       */
	      function sanitizeAndConfigure(scope, options) {
	        var selectEl = element.find('md-select-menu');
	
	        if (!options.target) {
	          throw new Error($mdUtil.supplant(ERROR_TARGET_EXPECTED, [options.target]));
	        }
	
	        angular.extend(options, {
	          isRemoved: false,
	          target: angular.element(options.target), //make sure it's not a naked dom node
	          parent: angular.element(options.parent),
	          selectEl: selectEl,
	          contentEl: element.find('md-content'),
	          optionNodes: selectEl[0].getElementsByTagName('md-option')
	        });
	      }
	
	      /**
	       * Configure various resize listeners for screen changes
	       */
	      function activateResizing() {
	        var debouncedOnResize = (function(scope, target, options) {
	
	          return function() {
	            if (options.isRemoved) return;
	
	            var updates = calculateMenuPositions(scope, target, options);
	            var container = updates.container;
	            var dropDown = updates.dropDown;
	
	            container.element.css(animator.toCss(container.styles));
	            dropDown.element.css(animator.toCss(dropDown.styles));
	          };
	
	        })(scope, element, opts);
	
	        var window = angular.element($window);
	        window.on('resize', debouncedOnResize);
	        window.on('orientationchange', debouncedOnResize);
	
	        // Publish deactivation closure...
	        return function deactivateResizing() {
	
	          // Disable resizing handlers
	          window.off('resize', debouncedOnResize);
	          window.off('orientationchange', debouncedOnResize);
	        };
	      }
	
	      /**
	       *  If asynchronously loading, watch and update internal
	       *  '$$loadingAsyncDone' flag
	       */
	      function watchAsyncLoad() {
	        if (opts.loadingAsync && !opts.isRemoved) {
	          scope.$$loadingAsyncDone = false;
	
	          $q.when(opts.loadingAsync)
	            .then(function() {
	              scope.$$loadingAsyncDone = true;
	              delete opts.loadingAsync;
	            }).then(function() {
	              $$rAF(positionAndFocusMenu);
	            });
	        }
	      }
	
	      /**
	       *
	       */
	      function activateInteraction() {
	        if (opts.isRemoved) return;
	
	        var dropDown = opts.selectEl;
	        var selectCtrl = dropDown.controller('mdSelectMenu') || {};
	
	        element.addClass('md-clickable');
	
	        // Close on backdrop click
	        opts.backdrop && opts.backdrop.on('click', onBackdropClick);
	
	        // Escape to close
	        // Cycling of options, and closing on enter
	        dropDown.on('keydown', onMenuKeyDown);
	        dropDown.on('click', checkCloseMenu);
	
	        return function cleanupInteraction() {
	          opts.backdrop && opts.backdrop.off('click', onBackdropClick);
	          dropDown.off('keydown', onMenuKeyDown);
	          dropDown.off('click', checkCloseMenu);
	
	          element.removeClass('md-clickable');
	          opts.isRemoved = true;
	        };
	
	        // ************************************
	        // Closure Functions
	        // ************************************
	
	        function onBackdropClick(e) {
	          e.preventDefault();
	          e.stopPropagation();
	          opts.restoreFocus = false;
	          $mdUtil.nextTick($mdSelect.hide, true);
	        }
	
	        function onMenuKeyDown(ev) {
	          ev.preventDefault();
	          ev.stopPropagation();
	
	          switch (ev.keyCode) {
	            case keyCodes.UP_ARROW:
	              return focusPrevOption();
	            case keyCodes.DOWN_ARROW:
	              return focusNextOption();
	            case keyCodes.SPACE:
	            case keyCodes.ENTER:
	              var option = $mdUtil.getClosest(ev.target, 'md-option');
	              if (option) {
	                dropDown.triggerHandler({
	                  type: 'click',
	                  target: option
	                });
	                ev.preventDefault();
	              }
	              checkCloseMenu(ev);
	              break;
	            case keyCodes.TAB:
	            case keyCodes.ESCAPE:
	              ev.stopPropagation();
	              ev.preventDefault();
	              opts.restoreFocus = true;
	              $mdUtil.nextTick($mdSelect.hide, true);
	              break;
	            default:
	              if (shouldHandleKey(ev, $mdConstant)) {
	                var optNode = dropDown.controller('mdSelectMenu').optNodeForKeyboardSearch(ev);
	                opts.focusedNode = optNode || opts.focusedNode;
	                optNode && optNode.focus();
	              }
	          }
	        }
	
	        function focusOption(direction) {
	          var optionsArray = $mdUtil.nodesToArray(opts.optionNodes);
	          var index = optionsArray.indexOf(opts.focusedNode);
	
	          var newOption;
	
	          do {
	            if (index === -1) {
	              // We lost the previously focused element, reset to first option
	              index = 0;
	            } else if (direction === 'next' && index < optionsArray.length - 1) {
	              index++;
	            } else if (direction === 'prev' && index > 0) {
	              index--;
	            }
	            newOption = optionsArray[index];
	            if (newOption.hasAttribute('disabled')) newOption = undefined;
	          } while (!newOption && index < optionsArray.length - 1 && index > 0);
	
	          newOption && newOption.focus();
	          opts.focusedNode = newOption;
	        }
	
	        function focusNextOption() {
	          focusOption('next');
	        }
	
	        function focusPrevOption() {
	          focusOption('prev');
	        }
	
	        function checkCloseMenu(ev) {
	          if (ev && ( ev.type == 'click') && (ev.currentTarget != dropDown[0])) return;
	          if ( mouseOnScrollbar() ) return;
	
	          var option = $mdUtil.getClosest(ev.target, 'md-option');
	          if (option && option.hasAttribute && !option.hasAttribute('disabled')) {
	            ev.preventDefault();
	            ev.stopPropagation();
	            if (!selectCtrl.isMultiple) {
	              opts.restoreFocus = true;
	
	              $mdUtil.nextTick(function () {
	                $mdSelect.hide(selectCtrl.ngModel.$viewValue);
	              }, true);
	            }
	          }
	          /**
	           * check if the mouseup event was on a scrollbar
	           */
	          function mouseOnScrollbar() {
	            var clickOnScrollbar = false;
	            if (ev && (ev.currentTarget.children.length > 0)) {
	              var child = ev.currentTarget.children[0];
	              var hasScrollbar = child.scrollHeight > child.clientHeight;
	              if (hasScrollbar && child.children.length > 0) {
	                var relPosX = ev.pageX - ev.currentTarget.getBoundingClientRect().left;
	                if (relPosX > child.querySelector('md-option').offsetWidth)
	                  clickOnScrollbar = true;
	              }
	            }
	            return clickOnScrollbar;
	          }
	        }
	      }
	
	    }
	
	    /**
	     * To notify listeners that the Select menu has closed,
	     * trigger the [optional] user-defined expression
	     */
	    function announceClosed(opts) {
	      var mdSelect = opts.selectCtrl;
	      if (mdSelect) {
	        var menuController = opts.selectEl.controller('mdSelectMenu');
	        mdSelect.setLabelText(menuController ? menuController.selectedLabels() : '');
	        mdSelect.triggerClose();
	      }
	    }
	
	
	    /**
	     * Calculate the
	     */
	    function calculateMenuPositions(scope, element, opts) {
	      var
	        containerNode = element[0],
	        targetNode = opts.target[0].children[0], // target the label
	        parentNode = $document[0].body,
	        selectNode = opts.selectEl[0],
	        contentNode = opts.contentEl[0],
	        parentRect = parentNode.getBoundingClientRect(),
	        targetRect = targetNode.getBoundingClientRect(),
	        shouldOpenAroundTarget = false,
	        bounds = {
	          left: parentRect.left + SELECT_EDGE_MARGIN,
	          top: SELECT_EDGE_MARGIN,
	          bottom: parentRect.height - SELECT_EDGE_MARGIN,
	          right: parentRect.width - SELECT_EDGE_MARGIN - ($mdUtil.floatingScrollbars() ? 16 : 0)
	        },
	        spaceAvailable = {
	          top: targetRect.top - bounds.top,
	          left: targetRect.left - bounds.left,
	          right: bounds.right - (targetRect.left + targetRect.width),
	          bottom: bounds.bottom - (targetRect.top + targetRect.height)
	        },
	        maxWidth = parentRect.width - SELECT_EDGE_MARGIN * 2,
	        selectedNode = selectNode.querySelector('md-option[selected]'),
	        optionNodes = selectNode.getElementsByTagName('md-option'),
	        optgroupNodes = selectNode.getElementsByTagName('md-optgroup'),
	        isScrollable = calculateScrollable(element, contentNode),
	        centeredNode;
	
	      var loading = isPromiseLike(opts.loadingAsync);
	      if (!loading) {
	        // If a selected node, center around that
	        if (selectedNode) {
	          centeredNode = selectedNode;
	          // If there are option groups, center around the first option group
	        } else if (optgroupNodes.length) {
	          centeredNode = optgroupNodes[0];
	          // Otherwise - if we are not loading async - center around the first optionNode
	        } else if (optionNodes.length) {
	          centeredNode = optionNodes[0];
	          // In case there are no options, center on whatever's in there... (eg progress indicator)
	        } else {
	          centeredNode = contentNode.firstElementChild || contentNode;
	        }
	      } else {
	        // If loading, center on progress indicator
	        centeredNode = contentNode.firstElementChild || contentNode;
	      }
	
	      if (contentNode.offsetWidth > maxWidth) {
	        contentNode.style['max-width'] = maxWidth + 'px';
	      } else {
	        contentNode.style.maxWidth = null;
	      }
	      if (shouldOpenAroundTarget) {
	        contentNode.style['min-width'] = targetRect.width + 'px';
	      }
	
	      // Remove padding before we compute the position of the menu
	      if (isScrollable) {
	        selectNode.classList.add('md-overflow');
	      }
	
	      var focusedNode = centeredNode;
	      if ((focusedNode.tagName || '').toUpperCase() === 'MD-OPTGROUP') {
	        focusedNode = optionNodes[0] || contentNode.firstElementChild || contentNode;
	        centeredNode = focusedNode;
	      }
	      // Cache for autoFocus()
	      opts.focusedNode = focusedNode;
	
	      // Get the selectMenuRect *after* max-width is possibly set above
	      containerNode.style.display = 'block';
	      var selectMenuRect = selectNode.getBoundingClientRect();
	      var centeredRect = getOffsetRect(centeredNode);
	
	      if (centeredNode) {
	        var centeredStyle = $window.getComputedStyle(centeredNode);
	        centeredRect.paddingLeft = parseInt(centeredStyle.paddingLeft, 10) || 0;
	        centeredRect.paddingRight = parseInt(centeredStyle.paddingRight, 10) || 0;
	      }
	
	      if (isScrollable) {
	        var scrollBuffer = contentNode.offsetHeight / 2;
	        contentNode.scrollTop = centeredRect.top + centeredRect.height / 2 - scrollBuffer;
	
	        if (spaceAvailable.top < scrollBuffer) {
	          contentNode.scrollTop = Math.min(
	            centeredRect.top,
	            contentNode.scrollTop + scrollBuffer - spaceAvailable.top
	          );
	        } else if (spaceAvailable.bottom < scrollBuffer) {
	          contentNode.scrollTop = Math.max(
	            centeredRect.top + centeredRect.height - selectMenuRect.height,
	            contentNode.scrollTop - scrollBuffer + spaceAvailable.bottom
	          );
	        }
	      }
	
	      var left, top, transformOrigin, minWidth, fontSize;
	      if (shouldOpenAroundTarget) {
	        left = targetRect.left;
	        top = targetRect.top + targetRect.height;
	        transformOrigin = '50% 0';
	        if (top + selectMenuRect.height > bounds.bottom) {
	          top = targetRect.top - selectMenuRect.height;
	          transformOrigin = '50% 100%';
	        }
	      } else {
	        left = (targetRect.left + centeredRect.left - centeredRect.paddingLeft) + 2;
	        top = Math.floor(targetRect.top + targetRect.height / 2 - centeredRect.height / 2 -
	            centeredRect.top + contentNode.scrollTop) + 2;
	
	        transformOrigin = (centeredRect.left + targetRect.width / 2) + 'px ' +
	          (centeredRect.top + centeredRect.height / 2 - contentNode.scrollTop) + 'px 0px';
	
	        minWidth = Math.min(targetRect.width + centeredRect.paddingLeft + centeredRect.paddingRight, maxWidth);
	
	        fontSize = window.getComputedStyle(targetNode)['font-size'];
	      }
	
	      // Keep left and top within the window
	      var containerRect = containerNode.getBoundingClientRect();
	      var scaleX = Math.round(100 * Math.min(targetRect.width / selectMenuRect.width, 1.0)) / 100;
	      var scaleY = Math.round(100 * Math.min(targetRect.height / selectMenuRect.height, 1.0)) / 100;
	
	      return {
	        container: {
	          element: angular.element(containerNode),
	          styles: {
	            left: Math.floor(clamp(bounds.left, left, bounds.right - containerRect.width)),
	            top: Math.floor(clamp(bounds.top, top, bounds.bottom - containerRect.height)),
	            'min-width': minWidth,
	            'font-size': fontSize
	          }
	        },
	        dropDown: {
	          element: angular.element(selectNode),
	          styles: {
	            transformOrigin: transformOrigin,
	            transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : ""
	          }
	        }
	      };
	
	    }
	
	  }
	
	  function isPromiseLike(obj) {
	    return obj && angular.isFunction(obj.then);
	  }
	
	  function clamp(min, n, max) {
	    return Math.max(min, Math.min(n, max));
	  }
	
	  function getOffsetRect(node) {
	    return node ? {
	      left: node.offsetLeft,
	      top: node.offsetTop,
	      width: node.offsetWidth,
	      height: node.offsetHeight
	    } : {left: 0, top: 0, width: 0, height: 0};
	  }
	
	  function calculateScrollable(element, contentNode) {
	    var isScrollable = false;
	
	    try {
	      var oldDisplay = element[0].style.display;
	
	      // Set the element's display to block so that this calculation is correct
	      element[0].style.display = 'block';
	
	      isScrollable = contentNode.scrollHeight > contentNode.offsetHeight;
	
	      // Reset it back afterwards
	      element[0].style.display = oldDisplay;
	    } finally {
	      // Nothing to do
	    }
	    return isScrollable;
	  }
	
	}
	
	function shouldHandleKey(ev, $mdConstant) {
	  var char = String.fromCharCode(ev.keyCode);
	  var isNonUsefulKey = (ev.keyCode <= 31);
	
	  return (char && char.length && !isNonUsefulKey &&
	    !$mdConstant.isMetaKey(ev) && !$mdConstant.isFnLockKey(ev) && !$mdConstant.hasModifierKey(ev));
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.showHide
	 */
	
	// Add additional handlers to ng-show and ng-hide that notify directives
	// contained within that they should recompute their size.
	// These run in addition to AngularJS's built-in ng-hide and ng-show directives.
	angular.module('material.components.showHide', [
	  'material.core'
	])
	  .directive('ngShow', createDirective('ngShow', true))
	  .directive('ngHide', createDirective('ngHide', false));
	
	
	function createDirective(name, targetValue) {
	  return ['$mdUtil', '$window', function($mdUtil, $window) {
	    return {
	      restrict: 'A',
	      multiElement: true,
	      link: function($scope, $element, $attr) {
	        var unregister = $scope.$on('$md-resize-enable', function() {
	          unregister();
	
	          var node = $element[0];
	          var cachedTransitionStyles = node.nodeType === $window.Node.ELEMENT_NODE ?
	            $window.getComputedStyle(node) : {};
	
	          $scope.$watch($attr[name], function(value) {
	            if (!!value === targetValue) {
	              $mdUtil.nextTick(function() {
	                $scope.$broadcast('$md-resize');
	              });
	
	              var opts = {
	                cachedTransitionStyles: cachedTransitionStyles
	              };
	
	              $mdUtil.dom.animator.waitTransitionEnd($element, opts).then(function() {
	                $scope.$broadcast('$md-resize');
	              });
	            }
	          });
	        });
	      }
	    };
	  }];
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.sidenav
	 *
	 * @description
	 * A Sidenav QP component.
	 */
	SidenavService.$inject = ["$mdComponentRegistry", "$mdUtil", "$q", "$log"];
	SidenavDirective.$inject = ["$mdMedia", "$mdUtil", "$mdConstant", "$mdTheming", "$mdInteraction", "$animate", "$compile", "$parse", "$log", "$q", "$document", "$window", "$$rAF"];
	SidenavController.$inject = ["$scope", "$attrs", "$mdComponentRegistry", "$q", "$interpolate"];
	angular
	  .module('material.components.sidenav', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .factory('$mdSidenav', SidenavService )
	  .directive('mdSidenav', SidenavDirective)
	  .directive('mdSidenavFocus', SidenavFocusDirective)
	  .controller('$mdSidenavController', SidenavController);
	
	
	/**
	 * @ngdoc service
	 * @name $mdSidenav
	 * @module material.components.sidenav
	 *
	 * @description
	 * `$mdSidenav` makes it easy to interact with multiple sidenavs
	 * in an app. When looking up a sidenav instance, you can either look
	 * it up synchronously or wait for it to be initializied asynchronously.
	 * This is done by passing the second argument to `$mdSidenav`.
	 *
	 * @usage
	 * <hljs lang="js">
	 * // Async lookup for sidenav instance; will resolve when the instance is available
	 * $mdSidenav(componentId, true).then(function(instance) {
	 *   $log.debug( componentId + "is now ready" );
	 * });
	 * // Sync lookup for sidenav instance; this will resolve immediately.
	 * $mdSidenav(componentId).then(function(instance) {
	 *   $log.debug( componentId + "is now ready" );
	 * });
	 * // Async toggle the given sidenav;
	 * // when instance is known ready and lazy lookup is not needed.
	 * $mdSidenav(componentId)
	 *    .toggle()
	 *    .then(function(){
	 *      $log.debug('toggled');
	 *    });
	 * // Async open the given sidenav
	 * $mdSidenav(componentId)
	 *    .open()
	 *    .then(function(){
	 *      $log.debug('opened');
	 *    });
	 * // Async close the given sidenav
	 * $mdSidenav(componentId)
	 *    .close()
	 *    .then(function(){
	 *      $log.debug('closed');
	 *    });
	 * // Async lookup for sidenav instance
	 * $mdSidenav(componentId, true).then(function(instance) {
	 *   // On close callback to handle close, backdrop click, or escape key pressed.
	 *   // Callback happens BEFORE the close action occurs.
	 *   instance.onClose(function() {
	 *     $log.debug('closing');
	 *   });
	 * });
	 * // Sync check to see if the specified sidenav is set to be open
	 * $mdSidenav(componentId).isOpen();
	 * // Sync check to whether given sidenav is locked open
	 * // If this is true, the sidenav will be open regardless of close()
	 * $mdSidenav(componentId).isLockedOpen();
	 * </hljs>
	 */
	function SidenavService($mdComponentRegistry, $mdUtil, $q, $log) {
	  var errorMsg = "SideNav '{0}' is not available! Did you use md-component-id='{0}'?";
	  var service = {
	        find    : findInstance,     //  sync  - returns proxy API
	        waitFor : waitForInstance   //  async - returns promise
	      };
	
	  /**
	   * Service API that supports three (3) usages:
	   *   $mdSidenav().find("left")                       // sync (must already exist) or returns undefined
	   *   $mdSidenav("left").toggle();                    // sync (must already exist) or returns reject promise;
	   *   $mdSidenav("left",true).then( function(left){   // async returns instance when available
	   *    left.toggle();
	   *   });
	   */
	  return function(handle, enableWait) {
	    if ( angular.isUndefined(handle) ) return service;
	
	    var shouldWait = enableWait === true;
	    var instance = service.find(handle, shouldWait);
	    return  !instance && shouldWait ? service.waitFor(handle) :
	            !instance && angular.isUndefined(enableWait) ? addLegacyAPI(service, handle) : instance;
	  };
	
	  /**
	   * For failed instance/handle lookups, older-clients expect an response object with noops
	   * that include `rejected promise APIs`
	   */
	  function addLegacyAPI(service, handle) {
	      var falseFn  = function() { return false; };
	      var rejectFn = function() {
	            return $q.when($mdUtil.supplant(errorMsg, [handle || ""]));
	          };
	
	      return angular.extend({
	        isLockedOpen : falseFn,
	        isOpen       : falseFn,
	        toggle       : rejectFn,
	        open         : rejectFn,
	        close        : rejectFn,
	        onClose      : angular.noop,
	        then : function(callback) {
	          return waitForInstance(handle)
	            .then(callback || angular.noop);
	        }
	       }, service);
	    }
	    /**
	     * Synchronously lookup the controller instance for the specified sidNav instance which has been
	     * registered with the markup `md-component-id`
	     */
	    function findInstance(handle, shouldWait) {
	      var instance = $mdComponentRegistry.get(handle);
	
	      if (!instance && !shouldWait) {
	
	        // Report missing instance
	        $log.error( $mdUtil.supplant(errorMsg, [handle || ""]) );
	
	        // The component has not registered itself... most like NOT yet created
	        // return null to indicate that the Sidenav is not in the DOM
	        return undefined;
	      }
	      return instance;
	    }
	
	    /**
	     * Asynchronously wait for the component instantiation,
	     * Deferred lookup of component instance using $component registry
	     */
	    function waitForInstance(handle) {
	      return $mdComponentRegistry.when(handle).catch($log.error);
	    }
	}
	/**
	 * @ngdoc directive
	 * @name mdSidenavFocus
	 * @module material.components.sidenav
	 *
	 * @restrict A
	 *
	 * @description
	 * `mdSidenavFocus` provides a way to specify the focused element when a sidenav opens.
	 * This is completely optional, as the sidenav itself is focused by default.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-sidenav>
	 *   <form>
	 *     <md-input-container>
	 *       <label for="testInput">Label</label>
	 *       <input id="testInput" type="text" md-sidenav-focus>
	 *     </md-input-container>
	 *   </form>
	 * </md-sidenav>
	 * </hljs>
	 **/
	function SidenavFocusDirective() {
	  return {
	    restrict: 'A',
	    require: '^mdSidenav',
	    link: function(scope, element, attr, sidenavCtrl) {
	      // @see $mdUtil.findFocusTarget(...)
	    }
	  };
	}
	/**
	 * @ngdoc directive
	 * @name mdSidenav
	 * @module material.components.sidenav
	 * @restrict E
	 *
	 * @description
	 *
	 * A Sidenav component that can be opened and closed programatically.
	 *
	 * By default, upon opening it will slide out on top of the main content area.
	 *
	 * For keyboard and screen reader accessibility, focus is sent to the sidenav wrapper by default.
	 * It can be overridden with the `md-autofocus` directive on the child element you want focused.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div layout="row" ng-controller="MyController">
	 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
	 *     Left Nav!
	 *   </md-sidenav>
	 *
	 *   <md-content>
	 *     Center Content
	 *     <md-button ng-click="openLeftMenu()">
	 *       Open Left Menu
	 *     </md-button>
	 *   </md-content>
	 *
	 *   <md-sidenav md-component-id="right"
	 *     md-is-locked-open="$mdMedia('min-width: 333px')"
	 *     class="md-sidenav-right">
	 *     <form>
	 *       <md-input-container>
	 *         <label for="testInput">Test input</label>
	 *         <input id="testInput" type="text"
	 *                ng-model="data" md-autofocus>
	 *       </md-input-container>
	 *     </form>
	 *   </md-sidenav>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="js">
	 * var app = angular.module('myApp', ['ngMaterial']);
	 * app.controller('MyController', function($scope, $mdSidenav) {
	 *   $scope.openLeftMenu = function() {
	 *     $mdSidenav('left').toggle();
	 *   };
	 * });
	 * </hljs>
	 *
	 * @param {expression=} md-is-open A model bound to whether the sidenav is opened.
	 * @param {boolean=} md-disable-backdrop When present in the markup, the sidenav will not show a backdrop.
	 * @param {boolean=} md-disable-close-events When present in the markup, clicking the backdrop or pressing the 'Escape' key will not close the sidenav.
	 * @param {string=} md-component-id componentId to use with $mdSidenav service.
	 * @param {expression=} md-is-locked-open When this expression evaluates to true,
	 * the sidenav 'locks open': it falls into the content's flow instead
	 * of appearing over it. This overrides the `md-is-open` attribute.
	 * @param {string=} md-disable-scroll-target Selector, pointing to an element, whose scrolling will
	 * be disabled when the sidenav is opened. By default this is the sidenav's direct parent.
	 *
	* The $mdMedia() service is exposed to the is-locked-open attribute, which
	 * can be given a media query or one of the `sm`, `gt-sm`, `md`, `gt-md`, `lg` or `gt-lg` presets.
	 * Examples:
	 *
	 *   - `<md-sidenav md-is-locked-open="shouldLockOpen"></md-sidenav>`
	 *   - `<md-sidenav md-is-locked-open="$mdMedia('min-width: 1000px')"></md-sidenav>`
	 *   - `<md-sidenav md-is-locked-open="$mdMedia('sm')"></md-sidenav>` (locks open on small screens)
	 */
	function SidenavDirective($mdMedia, $mdUtil, $mdConstant, $mdTheming, $mdInteraction, $animate,
	                          $compile, $parse, $log, $q, $document, $window, $$rAF) {
	  return {
	    restrict: 'E',
	    scope: {
	      isOpen: '=?mdIsOpen'
	    },
	    controller: '$mdSidenavController',
	    compile: function(element) {
	      element.addClass('md-closed').attr('tabIndex', '-1');
	      return postLink;
	    }
	  };
	
	  /**
	   * Directive Post Link function...
	   */
	  function postLink(scope, element, attr, sidenavCtrl) {
	    var lastParentOverFlow;
	    var backdrop;
	    var disableScrollTarget = null;
	    var triggeringInteractionType;
	    var triggeringElement = null;
	    var previousContainerStyles;
	    var promise = $q.when(true);
	    var isLockedOpenParsed = $parse(attr.mdIsLockedOpen);
	    var ngWindow = angular.element($window);
	    var isLocked = function() {
	      return isLockedOpenParsed(scope.$parent, {
	        $media: function(arg) {
	          $log.warn("$media is deprecated for is-locked-open. Use $mdMedia instead.");
	          return $mdMedia(arg);
	        },
	        $mdMedia: $mdMedia
	      });
	    };
	
	    if (attr.mdDisableScrollTarget) {
	      disableScrollTarget = $document[0].querySelector(attr.mdDisableScrollTarget);
	
	      if (disableScrollTarget) {
	        disableScrollTarget = angular.element(disableScrollTarget);
	      } else {
	        $log.warn($mdUtil.supplant('mdSidenav: couldn\'t find element matching ' +
	          'selector "{selector}". Falling back to parent.', { selector: attr.mdDisableScrollTarget }));
	      }
	    }
	
	    if (!disableScrollTarget) {
	      disableScrollTarget = element.parent();
	    }
	
	    // Only create the backdrop if the backdrop isn't disabled.
	    if (!attr.hasOwnProperty('mdDisableBackdrop')) {
	      backdrop = $mdUtil.createBackdrop(scope, "md-sidenav-backdrop md-opaque ng-enter");
	    }
	    
	    // If md-disable-close-events is set on the sidenav we will disable
	    // backdrop click and Escape key events
	    if (attr.hasOwnProperty('mdDisableCloseEvents')) {
	      var disableCloseEvents = true;
	    }
	
	    element.addClass('_md');     // private md component indicator for styling
	    $mdTheming(element);
	
	    // The backdrop should inherit the sidenavs theme,
	    // because the backdrop will take its parent theme by default.
	    if ( backdrop ) $mdTheming.inherit(backdrop, element);
	
	    element.on('$destroy', function() {
	      backdrop && backdrop.remove();
	      sidenavCtrl.destroy();
	    });
	
	    scope.$on('$destroy', function(){
	      backdrop && backdrop.remove();
	    });
	
	    scope.$watch(isLocked, updateIsLocked);
	    scope.$watch('isOpen', updateIsOpen);
	
	
	    // Publish special accessor for the Controller instance
	    sidenavCtrl.$toggleOpen = toggleOpen;
	
	    /**
	     * Toggle the DOM classes to indicate `locked`
	     * @param isLocked
	     */
	    function updateIsLocked(isLocked, oldValue) {
	      scope.isLockedOpen = isLocked;
	      if (isLocked === oldValue) {
	        element.toggleClass('md-locked-open', !!isLocked);
	      } else {
	        $animate[isLocked ? 'addClass' : 'removeClass'](element, 'md-locked-open');
	      }
	      if (backdrop) {
	        backdrop.toggleClass('md-locked-open', !!isLocked);
	      }
	    }
	
	    /**
	     * Toggle the SideNav view and attach/detach listeners
	     * @param isOpen
	     */
	    function updateIsOpen(isOpen) {
	      // Support deprecated md-sidenav-focus attribute as fallback
	      var focusEl = $mdUtil.findFocusTarget(element) || $mdUtil.findFocusTarget(element,'[md-sidenav-focus]') || element;
	      var parent = element.parent();
	
	      // If the user hasn't set the disable close events property we are adding
	      // click and escape events to close the sidenav
	      if ( !disableCloseEvents ) {
	        parent[isOpen ? 'on' : 'off']('keydown', onKeyDown);
	        if (backdrop) backdrop[isOpen ? 'on' : 'off']('click', close);
	      }
	
	      var restorePositioning = updateContainerPositions(parent, isOpen);
	
	      if ( isOpen ) {
	        // Capture upon opening..
	        triggeringElement = $document[0].activeElement;
	        triggeringInteractionType = $mdInteraction.getLastInteractionType();
	      }
	
	      disableParentScroll(isOpen);
	
	      return promise = $q.all([
	        isOpen && backdrop ? $animate.enter(backdrop, parent) : backdrop ?
	                             $animate.leave(backdrop) : $q.when(true),
	        $animate[isOpen ? 'removeClass' : 'addClass'](element, 'md-closed')
	      ]).then(function() {
	        // Perform focus when animations are ALL done...
	        if (scope.isOpen) {
	          $$rAF(function() {
	            // Notifies child components that the sidenav was opened. Should wait
	            // a frame in order to allow for the element height to be computed.
	            ngWindow.triggerHandler('resize');
	          });
	
	          focusEl && focusEl.focus();
	        }
	
	        // Restores the positioning on the sidenav and backdrop.
	        restorePositioning && restorePositioning();
	      });
	    }
	
	    function updateContainerPositions(parent, willOpen) {
	      var drawerEl = element[0];
	      var scrollTop = parent[0].scrollTop;
	
	      if (willOpen && scrollTop) {
	        previousContainerStyles = {
	          top: drawerEl.style.top,
	          bottom: drawerEl.style.bottom,
	          height: drawerEl.style.height
	        };
	
	        // When the parent is scrolled down, then we want to be able to show the sidenav at the current scroll
	        // position. We're moving the sidenav down to the correct scroll position and apply the height of the
	        // parent, to increase the performance. Using 100% as height, will impact the performance heavily.
	        var positionStyle = {
	          top: scrollTop + 'px',
	          bottom: 'auto',
	          height: parent[0].clientHeight + 'px'
	        };
	
	        // Apply the new position styles to the sidenav and backdrop.
	        element.css(positionStyle);
	        backdrop.css(positionStyle);
	      }
	
	      // When the sidenav is closing and we have previous defined container styles,
	      // then we return a restore function, which resets the sidenav and backdrop.
	      if (!willOpen && previousContainerStyles) {
	        return function() {
	          drawerEl.style.top = previousContainerStyles.top;
	          drawerEl.style.bottom = previousContainerStyles.bottom;
	          drawerEl.style.height = previousContainerStyles.height;
	
	          backdrop[0].style.top = null;
	          backdrop[0].style.bottom = null;
	          backdrop[0].style.height = null;
	
	          previousContainerStyles = null;
	        };
	      }
	    }
	
	    /**
	     * Prevent parent scrolling (when the SideNav is open)
	     */
	    function disableParentScroll(disabled) {
	      if ( disabled && !lastParentOverFlow ) {
	        lastParentOverFlow = disableScrollTarget.css('overflow');
	        disableScrollTarget.css('overflow', 'hidden');
	      } else if (angular.isDefined(lastParentOverFlow)) {
	        disableScrollTarget.css('overflow', lastParentOverFlow);
	        lastParentOverFlow = undefined;
	      }
	    }
	
	    /**
	     * Toggle the sideNav view and publish a promise to be resolved when
	     * the view animation finishes.
	     *
	     * @param isOpen
	     * @returns {*}
	     */
	    function toggleOpen( isOpen ) {
	      if (scope.isOpen == isOpen ) {
	
	        return $q.when(true);
	
	      } else {
	        if (scope.isOpen && sidenavCtrl.onCloseCb) sidenavCtrl.onCloseCb();
	
	        return $q(function(resolve){
	          // Toggle value to force an async `updateIsOpen()` to run
	          scope.isOpen = isOpen;
	
	          $mdUtil.nextTick(function() {
	            // When the current `updateIsOpen()` animation finishes
	            promise.then(function(result) {
	
	              if ( !scope.isOpen && triggeringElement && triggeringInteractionType === 'keyboard') {
	                // reset focus to originating element (if available) upon close
	                triggeringElement.focus();
	                triggeringElement = null;
	              }
	
	              resolve(result);
	            });
	          });
	
	        });
	
	      }
	    }
	
	    /**
	     * Auto-close sideNav when the `escape` key is pressed.
	     * @param evt
	     */
	    function onKeyDown(ev) {
	      var isEscape = (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE);
	      return isEscape ? close(ev) : $q.when(true);
	    }
	
	    /**
	     * With backdrop `clicks` or `escape` key-press, immediately
	     * apply the CSS close transition... Then notify the controller
	     * to close() and perform its own actions.
	     */
	    function close(ev) {
	      ev.preventDefault();
	
	      return sidenavCtrl.close();
	    }
	
	  }
	}
	
	/*
	 * @private
	 * @ngdoc controller
	 * @name SidenavController
	 * @module material.components.sidenav
	 */
	function SidenavController($scope, $attrs, $mdComponentRegistry, $q, $interpolate) {
	
	  var self = this;
	
	  // Use Default internal method until overridden by directive postLink
	
	  // Synchronous getters
	  self.isOpen = function() { return !!$scope.isOpen; };
	  self.isLockedOpen = function() { return !!$scope.isLockedOpen; };
	
	  // Synchronous setters
	  self.onClose = function (callback) {
	    self.onCloseCb = callback;
	    return self;
	  };
	
	  // Async actions
	  self.open   = function() { return self.$toggleOpen( true );  };
	  self.close  = function() { return self.$toggleOpen( false ); };
	  self.toggle = function() { return self.$toggleOpen( !$scope.isOpen );  };
	  self.$toggleOpen = function(value) { return $q.when($scope.isOpen = value); };
	
	  // Evaluate the component id.
	  var rawId = $attrs.mdComponentId;
	  var hasDataBinding = rawId && rawId.indexOf($interpolate.startSymbol()) > -1;
	  var componentId = hasDataBinding ? $interpolate(rawId)($scope.$parent) : rawId;
	
	  // Register the component.
	  self.destroy = $mdComponentRegistry.register(self, componentId);
	
	  // Watch and update the component, if the id has changed.
	  if (hasDataBinding) {
	    $attrs.$observe('mdComponentId', function(id) {
	      if (id && id !== self.$$mdHandle) {
	        self.destroy(); // `destroy` only deregisters the old component id so we can add the new one.
	        self.destroy = $mdComponentRegistry.register(self, id);
	      }
	    });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.slider
	 */
	SliderDirective.$inject = ["$$rAF", "$window", "$mdAria", "$mdUtil", "$mdConstant", "$mdTheming", "$mdGesture", "$parse", "$log", "$timeout"];
	angular.module('material.components.slider', [
	  'material.core'
	])
	.directive('mdSlider', SliderDirective)
	.directive('mdSliderContainer', SliderContainerDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdSliderContainer
	 * @module material.components.slider
	 * @restrict E
	 * @description
	 * The `<md-slider-container>` can hold the slider with two other elements.
	 * In this case, the other elements are a `span` for the label and an `input` for displaying
	 * the model value.
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-slider-container>
	 *    <span>Red</span>
	 *    <md-slider min="0" max="255" ng-model="color.red" aria-label="red" id="red-slider">
	 *    </md-slider>
	 *    <md-input-container>
	 *      <input type="number" ng-model="color.red" aria-label="Red" aria-controls="red-slider">
	 *    </md-input-container>
	 *  </md-slider-container>
	 * </hljs>
	 */
	function SliderContainerDirective() {
	  return {
	    controller: function () {},
	    compile: function (elem) {
	      var slider = elem.find('md-slider');
	
	      if (!slider) {
	        return;
	      }
	
	      var vertical = slider.attr('md-vertical');
	
	      if (vertical !== undefined) {
	        elem.attr('md-vertical', '');
	      }
	
	      if(!slider.attr('flex')) {
	        slider.attr('flex', '');
	      }
	
	      return function postLink(scope, element, attr, ctrl) {
	        element.addClass('_md');     // private md component indicator for styling
	
	        // We have to manually stop the $watch on ngDisabled because it exists
	        // on the parent scope, and won't be automatically destroyed when
	        // the component is destroyed.
	        function setDisable(value) {
	          element.children().attr('disabled', value);
	          element.find('input').attr('disabled', value);
	        }
	
	        var stopDisabledWatch = angular.noop;
	
	        if (attr.disabled) {
	          setDisable(true);
	        }
	        else if (attr.ngDisabled) {
	          stopDisabledWatch = scope.$watch(attr.ngDisabled, function (value) {
	            setDisable(value);
	          });
	        }
	
	        scope.$on('$destroy', function () {
	          stopDisabledWatch();
	        });
	
	        var initialMaxWidth;
	
	        ctrl.fitInputWidthToTextLength = function (length) {
	          var input = element[0].querySelector('md-input-container');
	
	          if (input) {
	            var computedStyle = getComputedStyle(input);
	            var minWidth = parseInt(computedStyle.minWidth);
	            var padding = parseInt(computedStyle.paddingLeft) + parseInt(computedStyle.paddingRight);
	
	            initialMaxWidth = initialMaxWidth || parseInt(computedStyle.maxWidth);
	            var newMaxWidth = Math.max(initialMaxWidth, minWidth + padding + (minWidth / 2 * length));
	
	            input.style.maxWidth = newMaxWidth + 'px';
	          }
	        };
	      };
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name mdSlider
	 * @module material.components.slider
	 * @restrict E
	 * @description
	 * The `<md-slider>` component allows the user to choose from a range of values.
	 *
	 * As per the [material design spec](https://material.io/guidelines/style/color.html#color-color-system)
	 * the slider is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * It has two modes:
	 * - "normal" mode where the user slides between a wide range of values
	 * - "discrete" mode where the user slides between only a few select values
	 *
	 * To enable discrete mode, add the `md-discrete` attribute to a slider
	 * and use the `step` attribute to change the distance between
	 * values the user is allowed to pick.
	 *
	 * When using the keyboard, holding the Meta, Control, or Alt key while pressing the left
	 * and right arrow buttons will cause the slider to move 4 steps.
	 *
	 * @usage
	 * <h4>Normal Mode</h4>
	 * <hljs lang="html">
	 * <md-slider ng-model="myValue" min="5" max="500">
	 * </md-slider>
	 * </hljs>
	 * <h4>Discrete Mode</h4>
	 * <hljs lang="html">
	 * <md-slider md-discrete ng-model="myDiscreteValue" step="10" min="10" max="130">
	 * </md-slider>
	 * </hljs>
	 * <h4>Invert Mode</h4>
	 * <hljs lang="html">
	 * <md-slider md-invert ng-model="myValue" step="10" min="10" max="130">
	 * </md-slider>
	 * </hljs>
	 *
	 * @param {expression} ng-model Assignable angular expression to be data-bound.
	 *  The expression should evaluate to a `number`.
	 * @param {boolean=} md-discrete Whether to enable discrete mode.
	 * @param {boolean=} md-invert Whether to enable invert mode.
	 * @param {number=} step The distance between values the user is allowed to pick. Default `1`.
	 * @param {number=} min The minimum value the user is allowed to pick. Default `0`.
	 * @param {number=} max The maximum value the user is allowed to pick. Default `100`.
	 * @param {number=} round The amount of numbers after the decimal point. The maximum is 6 to
	 *  prevent scientific notation. Default `3`.
	 */
	function SliderDirective($$rAF, $window, $mdAria, $mdUtil, $mdConstant, $mdTheming, $mdGesture,
	                         $parse, $log, $timeout) {
	  return {
	    scope: {},
	    require: ['?ngModel', '?^mdSliderContainer'],
	    template:
	      '<div class="md-slider-wrapper">' +
	        '<div class="md-slider-content">' +
	          '<div class="md-track-container">' +
	            '<div class="md-track"></div>' +
	            '<div class="md-track md-track-fill"></div>' +
	            '<div class="md-track-ticks"></div>' +
	          '</div>' +
	          '<div class="md-thumb-container">' +
	            '<div class="md-thumb"></div>' +
	            '<div class="md-focus-thumb"></div>' +
	            '<div class="md-focus-ring"></div>' +
	            '<div class="md-sign">' +
	              '<span class="md-thumb-text"></span>' +
	            '</div>' +
	            '<div class="md-disabled-thumb"></div>' +
	          '</div>' +
	        '</div>' +
	      '</div>',
	    compile: compile
	  };
	
	  // **********************************************************
	  // Private Methods
	  // **********************************************************
	
	  function compile (tElement, tAttrs) {
	    var wrapper = angular.element(tElement[0].getElementsByClassName('md-slider-wrapper'));
	
	    var tabIndex = tAttrs.tabindex || 0;
	    wrapper.attr('tabindex', tabIndex);
	
	    if (tAttrs.disabled || tAttrs.ngDisabled) wrapper.attr('tabindex', -1);
	
	    tElement.attr('role', 'slider');
	
	    $mdAria.expect(tElement, 'aria-label');
	
	    return postLink;
	  }
	
	  function postLink(scope, element, attr, ctrls) {
	    $mdTheming(element);
	    var ngModelCtrl = ctrls[0] || {
	      // Mock ngModelController if it doesn't exist to give us
	      // the minimum functionality needed
	      $setViewValue: function(val) {
	        this.$viewValue = val;
	        this.$viewChangeListeners.forEach(function(cb) { cb(); });
	      },
	      $parsers: [],
	      $formatters: [],
	      $viewChangeListeners: []
	    };
	
	    var containerCtrl = ctrls[1];
	    var container = angular.element($mdUtil.getClosest(element, '_md-slider-container', true));
	    var isDisabled = attr.ngDisabled ? angular.bind(null, $parse(attr.ngDisabled), scope.$parent) : function () {
	          return element[0].hasAttribute('disabled');
	        };
	
	    var thumb = angular.element(element[0].querySelector('.md-thumb'));
	    var thumbText = angular.element(element[0].querySelector('.md-thumb-text'));
	    var thumbContainer = thumb.parent();
	    var trackContainer = angular.element(element[0].querySelector('.md-track-container'));
	    var activeTrack = angular.element(element[0].querySelector('.md-track-fill'));
	    var tickContainer = angular.element(element[0].querySelector('.md-track-ticks'));
	    var wrapper = angular.element(element[0].getElementsByClassName('md-slider-wrapper'));
	    var content = angular.element(element[0].getElementsByClassName('md-slider-content'));
	    var throttledRefreshDimensions = $mdUtil.throttle(refreshSliderDimensions, 5000);
	
	    // Default values, overridable by attrs
	    var DEFAULT_ROUND = 3;
	    var vertical = angular.isDefined(attr.mdVertical);
	    var discrete = angular.isDefined(attr.mdDiscrete);
	    var invert = angular.isDefined(attr.mdInvert);
	    angular.isDefined(attr.min) ? attr.$observe('min', updateMin) : updateMin(0);
	    angular.isDefined(attr.max) ? attr.$observe('max', updateMax) : updateMax(100);
	    angular.isDefined(attr.step)? attr.$observe('step', updateStep) : updateStep(1);
	    angular.isDefined(attr.round)? attr.$observe('round', updateRound) : updateRound(DEFAULT_ROUND);
	
	    // We have to manually stop the $watch on ngDisabled because it exists
	    // on the parent scope, and won't be automatically destroyed when
	    // the component is destroyed.
	    var stopDisabledWatch = angular.noop;
	    if (attr.ngDisabled) {
	      stopDisabledWatch = scope.$parent.$watch(attr.ngDisabled, updateAriaDisabled);
	    }
	
	    $mdGesture.register(wrapper, 'drag', { horizontal: !vertical });
	
	    scope.mouseActive = false;
	
	    wrapper
	      .on('keydown', keydownListener)
	      .on('mousedown', mouseDownListener)
	      .on('focus', focusListener)
	      .on('blur', blurListener)
	      .on('$md.pressdown', onPressDown)
	      .on('$md.pressup', onPressUp)
	      .on('$md.dragstart', onDragStart)
	      .on('$md.drag', onDrag)
	      .on('$md.dragend', onDragEnd);
	
	    // On resize, recalculate the slider's dimensions and re-render
	    function updateAll() {
	      refreshSliderDimensions();
	      ngModelRender();
	    }
	    setTimeout(updateAll, 0);
	
	    var debouncedUpdateAll = $$rAF.throttle(updateAll);
	    angular.element($window).on('resize', debouncedUpdateAll);
	
	    scope.$on('$destroy', function() {
	      angular.element($window).off('resize', debouncedUpdateAll);
	    });
	
	    ngModelCtrl.$render = ngModelRender;
	    ngModelCtrl.$viewChangeListeners.push(ngModelRender);
	    ngModelCtrl.$formatters.push(minMaxValidator);
	    ngModelCtrl.$formatters.push(stepValidator);
	
	    /**
	     * Attributes
	     */
	    var min;
	    var max;
	    var step;
	    var round;
	    function updateMin(value) {
	      min = parseFloat(value);
	      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$modelValue, min, max);
	      element.attr('aria-valuemin', value);
	      updateAll();
	    }
	    function updateMax(value) {
	      max = parseFloat(value);
	      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$modelValue, min, max);
	      element.attr('aria-valuemax', value);
	      updateAll();
	    }
	    function updateStep(value) {
	      step = parseFloat(value);
	    }
	    function updateRound(value) {
	      // Set max round digits to 6, after 6 the input uses scientific notation
	      round = minMaxValidator(parseInt(value), 0, 6);
	    }
	    function updateAriaDisabled() {
	      element.attr('aria-disabled', !!isDisabled());
	    }
	
	    // Draw the ticks with canvas.
	    // The alternative to drawing ticks with canvas is to draw one element for each tick,
	    // which could quickly become a performance bottleneck.
	    var tickCanvas, tickCtx;
	    function redrawTicks() {
	      if (!discrete || isDisabled()) return;
	      if ( angular.isUndefined(step) )         return;
	
	      if ( step <= 0 ) {
	        var msg = 'Slider step value must be greater than zero when in discrete mode';
	        $log.error(msg);
	        throw new Error(msg);
	      }
	
	      var numSteps = Math.floor( (max - min) / step );
	      if (!tickCanvas) {
	        tickCanvas = angular.element('<canvas>').css('position', 'absolute');
	        tickContainer.append(tickCanvas);
	
	        tickCtx = tickCanvas[0].getContext('2d');
	      }
	
	      var dimensions = getSliderDimensions();
	
	      // If `dimensions` doesn't have height and width it might be the first attempt so we will refresh dimensions
	      if (dimensions && !dimensions.height && !dimensions.width) {
	        refreshSliderDimensions();
	        dimensions = sliderDimensions;
	      }
	
	      tickCanvas[0].width = dimensions.width;
	      tickCanvas[0].height = dimensions.height;
	
	      var distance;
	      for (var i = 0; i <= numSteps; i++) {
	        var trackTicksStyle = $window.getComputedStyle(tickContainer[0]);
	        tickCtx.fillStyle = trackTicksStyle.color || 'black';
	
	        distance = Math.floor((vertical ? dimensions.height : dimensions.width) * (i / numSteps));
	
	        tickCtx.fillRect(vertical ? 0 : distance - 1,
	          vertical ? distance - 1 : 0,
	          vertical ? dimensions.width : 2,
	          vertical ? 2 : dimensions.height);
	      }
	    }
	
	    function clearTicks() {
	      if(tickCanvas && tickCtx) {
	        var dimensions = getSliderDimensions();
	        tickCtx.clearRect(0, 0, dimensions.width, dimensions.height);
	      }
	    }
	
	    /**
	     * Refreshing Dimensions
	     */
	    var sliderDimensions = {};
	    refreshSliderDimensions();
	    function refreshSliderDimensions() {
	      sliderDimensions = trackContainer[0].getBoundingClientRect();
	    }
	    function getSliderDimensions() {
	      throttledRefreshDimensions();
	      return sliderDimensions;
	    }
	
	    /**
	     * left/right/up/down arrow listener
	     */
	    function keydownListener(ev) {
	      if (isDisabled()) return;
	
	      var changeAmount;
	      if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.DOWN_ARROW : ev.keyCode === $mdConstant.KEY_CODE.LEFT_ARROW) {
	        changeAmount = -step;
	      } else if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.UP_ARROW : ev.keyCode === $mdConstant.KEY_CODE.RIGHT_ARROW) {
	        changeAmount = step;
	      }
	      changeAmount = invert ? -changeAmount : changeAmount;
	      if (changeAmount) {
	        if (ev.metaKey || ev.ctrlKey || ev.altKey) {
	          changeAmount *= 4;
	        }
	        ev.preventDefault();
	        ev.stopPropagation();
	        scope.$evalAsync(function() {
	          setModelValue(ngModelCtrl.$viewValue + changeAmount);
	        });
	      }
	    }
	
	    function mouseDownListener() {
	      redrawTicks();
	
	      scope.mouseActive = true;
	      wrapper.removeClass('md-focused');
	
	      $timeout(function() {
	        scope.mouseActive = false;
	      }, 100);
	    }
	
	    function focusListener() {
	      if (scope.mouseActive === false) {
	        wrapper.addClass('md-focused');
	      }
	    }
	
	    function blurListener() {
	      wrapper.removeClass('md-focused');
	      element.removeClass('md-active');
	      clearTicks();
	    }
	
	    /**
	     * ngModel setters and validators
	     */
	    function setModelValue(value) {
	      ngModelCtrl.$setViewValue( minMaxValidator(stepValidator(value)) );
	    }
	    function ngModelRender() {
	      if (isNaN(ngModelCtrl.$viewValue)) {
	        ngModelCtrl.$viewValue = ngModelCtrl.$modelValue;
	      }
	
	      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$viewValue);
	
	      var percent = valueToPercent(ngModelCtrl.$viewValue);
	      scope.modelValue = ngModelCtrl.$viewValue;
	      element.attr('aria-valuenow', ngModelCtrl.$viewValue);
	      setSliderPercent(percent);
	      thumbText.text( ngModelCtrl.$viewValue );
	    }
	
	    function minMaxValidator(value, minValue, maxValue) {
	      if (angular.isNumber(value)) {
	        minValue = angular.isNumber(minValue) ? minValue : min;
	        maxValue = angular.isNumber(maxValue) ? maxValue : max;
	
	        return Math.max(minValue, Math.min(maxValue, value));
	      }
	    }
	
	    function stepValidator(value) {
	      if (angular.isNumber(value)) {
	        var formattedValue = (Math.round((value - min) / step) * step + min);
	        formattedValue = (Math.round(formattedValue * Math.pow(10, round)) / Math.pow(10, round));
	
	        if (containerCtrl && containerCtrl.fitInputWidthToTextLength){
	          $mdUtil.debounce(function () {
	            containerCtrl.fitInputWidthToTextLength(formattedValue.toString().length);
	          }, 100)();
	        }
	
	        return formattedValue;
	      }
	    }
	
	    /**
	     * @param percent 0-1
	     */
	    function setSliderPercent(percent) {
	
	      percent = clamp(percent);
	
	      var thumbPosition = (percent * 100) + '%';
	      var activeTrackPercent = invert ? (1 - percent) * 100 + '%' : thumbPosition;
	
	      if (vertical) {
	        thumbContainer.css('bottom', thumbPosition);
	      }
	      else {
	        $mdUtil.bidiProperty(thumbContainer, 'left', 'right', thumbPosition);
	      }
	
	      
	      activeTrack.css(vertical ? 'height' : 'width', activeTrackPercent);
	
	      element.toggleClass((invert ? 'md-max' : 'md-min'), percent === 0);
	      element.toggleClass((invert ? 'md-min' : 'md-max'), percent === 1);
	    }
	
	    /**
	     * Slide listeners
	     */
	    var isDragging = false;
	
	    function onPressDown(ev) {
	      if (isDisabled()) return;
	
	      element.addClass('md-active');
	      element[0].focus();
	      refreshSliderDimensions();
	
	      var exactVal = percentToValue( positionToPercent( vertical ? ev.pointer.y : ev.pointer.x ));
	      var closestVal = minMaxValidator( stepValidator(exactVal) );
	      scope.$apply(function() {
	        setModelValue( closestVal );
	        setSliderPercent( valueToPercent(closestVal));
	      });
	    }
	    function onPressUp(ev) {
	      if (isDisabled()) return;
	
	      element.removeClass('md-dragging');
	
	      var exactVal = percentToValue( positionToPercent( vertical ? ev.pointer.y : ev.pointer.x ));
	      var closestVal = minMaxValidator( stepValidator(exactVal) );
	      scope.$apply(function() {
	        setModelValue(closestVal);
	        ngModelRender();
	      });
	    }
	    function onDragStart(ev) {
	      if (isDisabled()) return;
	      isDragging = true;
	
	      ev.stopPropagation();
	
	      element.addClass('md-dragging');
	      setSliderFromEvent(ev);
	    }
	    function onDrag(ev) {
	      if (!isDragging) return;
	      ev.stopPropagation();
	      setSliderFromEvent(ev);
	    }
	    function onDragEnd(ev) {
	      if (!isDragging) return;
	      ev.stopPropagation();
	      isDragging = false;
	    }
	
	    function setSliderFromEvent(ev) {
	      // While panning discrete, update only the
	      // visual positioning but not the model value.
	      if ( discrete ) adjustThumbPosition( vertical ? ev.pointer.y : ev.pointer.x );
	      else            doSlide( vertical ? ev.pointer.y : ev.pointer.x );
	    }
	
	    /**
	     * Slide the UI by changing the model value
	     * @param x
	     */
	    function doSlide( x ) {
	      scope.$evalAsync( function() {
	        setModelValue( percentToValue( positionToPercent(x) ));
	      });
	    }
	
	    /**
	     * Slide the UI without changing the model (while dragging/panning)
	     * @param x
	     */
	    function adjustThumbPosition( x ) {
	      var exactVal = percentToValue( positionToPercent( x ));
	      var closestVal = minMaxValidator( stepValidator(exactVal) );
	      setSliderPercent( positionToPercent(x) );
	      thumbText.text( closestVal );
	    }
	
	    /**
	    * Clamps the value to be between 0 and 1.
	    * @param {number} value The value to clamp.
	    * @returns {number}
	    */
	    function clamp(value) {
	      return Math.max(0, Math.min(value || 0, 1));
	    }
	
	    /**
	     * Convert position on slider to percentage value of offset from beginning...
	     * @param position
	     * @returns {number}
	     */
	    function positionToPercent( position ) {
	      var offset = vertical ? sliderDimensions.top : sliderDimensions.left;
	      var size = vertical ? sliderDimensions.height : sliderDimensions.width;
	      var calc = (position - offset) / size;
	
	      if (!vertical && $mdUtil.bidi() === 'rtl') {
	        calc = 1 - calc;
	      }
	
	      return Math.max(0, Math.min(1, vertical ? 1 - calc : calc));
	    }
	
	    /**
	     * Convert percentage offset on slide to equivalent model value
	     * @param percent
	     * @returns {*}
	     */
	    function percentToValue( percent ) {
	      var adjustedPercent = invert ? (1 - percent) : percent;
	      return (min + adjustedPercent * (max - min));
	    }
	
	    function valueToPercent( val ) {
	      var percent = (val - min) / (max - min);
	      return invert ? (1 - percent) : percent;
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.sticky
	 * @description
	 * Sticky effects for md
	 *
	 */
	MdSticky.$inject = ["$mdConstant", "$$rAF", "$mdUtil", "$compile"];
	angular
	  .module('material.components.sticky', [
	    'material.core',
	    'material.components.content'
	  ])
	  .factory('$mdSticky', MdSticky);
	
	/**
	 * @ngdoc service
	 * @name $mdSticky
	 * @module material.components.sticky
	 *
	 * @description
	 * The `$mdSticky`service provides a mixin to make elements sticky.
	 *
	 * Whenever the current browser supports stickiness natively, the `$mdSticky` service will just
	 * use the native browser stickiness.
	 *
	 * By default the `$mdSticky` service compiles the cloned element, when not specified through the `elementClone`
	 * parameter, in the same scope as the actual element lives.
	 *
	 *
	 * <h3>Notes</h3>
	 * When using an element which is containing a compiled directive, which changed its DOM structure during compilation,
	 * you should compile the clone yourself using the plain template.<br/><br/>
	 * See the right usage below:
	 * <hljs lang="js">
	 *   angular.module('myModule')
	 *     .directive('stickySelect', function($mdSticky, $compile) {
	 *       var SELECT_TEMPLATE =
	 *         '<md-select ng-model="selected">' +
	 *           '<md-option>Option 1</md-option>' +
	 *         '</md-select>';
	 *
	 *       return {
	 *         restrict: 'E',
	 *         replace: true,
	 *         template: SELECT_TEMPLATE,
	 *         link: function(scope,element) {
	 *           $mdSticky(scope, element, $compile(SELECT_TEMPLATE)(scope));
	 *         }
	 *       };
	 *     });
	 * </hljs>
	 *
	 * @usage
	 * <hljs lang="js">
	 *   angular.module('myModule')
	 *     .directive('stickyText', function($mdSticky, $compile) {
	 *       return {
	 *         restrict: 'E',
	 *         template: '<span>Sticky Text</span>',
	 *         link: function(scope,element) {
	 *           $mdSticky(scope, element);
	 *         }
	 *       };
	 *     });
	 * </hljs>
	 *
	 * @returns A `$mdSticky` function that takes three arguments:
	 *   - `scope`
	 *   - `element`: The element that will be 'sticky'
	 *   - `elementClone`: A clone of the element, that will be shown
	 *     when the user starts scrolling past the original element.
	 *     If not provided, it will use the result of `element.clone()` and compiles it in the given scope.
	 */
	function MdSticky($mdConstant, $$rAF, $mdUtil, $compile) {
	
	  var browserStickySupport = $mdUtil.checkStickySupport();
	
	  /**
	   * Registers an element as sticky, used internally by directives to register themselves
	   */
	  return function registerStickyElement(scope, element, stickyClone) {
	    var contentCtrl = element.controller('mdContent');
	    if (!contentCtrl) return;
	
	    if (browserStickySupport) {
	      element.css({
	        position: browserStickySupport,
	        top: 0,
	        'z-index': 2
	      });
	    } else {
	      var $$sticky = contentCtrl.$element.data('$$sticky');
	      if (!$$sticky) {
	        $$sticky = setupSticky(contentCtrl);
	        contentCtrl.$element.data('$$sticky', $$sticky);
	      }
	
	      // Compile our cloned element, when cloned in this service, into the given scope.
	      var cloneElement = stickyClone || $compile(element.clone())(scope);
	
	      var deregister = $$sticky.add(element, cloneElement);
	      scope.$on('$destroy', deregister);
	    }
	  };
	
	  function setupSticky(contentCtrl) {
	    var contentEl = contentCtrl.$element;
	
	    // Refresh elements is very expensive, so we use the debounced
	    // version when possible.
	    var debouncedRefreshElements = $$rAF.throttle(refreshElements);
	
	    // setupAugmentedScrollEvents gives us `$scrollstart` and `$scroll`,
	    // more reliable than `scroll` on android.
	    setupAugmentedScrollEvents(contentEl);
	    contentEl.on('$scrollstart', debouncedRefreshElements);
	    contentEl.on('$scroll', onScroll);
	
	    var self;
	    return self = {
	      prev: null,
	      current: null, //the currently stickied item
	      next: null,
	      items: [],
	      add: add,
	      refreshElements: refreshElements
	    };
	
	    /***************
	     * Public
	     ***************/
	    // Add an element and its sticky clone to this content's sticky collection
	    function add(element, stickyClone) {
	      stickyClone.addClass('md-sticky-clone');
	
	      var item = {
	        element: element,
	        clone: stickyClone
	      };
	      self.items.push(item);
	
	      $mdUtil.nextTick(function() {
	        contentEl.prepend(item.clone);
	      });
	
	      debouncedRefreshElements();
	
	      return function remove() {
	        self.items.forEach(function(item, index) {
	          if (item.element[0] === element[0]) {
	            self.items.splice(index, 1);
	            item.clone.remove();
	          }
	        });
	        debouncedRefreshElements();
	      };
	    }
	
	    function refreshElements() {
	      // Sort our collection of elements by their current position in the DOM.
	      // We need to do this because our elements' order of being added may not
	      // be the same as their order of display.
	      self.items.forEach(refreshPosition);
	      self.items = self.items.sort(function(a, b) {
	        return a.top < b.top ? -1 : 1;
	      });
	
	      // Find which item in the list should be active, 
	      // based upon the content's current scroll position
	      var item;
	      var currentScrollTop = contentEl.prop('scrollTop');
	      for (var i = self.items.length - 1; i >= 0; i--) {
	        if (currentScrollTop > self.items[i].top) {
	          item = self.items[i];
	          break;
	        }
	      }
	      setCurrentItem(item);
	    }
	
	    /***************
	     * Private
	     ***************/
	
	    // Find the `top` of an item relative to the content element,
	    // and also the height.
	    function refreshPosition(item) {
	      // Find the top of an item by adding to the offsetHeight until we reach the 
	      // content element.
	      var current = item.element[0];
	      item.top = 0;
	      item.left = 0;
	      item.right = 0;
	      while (current && current !== contentEl[0]) {
	        item.top += current.offsetTop;
	        item.left += current.offsetLeft;
	        if ( current.offsetParent ){
	          item.right += current.offsetParent.offsetWidth - current.offsetWidth - current.offsetLeft; //Compute offsetRight
	        }
	        current = current.offsetParent;
	      }
	      item.height = item.element.prop('offsetHeight');
	
	      var defaultVal = $mdUtil.floatingScrollbars() ? '0' : undefined;
	      $mdUtil.bidi(item.clone, 'margin-left', item.left, defaultVal);
	      $mdUtil.bidi(item.clone, 'margin-right', defaultVal, item.right);
	    }
	
	    // As we scroll, push in and select the correct sticky element.
	    function onScroll() {
	      var scrollTop = contentEl.prop('scrollTop');
	      var isScrollingDown = scrollTop > (onScroll.prevScrollTop || 0);
	
	      // Store the previous scroll so we know which direction we are scrolling
	      onScroll.prevScrollTop = scrollTop;
	
	      //
	      // AT TOP (not scrolling)
	      //
	      if (scrollTop === 0) {
	        // If we're at the top, just clear the current item and return
	        setCurrentItem(null);
	        return;
	      }
	
	      //
	      // SCROLLING DOWN (going towards the next item)
	      //
	      if (isScrollingDown) {
	
	        // If we've scrolled down past the next item's position, sticky it and return
	        if (self.next && self.next.top <= scrollTop) {
	          setCurrentItem(self.next);
	          return;
	        }
	
	        // If the next item is close to the current one, push the current one up out of the way
	        if (self.current && self.next && self.next.top - scrollTop <= self.next.height) {
	          translate(self.current, scrollTop + (self.next.top - self.next.height - scrollTop));
	          return;
	        }
	      }
	
	      //
	      // SCROLLING UP (not at the top & not scrolling down; must be scrolling up)
	      //
	      if (!isScrollingDown) {
	
	        // If we've scrolled up past the previous item's position, sticky it and return
	        if (self.current && self.prev && scrollTop < self.current.top) {
	          setCurrentItem(self.prev);
	          return;
	        }
	
	        // If the next item is close to the current one, pull the current one down into view
	        if (self.next && self.current && (scrollTop >= (self.next.top - self.current.height))) {
	          translate(self.current, scrollTop + (self.next.top - scrollTop - self.current.height));
	          return;
	        }
	      }
	
	      //
	      // Otherwise, just move the current item to the proper place (scrolling up or down)
	      //
	      if (self.current) {
	        translate(self.current, scrollTop);
	      }
	    }
	
	    function setCurrentItem(item) {
	      if (self.current === item) return;
	      // Deactivate currently active item
	      if (self.current) {
	        translate(self.current, null);
	        setStickyState(self.current, null);
	      }
	
	      // Activate new item if given
	      if (item) {
	        setStickyState(item, 'active');
	      }
	
	      self.current = item;
	      var index = self.items.indexOf(item);
	      // If index === -1, index + 1 = 0. It works out.
	      self.next = self.items[index + 1];
	      self.prev = self.items[index - 1];
	      setStickyState(self.next, 'next');
	      setStickyState(self.prev, 'prev');
	    }
	
	    function setStickyState(item, state) {
	      if (!item || item.state === state) return;
	      if (item.state) {
	        item.clone.attr('sticky-prev-state', item.state);
	        item.element.attr('sticky-prev-state', item.state);
	      }
	      item.clone.attr('sticky-state', state);
	      item.element.attr('sticky-state', state);
	      item.state = state;
	    }
	
	    function translate(item, amount) {
	      if (!item) return;
	      if (amount === null || amount === undefined) {
	        if (item.translateY) {
	          item.translateY = null;
	          item.clone.css($mdConstant.CSS.TRANSFORM, '');
	        }
	      } else {
	        item.translateY = amount;
	
	        $mdUtil.bidi( item.clone, $mdConstant.CSS.TRANSFORM,
	          'translate3d(' + item.left + 'px,' + amount + 'px,0)',
	          'translateY(' + amount + 'px)'
	        );
	      }
	    }
	  }
	
	
	  // Android 4.4 don't accurately give scroll events.
	  // To fix this problem, we setup a fake scroll event. We say:
	  // > If a scroll or touchmove event has happened in the last DELAY milliseconds, 
	  //   then send a `$scroll` event every animationFrame.
	  // Additionally, we add $scrollstart and $scrollend events.
	  function setupAugmentedScrollEvents(element) {
	    var SCROLL_END_DELAY = 200;
	    var isScrolling;
	    var lastScrollTime;
	    element.on('scroll touchmove', function() {
	      if (!isScrolling) {
	        isScrolling = true;
	        $$rAF.throttle(loopScrollEvent);
	        element.triggerHandler('$scrollstart');
	      }
	      element.triggerHandler('$scroll');
	      lastScrollTime = +$mdUtil.now();
	    });
	
	    function loopScrollEvent() {
	      if (+$mdUtil.now() - lastScrollTime > SCROLL_END_DELAY) {
	        isScrolling = false;
	        element.triggerHandler('$scrollend');
	      } else {
	        element.triggerHandler('$scroll');
	        $$rAF.throttle(loopScrollEvent);
	      }
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.subheader
	 * @description
	 * SubHeader module
	 *
	 *  Subheaders are special list tiles that delineate distinct sections of a
	 *  list or grid list and are typically related to the current filtering or
	 *  sorting criteria. Subheader tiles are either displayed inline with tiles or
	 *  can be associated with content, for example, in an adjacent column.
	 *
	 *  Upon scrolling, subheaders remain pinned to the top of the screen and remain
	 *  pinned until pushed on or off screen by the next subheader. @see [Material
	 *  Design Specifications](https://www.google.com/design/spec/components/subheaders.html)
	 *
	 *  > To improve the visual grouping of content, use the system color for your subheaders.
	 *
	 */
	MdSubheaderDirective.$inject = ["$mdSticky", "$compile", "$mdTheming", "$mdUtil", "$mdAria"];
	angular
	  .module('material.components.subheader', [
	    'material.core',
	    'material.components.sticky'
	  ])
	  .directive('mdSubheader', MdSubheaderDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdSubheader
	 * @module material.components.subheader
	 *
	 * @restrict E
	 *
	 * @description
	 * The `md-subheader` directive creates a sticky subheader for a section.
	 *
	 * Developers are able to disable the stickiness of the subheader by using the following markup
	 *
	 * <hljs lang="html">
	 *   <md-subheader class="md-no-sticky">Not Sticky</md-subheader>
	 * </hljs>
	 *
	 * ### Notes
	 * - The `md-subheader` directive uses the <a ng-href="api/service/$mdSticky">$mdSticky</a> service
	 * to make the subheader sticky.
	 *
	 * > Whenever the current browser doesn't support stickiness natively, the subheader
	 * will be compiled twice to create a sticky clone of the subheader.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-subheader>Online Friends</md-subheader>
	 * </hljs>
	 */
	
	function MdSubheaderDirective($mdSticky, $compile, $mdTheming, $mdUtil, $mdAria) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: true,
	    template: (
	    '<div class="md-subheader _md">' +
	    '  <div class="md-subheader-inner">' +
	    '    <div class="md-subheader-content"></div>' +
	    '  </div>' +
	    '</div>'
	    ),
	    link: function postLink(scope, element, attr, controllers, transclude) {
	      $mdTheming(element);
	      element.addClass('_md');
	
	      // Remove the ngRepeat attribute from the root element, because we don't want to compile
	      // the ngRepeat for the sticky clone again.
	      $mdUtil.prefixer().removeAttribute(element, 'ng-repeat');
	
	      var outerHTML = element[0].outerHTML;
	
	      function getContent(el) {
	        return angular.element(el[0].querySelector('.md-subheader-content'));
	      }
	
	      // Set the ARIA attributes on the original element since it keeps it's original place in
	      // the DOM, whereas the clones are in reverse order. Should be done after the outerHTML,
	      // in order to avoid having multiple element be marked as headers.
	      attr.$set('role', 'heading');
	      $mdAria.expect(element, 'aria-level', '2');
	
	      // Transclude the user-given contents of the subheader
	      // the conventional way.
	      transclude(scope, function(clone) {
	        getContent(element).append(clone);
	      });
	
	      // Create another clone, that uses the outer and inner contents
	      // of the element, that will be 'stickied' as the user scrolls.
	      if (!element.hasClass('md-no-sticky')) {
	        transclude(scope, function(clone) {
	          // If the user adds an ng-if or ng-repeat directly to the md-subheader element, the
	          // compiled clone below will only be a comment tag (since they replace their elements with
	          // a comment) which cannot be properly passed to the $mdSticky; so we wrap it in our own
	          // DIV to ensure we have something $mdSticky can use
	          var wrapper = $compile('<div class="md-subheader-wrapper" aria-hidden="true">' + outerHTML + '</div>')(scope);
	
	          // Delay initialization until after any `ng-if`/`ng-repeat`/etc has finished before
	          // attempting to create the clone
	          $mdUtil.nextTick(function() {
	            // Append our transcluded clone into the wrapper.
	            // We don't have to recompile the element again, because the clone is already
	            // compiled in it's transclusion scope. If we recompile the outerHTML of the new clone, we would lose
	            // our ngIf's and other previous registered bindings / properties.
	            getContent(wrapper).append(clone);
	          });
	
	          // Make the element sticky and provide the stickyClone our self, to avoid recompilation of the subheader
	          // element.
	          $mdSticky(scope, element, wrapper);
	        });
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.swipe
	 * @description Swipe module!
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeLeft
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-left directive allows you to specify custom behavior when an element is swiped
	 * left.
	 *
	 * ### Notes
	 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
	 * reference to the element that actually holds the `md-swipe-left` directive by using `$target.current`
	 *
	 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer Tools console while swiping).
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-left="onSwipeLeft($event, $target)">Swipe me left!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeRight
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-right directive allows you to specify custom behavior when an element is swiped
	 * right.
	 *
	 * ### Notes
	 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
	 * reference to the element that actually holds the `md-swipe-right` directive by using `$target.current`
	 *
	 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer Tools console while swiping).
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-right="onSwipeRight($event, $target)">Swipe me right!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeUp
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-up directive allows you to specify custom behavior when an element is swiped
	 * up.
	 *
	 * ### Notes
	 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
	 * reference to the element that actually holds the `md-swipe-up` directive by using `$target.current`
	 *
	 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer Tools console while swiping).
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-up="onSwipeUp($event, $target)">Swipe me up!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeDown
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-down directive allows you to specify custom behavior when an element is swiped
	 * down.
	 *
	 * ### Notes
	 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
	 * reference to the element that actually holds the `md-swipe-down` directive by using `$target.current`
	 *
	 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer Tools console while swiping).
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-down="onSwipDown($event, $target)">Swipe me down!</div>
	 * </hljs>
	 */
	
	angular.module('material.components.swipe', ['material.core'])
	    .directive('mdSwipeLeft', getDirective('SwipeLeft'))
	    .directive('mdSwipeRight', getDirective('SwipeRight'))
	    .directive('mdSwipeUp', getDirective('SwipeUp'))
	    .directive('mdSwipeDown', getDirective('SwipeDown'));
	
	function getDirective(name) {
	    DirectiveFactory.$inject = ["$parse"];
	  var directiveName = 'md' + name;
	  var eventName = '$md.' + name.toLowerCase();
	
	  return DirectiveFactory;
	
	  /* @ngInject */
	  function DirectiveFactory($parse) {
	      return { restrict: 'A', link: postLink };
	      function postLink(scope, element, attr) {
	        var fn = $parse(attr[directiveName]);
	        element.on(eventName, function(ev) {
	          var currentTarget = ev.currentTarget;
	          scope.$applyAsync(function() { fn(scope, { $event: ev, $target: { current: currentTarget } }); });
	        });
	      }
	    }
	}
	
	
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.switch
	 */
	
	MdSwitch.$inject = ["mdCheckboxDirective", "$mdUtil", "$mdConstant", "$parse", "$$rAF", "$mdGesture", "$timeout"];
	angular.module('material.components.switch', [
	  'material.core',
	  'material.components.checkbox'
	])
	  .directive('mdSwitch', MdSwitch);
	
	/**
	 * @ngdoc directive
	 * @module material.components.switch
	 * @name mdSwitch
	 * @restrict E
	 *
	 * The switch directive is used very much like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
	 * the switch is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * @param {expression} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
	 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
	 * @param {expression=} ng-change Expression to be executed when the model value changes.
	 * @param {expression=} ng-disabled En/Disable based on the expression.
	 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects.
	 * @param {string=} aria-label Publish the button label used by screen-readers for accessibility. Defaults to the switch's text.
	 * @param {boolean=} md-invert When set to true, the switch will be inverted.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-switch ng-model="isActive" aria-label="Finished?">
	 *   Finished ?
	 * </md-switch>
	 *
	 * <md-switch md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
	 *   No Ink Effects
	 * </md-switch>
	 *
	 * <md-switch ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
	 *   Disabled
	 * </md-switch>
	 *
	 * </hljs>
	 */
	function MdSwitch(mdCheckboxDirective, $mdUtil, $mdConstant, $parse, $$rAF, $mdGesture, $timeout) {
	  var checkboxDirective = mdCheckboxDirective[0];
	
	  return {
	    restrict: 'E',
	    priority: $mdConstant.BEFORE_NG_ARIA,
	    transclude: true,
	    template:
	      '<div class="md-container">' +
	        '<div class="md-bar"></div>' +
	        '<div class="md-thumb-container">' +
	          '<div class="md-thumb" md-ink-ripple md-ink-ripple-checkbox></div>' +
	        '</div>'+
	      '</div>' +
	      '<div ng-transclude class="md-label"></div>',
	    require: ['^?mdInputContainer', '?ngModel', '?^form'],
	    compile: mdSwitchCompile
	  };
	
	  function mdSwitchCompile(element, attr) {
	    var checkboxLink = checkboxDirective.compile(element, attr).post;
	    // No transition on initial load.
	    element.addClass('md-dragging');
	
	    return function (scope, element, attr, ctrls) {
	      var containerCtrl = ctrls[0];
	      var ngModel = ctrls[1] || $mdUtil.fakeNgModel();
	      var formCtrl = ctrls[2];
	
	      var disabledGetter = null;
	      if (attr.disabled != null) {
	        disabledGetter = function() { return true; };
	      } else if (attr.ngDisabled) {
	        disabledGetter = $parse(attr.ngDisabled);
	      }
	
	      var thumbContainer = angular.element(element[0].querySelector('.md-thumb-container'));
	      var switchContainer = angular.element(element[0].querySelector('.md-container'));
	      var labelContainer = angular.element(element[0].querySelector('.md-label'));
	
	      // no transition on initial load
	      $$rAF(function() {
	        element.removeClass('md-dragging');
	      });
	
	      checkboxLink(scope, element, attr, ctrls);
	
	      if (disabledGetter) {
	        scope.$watch(disabledGetter, function(isDisabled) {
	          element.attr('tabindex', isDisabled ? -1 : 0);
	        });
	      }
	
	      attr.$observe('mdInvert', function(newValue) {
	        var isInverted = $mdUtil.parseAttributeBoolean(newValue);
	
	        isInverted ? element.prepend(labelContainer) : element.prepend(switchContainer);
	
	        // Toggle a CSS class to update the margin.
	        element.toggleClass('md-inverted', isInverted);
	      });
	
	      // These events are triggered by setup drag
	      $mdGesture.register(switchContainer, 'drag');
	      switchContainer
	        .on('$md.dragstart', onDragStart)
	        .on('$md.drag', onDrag)
	        .on('$md.dragend', onDragEnd);
	
	      var drag;
	      function onDragStart(ev) {
	        // Don't go if the switch is disabled.
	        if (disabledGetter && disabledGetter(scope)) return;
	        ev.stopPropagation();
	
	        element.addClass('md-dragging');
	        drag = {width: thumbContainer.prop('offsetWidth')};
	      }
	
	      function onDrag(ev) {
	        if (!drag) return;
	        ev.stopPropagation();
	        ev.srcEvent && ev.srcEvent.preventDefault();
	
	        var percent = ev.pointer.distanceX / drag.width;
	
	        //if checked, start from right. else, start from left
	        var translate = ngModel.$viewValue ?  1 + percent : percent;
	        // Make sure the switch stays inside its bounds, 0-1%
	        translate = Math.max(0, Math.min(1, translate));
	
	        thumbContainer.css($mdConstant.CSS.TRANSFORM, 'translate3d(' + (100*translate) + '%,0,0)');
	        drag.translate = translate;
	      }
	
	      function onDragEnd(ev) {
	        if (!drag) return;
	        ev.stopPropagation();
	
	        element.removeClass('md-dragging');
	        thumbContainer.css($mdConstant.CSS.TRANSFORM, '');
	
	        // We changed if there is no distance (this is a click a click),
	        // or if the drag distance is >50% of the total.
	        var isChanged = ngModel.$viewValue ? drag.translate < 0.5 : drag.translate > 0.5;
	        if (isChanged) {
	          applyModelValue(!ngModel.$viewValue);
	        }
	        drag = null;
	
	        // Wait for incoming mouse click
	        scope.skipToggle = true;
	        $timeout(function() {
	          scope.skipToggle = false;
	        }, 1);
	      }
	
	      function applyModelValue(newValue) {
	        scope.$apply(function() {
	          ngModel.$setViewValue(newValue);
	          ngModel.$render();
	        });
	      }
	
	    };
	  }
	
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.tabs
	 * @description
	 *
	 *  Tabs, created with the `<md-tabs>` directive provide *tabbed* navigation with different styles.
	 *  The Tabs component consists of clickable tabs that are aligned horizontally side-by-side.
	 *
	 *  Features include support for:
	 *
	 *  - static or dynamic tabs,
	 *  - responsive designs,
	 *  - accessibility support (ARIA),
	 *  - tab pagination,
	 *  - external or internal tab content,
	 *  - focus indicators and arrow-key navigations,
	 *  - programmatic lookup and access to tab controllers, and
	 *  - dynamic transitions through different tab contents.
	 *
	 */
	/*
	 * @see js folder for tabs implementation
	 */
	angular.module('material.components.tabs', [
	  'material.core',
	  'material.components.icon'
	]);
	
	})();
	(function(){
	"use strict";
	
	angular
	.module('material.components.tabs')
	.service('MdTabsPaginationService', MdTabsPaginationService);
	
	/**
	 * @private
	 * @module material.components.tabs
	 * @name MdTabsPaginationService
	 * @description Provides many standalone functions to ease in pagination calculations.
	 *
	 * Most functions accept the elements and the current offset.
	 *
	 * The `elements` parameter is typically the value returned from the `getElements()` function of the
	 * tabsController.
	 *
	 * The `offset` parameter is always positive regardless of LTR or RTL (we simply make the LTR one
	 * negative when we apply our transform). This is typically the `ctrl.leftOffset` variable in the
	 * tabsController.
	 *
	 * @returns MdTabsPaginationService
	 * @constructor
	 */
	function MdTabsPaginationService() {
	  return {
	    decreasePageOffset: decreasePageOffset,
	    increasePageOffset: increasePageOffset,
	    getTabOffsets: getTabOffsets,
	    getTotalTabsWidth: getTotalTabsWidth
	  };
	
	  /**
	   * Returns the offset for the next decreasing page.
	   *
	   * @param elements
	   * @param currentOffset
	   * @returns {number}
	   */
	  function decreasePageOffset(elements, currentOffset) {
	    var canvas       = elements.canvas,
	        tabOffsets   = getTabOffsets(elements),
	        i, firstVisibleTabOffset;
	
	    // Find the first fully visible tab in offset range
	    for (i = 0; i < tabOffsets.length; i++) {
	      if (tabOffsets[i] >= currentOffset) {
	        firstVisibleTabOffset = tabOffsets[i];
	        break;
	      }
	    }
	
	    // Return (the first visible tab offset - the tabs container width) without going negative
	    return Math.max(0, firstVisibleTabOffset - canvas.clientWidth);
	  }
	
	  /**
	   * Returns the offset for the next increasing page.
	   *
	   * @param elements
	   * @param currentOffset
	   * @returns {number}
	   */
	  function increasePageOffset(elements, currentOffset) {
	    var canvas       = elements.canvas,
	        maxOffset    = getTotalTabsWidth(elements) - canvas.clientWidth,
	        tabOffsets   = getTabOffsets(elements),
	        i, firstHiddenTabOffset;
	
	    // Find the first partially (or fully) invisible tab
	    for (i = 0; i < tabOffsets.length, tabOffsets[i] <= currentOffset + canvas.clientWidth; i++) {
	      firstHiddenTabOffset = tabOffsets[i];
	    }
	
	    // Return the offset of the first hidden tab, or the maximum offset (whichever is smaller)
	    return Math.min(maxOffset, firstHiddenTabOffset);
	  }
	
	  /**
	   * Returns the offsets of all of the tabs based on their widths.
	   *
	   * @param elements
	   * @returns {number[]}
	   */
	  function getTabOffsets(elements) {
	    var i, tab, currentOffset = 0, offsets = [];
	
	    for (i = 0; i < elements.tabs.length; i++) {
	      tab = elements.tabs[i];
	      offsets.push(currentOffset);
	      currentOffset += tab.offsetWidth;
	    }
	
	    return offsets;
	  }
	
	  /**
	   * Sum the width of all tabs.
	   *
	   * @param elements
	   * @returns {number}
	   */
	  function getTotalTabsWidth(elements) {
	    var sum = 0, i, tab;
	
	    for (i = 0; i < elements.tabs.length; i++) {
	      tab = elements.tabs[i];
	      sum += tab.offsetWidth;
	    }
	
	    return sum;
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	  * @ngdoc module
	  * @name material.components.toast
	  * @description
	  * Toast
	  */
	MdToastDirective.$inject = ["$mdToast"];
	MdToastProvider.$inject = ["$$interimElementProvider"];
	angular.module('material.components.toast', [
	  'material.core',
	  'material.components.button'
	])
	  .directive('mdToast', MdToastDirective)
	  .provider('$mdToast', MdToastProvider);
	
	/* @ngInject */
	function MdToastDirective($mdToast) {
	  return {
	    restrict: 'E',
	    link: function postLink(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      // When navigation force destroys an interimElement, then
	      // listen and $destroy() that interim instance...
	      scope.$on('$destroy', function() {
	        $mdToast.destroy();
	      });
	    }
	  };
	}
	
	/**
	  * @ngdoc service
	  * @name $mdToast
	  * @module material.components.toast
	  *
	  * @description
	  * `$mdToast` is a service to build a toast notification on any position
	  * on the screen with an optional duration, and provides a simple promise API.
	  *
	  * The toast will be always positioned at the `bottom`, when the screen size is
	  * between `600px` and `959px` (`sm` breakpoint)
	  *
	  * ## Restrictions on custom toasts
	  * - The toast's template must have an outer `<md-toast>` element.
	  * - For a toast action, use element with class `md-action`.
	  * - Add the class `md-capsule` for curved corners.
	  *
	  * ### Custom Presets
	  * Developers are also able to create their own preset, which can be easily used without repeating
	  * their options each time.
	  *
	  * <hljs lang="js">
	  *   $mdToastProvider.addPreset('testPreset', {
	  *     options: function() {
	  *       return {
	  *         template:
	  *           '<md-toast>' +
	  *             '<div class="md-toast-content">' +
	  *               'This is a custom preset' +
	  *             '</div>' +
	  *           '</md-toast>',
	  *         controllerAs: 'toast',
	  *         bindToController: true
	  *       };
	  *     }
	  *   });
	  * </hljs>
	  *
	  * After you created your preset at config phase, you can easily access it.
	  *
	  * <hljs lang="js">
	  *   $mdToast.show(
	  *     $mdToast.testPreset()
	  *   );
	  * </hljs>
	  *
	  * ## Parent container notes
	  *
	  * The toast is positioned using absolute positioning relative to its first non-static parent
	  * container. Thus, if the requested parent container uses static positioning, we will temporarily
	  * set its positioning to `relative` while the toast is visible and reset it when the toast is
	  * hidden.
	  *
	  * Because of this, it is usually best to ensure that the parent container has a fixed height and
	  * prevents scrolling by setting the `overflow: hidden;` style. Since the position is based off of
	  * the parent's height, the toast may be mispositioned if you allow the parent to scroll.
	  *
	  * You can, however, have a scrollable element inside of the container; just make sure the
	  * container itself does not scroll.
	  *
	  * <hljs lang="html">
	  * <div layout-fill id="toast-container">
	  *   <md-content>
	  *     I can have lots of content and scroll!
	  *   </md-content>
	  * </div>
	  * </hljs>
	  *
	  * @usage
	  * <hljs lang="html">
	  * <div ng-controller="MyController">
	  *   <md-button ng-click="openToast()">
	  *     Open a Toast!
	  *   </md-button>
	  * </div>
	  * </hljs>
	  *
	  * <hljs lang="js">
	  * var app = angular.module('app', ['ngMaterial']);
	  * app.controller('MyController', function($scope, $mdToast) {
	  *   $scope.openToast = function($event) {
	  *     $mdToast.show($mdToast.simple().textContent('Hello!'));
	  *     // Could also do $mdToast.showSimple('Hello');
	  *   };
	  * });
	  * </hljs>
	  */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#showSimple
	 *
	 * @param {string} message The message to display inside the toast
	 * @description
	 * Convenience method which builds and shows a simple toast.
	 *
	 * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
	 * rejected with `$mdToast.cancel()`.
	 *
	 */
	
	 /**
	  * @ngdoc method
	  * @name $mdToast#simple
	  *
	  * @description
	  * Builds a preconfigured toast.
	  *
	  * @returns {obj} a `$mdToastPreset` with the following chainable configuration methods.
	  *
	  * _**Note:** These configuration methods are provided in addition to the methods provided by
	  * the `build()` and `show()` methods below._
	  *
	  * <table class="md-api-table methods">
	  *    <thead>
	  *      <tr>
	  *        <th>Method</th>
	  *        <th>Description</th>
	  *      </tr>
	  *    </thead>
	  *    <tbody>
	  *      <tr>
	  *        <td>`.textContent(string)`</td>
	  *        <td>Sets the toast content to the specified string</td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.action(string)`</td>
	  *        <td>
	  *          Adds an action button. <br/>
	  *          If clicked, the promise (returned from `show()`)
	  *          will resolve with the value `'ok'`; otherwise, it is resolved with `true` after a `hideDelay`
	  *          timeout
	  *        </td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.highlightAction(boolean)`</td>
	  *        <td>
	  *          Whether or not the action button will have an additional highlight class.<br/>
	  *          By default the `accent` color will be applied to the action button.
	  *        </td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.highlightClass(string)`</td>
	  *        <td>
	  *          If set, the given class will be applied to the highlighted action button.<br/>
	  *          This allows you to specify the highlight color easily. Highlight classes are `md-primary`, `md-warn`
	  *          and `md-accent`
	  *        </td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.capsule(boolean)`</td>
	  *        <td>Whether or not to add the `md-capsule` class to the toast to provide rounded corners</td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.theme(string)`</td>
	  *        <td>Sets the theme on the toast to the requested theme. Default is `$mdThemingProvider`'s default.</td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.toastClass(string)`</td>
	  *        <td>Sets a class on the toast element</td>
	  *      </tr>
	  *    </tbody>
	  * </table>
	  *
	  */
	
	/**
	  * @ngdoc method
	  * @name $mdToast#updateTextContent
	  *
	  * @description
	  * Updates the content of an existing toast. Useful for updating things like counts, etc.
	  *
	  */
	
	 /**
	  * @ngdoc method
	  * @name $mdToast#build
	  *
	  * @description
	  * Creates a custom `$mdToastPreset` that you can configure.
	  *
	  * @returns {obj} a `$mdToastPreset` with the chainable configuration methods for shows' options (see below).
	  */
	
	 /**
	  * @ngdoc method
	  * @name $mdToast#show
	  *
	  * @description Shows the toast.
	  *
	  * @param {object} optionsOrPreset Either provide an `$mdToastPreset` returned from `simple()`
	  * and `build()`, or an options object with the following properties:
	  *
	  *   - `templateUrl` - `{string=}`: The url of an html template file that will
	  *     be used as the content of the toast. Restrictions: the template must
	  *     have an outer `md-toast` element.
	  *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
	  *     template string.
	  *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template content with a
	  *     `<div class="md-toast-content">` if one is not provided. Defaults to true. Can be disabled if you provide a
	  *     custom toast directive.
	  *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified, it will create a new child scope.
	  *     This scope will be destroyed when the toast is removed unless `preserveScope` is set to true.
	  *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	  *   - `hideDelay` - `{number=}`: How many milliseconds the toast should stay
	  *     active before automatically closing.  Set to 0 or false to have the toast stay open until
	  *     closed manually. Default: 3000.
	  *   - `position` - `{string=}`: Sets the position of the toast. <br/>
	  *     Available: any combination of `'bottom'`, `'left'`, `'top'`, `'right'`, `'end'` and `'start'`.
	  *     The properties `'end'` and `'start'` are dynamic and can be used for RTL support.<br/>
	  *     Default combination: `'bottom left'`.
	  *   - `toastClass` - `{string=}`: A class to set on the toast element.
	  *   - `controller` - `{string=}`: The controller to associate with this toast.
	  *     The controller will be injected the local `$mdToast.hide( )`, which is a function
	  *     used to hide the toast.
	  *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will
	  *     be used as names of values to inject into the controller. For example,
	  *     `locals: {three: 3}` would inject `three` into the controller with the value
	  *     of 3.
	  *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
	  *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
	  *     and the toast will not open until the promises resolve.
	  *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	  *   - `parent` - `{element=}`: The element to append the toast to. Defaults to appending
	  *     to the root element of the application.
	  *
	  * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
	  * rejected with `$mdToast.cancel()`. `$mdToast.hide()` will resolve either with a Boolean
	  * value == 'true' or the value passed as an argument to `$mdToast.hide()`.
	  * And `$mdToast.cancel()` will resolve the promise with a Boolean value == 'false'
	  */
	
	/**
	  * @ngdoc method
	  * @name $mdToast#hide
	  *
	  * @description
	  * Hide an existing toast and resolve the promise returned from `$mdToast.show()`.
	  *
	  * @param {*=} response An argument for the resolved promise.
	  *
	  * @returns {promise} a promise that is called when the existing element is removed from the DOM.
	  * The promise is resolved with either a Boolean value == 'true' or the value passed as the
	  * argument to `.hide()`.
	  *
	  */
	
	/**
	  * @ngdoc method
	  * @name $mdToast#cancel
	  *
	  * @description
	  * `DEPRECATED` - The promise returned from opening a toast is used only to notify about the closing of the toast.
	  * As such, there isn't any reason to also allow that promise to be rejected,
	  * since it's not clear what the difference between resolve and reject would be.
	  *
	  * Hide the existing toast and reject the promise returned from
	  * `$mdToast.show()`.
	  *
	  * @param {*=} response An argument for the rejected promise.
	  *
	  * @returns {promise} a promise that is called when the existing element is removed from the DOM
	  * The promise is resolved with a Boolean value == 'false'.
	  *
	  */
	
	function MdToastProvider($$interimElementProvider) {
	  // Differentiate promise resolves: hide timeout (value == true) and hide action clicks (value == ok).
	  MdToastController.$inject = ["$mdToast", "$scope"];
	  toastDefaultOptions.$inject = ["$animate", "$mdToast", "$mdUtil", "$mdMedia"];
	  var ACTION_RESOLVE = 'ok';
	
	  var activeToastContent;
	  var $mdToast = $$interimElementProvider('$mdToast')
	    .setDefaults({
	      methods: ['position', 'hideDelay', 'capsule', 'parent', 'position', 'toastClass'],
	      options: toastDefaultOptions
	    })
	    .addPreset('simple', {
	      argOption: 'textContent',
	      methods: ['textContent', 'content', 'action', 'highlightAction', 'highlightClass', 'theme', 'parent' ],
	      options: /* @ngInject */ ["$mdToast", "$mdTheming", function($mdToast, $mdTheming) {
	        return {
	          template:
	            '<md-toast md-theme="{{ toast.theme }}" ng-class="{\'md-capsule\': toast.capsule}">' +
	            '  <div class="md-toast-content">' +
	            '    <span class="md-toast-text" role="alert" aria-relevant="all" aria-atomic="true">' +
	            '      {{ toast.content }}' +
	            '    </span>' +
	            '    <md-button class="md-action" ng-if="toast.action" ng-click="toast.resolve()" ' +
	            '        ng-class="highlightClasses">' +
	            '      {{ toast.action }}' +
	            '    </md-button>' +
	            '  </div>' +
	            '</md-toast>',
	          controller: MdToastController,
	          theme: $mdTheming.defaultTheme(),
	          controllerAs: 'toast',
	          bindToController: true
	        };
	      }]
	    })
	    .addMethod('updateTextContent', updateTextContent)
	    .addMethod('updateContent', updateTextContent);
	
	    function updateTextContent(newContent) {
	      activeToastContent = newContent;
	    }
	
	    return $mdToast;
	
	  /**
	   * Controller for the Toast interim elements.
	   * @ngInject
	   */
	  function MdToastController($mdToast, $scope) {
	    // For compatibility with AngularJS 1.6+, we should always use the $onInit hook in
	    // interimElements. The $mdCompiler simulates the $onInit hook for all versions.
	    this.$onInit = function() {
	      var self = this;
	
	      if (self.highlightAction) {
	        $scope.highlightClasses = [
	          'md-highlight',
	          self.highlightClass
	        ];
	      }
	
	      $scope.$watch(function() { return activeToastContent; }, function() {
	        self.content = activeToastContent;
	      });
	
	      this.resolve = function() {
	        $mdToast.hide( ACTION_RESOLVE );
	      };
	    };
	  }
	
	  /* @ngInject */
	  function toastDefaultOptions($animate, $mdToast, $mdUtil, $mdMedia) {
	    var SWIPE_EVENTS = '$md.swipeleft $md.swiperight $md.swipeup $md.swipedown';
	    return {
	      onShow: onShow,
	      onRemove: onRemove,
	      toastClass: '',
	      position: 'bottom left',
	      themable: true,
	      hideDelay: 3000,
	      autoWrap: true,
	      transformTemplate: function(template, options) {
	        var shouldAddWrapper = options.autoWrap && template && !/md-toast-content/g.test(template);
	
	        if (shouldAddWrapper) {
	          // Root element of template will be <md-toast>. We need to wrap all of its content inside of
	          // of <div class="md-toast-content">. All templates provided here should be static, developer-controlled
	          // content (meaning we're not attempting to guard against XSS).
	          var templateRoot = document.createElement('md-template');
	          templateRoot.innerHTML = template;
	
	          // Iterate through all root children, to detect possible md-toast directives.
	          for (var i = 0; i < templateRoot.children.length; i++) {
	            if (templateRoot.children[i].nodeName === 'MD-TOAST') {
	              var wrapper = angular.element('<div class="md-toast-content">');
	
	              // Wrap the children of the `md-toast` directive in jqLite, to be able to append multiple
	              // nodes with the same execution.
	              wrapper.append(angular.element(templateRoot.children[i].childNodes));
	
	              // Append the new wrapped element to the `md-toast` directive.
	              templateRoot.children[i].appendChild(wrapper[0]);
	            }
	          }
	
	          // We have to return the innerHTMl, because we do not want to have the `md-template` element to be
	          // the root element of our interimElement.
	          return templateRoot.innerHTML;
	        }
	
	        return template || '';
	      }
	    };
	
	    function onShow(scope, element, options) {
	      activeToastContent = options.textContent || options.content; // support deprecated #content method
	
	      var isSmScreen = !$mdMedia('gt-sm');
	
	      element = $mdUtil.extractElementByName(element, 'md-toast', true);
	      options.element = element;
	
	      options.onSwipe = function(ev, gesture) {
	        //Add the relevant swipe class to the element so it can animate correctly
	        var swipe = ev.type.replace('$md.','');
	        var direction = swipe.replace('swipe', '');
	
	        // If the swipe direction is down/up but the toast came from top/bottom don't fade away
	        // Unless the screen is small, then the toast always on bottom
	        if ((direction === 'down' && options.position.indexOf('top') != -1 && !isSmScreen) ||
	            (direction === 'up' && (options.position.indexOf('bottom') != -1 || isSmScreen))) {
	          return;
	        }
	
	        if ((direction === 'left' || direction === 'right') && isSmScreen) {
	          return;
	        }
	
	        element.addClass('md-' + swipe);
	        $mdUtil.nextTick($mdToast.cancel);
	      };
	      options.openClass = toastOpenClass(options.position);
	
	      element.addClass(options.toastClass);
	
	      // 'top left' -> 'md-top md-left'
	      options.parent.addClass(options.openClass);
	
	      // static is the default position
	      if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
	        options.parent.css('position', 'relative');
	      }
	
	      element.on(SWIPE_EVENTS, options.onSwipe);
	      element.addClass(isSmScreen ? 'md-bottom' : options.position.split(' ').map(function(pos) {
	        return 'md-' + pos;
	      }).join(' '));
	
	      if (options.parent) options.parent.addClass('md-toast-animating');
	      return $animate.enter(element, options.parent).then(function() {
	        if (options.parent) options.parent.removeClass('md-toast-animating');
	      });
	    }
	
	    function onRemove(scope, element, options) {
	      element.off(SWIPE_EVENTS, options.onSwipe);
	      if (options.parent) options.parent.addClass('md-toast-animating');
	      if (options.openClass) options.parent.removeClass(options.openClass);
	
	      return ((options.$destroy == true) ? element.remove() : $animate.leave(element))
	        .then(function () {
	          if (options.parent) options.parent.removeClass('md-toast-animating');
	          if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
	            options.parent.css('position', '');
	          }
	        });
	    }
	
	    function toastOpenClass(position) {
	      // For mobile, always open full-width on bottom
	      if (!$mdMedia('gt-xs')) {
	        return 'md-toast-open-bottom';
	      }
	
	      return 'md-toast-open-' +
	        (position.indexOf('top') > -1 ? 'top' : 'bottom');
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.toolbar
	 */
	mdToolbarDirective.$inject = ["$$rAF", "$mdConstant", "$mdUtil", "$mdTheming", "$animate"];
	angular.module('material.components.toolbar', [
	  'material.core',
	  'material.components.content'
	])
	  .directive('mdToolbar', mdToolbarDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdToolbar
	 * @module material.components.toolbar
	 * @restrict E
	 * @description
	 * `md-toolbar` is used to place a toolbar in your app.
	 *
	 * Toolbars are usually used above a content area to display the title of the
	 * current page, and show relevant action buttons for that page.
	 *
	 * You can change the height of the toolbar by adding either the
	 * `md-medium-tall` or `md-tall` class to the toolbar.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div layout="column" layout-fill>
	 *   <md-toolbar>
	 *
	 *     <div class="md-toolbar-tools">
	 *       <h2 md-truncate flex>My App's Title</h2>
	 *
	 *       <md-button>
	 *         Right Bar Button
	 *       </md-button>
	 *     </div>
	 *
	 *   </md-toolbar>
	 *   <md-content>
	 *     Hello!
	 *   </md-content>
	 * </div>
	 * </hljs>
	 *
	 * <i><b>Note:</b> The code above shows usage with the `md-truncate` component which provides an
	 * ellipsis if the title is longer than the width of the Toolbar.</i>
	 *
	 * ## CSS & Styles
	 *
	 * The `<md-toolbar>` provides a few custom CSS classes that you may use to enhance the
	 * functionality of your toolbar.
	 *
	 * <div>
	 * <docs-css-api-table>
	 *
	 *   <docs-css-selector code="md-toolbar .md-toolbar-tools">
	 *     The `md-toolbar-tools` class provides quite a bit of automatic styling for your toolbar
	 *     buttons and text. When applied, it will center the buttons and text vertically for you.
	 *   </docs-css-selector>
	 *
	 * </docs-css-api-table>
	 * </div>
	 *
	 * ### Private Classes
	 *
	 * Currently, the only private class is the `md-toolbar-transitions` class. All other classes are
	 * considered public.
	 *
	 * @param {boolean=} md-scroll-shrink Whether the header should shrink away as
	 * the user scrolls down, and reveal itself as the user scrolls up.
	 *
	 * _**Note (1):** for scrollShrink to work, the toolbar must be a sibling of a
	 * `md-content` element, placed before it. See the scroll shrink demo._
	 *
	 * _**Note (2):** The `md-scroll-shrink` attribute is only parsed on component
	 * initialization, it does not watch for scope changes._
	 *
	 *
	 * @param {number=} md-shrink-speed-factor How much to change the speed of the toolbar's
	 * shrinking by. For example, if 0.25 is given then the toolbar will shrink
	 * at one fourth the rate at which the user scrolls down. Default 0.5.
	 *
	 */
	
	function mdToolbarDirective($$rAF, $mdConstant, $mdUtil, $mdTheming, $animate) {
	  var translateY = angular.bind(null, $mdUtil.supplant, 'translate3d(0,{0}px,0)');
	
	  return {
	    template: '',
	    restrict: 'E',
	
	    link: function(scope, element, attr) {
	
	      element.addClass('_md');     // private md component indicator for styling
	      $mdTheming(element);
	
	      $mdUtil.nextTick(function () {
	        element.addClass('_md-toolbar-transitions');     // adding toolbar transitions after digest
	      }, false);
	
	      if (angular.isDefined(attr.mdScrollShrink)) {
	        setupScrollShrink();
	      }
	
	      function setupScrollShrink() {
	
	        var toolbarHeight;
	        var contentElement;
	        var disableScrollShrink = angular.noop;
	
	        // Current "y" position of scroll
	        // Store the last scroll top position
	        var y = 0;
	        var prevScrollTop = 0;
	        var shrinkSpeedFactor = attr.mdShrinkSpeedFactor || 0.5;
	
	        var debouncedContentScroll = $$rAF.throttle(onContentScroll);
	        var debouncedUpdateHeight = $mdUtil.debounce(updateToolbarHeight, 5 * 1000);
	
	        // Wait for $mdContentLoaded event from mdContent directive.
	        // If the mdContent element is a sibling of our toolbar, hook it up
	        // to scroll events.
	
	        scope.$on('$mdContentLoaded', onMdContentLoad);
	
	        // If the toolbar is used inside an ng-if statement, we may miss the
	        // $mdContentLoaded event, so we attempt to fake it if we have a
	        // md-content close enough.
	
	        attr.$observe('mdScrollShrink', onChangeScrollShrink);
	
	        // If the toolbar has ngShow or ngHide we need to update height immediately as it changed
	        // and not wait for $mdUtil.debounce to happen
	
	        if (attr.ngShow) { scope.$watch(attr.ngShow, updateToolbarHeight); }
	        if (attr.ngHide) { scope.$watch(attr.ngHide, updateToolbarHeight); }
	
	        // If the scope is destroyed (which could happen with ng-if), make sure
	        // to disable scroll shrinking again
	
	        scope.$on('$destroy', disableScrollShrink);
	
	        /**
	         *
	         */
	        function onChangeScrollShrink(shrinkWithScroll) {
	          var closestContent = element.parent().find('md-content');
	
	          // If we have a content element, fake the call; this might still fail
	          // if the content element isn't a sibling of the toolbar
	
	          if (!contentElement && closestContent.length) {
	            onMdContentLoad(null, closestContent);
	          }
	
	          // Evaluate the expression
	          shrinkWithScroll = scope.$eval(shrinkWithScroll);
	
	          // Disable only if the attribute's expression evaluates to false
	          if (shrinkWithScroll === false) {
	            disableScrollShrink();
	          } else {
	            disableScrollShrink = enableScrollShrink();
	          }
	        }
	
	        /**
	         *
	         */
	        function onMdContentLoad($event, newContentEl) {
	          // Toolbar and content must be siblings
	          if (newContentEl && element.parent()[0] === newContentEl.parent()[0]) {
	            // unhook old content event listener if exists
	            if (contentElement) {
	              contentElement.off('scroll', debouncedContentScroll);
	            }
	
	            contentElement = newContentEl;
	            disableScrollShrink = enableScrollShrink();
	          }
	        }
	
	        /**
	         *
	         */
	        function onContentScroll(e) {
	          var scrollTop = e ? e.target.scrollTop : prevScrollTop;
	
	          debouncedUpdateHeight();
	
	          y = Math.min(
	            toolbarHeight / shrinkSpeedFactor,
	            Math.max(0, y + scrollTop - prevScrollTop)
	          );
	
	          element.css($mdConstant.CSS.TRANSFORM, translateY([-y * shrinkSpeedFactor]));
	          contentElement.css($mdConstant.CSS.TRANSFORM, translateY([(toolbarHeight - y) * shrinkSpeedFactor]));
	
	          prevScrollTop = scrollTop;
	
	          $mdUtil.nextTick(function() {
	            var hasWhiteFrame = element.hasClass('md-whiteframe-z1');
	
	            if (hasWhiteFrame && !y) {
	              $animate.removeClass(element, 'md-whiteframe-z1');
	            } else if (!hasWhiteFrame && y) {
	              $animate.addClass(element, 'md-whiteframe-z1');
	            }
	          });
	
	        }
	
	        /**
	         *
	         */
	        function enableScrollShrink() {
	          if (!contentElement)     return angular.noop;           // no md-content
	
	          contentElement.on('scroll', debouncedContentScroll);
	          contentElement.attr('scroll-shrink', 'true');
	
	          $mdUtil.nextTick(updateToolbarHeight, false);
	
	          return function disableScrollShrink() {
	            contentElement.off('scroll', debouncedContentScroll);
	            contentElement.attr('scroll-shrink', 'false');
	
	            updateToolbarHeight();
	          };
	        }
	
	        /**
	         *
	         */
	        function updateToolbarHeight() {
	          toolbarHeight = element.prop('offsetHeight');
	          // Add a negative margin-top the size of the toolbar to the content el.
	          // The content will start transformed down the toolbarHeight amount,
	          // so everything looks normal.
	          //
	          // As the user scrolls down, the content will be transformed up slowly
	          // to put the content underneath where the toolbar was.
	          var margin = (-toolbarHeight * shrinkSpeedFactor) + 'px';
	
	          contentElement.css({
	            "margin-top": margin,
	            "margin-bottom": margin
	          });
	
	          onContentScroll();
	        }
	
	      }
	
	    }
	  };
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.tooltip
	 */
	MdTooltipDirective.$inject = ["$timeout", "$window", "$$rAF", "$document", "$interpolate", "$mdUtil", "$mdPanel", "$$mdTooltipRegistry"];
	angular
	    .module('material.components.tooltip', [
	      'material.core',
	      'material.components.panel'
	    ])
	    .directive('mdTooltip', MdTooltipDirective)
	    .service('$$mdTooltipRegistry', MdTooltipRegistry);
	
	
	/**
	 * @ngdoc directive
	 * @name mdTooltip
	 * @module material.components.tooltip
	 * @description
	 * Tooltips are used to describe elements that are interactive and primarily
	 * graphical (not textual).
	 *
	 * Place a `<md-tooltip>` as a child of the element it describes.
	 *
	 * A tooltip will activate when the user hovers over, focuses, or touches the
	 * parent element.
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-button class="md-fab md-accent" aria-label="Play">
	 *     <md-tooltip>Play Music</md-tooltip>
	 *     <md-icon md-svg-src="img/icons/ic_play_arrow_24px.svg"></md-icon>
	 *   </md-button>
	 * </hljs>
	 *
	 * @param {number=} md-z-index The visual level that the tooltip will appear
	 *     in comparison with the rest of the elements of the application.
	 * @param {expression=} md-visible Boolean bound to whether the tooltip is
	 *     currently visible.
	 * @param {number=} md-delay How many milliseconds to wait to show the tooltip
	 *     after the user hovers over, focuses, or touches the parent element.
	 *     Defaults to 0ms on non-touch devices and 75ms on touch.
	 * @param {boolean=} md-autohide If present or provided with a boolean value,
	 *     the tooltip will hide on mouse leave, regardless of focus.
	 * @param {string=} md-direction The direction that the tooltip is shown,
	 *     relative to the parent element. Supports top, right, bottom, and left.
	 *     Defaults to bottom.
	 */
	function MdTooltipDirective($timeout, $window, $$rAF, $document, $interpolate,
	    $mdUtil, $mdPanel, $$mdTooltipRegistry) {
	
	  var ENTER_EVENTS = 'focus touchstart mouseenter';
	  var LEAVE_EVENTS = 'blur touchcancel mouseleave';
	  var TOOLTIP_DEFAULT_Z_INDEX = 100;
	  var TOOLTIP_DEFAULT_SHOW_DELAY = 0;
	  var TOOLTIP_DEFAULT_DIRECTION = 'bottom';
	  var TOOLTIP_DIRECTIONS = {
	    top: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.ABOVE },
	    right: { x: $mdPanel.xPosition.OFFSET_END, y: $mdPanel.yPosition.CENTER },
	    bottom: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.BELOW },
	    left: { x: $mdPanel.xPosition.OFFSET_START, y: $mdPanel.yPosition.CENTER }
	  };
	
	  return {
	    restrict: 'E',
	    priority: 210, // Before ngAria
	    scope: {
	      mdZIndex: '=?mdZIndex',
	      mdDelay: '=?mdDelay',
	      mdVisible: '=?mdVisible',
	      mdAutohide: '=?mdAutohide',
	      mdDirection: '@?mdDirection' // Do not expect expressions.
	    },
	    link: linkFunc
	  };
	
	  function linkFunc(scope, element, attr) {
	    // Set constants.
	    var tooltipId = 'md-tooltip-' + $mdUtil.nextUid();
	    var parent = $mdUtil.getParentWithPointerEvents(element);
	    var debouncedOnResize = $$rAF.throttle(updatePosition);
	    var mouseActive = false;
	    var origin, position, panelPosition, panelRef, autohide, showTimeout,
	        elementFocusedOnWindowBlur = null;
	
	    // Set defaults
	    setDefaults();
	
	    // Set parent aria-label.
	    addAriaLabel();
	
	    // Remove the element from its current DOM position.
	    element.detach();
	
	    updatePosition();
	    bindEvents();
	    configureWatchers();
	
	    function setDefaults() {
	      scope.mdZIndex = scope.mdZIndex || TOOLTIP_DEFAULT_Z_INDEX;
	      scope.mdDelay = scope.mdDelay || TOOLTIP_DEFAULT_SHOW_DELAY;
	      if (!TOOLTIP_DIRECTIONS[scope.mdDirection]) {
	        scope.mdDirection = TOOLTIP_DEFAULT_DIRECTION;
	      }
	    }
	
	    function addAriaLabel(labelText) {
	      // Only interpolate the text from the HTML element because otherwise the custom text could
	      // be interpolated twice and cause XSS violations.
	      var interpolatedText = labelText || $interpolate(element.text().trim())(scope.$parent);
	
	      // Only add the `aria-label` to the parent if there isn't already one, if there isn't an
	      // already present `aria-labelledby`, or if the previous `aria-label` was added by the
	      // tooltip directive.
	      if (
	        (!parent.attr('aria-label') && !parent.attr('aria-labelledby')) ||
	        parent.attr('md-labeled-by-tooltip')
	      ) {
	        parent.attr('aria-label', interpolatedText);
	
	        // Set the `md-labeled-by-tooltip` attribute if it has not already been set.
	        if (!parent.attr('md-labeled-by-tooltip')) {
	          parent.attr('md-labeled-by-tooltip', tooltipId);
	        }
	      }
	    }
	
	    function updatePosition() {
	      setDefaults();
	
	      // If the panel has already been created, remove the current origin
	      // class from the panel element.
	      if (panelRef && panelRef.panelEl) {
	        panelRef.panelEl.removeClass(origin);
	      }
	
	      // Set the panel element origin class based off of the current
	      // mdDirection.
	      origin = 'md-origin-' + scope.mdDirection;
	
	      // Create the position of the panel based off of the mdDirection.
	      position = TOOLTIP_DIRECTIONS[scope.mdDirection];
	
	      // Using the newly created position object, use the MdPanel
	      // panelPosition API to build the panel's position.
	      panelPosition = $mdPanel.newPanelPosition()
	          .relativeTo(parent)
	          .addPanelPosition(position.x, position.y);
	
	      // If the panel has already been created, add the new origin class to
	      // the panel element and update it's position with the panelPosition.
	      if (panelRef && panelRef.panelEl) {
	        panelRef.panelEl.addClass(origin);
	        panelRef.updatePosition(panelPosition);
	      }
	    }
	
	    function bindEvents() {
	      // Add a mutationObserver where there is support for it and the need
	      // for it in the form of viable host(parent[0]).
	      if (parent[0] && 'MutationObserver' in $window) {
	        // Use a mutationObserver to tackle #2602.
	        var attributeObserver = new MutationObserver(function(mutations) {
	          if (isDisabledMutation(mutations)) {
	            $mdUtil.nextTick(function() {
	              setVisible(false);
	            });
	          }
	        });
	
	        attributeObserver.observe(parent[0], {
	          attributes: true
	        });
	      }
	
	      elementFocusedOnWindowBlur = false;
	
	      $$mdTooltipRegistry.register('scroll', windowScrollEventHandler, true);
	      $$mdTooltipRegistry.register('blur', windowBlurEventHandler);
	      $$mdTooltipRegistry.register('resize', debouncedOnResize);
	
	      scope.$on('$destroy', onDestroy);
	
	      // To avoid 'synthetic clicks', we listen to mousedown instead of
	      // 'click'.
	      parent.on('mousedown', mousedownEventHandler);
	      parent.on(ENTER_EVENTS, enterEventHandler);
	
	      function isDisabledMutation(mutations) {
	        mutations.some(function(mutation) {
	          return mutation.attributeName === 'disabled' && parent[0].disabled;
	        });
	        return false;
	      }
	
	      function windowScrollEventHandler() {
	        setVisible(false);
	      }
	
	      function windowBlurEventHandler() {
	        elementFocusedOnWindowBlur = document.activeElement === parent[0];
	      }
	
	      function enterEventHandler($event) {
	        // Prevent the tooltip from showing when the window is receiving
	        // focus.
	        if ($event.type === 'focus' && elementFocusedOnWindowBlur) {
	          elementFocusedOnWindowBlur = false;
	        } else if (!scope.mdVisible) {
	          parent.on(LEAVE_EVENTS, leaveEventHandler);
	          setVisible(true);
	
	          // If the user is on a touch device, we should bind the tap away
	          // after the 'touched' in order to prevent the tooltip being
	          // removed immediately.
	          if ($event.type === 'touchstart') {
	            parent.one('touchend', function() {
	              $mdUtil.nextTick(function() {
	                $document.one('touchend', leaveEventHandler);
	              }, false);
	            });
	          }
	        }
	      }
	
	      function leaveEventHandler() {
	        autohide = scope.hasOwnProperty('mdAutohide') ?
	            scope.mdAutohide :
	            attr.hasOwnProperty('mdAutohide');
	
	        if (autohide || mouseActive ||
	            $document[0].activeElement !== parent[0]) {
	          // When a show timeout is currently in progress, then we have
	          // to cancel it, otherwise the tooltip will remain showing
	          // without focus or hover.
	          if (showTimeout) {
	            $timeout.cancel(showTimeout);
	            setVisible.queued = false;
	            showTimeout = null;
	          }
	
	          parent.off(LEAVE_EVENTS, leaveEventHandler);
	          parent.triggerHandler('blur');
	          setVisible(false);
	        }
	        mouseActive = false;
	      }
	
	      function mousedownEventHandler() {
	        mouseActive = true;
	      }
	
	      function onDestroy() {
	        $$mdTooltipRegistry.deregister('scroll', windowScrollEventHandler, true);
	        $$mdTooltipRegistry.deregister('blur', windowBlurEventHandler);
	        $$mdTooltipRegistry.deregister('resize', debouncedOnResize);
	
	        parent
	            .off(ENTER_EVENTS, enterEventHandler)
	            .off(LEAVE_EVENTS, leaveEventHandler)
	            .off('mousedown', mousedownEventHandler);
	
	        // Trigger the handler in case any of the tooltips are
	        // still visible.
	        leaveEventHandler();
	        attributeObserver && attributeObserver.disconnect();
	      }
	    }
	
	    function configureWatchers() {
	      if (element[0] && 'MutationObserver' in $window) {
	        var attributeObserver = new MutationObserver(function(mutations) {
	          mutations.forEach(function(mutation) {
	            if (mutation.attributeName === 'md-visible' &&
	                !scope.visibleWatcher ) {
	              scope.visibleWatcher = scope.$watch('mdVisible',
	                  onVisibleChanged);
	            }
	          });
	        });
	
	        attributeObserver.observe(element[0], {
	          attributes: true
	        });
	
	        // Build watcher only if mdVisible is being used.
	        if (attr.hasOwnProperty('mdVisible')) {
	          scope.visibleWatcher = scope.$watch('mdVisible',
	              onVisibleChanged);
	        }
	      } else {
	        // MutationObserver not supported
	        scope.visibleWatcher = scope.$watch('mdVisible', onVisibleChanged);
	      }
	
	      // Direction watcher
	      scope.$watch('mdDirection', updatePosition);
	
	      // Clean up if the element or parent was removed via jqLite's .remove.
	      // A couple of notes:
	      //   - In these cases the scope might not have been destroyed, which
	      //     is why we destroy it manually. An example of this can be having
	      //     `md-visible="false"` and adding tooltips while they're
	      //     invisible. If `md-visible` becomes true, at some point, you'd
	      //     usually get a lot of tooltips.
	      //   - We use `.one`, not `.on`, because this only needs to fire once.
	      //     If we were using `.on`, it would get thrown into an infinite
	      //     loop.
	      //   - This kicks off the scope's `$destroy` event which finishes the
	      //     cleanup.
	      element.one('$destroy', onElementDestroy);
	      parent.one('$destroy', onElementDestroy);
	      scope.$on('$destroy', function() {
	        setVisible(false);
	        panelRef && panelRef.destroy();
	        attributeObserver && attributeObserver.disconnect();
	        element.remove();
	      });
	
	      // Updates the aria-label when the element text changes. This watch
	      // doesn't need to be set up if the element doesn't have any data
	      // bindings.
	      if (element.text().indexOf($interpolate.startSymbol()) > -1) {
	        scope.$watch(function() {
	          return element.text().trim();
	        }, addAriaLabel);
	      }
	
	      function onElementDestroy() {
	        scope.$destroy();
	      }
	    }
	
	    function setVisible(value) {
	      // Break if passed value is already in queue or there is no queue and
	      // passed value is current in the controller.
	      if (setVisible.queued && setVisible.value === !!value ||
	          !setVisible.queued && scope.mdVisible === !!value) {
	        return;
	      }
	      setVisible.value = !!value;
	
	      if (!setVisible.queued) {
	        if (value) {
	          setVisible.queued = true;
	          showTimeout = $timeout(function() {
	            scope.mdVisible = setVisible.value;
	            setVisible.queued = false;
	            showTimeout = null;
	            if (!scope.visibleWatcher) {
	              onVisibleChanged(scope.mdVisible);
	            }
	          }, scope.mdDelay);
	        } else {
	          $mdUtil.nextTick(function() {
	            scope.mdVisible = false;
	            if (!scope.visibleWatcher) {
	              onVisibleChanged(false);
	            }
	          });
	        }
	      }
	    }
	
	    function onVisibleChanged(isVisible) {
	      isVisible ? showTooltip() : hideTooltip();
	    }
	
	    function showTooltip() {
	      // Do not show the tooltip if the text is empty.
	      if (!element[0].textContent.trim()) {
	        throw new Error('Text for the tooltip has not been provided. ' +
	            'Please include text within the mdTooltip element.');
	      }
	
	      if (!panelRef) {
	        var attachTo = angular.element(document.body);
	        var panelAnimation = $mdPanel.newPanelAnimation()
	            .openFrom(parent)
	            .closeTo(parent)
	            .withAnimation({
	              open: 'md-show',
	              close: 'md-hide'
	            });
	
	        var panelConfig = {
	          id: tooltipId,
	          attachTo: attachTo,
	          contentElement: element,
	          propagateContainerEvents: true,
	          panelClass: 'md-tooltip',
	          animation: panelAnimation,
	          position: panelPosition,
	          zIndex: scope.mdZIndex,
	          focusOnOpen: false,
	          onDomAdded: function() {
	            panelRef.panelEl.addClass(origin);
	          }
	        };
	
	        panelRef = $mdPanel.create(panelConfig);
	      }
	
	      panelRef.open().then(function() {
	        panelRef.panelEl.attr('role', 'tooltip');
	      });
	    }
	
	    function hideTooltip() {
	      panelRef && panelRef.close();
	    }
	  }
	
	}
	
	
	/**
	 * Service that is used to reduce the amount of listeners that are being
	 * registered on the `window` by the tooltip component. Works by collecting
	 * the individual event handlers and dispatching them from a global handler.
	 *
	 * @ngInject
	 */
	function MdTooltipRegistry() {
	  var listeners = {};
	  var ngWindow = angular.element(window);
	
	  return {
	    register: register,
	    deregister: deregister
	  };
	
	  /**
	   * Global event handler that dispatches the registered handlers in the
	   * service.
	   * @param {!Event} event Event object passed in by the browser
	   */
	  function globalEventHandler(event) {
	    if (listeners[event.type]) {
	      listeners[event.type].forEach(function(currentHandler) {
	        currentHandler.call(this, event);
	      }, this);
	    }
	  }
	
	  /**
	   * Registers a new handler with the service.
	   * @param {string} type Type of event to be registered.
	   * @param {!Function} handler Event handler.
	   * @param {boolean} useCapture Whether to use event capturing.
	   */
	  function register(type, handler, useCapture) {
	    var handlers = listeners[type] = listeners[type] || [];
	
	    if (!handlers.length) {
	      useCapture ? window.addEventListener(type, globalEventHandler, true) :
	          ngWindow.on(type, globalEventHandler);
	    }
	
	    if (handlers.indexOf(handler) === -1) {
	      handlers.push(handler);
	    }
	  }
	
	  /**
	   * Removes an event handler from the service.
	   * @param {string} type Type of event handler.
	   * @param {!Function} handler The event handler itself.
	   * @param {boolean} useCapture Whether the event handler used event capturing.
	   */
	  function deregister(type, handler, useCapture) {
	    var handlers = listeners[type];
	    var index = handlers ? handlers.indexOf(handler) : -1;
	
	    if (index > -1) {
	      handlers.splice(index, 1);
	
	      if (handlers.length === 0) {
	        useCapture ? window.removeEventListener(type, globalEventHandler, true) :
	            ngWindow.off(type, globalEventHandler);
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.truncate
	 */
	MdTruncateController.$inject = ["$element"];
	angular.module('material.components.truncate', ['material.core'])
	  .directive('mdTruncate', MdTruncateDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdTruncate
	 * @module material.components.truncate
	 * @restrict AE
	 * @description
	 *
	 * The `md-truncate` component displays a label that will automatically clip text which is wider
	 * than the component. By default, it displays an ellipsis, but you may apply the `md-clip` CSS
	 * class to override this default and use a standard "clipping" approach.
	 *
	 * <i><b>Note:</b> The `md-truncate` component does not automatically adjust it's width. You must
	 * provide the `flex` attribute, or some other CSS-based width management. See the
	 * <a ng-href="./demo/truncate">demos</a> for examples.</i>
	 *
	 * @usage
	 *
	 * ### As an Element
	 *
	 * <hljs lang="html">
	 *   <div layout="row">
	 *     <md-button>Back</md-button>
	 *
	 *     <md-truncate flex>Chapter 1 - The Way of the Old West</md-truncate>
	 *
	 *     <md-button>Forward</md-button>
	 *   </div>
	 * </hljs>
	 *
	 * ### As an Attribute
	 *
	 * <hljs lang="html">
	 *   <h2 md-truncate style="max-width: 100px;">Some Title With a Lot of Text</h2>
	 * </hljs>
	 *
	 * ## CSS & Styles
	 *
	 * `<md-truncate>` provides two CSS classes that you may use to control the type of clipping.
	 *
	 * <i><b>Note:</b> The `md-truncate` also applies a setting of `width: 0;` when used with the `flex`
	 * attribute to fix an issue with the flex element not shrinking properly.</i>
	 *
	 * <div>
	 * <docs-css-api-table>
	 *
	 *   <docs-css-selector code=".md-ellipsis">
	 *     Assigns the "ellipsis" behavior (default) which will cut off mid-word and append an ellipsis
	 *     (&hellip;) to the end of the text.
	 *   </docs-css-selector>
	 *
	 *   <docs-css-selector code=".md-clip">
	 *     Assigns the "clipping" behavior which will simply chop off the text. This may happen
	 *     mid-word or even mid-character.
	 *   </docs-css-selector>
	 *
	 * </docs-css-api-table>
	 * </div>
	 */
	function MdTruncateDirective() {
	  return {
	    restrict: 'AE',
	
	    controller: MdTruncateController
	  };
	}
	
	/**
	 * Controller for the <md-truncate> component.
	 *
	 * @param $element The md-truncate element.
	 *
	 * @constructor
	 * @ngInject
	 */
	function MdTruncateController($element) {
	  $element.addClass('md-truncate');
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.virtualRepeat
	 */
	VirtualRepeatContainerController.$inject = ["$$rAF", "$mdUtil", "$mdConstant", "$parse", "$rootScope", "$window", "$scope", "$element", "$attrs"];
	VirtualRepeatController.$inject = ["$scope", "$element", "$attrs", "$browser", "$document", "$rootScope", "$$rAF", "$mdUtil"];
	VirtualRepeatDirective.$inject = ["$parse"];
	angular.module('material.components.virtualRepeat', [
	  'material.core',
	  'material.components.showHide'
	])
	.directive('mdVirtualRepeatContainer', VirtualRepeatContainerDirective)
	.directive('mdVirtualRepeat', VirtualRepeatDirective)
	.directive('mdForceHeight', ForceHeightDirective);
	
	
	/**
	 * @ngdoc directive
	 * @name mdVirtualRepeatContainer
	 * @module material.components.virtualRepeat
	 * @restrict E
	 * @description
	 * `md-virtual-repeat-container` provides the scroll container for
	 * <a ng-href="api/directive/mdVirtualRepeat">md-virtual-repeat</a>.
	 *
	 * VirtualRepeat is a limited substitute for `ng-repeat` that renders only
	 * enough DOM nodes to fill the container, recycling them as the user scrolls.
	 *
	 * Once an element is not visible anymore, the Virtual Repeat recycles the element and reuses it
	 * for another visible item by replacing the previous data set with the set of currently visible
	 * elements.
	 *
	 * ### Common Issues
	 *
	 * - When having one-time bindings inside of the view template, the Virtual Repeat will not properly
	 *   update the bindings for new items, since the view will be recycled.
	 * - Directives inside of a Virtual Repeat will be only compiled (linked) once, because those
	 *   items will be recycled and used for other items.
	 *   The Virtual Repeat just updates the scope bindings.
	 *
	 *
	 * ### Notes
	 *
	 * > The VirtualRepeat is a similar implementation to the Android
	 * [RecyclerView](https://developer.android.com/reference/android/support/v7/widget/RecyclerView.html).
	 *
	 * <!-- This comment forces a break between blockquotes //-->
	 *
	 * > Please also review the <a ng-href="api/directive/mdVirtualRepeat">mdVirtualRepeat</a>
	 * documentation for more information.
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-virtual-repeat-container md-top-index="topIndex">
	 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 * </hljs>
	 *
	 * @param {boolean=} md-auto-shrink When present and the container will shrink to fit
	 *     the number of items in the `md-virtual-repeat`.
	 * @param {number=} md-auto-shrink-min Minimum number of items that md-auto-shrink
	 *     will shrink to. Default: `0`.
	 * @param {boolean=} md-orient-horizontal Whether the container should scroll horizontally.
	 *     The default is `false` which indicates vertical orientation and scrolling.
	 * @param {number=} md-top-index Binds the index of the item that is at the top of the scroll
	 *     container to `$scope`. It can both read and set the scroll position.
	 */
	function VirtualRepeatContainerDirective() {
	  return {
	    controller: VirtualRepeatContainerController,
	    template: virtualRepeatContainerTemplate,
	    compile: function virtualRepeatContainerCompile($element, $attrs) {
	      $element
	          .addClass('md-virtual-repeat-container')
	          .addClass($attrs.hasOwnProperty('mdOrientHorizontal')
	              ? 'md-orient-horizontal'
	              : 'md-orient-vertical');
	    }
	  };
	}
	
	
	function virtualRepeatContainerTemplate($element) {
	  return '<div class="md-virtual-repeat-scroller" role="presentation">' +
	    '<div class="md-virtual-repeat-sizer" role="presentation"></div>' +
	    '<div class="md-virtual-repeat-offsetter" role="presentation">' +
	      $element[0].innerHTML +
	    '</div></div>';
	}
	
	/**
	 * Number of additional elements to render above and below the visible area inside
	 * of the virtual repeat container. A higher number results in less flicker when scrolling
	 * very quickly in Safari, but comes with a higher rendering and dirty-checking cost.
	 * @const {number}
	 */
	var NUM_EXTRA = 3;
	
	/** @ngInject */
	function VirtualRepeatContainerController($$rAF, $mdUtil, $mdConstant, $parse, $rootScope, $window, $scope,
	                                          $element, $attrs) {
	  this.$rootScope = $rootScope;
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	
	  /** @type {number} The width or height of the container */
	  this.size = 0;
	  /** @type {number} The scroll width or height of the scroller */
	  this.scrollSize = 0;
	  /** @type {number} The scrollLeft or scrollTop of the scroller */
	  this.scrollOffset = 0;
	  /** @type {boolean} Whether the scroller is oriented horizontally */
	  this.horizontal = this.$attrs.hasOwnProperty('mdOrientHorizontal');
	  /** @type {!VirtualRepeatController} The repeater inside of this container */
	  this.repeater = null;
	  /** @type {boolean} Whether auto-shrink is enabled */
	  this.autoShrink = this.$attrs.hasOwnProperty('mdAutoShrink');
	  /** @type {number} Minimum number of items to auto-shrink to */
	  this.autoShrinkMin = parseInt(this.$attrs.mdAutoShrinkMin, 10) || 0;
	  /** @type {?number} Original container size when shrank */
	  this.originalSize = null;
	  /** @type {number} Amount to offset the total scroll size by. */
	  this.offsetSize = parseInt(this.$attrs.mdOffsetSize, 10) || 0;
	  /** @type {?string} height or width element style on the container prior to auto-shrinking. */
	  this.oldElementSize = null;
	  /** @type {!number} Maximum amount of pixels allowed for a single DOM element */
	  this.maxElementPixels = $mdConstant.ELEMENT_MAX_PIXELS;
	
	  if (this.$attrs.mdTopIndex) {
	    /** @type {function(angular.Scope): number} Binds to topIndex on AngularJS scope */
	    this.bindTopIndex = $parse(this.$attrs.mdTopIndex);
	    /** @type {number} The index of the item that is at the top of the scroll container */
	    this.topIndex = this.bindTopIndex(this.$scope);
	
	    if (!angular.isDefined(this.topIndex)) {
	      this.topIndex = 0;
	      this.bindTopIndex.assign(this.$scope, 0);
	    }
	
	    this.$scope.$watch(this.bindTopIndex, angular.bind(this, function(newIndex) {
	      if (newIndex !== this.topIndex) {
	        this.scrollToIndex(newIndex);
	      }
	    }));
	  } else {
	    this.topIndex = 0;
	  }
	
	  this.scroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	  this.sizer = this.scroller.querySelector('.md-virtual-repeat-sizer');
	  this.offsetter = this.scroller.querySelector('.md-virtual-repeat-offsetter');
	
	  // After the DOM stabilizes, measure the initial size of the container and
	  // make a best effort at re-measuring as it changes.
	  var boundUpdateSize = angular.bind(this, this.updateSize);
	
	  $$rAF(angular.bind(this, function() {
	    boundUpdateSize();
	
	    var debouncedUpdateSize = $mdUtil.debounce(boundUpdateSize, 10, null, false);
	    var jWindow = angular.element($window);
	
	    // Make one more attempt to get the size if it is 0.
	    // This is not by any means a perfect approach, but there's really no
	    // silver bullet here.
	    if (!this.size) {
	      debouncedUpdateSize();
	    }
	
	    jWindow.on('resize', debouncedUpdateSize);
	    $scope.$on('$destroy', function() {
	      jWindow.off('resize', debouncedUpdateSize);
	    });
	
	    $scope.$emit('$md-resize-enable');
	    $scope.$on('$md-resize', boundUpdateSize);
	  }));
	}
	
	
	/** Called by the md-virtual-repeat inside of the container at startup. */
	VirtualRepeatContainerController.prototype.register = function(repeaterCtrl) {
	  this.repeater = repeaterCtrl;
	
	  angular.element(this.scroller)
	      .on('scroll wheel touchmove touchend', angular.bind(this, this.handleScroll_));
	};
	
	
	/** @return {boolean} Whether the container is configured for horizontal scrolling. */
	VirtualRepeatContainerController.prototype.isHorizontal = function() {
	  return this.horizontal;
	};
	
	
	/** @return {number} The size (width or height) of the container. */
	VirtualRepeatContainerController.prototype.getSize = function() {
	  return this.size;
	};
	
	
	/**
	 * Resizes the container.
	 * @private
	 * @param {number} size The new size to set.
	 */
	VirtualRepeatContainerController.prototype.setSize_ = function(size) {
	  var dimension = this.getDimensionName_();
	
	  this.size = size;
	  this.$element[0].style[dimension] = size + 'px';
	};
	
	
	VirtualRepeatContainerController.prototype.unsetSize_ = function() {
	  this.$element[0].style[this.getDimensionName_()] = this.oldElementSize;
	  this.oldElementSize = null;
	};
	
	
	/** Instructs the container to re-measure its size. */
	VirtualRepeatContainerController.prototype.updateSize = function() {
	  // If the original size is already determined, we can skip the update.
	  if (this.originalSize) return;
	
	  this.size = this.isHorizontal()
	      ? this.$element[0].clientWidth
	      : this.$element[0].clientHeight;
	
	  // Recheck the scroll position after updating the size. This resolves
	  // problems that can result if the scroll position was measured while the
	  // element was display: none or detached from the document.
	  this.handleScroll_();
	
	  this.repeater && this.repeater.containerUpdated();
	};
	
	
	/** @return {number} The container's scrollHeight or scrollWidth. */
	VirtualRepeatContainerController.prototype.getScrollSize = function() {
	  return this.scrollSize;
	};
	
	
	VirtualRepeatContainerController.prototype.getDimensionName_ = function() {
	  return this.isHorizontal() ? 'width' : 'height';
	};
	
	
	/**
	 * Sets the scroller element to the specified size.
	 * @private
	 * @param {number} size The new size.
	 */
	VirtualRepeatContainerController.prototype.sizeScroller_ = function(size) {
	  var dimension =  this.getDimensionName_();
	  var crossDimension = this.isHorizontal() ? 'height' : 'width';
	
	  // Clear any existing dimensions.
	  this.sizer.innerHTML = '';
	
	  // If the size falls within the browser's maximum explicit size for a single element, we can
	  // set the size and be done. Otherwise, we have to create children that add up the the desired
	  // size.
	  if (size < this.maxElementPixels) {
	    this.sizer.style[dimension] = size + 'px';
	  } else {
	    this.sizer.style[dimension] = 'auto';
	    this.sizer.style[crossDimension] = 'auto';
	
	    // Divide the total size we have to render into N max-size pieces.
	    var numChildren = Math.floor(size / this.maxElementPixels);
	
	    // Element template to clone for each max-size piece.
	    var sizerChild = document.createElement('div');
	    sizerChild.style[dimension] = this.maxElementPixels + 'px';
	    sizerChild.style[crossDimension] = '1px';
	
	    for (var i = 0; i < numChildren; i++) {
	      this.sizer.appendChild(sizerChild.cloneNode(false));
	    }
	
	    // Re-use the element template for the remainder.
	    sizerChild.style[dimension] = (size - (numChildren * this.maxElementPixels)) + 'px';
	    this.sizer.appendChild(sizerChild);
	  }
	};
	
	
	/**
	 * If auto-shrinking is enabled, shrinks or unshrinks as appropriate.
	 * @private
	 * @param {number} size The new size.
	 */
	VirtualRepeatContainerController.prototype.autoShrink_ = function(size) {
	  var shrinkSize = Math.max(size, this.autoShrinkMin * this.repeater.getItemSize());
	
	  if (this.autoShrink && shrinkSize !== this.size) {
	    if (this.oldElementSize === null) {
	      this.oldElementSize = this.$element[0].style[this.getDimensionName_()];
	    }
	
	    var currentSize = this.originalSize || this.size;
	
	    if (!currentSize || shrinkSize < currentSize) {
	      if (!this.originalSize) {
	        this.originalSize = this.size;
	      }
	
	      // Now we update the containers size, because shrinking is enabled.
	      this.setSize_(shrinkSize);
	    } else if (this.originalSize !== null) {
	      // Set the size back to our initial size.
	      this.unsetSize_();
	
	      var _originalSize = this.originalSize;
	      this.originalSize = null;
	
	      // We determine the repeaters size again, if the original size was zero.
	      // The originalSize needs to be null, to be able to determine the size.
	      if (!_originalSize) this.updateSize();
	
	      // Apply the original size or the determined size back to the container, because
	      // it has been overwritten before, in the shrink block.
	      this.setSize_(_originalSize || this.size);
	    }
	
	    this.repeater.containerUpdated();
	  }
	};
	
	
	/**
	 * Sets the scrollHeight or scrollWidth. Called by the repeater based on
	 * its item count and item size.
	 * @param {number} itemsSize The total size of the items.
	 */
	VirtualRepeatContainerController.prototype.setScrollSize = function(itemsSize) {
	  var size = itemsSize + this.offsetSize;
	  if (this.scrollSize === size) return;
	
	  this.sizeScroller_(size);
	  this.autoShrink_(size);
	  this.scrollSize = size;
	};
	
	
	/** @return {number} The container's current scroll offset. */
	VirtualRepeatContainerController.prototype.getScrollOffset = function() {
	  return this.scrollOffset;
	};
	
	/**
	 * Scrolls to a given scrollTop position.
	 * @param {number} position
	 */
	VirtualRepeatContainerController.prototype.scrollTo = function(position) {
	  this.scroller[this.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = position;
	  this.handleScroll_();
	};
	
	/**
	 * Scrolls the item with the given index to the top of the scroll container.
	 * @param {number} index
	 */
	VirtualRepeatContainerController.prototype.scrollToIndex = function(index) {
	  var itemSize = this.repeater.getItemSize();
	  var itemsLength = this.repeater.itemsLength;
	  if(index > itemsLength) {
	    index = itemsLength - 1;
	  }
	  this.scrollTo(itemSize * index);
	};
	
	VirtualRepeatContainerController.prototype.resetScroll = function() {
	  this.scrollTo(0);
	};
	
	
	VirtualRepeatContainerController.prototype.handleScroll_ = function() {
	  var ltr = document.dir != 'rtl' && document.body.dir != 'rtl';
	  if(!ltr && !this.maxSize) {
	    this.scroller.scrollLeft = this.scrollSize;
	    this.maxSize = this.scroller.scrollLeft;
	  }
	  var offset = this.isHorizontal() ?
	      (ltr?this.scroller.scrollLeft : this.maxSize - this.scroller.scrollLeft)
	      : this.scroller.scrollTop;
	  if (offset === this.scrollOffset || offset > this.scrollSize - this.size) return;
	
	  var itemSize = this.repeater.getItemSize();
	  if (!itemSize) return;
	
	  var numItems = Math.max(0, Math.floor(offset / itemSize) - NUM_EXTRA);
	
	  var transform = (this.isHorizontal() ? 'translateX(' : 'translateY(') +
	      (!this.isHorizontal() || ltr ? (numItems * itemSize) : - (numItems * itemSize))  + 'px)';
	
	  this.scrollOffset = offset;
	  this.offsetter.style.webkitTransform = transform;
	  this.offsetter.style.transform = transform;
	
	  if (this.bindTopIndex) {
	    var topIndex = Math.floor(offset / itemSize);
	    if (topIndex !== this.topIndex && topIndex < this.repeater.getItemCount()) {
	      this.topIndex = topIndex;
	      this.bindTopIndex.assign(this.$scope, topIndex);
	      if (!this.$rootScope.$$phase) this.$scope.$digest();
	    }
	  }
	
	  this.repeater.containerUpdated();
	};
	
	
	/**
	 * @ngdoc directive
	 * @name mdVirtualRepeat
	 * @module material.components.virtualRepeat
	 * @restrict A
	 * @priority 1000
	 * @description
	 * The `md-virtual-repeat` attribute is applied to a template that is repeated using virtual
	 * scrolling. This provides smooth and performant scrolling through very large lists of elements.
	 *
	 * Virtual repeat is a limited substitute for `ng-repeat` that renders only
	 * enough DOM nodes to fill the container, recycling them as the user scrolls.
	 *
	 * ### Notes
	 *
	 * - Arrays are supported for iteration by default.
	 * - An object can used use if `md-on-demand` is specified and the object implements the interface
	 *   described in the `md-on-demand` <a ng-href="#attributes">documentation</a>.
	 * - `trackBy`, `as` alias, and `(key, value)` syntax from `ng-repeat` are not supported.
	 *
	 * ### On-Demand Async Item Loading
	 *
	 * When using the `md-on-demand` attribute and loading some asynchronous data,
	 * the `getItemAtIndex` function will mostly return nothing.
	 *
	 * <hljs lang="js">
	 *   DynamicItems.prototype.getItemAtIndex = function(index) {
	 *     if (this.pages[index]) {
	 *       return this.pages[index];
	 *     } else {
	 *       // This is an asynchronous action and does not return any value.
	 *       this.loadPage(index);
	 *     }
	 *   };
	 * </hljs>
	 *
	 * This means that the Virtual Repeat will not have any value for the given index.<br/>
	 * After the data loading completes, the user expects the Virtual Repeat to recognize the change.
	 *
	 * To make sure that the Virtual Repeat properly detects any change, you need to run the operation
	 * in another digest.
	 *
	 * <hljs lang="js">
	 *   DynamicItems.prototype.loadPage = function(index) {
	 *     var self = this;
	 *
	 *     // Trigger a new digest by using $timeout
	 *     $timeout(function() {
	 *       self.pages[index] = Data;
	 *     });
	 *   };
	 * </hljs>
	 *
	 * > <b>Note:</b> Please also review the
	 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation
	 *   for more information.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-virtual-repeat-container>
	 *   <div md-virtual-repeat="i in items">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 *
	 * <md-virtual-repeat-container md-orient-horizontal>
	 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 * </hljs>
	 *
	 * @param {expression=} md-extra-name Evaluates to an additional name to which the current iterated item
	 *   can be assigned on the repeated scope (needed for use in `md-autocomplete`).
	 * @param {number=} md-item-size Optional height or width of the repeated elements (which **must be
	 *   identical for each element**). Virtual repeat will attempt to read the size from the DOM,
	 *   if missing, but it still assumes that all repeated nodes have the **same height**
	 *   (when scrolling vertically) or **same width** (when scrolling horizontally).
	 * @param {boolean=} md-on-demand When present, treats the `md-virtual-repeat` argument as an object
	 *   that can fetch rows rather than an array.
	 *
	 *   **NOTE:** This object **must** implement the following interface with two methods:
	 *
	 *   - `getItemAtIndex` - `{function(index): Object}`: The item at that `index` or `null` if it is not
	 *     yet loaded (it should start downloading the item in that case).
	 *   - `getLength` - `{function(): number}`: The data length to which the repeater container
	 *     should be sized. Ideally, when the count is known, this method should return it.
	 *     Otherwise, return a higher number than the currently loaded items to produce an
	 *     infinite-scroll behavior.
	 */
	function VirtualRepeatDirective($parse) {
	  return {
	    controller: VirtualRepeatController,
	    priority: 1000,
	    require: ['mdVirtualRepeat', '^^mdVirtualRepeatContainer'],
	    restrict: 'A',
	    terminal: true,
	    transclude: 'element',
	    compile: function VirtualRepeatCompile($element, $attrs) {
	      var expression = $attrs.mdVirtualRepeat;
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)\s*$/);
	      var repeatName = match[1];
	      var repeatListExpression = $parse(match[2]);
	      var extraName = $attrs.mdExtraName && $parse($attrs.mdExtraName);
	
	      return function VirtualRepeatLink($scope, $element, $attrs, ctrl, $transclude) {
	        ctrl[0].link_(ctrl[1], $transclude, repeatName, repeatListExpression, extraName);
	      };
	    }
	  };
	}
	
	
	/** @ngInject */
	function VirtualRepeatController($scope, $element, $attrs, $browser, $document, $rootScope,
	    $$rAF, $mdUtil) {
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$browser = $browser;
	  this.$document = $document;
	  this.$mdUtil = $mdUtil;
	  this.$rootScope = $rootScope;
	  this.$$rAF = $$rAF;
	
	  /** @type {boolean} Whether we are in on-demand mode. */
	  this.onDemand = $mdUtil.parseAttributeBoolean($attrs.mdOnDemand);
	  /** @type {!Function} Backup reference to $browser.$$checkUrlChange */
	  this.browserCheckUrlChange = $browser.$$checkUrlChange;
	  /** @type {number} Most recent starting repeat index (based on scroll offset) */
	  this.newStartIndex = 0;
	  /** @type {number} Most recent ending repeat index (based on scroll offset) */
	  this.newEndIndex = 0;
	  /** @type {number} Most recent end visible index (based on scroll offset) */
	  this.newVisibleEnd = 0;
	  /** @type {number} Previous starting repeat index (based on scroll offset) */
	  this.startIndex = 0;
	  /** @type {number} Previous ending repeat index (based on scroll offset) */
	  this.endIndex = 0;
	  /** @type {?number} Height/width of repeated elements. */
	  this.itemSize = $scope.$eval($attrs.mdItemSize) || null;
	
	  /** @type {boolean} Whether this is the first time that items are rendered. */
	  this.isFirstRender = true;
	
	  /**
	   * @private {boolean} Whether the items in the list are already being updated. Used to prevent
	   *     nested calls to virtualRepeatUpdate_.
	   */
	  this.isVirtualRepeatUpdating_ = false;
	
	  /** @type {number} Most recently seen length of items. */
	  this.itemsLength = 0;
	
	  /**
	   * @type {!Function} Unwatch callback for item size (when md-items-size is
	   *     not specified), or angular.noop otherwise.
	   */
	  this.unwatchItemSize_ = angular.noop;
	
	  /**
	   * Presently rendered blocks by repeat index.
	   * @type {Object<number, !VirtualRepeatController.Block>}
	   */
	  this.blocks = {};
	  /** @type {Array<!VirtualRepeatController.Block>} A pool of presently unused blocks. */
	  this.pooledBlocks = [];
	
	  $scope.$on('$destroy', angular.bind(this, this.cleanupBlocks_));
	}
	
	
	/**
	 * An object representing a repeated item.
	 * @typedef {{element: !jqLite, new: boolean, scope: !angular.Scope}}
	 */
	VirtualRepeatController.Block;
	
	
	/**
	 * Called at startup by the md-virtual-repeat postLink function.
	 * @param {!VirtualRepeatContainerController} container The container's controller.
	 * @param {!Function} transclude The repeated element's bound transclude function.
	 * @param {string} repeatName The left hand side of the repeat expression, indicating
	 *     the name for each item in the array.
	 * @param {!Function} repeatListExpression A compiled expression based on the right hand side
	 *     of the repeat expression. Points to the array to repeat over.
	 * @param {string|undefined} extraName The optional extra repeatName.
	 */
	VirtualRepeatController.prototype.link_ =
	    function(container, transclude, repeatName, repeatListExpression, extraName) {
	  this.container = container;
	  this.transclude = transclude;
	  this.repeatName = repeatName;
	  this.rawRepeatListExpression = repeatListExpression;
	  this.extraName = extraName;
	  this.sized = false;
	
	  this.repeatListExpression = angular.bind(this, this.repeatListExpression_);
	
	  this.container.register(this);
	};
	
	
	/** @private Cleans up unused blocks. */
	VirtualRepeatController.prototype.cleanupBlocks_ = function() {
	  angular.forEach(this.pooledBlocks, function cleanupBlock(block) {
	    block.element.remove();
	  });
	};
	
	
	/** @private Attempts to set itemSize by measuring a repeated element in the dom */
	VirtualRepeatController.prototype.readItemSize_ = function() {
	  if (this.itemSize) {
	    // itemSize was successfully read in a different asynchronous call.
	    return;
	  }
	
	  this.items = this.repeatListExpression(this.$scope);
	  this.parentNode = this.$element[0].parentNode;
	  var block = this.getBlock_(0);
	  if (!block.element[0].parentNode) {
	    this.parentNode.appendChild(block.element[0]);
	  }
	
	  this.itemSize = block.element[0][
	      this.container.isHorizontal() ? 'offsetWidth' : 'offsetHeight'] || null;
	
	  this.blocks[0] = block;
	  this.poolBlock_(0);
	
	  if (this.itemSize) {
	    this.containerUpdated();
	  }
	};
	
	
	/**
	 * Returns the user-specified repeat list, transforming it into an array-like
	 * object in the case of infinite scroll/dynamic load mode.
	 * @param {!angular.Scope} The scope.
	 * @return {!Array|!Object} An array or array-like object for iteration.
	 */
	VirtualRepeatController.prototype.repeatListExpression_ = function(scope) {
	  var repeatList = this.rawRepeatListExpression(scope);
	
	  if (this.onDemand && repeatList) {
	    var virtualList = new VirtualRepeatModelArrayLike(repeatList);
	    virtualList.$$includeIndexes(this.newStartIndex, this.newVisibleEnd);
	    return virtualList;
	  } else {
	    return repeatList;
	  }
	};
	
	
	/**
	 * Called by the container. Informs us that the container's scroll or size has
	 * changed.
	 */
	VirtualRepeatController.prototype.containerUpdated = function() {
	  // If itemSize is unknown, attempt to measure it.
	  if (!this.itemSize) {
	    // Make sure to clean up watchers if we can (see #8178)
	    if(this.unwatchItemSize_ && this.unwatchItemSize_ !== angular.noop){
	      this.unwatchItemSize_();
	    }
	    this.unwatchItemSize_ = this.$scope.$watchCollection(
	        this.repeatListExpression,
	        angular.bind(this, function(items) {
	          if (items && items.length) {
	            this.readItemSize_();
	          }
	        }));
	    if (!this.$rootScope.$$phase) this.$scope.$digest();
	
	    return;
	  } else if (!this.sized) {
	    this.items = this.repeatListExpression(this.$scope);
	  }
	
	  if (!this.sized) {
	    this.unwatchItemSize_();
	    this.sized = true;
	    this.$scope.$watchCollection(this.repeatListExpression,
	        angular.bind(this, function(items, oldItems) {
	          if (!this.isVirtualRepeatUpdating_) {
	            this.virtualRepeatUpdate_(items, oldItems);
	          }
	        }));
	  }
	
	  this.updateIndexes_();
	
	  if (this.newStartIndex !== this.startIndex ||
	      this.newEndIndex !== this.endIndex ||
	      this.container.getScrollOffset() > this.container.getScrollSize()) {
	    if (this.items instanceof VirtualRepeatModelArrayLike) {
	      this.items.$$includeIndexes(this.newStartIndex, this.newEndIndex);
	    }
	    this.virtualRepeatUpdate_(this.items, this.items);
	  }
	};
	
	
	/**
	 * Called by the container. Returns the size of a single repeated item.
	 * @return {?number} size of a repeated item.
	 */
	VirtualRepeatController.prototype.getItemSize = function() {
	  return this.itemSize;
	};
	
	
	/**
	 * Called by the container.
	 * @return {?number} the most recently seen length of items.
	 */
	VirtualRepeatController.prototype.getItemCount = function() {
	  return this.itemsLength;
	};
	
	
	/**
	 * Updates the order and visible offset of repeated blocks in response to scrolling
	 * or updates to `items`.
	 * @param items {Array} visible elements
	 * @param oldItems {Array} previously visible elements
	 * @private
	 */
	VirtualRepeatController.prototype.virtualRepeatUpdate_ = function(items, oldItems) {
	  this.isVirtualRepeatUpdating_ = true;
	
	  var itemsLength = items && items.length || 0;
	  var lengthChanged = false;
	
	  // If the number of items shrank, keep the scroll position.
	  if (this.items && itemsLength < this.items.length && this.container.getScrollOffset() !== 0) {
	    this.items = items;
	    var previousScrollOffset = this.container.getScrollOffset();
	    this.container.resetScroll();
	    this.container.scrollTo(previousScrollOffset);
	  }
	
	  if (itemsLength !== this.itemsLength) {
	    lengthChanged = true;
	    this.itemsLength = itemsLength;
	  }
	
	  this.items = items;
	  if (items !== oldItems || lengthChanged) {
	    this.updateIndexes_();
	  }
	
	  this.parentNode = this.$element[0].parentNode;
	
	  if (lengthChanged) {
	    this.container.setScrollSize(itemsLength * this.itemSize);
	  }
	
	  // Detach and pool any blocks that are no longer in the viewport.
	  Object.keys(this.blocks).forEach(function(blockIndex) {
	    var index = parseInt(blockIndex, 10);
	    if (index < this.newStartIndex || index >= this.newEndIndex) {
	      this.poolBlock_(index);
	    }
	  }, this);
	
	  // Add needed blocks.
	  // For performance reasons, temporarily block browser url checks as we digest
	  // the restored block scopes ($$checkUrlChange reads window.location to
	  // check for changes and trigger route change, etc, which we don't need when
	  // trying to scroll at 60fps).
	  this.$browser.$$checkUrlChange = angular.noop;
	
	  var i, block,
	      newStartBlocks = [],
	      newEndBlocks = [];
	
	  // Collect blocks at the top.
	  for (i = this.newStartIndex; i < this.newEndIndex && this.blocks[i] == null; i++) {
	    block = this.getBlock_(i);
	    this.updateBlock_(block, i);
	    newStartBlocks.push(block);
	  }
	
	  // Update blocks that are already rendered.
	  for (; this.blocks[i] != null; i++) {
	    this.updateBlock_(this.blocks[i], i);
	  }
	  var maxIndex = i - 1;
	
	  // Collect blocks at the end.
	  for (; i < this.newEndIndex; i++) {
	    block = this.getBlock_(i);
	    this.updateBlock_(block, i);
	    newEndBlocks.push(block);
	  }
	
	  // Attach collected blocks to the document.
	  if (newStartBlocks.length) {
	    this.parentNode.insertBefore(
	        this.domFragmentFromBlocks_(newStartBlocks),
	        this.$element[0].nextSibling);
	  }
	  if (newEndBlocks.length) {
	    this.parentNode.insertBefore(
	        this.domFragmentFromBlocks_(newEndBlocks),
	        this.blocks[maxIndex] && this.blocks[maxIndex].element[0].nextSibling);
	  }
	
	  // Restore $$checkUrlChange.
	  this.$browser.$$checkUrlChange = this.browserCheckUrlChange;
	
	  this.startIndex = this.newStartIndex;
	  this.endIndex = this.newEndIndex;
	
	  if (this.isFirstRender) {
	    this.isFirstRender = false;
	    var firstRenderStartIndex = this.$attrs.mdStartIndex ?
	      this.$scope.$eval(this.$attrs.mdStartIndex) :
	      this.container.topIndex;
	
	    // The first call to virtualRepeatUpdate_ may not be when the virtual repeater is ready.
	    // Introduce a slight delay so that the update happens when it is actually ready.
	    this.$mdUtil.nextTick(function() {
	      this.container.scrollToIndex(firstRenderStartIndex);
	    }.bind(this));
	  }
	
	  this.isVirtualRepeatUpdating_ = false;
	};
	
	
	/**
	 * @param {number} index Where the block is to be in the repeated list.
	 * @return {!VirtualRepeatController.Block} A new or pooled block to place at the specified index.
	 * @private
	 */
	VirtualRepeatController.prototype.getBlock_ = function(index) {
	  if (this.pooledBlocks.length) {
	    return this.pooledBlocks.pop();
	  }
	
	  var block;
	  this.transclude(angular.bind(this, function(clone, scope) {
	    block = {
	      element: clone,
	      new: true,
	      scope: scope
	    };
	
	    this.updateScope_(scope, index);
	    this.parentNode.appendChild(clone[0]);
	  }));
	
	  return block;
	};
	
	
	/**
	 * Updates and if not in a digest cycle, digests the specified block's scope to the data
	 * at the specified index.
	 * @param {!VirtualRepeatController.Block} block The block whose scope should be updated.
	 * @param {number} index The index to set.
	 * @private
	 */
	VirtualRepeatController.prototype.updateBlock_ = function(block, index) {
	  this.blocks[index] = block;
	
	  if (!block.new &&
	      (block.scope.$index === index && block.scope[this.repeatName] === this.items[index])) {
	    return;
	  }
	  block.new = false;
	
	  // Update and digest the block's scope.
	  this.updateScope_(block.scope, index);
	
	  // Perform digest before reattaching the block.
	  // Any resulting synchronous DOM mutations should be much faster as a result.
	  // This might break some directives.
	  if (!this.$rootScope.$$phase) {
	    block.scope.$digest();
	  }
	};
	
	
	/**
	 * Updates scope to the data at the specified index.
	 * @param {!angular.Scope} scope The scope which should be updated.
	 * @param {number} index The index to set.
	 * @private
	 */
	VirtualRepeatController.prototype.updateScope_ = function(scope, index) {
	  scope.$index = index;
	  scope[this.repeatName] = this.items && this.items[index];
	  if (this.extraName) scope[this.extraName(this.$scope)] = this.items[index];
	};
	
	
	/**
	 * Pools the block at the specified index (Pulls its element out of the dom and stores it).
	 * @param {number} index The index at which the block to pool is stored.
	 * @private
	 */
	VirtualRepeatController.prototype.poolBlock_ = function(index) {
	  this.pooledBlocks.push(this.blocks[index]);
	  this.parentNode.removeChild(this.blocks[index].element[0]);
	  delete this.blocks[index];
	};
	
	
	/**
	 * Produces a dom fragment containing the elements from the list of blocks.
	 * @param {!Array<!VirtualRepeatController.Block>} blocks The blocks whose elements
	 *     should be added to the document fragment.
	 * @return {DocumentFragment}
	 * @private
	 */
	VirtualRepeatController.prototype.domFragmentFromBlocks_ = function(blocks) {
	  var fragment = this.$document[0].createDocumentFragment();
	  blocks.forEach(function(block) {
	    fragment.appendChild(block.element[0]);
	  });
	  return fragment;
	};
	
	
	/**
	 * Updates start and end indexes based on length of repeated items and container size.
	 * @private
	 */
	VirtualRepeatController.prototype.updateIndexes_ = function() {
	  var itemsLength = this.items ? this.items.length : 0;
	  var containerLength = Math.ceil(this.container.getSize() / this.itemSize);
	
	  this.newStartIndex = Math.max(0, Math.min(
	      itemsLength - containerLength,
	      Math.floor(this.container.getScrollOffset() / this.itemSize)));
	  this.newVisibleEnd = this.newStartIndex + containerLength + NUM_EXTRA;
	  this.newEndIndex = Math.min(itemsLength, this.newVisibleEnd);
	  this.newStartIndex = Math.max(0, this.newStartIndex - NUM_EXTRA);
	};
	
	/**
	 * This VirtualRepeatModelArrayLike class enforces the interface requirements
	 * for infinite scrolling within a mdVirtualRepeatContainer. An object with this
	 * interface must implement the following interface with two (2) methods:
	 *
	 * getItemAtIndex: function(index) -> item at that index or null if it is not yet
	 *     loaded (It should start downloading the item in that case).
	 *
	 * getLength: function() -> number The data legnth to which the repeater container
	 *     should be sized. Ideally, when the count is known, this method should return it.
	 *     Otherwise, return a higher number than the currently loaded items to produce an
	 *     infinite-scroll behavior.
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-virtual-repeat-container md-orient-horizontal>
	 *    <div md-virtual-repeat="i in items" md-on-demand>
	 *      Hello {{i}}!
	 *    </div>
	 *  </md-virtual-repeat-container>
	 * </hljs>
	 *
	 */
	function VirtualRepeatModelArrayLike(model) {
	  if (!angular.isFunction(model.getItemAtIndex) ||
	      !angular.isFunction(model.getLength)) {
	    throw Error('When md-on-demand is enabled, the Object passed to md-virtual-repeat must implement ' +
	        'functions getItemAtIndex() and getLength() ');
	  }
	
	  this.model = model;
	}
	
	
	VirtualRepeatModelArrayLike.prototype.$$includeIndexes = function(start, end) {
	  for (var i = start; i < end; i++) {
	    if (!this.hasOwnProperty(i)) {
	      this[i] = this.model.getItemAtIndex(i);
	    }
	  }
	  this.length = this.model.getLength();
	};
	
	/**
	 * @ngdoc directive
	 * @name mdForceHeight
	 * @module material.components.virtualRepeat
	 * @restrict A
	 * @description
	 *
	 * Force an element to have a certain `px` height. This is used in place of a style tag in order to
	 * conform to the
	 * <a href="https://developer.mozilla.org/docs/Web/HTTP/Headers/Content-Security-Policy/script-src">
	 *   Content Security Policy</a> regarding `unsafe-inline` `<style>` tags.
	 *
	 * This directive is related to <a ng-href="api/directive/mdVirtualRepeat">mdVirtualRepeat</a>.
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <div md-force-height="'100px'"></div>
	 * </hljs>
	 */
	function ForceHeightDirective($mdUtil) {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      var height = scope.$eval(attrs.mdForceHeight) || null;
	
	      if (height && element) {
	        element[0].style.height = height;
	      }
	    }
	  };
	}
	ForceHeightDirective.$inject = ['$mdUtil'];
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.whiteframe
	 */
	MdWhiteframeDirective.$inject = ["$log"];
	angular
	  .module('material.components.whiteframe', ['material.core'])
	  .directive('mdWhiteframe', MdWhiteframeDirective);
	
	/**
	 * @ngdoc directive
	 * @module material.components.whiteframe
	 * @name mdWhiteframe
	 *
	 * @description
	 * The md-whiteframe directive allows you to apply an elevation shadow to an element.
	 *
	 * The attribute values needs to be a number between 1 and 24 or -1.
	 * When set to -1 no style is applied.
	 *
	 * ### Notes
	 * - If there is no value specified it defaults to 4dp.
	 * - If the value is not valid it defaults to 4dp.
	
	 * @usage
	 * <hljs lang="html">
	 * <div md-whiteframe="3">
	 *   <span>Elevation of 3dp</span>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="html">
	 * <div md-whiteframe="-1">
	 *   <span>No elevation shadow applied</span>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="html">
	 * <div ng-init="elevation = 5" md-whiteframe="{{elevation}}">
	 *   <span>Elevation of 5dp with an interpolated value</span>
	 * </div>
	 * </hljs>
	 */
	function MdWhiteframeDirective($log) {
	  var DISABLE_DP = -1;
	  var MIN_DP = 1;
	  var MAX_DP = 24;
	  var DEFAULT_DP = 4;
	
	  return {
	    link: postLink
	  };
	
	  function postLink(scope, element, attr) {
	    var oldClass = '';
	
	    attr.$observe('mdWhiteframe', function(elevation) {
	      elevation = parseInt(elevation, 10) || DEFAULT_DP;
	
	      if (elevation != DISABLE_DP && (elevation > MAX_DP || elevation < MIN_DP)) {
	        $log.warn('md-whiteframe attribute value is invalid. It should be a number between ' + MIN_DP + ' and ' + MAX_DP, element[0]);
	        elevation = DEFAULT_DP;
	      }
	
	      var newClass = elevation == DISABLE_DP ? '' : 'md-whiteframe-' + elevation + 'dp';
	      attr.$updateClass(newClass, oldClass);
	      oldClass = newClass;
	    });
	  }
	}
	
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocompleteCtrl.$inject = ["$scope", "$element", "$mdUtil", "$mdConstant", "$mdTheming", "$window", "$animate", "$rootElement", "$attrs", "$q", "$log", "$mdLiveAnnouncer"];angular
	    .module('material.components.autocomplete')
	    .controller('MdAutocompleteCtrl', MdAutocompleteCtrl);
	
	var ITEM_HEIGHT   = 48,
	    MAX_ITEMS     = 5,
	    MENU_PADDING  = 8,
	    INPUT_PADDING = 2; // Padding provided by `md-input-container`
	
	function MdAutocompleteCtrl ($scope, $element, $mdUtil, $mdConstant, $mdTheming, $window,
	                             $animate, $rootElement, $attrs, $q, $log, $mdLiveAnnouncer) {
	
	  // Internal Variables.
	  var ctrl                 = this,
	      itemParts            = $scope.itemsExpr.split(/ in /i),
	      itemExpr             = itemParts[ 1 ],
	      elements             = null,
	      cache                = {},
	      noBlur               = false,
	      selectedItemWatchers = [],
	      hasFocus             = false,
	      fetchesInProgress    = 0,
	      enableWrapScroll     = null,
	      inputModelCtrl       = null,
	      debouncedOnResize    = $mdUtil.debounce(onWindowResize);
	
	  // Public Exported Variables with handlers
	  defineProperty('hidden', handleHiddenChange, true);
	
	  // Public Exported Variables
	  ctrl.scope      = $scope;
	  ctrl.parent     = $scope.$parent;
	  ctrl.itemName   = itemParts[ 0 ];
	  ctrl.matches    = [];
	  ctrl.loading    = false;
	  ctrl.hidden     = true;
	  ctrl.index      = null;
	  ctrl.id         = $mdUtil.nextUid();
	  ctrl.isDisabled = null;
	  ctrl.isRequired = null;
	  ctrl.isReadonly = null;
	  ctrl.hasNotFound = false;
	
	  // Public Exported Methods
	  ctrl.keydown                       = keydown;
	  ctrl.blur                          = blur;
	  ctrl.focus                         = focus;
	  ctrl.clear                         = clearValue;
	  ctrl.select                        = select;
	  ctrl.listEnter                     = onListEnter;
	  ctrl.listLeave                     = onListLeave;
	  ctrl.mouseUp                       = onMouseup;
	  ctrl.getCurrentDisplayValue        = getCurrentDisplayValue;
	  ctrl.registerSelectedItemWatcher   = registerSelectedItemWatcher;
	  ctrl.unregisterSelectedItemWatcher = unregisterSelectedItemWatcher;
	  ctrl.notFoundVisible               = notFoundVisible;
	  ctrl.loadingIsVisible              = loadingIsVisible;
	  ctrl.positionDropdown              = positionDropdown;
	
	  /**
	   * Report types to be used for the $mdLiveAnnouncer
	   * @enum {number} Unique flag id.
	   */
	  var ReportType = {
	    Count: 1,
	    Selected: 2
	  };
	
	  return init();
	
	  //-- initialization methods
	
	  /**
	   * Initialize the controller, setup watchers, gather elements
	   */
	  function init () {
	
	    $mdUtil.initOptionalProperties($scope, $attrs, {
	      searchText: '',
	      selectedItem: null,
	      clearButton: false
	    });
	
	    $mdTheming($element);
	    configureWatchers();
	    $mdUtil.nextTick(function () {
	
	      gatherElements();
	      moveDropdown();
	
	      // Forward all focus events to the input element when autofocus is enabled
	      if ($scope.autofocus) {
	        $element.on('focus', focusInputElement);
	      }
	    });
	  }
	
	  function updateModelValidators() {
	    if (!$scope.requireMatch || !inputModelCtrl) return;
	
	    inputModelCtrl.$setValidity('md-require-match', !!$scope.selectedItem || !$scope.searchText);
	  }
	
	  /**
	   * Calculates the dropdown's position and applies the new styles to the menu element
	   * @returns {*}
	   */
	  function positionDropdown () {
	    if (!elements) {
	      return $mdUtil.nextTick(positionDropdown, false, $scope);
	    }
	
	    var dropdownHeight = ($scope.dropdownItems || MAX_ITEMS) * ITEM_HEIGHT;
	
	    var hrect  = elements.wrap.getBoundingClientRect(),
	        vrect  = elements.snap.getBoundingClientRect(),
	        root   = elements.root.getBoundingClientRect(),
	        top    = vrect.bottom - root.top,
	        bot    = root.bottom - vrect.top,
	        left   = hrect.left - root.left,
	        width  = hrect.width,
	        offset = getVerticalOffset(),
	        position = $scope.dropdownPosition,
	        styles;
	
	    // Automatically determine dropdown placement based on available space in viewport.
	    if (!position) {
	      position = (top > bot && root.height - top - MENU_PADDING < dropdownHeight) ? 'top' : 'bottom';
	    }
	    // Adjust the width to account for the padding provided by `md-input-container`
	    if ($attrs.mdFloatingLabel) {
	      left += INPUT_PADDING;
	      width -= INPUT_PADDING * 2;
	    }
	    styles = {
	      left:     left + 'px',
	      minWidth: width + 'px',
	      maxWidth: Math.max(hrect.right - root.left, root.right - hrect.left) - MENU_PADDING + 'px'
	    };
	
	    if (position === 'top') {
	      styles.top       = 'auto';
	      styles.bottom    = bot + 'px';
	      styles.maxHeight = Math.min(dropdownHeight, hrect.top - root.top - MENU_PADDING) + 'px';
	    } else {
	      var bottomSpace = root.bottom - hrect.bottom - MENU_PADDING + $mdUtil.getViewportTop();
	
	      styles.top       = (top - offset) + 'px';
	      styles.bottom    = 'auto';
	      styles.maxHeight = Math.min(dropdownHeight, bottomSpace) + 'px';
	    }
	
	    elements.$.scrollContainer.css(styles);
	    $mdUtil.nextTick(correctHorizontalAlignment, false);
	
	    /**
	     * Calculates the vertical offset for floating label examples to account for ngMessages
	     * @returns {number}
	     */
	    function getVerticalOffset () {
	      var offset = 0;
	      var inputContainer = $element.find('md-input-container');
	      if (inputContainer.length) {
	        var input = inputContainer.find('input');
	        offset = inputContainer.prop('offsetHeight');
	        offset -= input.prop('offsetTop');
	        offset -= input.prop('offsetHeight');
	        // add in the height left up top for the floating label text
	        offset += inputContainer.prop('offsetTop');
	      }
	      return offset;
	    }
	
	    /**
	     * Makes sure that the menu doesn't go off of the screen on either side.
	     */
	    function correctHorizontalAlignment () {
	      var dropdown = elements.scrollContainer.getBoundingClientRect(),
	          styles   = {};
	      if (dropdown.right > root.right - MENU_PADDING) {
	        styles.left = (hrect.right - dropdown.width) + 'px';
	      }
	      elements.$.scrollContainer.css(styles);
	    }
	  }
	
	  /**
	   * Moves the dropdown menu to the body tag in order to avoid z-index and overflow issues.
	   */
	  function moveDropdown () {
	    if (!elements.$.root.length) return;
	    $mdTheming(elements.$.scrollContainer);
	    elements.$.scrollContainer.detach();
	    elements.$.root.append(elements.$.scrollContainer);
	    if ($animate.pin) $animate.pin(elements.$.scrollContainer, $rootElement);
	  }
	
	  /**
	   * Sends focus to the input element.
	   */
	  function focusInputElement () {
	    elements.input.focus();
	  }
	
	  /**
	   * Sets up any watchers used by autocomplete
	   */
	  function configureWatchers () {
	    var wait = parseInt($scope.delay, 10) || 0;
	
	    $attrs.$observe('disabled', function (value) { ctrl.isDisabled = $mdUtil.parseAttributeBoolean(value, false); });
	    $attrs.$observe('required', function (value) { ctrl.isRequired = $mdUtil.parseAttributeBoolean(value, false); });
	    $attrs.$observe('readonly', function (value) { ctrl.isReadonly = $mdUtil.parseAttributeBoolean(value, false); });
	
	    $scope.$watch('searchText', wait ? $mdUtil.debounce(handleSearchText, wait) : handleSearchText);
	    $scope.$watch('selectedItem', selectedItemChange);
	
	    angular.element($window).on('resize', debouncedOnResize);
	
	    $scope.$on('$destroy', cleanup);
	  }
	
	  /**
	   * Removes any events or leftover elements created by this controller
	   */
	  function cleanup () {
	    if (!ctrl.hidden) {
	      $mdUtil.enableScrolling();
	    }
	
	    angular.element($window).off('resize', debouncedOnResize);
	
	    if ( elements ){
	      var items = ['ul', 'scroller', 'scrollContainer', 'input'];
	      angular.forEach(items, function(key){
	        elements.$[key].remove();
	      });
	    }
	  }
	
	  /**
	   * Event handler to be called whenever the window resizes.
	   */
	  function onWindowResize() {
	    if (!ctrl.hidden) {
	      positionDropdown();
	    }
	  }
	
	  /**
	   * Gathers all of the elements needed for this controller
	   */
	  function gatherElements () {
	
	    var snapWrap = gatherSnapWrap();
	
	    elements = {
	      main:  $element[0],
	      scrollContainer: $element[0].querySelector('.md-virtual-repeat-container'),
	      scroller: $element[0].querySelector('.md-virtual-repeat-scroller'),
	      ul:    $element.find('ul')[0],
	      input: $element.find('input')[0],
	      wrap:  snapWrap.wrap,
	      snap:  snapWrap.snap,
	      root:  document.body
	    };
	
	    elements.li   = elements.ul.getElementsByTagName('li');
	    elements.$    = getAngularElements(elements);
	
	    inputModelCtrl = elements.$.input.controller('ngModel');
	  }
	
	  /**
	   * Gathers the snap and wrap elements
	   *
	   */
	  function gatherSnapWrap() {
	    var element;
	    var value;
	    for (element = $element; element.length; element = element.parent()) {
	      value = element.attr('md-autocomplete-snap');
	      if (angular.isDefined(value)) break;
	    }
	
	    if (element.length) {
	      return {
	        snap: element[0],
	        wrap: (value.toLowerCase() === 'width') ? element[0] : $element.find('md-autocomplete-wrap')[0]
	      };
	    }
	
	    var wrap = $element.find('md-autocomplete-wrap')[0];
	    return {
	      snap: wrap,
	      wrap: wrap
	    };
	  }
	
	  /**
	   * Gathers angular-wrapped versions of each element
	   * @param elements
	   * @returns {{}}
	   */
	  function getAngularElements (elements) {
	    var obj = {};
	    for (var key in elements) {
	      if (elements.hasOwnProperty(key)) obj[ key ] = angular.element(elements[ key ]);
	    }
	    return obj;
	  }
	
	  //-- event/change handlers
	
	  /**
	   * Handles changes to the `hidden` property.
	   * @param hidden
	   * @param oldHidden
	   */
	  function handleHiddenChange (hidden, oldHidden) {
	    if (!hidden && oldHidden) {
	      positionDropdown();
	
	      // Report in polite mode, because the screenreader should finish the default description of
	      // the input. element.
	      reportMessages(true, ReportType.Count | ReportType.Selected);
	
	      if (elements) {
	        $mdUtil.disableScrollAround(elements.ul);
	        enableWrapScroll = disableElementScrollEvents(angular.element(elements.wrap));
	      }
	    } else if (hidden && !oldHidden) {
	      $mdUtil.enableScrolling();
	
	      if (enableWrapScroll) {
	        enableWrapScroll();
	        enableWrapScroll = null;
	      }
	    }
	  }
	
	  /**
	   * Disables scrolling for a specific element
	   */
	  function disableElementScrollEvents(element) {
	
	    function preventDefault(e) {
	      e.preventDefault();
	    }
	
	    element.on('wheel', preventDefault);
	    element.on('touchmove', preventDefault);
	
	    return function() {
	      element.off('wheel', preventDefault);
	      element.off('touchmove', preventDefault);
	    };
	  }
	
	  /**
	   * When the user mouses over the dropdown menu, ignore blur events.
	   */
	  function onListEnter () {
	    noBlur = true;
	  }
	
	  /**
	   * When the user's mouse leaves the menu, blur events may hide the menu again.
	   */
	  function onListLeave () {
	    if (!hasFocus && !ctrl.hidden) elements.input.focus();
	    noBlur = false;
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * When the mouse button is released, send focus back to the input field.
	   */
	  function onMouseup () {
	    elements.input.focus();
	  }
	
	  /**
	   * Handles changes to the selected item.
	   * @param selectedItem
	   * @param previousSelectedItem
	   */
	  function selectedItemChange (selectedItem, previousSelectedItem) {
	
	    updateModelValidators();
	
	    if (selectedItem) {
	      getDisplayValue(selectedItem).then(function (val) {
	        $scope.searchText = val;
	        handleSelectedItemChange(selectedItem, previousSelectedItem);
	      });
	    } else if (previousSelectedItem && $scope.searchText) {
	      getDisplayValue(previousSelectedItem).then(function(displayValue) {
	        // Clear the searchText, when the selectedItem is set to null.
	        // Do not clear the searchText, when the searchText isn't matching with the previous
	        // selected item.
	        if (angular.isString($scope.searchText)
	          && displayValue.toString().toLowerCase() === $scope.searchText.toLowerCase()) {
	          $scope.searchText = '';
	        }
	      });
	    }
	
	    if (selectedItem !== previousSelectedItem) announceItemChange();
	  }
	
	  /**
	   * Use the user-defined expression to announce changes each time a new item is selected
	   */
	  function announceItemChange () {
	    angular.isFunction($scope.itemChange) && $scope.itemChange(getItemAsNameVal($scope.selectedItem));
	  }
	
	  /**
	   * Use the user-defined expression to announce changes each time the search text is changed
	   */
	  function announceTextChange () {
	    angular.isFunction($scope.textChange) && $scope.textChange();
	  }
	
	  /**
	   * Calls any external watchers listening for the selected item.  Used in conjunction with
	   * `registerSelectedItemWatcher`.
	   * @param selectedItem
	   * @param previousSelectedItem
	   */
	  function handleSelectedItemChange (selectedItem, previousSelectedItem) {
	    selectedItemWatchers.forEach(function (watcher) { watcher(selectedItem, previousSelectedItem); });
	  }
	
	  /**
	   * Register a function to be called when the selected item changes.
	   * @param cb
	   */
	  function registerSelectedItemWatcher (cb) {
	    if (selectedItemWatchers.indexOf(cb) == -1) {
	      selectedItemWatchers.push(cb);
	    }
	  }
	
	  /**
	   * Unregister a function previously registered for selected item changes.
	   * @param cb
	   */
	  function unregisterSelectedItemWatcher (cb) {
	    var i = selectedItemWatchers.indexOf(cb);
	    if (i != -1) {
	      selectedItemWatchers.splice(i, 1);
	    }
	  }
	
	  /**
	   * Handles changes to the searchText property.
	   * @param searchText
	   * @param previousSearchText
	   */
	  function handleSearchText (searchText, previousSearchText) {
	    ctrl.index = getDefaultIndex();
	
	    // do nothing on init
	    if (searchText === previousSearchText) return;
	
	    updateModelValidators();
	
	    getDisplayValue($scope.selectedItem).then(function (val) {
	      // clear selected item if search text no longer matches it
	      if (searchText !== val) {
	        $scope.selectedItem = null;
	
	
	        // trigger change event if available
	        if (searchText !== previousSearchText) announceTextChange();
	
	        // cancel results if search text is not long enough
	        if (!isMinLengthMet()) {
	          ctrl.matches = [];
	
	          setLoading(false);
	          reportMessages(false, ReportType.Count);
	
	        } else {
	          handleQuery();
	        }
	      }
	    });
	
	  }
	
	  /**
	   * Handles input blur event, determines if the dropdown should hide.
	   */
	  function blur($event) {
	    hasFocus = false;
	
	    if (!noBlur) {
	      ctrl.hidden = shouldHide();
	      evalAttr('ngBlur', { $event: $event });
	    }
	  }
	
	  /**
	   * Force blur on input element
	   * @param forceBlur
	   */
	  function doBlur(forceBlur) {
	    if (forceBlur) {
	      noBlur = false;
	      hasFocus = false;
	    }
	    elements.input.blur();
	  }
	
	  /**
	   * Handles input focus event, determines if the dropdown should show.
	   */
	  function focus($event) {
	    hasFocus = true;
	
	    if (isSearchable() && isMinLengthMet()) {
	      handleQuery();
	    }
	
	    ctrl.hidden = shouldHide();
	
	    evalAttr('ngFocus', { $event: $event });
	  }
	
	  /**
	   * Handles keyboard input.
	   * @param event
	   */
	  function keydown (event) {
	    switch (event.keyCode) {
	      case $mdConstant.KEY_CODE.DOWN_ARROW:
	        if (ctrl.loading) return;
	        event.stopPropagation();
	        event.preventDefault();
	        ctrl.index   = Math.min(ctrl.index + 1, ctrl.matches.length - 1);
	        updateScroll();
	        reportMessages(false, ReportType.Selected);
	        break;
	      case $mdConstant.KEY_CODE.UP_ARROW:
	        if (ctrl.loading) return;
	        event.stopPropagation();
	        event.preventDefault();
	        ctrl.index   = ctrl.index < 0 ? ctrl.matches.length - 1 : Math.max(0, ctrl.index - 1);
	        updateScroll();
	        reportMessages(false, ReportType.Selected);
	        break;
	      case $mdConstant.KEY_CODE.TAB:
	        // If we hit tab, assume that we've left the list so it will close
	        onListLeave();
	
	        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
	        select(ctrl.index);
	        break;
	      case $mdConstant.KEY_CODE.ENTER:
	        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
	        if (hasSelection()) return;
	        event.stopPropagation();
	        event.preventDefault();
	        select(ctrl.index);
	        break;
	      case $mdConstant.KEY_CODE.ESCAPE:
	        event.preventDefault(); // Prevent browser from always clearing input
	        if (!shouldProcessEscape()) return;
	        event.stopPropagation();
	
	        clearSelectedItem();
	        if ($scope.searchText && hasEscapeOption('clear')) {
	          clearSearchText();
	        }
	
	        // Manually hide (needed for mdNotFound support)
	        ctrl.hidden = true;
	
	        if (hasEscapeOption('blur')) {
	          // Force the component to blur if they hit escape
	          doBlur(true);
	        }
	
	        break;
	      default:
	    }
	  }
	
	  //-- getters
	
	  /**
	   * Returns the minimum length needed to display the dropdown.
	   * @returns {*}
	   */
	  function getMinLength () {
	    return angular.isNumber($scope.minLength) ? $scope.minLength : 1;
	  }
	
	  /**
	   * Returns the display value for an item.
	   * @param item
	   * @returns {*}
	   */
	  function getDisplayValue (item) {
	    return $q.when(getItemText(item) || item).then(function(itemText) {
	      if (itemText && !angular.isString(itemText)) {
	        $log.warn('md-autocomplete: Could not resolve display value to a string. ' +
	          'Please check the `md-item-text` attribute.');
	      }
	
	      return itemText;
	    });
	
	    /**
	     * Getter function to invoke user-defined expression (in the directive)
	     * to convert your object to a single string.
	     */
	    function getItemText (item) {
	      return (item && $scope.itemText) ? $scope.itemText(getItemAsNameVal(item)) : null;
	    }
	  }
	
	  /**
	   * Returns the locals object for compiling item templates.
	   * @param item
	   * @returns {{}}
	   */
	  function getItemAsNameVal (item) {
	    if (!item) return undefined;
	
	    var locals = {};
	    if (ctrl.itemName) locals[ ctrl.itemName ] = item;
	
	    return locals;
	  }
	
	  /**
	   * Returns the default index based on whether or not autoselect is enabled.
	   * @returns {number}
	   */
	  function getDefaultIndex () {
	    return $scope.autoselect ? 0 : -1;
	  }
	
	  /**
	   * Sets the loading parameter and updates the hidden state.
	   * @param value {boolean} Whether or not the component is currently loading.
	   */
	  function setLoading(value) {
	    if (ctrl.loading != value) {
	      ctrl.loading = value;
	    }
	
	    // Always refresh the hidden variable as something else might have changed
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * Determines if the menu should be hidden.
	   * @returns {boolean} true if the menu should be hidden
	   */
	  function shouldHide () {
	    return !shouldShow();
	  }
	
	  /**
	   * Determines whether the autocomplete is able to query within the current state.
	   * @returns {boolean} true if the query can be run
	   */
	  function isSearchable() {
	    if (ctrl.loading && !hasMatches()) {
	      // No query when query is in progress.
	      return false;
	    } else if (hasSelection()) {
	      // No query if there is already a selection
	      return false;
	    }
	    else if (!hasFocus) {
	      // No query if the input does not have focus
	      return false;
	    }
	    return true;
	  }
	
	  /**
	   * Determines if the escape keydown should be processed
	   * @returns {boolean}
	   */
	  function shouldProcessEscape() {
	    return hasEscapeOption('blur') || !ctrl.hidden || ctrl.loading || hasEscapeOption('clear') && $scope.searchText;
	  }
	
	  /**
	   * Determines if an escape option is set
	   * @returns {boolean}
	   */
	  function hasEscapeOption(option) {
	    return !$scope.escapeOptions || $scope.escapeOptions.toLowerCase().indexOf(option) !== -1;
	  }
	
	  /**
	   * Determines if the menu should be shown.
	   * @returns {boolean} true if the menu should be shown
	   */
	  function shouldShow() {
	    if (ctrl.isReadonly) {
	      // Don't show if read only is set
	      return false;
	    } else if (!isSearchable()) {
	      // Don't show if a query is in progress, there is already a selection,
	      // or the input is not focused.
	      return false;
	    }
	    return (isMinLengthMet() && hasMatches()) || notFoundVisible();
	  }
	
	  /**
	   * Returns true if the search text has matches.
	   * @returns {boolean}
	   */
	  function hasMatches() {
	    return ctrl.matches.length ? true : false;
	  }
	
	  /**
	   * Returns true if the autocomplete has a valid selection.
	   * @returns {boolean}
	   */
	  function hasSelection() {
	    return ctrl.scope.selectedItem ? true : false;
	  }
	
	  /**
	   * Returns true if the loading indicator is, or should be, visible.
	   * @returns {boolean}
	   */
	  function loadingIsVisible() {
	    return ctrl.loading && !hasSelection();
	  }
	
	  /**
	   * Returns the display value of the current item.
	   * @returns {*}
	   */
	  function getCurrentDisplayValue () {
	    return getDisplayValue(ctrl.matches[ ctrl.index ]);
	  }
	
	  /**
	   * Determines if the minimum length is met by the search text.
	   * @returns {*}
	   */
	  function isMinLengthMet () {
	    return ($scope.searchText || '').length >= getMinLength();
	  }
	
	  //-- actions
	
	  /**
	   * Defines a public property with a handler and a default value.
	   * @param key
	   * @param handler
	   * @param value
	   */
	  function defineProperty (key, handler, value) {
	    Object.defineProperty(ctrl, key, {
	      get: function () { return value; },
	      set: function (newValue) {
	        var oldValue = value;
	        value        = newValue;
	        handler(newValue, oldValue);
	      }
	    });
	  }
	
	  /**
	   * Selects the item at the given index.
	   * @param index
	   */
	  function select (index) {
	    //-- force form to update state for validation
	    $mdUtil.nextTick(function () {
	      getDisplayValue(ctrl.matches[ index ]).then(function (val) {
	        var ngModel = elements.$.input.controller('ngModel');
	        ngModel.$setViewValue(val);
	        ngModel.$render();
	      }).finally(function () {
	        $scope.selectedItem = ctrl.matches[ index ];
	        setLoading(false);
	      });
	    }, false);
	  }
	
	  /**
	   * Clears the searchText value and selected item.
	   */
	  function clearValue () {
	    clearSelectedItem();
	    clearSearchText();
	  }
	
	  /**
	   * Clears the selected item
	   */
	  function clearSelectedItem () {
	    // Reset our variables
	    ctrl.index = 0;
	    ctrl.matches = [];
	  }
	
	  /**
	   * Clears the searchText value
	   */
	  function clearSearchText () {
	    // Set the loading to true so we don't see flashes of content.
	    // The flashing will only occur when an async request is running.
	    // So the loading process will stop when the results had been retrieved.
	    setLoading(true);
	
	    $scope.searchText = '';
	
	    // Normally, triggering the change / input event is unnecessary, because the browser detects it properly.
	    // But some browsers are not detecting it properly, which means that we have to trigger the event.
	    // Using the `input` is not working properly, because for example IE11 is not supporting the `input` event.
	    // The `change` event is a good alternative and is supported by all supported browsers.
	    var eventObj = document.createEvent('CustomEvent');
	    eventObj.initCustomEvent('change', true, true, { value: '' });
	    elements.input.dispatchEvent(eventObj);
	
	    // For some reason, firing the above event resets the value of $scope.searchText if
	    // $scope.searchText has a space character at the end, so we blank it one more time and then
	    // focus.
	    elements.input.blur();
	    $scope.searchText = '';
	    elements.input.focus();
	  }
	
	  /**
	   * Fetches the results for the provided search text.
	   * @param searchText
	   */
	  function fetchResults (searchText) {
	    var items = $scope.$parent.$eval(itemExpr),
	        term  = searchText.toLowerCase(),
	        isList = angular.isArray(items),
	        isPromise = !!items.then; // Every promise should contain a `then` property
	
	    if (isList) onResultsRetrieved(items);
	    else if (isPromise) handleAsyncResults(items);
	
	    function handleAsyncResults(items) {
	      if ( !items ) return;
	
	      items = $q.when(items);
	      fetchesInProgress++;
	      setLoading(true);
	
	      $mdUtil.nextTick(function () {
	          items
	            .then(onResultsRetrieved)
	            .finally(function(){
	              if (--fetchesInProgress === 0) {
	                setLoading(false);
	              }
	            });
	      },true, $scope);
	    }
	
	    function onResultsRetrieved(matches) {
	      cache[term] = matches;
	
	      // Just cache the results if the request is now outdated.
	      // The request becomes outdated, when the new searchText has changed during the result fetching.
	      if ((searchText || '') !== ($scope.searchText || '')) {
	        return;
	      }
	
	      handleResults(matches);
	    }
	  }
	
	
	  /**
	   * Reports given message types to supported screenreaders.
	   * @param {boolean} isPolite Whether the announcement should be polite.
	   * @param {!number} types Message flags to be reported to the screenreader.
	   */
	  function reportMessages(isPolite, types) {
	
	    var politeness = isPolite ? 'polite' : 'assertive';
	    var messages = [];
	
	    if (types & ReportType.Selected && ctrl.index !== -1) {
	      messages.push(getCurrentDisplayValue());
	    }
	
	    if (types & ReportType.Count) {
	      messages.push($q.resolve(getCountMessage()));
	    }
	
	    $q.all(messages).then(function(data) {
	      $mdLiveAnnouncer.announce(data.join(' '), politeness);
	    });
	
	  }
	
	  /**
	   * Returns the ARIA message for how many results match the current query.
	   * @returns {*}
	   */
	  function getCountMessage () {
	    switch (ctrl.matches.length) {
	      case 0:
	        return 'There are no matches available.';
	      case 1:
	        return 'There is 1 match available.';
	      default:
	        return 'There are ' + ctrl.matches.length + ' matches available.';
	    }
	  }
	
	  /**
	   * Makes sure that the focused element is within view.
	   */
	  function updateScroll () {
	    if (!elements.li[0]) return;
	    var height = elements.li[0].offsetHeight,
	        top = height * ctrl.index,
	        bot = top + height,
	        hgt = elements.scroller.clientHeight,
	        scrollTop = elements.scroller.scrollTop;
	    if (top < scrollTop) {
	      scrollTo(top);
	    } else if (bot > scrollTop + hgt) {
	      scrollTo(bot - hgt);
	    }
	  }
	
	  function isPromiseFetching() {
	    return fetchesInProgress !== 0;
	  }
	
	  function scrollTo (offset) {
	    elements.$.scrollContainer.controller('mdVirtualRepeatContainer').scrollTo(offset);
	  }
	
	  function notFoundVisible () {
	    var textLength = (ctrl.scope.searchText || '').length;
	
	    return ctrl.hasNotFound && !hasMatches() && (!ctrl.loading || isPromiseFetching()) && textLength >= getMinLength() && (hasFocus || noBlur) && !hasSelection();
	  }
	
	  /**
	   * Starts the query to gather the results for the current searchText.  Attempts to return cached
	   * results first, then forwards the process to `fetchResults` if necessary.
	   */
	  function handleQuery () {
	    var searchText = $scope.searchText || '';
	    var term = searchText.toLowerCase();
	
	    // If caching is enabled and the current searchText is stored in the cache
	    if (!$scope.noCache && cache[term]) {
	      // The results should be handled as same as a normal un-cached request does.
	      handleResults(cache[term]);
	    } else {
	      fetchResults(searchText);
	    }
	
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * Handles the retrieved results by showing them in the autocompletes dropdown.
	   * @param results Retrieved results
	   */
	  function handleResults(results) {
	    ctrl.matches = results;
	    ctrl.hidden  = shouldHide();
	
	    // If loading is in progress, then we'll end the progress. This is needed for example,
	    // when the `clear` button was clicked, because there we always show the loading process, to prevent flashing.
	    if (ctrl.loading) setLoading(false);
	
	    if ($scope.selectOnMatch) selectItemOnMatch();
	
	    positionDropdown();
	    reportMessages(true, ReportType.Count);
	  }
	
	  /**
	   * If there is only one matching item and the search text matches its display value exactly,
	   * automatically select that item.  Note: This function is only called if the user uses the
	   * `md-select-on-match` flag.
	   */
	  function selectItemOnMatch () {
	    var searchText = $scope.searchText,
	        matches    = ctrl.matches,
	        item       = matches[ 0 ];
	    if (matches.length === 1) getDisplayValue(item).then(function (displayValue) {
	      var isMatching = searchText == displayValue;
	      if ($scope.matchInsensitive && !isMatching) {
	        isMatching = searchText.toLowerCase() == displayValue.toLowerCase();
	      }
	
	      if (isMatching) select(0);
	    });
	  }
	
	  /**
	   * Evaluates an attribute expression against the parent scope.
	   * @param {String} attr Name of the attribute to be evaluated.
	   * @param {Object?} locals Properties to be injected into the evaluation context.
	   */
	 function evalAttr(attr, locals) {
	    if ($attrs[attr]) {
	      $scope.$parent.$eval($attrs[attr], locals || {});
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocomplete.$inject = ["$$mdSvgRegistry"];angular
	    .module('material.components.autocomplete')
	    .directive('mdAutocomplete', MdAutocomplete);
	
	/**
	 * @ngdoc directive
	 * @name mdAutocomplete
	 * @module material.components.autocomplete
	 *
	 * @description
	 * `<md-autocomplete>` is a special input component with a drop-down of all possible matches to a
	 *     custom query. This component allows you to provide real-time suggestions as the user types
	 *     in the input area.
	 *
	 * To start, you will need to specify the required parameters and provide a template for your
	 *     results. The content inside `md-autocomplete` will be treated as a template.
	 *
	 * In more complex cases, you may want to include other content such as a message to display when
	 *     no matches were found.  You can do this by wrapping your template in `md-item-template` and
	 *     adding a tag for `md-not-found`.  An example of this is shown below.
	 *
	 * To reset the displayed value you must clear both values for `md-search-text` and `md-selected-item`.
	 *
	 * ### Validation
	 *
	 * You can use `ng-messages` to include validation the same way that you would normally validate;
	 *     however, if you want to replicate a standard input with a floating label, you will have to
	 *     do the following:
	 *
	 * - Make sure that your template is wrapped in `md-item-template`
	 * - Add your `ng-messages` code inside of `md-autocomplete`
	 * - Add your validation properties to `md-autocomplete` (ie. `required`)
	 * - Add a `name` to `md-autocomplete` (to be used on the generated `input`)
	 *
	 * There is an example below of how this should look.
	 *
	 * ### Snapping Drop-Down
	 *
	 * You can cause the autocomplete drop-down to snap to an ancestor element by applying the
	 *     `md-autocomplete-snap` attribute to that element. You can also snap to the width of
	 *     the `md-autocomplete-snap` element by setting the attribute's value to `width`
	 *     (ie. `md-autocomplete-snap="width"`).
	 *
	 * ### Notes
	 *
	 * **Autocomplete Dropdown Items Rendering**
	 *
	 * The `md-autocomplete` uses the the <a ng-href="api/directive/mdVirtualRepeat">
	 *   mdVirtualRepeat</a> directive for displaying the results inside of the dropdown.<br/>
	 *
	 * > When encountering issues regarding the item template please take a look at the
	 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation.
	 *
	 * **Autocomplete inside of a Virtual Repeat**
	 *
	 * When using the `md-autocomplete` directive inside of a
	 * <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> the dropdown items
	 * might not update properly, because caching of the results is enabled by default.
	 *
	 * The autocomplete will then show invalid dropdown items, because the Virtual Repeat only updates
	 * the scope bindings rather than re-creating the `md-autocomplete`. This means that the previous
	 * cached results will be used.
	 *
	 * > To avoid such problems, ensure that the autocomplete does not cache any results via
	 * `md-no-cache="true"`:
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-no-cache="true"
	 *       md-selected-item="selectedItem"
	 *       md-items="item in items"
	 *       md-search-text="searchText"
	 *       md-item-text="item.display">
	 *     <span>{{ item.display }}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 *
	 * @param {expression} md-items An expression in the format of `item in results` to iterate over
	 *     matches for your search.<br/><br/>
	 *     The `results` expression can be also a function, which returns the results synchronously
	 *     or asynchronously (per Promise).
	 * @param {expression=} md-selected-item-change An expression to be run each time a new item is
	 *     selected.
	 * @param {expression=} md-search-text-change An expression to be run each time the search text
	 *     updates.
	 * @param {expression=} md-search-text A model to bind the search query text to.
	 * @param {object=} md-selected-item A model to bind the selected item to.
	 * @param {expression=} md-item-text An expression that will convert your object to a single string.
	 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	 * @param {boolean=} md-no-cache Disables the internal caching that happens in autocomplete.
	 * @param {boolean=} ng-disabled Determines whether or not to disable the input field.
	 * @param {boolean=} md-require-match When set to true, the autocomplete will add a validator,
	 *     which will evaluate to false, when no item is currently selected.
	 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
	 *     make suggestions.
	 * @param {number=} md-delay Specifies the amount of time (in milliseconds) to wait before looking
	 *     for results.
	 * @param {boolean=} md-clear-button Whether the clear button for the autocomplete input should show up or not.
	 * @param {boolean=} md-autofocus If true, the autocomplete will be automatically focused when a `$mdDialog`,
	 *     `$mdBottomsheet` or `$mdSidenav`, which contains the autocomplete, is opening. <br/><br/>
	 *     Also the autocomplete will immediately focus the input element.
	 * @param {boolean=} md-no-asterisk When present, asterisk will not be appended to the floating label.
	 * @param {boolean=} md-autoselect If set to true, the first item will be automatically selected
	 *     in the dropdown upon open.
	 * @param {string=} md-input-name The name attribute given to the input element to be used with
	 *     FormController.
	 * @param {string=} md-menu-class This class will be applied to the dropdown menu for styling.
	 * @param {string=} md-menu-container-class This class will be applied to the parent container
	 *     of the dropdown panel.
	 * @param {string=} md-input-class This will be applied to the input for styling. This attribute
	 *     is only valid when a `md-floating-label` is defined.
	 * @param {string=} md-floating-label This will add a floating label to autocomplete and wrap it in
	 *     `md-input-container`
	 * @param {string=} md-select-on-focus When present the inputs text will be automatically selected
	 *     on focus.
	 * @param {string=} md-input-id An ID to be added to the input element.
	 * @param {number=} md-input-minlength The minimum length for the input's value for validation.
	 * @param {number=} md-input-maxlength The maximum length for the input's value for validation.
	 * @param {boolean=} md-select-on-match When set, autocomplete will automatically select
	 *     the item if the search text is an exact match. <br/><br/>
	 *     An exact match is when only one match is displayed.
	 * @param {boolean=} md-match-case-insensitive When set and using `md-select-on-match`, autocomplete
	 *     will select on case-insensitive match.
	 * @param {string=} md-escape-options Override escape key logic. Default is `blur clear`.<br/>
	 *     Options: `blur`, `clear`, `none`.
	 * @param {string=} md-dropdown-items Specifies the maximum amount of items to be shown in
	 *     the dropdown.<br/><br/>
	 *     When the dropdown doesn't fit into the viewport, the dropdown will shrink
	 *     as much as possible.
	 * @param {string=} md-dropdown-position Overrides the default dropdown position. Options: `top`, `bottom`.
	 * @param {boolean=} ng-trim If set to false, the search text will be not trimmed automatically.
	 *     Defaults to true.
	 * @param {string=} ng-pattern Adds the pattern validator to the ngModel of the search text.
	 *     See the [ngPattern Directive](https://docs.angularjs.org/api/ng/directive/ngPattern)
	 *     for more details.
	 *
	 * @usage
	 * ### Basic Example
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 * ### Example with "not found" message
	 * <hljs lang="html">
	 * <md-autocomplete
	 *     md-selected-item="selectedItem"
	 *     md-search-text="searchText"
	 *     md-items="item in getMatches(searchText)"
	 *     md-item-text="item.display">
	 *   <md-item-template>
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-item-template>
	 *   <md-not-found>
	 *     No matches found.
	 *   </md-not-found>
	 * </md-autocomplete>
	 * </hljs>
	 *
	 * In this example, our code utilizes `md-item-template` and `md-not-found` to specify the
	 *     different parts that make up our component.
	 *
	 * ### Clear button for the input
	 * By default, the clear button is displayed when there is input. This aligns with the spec's
	 * [Search Pattern](https://material.io/guidelines/patterns/search.html#search-in-app-search).
	 * In floating label mode, when `md-floating-label="My Label"` is applied, the clear button is not displayed
	 * by default (see the spec's
	 * [Autocomplete Text Field](https://material.io/guidelines/components/text-fields.html#text-fields-layout)).
	 *
	 * Nevertheless, developers are able to explicitly toggle the clear button for all autocomplete components
	 * with `md-clear-button`.
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete ... md-clear-button="true"></md-autocomplete>
	 *   <md-autocomplete ... md-clear-button="false"></md-autocomplete>
	 * </hljs>
	 *
	 * In previous versions, the clear button was always hidden when the component was disabled.
	 * This changed in `1.1.5` to give the developer control of this behavior. This example
	 * will hide the clear button only when the component is disabled.
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete ... ng-disabled="disabled" md-clear-button="!disabled"></md-autocomplete>
	 * </hljs>
	 *
	 * ### Example with validation
	 * <hljs lang="html">
	 * <form name="autocompleteForm">
	 *   <md-autocomplete
	 *       required
	 *       md-input-name="autocomplete"
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <md-item-template>
	 *       <span md-highlight-text="searchText">{{item.display}}</span>
	 *     </md-item-template>
	 *     <div ng-messages="autocompleteForm.autocomplete.$error">
	 *       <div ng-message="required">This field is required</div>
	 *     </div>
	 *   </md-autocomplete>
	 * </form>
	 * </hljs>
	 *
	 * In this example, our code utilizes `md-item-template` and `ng-messages` to specify
	 *     input validation for the field.
	 *
	 * ### Asynchronous Results
	 * The autocomplete items expression also supports promises, which will resolve with the query results.
	 *
	 * <hljs lang="js">
	 *   function AppController($scope, $http) {
	 *     $scope.query = function(searchText) {
	 *       return $http
	 *         .get(BACKEND_URL + '/items/' + searchText)
	 *         .then(function(data) {
	 *           // Map the response object to the data object.
	 *           return data;
	 *         });
	 *     };
	 *   }
	 * </hljs>
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in query(searchText)">
	 *     <md-item-template>
	 *       <span md-highlight-text="searchText">{{item}}</span>
	 *     </md-item-template>
	 * </md-autocomplete>
	 * </hljs>
	 *
	 */
	function MdAutocomplete ($$mdSvgRegistry) {
	
	  return {
	    controller:   'MdAutocompleteCtrl',
	    controllerAs: '$mdAutocompleteCtrl',
	    scope:        {
	      inputName:          '@mdInputName',
	      inputMinlength:     '@mdInputMinlength',
	      inputMaxlength:     '@mdInputMaxlength',
	      searchText:         '=?mdSearchText',
	      selectedItem:       '=?mdSelectedItem',
	      itemsExpr:          '@mdItems',
	      itemText:           '&mdItemText',
	      placeholder:        '@placeholder',
	      noCache:            '=?mdNoCache',
	      requireMatch:       '=?mdRequireMatch',
	      selectOnMatch:      '=?mdSelectOnMatch',
	      matchInsensitive:   '=?mdMatchCaseInsensitive',
	      itemChange:         '&?mdSelectedItemChange',
	      textChange:         '&?mdSearchTextChange',
	      minLength:          '=?mdMinLength',
	      delay:              '=?mdDelay',
	      autofocus:          '=?mdAutofocus',
	      floatingLabel:      '@?mdFloatingLabel',
	      autoselect:         '=?mdAutoselect',
	      menuClass:          '@?mdMenuClass',
	      menuContainerClass: '@?mdMenuContainerClass',
	      inputClass:         '@?mdInputClass',
	      inputId:            '@?mdInputId',
	      escapeOptions:      '@?mdEscapeOptions',
	      dropdownItems:      '=?mdDropdownItems',
	      dropdownPosition:   '@?mdDropdownPosition',
	      clearButton:        '=?mdClearButton'
	    },
	    compile: function(tElement, tAttrs) {
	      var attributes = ['md-select-on-focus', 'md-no-asterisk', 'ng-trim', 'ng-pattern'];
	      var input = tElement.find('input');
	
	      attributes.forEach(function(attribute) {
	        var attrValue = tAttrs[tAttrs.$normalize(attribute)];
	
	        if (attrValue !== null) {
	          input.attr(attribute, attrValue);
	        }
	      });
	
	      return function(scope, element, attrs, ctrl) {
	        // Retrieve the state of using a md-not-found template by using our attribute, which will
	        // be added to the element in the template function.
	        ctrl.hasNotFound = !!element.attr('md-has-not-found');
	
	        // By default the inset autocomplete should show the clear button when not explicitly overwritten
	        // or in floating label mode.
	        if (!angular.isDefined(attrs.mdClearButton) && !scope.floatingLabel) {
	          scope.clearButton = true;
	        }
	      };
	    },
	    template:     function (element, attr) {
	      var noItemsTemplate = getNoItemsTemplate(),
	          itemTemplate    = getItemTemplate(),
	          leftover        = element.html(),
	          tabindex        = attr.tabindex;
	      var menuContainerClass = attr.mdMenuContainerClass ? ' ' + attr.mdMenuContainerClass : '';
	
	      // Set our attribute for the link function above which runs later.
	      // We will set an attribute, because otherwise the stored variables will be trashed when
	      // removing the element is hidden while retrieving the template. For example when using ngIf.
	      if (noItemsTemplate) element.attr('md-has-not-found', true);
	
	      // Always set our tabindex of the autocomplete directive to -1, because our input
	      // will hold the actual tabindex.
	      element.attr('tabindex', '-1');
	
	      return '\
	        <md-autocomplete-wrap\
	            ng-class="{ \'md-whiteframe-z1\': !floatingLabel, \
	                        \'md-menu-showing\': !$mdAutocompleteCtrl.hidden, \
	                        \'md-show-clear-button\': !!clearButton }">\
	          ' + getInputElement() + '\
	          ' + getClearButton() + '\
	          <md-progress-linear\
	              class="' + (attr.mdFloatingLabel ? 'md-inline' : '') + '"\
	              ng-if="$mdAutocompleteCtrl.loadingIsVisible()"\
	              md-mode="indeterminate"></md-progress-linear>\
	          <md-virtual-repeat-container\
	              md-auto-shrink\
	              md-auto-shrink-min="1"\
	              ng-mouseenter="$mdAutocompleteCtrl.listEnter()"\
	              ng-mouseleave="$mdAutocompleteCtrl.listLeave()"\
	              ng-mouseup="$mdAutocompleteCtrl.mouseUp()"\
	              ng-hide="$mdAutocompleteCtrl.hidden"\
	              class="md-autocomplete-suggestions-container md-whiteframe-z1' + menuContainerClass + '"\
	              ng-class="{ \'md-not-found\': $mdAutocompleteCtrl.notFoundVisible() }"\
	              role="presentation">\
	            <ul class="md-autocomplete-suggestions"\
	                ng-class="::menuClass"\
	                id="ul-{{$mdAutocompleteCtrl.id}}">\
	              <li md-virtual-repeat="item in $mdAutocompleteCtrl.matches"\
	                  ng-class="{ selected: $index === $mdAutocompleteCtrl.index }"\
	                  ng-click="$mdAutocompleteCtrl.select($index)"\
	                  md-extra-name="$mdAutocompleteCtrl.itemName">\
	                  ' + itemTemplate + '\
	                  </li>' + noItemsTemplate + '\
	            </ul>\
	          </md-virtual-repeat-container>\
	        </md-autocomplete-wrap>';
	
	      function getItemTemplate() {
	        var templateTag = element.find('md-item-template').detach(),
	            html = templateTag.length ? templateTag.html() : element.html();
	        if (!templateTag.length) element.empty();
	        return '<md-autocomplete-parent-scope md-autocomplete-replace>' + html + '</md-autocomplete-parent-scope>';
	      }
	
	      function getNoItemsTemplate() {
	        var templateTag = element.find('md-not-found').detach(),
	            template = templateTag.length ? templateTag.html() : '';
	        return template
	            ? '<li ng-if="$mdAutocompleteCtrl.notFoundVisible()"\
	                         md-autocomplete-parent-scope>' + template + '</li>'
	            : '';
	
	      }
	
	      function getInputElement () {
	        if (attr.mdFloatingLabel) {
	          return '\
	            <md-input-container ng-if="floatingLabel">\
	              <label>{{floatingLabel}}</label>\
	              <input type="search"\
	                  ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
	                  id="{{ inputId || \'fl-input-\' + $mdAutocompleteCtrl.id }}"\
	                  name="{{inputName}}"\
	                  ng-class="::inputClass"\
	                  autocomplete="off"\
	                  ng-required="$mdAutocompleteCtrl.isRequired"\
	                  ng-readonly="$mdAutocompleteCtrl.isReadonly"\
	                  ng-minlength="inputMinlength"\
	                  ng-maxlength="inputMaxlength"\
	                  ng-disabled="$mdAutocompleteCtrl.isDisabled"\
	                  ng-model="$mdAutocompleteCtrl.scope.searchText"\
	                  ng-model-options="{ allowInvalid: true }"\
	                  ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
	                  ng-blur="$mdAutocompleteCtrl.blur($event)"\
	                  ng-focus="$mdAutocompleteCtrl.focus($event)"\
	                  aria-owns="ul-{{$mdAutocompleteCtrl.id}}"\
	                  aria-label="{{floatingLabel}}"\
	                  aria-autocomplete="list"\
	                  role="combobox"\
	                  aria-haspopup="true"\
	                  aria-activedescendant=""\
	                  aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"/>\
	              <div md-autocomplete-parent-scope md-autocomplete-replace>' + leftover + '</div>\
	            </md-input-container>';
	        } else {
	          return '\
	            <input type="search"\
	                ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
	                id="{{ inputId || \'input-\' + $mdAutocompleteCtrl.id }}"\
	                name="{{inputName}}"\
	                ng-class="::inputClass"\
	                ng-if="!floatingLabel"\
	                autocomplete="off"\
	                ng-required="$mdAutocompleteCtrl.isRequired"\
	                ng-disabled="$mdAutocompleteCtrl.isDisabled"\
	                ng-readonly="$mdAutocompleteCtrl.isReadonly"\
	                ng-minlength="inputMinlength"\
	                ng-maxlength="inputMaxlength"\
	                ng-model="$mdAutocompleteCtrl.scope.searchText"\
	                ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
	                ng-blur="$mdAutocompleteCtrl.blur($event)"\
	                ng-focus="$mdAutocompleteCtrl.focus($event)"\
	                placeholder="{{placeholder}}"\
	                aria-owns="ul-{{$mdAutocompleteCtrl.id}}"\
	                aria-label="{{placeholder}}"\
	                aria-autocomplete="list"\
	                role="combobox"\
	                aria-haspopup="true"\
	                aria-activedescendant=""\
	                aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"/>';
	        }
	      }
	
	      function getClearButton() {
	        return '' +
	          '<button ' +
	              'type="button" ' +
	              'aria-label="Clear Input" ' +
	              'tabindex="-1" ' +
	              'ng-if="clearButton && $mdAutocompleteCtrl.scope.searchText" ' +
	              'ng-click="$mdAutocompleteCtrl.clear($event)">' +
	            '<md-icon md-svg-src="' + $$mdSvgRegistry.mdClose + '"></md-icon>' +
	          '</button>';
	        }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocompleteItemScopeDirective.$inject = ["$compile", "$mdUtil"];angular
	  .module('material.components.autocomplete')
	  .directive('mdAutocompleteParentScope', MdAutocompleteItemScopeDirective);
	
	function MdAutocompleteItemScopeDirective($compile, $mdUtil) {
	  return {
	    restrict: 'AE',
	    compile: compile,
	    terminal: true,
	    transclude: 'element'
	  };
	
	  function compile(tElement, tAttr, transclude) {
	    return function postLink(scope, element, attr) {
	      var ctrl = scope.$mdAutocompleteCtrl;
	      var newScope = ctrl.parent.$new();
	      var itemName = ctrl.itemName;
	
	      // Watch for changes to our scope's variables and copy them to the new scope
	      watchVariable('$index', '$index');
	      watchVariable('item', itemName);
	
	      // Ensure that $digest calls on our scope trigger $digest on newScope.
	      connectScopes();
	
	      // Link the element against newScope.
	      transclude(newScope, function(clone) {
	        element.after(clone);
	      });
	
	      /**
	       * Creates a watcher for variables that are copied from the parent scope
	       * @param variable
	       * @param alias
	       */
	      function watchVariable(variable, alias) {
	        newScope[alias] = scope[variable];
	
	        scope.$watch(variable, function(value) {
	          $mdUtil.nextTick(function() {
	            newScope[alias] = value;
	          });
	        });
	      }
	
	      /**
	       * Creates watchers on scope and newScope that ensure that for any
	       * $digest of scope, newScope is also $digested.
	       */
	      function connectScopes() {
	        var scopeDigesting = false;
	        var newScopeDigesting = false;
	
	        scope.$watch(function() {
	          if (newScopeDigesting || scopeDigesting) {
	            return;
	          }
	
	          scopeDigesting = true;
	          scope.$$postDigest(function() {
	            if (!newScopeDigesting) {
	              newScope.$digest();
	            }
	
	            scopeDigesting = newScopeDigesting = false;
	          });
	        });
	
	        newScope.$watch(function() {
	          newScopeDigesting = true;
	        });
	      }
	    };
	  }
	}
	})();
	(function(){
	"use strict";
	
	
	MdHighlightCtrl.$inject = ["$scope", "$element", "$attrs"];angular
	    .module('material.components.autocomplete')
	    .controller('MdHighlightCtrl', MdHighlightCtrl);
	
	function MdHighlightCtrl ($scope, $element, $attrs) {
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	
	  // Cache the Regex to avoid rebuilding each time.
	  this.regex = null;
	}
	
	MdHighlightCtrl.prototype.init = function(unsafeTermFn, unsafeContentFn) {
	
	  this.flags = this.$attrs.mdHighlightFlags || '';
	
	  this.unregisterFn = this.$scope.$watch(function($scope) {
	    return {
	      term: unsafeTermFn($scope),
	      contentText: unsafeContentFn($scope)
	    };
	  }.bind(this), this.onRender.bind(this), true);
	
	  this.$element.on('$destroy', this.unregisterFn);
	};
	
	/**
	 * Triggered once a new change has been recognized and the highlighted
	 * text needs to be updated.
	 */
	MdHighlightCtrl.prototype.onRender = function(state, prevState) {
	
	  var contentText = state.contentText;
	
	  /* Update the regex if it's outdated, because we don't want to rebuilt it constantly. */
	  if (this.regex === null || state.term !== prevState.term) {
	    this.regex = this.createRegex(state.term, this.flags);
	  }
	
	  /* If a term is available apply the regex to the content */
	  if (state.term) {
	    this.applyRegex(contentText);
	  } else {
	    this.$element.text(contentText);
	  }
	
	};
	
	/**
	 * Decomposes the specified text into different tokens (whether match or not).
	 * Breaking down the string guarantees proper XSS protection due to the native browser
	 * escaping of unsafe text.
	 */
	MdHighlightCtrl.prototype.applyRegex = function(text) {
	  var tokens = this.resolveTokens(text);
	
	  this.$element.empty();
	
	  tokens.forEach(function (token) {
	
	    if (token.isMatch) {
	      var tokenEl = angular.element('<span class="highlight">').text(token.text);
	
	      this.$element.append(tokenEl);
	    } else {
	      this.$element.append(document.createTextNode(token));
	    }
	
	  }.bind(this));
	
	};
	
	  /**
	 * Decomposes the specified text into different tokens by running the regex against the text.
	 */
	MdHighlightCtrl.prototype.resolveTokens = function(string) {
	  var tokens = [];
	  var lastIndex = 0;
	
	  // Use replace here, because it supports global and single regular expressions at same time.
	  string.replace(this.regex, function(match, index) {
	    appendToken(lastIndex, index);
	
	    tokens.push({
	      text: match,
	      isMatch: true
	    });
	
	    lastIndex = index + match.length;
	  });
	
	  // Append the missing text as a token.
	  appendToken(lastIndex);
	
	  return tokens;
	
	  function appendToken(from, to) {
	    var targetText = string.slice(from, to);
	    targetText && tokens.push(targetText);
	  }
	};
	
	/** Creates a regex for the specified text with the given flags. */
	MdHighlightCtrl.prototype.createRegex = function(term, flags) {
	  var startFlag = '', endFlag = '';
	  var regexTerm = this.sanitizeRegex(term);
	
	  if (flags.indexOf('^') >= 0) startFlag = '^';
	  if (flags.indexOf('$') >= 0) endFlag = '$';
	
	  return new RegExp(startFlag + regexTerm + endFlag, flags.replace(/[$^]/g, ''));
	};
	
	/** Sanitizes a regex by removing all common RegExp identifiers */
	MdHighlightCtrl.prototype.sanitizeRegex = function(term) {
	  return term && term.toString().replace(/[\\^$*+?.()|{}[\]]/g, '\\$&');
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdHighlight.$inject = ["$interpolate", "$parse"];angular
	    .module('material.components.autocomplete')
	    .directive('mdHighlightText', MdHighlight);
	
	/**
	 * @ngdoc directive
	 * @name mdHighlightText
	 * @module material.components.autocomplete
	 *
	 * @description
	 * The `md-highlight-text` directive allows you to specify text that should be highlighted within
	 *     an element.  Highlighted text will be wrapped in `<span class="highlight"></span>` which can
	 *     be styled through CSS.  Please note that child elements may not be used with this directive.
	 *
	 * @param {string} md-highlight-text A model to be searched for
	 * @param {string=} md-highlight-flags A list of flags (loosely based on JavaScript RexExp flags).
	 * #### **Supported flags**:
	 * - `g`: Find all matches within the provided text
	 * - `i`: Ignore case when searching for matches
	 * - `$`: Only match if the text ends with the search term
	 * - `^`: Only match if the text begins with the search term
	 *
	 * @usage
	 * <hljs lang="html">
	 * <input placeholder="Enter a search term..." ng-model="searchTerm" type="text" />
	 * <ul>
	 *   <li ng-repeat="result in results" md-highlight-text="searchTerm">
	 *     {{result.text}}
	 *   </li>
	 * </ul>
	 * </hljs>
	 */
	
	function MdHighlight ($interpolate, $parse) {
	  return {
	    terminal: true,
	    controller: 'MdHighlightCtrl',
	    compile: function mdHighlightCompile(tElement, tAttr) {
	      var termExpr = $parse(tAttr.mdHighlightText);
	      var unsafeContentExpr = $interpolate(tElement.html());
	
	      return function mdHighlightLink(scope, element, attr, ctrl) {
	        ctrl.init(termExpr, unsafeContentExpr);
	      };
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipCtrl.$inject = ["$scope", "$element", "$mdConstant", "$timeout", "$mdUtil"];angular
	  .module('material.components.chips')
	  .controller('MdChipCtrl', MdChipCtrl);
	
	/**
	 * Controller for the MdChip component. Responsible for handling keyboard
	 * events and editing the chip if needed.
	 *
	 * @param $scope
	 * @param $element
	 * @param $mdConstant
	 * @param $timeout
	 * @param $mdUtil
	 * @constructor
	 */
	function MdChipCtrl ($scope, $element, $mdConstant, $timeout, $mdUtil) {
	  /**
	   * @type {$scope}
	   */
	  this.$scope = $scope;
	
	  /**
	   * @type {$element}
	   */
	  this.$element = $element;
	
	  /**
	   * @type {$mdConstant}
	   */
	  this.$mdConstant = $mdConstant;
	
	  /**
	   * @type {$timeout}
	   */
	  this.$timeout = $timeout;
	
	  /**
	   * @type {$mdUtil}
	   */
	  this.$mdUtil = $mdUtil;
	
	  /**
	   * @type {boolean}
	   */
	  this.isEditing = false;
	
	  /**
	   * @type {MdChipsCtrl}
	   */
	  this.parentController = undefined;
	
	  /**
	   * @type {boolean}
	   */
	  this.enableChipEdit = false;
	}
	
	
	/**
	 * @param {MdChipsCtrl} controller
	 */
	MdChipCtrl.prototype.init = function(controller) {
	  this.parentController = controller;
	  this.enableChipEdit = this.parentController.enableChipEdit;
	
	  if (this.enableChipEdit) {
	    this.$element.on('keydown', this.chipKeyDown.bind(this));
	    this.$element.on('dblclick', this.chipMouseDoubleClick.bind(this));
	    this.getChipContent().addClass('_md-chip-content-edit-is-enabled');
	  }
	};
	
	
	/**
	 * @return {Object} first element with the md-chip-content class
	 */
	MdChipCtrl.prototype.getChipContent = function() {
	  var chipContents = this.$element[0].getElementsByClassName('md-chip-content');
	  return angular.element(chipContents[0]);
	};
	
	
	/**
	 * @return {Object} first content element of the chips content element
	 */
	MdChipCtrl.prototype.getContentElement = function() {
	  return angular.element(this.getChipContent().contents()[0]);
	};
	
	
	/**
	 * @return {number} index of this chip
	 */
	MdChipCtrl.prototype.getChipIndex = function() {
	  return parseInt(this.$element.attr('index'));
	};
	
	
	/**
	 * Update the chip's contents, focus the chip if it's selected, and exit edit mode.
	 * If the contents were updated to be empty, remove the chip and re-focus the input element.
	 */
	MdChipCtrl.prototype.goOutOfEditMode = function() {
	  if (!this.isEditing) return;
	
	  this.isEditing = false;
	  this.$element.removeClass('_md-chip-editing');
	  this.getChipContent()[0].contentEditable = 'false';
	  var chipIndex = this.getChipIndex();
	
	  var content = this.getContentElement().text();
	  if (content) {
	    this.parentController.updateChipContents(
	        chipIndex,
	        this.getContentElement().text()
	    );
	
	    this.$mdUtil.nextTick(function() {
	      if (this.parentController.selectedChip === chipIndex) {
	        this.parentController.focusChip(chipIndex);
	      }
	    }.bind(this));
	  } else {
	    this.parentController.removeChipAndFocusInput(chipIndex);
	  }
	};
	
	
	/**
	 * Given an HTML element. Selects contents of it.
	 * @param {Element} node
	 */
	MdChipCtrl.prototype.selectNodeContents = function(node) {
	  var range, selection;
	  if (document.body.createTextRange) {
	    range = document.body.createTextRange();
	    range.moveToElementText(node);
	    range.select();
	  } else if (window.getSelection) {
	    selection = window.getSelection();
	    range = document.createRange();
	    range.selectNodeContents(node);
	    selection.removeAllRanges();
	    selection.addRange(range);
	  }
	};
	
	
	/**
	 * Presents an input element to edit the contents of the chip.
	 */
	MdChipCtrl.prototype.goInEditMode = function() {
	  this.isEditing = true;
	  this.$element.addClass('_md-chip-editing');
	  this.getChipContent()[0].contentEditable = 'true';
	  this.getChipContent().on('blur', function() {
	    this.goOutOfEditMode();
	  }.bind(this));
	
	  this.selectNodeContents(this.getChipContent()[0]);
	};
	
	
	/**
	 * Handles the keydown event on the chip element. If enable-chip-edit attribute is
	 * set to true, space or enter keys can trigger going into edit mode. Enter can also
	 * trigger submitting if the chip is already being edited.
	 * @param {KeyboardEvent} event
	 */
	MdChipCtrl.prototype.chipKeyDown = function(event) {
	  if (!this.isEditing &&
	    (event.keyCode === this.$mdConstant.KEY_CODE.ENTER ||
	    event.keyCode === this.$mdConstant.KEY_CODE.SPACE)) {
	    event.preventDefault();
	    this.goInEditMode();
	  } else if (this.isEditing &&
	    event.keyCode === this.$mdConstant.KEY_CODE.ENTER) {
	    event.preventDefault();
	    this.goOutOfEditMode();
	  }
	};
	
	
	/**
	 * Enter edit mode if we're not already editing and the enable-chip-edit attribute is enabled.
	 */
	MdChipCtrl.prototype.chipMouseDoubleClick = function() {
	  if (this.enableChipEdit && !this.isEditing) {
	    this.goInEditMode();
	  }
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdChip.$inject = ["$mdTheming", "$mdUtil", "$compile", "$timeout"];angular
	  .module('material.components.chips')
	  .directive('mdChip', MdChip);
	
	/**
	 * @ngdoc directive
	 * @name mdChip
	 * @module material.components.chips
	 *
	 * @description
	 * `<md-chip>` is a component used within `<md-chips>`. It is responsible for rendering an
	 * individual chip.
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-chips>
	 *     <md-chip>{{$chip}}</md-chip>
	 *   </md-chips>
	 * </hljs>
	 *
	 */
	
	// This hint text is visually hidden within a chip but used by screen readers to
	// inform the user how they can interact with a chip.
	var DELETE_HINT_TEMPLATE = '\
	    <span ng-if="!$mdChipsCtrl.readonly" class="md-visually-hidden">\
	      {{$mdChipsCtrl.deleteHint}}\
	    </span>';
	
	/**
	 * MDChip Directive Definition
	 *
	 * @param $mdTheming
	 * @param $mdUtil
	 * @param $compile
	 * @param $timeout
	 * @ngInject
	 */
	function MdChip($mdTheming, $mdUtil, $compile, $timeout) {
	  var deleteHintTemplate = $mdUtil.processTemplate(DELETE_HINT_TEMPLATE);
	
	  return {
	    restrict: 'E',
	    require: ['^?mdChips', 'mdChip'],
	    link: postLink,
	    controller: 'MdChipCtrl'
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	    var chipsController = ctrls.shift();
	    var chipController = ctrls.shift();
	    var chipContentElement = angular.element(element[0].querySelector('.md-chip-content'));
	
	    $mdTheming(element);
	
	    if (chipsController) {
	      chipController.init(chipsController);
	
	      // Append our delete hint to the div.md-chip-content (which does not exist at compile time)
	      chipContentElement.append($compile(deleteHintTemplate)(scope));
	
	      // When a chip is blurred, make sure to unset (or reset) the selected chip so that tabbing
	      // through elements works properly
	      chipContentElement.on('blur', function() {
	        chipsController.resetSelectedChip();
	        chipsController.$scope.$applyAsync();
	      });
	    }
	
	    // Use $timeout to ensure we run AFTER the element has been added to the DOM so we can focus it.
	    $timeout(function() {
	      if (!chipsController) {
	        return;
	      }
	
	      if (chipsController.shouldFocusLastChip) {
	        chipsController.focusLastChipThenInput();
	      }
	    });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipRemove.$inject = ["$timeout"];angular
	    .module('material.components.chips')
	    .directive('mdChipRemove', MdChipRemove);
	
	/**
	 * @ngdoc directive
	 * @name mdChipRemove
	 * @restrict A
	 * @module material.components.chips
	 *
	 * @description
	 * Designates an element to be used as the delete button for a chip. <br/>
	 * This element is passed as a child of the `md-chips` element.
	 *
	 * The designated button will be just appended to the chip and removes the given chip on click.<br/>
	 * By default the button is not being styled by the `md-chips` component.
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-chips>
	 *     <button md-chip-remove="">
	 *       <md-icon md-svg-icon="md-close"></md-icon>
	 *     </button>
	 *   </md-chips>
	 * </hljs>
	 */
	
	
	/**
	 * MdChipRemove Directive Definition.
	 * 
	 * @param $timeout
	 * @returns {{restrict: string, require: string[], link: Function, scope: boolean}}
	 * @constructor
	 */
	function MdChipRemove ($timeout) {
	  return {
	    restrict: 'A',
	    require: '^mdChips',
	    scope: false,
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrl) {
	    element.on('click', function(event) {
	      scope.$apply(function() {
	        ctrl.removeChip(scope.$$replacedScope.$index);
	      });
	    });
	
	    // Child elements aren't available until after a $timeout tick as they are hidden by an
	    // `ng-if`. see http://goo.gl/zIWfuw
	    $timeout(function() {
	      element.attr({ tabindex: -1, 'aria-hidden': true });
	      element.find('button').attr('tabindex', '-1');
	    });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipTransclude.$inject = ["$compile"];angular
	    .module('material.components.chips')
	    .directive('mdChipTransclude', MdChipTransclude);
	
	function MdChipTransclude ($compile) {
	  return {
	    restrict: 'EA',
	    terminal: true,
	    link: link,
	    scope: false
	  };
	  function link (scope, element, attr) {
	    var ctrl = scope.$parent.$mdChipsCtrl,
	        newScope = ctrl.parent.$new(false, ctrl.parent);
	    newScope.$$replacedScope = scope;
	    newScope.$chip = scope.$chip;
	    newScope.$index = scope.$index;
	    newScope.$mdChipsCtrl = ctrl;
	
	    var newHtml = ctrl.$scope.$eval(attr.mdChipTransclude);
	
	    element.html(newHtml);
	    $compile(element.contents())(newScope);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * The default chip append delay.
	 *
	 * @type {number}
	 */
	MdChipsCtrl.$inject = ["$scope", "$attrs", "$mdConstant", "$log", "$element", "$timeout", "$mdUtil", "$exceptionHandler"];
	var DEFAULT_CHIP_APPEND_DELAY = 300;
	
	angular
	    .module('material.components.chips')
	    .controller('MdChipsCtrl', MdChipsCtrl);
	
	/**
	 * Controller for the MdChips component. Responsible for adding to and
	 * removing from the list of chips, marking chips as selected, and binding to
	 * the models of various input components.
	 *
	 * @param $scope
	 * @param $attrs
	 * @param $mdConstant
	 * @param $log
	 * @param $element
	 * @param $timeout
	 * @param $mdUtil
	 * @param $exceptionHandler
	 * @constructor
	 */
	function MdChipsCtrl ($scope, $attrs, $mdConstant, $log, $element, $timeout, $mdUtil,
	                      $exceptionHandler) {
	  /** @type {$timeout} **/
	  this.$timeout = $timeout;
	
	  /** @type {Object} */
	  this.$mdConstant = $mdConstant;
	
	  /** @type {angular.$scope} */
	  this.$scope = $scope;
	
	  /** @type {angular.$scope} */
	  this.parent = $scope.$parent;
	
	  /** @type {$mdUtil} */
	  this.$mdUtil = $mdUtil;
	
	  /** @type {$log} */
	  this.$log = $log;
	
	  /** @type {$exceptionHandler} */
	  this.$exceptionHandler = $exceptionHandler;
	
	  /** @type {$element} */
	  this.$element = $element;
	
	  /** @type {$attrs} */
	  this.$attrs = $attrs;
	
	  /** @type {angular.NgModelController} */
	  this.ngModelCtrl = null;
	
	  /** @type {angular.NgModelController} */
	  this.userInputNgModelCtrl = null;
	
	  /** @type {MdAutocompleteCtrl} */
	  this.autocompleteCtrl = null;
	
	  /** @type {Element} */
	  this.userInputElement = null;
	
	  /** @type {Array.<Object>} */
	  this.items = [];
	
	  /** @type {number} */
	  this.selectedChip = -1;
	
	  /** @type {string} */
	  this.enableChipEdit = $mdUtil.parseAttributeBoolean($attrs.mdEnableChipEdit);
	
	  /** @type {string} */
	  this.addOnBlur = $mdUtil.parseAttributeBoolean($attrs.mdAddOnBlur);
	
	  /**
	   * The text to be used as the aria-label for the input.
	   * @type {string}
	   */
	  this.inputAriaLabel = 'Chips input.';
	
	  /**
	   * Hidden hint text to describe the chips container. Used to give context to screen readers when
	   * the chips are readonly and the input cannot be selected.
	   *
	   * @type {string}
	   */
	  this.containerHint = 'Chips container. Use arrow keys to select chips.';
	
	  /**
	   * Hidden hint text for how to delete a chip. Used to give context to screen readers.
	   * @type {string}
	   */
	  this.deleteHint = 'Press delete to remove this chip.';
	
	  /**
	   * Hidden label for the delete button. Used to give context to screen readers.
	   * @type {string}
	   */
	  this.deleteButtonLabel = 'Remove';
	
	  /**
	   * Model used by the input element.
	   * @type {string}
	   */
	  this.chipBuffer = '';
	
	  /**
	   * Whether to use the transformChip expression to transform the chip buffer
	   * before appending it to the list.
	   * @type {boolean}
	   */
	  this.useTransformChip = false;
	
	  /**
	   * Whether to use the onAdd expression to notify of chip additions.
	   * @type {boolean}
	   */
	  this.useOnAdd = false;
	
	  /**
	   * Whether to use the onRemove expression to notify of chip removals.
	   * @type {boolean}
	   */
	  this.useOnRemove = false;
	
	  /**
	   * The ID of the chips wrapper which is used to build unique IDs for the chips and the aria-owns
	   * attribute.
	   *
	   * Defaults to '_md-chips-wrapper-' plus a unique number.
	   *
	   * @type {string}
	   */
	  this.wrapperId = '';
	
	  /**
	   * Array of unique numbers which will be auto-generated any time the items change, and is used to
	   * create unique IDs for the aria-owns attribute.
	   *
	   * @type {Array<number>}
	   */
	  this.contentIds = [];
	
	  /**
	   * The index of the chip that should have it's `tabindex` property set to `0` so it is selectable
	   * via the keyboard.
	   *
	   * @type {number}
	   */
	  this.ariaTabIndex = null;
	
	  /**
	   * After appending a chip, the chip will be focused for this number of milliseconds before the
	   * input is refocused.
	   *
	   * **Note:** This is **required** for compatibility with certain screen readers in order for
	   * them to properly allow keyboard access.
	   *
	   * @type {number}
	   */
	  this.chipAppendDelay = DEFAULT_CHIP_APPEND_DELAY;
	
	  /**
	   * Collection of functions to call to un-register watchers
	   *
	   * @type {Array}
	   */
	  this.deRegister = [];
	
	  this.init();
	}
	
	/**
	 * Initializes variables and sets up watchers
	 */
	MdChipsCtrl.prototype.init = function() {
	  var ctrl = this;
	
	  // Set the wrapper ID
	  this.wrapperId = '_md-chips-wrapper-' + this.$mdUtil.nextUid();
	
	  // Setup a watcher which manages the role and aria-owns attributes
	  this.deRegister.push(
	    this.$scope.$watchCollection('$mdChipsCtrl.items', function() {
	      // Make sure our input and wrapper have the correct ARIA attributes
	      ctrl.setupInputAria();
	      ctrl.setupWrapperAria();
	    })
	  );
	
	  this.deRegister.push(
	    this.$attrs.$observe('mdChipAppendDelay', function(newValue) {
	      ctrl.chipAppendDelay = parseInt(newValue) || DEFAULT_CHIP_APPEND_DELAY;
	    })
	  );
	};
	
	/**
	 * Destructor for cleanup
	 */
	MdChipsCtrl.prototype.$onDestroy = function $onDestroy() {
	  var $destroyFn;
	  while (($destroyFn = this.deRegister.pop())) {
	    $destroyFn.call(this);
	  }
	};
	
	/**
	 * If we have an input, ensure it has the appropriate ARIA attributes.
	 */
	MdChipsCtrl.prototype.setupInputAria = function() {
	  var input = this.$element.find('input');
	
	  // If we have no input, just return
	  if (!input) {
	    return;
	  }
	
	  input.attr('role', 'textbox');
	  input.attr('aria-multiline', true);
	};
	
	/**
	 * Ensure our wrapper has the appropriate ARIA attributes.
	 */
	MdChipsCtrl.prototype.setupWrapperAria = function() {
	  var ctrl = this,
	      wrapper = this.$element.find('md-chips-wrap');
	
	  if (this.items && this.items.length) {
	    // Dynamically add the listbox role on every change because it must be removed when there are
	    // no items.
	    wrapper.attr('role', 'listbox');
	
	    // Generate some random (but unique) IDs for each chip
	    this.contentIds = this.items.map(function() {
	      return ctrl.wrapperId + '-chip-' + ctrl.$mdUtil.nextUid();
	    });
	
	    // Use the contentIDs above to generate the aria-owns attribute
	    wrapper.attr('aria-owns', this.contentIds.join(' '));
	  } else {
	    // If we have no items, then the role and aria-owns attributes MUST be removed
	    wrapper.removeAttr('role');
	    wrapper.removeAttr('aria-owns');
	  }
	};
	
	/**
	 * Handles the keydown event on the input element: by default <enter> appends
	 * the buffer to the chip list, while backspace removes the last chip in the
	 * list if the current buffer is empty.
	 * @param {jQuery.Event|KeyboardEvent} event
	 */
	MdChipsCtrl.prototype.inputKeydown = function(event) {
	  var chipBuffer = this.getChipBuffer();
	
	  // If we have an autocomplete, and it handled the event, we have nothing to do
	  if (this.autocompleteCtrl && event.isDefaultPrevented && event.isDefaultPrevented()) {
	    return;
	  }
	
	  if (event.keyCode === this.$mdConstant.KEY_CODE.BACKSPACE) {
	    // Only select and focus the previous chip, if the current caret position of the
	    // input element is at the beginning.
	    if (this.getCursorPosition(event.target) !== 0) {
	      return;
	    }
	
	    event.preventDefault();
	    event.stopPropagation();
	
	    if (this.items.length) {
	      this.selectAndFocusChipSafe(this.items.length - 1);
	    }
	
	    return;
	  }
	
	  // By default <enter> appends the buffer to the chip list.
	  if (!this.separatorKeys || this.separatorKeys.length < 1) {
	    this.separatorKeys = [this.$mdConstant.KEY_CODE.ENTER];
	  }
	
	  // Support additional separator key codes in an array of `md-separator-keys`.
	  if (this.separatorKeys.indexOf(event.keyCode) !== -1) {
	    if ((this.autocompleteCtrl && this.requireMatch) || !chipBuffer) return;
	    event.preventDefault();
	
	    // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
	    if (this.hasMaxChipsReached()) return;
	
	    this.appendChip(chipBuffer.trim());
	    this.resetChipBuffer();
	
	    return false;
	  }
	};
	
	/**
	 * Returns the cursor position of the specified input element.
	 * @param {HTMLInputElement} element relevant input element
	 * @returns {Number} Cursor Position of the input.
	 */
	MdChipsCtrl.prototype.getCursorPosition = function(element) {
	  /*
	   * Figure out whether the current input for the chips buffer is valid for using
	   * the selectionStart / end property to retrieve the cursor position.
	   * Some browsers do not allow the use of those attributes, on different input types.
	   */
	  try {
	    if (element.selectionStart === element.selectionEnd) {
	      return element.selectionStart;
	    }
	  } catch (e) {
	    if (!element.value) {
	      return 0;
	    }
	  }
	};
	
	
	/**
	 * Updates the content of the chip at given index
	 * @param {number} chipIndex
	 * @param {string} chipContents
	 */
	MdChipsCtrl.prototype.updateChipContents = function(chipIndex, chipContents) {
	  if (chipIndex >= 0 && chipIndex < this.items.length) {
	    this.items[chipIndex] = chipContents;
	    this.updateNgModel(true);
	  }
	};
	
	
	/**
	 * @return {boolean} true if a chip is currently being edited. False otherwise.
	 */
	MdChipsCtrl.prototype.isEditingChip = function() {
	  return !!this.$element[0].querySelector('._md-chip-editing');
	};
	
	
	MdChipsCtrl.prototype.isRemovable = function() {
	  // Return false if we have static chips
	  if (!this.ngModelCtrl) {
	    return false;
	  }
	
	  return this.readonly ? this.removable :
	         angular.isDefined(this.removable) ? this.removable : true;
	};
	
	/**
	 * Handles the keydown event on the chip elements: backspace removes the selected chip, arrow
	 * keys switch which chip is active.
	 * @param {KeyboardEvent} event
	 */
	MdChipsCtrl.prototype.chipKeydown = function (event) {
	  if (this.getChipBuffer()) return;
	  if (this.isEditingChip()) return;
	
	  switch (event.keyCode) {
	    case this.$mdConstant.KEY_CODE.BACKSPACE:
	    case this.$mdConstant.KEY_CODE.DELETE:
	      if (this.selectedChip < 0) return;
	      event.preventDefault();
	      // Cancel the delete action only after the event cancel. Otherwise the page will go back.
	      if (!this.isRemovable()) return;
	      this.removeAndSelectAdjacentChip(this.selectedChip, event);
	      break;
	    case this.$mdConstant.KEY_CODE.LEFT_ARROW:
	      event.preventDefault();
	      // By default, allow selection of -1 which will focus the input; if we're readonly, don't go
	      // below 0.
	      if (this.selectedChip < 0 || (this.readonly && this.selectedChip === 0)) {
	        this.selectedChip = this.items.length;
	      }
	      if (this.items.length) this.selectAndFocusChipSafe(this.selectedChip - 1);
	      break;
	    case this.$mdConstant.KEY_CODE.RIGHT_ARROW:
	      event.preventDefault();
	      this.selectAndFocusChipSafe(this.selectedChip + 1);
	      break;
	    case this.$mdConstant.KEY_CODE.ESCAPE:
	    case this.$mdConstant.KEY_CODE.TAB:
	      if (this.selectedChip < 0) return;
	      event.preventDefault();
	      this.onFocus();
	      break;
	  }
	};
	
	/**
	 * Get the input's placeholder - uses `placeholder` when list is empty and `secondary-placeholder`
	 * when the list is non-empty. If `secondary-placeholder` is not provided, `placeholder` is used
	 * always.
	 * @returns {string}
	 */
	MdChipsCtrl.prototype.getPlaceholder = function() {
	  // Allow `secondary-placeholder` to be blank.
	  var useSecondary = (this.items && this.items.length &&
	      (this.secondaryPlaceholder === '' || this.secondaryPlaceholder));
	  return useSecondary ? this.secondaryPlaceholder : this.placeholder;
	};
	
	/**
	 * Removes chip at {@code index} and selects the adjacent chip.
	 * @param {number} index adjacent chip to select
	 * @param {Event=} event
	 */
	MdChipsCtrl.prototype.removeAndSelectAdjacentChip = function(index, event) {
	  var self = this;
	  var selIndex = self.getAdjacentChipIndex(index);
	  var wrap = this.$element[0].querySelector('md-chips-wrap');
	  var chip = this.$element[0].querySelector('md-chip[index="' + index + '"]');
	
	  self.removeChip(index, event);
	
	  // The double-timeout is currently necessary to ensure that the DOM has finalized and the select()
	  // will find the proper chip since the selection is index-based.
	  //
	  // TODO: Investigate calling from within chip $scope.$on('$destroy') to reduce/remove timeouts
	  self.$timeout(function() {
	    self.$timeout(function() {
	      self.selectAndFocusChipSafe(selIndex);
	    });
	  });
	};
	
	/**
	 * Sets the selected chip index to -1.
	 */
	MdChipsCtrl.prototype.resetSelectedChip = function() {
	  this.selectedChip = -1;
	  this.ariaTabIndex = null;
	};
	
	/**
	 * Gets the index of an adjacent chip to select after deletion. Adjacency is
	 * determined as the next chip in the list, unless the target chip is the
	 * last in the list, then it is the chip immediately preceding the target. If
	 * there is only one item in the list, -1 is returned (select none).
	 * The number returned is the index to select AFTER the target has been removed.
	 * If the current chip is not selected, then -1 is returned to select none.
	 * @param {number} index
	 * @returns {number}
	 */
	MdChipsCtrl.prototype.getAdjacentChipIndex = function(index) {
	  var len = this.items.length - 1;
	  return (len === 0) ? -1 :
	      (index === len) ? index -1 : index;
	};
	
	/**
	 * Append the contents of the buffer to the chip list. This method will first
	 * call out to the md-transform-chip method, if provided.
	 * @param {string} newChip chip buffer contents that will be used to create the new chip
	 */
	MdChipsCtrl.prototype.appendChip = function(newChip) {
	  this.shouldFocusLastChip = !this.addOnBlur;
	  if (this.useTransformChip && this.transformChip) {
	    var transformedChip = this.transformChip({'$chip': newChip});
	
	    // Check to make sure the chip is defined before assigning it, otherwise, we'll just assume
	    // they want the string version.
	    if (angular.isDefined(transformedChip)) {
	      newChip = transformedChip;
	    }
	  }
	
	  // If items contains an identical object to newChip, do not append
	  if (angular.isObject(newChip)){
	    var identical = this.items.some(function(item){
	      return angular.equals(newChip, item);
	    });
	    if (identical) return;
	  }
	
	  // Check for a null (but not undefined), or existing chip and cancel appending
	  if (newChip == null || this.items.indexOf(newChip) + 1) return;
	
	  // Append the new chip onto our list
	  var length = this.items.push(newChip);
	  var index = length - 1;
	
	  this.updateNgModel();
	
	  // If the md-on-add attribute is specified, send a chip addition event
	  if (this.useOnAdd && this.onAdd) {
	    this.onAdd({ '$chip': newChip, '$index': index });
	  }
	};
	
	/**
	 * Sets whether to use the md-transform-chip expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code transformChip}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useTransformChipExpression = function() {
	  this.useTransformChip = true;
	};
	
	/**
	 * Sets whether to use the md-on-add expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onAdd}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnAddExpression = function() {
	  this.useOnAdd = true;
	};
	
	/**
	 * Sets whether to use the md-on-remove expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onRemove}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnRemoveExpression = function() {
	  this.useOnRemove = true;
	};
	
	/**
	 * Sets whether to use the md-on-select expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onSelect}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnSelectExpression = function() {
	  this.useOnSelect = true;
	};
	
	/**
	 * Gets the input buffer. The input buffer can be the model bound to the
	 * default input item {@code this.chipBuffer}, the {@code selectedItem}
	 * model of an {@code md-autocomplete}, or, through some magic, the model
	 * bound to any input or text area element found within a
	 * {@code md-input-container} element.
	 * @return {string} the input buffer
	 */
	MdChipsCtrl.prototype.getChipBuffer = function() {
	  var chipBuffer =  !this.userInputElement ? this.chipBuffer :
	                     this.userInputNgModelCtrl ? this.userInputNgModelCtrl.$viewValue :
	                     this.userInputElement[0].value;
	
	  // Ensure that the chip buffer is always a string. For example, the input element buffer
	  // might be falsy.
	  return angular.isString(chipBuffer) ? chipBuffer : '';
	};
	
	/**
	 * Resets the input buffer for either the internal input or user provided input element.
	 */
	MdChipsCtrl.prototype.resetChipBuffer = function() {
	  if (this.userInputElement) {
	    if (this.userInputNgModelCtrl) {
	      this.userInputNgModelCtrl.$setViewValue('');
	      this.userInputNgModelCtrl.$render();
	    } else {
	      this.userInputElement[0].value = '';
	    }
	  } else {
	    this.chipBuffer = '';
	  }
	};
	
	/**
	 * @returns {boolean} true if the max chips limit has been reached, false otherwise.
	 */
	MdChipsCtrl.prototype.hasMaxChipsReached = function() {
	  if (angular.isString(this.maxChips)) this.maxChips = parseInt(this.maxChips, 10) || 0;
	
	  return this.maxChips > 0 && this.items.length >= this.maxChips;
	};
	
	/**
	 * Updates the validity properties for the ngModel.
	 *
	 * TODO add the md-max-chips validator to this.ngModelCtrl.validators so that the validation will
	 * be performed automatically.
	 */
	MdChipsCtrl.prototype.validateModel = function() {
	  this.ngModelCtrl.$setValidity('md-max-chips', !this.hasMaxChipsReached());
	  this.ngModelCtrl.$validate(); // rerun any registered validators
	};
	
	/**
	 * Function to handle updating the model, validation, and change notification when a chip
	 * is added, removed, or changed.
	 * @param {boolean=} skipValidation true to skip calling validateModel()
	 */
	MdChipsCtrl.prototype.updateNgModel = function(skipValidation) {
	  if (!skipValidation) {
	    this.validateModel();
	  }
	  // This will trigger ng-change to fire, even in cases where $setViewValue() would not.
	  angular.forEach(this.ngModelCtrl.$viewChangeListeners, function(listener) {
	    try {
	      listener();
	    } catch (e) {
	      this.$exceptionHandler(e);
	    }
	  });
	};
	
	/**
	 * Removes the chip at the given index.
	 * @param {number} index of chip to remove
	 * @param {Event=} event optionally passed to the onRemove callback
	 */
	MdChipsCtrl.prototype.removeChip = function(index, event) {
	  var removed = this.items.splice(index, 1);
	
	  this.updateNgModel();
	
	  if (removed && removed.length && this.useOnRemove && this.onRemove) {
	    this.onRemove({ '$chip': removed[0], '$index': index, '$event': event });
	  }
	};
	
	/**
	 * @param {number} index location of chip to remove
	 * @param {Event=} $event
	 */
	MdChipsCtrl.prototype.removeChipAndFocusInput = function (index, $event) {
	  this.removeChip(index, $event);
	
	  if (this.autocompleteCtrl) {
	    // Always hide the autocomplete dropdown before focusing the autocomplete input.
	    // Wait for the input to move horizontally, because the chip was removed.
	    // This can lead to an incorrect dropdown position.
	    this.autocompleteCtrl.hidden = true;
	    this.$mdUtil.nextTick(this.onFocus.bind(this));
	  } else {
	    this.onFocus();
	  }
	
	};
	/**
	 * Selects the chip at `index`,
	 * @param {number} index location of chip to select and focus
	 */
	MdChipsCtrl.prototype.selectAndFocusChipSafe = function(index) {
	  // If we have no chips, or are asked to select a chip before the first, just focus the input
	  if (!this.items.length || index === -1) {
	    return this.focusInput();
	  }
	
	  // If we are asked to select a chip greater than the number of chips...
	  if (index >= this.items.length) {
	    if (this.readonly) {
	      // If we are readonly, jump back to the start (because we have no input)
	      index = 0;
	    } else {
	      // If we are not readonly, we should attempt to focus the input
	      return this.onFocus();
	    }
	  }
	
	  index = Math.max(index, 0);
	  index = Math.min(index, this.items.length - 1);
	
	  this.selectChip(index);
	  this.focusChip(index);
	};
	
	/**
	 * Focus last chip, then focus the input. This is needed for screen reader support.
	 */
	MdChipsCtrl.prototype.focusLastChipThenInput = function() {
	  var ctrl = this;
	
	  ctrl.shouldFocusLastChip = false;
	
	  ctrl.focusChip(this.items.length - 1);
	
	  ctrl.$timeout(function() {
	    ctrl.focusInput();
	  }, ctrl.chipAppendDelay);
	};
	
	/**
	 * Focus the input element.
	 */
	MdChipsCtrl.prototype.focusInput = function() {
	  this.selectChip(-1);
	  this.onFocus();
	};
	
	/**
	 * Marks the chip at the given index as selected.
	 * @param {number} index location of chip to select
	 */
	MdChipsCtrl.prototype.selectChip = function(index) {
	  if (index >= -1 && index <= this.items.length) {
	    this.selectedChip = index;
	
	    // Fire the onSelect if provided
	    if (this.useOnSelect && this.onSelect) {
	      this.onSelect({'$chip': this.items[index] });
	    }
	  } else {
	    this.$log.warn('Selected Chip index out of bounds; ignoring.');
	  }
	};
	
	/**
	 * Selects the chip at {@code index} and gives it focus.
	 * @param {number} index location of chip to select and focus
	 * @deprecated use MdChipsCtrl.selectAndFocusChipSafe. Will be removed in 1.2.
	 */
	MdChipsCtrl.prototype.selectAndFocusChip = function(index) {
	  this.selectChip(index);
	  if (index !== -1) {
	    this.focusChip(index);
	  }
	};
	
	/**
	 * Call {@code focus()} on the chip at {@code index}
	 * @param {number} index location of chip to focus
	 */
	MdChipsCtrl.prototype.focusChip = function(index) {
	  var chipContent = this.$element[0].querySelector(
	    'md-chip[index="' + index + '"] .md-chip-content'
	  );
	
	  this.ariaTabIndex = index;
	
	  chipContent.focus();
	};
	
	/**
	 * Configures the required interactions with the ngModel Controller.
	 * Specifically, set {@code this.items} to the {@code NgModelController#$viewValue}.
	 * @param {NgModelController} ngModelCtrl
	 */
	MdChipsCtrl.prototype.configureNgModel = function(ngModelCtrl) {
	  this.ngModelCtrl = ngModelCtrl;
	
	  var self = this;
	
	  // in chips the meaning of $isEmpty changes
	  ngModelCtrl.$isEmpty = function(value) {
	    return !value || value.length === 0;
	  };
	
	  ngModelCtrl.$render = function() {
	    // model is updated. do something.
	    self.items = self.ngModelCtrl.$viewValue;
	  };
	};
	
	MdChipsCtrl.prototype.onFocus = function () {
	  var input = this.$element[0].querySelector('input');
	  input && input.focus();
	  this.resetSelectedChip();
	};
	
	MdChipsCtrl.prototype.onInputFocus = function () {
	  this.inputHasFocus = true;
	
	  // Make sure we have the appropriate ARIA attributes
	  this.setupInputAria();
	
	  // Make sure we don't have any chips selected
	  this.resetSelectedChip();
	};
	
	MdChipsCtrl.prototype.onInputBlur = function () {
	  this.inputHasFocus = false;
	
	  if (this.shouldAddOnBlur()) {
	    this.appendChip(this.getChipBuffer().trim());
	    this.resetChipBuffer();
	  }
	};
	
	/**
	 * Configure event bindings on input element.
	 * @param {angular.element} inputElement
	 */
	MdChipsCtrl.prototype.configureInput = function configureInput(inputElement) {
	  // Find the NgModelCtrl for the input element
	  var ngModelCtrl = inputElement.controller('ngModel');
	  var ctrl = this;
	
	  if (ngModelCtrl) {
	
	    // sync touched-state from inner input to chips-element
	    this.deRegister.push(
	      this.$scope.$watch(
	        function() {
	          return ngModelCtrl.$touched;
	        },
	        function(isTouched) {
	          isTouched && ctrl.ngModelCtrl.$setTouched();
	        }
	      )
	    );
	
	    // sync dirty-state from inner input to chips-element
	    this.deRegister.push(
	      this.$scope.$watch(
	        function() {
	          return ngModelCtrl.$dirty;
	        },
	        function(isDirty) {
	          isDirty && ctrl.ngModelCtrl.$setDirty();
	        }
	      )
	    );
	  }
	};
	
	/**
	 * Configure event bindings on a user-provided input element.
	 * @param {angular.element} inputElement
	 */
	MdChipsCtrl.prototype.configureUserInput = function(inputElement) {
	  this.userInputElement = inputElement;
	
	  // Find the NgModelCtrl for the input element
	  var ngModelCtrl = inputElement.controller('ngModel');
	  // `.controller` will look in the parent as well.
	  if (ngModelCtrl !== this.ngModelCtrl) {
	    this.userInputNgModelCtrl = ngModelCtrl;
	  }
	
	  var scope = this.$scope;
	  var ctrl = this;
	
	  // Run all of the events using evalAsync because a focus may fire a blur in the same digest loop
	  var scopeApplyFn = function(event, fn) {
	    scope.$evalAsync(angular.bind(ctrl, fn, event));
	  };
	
	  // Bind to keydown and focus events of input
	  inputElement
	      .attr({ tabindex: 0 })
	      .on('keydown', function(event) { scopeApplyFn(event, ctrl.inputKeydown) })
	      .on('focus', function(event) { scopeApplyFn(event, ctrl.onInputFocus) })
	      .on('blur', function(event) { scopeApplyFn(event, ctrl.onInputBlur) });
	};
	
	/**
	 * @param {MdAutocompleteCtrl} ctrl controller from the autocomplete component
	 */
	MdChipsCtrl.prototype.configureAutocomplete = function(ctrl) {
	  if (ctrl) {
	    this.autocompleteCtrl = ctrl;
	
	    ctrl.registerSelectedItemWatcher(angular.bind(this, function (item) {
	      if (item) {
	        // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
	        if (this.hasMaxChipsReached()) return;
	
	        this.appendChip(item);
	        this.resetChipBuffer();
	      }
	    }));
	
	    this.$element.find('input')
	        .on('focus',angular.bind(this, this.onInputFocus) )
	        .on('blur', angular.bind(this, this.onInputBlur) );
	  }
	};
	
	/**
	 * @returns {boolean} Whether the current chip buffer should be added on input blur or not.
	 */
	MdChipsCtrl.prototype.shouldAddOnBlur = function() {
	
	  // Update the custom ngModel validators from the chips component.
	  this.validateModel();
	
	  var chipBuffer = this.getChipBuffer().trim();
	  // If the model value is empty and required is set on the element, then the model will be invalid.
	  // In that case, we still want to allow adding the chip. The main (but not only) case we want
	  // to disallow is adding a chip on blur when md-max-chips validation fails.
	  var isModelValid = this.ngModelCtrl.$isEmpty(this.ngModelCtrl.$modelValue) ||
	    this.ngModelCtrl.$valid;
	  var isAutocompleteShowing = this.autocompleteCtrl && !this.autocompleteCtrl.hidden;
	
	  if (this.userInputNgModelCtrl) {
	    isModelValid = isModelValid && this.userInputNgModelCtrl.$valid;
	  }
	
	  return this.addOnBlur && !this.requireMatch && chipBuffer && isModelValid &&
	    !isAutocompleteShowing;
	};
	
	/**
	 * @returns {boolean} true if the input or a chip is focused. False otherwise.
	 */
	MdChipsCtrl.prototype.hasFocus = function () {
	  return this.inputHasFocus || this.selectedChip >= 0;
	};
	
	/**
	 * @param {number} index location of content id
	 * @returns {number} unique id for the aria-owns attribute
	 */
	MdChipsCtrl.prototype.contentIdFor = function(index) {
	  return this.contentIds[index];
	};
	
	})();
	(function(){
	"use strict";
	
	  
	  MdChips.$inject = ["$mdTheming", "$mdUtil", "$compile", "$log", "$timeout", "$$mdSvgRegistry"];angular
	      .module('material.components.chips')
	      .directive('mdChips', MdChips);
	
	  /**
	   * @ngdoc directive
	   * @name mdChips
	   * @module material.components.chips
	   *
	   * @description
	   * `<md-chips>` is an input component for building lists of strings or objects. The list items are
	   * displayed as 'chips'. This component can make use of an `<input>` element or an
	   * `<md-autocomplete>` element.
	   *
	   * ### Custom templates
	   * A custom template may be provided to render the content of each chip. This is achieved by
	   * specifying an `<md-chip-template>` element containing the custom content as a child of
	   * `<md-chips>`.
	   *
	   * Note: Any attributes on
	   * `<md-chip-template>` will be dropped as only the innerHTML is used for the chip template. The
	   * variables `$chip` and `$index` are available in the scope of `<md-chip-template>`, representing
	   * the chip object and its index in the list of chips, respectively.
	   * To override the chip delete control, include an element (ideally a button) with the attribute
	   * `md-chip-remove`. A click listener to remove the chip will be added automatically. The element
	   * is also placed as a sibling to the chip content (on which there are also click listeners) to
	   * avoid a nested ng-click situation.
	   *
	   * <!-- Note: We no longer want to include this in the site docs; but it should remain here for
	   * future developers and those looking at the documentation.
	   *
	   * <h3> Pending Features </h3>
	   * <ul style="padding-left:20px;">
	   *
	   *   <ul>Style
	   *     <li>Colours for hover, press states (ripple?).</li>
	   *   </ul>
	   *
	   *   <ul>Validation
	   *     <li>allow a validation callback</li>
	   *     <li>highlighting style for invalid chips</li>
	   *   </ul>
	   *
	   *   <ul>Item mutation
	   *     <li>Support `
	   *       <md-chip-edit>` template, show/hide the edit element on tap/click? double tap/double
	   *       click?
	   *     </li>
	   *   </ul>
	   *
	   *   <ul>Truncation and Disambiguation (?)
	   *     <li>Truncate chip text where possible, but do not truncate entries such that two are
	   *     indistinguishable.</li>
	   *   </ul>
	   *
	   *   <ul>Drag and Drop
	   *     <li>Drag and drop chips between related `<md-chips>` elements.
	   *     </li>
	   *   </ul>
	   * </ul>
	   *
	   * //-->
	   *
	   * Sometimes developers want to limit the amount of possible chips.<br/>
	   * You can specify the maximum amount of chips by using the following markup.
	   *
	   * <hljs lang="html">
	   *   <md-chips
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       md-max-chips="5">
	   *   </md-chips>
	   * </hljs>
	   *
	   * In some cases, you have an autocomplete inside of the `md-chips`.<br/>
	   * When the maximum amount of chips has been reached, you can also disable the autocomplete
	   * selection.<br/>
	   * Here is an example markup.
	   *
	   * <hljs lang="html">
	   *   <md-chips ng-model="myItems" md-max-chips="5">
	   *     <md-autocomplete ng-hide="myItems.length > 5" ...></md-autocomplete>
	   *   </md-chips>
	   * </hljs>
	   *
	   * ### Accessibility
	   *
	   * The `md-chips` component supports keyboard and screen reader users since Version 1.1.2. In
	   * order to achieve this, we modified the chips behavior to select newly appended chips for
	   * `300ms` before re-focusing the input and allowing the user to type.
	   *
	   * For most users, this delay is small enough that it will not be noticeable but allows certain
	   * screen readers to function properly (JAWS and NVDA in particular).
	   *
	   * We introduced a new `md-chip-append-delay` option to allow developers to better control this
	   * behavior.
	   *
	   * Please refer to the documentation of this option (below) for more information.
	   *
	   * @param {expression} ng-model Assignable AngularJS expression to be data-bound to the list of
	   *    chips. The expression should evaluate to a `string` or `Object` Array. The type of this
	   *    array should align with the return value of `md-transform-chip`.
	   * @param {expression=} ng-change AngularJS expression to be executed on chip addition, removal,
	   *    or content change.
	   * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	   * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
	   *    displayed when there is at least one item in the list
	   * @param {boolean=} md-removable Enables or disables the deletion of chips through the
	   *    removal icon or the Delete/Backspace key. Defaults to true.
	   * @param {boolean=} readonly Disables list manipulation (deleting or adding list items), hiding
	   *    the input and delete buttons. If no `ng-model` is provided, the chips will automatically be
	   *    marked as readonly.<br/><br/>
	   *    When `md-removable` is not defined, the `md-remove` behavior will be overwritten and
	   *    disabled.
	   * @param {boolean=} md-enable-chip-edit Set this to `"true"` to enable editing of chip contents.
	   *    The user can go into edit mode by pressing the `space` or `enter` keys, or by double
	   *    clicking on the chip. Chip editing is only supported for chips using the basic template.
	   *    **Note:** This attribute is only evaluated once; it is not watched.
	   * @param {boolean=} ng-required Whether ng-model is allowed to be empty or not.
	   * @param {number=} md-max-chips The maximum number of chips allowed to add through user input.
	   *    <br/><br/>The validation property `md-max-chips` can be used when the max chips
	   *    amount is reached.
	   * @param {boolean=} md-add-on-blur When set to `"true"`, the remaining text inside of the input
	   *    will be converted into a new chip on blur.
	   *    **Note:** This attribute is only evaluated once; it is not watched.
	   * @param {expression} md-transform-chip An expression of form `myFunction($chip)` that when
	   *    called expects one of the following return values:
	   *    - an object representing the `$chip` input string
	   *    - `undefined` to simply add the `$chip` input string, or
	   *    - `null` to prevent the chip from being appended
	   * @param {expression=} md-on-add An expression which will be called when a chip has been
	   *    added with `$chip` and `$index` available as parameters.
	   * @param {expression=} md-on-remove An expression which will be called when a chip has been
	   *    removed with `$chip`, `$index`, and `$event` available as parameters.
	   * @param {expression=} md-on-select An expression which will be called when a chip is selected.
	   * @param {boolean} md-require-match If true, and the chips template contains an autocomplete,
	   *    only allow selection of pre-defined chips (i.e. you cannot add new ones).
	   * @param {string=} input-aria-label A string read by screen readers to identify the input.
	   * @param {string=} container-hint A string read by screen readers informing users of how to
	   *    navigate the chips. Used in readonly mode.
	   * @param {string=} delete-hint A string read by screen readers instructing users that pressing
	   *    the delete key will remove the chip.
	   * @param {string=} delete-button-label A label for the delete button. Also hidden and read by
	   *    screen readers.
	   * @param {expression=} md-separator-keys An array of key codes used to separate chips.
	   * @param {string=} md-chip-append-delay The number of milliseconds that the component will select
	   *    a newly appended chip before allowing a user to type into the input. This is **necessary**
	   *    for keyboard accessibility for screen readers. It defaults to 300ms and any number less than
	   *    300 can cause issues with screen readers (particularly JAWS and sometimes NVDA).
	   *
	   *    _Available since Version 1.1.2._
	   *
	   *    **Note:** You can safely set this to `0` in one of the following two instances:
	   *
	   *    1. You are targeting an iOS or Safari-only application (where users would use VoiceOver) or
	   *    only ChromeVox users.
	   *
	   *    2. If you have utilized the `md-separator-keys` to disable the `enter` keystroke in
	   *    favor of another one (such as `,` or `;`).
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <md-chips
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       readonly="isReadOnly">
	   *   </md-chips>
	   * </hljs>
	   *
	   * <h3>Validation</h3>
	   * When using [ngMessages](https://docs.angularjs.org/api/ngMessages), you can show errors based
	   * on our custom validators.
	   * <hljs lang="html">
	   *   <form name="userForm">
	   *     <md-chips
	   *       name="fruits"
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       md-max-chips="5">
	   *     </md-chips>
	   *     <div ng-messages="userForm.fruits.$error" ng-if="userForm.$dirty">
	   *       <div ng-message="md-max-chips">You reached the maximum amount of chips</div>
	   *    </div>
	   *   </form>
	   * </hljs>
	   *
	   */
	
	  var MD_CHIPS_TEMPLATE = '\
	      <md-chips-wrap\
	          id="{{$mdChipsCtrl.wrapperId}}"\
	          tabindex="{{$mdChipsCtrl.readonly ? 0 : -1}}"\
	          ng-keydown="$mdChipsCtrl.chipKeydown($event)"\
	          ng-class="{ \'md-focused\': $mdChipsCtrl.hasFocus(), \
	                      \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly,\
	                      \'md-removable\': $mdChipsCtrl.isRemovable() }"\
	          aria-setsize="{{$mdChipsCtrl.items.length}}"\
	          class="md-chips">\
	        <span ng-if="$mdChipsCtrl.readonly" class="md-visually-hidden">\
	          {{$mdChipsCtrl.containerHint}}\
	        </span>\
	        <md-chip ng-repeat="$chip in $mdChipsCtrl.items"\
	            index="{{$index}}"\
	            ng-class="{\'md-focused\': $mdChipsCtrl.selectedChip == $index, \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}">\
	          <div class="md-chip-content"\
	              tabindex="{{$mdChipsCtrl.ariaTabIndex == $index ? 0 : -1}}"\
	              id="{{$mdChipsCtrl.contentIdFor($index)}}"\
	              role="option"\
	              aria-selected="{{$mdChipsCtrl.selectedChip === $index}}"\
	              aria-posinset="{{$index}}"\
	              ng-click="!$mdChipsCtrl.readonly && $mdChipsCtrl.focusChip($index)"\
	              ng-focus="!$mdChipsCtrl.readonly && $mdChipsCtrl.selectChip($index)"\
	              md-chip-transclude="$mdChipsCtrl.chipContentsTemplate"></div>\
	          <div ng-if="$mdChipsCtrl.isRemovable()"\
	               class="md-chip-remove-container"\
	               tabindex="-1"\
	               md-chip-transclude="$mdChipsCtrl.chipRemoveTemplate"></div>\
	        </md-chip>\
	        <div class="md-chip-input-container" ng-if="!$mdChipsCtrl.readonly && $mdChipsCtrl.ngModelCtrl">\
	          <div md-chip-transclude="$mdChipsCtrl.chipInputTemplate"></div>\
	        </div>\
	      </md-chips-wrap>';
	
	  var CHIP_INPUT_TEMPLATE = '\
	        <input\
	            class="md-input"\
	            tabindex="0"\
	            aria-label="{{$mdChipsCtrl.inputAriaLabel}}" \
	            placeholder="{{$mdChipsCtrl.getPlaceholder()}}"\
	            ng-model="$mdChipsCtrl.chipBuffer"\
	            ng-focus="$mdChipsCtrl.onInputFocus()"\
	            ng-blur="$mdChipsCtrl.onInputBlur()"\
	            ng-keydown="$mdChipsCtrl.inputKeydown($event)">';
	
	  var CHIP_DEFAULT_TEMPLATE = '\
	      <span>{{$chip}}</span>';
	
	  var CHIP_REMOVE_TEMPLATE = '\
	      <button\
	          class="md-chip-remove"\
	          ng-if="$mdChipsCtrl.isRemovable()"\
	          ng-click="$mdChipsCtrl.removeChipAndFocusInput($$replacedScope.$index, $event)"\
	          type="button"\
	          tabindex="-1">\
	        <md-icon md-svg-src="{{ $mdChipsCtrl.mdCloseIcon }}"></md-icon>\
	        <span class="md-visually-hidden">\
	          {{$mdChipsCtrl.deleteButtonLabel}}\
	        </span>\
	      </button>';
	
	  /**
	   * MDChips Directive Definition
	   */
	  function MdChips ($mdTheming, $mdUtil, $compile, $log, $timeout, $$mdSvgRegistry) {
	    // Run our templates through $mdUtil.processTemplate() to allow custom start/end symbols
	    var templates = getTemplates();
	
	    return {
	      template: function(element, attrs) {
	        // Clone the element into an attribute. By prepending the attribute
	        // name with '$', AngularJS won't write it into the DOM. The cloned
	        // element propagates to the link function via the attrs argument,
	        // where various contained-elements can be consumed.
	        attrs['$mdUserTemplate'] = element.clone();
	        return templates.chips;
	      },
	      require: ['mdChips'],
	      restrict: 'E',
	      controller: 'MdChipsCtrl',
	      controllerAs: '$mdChipsCtrl',
	      bindToController: true,
	      compile: compile,
	      scope: {
	        readonly: '=readonly',
	        removable: '=mdRemovable',
	        placeholder: '@',
	        secondaryPlaceholder: '@',
	        maxChips: '@mdMaxChips',
	        transformChip: '&mdTransformChip',
	        onAppend: '&mdOnAppend',
	        onAdd: '&mdOnAdd',
	        onRemove: '&mdOnRemove',
	        onSelect: '&mdOnSelect',
	        inputAriaLabel: '@',
	        containerHint: '@',
	        deleteHint: '@',
	        deleteButtonLabel: '@',
	        separatorKeys: '=?mdSeparatorKeys',
	        requireMatch: '=?mdRequireMatch',
	        chipAppendDelayString: '@?mdChipAppendDelay',
	        ngChange: '&'
	      }
	    };
	
	    /**
	     * Builds the final template for `md-chips` and returns the postLink function.
	     *
	     * Building the template involves 3 key components:
	     * static chips
	     * chip template
	     * input control
	     *
	     * If no `ng-model` is provided, only the static chip work needs to be done.
	     *
	     * If no user-passed `md-chip-template` exists, the default template is used. This resulting
	     * template is appended to the chip content element.
	     *
	     * The remove button may be overridden by passing an element with an md-chip-remove attribute.
	     *
	     * If an `input` or `md-autocomplete` element is provided by the caller, it is set aside for
	     * transclusion later. The transclusion happens in `postLink` as the parent scope is required.
	     * If no user input is provided, a default one is appended to the input container node in the
	     * template.
	     *
	     * Static Chips (i.e. `md-chip` elements passed from the caller) are gathered and set aside for
	     * transclusion in the `postLink` function.
	     *
	     *
	     * @param element
	     * @param attr
	     * @returns {Function}
	     */
	    function compile(element, attr) {
	      // Grab the user template from attr and reset the attribute to null.
	      var userTemplate = attr['$mdUserTemplate'];
	      attr['$mdUserTemplate'] = null;
	
	      var chipTemplate = getTemplateByQuery('md-chips>md-chip-template');
	
	      var chipRemoveSelector = $mdUtil
	        .prefixer()
	        .buildList('md-chip-remove')
	        .map(function(attr) {
	          return 'md-chips>*[' + attr + ']';
	        })
	        .join(',');
	
	      // Set the chip remove, chip contents and chip input templates. The link function will put
	      // them on the scope for transclusion later.
	      var chipRemoveTemplate   = getTemplateByQuery(chipRemoveSelector) || templates.remove,
	          chipContentsTemplate = chipTemplate || templates.default,
	          chipInputTemplate    = getTemplateByQuery('md-chips>md-autocomplete')
	              || getTemplateByQuery('md-chips>input')
	              || templates.input,
	          staticChips = userTemplate.find('md-chip');
	
	      // Warn of malformed template. See #2545
	      if (userTemplate[0].querySelector('md-chip-template>*[md-chip-remove]')) {
	        $log.warn('invalid placement of md-chip-remove within md-chip-template.');
	      }
	
	      function getTemplateByQuery (query) {
	        if (!attr.ngModel) return;
	        var element = userTemplate[0].querySelector(query);
	        return element && element.outerHTML;
	      }
	
	      /**
	       * Configures controller and transcludes.
	       */
	      return function postLink(scope, element, attrs, controllers) {
	        $mdUtil.initOptionalProperties(scope, attr);
	
	        $mdTheming(element);
	        var mdChipsCtrl = controllers[0];
	        if (chipTemplate) {
	          // Chip editing functionality assumes we are using the default chip template.
	          mdChipsCtrl.enableChipEdit = false;
	        }
	
	        mdChipsCtrl.chipContentsTemplate = chipContentsTemplate;
	        mdChipsCtrl.chipRemoveTemplate   = chipRemoveTemplate;
	        mdChipsCtrl.chipInputTemplate    = chipInputTemplate;
	
	        mdChipsCtrl.mdCloseIcon = $$mdSvgRegistry.mdClose;
	
	        element
	            .attr({ tabindex: -1 })
	            .on('focus', function () { mdChipsCtrl.onFocus(); })
	            .on('click', function () {
	              if (!mdChipsCtrl.readonly && mdChipsCtrl.selectedChip === -1) {
	                mdChipsCtrl.onFocus();
	              }
	            });
	
	        if (attr.ngModel) {
	          mdChipsCtrl.configureNgModel(element.controller('ngModel'));
	
	          // If an `md-transform-chip` attribute was set, tell the controller to use the expression
	          // before appending chips.
	          if (attrs.mdTransformChip) mdChipsCtrl.useTransformChipExpression();
	
	          // If an `md-on-append` attribute was set, tell the controller to use the expression
	          // when appending chips.
	          //
	          // TODO: Remove this now that 1.0 is long since released
	          // DEPRECATED: Will remove in official 1.0 release
	          if (attrs.mdOnAppend) mdChipsCtrl.useOnAppendExpression();
	
	          // If an `md-on-add` attribute was set, tell the controller to use the expression
	          // when adding chips.
	          if (attrs.mdOnAdd) mdChipsCtrl.useOnAddExpression();
	
	          // If an `md-on-remove` attribute was set, tell the controller to use the expression
	          // when removing chips.
	          if (attrs.mdOnRemove) mdChipsCtrl.useOnRemoveExpression();
	
	          // If an `md-on-select` attribute was set, tell the controller to use the expression
	          // when selecting chips.
	          if (attrs.mdOnSelect) mdChipsCtrl.useOnSelectExpression();
	
	          // The md-autocomplete and input elements won't be compiled until after this directive
	          // is complete (due to their nested nature). Wait a tick before looking for them to
	          // configure the controller.
	          if (chipInputTemplate != templates.input) {
	            // The autocomplete will not appear until the readonly attribute is not true (i.e.
	            // false or undefined), so we have to watch the readonly and then on the next tick
	            // after the chip transclusion has run, we can configure the autocomplete and user
	            // input.
	            scope.$watch('$mdChipsCtrl.readonly', function(readonly) {
	              if (!readonly) {
	
	                $mdUtil.nextTick(function(){
	
	                  if (chipInputTemplate.indexOf('<md-autocomplete') === 0) {
	                    var autocompleteEl = element.find('md-autocomplete');
	                    mdChipsCtrl.configureAutocomplete(autocompleteEl.controller('mdAutocomplete'));
	                  }
	
	                  mdChipsCtrl.configureUserInput(element.find('input'));
	                });
	              }
	            });
	          }
	
	          // At the next tick, if we find an input, make sure it has the md-input class
	          $mdUtil.nextTick(function() {
	            var input = element.find('input');
	
	            if (input) {
	              mdChipsCtrl.configureInput(input);
	              input.toggleClass('md-input', true);
	            }
	          });
	        }
	
	        // Compile with the parent's scope and prepend any static chips to the wrapper.
	        if (staticChips.length > 0) {
	          var compiledStaticChips = $compile(staticChips.clone())(scope.$parent);
	          $timeout(function() { element.find('md-chips-wrap').prepend(compiledStaticChips); });
	        }
	      };
	    }
	
	    function getTemplates() {
	      return {
	        chips: $mdUtil.processTemplate(MD_CHIPS_TEMPLATE),
	        input: $mdUtil.processTemplate(CHIP_INPUT_TEMPLATE),
	        default: $mdUtil.processTemplate(CHIP_DEFAULT_TEMPLATE),
	        remove: $mdUtil.processTemplate(CHIP_REMOVE_TEMPLATE)
	      };
	    }
	  }
	
	})();
	(function(){
	"use strict";
	
	angular
	    .module('material.components.chips')
	    .controller('MdContactChipsCtrl', MdContactChipsCtrl);
	
	/**
	 * Controller for the MdContactChips component
	 * @constructor
	 */
	function MdContactChipsCtrl () {
	  /** @type {Object} */
	  this.selectedItem = null;
	
	  /** @type {string} */
	  this.searchText = '';
	}
	
	MdContactChipsCtrl.prototype.queryContact = function(searchText) {
	  return this.contactQuery({'$query': searchText});
	};
	
	MdContactChipsCtrl.prototype.itemName = function(item) {
	  return item[this.contactName];
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdContactChips.$inject = ["$mdTheming", "$mdUtil"];angular
	  .module('material.components.chips')
	  .directive('mdContactChips', MdContactChips);
	
	/**
	 * @ngdoc directive
	 * @name mdContactChips
	 * @module material.components.chips
	 *
	 * @description
	 * `<md-contact-chips>` is an input component based on `md-chips` and makes use of an
	 * `md-autocomplete` element. The component allows the caller to supply a query expression which
	 * returns  a list of possible contacts. The user can select one of these and add it to the list of
	 * chips.
	 *
	 * You may also use the `md-highlight-text` directive along with its parameters to control the
	 * appearance of the matched text inside of the contacts' autocomplete popup.
	 *
	 * @param {expression} ng-model Assignable AngularJS expression to be data-bound to the list of
	 *    contact chips. The expression should evaluate to an `Object` Array.
	 * @param {expression=} ng-change AngularJS expression to be executed on chip addition, removal,
	 *    or content change.
	 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	 * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
	 *    displayed when there is at least on item in the list
	 * @param {expression} md-contacts An expression expected to return contacts matching the search
	 *    test, `$query`. If this expression involves a promise, a loading bar is displayed while
	 *    waiting for it to resolve.
	 * @param {string} md-contact-name The field name of the contact object representing the
	 *    contact's name.
	 * @param {string} md-contact-email The field name of the contact object representing the
	 *    contact's email address.
	 * @param {string} md-contact-image The field name of the contact object representing the
	 *    contact's image.
	 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
	 *    make suggestions
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-contact-chips
	 *       ng-model="ctrl.contacts"
	 *       md-contacts="ctrl.querySearch($query)"
	 *       md-contact-name="name"
	 *       md-contact-image="image"
	 *       md-contact-email="email"
	 *       placeholder="To">
	 *   </md-contact-chips>
	 * </hljs>
	 *
	 */
	
	
	var MD_CONTACT_CHIPS_TEMPLATE = '\
	      <md-chips class="md-contact-chips"\
	          ng-model="$mdContactChipsCtrl.contacts"\
	          ng-change="$mdContactChipsCtrl.ngChange($mdContactChipsCtrl.contacts)"\
	          md-require-match="$mdContactChipsCtrl.requireMatch"\
	          md-chip-append-delay="{{$mdContactChipsCtrl.chipAppendDelay}}" \
	          md-autocomplete-snap>\
	          <md-autocomplete\
	              md-menu-class="md-contact-chips-suggestions"\
	              md-selected-item="$mdContactChipsCtrl.selectedItem"\
	              md-search-text="$mdContactChipsCtrl.searchText"\
	              md-items="item in $mdContactChipsCtrl.queryContact($mdContactChipsCtrl.searchText)"\
	              md-item-text="$mdContactChipsCtrl.itemName(item)"\
	              md-no-cache="true"\
	              md-min-length="$mdContactChipsCtrl.minLength"\
	              md-autoselect\
	              placeholder="{{$mdContactChipsCtrl.contacts.length == 0 ?\
	                  $mdContactChipsCtrl.placeholder : $mdContactChipsCtrl.secondaryPlaceholder}}">\
	            <div class="md-contact-suggestion">\
	              <img \
	                  ng-src="{{item[$mdContactChipsCtrl.contactImage]}}"\
	                  alt="{{item[$mdContactChipsCtrl.contactName]}}"\
	                  ng-if="item[$mdContactChipsCtrl.contactImage]" />\
	              <span class="md-contact-name" md-highlight-text="$mdContactChipsCtrl.searchText"\
	                    md-highlight-flags="{{$mdContactChipsCtrl.highlightFlags}}">\
	                {{item[$mdContactChipsCtrl.contactName]}}\
	              </span>\
	              <span class="md-contact-email" >{{item[$mdContactChipsCtrl.contactEmail]}}</span>\
	            </div>\
	          </md-autocomplete>\
	          <md-chip-template>\
	            <div class="md-contact-avatar">\
	              <img \
	                  ng-src="{{$chip[$mdContactChipsCtrl.contactImage]}}"\
	                  alt="{{$chip[$mdContactChipsCtrl.contactName]}}"\
	                  ng-if="$chip[$mdContactChipsCtrl.contactImage]" />\
	            </div>\
	            <div class="md-contact-name">\
	              {{$chip[$mdContactChipsCtrl.contactName]}}\
	            </div>\
	          </md-chip-template>\
	      </md-chips>';
	
	
	/**
	 * MDContactChips Directive Definition
	 *
	 * @param $mdTheming
	 * @returns {*}
	 * @ngInject
	 */
	function MdContactChips($mdTheming, $mdUtil) {
	  return {
	    template: function(element, attrs) {
	      return MD_CONTACT_CHIPS_TEMPLATE;
	    },
	    restrict: 'E',
	    controller: 'MdContactChipsCtrl',
	    controllerAs: '$mdContactChipsCtrl',
	    bindToController: true,
	    compile: compile,
	    scope: {
	      contactQuery: '&mdContacts',
	      placeholder: '@',
	      secondaryPlaceholder: '@',
	      contactName: '@mdContactName',
	      contactImage: '@mdContactImage',
	      contactEmail: '@mdContactEmail',
	      contacts: '=ngModel',
	      ngChange: '&',
	      requireMatch: '=?mdRequireMatch',
	      minLength: '=?mdMinLength',
	      highlightFlags: '@?mdHighlightFlags',
	      chipAppendDelay: '@?mdChipAppendDelay'
	    }
	  };
	
	  function compile(element, attr) {
	    return function postLink(scope, element, attrs, controllers) {
	      var contactChipsController = controllers;
	
	      $mdUtil.initOptionalProperties(scope, attr);
	      $mdTheming(element);
	
	      element.attr('tabindex', '-1');
	
	      attrs.$observe('mdChipAppendDelay', function(newValue) {
	        contactChipsController.chipAppendDelay = newValue;
	      });
	    };
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc directive
	   * @name mdCalendar
	   * @module material.components.datepicker
	   *
	   * @param {Date} ng-model The component's model. Should be a Date object.
	   * @param {Date=} md-min-date Expression representing the minimum date.
	   * @param {Date=} md-max-date Expression representing the maximum date.
	   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a boolean whether it can be selected or not.
	   * @param {String=} md-current-view Current view of the calendar. Can be either "month" or "year".
	   * @param {String=} md-mode Restricts the user to only selecting a value from a particular view. This option can
	   * be used if the user is only supposed to choose from a certain date type (e.g. only selecting the month).
	   * Can be either "month" or "day". **Note** that this will ovewrite the `md-current-view` value.
	   *
	   * @description
	   * `<md-calendar>` is a component that renders a calendar that can be used to select a date.
	   * It is a part of the `<md-datepicker>` pane, however it can also be used on it's own.
	   *
	   * @usage
	   *
	   * <hljs lang="html">
	   *   <md-calendar ng-model="birthday"></md-calendar>
	   * </hljs>
	   */
	  CalendarCtrl.$inject = ["$element", "$scope", "$$mdDateUtil", "$mdUtil", "$mdConstant", "$mdTheming", "$$rAF", "$attrs", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendar', calendarDirective);
	
	  // POST RELEASE
	  // TODO(jelbourn): Mac Cmd + left / right == Home / End
	  // TODO(jelbourn): Refactor month element creation to use cloneNode (performance).
	  // TODO(jelbourn): Define virtual scrolling constants (compactness) users can override.
	  // TODO(jelbourn): Animated month transition on ng-model change (virtual-repeat)
	  // TODO(jelbourn): Scroll snapping (virtual repeat)
	  // TODO(jelbourn): Remove superfluous row from short months (virtual-repeat)
	  // TODO(jelbourn): Month headers stick to top when scrolling.
	  // TODO(jelbourn): Previous month opacity is lowered when partially scrolled out of view.
	  // TODO(jelbourn): Support md-calendar standalone on a page (as a tabstop w/ aria-live
	  //     announcement and key handling).
	  // Read-only calendar (not just date-picker).
	
	  function calendarDirective() {
	    return {
	      template: function(tElement, tAttr) {
	        // TODO(crisbeto): This is a workaround that allows the calendar to work, without
	        // a datepicker, until issue #8585 gets resolved. It can safely be removed
	        // afterwards. This ensures that the virtual repeater scrolls to the proper place on load by
	        // deferring the execution until the next digest. It's necessary only if the calendar is used
	        // without a datepicker, otherwise it's already wrapped in an ngIf.
	        var extraAttrs = tAttr.hasOwnProperty('ngIf') ? '' : 'ng-if="calendarCtrl.isInitialized"';
	        var template = '' +
	          '<div ng-switch="calendarCtrl.currentView" ' + extraAttrs + '>' +
	            '<md-calendar-year ng-switch-when="year"></md-calendar-year>' +
	            '<md-calendar-month ng-switch-default></md-calendar-month>' +
	          '</div>';
	
	        return template;
	      },
	      scope: {
	        minDate: '=mdMinDate',
	        maxDate: '=mdMaxDate',
	        dateFilter: '=mdDateFilter',
	
	        // These need to be prefixed, because Angular resets
	        // any changes to the value due to bindToController.
	        _mode: '@mdMode',
	        _currentView: '@mdCurrentView'
	      },
	      require: ['ngModel', 'mdCalendar'],
	      controller: CalendarCtrl,
	      controllerAs: 'calendarCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var ngModelCtrl = controllers[0];
	        var mdCalendarCtrl = controllers[1];
	        mdCalendarCtrl.configureNgModel(ngModelCtrl);
	      }
	    };
	  }
	
	  /**
	   * Occasionally the hideVerticalScrollbar method might read an element's
	   * width as 0, because it hasn't been laid out yet. This value will be used
	   * as a fallback, in order to prevent scenarios where the element's width
	   * would otherwise have been set to 0. This value is the "usual" width of a
	   * calendar within a floating calendar pane.
	   */
	  var FALLBACK_WIDTH = 340;
	
	  /** Next identifier for calendar instance. */
	  var nextUniqueId = 0;
	
	  /** Maps the `md-mode` values to their corresponding calendar views. */
	  var MODE_MAP = {
	    day: 'month',
	    month: 'year'
	  };
	
	  /**
	   * Controller for the mdCalendar component.
	   * @ngInject @constructor
	   */
	  function CalendarCtrl($element, $scope, $$mdDateUtil, $mdUtil,
	    $mdConstant, $mdTheming, $$rAF, $attrs, $mdDateLocale) {
	
	    $mdTheming($element);
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.$mdUtil = $mdUtil;
	
	    /** @final */
	    this.keyCode = $mdConstant.KEY_CODE;
	
	    /** @final */
	    this.$$rAF = $$rAF;
	
	    /** @final */
	    this.$mdDateLocale = $mdDateLocale;
	
	    /** @final {Date} */
	    this.today = this.dateUtil.createDateAtMidnight();
	
	    /** @type {!angular.NgModelController} */
	    this.ngModelCtrl = null;
	
	    /** @type {String} Class applied to the selected date cell. */
	    this.SELECTED_DATE_CLASS = 'md-calendar-selected-date';
	
	    /** @type {String} Class applied to the cell for today. */
	    this.TODAY_CLASS = 'md-calendar-date-today';
	
	    /** @type {String} Class applied to the focused cell. */
	    this.FOCUSED_DATE_CLASS = 'md-focus';
	
	    /** @final {number} Unique ID for this calendar instance. */
	    this.id = nextUniqueId++;
	
	    /**
	     * The date that is currently focused or showing in the calendar. This will initially be set
	     * to the ng-model value if set, otherwise to today. It will be updated as the user navigates
	     * to other months. The cell corresponding to the displayDate does not necesarily always have
	     * focus in the document (such as for cases when the user is scrolling the calendar).
	     * @type {Date}
	     */
	    this.displayDate = null;
	
	    /**
	     * The selected date. Keep track of this separately from the ng-model value so that we
	     * can know, when the ng-model value changes, what the previous value was before it's updated
	     * in the component's UI.
	     *
	     * @type {Date}
	     */
	    this.selectedDate = null;
	
	    /**
	     * The first date that can be rendered by the calendar. The default is taken
	     * from the mdDateLocale provider and is limited by the mdMinDate.
	     * @type {Date}
	     */
	    this.firstRenderableDate = null;
	
	    /**
	     * The last date that can be rendered by the calendar. The default comes
	     * from the mdDateLocale provider and is limited by the maxDate.
	     * @type {Date}
	     */
	    this.lastRenderableDate = null;
	
	    /**
	     * Used to toggle initialize the root element in the next digest.
	     * @type {Boolean}
	     */
	    this.isInitialized = false;
	
	    /**
	     * Cache for the  width of the element without a scrollbar. Used to hide the scrollbar later on
	     * and to avoid extra reflows when switching between views.
	     * @type {Number}
	     */
	    this.width = 0;
	
	    /**
	     * Caches the width of the scrollbar in order to be used when hiding it and to avoid extra reflows.
	     * @type {Number}
	     */
	    this.scrollbarWidth = 0;
	
	    // Unless the user specifies so, the calendar should not be a tab stop.
	    // This is necessary because ngAria might add a tabindex to anything with an ng-model
	    // (based on whether or not the user has turned that particular feature on/off).
	    if (!$attrs.tabindex) {
	      $element.attr('tabindex', '-1');
	    }
	
	    var boundKeyHandler = angular.bind(this, this.handleKeyEvent);
	
	    // If use the md-calendar directly in the body without datepicker,
	    // handleKeyEvent will disable other inputs on the page.
	    // So only apply the handleKeyEvent on the body when the md-calendar inside datepicker,
	    // otherwise apply on the calendar element only.
	
	    var handleKeyElement;
	    if ($element.parent().hasClass('md-datepicker-calendar')) {
	      handleKeyElement = angular.element(document.body);
	    } else {
	      handleKeyElement = $element;
	    }
	
	    // Bind the keydown handler to the body, in order to handle cases where the focused
	    // element gets removed from the DOM and stops propagating click events.
	    handleKeyElement.on('keydown', boundKeyHandler);
	
	    $scope.$on('$destroy', function() {
	      handleKeyElement.off('keydown', boundKeyHandler);
	    });
	
	    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	    // manually call the $onInit hook.
	    if (angular.version.major === 1 && angular.version.minor <= 4) {
	      this.$onInit();
	    }
	
	  }
	
	  /**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	   */
	  CalendarCtrl.prototype.$onInit = function() {
	    /**
	     * The currently visible calendar view. Note the prefix on the scope value,
	     * which is necessary, because the datepicker seems to reset the real one value if the
	     * calendar is open, but the `currentView` on the datepicker's scope is empty.
	     * @type {String}
	     */
	    if (this._mode && MODE_MAP.hasOwnProperty(this._mode)) {
	      this.currentView = MODE_MAP[this._mode];
	      this.mode = this._mode;
	    } else {
	      this.currentView = this._currentView || 'month';
	      this.mode = null;
	    }
	
	    var dateLocale = this.$mdDateLocale;
	
	    if (this.minDate && this.minDate > dateLocale.firstRenderableDate) {
	      this.firstRenderableDate = this.minDate;
	    } else {
	      this.firstRenderableDate = dateLocale.firstRenderableDate;
	    }
	
	    if (this.maxDate && this.maxDate < dateLocale.lastRenderableDate) {
	      this.lastRenderableDate = this.maxDate;
	    } else {
	      this.lastRenderableDate = dateLocale.lastRenderableDate;
	    }
	  };
	
	  /**
	   * Sets up the controller's reference to ngModelController.
	   * @param {!angular.NgModelController} ngModelCtrl
	   */
	  CalendarCtrl.prototype.configureNgModel = function(ngModelCtrl) {
	    var self = this;
	
	    self.ngModelCtrl = ngModelCtrl;
	
	    self.$mdUtil.nextTick(function() {
	      self.isInitialized = true;
	    });
	
	    ngModelCtrl.$render = function() {
	      var value = this.$viewValue;
	
	      // Notify the child scopes of any changes.
	      self.$scope.$broadcast('md-calendar-parent-changed', value);
	
	      // Set up the selectedDate if it hasn't been already.
	      if (!self.selectedDate) {
	        self.selectedDate = value;
	      }
	
	      // Also set up the displayDate.
	      if (!self.displayDate) {
	        self.displayDate = self.selectedDate || self.today;
	      }
	    };
	  };
	
	  /**
	   * Sets the ng-model value for the calendar and emits a change event.
	   * @param {Date} date
	   */
	  CalendarCtrl.prototype.setNgModelValue = function(date) {
	    var value = this.dateUtil.createDateAtMidnight(date);
	    this.focus(value);
	    this.$scope.$emit('md-calendar-change', value);
	    this.ngModelCtrl.$setViewValue(value);
	    this.ngModelCtrl.$render();
	    return value;
	  };
	
	  /**
	   * Sets the current view that should be visible in the calendar
	   * @param {string} newView View name to be set.
	   * @param {number|Date} time Date object or a timestamp for the new display date.
	   */
	  CalendarCtrl.prototype.setCurrentView = function(newView, time) {
	    var self = this;
	
	    self.$mdUtil.nextTick(function() {
	      self.currentView = newView;
	
	      if (time) {
	        self.displayDate = angular.isDate(time) ? time : new Date(time);
	      }
	    });
	  };
	
	  /**
	   * Focus the cell corresponding to the given date.
	   * @param {Date} date The date to be focused.
	   */
	  CalendarCtrl.prototype.focus = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var previousFocus = this.$element[0].querySelector('.' + this.FOCUSED_DATE_CLASS);
	      if (previousFocus) {
	        previousFocus.classList.remove(this.FOCUSED_DATE_CLASS);
	      }
	
	      var cellId = this.getDateId(date, this.currentView);
	      var cell = document.getElementById(cellId);
	      if (cell) {
	        cell.classList.add(this.FOCUSED_DATE_CLASS);
	        cell.focus();
	        this.displayDate = date;
	      }
	    } else {
	      var rootElement = this.$element[0].querySelector('[ng-switch]');
	
	      if (rootElement) {
	        rootElement.focus();
	      }
	    }
	  };
	
	  /**
	   * Highlights a date cell on the calendar and changes the selected date.
	   * @param {Date=} date Date to be marked as selected.
	   */
	  CalendarCtrl.prototype.changeSelectedDate = function(date) {
	    var selectedDateClass = this.SELECTED_DATE_CLASS;
	    var prevDateCell = this.$element[0].querySelector('.' + selectedDateClass);
	
	    // Remove the selected class from the previously selected date, if any.
	    if (prevDateCell) {
	      prevDateCell.classList.remove(selectedDateClass);
	      prevDateCell.setAttribute('aria-selected', 'false');
	    }
	
	    // Apply the select class to the new selected date if it is set.
	    if (date) {
	      var dateCell = document.getElementById(this.getDateId(date, this.currentView));
	      if (dateCell) {
	        dateCell.classList.add(selectedDateClass);
	        dateCell.setAttribute('aria-selected', 'true');
	      }
	    }
	
	    this.selectedDate = date;
	  };
	
	  /**
	   * Normalizes the key event into an action name. The action will be broadcast
	   * to the child controllers.
	   * @param {KeyboardEvent} event
	   * @returns {String} The action that should be taken, or null if the key
	   * does not match a calendar shortcut.
	   */
	  CalendarCtrl.prototype.getActionFromKeyEvent = function(event) {
	    var keyCode = this.keyCode;
	
	    switch (event.which) {
	      case keyCode.ENTER: return 'select';
	
	      case keyCode.RIGHT_ARROW: return 'move-right';
	      case keyCode.LEFT_ARROW: return 'move-left';
	
	      case keyCode.DOWN_ARROW: return event.metaKey ? 'move-page-down' : 'move-row-down';
	      case keyCode.UP_ARROW: return event.metaKey ? 'move-page-up' : 'move-row-up';
	
	      case keyCode.PAGE_DOWN: return 'move-page-down';
	      case keyCode.PAGE_UP: return 'move-page-up';
	
	      case keyCode.HOME: return 'start';
	      case keyCode.END: return 'end';
	
	      default: return null;
	    }
	  };
	
	  /**
	   * Handles a key event in the calendar with the appropriate action. The action will either
	   * be to select the focused date or to navigate to focus a new date.
	   * @param {KeyboardEvent} event
	   */
	  CalendarCtrl.prototype.handleKeyEvent = function(event) {
	    var self = this;
	
	    this.$scope.$apply(function() {
	      // Capture escape and emit back up so that a wrapping component
	      // (such as a date-picker) can decide to close.
	      if (event.which == self.keyCode.ESCAPE || event.which == self.keyCode.TAB) {
	        self.$scope.$emit('md-calendar-close');
	
	        if (event.which == self.keyCode.TAB) {
	          event.preventDefault();
	        }
	
	        return;
	      }
	
	      // Broadcast the action that any child controllers should take.
	      var action = self.getActionFromKeyEvent(event);
	      if (action) {
	        event.preventDefault();
	        event.stopPropagation();
	        self.$scope.$broadcast('md-calendar-parent-action', action);
	      }
	    });
	  };
	
	  /**
	   * Hides the vertical scrollbar on the calendar scroller of a child controller by
	   * setting the width on the calendar scroller and the `overflow: hidden` wrapper
	   * around the scroller, and then setting a padding-right on the scroller equal
	   * to the width of the browser's scrollbar.
	   *
	   * This will cause a reflow.
	   *
	   * @param {object} childCtrl The child controller whose scrollbar should be hidden.
	   */
	  CalendarCtrl.prototype.hideVerticalScrollbar = function(childCtrl) {
	    var self = this;
	    var element = childCtrl.$element[0];
	    var scrollMask = element.querySelector('.md-calendar-scroll-mask');
	
	    if (self.width > 0) {
	      setWidth();
	    } else {
	      self.$$rAF(function() {
	        var scroller = childCtrl.calendarScroller;
	
	        self.scrollbarWidth = scroller.offsetWidth - scroller.clientWidth;
	        self.width = element.querySelector('table').offsetWidth;
	        setWidth();
	      });
	    }
	
	    function setWidth() {
	      var width = self.width || FALLBACK_WIDTH;
	      var scrollbarWidth = self.scrollbarWidth;
	      var scroller = childCtrl.calendarScroller;
	
	      scrollMask.style.width = width + 'px';
	      scroller.style.width = (width + scrollbarWidth) + 'px';
	      scroller.style.paddingRight = scrollbarWidth + 'px';
	    }
	  };
	
	  /**
	   * Gets an identifier for a date unique to the calendar instance for internal
	   * purposes. Not to be displayed.
	   * @param {Date} date The date for which the id is being generated
	   * @param {string} namespace Namespace for the id. (month, year etc.)
	   * @returns {string}
	   */
	  CalendarCtrl.prototype.getDateId = function(date, namespace) {
	    if (!namespace) {
	      throw new Error('A namespace for the date id has to be specified.');
	    }
	
	    return [
	      'md',
	      this.id,
	      namespace,
	      date.getFullYear(),
	      date.getMonth(),
	      date.getDate()
	    ].join('-');
	  };
	
	  /**
	   * Util to trigger an extra digest on a parent scope, in order to to ensure that
	   * any child virtual repeaters have updated. This is necessary, because the virtual
	   * repeater doesn't update the $index the first time around since the content isn't
	   * in place yet. The case, in which this is an issue, is when the repeater has less
	   * than a page of content (e.g. a month or year view has a min or max date).
	   */
	  CalendarCtrl.prototype.updateVirtualRepeat = function() {
	    var scope = this.$scope;
	    var virtualRepeatResizeListener = scope.$on('$md-resize-enable', function() {
	      if (!scope.$$phase) {
	        scope.$apply();
	      }
	
	      virtualRepeatResizeListener();
	    });
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarMonthCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendarMonth', calendarDirective);
	
	  /**
	   * Height of one calendar month tbody. This must be made known to the virtual-repeat and is
	   * subsequently used for scrolling to specific months.
	   */
	  var TBODY_HEIGHT = 265;
	
	  /**
	   * Height of a calendar month with a single row. This is needed to calculate the offset for
	   * rendering an extra month in virtual-repeat that only contains one row.
	   */
	  var TBODY_SINGLE_ROW_HEIGHT = 45;
	
	  /** Private directive that represents a list of months inside the calendar. */
	  function calendarDirective() {
	    return {
	      template:
	        '<table aria-hidden="true" class="md-calendar-day-header"><thead></thead></table>' +
	        '<div class="md-calendar-scroll-mask">' +
	        '<md-virtual-repeat-container class="md-calendar-scroll-container" ' +
	              'md-offset-size="' + (TBODY_SINGLE_ROW_HEIGHT - TBODY_HEIGHT) + '">' +
	            '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
	              '<tbody ' +
	                  'md-calendar-month-body ' +
	                  'role="rowgroup" ' +
	                  'md-virtual-repeat="i in monthCtrl.items" ' +
	                  'md-month-offset="$index" ' +
	                  'class="md-calendar-month" ' +
	                  'md-start-index="monthCtrl.getSelectedMonthIndex()" ' +
	                  'md-item-size="' + TBODY_HEIGHT + '">' +
	
	                // The <tr> ensures that the <tbody> will always have the
	                // proper height, even if it's empty. If it's content is
	                // compiled, the <tr> will be overwritten.
	                '<tr aria-hidden="true" md-force-height="\'' + TBODY_HEIGHT + 'px\'"></tr>' +
	              '</tbody>' +
	            '</table>' +
	          '</md-virtual-repeat-container>' +
	        '</div>',
	      require: ['^^mdCalendar', 'mdCalendarMonth'],
	      controller: CalendarMonthCtrl,
	      controllerAs: 'monthCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var monthCtrl = controllers[1];
	        monthCtrl.initialize(calendarCtrl);
	      }
	    };
	  }
	
	  /**
	   * Controller for the calendar month component.
	   * @ngInject @constructor
	   */
	  function CalendarMonthCtrl($element, $scope, $animate, $q,
	    $$mdDateUtil, $mdDateLocale) {
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @final {!angular.$animate} */
	    this.$animate = $animate;
	
	    /** @final {!angular.$q} */
	    this.$q = $q;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @final {HTMLElement} */
	    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	
	    /** @type {boolean} */
	    this.isInitialized = false;
	
	    /** @type {boolean} */
	    this.isMonthTransitionInProgress = false;
	
	    var self = this;
	
	    /**
	     * Handles a click event on a date cell.
	     * Created here so that every cell can use the same function instance.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.cellClickHandler = function() {
	      var timestamp = $$mdDateUtil.getTimestampFromNode(this);
	      self.$scope.$apply(function() {
	        self.calendarCtrl.setNgModelValue(timestamp);
	      });
	    };
	
	    /**
	     * Handles click events on the month headers. Switches
	     * the calendar to the year view.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.headerClickHandler = function() {
	      self.calendarCtrl.setCurrentView('year', $$mdDateUtil.getTimestampFromNode(this));
	    };
	  }
	
	  /*** Initialization ***/
	
	  /**
	   * Initialize the controller by saving a reference to the calendar and
	   * setting up the object that will be iterated by the virtual repeater.
	   */
	  CalendarMonthCtrl.prototype.initialize = function(calendarCtrl) {
	    /**
	     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
	     * number of months that can be viewed. We add 2 months: one to include the current month
	     * and one for the last dummy month.
	     *
	     * This is shorter than ideal because of a (potential) Firefox bug
	     * https://bugzilla.mozilla.org/show_bug.cgi?id=1181658.
	     */
	
	    this.items = {
	      length: this.dateUtil.getMonthDistance(
	        calendarCtrl.firstRenderableDate,
	        calendarCtrl.lastRenderableDate
	      ) + 2
	    };
	
	    this.calendarCtrl = calendarCtrl;
	    this.attachScopeListeners();
	    calendarCtrl.updateVirtualRepeat();
	
	    // Fire the initial render, since we might have missed it the first time it fired.
	    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
	  };
	
	  /**
	   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
	   * @returns {number}
	   */
	  CalendarMonthCtrl.prototype.getSelectedMonthIndex = function() {
	    var calendarCtrl = this.calendarCtrl;
	
	    return this.dateUtil.getMonthDistance(
	      calendarCtrl.firstRenderableDate,
	      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
	    );
	  };
	
	  /**
	   * Change the date that is being shown in the calendar. If the given date is in a different
	   * month, the displayed month will be transitioned.
	   * @param {Date} date
	   */
	  CalendarMonthCtrl.prototype.changeDisplayDate = function(date) {
	    // Initialization is deferred until this function is called because we want to reflect
	    // the starting value of ngModel.
	    if (!this.isInitialized) {
	      this.buildWeekHeader();
	      this.calendarCtrl.hideVerticalScrollbar(this);
	      this.isInitialized = true;
	      return this.$q.when();
	    }
	
	    // If trying to show an invalid date or a transition is in progress, do nothing.
	    if (!this.dateUtil.isValidDate(date) || this.isMonthTransitionInProgress) {
	      return this.$q.when();
	    }
	
	    this.isMonthTransitionInProgress = true;
	    var animationPromise = this.animateDateChange(date);
	
	    this.calendarCtrl.displayDate = date;
	
	    var self = this;
	    animationPromise.then(function() {
	      self.isMonthTransitionInProgress = false;
	    });
	
	    return animationPromise;
	  };
	
	  /**
	   * Animates the transition from the calendar's current month to the given month.
	   * @param {Date} date
	   * @returns {angular.$q.Promise} The animation promise.
	   */
	  CalendarMonthCtrl.prototype.animateDateChange = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var monthDistance = this.dateUtil.getMonthDistance(this.calendarCtrl.firstRenderableDate, date);
	      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
	    }
	
	    return this.$q.when();
	  };
	
	  /**
	   * Builds and appends a day-of-the-week header to the calendar.
	   * This should only need to be called once during initialization.
	   */
	  CalendarMonthCtrl.prototype.buildWeekHeader = function() {
	    var firstDayOfWeek = this.dateLocale.firstDayOfWeek;
	    var shortDays = this.dateLocale.shortDays;
	
	    var row = document.createElement('tr');
	    for (var i = 0; i < 7; i++) {
	      var th = document.createElement('th');
	      th.textContent = shortDays[(i + firstDayOfWeek) % 7];
	      row.appendChild(th);
	    }
	
	    this.$element.find('thead').append(row);
	  };
	
	  /**
	   * Attaches listeners for the scope events that are broadcast by the calendar.
	   */
	  CalendarMonthCtrl.prototype.attachScopeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
	      self.calendarCtrl.changeSelectedDate(value);
	      self.changeDisplayDate(value);
	    });
	
	    self.$scope.$on('md-calendar-parent-action', angular.bind(this, this.handleKeyEvent));
	  };
	
	  /**
	   * Handles the month-specific keyboard interactions.
	   * @param {Object} event Scope event object passed by the calendar.
	   * @param {String} action Action, corresponding to the key that was pressed.
	   */
	  CalendarMonthCtrl.prototype.handleKeyEvent = function(event, action) {
	    var calendarCtrl = this.calendarCtrl;
	    var displayDate = calendarCtrl.displayDate;
	
	    if (action === 'select') {
	      calendarCtrl.setNgModelValue(displayDate);
	    } else {
	      var date = null;
	      var dateUtil = this.dateUtil;
	
	      switch (action) {
	        case 'move-right': date = dateUtil.incrementDays(displayDate, 1); break;
	        case 'move-left': date = dateUtil.incrementDays(displayDate, -1); break;
	
	        case 'move-page-down': date = dateUtil.incrementMonths(displayDate, 1); break;
	        case 'move-page-up': date = dateUtil.incrementMonths(displayDate, -1); break;
	
	        case 'move-row-down': date = dateUtil.incrementDays(displayDate, 7); break;
	        case 'move-row-up': date = dateUtil.incrementDays(displayDate, -7); break;
	
	        case 'start': date = dateUtil.getFirstDateOfMonth(displayDate); break;
	        case 'end': date = dateUtil.getLastDateOfMonth(displayDate); break;
	      }
	
	      if (date) {
	        date = this.dateUtil.clampDate(date, calendarCtrl.minDate, calendarCtrl.maxDate);
	
	        this.changeDisplayDate(date).then(function() {
	          calendarCtrl.focus(date);
	        });
	      }
	    }
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  mdCalendarMonthBodyDirective.$inject = ["$compile", "$$mdSvgRegistry"];
	  CalendarMonthBodyCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	      .directive('mdCalendarMonthBody', mdCalendarMonthBodyDirective);
	
	  /**
	   * Private directive consumed by md-calendar-month. Having this directive lets the calender use
	   * md-virtual-repeat and also cleanly separates the month DOM construction functions from
	   * the rest of the calendar controller logic.
	   * @ngInject
	   */
	  function mdCalendarMonthBodyDirective($compile, $$mdSvgRegistry) {
	    var ARROW_ICON = $compile('<md-icon md-svg-src="' +
	      $$mdSvgRegistry.mdTabsArrow + '"></md-icon>')({})[0];
	
	    return {
	      require: ['^^mdCalendar', '^^mdCalendarMonth', 'mdCalendarMonthBody'],
	      scope: { offset: '=mdMonthOffset' },
	      controller: CalendarMonthBodyCtrl,
	      controllerAs: 'mdMonthBodyCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var monthCtrl = controllers[1];
	        var monthBodyCtrl = controllers[2];
	
	        monthBodyCtrl.calendarCtrl = calendarCtrl;
	        monthBodyCtrl.monthCtrl = monthCtrl;
	        monthBodyCtrl.arrowIcon = ARROW_ICON.cloneNode(true);
	
	        // The virtual-repeat re-uses the same DOM elements, so there are only a limited number
	        // of repeated items that are linked, and then those elements have their bindings updated.
	        // Since the months are not generated by bindings, we simply regenerate the entire thing
	        // when the binding (offset) changes.
	        scope.$watch(function() { return monthBodyCtrl.offset; }, function(offset) {
	          if (angular.isNumber(offset)) {
	            monthBodyCtrl.generateContent();
	          }
	        });
	      }
	    };
	  }
	
	  /**
	   * Controller for a single calendar month.
	   * @ngInject @constructor
	   */
	  function CalendarMonthBodyCtrl($element, $$mdDateUtil, $mdDateLocale) {
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @type {Object} Reference to the month view. */
	    this.monthCtrl = null;
	
	    /** @type {Object} Reference to the calendar. */
	    this.calendarCtrl = null;
	
	    /**
	     * Number of months from the start of the month "items" that the currently rendered month
	     * occurs. Set via angular data binding.
	     * @type {number}
	     */
	    this.offset = null;
	
	    /**
	     * Date cell to focus after appending the month to the document.
	     * @type {HTMLElement}
	     */
	    this.focusAfterAppend = null;
	  }
	
	  /** Generate and append the content for this month to the directive element. */
	  CalendarMonthBodyCtrl.prototype.generateContent = function() {
	    var date = this.dateUtil.incrementMonths(this.calendarCtrl.firstRenderableDate, this.offset);
	
	    this.$element
	      .empty()
	      .append(this.buildCalendarForMonth(date));
	
	    if (this.focusAfterAppend) {
	      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
	      this.focusAfterAppend.focus();
	      this.focusAfterAppend = null;
	    }
	  };
	
	  /**
	   * Creates a single cell to contain a date in the calendar with all appropriate
	   * attributes and classes added. If a date is given, the cell content will be set
	   * based on the date.
	   * @param {Date=} opt_date
	   * @returns {HTMLElement}
	   */
	  CalendarMonthBodyCtrl.prototype.buildDateCell = function(opt_date) {
	    var monthCtrl = this.monthCtrl;
	    var calendarCtrl = this.calendarCtrl;
	
	    // TODO(jelbourn): cloneNode is likely a faster way of doing this.
	    var cell = document.createElement('td');
	    cell.tabIndex = -1;
	    cell.classList.add('md-calendar-date');
	    cell.setAttribute('role', 'gridcell');
	
	    if (opt_date) {
	      cell.setAttribute('tabindex', '-1');
	      cell.setAttribute('aria-label', this.dateLocale.longDateFormatter(opt_date));
	      cell.id = calendarCtrl.getDateId(opt_date, 'month');
	
	      // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
	      cell.setAttribute('data-timestamp', opt_date.getTime());
	
	      // TODO(jelourn): Doing these comparisons for class addition during generation might be slow.
	      // It may be better to finish the construction and then query the node and add the class.
	      if (this.dateUtil.isSameDay(opt_date, calendarCtrl.today)) {
	        cell.classList.add(calendarCtrl.TODAY_CLASS);
	      }
	
	      if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
	          this.dateUtil.isSameDay(opt_date, calendarCtrl.selectedDate)) {
	        cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
	        cell.setAttribute('aria-selected', 'true');
	      }
	
	      var cellText = this.dateLocale.dates[opt_date.getDate()];
	
	      if (this.isDateEnabled(opt_date)) {
	        // Add a indicator for select, hover, and focus states.
	        var selectionIndicator = document.createElement('span');
	        selectionIndicator.classList.add('md-calendar-date-selection-indicator');
	        selectionIndicator.textContent = cellText;
	        cell.appendChild(selectionIndicator);
	        cell.addEventListener('click', monthCtrl.cellClickHandler);
	
	        if (calendarCtrl.displayDate && this.dateUtil.isSameDay(opt_date, calendarCtrl.displayDate)) {
	          this.focusAfterAppend = cell;
	        }
	      } else {
	        cell.classList.add('md-calendar-date-disabled');
	        cell.textContent = cellText;
	      }
	    }
	
	    return cell;
	  };
	
	  /**
	   * Check whether date is in range and enabled
	   * @param {Date=} opt_date
	   * @return {boolean} Whether the date is enabled.
	   */
	  CalendarMonthBodyCtrl.prototype.isDateEnabled = function(opt_date) {
	    return this.dateUtil.isDateWithinRange(opt_date,
	          this.calendarCtrl.minDate, this.calendarCtrl.maxDate) &&
	          (!angular.isFunction(this.calendarCtrl.dateFilter)
	           || this.calendarCtrl.dateFilter(opt_date));
	  };
	
	  /**
	   * Builds a `tr` element for the calendar grid.
	   * @param rowNumber The week number within the month.
	   * @returns {HTMLElement}
	   */
	  CalendarMonthBodyCtrl.prototype.buildDateRow = function(rowNumber) {
	    var row = document.createElement('tr');
	    row.setAttribute('role', 'row');
	
	    // Because of an NVDA bug (with Firefox), the row needs an aria-label in order
	    // to prevent the entire row being read aloud when the user moves between rows.
	    // See http://community.nvda-project.org/ticket/4643.
	    row.setAttribute('aria-label', this.dateLocale.weekNumberFormatter(rowNumber));
	
	    return row;
	  };
	
	  /**
	   * Builds the <tbody> content for the given date's month.
	   * @param {Date=} opt_dateInMonth
	   * @returns {DocumentFragment} A document fragment containing the <tr> elements.
	   */
	  CalendarMonthBodyCtrl.prototype.buildCalendarForMonth = function(opt_dateInMonth) {
	    var date = this.dateUtil.isValidDate(opt_dateInMonth) ? opt_dateInMonth : new Date();
	
	    var firstDayOfMonth = this.dateUtil.getFirstDateOfMonth(date);
	    var firstDayOfTheWeek = this.getLocaleDay_(firstDayOfMonth);
	    var numberOfDaysInMonth = this.dateUtil.getNumberOfDaysInMonth(date);
	
	    // Store rows for the month in a document fragment so that we can append them all at once.
	    var monthBody = document.createDocumentFragment();
	
	    var rowNumber = 1;
	    var row = this.buildDateRow(rowNumber);
	    monthBody.appendChild(row);
	
	    // If this is the final month in the list of items, only the first week should render,
	    // so we should return immediately after the first row is complete and has been
	    // attached to the body.
	    var isFinalMonth = this.offset === this.monthCtrl.items.length - 1;
	
	    // Add a label for the month. If the month starts on a Sun/Mon/Tues, the month label
	    // goes on a row above the first of the month. Otherwise, the month label takes up the first
	    // two cells of the first row.
	    var blankCellOffset = 0;
	    var monthLabelCell = document.createElement('td');
	    var monthLabelCellContent = document.createElement('span');
	    var calendarCtrl = this.calendarCtrl;
	
	    monthLabelCellContent.textContent = this.dateLocale.monthHeaderFormatter(date);
	    monthLabelCell.appendChild(monthLabelCellContent);
	    monthLabelCell.classList.add('md-calendar-month-label');
	    // If the entire month is after the max date, render the label as a disabled state.
	    if (calendarCtrl.maxDate && firstDayOfMonth > calendarCtrl.maxDate) {
	      monthLabelCell.classList.add('md-calendar-month-label-disabled');
	    // If the user isn't supposed to be able to change views, render the
	    // label as usual, but disable the clicking functionality.
	    } else if (!calendarCtrl.mode) {
	      monthLabelCell.addEventListener('click', this.monthCtrl.headerClickHandler);
	      monthLabelCell.setAttribute('data-timestamp', firstDayOfMonth.getTime());
	      monthLabelCell.setAttribute('aria-label', this.dateLocale.monthFormatter(date));
	      monthLabelCell.classList.add('md-calendar-label-clickable');
	      monthLabelCell.appendChild(this.arrowIcon.cloneNode(true));
	    }
	
	    if (firstDayOfTheWeek <= 2) {
	      monthLabelCell.setAttribute('colspan', '7');
	
	      var monthLabelRow = this.buildDateRow();
	      monthLabelRow.appendChild(monthLabelCell);
	      monthBody.insertBefore(monthLabelRow, row);
	
	      if (isFinalMonth) {
	        return monthBody;
	      }
	    } else {
	      blankCellOffset = 3;
	      monthLabelCell.setAttribute('colspan', '3');
	      row.appendChild(monthLabelCell);
	    }
	
	    // Add a blank cell for each day of the week that occurs before the first of the month.
	    // For example, if the first day of the month is a Tuesday, add blank cells for Sun and Mon.
	    // The blankCellOffset is needed in cases where the first N cells are used by the month label.
	    for (var i = blankCellOffset; i < firstDayOfTheWeek; i++) {
	      row.appendChild(this.buildDateCell());
	    }
	
	    // Add a cell for each day of the month, keeping track of the day of the week so that
	    // we know when to start a new row.
	    var dayOfWeek = firstDayOfTheWeek;
	    var iterationDate = firstDayOfMonth;
	    for (var d = 1; d <= numberOfDaysInMonth; d++) {
	      // If we've reached the end of the week, start a new row.
	      if (dayOfWeek === 7) {
	        // We've finished the first row, so we're done if this is the final month.
	        if (isFinalMonth) {
	          return monthBody;
	        }
	        dayOfWeek = 0;
	        rowNumber++;
	        row = this.buildDateRow(rowNumber);
	        monthBody.appendChild(row);
	      }
	
	      iterationDate.setDate(d);
	      var cell = this.buildDateCell(iterationDate);
	      row.appendChild(cell);
	
	      dayOfWeek++;
	    }
	
	    // Ensure that the last row of the month has 7 cells.
	    while (row.childNodes.length < 7) {
	      row.appendChild(this.buildDateCell());
	    }
	
	    // Ensure that all months have 6 rows. This is necessary for now because the virtual-repeat
	    // requires that all items have exactly the same height.
	    while (monthBody.childNodes.length < 6) {
	      var whitespaceRow = this.buildDateRow();
	      for (var j = 0; j < 7; j++) {
	        whitespaceRow.appendChild(this.buildDateCell());
	      }
	      monthBody.appendChild(whitespaceRow);
	    }
	
	    return monthBody;
	  };
	
	  /**
	   * Gets the day-of-the-week index for a date for the current locale.
	   * @private
	   * @param {Date} date
	   * @returns {number} The column index of the date in the calendar.
	   */
	  CalendarMonthBodyCtrl.prototype.getLocaleDay_ = function(date) {
	    return (date.getDay() + (7 - this.dateLocale.firstDayOfWeek)) % 7;
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarYearCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil", "$mdUtil"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendarYear', calendarDirective);
	
	  /**
	   * Height of one calendar year tbody. This must be made known to the virtual-repeat and is
	   * subsequently used for scrolling to specific years.
	   */
	  var TBODY_HEIGHT = 88;
	
	  /** Private component, representing a list of years in the calendar. */
	  function calendarDirective() {
	    return {
	      template:
	        '<div class="md-calendar-scroll-mask">' +
	          '<md-virtual-repeat-container class="md-calendar-scroll-container">' +
	            '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
	              '<tbody ' +
	                  'md-calendar-year-body ' +
	                  'role="rowgroup" ' +
	                  'md-virtual-repeat="i in yearCtrl.items" ' +
	                  'md-year-offset="$index" class="md-calendar-year" ' +
	                  'md-start-index="yearCtrl.getFocusedYearIndex()" ' +
	                  'md-item-size="' + TBODY_HEIGHT + '">' +
	                // The <tr> ensures that the <tbody> will have the proper
	                // height, even though it may be empty.
	                '<tr aria-hidden="true" md-force-height="\'' + TBODY_HEIGHT + 'px\'"></tr>' +
	              '</tbody>' +
	            '</table>' +
	          '</md-virtual-repeat-container>' +
	        '</div>',
	      require: ['^^mdCalendar', 'mdCalendarYear'],
	      controller: CalendarYearCtrl,
	      controllerAs: 'yearCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var yearCtrl = controllers[1];
	        yearCtrl.initialize(calendarCtrl);
	      }
	    };
	  }
	
	  /**
	   * Controller for the mdCalendar component.
	   * @ngInject @constructor
	   */
	  function CalendarYearCtrl($element, $scope, $animate, $q,
	    $$mdDateUtil, $mdUtil) {
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @final {!angular.$animate} */
	    this.$animate = $animate;
	
	    /** @final {!angular.$q} */
	    this.$q = $q;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final {HTMLElement} */
	    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	
	    /** @type {boolean} */
	    this.isInitialized = false;
	
	    /** @type {boolean} */
	    this.isMonthTransitionInProgress = false;
	
	    /** @final */
	    this.$mdUtil = $mdUtil;
	
	    var self = this;
	
	    /**
	     * Handles a click event on a date cell.
	     * Created here so that every cell can use the same function instance.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.cellClickHandler = function() {
	      self.onTimestampSelected($$mdDateUtil.getTimestampFromNode(this));
	    };
	  }
	
	  /**
	   * Initialize the controller by saving a reference to the calendar and
	   * setting up the object that will be iterated by the virtual repeater.
	   */
	  CalendarYearCtrl.prototype.initialize = function(calendarCtrl) {
	    /**
	     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
	     * number of years that can be viewed. We add 1 extra in order to include the current year.
	     */
	
	    this.items = {
	      length: this.dateUtil.getYearDistance(
	        calendarCtrl.firstRenderableDate,
	        calendarCtrl.lastRenderableDate
	      ) + 1
	    };
	
	    this.calendarCtrl = calendarCtrl;
	    this.attachScopeListeners();
	    calendarCtrl.updateVirtualRepeat();
	
	    // Fire the initial render, since we might have missed it the first time it fired.
	    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
	  };
	
	  /**
	   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
	   * @returns {number}
	   */
	  CalendarYearCtrl.prototype.getFocusedYearIndex = function() {
	    var calendarCtrl = this.calendarCtrl;
	
	    return this.dateUtil.getYearDistance(
	      calendarCtrl.firstRenderableDate,
	      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
	    );
	  };
	
	  /**
	   * Change the date that is highlighted in the calendar.
	   * @param {Date} date
	   */
	  CalendarYearCtrl.prototype.changeDate = function(date) {
	    // Initialization is deferred until this function is called because we want to reflect
	    // the starting value of ngModel.
	    if (!this.isInitialized) {
	      this.calendarCtrl.hideVerticalScrollbar(this);
	      this.isInitialized = true;
	      return this.$q.when();
	    } else if (this.dateUtil.isValidDate(date) && !this.isMonthTransitionInProgress) {
	      var self = this;
	      var animationPromise = this.animateDateChange(date);
	
	      self.isMonthTransitionInProgress = true;
	      self.calendarCtrl.displayDate = date;
	
	      return animationPromise.then(function() {
	        self.isMonthTransitionInProgress = false;
	      });
	    }
	  };
	
	  /**
	   * Animates the transition from the calendar's current month to the given month.
	   * @param {Date} date
	   * @returns {angular.$q.Promise} The animation promise.
	   */
	  CalendarYearCtrl.prototype.animateDateChange = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var monthDistance = this.dateUtil.getYearDistance(this.calendarCtrl.firstRenderableDate, date);
	      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
	    }
	
	    return this.$q.when();
	  };
	
	  /**
	   * Handles the year-view-specific keyboard interactions.
	   * @param {Object} event Scope event object passed by the calendar.
	   * @param {String} action Action, corresponding to the key that was pressed.
	   */
	  CalendarYearCtrl.prototype.handleKeyEvent = function(event, action) {
	    var self = this;
	    var calendarCtrl = self.calendarCtrl;
	    var displayDate = calendarCtrl.displayDate;
	
	    if (action === 'select') {
	      self.changeDate(displayDate).then(function() {
	        self.onTimestampSelected(displayDate);
	      });
	    } else {
	      var date = null;
	      var dateUtil = self.dateUtil;
	
	      switch (action) {
	        case 'move-right': date = dateUtil.incrementMonths(displayDate, 1); break;
	        case 'move-left': date = dateUtil.incrementMonths(displayDate, -1); break;
	
	        case 'move-row-down': date = dateUtil.incrementMonths(displayDate, 6); break;
	        case 'move-row-up': date = dateUtil.incrementMonths(displayDate, -6); break;
	      }
	
	      if (date) {
	        var min = calendarCtrl.minDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.minDate) : null;
	        var max = calendarCtrl.maxDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.maxDate) : null;
	        date = dateUtil.getFirstDateOfMonth(self.dateUtil.clampDate(date, min, max));
	
	        self.changeDate(date).then(function() {
	          calendarCtrl.focus(date);
	        });
	      }
	    }
	  };
	
	  /**
	   * Attaches listeners for the scope events that are broadcast by the calendar.
	   */
	  CalendarYearCtrl.prototype.attachScopeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
	      self.calendarCtrl.changeSelectedDate(value ? self.dateUtil.getFirstDateOfMonth(value) : value);
	      self.changeDate(value);
	    });
	
	    self.$scope.$on('md-calendar-parent-action', angular.bind(self, self.handleKeyEvent));
	  };
	
	  /**
	   * Handles the behavior when a date is selected. Depending on the `mode`
	   * of the calendar, this can either switch back to the calendar view or
	   * set the model value.
	   * @param {number} timestamp The selected timestamp.
	   */
	  CalendarYearCtrl.prototype.onTimestampSelected = function(timestamp) {
	    var calendarCtrl = this.calendarCtrl;
	
	    if (calendarCtrl.mode) {
	      this.$mdUtil.nextTick(function() {
	        calendarCtrl.setNgModelValue(timestamp);
	      });
	    } else {
	      calendarCtrl.setCurrentView('month', timestamp);
	    }
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarYearBodyCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	      .directive('mdCalendarYearBody', mdCalendarYearDirective);
	
	  /**
	   * Private component, consumed by the md-calendar-year, which separates the DOM construction logic
	   * and allows for the year view to use md-virtual-repeat.
	   */
	  function mdCalendarYearDirective() {
	    return {
	      require: ['^^mdCalendar', '^^mdCalendarYear', 'mdCalendarYearBody'],
	      scope: { offset: '=mdYearOffset' },
	      controller: CalendarYearBodyCtrl,
	      controllerAs: 'mdYearBodyCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var yearCtrl = controllers[1];
	        var yearBodyCtrl = controllers[2];
	
	        yearBodyCtrl.calendarCtrl = calendarCtrl;
	        yearBodyCtrl.yearCtrl = yearCtrl;
	
	        scope.$watch(function() { return yearBodyCtrl.offset; }, function(offset) {
	          if (angular.isNumber(offset)) {
	            yearBodyCtrl.generateContent();
	          }
	        });
	      }
	    };
	  }
	
	  /**
	   * Controller for a single year.
	   * @ngInject @constructor
	   */
	  function CalendarYearBodyCtrl($element, $$mdDateUtil, $mdDateLocale) {
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @type {Object} Reference to the calendar. */
	    this.calendarCtrl = null;
	
	    /** @type {Object} Reference to the year view. */
	    this.yearCtrl = null;
	
	    /**
	     * Number of months from the start of the month "items" that the currently rendered month
	     * occurs. Set via angular data binding.
	     * @type {number}
	     */
	    this.offset = null;
	
	    /**
	     * Date cell to focus after appending the month to the document.
	     * @type {HTMLElement}
	     */
	    this.focusAfterAppend = null;
	  }
	
	  /** Generate and append the content for this year to the directive element. */
	  CalendarYearBodyCtrl.prototype.generateContent = function() {
	    var date = this.dateUtil.incrementYears(this.calendarCtrl.firstRenderableDate, this.offset);
	
	    this.$element
	      .empty()
	      .append(this.buildCalendarForYear(date));
	
	    if (this.focusAfterAppend) {
	      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
	      this.focusAfterAppend.focus();
	      this.focusAfterAppend = null;
	    }
	  };
	
	  /**
	   * Creates a single cell to contain a year in the calendar.
	   * @param {number} opt_year Four-digit year.
	   * @param {number} opt_month Zero-indexed month.
	   * @returns {HTMLElement}
	   */
	  CalendarYearBodyCtrl.prototype.buildMonthCell = function(year, month) {
	    var calendarCtrl = this.calendarCtrl;
	    var yearCtrl = this.yearCtrl;
	    var cell = this.buildBlankCell();
	
	    // Represent this month/year as a date.
	    var firstOfMonth = new Date(year, month, 1);
	    cell.setAttribute('aria-label', this.dateLocale.monthFormatter(firstOfMonth));
	    cell.id = calendarCtrl.getDateId(firstOfMonth, 'year');
	
	    // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
	    cell.setAttribute('data-timestamp', firstOfMonth.getTime());
	
	    if (this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.today)) {
	      cell.classList.add(calendarCtrl.TODAY_CLASS);
	    }
	
	    if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
	        this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.selectedDate)) {
	      cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
	      cell.setAttribute('aria-selected', 'true');
	    }
	
	    var cellText = this.dateLocale.shortMonths[month];
	
	    if (this.dateUtil.isMonthWithinRange(firstOfMonth,
	        calendarCtrl.minDate, calendarCtrl.maxDate)) {
	      var selectionIndicator = document.createElement('span');
	      selectionIndicator.classList.add('md-calendar-date-selection-indicator');
	      selectionIndicator.textContent = cellText;
	      cell.appendChild(selectionIndicator);
	      cell.addEventListener('click', yearCtrl.cellClickHandler);
	
	      if (calendarCtrl.displayDate && this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.displayDate)) {
	        this.focusAfterAppend = cell;
	      }
	    } else {
	      cell.classList.add('md-calendar-date-disabled');
	      cell.textContent = cellText;
	    }
	
	    return cell;
	  };
	
	  /**
	   * Builds a blank cell.
	   * @return {HTMLTableCellElement}
	   */
	  CalendarYearBodyCtrl.prototype.buildBlankCell = function() {
	    var cell = document.createElement('td');
	    cell.tabIndex = -1;
	    cell.classList.add('md-calendar-date');
	    cell.setAttribute('role', 'gridcell');
	
	    cell.setAttribute('tabindex', '-1');
	    return cell;
	  };
	
	  /**
	   * Builds the <tbody> content for the given year.
	   * @param {Date} date Date for which the content should be built.
	   * @returns {DocumentFragment} A document fragment containing the months within the year.
	   */
	  CalendarYearBodyCtrl.prototype.buildCalendarForYear = function(date) {
	    // Store rows for the month in a document fragment so that we can append them all at once.
	    var year = date.getFullYear();
	    var yearBody = document.createDocumentFragment();
	
	    var monthCell, i;
	    // First row contains label and Jan-Jun.
	    var firstRow = document.createElement('tr');
	    var labelCell = document.createElement('td');
	    labelCell.className = 'md-calendar-month-label';
	    labelCell.textContent = year;
	    firstRow.appendChild(labelCell);
	
	    for (i = 0; i < 6; i++) {
	      firstRow.appendChild(this.buildMonthCell(year, i));
	    }
	    yearBody.appendChild(firstRow);
	
	    // Second row contains a blank cell and Jul-Dec.
	    var secondRow = document.createElement('tr');
	    secondRow.appendChild(this.buildBlankCell());
	    for (i = 6; i < 12; i++) {
	      secondRow.appendChild(this.buildMonthCell(year, i));
	    }
	    yearBody.appendChild(secondRow);
	
	    return yearBody;
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdDateLocaleProvider
	   * @module material.components.datepicker
	   *
	   * @description
	   * The `$mdDateLocaleProvider` is the provider that creates the `$mdDateLocale` service.
	   * This provider that allows the user to specify messages, formatters, and parsers for date
	   * internationalization. The `$mdDateLocale` service itself is consumed by AngularJS Material
	   * components that deal with dates (i.e. {@link api/directive/mdDatepicker mdDatepicker}).
	   *
	   * @property {Array<string>} months Array of month names (in order).
	   * @property {Array<string>} shortMonths Array of abbreviated month names.
	   * @property {Array<string>} days Array of the days of the week (in order).
	   * @property {Array<string>} shortDays Array of abbreviated days of the week.
	   * @property {Array<string>} dates Array of dates of the month. Only necessary for locales
	   *  using a numeral system other than [1, 2, 3...].
	   * @property {Array<string>} firstDayOfWeek The first day of the week. Sunday = 0, Monday = 1,
	   *  etc.
	   * @property {function(string): Date} parseDate Function that converts a date string to a Date
	   *  object (the date portion).
	   * @property {function(Date, string): string} formatDate Function to format a date object to a
	   *  string. The datepicker directive also provides the time zone, if it was specified.
	   * @property {function(Date): string} monthHeaderFormatter Function that returns the label for
	   *  a month given a date.
	   * @property {function(Date): string} monthFormatter Function that returns the full name of a month
	   *  for a given date.
	   * @property {function(number): string} weekNumberFormatter Function that returns a label for
	   *  a week given the week number.
	   * @property {function(Date): string} longDateFormatter Function that formats a date into a long
	   *  `aria-label` that is read by the screen reader when the focused date changes.
	   * @property {string} msgCalendar Translation of the label "Calendar" for the current locale.
	   * @property {string} msgOpenCalendar Translation of the button label "Open calendar" for the
	   *  current locale.
	   * @property {Date} firstRenderableDate The date from which the datepicker calendar will begin
	   *  rendering. Note that this will be ignored if a minimum date is set.
	   *  Defaults to January 1st 1880.
	   * @property {Date} lastRenderableDate The last date that will be rendered by the datepicker
	   *  calendar. Note that this will be ignored if a maximum date is set.
	   *  Defaults to January 1st 2130.
	   * @property {function(string): boolean} isDateComplete Function to determine whether a string
	   *  makes sense to be parsed to a `Date` object. Returns `true` if the date appears to be complete
	   *  and parsing should occur. By default, this checks for 3 groups of text or numbers separated
	   *  by delimiters. This means that by default, date strings must include a month, day, and year
	   *  to be parsed and for the model to be updated.
	   *
	   * @usage
	   * <hljs lang="js">
	   * myAppModule.config(function($mdDateLocaleProvider) {
	   *
	   *     // Example of a French localization.
	   *     $mdDateLocaleProvider.months = ['janvier', 'février', 'mars', ...];
	   *     $mdDateLocaleProvider.shortMonths = ['janv', 'févr', 'mars', ...];
	   *     $mdDateLocaleProvider.days = ['dimanche', 'lundi', 'mardi', ...];
	   *     $mdDateLocaleProvider.shortDays = ['Di', 'Lu', 'Ma', ...];
	   *
	   *     // Can change week display to start on Monday.
	   *     $mdDateLocaleProvider.firstDayOfWeek = 1;
	   *
	   *     // Optional.
	   *     $mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, ...];
	   *
	   *     // Example uses moment.js to parse and format dates.
	   *     $mdDateLocaleProvider.parseDate = function(dateString) {
	   *       var m = moment(dateString, 'L', true);
	   *       return m.isValid() ? m.toDate() : new Date(NaN);
	   *     };
	   *
	   *     $mdDateLocaleProvider.formatDate = function(date) {
	   *       var m = moment(date);
	   *       return m.isValid() ? m.format('L') : '';
	   *     };
	   *
	   *     // Allow only a day and month to be specified.
	   *     // This is required if using the 'M/D' format with moment.js.
	   *     $mdDateLocaleProvider.isDateComplete = function(dateString) {
	   *       dateString = dateString.trim();
	   *
	   *       // Look for two chunks of content (either numbers or text) separated by delimiters.
	   *       var re = /^(([a-zA-Z]{3,}|[0-9]{1,4})([ .,]+|[/-]))([a-zA-Z]{3,}|[0-9]{1,4})/;
	   *       return re.test(dateString);
	   *     };
	   *
	   *     $mdDateLocaleProvider.monthHeaderFormatter = function(date) {
	   *       return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
	   *     };
	   *
	   *     // In addition to date display, date components also need localized messages
	   *     // for aria-labels for screen-reader users.
	   *
	   *     $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
	   *       return 'Semaine ' + weekNumber;
	   *     };
	   *
	   *     $mdDateLocaleProvider.msgCalendar = 'Calendrier';
	   *     $mdDateLocaleProvider.msgOpenCalendar = 'Ouvrir le calendrier';
	   *
	   *     // You can also set when your calendar begins and ends.
	   *     $mdDateLocaleProvider.firstRenderableDate = new Date(1776, 6, 4);
	   *     $mdDateLocaleProvider.lastRenderableDate = new Date(2012, 11, 21);
	   * });
	   * </hljs>
	   *
	   */
	  angular.module('material.components.datepicker').config(["$provide", function($provide) {
	    // TODO(jelbourn): Assert provided values are correctly formatted. Need assertions.
	
	    /** @constructor */
	    function DateLocaleProvider() {
	      /** Array of full month names. E.g., ['January', 'February', ...] */
	      this.months = null;
	
	      /** Array of abbreviated month names. E.g., ['Jan', 'Feb', ...] */
	      this.shortMonths = null;
	
	      /** Array of full day of the week names. E.g., ['Monday', 'Tuesday', ...] */
	      this.days = null;
	
	      /** Array of abbreviated dat of the week names. E.g., ['M', 'T', ...] */
	      this.shortDays = null;
	
	      /** Array of dates of a month (1 - 31). Characters might be different in some locales. */
	      this.dates = null;
	
	      /** Index of the first day of the week. 0 = Sunday, 1 = Monday, etc. */
	      this.firstDayOfWeek = 0;
	
	      /**
	       * Function that converts the date portion of a Date to a string.
	       * @type {(function(Date): string)}
	       */
	      this.formatDate = null;
	
	      /**
	       * Function that converts a date string to a Date object (the date portion)
	       * @type {function(string): Date}
	       */
	      this.parseDate = null;
	
	      /**
	       * Function that formats a Date into a month header string.
	       * @type {function(Date): string}
	       */
	      this.monthHeaderFormatter = null;
	
	      /**
	       * Function that formats a week number into a label for the week.
	       * @type {function(number): string}
	       */
	      this.weekNumberFormatter = null;
	
	      /**
	       * Function that formats a date into a long aria-label that is read
	       * when the focused date changes.
	       * @type {function(Date): string}
	       */
	      this.longDateFormatter = null;
	
	      /**
	       * Function to determine whether a string makes sense to be
	       * parsed to a Date object.
	       * @type {function(string): boolean}
	       */
	      this.isDateComplete = null;
	
	      /**
	       * ARIA label for the calendar "dialog" used in the datepicker.
	       * @type {string}
	       */
	      this.msgCalendar = '';
	
	      /**
	       * ARIA label for the datepicker's "Open calendar" buttons.
	       * @type {string}
	       */
	      this.msgOpenCalendar = '';
	    }
	
	    /**
	     * Factory function that returns an instance of the dateLocale service.
	     * @ngInject
	     * @param $locale
	     * @returns {DateLocale}
	     */
	    DateLocaleProvider.prototype.$get = function($locale, $filter) {
	      /**
	       * Default date-to-string formatting function.
	       * @param {!Date} date
	       * @param {string=} timezone
	       * @returns {string}
	       */
	      function defaultFormatDate(date, timezone) {
	        if (!date) {
	          return '';
	        }
	
	        // All of the dates created through ng-material *should* be set to midnight.
	        // If we encounter a date where the localeTime shows at 11pm instead of midnight,
	        // we have run into an issue with DST where we need to increment the hour by one:
	        // var d = new Date(1992, 9, 8, 0, 0, 0);
	        // d.toLocaleString(); // == "10/7/1992, 11:00:00 PM"
	        var localeTime = date.toLocaleTimeString();
	        var formatDate = date;
	        if (date.getHours() === 0 &&
	            (localeTime.indexOf('11:') !== -1 || localeTime.indexOf('23:') !== -1)) {
	          formatDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 1, 0, 0);
	        }
	
	        return $filter('date')(formatDate, 'M/d/yyyy', timezone);
	      }
	
	      /**
	       * Default string-to-date parsing function.
	       * @param {string} dateString
	       * @returns {!Date}
	       */
	      function defaultParseDate(dateString) {
	        return new Date(dateString);
	      }
	
	      /**
	       * Default function to determine whether a string makes sense to be
	       * parsed to a Date object.
	       *
	       * This is very permissive and is just a basic sanity check to ensure that
	       * things like single integers aren't able to be parsed into dates.
	       * @param {string} dateString
	       * @returns {boolean}
	       */
	      function defaultIsDateComplete(dateString) {
	        dateString = dateString.trim();
	
	        // Looks for three chunks of content (either numbers or text) separated
	        // by delimiters.
	        var re = /^(([a-zA-Z]{3,}|[0-9]{1,4})([ .,]+|[/-])){2}([a-zA-Z]{3,}|[0-9]{1,4})$/;
	        return re.test(dateString);
	      }
	
	      /**
	       * Default date-to-string formatter to get a month header.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultMonthHeaderFormatter(date) {
	        return service.shortMonths[date.getMonth()] + ' ' + date.getFullYear();
	      }
	
	      /**
	       * Default formatter for a month.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultMonthFormatter(date) {
	        return service.months[date.getMonth()] + ' ' + date.getFullYear();
	      }
	
	      /**
	       * Default week number formatter.
	       * @param number
	       * @returns {string}
	       */
	      function defaultWeekNumberFormatter(number) {
	        return 'Week ' + number;
	      }
	
	      /**
	       * Default formatter for date cell aria-labels.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultLongDateFormatter(date) {
	        // Example: 'Thursday June 18 2015'
	        return [
	          service.days[date.getDay()],
	          service.months[date.getMonth()],
	          service.dates[date.getDate()],
	          date.getFullYear()
	        ].join(' ');
	      }
	
	      // The default "short" day strings are the first character of each day,
	      // e.g., "Monday" => "M".
	      var defaultShortDays = $locale.DATETIME_FORMATS.SHORTDAY.map(function(day) {
	        return day.substring(0, 1);
	      });
	
	      // The default dates are simply the numbers 1 through 31.
	      var defaultDates = Array(32);
	      for (var i = 1; i <= 31; i++) {
	        defaultDates[i] = i;
	      }
	
	      // Default ARIA messages are in English (US).
	      var defaultMsgCalendar = 'Calendar';
	      var defaultMsgOpenCalendar = 'Open calendar';
	
	      // Default start/end dates that are rendered in the calendar.
	      var defaultFirstRenderableDate = new Date(1880, 0, 1);
	      var defaultLastRendereableDate = new Date(defaultFirstRenderableDate.getFullYear() + 250, 0, 1);
	
	      var service = {
	        months: this.months || $locale.DATETIME_FORMATS.MONTH,
	        shortMonths: this.shortMonths || $locale.DATETIME_FORMATS.SHORTMONTH,
	        days: this.days || $locale.DATETIME_FORMATS.DAY,
	        shortDays: this.shortDays || defaultShortDays,
	        dates: this.dates || defaultDates,
	        firstDayOfWeek: this.firstDayOfWeek || 0,
	        formatDate: this.formatDate || defaultFormatDate,
	        parseDate: this.parseDate || defaultParseDate,
	        isDateComplete: this.isDateComplete || defaultIsDateComplete,
	        monthHeaderFormatter: this.monthHeaderFormatter || defaultMonthHeaderFormatter,
	        monthFormatter: this.monthFormatter || defaultMonthFormatter,
	        weekNumberFormatter: this.weekNumberFormatter || defaultWeekNumberFormatter,
	        longDateFormatter: this.longDateFormatter || defaultLongDateFormatter,
	        msgCalendar: this.msgCalendar || defaultMsgCalendar,
	        msgOpenCalendar: this.msgOpenCalendar || defaultMsgOpenCalendar,
	        firstRenderableDate: this.firstRenderableDate || defaultFirstRenderableDate,
	        lastRenderableDate: this.lastRenderableDate || defaultLastRendereableDate
	      };
	
	      return service;
	    };
	    DateLocaleProvider.prototype.$get.$inject = ["$locale", "$filter"];
	
	    $provide.provider('$mdDateLocale', new DateLocaleProvider());
	  }]);
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * Utility for performing date calculations to facilitate operation of the calendar and
	   * datepicker.
	   */
	  angular.module('material.components.datepicker').factory('$$mdDateUtil', function() {
	    return {
	      getFirstDateOfMonth: getFirstDateOfMonth,
	      getNumberOfDaysInMonth: getNumberOfDaysInMonth,
	      getDateInNextMonth: getDateInNextMonth,
	      getDateInPreviousMonth: getDateInPreviousMonth,
	      isInNextMonth: isInNextMonth,
	      isInPreviousMonth: isInPreviousMonth,
	      getDateMidpoint: getDateMidpoint,
	      isSameMonthAndYear: isSameMonthAndYear,
	      getWeekOfMonth: getWeekOfMonth,
	      incrementDays: incrementDays,
	      incrementMonths: incrementMonths,
	      getLastDateOfMonth: getLastDateOfMonth,
	      isSameDay: isSameDay,
	      getMonthDistance: getMonthDistance,
	      isValidDate: isValidDate,
	      setDateTimeToMidnight: setDateTimeToMidnight,
	      createDateAtMidnight: createDateAtMidnight,
	      isDateWithinRange: isDateWithinRange,
	      incrementYears: incrementYears,
	      getYearDistance: getYearDistance,
	      clampDate: clampDate,
	      getTimestampFromNode: getTimestampFromNode,
	      isMonthWithinRange: isMonthWithinRange
	    };
	
	    /**
	     * Gets the first day of the month for the given date's month.
	     * @param {Date} date
	     * @returns {Date}
	     */
	    function getFirstDateOfMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth(), 1);
	    }
	
	    /**
	     * Gets the number of days in the month for the given date's month.
	     * @param date
	     * @returns {number}
	     */
	    function getNumberOfDaysInMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
	    }
	
	    /**
	     * Get an arbitrary date in the month after the given date's month.
	     * @param date
	     * @returns {Date}
	     */
	    function getDateInNextMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() + 1, 1);
	    }
	
	    /**
	     * Get an arbitrary date in the month before the given date's month.
	     * @param date
	     * @returns {Date}
	     */
	    function getDateInPreviousMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() - 1, 1);
	    }
	
	    /**
	     * Gets whether two dates have the same month and year.
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {boolean}
	     */
	    function isSameMonthAndYear(d1, d2) {
	      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
	    }
	
	    /**
	     * Gets whether two dates are the same day (not not necesarily the same time).
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {boolean}
	     */
	    function isSameDay(d1, d2) {
	      return d1.getDate() == d2.getDate() && isSameMonthAndYear(d1, d2);
	    }
	
	    /**
	     * Gets whether a date is in the month immediately after some date.
	     * @param {Date} startDate The date from which to compare.
	     * @param {Date} endDate The date to check.
	     * @returns {boolean}
	     */
	    function isInNextMonth(startDate, endDate) {
	      var nextMonth = getDateInNextMonth(startDate);
	      return isSameMonthAndYear(nextMonth, endDate);
	    }
	
	    /**
	     * Gets whether a date is in the month immediately before some date.
	     * @param {Date} startDate The date from which to compare.
	     * @param {Date} endDate The date to check.
	     * @returns {boolean}
	     */
	    function isInPreviousMonth(startDate, endDate) {
	      var previousMonth = getDateInPreviousMonth(startDate);
	      return isSameMonthAndYear(endDate, previousMonth);
	    }
	
	    /**
	     * Gets the midpoint between two dates.
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {Date}
	     */
	    function getDateMidpoint(d1, d2) {
	      return createDateAtMidnight((d1.getTime() + d2.getTime()) / 2);
	    }
	
	    /**
	     * Gets the week of the month that a given date occurs in.
	     * @param {Date} date
	     * @returns {number} Index of the week of the month (zero-based).
	     */
	    function getWeekOfMonth(date) {
	      var firstDayOfMonth = getFirstDateOfMonth(date);
	      return Math.floor((firstDayOfMonth.getDay() + date.getDate() - 1) / 7);
	    }
	
	    /**
	     * Gets a new date incremented by the given number of days. Number of days can be negative.
	     * @param {Date} date
	     * @param {number} numberOfDays
	     * @returns {Date}
	     */
	    function incrementDays(date, numberOfDays) {
	      return new Date(date.getFullYear(), date.getMonth(), date.getDate() + numberOfDays);
	    }
	
	    /**
	     * Gets a new date incremented by the given number of months. Number of months can be negative.
	     * If the date of the given month does not match the target month, the date will be set to the
	     * last day of the month.
	     * @param {Date} date
	     * @param {number} numberOfMonths
	     * @returns {Date}
	     */
	    function incrementMonths(date, numberOfMonths) {
	      // If the same date in the target month does not actually exist, the Date object will
	      // automatically advance *another* month by the number of missing days.
	      // For example, if you try to go from Jan. 30 to Feb. 30, you'll end up on March 2.
	      // So, we check if the month overflowed and go to the last day of the target month instead.
	      var dateInTargetMonth = new Date(date.getFullYear(), date.getMonth() + numberOfMonths, 1);
	      var numberOfDaysInMonth = getNumberOfDaysInMonth(dateInTargetMonth);
	      if (numberOfDaysInMonth < date.getDate()) {
	        dateInTargetMonth.setDate(numberOfDaysInMonth);
	      } else {
	        dateInTargetMonth.setDate(date.getDate());
	      }
	
	      return dateInTargetMonth;
	    }
	
	    /**
	     * Get the integer distance between two months. This *only* considers the month and year
	     * portion of the Date instances.
	     *
	     * @param {Date} start
	     * @param {Date} end
	     * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
	     *     chronologically, this number will be negative.
	     */
	    function getMonthDistance(start, end) {
	      return (12 * (end.getFullYear() - start.getFullYear())) + (end.getMonth() - start.getMonth());
	    }
	
	    /**
	     * Gets the last day of the month for the given date.
	     * @param {Date} date
	     * @returns {Date}
	     */
	    function getLastDateOfMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth(), getNumberOfDaysInMonth(date));
	    }
	
	    /**
	     * Checks whether a date is valid.
	     * @param {Date} date
	     * @return {boolean} Whether the date is a valid Date.
	     */
	    function isValidDate(date) {
	      return date && date.getTime && !isNaN(date.getTime());
	    }
	
	    /**
	     * Sets a date's time to midnight.
	     * @param {Date} date
	     */
	    function setDateTimeToMidnight(date) {
	      if (isValidDate(date)) {
	        date.setHours(0, 0, 0, 0);
	      }
	    }
	
	    /**
	     * Creates a date with the time set to midnight.
	     * Drop-in replacement for two forms of the Date constructor:
	     * 1. No argument for Date representing now.
	     * 2. Single-argument value representing number of seconds since Unix Epoch
	     * or a Date object.
	     * @param {number|Date=} opt_value
	     * @return {Date} New date with time set to midnight.
	     */
	    function createDateAtMidnight(opt_value) {
	      var date;
	      if (angular.isUndefined(opt_value)) {
	        date = new Date();
	      } else {
	        date = new Date(opt_value);
	      }
	      setDateTimeToMidnight(date);
	      return date;
	    }
	
	     /**
	      * Checks if a date is within a min and max range, ignoring the time component.
	      * If minDate or maxDate are not dates, they are ignored.
	      * @param {Date} date
	      * @param {Date} minDate
	      * @param {Date} maxDate
	      */
	     function isDateWithinRange(date, minDate, maxDate) {
	       var dateAtMidnight = createDateAtMidnight(date);
	       var minDateAtMidnight = isValidDate(minDate) ? createDateAtMidnight(minDate) : null;
	       var maxDateAtMidnight = isValidDate(maxDate) ? createDateAtMidnight(maxDate) : null;
	       return (!minDateAtMidnight || minDateAtMidnight <= dateAtMidnight) &&
	           (!maxDateAtMidnight || maxDateAtMidnight >= dateAtMidnight);
	     }
	
	    /**
	     * Gets a new date incremented by the given number of years. Number of years can be negative.
	     * See `incrementMonths` for notes on overflow for specific dates.
	     * @param {Date} date
	     * @param {number} numberOfYears
	     * @returns {Date}
	     */
	     function incrementYears(date, numberOfYears) {
	       return incrementMonths(date, numberOfYears * 12);
	     }
	
	     /**
	      * Get the integer distance between two years. This *only* considers the year portion of the
	      * Date instances.
	      *
	      * @param {Date} start
	      * @param {Date} end
	      * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
	      *     chronologically, this number will be negative.
	      */
	     function getYearDistance(start, end) {
	       return end.getFullYear() - start.getFullYear();
	     }
	
	     /**
	      * Clamps a date between a minimum and a maximum date.
	      * @param {Date} date Date to be clamped
	      * @param {Date=} minDate Minimum date
	      * @param {Date=} maxDate Maximum date
	      * @return {Date}
	      */
	     function clampDate(date, minDate, maxDate) {
	       var boundDate = date;
	       if (minDate && date < minDate) {
	         boundDate = new Date(minDate.getTime());
	       }
	       if (maxDate && date > maxDate) {
	         boundDate = new Date(maxDate.getTime());
	       }
	       return boundDate;
	     }
	
	     /**
	      * Extracts and parses the timestamp from a DOM node.
	      * @param  {HTMLElement} node Node from which the timestamp will be extracted.
	      * @return {number} Time since epoch.
	      */
	     function getTimestampFromNode(node) {
	       if (node && node.hasAttribute('data-timestamp')) {
	         return Number(node.getAttribute('data-timestamp'));
	       }
	     }
	
	     /**
	      * Checks if a month is within a min and max range, ignoring the date and time components.
	      * If minDate or maxDate are not dates, they are ignored.
	      * @param {Date} date
	      * @param {Date} minDate
	      * @param {Date} maxDate
	      */
	     function isMonthWithinRange(date, minDate, maxDate) {
	       var month = date.getMonth();
	       var year = date.getFullYear();
	
	       return (!minDate || minDate.getFullYear() < year || minDate.getMonth() <= month) &&
	        (!maxDate || maxDate.getFullYear() > year || maxDate.getMonth() >= month);
	     }
	  });
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  // TODO(jelbourn): forward more attributes to the internal input (required, autofocus, etc.)
	  // TODO(jelbourn): something better for mobile (calendar panel takes up entire screen?)
	  // TODO(jelbourn): input behavior (masking? auto-complete?)
	
	  DatePickerCtrl.$inject = ["$scope", "$element", "$attrs", "$window", "$mdConstant", "$mdTheming", "$mdUtil", "$mdDateLocale", "$$mdDateUtil", "$$rAF", "$filter"];
	  datePickerDirective.$inject = ["$$mdSvgRegistry", "$mdUtil", "$mdAria", "inputDirective"];
	  angular.module('material.components.datepicker')
	      .directive('mdDatepicker', datePickerDirective);
	
	  /**
	   * @ngdoc directive
	   * @name mdDatepicker
	   * @module material.components.datepicker
	   *
	   * @param {Date} ng-model The component's model. Expects either a JavaScript Date object or a
	   *  value that can be parsed into one (e.g. a ISO 8601 string).
	   * @param {Object=} ng-model-options Allows tuning of the way in which `ng-model` is being
	   *  updated. Also allows for a timezone to be specified.
	   *  <a href="https://docs.angularjs.org/api/ng/directive/ngModelOptions#usage">
	   *    Read more at the ngModelOptions docs.</a>
	   * @param {expression=} ng-change Expression evaluated when the model value changes.
	   * @param {expression=} ng-focus Expression evaluated when the input is focused or the calendar
	   *  is opened.
	   * @param {expression=} ng-blur Expression evaluated when focus is removed from the input or the
	   *  calendar is closed.
	   * @param {boolean=} ng-disabled Whether the datepicker is disabled.
	   * @param {boolean=} ng-required Whether a value is required for the datepicker.
	   * @param {Date=} md-min-date Expression representing a min date (inclusive).
	   * @param {Date=} md-max-date Expression representing a max date (inclusive).
	   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a
	   *  boolean whether it can be selected or not.
	   * @param {String=} md-placeholder The date input placeholder value.
	   * @param {String=} md-open-on-focus When present, the calendar will be opened when the input
	   *  is focused.
	   * @param {Boolean=} md-is-open Expression that can be used to open the datepicker's calendar
	   *  on-demand.
	   * @param {String=} md-current-view Default open view of the calendar pane. Can be either
	   *  "month" or "year".
	   * @param {String=} md-mode Restricts the user to only selecting a value from a particular view.
	   *  This option can be used if the user is only supposed to choose from a certain date type
	   *  (e.g. only selecting the month).
	   * Can be either "month" or "day". **Note** that this will overwrite the `md-current-view` value.
	   *
	   * @param {String=} md-hide-icons Determines which datepicker icons should be hidden. Note that
	   *  this may cause the datepicker to not align properly with other components.
	   *  **Use at your own risk.** Possible values are:
	   * * `"all"` - Hides all icons.
	   * * `"calendar"` - Only hides the calendar icon.
	   * * `"triangle"` - Only hides the triangle icon.
	   * @param {Object=} md-date-locale Allows for the values from the `$mdDateLocaleProvider` to be
	   * ovewritten on a per-element basis (e.g. `msgOpenCalendar` can be overwritten with
	   * `md-date-locale="{ msgOpenCalendar: 'Open a special calendar' }"`).
	   *
	   * @description
	   * `<md-datepicker>` is a component used to select a single date.
	   * For information on how to configure internationalization for the date picker,
	   * see {@link api/service/$mdDateLocaleProvider $mdDateLocaleProvider}.
	   *
	   * This component supports
	   * [ngMessages](https://docs.angularjs.org/api/ngMessages/directive/ngMessages).
	   * Supported attributes are:
	   * * `required`: whether a required date is not set.
	   * * `mindate`: whether the selected date is before the minimum allowed date.
	   * * `maxdate`: whether the selected date is after the maximum allowed date.
	   * * `debounceInterval`: ms to delay input processing (since last debounce reset);
	   *    default value 500ms
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <md-datepicker ng-model="birthday"></md-datepicker>
	   * </hljs>
	   *
	   */
	
	  function datePickerDirective($$mdSvgRegistry, $mdUtil, $mdAria, inputDirective) {
	    return {
	      template: function(tElement, tAttrs) {
	        // Buttons are not in the tab order because users can open the calendar via keyboard
	        // interaction on the text input, and multiple tab stops for one component (picker)
	        // may be confusing.
	        var hiddenIcons = tAttrs.mdHideIcons;
	        var ariaLabelValue = tAttrs.ariaLabel || tAttrs.mdPlaceholder;
	
	        var calendarButton = (hiddenIcons === 'all' || hiddenIcons === 'calendar') ? '' :
	          '<md-button class="md-datepicker-button md-icon-button" type="button" ' +
	              'tabindex="-1" aria-hidden="true" ' +
	              'ng-click="ctrl.openCalendarPane($event)">' +
	            '<md-icon class="md-datepicker-calendar-icon" aria-label="md-calendar" ' +
	                     'md-svg-src="' + $$mdSvgRegistry.mdCalendar + '"></md-icon>' +
	          '</md-button>';
	
	        var triangleButton = '';
	
	        if (hiddenIcons !== 'all' && hiddenIcons !== 'triangle') {
	          triangleButton = '' +
	            '<md-button type="button" md-no-ink ' +
	              'class="md-datepicker-triangle-button md-icon-button" ' +
	              'ng-click="ctrl.openCalendarPane($event)" ' +
	              'aria-label="{{::ctrl.locale.msgOpenCalendar}}">' +
	            '<div class="md-datepicker-expand-triangle"></div>' +
	          '</md-button>';
	
	          tElement.addClass(HAS_TRIANGLE_ICON_CLASS);
	        }
	
	        return calendarButton +
	        '<div class="md-datepicker-input-container" ng-class="{\'md-datepicker-focused\': ctrl.isFocused}">' +
	          '<input ' +
	            (ariaLabelValue ? 'aria-label="' + ariaLabelValue + '" ' : '') +
	            'class="md-datepicker-input" ' +
	            'aria-haspopup="true" ' +
	            'aria-expanded="{{ctrl.isCalendarOpen}}" ' +
	            'ng-focus="ctrl.setFocused(true)" ' +
	            'ng-blur="ctrl.setFocused(false)"> ' +
	            triangleButton +
	        '</div>' +
	
	        // This pane will be detached from here and re-attached to the document body.
	        '<div class="md-datepicker-calendar-pane md-whiteframe-z1" id="{{::ctrl.calendarPaneId}}">' +
	          '<div class="md-datepicker-input-mask">' +
	            '<div class="md-datepicker-input-mask-opaque"></div>' +
	          '</div>' +
	          '<div class="md-datepicker-calendar">' +
	            '<md-calendar role="dialog" aria-label="{{::ctrl.locale.msgCalendar}}" ' +
	                'md-current-view="{{::ctrl.currentView}}" ' +
	                'md-mode="{{::ctrl.mode}}" ' +
	                'md-min-date="ctrl.minDate" ' +
	                'md-max-date="ctrl.maxDate" ' +
	                'md-date-filter="ctrl.dateFilter" ' +
	                'ng-model="ctrl.date" ng-if="ctrl.isCalendarOpen">' +
	            '</md-calendar>' +
	          '</div>' +
	        '</div>';
	      },
	      require: ['ngModel', 'mdDatepicker', '?^mdInputContainer', '?^form'],
	      scope: {
	        minDate: '=mdMinDate',
	        maxDate: '=mdMaxDate',
	        placeholder: '@mdPlaceholder',
	        currentView: '@mdCurrentView',
	        mode: '@mdMode',
	        dateFilter: '=mdDateFilter',
	        isOpen: '=?mdIsOpen',
	        debounceInterval: '=mdDebounceInterval',
	        dateLocale: '=mdDateLocale'
	      },
	      controller: DatePickerCtrl,
	      controllerAs: 'ctrl',
	      bindToController: true,
	      link: function(scope, element, attr, controllers) {
	        var ngModelCtrl = controllers[0];
	        var mdDatePickerCtrl = controllers[1];
	        var mdInputContainer = controllers[2];
	        var parentForm = controllers[3];
	        var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
	
	        mdDatePickerCtrl.configureNgModel(ngModelCtrl, mdInputContainer, inputDirective);
	
	        if (mdInputContainer) {
	          // We need to move the spacer after the datepicker itself,
	          // because md-input-container adds it after the
	          // md-datepicker-input by default. The spacer gets wrapped in a
	          // div, because it floats and gets aligned next to the datepicker.
	          // There are easier ways of working around this with CSS (making the
	          // datepicker 100% wide, change the `display` etc.), however they
	          // break the alignment with any other form controls.
	          var spacer = element[0].querySelector('.md-errors-spacer');
	
	          if (spacer) {
	            element.after(angular.element('<div>').append(spacer));
	          }
	
	          mdInputContainer.setHasPlaceholder(attr.mdPlaceholder);
	          mdInputContainer.input = element;
	          mdInputContainer.element
	            .addClass(INPUT_CONTAINER_CLASS)
	            .toggleClass(HAS_CALENDAR_ICON_CLASS, attr.mdHideIcons !== 'calendar' && attr.mdHideIcons !== 'all');
	
	          if (!mdInputContainer.label) {
	            $mdAria.expect(element, 'aria-label', attr.mdPlaceholder);
	          } else if(!mdNoAsterisk) {
	            attr.$observe('required', function(value) {
	              mdInputContainer.label.toggleClass('md-required', !!value);
	            });
	          }
	
	          scope.$watch(mdInputContainer.isErrorGetter || function() {
	            return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (parentForm && parentForm.$submitted));
	          }, mdInputContainer.setInvalid);
	        } else if (parentForm) {
	          // If invalid, highlights the input when the parent form is submitted.
	          var parentSubmittedWatcher = scope.$watch(function() {
	            return parentForm.$submitted;
	          }, function(isSubmitted) {
	            if (isSubmitted) {
	              mdDatePickerCtrl.updateErrorState();
	              parentSubmittedWatcher();
	            }
	          });
	        }
	      }
	    };
	  }
	
	  /** Additional offset for the input's `size` attribute, which is updated based on its content. */
	  var EXTRA_INPUT_SIZE = 3;
	
	  /** Class applied to the container if the date is invalid. */
	  var INVALID_CLASS = 'md-datepicker-invalid';
	
	  /** Class applied to the datepicker when it's open. */
	  var OPEN_CLASS = 'md-datepicker-open';
	
	  /** Class applied to the md-input-container, if a datepicker is placed inside it */
	  var INPUT_CONTAINER_CLASS = '_md-datepicker-floating-label';
	
	  /** Class to be applied when the calendar icon is enabled. */
	  var HAS_CALENDAR_ICON_CLASS = '_md-datepicker-has-calendar-icon';
	
	  /** Class to be applied when the triangle icon is enabled. */
	  var HAS_TRIANGLE_ICON_CLASS = '_md-datepicker-has-triangle-icon';
	
	  /** Default time in ms to debounce input event by. */
	  var DEFAULT_DEBOUNCE_INTERVAL = 500;
	
	  /**
	   * Height of the calendar pane used to check if the pane is going outside the boundary of
	   * the viewport. See calendar.scss for how $md-calendar-height is computed; an extra 20px is
	   * also added to space the pane away from the exact edge of the screen.
	   *
	   *  This is computed statically now, but can be changed to be measured if the circumstances
	   *  of calendar sizing are changed.
	   */
	  var CALENDAR_PANE_HEIGHT = 368;
	
	  /**
	   * Width of the calendar pane used to check if the pane is going outside the boundary of
	   * the viewport. See calendar.scss for how $md-calendar-width is computed; an extra 20px is
	   * also added to space the pane away from the exact edge of the screen.
	   *
	   *  This is computed statically now, but can be changed to be measured if the circumstances
	   *  of calendar sizing are changed.
	   */
	  var CALENDAR_PANE_WIDTH = 360;
	
	  /** Used for checking whether the current user agent is on iOS or Android. */
	  var IS_MOBILE_REGEX = /ipad|iphone|ipod|android/i;
	
	  /**
	   * Controller for md-datepicker.
	   *
	   * @ngInject @constructor
	   */
	  function DatePickerCtrl($scope, $element, $attrs, $window, $mdConstant,
	    $mdTheming, $mdUtil, $mdDateLocale, $$mdDateUtil, $$rAF, $filter) {
	
	    /** @final */
	    this.$window = $window;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.$mdConstant = $mdConstant;
	
	    /* @final */
	    this.$mdUtil = $mdUtil;
	
	    /** @final */
	    this.$$rAF = $$rAF;
	
	    /** @final */
	    this.$mdDateLocale = $mdDateLocale;
	
	    /**
	     * The root document element. This is used for attaching a top-level click handler to
	     * close the calendar panel when a click outside said panel occurs. We use `documentElement`
	     * instead of body because, when scrolling is disabled, some browsers consider the body element
	     * to be completely off the screen and propagate events directly to the html element.
	     * @type {!angular.JQLite}
	     */
	    this.documentElement = angular.element(document.documentElement);
	
	    /** @type {!angular.NgModelController} */
	    this.ngModelCtrl = null;
	
	    /** @type {HTMLInputElement} */
	    this.inputElement = $element[0].querySelector('input');
	
	    /** @final {!angular.JQLite} */
	    this.ngInputElement = angular.element(this.inputElement);
	
	    /** @type {HTMLElement} */
	    this.inputContainer = $element[0].querySelector('.md-datepicker-input-container');
	
	    /** @type {HTMLElement} Floating calendar pane. */
	    this.calendarPane = $element[0].querySelector('.md-datepicker-calendar-pane');
	
	    /** @type {HTMLElement} Calendar icon button. */
	    this.calendarButton = $element[0].querySelector('.md-datepicker-button');
	
	    /**
	     * Element covering everything but the input in the top of the floating calendar pane.
	     * @type {!angular.JQLite}
	     */
	    this.inputMask = angular.element($element[0].querySelector('.md-datepicker-input-mask-opaque'));
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Attributes} */
	    this.$attrs = $attrs;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @type {Date} */
	    this.date = null;
	
	    /** @type {boolean} */
	    this.isFocused = false;
	
	    /** @type {boolean} */
	    this.isDisabled;
	    this.setDisabled($element[0].disabled || angular.isString($attrs.disabled));
	
	    /** @type {boolean} Whether the date-picker's calendar pane is open. */
	    this.isCalendarOpen = false;
	
	    /** @type {boolean} Whether the calendar should open when the input is focused. */
	    this.openOnFocus = $attrs.hasOwnProperty('mdOpenOnFocus');
	
	    /** @final */
	    this.mdInputContainer = null;
	
	    /**
	     * Element from which the calendar pane was opened. Keep track of this so that we can return
	     * focus to it when the pane is closed.
	     * @type {HTMLElement}
	     */
	    this.calendarPaneOpenedFrom = null;
	
	    /** @type {String} Unique id for the calendar pane. */
	    this.calendarPaneId = 'md-date-pane-' + $mdUtil.nextUid();
	
	    /** Pre-bound click handler is saved so that the event listener can be removed. */
	    this.bodyClickHandler = angular.bind(this, this.handleBodyClick);
	
	    /**
	     * Name of the event that will trigger a close. Necessary to sniff the browser, because
	     * the resize event doesn't make sense on mobile and can have a negative impact since it
	     * triggers whenever the browser zooms in on a focused input.
	     */
	    this.windowEventName = IS_MOBILE_REGEX.test(
	      navigator.userAgent || navigator.vendor || window.opera
	    ) ? 'orientationchange' : 'resize';
	
	    /** Pre-bound close handler so that the event listener can be removed. */
	    this.windowEventHandler = $mdUtil.debounce(angular.bind(this, this.closeCalendarPane), 100);
	
	    /** Pre-bound handler for the window blur event. Allows for it to be removed later. */
	    this.windowBlurHandler = angular.bind(this, this.handleWindowBlur);
	
	    /** The built-in AngularJS date filter. */
	    this.ngDateFilter = $filter('date');
	
	    /** @type {Number} Extra margin for the left side of the floating calendar pane. */
	    this.leftMargin = 20;
	
	    /** @type {Number} Extra margin for the top of the floating calendar. Gets determined on the first open. */
	    this.topMargin = null;
	
	    // Unless the user specifies so, the datepicker should not be a tab stop.
	    // This is necessary because ngAria might add a tabindex to anything with an ng-model
	    // (based on whether or not the user has turned that particular feature on/off).
	    if ($attrs.tabindex) {
	      this.ngInputElement.attr('tabindex', $attrs.tabindex);
	      $attrs.$set('tabindex', null);
	    } else {
	      $attrs.$set('tabindex', '-1');
	    }
	
	    $attrs.$set('aria-owns', this.calendarPaneId);
	
	    $mdTheming($element);
	    $mdTheming(angular.element(this.calendarPane));
	
	    var self = this;
	
	    $scope.$on('$destroy', function() {
	      self.detachCalendarPane();
	    });
	
	    if ($attrs.mdIsOpen) {
	      $scope.$watch('ctrl.isOpen', function(shouldBeOpen) {
	        if (shouldBeOpen) {
	          self.openCalendarPane({
	            target: self.inputElement
	          });
	        } else {
	          self.closeCalendarPane();
	        }
	      });
	    }
	
	    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	    // manually call the $onInit hook.
	    if (angular.version.major === 1 && angular.version.minor <= 4) {
	      this.$onInit();
	    }
	
	  }
	
	  /**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	   */
	  DatePickerCtrl.prototype.$onInit = function() {
	
	    /**
	     * Holds locale-specific formatters, parsers, labels etc. Allows
	     * the user to override specific ones from the $mdDateLocale provider.
	     * @type {!Object}
	     */
	    this.locale = this.dateLocale ? angular.extend({}, this.$mdDateLocale, this.dateLocale) : this.$mdDateLocale;
	
	    this.installPropertyInterceptors();
	    this.attachChangeListeners();
	    this.attachInteractionListeners();
	  };
	
	  /**
	   * Sets up the controller's reference to ngModelController and
	   * applies AngularJS's `input[type="date"]` directive.
	   * @param {!angular.NgModelController} ngModelCtrl Instance of the ngModel controller.
	   * @param {Object} mdInputContainer Instance of the mdInputContainer controller.
	   * @param {Object} inputDirective Config for AngularJS's `input` directive.
	   */
	  DatePickerCtrl.prototype.configureNgModel = function(ngModelCtrl, mdInputContainer, inputDirective) {
	    this.ngModelCtrl = ngModelCtrl;
	    this.mdInputContainer = mdInputContainer;
	
	    // The input needs to be [type="date"] in order to be picked up by AngularJS.
	    this.$attrs.$set('type', 'date');
	
	    // Invoke the `input` directive link function, adding a stub for the element.
	    // This allows us to re-use AngularJS's logic for setting the timezone via ng-model-options.
	    // It works by calling the link function directly which then adds the proper `$parsers` and
	    // `$formatters` to the ngModel controller.
	    inputDirective[0].link.pre(this.$scope, {
	      on: angular.noop,
	      val: angular.noop,
	      0: {}
	    }, this.$attrs, [ngModelCtrl]);
	
	    var self = this;
	
	    // Responds to external changes to the model value.
	    self.ngModelCtrl.$formatters.push(function(value) {
	      var parsedValue = angular.isDefined(value) ? value : null;
	
	      if (!(value instanceof Date)) {
	        parsedValue = Date.parse(value);
	
	        // `parsedValue` is the time since epoch if valid or `NaN` if invalid.
	        if (!isNaN(parsedValue) && angular.isNumber(parsedValue)) {
	          value = new Date(parsedValue);
	        }
	
	        if (value && !(value instanceof Date)) {
	          throw Error(
	            'The ng-model for md-datepicker must be a Date instance or a value ' +
	              'that can be parsed into a date. Currently the model is of type: ' + typeof value
	          );
	        }
	      }
	
	      self.onExternalChange(value);
	
	      return value;
	    });
	
	    // Responds to external error state changes (e.g. ng-required based on another input).
	    ngModelCtrl.$viewChangeListeners.unshift(angular.bind(this, this.updateErrorState));
	
	    // Forwards any events from the input to the root element. This is necessary to get `updateOn`
	    // working for events that don't bubble (e.g. 'blur') since AngularJS binds the handlers to
	    // the `<md-datepicker>`.
	    var updateOn = self.$mdUtil.getModelOption(ngModelCtrl, 'updateOn');
	
	    if (updateOn) {
	      this.ngInputElement.on(
	        updateOn,
	        angular.bind(this.$element, this.$element.triggerHandler, updateOn)
	      );
	    }
	  };
	
	  /**
	   * Attach event listeners for both the text input and the md-calendar.
	   * Events are used instead of ng-model so that updates don't infinitely update the other
	   * on a change. This should also be more performant than using a $watch.
	   */
	  DatePickerCtrl.prototype.attachChangeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-change', function(event, date) {
	      self.setModelValue(date);
	      self.onExternalChange(date);
	      self.closeCalendarPane();
	    });
	
	    self.ngInputElement.on('input', angular.bind(self, self.resizeInputElement));
	
	    var debounceInterval = angular.isDefined(this.debounceInterval) ?
	        this.debounceInterval : DEFAULT_DEBOUNCE_INTERVAL;
	    self.ngInputElement.on('input', self.$mdUtil.debounce(self.handleInputEvent,
	        debounceInterval, self));
	  };
	
	  /** Attach event listeners for user interaction. */
	  DatePickerCtrl.prototype.attachInteractionListeners = function() {
	    var self = this;
	    var $scope = this.$scope;
	    var keyCodes = this.$mdConstant.KEY_CODE;
	
	    // Add event listener through angular so that we can triggerHandler in unit tests.
	    self.ngInputElement.on('keydown', function(event) {
	      if (event.altKey && event.keyCode == keyCodes.DOWN_ARROW) {
	        self.openCalendarPane(event);
	        $scope.$digest();
	      }
	    });
	
	    if (self.openOnFocus) {
	      self.ngInputElement.on('focus', angular.bind(self, self.openCalendarPane));
	      angular.element(self.$window).on('blur', self.windowBlurHandler);
	
	      $scope.$on('$destroy', function() {
	        angular.element(self.$window).off('blur', self.windowBlurHandler);
	      });
	    }
	
	    $scope.$on('md-calendar-close', function() {
	      self.closeCalendarPane();
	    });
	  };
	
	  /**
	   * Capture properties set to the date-picker and imperitively handle internal changes.
	   * This is done to avoid setting up additional $watches.
	   */
	  DatePickerCtrl.prototype.installPropertyInterceptors = function() {
	    var self = this;
	
	    if (this.$attrs.ngDisabled) {
	      // The expression is to be evaluated against the directive element's scope and not
	      // the directive's isolate scope.
	      var scope = this.$scope.$parent;
	
	      if (scope) {
	        scope.$watch(this.$attrs.ngDisabled, function(isDisabled) {
	          self.setDisabled(isDisabled);
	        });
	      }
	    }
	
	    Object.defineProperty(this, 'placeholder', {
	      get: function() { return self.inputElement.placeholder; },
	      set: function(value) { self.inputElement.placeholder = value || ''; }
	    });
	  };
	
	  /**
	   * Sets whether the date-picker is disabled.
	   * @param {boolean} isDisabled
	   */
	  DatePickerCtrl.prototype.setDisabled = function(isDisabled) {
	    this.isDisabled = isDisabled;
	    this.inputElement.disabled = isDisabled;
	
	    if (this.calendarButton) {
	      this.calendarButton.disabled = isDisabled;
	    }
	  };
	
	  /**
	   * Sets the custom ngModel.$error flags to be consumed by ngMessages. Flags are:
	   *   - mindate: whether the selected date is before the minimum date.
	   *   - maxdate: whether the selected flag is after the maximum date.
	   *   - filtered: whether the selected date is allowed by the custom filtering function.
	   *   - valid: whether the entered text input is a valid date
	   *
	   * The 'required' flag is handled automatically by ngModel.
	   *
	   * @param {Date=} opt_date Date to check. If not given, defaults to the datepicker's model value.
	   */
	  DatePickerCtrl.prototype.updateErrorState = function(opt_date) {
	    var date = opt_date || this.date;
	
	    // Clear any existing errors to get rid of anything that's no longer relevant.
	    this.clearErrorState();
	
	    if (this.dateUtil.isValidDate(date)) {
	      // Force all dates to midnight in order to ignore the time portion.
	      date = this.dateUtil.createDateAtMidnight(date);
	
	      if (this.dateUtil.isValidDate(this.minDate)) {
	        var minDate = this.dateUtil.createDateAtMidnight(this.minDate);
	        this.ngModelCtrl.$setValidity('mindate', date >= minDate);
	      }
	
	      if (this.dateUtil.isValidDate(this.maxDate)) {
	        var maxDate = this.dateUtil.createDateAtMidnight(this.maxDate);
	        this.ngModelCtrl.$setValidity('maxdate', date <= maxDate);
	      }
	
	      if (angular.isFunction(this.dateFilter)) {
	        this.ngModelCtrl.$setValidity('filtered', this.dateFilter(date));
	      }
	    } else {
	      // The date is seen as "not a valid date" if there is *something* set
	      // (i.e.., not null or undefined), but that something isn't a valid date.
	      this.ngModelCtrl.$setValidity('valid', date == null);
	    }
	
	    angular.element(this.inputContainer).toggleClass(INVALID_CLASS, !this.ngModelCtrl.$valid);
	  };
	
	  /** Clears any error flags set by `updateErrorState`. */
	  DatePickerCtrl.prototype.clearErrorState = function() {
	    this.inputContainer.classList.remove(INVALID_CLASS);
	    ['mindate', 'maxdate', 'filtered', 'valid'].forEach(function(field) {
	      this.ngModelCtrl.$setValidity(field, true);
	    }, this);
	  };
	
	  /** Resizes the input element based on the size of its content. */
	  DatePickerCtrl.prototype.resizeInputElement = function() {
	    this.inputElement.size = this.inputElement.value.length + EXTRA_INPUT_SIZE;
	  };
	
	  /**
	   * Sets the model value if the user input is a valid date.
	   * Adds an invalid class to the input element if not.
	   */
	  DatePickerCtrl.prototype.handleInputEvent = function() {
	    var inputString = this.inputElement.value;
	    var parsedDate = inputString ? this.locale.parseDate(inputString) : null;
	    this.dateUtil.setDateTimeToMidnight(parsedDate);
	
	    // An input string is valid if it is either empty (representing no date)
	    // or if it parses to a valid date that the user is allowed to select.
	    var isValidInput = inputString == '' || (
	      this.dateUtil.isValidDate(parsedDate) &&
	      this.locale.isDateComplete(inputString) &&
	      this.isDateEnabled(parsedDate)
	    );
	
	    // The datepicker's model is only updated when there is a valid input.
	    if (isValidInput) {
	      this.setModelValue(parsedDate);
	      this.date = parsedDate;
	    }
	
	    this.updateErrorState(parsedDate);
	  };
	
	  /**
	   * Check whether date is in range and enabled
	   * @param {Date=} opt_date
	   * @return {boolean} Whether the date is enabled.
	   */
	  DatePickerCtrl.prototype.isDateEnabled = function(opt_date) {
	    return this.dateUtil.isDateWithinRange(opt_date, this.minDate, this.maxDate) &&
	          (!angular.isFunction(this.dateFilter) || this.dateFilter(opt_date));
	  };
	
	  /** Position and attach the floating calendar to the document. */
	  DatePickerCtrl.prototype.attachCalendarPane = function() {
	    var calendarPane = this.calendarPane;
	    var body = document.body;
	
	    calendarPane.style.transform = '';
	    this.$element.addClass(OPEN_CLASS);
	    this.mdInputContainer && this.mdInputContainer.element.addClass(OPEN_CLASS);
	    angular.element(body).addClass('md-datepicker-is-showing');
	
	    var elementRect = this.inputContainer.getBoundingClientRect();
	    var bodyRect = body.getBoundingClientRect();
	
	    if (!this.topMargin || this.topMargin < 0) {
	      this.topMargin = (this.inputMask.parent().prop('clientHeight') - this.ngInputElement.prop('clientHeight')) / 2;
	    }
	
	    // Check to see if the calendar pane would go off the screen. If so, adjust position
	    // accordingly to keep it within the viewport.
	    var paneTop = elementRect.top - bodyRect.top - this.topMargin;
	    var paneLeft = elementRect.left - bodyRect.left - this.leftMargin;
	
	    // If ng-material has disabled body scrolling (for example, if a dialog is open),
	    // then it's possible that the already-scrolled body has a negative top/left. In this case,
	    // we want to treat the "real" top as (0 - bodyRect.top). In a normal scrolling situation,
	    // though, the top of the viewport should just be the body's scroll position.
	    var viewportTop = (bodyRect.top < 0 && document.body.scrollTop == 0) ?
	        -bodyRect.top :
	        document.body.scrollTop;
	
	    var viewportLeft = (bodyRect.left < 0 && document.body.scrollLeft == 0) ?
	        -bodyRect.left :
	        document.body.scrollLeft;
	
	    var viewportBottom = viewportTop + this.$window.innerHeight;
	    var viewportRight = viewportLeft + this.$window.innerWidth;
	
	    // Creates an overlay with a hole the same size as element. We remove a pixel or two
	    // on each end to make it overlap slightly. The overlay's background is added in
	    // the theme in the form of a box-shadow with a huge spread.
	    this.inputMask.css({
	      position: 'absolute',
	      left: this.leftMargin + 'px',
	      top: this.topMargin + 'px',
	      width: (elementRect.width - 1) + 'px',
	      height: (elementRect.height - 2) + 'px'
	    });
	
	    // If the right edge of the pane would be off the screen and shifting it left by the
	    // difference would not go past the left edge of the screen. If the calendar pane is too
	    // big to fit on the screen at all, move it to the left of the screen and scale the entire
	    // element down to fit.
	    if (paneLeft + CALENDAR_PANE_WIDTH > viewportRight) {
	      if (viewportRight - CALENDAR_PANE_WIDTH > 0) {
	        paneLeft = viewportRight - CALENDAR_PANE_WIDTH;
	      } else {
	        paneLeft = viewportLeft;
	        var scale = this.$window.innerWidth / CALENDAR_PANE_WIDTH;
	        calendarPane.style.transform = 'scale(' + scale + ')';
	      }
	
	      calendarPane.classList.add('md-datepicker-pos-adjusted');
	    }
	
	    // If the bottom edge of the pane would be off the screen and shifting it up by the
	    // difference would not go past the top edge of the screen.
	    if (paneTop + CALENDAR_PANE_HEIGHT > viewportBottom &&
	        viewportBottom - CALENDAR_PANE_HEIGHT > viewportTop) {
	      paneTop = viewportBottom - CALENDAR_PANE_HEIGHT;
	      calendarPane.classList.add('md-datepicker-pos-adjusted');
	    }
	
	    calendarPane.style.left = paneLeft + 'px';
	    calendarPane.style.top = paneTop + 'px';
	    document.body.appendChild(calendarPane);
	
	    // Add CSS class after one frame to trigger open animation.
	    this.$$rAF(function() {
	      calendarPane.classList.add('md-pane-open');
	    });
	  };
	
	  /** Detach the floating calendar pane from the document. */
	  DatePickerCtrl.prototype.detachCalendarPane = function() {
	    this.$element.removeClass(OPEN_CLASS);
	    this.mdInputContainer && this.mdInputContainer.element.removeClass(OPEN_CLASS);
	    angular.element(document.body).removeClass('md-datepicker-is-showing');
	    this.calendarPane.classList.remove('md-pane-open');
	    this.calendarPane.classList.remove('md-datepicker-pos-adjusted');
	
	    if (this.isCalendarOpen) {
	      this.$mdUtil.enableScrolling();
	    }
	
	    if (this.calendarPane.parentNode) {
	      // Use native DOM removal because we do not want any of the
	      // angular state of this element to be disposed.
	      this.calendarPane.parentNode.removeChild(this.calendarPane);
	    }
	  };
	
	  /**
	   * Open the floating calendar pane.
	   * @param {Event} event
	   */
	  DatePickerCtrl.prototype.openCalendarPane = function(event) {
	    if (!this.isCalendarOpen && !this.isDisabled && !this.inputFocusedOnWindowBlur) {
	      this.isCalendarOpen = this.isOpen = true;
	      this.calendarPaneOpenedFrom = event.target;
	
	      // Because the calendar pane is attached directly to the body, it is possible that the
	      // rest of the component (input, etc) is in a different scrolling container, such as
	      // an md-content. This means that, if the container is scrolled, the pane would remain
	      // stationary. To remedy this, we disable scrolling while the calendar pane is open, which
	      // also matches the native behavior for things like `<select>` on Mac and Windows.
	      this.$mdUtil.disableScrollAround(this.calendarPane);
	
	      this.attachCalendarPane();
	      this.focusCalendar();
	      this.evalAttr('ngFocus');
	
	      // Attach click listener inside of a timeout because, if this open call was triggered by a
	      // click, we don't want it to be immediately propogated up to the body and handled.
	      var self = this;
	      this.$mdUtil.nextTick(function() {
	        // Use 'touchstart` in addition to click in order to work on iOS Safari, where click
	        // events aren't propagated under most circumstances.
	        // See http://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	        self.documentElement.on('click touchstart', self.bodyClickHandler);
	      }, false);
	
	      window.addEventListener(this.windowEventName, this.windowEventHandler);
	    }
	  };
	
	  /** Close the floating calendar pane. */
	  DatePickerCtrl.prototype.closeCalendarPane = function() {
	    if (this.isCalendarOpen) {
	      var self = this;
	
	      self.detachCalendarPane();
	      self.ngModelCtrl.$setTouched();
	      self.evalAttr('ngBlur');
	
	      self.documentElement.off('click touchstart', self.bodyClickHandler);
	      window.removeEventListener(self.windowEventName, self.windowEventHandler);
	
	      self.calendarPaneOpenedFrom.focus();
	      self.calendarPaneOpenedFrom = null;
	
	      if (self.openOnFocus) {
	        // Ensures that all focus events have fired before resetting
	        // the calendar. Prevents the calendar from reopening immediately
	        // in IE when md-open-on-focus is set. Also it needs to trigger
	        // a digest, in order to prevent issues where the calendar wasn't
	        // showing up on the next open.
	        self.$mdUtil.nextTick(reset);
	      } else {
	        reset();
	      }
	    }
	
	    function reset(){
	      self.isCalendarOpen = self.isOpen = false;
	    }
	  };
	
	  /** Gets the controller instance for the calendar in the floating pane. */
	  DatePickerCtrl.prototype.getCalendarCtrl = function() {
	    return angular.element(this.calendarPane.querySelector('md-calendar')).controller('mdCalendar');
	  };
	
	  /** Focus the calendar in the floating pane. */
	  DatePickerCtrl.prototype.focusCalendar = function() {
	    // Use a timeout in order to allow the calendar to be rendered, as it is gated behind an ng-if.
	    var self = this;
	    this.$mdUtil.nextTick(function() {
	      self.getCalendarCtrl().focus();
	    }, false);
	  };
	
	  /**
	   * Sets whether the input is currently focused.
	   * @param {boolean} isFocused
	   */
	  DatePickerCtrl.prototype.setFocused = function(isFocused) {
	    if (!isFocused) {
	      this.ngModelCtrl.$setTouched();
	    }
	
	    // The ng* expressions shouldn't be evaluated when mdOpenOnFocus is on,
	    // because they also get called when the calendar is opened/closed.
	    if (!this.openOnFocus) {
	      this.evalAttr(isFocused ? 'ngFocus' : 'ngBlur');
	    }
	
	    this.isFocused = isFocused;
	  };
	
	  /**
	   * Handles a click on the document body when the floating calendar pane is open.
	   * Closes the floating calendar pane if the click is not inside of it.
	   * @param {MouseEvent} event
	   */
	  DatePickerCtrl.prototype.handleBodyClick = function(event) {
	    if (this.isCalendarOpen) {
	      var isInCalendar = this.$mdUtil.getClosest(event.target, 'md-calendar');
	
	      if (!isInCalendar) {
	        this.closeCalendarPane();
	      }
	
	      this.$scope.$digest();
	    }
	  };
	
	  /**
	   * Handles the event when the user navigates away from the current tab. Keeps track of
	   * whether the input was focused when the event happened, in order to prevent the calendar
	   * from re-opening.
	   */
	  DatePickerCtrl.prototype.handleWindowBlur = function() {
	    this.inputFocusedOnWindowBlur = document.activeElement === this.inputElement;
	  };
	
	  /**
	   * Evaluates an attribute expression against the parent scope.
	   * @param {String} attr Name of the attribute to be evaluated.
	   */
	  DatePickerCtrl.prototype.evalAttr = function(attr) {
	    if (this.$attrs[attr]) {
	      this.$scope.$parent.$eval(this.$attrs[attr]);
	    }
	  };
	
	  /**
	   * Sets the ng-model value by first converting the date object into a string. Converting it
	   * is necessary, in order to pass AngularJS's `input[type="date"]` validations. AngularJS turns
	   * the value into a Date object afterwards, before setting it on the model.
	   * @param {Date=} value Date to be set as the model value.
	   */
	  DatePickerCtrl.prototype.setModelValue = function(value) {
	    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');
	    this.ngModelCtrl.$setViewValue(this.ngDateFilter(value, 'yyyy-MM-dd', timezone));
	  };
	
	  /**
	   * Updates the datepicker when a model change occurred externally.
	   * @param {Date=} value Value that was set to the model.
	   */
	  DatePickerCtrl.prototype.onExternalChange = function(value) {
	    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');
	
	    this.date = value;
	    this.inputElement.value = this.locale.formatDate(value, timezone);
	    this.mdInputContainer && this.mdInputContainer.setHasValue(!!value);
	    this.resizeInputElement();
	    this.updateErrorState();
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	angular
	  .module('material.components.icon')
	  .directive('mdIcon', ['$mdIcon', '$mdTheming', '$mdAria', '$sce', mdIconDirective]);
	
	/**
	 * @ngdoc directive
	 * @name mdIcon
	 * @module material.components.icon
	 *
	 * @restrict E
	 *
	 * @description
	 * The `md-icon` directive makes it easier to use vector-based icons in your app (as opposed to
	 * raster-based icons types like PNG). The directive supports both icon fonts and SVG icons.
	 *
	 * Icons should be considered view-only elements that should not be used directly as buttons; instead nest a `<md-icon>`
	 * inside a `md-button` to add hover and click features.
	 *
	 * ### Icon fonts
	 * Icon fonts are a technique in which you use a font where the glyphs in the font are
	 * your icons instead of text. Benefits include a straightforward way to bundle everything into a
	 * single HTTP request, simple scaling, easy color changing, and more.
	 *
	 * `md-icon` lets you consume an icon font by letting you reference specific icons in that font
	 * by name rather than character code.
	 *
	 * ### SVG
	 * For SVGs, the problem with using `<img>` or a CSS `background-image` is that you can't take
	 * advantage of some SVG features, such as styling specific parts of the icon with CSS or SVG
	 * animation.
	 *
	 * `md-icon` makes it easier to use SVG icons by *inlining* the SVG into an `<svg>` element in the
	 * document. The most straightforward way of referencing an SVG icon is via URL, just like a
	 * traditional `<img>`. `$mdIconProvider`, as a convenience, lets you _name_ an icon so you can
	 * reference it by name instead of URL throughout your templates.
	 *
	 * Additionally, you may not want to make separate HTTP requests for every icon, so you can bundle
	 * your SVG icons together and pre-load them with $mdIconProvider as an icon set. An icon set can
	 * also be given a name, which acts as a namespace for individual icons, so you can reference them
	 * like `"social:cake"`.
	 *
	 * When using SVGs, both external SVGs (via URLs) or sets of SVGs [from icon sets] can be
	 * easily loaded and used. When using font-icons, developers must follow three (3) simple steps:
	 *
	 * <ol>
	 * <li>Load the font library. e.g.<br/>
	 *    `<link href="https://fonts.googleapis.com/icon?family=Material+Icons"
	 *    rel="stylesheet">`
	 * </li>
	 * <li>
	 *   Use either (a) font-icon class names or (b) a fontset and a font ligature to render the font glyph by
	 *   using its textual name _or_ numerical character reference. Note that `material-icons` is the default fontset when
	 *   none is specified.
	 * </li>
	 * <li> Use any of the following templates: <br/>
	 *   <ul>
	 *     <li>`<md-icon md-font-icon="classname"></md-icon>`</li>
	 *     <li>`<md-icon md-font-set="font library classname or alias">textual_name</md-icon>`</li>
	 *     <li>`<md-icon> numerical_character_reference </md-icon>`</li>
	 *     <li>`<md-icon ng_bind="'textual_name'"></md-icon>`</li>
	 *     <li>`<md-icon ng-bind="scopeVariable"></md-icon>`</li>
	 *   </ul>
	 * </li>
	 * </ol>
	 *
	 * Full details for these steps can be found:
	 *
	 * <ul>
	 * <li>http://google.github.io/material-design-icons/</li>
	 * <li>http://google.github.io/material-design-icons/#icon-font-for-the-web</li>
	 * </ul>
	 *
	 * The Material Design icon style <code>.material-icons</code> and the icon font references are published in
	 * Material Design Icons:
	 *
	 * <ul>
	 * <li>https://design.google.com/icons/</li>
	 * <li>https://design.google.com/icons/#ic_accessibility</li>
	 * </ul>
	 *
	 * ### Localization
	 *
	 * Because an `md-icon` element's text content is not intended to be translated, it is recommended to declare the text
	 * content for an `md-icon` element in its start tag. Instead of using the HTML text content, consider using `ng-bind`
	 * with a scope variable or literal string.
	 *
	 * Examples:
	 *
	 * <ul>
	 *   <li>`<md-icon ng-bind="myIconVariable"></md-icon>`</li>
	 *   <li>`<md-icon ng-bind="'menu'"></md-icon>`
	 * </ul>
	 *
	 * <h2 id="material_design_icons">Material Design Icons</h2>
	 * Using the Material Design Icon-Selector, developers can easily and quickly search for a Material Design font-icon and
	 * determine its textual name and character reference code. Click on any icon to see the slide-up information
	 * panel with details regarding a SVG download or information on the font-icon usage.
	 *
	 * <a href="https://www.google.com/design/icons/#ic_accessibility" target="_blank" style="border-bottom:none;">
	 * <img src="https://cloud.githubusercontent.com/assets/210413/7902490/fe8dd14c-0780-11e5-98fb-c821cc6475e6.png"
	 *      aria-label="Material Design Icon-Selector" style="max-width:75%;padding-left:10%">
	 * </a>
	 *
	 * <span class="image_caption">
	 *  Click on the image above to link to the
	 *  <a href="https://design.google.com/icons/#ic_accessibility" target="_blank">Material Design Icon-Selector</a>.
	 * </span>
	 *
	 * @param {string} md-font-icon String name of CSS icon associated with the font-face will be used
	 * to render the icon. Requires the fonts and the named CSS styles to be preloaded.
	 * @param {string} md-font-set CSS style name associated with the font library; which will be assigned as
	 * the class for the font-icon ligature. This value may also be an alias that is used to lookup the classname;
	 * internally use `$mdIconProvider.fontSet(<alias>)` to determine the style name.
	 * @param {string} md-svg-src String URL (or expression) used to load, cache, and display an
	 *     external SVG.
	 * @param {string} md-svg-icon md-svg-icon String name used for lookup of the icon from the internal cache;
	 *     interpolated strings or expressions may also be used. Specific set names can be used with
	 *     the syntax `<set name>:<icon name>`.<br/><br/>
	 * To use icon sets, developers are required to pre-register the sets using the `$mdIconProvider` service.
	 * @param {string=} aria-label Labels icon for accessibility. If an empty string is provided, icon
	 * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no aria-label on the icon
	 * nor a label on the parent element, a warning will be logged to the console.
	 * @param {string=} alt Labels icon for accessibility. If an empty string is provided, icon
	 * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no alt on the icon
	 * nor a label on the parent element, a warning will be logged to the console.
	 *
	 * @usage
	 * When using SVGs:
	 * <hljs lang="html">
	 *
	 *  <!-- Icon ID; may contain optional icon set prefix; icons must registered using $mdIconProvider -->
	 *  <md-icon md-svg-icon="social:android"    aria-label="android " ></md-icon>
	 *
	 *  <!-- Icon urls; may be preloaded in templateCache -->
	 *  <md-icon md-svg-src="/android.svg"       aria-label="android " ></md-icon>
	 *  <md-icon md-svg-src="{{ getAndroid() }}" aria-label="android " ></md-icon>
	 *
	 * </hljs>
	 *
	 * Use the <code>$mdIconProvider</code> to configure your application with
	 * svg iconsets.
	 *
	 * <hljs lang="js">
	 *  angular.module('appSvgIconSets', ['ngMaterial'])
	 *    .controller('DemoCtrl', function($scope) {})
	 *    .config(function($mdIconProvider) {
	 *      $mdIconProvider
	 *         .iconSet('social', 'img/icons/sets/social-icons.svg', 24)
	 *         .defaultIconSet('img/icons/sets/core-icons.svg', 24);
	 *     });
	 * </hljs>
	 *
	 *
	 * When using Font Icons with classnames:
	 * <hljs lang="html">
	 *
	 *  <md-icon md-font-icon="android" aria-label="android" ></md-icon>
	 *  <md-icon class="icon_home"      aria-label="Home"    ></md-icon>
	 *
	 * </hljs>
	 *
	 * When using Material Font Icons with ligatures:
	 * <hljs lang="html">
	 *  <!--
	 *  For Material Design Icons
	 *  The class '.material-icons' is auto-added if a style has NOT been specified
	 *  since `material-icons` is the default fontset. So your markup:
	 *  -->
	 *  <md-icon> face </md-icon>
	 *  <!-- becomes this at runtime: -->
	 *  <md-icon md-font-set="material-icons"> face </md-icon>
	 *  <!-- If the fontset does not support ligature names, then we need to use the ligature unicode.-->
	 *  <md-icon> &#xE87C; </md-icon>
	 *  <!-- The class '.material-icons' must be manually added if other styles are also specified-->
	 *  <md-icon class="material-icons md-light md-48"> face </md-icon>
	 * </hljs>
	 *
	 * When using other Font-Icon libraries:
	 *
	 * <hljs lang="js">
	 *  // Specify a font-icon style alias
	 *  angular.config(function($mdIconProvider) {
	 *    $mdIconProvider.fontSet('md', 'material-icons');
	 *  });
	 * </hljs>
	 *
	 * <hljs lang="html">
	 *  <md-icon md-font-set="md">favorite</md-icon>
	 * </hljs>
	 *
	 */
	function mdIconDirective($mdIcon, $mdTheming, $mdAria, $sce) {
	
	  return {
	    restrict: 'E',
	    link : postLink
	  };
	
	
	  /**
	   * Directive postLink
	   * Supports embedded SVGs, font-icons, & external SVGs
	   */
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	    var lastFontIcon = attr.mdFontIcon;
	    var lastFontSet = $mdIcon.fontSet(attr.mdFontSet);
	
	    prepareForFontIcon();
	
	    attr.$observe('mdFontIcon', fontIconChanged);
	    attr.$observe('mdFontSet', fontIconChanged);
	
	    // Keep track of the content of the svg src so we can compare against it later to see if the
	    // attribute is static (and thus safe).
	    var originalSvgSrc = element[0].getAttribute(attr.$attr.mdSvgSrc);
	
	    // If using a font-icon, then the textual name of the icon itself
	    // provides the aria-label.
	
	    var attrName = attr.$normalize(attr.$attr.mdSvgIcon || attr.$attr.mdSvgSrc || '');
	
	    /* Provide a default accessibility role of img */
	    if (!attr.role) {
	      $mdAria.expect(element, 'role', 'img');
	      /* manually update attr variable */
	      attr.role = 'img';
	    }
	
	    /* Don't process ARIA if already valid */
	    if ( attr.role === "img" && !attr.ariaHidden && !$mdAria.hasAriaLabel(element) ) {
	      var iconName;
	      if (attr.alt) {
	        /* Use alt text by default if available */
	        $mdAria.expect(element, 'aria-label', attr.alt);
	      } else if ($mdAria.parentHasAriaLabel(element, 2)) {
	        /* Parent has ARIA so we will assume it will describe the image */
	        $mdAria.expect(element, 'aria-hidden', 'true');
	      } else if (iconName = (attr.mdFontIcon || attr.mdSvgIcon || element.text())) {
	        /* Use icon name as aria-label */
	        $mdAria.expect(element, 'aria-label', iconName);
	      } else {
	        /* No label found */
	        $mdAria.expect(element, 'aria-hidden', 'true');
	      }
	    }
	
	    if (attrName) {
	      // Use either pre-configured SVG or URL source, respectively.
	      attr.$observe(attrName, function(attrVal) {
	        element.empty();
	        if (attrVal) {
	          $mdIcon(attrVal)
	            .then(function(svg) {
	            element.empty();
	            element.append(svg);
	          });
	        }
	      });
	    }
	
	    function prepareForFontIcon() {
	      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
	        if (attr.mdFontIcon) {
	          element.addClass('md-font ' + attr.mdFontIcon);
	        }
	
	        element.addClass(lastFontSet);
	      }
	    }
	
	    function fontIconChanged() {
	      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
	        if (attr.mdFontIcon) {
	          element.removeClass(lastFontIcon);
	          element.addClass(attr.mdFontIcon);
	
	          lastFontIcon = attr.mdFontIcon;
	        }
	
	        var fontSet = $mdIcon.fontSet(attr.mdFontSet);
	
	        if (lastFontSet !== fontSet) {
	          element.removeClass(lastFontSet);
	          element.addClass(fontSet);
	
	          lastFontSet = fontSet;
	        }
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	  
	MdIconService.$inject = ["config", "$templateRequest", "$q", "$log", "$mdUtil", "$sce"];angular
	    .module('material.components.icon')
	    .constant('$$mdSvgRegistry', {
	        'mdTabsArrow':   'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwb2x5Z29uIHBvaW50cz0iMTUuNCw3LjQgMTQsNiA4LDEyIDE0LDE4IDE1LjQsMTYuNiAxMC44LDEyICIvPjwvZz48L3N2Zz4=',
	        'mdClose':       'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=',
	        'mdCancel':      'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xMiAyYy01LjUzIDAtMTAgNC40Ny0xMCAxMHM0LjQ3IDEwIDEwIDEwIDEwLTQuNDcgMTAtMTAtNC40Ny0xMC0xMC0xMHptNSAxMy41OWwtMS40MSAxLjQxLTMuNTktMy41OS0zLjU5IDMuNTktMS40MS0xLjQxIDMuNTktMy41OS0zLjU5LTMuNTkgMS40MS0xLjQxIDMuNTkgMy41OSAzLjU5LTMuNTkgMS40MSAxLjQxLTMuNTkgMy41OSAzLjU5IDMuNTl6Ii8+PC9nPjwvc3ZnPg==',
	        'mdMenu':        'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0zLDZIMjFWOEgzVjZNMywxMUgyMVYxM0gzVjExTTMsMTZIMjFWMThIM1YxNloiIC8+PC9zdmc+',
	        'mdToggleArrow': 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiPjxwYXRoIGQ9Ik0yNCAxNmwtMTIgMTIgMi44MyAyLjgzIDkuMTctOS4xNyA5LjE3IDkuMTcgMi44My0yLjgzeiIvPjxwYXRoIGQ9Ik0wIDBoNDh2NDhoLTQ4eiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg==',
	        'mdCalendar':    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkgM2gtMVYxaC0ydjJIOFYxSDZ2Mkg1Yy0xLjExIDAtMS45OS45LTEuOTkgMkwzIDE5YzAgMS4xLjg5IDIgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjVjMC0xLjEtLjktMi0yLTJ6bTAgMTZINVY4aDE0djExek03IDEwaDV2NUg3eiIvPjwvc3ZnPg==',
	        'mdChecked':     'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik05IDE2LjE3TDQuODMgMTJsLTEuNDIgMS40MUw5IDE5IDIxIDdsLTEuNDEtMS40MXoiLz48L2c+PC9zdmc+'
	    })
	    .provider('$mdIcon', MdIconProvider);
	
	/**
	 * @ngdoc service
	 * @name $mdIconProvider
	 * @module material.components.icon
	 *
	 * @description
	 * `$mdIconProvider` is used only to register icon IDs with URLs. These configuration features allow
	 * icons and icon sets to be pre-registered and associated with source URLs **before** the `<md-icon />`
	 * directives are compiled.
	 *
	 * If using font-icons, the developer is responsible for loading the fonts.
	 *
	 * If using SVGs, loading of the actual svg files are deferred to on-demand requests and are loaded
	 * internally by the `$mdIcon` service using the `$templateRequest` service. When an SVG is
	 * requested by name/ID, the `$mdIcon` service searches its registry for the associated source URL;
	 * that URL is used to on-demand load and parse the SVG dynamically.
	 *
	 * The `$templateRequest` service expects the icons source to be loaded over trusted URLs.<br/>
	 * This means, when loading icons from an external URL, you have to trust the URL in the `$sceDelegateProvider`.
	 *
	 * <hljs lang="js">
	 *   app.config(function($sceDelegateProvider) {
	 *     $sceDelegateProvider.resourceUrlWhitelist([
	 *       // Adding 'self' to the whitelist, will allow requests from the current origin.
	 *       'self',
	 *       // Using double asterisks here, will allow all URLs to load.
	 *       // We recommend to only specify the given domain you want to allow.
	 *       '**'
	 *     ]);
	 *   });
	 * </hljs>
	 *
	 * Read more about the [$sceDelegateProvider](https://docs.angularjs.org/api/ng/provider/$sceDelegateProvider).
	 *
	 * **Notice:** Most font-icons libraries do not support ligatures (for example `fontawesome`).<br/>
	 *  In such cases you are not able to use the icon's ligature name - Like so:
	 *
	 *  <hljs lang="html">
	 *    <md-icon md-font-set="fa">fa-bell</md-icon>
	 *  </hljs>
	 *
	 * You should instead use the given unicode, instead of the ligature name.
	 *
	 * <p ng-hide="true"> ##// Notice we can't use a hljs element here, because the characters will be escaped.</p>
	 *  ```html
	 *    <md-icon md-font-set="fa">&#xf0f3</md-icon>
	 *  ```
	 *
	 * All unicode ligatures are prefixed with the `&#x` string.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultFontSet( 'fa' )                   // This sets our default fontset className.
	    *          .defaultIconSet('my/app/icons.svg')       // Register a default set of SVG icons
	    *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set of SVGs
	    *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
	    *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
	    *   });
	 * </hljs>
	 *
	 * SVG icons and icon sets can be easily pre-loaded and cached using either (a) a build process or (b) a runtime
	 * **startup** process (shown below):
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Register a default set of SVG icon definitions
	    *     $mdIconProvider.defaultIconSet('my/app/icons.svg')
	    *
	    *   })
	 *   .run(function($templateRequest){
	    *
	    *     // Pre-fetch icons sources by URL and cache in the $templateCache...
	    *     // subsequent $templateRequest calls will look there first.
	    *
	    *     var urls = [ 'imy/app/icons.svg', 'img/icons/android.svg'];
	    *
	    *     angular.forEach(urls, function(url) {
	    *       $templateRequest(url);
	    *     });
	    *
	    *   });
	 *
	 * </hljs>
	 *
	 * > <b>Note:</b> The loaded SVG data is subsequently cached internally for future requests.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#icon
	 *
	 * @description
	 * Register a source URL for a specific icon name; the name may include optional 'icon set' name prefix.
	 * These icons  will later be retrieved from the cache using `$mdIcon( <icon name> )`
	 *
	 * @param {string} id Icon name/id used to register the icon
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height the icon's viewBox.
	 * It is ignored for icons with an existing viewBox. Default size is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
	    *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
	    *   });
	 * </hljs>
	 *
	 */
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#iconSet
	 *
	 * @description
	 * Register a source URL for a 'named' set of icons; group of SVG definitions where each definition
	 * has an icon id. Individual icons can be subsequently retrieved from this cached set using
	 * `$mdIcon(<icon set name>:<icon name>)`
	 *
	 * @param {string} id Icon name/id used to register the iconset
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
	 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
	 * Default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set
	    *   });
	 * </hljs>
	 *
	 */
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultIconSet
	 *
	 * @description
	 * Register a source URL for the default 'named' set of icons. Unless explicitly registered,
	 * subsequent lookups of icons will failover to search this 'default' icon set.
	 * Icon can be retrieved from this cached, default set using `$mdIcon(<name>)`
	 *
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
	 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
	 * Default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultIconSet( 'my/app/social.svg' )   // Register a default icon set
	    *   });
	 * </hljs>
	 *
	 */
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultFontSet
	 *
	 * @description
	 * When using Font-Icons, AngularJS Material assumes the the Material Design icons will be used and automatically
	 * configures the default font-set == 'material-icons'. Note that the font-set references the font-icon library
	 * class style that should be applied to the `<md-icon>`.
	 *
	 * Configuring the default means that the attributes
	 * `md-font-set="material-icons"` or `class="material-icons"` do not need to be explicitly declared on the
	 * `<md-icon>` markup. For example:
	 *
	 *  `<md-icon> face </md-icon>`
	 *  will render as
	 *  `<span class="material-icons"> face </span>`, and
	 *
	 *  `<md-icon md-font-set="fa"> face </md-icon>`
	 *  will render as
	 *  `<span class="fa"> face </span>`
	 *
	 * @param {string} name of the font-library style that should be applied to the md-icon DOM element
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	   *     $mdIconProvider.defaultFontSet( 'fa' );
	   *   });
	 * </hljs>
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#fontSet
	 *
	 * @description
	 * When using a font set for `<md-icon>` you must specify the correct font classname in the `md-font-set`
	 * attribute. If the fonset className is really long, your markup may become cluttered... an easy
	 * solution is to define an `alias` for your fontset:
	 *
	 * @param {string} alias of the specified fontset.
	 * @param {string} className of the fontset.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	   *     // In this case, we set an alias for the `material-icons` fontset.
	   *     $mdIconProvider.fontSet('md', 'material-icons');
	   *   });
	 * </hljs>
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultViewBoxSize
	 *
	 * @description
	 * While `<md-icon />` markup can also be style with sizing CSS, this method configures
	 * the default width **and** height used for all icons; unless overridden by specific CSS.
	 * The default sizing is (24px, 24px).
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox for an icon or an icon set.
	 * All icons in a set should be the same size. The default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultViewBoxSize(36)   // Register a default icon size (width == height)
	    *   });
	 * </hljs>
	 *
	 */
	
	var config = {
	  defaultViewBoxSize: 24,
	  defaultFontSet: 'material-icons',
	  fontSets: []
	};
	
	function MdIconProvider() {
	}
	
	MdIconProvider.prototype = {
	  icon: function(id, url, viewBoxSize) {
	    if (id.indexOf(':') == -1) id = '$default:' + id;
	
	    config[id] = new ConfigurationItem(url, viewBoxSize);
	    return this;
	  },
	
	  iconSet: function(id, url, viewBoxSize) {
	    config[id] = new ConfigurationItem(url, viewBoxSize);
	    return this;
	  },
	
	  defaultIconSet: function(url, viewBoxSize) {
	    var setName = '$default';
	
	    if (!config[setName]) {
	      config[setName] = new ConfigurationItem(url, viewBoxSize);
	    }
	
	    config[setName].viewBoxSize = viewBoxSize || config.defaultViewBoxSize;
	
	    return this;
	  },
	
	  defaultViewBoxSize: function(viewBoxSize) {
	    config.defaultViewBoxSize = viewBoxSize;
	    return this;
	  },
	
	  /**
	   * Register an alias name associated with a font-icon library style ;
	   */
	  fontSet: function fontSet(alias, className) {
	    config.fontSets.push({
	      alias: alias,
	      fontSet: className || alias
	    });
	    return this;
	  },
	
	  /**
	   * Specify a default style name associated with a font-icon library
	   * fallback to Material Icons.
	   *
	   */
	  defaultFontSet: function defaultFontSet(className) {
	    config.defaultFontSet = !className ? '' : className;
	    return this;
	  },
	
	  defaultIconSize: function defaultIconSize(iconSize) {
	    config.defaultIconSize = iconSize;
	    return this;
	  },
	
	  $get: ['$templateRequest', '$q', '$log', '$mdUtil', '$sce', function($templateRequest, $q, $log, $mdUtil, $sce) {
	    return MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce);
	  }]
	};
	
	/**
	 *  Configuration item stored in the Icon registry; used for lookups
	 *  to load if not already cached in the `loaded` cache
	 */
	function ConfigurationItem(url, viewBoxSize) {
	  this.url = url;
	  this.viewBoxSize = viewBoxSize || config.defaultViewBoxSize;
	}
	
	/**
	 * @ngdoc service
	 * @name $mdIcon
	 * @module material.components.icon
	 *
	 * @description
	 * The `$mdIcon` service is a function used to lookup SVG icons.
	 *
	 * @param {string} id Query value for a unique Id or URL. If the argument is a URL, then the service will retrieve the icon element
	 * from its internal cache or load the icon and cache it first. If the value is not a URL-type string, then an ID lookup is
	 * performed. The Id may be a unique icon ID or may include an iconSet ID prefix.
	 *
	 * For the **id** query to work properly, this means that all id-to-URL mappings must have been previously configured
	 * using the `$mdIconProvider`.
	 *
	 * @returns {angular.$q.Promise} A promise that gets resolved to a clone of the initial SVG DOM element; which was
	 * created from the SVG markup in the SVG data file. If an error occurs (e.g. the icon cannot be found) the promise
	 * will get rejected.
	 *
	 * @usage
	 * <hljs lang="js">
	 * function SomeDirective($mdIcon) {
	  *
	  *   // See if the icon has already been loaded, if not
	  *   // then lookup the icon from the registry cache, load and cache
	  *   // it for future requests.
	  *   // NOTE: ID queries require configuration with $mdIconProvider
	  *
	  *   $mdIcon('android').then(function(iconEl)    { element.append(iconEl); });
	  *   $mdIcon('work:chair').then(function(iconEl) { element.append(iconEl); });
	  *
	  *   // Load and cache the external SVG using a URL
	  *
	  *   $mdIcon('img/icons/android.svg').then(function(iconEl) {
	  *     element.append(iconEl);
	  *   });
	  * };
	 * </hljs>
	 *
	 * > <b>Note:</b> The `<md-icon>` directive internally uses the `$mdIcon` service to query, loaded,
	 *   and instantiate SVG DOM elements.
	 */
	
	/* @ngInject */
	function MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce) {
	  var iconCache = {};
	  var svgCache = {};
	  var urlRegex = /[-\w@:%+.~#?&//=]{2,}\.[a-z]{2,4}\b(\/[-\w@:%+.~#?&//=]*)?/i;
	  var dataUrlRegex = /^data:image\/svg\+xml[\s*;\w\-=]*?(base64)?,(.*)$/i;
	
	  Icon.prototype = {clone: cloneSVG, prepare: prepareAndStyle};
	  getIcon.fontSet = findRegisteredFontSet;
	
	  // Publish service...
	  return getIcon;
	
	  /**
	   * Actual $mdIcon service is essentially a lookup function
	   */
	  function getIcon(id) {
	    id = id || '';
	
	    // If the "id" provided is not a string, the only other valid value is a $sce trust wrapper
	    // over a URL string. If the value is not trusted, this will intentionally throw an error
	    // because the user is attempted to use an unsafe URL, potentially opening themselves up
	    // to an XSS attack.
	    if (!angular.isString(id)) {
	      id = $sce.getTrustedUrl(id);
	    }
	
	    // If already loaded and cached, use a clone of the cached icon.
	    // Otherwise either load by URL, or lookup in the registry and then load by URL, and cache.
	
	    if (iconCache[id]) {
	      return $q.when(transformClone(iconCache[id]));
	    }
	
	    if (urlRegex.test(id) || dataUrlRegex.test(id)) {
	      return loadByURL(id).then(cacheIcon(id));
	    }
	
	    if (id.indexOf(':') == -1) {
	      id = '$default:' + id;
	    }
	
	    var load = config[id] ? loadByID : loadFromIconSet;
	    return load(id)
	      .then(cacheIcon(id));
	  }
	
	  /**
	   * Lookup registered fontSet style using its alias...
	   * If not found,
	   */
	  function findRegisteredFontSet(alias) {
	    var useDefault = angular.isUndefined(alias) || !(alias && alias.length);
	    if (useDefault) return config.defaultFontSet;
	
	    var result = alias;
	    angular.forEach(config.fontSets, function(it) {
	      if (it.alias == alias) result = it.fontSet || result;
	    });
	
	    return result;
	  }
	
	  function transformClone(cacheElement) {
	    var clone = cacheElement.clone();
	    var cacheSuffix = '_cache' + $mdUtil.nextUid();
	
	    // We need to modify for each cached icon the id attributes.
	    // This is needed because SVG id's are treated as normal DOM ids
	    // and should not have a duplicated id.
	    if (clone.id) clone.id += cacheSuffix;
	    angular.forEach(clone.querySelectorAll('[id]'), function(item) {
	      item.id += cacheSuffix;
	    });
	
	    return clone;
	  }
	
	  /**
	   * Prepare and cache the loaded icon for the specified `id`
	   */
	  function cacheIcon(id) {
	
	    return function updateCache(icon) {
	      iconCache[id] = isIcon(icon) ? icon : new Icon(icon, config[id]);
	
	      return iconCache[id].clone();
	    };
	  }
	
	  /**
	   * Lookup the configuration in the registry, if !registered throw an error
	   * otherwise load the icon [on-demand] using the registered URL.
	   *
	   */
	  function loadByID(id) {
	    var iconConfig = config[id];
	    return loadByURL(iconConfig.url).then(function(icon) {
	      return new Icon(icon, iconConfig);
	    });
	  }
	
	  /**
	   *    Loads the file as XML and uses querySelector( <id> ) to find
	   *    the desired node...
	   */
	  function loadFromIconSet(id) {
	    var setName = id.substring(0, id.lastIndexOf(':')) || '$default';
	    var iconSetConfig = config[setName];
	
	    return !iconSetConfig ? announceIdNotFound(id) : loadByURL(iconSetConfig.url).then(extractFromSet);
	
	    function extractFromSet(set) {
	      var iconName = id.slice(id.lastIndexOf(':') + 1);
	      var icon = set.querySelector('#' + iconName);
	      return icon ? new Icon(icon, iconSetConfig) : announceIdNotFound(id);
	    }
	
	    function announceIdNotFound(id) {
	      var msg = 'icon ' + id + ' not found';
	      $log.warn(msg);
	
	      return $q.reject(msg || id);
	    }
	  }
	
	  /**
	   * Load the icon by URL (may use the $templateCache).
	   * Extract the data for later conversion to Icon
	   */
	  function loadByURL(url) {
	    /* Load the icon from embedded data URL. */
	    function loadByDataUrl(url) {
	      var results = dataUrlRegex.exec(url);
	      var isBase64 = /base64/i.test(url);
	      var data = isBase64 ? window.atob(results[2]) : results[2];
	
	      return $q.when(angular.element(data)[0]);
	    }
	
	    /* Load the icon by URL using HTTP. */
	    function loadByHttpUrl(url) {
	      return $q(function(resolve, reject) {
	        // Catch HTTP or generic errors not related to incorrect icon IDs.
	        var announceAndReject = function(err) {
	            var msg = angular.isString(err) ? err : (err.message || err.data || err.statusText);
	            $log.warn(msg);
	            reject(err);
	          },
	          extractSvg = function(response) {
	            if (!svgCache[url]) {
	              svgCache[url] = angular.element('<div>').append(response)[0].querySelector('svg');
	            }
	            resolve(svgCache[url]);
	          };
	
	        $templateRequest(url, true).then(extractSvg, announceAndReject);
	      });
	    }
	
	    return dataUrlRegex.test(url)
	      ? loadByDataUrl(url)
	      : loadByHttpUrl(url);
	  }
	
	  /**
	   * Check target signature to see if it is an Icon instance.
	   */
	  function isIcon(target) {
	    return angular.isDefined(target.element) && angular.isDefined(target.config);
	  }
	
	  /**
	   *  Define the Icon class
	   */
	  function Icon(el, config) {
	    // If the node is a <symbol>, it won't be rendered so we have to convert it into <svg>.
	    if (el && el.tagName.toLowerCase() === 'symbol') {
	      var viewbox = el.getAttribute('viewBox');
	      el = angular.element('<svg xmlns="http://www.w3.org/2000/svg">').html(el.innerHTML)[0];
	      if (viewbox) el.setAttribute('viewBox', viewbox);
	    }
	
	    if (el && el.tagName.toLowerCase() !== 'svg') {
	      el = angular.element('<svg xmlns="http://www.w3.org/2000/svg">').append(el.cloneNode(true))[0];
	    }
	
	    // Inject the namespace if not available...
	    if (!el.getAttribute('xmlns')) {
	      el.setAttribute('xmlns', "http://www.w3.org/2000/svg");
	    }
	
	    this.element = el;
	    this.config = config;
	    this.prepare();
	  }
	
	  /**
	   *  Prepare the DOM element that will be cached in the
	   *  loaded iconCache store.
	   */
	  function prepareAndStyle() {
	    var viewBoxSize = this.config ? this.config.viewBoxSize : config.defaultViewBoxSize;
	    angular.forEach({
	      'fit': '',
	      'height': '100%',
	      'width': '100%',
	      'preserveAspectRatio': 'xMidYMid meet',
	      'viewBox': this.element.getAttribute('viewBox') || ('0 0 ' + viewBoxSize + ' ' + viewBoxSize),
	      'focusable': false // Disable IE11s default behavior to make SVGs focusable
	    }, function(val, attr) {
	      this.element.setAttribute(attr, val);
	    }, this);
	  }
	
	  /**
	   * Clone the Icon DOM element.
	   */
	  function cloneSVG() {
	    // If the element or any of its children have a style attribute, then a CSP policy without
	    // 'unsafe-inline' in the style-src directive, will result in a violation.
	    return this.element.cloneNode(true);
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	
	
	MenuController.$inject = ["$mdMenu", "$attrs", "$element", "$scope", "$mdUtil", "$timeout", "$rootScope", "$q", "$log"];
	angular
	    .module('material.components.menu')
	    .controller('mdMenuCtrl', MenuController);
	
	/**
	 * @ngInject
	 */
	function MenuController($mdMenu, $attrs, $element, $scope, $mdUtil, $timeout, $rootScope, $q, $log) {
	
	  var prefixer = $mdUtil.prefixer();
	  var menuContainer;
	  var self = this;
	  var triggerElement;
	
	  this.nestLevel = parseInt($attrs.mdNestLevel, 10) || 0;
	
	  /**
	   * Called by our linking fn to provide access to the menu-content
	   * element removed during link
	   */
	  this.init = function init(setMenuContainer, opts) {
	    opts = opts || {};
	    menuContainer = setMenuContainer;
	
	    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
	    triggerElement = $element[0].querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter']));
	    triggerElement.setAttribute('aria-expanded', 'false');
	
	    this.isInMenuBar = opts.isInMenuBar;
	    this.nestedMenus = $mdUtil.nodesToArray(menuContainer[0].querySelectorAll('.md-nested-menu'));
	
	    menuContainer.on('$mdInterimElementRemove', function() {
	      self.isOpen = false;
	      $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	    });
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	
	    var menuContainerId = 'menu_container_' + $mdUtil.nextUid();
	    menuContainer.attr('id', menuContainerId);
	    angular.element(triggerElement).attr({
	      'aria-owns': menuContainerId,
	      'aria-haspopup': 'true'
	    });
	
	    $scope.$on('$destroy', angular.bind(this, function() {
	      this.disableHoverListener();
	      $mdMenu.destroy();
	    }));
	
	    menuContainer.on('$destroy', function() {
	      $mdMenu.destroy();
	    });
	  };
	
	  var openMenuTimeout, menuItems, deregisterScopeListeners = [];
	  this.enableHoverListener = function() {
	    deregisterScopeListeners.push($rootScope.$on('$mdMenuOpen', function(event, el) {
	      if (menuContainer[0].contains(el[0])) {
	        self.currentlyOpenMenu = el.controller('mdMenu');
	        self.isAlreadyOpening = false;
	        self.currentlyOpenMenu.registerContainerProxy(self.triggerContainerProxy.bind(self));
	      }
	    }));
	    deregisterScopeListeners.push($rootScope.$on('$mdMenuClose', function(event, el) {
	      if (menuContainer[0].contains(el[0])) {
	        self.currentlyOpenMenu = undefined;
	      }
	    }));
	    menuItems = angular.element($mdUtil.nodesToArray(menuContainer[0].children[0].children));
	    menuItems.on('mouseenter', self.handleMenuItemHover);
	    menuItems.on('mouseleave', self.handleMenuItemMouseLeave);
	  };
	
	  this.disableHoverListener = function() {
	    while (deregisterScopeListeners.length) {
	      deregisterScopeListeners.shift()();
	    }
	    menuItems && menuItems.off('mouseenter', self.handleMenuItemHover);
	    menuItems && menuItems.off('mouseleave', self.handleMenuItemMouseLeave);
	  };
	
	  this.handleMenuItemHover = function(event) {
	    if (self.isAlreadyOpening) return;
	    var nestedMenu = (
	      event.target.querySelector('md-menu')
	        || $mdUtil.getClosest(event.target, 'MD-MENU')
	    );
	    openMenuTimeout = $timeout(function() {
	      if (nestedMenu) {
	        nestedMenu = angular.element(nestedMenu).controller('mdMenu');
	      }
	
	      if (self.currentlyOpenMenu && self.currentlyOpenMenu != nestedMenu) {
	        var closeTo = self.nestLevel + 1;
	        self.currentlyOpenMenu.close(true, { closeTo: closeTo });
	        self.isAlreadyOpening = !!nestedMenu;
	        nestedMenu && nestedMenu.open();
	      } else if (nestedMenu && !nestedMenu.isOpen && nestedMenu.open) {
	        self.isAlreadyOpening = !!nestedMenu;
	        nestedMenu && nestedMenu.open();
	      }
	    }, nestedMenu ? 100 : 250);
	    var focusableTarget = event.currentTarget.querySelector('.md-button:not([disabled])');
	    focusableTarget && focusableTarget.focus();
	  };
	
	  this.handleMenuItemMouseLeave = function() {
	    if (openMenuTimeout) {
	      $timeout.cancel(openMenuTimeout);
	      openMenuTimeout = undefined;
	    }
	  };
	
	
	  /**
	   * Uses the $mdMenu interim element service to open the menu contents
	   */
	  this.open = function openMenu(ev) {
	    ev && ev.stopPropagation();
	    ev && ev.preventDefault();
	    if (self.isOpen) return;
	    self.enableHoverListener();
	    self.isOpen = true;
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	    triggerElement = triggerElement || (ev ? ev.target : $element[0]);
	    triggerElement.setAttribute('aria-expanded', 'true');
	    $scope.$emit('$mdMenuOpen', $element);
	    $mdMenu.show({
	      scope: $scope,
	      mdMenuCtrl: self,
	      nestLevel: self.nestLevel,
	      element: menuContainer,
	      target: triggerElement,
	      preserveElement: true,
	      parent: 'body'
	    }).finally(function() {
	      triggerElement.setAttribute('aria-expanded', 'false');
	      self.disableHoverListener();
	    });
	  };
	
	  this.onIsOpenChanged = function(isOpen) {
	    if (isOpen) {
	      menuContainer.attr('aria-hidden', 'false');
	      $element[0].classList.add('md-open');
	      angular.forEach(self.nestedMenus, function(el) {
	        el.classList.remove('md-open');
	      });
	    } else {
	      menuContainer.attr('aria-hidden', 'true');
	      $element[0].classList.remove('md-open');
	    }
	    $scope.$mdMenuIsOpen = self.isOpen;
	  };
	
	  this.focusMenuContainer = function focusMenuContainer() {
	    var focusTarget = menuContainer[0]
	      .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));
	
	    if (!focusTarget) focusTarget = menuContainer[0].querySelector('.md-button:not([disabled])');
	    focusTarget.focus();
	  };
	
	  this.registerContainerProxy = function registerContainerProxy(handler) {
	    this.containerProxy = handler;
	  };
	
	  this.triggerContainerProxy = function triggerContainerProxy(ev) {
	    this.containerProxy && this.containerProxy(ev);
	  };
	
	  this.destroy = function() {
	    return self.isOpen ? $mdMenu.destroy() : $q.when(false);
	  };
	
	  // Use the $mdMenu interim element service to close the menu contents
	  this.close = function closeMenu(skipFocus, closeOpts) {
	    if ( !self.isOpen ) return;
	    self.isOpen = false;
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	
	    var eventDetails = angular.extend({}, closeOpts, { skipFocus: skipFocus });
	    $scope.$emit('$mdMenuClose', $element, eventDetails);
	    $mdMenu.hide(null, closeOpts);
	
	    if (!skipFocus) {
	      var el = self.restoreFocusTo || $element.find('button')[0];
	      if (el instanceof angular.element) el = el[0];
	      if (el) el.focus();
	    }
	  };
	
	  /**
	   * Build a nice object out of our string attribute which specifies the
	   * target mode for left and top positioning
	   */
	  this.positionMode = function positionMode() {
	    var attachment = ($attrs.mdPositionMode || 'target').split(' ');
	
	    // If attachment is a single item, duplicate it for our second value.
	    // ie. 'target' -> 'target target'
	    if (attachment.length === 1) {
	      attachment.push(attachment[0]);
	    }
	
	    return {
	      left: attachment[0],
	      top: attachment[1]
	    };
	  };
	
	  /**
	   * Build a nice object out of our string attribute which specifies
	   * the offset of top and left in pixels.
	   */
	  this.offsets = function offsets() {
	    var position = ($attrs.mdOffset || '0 0').split(' ').map(parseFloat);
	    if (position.length === 2) {
	      return {
	        left: position[0],
	        top: position[1]
	      };
	    } else if (position.length === 1) {
	      return {
	        top: position[0],
	        left: position[0]
	      };
	    } else {
	      throw Error('Invalid offsets specified. Please follow format <x, y> or <n>');
	    }
	  };
	
	  // Functionality that is exposed in the view.
	  $scope.$mdMenu = {
	    open: this.open,
	    close: this.close
	  };
	
	  // Deprecated APIs
	  $scope.$mdOpenMenu = angular.bind(this, function() {
	    $log.warn('mdMenu: The $mdOpenMenu method is deprecated. Please use `$mdMenu.open`.');
	    return this.open.apply(this, arguments);
	  });
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdMenu
	 * @module material.components.menu
	 * @restrict E
	 * @description
	 *
	 * Menus are elements that open when clicked. They are useful for displaying
	 * additional options within the context of an action.
	 *
	 * Every `md-menu` must specify exactly two child elements. The first element is what is
	 * left in the DOM and is used to open the menu. This element is called the trigger element.
	 * The trigger element's scope has access to `$mdMenu.open($event)`
	 * which it may call to open the menu. By passing $event as argument, the
	 * corresponding event is stopped from propagating up the DOM-tree. Similarly, `$mdMenu.close()`
	 * can be used to close the menu.
	 *
	 * The second element is the `md-menu-content` element which represents the
	 * contents of the menu when it is open. Typically this will contain `md-menu-item`s,
	 * but you can do custom content as well.
	 *
	 * <hljs lang="html">
	 * <md-menu>
	 *  <!-- Trigger element is a md-button with an icon -->
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open sample menu">
	 *    <md-icon md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	
	 * ## Sizing Menus
	 *
	 * The width of the menu when it is open may be specified by specifying a `width`
	 * attribute on the `md-menu-content` element.
	 * See the [Material Design Spec](https://material.io/guidelines/components/menus.html#menus-simple-menus)
	 * for more information.
	 *
	 *
	 * ## Aligning Menus
	 *
	 * When a menu opens, it is important that the content aligns with the trigger element.
	 * Failure to align menus can result in jarring experiences for users as content
	 * suddenly shifts. To help with this, `md-menu` provides several APIs to help
	 * with alignment.
	 *
	 * ### Target Mode
	 *
	 * By default, `md-menu` will attempt to align the `md-menu-content` by aligning
	 * designated child elements in both the trigger and the menu content.
	 *
	 * To specify the alignment element in the `trigger` you can use the `md-menu-origin`
	 * attribute on a child element. If no `md-menu-origin` is specified, the `md-menu`
	 * will be used as the origin element.
	 *
	 * Similarly, the `md-menu-content` may specify a `md-menu-align-target` for a
	 * `md-menu-item` to specify the node that it should try and align with.
	 *
	 * In this example code, we specify an icon to be our origin element, and an
	 * icon in our menu content to be our alignment target. This ensures that both
	 * icons are aligned when the menu opens.
	 *
	 * <hljs lang="html">
	 * <md-menu>
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open some menu">
	 *    <md-icon md-menu-origin md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item>
	 *      <md-button ng-click="doSomething()" aria-label="Do something">
	 *        <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
	 *        Do Something
	 *      </md-button>
	 *    </md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	 *
	 * ### Position Mode
	 *
	 * We can specify the origin of the menu by using the `md-position-mode` attribute.
	 * This attribute allows specifying the positioning by the `x` and `y` axes.
	 *
	 * The default mode is `target target`. This mode uses the left and top edges of the origin element
	 * to position the menu in LTR layouts. The `x` axis modes will adjust when in RTL layouts.
	 *
	 * Sometimes you want to specify alignment from the right side of a origin element. For example,
	 * if we have a menu on the right side a toolbar, we may want to right align our menu content.
	 * We can use `target-right target` to specify a right-oriented alignment target.
	 * There is a working example of this in the Menu Position Modes demo.
	 *
	 * #### Horizontal Positioning Options
	 * - `target`
	 * - `target-left`
	 * - `target-right`
	 * - `cascade`
	 * - `right`
	 * - `left`
	 *
	 * #### Vertical Positioning Options
	 * - `target`
	 * - `cascade`
	 * - `bottom`
	 *
	 * ### Menu Offsets
	 *
	 * It is sometimes unavoidable to need to have a deeper level of control for
	 * the positioning of a menu to ensure perfect alignment. `md-menu` provides
	 * the `md-offset` attribute to allow pixel-level specificity when adjusting
	 * menu positioning.
	 *
	 * This offset is provided in the format of `x y` or `n` where `n` will be used
	 * in both the `x` and `y` axis.
	 * For example, to move a menu by `2px` down from the top, we can use:
	 *
	 * <hljs lang="html">
	 * <md-menu md-offset="0 2">
	 *   <!-- menu-content -->
	 * </md-menu>
	 * </hljs>
	 *
	 * Specifying `md-offset="2 2"` would shift the menu two pixels down and two pixels to the right.
	 *
	 * ### Auto Focus
	 * By default, when a menu opens, `md-menu` focuses the first button in the menu content.
	 *
	 * Sometimes you would like to focus another menu item instead of the first.<br/>
	 * This can be done by applying the `md-autofocus` directive on the given element.
	 *
	 * <hljs lang="html">
	 * <md-menu-item>
	 *   <md-button md-autofocus ng-click="doSomething()">
	 *     Auto Focus
	 *   </md-button>
	 * </md-menu-item>
	 * </hljs>
	 *
	 *
	 * ### Preventing close
	 *
	 * Sometimes you would like to be able to click on a menu item without having the menu
	 * close. To do this, AngularJS Material exposes the `md-prevent-menu-close` attribute which
	 * can be added to a button inside a menu to stop the menu from automatically closing.
	 * You can then close the menu either by using `$mdMenu.close()` in the template,
	 * or programmatically by injecting `$mdMenu` and calling `$mdMenu.hide()`.
	 *
	 * <hljs lang="html">
	 * <md-menu-content ng-mouseleave="$mdMenu.close()">
	 *   <md-menu-item>
	 *     <md-button ng-click="doSomething()" aria-label="Do something" md-prevent-menu-close="md-prevent-menu-close">
	 *       <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
	 *       Do Something
	 *     </md-button>
	 *   </md-menu-item>
	 * </md-menu-content>
	 * </hljs>
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-menu>
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button">
	 *    <md-icon md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	 *
	 * @param {string=} md-position-mode Specify pre-defined position modes for the `x` and `y` axes.
	 *  The default modes are `target target`. This positions the origin of the menu using the left and top edges
	 *  of the origin element in LTR layouts.<br>
	 *  #### Valid modes for horizontal positioning
	 * - `target`
	 * - `target-left`
	 * - `target-right`
	 * - `cascade`
	 * - `right`
	 * - `left`<br>
	 *  #### Valid modes for vertical positioning
	 * - `target`
	 * - `cascade`
	 * - `bottom`
	 * @param {string=} md-offset An offset to apply to the dropdown on opening, after positioning.
	 *  Defined as `x` and `y` pixel offset values in the form of `x y`.<br>
	 *  The default value is `0 0`.
	 */
	MenuDirective.$inject = ["$mdUtil"];
	angular
	    .module('material.components.menu')
	    .directive('mdMenu', MenuDirective);
	
	/**
	 * @ngInject
	 */
	function MenuDirective($mdUtil) {
	  var INVALID_PREFIX = 'Invalid HTML for md-menu: ';
	  return {
	    restrict: 'E',
	    require: ['mdMenu', '?^mdMenuBar'],
	    controller: 'mdMenuCtrl', // empty function to be built by link
	    scope: true,
	    compile: compile
	  };
	
	  function compile(templateElement) {
	    templateElement.addClass('md-menu');
	
	    var triggerEl = templateElement.children()[0];
	    var prefixer = $mdUtil.prefixer();
	
	    if (!prefixer.hasAttribute(triggerEl, 'ng-click')) {
	      triggerEl = triggerEl
	          .querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter'])) || triggerEl;
	    }
	
	    var isButtonTrigger = triggerEl.nodeName === 'MD-BUTTON' || triggerEl.nodeName === 'BUTTON';
	
	    if (triggerEl && isButtonTrigger && !triggerEl.hasAttribute('type')) {
	      triggerEl.setAttribute('type', 'button');
	    }
	
	    if (!triggerEl) {
	      throw Error(INVALID_PREFIX + 'Expected the menu to have a trigger element.');
	    }
	
	    if (templateElement.children().length !== 2) {
	      throw Error(INVALID_PREFIX + 'Expected two children elements. The second element must have a `md-menu-content` element.');
	    }
	
	    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
	    triggerEl && triggerEl.setAttribute('aria-haspopup', 'true');
	
	    var nestedMenus = templateElement[0].querySelectorAll('md-menu');
	    var nestingDepth = parseInt(templateElement[0].getAttribute('md-nest-level'), 10) || 0;
	    if (nestedMenus) {
	      angular.forEach($mdUtil.nodesToArray(nestedMenus), function(menuEl) {
	        if (!menuEl.hasAttribute('md-position-mode')) {
	          menuEl.setAttribute('md-position-mode', 'cascade');
	        }
	        menuEl.classList.add('_md-nested-menu');
	        menuEl.setAttribute('md-nest-level', nestingDepth + 1);
	      });
	    }
	    return link;
	  }
	
	  function link(scope, element, attr, ctrls) {
	    var mdMenuCtrl = ctrls[0];
	    var isInMenuBar = !!ctrls[1];
	    // Move everything into a md-menu-container and pass it to the controller
	    var menuContainer = angular.element( '<div class="_md md-open-menu-container md-whiteframe-z2"></div>');
	    var menuContents = element.children()[1];
	
	    element.addClass('_md');     // private md component indicator for styling
	
	    if (!menuContents.hasAttribute('role')) {
	      menuContents.setAttribute('role', 'menu');
	    }
	    menuContainer.append(menuContents);
	
	    element.on('$destroy', function() {
	      menuContainer.remove();
	    });
	
	    element.append(menuContainer);
	    menuContainer[0].style.display = 'none';
	    mdMenuCtrl.init(menuContainer, { isInMenuBar: isInMenuBar });
	
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MenuProvider.$inject = ["$$interimElementProvider"];angular
	  .module('material.components.menu')
	  .provider('$mdMenu', MenuProvider);
	
	/*
	 * Interim element provider for the menu.
	 * Handles behavior for a menu while it is open, including:
	 *    - handling animating the menu opening/closing
	 *    - handling key/mouse events on the menu element
	 *    - handling enabling/disabling scroll while the menu is open
	 *    - handling redrawing during resizes and orientation changes
	 *
	 */
	
	function MenuProvider($$interimElementProvider) {
	  menuDefaultOptions.$inject = ["$mdUtil", "$mdTheming", "$mdConstant", "$document", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$log"];
	  var MENU_EDGE_MARGIN = 8;
	
	  return $$interimElementProvider('$mdMenu')
	    .setDefaults({
	      methods: ['target'],
	      options: menuDefaultOptions
	    });
	
	  /* @ngInject */
	  function menuDefaultOptions($mdUtil, $mdTheming, $mdConstant, $document, $window, $q, $$rAF,
	                              $animateCss, $animate, $log) {
	
	    var prefixer = $mdUtil.prefixer();
	    var animator = $mdUtil.dom.animator;
	
	    return {
	      parent: 'body',
	      onShow: onShow,
	      onRemove: onRemove,
	      hasBackdrop: true,
	      disableParentScroll: true,
	      skipCompile: true,
	      preserveScope: true,
	      multiple: true,
	      themable: true
	    };
	
	    /**
	     * Show modal backdrop element...
	     * @returns {function(): void} A function that removes this backdrop
	     */
	    function showBackdrop(scope, element, options) {
	      if (options.nestLevel) return angular.noop;
	
	      // If we are not within a dialog...
	      if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
	        // !! DO this before creating the backdrop; since disableScrollAround()
	        //    configures the scroll offset; which is used by mdBackDrop postLink()
	        options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
	      } else {
	        options.disableParentScroll = false;
	      }
	
	      if (options.hasBackdrop) {
	        options.backdrop = $mdUtil.createBackdrop(scope, "md-menu-backdrop md-click-catcher");
	
	        $animate.enter(options.backdrop, $document[0].body);
	      }
	
	      /**
	       * Hide and destroys the backdrop created by showBackdrop()
	       */
	      return function hideBackdrop() {
	        if (options.backdrop) options.backdrop.remove();
	        if (options.disableParentScroll) options.restoreScroll();
	      };
	    }
	
	    /**
	     * Removing the menu element from the DOM and remove all associated event listeners
	     * and backdrop
	     */
	    function onRemove(scope, element, opts) {
	      opts.cleanupInteraction();
	      opts.cleanupBackdrop();
	      opts.cleanupResizing();
	      opts.hideBackdrop();
	
	      // Before the menu is closing remove the clickable class.
	      element.removeClass('md-clickable');
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	
	      return (opts.$destroy === true) ? detachAndClean() : animateRemoval().then( detachAndClean );
	
	      /**
	       * For normal closes, animate the removal.
	       * For forced closes (like $destroy events), skip the animations
	       */
	      function animateRemoval() {
	        return $animateCss(element, {addClass: 'md-leave'}).start();
	      }
	
	      /**
	       * Detach the element
	       */
	      function detachAndClean() {
	        element.removeClass('md-active');
	        detachElement(element, opts);
	        opts.alreadyOpen = false;
	      }
	
	    }
	
	    /**
	     * Inserts and configures the staged Menu element into the DOM, positioning it,
	     * and wiring up various interaction events
	     */
	    function onShow(scope, element, opts) {
	      sanitizeAndConfigure(opts);
	
	      if (opts.menuContentEl[0]) {
	        // Inherit the theme from the target element.
	        $mdTheming.inherit(opts.menuContentEl, opts.target);
	      } else {
	        $log.warn(
	          '$mdMenu: Menu elements should always contain a `md-menu-content` element,' +
	          'otherwise interactivity features will not work properly.',
	          element
	        );
	      }
	
	      // Register various listeners to move menu on resize/orientation change
	      opts.cleanupResizing = startRepositioningOnResize();
	      opts.hideBackdrop = showBackdrop(scope, element, opts);
	
	      // Return the promise for when our menu is done animating in
	      return showMenu()
	        .then(function(response) {
	          opts.alreadyOpen = true;
	          opts.cleanupInteraction = activateInteraction();
	          opts.cleanupBackdrop = setupBackdrop();
	
	          // Since the menu finished its animation, mark the menu as clickable.
	          element.addClass('md-clickable');
	
	          return response;
	        });
	
	      /**
	       * Place the menu into the DOM and call positioning related functions
	       */
	      function showMenu() {
	        opts.parent.append(element);
	        element[0].style.display = '';
	
	        return $q(function(resolve) {
	          var position = calculateMenuPosition(element, opts);
	
	          element.removeClass('md-leave');
	
	          // Animate the menu scaling, and opacity [from its position origin (default == top-left)]
	          // to normal scale.
	          $animateCss(element, {
	            addClass: 'md-active',
	            from: animator.toCss(position),
	            to: animator.toCss({transform: ''})
	          })
	          .start()
	          .then(resolve);
	
	        });
	      }
	
	      /**
	       * Check for valid opts and set some sane defaults
	       */
	      function sanitizeAndConfigure() {
	        if (!opts.target) {
	          throw Error(
	            '$mdMenu.show() expected a target to animate from in options.target'
	          );
	        }
	        angular.extend(opts, {
	          alreadyOpen: false,
	          isRemoved: false,
	          target: angular.element(opts.target), //make sure it's not a naked dom node
	          parent: angular.element(opts.parent),
	          menuContentEl: angular.element(element[0].querySelector('md-menu-content'))
	        });
	      }
	
	      /**
	       * Configure various resize listeners for screen changes
	       */
	      function startRepositioningOnResize() {
	
	        var repositionMenu = (function(target, options) {
	          return $$rAF.throttle(function() {
	            if (opts.isRemoved) return;
	            var position = calculateMenuPosition(target, options);
	
	            target.css(animator.toCss(position));
	          });
	        })(element, opts);
	
	        $window.addEventListener('resize', repositionMenu);
	        $window.addEventListener('orientationchange', repositionMenu);
	
	        return function stopRepositioningOnResize() {
	
	          // Disable resizing handlers
	          $window.removeEventListener('resize', repositionMenu);
	          $window.removeEventListener('orientationchange', repositionMenu);
	
	        };
	      }
	
	      /**
	       * Sets up the backdrop and listens for click elements.
	       * Once the backdrop will be clicked, the menu will automatically close.
	       * @returns {!Function} Function to remove the backdrop.
	       */
	      function setupBackdrop() {
	        if (!opts.backdrop) return angular.noop;
	
	        opts.backdrop.on('click', onBackdropClick);
	
	        return function() {
	          opts.backdrop.off('click', onBackdropClick);
	        };
	      }
	
	      /**
	       * Function to be called whenever the backdrop is clicked.
	       * @param {!MouseEvent} event
	       */
	      function onBackdropClick(event) {
	        event.preventDefault();
	        event.stopPropagation();
	
	        scope.$apply(function() {
	          opts.mdMenuCtrl.close(true, { closeAll: true });
	        });
	      }
	
	      /**
	       * Activate interaction on the menu. Resolves the focus target and closes the menu on
	       * escape or option click.
	       * @returns {!Function} Function to deactivate the interaction listeners.
	       */
	      function activateInteraction() {
	        if (!opts.menuContentEl[0]) return angular.noop;
	
	        // Wire up keyboard listeners.
	        // - Close on escape,
	        // - focus next item on down arrow,
	        // - focus prev item on up
	        opts.menuContentEl.on('keydown', onMenuKeyDown);
	        opts.menuContentEl[0].addEventListener('click', captureClickListener, true);
	
	        // kick off initial focus in the menu on the first enabled element
	        var focusTarget = opts.menuContentEl[0]
	          .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));
	
	        if ( !focusTarget ) {
	          var childrenLen = opts.menuContentEl[0].children.length;
	          for(var childIndex = 0; childIndex < childrenLen; childIndex++) {
	            var child = opts.menuContentEl[0].children[childIndex];
	            focusTarget = child.querySelector('.md-button:not([disabled])');
	            if (focusTarget) {
	              break;
	            }
	            if (child.firstElementChild && !child.firstElementChild.disabled) {
	              focusTarget = child.firstElementChild;
	              break;
	            }
	          }
	        }
	
	        focusTarget && focusTarget.focus();
	
	        return function cleanupInteraction() {
	          opts.menuContentEl.off('keydown', onMenuKeyDown);
	          opts.menuContentEl[0].removeEventListener('click', captureClickListener, true);
	        };
	
	        // ************************************
	        // internal functions
	        // ************************************
	
	        function onMenuKeyDown(ev) {
	          var handled;
	          switch (ev.keyCode) {
	            case $mdConstant.KEY_CODE.ESCAPE:
	              opts.mdMenuCtrl.close(false, { closeAll: true });
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.TAB:
	              opts.mdMenuCtrl.close(false, { closeAll: true });
	              // Don't prevent default or stop propagation on this event as we want tab
	              // to move the focus to the next focusable element on the page.
	              handled = false;
	              break;
	            case $mdConstant.KEY_CODE.UP_ARROW:
	              if (!focusMenuItem(ev, opts.menuContentEl, opts, -1) && !opts.nestLevel) {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.DOWN_ARROW:
	              if (!focusMenuItem(ev, opts.menuContentEl, opts, 1) && !opts.nestLevel) {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.LEFT_ARROW:
	              if (opts.nestLevel) {
	                opts.mdMenuCtrl.close();
	              } else {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.RIGHT_ARROW:
	              var parentMenu = $mdUtil.getClosest(ev.target, 'MD-MENU');
	              if (parentMenu && parentMenu != opts.parent[0]) {
	                ev.target.click();
	              } else {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	          }
	          if (handled) {
	            ev.preventDefault();
	            ev.stopImmediatePropagation();
	          }
	        }
	
	        function onBackdropClick(e) {
	          e.preventDefault();
	          e.stopPropagation();
	          scope.$apply(function() {
	            opts.mdMenuCtrl.close(true, { closeAll: true });
	          });
	        }
	
	        // Close menu on menu item click, if said menu-item is not disabled
	        function captureClickListener(e) {
	          var target = e.target;
	          // Traverse up the event until we get to the menuContentEl to see if
	          // there is an ng-click and that the ng-click is not disabled
	          do {
	            if (target == opts.menuContentEl[0]) return;
	            if ((hasAnyAttribute(target, ['ng-click', 'ng-href', 'ui-sref']) ||
	                target.nodeName == 'BUTTON' || target.nodeName == 'MD-BUTTON') && !hasAnyAttribute(target, ['md-prevent-menu-close'])) {
	              var closestMenu = $mdUtil.getClosest(target, 'MD-MENU');
	              if (!target.hasAttribute('disabled') && (!closestMenu || closestMenu == opts.parent[0])) {
	                close();
	              }
	              break;
	            }
	          } while (target = target.parentNode);
	
	          function close() {
	            scope.$apply(function() {
	              opts.mdMenuCtrl.close(true, { closeAll: true });
	            });
	          }
	
	          function hasAnyAttribute(target, attrs) {
	            if (!target) return false;
	
	            for (var i = 0, attr; attr = attrs[i]; ++i) {
	              if (prefixer.hasAttribute(target, attr)) {
	                return true;
	              }
	            }
	
	            return false;
	          }
	        }
	
	      }
	    }
	
	    /**
	     * Takes a keypress event and focuses the next/previous menu
	     * item from the emitting element
	     * @param {event} e - The origin keypress event
	     * @param {angular.element} menuEl - The menu element
	     * @param {object} opts - The interim element options for the mdMenu
	     * @param {number} direction - The direction to move in (+1 = next, -1 = prev)
	     */
	    function focusMenuItem(e, menuEl, opts, direction) {
	      var currentItem = $mdUtil.getClosest(e.target, 'MD-MENU-ITEM');
	
	      var items = $mdUtil.nodesToArray(menuEl[0].children);
	      var currentIndex = items.indexOf(currentItem);
	
	      // Traverse through our elements in the specified direction (+/-1) and try to
	      // focus them until we find one that accepts focus
	      var didFocus;
	      for (var i = currentIndex + direction; i >= 0 && i < items.length; i = i + direction) {
	        var focusTarget = items[i].querySelector('.md-button');
	        didFocus = attemptFocus(focusTarget);
	        if (didFocus) {
	          break;
	        }
	      }
	      return didFocus;
	    }
	
	    /**
	     * Attempts to focus an element. Checks whether that element is the currently
	     * focused element after attempting.
	     * @param {HTMLElement} el - the element to attempt focus on
	     * @returns {boolean} - whether the element was successfully focused
	     */
	    function attemptFocus(el) {
	      if (el && el.getAttribute('tabindex') != -1) {
	        el.focus();
	        return ($document[0].activeElement == el);
	      }
	    }
	
	    /**
	     * Use browser to remove this element without triggering a $destroy event
	     */
	    function detachElement(element, opts) {
	      if (!opts.preserveElement) {
	        if (toNode(element).parentNode === toNode(opts.parent)) {
	          toNode(opts.parent).removeChild(toNode(element));
	        }
	      } else {
	        toNode(element).style.display = 'none';
	      }
	    }
	
	    /**
	     * Computes menu position and sets the style on the menu container
	     * @param {HTMLElement} el - the menu container element
	     * @param {object} opts - the interim element options object
	     */
	    function calculateMenuPosition(el, opts) {
	
	      var containerNode = el[0],
	        openMenuNode = el[0].firstElementChild,
	        openMenuNodeRect = openMenuNode.getBoundingClientRect(),
	        boundryNode = $document[0].body,
	        boundryNodeRect = boundryNode.getBoundingClientRect();
	
	      var menuStyle = $window.getComputedStyle(openMenuNode);
	
	      var originNode = opts.target[0].querySelector(prefixer.buildSelector('md-menu-origin')) || opts.target[0],
	        originNodeRect = originNode.getBoundingClientRect();
	
	      var bounds = {
	        left: boundryNodeRect.left + MENU_EDGE_MARGIN,
	        top: Math.max(boundryNodeRect.top, 0) + MENU_EDGE_MARGIN,
	        bottom: Math.max(boundryNodeRect.bottom, Math.max(boundryNodeRect.top, 0) + boundryNodeRect.height) - MENU_EDGE_MARGIN,
	        right: boundryNodeRect.right - MENU_EDGE_MARGIN
	      };
	
	      var alignTarget, alignTargetRect = { top:0, left : 0, right:0, bottom:0 }, existingOffsets  = { top:0, left : 0, right:0, bottom:0  };
	      var positionMode = opts.mdMenuCtrl.positionMode();
	
	      if (positionMode.top === 'target' || positionMode.left === 'target' || positionMode.left === 'target-right') {
	        alignTarget = firstVisibleChild();
	        if ( alignTarget ) {
	          // TODO: Allow centering on an arbitrary node, for now center on first menu-item's child
	          alignTarget = alignTarget.firstElementChild || alignTarget;
	          alignTarget = alignTarget.querySelector(prefixer.buildSelector('md-menu-align-target')) || alignTarget;
	          alignTargetRect = alignTarget.getBoundingClientRect();
	
	          existingOffsets = {
	            top: parseFloat(containerNode.style.top || 0),
	            left: parseFloat(containerNode.style.left || 0)
	          };
	        }
	      }
	
	      var position = {};
	      var transformOrigin = 'top ';
	
	      switch (positionMode.top) {
	        case 'target':
	          position.top = existingOffsets.top + originNodeRect.top - alignTargetRect.top;
	          break;
	        case 'cascade':
	          position.top = originNodeRect.top - parseFloat(menuStyle.paddingTop) - originNode.style.top;
	          break;
	        case 'bottom':
	          position.top = originNodeRect.top + originNodeRect.height;
	          break;
	        default:
	          throw new Error('Invalid target mode "' + positionMode.top + '" specified for md-menu on Y axis.');
	      }
	
	      var rtl = ($mdUtil.bidi() === 'rtl');
	
	      switch (positionMode.left) {
	        case 'target':
	          position.left = existingOffsets.left + originNodeRect.left - alignTargetRect.left;
	          transformOrigin += rtl ? 'right'  : 'left';
	          break;
	        case 'target-left':
	          position.left = originNodeRect.left;
	          transformOrigin += 'left';
	          break;
	        case 'target-right':
	          position.left = originNodeRect.right - openMenuNodeRect.width + (openMenuNodeRect.right - alignTargetRect.right);
	          transformOrigin += 'right';
	          break;
	        case 'cascade':
	          var willFitRight = rtl ? (originNodeRect.left - openMenuNodeRect.width) < bounds.left : (originNodeRect.right + openMenuNodeRect.width) < bounds.right;
	          position.left = willFitRight ? originNodeRect.right - originNode.style.left : originNodeRect.left - originNode.style.left - openMenuNodeRect.width;
	          transformOrigin += willFitRight ? 'left' : 'right';
	          break;
	        case 'right':
	          if (rtl) {
	            position.left = originNodeRect.right - originNodeRect.width;
	            transformOrigin += 'left';
	          } else {
	            position.left = originNodeRect.right - openMenuNodeRect.width;
	            transformOrigin += 'right';
	          }
	          break;
	        case 'left':
	          if (rtl) {
	            position.left = originNodeRect.right - openMenuNodeRect.width;
	            transformOrigin += 'right';
	          } else {
	            position.left = originNodeRect.left;
	            transformOrigin += 'left';
	          }
	          break;
	        default:
	          throw new Error('Invalid target mode "' + positionMode.left + '" specified for md-menu on X axis.');
	      }
	
	      var offsets = opts.mdMenuCtrl.offsets();
	      position.top += offsets.top;
	      position.left += offsets.left;
	
	      clamp(position);
	
	      var scaleX = Math.round(100 * Math.min(originNodeRect.width / containerNode.offsetWidth, 1.0)) / 100;
	      var scaleY = Math.round(100 * Math.min(originNodeRect.height / containerNode.offsetHeight, 1.0)) / 100;
	
	      return {
	        top: Math.round(position.top),
	        left: Math.round(position.left),
	        // Animate a scale out if we aren't just repositioning
	        transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : undefined,
	        transformOrigin: transformOrigin
	      };
	
	      /**
	       * Clamps the repositioning of the menu within the confines of
	       * bounding element (often the screen/body)
	       */
	      function clamp(pos) {
	        pos.top = Math.max(Math.min(pos.top, bounds.bottom - containerNode.offsetHeight), bounds.top);
	        pos.left = Math.max(Math.min(pos.left, bounds.right - containerNode.offsetWidth), bounds.left);
	      }
	
	      /**
	       * Gets the first visible child in the openMenuNode
	       * Necessary incase menu nodes are being dynamically hidden
	       */
	      function firstVisibleChild() {
	        for (var i = 0; i < openMenuNode.children.length; ++i) {
	          if ($window.getComputedStyle(openMenuNode.children[i]).display != 'none') {
	            return openMenuNode.children[i];
	          }
	        }
	      }
	    }
	  }
	  function toNode(el) {
	    if (el instanceof angular.element) {
	      el = el[0];
	    }
	    return el;
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MenuBarController.$inject = ["$scope", "$rootScope", "$element", "$attrs", "$mdConstant", "$document", "$mdUtil", "$timeout"];
	angular
	  .module('material.components.menuBar')
	  .controller('MenuBarController', MenuBarController);
	
	var BOUND_MENU_METHODS = ['handleKeyDown', 'handleMenuHover', 'scheduleOpenHoveredMenu', 'cancelScheduledOpen'];
	
	/**
	 * @ngInject
	 */
	function MenuBarController($scope, $rootScope, $element, $attrs, $mdConstant, $document, $mdUtil, $timeout) {
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$mdConstant = $mdConstant;
	  this.$mdUtil = $mdUtil;
	  this.$document = $document;
	  this.$scope = $scope;
	  this.$rootScope = $rootScope;
	  this.$timeout = $timeout;
	
	  var self = this;
	  angular.forEach(BOUND_MENU_METHODS, function(methodName) {
	    self[methodName] = angular.bind(self, self[methodName]);
	  });
	}
	
	MenuBarController.prototype.init = function() {
	  var $element = this.$element;
	  var $mdUtil = this.$mdUtil;
	  var $scope = this.$scope;
	
	  var self = this;
	  var deregisterFns = [];
	  $element.on('keydown', this.handleKeyDown);
	  this.parentToolbar = $mdUtil.getClosest($element, 'MD-TOOLBAR');
	
	  deregisterFns.push(this.$rootScope.$on('$mdMenuOpen', function(event, el) {
	    if (self.getMenus().indexOf(el[0]) != -1) {
	      $element[0].classList.add('md-open');
	      el[0].classList.add('md-open');
	      self.currentlyOpenMenu = el.controller('mdMenu');
	      self.currentlyOpenMenu.registerContainerProxy(self.handleKeyDown);
	      self.enableOpenOnHover();
	    }
	  }));
	
	  deregisterFns.push(this.$rootScope.$on('$mdMenuClose', function(event, el, opts) {
	    var rootMenus = self.getMenus();
	    if (rootMenus.indexOf(el[0]) != -1) {
	      $element[0].classList.remove('md-open');
	      el[0].classList.remove('md-open');
	    }
	
	    if ($element[0].contains(el[0])) {
	      var parentMenu = el[0];
	      while (parentMenu && rootMenus.indexOf(parentMenu) == -1) {
	        parentMenu = $mdUtil.getClosest(parentMenu, 'MD-MENU', true);
	      }
	      if (parentMenu) {
	        if (!opts.skipFocus) parentMenu.querySelector('button:not([disabled])').focus();
	        self.currentlyOpenMenu = undefined;
	        self.disableOpenOnHover();
	        self.setKeyboardMode(true);
	      }
	    }
	  }));
	
	  $scope.$on('$destroy', function() {
	    self.disableOpenOnHover();
	    while (deregisterFns.length) {
	      deregisterFns.shift()();
	    }
	  });
	
	
	  this.setKeyboardMode(true);
	};
	
	MenuBarController.prototype.setKeyboardMode = function(enabled) {
	  if (enabled) this.$element[0].classList.add('md-keyboard-mode');
	  else this.$element[0].classList.remove('md-keyboard-mode');
	};
	
	MenuBarController.prototype.enableOpenOnHover = function() {
	  if (this.openOnHoverEnabled) return;
	
	  var self = this;
	
	  self.openOnHoverEnabled = true;
	
	  if (self.parentToolbar) {
	    self.parentToolbar.classList.add('md-has-open-menu');
	
	    // Needs to be on the next tick so it doesn't close immediately.
	    self.$mdUtil.nextTick(function() {
	      angular.element(self.parentToolbar).on('click', self.handleParentClick);
	    }, false);
	  }
	
	  angular
	    .element(self.getMenus())
	    .on('mouseenter', self.handleMenuHover);
	};
	
	MenuBarController.prototype.handleMenuHover = function(e) {
	  this.setKeyboardMode(false);
	  if (this.openOnHoverEnabled) {
	    this.scheduleOpenHoveredMenu(e);
	  }
	};
	
	MenuBarController.prototype.disableOpenOnHover = function() {
	  if (!this.openOnHoverEnabled) return;
	
	  this.openOnHoverEnabled = false;
	
	  if (this.parentToolbar) {
	    this.parentToolbar.classList.remove('md-has-open-menu');
	    angular.element(this.parentToolbar).off('click', this.handleParentClick);
	  }
	
	  angular
	    .element(this.getMenus())
	    .off('mouseenter', this.handleMenuHover);
	};
	
	MenuBarController.prototype.scheduleOpenHoveredMenu = function(e) {
	  var menuEl = angular.element(e.currentTarget);
	  var menuCtrl = menuEl.controller('mdMenu');
	  this.setKeyboardMode(false);
	  this.scheduleOpenMenu(menuCtrl);
	};
	
	MenuBarController.prototype.scheduleOpenMenu = function(menuCtrl) {
	  var self = this;
	  var $timeout = this.$timeout;
	  if (menuCtrl != self.currentlyOpenMenu) {
	    $timeout.cancel(self.pendingMenuOpen);
	    self.pendingMenuOpen = $timeout(function() {
	      self.pendingMenuOpen = undefined;
	      if (self.currentlyOpenMenu) {
	        self.currentlyOpenMenu.close(true, { closeAll: true });
	      }
	      menuCtrl.open();
	    }, 200, false);
	  }
	};
	
	MenuBarController.prototype.handleKeyDown = function(e) {
	  var keyCodes = this.$mdConstant.KEY_CODE;
	  var currentMenu = this.currentlyOpenMenu;
	  var wasOpen = currentMenu && currentMenu.isOpen;
	  this.setKeyboardMode(true);
	  var handled, newMenu, newMenuCtrl;
	  switch (e.keyCode) {
	    case keyCodes.DOWN_ARROW:
	      if (currentMenu) {
	        currentMenu.focusMenuContainer();
	      } else {
	        this.openFocusedMenu();
	      }
	      handled = true;
	      break;
	    case keyCodes.UP_ARROW:
	      currentMenu && currentMenu.close();
	      handled = true;
	      break;
	    case keyCodes.LEFT_ARROW:
	      newMenu = this.focusMenu(-1);
	      if (wasOpen) {
	        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
	        this.scheduleOpenMenu(newMenuCtrl);
	      }
	      handled = true;
	      break;
	    case keyCodes.RIGHT_ARROW:
	      newMenu = this.focusMenu(+1);
	      if (wasOpen) {
	        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
	        this.scheduleOpenMenu(newMenuCtrl);
	      }
	      handled = true;
	      break;
	  }
	  if (handled) {
	    e && e.preventDefault && e.preventDefault();
	    e && e.stopImmediatePropagation && e.stopImmediatePropagation();
	  }
	};
	
	MenuBarController.prototype.focusMenu = function(direction) {
	  var menus = this.getMenus();
	  var focusedIndex = this.getFocusedMenuIndex();
	
	  if (focusedIndex == -1) { focusedIndex = this.getOpenMenuIndex(); }
	
	  var changed = false;
	
	  if (focusedIndex == -1) { focusedIndex = 0; changed = true; }
	  else if (
	    direction < 0 && focusedIndex > 0 ||
	    direction > 0 && focusedIndex < menus.length - direction
	  ) {
	    focusedIndex += direction;
	    changed = true;
	  }
	  if (changed) {
	    menus[focusedIndex].querySelector('button').focus();
	    return menus[focusedIndex];
	  }
	};
	
	MenuBarController.prototype.openFocusedMenu = function() {
	  var menu = this.getFocusedMenu();
	  menu && angular.element(menu).controller('mdMenu').open();
	};
	
	MenuBarController.prototype.getMenus = function() {
	  var $element = this.$element;
	  return this.$mdUtil.nodesToArray($element[0].children)
	    .filter(function(el) { return el.nodeName == 'MD-MENU'; });
	};
	
	MenuBarController.prototype.getFocusedMenu = function() {
	  return this.getMenus()[this.getFocusedMenuIndex()];
	};
	
	MenuBarController.prototype.getFocusedMenuIndex = function() {
	  var $mdUtil = this.$mdUtil;
	  var focusedEl = $mdUtil.getClosest(
	    this.$document[0].activeElement,
	    'MD-MENU'
	  );
	  if (!focusedEl) return -1;
	
	  var focusedIndex = this.getMenus().indexOf(focusedEl);
	  return focusedIndex;
	};
	
	MenuBarController.prototype.getOpenMenuIndex = function() {
	  var menus = this.getMenus();
	  for (var i = 0; i < menus.length; ++i) {
	    if (menus[i].classList.contains('md-open')) return i;
	  }
	  return -1;
	};
	
	MenuBarController.prototype.handleParentClick = function(event) {
	  var openMenu = this.querySelector('md-menu.md-open');
	
	  if (openMenu && !openMenu.contains(event.target)) {
	    angular.element(openMenu).controller('mdMenu').close(true, {
	      closeAll: true
	    });
	  }
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdMenuBar
	 * @module material.components.menuBar
	 * @restrict E
	 * @description
	 *
	 * Menu bars are containers that hold multiple menus. They change the behavior and appearence
	 * of the `md-menu` directive to behave similar to an operating system provided menu.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-menu-bar>
	 *   <md-menu>
	 *     <button ng-click="$mdMenu.open()">
	 *       File
	 *     </button>
	 *     <md-menu-content>
	 *       <md-menu-item>
	 *         <md-button ng-click="ctrl.sampleAction('share', $event)">
	 *           Share...
	 *         </md-button>
	 *       </md-menu-item>
	 *       <md-menu-divider></md-menu-divider>
	 *       <md-menu-item>
	 *       <md-menu-item>
	 *         <md-menu>
	 *           <md-button ng-click="$mdMenu.open()">New</md-button>
	 *           <md-menu-content>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
	 *           </md-menu-content>
	 *         </md-menu>
	 *       </md-menu-item>
	 *     </md-menu-content>
	 *   </md-menu>
	 * </md-menu-bar>
	 * </hljs>
	 *
	 * ## Menu Bar Controls
	 *
	 * You may place `md-menu-items` that function as controls within menu bars.
	 * There are two modes that are exposed via the `type` attribute of the `md-menu-item`.
	 * `type="checkbox"` will function as a boolean control for the `ng-model` attribute of the
	 * `md-menu-item`. `type="radio"` will function like a radio button, setting the `ngModel`
	 * to the `string` value of the `value` attribute. If you need non-string values, you can use
	 * `ng-value` to provide an expression (this is similar to how angular's native `input[type=radio]` works.
	 *
	 * <hljs lang="html">
	 * <md-menu-bar>
	 *  <md-menu>
	 *    <button ng-click="$mdMenu.open()">
	 *      Sample Menu
	 *    </button>
	 *    <md-menu-content>
	 *      <md-menu-item type="checkbox" ng-model="settings.allowChanges">Allow changes</md-menu-item>
	 *      <md-menu-divider></md-menu-divider>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 1</md-menu-item>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 2</md-menu-item>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 3</md-menu-item>
	 *    </md-menu-content>
	 *  </md-menu>
	 * </md-menu-bar>
	 * </hljs>
	 *
	 *
	 * ### Nesting Menus
	 *
	 * Menus may be nested within menu bars. This is commonly called cascading menus.
	 * To nest a menu place the nested menu inside the content of the `md-menu-item`.
	 * <hljs lang="html">
	 * <md-menu-item>
	 *   <md-menu>
	 *     <button ng-click="$mdMenu.open()">New</md-button>
	 *     <md-menu-content>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
	 *     </md-menu-content>
	 *   </md-menu>
	 * </md-menu-item>
	 * </hljs>
	 *
	 */
	
	MenuBarDirective.$inject = ["$mdUtil", "$mdTheming"];
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuBar', MenuBarDirective);
	
	/* @ngInject */
	function MenuBarDirective($mdUtil, $mdTheming) {
	  return {
	    restrict: 'E',
	    require: 'mdMenuBar',
	    controller: 'MenuBarController',
	
	    compile: function compile(templateEl, templateAttrs) {
	      if (!templateAttrs.ariaRole) {
	        templateEl[0].setAttribute('role', 'menubar');
	      }
	      angular.forEach(templateEl[0].children, function(menuEl) {
	        if (menuEl.nodeName == 'MD-MENU') {
	          if (!menuEl.hasAttribute('md-position-mode')) {
	            menuEl.setAttribute('md-position-mode', 'left bottom');
	
	            // Since we're in the compile function and actual `md-buttons` are not compiled yet,
	            // we need to query for possible `md-buttons` as well.
	            menuEl.querySelector('button, a, md-button').setAttribute('role', 'menuitem');
	          }
	          var contentEls = $mdUtil.nodesToArray(menuEl.querySelectorAll('md-menu-content'));
	          angular.forEach(contentEls, function(contentEl) {
	            contentEl.classList.add('md-menu-bar-menu');
	            contentEl.classList.add('md-dense');
	            if (!contentEl.hasAttribute('width')) {
	              contentEl.setAttribute('width', 5);
	            }
	          });
	        }
	      });
	
	      // Mark the child menu items that they're inside a menu bar. This is necessary,
	      // because mnMenuItem has special behaviour during compilation, depending on
	      // whether it is inside a mdMenuBar. We can usually figure this out via the DOM,
	      // however if a directive that uses documentFragment is applied to the child (e.g. ngRepeat),
	      // the element won't have a parent and won't compile properly.
	      templateEl.find('md-menu-item').addClass('md-in-menu-bar');
	
	      return function postLink(scope, el, attr, ctrl) {
	        el.addClass('_md');     // private md component indicator for styling
	        $mdTheming(scope, el);
	        ctrl.init();
	      };
	    }
	  };
	
	}
	
	})();
	(function(){
	"use strict";
	
	
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuDivider', MenuDividerDirective);
	
	
	function MenuDividerDirective() {
	  return {
	    restrict: 'E',
	    compile: function(templateEl, templateAttrs) {
	      if (!templateAttrs.role) {
	        templateEl[0].setAttribute('role', 'separator');
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MenuItemController.$inject = ["$scope", "$element", "$attrs"];
	angular
	  .module('material.components.menuBar')
	  .controller('MenuItemController', MenuItemController);
	
	
	/**
	 * @ngInject
	 */
	function MenuItemController($scope, $element, $attrs) {
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$scope = $scope;
	}
	
	MenuItemController.prototype.init = function(ngModel) {
	  var $element = this.$element;
	  var $attrs = this.$attrs;
	
	  this.ngModel = ngModel;
	  if ($attrs.type == 'checkbox' || $attrs.type == 'radio') {
	    this.mode  = $attrs.type;
	    this.iconEl = $element[0].children[0];
	    this.buttonEl = $element[0].children[1];
	    if (ngModel) {
	      // Clear ngAria set attributes
	      this.initClickListeners();
	    }
	  }
	};
	
	// ngAria auto sets attributes on a menu-item with a ngModel.
	// We don't want this because our content (buttons) get the focus
	// and set their own aria attributes appropritately. Having both
	// breaks NVDA / JAWS. This undeoes ngAria's attrs.
	MenuItemController.prototype.clearNgAria = function() {
	  var el = this.$element[0];
	  var clearAttrs = ['role', 'tabindex', 'aria-invalid', 'aria-checked'];
	  angular.forEach(clearAttrs, function(attr) {
	    el.removeAttribute(attr);
	  });
	};
	
	MenuItemController.prototype.initClickListeners = function() {
	  var self = this;
	  var ngModel = this.ngModel;
	  var $scope = this.$scope;
	  var $attrs = this.$attrs;
	  var $element = this.$element;
	  var mode = this.mode;
	
	  this.handleClick = angular.bind(this, this.handleClick);
	
	  var icon = this.iconEl;
	  var button = angular.element(this.buttonEl);
	  var handleClick = this.handleClick;
	
	  $attrs.$observe('disabled', setDisabled);
	  setDisabled($attrs.disabled);
	
	  ngModel.$render = function render() {
	    self.clearNgAria();
	    if (isSelected()) {
	      icon.style.display = '';
	      button.attr('aria-checked', 'true');
	    } else {
	      icon.style.display = 'none';
	      button.attr('aria-checked', 'false');
	    }
	  };
	
	  $scope.$$postDigest(ngModel.$render);
	
	  function isSelected() {
	    if (mode == 'radio') {
	      var val = $attrs.ngValue ? $scope.$eval($attrs.ngValue) : $attrs.value;
	      return ngModel.$modelValue == val;
	    } else {
	      return ngModel.$modelValue;
	    }
	  }
	
	  function setDisabled(disabled) {
	    if (disabled) {
	      button.off('click', handleClick);
	    } else {
	      button.on('click', handleClick);
	    }
	  }
	};
	
	MenuItemController.prototype.handleClick = function(e) {
	  var mode = this.mode;
	  var ngModel = this.ngModel;
	  var $attrs = this.$attrs;
	  var newVal;
	  if (mode == 'checkbox') {
	    newVal = !ngModel.$modelValue;
	  } else if (mode == 'radio') {
	    newVal = $attrs.ngValue ? this.$scope.$eval($attrs.ngValue) : $attrs.value;
	  }
	  ngModel.$setViewValue(newVal);
	  ngModel.$render();
	};
	
	})();
	(function(){
	"use strict";
	
	
	MenuItemDirective.$inject = ["$mdUtil", "$mdConstant", "$$mdSvgRegistry"];
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuItem', MenuItemDirective);
	
	 /* @ngInject */
	function MenuItemDirective($mdUtil, $mdConstant, $$mdSvgRegistry) {
	  return {
	    controller: 'MenuItemController',
	    require: ['mdMenuItem', '?ngModel'],
	    priority: $mdConstant.BEFORE_NG_ARIA,
	    compile: function(templateEl, templateAttrs) {
	      var type = templateAttrs.type;
	      var inMenuBarClass = 'md-in-menu-bar';
	
	      // Note: This allows us to show the `check` icon for the md-menu-bar items.
	      // The `md-in-menu-bar` class is set by the mdMenuBar directive.
	      if ((type == 'checkbox' || type == 'radio') && templateEl.hasClass(inMenuBarClass)) {
	        var text = templateEl[0].textContent;
	        var buttonEl = angular.element('<md-button type="button"></md-button>');
	        var iconTemplate = '<md-icon md-svg-src="' + $$mdSvgRegistry.mdChecked + '"></md-icon>';
	
	        buttonEl.html(text);
	        buttonEl.attr('tabindex', '0');
	
	        templateEl.html('');
	        templateEl.append(angular.element(iconTemplate));
	        templateEl.append(buttonEl);
	        templateEl.addClass('md-indent').removeClass(inMenuBarClass);
	
	        setDefault('role', type == 'checkbox' ? 'menuitemcheckbox' : 'menuitemradio', buttonEl);
	        moveAttrToButton('ng-disabled');
	
	      } else {
	        setDefault('role', 'menuitem', templateEl[0].querySelector('md-button, button, a'));
	      }
	
	
	      return function(scope, el, attrs, ctrls) {
	        var ctrl = ctrls[0];
	        var ngModel = ctrls[1];
	        ctrl.init(ngModel);
	      };
	
	      function setDefault(attr, val, el) {
	        el = el || templateEl;
	        if (el instanceof angular.element) {
	          el = el[0];
	        }
	        if (!el.hasAttribute(attr)) {
	          el.setAttribute(attr, val);
	        }
	      }
	
	      function moveAttrToButton(attribute) {
	        var attributes = $mdUtil.prefixer(attribute);
	
	        angular.forEach(attributes, function(attr) {
	          if (templateEl[0].hasAttribute(attr)) {
	            var val = templateEl[0].getAttribute(attr);
	            buttonEl[0].setAttribute(attr, val);
	            templateEl[0].removeAttribute(attr);
	          }
	        });
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdProgressCircular
	 * @module material.components.progressCircular
	 * @restrict E
	 *
	 * @description
	 * The circular progress directive is used to make loading content in your app as delightful and
	 * painless as possible by minimizing the amount of visual change a user sees before they can view
	 * and interact with content.
	 *
	 * For operations where the percentage of the operation completed can be determined, use a
	 * determinate indicator. They give users a quick sense of how long an operation will take.
	 *
	 * For operations where the user is asked to wait a moment while something finishes up, and it’s
	 * not necessary to expose what's happening behind the scenes and how long it will take, use an
	 * indeterminate indicator.
	 *
	 * @param {string} md-mode Select from one of two modes: **'determinate'** and **'indeterminate'**.
	 *
	 * Note: if the `md-mode` value is set as undefined or specified as not 1 of the two (2) valid modes, then **'indeterminate'**
	 * will be auto-applied as the mode.
	 *
	 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute.
	 * If `value=""` is also specified, however, then `md-mode="determinate"` would be auto-injected instead.
	 * @param {number=} value In determinate mode, this number represents the percentage of the
	 *     circular progress. Default: 0
	 * @param {number=} md-diameter This specifies the diameter of the circular progress. The value
	 * should be a pixel-size value (eg '100'). If this attribute is
	 * not present then a default value of '50px' is assumed.
	 *
	 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-progress-circular md-mode="determinate" value="..."></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="determinate" ng-value="..."></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="determinate" value="..." md-diameter="100"></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="indeterminate"></md-progress-circular>
	 * </hljs>
	 */
	
	MdProgressCircularDirective.$inject = ["$window", "$mdProgressCircular", "$mdTheming", "$mdUtil", "$interval", "$log"];
	angular
	  .module('material.components.progressCircular')
	  .directive('mdProgressCircular', MdProgressCircularDirective);
	
	/* @ngInject */
	function MdProgressCircularDirective($window, $mdProgressCircular, $mdTheming,
	                                     $mdUtil, $interval, $log) {
	
	  // Note that this shouldn't use use $$rAF, because it can cause an infinite loop
	  // in any tests that call $animate.flush.
	  var rAF = $window.requestAnimationFrame ||
	            $window.webkitRequestAnimationFrame ||
	            angular.noop;
	
	  var cAF = $window.cancelAnimationFrame ||
	            $window.webkitCancelAnimationFrame ||
	            $window.webkitCancelRequestAnimationFrame ||
	            angular.noop;
	
	  var MODE_DETERMINATE = 'determinate';
	  var MODE_INDETERMINATE = 'indeterminate';
	  var DISABLED_CLASS = '_md-progress-circular-disabled';
	  var INDETERMINATE_CLASS = 'md-mode-indeterminate';
	
	  return {
	    restrict: 'E',
	    scope: {
	      value: '@',
	      mdDiameter: '@',
	      mdMode: '@'
	    },
	    template:
	      '<svg xmlns="http://www.w3.org/2000/svg">' +
	        '<path fill="none"/>' +
	      '</svg>',
	    compile: function(element, attrs) {
	      element.attr({
	        'aria-valuemin': 0,
	        'aria-valuemax': 100,
	        'role': 'progressbar'
	      });
	
	      if (angular.isUndefined(attrs.mdMode)) {
	        var mode = attrs.hasOwnProperty('value') ? MODE_DETERMINATE : MODE_INDETERMINATE;
	        attrs.$set('mdMode', mode);
	      } else {
	        attrs.$set('mdMode', attrs.mdMode.trim());
	      }
	
	      return MdProgressCircularLink;
	    }
	  };
	
	  function MdProgressCircularLink(scope, element, attrs) {
	    var node = element[0];
	    var svg = angular.element(node.querySelector('svg'));
	    var path = angular.element(node.querySelector('path'));
	    var startIndeterminate = $mdProgressCircular.startIndeterminate;
	    var endIndeterminate = $mdProgressCircular.endIndeterminate;
	    var iterationCount = 0;
	    var lastAnimationId = 0;
	    var lastDrawFrame;
	    var interval;
	
	    $mdTheming(element);
	    element.toggleClass(DISABLED_CLASS, attrs.hasOwnProperty('disabled'));
	
	    // If the mode is indeterminate, it doesn't need to
	    // wait for the next digest. It can start right away.
	    if(scope.mdMode === MODE_INDETERMINATE){
	      startIndeterminateAnimation();
	    }
	
	    scope.$on('$destroy', function(){
	      cleanupIndeterminateAnimation();
	
	      if (lastDrawFrame) {
	        cAF(lastDrawFrame);
	      }
	    });
	
	    scope.$watchGroup(['value', 'mdMode', function() {
	      var isDisabled = node.disabled;
	
	      // Sometimes the browser doesn't return a boolean, in
	      // which case we should check whether the attribute is
	      // present.
	      if (isDisabled === true || isDisabled === false){
	        return isDisabled;
	      }
	
	      return angular.isDefined(element.attr('disabled'));
	    }], function(newValues, oldValues) {
	      var mode = newValues[1];
	      var isDisabled = newValues[2];
	      var wasDisabled = oldValues[2];
	
	      if (isDisabled !== wasDisabled) {
	        element.toggleClass(DISABLED_CLASS, !!isDisabled);
	      }
	
	      if (isDisabled) {
	        cleanupIndeterminateAnimation();
	      } else {
	        if (mode !== MODE_DETERMINATE && mode !== MODE_INDETERMINATE) {
	          mode = MODE_INDETERMINATE;
	          attrs.$set('mdMode', mode);
	        }
	
	        if (mode === MODE_INDETERMINATE) {
	          startIndeterminateAnimation();
	        } else {
	          var newValue = clamp(newValues[0]);
	
	          cleanupIndeterminateAnimation();
	
	          element.attr('aria-valuenow', newValue);
	          renderCircle(clamp(oldValues[0]), newValue);
	        }
	      }
	
	    });
	
	    // This is in a separate watch in order to avoid layout, unless
	    // the value has actually changed.
	    scope.$watch('mdDiameter', function(newValue) {
	      var diameter = getSize(newValue);
	      var strokeWidth = getStroke(diameter);
	      var value = clamp(scope.value);
	      var transformOrigin = (diameter / 2) + 'px';
	      var dimensions = {
	        width: diameter + 'px',
	        height: diameter + 'px'
	      };
	
	      // The viewBox has to be applied via setAttribute, because it is
	      // case-sensitive. If jQuery is included in the page, `.attr` lowercases
	      // all attribute names.
	      svg[0].setAttribute('viewBox', '0 0 ' + diameter + ' ' + diameter);
	
	      // Usually viewBox sets the dimensions for the SVG, however that doesn't
	      // seem to be the case on IE10.
	      // Important! The transform origin has to be set from here and it has to
	      // be in the format of "Ypx Ypx Ypx", otherwise the rotation wobbles in
	      // IE and Edge, because they don't account for the stroke width when
	      // rotating. Also "center" doesn't help in this case, it has to be a
	      // precise value.
	      svg
	        .css(dimensions)
	        .css('transform-origin', transformOrigin + ' ' + transformOrigin + ' ' + transformOrigin);
	
	      element.css(dimensions);
	
	      path.attr('stroke-width', strokeWidth);
	      path.attr('stroke-linecap', 'square');
	      if (scope.mdMode == MODE_INDETERMINATE) {
	        path.attr('d', getSvgArc(diameter, strokeWidth, true));
	        path.attr('stroke-dasharray', (diameter - strokeWidth) * $window.Math.PI * 0.75);
	        path.attr('stroke-dashoffset', getDashLength(diameter, strokeWidth, 1, 75));
	      } else {
	        path.attr('d', getSvgArc(diameter, strokeWidth, false));
	        path.attr('stroke-dasharray', (diameter - strokeWidth) * $window.Math.PI);
	        path.attr('stroke-dashoffset', getDashLength(diameter, strokeWidth, 0, 100));
	        renderCircle(value, value);
	      }
	
	    });
	
	    function renderCircle(animateFrom, animateTo, easing, duration, iterationCount, maxValue) {
	      var id = ++lastAnimationId;
	      var startTime = $mdUtil.now();
	      var changeInValue = animateTo - animateFrom;
	      var diameter = getSize(scope.mdDiameter);
	      var strokeWidth = getStroke(diameter);
	      var ease = easing || $mdProgressCircular.easeFn;
	      var animationDuration = duration || $mdProgressCircular.duration;
	      var rotation = -90 * (iterationCount || 0);
	      var dashLimit = maxValue || 100;
	
	      // No need to animate it if the values are the same
	      if (animateTo === animateFrom) {
	        renderFrame(animateTo);
	      } else {
	        lastDrawFrame = rAF(function animation() {
	          var currentTime = $window.Math.max(0, $window.Math.min($mdUtil.now() - startTime, animationDuration));
	
	          renderFrame(ease(currentTime, animateFrom, changeInValue, animationDuration));
	
	          // Do not allow overlapping animations
	          if (id === lastAnimationId && currentTime < animationDuration) {
	            lastDrawFrame = rAF(animation);
	          }
	        });
	      }
	
	      function renderFrame(value) {
	        path.attr('stroke-dashoffset', getDashLength(diameter, strokeWidth, value, dashLimit));
	        path.attr('transform','rotate(' + (rotation) + ' ' + diameter/2 + ' ' + diameter/2 + ')');
	      }
	    }
	
	    function animateIndeterminate() {
	      renderCircle(
	        startIndeterminate,
	        endIndeterminate,
	        $mdProgressCircular.easeFnIndeterminate,
	        $mdProgressCircular.durationIndeterminate,
	        iterationCount,
	        75
	      );
	
	      // The %4 technically isn't necessary, but it keeps the rotation
	      // under 360, instead of becoming a crazy large number.
	      iterationCount = ++iterationCount % 4;
	
	    }
	
	    function startIndeterminateAnimation() {
	      if (!interval) {
	        // Note that this interval isn't supposed to trigger a digest.
	        interval = $interval(
	          animateIndeterminate,
	          $mdProgressCircular.durationIndeterminate,
	          0,
	          false
	        );
	
	        animateIndeterminate();
	
	        element
	          .addClass(INDETERMINATE_CLASS)
	          .removeAttr('aria-valuenow');
	      }
	    }
	
	    function cleanupIndeterminateAnimation() {
	      if (interval) {
	        $interval.cancel(interval);
	        interval = null;
	        element.removeClass(INDETERMINATE_CLASS);
	      }
	    }
	  }
	
	  /**
	   * Returns SVG path data for progress circle
	   * Syntax spec: https://www.w3.org/TR/SVG/paths.html#PathDataEllipticalArcCommands
	   *
	   * @param {number} diameter Diameter of the container.
	   * @param {number} strokeWidth Stroke width to be used when drawing circle
	   * @param {boolean} indeterminate Use if progress circle will be used for indeterminate
	   *
	   * @returns {string} String representation of an SVG arc.
	   */
	  function getSvgArc(diameter, strokeWidth, indeterminate) {
	    var radius = diameter / 2;
	    var offset = strokeWidth / 2;
	    var start = radius + ',' + offset; // ie: (25, 2.5) or 12 o'clock
	    var end = offset + ',' + radius;   // ie: (2.5, 25) or  9 o'clock
	    var arcRadius = radius - offset;
	    return 'M' + start
	         + 'A' + arcRadius + ',' + arcRadius + ' 0 1 1 ' + end // 75% circle
	         + (indeterminate ? '' : 'A' + arcRadius + ',' + arcRadius + ' 0 0 1 ' + start); // loop to start
	  }
	
	  /**
	   * Return stroke length for progress circle
	   *
	   * @param {number} diameter Diameter of the container.
	   * @param {number} strokeWidth Stroke width to be used when drawing circle
	   * @param {number} value Percentage of circle (between 0 and 100)
	   * @param {number} limit Max percentage for circle
	   *
	   * @returns {number} Stroke length for progres circle
	   */
	  function getDashLength(diameter, strokeWidth, value, limit) {
	    return (diameter - strokeWidth) * $window.Math.PI * ( (3 * (limit || 100) / 100) - (value/100) );
	  }
	
	  /**
	   * Limits a value between 0 and 100.
	   */
	  function clamp(value) {
	    return $window.Math.max(0, $window.Math.min(value || 0, 100));
	  }
	
	  /**
	   * Determines the size of a progress circle, based on the provided
	   * value in the following formats: `X`, `Ypx`, `Z%`.
	   */
	  function getSize(value) {
	    var defaultValue = $mdProgressCircular.progressSize;
	
	    if (value) {
	      var parsed = parseFloat(value);
	
	      if (value.lastIndexOf('%') === value.length - 1) {
	        parsed = (parsed / 100) * defaultValue;
	      }
	
	      return parsed;
	    }
	
	    return defaultValue;
	  }
	
	  /**
	   * Determines the circle's stroke width, based on
	   * the provided diameter.
	   */
	  function getStroke(diameter) {
	    return $mdProgressCircular.strokeWidth / 100 * diameter;
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc service
	 * @name $mdProgressCircular
	 * @module material.components.progressCircular
	 *
	 * @description
	 * Allows the user to specify the default options for the `progressCircular` directive.
	 *
	 * @property {number} progressSize Diameter of the progress circle in pixels.
	 * @property {number} strokeWidth Width of the circle's stroke as a percentage of the circle's size.
	 * @property {number} duration Length of the circle animation in milliseconds.
	 * @property {function} easeFn Default easing animation function.
	 * @property {object} easingPresets Collection of pre-defined easing functions.
	 *
	 * @property {number} durationIndeterminate Duration of the indeterminate animation.
	 * @property {number} startIndeterminate Indeterminate animation start point.
	 * @property {number} endIndeterminate Indeterminate animation end point.
	 * @property {function} easeFnIndeterminate Easing function to be used when animating
	 * between the indeterminate values.
	 *
	 * @property {(function(object): object)} configure Used to modify the default options.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdProgressCircularProvider) {
	 *
	 *     // Example of changing the default progress options.
	 *     $mdProgressCircularProvider.configure({
	 *       progressSize: 100,
	 *       strokeWidth: 20,
	 *       duration: 800
	 *     });
	 * });
	 * </hljs>
	 *
	 */
	
	angular
	  .module('material.components.progressCircular')
	  .provider("$mdProgressCircular", MdProgressCircularProvider);
	
	function MdProgressCircularProvider() {
	  var progressConfig = {
	    progressSize: 50,
	    strokeWidth: 10,
	    duration: 100,
	    easeFn: linearEase,
	
	    durationIndeterminate: 1333,
	    startIndeterminate: 1,
	    endIndeterminate: 149,
	    easeFnIndeterminate: materialEase,
	
	    easingPresets: {
	      linearEase: linearEase,
	      materialEase: materialEase
	    }
	  };
	
	  return {
	    configure: function(options) {
	      progressConfig = angular.extend(progressConfig, options || {});
	      return progressConfig;
	    },
	    $get: function() { return progressConfig; }
	  };
	
	  function linearEase(t, b, c, d) {
	    return c * t / d + b;
	  }
	
	  function materialEase(t, b, c, d) {
	    // via http://www.timotheegroleau.com/Flash/experiments/easing_function_generator.htm
	    // with settings of [0, 0, 1, 1]
	    var ts = (t /= d) * t;
	    var tc = ts * t;
	    return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdTab
	 * @module material.components.tabs
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-tab>` is a nested directive used within `<md-tabs>` to specify a tab with a **label** and optional *view content*.
	 *
	 * If the `label` attribute is not specified, then an optional `<md-tab-label>` tag can be used to specify more
	 * complex tab header markup. If neither the **label** nor the **md-tab-label** are specified, then the nested
	 * markup of the `<md-tab>` is used as the tab header markup.
	 *
	 * Please note that if you use `<md-tab-label>`, your content **MUST** be wrapped in the `<md-tab-body>` tag.  This
	 * is to define a clear separation between the tab content and the tab label.
	 *
	 * This container is used by the TabsController to show/hide the active tab's content view. This synchronization is
	 * automatically managed by the internal TabsController whenever the tab selection changes. Selection changes can
	 * be initiated via data binding changes, programmatic invocation, or user gestures.
	 *
	 * @param {string=} label Optional attribute to specify a simple string as the tab label
	 * @param {boolean=} ng-disabled If present and expression evaluates to truthy, disabled tab selection.
	 * @param {expression=} md-on-deselect Expression to be evaluated after the tab has been de-selected.
	 * @param {expression=} md-on-select Expression to be evaluated after the tab has been selected.
	 * @param {boolean=} md-active When true, sets the active tab.  Note: There can only be one active tab at a time.
	 *
	 *
	 * @usage
	 *
	 * <hljs lang="html">
	 * <md-tab label="" ng-disabled md-on-select="" md-on-deselect="" >
	 *   <h3>My Tab content</h3>
	 * </md-tab>
	 *
	 * <md-tab >
	 *   <md-tab-label>
	 *     <h3>My Tab content</h3>
	 *   </md-tab-label>
	 *   <md-tab-body>
	 *     <p>
	 *       Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium,
	 *       totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae
	 *       dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit,
	 *       sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
	 *     </p>
	 *   </md-tab-body>
	 * </md-tab>
	 * </hljs>
	 *
	 */
	angular
	    .module('material.components.tabs')
	    .directive('mdTab', MdTab);
	
	function MdTab () {
	  return {
	    require:  '^?mdTabs',
	    terminal: true,
	    compile:  function (element, attr) {
	      var label = firstChild(element, 'md-tab-label'),
	          body  = firstChild(element, 'md-tab-body');
	
	      if (label.length === 0) {
	        label = angular.element('<md-tab-label></md-tab-label>');
	        if (attr.label) label.text(attr.label);
	        else label.append(element.contents());
	
	        if (body.length === 0) {
	          var contents = element.contents().detach();
	          body         = angular.element('<md-tab-body></md-tab-body>');
	          body.append(contents);
	        }
	      }
	
	      element.append(label);
	      if (body.html()) element.append(body);
	
	      return postLink;
	    },
	    scope:    {
	      active:   '=?mdActive',
	      disabled: '=?ngDisabled',
	      select:   '&?mdOnSelect',
	      deselect: '&?mdOnDeselect'
	    }
	  };
	
	  function postLink (scope, element, attr, ctrl) {
	    if (!ctrl) return;
	    var index = ctrl.getTabElementIndex(element),
	        body  = firstChild(element, 'md-tab-body').remove(),
	        label = firstChild(element, 'md-tab-label').remove(),
	        data  = ctrl.insertTab({
	          scope:    scope,
	          parent:   scope.$parent,
	          index:    index,
	          element:  element,
	          template: body.html(),
	          label:    label.html()
	        }, index);
	
	    scope.select   = scope.select || angular.noop;
	    scope.deselect = scope.deselect || angular.noop;
	
	    scope.$watch('active', function (active) { if (active) ctrl.select(data.getIndex(), true); });
	    scope.$watch('disabled', function () { ctrl.refreshIndex(); });
	    scope.$watch(
	        function () {
	          return ctrl.getTabElementIndex(element);
	        },
	        function (newIndex) {
	          data.index = newIndex;
	          ctrl.updateTabOrder();
	        }
	    );
	    scope.$on('$destroy', function () { ctrl.removeTab(data); });
	  }
	
	  function firstChild (element, tagName) {
	    var children = element[0].children;
	    for (var i = 0, len = children.length; i < len; i++) {
	      var child = children[i];
	      if (child.tagName === tagName.toUpperCase()) return angular.element(child);
	    }
	    return angular.element();
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	    .module('material.components.tabs')
	    .directive('mdTabItem', MdTabItem);
	
	function MdTabItem () {
	  return {
	    require: '^?mdTabs',
	    link:    function link (scope, element, attr, ctrl) {
	      if (!ctrl) return;
	      ctrl.attachRipple(scope, element);
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	    .module('material.components.tabs')
	    .directive('mdTabLabel', MdTabLabel);
	
	function MdTabLabel () {
	  return { terminal: true };
	}
	
	
	})();
	(function(){
	"use strict";
	
	
	MdTabScroll.$inject = ["$parse"];angular.module('material.components.tabs')
	    .directive('mdTabScroll', MdTabScroll);
	
	function MdTabScroll ($parse) {
	  return {
	    restrict: 'A',
	    compile: function ($element, attr) {
	      var fn = $parse(attr.mdTabScroll, null, true);
	      return function ngEventHandler (scope, element) {
	        element.on('mousewheel', function (event) {
	          scope.$apply(function () { fn(scope, { $event: event }); });
	        });
	      };
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsController.$inject = ["$scope", "$element", "$window", "$mdConstant", "$mdTabInkRipple", "$mdUtil", "$animateCss", "$attrs", "$compile", "$mdTheming", "$mdInteraction", "MdTabsPaginationService"];angular
	    .module('material.components.tabs')
	    .controller('MdTabsController', MdTabsController);
	
	/**
	 * @ngInject
	 */
	function MdTabsController ($scope, $element, $window, $mdConstant, $mdTabInkRipple, $mdUtil,
	                           $animateCss, $attrs, $compile, $mdTheming, $mdInteraction,
	                           MdTabsPaginationService) {
	  // define private properties
	  var ctrl      = this,
	      locked    = false,
	      elements  = getElements(),
	      queue     = [],
	      destroyed = false,
	      loaded    = false;
	
	
	  // Define public methods
	  ctrl.$onInit            = $onInit;
	  ctrl.updatePagination   = $mdUtil.debounce(updatePagination, 100);
	  ctrl.redirectFocus      = redirectFocus;
	  ctrl.attachRipple       = attachRipple;
	  ctrl.insertTab          = insertTab;
	  ctrl.removeTab          = removeTab;
	  ctrl.select             = select;
	  ctrl.scroll             = scroll;
	  ctrl.nextPage           = nextPage;
	  ctrl.previousPage       = previousPage;
	  ctrl.keydown            = keydown;
	  ctrl.canPageForward     = canPageForward;
	  ctrl.canPageBack        = canPageBack;
	  ctrl.refreshIndex       = refreshIndex;
	  ctrl.incrementIndex     = incrementIndex;
	  ctrl.getTabElementIndex = getTabElementIndex;
	  ctrl.updateInkBarStyles = $mdUtil.debounce(updateInkBarStyles, 100);
	  ctrl.updateTabOrder     = $mdUtil.debounce(updateTabOrder, 100);
	  ctrl.getFocusedTabId    = getFocusedTabId;
	
	  // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	  // manually call the $onInit hook.
	  if (angular.version.major === 1 && angular.version.minor <= 4) {
	    this.$onInit();
	  }
	
	  /**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	   */
	  function $onInit() {
	    // Define one-way bindings
	    defineOneWayBinding('stretchTabs', handleStretchTabs);
	
	    // Define public properties with change handlers
	    defineProperty('focusIndex', handleFocusIndexChange, ctrl.selectedIndex || 0);
	    defineProperty('offsetLeft', handleOffsetChange, 0);
	    defineProperty('hasContent', handleHasContent, false);
	    defineProperty('maxTabWidth', handleMaxTabWidth, getMaxTabWidth());
	    defineProperty('shouldPaginate', handleShouldPaginate, false);
	
	    // Define boolean attributes
	    defineBooleanAttribute('noInkBar', handleInkBar);
	    defineBooleanAttribute('dynamicHeight', handleDynamicHeight);
	    defineBooleanAttribute('noPagination');
	    defineBooleanAttribute('swipeContent');
	    defineBooleanAttribute('noDisconnect');
	    defineBooleanAttribute('autoselect');
	    defineBooleanAttribute('noSelectClick');
	    defineBooleanAttribute('centerTabs', handleCenterTabs, false);
	    defineBooleanAttribute('enableDisconnect');
	
	    // Define public properties
	    ctrl.scope             = $scope;
	    ctrl.parent            = $scope.$parent;
	    ctrl.tabs              = [];
	    ctrl.lastSelectedIndex = null;
	    ctrl.hasFocus          = false;
	    ctrl.styleTabItemFocus = false;
	    ctrl.shouldCenterTabs  = shouldCenterTabs();
	    ctrl.tabContentPrefix  = 'tab-content-';
	
	    // Setup the tabs controller after all bindings are available.
	    setupTabsController();
	  }
	
	  /**
	   * Perform setup for the controller, setup events and watcher(s)
	   */
	  function setupTabsController () {
	    ctrl.selectedIndex = ctrl.selectedIndex || 0;
	    compileTemplate();
	    configureWatchers();
	    bindEvents();
	    $mdTheming($element);
	    $mdUtil.nextTick(function () {
	      // Note that the element references need to be updated, because certain "browsers"
	      // (IE/Edge) lose them and start throwing "Invalid calling object" errors, when we
	      // compile the element contents down in `compileElement`.
	      elements = getElements();
	      updateHeightFromContent();
	      adjustOffset();
	      updateInkBarStyles();
	      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
	      loaded = true;
	      updatePagination();
	    });
	  }
	
	  /**
	   * Compiles the template provided by the user.  This is passed as an attribute from the tabs
	   * directive's template function.
	   */
	  function compileTemplate () {
	    var template = $attrs.$mdTabsTemplate,
	        element  = angular.element($element[0].querySelector('md-tab-data'));
	
	    element.html(template);
	    $compile(element.contents())(ctrl.parent);
	    delete $attrs.$mdTabsTemplate;
	  }
	
	  /**
	   * Binds events used by the tabs component.
	   */
	  function bindEvents () {
	    angular.element($window).on('resize', handleWindowResize);
	    $scope.$on('$destroy', cleanup);
	  }
	
	  /**
	   * Configure watcher(s) used by Tabs
	   */
	  function configureWatchers () {
	    $scope.$watch('$mdTabsCtrl.selectedIndex', handleSelectedIndexChange);
	  }
	
	  /**
	   * Creates a one-way binding manually rather than relying on AngularJS's isolated scope
	   * @param key
	   * @param handler
	   */
	  function defineOneWayBinding (key, handler) {
	    var attr = $attrs.$normalize('md-' + key);
	    if (handler) defineProperty(key, handler);
	    $attrs.$observe(attr, function (newValue) { ctrl[ key ] = newValue; });
	  }
	
	  /**
	   * Defines boolean attributes with default value set to true.  (ie. md-stretch-tabs with no value
	   * will be treated as being truthy)
	   * @param key
	   * @param handler
	   */
	  function defineBooleanAttribute (key, handler) {
	    var attr = $attrs.$normalize('md-' + key);
	    if (handler) defineProperty(key, handler);
	    if ($attrs.hasOwnProperty(attr)) updateValue($attrs[attr]);
	    $attrs.$observe(attr, updateValue);
	    function updateValue (newValue) {
	      ctrl[ key ] = newValue !== 'false';
	    }
	  }
	
	  /**
	   * Remove any events defined by this controller
	   */
	  function cleanup () {
	    destroyed = true;
	    angular.element($window).off('resize', handleWindowResize);
	  }
	
	  // Change handlers
	
	  /**
	   * Toggles stretch tabs class and updates inkbar when tab stretching changes
	   * @param stretchTabs
	   */
	  function handleStretchTabs (stretchTabs) {
	    var elements = getElements();
	    angular.element(elements.wrapper).toggleClass('md-stretch-tabs', shouldStretchTabs());
	    updateInkBarStyles();
	  }
	
	  function handleCenterTabs (newValue) {
	    ctrl.shouldCenterTabs = shouldCenterTabs();
	  }
	
	  function handleMaxTabWidth (newWidth, oldWidth) {
	    if (newWidth !== oldWidth) {
	      var elements = getElements();
	
	      // Set the max width for the real tabs
	      angular.forEach(elements.tabs, function(tab) {
	        tab.style.maxWidth = newWidth + 'px';
	      });
	
	      // Set the max width for the dummy tabs too
	      angular.forEach(elements.dummies, function(tab) {
	        tab.style.maxWidth = newWidth + 'px';
	      });
	
	      $mdUtil.nextTick(ctrl.updateInkBarStyles);
	    }
	  }
	
	  function handleShouldPaginate (newValue, oldValue) {
	    if (newValue !== oldValue) {
	      ctrl.maxTabWidth      = getMaxTabWidth();
	      ctrl.shouldCenterTabs = shouldCenterTabs();
	      $mdUtil.nextTick(function () {
	        ctrl.maxTabWidth = getMaxTabWidth();
	        adjustOffset(ctrl.selectedIndex);
	      });
	    }
	  }
	
	  /**
	   * Add/remove the `md-no-tab-content` class depending on `ctrl.hasContent`
	   * @param hasContent
	   */
	  function handleHasContent (hasContent) {
	    $element[ hasContent ? 'removeClass' : 'addClass' ]('md-no-tab-content');
	  }
	
	  /**
	   * Apply ctrl.offsetLeft to the paging element when it changes
	   * @param left
	   */
	  function handleOffsetChange (left) {
	    var elements = getElements();
	    var newValue = ((ctrl.shouldCenterTabs || isRtl() ? '' : '-') + left + 'px');
	
	    // Fix double-negative which can happen with RTL support
	    newValue = newValue.replace('--', '');
	
	    angular.element(elements.paging).css($mdConstant.CSS.TRANSFORM, 'translate3d(' + newValue + ', 0, 0)');
	    $scope.$broadcast('$mdTabsPaginationChanged');
	  }
	
	  /**
	   * Update the UI whenever `ctrl.focusIndex` is updated
	   * @param newIndex
	   * @param oldIndex
	   */
	  function handleFocusIndexChange (newIndex, oldIndex) {
	    if (newIndex === oldIndex) return;
	    if (!getElements().tabs[ newIndex ]) return;
	    adjustOffset();
	    redirectFocus();
	  }
	
	  /**
	   * Update the UI whenever the selected index changes. Calls user-defined select/deselect methods.
	   * @param newValue
	   * @param oldValue
	   */
	  function handleSelectedIndexChange (newValue, oldValue) {
	    if (newValue === oldValue) return;
	
	    ctrl.selectedIndex     = getNearestSafeIndex(newValue);
	    ctrl.lastSelectedIndex = oldValue;
	    ctrl.updateInkBarStyles();
	    updateHeightFromContent();
	    adjustOffset(newValue);
	    $scope.$broadcast('$mdTabsChanged');
	    ctrl.tabs[ oldValue ] && ctrl.tabs[ oldValue ].scope.deselect();
	    ctrl.tabs[ newValue ] && ctrl.tabs[ newValue ].scope.select();
	  }
	
	  function getTabElementIndex(tabEl){
	    var tabs = $element[0].getElementsByTagName('md-tab');
	    return Array.prototype.indexOf.call(tabs, tabEl[0]);
	  }
	
	  /**
	   * Queues up a call to `handleWindowResize` when a resize occurs while the tabs component is
	   * hidden.
	   */
	  function handleResizeWhenVisible () {
	    // if there is already a watcher waiting for resize, do nothing
	    if (handleResizeWhenVisible.watcher) return;
	    // otherwise, we will abuse the $watch function to check for visible
	    handleResizeWhenVisible.watcher = $scope.$watch(function () {
	      // since we are checking for DOM size, we use $mdUtil.nextTick() to wait for after the DOM updates
	      $mdUtil.nextTick(function () {
	        // if the watcher has already run (ie. multiple digests in one cycle), do nothing
	        if (!handleResizeWhenVisible.watcher) return;
	
	        if ($element.prop('offsetParent')) {
	          handleResizeWhenVisible.watcher();
	          handleResizeWhenVisible.watcher = null;
	
	          handleWindowResize();
	        }
	      }, false);
	    });
	  }
	
	  // Event handlers / actions
	
	  /**
	   * Handle user keyboard interactions
	   * @param event
	   */
	  function keydown (event) {
	    switch (event.keyCode) {
	      case $mdConstant.KEY_CODE.LEFT_ARROW:
	        event.preventDefault();
	        incrementIndex(-1, true);
	        break;
	      case $mdConstant.KEY_CODE.RIGHT_ARROW:
	        event.preventDefault();
	        incrementIndex(1, true);
	        break;
	      case $mdConstant.KEY_CODE.SPACE:
	      case $mdConstant.KEY_CODE.ENTER:
	        event.preventDefault();
	        if (!locked) select(ctrl.focusIndex);
	        break;
	      case $mdConstant.KEY_CODE.TAB:
	        // On tabbing out of the tablist, reset hasFocus to reset ng-focused and
	        // its md-focused class if the focused tab is not the active tab.
	        if (ctrl.focusIndex !== ctrl.selectedIndex) {
	          ctrl.focusIndex = ctrl.selectedIndex;
	        }
	        break;
	    }
	  }
	
	  /**
	   * Update the selected index. Triggers a click event on the original `md-tab` element in order
	   * to fire user-added click events if canSkipClick or `md-no-select-click` are false.
	   * @param index
	   * @param canSkipClick Optionally allow not firing the click event if `md-no-select-click` is also true.
	   */
	  function select (index, canSkipClick) {
	    if (!locked) ctrl.focusIndex = ctrl.selectedIndex = index;
	    // skip the click event if noSelectClick is enabled
	    if (canSkipClick && ctrl.noSelectClick) return;
	    // nextTick is required to prevent errors in user-defined click events
	    $mdUtil.nextTick(function () {
	      ctrl.tabs[ index ].element.triggerHandler('click');
	    }, false);
	  }
	
	  /**
	   * When pagination is on, this makes sure the selected index is in view.
	   * @param event
	   */
	  function scroll (event) {
	    if (!ctrl.shouldPaginate) return;
	    event.preventDefault();
	    ctrl.offsetLeft = fixOffset(ctrl.offsetLeft - event.wheelDelta);
	  }
	
	  /**
	   * Slides the tabs over approximately one page forward.
	   */
	  function nextPage () {
	    if (!ctrl.canPageForward()) { return; }
	
	    var newOffset = MdTabsPaginationService.increasePageOffset(getElements(), ctrl.offsetLeft);
	
	    ctrl.offsetLeft = fixOffset(newOffset);
	  }
	
	  /**
	   * Slides the tabs over approximately one page backward.
	   */
	  function previousPage () {
	    if (!ctrl.canPageBack()) { return; }
	
	    var newOffset = MdTabsPaginationService.decreasePageOffset(getElements(), ctrl.offsetLeft);
	
	    // Set the new offset
	    ctrl.offsetLeft = fixOffset(newOffset);
	  }
	
	  /**
	   * Update size calculations when the window is resized.
	   */
	  function handleWindowResize () {
	    ctrl.lastSelectedIndex = ctrl.selectedIndex;
	    ctrl.offsetLeft        = fixOffset(ctrl.offsetLeft);
	
	    $mdUtil.nextTick(function () {
	      ctrl.updateInkBarStyles();
	      updatePagination();
	    });
	  }
	
	  function handleInkBar (hide) {
	    angular.element(getElements().inkBar).toggleClass('ng-hide', hide);
	  }
	
	  /**
	   * Toggle dynamic height class when value changes
	   * @param value
	   */
	  function handleDynamicHeight (value) {
	    $element.toggleClass('md-dynamic-height', value);
	  }
	
	  /**
	   * Remove a tab from the data and select the nearest valid tab.
	   * @param tabData
	   */
	  function removeTab (tabData) {
	    if (destroyed) return;
	    var selectedIndex = ctrl.selectedIndex,
	        tab           = ctrl.tabs.splice(tabData.getIndex(), 1)[ 0 ];
	    refreshIndex();
	    // when removing a tab, if the selected index did not change, we have to manually trigger the
	    //   tab select/deselect events
	    if (ctrl.selectedIndex === selectedIndex) {
	      tab.scope.deselect();
	      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
	    }
	    $mdUtil.nextTick(function () {
	      updatePagination();
	      ctrl.offsetLeft = fixOffset(ctrl.offsetLeft);
	    });
	  }
	
	  /**
	   * Create an entry in the tabs array for a new tab at the specified index.
	   * @param tabData
	   * @param index
	   * @returns {*}
	   */
	  function insertTab (tabData, index) {
	    var hasLoaded = loaded;
	    var proto     = {
	          getIndex:     function () { return ctrl.tabs.indexOf(tab); },
	          isActive:     function () { return this.getIndex() === ctrl.selectedIndex; },
	          isLeft:       function () { return this.getIndex() < ctrl.selectedIndex; },
	          isRight:      function () { return this.getIndex() > ctrl.selectedIndex; },
	          shouldRender: function () { return !ctrl.noDisconnect || this.isActive(); },
	          hasFocus:     function () {
	            return ctrl.styleTabItemFocus
	                && ctrl.hasFocus && this.getIndex() === ctrl.focusIndex;
	          },
	          id:           $mdUtil.nextUid(),
	          hasContent: !!(tabData.template && tabData.template.trim())
	        },
	        tab       = angular.extend(proto, tabData);
	    if (angular.isDefined(index)) {
	      ctrl.tabs.splice(index, 0, tab);
	    } else {
	      ctrl.tabs.push(tab);
	    }
	
	    processQueue();
	    updateHasContent();
	    $mdUtil.nextTick(function () {
	      updatePagination();
	      setAriaControls(tab);
	
	      // if autoselect is enabled, select the newly added tab
	      if (hasLoaded && ctrl.autoselect) $mdUtil.nextTick(function () {
	        $mdUtil.nextTick(function () { select(ctrl.tabs.indexOf(tab)); });
	      });
	    });
	    return tab;
	  }
	
	  // Getter methods
	
	  /**
	   * Gathers references to all of the DOM elements used by this controller.
	   * @returns {{}}
	   */
	  function getElements () {
	    var elements = {};
	    var node = $element[0];
	
	    // gather tab bar elements
	    elements.wrapper = node.querySelector('md-tabs-wrapper');
	    elements.canvas  = elements.wrapper.querySelector('md-tabs-canvas');
	    elements.paging  = elements.canvas.querySelector('md-pagination-wrapper');
	    elements.inkBar  = elements.paging.querySelector('md-ink-bar');
	    elements.nextButton = node.querySelector('md-next-button');
	    elements.prevButton = node.querySelector('md-prev-button');
	
	    elements.contents = node.querySelectorAll('md-tabs-content-wrapper > md-tab-content');
	    elements.tabs    = elements.paging.querySelectorAll('md-tab-item');
	    elements.dummies = elements.canvas.querySelectorAll('md-dummy-tab');
	
	    return elements;
	  }
	
	  /**
	   * Determines whether or not the left pagination arrow should be enabled.
	   * @returns {boolean}
	   */
	  function canPageBack () {
	    // This works for both LTR and RTL
	    return ctrl.offsetLeft > 0;
	  }
	
	  /**
	   * Determines whether or not the right pagination arrow should be enabled.
	   * @returns {*|boolean}
	   */
	  function canPageForward () {
	    var elements = getElements();
	    var lastTab = elements.tabs[ elements.tabs.length - 1 ];
	
	    if (isRtl()) {
	      return ctrl.offsetLeft < elements.paging.offsetWidth - elements.canvas.offsetWidth;
	    }
	
	    return lastTab && lastTab.offsetLeft + lastTab.offsetWidth > elements.canvas.clientWidth +
	        ctrl.offsetLeft;
	  }
	
	  /**
	   * Returns currently focused tab item's element ID
	   */
	  function getFocusedTabId() {
	    var focusedTab = ctrl.tabs[ctrl.focusIndex];
	    if (!focusedTab || !focusedTab.id) {
	      return null;
	    }
	    return 'tab-item-' + focusedTab.id;
	  }
	
	  /**
	   * Determines if the UI should stretch the tabs to fill the available space.
	   * @returns {*}
	   */
	  function shouldStretchTabs () {
	    switch (ctrl.stretchTabs) {
	      case 'always':
	        return true;
	      case 'never':
	        return false;
	      default:
	        return !ctrl.shouldPaginate
	            && $window.matchMedia('(max-width: 600px)').matches;
	    }
	  }
	
	  /**
	   * Determines if the tabs should appear centered.
	   * @returns {string|boolean}
	   */
	  function shouldCenterTabs () {
	    return ctrl.centerTabs && !ctrl.shouldPaginate;
	  }
	
	  /**
	   * Determines if pagination is necessary to display the tabs within the available space.
	   * @returns {boolean}
	   */
	  function shouldPaginate () {
	    if (ctrl.noPagination || !loaded) return false;
	    var canvasWidth = $element.prop('clientWidth');
	
	    angular.forEach(getElements().tabs, function (tab) {
	      canvasWidth -= tab.offsetWidth;
	    });
	
	    return canvasWidth < 0;
	  }
	
	  /**
	   * Finds the nearest tab index that is available.  This is primarily used for when the active
	   * tab is removed.
	   * @param newIndex
	   * @returns {*}
	   */
	  function getNearestSafeIndex (newIndex) {
	    if (newIndex === -1) return -1;
	    var maxOffset = Math.max(ctrl.tabs.length - newIndex, newIndex),
	        i, tab;
	    for (i = 0; i <= maxOffset; i++) {
	      tab = ctrl.tabs[ newIndex + i ];
	      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
	      tab = ctrl.tabs[ newIndex - i ];
	      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
	    }
	    return newIndex;
	  }
	
	  // Utility methods
	
	  /**
	   * Defines a property using a getter and setter in order to trigger a change handler without
	   * using `$watch` to observe changes.
	   * @param key
	   * @param handler
	   * @param value
	   */
	  function defineProperty (key, handler, value) {
	    Object.defineProperty(ctrl, key, {
	      get: function () { return value; },
	      set: function (newValue) {
	        var oldValue = value;
	        value        = newValue;
	        handler && handler(newValue, oldValue);
	      }
	    });
	  }
	
	  /**
	   * Updates whether or not pagination should be displayed.
	   */
	  function updatePagination () {
	    ctrl.maxTabWidth = getMaxTabWidth();
	    ctrl.shouldPaginate = shouldPaginate();
	  }
	
	  /**
	   * Calculates the width of the pagination wrapper by summing the widths of the dummy tabs.
	   * @returns {number}
	   */
	  function calcPagingWidth () {
	    return calcTabsWidth(getElements().tabs);
	  }
	
	  function calcTabsWidth(tabs) {
	    var width = 0;
	
	    angular.forEach(tabs, function (tab) {
	      //-- Uses the larger value between `getBoundingClientRect().width` and `offsetWidth`.  This
	      //   prevents `offsetWidth` value from being rounded down and causing wrapping issues, but
	      //   also handles scenarios where `getBoundingClientRect()` is inaccurate (ie. tabs inside
	      //   of a dialog)
	      width += Math.max(tab.offsetWidth, tab.getBoundingClientRect().width);
	    });
	
	    return Math.ceil(width);
	  }
	
	  function getMaxTabWidth () {
	    var elements = getElements(),
	        containerWidth = elements.canvas.clientWidth,
	
	        // See https://material.google.com/components/tabs.html#tabs-specs
	        specMax = 264;
	
	    // Do the spec maximum, or the canvas width; whichever is *smaller* (tabs larger than the canvas
	    // width can break the pagination) but not less than 0
	    return Math.max(0, Math.min(containerWidth - 1, specMax));
	  }
	
	  function getMinTabWidth() {
	    var elements = getElements(),
	        containerWidth = elements.canvas.clientWidth,
	        xsBreakpoint = 600,
	
	        // See https://material.google.com/components/tabs.html#tabs-specs
	        specMin = containerWidth > xsBreakpoint ? 160 : 72;
	
	    // Do the spec minimum, or the canvas width; whichever is *smaller* (tabs larger than the canvas
	    // width can break the pagination) but not less than 0
	    return Math.max(0, Math.min(containerWidth - 1, specMin));
	  }
	
	  /**
	   * Re-orders the tabs and updates the selected and focus indexes to their new positions.
	   * This is triggered by `tabDirective.js` when the user's tabs have been re-ordered.
	   */
	  function updateTabOrder () {
	    var selectedItem   = ctrl.tabs[ ctrl.selectedIndex ],
	        focusItem      = ctrl.tabs[ ctrl.focusIndex ];
	    ctrl.tabs          = ctrl.tabs.sort(function (a, b) {
	      return a.index - b.index;
	    });
	    ctrl.selectedIndex = ctrl.tabs.indexOf(selectedItem);
	    ctrl.focusIndex    = ctrl.tabs.indexOf(focusItem);
	  }
	
	  /**
	   * This moves the selected or focus index left or right.  This is used by the keydown handler.
	   * @param inc
	   */
	  function incrementIndex (inc, focus) {
	    var newIndex,
	        key   = focus ? 'focusIndex' : 'selectedIndex',
	        index = ctrl[ key ];
	    for (newIndex = index + inc;
	         ctrl.tabs[ newIndex ] && ctrl.tabs[ newIndex ].scope.disabled;
	         newIndex += inc) { /* do nothing */ }
	
	    newIndex = (index + inc + ctrl.tabs.length) % ctrl.tabs.length;
	
	    if (ctrl.tabs[ newIndex ]) {
	      ctrl[ key ] = newIndex;
	    }
	  }
	
	  /**
	   * This is used to forward focus to tab container elements.  This method is necessary to avoid
	   * animation issues when attempting to focus an item that is out of view.
	   */
	  function redirectFocus () {
	    ctrl.styleTabItemFocus = ($mdInteraction.getLastInteractionType() === 'keyboard');
	    getElements().tabs[ ctrl.focusIndex ].focus();
	  }
	
	  /**
	   * Forces the pagination to move the focused tab into view.
	   */
	  function adjustOffset (index) {
	    var elements = getElements();
	
	    if (!angular.isNumber(index)) index = ctrl.focusIndex;
	    if (!elements.tabs[ index ]) return;
	    if (ctrl.shouldCenterTabs) return;
	    var tab         = elements.tabs[ index ],
	        left        = tab.offsetLeft,
	        right       = tab.offsetWidth + left,
	        extraOffset = 32;
	
	    // If we are selecting the first tab (in LTR and RTL), always set the offset to 0
	    if (index == 0) {
	      ctrl.offsetLeft = 0;
	      return;
	    }
	
	    if (isRtl()) {
	      var tabWidthsBefore = calcTabsWidth(Array.prototype.slice.call(elements.tabs, 0, index));
	      var tabWidthsIncluding = calcTabsWidth(Array.prototype.slice.call(elements.tabs, 0, index + 1));
	
	      ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(tabWidthsBefore));
	      ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(tabWidthsIncluding - elements.canvas.clientWidth));
	    } else {
	      ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(right - elements.canvas.clientWidth + extraOffset));
	      ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(left));
	    }
	  }
	
	  /**
	   * Iterates through all queued functions and clears the queue.  This is used for functions that
	   * are called before the UI is ready, such as size calculations.
	   */
	  function processQueue () {
	    queue.forEach(function (func) { $mdUtil.nextTick(func); });
	    queue = [];
	  }
	
	  /**
	   * Determines if the tab content area is needed.
	   */
	  function updateHasContent () {
	    var hasContent  = false;
	
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].hasContent) {
	        hasContent = true;
	        break;
	      }
	    }
	
	    ctrl.hasContent = hasContent;
	  }
	
	  /**
	   * Moves the indexes to their nearest valid values.
	   */
	  function refreshIndex () {
	    ctrl.selectedIndex = getNearestSafeIndex(ctrl.selectedIndex);
	    ctrl.focusIndex    = getNearestSafeIndex(ctrl.focusIndex);
	  }
	
	  /**
	   * Calculates the content height of the current tab.
	   * @returns {*}
	   */
	  function updateHeightFromContent () {
	    if (!ctrl.dynamicHeight) return $element.css('height', '');
	    if (!ctrl.tabs.length) return queue.push(updateHeightFromContent);
	
	    var elements = getElements();
	
	    var tabContent    = elements.contents[ ctrl.selectedIndex ],
	        contentHeight = tabContent ? tabContent.offsetHeight : 0,
	        tabsHeight    = elements.wrapper.offsetHeight,
	        newHeight     = contentHeight + tabsHeight,
	        currentHeight = $element.prop('clientHeight');
	
	    if (currentHeight === newHeight) return;
	
	    // Adjusts calculations for when the buttons are bottom-aligned since this relies on absolute
	    // positioning.  This should probably be cleaned up if a cleaner solution is possible.
	    if ($element.attr('md-align-tabs') === 'bottom') {
	      currentHeight -= tabsHeight;
	      newHeight -= tabsHeight;
	      // Need to include bottom border in these calculations
	      if ($element.attr('md-border-bottom') !== undefined) ++currentHeight;
	    }
	
	    // Lock during animation so the user can't change tabs
	    locked = true;
	
	    var fromHeight = { height: currentHeight + 'px' },
	        toHeight = { height: newHeight + 'px' };
	
	    // Set the height to the current, specific pixel height to fix a bug on iOS where the height
	    // first animates to 0, then back to the proper height causing a visual glitch
	    $element.css(fromHeight);
	
	    // Animate the height from the old to the new
	    $animateCss($element, {
	      from: fromHeight,
	      to: toHeight,
	      easing: 'cubic-bezier(0.35, 0, 0.25, 1)',
	      duration: 0.5
	    }).start().done(function () {
	      // Then (to fix the same iOS issue as above), disable transitions and remove the specific
	      // pixel height so the height can size with browser width/content changes, etc.
	      $element.css({
	        transition: 'none',
	        height: ''
	      });
	
	      // In the next tick, re-allow transitions (if we do it all at once, $element.css is "smart"
	      // enough to batch it for us instead of doing it immediately, which undoes the original
	      // transition: none)
	      $mdUtil.nextTick(function() {
	        $element.css('transition', '');
	      });
	
	      // And unlock so tab changes can occur
	      locked = false;
	    });
	  }
	
	  /**
	   * Repositions the ink bar to the selected tab.
	   * @returns {*}
	   */
	  function updateInkBarStyles () {
	    var elements = getElements();
	
	    if (!elements.tabs[ ctrl.selectedIndex ]) {
	      angular.element(elements.inkBar).css({ left: 'auto', right: 'auto' });
	      return;
	    }
	
	    if (!ctrl.tabs.length) return queue.push(ctrl.updateInkBarStyles);
	    // if the element is not visible, we will not be able to calculate sizes until it is
	    // we should treat that as a resize event rather than just updating the ink bar
	    if (!$element.prop('offsetParent')) return handleResizeWhenVisible();
	
	    var index      = ctrl.selectedIndex,
	        totalWidth = elements.paging.offsetWidth,
	        tab        = elements.tabs[ index ],
	        left       = tab.offsetLeft,
	        right      = totalWidth - left - tab.offsetWidth;
	
	    if (ctrl.shouldCenterTabs) {
	      // We need to use the same calculate process as in the pagination wrapper, to avoid rounding deviations.
	      var tabWidth = calcTabsWidth(elements.tabs);
	
	      if (totalWidth > tabWidth) {
	        $mdUtil.nextTick(updateInkBarStyles, false);
	      }
	    }
	    updateInkBarClassName();
	    angular.element(elements.inkBar).css({ left: left + 'px', right: right + 'px' });
	  }
	
	  /**
	   * Adds left/right classes so that the ink bar will animate properly.
	   */
	  function updateInkBarClassName () {
	    var elements = getElements();
	    var newIndex = ctrl.selectedIndex,
	        oldIndex = ctrl.lastSelectedIndex,
	        ink      = angular.element(elements.inkBar);
	    if (!angular.isNumber(oldIndex)) return;
	    ink
	        .toggleClass('md-left', newIndex < oldIndex)
	        .toggleClass('md-right', newIndex > oldIndex);
	  }
	
	  /**
	   * Takes an offset value and makes sure that it is within the min/max allowed values.
	   * @param value
	   * @returns {*}
	   */
	  function fixOffset (value) {
	    var elements = getElements();
	
	    if (!elements.tabs.length || !ctrl.shouldPaginate) return 0;
	
	    var lastTab    = elements.tabs[ elements.tabs.length - 1 ],
	        totalWidth = lastTab.offsetLeft + lastTab.offsetWidth;
	
	    if (isRtl()) {
	      value = Math.min(elements.paging.offsetWidth - elements.canvas.clientWidth, value);
	      value = Math.max(0, value);
	    } else {
	      value = Math.max(0, value);
	      value = Math.min(totalWidth - elements.canvas.clientWidth, value);
	    }
	
	    return value;
	  }
	
	  /**
	   * Attaches a ripple to the tab item element.
	   * @param scope
	   * @param element
	   */
	  function attachRipple (scope, element) {
	    var elements = getElements();
	    var options = { colorElement: angular.element(elements.inkBar) };
	    $mdTabInkRipple.attach(scope, element, options);
	  }
	
	  /**
	   * Sets the `aria-controls` attribute to the elements that
	   * correspond to the passed-in tab.
	   * @param tab
	   */
	  function setAriaControls (tab) {
	    if (tab.hasContent) {
	      var nodes = $element[0].querySelectorAll('[md-tab-id="' + tab.id + '"]');
	      angular.element(nodes).attr('aria-controls', ctrl.tabContentPrefix + tab.id);
	    }
	  }
	
	  function isRtl() {
	    return ($mdUtil.bidi() == 'rtl');
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdTabs
	 * @module material.components.tabs
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-tabs>` directive serves as the container for 1..n
	 * <a ng-href="api/directive/mdTab">`<md-tab>`</a> child directives.
	 * In turn, the nested `<md-tab>` directive is used to specify a tab label for the
	 * **header button** and <i>optional</i> tab view content that will be associated with each tab
	 * button.
	 *
	 * Below is the markup for its simplest usage:
	 *
	 *  <hljs lang="html">
	 *  <md-tabs>
	 *    <md-tab label="Tab #1"></md-tab>
	 *    <md-tab label="Tab #2"></md-tab>
	 *    <md-tab label="Tab #3"></md-tab>
	 *  </md-tabs>
	 *  </hljs>
	 *
	 * Tabs support three (3) usage scenarios:
	 *
	 *  1. Tabs (buttons only)
	 *  2. Tabs with internal view content
	 *  3. Tabs with external view content
	 *
	 * **Tabs-only** support is useful when tab buttons are used for custom navigation regardless of any
	 * other components, content, or views.
	 *
	 * <i><b>Note:</b> If you are using the Tabs component for page-level navigation, please use
	 * the <a ng-href="./api/directive/mdNavBar">NavBar component</a> instead. It handles this
	 * case a more natively and more performantly.</i>
	 *
	 * **Tabs with internal views** are the traditional usage where each tab has associated view
	 * content and the view switching is managed internally by the Tabs component.
	 *
	 * **Tabs with external view content** is often useful when content associated with each tab is
	 * independently managed and data-binding notifications announce tab selection changes.
	 *
	 * Additional features also include:
	 *
	 * *  Content can include any markup.
	 * *  If a tab is disabled while active/selected, then the next tab will be auto-selected.
	 *
	 * ### Explanation of tab stretching
	 *
	 * Initially, tabs will have an inherent size.  This size will either be defined by how much space
	 * is needed to accommodate their text or set by the user through CSS.
	 * Calculations will be based on this size.
	 *
	 * On mobile devices, tabs will be expanded to fill the available horizontal space.
	 * When this happens, all tabs will become the same size.
	 *
	 * On desktops, by default, stretching will never occur.
	 *
	 * This default behavior can be overridden through the `md-stretch-tabs` attribute.
	 * Here is a table showing when stretching will occur:
	 *
	 * `md-stretch-tabs` | mobile    | desktop
	 * ------------------|-----------|--------
	 * `auto`            | stretched | ---
	 * `always`          | stretched | stretched
	 * `never`           | ---       | ---
	 *
	 * @param {integer=} md-selected Index of the active/selected tab.
	 * @param {boolean=} md-no-ink If present, disables ink ripple effects.
	 * @param {boolean=} md-no-ink-bar If present, disables the selection ink bar.
	 * @param {string=}  md-align-tabs Attribute to indicate position of tab buttons: `bottom` or `top`;
	 *  Default is `top`.
	 * @param {string=} md-stretch-tabs Attribute to indicate whether or not to stretch tabs: `auto`,
	 *  `always`, or `never`; Default is `auto`.
	 * @param {boolean=} md-dynamic-height When enabled, the tab wrapper will resize based on the
	 *  contents of the selected tab.
	 * @param {boolean=} md-border-bottom If present, shows a solid `1px` border between the tabs and
	 *  their content.
	 * @param {boolean=} md-center-tabs When enabled, tabs will be centered provided there is no need
	 *  for pagination.
	 * @param {boolean=} md-no-pagination When enabled, pagination will remain off.
	 * @param {boolean=} md-swipe-content When enabled, swipe gestures will be enabled for the content
	 *  area to allow swiping between tabs.
	 * @param {boolean=} md-enable-disconnect When enabled, scopes will be disconnected for tabs that
	 *  are not being displayed. This provides a performance boost, but may also cause unexpected
	 *  issues. It is not recommended for most users.
	 * @param {boolean=} md-autoselect When present, any tabs added after the initial load will be
	 *  automatically selected.
	 * @param {boolean=} md-no-select-click When true, click events will not be fired when the value of
	 *  `md-active` on an `md-tab` changes. This is useful when using tabs with UI-Router's child
	 *  states, as triggering a click event in that case can cause an extra tab change to occur.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-tabs md-selected="selectedIndex" >
	 *   <img ng-src="img/angular.png" class="centered">
	 *   <md-tab
	 *       ng-repeat="tab in tabs | orderBy:predicate:reversed"
	 *       md-on-select="onTabSelected(tab)"
	 *       md-on-deselect="announceDeselected(tab)"
	 *       ng-disabled="tab.disabled">
	 *     <md-tab-label>
	 *       {{tab.title}}
	 *       <img src="img/removeTab.png" ng-click="removeTab(tab)" class="delete">
	 *     </md-tab-label>
	 *     <md-tab-body>
	 *       {{tab.content}}
	 *     </md-tab-body>
	 *   </md-tab>
	 * </md-tabs>
	 * </hljs>
	 *
	 */
	MdTabs.$inject = ["$$mdSvgRegistry"];
	angular
	    .module('material.components.tabs')
	    .directive('mdTabs', MdTabs);
	
	function MdTabs ($$mdSvgRegistry) {
	  return {
	    scope:            {
	      selectedIndex: '=?mdSelected'
	    },
	    template:         function (element, attr) {
	      attr.$mdTabsTemplate = element.html();
	      return '' +
	        '<md-tabs-wrapper> ' +
	          '<md-tab-data></md-tab-data> ' +
	          '<md-prev-button ' +
	              'tabindex="-1" ' +
	              'role="button" ' +
	              'aria-label="Previous Page" ' +
	              'aria-disabled="{{!$mdTabsCtrl.canPageBack()}}" ' +
	              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageBack() }" ' +
	              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
	              'ng-click="$mdTabsCtrl.previousPage()"> ' +
	            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
	          '</md-prev-button> ' +
	          '<md-next-button ' +
	              'tabindex="-1" ' +
	              'role="button" ' +
	              'aria-label="Next Page" ' +
	              'aria-disabled="{{!$mdTabsCtrl.canPageForward()}}" ' +
	              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageForward() }" ' +
	              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
	              'ng-click="$mdTabsCtrl.nextPage()"> ' +
	            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
	          '</md-next-button> ' +
	          '<md-tabs-canvas ' +
	              'ng-focus="$mdTabsCtrl.redirectFocus()" ' +
	              'ng-class="{ ' +
	                  '\'md-paginated\': $mdTabsCtrl.shouldPaginate, ' +
	                  '\'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs ' +
	              '}" ' +
	              'ng-keydown="$mdTabsCtrl.keydown($event)"> ' +
	            '<md-pagination-wrapper ' +
	                'ng-class="{ \'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs }" ' +
	                'md-tab-scroll="$mdTabsCtrl.scroll($event)" ' +
	                'role="tablist"> ' +
	              '<md-tab-item ' +
	                  'tabindex="{{ tab.isActive() ? 0 : -1 }}" ' +
	                  'class="md-tab" ' +
	                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
	                  'role="tab" ' +
	                  'id="tab-item-{{::tab.id}}" ' +
	                  'md-tab-id="{{::tab.id}}" ' +
	                  'aria-selected="{{tab.isActive()}}" ' +
	                  'aria-disabled="{{tab.scope.disabled || \'false\'}}" ' +
	                  'ng-click="$mdTabsCtrl.select(tab.getIndex())" ' +
	                  'ng-focus="$mdTabsCtrl.hasFocus = true" ' +
	                  'ng-blur="$mdTabsCtrl.hasFocus = false" ' +
	                  'ng-class="{ ' +
	                      '\'md-active\':    tab.isActive(), ' +
	                      '\'md-focused\':   tab.hasFocus(), ' +
	                      '\'md-disabled\':  tab.scope.disabled ' +
	                  '}" ' +
	                  'ng-disabled="tab.scope.disabled" ' +
	                  'md-swipe-left="$mdTabsCtrl.nextPage()" ' +
	                  'md-swipe-right="$mdTabsCtrl.previousPage()" ' +
	                  'md-tabs-template="::tab.label" ' +
	                  'md-scope="::tab.parent"></md-tab-item> ' +
	              '<md-ink-bar></md-ink-bar> ' +
	            '</md-pagination-wrapper> ' +
	            '<md-tabs-dummy-wrapper aria-hidden="true" class="md-visually-hidden md-dummy-wrapper"> ' +
	              '<md-dummy-tab ' +
	                  'class="md-tab" ' +
	                  'tabindex="-1" ' +
	                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
	                  'md-tabs-template="::tab.label" ' +
	                  'md-scope="::tab.parent"></md-dummy-tab> ' +
	            '</md-tabs-dummy-wrapper> ' +
	          '</md-tabs-canvas> ' +
	        '</md-tabs-wrapper> ' +
	        '<md-tabs-content-wrapper ng-show="$mdTabsCtrl.hasContent && $mdTabsCtrl.selectedIndex >= 0" class="_md"> ' +
	          '<md-tab-content ' +
	              'id="{{:: $mdTabsCtrl.tabContentPrefix + tab.id}}" ' +
	              'class="_md" ' +
	              'role="tabpanel" ' +
	              'aria-labelledby="tab-item-{{::tab.id}}" ' +
	              'md-swipe-left="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(1)" ' +
	              'md-swipe-right="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(-1)" ' +
	              'ng-if="tab.hasContent" ' +
	              'ng-repeat="(index, tab) in $mdTabsCtrl.tabs" ' +
	              'ng-class="{ ' +
	                '\'md-no-transition\': $mdTabsCtrl.lastSelectedIndex == null, ' +
	                '\'md-active\':        tab.isActive(), ' +
	                '\'md-left\':          tab.isLeft(), ' +
	                '\'md-right\':         tab.isRight(), ' +
	                '\'md-no-scroll\':     $mdTabsCtrl.dynamicHeight ' +
	              '}"> ' +
	            '<div ' +
	                'md-tabs-template="::tab.template" ' +
	                'md-connected-if="tab.isActive()" ' +
	                'md-scope="::tab.parent" ' +
	                'ng-if="$mdTabsCtrl.enableDisconnect || tab.shouldRender()"></div> ' +
	          '</md-tab-content> ' +
	        '</md-tabs-content-wrapper>';
	    },
	    controller:       'MdTabsController',
	    controllerAs:     '$mdTabsCtrl',
	    bindToController: true
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsDummyWrapper.$inject = ["$mdUtil", "$window"];angular
	  .module('material.components.tabs')
	  .directive('mdTabsDummyWrapper', MdTabsDummyWrapper);
	
	/**
	 * @private
	 *
	 * @param $mdUtil
	 * @param $window
	 * @returns {{require: string, link: link}}
	 * @constructor
	 *
	 * @ngInject
	 */
	function MdTabsDummyWrapper ($mdUtil, $window) {
	  return {
	    require: '^?mdTabs',
	    link:    function link (scope, element, attr, ctrl) {
	      if (!ctrl) return;
	
	      var observer;
	      var disconnect;
	
	      var mutationCallback = function() {
	        ctrl.updatePagination();
	        ctrl.updateInkBarStyles();
	      };
	
	      if('MutationObserver' in $window) {
	        var config = {
	          childList: true,
	          subtree: true,
	          // Per https://bugzilla.mozilla.org/show_bug.cgi?id=1138368, browsers will not fire
	          // the childList mutation, once a <span> element's innerText changes.
	          // The characterData of the <span> element will change.
	          characterData: true
	        };
	
	        observer = new MutationObserver(mutationCallback);
	        observer.observe(element[0], config);
	        disconnect = observer.disconnect.bind(observer);
	      } else {
	        var debounced = $mdUtil.debounce(mutationCallback, 15, null, false);
	        
	        element.on('DOMSubtreeModified', debounced);
	        disconnect = element.off.bind(element, 'DOMSubtreeModified', debounced);
	      }
	
	      // Disconnect the observer
	      scope.$on('$destroy', function() {
	        disconnect();
	      });
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsTemplate.$inject = ["$compile", "$mdUtil"];angular
	    .module('material.components.tabs')
	    .directive('mdTabsTemplate', MdTabsTemplate);
	
	function MdTabsTemplate ($compile, $mdUtil) {
	  return {
	    restrict: 'A',
	    link:     link,
	    scope:    {
	      template:     '=mdTabsTemplate',
	      connected:    '=?mdConnectedIf',
	      compileScope: '=mdScope'
	    },
	    require:  '^?mdTabs'
	  };
	  function link (scope, element, attr, ctrl) {
	    if (!ctrl) return;
	
	    var compileScope = ctrl.enableDisconnect ? scope.compileScope.$new() : scope.compileScope;
	
	    element.html(scope.template);
	    $compile(element.contents())(compileScope);
	
	    return $mdUtil.nextTick(handleScope);
	
	    function handleScope () {
	      scope.$watch('connected', function (value) { value === false ? disconnect() : reconnect(); });
	      scope.$on('$destroy', reconnect);
	    }
	
	    function disconnect () {
	      if (ctrl.enableDisconnect) $mdUtil.disconnectScope(compileScope);
	    }
	
	    function reconnect () {
	      if (ctrl.enableDisconnect) $mdUtil.reconnectScope(compileScope);
	    }
	  }
	}
	
	})();
	(function(){ 
	angular.module("material.core").constant("$MD_THEME_CSS", "md-autocomplete.md-THEME_NAME-theme{background:\"{{background-hue-1}}\"}md-autocomplete.md-THEME_NAME-theme[disabled]:not([md-floating-label]){background:\"{{background-hue-2}}\"}md-autocomplete.md-THEME_NAME-theme button md-icon path{fill:\"{{background-600}}\"}md-autocomplete.md-THEME_NAME-theme button:after{background:\"{{background-600-0.3}}\"}md-autocomplete.md-THEME_NAME-theme input{color:\"{{foreground-1}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme{background:\"{{background-hue-1}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li{color:\"{{foreground-1}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li.selected,.md-autocomplete-suggestions-container.md-THEME_NAME-theme li:hover{background:\"{{background-500-0.18}}\"}md-backdrop{background-color:\"{{background-900-0.0}}\"}md-backdrop.md-opaque.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-bottom-sheet.md-THEME_NAME-theme{background-color:\"{{background-50}}\";border-top-color:\"{{background-300}}\"}md-bottom-sheet.md-THEME_NAME-theme.md-list md-list-item{color:\"{{foreground-1}}\"}md-bottom-sheet.md-THEME_NAME-theme .md-subheader{background-color:\"{{background-50}}\";color:\"{{foreground-1}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme:not([disabled]):hover{background-color:\"{{background-500-0.2}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-icon-button:hover{background-color:transparent}.md-button.md-THEME_NAME-theme.md-fab md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab,.md-button.md-THEME_NAME-theme.md-primary.md-raised{color:\"{{primary-contrast}}\";background-color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]) md-icon{color:\"{{primary-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]):hover{background-color:\"{{primary-600}}\"}.md-button.md-THEME_NAME-theme.md-primary:not([disabled]) md-icon{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-fab{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]) .md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-fab:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-raised{color:\"{{background-900}}\";background-color:\"{{background-50}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]) md-icon{color:\"{{background-900}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]):hover{background-color:\"{{background-50}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]).md-focused{background-color:\"{{background-200}}\"}.md-button.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab,.md-button.md-THEME_NAME-theme.md-warn.md-raised{color:\"{{warn-contrast}}\";background-color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]) md-icon{color:\"{{warn-contrast}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]):hover{background-color:\"{{warn-600}}\"}.md-button.md-THEME_NAME-theme.md-warn:not([disabled]) md-icon{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab,.md-button.md-THEME_NAME-theme.md-accent.md-raised{color:\"{{accent-contrast}}\";background-color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]) md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-accent:not([disabled]) md-icon{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent[disabled],.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled],.md-button.md-THEME_NAME-theme.md-warn[disabled],.md-button.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\";cursor:default}.md-button.md-THEME_NAME-theme.md-accent[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-fab[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-raised[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-warn[disabled] md-icon,.md-button.md-THEME_NAME-theme[disabled] md-icon{color:\"{{foreground-3}}\"}.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled]{background-color:\"{{foreground-4}}\"}.md-button.md-THEME_NAME-theme[disabled]{background-color:transparent}._md a.md-THEME_NAME-theme:not(.md-button).md-primary{color:\"{{primary-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-primary:hover{color:\"{{primary-700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent{color:\"{{accent-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent:hover{color:\"{{accent-A700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn{color:\"{{warn-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn:hover{color:\"{{warn-700}}\"}md-card.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-hue-1}}\";border-radius:2px}md-card.md-THEME_NAME-theme .md-card-image{border-radius:2px 2px 0 0}md-card.md-THEME_NAME-theme md-card-header md-card-avatar md-icon{color:\"{{background-color}}\";background-color:\"{{foreground-3}}\"}md-card.md-THEME_NAME-theme md-card-header md-card-header-text .md-subhead,md-card.md-THEME_NAME-theme md-card-title md-card-title-text:not(:only-child) .md-subhead{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme .md-ripple{color:\"{{accent-A700}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme.md-checked.md-focused .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon{background-color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon:after{border-color:\"{{accent-contrast-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ripple{color:\"{{primary-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon{background-color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked.md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ripple{color:\"{{warn-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon{background-color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked.md-focused:not([disabled]) .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon:after{border-color:\"{{background-200}}\"}md-checkbox.md-THEME_NAME-theme[disabled]:not(.md-checked) .md-icon{border-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon{background-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon:after{border-color:\"{{background-200}}\"}md-checkbox.md-THEME_NAME-theme[disabled] .md-icon:after{border-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled] .md-label{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips{box-shadow:0 1px \"{{foreground-4}}\"}md-chips.md-THEME_NAME-theme .md-chips.md-focused{box-shadow:0 2px \"{{primary-color}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input{color:\"{{foreground-1}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-moz-placeholder,md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-moz-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-ms-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme md-chip{background:\"{{background-300}}\";color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme md-chip md-icon{color:\"{{background-700}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused{background:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused md-icon{color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip._md-chip-editing{background:transparent;color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme md-chip-remove .md-button md-icon path{fill:\"{{background-500}}\"}.md-contact-suggestion span.md-contact-email{color:\"{{background-400}}\"}md-content.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-default}}\"}.md-THEME_NAME-theme .md-calendar{background:\"{{background-hue-1}}\";color:\"{{foreground-1-0.87}}\"}.md-THEME_NAME-theme .md-calendar tr:last-child td{border-bottom-color:\"{{background-hue-2}}\"}.md-THEME_NAME-theme .md-calendar-day-header{background:\"{{background-500-0.32}}\";color:\"{{foreground-1-0.87}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today .md-calendar-date-selection-indicator{border:1px solid \"{{primary-500}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today.md-calendar-date-disabled{color:\"{{primary-500-0.6}}\"}.md-calendar-date.md-focus .md-THEME_NAME-theme .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date-selection-indicator:hover{background:\"{{background-500-0.32}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-selected-date .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date.md-focus.md-calendar-selected-date .md-calendar-date-selection-indicator{background:\"{{primary-500}}\";color:\"{{primary-500-contrast}}\";border-color:transparent}.md-THEME_NAME-theme .md-calendar-date-disabled,.md-THEME_NAME-theme .md-calendar-month-label-disabled{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-calendar-month-label md-icon,.md-THEME_NAME-theme .md-datepicker-input{color:\"{{foreground-1}}\"}.md-THEME_NAME-theme .md-datepicker-input:-moz-placeholder,.md-THEME_NAME-theme .md-datepicker-input::-moz-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input:-ms-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input-container{border-bottom-color:\"{{foreground-4}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-invalid,.md-warn .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar-pane{border-color:\"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-triangle-button .md-datepicker-expand-triangle{border-top-color:\"{{foreground-2}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon,.md-THEME_NAME-theme .md-datepicker-open.md-accent .md-datepicker-calendar-icon{color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-open.md-warn .md-datepicker-calendar-icon,.md-warn .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar{background:\"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-input-mask-opaque{box-shadow:0 0 0 9999px \"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-input-container{background:\"{{background-hue-1}}\"}md-dialog.md-THEME_NAME-theme{border-radius:4px;background-color:\"{{background-hue-1}}\";color:\"{{foreground-1}}\"}md-dialog.md-THEME_NAME-theme.md-content-overflow .md-actions,md-dialog.md-THEME_NAME-theme.md-content-overflow md-dialog-actions,md-divider.md-THEME_NAME-theme{border-top-color:\"{{foreground-4}}\"}.layout-gt-lg-row>md-divider.md-THEME_NAME-theme,.layout-gt-md-row>md-divider.md-THEME_NAME-theme,.layout-gt-sm-row>md-divider.md-THEME_NAME-theme,.layout-gt-xs-row>md-divider.md-THEME_NAME-theme,.layout-lg-row>md-divider.md-THEME_NAME-theme,.layout-md-row>md-divider.md-THEME_NAME-theme,.layout-row>md-divider.md-THEME_NAME-theme,.layout-sm-row>md-divider.md-THEME_NAME-theme,.layout-xl-row>md-divider.md-THEME_NAME-theme,.layout-xs-row>md-divider.md-THEME_NAME-theme{border-right-color:\"{{foreground-4}}\"}md-icon.md-THEME_NAME-theme{color:\"{{foreground-2}}\"}md-icon.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}md-icon.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}md-icon.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-input-container.md-THEME_NAME-theme .md-input{color:\"{{foreground-1}}\";border-color:\"{{foreground-4}}\"}md-input-container.md-THEME_NAME-theme .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme .md-input::-moz-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme .md-input:-ms-input-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme .md-input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme>md-icon{color:\"{{foreground-1}}\"}md-input-container.md-THEME_NAME-theme .md-placeholder,md-input-container.md-THEME_NAME-theme label{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme label.md-required:after{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-focused):not(.md-input-invalid) label.md-required:after{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation,md-input-container.md-THEME_NAME-theme .md-input-messages-animation{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation .md-char-counter,md-input-container.md-THEME_NAME-theme .md-input-messages-animation .md-char-counter{color:\"{{foreground-1}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-moz-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-ms-input-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-webkit-input-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-has-value label{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused .md-input,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-resized .md-input{border-color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused md-icon{color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent .md-input{border-color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent md-icon{color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn md-icon{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-char-counter,md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input-message-animation,md-input-container.md-THEME_NAME-theme.md-input-invalid label{color:\"{{warn-A700}}\"}[disabled] md-input-container.md-THEME_NAME-theme .md-input,md-input-container.md-THEME_NAME-theme .md-input[disabled]{border-bottom-color:transparent;color:\"{{foreground-3}}\";background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%)}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h4,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h4{color:\"{{foreground-1}}\"}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text p,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text p{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme .md-proxy-focus.md-focused div.md-no-style{background-color:\"{{background-100}}\"}md-list.md-THEME_NAME-theme md-list-item .md-avatar-icon{background-color:\"{{foreground-3}}\";color:\"{{background-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight{color:\"{{primary-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight.md-accent{color:\"{{accent-color}}\"}md-menu-content.md-THEME_NAME-theme{background-color:\"{{background-hue-1}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item{color:\"{{foreground-1}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item md-icon{color:\"{{foreground-2}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled],md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled] md-icon{color:\"{{foreground-3}}\"}md-menu-content.md-THEME_NAME-theme md-menu-divider{background-color:\"{{foreground-4}}\"}md-menu-bar.md-THEME_NAME-theme>button.md-button{color:\"{{foreground-1}}\";border-radius:2px}md-menu-bar.md-THEME_NAME-theme md-menu>button{color:\"{{foreground-1}}\"}md-menu-bar.md-THEME_NAME-theme md-menu.md-open>button,md-menu-bar.md-THEME_NAME-theme md-menu>button:focus{outline:none;background-color:\"{{ background-500-0.18}}\"}md-menu-bar.md-THEME_NAME-theme.md-open:not(.md-keyboard-mode) md-menu:hover>button{background-color:\"{{ background-500-0.18}}\"}md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:focus,md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:hover{background:transparent}md-menu-content.md-THEME_NAME-theme .md-menu>.md-button:after{color:\"{{foreground-2}}\"}md-menu-content.md-THEME_NAME-theme .md-menu.md-open>.md-button{background-color:\"{{ background-500-0.18}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar{background-color:\"{{background-hue-1}}\";color:\"{{foreground-1}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler{background-color:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler md-icon{color:\"{{primary-contrast}}\"}md-nav-bar.md-THEME_NAME-theme .md-nav-bar{background-color:transparent;border-color:\"{{foreground-4}}\"}md-nav-bar.md-THEME_NAME-theme .md-button._md-nav-button.md-unselected{color:\"{{foreground-2}}\"}md-nav-bar.md-THEME_NAME-theme .md-button._md-nav-button[disabled]{color:\"{{foreground-3}}\"}md-nav-bar.md-THEME_NAME-theme md-nav-ink-bar{color:\"{{accent-color}}\";background:\"{{accent-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar{background-color:\"{{accent-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button{color:\"{{accent-A100}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{accent-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{accent-contrast-0.1}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar md-nav-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar{background-color:\"{{warn-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button{color:\"{{warn-100}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{warn-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{warn-contrast-0.1}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar{background-color:\"{{primary-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button{color:\"{{primary-100}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{primary-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{primary-color}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{primary-100}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{primary-contrast}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{accent-color}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{accent-A100}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{accent-contrast}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{accent-contrast-0.1}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar md-nav-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{warn-color}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{warn-100}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{warn-contrast}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{warn-contrast-0.1}}\"}._md-panel-backdrop.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-progress-circular.md-THEME_NAME-theme path{stroke:\"{{primary-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-warn path{stroke:\"{{warn-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-accent path{stroke:\"{{accent-color}}\"}md-progress-linear.md-THEME_NAME-theme .md-container{background-color:\"{{primary-100}}\"}md-progress-linear.md-THEME_NAME-theme .md-bar{background-color:\"{{primary-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-container{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-bar{background-color:\"{{warn-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-container{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-bar{background-color:\"{{accent-color}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-primary .md-bar1{background-color:\"{{primary-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-primary .md-dashed:before{background:radial-gradient(\"{{primary-100}}\" 0,\"{{primary-100}}\" 16%,transparent 42%)}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-bar1{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-dashed:before{background:radial-gradient(\"{{warn-100}}\" 0,\"{{warn-100}}\" 16%,transparent 42%)}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-bar1{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-dashed:before{background:radial-gradient(\"{{accent-100}}\" 0,\"{{accent-100}}\" 16%,transparent 42%)}md-radio-button.md-THEME_NAME-theme .md-off{border-color:\"{{foreground-2}}\"}md-radio-button.md-THEME_NAME-theme .md-on{background-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-off{border-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme .md-container .md-ripple{color:\"{{accent-A700}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on{background-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off{border-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple{color:\"{{primary-600}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on{background-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off{border-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple{color:\"{{warn-600}}\"}md-radio-button.md-THEME_NAME-theme[disabled],md-radio-group.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\"}md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-on,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-on{border-color:\"{{foreground-3}}\"}md-radio-group.md-THEME_NAME-theme .md-checked .md-ink-ripple{color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme .md-checked:not([disabled]).md-primary .md-ink-ripple,md-radio-group.md-THEME_NAME-theme.md-primary .md-checked:not([disabled]) .md-ink-ripple{color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-primary .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-primary .md-checked .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-warn .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-warn .md-checked .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-input-container md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-input-container:not(.md-input-focused):not(.md-input-invalid) md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{foreground-3}}\"}md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value,md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{primary-color}}\"}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme .md-select-value{color:\"{{warn-A700}}\"!important;border-bottom-color:\"{{warn-A700}}\"!important}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme[disabled] .md-select-value{border-bottom-color:transparent;background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%)}md-select.md-THEME_NAME-theme .md-select-value{border-bottom-color:\"{{foreground-4}}\"}md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched .md-select-value{color:\"{{warn-A700}}\"!important;border-bottom-color:\"{{warn-A700}}\"!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value{border-bottom-color:\"{{primary-color}}\";color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value.md-select-placeholder{color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-accent .md-select-value{border-bottom-color:\"{{accent-color}}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-warn .md-select-value{border-bottom-color:\"{{warn-color}}\"}md-select.md-THEME_NAME-theme[disabled] .md-select-icon,md-select.md-THEME_NAME-theme[disabled] .md-select-value,md-select.md-THEME_NAME-theme[disabled] .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-icon{color:\"{{foreground-2}}\"}md-select-menu.md-THEME_NAME-theme md-content{background-color:\"{{background-hue-1}}\"}md-select-menu.md-THEME_NAME-theme md-content md-optgroup{color:\"{{foreground-2}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option{color:\"{{foreground-1}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[disabled] .md-text{color:\"{{foreground-3}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):focus,md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):hover{background-color:\"{{background-500-0.18}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]{color:\"{{primary-500}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]:focus{color:\"{{primary-600}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent{color:\"{{accent-color}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent:focus{color:\"{{accent-A700}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ripple{color:\"{{primary-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ripple{color:\"{{background-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ink-ripple{color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon{background-color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected].md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}.md-checkbox-enabled.md-THEME_NAME-theme md-option .md-text{color:\"{{foreground-1}}\"}md-sidenav.md-THEME_NAME-theme,md-sidenav.md-THEME_NAME-theme md-content{background-color:\"{{background-hue-1}}\"}md-slider.md-THEME_NAME-theme .md-track{background-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme .md-track-ticks{color:\"{{background-contrast}}\"}md-slider.md-THEME_NAME-theme .md-focus-ring{background-color:\"{{accent-A200-0.2}}\"}md-slider.md-THEME_NAME-theme .md-disabled-thumb{border-color:\"{{background-color}}\";background-color:\"{{background-color}}\"}md-slider.md-THEME_NAME-theme.md-min .md-thumb:after{background-color:\"{{background-color}}\";border-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme.md-min .md-focus-ring{background-color:\"{{foreground-3-0.38}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-thumb:after{background-color:\"{{background-contrast}}\";border-color:transparent}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete][md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme .md-track.md-track-fill{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-thumb:after{border-color:\"{{accent-color}}\";background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign:after{border-top-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-thumb-text{color:\"{{accent-contrast}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-focus-ring{background-color:\"{{warn-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-track.md-track-fill{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-thumb:after{border-color:\"{{warn-color}}\";background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign:after{border-top-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-thumb-text{color:\"{{warn-contrast}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-focus-ring{background-color:\"{{primary-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-track.md-track-fill{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-thumb:after{border-color:\"{{primary-color}}\";background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign:after{border-top-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-thumb-text{color:\"{{primary-contrast}}\"}md-slider.md-THEME_NAME-theme[disabled] .md-thumb:after{border-color:transparent}md-slider.md-THEME_NAME-theme[disabled]:not(.md-min) .md-thumb:after,md-slider.md-THEME_NAME-theme[disabled][md-discrete] .md-thumb:after{background-color:\"{{foreground-3}}\";border-color:transparent}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly][md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-disabled-thumb{border-color:transparent;background-color:transparent}md-slider-container[disabled]>:first-child:not(md-slider),md-slider-container[disabled]>:last-child:not(md-slider){color:\"{{foreground-3}}\"}.md-subheader.md-THEME_NAME-theme{color:\"{{ foreground-2-0.23 }}\";background-color:\"{{background-default}}\"}.md-subheader.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-subheader.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-subheader.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme .md-ink-ripple{color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme .md-thumb{background-color:\"{{background-50}}\"}md-switch.md-THEME_NAME-theme .md-bar{background-color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-thumb{background-color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-bar{background-color:\"{{accent-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-focused .md-thumb:before{background-color:\"{{accent-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-ink-ripple{color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-thumb{background-color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-bar{background-color:\"{{primary-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary.md-focused .md-thumb:before{background-color:\"{{primary-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-ink-ripple{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-thumb{background-color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-bar{background-color:\"{{warn-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn.md-focused .md-thumb:before{background-color:\"{{warn-color-0.26}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-thumb{background-color:\"{{background-400}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-bar{background-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme md-tabs-wrapper{background-color:transparent;border-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme .md-paginator md-icon{color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme md-ink-bar{color:\"{{accent-color}}\";background:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab{color:\"{{foreground-2}}\"}md-tabs.md-THEME_NAME-theme .md-tab[disabled],md-tabs.md-THEME_NAME-theme .md-tab[disabled] md-icon{color:\"{{foreground-3}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-active,md-tabs.md-THEME_NAME-theme .md-tab.md-active md-icon,md-tabs.md-THEME_NAME-theme .md-tab.md-focused,md-tabs.md-THEME_NAME-theme .md-tab.md-focused md-icon{color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-focused{background:\"{{primary-color-0.1}}\"}md-tabs.md-THEME_NAME-theme .md-tab .md-ripple-container{color:\"{{accent-A100}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper{background-color:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{accent-A100}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-100}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper{background-color:\"{{warn-color}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-100}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-contrast-0.1}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-100}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{accent-color}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{accent-A100}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-contrast}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-contrast-0.1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{warn-color}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-100}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-contrast}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-contrast-0.1}}\"}md-toast.md-THEME_NAME-theme .md-toast-content{background-color:#323232;color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button{color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight{color:\"{{accent-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-primary{color:\"{{primary-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-warn{color:\"{{warn-color}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar){background-color:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-icon{color:\"{{primary-contrast}}\";fill:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) .md-button[disabled] md-icon{color:\"{{primary-contrast-0.26}}\";fill:\"{{primary-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-ink-ripple{color:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-icon{color:\"{{accent-contrast}}\";fill:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-button[disabled] md-icon{color:\"{{accent-contrast-0.26}}\";fill:\"{{accent-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn{background-color:\"{{warn-color}}\";color:\"{{warn-contrast}}\"}.md-panel.md-tooltip.md-THEME_NAME-theme{color:\"{{background-700-contrast}}\";background-color:\"{{background-700}}\"}body.md-THEME_NAME-theme,html.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-color}}\"}"); 
	})();
	
	
	})(window, window.angular);;window.ngMaterial={version:{full: "1.1.10"}};

/***/ }),

/***/ 1070:
983,

/***/ 1076:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1077);

/***/ }),

/***/ 1077:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.11
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var ELEMENT_NODE = 1;
	var COMMENT_NODE = 8;
	
	var ADD_CLASS_SUFFIX = '-add';
	var REMOVE_CLASS_SUFFIX = '-remove';
	var EVENT_CLASS_PREFIX = 'ng-';
	var ACTIVE_CLASS_SUFFIX = '-active';
	var PREPARE_CLASS_SUFFIX = '-prepare';
	
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';
	
	// Detect proper transitionend/animationend event names.
	var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;
	
	// If unprefixed events are not supported but webkit-prefixed are, use the latter.
	// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
	// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
	// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
	// Register both events in case `window.onanimationend` is not supported because of that,
	// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
	// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
	// therefore there is no reason to test anymore for other vendor prefixes:
	// http://caniuse.com/#search=transition
	if ((window.ontransitionend === undefined) && (window.onwebkittransitionend !== undefined)) {
	  CSS_PREFIX = '-webkit-';
	  TRANSITION_PROP = 'WebkitTransition';
	  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
	} else {
	  TRANSITION_PROP = 'transition';
	  TRANSITIONEND_EVENT = 'transitionend';
	}
	
	if ((window.onanimationend === undefined) && (window.onwebkitanimationend !== undefined)) {
	  CSS_PREFIX = '-webkit-';
	  ANIMATION_PROP = 'WebkitAnimation';
	  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
	} else {
	  ANIMATION_PROP = 'animation';
	  ANIMATIONEND_EVENT = 'animationend';
	}
	
	var DURATION_KEY = 'Duration';
	var PROPERTY_KEY = 'Property';
	var DELAY_KEY = 'Delay';
	var TIMING_KEY = 'TimingFunction';
	var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
	var ANIMATION_PLAYSTATE_KEY = 'PlayState';
	var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;
	
	var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
	var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
	var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
	var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;
	
	var ngMinErr = angular.$$minErr('ng');
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function packageStyles(options) {
	  var styles = {};
	  if (options && (options.to || options.from)) {
	    styles.to = options.to;
	    styles.from = options.from;
	  }
	  return styles;
	}
	
	function pendClasses(classes, fix, isPrefix) {
	  var className = '';
	  classes = isArray(classes)
	      ? classes
	      : classes && isString(classes) && classes.length
	          ? classes.split(/\s+/)
	          : [];
	  forEach(classes, function(klass, i) {
	    if (klass && klass.length > 0) {
	      className += (i > 0) ? ' ' : '';
	      className += isPrefix ? fix + klass
	                            : klass + fix;
	    }
	  });
	  return className;
	}
	
	function removeFromArray(arr, val) {
	  var index = arr.indexOf(val);
	  if (val >= 0) {
	    arr.splice(index, 1);
	  }
	}
	
	function stripCommentsFromElement(element) {
	  if (element instanceof jqLite) {
	    switch (element.length) {
	      case 0:
	        return element;
	
	      case 1:
	        // there is no point of stripping anything if the element
	        // is the only element within the jqLite wrapper.
	        // (it's important that we retain the element instance.)
	        if (element[0].nodeType === ELEMENT_NODE) {
	          return element;
	        }
	        break;
	
	      default:
	        return jqLite(extractElementNode(element));
	    }
	  }
	
	  if (element.nodeType === ELEMENT_NODE) {
	    return jqLite(element);
	  }
	}
	
	function extractElementNode(element) {
	  if (!element[0]) return element;
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function $$addClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.addClass(elm, className);
	  });
	}
	
	function $$removeClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.removeClass(elm, className);
	  });
	}
	
	function applyAnimationClassesFactory($$jqLite) {
	  return function(element, options) {
	    if (options.addClass) {
	      $$addClass($$jqLite, element, options.addClass);
	      options.addClass = null;
	    }
	    if (options.removeClass) {
	      $$removeClass($$jqLite, element, options.removeClass);
	      options.removeClass = null;
	    }
	  };
	}
	
	function prepareAnimationOptions(options) {
	  options = options || {};
	  if (!options.$$prepared) {
	    var domOperation = options.domOperation || noop;
	    options.domOperation = function() {
	      options.$$domOperationFired = true;
	      domOperation();
	      domOperation = noop;
	    };
	    options.$$prepared = true;
	  }
	  return options;
	}
	
	function applyAnimationStyles(element, options) {
	  applyAnimationFromStyles(element, options);
	  applyAnimationToStyles(element, options);
	}
	
	function applyAnimationFromStyles(element, options) {
	  if (options.from) {
	    element.css(options.from);
	    options.from = null;
	  }
	}
	
	function applyAnimationToStyles(element, options) {
	  if (options.to) {
	    element.css(options.to);
	    options.to = null;
	  }
	}
	
	function mergeAnimationDetails(element, oldAnimation, newAnimation) {
	  var target = oldAnimation.options || {};
	  var newOptions = newAnimation.options || {};
	
	  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
	  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
	  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);
	
	  if (newOptions.preparationClasses) {
	    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
	    delete newOptions.preparationClasses;
	  }
	
	  // noop is basically when there is no callback; otherwise something has been set
	  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;
	
	  extend(target, newOptions);
	
	  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
	  if (realDomOperation) {
	    target.domOperation = realDomOperation;
	  }
	
	  if (classes.addClass) {
	    target.addClass = classes.addClass;
	  } else {
	    target.addClass = null;
	  }
	
	  if (classes.removeClass) {
	    target.removeClass = classes.removeClass;
	  } else {
	    target.removeClass = null;
	  }
	
	  oldAnimation.addClass = target.addClass;
	  oldAnimation.removeClass = target.removeClass;
	
	  return target;
	}
	
	function resolveElementClasses(existing, toAdd, toRemove) {
	  var ADD_CLASS = 1;
	  var REMOVE_CLASS = -1;
	
	  var flags = {};
	  existing = splitClassesToLookup(existing);
	
	  toAdd = splitClassesToLookup(toAdd);
	  forEach(toAdd, function(value, key) {
	    flags[key] = ADD_CLASS;
	  });
	
	  toRemove = splitClassesToLookup(toRemove);
	  forEach(toRemove, function(value, key) {
	    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
	  });
	
	  var classes = {
	    addClass: '',
	    removeClass: ''
	  };
	
	  forEach(flags, function(val, klass) {
	    var prop, allow;
	    if (val === ADD_CLASS) {
	      prop = 'addClass';
	      allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
	    } else if (val === REMOVE_CLASS) {
	      prop = 'removeClass';
	      allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
	    }
	    if (allow) {
	      if (classes[prop].length) {
	        classes[prop] += ' ';
	      }
	      classes[prop] += klass;
	    }
	  });
	
	  function splitClassesToLookup(classes) {
	    if (isString(classes)) {
	      classes = classes.split(' ');
	    }
	
	    var obj = {};
	    forEach(classes, function(klass) {
	      // sometimes the split leaves empty string values
	      // incase extra spaces were applied to the options
	      if (klass.length) {
	        obj[klass] = true;
	      }
	    });
	    return obj;
	  }
	
	  return classes;
	}
	
	function getDomNode(element) {
	  return (element instanceof jqLite) ? element[0] : element;
	}
	
	function applyGeneratedPreparationClasses(element, event, options) {
	  var classes = '';
	  if (event) {
	    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
	  }
	  if (options.addClass) {
	    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
	  }
	  if (options.removeClass) {
	    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
	  }
	  if (classes.length) {
	    options.preparationClasses = classes;
	    element.addClass(classes);
	  }
	}
	
	function clearGeneratedClasses(element, options) {
	  if (options.preparationClasses) {
	    element.removeClass(options.preparationClasses);
	    options.preparationClasses = null;
	  }
	  if (options.activeClasses) {
	    element.removeClass(options.activeClasses);
	    options.activeClasses = null;
	  }
	}
	
	function blockTransitions(node, duration) {
	  // we use a negative delay value since it performs blocking
	  // yet it doesn't kill any existing transitions running on the
	  // same element which makes this safe for class-based animations
	  var value = duration ? '-' + duration + 's' : '';
	  applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
	  return [TRANSITION_DELAY_PROP, value];
	}
	
	function blockKeyframeAnimations(node, applyBlock) {
	  var value = applyBlock ? 'paused' : '';
	  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
	  applyInlineStyle(node, [key, value]);
	  return [key, value];
	}
	
	function applyInlineStyle(node, styleTuple) {
	  var prop = styleTuple[0];
	  var value = styleTuple[1];
	  node.style[prop] = value;
	}
	
	function concatWithSpace(a,b) {
	  if (!a) return b;
	  if (!b) return a;
	  return a + ' ' + b;
	}
	
	var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
	  var queue, cancelFn;
	
	  function scheduler(tasks) {
	    // we make a copy since RAFScheduler mutates the state
	    // of the passed in array variable and this would be difficult
	    // to track down on the outside code
	    queue = queue.concat(tasks);
	    nextTick();
	  }
	
	  queue = scheduler.queue = [];
	
	  /* waitUntilQuiet does two things:
	   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
	   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
	   *
	   * The motivation here is that animation code can request more time from the scheduler
	   * before the next wave runs. This allows for certain DOM properties such as classes to
	   * be resolved in time for the next animation to run.
	   */
	  scheduler.waitUntilQuiet = function(fn) {
	    if (cancelFn) cancelFn();
	
	    cancelFn = $$rAF(function() {
	      cancelFn = null;
	      fn();
	      nextTick();
	    });
	  };
	
	  return scheduler;
	
	  function nextTick() {
	    if (!queue.length) return;
	
	    var items = queue.shift();
	    for (var i = 0; i < items.length; i++) {
	      items[i]();
	    }
	
	    if (!cancelFn) {
	      $$rAF(function() {
	        if (!cancelFn) nextTick();
	      });
	    }
	  }
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateChildren
	 * @restrict AE
	 * @element ANY
	 *
	 * @description
	 *
	 * ngAnimateChildren allows you to specify that children of this element should animate even if any
	 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
	 * (structural) animation, child elements that also have an active structural animation are not animated.
	 *
	 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
	 *
	 *
	 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
	 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
	 *
	 * @example
	 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	       <div ng-controller="MainController as main">
	         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
	         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
	         <hr>
	         <div ng-animate-children="{{main.animateChildren}}">
	           <div ng-if="main.enterElement" class="container">
	             List of items:
	             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
	           </div>
	         </div>
	       </div>
	     </file>
	     <file name="animations.css">
	
	      .container.ng-enter,
	      .container.ng-leave {
	        transition: all ease 1.5s;
	      }
	
	      .container.ng-enter,
	      .container.ng-leave-active {
	        opacity: 0;
	      }
	
	      .container.ng-leave,
	      .container.ng-enter-active {
	        opacity: 1;
	      }
	
	      .item {
	        background: firebrick;
	        color: #FFF;
	        margin-bottom: 10px;
	      }
	
	      .item.ng-enter,
	      .item.ng-leave {
	        transition: transform 1.5s ease;
	      }
	
	      .item.ng-enter {
	        transform: translateX(50px);
	      }
	
	      .item.ng-enter-active {
	        transform: translateX(0);
	      }
	    </file>
	    <file name="script.js">
	      angular.module('ngAnimateChildren', ['ngAnimate'])
	        .controller('MainController', function MainController() {
	          this.animateChildren = false;
	          this.enterElement = false;
	        });
	    </file>
	  </example>
	 */
	var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
	  return {
	    link: function(scope, element, attrs) {
	      var val = attrs.ngAnimateChildren;
	      if (isString(val) && val.length === 0) { //empty attribute
	        element.data(NG_ANIMATE_CHILDREN_DATA, true);
	      } else {
	        // Interpolate and set the value, so that it is available to
	        // animations that run right after compilation
	        setData($interpolate(val)(scope));
	        attrs.$observe('ngAnimateChildren', setData);
	      }
	
	      function setData(value) {
	        value = value === 'on' || value === 'true';
	        element.data(NG_ANIMATE_CHILDREN_DATA, value);
	      }
	    }
	  };
	}];
	
	/* exported $AnimateCssProvider */
	
	var ANIMATE_TIMER_KEY = '$$animateCss';
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 *
	 * @description
	 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
	 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
	 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
	 * directives to create more complex animations that can be purely driven using CSS code.
	 *
	 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
	 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
	 *
	 * ## Usage
	 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
	 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
	 * any automatic control over cancelling animations and/or preventing animations from being run on
	 * child elements will not be handled by Angular. For this to work as expected, please use `$animate` to
	 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
	 * the CSS animation.
	 *
	 * The example below shows how we can create a folding animation on an element using `ng-if`:
	 *
	 * ```html
	 * <!-- notice the `fold-animation` CSS class -->
	 * <div ng-if="onOff" class="fold-animation">
	 *   This element will go BOOM
	 * </div>
	 * <button ng-click="onOff=true">Fold In</button>
	 * ```
	 *
	 * Now we create the **JavaScript animation** that will trigger the CSS transition:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## More Advanced Uses
	 *
	 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
	 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
	 *
	 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
	 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
	 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
	 * to provide a working animation that will run in CSS.
	 *
	 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         addClass: 'red large-text pulse-twice',
	 *         easing: 'ease-out',
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
	 *
	 * ```css
	 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
	 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
	 * .red { background:red; }
	 * .large-text { font-size:20px; }
	 *
	 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
	 * .pulse-twice {
	 *   animation: 0.5s pulse linear 2;
	 *   -webkit-animation: 0.5s pulse linear 2;
	 * }
	 *
	 * @keyframes pulse {
	 *   from { transform: scale(0.5); }
	 *   to { transform: scale(1.5); }
	 * }
	 *
	 * @-webkit-keyframes pulse {
	 *   from { -webkit-transform: scale(0.5); }
	 *   to { -webkit-transform: scale(1.5); }
	 * }
	 * ```
	 *
	 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
	 *
	 * ## How the Options are handled
	 *
	 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
	 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
	 * styles using the `from` and `to` properties.
	 *
	 * ```js
	 * var animator = $animateCss(element, {
	 *   from: { background:'red' },
	 *   to: { background:'blue' }
	 * });
	 * animator.start();
	 * ```
	 *
	 * ```css
	 * .rotating-animation {
	 *   animation:0.5s rotate linear;
	 *   -webkit-animation:0.5s rotate linear;
	 * }
	 *
	 * @keyframes rotate {
	 *   from { transform: rotate(0deg); }
	 *   to { transform: rotate(360deg); }
	 * }
	 *
	 * @-webkit-keyframes rotate {
	 *   from { -webkit-transform: rotate(0deg); }
	 *   to { -webkit-transform: rotate(360deg); }
	 * }
	 * ```
	 *
	 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
	 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
	 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
	 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
	 * and spread across the transition and keyframe animation.
	 *
	 * ## What is returned
	 *
	 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
	 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
	 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
	 *
	 * ```js
	 * var animator = $animateCss(element, { ... });
	 * ```
	 *
	 * Now what do the contents of our `animator` variable look like:
	 *
	 * ```js
	 * {
	 *   // starts the animation
	 *   start: Function,
	 *
	 *   // ends (aborts) the animation
	 *   end: Function
	 * }
	 * ```
	 *
	 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
	 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
	 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
	 * and that changing them will not reconfigure the parameters of the animation.
	 *
	 * ### runner.done() vs runner.then()
	 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
	 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
	 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
	 * unless you really need a digest to kick off afterwards.
	 *
	 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
	 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
	 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
	 *
	 * @param {DOMElement} element the element that will be animated
	 * @param {object} options the animation-related options that will be applied during the animation
	 *
	 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
	 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
	 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
	 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
	 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
	 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
	 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
	 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
	 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
	 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
	 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
	 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
	 * is provided then the animation will be skipped entirely.
	 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
	 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
	 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
	 * CSS delay value.
	 * * `stagger` - A numeric time value representing the delay between successively animated elements
	 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
	 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
	 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
	 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
	 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
	 *    the animation is closed. This is useful for when the styles are used purely for the sake of
	 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
	 *    By default this value is set to `false`.
	 *
	 * @return {object} an object with start and end methods and details about the animation.
	 *
	 * * `start` - The method to start the animation. This will return a `Promise` when called.
	 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
	 */
	var ONE_SECOND = 1000;
	
	var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
	var CLOSING_TIME_BUFFER = 1.5;
	
	var DETECT_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP,
	  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
	};
	
	var DETECT_STAGGER_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP
	};
	
	function getCssKeyframeDurationStyle(duration) {
	  return [ANIMATION_DURATION_PROP, duration + 's'];
	}
	
	function getCssDelayStyle(delay, isKeyframeAnimation) {
	  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
	  return [prop, delay + 's'];
	}
	
	function computeCssStyles($window, element, properties) {
	  var styles = Object.create(null);
	  var detectedStyles = $window.getComputedStyle(element) || {};
	  forEach(properties, function(formalStyleName, actualStyleName) {
	    var val = detectedStyles[formalStyleName];
	    if (val) {
	      var c = val.charAt(0);
	
	      // only numerical-based values have a negative sign or digit as the first value
	      if (c === '-' || c === '+' || c >= 0) {
	        val = parseMaxTime(val);
	      }
	
	      // by setting this to null in the event that the delay is not set or is set directly as 0
	      // then we can still allow for negative values to be used later on and not mistake this
	      // value for being greater than any other negative value.
	      if (val === 0) {
	        val = null;
	      }
	      styles[actualStyleName] = val;
	    }
	  });
	
	  return styles;
	}
	
	function parseMaxTime(str) {
	  var maxValue = 0;
	  var values = str.split(/\s*,\s*/);
	  forEach(values, function(value) {
	    // it's always safe to consider only second values and omit `ms` values since
	    // getComputedStyle will always handle the conversion for us
	    if (value.charAt(value.length - 1) === 's') {
	      value = value.substring(0, value.length - 1);
	    }
	    value = parseFloat(value) || 0;
	    maxValue = maxValue ? Math.max(value, maxValue) : value;
	  });
	  return maxValue;
	}
	
	function truthyTimingValue(val) {
	  return val === 0 || val != null;
	}
	
	function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
	  var style = TRANSITION_PROP;
	  var value = duration + 's';
	  if (applyOnlyDuration) {
	    style += DURATION_KEY;
	  } else {
	    value += ' linear all';
	  }
	  return [style, value];
	}
	
	function createLocalCacheLookup() {
	  var cache = Object.create(null);
	  return {
	    flush: function() {
	      cache = Object.create(null);
	    },
	
	    count: function(key) {
	      var entry = cache[key];
	      return entry ? entry.total : 0;
	    },
	
	    get: function(key) {
	      var entry = cache[key];
	      return entry && entry.value;
	    },
	
	    put: function(key, value) {
	      if (!cache[key]) {
	        cache[key] = { total: 1, value: value };
	      } else {
	        cache[key].total++;
	      }
	    }
	  };
	}
	
	// we do not reassign an already present style value since
	// if we detect the style property value again we may be
	// detecting styles that were added via the `from` styles.
	// We make use of `isDefined` here since an empty string
	// or null value (which is what getPropertyValue will return
	// for a non-existing style) will still be marked as a valid
	// value for the style (a falsy value implies that the style
	// is to be removed at the end of the animation). If we had a simple
	// "OR" statement then it would not be enough to catch that.
	function registerRestorableStyles(backup, node, properties) {
	  forEach(properties, function(prop) {
	    backup[prop] = isDefined(backup[prop])
	        ? backup[prop]
	        : node.style.getPropertyValue(prop);
	  });
	}
	
	var $AnimateCssProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var gcsLookup = createLocalCacheLookup();
	  var gcsStaggerLookup = createLocalCacheLookup();
	
	  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout',
	               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
	       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,
	                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    var parentCounter = 0;
	    function gcsHashFn(node, extraClasses) {
	      var KEY = '$$ngAnimateParentKey';
	      var parentNode = node.parentNode;
	      var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
	      return parentID + '-' + node.getAttribute('class') + '-' + extraClasses;
	    }
	
	    function computeCachedCssStyles(node, className, cacheKey, properties) {
	      var timings = gcsLookup.get(cacheKey);
	
	      if (!timings) {
	        timings = computeCssStyles($window, node, properties);
	        if (timings.animationIterationCount === 'infinite') {
	          timings.animationIterationCount = 1;
	        }
	      }
	
	      // we keep putting this in multiple times even though the value and the cacheKey are the same
	      // because we're keeping an internal tally of how many duplicate animations are detected.
	      gcsLookup.put(cacheKey, timings);
	      return timings;
	    }
	
	    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
	      var stagger;
	
	      // if we have one or more existing matches of matching elements
	      // containing the same parent + CSS styles (which is how cacheKey works)
	      // then staggering is possible
	      if (gcsLookup.count(cacheKey) > 0) {
	        stagger = gcsStaggerLookup.get(cacheKey);
	
	        if (!stagger) {
	          var staggerClassName = pendClasses(className, '-stagger');
	
	          $$jqLite.addClass(node, staggerClassName);
	
	          stagger = computeCssStyles($window, node, properties);
	
	          // force the conversion of a null value to zero incase not set
	          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
	          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);
	
	          $$jqLite.removeClass(node, staggerClassName);
	
	          gcsStaggerLookup.put(cacheKey, stagger);
	        }
	      }
	
	      return stagger || {};
	    }
	
	    var rafWaitQueue = [];
	    function waitUntilQuiet(callback) {
	      rafWaitQueue.push(callback);
	      $$rAFScheduler.waitUntilQuiet(function() {
	        gcsLookup.flush();
	        gcsStaggerLookup.flush();
	
	        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	        var pageWidth = $$forceReflow();
	
	        // we use a for loop to ensure that if the queue is changed
	        // during this looping then it will consider new requests
	        for (var i = 0; i < rafWaitQueue.length; i++) {
	          rafWaitQueue[i](pageWidth);
	        }
	        rafWaitQueue.length = 0;
	      });
	    }
	
	    function computeTimings(node, className, cacheKey) {
	      var timings = computeCachedCssStyles(node, className, cacheKey, DETECT_CSS_PROPERTIES);
	      var aD = timings.animationDelay;
	      var tD = timings.transitionDelay;
	      timings.maxDelay = aD && tD
	          ? Math.max(aD, tD)
	          : (aD || tD);
	      timings.maxDuration = Math.max(
	          timings.animationDuration * timings.animationIterationCount,
	          timings.transitionDuration);
	
	      return timings;
	    }
	
	    return function init(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = prepareAnimationOptions(copy(options));
	      }
	
	      var restoreStyles = {};
	      var node = getDomNode(element);
	      if (!node
	          || !node.parentNode
	          || !$$animateQueue.enabled()) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var temporaryStyles = [];
	      var classes = element.attr('class');
	      var styles = packageStyles(options);
	      var animationClosed;
	      var animationPaused;
	      var animationCompleted;
	      var runner;
	      var runnerHost;
	      var maxDelay;
	      var maxDelayTime;
	      var maxDuration;
	      var maxDurationTime;
	      var startTime;
	      var events = [];
	
	      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var method = options.event && isArray(options.event)
	            ? options.event.join(' ')
	            : options.event;
	
	      var isStructural = method && options.structural;
	      var structuralClassName = '';
	      var addRemoveClassName = '';
	
	      if (isStructural) {
	        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
	      } else if (method) {
	        structuralClassName = method;
	      }
	
	      if (options.addClass) {
	        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
	      }
	
	      if (options.removeClass) {
	        if (addRemoveClassName.length) {
	          addRemoveClassName += ' ';
	        }
	        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
	      }
	
	      // there may be a situation where a structural animation is combined together
	      // with CSS classes that need to resolve before the animation is computed.
	      // However this means that there is no explicit CSS code to block the animation
	      // from happening (by setting 0s none in the class name). If this is the case
	      // we need to apply the classes before the first rAF so we know to continue if
	      // there actually is a detected transition or keyframe animation
	      if (options.applyClassesEarly && addRemoveClassName.length) {
	        applyAnimationClasses(element, options);
	      }
	
	      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
	      var fullClassName = classes + ' ' + preparationClasses;
	      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
	      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
	      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;
	
	      // there is no way we can trigger an animation if no styles and
	      // no classes are being applied which would then trigger a transition,
	      // unless there a is raw keyframe value that is applied to the element.
	      if (!containsKeyframeAnimation
	           && !hasToStyles
	           && !preparationClasses) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var cacheKey, stagger;
	      if (options.stagger > 0) {
	        var staggerVal = parseFloat(options.stagger);
	        stagger = {
	          transitionDelay: staggerVal,
	          animationDelay: staggerVal,
	          transitionDuration: 0,
	          animationDuration: 0
	        };
	      } else {
	        cacheKey = gcsHashFn(node, fullClassName);
	        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
	      }
	
	      if (!options.$$skipPreparationClasses) {
	        $$jqLite.addClass(element, preparationClasses);
	      }
	
	      var applyOnlyDuration;
	
	      if (options.transitionStyle) {
	        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
	        applyInlineStyle(node, transitionStyle);
	        temporaryStyles.push(transitionStyle);
	      }
	
	      if (options.duration >= 0) {
	        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
	        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);
	
	        // we set the duration so that it will be picked up by getComputedStyle later
	        applyInlineStyle(node, durationStyle);
	        temporaryStyles.push(durationStyle);
	      }
	
	      if (options.keyframeStyle) {
	        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
	        applyInlineStyle(node, keyframeStyle);
	        temporaryStyles.push(keyframeStyle);
	      }
	
	      var itemIndex = stagger
	          ? options.staggerIndex >= 0
	              ? options.staggerIndex
	              : gcsLookup.count(cacheKey)
	          : 0;
	
	      var isFirst = itemIndex === 0;
	
	      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
	      // without causing any combination of transitions to kick in. By adding a negative delay value
	      // it forces the setup class' transition to end immediately. We later then remove the negative
	      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
	      // that if there is no transition defined then nothing will happen and this will also allow
	      // other transitions to be stacked on top of each other without any chopping them out.
	      if (isFirst && !options.skipBlocking) {
	        blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
	      }
	
	      var timings = computeTimings(node, fullClassName, cacheKey);
	      var relativeDelay = timings.maxDelay;
	      maxDelay = Math.max(relativeDelay, 0);
	      maxDuration = timings.maxDuration;
	
	      var flags = {};
	      flags.hasTransitions          = timings.transitionDuration > 0;
	      flags.hasAnimations           = timings.animationDuration > 0;
	      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty === 'all';
	      flags.applyTransitionDuration = hasToStyles && (
	                                        (flags.hasTransitions && !flags.hasTransitionAll)
	                                         || (flags.hasAnimations && !flags.hasTransitions));
	      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
	      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
	      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
	      flags.recalculateTimingStyles = addRemoveClassName.length > 0;
	
	      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
	        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;
	
	        if (flags.applyTransitionDuration) {
	          flags.hasTransitions = true;
	          timings.transitionDuration = maxDuration;
	          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
	          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
	        }
	
	        if (flags.applyAnimationDuration) {
	          flags.hasAnimations = true;
	          timings.animationDuration = maxDuration;
	          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
	        }
	      }
	
	      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      if (options.delay != null) {
	        var delayStyle;
	        if (typeof options.delay !== 'boolean') {
	          delayStyle = parseFloat(options.delay);
	          // number in options.delay means we have to recalculate the delay for the closing timeout
	          maxDelay = Math.max(delayStyle, 0);
	        }
	
	        if (flags.applyTransitionDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle));
	        }
	
	        if (flags.applyAnimationDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
	        }
	      }
	
	      // we need to recalculate the delay value since we used a pre-emptive negative
	      // delay value and the delay value is required for the final event checking. This
	      // property will ensure that this will happen after the RAF phase has passed.
	      if (options.duration == null && timings.transitionDuration > 0) {
	        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
	      }
	
	      maxDelayTime = maxDelay * ONE_SECOND;
	      maxDurationTime = maxDuration * ONE_SECOND;
	      if (!options.skipBlocking) {
	        flags.blockTransition = timings.transitionDuration > 0;
	        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
	                                       stagger.animationDelay > 0 &&
	                                       stagger.animationDuration === 0;
	      }
	
	      if (options.from) {
	        if (options.cleanupStyles) {
	          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
	        }
	        applyAnimationFromStyles(element, options);
	      }
	
	      if (flags.blockTransition || flags.blockKeyframeAnimation) {
	        applyBlocking(maxDuration);
	      } else if (!options.skipBlocking) {
	        blockTransitions(node, false);
	      }
	
	      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
	      return {
	        $$willAnimate: true,
	        end: endFn,
	        start: function() {
	          if (animationClosed) return;
	
	          runnerHost = {
	            end: endFn,
	            cancel: cancelFn,
	            resume: null, //this will be set during the start() phase
	            pause: null
	          };
	
	          runner = new $$AnimateRunner(runnerHost);
	
	          waitUntilQuiet(start);
	
	          // we don't have access to pause/resume the animation
	          // since it hasn't run yet. AnimateRunner will therefore
	          // set noop functions for resume and pause and they will
	          // later be overridden once the animation is triggered
	          return runner;
	        }
	      };
	
	      function endFn() {
	        close();
	      }
	
	      function cancelFn() {
	        close(true);
	      }
	
	      function close(rejected) {
	        // if the promise has been called already then we shouldn't close
	        // the animation again
	        if (animationClosed || (animationCompleted && animationPaused)) return;
	        animationClosed = true;
	        animationPaused = false;
	
	        if (!options.$$skipPreparationClasses) {
	          $$jqLite.removeClass(element, preparationClasses);
	        }
	        $$jqLite.removeClass(element, activeClasses);
	
	        blockKeyframeAnimations(node, false);
	        blockTransitions(node, false);
	
	        forEach(temporaryStyles, function(entry) {
	          // There is only one way to remove inline style properties entirely from elements.
	          // By using `removeProperty` this works, but we need to convert camel-cased CSS
	          // styles down to hyphenated values.
	          node.style[entry[0]] = '';
	        });
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	
	        if (Object.keys(restoreStyles).length) {
	          forEach(restoreStyles, function(value, prop) {
	            if (value) {
	              node.style.setProperty(prop, value);
	            } else {
	              node.style.removeProperty(prop);
	            }
	          });
	        }
	
	        // the reason why we have this option is to allow a synchronous closing callback
	        // that is fired as SOON as the animation ends (when the CSS is removed) or if
	        // the animation never takes off at all. A good example is a leave animation since
	        // the element must be removed just after the animation is over or else the element
	        // will appear on screen for one animation frame causing an overbearing flicker.
	        if (options.onDone) {
	          options.onDone();
	        }
	
	        if (events && events.length) {
	          // Remove the transitionend / animationend listener(s)
	          element.off(events.join(' '), onAnimationProgress);
	        }
	
	        //Cancel the fallback closing timeout and remove the timer data
	        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
	        if (animationTimerData) {
	          $timeout.cancel(animationTimerData[0].timer);
	          element.removeData(ANIMATE_TIMER_KEY);
	        }
	
	        // if the preparation function fails then the promise is not setup
	        if (runner) {
	          runner.complete(!rejected);
	        }
	      }
	
	      function applyBlocking(duration) {
	        if (flags.blockTransition) {
	          blockTransitions(node, duration);
	        }
	
	        if (flags.blockKeyframeAnimation) {
	          blockKeyframeAnimations(node, !!duration);
	        }
	      }
	
	      function closeAndReturnNoopAnimator() {
	        runner = new $$AnimateRunner({
	          end: endFn,
	          cancel: cancelFn
	        });
	
	        // should flush the cache animation
	        waitUntilQuiet(noop);
	        close();
	
	        return {
	          $$willAnimate: false,
	          start: function() {
	            return runner;
	          },
	          end: endFn
	        };
	      }
	
	      function onAnimationProgress(event) {
	        event.stopPropagation();
	        var ev = event.originalEvent || event;
	
	        // we now always use `Date.now()` due to the recent changes with
	        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
	        var timeStamp = ev.$manualTimeStamp || Date.now();
	
	        /* Firefox (or possibly just Gecko) likes to not round values up
	         * when a ms measurement is used for the animation */
	        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));
	
	        /* $manualTimeStamp is a mocked timeStamp value which is set
	         * within browserTrigger(). This is only here so that tests can
	         * mock animations properly. Real events fallback to event.timeStamp,
	         * or, if they don't, then a timeStamp is automatically created for them.
	         * We're checking to see if the timeStamp surpasses the expected delay,
	         * but we're using elapsedTime instead of the timeStamp on the 2nd
	         * pre-condition since animationPauseds sometimes close off early */
	        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	          // we set this flag to ensure that if the transition is paused then, when resumed,
	          // the animation will automatically close itself since transitions cannot be paused.
	          animationCompleted = true;
	          close();
	        }
	      }
	
	      function start() {
	        if (animationClosed) return;
	        if (!node.parentNode) {
	          close();
	          return;
	        }
	
	        // even though we only pause keyframe animations here the pause flag
	        // will still happen when transitions are used. Only the transition will
	        // not be paused since that is not possible. If the animation ends when
	        // paused then it will not complete until unpaused or cancelled.
	        var playPause = function(playAnimation) {
	          if (!animationCompleted) {
	            animationPaused = !playAnimation;
	            if (timings.animationDuration) {
	              var value = blockKeyframeAnimations(node, animationPaused);
	              if (animationPaused) {
	                temporaryStyles.push(value);
	              } else {
	                removeFromArray(temporaryStyles, value);
	              }
	            }
	          } else if (animationPaused && playAnimation) {
	            animationPaused = false;
	            close();
	          }
	        };
	
	        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
	        // being inherited from the parent. If the transition duration is zero then we can safely
	        // rely that the delay value is an intentional stagger delay style.
	        var maxStagger = itemIndex > 0
	                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
	                            (timings.animationDuration && stagger.animationDuration === 0))
	                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
	        if (maxStagger) {
	          $timeout(triggerAnimationStart,
	                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
	                   false);
	        } else {
	          triggerAnimationStart();
	        }
	
	        // this will decorate the existing promise runner with pause/resume methods
	        runnerHost.resume = function() {
	          playPause(true);
	        };
	
	        runnerHost.pause = function() {
	          playPause(false);
	        };
	
	        function triggerAnimationStart() {
	          // just incase a stagger animation kicks in when the animation
	          // itself was cancelled entirely
	          if (animationClosed) return;
	
	          applyBlocking(false);
	
	          forEach(temporaryStyles, function(entry) {
	            var key = entry[0];
	            var value = entry[1];
	            node.style[key] = value;
	          });
	
	          applyAnimationClasses(element, options);
	          $$jqLite.addClass(element, activeClasses);
	
	          if (flags.recalculateTimingStyles) {
	            fullClassName = node.className + ' ' + preparationClasses;
	            cacheKey = gcsHashFn(node, fullClassName);
	
	            timings = computeTimings(node, fullClassName, cacheKey);
	            relativeDelay = timings.maxDelay;
	            maxDelay = Math.max(relativeDelay, 0);
	            maxDuration = timings.maxDuration;
	
	            if (maxDuration === 0) {
	              close();
	              return;
	            }
	
	            flags.hasTransitions = timings.transitionDuration > 0;
	            flags.hasAnimations = timings.animationDuration > 0;
	          }
	
	          if (flags.applyAnimationDelay) {
	            relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay)
	                  ? parseFloat(options.delay)
	                  : relativeDelay;
	
	            maxDelay = Math.max(relativeDelay, 0);
	            timings.animationDelay = relativeDelay;
	            delayStyle = getCssDelayStyle(relativeDelay, true);
	            temporaryStyles.push(delayStyle);
	            node.style[delayStyle[0]] = delayStyle[1];
	          }
	
	          maxDelayTime = maxDelay * ONE_SECOND;
	          maxDurationTime = maxDuration * ONE_SECOND;
	
	          if (options.easing) {
	            var easeProp, easeVal = options.easing;
	            if (flags.hasTransitions) {
	              easeProp = TRANSITION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	            if (flags.hasAnimations) {
	              easeProp = ANIMATION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	          }
	
	          if (timings.transitionDuration) {
	            events.push(TRANSITIONEND_EVENT);
	          }
	
	          if (timings.animationDuration) {
	            events.push(ANIMATIONEND_EVENT);
	          }
	
	          startTime = Date.now();
	          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
	          var endTime = startTime + timerTime;
	
	          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
	          var setupFallbackTimer = true;
	          if (animationsData.length) {
	            var currentTimerData = animationsData[0];
	            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
	            if (setupFallbackTimer) {
	              $timeout.cancel(currentTimerData.timer);
	            } else {
	              animationsData.push(close);
	            }
	          }
	
	          if (setupFallbackTimer) {
	            var timer = $timeout(onAnimationExpired, timerTime, false);
	            animationsData[0] = {
	              timer: timer,
	              expectedEndTime: endTime
	            };
	            animationsData.push(close);
	            element.data(ANIMATE_TIMER_KEY, animationsData);
	          }
	
	          if (events.length) {
	            element.on(events.join(' '), onAnimationProgress);
	          }
	
	          if (options.to) {
	            if (options.cleanupStyles) {
	              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
	            }
	            applyAnimationToStyles(element, options);
	          }
	        }
	
	        function onAnimationExpired() {
	          var animationsData = element.data(ANIMATE_TIMER_KEY);
	
	          // this will be false in the event that the element was
	          // removed from the DOM (via a leave animation or something
	          // similar)
	          if (animationsData) {
	            for (var i = 1; i < animationsData.length; i++) {
	              animationsData[i]();
	            }
	            element.removeData(ANIMATE_TIMER_KEY);
	          }
	        }
	      }
	    };
	  }];
	}];
	
	var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateCssDriver');
	
	  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
	  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';
	
	  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
	  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';
	
	  function isDocumentFragment(node) {
	    return node.parentNode && node.parentNode.nodeType === 11;
	  }
	
	  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
	       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {
	
	    // only browsers that support these properties can render animations
	    if (!$sniffer.animations && !$sniffer.transitions) return noop;
	
	    var bodyNode = $document[0].body;
	    var rootNode = getDomNode($rootElement);
	
	    var rootBodyElement = jqLite(
	      // this is to avoid using something that exists outside of the body
	      // we also special case the doc fragment case because our unit test code
	      // appends the $rootElement to the body after the app has been bootstrapped
	      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
	    );
	
	    return function initDriverFn(animationDetails) {
	      return animationDetails.from && animationDetails.to
	          ? prepareFromToAnchorAnimation(animationDetails.from,
	                                         animationDetails.to,
	                                         animationDetails.classes,
	                                         animationDetails.anchors)
	          : prepareRegularAnimation(animationDetails);
	    };
	
	    function filterCssClasses(classes) {
	      //remove all the `ng-` stuff
	      return classes.replace(/\bng-\S+\b/g, '');
	    }
	
	    function getUniqueValues(a, b) {
	      if (isString(a)) a = a.split(' ');
	      if (isString(b)) b = b.split(' ');
	      return a.filter(function(val) {
	        return b.indexOf(val) === -1;
	      }).join(' ');
	    }
	
	    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
	      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
	      var startingClasses = filterCssClasses(getClassVal(clone));
	
	      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	
	      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);
	
	      rootBodyElement.append(clone);
	
	      var animatorIn, animatorOut = prepareOutAnimation();
	
	      // the user may not end up using the `out` animation and
	      // only making use of the `in` animation or vice-versa.
	      // In either case we should allow this and not assume the
	      // animation is over unless both animations are not used.
	      if (!animatorOut) {
	        animatorIn = prepareInAnimation();
	        if (!animatorIn) {
	          return end();
	        }
	      }
	
	      var startingAnimator = animatorOut || animatorIn;
	
	      return {
	        start: function() {
	          var runner;
	
	          var currentAnimation = startingAnimator.start();
	          currentAnimation.done(function() {
	            currentAnimation = null;
	            if (!animatorIn) {
	              animatorIn = prepareInAnimation();
	              if (animatorIn) {
	                currentAnimation = animatorIn.start();
	                currentAnimation.done(function() {
	                  currentAnimation = null;
	                  end();
	                  runner.complete();
	                });
	                return currentAnimation;
	              }
	            }
	            // in the event that there is no `in` animation
	            end();
	            runner.complete();
	          });
	
	          runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn
	          });
	
	          return runner;
	
	          function endFn() {
	            if (currentAnimation) {
	              currentAnimation.end();
	            }
	          }
	        }
	      };
	
	      function calculateAnchorStyles(anchor) {
	        var styles = {};
	
	        var coords = getDomNode(anchor).getBoundingClientRect();
	
	        // we iterate directly since safari messes up and doesn't return
	        // all the keys for the coords object when iterated
	        forEach(['width','height','top','left'], function(key) {
	          var value = coords[key];
	          switch (key) {
	            case 'top':
	              value += bodyNode.scrollTop;
	              break;
	            case 'left':
	              value += bodyNode.scrollLeft;
	              break;
	          }
	          styles[key] = Math.floor(value) + 'px';
	        });
	        return styles;
	      }
	
	      function prepareOutAnimation() {
	        var animator = $animateCss(clone, {
	          addClass: NG_OUT_ANCHOR_CLASS_NAME,
	          delay: true,
	          from: calculateAnchorStyles(outAnchor)
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function getClassVal(element) {
	        return element.attr('class') || '';
	      }
	
	      function prepareInAnimation() {
	        var endingClasses = filterCssClasses(getClassVal(inAnchor));
	        var toAdd = getUniqueValues(endingClasses, startingClasses);
	        var toRemove = getUniqueValues(startingClasses, endingClasses);
	
	        var animator = $animateCss(clone, {
	          to: calculateAnchorStyles(inAnchor),
	          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
	          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
	          delay: true
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function end() {
	        clone.remove();
	        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      }
	    }
	
	    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
	      var fromAnimation = prepareRegularAnimation(from, noop);
	      var toAnimation = prepareRegularAnimation(to, noop);
	
	      var anchorAnimations = [];
	      forEach(anchors, function(anchor) {
	        var outElement = anchor['out'];
	        var inElement = anchor['in'];
	        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
	        if (animator) {
	          anchorAnimations.push(animator);
	        }
	      });
	
	      // no point in doing anything when there are no elements to animate
	      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;
	
	      return {
	        start: function() {
	          var animationRunners = [];
	
	          if (fromAnimation) {
	            animationRunners.push(fromAnimation.start());
	          }
	
	          if (toAnimation) {
	            animationRunners.push(toAnimation.start());
	          }
	
	          forEach(anchorAnimations, function(animation) {
	            animationRunners.push(animation.start());
	          });
	
	          var runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
	          });
	
	          $$AnimateRunner.all(animationRunners, function(status) {
	            runner.complete(status);
	          });
	
	          return runner;
	
	          function endFn() {
	            forEach(animationRunners, function(runner) {
	              runner.end();
	            });
	          }
	        }
	      };
	    }
	
	    function prepareRegularAnimation(animationDetails) {
	      var element = animationDetails.element;
	      var options = animationDetails.options || {};
	
	      if (animationDetails.structural) {
	        options.event = animationDetails.event;
	        options.structural = true;
	        options.applyClassesEarly = true;
	
	        // we special case the leave animation since we want to ensure that
	        // the element is removed as soon as the animation is over. Otherwise
	        // a flicker might appear or the element may not be removed at all
	        if (animationDetails.event === 'leave') {
	          options.onDone = options.domOperation;
	        }
	      }
	
	      // We assign the preparationClasses as the actual animation event since
	      // the internals of $animateCss will just suffix the event token values
	      // with `-active` to trigger the animation.
	      if (options.preparationClasses) {
	        options.event = concatWithSpace(options.event, options.preparationClasses);
	      }
	
	      var animator = $animateCss(element, options);
	
	      // the driver lookup code inside of $$animation attempts to spawn a
	      // driver one by one until a driver returns a.$$willAnimate animator object.
	      // $animateCss will always return an object, however, it will pass in
	      // a flag as a hint as to whether an animation was detected or not
	      return animator.$$willAnimate ? animator : null;
	    }
	  }];
	}];
	
	// TODO(matsko): use caching here to speed things up for detection
	// TODO(matsko): add documentation
	//  by the time...
	
	var $$AnimateJsProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
	       function($injector,   $$AnimateRunner,   $$jqLite) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	         // $animateJs(element, 'enter');
	    return function(element, event, classes, options) {
	      var animationClosed = false;
	
	      // the `classes` argument is optional and if it is not used
	      // then the classes will be resolved from the element's className
	      // property as well as options.addClass/options.removeClass.
	      if (arguments.length === 3 && isObject(classes)) {
	        options = classes;
	        classes = null;
	      }
	
	      options = prepareAnimationOptions(options);
	      if (!classes) {
	        classes = element.attr('class') || '';
	        if (options.addClass) {
	          classes += ' ' + options.addClass;
	        }
	        if (options.removeClass) {
	          classes += ' ' + options.removeClass;
	        }
	      }
	
	      var classesToAdd = options.addClass;
	      var classesToRemove = options.removeClass;
	
	      // the lookupAnimations function returns a series of animation objects that are
	      // matched up with one or more of the CSS classes. These animation objects are
	      // defined via the module.animation factory function. If nothing is detected then
	      // we don't return anything which then makes $animation query the next driver.
	      var animations = lookupAnimations(classes);
	      var before, after;
	      if (animations.length) {
	        var afterFn, beforeFn;
	        if (event === 'leave') {
	          beforeFn = 'leave';
	          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
	        } else {
	          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
	          afterFn = event;
	        }
	
	        if (event !== 'enter' && event !== 'move') {
	          before = packageAnimations(element, event, options, animations, beforeFn);
	        }
	        after  = packageAnimations(element, event, options, animations, afterFn);
	      }
	
	      // no matching animations
	      if (!before && !after) return;
	
	      function applyOptions() {
	        options.domOperation();
	        applyAnimationClasses(element, options);
	      }
	
	      function close() {
	        animationClosed = true;
	        applyOptions();
	        applyAnimationStyles(element, options);
	      }
	
	      var runner;
	
	      return {
	        $$willAnimate: true,
	        end: function() {
	          if (runner) {
	            runner.end();
	          } else {
	            close();
	            runner = new $$AnimateRunner();
	            runner.complete(true);
	          }
	          return runner;
	        },
	        start: function() {
	          if (runner) {
	            return runner;
	          }
	
	          runner = new $$AnimateRunner();
	          var closeActiveAnimations;
	          var chain = [];
	
	          if (before) {
	            chain.push(function(fn) {
	              closeActiveAnimations = before(fn);
	            });
	          }
	
	          if (chain.length) {
	            chain.push(function(fn) {
	              applyOptions();
	              fn(true);
	            });
	          } else {
	            applyOptions();
	          }
	
	          if (after) {
	            chain.push(function(fn) {
	              closeActiveAnimations = after(fn);
	            });
	          }
	
	          runner.setHost({
	            end: function() {
	              endAnimations();
	            },
	            cancel: function() {
	              endAnimations(true);
	            }
	          });
	
	          $$AnimateRunner.chain(chain, onComplete);
	          return runner;
	
	          function onComplete(success) {
	            close(success);
	            runner.complete(success);
	          }
	
	          function endAnimations(cancelled) {
	            if (!animationClosed) {
	              (closeActiveAnimations || noop)(cancelled);
	              onComplete(cancelled);
	            }
	          }
	        }
	      };
	
	      function executeAnimationFn(fn, element, event, options, onDone) {
	        var args;
	        switch (event) {
	          case 'animate':
	            args = [element, options.from, options.to, onDone];
	            break;
	
	          case 'setClass':
	            args = [element, classesToAdd, classesToRemove, onDone];
	            break;
	
	          case 'addClass':
	            args = [element, classesToAdd, onDone];
	            break;
	
	          case 'removeClass':
	            args = [element, classesToRemove, onDone];
	            break;
	
	          default:
	            args = [element, onDone];
	            break;
	        }
	
	        args.push(options);
	
	        var value = fn.apply(fn, args);
	        if (value) {
	          if (isFunction(value.start)) {
	            value = value.start();
	          }
	
	          if (value instanceof $$AnimateRunner) {
	            value.done(onDone);
	          } else if (isFunction(value)) {
	            // optional onEnd / onCancel callback
	            return value;
	          }
	        }
	
	        return noop;
	      }
	
	      function groupEventedAnimations(element, event, options, animations, fnName) {
	        var operations = [];
	        forEach(animations, function(ani) {
	          var animation = ani[fnName];
	          if (!animation) return;
	
	          // note that all of these animations will run in parallel
	          operations.push(function() {
	            var runner;
	            var endProgressCb;
	
	            var resolved = false;
	            var onAnimationComplete = function(rejected) {
	              if (!resolved) {
	                resolved = true;
	                (endProgressCb || noop)(rejected);
	                runner.complete(!rejected);
	              }
	            };
	
	            runner = new $$AnimateRunner({
	              end: function() {
	                onAnimationComplete();
	              },
	              cancel: function() {
	                onAnimationComplete(true);
	              }
	            });
	
	            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
	              var cancelled = result === false;
	              onAnimationComplete(cancelled);
	            });
	
	            return runner;
	          });
	        });
	
	        return operations;
	      }
	
	      function packageAnimations(element, event, options, animations, fnName) {
	        var operations = groupEventedAnimations(element, event, options, animations, fnName);
	        if (operations.length === 0) {
	          var a, b;
	          if (fnName === 'beforeSetClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
	          } else if (fnName === 'setClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
	          }
	
	          if (a) {
	            operations = operations.concat(a);
	          }
	          if (b) {
	            operations = operations.concat(b);
	          }
	        }
	
	        if (operations.length === 0) return;
	
	        // TODO(matsko): add documentation
	        return function startAnimation(callback) {
	          var runners = [];
	          if (operations.length) {
	            forEach(operations, function(animateFn) {
	              runners.push(animateFn());
	            });
	          }
	
	          if (runners.length) {
	            $$AnimateRunner.all(runners, callback);
	          }  else {
	            callback();
	          }
	
	          return function endFn(reject) {
	            forEach(runners, function(runner) {
	              if (reject) {
	                runner.cancel();
	              } else {
	                runner.end();
	              }
	            });
	          };
	        };
	      }
	    };
	
	    function lookupAnimations(classes) {
	      classes = isArray(classes) ? classes : classes.split(' ');
	      var matches = [], flagMap = {};
	      for (var i = 0; i < classes.length; i++) {
	        var klass = classes[i],
	            animationFactory = $animateProvider.$$registeredAnimations[klass];
	        if (animationFactory && !flagMap[klass]) {
	          matches.push($injector.get(animationFactory));
	          flagMap[klass] = true;
	        }
	      }
	      return matches;
	    }
	  }];
	}];
	
	var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateJsDriver');
	  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
	    return function initDriverFn(animationDetails) {
	      if (animationDetails.from && animationDetails.to) {
	        var fromAnimation = prepareAnimation(animationDetails.from);
	        var toAnimation = prepareAnimation(animationDetails.to);
	        if (!fromAnimation && !toAnimation) return;
	
	        return {
	          start: function() {
	            var animationRunners = [];
	
	            if (fromAnimation) {
	              animationRunners.push(fromAnimation.start());
	            }
	
	            if (toAnimation) {
	              animationRunners.push(toAnimation.start());
	            }
	
	            $$AnimateRunner.all(animationRunners, done);
	
	            var runner = new $$AnimateRunner({
	              end: endFnFactory(),
	              cancel: endFnFactory()
	            });
	
	            return runner;
	
	            function endFnFactory() {
	              return function() {
	                forEach(animationRunners, function(runner) {
	                  // at this point we cannot cancel animations for groups just yet. 1.5+
	                  runner.end();
	                });
	              };
	            }
	
	            function done(status) {
	              runner.complete(status);
	            }
	          }
	        };
	      } else {
	        return prepareAnimation(animationDetails);
	      }
	    };
	
	    function prepareAnimation(animationDetails) {
	      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
	      var element = animationDetails.element;
	      var event = animationDetails.event;
	      var options = animationDetails.options;
	      var classes = animationDetails.classes;
	      return $$animateJs(element, event, classes, options);
	    }
	  }];
	}];
	
	var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
	var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
	var $$AnimateQueueProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var PRE_DIGEST_STATE = 1;
	  var RUNNING_STATE = 2;
	  var ONE_SPACE = ' ';
	
	  var rules = this.rules = {
	    skip: [],
	    cancel: [],
	    join: []
	  };
	
	  function makeTruthyCssClassMap(classString) {
	    if (!classString) {
	      return null;
	    }
	
	    var keys = classString.split(ONE_SPACE);
	    var map = Object.create(null);
	
	    forEach(keys, function(key) {
	      map[key] = true;
	    });
	    return map;
	  }
	
	  function hasMatchingClasses(newClassString, currentClassString) {
	    if (newClassString && currentClassString) {
	      var currentClassMap = makeTruthyCssClassMap(currentClassString);
	      return newClassString.split(ONE_SPACE).some(function(className) {
	        return currentClassMap[className];
	      });
	    }
	  }
	
	  function isAllowed(ruleType, element, currentAnimation, previousAnimation) {
	    return rules[ruleType].some(function(fn) {
	      return fn(element, currentAnimation, previousAnimation);
	    });
	  }
	
	  function hasAnimationClasses(animation, and) {
	    var a = (animation.addClass || '').length > 0;
	    var b = (animation.removeClass || '').length > 0;
	    return and ? a && b : a || b;
	  }
	
	  rules.join.push(function(element, newAnimation, currentAnimation) {
	    // if the new animation is class-based then we can just tack that on
	    return !newAnimation.structural && hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(element, newAnimation, currentAnimation) {
	    // there is no need to animate anything if no classes are being added and
	    // there is no structural animation that will be triggered
	    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(element, newAnimation, currentAnimation) {
	    // why should we trigger a new structural animation if the element will
	    // be removed from the DOM anyway?
	    return currentAnimation.event === 'leave' && newAnimation.structural;
	  });
	
	  rules.skip.push(function(element, newAnimation, currentAnimation) {
	    // if there is an ongoing current animation then don't even bother running the class-based animation
	    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
	  });
	
	  rules.cancel.push(function(element, newAnimation, currentAnimation) {
	    // there can never be two structural animations running at the same time
	    return currentAnimation.structural && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(element, newAnimation, currentAnimation) {
	    // if the previous animation is already running, but the new animation will
	    // be triggered, but the new animation is structural
	    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(element, newAnimation, currentAnimation) {
	    // cancel the animation if classes added / removed in both animation cancel each other out,
	    // but only if the current animation isn't structural
	
	    if (currentAnimation.structural) return false;
	
	    var nA = newAnimation.addClass;
	    var nR = newAnimation.removeClass;
	    var cA = currentAnimation.addClass;
	    var cR = currentAnimation.removeClass;
	
	    // early detection to save the global CPU shortage :)
	    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
	      return false;
	    }
	
	    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
	  });
	
	  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$HashMap',
	               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
	       function($$rAF,   $rootScope,   $rootElement,   $document,   $$HashMap,
	                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow) {
	
	    var activeAnimationsLookup = new $$HashMap();
	    var disabledElementsLookup = new $$HashMap();
	    var animationsEnabled = null;
	
	    function postDigestTaskFactory() {
	      var postDigestCalled = false;
	      return function(fn) {
	        // we only issue a call to postDigest before
	        // it has first passed. This prevents any callbacks
	        // from not firing once the animation has completed
	        // since it will be out of the digest cycle.
	        if (postDigestCalled) {
	          fn();
	        } else {
	          $rootScope.$$postDigest(function() {
	            postDigestCalled = true;
	            fn();
	          });
	        }
	      };
	    }
	
	    // Wait until all directive and route-related templates are downloaded and
	    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
	    // all of the remote templates being currently downloaded. If there are no
	    // templates currently downloading then the watcher will still fire anyway.
	    var deregisterWatch = $rootScope.$watch(
	      function() { return $templateRequest.totalPendingRequests === 0; },
	      function(isEmpty) {
	        if (!isEmpty) return;
	        deregisterWatch();
	
	        // Now that all templates have been downloaded, $animate will wait until
	        // the post digest queue is empty before enabling animations. By having two
	        // calls to $postDigest calls we can ensure that the flag is enabled at the
	        // very end of the post digest queue. Since all of the animations in $animate
	        // use $postDigest, it's important that the code below executes at the end.
	        // This basically means that the page is fully downloaded and compiled before
	        // any animations are triggered.
	        $rootScope.$$postDigest(function() {
	          $rootScope.$$postDigest(function() {
	            // we check for null directly in the event that the application already called
	            // .enabled() with whatever arguments that it provided it with
	            if (animationsEnabled === null) {
	              animationsEnabled = true;
	            }
	          });
	        });
	      }
	    );
	
	    var callbackRegistry = Object.create(null);
	
	    // remember that the classNameFilter is set during the provider/config
	    // stage therefore we can optimize here and setup a helper function
	    var classNameFilter = $animateProvider.classNameFilter();
	    var isAnimatableClassName = !classNameFilter
	              ? function() { return true; }
	              : function(className) {
	                return classNameFilter.test(className);
	              };
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function normalizeAnimationDetails(element, animation) {
	      return mergeAnimationDetails(element, animation, {});
	    }
	
	    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	    var contains = window.Node.prototype.contains || /** @this */ function(arg) {
	      // eslint-disable-next-line no-bitwise
	      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
	    };
	
	    function findCallbacks(parent, element, event) {
	      var targetNode = getDomNode(element);
	      var targetParentNode = getDomNode(parent);
	
	      var matches = [];
	      var entries = callbackRegistry[event];
	      if (entries) {
	        forEach(entries, function(entry) {
	          if (contains.call(entry.node, targetNode)) {
	            matches.push(entry.callback);
	          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
	            matches.push(entry.callback);
	          }
	        });
	      }
	
	      return matches;
	    }
	
	    function filterFromRegistry(list, matchContainer, matchCallback) {
	      var containerNode = extractElementNode(matchContainer);
	      return list.filter(function(entry) {
	        var isMatch = entry.node === containerNode &&
	                        (!matchCallback || entry.callback === matchCallback);
	        return !isMatch;
	      });
	    }
	
	    function cleanupEventListeners(phase, element) {
	      if (phase === 'close' && !element[0].parentNode) {
	        // If the element is not attached to a parentNode, it has been removed by
	        // the domOperation, and we can safely remove the event callbacks
	        $animate.off(element);
	      }
	    }
	
	    var $animate = {
	      on: function(event, container, callback) {
	        var node = extractElementNode(container);
	        callbackRegistry[event] = callbackRegistry[event] || [];
	        callbackRegistry[event].push({
	          node: node,
	          callback: callback
	        });
	
	        // Remove the callback when the element is removed from the DOM
	        jqLite(container).on('$destroy', function() {
	          var animationDetails = activeAnimationsLookup.get(node);
	
	          if (!animationDetails) {
	            // If there's an animation ongoing, the callback calling code will remove
	            // the event listeners. If we'd remove here, the callbacks would be removed
	            // before the animation ends
	            $animate.off(event, container, callback);
	          }
	        });
	      },
	
	      off: function(event, container, callback) {
	        if (arguments.length === 1 && !isString(arguments[0])) {
	          container = arguments[0];
	          for (var eventType in callbackRegistry) {
	            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
	          }
	
	          return;
	        }
	
	        var entries = callbackRegistry[event];
	        if (!entries) return;
	
	        callbackRegistry[event] = arguments.length === 1
	            ? null
	            : filterFromRegistry(entries, container, callback);
	      },
	
	      pin: function(element, parentElement) {
	        assertArg(isElement(element), 'element', 'not an element');
	        assertArg(isElement(parentElement), 'parentElement', 'not an element');
	        element.data(NG_ANIMATE_PIN_DATA, parentElement);
	      },
	
	      push: function(element, event, options, domOperation) {
	        options = options || {};
	        options.domOperation = domOperation;
	        return queueAnimation(element, event, options);
	      },
	
	      // this method has four signatures:
	      //  () - global getter
	      //  (bool) - global setter
	      //  (element) - element getter
	      //  (element, bool) - element setter<F37>
	      enabled: function(element, bool) {
	        var argCount = arguments.length;
	
	        if (argCount === 0) {
	          // () - Global getter
	          bool = !!animationsEnabled;
	        } else {
	          var hasElement = isElement(element);
	
	          if (!hasElement) {
	            // (bool) - Global setter
	            bool = animationsEnabled = !!element;
	          } else {
	            var node = getDomNode(element);
	
	            if (argCount === 1) {
	              // (element) - Element getter
	              bool = !disabledElementsLookup.get(node);
	            } else {
	              // (element, bool) - Element setter
	              disabledElementsLookup.put(node, !bool);
	            }
	          }
	        }
	
	        return bool;
	      }
	    };
	
	    return $animate;
	
	    function queueAnimation(element, event, initialOptions) {
	      // we always make a copy of the options since
	      // there should never be any side effects on
	      // the input data when running `$animateCss`.
	      var options = copy(initialOptions);
	
	      var node, parent;
	      element = stripCommentsFromElement(element);
	      if (element) {
	        node = getDomNode(element);
	        parent = element.parent();
	      }
	
	      options = prepareAnimationOptions(options);
	
	      // we create a fake runner with a working promise.
	      // These methods will become available after the digest has passed
	      var runner = new $$AnimateRunner();
	
	      // this is used to trigger callbacks in postDigest mode
	      var runInNextPostDigestOrNow = postDigestTaskFactory();
	
	      if (isArray(options.addClass)) {
	        options.addClass = options.addClass.join(' ');
	      }
	
	      if (options.addClass && !isString(options.addClass)) {
	        options.addClass = null;
	      }
	
	      if (isArray(options.removeClass)) {
	        options.removeClass = options.removeClass.join(' ');
	      }
	
	      if (options.removeClass && !isString(options.removeClass)) {
	        options.removeClass = null;
	      }
	
	      if (options.from && !isObject(options.from)) {
	        options.from = null;
	      }
	
	      if (options.to && !isObject(options.to)) {
	        options.to = null;
	      }
	
	      // there are situations where a directive issues an animation for
	      // a jqLite wrapper that contains only comment nodes... If this
	      // happens then there is no way we can perform an animation
	      if (!node) {
	        close();
	        return runner;
	      }
	
	      var className = [node.className, options.addClass, options.removeClass].join(' ');
	      if (!isAnimatableClassName(className)) {
	        close();
	        return runner;
	      }
	
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      var documentHidden = $document[0].hidden;
	
	      // this is a hard disable of all animations for the application or on
	      // the element itself, therefore  there is no need to continue further
	      // past this point if not enabled
	      // Animations are also disabled if the document is currently hidden (page is not visible
	      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
	      var skipAnimations = !animationsEnabled || documentHidden || disabledElementsLookup.get(node);
	      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
	      var hasExistingAnimation = !!existingAnimation.state;
	
	      // there is no point in traversing the same collection of parent ancestors if a followup
	      // animation will be run on the same element that already did all that checking work
	      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
	        skipAnimations = !areAnimationsAllowed(element, parent, event);
	      }
	
	      if (skipAnimations) {
	        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
	        if (documentHidden) notifyProgress(runner, event, 'start');
	        close();
	        if (documentHidden) notifyProgress(runner, event, 'close');
	        return runner;
	      }
	
	      if (isStructural) {
	        closeChildAnimations(element);
	      }
	
	      var newAnimation = {
	        structural: isStructural,
	        element: element,
	        event: event,
	        addClass: options.addClass,
	        removeClass: options.removeClass,
	        close: close,
	        options: options,
	        runner: runner
	      };
	
	      if (hasExistingAnimation) {
	        var skipAnimationFlag = isAllowed('skip', element, newAnimation, existingAnimation);
	        if (skipAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            close();
	            return runner;
	          } else {
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	            return existingAnimation.runner;
	          }
	        }
	        var cancelAnimationFlag = isAllowed('cancel', element, newAnimation, existingAnimation);
	        if (cancelAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            // this will end the animation right away and it is safe
	            // to do so since the animation is already running and the
	            // runner callback code will run in async
	            existingAnimation.runner.end();
	          } else if (existingAnimation.structural) {
	            // this means that the animation is queued into a digest, but
	            // hasn't started yet. Therefore it is safe to run the close
	            // method which will call the runner methods in async.
	            existingAnimation.close();
	          } else {
	            // this will merge the new animation options into existing animation options
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	            return existingAnimation.runner;
	          }
	        } else {
	          // a joined animation means that this animation will take over the existing one
	          // so an example would involve a leave animation taking over an enter. Then when
	          // the postDigest kicks in the enter will be ignored.
	          var joinAnimationFlag = isAllowed('join', element, newAnimation, existingAnimation);
	          if (joinAnimationFlag) {
	            if (existingAnimation.state === RUNNING_STATE) {
	              normalizeAnimationDetails(element, newAnimation);
	            } else {
	              applyGeneratedPreparationClasses(element, isStructural ? event : null, options);
	
	              event = newAnimation.event = existingAnimation.event;
	              options = mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	              //we return the same runner since only the option values of this animation will
	              //be fed into the `existingAnimation`.
	              return existingAnimation.runner;
	            }
	          }
	        }
	      } else {
	        // normalization in this case means that it removes redundant CSS classes that
	        // already exist (addClass) or do not exist (removeClass) on the element
	        normalizeAnimationDetails(element, newAnimation);
	      }
	
	      // when the options are merged and cleaned up we may end up not having to do
	      // an animation at all, therefore we should check this before issuing a post
	      // digest callback. Structural animations will always run no matter what.
	      var isValidAnimation = newAnimation.structural;
	      if (!isValidAnimation) {
	        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
	        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
	                            || hasAnimationClasses(newAnimation);
	      }
	
	      if (!isValidAnimation) {
	        close();
	        clearElementAnimationState(element);
	        return runner;
	      }
	
	      // the counter keeps track of cancelled animations
	      var counter = (existingAnimation.counter || 0) + 1;
	      newAnimation.counter = counter;
	
	      markElementAnimationState(element, PRE_DIGEST_STATE, newAnimation);
	
	      $rootScope.$$postDigest(function() {
	        var animationDetails = activeAnimationsLookup.get(node);
	        var animationCancelled = !animationDetails;
	        animationDetails = animationDetails || {};
	
	        // if addClass/removeClass is called before something like enter then the
	        // registered parent element may not be present. The code below will ensure
	        // that a final value for parent element is obtained
	        var parentElement = element.parent() || [];
	
	        // animate/structural/class-based animations all have requirements. Otherwise there
	        // is no point in performing an animation. The parent node must also be set.
	        var isValidAnimation = parentElement.length > 0
	                                && (animationDetails.event === 'animate'
	                                    || animationDetails.structural
	                                    || hasAnimationClasses(animationDetails));
	
	        // this means that the previous animation was cancelled
	        // even if the follow-up animation is the same event
	        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
	          // if another animation did not take over then we need
	          // to make sure that the domOperation and options are
	          // handled accordingly
	          if (animationCancelled) {
	            applyAnimationClasses(element, options);
	            applyAnimationStyles(element, options);
	          }
	
	          // if the event changed from something like enter to leave then we do
	          // it, otherwise if it's the same then the end result will be the same too
	          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
	            options.domOperation();
	            runner.end();
	          }
	
	          // in the event that the element animation was not cancelled or a follow-up animation
	          // isn't allowed to animate from here then we need to clear the state of the element
	          // so that any future animations won't read the expired animation data.
	          if (!isValidAnimation) {
	            clearElementAnimationState(element);
	          }
	
	          return;
	        }
	
	        // this combined multiple class to addClass / removeClass into a setClass event
	        // so long as a structural event did not take over the animation
	        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
	            ? 'setClass'
	            : animationDetails.event;
	
	        markElementAnimationState(element, RUNNING_STATE);
	        var realRunner = $$animation(element, event, animationDetails.options);
	
	        // this will update the runner's flow-control events based on
	        // the `realRunner` object.
	        runner.setHost(realRunner);
	        notifyProgress(runner, event, 'start', {});
	
	        realRunner.done(function(status) {
	          close(!status);
	          var animationDetails = activeAnimationsLookup.get(node);
	          if (animationDetails && animationDetails.counter === counter) {
	            clearElementAnimationState(getDomNode(element));
	          }
	          notifyProgress(runner, event, 'close', {});
	        });
	      });
	
	      return runner;
	
	      function notifyProgress(runner, event, phase, data) {
	        runInNextPostDigestOrNow(function() {
	          var callbacks = findCallbacks(parent, element, event);
	          if (callbacks.length) {
	            // do not optimize this call here to RAF because
	            // we don't know how heavy the callback code here will
	            // be and if this code is buffered then this can
	            // lead to a performance regression.
	            $$rAF(function() {
	              forEach(callbacks, function(callback) {
	                callback(element, phase, data);
	              });
	              cleanupEventListeners(phase, element);
	            });
	          } else {
	            cleanupEventListeners(phase, element);
	          }
	        });
	        runner.progress(event, phase, data);
	      }
	
	      function close(reject) {
	        clearGeneratedClasses(element, options);
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	        runner.complete(!reject);
	      }
	    }
	
	    function closeChildAnimations(element) {
	      var node = getDomNode(element);
	      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
	      forEach(children, function(child) {
	        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
	        var animationDetails = activeAnimationsLookup.get(child);
	        if (animationDetails) {
	          switch (state) {
	            case RUNNING_STATE:
	              animationDetails.runner.end();
	              /* falls through */
	            case PRE_DIGEST_STATE:
	              activeAnimationsLookup.remove(child);
	              break;
	          }
	        }
	      });
	    }
	
	    function clearElementAnimationState(element) {
	      var node = getDomNode(element);
	      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
	      activeAnimationsLookup.remove(node);
	    }
	
	    function isMatchingElement(nodeOrElmA, nodeOrElmB) {
	      return getDomNode(nodeOrElmA) === getDomNode(nodeOrElmB);
	    }
	
	    /**
	     * This fn returns false if any of the following is true:
	     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
	     * b) a parent element has an ongoing structural animation, and animateChildren is false
	     * c) the element is not a child of the body
	     * d) the element is not a child of the $rootElement
	     */
	    function areAnimationsAllowed(element, parentElement, event) {
	      var bodyElement = jqLite($document[0].body);
	      var bodyElementDetected = isMatchingElement(element, bodyElement) || element[0].nodeName === 'HTML';
	      var rootElementDetected = isMatchingElement(element, $rootElement);
	      var parentAnimationDetected = false;
	      var animateChildren;
	      var elementDisabled = disabledElementsLookup.get(getDomNode(element));
	
	      var parentHost = jqLite.data(element[0], NG_ANIMATE_PIN_DATA);
	      if (parentHost) {
	        parentElement = parentHost;
	      }
	
	      parentElement = getDomNode(parentElement);
	
	      while (parentElement) {
	        if (!rootElementDetected) {
	          // angular doesn't want to attempt to animate elements outside of the application
	          // therefore we need to ensure that the rootElement is an ancestor of the current element
	          rootElementDetected = isMatchingElement(parentElement, $rootElement);
	        }
	
	        if (parentElement.nodeType !== ELEMENT_NODE) {
	          // no point in inspecting the #document element
	          break;
	        }
	
	        var details = activeAnimationsLookup.get(parentElement) || {};
	        // either an enter, leave or move animation will commence
	        // therefore we can't allow any animations to take place
	        // but if a parent animation is class-based then that's ok
	        if (!parentAnimationDetected) {
	          var parentElementDisabled = disabledElementsLookup.get(parentElement);
	
	          if (parentElementDisabled === true && elementDisabled !== false) {
	            // disable animations if the user hasn't explicitly enabled animations on the
	            // current element
	            elementDisabled = true;
	            // element is disabled via parent element, no need to check anything else
	            break;
	          } else if (parentElementDisabled === false) {
	            elementDisabled = false;
	          }
	          parentAnimationDetected = details.structural;
	        }
	
	        if (isUndefined(animateChildren) || animateChildren === true) {
	          var value = jqLite.data(parentElement, NG_ANIMATE_CHILDREN_DATA);
	          if (isDefined(value)) {
	            animateChildren = value;
	          }
	        }
	
	        // there is no need to continue traversing at this point
	        if (parentAnimationDetected && animateChildren === false) break;
	
	        if (!bodyElementDetected) {
	          // we also need to ensure that the element is or will be a part of the body element
	          // otherwise it is pointless to even issue an animation to be rendered
	          bodyElementDetected = isMatchingElement(parentElement, bodyElement);
	        }
	
	        if (bodyElementDetected && rootElementDetected) {
	          // If both body and root have been found, any other checks are pointless,
	          // as no animation data should live outside the application
	          break;
	        }
	
	        if (!rootElementDetected) {
	          // If no rootElement is detected, check if the parentElement is pinned to another element
	          parentHost = jqLite.data(parentElement, NG_ANIMATE_PIN_DATA);
	          if (parentHost) {
	            // The pin target element becomes the next parent element
	            parentElement = getDomNode(parentHost);
	            continue;
	          }
	        }
	
	        parentElement = parentElement.parentNode;
	      }
	
	      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
	      return allowAnimation && rootElementDetected && bodyElementDetected;
	    }
	
	    function markElementAnimationState(element, state, details) {
	      details = details || {};
	      details.state = state;
	
	      var node = getDomNode(element);
	      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);
	
	      var oldValue = activeAnimationsLookup.get(node);
	      var newValue = oldValue
	          ? extend(oldValue, details)
	          : details;
	      activeAnimationsLookup.put(node, newValue);
	    }
	  }];
	}];
	
	/* exported $$AnimationProvider */
	
	var $$AnimationProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';
	
	  var drivers = this.drivers = [];
	
	  var RUNNER_STORAGE_KEY = '$$animationRunner';
	
	  function setRunner(element, runner) {
	    element.data(RUNNER_STORAGE_KEY, runner);
	  }
	
	  function removeRunner(element) {
	    element.removeData(RUNNER_STORAGE_KEY);
	  }
	
	  function getRunner(element) {
	    return element.data(RUNNER_STORAGE_KEY);
	  }
	
	  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$HashMap', '$$rAFScheduler',
	       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$HashMap,   $$rAFScheduler) {
	
	    var animationQueue = [];
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function sortAnimations(animations) {
	      var tree = { children: [] };
	      var i, lookup = new $$HashMap();
	
	      // this is done first beforehand so that the hashmap
	      // is filled with a list of the elements that will be animated
	      for (i = 0; i < animations.length; i++) {
	        var animation = animations[i];
	        lookup.put(animation.domNode, animations[i] = {
	          domNode: animation.domNode,
	          fn: animation.fn,
	          children: []
	        });
	      }
	
	      for (i = 0; i < animations.length; i++) {
	        processNode(animations[i]);
	      }
	
	      return flatten(tree);
	
	      function processNode(entry) {
	        if (entry.processed) return entry;
	        entry.processed = true;
	
	        var elementNode = entry.domNode;
	        var parentNode = elementNode.parentNode;
	        lookup.put(elementNode, entry);
	
	        var parentEntry;
	        while (parentNode) {
	          parentEntry = lookup.get(parentNode);
	          if (parentEntry) {
	            if (!parentEntry.processed) {
	              parentEntry = processNode(parentEntry);
	            }
	            break;
	          }
	          parentNode = parentNode.parentNode;
	        }
	
	        (parentEntry || tree).children.push(entry);
	        return entry;
	      }
	
	      function flatten(tree) {
	        var result = [];
	        var queue = [];
	        var i;
	
	        for (i = 0; i < tree.children.length; i++) {
	          queue.push(tree.children[i]);
	        }
	
	        var remainingLevelEntries = queue.length;
	        var nextLevelEntries = 0;
	        var row = [];
	
	        for (i = 0; i < queue.length; i++) {
	          var entry = queue[i];
	          if (remainingLevelEntries <= 0) {
	            remainingLevelEntries = nextLevelEntries;
	            nextLevelEntries = 0;
	            result.push(row);
	            row = [];
	          }
	          row.push(entry.fn);
	          entry.children.forEach(function(childEntry) {
	            nextLevelEntries++;
	            queue.push(childEntry);
	          });
	          remainingLevelEntries--;
	        }
	
	        if (row.length) {
	          result.push(row);
	        }
	
	        return result;
	      }
	    }
	
	    // TODO(matsko): document the signature in a better way
	    return function(element, event, options) {
	      options = prepareAnimationOptions(options);
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      // there is no animation at the current moment, however
	      // these runner methods will get later updated with the
	      // methods leading into the driver's end/cancel methods
	      // for now they just stop the animation from starting
	      var runner = new $$AnimateRunner({
	        end: function() { close(); },
	        cancel: function() { close(true); }
	      });
	
	      if (!drivers.length) {
	        close();
	        return runner;
	      }
	
	      setRunner(element, runner);
	
	      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
	      var tempClasses = options.tempClasses;
	      if (tempClasses) {
	        classes += ' ' + tempClasses;
	        options.tempClasses = null;
	      }
	
	      var prepareClassName;
	      if (isStructural) {
	        prepareClassName = 'ng-' + event + PREPARE_CLASS_SUFFIX;
	        $$jqLite.addClass(element, prepareClassName);
	      }
	
	      animationQueue.push({
	        // this data is used by the postDigest code and passed into
	        // the driver step function
	        element: element,
	        classes: classes,
	        event: event,
	        structural: isStructural,
	        options: options,
	        beforeStart: beforeStart,
	        close: close
	      });
	
	      element.on('$destroy', handleDestroyedElement);
	
	      // we only want there to be one function called within the post digest
	      // block. This way we can group animations for all the animations that
	      // were apart of the same postDigest flush call.
	      if (animationQueue.length > 1) return runner;
	
	      $rootScope.$$postDigest(function() {
	        var animations = [];
	        forEach(animationQueue, function(entry) {
	          // the element was destroyed early on which removed the runner
	          // form its storage. This means we can't animate this element
	          // at all and it already has been closed due to destruction.
	          if (getRunner(entry.element)) {
	            animations.push(entry);
	          } else {
	            entry.close();
	          }
	        });
	
	        // now any future animations will be in another postDigest
	        animationQueue.length = 0;
	
	        var groupedAnimations = groupAnimations(animations);
	        var toBeSortedAnimations = [];
	
	        forEach(groupedAnimations, function(animationEntry) {
	          toBeSortedAnimations.push({
	            domNode: getDomNode(animationEntry.from ? animationEntry.from.element : animationEntry.element),
	            fn: function triggerAnimationStart() {
	              // it's important that we apply the `ng-animate` CSS class and the
	              // temporary classes before we do any driver invoking since these
	              // CSS classes may be required for proper CSS detection.
	              animationEntry.beforeStart();
	
	              var startAnimationFn, closeFn = animationEntry.close;
	
	              // in the event that the element was removed before the digest runs or
	              // during the RAF sequencing then we should not trigger the animation.
	              var targetElement = animationEntry.anchors
	                  ? (animationEntry.from.element || animationEntry.to.element)
	                  : animationEntry.element;
	
	              if (getRunner(targetElement)) {
	                var operation = invokeFirstDriver(animationEntry);
	                if (operation) {
	                  startAnimationFn = operation.start;
	                }
	              }
	
	              if (!startAnimationFn) {
	                closeFn();
	              } else {
	                var animationRunner = startAnimationFn();
	                animationRunner.done(function(status) {
	                  closeFn(!status);
	                });
	                updateAnimationRunners(animationEntry, animationRunner);
	              }
	            }
	          });
	        });
	
	        // we need to sort each of the animations in order of parent to child
	        // relationships. This ensures that the child classes are applied at the
	        // right time.
	        $$rAFScheduler(sortAnimations(toBeSortedAnimations));
	      });
	
	      return runner;
	
	      // TODO(matsko): change to reference nodes
	      function getAnchorNodes(node) {
	        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
	        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
	              ? [node]
	              : node.querySelectorAll(SELECTOR);
	        var anchors = [];
	        forEach(items, function(node) {
	          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
	          if (attr && attr.length) {
	            anchors.push(node);
	          }
	        });
	        return anchors;
	      }
	
	      function groupAnimations(animations) {
	        var preparedAnimations = [];
	        var refLookup = {};
	        forEach(animations, function(animation, index) {
	          var element = animation.element;
	          var node = getDomNode(element);
	          var event = animation.event;
	          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
	          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];
	
	          if (anchorNodes.length) {
	            var direction = enterOrMove ? 'to' : 'from';
	
	            forEach(anchorNodes, function(anchor) {
	              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
	              refLookup[key] = refLookup[key] || {};
	              refLookup[key][direction] = {
	                animationID: index,
	                element: jqLite(anchor)
	              };
	            });
	          } else {
	            preparedAnimations.push(animation);
	          }
	        });
	
	        var usedIndicesLookup = {};
	        var anchorGroups = {};
	        forEach(refLookup, function(operations, key) {
	          var from = operations.from;
	          var to = operations.to;
	
	          if (!from || !to) {
	            // only one of these is set therefore we can't have an
	            // anchor animation since all three pieces are required
	            var index = from ? from.animationID : to.animationID;
	            var indexKey = index.toString();
	            if (!usedIndicesLookup[indexKey]) {
	              usedIndicesLookup[indexKey] = true;
	              preparedAnimations.push(animations[index]);
	            }
	            return;
	          }
	
	          var fromAnimation = animations[from.animationID];
	          var toAnimation = animations[to.animationID];
	          var lookupKey = from.animationID.toString();
	          if (!anchorGroups[lookupKey]) {
	            var group = anchorGroups[lookupKey] = {
	              structural: true,
	              beforeStart: function() {
	                fromAnimation.beforeStart();
	                toAnimation.beforeStart();
	              },
	              close: function() {
	                fromAnimation.close();
	                toAnimation.close();
	              },
	              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
	              from: fromAnimation,
	              to: toAnimation,
	              anchors: [] // TODO(matsko): change to reference nodes
	            };
	
	            // the anchor animations require that the from and to elements both have at least
	            // one shared CSS class which effectively marries the two elements together to use
	            // the same animation driver and to properly sequence the anchor animation.
	            if (group.classes.length) {
	              preparedAnimations.push(group);
	            } else {
	              preparedAnimations.push(fromAnimation);
	              preparedAnimations.push(toAnimation);
	            }
	          }
	
	          anchorGroups[lookupKey].anchors.push({
	            'out': from.element, 'in': to.element
	          });
	        });
	
	        return preparedAnimations;
	      }
	
	      function cssClassesIntersection(a,b) {
	        a = a.split(' ');
	        b = b.split(' ');
	        var matches = [];
	
	        for (var i = 0; i < a.length; i++) {
	          var aa = a[i];
	          if (aa.substring(0,3) === 'ng-') continue;
	
	          for (var j = 0; j < b.length; j++) {
	            if (aa === b[j]) {
	              matches.push(aa);
	              break;
	            }
	          }
	        }
	
	        return matches.join(' ');
	      }
	
	      function invokeFirstDriver(animationDetails) {
	        // we loop in reverse order since the more general drivers (like CSS and JS)
	        // may attempt more elements, but custom drivers are more particular
	        for (var i = drivers.length - 1; i >= 0; i--) {
	          var driverName = drivers[i];
	          var factory = $injector.get(driverName);
	          var driver = factory(animationDetails);
	          if (driver) {
	            return driver;
	          }
	        }
	      }
	
	      function beforeStart() {
	        element.addClass(NG_ANIMATE_CLASSNAME);
	        if (tempClasses) {
	          $$jqLite.addClass(element, tempClasses);
	        }
	        if (prepareClassName) {
	          $$jqLite.removeClass(element, prepareClassName);
	          prepareClassName = null;
	        }
	      }
	
	      function updateAnimationRunners(animation, newRunner) {
	        if (animation.from && animation.to) {
	          update(animation.from.element);
	          update(animation.to.element);
	        } else {
	          update(animation.element);
	        }
	
	        function update(element) {
	          var runner = getRunner(element);
	          if (runner) runner.setHost(newRunner);
	        }
	      }
	
	      function handleDestroyedElement() {
	        var runner = getRunner(element);
	        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
	          runner.end();
	        }
	      }
	
	      function close(rejected) {
	        element.off('$destroy', handleDestroyedElement);
	        removeRunner(element);
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	
	        if (tempClasses) {
	          $$jqLite.removeClass(element, tempClasses);
	        }
	
	        element.removeClass(NG_ANIMATE_CLASSNAME);
	        runner.complete(!rejected);
	      }
	    };
	  }];
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateSwap
	 * @restrict A
	 * @scope
	 *
	 * @description
	 *
	 * ngAnimateSwap is a animation-oriented directive that allows for the container to
	 * be removed and entered in whenever the associated expression changes. A
	 * common usecase for this directive is a rotating banner or slider component which
	 * contains one image being present at a time. When the active image changes
	 * then the old image will perform a `leave` animation and the new element
	 * will be inserted via an `enter` animation.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|--------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
	 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
	 *
	 * @example
	 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
	 *          deps="angular-animate.js"
	 *          animations="true" fixBase="true">
	 *   <file name="index.html">
	 *     <div class="container" ng-controller="AppCtrl">
	 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
	 *         {{ number }}
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="script.js">
	 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
	 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
	 *         $scope.number = 0;
	 *         $interval(function() {
	 *           $scope.number++;
	 *         }, 1000);
	 *
	 *         var colors = ['red','blue','green','yellow','orange'];
	 *         $scope.colorClass = function(number) {
	 *           return colors[number % colors.length];
	 *         };
	 *       }]);
	 *   </file>
	 *  <file name="animations.css">
	 *  .container {
	 *    height:250px;
	 *    width:250px;
	 *    position:relative;
	 *    overflow:hidden;
	 *    border:2px solid black;
	 *  }
	 *  .container .cell {
	 *    font-size:150px;
	 *    text-align:center;
	 *    line-height:250px;
	 *    position:absolute;
	 *    top:0;
	 *    left:0;
	 *    right:0;
	 *    border-bottom:2px solid black;
	 *  }
	 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
	 *    transition:0.5s linear all;
	 *  }
	 *  .swap-animation.ng-enter {
	 *    top:-250px;
	 *  }
	 *  .swap-animation.ng-enter-active {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave-active {
	 *    top:250px;
	 *  }
	 *  .red { background:red; }
	 *  .green { background:green; }
	 *  .blue { background:blue; }
	 *  .yellow { background:yellow; }
	 *  .orange { background:orange; }
	 *  </file>
	 * </example>
	 */
	var ngAnimateSwapDirective = ['$animate', '$rootScope', function($animate, $rootScope) {
	  return {
	    restrict: 'A',
	    transclude: 'element',
	    terminal: true,
	    priority: 600, // we use 600 here to ensure that the directive is caught before others
	    link: function(scope, $element, attrs, ctrl, $transclude) {
	      var previousElement, previousScope;
	      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
	        if (previousElement) {
	          $animate.leave(previousElement);
	        }
	        if (previousScope) {
	          previousScope.$destroy();
	          previousScope = null;
	        }
	        if (value || value === 0) {
	          previousScope = scope.$new();
	          $transclude(previousScope, function(element) {
	            previousElement = element;
	            $animate.enter(element, null, $element);
	          });
	        }
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc module
	 * @name ngAnimate
	 * @description
	 *
	 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
	 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an Angular app.
	 *
	 * <div doc-module-components="ngAnimate"></div>
	 *
	 * # Usage
	 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
	 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
	 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
	 * the HTML element that the animation will be triggered on.
	 *
	 * ## Directive Support
	 * The following directives are "animation aware":
	 *
	 * | Directive                                                                                                | Supported Animations                                                     |
	 * |----------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------------|
	 * | {@link ng.directive:ngRepeat#animations ngRepeat}                                                        | enter, leave and move                                                    |
	 * | {@link ngRoute.directive:ngView#animations ngView}                                                       | enter and leave                                                          |
	 * | {@link ng.directive:ngInclude#animations ngInclude}                                                      | enter and leave                                                          |
	 * | {@link ng.directive:ngSwitch#animations ngSwitch}                                                        | enter and leave                                                          |
	 * | {@link ng.directive:ngIf#animations ngIf}                                                                | enter and leave                                                          |
	 * | {@link ng.directive:ngClass#animations ngClass}                                                          | add and remove (the CSS class(es) present)                               |
	 * | {@link ng.directive:ngShow#animations ngShow} & {@link ng.directive:ngHide#animations ngHide}            | add and remove (the ng-hide class value)                                 |
	 * | {@link ng.directive:form#animation-hooks form} & {@link ng.directive:ngModel#animation-hooks ngModel}    | add and remove (dirty, pristine, valid, invalid & all other validations) |
	 * | {@link module:ngMessages#animations ngMessages}                                                          | add and remove (ng-active & ng-inactive)                                 |
	 * | {@link module:ngMessages#animations ngMessage}                                                           | enter and leave                                                          |
	 *
	 * (More information can be found by visiting each the documentation associated with each directive.)
	 *
	 * ## CSS-based Animations
	 *
	 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
	 * and CSS code we can create an animation that will be picked up by Angular when an underlying directive performs an operation.
	 *
	 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
	 *
	 * ```html
	 * <div ng-if="bool" class="fade">
	 *    Fade me in out
	 * </div>
	 * <button ng-click="bool=true">Fade In!</button>
	 * <button ng-click="bool=false">Fade Out!</button>
	 * ```
	 *
	 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
	 *
	 * ```css
	 * /&#42; The starting CSS styles for the enter animation &#42;/
	 * .fade.ng-enter {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 *
	 * /&#42; The finishing CSS styles for the enter animation &#42;/
	 * .fade.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
	 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
	 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
	 *
	 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
	 *
	 * ```css
	 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
	 * .fade.ng-leave {
	 *   transition:0.5s linear all;
	 *   opacity:1;
	 * }
	 * .fade.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
	 *
	 * ```css
	 * /&#42; there is no need to define anything inside of the destination
	 * CSS class since the keyframe will take charge of the animation &#42;/
	 * .fade.ng-leave {
	 *   animation: my_fade_animation 0.5s linear;
	 *   -webkit-animation: my_fade_animation 0.5s linear;
	 * }
	 *
	 * @keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 *
	 * @-webkit-keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 * ```
	 *
	 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
	 *
	 * ### CSS Class-based Animations
	 *
	 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
	 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
	 * and removed.
	 *
	 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
	 *
	 * ```html
	 * <div ng-show="bool" class="fade">
	 *   Show and hide me
	 * </div>
	 * <button ng-click="bool=!bool">Toggle</button>
	 *
	 * <style>
	 * .fade.ng-hide {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 * </style>
	 * ```
	 *
	 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
	 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
	 *
	 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
	 * with CSS styles.
	 *
	 * ```html
	 * <div ng-class="{on:onOff}" class="highlight">
	 *   Highlight this box
	 * </div>
	 * <button ng-click="onOff=!onOff">Toggle</button>
	 *
	 * <style>
	 * .highlight {
	 *   transition:0.5s linear all;
	 * }
	 * .highlight.on-add {
	 *   background:white;
	 * }
	 * .highlight.on {
	 *   background:yellow;
	 * }
	 * .highlight.on-remove {
	 *   background:black;
	 * }
	 * </style>
	 * ```
	 *
	 * We can also make use of CSS keyframes by placing them within the CSS classes.
	 *
	 *
	 * ### CSS Staggering Animations
	 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
	 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
	 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
	 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
	 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
	 *
	 * ```css
	 * .my-animation.ng-enter {
	 *   /&#42; standard transition code &#42;/
	 *   transition: 1s linear all;
	 *   opacity:0;
	 * }
	 * .my-animation.ng-enter-stagger {
	 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
	 *   transition-delay: 0.1s;
	 *
	 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
	 *     to not accidentally inherit a delay property from another CSS class &#42;/
	 *   transition-duration: 0s;
	 * }
	 * .my-animation.ng-enter.ng-enter-active {
	 *   /&#42; standard transition styles &#42;/
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
	 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
	 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
	 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
	 *
	 * The following code will issue the **ng-leave-stagger** event on the element provided:
	 *
	 * ```js
	 * var kids = parent.children();
	 *
	 * $animate.leave(kids[0]); //stagger index=0
	 * $animate.leave(kids[1]); //stagger index=1
	 * $animate.leave(kids[2]); //stagger index=2
	 * $animate.leave(kids[3]); //stagger index=3
	 * $animate.leave(kids[4]); //stagger index=4
	 *
	 * window.requestAnimationFrame(function() {
	 *   //stagger has reset itself
	 *   $animate.leave(kids[5]); //stagger index=0
	 *   $animate.leave(kids[6]); //stagger index=1
	 *
	 *   $scope.$digest();
	 * });
	 * ```
	 *
	 * Stagger animations are currently only supported within CSS-defined animations.
	 *
	 * ### The `ng-animate` CSS class
	 *
	 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
	 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
	 *
	 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
	 *
	 * ```css
	 * .zipper.ng-animate {
	 *   transition:0.5s linear all;
	 * }
	 * .zipper.ng-enter {
	 *   opacity:0;
	 * }
	 * .zipper.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
	 * the CSS class once an animation has completed.)
	 *
	 *
	 * ### The `ng-[event]-prepare` class
	 *
	 * This is a special class that can be used to prevent unwanted flickering / flash of content before
	 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
	 * before the actual animation starts (after waiting for a $digest).
	 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
	 *
	 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
	 * into elements that have class-based animations such as `ngClass`.
	 *
	 * ```html
	 * <div ng-class="{red: myProp}">
	 *   <div ng-class="{blue: myProp}">
	 *     <div class="message" ng-if="myProp"></div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
	 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
	 *
	 * ```css
	 * .message.ng-enter-prepare {
	 *   opacity: 0;
	 * }
	 *
	 * ```
	 *
	 * ## JavaScript-based Animations
	 *
	 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
	 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
	 * `module.animation()` module function we can register the animation.
	 *
	 * Let's see an example of a enter/leave animation using `ngRepeat`:
	 *
	 * ```html
	 * <div ng-repeat="item in items" class="slide">
	 *   {{ item }}
	 * </div>
	 * ```
	 *
	 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     // make note that other events (like addClass/removeClass)
	 *     // have different function input parameters
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *
	 *       // remember to call doneFn so that angular
	 *       // knows that the animation has concluded
	 *     },
	 *
	 *     move: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *     },
	 *
	 *     leave: function(element, doneFn) {
	 *       jQuery(element).fadeOut(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
	 * greensock.js and velocity.js.
	 *
	 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
	 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
	 *
	 * ```html
	 * <div ng-class="color" class="colorful">
	 *   this box is moody
	 * </div>
	 * <button ng-click="color='red'">Change to red</button>
	 * <button ng-click="color='blue'">Change to blue</button>
	 * <button ng-click="color='green'">Change to green</button>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.colorful', [function() {
	 *   return {
	 *     addClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     removeClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     setClass: function(element, addedClass, removedClass, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## CSS + JS Animations Together
	 *
	 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of Angular,
	 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
	 * charge of the animation**:
	 *
	 * ```html
	 * <div ng-if="bool" class="slide">
	 *   Slide in and out
	 * </div>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).slideIn(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ```css
	 * .slide.ng-enter {
	 *   transition:0.5s linear all;
	 *   transform:translateY(-100px);
	 * }
	 * .slide.ng-enter.ng-enter-active {
	 *   transform:translateY(0);
	 * }
	 * ```
	 *
	 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
	 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
	 * our own JS-based animation code:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
	 *
	 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
	 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
	 * data into `$animateCss` directly:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true,
	 *         addClass: 'maroon-setting',
	 *         from: { height:0 },
	 *         to: { height: 200 }
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Now we can fill in the rest via our transition CSS code:
	 *
	 * ```css
	 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
	 * .slide.ng-enter { transition:0.5s linear all; }
	 *
	 * /&#42; this extra CSS class will be absorbed into the transition
	 * since the $animateCss code is adding the class &#42;/
	 * .maroon-setting { background:red; }
	 * ```
	 *
	 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
	 *
	 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
	 *
	 * ## Animation Anchoring (via `ng-animate-ref`)
	 *
	 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
	 * structural areas of an application (like views) by pairing up elements using an attribute
	 * called `ng-animate-ref`.
	 *
	 * Let's say for example we have two views that are managed by `ng-view` and we want to show
	 * that there is a relationship between two components situated in within these views. By using the
	 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
	 * can then attach an animation, which is triggered when the view changes.
	 *
	 * Say for example we have the following template code:
	 *
	 * ```html
	 * <!-- index.html -->
	 * <div ng-view class="view-animation">
	 * </div>
	 *
	 * <!-- home.html -->
	 * <a href="#/banner-page">
	 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * </a>
	 *
	 * <!-- banner-page.html -->
	 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * ```
	 *
	 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
	 * HTML contents to see if there is a match reference between any components in the view
	 * that is leaving and the view that is entering. It will scan both the view which is being
	 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
	 * contain a matching ref value.
	 *
	 * The two images match since they share the same ref value. ngAnimate will now create a
	 * transport element (which is a clone of the first image element) and it will then attempt
	 * to animate to the position of the second image element in the next view. For the animation to
	 * work a special CSS class called `ng-anchor` will be added to the transported element.
	 *
	 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
	 * ngAnimate will handle the entire transition for us as well as the addition and removal of
	 * any changes of CSS classes between the elements:
	 *
	 * ```css
	 * .banner.ng-anchor {
	 *   /&#42; this animation will last for 1 second since there are
	 *          two phases to the animation (an `in` and an `out` phase) &#42;/
	 *   transition:0.5s linear all;
	 * }
	 * ```
	 *
	 * We also **must** include animations for the views that are being entered and removed
	 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
	 *
	 * ```css
	 * .view-animation.ng-enter, .view-animation.ng-leave {
	 *   transition:0.5s linear all;
	 *   position:fixed;
	 *   left:0;
	 *   top:0;
	 *   width:100%;
	 * }
	 * .view-animation.ng-enter {
	 *   transform:translateX(100%);
	 * }
	 * .view-animation.ng-leave,
	 * .view-animation.ng-enter.ng-enter-active {
	 *   transform:translateX(0%);
	 * }
	 * .view-animation.ng-leave.ng-leave-active {
	 *   transform:translateX(-100%);
	 * }
	 * ```
	 *
	 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
	 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
	 * from its origin. Once that animation is over then the `in` stage occurs which animates the
	 * element to its destination. The reason why there are two animations is to give enough time
	 * for the enter animation on the new element to be ready.
	 *
	 * The example above sets up a transition for both the in and out phases, but we can also target the out or
	 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
	 *
	 * ```css
	 * .banner.ng-anchor-out {
	 *   transition: 0.5s linear all;
	 *
	 *   /&#42; the scale will be applied during the out animation,
	 *          but will be animated away when the in animation runs &#42;/
	 *   transform: scale(1.2);
	 * }
	 *
	 * .banner.ng-anchor-in {
	 *   transition: 1s linear all;
	 * }
	 * ```
	 *
	 *
	 *
	 *
	 * ### Anchoring Demo
	 *
	  <example module="anchoringExample"
	           name="anchoringExample"
	           id="anchoringExample"
	           deps="angular-animate.js;angular-route.js"
	           animations="true">
	    <file name="index.html">
	      <a href="#/">Home</a>
	      <hr />
	      <div class="view-container">
	        <div ng-view class="view"></div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
	        .config(['$routeProvider', function($routeProvider) {
	          $routeProvider.when('/', {
	            templateUrl: 'home.html',
	            controller: 'HomeController as home'
	          });
	          $routeProvider.when('/profile/:id', {
	            templateUrl: 'profile.html',
	            controller: 'ProfileController as profile'
	          });
	        }])
	        .run(['$rootScope', function($rootScope) {
	          $rootScope.records = [
	            { id: 1, title: 'Miss Beulah Roob' },
	            { id: 2, title: 'Trent Morissette' },
	            { id: 3, title: 'Miss Ava Pouros' },
	            { id: 4, title: 'Rod Pouros' },
	            { id: 5, title: 'Abdul Rice' },
	            { id: 6, title: 'Laurie Rutherford Sr.' },
	            { id: 7, title: 'Nakia McLaughlin' },
	            { id: 8, title: 'Jordon Blanda DVM' },
	            { id: 9, title: 'Rhoda Hand' },
	            { id: 10, title: 'Alexandrea Sauer' }
	          ];
	        }])
	        .controller('HomeController', [function() {
	          //empty
	        }])
	        .controller('ProfileController', ['$rootScope', '$routeParams',
	            function ProfileController($rootScope, $routeParams) {
	          var index = parseInt($routeParams.id, 10);
	          var record = $rootScope.records[index - 1];
	
	          this.title = record.title;
	          this.id = record.id;
	        }]);
	    </file>
	    <file name="home.html">
	      <h2>Welcome to the home page</h1>
	      <p>Please click on an element</p>
	      <a class="record"
	         ng-href="#/profile/{{ record.id }}"
	         ng-animate-ref="{{ record.id }}"
	         ng-repeat="record in records">
	        {{ record.title }}
	      </a>
	    </file>
	    <file name="profile.html">
	      <div class="profile record" ng-animate-ref="{{ profile.id }}">
	        {{ profile.title }}
	      </div>
	    </file>
	    <file name="animations.css">
	      .record {
	        display:block;
	        font-size:20px;
	      }
	      .profile {
	        background:black;
	        color:white;
	        font-size:100px;
	      }
	      .view-container {
	        position:relative;
	      }
	      .view-container > .view.ng-animate {
	        position:absolute;
	        top:0;
	        left:0;
	        width:100%;
	        min-height:500px;
	      }
	      .view.ng-enter, .view.ng-leave,
	      .record.ng-anchor {
	        transition:0.5s linear all;
	      }
	      .view.ng-enter {
	        transform:translateX(100%);
	      }
	      .view.ng-enter.ng-enter-active, .view.ng-leave {
	        transform:translateX(0%);
	      }
	      .view.ng-leave.ng-leave-active {
	        transform:translateX(-100%);
	      }
	      .record.ng-anchor-out {
	        background:red;
	      }
	    </file>
	  </example>
	 *
	 * ### How is the element transported?
	 *
	 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
	 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
	 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
	 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
	 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
	 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
	 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
	 * will become visible since the shim class will be removed.
	 *
	 * ### How is the morphing handled?
	 *
	 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
	 * what CSS classes differ between the starting element and the destination element. These different CSS classes
	 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
	 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
	 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
	 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
	 * the cloned element is placed inside of root element which is likely close to the body element).
	 *
	 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
	 *
	 *
	 * ## Using $animate in your directive code
	 *
	 * So far we've explored how to feed in animations into an Angular application, but how do we trigger animations within our own directives in our application?
	 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
	 * imagine we have a greeting box that shows and hides itself when the data changes
	 *
	 * ```html
	 * <greeting-box active="onOrOff">Hi there</greeting-box>
	 * ```
	 *
	 * ```js
	 * ngModule.directive('greetingBox', ['$animate', function($animate) {
	 *   return function(scope, element, attrs) {
	 *     attrs.$observe('active', function(value) {
	 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
	 *     });
	 *   });
	 * }]);
	 * ```
	 *
	 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
	 * in our HTML code then we can trigger a CSS or JS animation to happen.
	 *
	 * ```css
	 * /&#42; normally we would create a CSS class to reference on the element &#42;/
	 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
	 * ```
	 *
	 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
	 * possible be sure to visit the {@link ng.$animate $animate service API page}.
	 *
	 *
	 * ## Callbacks and Promises
	 *
	 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
	 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
	 * ended by chaining onto the returned promise that animation method returns.
	 *
	 * ```js
	 * // somewhere within the depths of the directive
	 * $animate.enter(element, parent).then(function() {
	 *   //the animation has completed
	 * });
	 * ```
	 *
	 * (Note that earlier versions of Angular prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
	 * anymore.)
	 *
	 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
	 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
	 * routing controller to hook into that:
	 *
	 * ```js
	 * ngModule.controller('HomePageController', ['$animate', function($animate) {
	 *   $animate.on('enter', ngViewElement, function(element) {
	 *     // the animation for this route has completed
	 *   }]);
	 * }])
	 * ```
	 *
	 * (Note that you will need to trigger a digest within the callback to get angular to notice any scope-related changes.)
	 */
	
	var copy;
	var extend;
	var forEach;
	var isArray;
	var isDefined;
	var isElement;
	var isFunction;
	var isObject;
	var isString;
	var isUndefined;
	var jqLite;
	var noop;
	
	/**
	 * @ngdoc service
	 * @name $animate
	 * @kind object
	 *
	 * @description
	 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
	 *
	 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
	 */
	angular.module('ngAnimate', [], function initAngularHelpers() {
	  // Access helpers from angular core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  noop        = angular.noop;
	  copy        = angular.copy;
	  extend      = angular.extend;
	  jqLite      = angular.element;
	  forEach     = angular.forEach;
	  isArray     = angular.isArray;
	  isString    = angular.isString;
	  isObject    = angular.isObject;
	  isUndefined = angular.isUndefined;
	  isDefined   = angular.isDefined;
	  isFunction  = angular.isFunction;
	  isElement   = angular.isElement;
	})
	  .directive('ngAnimateSwap', ngAnimateSwapDirective)
	
	  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
	  .factory('$$rAFScheduler', $$rAFSchedulerFactory)
	
	  .provider('$$animateQueue', $$AnimateQueueProvider)
	  .provider('$$animation', $$AnimationProvider)
	
	  .provider('$animateCss', $AnimateCssProvider)
	  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)
	
	  .provider('$$animateJs', $$AnimateJsProvider)
	  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);
	
	
	})(window, window.angular);


/***/ }),

/***/ 1078:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1079);

/***/ }),

/***/ 1079:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.11
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngAria
	 * @description
	 *
	 * The `ngAria` module provides support for common
	 * [<abbr title="Accessible Rich Internet Applications">ARIA</abbr>](http://www.w3.org/TR/wai-aria/)
	 * attributes that convey state or semantic information about the application for users
	 * of assistive technologies, such as screen readers.
	 *
	 * <div doc-module-components="ngAria"></div>
	 *
	 * ## Usage
	 *
	 * For ngAria to do its magic, simply include the module `ngAria` as a dependency. The following
	 * directives are supported:
	 * `ngModel`, `ngChecked`, `ngReadonly`, `ngRequired`, `ngValue`, `ngDisabled`, `ngShow`, `ngHide`, `ngClick`,
	 * `ngDblClick`, and `ngMessages`.
	 *
	 * Below is a more detailed breakdown of the attributes handled by ngAria:
	 *
	 * | Directive                                   | Supported Attributes                                                                   |
	 * |---------------------------------------------|----------------------------------------------------------------------------------------|
	 * | {@link ng.directive:ngModel ngModel}        | aria-checked, aria-valuemin, aria-valuemax, aria-valuenow, aria-invalid, aria-required, input roles |
	 * | {@link ng.directive:ngDisabled ngDisabled}  | aria-disabled                                                                          |
	 * | {@link ng.directive:ngRequired ngRequired}  | aria-required
	 * | {@link ng.directive:ngChecked ngChecked}    | aria-checked
	 * | {@link ng.directive:ngReadonly ngReadonly}  | aria-readonly                                                                          |
	 * | {@link ng.directive:ngValue ngValue}        | aria-checked                                                                           |
	 * | {@link ng.directive:ngShow ngShow}          | aria-hidden                                                                            |
	 * | {@link ng.directive:ngHide ngHide}          | aria-hidden                                                                            |
	 * | {@link ng.directive:ngDblclick ngDblclick}  | tabindex                                                                               |
	 * | {@link module:ngMessages ngMessages}        | aria-live                                                                              |
	 * | {@link ng.directive:ngClick ngClick}        | tabindex, keypress event, button role                                                  |
	 *
	 * Find out more information about each directive by reading the
	 * {@link guide/accessibility ngAria Developer Guide}.
	 *
	 * ## Example
	 * Using ngDisabled with ngAria:
	 * ```html
	 * <md-checkbox ng-disabled="disabled">
	 * ```
	 * Becomes:
	 * ```html
	 * <md-checkbox ng-disabled="disabled" aria-disabled="true">
	 * ```
	 *
	 * ## Disabling Attributes
	 * It's possible to disable individual attributes added by ngAria with the
	 * {@link ngAria.$ariaProvider#config config} method. For more details, see the
	 * {@link guide/accessibility Developer Guide}.
	 */
	var ngAriaModule = angular.module('ngAria', ['ng']).
	                        provider('$aria', $AriaProvider);
	
	/**
	* Internal Utilities
	*/
	var nodeBlackList = ['BUTTON', 'A', 'INPUT', 'TEXTAREA', 'SELECT', 'DETAILS', 'SUMMARY'];
	
	var isNodeOneOf = function(elem, nodeTypeArray) {
	  if (nodeTypeArray.indexOf(elem[0].nodeName) !== -1) {
	    return true;
	  }
	};
	/**
	 * @ngdoc provider
	 * @name $ariaProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the ARIA attributes injected and managed by ngAria.
	 *
	 * ```js
	 * angular.module('myApp', ['ngAria'], function config($ariaProvider) {
	 *   $ariaProvider.config({
	 *     ariaValue: true,
	 *     tabindex: false
	 *   });
	 * });
	 *```
	 *
	 * ## Dependencies
	 * Requires the {@link ngAria} module to be installed.
	 *
	 */
	function $AriaProvider() {
	  var config = {
	    ariaHidden: true,
	    ariaChecked: true,
	    ariaReadonly: true,
	    ariaDisabled: true,
	    ariaRequired: true,
	    ariaInvalid: true,
	    ariaValue: true,
	    tabindex: true,
	    bindKeypress: true,
	    bindRoleForClick: true
	  };
	
	  /**
	   * @ngdoc method
	   * @name $ariaProvider#config
	   *
	   * @param {object} config object to enable/disable specific ARIA attributes
	   *
	   *  - **ariaHidden** – `{boolean}` – Enables/disables aria-hidden tags
	   *  - **ariaChecked** – `{boolean}` – Enables/disables aria-checked tags
	   *  - **ariaReadonly** – `{boolean}` – Enables/disables aria-readonly tags
	   *  - **ariaDisabled** – `{boolean}` – Enables/disables aria-disabled tags
	   *  - **ariaRequired** – `{boolean}` – Enables/disables aria-required tags
	   *  - **ariaInvalid** – `{boolean}` – Enables/disables aria-invalid tags
	   *  - **ariaValue** – `{boolean}` – Enables/disables aria-valuemin, aria-valuemax and aria-valuenow tags
	   *  - **tabindex** – `{boolean}` – Enables/disables tabindex tags
	   *  - **bindKeypress** – `{boolean}` – Enables/disables keypress event binding on `div` and
	   *    `li` elements with ng-click
	   *  - **bindRoleForClick** – `{boolean}` – Adds role=button to non-interactive elements like `div`
	   *    using ng-click, making them more accessible to users of assistive technologies
	   *
	   * @description
	   * Enables/disables various ARIA attributes
	   */
	  this.config = function(newConfig) {
	    config = angular.extend(config, newConfig);
	  };
	
	  function watchExpr(attrName, ariaAttr, nodeBlackList, negate) {
	    return function(scope, elem, attr) {
	      var ariaCamelName = attr.$normalize(ariaAttr);
	      if (config[ariaCamelName] && !isNodeOneOf(elem, nodeBlackList) && !attr[ariaCamelName]) {
	        scope.$watch(attr[attrName], function(boolVal) {
	          // ensure boolean value
	          boolVal = negate ? !boolVal : !!boolVal;
	          elem.attr(ariaAttr, boolVal);
	        });
	      }
	    };
	  }
	  /**
	   * @ngdoc service
	   * @name $aria
	   *
	   * @description
	   * @priority 200
	   *
	   * The $aria service contains helper methods for applying common
	   * [ARIA](http://www.w3.org/TR/wai-aria/) attributes to HTML directives.
	   *
	   * ngAria injects common accessibility attributes that tell assistive technologies when HTML
	   * elements are enabled, selected, hidden, and more. To see how this is performed with ngAria,
	   * let's review a code snippet from ngAria itself:
	   *
	   *```js
	   * ngAriaModule.directive('ngDisabled', ['$aria', function($aria) {
	   *   return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
	   * }])
	   *```
	   * Shown above, the ngAria module creates a directive with the same signature as the
	   * traditional `ng-disabled` directive. But this ngAria version is dedicated to
	   * solely managing accessibility attributes on custom elements. The internal `$aria` service is
	   * used to watch the boolean attribute `ngDisabled`. If it has not been explicitly set by the
	   * developer, `aria-disabled` is injected as an attribute with its value synchronized to the
	   * value in `ngDisabled`.
	   *
	   * Because ngAria hooks into the `ng-disabled` directive, developers do not have to do
	   * anything to enable this feature. The `aria-disabled` attribute is automatically managed
	   * simply as a silent side-effect of using `ng-disabled` with the ngAria module.
	   *
	   * The full list of directives that interface with ngAria:
	   * * **ngModel**
	   * * **ngChecked**
	   * * **ngReadonly**
	   * * **ngRequired**
	   * * **ngDisabled**
	   * * **ngValue**
	   * * **ngShow**
	   * * **ngHide**
	   * * **ngClick**
	   * * **ngDblclick**
	   * * **ngMessages**
	   *
	   * Read the {@link guide/accessibility ngAria Developer Guide} for a thorough explanation of each
	   * directive.
	   *
	   *
	   * ## Dependencies
	   * Requires the {@link ngAria} module to be installed.
	   */
	  this.$get = function() {
	    return {
	      config: function(key) {
	        return config[key];
	      },
	      $$watchExpr: watchExpr
	    };
	  };
	}
	
	
	ngAriaModule.directive('ngShow', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngShow', 'aria-hidden', [], true);
	}])
	.directive('ngHide', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngHide', 'aria-hidden', [], false);
	}])
	.directive('ngValue', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngValue', 'aria-checked', nodeBlackList, false);
	}])
	.directive('ngChecked', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngChecked', 'aria-checked', nodeBlackList, false);
	}])
	.directive('ngReadonly', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngReadonly', 'aria-readonly', nodeBlackList, false);
	}])
	.directive('ngRequired', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngRequired', 'aria-required', nodeBlackList, false);
	}])
	.directive('ngModel', ['$aria', function($aria) {
	
	  function shouldAttachAttr(attr, normalizedAttr, elem, allowBlacklistEls) {
	    return $aria.config(normalizedAttr) && !elem.attr(attr) && (allowBlacklistEls || !isNodeOneOf(elem, nodeBlackList));
	  }
	
	  function shouldAttachRole(role, elem) {
	    // if element does not have role attribute
	    // AND element type is equal to role (if custom element has a type equaling shape) <-- remove?
	    // AND element is not INPUT
	    return !elem.attr('role') && (elem.attr('type') === role) && (elem[0].nodeName !== 'INPUT');
	  }
	
	  function getShape(attr, elem) {
	    var type = attr.type,
	        role = attr.role;
	
	    return ((type || role) === 'checkbox' || role === 'menuitemcheckbox') ? 'checkbox' :
	           ((type || role) === 'radio'    || role === 'menuitemradio') ? 'radio' :
	           (type === 'range'              || role === 'progressbar' || role === 'slider') ? 'range' : '';
	  }
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    priority: 200, //Make sure watches are fired after any other directives that affect the ngModel value
	    compile: function(elem, attr) {
	      var shape = getShape(attr, elem);
	
	      return {
	        pre: function(scope, elem, attr, ngModel) {
	          if (shape === 'checkbox') {
	            //Use the input[checkbox] $isEmpty implementation for elements with checkbox roles
	            ngModel.$isEmpty = function(value) {
	              return value === false;
	            };
	          }
	        },
	        post: function(scope, elem, attr, ngModel) {
	          var needsTabIndex = shouldAttachAttr('tabindex', 'tabindex', elem, false);
	
	          function ngAriaWatchModelValue() {
	            return ngModel.$modelValue;
	          }
	
	          function getRadioReaction(newVal) {
	            // Strict comparison would cause a BC
	            // eslint-disable-next-line eqeqeq
	            var boolVal = (attr.value == ngModel.$viewValue);
	            elem.attr('aria-checked', boolVal);
	          }
	
	          function getCheckboxReaction() {
	            elem.attr('aria-checked', !ngModel.$isEmpty(ngModel.$viewValue));
	          }
	
	          switch (shape) {
	            case 'radio':
	            case 'checkbox':
	              if (shouldAttachRole(shape, elem)) {
	                elem.attr('role', shape);
	              }
	              if (shouldAttachAttr('aria-checked', 'ariaChecked', elem, false)) {
	                scope.$watch(ngAriaWatchModelValue, shape === 'radio' ?
	                    getRadioReaction : getCheckboxReaction);
	              }
	              if (needsTabIndex) {
	                elem.attr('tabindex', 0);
	              }
	              break;
	            case 'range':
	              if (shouldAttachRole(shape, elem)) {
	                elem.attr('role', 'slider');
	              }
	              if ($aria.config('ariaValue')) {
	                var needsAriaValuemin = !elem.attr('aria-valuemin') &&
	                    (attr.hasOwnProperty('min') || attr.hasOwnProperty('ngMin'));
	                var needsAriaValuemax = !elem.attr('aria-valuemax') &&
	                    (attr.hasOwnProperty('max') || attr.hasOwnProperty('ngMax'));
	                var needsAriaValuenow = !elem.attr('aria-valuenow');
	
	                if (needsAriaValuemin) {
	                  attr.$observe('min', function ngAriaValueMinReaction(newVal) {
	                    elem.attr('aria-valuemin', newVal);
	                  });
	                }
	                if (needsAriaValuemax) {
	                  attr.$observe('max', function ngAriaValueMinReaction(newVal) {
	                    elem.attr('aria-valuemax', newVal);
	                  });
	                }
	                if (needsAriaValuenow) {
	                  scope.$watch(ngAriaWatchModelValue, function ngAriaValueNowReaction(newVal) {
	                    elem.attr('aria-valuenow', newVal);
	                  });
	                }
	              }
	              if (needsTabIndex) {
	                elem.attr('tabindex', 0);
	              }
	              break;
	          }
	
	          if (!attr.hasOwnProperty('ngRequired') && ngModel.$validators.required
	            && shouldAttachAttr('aria-required', 'ariaRequired', elem, false)) {
	            // ngModel.$error.required is undefined on custom controls
	            attr.$observe('required', function() {
	              elem.attr('aria-required', !!attr['required']);
	            });
	          }
	
	          if (shouldAttachAttr('aria-invalid', 'ariaInvalid', elem, true)) {
	            scope.$watch(function ngAriaInvalidWatch() {
	              return ngModel.$invalid;
	            }, function ngAriaInvalidReaction(newVal) {
	              elem.attr('aria-invalid', !!newVal);
	            });
	          }
	        }
	      };
	    }
	  };
	}])
	.directive('ngDisabled', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
	}])
	.directive('ngMessages', function() {
	  return {
	    restrict: 'A',
	    require: '?ngMessages',
	    link: function(scope, elem, attr, ngMessages) {
	      if (!elem.attr('aria-live')) {
	        elem.attr('aria-live', 'assertive');
	      }
	    }
	  };
	})
	.directive('ngClick',['$aria', '$parse', function($aria, $parse) {
	  return {
	    restrict: 'A',
	    compile: function(elem, attr) {
	      var fn = $parse(attr.ngClick, /* interceptorFn */ null, /* expensiveChecks */ true);
	      return function(scope, elem, attr) {
	
	        if (!isNodeOneOf(elem, nodeBlackList)) {
	
	          if ($aria.config('bindRoleForClick') && !elem.attr('role')) {
	            elem.attr('role', 'button');
	          }
	
	          if ($aria.config('tabindex') && !elem.attr('tabindex')) {
	            elem.attr('tabindex', 0);
	          }
	
	          if ($aria.config('bindKeypress') && !attr.ngKeypress) {
	            elem.on('keypress', function(event) {
	              var keyCode = event.which || event.keyCode;
	              if (keyCode === 32 || keyCode === 13) {
	                scope.$apply(callback);
	              }
	
	              function callback() {
	                fn(scope, { $event: event });
	              }
	            });
	          }
	        }
	      };
	    }
	  };
	}])
	.directive('ngDblclick', ['$aria', function($aria) {
	  return function(scope, elem, attr) {
	    if ($aria.config('tabindex') && !elem.attr('tabindex') && !isNodeOneOf(elem, nodeBlackList)) {
	      elem.attr('tabindex', 0);
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),

/***/ 1080:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1081);

/***/ }),

/***/ 1081:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.11
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var forEach;
	var isArray;
	var isString;
	var jqLite;
	
	/**
	 * @ngdoc module
	 * @name ngMessages
	 * @description
	 *
	 * The `ngMessages` module provides enhanced support for displaying messages within templates
	 * (typically within forms or when rendering message objects that return key/value data).
	 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
	 * show and hide error messages specific to the state of an input field, the `ngMessages` and
	 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
	 * sequencing based on the order of how the messages are defined in the template.
	 *
	 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
	 * `ngMessage` and `ngMessageExp` directives.
	 *
	 * # Usage
	 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
	 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
	 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
	 * {@link ngModel ngModel} directive.
	 *
	 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
	 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
	 * the `ngMessages` directive.
	 *
	 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
	 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
	 * directive.
	 *
	 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Enter text:
	 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
	 *   </label>
	 *   <div ng-messages="myForm.myField.$error" role="alert">
	 *     <div ng-message="required">Please enter a value for this field.</div>
	 *     <div ng-message="email">This field must be a valid email address.</div>
	 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
	 * set to the `$error` object owned by the `myField` input in our `myForm` form.
	 *
	 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
	 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
	 * setting `ng-message="required"` specifies that this particular element should be displayed when there
	 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
	 * `myForm.myField.$error`).
	 *
	 * ### Message order
	 *
	 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
	 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
	 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
	 * to prioritize messages using custom JavaScript code.
	 *
	 * Given the following error object for our example (which informs us that the field `myField` currently has both the
	 * `required` and `email` errors):
	 *
	 * ```javascript
	 * <!-- keep in mind that ngModel automatically sets these error flags -->
	 * myField.$error = { required : true, email: true, maxlength: false };
	 * ```
	 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
	 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
	 * but the `email` message will be visible because it is still applicable.
	 *
	 * ### Displaying multiple messages at the same time
	 *
	 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
	 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
	 *
	 * ```html
	 * <!-- attribute-style usage -->
	 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
	 *
	 * <!-- element-style usage -->
	 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
	 * ```
	 *
	 * ## Reusing and Overriding Messages
	 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
	 * template. This allows for generic collection of messages to be reused across multiple parts of an
	 * application.
	 *
	 * ```html
	 * <script type="text/ng-template" id="error-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <div ng-messages="myForm.myField.$error" role="alert">
	 *   <div ng-messages-include="error-messages"></div>
	 * </div>
	 * ```
	 *
	 * However, including generic messages may not be useful enough to match all input fields, therefore,
	 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
	 * them within the directive container.
	 *
	 * ```html
	 * <!-- a generic template of error messages known as "my-custom-messages" -->
	 * <script type="text/ng-template" id="my-custom-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            id="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
	 *        override the messages present in the ng-messages-include template -->
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <!-- this required message has overridden the template message -->
	 *     <div ng-message="required">You did not enter your email address</div>
	 *
	 *     <!-- this is a brand new message and will appear last in the prioritization -->
	 *     <div ng-message="email">Your email address is invalid</div>
	 *
	 *     <!-- and here are the generic error messages -->
	 *     <div ng-messages-include="my-custom-messages"></div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In the example HTML code above the message that is set on required will override the corresponding
	 * required message defined within the remote template. Therefore, with particular input fields (such
	 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
	 * while more generic messages can be used to handle other, more general input errors.
	 *
	 * ## Dynamic Messaging
	 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
	 * repeaters to list messages is also supported. This means that the code below will be able to
	 * fully adapt itself and display the appropriate message when any of the expression data changes:
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message="required">You did not enter your email address</div>
	 *     <div ng-repeat="errorMessage in errorMessages">
	 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
	 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
	 *     </div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * The `errorMessage.type` expression can be a string value or it can be an array so
	 * that multiple errors can be associated with a single error message:
	 *
	 * ```html
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            ng-model="data.email"
	 *            name="myEmail"
	 *            ng-minlength="5"
	 *            ng-maxlength="100"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message-exp="'required'">You did not enter your email address</div>
	 *     <div ng-message-exp="['minlength', 'maxlength']">
	 *       Your email must be between 5 and 100 characters long
	 *     </div>
	 *   </div>
	 * ```
	 *
	 * Feel free to use other structural directives such as ng-if and ng-switch to further control
	 * what messages are active and when. Be careful, if you place ng-message on the same element
	 * as these structural directives, Angular may not be able to determine if a message is active
	 * or not. Therefore it is best to place the ng-message on a child element of the structural
	 * directive.
	 *
	 * ```html
	 * <div ng-messages="myForm.myEmail.$error" role="alert">
	 *   <div ng-if="showRequiredError">
	 *     <div ng-message="required">Please enter something</div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * ## Animations
	 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
	 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
	 * the DOM by the `ngMessages` directive.
	 *
	 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
	 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
	 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
	 * hook into the animations whenever these classes are added/removed.
	 *
	 * Let's say that our HTML code for our messages container looks like so:
	 *
	 * ```html
	 * <div ng-messages="myMessages" class="my-messages" role="alert">
	 *   <div ng-message="alert" class="some-message">...</div>
	 *   <div ng-message="fail" class="some-message">...</div>
	 * </div>
	 * ```
	 *
	 * Then the CSS animation code for the message container looks like so:
	 *
	 * ```css
	 * .my-messages {
	 *   transition:1s linear all;
	 * }
	 * .my-messages.ng-active {
	 *   // messages are visible
	 * }
	 * .my-messages.ng-inactive {
	 *   // messages are hidden
	 * }
	 * ```
	 *
	 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
	 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
	 *
	 * Therefore, the CSS code for the inner messages looks like so:
	 *
	 * ```css
	 * .some-message {
	 *   transition:1s linear all;
	 * }
	 *
	 * .some-message.ng-enter {}
	 * .some-message.ng-enter.ng-enter-active {}
	 *
	 * .some-message.ng-leave {}
	 * .some-message.ng-leave.ng-leave-active {}
	 * ```
	 *
	 * {@link ngAnimate Click here} to learn how to use JavaScript animations or to learn more about ngAnimate.
	 */
	angular.module('ngMessages', [], function initAngularHelpers() {
	  // Access helpers from angular core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  forEach = angular.forEach;
	  isArray = angular.isArray;
	  isString = angular.isString;
	  jqLite = angular.element;
	})
	
	  /**
	   * @ngdoc directive
	   * @module ngMessages
	   * @name ngMessages
	   * @restrict AE
	   *
	   * @description
	   * `ngMessages` is a directive that is designed to show and hide messages based on the state
	   * of a key/value object that it listens on. The directive itself complements error message
	   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
	   *
	   * `ngMessages` manages the state of internal messages within its container element. The internal
	   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
	   * on if they're present within the key/value object. By default, only one message will be displayed
	   * at a time and this depends on the prioritization of the messages within the template. (This can
	   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
	   *
	   * A remote template can also be used to promote message reusability and messages can also be
	   * overridden.
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {string} ngMessages an angular expression evaluating to a key/value object
	   *                 (this is typically the $error object on an ngModel instance).
	   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
	   *
	   * @example
	   * <example name="ngMessages-directive" module="ngMessagesExample"
	   *          deps="angular-messages.js"
	   *          animations="true" fixBase="true">
	   *   <file name="index.html">
	   *     <form name="myForm">
	   *       <label>
	   *         Enter your name:
	   *         <input type="text"
	   *                name="myName"
	   *                ng-model="name"
	   *                ng-minlength="5"
	   *                ng-maxlength="20"
	   *                required />
	   *       </label>
	   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
	   *
	   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
	   *         <div ng-message="required">You did not enter a field</div>
	   *         <div ng-message="minlength">Your field is too short</div>
	   *         <div ng-message="maxlength">Your field is too long</div>
	   *       </div>
	   *     </form>
	   *   </file>
	   *   <file name="script.js">
	   *     angular.module('ngMessagesExample', ['ngMessages']);
	   *   </file>
	   * </example>
	   */
	  .directive('ngMessages', ['$animate', function($animate) {
	    var ACTIVE_CLASS = 'ng-active';
	    var INACTIVE_CLASS = 'ng-inactive';
	
	    return {
	      require: 'ngMessages',
	      restrict: 'AE',
	      controller: ['$element', '$scope', '$attrs', function NgMessagesCtrl($element, $scope, $attrs) {
	        var ctrl = this;
	        var latestKey = 0;
	        var nextAttachId = 0;
	
	        this.getAttachId = function getAttachId() { return nextAttachId++; };
	
	        var messages = this.messages = {};
	        var renderLater, cachedCollection;
	
	        this.render = function(collection) {
	          collection = collection || {};
	
	          renderLater = false;
	          cachedCollection = collection;
	
	          // this is true if the attribute is empty or if the attribute value is truthy
	          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
	                         isAttrTruthy($scope, $attrs.multiple);
	
	          var unmatchedMessages = [];
	          var matchedKeys = {};
	          var messageItem = ctrl.head;
	          var messageFound = false;
	          var totalMessages = 0;
	
	          // we use != instead of !== to allow for both undefined and null values
	          while (messageItem != null) {
	            totalMessages++;
	            var messageCtrl = messageItem.message;
	
	            var messageUsed = false;
	            if (!messageFound) {
	              forEach(collection, function(value, key) {
	                if (!messageUsed && truthy(value) && messageCtrl.test(key)) {
	                  // this is to prevent the same error name from showing up twice
	                  if (matchedKeys[key]) return;
	                  matchedKeys[key] = true;
	
	                  messageUsed = true;
	                  messageCtrl.attach();
	                }
	              });
	            }
	
	            if (messageUsed) {
	              // unless we want to display multiple messages then we should
	              // set a flag here to avoid displaying the next message in the list
	              messageFound = !multiple;
	            } else {
	              unmatchedMessages.push(messageCtrl);
	            }
	
	            messageItem = messageItem.next;
	          }
	
	          forEach(unmatchedMessages, function(messageCtrl) {
	            messageCtrl.detach();
	          });
	
	          if (unmatchedMessages.length !== totalMessages) {
	            $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS);
	          } else {
	            $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
	          }
	        };
	
	        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);
	
	        // If the element is destroyed, proactively destroy all the currently visible messages
	        $element.on('$destroy', function() {
	          forEach(messages, function(item) {
	            item.message.detach();
	          });
	        });
	
	        this.reRender = function() {
	          if (!renderLater) {
	            renderLater = true;
	            $scope.$evalAsync(function() {
	              if (renderLater && cachedCollection) {
	                ctrl.render(cachedCollection);
	              }
	            });
	          }
	        };
	
	        this.register = function(comment, messageCtrl) {
	          var nextKey = latestKey.toString();
	          messages[nextKey] = {
	            message: messageCtrl
	          };
	          insertMessageNode($element[0], comment, nextKey);
	          comment.$$ngMessageNode = nextKey;
	          latestKey++;
	
	          ctrl.reRender();
	        };
	
	        this.deregister = function(comment) {
	          var key = comment.$$ngMessageNode;
	          delete comment.$$ngMessageNode;
	          removeMessageNode($element[0], comment, key);
	          delete messages[key];
	          ctrl.reRender();
	        };
	
	        function findPreviousMessage(parent, comment) {
	          var prevNode = comment;
	          var parentLookup = [];
	
	          while (prevNode && prevNode !== parent) {
	            var prevKey = prevNode.$$ngMessageNode;
	            if (prevKey && prevKey.length) {
	              return messages[prevKey];
	            }
	
	            // dive deeper into the DOM and examine its children for any ngMessage
	            // comments that may be in an element that appears deeper in the list
	            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
	              parentLookup.push(prevNode);
	              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
	            } else if (prevNode.previousSibling) {
	              prevNode = prevNode.previousSibling;
	            } else {
	              prevNode = prevNode.parentNode;
	              parentLookup.push(prevNode);
	            }
	          }
	        }
	
	        function insertMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	          if (!ctrl.head) {
	            ctrl.head = messageNode;
	          } else {
	            var match = findPreviousMessage(parent, comment);
	            if (match) {
	              messageNode.next = match.next;
	              match.next = messageNode;
	            } else {
	              messageNode.next = ctrl.head;
	              ctrl.head = messageNode;
	            }
	          }
	        }
	
	        function removeMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	
	          var match = findPreviousMessage(parent, comment);
	          if (match) {
	            match.next = messageNode.next;
	          } else {
	            ctrl.head = messageNode.next;
	          }
	        }
	      }]
	    };
	
	    function isAttrTruthy(scope, attr) {
	     return (isString(attr) && attr.length === 0) || //empty attribute
	            truthy(scope.$eval(attr));
	    }
	
	    function truthy(val) {
	      return isString(val) ? val.length : !!val;
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessagesInclude
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
	   * code from a remote template and place the downloaded template code into the exact spot
	   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
	   * for a series of pre-defined messages to be reused and also allows for the developer to
	   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-messages-include="remoteTplString">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
	   */
	  .directive('ngMessagesInclude',
	    ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {
	
	    return {
	      restrict: 'AE',
	      require: '^^ngMessages', // we only require this for validation sake
	      link: function($scope, element, attrs) {
	        var src = attrs.ngMessagesInclude || attrs.src;
	        $templateRequest(src).then(function(html) {
	          if ($scope.$$destroyed) return;
	
	          if (isString(html) && !html.trim()) {
	            // Empty template - nothing to compile
	            replaceElementWithMarker(element, src);
	          } else {
	            // Non-empty template - compile and link
	            $compile(html)($scope, function(contents) {
	              element.after(contents);
	              replaceElementWithMarker(element, src);
	            });
	          }
	        });
	      }
	    };
	
	    // Helpers
	    function replaceElementWithMarker(element, src) {
	      // A comment marker is placed for debugging purposes
	      var comment = $compile.$$createComment ?
	          $compile.$$createComment('ngMessagesInclude', src) :
	          $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
	      var marker = jqLite(comment);
	      element.after(marker);
	
	      // Don't pollute the DOM anymore by keeping an empty directive element
	      element.remove();
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessage
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessage` is a directive with the purpose to show and hide a particular message.
	   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
	   * must be situated since it determines which messages are visible based on the state
	   * of the provided key/value map that `ngMessages` listens on.
	   *
	   * More information about using `ngMessage` can be found in the
	   * {@link module:ngMessages `ngMessages` module documentation}.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {expression} ngMessage|when a string value corresponding to the message key.
	   */
	  .directive('ngMessage', ngMessageDirectiveFactory())
	
	
	  /**
	   * @ngdoc directive
	   * @name ngMessageExp
	   * @restrict AE
	   * @priority 1
	   * @scope
	   *
	   * @description
	   * `ngMessageExp` is the same as {@link directive:ngMessage `ngMessage`}, but instead of a static
	   * value, it accepts an expression to be evaluated for the message key.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression">
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression">
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
	   */
	  .directive('ngMessageExp', ngMessageDirectiveFactory());
	
	function ngMessageDirectiveFactory() {
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AE',
	      transclude: 'element',
	      priority: 1, // must run before ngBind, otherwise the text is set on the comment
	      terminal: true,
	      require: '^^ngMessages',
	      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
	        var commentNode = element[0];
	
	        var records;
	        var staticExp = attrs.ngMessage || attrs.when;
	        var dynamicExp = attrs.ngMessageExp || attrs.whenExp;
	        var assignRecords = function(items) {
	          records = items
	              ? (isArray(items)
	                  ? items
	                  : items.split(/[\s,]+/))
	              : null;
	          ngMessagesCtrl.reRender();
	        };
	
	        if (dynamicExp) {
	          assignRecords(scope.$eval(dynamicExp));
	          scope.$watchCollection(dynamicExp, assignRecords);
	        } else {
	          assignRecords(staticExp);
	        }
	
	        var currentElement, messageCtrl;
	        ngMessagesCtrl.register(commentNode, messageCtrl = {
	          test: function(name) {
	            return contains(records, name);
	          },
	          attach: function() {
	            if (!currentElement) {
	              $transclude(function(elm, newScope) {
	                $animate.enter(elm, null, element);
	                currentElement = elm;
	
	                // Each time we attach this node to a message we get a new id that we can match
	                // when we are destroying the node later.
	                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();
	
	                // in the event that the element or a parent element is destroyed
	                // by another structural directive then it's time
	                // to deregister the message from the controller
	                currentElement.on('$destroy', function() {
	                  if (currentElement && currentElement.$$attachId === $$attachId) {
	                    ngMessagesCtrl.deregister(commentNode);
	                    messageCtrl.detach();
	                  }
	                  newScope.$destroy();
	                });
	              });
	            }
	          },
	          detach: function() {
	            if (currentElement) {
	              var elm = currentElement;
	              currentElement = null;
	              $animate.leave(elm);
	            }
	          }
	        });
	      }
	    };
	  }];
	
	  function contains(collection, key) {
	    if (collection) {
	      return isArray(collection)
	          ? collection.indexOf(key) >= 0
	          : collection.hasOwnProperty(key);
	    }
	  }
	}
	
	
	})(window, window.angular);


/***/ }),

/***/ 1082:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1083);

/***/ }),

/***/ 1083:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.11
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* global ngTouchClickDirectiveFactory: false */
	
	/**
	 * @ngdoc module
	 * @name ngTouch
	 * @description
	 *
	 * # ngTouch
	 *
	 * The `ngTouch` module provides touch events and other helpers for touch-enabled devices.
	 * The implementation is based on jQuery Mobile touch event handling
	 * ([jquerymobile.com](http://jquerymobile.com/)).
	 *
	 *
	 * See {@link ngTouch.$swipe `$swipe`} for usage.
	 *
	 * <div doc-module-components="ngTouch"></div>
	 *
	 */
	
	// define ngTouch module
	/* global -ngTouch */
	var ngTouch = angular.module('ngTouch', []);
	
	ngTouch.provider('$touch', $TouchProvider);
	
	function nodeName_(element) {
	  return angular.lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	/**
	 * @ngdoc provider
	 * @name $touchProvider
	 *
	 * @description
	 * The `$touchProvider` allows enabling / disabling {@link ngTouch.ngClick ngTouch's ngClick directive}.
	 */
	$TouchProvider.$inject = ['$provide', '$compileProvider'];
	function $TouchProvider($provide, $compileProvider) {
	
	  /**
	   * @ngdoc method
	   * @name  $touchProvider#ngClickOverrideEnabled
	   *
	   * @param {boolean=} enabled update the ngClickOverrideEnabled state if provided, otherwise just return the
	   * current ngClickOverrideEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable {@link ngTouch.ngClick ngTouch's ngClick directive}. If enabled,
	   * the default ngClick directive will be replaced by a version that eliminates the 300ms delay for
	   * click events on browser for touch-devices.
	   *
	   * The default is `false`.
	   *
	   */
	  var ngClickOverrideEnabled = false;
	  var ngClickDirectiveAdded = false;
	  // eslint-disable-next-line no-invalid-this
	  this.ngClickOverrideEnabled = function(enabled) {
	    if (angular.isDefined(enabled)) {
	
	      if (enabled && !ngClickDirectiveAdded) {
	        ngClickDirectiveAdded = true;
	
	        // Use this to identify the correct directive in the delegate
	        ngTouchClickDirectiveFactory.$$moduleName = 'ngTouch';
	        $compileProvider.directive('ngClick', ngTouchClickDirectiveFactory);
	
	        $provide.decorator('ngClickDirective', ['$delegate', function($delegate) {
	          if (ngClickOverrideEnabled) {
	            // drop the default ngClick directive
	            $delegate.shift();
	          } else {
	            // drop the ngTouch ngClick directive if the override has been re-disabled (because
	            // we cannot de-register added directives)
	            var i = $delegate.length - 1;
	            while (i >= 0) {
	              if ($delegate[i].$$moduleName === 'ngTouch') {
	                $delegate.splice(i, 1);
	                break;
	              }
	              i--;
	            }
	          }
	
	          return $delegate;
	        }]);
	      }
	
	      ngClickOverrideEnabled = enabled;
	      return this;
	    }
	
	    return ngClickOverrideEnabled;
	  };
	
	  /**
	  * @ngdoc service
	  * @name $touch
	  * @kind object
	  *
	  * @description
	  * Provides the {@link ngTouch.$touch#ngClickOverrideEnabled `ngClickOverrideEnabled`} method.
	  *
	  */
	  // eslint-disable-next-line no-invalid-this
	  this.$get = function() {
	    return {
	      /**
	       * @ngdoc method
	       * @name  $touch#ngClickOverrideEnabled
	       *
	       * @returns {*} current value of `ngClickOverrideEnabled` set in the {@link ngTouch.$touchProvider $touchProvider},
	       * i.e. if {@link ngTouch.ngClick ngTouch's ngClick} directive is enabled.
	       *
	       * @kind function
	       */
	      ngClickOverrideEnabled: function() {
	        return ngClickOverrideEnabled;
	      }
	    };
	  };
	
	}
	
	/* global ngTouch: false */
	
	    /**
	     * @ngdoc service
	     * @name $swipe
	     *
	     * @description
	     * The `$swipe` service is a service that abstracts the messier details of hold-and-drag swipe
	     * behavior, to make implementing swipe-related directives more convenient.
	     *
	     * Requires the {@link ngTouch `ngTouch`} module to be installed.
	     *
	     * `$swipe` is used by the `ngSwipeLeft` and `ngSwipeRight` directives in `ngTouch`.
	     *
	     * # Usage
	     * The `$swipe` service is an object with a single method: `bind`. `bind` takes an element
	     * which is to be watched for swipes, and an object with four handler functions. See the
	     * documentation for `bind` below.
	     */
	
	ngTouch.factory('$swipe', [function() {
	  // The total distance in any direction before we make the call on swipe vs. scroll.
	  var MOVE_BUFFER_RADIUS = 10;
	
	  var POINTER_EVENTS = {
	    'mouse': {
	      start: 'mousedown',
	      move: 'mousemove',
	      end: 'mouseup'
	    },
	    'touch': {
	      start: 'touchstart',
	      move: 'touchmove',
	      end: 'touchend',
	      cancel: 'touchcancel'
	    },
	    'pointer': {
	      start: 'pointerdown',
	      move: 'pointermove',
	      end: 'pointerup',
	      cancel: 'pointercancel'
	    }
	  };
	
	  function getCoordinates(event) {
	    var originalEvent = event.originalEvent || event;
	    var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
	    var e = (originalEvent.changedTouches && originalEvent.changedTouches[0]) || touches[0];
	
	    return {
	      x: e.clientX,
	      y: e.clientY
	    };
	  }
	
	  function getEvents(pointerTypes, eventType) {
	    var res = [];
	    angular.forEach(pointerTypes, function(pointerType) {
	      var eventName = POINTER_EVENTS[pointerType][eventType];
	      if (eventName) {
	        res.push(eventName);
	      }
	    });
	    return res.join(' ');
	  }
	
	  return {
	    /**
	     * @ngdoc method
	     * @name $swipe#bind
	     *
	     * @description
	     * The main method of `$swipe`. It takes an element to be watched for swipe motions, and an
	     * object containing event handlers.
	     * The pointer types that should be used can be specified via the optional
	     * third argument, which is an array of strings `'mouse'`, `'touch'` and `'pointer'`. By default,
	     * `$swipe` will listen for `mouse`, `touch` and `pointer` events.
	     *
	     * The four events are `start`, `move`, `end`, and `cancel`. `start`, `move`, and `end`
	     * receive as a parameter a coordinates object of the form `{ x: 150, y: 310 }` and the raw
	     * `event`. `cancel` receives the raw `event` as its single parameter.
	     *
	     * `start` is called on either `mousedown`, `touchstart` or `pointerdown`. After this event, `$swipe` is
	     * watching for `touchmove`, `mousemove` or `pointermove` events. These events are ignored until the total
	     * distance moved in either dimension exceeds a small threshold.
	     *
	     * Once this threshold is exceeded, either the horizontal or vertical delta is greater.
	     * - If the horizontal distance is greater, this is a swipe and `move` and `end` events follow.
	     * - If the vertical distance is greater, this is a scroll, and we let the browser take over.
	     *   A `cancel` event is sent.
	     *
	     * `move` is called on `mousemove`, `touchmove` and `pointermove` after the above logic has determined that
	     * a swipe is in progress.
	     *
	     * `end` is called when a swipe is successfully completed with a `touchend`, `mouseup` or `pointerup`.
	     *
	     * `cancel` is called either on a `touchcancel` or `pointercancel`  from the browser, or when we begin scrolling
	     * as described above.
	     *
	     */
	    bind: function(element, eventHandlers, pointerTypes) {
	      // Absolute total movement, used to control swipe vs. scroll.
	      var totalX, totalY;
	      // Coordinates of the start position.
	      var startCoords;
	      // Last event's position.
	      var lastPos;
	      // Whether a swipe is active.
	      var active = false;
	
	      pointerTypes = pointerTypes || ['mouse', 'touch', 'pointer'];
	      element.on(getEvents(pointerTypes, 'start'), function(event) {
	        startCoords = getCoordinates(event);
	        active = true;
	        totalX = 0;
	        totalY = 0;
	        lastPos = startCoords;
	        if (eventHandlers['start']) {
	          eventHandlers['start'](startCoords, event);
	        }
	      });
	      var events = getEvents(pointerTypes, 'cancel');
	      if (events) {
	        element.on(events, function(event) {
	          active = false;
	          if (eventHandlers['cancel']) {
	            eventHandlers['cancel'](event);
	          }
	        });
	      }
	
	      element.on(getEvents(pointerTypes, 'move'), function(event) {
	        if (!active) return;
	
	        // Android will send a touchcancel if it thinks we're starting to scroll.
	        // So when the total distance (+ or - or both) exceeds 10px in either direction,
	        // we either:
	        // - On totalX > totalY, we send preventDefault() and treat this as a swipe.
	        // - On totalY > totalX, we let the browser handle it as a scroll.
	
	        if (!startCoords) return;
	        var coords = getCoordinates(event);
	
	        totalX += Math.abs(coords.x - lastPos.x);
	        totalY += Math.abs(coords.y - lastPos.y);
	
	        lastPos = coords;
	
	        if (totalX < MOVE_BUFFER_RADIUS && totalY < MOVE_BUFFER_RADIUS) {
	          return;
	        }
	
	        // One of totalX or totalY has exceeded the buffer, so decide on swipe vs. scroll.
	        if (totalY > totalX) {
	          // Allow native scrolling to take over.
	          active = false;
	          if (eventHandlers['cancel']) {
	            eventHandlers['cancel'](event);
	          }
	          return;
	        } else {
	          // Prevent the browser from scrolling.
	          event.preventDefault();
	          if (eventHandlers['move']) {
	            eventHandlers['move'](coords, event);
	          }
	        }
	      });
	
	      element.on(getEvents(pointerTypes, 'end'), function(event) {
	        if (!active) return;
	        active = false;
	        if (eventHandlers['end']) {
	          eventHandlers['end'](getCoordinates(event), event);
	        }
	      });
	    }
	  };
	}]);
	
	/* global ngTouch: false,
	  nodeName_: false
	*/
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 * @deprecated
	 * sinceVersion="v1.5.0"
	 * This directive is deprecated and **disabled** by default.
	 * The directive will receive no further support and might be removed from future releases.
	 * If you need the directive, you can enable it with the {@link ngTouch.$touchProvider $touchProvider#ngClickOverrideEnabled}
	 * function. We also recommend that you migrate to [FastClick](https://github.com/ftlabs/fastclick).
	 * To learn more about the 300ms delay, this [Telerik article](http://developer.telerik.com/featured/300-ms-click-delay-ios-8/)
	 * gives a good overview.
	 *
	 * @description
	 * A more powerful replacement for the default ngClick designed to be used on touchscreen
	 * devices. Most mobile browsers wait about 300ms after a tap-and-release before sending
	 * the click event. This version handles them immediately, and then prevents the
	 * following click event from propagating.
	 *
	 * Requires the {@link ngTouch `ngTouch`} module to be installed.
	 *
	 * This directive can fall back to using an ordinary click event, and so works on desktop
	 * browsers as well as mobile.
	 *
	 * This directive also sets the CSS class `ng-click-active` while the element is being held
	 * down (by a mouse click or touch) so you can restyle the depressed element if you wish.
	 *
	 * @element ANY
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate
	 * upon tap. (Event object is available as `$event`)
	 *
	 * @example
	    <example module="ngClickExample" deps="angular-touch.js" name="ng-touch-ng-click">
	      <file name="index.html">
	        <button ng-click="count = count + 1" ng-init="count=0">
	          Increment
	        </button>
	        count: {{ count }}
	      </file>
	      <file name="script.js">
	        angular.module('ngClickExample', ['ngTouch']);
	      </file>
	    </example>
	 */
	
	var ngTouchClickDirectiveFactory = ['$parse', '$timeout', '$rootElement',
	    function($parse, $timeout, $rootElement) {
	  var TAP_DURATION = 750; // Shorter than 750ms is a tap, longer is a taphold or drag.
	  var MOVE_TOLERANCE = 12; // 12px seems to work in most mobile browsers.
	  var PREVENT_DURATION = 2500; // 2.5 seconds maximum from preventGhostClick call to click
	  var CLICKBUSTER_THRESHOLD = 25; // 25 pixels in any dimension is the limit for busting clicks.
	
	  var ACTIVE_CLASS_NAME = 'ng-click-active';
	  var lastPreventedTime;
	  var touchCoordinates;
	  var lastLabelClickCoordinates;
	
	
	  // TAP EVENTS AND GHOST CLICKS
	  //
	  // Why tap events?
	  // Mobile browsers detect a tap, then wait a moment (usually ~300ms) to see if you're
	  // double-tapping, and then fire a click event.
	  //
	  // This delay sucks and makes mobile apps feel unresponsive.
	  // So we detect touchstart, touchcancel and touchend ourselves and determine when
	  // the user has tapped on something.
	  //
	  // What happens when the browser then generates a click event?
	  // The browser, of course, also detects the tap and fires a click after a delay. This results in
	  // tapping/clicking twice. We do "clickbusting" to prevent it.
	  //
	  // How does it work?
	  // We attach global touchstart and click handlers, that run during the capture (early) phase.
	  // So the sequence for a tap is:
	  // - global touchstart: Sets an "allowable region" at the point touched.
	  // - element's touchstart: Starts a touch
	  // (- touchcancel ends the touch, no click follows)
	  // - element's touchend: Determines if the tap is valid (didn't move too far away, didn't hold
	  //   too long) and fires the user's tap handler. The touchend also calls preventGhostClick().
	  // - preventGhostClick() removes the allowable region the global touchstart created.
	  // - The browser generates a click event.
	  // - The global click handler catches the click, and checks whether it was in an allowable region.
	  //     - If preventGhostClick was called, the region will have been removed, the click is busted.
	  //     - If the region is still there, the click proceeds normally. Therefore clicks on links and
	  //       other elements without ngTap on them work normally.
	  //
	  // This is an ugly, terrible hack!
	  // Yeah, tell me about it. The alternatives are using the slow click events, or making our users
	  // deal with the ghost clicks, so I consider this the least of evils. Fortunately Angular
	  // encapsulates this ugly logic away from the user.
	  //
	  // Why not just put click handlers on the element?
	  // We do that too, just to be sure. If the tap event caused the DOM to change,
	  // it is possible another element is now in that position. To take account for these possibly
	  // distinct elements, the handlers are global and care only about coordinates.
	
	  // Checks if the coordinates are close enough to be within the region.
	  function hit(x1, y1, x2, y2) {
	    return Math.abs(x1 - x2) < CLICKBUSTER_THRESHOLD && Math.abs(y1 - y2) < CLICKBUSTER_THRESHOLD;
	  }
	
	  // Checks a list of allowable regions against a click location.
	  // Returns true if the click should be allowed.
	  // Splices out the allowable region from the list after it has been used.
	  function checkAllowableRegions(touchCoordinates, x, y) {
	    for (var i = 0; i < touchCoordinates.length; i += 2) {
	      if (hit(touchCoordinates[i], touchCoordinates[i + 1], x, y)) {
	        touchCoordinates.splice(i, i + 2);
	        return true; // allowable region
	      }
	    }
	    return false; // No allowable region; bust it.
	  }
	
	  // Global click handler that prevents the click if it's in a bustable zone and preventGhostClick
	  // was called recently.
	  function onClick(event) {
	    if (Date.now() - lastPreventedTime > PREVENT_DURATION) {
	      return; // Too old.
	    }
	
	    var touches = event.touches && event.touches.length ? event.touches : [event];
	    var x = touches[0].clientX;
	    var y = touches[0].clientY;
	    // Work around desktop Webkit quirk where clicking a label will fire two clicks (on the label
	    // and on the input element). Depending on the exact browser, this second click we don't want
	    // to bust has either (0,0), negative coordinates, or coordinates equal to triggering label
	    // click event
	    if (x < 1 && y < 1) {
	      return; // offscreen
	    }
	    if (lastLabelClickCoordinates &&
	        lastLabelClickCoordinates[0] === x && lastLabelClickCoordinates[1] === y) {
	      return; // input click triggered by label click
	    }
	    // reset label click coordinates on first subsequent click
	    if (lastLabelClickCoordinates) {
	      lastLabelClickCoordinates = null;
	    }
	    // remember label click coordinates to prevent click busting of trigger click event on input
	    if (nodeName_(event.target) === 'label') {
	      lastLabelClickCoordinates = [x, y];
	    }
	
	    // Look for an allowable region containing this click.
	    // If we find one, that means it was created by touchstart and not removed by
	    // preventGhostClick, so we don't bust it.
	    if (checkAllowableRegions(touchCoordinates, x, y)) {
	      return;
	    }
	
	    // If we didn't find an allowable region, bust the click.
	    event.stopPropagation();
	    event.preventDefault();
	
	    // Blur focused form elements
	    if (event.target && event.target.blur) {
	      event.target.blur();
	    }
	  }
	
	
	  // Global touchstart handler that creates an allowable region for a click event.
	  // This allowable region can be removed by preventGhostClick if we want to bust it.
	  function onTouchStart(event) {
	    var touches = event.touches && event.touches.length ? event.touches : [event];
	    var x = touches[0].clientX;
	    var y = touches[0].clientY;
	    touchCoordinates.push(x, y);
	
	    $timeout(function() {
	      // Remove the allowable region.
	      for (var i = 0; i < touchCoordinates.length; i += 2) {
	        if (touchCoordinates[i] === x && touchCoordinates[i + 1] === y) {
	          touchCoordinates.splice(i, i + 2);
	          return;
	        }
	      }
	    }, PREVENT_DURATION, false);
	  }
	
	  // On the first call, attaches some event handlers. Then whenever it gets called, it creates a
	  // zone around the touchstart where clicks will get busted.
	  function preventGhostClick(x, y) {
	    if (!touchCoordinates) {
	      $rootElement[0].addEventListener('click', onClick, true);
	      $rootElement[0].addEventListener('touchstart', onTouchStart, true);
	      touchCoordinates = [];
	    }
	
	    lastPreventedTime = Date.now();
	
	    checkAllowableRegions(touchCoordinates, x, y);
	  }
	
	  // Actual linking function.
	  return function(scope, element, attr) {
	    var clickHandler = $parse(attr.ngClick),
	        tapping = false,
	        tapElement,  // Used to blur the element after a tap.
	        startTime,   // Used to check if the tap was held too long.
	        touchStartX,
	        touchStartY;
	
	    function resetState() {
	      tapping = false;
	      element.removeClass(ACTIVE_CLASS_NAME);
	    }
	
	    element.on('touchstart', function(event) {
	      tapping = true;
	      tapElement = event.target ? event.target : event.srcElement; // IE uses srcElement.
	      // Hack for Safari, which can target text nodes instead of containers.
	      if (tapElement.nodeType === 3) {
	        tapElement = tapElement.parentNode;
	      }
	
	      element.addClass(ACTIVE_CLASS_NAME);
	
	      startTime = Date.now();
	
	      // Use jQuery originalEvent
	      var originalEvent = event.originalEvent || event;
	      var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
	      var e = touches[0];
	      touchStartX = e.clientX;
	      touchStartY = e.clientY;
	    });
	
	    element.on('touchcancel', function(event) {
	      resetState();
	    });
	
	    element.on('touchend', function(event) {
	      var diff = Date.now() - startTime;
	
	      // Use jQuery originalEvent
	      var originalEvent = event.originalEvent || event;
	      var touches = (originalEvent.changedTouches && originalEvent.changedTouches.length) ?
	          originalEvent.changedTouches :
	          ((originalEvent.touches && originalEvent.touches.length) ? originalEvent.touches : [originalEvent]);
	      var e = touches[0];
	      var x = e.clientX;
	      var y = e.clientY;
	      var dist = Math.sqrt(Math.pow(x - touchStartX, 2) + Math.pow(y - touchStartY, 2));
	
	      if (tapping && diff < TAP_DURATION && dist < MOVE_TOLERANCE) {
	        // Call preventGhostClick so the clickbuster will catch the corresponding click.
	        preventGhostClick(x, y);
	
	        // Blur the focused element (the button, probably) before firing the callback.
	        // This doesn't work perfectly on Android Chrome, but seems to work elsewhere.
	        // I couldn't get anything to work reliably on Android Chrome.
	        if (tapElement) {
	          tapElement.blur();
	        }
	
	        if (!angular.isDefined(attr.disabled) || attr.disabled === false) {
	          element.triggerHandler('click', [event]);
	        }
	      }
	
	      resetState();
	    });
	
	    // Hack for iOS Safari's benefit. It goes searching for onclick handlers and is liable to click
	    // something else nearby.
	    element.onclick = function(event) { };
	
	    // Actual click handler.
	    // There are three different kinds of clicks, only two of which reach this point.
	    // - On desktop browsers without touch events, their clicks will always come here.
	    // - On mobile browsers, the simulated "fast" click will call this.
	    // - But the browser's follow-up slow click will be "busted" before it reaches this handler.
	    // Therefore it's safe to use this directive on both mobile and desktop.
	    element.on('click', function(event, touchend) {
	      scope.$apply(function() {
	        clickHandler(scope, {$event: (touchend || event)});
	      });
	    });
	
	    element.on('mousedown', function(event) {
	      element.addClass(ACTIVE_CLASS_NAME);
	    });
	
	    element.on('mousemove mouseup', function(event) {
	      element.removeClass(ACTIVE_CLASS_NAME);
	    });
	
	  };
	}];
	
	/* global ngTouch: false */
	
	/**
	 * @ngdoc directive
	 * @name ngSwipeLeft
	 *
	 * @description
	 * Specify custom behavior when an element is swiped to the left on a touchscreen device.
	 * A leftward swipe is a quick, right-to-left slide of the finger.
	 * Though ngSwipeLeft is designed for touch-based devices, it will work with a mouse click and drag
	 * too.
	 *
	 * To disable the mouse click and drag functionality, add `ng-swipe-disable-mouse` to
	 * the `ng-swipe-left` or `ng-swipe-right` DOM Element.
	 *
	 * Requires the {@link ngTouch `ngTouch`} module to be installed.
	 *
	 * @element ANY
	 * @param {expression} ngSwipeLeft {@link guide/expression Expression} to evaluate
	 * upon left swipe. (Event object is available as `$event`)
	 *
	 * @example
	    <example module="ngSwipeLeftExample" deps="angular-touch.js" name="ng-swipe-left">
	      <file name="index.html">
	        <div ng-show="!showActions" ng-swipe-left="showActions = true">
	          Some list content, like an email in the inbox
	        </div>
	        <div ng-show="showActions" ng-swipe-right="showActions = false">
	          <button ng-click="reply()">Reply</button>
	          <button ng-click="delete()">Delete</button>
	        </div>
	      </file>
	      <file name="script.js">
	        angular.module('ngSwipeLeftExample', ['ngTouch']);
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSwipeRight
	 *
	 * @description
	 * Specify custom behavior when an element is swiped to the right on a touchscreen device.
	 * A rightward swipe is a quick, left-to-right slide of the finger.
	 * Though ngSwipeRight is designed for touch-based devices, it will work with a mouse click and drag
	 * too.
	 *
	 * Requires the {@link ngTouch `ngTouch`} module to be installed.
	 *
	 * @element ANY
	 * @param {expression} ngSwipeRight {@link guide/expression Expression} to evaluate
	 * upon right swipe. (Event object is available as `$event`)
	 *
	 * @example
	    <example module="ngSwipeRightExample" deps="angular-touch.js" name="ng-swipe-right">
	      <file name="index.html">
	        <div ng-show="!showActions" ng-swipe-left="showActions = true">
	          Some list content, like an email in the inbox
	        </div>
	        <div ng-show="showActions" ng-swipe-right="showActions = false">
	          <button ng-click="reply()">Reply</button>
	          <button ng-click="delete()">Delete</button>
	        </div>
	      </file>
	      <file name="script.js">
	        angular.module('ngSwipeRightExample', ['ngTouch']);
	      </file>
	    </example>
	 */
	
	function makeSwipeDirective(directiveName, direction, eventName) {
	  ngTouch.directive(directiveName, ['$parse', '$swipe', function($parse, $swipe) {
	    // The maximum vertical delta for a swipe should be less than 75px.
	    var MAX_VERTICAL_DISTANCE = 75;
	    // Vertical distance should not be more than a fraction of the horizontal distance.
	    var MAX_VERTICAL_RATIO = 0.3;
	    // At least a 30px lateral motion is necessary for a swipe.
	    var MIN_HORIZONTAL_DISTANCE = 30;
	
	    return function(scope, element, attr) {
	      var swipeHandler = $parse(attr[directiveName]);
	
	      var startCoords, valid;
	
	      function validSwipe(coords) {
	        // Check that it's within the coordinates.
	        // Absolute vertical distance must be within tolerances.
	        // Horizontal distance, we take the current X - the starting X.
	        // This is negative for leftward swipes and positive for rightward swipes.
	        // After multiplying by the direction (-1 for left, +1 for right), legal swipes
	        // (ie. same direction as the directive wants) will have a positive delta and
	        // illegal ones a negative delta.
	        // Therefore this delta must be positive, and larger than the minimum.
	        if (!startCoords) return false;
	        var deltaY = Math.abs(coords.y - startCoords.y);
	        var deltaX = (coords.x - startCoords.x) * direction;
	        return valid && // Short circuit for already-invalidated swipes.
	            deltaY < MAX_VERTICAL_DISTANCE &&
	            deltaX > 0 &&
	            deltaX > MIN_HORIZONTAL_DISTANCE &&
	            deltaY / deltaX < MAX_VERTICAL_RATIO;
	      }
	
	      var pointerTypes = ['touch'];
	      if (!angular.isDefined(attr['ngSwipeDisableMouse'])) {
	        pointerTypes.push('mouse');
	      }
	      $swipe.bind(element, {
	        'start': function(coords, event) {
	          startCoords = coords;
	          valid = true;
	        },
	        'cancel': function(event) {
	          valid = false;
	        },
	        'end': function(coords, event) {
	          if (validSwipe(coords)) {
	            scope.$apply(function() {
	              element.triggerHandler(eventName);
	              swipeHandler(scope, {$event: event});
	            });
	          }
	        }
	      }, pointerTypes);
	    };
	  }]);
	}
	
	// Left is negative X-coordinate, right is positive.
	makeSwipeDirective('ngSwipeLeft', -1, 'swipeleft');
	makeSwipeDirective('ngSwipeRight', 1, 'swiperight');
	
	
	
	})(window, window.angular);


/***/ }),

/***/ 1084:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1085);
	__webpack_require__(1086);

/***/ }),

/***/ 1085:
/***/ (function(module, exports) {

	/*! ngImgCrop v0.2.0 License: MIT */!function(){"use strict";var e=angular.module("ngImgCrop",[]);e.factory("cropAreaCircle",["cropArea",function(e){var t=function(){e.apply(this,arguments),this._boxResizeBaseSize=20,this._boxResizeNormalRatio=.9,this._boxResizeHoverRatio=1.2,this._iconMoveNormalRatio=.9,this._iconMoveHoverRatio=1.2,this._boxResizeNormalSize=this._boxResizeBaseSize*this._boxResizeNormalRatio,this._boxResizeHoverSize=this._boxResizeBaseSize*this._boxResizeHoverRatio,this._posDragStartX=0,this._posDragStartY=0,this._posResizeStartX=0,this._posResizeStartY=0,this._posResizeStartSize=0,this._boxResizeIsHover=!1,this._areaIsHover=!1,this._boxResizeIsDragging=!1,this._areaIsDragging=!1};return t.prototype=new e,t.prototype._calcCirclePerimeterCoords=function(e){var t=this._size/2,i=e*(Math.PI/180),s=this._x+t*Math.cos(i),r=this._y+t*Math.sin(i);return[s,r]},t.prototype._calcResizeIconCenterCoords=function(){return this._calcCirclePerimeterCoords(-45)},t.prototype._isCoordWithinArea=function(e){return Math.sqrt((e[0]-this._x)*(e[0]-this._x)+(e[1]-this._y)*(e[1]-this._y))<this._size/2},t.prototype._isCoordWithinBoxResize=function(e){var t=this._calcResizeIconCenterCoords(),i=this._boxResizeHoverSize/2;return e[0]>t[0]-i&&e[0]<t[0]+i&&e[1]>t[1]-i&&e[1]<t[1]+i},t.prototype._drawArea=function(e,t,i){e.arc(t[0],t[1],i/2,0,2*Math.PI)},t.prototype.draw=function(){e.prototype.draw.apply(this,arguments),this._cropCanvas.drawIconMove([this._x,this._y],this._areaIsHover?this._iconMoveHoverRatio:this._iconMoveNormalRatio),this._cropCanvas.drawIconResizeBoxNESW(this._calcResizeIconCenterCoords(),this._boxResizeBaseSize,this._boxResizeIsHover?this._boxResizeHoverRatio:this._boxResizeNormalRatio)},t.prototype.processMouseMove=function(e,t){var i="default",s=!1;if(this._boxResizeIsHover=!1,this._areaIsHover=!1,this._areaIsDragging)this._x=e-this._posDragStartX,this._y=t-this._posDragStartY,this._areaIsHover=!0,i="move",s=!0,this._events.trigger("area-move");else if(this._boxResizeIsDragging){i="nesw-resize";var r,o,a;o=e-this._posResizeStartX,a=this._posResizeStartY-t,r=o>a?this._posResizeStartSize+2*a:this._posResizeStartSize+2*o,this._size=Math.max(this._minSize,r),this._boxResizeIsHover=!0,s=!0,this._events.trigger("area-resize")}else this._isCoordWithinBoxResize([e,t])?(i="nesw-resize",this._areaIsHover=!1,this._boxResizeIsHover=!0,s=!0):this._isCoordWithinArea([e,t])&&(i="move",this._areaIsHover=!0,s=!0);return this._dontDragOutside(),angular.element(this._ctx.canvas).css({cursor:i}),s},t.prototype.processMouseDown=function(e,t){this._isCoordWithinBoxResize([e,t])?(this._areaIsDragging=!1,this._areaIsHover=!1,this._boxResizeIsDragging=!0,this._boxResizeIsHover=!0,this._posResizeStartX=e,this._posResizeStartY=t,this._posResizeStartSize=this._size,this._events.trigger("area-resize-start")):this._isCoordWithinArea([e,t])&&(this._areaIsDragging=!0,this._areaIsHover=!0,this._boxResizeIsDragging=!1,this._boxResizeIsHover=!1,this._posDragStartX=e-this._x,this._posDragStartY=t-this._y,this._events.trigger("area-move-start"))},t.prototype.processMouseUp=function(){this._areaIsDragging&&(this._areaIsDragging=!1,this._events.trigger("area-move-end")),this._boxResizeIsDragging&&(this._boxResizeIsDragging=!1,this._events.trigger("area-resize-end")),this._areaIsHover=!1,this._boxResizeIsHover=!1,this._posDragStartX=0,this._posDragStartY=0},t}]),e.factory("cropAreaSquare",["cropArea",function(e){var t=function(){e.apply(this,arguments),this._resizeCtrlBaseRadius=10,this._resizeCtrlNormalRatio=.75,this._resizeCtrlHoverRatio=1,this._iconMoveNormalRatio=.9,this._iconMoveHoverRatio=1.2,this._resizeCtrlNormalRadius=this._resizeCtrlBaseRadius*this._resizeCtrlNormalRatio,this._resizeCtrlHoverRadius=this._resizeCtrlBaseRadius*this._resizeCtrlHoverRatio,this._posDragStartX=0,this._posDragStartY=0,this._posResizeStartX=0,this._posResizeStartY=0,this._posResizeStartSize=0,this._resizeCtrlIsHover=-1,this._areaIsHover=!1,this._resizeCtrlIsDragging=-1,this._areaIsDragging=!1};return t.prototype=new e,t.prototype._calcSquareCorners=function(){var e=this._size/2;return[[this._x-e,this._y-e],[this._x+e,this._y-e],[this._x-e,this._y+e],[this._x+e,this._y+e]]},t.prototype._calcSquareDimensions=function(){var e=this._size/2;return{left:this._x-e,top:this._y-e,right:this._x+e,bottom:this._y+e}},t.prototype._isCoordWithinArea=function(e){var t=this._calcSquareDimensions();return e[0]>=t.left&&e[0]<=t.right&&e[1]>=t.top&&e[1]<=t.bottom},t.prototype._isCoordWithinResizeCtrl=function(e){for(var t=this._calcSquareCorners(),i=-1,s=0,r=t.length;r>s;s++){var o=t[s];if(e[0]>o[0]-this._resizeCtrlHoverRadius&&e[0]<o[0]+this._resizeCtrlHoverRadius&&e[1]>o[1]-this._resizeCtrlHoverRadius&&e[1]<o[1]+this._resizeCtrlHoverRadius){i=s;break}}return i},t.prototype._drawArea=function(e,t,i){var s=i/2;e.rect(t[0]-s,t[1]-s,i,i)},t.prototype.draw=function(){e.prototype.draw.apply(this,arguments),this._cropCanvas.drawIconMove([this._x,this._y],this._areaIsHover?this._iconMoveHoverRatio:this._iconMoveNormalRatio);for(var t=this._calcSquareCorners(),i=0,s=t.length;s>i;i++){var r=t[i];this._cropCanvas.drawIconResizeCircle(r,this._resizeCtrlBaseRadius,this._resizeCtrlIsHover===i?this._resizeCtrlHoverRatio:this._resizeCtrlNormalRatio)}},t.prototype.processMouseMove=function(e,t){var i="default",s=!1;if(this._resizeCtrlIsHover=-1,this._areaIsHover=!1,this._areaIsDragging)this._x=e-this._posDragStartX,this._y=t-this._posDragStartY,this._areaIsHover=!0,i="move",s=!0,this._events.trigger("area-move");else if(this._resizeCtrlIsDragging>-1){var r,o;switch(this._resizeCtrlIsDragging){case 0:r=-1,o=-1,i="nwse-resize";break;case 1:r=1,o=-1,i="nesw-resize";break;case 2:r=-1,o=1,i="nesw-resize";break;case 3:r=1,o=1,i="nwse-resize"}var a,n=(e-this._posResizeStartX)*r,h=(t-this._posResizeStartY)*o;a=n>h?this._posResizeStartSize+h:this._posResizeStartSize+n;var c=this._size;this._size=Math.max(this._minSize,a);var _=(this._size-c)/2;this._x+=_*r,this._y+=_*o,this._resizeCtrlIsHover=this._resizeCtrlIsDragging,s=!0,this._events.trigger("area-resize")}else{var g=this._isCoordWithinResizeCtrl([e,t]);if(g>-1){switch(g){case 0:i="nwse-resize";break;case 1:i="nesw-resize";break;case 2:i="nesw-resize";break;case 3:i="nwse-resize"}this._areaIsHover=!1,this._resizeCtrlIsHover=g,s=!0}else this._isCoordWithinArea([e,t])&&(i="move",this._areaIsHover=!0,s=!0)}return this._dontDragOutside(),angular.element(this._ctx.canvas).css({cursor:i}),s},t.prototype.processMouseDown=function(e,t){var i=this._isCoordWithinResizeCtrl([e,t]);i>-1?(this._areaIsDragging=!1,this._areaIsHover=!1,this._resizeCtrlIsDragging=i,this._resizeCtrlIsHover=i,this._posResizeStartX=e,this._posResizeStartY=t,this._posResizeStartSize=this._size,this._events.trigger("area-resize-start")):this._isCoordWithinArea([e,t])&&(this._areaIsDragging=!0,this._areaIsHover=!0,this._resizeCtrlIsDragging=-1,this._resizeCtrlIsHover=-1,this._posDragStartX=e-this._x,this._posDragStartY=t-this._y,this._events.trigger("area-move-start"))},t.prototype.processMouseUp=function(){this._areaIsDragging&&(this._areaIsDragging=!1,this._events.trigger("area-move-end")),this._resizeCtrlIsDragging>-1&&(this._resizeCtrlIsDragging=-1,this._events.trigger("area-resize-end")),this._areaIsHover=!1,this._resizeCtrlIsHover=-1,this._posDragStartX=0,this._posDragStartY=0},t}]),e.factory("cropArea",["cropCanvas",function(e){var t=function(t,i){this._ctx=t,this._events=i,this._minSize=80,this._cropCanvas=new e(t),this._image=new Image,this._x=0,this._y=0,this._size=200};return t.prototype.getImage=function(){return this._image},t.prototype.setImage=function(e){this._image=e},t.prototype.getX=function(){return this._x},t.prototype.setX=function(e){this._x=e,this._dontDragOutside()},t.prototype.getY=function(){return this._y},t.prototype.setY=function(e){this._y=e,this._dontDragOutside()},t.prototype.getSize=function(){return this._size},t.prototype.setSize=function(e){this._size=Math.max(this._minSize,e),this._dontDragOutside()},t.prototype.getMinSize=function(){return this._minSize},t.prototype.setMinSize=function(e){this._minSize=e,this._size=Math.max(this._minSize,this._size),this._dontDragOutside()},t.prototype._dontDragOutside=function(){var e=this._ctx.canvas.height,t=this._ctx.canvas.width;this._size>t&&(this._size=t),this._size>e&&(this._size=e),this._x<this._size/2&&(this._x=this._size/2),this._x>t-this._size/2&&(this._x=t-this._size/2),this._y<this._size/2&&(this._y=this._size/2),this._y>e-this._size/2&&(this._y=e-this._size/2)},t.prototype._drawArea=function(){},t.prototype.draw=function(){this._cropCanvas.drawCropArea(this._image,[this._x,this._y],this._size,this._drawArea)},t.prototype.processMouseMove=function(){},t.prototype.processMouseDown=function(){},t.prototype.processMouseUp=function(){},t}]),e.factory("cropCanvas",[function(){var e=[[-.5,-2],[-3,-4.5],[-.5,-7],[-7,-7],[-7,-.5],[-4.5,-3],[-2,-.5]],t=[[.5,-2],[3,-4.5],[.5,-7],[7,-7],[7,-.5],[4.5,-3],[2,-.5]],i=[[-.5,2],[-3,4.5],[-.5,7],[-7,7],[-7,.5],[-4.5,3],[-2,.5]],s=[[.5,2],[3,4.5],[.5,7],[7,7],[7,.5],[4.5,3],[2,.5]],r=[[-1.5,-2.5],[-1.5,-6],[-5,-6],[0,-11],[5,-6],[1.5,-6],[1.5,-2.5]],o=[[-2.5,-1.5],[-6,-1.5],[-6,-5],[-11,0],[-6,5],[-6,1.5],[-2.5,1.5]],a=[[-1.5,2.5],[-1.5,6],[-5,6],[0,11],[5,6],[1.5,6],[1.5,2.5]],n=[[2.5,-1.5],[6,-1.5],[6,-5],[11,0],[6,5],[6,1.5],[2.5,1.5]],h={areaOutline:"#fff",resizeBoxStroke:"#fff",resizeBoxFill:"#444",resizeBoxArrowFill:"#fff",resizeCircleStroke:"#fff",resizeCircleFill:"#444",moveIconFill:"#fff"};return function(c){var _=function(e,t,i){return[i*e[0]+t[0],i*e[1]+t[1]]},g=function(e,t,i,s){c.save(),c.fillStyle=t,c.beginPath();var r,o=_(e[0],i,s);c.moveTo(o[0],o[1]);for(var a in e)a>0&&(r=_(e[a],i,s),c.lineTo(r[0],r[1]));c.lineTo(o[0],o[1]),c.fill(),c.closePath(),c.restore()};this.drawIconMove=function(e,t){g(r,h.moveIconFill,e,t),g(o,h.moveIconFill,e,t),g(a,h.moveIconFill,e,t),g(n,h.moveIconFill,e,t)},this.drawIconResizeCircle=function(e,t,i){var s=t*i;c.save(),c.strokeStyle=h.resizeCircleStroke,c.lineWidth=2,c.fillStyle=h.resizeCircleFill,c.beginPath(),c.arc(e[0],e[1],s,0,2*Math.PI),c.fill(),c.stroke(),c.closePath(),c.restore()},this.drawIconResizeBoxBase=function(e,t,i){var s=t*i;c.save(),c.strokeStyle=h.resizeBoxStroke,c.lineWidth=2,c.fillStyle=h.resizeBoxFill,c.fillRect(e[0]-s/2,e[1]-s/2,s,s),c.strokeRect(e[0]-s/2,e[1]-s/2,s,s),c.restore()},this.drawIconResizeBoxNESW=function(e,s,r){this.drawIconResizeBoxBase(e,s,r),g(t,h.resizeBoxArrowFill,e,r),g(i,h.resizeBoxArrowFill,e,r)},this.drawIconResizeBoxNWSE=function(t,i,r){this.drawIconResizeBoxBase(t,i,r),g(e,h.resizeBoxArrowFill,t,r),g(s,h.resizeBoxArrowFill,t,r)},this.drawCropArea=function(e,t,i,s){var r=e.width/c.canvas.width,o=e.height/c.canvas.height,a=t[0]-i/2,n=t[1]-i/2;c.save(),c.strokeStyle=h.areaOutline,c.lineWidth=2,c.beginPath(),s(c,t,i),c.stroke(),c.clip(),i>0&&c.drawImage(e,a*r,n*o,i*r,i*o,a,n,i,i),c.beginPath(),s(c,t,i),c.stroke(),c.clip(),c.restore()}}}]),e.factory("cropHost",["$document","cropAreaCircle","cropAreaSquare",function(e,t,i){var s=function(e){var t=e.getBoundingClientRect(),i=document.body,s=document.documentElement,r=window.pageYOffset||s.scrollTop||i.scrollTop,o=window.pageXOffset||s.scrollLeft||i.scrollLeft,a=s.clientTop||i.clientTop||0,n=s.clientLeft||i.clientLeft||0,h=t.top+r-a,c=t.left+o-n;return{top:Math.round(h),left:Math.round(c)}};return function(r,o,a){function n(){h.clearRect(0,0,h.canvas.width,h.canvas.height),null!==c&&(h.drawImage(c,0,0,h.canvas.width,h.canvas.height),h.save(),h.fillStyle="rgba(0, 0, 0, 0.65)",h.fillRect(0,0,h.canvas.width,h.canvas.height),h.restore(),_.draw())}var h=null,c=null,_=null,g=[100,100],u=[300,300],l=200,p=function(){if(null!==c){_.setImage(c);var e=[c.width,c.height],t=c.width/c.height,i=e;i[0]>u[0]?(i[0]=u[0],i[1]=i[0]/t):i[0]<g[0]&&(i[0]=g[0],i[1]=i[0]/t),i[1]>u[1]?(i[1]=u[1],i[0]=i[1]*t):i[1]<g[1]&&(i[1]=g[1],i[0]=i[1]*t),r.prop("width",i[0]).prop("height",i[1]).css({"margin-left":-i[0]/2+"px","margin-top":-i[1]/2+"px"}),_.setX(h.canvas.width/2),_.setY(h.canvas.height/2),_.setSize(Math.min(200,h.canvas.width/2,h.canvas.height/2))}else r.prop("width",0).prop("height",0).css({"margin-top":0});n()},z=function(e){if(null!==c){var t,i,r=s(h.canvas);"touchmove"===e.type?(t=e.changedTouches[0].pageX,i=e.changedTouches[0].pageY):(t=e.pageX,i=e.pageY),_.processMouseMove(t-r.left,i-r.top),n()}},v=function(e){if(e.preventDefault(),e.stopPropagation(),null!==c){var t,i,r=s(h.canvas);"touchstart"===e.type?(t=e.changedTouches[0].pageX,i=e.changedTouches[0].pageY):(t=e.pageX,i=e.pageY),_.processMouseDown(t-r.left,i-r.top),n()}},f=function(e){if(null!==c){var t,i,r=s(h.canvas);"touchend"===e.type?(t=e.changedTouches[0].pageX,i=e.changedTouches[0].pageY):(t=e.pageX,i=e.pageY),_.processMouseUp(t-r.left,i-r.top),n()}};this.getResultImageDataURI=function(){var e,t;return t=angular.element("<canvas></canvas>")[0],e=t.getContext("2d"),t.width=l,t.height=l,null!==c&&e.drawImage(c,(_.getX()-_.getSize()/2)*(c.width/h.canvas.width),(_.getY()-_.getSize()/2)*(c.height/h.canvas.height),_.getSize()*(c.width/h.canvas.width),_.getSize()*(c.height/h.canvas.height),0,0,l,l),t.toDataURL()},this.setNewImageSource=function(e){if(c=null,p(),a.trigger("image-updated"),e){var t=new Image;t.onload=function(){a.trigger("load-done"),c=t,p(),a.trigger("image-updated")},t.onerror=function(){a.trigger("load-error")},a.trigger("load-start"),t.src=e}},this.setMaxDimensions=function(e,t){if(u=[e,t],null!==c){var i=h.canvas.width,s=h.canvas.height,o=[c.width,c.height],a=c.width/c.height,l=o;l[0]>u[0]?(l[0]=u[0],l[1]=l[0]/a):l[0]<g[0]&&(l[0]=g[0],l[1]=l[0]/a),l[1]>u[1]?(l[1]=u[1],l[0]=l[1]*a):l[1]<g[1]&&(l[1]=g[1],l[0]=l[1]*a),r.prop("width",l[0]).prop("height",l[1]).css({"margin-left":-l[0]/2+"px","margin-top":-l[1]/2+"px"});var p=h.canvas.width/i,z=h.canvas.height/s,v=Math.min(p,z);_.setX(_.getX()*p),_.setY(_.getY()*z),_.setSize(_.getSize()*v)}else r.prop("width",0).prop("height",0).css({"margin-top":0});n()},this.setAreaMinSize=function(e){e=parseInt(e,10),isNaN(e)||(_.setMinSize(e),n())},this.setResultImageSize=function(e){e=parseInt(e,10),isNaN(e)||(l=e)},this.setAreaType=function(e){var s=_.getSize(),r=_.getMinSize(),o=_.getX(),g=_.getY(),u=t;"square"===e&&(u=i),_=new u(h,a),_.setMinSize(r),_.setSize(s),_.setX(o),_.setY(g),null!==c&&_.setImage(c),n()},h=r[0].getContext("2d"),_=new t(h,a),e.on("mousemove",z),r.on("mousedown",v),e.on("mouseup",f),e.on("touchmove",z),r.on("touchstart",v),e.on("touchend",f),this.destroy=function(){e.off("mousemove",z),r.off("mousedown",v),e.off("mouseup",z),e.off("touchmove",z),r.off("touchstart",v),e.off("touchend",z),r.remove()}}}]),e.factory("cropPubSub",[function(){return function(){var e={};this.on=function(t,i){return t.split(" ").forEach(function(t){e[t]||(e[t]=[]),e[t].push(i)}),this},this.trigger=function(t,i){return angular.forEach(e[t],function(e){e.call(null,i)}),this}}}]),e.directive("imgCrop",["$timeout","cropHost","cropPubSub",function(e,t,i){return{restrict:"E",scope:{image:"=",resultImage:"=",changeOnFly:"=",areaType:"@",areaMinSize:"=",resultImageSize:"=",onChange:"&",onLoadBegin:"&",onLoadDone:"&",onLoadError:"&"},template:"<canvas></canvas>",controller:["$scope",function(e){e.events=new i}],link:function(i,s){var r,o=i.events,a=new t(s.find("canvas"),{},o),n=function(e){var t=a.getResultImageDataURI();r!==t&&(r=t,angular.isDefined(e.resultImage)&&(e.resultImage=t),e.onChange({$dataURI:e.resultImage}))},h=function(t){return function(){e(function(){i.$apply(function(e){t(e)})})}};o.on("load-start",h(function(e){e.onLoadBegin({})})).on("load-done",h(function(e){e.onLoadDone({})})).on("load-error",h(function(e){e.onLoadError({})})).on("area-move area-resize",h(function(e){e.changeOnFly&&n(e)})).on("area-move-end area-resize-end image-updated",h(function(e){n(e)})),i.$watch("image",function(){a.setNewImageSource(i.image)}),i.$watch("areaType",function(){a.setAreaType(i.areaType),n(i)}),i.$watch("areaMinSize",function(){a.setAreaMinSize(i.areaMinSize),n(i)}),i.$watch("resultImageSize",function(){a.setResultImageSize(i.resultImageSize),n(i)}),i.$watch(function(){return[s[0].clientWidth,s[0].clientHeight]},function(e){a.setMaxDimensions(e[0],e[1]),n(i)},!0),i.$on("$destroy",function(){a.destroy()})}}}])}();

/***/ }),

/***/ 1086:
983,

/***/ 1091:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1092);
	__webpack_require__(1093);
	__webpack_require__(1096);
	__webpack_require__(1098);
	__webpack_require__(1095);
	__webpack_require__(1097);
	__webpack_require__(1099);

/***/ }),

/***/ 1092:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! DataTables 1.10.19
	 * ©2008-2018 SpryMedia Ltd - datatables.net/license
	 */
	
	/**
	 * @summary     DataTables
	 * @description Paginate, search and order HTML tables
	 * @version     1.10.19
	 * @file        jquery.dataTables.js
	 * @author      SpryMedia Ltd
	 * @contact     www.datatables.net
	 * @copyright   Copyright 2008-2018 SpryMedia Ltd.
	 *
	 * This source file is free software, available under the following license:
	 *   MIT license - http://datatables.net/license
	 *
	 * This source file is distributed in the hope that it will be useful, but
	 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
	 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
	 *
	 * For details please refer to: http://www.datatables.net
	 */
	
	/*jslint evil: true, undef: true, browser: true */
	/*globals $,require,jQuery,define,_selector_run,_selector_opts,_selector_first,_selector_row_indexes,_ext,_Api,_api_register,_api_registerPlural,_re_new_lines,_re_html,_re_formatted_numeric,_re_escape_regex,_empty,_intVal,_numToDecimal,_isNumber,_isHtml,_htmlNumeric,_pluck,_pluck_order,_range,_stripHtml,_unique,_fnBuildAjax,_fnAjaxUpdate,_fnAjaxParameters,_fnAjaxUpdateDraw,_fnAjaxDataSrc,_fnAddColumn,_fnColumnOptions,_fnAdjustColumnSizing,_fnVisibleToColumnIndex,_fnColumnIndexToVisible,_fnVisbleColumns,_fnGetColumns,_fnColumnTypes,_fnApplyColumnDefs,_fnHungarianMap,_fnCamelToHungarian,_fnLanguageCompat,_fnBrowserDetect,_fnAddData,_fnAddTr,_fnNodeToDataIndex,_fnNodeToColumnIndex,_fnGetCellData,_fnSetCellData,_fnSplitObjNotation,_fnGetObjectDataFn,_fnSetObjectDataFn,_fnGetDataMaster,_fnClearTable,_fnDeleteIndex,_fnInvalidate,_fnGetRowElements,_fnCreateTr,_fnBuildHead,_fnDrawHead,_fnDraw,_fnReDraw,_fnAddOptionsHtml,_fnDetectHeader,_fnGetUniqueThs,_fnFeatureHtmlFilter,_fnFilterComplete,_fnFilterCustom,_fnFilterColumn,_fnFilter,_fnFilterCreateSearch,_fnEscapeRegex,_fnFilterData,_fnFeatureHtmlInfo,_fnUpdateInfo,_fnInfoMacros,_fnInitialise,_fnInitComplete,_fnLengthChange,_fnFeatureHtmlLength,_fnFeatureHtmlPaginate,_fnPageChange,_fnFeatureHtmlProcessing,_fnProcessingDisplay,_fnFeatureHtmlTable,_fnScrollDraw,_fnApplyToChildren,_fnCalculateColumnWidths,_fnThrottle,_fnConvertToWidth,_fnGetWidestNode,_fnGetMaxLenString,_fnStringToCss,_fnSortFlatten,_fnSort,_fnSortAria,_fnSortListener,_fnSortAttachListener,_fnSortingClasses,_fnSortData,_fnSaveState,_fnLoadState,_fnSettingsFromNode,_fnLog,_fnMap,_fnBindAction,_fnCallbackReg,_fnCallbackFire,_fnLengthOverflow,_fnRenderer,_fnDataSource,_fnRowAttributes*/
	
	(function( factory ) {
		"use strict";
	
		if ( true ) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(112)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
				return factory( $, window, document );
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else if ( typeof exports === 'object' ) {
			// CommonJS
			module.exports = function (root, $) {
				if ( ! root ) {
					// CommonJS environments without a window global must pass a
					// root. This will give an error otherwise
					root = window;
				}
	
				if ( ! $ ) {
					$ = typeof window !== 'undefined' ? // jQuery's factory checks for a global window
						require('jquery') :
						require('jquery')( root );
				}
	
				return factory( $, root, root.document );
			};
		}
		else {
			// Browser
			factory( jQuery, window, document );
		}
	}
	(function( $, window, document, undefined ) {
		"use strict";
	
		/**
		 * DataTables is a plug-in for the jQuery Javascript library. It is a highly
		 * flexible tool, based upon the foundations of progressive enhancement,
		 * which will add advanced interaction controls to any HTML table. For a
		 * full list of features please refer to
		 * [DataTables.net](href="http://datatables.net).
		 *
		 * Note that the `DataTable` object is not a global variable but is aliased
		 * to `jQuery.fn.DataTable` and `jQuery.fn.dataTable` through which it may
		 * be  accessed.
		 *
		 *  @class
		 *  @param {object} [init={}] Configuration object for DataTables. Options
		 *    are defined by {@link DataTable.defaults}
		 *  @requires jQuery 1.7+
		 *
		 *  @example
		 *    // Basic initialisation
		 *    $(document).ready( function {
		 *      $('#example').dataTable();
		 *    } );
		 *
		 *  @example
		 *    // Initialisation with configuration options - in this case, disable
		 *    // pagination and sorting.
		 *    $(document).ready( function {
		 *      $('#example').dataTable( {
		 *        "paginate": false,
		 *        "sort": false
		 *      } );
		 *    } );
		 */
		var DataTable = function ( options )
		{
			/**
			 * Perform a jQuery selector action on the table's TR elements (from the tbody) and
			 * return the resulting jQuery object.
			 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
			 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
			 *  @param {string} [oOpts.filter=none] Select TR elements that meet the current filter
			 *    criterion ("applied") or all TR elements (i.e. no filter).
			 *  @param {string} [oOpts.order=current] Order of the TR elements in the processed array.
			 *    Can be either 'current', whereby the current sorting of the table is used, or
			 *    'original' whereby the original order the data was read into the table is used.
			 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
			 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
			 *    'current' and filter is 'applied', regardless of what they might be given as.
			 *  @returns {object} jQuery object, filtered by the given selector.
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Highlight every second row
			 *      oTable.$('tr:odd').css('backgroundColor', 'blue');
			 *    } );
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Filter to rows with 'Webkit' in them, add a background colour and then
			 *      // remove the filter, thus highlighting the 'Webkit' rows only.
			 *      oTable.fnFilter('Webkit');
			 *      oTable.$('tr', {"search": "applied"}).css('backgroundColor', 'blue');
			 *      oTable.fnFilter('');
			 *    } );
			 */
			this.$ = function ( sSelector, oOpts )
			{
				return this.api(true).$( sSelector, oOpts );
			};
			
			
			/**
			 * Almost identical to $ in operation, but in this case returns the data for the matched
			 * rows - as such, the jQuery selector used should match TR row nodes or TD/TH cell nodes
			 * rather than any descendants, so the data can be obtained for the row/cell. If matching
			 * rows are found, the data returned is the original data array/object that was used to
			 * create the row (or a generated array if from a DOM source).
			 *
			 * This method is often useful in-combination with $ where both functions are given the
			 * same parameters and the array indexes will match identically.
			 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
			 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
			 *  @param {string} [oOpts.filter=none] Select elements that meet the current filter
			 *    criterion ("applied") or all elements (i.e. no filter).
			 *  @param {string} [oOpts.order=current] Order of the data in the processed array.
			 *    Can be either 'current', whereby the current sorting of the table is used, or
			 *    'original' whereby the original order the data was read into the table is used.
			 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
			 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
			 *    'current' and filter is 'applied', regardless of what they might be given as.
			 *  @returns {array} Data for the matched elements. If any elements, as a result of the
			 *    selector, were not TR, TD or TH elements in the DataTable, they will have a null
			 *    entry in the array.
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Get the data from the first row in the table
			 *      var data = oTable._('tr:first');
			 *
			 *      // Do something useful with the data
			 *      alert( "First cell is: "+data[0] );
			 *    } );
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Filter to 'Webkit' and get all data for
			 *      oTable.fnFilter('Webkit');
			 *      var data = oTable._('tr', {"search": "applied"});
			 *
			 *      // Do something with the data
			 *      alert( data.length+" rows matched the search" );
			 *    } );
			 */
			this._ = function ( sSelector, oOpts )
			{
				return this.api(true).rows( sSelector, oOpts ).data();
			};
			
			
			/**
			 * Create a DataTables Api instance, with the currently selected tables for
			 * the Api's context.
			 * @param {boolean} [traditional=false] Set the API instance's context to be
			 *   only the table referred to by the `DataTable.ext.iApiIndex` option, as was
			 *   used in the API presented by DataTables 1.9- (i.e. the traditional mode),
			 *   or if all tables captured in the jQuery object should be used.
			 * @return {DataTables.Api}
			 */
			this.api = function ( traditional )
			{
				return traditional ?
					new _Api(
						_fnSettingsFromNode( this[ _ext.iApiIndex ] )
					) :
					new _Api( this );
			};
			
			
			/**
			 * Add a single new row or multiple rows of data to the table. Please note
			 * that this is suitable for client-side processing only - if you are using
			 * server-side processing (i.e. "bServerSide": true), then to add data, you
			 * must add it to the data source, i.e. the server-side, through an Ajax call.
			 *  @param {array|object} data The data to be added to the table. This can be:
			 *    <ul>
			 *      <li>1D array of data - add a single row with the data provided</li>
			 *      <li>2D array of arrays - add multiple rows in a single call</li>
			 *      <li>object - data object when using <i>mData</i></li>
			 *      <li>array of objects - multiple data objects when using <i>mData</i></li>
			 *    </ul>
			 *  @param {bool} [redraw=true] redraw the table or not
			 *  @returns {array} An array of integers, representing the list of indexes in
			 *    <i>aoData</i> ({@link DataTable.models.oSettings}) that have been added to
			 *    the table.
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    // Global var for counter
			 *    var giCount = 2;
			 *
			 *    $(document).ready(function() {
			 *      $('#example').dataTable();
			 *    } );
			 *
			 *    function fnClickAddRow() {
			 *      $('#example').dataTable().fnAddData( [
			 *        giCount+".1",
			 *        giCount+".2",
			 *        giCount+".3",
			 *        giCount+".4" ]
			 *      );
			 *
			 *      giCount++;
			 *    }
			 */
			this.fnAddData = function( data, redraw )
			{
				var api = this.api( true );
			
				/* Check if we want to add multiple rows or not */
				var rows = $.isArray(data) && ( $.isArray(data[0]) || $.isPlainObject(data[0]) ) ?
					api.rows.add( data ) :
					api.row.add( data );
			
				if ( redraw === undefined || redraw ) {
					api.draw();
				}
			
				return rows.flatten().toArray();
			};
			
			
			/**
			 * This function will make DataTables recalculate the column sizes, based on the data
			 * contained in the table and the sizes applied to the columns (in the DOM, CSS or
			 * through the sWidth parameter). This can be useful when the width of the table's
			 * parent element changes (for example a window resize).
			 *  @param {boolean} [bRedraw=true] Redraw the table or not, you will typically want to
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable( {
			 *        "sScrollY": "200px",
			 *        "bPaginate": false
			 *      } );
			 *
			 *      $(window).on('resize', function () {
			 *        oTable.fnAdjustColumnSizing();
			 *      } );
			 *    } );
			 */
			this.fnAdjustColumnSizing = function ( bRedraw )
			{
				var api = this.api( true ).columns.adjust();
				var settings = api.settings()[0];
				var scroll = settings.oScroll;
			
				if ( bRedraw === undefined || bRedraw ) {
					api.draw( false );
				}
				else if ( scroll.sX !== "" || scroll.sY !== "" ) {
					/* If not redrawing, but scrolling, we want to apply the new column sizes anyway */
					_fnScrollDraw( settings );
				}
			};
			
			
			/**
			 * Quickly and simply clear a table
			 *  @param {bool} [bRedraw=true] redraw the table or not
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Immediately 'nuke' the current rows (perhaps waiting for an Ajax callback...)
			 *      oTable.fnClearTable();
			 *    } );
			 */
			this.fnClearTable = function( bRedraw )
			{
				var api = this.api( true ).clear();
			
				if ( bRedraw === undefined || bRedraw ) {
					api.draw();
				}
			};
			
			
			/**
			 * The exact opposite of 'opening' a row, this function will close any rows which
			 * are currently 'open'.
			 *  @param {node} nTr the table row to 'close'
			 *  @returns {int} 0 on success, or 1 if failed (can't find the row)
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable;
			 *
			 *      // 'open' an information row when a row is clicked on
			 *      $('#example tbody tr').click( function () {
			 *        if ( oTable.fnIsOpen(this) ) {
			 *          oTable.fnClose( this );
			 *        } else {
			 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
			 *        }
			 *      } );
			 *
			 *      oTable = $('#example').dataTable();
			 *    } );
			 */
			this.fnClose = function( nTr )
			{
				this.api( true ).row( nTr ).child.hide();
			};
			
			
			/**
			 * Remove a row for the table
			 *  @param {mixed} target The index of the row from aoData to be deleted, or
			 *    the TR element you want to delete
			 *  @param {function|null} [callBack] Callback function
			 *  @param {bool} [redraw=true] Redraw the table or not
			 *  @returns {array} The row that was deleted
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Immediately remove the first row
			 *      oTable.fnDeleteRow( 0 );
			 *    } );
			 */
			this.fnDeleteRow = function( target, callback, redraw )
			{
				var api = this.api( true );
				var rows = api.rows( target );
				var settings = rows.settings()[0];
				var data = settings.aoData[ rows[0][0] ];
			
				rows.remove();
			
				if ( callback ) {
					callback.call( this, settings, data );
				}
			
				if ( redraw === undefined || redraw ) {
					api.draw();
				}
			
				return data;
			};
			
			
			/**
			 * Restore the table to it's original state in the DOM by removing all of DataTables
			 * enhancements, alterations to the DOM structure of the table and event listeners.
			 *  @param {boolean} [remove=false] Completely remove the table from the DOM
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      // This example is fairly pointless in reality, but shows how fnDestroy can be used
			 *      var oTable = $('#example').dataTable();
			 *      oTable.fnDestroy();
			 *    } );
			 */
			this.fnDestroy = function ( remove )
			{
				this.api( true ).destroy( remove );
			};
			
			
			/**
			 * Redraw the table
			 *  @param {bool} [complete=true] Re-filter and resort (if enabled) the table before the draw.
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Re-draw the table - you wouldn't want to do it here, but it's an example :-)
			 *      oTable.fnDraw();
			 *    } );
			 */
			this.fnDraw = function( complete )
			{
				// Note that this isn't an exact match to the old call to _fnDraw - it takes
				// into account the new data, but can hold position.
				this.api( true ).draw( complete );
			};
			
			
			/**
			 * Filter the input based on data
			 *  @param {string} sInput String to filter the table on
			 *  @param {int|null} [iColumn] Column to limit filtering to
			 *  @param {bool} [bRegex=false] Treat as regular expression or not
			 *  @param {bool} [bSmart=true] Perform smart filtering or not
			 *  @param {bool} [bShowGlobal=true] Show the input global filter in it's input box(es)
			 *  @param {bool} [bCaseInsensitive=true] Do case-insensitive matching (true) or not (false)
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Sometime later - filter...
			 *      oTable.fnFilter( 'test string' );
			 *    } );
			 */
			this.fnFilter = function( sInput, iColumn, bRegex, bSmart, bShowGlobal, bCaseInsensitive )
			{
				var api = this.api( true );
			
				if ( iColumn === null || iColumn === undefined ) {
					api.search( sInput, bRegex, bSmart, bCaseInsensitive );
				}
				else {
					api.column( iColumn ).search( sInput, bRegex, bSmart, bCaseInsensitive );
				}
			
				api.draw();
			};
			
			
			/**
			 * Get the data for the whole table, an individual row or an individual cell based on the
			 * provided parameters.
			 *  @param {int|node} [src] A TR row node, TD/TH cell node or an integer. If given as
			 *    a TR node then the data source for the whole row will be returned. If given as a
			 *    TD/TH cell node then iCol will be automatically calculated and the data for the
			 *    cell returned. If given as an integer, then this is treated as the aoData internal
			 *    data index for the row (see fnGetPosition) and the data for that row used.
			 *  @param {int} [col] Optional column index that you want the data of.
			 *  @returns {array|object|string} If mRow is undefined, then the data for all rows is
			 *    returned. If mRow is defined, just data for that row, and is iCol is
			 *    defined, only data for the designated cell is returned.
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    // Row data
			 *    $(document).ready(function() {
			 *      oTable = $('#example').dataTable();
			 *
			 *      oTable.$('tr').click( function () {
			 *        var data = oTable.fnGetData( this );
			 *        // ... do something with the array / object of data for the row
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Individual cell data
			 *    $(document).ready(function() {
			 *      oTable = $('#example').dataTable();
			 *
			 *      oTable.$('td').click( function () {
			 *        var sData = oTable.fnGetData( this );
			 *        alert( 'The cell clicked on had the value of '+sData );
			 *      } );
			 *    } );
			 */
			this.fnGetData = function( src, col )
			{
				var api = this.api( true );
			
				if ( src !== undefined ) {
					var type = src.nodeName ? src.nodeName.toLowerCase() : '';
			
					return col !== undefined || type == 'td' || type == 'th' ?
						api.cell( src, col ).data() :
						api.row( src ).data() || null;
				}
			
				return api.data().toArray();
			};
			
			
			/**
			 * Get an array of the TR nodes that are used in the table's body. Note that you will
			 * typically want to use the '$' API method in preference to this as it is more
			 * flexible.
			 *  @param {int} [iRow] Optional row index for the TR element you want
			 *  @returns {array|node} If iRow is undefined, returns an array of all TR elements
			 *    in the table's body, or iRow is defined, just the TR element requested.
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Get the nodes from the table
			 *      var nNodes = oTable.fnGetNodes( );
			 *    } );
			 */
			this.fnGetNodes = function( iRow )
			{
				var api = this.api( true );
			
				return iRow !== undefined ?
					api.row( iRow ).node() :
					api.rows().nodes().flatten().toArray();
			};
			
			
			/**
			 * Get the array indexes of a particular cell from it's DOM element
			 * and column index including hidden columns
			 *  @param {node} node this can either be a TR, TD or TH in the table's body
			 *  @returns {int} If nNode is given as a TR, then a single index is returned, or
			 *    if given as a cell, an array of [row index, column index (visible),
			 *    column index (all)] is given.
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      $('#example tbody td').click( function () {
			 *        // Get the position of the current data from the node
			 *        var aPos = oTable.fnGetPosition( this );
			 *
			 *        // Get the data array for this row
			 *        var aData = oTable.fnGetData( aPos[0] );
			 *
			 *        // Update the data array and return the value
			 *        aData[ aPos[1] ] = 'clicked';
			 *        this.innerHTML = 'clicked';
			 *      } );
			 *
			 *      // Init DataTables
			 *      oTable = $('#example').dataTable();
			 *    } );
			 */
			this.fnGetPosition = function( node )
			{
				var api = this.api( true );
				var nodeName = node.nodeName.toUpperCase();
			
				if ( nodeName == 'TR' ) {
					return api.row( node ).index();
				}
				else if ( nodeName == 'TD' || nodeName == 'TH' ) {
					var cell = api.cell( node ).index();
			
					return [
						cell.row,
						cell.columnVisible,
						cell.column
					];
				}
				return null;
			};
			
			
			/**
			 * Check to see if a row is 'open' or not.
			 *  @param {node} nTr the table row to check
			 *  @returns {boolean} true if the row is currently open, false otherwise
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable;
			 *
			 *      // 'open' an information row when a row is clicked on
			 *      $('#example tbody tr').click( function () {
			 *        if ( oTable.fnIsOpen(this) ) {
			 *          oTable.fnClose( this );
			 *        } else {
			 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
			 *        }
			 *      } );
			 *
			 *      oTable = $('#example').dataTable();
			 *    } );
			 */
			this.fnIsOpen = function( nTr )
			{
				return this.api( true ).row( nTr ).child.isShown();
			};
			
			
			/**
			 * This function will place a new row directly after a row which is currently
			 * on display on the page, with the HTML contents that is passed into the
			 * function. This can be used, for example, to ask for confirmation that a
			 * particular record should be deleted.
			 *  @param {node} nTr The table row to 'open'
			 *  @param {string|node|jQuery} mHtml The HTML to put into the row
			 *  @param {string} sClass Class to give the new TD cell
			 *  @returns {node} The row opened. Note that if the table row passed in as the
			 *    first parameter, is not found in the table, this method will silently
			 *    return.
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable;
			 *
			 *      // 'open' an information row when a row is clicked on
			 *      $('#example tbody tr').click( function () {
			 *        if ( oTable.fnIsOpen(this) ) {
			 *          oTable.fnClose( this );
			 *        } else {
			 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
			 *        }
			 *      } );
			 *
			 *      oTable = $('#example').dataTable();
			 *    } );
			 */
			this.fnOpen = function( nTr, mHtml, sClass )
			{
				return this.api( true )
					.row( nTr )
					.child( mHtml, sClass )
					.show()
					.child()[0];
			};
			
			
			/**
			 * Change the pagination - provides the internal logic for pagination in a simple API
			 * function. With this function you can have a DataTables table go to the next,
			 * previous, first or last pages.
			 *  @param {string|int} mAction Paging action to take: "first", "previous", "next" or "last"
			 *    or page number to jump to (integer), note that page 0 is the first page.
			 *  @param {bool} [bRedraw=true] Redraw the table or not
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *      oTable.fnPageChange( 'next' );
			 *    } );
			 */
			this.fnPageChange = function ( mAction, bRedraw )
			{
				var api = this.api( true ).page( mAction );
			
				if ( bRedraw === undefined || bRedraw ) {
					api.draw(false);
				}
			};
			
			
			/**
			 * Show a particular column
			 *  @param {int} iCol The column whose display should be changed
			 *  @param {bool} bShow Show (true) or hide (false) the column
			 *  @param {bool} [bRedraw=true] Redraw the table or not
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Hide the second column after initialisation
			 *      oTable.fnSetColumnVis( 1, false );
			 *    } );
			 */
			this.fnSetColumnVis = function ( iCol, bShow, bRedraw )
			{
				var api = this.api( true ).column( iCol ).visible( bShow );
			
				if ( bRedraw === undefined || bRedraw ) {
					api.columns.adjust().draw();
				}
			};
			
			
			/**
			 * Get the settings for a particular table for external manipulation
			 *  @returns {object} DataTables settings object. See
			 *    {@link DataTable.models.oSettings}
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *      var oSettings = oTable.fnSettings();
			 *
			 *      // Show an example parameter from the settings
			 *      alert( oSettings._iDisplayStart );
			 *    } );
			 */
			this.fnSettings = function()
			{
				return _fnSettingsFromNode( this[_ext.iApiIndex] );
			};
			
			
			/**
			 * Sort the table by a particular column
			 *  @param {int} iCol the data index to sort on. Note that this will not match the
			 *    'display index' if you have hidden data entries
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Sort immediately with columns 0 and 1
			 *      oTable.fnSort( [ [0,'asc'], [1,'asc'] ] );
			 *    } );
			 */
			this.fnSort = function( aaSort )
			{
				this.api( true ).order( aaSort ).draw();
			};
			
			
			/**
			 * Attach a sort listener to an element for a given column
			 *  @param {node} nNode the element to attach the sort listener to
			 *  @param {int} iColumn the column that a click on this node will sort on
			 *  @param {function} [fnCallback] callback function when sort is run
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *
			 *      // Sort on column 1, when 'sorter' is clicked on
			 *      oTable.fnSortListener( document.getElementById('sorter'), 1 );
			 *    } );
			 */
			this.fnSortListener = function( nNode, iColumn, fnCallback )
			{
				this.api( true ).order.listener( nNode, iColumn, fnCallback );
			};
			
			
			/**
			 * Update a table cell or row - this method will accept either a single value to
			 * update the cell with, an array of values with one element for each column or
			 * an object in the same format as the original data source. The function is
			 * self-referencing in order to make the multi column updates easier.
			 *  @param {object|array|string} mData Data to update the cell/row with
			 *  @param {node|int} mRow TR element you want to update or the aoData index
			 *  @param {int} [iColumn] The column to update, give as null or undefined to
			 *    update a whole row.
			 *  @param {bool} [bRedraw=true] Redraw the table or not
			 *  @param {bool} [bAction=true] Perform pre-draw actions or not
			 *  @returns {int} 0 on success, 1 on error
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *      oTable.fnUpdate( 'Example update', 0, 0 ); // Single cell
			 *      oTable.fnUpdate( ['a', 'b', 'c', 'd', 'e'], $('tbody tr')[0] ); // Row
			 *    } );
			 */
			this.fnUpdate = function( mData, mRow, iColumn, bRedraw, bAction )
			{
				var api = this.api( true );
			
				if ( iColumn === undefined || iColumn === null ) {
					api.row( mRow ).data( mData );
				}
				else {
					api.cell( mRow, iColumn ).data( mData );
				}
			
				if ( bAction === undefined || bAction ) {
					api.columns.adjust();
				}
			
				if ( bRedraw === undefined || bRedraw ) {
					api.draw();
				}
				return 0;
			};
			
			
			/**
			 * Provide a common method for plug-ins to check the version of DataTables being used, in order
			 * to ensure compatibility.
			 *  @param {string} sVersion Version string to check for, in the format "X.Y.Z". Note that the
			 *    formats "X" and "X.Y" are also acceptable.
			 *  @returns {boolean} true if this version of DataTables is greater or equal to the required
			 *    version, or false if this version of DataTales is not suitable
			 *  @method
			 *  @dtopt API
			 *  @deprecated Since v1.10
			 *
			 *  @example
			 *    $(document).ready(function() {
			 *      var oTable = $('#example').dataTable();
			 *      alert( oTable.fnVersionCheck( '1.9.0' ) );
			 *    } );
			 */
			this.fnVersionCheck = _ext.fnVersionCheck;
			
	
			var _that = this;
			var emptyInit = options === undefined;
			var len = this.length;
	
			if ( emptyInit ) {
				options = {};
			}
	
			this.oApi = this.internal = _ext.internal;
	
			// Extend with old style plug-in API methods
			for ( var fn in DataTable.ext.internal ) {
				if ( fn ) {
					this[fn] = _fnExternApiFunc(fn);
				}
			}
	
			this.each(function() {
				// For each initialisation we want to give it a clean initialisation
				// object that can be bashed around
				var o = {};
				var oInit = len > 1 ? // optimisation for single table case
					_fnExtend( o, options, true ) :
					options;
	
				/*global oInit,_that,emptyInit*/
				var i=0, iLen, j, jLen, k, kLen;
				var sId = this.getAttribute( 'id' );
				var bInitHandedOff = false;
				var defaults = DataTable.defaults;
				var $this = $(this);
				
				
				/* Sanity check */
				if ( this.nodeName.toLowerCase() != 'table' )
				{
					_fnLog( null, 0, 'Non-table node initialisation ('+this.nodeName+')', 2 );
					return;
				}
				
				/* Backwards compatibility for the defaults */
				_fnCompatOpts( defaults );
				_fnCompatCols( defaults.column );
				
				/* Convert the camel-case defaults to Hungarian */
				_fnCamelToHungarian( defaults, defaults, true );
				_fnCamelToHungarian( defaults.column, defaults.column, true );
				
				/* Setting up the initialisation object */
				_fnCamelToHungarian( defaults, $.extend( oInit, $this.data() ) );
				
				
				
				/* Check to see if we are re-initialising a table */
				var allSettings = DataTable.settings;
				for ( i=0, iLen=allSettings.length ; i<iLen ; i++ )
				{
					var s = allSettings[i];
				
					/* Base check on table node */
					if (
						s.nTable == this ||
						(s.nTHead && s.nTHead.parentNode == this) ||
						(s.nTFoot && s.nTFoot.parentNode == this)
					) {
						var bRetrieve = oInit.bRetrieve !== undefined ? oInit.bRetrieve : defaults.bRetrieve;
						var bDestroy = oInit.bDestroy !== undefined ? oInit.bDestroy : defaults.bDestroy;
				
						if ( emptyInit || bRetrieve )
						{
							return s.oInstance;
						}
						else if ( bDestroy )
						{
							s.oInstance.fnDestroy();
							break;
						}
						else
						{
							_fnLog( s, 0, 'Cannot reinitialise DataTable', 3 );
							return;
						}
					}
				
					/* If the element we are initialising has the same ID as a table which was previously
					 * initialised, but the table nodes don't match (from before) then we destroy the old
					 * instance by simply deleting it. This is under the assumption that the table has been
					 * destroyed by other methods. Anyone using non-id selectors will need to do this manually
					 */
					if ( s.sTableId == this.id )
					{
						allSettings.splice( i, 1 );
						break;
					}
				}
				
				/* Ensure the table has an ID - required for accessibility */
				if ( sId === null || sId === "" )
				{
					sId = "DataTables_Table_"+(DataTable.ext._unique++);
					this.id = sId;
				}
				
				/* Create the settings object for this table and set some of the default parameters */
				var oSettings = $.extend( true, {}, DataTable.models.oSettings, {
					"sDestroyWidth": $this[0].style.width,
					"sInstance":     sId,
					"sTableId":      sId
				} );
				oSettings.nTable = this;
				oSettings.oApi   = _that.internal;
				oSettings.oInit  = oInit;
				
				allSettings.push( oSettings );
				
				// Need to add the instance after the instance after the settings object has been added
				// to the settings array, so we can self reference the table instance if more than one
				oSettings.oInstance = (_that.length===1) ? _that : $this.dataTable();
				
				// Backwards compatibility, before we apply all the defaults
				_fnCompatOpts( oInit );
				_fnLanguageCompat( oInit.oLanguage );
				
				// If the length menu is given, but the init display length is not, use the length menu
				if ( oInit.aLengthMenu && ! oInit.iDisplayLength )
				{
					oInit.iDisplayLength = $.isArray( oInit.aLengthMenu[0] ) ?
						oInit.aLengthMenu[0][0] : oInit.aLengthMenu[0];
				}
				
				// Apply the defaults and init options to make a single init object will all
				// options defined from defaults and instance options.
				oInit = _fnExtend( $.extend( true, {}, defaults ), oInit );
				
				
				// Map the initialisation options onto the settings object
				_fnMap( oSettings.oFeatures, oInit, [
					"bPaginate",
					"bLengthChange",
					"bFilter",
					"bSort",
					"bSortMulti",
					"bInfo",
					"bProcessing",
					"bAutoWidth",
					"bSortClasses",
					"bServerSide",
					"bDeferRender"
				] );
				_fnMap( oSettings, oInit, [
					"asStripeClasses",
					"ajax",
					"fnServerData",
					"fnFormatNumber",
					"sServerMethod",
					"aaSorting",
					"aaSortingFixed",
					"aLengthMenu",
					"sPaginationType",
					"sAjaxSource",
					"sAjaxDataProp",
					"iStateDuration",
					"sDom",
					"bSortCellsTop",
					"iTabIndex",
					"fnStateLoadCallback",
					"fnStateSaveCallback",
					"renderer",
					"searchDelay",
					"rowId",
					[ "iCookieDuration", "iStateDuration" ], // backwards compat
					[ "oSearch", "oPreviousSearch" ],
					[ "aoSearchCols", "aoPreSearchCols" ],
					[ "iDisplayLength", "_iDisplayLength" ]
				] );
				_fnMap( oSettings.oScroll, oInit, [
					[ "sScrollX", "sX" ],
					[ "sScrollXInner", "sXInner" ],
					[ "sScrollY", "sY" ],
					[ "bScrollCollapse", "bCollapse" ]
				] );
				_fnMap( oSettings.oLanguage, oInit, "fnInfoCallback" );
				
				/* Callback functions which are array driven */
				_fnCallbackReg( oSettings, 'aoDrawCallback',       oInit.fnDrawCallback,      'user' );
				_fnCallbackReg( oSettings, 'aoServerParams',       oInit.fnServerParams,      'user' );
				_fnCallbackReg( oSettings, 'aoStateSaveParams',    oInit.fnStateSaveParams,   'user' );
				_fnCallbackReg( oSettings, 'aoStateLoadParams',    oInit.fnStateLoadParams,   'user' );
				_fnCallbackReg( oSettings, 'aoStateLoaded',        oInit.fnStateLoaded,       'user' );
				_fnCallbackReg( oSettings, 'aoRowCallback',        oInit.fnRowCallback,       'user' );
				_fnCallbackReg( oSettings, 'aoRowCreatedCallback', oInit.fnCreatedRow,        'user' );
				_fnCallbackReg( oSettings, 'aoHeaderCallback',     oInit.fnHeaderCallback,    'user' );
				_fnCallbackReg( oSettings, 'aoFooterCallback',     oInit.fnFooterCallback,    'user' );
				_fnCallbackReg( oSettings, 'aoInitComplete',       oInit.fnInitComplete,      'user' );
				_fnCallbackReg( oSettings, 'aoPreDrawCallback',    oInit.fnPreDrawCallback,   'user' );
				
				oSettings.rowIdFn = _fnGetObjectDataFn( oInit.rowId );
				
				/* Browser support detection */
				_fnBrowserDetect( oSettings );
				
				var oClasses = oSettings.oClasses;
				
				$.extend( oClasses, DataTable.ext.classes, oInit.oClasses );
				$this.addClass( oClasses.sTable );
				
				
				if ( oSettings.iInitDisplayStart === undefined )
				{
					/* Display start point, taking into account the save saving */
					oSettings.iInitDisplayStart = oInit.iDisplayStart;
					oSettings._iDisplayStart = oInit.iDisplayStart;
				}
				
				if ( oInit.iDeferLoading !== null )
				{
					oSettings.bDeferLoading = true;
					var tmp = $.isArray( oInit.iDeferLoading );
					oSettings._iRecordsDisplay = tmp ? oInit.iDeferLoading[0] : oInit.iDeferLoading;
					oSettings._iRecordsTotal = tmp ? oInit.iDeferLoading[1] : oInit.iDeferLoading;
				}
				
				/* Language definitions */
				var oLanguage = oSettings.oLanguage;
				$.extend( true, oLanguage, oInit.oLanguage );
				
				if ( oLanguage.sUrl )
				{
					/* Get the language definitions from a file - because this Ajax call makes the language
					 * get async to the remainder of this function we use bInitHandedOff to indicate that
					 * _fnInitialise will be fired by the returned Ajax handler, rather than the constructor
					 */
					$.ajax( {
						dataType: 'json',
						url: oLanguage.sUrl,
						success: function ( json ) {
							_fnLanguageCompat( json );
							_fnCamelToHungarian( defaults.oLanguage, json );
							$.extend( true, oLanguage, json );
							_fnInitialise( oSettings );
						},
						error: function () {
							// Error occurred loading language file, continue on as best we can
							_fnInitialise( oSettings );
						}
					} );
					bInitHandedOff = true;
				}
				
				/*
				 * Stripes
				 */
				if ( oInit.asStripeClasses === null )
				{
					oSettings.asStripeClasses =[
						oClasses.sStripeOdd,
						oClasses.sStripeEven
					];
				}
				
				/* Remove row stripe classes if they are already on the table row */
				var stripeClasses = oSettings.asStripeClasses;
				var rowOne = $this.children('tbody').find('tr').eq(0);
				if ( $.inArray( true, $.map( stripeClasses, function(el, i) {
					return rowOne.hasClass(el);
				} ) ) !== -1 ) {
					$('tbody tr', this).removeClass( stripeClasses.join(' ') );
					oSettings.asDestroyStripes = stripeClasses.slice();
				}
				
				/*
				 * Columns
				 * See if we should load columns automatically or use defined ones
				 */
				var anThs = [];
				var aoColumnsInit;
				var nThead = this.getElementsByTagName('thead');
				if ( nThead.length !== 0 )
				{
					_fnDetectHeader( oSettings.aoHeader, nThead[0] );
					anThs = _fnGetUniqueThs( oSettings );
				}
				
				/* If not given a column array, generate one with nulls */
				if ( oInit.aoColumns === null )
				{
					aoColumnsInit = [];
					for ( i=0, iLen=anThs.length ; i<iLen ; i++ )
					{
						aoColumnsInit.push( null );
					}
				}
				else
				{
					aoColumnsInit = oInit.aoColumns;
				}
				
				/* Add the columns */
				for ( i=0, iLen=aoColumnsInit.length ; i<iLen ; i++ )
				{
					_fnAddColumn( oSettings, anThs ? anThs[i] : null );
				}
				
				/* Apply the column definitions */
				_fnApplyColumnDefs( oSettings, oInit.aoColumnDefs, aoColumnsInit, function (iCol, oDef) {
					_fnColumnOptions( oSettings, iCol, oDef );
				} );
				
				/* HTML5 attribute detection - build an mData object automatically if the
				 * attributes are found
				 */
				if ( rowOne.length ) {
					var a = function ( cell, name ) {
						return cell.getAttribute( 'data-'+name ) !== null ? name : null;
					};
				
					$( rowOne[0] ).children('th, td').each( function (i, cell) {
						var col = oSettings.aoColumns[i];
				
						if ( col.mData === i ) {
							var sort = a( cell, 'sort' ) || a( cell, 'order' );
							var filter = a( cell, 'filter' ) || a( cell, 'search' );
				
							if ( sort !== null || filter !== null ) {
								col.mData = {
									_:      i+'.display',
									sort:   sort !== null   ? i+'.@data-'+sort   : undefined,
									type:   sort !== null   ? i+'.@data-'+sort   : undefined,
									filter: filter !== null ? i+'.@data-'+filter : undefined
								};
				
								_fnColumnOptions( oSettings, i );
							}
						}
					} );
				}
				
				var features = oSettings.oFeatures;
				var loadedInit = function () {
					/*
					 * Sorting
					 * @todo For modularisation (1.11) this needs to do into a sort start up handler
					 */
				
					// If aaSorting is not defined, then we use the first indicator in asSorting
					// in case that has been altered, so the default sort reflects that option
					if ( oInit.aaSorting === undefined ) {
						var sorting = oSettings.aaSorting;
						for ( i=0, iLen=sorting.length ; i<iLen ; i++ ) {
							sorting[i][1] = oSettings.aoColumns[ i ].asSorting[0];
						}
					}
				
					/* Do a first pass on the sorting classes (allows any size changes to be taken into
					 * account, and also will apply sorting disabled classes if disabled
					 */
					_fnSortingClasses( oSettings );
				
					if ( features.bSort ) {
						_fnCallbackReg( oSettings, 'aoDrawCallback', function () {
							if ( oSettings.bSorted ) {
								var aSort = _fnSortFlatten( oSettings );
								var sortedColumns = {};
				
								$.each( aSort, function (i, val) {
									sortedColumns[ val.src ] = val.dir;
								} );
				
								_fnCallbackFire( oSettings, null, 'order', [oSettings, aSort, sortedColumns] );
								_fnSortAria( oSettings );
							}
						} );
					}
				
					_fnCallbackReg( oSettings, 'aoDrawCallback', function () {
						if ( oSettings.bSorted || _fnDataSource( oSettings ) === 'ssp' || features.bDeferRender ) {
							_fnSortingClasses( oSettings );
						}
					}, 'sc' );
				
				
					/*
					 * Final init
					 * Cache the header, body and footer as required, creating them if needed
					 */
				
					// Work around for Webkit bug 83867 - store the caption-side before removing from doc
					var captions = $this.children('caption').each( function () {
						this._captionSide = $(this).css('caption-side');
					} );
				
					var thead = $this.children('thead');
					if ( thead.length === 0 ) {
						thead = $('<thead/>').appendTo($this);
					}
					oSettings.nTHead = thead[0];
				
					var tbody = $this.children('tbody');
					if ( tbody.length === 0 ) {
						tbody = $('<tbody/>').appendTo($this);
					}
					oSettings.nTBody = tbody[0];
				
					var tfoot = $this.children('tfoot');
					if ( tfoot.length === 0 && captions.length > 0 && (oSettings.oScroll.sX !== "" || oSettings.oScroll.sY !== "") ) {
						// If we are a scrolling table, and no footer has been given, then we need to create
						// a tfoot element for the caption element to be appended to
						tfoot = $('<tfoot/>').appendTo($this);
					}
				
					if ( tfoot.length === 0 || tfoot.children().length === 0 ) {
						$this.addClass( oClasses.sNoFooter );
					}
					else if ( tfoot.length > 0 ) {
						oSettings.nTFoot = tfoot[0];
						_fnDetectHeader( oSettings.aoFooter, oSettings.nTFoot );
					}
				
					/* Check if there is data passing into the constructor */
					if ( oInit.aaData ) {
						for ( i=0 ; i<oInit.aaData.length ; i++ ) {
							_fnAddData( oSettings, oInit.aaData[ i ] );
						}
					}
					else if ( oSettings.bDeferLoading || _fnDataSource( oSettings ) == 'dom' ) {
						/* Grab the data from the page - only do this when deferred loading or no Ajax
						 * source since there is no point in reading the DOM data if we are then going
						 * to replace it with Ajax data
						 */
						_fnAddTr( oSettings, $(oSettings.nTBody).children('tr') );
					}
				
					/* Copy the data index array */
					oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
				
					/* Initialisation complete - table can be drawn */
					oSettings.bInitialised = true;
				
					/* Check if we need to initialise the table (it might not have been handed off to the
					 * language processor)
					 */
					if ( bInitHandedOff === false ) {
						_fnInitialise( oSettings );
					}
				};
				
				/* Must be done after everything which can be overridden by the state saving! */
				if ( oInit.bStateSave )
				{
					features.bStateSave = true;
					_fnCallbackReg( oSettings, 'aoDrawCallback', _fnSaveState, 'state_save' );
					_fnLoadState( oSettings, oInit, loadedInit );
				}
				else {
					loadedInit();
				}
				
			} );
			_that = null;
			return this;
		};
	
		
		/*
		 * It is useful to have variables which are scoped locally so only the
		 * DataTables functions can access them and they don't leak into global space.
		 * At the same time these functions are often useful over multiple files in the
		 * core and API, so we list, or at least document, all variables which are used
		 * by DataTables as private variables here. This also ensures that there is no
		 * clashing of variable names and that they can easily referenced for reuse.
		 */
		
		
		// Defined else where
		//  _selector_run
		//  _selector_opts
		//  _selector_first
		//  _selector_row_indexes
		
		var _ext; // DataTable.ext
		var _Api; // DataTable.Api
		var _api_register; // DataTable.Api.register
		var _api_registerPlural; // DataTable.Api.registerPlural
		
		var _re_dic = {};
		var _re_new_lines = /[\r\n]/g;
		var _re_html = /<.*?>/g;
		
		// This is not strict ISO8601 - Date.parse() is quite lax, although
		// implementations differ between browsers.
		var _re_date = /^\d{2,4}[\.\/\-]\d{1,2}[\.\/\-]\d{1,2}([T ]{1}\d{1,2}[:\.]\d{2}([\.:]\d{2})?)?$/;
		
		// Escape regular expression special characters
		var _re_escape_regex = new RegExp( '(\\' + [ '/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\', '$', '^', '-' ].join('|\\') + ')', 'g' );
		
		// http://en.wikipedia.org/wiki/Foreign_exchange_market
		// - \u20BD - Russian ruble.
		// - \u20a9 - South Korean Won
		// - \u20BA - Turkish Lira
		// - \u20B9 - Indian Rupee
		// - R - Brazil (R$) and South Africa
		// - fr - Swiss Franc
		// - kr - Swedish krona, Norwegian krone and Danish krone
		// - \u2009 is thin space and \u202F is narrow no-break space, both used in many
		// - Ƀ - Bitcoin
		// - Ξ - Ethereum
		//   standards as thousands separators.
		var _re_formatted_numeric = /[',$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfkɃΞ]/gi;
		
		
		var _empty = function ( d ) {
			return !d || d === true || d === '-' ? true : false;
		};
		
		
		var _intVal = function ( s ) {
			var integer = parseInt( s, 10 );
			return !isNaN(integer) && isFinite(s) ? integer : null;
		};
		
		// Convert from a formatted number with characters other than `.` as the
		// decimal place, to a Javascript number
		var _numToDecimal = function ( num, decimalPoint ) {
			// Cache created regular expressions for speed as this function is called often
			if ( ! _re_dic[ decimalPoint ] ) {
				_re_dic[ decimalPoint ] = new RegExp( _fnEscapeRegex( decimalPoint ), 'g' );
			}
			return typeof num === 'string' && decimalPoint !== '.' ?
				num.replace( /\./g, '' ).replace( _re_dic[ decimalPoint ], '.' ) :
				num;
		};
		
		
		var _isNumber = function ( d, decimalPoint, formatted ) {
			var strType = typeof d === 'string';
		
			// If empty return immediately so there must be a number if it is a
			// formatted string (this stops the string "k", or "kr", etc being detected
			// as a formatted number for currency
			if ( _empty( d ) ) {
				return true;
			}
		
			if ( decimalPoint && strType ) {
				d = _numToDecimal( d, decimalPoint );
			}
		
			if ( formatted && strType ) {
				d = d.replace( _re_formatted_numeric, '' );
			}
		
			return !isNaN( parseFloat(d) ) && isFinite( d );
		};
		
		
		// A string without HTML in it can be considered to be HTML still
		var _isHtml = function ( d ) {
			return _empty( d ) || typeof d === 'string';
		};
		
		
		var _htmlNumeric = function ( d, decimalPoint, formatted ) {
			if ( _empty( d ) ) {
				return true;
			}
		
			var html = _isHtml( d );
			return ! html ?
				null :
				_isNumber( _stripHtml( d ), decimalPoint, formatted ) ?
					true :
					null;
		};
		
		
		var _pluck = function ( a, prop, prop2 ) {
			var out = [];
			var i=0, ien=a.length;
		
			// Could have the test in the loop for slightly smaller code, but speed
			// is essential here
			if ( prop2 !== undefined ) {
				for ( ; i<ien ; i++ ) {
					if ( a[i] && a[i][ prop ] ) {
						out.push( a[i][ prop ][ prop2 ] );
					}
				}
			}
			else {
				for ( ; i<ien ; i++ ) {
					if ( a[i] ) {
						out.push( a[i][ prop ] );
					}
				}
			}
		
			return out;
		};
		
		
		// Basically the same as _pluck, but rather than looping over `a` we use `order`
		// as the indexes to pick from `a`
		var _pluck_order = function ( a, order, prop, prop2 )
		{
			var out = [];
			var i=0, ien=order.length;
		
			// Could have the test in the loop for slightly smaller code, but speed
			// is essential here
			if ( prop2 !== undefined ) {
				for ( ; i<ien ; i++ ) {
					if ( a[ order[i] ][ prop ] ) {
						out.push( a[ order[i] ][ prop ][ prop2 ] );
					}
				}
			}
			else {
				for ( ; i<ien ; i++ ) {
					out.push( a[ order[i] ][ prop ] );
				}
			}
		
			return out;
		};
		
		
		var _range = function ( len, start )
		{
			var out = [];
			var end;
		
			if ( start === undefined ) {
				start = 0;
				end = len;
			}
			else {
				end = start;
				start = len;
			}
		
			for ( var i=start ; i<end ; i++ ) {
				out.push( i );
			}
		
			return out;
		};
		
		
		var _removeEmpty = function ( a )
		{
			var out = [];
		
			for ( var i=0, ien=a.length ; i<ien ; i++ ) {
				if ( a[i] ) { // careful - will remove all falsy values!
					out.push( a[i] );
				}
			}
		
			return out;
		};
		
		
		var _stripHtml = function ( d ) {
			return d.replace( _re_html, '' );
		};
		
		
		/**
		 * Determine if all values in the array are unique. This means we can short
		 * cut the _unique method at the cost of a single loop. A sorted array is used
		 * to easily check the values.
		 *
		 * @param  {array} src Source array
		 * @return {boolean} true if all unique, false otherwise
		 * @ignore
		 */
		var _areAllUnique = function ( src ) {
			if ( src.length < 2 ) {
				return true;
			}
		
			var sorted = src.slice().sort();
			var last = sorted[0];
		
			for ( var i=1, ien=sorted.length ; i<ien ; i++ ) {
				if ( sorted[i] === last ) {
					return false;
				}
		
				last = sorted[i];
			}
		
			return true;
		};
		
		
		/**
		 * Find the unique elements in a source array.
		 *
		 * @param  {array} src Source array
		 * @return {array} Array of unique items
		 * @ignore
		 */
		var _unique = function ( src )
		{
			if ( _areAllUnique( src ) ) {
				return src.slice();
			}
		
			// A faster unique method is to use object keys to identify used values,
			// but this doesn't work with arrays or objects, which we must also
			// consider. See jsperf.com/compare-array-unique-versions/4 for more
			// information.
			var
				out = [],
				val,
				i, ien=src.length,
				j, k=0;
		
			again: for ( i=0 ; i<ien ; i++ ) {
				val = src[i];
		
				for ( j=0 ; j<k ; j++ ) {
					if ( out[j] === val ) {
						continue again;
					}
				}
		
				out.push( val );
				k++;
			}
		
			return out;
		};
		
		
		/**
		 * DataTables utility methods
		 * 
		 * This namespace provides helper methods that DataTables uses internally to
		 * create a DataTable, but which are not exclusively used only for DataTables.
		 * These methods can be used by extension authors to save the duplication of
		 * code.
		 *
		 *  @namespace
		 */
		DataTable.util = {
			/**
			 * Throttle the calls to a function. Arguments and context are maintained
			 * for the throttled function.
			 *
			 * @param {function} fn Function to be called
			 * @param {integer} freq Call frequency in mS
			 * @return {function} Wrapped function
			 */
			throttle: function ( fn, freq ) {
				var
					frequency = freq !== undefined ? freq : 200,
					last,
					timer;
		
				return function () {
					var
						that = this,
						now  = +new Date(),
						args = arguments;
		
					if ( last && now < last + frequency ) {
						clearTimeout( timer );
		
						timer = setTimeout( function () {
							last = undefined;
							fn.apply( that, args );
						}, frequency );
					}
					else {
						last = now;
						fn.apply( that, args );
					}
				};
			},
		
		
			/**
			 * Escape a string such that it can be used in a regular expression
			 *
			 *  @param {string} val string to escape
			 *  @returns {string} escaped string
			 */
			escapeRegex: function ( val ) {
				return val.replace( _re_escape_regex, '\\$1' );
			}
		};
		
		
		
		/**
		 * Create a mapping object that allows camel case parameters to be looked up
		 * for their Hungarian counterparts. The mapping is stored in a private
		 * parameter called `_hungarianMap` which can be accessed on the source object.
		 *  @param {object} o
		 *  @memberof DataTable#oApi
		 */
		function _fnHungarianMap ( o )
		{
			var
				hungarian = 'a aa ai ao as b fn i m o s ',
				match,
				newKey,
				map = {};
		
			$.each( o, function (key, val) {
				match = key.match(/^([^A-Z]+?)([A-Z])/);
		
				if ( match && hungarian.indexOf(match[1]+' ') !== -1 )
				{
					newKey = key.replace( match[0], match[2].toLowerCase() );
					map[ newKey ] = key;
		
					if ( match[1] === 'o' )
					{
						_fnHungarianMap( o[key] );
					}
				}
			} );
		
			o._hungarianMap = map;
		}
		
		
		/**
		 * Convert from camel case parameters to Hungarian, based on a Hungarian map
		 * created by _fnHungarianMap.
		 *  @param {object} src The model object which holds all parameters that can be
		 *    mapped.
		 *  @param {object} user The object to convert from camel case to Hungarian.
		 *  @param {boolean} force When set to `true`, properties which already have a
		 *    Hungarian value in the `user` object will be overwritten. Otherwise they
		 *    won't be.
		 *  @memberof DataTable#oApi
		 */
		function _fnCamelToHungarian ( src, user, force )
		{
			if ( ! src._hungarianMap ) {
				_fnHungarianMap( src );
			}
		
			var hungarianKey;
		
			$.each( user, function (key, val) {
				hungarianKey = src._hungarianMap[ key ];
		
				if ( hungarianKey !== undefined && (force || user[hungarianKey] === undefined) )
				{
					// For objects, we need to buzz down into the object to copy parameters
					if ( hungarianKey.charAt(0) === 'o' )
					{
						// Copy the camelCase options over to the hungarian
						if ( ! user[ hungarianKey ] ) {
							user[ hungarianKey ] = {};
						}
						$.extend( true, user[hungarianKey], user[key] );
		
						_fnCamelToHungarian( src[hungarianKey], user[hungarianKey], force );
					}
					else {
						user[hungarianKey] = user[ key ];
					}
				}
			} );
		}
		
		
		/**
		 * Language compatibility - when certain options are given, and others aren't, we
		 * need to duplicate the values over, in order to provide backwards compatibility
		 * with older language files.
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnLanguageCompat( lang )
		{
			// Note the use of the Hungarian notation for the parameters in this method as
			// this is called after the mapping of camelCase to Hungarian
			var defaults = DataTable.defaults.oLanguage;
		
			// Default mapping
			var defaultDecimal = defaults.sDecimal;
			if ( defaultDecimal ) {
				_addNumericSort( defaultDecimal );
			}
		
			if ( lang ) {
				var zeroRecords = lang.sZeroRecords;
		
				// Backwards compatibility - if there is no sEmptyTable given, then use the same as
				// sZeroRecords - assuming that is given.
				if ( ! lang.sEmptyTable && zeroRecords &&
					defaults.sEmptyTable === "No data available in table" )
				{
					_fnMap( lang, lang, 'sZeroRecords', 'sEmptyTable' );
				}
		
				// Likewise with loading records
				if ( ! lang.sLoadingRecords && zeroRecords &&
					defaults.sLoadingRecords === "Loading..." )
				{
					_fnMap( lang, lang, 'sZeroRecords', 'sLoadingRecords' );
				}
		
				// Old parameter name of the thousands separator mapped onto the new
				if ( lang.sInfoThousands ) {
					lang.sThousands = lang.sInfoThousands;
				}
		
				var decimal = lang.sDecimal;
				if ( decimal && defaultDecimal !== decimal ) {
					_addNumericSort( decimal );
				}
			}
		}
		
		
		/**
		 * Map one parameter onto another
		 *  @param {object} o Object to map
		 *  @param {*} knew The new parameter name
		 *  @param {*} old The old parameter name
		 */
		var _fnCompatMap = function ( o, knew, old ) {
			if ( o[ knew ] !== undefined ) {
				o[ old ] = o[ knew ];
			}
		};
		
		
		/**
		 * Provide backwards compatibility for the main DT options. Note that the new
		 * options are mapped onto the old parameters, so this is an external interface
		 * change only.
		 *  @param {object} init Object to map
		 */
		function _fnCompatOpts ( init )
		{
			_fnCompatMap( init, 'ordering',      'bSort' );
			_fnCompatMap( init, 'orderMulti',    'bSortMulti' );
			_fnCompatMap( init, 'orderClasses',  'bSortClasses' );
			_fnCompatMap( init, 'orderCellsTop', 'bSortCellsTop' );
			_fnCompatMap( init, 'order',         'aaSorting' );
			_fnCompatMap( init, 'orderFixed',    'aaSortingFixed' );
			_fnCompatMap( init, 'paging',        'bPaginate' );
			_fnCompatMap( init, 'pagingType',    'sPaginationType' );
			_fnCompatMap( init, 'pageLength',    'iDisplayLength' );
			_fnCompatMap( init, 'searching',     'bFilter' );
		
			// Boolean initialisation of x-scrolling
			if ( typeof init.sScrollX === 'boolean' ) {
				init.sScrollX = init.sScrollX ? '100%' : '';
			}
			if ( typeof init.scrollX === 'boolean' ) {
				init.scrollX = init.scrollX ? '100%' : '';
			}
		
			// Column search objects are in an array, so it needs to be converted
			// element by element
			var searchCols = init.aoSearchCols;
		
			if ( searchCols ) {
				for ( var i=0, ien=searchCols.length ; i<ien ; i++ ) {
					if ( searchCols[i] ) {
						_fnCamelToHungarian( DataTable.models.oSearch, searchCols[i] );
					}
				}
			}
		}
		
		
		/**
		 * Provide backwards compatibility for column options. Note that the new options
		 * are mapped onto the old parameters, so this is an external interface change
		 * only.
		 *  @param {object} init Object to map
		 */
		function _fnCompatCols ( init )
		{
			_fnCompatMap( init, 'orderable',     'bSortable' );
			_fnCompatMap( init, 'orderData',     'aDataSort' );
			_fnCompatMap( init, 'orderSequence', 'asSorting' );
			_fnCompatMap( init, 'orderDataType', 'sortDataType' );
		
			// orderData can be given as an integer
			var dataSort = init.aDataSort;
			if ( typeof dataSort === 'number' && ! $.isArray( dataSort ) ) {
				init.aDataSort = [ dataSort ];
			}
		}
		
		
		/**
		 * Browser feature detection for capabilities, quirks
		 *  @param {object} settings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnBrowserDetect( settings )
		{
			// We don't need to do this every time DataTables is constructed, the values
			// calculated are specific to the browser and OS configuration which we
			// don't expect to change between initialisations
			if ( ! DataTable.__browser ) {
				var browser = {};
				DataTable.__browser = browser;
		
				// Scrolling feature / quirks detection
				var n = $('<div/>')
					.css( {
						position: 'fixed',
						top: 0,
						left: $(window).scrollLeft()*-1, // allow for scrolling
						height: 1,
						width: 1,
						overflow: 'hidden'
					} )
					.append(
						$('<div/>')
							.css( {
								position: 'absolute',
								top: 1,
								left: 1,
								width: 100,
								overflow: 'scroll'
							} )
							.append(
								$('<div/>')
									.css( {
										width: '100%',
										height: 10
									} )
							)
					)
					.appendTo( 'body' );
		
				var outer = n.children();
				var inner = outer.children();
		
				// Numbers below, in order, are:
				// inner.offsetWidth, inner.clientWidth, outer.offsetWidth, outer.clientWidth
				//
				// IE6 XP:                           100 100 100  83
				// IE7 Vista:                        100 100 100  83
				// IE 8+ Windows:                     83  83 100  83
				// Evergreen Windows:                 83  83 100  83
				// Evergreen Mac with scrollbars:     85  85 100  85
				// Evergreen Mac without scrollbars: 100 100 100 100
		
				// Get scrollbar width
				browser.barWidth = outer[0].offsetWidth - outer[0].clientWidth;
		
				// IE6/7 will oversize a width 100% element inside a scrolling element, to
				// include the width of the scrollbar, while other browsers ensure the inner
				// element is contained without forcing scrolling
				browser.bScrollOversize = inner[0].offsetWidth === 100 && outer[0].clientWidth !== 100;
		
				// In rtl text layout, some browsers (most, but not all) will place the
				// scrollbar on the left, rather than the right.
				browser.bScrollbarLeft = Math.round( inner.offset().left ) !== 1;
		
				// IE8- don't provide height and width for getBoundingClientRect
				browser.bBounding = n[0].getBoundingClientRect().width ? true : false;
		
				n.remove();
			}
		
			$.extend( settings.oBrowser, DataTable.__browser );
			settings.oScroll.iBarWidth = DataTable.__browser.barWidth;
		}
		
		
		/**
		 * Array.prototype reduce[Right] method, used for browsers which don't support
		 * JS 1.6. Done this way to reduce code size, since we iterate either way
		 *  @param {object} settings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnReduce ( that, fn, init, start, end, inc )
		{
			var
				i = start,
				value,
				isSet = false;
		
			if ( init !== undefined ) {
				value = init;
				isSet = true;
			}
		
			while ( i !== end ) {
				if ( ! that.hasOwnProperty(i) ) {
					continue;
				}
		
				value = isSet ?
					fn( value, that[i], i, that ) :
					that[i];
		
				isSet = true;
				i += inc;
			}
		
			return value;
		}
		
		/**
		 * Add a column to the list used for the table with default values
		 *  @param {object} oSettings dataTables settings object
		 *  @param {node} nTh The th element for this column
		 *  @memberof DataTable#oApi
		 */
		function _fnAddColumn( oSettings, nTh )
		{
			// Add column to aoColumns array
			var oDefaults = DataTable.defaults.column;
			var iCol = oSettings.aoColumns.length;
			var oCol = $.extend( {}, DataTable.models.oColumn, oDefaults, {
				"nTh": nTh ? nTh : document.createElement('th'),
				"sTitle":    oDefaults.sTitle    ? oDefaults.sTitle    : nTh ? nTh.innerHTML : '',
				"aDataSort": oDefaults.aDataSort ? oDefaults.aDataSort : [iCol],
				"mData": oDefaults.mData ? oDefaults.mData : iCol,
				idx: iCol
			} );
			oSettings.aoColumns.push( oCol );
		
			// Add search object for column specific search. Note that the `searchCols[ iCol ]`
			// passed into extend can be undefined. This allows the user to give a default
			// with only some of the parameters defined, and also not give a default
			var searchCols = oSettings.aoPreSearchCols;
			searchCols[ iCol ] = $.extend( {}, DataTable.models.oSearch, searchCols[ iCol ] );
		
			// Use the default column options function to initialise classes etc
			_fnColumnOptions( oSettings, iCol, $(nTh).data() );
		}
		
		
		/**
		 * Apply options for a column
		 *  @param {object} oSettings dataTables settings object
		 *  @param {int} iCol column index to consider
		 *  @param {object} oOptions object with sType, bVisible and bSearchable etc
		 *  @memberof DataTable#oApi
		 */
		function _fnColumnOptions( oSettings, iCol, oOptions )
		{
			var oCol = oSettings.aoColumns[ iCol ];
			var oClasses = oSettings.oClasses;
			var th = $(oCol.nTh);
		
			// Try to get width information from the DOM. We can't get it from CSS
			// as we'd need to parse the CSS stylesheet. `width` option can override
			if ( ! oCol.sWidthOrig ) {
				// Width attribute
				oCol.sWidthOrig = th.attr('width') || null;
		
				// Style attribute
				var t = (th.attr('style') || '').match(/width:\s*(\d+[pxem%]+)/);
				if ( t ) {
					oCol.sWidthOrig = t[1];
				}
			}
		
			/* User specified column options */
			if ( oOptions !== undefined && oOptions !== null )
			{
				// Backwards compatibility
				_fnCompatCols( oOptions );
		
				// Map camel case parameters to their Hungarian counterparts
				_fnCamelToHungarian( DataTable.defaults.column, oOptions );
		
				/* Backwards compatibility for mDataProp */
				if ( oOptions.mDataProp !== undefined && !oOptions.mData )
				{
					oOptions.mData = oOptions.mDataProp;
				}
		
				if ( oOptions.sType )
				{
					oCol._sManualType = oOptions.sType;
				}
		
				// `class` is a reserved word in Javascript, so we need to provide
				// the ability to use a valid name for the camel case input
				if ( oOptions.className && ! oOptions.sClass )
				{
					oOptions.sClass = oOptions.className;
				}
				if ( oOptions.sClass ) {
					th.addClass( oOptions.sClass );
				}
		
				$.extend( oCol, oOptions );
				_fnMap( oCol, oOptions, "sWidth", "sWidthOrig" );
		
				/* iDataSort to be applied (backwards compatibility), but aDataSort will take
				 * priority if defined
				 */
				if ( oOptions.iDataSort !== undefined )
				{
					oCol.aDataSort = [ oOptions.iDataSort ];
				}
				_fnMap( oCol, oOptions, "aDataSort" );
			}
		
			/* Cache the data get and set functions for speed */
			var mDataSrc = oCol.mData;
			var mData = _fnGetObjectDataFn( mDataSrc );
			var mRender = oCol.mRender ? _fnGetObjectDataFn( oCol.mRender ) : null;
		
			var attrTest = function( src ) {
				return typeof src === 'string' && src.indexOf('@') !== -1;
			};
			oCol._bAttrSrc = $.isPlainObject( mDataSrc ) && (
				attrTest(mDataSrc.sort) || attrTest(mDataSrc.type) || attrTest(mDataSrc.filter)
			);
			oCol._setter = null;
		
			oCol.fnGetData = function (rowData, type, meta) {
				var innerData = mData( rowData, type, undefined, meta );
		
				return mRender && type ?
					mRender( innerData, type, rowData, meta ) :
					innerData;
			};
			oCol.fnSetData = function ( rowData, val, meta ) {
				return _fnSetObjectDataFn( mDataSrc )( rowData, val, meta );
			};
		
			// Indicate if DataTables should read DOM data as an object or array
			// Used in _fnGetRowElements
			if ( typeof mDataSrc !== 'number' ) {
				oSettings._rowReadObject = true;
			}
		
			/* Feature sorting overrides column specific when off */
			if ( !oSettings.oFeatures.bSort )
			{
				oCol.bSortable = false;
				th.addClass( oClasses.sSortableNone ); // Have to add class here as order event isn't called
			}
		
			/* Check that the class assignment is correct for sorting */
			var bAsc = $.inArray('asc', oCol.asSorting) !== -1;
			var bDesc = $.inArray('desc', oCol.asSorting) !== -1;
			if ( !oCol.bSortable || (!bAsc && !bDesc) )
			{
				oCol.sSortingClass = oClasses.sSortableNone;
				oCol.sSortingClassJUI = "";
			}
			else if ( bAsc && !bDesc )
			{
				oCol.sSortingClass = oClasses.sSortableAsc;
				oCol.sSortingClassJUI = oClasses.sSortJUIAscAllowed;
			}
			else if ( !bAsc && bDesc )
			{
				oCol.sSortingClass = oClasses.sSortableDesc;
				oCol.sSortingClassJUI = oClasses.sSortJUIDescAllowed;
			}
			else
			{
				oCol.sSortingClass = oClasses.sSortable;
				oCol.sSortingClassJUI = oClasses.sSortJUI;
			}
		}
		
		
		/**
		 * Adjust the table column widths for new data. Note: you would probably want to
		 * do a redraw after calling this function!
		 *  @param {object} settings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnAdjustColumnSizing ( settings )
		{
			/* Not interested in doing column width calculation if auto-width is disabled */
			if ( settings.oFeatures.bAutoWidth !== false )
			{
				var columns = settings.aoColumns;
		
				_fnCalculateColumnWidths( settings );
				for ( var i=0 , iLen=columns.length ; i<iLen ; i++ )
				{
					columns[i].nTh.style.width = columns[i].sWidth;
				}
			}
		
			var scroll = settings.oScroll;
			if ( scroll.sY !== '' || scroll.sX !== '')
			{
				_fnScrollDraw( settings );
			}
		
			_fnCallbackFire( settings, null, 'column-sizing', [settings] );
		}
		
		
		/**
		 * Covert the index of a visible column to the index in the data array (take account
		 * of hidden columns)
		 *  @param {object} oSettings dataTables settings object
		 *  @param {int} iMatch Visible column index to lookup
		 *  @returns {int} i the data index
		 *  @memberof DataTable#oApi
		 */
		function _fnVisibleToColumnIndex( oSettings, iMatch )
		{
			var aiVis = _fnGetColumns( oSettings, 'bVisible' );
		
			return typeof aiVis[iMatch] === 'number' ?
				aiVis[iMatch] :
				null;
		}
		
		
		/**
		 * Covert the index of an index in the data array and convert it to the visible
		 *   column index (take account of hidden columns)
		 *  @param {int} iMatch Column index to lookup
		 *  @param {object} oSettings dataTables settings object
		 *  @returns {int} i the data index
		 *  @memberof DataTable#oApi
		 */
		function _fnColumnIndexToVisible( oSettings, iMatch )
		{
			var aiVis = _fnGetColumns( oSettings, 'bVisible' );
			var iPos = $.inArray( iMatch, aiVis );
		
			return iPos !== -1 ? iPos : null;
		}
		
		
		/**
		 * Get the number of visible columns
		 *  @param {object} oSettings dataTables settings object
		 *  @returns {int} i the number of visible columns
		 *  @memberof DataTable#oApi
		 */
		function _fnVisbleColumns( oSettings )
		{
			var vis = 0;
		
			// No reduce in IE8, use a loop for now
			$.each( oSettings.aoColumns, function ( i, col ) {
				if ( col.bVisible && $(col.nTh).css('display') !== 'none' ) {
					vis++;
				}
			} );
		
			return vis;
		}
		
		
		/**
		 * Get an array of column indexes that match a given property
		 *  @param {object} oSettings dataTables settings object
		 *  @param {string} sParam Parameter in aoColumns to look for - typically
		 *    bVisible or bSearchable
		 *  @returns {array} Array of indexes with matched properties
		 *  @memberof DataTable#oApi
		 */
		function _fnGetColumns( oSettings, sParam )
		{
			var a = [];
		
			$.map( oSettings.aoColumns, function(val, i) {
				if ( val[sParam] ) {
					a.push( i );
				}
			} );
		
			return a;
		}
		
		
		/**
		 * Calculate the 'type' of a column
		 *  @param {object} settings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnColumnTypes ( settings )
		{
			var columns = settings.aoColumns;
			var data = settings.aoData;
			var types = DataTable.ext.type.detect;
			var i, ien, j, jen, k, ken;
			var col, cell, detectedType, cache;
		
			// For each column, spin over the 
			for ( i=0, ien=columns.length ; i<ien ; i++ ) {
				col = columns[i];
				cache = [];
		
				if ( ! col.sType && col._sManualType ) {
					col.sType = col._sManualType;
				}
				else if ( ! col.sType ) {
					for ( j=0, jen=types.length ; j<jen ; j++ ) {
						for ( k=0, ken=data.length ; k<ken ; k++ ) {
							// Use a cache array so we only need to get the type data
							// from the formatter once (when using multiple detectors)
							if ( cache[k] === undefined ) {
								cache[k] = _fnGetCellData( settings, k, i, 'type' );
							}
		
							detectedType = types[j]( cache[k], settings );
		
							// If null, then this type can't apply to this column, so
							// rather than testing all cells, break out. There is an
							// exception for the last type which is `html`. We need to
							// scan all rows since it is possible to mix string and HTML
							// types
							if ( ! detectedType && j !== types.length-1 ) {
								break;
							}
		
							// Only a single match is needed for html type since it is
							// bottom of the pile and very similar to string
							if ( detectedType === 'html' ) {
								break;
							}
						}
		
						// Type is valid for all data points in the column - use this
						// type
						if ( detectedType ) {
							col.sType = detectedType;
							break;
						}
					}
		
					// Fall back - if no type was detected, always use string
					if ( ! col.sType ) {
						col.sType = 'string';
					}
				}
			}
		}
		
		
		/**
		 * Take the column definitions and static columns arrays and calculate how
		 * they relate to column indexes. The callback function will then apply the
		 * definition found for a column to a suitable configuration object.
		 *  @param {object} oSettings dataTables settings object
		 *  @param {array} aoColDefs The aoColumnDefs array that is to be applied
		 *  @param {array} aoCols The aoColumns array that defines columns individually
		 *  @param {function} fn Callback function - takes two parameters, the calculated
		 *    column index and the definition for that column.
		 *  @memberof DataTable#oApi
		 */
		function _fnApplyColumnDefs( oSettings, aoColDefs, aoCols, fn )
		{
			var i, iLen, j, jLen, k, kLen, def;
			var columns = oSettings.aoColumns;
		
			// Column definitions with aTargets
			if ( aoColDefs )
			{
				/* Loop over the definitions array - loop in reverse so first instance has priority */
				for ( i=aoColDefs.length-1 ; i>=0 ; i-- )
				{
					def = aoColDefs[i];
		
					/* Each definition can target multiple columns, as it is an array */
					var aTargets = def.targets !== undefined ?
						def.targets :
						def.aTargets;
		
					if ( ! $.isArray( aTargets ) )
					{
						aTargets = [ aTargets ];
					}
		
					for ( j=0, jLen=aTargets.length ; j<jLen ; j++ )
					{
						if ( typeof aTargets[j] === 'number' && aTargets[j] >= 0 )
						{
							/* Add columns that we don't yet know about */
							while( columns.length <= aTargets[j] )
							{
								_fnAddColumn( oSettings );
							}
		
							/* Integer, basic index */
							fn( aTargets[j], def );
						}
						else if ( typeof aTargets[j] === 'number' && aTargets[j] < 0 )
						{
							/* Negative integer, right to left column counting */
							fn( columns.length+aTargets[j], def );
						}
						else if ( typeof aTargets[j] === 'string' )
						{
							/* Class name matching on TH element */
							for ( k=0, kLen=columns.length ; k<kLen ; k++ )
							{
								if ( aTargets[j] == "_all" ||
								     $(columns[k].nTh).hasClass( aTargets[j] ) )
								{
									fn( k, def );
								}
							}
						}
					}
				}
			}
		
			// Statically defined columns array
			if ( aoCols )
			{
				for ( i=0, iLen=aoCols.length ; i<iLen ; i++ )
				{
					fn( i, aoCols[i] );
				}
			}
		}
		
		/**
		 * Add a data array to the table, creating DOM node etc. This is the parallel to
		 * _fnGatherData, but for adding rows from a Javascript source, rather than a
		 * DOM source.
		 *  @param {object} oSettings dataTables settings object
		 *  @param {array} aData data array to be added
		 *  @param {node} [nTr] TR element to add to the table - optional. If not given,
		 *    DataTables will create a row automatically
		 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
		 *    if nTr is.
		 *  @returns {int} >=0 if successful (index of new aoData entry), -1 if failed
		 *  @memberof DataTable#oApi
		 */
		function _fnAddData ( oSettings, aDataIn, nTr, anTds )
		{
			/* Create the object for storing information about this new row */
			var iRow = oSettings.aoData.length;
			var oData = $.extend( true, {}, DataTable.models.oRow, {
				src: nTr ? 'dom' : 'data',
				idx: iRow
			} );
		
			oData._aData = aDataIn;
			oSettings.aoData.push( oData );
		
			/* Create the cells */
			var nTd, sThisType;
			var columns = oSettings.aoColumns;
		
			// Invalidate the column types as the new data needs to be revalidated
			for ( var i=0, iLen=columns.length ; i<iLen ; i++ )
			{
				columns[i].sType = null;
			}
		
			/* Add to the display array */
			oSettings.aiDisplayMaster.push( iRow );
		
			var id = oSettings.rowIdFn( aDataIn );
			if ( id !== undefined ) {
				oSettings.aIds[ id ] = oData;
			}
		
			/* Create the DOM information, or register it if already present */
			if ( nTr || ! oSettings.oFeatures.bDeferRender )
			{
				_fnCreateTr( oSettings, iRow, nTr, anTds );
			}
		
			return iRow;
		}
		
		
		/**
		 * Add one or more TR elements to the table. Generally we'd expect to
		 * use this for reading data from a DOM sourced table, but it could be
		 * used for an TR element. Note that if a TR is given, it is used (i.e.
		 * it is not cloned).
		 *  @param {object} settings dataTables settings object
		 *  @param {array|node|jQuery} trs The TR element(s) to add to the table
		 *  @returns {array} Array of indexes for the added rows
		 *  @memberof DataTable#oApi
		 */
		function _fnAddTr( settings, trs )
		{
			var row;
		
			// Allow an individual node to be passed in
			if ( ! (trs instanceof $) ) {
				trs = $(trs);
			}
		
			return trs.map( function (i, el) {
				row = _fnGetRowElements( settings, el );
				return _fnAddData( settings, row.data, el, row.cells );
			} );
		}
		
		
		/**
		 * Take a TR element and convert it to an index in aoData
		 *  @param {object} oSettings dataTables settings object
		 *  @param {node} n the TR element to find
		 *  @returns {int} index if the node is found, null if not
		 *  @memberof DataTable#oApi
		 */
		function _fnNodeToDataIndex( oSettings, n )
		{
			return (n._DT_RowIndex!==undefined) ? n._DT_RowIndex : null;
		}
		
		
		/**
		 * Take a TD element and convert it into a column data index (not the visible index)
		 *  @param {object} oSettings dataTables settings object
		 *  @param {int} iRow The row number the TD/TH can be found in
		 *  @param {node} n The TD/TH element to find
		 *  @returns {int} index if the node is found, -1 if not
		 *  @memberof DataTable#oApi
		 */
		function _fnNodeToColumnIndex( oSettings, iRow, n )
		{
			return $.inArray( n, oSettings.aoData[ iRow ].anCells );
		}
		
		
		/**
		 * Get the data for a given cell from the internal cache, taking into account data mapping
		 *  @param {object} settings dataTables settings object
		 *  @param {int} rowIdx aoData row id
		 *  @param {int} colIdx Column index
		 *  @param {string} type data get type ('display', 'type' 'filter' 'sort')
		 *  @returns {*} Cell data
		 *  @memberof DataTable#oApi
		 */
		function _fnGetCellData( settings, rowIdx, colIdx, type )
		{
			var draw           = settings.iDraw;
			var col            = settings.aoColumns[colIdx];
			var rowData        = settings.aoData[rowIdx]._aData;
			var defaultContent = col.sDefaultContent;
			var cellData       = col.fnGetData( rowData, type, {
				settings: settings,
				row:      rowIdx,
				col:      colIdx
			} );
		
			if ( cellData === undefined ) {
				if ( settings.iDrawError != draw && defaultContent === null ) {
					_fnLog( settings, 0, "Requested unknown parameter "+
						(typeof col.mData=='function' ? '{function}' : "'"+col.mData+"'")+
						" for row "+rowIdx+", column "+colIdx, 4 );
					settings.iDrawError = draw;
				}
				return defaultContent;
			}
		
			// When the data source is null and a specific data type is requested (i.e.
			// not the original data), we can use default column data
			if ( (cellData === rowData || cellData === null) && defaultContent !== null && type !== undefined ) {
				cellData = defaultContent;
			}
			else if ( typeof cellData === 'function' ) {
				// If the data source is a function, then we run it and use the return,
				// executing in the scope of the data object (for instances)
				return cellData.call( rowData );
			}
		
			if ( cellData === null && type == 'display' ) {
				return '';
			}
			return cellData;
		}
		
		
		/**
		 * Set the value for a specific cell, into the internal data cache
		 *  @param {object} settings dataTables settings object
		 *  @param {int} rowIdx aoData row id
		 *  @param {int} colIdx Column index
		 *  @param {*} val Value to set
		 *  @memberof DataTable#oApi
		 */
		function _fnSetCellData( settings, rowIdx, colIdx, val )
		{
			var col     = settings.aoColumns[colIdx];
			var rowData = settings.aoData[rowIdx]._aData;
		
			col.fnSetData( rowData, val, {
				settings: settings,
				row:      rowIdx,
				col:      colIdx
			}  );
		}
		
		
		// Private variable that is used to match action syntax in the data property object
		var __reArray = /\[.*?\]$/;
		var __reFn = /\(\)$/;
		
		/**
		 * Split string on periods, taking into account escaped periods
		 * @param  {string} str String to split
		 * @return {array} Split string
		 */
		function _fnSplitObjNotation( str )
		{
			return $.map( str.match(/(\\.|[^\.])+/g) || [''], function ( s ) {
				return s.replace(/\\\./g, '.');
			} );
		}
		
		
		/**
		 * Return a function that can be used to get data from a source object, taking
		 * into account the ability to use nested objects as a source
		 *  @param {string|int|function} mSource The data source for the object
		 *  @returns {function} Data get function
		 *  @memberof DataTable#oApi
		 */
		function _fnGetObjectDataFn( mSource )
		{
			if ( $.isPlainObject( mSource ) )
			{
				/* Build an object of get functions, and wrap them in a single call */
				var o = {};
				$.each( mSource, function (key, val) {
					if ( val ) {
						o[key] = _fnGetObjectDataFn( val );
					}
				} );
		
				return function (data, type, row, meta) {
					var t = o[type] || o._;
					return t !== undefined ?
						t(data, type, row, meta) :
						data;
				};
			}
			else if ( mSource === null )
			{
				/* Give an empty string for rendering / sorting etc */
				return function (data) { // type, row and meta also passed, but not used
					return data;
				};
			}
			else if ( typeof mSource === 'function' )
			{
				return function (data, type, row, meta) {
					return mSource( data, type, row, meta );
				};
			}
			else if ( typeof mSource === 'string' && (mSource.indexOf('.') !== -1 ||
				      mSource.indexOf('[') !== -1 || mSource.indexOf('(') !== -1) )
			{
				/* If there is a . in the source string then the data source is in a
				 * nested object so we loop over the data for each level to get the next
				 * level down. On each loop we test for undefined, and if found immediately
				 * return. This allows entire objects to be missing and sDefaultContent to
				 * be used if defined, rather than throwing an error
				 */
				var fetchData = function (data, type, src) {
					var arrayNotation, funcNotation, out, innerSrc;
		
					if ( src !== "" )
					{
						var a = _fnSplitObjNotation( src );
		
						for ( var i=0, iLen=a.length ; i<iLen ; i++ )
						{
							// Check if we are dealing with special notation
							arrayNotation = a[i].match(__reArray);
							funcNotation = a[i].match(__reFn);
		
							if ( arrayNotation )
							{
								// Array notation
								a[i] = a[i].replace(__reArray, '');
		
								// Condition allows simply [] to be passed in
								if ( a[i] !== "" ) {
									data = data[ a[i] ];
								}
								out = [];
		
								// Get the remainder of the nested object to get
								a.splice( 0, i+1 );
								innerSrc = a.join('.');
		
								// Traverse each entry in the array getting the properties requested
								if ( $.isArray( data ) ) {
									for ( var j=0, jLen=data.length ; j<jLen ; j++ ) {
										out.push( fetchData( data[j], type, innerSrc ) );
									}
								}
		
								// If a string is given in between the array notation indicators, that
								// is used to join the strings together, otherwise an array is returned
								var join = arrayNotation[0].substring(1, arrayNotation[0].length-1);
								data = (join==="") ? out : out.join(join);
		
								// The inner call to fetchData has already traversed through the remainder
								// of the source requested, so we exit from the loop
								break;
							}
							else if ( funcNotation )
							{
								// Function call
								a[i] = a[i].replace(__reFn, '');
								data = data[ a[i] ]();
								continue;
							}
		
							if ( data === null || data[ a[i] ] === undefined )
							{
								return undefined;
							}
							data = data[ a[i] ];
						}
					}
		
					return data;
				};
		
				return function (data, type) { // row and meta also passed, but not used
					return fetchData( data, type, mSource );
				};
			}
			else
			{
				/* Array or flat object mapping */
				return function (data, type) { // row and meta also passed, but not used
					return data[mSource];
				};
			}
		}
		
		
		/**
		 * Return a function that can be used to set data from a source object, taking
		 * into account the ability to use nested objects as a source
		 *  @param {string|int|function} mSource The data source for the object
		 *  @returns {function} Data set function
		 *  @memberof DataTable#oApi
		 */
		function _fnSetObjectDataFn( mSource )
		{
			if ( $.isPlainObject( mSource ) )
			{
				/* Unlike get, only the underscore (global) option is used for for
				 * setting data since we don't know the type here. This is why an object
				 * option is not documented for `mData` (which is read/write), but it is
				 * for `mRender` which is read only.
				 */
				return _fnSetObjectDataFn( mSource._ );
			}
			else if ( mSource === null )
			{
				/* Nothing to do when the data source is null */
				return function () {};
			}
			else if ( typeof mSource === 'function' )
			{
				return function (data, val, meta) {
					mSource( data, 'set', val, meta );
				};
			}
			else if ( typeof mSource === 'string' && (mSource.indexOf('.') !== -1 ||
				      mSource.indexOf('[') !== -1 || mSource.indexOf('(') !== -1) )
			{
				/* Like the get, we need to get data from a nested object */
				var setData = function (data, val, src) {
					var a = _fnSplitObjNotation( src ), b;
					var aLast = a[a.length-1];
					var arrayNotation, funcNotation, o, innerSrc;
		
					for ( var i=0, iLen=a.length-1 ; i<iLen ; i++ )
					{
						// Check if we are dealing with an array notation request
						arrayNotation = a[i].match(__reArray);
						funcNotation = a[i].match(__reFn);
		
						if ( arrayNotation )
						{
							a[i] = a[i].replace(__reArray, '');
							data[ a[i] ] = [];
		
							// Get the remainder of the nested object to set so we can recurse
							b = a.slice();
							b.splice( 0, i+1 );
							innerSrc = b.join('.');
		
							// Traverse each entry in the array setting the properties requested
							if ( $.isArray( val ) )
							{
								for ( var j=0, jLen=val.length ; j<jLen ; j++ )
								{
									o = {};
									setData( o, val[j], innerSrc );
									data[ a[i] ].push( o );
								}
							}
							else
							{
								// We've been asked to save data to an array, but it
								// isn't array data to be saved. Best that can be done
								// is to just save the value.
								data[ a[i] ] = val;
							}
		
							// The inner call to setData has already traversed through the remainder
							// of the source and has set the data, thus we can exit here
							return;
						}
						else if ( funcNotation )
						{
							// Function call
							a[i] = a[i].replace(__reFn, '');
							data = data[ a[i] ]( val );
						}
		
						// If the nested object doesn't currently exist - since we are
						// trying to set the value - create it
						if ( data[ a[i] ] === null || data[ a[i] ] === undefined )
						{
							data[ a[i] ] = {};
						}
						data = data[ a[i] ];
					}
		
					// Last item in the input - i.e, the actual set
					if ( aLast.match(__reFn ) )
					{
						// Function call
						data = data[ aLast.replace(__reFn, '') ]( val );
					}
					else
					{
						// If array notation is used, we just want to strip it and use the property name
						// and assign the value. If it isn't used, then we get the result we want anyway
						data[ aLast.replace(__reArray, '') ] = val;
					}
				};
		
				return function (data, val) { // meta is also passed in, but not used
					return setData( data, val, mSource );
				};
			}
			else
			{
				/* Array or flat object mapping */
				return function (data, val) { // meta is also passed in, but not used
					data[mSource] = val;
				};
			}
		}
		
		
		/**
		 * Return an array with the full table data
		 *  @param {object} oSettings dataTables settings object
		 *  @returns array {array} aData Master data array
		 *  @memberof DataTable#oApi
		 */
		function _fnGetDataMaster ( settings )
		{
			return _pluck( settings.aoData, '_aData' );
		}
		
		
		/**
		 * Nuke the table
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnClearTable( settings )
		{
			settings.aoData.length = 0;
			settings.aiDisplayMaster.length = 0;
			settings.aiDisplay.length = 0;
			settings.aIds = {};
		}
		
		
		 /**
		 * Take an array of integers (index array) and remove a target integer (value - not
		 * the key!)
		 *  @param {array} a Index array to target
		 *  @param {int} iTarget value to find
		 *  @memberof DataTable#oApi
		 */
		function _fnDeleteIndex( a, iTarget, splice )
		{
			var iTargetIndex = -1;
		
			for ( var i=0, iLen=a.length ; i<iLen ; i++ )
			{
				if ( a[i] == iTarget )
				{
					iTargetIndex = i;
				}
				else if ( a[i] > iTarget )
				{
					a[i]--;
				}
			}
		
			if ( iTargetIndex != -1 && splice === undefined )
			{
				a.splice( iTargetIndex, 1 );
			}
		}
		
		
		/**
		 * Mark cached data as invalid such that a re-read of the data will occur when
		 * the cached data is next requested. Also update from the data source object.
		 *
		 * @param {object} settings DataTables settings object
		 * @param {int}    rowIdx   Row index to invalidate
		 * @param {string} [src]    Source to invalidate from: undefined, 'auto', 'dom'
		 *     or 'data'
		 * @param {int}    [colIdx] Column index to invalidate. If undefined the whole
		 *     row will be invalidated
		 * @memberof DataTable#oApi
		 *
		 * @todo For the modularisation of v1.11 this will need to become a callback, so
		 *   the sort and filter methods can subscribe to it. That will required
		 *   initialisation options for sorting, which is why it is not already baked in
		 */
		function _fnInvalidate( settings, rowIdx, src, colIdx )
		{
			var row = settings.aoData[ rowIdx ];
			var i, ien;
			var cellWrite = function ( cell, col ) {
				// This is very frustrating, but in IE if you just write directly
				// to innerHTML, and elements that are overwritten are GC'ed,
				// even if there is a reference to them elsewhere
				while ( cell.childNodes.length ) {
					cell.removeChild( cell.firstChild );
				}
		
				cell.innerHTML = _fnGetCellData( settings, rowIdx, col, 'display' );
			};
		
			// Are we reading last data from DOM or the data object?
			if ( src === 'dom' || ((! src || src === 'auto') && row.src === 'dom') ) {
				// Read the data from the DOM
				row._aData = _fnGetRowElements(
						settings, row, colIdx, colIdx === undefined ? undefined : row._aData
					)
					.data;
			}
			else {
				// Reading from data object, update the DOM
				var cells = row.anCells;
		
				if ( cells ) {
					if ( colIdx !== undefined ) {
						cellWrite( cells[colIdx], colIdx );
					}
					else {
						for ( i=0, ien=cells.length ; i<ien ; i++ ) {
							cellWrite( cells[i], i );
						}
					}
				}
			}
		
			// For both row and cell invalidation, the cached data for sorting and
			// filtering is nulled out
			row._aSortData = null;
			row._aFilterData = null;
		
			// Invalidate the type for a specific column (if given) or all columns since
			// the data might have changed
			var cols = settings.aoColumns;
			if ( colIdx !== undefined ) {
				cols[ colIdx ].sType = null;
			}
			else {
				for ( i=0, ien=cols.length ; i<ien ; i++ ) {
					cols[i].sType = null;
				}
		
				// Update DataTables special `DT_*` attributes for the row
				_fnRowAttributes( settings, row );
			}
		}
		
		
		/**
		 * Build a data source object from an HTML row, reading the contents of the
		 * cells that are in the row.
		 *
		 * @param {object} settings DataTables settings object
		 * @param {node|object} TR element from which to read data or existing row
		 *   object from which to re-read the data from the cells
		 * @param {int} [colIdx] Optional column index
		 * @param {array|object} [d] Data source object. If `colIdx` is given then this
		 *   parameter should also be given and will be used to write the data into.
		 *   Only the column in question will be written
		 * @returns {object} Object with two parameters: `data` the data read, in
		 *   document order, and `cells` and array of nodes (they can be useful to the
		 *   caller, so rather than needing a second traversal to get them, just return
		 *   them from here).
		 * @memberof DataTable#oApi
		 */
		function _fnGetRowElements( settings, row, colIdx, d )
		{
			var
				tds = [],
				td = row.firstChild,
				name, col, o, i=0, contents,
				columns = settings.aoColumns,
				objectRead = settings._rowReadObject;
		
			// Allow the data object to be passed in, or construct
			d = d !== undefined ?
				d :
				objectRead ?
					{} :
					[];
		
			var attr = function ( str, td  ) {
				if ( typeof str === 'string' ) {
					var idx = str.indexOf('@');
		
					if ( idx !== -1 ) {
						var attr = str.substring( idx+1 );
						var setter = _fnSetObjectDataFn( str );
						setter( d, td.getAttribute( attr ) );
					}
				}
			};
		
			// Read data from a cell and store into the data object
			var cellProcess = function ( cell ) {
				if ( colIdx === undefined || colIdx === i ) {
					col = columns[i];
					contents = $.trim(cell.innerHTML);
		
					if ( col && col._bAttrSrc ) {
						var setter = _fnSetObjectDataFn( col.mData._ );
						setter( d, contents );
		
						attr( col.mData.sort, cell );
						attr( col.mData.type, cell );
						attr( col.mData.filter, cell );
					}
					else {
						// Depending on the `data` option for the columns the data can
						// be read to either an object or an array.
						if ( objectRead ) {
							if ( ! col._setter ) {
								// Cache the setter function
								col._setter = _fnSetObjectDataFn( col.mData );
							}
							col._setter( d, contents );
						}
						else {
							d[i] = contents;
						}
					}
				}
		
				i++;
			};
		
			if ( td ) {
				// `tr` element was passed in
				while ( td ) {
					name = td.nodeName.toUpperCase();
		
					if ( name == "TD" || name == "TH" ) {
						cellProcess( td );
						tds.push( td );
					}
		
					td = td.nextSibling;
				}
			}
			else {
				// Existing row object passed in
				tds = row.anCells;
		
				for ( var j=0, jen=tds.length ; j<jen ; j++ ) {
					cellProcess( tds[j] );
				}
			}
		
			// Read the ID from the DOM if present
			var rowNode = row.firstChild ? row : row.nTr;
		
			if ( rowNode ) {
				var id = rowNode.getAttribute( 'id' );
		
				if ( id ) {
					_fnSetObjectDataFn( settings.rowId )( d, id );
				}
			}
		
			return {
				data: d,
				cells: tds
			};
		}
		/**
		 * Create a new TR element (and it's TD children) for a row
		 *  @param {object} oSettings dataTables settings object
		 *  @param {int} iRow Row to consider
		 *  @param {node} [nTrIn] TR element to add to the table - optional. If not given,
		 *    DataTables will create a row automatically
		 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
		 *    if nTr is.
		 *  @memberof DataTable#oApi
		 */
		function _fnCreateTr ( oSettings, iRow, nTrIn, anTds )
		{
			var
				row = oSettings.aoData[iRow],
				rowData = row._aData,
				cells = [],
				nTr, nTd, oCol,
				i, iLen;
		
			if ( row.nTr === null )
			{
				nTr = nTrIn || document.createElement('tr');
		
				row.nTr = nTr;
				row.anCells = cells;
		
				/* Use a private property on the node to allow reserve mapping from the node
				 * to the aoData array for fast look up
				 */
				nTr._DT_RowIndex = iRow;
		
				/* Special parameters can be given by the data source to be used on the row */
				_fnRowAttributes( oSettings, row );
		
				/* Process each column */
				for ( i=0, iLen=oSettings.aoColumns.length ; i<iLen ; i++ )
				{
					oCol = oSettings.aoColumns[i];
		
					nTd = nTrIn ? anTds[i] : document.createElement( oCol.sCellType );
					nTd._DT_CellIndex = {
						row: iRow,
						column: i
					};
					
					cells.push( nTd );
		
					// Need to create the HTML if new, or if a rendering function is defined
					if ( (!nTrIn || oCol.mRender || oCol.mData !== i) &&
						 (!$.isPlainObject(oCol.mData) || oCol.mData._ !== i+'.display')
					) {
						nTd.innerHTML = _fnGetCellData( oSettings, iRow, i, 'display' );
					}
		
					/* Add user defined class */
					if ( oCol.sClass )
					{
						nTd.className += ' '+oCol.sClass;
					}
		
					// Visibility - add or remove as required
					if ( oCol.bVisible && ! nTrIn )
					{
						nTr.appendChild( nTd );
					}
					else if ( ! oCol.bVisible && nTrIn )
					{
						nTd.parentNode.removeChild( nTd );
					}
		
					if ( oCol.fnCreatedCell )
					{
						oCol.fnCreatedCell.call( oSettings.oInstance,
							nTd, _fnGetCellData( oSettings, iRow, i ), rowData, iRow, i
						);
					}
				}
		
				_fnCallbackFire( oSettings, 'aoRowCreatedCallback', null, [nTr, rowData, iRow, cells] );
			}
		
			// Remove once webkit bug 131819 and Chromium bug 365619 have been resolved
			// and deployed
			row.nTr.setAttribute( 'role', 'row' );
		}
		
		
		/**
		 * Add attributes to a row based on the special `DT_*` parameters in a data
		 * source object.
		 *  @param {object} settings DataTables settings object
		 *  @param {object} DataTables row object for the row to be modified
		 *  @memberof DataTable#oApi
		 */
		function _fnRowAttributes( settings, row )
		{
			var tr = row.nTr;
			var data = row._aData;
		
			if ( tr ) {
				var id = settings.rowIdFn( data );
		
				if ( id ) {
					tr.id = id;
				}
		
				if ( data.DT_RowClass ) {
					// Remove any classes added by DT_RowClass before
					var a = data.DT_RowClass.split(' ');
					row.__rowc = row.__rowc ?
						_unique( row.__rowc.concat( a ) ) :
						a;
		
					$(tr)
						.removeClass( row.__rowc.join(' ') )
						.addClass( data.DT_RowClass );
				}
		
				if ( data.DT_RowAttr ) {
					$(tr).attr( data.DT_RowAttr );
				}
		
				if ( data.DT_RowData ) {
					$(tr).data( data.DT_RowData );
				}
			}
		}
		
		
		/**
		 * Create the HTML header for the table
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnBuildHead( oSettings )
		{
			var i, ien, cell, row, column;
			var thead = oSettings.nTHead;
			var tfoot = oSettings.nTFoot;
			var createHeader = $('th, td', thead).length === 0;
			var classes = oSettings.oClasses;
			var columns = oSettings.aoColumns;
		
			if ( createHeader ) {
				row = $('<tr/>').appendTo( thead );
			}
		
			for ( i=0, ien=columns.length ; i<ien ; i++ ) {
				column = columns[i];
				cell = $( column.nTh ).addClass( column.sClass );
		
				if ( createHeader ) {
					cell.appendTo( row );
				}
		
				// 1.11 move into sorting
				if ( oSettings.oFeatures.bSort ) {
					cell.addClass( column.sSortingClass );
		
					if ( column.bSortable !== false ) {
						cell
							.attr( 'tabindex', oSettings.iTabIndex )
							.attr( 'aria-controls', oSettings.sTableId );
		
						_fnSortAttachListener( oSettings, column.nTh, i );
					}
				}
		
				if ( column.sTitle != cell[0].innerHTML ) {
					cell.html( column.sTitle );
				}
		
				_fnRenderer( oSettings, 'header' )(
					oSettings, cell, column, classes
				);
			}
		
			if ( createHeader ) {
				_fnDetectHeader( oSettings.aoHeader, thead );
			}
			
			/* ARIA role for the rows */
		 	$(thead).find('>tr').attr('role', 'row');
		
			/* Deal with the footer - add classes if required */
			$(thead).find('>tr>th, >tr>td').addClass( classes.sHeaderTH );
			$(tfoot).find('>tr>th, >tr>td').addClass( classes.sFooterTH );
		
			// Cache the footer cells. Note that we only take the cells from the first
			// row in the footer. If there is more than one row the user wants to
			// interact with, they need to use the table().foot() method. Note also this
			// allows cells to be used for multiple columns using colspan
			if ( tfoot !== null ) {
				var cells = oSettings.aoFooter[0];
		
				for ( i=0, ien=cells.length ; i<ien ; i++ ) {
					column = columns[i];
					column.nTf = cells[i].cell;
		
					if ( column.sClass ) {
						$(column.nTf).addClass( column.sClass );
					}
				}
			}
		}
		
		
		/**
		 * Draw the header (or footer) element based on the column visibility states. The
		 * methodology here is to use the layout array from _fnDetectHeader, modified for
		 * the instantaneous column visibility, to construct the new layout. The grid is
		 * traversed over cell at a time in a rows x columns grid fashion, although each
		 * cell insert can cover multiple elements in the grid - which is tracks using the
		 * aApplied array. Cell inserts in the grid will only occur where there isn't
		 * already a cell in that position.
		 *  @param {object} oSettings dataTables settings object
		 *  @param array {objects} aoSource Layout array from _fnDetectHeader
		 *  @param {boolean} [bIncludeHidden=false] If true then include the hidden columns in the calc,
		 *  @memberof DataTable#oApi
		 */
		function _fnDrawHead( oSettings, aoSource, bIncludeHidden )
		{
			var i, iLen, j, jLen, k, kLen, n, nLocalTr;
			var aoLocal = [];
			var aApplied = [];
			var iColumns = oSettings.aoColumns.length;
			var iRowspan, iColspan;
		
			if ( ! aoSource )
			{
				return;
			}
		
			if (  bIncludeHidden === undefined )
			{
				bIncludeHidden = false;
			}
		
			/* Make a copy of the master layout array, but without the visible columns in it */
			for ( i=0, iLen=aoSource.length ; i<iLen ; i++ )
			{
				aoLocal[i] = aoSource[i].slice();
				aoLocal[i].nTr = aoSource[i].nTr;
		
				/* Remove any columns which are currently hidden */
				for ( j=iColumns-1 ; j>=0 ; j-- )
				{
					if ( !oSettings.aoColumns[j].bVisible && !bIncludeHidden )
					{
						aoLocal[i].splice( j, 1 );
					}
				}
		
				/* Prep the applied array - it needs an element for each row */
				aApplied.push( [] );
			}
		
			for ( i=0, iLen=aoLocal.length ; i<iLen ; i++ )
			{
				nLocalTr = aoLocal[i].nTr;
		
				/* All cells are going to be replaced, so empty out the row */
				if ( nLocalTr )
				{
					while( (n = nLocalTr.firstChild) )
					{
						nLocalTr.removeChild( n );
					}
				}
		
				for ( j=0, jLen=aoLocal[i].length ; j<jLen ; j++ )
				{
					iRowspan = 1;
					iColspan = 1;
		
					/* Check to see if there is already a cell (row/colspan) covering our target
					 * insert point. If there is, then there is nothing to do.
					 */
					if ( aApplied[i][j] === undefined )
					{
						nLocalTr.appendChild( aoLocal[i][j].cell );
						aApplied[i][j] = 1;
		
						/* Expand the cell to cover as many rows as needed */
						while ( aoLocal[i+iRowspan] !== undefined &&
						        aoLocal[i][j].cell == aoLocal[i+iRowspan][j].cell )
						{
							aApplied[i+iRowspan][j] = 1;
							iRowspan++;
						}
		
						/* Expand the cell to cover as many columns as needed */
						while ( aoLocal[i][j+iColspan] !== undefined &&
						        aoLocal[i][j].cell == aoLocal[i][j+iColspan].cell )
						{
							/* Must update the applied array over the rows for the columns */
							for ( k=0 ; k<iRowspan ; k++ )
							{
								aApplied[i+k][j+iColspan] = 1;
							}
							iColspan++;
						}
		
						/* Do the actual expansion in the DOM */
						$(aoLocal[i][j].cell)
							.attr('rowspan', iRowspan)
							.attr('colspan', iColspan);
					}
				}
			}
		}
		
		
		/**
		 * Insert the required TR nodes into the table for display
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnDraw( oSettings )
		{
			/* Provide a pre-callback function which can be used to cancel the draw is false is returned */
			var aPreDraw = _fnCallbackFire( oSettings, 'aoPreDrawCallback', 'preDraw', [oSettings] );
			if ( $.inArray( false, aPreDraw ) !== -1 )
			{
				_fnProcessingDisplay( oSettings, false );
				return;
			}
		
			var i, iLen, n;
			var anRows = [];
			var iRowCount = 0;
			var asStripeClasses = oSettings.asStripeClasses;
			var iStripes = asStripeClasses.length;
			var iOpenRows = oSettings.aoOpenRows.length;
			var oLang = oSettings.oLanguage;
			var iInitDisplayStart = oSettings.iInitDisplayStart;
			var bServerSide = _fnDataSource( oSettings ) == 'ssp';
			var aiDisplay = oSettings.aiDisplay;
		
			oSettings.bDrawing = true;
		
			/* Check and see if we have an initial draw position from state saving */
			if ( iInitDisplayStart !== undefined && iInitDisplayStart !== -1 )
			{
				oSettings._iDisplayStart = bServerSide ?
					iInitDisplayStart :
					iInitDisplayStart >= oSettings.fnRecordsDisplay() ?
						0 :
						iInitDisplayStart;
		
				oSettings.iInitDisplayStart = -1;
			}
		
			var iDisplayStart = oSettings._iDisplayStart;
			var iDisplayEnd = oSettings.fnDisplayEnd();
		
			/* Server-side processing draw intercept */
			if ( oSettings.bDeferLoading )
			{
				oSettings.bDeferLoading = false;
				oSettings.iDraw++;
				_fnProcessingDisplay( oSettings, false );
			}
			else if ( !bServerSide )
			{
				oSettings.iDraw++;
			}
			else if ( !oSettings.bDestroying && !_fnAjaxUpdate( oSettings ) )
			{
				return;
			}
		
			if ( aiDisplay.length !== 0 )
			{
				var iStart = bServerSide ? 0 : iDisplayStart;
				var iEnd = bServerSide ? oSettings.aoData.length : iDisplayEnd;
		
				for ( var j=iStart ; j<iEnd ; j++ )
				{
					var iDataIndex = aiDisplay[j];
					var aoData = oSettings.aoData[ iDataIndex ];
					if ( aoData.nTr === null )
					{
						_fnCreateTr( oSettings, iDataIndex );
					}
		
					var nRow = aoData.nTr;
		
					/* Remove the old striping classes and then add the new one */
					if ( iStripes !== 0 )
					{
						var sStripe = asStripeClasses[ iRowCount % iStripes ];
						if ( aoData._sRowStripe != sStripe )
						{
							$(nRow).removeClass( aoData._sRowStripe ).addClass( sStripe );
							aoData._sRowStripe = sStripe;
						}
					}
		
					// Row callback functions - might want to manipulate the row
					// iRowCount and j are not currently documented. Are they at all
					// useful?
					_fnCallbackFire( oSettings, 'aoRowCallback', null,
						[nRow, aoData._aData, iRowCount, j, iDataIndex] );
		
					anRows.push( nRow );
					iRowCount++;
				}
			}
			else
			{
				/* Table is empty - create a row with an empty message in it */
				var sZero = oLang.sZeroRecords;
				if ( oSettings.iDraw == 1 &&  _fnDataSource( oSettings ) == 'ajax' )
				{
					sZero = oLang.sLoadingRecords;
				}
				else if ( oLang.sEmptyTable && oSettings.fnRecordsTotal() === 0 )
				{
					sZero = oLang.sEmptyTable;
				}
		
				anRows[ 0 ] = $( '<tr/>', { 'class': iStripes ? asStripeClasses[0] : '' } )
					.append( $('<td />', {
						'valign':  'top',
						'colSpan': _fnVisbleColumns( oSettings ),
						'class':   oSettings.oClasses.sRowEmpty
					} ).html( sZero ) )[0];
			}
		
			/* Header and footer callbacks */
			_fnCallbackFire( oSettings, 'aoHeaderCallback', 'header', [ $(oSettings.nTHead).children('tr')[0],
				_fnGetDataMaster( oSettings ), iDisplayStart, iDisplayEnd, aiDisplay ] );
		
			_fnCallbackFire( oSettings, 'aoFooterCallback', 'footer', [ $(oSettings.nTFoot).children('tr')[0],
				_fnGetDataMaster( oSettings ), iDisplayStart, iDisplayEnd, aiDisplay ] );
		
			var body = $(oSettings.nTBody);
		
			body.children().detach();
			body.append( $(anRows) );
		
			/* Call all required callback functions for the end of a draw */
			_fnCallbackFire( oSettings, 'aoDrawCallback', 'draw', [oSettings] );
		
			/* Draw is complete, sorting and filtering must be as well */
			oSettings.bSorted = false;
			oSettings.bFiltered = false;
			oSettings.bDrawing = false;
		}
		
		
		/**
		 * Redraw the table - taking account of the various features which are enabled
		 *  @param {object} oSettings dataTables settings object
		 *  @param {boolean} [holdPosition] Keep the current paging position. By default
		 *    the paging is reset to the first page
		 *  @memberof DataTable#oApi
		 */
		function _fnReDraw( settings, holdPosition )
		{
			var
				features = settings.oFeatures,
				sort     = features.bSort,
				filter   = features.bFilter;
		
			if ( sort ) {
				_fnSort( settings );
			}
		
			if ( filter ) {
				_fnFilterComplete( settings, settings.oPreviousSearch );
			}
			else {
				// No filtering, so we want to just use the display master
				settings.aiDisplay = settings.aiDisplayMaster.slice();
			}
		
			if ( holdPosition !== true ) {
				settings._iDisplayStart = 0;
			}
		
			// Let any modules know about the draw hold position state (used by
			// scrolling internally)
			settings._drawHold = holdPosition;
		
			_fnDraw( settings );
		
			settings._drawHold = false;
		}
		
		
		/**
		 * Add the options to the page HTML for the table
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnAddOptionsHtml ( oSettings )
		{
			var classes = oSettings.oClasses;
			var table = $(oSettings.nTable);
			var holding = $('<div/>').insertBefore( table ); // Holding element for speed
			var features = oSettings.oFeatures;
		
			// All DataTables are wrapped in a div
			var insert = $('<div/>', {
				id:      oSettings.sTableId+'_wrapper',
				'class': classes.sWrapper + (oSettings.nTFoot ? '' : ' '+classes.sNoFooter)
			} );
		
			oSettings.nHolding = holding[0];
			oSettings.nTableWrapper = insert[0];
			oSettings.nTableReinsertBefore = oSettings.nTable.nextSibling;
		
			/* Loop over the user set positioning and place the elements as needed */
			var aDom = oSettings.sDom.split('');
			var featureNode, cOption, nNewNode, cNext, sAttr, j;
			for ( var i=0 ; i<aDom.length ; i++ )
			{
				featureNode = null;
				cOption = aDom[i];
		
				if ( cOption == '<' )
				{
					/* New container div */
					nNewNode = $('<div/>')[0];
		
					/* Check to see if we should append an id and/or a class name to the container */
					cNext = aDom[i+1];
					if ( cNext == "'" || cNext == '"' )
					{
						sAttr = "";
						j = 2;
						while ( aDom[i+j] != cNext )
						{
							sAttr += aDom[i+j];
							j++;
						}
		
						/* Replace jQuery UI constants @todo depreciated */
						if ( sAttr == "H" )
						{
							sAttr = classes.sJUIHeader;
						}
						else if ( sAttr == "F" )
						{
							sAttr = classes.sJUIFooter;
						}
		
						/* The attribute can be in the format of "#id.class", "#id" or "class" This logic
						 * breaks the string into parts and applies them as needed
						 */
						if ( sAttr.indexOf('.') != -1 )
						{
							var aSplit = sAttr.split('.');
							nNewNode.id = aSplit[0].substr(1, aSplit[0].length-1);
							nNewNode.className = aSplit[1];
						}
						else if ( sAttr.charAt(0) == "#" )
						{
							nNewNode.id = sAttr.substr(1, sAttr.length-1);
						}
						else
						{
							nNewNode.className = sAttr;
						}
		
						i += j; /* Move along the position array */
					}
		
					insert.append( nNewNode );
					insert = $(nNewNode);
				}
				else if ( cOption == '>' )
				{
					/* End container div */
					insert = insert.parent();
				}
				// @todo Move options into their own plugins?
				else if ( cOption == 'l' && features.bPaginate && features.bLengthChange )
				{
					/* Length */
					featureNode = _fnFeatureHtmlLength( oSettings );
				}
				else if ( cOption == 'f' && features.bFilter )
				{
					/* Filter */
					featureNode = _fnFeatureHtmlFilter( oSettings );
				}
				else if ( cOption == 'r' && features.bProcessing )
				{
					/* pRocessing */
					featureNode = _fnFeatureHtmlProcessing( oSettings );
				}
				else if ( cOption == 't' )
				{
					/* Table */
					featureNode = _fnFeatureHtmlTable( oSettings );
				}
				else if ( cOption ==  'i' && features.bInfo )
				{
					/* Info */
					featureNode = _fnFeatureHtmlInfo( oSettings );
				}
				else if ( cOption == 'p' && features.bPaginate )
				{
					/* Pagination */
					featureNode = _fnFeatureHtmlPaginate( oSettings );
				}
				else if ( DataTable.ext.feature.length !== 0 )
				{
					/* Plug-in features */
					var aoFeatures = DataTable.ext.feature;
					for ( var k=0, kLen=aoFeatures.length ; k<kLen ; k++ )
					{
						if ( cOption == aoFeatures[k].cFeature )
						{
							featureNode = aoFeatures[k].fnInit( oSettings );
							break;
						}
					}
				}
		
				/* Add to the 2D features array */
				if ( featureNode )
				{
					var aanFeatures = oSettings.aanFeatures;
		
					if ( ! aanFeatures[cOption] )
					{
						aanFeatures[cOption] = [];
					}
		
					aanFeatures[cOption].push( featureNode );
					insert.append( featureNode );
				}
			}
		
			/* Built our DOM structure - replace the holding div with what we want */
			holding.replaceWith( insert );
			oSettings.nHolding = null;
		}
		
		
		/**
		 * Use the DOM source to create up an array of header cells. The idea here is to
		 * create a layout grid (array) of rows x columns, which contains a reference
		 * to the cell that that point in the grid (regardless of col/rowspan), such that
		 * any column / row could be removed and the new grid constructed
		 *  @param array {object} aLayout Array to store the calculated layout in
		 *  @param {node} nThead The header/footer element for the table
		 *  @memberof DataTable#oApi
		 */
		function _fnDetectHeader ( aLayout, nThead )
		{
			var nTrs = $(nThead).children('tr');
			var nTr, nCell;
			var i, k, l, iLen, jLen, iColShifted, iColumn, iColspan, iRowspan;
			var bUnique;
			var fnShiftCol = function ( a, i, j ) {
				var k = a[i];
		                while ( k[j] ) {
					j++;
				}
				return j;
			};
		
			aLayout.splice( 0, aLayout.length );
		
			/* We know how many rows there are in the layout - so prep it */
			for ( i=0, iLen=nTrs.length ; i<iLen ; i++ )
			{
				aLayout.push( [] );
			}
		
			/* Calculate a layout array */
			for ( i=0, iLen=nTrs.length ; i<iLen ; i++ )
			{
				nTr = nTrs[i];
				iColumn = 0;
		
				/* For every cell in the row... */
				nCell = nTr.firstChild;
				while ( nCell ) {
					if ( nCell.nodeName.toUpperCase() == "TD" ||
					     nCell.nodeName.toUpperCase() == "TH" )
					{
						/* Get the col and rowspan attributes from the DOM and sanitise them */
						iColspan = nCell.getAttribute('colspan') * 1;
						iRowspan = nCell.getAttribute('rowspan') * 1;
						iColspan = (!iColspan || iColspan===0 || iColspan===1) ? 1 : iColspan;
						iRowspan = (!iRowspan || iRowspan===0 || iRowspan===1) ? 1 : iRowspan;
		
						/* There might be colspan cells already in this row, so shift our target
						 * accordingly
						 */
						iColShifted = fnShiftCol( aLayout, i, iColumn );
		
						/* Cache calculation for unique columns */
						bUnique = iColspan === 1 ? true : false;
		
						/* If there is col / rowspan, copy the information into the layout grid */
						for ( l=0 ; l<iColspan ; l++ )
						{
							for ( k=0 ; k<iRowspan ; k++ )
							{
								aLayout[i+k][iColShifted+l] = {
									"cell": nCell,
									"unique": bUnique
								};
								aLayout[i+k].nTr = nTr;
							}
						}
					}
					nCell = nCell.nextSibling;
				}
			}
		}
		
		
		/**
		 * Get an array of unique th elements, one for each column
		 *  @param {object} oSettings dataTables settings object
		 *  @param {node} nHeader automatically detect the layout from this node - optional
		 *  @param {array} aLayout thead/tfoot layout from _fnDetectHeader - optional
		 *  @returns array {node} aReturn list of unique th's
		 *  @memberof DataTable#oApi
		 */
		function _fnGetUniqueThs ( oSettings, nHeader, aLayout )
		{
			var aReturn = [];
			if ( !aLayout )
			{
				aLayout = oSettings.aoHeader;
				if ( nHeader )
				{
					aLayout = [];
					_fnDetectHeader( aLayout, nHeader );
				}
			}
		
			for ( var i=0, iLen=aLayout.length ; i<iLen ; i++ )
			{
				for ( var j=0, jLen=aLayout[i].length ; j<jLen ; j++ )
				{
					if ( aLayout[i][j].unique &&
						 (!aReturn[j] || !oSettings.bSortCellsTop) )
					{
						aReturn[j] = aLayout[i][j].cell;
					}
				}
			}
		
			return aReturn;
		}
		
		/**
		 * Create an Ajax call based on the table's settings, taking into account that
		 * parameters can have multiple forms, and backwards compatibility.
		 *
		 * @param {object} oSettings dataTables settings object
		 * @param {array} data Data to send to the server, required by
		 *     DataTables - may be augmented by developer callbacks
		 * @param {function} fn Callback function to run when data is obtained
		 */
		function _fnBuildAjax( oSettings, data, fn )
		{
			// Compatibility with 1.9-, allow fnServerData and event to manipulate
			_fnCallbackFire( oSettings, 'aoServerParams', 'serverParams', [data] );
		
			// Convert to object based for 1.10+ if using the old array scheme which can
			// come from server-side processing or serverParams
			if ( data && $.isArray(data) ) {
				var tmp = {};
				var rbracket = /(.*?)\[\]$/;
		
				$.each( data, function (key, val) {
					var match = val.name.match(rbracket);
		
					if ( match ) {
						// Support for arrays
						var name = match[0];
		
						if ( ! tmp[ name ] ) {
							tmp[ name ] = [];
						}
						tmp[ name ].push( val.value );
					}
					else {
						tmp[val.name] = val.value;
					}
				} );
				data = tmp;
			}
		
			var ajaxData;
			var ajax = oSettings.ajax;
			var instance = oSettings.oInstance;
			var callback = function ( json ) {
				_fnCallbackFire( oSettings, null, 'xhr', [oSettings, json, oSettings.jqXHR] );
				fn( json );
			};
		
			if ( $.isPlainObject( ajax ) && ajax.data )
			{
				ajaxData = ajax.data;
		
				var newData = typeof ajaxData === 'function' ?
					ajaxData( data, oSettings ) :  // fn can manipulate data or return
					ajaxData;                      // an object object or array to merge
		
				// If the function returned something, use that alone
				data = typeof ajaxData === 'function' && newData ?
					newData :
					$.extend( true, data, newData );
		
				// Remove the data property as we've resolved it already and don't want
				// jQuery to do it again (it is restored at the end of the function)
				delete ajax.data;
			}
		
			var baseAjax = {
				"data": data,
				"success": function (json) {
					var error = json.error || json.sError;
					if ( error ) {
						_fnLog( oSettings, 0, error );
					}
		
					oSettings.json = json;
					callback( json );
				},
				"dataType": "json",
				"cache": false,
				"type": oSettings.sServerMethod,
				"error": function (xhr, error, thrown) {
					var ret = _fnCallbackFire( oSettings, null, 'xhr', [oSettings, null, oSettings.jqXHR] );
		
					if ( $.inArray( true, ret ) === -1 ) {
						if ( error == "parsererror" ) {
							_fnLog( oSettings, 0, 'Invalid JSON response', 1 );
						}
						else if ( xhr.readyState === 4 ) {
							_fnLog( oSettings, 0, 'Ajax error', 7 );
						}
					}
		
					_fnProcessingDisplay( oSettings, false );
				}
			};
		
			// Store the data submitted for the API
			oSettings.oAjaxData = data;
		
			// Allow plug-ins and external processes to modify the data
			_fnCallbackFire( oSettings, null, 'preXhr', [oSettings, data] );
		
			if ( oSettings.fnServerData )
			{
				// DataTables 1.9- compatibility
				oSettings.fnServerData.call( instance,
					oSettings.sAjaxSource,
					$.map( data, function (val, key) { // Need to convert back to 1.9 trad format
						return { name: key, value: val };
					} ),
					callback,
					oSettings
				);
			}
			else if ( oSettings.sAjaxSource || typeof ajax === 'string' )
			{
				// DataTables 1.9- compatibility
				oSettings.jqXHR = $.ajax( $.extend( baseAjax, {
					url: ajax || oSettings.sAjaxSource
				} ) );
			}
			else if ( typeof ajax === 'function' )
			{
				// Is a function - let the caller define what needs to be done
				oSettings.jqXHR = ajax.call( instance, data, callback, oSettings );
			}
			else
			{
				// Object to extend the base settings
				oSettings.jqXHR = $.ajax( $.extend( baseAjax, ajax ) );
		
				// Restore for next time around
				ajax.data = ajaxData;
			}
		}
		
		
		/**
		 * Update the table using an Ajax call
		 *  @param {object} settings dataTables settings object
		 *  @returns {boolean} Block the table drawing or not
		 *  @memberof DataTable#oApi
		 */
		function _fnAjaxUpdate( settings )
		{
			if ( settings.bAjaxDataGet ) {
				settings.iDraw++;
				_fnProcessingDisplay( settings, true );
		
				_fnBuildAjax(
					settings,
					_fnAjaxParameters( settings ),
					function(json) {
						_fnAjaxUpdateDraw( settings, json );
					}
				);
		
				return false;
			}
			return true;
		}
		
		
		/**
		 * Build up the parameters in an object needed for a server-side processing
		 * request. Note that this is basically done twice, is different ways - a modern
		 * method which is used by default in DataTables 1.10 which uses objects and
		 * arrays, or the 1.9- method with is name / value pairs. 1.9 method is used if
		 * the sAjaxSource option is used in the initialisation, or the legacyAjax
		 * option is set.
		 *  @param {object} oSettings dataTables settings object
		 *  @returns {bool} block the table drawing or not
		 *  @memberof DataTable#oApi
		 */
		function _fnAjaxParameters( settings )
		{
			var
				columns = settings.aoColumns,
				columnCount = columns.length,
				features = settings.oFeatures,
				preSearch = settings.oPreviousSearch,
				preColSearch = settings.aoPreSearchCols,
				i, data = [], dataProp, column, columnSearch,
				sort = _fnSortFlatten( settings ),
				displayStart = settings._iDisplayStart,
				displayLength = features.bPaginate !== false ?
					settings._iDisplayLength :
					-1;
		
			var param = function ( name, value ) {
				data.push( { 'name': name, 'value': value } );
			};
		
			// DataTables 1.9- compatible method
			param( 'sEcho',          settings.iDraw );
			param( 'iColumns',       columnCount );
			param( 'sColumns',       _pluck( columns, 'sName' ).join(',') );
			param( 'iDisplayStart',  displayStart );
			param( 'iDisplayLength', displayLength );
		
			// DataTables 1.10+ method
			var d = {
				draw:    settings.iDraw,
				columns: [],
				order:   [],
				start:   displayStart,
				length:  displayLength,
				search:  {
					value: preSearch.sSearch,
					regex: preSearch.bRegex
				}
			};
		
			for ( i=0 ; i<columnCount ; i++ ) {
				column = columns[i];
				columnSearch = preColSearch[i];
				dataProp = typeof column.mData=="function" ? 'function' : column.mData ;
		
				d.columns.push( {
					data:       dataProp,
					name:       column.sName,
					searchable: column.bSearchable,
					orderable:  column.bSortable,
					search:     {
						value: columnSearch.sSearch,
						regex: columnSearch.bRegex
					}
				} );
		
				param( "mDataProp_"+i, dataProp );
		
				if ( features.bFilter ) {
					param( 'sSearch_'+i,     columnSearch.sSearch );
					param( 'bRegex_'+i,      columnSearch.bRegex );
					param( 'bSearchable_'+i, column.bSearchable );
				}
		
				if ( features.bSort ) {
					param( 'bSortable_'+i, column.bSortable );
				}
			}
		
			if ( features.bFilter ) {
				param( 'sSearch', preSearch.sSearch );
				param( 'bRegex', preSearch.bRegex );
			}
		
			if ( features.bSort ) {
				$.each( sort, function ( i, val ) {
					d.order.push( { column: val.col, dir: val.dir } );
		
					param( 'iSortCol_'+i, val.col );
					param( 'sSortDir_'+i, val.dir );
				} );
		
				param( 'iSortingCols', sort.length );
			}
		
			// If the legacy.ajax parameter is null, then we automatically decide which
			// form to use, based on sAjaxSource
			var legacy = DataTable.ext.legacy.ajax;
			if ( legacy === null ) {
				return settings.sAjaxSource ? data : d;
			}
		
			// Otherwise, if legacy has been specified then we use that to decide on the
			// form
			return legacy ? data : d;
		}
		
		
		/**
		 * Data the data from the server (nuking the old) and redraw the table
		 *  @param {object} oSettings dataTables settings object
		 *  @param {object} json json data return from the server.
		 *  @param {string} json.sEcho Tracking flag for DataTables to match requests
		 *  @param {int} json.iTotalRecords Number of records in the data set, not accounting for filtering
		 *  @param {int} json.iTotalDisplayRecords Number of records in the data set, accounting for filtering
		 *  @param {array} json.aaData The data to display on this page
		 *  @param {string} [json.sColumns] Column ordering (sName, comma separated)
		 *  @memberof DataTable#oApi
		 */
		function _fnAjaxUpdateDraw ( settings, json )
		{
			// v1.10 uses camelCase variables, while 1.9 uses Hungarian notation.
			// Support both
			var compat = function ( old, modern ) {
				return json[old] !== undefined ? json[old] : json[modern];
			};
		
			var data = _fnAjaxDataSrc( settings, json );
			var draw            = compat( 'sEcho',                'draw' );
			var recordsTotal    = compat( 'iTotalRecords',        'recordsTotal' );
			var recordsFiltered = compat( 'iTotalDisplayRecords', 'recordsFiltered' );
		
			if ( draw ) {
				// Protect against out of sequence returns
				if ( draw*1 < settings.iDraw ) {
					return;
				}
				settings.iDraw = draw * 1;
			}
		
			_fnClearTable( settings );
			settings._iRecordsTotal   = parseInt(recordsTotal, 10);
			settings._iRecordsDisplay = parseInt(recordsFiltered, 10);
		
			for ( var i=0, ien=data.length ; i<ien ; i++ ) {
				_fnAddData( settings, data[i] );
			}
			settings.aiDisplay = settings.aiDisplayMaster.slice();
		
			settings.bAjaxDataGet = false;
			_fnDraw( settings );
		
			if ( ! settings._bInitComplete ) {
				_fnInitComplete( settings, json );
			}
		
			settings.bAjaxDataGet = true;
			_fnProcessingDisplay( settings, false );
		}
		
		
		/**
		 * Get the data from the JSON data source to use for drawing a table. Using
		 * `_fnGetObjectDataFn` allows the data to be sourced from a property of the
		 * source object, or from a processing function.
		 *  @param {object} oSettings dataTables settings object
		 *  @param  {object} json Data source object / array from the server
		 *  @return {array} Array of data to use
		 */
		function _fnAjaxDataSrc ( oSettings, json )
		{
			var dataSrc = $.isPlainObject( oSettings.ajax ) && oSettings.ajax.dataSrc !== undefined ?
				oSettings.ajax.dataSrc :
				oSettings.sAjaxDataProp; // Compatibility with 1.9-.
		
			// Compatibility with 1.9-. In order to read from aaData, check if the
			// default has been changed, if not, check for aaData
			if ( dataSrc === 'data' ) {
				return json.aaData || json[dataSrc];
			}
		
			return dataSrc !== "" ?
				_fnGetObjectDataFn( dataSrc )( json ) :
				json;
		}
		
		/**
		 * Generate the node required for filtering text
		 *  @returns {node} Filter control element
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnFeatureHtmlFilter ( settings )
		{
			var classes = settings.oClasses;
			var tableId = settings.sTableId;
			var language = settings.oLanguage;
			var previousSearch = settings.oPreviousSearch;
			var features = settings.aanFeatures;
			var input = '<input type="search" class="'+classes.sFilterInput+'"/>';
		
			var str = language.sSearch;
			str = str.match(/_INPUT_/) ?
				str.replace('_INPUT_', input) :
				str+input;
		
			var filter = $('<div/>', {
					'id': ! features.f ? tableId+'_filter' : null,
					'class': classes.sFilter
				} )
				.append( $('<label/>' ).append( str ) );
		
			var searchFn = function() {
				/* Update all other filter input elements for the new display */
				var n = features.f;
				var val = !this.value ? "" : this.value; // mental IE8 fix :-(
		
				/* Now do the filter */
				if ( val != previousSearch.sSearch ) {
					_fnFilterComplete( settings, {
						"sSearch": val,
						"bRegex": previousSearch.bRegex,
						"bSmart": previousSearch.bSmart ,
						"bCaseInsensitive": previousSearch.bCaseInsensitive
					} );
		
					// Need to redraw, without resorting
					settings._iDisplayStart = 0;
					_fnDraw( settings );
				}
			};
		
			var searchDelay = settings.searchDelay !== null ?
				settings.searchDelay :
				_fnDataSource( settings ) === 'ssp' ?
					400 :
					0;
		
			var jqFilter = $('input', filter)
				.val( previousSearch.sSearch )
				.attr( 'placeholder', language.sSearchPlaceholder )
				.on(
					'keyup.DT search.DT input.DT paste.DT cut.DT',
					searchDelay ?
						_fnThrottle( searchFn, searchDelay ) :
						searchFn
				)
				.on( 'keypress.DT', function(e) {
					/* Prevent form submission */
					if ( e.keyCode == 13 ) {
						return false;
					}
				} )
				.attr('aria-controls', tableId);
		
			// Update the input elements whenever the table is filtered
			$(settings.nTable).on( 'search.dt.DT', function ( ev, s ) {
				if ( settings === s ) {
					// IE9 throws an 'unknown error' if document.activeElement is used
					// inside an iframe or frame...
					try {
						if ( jqFilter[0] !== document.activeElement ) {
							jqFilter.val( previousSearch.sSearch );
						}
					}
					catch ( e ) {}
				}
			} );
		
			return filter[0];
		}
		
		
		/**
		 * Filter the table using both the global filter and column based filtering
		 *  @param {object} oSettings dataTables settings object
		 *  @param {object} oSearch search information
		 *  @param {int} [iForce] force a research of the master array (1) or not (undefined or 0)
		 *  @memberof DataTable#oApi
		 */
		function _fnFilterComplete ( oSettings, oInput, iForce )
		{
			var oPrevSearch = oSettings.oPreviousSearch;
			var aoPrevSearch = oSettings.aoPreSearchCols;
			var fnSaveFilter = function ( oFilter ) {
				/* Save the filtering values */
				oPrevSearch.sSearch = oFilter.sSearch;
				oPrevSearch.bRegex = oFilter.bRegex;
				oPrevSearch.bSmart = oFilter.bSmart;
				oPrevSearch.bCaseInsensitive = oFilter.bCaseInsensitive;
			};
			var fnRegex = function ( o ) {
				// Backwards compatibility with the bEscapeRegex option
				return o.bEscapeRegex !== undefined ? !o.bEscapeRegex : o.bRegex;
			};
		
			// Resolve any column types that are unknown due to addition or invalidation
			// @todo As per sort - can this be moved into an event handler?
			_fnColumnTypes( oSettings );
		
			/* In server-side processing all filtering is done by the server, so no point hanging around here */
			if ( _fnDataSource( oSettings ) != 'ssp' )
			{
				/* Global filter */
				_fnFilter( oSettings, oInput.sSearch, iForce, fnRegex(oInput), oInput.bSmart, oInput.bCaseInsensitive );
				fnSaveFilter( oInput );
		
				/* Now do the individual column filter */
				for ( var i=0 ; i<aoPrevSearch.length ; i++ )
				{
					_fnFilterColumn( oSettings, aoPrevSearch[i].sSearch, i, fnRegex(aoPrevSearch[i]),
						aoPrevSearch[i].bSmart, aoPrevSearch[i].bCaseInsensitive );
				}
		
				/* Custom filtering */
				_fnFilterCustom( oSettings );
			}
			else
			{
				fnSaveFilter( oInput );
			}
		
			/* Tell the draw function we have been filtering */
			oSettings.bFiltered = true;
			_fnCallbackFire( oSettings, null, 'search', [oSettings] );
		}
		
		
		/**
		 * Apply custom filtering functions
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnFilterCustom( settings )
		{
			var filters = DataTable.ext.search;
			var displayRows = settings.aiDisplay;
			var row, rowIdx;
		
			for ( var i=0, ien=filters.length ; i<ien ; i++ ) {
				var rows = [];
		
				// Loop over each row and see if it should be included
				for ( var j=0, jen=displayRows.length ; j<jen ; j++ ) {
					rowIdx = displayRows[ j ];
					row = settings.aoData[ rowIdx ];
		
					if ( filters[i]( settings, row._aFilterData, rowIdx, row._aData, j ) ) {
						rows.push( rowIdx );
					}
				}
		
				// So the array reference doesn't break set the results into the
				// existing array
				displayRows.length = 0;
				$.merge( displayRows, rows );
			}
		}
		
		
		/**
		 * Filter the table on a per-column basis
		 *  @param {object} oSettings dataTables settings object
		 *  @param {string} sInput string to filter on
		 *  @param {int} iColumn column to filter
		 *  @param {bool} bRegex treat search string as a regular expression or not
		 *  @param {bool} bSmart use smart filtering or not
		 *  @param {bool} bCaseInsensitive Do case insenstive matching or not
		 *  @memberof DataTable#oApi
		 */
		function _fnFilterColumn ( settings, searchStr, colIdx, regex, smart, caseInsensitive )
		{
			if ( searchStr === '' ) {
				return;
			}
		
			var data;
			var out = [];
			var display = settings.aiDisplay;
			var rpSearch = _fnFilterCreateSearch( searchStr, regex, smart, caseInsensitive );
		
			for ( var i=0 ; i<display.length ; i++ ) {
				data = settings.aoData[ display[i] ]._aFilterData[ colIdx ];
		
				if ( rpSearch.test( data ) ) {
					out.push( display[i] );
				}
			}
		
			settings.aiDisplay = out;
		}
		
		
		/**
		 * Filter the data table based on user input and draw the table
		 *  @param {object} settings dataTables settings object
		 *  @param {string} input string to filter on
		 *  @param {int} force optional - force a research of the master array (1) or not (undefined or 0)
		 *  @param {bool} regex treat as a regular expression or not
		 *  @param {bool} smart perform smart filtering or not
		 *  @param {bool} caseInsensitive Do case insenstive matching or not
		 *  @memberof DataTable#oApi
		 */
		function _fnFilter( settings, input, force, regex, smart, caseInsensitive )
		{
			var rpSearch = _fnFilterCreateSearch( input, regex, smart, caseInsensitive );
			var prevSearch = settings.oPreviousSearch.sSearch;
			var displayMaster = settings.aiDisplayMaster;
			var display, invalidated, i;
			var filtered = [];
		
			// Need to take account of custom filtering functions - always filter
			if ( DataTable.ext.search.length !== 0 ) {
				force = true;
			}
		
			// Check if any of the rows were invalidated
			invalidated = _fnFilterData( settings );
		
			// If the input is blank - we just want the full data set
			if ( input.length <= 0 ) {
				settings.aiDisplay = displayMaster.slice();
			}
			else {
				// New search - start from the master array
				if ( invalidated ||
					 force ||
					 prevSearch.length > input.length ||
					 input.indexOf(prevSearch) !== 0 ||
					 settings.bSorted // On resort, the display master needs to be
					                  // re-filtered since indexes will have changed
				) {
					settings.aiDisplay = displayMaster.slice();
				}
		
				// Search the display array
				display = settings.aiDisplay;
		
				for ( i=0 ; i<display.length ; i++ ) {
					if ( rpSearch.test( settings.aoData[ display[i] ]._sFilterRow ) ) {
						filtered.push( display[i] );
					}
				}
		
				settings.aiDisplay = filtered;
			}
		}
		
		
		/**
		 * Build a regular expression object suitable for searching a table
		 *  @param {string} sSearch string to search for
		 *  @param {bool} bRegex treat as a regular expression or not
		 *  @param {bool} bSmart perform smart filtering or not
		 *  @param {bool} bCaseInsensitive Do case insensitive matching or not
		 *  @returns {RegExp} constructed object
		 *  @memberof DataTable#oApi
		 */
		function _fnFilterCreateSearch( search, regex, smart, caseInsensitive )
		{
			search = regex ?
				search :
				_fnEscapeRegex( search );
			
			if ( smart ) {
				/* For smart filtering we want to allow the search to work regardless of
				 * word order. We also want double quoted text to be preserved, so word
				 * order is important - a la google. So this is what we want to
				 * generate:
				 * 
				 * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
				 */
				var a = $.map( search.match( /"[^"]+"|[^ ]+/g ) || [''], function ( word ) {
					if ( word.charAt(0) === '"' ) {
						var m = word.match( /^"(.*)"$/ );
						word = m ? m[1] : word;
					}
		
					return word.replace('"', '');
				} );
		
				search = '^(?=.*?'+a.join( ')(?=.*?' )+').*$';
			}
		
			return new RegExp( search, caseInsensitive ? 'i' : '' );
		}
		
		
		/**
		 * Escape a string such that it can be used in a regular expression
		 *  @param {string} sVal string to escape
		 *  @returns {string} escaped string
		 *  @memberof DataTable#oApi
		 */
		var _fnEscapeRegex = DataTable.util.escapeRegex;
		
		var __filter_div = $('<div>')[0];
		var __filter_div_textContent = __filter_div.textContent !== undefined;
		
		// Update the filtering data for each row if needed (by invalidation or first run)
		function _fnFilterData ( settings )
		{
			var columns = settings.aoColumns;
			var column;
			var i, j, ien, jen, filterData, cellData, row;
			var fomatters = DataTable.ext.type.search;
			var wasInvalidated = false;
		
			for ( i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
				row = settings.aoData[i];
		
				if ( ! row._aFilterData ) {
					filterData = [];
		
					for ( j=0, jen=columns.length ; j<jen ; j++ ) {
						column = columns[j];
		
						if ( column.bSearchable ) {
							cellData = _fnGetCellData( settings, i, j, 'filter' );
		
							if ( fomatters[ column.sType ] ) {
								cellData = fomatters[ column.sType ]( cellData );
							}
		
							// Search in DataTables 1.10 is string based. In 1.11 this
							// should be altered to also allow strict type checking.
							if ( cellData === null ) {
								cellData = '';
							}
		
							if ( typeof cellData !== 'string' && cellData.toString ) {
								cellData = cellData.toString();
							}
						}
						else {
							cellData = '';
						}
		
						// If it looks like there is an HTML entity in the string,
						// attempt to decode it so sorting works as expected. Note that
						// we could use a single line of jQuery to do this, but the DOM
						// method used here is much faster http://jsperf.com/html-decode
						if ( cellData.indexOf && cellData.indexOf('&') !== -1 ) {
							__filter_div.innerHTML = cellData;
							cellData = __filter_div_textContent ?
								__filter_div.textContent :
								__filter_div.innerText;
						}
		
						if ( cellData.replace ) {
							cellData = cellData.replace(/[\r\n]/g, '');
						}
		
						filterData.push( cellData );
					}
		
					row._aFilterData = filterData;
					row._sFilterRow = filterData.join('  ');
					wasInvalidated = true;
				}
			}
		
			return wasInvalidated;
		}
		
		
		/**
		 * Convert from the internal Hungarian notation to camelCase for external
		 * interaction
		 *  @param {object} obj Object to convert
		 *  @returns {object} Inverted object
		 *  @memberof DataTable#oApi
		 */
		function _fnSearchToCamel ( obj )
		{
			return {
				search:          obj.sSearch,
				smart:           obj.bSmart,
				regex:           obj.bRegex,
				caseInsensitive: obj.bCaseInsensitive
			};
		}
		
		
		
		/**
		 * Convert from camelCase notation to the internal Hungarian. We could use the
		 * Hungarian convert function here, but this is cleaner
		 *  @param {object} obj Object to convert
		 *  @returns {object} Inverted object
		 *  @memberof DataTable#oApi
		 */
		function _fnSearchToHung ( obj )
		{
			return {
				sSearch:          obj.search,
				bSmart:           obj.smart,
				bRegex:           obj.regex,
				bCaseInsensitive: obj.caseInsensitive
			};
		}
		
		/**
		 * Generate the node required for the info display
		 *  @param {object} oSettings dataTables settings object
		 *  @returns {node} Information element
		 *  @memberof DataTable#oApi
		 */
		function _fnFeatureHtmlInfo ( settings )
		{
			var
				tid = settings.sTableId,
				nodes = settings.aanFeatures.i,
				n = $('<div/>', {
					'class': settings.oClasses.sInfo,
					'id': ! nodes ? tid+'_info' : null
				} );
		
			if ( ! nodes ) {
				// Update display on each draw
				settings.aoDrawCallback.push( {
					"fn": _fnUpdateInfo,
					"sName": "information"
				} );
		
				n
					.attr( 'role', 'status' )
					.attr( 'aria-live', 'polite' );
		
				// Table is described by our info div
				$(settings.nTable).attr( 'aria-describedby', tid+'_info' );
			}
		
			return n[0];
		}
		
		
		/**
		 * Update the information elements in the display
		 *  @param {object} settings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnUpdateInfo ( settings )
		{
			/* Show information about the table */
			var nodes = settings.aanFeatures.i;
			if ( nodes.length === 0 ) {
				return;
			}
		
			var
				lang  = settings.oLanguage,
				start = settings._iDisplayStart+1,
				end   = settings.fnDisplayEnd(),
				max   = settings.fnRecordsTotal(),
				total = settings.fnRecordsDisplay(),
				out   = total ?
					lang.sInfo :
					lang.sInfoEmpty;
		
			if ( total !== max ) {
				/* Record set after filtering */
				out += ' ' + lang.sInfoFiltered;
			}
		
			// Convert the macros
			out += lang.sInfoPostFix;
			out = _fnInfoMacros( settings, out );
		
			var callback = lang.fnInfoCallback;
			if ( callback !== null ) {
				out = callback.call( settings.oInstance,
					settings, start, end, max, total, out
				);
			}
		
			$(nodes).html( out );
		}
		
		
		function _fnInfoMacros ( settings, str )
		{
			// When infinite scrolling, we are always starting at 1. _iDisplayStart is used only
			// internally
			var
				formatter  = settings.fnFormatNumber,
				start      = settings._iDisplayStart+1,
				len        = settings._iDisplayLength,
				vis        = settings.fnRecordsDisplay(),
				all        = len === -1;
		
			return str.
				replace(/_START_/g, formatter.call( settings, start ) ).
				replace(/_END_/g,   formatter.call( settings, settings.fnDisplayEnd() ) ).
				replace(/_MAX_/g,   formatter.call( settings, settings.fnRecordsTotal() ) ).
				replace(/_TOTAL_/g, formatter.call( settings, vis ) ).
				replace(/_PAGE_/g,  formatter.call( settings, all ? 1 : Math.ceil( start / len ) ) ).
				replace(/_PAGES_/g, formatter.call( settings, all ? 1 : Math.ceil( vis / len ) ) );
		}
		
		
		
		/**
		 * Draw the table for the first time, adding all required features
		 *  @param {object} settings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnInitialise ( settings )
		{
			var i, iLen, iAjaxStart=settings.iInitDisplayStart;
			var columns = settings.aoColumns, column;
			var features = settings.oFeatures;
			var deferLoading = settings.bDeferLoading; // value modified by the draw
		
			/* Ensure that the table data is fully initialised */
			if ( ! settings.bInitialised ) {
				setTimeout( function(){ _fnInitialise( settings ); }, 200 );
				return;
			}
		
			/* Show the display HTML options */
			_fnAddOptionsHtml( settings );
		
			/* Build and draw the header / footer for the table */
			_fnBuildHead( settings );
			_fnDrawHead( settings, settings.aoHeader );
			_fnDrawHead( settings, settings.aoFooter );
		
			/* Okay to show that something is going on now */
			_fnProcessingDisplay( settings, true );
		
			/* Calculate sizes for columns */
			if ( features.bAutoWidth ) {
				_fnCalculateColumnWidths( settings );
			}
		
			for ( i=0, iLen=columns.length ; i<iLen ; i++ ) {
				column = columns[i];
		
				if ( column.sWidth ) {
					column.nTh.style.width = _fnStringToCss( column.sWidth );
				}
			}
		
			_fnCallbackFire( settings, null, 'preInit', [settings] );
		
			// If there is default sorting required - let's do it. The sort function
			// will do the drawing for us. Otherwise we draw the table regardless of the
			// Ajax source - this allows the table to look initialised for Ajax sourcing
			// data (show 'loading' message possibly)
			_fnReDraw( settings );
		
			// Server-side processing init complete is done by _fnAjaxUpdateDraw
			var dataSrc = _fnDataSource( settings );
			if ( dataSrc != 'ssp' || deferLoading ) {
				// if there is an ajax source load the data
				if ( dataSrc == 'ajax' ) {
					_fnBuildAjax( settings, [], function(json) {
						var aData = _fnAjaxDataSrc( settings, json );
		
						// Got the data - add it to the table
						for ( i=0 ; i<aData.length ; i++ ) {
							_fnAddData( settings, aData[i] );
						}
		
						// Reset the init display for cookie saving. We've already done
						// a filter, and therefore cleared it before. So we need to make
						// it appear 'fresh'
						settings.iInitDisplayStart = iAjaxStart;
		
						_fnReDraw( settings );
		
						_fnProcessingDisplay( settings, false );
						_fnInitComplete( settings, json );
					}, settings );
				}
				else {
					_fnProcessingDisplay( settings, false );
					_fnInitComplete( settings );
				}
			}
		}
		
		
		/**
		 * Draw the table for the first time, adding all required features
		 *  @param {object} oSettings dataTables settings object
		 *  @param {object} [json] JSON from the server that completed the table, if using Ajax source
		 *    with client-side processing (optional)
		 *  @memberof DataTable#oApi
		 */
		function _fnInitComplete ( settings, json )
		{
			settings._bInitComplete = true;
		
			// When data was added after the initialisation (data or Ajax) we need to
			// calculate the column sizing
			if ( json || settings.oInit.aaData ) {
				_fnAdjustColumnSizing( settings );
			}
		
			_fnCallbackFire( settings, null, 'plugin-init', [settings, json] );
			_fnCallbackFire( settings, 'aoInitComplete', 'init', [settings, json] );
		}
		
		
		function _fnLengthChange ( settings, val )
		{
			var len = parseInt( val, 10 );
			settings._iDisplayLength = len;
		
			_fnLengthOverflow( settings );
		
			// Fire length change event
			_fnCallbackFire( settings, null, 'length', [settings, len] );
		}
		
		
		/**
		 * Generate the node required for user display length changing
		 *  @param {object} settings dataTables settings object
		 *  @returns {node} Display length feature node
		 *  @memberof DataTable#oApi
		 */
		function _fnFeatureHtmlLength ( settings )
		{
			var
				classes  = settings.oClasses,
				tableId  = settings.sTableId,
				menu     = settings.aLengthMenu,
				d2       = $.isArray( menu[0] ),
				lengths  = d2 ? menu[0] : menu,
				language = d2 ? menu[1] : menu;
		
			var select = $('<select/>', {
				'name':          tableId+'_length',
				'aria-controls': tableId,
				'class':         classes.sLengthSelect
			} );
		
			for ( var i=0, ien=lengths.length ; i<ien ; i++ ) {
				select[0][ i ] = new Option(
					typeof language[i] === 'number' ?
						settings.fnFormatNumber( language[i] ) :
						language[i],
					lengths[i]
				);
			}
		
			var div = $('<div><label/></div>').addClass( classes.sLength );
			if ( ! settings.aanFeatures.l ) {
				div[0].id = tableId+'_length';
			}
		
			div.children().append(
				settings.oLanguage.sLengthMenu.replace( '_MENU_', select[0].outerHTML )
			);
		
			// Can't use `select` variable as user might provide their own and the
			// reference is broken by the use of outerHTML
			$('select', div)
				.val( settings._iDisplayLength )
				.on( 'change.DT', function(e) {
					_fnLengthChange( settings, $(this).val() );
					_fnDraw( settings );
				} );
		
			// Update node value whenever anything changes the table's length
			$(settings.nTable).on( 'length.dt.DT', function (e, s, len) {
				if ( settings === s ) {
					$('select', div).val( len );
				}
			} );
		
			return div[0];
		}
		
		
		
		/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
		 * Note that most of the paging logic is done in
		 * DataTable.ext.pager
		 */
		
		/**
		 * Generate the node required for default pagination
		 *  @param {object} oSettings dataTables settings object
		 *  @returns {node} Pagination feature node
		 *  @memberof DataTable#oApi
		 */
		function _fnFeatureHtmlPaginate ( settings )
		{
			var
				type   = settings.sPaginationType,
				plugin = DataTable.ext.pager[ type ],
				modern = typeof plugin === 'function',
				redraw = function( settings ) {
					_fnDraw( settings );
				},
				node = $('<div/>').addClass( settings.oClasses.sPaging + type )[0],
				features = settings.aanFeatures;
		
			if ( ! modern ) {
				plugin.fnInit( settings, node, redraw );
			}
		
			/* Add a draw callback for the pagination on first instance, to update the paging display */
			if ( ! features.p )
			{
				node.id = settings.sTableId+'_paginate';
		
				settings.aoDrawCallback.push( {
					"fn": function( settings ) {
						if ( modern ) {
							var
								start      = settings._iDisplayStart,
								len        = settings._iDisplayLength,
								visRecords = settings.fnRecordsDisplay(),
								all        = len === -1,
								page = all ? 0 : Math.ceil( start / len ),
								pages = all ? 1 : Math.ceil( visRecords / len ),
								buttons = plugin(page, pages),
								i, ien;
		
							for ( i=0, ien=features.p.length ; i<ien ; i++ ) {
								_fnRenderer( settings, 'pageButton' )(
									settings, features.p[i], i, buttons, page, pages
								);
							}
						}
						else {
							plugin.fnUpdate( settings, redraw );
						}
					},
					"sName": "pagination"
				} );
			}
		
			return node;
		}
		
		
		/**
		 * Alter the display settings to change the page
		 *  @param {object} settings DataTables settings object
		 *  @param {string|int} action Paging action to take: "first", "previous",
		 *    "next" or "last" or page number to jump to (integer)
		 *  @param [bool] redraw Automatically draw the update or not
		 *  @returns {bool} true page has changed, false - no change
		 *  @memberof DataTable#oApi
		 */
		function _fnPageChange ( settings, action, redraw )
		{
			var
				start     = settings._iDisplayStart,
				len       = settings._iDisplayLength,
				records   = settings.fnRecordsDisplay();
		
			if ( records === 0 || len === -1 )
			{
				start = 0;
			}
			else if ( typeof action === "number" )
			{
				start = action * len;
		
				if ( start > records )
				{
					start = 0;
				}
			}
			else if ( action == "first" )
			{
				start = 0;
			}
			else if ( action == "previous" )
			{
				start = len >= 0 ?
					start - len :
					0;
		
				if ( start < 0 )
				{
				  start = 0;
				}
			}
			else if ( action == "next" )
			{
				if ( start + len < records )
				{
					start += len;
				}
			}
			else if ( action == "last" )
			{
				start = Math.floor( (records-1) / len) * len;
			}
			else
			{
				_fnLog( settings, 0, "Unknown paging action: "+action, 5 );
			}
		
			var changed = settings._iDisplayStart !== start;
			settings._iDisplayStart = start;
		
			if ( changed ) {
				_fnCallbackFire( settings, null, 'page', [settings] );
		
				if ( redraw ) {
					_fnDraw( settings );
				}
			}
		
			return changed;
		}
		
		
		
		/**
		 * Generate the node required for the processing node
		 *  @param {object} settings dataTables settings object
		 *  @returns {node} Processing element
		 *  @memberof DataTable#oApi
		 */
		function _fnFeatureHtmlProcessing ( settings )
		{
			return $('<div/>', {
					'id': ! settings.aanFeatures.r ? settings.sTableId+'_processing' : null,
					'class': settings.oClasses.sProcessing
				} )
				.html( settings.oLanguage.sProcessing )
				.insertBefore( settings.nTable )[0];
		}
		
		
		/**
		 * Display or hide the processing indicator
		 *  @param {object} settings dataTables settings object
		 *  @param {bool} show Show the processing indicator (true) or not (false)
		 *  @memberof DataTable#oApi
		 */
		function _fnProcessingDisplay ( settings, show )
		{
			if ( settings.oFeatures.bProcessing ) {
				$(settings.aanFeatures.r).css( 'display', show ? 'block' : 'none' );
			}
		
			_fnCallbackFire( settings, null, 'processing', [settings, show] );
		}
		
		/**
		 * Add any control elements for the table - specifically scrolling
		 *  @param {object} settings dataTables settings object
		 *  @returns {node} Node to add to the DOM
		 *  @memberof DataTable#oApi
		 */
		function _fnFeatureHtmlTable ( settings )
		{
			var table = $(settings.nTable);
		
			// Add the ARIA grid role to the table
			table.attr( 'role', 'grid' );
		
			// Scrolling from here on in
			var scroll = settings.oScroll;
		
			if ( scroll.sX === '' && scroll.sY === '' ) {
				return settings.nTable;
			}
		
			var scrollX = scroll.sX;
			var scrollY = scroll.sY;
			var classes = settings.oClasses;
			var caption = table.children('caption');
			var captionSide = caption.length ? caption[0]._captionSide : null;
			var headerClone = $( table[0].cloneNode(false) );
			var footerClone = $( table[0].cloneNode(false) );
			var footer = table.children('tfoot');
			var _div = '<div/>';
			var size = function ( s ) {
				return !s ? null : _fnStringToCss( s );
			};
		
			if ( ! footer.length ) {
				footer = null;
			}
		
			/*
			 * The HTML structure that we want to generate in this function is:
			 *  div - scroller
			 *    div - scroll head
			 *      div - scroll head inner
			 *        table - scroll head table
			 *          thead - thead
			 *    div - scroll body
			 *      table - table (master table)
			 *        thead - thead clone for sizing
			 *        tbody - tbody
			 *    div - scroll foot
			 *      div - scroll foot inner
			 *        table - scroll foot table
			 *          tfoot - tfoot
			 */
			var scroller = $( _div, { 'class': classes.sScrollWrapper } )
				.append(
					$(_div, { 'class': classes.sScrollHead } )
						.css( {
							overflow: 'hidden',
							position: 'relative',
							border: 0,
							width: scrollX ? size(scrollX) : '100%'
						} )
						.append(
							$(_div, { 'class': classes.sScrollHeadInner } )
								.css( {
									'box-sizing': 'content-box',
									width: scroll.sXInner || '100%'
								} )
								.append(
									headerClone
										.removeAttr('id')
										.css( 'margin-left', 0 )
										.append( captionSide === 'top' ? caption : null )
										.append(
											table.children('thead')
										)
								)
						)
				)
				.append(
					$(_div, { 'class': classes.sScrollBody } )
						.css( {
							position: 'relative',
							overflow: 'auto',
							width: size( scrollX )
						} )
						.append( table )
				);
		
			if ( footer ) {
				scroller.append(
					$(_div, { 'class': classes.sScrollFoot } )
						.css( {
							overflow: 'hidden',
							border: 0,
							width: scrollX ? size(scrollX) : '100%'
						} )
						.append(
							$(_div, { 'class': classes.sScrollFootInner } )
								.append(
									footerClone
										.removeAttr('id')
										.css( 'margin-left', 0 )
										.append( captionSide === 'bottom' ? caption : null )
										.append(
											table.children('tfoot')
										)
								)
						)
				);
			}
		
			var children = scroller.children();
			var scrollHead = children[0];
			var scrollBody = children[1];
			var scrollFoot = footer ? children[2] : null;
		
			// When the body is scrolled, then we also want to scroll the headers
			if ( scrollX ) {
				$(scrollBody).on( 'scroll.DT', function (e) {
					var scrollLeft = this.scrollLeft;
		
					scrollHead.scrollLeft = scrollLeft;
		
					if ( footer ) {
						scrollFoot.scrollLeft = scrollLeft;
					}
				} );
			}
		
			$(scrollBody).css(
				scrollY && scroll.bCollapse ? 'max-height' : 'height', 
				scrollY
			);
		
			settings.nScrollHead = scrollHead;
			settings.nScrollBody = scrollBody;
			settings.nScrollFoot = scrollFoot;
		
			// On redraw - align columns
			settings.aoDrawCallback.push( {
				"fn": _fnScrollDraw,
				"sName": "scrolling"
			} );
		
			return scroller[0];
		}
		
		
		
		/**
		 * Update the header, footer and body tables for resizing - i.e. column
		 * alignment.
		 *
		 * Welcome to the most horrible function DataTables. The process that this
		 * function follows is basically:
		 *   1. Re-create the table inside the scrolling div
		 *   2. Take live measurements from the DOM
		 *   3. Apply the measurements to align the columns
		 *   4. Clean up
		 *
		 *  @param {object} settings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnScrollDraw ( settings )
		{
			// Given that this is such a monster function, a lot of variables are use
			// to try and keep the minimised size as small as possible
			var
				scroll         = settings.oScroll,
				scrollX        = scroll.sX,
				scrollXInner   = scroll.sXInner,
				scrollY        = scroll.sY,
				barWidth       = scroll.iBarWidth,
				divHeader      = $(settings.nScrollHead),
				divHeaderStyle = divHeader[0].style,
				divHeaderInner = divHeader.children('div'),
				divHeaderInnerStyle = divHeaderInner[0].style,
				divHeaderTable = divHeaderInner.children('table'),
				divBodyEl      = settings.nScrollBody,
				divBody        = $(divBodyEl),
				divBodyStyle   = divBodyEl.style,
				divFooter      = $(settings.nScrollFoot),
				divFooterInner = divFooter.children('div'),
				divFooterTable = divFooterInner.children('table'),
				header         = $(settings.nTHead),
				table          = $(settings.nTable),
				tableEl        = table[0],
				tableStyle     = tableEl.style,
				footer         = settings.nTFoot ? $(settings.nTFoot) : null,
				browser        = settings.oBrowser,
				ie67           = browser.bScrollOversize,
				dtHeaderCells  = _pluck( settings.aoColumns, 'nTh' ),
				headerTrgEls, footerTrgEls,
				headerSrcEls, footerSrcEls,
				headerCopy, footerCopy,
				headerWidths=[], footerWidths=[],
				headerContent=[], footerContent=[],
				idx, correction, sanityWidth,
				zeroOut = function(nSizer) {
					var style = nSizer.style;
					style.paddingTop = "0";
					style.paddingBottom = "0";
					style.borderTopWidth = "0";
					style.borderBottomWidth = "0";
					style.height = 0;
				};
		
			// If the scrollbar visibility has changed from the last draw, we need to
			// adjust the column sizes as the table width will have changed to account
			// for the scrollbar
			var scrollBarVis = divBodyEl.scrollHeight > divBodyEl.clientHeight;
			
			if ( settings.scrollBarVis !== scrollBarVis && settings.scrollBarVis !== undefined ) {
				settings.scrollBarVis = scrollBarVis;
				_fnAdjustColumnSizing( settings );
				return; // adjust column sizing will call this function again
			}
			else {
				settings.scrollBarVis = scrollBarVis;
			}
		
			/*
			 * 1. Re-create the table inside the scrolling div
			 */
		
			// Remove the old minimised thead and tfoot elements in the inner table
			table.children('thead, tfoot').remove();
		
			if ( footer ) {
				footerCopy = footer.clone().prependTo( table );
				footerTrgEls = footer.find('tr'); // the original tfoot is in its own table and must be sized
				footerSrcEls = footerCopy.find('tr');
			}
		
			// Clone the current header and footer elements and then place it into the inner table
			headerCopy = header.clone().prependTo( table );
			headerTrgEls = header.find('tr'); // original header is in its own table
			headerSrcEls = headerCopy.find('tr');
			headerCopy.find('th, td').removeAttr('tabindex');
		
		
			/*
			 * 2. Take live measurements from the DOM - do not alter the DOM itself!
			 */
		
			// Remove old sizing and apply the calculated column widths
			// Get the unique column headers in the newly created (cloned) header. We want to apply the
			// calculated sizes to this header
			if ( ! scrollX )
			{
				divBodyStyle.width = '100%';
				divHeader[0].style.width = '100%';
			}
		
			$.each( _fnGetUniqueThs( settings, headerCopy ), function ( i, el ) {
				idx = _fnVisibleToColumnIndex( settings, i );
				el.style.width = settings.aoColumns[idx].sWidth;
			} );
		
			if ( footer ) {
				_fnApplyToChildren( function(n) {
					n.style.width = "";
				}, footerSrcEls );
			}
		
			// Size the table as a whole
			sanityWidth = table.outerWidth();
			if ( scrollX === "" ) {
				// No x scrolling
				tableStyle.width = "100%";
		
				// IE7 will make the width of the table when 100% include the scrollbar
				// - which is shouldn't. When there is a scrollbar we need to take this
				// into account.
				if ( ie67 && (table.find('tbody').height() > divBodyEl.offsetHeight ||
					divBody.css('overflow-y') == "scroll")
				) {
					tableStyle.width = _fnStringToCss( table.outerWidth() - barWidth);
				}
		
				// Recalculate the sanity width
				sanityWidth = table.outerWidth();
			}
			else if ( scrollXInner !== "" ) {
				// legacy x scroll inner has been given - use it
				tableStyle.width = _fnStringToCss(scrollXInner);
		
				// Recalculate the sanity width
				sanityWidth = table.outerWidth();
			}
		
			// Hidden header should have zero height, so remove padding and borders. Then
			// set the width based on the real headers
		
			// Apply all styles in one pass
			_fnApplyToChildren( zeroOut, headerSrcEls );
		
			// Read all widths in next pass
			_fnApplyToChildren( function(nSizer) {
				headerContent.push( nSizer.innerHTML );
				headerWidths.push( _fnStringToCss( $(nSizer).css('width') ) );
			}, headerSrcEls );
		
			// Apply all widths in final pass
			_fnApplyToChildren( function(nToSize, i) {
				// Only apply widths to the DataTables detected header cells - this
				// prevents complex headers from having contradictory sizes applied
				if ( $.inArray( nToSize, dtHeaderCells ) !== -1 ) {
					nToSize.style.width = headerWidths[i];
				}
			}, headerTrgEls );
		
			$(headerSrcEls).height(0);
		
			/* Same again with the footer if we have one */
			if ( footer )
			{
				_fnApplyToChildren( zeroOut, footerSrcEls );
		
				_fnApplyToChildren( function(nSizer) {
					footerContent.push( nSizer.innerHTML );
					footerWidths.push( _fnStringToCss( $(nSizer).css('width') ) );
				}, footerSrcEls );
		
				_fnApplyToChildren( function(nToSize, i) {
					nToSize.style.width = footerWidths[i];
				}, footerTrgEls );
		
				$(footerSrcEls).height(0);
			}
		
		
			/*
			 * 3. Apply the measurements
			 */
		
			// "Hide" the header and footer that we used for the sizing. We need to keep
			// the content of the cell so that the width applied to the header and body
			// both match, but we want to hide it completely. We want to also fix their
			// width to what they currently are
			_fnApplyToChildren( function(nSizer, i) {
				nSizer.innerHTML = '<div class="dataTables_sizing">'+headerContent[i]+'</div>';
				nSizer.childNodes[0].style.height = "0";
				nSizer.childNodes[0].style.overflow = "hidden";
				nSizer.style.width = headerWidths[i];
			}, headerSrcEls );
		
			if ( footer )
			{
				_fnApplyToChildren( function(nSizer, i) {
					nSizer.innerHTML = '<div class="dataTables_sizing">'+footerContent[i]+'</div>';
					nSizer.childNodes[0].style.height = "0";
					nSizer.childNodes[0].style.overflow = "hidden";
					nSizer.style.width = footerWidths[i];
				}, footerSrcEls );
			}
		
			// Sanity check that the table is of a sensible width. If not then we are going to get
			// misalignment - try to prevent this by not allowing the table to shrink below its min width
			if ( table.outerWidth() < sanityWidth )
			{
				// The min width depends upon if we have a vertical scrollbar visible or not */
				correction = ((divBodyEl.scrollHeight > divBodyEl.offsetHeight ||
					divBody.css('overflow-y') == "scroll")) ?
						sanityWidth+barWidth :
						sanityWidth;
		
				// IE6/7 are a law unto themselves...
				if ( ie67 && (divBodyEl.scrollHeight >
					divBodyEl.offsetHeight || divBody.css('overflow-y') == "scroll")
				) {
					tableStyle.width = _fnStringToCss( correction-barWidth );
				}
		
				// And give the user a warning that we've stopped the table getting too small
				if ( scrollX === "" || scrollXInner !== "" ) {
					_fnLog( settings, 1, 'Possible column misalignment', 6 );
				}
			}
			else
			{
				correction = '100%';
			}
		
			// Apply to the container elements
			divBodyStyle.width = _fnStringToCss( correction );
			divHeaderStyle.width = _fnStringToCss( correction );
		
			if ( footer ) {
				settings.nScrollFoot.style.width = _fnStringToCss( correction );
			}
		
		
			/*
			 * 4. Clean up
			 */
			if ( ! scrollY ) {
				/* IE7< puts a vertical scrollbar in place (when it shouldn't be) due to subtracting
				 * the scrollbar height from the visible display, rather than adding it on. We need to
				 * set the height in order to sort this. Don't want to do it in any other browsers.
				 */
				if ( ie67 ) {
					divBodyStyle.height = _fnStringToCss( tableEl.offsetHeight+barWidth );
				}
			}
		
			/* Finally set the width's of the header and footer tables */
			var iOuterWidth = table.outerWidth();
			divHeaderTable[0].style.width = _fnStringToCss( iOuterWidth );
			divHeaderInnerStyle.width = _fnStringToCss( iOuterWidth );
		
			// Figure out if there are scrollbar present - if so then we need a the header and footer to
			// provide a bit more space to allow "overflow" scrolling (i.e. past the scrollbar)
			var bScrolling = table.height() > divBodyEl.clientHeight || divBody.css('overflow-y') == "scroll";
			var padding = 'padding' + (browser.bScrollbarLeft ? 'Left' : 'Right' );
			divHeaderInnerStyle[ padding ] = bScrolling ? barWidth+"px" : "0px";
		
			if ( footer ) {
				divFooterTable[0].style.width = _fnStringToCss( iOuterWidth );
				divFooterInner[0].style.width = _fnStringToCss( iOuterWidth );
				divFooterInner[0].style[padding] = bScrolling ? barWidth+"px" : "0px";
			}
		
			// Correct DOM ordering for colgroup - comes before the thead
			table.children('colgroup').insertBefore( table.children('thead') );
		
			/* Adjust the position of the header in case we loose the y-scrollbar */
			divBody.scroll();
		
			// If sorting or filtering has occurred, jump the scrolling back to the top
			// only if we aren't holding the position
			if ( (settings.bSorted || settings.bFiltered) && ! settings._drawHold ) {
				divBodyEl.scrollTop = 0;
			}
		}
		
		
		
		/**
		 * Apply a given function to the display child nodes of an element array (typically
		 * TD children of TR rows
		 *  @param {function} fn Method to apply to the objects
		 *  @param array {nodes} an1 List of elements to look through for display children
		 *  @param array {nodes} an2 Another list (identical structure to the first) - optional
		 *  @memberof DataTable#oApi
		 */
		function _fnApplyToChildren( fn, an1, an2 )
		{
			var index=0, i=0, iLen=an1.length;
			var nNode1, nNode2;
		
			while ( i < iLen ) {
				nNode1 = an1[i].firstChild;
				nNode2 = an2 ? an2[i].firstChild : null;
		
				while ( nNode1 ) {
					if ( nNode1.nodeType === 1 ) {
						if ( an2 ) {
							fn( nNode1, nNode2, index );
						}
						else {
							fn( nNode1, index );
						}
		
						index++;
					}
		
					nNode1 = nNode1.nextSibling;
					nNode2 = an2 ? nNode2.nextSibling : null;
				}
		
				i++;
			}
		}
		
		
		
		var __re_html_remove = /<.*?>/g;
		
		
		/**
		 * Calculate the width of columns for the table
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnCalculateColumnWidths ( oSettings )
		{
			var
				table = oSettings.nTable,
				columns = oSettings.aoColumns,
				scroll = oSettings.oScroll,
				scrollY = scroll.sY,
				scrollX = scroll.sX,
				scrollXInner = scroll.sXInner,
				columnCount = columns.length,
				visibleColumns = _fnGetColumns( oSettings, 'bVisible' ),
				headerCells = $('th', oSettings.nTHead),
				tableWidthAttr = table.getAttribute('width'), // from DOM element
				tableContainer = table.parentNode,
				userInputs = false,
				i, column, columnIdx, width, outerWidth,
				browser = oSettings.oBrowser,
				ie67 = browser.bScrollOversize;
		
			var styleWidth = table.style.width;
			if ( styleWidth && styleWidth.indexOf('%') !== -1 ) {
				tableWidthAttr = styleWidth;
			}
		
			/* Convert any user input sizes into pixel sizes */
			for ( i=0 ; i<visibleColumns.length ; i++ ) {
				column = columns[ visibleColumns[i] ];
		
				if ( column.sWidth !== null ) {
					column.sWidth = _fnConvertToWidth( column.sWidthOrig, tableContainer );
		
					userInputs = true;
				}
			}
		
			/* If the number of columns in the DOM equals the number that we have to
			 * process in DataTables, then we can use the offsets that are created by
			 * the web- browser. No custom sizes can be set in order for this to happen,
			 * nor scrolling used
			 */
			if ( ie67 || ! userInputs && ! scrollX && ! scrollY &&
			     columnCount == _fnVisbleColumns( oSettings ) &&
			     columnCount == headerCells.length
			) {
				for ( i=0 ; i<columnCount ; i++ ) {
					var colIdx = _fnVisibleToColumnIndex( oSettings, i );
		
					if ( colIdx !== null ) {
						columns[ colIdx ].sWidth = _fnStringToCss( headerCells.eq(i).width() );
					}
				}
			}
			else
			{
				// Otherwise construct a single row, worst case, table with the widest
				// node in the data, assign any user defined widths, then insert it into
				// the DOM and allow the browser to do all the hard work of calculating
				// table widths
				var tmpTable = $(table).clone() // don't use cloneNode - IE8 will remove events on the main table
					.css( 'visibility', 'hidden' )
					.removeAttr( 'id' );
		
				// Clean up the table body
				tmpTable.find('tbody tr').remove();
				var tr = $('<tr/>').appendTo( tmpTable.find('tbody') );
		
				// Clone the table header and footer - we can't use the header / footer
				// from the cloned table, since if scrolling is active, the table's
				// real header and footer are contained in different table tags
				tmpTable.find('thead, tfoot').remove();
				tmpTable
					.append( $(oSettings.nTHead).clone() )
					.append( $(oSettings.nTFoot).clone() );
		
				// Remove any assigned widths from the footer (from scrolling)
				tmpTable.find('tfoot th, tfoot td').css('width', '');
		
				// Apply custom sizing to the cloned header
				headerCells = _fnGetUniqueThs( oSettings, tmpTable.find('thead')[0] );
		
				for ( i=0 ; i<visibleColumns.length ; i++ ) {
					column = columns[ visibleColumns[i] ];
		
					headerCells[i].style.width = column.sWidthOrig !== null && column.sWidthOrig !== '' ?
						_fnStringToCss( column.sWidthOrig ) :
						'';
		
					// For scrollX we need to force the column width otherwise the
					// browser will collapse it. If this width is smaller than the
					// width the column requires, then it will have no effect
					if ( column.sWidthOrig && scrollX ) {
						$( headerCells[i] ).append( $('<div/>').css( {
							width: column.sWidthOrig,
							margin: 0,
							padding: 0,
							border: 0,
							height: 1
						} ) );
					}
				}
		
				// Find the widest cell for each column and put it into the table
				if ( oSettings.aoData.length ) {
					for ( i=0 ; i<visibleColumns.length ; i++ ) {
						columnIdx = visibleColumns[i];
						column = columns[ columnIdx ];
		
						$( _fnGetWidestNode( oSettings, columnIdx ) )
							.clone( false )
							.append( column.sContentPadding )
							.appendTo( tr );
					}
				}
		
				// Tidy the temporary table - remove name attributes so there aren't
				// duplicated in the dom (radio elements for example)
				$('[name]', tmpTable).removeAttr('name');
		
				// Table has been built, attach to the document so we can work with it.
				// A holding element is used, positioned at the top of the container
				// with minimal height, so it has no effect on if the container scrolls
				// or not. Otherwise it might trigger scrolling when it actually isn't
				// needed
				var holder = $('<div/>').css( scrollX || scrollY ?
						{
							position: 'absolute',
							top: 0,
							left: 0,
							height: 1,
							right: 0,
							overflow: 'hidden'
						} :
						{}
					)
					.append( tmpTable )
					.appendTo( tableContainer );
		
				// When scrolling (X or Y) we want to set the width of the table as 
				// appropriate. However, when not scrolling leave the table width as it
				// is. This results in slightly different, but I think correct behaviour
				if ( scrollX && scrollXInner ) {
					tmpTable.width( scrollXInner );
				}
				else if ( scrollX ) {
					tmpTable.css( 'width', 'auto' );
					tmpTable.removeAttr('width');
		
					// If there is no width attribute or style, then allow the table to
					// collapse
					if ( tmpTable.width() < tableContainer.clientWidth && tableWidthAttr ) {
						tmpTable.width( tableContainer.clientWidth );
					}
				}
				else if ( scrollY ) {
					tmpTable.width( tableContainer.clientWidth );
				}
				else if ( tableWidthAttr ) {
					tmpTable.width( tableWidthAttr );
				}
		
				// Get the width of each column in the constructed table - we need to
				// know the inner width (so it can be assigned to the other table's
				// cells) and the outer width so we can calculate the full width of the
				// table. This is safe since DataTables requires a unique cell for each
				// column, but if ever a header can span multiple columns, this will
				// need to be modified.
				var total = 0;
				for ( i=0 ; i<visibleColumns.length ; i++ ) {
					var cell = $(headerCells[i]);
					var border = cell.outerWidth() - cell.width();
		
					// Use getBounding... where possible (not IE8-) because it can give
					// sub-pixel accuracy, which we then want to round up!
					var bounding = browser.bBounding ?
						Math.ceil( headerCells[i].getBoundingClientRect().width ) :
						cell.outerWidth();
		
					// Total is tracked to remove any sub-pixel errors as the outerWidth
					// of the table might not equal the total given here (IE!).
					total += bounding;
		
					// Width for each column to use
					columns[ visibleColumns[i] ].sWidth = _fnStringToCss( bounding - border );
				}
		
				table.style.width = _fnStringToCss( total );
		
				// Finished with the table - ditch it
				holder.remove();
			}
		
			// If there is a width attr, we want to attach an event listener which
			// allows the table sizing to automatically adjust when the window is
			// resized. Use the width attr rather than CSS, since we can't know if the
			// CSS is a relative value or absolute - DOM read is always px.
			if ( tableWidthAttr ) {
				table.style.width = _fnStringToCss( tableWidthAttr );
			}
		
			if ( (tableWidthAttr || scrollX) && ! oSettings._reszEvt ) {
				var bindResize = function () {
					$(window).on('resize.DT-'+oSettings.sInstance, _fnThrottle( function () {
						_fnAdjustColumnSizing( oSettings );
					} ) );
				};
		
				// IE6/7 will crash if we bind a resize event handler on page load.
				// To be removed in 1.11 which drops IE6/7 support
				if ( ie67 ) {
					setTimeout( bindResize, 1000 );
				}
				else {
					bindResize();
				}
		
				oSettings._reszEvt = true;
			}
		}
		
		
		/**
		 * Throttle the calls to a function. Arguments and context are maintained for
		 * the throttled function
		 *  @param {function} fn Function to be called
		 *  @param {int} [freq=200] call frequency in mS
		 *  @returns {function} wrapped function
		 *  @memberof DataTable#oApi
		 */
		var _fnThrottle = DataTable.util.throttle;
		
		
		/**
		 * Convert a CSS unit width to pixels (e.g. 2em)
		 *  @param {string} width width to be converted
		 *  @param {node} parent parent to get the with for (required for relative widths) - optional
		 *  @returns {int} width in pixels
		 *  @memberof DataTable#oApi
		 */
		function _fnConvertToWidth ( width, parent )
		{
			if ( ! width ) {
				return 0;
			}
		
			var n = $('<div/>')
				.css( 'width', _fnStringToCss( width ) )
				.appendTo( parent || document.body );
		
			var val = n[0].offsetWidth;
			n.remove();
		
			return val;
		}
		
		
		/**
		 * Get the widest node
		 *  @param {object} settings dataTables settings object
		 *  @param {int} colIdx column of interest
		 *  @returns {node} widest table node
		 *  @memberof DataTable#oApi
		 */
		function _fnGetWidestNode( settings, colIdx )
		{
			var idx = _fnGetMaxLenString( settings, colIdx );
			if ( idx < 0 ) {
				return null;
			}
		
			var data = settings.aoData[ idx ];
			return ! data.nTr ? // Might not have been created when deferred rendering
				$('<td/>').html( _fnGetCellData( settings, idx, colIdx, 'display' ) )[0] :
				data.anCells[ colIdx ];
		}
		
		
		/**
		 * Get the maximum strlen for each data column
		 *  @param {object} settings dataTables settings object
		 *  @param {int} colIdx column of interest
		 *  @returns {string} max string length for each column
		 *  @memberof DataTable#oApi
		 */
		function _fnGetMaxLenString( settings, colIdx )
		{
			var s, max=-1, maxIdx = -1;
		
			for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
				s = _fnGetCellData( settings, i, colIdx, 'display' )+'';
				s = s.replace( __re_html_remove, '' );
				s = s.replace( /&nbsp;/g, ' ' );
		
				if ( s.length > max ) {
					max = s.length;
					maxIdx = i;
				}
			}
		
			return maxIdx;
		}
		
		
		/**
		 * Append a CSS unit (only if required) to a string
		 *  @param {string} value to css-ify
		 *  @returns {string} value with css unit
		 *  @memberof DataTable#oApi
		 */
		function _fnStringToCss( s )
		{
			if ( s === null ) {
				return '0px';
			}
		
			if ( typeof s == 'number' ) {
				return s < 0 ?
					'0px' :
					s+'px';
			}
		
			// Check it has a unit character already
			return s.match(/\d$/) ?
				s+'px' :
				s;
		}
		
		
		
		function _fnSortFlatten ( settings )
		{
			var
				i, iLen, k, kLen,
				aSort = [],
				aiOrig = [],
				aoColumns = settings.aoColumns,
				aDataSort, iCol, sType, srcCol,
				fixed = settings.aaSortingFixed,
				fixedObj = $.isPlainObject( fixed ),
				nestedSort = [],
				add = function ( a ) {
					if ( a.length && ! $.isArray( a[0] ) ) {
						// 1D array
						nestedSort.push( a );
					}
					else {
						// 2D array
						$.merge( nestedSort, a );
					}
				};
		
			// Build the sort array, with pre-fix and post-fix options if they have been
			// specified
			if ( $.isArray( fixed ) ) {
				add( fixed );
			}
		
			if ( fixedObj && fixed.pre ) {
				add( fixed.pre );
			}
		
			add( settings.aaSorting );
		
			if (fixedObj && fixed.post ) {
				add( fixed.post );
			}
		
			for ( i=0 ; i<nestedSort.length ; i++ )
			{
				srcCol = nestedSort[i][0];
				aDataSort = aoColumns[ srcCol ].aDataSort;
		
				for ( k=0, kLen=aDataSort.length ; k<kLen ; k++ )
				{
					iCol = aDataSort[k];
					sType = aoColumns[ iCol ].sType || 'string';
		
					if ( nestedSort[i]._idx === undefined ) {
						nestedSort[i]._idx = $.inArray( nestedSort[i][1], aoColumns[iCol].asSorting );
					}
		
					aSort.push( {
						src:       srcCol,
						col:       iCol,
						dir:       nestedSort[i][1],
						index:     nestedSort[i]._idx,
						type:      sType,
						formatter: DataTable.ext.type.order[ sType+"-pre" ]
					} );
				}
			}
		
			return aSort;
		}
		
		/**
		 * Change the order of the table
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 *  @todo This really needs split up!
		 */
		function _fnSort ( oSettings )
		{
			var
				i, ien, iLen, j, jLen, k, kLen,
				sDataType, nTh,
				aiOrig = [],
				oExtSort = DataTable.ext.type.order,
				aoData = oSettings.aoData,
				aoColumns = oSettings.aoColumns,
				aDataSort, data, iCol, sType, oSort,
				formatters = 0,
				sortCol,
				displayMaster = oSettings.aiDisplayMaster,
				aSort;
		
			// Resolve any column types that are unknown due to addition or invalidation
			// @todo Can this be moved into a 'data-ready' handler which is called when
			//   data is going to be used in the table?
			_fnColumnTypes( oSettings );
		
			aSort = _fnSortFlatten( oSettings );
		
			for ( i=0, ien=aSort.length ; i<ien ; i++ ) {
				sortCol = aSort[i];
		
				// Track if we can use the fast sort algorithm
				if ( sortCol.formatter ) {
					formatters++;
				}
		
				// Load the data needed for the sort, for each cell
				_fnSortData( oSettings, sortCol.col );
			}
		
			/* No sorting required if server-side or no sorting array */
			if ( _fnDataSource( oSettings ) != 'ssp' && aSort.length !== 0 )
			{
				// Create a value - key array of the current row positions such that we can use their
				// current position during the sort, if values match, in order to perform stable sorting
				for ( i=0, iLen=displayMaster.length ; i<iLen ; i++ ) {
					aiOrig[ displayMaster[i] ] = i;
				}
		
				/* Do the sort - here we want multi-column sorting based on a given data source (column)
				 * and sorting function (from oSort) in a certain direction. It's reasonably complex to
				 * follow on it's own, but this is what we want (example two column sorting):
				 *  fnLocalSorting = function(a,b){
				 *    var iTest;
				 *    iTest = oSort['string-asc']('data11', 'data12');
				 *      if (iTest !== 0)
				 *        return iTest;
				 *    iTest = oSort['numeric-desc']('data21', 'data22');
				 *    if (iTest !== 0)
				 *      return iTest;
				 *    return oSort['numeric-asc']( aiOrig[a], aiOrig[b] );
				 *  }
				 * Basically we have a test for each sorting column, if the data in that column is equal,
				 * test the next column. If all columns match, then we use a numeric sort on the row
				 * positions in the original data array to provide a stable sort.
				 *
				 * Note - I know it seems excessive to have two sorting methods, but the first is around
				 * 15% faster, so the second is only maintained for backwards compatibility with sorting
				 * methods which do not have a pre-sort formatting function.
				 */
				if ( formatters === aSort.length ) {
					// All sort types have formatting functions
					displayMaster.sort( function ( a, b ) {
						var
							x, y, k, test, sort,
							len=aSort.length,
							dataA = aoData[a]._aSortData,
							dataB = aoData[b]._aSortData;
		
						for ( k=0 ; k<len ; k++ ) {
							sort = aSort[k];
		
							x = dataA[ sort.col ];
							y = dataB[ sort.col ];
		
							test = x<y ? -1 : x>y ? 1 : 0;
							if ( test !== 0 ) {
								return sort.dir === 'asc' ? test : -test;
							}
						}
		
						x = aiOrig[a];
						y = aiOrig[b];
						return x<y ? -1 : x>y ? 1 : 0;
					} );
				}
				else {
					// Depreciated - remove in 1.11 (providing a plug-in option)
					// Not all sort types have formatting methods, so we have to call their sorting
					// methods.
					displayMaster.sort( function ( a, b ) {
						var
							x, y, k, l, test, sort, fn,
							len=aSort.length,
							dataA = aoData[a]._aSortData,
							dataB = aoData[b]._aSortData;
		
						for ( k=0 ; k<len ; k++ ) {
							sort = aSort[k];
		
							x = dataA[ sort.col ];
							y = dataB[ sort.col ];
		
							fn = oExtSort[ sort.type+"-"+sort.dir ] || oExtSort[ "string-"+sort.dir ];
							test = fn( x, y );
							if ( test !== 0 ) {
								return test;
							}
						}
		
						x = aiOrig[a];
						y = aiOrig[b];
						return x<y ? -1 : x>y ? 1 : 0;
					} );
				}
			}
		
			/* Tell the draw function that we have sorted the data */
			oSettings.bSorted = true;
		}
		
		
		function _fnSortAria ( settings )
		{
			var label;
			var nextSort;
			var columns = settings.aoColumns;
			var aSort = _fnSortFlatten( settings );
			var oAria = settings.oLanguage.oAria;
		
			// ARIA attributes - need to loop all columns, to update all (removing old
			// attributes as needed)
			for ( var i=0, iLen=columns.length ; i<iLen ; i++ )
			{
				var col = columns[i];
				var asSorting = col.asSorting;
				var sTitle = col.sTitle.replace( /<.*?>/g, "" );
				var th = col.nTh;
		
				// IE7 is throwing an error when setting these properties with jQuery's
				// attr() and removeAttr() methods...
				th.removeAttribute('aria-sort');
		
				/* In ARIA only the first sorting column can be marked as sorting - no multi-sort option */
				if ( col.bSortable ) {
					if ( aSort.length > 0 && aSort[0].col == i ) {
						th.setAttribute('aria-sort', aSort[0].dir=="asc" ? "ascending" : "descending" );
						nextSort = asSorting[ aSort[0].index+1 ] || asSorting[0];
					}
					else {
						nextSort = asSorting[0];
					}
		
					label = sTitle + ( nextSort === "asc" ?
						oAria.sSortAscending :
						oAria.sSortDescending
					);
				}
				else {
					label = sTitle;
				}
		
				th.setAttribute('aria-label', label);
			}
		}
		
		
		/**
		 * Function to run on user sort request
		 *  @param {object} settings dataTables settings object
		 *  @param {node} attachTo node to attach the handler to
		 *  @param {int} colIdx column sorting index
		 *  @param {boolean} [append=false] Append the requested sort to the existing
		 *    sort if true (i.e. multi-column sort)
		 *  @param {function} [callback] callback function
		 *  @memberof DataTable#oApi
		 */
		function _fnSortListener ( settings, colIdx, append, callback )
		{
			var col = settings.aoColumns[ colIdx ];
			var sorting = settings.aaSorting;
			var asSorting = col.asSorting;
			var nextSortIdx;
			var next = function ( a, overflow ) {
				var idx = a._idx;
				if ( idx === undefined ) {
					idx = $.inArray( a[1], asSorting );
				}
		
				return idx+1 < asSorting.length ?
					idx+1 :
					overflow ?
						null :
						0;
			};
		
			// Convert to 2D array if needed
			if ( typeof sorting[0] === 'number' ) {
				sorting = settings.aaSorting = [ sorting ];
			}
		
			// If appending the sort then we are multi-column sorting
			if ( append && settings.oFeatures.bSortMulti ) {
				// Are we already doing some kind of sort on this column?
				var sortIdx = $.inArray( colIdx, _pluck(sorting, '0') );
		
				if ( sortIdx !== -1 ) {
					// Yes, modify the sort
					nextSortIdx = next( sorting[sortIdx], true );
		
					if ( nextSortIdx === null && sorting.length === 1 ) {
						nextSortIdx = 0; // can't remove sorting completely
					}
		
					if ( nextSortIdx === null ) {
						sorting.splice( sortIdx, 1 );
					}
					else {
						sorting[sortIdx][1] = asSorting[ nextSortIdx ];
						sorting[sortIdx]._idx = nextSortIdx;
					}
				}
				else {
					// No sort on this column yet
					sorting.push( [ colIdx, asSorting[0], 0 ] );
					sorting[sorting.length-1]._idx = 0;
				}
			}
			else if ( sorting.length && sorting[0][0] == colIdx ) {
				// Single column - already sorting on this column, modify the sort
				nextSortIdx = next( sorting[0] );
		
				sorting.length = 1;
				sorting[0][1] = asSorting[ nextSortIdx ];
				sorting[0]._idx = nextSortIdx;
			}
			else {
				// Single column - sort only on this column
				sorting.length = 0;
				sorting.push( [ colIdx, asSorting[0] ] );
				sorting[0]._idx = 0;
			}
		
			// Run the sort by calling a full redraw
			_fnReDraw( settings );
		
			// callback used for async user interaction
			if ( typeof callback == 'function' ) {
				callback( settings );
			}
		}
		
		
		/**
		 * Attach a sort handler (click) to a node
		 *  @param {object} settings dataTables settings object
		 *  @param {node} attachTo node to attach the handler to
		 *  @param {int} colIdx column sorting index
		 *  @param {function} [callback] callback function
		 *  @memberof DataTable#oApi
		 */
		function _fnSortAttachListener ( settings, attachTo, colIdx, callback )
		{
			var col = settings.aoColumns[ colIdx ];
		
			_fnBindAction( attachTo, {}, function (e) {
				/* If the column is not sortable - don't to anything */
				if ( col.bSortable === false ) {
					return;
				}
		
				// If processing is enabled use a timeout to allow the processing
				// display to be shown - otherwise to it synchronously
				if ( settings.oFeatures.bProcessing ) {
					_fnProcessingDisplay( settings, true );
		
					setTimeout( function() {
						_fnSortListener( settings, colIdx, e.shiftKey, callback );
		
						// In server-side processing, the draw callback will remove the
						// processing display
						if ( _fnDataSource( settings ) !== 'ssp' ) {
							_fnProcessingDisplay( settings, false );
						}
					}, 0 );
				}
				else {
					_fnSortListener( settings, colIdx, e.shiftKey, callback );
				}
			} );
		}
		
		
		/**
		 * Set the sorting classes on table's body, Note: it is safe to call this function
		 * when bSort and bSortClasses are false
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnSortingClasses( settings )
		{
			var oldSort = settings.aLastSort;
			var sortClass = settings.oClasses.sSortColumn;
			var sort = _fnSortFlatten( settings );
			var features = settings.oFeatures;
			var i, ien, colIdx;
		
			if ( features.bSort && features.bSortClasses ) {
				// Remove old sorting classes
				for ( i=0, ien=oldSort.length ; i<ien ; i++ ) {
					colIdx = oldSort[i].src;
		
					// Remove column sorting
					$( _pluck( settings.aoData, 'anCells', colIdx ) )
						.removeClass( sortClass + (i<2 ? i+1 : 3) );
				}
		
				// Add new column sorting
				for ( i=0, ien=sort.length ; i<ien ; i++ ) {
					colIdx = sort[i].src;
		
					$( _pluck( settings.aoData, 'anCells', colIdx ) )
						.addClass( sortClass + (i<2 ? i+1 : 3) );
				}
			}
		
			settings.aLastSort = sort;
		}
		
		
		// Get the data to sort a column, be it from cache, fresh (populating the
		// cache), or from a sort formatter
		function _fnSortData( settings, idx )
		{
			// Custom sorting function - provided by the sort data type
			var column = settings.aoColumns[ idx ];
			var customSort = DataTable.ext.order[ column.sSortDataType ];
			var customData;
		
			if ( customSort ) {
				customData = customSort.call( settings.oInstance, settings, idx,
					_fnColumnIndexToVisible( settings, idx )
				);
			}
		
			// Use / populate cache
			var row, cellData;
			var formatter = DataTable.ext.type.order[ column.sType+"-pre" ];
		
			for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
				row = settings.aoData[i];
		
				if ( ! row._aSortData ) {
					row._aSortData = [];
				}
		
				if ( ! row._aSortData[idx] || customSort ) {
					cellData = customSort ?
						customData[i] : // If there was a custom sort function, use data from there
						_fnGetCellData( settings, i, idx, 'sort' );
		
					row._aSortData[ idx ] = formatter ?
						formatter( cellData ) :
						cellData;
				}
			}
		}
		
		
		
		/**
		 * Save the state of a table
		 *  @param {object} oSettings dataTables settings object
		 *  @memberof DataTable#oApi
		 */
		function _fnSaveState ( settings )
		{
			if ( !settings.oFeatures.bStateSave || settings.bDestroying )
			{
				return;
			}
		
			/* Store the interesting variables */
			var state = {
				time:    +new Date(),
				start:   settings._iDisplayStart,
				length:  settings._iDisplayLength,
				order:   $.extend( true, [], settings.aaSorting ),
				search:  _fnSearchToCamel( settings.oPreviousSearch ),
				columns: $.map( settings.aoColumns, function ( col, i ) {
					return {
						visible: col.bVisible,
						search: _fnSearchToCamel( settings.aoPreSearchCols[i] )
					};
				} )
			};
		
			_fnCallbackFire( settings, "aoStateSaveParams", 'stateSaveParams', [settings, state] );
		
			settings.oSavedState = state;
			settings.fnStateSaveCallback.call( settings.oInstance, settings, state );
		}
		
		
		/**
		 * Attempt to load a saved table state
		 *  @param {object} oSettings dataTables settings object
		 *  @param {object} oInit DataTables init object so we can override settings
		 *  @param {function} callback Callback to execute when the state has been loaded
		 *  @memberof DataTable#oApi
		 */
		function _fnLoadState ( settings, oInit, callback )
		{
			var i, ien;
			var columns = settings.aoColumns;
			var loaded = function ( s ) {
				if ( ! s || ! s.time ) {
					callback();
					return;
				}
		
				// Allow custom and plug-in manipulation functions to alter the saved data set and
				// cancelling of loading by returning false
				var abStateLoad = _fnCallbackFire( settings, 'aoStateLoadParams', 'stateLoadParams', [settings, s] );
				if ( $.inArray( false, abStateLoad ) !== -1 ) {
					callback();
					return;
				}
		
				// Reject old data
				var duration = settings.iStateDuration;
				if ( duration > 0 && s.time < +new Date() - (duration*1000) ) {
					callback();
					return;
				}
		
				// Number of columns have changed - all bets are off, no restore of settings
				if ( s.columns && columns.length !== s.columns.length ) {
					callback();
					return;
				}
		
				// Store the saved state so it might be accessed at any time
				settings.oLoadedState = $.extend( true, {}, s );
		
				// Restore key features - todo - for 1.11 this needs to be done by
				// subscribed events
				if ( s.start !== undefined ) {
					settings._iDisplayStart    = s.start;
					settings.iInitDisplayStart = s.start;
				}
				if ( s.length !== undefined ) {
					settings._iDisplayLength   = s.length;
				}
		
				// Order
				if ( s.order !== undefined ) {
					settings.aaSorting = [];
					$.each( s.order, function ( i, col ) {
						settings.aaSorting.push( col[0] >= columns.length ?
							[ 0, col[1] ] :
							col
						);
					} );
				}
		
				// Search
				if ( s.search !== undefined ) {
					$.extend( settings.oPreviousSearch, _fnSearchToHung( s.search ) );
				}
		
				// Columns
				//
				if ( s.columns ) {
					for ( i=0, ien=s.columns.length ; i<ien ; i++ ) {
						var col = s.columns[i];
		
						// Visibility
						if ( col.visible !== undefined ) {
							columns[i].bVisible = col.visible;
						}
		
						// Search
						if ( col.search !== undefined ) {
							$.extend( settings.aoPreSearchCols[i], _fnSearchToHung( col.search ) );
						}
					}
				}
		
				_fnCallbackFire( settings, 'aoStateLoaded', 'stateLoaded', [settings, s] );
				callback();
			}
		
			if ( ! settings.oFeatures.bStateSave ) {
				callback();
				return;
			}
		
			var state = settings.fnStateLoadCallback.call( settings.oInstance, settings, loaded );
		
			if ( state !== undefined ) {
				loaded( state );
			}
			// otherwise, wait for the loaded callback to be executed
		}
		
		
		/**
		 * Return the settings object for a particular table
		 *  @param {node} table table we are using as a dataTable
		 *  @returns {object} Settings object - or null if not found
		 *  @memberof DataTable#oApi
		 */
		function _fnSettingsFromNode ( table )
		{
			var settings = DataTable.settings;
			var idx = $.inArray( table, _pluck( settings, 'nTable' ) );
		
			return idx !== -1 ?
				settings[ idx ] :
				null;
		}
		
		
		/**
		 * Log an error message
		 *  @param {object} settings dataTables settings object
		 *  @param {int} level log error messages, or display them to the user
		 *  @param {string} msg error message
		 *  @param {int} tn Technical note id to get more information about the error.
		 *  @memberof DataTable#oApi
		 */
		function _fnLog( settings, level, msg, tn )
		{
			msg = 'DataTables warning: '+
				(settings ? 'table id='+settings.sTableId+' - ' : '')+msg;
		
			if ( tn ) {
				msg += '. For more information about this error, please see '+
				'http://datatables.net/tn/'+tn;
			}
		
			if ( ! level  ) {
				// Backwards compatibility pre 1.10
				var ext = DataTable.ext;
				var type = ext.sErrMode || ext.errMode;
		
				if ( settings ) {
					_fnCallbackFire( settings, null, 'error', [ settings, tn, msg ] );
				}
		
				if ( type == 'alert' ) {
					alert( msg );
				}
				else if ( type == 'throw' ) {
					throw new Error(msg);
				}
				else if ( typeof type == 'function' ) {
					type( settings, tn, msg );
				}
			}
			else if ( window.console && console.log ) {
				console.log( msg );
			}
		}
		
		
		/**
		 * See if a property is defined on one object, if so assign it to the other object
		 *  @param {object} ret target object
		 *  @param {object} src source object
		 *  @param {string} name property
		 *  @param {string} [mappedName] name to map too - optional, name used if not given
		 *  @memberof DataTable#oApi
		 */
		function _fnMap( ret, src, name, mappedName )
		{
			if ( $.isArray( name ) ) {
				$.each( name, function (i, val) {
					if ( $.isArray( val ) ) {
						_fnMap( ret, src, val[0], val[1] );
					}
					else {
						_fnMap( ret, src, val );
					}
				} );
		
				return;
			}
		
			if ( mappedName === undefined ) {
				mappedName = name;
			}
		
			if ( src[name] !== undefined ) {
				ret[mappedName] = src[name];
			}
		}
		
		
		/**
		 * Extend objects - very similar to jQuery.extend, but deep copy objects, and
		 * shallow copy arrays. The reason we need to do this, is that we don't want to
		 * deep copy array init values (such as aaSorting) since the dev wouldn't be
		 * able to override them, but we do want to deep copy arrays.
		 *  @param {object} out Object to extend
		 *  @param {object} extender Object from which the properties will be applied to
		 *      out
		 *  @param {boolean} breakRefs If true, then arrays will be sliced to take an
		 *      independent copy with the exception of the `data` or `aaData` parameters
		 *      if they are present. This is so you can pass in a collection to
		 *      DataTables and have that used as your data source without breaking the
		 *      references
		 *  @returns {object} out Reference, just for convenience - out === the return.
		 *  @memberof DataTable#oApi
		 *  @todo This doesn't take account of arrays inside the deep copied objects.
		 */
		function _fnExtend( out, extender, breakRefs )
		{
			var val;
		
			for ( var prop in extender ) {
				if ( extender.hasOwnProperty(prop) ) {
					val = extender[prop];
		
					if ( $.isPlainObject( val ) ) {
						if ( ! $.isPlainObject( out[prop] ) ) {
							out[prop] = {};
						}
						$.extend( true, out[prop], val );
					}
					else if ( breakRefs && prop !== 'data' && prop !== 'aaData' && $.isArray(val) ) {
						out[prop] = val.slice();
					}
					else {
						out[prop] = val;
					}
				}
			}
		
			return out;
		}
		
		
		/**
		 * Bind an event handers to allow a click or return key to activate the callback.
		 * This is good for accessibility since a return on the keyboard will have the
		 * same effect as a click, if the element has focus.
		 *  @param {element} n Element to bind the action to
		 *  @param {object} oData Data object to pass to the triggered function
		 *  @param {function} fn Callback function for when the event is triggered
		 *  @memberof DataTable#oApi
		 */
		function _fnBindAction( n, oData, fn )
		{
			$(n)
				.on( 'click.DT', oData, function (e) {
						$(n).blur(); // Remove focus outline for mouse users
						fn(e);
					} )
				.on( 'keypress.DT', oData, function (e){
						if ( e.which === 13 ) {
							e.preventDefault();
							fn(e);
						}
					} )
				.on( 'selectstart.DT', function () {
						/* Take the brutal approach to cancelling text selection */
						return false;
					} );
		}
		
		
		/**
		 * Register a callback function. Easily allows a callback function to be added to
		 * an array store of callback functions that can then all be called together.
		 *  @param {object} oSettings dataTables settings object
		 *  @param {string} sStore Name of the array storage for the callbacks in oSettings
		 *  @param {function} fn Function to be called back
		 *  @param {string} sName Identifying name for the callback (i.e. a label)
		 *  @memberof DataTable#oApi
		 */
		function _fnCallbackReg( oSettings, sStore, fn, sName )
		{
			if ( fn )
			{
				oSettings[sStore].push( {
					"fn": fn,
					"sName": sName
				} );
			}
		}
		
		
		/**
		 * Fire callback functions and trigger events. Note that the loop over the
		 * callback array store is done backwards! Further note that you do not want to
		 * fire off triggers in time sensitive applications (for example cell creation)
		 * as its slow.
		 *  @param {object} settings dataTables settings object
		 *  @param {string} callbackArr Name of the array storage for the callbacks in
		 *      oSettings
		 *  @param {string} eventName Name of the jQuery custom event to trigger. If
		 *      null no trigger is fired
		 *  @param {array} args Array of arguments to pass to the callback function /
		 *      trigger
		 *  @memberof DataTable#oApi
		 */
		function _fnCallbackFire( settings, callbackArr, eventName, args )
		{
			var ret = [];
		
			if ( callbackArr ) {
				ret = $.map( settings[callbackArr].slice().reverse(), function (val, i) {
					return val.fn.apply( settings.oInstance, args );
				} );
			}
		
			if ( eventName !== null ) {
				var e = $.Event( eventName+'.dt' );
		
				$(settings.nTable).trigger( e, args );
		
				ret.push( e.result );
			}
		
			return ret;
		}
		
		
		function _fnLengthOverflow ( settings )
		{
			var
				start = settings._iDisplayStart,
				end = settings.fnDisplayEnd(),
				len = settings._iDisplayLength;
		
			/* If we have space to show extra rows (backing up from the end point - then do so */
			if ( start >= end )
			{
				start = end - len;
			}
		
			// Keep the start record on the current page
			start -= (start % len);
		
			if ( len === -1 || start < 0 )
			{
				start = 0;
			}
		
			settings._iDisplayStart = start;
		}
		
		
		function _fnRenderer( settings, type )
		{
			var renderer = settings.renderer;
			var host = DataTable.ext.renderer[type];
		
			if ( $.isPlainObject( renderer ) && renderer[type] ) {
				// Specific renderer for this type. If available use it, otherwise use
				// the default.
				return host[renderer[type]] || host._;
			}
			else if ( typeof renderer === 'string' ) {
				// Common renderer - if there is one available for this type use it,
				// otherwise use the default
				return host[renderer] || host._;
			}
		
			// Use the default
			return host._;
		}
		
		
		/**
		 * Detect the data source being used for the table. Used to simplify the code
		 * a little (ajax) and to make it compress a little smaller.
		 *
		 *  @param {object} settings dataTables settings object
		 *  @returns {string} Data source
		 *  @memberof DataTable#oApi
		 */
		function _fnDataSource ( settings )
		{
			if ( settings.oFeatures.bServerSide ) {
				return 'ssp';
			}
			else if ( settings.ajax || settings.sAjaxSource ) {
				return 'ajax';
			}
			return 'dom';
		}
		
	
		
		
		/**
		 * Computed structure of the DataTables API, defined by the options passed to
		 * `DataTable.Api.register()` when building the API.
		 *
		 * The structure is built in order to speed creation and extension of the Api
		 * objects since the extensions are effectively pre-parsed.
		 *
		 * The array is an array of objects with the following structure, where this
		 * base array represents the Api prototype base:
		 *
		 *     [
		 *       {
		 *         name:      'data'                -- string   - Property name
		 *         val:       function () {},       -- function - Api method (or undefined if just an object
		 *         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
		 *         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
		 *       },
		 *       {
		 *         name:     'row'
		 *         val:       {},
		 *         methodExt: [ ... ],
		 *         propExt:   [
		 *           {
		 *             name:      'data'
		 *             val:       function () {},
		 *             methodExt: [ ... ],
		 *             propExt:   [ ... ]
		 *           },
		 *           ...
		 *         ]
		 *       }
		 *     ]
		 *
		 * @type {Array}
		 * @ignore
		 */
		var __apiStruct = [];
		
		
		/**
		 * `Array.prototype` reference.
		 *
		 * @type object
		 * @ignore
		 */
		var __arrayProto = Array.prototype;
		
		
		/**
		 * Abstraction for `context` parameter of the `Api` constructor to allow it to
		 * take several different forms for ease of use.
		 *
		 * Each of the input parameter types will be converted to a DataTables settings
		 * object where possible.
		 *
		 * @param  {string|node|jQuery|object} mixed DataTable identifier. Can be one
		 *   of:
		 *
		 *   * `string` - jQuery selector. Any DataTables' matching the given selector
		 *     with be found and used.
		 *   * `node` - `TABLE` node which has already been formed into a DataTable.
		 *   * `jQuery` - A jQuery object of `TABLE` nodes.
		 *   * `object` - DataTables settings object
		 *   * `DataTables.Api` - API instance
		 * @return {array|null} Matching DataTables settings objects. `null` or
		 *   `undefined` is returned if no matching DataTable is found.
		 * @ignore
		 */
		var _toSettings = function ( mixed )
		{
			var idx, jq;
			var settings = DataTable.settings;
			var tables = $.map( settings, function (el, i) {
				return el.nTable;
			} );
		
			if ( ! mixed ) {
				return [];
			}
			else if ( mixed.nTable && mixed.oApi ) {
				// DataTables settings object
				return [ mixed ];
			}
			else if ( mixed.nodeName && mixed.nodeName.toLowerCase() === 'table' ) {
				// Table node
				idx = $.inArray( mixed, tables );
				return idx !== -1 ? [ settings[idx] ] : null;
			}
			else if ( mixed && typeof mixed.settings === 'function' ) {
				return mixed.settings().toArray();
			}
			else if ( typeof mixed === 'string' ) {
				// jQuery selector
				jq = $(mixed);
			}
			else if ( mixed instanceof $ ) {
				// jQuery object (also DataTables instance)
				jq = mixed;
			}
		
			if ( jq ) {
				return jq.map( function(i) {
					idx = $.inArray( this, tables );
					return idx !== -1 ? settings[idx] : null;
				} ).toArray();
			}
		};
		
		
		/**
		 * DataTables API class - used to control and interface with  one or more
		 * DataTables enhanced tables.
		 *
		 * The API class is heavily based on jQuery, presenting a chainable interface
		 * that you can use to interact with tables. Each instance of the API class has
		 * a "context" - i.e. the tables that it will operate on. This could be a single
		 * table, all tables on a page or a sub-set thereof.
		 *
		 * Additionally the API is designed to allow you to easily work with the data in
		 * the tables, retrieving and manipulating it as required. This is done by
		 * presenting the API class as an array like interface. The contents of the
		 * array depend upon the actions requested by each method (for example
		 * `rows().nodes()` will return an array of nodes, while `rows().data()` will
		 * return an array of objects or arrays depending upon your table's
		 * configuration). The API object has a number of array like methods (`push`,
		 * `pop`, `reverse` etc) as well as additional helper methods (`each`, `pluck`,
		 * `unique` etc) to assist your working with the data held in a table.
		 *
		 * Most methods (those which return an Api instance) are chainable, which means
		 * the return from a method call also has all of the methods available that the
		 * top level object had. For example, these two calls are equivalent:
		 *
		 *     // Not chained
		 *     api.row.add( {...} );
		 *     api.draw();
		 *
		 *     // Chained
		 *     api.row.add( {...} ).draw();
		 *
		 * @class DataTable.Api
		 * @param {array|object|string|jQuery} context DataTable identifier. This is
		 *   used to define which DataTables enhanced tables this API will operate on.
		 *   Can be one of:
		 *
		 *   * `string` - jQuery selector. Any DataTables' matching the given selector
		 *     with be found and used.
		 *   * `node` - `TABLE` node which has already been formed into a DataTable.
		 *   * `jQuery` - A jQuery object of `TABLE` nodes.
		 *   * `object` - DataTables settings object
		 * @param {array} [data] Data to initialise the Api instance with.
		 *
		 * @example
		 *   // Direct initialisation during DataTables construction
		 *   var api = $('#example').DataTable();
		 *
		 * @example
		 *   // Initialisation using a DataTables jQuery object
		 *   var api = $('#example').dataTable().api();
		 *
		 * @example
		 *   // Initialisation as a constructor
		 *   var api = new $.fn.DataTable.Api( 'table.dataTable' );
		 */
		_Api = function ( context, data )
		{
			if ( ! (this instanceof _Api) ) {
				return new _Api( context, data );
			}
		
			var settings = [];
			var ctxSettings = function ( o ) {
				var a = _toSettings( o );
				if ( a ) {
					settings = settings.concat( a );
				}
			};
		
			if ( $.isArray( context ) ) {
				for ( var i=0, ien=context.length ; i<ien ; i++ ) {
					ctxSettings( context[i] );
				}
			}
			else {
				ctxSettings( context );
			}
		
			// Remove duplicates
			this.context = _unique( settings );
		
			// Initial data
			if ( data ) {
				$.merge( this, data );
			}
		
			// selector
			this.selector = {
				rows: null,
				cols: null,
				opts: null
			};
		
			_Api.extend( this, this, __apiStruct );
		};
		
		DataTable.Api = _Api;
		
		// Don't destroy the existing prototype, just extend it. Required for jQuery 2's
		// isPlainObject.
		$.extend( _Api.prototype, {
			any: function ()
			{
				return this.count() !== 0;
			},
		
		
			concat:  __arrayProto.concat,
		
		
			context: [], // array of table settings objects
		
		
			count: function ()
			{
				return this.flatten().length;
			},
		
		
			each: function ( fn )
			{
				for ( var i=0, ien=this.length ; i<ien; i++ ) {
					fn.call( this, this[i], i, this );
				}
		
				return this;
			},
		
		
			eq: function ( idx )
			{
				var ctx = this.context;
		
				return ctx.length > idx ?
					new _Api( ctx[idx], this[idx] ) :
					null;
			},
		
		
			filter: function ( fn )
			{
				var a = [];
		
				if ( __arrayProto.filter ) {
					a = __arrayProto.filter.call( this, fn, this );
				}
				else {
					// Compatibility for browsers without EMCA-252-5 (JS 1.6)
					for ( var i=0, ien=this.length ; i<ien ; i++ ) {
						if ( fn.call( this, this[i], i, this ) ) {
							a.push( this[i] );
						}
					}
				}
		
				return new _Api( this.context, a );
			},
		
		
			flatten: function ()
			{
				var a = [];
				return new _Api( this.context, a.concat.apply( a, this.toArray() ) );
			},
		
		
			join:    __arrayProto.join,
		
		
			indexOf: __arrayProto.indexOf || function (obj, start)
			{
				for ( var i=(start || 0), ien=this.length ; i<ien ; i++ ) {
					if ( this[i] === obj ) {
						return i;
					}
				}
				return -1;
			},
		
			iterator: function ( flatten, type, fn, alwaysNew ) {
				var
					a = [], ret,
					i, ien, j, jen,
					context = this.context,
					rows, items, item,
					selector = this.selector;
		
				// Argument shifting
				if ( typeof flatten === 'string' ) {
					alwaysNew = fn;
					fn = type;
					type = flatten;
					flatten = false;
				}
		
				for ( i=0, ien=context.length ; i<ien ; i++ ) {
					var apiInst = new _Api( context[i] );
		
					if ( type === 'table' ) {
						ret = fn.call( apiInst, context[i], i );
		
						if ( ret !== undefined ) {
							a.push( ret );
						}
					}
					else if ( type === 'columns' || type === 'rows' ) {
						// this has same length as context - one entry for each table
						ret = fn.call( apiInst, context[i], this[i], i );
		
						if ( ret !== undefined ) {
							a.push( ret );
						}
					}
					else if ( type === 'column' || type === 'column-rows' || type === 'row' || type === 'cell' ) {
						// columns and rows share the same structure.
						// 'this' is an array of column indexes for each context
						items = this[i];
		
						if ( type === 'column-rows' ) {
							rows = _selector_row_indexes( context[i], selector.opts );
						}
		
						for ( j=0, jen=items.length ; j<jen ; j++ ) {
							item = items[j];
		
							if ( type === 'cell' ) {
								ret = fn.call( apiInst, context[i], item.row, item.column, i, j );
							}
							else {
								ret = fn.call( apiInst, context[i], item, i, j, rows );
							}
		
							if ( ret !== undefined ) {
								a.push( ret );
							}
						}
					}
				}
		
				if ( a.length || alwaysNew ) {
					var api = new _Api( context, flatten ? a.concat.apply( [], a ) : a );
					var apiSelector = api.selector;
					apiSelector.rows = selector.rows;
					apiSelector.cols = selector.cols;
					apiSelector.opts = selector.opts;
					return api;
				}
				return this;
			},
		
		
			lastIndexOf: __arrayProto.lastIndexOf || function (obj, start)
			{
				// Bit cheeky...
				return this.indexOf.apply( this.toArray.reverse(), arguments );
			},
		
		
			length:  0,
		
		
			map: function ( fn )
			{
				var a = [];
		
				if ( __arrayProto.map ) {
					a = __arrayProto.map.call( this, fn, this );
				}
				else {
					// Compatibility for browsers without EMCA-252-5 (JS 1.6)
					for ( var i=0, ien=this.length ; i<ien ; i++ ) {
						a.push( fn.call( this, this[i], i ) );
					}
				}
		
				return new _Api( this.context, a );
			},
		
		
			pluck: function ( prop )
			{
				return this.map( function ( el ) {
					return el[ prop ];
				} );
			},
		
			pop:     __arrayProto.pop,
		
		
			push:    __arrayProto.push,
		
		
			// Does not return an API instance
			reduce: __arrayProto.reduce || function ( fn, init )
			{
				return _fnReduce( this, fn, init, 0, this.length, 1 );
			},
		
		
			reduceRight: __arrayProto.reduceRight || function ( fn, init )
			{
				return _fnReduce( this, fn, init, this.length-1, -1, -1 );
			},
		
		
			reverse: __arrayProto.reverse,
		
		
			// Object with rows, columns and opts
			selector: null,
		
		
			shift:   __arrayProto.shift,
		
		
			slice: function () {
				return new _Api( this.context, this );
			},
		
		
			sort:    __arrayProto.sort, // ? name - order?
		
		
			splice:  __arrayProto.splice,
		
		
			toArray: function ()
			{
				return __arrayProto.slice.call( this );
			},
		
		
			to$: function ()
			{
				return $( this );
			},
		
		
			toJQuery: function ()
			{
				return $( this );
			},
		
		
			unique: function ()
			{
				return new _Api( this.context, _unique(this) );
			},
		
		
			unshift: __arrayProto.unshift
		} );
		
		
		_Api.extend = function ( scope, obj, ext )
		{
			// Only extend API instances and static properties of the API
			if ( ! ext.length || ! obj || ( ! (obj instanceof _Api) && ! obj.__dt_wrapper ) ) {
				return;
			}
		
			var
				i, ien,
				j, jen,
				struct, inner,
				methodScoping = function ( scope, fn, struc ) {
					return function () {
						var ret = fn.apply( scope, arguments );
		
						// Method extension
						_Api.extend( ret, ret, struc.methodExt );
						return ret;
					};
				};
		
			for ( i=0, ien=ext.length ; i<ien ; i++ ) {
				struct = ext[i];
		
				// Value
				obj[ struct.name ] = typeof struct.val === 'function' ?
					methodScoping( scope, struct.val, struct ) :
					$.isPlainObject( struct.val ) ?
						{} :
						struct.val;
		
				obj[ struct.name ].__dt_wrapper = true;
		
				// Property extension
				_Api.extend( scope, obj[ struct.name ], struct.propExt );
			}
		};
		
		
		// @todo - Is there need for an augment function?
		// _Api.augment = function ( inst, name )
		// {
		// 	// Find src object in the structure from the name
		// 	var parts = name.split('.');
		
		// 	_Api.extend( inst, obj );
		// };
		
		
		//     [
		//       {
		//         name:      'data'                -- string   - Property name
		//         val:       function () {},       -- function - Api method (or undefined if just an object
		//         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
		//         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
		//       },
		//       {
		//         name:     'row'
		//         val:       {},
		//         methodExt: [ ... ],
		//         propExt:   [
		//           {
		//             name:      'data'
		//             val:       function () {},
		//             methodExt: [ ... ],
		//             propExt:   [ ... ]
		//           },
		//           ...
		//         ]
		//       }
		//     ]
		
		_Api.register = _api_register = function ( name, val )
		{
			if ( $.isArray( name ) ) {
				for ( var j=0, jen=name.length ; j<jen ; j++ ) {
					_Api.register( name[j], val );
				}
				return;
			}
		
			var
				i, ien,
				heir = name.split('.'),
				struct = __apiStruct,
				key, method;
		
			var find = function ( src, name ) {
				for ( var i=0, ien=src.length ; i<ien ; i++ ) {
					if ( src[i].name === name ) {
						return src[i];
					}
				}
				return null;
			};
		
			for ( i=0, ien=heir.length ; i<ien ; i++ ) {
				method = heir[i].indexOf('()') !== -1;
				key = method ?
					heir[i].replace('()', '') :
					heir[i];
		
				var src = find( struct, key );
				if ( ! src ) {
					src = {
						name:      key,
						val:       {},
						methodExt: [],
						propExt:   []
					};
					struct.push( src );
				}
		
				if ( i === ien-1 ) {
					src.val = val;
				}
				else {
					struct = method ?
						src.methodExt :
						src.propExt;
				}
			}
		};
		
		
		_Api.registerPlural = _api_registerPlural = function ( pluralName, singularName, val ) {
			_Api.register( pluralName, val );
		
			_Api.register( singularName, function () {
				var ret = val.apply( this, arguments );
		
				if ( ret === this ) {
					// Returned item is the API instance that was passed in, return it
					return this;
				}
				else if ( ret instanceof _Api ) {
					// New API instance returned, want the value from the first item
					// in the returned array for the singular result.
					return ret.length ?
						$.isArray( ret[0] ) ?
							new _Api( ret.context, ret[0] ) : // Array results are 'enhanced'
							ret[0] :
						undefined;
				}
		
				// Non-API return - just fire it back
				return ret;
			} );
		};
		
		
		/**
		 * Selector for HTML tables. Apply the given selector to the give array of
		 * DataTables settings objects.
		 *
		 * @param {string|integer} [selector] jQuery selector string or integer
		 * @param  {array} Array of DataTables settings objects to be filtered
		 * @return {array}
		 * @ignore
		 */
		var __table_selector = function ( selector, a )
		{
			// Integer is used to pick out a table by index
			if ( typeof selector === 'number' ) {
				return [ a[ selector ] ];
			}
		
			// Perform a jQuery selector on the table nodes
			var nodes = $.map( a, function (el, i) {
				return el.nTable;
			} );
		
			return $(nodes)
				.filter( selector )
				.map( function (i) {
					// Need to translate back from the table node to the settings
					var idx = $.inArray( this, nodes );
					return a[ idx ];
				} )
				.toArray();
		};
		
		
		
		/**
		 * Context selector for the API's context (i.e. the tables the API instance
		 * refers to.
		 *
		 * @name    DataTable.Api#tables
		 * @param {string|integer} [selector] Selector to pick which tables the iterator
		 *   should operate on. If not given, all tables in the current context are
		 *   used. This can be given as a jQuery selector (for example `':gt(0)'`) to
		 *   select multiple tables or as an integer to select a single table.
		 * @returns {DataTable.Api} Returns a new API instance if a selector is given.
		 */
		_api_register( 'tables()', function ( selector ) {
			// A new instance is created if there was a selector specified
			return selector ?
				new _Api( __table_selector( selector, this.context ) ) :
				this;
		} );
		
		
		_api_register( 'table()', function ( selector ) {
			var tables = this.tables( selector );
			var ctx = tables.context;
		
			// Truncate to the first matched table
			return ctx.length ?
				new _Api( ctx[0] ) :
				tables;
		} );
		
		
		_api_registerPlural( 'tables().nodes()', 'table().node()' , function () {
			return this.iterator( 'table', function ( ctx ) {
				return ctx.nTable;
			}, 1 );
		} );
		
		
		_api_registerPlural( 'tables().body()', 'table().body()' , function () {
			return this.iterator( 'table', function ( ctx ) {
				return ctx.nTBody;
			}, 1 );
		} );
		
		
		_api_registerPlural( 'tables().header()', 'table().header()' , function () {
			return this.iterator( 'table', function ( ctx ) {
				return ctx.nTHead;
			}, 1 );
		} );
		
		
		_api_registerPlural( 'tables().footer()', 'table().footer()' , function () {
			return this.iterator( 'table', function ( ctx ) {
				return ctx.nTFoot;
			}, 1 );
		} );
		
		
		_api_registerPlural( 'tables().containers()', 'table().container()' , function () {
			return this.iterator( 'table', function ( ctx ) {
				return ctx.nTableWrapper;
			}, 1 );
		} );
		
		
		
		/**
		 * Redraw the tables in the current context.
		 */
		_api_register( 'draw()', function ( paging ) {
			return this.iterator( 'table', function ( settings ) {
				if ( paging === 'page' ) {
					_fnDraw( settings );
				}
				else {
					if ( typeof paging === 'string' ) {
						paging = paging === 'full-hold' ?
							false :
							true;
					}
		
					_fnReDraw( settings, paging===false );
				}
			} );
		} );
		
		
		
		/**
		 * Get the current page index.
		 *
		 * @return {integer} Current page index (zero based)
		 *//**
		 * Set the current page.
		 *
		 * Note that if you attempt to show a page which does not exist, DataTables will
		 * not throw an error, but rather reset the paging.
		 *
		 * @param {integer|string} action The paging action to take. This can be one of:
		 *  * `integer` - The page index to jump to
		 *  * `string` - An action to take:
		 *    * `first` - Jump to first page.
		 *    * `next` - Jump to the next page
		 *    * `previous` - Jump to previous page
		 *    * `last` - Jump to the last page.
		 * @returns {DataTables.Api} this
		 */
		_api_register( 'page()', function ( action ) {
			if ( action === undefined ) {
				return this.page.info().page; // not an expensive call
			}
		
			// else, have an action to take on all tables
			return this.iterator( 'table', function ( settings ) {
				_fnPageChange( settings, action );
			} );
		} );
		
		
		/**
		 * Paging information for the first table in the current context.
		 *
		 * If you require paging information for another table, use the `table()` method
		 * with a suitable selector.
		 *
		 * @return {object} Object with the following properties set:
		 *  * `page` - Current page index (zero based - i.e. the first page is `0`)
		 *  * `pages` - Total number of pages
		 *  * `start` - Display index for the first record shown on the current page
		 *  * `end` - Display index for the last record shown on the current page
		 *  * `length` - Display length (number of records). Note that generally `start
		 *    + length = end`, but this is not always true, for example if there are
		 *    only 2 records to show on the final page, with a length of 10.
		 *  * `recordsTotal` - Full data set length
		 *  * `recordsDisplay` - Data set length once the current filtering criterion
		 *    are applied.
		 */
		_api_register( 'page.info()', function ( action ) {
			if ( this.context.length === 0 ) {
				return undefined;
			}
		
			var
				settings   = this.context[0],
				start      = settings._iDisplayStart,
				len        = settings.oFeatures.bPaginate ? settings._iDisplayLength : -1,
				visRecords = settings.fnRecordsDisplay(),
				all        = len === -1;
		
			return {
				"page":           all ? 0 : Math.floor( start / len ),
				"pages":          all ? 1 : Math.ceil( visRecords / len ),
				"start":          start,
				"end":            settings.fnDisplayEnd(),
				"length":         len,
				"recordsTotal":   settings.fnRecordsTotal(),
				"recordsDisplay": visRecords,
				"serverSide":     _fnDataSource( settings ) === 'ssp'
			};
		} );
		
		
		/**
		 * Get the current page length.
		 *
		 * @return {integer} Current page length. Note `-1` indicates that all records
		 *   are to be shown.
		 *//**
		 * Set the current page length.
		 *
		 * @param {integer} Page length to set. Use `-1` to show all records.
		 * @returns {DataTables.Api} this
		 */
		_api_register( 'page.len()', function ( len ) {
			// Note that we can't call this function 'length()' because `length`
			// is a Javascript property of functions which defines how many arguments
			// the function expects.
			if ( len === undefined ) {
				return this.context.length !== 0 ?
					this.context[0]._iDisplayLength :
					undefined;
			}
		
			// else, set the page length
			return this.iterator( 'table', function ( settings ) {
				_fnLengthChange( settings, len );
			} );
		} );
		
		
		
		var __reload = function ( settings, holdPosition, callback ) {
			// Use the draw event to trigger a callback
			if ( callback ) {
				var api = new _Api( settings );
		
				api.one( 'draw', function () {
					callback( api.ajax.json() );
				} );
			}
		
			if ( _fnDataSource( settings ) == 'ssp' ) {
				_fnReDraw( settings, holdPosition );
			}
			else {
				_fnProcessingDisplay( settings, true );
		
				// Cancel an existing request
				var xhr = settings.jqXHR;
				if ( xhr && xhr.readyState !== 4 ) {
					xhr.abort();
				}
		
				// Trigger xhr
				_fnBuildAjax( settings, [], function( json ) {
					_fnClearTable( settings );
		
					var data = _fnAjaxDataSrc( settings, json );
					for ( var i=0, ien=data.length ; i<ien ; i++ ) {
						_fnAddData( settings, data[i] );
					}
		
					_fnReDraw( settings, holdPosition );
					_fnProcessingDisplay( settings, false );
				} );
			}
		};
		
		
		/**
		 * Get the JSON response from the last Ajax request that DataTables made to the
		 * server. Note that this returns the JSON from the first table in the current
		 * context.
		 *
		 * @return {object} JSON received from the server.
		 */
		_api_register( 'ajax.json()', function () {
			var ctx = this.context;
		
			if ( ctx.length > 0 ) {
				return ctx[0].json;
			}
		
			// else return undefined;
		} );
		
		
		/**
		 * Get the data submitted in the last Ajax request
		 */
		_api_register( 'ajax.params()', function () {
			var ctx = this.context;
		
			if ( ctx.length > 0 ) {
				return ctx[0].oAjaxData;
			}
		
			// else return undefined;
		} );
		
		
		/**
		 * Reload tables from the Ajax data source. Note that this function will
		 * automatically re-draw the table when the remote data has been loaded.
		 *
		 * @param {boolean} [reset=true] Reset (default) or hold the current paging
		 *   position. A full re-sort and re-filter is performed when this method is
		 *   called, which is why the pagination reset is the default action.
		 * @returns {DataTables.Api} this
		 */
		_api_register( 'ajax.reload()', function ( callback, resetPaging ) {
			return this.iterator( 'table', function (settings) {
				__reload( settings, resetPaging===false, callback );
			} );
		} );
		
		
		/**
		 * Get the current Ajax URL. Note that this returns the URL from the first
		 * table in the current context.
		 *
		 * @return {string} Current Ajax source URL
		 *//**
		 * Set the Ajax URL. Note that this will set the URL for all tables in the
		 * current context.
		 *
		 * @param {string} url URL to set.
		 * @returns {DataTables.Api} this
		 */
		_api_register( 'ajax.url()', function ( url ) {
			var ctx = this.context;
		
			if ( url === undefined ) {
				// get
				if ( ctx.length === 0 ) {
					return undefined;
				}
				ctx = ctx[0];
		
				return ctx.ajax ?
					$.isPlainObject( ctx.ajax ) ?
						ctx.ajax.url :
						ctx.ajax :
					ctx.sAjaxSource;
			}
		
			// set
			return this.iterator( 'table', function ( settings ) {
				if ( $.isPlainObject( settings.ajax ) ) {
					settings.ajax.url = url;
				}
				else {
					settings.ajax = url;
				}
				// No need to consider sAjaxSource here since DataTables gives priority
				// to `ajax` over `sAjaxSource`. So setting `ajax` here, renders any
				// value of `sAjaxSource` redundant.
			} );
		} );
		
		
		/**
		 * Load data from the newly set Ajax URL. Note that this method is only
		 * available when `ajax.url()` is used to set a URL. Additionally, this method
		 * has the same effect as calling `ajax.reload()` but is provided for
		 * convenience when setting a new URL. Like `ajax.reload()` it will
		 * automatically redraw the table once the remote data has been loaded.
		 *
		 * @returns {DataTables.Api} this
		 */
		_api_register( 'ajax.url().load()', function ( callback, resetPaging ) {
			// Same as a reload, but makes sense to present it for easy access after a
			// url change
			return this.iterator( 'table', function ( ctx ) {
				__reload( ctx, resetPaging===false, callback );
			} );
		} );
		
		
		
		
		var _selector_run = function ( type, selector, selectFn, settings, opts )
		{
			var
				out = [], res,
				a, i, ien, j, jen,
				selectorType = typeof selector;
		
			// Can't just check for isArray here, as an API or jQuery instance might be
			// given with their array like look
			if ( ! selector || selectorType === 'string' || selectorType === 'function' || selector.length === undefined ) {
				selector = [ selector ];
			}
		
			for ( i=0, ien=selector.length ; i<ien ; i++ ) {
				// Only split on simple strings - complex expressions will be jQuery selectors
				a = selector[i] && selector[i].split && ! selector[i].match(/[\[\(:]/) ?
					selector[i].split(',') :
					[ selector[i] ];
		
				for ( j=0, jen=a.length ; j<jen ; j++ ) {
					res = selectFn( typeof a[j] === 'string' ? $.trim(a[j]) : a[j] );
		
					if ( res && res.length ) {
						out = out.concat( res );
					}
				}
			}
		
			// selector extensions
			var ext = _ext.selector[ type ];
			if ( ext.length ) {
				for ( i=0, ien=ext.length ; i<ien ; i++ ) {
					out = ext[i]( settings, opts, out );
				}
			}
		
			return _unique( out );
		};
		
		
		var _selector_opts = function ( opts )
		{
			if ( ! opts ) {
				opts = {};
			}
		
			// Backwards compatibility for 1.9- which used the terminology filter rather
			// than search
			if ( opts.filter && opts.search === undefined ) {
				opts.search = opts.filter;
			}
		
			return $.extend( {
				search: 'none',
				order: 'current',
				page: 'all'
			}, opts );
		};
		
		
		var _selector_first = function ( inst )
		{
			// Reduce the API instance to the first item found
			for ( var i=0, ien=inst.length ; i<ien ; i++ ) {
				if ( inst[i].length > 0 ) {
					// Assign the first element to the first item in the instance
					// and truncate the instance and context
					inst[0] = inst[i];
					inst[0].length = 1;
					inst.length = 1;
					inst.context = [ inst.context[i] ];
		
					return inst;
				}
			}
		
			// Not found - return an empty instance
			inst.length = 0;
			return inst;
		};
		
		
		var _selector_row_indexes = function ( settings, opts )
		{
			var
				i, ien, tmp, a=[],
				displayFiltered = settings.aiDisplay,
				displayMaster = settings.aiDisplayMaster;
		
			var
				search = opts.search,  // none, applied, removed
				order  = opts.order,   // applied, current, index (original - compatibility with 1.9)
				page   = opts.page;    // all, current
		
			if ( _fnDataSource( settings ) == 'ssp' ) {
				// In server-side processing mode, most options are irrelevant since
				// rows not shown don't exist and the index order is the applied order
				// Removed is a special case - for consistency just return an empty
				// array
				return search === 'removed' ?
					[] :
					_range( 0, displayMaster.length );
			}
			else if ( page == 'current' ) {
				// Current page implies that order=current and fitler=applied, since it is
				// fairly senseless otherwise, regardless of what order and search actually
				// are
				for ( i=settings._iDisplayStart, ien=settings.fnDisplayEnd() ; i<ien ; i++ ) {
					a.push( displayFiltered[i] );
				}
			}
			else if ( order == 'current' || order == 'applied' ) {
				if ( search == 'none') {
					a = displayMaster.slice();
				}
				else if ( search == 'applied' ) {
					a = displayFiltered.slice();
				}
				else if ( search == 'removed' ) {
					// O(n+m) solution by creating a hash map
					var displayFilteredMap = {};
		
					for ( var i=0, ien=displayFiltered.length ; i<ien ; i++ ) {
						displayFilteredMap[displayFiltered[i]] = null;
					}
		
					a = $.map( displayMaster, function (el) {
						return ! displayFilteredMap.hasOwnProperty(el) ?
							el :
							null;
					} );
				}
			}
			else if ( order == 'index' || order == 'original' ) {
				for ( i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
					if ( search == 'none' ) {
						a.push( i );
					}
					else { // applied | removed
						tmp = $.inArray( i, displayFiltered );
		
						if ((tmp === -1 && search == 'removed') ||
							(tmp >= 0   && search == 'applied') )
						{
							a.push( i );
						}
					}
				}
			}
		
			return a;
		};
		
		
		/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
		 * Rows
		 *
		 * {}          - no selector - use all available rows
		 * {integer}   - row aoData index
		 * {node}      - TR node
		 * {string}    - jQuery selector to apply to the TR elements
		 * {array}     - jQuery array of nodes, or simply an array of TR nodes
		 *
		 */
		var __row_selector = function ( settings, selector, opts )
		{
			var rows;
			var run = function ( sel ) {
				var selInt = _intVal( sel );
				var i, ien;
				var aoData = settings.aoData;
		
				// Short cut - selector is a number and no options provided (default is
				// all records, so no need to check if the index is in there, since it
				// must be - dev error if the index doesn't exist).
				if ( selInt !== null && ! opts ) {
					return [ selInt ];
				}
		
				if ( ! rows ) {
					rows = _selector_row_indexes( settings, opts );
				}
		
				if ( selInt !== null && $.inArray( selInt, rows ) !== -1 ) {
					// Selector - integer
					return [ selInt ];
				}
				else if ( sel === null || sel === undefined || sel === '' ) {
					// Selector - none
					return rows;
				}
		
				// Selector - function
				if ( typeof sel === 'function' ) {
					return $.map( rows, function (idx) {
						var row = aoData[ idx ];
						return sel( idx, row._aData, row.nTr ) ? idx : null;
					} );
				}
		
				// Selector - node
				if ( sel.nodeName ) {
					var rowIdx = sel._DT_RowIndex;  // Property added by DT for fast lookup
					var cellIdx = sel._DT_CellIndex;
		
					if ( rowIdx !== undefined ) {
						// Make sure that the row is actually still present in the table
						return aoData[ rowIdx ] && aoData[ rowIdx ].nTr === sel ?
							[ rowIdx ] :
							[];
					}
					else if ( cellIdx ) {
						return aoData[ cellIdx.row ] && aoData[ cellIdx.row ].nTr === sel ?
							[ cellIdx.row ] :
							[];
					}
					else {
						var host = $(sel).closest('*[data-dt-row]');
						return host.length ?
							[ host.data('dt-row') ] :
							[];
					}
				}
		
				// ID selector. Want to always be able to select rows by id, regardless
				// of if the tr element has been created or not, so can't rely upon
				// jQuery here - hence a custom implementation. This does not match
				// Sizzle's fast selector or HTML4 - in HTML5 the ID can be anything,
				// but to select it using a CSS selector engine (like Sizzle or
				// querySelect) it would need to need to be escaped for some characters.
				// DataTables simplifies this for row selectors since you can select
				// only a row. A # indicates an id any anything that follows is the id -
				// unescaped.
				if ( typeof sel === 'string' && sel.charAt(0) === '#' ) {
					// get row index from id
					var rowObj = settings.aIds[ sel.replace( /^#/, '' ) ];
					if ( rowObj !== undefined ) {
						return [ rowObj.idx ];
					}
		
					// need to fall through to jQuery in case there is DOM id that
					// matches
				}
				
				// Get nodes in the order from the `rows` array with null values removed
				var nodes = _removeEmpty(
					_pluck_order( settings.aoData, rows, 'nTr' )
				);
		
				// Selector - jQuery selector string, array of nodes or jQuery object/
				// As jQuery's .filter() allows jQuery objects to be passed in filter,
				// it also allows arrays, so this will cope with all three options
				return $(nodes)
					.filter( sel )
					.map( function () {
						return this._DT_RowIndex;
					} )
					.toArray();
			};
		
			return _selector_run( 'row', selector, run, settings, opts );
		};
		
		
		_api_register( 'rows()', function ( selector, opts ) {
			// argument shifting
			if ( selector === undefined ) {
				selector = '';
			}
			else if ( $.isPlainObject( selector ) ) {
				opts = selector;
				selector = '';
			}
		
			opts = _selector_opts( opts );
		
			var inst = this.iterator( 'table', function ( settings ) {
				return __row_selector( settings, selector, opts );
			}, 1 );
		
			// Want argument shifting here and in __row_selector?
			inst.selector.rows = selector;
			inst.selector.opts = opts;
		
			return inst;
		} );
		
		_api_register( 'rows().nodes()', function () {
			return this.iterator( 'row', function ( settings, row ) {
				return settings.aoData[ row ].nTr || undefined;
			}, 1 );
		} );
		
		_api_register( 'rows().data()', function () {
			return this.iterator( true, 'rows', function ( settings, rows ) {
				return _pluck_order( settings.aoData, rows, '_aData' );
			}, 1 );
		} );
		
		_api_registerPlural( 'rows().cache()', 'row().cache()', function ( type ) {
			return this.iterator( 'row', function ( settings, row ) {
				var r = settings.aoData[ row ];
				return type === 'search' ? r._aFilterData : r._aSortData;
			}, 1 );
		} );
		
		_api_registerPlural( 'rows().invalidate()', 'row().invalidate()', function ( src ) {
			return this.iterator( 'row', function ( settings, row ) {
				_fnInvalidate( settings, row, src );
			} );
		} );
		
		_api_registerPlural( 'rows().indexes()', 'row().index()', function () {
			return this.iterator( 'row', function ( settings, row ) {
				return row;
			}, 1 );
		} );
		
		_api_registerPlural( 'rows().ids()', 'row().id()', function ( hash ) {
			var a = [];
			var context = this.context;
		
			// `iterator` will drop undefined values, but in this case we want them
			for ( var i=0, ien=context.length ; i<ien ; i++ ) {
				for ( var j=0, jen=this[i].length ; j<jen ; j++ ) {
					var id = context[i].rowIdFn( context[i].aoData[ this[i][j] ]._aData );
					a.push( (hash === true ? '#' : '' )+ id );
				}
			}
		
			return new _Api( context, a );
		} );
		
		_api_registerPlural( 'rows().remove()', 'row().remove()', function () {
			var that = this;
		
			this.iterator( 'row', function ( settings, row, thatIdx ) {
				var data = settings.aoData;
				var rowData = data[ row ];
				var i, ien, j, jen;
				var loopRow, loopCells;
		
				data.splice( row, 1 );
		
				// Update the cached indexes
				for ( i=0, ien=data.length ; i<ien ; i++ ) {
					loopRow = data[i];
					loopCells = loopRow.anCells;
		
					// Rows
					if ( loopRow.nTr !== null ) {
						loopRow.nTr._DT_RowIndex = i;
					}
		
					// Cells
					if ( loopCells !== null ) {
						for ( j=0, jen=loopCells.length ; j<jen ; j++ ) {
							loopCells[j]._DT_CellIndex.row = i;
						}
					}
				}
		
				// Delete from the display arrays
				_fnDeleteIndex( settings.aiDisplayMaster, row );
				_fnDeleteIndex( settings.aiDisplay, row );
				_fnDeleteIndex( that[ thatIdx ], row, false ); // maintain local indexes
		
				// For server-side processing tables - subtract the deleted row from the count
				if ( settings._iRecordsDisplay > 0 ) {
					settings._iRecordsDisplay--;
				}
		
				// Check for an 'overflow' they case for displaying the table
				_fnLengthOverflow( settings );
		
				// Remove the row's ID reference if there is one
				var id = settings.rowIdFn( rowData._aData );
				if ( id !== undefined ) {
					delete settings.aIds[ id ];
				}
			} );
		
			this.iterator( 'table', function ( settings ) {
				for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
					settings.aoData[i].idx = i;
				}
			} );
		
			return this;
		} );
		
		
		_api_register( 'rows.add()', function ( rows ) {
			var newRows = this.iterator( 'table', function ( settings ) {
					var row, i, ien;
					var out = [];
		
					for ( i=0, ien=rows.length ; i<ien ; i++ ) {
						row = rows[i];
		
						if ( row.nodeName && row.nodeName.toUpperCase() === 'TR' ) {
							out.push( _fnAddTr( settings, row )[0] );
						}
						else {
							out.push( _fnAddData( settings, row ) );
						}
					}
		
					return out;
				}, 1 );
		
			// Return an Api.rows() extended instance, so rows().nodes() etc can be used
			var modRows = this.rows( -1 );
			modRows.pop();
			$.merge( modRows, newRows );
		
			return modRows;
		} );
		
		
		
		
		
		/**
		 *
		 */
		_api_register( 'row()', function ( selector, opts ) {
			return _selector_first( this.rows( selector, opts ) );
		} );
		
		
		_api_register( 'row().data()', function ( data ) {
			var ctx = this.context;
		
			if ( data === undefined ) {
				// Get
				return ctx.length && this.length ?
					ctx[0].aoData[ this[0] ]._aData :
					undefined;
			}
		
			// Set
			var row = ctx[0].aoData[ this[0] ];
			row._aData = data;
		
			// If the DOM has an id, and the data source is an array
			if ( $.isArray( data ) && row.nTr.id ) {
				_fnSetObjectDataFn( ctx[0].rowId )( data, row.nTr.id );
			}
		
			// Automatically invalidate
			_fnInvalidate( ctx[0], this[0], 'data' );
		
			return this;
		} );
		
		
		_api_register( 'row().node()', function () {
			var ctx = this.context;
		
			return ctx.length && this.length ?
				ctx[0].aoData[ this[0] ].nTr || null :
				null;
		} );
		
		
		_api_register( 'row.add()', function ( row ) {
			// Allow a jQuery object to be passed in - only a single row is added from
			// it though - the first element in the set
			if ( row instanceof $ && row.length ) {
				row = row[0];
			}
		
			var rows = this.iterator( 'table', function ( settings ) {
				if ( row.nodeName && row.nodeName.toUpperCase() === 'TR' ) {
					return _fnAddTr( settings, row )[0];
				}
				return _fnAddData( settings, row );
			} );
		
			// Return an Api.rows() extended instance, with the newly added row selected
			return this.row( rows[0] );
		} );
		
		
		
		var __details_add = function ( ctx, row, data, klass )
		{
			// Convert to array of TR elements
			var rows = [];
			var addRow = function ( r, k ) {
				// Recursion to allow for arrays of jQuery objects
				if ( $.isArray( r ) || r instanceof $ ) {
					for ( var i=0, ien=r.length ; i<ien ; i++ ) {
						addRow( r[i], k );
					}
					return;
				}
		
				// If we get a TR element, then just add it directly - up to the dev
				// to add the correct number of columns etc
				if ( r.nodeName && r.nodeName.toLowerCase() === 'tr' ) {
					rows.push( r );
				}
				else {
					// Otherwise create a row with a wrapper
					var created = $('<tr><td/></tr>').addClass( k );
					$('td', created)
						.addClass( k )
						.html( r )
						[0].colSpan = _fnVisbleColumns( ctx );
		
					rows.push( created[0] );
				}
			};
		
			addRow( data, klass );
		
			if ( row._details ) {
				row._details.detach();
			}
		
			row._details = $(rows);
		
			// If the children were already shown, that state should be retained
			if ( row._detailsShow ) {
				row._details.insertAfter( row.nTr );
			}
		};
		
		
		var __details_remove = function ( api, idx )
		{
			var ctx = api.context;
		
			if ( ctx.length ) {
				var row = ctx[0].aoData[ idx !== undefined ? idx : api[0] ];
		
				if ( row && row._details ) {
					row._details.remove();
		
					row._detailsShow = undefined;
					row._details = undefined;
				}
			}
		};
		
		
		var __details_display = function ( api, show ) {
			var ctx = api.context;
		
			if ( ctx.length && api.length ) {
				var row = ctx[0].aoData[ api[0] ];
		
				if ( row._details ) {
					row._detailsShow = show;
		
					if ( show ) {
						row._details.insertAfter( row.nTr );
					}
					else {
						row._details.detach();
					}
		
					__details_events( ctx[0] );
				}
			}
		};
		
		
		var __details_events = function ( settings )
		{
			var api = new _Api( settings );
			var namespace = '.dt.DT_details';
			var drawEvent = 'draw'+namespace;
			var colvisEvent = 'column-visibility'+namespace;
			var destroyEvent = 'destroy'+namespace;
			var data = settings.aoData;
		
			api.off( drawEvent +' '+ colvisEvent +' '+ destroyEvent );
		
			if ( _pluck( data, '_details' ).length > 0 ) {
				// On each draw, insert the required elements into the document
				api.on( drawEvent, function ( e, ctx ) {
					if ( settings !== ctx ) {
						return;
					}
		
					api.rows( {page:'current'} ).eq(0).each( function (idx) {
						// Internal data grab
						var row = data[ idx ];
		
						if ( row._detailsShow ) {
							row._details.insertAfter( row.nTr );
						}
					} );
				} );
		
				// Column visibility change - update the colspan
				api.on( colvisEvent, function ( e, ctx, idx, vis ) {
					if ( settings !== ctx ) {
						return;
					}
		
					// Update the colspan for the details rows (note, only if it already has
					// a colspan)
					var row, visible = _fnVisbleColumns( ctx );
		
					for ( var i=0, ien=data.length ; i<ien ; i++ ) {
						row = data[i];
		
						if ( row._details ) {
							row._details.children('td[colspan]').attr('colspan', visible );
						}
					}
				} );
		
				// Table destroyed - nuke any child rows
				api.on( destroyEvent, function ( e, ctx ) {
					if ( settings !== ctx ) {
						return;
					}
		
					for ( var i=0, ien=data.length ; i<ien ; i++ ) {
						if ( data[i]._details ) {
							__details_remove( api, i );
						}
					}
				} );
			}
		};
		
		// Strings for the method names to help minification
		var _emp = '';
		var _child_obj = _emp+'row().child';
		var _child_mth = _child_obj+'()';
		
		// data can be:
		//  tr
		//  string
		//  jQuery or array of any of the above
		_api_register( _child_mth, function ( data, klass ) {
			var ctx = this.context;
		
			if ( data === undefined ) {
				// get
				return ctx.length && this.length ?
					ctx[0].aoData[ this[0] ]._details :
					undefined;
			}
			else if ( data === true ) {
				// show
				this.child.show();
			}
			else if ( data === false ) {
				// remove
				__details_remove( this );
			}
			else if ( ctx.length && this.length ) {
				// set
				__details_add( ctx[0], ctx[0].aoData[ this[0] ], data, klass );
			}
		
			return this;
		} );
		
		
		_api_register( [
			_child_obj+'.show()',
			_child_mth+'.show()' // only when `child()` was called with parameters (without
		], function ( show ) {   // it returns an object and this method is not executed)
			__details_display( this, true );
			return this;
		} );
		
		
		_api_register( [
			_child_obj+'.hide()',
			_child_mth+'.hide()' // only when `child()` was called with parameters (without
		], function () {         // it returns an object and this method is not executed)
			__details_display( this, false );
			return this;
		} );
		
		
		_api_register( [
			_child_obj+'.remove()',
			_child_mth+'.remove()' // only when `child()` was called with parameters (without
		], function () {           // it returns an object and this method is not executed)
			__details_remove( this );
			return this;
		} );
		
		
		_api_register( _child_obj+'.isShown()', function () {
			var ctx = this.context;
		
			if ( ctx.length && this.length ) {
				// _detailsShown as false or undefined will fall through to return false
				return ctx[0].aoData[ this[0] ]._detailsShow || false;
			}
			return false;
		} );
		
		
		
		/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
		 * Columns
		 *
		 * {integer}           - column index (>=0 count from left, <0 count from right)
		 * "{integer}:visIdx"  - visible column index (i.e. translate to column index)  (>=0 count from left, <0 count from right)
		 * "{integer}:visible" - alias for {integer}:visIdx  (>=0 count from left, <0 count from right)
		 * "{string}:name"     - column name
		 * "{string}"          - jQuery selector on column header nodes
		 *
		 */
		
		// can be an array of these items, comma separated list, or an array of comma
		// separated lists
		
		var __re_column_selector = /^([^:]+):(name|visIdx|visible)$/;
		
		
		// r1 and r2 are redundant - but it means that the parameters match for the
		// iterator callback in columns().data()
		var __columnData = function ( settings, column, r1, r2, rows ) {
			var a = [];
			for ( var row=0, ien=rows.length ; row<ien ; row++ ) {
				a.push( _fnGetCellData( settings, rows[row], column ) );
			}
			return a;
		};
		
		
		var __column_selector = function ( settings, selector, opts )
		{
			var
				columns = settings.aoColumns,
				names = _pluck( columns, 'sName' ),
				nodes = _pluck( columns, 'nTh' );
		
			var run = function ( s ) {
				var selInt = _intVal( s );
		
				// Selector - all
				if ( s === '' ) {
					return _range( columns.length );
				}
		
				// Selector - index
				if ( selInt !== null ) {
					return [ selInt >= 0 ?
						selInt : // Count from left
						columns.length + selInt // Count from right (+ because its a negative value)
					];
				}
		
				// Selector = function
				if ( typeof s === 'function' ) {
					var rows = _selector_row_indexes( settings, opts );
		
					return $.map( columns, function (col, idx) {
						return s(
								idx,
								__columnData( settings, idx, 0, 0, rows ),
								nodes[ idx ]
							) ? idx : null;
					} );
				}
		
				// jQuery or string selector
				var match = typeof s === 'string' ?
					s.match( __re_column_selector ) :
					'';
		
				if ( match ) {
					switch( match[2] ) {
						case 'visIdx':
						case 'visible':
							var idx = parseInt( match[1], 10 );
							// Visible index given, convert to column index
							if ( idx < 0 ) {
								// Counting from the right
								var visColumns = $.map( columns, function (col,i) {
									return col.bVisible ? i : null;
								} );
								return [ visColumns[ visColumns.length + idx ] ];
							}
							// Counting from the left
							return [ _fnVisibleToColumnIndex( settings, idx ) ];
		
						case 'name':
							// match by name. `names` is column index complete and in order
							return $.map( names, function (name, i) {
								return name === match[1] ? i : null;
							} );
		
						default:
							return [];
					}
				}
		
				// Cell in the table body
				if ( s.nodeName && s._DT_CellIndex ) {
					return [ s._DT_CellIndex.column ];
				}
		
				// jQuery selector on the TH elements for the columns
				var jqResult = $( nodes )
					.filter( s )
					.map( function () {
						return $.inArray( this, nodes ); // `nodes` is column index complete and in order
					} )
					.toArray();
		
				if ( jqResult.length || ! s.nodeName ) {
					return jqResult;
				}
		
				// Otherwise a node which might have a `dt-column` data attribute, or be
				// a child or such an element
				var host = $(s).closest('*[data-dt-column]');
				return host.length ?
					[ host.data('dt-column') ] :
					[];
			};
		
			return _selector_run( 'column', selector, run, settings, opts );
		};
		
		
		var __setColumnVis = function ( settings, column, vis ) {
			var
				cols = settings.aoColumns,
				col  = cols[ column ],
				data = settings.aoData,
				row, cells, i, ien, tr;
		
			// Get
			if ( vis === undefined ) {
				return col.bVisible;
			}
		
			// Set
			// No change
			if ( col.bVisible === vis ) {
				return;
			}
		
			if ( vis ) {
				// Insert column
				// Need to decide if we should use appendChild or insertBefore
				var insertBefore = $.inArray( true, _pluck(cols, 'bVisible'), column+1 );
		
				for ( i=0, ien=data.length ; i<ien ; i++ ) {
					tr = data[i].nTr;
					cells = data[i].anCells;
		
					if ( tr ) {
						// insertBefore can act like appendChild if 2nd arg is null
						tr.insertBefore( cells[ column ], cells[ insertBefore ] || null );
					}
				}
			}
			else {
				// Remove column
				$( _pluck( settings.aoData, 'anCells', column ) ).detach();
			}
		
			// Common actions
			col.bVisible = vis;
			_fnDrawHead( settings, settings.aoHeader );
			_fnDrawHead( settings, settings.aoFooter );
		
			// Update colspan for no records display. Child rows and extensions will use their own
			// listeners to do this - only need to update the empty table item here
			if ( ! settings.aiDisplay.length ) {
				$(settings.nTBody).find('td[colspan]').attr('colspan', _fnVisbleColumns(settings));
			}
		
			_fnSaveState( settings );
		};
		
		
		_api_register( 'columns()', function ( selector, opts ) {
			// argument shifting
			if ( selector === undefined ) {
				selector = '';
			}
			else if ( $.isPlainObject( selector ) ) {
				opts = selector;
				selector = '';
			}
		
			opts = _selector_opts( opts );
		
			var inst = this.iterator( 'table', function ( settings ) {
				return __column_selector( settings, selector, opts );
			}, 1 );
		
			// Want argument shifting here and in _row_selector?
			inst.selector.cols = selector;
			inst.selector.opts = opts;
		
			return inst;
		} );
		
		_api_registerPlural( 'columns().header()', 'column().header()', function ( selector, opts ) {
			return this.iterator( 'column', function ( settings, column ) {
				return settings.aoColumns[column].nTh;
			}, 1 );
		} );
		
		_api_registerPlural( 'columns().footer()', 'column().footer()', function ( selector, opts ) {
			return this.iterator( 'column', function ( settings, column ) {
				return settings.aoColumns[column].nTf;
			}, 1 );
		} );
		
		_api_registerPlural( 'columns().data()', 'column().data()', function () {
			return this.iterator( 'column-rows', __columnData, 1 );
		} );
		
		_api_registerPlural( 'columns().dataSrc()', 'column().dataSrc()', function () {
			return this.iterator( 'column', function ( settings, column ) {
				return settings.aoColumns[column].mData;
			}, 1 );
		} );
		
		_api_registerPlural( 'columns().cache()', 'column().cache()', function ( type ) {
			return this.iterator( 'column-rows', function ( settings, column, i, j, rows ) {
				return _pluck_order( settings.aoData, rows,
					type === 'search' ? '_aFilterData' : '_aSortData', column
				);
			}, 1 );
		} );
		
		_api_registerPlural( 'columns().nodes()', 'column().nodes()', function () {
			return this.iterator( 'column-rows', function ( settings, column, i, j, rows ) {
				return _pluck_order( settings.aoData, rows, 'anCells', column ) ;
			}, 1 );
		} );
		
		_api_registerPlural( 'columns().visible()', 'column().visible()', function ( vis, calc ) {
			var ret = this.iterator( 'column', function ( settings, column ) {
				if ( vis === undefined ) {
					return settings.aoColumns[ column ].bVisible;
				} // else
				__setColumnVis( settings, column, vis );
			} );
		
			// Group the column visibility changes
			if ( vis !== undefined ) {
				// Second loop once the first is done for events
				this.iterator( 'column', function ( settings, column ) {
					_fnCallbackFire( settings, null, 'column-visibility', [settings, column, vis, calc] );
				} );
		
				if ( calc === undefined || calc ) {
					this.columns.adjust();
				}
			}
		
			return ret;
		} );
		
		_api_registerPlural( 'columns().indexes()', 'column().index()', function ( type ) {
			return this.iterator( 'column', function ( settings, column ) {
				return type === 'visible' ?
					_fnColumnIndexToVisible( settings, column ) :
					column;
			}, 1 );
		} );
		
		_api_register( 'columns.adjust()', function () {
			return this.iterator( 'table', function ( settings ) {
				_fnAdjustColumnSizing( settings );
			}, 1 );
		} );
		
		_api_register( 'column.index()', function ( type, idx ) {
			if ( this.context.length !== 0 ) {
				var ctx = this.context[0];
		
				if ( type === 'fromVisible' || type === 'toData' ) {
					return _fnVisibleToColumnIndex( ctx, idx );
				}
				else if ( type === 'fromData' || type === 'toVisible' ) {
					return _fnColumnIndexToVisible( ctx, idx );
				}
			}
		} );
		
		_api_register( 'column()', function ( selector, opts ) {
			return _selector_first( this.columns( selector, opts ) );
		} );
		
		
		
		var __cell_selector = function ( settings, selector, opts )
		{
			var data = settings.aoData;
			var rows = _selector_row_indexes( settings, opts );
			var cells = _removeEmpty( _pluck_order( data, rows, 'anCells' ) );
			var allCells = $( [].concat.apply([], cells) );
			var row;
			var columns = settings.aoColumns.length;
			var a, i, ien, j, o, host;
		
			var run = function ( s ) {
				var fnSelector = typeof s === 'function';
		
				if ( s === null || s === undefined || fnSelector ) {
					// All cells and function selectors
					a = [];
		
					for ( i=0, ien=rows.length ; i<ien ; i++ ) {
						row = rows[i];
		
						for ( j=0 ; j<columns ; j++ ) {
							o = {
								row: row,
								column: j
							};
		
							if ( fnSelector ) {
								// Selector - function
								host = data[ row ];
		
								if ( s( o, _fnGetCellData(settings, row, j), host.anCells ? host.anCells[j] : null ) ) {
									a.push( o );
								}
							}
							else {
								// Selector - all
								a.push( o );
							}
						}
					}
		
					return a;
				}
				
				// Selector - index
				if ( $.isPlainObject( s ) ) {
					// Valid cell index and its in the array of selectable rows
					return s.column !== undefined && s.row !== undefined && $.inArray( s.row, rows ) !== -1 ?
						[s] :
						[];
				}
		
				// Selector - jQuery filtered cells
				var jqResult = allCells
					.filter( s )
					.map( function (i, el) {
						return { // use a new object, in case someone changes the values
							row:    el._DT_CellIndex.row,
							column: el._DT_CellIndex.column
		 				};
					} )
					.toArray();
		
				if ( jqResult.length || ! s.nodeName ) {
					return jqResult;
				}
		
				// Otherwise the selector is a node, and there is one last option - the
				// element might be a child of an element which has dt-row and dt-column
				// data attributes
				host = $(s).closest('*[data-dt-row]');
				return host.length ?
					[ {
						row: host.data('dt-row'),
						column: host.data('dt-column')
					} ] :
					[];
			};
		
			return _selector_run( 'cell', selector, run, settings, opts );
		};
		
		
		
		
		_api_register( 'cells()', function ( rowSelector, columnSelector, opts ) {
			// Argument shifting
			if ( $.isPlainObject( rowSelector ) ) {
				// Indexes
				if ( rowSelector.row === undefined ) {
					// Selector options in first parameter
					opts = rowSelector;
					rowSelector = null;
				}
				else {
					// Cell index objects in first parameter
					opts = columnSelector;
					columnSelector = null;
				}
			}
			if ( $.isPlainObject( columnSelector ) ) {
				opts = columnSelector;
				columnSelector = null;
			}
		
			// Cell selector
			if ( columnSelector === null || columnSelector === undefined ) {
				return this.iterator( 'table', function ( settings ) {
					return __cell_selector( settings, rowSelector, _selector_opts( opts ) );
				} );
			}
		
			// Row + column selector
			var columns = this.columns( columnSelector );
			var rows = this.rows( rowSelector );
			var a, i, ien, j, jen;
		
			this.iterator( 'table', function ( settings, idx ) {
				a = [];
		
				for ( i=0, ien=rows[idx].length ; i<ien ; i++ ) {
					for ( j=0, jen=columns[idx].length ; j<jen ; j++ ) {
						a.push( {
							row:    rows[idx][i],
							column: columns[idx][j]
						} );
					}
				}
			}, 1 );
		
		    // Now pass through the cell selector for options
		    var cells = this.cells( a, opts );
		
			$.extend( cells.selector, {
				cols: columnSelector,
				rows: rowSelector,
				opts: opts
			} );
		
			return cells;
		} );
		
		
		_api_registerPlural( 'cells().nodes()', 'cell().node()', function () {
			return this.iterator( 'cell', function ( settings, row, column ) {
				var data = settings.aoData[ row ];
		
				return data && data.anCells ?
					data.anCells[ column ] :
					undefined;
			}, 1 );
		} );
		
		
		_api_register( 'cells().data()', function () {
			return this.iterator( 'cell', function ( settings, row, column ) {
				return _fnGetCellData( settings, row, column );
			}, 1 );
		} );
		
		
		_api_registerPlural( 'cells().cache()', 'cell().cache()', function ( type ) {
			type = type === 'search' ? '_aFilterData' : '_aSortData';
		
			return this.iterator( 'cell', function ( settings, row, column ) {
				return settings.aoData[ row ][ type ][ column ];
			}, 1 );
		} );
		
		
		_api_registerPlural( 'cells().render()', 'cell().render()', function ( type ) {
			return this.iterator( 'cell', function ( settings, row, column ) {
				return _fnGetCellData( settings, row, column, type );
			}, 1 );
		} );
		
		
		_api_registerPlural( 'cells().indexes()', 'cell().index()', function () {
			return this.iterator( 'cell', function ( settings, row, column ) {
				return {
					row: row,
					column: column,
					columnVisible: _fnColumnIndexToVisible( settings, column )
				};
			}, 1 );
		} );
		
		
		_api_registerPlural( 'cells().invalidate()', 'cell().invalidate()', function ( src ) {
			return this.iterator( 'cell', function ( settings, row, column ) {
				_fnInvalidate( settings, row, src, column );
			} );
		} );
		
		
		
		_api_register( 'cell()', function ( rowSelector, columnSelector, opts ) {
			return _selector_first( this.cells( rowSelector, columnSelector, opts ) );
		} );
		
		
		_api_register( 'cell().data()', function ( data ) {
			var ctx = this.context;
			var cell = this[0];
		
			if ( data === undefined ) {
				// Get
				return ctx.length && cell.length ?
					_fnGetCellData( ctx[0], cell[0].row, cell[0].column ) :
					undefined;
			}
		
			// Set
			_fnSetCellData( ctx[0], cell[0].row, cell[0].column, data );
			_fnInvalidate( ctx[0], cell[0].row, 'data', cell[0].column );
		
			return this;
		} );
		
		
		
		/**
		 * Get current ordering (sorting) that has been applied to the table.
		 *
		 * @returns {array} 2D array containing the sorting information for the first
		 *   table in the current context. Each element in the parent array represents
		 *   a column being sorted upon (i.e. multi-sorting with two columns would have
		 *   2 inner arrays). The inner arrays may have 2 or 3 elements. The first is
		 *   the column index that the sorting condition applies to, the second is the
		 *   direction of the sort (`desc` or `asc`) and, optionally, the third is the
		 *   index of the sorting order from the `column.sorting` initialisation array.
		 *//**
		 * Set the ordering for the table.
		 *
		 * @param {integer} order Column index to sort upon.
		 * @param {string} direction Direction of the sort to be applied (`asc` or `desc`)
		 * @returns {DataTables.Api} this
		 *//**
		 * Set the ordering for the table.
		 *
		 * @param {array} order 1D array of sorting information to be applied.
		 * @param {array} [...] Optional additional sorting conditions
		 * @returns {DataTables.Api} this
		 *//**
		 * Set the ordering for the table.
		 *
		 * @param {array} order 2D array of sorting information to be applied.
		 * @returns {DataTables.Api} this
		 */
		_api_register( 'order()', function ( order, dir ) {
			var ctx = this.context;
		
			if ( order === undefined ) {
				// get
				return ctx.length !== 0 ?
					ctx[0].aaSorting :
					undefined;
			}
		
			// set
			if ( typeof order === 'number' ) {
				// Simple column / direction passed in
				order = [ [ order, dir ] ];
			}
			else if ( order.length && ! $.isArray( order[0] ) ) {
				// Arguments passed in (list of 1D arrays)
				order = Array.prototype.slice.call( arguments );
			}
			// otherwise a 2D array was passed in
		
			return this.iterator( 'table', function ( settings ) {
				settings.aaSorting = order.slice();
			} );
		} );
		
		
		/**
		 * Attach a sort listener to an element for a given column
		 *
		 * @param {node|jQuery|string} node Identifier for the element(s) to attach the
		 *   listener to. This can take the form of a single DOM node, a jQuery
		 *   collection of nodes or a jQuery selector which will identify the node(s).
		 * @param {integer} column the column that a click on this node will sort on
		 * @param {function} [callback] callback function when sort is run
		 * @returns {DataTables.Api} this
		 */
		_api_register( 'order.listener()', function ( node, column, callback ) {
			return this.iterator( 'table', function ( settings ) {
				_fnSortAttachListener( settings, node, column, callback );
			} );
		} );
		
		
		_api_register( 'order.fixed()', function ( set ) {
			if ( ! set ) {
				var ctx = this.context;
				var fixed = ctx.length ?
					ctx[0].aaSortingFixed :
					undefined;
		
				return $.isArray( fixed ) ?
					{ pre: fixed } :
					fixed;
			}
		
			return this.iterator( 'table', function ( settings ) {
				settings.aaSortingFixed = $.extend( true, {}, set );
			} );
		} );
		
		
		// Order by the selected column(s)
		_api_register( [
			'columns().order()',
			'column().order()'
		], function ( dir ) {
			var that = this;
		
			return this.iterator( 'table', function ( settings, i ) {
				var sort = [];
		
				$.each( that[i], function (j, col) {
					sort.push( [ col, dir ] );
				} );
		
				settings.aaSorting = sort;
			} );
		} );
		
		
		
		_api_register( 'search()', function ( input, regex, smart, caseInsen ) {
			var ctx = this.context;
		
			if ( input === undefined ) {
				// get
				return ctx.length !== 0 ?
					ctx[0].oPreviousSearch.sSearch :
					undefined;
			}
		
			// set
			return this.iterator( 'table', function ( settings ) {
				if ( ! settings.oFeatures.bFilter ) {
					return;
				}
		
				_fnFilterComplete( settings, $.extend( {}, settings.oPreviousSearch, {
					"sSearch": input+"",
					"bRegex":  regex === null ? false : regex,
					"bSmart":  smart === null ? true  : smart,
					"bCaseInsensitive": caseInsen === null ? true : caseInsen
				} ), 1 );
			} );
		} );
		
		
		_api_registerPlural(
			'columns().search()',
			'column().search()',
			function ( input, regex, smart, caseInsen ) {
				return this.iterator( 'column', function ( settings, column ) {
					var preSearch = settings.aoPreSearchCols;
		
					if ( input === undefined ) {
						// get
						return preSearch[ column ].sSearch;
					}
		
					// set
					if ( ! settings.oFeatures.bFilter ) {
						return;
					}
		
					$.extend( preSearch[ column ], {
						"sSearch": input+"",
						"bRegex":  regex === null ? false : regex,
						"bSmart":  smart === null ? true  : smart,
						"bCaseInsensitive": caseInsen === null ? true : caseInsen
					} );
		
					_fnFilterComplete( settings, settings.oPreviousSearch, 1 );
				} );
			}
		);
		
		/*
		 * State API methods
		 */
		
		_api_register( 'state()', function () {
			return this.context.length ?
				this.context[0].oSavedState :
				null;
		} );
		
		
		_api_register( 'state.clear()', function () {
			return this.iterator( 'table', function ( settings ) {
				// Save an empty object
				settings.fnStateSaveCallback.call( settings.oInstance, settings, {} );
			} );
		} );
		
		
		_api_register( 'state.loaded()', function () {
			return this.context.length ?
				this.context[0].oLoadedState :
				null;
		} );
		
		
		_api_register( 'state.save()', function () {
			return this.iterator( 'table', function ( settings ) {
				_fnSaveState( settings );
			} );
		} );
		
		
		
		/**
		 * Provide a common method for plug-ins to check the version of DataTables being
		 * used, in order to ensure compatibility.
		 *
		 *  @param {string} version Version string to check for, in the format "X.Y.Z".
		 *    Note that the formats "X" and "X.Y" are also acceptable.
		 *  @returns {boolean} true if this version of DataTables is greater or equal to
		 *    the required version, or false if this version of DataTales is not
		 *    suitable
		 *  @static
		 *  @dtopt API-Static
		 *
		 *  @example
		 *    alert( $.fn.dataTable.versionCheck( '1.9.0' ) );
		 */
		DataTable.versionCheck = DataTable.fnVersionCheck = function( version )
		{
			var aThis = DataTable.version.split('.');
			var aThat = version.split('.');
			var iThis, iThat;
		
			for ( var i=0, iLen=aThat.length ; i<iLen ; i++ ) {
				iThis = parseInt( aThis[i], 10 ) || 0;
				iThat = parseInt( aThat[i], 10 ) || 0;
		
				// Parts are the same, keep comparing
				if (iThis === iThat) {
					continue;
				}
		
				// Parts are different, return immediately
				return iThis > iThat;
			}
		
			return true;
		};
		
		
		/**
		 * Check if a `<table>` node is a DataTable table already or not.
		 *
		 *  @param {node|jquery|string} table Table node, jQuery object or jQuery
		 *      selector for the table to test. Note that if more than more than one
		 *      table is passed on, only the first will be checked
		 *  @returns {boolean} true the table given is a DataTable, or false otherwise
		 *  @static
		 *  @dtopt API-Static
		 *
		 *  @example
		 *    if ( ! $.fn.DataTable.isDataTable( '#example' ) ) {
		 *      $('#example').dataTable();
		 *    }
		 */
		DataTable.isDataTable = DataTable.fnIsDataTable = function ( table )
		{
			var t = $(table).get(0);
			var is = false;
		
			if ( table instanceof DataTable.Api ) {
				return true;
			}
		
			$.each( DataTable.settings, function (i, o) {
				var head = o.nScrollHead ? $('table', o.nScrollHead)[0] : null;
				var foot = o.nScrollFoot ? $('table', o.nScrollFoot)[0] : null;
		
				if ( o.nTable === t || head === t || foot === t ) {
					is = true;
				}
			} );
		
			return is;
		};
		
		
		/**
		 * Get all DataTable tables that have been initialised - optionally you can
		 * select to get only currently visible tables.
		 *
		 *  @param {boolean} [visible=false] Flag to indicate if you want all (default)
		 *    or visible tables only.
		 *  @returns {array} Array of `table` nodes (not DataTable instances) which are
		 *    DataTables
		 *  @static
		 *  @dtopt API-Static
		 *
		 *  @example
		 *    $.each( $.fn.dataTable.tables(true), function () {
		 *      $(table).DataTable().columns.adjust();
		 *    } );
		 */
		DataTable.tables = DataTable.fnTables = function ( visible )
		{
			var api = false;
		
			if ( $.isPlainObject( visible ) ) {
				api = visible.api;
				visible = visible.visible;
			}
		
			var a = $.map( DataTable.settings, function (o) {
				if ( !visible || (visible && $(o.nTable).is(':visible')) ) {
					return o.nTable;
				}
			} );
		
			return api ?
				new _Api( a ) :
				a;
		};
		
		
		/**
		 * Convert from camel case parameters to Hungarian notation. This is made public
		 * for the extensions to provide the same ability as DataTables core to accept
		 * either the 1.9 style Hungarian notation, or the 1.10+ style camelCase
		 * parameters.
		 *
		 *  @param {object} src The model object which holds all parameters that can be
		 *    mapped.
		 *  @param {object} user The object to convert from camel case to Hungarian.
		 *  @param {boolean} force When set to `true`, properties which already have a
		 *    Hungarian value in the `user` object will be overwritten. Otherwise they
		 *    won't be.
		 */
		DataTable.camelToHungarian = _fnCamelToHungarian;
		
		
		
		/**
		 *
		 */
		_api_register( '$()', function ( selector, opts ) {
			var
				rows   = this.rows( opts ).nodes(), // Get all rows
				jqRows = $(rows);
		
			return $( [].concat(
				jqRows.filter( selector ).toArray(),
				jqRows.find( selector ).toArray()
			) );
		} );
		
		
		// jQuery functions to operate on the tables
		$.each( [ 'on', 'one', 'off' ], function (i, key) {
			_api_register( key+'()', function ( /* event, handler */ ) {
				var args = Array.prototype.slice.call(arguments);
		
				// Add the `dt` namespace automatically if it isn't already present
				args[0] = $.map( args[0].split( /\s/ ), function ( e ) {
					return ! e.match(/\.dt\b/) ?
						e+'.dt' :
						e;
					} ).join( ' ' );
		
				var inst = $( this.tables().nodes() );
				inst[key].apply( inst, args );
				return this;
			} );
		} );
		
		
		_api_register( 'clear()', function () {
			return this.iterator( 'table', function ( settings ) {
				_fnClearTable( settings );
			} );
		} );
		
		
		_api_register( 'settings()', function () {
			return new _Api( this.context, this.context );
		} );
		
		
		_api_register( 'init()', function () {
			var ctx = this.context;
			return ctx.length ? ctx[0].oInit : null;
		} );
		
		
		_api_register( 'data()', function () {
			return this.iterator( 'table', function ( settings ) {
				return _pluck( settings.aoData, '_aData' );
			} ).flatten();
		} );
		
		
		_api_register( 'destroy()', function ( remove ) {
			remove = remove || false;
		
			return this.iterator( 'table', function ( settings ) {
				var orig      = settings.nTableWrapper.parentNode;
				var classes   = settings.oClasses;
				var table     = settings.nTable;
				var tbody     = settings.nTBody;
				var thead     = settings.nTHead;
				var tfoot     = settings.nTFoot;
				var jqTable   = $(table);
				var jqTbody   = $(tbody);
				var jqWrapper = $(settings.nTableWrapper);
				var rows      = $.map( settings.aoData, function (r) { return r.nTr; } );
				var i, ien;
		
				// Flag to note that the table is currently being destroyed - no action
				// should be taken
				settings.bDestroying = true;
		
				// Fire off the destroy callbacks for plug-ins etc
				_fnCallbackFire( settings, "aoDestroyCallback", "destroy", [settings] );
		
				// If not being removed from the document, make all columns visible
				if ( ! remove ) {
					new _Api( settings ).columns().visible( true );
				}
		
				// Blitz all `DT` namespaced events (these are internal events, the
				// lowercase, `dt` events are user subscribed and they are responsible
				// for removing them
				jqWrapper.off('.DT').find(':not(tbody *)').off('.DT');
				$(window).off('.DT-'+settings.sInstance);
		
				// When scrolling we had to break the table up - restore it
				if ( table != thead.parentNode ) {
					jqTable.children('thead').detach();
					jqTable.append( thead );
				}
		
				if ( tfoot && table != tfoot.parentNode ) {
					jqTable.children('tfoot').detach();
					jqTable.append( tfoot );
				}
		
				settings.aaSorting = [];
				settings.aaSortingFixed = [];
				_fnSortingClasses( settings );
		
				$( rows ).removeClass( settings.asStripeClasses.join(' ') );
		
				$('th, td', thead).removeClass( classes.sSortable+' '+
					classes.sSortableAsc+' '+classes.sSortableDesc+' '+classes.sSortableNone
				);
		
				// Add the TR elements back into the table in their original order
				jqTbody.children().detach();
				jqTbody.append( rows );
		
				// Remove the DataTables generated nodes, events and classes
				var removedMethod = remove ? 'remove' : 'detach';
				jqTable[ removedMethod ]();
				jqWrapper[ removedMethod ]();
		
				// If we need to reattach the table to the document
				if ( ! remove && orig ) {
					// insertBefore acts like appendChild if !arg[1]
					orig.insertBefore( table, settings.nTableReinsertBefore );
		
					// Restore the width of the original table - was read from the style property,
					// so we can restore directly to that
					jqTable
						.css( 'width', settings.sDestroyWidth )
						.removeClass( classes.sTable );
		
					// If the were originally stripe classes - then we add them back here.
					// Note this is not fool proof (for example if not all rows had stripe
					// classes - but it's a good effort without getting carried away
					ien = settings.asDestroyStripes.length;
		
					if ( ien ) {
						jqTbody.children().each( function (i) {
							$(this).addClass( settings.asDestroyStripes[i % ien] );
						} );
					}
				}
		
				/* Remove the settings object from the settings array */
				var idx = $.inArray( settings, DataTable.settings );
				if ( idx !== -1 ) {
					DataTable.settings.splice( idx, 1 );
				}
			} );
		} );
		
		
		// Add the `every()` method for rows, columns and cells in a compact form
		$.each( [ 'column', 'row', 'cell' ], function ( i, type ) {
			_api_register( type+'s().every()', function ( fn ) {
				var opts = this.selector.opts;
				var api = this;
		
				return this.iterator( type, function ( settings, arg1, arg2, arg3, arg4 ) {
					// Rows and columns:
					//  arg1 - index
					//  arg2 - table counter
					//  arg3 - loop counter
					//  arg4 - undefined
					// Cells:
					//  arg1 - row index
					//  arg2 - column index
					//  arg3 - table counter
					//  arg4 - loop counter
					fn.call(
						api[ type ](
							arg1,
							type==='cell' ? arg2 : opts,
							type==='cell' ? opts : undefined
						),
						arg1, arg2, arg3, arg4
					);
				} );
			} );
		} );
		
		
		// i18n method for extensions to be able to use the language object from the
		// DataTable
		_api_register( 'i18n()', function ( token, def, plural ) {
			var ctx = this.context[0];
			var resolved = _fnGetObjectDataFn( token )( ctx.oLanguage );
		
			if ( resolved === undefined ) {
				resolved = def;
			}
		
			if ( plural !== undefined && $.isPlainObject( resolved ) ) {
				resolved = resolved[ plural ] !== undefined ?
					resolved[ plural ] :
					resolved._;
			}
		
			return resolved.replace( '%d', plural ); // nb: plural might be undefined,
		} );
	
		/**
		 * Version string for plug-ins to check compatibility. Allowed format is
		 * `a.b.c-d` where: a:int, b:int, c:int, d:string(dev|beta|alpha). `d` is used
		 * only for non-release builds. See http://semver.org/ for more information.
		 *  @member
		 *  @type string
		 *  @default Version number
		 */
		DataTable.version = "1.10.19";
	
		/**
		 * Private data store, containing all of the settings objects that are
		 * created for the tables on a given page.
		 *
		 * Note that the `DataTable.settings` object is aliased to
		 * `jQuery.fn.dataTableExt` through which it may be accessed and
		 * manipulated, or `jQuery.fn.dataTable.settings`.
		 *  @member
		 *  @type array
		 *  @default []
		 *  @private
		 */
		DataTable.settings = [];
	
		/**
		 * Object models container, for the various models that DataTables has
		 * available to it. These models define the objects that are used to hold
		 * the active state and configuration of the table.
		 *  @namespace
		 */
		DataTable.models = {};
		
		
		
		/**
		 * Template object for the way in which DataTables holds information about
		 * search information for the global filter and individual column filters.
		 *  @namespace
		 */
		DataTable.models.oSearch = {
			/**
			 * Flag to indicate if the filtering should be case insensitive or not
			 *  @type boolean
			 *  @default true
			 */
			"bCaseInsensitive": true,
		
			/**
			 * Applied search term
			 *  @type string
			 *  @default <i>Empty string</i>
			 */
			"sSearch": "",
		
			/**
			 * Flag to indicate if the search term should be interpreted as a
			 * regular expression (true) or not (false) and therefore and special
			 * regex characters escaped.
			 *  @type boolean
			 *  @default false
			 */
			"bRegex": false,
		
			/**
			 * Flag to indicate if DataTables is to use its smart filtering or not.
			 *  @type boolean
			 *  @default true
			 */
			"bSmart": true
		};
		
		
		
		
		/**
		 * Template object for the way in which DataTables holds information about
		 * each individual row. This is the object format used for the settings
		 * aoData array.
		 *  @namespace
		 */
		DataTable.models.oRow = {
			/**
			 * TR element for the row
			 *  @type node
			 *  @default null
			 */
			"nTr": null,
		
			/**
			 * Array of TD elements for each row. This is null until the row has been
			 * created.
			 *  @type array nodes
			 *  @default []
			 */
			"anCells": null,
		
			/**
			 * Data object from the original data source for the row. This is either
			 * an array if using the traditional form of DataTables, or an object if
			 * using mData options. The exact type will depend on the passed in
			 * data from the data source, or will be an array if using DOM a data
			 * source.
			 *  @type array|object
			 *  @default []
			 */
			"_aData": [],
		
			/**
			 * Sorting data cache - this array is ostensibly the same length as the
			 * number of columns (although each index is generated only as it is
			 * needed), and holds the data that is used for sorting each column in the
			 * row. We do this cache generation at the start of the sort in order that
			 * the formatting of the sort data need be done only once for each cell
			 * per sort. This array should not be read from or written to by anything
			 * other than the master sorting methods.
			 *  @type array
			 *  @default null
			 *  @private
			 */
			"_aSortData": null,
		
			/**
			 * Per cell filtering data cache. As per the sort data cache, used to
			 * increase the performance of the filtering in DataTables
			 *  @type array
			 *  @default null
			 *  @private
			 */
			"_aFilterData": null,
		
			/**
			 * Filtering data cache. This is the same as the cell filtering cache, but
			 * in this case a string rather than an array. This is easily computed with
			 * a join on `_aFilterData`, but is provided as a cache so the join isn't
			 * needed on every search (memory traded for performance)
			 *  @type array
			 *  @default null
			 *  @private
			 */
			"_sFilterRow": null,
		
			/**
			 * Cache of the class name that DataTables has applied to the row, so we
			 * can quickly look at this variable rather than needing to do a DOM check
			 * on className for the nTr property.
			 *  @type string
			 *  @default <i>Empty string</i>
			 *  @private
			 */
			"_sRowStripe": "",
		
			/**
			 * Denote if the original data source was from the DOM, or the data source
			 * object. This is used for invalidating data, so DataTables can
			 * automatically read data from the original source, unless uninstructed
			 * otherwise.
			 *  @type string
			 *  @default null
			 *  @private
			 */
			"src": null,
		
			/**
			 * Index in the aoData array. This saves an indexOf lookup when we have the
			 * object, but want to know the index
			 *  @type integer
			 *  @default -1
			 *  @private
			 */
			"idx": -1
		};
		
		
		/**
		 * Template object for the column information object in DataTables. This object
		 * is held in the settings aoColumns array and contains all the information that
		 * DataTables needs about each individual column.
		 *
		 * Note that this object is related to {@link DataTable.defaults.column}
		 * but this one is the internal data store for DataTables's cache of columns.
		 * It should NOT be manipulated outside of DataTables. Any configuration should
		 * be done through the initialisation options.
		 *  @namespace
		 */
		DataTable.models.oColumn = {
			/**
			 * Column index. This could be worked out on-the-fly with $.inArray, but it
			 * is faster to just hold it as a variable
			 *  @type integer
			 *  @default null
			 */
			"idx": null,
		
			/**
			 * A list of the columns that sorting should occur on when this column
			 * is sorted. That this property is an array allows multi-column sorting
			 * to be defined for a column (for example first name / last name columns
			 * would benefit from this). The values are integers pointing to the
			 * columns to be sorted on (typically it will be a single integer pointing
			 * at itself, but that doesn't need to be the case).
			 *  @type array
			 */
			"aDataSort": null,
		
			/**
			 * Define the sorting directions that are applied to the column, in sequence
			 * as the column is repeatedly sorted upon - i.e. the first value is used
			 * as the sorting direction when the column if first sorted (clicked on).
			 * Sort it again (click again) and it will move on to the next index.
			 * Repeat until loop.
			 *  @type array
			 */
			"asSorting": null,
		
			/**
			 * Flag to indicate if the column is searchable, and thus should be included
			 * in the filtering or not.
			 *  @type boolean
			 */
			"bSearchable": null,
		
			/**
			 * Flag to indicate if the column is sortable or not.
			 *  @type boolean
			 */
			"bSortable": null,
		
			/**
			 * Flag to indicate if the column is currently visible in the table or not
			 *  @type boolean
			 */
			"bVisible": null,
		
			/**
			 * Store for manual type assignment using the `column.type` option. This
			 * is held in store so we can manipulate the column's `sType` property.
			 *  @type string
			 *  @default null
			 *  @private
			 */
			"_sManualType": null,
		
			/**
			 * Flag to indicate if HTML5 data attributes should be used as the data
			 * source for filtering or sorting. True is either are.
			 *  @type boolean
			 *  @default false
			 *  @private
			 */
			"_bAttrSrc": false,
		
			/**
			 * Developer definable function that is called whenever a cell is created (Ajax source,
			 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
			 * allowing you to modify the DOM element (add background colour for example) when the
			 * element is available.
			 *  @type function
			 *  @param {element} nTd The TD node that has been created
			 *  @param {*} sData The Data for the cell
			 *  @param {array|object} oData The data for the whole row
			 *  @param {int} iRow The row index for the aoData data store
			 *  @default null
			 */
			"fnCreatedCell": null,
		
			/**
			 * Function to get data from a cell in a column. You should <b>never</b>
			 * access data directly through _aData internally in DataTables - always use
			 * the method attached to this property. It allows mData to function as
			 * required. This function is automatically assigned by the column
			 * initialisation method
			 *  @type function
			 *  @param {array|object} oData The data array/object for the array
			 *    (i.e. aoData[]._aData)
			 *  @param {string} sSpecific The specific data type you want to get -
			 *    'display', 'type' 'filter' 'sort'
			 *  @returns {*} The data for the cell from the given row's data
			 *  @default null
			 */
			"fnGetData": null,
		
			/**
			 * Function to set data for a cell in the column. You should <b>never</b>
			 * set the data directly to _aData internally in DataTables - always use
			 * this method. It allows mData to function as required. This function
			 * is automatically assigned by the column initialisation method
			 *  @type function
			 *  @param {array|object} oData The data array/object for the array
			 *    (i.e. aoData[]._aData)
			 *  @param {*} sValue Value to set
			 *  @default null
			 */
			"fnSetData": null,
		
			/**
			 * Property to read the value for the cells in the column from the data
			 * source array / object. If null, then the default content is used, if a
			 * function is given then the return from the function is used.
			 *  @type function|int|string|null
			 *  @default null
			 */
			"mData": null,
		
			/**
			 * Partner property to mData which is used (only when defined) to get
			 * the data - i.e. it is basically the same as mData, but without the
			 * 'set' option, and also the data fed to it is the result from mData.
			 * This is the rendering method to match the data method of mData.
			 *  @type function|int|string|null
			 *  @default null
			 */
			"mRender": null,
		
			/**
			 * Unique header TH/TD element for this column - this is what the sorting
			 * listener is attached to (if sorting is enabled.)
			 *  @type node
			 *  @default null
			 */
			"nTh": null,
		
			/**
			 * Unique footer TH/TD element for this column (if there is one). Not used
			 * in DataTables as such, but can be used for plug-ins to reference the
			 * footer for each column.
			 *  @type node
			 *  @default null
			 */
			"nTf": null,
		
			/**
			 * The class to apply to all TD elements in the table's TBODY for the column
			 *  @type string
			 *  @default null
			 */
			"sClass": null,
		
			/**
			 * When DataTables calculates the column widths to assign to each column,
			 * it finds the longest string in each column and then constructs a
			 * temporary table and reads the widths from that. The problem with this
			 * is that "mmm" is much wider then "iiii", but the latter is a longer
			 * string - thus the calculation can go wrong (doing it properly and putting
			 * it into an DOM object and measuring that is horribly(!) slow). Thus as
			 * a "work around" we provide this option. It will append its value to the
			 * text that is found to be the longest string for the column - i.e. padding.
			 *  @type string
			 */
			"sContentPadding": null,
		
			/**
			 * Allows a default value to be given for a column's data, and will be used
			 * whenever a null data source is encountered (this can be because mData
			 * is set to null, or because the data source itself is null).
			 *  @type string
			 *  @default null
			 */
			"sDefaultContent": null,
		
			/**
			 * Name for the column, allowing reference to the column by name as well as
			 * by index (needs a lookup to work by name).
			 *  @type string
			 */
			"sName": null,
		
			/**
			 * Custom sorting data type - defines which of the available plug-ins in
			 * afnSortData the custom sorting will use - if any is defined.
			 *  @type string
			 *  @default std
			 */
			"sSortDataType": 'std',
		
			/**
			 * Class to be applied to the header element when sorting on this column
			 *  @type string
			 *  @default null
			 */
			"sSortingClass": null,
		
			/**
			 * Class to be applied to the header element when sorting on this column -
			 * when jQuery UI theming is used.
			 *  @type string
			 *  @default null
			 */
			"sSortingClassJUI": null,
		
			/**
			 * Title of the column - what is seen in the TH element (nTh).
			 *  @type string
			 */
			"sTitle": null,
		
			/**
			 * Column sorting and filtering type
			 *  @type string
			 *  @default null
			 */
			"sType": null,
		
			/**
			 * Width of the column
			 *  @type string
			 *  @default null
			 */
			"sWidth": null,
		
			/**
			 * Width of the column when it was first "encountered"
			 *  @type string
			 *  @default null
			 */
			"sWidthOrig": null
		};
		
		
		/*
		 * Developer note: The properties of the object below are given in Hungarian
		 * notation, that was used as the interface for DataTables prior to v1.10, however
		 * from v1.10 onwards the primary interface is camel case. In order to avoid
		 * breaking backwards compatibility utterly with this change, the Hungarian
		 * version is still, internally the primary interface, but is is not documented
		 * - hence the @name tags in each doc comment. This allows a Javascript function
		 * to create a map from Hungarian notation to camel case (going the other direction
		 * would require each property to be listed, which would at around 3K to the size
		 * of DataTables, while this method is about a 0.5K hit.
		 *
		 * Ultimately this does pave the way for Hungarian notation to be dropped
		 * completely, but that is a massive amount of work and will break current
		 * installs (therefore is on-hold until v2).
		 */
		
		/**
		 * Initialisation options that can be given to DataTables at initialisation
		 * time.
		 *  @namespace
		 */
		DataTable.defaults = {
			/**
			 * An array of data to use for the table, passed in at initialisation which
			 * will be used in preference to any data which is already in the DOM. This is
			 * particularly useful for constructing tables purely in Javascript, for
			 * example with a custom Ajax call.
			 *  @type array
			 *  @default null
			 *
			 *  @dtopt Option
			 *  @name DataTable.defaults.data
			 *
			 *  @example
			 *    // Using a 2D array data source
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "data": [
			 *          ['Trident', 'Internet Explorer 4.0', 'Win 95+', 4, 'X'],
			 *          ['Trident', 'Internet Explorer 5.0', 'Win 95+', 5, 'C'],
			 *        ],
			 *        "columns": [
			 *          { "title": "Engine" },
			 *          { "title": "Browser" },
			 *          { "title": "Platform" },
			 *          { "title": "Version" },
			 *          { "title": "Grade" }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using an array of objects as a data source (`data`)
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "data": [
			 *          {
			 *            "engine":   "Trident",
			 *            "browser":  "Internet Explorer 4.0",
			 *            "platform": "Win 95+",
			 *            "version":  4,
			 *            "grade":    "X"
			 *          },
			 *          {
			 *            "engine":   "Trident",
			 *            "browser":  "Internet Explorer 5.0",
			 *            "platform": "Win 95+",
			 *            "version":  5,
			 *            "grade":    "C"
			 *          }
			 *        ],
			 *        "columns": [
			 *          { "title": "Engine",   "data": "engine" },
			 *          { "title": "Browser",  "data": "browser" },
			 *          { "title": "Platform", "data": "platform" },
			 *          { "title": "Version",  "data": "version" },
			 *          { "title": "Grade",    "data": "grade" }
			 *        ]
			 *      } );
			 *    } );
			 */
			"aaData": null,
		
		
			/**
			 * If ordering is enabled, then DataTables will perform a first pass sort on
			 * initialisation. You can define which column(s) the sort is performed
			 * upon, and the sorting direction, with this variable. The `sorting` array
			 * should contain an array for each column to be sorted initially containing
			 * the column's index and a direction string ('asc' or 'desc').
			 *  @type array
			 *  @default [[0,'asc']]
			 *
			 *  @dtopt Option
			 *  @name DataTable.defaults.order
			 *
			 *  @example
			 *    // Sort by 3rd column first, and then 4th column
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "order": [[2,'asc'], [3,'desc']]
			 *      } );
			 *    } );
			 *
			 *    // No initial sorting
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "order": []
			 *      } );
			 *    } );
			 */
			"aaSorting": [[0,'asc']],
		
		
			/**
			 * This parameter is basically identical to the `sorting` parameter, but
			 * cannot be overridden by user interaction with the table. What this means
			 * is that you could have a column (visible or hidden) which the sorting
			 * will always be forced on first - any sorting after that (from the user)
			 * will then be performed as required. This can be useful for grouping rows
			 * together.
			 *  @type array
			 *  @default null
			 *
			 *  @dtopt Option
			 *  @name DataTable.defaults.orderFixed
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "orderFixed": [[0,'asc']]
			 *      } );
			 *    } )
			 */
			"aaSortingFixed": [],
		
		
			/**
			 * DataTables can be instructed to load data to display in the table from a
			 * Ajax source. This option defines how that Ajax call is made and where to.
			 *
			 * The `ajax` property has three different modes of operation, depending on
			 * how it is defined. These are:
			 *
			 * * `string` - Set the URL from where the data should be loaded from.
			 * * `object` - Define properties for `jQuery.ajax`.
			 * * `function` - Custom data get function
			 *
			 * `string`
			 * --------
			 *
			 * As a string, the `ajax` property simply defines the URL from which
			 * DataTables will load data.
			 *
			 * `object`
			 * --------
			 *
			 * As an object, the parameters in the object are passed to
			 * [jQuery.ajax](http://api.jquery.com/jQuery.ajax/) allowing fine control
			 * of the Ajax request. DataTables has a number of default parameters which
			 * you can override using this option. Please refer to the jQuery
			 * documentation for a full description of the options available, although
			 * the following parameters provide additional options in DataTables or
			 * require special consideration:
			 *
			 * * `data` - As with jQuery, `data` can be provided as an object, but it
			 *   can also be used as a function to manipulate the data DataTables sends
			 *   to the server. The function takes a single parameter, an object of
			 *   parameters with the values that DataTables has readied for sending. An
			 *   object may be returned which will be merged into the DataTables
			 *   defaults, or you can add the items to the object that was passed in and
			 *   not return anything from the function. This supersedes `fnServerParams`
			 *   from DataTables 1.9-.
			 *
			 * * `dataSrc` - By default DataTables will look for the property `data` (or
			 *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
			 *   from an Ajax source or for server-side processing - this parameter
			 *   allows that property to be changed. You can use Javascript dotted
			 *   object notation to get a data source for multiple levels of nesting, or
			 *   it my be used as a function. As a function it takes a single parameter,
			 *   the JSON returned from the server, which can be manipulated as
			 *   required, with the returned value being that used by DataTables as the
			 *   data source for the table. This supersedes `sAjaxDataProp` from
			 *   DataTables 1.9-.
			 *
			 * * `success` - Should not be overridden it is used internally in
			 *   DataTables. To manipulate / transform the data returned by the server
			 *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
			 *
			 * `function`
			 * ----------
			 *
			 * As a function, making the Ajax call is left up to yourself allowing
			 * complete control of the Ajax request. Indeed, if desired, a method other
			 * than Ajax could be used to obtain the required data, such as Web storage
			 * or an AIR database.
			 *
			 * The function is given four parameters and no return is required. The
			 * parameters are:
			 *
			 * 1. _object_ - Data to send to the server
			 * 2. _function_ - Callback function that must be executed when the required
			 *    data has been obtained. That data should be passed into the callback
			 *    as the only parameter
			 * 3. _object_ - DataTables settings object for the table
			 *
			 * Note that this supersedes `fnServerData` from DataTables 1.9-.
			 *
			 *  @type string|object|function
			 *  @default null
			 *
			 *  @dtopt Option
			 *  @name DataTable.defaults.ajax
			 *  @since 1.10.0
			 *
			 * @example
			 *   // Get JSON data from a file via Ajax.
			 *   // Note DataTables expects data in the form `{ data: [ ...data... ] }` by default).
			 *   $('#example').dataTable( {
			 *     "ajax": "data.json"
			 *   } );
			 *
			 * @example
			 *   // Get JSON data from a file via Ajax, using `dataSrc` to change
			 *   // `data` to `tableData` (i.e. `{ tableData: [ ...data... ] }`)
			 *   $('#example').dataTable( {
			 *     "ajax": {
			 *       "url": "data.json",
			 *       "dataSrc": "tableData"
			 *     }
			 *   } );
			 *
			 * @example
			 *   // Get JSON data from a file via Ajax, using `dataSrc` to read data
			 *   // from a plain array rather than an array in an object
			 *   $('#example').dataTable( {
			 *     "ajax": {
			 *       "url": "data.json",
			 *       "dataSrc": ""
			 *     }
			 *   } );
			 *
			 * @example
			 *   // Manipulate the data returned from the server - add a link to data
			 *   // (note this can, should, be done using `render` for the column - this
			 *   // is just a simple example of how the data can be manipulated).
			 *   $('#example').dataTable( {
			 *     "ajax": {
			 *       "url": "data.json",
			 *       "dataSrc": function ( json ) {
			 *         for ( var i=0, ien=json.length ; i<ien ; i++ ) {
			 *           json[i][0] = '<a href="/message/'+json[i][0]+'>View message</a>';
			 *         }
			 *         return json;
			 *       }
			 *     }
			 *   } );
			 *
			 * @example
			 *   // Add data to the request
			 *   $('#example').dataTable( {
			 *     "ajax": {
			 *       "url": "data.json",
			 *       "data": function ( d ) {
			 *         return {
			 *           "extra_search": $('#extra').val()
			 *         };
			 *       }
			 *     }
			 *   } );
			 *
			 * @example
			 *   // Send request as POST
			 *   $('#example').dataTable( {
			 *     "ajax": {
			 *       "url": "data.json",
			 *       "type": "POST"
			 *     }
			 *   } );
			 *
			 * @example
			 *   // Get the data from localStorage (could interface with a form for
			 *   // adding, editing and removing rows).
			 *   $('#example').dataTable( {
			 *     "ajax": function (data, callback, settings) {
			 *       callback(
			 *         JSON.parse( localStorage.getItem('dataTablesData') )
			 *       );
			 *     }
			 *   } );
			 */
			"ajax": null,
		
		
			/**
			 * This parameter allows you to readily specify the entries in the length drop
			 * down menu that DataTables shows when pagination is enabled. It can be
			 * either a 1D array of options which will be used for both the displayed
			 * option and the value, or a 2D array which will use the array in the first
			 * position as the value, and the array in the second position as the
			 * displayed options (useful for language strings such as 'All').
			 *
			 * Note that the `pageLength` property will be automatically set to the
			 * first value given in this array, unless `pageLength` is also provided.
			 *  @type array
			 *  @default [ 10, 25, 50, 100 ]
			 *
			 *  @dtopt Option
			 *  @name DataTable.defaults.lengthMenu
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]]
			 *      } );
			 *    } );
			 */
			"aLengthMenu": [ 10, 25, 50, 100 ],
		
		
			/**
			 * The `columns` option in the initialisation parameter allows you to define
			 * details about the way individual columns behave. For a full list of
			 * column options that can be set, please see
			 * {@link DataTable.defaults.column}. Note that if you use `columns` to
			 * define your columns, you must have an entry in the array for every single
			 * column that you have in your table (these can be null if you don't which
			 * to specify any options).
			 *  @member
			 *
			 *  @name DataTable.defaults.column
			 */
			"aoColumns": null,
		
			/**
			 * Very similar to `columns`, `columnDefs` allows you to target a specific
			 * column, multiple columns, or all columns, using the `targets` property of
			 * each object in the array. This allows great flexibility when creating
			 * tables, as the `columnDefs` arrays can be of any length, targeting the
			 * columns you specifically want. `columnDefs` may use any of the column
			 * options available: {@link DataTable.defaults.column}, but it _must_
			 * have `targets` defined in each object in the array. Values in the `targets`
			 * array may be:
			 *   <ul>
			 *     <li>a string - class name will be matched on the TH for the column</li>
			 *     <li>0 or a positive integer - column index counting from the left</li>
			 *     <li>a negative integer - column index counting from the right</li>
			 *     <li>the string "_all" - all columns (i.e. assign a default)</li>
			 *   </ul>
			 *  @member
			 *
			 *  @name DataTable.defaults.columnDefs
			 */
			"aoColumnDefs": null,
		
		
			/**
			 * Basically the same as `search`, this parameter defines the individual column
			 * filtering state at initialisation time. The array must be of the same size
			 * as the number of columns, and each element be an object with the parameters
			 * `search` and `escapeRegex` (the latter is optional). 'null' is also
			 * accepted and the default will be used.
			 *  @type array
			 *  @default []
			 *
			 *  @dtopt Option
			 *  @name DataTable.defaults.searchCols
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "searchCols": [
			 *          null,
			 *          { "search": "My filter" },
			 *          null,
			 *          { "search": "^[0-9]", "escapeRegex": false }
			 *        ]
			 *      } );
			 *    } )
			 */
			"aoSearchCols": [],
		
		
			/**
			 * An array of CSS classes that should be applied to displayed rows. This
			 * array may be of any length, and DataTables will apply each class
			 * sequentially, looping when required.
			 *  @type array
			 *  @default null <i>Will take the values determined by the `oClasses.stripe*`
			 *    options</i>
			 *
			 *  @dtopt Option
			 *  @name DataTable.defaults.stripeClasses
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "stripeClasses": [ 'strip1', 'strip2', 'strip3' ]
			 *      } );
			 *    } )
			 */
			"asStripeClasses": null,
		
		
			/**
			 * Enable or disable automatic column width calculation. This can be disabled
			 * as an optimisation (it takes some time to calculate the widths) if the
			 * tables widths are passed in using `columns`.
			 *  @type boolean
			 *  @default true
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.autoWidth
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "autoWidth": false
			 *      } );
			 *    } );
			 */
			"bAutoWidth": true,
		
		
			/**
			 * Deferred rendering can provide DataTables with a huge speed boost when you
			 * are using an Ajax or JS data source for the table. This option, when set to
			 * true, will cause DataTables to defer the creation of the table elements for
			 * each row until they are needed for a draw - saving a significant amount of
			 * time.
			 *  @type boolean
			 *  @default false
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.deferRender
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "ajax": "sources/arrays.txt",
			 *        "deferRender": true
			 *      } );
			 *    } );
			 */
			"bDeferRender": false,
		
		
			/**
			 * Replace a DataTable which matches the given selector and replace it with
			 * one which has the properties of the new initialisation object passed. If no
			 * table matches the selector, then the new DataTable will be constructed as
			 * per normal.
			 *  @type boolean
			 *  @default false
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.destroy
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "srollY": "200px",
			 *        "paginate": false
			 *      } );
			 *
			 *      // Some time later....
			 *      $('#example').dataTable( {
			 *        "filter": false,
			 *        "destroy": true
			 *      } );
			 *    } );
			 */
			"bDestroy": false,
		
		
			/**
			 * Enable or disable filtering of data. Filtering in DataTables is "smart" in
			 * that it allows the end user to input multiple words (space separated) and
			 * will match a row containing those words, even if not in the order that was
			 * specified (this allow matching across multiple columns). Note that if you
			 * wish to use filtering in DataTables this must remain 'true' - to remove the
			 * default filtering input box and retain filtering abilities, please use
			 * {@link DataTable.defaults.dom}.
			 *  @type boolean
			 *  @default true
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.searching
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "searching": false
			 *      } );
			 *    } );
			 */
			"bFilter": true,
		
		
			/**
			 * Enable or disable the table information display. This shows information
			 * about the data that is currently visible on the page, including information
			 * about filtered data if that action is being performed.
			 *  @type boolean
			 *  @default true
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.info
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "info": false
			 *      } );
			 *    } );
			 */
			"bInfo": true,
		
		
			/**
			 * Allows the end user to select the size of a formatted page from a select
			 * menu (sizes are 10, 25, 50 and 100). Requires pagination (`paginate`).
			 *  @type boolean
			 *  @default true
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.lengthChange
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "lengthChange": false
			 *      } );
			 *    } );
			 */
			"bLengthChange": true,
		
		
			/**
			 * Enable or disable pagination.
			 *  @type boolean
			 *  @default true
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.paging
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "paging": false
			 *      } );
			 *    } );
			 */
			"bPaginate": true,
		
		
			/**
			 * Enable or disable the display of a 'processing' indicator when the table is
			 * being processed (e.g. a sort). This is particularly useful for tables with
			 * large amounts of data where it can take a noticeable amount of time to sort
			 * the entries.
			 *  @type boolean
			 *  @default false
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.processing
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "processing": true
			 *      } );
			 *    } );
			 */
			"bProcessing": false,
		
		
			/**
			 * Retrieve the DataTables object for the given selector. Note that if the
			 * table has already been initialised, this parameter will cause DataTables
			 * to simply return the object that has already been set up - it will not take
			 * account of any changes you might have made to the initialisation object
			 * passed to DataTables (setting this parameter to true is an acknowledgement
			 * that you understand this). `destroy` can be used to reinitialise a table if
			 * you need.
			 *  @type boolean
			 *  @default false
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.retrieve
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      initTable();
			 *      tableActions();
			 *    } );
			 *
			 *    function initTable ()
			 *    {
			 *      return $('#example').dataTable( {
			 *        "scrollY": "200px",
			 *        "paginate": false,
			 *        "retrieve": true
			 *      } );
			 *    }
			 *
			 *    function tableActions ()
			 *    {
			 *      var table = initTable();
			 *      // perform API operations with oTable
			 *    }
			 */
			"bRetrieve": false,
		
		
			/**
			 * When vertical (y) scrolling is enabled, DataTables will force the height of
			 * the table's viewport to the given height at all times (useful for layout).
			 * However, this can look odd when filtering data down to a small data set,
			 * and the footer is left "floating" further down. This parameter (when
			 * enabled) will cause DataTables to collapse the table's viewport down when
			 * the result set will fit within the given Y height.
			 *  @type boolean
			 *  @default false
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.scrollCollapse
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "scrollY": "200",
			 *        "scrollCollapse": true
			 *      } );
			 *    } );
			 */
			"bScrollCollapse": false,
		
		
			/**
			 * Configure DataTables to use server-side processing. Note that the
			 * `ajax` parameter must also be given in order to give DataTables a
			 * source to obtain the required data for each draw.
			 *  @type boolean
			 *  @default false
			 *
			 *  @dtopt Features
			 *  @dtopt Server-side
			 *  @name DataTable.defaults.serverSide
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "serverSide": true,
			 *        "ajax": "xhr.php"
			 *      } );
			 *    } );
			 */
			"bServerSide": false,
		
		
			/**
			 * Enable or disable sorting of columns. Sorting of individual columns can be
			 * disabled by the `sortable` option for each column.
			 *  @type boolean
			 *  @default true
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.ordering
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "ordering": false
			 *      } );
			 *    } );
			 */
			"bSort": true,
		
		
			/**
			 * Enable or display DataTables' ability to sort multiple columns at the
			 * same time (activated by shift-click by the user).
			 *  @type boolean
			 *  @default true
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.orderMulti
			 *
			 *  @example
			 *    // Disable multiple column sorting ability
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "orderMulti": false
			 *      } );
			 *    } );
			 */
			"bSortMulti": true,
		
		
			/**
			 * Allows control over whether DataTables should use the top (true) unique
			 * cell that is found for a single column, or the bottom (false - default).
			 * This is useful when using complex headers.
			 *  @type boolean
			 *  @default false
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.orderCellsTop
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "orderCellsTop": true
			 *      } );
			 *    } );
			 */
			"bSortCellsTop": false,
		
		
			/**
			 * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
			 * `sorting\_3` to the columns which are currently being sorted on. This is
			 * presented as a feature switch as it can increase processing time (while
			 * classes are removed and added) so for large data sets you might want to
			 * turn this off.
			 *  @type boolean
			 *  @default true
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.orderClasses
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "orderClasses": false
			 *      } );
			 *    } );
			 */
			"bSortClasses": true,
		
		
			/**
			 * Enable or disable state saving. When enabled HTML5 `localStorage` will be
			 * used to save table display information such as pagination information,
			 * display length, filtering and sorting. As such when the end user reloads
			 * the page the display display will match what thy had previously set up.
			 *
			 * Due to the use of `localStorage` the default state saving is not supported
			 * in IE6 or 7. If state saving is required in those browsers, use
			 * `stateSaveCallback` to provide a storage solution such as cookies.
			 *  @type boolean
			 *  @default false
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.stateSave
			 *
			 *  @example
			 *    $(document).ready( function () {
			 *      $('#example').dataTable( {
			 *        "stateSave": true
			 *      } );
			 *    } );
			 */
			"bStateSave": false,
		
		
			/**
			 * This function is called when a TR element is created (and all TD child
			 * elements have been inserted), or registered if using a DOM source, allowing
			 * manipulation of the TR element (adding classes etc).
			 *  @type function
			 *  @param {node} row "TR" element for the current row
			 *  @param {array} data Raw data array for this row
			 *  @param {int} dataIndex The index of this row in the internal aoData array
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.createdRow
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "createdRow": function( row, data, dataIndex ) {
			 *          // Bold the grade for all 'A' grade browsers
			 *          if ( data[4] == "A" )
			 *          {
			 *            $('td:eq(4)', row).html( '<b>A</b>' );
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"fnCreatedRow": null,
		
		
			/**
			 * This function is called on every 'draw' event, and allows you to
			 * dynamically modify any aspect you want about the created DOM.
			 *  @type function
			 *  @param {object} settings DataTables settings object
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.drawCallback
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "drawCallback": function( settings ) {
			 *          alert( 'DataTables has redrawn the table' );
			 *        }
			 *      } );
			 *    } );
			 */
			"fnDrawCallback": null,
		
		
			/**
			 * Identical to fnHeaderCallback() but for the table footer this function
			 * allows you to modify the table footer on every 'draw' event.
			 *  @type function
			 *  @param {node} foot "TR" element for the footer
			 *  @param {array} data Full table data (as derived from the original HTML)
			 *  @param {int} start Index for the current display starting point in the
			 *    display array
			 *  @param {int} end Index for the current display ending point in the
			 *    display array
			 *  @param {array int} display Index array to translate the visual position
			 *    to the full data array
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.footerCallback
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "footerCallback": function( tfoot, data, start, end, display ) {
			 *          tfoot.getElementsByTagName('th')[0].innerHTML = "Starting index is "+start;
			 *        }
			 *      } );
			 *    } )
			 */
			"fnFooterCallback": null,
		
		
			/**
			 * When rendering large numbers in the information element for the table
			 * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
			 * to have a comma separator for the 'thousands' units (e.g. 1 million is
			 * rendered as "1,000,000") to help readability for the end user. This
			 * function will override the default method DataTables uses.
			 *  @type function
			 *  @member
			 *  @param {int} toFormat number to be formatted
			 *  @returns {string} formatted string for DataTables to show the number
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.formatNumber
			 *
			 *  @example
			 *    // Format a number using a single quote for the separator (note that
			 *    // this can also be done with the language.thousands option)
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "formatNumber": function ( toFormat ) {
			 *          return toFormat.toString().replace(
			 *            /\B(?=(\d{3})+(?!\d))/g, "'"
			 *          );
			 *        };
			 *      } );
			 *    } );
			 */
			"fnFormatNumber": function ( toFormat ) {
				return toFormat.toString().replace(
					/\B(?=(\d{3})+(?!\d))/g,
					this.oLanguage.sThousands
				);
			},
		
		
			/**
			 * This function is called on every 'draw' event, and allows you to
			 * dynamically modify the header row. This can be used to calculate and
			 * display useful information about the table.
			 *  @type function
			 *  @param {node} head "TR" element for the header
			 *  @param {array} data Full table data (as derived from the original HTML)
			 *  @param {int} start Index for the current display starting point in the
			 *    display array
			 *  @param {int} end Index for the current display ending point in the
			 *    display array
			 *  @param {array int} display Index array to translate the visual position
			 *    to the full data array
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.headerCallback
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "fheaderCallback": function( head, data, start, end, display ) {
			 *          head.getElementsByTagName('th')[0].innerHTML = "Displaying "+(end-start)+" records";
			 *        }
			 *      } );
			 *    } )
			 */
			"fnHeaderCallback": null,
		
		
			/**
			 * The information element can be used to convey information about the current
			 * state of the table. Although the internationalisation options presented by
			 * DataTables are quite capable of dealing with most customisations, there may
			 * be times where you wish to customise the string further. This callback
			 * allows you to do exactly that.
			 *  @type function
			 *  @param {object} oSettings DataTables settings object
			 *  @param {int} start Starting position in data for the draw
			 *  @param {int} end End position in data for the draw
			 *  @param {int} max Total number of rows in the table (regardless of
			 *    filtering)
			 *  @param {int} total Total number of rows in the data set, after filtering
			 *  @param {string} pre The string that DataTables has formatted using it's
			 *    own rules
			 *  @returns {string} The string to be displayed in the information element.
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.infoCallback
			 *
			 *  @example
			 *    $('#example').dataTable( {
			 *      "infoCallback": function( settings, start, end, max, total, pre ) {
			 *        return start +" to "+ end;
			 *      }
			 *    } );
			 */
			"fnInfoCallback": null,
		
		
			/**
			 * Called when the table has been initialised. Normally DataTables will
			 * initialise sequentially and there will be no need for this function,
			 * however, this does not hold true when using external language information
			 * since that is obtained using an async XHR call.
			 *  @type function
			 *  @param {object} settings DataTables settings object
			 *  @param {object} json The JSON object request from the server - only
			 *    present if client-side Ajax sourced data is used
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.initComplete
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "initComplete": function(settings, json) {
			 *          alert( 'DataTables has finished its initialisation.' );
			 *        }
			 *      } );
			 *    } )
			 */
			"fnInitComplete": null,
		
		
			/**
			 * Called at the very start of each table draw and can be used to cancel the
			 * draw by returning false, any other return (including undefined) results in
			 * the full draw occurring).
			 *  @type function
			 *  @param {object} settings DataTables settings object
			 *  @returns {boolean} False will cancel the draw, anything else (including no
			 *    return) will allow it to complete.
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.preDrawCallback
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "preDrawCallback": function( settings ) {
			 *          if ( $('#test').val() == 1 ) {
			 *            return false;
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"fnPreDrawCallback": null,
		
		
			/**
			 * This function allows you to 'post process' each row after it have been
			 * generated for each table draw, but before it is rendered on screen. This
			 * function might be used for setting the row class name etc.
			 *  @type function
			 *  @param {node} row "TR" element for the current row
			 *  @param {array} data Raw data array for this row
			 *  @param {int} displayIndex The display index for the current table draw
			 *  @param {int} displayIndexFull The index of the data in the full list of
			 *    rows (after filtering)
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.rowCallback
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "rowCallback": function( row, data, displayIndex, displayIndexFull ) {
			 *          // Bold the grade for all 'A' grade browsers
			 *          if ( data[4] == "A" ) {
			 *            $('td:eq(4)', row).html( '<b>A</b>' );
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"fnRowCallback": null,
		
		
			/**
			 * __Deprecated__ The functionality provided by this parameter has now been
			 * superseded by that provided through `ajax`, which should be used instead.
			 *
			 * This parameter allows you to override the default function which obtains
			 * the data from the server so something more suitable for your application.
			 * For example you could use POST data, or pull information from a Gears or
			 * AIR database.
			 *  @type function
			 *  @member
			 *  @param {string} source HTTP source to obtain the data from (`ajax`)
			 *  @param {array} data A key/value pair object containing the data to send
			 *    to the server
			 *  @param {function} callback to be called on completion of the data get
			 *    process that will draw the data on the page.
			 *  @param {object} settings DataTables settings object
			 *
			 *  @dtopt Callbacks
			 *  @dtopt Server-side
			 *  @name DataTable.defaults.serverData
			 *
			 *  @deprecated 1.10. Please use `ajax` for this functionality now.
			 */
			"fnServerData": null,
		
		
			/**
			 * __Deprecated__ The functionality provided by this parameter has now been
			 * superseded by that provided through `ajax`, which should be used instead.
			 *
			 *  It is often useful to send extra data to the server when making an Ajax
			 * request - for example custom filtering information, and this callback
			 * function makes it trivial to send extra information to the server. The
			 * passed in parameter is the data set that has been constructed by
			 * DataTables, and you can add to this or modify it as you require.
			 *  @type function
			 *  @param {array} data Data array (array of objects which are name/value
			 *    pairs) that has been constructed by DataTables and will be sent to the
			 *    server. In the case of Ajax sourced data with server-side processing
			 *    this will be an empty array, for server-side processing there will be a
			 *    significant number of parameters!
			 *  @returns {undefined} Ensure that you modify the data array passed in,
			 *    as this is passed by reference.
			 *
			 *  @dtopt Callbacks
			 *  @dtopt Server-side
			 *  @name DataTable.defaults.serverParams
			 *
			 *  @deprecated 1.10. Please use `ajax` for this functionality now.
			 */
			"fnServerParams": null,
		
		
			/**
			 * Load the table state. With this function you can define from where, and how, the
			 * state of a table is loaded. By default DataTables will load from `localStorage`
			 * but you might wish to use a server-side database or cookies.
			 *  @type function
			 *  @member
			 *  @param {object} settings DataTables settings object
			 *  @param {object} callback Callback that can be executed when done. It
			 *    should be passed the loaded state object.
			 *  @return {object} The DataTables state object to be loaded
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.stateLoadCallback
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "stateSave": true,
			 *        "stateLoadCallback": function (settings, callback) {
			 *          $.ajax( {
			 *            "url": "/state_load",
			 *            "dataType": "json",
			 *            "success": function (json) {
			 *              callback( json );
			 *            }
			 *          } );
			 *        }
			 *      } );
			 *    } );
			 */
			"fnStateLoadCallback": function ( settings ) {
				try {
					return JSON.parse(
						(settings.iStateDuration === -1 ? sessionStorage : localStorage).getItem(
							'DataTables_'+settings.sInstance+'_'+location.pathname
						)
					);
				} catch (e) {}
			},
		
		
			/**
			 * Callback which allows modification of the saved state prior to loading that state.
			 * This callback is called when the table is loading state from the stored data, but
			 * prior to the settings object being modified by the saved state. Note that for
			 * plug-in authors, you should use the `stateLoadParams` event to load parameters for
			 * a plug-in.
			 *  @type function
			 *  @param {object} settings DataTables settings object
			 *  @param {object} data The state object that is to be loaded
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.stateLoadParams
			 *
			 *  @example
			 *    // Remove a saved filter, so filtering is never loaded
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "stateSave": true,
			 *        "stateLoadParams": function (settings, data) {
			 *          data.oSearch.sSearch = "";
			 *        }
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Disallow state loading by returning false
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "stateSave": true,
			 *        "stateLoadParams": function (settings, data) {
			 *          return false;
			 *        }
			 *      } );
			 *    } );
			 */
			"fnStateLoadParams": null,
		
		
			/**
			 * Callback that is called when the state has been loaded from the state saving method
			 * and the DataTables settings object has been modified as a result of the loaded state.
			 *  @type function
			 *  @param {object} settings DataTables settings object
			 *  @param {object} data The state object that was loaded
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.stateLoaded
			 *
			 *  @example
			 *    // Show an alert with the filtering value that was saved
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "stateSave": true,
			 *        "stateLoaded": function (settings, data) {
			 *          alert( 'Saved filter was: '+data.oSearch.sSearch );
			 *        }
			 *      } );
			 *    } );
			 */
			"fnStateLoaded": null,
		
		
			/**
			 * Save the table state. This function allows you to define where and how the state
			 * information for the table is stored By default DataTables will use `localStorage`
			 * but you might wish to use a server-side database or cookies.
			 *  @type function
			 *  @member
			 *  @param {object} settings DataTables settings object
			 *  @param {object} data The state object to be saved
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.stateSaveCallback
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "stateSave": true,
			 *        "stateSaveCallback": function (settings, data) {
			 *          // Send an Ajax request to the server with the state object
			 *          $.ajax( {
			 *            "url": "/state_save",
			 *            "data": data,
			 *            "dataType": "json",
			 *            "method": "POST"
			 *            "success": function () {}
			 *          } );
			 *        }
			 *      } );
			 *    } );
			 */
			"fnStateSaveCallback": function ( settings, data ) {
				try {
					(settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem(
						'DataTables_'+settings.sInstance+'_'+location.pathname,
						JSON.stringify( data )
					);
				} catch (e) {}
			},
		
		
			/**
			 * Callback which allows modification of the state to be saved. Called when the table
			 * has changed state a new state save is required. This method allows modification of
			 * the state saving object prior to actually doing the save, including addition or
			 * other state properties or modification. Note that for plug-in authors, you should
			 * use the `stateSaveParams` event to save parameters for a plug-in.
			 *  @type function
			 *  @param {object} settings DataTables settings object
			 *  @param {object} data The state object to be saved
			 *
			 *  @dtopt Callbacks
			 *  @name DataTable.defaults.stateSaveParams
			 *
			 *  @example
			 *    // Remove a saved filter, so filtering is never saved
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "stateSave": true,
			 *        "stateSaveParams": function (settings, data) {
			 *          data.oSearch.sSearch = "";
			 *        }
			 *      } );
			 *    } );
			 */
			"fnStateSaveParams": null,
		
		
			/**
			 * Duration for which the saved state information is considered valid. After this period
			 * has elapsed the state will be returned to the default.
			 * Value is given in seconds.
			 *  @type int
			 *  @default 7200 <i>(2 hours)</i>
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.stateDuration
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "stateDuration": 60*60*24; // 1 day
			 *      } );
			 *    } )
			 */
			"iStateDuration": 7200,
		
		
			/**
			 * When enabled DataTables will not make a request to the server for the first
			 * page draw - rather it will use the data already on the page (no sorting etc
			 * will be applied to it), thus saving on an XHR at load time. `deferLoading`
			 * is used to indicate that deferred loading is required, but it is also used
			 * to tell DataTables how many records there are in the full table (allowing
			 * the information element and pagination to be displayed correctly). In the case
			 * where a filtering is applied to the table on initial load, this can be
			 * indicated by giving the parameter as an array, where the first element is
			 * the number of records available after filtering and the second element is the
			 * number of records without filtering (allowing the table information element
			 * to be shown correctly).
			 *  @type int | array
			 *  @default null
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.deferLoading
			 *
			 *  @example
			 *    // 57 records available in the table, no filtering applied
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "serverSide": true,
			 *        "ajax": "scripts/server_processing.php",
			 *        "deferLoading": 57
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // 57 records after filtering, 100 without filtering (an initial filter applied)
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "serverSide": true,
			 *        "ajax": "scripts/server_processing.php",
			 *        "deferLoading": [ 57, 100 ],
			 *        "search": {
			 *          "search": "my_filter"
			 *        }
			 *      } );
			 *    } );
			 */
			"iDeferLoading": null,
		
		
			/**
			 * Number of rows to display on a single page when using pagination. If
			 * feature enabled (`lengthChange`) then the end user will be able to override
			 * this to a custom setting using a pop-up menu.
			 *  @type int
			 *  @default 10
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.pageLength
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "pageLength": 50
			 *      } );
			 *    } )
			 */
			"iDisplayLength": 10,
		
		
			/**
			 * Define the starting point for data display when using DataTables with
			 * pagination. Note that this parameter is the number of records, rather than
			 * the page number, so if you have 10 records per page and want to start on
			 * the third page, it should be "20".
			 *  @type int
			 *  @default 0
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.displayStart
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "displayStart": 20
			 *      } );
			 *    } )
			 */
			"iDisplayStart": 0,
		
		
			/**
			 * By default DataTables allows keyboard navigation of the table (sorting, paging,
			 * and filtering) by adding a `tabindex` attribute to the required elements. This
			 * allows you to tab through the controls and press the enter key to activate them.
			 * The tabindex is default 0, meaning that the tab follows the flow of the document.
			 * You can overrule this using this parameter if you wish. Use a value of -1 to
			 * disable built-in keyboard navigation.
			 *  @type int
			 *  @default 0
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.tabIndex
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "tabIndex": 1
			 *      } );
			 *    } );
			 */
			"iTabIndex": 0,
		
		
			/**
			 * Classes that DataTables assigns to the various components and features
			 * that it adds to the HTML table. This allows classes to be configured
			 * during initialisation in addition to through the static
			 * {@link DataTable.ext.oStdClasses} object).
			 *  @namespace
			 *  @name DataTable.defaults.classes
			 */
			"oClasses": {},
		
		
			/**
			 * All strings that DataTables uses in the user interface that it creates
			 * are defined in this object, allowing you to modified them individually or
			 * completely replace them all as required.
			 *  @namespace
			 *  @name DataTable.defaults.language
			 */
			"oLanguage": {
				/**
				 * Strings that are used for WAI-ARIA labels and controls only (these are not
				 * actually visible on the page, but will be read by screenreaders, and thus
				 * must be internationalised as well).
				 *  @namespace
				 *  @name DataTable.defaults.language.aria
				 */
				"oAria": {
					/**
					 * ARIA label that is added to the table headers when the column may be
					 * sorted ascending by activing the column (click or return when focused).
					 * Note that the column header is prefixed to this string.
					 *  @type string
					 *  @default : activate to sort column ascending
					 *
					 *  @dtopt Language
					 *  @name DataTable.defaults.language.aria.sortAscending
					 *
					 *  @example
					 *    $(document).ready( function() {
					 *      $('#example').dataTable( {
					 *        "language": {
					 *          "aria": {
					 *            "sortAscending": " - click/return to sort ascending"
					 *          }
					 *        }
					 *      } );
					 *    } );
					 */
					"sSortAscending": ": activate to sort column ascending",
		
					/**
					 * ARIA label that is added to the table headers when the column may be
					 * sorted descending by activing the column (click or return when focused).
					 * Note that the column header is prefixed to this string.
					 *  @type string
					 *  @default : activate to sort column ascending
					 *
					 *  @dtopt Language
					 *  @name DataTable.defaults.language.aria.sortDescending
					 *
					 *  @example
					 *    $(document).ready( function() {
					 *      $('#example').dataTable( {
					 *        "language": {
					 *          "aria": {
					 *            "sortDescending": " - click/return to sort descending"
					 *          }
					 *        }
					 *      } );
					 *    } );
					 */
					"sSortDescending": ": activate to sort column descending"
				},
		
				/**
				 * Pagination string used by DataTables for the built-in pagination
				 * control types.
				 *  @namespace
				 *  @name DataTable.defaults.language.paginate
				 */
				"oPaginate": {
					/**
					 * Text to use when using the 'full_numbers' type of pagination for the
					 * button to take the user to the first page.
					 *  @type string
					 *  @default First
					 *
					 *  @dtopt Language
					 *  @name DataTable.defaults.language.paginate.first
					 *
					 *  @example
					 *    $(document).ready( function() {
					 *      $('#example').dataTable( {
					 *        "language": {
					 *          "paginate": {
					 *            "first": "First page"
					 *          }
					 *        }
					 *      } );
					 *    } );
					 */
					"sFirst": "First",
		
		
					/**
					 * Text to use when using the 'full_numbers' type of pagination for the
					 * button to take the user to the last page.
					 *  @type string
					 *  @default Last
					 *
					 *  @dtopt Language
					 *  @name DataTable.defaults.language.paginate.last
					 *
					 *  @example
					 *    $(document).ready( function() {
					 *      $('#example').dataTable( {
					 *        "language": {
					 *          "paginate": {
					 *            "last": "Last page"
					 *          }
					 *        }
					 *      } );
					 *    } );
					 */
					"sLast": "Last",
		
		
					/**
					 * Text to use for the 'next' pagination button (to take the user to the
					 * next page).
					 *  @type string
					 *  @default Next
					 *
					 *  @dtopt Language
					 *  @name DataTable.defaults.language.paginate.next
					 *
					 *  @example
					 *    $(document).ready( function() {
					 *      $('#example').dataTable( {
					 *        "language": {
					 *          "paginate": {
					 *            "next": "Next page"
					 *          }
					 *        }
					 *      } );
					 *    } );
					 */
					"sNext": "Next",
		
		
					/**
					 * Text to use for the 'previous' pagination button (to take the user to
					 * the previous page).
					 *  @type string
					 *  @default Previous
					 *
					 *  @dtopt Language
					 *  @name DataTable.defaults.language.paginate.previous
					 *
					 *  @example
					 *    $(document).ready( function() {
					 *      $('#example').dataTable( {
					 *        "language": {
					 *          "paginate": {
					 *            "previous": "Previous page"
					 *          }
					 *        }
					 *      } );
					 *    } );
					 */
					"sPrevious": "Previous"
				},
		
				/**
				 * This string is shown in preference to `zeroRecords` when the table is
				 * empty of data (regardless of filtering). Note that this is an optional
				 * parameter - if it is not given, the value of `zeroRecords` will be used
				 * instead (either the default or given value).
				 *  @type string
				 *  @default No data available in table
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.emptyTable
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "emptyTable": "No data available in table"
				 *        }
				 *      } );
				 *    } );
				 */
				"sEmptyTable": "No data available in table",
		
		
				/**
				 * This string gives information to the end user about the information
				 * that is current on display on the page. The following tokens can be
				 * used in the string and will be dynamically replaced as the table
				 * display updates. This tokens can be placed anywhere in the string, or
				 * removed as needed by the language requires:
				 *
				 * * `\_START\_` - Display index of the first record on the current page
				 * * `\_END\_` - Display index of the last record on the current page
				 * * `\_TOTAL\_` - Number of records in the table after filtering
				 * * `\_MAX\_` - Number of records in the table without filtering
				 * * `\_PAGE\_` - Current page number
				 * * `\_PAGES\_` - Total number of pages of data in the table
				 *
				 *  @type string
				 *  @default Showing _START_ to _END_ of _TOTAL_ entries
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.info
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "info": "Showing page _PAGE_ of _PAGES_"
				 *        }
				 *      } );
				 *    } );
				 */
				"sInfo": "Showing _START_ to _END_ of _TOTAL_ entries",
		
		
				/**
				 * Display information string for when the table is empty. Typically the
				 * format of this string should match `info`.
				 *  @type string
				 *  @default Showing 0 to 0 of 0 entries
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.infoEmpty
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "infoEmpty": "No entries to show"
				 *        }
				 *      } );
				 *    } );
				 */
				"sInfoEmpty": "Showing 0 to 0 of 0 entries",
		
		
				/**
				 * When a user filters the information in a table, this string is appended
				 * to the information (`info`) to give an idea of how strong the filtering
				 * is. The variable _MAX_ is dynamically updated.
				 *  @type string
				 *  @default (filtered from _MAX_ total entries)
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.infoFiltered
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "infoFiltered": " - filtering from _MAX_ records"
				 *        }
				 *      } );
				 *    } );
				 */
				"sInfoFiltered": "(filtered from _MAX_ total entries)",
		
		
				/**
				 * If can be useful to append extra information to the info string at times,
				 * and this variable does exactly that. This information will be appended to
				 * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
				 * being used) at all times.
				 *  @type string
				 *  @default <i>Empty string</i>
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.infoPostFix
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "infoPostFix": "All records shown are derived from real information."
				 *        }
				 *      } );
				 *    } );
				 */
				"sInfoPostFix": "",
		
		
				/**
				 * This decimal place operator is a little different from the other
				 * language options since DataTables doesn't output floating point
				 * numbers, so it won't ever use this for display of a number. Rather,
				 * what this parameter does is modify the sort methods of the table so
				 * that numbers which are in a format which has a character other than
				 * a period (`.`) as a decimal place will be sorted numerically.
				 *
				 * Note that numbers with different decimal places cannot be shown in
				 * the same table and still be sortable, the table must be consistent.
				 * However, multiple different tables on the page can use different
				 * decimal place characters.
				 *  @type string
				 *  @default 
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.decimal
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "decimal": ","
				 *          "thousands": "."
				 *        }
				 *      } );
				 *    } );
				 */
				"sDecimal": "",
		
		
				/**
				 * DataTables has a build in number formatter (`formatNumber`) which is
				 * used to format large numbers that are used in the table information.
				 * By default a comma is used, but this can be trivially changed to any
				 * character you wish with this parameter.
				 *  @type string
				 *  @default ,
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.thousands
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "thousands": "'"
				 *        }
				 *      } );
				 *    } );
				 */
				"sThousands": ",",
		
		
				/**
				 * Detail the action that will be taken when the drop down menu for the
				 * pagination length option is changed. The '_MENU_' variable is replaced
				 * with a default select list of 10, 25, 50 and 100, and can be replaced
				 * with a custom select box if required.
				 *  @type string
				 *  @default Show _MENU_ entries
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.lengthMenu
				 *
				 *  @example
				 *    // Language change only
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "lengthMenu": "Display _MENU_ records"
				 *        }
				 *      } );
				 *    } );
				 *
				 *  @example
				 *    // Language and options change
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "lengthMenu": 'Display <select>'+
				 *            '<option value="10">10</option>'+
				 *            '<option value="20">20</option>'+
				 *            '<option value="30">30</option>'+
				 *            '<option value="40">40</option>'+
				 *            '<option value="50">50</option>'+
				 *            '<option value="-1">All</option>'+
				 *            '</select> records'
				 *        }
				 *      } );
				 *    } );
				 */
				"sLengthMenu": "Show _MENU_ entries",
		
		
				/**
				 * When using Ajax sourced data and during the first draw when DataTables is
				 * gathering the data, this message is shown in an empty row in the table to
				 * indicate to the end user the the data is being loaded. Note that this
				 * parameter is not used when loading data by server-side processing, just
				 * Ajax sourced data with client-side processing.
				 *  @type string
				 *  @default Loading...
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.loadingRecords
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "loadingRecords": "Please wait - loading..."
				 *        }
				 *      } );
				 *    } );
				 */
				"sLoadingRecords": "Loading...",
		
		
				/**
				 * Text which is displayed when the table is processing a user action
				 * (usually a sort command or similar).
				 *  @type string
				 *  @default Processing...
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.processing
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "processing": "DataTables is currently busy"
				 *        }
				 *      } );
				 *    } );
				 */
				"sProcessing": "Processing...",
		
		
				/**
				 * Details the actions that will be taken when the user types into the
				 * filtering input text box. The variable "_INPUT_", if used in the string,
				 * is replaced with the HTML text box for the filtering input allowing
				 * control over where it appears in the string. If "_INPUT_" is not given
				 * then the input box is appended to the string automatically.
				 *  @type string
				 *  @default Search:
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.search
				 *
				 *  @example
				 *    // Input text box will be appended at the end automatically
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "search": "Filter records:"
				 *        }
				 *      } );
				 *    } );
				 *
				 *  @example
				 *    // Specify where the filter should appear
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "search": "Apply filter _INPUT_ to table"
				 *        }
				 *      } );
				 *    } );
				 */
				"sSearch": "Search:",
		
		
				/**
				 * Assign a `placeholder` attribute to the search `input` element
				 *  @type string
				 *  @default 
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.searchPlaceholder
				 */
				"sSearchPlaceholder": "",
		
		
				/**
				 * All of the language information can be stored in a file on the
				 * server-side, which DataTables will look up if this parameter is passed.
				 * It must store the URL of the language file, which is in a JSON format,
				 * and the object has the same properties as the oLanguage object in the
				 * initialiser object (i.e. the above parameters). Please refer to one of
				 * the example language files to see how this works in action.
				 *  @type string
				 *  @default <i>Empty string - i.e. disabled</i>
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.url
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "url": "http://www.sprymedia.co.uk/dataTables/lang.txt"
				 *        }
				 *      } );
				 *    } );
				 */
				"sUrl": "",
		
		
				/**
				 * Text shown inside the table records when the is no information to be
				 * displayed after filtering. `emptyTable` is shown when there is simply no
				 * information in the table at all (regardless of filtering).
				 *  @type string
				 *  @default No matching records found
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.zeroRecords
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "zeroRecords": "No records to display"
				 *        }
				 *      } );
				 *    } );
				 */
				"sZeroRecords": "No matching records found"
			},
		
		
			/**
			 * This parameter allows you to have define the global filtering state at
			 * initialisation time. As an object the `search` parameter must be
			 * defined, but all other parameters are optional. When `regex` is true,
			 * the search string will be treated as a regular expression, when false
			 * (default) it will be treated as a straight string. When `smart`
			 * DataTables will use it's smart filtering methods (to word match at
			 * any point in the data), when false this will not be done.
			 *  @namespace
			 *  @extends DataTable.models.oSearch
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.search
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "search": {"search": "Initial search"}
			 *      } );
			 *    } )
			 */
			"oSearch": $.extend( {}, DataTable.models.oSearch ),
		
		
			/**
			 * __Deprecated__ The functionality provided by this parameter has now been
			 * superseded by that provided through `ajax`, which should be used instead.
			 *
			 * By default DataTables will look for the property `data` (or `aaData` for
			 * compatibility with DataTables 1.9-) when obtaining data from an Ajax
			 * source or for server-side processing - this parameter allows that
			 * property to be changed. You can use Javascript dotted object notation to
			 * get a data source for multiple levels of nesting.
			 *  @type string
			 *  @default data
			 *
			 *  @dtopt Options
			 *  @dtopt Server-side
			 *  @name DataTable.defaults.ajaxDataProp
			 *
			 *  @deprecated 1.10. Please use `ajax` for this functionality now.
			 */
			"sAjaxDataProp": "data",
		
		
			/**
			 * __Deprecated__ The functionality provided by this parameter has now been
			 * superseded by that provided through `ajax`, which should be used instead.
			 *
			 * You can instruct DataTables to load data from an external
			 * source using this parameter (use aData if you want to pass data in you
			 * already have). Simply provide a url a JSON object can be obtained from.
			 *  @type string
			 *  @default null
			 *
			 *  @dtopt Options
			 *  @dtopt Server-side
			 *  @name DataTable.defaults.ajaxSource
			 *
			 *  @deprecated 1.10. Please use `ajax` for this functionality now.
			 */
			"sAjaxSource": null,
		
		
			/**
			 * This initialisation variable allows you to specify exactly where in the
			 * DOM you want DataTables to inject the various controls it adds to the page
			 * (for example you might want the pagination controls at the top of the
			 * table). DIV elements (with or without a custom class) can also be added to
			 * aid styling. The follow syntax is used:
			 *   <ul>
			 *     <li>The following options are allowed:
			 *       <ul>
			 *         <li>'l' - Length changing</li>
			 *         <li>'f' - Filtering input</li>
			 *         <li>'t' - The table!</li>
			 *         <li>'i' - Information</li>
			 *         <li>'p' - Pagination</li>
			 *         <li>'r' - pRocessing</li>
			 *       </ul>
			 *     </li>
			 *     <li>The following constants are allowed:
			 *       <ul>
			 *         <li>'H' - jQueryUI theme "header" classes ('fg-toolbar ui-widget-header ui-corner-tl ui-corner-tr ui-helper-clearfix')</li>
			 *         <li>'F' - jQueryUI theme "footer" classes ('fg-toolbar ui-widget-header ui-corner-bl ui-corner-br ui-helper-clearfix')</li>
			 *       </ul>
			 *     </li>
			 *     <li>The following syntax is expected:
			 *       <ul>
			 *         <li>'&lt;' and '&gt;' - div elements</li>
			 *         <li>'&lt;"class" and '&gt;' - div with a class</li>
			 *         <li>'&lt;"#id" and '&gt;' - div with an ID</li>
			 *       </ul>
			 *     </li>
			 *     <li>Examples:
			 *       <ul>
			 *         <li>'&lt;"wrapper"flipt&gt;'</li>
			 *         <li>'&lt;lf&lt;t&gt;ip&gt;'</li>
			 *       </ul>
			 *     </li>
			 *   </ul>
			 *  @type string
			 *  @default lfrtip <i>(when `jQueryUI` is false)</i> <b>or</b>
			 *    <"H"lfr>t<"F"ip> <i>(when `jQueryUI` is true)</i>
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.dom
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "dom": '&lt;"top"i&gt;rt&lt;"bottom"flp&gt;&lt;"clear"&gt;'
			 *      } );
			 *    } );
			 */
			"sDom": "lfrtip",
		
		
			/**
			 * Search delay option. This will throttle full table searches that use the
			 * DataTables provided search input element (it does not effect calls to
			 * `dt-api search()`, providing a delay before the search is made.
			 *  @type integer
			 *  @default 0
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.searchDelay
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "searchDelay": 200
			 *      } );
			 *    } )
			 */
			"searchDelay": null,
		
		
			/**
			 * DataTables features six different built-in options for the buttons to
			 * display for pagination control:
			 *
			 * * `numbers` - Page number buttons only
			 * * `simple` - 'Previous' and 'Next' buttons only
			 * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
			 * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
			 * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus page numbers
			 * * `first_last_numbers` - 'First' and 'Last' buttons, plus page numbers
			 *  
			 * Further methods can be added using {@link DataTable.ext.oPagination}.
			 *  @type string
			 *  @default simple_numbers
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.pagingType
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "pagingType": "full_numbers"
			 *      } );
			 *    } )
			 */
			"sPaginationType": "simple_numbers",
		
		
			/**
			 * Enable horizontal scrolling. When a table is too wide to fit into a
			 * certain layout, or you have a large number of columns in the table, you
			 * can enable x-scrolling to show the table in a viewport, which can be
			 * scrolled. This property can be `true` which will allow the table to
			 * scroll horizontally when needed, or any CSS unit, or a number (in which
			 * case it will be treated as a pixel measurement). Setting as simply `true`
			 * is recommended.
			 *  @type boolean|string
			 *  @default <i>blank string - i.e. disabled</i>
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.scrollX
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "scrollX": true,
			 *        "scrollCollapse": true
			 *      } );
			 *    } );
			 */
			"sScrollX": "",
		
		
			/**
			 * This property can be used to force a DataTable to use more width than it
			 * might otherwise do when x-scrolling is enabled. For example if you have a
			 * table which requires to be well spaced, this parameter is useful for
			 * "over-sizing" the table, and thus forcing scrolling. This property can by
			 * any CSS unit, or a number (in which case it will be treated as a pixel
			 * measurement).
			 *  @type string
			 *  @default <i>blank string - i.e. disabled</i>
			 *
			 *  @dtopt Options
			 *  @name DataTable.defaults.scrollXInner
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "scrollX": "100%",
			 *        "scrollXInner": "110%"
			 *      } );
			 *    } );
			 */
			"sScrollXInner": "",
		
		
			/**
			 * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
			 * to the given height, and enable scrolling for any data which overflows the
			 * current viewport. This can be used as an alternative to paging to display
			 * a lot of data in a small area (although paging and scrolling can both be
			 * enabled at the same time). This property can be any CSS unit, or a number
			 * (in which case it will be treated as a pixel measurement).
			 *  @type string
			 *  @default <i>blank string - i.e. disabled</i>
			 *
			 *  @dtopt Features
			 *  @name DataTable.defaults.scrollY
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "scrollY": "200px",
			 *        "paginate": false
			 *      } );
			 *    } );
			 */
			"sScrollY": "",
		
		
			/**
			 * __Deprecated__ The functionality provided by this parameter has now been
			 * superseded by that provided through `ajax`, which should be used instead.
			 *
			 * Set the HTTP method that is used to make the Ajax call for server-side
			 * processing or Ajax sourced data.
			 *  @type string
			 *  @default GET
			 *
			 *  @dtopt Options
			 *  @dtopt Server-side
			 *  @name DataTable.defaults.serverMethod
			 *
			 *  @deprecated 1.10. Please use `ajax` for this functionality now.
			 */
			"sServerMethod": "GET",
		
		
			/**
			 * DataTables makes use of renderers when displaying HTML elements for
			 * a table. These renderers can be added or modified by plug-ins to
			 * generate suitable mark-up for a site. For example the Bootstrap
			 * integration plug-in for DataTables uses a paging button renderer to
			 * display pagination buttons in the mark-up required by Bootstrap.
			 *
			 * For further information about the renderers available see
			 * DataTable.ext.renderer
			 *  @type string|object
			 *  @default null
			 *
			 *  @name DataTable.defaults.renderer
			 *
			 */
			"renderer": null,
		
		
			/**
			 * Set the data property name that DataTables should use to get a row's id
			 * to set as the `id` property in the node.
			 *  @type string
			 *  @default DT_RowId
			 *
			 *  @name DataTable.defaults.rowId
			 */
			"rowId": "DT_RowId"
		};
		
		_fnHungarianMap( DataTable.defaults );
		
		
		
		/*
		 * Developer note - See note in model.defaults.js about the use of Hungarian
		 * notation and camel case.
		 */
		
		/**
		 * Column options that can be given to DataTables at initialisation time.
		 *  @namespace
		 */
		DataTable.defaults.column = {
			/**
			 * Define which column(s) an order will occur on for this column. This
			 * allows a column's ordering to take multiple columns into account when
			 * doing a sort or use the data from a different column. For example first
			 * name / last name columns make sense to do a multi-column sort over the
			 * two columns.
			 *  @type array|int
			 *  @default null <i>Takes the value of the column index automatically</i>
			 *
			 *  @name DataTable.defaults.column.orderData
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "orderData": [ 0, 1 ], "targets": [ 0 ] },
			 *          { "orderData": [ 1, 0 ], "targets": [ 1 ] },
			 *          { "orderData": 2, "targets": [ 2 ] }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "orderData": [ 0, 1 ] },
			 *          { "orderData": [ 1, 0 ] },
			 *          { "orderData": 2 },
			 *          null,
			 *          null
			 *        ]
			 *      } );
			 *    } );
			 */
			"aDataSort": null,
			"iDataSort": -1,
		
		
			/**
			 * You can control the default ordering direction, and even alter the
			 * behaviour of the sort handler (i.e. only allow ascending ordering etc)
			 * using this parameter.
			 *  @type array
			 *  @default [ 'asc', 'desc' ]
			 *
			 *  @name DataTable.defaults.column.orderSequence
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "orderSequence": [ "asc" ], "targets": [ 1 ] },
			 *          { "orderSequence": [ "desc", "asc", "asc" ], "targets": [ 2 ] },
			 *          { "orderSequence": [ "desc" ], "targets": [ 3 ] }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          null,
			 *          { "orderSequence": [ "asc" ] },
			 *          { "orderSequence": [ "desc", "asc", "asc" ] },
			 *          { "orderSequence": [ "desc" ] },
			 *          null
			 *        ]
			 *      } );
			 *    } );
			 */
			"asSorting": [ 'asc', 'desc' ],
		
		
			/**
			 * Enable or disable filtering on the data in this column.
			 *  @type boolean
			 *  @default true
			 *
			 *  @name DataTable.defaults.column.searchable
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "searchable": false, "targets": [ 0 ] }
			 *        ] } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "searchable": false },
			 *          null,
			 *          null,
			 *          null,
			 *          null
			 *        ] } );
			 *    } );
			 */
			"bSearchable": true,
		
		
			/**
			 * Enable or disable ordering on this column.
			 *  @type boolean
			 *  @default true
			 *
			 *  @name DataTable.defaults.column.orderable
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "orderable": false, "targets": [ 0 ] }
			 *        ] } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "orderable": false },
			 *          null,
			 *          null,
			 *          null,
			 *          null
			 *        ] } );
			 *    } );
			 */
			"bSortable": true,
		
		
			/**
			 * Enable or disable the display of this column.
			 *  @type boolean
			 *  @default true
			 *
			 *  @name DataTable.defaults.column.visible
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "visible": false, "targets": [ 0 ] }
			 *        ] } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "visible": false },
			 *          null,
			 *          null,
			 *          null,
			 *          null
			 *        ] } );
			 *    } );
			 */
			"bVisible": true,
		
		
			/**
			 * Developer definable function that is called whenever a cell is created (Ajax source,
			 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
			 * allowing you to modify the DOM element (add background colour for example) when the
			 * element is available.
			 *  @type function
			 *  @param {element} td The TD node that has been created
			 *  @param {*} cellData The Data for the cell
			 *  @param {array|object} rowData The data for the whole row
			 *  @param {int} row The row index for the aoData data store
			 *  @param {int} col The column index for aoColumns
			 *
			 *  @name DataTable.defaults.column.createdCell
			 *  @dtopt Columns
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [ {
			 *          "targets": [3],
			 *          "createdCell": function (td, cellData, rowData, row, col) {
			 *            if ( cellData == "1.7" ) {
			 *              $(td).css('color', 'blue')
			 *            }
			 *          }
			 *        } ]
			 *      });
			 *    } );
			 */
			"fnCreatedCell": null,
		
		
			/**
			 * This parameter has been replaced by `data` in DataTables to ensure naming
			 * consistency. `dataProp` can still be used, as there is backwards
			 * compatibility in DataTables for this option, but it is strongly
			 * recommended that you use `data` in preference to `dataProp`.
			 *  @name DataTable.defaults.column.dataProp
			 */
		
		
			/**
			 * This property can be used to read data from any data source property,
			 * including deeply nested objects / properties. `data` can be given in a
			 * number of different ways which effect its behaviour:
			 *
			 * * `integer` - treated as an array index for the data source. This is the
			 *   default that DataTables uses (incrementally increased for each column).
			 * * `string` - read an object property from the data source. There are
			 *   three 'special' options that can be used in the string to alter how
			 *   DataTables reads the data from the source object:
			 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
			 *      Javascript to read from nested objects, so to can the options
			 *      specified in `data`. For example: `browser.version` or
			 *      `browser.name`. If your object parameter name contains a period, use
			 *      `\\` to escape it - i.e. `first\\.name`.
			 *    * `[]` - Array notation. DataTables can automatically combine data
			 *      from and array source, joining the data with the characters provided
			 *      between the two brackets. For example: `name[, ]` would provide a
			 *      comma-space separated list from the source array. If no characters
			 *      are provided between the brackets, the original array source is
			 *      returned.
			 *    * `()` - Function notation. Adding `()` to the end of a parameter will
			 *      execute a function of the name given. For example: `browser()` for a
			 *      simple function on the data source, `browser.version()` for a
			 *      function in a nested property or even `browser().version` to get an
			 *      object property if the function called returns an object. Note that
			 *      function notation is recommended for use in `render` rather than
			 *      `data` as it is much simpler to use as a renderer.
			 * * `null` - use the original data source for the row rather than plucking
			 *   data directly from it. This action has effects on two other
			 *   initialisation options:
			 *    * `defaultContent` - When null is given as the `data` option and
			 *      `defaultContent` is specified for the column, the value defined by
			 *      `defaultContent` will be used for the cell.
			 *    * `render` - When null is used for the `data` option and the `render`
			 *      option is specified for the column, the whole data source for the
			 *      row is used for the renderer.
			 * * `function` - the function given will be executed whenever DataTables
			 *   needs to set or get the data for a cell in the column. The function
			 *   takes three parameters:
			 *    * Parameters:
			 *      * `{array|object}` The data source for the row
			 *      * `{string}` The type call data requested - this will be 'set' when
			 *        setting data or 'filter', 'display', 'type', 'sort' or undefined
			 *        when gathering data. Note that when `undefined` is given for the
			 *        type DataTables expects to get the raw data for the object back<
			 *      * `{*}` Data to set when the second parameter is 'set'.
			 *    * Return:
			 *      * The return value from the function is not required when 'set' is
			 *        the type of call, but otherwise the return is what will be used
			 *        for the data requested.
			 *
			 * Note that `data` is a getter and setter option. If you just require
			 * formatting of data for output, you will likely want to use `render` which
			 * is simply a getter and thus simpler to use.
			 *
			 * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
			 * name change reflects the flexibility of this property and is consistent
			 * with the naming of mRender. If 'mDataProp' is given, then it will still
			 * be used by DataTables, as it automatically maps the old name to the new
			 * if required.
			 *
			 *  @type string|int|function|null
			 *  @default null <i>Use automatically calculated column index</i>
			 *
			 *  @name DataTable.defaults.column.data
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Read table data from objects
			 *    // JSON structure for each row:
			 *    //   {
			 *    //      "engine": {value},
			 *    //      "browser": {value},
			 *    //      "platform": {value},
			 *    //      "version": {value},
			 *    //      "grade": {value}
			 *    //   }
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "ajaxSource": "sources/objects.txt",
			 *        "columns": [
			 *          { "data": "engine" },
			 *          { "data": "browser" },
			 *          { "data": "platform" },
			 *          { "data": "version" },
			 *          { "data": "grade" }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Read information from deeply nested objects
			 *    // JSON structure for each row:
			 *    //   {
			 *    //      "engine": {value},
			 *    //      "browser": {value},
			 *    //      "platform": {
			 *    //         "inner": {value}
			 *    //      },
			 *    //      "details": [
			 *    //         {value}, {value}
			 *    //      ]
			 *    //   }
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "ajaxSource": "sources/deep.txt",
			 *        "columns": [
			 *          { "data": "engine" },
			 *          { "data": "browser" },
			 *          { "data": "platform.inner" },
			 *          { "data": "details.0" },
			 *          { "data": "details.1" }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `data` as a function to provide different information for
			 *    // sorting, filtering and display. In this case, currency (price)
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [ {
			 *          "targets": [ 0 ],
			 *          "data": function ( source, type, val ) {
			 *            if (type === 'set') {
			 *              source.price = val;
			 *              // Store the computed dislay and filter values for efficiency
			 *              source.price_display = val=="" ? "" : "$"+numberFormat(val);
			 *              source.price_filter  = val=="" ? "" : "$"+numberFormat(val)+" "+val;
			 *              return;
			 *            }
			 *            else if (type === 'display') {
			 *              return source.price_display;
			 *            }
			 *            else if (type === 'filter') {
			 *              return source.price_filter;
			 *            }
			 *            // 'sort', 'type' and undefined all just use the integer
			 *            return source.price;
			 *          }
			 *        } ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using default content
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [ {
			 *          "targets": [ 0 ],
			 *          "data": null,
			 *          "defaultContent": "Click to edit"
			 *        } ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using array notation - outputting a list from an array
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [ {
			 *          "targets": [ 0 ],
			 *          "data": "name[, ]"
			 *        } ]
			 *      } );
			 *    } );
			 *
			 */
			"mData": null,
		
		
			/**
			 * This property is the rendering partner to `data` and it is suggested that
			 * when you want to manipulate data for display (including filtering,
			 * sorting etc) without altering the underlying data for the table, use this
			 * property. `render` can be considered to be the the read only companion to
			 * `data` which is read / write (then as such more complex). Like `data`
			 * this option can be given in a number of different ways to effect its
			 * behaviour:
			 *
			 * * `integer` - treated as an array index for the data source. This is the
			 *   default that DataTables uses (incrementally increased for each column).
			 * * `string` - read an object property from the data source. There are
			 *   three 'special' options that can be used in the string to alter how
			 *   DataTables reads the data from the source object:
			 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
			 *      Javascript to read from nested objects, so to can the options
			 *      specified in `data`. For example: `browser.version` or
			 *      `browser.name`. If your object parameter name contains a period, use
			 *      `\\` to escape it - i.e. `first\\.name`.
			 *    * `[]` - Array notation. DataTables can automatically combine data
			 *      from and array source, joining the data with the characters provided
			 *      between the two brackets. For example: `name[, ]` would provide a
			 *      comma-space separated list from the source array. If no characters
			 *      are provided between the brackets, the original array source is
			 *      returned.
			 *    * `()` - Function notation. Adding `()` to the end of a parameter will
			 *      execute a function of the name given. For example: `browser()` for a
			 *      simple function on the data source, `browser.version()` for a
			 *      function in a nested property or even `browser().version` to get an
			 *      object property if the function called returns an object.
			 * * `object` - use different data for the different data types requested by
			 *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
			 *   of the object is the data type the property refers to and the value can
			 *   defined using an integer, string or function using the same rules as
			 *   `render` normally does. Note that an `_` option _must_ be specified.
			 *   This is the default value to use if you haven't specified a value for
			 *   the data type requested by DataTables.
			 * * `function` - the function given will be executed whenever DataTables
			 *   needs to set or get the data for a cell in the column. The function
			 *   takes three parameters:
			 *    * Parameters:
			 *      * {array|object} The data source for the row (based on `data`)
			 *      * {string} The type call data requested - this will be 'filter',
			 *        'display', 'type' or 'sort'.
			 *      * {array|object} The full data source for the row (not based on
			 *        `data`)
			 *    * Return:
			 *      * The return value from the function is what will be used for the
			 *        data requested.
			 *
			 *  @type string|int|function|object|null
			 *  @default null Use the data source value.
			 *
			 *  @name DataTable.defaults.column.render
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Create a comma separated list from an array of objects
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "ajaxSource": "sources/deep.txt",
			 *        "columns": [
			 *          { "data": "engine" },
			 *          { "data": "browser" },
			 *          {
			 *            "data": "platform",
			 *            "render": "[, ].name"
			 *          }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Execute a function to obtain data
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [ {
			 *          "targets": [ 0 ],
			 *          "data": null, // Use the full data source object for the renderer's source
			 *          "render": "browserName()"
			 *        } ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // As an object, extracting different data for the different types
			 *    // This would be used with a data source such as:
			 *    //   { "phone": 5552368, "phone_filter": "5552368 555-2368", "phone_display": "555-2368" }
			 *    // Here the `phone` integer is used for sorting and type detection, while `phone_filter`
			 *    // (which has both forms) is used for filtering for if a user inputs either format, while
			 *    // the formatted phone number is the one that is shown in the table.
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [ {
			 *          "targets": [ 0 ],
			 *          "data": null, // Use the full data source object for the renderer's source
			 *          "render": {
			 *            "_": "phone",
			 *            "filter": "phone_filter",
			 *            "display": "phone_display"
			 *          }
			 *        } ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Use as a function to create a link from the data source
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [ {
			 *          "targets": [ 0 ],
			 *          "data": "download_link",
			 *          "render": function ( data, type, full ) {
			 *            return '<a href="'+data+'">Download</a>';
			 *          }
			 *        } ]
			 *      } );
			 *    } );
			 */
			"mRender": null,
		
		
			/**
			 * Change the cell type created for the column - either TD cells or TH cells. This
			 * can be useful as TH cells have semantic meaning in the table body, allowing them
			 * to act as a header for a row (you may wish to add scope='row' to the TH elements).
			 *  @type string
			 *  @default td
			 *
			 *  @name DataTable.defaults.column.cellType
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Make the first column use TH cells
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [ {
			 *          "targets": [ 0 ],
			 *          "cellType": "th"
			 *        } ]
			 *      } );
			 *    } );
			 */
			"sCellType": "td",
		
		
			/**
			 * Class to give to each cell in this column.
			 *  @type string
			 *  @default <i>Empty string</i>
			 *
			 *  @name DataTable.defaults.column.class
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "class": "my_class", "targets": [ 0 ] }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "class": "my_class" },
			 *          null,
			 *          null,
			 *          null,
			 *          null
			 *        ]
			 *      } );
			 *    } );
			 */
			"sClass": "",
		
			/**
			 * When DataTables calculates the column widths to assign to each column,
			 * it finds the longest string in each column and then constructs a
			 * temporary table and reads the widths from that. The problem with this
			 * is that "mmm" is much wider then "iiii", but the latter is a longer
			 * string - thus the calculation can go wrong (doing it properly and putting
			 * it into an DOM object and measuring that is horribly(!) slow). Thus as
			 * a "work around" we provide this option. It will append its value to the
			 * text that is found to be the longest string for the column - i.e. padding.
			 * Generally you shouldn't need this!
			 *  @type string
			 *  @default <i>Empty string<i>
			 *
			 *  @name DataTable.defaults.column.contentPadding
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          null,
			 *          null,
			 *          null,
			 *          {
			 *            "contentPadding": "mmm"
			 *          }
			 *        ]
			 *      } );
			 *    } );
			 */
			"sContentPadding": "",
		
		
			/**
			 * Allows a default value to be given for a column's data, and will be used
			 * whenever a null data source is encountered (this can be because `data`
			 * is set to null, or because the data source itself is null).
			 *  @type string
			 *  @default null
			 *
			 *  @name DataTable.defaults.column.defaultContent
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          {
			 *            "data": null,
			 *            "defaultContent": "Edit",
			 *            "targets": [ -1 ]
			 *          }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          null,
			 *          null,
			 *          null,
			 *          {
			 *            "data": null,
			 *            "defaultContent": "Edit"
			 *          }
			 *        ]
			 *      } );
			 *    } );
			 */
			"sDefaultContent": null,
		
		
			/**
			 * This parameter is only used in DataTables' server-side processing. It can
			 * be exceptionally useful to know what columns are being displayed on the
			 * client side, and to map these to database fields. When defined, the names
			 * also allow DataTables to reorder information from the server if it comes
			 * back in an unexpected order (i.e. if you switch your columns around on the
			 * client-side, your server-side code does not also need updating).
			 *  @type string
			 *  @default <i>Empty string</i>
			 *
			 *  @name DataTable.defaults.column.name
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "name": "engine", "targets": [ 0 ] },
			 *          { "name": "browser", "targets": [ 1 ] },
			 *          { "name": "platform", "targets": [ 2 ] },
			 *          { "name": "version", "targets": [ 3 ] },
			 *          { "name": "grade", "targets": [ 4 ] }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "name": "engine" },
			 *          { "name": "browser" },
			 *          { "name": "platform" },
			 *          { "name": "version" },
			 *          { "name": "grade" }
			 *        ]
			 *      } );
			 *    } );
			 */
			"sName": "",
		
		
			/**
			 * Defines a data source type for the ordering which can be used to read
			 * real-time information from the table (updating the internally cached
			 * version) prior to ordering. This allows ordering to occur on user
			 * editable elements such as form inputs.
			 *  @type string
			 *  @default std
			 *
			 *  @name DataTable.defaults.column.orderDataType
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "orderDataType": "dom-text", "targets": [ 2, 3 ] },
			 *          { "type": "numeric", "targets": [ 3 ] },
			 *          { "orderDataType": "dom-select", "targets": [ 4 ] },
			 *          { "orderDataType": "dom-checkbox", "targets": [ 5 ] }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          null,
			 *          null,
			 *          { "orderDataType": "dom-text" },
			 *          { "orderDataType": "dom-text", "type": "numeric" },
			 *          { "orderDataType": "dom-select" },
			 *          { "orderDataType": "dom-checkbox" }
			 *        ]
			 *      } );
			 *    } );
			 */
			"sSortDataType": "std",
		
		
			/**
			 * The title of this column.
			 *  @type string
			 *  @default null <i>Derived from the 'TH' value for this column in the
			 *    original HTML table.</i>
			 *
			 *  @name DataTable.defaults.column.title
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "title": "My column title", "targets": [ 0 ] }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "title": "My column title" },
			 *          null,
			 *          null,
			 *          null,
			 *          null
			 *        ]
			 *      } );
			 *    } );
			 */
			"sTitle": null,
		
		
			/**
			 * The type allows you to specify how the data for this column will be
			 * ordered. Four types (string, numeric, date and html (which will strip
			 * HTML tags before ordering)) are currently available. Note that only date
			 * formats understood by Javascript's Date() object will be accepted as type
			 * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
			 * 'numeric', 'date' or 'html' (by default). Further types can be adding
			 * through plug-ins.
			 *  @type string
			 *  @default null <i>Auto-detected from raw data</i>
			 *
			 *  @name DataTable.defaults.column.type
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "type": "html", "targets": [ 0 ] }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "type": "html" },
			 *          null,
			 *          null,
			 *          null,
			 *          null
			 *        ]
			 *      } );
			 *    } );
			 */
			"sType": null,
		
		
			/**
			 * Defining the width of the column, this parameter may take any CSS value
			 * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
			 * been given a specific width through this interface ensuring that the table
			 * remains readable.
			 *  @type string
			 *  @default null <i>Automatic</i>
			 *
			 *  @name DataTable.defaults.column.width
			 *  @dtopt Columns
			 *
			 *  @example
			 *    // Using `columnDefs`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columnDefs": [
			 *          { "width": "20%", "targets": [ 0 ] }
			 *        ]
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Using `columns`
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "columns": [
			 *          { "width": "20%" },
			 *          null,
			 *          null,
			 *          null,
			 *          null
			 *        ]
			 *      } );
			 *    } );
			 */
			"sWidth": null
		};
		
		_fnHungarianMap( DataTable.defaults.column );
		
		
		
		/**
		 * DataTables settings object - this holds all the information needed for a
		 * given table, including configuration, data and current application of the
		 * table options. DataTables does not have a single instance for each DataTable
		 * with the settings attached to that instance, but rather instances of the
		 * DataTable "class" are created on-the-fly as needed (typically by a
		 * $().dataTable() call) and the settings object is then applied to that
		 * instance.
		 *
		 * Note that this object is related to {@link DataTable.defaults} but this
		 * one is the internal data store for DataTables's cache of columns. It should
		 * NOT be manipulated outside of DataTables. Any configuration should be done
		 * through the initialisation options.
		 *  @namespace
		 *  @todo Really should attach the settings object to individual instances so we
		 *    don't need to create new instances on each $().dataTable() call (if the
		 *    table already exists). It would also save passing oSettings around and
		 *    into every single function. However, this is a very significant
		 *    architecture change for DataTables and will almost certainly break
		 *    backwards compatibility with older installations. This is something that
		 *    will be done in 2.0.
		 */
		DataTable.models.oSettings = {
			/**
			 * Primary features of DataTables and their enablement state.
			 *  @namespace
			 */
			"oFeatures": {
		
				/**
				 * Flag to say if DataTables should automatically try to calculate the
				 * optimum table and columns widths (true) or not (false).
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bAutoWidth": null,
		
				/**
				 * Delay the creation of TR and TD elements until they are actually
				 * needed by a driven page draw. This can give a significant speed
				 * increase for Ajax source and Javascript source data, but makes no
				 * difference at all fro DOM and server-side processing tables.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bDeferRender": null,
		
				/**
				 * Enable filtering on the table or not. Note that if this is disabled
				 * then there is no filtering at all on the table, including fnFilter.
				 * To just remove the filtering input use sDom and remove the 'f' option.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bFilter": null,
		
				/**
				 * Table information element (the 'Showing x of y records' div) enable
				 * flag.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bInfo": null,
		
				/**
				 * Present a user control allowing the end user to change the page size
				 * when pagination is enabled.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bLengthChange": null,
		
				/**
				 * Pagination enabled or not. Note that if this is disabled then length
				 * changing must also be disabled.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bPaginate": null,
		
				/**
				 * Processing indicator enable flag whenever DataTables is enacting a
				 * user request - typically an Ajax request for server-side processing.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bProcessing": null,
		
				/**
				 * Server-side processing enabled flag - when enabled DataTables will
				 * get all data from the server for every draw - there is no filtering,
				 * sorting or paging done on the client-side.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bServerSide": null,
		
				/**
				 * Sorting enablement flag.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bSort": null,
		
				/**
				 * Multi-column sorting
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bSortMulti": null,
		
				/**
				 * Apply a class to the columns which are being sorted to provide a
				 * visual highlight or not. This can slow things down when enabled since
				 * there is a lot of DOM interaction.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bSortClasses": null,
		
				/**
				 * State saving enablement flag.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bStateSave": null
			},
		
		
			/**
			 * Scrolling settings for a table.
			 *  @namespace
			 */
			"oScroll": {
				/**
				 * When the table is shorter in height than sScrollY, collapse the
				 * table container down to the height of the table (when true).
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type boolean
				 */
				"bCollapse": null,
		
				/**
				 * Width of the scrollbar for the web-browser's platform. Calculated
				 * during table initialisation.
				 *  @type int
				 *  @default 0
				 */
				"iBarWidth": 0,
		
				/**
				 * Viewport width for horizontal scrolling. Horizontal scrolling is
				 * disabled if an empty string.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type string
				 */
				"sX": null,
		
				/**
				 * Width to expand the table to when using x-scrolling. Typically you
				 * should not need to use this.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type string
				 *  @deprecated
				 */
				"sXInner": null,
		
				/**
				 * Viewport height for vertical scrolling. Vertical scrolling is disabled
				 * if an empty string.
				 * Note that this parameter will be set by the initialisation routine. To
				 * set a default use {@link DataTable.defaults}.
				 *  @type string
				 */
				"sY": null
			},
		
			/**
			 * Language information for the table.
			 *  @namespace
			 *  @extends DataTable.defaults.oLanguage
			 */
			"oLanguage": {
				/**
				 * Information callback function. See
				 * {@link DataTable.defaults.fnInfoCallback}
				 *  @type function
				 *  @default null
				 */
				"fnInfoCallback": null
			},
		
			/**
			 * Browser support parameters
			 *  @namespace
			 */
			"oBrowser": {
				/**
				 * Indicate if the browser incorrectly calculates width:100% inside a
				 * scrolling element (IE6/7)
				 *  @type boolean
				 *  @default false
				 */
				"bScrollOversize": false,
		
				/**
				 * Determine if the vertical scrollbar is on the right or left of the
				 * scrolling container - needed for rtl language layout, although not
				 * all browsers move the scrollbar (Safari).
				 *  @type boolean
				 *  @default false
				 */
				"bScrollbarLeft": false,
		
				/**
				 * Flag for if `getBoundingClientRect` is fully supported or not
				 *  @type boolean
				 *  @default false
				 */
				"bBounding": false,
		
				/**
				 * Browser scrollbar width
				 *  @type integer
				 *  @default 0
				 */
				"barWidth": 0
			},
		
		
			"ajax": null,
		
		
			/**
			 * Array referencing the nodes which are used for the features. The
			 * parameters of this object match what is allowed by sDom - i.e.
			 *   <ul>
			 *     <li>'l' - Length changing</li>
			 *     <li>'f' - Filtering input</li>
			 *     <li>'t' - The table!</li>
			 *     <li>'i' - Information</li>
			 *     <li>'p' - Pagination</li>
			 *     <li>'r' - pRocessing</li>
			 *   </ul>
			 *  @type array
			 *  @default []
			 */
			"aanFeatures": [],
		
			/**
			 * Store data information - see {@link DataTable.models.oRow} for detailed
			 * information.
			 *  @type array
			 *  @default []
			 */
			"aoData": [],
		
			/**
			 * Array of indexes which are in the current display (after filtering etc)
			 *  @type array
			 *  @default []
			 */
			"aiDisplay": [],
		
			/**
			 * Array of indexes for display - no filtering
			 *  @type array
			 *  @default []
			 */
			"aiDisplayMaster": [],
		
			/**
			 * Map of row ids to data indexes
			 *  @type object
			 *  @default {}
			 */
			"aIds": {},
		
			/**
			 * Store information about each column that is in use
			 *  @type array
			 *  @default []
			 */
			"aoColumns": [],
		
			/**
			 * Store information about the table's header
			 *  @type array
			 *  @default []
			 */
			"aoHeader": [],
		
			/**
			 * Store information about the table's footer
			 *  @type array
			 *  @default []
			 */
			"aoFooter": [],
		
			/**
			 * Store the applied global search information in case we want to force a
			 * research or compare the old search to a new one.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @namespace
			 *  @extends DataTable.models.oSearch
			 */
			"oPreviousSearch": {},
		
			/**
			 * Store the applied search for each column - see
			 * {@link DataTable.models.oSearch} for the format that is used for the
			 * filtering information for each column.
			 *  @type array
			 *  @default []
			 */
			"aoPreSearchCols": [],
		
			/**
			 * Sorting that is applied to the table. Note that the inner arrays are
			 * used in the following manner:
			 * <ul>
			 *   <li>Index 0 - column number</li>
			 *   <li>Index 1 - current sorting direction</li>
			 * </ul>
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type array
			 *  @todo These inner arrays should really be objects
			 */
			"aaSorting": null,
		
			/**
			 * Sorting that is always applied to the table (i.e. prefixed in front of
			 * aaSorting).
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type array
			 *  @default []
			 */
			"aaSortingFixed": [],
		
			/**
			 * Classes to use for the striping of a table.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type array
			 *  @default []
			 */
			"asStripeClasses": null,
		
			/**
			 * If restoring a table - we should restore its striping classes as well
			 *  @type array
			 *  @default []
			 */
			"asDestroyStripes": [],
		
			/**
			 * If restoring a table - we should restore its width
			 *  @type int
			 *  @default 0
			 */
			"sDestroyWidth": 0,
		
			/**
			 * Callback functions array for every time a row is inserted (i.e. on a draw).
			 *  @type array
			 *  @default []
			 */
			"aoRowCallback": [],
		
			/**
			 * Callback functions for the header on each draw.
			 *  @type array
			 *  @default []
			 */
			"aoHeaderCallback": [],
		
			/**
			 * Callback function for the footer on each draw.
			 *  @type array
			 *  @default []
			 */
			"aoFooterCallback": [],
		
			/**
			 * Array of callback functions for draw callback functions
			 *  @type array
			 *  @default []
			 */
			"aoDrawCallback": [],
		
			/**
			 * Array of callback functions for row created function
			 *  @type array
			 *  @default []
			 */
			"aoRowCreatedCallback": [],
		
			/**
			 * Callback functions for just before the table is redrawn. A return of
			 * false will be used to cancel the draw.
			 *  @type array
			 *  @default []
			 */
			"aoPreDrawCallback": [],
		
			/**
			 * Callback functions for when the table has been initialised.
			 *  @type array
			 *  @default []
			 */
			"aoInitComplete": [],
		
		
			/**
			 * Callbacks for modifying the settings to be stored for state saving, prior to
			 * saving state.
			 *  @type array
			 *  @default []
			 */
			"aoStateSaveParams": [],
		
			/**
			 * Callbacks for modifying the settings that have been stored for state saving
			 * prior to using the stored values to restore the state.
			 *  @type array
			 *  @default []
			 */
			"aoStateLoadParams": [],
		
			/**
			 * Callbacks for operating on the settings object once the saved state has been
			 * loaded
			 *  @type array
			 *  @default []
			 */
			"aoStateLoaded": [],
		
			/**
			 * Cache the table ID for quick access
			 *  @type string
			 *  @default <i>Empty string</i>
			 */
			"sTableId": "",
		
			/**
			 * The TABLE node for the main table
			 *  @type node
			 *  @default null
			 */
			"nTable": null,
		
			/**
			 * Permanent ref to the thead element
			 *  @type node
			 *  @default null
			 */
			"nTHead": null,
		
			/**
			 * Permanent ref to the tfoot element - if it exists
			 *  @type node
			 *  @default null
			 */
			"nTFoot": null,
		
			/**
			 * Permanent ref to the tbody element
			 *  @type node
			 *  @default null
			 */
			"nTBody": null,
		
			/**
			 * Cache the wrapper node (contains all DataTables controlled elements)
			 *  @type node
			 *  @default null
			 */
			"nTableWrapper": null,
		
			/**
			 * Indicate if when using server-side processing the loading of data
			 * should be deferred until the second draw.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 *  @default false
			 */
			"bDeferLoading": false,
		
			/**
			 * Indicate if all required information has been read in
			 *  @type boolean
			 *  @default false
			 */
			"bInitialised": false,
		
			/**
			 * Information about open rows. Each object in the array has the parameters
			 * 'nTr' and 'nParent'
			 *  @type array
			 *  @default []
			 */
			"aoOpenRows": [],
		
			/**
			 * Dictate the positioning of DataTables' control elements - see
			 * {@link DataTable.model.oInit.sDom}.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 *  @default null
			 */
			"sDom": null,
		
			/**
			 * Search delay (in mS)
			 *  @type integer
			 *  @default null
			 */
			"searchDelay": null,
		
			/**
			 * Which type of pagination should be used.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 *  @default two_button
			 */
			"sPaginationType": "two_button",
		
			/**
			 * The state duration (for `stateSave`) in seconds.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type int
			 *  @default 0
			 */
			"iStateDuration": 0,
		
			/**
			 * Array of callback functions for state saving. Each array element is an
			 * object with the following parameters:
			 *   <ul>
			 *     <li>function:fn - function to call. Takes two parameters, oSettings
			 *       and the JSON string to save that has been thus far created. Returns
			 *       a JSON string to be inserted into a json object
			 *       (i.e. '"param": [ 0, 1, 2]')</li>
			 *     <li>string:sName - name of callback</li>
			 *   </ul>
			 *  @type array
			 *  @default []
			 */
			"aoStateSave": [],
		
			/**
			 * Array of callback functions for state loading. Each array element is an
			 * object with the following parameters:
			 *   <ul>
			 *     <li>function:fn - function to call. Takes two parameters, oSettings
			 *       and the object stored. May return false to cancel state loading</li>
			 *     <li>string:sName - name of callback</li>
			 *   </ul>
			 *  @type array
			 *  @default []
			 */
			"aoStateLoad": [],
		
			/**
			 * State that was saved. Useful for back reference
			 *  @type object
			 *  @default null
			 */
			"oSavedState": null,
		
			/**
			 * State that was loaded. Useful for back reference
			 *  @type object
			 *  @default null
			 */
			"oLoadedState": null,
		
			/**
			 * Source url for AJAX data for the table.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 *  @default null
			 */
			"sAjaxSource": null,
		
			/**
			 * Property from a given object from which to read the table data from. This
			 * can be an empty string (when not server-side processing), in which case
			 * it is  assumed an an array is given directly.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 */
			"sAjaxDataProp": null,
		
			/**
			 * Note if draw should be blocked while getting data
			 *  @type boolean
			 *  @default true
			 */
			"bAjaxDataGet": true,
		
			/**
			 * The last jQuery XHR object that was used for server-side data gathering.
			 * This can be used for working with the XHR information in one of the
			 * callbacks
			 *  @type object
			 *  @default null
			 */
			"jqXHR": null,
		
			/**
			 * JSON returned from the server in the last Ajax request
			 *  @type object
			 *  @default undefined
			 */
			"json": undefined,
		
			/**
			 * Data submitted as part of the last Ajax request
			 *  @type object
			 *  @default undefined
			 */
			"oAjaxData": undefined,
		
			/**
			 * Function to get the server-side data.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type function
			 */
			"fnServerData": null,
		
			/**
			 * Functions which are called prior to sending an Ajax request so extra
			 * parameters can easily be sent to the server
			 *  @type array
			 *  @default []
			 */
			"aoServerParams": [],
		
			/**
			 * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
			 * required).
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 */
			"sServerMethod": null,
		
			/**
			 * Format numbers for display.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type function
			 */
			"fnFormatNumber": null,
		
			/**
			 * List of options that can be used for the user selectable length menu.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type array
			 *  @default []
			 */
			"aLengthMenu": null,
		
			/**
			 * Counter for the draws that the table does. Also used as a tracker for
			 * server-side processing
			 *  @type int
			 *  @default 0
			 */
			"iDraw": 0,
		
			/**
			 * Indicate if a redraw is being done - useful for Ajax
			 *  @type boolean
			 *  @default false
			 */
			"bDrawing": false,
		
			/**
			 * Draw index (iDraw) of the last error when parsing the returned data
			 *  @type int
			 *  @default -1
			 */
			"iDrawError": -1,
		
			/**
			 * Paging display length
			 *  @type int
			 *  @default 10
			 */
			"_iDisplayLength": 10,
		
			/**
			 * Paging start point - aiDisplay index
			 *  @type int
			 *  @default 0
			 */
			"_iDisplayStart": 0,
		
			/**
			 * Server-side processing - number of records in the result set
			 * (i.e. before filtering), Use fnRecordsTotal rather than
			 * this property to get the value of the number of records, regardless of
			 * the server-side processing setting.
			 *  @type int
			 *  @default 0
			 *  @private
			 */
			"_iRecordsTotal": 0,
		
			/**
			 * Server-side processing - number of records in the current display set
			 * (i.e. after filtering). Use fnRecordsDisplay rather than
			 * this property to get the value of the number of records, regardless of
			 * the server-side processing setting.
			 *  @type boolean
			 *  @default 0
			 *  @private
			 */
			"_iRecordsDisplay": 0,
		
			/**
			 * The classes to use for the table
			 *  @type object
			 *  @default {}
			 */
			"oClasses": {},
		
			/**
			 * Flag attached to the settings object so you can check in the draw
			 * callback if filtering has been done in the draw. Deprecated in favour of
			 * events.
			 *  @type boolean
			 *  @default false
			 *  @deprecated
			 */
			"bFiltered": false,
		
			/**
			 * Flag attached to the settings object so you can check in the draw
			 * callback if sorting has been done in the draw. Deprecated in favour of
			 * events.
			 *  @type boolean
			 *  @default false
			 *  @deprecated
			 */
			"bSorted": false,
		
			/**
			 * Indicate that if multiple rows are in the header and there is more than
			 * one unique cell per column, if the top one (true) or bottom one (false)
			 * should be used for sorting / title by DataTables.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bSortCellsTop": null,
		
			/**
			 * Initialisation object that is used for the table
			 *  @type object
			 *  @default null
			 */
			"oInit": null,
		
			/**
			 * Destroy callback functions - for plug-ins to attach themselves to the
			 * destroy so they can clean up markup and events.
			 *  @type array
			 *  @default []
			 */
			"aoDestroyCallback": [],
		
		
			/**
			 * Get the number of records in the current record set, before filtering
			 *  @type function
			 */
			"fnRecordsTotal": function ()
			{
				return _fnDataSource( this ) == 'ssp' ?
					this._iRecordsTotal * 1 :
					this.aiDisplayMaster.length;
			},
		
			/**
			 * Get the number of records in the current record set, after filtering
			 *  @type function
			 */
			"fnRecordsDisplay": function ()
			{
				return _fnDataSource( this ) == 'ssp' ?
					this._iRecordsDisplay * 1 :
					this.aiDisplay.length;
			},
		
			/**
			 * Get the display end point - aiDisplay index
			 *  @type function
			 */
			"fnDisplayEnd": function ()
			{
				var
					len      = this._iDisplayLength,
					start    = this._iDisplayStart,
					calc     = start + len,
					records  = this.aiDisplay.length,
					features = this.oFeatures,
					paginate = features.bPaginate;
		
				if ( features.bServerSide ) {
					return paginate === false || len === -1 ?
						start + records :
						Math.min( start+len, this._iRecordsDisplay );
				}
				else {
					return ! paginate || calc>records || len===-1 ?
						records :
						calc;
				}
			},
		
			/**
			 * The DataTables object for this table
			 *  @type object
			 *  @default null
			 */
			"oInstance": null,
		
			/**
			 * Unique identifier for each instance of the DataTables object. If there
			 * is an ID on the table node, then it takes that value, otherwise an
			 * incrementing internal counter is used.
			 *  @type string
			 *  @default null
			 */
			"sInstance": null,
		
			/**
			 * tabindex attribute value that is added to DataTables control elements, allowing
			 * keyboard navigation of the table and its controls.
			 */
			"iTabIndex": 0,
		
			/**
			 * DIV container for the footer scrolling table if scrolling
			 */
			"nScrollHead": null,
		
			/**
			 * DIV container for the footer scrolling table if scrolling
			 */
			"nScrollFoot": null,
		
			/**
			 * Last applied sort
			 *  @type array
			 *  @default []
			 */
			"aLastSort": [],
		
			/**
			 * Stored plug-in instances
			 *  @type object
			 *  @default {}
			 */
			"oPlugins": {},
		
			/**
			 * Function used to get a row's id from the row's data
			 *  @type function
			 *  @default null
			 */
			"rowIdFn": null,
		
			/**
			 * Data location where to store a row's id
			 *  @type string
			 *  @default null
			 */
			"rowId": null
		};
	
		/**
		 * Extension object for DataTables that is used to provide all extension
		 * options.
		 *
		 * Note that the `DataTable.ext` object is available through
		 * `jQuery.fn.dataTable.ext` where it may be accessed and manipulated. It is
		 * also aliased to `jQuery.fn.dataTableExt` for historic reasons.
		 *  @namespace
		 *  @extends DataTable.models.ext
		 */
		
		
		/**
		 * DataTables extensions
		 * 
		 * This namespace acts as a collection area for plug-ins that can be used to
		 * extend DataTables capabilities. Indeed many of the build in methods
		 * use this method to provide their own capabilities (sorting methods for
		 * example).
		 *
		 * Note that this namespace is aliased to `jQuery.fn.dataTableExt` for legacy
		 * reasons
		 *
		 *  @namespace
		 */
		DataTable.ext = _ext = {
			/**
			 * Buttons. For use with the Buttons extension for DataTables. This is
			 * defined here so other extensions can define buttons regardless of load
			 * order. It is _not_ used by DataTables core.
			 *
			 *  @type object
			 *  @default {}
			 */
			buttons: {},
		
		
			/**
			 * Element class names
			 *
			 *  @type object
			 *  @default {}
			 */
			classes: {},
		
		
			/**
			 * DataTables build type (expanded by the download builder)
			 *
			 *  @type string
			 */
			builder: "-source-",
		
		
			/**
			 * Error reporting.
			 * 
			 * How should DataTables report an error. Can take the value 'alert',
			 * 'throw', 'none' or a function.
			 *
			 *  @type string|function
			 *  @default alert
			 */
			errMode: "alert",
		
		
			/**
			 * Feature plug-ins.
			 * 
			 * This is an array of objects which describe the feature plug-ins that are
			 * available to DataTables. These feature plug-ins are then available for
			 * use through the `dom` initialisation option.
			 * 
			 * Each feature plug-in is described by an object which must have the
			 * following properties:
			 * 
			 * * `fnInit` - function that is used to initialise the plug-in,
			 * * `cFeature` - a character so the feature can be enabled by the `dom`
			 *   instillation option. This is case sensitive.
			 *
			 * The `fnInit` function has the following input parameters:
			 *
			 * 1. `{object}` DataTables settings object: see
			 *    {@link DataTable.models.oSettings}
			 *
			 * And the following return is expected:
			 * 
			 * * {node|null} The element which contains your feature. Note that the
			 *   return may also be void if your plug-in does not require to inject any
			 *   DOM elements into DataTables control (`dom`) - for example this might
			 *   be useful when developing a plug-in which allows table control via
			 *   keyboard entry
			 *
			 *  @type array
			 *
			 *  @example
			 *    $.fn.dataTable.ext.features.push( {
			 *      "fnInit": function( oSettings ) {
			 *        return new TableTools( { "oDTSettings": oSettings } );
			 *      },
			 *      "cFeature": "T"
			 *    } );
			 */
			feature: [],
		
		
			/**
			 * Row searching.
			 * 
			 * This method of searching is complimentary to the default type based
			 * searching, and a lot more comprehensive as it allows you complete control
			 * over the searching logic. Each element in this array is a function
			 * (parameters described below) that is called for every row in the table,
			 * and your logic decides if it should be included in the searching data set
			 * or not.
			 *
			 * Searching functions have the following input parameters:
			 *
			 * 1. `{object}` DataTables settings object: see
			 *    {@link DataTable.models.oSettings}
			 * 2. `{array|object}` Data for the row to be processed (same as the
			 *    original format that was passed in as the data source, or an array
			 *    from a DOM data source
			 * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
			 *    can be useful to retrieve the `TR` element if you need DOM interaction.
			 *
			 * And the following return is expected:
			 *
			 * * {boolean} Include the row in the searched result set (true) or not
			 *   (false)
			 *
			 * Note that as with the main search ability in DataTables, technically this
			 * is "filtering", since it is subtractive. However, for consistency in
			 * naming we call it searching here.
			 *
			 *  @type array
			 *  @default []
			 *
			 *  @example
			 *    // The following example shows custom search being applied to the
			 *    // fourth column (i.e. the data[3] index) based on two input values
			 *    // from the end-user, matching the data in a certain range.
			 *    $.fn.dataTable.ext.search.push(
			 *      function( settings, data, dataIndex ) {
			 *        var min = document.getElementById('min').value * 1;
			 *        var max = document.getElementById('max').value * 1;
			 *        var version = data[3] == "-" ? 0 : data[3]*1;
			 *
			 *        if ( min == "" && max == "" ) {
			 *          return true;
			 *        }
			 *        else if ( min == "" && version < max ) {
			 *          return true;
			 *        }
			 *        else if ( min < version && "" == max ) {
			 *          return true;
			 *        }
			 *        else if ( min < version && version < max ) {
			 *          return true;
			 *        }
			 *        return false;
			 *      }
			 *    );
			 */
			search: [],
		
		
			/**
			 * Selector extensions
			 *
			 * The `selector` option can be used to extend the options available for the
			 * selector modifier options (`selector-modifier` object data type) that
			 * each of the three built in selector types offer (row, column and cell +
			 * their plural counterparts). For example the Select extension uses this
			 * mechanism to provide an option to select only rows, columns and cells
			 * that have been marked as selected by the end user (`{selected: true}`),
			 * which can be used in conjunction with the existing built in selector
			 * options.
			 *
			 * Each property is an array to which functions can be pushed. The functions
			 * take three attributes:
			 *
			 * * Settings object for the host table
			 * * Options object (`selector-modifier` object type)
			 * * Array of selected item indexes
			 *
			 * The return is an array of the resulting item indexes after the custom
			 * selector has been applied.
			 *
			 *  @type object
			 */
			selector: {
				cell: [],
				column: [],
				row: []
			},
		
		
			/**
			 * Internal functions, exposed for used in plug-ins.
			 * 
			 * Please note that you should not need to use the internal methods for
			 * anything other than a plug-in (and even then, try to avoid if possible).
			 * The internal function may change between releases.
			 *
			 *  @type object
			 *  @default {}
			 */
			internal: {},
		
		
			/**
			 * Legacy configuration options. Enable and disable legacy options that
			 * are available in DataTables.
			 *
			 *  @type object
			 */
			legacy: {
				/**
				 * Enable / disable DataTables 1.9 compatible server-side processing
				 * requests
				 *
				 *  @type boolean
				 *  @default null
				 */
				ajax: null
			},
		
		
			/**
			 * Pagination plug-in methods.
			 * 
			 * Each entry in this object is a function and defines which buttons should
			 * be shown by the pagination rendering method that is used for the table:
			 * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
			 * buttons are displayed in the document, while the functions here tell it
			 * what buttons to display. This is done by returning an array of button
			 * descriptions (what each button will do).
			 *
			 * Pagination types (the four built in options and any additional plug-in
			 * options defined here) can be used through the `paginationType`
			 * initialisation parameter.
			 *
			 * The functions defined take two parameters:
			 *
			 * 1. `{int} page` The current page index
			 * 2. `{int} pages` The number of pages in the table
			 *
			 * Each function is expected to return an array where each element of the
			 * array can be one of:
			 *
			 * * `first` - Jump to first page when activated
			 * * `last` - Jump to last page when activated
			 * * `previous` - Show previous page when activated
			 * * `next` - Show next page when activated
			 * * `{int}` - Show page of the index given
			 * * `{array}` - A nested array containing the above elements to add a
			 *   containing 'DIV' element (might be useful for styling).
			 *
			 * Note that DataTables v1.9- used this object slightly differently whereby
			 * an object with two functions would be defined for each plug-in. That
			 * ability is still supported by DataTables 1.10+ to provide backwards
			 * compatibility, but this option of use is now decremented and no longer
			 * documented in DataTables 1.10+.
			 *
			 *  @type object
			 *  @default {}
			 *
			 *  @example
			 *    // Show previous, next and current page buttons only
			 *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
			 *      return [ 'previous', page, 'next' ];
			 *    };
			 */
			pager: {},
		
		
			renderer: {
				pageButton: {},
				header: {}
			},
		
		
			/**
			 * Ordering plug-ins - custom data source
			 * 
			 * The extension options for ordering of data available here is complimentary
			 * to the default type based ordering that DataTables typically uses. It
			 * allows much greater control over the the data that is being used to
			 * order a column, but is necessarily therefore more complex.
			 * 
			 * This type of ordering is useful if you want to do ordering based on data
			 * live from the DOM (for example the contents of an 'input' element) rather
			 * than just the static string that DataTables knows of.
			 * 
			 * The way these plug-ins work is that you create an array of the values you
			 * wish to be ordering for the column in question and then return that
			 * array. The data in the array much be in the index order of the rows in
			 * the table (not the currently ordering order!). Which order data gathering
			 * function is run here depends on the `dt-init columns.orderDataType`
			 * parameter that is used for the column (if any).
			 *
			 * The functions defined take two parameters:
			 *
			 * 1. `{object}` DataTables settings object: see
			 *    {@link DataTable.models.oSettings}
			 * 2. `{int}` Target column index
			 *
			 * Each function is expected to return an array:
			 *
			 * * `{array}` Data for the column to be ordering upon
			 *
			 *  @type array
			 *
			 *  @example
			 *    // Ordering using `input` node values
			 *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
			 *    {
			 *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
			 *        return $('input', td).val();
			 *      } );
			 *    }
			 */
			order: {},
		
		
			/**
			 * Type based plug-ins.
			 *
			 * Each column in DataTables has a type assigned to it, either by automatic
			 * detection or by direct assignment using the `type` option for the column.
			 * The type of a column will effect how it is ordering and search (plug-ins
			 * can also make use of the column type if required).
			 *
			 * @namespace
			 */
			type: {
				/**
				 * Type detection functions.
				 *
				 * The functions defined in this object are used to automatically detect
				 * a column's type, making initialisation of DataTables super easy, even
				 * when complex data is in the table.
				 *
				 * The functions defined take two parameters:
				 *
			     *  1. `{*}` Data from the column cell to be analysed
			     *  2. `{settings}` DataTables settings object. This can be used to
			     *     perform context specific type detection - for example detection
			     *     based on language settings such as using a comma for a decimal
			     *     place. Generally speaking the options from the settings will not
			     *     be required
				 *
				 * Each function is expected to return:
				 *
				 * * `{string|null}` Data type detected, or null if unknown (and thus
				 *   pass it on to the other type detection functions.
				 *
				 *  @type array
				 *
				 *  @example
				 *    // Currency type detection plug-in:
				 *    $.fn.dataTable.ext.type.detect.push(
				 *      function ( data, settings ) {
				 *        // Check the numeric part
				 *        if ( ! data.substring(1).match(/[0-9]/) ) {
				 *          return null;
				 *        }
				 *
				 *        // Check prefixed by currency
				 *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
				 *          return 'currency';
				 *        }
				 *        return null;
				 *      }
				 *    );
				 */
				detect: [],
		
		
				/**
				 * Type based search formatting.
				 *
				 * The type based searching functions can be used to pre-format the
				 * data to be search on. For example, it can be used to strip HTML
				 * tags or to de-format telephone numbers for numeric only searching.
				 *
				 * Note that is a search is not defined for a column of a given type,
				 * no search formatting will be performed.
				 * 
				 * Pre-processing of searching data plug-ins - When you assign the sType
				 * for a column (or have it automatically detected for you by DataTables
				 * or a type detection plug-in), you will typically be using this for
				 * custom sorting, but it can also be used to provide custom searching
				 * by allowing you to pre-processing the data and returning the data in
				 * the format that should be searched upon. This is done by adding
				 * functions this object with a parameter name which matches the sType
				 * for that target column. This is the corollary of <i>afnSortData</i>
				 * for searching data.
				 *
				 * The functions defined take a single parameter:
				 *
			     *  1. `{*}` Data from the column cell to be prepared for searching
				 *
				 * Each function is expected to return:
				 *
				 * * `{string|null}` Formatted string that will be used for the searching.
				 *
				 *  @type object
				 *  @default {}
				 *
				 *  @example
				 *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
				 *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
				 *    }
				 */
				search: {},
		
		
				/**
				 * Type based ordering.
				 *
				 * The column type tells DataTables what ordering to apply to the table
				 * when a column is sorted upon. The order for each type that is defined,
				 * is defined by the functions available in this object.
				 *
				 * Each ordering option can be described by three properties added to
				 * this object:
				 *
				 * * `{type}-pre` - Pre-formatting function
				 * * `{type}-asc` - Ascending order function
				 * * `{type}-desc` - Descending order function
				 *
				 * All three can be used together, only `{type}-pre` or only
				 * `{type}-asc` and `{type}-desc` together. It is generally recommended
				 * that only `{type}-pre` is used, as this provides the optimal
				 * implementation in terms of speed, although the others are provided
				 * for compatibility with existing Javascript sort functions.
				 *
				 * `{type}-pre`: Functions defined take a single parameter:
				 *
			     *  1. `{*}` Data from the column cell to be prepared for ordering
				 *
				 * And return:
				 *
				 * * `{*}` Data to be sorted upon
				 *
				 * `{type}-asc` and `{type}-desc`: Functions are typical Javascript sort
				 * functions, taking two parameters:
				 *
			     *  1. `{*}` Data to compare to the second parameter
			     *  2. `{*}` Data to compare to the first parameter
				 *
				 * And returning:
				 *
				 * * `{*}` Ordering match: <0 if first parameter should be sorted lower
				 *   than the second parameter, ===0 if the two parameters are equal and
				 *   >0 if the first parameter should be sorted height than the second
				 *   parameter.
				 * 
				 *  @type object
				 *  @default {}
				 *
				 *  @example
				 *    // Numeric ordering of formatted numbers with a pre-formatter
				 *    $.extend( $.fn.dataTable.ext.type.order, {
				 *      "string-pre": function(x) {
				 *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
				 *        return parseFloat( a );
				 *      }
				 *    } );
				 *
				 *  @example
				 *    // Case-sensitive string ordering, with no pre-formatting method
				 *    $.extend( $.fn.dataTable.ext.order, {
				 *      "string-case-asc": function(x,y) {
				 *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
				 *      },
				 *      "string-case-desc": function(x,y) {
				 *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
				 *      }
				 *    } );
				 */
				order: {}
			},
		
			/**
			 * Unique DataTables instance counter
			 *
			 * @type int
			 * @private
			 */
			_unique: 0,
		
		
			//
			// Depreciated
			// The following properties are retained for backwards compatiblity only.
			// The should not be used in new projects and will be removed in a future
			// version
			//
		
			/**
			 * Version check function.
			 *  @type function
			 *  @depreciated Since 1.10
			 */
			fnVersionCheck: DataTable.fnVersionCheck,
		
		
			/**
			 * Index for what 'this' index API functions should use
			 *  @type int
			 *  @deprecated Since v1.10
			 */
			iApiIndex: 0,
		
		
			/**
			 * jQuery UI class container
			 *  @type object
			 *  @deprecated Since v1.10
			 */
			oJUIClasses: {},
		
		
			/**
			 * Software version
			 *  @type string
			 *  @deprecated Since v1.10
			 */
			sVersion: DataTable.version
		};
		
		
		//
		// Backwards compatibility. Alias to pre 1.10 Hungarian notation counter parts
		//
		$.extend( _ext, {
			afnFiltering: _ext.search,
			aTypes:       _ext.type.detect,
			ofnSearch:    _ext.type.search,
			oSort:        _ext.type.order,
			afnSortData:  _ext.order,
			aoFeatures:   _ext.feature,
			oApi:         _ext.internal,
			oStdClasses:  _ext.classes,
			oPagination:  _ext.pager
		} );
		
		
		$.extend( DataTable.ext.classes, {
			"sTable": "dataTable",
			"sNoFooter": "no-footer",
		
			/* Paging buttons */
			"sPageButton": "paginate_button",
			"sPageButtonActive": "current",
			"sPageButtonDisabled": "disabled",
		
			/* Striping classes */
			"sStripeOdd": "odd",
			"sStripeEven": "even",
		
			/* Empty row */
			"sRowEmpty": "dataTables_empty",
		
			/* Features */
			"sWrapper": "dataTables_wrapper",
			"sFilter": "dataTables_filter",
			"sInfo": "dataTables_info",
			"sPaging": "dataTables_paginate paging_", /* Note that the type is postfixed */
			"sLength": "dataTables_length",
			"sProcessing": "dataTables_processing",
		
			/* Sorting */
			"sSortAsc": "sorting_asc",
			"sSortDesc": "sorting_desc",
			"sSortable": "sorting", /* Sortable in both directions */
			"sSortableAsc": "sorting_asc_disabled",
			"sSortableDesc": "sorting_desc_disabled",
			"sSortableNone": "sorting_disabled",
			"sSortColumn": "sorting_", /* Note that an int is postfixed for the sorting order */
		
			/* Filtering */
			"sFilterInput": "",
		
			/* Page length */
			"sLengthSelect": "",
		
			/* Scrolling */
			"sScrollWrapper": "dataTables_scroll",
			"sScrollHead": "dataTables_scrollHead",
			"sScrollHeadInner": "dataTables_scrollHeadInner",
			"sScrollBody": "dataTables_scrollBody",
			"sScrollFoot": "dataTables_scrollFoot",
			"sScrollFootInner": "dataTables_scrollFootInner",
		
			/* Misc */
			"sHeaderTH": "",
			"sFooterTH": "",
		
			// Deprecated
			"sSortJUIAsc": "",
			"sSortJUIDesc": "",
			"sSortJUI": "",
			"sSortJUIAscAllowed": "",
			"sSortJUIDescAllowed": "",
			"sSortJUIWrapper": "",
			"sSortIcon": "",
			"sJUIHeader": "",
			"sJUIFooter": ""
		} );
		
		
		var extPagination = DataTable.ext.pager;
		
		function _numbers ( page, pages ) {
			var
				numbers = [],
				buttons = extPagination.numbers_length,
				half = Math.floor( buttons / 2 ),
				i = 1;
		
			if ( pages <= buttons ) {
				numbers = _range( 0, pages );
			}
			else if ( page <= half ) {
				numbers = _range( 0, buttons-2 );
				numbers.push( 'ellipsis' );
				numbers.push( pages-1 );
			}
			else if ( page >= pages - 1 - half ) {
				numbers = _range( pages-(buttons-2), pages );
				numbers.splice( 0, 0, 'ellipsis' ); // no unshift in ie6
				numbers.splice( 0, 0, 0 );
			}
			else {
				numbers = _range( page-half+2, page+half-1 );
				numbers.push( 'ellipsis' );
				numbers.push( pages-1 );
				numbers.splice( 0, 0, 'ellipsis' );
				numbers.splice( 0, 0, 0 );
			}
		
			numbers.DT_el = 'span';
			return numbers;
		}
		
		
		$.extend( extPagination, {
			simple: function ( page, pages ) {
				return [ 'previous', 'next' ];
			},
		
			full: function ( page, pages ) {
				return [  'first', 'previous', 'next', 'last' ];
			},
		
			numbers: function ( page, pages ) {
				return [ _numbers(page, pages) ];
			},
		
			simple_numbers: function ( page, pages ) {
				return [ 'previous', _numbers(page, pages), 'next' ];
			},
		
			full_numbers: function ( page, pages ) {
				return [ 'first', 'previous', _numbers(page, pages), 'next', 'last' ];
			},
			
			first_last_numbers: function (page, pages) {
		 		return ['first', _numbers(page, pages), 'last'];
		 	},
		
			// For testing and plug-ins to use
			_numbers: _numbers,
		
			// Number of number buttons (including ellipsis) to show. _Must be odd!_
			numbers_length: 7
		} );
		
		
		$.extend( true, DataTable.ext.renderer, {
			pageButton: {
				_: function ( settings, host, idx, buttons, page, pages ) {
					var classes = settings.oClasses;
					var lang = settings.oLanguage.oPaginate;
					var aria = settings.oLanguage.oAria.paginate || {};
					var btnDisplay, btnClass, counter=0;
		
					var attach = function( container, buttons ) {
						var i, ien, node, button;
						var clickHandler = function ( e ) {
							_fnPageChange( settings, e.data.action, true );
						};
		
						for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
							button = buttons[i];
		
							if ( $.isArray( button ) ) {
								var inner = $( '<'+(button.DT_el || 'div')+'/>' )
									.appendTo( container );
								attach( inner, button );
							}
							else {
								btnDisplay = null;
								btnClass = '';
		
								switch ( button ) {
									case 'ellipsis':
										container.append('<span class="ellipsis">&#x2026;</span>');
										break;
		
									case 'first':
										btnDisplay = lang.sFirst;
										btnClass = button + (page > 0 ?
											'' : ' '+classes.sPageButtonDisabled);
										break;
		
									case 'previous':
										btnDisplay = lang.sPrevious;
										btnClass = button + (page > 0 ?
											'' : ' '+classes.sPageButtonDisabled);
										break;
		
									case 'next':
										btnDisplay = lang.sNext;
										btnClass = button + (page < pages-1 ?
											'' : ' '+classes.sPageButtonDisabled);
										break;
		
									case 'last':
										btnDisplay = lang.sLast;
										btnClass = button + (page < pages-1 ?
											'' : ' '+classes.sPageButtonDisabled);
										break;
		
									default:
										btnDisplay = button + 1;
										btnClass = page === button ?
											classes.sPageButtonActive : '';
										break;
								}
		
								if ( btnDisplay !== null ) {
									node = $('<a>', {
											'class': classes.sPageButton+' '+btnClass,
											'aria-controls': settings.sTableId,
											'aria-label': aria[ button ],
											'data-dt-idx': counter,
											'tabindex': settings.iTabIndex,
											'id': idx === 0 && typeof button === 'string' ?
												settings.sTableId +'_'+ button :
												null
										} )
										.html( btnDisplay )
										.appendTo( container );
		
									_fnBindAction(
										node, {action: button}, clickHandler
									);
		
									counter++;
								}
							}
						}
					};
		
					// IE9 throws an 'unknown error' if document.activeElement is used
					// inside an iframe or frame. Try / catch the error. Not good for
					// accessibility, but neither are frames.
					var activeEl;
		
					try {
						// Because this approach is destroying and recreating the paging
						// elements, focus is lost on the select button which is bad for
						// accessibility. So we want to restore focus once the draw has
						// completed
						activeEl = $(host).find(document.activeElement).data('dt-idx');
					}
					catch (e) {}
		
					attach( $(host).empty(), buttons );
		
					if ( activeEl !== undefined ) {
						$(host).find( '[data-dt-idx='+activeEl+']' ).focus();
					}
				}
			}
		} );
		
		
		
		// Built in type detection. See model.ext.aTypes for information about
		// what is required from this methods.
		$.extend( DataTable.ext.type.detect, [
			// Plain numbers - first since V8 detects some plain numbers as dates
			// e.g. Date.parse('55') (but not all, e.g. Date.parse('22')...).
			function ( d, settings )
			{
				var decimal = settings.oLanguage.sDecimal;
				return _isNumber( d, decimal ) ? 'num'+decimal : null;
			},
		
			// Dates (only those recognised by the browser's Date.parse)
			function ( d, settings )
			{
				// V8 tries _very_ hard to make a string passed into `Date.parse()`
				// valid, so we need to use a regex to restrict date formats. Use a
				// plug-in for anything other than ISO8601 style strings
				if ( d && !(d instanceof Date) && ! _re_date.test(d) ) {
					return null;
				}
				var parsed = Date.parse(d);
				return (parsed !== null && !isNaN(parsed)) || _empty(d) ? 'date' : null;
			},
		
			// Formatted numbers
			function ( d, settings )
			{
				var decimal = settings.oLanguage.sDecimal;
				return _isNumber( d, decimal, true ) ? 'num-fmt'+decimal : null;
			},
		
			// HTML numeric
			function ( d, settings )
			{
				var decimal = settings.oLanguage.sDecimal;
				return _htmlNumeric( d, decimal ) ? 'html-num'+decimal : null;
			},
		
			// HTML numeric, formatted
			function ( d, settings )
			{
				var decimal = settings.oLanguage.sDecimal;
				return _htmlNumeric( d, decimal, true ) ? 'html-num-fmt'+decimal : null;
			},
		
			// HTML (this is strict checking - there must be html)
			function ( d, settings )
			{
				return _empty( d ) || (typeof d === 'string' && d.indexOf('<') !== -1) ?
					'html' : null;
			}
		] );
		
		
		
		// Filter formatting functions. See model.ext.ofnSearch for information about
		// what is required from these methods.
		// 
		// Note that additional search methods are added for the html numbers and
		// html formatted numbers by `_addNumericSort()` when we know what the decimal
		// place is
		
		
		$.extend( DataTable.ext.type.search, {
			html: function ( data ) {
				return _empty(data) ?
					data :
					typeof data === 'string' ?
						data
							.replace( _re_new_lines, " " )
							.replace( _re_html, "" ) :
						'';
			},
		
			string: function ( data ) {
				return _empty(data) ?
					data :
					typeof data === 'string' ?
						data.replace( _re_new_lines, " " ) :
						data;
			}
		} );
		
		
		
		var __numericReplace = function ( d, decimalPlace, re1, re2 ) {
			if ( d !== 0 && (!d || d === '-') ) {
				return -Infinity;
			}
		
			// If a decimal place other than `.` is used, it needs to be given to the
			// function so we can detect it and replace with a `.` which is the only
			// decimal place Javascript recognises - it is not locale aware.
			if ( decimalPlace ) {
				d = _numToDecimal( d, decimalPlace );
			}
		
			if ( d.replace ) {
				if ( re1 ) {
					d = d.replace( re1, '' );
				}
		
				if ( re2 ) {
					d = d.replace( re2, '' );
				}
			}
		
			return d * 1;
		};
		
		
		// Add the numeric 'deformatting' functions for sorting and search. This is done
		// in a function to provide an easy ability for the language options to add
		// additional methods if a non-period decimal place is used.
		function _addNumericSort ( decimalPlace ) {
			$.each(
				{
					// Plain numbers
					"num": function ( d ) {
						return __numericReplace( d, decimalPlace );
					},
		
					// Formatted numbers
					"num-fmt": function ( d ) {
						return __numericReplace( d, decimalPlace, _re_formatted_numeric );
					},
		
					// HTML numeric
					"html-num": function ( d ) {
						return __numericReplace( d, decimalPlace, _re_html );
					},
		
					// HTML numeric, formatted
					"html-num-fmt": function ( d ) {
						return __numericReplace( d, decimalPlace, _re_html, _re_formatted_numeric );
					}
				},
				function ( key, fn ) {
					// Add the ordering method
					_ext.type.order[ key+decimalPlace+'-pre' ] = fn;
		
					// For HTML types add a search formatter that will strip the HTML
					if ( key.match(/^html\-/) ) {
						_ext.type.search[ key+decimalPlace ] = _ext.type.search.html;
					}
				}
			);
		}
		
		
		// Default sort methods
		$.extend( _ext.type.order, {
			// Dates
			"date-pre": function ( d ) {
				var ts = Date.parse( d );
				return isNaN(ts) ? -Infinity : ts;
			},
		
			// html
			"html-pre": function ( a ) {
				return _empty(a) ?
					'' :
					a.replace ?
						a.replace( /<.*?>/g, "" ).toLowerCase() :
						a+'';
			},
		
			// string
			"string-pre": function ( a ) {
				// This is a little complex, but faster than always calling toString,
				// http://jsperf.com/tostring-v-check
				return _empty(a) ?
					'' :
					typeof a === 'string' ?
						a.toLowerCase() :
						! a.toString ?
							'' :
							a.toString();
			},
		
			// string-asc and -desc are retained only for compatibility with the old
			// sort methods
			"string-asc": function ( x, y ) {
				return ((x < y) ? -1 : ((x > y) ? 1 : 0));
			},
		
			"string-desc": function ( x, y ) {
				return ((x < y) ? 1 : ((x > y) ? -1 : 0));
			}
		} );
		
		
		// Numeric sorting types - order doesn't matter here
		_addNumericSort( '' );
		
		
		$.extend( true, DataTable.ext.renderer, {
			header: {
				_: function ( settings, cell, column, classes ) {
					// No additional mark-up required
					// Attach a sort listener to update on sort - note that using the
					// `DT` namespace will allow the event to be removed automatically
					// on destroy, while the `dt` namespaced event is the one we are
					// listening for
					$(settings.nTable).on( 'order.dt.DT', function ( e, ctx, sorting, columns ) {
						if ( settings !== ctx ) { // need to check this this is the host
							return;               // table, not a nested one
						}
		
						var colIdx = column.idx;
		
						cell
							.removeClass(
								column.sSortingClass +' '+
								classes.sSortAsc +' '+
								classes.sSortDesc
							)
							.addClass( columns[ colIdx ] == 'asc' ?
								classes.sSortAsc : columns[ colIdx ] == 'desc' ?
									classes.sSortDesc :
									column.sSortingClass
							);
					} );
				},
		
				jqueryui: function ( settings, cell, column, classes ) {
					$('<div/>')
						.addClass( classes.sSortJUIWrapper )
						.append( cell.contents() )
						.append( $('<span/>')
							.addClass( classes.sSortIcon+' '+column.sSortingClassJUI )
						)
						.appendTo( cell );
		
					// Attach a sort listener to update on sort
					$(settings.nTable).on( 'order.dt.DT', function ( e, ctx, sorting, columns ) {
						if ( settings !== ctx ) {
							return;
						}
		
						var colIdx = column.idx;
		
						cell
							.removeClass( classes.sSortAsc +" "+classes.sSortDesc )
							.addClass( columns[ colIdx ] == 'asc' ?
								classes.sSortAsc : columns[ colIdx ] == 'desc' ?
									classes.sSortDesc :
									column.sSortingClass
							);
		
						cell
							.find( 'span.'+classes.sSortIcon )
							.removeClass(
								classes.sSortJUIAsc +" "+
								classes.sSortJUIDesc +" "+
								classes.sSortJUI +" "+
								classes.sSortJUIAscAllowed +" "+
								classes.sSortJUIDescAllowed
							)
							.addClass( columns[ colIdx ] == 'asc' ?
								classes.sSortJUIAsc : columns[ colIdx ] == 'desc' ?
									classes.sSortJUIDesc :
									column.sSortingClassJUI
							);
					} );
				}
			}
		} );
		
		/*
		 * Public helper functions. These aren't used internally by DataTables, or
		 * called by any of the options passed into DataTables, but they can be used
		 * externally by developers working with DataTables. They are helper functions
		 * to make working with DataTables a little bit easier.
		 */
		
		var __htmlEscapeEntities = function ( d ) {
			return typeof d === 'string' ?
				d.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') :
				d;
		};
		
		/**
		 * Helpers for `columns.render`.
		 *
		 * The options defined here can be used with the `columns.render` initialisation
		 * option to provide a display renderer. The following functions are defined:
		 *
		 * * `number` - Will format numeric data (defined by `columns.data`) for
		 *   display, retaining the original unformatted data for sorting and filtering.
		 *   It takes 5 parameters:
		 *   * `string` - Thousands grouping separator
		 *   * `string` - Decimal point indicator
		 *   * `integer` - Number of decimal points to show
		 *   * `string` (optional) - Prefix.
		 *   * `string` (optional) - Postfix (/suffix).
		 * * `text` - Escape HTML to help prevent XSS attacks. It has no optional
		 *   parameters.
		 *
		 * @example
		 *   // Column definition using the number renderer
		 *   {
		 *     data: "salary",
		 *     render: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
		 *   }
		 *
		 * @namespace
		 */
		DataTable.render = {
			number: function ( thousands, decimal, precision, prefix, postfix ) {
				return {
					display: function ( d ) {
						if ( typeof d !== 'number' && typeof d !== 'string' ) {
							return d;
						}
		
						var negative = d < 0 ? '-' : '';
						var flo = parseFloat( d );
		
						// If NaN then there isn't much formatting that we can do - just
						// return immediately, escaping any HTML (this was supposed to
						// be a number after all)
						if ( isNaN( flo ) ) {
							return __htmlEscapeEntities( d );
						}
		
						flo = flo.toFixed( precision );
						d = Math.abs( flo );
		
						var intPart = parseInt( d, 10 );
						var floatPart = precision ?
							decimal+(d - intPart).toFixed( precision ).substring( 2 ):
							'';
		
						return negative + (prefix||'') +
							intPart.toString().replace(
								/\B(?=(\d{3})+(?!\d))/g, thousands
							) +
							floatPart +
							(postfix||'');
					}
				};
			},
		
			text: function () {
				return {
					display: __htmlEscapeEntities,
					filter: __htmlEscapeEntities
				};
			}
		};
		
		
		/*
		 * This is really a good bit rubbish this method of exposing the internal methods
		 * publicly... - To be fixed in 2.0 using methods on the prototype
		 */
		
		
		/**
		 * Create a wrapper function for exporting an internal functions to an external API.
		 *  @param {string} fn API function name
		 *  @returns {function} wrapped function
		 *  @memberof DataTable#internal
		 */
		function _fnExternApiFunc (fn)
		{
			return function() {
				var args = [_fnSettingsFromNode( this[DataTable.ext.iApiIndex] )].concat(
					Array.prototype.slice.call(arguments)
				);
				return DataTable.ext.internal[fn].apply( this, args );
			};
		}
		
		
		/**
		 * Reference to internal functions for use by plug-in developers. Note that
		 * these methods are references to internal functions and are considered to be
		 * private. If you use these methods, be aware that they are liable to change
		 * between versions.
		 *  @namespace
		 */
		$.extend( DataTable.ext.internal, {
			_fnExternApiFunc: _fnExternApiFunc,
			_fnBuildAjax: _fnBuildAjax,
			_fnAjaxUpdate: _fnAjaxUpdate,
			_fnAjaxParameters: _fnAjaxParameters,
			_fnAjaxUpdateDraw: _fnAjaxUpdateDraw,
			_fnAjaxDataSrc: _fnAjaxDataSrc,
			_fnAddColumn: _fnAddColumn,
			_fnColumnOptions: _fnColumnOptions,
			_fnAdjustColumnSizing: _fnAdjustColumnSizing,
			_fnVisibleToColumnIndex: _fnVisibleToColumnIndex,
			_fnColumnIndexToVisible: _fnColumnIndexToVisible,
			_fnVisbleColumns: _fnVisbleColumns,
			_fnGetColumns: _fnGetColumns,
			_fnColumnTypes: _fnColumnTypes,
			_fnApplyColumnDefs: _fnApplyColumnDefs,
			_fnHungarianMap: _fnHungarianMap,
			_fnCamelToHungarian: _fnCamelToHungarian,
			_fnLanguageCompat: _fnLanguageCompat,
			_fnBrowserDetect: _fnBrowserDetect,
			_fnAddData: _fnAddData,
			_fnAddTr: _fnAddTr,
			_fnNodeToDataIndex: _fnNodeToDataIndex,
			_fnNodeToColumnIndex: _fnNodeToColumnIndex,
			_fnGetCellData: _fnGetCellData,
			_fnSetCellData: _fnSetCellData,
			_fnSplitObjNotation: _fnSplitObjNotation,
			_fnGetObjectDataFn: _fnGetObjectDataFn,
			_fnSetObjectDataFn: _fnSetObjectDataFn,
			_fnGetDataMaster: _fnGetDataMaster,
			_fnClearTable: _fnClearTable,
			_fnDeleteIndex: _fnDeleteIndex,
			_fnInvalidate: _fnInvalidate,
			_fnGetRowElements: _fnGetRowElements,
			_fnCreateTr: _fnCreateTr,
			_fnBuildHead: _fnBuildHead,
			_fnDrawHead: _fnDrawHead,
			_fnDraw: _fnDraw,
			_fnReDraw: _fnReDraw,
			_fnAddOptionsHtml: _fnAddOptionsHtml,
			_fnDetectHeader: _fnDetectHeader,
			_fnGetUniqueThs: _fnGetUniqueThs,
			_fnFeatureHtmlFilter: _fnFeatureHtmlFilter,
			_fnFilterComplete: _fnFilterComplete,
			_fnFilterCustom: _fnFilterCustom,
			_fnFilterColumn: _fnFilterColumn,
			_fnFilter: _fnFilter,
			_fnFilterCreateSearch: _fnFilterCreateSearch,
			_fnEscapeRegex: _fnEscapeRegex,
			_fnFilterData: _fnFilterData,
			_fnFeatureHtmlInfo: _fnFeatureHtmlInfo,
			_fnUpdateInfo: _fnUpdateInfo,
			_fnInfoMacros: _fnInfoMacros,
			_fnInitialise: _fnInitialise,
			_fnInitComplete: _fnInitComplete,
			_fnLengthChange: _fnLengthChange,
			_fnFeatureHtmlLength: _fnFeatureHtmlLength,
			_fnFeatureHtmlPaginate: _fnFeatureHtmlPaginate,
			_fnPageChange: _fnPageChange,
			_fnFeatureHtmlProcessing: _fnFeatureHtmlProcessing,
			_fnProcessingDisplay: _fnProcessingDisplay,
			_fnFeatureHtmlTable: _fnFeatureHtmlTable,
			_fnScrollDraw: _fnScrollDraw,
			_fnApplyToChildren: _fnApplyToChildren,
			_fnCalculateColumnWidths: _fnCalculateColumnWidths,
			_fnThrottle: _fnThrottle,
			_fnConvertToWidth: _fnConvertToWidth,
			_fnGetWidestNode: _fnGetWidestNode,
			_fnGetMaxLenString: _fnGetMaxLenString,
			_fnStringToCss: _fnStringToCss,
			_fnSortFlatten: _fnSortFlatten,
			_fnSort: _fnSort,
			_fnSortAria: _fnSortAria,
			_fnSortListener: _fnSortListener,
			_fnSortAttachListener: _fnSortAttachListener,
			_fnSortingClasses: _fnSortingClasses,
			_fnSortData: _fnSortData,
			_fnSaveState: _fnSaveState,
			_fnLoadState: _fnLoadState,
			_fnSettingsFromNode: _fnSettingsFromNode,
			_fnLog: _fnLog,
			_fnMap: _fnMap,
			_fnBindAction: _fnBindAction,
			_fnCallbackReg: _fnCallbackReg,
			_fnCallbackFire: _fnCallbackFire,
			_fnLengthOverflow: _fnLengthOverflow,
			_fnRenderer: _fnRenderer,
			_fnDataSource: _fnDataSource,
			_fnRowAttributes: _fnRowAttributes,
			_fnExtend: _fnExtend,
			_fnCalculateEnd: function () {} // Used by a lot of plug-ins, but redundant
			                                // in 1.10, so this dead-end function is
			                                // added to prevent errors
		} );
		
	
		// jQuery access
		$.fn.dataTable = DataTable;
	
		// Provide access to the host jQuery object (circular reference)
		DataTable.$ = $;
	
		// Legacy aliases
		$.fn.dataTableSettings = DataTable.settings;
		$.fn.dataTableExt = DataTable.ext;
	
		// With a capital `D` we return a DataTables API instance rather than a
		// jQuery object
		$.fn.DataTable = function ( opts ) {
			return $(this).dataTable( opts ).api();
		};
	
		// All properties that are available to $.fn.dataTable should also be
		// available on $.fn.DataTable
		$.each( DataTable, function ( prop, val ) {
			$.fn.DataTable[ prop ] = val;
		} );
	
	
		// Information about events fired by DataTables - for documentation.
		/**
		 * Draw event, fired whenever the table is redrawn on the page, at the same
		 * point as fnDrawCallback. This may be useful for binding events or
		 * performing calculations when the table is altered at all.
		 *  @name DataTable#draw.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 */
	
		/**
		 * Search event, fired when the searching applied to the table (using the
		 * built-in global search, or column filters) is altered.
		 *  @name DataTable#search.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 */
	
		/**
		 * Page change event, fired when the paging of the table is altered.
		 *  @name DataTable#page.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 */
	
		/**
		 * Order event, fired when the ordering applied to the table is altered.
		 *  @name DataTable#order.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 */
	
		/**
		 * DataTables initialisation complete event, fired when the table is fully
		 * drawn, including Ajax data loaded, if Ajax data is required.
		 *  @name DataTable#init.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} oSettings DataTables settings object
		 *  @param {object} json The JSON object request from the server - only
		 *    present if client-side Ajax sourced data is used</li></ol>
		 */
	
		/**
		 * State save event, fired when the table has changed state a new state save
		 * is required. This event allows modification of the state saving object
		 * prior to actually doing the save, including addition or other state
		 * properties (for plug-ins) or modification of a DataTables core property.
		 *  @name DataTable#stateSaveParams.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} oSettings DataTables settings object
		 *  @param {object} json The state information to be saved
		 */
	
		/**
		 * State load event, fired when the table is loading state from the stored
		 * data, but prior to the settings object being modified by the saved state
		 * - allowing modification of the saved state is required or loading of
		 * state for a plug-in.
		 *  @name DataTable#stateLoadParams.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} oSettings DataTables settings object
		 *  @param {object} json The saved state information
		 */
	
		/**
		 * State loaded event, fired when state has been loaded from stored data and
		 * the settings object has been modified by the loaded data.
		 *  @name DataTable#stateLoaded.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} oSettings DataTables settings object
		 *  @param {object} json The saved state information
		 */
	
		/**
		 * Processing event, fired when DataTables is doing some kind of processing
		 * (be it, order, searcg or anything else). It can be used to indicate to
		 * the end user that there is something happening, or that something has
		 * finished.
		 *  @name DataTable#processing.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} oSettings DataTables settings object
		 *  @param {boolean} bShow Flag for if DataTables is doing processing or not
		 */
	
		/**
		 * Ajax (XHR) event, fired whenever an Ajax request is completed from a
		 * request to made to the server for new data. This event is called before
		 * DataTables processed the returned data, so it can also be used to pre-
		 * process the data returned from the server, if needed.
		 *
		 * Note that this trigger is called in `fnServerData`, if you override
		 * `fnServerData` and which to use this event, you need to trigger it in you
		 * success function.
		 *  @name DataTable#xhr.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 *  @param {object} json JSON returned from the server
		 *
		 *  @example
		 *     // Use a custom property returned from the server in another DOM element
		 *     $('#table').dataTable().on('xhr.dt', function (e, settings, json) {
		 *       $('#status').html( json.status );
		 *     } );
		 *
		 *  @example
		 *     // Pre-process the data returned from the server
		 *     $('#table').dataTable().on('xhr.dt', function (e, settings, json) {
		 *       for ( var i=0, ien=json.aaData.length ; i<ien ; i++ ) {
		 *         json.aaData[i].sum = json.aaData[i].one + json.aaData[i].two;
		 *       }
		 *       // Note no return - manipulate the data directly in the JSON object.
		 *     } );
		 */
	
		/**
		 * Destroy event, fired when the DataTable is destroyed by calling fnDestroy
		 * or passing the bDestroy:true parameter in the initialisation object. This
		 * can be used to remove bound events, added DOM nodes, etc.
		 *  @name DataTable#destroy.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 */
	
		/**
		 * Page length change event, fired when number of records to show on each
		 * page (the length) is changed.
		 *  @name DataTable#length.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 *  @param {integer} len New length
		 */
	
		/**
		 * Column sizing has changed.
		 *  @name DataTable#column-sizing.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 */
	
		/**
		 * Column visibility has changed.
		 *  @name DataTable#column-visibility.dt
		 *  @event
		 *  @param {event} e jQuery event object
		 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
		 *  @param {int} column Column index
		 *  @param {bool} vis `false` if column now hidden, or `true` if visible
		 */
	
		return $.fn.dataTable;
	}));


/***/ }),

/***/ 1093:
983,

/***/ 1095:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9a6486086d09bb38cf66a57cc559ade3.png";

/***/ }),

/***/ 1096:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9326ad44ae4bebdedd141e7a53c2a730.png";

/***/ }),

/***/ 1097:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1fc418e33fd5a687290258b23fac4e98.png";

/***/ }),

/***/ 1098:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d7dc10c78f23615d328581aebcd805eb.png";

/***/ }),

/***/ 1099:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bda51e15154a18257b4f955a222fd66f.png";

/***/ }),

/***/ 1100:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1101);
	__webpack_require__(1102);
	__webpack_require__(1104);
	__webpack_require__(1107);
	__webpack_require__(1106);
	__webpack_require__(1105);

/***/ }),

/***/ 1101:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * FooTable - Awesome Responsive Tables
	 * Version : 2.0.3
	 * http://fooplugins.com/plugins/footable-jquery/
	 *
	 * Requires jQuery - http://jquery.com/
	 *
	 * Copyright 2014 Steven Usher & Brad Vincent
	 * Released under the MIT license
	 * You are free to use FooTable in commercial projects as long as this copyright header is left intact.
	 *
	 * Date: 11 Nov 2014
	 */
	(function ($, w, undefined) {
	    w.footable = {
	        options: {
	            delay: 100, // The number of millseconds to wait before triggering the react event
	            breakpoints: { // The different screen resolution breakpoints
	                phone: 480,
	                tablet: 1024
	            },
	            parsers: {  // The default parser to parse the value out of a cell (values are used in building up row detail)
	                alpha: function (cell) {
	                    return $(cell).data('value') || $.trim($(cell).text());
	                },
	                numeric: function (cell) {
	                    var val = $(cell).data('value') || $(cell).text().replace(/[^0-9.\-]/g, '');
	                    val = parseFloat(val);
	                    if (isNaN(val)) val = 0;
	                    return val;
	                }
	            },
	            addRowToggle: true,
	            calculateWidthOverride: null,
	            toggleSelector: ' > tbody > tr:not(.footable-row-detail)', //the selector to show/hide the detail row
	            columnDataSelector: '> thead > tr:last-child > th, > thead > tr:last-child > td', //the selector used to find the column data in the thead
	            detailSeparator: ':', //the separator character used when building up the detail row
	            toggleHTMLElement: '<span />', // override this if you want to insert a click target rather than use a background image.
	            createGroupedDetail: function (data) {
	                var groups = { '_none': { 'name': null, 'data': [] } };
	                for (var i = 0; i < data.length; i++) {
	                    var groupid = data[i].group;
	                    if (groupid !== null) {
	                        if (!(groupid in groups))
	                            groups[groupid] = { 'name': data[i].groupName || data[i].group, 'data': [] };
	
	                        groups[groupid].data.push(data[i]);
	                    } else {
	                        groups._none.data.push(data[i]);
	                    }
	                }
	                return groups;
	            },
	            createDetail: function (element, data, createGroupedDetail, separatorChar, classes) {
	                /// <summary>This function is used by FooTable to generate the detail view seen when expanding a collapsed row.</summary>
	                /// <param name="element">This is the div that contains all the detail row information, anything could be added to it.</param>
	                /// <param name="data">
	                ///  This is an array of objects containing the cell information for the current row.
	                ///  These objects look like the below:
	                ///    obj = {
	                ///      'name': String, // The name of the column
	                ///      'value': Object, // The value parsed from the cell using the parsers. This could be a string, a number or whatever the parser outputs.
	                ///      'display': String, // This is the actual HTML from the cell, so if you have images etc you want moved this is the one to use and is the default value used.
	                ///      'group': String, // This is the identifier used in the data-group attribute of the column.
	                ///      'groupName': String // This is the actual name of the group the column belongs to.
	                ///    }
	                /// </param>
	                /// <param name="createGroupedDetail">The grouping function to group the data</param>
	                /// <param name="separatorChar">The separator charactor used</param>
	                /// <param name="classes">The array of class names used to build up the detail row</param>
	
	                var groups = createGroupedDetail(data);
	                for (var group in groups) {
	                    if (groups[group].data.length === 0) continue;
	                    if (group !== '_none') element.append('<div class="' + classes.detailInnerGroup + '">' + groups[group].name + '</div>');
	
	                    for (var j = 0; j < groups[group].data.length; j++) {
	                        var separator = (groups[group].data[j].name) ? separatorChar : '';
	                        element.append($('<div></div>').addClass(classes.detailInnerRow).append($('<div></div>').addClass(classes.detailInnerName)
	                                .append(groups[group].data[j].name + separator)).append($('<div></div>').addClass(classes.detailInnerValue)
	                                .attr('data-bind-value', groups[group].data[j].bindName).append(groups[group].data[j].display)));
	                    }
	                }
	            },
	            classes: {
	                main: 'footable',
	                loading: 'footable-loading',
	                loaded: 'footable-loaded',
	                toggle: 'footable-toggle',
	                disabled: 'footable-disabled',
	                detail: 'footable-row-detail',
	                detailCell: 'footable-row-detail-cell',
	                detailInner: 'footable-row-detail-inner',
	                detailInnerRow: 'footable-row-detail-row',
	                detailInnerGroup: 'footable-row-detail-group',
	                detailInnerName: 'footable-row-detail-name',
	                detailInnerValue: 'footable-row-detail-value',
	                detailShow: 'footable-detail-show'
	            },
	            triggers: {
	                initialize: 'footable_initialize',                      //trigger this event to force FooTable to reinitialize
	                resize: 'footable_resize',                              //trigger this event to force FooTable to resize
	                redraw: 'footable_redraw',                              //trigger this event to force FooTable to redraw
	                toggleRow: 'footable_toggle_row',                       //trigger this event to force FooTable to toggle a row
	                expandFirstRow: 'footable_expand_first_row',            //trigger this event to force FooTable to expand the first row
	                expandAll: 'footable_expand_all',                       //trigger this event to force FooTable to expand all rows
	                collapseAll: 'footable_collapse_all'                    //trigger this event to force FooTable to collapse all rows
	            },
	            events: {
	                alreadyInitialized: 'footable_already_initialized',     //fires when the FooTable has already been initialized
	                initializing: 'footable_initializing',                  //fires before FooTable starts initializing
	                initialized: 'footable_initialized',                    //fires after FooTable has finished initializing
	                resizing: 'footable_resizing',                          //fires before FooTable resizes
	                resized: 'footable_resized',                            //fires after FooTable has resized
	                redrawn: 'footable_redrawn',                            //fires after FooTable has redrawn
	                breakpoint: 'footable_breakpoint',                      //fires inside the resize function, when a breakpoint is hit
	                columnData: 'footable_column_data',                     //fires when setting up column data. Plugins should use this event to capture their own info about a column
	                rowDetailUpdating: 'footable_row_detail_updating',      //fires before a detail row is updated
	                rowDetailUpdated: 'footable_row_detail_updated',        //fires when a detail row is being updated
	                rowCollapsed: 'footable_row_collapsed',                 //fires when a row is collapsed
	                rowExpanded: 'footable_row_expanded',                   //fires when a row is expanded
	                rowRemoved: 'footable_row_removed',                     //fires when a row is removed
	                reset: 'footable_reset'                                 //fires when FooTable is reset
	            },
	            debug: false, // Whether or not to log information to the console.
	            log: null
	        },
	
	        version: {
	            major: 0, minor: 5,
	            toString: function () {
	                return w.footable.version.major + '.' + w.footable.version.minor;
	            },
	            parse: function (str) {
	                var version = /(\d+)\.?(\d+)?\.?(\d+)?/.exec(str);
	                return {
	                    major: parseInt(version[1], 10) || 0,
	                    minor: parseInt(version[2], 10) || 0,
	                    patch: parseInt(version[3], 10) || 0
	                };
	            }
	        },
	
	        plugins: {
	            _validate: function (plugin) {
	                ///<summary>Simple validation of the <paramref name="plugin"/> to make sure any members called by FooTable actually exist.</summary>
	                ///<param name="plugin">The object defining the plugin, this should implement a string property called "name" and a function called "init".</param>
	
	                if (!$.isFunction(plugin)) {
	                  if (w.footable.options.debug === true) console.error('Validation failed, expected type "function", received type "{0}".', typeof plugin);
	                  return false;
	                }
	                var p = new plugin();
	                if (typeof p['name'] !== 'string') {
	                    if (w.footable.options.debug === true) console.error('Validation failed, plugin does not implement a string property called "name".', p);
	                    return false;
	                }
	                if (!$.isFunction(p['init'])) {
	                    if (w.footable.options.debug === true) console.error('Validation failed, plugin "' + p['name'] + '" does not implement a function called "init".', p);
	                    return false;
	                }
	                if (w.footable.options.debug === true) console.log('Validation succeeded for plugin "' + p['name'] + '".', p);
	                return true;
	            },
	            registered: [], // An array containing all registered plugins.
	            register: function (plugin, options) {
	                ///<summary>Registers a <paramref name="plugin"/> and its default <paramref name="options"/> with FooTable.</summary>
	                ///<param name="plugin">The plugin that should implement a string property called "name" and a function called "init".</param>
	                ///<param name="options">The default options to merge with the FooTable's base options.</param>
	
	                if (w.footable.plugins._validate(plugin)) {
	                    w.footable.plugins.registered.push(plugin);
	                    if (typeof options === 'object') $.extend(true, w.footable.options, options);
	                }
	            },
	            load: function(instance){
	              var loaded = [], registered, i;
	              for(i = 0; i < w.footable.plugins.registered.length; i++){
	                try {
	                  registered = w.footable.plugins.registered[i];
	                  loaded.push(new registered(instance));
	                } catch (err) {
	                  if (w.footable.options.debug === true) console.error(err);
	                }
	              }
	              return loaded;
	            },
	            init: function (instance) {
	                ///<summary>Loops through all registered plugins and calls the "init" method supplying the current <paramref name="instance"/> of the FooTable as the first parameter.</summary>
	                ///<param name="instance">The current instance of the FooTable that the plugin is being initialized for.</param>
	
	                for (var i = 0; i < instance.plugins.length; i++) {
	                    try {
	                      instance.plugins[i]['init'](instance);
	                    } catch (err) {
	                        if (w.footable.options.debug === true) console.error(err);
	                    }
	                }
	            }
	        }
	    };
	
	    var instanceCount = 0;
	
	    $.fn.footable = function (options) {
	        ///<summary>The main constructor call to initialize the plugin using the supplied <paramref name="options"/>.</summary>
	        ///<param name="options">
	        ///<para>A JSON object containing user defined options for the plugin to use. Any options not supplied will have a default value assigned.</para>
	        ///<para>Check the documentation or the default options object above for more information on available options.</para>
	        ///</param>
	
	        options = options || {};
	        var o = $.extend(true, {}, w.footable.options, options); //merge user and default options
	        return this.each(function () {
	            instanceCount++;
	            var footable = new Footable(this, o, instanceCount);
	            $(this).data('footable', footable);
	        });
	    };
	
	    //helper for using timeouts
	    function Timer() {
	        ///<summary>Simple timer object created around a timeout.</summary>
	        var t = this;
	        t.id = null;
	        t.busy = false;
	        t.start = function (code, milliseconds) {
	            ///<summary>Starts the timer and waits the specified amount of <paramref name="milliseconds"/> before executing the supplied <paramref name="code"/>.</summary>
	            ///<param name="code">The code to execute once the timer runs out.</param>
	            ///<param name="milliseconds">The time in milliseconds to wait before executing the supplied <paramref name="code"/>.</param>
	
	            if (t.busy) {
	                return;
	            }
	            t.stop();
	            t.id = setTimeout(function () {
	                code();
	                t.id = null;
	                t.busy = false;
	            }, milliseconds);
	            t.busy = true;
	        };
	        t.stop = function () {
	            ///<summary>Stops the timer if its runnning and resets it back to its starting state.</summary>
	
	            if (t.id !== null) {
	                clearTimeout(t.id);
	                t.id = null;
	                t.busy = false;
	            }
	        };
	    }
	
	    function Footable(t, o, id) {
	        ///<summary>Inits a new instance of the plugin.</summary>
	        ///<param name="t">The main table element to apply this plugin to.</param>
	        ///<param name="o">The options supplied to the plugin. Check the defaults object to see all available options.</param>
	        ///<param name="id">The id to assign to this instance of the plugin.</param>
	
	        var ft = this;
	        ft.id = id;
	        ft.table = t;
	        ft.options = o;
	        ft.breakpoints = [];
	        ft.breakpointNames = '';
	        ft.columns = {};
	        ft.plugins = w.footable.plugins.load(ft);
	
	        var opt = ft.options,
	            cls = opt.classes,
	            evt = opt.events,
	            trg = opt.triggers,
	            indexOffset = 0;
	
	        // This object simply houses all the timers used in the FooTable.
	        ft.timers = {
	            resize: new Timer(),
	            register: function (name) {
	                ft.timers[name] = new Timer();
	                return ft.timers[name];
	            }
	        };
	
	        ft.init = function () {
	            var $window = $(w), $table = $(ft.table);
	
	            w.footable.plugins.init(ft);
	
	            if ($table.hasClass(cls.loaded)) {
	                //already loaded FooTable for the table, so don't init again
	                ft.raise(evt.alreadyInitialized);
	                return;
	            }
	
	            //raise the initializing event
	            ft.raise(evt.initializing);
	
	            $table.addClass(cls.loading);
	
	            // Get the column data once for the life time of the plugin
	            $table.find(opt.columnDataSelector).each(function () {
	                var data = ft.getColumnData(this);
	                ft.columns[data.index] = data;
	            });
	
	            // Create a nice friendly array to work with out of the breakpoints object.
	            for (var name in opt.breakpoints) {
	                ft.breakpoints.push({ 'name': name, 'width': opt.breakpoints[name] });
	                ft.breakpointNames += (name + ' ');
	            }
	
	            // Sort the breakpoints so the smallest is checked first
	            ft.breakpoints.sort(function (a, b) {
	                return a['width'] - b['width'];
	            });
	
	            $table
	                .unbind(trg.initialize)
	                //bind to FooTable initialize trigger
	                .bind(trg.initialize, function () {
	                    //remove previous "state" (to "force" a resize)
	                    $table.removeData('footable_info');
	                    $table.data('breakpoint', '');
	
	                    //trigger the FooTable resize
	                    $table.trigger(trg.resize);
	
	                    //remove the loading class
	                    $table.removeClass(cls.loading);
	
	                    //add the FooTable and loaded class
	                    $table.addClass(cls.loaded).addClass(cls.main);
	
	                    //raise the initialized event
	                    ft.raise(evt.initialized);
	                })
	                .unbind(trg.redraw)
	                //bind to FooTable redraw trigger
	                .bind(trg.redraw, function () {
	                    ft.redraw();
	                })
	                .unbind(trg.resize)
	                //bind to FooTable resize trigger
	                .bind(trg.resize, function () {
	                    ft.resize();
	                })
	                .unbind(trg.expandFirstRow)
	                //bind to FooTable expandFirstRow trigger
	                .bind(trg.expandFirstRow, function () {
	                    $table.find(opt.toggleSelector).first().not('.' + cls.detailShow).trigger(trg.toggleRow);
	                })
	                .unbind(trg.expandAll)
	                //bind to FooTable expandFirstRow trigger
	                .bind(trg.expandAll, function () {
	                    $table.find(opt.toggleSelector).not('.' + cls.detailShow).trigger(trg.toggleRow);
	                })
	                .unbind(trg.collapseAll)
	                //bind to FooTable expandFirstRow trigger
	                .bind(trg.collapseAll, function () {
	                    $table.find('.' + cls.detailShow).trigger(trg.toggleRow);
	                });
	
	            //trigger a FooTable initialize
	            $table.trigger(trg.initialize);
	
	            //bind to window resize
	            $window
	                .bind('resize.footable', function () {
	                    ft.timers.resize.stop();
	                    ft.timers.resize.start(function () {
	                        ft.raise(trg.resize);
	                    }, opt.delay);
	                });
	        };
	
	        ft.addRowToggle = function () {
	            if (!opt.addRowToggle) return;
	
	            var $table = $(ft.table),
	                hasToggleColumn = false;
	
	            //first remove all toggle spans
	            $table.find('span.' + cls.toggle).remove();
	
	            for (var c in ft.columns) {
	                var col = ft.columns[c];
	                if (col.toggle) {
	                    hasToggleColumn = true;
	                    var selector = '> tbody > tr:not(.' + cls.detail + ',.' + cls.disabled + ') > td:nth-child(' + (parseInt(col.index, 10) + 1) + '),' +
	                                            '> tbody > tr:not(.' + cls.detail + ',.' + cls.disabled + ') > th:nth-child(' + (parseInt(col.index, 10) + 1) + ')';
	                    $table.find(selector).not('.' + cls.detailCell).prepend($(opt.toggleHTMLElement).addClass(cls.toggle));
	                    return;
	                }
	            }
	            //check if we have an toggle column. If not then add it to the first column just to be safe
	            if (!hasToggleColumn) {
	                $table
	                    .find('> tbody > tr:not(.' + cls.detail + ',.' + cls.disabled + ') > td:first-child')
	                                        .add('> tbody > tr:not(.' + cls.detail + ',.' + cls.disabled + ') > th:first-child')
	                    .not('.' + cls.detailCell)
	                    .prepend($(opt.toggleHTMLElement).addClass(cls.toggle));
	            }
	        };
	
	        ft.setColumnClasses = function () {
	            var $table = $(ft.table);
	            for (var c in ft.columns) {
	                var col = ft.columns[c];
	                if (col.className !== null) {
	                    var selector = '', first = true;
	                    $.each(col.matches, function (m, match) { //support for colspans
	                        if (!first) selector += ', ';
	                        selector += '> tbody > tr:not(.' + cls.detail + ') > td:nth-child(' + (parseInt(match, 10) + 1) + ')';
	                        first = false;
	                    });
	                    //add the className to the cells specified by data-class="blah"
	                    $table.find(selector).not('.' + cls.detailCell).addClass(col.className);
	                }
	            }
	        };
	
	        //moved this out into it's own function so that it can be called from other add-ons
	        ft.bindToggleSelectors = function () {
	            var $table = $(ft.table);
	
	            if (!ft.hasAnyBreakpointColumn()) return;
	
	            $table.find(opt.toggleSelector).unbind(trg.toggleRow).bind(trg.toggleRow, function (e) {
	                var $row = $(this).is('tr') ? $(this) : $(this).parents('tr:first');
	                ft.toggleDetail($row);
	            });
	
	            $table.find(opt.toggleSelector).unbind('click.footable').bind('click.footable', function (e) {
	                if ($table.is('.breakpoint') && $(e.target).is('td,th,.'+ cls.toggle)) {
	                    $(this).trigger(trg.toggleRow);
	                }
	            });
	        };
	
	        ft.parse = function (cell, column) {
	            var parser = opt.parsers[column.type] || opt.parsers.alpha;
	            return parser(cell);
	        };
	
	        ft.getColumnData = function (th) {
	            var $th = $(th), hide = $th.data('hide'), index = $th.index();
	            hide = hide || '';
	            hide = jQuery.map(hide.split(','), function (a) {
	                return jQuery.trim(a);
	            });
	            var data = {
	                'index': index,
	                'hide': { },
	                'type': $th.data('type') || 'alpha',
	                'name': $th.data('name') || $.trim($th.text()),
	                'ignore': $th.data('ignore') || false,
	                'toggle': $th.data('toggle') || false,
	                'className': $th.data('class') || null,
	                'matches': [],
	                'names': { },
	                'group': $th.data('group') || null,
	                'groupName': null,
	                'isEditable': $th.data('editable')
	            };
	
	            if (data.group !== null) {
	                var $group = $(ft.table).find('> thead > tr.footable-group-row > th[data-group="' + data.group + '"], > thead > tr.footable-group-row > td[data-group="' + data.group + '"]').first();
	                data.groupName = ft.parse($group, { 'type': 'alpha' });
	            }
	
	            var pcolspan = parseInt($th.prev().attr('colspan') || 0, 10);
	            indexOffset += pcolspan > 1 ? pcolspan - 1 : 0;
	            var colspan = parseInt($th.attr('colspan') || 0, 10), curindex = data.index + indexOffset;
	            if (colspan > 1) {
	                var names = $th.data('names');
	                names = names || '';
	                names = names.split(',');
	                for (var i = 0; i < colspan; i++) {
	                    data.matches.push(i + curindex);
	                    if (i < names.length) data.names[i + curindex] = names[i];
	                }
	            } else {
	                data.matches.push(curindex);
	            }
	
	            data.hide['default'] = ($th.data('hide') === "all") || ($.inArray('default', hide) >= 0);
	
	            var hasBreakpoint = false;
	            for (var name in opt.breakpoints) {
	                data.hide[name] = ($th.data('hide') === "all") || ($.inArray(name, hide) >= 0);
	                hasBreakpoint = hasBreakpoint || data.hide[name];
	            }
	            data.hasBreakpoint = hasBreakpoint;
	            var e = ft.raise(evt.columnData, { 'column': { 'data': data, 'th': th } });
	            return e.column.data;
	        };
	
	        ft.getViewportWidth = function () {
	            return window.innerWidth || (document.body ? document.body.offsetWidth : 0);
	        };
	
	        ft.calculateWidth = function ($table, info) {
	            if (jQuery.isFunction(opt.calculateWidthOverride)) {
	                return opt.calculateWidthOverride($table, info);
	            }
	            if (info.viewportWidth < info.width) info.width = info.viewportWidth;
	            if (info.parentWidth < info.width) info.width = info.parentWidth;
	            return info;
	        };
	
	        ft.hasBreakpointColumn = function (breakpoint) {
	            for (var c in ft.columns) {
	                if (ft.columns[c].hide[breakpoint]) {
	                    if (ft.columns[c].ignore) {
	                        continue;
	                    }
	                    return true;
	                }
	            }
	            return false;
	        };
	
	        ft.hasAnyBreakpointColumn = function () {
	            for (var c in ft.columns) {
	                if (ft.columns[c].hasBreakpoint) {
	                    return true;
	                }
	            }
	            return false;
	        };
	
	        ft.resize = function () {
	            var $table = $(ft.table);
	
	            if (!$table.is(':visible')) {
	                return;
	            } //we only care about FooTables that are visible
	
	            if (!ft.hasAnyBreakpointColumn()) {
					$table.trigger(trg.redraw);
					return;
	            } //we only care about FooTables that have breakpoints
	
	            var info = {
	                'width': $table.width(),                  //the table width
	                'viewportWidth': ft.getViewportWidth(),   //the width of the viewport
	                'parentWidth': $table.parent().width()    //the width of the parent
	            };
	
	            info = ft.calculateWidth($table, info);
	
	            var pinfo = $table.data('footable_info');
	            $table.data('footable_info', info);
	            ft.raise(evt.resizing, { 'old': pinfo, 'info': info });
	
	            // This (if) statement is here purely to make sure events aren't raised twice as mobile safari seems to do
	            if (!pinfo || (pinfo && pinfo.width && pinfo.width !== info.width)) {
	
	                var current = null, breakpoint;
	                for (var i = 0; i < ft.breakpoints.length; i++) {
	                    breakpoint = ft.breakpoints[i];
	                    if (breakpoint && breakpoint.width && info.width <= breakpoint.width) {
	                        current = breakpoint;
	                        break;
	                    }
	                }
	
	                var breakpointName = (current === null ? 'default' : current['name']),
	                    hasBreakpointFired = ft.hasBreakpointColumn(breakpointName),
	                    previousBreakpoint = $table.data('breakpoint');
	
	                $table
	                    .data('breakpoint', breakpointName)
	                    .removeClass('default breakpoint').removeClass(ft.breakpointNames)
	                    .addClass(breakpointName + (hasBreakpointFired ? ' breakpoint' : ''));
	
	                //only do something if the breakpoint has changed
	                if (breakpointName !== previousBreakpoint) {
	                    //trigger a redraw
	                    $table.trigger(trg.redraw);
	                    //raise a breakpoint event
	                    ft.raise(evt.breakpoint, { 'breakpoint': breakpointName, 'info': info });
	                }
	            }
	
	            ft.raise(evt.resized, { 'old': pinfo, 'info': info });
	        };
	
	        ft.redraw = function () {
	            //add the toggler to each row
	            ft.addRowToggle();
	
	            //bind the toggle selector click events
	            ft.bindToggleSelectors();
	
	            //set any cell classes defined for the columns
	            ft.setColumnClasses();
	
	            var $table = $(ft.table),
	                breakpointName = $table.data('breakpoint'),
	                hasBreakpointFired = ft.hasBreakpointColumn(breakpointName);
	
	            $table
	                .find('> tbody > tr:not(.' + cls.detail + ')').data('detail_created', false).end()
	                .find('> thead > tr:last-child > th')
	                .each(function () {
	                    var data = ft.columns[$(this).index()], selector = '', first = true;
	                    $.each(data.matches, function (m, match) {
	                        if (!first) {
	                            selector += ', ';
	                        }
	                        var count = match + 1;
	                        selector += '> tbody > tr:not(.' + cls.detail + ') > td:nth-child(' + count + ')';
	                        selector += ', > tfoot > tr:not(.' + cls.detail + ') > td:nth-child(' + count + ')';
	                        selector += ', > colgroup > col:nth-child(' + count + ')';
	                        first = false;
	                    });
	
	                    selector += ', > thead > tr[data-group-row="true"] > th[data-group="' + data.group + '"]';
	                    var $column = $table.find(selector).add(this);
	                    if (breakpointName !== '') {
	                      if (data.hide[breakpointName] === false) $column.addClass('footable-visible').show();
	                      else $column.removeClass('footable-visible').hide();
	                    }
	
	                    if ($table.find('> thead > tr.footable-group-row').length === 1) {
	                        var $groupcols = $table.find('> thead > tr:last-child > th[data-group="' + data.group + '"]:visible, > thead > tr:last-child > th[data-group="' + data.group + '"]:visible'),
	                            $group = $table.find('> thead > tr.footable-group-row > th[data-group="' + data.group + '"], > thead > tr.footable-group-row > td[data-group="' + data.group + '"]'),
	                            groupspan = 0;
	
	                        $.each($groupcols, function () {
	                            groupspan += parseInt($(this).attr('colspan') || 1, 10);
	                        });
	
	                        if (groupspan > 0) $group.attr('colspan', groupspan).show();
	                        else $group.hide();
	                    }
	                })
	                .end()
	                .find('> tbody > tr.' + cls.detailShow).each(function () {
	                    ft.createOrUpdateDetailRow(this);
	                });
	
	            $table.find("[data-bind-name]").each(function () {
	                ft.toggleInput(this);
	            });
	
	            $table.find('> tbody > tr.' + cls.detailShow + ':visible').each(function () {
	                var $next = $(this).next();
	                if ($next.hasClass(cls.detail)) {
	                    if (!hasBreakpointFired) $next.hide();
	                    else $next.show();
	                }
	            });
	
	            // adding .footable-first-column and .footable-last-column to the first and last th and td of each row in order to allow
	            // for styling if the first or last column is hidden (which won't work using :first-child or :last-child)
	            $table.find('> thead > tr > th.footable-last-column, > tbody > tr > td.footable-last-column').removeClass('footable-last-column');
	            $table.find('> thead > tr > th.footable-first-column, > tbody > tr > td.footable-first-column').removeClass('footable-first-column');
	            $table.find('> thead > tr, > tbody > tr')
	                .find('> th.footable-visible:last, > td.footable-visible:last')
	                .addClass('footable-last-column')
	                .end()
	                .find('> th.footable-visible:first, > td.footable-visible:first')
	                .addClass('footable-first-column');
	
	            ft.raise(evt.redrawn);
	        };
	
	        ft.toggleDetail = function (row) {
	            var $row = (row.jquery) ? row : $(row),
	                $next = $row.next();
	
	            //check if the row is already expanded
	            if ($row.hasClass(cls.detailShow)) {
	                $row.removeClass(cls.detailShow);
	
	                //only hide the next row if it's a detail row
	                if ($next.hasClass(cls.detail)) $next.hide();
	
	                ft.raise(evt.rowCollapsed, { 'row': $row[0] });
	
	            } else {
	                ft.createOrUpdateDetailRow($row[0]);
	                $row.addClass(cls.detailShow)
	                    .next().show();
	
	                ft.raise(evt.rowExpanded, { 'row': $row[0] });
	            }
	        };
	
	        ft.removeRow = function (row) {
	            var $row = (row.jquery) ? row : $(row);
	            if ($row.hasClass(cls.detail)) {
	                $row = $row.prev();
	            }
	            var $next = $row.next();
	            if ($row.data('detail_created') === true) {
	                //remove the detail row
	                $next.remove();
	            }
	            $row.remove();
	
	            //raise event
	            ft.raise(evt.rowRemoved);
	        };
	
	        ft.appendRow = function (row) {
	            var $row = (row.jquery) ? row : $(row);
	            $(ft.table).find('tbody').append($row);
	
	            //redraw the table
	            ft.redraw();
	        };
	
	        ft.getColumnFromTdIndex = function (index) {
	            /// <summary>Returns the correct column data for the supplied index taking into account colspans.</summary>
	            /// <param name="index">The index to retrieve the column data for.</param>
	            /// <returns type="json">A JSON object containing the column data for the supplied index.</returns>
	            var result = null;
	            for (var column in ft.columns) {
	                if ($.inArray(index, ft.columns[column].matches) >= 0) {
	                    result = ft.columns[column];
	                    break;
	                }
	            }
	            return result;
	        };
	
	        ft.createOrUpdateDetailRow = function (actualRow) {
	            var $row = $(actualRow), $next = $row.next(), $detail, values = [];
	            if ($row.data('detail_created') === true) return true;
	
	            if ($row.is(':hidden')) return false; //if the row is hidden for some reason (perhaps filtered) then get out of here
	            ft.raise(evt.rowDetailUpdating, { 'row': $row, 'detail': $next });
	            $row.find('> td:hidden').each(function () {
	                var index = $(this).index(), column = ft.getColumnFromTdIndex(index), name = column.name;
	                if (column.ignore === true) return true;
	
	                if (index in column.names) name = column.names[index];
	
	                var bindName = $(this).attr("data-bind-name");
	                if (bindName != null && $(this).is(':empty')) {
	                    var bindValue = $('.' + cls.detailInnerValue + '[' + 'data-bind-value="' + bindName + '"]');
	                    $(this).html($(bindValue).contents().detach());
	                }
	                var display;
	                if (column.isEditable !== false && (column.isEditable || $(this).find(":input").length > 0)) {
	                    if(bindName == null) {
	                        bindName = "bind-" + $.now() + "-" + index;
	                        $(this).attr("data-bind-name", bindName);
	                    }
	                    display = $(this).contents().detach();
	                }
	                if (!display) display = $(this).contents().clone(true, true);
	                values.push({ 'name': name, 'value': ft.parse(this, column), 'display': display, 'group': column.group, 'groupName': column.groupName, 'bindName': bindName });
	                return true;
	            });
	            if (values.length === 0) return false; //return if we don't have any data to show
	            var colspan = $row.find('> td:visible').length;
	            var exists = $next.hasClass(cls.detail);
	            if (!exists) { // Create
	                $next = $('<tr class="' + cls.detail + '"><td class="' + cls.detailCell + '"><div class="' + cls.detailInner + '"></div></td></tr>');
	                $row.after($next);
	            }
	            $next.find('> td:first').attr('colspan', colspan);
	            $detail = $next.find('.' + cls.detailInner).empty();
	            opt.createDetail($detail, values, opt.createGroupedDetail, opt.detailSeparator, cls);
	            $row.data('detail_created', true);
	            ft.raise(evt.rowDetailUpdated, { 'row': $row, 'detail': $next });
	            return !exists;
	        };
	
	        ft.raise = function (eventName, args) {
	
	            if (ft.options.debug === true && $.isFunction(ft.options.log)) ft.options.log(eventName, 'event');
	
	            args = args || { };
	            var def = { 'ft': ft };
	            $.extend(true, def, args);
	            var e = $.Event(eventName, def);
	            if (!e.ft) {
	                $.extend(true, e, def);
	            } //pre jQuery 1.6 which did not allow data to be passed to event object constructor
	            $(ft.table).trigger(e);
	            return e;
	        };
	
	        //reset the state of FooTable
	        ft.reset = function() {
	            var $table = $(ft.table);
	            $table.removeData('footable_info')
	                .data('breakpoint', '')
	                .removeClass(cls.loading)
	                .removeClass(cls.loaded);
	
	            $table.find(opt.toggleSelector).unbind(trg.toggleRow).unbind('click.footable');
	
	            $table.find('> tbody > tr').removeClass(cls.detailShow);
	
	            $table.find('> tbody > tr.' + cls.detail).remove();
	
	            ft.raise(evt.reset);
	        };
	
	        //Switch between row-detail and detail-show.
	        ft.toggleInput = function (column) {
	            var bindName = $(column).attr("data-bind-name");
	            if(bindName != null) {
	                var bindValue = $('.' + cls.detailInnerValue + '[' + 'data-bind-value="' + bindName + '"]');
	                if(bindValue != null) {
	                    if($(column).is(":visible")) {
	                        if(!$(bindValue).is(':empty')) $(column).html($(bindValue).contents().detach());
	                    } else if(!$(column).is(':empty')) {
	                        $(bindValue).html($(column).contents().detach());
	                    }
	                }
	            }
	        };
	
	        ft.init();
	        return ft;
	    }
	})(jQuery, window);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(112)))

/***/ }),

/***/ 1102:
983,

/***/ 1104:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "91c343856c56695b45993db2e1575519.eot";

/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "634513dc791352157f12cb0a5ed8782b.woff";

/***/ }),

/***/ 1106:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2256ee07c7a1a366e5bac1c3fcb8e216.ttf";

/***/ }),

/***/ 1107:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f6c396c95866da7ecdd6768ae48f0307.svg";

/***/ }),

/***/ 1108:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1109);
	__webpack_require__(1110);

/***/ }),

/***/ 1109:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * Waves v0.7.6
	 * http://fian.my.id/Waves
	 *
	 * Copyright 2014-2018 Alfiana E. Sibuea and other contributors
	 * Released under the MIT license
	 * https://github.com/fians/Waves/blob/master/LICENSE
	 */
	
	;(function(window, factory) {
	    'use strict';
	
	    // AMD. Register as an anonymous module.  Wrap in function so we have access
	    // to root via `this`.
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            window.Waves = factory.call(window);
	            return window.Waves;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	
	    // Node. Does not work with strict CommonJS, but only CommonJS-like
	    // environments that support module.exports, like Node.
	    else if (typeof exports === 'object') {
	        module.exports = factory.call(window);
	    }
	
	    // Browser globals.
	    else {
	        window.Waves = factory.call(window);
	    }
	})(typeof global === 'object' ? global : this, function() {
	    'use strict';
	
	    var Waves            = Waves || {};
	    var $$               = document.querySelectorAll.bind(document);
	    var toString         = Object.prototype.toString;
	    var isTouchAvailable = 'ontouchstart' in window;
	
	
	    // Find exact position of element
	    function isWindow(obj) {
	        return obj !== null && obj === obj.window;
	    }
	
	    function getWindow(elem) {
	        return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
	    }
	
	    function isObject(value) {
	        var type = typeof value;
	        return type === 'function' || type === 'object' && !!value;
	    }
	
	    function isDOMNode(obj) {
	        return isObject(obj) && obj.nodeType > 0;
	    }
	
	    function getWavesElements(nodes) {
	        var stringRepr = toString.call(nodes);
	
	        if (stringRepr === '[object String]') {
	            return $$(nodes);
	        } else if (isObject(nodes) && /^\[object (Array|HTMLCollection|NodeList|Object)\]$/.test(stringRepr) && nodes.hasOwnProperty('length')) {
	            return nodes;
	        } else if (isDOMNode(nodes)) {
	            return [nodes];
	        }
	
	        return [];
	    }
	
	    function offset(elem) {
	        var docElem, win,
	            box = { top: 0, left: 0 },
	            doc = elem && elem.ownerDocument;
	
	        docElem = doc.documentElement;
	
	        if (typeof elem.getBoundingClientRect !== typeof undefined) {
	            box = elem.getBoundingClientRect();
	        }
	        win = getWindow(doc);
	        return {
	            top: box.top + win.pageYOffset - docElem.clientTop,
	            left: box.left + win.pageXOffset - docElem.clientLeft
	        };
	    }
	
	    function convertStyle(styleObj) {
	        var style = '';
	
	        for (var prop in styleObj) {
	            if (styleObj.hasOwnProperty(prop)) {
	                style += (prop + ':' + styleObj[prop] + ';');
	            }
	        }
	
	        return style;
	    }
	
	    var Effect = {
	
	        // Effect duration
	        duration: 750,
	
	        // Effect delay (check for scroll before showing effect)
	        delay: 200,
	
	        show: function(e, element, velocity) {
	
	            // Disable right click
	            if (e.button === 2) {
	                return false;
	            }
	
	            element = element || this;
	
	            // Create ripple
	            var ripple = document.createElement('div');
	            ripple.className = 'waves-ripple waves-rippling';
	            element.appendChild(ripple);
	
	            // Get click coordinate and element width
	            var pos       = offset(element);
	            var relativeY = 0;
	            var relativeX = 0;
	            // Support for touch devices
	            if('touches' in e && e.touches.length) {
	                relativeY   = (e.touches[0].pageY - pos.top);
	                relativeX   = (e.touches[0].pageX - pos.left);
	            }
	            //Normal case
	            else {
	                relativeY   = (e.pageY - pos.top);
	                relativeX   = (e.pageX - pos.left);
	            }
	            // Support for synthetic events
	            relativeX = relativeX >= 0 ? relativeX : 0;
	            relativeY = relativeY >= 0 ? relativeY : 0;
	
	            var scale     = 'scale(' + ((element.clientWidth / 100) * 3) + ')';
	            var translate = 'translate(0,0)';
	
	            if (velocity) {
	                translate = 'translate(' + (velocity.x) + 'px, ' + (velocity.y) + 'px)';
	            }
	
	            // Attach data to element
	            ripple.setAttribute('data-hold', Date.now());
	            ripple.setAttribute('data-x', relativeX);
	            ripple.setAttribute('data-y', relativeY);
	            ripple.setAttribute('data-scale', scale);
	            ripple.setAttribute('data-translate', translate);
	
	            // Set ripple position
	            var rippleStyle = {
	                top: relativeY + 'px',
	                left: relativeX + 'px'
	            };
	
	            ripple.classList.add('waves-notransition');
	            ripple.setAttribute('style', convertStyle(rippleStyle));
	            ripple.classList.remove('waves-notransition');
	
	            // Scale the ripple
	            rippleStyle['-webkit-transform'] = scale + ' ' + translate;
	            rippleStyle['-moz-transform'] = scale + ' ' + translate;
	            rippleStyle['-ms-transform'] = scale + ' ' + translate;
	            rippleStyle['-o-transform'] = scale + ' ' + translate;
	            rippleStyle.transform = scale + ' ' + translate;
	            rippleStyle.opacity = '1';
	
	            var duration = e.type === 'mousemove' ? 2500 : Effect.duration;
	            rippleStyle['-webkit-transition-duration'] = duration + 'ms';
	            rippleStyle['-moz-transition-duration']    = duration + 'ms';
	            rippleStyle['-o-transition-duration']      = duration + 'ms';
	            rippleStyle['transition-duration']         = duration + 'ms';
	
	            ripple.setAttribute('style', convertStyle(rippleStyle));
	        },
	
	        hide: function(e, element) {
	            element = element || this;
	
	            var ripples = element.getElementsByClassName('waves-rippling');
	
	            for (var i = 0, len = ripples.length; i < len; i++) {
	                removeRipple(e, element, ripples[i]);
	            }
	
	            if (isTouchAvailable) {
	                element.removeEventListener('touchend', Effect.hide);
	                element.removeEventListener('touchcancel', Effect.hide);
	            }
	
	            element.removeEventListener('mouseup', Effect.hide);
	            element.removeEventListener('mouseleave', Effect.hide);
	        }
	    };
	
	    /**
	     * Collection of wrapper for HTML element that only have single tag
	     * like <input> and <img>
	     */
	    var TagWrapper = {
	
	        // Wrap <input> tag so it can perform the effect
	        input: function(element) {
	
	            var parent = element.parentNode;
	
	            // If input already have parent just pass through
	            if (parent.tagName.toLowerCase() === 'i' && parent.classList.contains('waves-effect')) {
	                return;
	            }
	
	            // Put element class and style to the specified parent
	            var wrapper       = document.createElement('i');
	            wrapper.className = element.className + ' waves-input-wrapper';
	            element.className = 'waves-button-input';
	
	            // Put element as child
	            parent.replaceChild(wrapper, element);
	            wrapper.appendChild(element);
	
	            // Apply element color and background color to wrapper
	            var elementStyle    = window.getComputedStyle(element, null);
	            var color           = elementStyle.color;
	            var backgroundColor = elementStyle.backgroundColor;
	
	            wrapper.setAttribute('style', 'color:' + color + ';background:' + backgroundColor);
	            element.setAttribute('style', 'background-color:rgba(0,0,0,0);');
	
	        },
	
	        // Wrap <img> tag so it can perform the effect
	        img: function(element) {
	
	            var parent = element.parentNode;
	
	            // If input already have parent just pass through
	            if (parent.tagName.toLowerCase() === 'i' && parent.classList.contains('waves-effect')) {
	                return;
	            }
	
	            // Put element as child
	            var wrapper  = document.createElement('i');
	            parent.replaceChild(wrapper, element);
	            wrapper.appendChild(element);
	
	        }
	    };
	
	    /**
	     * Hide the effect and remove the ripple. Must be
	     * a separate function to pass the JSLint...
	     */
	    function removeRipple(e, el, ripple) {
	
	        // Check if the ripple still exist
	        if (!ripple) {
	            return;
	        }
	
	        ripple.classList.remove('waves-rippling');
	
	        var relativeX = ripple.getAttribute('data-x');
	        var relativeY = ripple.getAttribute('data-y');
	        var scale     = ripple.getAttribute('data-scale');
	        var translate = ripple.getAttribute('data-translate');
	
	        // Get delay beetween mousedown and mouse leave
	        var diff = Date.now() - Number(ripple.getAttribute('data-hold'));
	        var delay = 350 - diff;
	
	        if (delay < 0) {
	            delay = 0;
	        }
	
	        if (e.type === 'mousemove') {
	            delay = 150;
	        }
	
	        // Fade out ripple after delay
	        var duration = e.type === 'mousemove' ? 2500 : Effect.duration;
	
	        setTimeout(function() {
	
	            var style = {
	                top: relativeY + 'px',
	                left: relativeX + 'px',
	                opacity: '0',
	
	                // Duration
	                '-webkit-transition-duration': duration + 'ms',
	                '-moz-transition-duration': duration + 'ms',
	                '-o-transition-duration': duration + 'ms',
	                'transition-duration': duration + 'ms',
	                '-webkit-transform': scale + ' ' + translate,
	                '-moz-transform': scale + ' ' + translate,
	                '-ms-transform': scale + ' ' + translate,
	                '-o-transform': scale + ' ' + translate,
	                'transform': scale + ' ' + translate
	            };
	
	            ripple.setAttribute('style', convertStyle(style));
	
	            setTimeout(function() {
	                try {
	                    el.removeChild(ripple);
	                } catch (e) {
	                    return false;
	                }
	            }, duration);
	
	        }, delay);
	    }
	
	
	    /**
	     * Disable mousedown event for 500ms during and after touch
	     */
	    var TouchHandler = {
	
	        /* uses an integer rather than bool so there's no issues with
	         * needing to clear timeouts if another touch event occurred
	         * within the 500ms. Cannot mouseup between touchstart and
	         * touchend, nor in the 500ms after touchend. */
	        touches: 0,
	
	        allowEvent: function(e) {
	
	            var allow = true;
	
	            if (/^(mousedown|mousemove)$/.test(e.type) && TouchHandler.touches) {
	                allow = false;
	            }
	
	            return allow;
	        },
	        registerEvent: function(e) {
	            var eType = e.type;
	
	            if (eType === 'touchstart') {
	
	                TouchHandler.touches += 1; // push
	
	            } else if (/^(touchend|touchcancel)$/.test(eType)) {
	
	                setTimeout(function() {
	                    if (TouchHandler.touches) {
	                        TouchHandler.touches -= 1; // pop after 500ms
	                    }
	                }, 500);
	
	            }
	        }
	    };
	
	
	    /**
	     * Delegated click handler for .waves-effect element.
	     * returns null when .waves-effect element not in "click tree"
	     */
	    function getWavesEffectElement(e) {
	
	        if (TouchHandler.allowEvent(e) === false) {
	            return null;
	        }
	
	        var element = null;
	        var target = e.target || e.srcElement;
	
	        while (target.parentElement) {
	            if ( (!(target instanceof SVGElement)) && target.classList.contains('waves-effect')) {
	                element = target;
	                break;
	            }
	            target = target.parentElement;
	        }
	
	        return element;
	    }
	
	    /**
	     * Bubble the click and show effect if .waves-effect elem was found
	     */
	    function showEffect(e) {
	
	        // Disable effect if element has "disabled" property on it
	        // In some cases, the event is not triggered by the current element
	        // if (e.target.getAttribute('disabled') !== null) {
	        //     return;
	        // }
	
	        var element = getWavesEffectElement(e);
	
	        if (element !== null) {
	
	            // Make it sure the element has either disabled property, disabled attribute or 'disabled' class
	            if (element.disabled || element.getAttribute('disabled') || element.classList.contains('disabled')) {
	                return;
	            }
	
	            TouchHandler.registerEvent(e);
	
	            if (e.type === 'touchstart' && Effect.delay) {
	
	                var hidden = false;
	
	                var timer = setTimeout(function () {
	                    timer = null;
	                    Effect.show(e, element);
	                }, Effect.delay);
	
	                var hideEffect = function(hideEvent) {
	
	                    // if touch hasn't moved, and effect not yet started: start effect now
	                    if (timer) {
	                        clearTimeout(timer);
	                        timer = null;
	                        Effect.show(e, element);
	                    }
	                    if (!hidden) {
	                        hidden = true;
	                        Effect.hide(hideEvent, element);
	                    }
	
	                    removeListeners();
	                };
	
	                var touchMove = function(moveEvent) {
	                    if (timer) {
	                        clearTimeout(timer);
	                        timer = null;
	                    }
	                    hideEffect(moveEvent);
	
	                    removeListeners();
	                };
	
	                element.addEventListener('touchmove', touchMove, false);
	                element.addEventListener('touchend', hideEffect, false);
	                element.addEventListener('touchcancel', hideEffect, false);
	
	                var removeListeners = function() {
	                    element.removeEventListener('touchmove', touchMove);
	                    element.removeEventListener('touchend', hideEffect);
	                    element.removeEventListener('touchcancel', hideEffect);
	                };
	            } else {
	
	                Effect.show(e, element);
	
	                if (isTouchAvailable) {
	                    element.addEventListener('touchend', Effect.hide, false);
	                    element.addEventListener('touchcancel', Effect.hide, false);
	                }
	
	                element.addEventListener('mouseup', Effect.hide, false);
	                element.addEventListener('mouseleave', Effect.hide, false);
	            }
	        }
	    }
	
	    Waves.init = function(options) {
	        var body = document.body;
	
	        options = options || {};
	
	        if ('duration' in options) {
	            Effect.duration = options.duration;
	        }
	
	        if ('delay' in options) {
	            Effect.delay = options.delay;
	        }
	
	        if (isTouchAvailable) {
	            body.addEventListener('touchstart', showEffect, false);
	            body.addEventListener('touchcancel', TouchHandler.registerEvent, false);
	            body.addEventListener('touchend', TouchHandler.registerEvent, false);
	        }
	
	        body.addEventListener('mousedown', showEffect, false);
	    };
	
	
	    /**
	     * Attach Waves to dynamically loaded inputs, or add .waves-effect and other
	     * waves classes to a set of elements. Set drag to true if the ripple mouseover
	     * or skimming effect should be applied to the elements.
	     */
	    Waves.attach = function(elements, classes) {
	
	        elements = getWavesElements(elements);
	
	        if (toString.call(classes) === '[object Array]') {
	            classes = classes.join(' ');
	        }
	
	        classes = classes ? ' ' + classes : '';
	
	        var element, tagName;
	
	        for (var i = 0, len = elements.length; i < len; i++) {
	
	            element = elements[i];
	            tagName = element.tagName.toLowerCase();
	
	            if (['input', 'img'].indexOf(tagName) !== -1) {
	                TagWrapper[tagName](element);
	                element = element.parentElement;
	            }
	
	            if (element.className.indexOf('waves-effect') === -1) {
	                element.className += ' waves-effect' + classes;
	            }
	        }
	    };
	
	
	    /**
	     * Cause a ripple to appear in an element via code.
	     */
	    Waves.ripple = function(elements, options) {
	        elements = getWavesElements(elements);
	        var elementsLen = elements.length;
	
	        options          = options || {};
	        options.wait     = options.wait || 0;
	        options.position = options.position || null; // default = centre of element
	
	
	        if (elementsLen) {
	            var element, pos, off, centre = {}, i = 0;
	            var mousedown = {
	                type: 'mousedown',
	                button: 1
	            };
	            var hideRipple = function(mouseup, element) {
	                return function() {
	                    Effect.hide(mouseup, element);
	                };
	            };
	
	            for (; i < elementsLen; i++) {
	                element = elements[i];
	                pos = options.position || {
	                    x: element.clientWidth / 2,
	                    y: element.clientHeight / 2
	                };
	
	                off      = offset(element);
	                centre.x = off.left + pos.x;
	                centre.y = off.top + pos.y;
	
	                mousedown.pageX = centre.x;
	                mousedown.pageY = centre.y;
	
	                Effect.show(mousedown, element);
	
	                if (options.wait >= 0 && options.wait !== null) {
	                    var mouseup = {
	                        type: 'mouseup',
	                        button: 1
	                    };
	
	                    setTimeout(hideRipple(mouseup, element), options.wait);
	                }
	            }
	        }
	    };
	
	    /**
	     * Remove all ripples from an element.
	     */
	    Waves.calm = function(elements) {
	        elements = getWavesElements(elements);
	        var mouseup = {
	            type: 'mouseup',
	            button: 1
	        };
	
	        for (var i = 0, len = elements.length; i < len; i++) {
	            Effect.hide(mouseup, elements[i]);
	        }
	    };
	
	    /**
	     * Deprecated API fallback
	     */
	    Waves.displayEffect = function(options) {
	        console.error('Waves.displayEffect() has been deprecated and will be removed in future version. Please use Waves.init() to initialize Waves effect');
	        Waves.init(options);
	    };
	
	    return Waves;
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 1110:
983,

/***/ 1112:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1113);
	__webpack_require__(1114);

/***/ }),

/***/ 1113:
/***/ (function(module, exports, __webpack_require__) {

	(function() {
	  var callWithJQuery,
	    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
	    slice = [].slice,
	    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    hasProp = {}.hasOwnProperty;
	
	  callWithJQuery = function(pivotModule) {
	    if (true) {
	      return pivotModule(__webpack_require__(112));
	    } else if (typeof define === "function" && define.amd) {
	      return define(["jquery"], pivotModule);
	    } else {
	      return pivotModule(jQuery);
	    }
	  };
	
	  callWithJQuery(function($) {
	
	    /*
	    Utilities
	     */
	    var PivotData, addSeparators, aggregatorTemplates, aggregators, dayNamesEn, derivers, getSort, locales, mthNamesEn, naturalSort, numberFormat, pivotTableRenderer, rd, renderers, rx, rz, sortAs, usFmt, usFmtInt, usFmtPct, zeroPad;
	    addSeparators = function(nStr, thousandsSep, decimalSep) {
	      var rgx, x, x1, x2;
	      nStr += '';
	      x = nStr.split('.');
	      x1 = x[0];
	      x2 = x.length > 1 ? decimalSep + x[1] : '';
	      rgx = /(\d+)(\d{3})/;
	      while (rgx.test(x1)) {
	        x1 = x1.replace(rgx, '$1' + thousandsSep + '$2');
	      }
	      return x1 + x2;
	    };
	    numberFormat = function(opts) {
	      var defaults;
	      defaults = {
	        digitsAfterDecimal: 2,
	        scaler: 1,
	        thousandsSep: ",",
	        decimalSep: ".",
	        prefix: "",
	        suffix: ""
	      };
	      opts = $.extend({}, defaults, opts);
	      return function(x) {
	        var result;
	        if (isNaN(x) || !isFinite(x)) {
	          return "";
	        }
	        result = addSeparators((opts.scaler * x).toFixed(opts.digitsAfterDecimal), opts.thousandsSep, opts.decimalSep);
	        return "" + opts.prefix + result + opts.suffix;
	      };
	    };
	    usFmt = numberFormat();
	    usFmtInt = numberFormat({
	      digitsAfterDecimal: 0
	    });
	    usFmtPct = numberFormat({
	      digitsAfterDecimal: 1,
	      scaler: 100,
	      suffix: "%"
	    });
	    aggregatorTemplates = {
	      count: function(formatter) {
	        if (formatter == null) {
	          formatter = usFmtInt;
	        }
	        return function() {
	          return function(data, rowKey, colKey) {
	            return {
	              count: 0,
	              push: function() {
	                return this.count++;
	              },
	              value: function() {
	                return this.count;
	              },
	              format: formatter
	            };
	          };
	        };
	      },
	      uniques: function(fn, formatter) {
	        if (formatter == null) {
	          formatter = usFmtInt;
	        }
	        return function(arg) {
	          var attr;
	          attr = arg[0];
	          return function(data, rowKey, colKey) {
	            return {
	              uniq: [],
	              push: function(record) {
	                var ref;
	                if (ref = record[attr], indexOf.call(this.uniq, ref) < 0) {
	                  return this.uniq.push(record[attr]);
	                }
	              },
	              value: function() {
	                return fn(this.uniq);
	              },
	              format: formatter,
	              numInputs: attr != null ? 0 : 1
	            };
	          };
	        };
	      },
	      sum: function(formatter) {
	        if (formatter == null) {
	          formatter = usFmt;
	        }
	        return function(arg) {
	          var attr;
	          attr = arg[0];
	          return function(data, rowKey, colKey) {
	            return {
	              sum: 0,
	              push: function(record) {
	                if (!isNaN(parseFloat(record[attr]))) {
	                  return this.sum += parseFloat(record[attr]);
	                }
	              },
	              value: function() {
	                return this.sum;
	              },
	              format: formatter,
	              numInputs: attr != null ? 0 : 1
	            };
	          };
	        };
	      },
	      extremes: function(mode, formatter) {
	        if (formatter == null) {
	          formatter = usFmt;
	        }
	        return function(arg) {
	          var attr;
	          attr = arg[0];
	          return function(data, rowKey, colKey) {
	            return {
	              val: null,
	              sorter: getSort(data != null ? data.sorters : void 0, attr),
	              push: function(record) {
	                var ref, ref1, ref2, x;
	                x = record[attr];
	                if (mode === "min" || mode === "max") {
	                  x = parseFloat(x);
	                  if (!isNaN(x)) {
	                    this.val = Math[mode](x, (ref = this.val) != null ? ref : x);
	                  }
	                }
	                if (mode === "first") {
	                  if (this.sorter(x, (ref1 = this.val) != null ? ref1 : x) <= 0) {
	                    this.val = x;
	                  }
	                }
	                if (mode === "last") {
	                  if (this.sorter(x, (ref2 = this.val) != null ? ref2 : x) >= 0) {
	                    return this.val = x;
	                  }
	                }
	              },
	              value: function() {
	                return this.val;
	              },
	              format: function(x) {
	                if (isNaN(x)) {
	                  return x;
	                } else {
	                  return formatter(x);
	                }
	              },
	              numInputs: attr != null ? 0 : 1
	            };
	          };
	        };
	      },
	      quantile: function(q, formatter) {
	        if (formatter == null) {
	          formatter = usFmt;
	        }
	        return function(arg) {
	          var attr;
	          attr = arg[0];
	          return function(data, rowKey, colKey) {
	            return {
	              vals: [],
	              push: function(record) {
	                var x;
	                x = parseFloat(record[attr]);
	                if (!isNaN(x)) {
	                  return this.vals.push(x);
	                }
	              },
	              value: function() {
	                var i;
	                if (this.vals.length === 0) {
	                  return null;
	                }
	                this.vals.sort(function(a, b) {
	                  return a - b;
	                });
	                i = (this.vals.length - 1) * q;
	                return (this.vals[Math.floor(i)] + this.vals[Math.ceil(i)]) / 2.0;
	              },
	              format: formatter,
	              numInputs: attr != null ? 0 : 1
	            };
	          };
	        };
	      },
	      runningStat: function(mode, ddof, formatter) {
	        if (mode == null) {
	          mode = "mean";
	        }
	        if (ddof == null) {
	          ddof = 1;
	        }
	        if (formatter == null) {
	          formatter = usFmt;
	        }
	        return function(arg) {
	          var attr;
	          attr = arg[0];
	          return function(data, rowKey, colKey) {
	            return {
	              n: 0.0,
	              m: 0.0,
	              s: 0.0,
	              push: function(record) {
	                var m_new, x;
	                x = parseFloat(record[attr]);
	                if (isNaN(x)) {
	                  return;
	                }
	                this.n += 1.0;
	                if (this.n === 1.0) {
	                  return this.m = x;
	                } else {
	                  m_new = this.m + (x - this.m) / this.n;
	                  this.s = this.s + (x - this.m) * (x - m_new);
	                  return this.m = m_new;
	                }
	              },
	              value: function() {
	                if (mode === "mean") {
	                  if (this.n === 0) {
	                    return 0 / 0;
	                  } else {
	                    return this.m;
	                  }
	                }
	                if (this.n <= ddof) {
	                  return 0;
	                }
	                switch (mode) {
	                  case "var":
	                    return this.s / (this.n - ddof);
	                  case "stdev":
	                    return Math.sqrt(this.s / (this.n - ddof));
	                }
	              },
	              format: formatter,
	              numInputs: attr != null ? 0 : 1
	            };
	          };
	        };
	      },
	      sumOverSum: function(formatter) {
	        if (formatter == null) {
	          formatter = usFmt;
	        }
	        return function(arg) {
	          var denom, num;
	          num = arg[0], denom = arg[1];
	          return function(data, rowKey, colKey) {
	            return {
	              sumNum: 0,
	              sumDenom: 0,
	              push: function(record) {
	                if (!isNaN(parseFloat(record[num]))) {
	                  this.sumNum += parseFloat(record[num]);
	                }
	                if (!isNaN(parseFloat(record[denom]))) {
	                  return this.sumDenom += parseFloat(record[denom]);
	                }
	              },
	              value: function() {
	                return this.sumNum / this.sumDenom;
	              },
	              format: formatter,
	              numInputs: (num != null) && (denom != null) ? 0 : 2
	            };
	          };
	        };
	      },
	      sumOverSumBound80: function(upper, formatter) {
	        if (upper == null) {
	          upper = true;
	        }
	        if (formatter == null) {
	          formatter = usFmt;
	        }
	        return function(arg) {
	          var denom, num;
	          num = arg[0], denom = arg[1];
	          return function(data, rowKey, colKey) {
	            return {
	              sumNum: 0,
	              sumDenom: 0,
	              push: function(record) {
	                if (!isNaN(parseFloat(record[num]))) {
	                  this.sumNum += parseFloat(record[num]);
	                }
	                if (!isNaN(parseFloat(record[denom]))) {
	                  return this.sumDenom += parseFloat(record[denom]);
	                }
	              },
	              value: function() {
	                var sign;
	                sign = upper ? 1 : -1;
	                return (0.821187207574908 / this.sumDenom + this.sumNum / this.sumDenom + 1.2815515655446004 * sign * Math.sqrt(0.410593603787454 / (this.sumDenom * this.sumDenom) + (this.sumNum * (1 - this.sumNum / this.sumDenom)) / (this.sumDenom * this.sumDenom))) / (1 + 1.642374415149816 / this.sumDenom);
	              },
	              format: formatter,
	              numInputs: (num != null) && (denom != null) ? 0 : 2
	            };
	          };
	        };
	      },
	      fractionOf: function(wrapped, type, formatter) {
	        if (type == null) {
	          type = "total";
	        }
	        if (formatter == null) {
	          formatter = usFmtPct;
	        }
	        return function() {
	          var x;
	          x = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	          return function(data, rowKey, colKey) {
	            return {
	              selector: {
	                total: [[], []],
	                row: [rowKey, []],
	                col: [[], colKey]
	              }[type],
	              inner: wrapped.apply(null, x)(data, rowKey, colKey),
	              push: function(record) {
	                return this.inner.push(record);
	              },
	              format: formatter,
	              value: function() {
	                return this.inner.value() / data.getAggregator.apply(data, this.selector).inner.value();
	              },
	              numInputs: wrapped.apply(null, x)().numInputs
	            };
	          };
	        };
	      }
	    };
	    aggregatorTemplates.countUnique = function(f) {
	      return aggregatorTemplates.uniques((function(x) {
	        return x.length;
	      }), f);
	    };
	    aggregatorTemplates.listUnique = function(s) {
	      return aggregatorTemplates.uniques((function(x) {
	        return x.sort(naturalSort).join(s);
	      }), (function(x) {
	        return x;
	      }));
	    };
	    aggregatorTemplates.max = function(f) {
	      return aggregatorTemplates.extremes('max', f);
	    };
	    aggregatorTemplates.min = function(f) {
	      return aggregatorTemplates.extremes('min', f);
	    };
	    aggregatorTemplates.first = function(f) {
	      return aggregatorTemplates.extremes('first', f);
	    };
	    aggregatorTemplates.last = function(f) {
	      return aggregatorTemplates.extremes('last', f);
	    };
	    aggregatorTemplates.median = function(f) {
	      return aggregatorTemplates.quantile(0.5, f);
	    };
	    aggregatorTemplates.average = function(f) {
	      return aggregatorTemplates.runningStat("mean", 1, f);
	    };
	    aggregatorTemplates["var"] = function(ddof, f) {
	      return aggregatorTemplates.runningStat("var", ddof, f);
	    };
	    aggregatorTemplates.stdev = function(ddof, f) {
	      return aggregatorTemplates.runningStat("stdev", ddof, f);
	    };
	    aggregators = (function(tpl) {
	      return {
	        "Count": tpl.count(usFmtInt),
	        "Count Unique Values": tpl.countUnique(usFmtInt),
	        "List Unique Values": tpl.listUnique(", "),
	        "Sum": tpl.sum(usFmt),
	        "Integer Sum": tpl.sum(usFmtInt),
	        "Average": tpl.average(usFmt),
	        "Median": tpl.median(usFmt),
	        "Sample Variance": tpl["var"](1, usFmt),
	        "Sample Standard Deviation": tpl.stdev(1, usFmt),
	        "Minimum": tpl.min(usFmt),
	        "Maximum": tpl.max(usFmt),
	        "First": tpl.first(usFmt),
	        "Last": tpl.last(usFmt),
	        "Sum over Sum": tpl.sumOverSum(usFmt),
	        "80% Upper Bound": tpl.sumOverSumBound80(true, usFmt),
	        "80% Lower Bound": tpl.sumOverSumBound80(false, usFmt),
	        "Sum as Fraction of Total": tpl.fractionOf(tpl.sum(), "total", usFmtPct),
	        "Sum as Fraction of Rows": tpl.fractionOf(tpl.sum(), "row", usFmtPct),
	        "Sum as Fraction of Columns": tpl.fractionOf(tpl.sum(), "col", usFmtPct),
	        "Count as Fraction of Total": tpl.fractionOf(tpl.count(), "total", usFmtPct),
	        "Count as Fraction of Rows": tpl.fractionOf(tpl.count(), "row", usFmtPct),
	        "Count as Fraction of Columns": tpl.fractionOf(tpl.count(), "col", usFmtPct)
	      };
	    })(aggregatorTemplates);
	    renderers = {
	      "Table": function(data, opts) {
	        return pivotTableRenderer(data, opts);
	      },
	      "Table Barchart": function(data, opts) {
	        return $(pivotTableRenderer(data, opts)).barchart();
	      },
	      "Heatmap": function(data, opts) {
	        return $(pivotTableRenderer(data, opts)).heatmap("heatmap", opts);
	      },
	      "Row Heatmap": function(data, opts) {
	        return $(pivotTableRenderer(data, opts)).heatmap("rowheatmap", opts);
	      },
	      "Col Heatmap": function(data, opts) {
	        return $(pivotTableRenderer(data, opts)).heatmap("colheatmap", opts);
	      }
	    };
	    locales = {
	      en: {
	        aggregators: aggregators,
	        renderers: renderers,
	        localeStrings: {
	          renderError: "An error occurred rendering the PivotTable results.",
	          computeError: "An error occurred computing the PivotTable results.",
	          uiRenderError: "An error occurred rendering the PivotTable UI.",
	          selectAll: "Select All",
	          selectNone: "Select None",
	          tooMany: "(too many to list)",
	          filterResults: "Filter values",
	          apply: "Apply",
	          cancel: "Cancel",
	          totals: "Totals",
	          vs: "vs",
	          by: "by"
	        }
	      }
	    };
	    mthNamesEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	    dayNamesEn = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
	    zeroPad = function(number) {
	      return ("0" + number).substr(-2, 2);
	    };
	    derivers = {
	      bin: function(col, binWidth) {
	        return function(record) {
	          return record[col] - record[col] % binWidth;
	        };
	      },
	      dateFormat: function(col, formatString, utcOutput, mthNames, dayNames) {
	        var utc;
	        if (utcOutput == null) {
	          utcOutput = false;
	        }
	        if (mthNames == null) {
	          mthNames = mthNamesEn;
	        }
	        if (dayNames == null) {
	          dayNames = dayNamesEn;
	        }
	        utc = utcOutput ? "UTC" : "";
	        return function(record) {
	          var date;
	          date = new Date(Date.parse(record[col]));
	          if (isNaN(date)) {
	            return "";
	          }
	          return formatString.replace(/%(.)/g, function(m, p) {
	            switch (p) {
	              case "y":
	                return date["get" + utc + "FullYear"]();
	              case "m":
	                return zeroPad(date["get" + utc + "Month"]() + 1);
	              case "n":
	                return mthNames[date["get" + utc + "Month"]()];
	              case "d":
	                return zeroPad(date["get" + utc + "Date"]());
	              case "w":
	                return dayNames[date["get" + utc + "Day"]()];
	              case "x":
	                return date["get" + utc + "Day"]();
	              case "H":
	                return zeroPad(date["get" + utc + "Hours"]());
	              case "M":
	                return zeroPad(date["get" + utc + "Minutes"]());
	              case "S":
	                return zeroPad(date["get" + utc + "Seconds"]());
	              default:
	                return "%" + p;
	            }
	          });
	        };
	      }
	    };
	    rx = /(\d+)|(\D+)/g;
	    rd = /\d/;
	    rz = /^0/;
	    naturalSort = (function(_this) {
	      return function(as, bs) {
	        var a, a1, b, b1, nas, nbs;
	        if ((bs != null) && (as == null)) {
	          return -1;
	        }
	        if ((as != null) && (bs == null)) {
	          return 1;
	        }
	        if (typeof as === "number" && isNaN(as)) {
	          return -1;
	        }
	        if (typeof bs === "number" && isNaN(bs)) {
	          return 1;
	        }
	        nas = +as;
	        nbs = +bs;
	        if (nas < nbs) {
	          return -1;
	        }
	        if (nas > nbs) {
	          return 1;
	        }
	        if (typeof as === "number" && typeof bs !== "number") {
	          return -1;
	        }
	        if (typeof bs === "number" && typeof as !== "number") {
	          return 1;
	        }
	        if (typeof as === "number" && typeof bs === "number") {
	          return 0;
	        }
	        if (isNaN(nbs) && !isNaN(nas)) {
	          return -1;
	        }
	        if (isNaN(nas) && !isNaN(nbs)) {
	          return 1;
	        }
	        a = String(as);
	        b = String(bs);
	        if (a === b) {
	          return 0;
	        }
	        if (!(rd.test(a) && rd.test(b))) {
	          return (a > b ? 1 : -1);
	        }
	        a = a.match(rx);
	        b = b.match(rx);
	        while (a.length && b.length) {
	          a1 = a.shift();
	          b1 = b.shift();
	          if (a1 !== b1) {
	            if (rd.test(a1) && rd.test(b1)) {
	              return a1.replace(rz, ".0") - b1.replace(rz, ".0");
	            } else {
	              return (a1 > b1 ? 1 : -1);
	            }
	          }
	        }
	        return a.length - b.length;
	      };
	    })(this);
	    sortAs = function(order) {
	      var i, l_mapping, mapping, x;
	      mapping = {};
	      l_mapping = {};
	      for (i in order) {
	        x = order[i];
	        mapping[x] = i;
	        if (typeof x === "string") {
	          l_mapping[x.toLowerCase()] = i;
	        }
	      }
	      return function(a, b) {
	        if ((mapping[a] != null) && (mapping[b] != null)) {
	          return mapping[a] - mapping[b];
	        } else if (mapping[a] != null) {
	          return -1;
	        } else if (mapping[b] != null) {
	          return 1;
	        } else if ((l_mapping[a] != null) && (l_mapping[b] != null)) {
	          return l_mapping[a] - l_mapping[b];
	        } else if (l_mapping[a] != null) {
	          return -1;
	        } else if (l_mapping[b] != null) {
	          return 1;
	        } else {
	          return naturalSort(a, b);
	        }
	      };
	    };
	    getSort = function(sorters, attr) {
	      var sort;
	      if (sorters != null) {
	        if ($.isFunction(sorters)) {
	          sort = sorters(attr);
	          if ($.isFunction(sort)) {
	            return sort;
	          }
	        } else if (sorters[attr] != null) {
	          return sorters[attr];
	        }
	      }
	      return naturalSort;
	    };
	
	    /*
	    Data Model class
	     */
	    PivotData = (function() {
	      function PivotData(input, opts) {
	        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
	        if (opts == null) {
	          opts = {};
	        }
	        this.getAggregator = bind(this.getAggregator, this);
	        this.getRowKeys = bind(this.getRowKeys, this);
	        this.getColKeys = bind(this.getColKeys, this);
	        this.sortKeys = bind(this.sortKeys, this);
	        this.arrSort = bind(this.arrSort, this);
	        this.input = input;
	        this.aggregator = (ref = opts.aggregator) != null ? ref : aggregatorTemplates.count()();
	        this.aggregatorName = (ref1 = opts.aggregatorName) != null ? ref1 : "Count";
	        this.colAttrs = (ref2 = opts.cols) != null ? ref2 : [];
	        this.rowAttrs = (ref3 = opts.rows) != null ? ref3 : [];
	        this.valAttrs = (ref4 = opts.vals) != null ? ref4 : [];
	        this.sorters = (ref5 = opts.sorters) != null ? ref5 : {};
	        this.rowOrder = (ref6 = opts.rowOrder) != null ? ref6 : "key_a_to_z";
	        this.colOrder = (ref7 = opts.colOrder) != null ? ref7 : "key_a_to_z";
	        this.derivedAttributes = (ref8 = opts.derivedAttributes) != null ? ref8 : {};
	        this.filter = (ref9 = opts.filter) != null ? ref9 : (function() {
	          return true;
	        });
	        this.tree = {};
	        this.rowKeys = [];
	        this.colKeys = [];
	        this.rowTotals = {};
	        this.colTotals = {};
	        this.allTotal = this.aggregator(this, [], []);
	        this.sorted = false;
	        PivotData.forEachRecord(this.input, this.derivedAttributes, (function(_this) {
	          return function(record) {
	            if (_this.filter(record)) {
	              return _this.processRecord(record);
	            }
	          };
	        })(this));
	      }
	
	      PivotData.forEachRecord = function(input, derivedAttributes, f) {
	        var addRecord, compactRecord, i, j, k, l, len1, record, ref, results, results1, tblCols;
	        if ($.isEmptyObject(derivedAttributes)) {
	          addRecord = f;
	        } else {
	          addRecord = function(record) {
	            var k, ref, v;
	            for (k in derivedAttributes) {
	              v = derivedAttributes[k];
	              record[k] = (ref = v(record)) != null ? ref : record[k];
	            }
	            return f(record);
	          };
	        }
	        if ($.isFunction(input)) {
	          return input(addRecord);
	        } else if ($.isArray(input)) {
	          if ($.isArray(input[0])) {
	            results = [];
	            for (i in input) {
	              if (!hasProp.call(input, i)) continue;
	              compactRecord = input[i];
	              if (!(i > 0)) {
	                continue;
	              }
	              record = {};
	              ref = input[0];
	              for (j in ref) {
	                if (!hasProp.call(ref, j)) continue;
	                k = ref[j];
	                record[k] = compactRecord[j];
	              }
	              results.push(addRecord(record));
	            }
	            return results;
	          } else {
	            results1 = [];
	            for (l = 0, len1 = input.length; l < len1; l++) {
	              record = input[l];
	              results1.push(addRecord(record));
	            }
	            return results1;
	          }
	        } else if (input instanceof $) {
	          tblCols = [];
	          $("thead > tr > th", input).each(function(i) {
	            return tblCols.push($(this).text());
	          });
	          return $("tbody > tr", input).each(function(i) {
	            record = {};
	            $("td", this).each(function(j) {
	              return record[tblCols[j]] = $(this).text();
	            });
	            return addRecord(record);
	          });
	        } else {
	          throw new Error("unknown input format");
	        }
	      };
	
	      PivotData.prototype.forEachMatchingRecord = function(criteria, callback) {
	        return PivotData.forEachRecord(this.input, this.derivedAttributes, (function(_this) {
	          return function(record) {
	            var k, ref, v;
	            if (!_this.filter(record)) {
	              return;
	            }
	            for (k in criteria) {
	              v = criteria[k];
	              if (v !== ((ref = record[k]) != null ? ref : "null")) {
	                return;
	              }
	            }
	            return callback(record);
	          };
	        })(this));
	      };
	
	      PivotData.prototype.arrSort = function(attrs) {
	        var a, sortersArr;
	        sortersArr = (function() {
	          var l, len1, results;
	          results = [];
	          for (l = 0, len1 = attrs.length; l < len1; l++) {
	            a = attrs[l];
	            results.push(getSort(this.sorters, a));
	          }
	          return results;
	        }).call(this);
	        return function(a, b) {
	          var comparison, i, sorter;
	          for (i in sortersArr) {
	            if (!hasProp.call(sortersArr, i)) continue;
	            sorter = sortersArr[i];
	            comparison = sorter(a[i], b[i]);
	            if (comparison !== 0) {
	              return comparison;
	            }
	          }
	          return 0;
	        };
	      };
	
	      PivotData.prototype.sortKeys = function() {
	        var v;
	        if (!this.sorted) {
	          this.sorted = true;
	          v = (function(_this) {
	            return function(r, c) {
	              return _this.getAggregator(r, c).value();
	            };
	          })(this);
	          switch (this.rowOrder) {
	            case "value_a_to_z":
	              this.rowKeys.sort((function(_this) {
	                return function(a, b) {
	                  return naturalSort(v(a, []), v(b, []));
	                };
	              })(this));
	              break;
	            case "value_z_to_a":
	              this.rowKeys.sort((function(_this) {
	                return function(a, b) {
	                  return -naturalSort(v(a, []), v(b, []));
	                };
	              })(this));
	              break;
	            default:
	              this.rowKeys.sort(this.arrSort(this.rowAttrs));
	          }
	          switch (this.colOrder) {
	            case "value_a_to_z":
	              return this.colKeys.sort((function(_this) {
	                return function(a, b) {
	                  return naturalSort(v([], a), v([], b));
	                };
	              })(this));
	            case "value_z_to_a":
	              return this.colKeys.sort((function(_this) {
	                return function(a, b) {
	                  return -naturalSort(v([], a), v([], b));
	                };
	              })(this));
	            default:
	              return this.colKeys.sort(this.arrSort(this.colAttrs));
	          }
	        }
	      };
	
	      PivotData.prototype.getColKeys = function() {
	        this.sortKeys();
	        return this.colKeys;
	      };
	
	      PivotData.prototype.getRowKeys = function() {
	        this.sortKeys();
	        return this.rowKeys;
	      };
	
	      PivotData.prototype.processRecord = function(record) {
	        var colKey, flatColKey, flatRowKey, l, len1, len2, n, ref, ref1, ref2, ref3, rowKey, x;
	        colKey = [];
	        rowKey = [];
	        ref = this.colAttrs;
	        for (l = 0, len1 = ref.length; l < len1; l++) {
	          x = ref[l];
	          colKey.push((ref1 = record[x]) != null ? ref1 : "null");
	        }
	        ref2 = this.rowAttrs;
	        for (n = 0, len2 = ref2.length; n < len2; n++) {
	          x = ref2[n];
	          rowKey.push((ref3 = record[x]) != null ? ref3 : "null");
	        }
	        flatRowKey = rowKey.join(String.fromCharCode(0));
	        flatColKey = colKey.join(String.fromCharCode(0));
	        this.allTotal.push(record);
	        if (rowKey.length !== 0) {
	          if (!this.rowTotals[flatRowKey]) {
	            this.rowKeys.push(rowKey);
	            this.rowTotals[flatRowKey] = this.aggregator(this, rowKey, []);
	          }
	          this.rowTotals[flatRowKey].push(record);
	        }
	        if (colKey.length !== 0) {
	          if (!this.colTotals[flatColKey]) {
	            this.colKeys.push(colKey);
	            this.colTotals[flatColKey] = this.aggregator(this, [], colKey);
	          }
	          this.colTotals[flatColKey].push(record);
	        }
	        if (colKey.length !== 0 && rowKey.length !== 0) {
	          if (!this.tree[flatRowKey]) {
	            this.tree[flatRowKey] = {};
	          }
	          if (!this.tree[flatRowKey][flatColKey]) {
	            this.tree[flatRowKey][flatColKey] = this.aggregator(this, rowKey, colKey);
	          }
	          return this.tree[flatRowKey][flatColKey].push(record);
	        }
	      };
	
	      PivotData.prototype.getAggregator = function(rowKey, colKey) {
	        var agg, flatColKey, flatRowKey;
	        flatRowKey = rowKey.join(String.fromCharCode(0));
	        flatColKey = colKey.join(String.fromCharCode(0));
	        if (rowKey.length === 0 && colKey.length === 0) {
	          agg = this.allTotal;
	        } else if (rowKey.length === 0) {
	          agg = this.colTotals[flatColKey];
	        } else if (colKey.length === 0) {
	          agg = this.rowTotals[flatRowKey];
	        } else {
	          agg = this.tree[flatRowKey][flatColKey];
	        }
	        return agg != null ? agg : {
	          value: (function() {
	            return null;
	          }),
	          format: function() {
	            return "";
	          }
	        };
	      };
	
	      return PivotData;
	
	    })();
	    $.pivotUtilities = {
	      aggregatorTemplates: aggregatorTemplates,
	      aggregators: aggregators,
	      renderers: renderers,
	      derivers: derivers,
	      locales: locales,
	      naturalSort: naturalSort,
	      numberFormat: numberFormat,
	      sortAs: sortAs,
	      PivotData: PivotData
	    };
	
	    /*
	    Default Renderer for hierarchical table layout
	     */
	    pivotTableRenderer = function(pivotData, opts) {
	      var aggregator, c, colAttrs, colKey, colKeys, defaults, getClickHandler, i, j, r, result, rowAttrs, rowKey, rowKeys, spanSize, tbody, td, th, thead, totalAggregator, tr, txt, val, x;
	      defaults = {
	        table: {
	          clickCallback: null,
	          rowTotals: true,
	          colTotals: true
	        },
	        localeStrings: {
	          totals: "Totals"
	        }
	      };
	      opts = $.extend(true, {}, defaults, opts);
	      colAttrs = pivotData.colAttrs;
	      rowAttrs = pivotData.rowAttrs;
	      rowKeys = pivotData.getRowKeys();
	      colKeys = pivotData.getColKeys();
	      if (opts.table.clickCallback) {
	        getClickHandler = function(value, rowValues, colValues) {
	          var attr, filters, i;
	          filters = {};
	          for (i in colAttrs) {
	            if (!hasProp.call(colAttrs, i)) continue;
	            attr = colAttrs[i];
	            if (colValues[i] != null) {
	              filters[attr] = colValues[i];
	            }
	          }
	          for (i in rowAttrs) {
	            if (!hasProp.call(rowAttrs, i)) continue;
	            attr = rowAttrs[i];
	            if (rowValues[i] != null) {
	              filters[attr] = rowValues[i];
	            }
	          }
	          return function(e) {
	            return opts.table.clickCallback(e, value, filters, pivotData);
	          };
	        };
	      }
	      result = document.createElement("table");
	      result.className = "pvtTable";
	      spanSize = function(arr, i, j) {
	        var l, len, n, noDraw, ref, ref1, stop, x;
	        if (i !== 0) {
	          noDraw = true;
	          for (x = l = 0, ref = j; 0 <= ref ? l <= ref : l >= ref; x = 0 <= ref ? ++l : --l) {
	            if (arr[i - 1][x] !== arr[i][x]) {
	              noDraw = false;
	            }
	          }
	          if (noDraw) {
	            return -1;
	          }
	        }
	        len = 0;
	        while (i + len < arr.length) {
	          stop = false;
	          for (x = n = 0, ref1 = j; 0 <= ref1 ? n <= ref1 : n >= ref1; x = 0 <= ref1 ? ++n : --n) {
	            if (arr[i][x] !== arr[i + len][x]) {
	              stop = true;
	            }
	          }
	          if (stop) {
	            break;
	          }
	          len++;
	        }
	        return len;
	      };
	      thead = document.createElement("thead");
	      for (j in colAttrs) {
	        if (!hasProp.call(colAttrs, j)) continue;
	        c = colAttrs[j];
	        tr = document.createElement("tr");
	        if (parseInt(j) === 0 && rowAttrs.length !== 0) {
	          th = document.createElement("th");
	          th.setAttribute("colspan", rowAttrs.length);
	          th.setAttribute("rowspan", colAttrs.length);
	          tr.appendChild(th);
	        }
	        th = document.createElement("th");
	        th.className = "pvtAxisLabel";
	        th.textContent = c;
	        tr.appendChild(th);
	        for (i in colKeys) {
	          if (!hasProp.call(colKeys, i)) continue;
	          colKey = colKeys[i];
	          x = spanSize(colKeys, parseInt(i), parseInt(j));
	          if (x !== -1) {
	            th = document.createElement("th");
	            th.className = "pvtColLabel";
	            th.textContent = colKey[j];
	            th.setAttribute("colspan", x);
	            if (parseInt(j) === colAttrs.length - 1 && rowAttrs.length !== 0) {
	              th.setAttribute("rowspan", 2);
	            }
	            tr.appendChild(th);
	          }
	        }
	        if (parseInt(j) === 0 && opts.table.rowTotals) {
	          th = document.createElement("th");
	          th.className = "pvtTotalLabel pvtRowTotalLabel";
	          th.innerHTML = opts.localeStrings.totals;
	          th.setAttribute("rowspan", colAttrs.length + (rowAttrs.length === 0 ? 0 : 1));
	          tr.appendChild(th);
	        }
	        thead.appendChild(tr);
	      }
	      if (rowAttrs.length !== 0) {
	        tr = document.createElement("tr");
	        for (i in rowAttrs) {
	          if (!hasProp.call(rowAttrs, i)) continue;
	          r = rowAttrs[i];
	          th = document.createElement("th");
	          th.className = "pvtAxisLabel";
	          th.textContent = r;
	          tr.appendChild(th);
	        }
	        th = document.createElement("th");
	        if (colAttrs.length === 0) {
	          th.className = "pvtTotalLabel pvtRowTotalLabel";
	          th.innerHTML = opts.localeStrings.totals;
	        }
	        tr.appendChild(th);
	        thead.appendChild(tr);
	      }
	      result.appendChild(thead);
	      tbody = document.createElement("tbody");
	      for (i in rowKeys) {
	        if (!hasProp.call(rowKeys, i)) continue;
	        rowKey = rowKeys[i];
	        tr = document.createElement("tr");
	        for (j in rowKey) {
	          if (!hasProp.call(rowKey, j)) continue;
	          txt = rowKey[j];
	          x = spanSize(rowKeys, parseInt(i), parseInt(j));
	          if (x !== -1) {
	            th = document.createElement("th");
	            th.className = "pvtRowLabel";
	            th.textContent = txt;
	            th.setAttribute("rowspan", x);
	            if (parseInt(j) === rowAttrs.length - 1 && colAttrs.length !== 0) {
	              th.setAttribute("colspan", 2);
	            }
	            tr.appendChild(th);
	          }
	        }
	        for (j in colKeys) {
	          if (!hasProp.call(colKeys, j)) continue;
	          colKey = colKeys[j];
	          aggregator = pivotData.getAggregator(rowKey, colKey);
	          val = aggregator.value();
	          td = document.createElement("td");
	          td.className = "pvtVal row" + i + " col" + j;
	          td.textContent = aggregator.format(val);
	          td.setAttribute("data-value", val);
	          if (getClickHandler != null) {
	            td.onclick = getClickHandler(val, rowKey, colKey);
	          }
	          tr.appendChild(td);
	        }
	        if (opts.table.rowTotals || colAttrs.length === 0) {
	          totalAggregator = pivotData.getAggregator(rowKey, []);
	          val = totalAggregator.value();
	          td = document.createElement("td");
	          td.className = "pvtTotal rowTotal";
	          td.textContent = totalAggregator.format(val);
	          td.setAttribute("data-value", val);
	          if (getClickHandler != null) {
	            td.onclick = getClickHandler(val, rowKey, []);
	          }
	          td.setAttribute("data-for", "row" + i);
	          tr.appendChild(td);
	        }
	        tbody.appendChild(tr);
	      }
	      if (opts.table.colTotals || rowAttrs.length === 0) {
	        tr = document.createElement("tr");
	        if (opts.table.colTotals || rowAttrs.length === 0) {
	          th = document.createElement("th");
	          th.className = "pvtTotalLabel pvtColTotalLabel";
	          th.innerHTML = opts.localeStrings.totals;
	          th.setAttribute("colspan", rowAttrs.length + (colAttrs.length === 0 ? 0 : 1));
	          tr.appendChild(th);
	        }
	        for (j in colKeys) {
	          if (!hasProp.call(colKeys, j)) continue;
	          colKey = colKeys[j];
	          totalAggregator = pivotData.getAggregator([], colKey);
	          val = totalAggregator.value();
	          td = document.createElement("td");
	          td.className = "pvtTotal colTotal";
	          td.textContent = totalAggregator.format(val);
	          td.setAttribute("data-value", val);
	          if (getClickHandler != null) {
	            td.onclick = getClickHandler(val, [], colKey);
	          }
	          td.setAttribute("data-for", "col" + j);
	          tr.appendChild(td);
	        }
	        if (opts.table.rowTotals || colAttrs.length === 0) {
	          totalAggregator = pivotData.getAggregator([], []);
	          val = totalAggregator.value();
	          td = document.createElement("td");
	          td.className = "pvtGrandTotal";
	          td.textContent = totalAggregator.format(val);
	          td.setAttribute("data-value", val);
	          if (getClickHandler != null) {
	            td.onclick = getClickHandler(val, [], []);
	          }
	          tr.appendChild(td);
	        }
	        tbody.appendChild(tr);
	      }
	      result.appendChild(tbody);
	      result.setAttribute("data-numrows", rowKeys.length);
	      result.setAttribute("data-numcols", colKeys.length);
	      return result;
	    };
	
	    /*
	    Pivot Table core: create PivotData object and call Renderer on it
	     */
	    $.fn.pivot = function(input, inputOpts, locale) {
	      var defaults, e, localeDefaults, localeStrings, opts, pivotData, result, x;
	      if (locale == null) {
	        locale = "en";
	      }
	      if (locales[locale] == null) {
	        locale = "en";
	      }
	      defaults = {
	        cols: [],
	        rows: [],
	        vals: [],
	        rowOrder: "key_a_to_z",
	        colOrder: "key_a_to_z",
	        dataClass: PivotData,
	        filter: function() {
	          return true;
	        },
	        aggregator: aggregatorTemplates.count()(),
	        aggregatorName: "Count",
	        sorters: {},
	        derivedAttributes: {},
	        renderer: pivotTableRenderer
	      };
	      localeStrings = $.extend(true, {}, locales.en.localeStrings, locales[locale].localeStrings);
	      localeDefaults = {
	        rendererOptions: {
	          localeStrings: localeStrings
	        },
	        localeStrings: localeStrings
	      };
	      opts = $.extend(true, {}, localeDefaults, $.extend({}, defaults, inputOpts));
	      result = null;
	      try {
	        pivotData = new opts.dataClass(input, opts);
	        try {
	          result = opts.renderer(pivotData, opts.rendererOptions);
	        } catch (error) {
	          e = error;
	          if (typeof console !== "undefined" && console !== null) {
	            console.error(e.stack);
	          }
	          result = $("<span>").html(opts.localeStrings.renderError);
	        }
	      } catch (error) {
	        e = error;
	        if (typeof console !== "undefined" && console !== null) {
	          console.error(e.stack);
	        }
	        result = $("<span>").html(opts.localeStrings.computeError);
	      }
	      x = this[0];
	      while (x.hasChildNodes()) {
	        x.removeChild(x.lastChild);
	      }
	      return this.append(result);
	    };
	
	    /*
	    Pivot Table UI: calls Pivot Table core above with options set by user
	     */
	    $.fn.pivotUI = function(input, inputOpts, overwrite, locale) {
	      var a, aggregator, attr, attrLength, attrValues, c, colOrderArrow, defaults, e, existingOpts, fn1, i, initialRender, l, len1, len2, len3, localeDefaults, localeStrings, materializedInput, n, o, opts, ordering, pivotTable, recordsProcessed, ref, ref1, ref2, ref3, refresh, refreshDelayed, renderer, rendererControl, rowOrderArrow, shownAttributes, shownInAggregators, shownInDragDrop, tr1, tr2, uiTable, unused, unusedAttrsVerticalAutoCutoff, unusedAttrsVerticalAutoOverride, x;
	      if (overwrite == null) {
	        overwrite = false;
	      }
	      if (locale == null) {
	        locale = "en";
	      }
	      if (locales[locale] == null) {
	        locale = "en";
	      }
	      defaults = {
	        derivedAttributes: {},
	        aggregators: locales[locale].aggregators,
	        renderers: locales[locale].renderers,
	        hiddenAttributes: [],
	        hiddenFromAggregators: [],
	        hiddenFromDragDrop: [],
	        menuLimit: 500,
	        cols: [],
	        rows: [],
	        vals: [],
	        rowOrder: "key_a_to_z",
	        colOrder: "key_a_to_z",
	        dataClass: PivotData,
	        exclusions: {},
	        inclusions: {},
	        unusedAttrsVertical: 85,
	        autoSortUnusedAttrs: false,
	        onRefresh: null,
	        showUI: true,
	        filter: function() {
	          return true;
	        },
	        sorters: {}
	      };
	      localeStrings = $.extend(true, {}, locales.en.localeStrings, locales[locale].localeStrings);
	      localeDefaults = {
	        rendererOptions: {
	          localeStrings: localeStrings
	        },
	        localeStrings: localeStrings
	      };
	      existingOpts = this.data("pivotUIOptions");
	      if ((existingOpts == null) || overwrite) {
	        opts = $.extend(true, {}, localeDefaults, $.extend({}, defaults, inputOpts));
	      } else {
	        opts = existingOpts;
	      }
	      try {
	        attrValues = {};
	        materializedInput = [];
	        recordsProcessed = 0;
	        PivotData.forEachRecord(input, opts.derivedAttributes, function(record) {
	          var attr, base, ref, value;
	          if (!opts.filter(record)) {
	            return;
	          }
	          materializedInput.push(record);
	          for (attr in record) {
	            if (!hasProp.call(record, attr)) continue;
	            if (attrValues[attr] == null) {
	              attrValues[attr] = {};
	              if (recordsProcessed > 0) {
	                attrValues[attr]["null"] = recordsProcessed;
	              }
	            }
	          }
	          for (attr in attrValues) {
	            value = (ref = record[attr]) != null ? ref : "null";
	            if ((base = attrValues[attr])[value] == null) {
	              base[value] = 0;
	            }
	            attrValues[attr][value]++;
	          }
	          return recordsProcessed++;
	        });
	        uiTable = $("<table>", {
	          "class": "pvtUi"
	        }).attr("cellpadding", 5);
	        rendererControl = $("<td>").addClass("pvtUiCell");
	        renderer = $("<select>").addClass('pvtRenderer').appendTo(rendererControl).bind("change", function() {
	          return refresh();
	        });
	        ref = opts.renderers;
	        for (x in ref) {
	          if (!hasProp.call(ref, x)) continue;
	          $("<option>").val(x).html(x).appendTo(renderer);
	        }
	        unused = $("<td>").addClass('pvtAxisContainer pvtUnused pvtUiCell');
	        shownAttributes = (function() {
	          var results;
	          results = [];
	          for (a in attrValues) {
	            if (indexOf.call(opts.hiddenAttributes, a) < 0) {
	              results.push(a);
	            }
	          }
	          return results;
	        })();
	        shownInAggregators = (function() {
	          var l, len1, results;
	          results = [];
	          for (l = 0, len1 = shownAttributes.length; l < len1; l++) {
	            c = shownAttributes[l];
	            if (indexOf.call(opts.hiddenFromAggregators, c) < 0) {
	              results.push(c);
	            }
	          }
	          return results;
	        })();
	        shownInDragDrop = (function() {
	          var l, len1, results;
	          results = [];
	          for (l = 0, len1 = shownAttributes.length; l < len1; l++) {
	            c = shownAttributes[l];
	            if (indexOf.call(opts.hiddenFromDragDrop, c) < 0) {
	              results.push(c);
	            }
	          }
	          return results;
	        })();
	        unusedAttrsVerticalAutoOverride = false;
	        if (opts.unusedAttrsVertical === "auto") {
	          unusedAttrsVerticalAutoCutoff = 120;
	        } else {
	          unusedAttrsVerticalAutoCutoff = parseInt(opts.unusedAttrsVertical);
	        }
	        if (!isNaN(unusedAttrsVerticalAutoCutoff)) {
	          attrLength = 0;
	          for (l = 0, len1 = shownInDragDrop.length; l < len1; l++) {
	            a = shownInDragDrop[l];
	            attrLength += a.length;
	          }
	          unusedAttrsVerticalAutoOverride = attrLength > unusedAttrsVerticalAutoCutoff;
	        }
	        if (opts.unusedAttrsVertical === true || unusedAttrsVerticalAutoOverride) {
	          unused.addClass('pvtVertList');
	        } else {
	          unused.addClass('pvtHorizList');
	        }
	        fn1 = function(attr) {
	          var attrElem, checkContainer, closeFilterBox, controls, filterItem, filterItemExcluded, finalButtons, hasExcludedItem, len2, n, placeholder, ref1, sorter, triangleLink, v, value, valueCount, valueList, values;
	          values = (function() {
	            var results;
	            results = [];
	            for (v in attrValues[attr]) {
	              results.push(v);
	            }
	            return results;
	          })();
	          hasExcludedItem = false;
	          valueList = $("<div>").addClass('pvtFilterBox').hide();
	          valueList.append($("<h4>").append($("<span>").text(attr), $("<span>").addClass("count").text("(" + values.length + ")")));
	          if (values.length > opts.menuLimit) {
	            valueList.append($("<p>").html(opts.localeStrings.tooMany));
	          } else {
	            if (values.length > 5) {
	              controls = $("<p>").appendTo(valueList);
	              sorter = getSort(opts.sorters, attr);
	              placeholder = opts.localeStrings.filterResults;
	              $("<input>", {
	                type: "text"
	              }).appendTo(controls).attr({
	                placeholder: placeholder,
	                "class": "pvtSearch"
	              }).bind("keyup", function() {
	                var accept, accept_gen, filter;
	                filter = $(this).val().toLowerCase().trim();
	                accept_gen = function(prefix, accepted) {
	                  return function(v) {
	                    var real_filter, ref1;
	                    real_filter = filter.substring(prefix.length).trim();
	                    if (real_filter.length === 0) {
	                      return true;
	                    }
	                    return ref1 = Math.sign(sorter(v.toLowerCase(), real_filter)), indexOf.call(accepted, ref1) >= 0;
	                  };
	                };
	                accept = filter.indexOf(">=") === 0 ? accept_gen(">=", [1, 0]) : filter.indexOf("<=") === 0 ? accept_gen("<=", [-1, 0]) : filter.indexOf(">") === 0 ? accept_gen(">", [1]) : filter.indexOf("<") === 0 ? accept_gen("<", [-1]) : filter.indexOf("~") === 0 ? function(v) {
	                  if (filter.substring(1).trim().length === 0) {
	                    return true;
	                  }
	                  return v.toLowerCase().match(filter.substring(1));
	                } : function(v) {
	                  return v.toLowerCase().indexOf(filter) !== -1;
	                };
	                return valueList.find('.pvtCheckContainer p label span.value').each(function() {
	                  if (accept($(this).text())) {
	                    return $(this).parent().parent().show();
	                  } else {
	                    return $(this).parent().parent().hide();
	                  }
	                });
	              });
	              controls.append($("<br>"));
	              $("<button>", {
	                type: "button"
	              }).appendTo(controls).html(opts.localeStrings.selectAll).bind("click", function() {
	                valueList.find("input:visible:not(:checked)").prop("checked", true).toggleClass("changed");
	                return false;
	              });
	              $("<button>", {
	                type: "button"
	              }).appendTo(controls).html(opts.localeStrings.selectNone).bind("click", function() {
	                valueList.find("input:visible:checked").prop("checked", false).toggleClass("changed");
	                return false;
	              });
	            }
	            checkContainer = $("<div>").addClass("pvtCheckContainer").appendTo(valueList);
	            ref1 = values.sort(getSort(opts.sorters, attr));
	            for (n = 0, len2 = ref1.length; n < len2; n++) {
	              value = ref1[n];
	              valueCount = attrValues[attr][value];
	              filterItem = $("<label>");
	              filterItemExcluded = false;
	              if (opts.inclusions[attr]) {
	                filterItemExcluded = (indexOf.call(opts.inclusions[attr], value) < 0);
	              } else if (opts.exclusions[attr]) {
	                filterItemExcluded = (indexOf.call(opts.exclusions[attr], value) >= 0);
	              }
	              hasExcludedItem || (hasExcludedItem = filterItemExcluded);
	              $("<input>").attr("type", "checkbox").addClass('pvtFilter').attr("checked", !filterItemExcluded).data("filter", [attr, value]).appendTo(filterItem).bind("change", function() {
	                return $(this).toggleClass("changed");
	              });
	              filterItem.append($("<span>").addClass("value").text(value));
	              filterItem.append($("<span>").addClass("count").text("(" + valueCount + ")"));
	              checkContainer.append($("<p>").append(filterItem));
	            }
	          }
	          closeFilterBox = function() {
	            if (valueList.find("[type='checkbox']").length > valueList.find("[type='checkbox']:checked").length) {
	              attrElem.addClass("pvtFilteredAttribute");
	            } else {
	              attrElem.removeClass("pvtFilteredAttribute");
	            }
	            valueList.find('.pvtSearch').val('');
	            valueList.find('.pvtCheckContainer p').show();
	            return valueList.hide();
	          };
	          finalButtons = $("<p>").appendTo(valueList);
	          if (values.length <= opts.menuLimit) {
	            $("<button>", {
	              type: "button"
	            }).text(opts.localeStrings.apply).appendTo(finalButtons).bind("click", function() {
	              if (valueList.find(".changed").removeClass("changed").length) {
	                refresh();
	              }
	              return closeFilterBox();
	            });
	          }
	          $("<button>", {
	            type: "button"
	          }).text(opts.localeStrings.cancel).appendTo(finalButtons).bind("click", function() {
	            valueList.find(".changed:checked").removeClass("changed").prop("checked", false);
	            valueList.find(".changed:not(:checked)").removeClass("changed").prop("checked", true);
	            return closeFilterBox();
	          });
	          triangleLink = $("<span>").addClass('pvtTriangle').html(" &#x25BE;").bind("click", function(e) {
	            var left, ref2, top;
	            ref2 = $(e.currentTarget).position(), left = ref2.left, top = ref2.top;
	            return valueList.css({
	              left: left + 10,
	              top: top + 10
	            }).show();
	          });
	          attrElem = $("<li>").addClass("axis_" + i).append($("<span>").addClass('pvtAttr').text(attr).data("attrName", attr).append(triangleLink));
	          if (hasExcludedItem) {
	            attrElem.addClass('pvtFilteredAttribute');
	          }
	          return unused.append(attrElem).append(valueList);
	        };
	        for (i in shownInDragDrop) {
	          if (!hasProp.call(shownInDragDrop, i)) continue;
	          attr = shownInDragDrop[i];
	          fn1(attr);
	        }
	        tr1 = $("<tr>").appendTo(uiTable);
	        aggregator = $("<select>").addClass('pvtAggregator').bind("change", function() {
	          return refresh();
	        });
	        ref1 = opts.aggregators;
	        for (x in ref1) {
	          if (!hasProp.call(ref1, x)) continue;
	          aggregator.append($("<option>").val(x).html(x));
	        }
	        ordering = {
	          key_a_to_z: {
	            rowSymbol: "&varr;",
	            colSymbol: "&harr;",
	            next: "value_a_to_z"
	          },
	          value_a_to_z: {
	            rowSymbol: "&darr;",
	            colSymbol: "&rarr;",
	            next: "value_z_to_a"
	          },
	          value_z_to_a: {
	            rowSymbol: "&uarr;",
	            colSymbol: "&larr;",
	            next: "key_a_to_z"
	          }
	        };
	        rowOrderArrow = $("<a>", {
	          role: "button"
	        }).addClass("pvtRowOrder").data("order", opts.rowOrder).html(ordering[opts.rowOrder].rowSymbol).bind("click", function() {
	          $(this).data("order", ordering[$(this).data("order")].next);
	          $(this).html(ordering[$(this).data("order")].rowSymbol);
	          return refresh();
	        });
	        colOrderArrow = $("<a>", {
	          role: "button"
	        }).addClass("pvtColOrder").data("order", opts.colOrder).html(ordering[opts.colOrder].colSymbol).bind("click", function() {
	          $(this).data("order", ordering[$(this).data("order")].next);
	          $(this).html(ordering[$(this).data("order")].colSymbol);
	          return refresh();
	        });
	        $("<td>").addClass('pvtVals pvtUiCell').appendTo(tr1).append(aggregator).append(rowOrderArrow).append(colOrderArrow).append($("<br>"));
	        $("<td>").addClass('pvtAxisContainer pvtHorizList pvtCols pvtUiCell').appendTo(tr1);
	        tr2 = $("<tr>").appendTo(uiTable);
	        tr2.append($("<td>").addClass('pvtAxisContainer pvtRows pvtUiCell').attr("valign", "top"));
	        pivotTable = $("<td>").attr("valign", "top").addClass('pvtRendererArea').appendTo(tr2);
	        if (opts.unusedAttrsVertical === true || unusedAttrsVerticalAutoOverride) {
	          uiTable.find('tr:nth-child(1)').prepend(rendererControl);
	          uiTable.find('tr:nth-child(2)').prepend(unused);
	        } else {
	          uiTable.prepend($("<tr>").append(rendererControl).append(unused));
	        }
	        this.html(uiTable);
	        ref2 = opts.cols;
	        for (n = 0, len2 = ref2.length; n < len2; n++) {
	          x = ref2[n];
	          this.find(".pvtCols").append(this.find(".axis_" + ($.inArray(x, shownInDragDrop))));
	        }
	        ref3 = opts.rows;
	        for (o = 0, len3 = ref3.length; o < len3; o++) {
	          x = ref3[o];
	          this.find(".pvtRows").append(this.find(".axis_" + ($.inArray(x, shownInDragDrop))));
	        }
	        if (opts.aggregatorName != null) {
	          this.find(".pvtAggregator").val(opts.aggregatorName);
	        }
	        if (opts.rendererName != null) {
	          this.find(".pvtRenderer").val(opts.rendererName);
	        }
	        if (!opts.showUI) {
	          this.find(".pvtUiCell").hide();
	        }
	        initialRender = true;
	        refreshDelayed = (function(_this) {
	          return function() {
	            var exclusions, inclusions, len4, newDropdown, numInputsToProcess, pivotUIOptions, pvtVals, ref4, ref5, subopts, t, u, unusedAttrsContainer, vals;
	            subopts = {
	              derivedAttributes: opts.derivedAttributes,
	              localeStrings: opts.localeStrings,
	              rendererOptions: opts.rendererOptions,
	              sorters: opts.sorters,
	              cols: [],
	              rows: [],
	              dataClass: opts.dataClass
	            };
	            numInputsToProcess = (ref4 = opts.aggregators[aggregator.val()]([])().numInputs) != null ? ref4 : 0;
	            vals = [];
	            _this.find(".pvtRows li span.pvtAttr").each(function() {
	              return subopts.rows.push($(this).data("attrName"));
	            });
	            _this.find(".pvtCols li span.pvtAttr").each(function() {
	              return subopts.cols.push($(this).data("attrName"));
	            });
	            _this.find(".pvtVals select.pvtAttrDropdown").each(function() {
	              if (numInputsToProcess === 0) {
	                return $(this).remove();
	              } else {
	                numInputsToProcess--;
	                if ($(this).val() !== "") {
	                  return vals.push($(this).val());
	                }
	              }
	            });
	            if (numInputsToProcess !== 0) {
	              pvtVals = _this.find(".pvtVals");
	              for (x = t = 0, ref5 = numInputsToProcess; 0 <= ref5 ? t < ref5 : t > ref5; x = 0 <= ref5 ? ++t : --t) {
	                newDropdown = $("<select>").addClass('pvtAttrDropdown').append($("<option>")).bind("change", function() {
	                  return refresh();
	                });
	                for (u = 0, len4 = shownInAggregators.length; u < len4; u++) {
	                  attr = shownInAggregators[u];
	                  newDropdown.append($("<option>").val(attr).text(attr));
	                }
	                pvtVals.append(newDropdown);
	              }
	            }
	            if (initialRender) {
	              vals = opts.vals;
	              i = 0;
	              _this.find(".pvtVals select.pvtAttrDropdown").each(function() {
	                $(this).val(vals[i]);
	                return i++;
	              });
	              initialRender = false;
	            }
	            subopts.aggregatorName = aggregator.val();
	            subopts.vals = vals;
	            subopts.aggregator = opts.aggregators[aggregator.val()](vals);
	            subopts.renderer = opts.renderers[renderer.val()];
	            subopts.rowOrder = rowOrderArrow.data("order");
	            subopts.colOrder = colOrderArrow.data("order");
	            exclusions = {};
	            _this.find('input.pvtFilter').not(':checked').each(function() {
	              var filter;
	              filter = $(this).data("filter");
	              if (exclusions[filter[0]] != null) {
	                return exclusions[filter[0]].push(filter[1]);
	              } else {
	                return exclusions[filter[0]] = [filter[1]];
	              }
	            });
	            inclusions = {};
	            _this.find('input.pvtFilter:checked').each(function() {
	              var filter;
	              filter = $(this).data("filter");
	              if (exclusions[filter[0]] != null) {
	                if (inclusions[filter[0]] != null) {
	                  return inclusions[filter[0]].push(filter[1]);
	                } else {
	                  return inclusions[filter[0]] = [filter[1]];
	                }
	              }
	            });
	            subopts.filter = function(record) {
	              var excludedItems, k, ref6, ref7;
	              if (!opts.filter(record)) {
	                return false;
	              }
	              for (k in exclusions) {
	                excludedItems = exclusions[k];
	                if (ref6 = "" + ((ref7 = record[k]) != null ? ref7 : 'null'), indexOf.call(excludedItems, ref6) >= 0) {
	                  return false;
	                }
	              }
	              return true;
	            };
	            pivotTable.pivot(materializedInput, subopts);
	            pivotUIOptions = $.extend({}, opts, {
	              cols: subopts.cols,
	              rows: subopts.rows,
	              colOrder: subopts.colOrder,
	              rowOrder: subopts.rowOrder,
	              vals: vals,
	              exclusions: exclusions,
	              inclusions: inclusions,
	              inclusionsInfo: inclusions,
	              aggregatorName: aggregator.val(),
	              rendererName: renderer.val()
	            });
	            _this.data("pivotUIOptions", pivotUIOptions);
	            if (opts.autoSortUnusedAttrs) {
	              unusedAttrsContainer = _this.find("td.pvtUnused.pvtAxisContainer");
	              $(unusedAttrsContainer).children("li").sort(function(a, b) {
	                return naturalSort($(a).text(), $(b).text());
	              }).appendTo(unusedAttrsContainer);
	            }
	            pivotTable.css("opacity", 1);
	            if (opts.onRefresh != null) {
	              return opts.onRefresh(pivotUIOptions);
	            }
	          };
	        })(this);
	        refresh = (function(_this) {
	          return function() {
	            pivotTable.css("opacity", 0.5);
	            return setTimeout(refreshDelayed, 10);
	          };
	        })(this);
	        refresh();
	        this.find(".pvtAxisContainer").sortable({
	          update: function(e, ui) {
	            if (ui.sender == null) {
	              return refresh();
	            }
	          },
	          connectWith: this.find(".pvtAxisContainer"),
	          items: 'li',
	          placeholder: 'pvtPlaceholder'
	        });
	      } catch (error) {
	        e = error;
	        if (typeof console !== "undefined" && console !== null) {
	          console.error(e.stack);
	        }
	        this.html(opts.localeStrings.uiRenderError);
	      }
	      return this;
	    };
	
	    /*
	    Heatmap post-processing
	     */
	    $.fn.heatmap = function(scope, opts) {
	      var colorScaleGenerator, heatmapper, i, j, l, n, numCols, numRows, ref, ref1, ref2;
	      if (scope == null) {
	        scope = "heatmap";
	      }
	      numRows = this.data("numrows");
	      numCols = this.data("numcols");
	      colorScaleGenerator = opts != null ? (ref = opts.heatmap) != null ? ref.colorScaleGenerator : void 0 : void 0;
	      if (colorScaleGenerator == null) {
	        colorScaleGenerator = function(values) {
	          var max, min;
	          min = Math.min.apply(Math, values);
	          max = Math.max.apply(Math, values);
	          return function(x) {
	            var nonRed;
	            nonRed = 255 - Math.round(255 * (x - min) / (max - min));
	            return "rgb(255," + nonRed + "," + nonRed + ")";
	          };
	        };
	      }
	      heatmapper = (function(_this) {
	        return function(scope) {
	          var colorScale, forEachCell, values;
	          forEachCell = function(f) {
	            return _this.find(scope).each(function() {
	              var x;
	              x = $(this).data("value");
	              if ((x != null) && isFinite(x)) {
	                return f(x, $(this));
	              }
	            });
	          };
	          values = [];
	          forEachCell(function(x) {
	            return values.push(x);
	          });
	          colorScale = colorScaleGenerator(values);
	          return forEachCell(function(x, elem) {
	            return elem.css("background-color", colorScale(x));
	          });
	        };
	      })(this);
	      switch (scope) {
	        case "heatmap":
	          heatmapper(".pvtVal");
	          break;
	        case "rowheatmap":
	          for (i = l = 0, ref1 = numRows; 0 <= ref1 ? l < ref1 : l > ref1; i = 0 <= ref1 ? ++l : --l) {
	            heatmapper(".pvtVal.row" + i);
	          }
	          break;
	        case "colheatmap":
	          for (j = n = 0, ref2 = numCols; 0 <= ref2 ? n < ref2 : n > ref2; j = 0 <= ref2 ? ++n : --n) {
	            heatmapper(".pvtVal.col" + j);
	          }
	      }
	      heatmapper(".pvtTotal.rowTotal");
	      heatmapper(".pvtTotal.colTotal");
	      return this;
	    };
	
	    /*
	    Barchart post-processing
	     */
	    return $.fn.barchart = function(opts) {
	      var barcharter, i, l, numCols, numRows, ref;
	      numRows = this.data("numrows");
	      numCols = this.data("numcols");
	      barcharter = (function(_this) {
	        return function(scope) {
	          var forEachCell, max, min, range, scaler, values;
	          forEachCell = function(f) {
	            return _this.find(scope).each(function() {
	              var x;
	              x = $(this).data("value");
	              if ((x != null) && isFinite(x)) {
	                return f(x, $(this));
	              }
	            });
	          };
	          values = [];
	          forEachCell(function(x) {
	            return values.push(x);
	          });
	          max = Math.max.apply(Math, values);
	          if (max < 0) {
	            max = 0;
	          }
	          range = max;
	          min = Math.min.apply(Math, values);
	          if (min < 0) {
	            range = max - min;
	          }
	          scaler = function(x) {
	            return 100 * x / (1.4 * range);
	          };
	          return forEachCell(function(x, elem) {
	            var bBase, bgColor, text, wrapper;
	            text = elem.text();
	            wrapper = $("<div>").css({
	              "position": "relative",
	              "height": "55px"
	            });
	            bgColor = "gray";
	            bBase = 0;
	            if (min < 0) {
	              bBase = scaler(-min);
	            }
	            if (x < 0) {
	              bBase += scaler(x);
	              bgColor = "darkred";
	              x = -x;
	            }
	            wrapper.append($("<div>").css({
	              "position": "absolute",
	              "bottom": bBase + "%",
	              "left": 0,
	              "right": 0,
	              "height": scaler(x) + "%",
	              "background-color": bgColor
	            }));
	            wrapper.append($("<div>").text(text).css({
	              "position": "relative",
	              "padding-left": "5px",
	              "padding-right": "5px"
	            }));
	            return elem.css({
	              "padding": 0,
	              "padding-top": "5px",
	              "text-align": "center"
	            }).html(wrapper);
	          });
	        };
	      })(this);
	      for (i = l = 0, ref = numRows; 0 <= ref ? l < ref : l > ref; i = 0 <= ref ? ++l : --l) {
	        barcharter(".pvtVal.row" + i);
	      }
	      barcharter(".pvtTotal.colTotal");
	      return this;
	    };
	  });
	
	}).call(this);
	
	//# sourceMappingURL=pivot.js.map


/***/ }),

/***/ 1114:
983,

/***/ 1116:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1117);
	__webpack_require__(1118);

/***/ }),

/***/ 1117:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	     _ _      _       _
	 ___| (_) ___| | __  (_)___
	/ __| | |/ __| |/ /  | / __|
	\__ \ | | (__|   < _ | \__ \
	|___/_|_|\___|_|\_(_)/ |___/
	                   |__/
	
	 Version: 1.6.0
	  Author: Ken Wheeler
	 Website: http://kenwheeler.github.io
	    Docs: http://kenwheeler.github.io/slick
	    Repo: http://github.com/kenwheeler/slick
	  Issues: http://github.com/kenwheeler/slick/issues
	
	 */
	/* global window, document, define, jQuery, setInterval, clearInterval */
	(function(factory) {
	    'use strict';
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(112)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== 'undefined') {
	        module.exports = factory(require('jquery'));
	    } else {
	        factory(jQuery);
	    }
	
	}(function($) {
	    'use strict';
	    var Slick = window.Slick || {};
	
	    Slick = (function() {
	
	        var instanceUid = 0;
	
	        function Slick(element, settings) {
	
	            var _ = this, dataSettings;
	
	            _.defaults = {
	                accessibility: true,
	                adaptiveHeight: false,
	                appendArrows: $(element),
	                appendDots: $(element),
	                arrows: true,
	                asNavFor: null,
	                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
	                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
	                autoplay: false,
	                autoplaySpeed: 3000,
	                centerMode: false,
	                centerPadding: '50px',
	                cssEase: 'ease',
	                customPaging: function(slider, i) {
	                    return $('<button type="button" data-role="none" role="button" tabindex="0" />').text(i + 1);
	                },
	                dots: false,
	                dotsClass: 'slick-dots',
	                draggable: true,
	                easing: 'linear',
	                edgeFriction: 0.35,
	                fade: false,
	                focusOnSelect: false,
	                infinite: true,
	                initialSlide: 0,
	                lazyLoad: 'ondemand',
	                mobileFirst: false,
	                pauseOnHover: true,
	                pauseOnFocus: true,
	                pauseOnDotsHover: false,
	                respondTo: 'window',
	                responsive: null,
	                rows: 1,
	                rtl: false,
	                slide: '',
	                slidesPerRow: 1,
	                slidesToShow: 1,
	                slidesToScroll: 1,
	                speed: 500,
	                swipe: true,
	                swipeToSlide: false,
	                touchMove: true,
	                touchThreshold: 5,
	                useCSS: true,
	                useTransform: true,
	                variableWidth: false,
	                vertical: false,
	                verticalSwiping: false,
	                waitForAnimate: true,
	                zIndex: 1000
	            };
	
	            _.initials = {
	                animating: false,
	                dragging: false,
	                autoPlayTimer: null,
	                currentDirection: 0,
	                currentLeft: null,
	                currentSlide: 0,
	                direction: 1,
	                $dots: null,
	                listWidth: null,
	                listHeight: null,
	                loadIndex: 0,
	                $nextArrow: null,
	                $prevArrow: null,
	                slideCount: null,
	                slideWidth: null,
	                $slideTrack: null,
	                $slides: null,
	                sliding: false,
	                slideOffset: 0,
	                swipeLeft: null,
	                $list: null,
	                touchObject: {},
	                transformsEnabled: false,
	                unslicked: false
	            };
	
	            $.extend(_, _.initials);
	
	            _.activeBreakpoint = null;
	            _.animType = null;
	            _.animProp = null;
	            _.breakpoints = [];
	            _.breakpointSettings = [];
	            _.cssTransitions = false;
	            _.focussed = false;
	            _.interrupted = false;
	            _.hidden = 'hidden';
	            _.paused = true;
	            _.positionProp = null;
	            _.respondTo = null;
	            _.rowCount = 1;
	            _.shouldClick = true;
	            _.$slider = $(element);
	            _.$slidesCache = null;
	            _.transformType = null;
	            _.transitionType = null;
	            _.visibilityChange = 'visibilitychange';
	            _.windowWidth = 0;
	            _.windowTimer = null;
	
	            dataSettings = $(element).data('slick') || {};
	
	            _.options = $.extend({}, _.defaults, settings, dataSettings);
	
	            _.currentSlide = _.options.initialSlide;
	
	            _.originalSettings = _.options;
	
	            if (typeof document.mozHidden !== 'undefined') {
	                _.hidden = 'mozHidden';
	                _.visibilityChange = 'mozvisibilitychange';
	            } else if (typeof document.webkitHidden !== 'undefined') {
	                _.hidden = 'webkitHidden';
	                _.visibilityChange = 'webkitvisibilitychange';
	            }
	
	            _.autoPlay = $.proxy(_.autoPlay, _);
	            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
	            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
	            _.changeSlide = $.proxy(_.changeSlide, _);
	            _.clickHandler = $.proxy(_.clickHandler, _);
	            _.selectHandler = $.proxy(_.selectHandler, _);
	            _.setPosition = $.proxy(_.setPosition, _);
	            _.swipeHandler = $.proxy(_.swipeHandler, _);
	            _.dragHandler = $.proxy(_.dragHandler, _);
	            _.keyHandler = $.proxy(_.keyHandler, _);
	
	            _.instanceUid = instanceUid++;
	
	            // A simple way to check for HTML strings
	            // Strict HTML recognition (must start with <)
	            // Extracted from jQuery v1.11 source
	            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
	
	
	            _.registerBreakpoints();
	            _.init(true);
	
	        }
	
	        return Slick;
	
	    }());
	
	    Slick.prototype.activateADA = function() {
	        var _ = this;
	
	        _.$slideTrack.find('.slick-active').attr({
	            'aria-hidden': 'false'
	        }).find('a, input, button, select').attr({
	            'tabindex': '0'
	        });
	
	    };
	
	    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
	
	        var _ = this;
	
	        if (typeof(index) === 'boolean') {
	            addBefore = index;
	            index = null;
	        } else if (index < 0 || (index >= _.slideCount)) {
	            return false;
	        }
	
	        _.unload();
	
	        if (typeof(index) === 'number') {
	            if (index === 0 && _.$slides.length === 0) {
	                $(markup).appendTo(_.$slideTrack);
	            } else if (addBefore) {
	                $(markup).insertBefore(_.$slides.eq(index));
	            } else {
	                $(markup).insertAfter(_.$slides.eq(index));
	            }
	        } else {
	            if (addBefore === true) {
	                $(markup).prependTo(_.$slideTrack);
	            } else {
	                $(markup).appendTo(_.$slideTrack);
	            }
	        }
	
	        _.$slides = _.$slideTrack.children(this.options.slide);
	
	        _.$slideTrack.children(this.options.slide).detach();
	
	        _.$slideTrack.append(_.$slides);
	
	        _.$slides.each(function(index, element) {
	            $(element).attr('data-slick-index', index);
	        });
	
	        _.$slidesCache = _.$slides;
	
	        _.reinit();
	
	    };
	
	    Slick.prototype.animateHeight = function() {
	        var _ = this;
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.animate({
	                height: targetHeight
	            }, _.options.speed);
	        }
	    };
	
	    Slick.prototype.animateSlide = function(targetLeft, callback) {
	
	        var animProps = {},
	            _ = this;
	
	        _.animateHeight();
	
	        if (_.options.rtl === true && _.options.vertical === false) {
	            targetLeft = -targetLeft;
	        }
	        if (_.transformsEnabled === false) {
	            if (_.options.vertical === false) {
	                _.$slideTrack.animate({
	                    left: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            } else {
	                _.$slideTrack.animate({
	                    top: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            }
	
	        } else {
	
	            if (_.cssTransitions === false) {
	                if (_.options.rtl === true) {
	                    _.currentLeft = -(_.currentLeft);
	                }
	                $({
	                    animStart: _.currentLeft
	                }).animate({
	                    animStart: targetLeft
	                }, {
	                    duration: _.options.speed,
	                    easing: _.options.easing,
	                    step: function(now) {
	                        now = Math.ceil(now);
	                        if (_.options.vertical === false) {
	                            animProps[_.animType] = 'translate(' +
	                                now + 'px, 0px)';
	                            _.$slideTrack.css(animProps);
	                        } else {
	                            animProps[_.animType] = 'translate(0px,' +
	                                now + 'px)';
	                            _.$slideTrack.css(animProps);
	                        }
	                    },
	                    complete: function() {
	                        if (callback) {
	                            callback.call();
	                        }
	                    }
	                });
	
	            } else {
	
	                _.applyTransition();
	                targetLeft = Math.ceil(targetLeft);
	
	                if (_.options.vertical === false) {
	                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
	                } else {
	                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
	                }
	                _.$slideTrack.css(animProps);
	
	                if (callback) {
	                    setTimeout(function() {
	
	                        _.disableTransition();
	
	                        callback.call();
	                    }, _.options.speed);
	                }
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.getNavTarget = function() {
	
	        var _ = this,
	            asNavFor = _.options.asNavFor;
	
	        if ( asNavFor && asNavFor !== null ) {
	            asNavFor = $(asNavFor).not(_.$slider);
	        }
	
	        return asNavFor;
	
	    };
	
	    Slick.prototype.asNavFor = function(index) {
	
	        var _ = this,
	            asNavFor = _.getNavTarget();
	
	        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
	            asNavFor.each(function() {
	                var target = $(this).slick('getSlick');
	                if(!target.unslicked) {
	                    target.slideHandler(index, true);
	                }
	            });
	        }
	
	    };
	
	    Slick.prototype.applyTransition = function(slide) {
	
	        var _ = this,
	            transition = {};
	
	        if (_.options.fade === false) {
	            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
	        } else {
	            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
	        }
	
	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	
	    };
	
	    Slick.prototype.autoPlay = function() {
	
	        var _ = this;
	
	        _.autoPlayClear();
	
	        if ( _.slideCount > _.options.slidesToShow ) {
	            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
	        }
	
	    };
	
	    Slick.prototype.autoPlayClear = function() {
	
	        var _ = this;
	
	        if (_.autoPlayTimer) {
	            clearInterval(_.autoPlayTimer);
	        }
	
	    };
	
	    Slick.prototype.autoPlayIterator = function() {
	
	        var _ = this,
	            slideTo = _.currentSlide + _.options.slidesToScroll;
	
	        if ( !_.paused && !_.interrupted && !_.focussed ) {
	
	            if ( _.options.infinite === false ) {
	
	                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
	                    _.direction = 0;
	                }
	
	                else if ( _.direction === 0 ) {
	
	                    slideTo = _.currentSlide - _.options.slidesToScroll;
	
	                    if ( _.currentSlide - 1 === 0 ) {
	                        _.direction = 1;
	                    }
	
	                }
	
	            }
	
	            _.slideHandler( slideTo );
	
	        }
	
	    };
	
	    Slick.prototype.buildArrows = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true ) {
	
	            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
	            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
	
	            if( _.slideCount > _.options.slidesToShow ) {
	
	                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	
	                if (_.htmlExpr.test(_.options.prevArrow)) {
	                    _.$prevArrow.prependTo(_.options.appendArrows);
	                }
	
	                if (_.htmlExpr.test(_.options.nextArrow)) {
	                    _.$nextArrow.appendTo(_.options.appendArrows);
	                }
	
	                if (_.options.infinite !== true) {
	                    _.$prevArrow
	                        .addClass('slick-disabled')
	                        .attr('aria-disabled', 'true');
	                }
	
	            } else {
	
	                _.$prevArrow.add( _.$nextArrow )
	
	                    .addClass('slick-hidden')
	                    .attr({
	                        'aria-disabled': 'true',
	                        'tabindex': '-1'
	                    });
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.buildDots = function() {
	
	        var _ = this,
	            i, dot;
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$slider.addClass('slick-dotted');
	
	            dot = $('<ul />').addClass(_.options.dotsClass);
	
	            for (i = 0; i <= _.getDotCount(); i += 1) {
	                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
	            }
	
	            _.$dots = dot.appendTo(_.options.appendDots);
	
	            _.$dots.find('li').first().addClass('slick-active').attr('aria-hidden', 'false');
	
	        }
	
	    };
	
	    Slick.prototype.buildOut = function() {
	
	        var _ = this;
	
	        _.$slides =
	            _.$slider
	                .children( _.options.slide + ':not(.slick-cloned)')
	                .addClass('slick-slide');
	
	        _.slideCount = _.$slides.length;
	
	        _.$slides.each(function(index, element) {
	            $(element)
	                .attr('data-slick-index', index)
	                .data('originalStyling', $(element).attr('style') || '');
	        });
	
	        _.$slider.addClass('slick-slider');
	
	        _.$slideTrack = (_.slideCount === 0) ?
	            $('<div class="slick-track"/>').appendTo(_.$slider) :
	            _.$slides.wrapAll('<div class="slick-track"/>').parent();
	
	        _.$list = _.$slideTrack.wrap(
	            '<div aria-live="polite" class="slick-list"/>').parent();
	        _.$slideTrack.css('opacity', 0);
	
	        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
	            _.options.slidesToScroll = 1;
	        }
	
	        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
	
	        _.setupInfinite();
	
	        _.buildArrows();
	
	        _.buildDots();
	
	        _.updateDots();
	
	
	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
	
	        if (_.options.draggable === true) {
	            _.$list.addClass('draggable');
	        }
	
	    };
	
	    Slick.prototype.buildRows = function() {
	
	        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;
	
	        newSlides = document.createDocumentFragment();
	        originalSlides = _.$slider.children();
	
	        if(_.options.rows > 1) {
	
	            slidesPerSection = _.options.slidesPerRow * _.options.rows;
	            numOfSlides = Math.ceil(
	                originalSlides.length / slidesPerSection
	            );
	
	            for(a = 0; a < numOfSlides; a++){
	                var slide = document.createElement('div');
	                for(b = 0; b < _.options.rows; b++) {
	                    var row = document.createElement('div');
	                    for(c = 0; c < _.options.slidesPerRow; c++) {
	                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
	                        if (originalSlides.get(target)) {
	                            row.appendChild(originalSlides.get(target));
	                        }
	                    }
	                    slide.appendChild(row);
	                }
	                newSlides.appendChild(slide);
	            }
	
	            _.$slider.empty().append(newSlides);
	            _.$slider.children().children().children()
	                .css({
	                    'width':(100 / _.options.slidesPerRow) + '%',
	                    'display': 'inline-block'
	                });
	
	        }
	
	    };
	
	    Slick.prototype.checkResponsive = function(initial, forceUpdate) {
	
	        var _ = this,
	            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
	        var sliderWidth = _.$slider.width();
	        var windowWidth = window.innerWidth || $(window).width();
	
	        if (_.respondTo === 'window') {
	            respondToWidth = windowWidth;
	        } else if (_.respondTo === 'slider') {
	            respondToWidth = sliderWidth;
	        } else if (_.respondTo === 'min') {
	            respondToWidth = Math.min(windowWidth, sliderWidth);
	        }
	
	        if ( _.options.responsive &&
	            _.options.responsive.length &&
	            _.options.responsive !== null) {
	
	            targetBreakpoint = null;
	
	            for (breakpoint in _.breakpoints) {
	                if (_.breakpoints.hasOwnProperty(breakpoint)) {
	                    if (_.originalSettings.mobileFirst === false) {
	                        if (respondToWidth < _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    } else {
	                        if (respondToWidth > _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    }
	                }
	            }
	
	            if (targetBreakpoint !== null) {
	                if (_.activeBreakpoint !== null) {
	                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
	                        _.activeBreakpoint =
	                            targetBreakpoint;
	                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                            _.unslick(targetBreakpoint);
	                        } else {
	                            _.options = $.extend({}, _.originalSettings,
	                                _.breakpointSettings[
	                                    targetBreakpoint]);
	                            if (initial === true) {
	                                _.currentSlide = _.options.initialSlide;
	                            }
	                            _.refresh(initial);
	                        }
	                        triggerBreakpoint = targetBreakpoint;
	                    }
	                } else {
	                    _.activeBreakpoint = targetBreakpoint;
	                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                        _.unslick(targetBreakpoint);
	                    } else {
	                        _.options = $.extend({}, _.originalSettings,
	                            _.breakpointSettings[
	                                targetBreakpoint]);
	                        if (initial === true) {
	                            _.currentSlide = _.options.initialSlide;
	                        }
	                        _.refresh(initial);
	                    }
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            } else {
	                if (_.activeBreakpoint !== null) {
	                    _.activeBreakpoint = null;
	                    _.options = _.originalSettings;
	                    if (initial === true) {
	                        _.currentSlide = _.options.initialSlide;
	                    }
	                    _.refresh(initial);
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            }
	
	            // only trigger breakpoints during an actual break. not on initialize.
	            if( !initial && triggerBreakpoint !== false ) {
	                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
	            }
	        }
	
	    };
	
	    Slick.prototype.changeSlide = function(event, dontAnimate) {
	
	        var _ = this,
	            $target = $(event.currentTarget),
	            indexOffset, slideOffset, unevenOffset;
	
	        // If target is a link, prevent default action.
	        if($target.is('a')) {
	            event.preventDefault();
	        }
	
	        // If target is not the <li> element (ie: a child), find the <li>.
	        if(!$target.is('li')) {
	            $target = $target.closest('li');
	        }
	
	        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
	        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
	
	        switch (event.data.message) {
	
	            case 'previous':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
	                }
	                break;
	
	            case 'next':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
	                }
	                break;
	
	            case 'index':
	                var index = event.data.index === 0 ? 0 :
	                    event.data.index || $target.index() * _.options.slidesToScroll;
	
	                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
	                $target.children().trigger('focus');
	                break;
	
	            default:
	                return;
	        }
	
	    };
	
	    Slick.prototype.checkNavigable = function(index) {
	
	        var _ = this,
	            navigables, prevNavigable;
	
	        navigables = _.getNavigableIndexes();
	        prevNavigable = 0;
	        if (index > navigables[navigables.length - 1]) {
	            index = navigables[navigables.length - 1];
	        } else {
	            for (var n in navigables) {
	                if (index < navigables[n]) {
	                    index = prevNavigable;
	                    break;
	                }
	                prevNavigable = navigables[n];
	            }
	        }
	
	        return index;
	    };
	
	    Slick.prototype.cleanUpEvents = function() {
	
	        var _ = this;
	
	        if (_.options.dots && _.$dots !== null) {
	
	            $('li', _.$dots)
	                .off('click.slick', _.changeSlide)
	                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
	                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	        _.$slider.off('focus.slick blur.slick');
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
	            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
	        }
	
	        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
	        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
	        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
	        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
	
	        _.$list.off('click.slick', _.clickHandler);
	
	        $(document).off(_.visibilityChange, _.visibility);
	
	        _.cleanUpSlideEvents();
	
	        if (_.options.accessibility === true) {
	            _.$list.off('keydown.slick', _.keyHandler);
	        }
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
	        }
	
	        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
	
	        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
	
	        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
	
	        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
	        $(document).off('ready.slick.slick-' + _.instanceUid, _.setPosition);
	
	    };
	
	    Slick.prototype.cleanUpSlideEvents = function() {
	
	        var _ = this;
	
	        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
	        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	    };
	
	    Slick.prototype.cleanUpRows = function() {
	
	        var _ = this, originalSlides;
	
	        if(_.options.rows > 1) {
	            originalSlides = _.$slides.children().children();
	            originalSlides.removeAttr('style');
	            _.$slider.empty().append(originalSlides);
	        }
	
	    };
	
	    Slick.prototype.clickHandler = function(event) {
	
	        var _ = this;
	
	        if (_.shouldClick === false) {
	            event.stopImmediatePropagation();
	            event.stopPropagation();
	            event.preventDefault();
	        }
	
	    };
	
	    Slick.prototype.destroy = function(refresh) {
	
	        var _ = this;
	
	        _.autoPlayClear();
	
	        _.touchObject = {};
	
	        _.cleanUpEvents();
	
	        $('.slick-cloned', _.$slider).detach();
	
	        if (_.$dots) {
	            _.$dots.remove();
	        }
	
	
	        if ( _.$prevArrow && _.$prevArrow.length ) {
	
	            _.$prevArrow
	                .removeClass('slick-disabled slick-arrow slick-hidden')
	                .removeAttr('aria-hidden aria-disabled tabindex')
	                .css('display','');
	
	            if ( _.htmlExpr.test( _.options.prevArrow )) {
	                _.$prevArrow.remove();
	            }
	        }
	
	        if ( _.$nextArrow && _.$nextArrow.length ) {
	
	            _.$nextArrow
	                .removeClass('slick-disabled slick-arrow slick-hidden')
	                .removeAttr('aria-hidden aria-disabled tabindex')
	                .css('display','');
	
	            if ( _.htmlExpr.test( _.options.nextArrow )) {
	                _.$nextArrow.remove();
	            }
	
	        }
	
	
	        if (_.$slides) {
	
	            _.$slides
	                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
	                .removeAttr('aria-hidden')
	                .removeAttr('data-slick-index')
	                .each(function(){
	                    $(this).attr('style', $(this).data('originalStyling'));
	                });
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slideTrack.detach();
	
	            _.$list.detach();
	
	            _.$slider.append(_.$slides);
	        }
	
	        _.cleanUpRows();
	
	        _.$slider.removeClass('slick-slider');
	        _.$slider.removeClass('slick-initialized');
	        _.$slider.removeClass('slick-dotted');
	
	        _.unslicked = true;
	
	        if(!refresh) {
	            _.$slider.trigger('destroy', [_]);
	        }
	
	    };
	
	    Slick.prototype.disableTransition = function(slide) {
	
	        var _ = this,
	            transition = {};
	
	        transition[_.transitionType] = '';
	
	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	
	    };
	
	    Slick.prototype.fadeSlide = function(slideIndex, callback) {
	
	        var _ = this;
	
	        if (_.cssTransitions === false) {
	
	            _.$slides.eq(slideIndex).css({
	                zIndex: _.options.zIndex
	            });
	
	            _.$slides.eq(slideIndex).animate({
	                opacity: 1
	            }, _.options.speed, _.options.easing, callback);
	
	        } else {
	
	            _.applyTransition(slideIndex);
	
	            _.$slides.eq(slideIndex).css({
	                opacity: 1,
	                zIndex: _.options.zIndex
	            });
	
	            if (callback) {
	                setTimeout(function() {
	
	                    _.disableTransition(slideIndex);
	
	                    callback.call();
	                }, _.options.speed);
	            }
	
	        }
	
	    };
	
	    Slick.prototype.fadeSlideOut = function(slideIndex) {
	
	        var _ = this;
	
	        if (_.cssTransitions === false) {
	
	            _.$slides.eq(slideIndex).animate({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            }, _.options.speed, _.options.easing);
	
	        } else {
	
	            _.applyTransition(slideIndex);
	
	            _.$slides.eq(slideIndex).css({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            });
	
	        }
	
	    };
	
	    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
	
	        var _ = this;
	
	        if (filter !== null) {
	
	            _.$slidesCache = _.$slides;
	
	            _.unload();
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
	
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.focusHandler = function() {
	
	        var _ = this;
	
	        _.$slider
	            .off('focus.slick blur.slick')
	            .on('focus.slick blur.slick',
	                '*:not(.slick-arrow)', function(event) {
	
	            event.stopImmediatePropagation();
	            var $sf = $(this);
	
	            setTimeout(function() {
	
	                if( _.options.pauseOnFocus ) {
	                    _.focussed = $sf.is(':focus');
	                    _.autoPlay();
	                }
	
	            }, 0);
	
	        });
	    };
	
	    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
	
	        var _ = this;
	        return _.currentSlide;
	
	    };
	
	    Slick.prototype.getDotCount = function() {
	
	        var _ = this;
	
	        var breakPoint = 0;
	        var counter = 0;
	        var pagerQty = 0;
	
	        if (_.options.infinite === true) {
	            while (breakPoint < _.slideCount) {
	                ++pagerQty;
	                breakPoint = counter + _.options.slidesToScroll;
	                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	            }
	        } else if (_.options.centerMode === true) {
	            pagerQty = _.slideCount;
	        } else if(!_.options.asNavFor) {
	            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
	        }else {
	            while (breakPoint < _.slideCount) {
	                ++pagerQty;
	                breakPoint = counter + _.options.slidesToScroll;
	                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	            }
	        }
	
	        return pagerQty - 1;
	
	    };
	
	    Slick.prototype.getLeft = function(slideIndex) {
	
	        var _ = this,
	            targetLeft,
	            verticalHeight,
	            verticalOffset = 0,
	            targetSlide;
	
	        _.slideOffset = 0;
	        verticalHeight = _.$slides.first().outerHeight(true);
	
	        if (_.options.infinite === true) {
	            if (_.slideCount > _.options.slidesToShow) {
	                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
	                verticalOffset = (verticalHeight * _.options.slidesToShow) * -1;
	            }
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
	                    if (slideIndex > _.slideCount) {
	                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
	                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
	                    } else {
	                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
	                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
	                    }
	                }
	            }
	        } else {
	            if (slideIndex + _.options.slidesToShow > _.slideCount) {
	                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
	                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
	            }
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = 0;
	            verticalOffset = 0;
	        }
	
	        if (_.options.centerMode === true && _.options.infinite === true) {
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
	        } else if (_.options.centerMode === true) {
	            _.slideOffset = 0;
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
	        }
	
	        if (_.options.vertical === false) {
	            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
	        } else {
	            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
	        }
	
	        if (_.options.variableWidth === true) {
	
	            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	            } else {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
	            }
	
	            if (_.options.rtl === true) {
	                if (targetSlide[0]) {
	                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                } else {
	                    targetLeft =  0;
	                }
	            } else {
	                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	            }
	
	            if (_.options.centerMode === true) {
	                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	                } else {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
	                }
	
	                if (_.options.rtl === true) {
	                    if (targetSlide[0]) {
	                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                    } else {
	                        targetLeft =  0;
	                    }
	                } else {
	                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	                }
	
	                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
	            }
	        }
	
	        return targetLeft;
	
	    };
	
	    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
	
	        var _ = this;
	
	        return _.options[option];
	
	    };
	
	    Slick.prototype.getNavigableIndexes = function() {
	
	        var _ = this,
	            breakPoint = 0,
	            counter = 0,
	            indexes = [],
	            max;
	
	        if (_.options.infinite === false) {
	            max = _.slideCount;
	        } else {
	            breakPoint = _.options.slidesToScroll * -1;
	            counter = _.options.slidesToScroll * -1;
	            max = _.slideCount * 2;
	        }
	
	        while (breakPoint < max) {
	            indexes.push(breakPoint);
	            breakPoint = counter + _.options.slidesToScroll;
	            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	        }
	
	        return indexes;
	
	    };
	
	    Slick.prototype.getSlick = function() {
	
	        return this;
	
	    };
	
	    Slick.prototype.getSlideCount = function() {
	
	        var _ = this,
	            slidesTraversed, swipedSlide, centerOffset;
	
	        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
	
	        if (_.options.swipeToSlide === true) {
	            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
	                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
	                    swipedSlide = slide;
	                    return false;
	                }
	            });
	
	            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
	
	            return slidesTraversed;
	
	        } else {
	            return _.options.slidesToScroll;
	        }
	
	    };
	
	    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'index',
	                index: parseInt(slide)
	            }
	        }, dontAnimate);
	
	    };
	
	    Slick.prototype.init = function(creation) {
	
	        var _ = this;
	
	        if (!$(_.$slider).hasClass('slick-initialized')) {
	
	            $(_.$slider).addClass('slick-initialized');
	
	            _.buildRows();
	            _.buildOut();
	            _.setProps();
	            _.startLoad();
	            _.loadSlider();
	            _.initializeEvents();
	            _.updateArrows();
	            _.updateDots();
	            _.checkResponsive(true);
	            _.focusHandler();
	
	        }
	
	        if (creation) {
	            _.$slider.trigger('init', [_]);
	        }
	
	        if (_.options.accessibility === true) {
	            _.initADA();
	        }
	
	        if ( _.options.autoplay ) {
	
	            _.paused = false;
	            _.autoPlay();
	
	        }
	
	    };
	
	    Slick.prototype.initADA = function() {
	        var _ = this;
	        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
	            'aria-hidden': 'true',
	            'tabindex': '-1'
	        }).find('a, input, button, select').attr({
	            'tabindex': '-1'
	        });
	
	        _.$slideTrack.attr('role', 'listbox');
	
	        _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
	            $(this).attr({
	                'role': 'option',
	                'aria-describedby': 'slick-slide' + _.instanceUid + i + ''
	            });
	        });
	
	        if (_.$dots !== null) {
	            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
	                $(this).attr({
	                    'role': 'presentation',
	                    'aria-selected': 'false',
	                    'aria-controls': 'navigation' + _.instanceUid + i + '',
	                    'id': 'slick-slide' + _.instanceUid + i + ''
	                });
	            })
	                .first().attr('aria-selected', 'true').end()
	                .find('button').attr('role', 'button').end()
	                .closest('div').attr('role', 'toolbar');
	        }
	        _.activateADA();
	
	    };
	
	    Slick.prototype.initArrowEvents = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow
	               .off('click.slick')
	               .on('click.slick', {
	                    message: 'previous'
	               }, _.changeSlide);
	            _.$nextArrow
	               .off('click.slick')
	               .on('click.slick', {
	                    message: 'next'
	               }, _.changeSlide);
	        }
	
	    };
	
	    Slick.prototype.initDotEvents = function() {
	
	        var _ = this;
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	            $('li', _.$dots).on('click.slick', {
	                message: 'index'
	            }, _.changeSlide);
	        }
	
	        if ( _.options.dots === true && _.options.pauseOnDotsHover === true ) {
	
	            $('li', _.$dots)
	                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
	                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	    };
	
	    Slick.prototype.initSlideEvents = function() {
	
	        var _ = this;
	
	        if ( _.options.pauseOnHover ) {
	
	            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
	            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	    };
	
	    Slick.prototype.initializeEvents = function() {
	
	        var _ = this;
	
	        _.initArrowEvents();
	
	        _.initDotEvents();
	        _.initSlideEvents();
	
	        _.$list.on('touchstart.slick mousedown.slick', {
	            action: 'start'
	        }, _.swipeHandler);
	        _.$list.on('touchmove.slick mousemove.slick', {
	            action: 'move'
	        }, _.swipeHandler);
	        _.$list.on('touchend.slick mouseup.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	        _.$list.on('touchcancel.slick mouseleave.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	
	        _.$list.on('click.slick', _.clickHandler);
	
	        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
	
	        if (_.options.accessibility === true) {
	            _.$list.on('keydown.slick', _.keyHandler);
	        }
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }
	
	        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
	
	        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
	
	        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
	
	        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
	        $(document).on('ready.slick.slick-' + _.instanceUid, _.setPosition);
	
	    };
	
	    Slick.prototype.initUI = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$prevArrow.show();
	            _.$nextArrow.show();
	
	        }
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$dots.show();
	
	        }
	
	    };
	
	    Slick.prototype.keyHandler = function(event) {
	
	        var _ = this;
	         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	            if (event.keyCode === 37 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'next' :  'previous'
	                    }
	                });
	            } else if (event.keyCode === 39 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'previous' : 'next'
	                    }
	                });
	            }
	        }
	
	    };
	
	    Slick.prototype.lazyLoad = function() {
	
	        var _ = this,
	            loadRange, cloneRange, rangeStart, rangeEnd;
	
	        function loadImages(imagesScope) {
	
	            $('img[data-lazy]', imagesScope).each(function() {
	
	                var image = $(this),
	                    imageSource = $(this).attr('data-lazy'),
	                    imageToLoad = document.createElement('img');
	
	                imageToLoad.onload = function() {
	
	                    image
	                        .animate({ opacity: 0 }, 100, function() {
	                            image
	                                .attr('src', imageSource)
	                                .animate({ opacity: 1 }, 200, function() {
	                                    image
	                                        .removeAttr('data-lazy')
	                                        .removeClass('slick-loading');
	                                });
	                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
	                        });
	
	                };
	
	                imageToLoad.onerror = function() {
	
	                    image
	                        .removeAttr( 'data-lazy' )
	                        .removeClass( 'slick-loading' )
	                        .addClass( 'slick-lazyload-error' );
	
	                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);
	
	                };
	
	                imageToLoad.src = imageSource;
	
	            });
	
	        }
	
	        if (_.options.centerMode === true) {
	            if (_.options.infinite === true) {
	                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
	                rangeEnd = rangeStart + _.options.slidesToShow + 2;
	            } else {
	                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
	                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
	            }
	        } else {
	            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
	            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
	            if (_.options.fade === true) {
	                if (rangeStart > 0) rangeStart--;
	                if (rangeEnd <= _.slideCount) rangeEnd++;
	            }
	        }
	
	        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
	        loadImages(loadRange);
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-slide');
	            loadImages(cloneRange);
	        } else
	        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
	            loadImages(cloneRange);
	        } else if (_.currentSlide === 0) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
	            loadImages(cloneRange);
	        }
	
	    };
	
	    Slick.prototype.loadSlider = function() {
	
	        var _ = this;
	
	        _.setPosition();
	
	        _.$slideTrack.css({
	            opacity: 1
	        });
	
	        _.$slider.removeClass('slick-loading');
	
	        _.initUI();
	
	        if (_.options.lazyLoad === 'progressive') {
	            _.progressiveLazyLoad();
	        }
	
	    };
	
	    Slick.prototype.next = Slick.prototype.slickNext = function() {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'next'
	            }
	        });
	
	    };
	
	    Slick.prototype.orientationChange = function() {
	
	        var _ = this;
	
	        _.checkResponsive();
	        _.setPosition();
	
	    };
	
	    Slick.prototype.pause = Slick.prototype.slickPause = function() {
	
	        var _ = this;
	
	        _.autoPlayClear();
	        _.paused = true;
	
	    };
	
	    Slick.prototype.play = Slick.prototype.slickPlay = function() {
	
	        var _ = this;
	
	        _.autoPlay();
	        _.options.autoplay = true;
	        _.paused = false;
	        _.focussed = false;
	        _.interrupted = false;
	
	    };
	
	    Slick.prototype.postSlide = function(index) {
	
	        var _ = this;
	
	        if( !_.unslicked ) {
	
	            _.$slider.trigger('afterChange', [_, index]);
	
	            _.animating = false;
	
	            _.setPosition();
	
	            _.swipeLeft = null;
	
	            if ( _.options.autoplay ) {
	                _.autoPlay();
	            }
	
	            if (_.options.accessibility === true) {
	                _.initADA();
	            }
	
	        }
	
	    };
	
	    Slick.prototype.prev = Slick.prototype.slickPrev = function() {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'previous'
	            }
	        });
	
	    };
	
	    Slick.prototype.preventDefault = function(event) {
	
	        event.preventDefault();
	
	    };
	
	    Slick.prototype.progressiveLazyLoad = function( tryCount ) {
	
	        tryCount = tryCount || 1;
	
	        var _ = this,
	            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
	            image,
	            imageSource,
	            imageToLoad;
	
	        if ( $imgsToLoad.length ) {
	
	            image = $imgsToLoad.first();
	            imageSource = image.attr('data-lazy');
	            imageToLoad = document.createElement('img');
	
	            imageToLoad.onload = function() {
	
	                image
	                    .attr( 'src', imageSource )
	                    .removeAttr('data-lazy')
	                    .removeClass('slick-loading');
	
	                if ( _.options.adaptiveHeight === true ) {
	                    _.setPosition();
	                }
	
	                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
	                _.progressiveLazyLoad();
	
	            };
	
	            imageToLoad.onerror = function() {
	
	                if ( tryCount < 3 ) {
	
	                    /**
	                     * try to load the image 3 times,
	                     * leave a slight delay so we don't get
	                     * servers blocking the request.
	                     */
	                    setTimeout( function() {
	                        _.progressiveLazyLoad( tryCount + 1 );
	                    }, 500 );
	
	                } else {
	
	                    image
	                        .removeAttr( 'data-lazy' )
	                        .removeClass( 'slick-loading' )
	                        .addClass( 'slick-lazyload-error' );
	
	                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);
	
	                    _.progressiveLazyLoad();
	
	                }
	
	            };
	
	            imageToLoad.src = imageSource;
	
	        } else {
	
	            _.$slider.trigger('allImagesLoaded', [ _ ]);
	
	        }
	
	    };
	
	    Slick.prototype.refresh = function( initializing ) {
	
	        var _ = this, currentSlide, lastVisibleIndex;
	
	        lastVisibleIndex = _.slideCount - _.options.slidesToShow;
	
	        // in non-infinite sliders, we don't want to go past the
	        // last visible index.
	        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
	            _.currentSlide = lastVisibleIndex;
	        }
	
	        // if less slides than to show, go to start.
	        if ( _.slideCount <= _.options.slidesToShow ) {
	            _.currentSlide = 0;
	
	        }
	
	        currentSlide = _.currentSlide;
	
	        _.destroy(true);
	
	        $.extend(_, _.initials, { currentSlide: currentSlide });
	
	        _.init();
	
	        if( !initializing ) {
	
	            _.changeSlide({
	                data: {
	                    message: 'index',
	                    index: currentSlide
	                }
	            }, false);
	
	        }
	
	    };
	
	    Slick.prototype.registerBreakpoints = function() {
	
	        var _ = this, breakpoint, currentBreakpoint, l,
	            responsiveSettings = _.options.responsive || null;
	
	        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {
	
	            _.respondTo = _.options.respondTo || 'window';
	
	            for ( breakpoint in responsiveSettings ) {
	
	                l = _.breakpoints.length-1;
	                currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
	
	                if (responsiveSettings.hasOwnProperty(breakpoint)) {
	
	                    // loop through the breakpoints and cut out any existing
	                    // ones with the same breakpoint number, we don't want dupes.
	                    while( l >= 0 ) {
	                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
	                            _.breakpoints.splice(l,1);
	                        }
	                        l--;
	                    }
	
	                    _.breakpoints.push(currentBreakpoint);
	                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
	
	                }
	
	            }
	
	            _.breakpoints.sort(function(a, b) {
	                return ( _.options.mobileFirst ) ? a-b : b-a;
	            });
	
	        }
	
	    };
	
	    Slick.prototype.reinit = function() {
	
	        var _ = this;
	
	        _.$slides =
	            _.$slideTrack
	                .children(_.options.slide)
	                .addClass('slick-slide');
	
	        _.slideCount = _.$slides.length;
	
	        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
	            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.currentSlide = 0;
	        }
	
	        _.registerBreakpoints();
	
	        _.setProps();
	        _.setupInfinite();
	        _.buildArrows();
	        _.updateArrows();
	        _.initArrowEvents();
	        _.buildDots();
	        _.updateDots();
	        _.initDotEvents();
	        _.cleanUpSlideEvents();
	        _.initSlideEvents();
	
	        _.checkResponsive(false, true);
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }
	
	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
	
	        _.setPosition();
	        _.focusHandler();
	
	        _.paused = !_.options.autoplay;
	        _.autoPlay();
	
	        _.$slider.trigger('reInit', [_]);
	
	    };
	
	    Slick.prototype.resize = function() {
	
	        var _ = this;
	
	        if ($(window).width() !== _.windowWidth) {
	            clearTimeout(_.windowDelay);
	            _.windowDelay = window.setTimeout(function() {
	                _.windowWidth = $(window).width();
	                _.checkResponsive();
	                if( !_.unslicked ) { _.setPosition(); }
	            }, 50);
	        }
	    };
	
	    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
	
	        var _ = this;
	
	        if (typeof(index) === 'boolean') {
	            removeBefore = index;
	            index = removeBefore === true ? 0 : _.slideCount - 1;
	        } else {
	            index = removeBefore === true ? --index : index;
	        }
	
	        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
	            return false;
	        }
	
	        _.unload();
	
	        if (removeAll === true) {
	            _.$slideTrack.children().remove();
	        } else {
	            _.$slideTrack.children(this.options.slide).eq(index).remove();
	        }
	
	        _.$slides = _.$slideTrack.children(this.options.slide);
	
	        _.$slideTrack.children(this.options.slide).detach();
	
	        _.$slideTrack.append(_.$slides);
	
	        _.$slidesCache = _.$slides;
	
	        _.reinit();
	
	    };
	
	    Slick.prototype.setCSS = function(position) {
	
	        var _ = this,
	            positionProps = {},
	            x, y;
	
	        if (_.options.rtl === true) {
	            position = -position;
	        }
	        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
	        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
	
	        positionProps[_.positionProp] = position;
	
	        if (_.transformsEnabled === false) {
	            _.$slideTrack.css(positionProps);
	        } else {
	            positionProps = {};
	            if (_.cssTransitions === false) {
	                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
	                _.$slideTrack.css(positionProps);
	            } else {
	                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
	                _.$slideTrack.css(positionProps);
	            }
	        }
	
	    };
	
	    Slick.prototype.setDimensions = function() {
	
	        var _ = this;
	
	        if (_.options.vertical === false) {
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: ('0px ' + _.options.centerPadding)
	                });
	            }
	        } else {
	            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: (_.options.centerPadding + ' 0px')
	                });
	            }
	        }
	
	        _.listWidth = _.$list.width();
	        _.listHeight = _.$list.height();
	
	
	        if (_.options.vertical === false && _.options.variableWidth === false) {
	            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
	            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));
	
	        } else if (_.options.variableWidth === true) {
	            _.$slideTrack.width(5000 * _.slideCount);
	        } else {
	            _.slideWidth = Math.ceil(_.listWidth);
	            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
	        }
	
	        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
	        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
	
	    };
	
	    Slick.prototype.setFade = function() {
	
	        var _ = this,
	            targetLeft;
	
	        _.$slides.each(function(index, element) {
	            targetLeft = (_.slideWidth * index) * -1;
	            if (_.options.rtl === true) {
	                $(element).css({
	                    position: 'relative',
	                    right: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            } else {
	                $(element).css({
	                    position: 'relative',
	                    left: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            }
	        });
	
	        _.$slides.eq(_.currentSlide).css({
	            zIndex: _.options.zIndex - 1,
	            opacity: 1
	        });
	
	    };
	
	    Slick.prototype.setHeight = function() {
	
	        var _ = this;
	
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.css('height', targetHeight);
	        }
	
	    };
	
	    Slick.prototype.setOption =
	    Slick.prototype.slickSetOption = function() {
	
	        /**
	         * accepts arguments in format of:
	         *
	         *  - for changing a single option's value:
	         *     .slick("setOption", option, value, refresh )
	         *
	         *  - for changing a set of responsive options:
	         *     .slick("setOption", 'responsive', [{}, ...], refresh )
	         *
	         *  - for updating multiple values at once (not responsive)
	         *     .slick("setOption", { 'option': value, ... }, refresh )
	         */
	
	        var _ = this, l, item, option, value, refresh = false, type;
	
	        if( $.type( arguments[0] ) === 'object' ) {
	
	            option =  arguments[0];
	            refresh = arguments[1];
	            type = 'multiple';
	
	        } else if ( $.type( arguments[0] ) === 'string' ) {
	
	            option =  arguments[0];
	            value = arguments[1];
	            refresh = arguments[2];
	
	            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {
	
	                type = 'responsive';
	
	            } else if ( typeof arguments[1] !== 'undefined' ) {
	
	                type = 'single';
	
	            }
	
	        }
	
	        if ( type === 'single' ) {
	
	            _.options[option] = value;
	
	
	        } else if ( type === 'multiple' ) {
	
	            $.each( option , function( opt, val ) {
	
	                _.options[opt] = val;
	
	            });
	
	
	        } else if ( type === 'responsive' ) {
	
	            for ( item in value ) {
	
	                if( $.type( _.options.responsive ) !== 'array' ) {
	
	                    _.options.responsive = [ value[item] ];
	
	                } else {
	
	                    l = _.options.responsive.length-1;
	
	                    // loop through the responsive object and splice out duplicates.
	                    while( l >= 0 ) {
	
	                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {
	
	                            _.options.responsive.splice(l,1);
	
	                        }
	
	                        l--;
	
	                    }
	
	                    _.options.responsive.push( value[item] );
	
	                }
	
	            }
	
	        }
	
	        if ( refresh ) {
	
	            _.unload();
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.setPosition = function() {
	
	        var _ = this;
	
	        _.setDimensions();
	
	        _.setHeight();
	
	        if (_.options.fade === false) {
	            _.setCSS(_.getLeft(_.currentSlide));
	        } else {
	            _.setFade();
	        }
	
	        _.$slider.trigger('setPosition', [_]);
	
	    };
	
	    Slick.prototype.setProps = function() {
	
	        var _ = this,
	            bodyStyle = document.body.style;
	
	        _.positionProp = _.options.vertical === true ? 'top' : 'left';
	
	        if (_.positionProp === 'top') {
	            _.$slider.addClass('slick-vertical');
	        } else {
	            _.$slider.removeClass('slick-vertical');
	        }
	
	        if (bodyStyle.WebkitTransition !== undefined ||
	            bodyStyle.MozTransition !== undefined ||
	            bodyStyle.msTransition !== undefined) {
	            if (_.options.useCSS === true) {
	                _.cssTransitions = true;
	            }
	        }
	
	        if ( _.options.fade ) {
	            if ( typeof _.options.zIndex === 'number' ) {
	                if( _.options.zIndex < 3 ) {
	                    _.options.zIndex = 3;
	                }
	            } else {
	                _.options.zIndex = _.defaults.zIndex;
	            }
	        }
	
	        if (bodyStyle.OTransform !== undefined) {
	            _.animType = 'OTransform';
	            _.transformType = '-o-transform';
	            _.transitionType = 'OTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.MozTransform !== undefined) {
	            _.animType = 'MozTransform';
	            _.transformType = '-moz-transform';
	            _.transitionType = 'MozTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.webkitTransform !== undefined) {
	            _.animType = 'webkitTransform';
	            _.transformType = '-webkit-transform';
	            _.transitionType = 'webkitTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.msTransform !== undefined) {
	            _.animType = 'msTransform';
	            _.transformType = '-ms-transform';
	            _.transitionType = 'msTransition';
	            if (bodyStyle.msTransform === undefined) _.animType = false;
	        }
	        if (bodyStyle.transform !== undefined && _.animType !== false) {
	            _.animType = 'transform';
	            _.transformType = 'transform';
	            _.transitionType = 'transition';
	        }
	        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
	    };
	
	
	    Slick.prototype.setSlideClasses = function(index) {
	
	        var _ = this,
	            centerOffset, allSlides, indexOffset, remainder;
	
	        allSlides = _.$slider
	            .find('.slick-slide')
	            .removeClass('slick-active slick-center slick-current')
	            .attr('aria-hidden', 'true');
	
	        _.$slides
	            .eq(index)
	            .addClass('slick-current');
	
	        if (_.options.centerMode === true) {
	
	            centerOffset = Math.floor(_.options.slidesToShow / 2);
	
	            if (_.options.infinite === true) {
	
	                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
	
	                    _.$slides
	                        .slice(index - centerOffset, index + centerOffset + 1)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                } else {
	
	                    indexOffset = _.options.slidesToShow + index;
	                    allSlides
	                        .slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                }
	
	                if (index === 0) {
	
	                    allSlides
	                        .eq(allSlides.length - 1 - _.options.slidesToShow)
	                        .addClass('slick-center');
	
	                } else if (index === _.slideCount - 1) {
	
	                    allSlides
	                        .eq(_.options.slidesToShow)
	                        .addClass('slick-center');
	
	                }
	
	            }
	
	            _.$slides
	                .eq(index)
	                .addClass('slick-center');
	
	        } else {
	
	            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {
	
	                _.$slides
	                    .slice(index, index + _.options.slidesToShow)
	                    .addClass('slick-active')
	                    .attr('aria-hidden', 'false');
	
	            } else if (allSlides.length <= _.options.slidesToShow) {
	
	                allSlides
	                    .addClass('slick-active')
	                    .attr('aria-hidden', 'false');
	
	            } else {
	
	                remainder = _.slideCount % _.options.slidesToShow;
	                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
	
	                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {
	
	                    allSlides
	                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                } else {
	
	                    allSlides
	                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                }
	
	            }
	
	        }
	
	        if (_.options.lazyLoad === 'ondemand') {
	            _.lazyLoad();
	        }
	
	    };
	
	    Slick.prototype.setupInfinite = function() {
	
	        var _ = this,
	            i, slideIndex, infiniteCount;
	
	        if (_.options.fade === true) {
	            _.options.centerMode = false;
	        }
	
	        if (_.options.infinite === true && _.options.fade === false) {
	
	            slideIndex = null;
	
	            if (_.slideCount > _.options.slidesToShow) {
	
	                if (_.options.centerMode === true) {
	                    infiniteCount = _.options.slidesToShow + 1;
	                } else {
	                    infiniteCount = _.options.slidesToShow;
	                }
	
	                for (i = _.slideCount; i > (_.slideCount -
	                        infiniteCount); i -= 1) {
	                    slideIndex = i - 1;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
	                        .attr('data-slick-index', slideIndex - _.slideCount)
	                        .prependTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                for (i = 0; i < infiniteCount; i += 1) {
	                    slideIndex = i;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
	                        .attr('data-slick-index', slideIndex + _.slideCount)
	                        .appendTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
	                    $(this).attr('id', '');
	                });
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.interrupt = function( toggle ) {
	
	        var _ = this;
	
	        if( !toggle ) {
	            _.autoPlay();
	        }
	        _.interrupted = toggle;
	
	    };
	
	    Slick.prototype.selectHandler = function(event) {
	
	        var _ = this;
	
	        var targetElement =
	            $(event.target).is('.slick-slide') ?
	                $(event.target) :
	                $(event.target).parents('.slick-slide');
	
	        var index = parseInt(targetElement.attr('data-slick-index'));
	
	        if (!index) index = 0;
	
	        if (_.slideCount <= _.options.slidesToShow) {
	
	            _.setSlideClasses(index);
	            _.asNavFor(index);
	            return;
	
	        }
	
	        _.slideHandler(index);
	
	    };
	
	    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
	
	        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
	            _ = this, navTarget;
	
	        sync = sync || false;
	
	        if (_.animating === true && _.options.waitForAnimate === true) {
	            return;
	        }
	
	        if (_.options.fade === true && _.currentSlide === index) {
	            return;
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            return;
	        }
	
	        if (sync === false) {
	            _.asNavFor(index);
	        }
	
	        targetSlide = index;
	        targetLeft = _.getLeft(targetSlide);
	        slideLeft = _.getLeft(_.currentSlide);
	
	        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
	
	        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true) {
	                    _.animateSlide(slideLeft, function() {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true) {
	                    _.animateSlide(slideLeft, function() {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        }
	
	        if ( _.options.autoplay ) {
	            clearInterval(_.autoPlayTimer);
	        }
	
	        if (targetSlide < 0) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
	            } else {
	                animSlide = _.slideCount + targetSlide;
	            }
	        } else if (targetSlide >= _.slideCount) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = 0;
	            } else {
	                animSlide = targetSlide - _.slideCount;
	            }
	        } else {
	            animSlide = targetSlide;
	        }
	
	        _.animating = true;
	
	        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);
	
	        oldSlide = _.currentSlide;
	        _.currentSlide = animSlide;
	
	        _.setSlideClasses(_.currentSlide);
	
	        if ( _.options.asNavFor ) {
	
	            navTarget = _.getNavTarget();
	            navTarget = navTarget.slick('getSlick');
	
	            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
	                navTarget.setSlideClasses(_.currentSlide);
	            }
	
	        }
	
	        _.updateDots();
	        _.updateArrows();
	
	        if (_.options.fade === true) {
	            if (dontAnimate !== true) {
	
	                _.fadeSlideOut(oldSlide);
	
	                _.fadeSlide(animSlide, function() {
	                    _.postSlide(animSlide);
	                });
	
	            } else {
	                _.postSlide(animSlide);
	            }
	            _.animateHeight();
	            return;
	        }
	
	        if (dontAnimate !== true) {
	            _.animateSlide(targetLeft, function() {
	                _.postSlide(animSlide);
	            });
	        } else {
	            _.postSlide(animSlide);
	        }
	
	    };
	
	    Slick.prototype.startLoad = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$prevArrow.hide();
	            _.$nextArrow.hide();
	
	        }
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$dots.hide();
	
	        }
	
	        _.$slider.addClass('slick-loading');
	
	    };
	
	    Slick.prototype.swipeDirection = function() {
	
	        var xDist, yDist, r, swipeAngle, _ = this;
	
	        xDist = _.touchObject.startX - _.touchObject.curX;
	        yDist = _.touchObject.startY - _.touchObject.curY;
	        r = Math.atan2(yDist, xDist);
	
	        swipeAngle = Math.round(r * 180 / Math.PI);
	        if (swipeAngle < 0) {
	            swipeAngle = 360 - Math.abs(swipeAngle);
	        }
	
	        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
	            return (_.options.rtl === false ? 'left' : 'right');
	        }
	        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
	            return (_.options.rtl === false ? 'left' : 'right');
	        }
	        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
	            return (_.options.rtl === false ? 'right' : 'left');
	        }
	        if (_.options.verticalSwiping === true) {
	            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
	                return 'down';
	            } else {
	                return 'up';
	            }
	        }
	
	        return 'vertical';
	
	    };
	
	    Slick.prototype.swipeEnd = function(event) {
	
	        var _ = this,
	            slideCount,
	            direction;
	
	        _.dragging = false;
	        _.interrupted = false;
	        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;
	
	        if ( _.touchObject.curX === undefined ) {
	            return false;
	        }
	
	        if ( _.touchObject.edgeHit === true ) {
	            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
	        }
	
	        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {
	
	            direction = _.swipeDirection();
	
	            switch ( direction ) {
	
	                case 'left':
	                case 'down':
	
	                    slideCount =
	                        _.options.swipeToSlide ?
	                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
	                            _.currentSlide + _.getSlideCount();
	
	                    _.currentDirection = 0;
	
	                    break;
	
	                case 'right':
	                case 'up':
	
	                    slideCount =
	                        _.options.swipeToSlide ?
	                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
	                            _.currentSlide - _.getSlideCount();
	
	                    _.currentDirection = 1;
	
	                    break;
	
	                default:
	
	
	            }
	
	            if( direction != 'vertical' ) {
	
	                _.slideHandler( slideCount );
	                _.touchObject = {};
	                _.$slider.trigger('swipe', [_, direction ]);
	
	            }
	
	        } else {
	
	            if ( _.touchObject.startX !== _.touchObject.curX ) {
	
	                _.slideHandler( _.currentSlide );
	                _.touchObject = {};
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.swipeHandler = function(event) {
	
	        var _ = this;
	
	        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
	            return;
	        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
	            return;
	        }
	
	        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
	            event.originalEvent.touches.length : 1;
	
	        _.touchObject.minSwipe = _.listWidth / _.options
	            .touchThreshold;
	
	        if (_.options.verticalSwiping === true) {
	            _.touchObject.minSwipe = _.listHeight / _.options
	                .touchThreshold;
	        }
	
	        switch (event.data.action) {
	
	            case 'start':
	                _.swipeStart(event);
	                break;
	
	            case 'move':
	                _.swipeMove(event);
	                break;
	
	            case 'end':
	                _.swipeEnd(event);
	                break;
	
	        }
	
	    };
	
	    Slick.prototype.swipeMove = function(event) {
	
	        var _ = this,
	            edgeWasHit = false,
	            curLeft, swipeDirection, swipeLength, positionOffset, touches;
	
	        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
	
	        if (!_.dragging || touches && touches.length !== 1) {
	            return false;
	        }
	
	        curLeft = _.getLeft(_.currentSlide);
	
	        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
	        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
	
	        _.touchObject.swipeLength = Math.round(Math.sqrt(
	            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
	
	        if (_.options.verticalSwiping === true) {
	            _.touchObject.swipeLength = Math.round(Math.sqrt(
	                Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
	        }
	
	        swipeDirection = _.swipeDirection();
	
	        if (swipeDirection === 'vertical') {
	            return;
	        }
	
	        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
	            event.preventDefault();
	        }
	
	        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
	        if (_.options.verticalSwiping === true) {
	            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
	        }
	
	
	        swipeLength = _.touchObject.swipeLength;
	
	        _.touchObject.edgeHit = false;
	
	        if (_.options.infinite === false) {
	            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
	                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
	                _.touchObject.edgeHit = true;
	            }
	        }
	
	        if (_.options.vertical === false) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        } else {
	            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
	        }
	        if (_.options.verticalSwiping === true) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        }
	
	        if (_.options.fade === true || _.options.touchMove === false) {
	            return false;
	        }
	
	        if (_.animating === true) {
	            _.swipeLeft = null;
	            return false;
	        }
	
	        _.setCSS(_.swipeLeft);
	
	    };
	
	    Slick.prototype.swipeStart = function(event) {
	
	        var _ = this,
	            touches;
	
	        _.interrupted = true;
	
	        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
	            _.touchObject = {};
	            return false;
	        }
	
	        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
	            touches = event.originalEvent.touches[0];
	        }
	
	        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
	        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
	
	        _.dragging = true;
	
	    };
	
	    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
	
	        var _ = this;
	
	        if (_.$slidesCache !== null) {
	
	            _.unload();
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slidesCache.appendTo(_.$slideTrack);
	
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.unload = function() {
	
	        var _ = this;
	
	        $('.slick-cloned', _.$slider).remove();
	
	        if (_.$dots) {
	            _.$dots.remove();
	        }
	
	        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
	            _.$prevArrow.remove();
	        }
	
	        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
	            _.$nextArrow.remove();
	        }
	
	        _.$slides
	            .removeClass('slick-slide slick-active slick-visible slick-current')
	            .attr('aria-hidden', 'true')
	            .css('width', '');
	
	    };
	
	    Slick.prototype.unslick = function(fromBreakpoint) {
	
	        var _ = this;
	        _.$slider.trigger('unslick', [_, fromBreakpoint]);
	        _.destroy();
	
	    };
	
	    Slick.prototype.updateArrows = function() {
	
	        var _ = this,
	            centerOffset;
	
	        centerOffset = Math.floor(_.options.slidesToShow / 2);
	
	        if ( _.options.arrows === true &&
	            _.slideCount > _.options.slidesToShow &&
	            !_.options.infinite ) {
	
	            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            if (_.currentSlide === 0) {
	
	                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
	
	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
	
	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.updateDots = function() {
	
	        var _ = this;
	
	        if (_.$dots !== null) {
	
	            _.$dots
	                .find('li')
	                .removeClass('slick-active')
	                .attr('aria-hidden', 'true');
	
	            _.$dots
	                .find('li')
	                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
	                .addClass('slick-active')
	                .attr('aria-hidden', 'false');
	
	        }
	
	    };
	
	    Slick.prototype.visibility = function() {
	
	        var _ = this;
	
	        if ( _.options.autoplay ) {
	
	            if ( document[_.hidden] ) {
	
	                _.interrupted = true;
	
	            } else {
	
	                _.interrupted = false;
	
	            }
	
	        }
	
	    };
	
	    $.fn.slick = function() {
	        var _ = this,
	            opt = arguments[0],
	            args = Array.prototype.slice.call(arguments, 1),
	            l = _.length,
	            i,
	            ret;
	        for (i = 0; i < l; i++) {
	            if (typeof opt == 'object' || typeof opt == 'undefined')
	                _[i].slick = new Slick(_[i], opt);
	            else
	                ret = _[i].slick[opt].apply(_[i].slick, args);
	            if (typeof ret != 'undefined') return ret;
	        }
	        return _;
	    };
	
	}));


/***/ }),

/***/ 1118:
983,

/***/ 1120:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1121);
	module.exports = __webpack_require__(1123);

/***/ }),

/***/ 1121:
983,

/***/ 1123:
/***/ (function(module, exports, __webpack_require__) {

	/* @license C3.js v0.4.24 | (c) C3 Team and other contributors | http://c3js.org/ */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.c3 = factory());
	}(this, (function () { 'use strict';
	
	    var CLASS = {
	        target: 'c3-target',
	        chart: 'c3-chart',
	        chartLine: 'c3-chart-line',
	        chartLines: 'c3-chart-lines',
	        chartBar: 'c3-chart-bar',
	        chartBars: 'c3-chart-bars',
	        chartText: 'c3-chart-text',
	        chartTexts: 'c3-chart-texts',
	        chartArc: 'c3-chart-arc',
	        chartArcs: 'c3-chart-arcs',
	        chartArcsTitle: 'c3-chart-arcs-title',
	        chartArcsBackground: 'c3-chart-arcs-background',
	        chartArcsGaugeUnit: 'c3-chart-arcs-gauge-unit',
	        chartArcsGaugeMax: 'c3-chart-arcs-gauge-max',
	        chartArcsGaugeMin: 'c3-chart-arcs-gauge-min',
	        selectedCircle: 'c3-selected-circle',
	        selectedCircles: 'c3-selected-circles',
	        eventRect: 'c3-event-rect',
	        eventRects: 'c3-event-rects',
	        eventRectsSingle: 'c3-event-rects-single',
	        eventRectsMultiple: 'c3-event-rects-multiple',
	        zoomRect: 'c3-zoom-rect',
	        brush: 'c3-brush',
	        focused: 'c3-focused',
	        defocused: 'c3-defocused',
	        region: 'c3-region',
	        regions: 'c3-regions',
	        title: 'c3-title',
	        tooltipContainer: 'c3-tooltip-container',
	        tooltip: 'c3-tooltip',
	        tooltipName: 'c3-tooltip-name',
	        shape: 'c3-shape',
	        shapes: 'c3-shapes',
	        line: 'c3-line',
	        lines: 'c3-lines',
	        bar: 'c3-bar',
	        bars: 'c3-bars',
	        circle: 'c3-circle',
	        circles: 'c3-circles',
	        arc: 'c3-arc',
	        arcLabelLine: 'c3-arc-label-line',
	        arcs: 'c3-arcs',
	        area: 'c3-area',
	        areas: 'c3-areas',
	        empty: 'c3-empty',
	        text: 'c3-text',
	        texts: 'c3-texts',
	        gaugeValue: 'c3-gauge-value',
	        grid: 'c3-grid',
	        gridLines: 'c3-grid-lines',
	        xgrid: 'c3-xgrid',
	        xgrids: 'c3-xgrids',
	        xgridLine: 'c3-xgrid-line',
	        xgridLines: 'c3-xgrid-lines',
	        xgridFocus: 'c3-xgrid-focus',
	        ygrid: 'c3-ygrid',
	        ygrids: 'c3-ygrids',
	        ygridLine: 'c3-ygrid-line',
	        ygridLines: 'c3-ygrid-lines',
	        axis: 'c3-axis',
	        axisX: 'c3-axis-x',
	        axisXLabel: 'c3-axis-x-label',
	        axisY: 'c3-axis-y',
	        axisYLabel: 'c3-axis-y-label',
	        axisY2: 'c3-axis-y2',
	        axisY2Label: 'c3-axis-y2-label',
	        legendBackground: 'c3-legend-background',
	        legendItem: 'c3-legend-item',
	        legendItemEvent: 'c3-legend-item-event',
	        legendItemTile: 'c3-legend-item-tile',
	        legendItemHidden: 'c3-legend-item-hidden',
	        legendItemFocused: 'c3-legend-item-focused',
	        dragarea: 'c3-dragarea',
	        EXPANDED: '_expanded_',
	        SELECTED: '_selected_',
	        INCLUDED: '_included_'
	    };
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	      return typeof obj;
	    } : function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    var classCallCheck = function (instance, Constructor) {
	      if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	      }
	    };
	
	    var inherits = function (subClass, superClass) {
	      if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	      }
	
	      subClass.prototype = Object.create(superClass && superClass.prototype, {
	        constructor: {
	          value: subClass,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      });
	      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    };
	
	    var possibleConstructorReturn = function (self, call) {
	      if (!self) {
	        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	      }
	
	      return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    };
	
	    var isValue = function isValue(v) {
	        return v || v === 0;
	    };
	    var isFunction = function isFunction(o) {
	        return typeof o === 'function';
	    };
	    var isArray = function isArray(o) {
	        return Array.isArray(o);
	    };
	    var isString = function isString(o) {
	        return typeof o === 'string';
	    };
	    var isUndefined = function isUndefined(v) {
	        return typeof v === 'undefined';
	    };
	    var isDefined = function isDefined(v) {
	        return typeof v !== 'undefined';
	    };
	    var ceil10 = function ceil10(v) {
	        return Math.ceil(v / 10) * 10;
	    };
	    var asHalfPixel = function asHalfPixel(n) {
	        return Math.ceil(n) + 0.5;
	    };
	    var diffDomain = function diffDomain(d) {
	        return d[1] - d[0];
	    };
	    var isEmpty = function isEmpty(o) {
	        return typeof o === 'undefined' || o === null || isString(o) && o.length === 0 || (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' && Object.keys(o).length === 0;
	    };
	    var notEmpty = function notEmpty(o) {
	        return !c3_chart_internal_fn.isEmpty(o);
	    };
	    var getOption = function getOption(options, key, defaultValue) {
	        return isDefined(options[key]) ? options[key] : defaultValue;
	    };
	    var hasValue = function hasValue(dict, value) {
	        var found = false;
	        Object.keys(dict).forEach(function (key) {
	            if (dict[key] === value) {
	                found = true;
	            }
	        });
	        return found;
	    };
	    var sanitise = function sanitise(str) {
	        return typeof str === 'string' ? str.replace(/</g, '&lt;').replace(/>/g, '&gt;') : str;
	    };
	    var getPathBox = function getPathBox(path) {
	        var box = path.getBoundingClientRect(),
	            items = [path.pathSegList.getItem(0), path.pathSegList.getItem(1)],
	            minX = items[0].x,
	            minY = Math.min(items[0].y, items[1].y);
	        return { x: minX, y: minY, width: box.width, height: box.height };
	    };
	
	    var c3_axis_fn;
	    var c3_axis_internal_fn;
	
	    function AxisInternal(component, params) {
	        var internal = this;
	        internal.component = component;
	        internal.params = params || {};
	
	        internal.d3 = component.d3;
	        internal.scale = internal.d3.scale.linear();
	        internal.range;
	        internal.orient = "bottom";
	        internal.innerTickSize = 6;
	        internal.outerTickSize = this.params.withOuterTick ? 6 : 0;
	        internal.tickPadding = 3;
	        internal.tickValues = null;
	        internal.tickFormat;
	        internal.tickArguments;
	
	        internal.tickOffset = 0;
	        internal.tickCulling = true;
	        internal.tickCentered;
	        internal.tickTextCharSize;
	        internal.tickTextRotate = internal.params.tickTextRotate;
	        internal.tickLength;
	
	        internal.axis = internal.generateAxis();
	    }
	    c3_axis_internal_fn = AxisInternal.prototype;
	
	    c3_axis_internal_fn.axisX = function (selection, x, tickOffset) {
	        selection.attr("transform", function (d) {
	            return "translate(" + Math.ceil(x(d) + tickOffset) + ", 0)";
	        });
	    };
	    c3_axis_internal_fn.axisY = function (selection, y) {
	        selection.attr("transform", function (d) {
	            return "translate(0," + Math.ceil(y(d)) + ")";
	        });
	    };
	    c3_axis_internal_fn.scaleExtent = function (domain) {
	        var start = domain[0],
	            stop = domain[domain.length - 1];
	        return start < stop ? [start, stop] : [stop, start];
	    };
	    c3_axis_internal_fn.generateTicks = function (scale) {
	        var internal = this;
	        var i,
	            domain,
	            ticks = [];
	        if (scale.ticks) {
	            return scale.ticks.apply(scale, internal.tickArguments);
	        }
	        domain = scale.domain();
	        for (i = Math.ceil(domain[0]); i < domain[1]; i++) {
	            ticks.push(i);
	        }
	        if (ticks.length > 0 && ticks[0] > 0) {
	            ticks.unshift(ticks[0] - (ticks[1] - ticks[0]));
	        }
	        return ticks;
	    };
	    c3_axis_internal_fn.copyScale = function () {
	        var internal = this;
	        var newScale = internal.scale.copy(),
	            domain;
	        if (internal.params.isCategory) {
	            domain = internal.scale.domain();
	            newScale.domain([domain[0], domain[1] - 1]);
	        }
	        return newScale;
	    };
	    c3_axis_internal_fn.textFormatted = function (v) {
	        var internal = this,
	            formatted = internal.tickFormat ? internal.tickFormat(v) : v;
	        return typeof formatted !== 'undefined' ? formatted : '';
	    };
	    c3_axis_internal_fn.updateRange = function () {
	        var internal = this;
	        internal.range = internal.scale.rangeExtent ? internal.scale.rangeExtent() : internal.scaleExtent(internal.scale.range());
	        return internal.range;
	    };
	    c3_axis_internal_fn.updateTickTextCharSize = function (tick) {
	        var internal = this;
	        if (internal.tickTextCharSize) {
	            return internal.tickTextCharSize;
	        }
	        var size = {
	            h: 11.5,
	            w: 5.5
	        };
	        tick.select('text').text(function (d) {
	            return internal.textFormatted(d);
	        }).each(function (d) {
	            var box = this.getBoundingClientRect(),
	                text = internal.textFormatted(d),
	                h = box.height,
	                w = text ? box.width / text.length : undefined;
	            if (h && w) {
	                size.h = h;
	                size.w = w;
	            }
	        }).text('');
	        internal.tickTextCharSize = size;
	        return size;
	    };
	    c3_axis_internal_fn.transitionise = function (selection) {
	        return this.params.withoutTransition ? selection : this.d3.transition(selection);
	    };
	    c3_axis_internal_fn.isVertical = function () {
	        return this.orient === 'left' || this.orient === 'right';
	    };
	    c3_axis_internal_fn.tspanData = function (d, i, ticks, scale) {
	        var internal = this;
	        var splitted = internal.params.tickMultiline ? internal.splitTickText(d, ticks, scale) : [].concat(internal.textFormatted(d));
	
	        if (internal.params.tickMultiline && internal.params.tickMultilineMax > 0) {
	            splitted = internal.ellipsify(splitted, internal.params.tickMultilineMax);
	        }
	
	        return splitted.map(function (s) {
	            return { index: i, splitted: s, length: splitted.length };
	        });
	    };
	    c3_axis_internal_fn.splitTickText = function (d, ticks, scale) {
	        var internal = this,
	            tickText = internal.textFormatted(d),
	            maxWidth = internal.params.tickWidth,
	            subtext,
	            spaceIndex,
	            textWidth,
	            splitted = [];
	
	        if (Object.prototype.toString.call(tickText) === "[object Array]") {
	            return tickText;
	        }
	
	        if (!maxWidth || maxWidth <= 0) {
	            maxWidth = internal.isVertical() ? 95 : internal.params.isCategory ? Math.ceil(scale(ticks[1]) - scale(ticks[0])) - 12 : 110;
	        }
	
	        function split(splitted, text) {
	            spaceIndex = undefined;
	            for (var i = 1; i < text.length; i++) {
	                if (text.charAt(i) === ' ') {
	                    spaceIndex = i;
	                }
	                subtext = text.substr(0, i + 1);
	                textWidth = internal.tickTextCharSize.w * subtext.length;
	                // if text width gets over tick width, split by space index or crrent index
	                if (maxWidth < textWidth) {
	                    return split(splitted.concat(text.substr(0, spaceIndex ? spaceIndex : i)), text.slice(spaceIndex ? spaceIndex + 1 : i));
	                }
	            }
	            return splitted.concat(text);
	        }
	
	        return split(splitted, tickText + "");
	    };
	    c3_axis_internal_fn.ellipsify = function (splitted, max) {
	        if (splitted.length <= max) {
	            return splitted;
	        }
	
	        var ellipsified = splitted.slice(0, max);
	        var remaining = 3;
	        for (var i = max - 1; i >= 0; i--) {
	            var available = ellipsified[i].length;
	
	            ellipsified[i] = ellipsified[i].substr(0, available - remaining).padEnd(available, '.');
	
	            remaining -= available;
	
	            if (remaining <= 0) {
	                break;
	            }
	        }
	
	        return ellipsified;
	    };
	    c3_axis_internal_fn.updateTickLength = function () {
	        var internal = this;
	        internal.tickLength = Math.max(internal.innerTickSize, 0) + internal.tickPadding;
	    };
	    c3_axis_internal_fn.lineY2 = function (d) {
	        var internal = this,
	            tickPosition = internal.scale(d) + (internal.tickCentered ? 0 : internal.tickOffset);
	        return internal.range[0] < tickPosition && tickPosition < internal.range[1] ? internal.innerTickSize : 0;
	    };
	    c3_axis_internal_fn.textY = function () {
	        var internal = this,
	            rotate = internal.tickTextRotate;
	        return rotate ? 11.5 - 2.5 * (rotate / 15) * (rotate > 0 ? 1 : -1) : internal.tickLength;
	    };
	    c3_axis_internal_fn.textTransform = function () {
	        var internal = this,
	            rotate = internal.tickTextRotate;
	        return rotate ? "rotate(" + rotate + ")" : "";
	    };
	    c3_axis_internal_fn.textTextAnchor = function () {
	        var internal = this,
	            rotate = internal.tickTextRotate;
	        return rotate ? rotate > 0 ? "start" : "end" : "middle";
	    };
	    c3_axis_internal_fn.tspanDx = function () {
	        var internal = this,
	            rotate = internal.tickTextRotate;
	        return rotate ? 8 * Math.sin(Math.PI * (rotate / 180)) : 0;
	    };
	    c3_axis_internal_fn.tspanDy = function (d, i) {
	        var internal = this,
	            dy = internal.tickTextCharSize.h;
	        if (i === 0) {
	            if (internal.isVertical()) {
	                dy = -((d.length - 1) * (internal.tickTextCharSize.h / 2) - 3);
	            } else {
	                dy = ".71em";
	            }
	        }
	        return dy;
	    };
	
	    c3_axis_internal_fn.generateAxis = function () {
	        var internal = this,
	            d3 = internal.d3,
	            params = internal.params;
	        function axis(g) {
	            g.each(function () {
	                var g = axis.g = d3.select(this);
	
	                var scale0 = this.__chart__ || internal.scale,
	                    scale1 = this.__chart__ = internal.copyScale();
	
	                var ticks = internal.tickValues ? internal.tickValues : internal.generateTicks(scale1),
	                    tick = g.selectAll(".tick").data(ticks, scale1),
	                    tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", 1e-6),
	
	                // MEMO: No exit transition. The reason is this transition affects max tick width calculation because old tick will be included in the ticks.
	                tickExit = tick.exit().remove(),
	                    tickUpdate = internal.transitionise(tick).style("opacity", 1),
	                    tickTransform,
	                    tickX,
	                    tickY;
	
	                if (params.isCategory) {
	                    internal.tickOffset = Math.ceil((scale1(1) - scale1(0)) / 2);
	                    tickX = internal.tickCentered ? 0 : internal.tickOffset;
	                    tickY = internal.tickCentered ? internal.tickOffset : 0;
	                } else {
	                    internal.tickOffset = tickX = 0;
	                }
	
	                tickEnter.append("line");
	                tickEnter.append("text");
	
	                internal.updateRange();
	                internal.updateTickLength();
	                internal.updateTickTextCharSize(g.select('.tick'));
	
	                var lineUpdate = tickUpdate.select("line"),
	                    textUpdate = tickUpdate.select("text"),
	                    tspanUpdate = tick.select("text").selectAll('tspan').data(function (d, i) {
	                    return internal.tspanData(d, i, ticks, scale1);
	                });
	
	                tspanUpdate.enter().append('tspan');
	                tspanUpdate.exit().remove();
	                tspanUpdate.text(function (d) {
	                    return d.splitted;
	                });
	
	                var path = g.selectAll(".domain").data([0]),
	                    pathUpdate = (path.enter().append("path").attr("class", "domain"), internal.transitionise(path));
	
	                // TODO: each attr should be one function and change its behavior by internal.orient, probably
	                switch (internal.orient) {
	                    case "bottom":
	                        {
	                            tickTransform = internal.axisX;
	                            lineUpdate.attr("x1", tickX).attr("x2", tickX).attr("y2", function (d, i) {
	                                return internal.lineY2(d, i);
	                            });
	                            textUpdate.attr("x", 0).attr("y", function (d, i) {
	                                return internal.textY(d, i);
	                            }).attr("transform", function (d, i) {
	                                return internal.textTransform(d, i);
	                            }).style("text-anchor", function (d, i) {
	                                return internal.textTextAnchor(d, i);
	                            });
	                            tspanUpdate.attr('x', 0).attr("dy", function (d, i) {
	                                return internal.tspanDy(d, i);
	                            }).attr('dx', function (d, i) {
	                                return internal.tspanDx(d, i);
	                            });
	                            pathUpdate.attr("d", "M" + internal.range[0] + "," + internal.outerTickSize + "V0H" + internal.range[1] + "V" + internal.outerTickSize);
	                            break;
	                        }
	                    case "top":
	                        {
	                            // TODO: rotated tick text
	                            tickTransform = internal.axisX;
	                            lineUpdate.attr("x1", tickX).attr("x2", tickX).attr("y2", function (d, i) {
	                                return -1 * internal.lineY2(d, i);
	                            });
	                            textUpdate.attr("x", 0).attr("y", function (d, i) {
	                                return -1 * internal.textY(d, i) - (params.isCategory ? 2 : internal.tickLength - 2);
	                            }).attr("transform", function (d, i) {
	                                return internal.textTransform(d, i);
	                            }).style("text-anchor", function (d, i) {
	                                return internal.textTextAnchor(d, i);
	                            });
	                            tspanUpdate.attr('x', 0).attr("dy", function (d, i) {
	                                return internal.tspanDy(d, i);
	                            }).attr('dx', function (d, i) {
	                                return internal.tspanDx(d, i);
	                            });
	                            pathUpdate.attr("d", "M" + internal.range[0] + "," + -internal.outerTickSize + "V0H" + internal.range[1] + "V" + -internal.outerTickSize);
	                            break;
	                        }
	                    case "left":
	                        {
	                            tickTransform = internal.axisY;
	                            lineUpdate.attr("x2", -internal.innerTickSize).attr("y1", tickY).attr("y2", tickY);
	                            textUpdate.attr("x", -internal.tickLength).attr("y", internal.tickOffset).style("text-anchor", "end");
	                            tspanUpdate.attr('x', -internal.tickLength).attr("dy", function (d, i) {
	                                return internal.tspanDy(d, i);
	                            });
	                            pathUpdate.attr("d", "M" + -internal.outerTickSize + "," + internal.range[0] + "H0V" + internal.range[1] + "H" + -internal.outerTickSize);
	                            break;
	                        }
	                    case "right":
	                        {
	                            tickTransform = internal.axisY;
	                            lineUpdate.attr("x2", internal.innerTickSize).attr("y1", tickY).attr("y2", tickY);
	                            textUpdate.attr("x", internal.tickLength).attr("y", internal.tickOffset).style("text-anchor", "start");
	                            tspanUpdate.attr('x', internal.tickLength).attr("dy", function (d, i) {
	                                return internal.tspanDy(d, i);
	                            });
	                            pathUpdate.attr("d", "M" + internal.outerTickSize + "," + internal.range[0] + "H0V" + internal.range[1] + "H" + internal.outerTickSize);
	                            break;
	                        }
	                }
	                if (scale1.rangeBand) {
	                    var x = scale1,
	                        dx = x.rangeBand() / 2;
	                    scale0 = scale1 = function scale1(d) {
	                        return x(d) + dx;
	                    };
	                } else if (scale0.rangeBand) {
	                    scale0 = scale1;
	                } else {
	                    tickExit.call(tickTransform, scale1, internal.tickOffset);
	                }
	                tickEnter.call(tickTransform, scale0, internal.tickOffset);
	                tickUpdate.call(tickTransform, scale1, internal.tickOffset);
	            });
	        }
	        axis.scale = function (x) {
	            if (!arguments.length) {
	                return internal.scale;
	            }
	            internal.scale = x;
	            return axis;
	        };
	        axis.orient = function (x) {
	            if (!arguments.length) {
	                return internal.orient;
	            }
	            internal.orient = x in { top: 1, right: 1, bottom: 1, left: 1 } ? x + "" : "bottom";
	            return axis;
	        };
	        axis.tickFormat = function (format) {
	            if (!arguments.length) {
	                return internal.tickFormat;
	            }
	            internal.tickFormat = format;
	            return axis;
	        };
	        axis.tickCentered = function (isCentered) {
	            if (!arguments.length) {
	                return internal.tickCentered;
	            }
	            internal.tickCentered = isCentered;
	            return axis;
	        };
	        axis.tickOffset = function () {
	            return internal.tickOffset;
	        };
	        axis.tickInterval = function () {
	            var interval, length;
	            if (params.isCategory) {
	                interval = internal.tickOffset * 2;
	            } else {
	                length = axis.g.select('path.domain').node().getTotalLength() - internal.outerTickSize * 2;
	                interval = length / axis.g.selectAll('line').size();
	            }
	            return interval === Infinity ? 0 : interval;
	        };
	        axis.ticks = function () {
	            if (!arguments.length) {
	                return internal.tickArguments;
	            }
	            internal.tickArguments = arguments;
	            return axis;
	        };
	        axis.tickCulling = function (culling) {
	            if (!arguments.length) {
	                return internal.tickCulling;
	            }
	            internal.tickCulling = culling;
	            return axis;
	        };
	        axis.tickValues = function (x) {
	            if (typeof x === 'function') {
	                internal.tickValues = function () {
	                    return x(internal.scale.domain());
	                };
	            } else {
	                if (!arguments.length) {
	                    return internal.tickValues;
	                }
	                internal.tickValues = x;
	            }
	            return axis;
	        };
	        return axis;
	    };
	
	    var Axis = function (_Component) {
	        inherits(Axis, _Component);
	
	        function Axis(owner) {
	            classCallCheck(this, Axis);
	
	            var fn = {
	                fn: c3_axis_fn,
	                internal: {
	                    fn: c3_axis_internal_fn
	                }
	            };
	
	            var _this = possibleConstructorReturn(this, (Axis.__proto__ || Object.getPrototypeOf(Axis)).call(this, owner, 'axis', fn));
	
	            _this.d3 = owner.d3;
	            _this.internal = AxisInternal;
	            return _this;
	        }
	
	        return Axis;
	    }(Component);
	
	    c3_axis_fn = Axis.prototype;
	
	    c3_axis_fn.init = function init() {
	        var $$ = this.owner,
	            config = $$.config,
	            main = $$.main;
	        $$.axes.x = main.append("g").attr("class", CLASS.axis + ' ' + CLASS.axisX).attr("clip-path", config.axis_x_inner ? "" : $$.clipPathForXAxis).attr("transform", $$.getTranslate('x')).style("visibility", config.axis_x_show ? 'visible' : 'hidden');
	        $$.axes.x.append("text").attr("class", CLASS.axisXLabel).attr("transform", config.axis_rotated ? "rotate(-90)" : "").style("text-anchor", this.textAnchorForXAxisLabel.bind(this));
	        $$.axes.y = main.append("g").attr("class", CLASS.axis + ' ' + CLASS.axisY).attr("clip-path", config.axis_y_inner ? "" : $$.clipPathForYAxis).attr("transform", $$.getTranslate('y')).style("visibility", config.axis_y_show ? 'visible' : 'hidden');
	        $$.axes.y.append("text").attr("class", CLASS.axisYLabel).attr("transform", config.axis_rotated ? "" : "rotate(-90)").style("text-anchor", this.textAnchorForYAxisLabel.bind(this));
	
	        $$.axes.y2 = main.append("g").attr("class", CLASS.axis + ' ' + CLASS.axisY2)
	        // clip-path?
	        .attr("transform", $$.getTranslate('y2')).style("visibility", config.axis_y2_show ? 'visible' : 'hidden');
	        $$.axes.y2.append("text").attr("class", CLASS.axisY2Label).attr("transform", config.axis_rotated ? "" : "rotate(-90)").style("text-anchor", this.textAnchorForY2AxisLabel.bind(this));
	    };
	    c3_axis_fn.getXAxis = function getXAxis(scale, orient, tickFormat, tickValues, withOuterTick, withoutTransition, withoutRotateTickText) {
	        var $$ = this.owner,
	            config = $$.config,
	            axisParams = {
	            isCategory: $$.isCategorized(),
	            withOuterTick: withOuterTick,
	            tickMultiline: config.axis_x_tick_multiline,
	            tickMultilineMax: config.axis_x_tick_multiline ? Number(config.axis_x_tick_multilineMax) : 0,
	            tickWidth: config.axis_x_tick_width,
	            tickTextRotate: withoutRotateTickText ? 0 : config.axis_x_tick_rotate,
	            withoutTransition: withoutTransition
	        },
	            axis = new this.internal(this, axisParams).axis.scale(scale).orient(orient);
	
	        if ($$.isTimeSeries() && tickValues && typeof tickValues !== "function") {
	            tickValues = tickValues.map(function (v) {
	                return $$.parseDate(v);
	            });
	        }
	
	        // Set tick
	        axis.tickFormat(tickFormat).tickValues(tickValues);
	        if ($$.isCategorized()) {
	            axis.tickCentered(config.axis_x_tick_centered);
	            if (isEmpty(config.axis_x_tick_culling)) {
	                config.axis_x_tick_culling = false;
	            }
	        }
	
	        return axis;
	    };
	    c3_axis_fn.updateXAxisTickValues = function updateXAxisTickValues(targets, axis) {
	        var $$ = this.owner,
	            config = $$.config,
	            tickValues;
	        if (config.axis_x_tick_fit || config.axis_x_tick_count) {
	            tickValues = this.generateTickValues($$.mapTargetsToUniqueXs(targets), config.axis_x_tick_count, $$.isTimeSeries());
	        }
	        if (axis) {
	            axis.tickValues(tickValues);
	        } else {
	            $$.xAxis.tickValues(tickValues);
	            $$.subXAxis.tickValues(tickValues);
	        }
	        return tickValues;
	    };
	    c3_axis_fn.getYAxis = function getYAxis(scale, orient, tickFormat, tickValues, withOuterTick, withoutTransition, withoutRotateTickText) {
	        var $$ = this.owner,
	            config = $$.config,
	            axisParams = {
	            withOuterTick: withOuterTick,
	            withoutTransition: withoutTransition,
	            tickTextRotate: withoutRotateTickText ? 0 : config.axis_y_tick_rotate
	        },
	            axis = new this.internal(this, axisParams).axis.scale(scale).orient(orient).tickFormat(tickFormat);
	        if ($$.isTimeSeriesY()) {
	            axis.ticks($$.d3.time[config.axis_y_tick_time_value], config.axis_y_tick_time_interval);
	        } else {
	            axis.tickValues(tickValues);
	        }
	        return axis;
	    };
	    c3_axis_fn.getId = function getId(id) {
	        var config = this.owner.config;
	        return id in config.data_axes ? config.data_axes[id] : 'y';
	    };
	    c3_axis_fn.getXAxisTickFormat = function getXAxisTickFormat() {
	        var $$ = this.owner,
	            config = $$.config,
	            format = $$.isTimeSeries() ? $$.defaultAxisTimeFormat : $$.isCategorized() ? $$.categoryName : function (v) {
	            return v < 0 ? v.toFixed(0) : v;
	        };
	        if (config.axis_x_tick_format) {
	            if (isFunction(config.axis_x_tick_format)) {
	                format = config.axis_x_tick_format;
	            } else if ($$.isTimeSeries()) {
	                format = function format(date) {
	                    return date ? $$.axisTimeFormat(config.axis_x_tick_format)(date) : "";
	                };
	            }
	        }
	        return isFunction(format) ? function (v) {
	            return format.call($$, v);
	        } : format;
	    };
	    c3_axis_fn.getTickValues = function getTickValues(tickValues, axis) {
	        return tickValues ? tickValues : axis ? axis.tickValues() : undefined;
	    };
	    c3_axis_fn.getXAxisTickValues = function getXAxisTickValues() {
	        return this.getTickValues(this.owner.config.axis_x_tick_values, this.owner.xAxis);
	    };
	    c3_axis_fn.getYAxisTickValues = function getYAxisTickValues() {
	        return this.getTickValues(this.owner.config.axis_y_tick_values, this.owner.yAxis);
	    };
	    c3_axis_fn.getY2AxisTickValues = function getY2AxisTickValues() {
	        return this.getTickValues(this.owner.config.axis_y2_tick_values, this.owner.y2Axis);
	    };
	    c3_axis_fn.getLabelOptionByAxisId = function getLabelOptionByAxisId(axisId) {
	        var $$ = this.owner,
	            config = $$.config,
	            option;
	        if (axisId === 'y') {
	            option = config.axis_y_label;
	        } else if (axisId === 'y2') {
	            option = config.axis_y2_label;
	        } else if (axisId === 'x') {
	            option = config.axis_x_label;
	        }
	        return option;
	    };
	    c3_axis_fn.getLabelText = function getLabelText(axisId) {
	        var option = this.getLabelOptionByAxisId(axisId);
	        return isString(option) ? option : option ? option.text : null;
	    };
	    c3_axis_fn.setLabelText = function setLabelText(axisId, text) {
	        var $$ = this.owner,
	            config = $$.config,
	            option = this.getLabelOptionByAxisId(axisId);
	        if (isString(option)) {
	            if (axisId === 'y') {
	                config.axis_y_label = text;
	            } else if (axisId === 'y2') {
	                config.axis_y2_label = text;
	            } else if (axisId === 'x') {
	                config.axis_x_label = text;
	            }
	        } else if (option) {
	            option.text = text;
	        }
	    };
	    c3_axis_fn.getLabelPosition = function getLabelPosition(axisId, defaultPosition) {
	        var option = this.getLabelOptionByAxisId(axisId),
	            position = option && (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' && option.position ? option.position : defaultPosition;
	        return {
	            isInner: position.indexOf('inner') >= 0,
	            isOuter: position.indexOf('outer') >= 0,
	            isLeft: position.indexOf('left') >= 0,
	            isCenter: position.indexOf('center') >= 0,
	            isRight: position.indexOf('right') >= 0,
	            isTop: position.indexOf('top') >= 0,
	            isMiddle: position.indexOf('middle') >= 0,
	            isBottom: position.indexOf('bottom') >= 0
	        };
	    };
	    c3_axis_fn.getXAxisLabelPosition = function getXAxisLabelPosition() {
	        return this.getLabelPosition('x', this.owner.config.axis_rotated ? 'inner-top' : 'inner-right');
	    };
	    c3_axis_fn.getYAxisLabelPosition = function getYAxisLabelPosition() {
	        return this.getLabelPosition('y', this.owner.config.axis_rotated ? 'inner-right' : 'inner-top');
	    };
	    c3_axis_fn.getY2AxisLabelPosition = function getY2AxisLabelPosition() {
	        return this.getLabelPosition('y2', this.owner.config.axis_rotated ? 'inner-right' : 'inner-top');
	    };
	    c3_axis_fn.getLabelPositionById = function getLabelPositionById(id) {
	        return id === 'y2' ? this.getY2AxisLabelPosition() : id === 'y' ? this.getYAxisLabelPosition() : this.getXAxisLabelPosition();
	    };
	    c3_axis_fn.textForXAxisLabel = function textForXAxisLabel() {
	        return this.getLabelText('x');
	    };
	    c3_axis_fn.textForYAxisLabel = function textForYAxisLabel() {
	        return this.getLabelText('y');
	    };
	    c3_axis_fn.textForY2AxisLabel = function textForY2AxisLabel() {
	        return this.getLabelText('y2');
	    };
	    c3_axis_fn.xForAxisLabel = function xForAxisLabel(forHorizontal, position) {
	        var $$ = this.owner;
	        if (forHorizontal) {
	            return position.isLeft ? 0 : position.isCenter ? $$.width / 2 : $$.width;
	        } else {
	            return position.isBottom ? -$$.height : position.isMiddle ? -$$.height / 2 : 0;
	        }
	    };
	    c3_axis_fn.dxForAxisLabel = function dxForAxisLabel(forHorizontal, position) {
	        if (forHorizontal) {
	            return position.isLeft ? "0.5em" : position.isRight ? "-0.5em" : "0";
	        } else {
	            return position.isTop ? "-0.5em" : position.isBottom ? "0.5em" : "0";
	        }
	    };
	    c3_axis_fn.textAnchorForAxisLabel = function textAnchorForAxisLabel(forHorizontal, position) {
	        if (forHorizontal) {
	            return position.isLeft ? 'start' : position.isCenter ? 'middle' : 'end';
	        } else {
	            return position.isBottom ? 'start' : position.isMiddle ? 'middle' : 'end';
	        }
	    };
	    c3_axis_fn.xForXAxisLabel = function xForXAxisLabel() {
	        return this.xForAxisLabel(!this.owner.config.axis_rotated, this.getXAxisLabelPosition());
	    };
	    c3_axis_fn.xForYAxisLabel = function xForYAxisLabel() {
	        return this.xForAxisLabel(this.owner.config.axis_rotated, this.getYAxisLabelPosition());
	    };
	    c3_axis_fn.xForY2AxisLabel = function xForY2AxisLabel() {
	        return this.xForAxisLabel(this.owner.config.axis_rotated, this.getY2AxisLabelPosition());
	    };
	    c3_axis_fn.dxForXAxisLabel = function dxForXAxisLabel() {
	        return this.dxForAxisLabel(!this.owner.config.axis_rotated, this.getXAxisLabelPosition());
	    };
	    c3_axis_fn.dxForYAxisLabel = function dxForYAxisLabel() {
	        return this.dxForAxisLabel(this.owner.config.axis_rotated, this.getYAxisLabelPosition());
	    };
	    c3_axis_fn.dxForY2AxisLabel = function dxForY2AxisLabel() {
	        return this.dxForAxisLabel(this.owner.config.axis_rotated, this.getY2AxisLabelPosition());
	    };
	    c3_axis_fn.dyForXAxisLabel = function dyForXAxisLabel() {
	        var $$ = this.owner,
	            config = $$.config,
	            position = this.getXAxisLabelPosition();
	        if (config.axis_rotated) {
	            return position.isInner ? "1.2em" : -25 - ($$.config.axis_x_inner ? 0 : this.getMaxTickWidth('x'));
	        } else {
	            return position.isInner ? "-0.5em" : config.axis_x_height ? config.axis_x_height - 10 : "3em";
	        }
	    };
	    c3_axis_fn.dyForYAxisLabel = function dyForYAxisLabel() {
	        var $$ = this.owner,
	            position = this.getYAxisLabelPosition();
	        if ($$.config.axis_rotated) {
	            return position.isInner ? "-0.5em" : "3em";
	        } else {
	            return position.isInner ? "1.2em" : -10 - ($$.config.axis_y_inner ? 0 : this.getMaxTickWidth('y') + 10);
	        }
	    };
	    c3_axis_fn.dyForY2AxisLabel = function dyForY2AxisLabel() {
	        var $$ = this.owner,
	            position = this.getY2AxisLabelPosition();
	        if ($$.config.axis_rotated) {
	            return position.isInner ? "1.2em" : "-2.2em";
	        } else {
	            return position.isInner ? "-0.5em" : 15 + ($$.config.axis_y2_inner ? 0 : this.getMaxTickWidth('y2') + 15);
	        }
	    };
	    c3_axis_fn.textAnchorForXAxisLabel = function textAnchorForXAxisLabel() {
	        var $$ = this.owner;
	        return this.textAnchorForAxisLabel(!$$.config.axis_rotated, this.getXAxisLabelPosition());
	    };
	    c3_axis_fn.textAnchorForYAxisLabel = function textAnchorForYAxisLabel() {
	        var $$ = this.owner;
	        return this.textAnchorForAxisLabel($$.config.axis_rotated, this.getYAxisLabelPosition());
	    };
	    c3_axis_fn.textAnchorForY2AxisLabel = function textAnchorForY2AxisLabel() {
	        var $$ = this.owner;
	        return this.textAnchorForAxisLabel($$.config.axis_rotated, this.getY2AxisLabelPosition());
	    };
	    c3_axis_fn.getMaxTickWidth = function getMaxTickWidth(id, withoutRecompute) {
	        var $$ = this.owner,
	            config = $$.config,
	            maxWidth = 0,
	            targetsToShow,
	            scale,
	            axis,
	            dummy,
	            svg;
	        if (withoutRecompute && $$.currentMaxTickWidths[id]) {
	            return $$.currentMaxTickWidths[id];
	        }
	        if ($$.svg) {
	            targetsToShow = $$.filterTargetsToShow($$.data.targets);
	            if (id === 'y') {
	                scale = $$.y.copy().domain($$.getYDomain(targetsToShow, 'y'));
	                axis = this.getYAxis(scale, $$.yOrient, config.axis_y_tick_format, $$.yAxisTickValues, false, true, true);
	            } else if (id === 'y2') {
	                scale = $$.y2.copy().domain($$.getYDomain(targetsToShow, 'y2'));
	                axis = this.getYAxis(scale, $$.y2Orient, config.axis_y2_tick_format, $$.y2AxisTickValues, false, true, true);
	            } else {
	                scale = $$.x.copy().domain($$.getXDomain(targetsToShow));
	                axis = this.getXAxis(scale, $$.xOrient, $$.xAxisTickFormat, $$.xAxisTickValues, false, true, true);
	                this.updateXAxisTickValues(targetsToShow, axis);
	            }
	            dummy = $$.d3.select('body').append('div').classed('c3', true);
	            svg = dummy.append("svg").style('visibility', 'hidden').style('position', 'fixed').style('top', 0).style('left', 0), svg.append('g').call(axis).each(function () {
	                $$.d3.select(this).selectAll('text').each(function () {
	                    var box = this.getBoundingClientRect();
	                    if (maxWidth < box.width) {
	                        maxWidth = box.width;
	                    }
	                });
	                dummy.remove();
	            });
	        }
	        $$.currentMaxTickWidths[id] = maxWidth <= 0 ? $$.currentMaxTickWidths[id] : maxWidth;
	        return $$.currentMaxTickWidths[id];
	    };
	
	    c3_axis_fn.updateLabels = function updateLabels(withTransition) {
	        var $$ = this.owner;
	        var axisXLabel = $$.main.select('.' + CLASS.axisX + ' .' + CLASS.axisXLabel),
	            axisYLabel = $$.main.select('.' + CLASS.axisY + ' .' + CLASS.axisYLabel),
	            axisY2Label = $$.main.select('.' + CLASS.axisY2 + ' .' + CLASS.axisY2Label);
	        (withTransition ? axisXLabel.transition() : axisXLabel).attr("x", this.xForXAxisLabel.bind(this)).attr("dx", this.dxForXAxisLabel.bind(this)).attr("dy", this.dyForXAxisLabel.bind(this)).text(this.textForXAxisLabel.bind(this));
	        (withTransition ? axisYLabel.transition() : axisYLabel).attr("x", this.xForYAxisLabel.bind(this)).attr("dx", this.dxForYAxisLabel.bind(this)).attr("dy", this.dyForYAxisLabel.bind(this)).text(this.textForYAxisLabel.bind(this));
	        (withTransition ? axisY2Label.transition() : axisY2Label).attr("x", this.xForY2AxisLabel.bind(this)).attr("dx", this.dxForY2AxisLabel.bind(this)).attr("dy", this.dyForY2AxisLabel.bind(this)).text(this.textForY2AxisLabel.bind(this));
	    };
	    c3_axis_fn.getPadding = function getPadding(padding, key, defaultValue, domainLength) {
	        var p = typeof padding === 'number' ? padding : padding[key];
	        if (!isValue(p)) {
	            return defaultValue;
	        }
	        if (padding.unit === 'ratio') {
	            return padding[key] * domainLength;
	        }
	        // assume padding is pixels if unit is not specified
	        return this.convertPixelsToAxisPadding(p, domainLength);
	    };
	    c3_axis_fn.convertPixelsToAxisPadding = function convertPixelsToAxisPadding(pixels, domainLength) {
	        var $$ = this.owner,
	            length = $$.config.axis_rotated ? $$.width : $$.height;
	        return domainLength * (pixels / length);
	    };
	    c3_axis_fn.generateTickValues = function generateTickValues(values, tickCount, forTimeSeries) {
	        var tickValues = values,
	            targetCount,
	            start,
	            end,
	            count,
	            interval,
	            i,
	            tickValue;
	        if (tickCount) {
	            targetCount = isFunction(tickCount) ? tickCount() : tickCount;
	            // compute ticks according to tickCount
	            if (targetCount === 1) {
	                tickValues = [values[0]];
	            } else if (targetCount === 2) {
	                tickValues = [values[0], values[values.length - 1]];
	            } else if (targetCount > 2) {
	                count = targetCount - 2;
	                start = values[0];
	                end = values[values.length - 1];
	                interval = (end - start) / (count + 1);
	                // re-construct unique values
	                tickValues = [start];
	                for (i = 0; i < count; i++) {
	                    tickValue = +start + interval * (i + 1);
	                    tickValues.push(forTimeSeries ? new Date(tickValue) : tickValue);
	                }
	                tickValues.push(end);
	            }
	        }
	        if (!forTimeSeries) {
	            tickValues = tickValues.sort(function (a, b) {
	                return a - b;
	            });
	        }
	        return tickValues;
	    };
	    c3_axis_fn.generateTransitions = function generateTransitions(duration) {
	        var $$ = this.owner,
	            axes = $$.axes;
	        return {
	            axisX: duration ? axes.x.transition().duration(duration) : axes.x,
	            axisY: duration ? axes.y.transition().duration(duration) : axes.y,
	            axisY2: duration ? axes.y2.transition().duration(duration) : axes.y2,
	            axisSubX: duration ? axes.subx.transition().duration(duration) : axes.subx
	        };
	    };
	    c3_axis_fn.redraw = function redraw(transitions, isHidden) {
	        var $$ = this.owner;
	        $$.axes.x.style("opacity", isHidden ? 0 : 1);
	        $$.axes.y.style("opacity", isHidden ? 0 : 1);
	        $$.axes.y2.style("opacity", isHidden ? 0 : 1);
	        $$.axes.subx.style("opacity", isHidden ? 0 : 1);
	        transitions.axisX.call($$.xAxis);
	        transitions.axisY.call($$.yAxis);
	        transitions.axisY2.call($$.y2Axis);
	        transitions.axisSubX.call($$.subXAxis);
	    };
	
	    var c3 = { version: "0.4.24" };
	
	    var c3_chart_fn;
	    var c3_chart_internal_fn;
	
	    function Component(owner, componentKey, fn) {
	        this.owner = owner;
	        c3.chart.internal[componentKey] = fn;
	    }
	
	    function Chart(config) {
	        var $$ = this.internal = new ChartInternal(this);
	        $$.loadConfig(config);
	
	        $$.beforeInit(config);
	        $$.init();
	        $$.afterInit(config);
	
	        // bind "this" to nested API
	        (function bindThis(fn, target, argThis) {
	            Object.keys(fn).forEach(function (key) {
	                target[key] = fn[key].bind(argThis);
	                if (Object.keys(fn[key]).length > 0) {
	                    bindThis(fn[key], target[key], argThis);
	                }
	            });
	        })(c3_chart_fn, this, this);
	    }
	
	    function ChartInternal(api) {
	        var $$ = this;
	        $$.d3 = window.d3 ? window.d3 :  true ? __webpack_require__(1045) : undefined;
	        $$.api = api;
	        $$.config = $$.getDefaultConfig();
	        $$.data = {};
	        $$.cache = {};
	        $$.axes = {};
	    }
	
	    c3.generate = function (config) {
	        return new Chart(config);
	    };
	
	    c3.chart = {
	        fn: Chart.prototype,
	        internal: {
	            fn: ChartInternal.prototype
	        }
	    };
	    c3_chart_fn = c3.chart.fn;
	    c3_chart_internal_fn = c3.chart.internal.fn;
	
	    c3_chart_internal_fn.beforeInit = function () {
	        // can do something
	    };
	    c3_chart_internal_fn.afterInit = function () {
	        // can do something
	    };
	    c3_chart_internal_fn.init = function () {
	        var $$ = this,
	            config = $$.config;
	
	        $$.initParams();
	
	        if (config.data_url) {
	            $$.convertUrlToData(config.data_url, config.data_mimeType, config.data_headers, config.data_keys, $$.initWithData);
	        } else if (config.data_json) {
	            $$.initWithData($$.convertJsonToData(config.data_json, config.data_keys));
	        } else if (config.data_rows) {
	            $$.initWithData($$.convertRowsToData(config.data_rows));
	        } else if (config.data_columns) {
	            $$.initWithData($$.convertColumnsToData(config.data_columns));
	        } else {
	            throw Error('url or json or rows or columns is required.');
	        }
	    };
	
	    c3_chart_internal_fn.initParams = function () {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config;
	
	        // MEMO: clipId needs to be unique because it conflicts when multiple charts exist
	        $$.clipId = "c3-" + +new Date() + '-clip', $$.clipIdForXAxis = $$.clipId + '-xaxis', $$.clipIdForYAxis = $$.clipId + '-yaxis', $$.clipIdForGrid = $$.clipId + '-grid', $$.clipIdForSubchart = $$.clipId + '-subchart', $$.clipPath = $$.getClipPath($$.clipId), $$.clipPathForXAxis = $$.getClipPath($$.clipIdForXAxis), $$.clipPathForYAxis = $$.getClipPath($$.clipIdForYAxis);
	        $$.clipPathForGrid = $$.getClipPath($$.clipIdForGrid), $$.clipPathForSubchart = $$.getClipPath($$.clipIdForSubchart), $$.dragStart = null;
	        $$.dragging = false;
	        $$.flowing = false;
	        $$.cancelClick = false;
	        $$.mouseover = false;
	        $$.transiting = false;
	
	        $$.color = $$.generateColor();
	        $$.levelColor = $$.generateLevelColor();
	
	        $$.dataTimeFormat = config.data_xLocaltime ? d3.time.format : d3.time.format.utc;
	        $$.axisTimeFormat = config.axis_x_localtime ? d3.time.format : d3.time.format.utc;
	        $$.defaultAxisTimeFormat = $$.axisTimeFormat.multi([[".%L", function (d) {
	            return d.getMilliseconds();
	        }], [":%S", function (d) {
	            return d.getSeconds();
	        }], ["%I:%M", function (d) {
	            return d.getMinutes();
	        }], ["%I %p", function (d) {
	            return d.getHours();
	        }], ["%-m/%-d", function (d) {
	            return d.getDay() && d.getDate() !== 1;
	        }], ["%-m/%-d", function (d) {
	            return d.getDate() !== 1;
	        }], ["%-m/%-d", function (d) {
	            return d.getMonth();
	        }], ["%Y/%-m/%-d", function () {
	            return true;
	        }]]);
	
	        $$.hiddenTargetIds = [];
	        $$.hiddenLegendIds = [];
	        $$.focusedTargetIds = [];
	        $$.defocusedTargetIds = [];
	
	        $$.xOrient = config.axis_rotated ? config.axis_x_inner ? "right" : "left" : config.axis_x_inner ? "top" : "bottom";
	        $$.yOrient = config.axis_rotated ? config.axis_y_inner ? "top" : "bottom" : config.axis_y_inner ? "right" : "left";
	        $$.y2Orient = config.axis_rotated ? config.axis_y2_inner ? "bottom" : "top" : config.axis_y2_inner ? "left" : "right";
	        $$.subXOrient = config.axis_rotated ? "left" : "bottom";
	
	        $$.isLegendRight = config.legend_position === 'right';
	        $$.isLegendInset = config.legend_position === 'inset';
	        $$.isLegendTop = config.legend_inset_anchor === 'top-left' || config.legend_inset_anchor === 'top-right';
	        $$.isLegendLeft = config.legend_inset_anchor === 'top-left' || config.legend_inset_anchor === 'bottom-left';
	        $$.legendStep = 0;
	        $$.legendItemWidth = 0;
	        $$.legendItemHeight = 0;
	
	        $$.currentMaxTickWidths = {
	            x: 0,
	            y: 0,
	            y2: 0
	        };
	
	        $$.rotated_padding_left = 30;
	        $$.rotated_padding_right = config.axis_rotated && !config.axis_x_show ? 0 : 30;
	        $$.rotated_padding_top = 5;
	
	        $$.withoutFadeIn = {};
	
	        $$.intervalForObserveInserted = undefined;
	
	        $$.axes.subx = d3.selectAll([]); // needs when excluding subchart.js
	    };
	
	    c3_chart_internal_fn.initChartElements = function () {
	        if (this.initBar) {
	            this.initBar();
	        }
	        if (this.initLine) {
	            this.initLine();
	        }
	        if (this.initArc) {
	            this.initArc();
	        }
	        if (this.initGauge) {
	            this.initGauge();
	        }
	        if (this.initText) {
	            this.initText();
	        }
	    };
	
	    c3_chart_internal_fn.initWithData = function (data) {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config;
	        var defs,
	            main,
	            binding = true;
	
	        $$.axis = new Axis($$);
	
	        if ($$.initPie) {
	            $$.initPie();
	        }
	        if ($$.initBrush) {
	            $$.initBrush();
	        }
	        if ($$.initZoom) {
	            $$.initZoom();
	        }
	
	        if (!config.bindto) {
	            $$.selectChart = d3.selectAll([]);
	        } else if (typeof config.bindto.node === 'function') {
	            $$.selectChart = config.bindto;
	        } else {
	            $$.selectChart = d3.select(config.bindto);
	        }
	        if ($$.selectChart.empty()) {
	            $$.selectChart = d3.select(document.createElement('div')).style('opacity', 0);
	            $$.observeInserted($$.selectChart);
	            binding = false;
	        }
	        $$.selectChart.html("").classed("c3", true);
	
	        // Init data as targets
	        $$.data.xs = {};
	        $$.data.targets = $$.convertDataToTargets(data);
	
	        if (config.data_filter) {
	            $$.data.targets = $$.data.targets.filter(config.data_filter);
	        }
	
	        // Set targets to hide if needed
	        if (config.data_hide) {
	            $$.addHiddenTargetIds(config.data_hide === true ? $$.mapToIds($$.data.targets) : config.data_hide);
	        }
	        if (config.legend_hide) {
	            $$.addHiddenLegendIds(config.legend_hide === true ? $$.mapToIds($$.data.targets) : config.legend_hide);
	        }
	
	        // Init sizes and scales
	        $$.updateSizes();
	        $$.updateScales();
	
	        // Set domains for each scale
	        $$.x.domain(d3.extent($$.getXDomain($$.data.targets)));
	        $$.y.domain($$.getYDomain($$.data.targets, 'y'));
	        $$.y2.domain($$.getYDomain($$.data.targets, 'y2'));
	        $$.subX.domain($$.x.domain());
	        $$.subY.domain($$.y.domain());
	        $$.subY2.domain($$.y2.domain());
	
	        // Save original x domain for zoom update
	        $$.orgXDomain = $$.x.domain();
	
	        // Set initialized scales to brush and zoom
	        if ($$.brush) {
	            $$.brush.scale($$.subX);
	        }
	        if (config.zoom_enabled) {
	            $$.zoom.scale($$.x);
	        }
	
	        /*-- Basic Elements --*/
	
	        // Define svgs
	        $$.svg = $$.selectChart.append("svg").style("overflow", "hidden").on('mouseenter', function () {
	            return config.onmouseover.call($$);
	        }).on('mouseleave', function () {
	            return config.onmouseout.call($$);
	        });
	
	        if ($$.config.svg_classname) {
	            $$.svg.attr('class', $$.config.svg_classname);
	        }
	
	        // Define defs
	        defs = $$.svg.append("defs");
	        $$.clipChart = $$.appendClip(defs, $$.clipId);
	        $$.clipXAxis = $$.appendClip(defs, $$.clipIdForXAxis);
	        $$.clipYAxis = $$.appendClip(defs, $$.clipIdForYAxis);
	        $$.clipGrid = $$.appendClip(defs, $$.clipIdForGrid);
	        $$.clipSubchart = $$.appendClip(defs, $$.clipIdForSubchart);
	        $$.updateSvgSize();
	
	        // Define regions
	        main = $$.main = $$.svg.append("g").attr("transform", $$.getTranslate('main'));
	
	        if ($$.initSubchart) {
	            $$.initSubchart();
	        }
	        if ($$.initTooltip) {
	            $$.initTooltip();
	        }
	        if ($$.initLegend) {
	            $$.initLegend();
	        }
	        if ($$.initTitle) {
	            $$.initTitle();
	        }
	
	        /*-- Main Region --*/
	
	        // text when empty
	        main.append("text").attr("class", CLASS.text + ' ' + CLASS.empty).attr("text-anchor", "middle") // horizontal centering of text at x position in all browsers.
	        .attr("dominant-baseline", "middle"); // vertical centering of text at y position in all browsers, except IE.
	
	        // Regions
	        $$.initRegion();
	
	        // Grids
	        $$.initGrid();
	
	        // Define g for chart area
	        main.append('g').attr("clip-path", $$.clipPath).attr('class', CLASS.chart);
	
	        // Grid lines
	        if (config.grid_lines_front) {
	            $$.initGridLines();
	        }
	
	        // Cover whole with rects for events
	        $$.initEventRect();
	
	        // Define g for chart
	        $$.initChartElements();
	
	        // if zoom privileged, insert rect to forefront
	        // TODO: is this needed?
	        main.insert('rect', config.zoom_privileged ? null : 'g.' + CLASS.regions).attr('class', CLASS.zoomRect).attr('width', $$.width).attr('height', $$.height).style('opacity', 0).on("dblclick.zoom", null);
	
	        // Set default extent if defined
	        if (config.axis_x_extent) {
	            $$.brush.extent($$.getDefaultExtent());
	        }
	
	        // Add Axis
	        $$.axis.init();
	
	        // Set targets
	        $$.updateTargets($$.data.targets);
	
	        // Draw with targets
	        if (binding) {
	            $$.updateDimension();
	            $$.config.oninit.call($$);
	            $$.redraw({
	                withTransition: false,
	                withTransform: true,
	                withUpdateXDomain: true,
	                withUpdateOrgXDomain: true,
	                withTransitionForAxis: false
	            });
	        }
	
	        // Bind resize event
	        $$.bindResize();
	
	        // export element of the chart
	        $$.api.element = $$.selectChart.node();
	    };
	
	    c3_chart_internal_fn.smoothLines = function (el, type) {
	        var $$ = this;
	        if (type === 'grid') {
	            el.each(function () {
	                var g = $$.d3.select(this),
	                    x1 = g.attr('x1'),
	                    x2 = g.attr('x2'),
	                    y1 = g.attr('y1'),
	                    y2 = g.attr('y2');
	                g.attr({
	                    'x1': Math.ceil(x1),
	                    'x2': Math.ceil(x2),
	                    'y1': Math.ceil(y1),
	                    'y2': Math.ceil(y2)
	                });
	            });
	        }
	    };
	
	    c3_chart_internal_fn.updateSizes = function () {
	        var $$ = this,
	            config = $$.config;
	        var legendHeight = $$.legend ? $$.getLegendHeight() : 0,
	            legendWidth = $$.legend ? $$.getLegendWidth() : 0,
	            legendHeightForBottom = $$.isLegendRight || $$.isLegendInset ? 0 : legendHeight,
	            hasArc = $$.hasArcType(),
	            xAxisHeight = config.axis_rotated || hasArc ? 0 : $$.getHorizontalAxisHeight('x'),
	            subchartHeight = config.subchart_show && !hasArc ? config.subchart_size_height + xAxisHeight : 0;
	
	        $$.currentWidth = $$.getCurrentWidth();
	        $$.currentHeight = $$.getCurrentHeight();
	
	        // for main
	        $$.margin = config.axis_rotated ? {
	            top: $$.getHorizontalAxisHeight('y2') + $$.getCurrentPaddingTop(),
	            right: hasArc ? 0 : $$.getCurrentPaddingRight(),
	            bottom: $$.getHorizontalAxisHeight('y') + legendHeightForBottom + $$.getCurrentPaddingBottom(),
	            left: subchartHeight + (hasArc ? 0 : $$.getCurrentPaddingLeft())
	        } : {
	            top: 4 + $$.getCurrentPaddingTop(), // for top tick text
	            right: hasArc ? 0 : $$.getCurrentPaddingRight(),
	            bottom: xAxisHeight + subchartHeight + legendHeightForBottom + $$.getCurrentPaddingBottom(),
	            left: hasArc ? 0 : $$.getCurrentPaddingLeft()
	        };
	
	        // for subchart
	        $$.margin2 = config.axis_rotated ? {
	            top: $$.margin.top,
	            right: NaN,
	            bottom: 20 + legendHeightForBottom,
	            left: $$.rotated_padding_left
	        } : {
	            top: $$.currentHeight - subchartHeight - legendHeightForBottom,
	            right: NaN,
	            bottom: xAxisHeight + legendHeightForBottom,
	            left: $$.margin.left
	        };
	
	        // for legend
	        $$.margin3 = {
	            top: 0,
	            right: NaN,
	            bottom: 0,
	            left: 0
	        };
	        if ($$.updateSizeForLegend) {
	            $$.updateSizeForLegend(legendHeight, legendWidth);
	        }
	
	        $$.width = $$.currentWidth - $$.margin.left - $$.margin.right;
	        $$.height = $$.currentHeight - $$.margin.top - $$.margin.bottom;
	        if ($$.width < 0) {
	            $$.width = 0;
	        }
	        if ($$.height < 0) {
	            $$.height = 0;
	        }
	
	        $$.width2 = config.axis_rotated ? $$.margin.left - $$.rotated_padding_left - $$.rotated_padding_right : $$.width;
	        $$.height2 = config.axis_rotated ? $$.height : $$.currentHeight - $$.margin2.top - $$.margin2.bottom;
	        if ($$.width2 < 0) {
	            $$.width2 = 0;
	        }
	        if ($$.height2 < 0) {
	            $$.height2 = 0;
	        }
	
	        // for arc
	        $$.arcWidth = $$.width - ($$.isLegendRight ? legendWidth + 10 : 0);
	        $$.arcHeight = $$.height - ($$.isLegendRight ? 0 : 10);
	        if ($$.hasType('gauge') && !config.gauge_fullCircle) {
	            $$.arcHeight += $$.height - $$.getGaugeLabelHeight();
	        }
	        if ($$.updateRadius) {
	            $$.updateRadius();
	        }
	
	        if ($$.isLegendRight && hasArc) {
	            $$.margin3.left = $$.arcWidth / 2 + $$.radiusExpanded * 1.1;
	        }
	    };
	
	    c3_chart_internal_fn.updateTargets = function (targets) {
	        var $$ = this;
	
	        /*-- Main --*/
	
	        //-- Text --//
	        $$.updateTargetsForText(targets);
	
	        //-- Bar --//
	        $$.updateTargetsForBar(targets);
	
	        //-- Line --//
	        $$.updateTargetsForLine(targets);
	
	        //-- Arc --//
	        if ($$.hasArcType() && $$.updateTargetsForArc) {
	            $$.updateTargetsForArc(targets);
	        }
	
	        /*-- Sub --*/
	
	        if ($$.updateTargetsForSubchart) {
	            $$.updateTargetsForSubchart(targets);
	        }
	
	        // Fade-in each chart
	        $$.showTargets();
	    };
	    c3_chart_internal_fn.showTargets = function () {
	        var $$ = this;
	        $$.svg.selectAll('.' + CLASS.target).filter(function (d) {
	            return $$.isTargetToShow(d.id);
	        }).transition().duration($$.config.transition_duration).style("opacity", 1);
	    };
	
	    c3_chart_internal_fn.redraw = function (options, transitions) {
	        var $$ = this,
	            main = $$.main,
	            d3 = $$.d3,
	            config = $$.config;
	        var areaIndices = $$.getShapeIndices($$.isAreaType),
	            barIndices = $$.getShapeIndices($$.isBarType),
	            lineIndices = $$.getShapeIndices($$.isLineType);
	        var withY, withSubchart, withTransition, withTransitionForExit, withTransitionForAxis, withTransform, withUpdateXDomain, withUpdateOrgXDomain, withTrimXDomain, withLegend, withEventRect, withDimension, withUpdateXAxis;
	        var hideAxis = $$.hasArcType();
	        var drawArea, drawBar, drawLine, xForText, yForText;
	        var duration, durationForExit, durationForAxis;
	        var waitForDraw, flow;
	        var targetsToShow = $$.filterTargetsToShow($$.data.targets),
	            tickValues,
	            i,
	            intervalForCulling,
	            xDomainForZoom;
	        var xv = $$.xv.bind($$),
	            cx,
	            cy;
	
	        options = options || {};
	        withY = getOption(options, "withY", true);
	        withSubchart = getOption(options, "withSubchart", true);
	        withTransition = getOption(options, "withTransition", true);
	        withTransform = getOption(options, "withTransform", false);
	        withUpdateXDomain = getOption(options, "withUpdateXDomain", false);
	        withUpdateOrgXDomain = getOption(options, "withUpdateOrgXDomain", false);
	        withTrimXDomain = getOption(options, "withTrimXDomain", true);
	        withUpdateXAxis = getOption(options, "withUpdateXAxis", withUpdateXDomain);
	        withLegend = getOption(options, "withLegend", false);
	        withEventRect = getOption(options, "withEventRect", true);
	        withDimension = getOption(options, "withDimension", true);
	        withTransitionForExit = getOption(options, "withTransitionForExit", withTransition);
	        withTransitionForAxis = getOption(options, "withTransitionForAxis", withTransition);
	
	        duration = withTransition ? config.transition_duration : 0;
	        durationForExit = withTransitionForExit ? duration : 0;
	        durationForAxis = withTransitionForAxis ? duration : 0;
	
	        transitions = transitions || $$.axis.generateTransitions(durationForAxis);
	
	        // update legend and transform each g
	        if (withLegend && config.legend_show) {
	            $$.updateLegend($$.mapToIds($$.data.targets), options, transitions);
	        } else if (withDimension) {
	            // need to update dimension (e.g. axis.y.tick.values) because y tick values should change
	            // no need to update axis in it because they will be updated in redraw()
	            $$.updateDimension(true);
	        }
	
	        // MEMO: needed for grids calculation
	        if ($$.isCategorized() && targetsToShow.length === 0) {
	            $$.x.domain([0, $$.axes.x.selectAll('.tick').size()]);
	        }
	
	        if (targetsToShow.length) {
	            $$.updateXDomain(targetsToShow, withUpdateXDomain, withUpdateOrgXDomain, withTrimXDomain);
	            if (!config.axis_x_tick_values) {
	                tickValues = $$.axis.updateXAxisTickValues(targetsToShow);
	            }
	        } else {
	            $$.xAxis.tickValues([]);
	            $$.subXAxis.tickValues([]);
	        }
	
	        if (config.zoom_rescale && !options.flow) {
	            xDomainForZoom = $$.x.orgDomain();
	        }
	
	        $$.y.domain($$.getYDomain(targetsToShow, 'y', xDomainForZoom));
	        $$.y2.domain($$.getYDomain(targetsToShow, 'y2', xDomainForZoom));
	
	        if (!config.axis_y_tick_values && config.axis_y_tick_count) {
	            $$.yAxis.tickValues($$.axis.generateTickValues($$.y.domain(), config.axis_y_tick_count));
	        }
	        if (!config.axis_y2_tick_values && config.axis_y2_tick_count) {
	            $$.y2Axis.tickValues($$.axis.generateTickValues($$.y2.domain(), config.axis_y2_tick_count));
	        }
	
	        // axes
	        $$.axis.redraw(transitions, hideAxis);
	
	        // Update axis label
	        $$.axis.updateLabels(withTransition);
	
	        // show/hide if manual culling needed
	        if ((withUpdateXDomain || withUpdateXAxis) && targetsToShow.length) {
	            if (config.axis_x_tick_culling && tickValues) {
	                for (i = 1; i < tickValues.length; i++) {
	                    if (tickValues.length / i < config.axis_x_tick_culling_max) {
	                        intervalForCulling = i;
	                        break;
	                    }
	                }
	                $$.svg.selectAll('.' + CLASS.axisX + ' .tick text').each(function (e) {
	                    var index = tickValues.indexOf(e);
	                    if (index >= 0) {
	                        d3.select(this).style('display', index % intervalForCulling ? 'none' : 'block');
	                    }
	                });
	            } else {
	                $$.svg.selectAll('.' + CLASS.axisX + ' .tick text').style('display', 'block');
	            }
	        }
	
	        // setup drawer - MEMO: these must be called after axis updated
	        drawArea = $$.generateDrawArea ? $$.generateDrawArea(areaIndices, false) : undefined;
	        drawBar = $$.generateDrawBar ? $$.generateDrawBar(barIndices) : undefined;
	        drawLine = $$.generateDrawLine ? $$.generateDrawLine(lineIndices, false) : undefined;
	        xForText = $$.generateXYForText(areaIndices, barIndices, lineIndices, true);
	        yForText = $$.generateXYForText(areaIndices, barIndices, lineIndices, false);
	
	        // Update sub domain
	        if (withY) {
	            $$.subY.domain($$.getYDomain(targetsToShow, 'y'));
	            $$.subY2.domain($$.getYDomain(targetsToShow, 'y2'));
	        }
	
	        // xgrid focus
	        $$.updateXgridFocus();
	
	        // Data empty label positioning and text.
	        main.select("text." + CLASS.text + '.' + CLASS.empty).attr("x", $$.width / 2).attr("y", $$.height / 2).text(config.data_empty_label_text).transition().style('opacity', targetsToShow.length ? 0 : 1);
	
	        // grid
	        $$.updateGrid(duration);
	
	        // rect for regions
	        $$.updateRegion(duration);
	
	        // bars
	        $$.updateBar(durationForExit);
	
	        // lines, areas and cricles
	        $$.updateLine(durationForExit);
	        $$.updateArea(durationForExit);
	        $$.updateCircle();
	
	        // text
	        if ($$.hasDataLabel()) {
	            $$.updateText(durationForExit);
	        }
	
	        // title
	        if ($$.redrawTitle) {
	            $$.redrawTitle();
	        }
	
	        // arc
	        if ($$.redrawArc) {
	            $$.redrawArc(duration, durationForExit, withTransform);
	        }
	
	        // subchart
	        if ($$.redrawSubchart) {
	            $$.redrawSubchart(withSubchart, transitions, duration, durationForExit, areaIndices, barIndices, lineIndices);
	        }
	
	        // circles for select
	        main.selectAll('.' + CLASS.selectedCircles).filter($$.isBarType.bind($$)).selectAll('circle').remove();
	
	        // event rects will redrawn when flow called
	        if (config.interaction_enabled && !options.flow && withEventRect) {
	            $$.redrawEventRect();
	            if ($$.updateZoom) {
	                $$.updateZoom();
	            }
	        }
	
	        // update circleY based on updated parameters
	        $$.updateCircleY();
	
	        // generate circle x/y functions depending on updated params
	        cx = ($$.config.axis_rotated ? $$.circleY : $$.circleX).bind($$);
	        cy = ($$.config.axis_rotated ? $$.circleX : $$.circleY).bind($$);
	
	        if (options.flow) {
	            flow = $$.generateFlow({
	                targets: targetsToShow,
	                flow: options.flow,
	                duration: options.flow.duration,
	                drawBar: drawBar,
	                drawLine: drawLine,
	                drawArea: drawArea,
	                cx: cx,
	                cy: cy,
	                xv: xv,
	                xForText: xForText,
	                yForText: yForText
	            });
	        }
	
	        if ((duration || flow) && $$.isTabVisible()) {
	            // Only use transition if tab visible. See #938.
	            // transition should be derived from one transition
	            d3.transition().duration(duration).each(function () {
	                var transitionsToWait = [];
	
	                // redraw and gather transitions
	                [$$.redrawBar(drawBar, true), $$.redrawLine(drawLine, true), $$.redrawArea(drawArea, true), $$.redrawCircle(cx, cy, true), $$.redrawText(xForText, yForText, options.flow, true), $$.redrawRegion(true), $$.redrawGrid(true)].forEach(function (transitions) {
	                    transitions.forEach(function (transition) {
	                        transitionsToWait.push(transition);
	                    });
	                });
	
	                // Wait for end of transitions to call flow and onrendered callback
	                waitForDraw = $$.generateWait();
	                transitionsToWait.forEach(function (t) {
	                    waitForDraw.add(t);
	                });
	            }).call(waitForDraw, function () {
	                if (flow) {
	                    flow();
	                }
	                if (config.onrendered) {
	                    config.onrendered.call($$);
	                }
	            });
	        } else {
	            $$.redrawBar(drawBar);
	            $$.redrawLine(drawLine);
	            $$.redrawArea(drawArea);
	            $$.redrawCircle(cx, cy);
	            $$.redrawText(xForText, yForText, options.flow);
	            $$.redrawRegion();
	            $$.redrawGrid();
	            if (config.onrendered) {
	                config.onrendered.call($$);
	            }
	        }
	
	        // update fadein condition
	        $$.mapToIds($$.data.targets).forEach(function (id) {
	            $$.withoutFadeIn[id] = true;
	        });
	    };
	
	    c3_chart_internal_fn.updateAndRedraw = function (options) {
	        var $$ = this,
	            config = $$.config,
	            transitions;
	        options = options || {};
	        // same with redraw
	        options.withTransition = getOption(options, "withTransition", true);
	        options.withTransform = getOption(options, "withTransform", false);
	        options.withLegend = getOption(options, "withLegend", false);
	        // NOT same with redraw
	        options.withUpdateXDomain = true;
	        options.withUpdateOrgXDomain = true;
	        options.withTransitionForExit = false;
	        options.withTransitionForTransform = getOption(options, "withTransitionForTransform", options.withTransition);
	        // MEMO: this needs to be called before updateLegend and it means this ALWAYS needs to be called)
	        $$.updateSizes();
	        // MEMO: called in updateLegend in redraw if withLegend
	        if (!(options.withLegend && config.legend_show)) {
	            transitions = $$.axis.generateTransitions(options.withTransitionForAxis ? config.transition_duration : 0);
	            // Update scales
	            $$.updateScales();
	            $$.updateSvgSize();
	            // Update g positions
	            $$.transformAll(options.withTransitionForTransform, transitions);
	        }
	        // Draw with new sizes & scales
	        $$.redraw(options, transitions);
	    };
	    c3_chart_internal_fn.redrawWithoutRescale = function () {
	        this.redraw({
	            withY: false,
	            withSubchart: false,
	            withEventRect: false,
	            withTransitionForAxis: false
	        });
	    };
	
	    c3_chart_internal_fn.isTimeSeries = function () {
	        return this.config.axis_x_type === 'timeseries';
	    };
	    c3_chart_internal_fn.isCategorized = function () {
	        return this.config.axis_x_type.indexOf('categor') >= 0;
	    };
	    c3_chart_internal_fn.isCustomX = function () {
	        var $$ = this,
	            config = $$.config;
	        return !$$.isTimeSeries() && (config.data_x || notEmpty(config.data_xs));
	    };
	
	    c3_chart_internal_fn.isTimeSeriesY = function () {
	        return this.config.axis_y_type === 'timeseries';
	    };
	
	    c3_chart_internal_fn.getTranslate = function (target) {
	        var $$ = this,
	            config = $$.config,
	            x,
	            y;
	        if (target === 'main') {
	            x = asHalfPixel($$.margin.left);
	            y = asHalfPixel($$.margin.top);
	        } else if (target === 'context') {
	            x = asHalfPixel($$.margin2.left);
	            y = asHalfPixel($$.margin2.top);
	        } else if (target === 'legend') {
	            x = $$.margin3.left;
	            y = $$.margin3.top;
	        } else if (target === 'x') {
	            x = 0;
	            y = config.axis_rotated ? 0 : $$.height;
	        } else if (target === 'y') {
	            x = 0;
	            y = config.axis_rotated ? $$.height : 0;
	        } else if (target === 'y2') {
	            x = config.axis_rotated ? 0 : $$.width;
	            y = config.axis_rotated ? 1 : 0;
	        } else if (target === 'subx') {
	            x = 0;
	            y = config.axis_rotated ? 0 : $$.height2;
	        } else if (target === 'arc') {
	            x = $$.arcWidth / 2;
	            y = $$.arcHeight / 2 - ($$.hasType('gauge') ? 6 : 0); // to prevent wrong display of min and max label
	        }
	        return "translate(" + x + "," + y + ")";
	    };
	    c3_chart_internal_fn.initialOpacity = function (d) {
	        return d.value !== null && this.withoutFadeIn[d.id] ? 1 : 0;
	    };
	    c3_chart_internal_fn.initialOpacityForCircle = function (d) {
	        return d.value !== null && this.withoutFadeIn[d.id] ? this.opacityForCircle(d) : 0;
	    };
	    c3_chart_internal_fn.opacityForCircle = function (d) {
	        var isPointShouldBeShown = isFunction(this.config.point_show) ? this.config.point_show(d) : this.config.point_show;
	        var opacity = isPointShouldBeShown ? 1 : 0;
	        return isValue(d.value) ? this.isScatterType(d) ? 0.5 : opacity : 0;
	    };
	    c3_chart_internal_fn.opacityForText = function () {
	        return this.hasDataLabel() ? 1 : 0;
	    };
	    c3_chart_internal_fn.xx = function (d) {
	        return d ? this.x(d.x) : null;
	    };
	    c3_chart_internal_fn.xv = function (d) {
	        var $$ = this,
	            value = d.value;
	        if ($$.isTimeSeries()) {
	            value = $$.parseDate(d.value);
	        } else if ($$.isCategorized() && typeof d.value === 'string') {
	            value = $$.config.axis_x_categories.indexOf(d.value);
	        }
	        return Math.ceil($$.x(value));
	    };
	    c3_chart_internal_fn.yv = function (d) {
	        var $$ = this,
	            yScale = d.axis && d.axis === 'y2' ? $$.y2 : $$.y;
	        return Math.ceil(yScale(d.value));
	    };
	    c3_chart_internal_fn.subxx = function (d) {
	        return d ? this.subX(d.x) : null;
	    };
	
	    c3_chart_internal_fn.transformMain = function (withTransition, transitions) {
	        var $$ = this,
	            xAxis,
	            yAxis,
	            y2Axis;
	        if (transitions && transitions.axisX) {
	            xAxis = transitions.axisX;
	        } else {
	            xAxis = $$.main.select('.' + CLASS.axisX);
	            if (withTransition) {
	                xAxis = xAxis.transition();
	            }
	        }
	        if (transitions && transitions.axisY) {
	            yAxis = transitions.axisY;
	        } else {
	            yAxis = $$.main.select('.' + CLASS.axisY);
	            if (withTransition) {
	                yAxis = yAxis.transition();
	            }
	        }
	        if (transitions && transitions.axisY2) {
	            y2Axis = transitions.axisY2;
	        } else {
	            y2Axis = $$.main.select('.' + CLASS.axisY2);
	            if (withTransition) {
	                y2Axis = y2Axis.transition();
	            }
	        }
	        (withTransition ? $$.main.transition() : $$.main).attr("transform", $$.getTranslate('main'));
	        xAxis.attr("transform", $$.getTranslate('x'));
	        yAxis.attr("transform", $$.getTranslate('y'));
	        y2Axis.attr("transform", $$.getTranslate('y2'));
	        $$.main.select('.' + CLASS.chartArcs).attr("transform", $$.getTranslate('arc'));
	    };
	    c3_chart_internal_fn.transformAll = function (withTransition, transitions) {
	        var $$ = this;
	        $$.transformMain(withTransition, transitions);
	        if ($$.config.subchart_show) {
	            $$.transformContext(withTransition, transitions);
	        }
	        if ($$.legend) {
	            $$.transformLegend(withTransition);
	        }
	    };
	
	    c3_chart_internal_fn.updateSvgSize = function () {
	        var $$ = this,
	            brush = $$.svg.select(".c3-brush .background");
	        $$.svg.attr('width', $$.currentWidth).attr('height', $$.currentHeight);
	        $$.svg.selectAll(['#' + $$.clipId, '#' + $$.clipIdForGrid]).select('rect').attr('width', $$.width).attr('height', $$.height);
	        $$.svg.select('#' + $$.clipIdForXAxis).select('rect').attr('x', $$.getXAxisClipX.bind($$)).attr('y', $$.getXAxisClipY.bind($$)).attr('width', $$.getXAxisClipWidth.bind($$)).attr('height', $$.getXAxisClipHeight.bind($$));
	        $$.svg.select('#' + $$.clipIdForYAxis).select('rect').attr('x', $$.getYAxisClipX.bind($$)).attr('y', $$.getYAxisClipY.bind($$)).attr('width', $$.getYAxisClipWidth.bind($$)).attr('height', $$.getYAxisClipHeight.bind($$));
	        $$.svg.select('#' + $$.clipIdForSubchart).select('rect').attr('width', $$.width).attr('height', brush.size() ? brush.attr('height') : 0);
	        $$.svg.select('.' + CLASS.zoomRect).attr('width', $$.width).attr('height', $$.height);
	        // MEMO: parent div's height will be bigger than svg when <!DOCTYPE html>
	        $$.selectChart.style('max-height', $$.currentHeight + "px");
	    };
	
	    c3_chart_internal_fn.updateDimension = function (withoutAxis) {
	        var $$ = this;
	        if (!withoutAxis) {
	            if ($$.config.axis_rotated) {
	                $$.axes.x.call($$.xAxis);
	                $$.axes.subx.call($$.subXAxis);
	            } else {
	                $$.axes.y.call($$.yAxis);
	                $$.axes.y2.call($$.y2Axis);
	            }
	        }
	        $$.updateSizes();
	        $$.updateScales();
	        $$.updateSvgSize();
	        $$.transformAll(false);
	    };
	
	    c3_chart_internal_fn.observeInserted = function (selection) {
	        var $$ = this,
	            observer;
	        if (typeof MutationObserver === 'undefined') {
	            window.console.error("MutationObserver not defined.");
	            return;
	        }
	        observer = new MutationObserver(function (mutations) {
	            mutations.forEach(function (mutation) {
	                if (mutation.type === 'childList' && mutation.previousSibling) {
	                    observer.disconnect();
	                    // need to wait for completion of load because size calculation requires the actual sizes determined after that completion
	                    $$.intervalForObserveInserted = window.setInterval(function () {
	                        // parentNode will NOT be null when completed
	                        if (selection.node().parentNode) {
	                            window.clearInterval($$.intervalForObserveInserted);
	                            $$.updateDimension();
	                            if ($$.brush) {
	                                $$.brush.update();
	                            }
	                            $$.config.oninit.call($$);
	                            $$.redraw({
	                                withTransform: true,
	                                withUpdateXDomain: true,
	                                withUpdateOrgXDomain: true,
	                                withTransition: false,
	                                withTransitionForTransform: false,
	                                withLegend: true
	                            });
	                            selection.transition().style('opacity', 1);
	                        }
	                    }, 10);
	                }
	            });
	        });
	        observer.observe(selection.node(), { attributes: true, childList: true, characterData: true });
	    };
	
	    c3_chart_internal_fn.bindResize = function () {
	        var $$ = this,
	            config = $$.config;
	
	        $$.resizeFunction = $$.generateResize(); // need to call .remove
	
	        $$.resizeFunction.add(function () {
	            config.onresize.call($$);
	        });
	        if (config.resize_auto) {
	            $$.resizeFunction.add(function () {
	                if ($$.resizeTimeout !== undefined) {
	                    window.clearTimeout($$.resizeTimeout);
	                }
	                $$.resizeTimeout = window.setTimeout(function () {
	                    delete $$.resizeTimeout;
	                    $$.api.flush();
	                }, 100);
	            });
	        }
	        $$.resizeFunction.add(function () {
	            config.onresized.call($$);
	        });
	
	        $$.resizeIfElementDisplayed = function () {
	            // if element not displayed skip it
	            if ($$.api == null || !$$.api.element.offsetParent) {
	                return;
	            }
	
	            $$.resizeFunction();
	        };
	
	        if (window.attachEvent) {
	            window.attachEvent('onresize', $$.resizeIfElementDisplayed);
	        } else if (window.addEventListener) {
	            window.addEventListener('resize', $$.resizeIfElementDisplayed, false);
	        } else {
	            // fallback to this, if this is a very old browser
	            var wrapper = window.onresize;
	            if (!wrapper) {
	                // create a wrapper that will call all charts
	                wrapper = $$.generateResize();
	            } else if (!wrapper.add || !wrapper.remove) {
	                // there is already a handler registered, make sure we call it too
	                wrapper = $$.generateResize();
	                wrapper.add(window.onresize);
	            }
	            // add this graph to the wrapper, we will be removed if the user calls destroy
	            wrapper.add($$.resizeFunction);
	            window.onresize = function () {
	                // if element not displayed skip it
	                if (!$$.api.element.offsetParent) {
	                    return;
	                }
	
	                wrapper();
	            };
	        }
	    };
	
	    c3_chart_internal_fn.generateResize = function () {
	        var resizeFunctions = [];
	        function callResizeFunctions() {
	            resizeFunctions.forEach(function (f) {
	                f();
	            });
	        }
	        callResizeFunctions.add = function (f) {
	            resizeFunctions.push(f);
	        };
	        callResizeFunctions.remove = function (f) {
	            for (var i = 0; i < resizeFunctions.length; i++) {
	                if (resizeFunctions[i] === f) {
	                    resizeFunctions.splice(i, 1);
	                    break;
	                }
	            }
	        };
	        return callResizeFunctions;
	    };
	
	    c3_chart_internal_fn.endall = function (transition, callback) {
	        var n = 0;
	        transition.each(function () {
	            ++n;
	        }).each("end", function () {
	            if (! --n) {
	                callback.apply(this, arguments);
	            }
	        });
	    };
	    c3_chart_internal_fn.generateWait = function () {
	        var transitionsToWait = [],
	            f = function f(transition, callback) {
	            var timer = setInterval(function () {
	                var done = 0;
	                transitionsToWait.forEach(function (t) {
	                    if (t.empty()) {
	                        done += 1;
	                        return;
	                    }
	                    try {
	                        t.transition();
	                    } catch (e) {
	                        done += 1;
	                    }
	                });
	                if (done === transitionsToWait.length) {
	                    clearInterval(timer);
	                    if (callback) {
	                        callback();
	                    }
	                }
	            }, 10);
	        };
	        f.add = function (transition) {
	            transitionsToWait.push(transition);
	        };
	        return f;
	    };
	
	    c3_chart_internal_fn.parseDate = function (date) {
	        var $$ = this,
	            parsedDate;
	        if (date instanceof Date) {
	            parsedDate = date;
	        } else if (typeof date === 'string') {
	            parsedDate = $$.dataTimeFormat($$.config.data_xFormat).parse(date);
	        } else if ((typeof date === 'undefined' ? 'undefined' : _typeof(date)) === 'object') {
	            parsedDate = new Date(+date);
	        } else if (typeof date === 'number' && !isNaN(date)) {
	            parsedDate = new Date(+date);
	        }
	        if (!parsedDate || isNaN(+parsedDate)) {
	            window.console.error("Failed to parse x '" + date + "' to Date object");
	        }
	        return parsedDate;
	    };
	
	    c3_chart_internal_fn.isTabVisible = function () {
	        var hidden;
	        if (typeof document.hidden !== "undefined") {
	            // Opera 12.10 and Firefox 18 and later support
	            hidden = "hidden";
	        } else if (typeof document.mozHidden !== "undefined") {
	            hidden = "mozHidden";
	        } else if (typeof document.msHidden !== "undefined") {
	            hidden = "msHidden";
	        } else if (typeof document.webkitHidden !== "undefined") {
	            hidden = "webkitHidden";
	        }
	
	        return document[hidden] ? false : true;
	    };
	
	    c3_chart_internal_fn.isValue = isValue;
	    c3_chart_internal_fn.isFunction = isFunction;
	    c3_chart_internal_fn.isString = isString;
	    c3_chart_internal_fn.isUndefined = isUndefined;
	    c3_chart_internal_fn.isDefined = isDefined;
	    c3_chart_internal_fn.ceil10 = ceil10;
	    c3_chart_internal_fn.asHalfPixel = asHalfPixel;
	    c3_chart_internal_fn.diffDomain = diffDomain;
	    c3_chart_internal_fn.isEmpty = isEmpty;
	    c3_chart_internal_fn.notEmpty = notEmpty;
	    c3_chart_internal_fn.notEmpty = notEmpty;
	    c3_chart_internal_fn.getOption = getOption;
	    c3_chart_internal_fn.hasValue = hasValue;
	    c3_chart_internal_fn.sanitise = sanitise;
	    c3_chart_internal_fn.getPathBox = getPathBox;
	    c3_chart_internal_fn.CLASS = CLASS;
	
	    /* jshint ignore:start */
	
	    // PhantomJS doesn't have support for Function.prototype.bind, which has caused confusion. Use
	    // this polyfill to avoid the confusion.
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill
	
	    if (!Function.prototype.bind) {
	        Function.prototype.bind = function (oThis) {
	            if (typeof this !== 'function') {
	                // closest thing possible to the ECMAScript 5
	                // internal IsCallable function
	                throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	            }
	
	            var aArgs = Array.prototype.slice.call(arguments, 1),
	                fToBind = this,
	                fNOP = function fNOP() {},
	                fBound = function fBound() {
	                return fToBind.apply(this instanceof fNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
	            };
	
	            fNOP.prototype = this.prototype;
	            fBound.prototype = new fNOP();
	
	            return fBound;
	        };
	    }
	
	    // SVGPathSeg API polyfill
	    // https://github.com/progers/pathseg
	    //
	    // This is a drop-in replacement for the SVGPathSeg and SVGPathSegList APIs that were removed from
	    // SVG2 (https://lists.w3.org/Archives/Public/www-svg/2015Jun/0044.html), including the latest spec
	    // changes which were implemented in Firefox 43 and Chrome 46.
	
	    (function () {
	
	        if (!("SVGPathSeg" in window)) {
	            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathSeg
	            window.SVGPathSeg = function (type, typeAsLetter, owningPathSegList) {
	                this.pathSegType = type;
	                this.pathSegTypeAsLetter = typeAsLetter;
	                this._owningPathSegList = owningPathSegList;
	            };
	
	            window.SVGPathSeg.prototype.classname = "SVGPathSeg";
	
	            window.SVGPathSeg.PATHSEG_UNKNOWN = 0;
	            window.SVGPathSeg.PATHSEG_CLOSEPATH = 1;
	            window.SVGPathSeg.PATHSEG_MOVETO_ABS = 2;
	            window.SVGPathSeg.PATHSEG_MOVETO_REL = 3;
	            window.SVGPathSeg.PATHSEG_LINETO_ABS = 4;
	            window.SVGPathSeg.PATHSEG_LINETO_REL = 5;
	            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS = 6;
	            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL = 7;
	            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS = 8;
	            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL = 9;
	            window.SVGPathSeg.PATHSEG_ARC_ABS = 10;
	            window.SVGPathSeg.PATHSEG_ARC_REL = 11;
	            window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS = 12;
	            window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL = 13;
	            window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS = 14;
	            window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL = 15;
	            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS = 16;
	            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL = 17;
	            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS = 18;
	            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL = 19;
	
	            // Notify owning PathSegList on any changes so they can be synchronized back to the path element.
	            window.SVGPathSeg.prototype._segmentChanged = function () {
	                if (this._owningPathSegList) this._owningPathSegList.segmentChanged(this);
	            };
	
	            window.SVGPathSegClosePath = function (owningPathSegList) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CLOSEPATH, "z", owningPathSegList);
	            };
	            window.SVGPathSegClosePath.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegClosePath.prototype.toString = function () {
	                return "[object SVGPathSegClosePath]";
	            };
	            window.SVGPathSegClosePath.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter;
	            };
	            window.SVGPathSegClosePath.prototype.clone = function () {
	                return new window.SVGPathSegClosePath(undefined);
	            };
	
	            window.SVGPathSegMovetoAbs = function (owningPathSegList, x, y) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_ABS, "M", owningPathSegList);
	                this._x = x;
	                this._y = y;
	            };
	            window.SVGPathSegMovetoAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegMovetoAbs.prototype.toString = function () {
	                return "[object SVGPathSegMovetoAbs]";
	            };
	            window.SVGPathSegMovetoAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegMovetoAbs.prototype.clone = function () {
	                return new window.SVGPathSegMovetoAbs(undefined, this._x, this._y);
	            };
	            Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegMovetoRel = function (owningPathSegList, x, y) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_REL, "m", owningPathSegList);
	                this._x = x;
	                this._y = y;
	            };
	            window.SVGPathSegMovetoRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegMovetoRel.prototype.toString = function () {
	                return "[object SVGPathSegMovetoRel]";
	            };
	            window.SVGPathSegMovetoRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegMovetoRel.prototype.clone = function () {
	                return new window.SVGPathSegMovetoRel(undefined, this._x, this._y);
	            };
	            Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegLinetoAbs = function (owningPathSegList, x, y) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_ABS, "L", owningPathSegList);
	                this._x = x;
	                this._y = y;
	            };
	            window.SVGPathSegLinetoAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegLinetoAbs.prototype.toString = function () {
	                return "[object SVGPathSegLinetoAbs]";
	            };
	            window.SVGPathSegLinetoAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegLinetoAbs.prototype.clone = function () {
	                return new window.SVGPathSegLinetoAbs(undefined, this._x, this._y);
	            };
	            Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegLinetoRel = function (owningPathSegList, x, y) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_REL, "l", owningPathSegList);
	                this._x = x;
	                this._y = y;
	            };
	            window.SVGPathSegLinetoRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegLinetoRel.prototype.toString = function () {
	                return "[object SVGPathSegLinetoRel]";
	            };
	            window.SVGPathSegLinetoRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegLinetoRel.prototype.clone = function () {
	                return new window.SVGPathSegLinetoRel(undefined, this._x, this._y);
	            };
	            Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegCurvetoCubicAbs = function (owningPathSegList, x, y, x1, y1, x2, y2) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS, "C", owningPathSegList);
	                this._x = x;
	                this._y = y;
	                this._x1 = x1;
	                this._y1 = y1;
	                this._x2 = x2;
	                this._y2 = y2;
	            };
	            window.SVGPathSegCurvetoCubicAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegCurvetoCubicAbs.prototype.toString = function () {
	                return "[object SVGPathSegCurvetoCubicAbs]";
	            };
	            window.SVGPathSegCurvetoCubicAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegCurvetoCubicAbs.prototype.clone = function () {
	                return new window.SVGPathSegCurvetoCubicAbs(undefined, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
	            };
	            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x1", { get: function get() {
	                    return this._x1;
	                }, set: function set(x1) {
	                    this._x1 = x1;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y1", { get: function get() {
	                    return this._y1;
	                }, set: function set(y1) {
	                    this._y1 = y1;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x2", { get: function get() {
	                    return this._x2;
	                }, set: function set(x2) {
	                    this._x2 = x2;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y2", { get: function get() {
	                    return this._y2;
	                }, set: function set(y2) {
	                    this._y2 = y2;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegCurvetoCubicRel = function (owningPathSegList, x, y, x1, y1, x2, y2) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL, "c", owningPathSegList);
	                this._x = x;
	                this._y = y;
	                this._x1 = x1;
	                this._y1 = y1;
	                this._x2 = x2;
	                this._y2 = y2;
	            };
	            window.SVGPathSegCurvetoCubicRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegCurvetoCubicRel.prototype.toString = function () {
	                return "[object SVGPathSegCurvetoCubicRel]";
	            };
	            window.SVGPathSegCurvetoCubicRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegCurvetoCubicRel.prototype.clone = function () {
	                return new window.SVGPathSegCurvetoCubicRel(undefined, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
	            };
	            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x1", { get: function get() {
	                    return this._x1;
	                }, set: function set(x1) {
	                    this._x1 = x1;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y1", { get: function get() {
	                    return this._y1;
	                }, set: function set(y1) {
	                    this._y1 = y1;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x2", { get: function get() {
	                    return this._x2;
	                }, set: function set(x2) {
	                    this._x2 = x2;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y2", { get: function get() {
	                    return this._y2;
	                }, set: function set(y2) {
	                    this._y2 = y2;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegCurvetoQuadraticAbs = function (owningPathSegList, x, y, x1, y1) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS, "Q", owningPathSegList);
	                this._x = x;
	                this._y = y;
	                this._x1 = x1;
	                this._y1 = y1;
	            };
	            window.SVGPathSegCurvetoQuadraticAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegCurvetoQuadraticAbs.prototype.toString = function () {
	                return "[object SVGPathSegCurvetoQuadraticAbs]";
	            };
	            window.SVGPathSegCurvetoQuadraticAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegCurvetoQuadraticAbs.prototype.clone = function () {
	                return new window.SVGPathSegCurvetoQuadraticAbs(undefined, this._x, this._y, this._x1, this._y1);
	            };
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x1", { get: function get() {
	                    return this._x1;
	                }, set: function set(x1) {
	                    this._x1 = x1;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y1", { get: function get() {
	                    return this._y1;
	                }, set: function set(y1) {
	                    this._y1 = y1;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegCurvetoQuadraticRel = function (owningPathSegList, x, y, x1, y1) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL, "q", owningPathSegList);
	                this._x = x;
	                this._y = y;
	                this._x1 = x1;
	                this._y1 = y1;
	            };
	            window.SVGPathSegCurvetoQuadraticRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegCurvetoQuadraticRel.prototype.toString = function () {
	                return "[object SVGPathSegCurvetoQuadraticRel]";
	            };
	            window.SVGPathSegCurvetoQuadraticRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegCurvetoQuadraticRel.prototype.clone = function () {
	                return new window.SVGPathSegCurvetoQuadraticRel(undefined, this._x, this._y, this._x1, this._y1);
	            };
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x1", { get: function get() {
	                    return this._x1;
	                }, set: function set(x1) {
	                    this._x1 = x1;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y1", { get: function get() {
	                    return this._y1;
	                }, set: function set(y1) {
	                    this._y1 = y1;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegArcAbs = function (owningPathSegList, x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_ABS, "A", owningPathSegList);
	                this._x = x;
	                this._y = y;
	                this._r1 = r1;
	                this._r2 = r2;
	                this._angle = angle;
	                this._largeArcFlag = largeArcFlag;
	                this._sweepFlag = sweepFlag;
	            };
	            window.SVGPathSegArcAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegArcAbs.prototype.toString = function () {
	                return "[object SVGPathSegArcAbs]";
	            };
	            window.SVGPathSegArcAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegArcAbs.prototype.clone = function () {
	                return new window.SVGPathSegArcAbs(undefined, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
	            };
	            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r1", { get: function get() {
	                    return this._r1;
	                }, set: function set(r1) {
	                    this._r1 = r1;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r2", { get: function get() {
	                    return this._r2;
	                }, set: function set(r2) {
	                    this._r2 = r2;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "angle", { get: function get() {
	                    return this._angle;
	                }, set: function set(angle) {
	                    this._angle = angle;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "largeArcFlag", { get: function get() {
	                    return this._largeArcFlag;
	                }, set: function set(largeArcFlag) {
	                    this._largeArcFlag = largeArcFlag;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "sweepFlag", { get: function get() {
	                    return this._sweepFlag;
	                }, set: function set(sweepFlag) {
	                    this._sweepFlag = sweepFlag;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegArcRel = function (owningPathSegList, x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_REL, "a", owningPathSegList);
	                this._x = x;
	                this._y = y;
	                this._r1 = r1;
	                this._r2 = r2;
	                this._angle = angle;
	                this._largeArcFlag = largeArcFlag;
	                this._sweepFlag = sweepFlag;
	            };
	            window.SVGPathSegArcRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegArcRel.prototype.toString = function () {
	                return "[object SVGPathSegArcRel]";
	            };
	            window.SVGPathSegArcRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegArcRel.prototype.clone = function () {
	                return new window.SVGPathSegArcRel(undefined, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
	            };
	            Object.defineProperty(window.SVGPathSegArcRel.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcRel.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcRel.prototype, "r1", { get: function get() {
	                    return this._r1;
	                }, set: function set(r1) {
	                    this._r1 = r1;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcRel.prototype, "r2", { get: function get() {
	                    return this._r2;
	                }, set: function set(r2) {
	                    this._r2 = r2;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcRel.prototype, "angle", { get: function get() {
	                    return this._angle;
	                }, set: function set(angle) {
	                    this._angle = angle;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcRel.prototype, "largeArcFlag", { get: function get() {
	                    return this._largeArcFlag;
	                }, set: function set(largeArcFlag) {
	                    this._largeArcFlag = largeArcFlag;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegArcRel.prototype, "sweepFlag", { get: function get() {
	                    return this._sweepFlag;
	                }, set: function set(sweepFlag) {
	                    this._sweepFlag = sweepFlag;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegLinetoHorizontalAbs = function (owningPathSegList, x) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS, "H", owningPathSegList);
	                this._x = x;
	            };
	            window.SVGPathSegLinetoHorizontalAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegLinetoHorizontalAbs.prototype.toString = function () {
	                return "[object SVGPathSegLinetoHorizontalAbs]";
	            };
	            window.SVGPathSegLinetoHorizontalAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x;
	            };
	            window.SVGPathSegLinetoHorizontalAbs.prototype.clone = function () {
	                return new window.SVGPathSegLinetoHorizontalAbs(undefined, this._x);
	            };
	            Object.defineProperty(window.SVGPathSegLinetoHorizontalAbs.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegLinetoHorizontalRel = function (owningPathSegList, x) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL, "h", owningPathSegList);
	                this._x = x;
	            };
	            window.SVGPathSegLinetoHorizontalRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegLinetoHorizontalRel.prototype.toString = function () {
	                return "[object SVGPathSegLinetoHorizontalRel]";
	            };
	            window.SVGPathSegLinetoHorizontalRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x;
	            };
	            window.SVGPathSegLinetoHorizontalRel.prototype.clone = function () {
	                return new window.SVGPathSegLinetoHorizontalRel(undefined, this._x);
	            };
	            Object.defineProperty(window.SVGPathSegLinetoHorizontalRel.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegLinetoVerticalAbs = function (owningPathSegList, y) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS, "V", owningPathSegList);
	                this._y = y;
	            };
	            window.SVGPathSegLinetoVerticalAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegLinetoVerticalAbs.prototype.toString = function () {
	                return "[object SVGPathSegLinetoVerticalAbs]";
	            };
	            window.SVGPathSegLinetoVerticalAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._y;
	            };
	            window.SVGPathSegLinetoVerticalAbs.prototype.clone = function () {
	                return new window.SVGPathSegLinetoVerticalAbs(undefined, this._y);
	            };
	            Object.defineProperty(window.SVGPathSegLinetoVerticalAbs.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegLinetoVerticalRel = function (owningPathSegList, y) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL, "v", owningPathSegList);
	                this._y = y;
	            };
	            window.SVGPathSegLinetoVerticalRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegLinetoVerticalRel.prototype.toString = function () {
	                return "[object SVGPathSegLinetoVerticalRel]";
	            };
	            window.SVGPathSegLinetoVerticalRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._y;
	            };
	            window.SVGPathSegLinetoVerticalRel.prototype.clone = function () {
	                return new window.SVGPathSegLinetoVerticalRel(undefined, this._y);
	            };
	            Object.defineProperty(window.SVGPathSegLinetoVerticalRel.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegCurvetoCubicSmoothAbs = function (owningPathSegList, x, y, x2, y2) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS, "S", owningPathSegList);
	                this._x = x;
	                this._y = y;
	                this._x2 = x2;
	                this._y2 = y2;
	            };
	            window.SVGPathSegCurvetoCubicSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegCurvetoCubicSmoothAbs.prototype.toString = function () {
	                return "[object SVGPathSegCurvetoCubicSmoothAbs]";
	            };
	            window.SVGPathSegCurvetoCubicSmoothAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegCurvetoCubicSmoothAbs.prototype.clone = function () {
	                return new window.SVGPathSegCurvetoCubicSmoothAbs(undefined, this._x, this._y, this._x2, this._y2);
	            };
	            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x2", { get: function get() {
	                    return this._x2;
	                }, set: function set(x2) {
	                    this._x2 = x2;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y2", { get: function get() {
	                    return this._y2;
	                }, set: function set(y2) {
	                    this._y2 = y2;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegCurvetoCubicSmoothRel = function (owningPathSegList, x, y, x2, y2) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL, "s", owningPathSegList);
	                this._x = x;
	                this._y = y;
	                this._x2 = x2;
	                this._y2 = y2;
	            };
	            window.SVGPathSegCurvetoCubicSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegCurvetoCubicSmoothRel.prototype.toString = function () {
	                return "[object SVGPathSegCurvetoCubicSmoothRel]";
	            };
	            window.SVGPathSegCurvetoCubicSmoothRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegCurvetoCubicSmoothRel.prototype.clone = function () {
	                return new window.SVGPathSegCurvetoCubicSmoothRel(undefined, this._x, this._y, this._x2, this._y2);
	            };
	            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x2", { get: function get() {
	                    return this._x2;
	                }, set: function set(x2) {
	                    this._x2 = x2;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y2", { get: function get() {
	                    return this._y2;
	                }, set: function set(y2) {
	                    this._y2 = y2;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegCurvetoQuadraticSmoothAbs = function (owningPathSegList, x, y) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS, "T", owningPathSegList);
	                this._x = x;
	                this._y = y;
	            };
	            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.toString = function () {
	                return "[object SVGPathSegCurvetoQuadraticSmoothAbs]";
	            };
	            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.clone = function () {
	                return new window.SVGPathSegCurvetoQuadraticSmoothAbs(undefined, this._x, this._y);
	            };
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	
	            window.SVGPathSegCurvetoQuadraticSmoothRel = function (owningPathSegList, x, y) {
	                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL, "t", owningPathSegList);
	                this._x = x;
	                this._y = y;
	            };
	            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype);
	            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.toString = function () {
	                return "[object SVGPathSegCurvetoQuadraticSmoothRel]";
	            };
	            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype._asPathString = function () {
	                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	            };
	            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.clone = function () {
	                return new window.SVGPathSegCurvetoQuadraticSmoothRel(undefined, this._x, this._y);
	            };
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "x", { get: function get() {
	                    return this._x;
	                }, set: function set(x) {
	                    this._x = x;this._segmentChanged();
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "y", { get: function get() {
	                    return this._y;
	                }, set: function set(y) {
	                    this._y = y;this._segmentChanged();
	                }, enumerable: true });
	
	            // Add createSVGPathSeg* functions to window.SVGPathElement.
	            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-Interfacewindow.SVGPathElement.
	            window.SVGPathElement.prototype.createSVGPathSegClosePath = function () {
	                return new window.SVGPathSegClosePath(undefined);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegMovetoAbs = function (x, y) {
	                return new window.SVGPathSegMovetoAbs(undefined, x, y);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegMovetoRel = function (x, y) {
	                return new window.SVGPathSegMovetoRel(undefined, x, y);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegLinetoAbs = function (x, y) {
	                return new window.SVGPathSegLinetoAbs(undefined, x, y);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegLinetoRel = function (x, y) {
	                return new window.SVGPathSegLinetoRel(undefined, x, y);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicAbs = function (x, y, x1, y1, x2, y2) {
	                return new window.SVGPathSegCurvetoCubicAbs(undefined, x, y, x1, y1, x2, y2);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicRel = function (x, y, x1, y1, x2, y2) {
	                return new window.SVGPathSegCurvetoCubicRel(undefined, x, y, x1, y1, x2, y2);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticAbs = function (x, y, x1, y1) {
	                return new window.SVGPathSegCurvetoQuadraticAbs(undefined, x, y, x1, y1);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticRel = function (x, y, x1, y1) {
	                return new window.SVGPathSegCurvetoQuadraticRel(undefined, x, y, x1, y1);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegArcAbs = function (x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
	                return new window.SVGPathSegArcAbs(undefined, x, y, r1, r2, angle, largeArcFlag, sweepFlag);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegArcRel = function (x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
	                return new window.SVGPathSegArcRel(undefined, x, y, r1, r2, angle, largeArcFlag, sweepFlag);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalAbs = function (x) {
	                return new window.SVGPathSegLinetoHorizontalAbs(undefined, x);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalRel = function (x) {
	                return new window.SVGPathSegLinetoHorizontalRel(undefined, x);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalAbs = function (y) {
	                return new window.SVGPathSegLinetoVerticalAbs(undefined, y);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalRel = function (y) {
	                return new window.SVGPathSegLinetoVerticalRel(undefined, y);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothAbs = function (x, y, x2, y2) {
	                return new window.SVGPathSegCurvetoCubicSmoothAbs(undefined, x, y, x2, y2);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothRel = function (x, y, x2, y2) {
	                return new window.SVGPathSegCurvetoCubicSmoothRel(undefined, x, y, x2, y2);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothAbs = function (x, y) {
	                return new window.SVGPathSegCurvetoQuadraticSmoothAbs(undefined, x, y);
	            };
	            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothRel = function (x, y) {
	                return new window.SVGPathSegCurvetoQuadraticSmoothRel(undefined, x, y);
	            };
	
	            if (!("getPathSegAtLength" in window.SVGPathElement.prototype)) {
	                // Add getPathSegAtLength to SVGPathElement.
	                // Spec: https://www.w3.org/TR/SVG11/single-page.html#paths-__svg__SVGPathElement__getPathSegAtLength
	                // This polyfill requires SVGPathElement.getTotalLength to implement the distance-along-a-path algorithm.
	                window.SVGPathElement.prototype.getPathSegAtLength = function (distance) {
	                    if (distance === undefined || !isFinite(distance)) throw "Invalid arguments.";
	
	                    var measurementElement = document.createElementNS("http://www.w3.org/2000/svg", "path");
	                    measurementElement.setAttribute("d", this.getAttribute("d"));
	                    var lastPathSegment = measurementElement.pathSegList.numberOfItems - 1;
	
	                    // If the path is empty, return 0.
	                    if (lastPathSegment <= 0) return 0;
	
	                    do {
	                        measurementElement.pathSegList.removeItem(lastPathSegment);
	                        if (distance > measurementElement.getTotalLength()) break;
	                        lastPathSegment--;
	                    } while (lastPathSegment > 0);
	                    return lastPathSegment;
	                };
	            }
	        }
	
	        if (!("SVGPathSegList" in window)) {
	            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathSegList
	            window.SVGPathSegList = function (pathElement) {
	                this._pathElement = pathElement;
	                this._list = this._parsePath(this._pathElement.getAttribute("d"));
	
	                // Use a MutationObserver to catch changes to the path's "d" attribute.
	                this._mutationObserverConfig = { "attributes": true, "attributeFilter": ["d"] };
	                this._pathElementMutationObserver = new MutationObserver(this._updateListFromPathMutations.bind(this));
	                this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
	            };
	
	            window.SVGPathSegList.prototype.classname = "SVGPathSegList";
	
	            Object.defineProperty(window.SVGPathSegList.prototype, "numberOfItems", {
	                get: function get() {
	                    this._checkPathSynchronizedToList();
	                    return this._list.length;
	                },
	                enumerable: true
	            });
	
	            // Add the pathSegList accessors to window.SVGPathElement.
	            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGAnimatedPathData
	            Object.defineProperty(window.SVGPathElement.prototype, "pathSegList", {
	                get: function get() {
	                    if (!this._pathSegList) this._pathSegList = new window.SVGPathSegList(this);
	                    return this._pathSegList;
	                },
	                enumerable: true
	            });
	            // FIXME: The following are not implemented and simply return window.SVGPathElement.pathSegList.
	            Object.defineProperty(window.SVGPathElement.prototype, "normalizedPathSegList", { get: function get() {
	                    return this.pathSegList;
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathElement.prototype, "animatedPathSegList", { get: function get() {
	                    return this.pathSegList;
	                }, enumerable: true });
	            Object.defineProperty(window.SVGPathElement.prototype, "animatedNormalizedPathSegList", { get: function get() {
	                    return this.pathSegList;
	                }, enumerable: true });
	
	            // Process any pending mutations to the path element and update the list as needed.
	            // This should be the first call of all public functions and is needed because
	            // MutationObservers are not synchronous so we can have pending asynchronous mutations.
	            window.SVGPathSegList.prototype._checkPathSynchronizedToList = function () {
	                this._updateListFromPathMutations(this._pathElementMutationObserver.takeRecords());
	            };
	
	            window.SVGPathSegList.prototype._updateListFromPathMutations = function (mutationRecords) {
	                if (!this._pathElement) return;
	                var hasPathMutations = false;
	                mutationRecords.forEach(function (record) {
	                    if (record.attributeName == "d") hasPathMutations = true;
	                });
	                if (hasPathMutations) this._list = this._parsePath(this._pathElement.getAttribute("d"));
	            };
	
	            // Serialize the list and update the path's 'd' attribute.
	            window.SVGPathSegList.prototype._writeListToPath = function () {
	                this._pathElementMutationObserver.disconnect();
	                this._pathElement.setAttribute("d", window.SVGPathSegList._pathSegArrayAsString(this._list));
	                this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
	            };
	
	            // When a path segment changes the list needs to be synchronized back to the path element.
	            window.SVGPathSegList.prototype.segmentChanged = function (pathSeg) {
	                this._writeListToPath();
	            };
	
	            window.SVGPathSegList.prototype.clear = function () {
	                this._checkPathSynchronizedToList();
	
	                this._list.forEach(function (pathSeg) {
	                    pathSeg._owningPathSegList = null;
	                });
	                this._list = [];
	                this._writeListToPath();
	            };
	
	            window.SVGPathSegList.prototype.initialize = function (newItem) {
	                this._checkPathSynchronizedToList();
	
	                this._list = [newItem];
	                newItem._owningPathSegList = this;
	                this._writeListToPath();
	                return newItem;
	            };
	
	            window.SVGPathSegList.prototype._checkValidIndex = function (index) {
	                if (isNaN(index) || index < 0 || index >= this.numberOfItems) throw "INDEX_SIZE_ERR";
	            };
	
	            window.SVGPathSegList.prototype.getItem = function (index) {
	                this._checkPathSynchronizedToList();
	
	                this._checkValidIndex(index);
	                return this._list[index];
	            };
	
	            window.SVGPathSegList.prototype.insertItemBefore = function (newItem, index) {
	                this._checkPathSynchronizedToList();
	
	                // Spec: If the index is greater than or equal to numberOfItems, then the new item is appended to the end of the list.
	                if (index > this.numberOfItems) index = this.numberOfItems;
	                if (newItem._owningPathSegList) {
	                    // SVG2 spec says to make a copy.
	                    newItem = newItem.clone();
	                }
	                this._list.splice(index, 0, newItem);
	                newItem._owningPathSegList = this;
	                this._writeListToPath();
	                return newItem;
	            };
	
	            window.SVGPathSegList.prototype.replaceItem = function (newItem, index) {
	                this._checkPathSynchronizedToList();
	
	                if (newItem._owningPathSegList) {
	                    // SVG2 spec says to make a copy.
	                    newItem = newItem.clone();
	                }
	                this._checkValidIndex(index);
	                this._list[index] = newItem;
	                newItem._owningPathSegList = this;
	                this._writeListToPath();
	                return newItem;
	            };
	
	            window.SVGPathSegList.prototype.removeItem = function (index) {
	                this._checkPathSynchronizedToList();
	
	                this._checkValidIndex(index);
	                var item = this._list[index];
	                this._list.splice(index, 1);
	                this._writeListToPath();
	                return item;
	            };
	
	            window.SVGPathSegList.prototype.appendItem = function (newItem) {
	                this._checkPathSynchronizedToList();
	
	                if (newItem._owningPathSegList) {
	                    // SVG2 spec says to make a copy.
	                    newItem = newItem.clone();
	                }
	                this._list.push(newItem);
	                newItem._owningPathSegList = this;
	                // TODO: Optimize this to just append to the existing attribute.
	                this._writeListToPath();
	                return newItem;
	            };
	
	            window.SVGPathSegList._pathSegArrayAsString = function (pathSegArray) {
	                var string = "";
	                var first = true;
	                pathSegArray.forEach(function (pathSeg) {
	                    if (first) {
	                        first = false;
	                        string += pathSeg._asPathString();
	                    } else {
	                        string += " " + pathSeg._asPathString();
	                    }
	                });
	                return string;
	            };
	
	            // This closely follows SVGPathParser::parsePath from Source/core/svg/SVGPathParser.cpp.
	            window.SVGPathSegList.prototype._parsePath = function (string) {
	                if (!string || string.length == 0) return [];
	
	                var owningPathSegList = this;
	
	                var Builder = function Builder() {
	                    this.pathSegList = [];
	                };
	
	                Builder.prototype.appendSegment = function (pathSeg) {
	                    this.pathSegList.push(pathSeg);
	                };
	
	                var Source = function Source(string) {
	                    this._string = string;
	                    this._currentIndex = 0;
	                    this._endIndex = this._string.length;
	                    this._previousCommand = window.SVGPathSeg.PATHSEG_UNKNOWN;
	
	                    this._skipOptionalSpaces();
	                };
	
	                Source.prototype._isCurrentSpace = function () {
	                    var character = this._string[this._currentIndex];
	                    return character <= " " && (character == " " || character == "\n" || character == "\t" || character == "\r" || character == "\f");
	                };
	
	                Source.prototype._skipOptionalSpaces = function () {
	                    while (this._currentIndex < this._endIndex && this._isCurrentSpace()) {
	                        this._currentIndex++;
	                    }return this._currentIndex < this._endIndex;
	                };
	
	                Source.prototype._skipOptionalSpacesOrDelimiter = function () {
	                    if (this._currentIndex < this._endIndex && !this._isCurrentSpace() && this._string.charAt(this._currentIndex) != ",") return false;
	                    if (this._skipOptionalSpaces()) {
	                        if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ",") {
	                            this._currentIndex++;
	                            this._skipOptionalSpaces();
	                        }
	                    }
	                    return this._currentIndex < this._endIndex;
	                };
	
	                Source.prototype.hasMoreData = function () {
	                    return this._currentIndex < this._endIndex;
	                };
	
	                Source.prototype.peekSegmentType = function () {
	                    var lookahead = this._string[this._currentIndex];
	                    return this._pathSegTypeFromChar(lookahead);
	                };
	
	                Source.prototype._pathSegTypeFromChar = function (lookahead) {
	                    switch (lookahead) {
	                        case "Z":
	                        case "z":
	                            return window.SVGPathSeg.PATHSEG_CLOSEPATH;
	                        case "M":
	                            return window.SVGPathSeg.PATHSEG_MOVETO_ABS;
	                        case "m":
	                            return window.SVGPathSeg.PATHSEG_MOVETO_REL;
	                        case "L":
	                            return window.SVGPathSeg.PATHSEG_LINETO_ABS;
	                        case "l":
	                            return window.SVGPathSeg.PATHSEG_LINETO_REL;
	                        case "C":
	                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS;
	                        case "c":
	                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL;
	                        case "Q":
	                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS;
	                        case "q":
	                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL;
	                        case "A":
	                            return window.SVGPathSeg.PATHSEG_ARC_ABS;
	                        case "a":
	                            return window.SVGPathSeg.PATHSEG_ARC_REL;
	                        case "H":
	                            return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS;
	                        case "h":
	                            return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL;
	                        case "V":
	                            return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS;
	                        case "v":
	                            return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL;
	                        case "S":
	                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS;
	                        case "s":
	                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL;
	                        case "T":
	                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS;
	                        case "t":
	                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL;
	                        default:
	                            return window.SVGPathSeg.PATHSEG_UNKNOWN;
	                    }
	                };
	
	                Source.prototype._nextCommandHelper = function (lookahead, previousCommand) {
	                    // Check for remaining coordinates in the current command.
	                    if ((lookahead == "+" || lookahead == "-" || lookahead == "." || lookahead >= "0" && lookahead <= "9") && previousCommand != window.SVGPathSeg.PATHSEG_CLOSEPATH) {
	                        if (previousCommand == window.SVGPathSeg.PATHSEG_MOVETO_ABS) return window.SVGPathSeg.PATHSEG_LINETO_ABS;
	                        if (previousCommand == window.SVGPathSeg.PATHSEG_MOVETO_REL) return window.SVGPathSeg.PATHSEG_LINETO_REL;
	                        return previousCommand;
	                    }
	                    return window.SVGPathSeg.PATHSEG_UNKNOWN;
	                };
	
	                Source.prototype.initialCommandIsMoveTo = function () {
	                    // If the path is empty it is still valid, so return true.
	                    if (!this.hasMoreData()) return true;
	                    var command = this.peekSegmentType();
	                    // Path must start with moveTo.
	                    return command == window.SVGPathSeg.PATHSEG_MOVETO_ABS || command == window.SVGPathSeg.PATHSEG_MOVETO_REL;
	                };
	
	                // Parse a number from an SVG path. This very closely follows genericParseNumber(...) from Source/core/svg/SVGParserUtilities.cpp.
	                // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-PathDataBNF
	                Source.prototype._parseNumber = function () {
	                    var exponent = 0;
	                    var integer = 0;
	                    var frac = 1;
	                    var decimal = 0;
	                    var sign = 1;
	                    var expsign = 1;
	
	                    var startIndex = this._currentIndex;
	
	                    this._skipOptionalSpaces();
	
	                    // Read the sign.
	                    if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "+") this._currentIndex++;else if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "-") {
	                        this._currentIndex++;
	                        sign = -1;
	                    }
	
	                    if (this._currentIndex == this._endIndex || (this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") && this._string.charAt(this._currentIndex) != ".")
	                        // The first character of a number must be one of [0-9+-.].
	                        return undefined;
	
	                    // Read the integer part, build right-to-left.
	                    var startIntPartIndex = this._currentIndex;
	                    while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9") {
	                        this._currentIndex++;
	                    } // Advance to first non-digit.
	
	                    if (this._currentIndex != startIntPartIndex) {
	                        var scanIntPartIndex = this._currentIndex - 1;
	                        var multiplier = 1;
	                        while (scanIntPartIndex >= startIntPartIndex) {
	                            integer += multiplier * (this._string.charAt(scanIntPartIndex--) - "0");
	                            multiplier *= 10;
	                        }
	                    }
	
	                    // Read the decimals.
	                    if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ".") {
	                        this._currentIndex++;
	
	                        // There must be a least one digit following the .
	                        if (this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") return undefined;
	                        while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9") {
	                            frac *= 10;
	                            decimal += (this._string.charAt(this._currentIndex) - "0") / frac;
	                            this._currentIndex += 1;
	                        }
	                    }
	
	                    // Read the exponent part.
	                    if (this._currentIndex != startIndex && this._currentIndex + 1 < this._endIndex && (this._string.charAt(this._currentIndex) == "e" || this._string.charAt(this._currentIndex) == "E") && this._string.charAt(this._currentIndex + 1) != "x" && this._string.charAt(this._currentIndex + 1) != "m") {
	                        this._currentIndex++;
	
	                        // Read the sign of the exponent.
	                        if (this._string.charAt(this._currentIndex) == "+") {
	                            this._currentIndex++;
	                        } else if (this._string.charAt(this._currentIndex) == "-") {
	                            this._currentIndex++;
	                            expsign = -1;
	                        }
	
	                        // There must be an exponent.
	                        if (this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") return undefined;
	
	                        while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9") {
	                            exponent *= 10;
	                            exponent += this._string.charAt(this._currentIndex) - "0";
	                            this._currentIndex++;
	                        }
	                    }
	
	                    var number = integer + decimal;
	                    number *= sign;
	
	                    if (exponent) number *= Math.pow(10, expsign * exponent);
	
	                    if (startIndex == this._currentIndex) return undefined;
	
	                    this._skipOptionalSpacesOrDelimiter();
	
	                    return number;
	                };
	
	                Source.prototype._parseArcFlag = function () {
	                    if (this._currentIndex >= this._endIndex) return undefined;
	                    var flag = false;
	                    var flagChar = this._string.charAt(this._currentIndex++);
	                    if (flagChar == "0") flag = false;else if (flagChar == "1") flag = true;else return undefined;
	
	                    this._skipOptionalSpacesOrDelimiter();
	                    return flag;
	                };
	
	                Source.prototype.parseSegment = function () {
	                    var lookahead = this._string[this._currentIndex];
	                    var command = this._pathSegTypeFromChar(lookahead);
	                    if (command == window.SVGPathSeg.PATHSEG_UNKNOWN) {
	                        // Possibly an implicit command. Not allowed if this is the first command.
	                        if (this._previousCommand == window.SVGPathSeg.PATHSEG_UNKNOWN) return null;
	                        command = this._nextCommandHelper(lookahead, this._previousCommand);
	                        if (command == window.SVGPathSeg.PATHSEG_UNKNOWN) return null;
	                    } else {
	                        this._currentIndex++;
	                    }
	
	                    this._previousCommand = command;
	
	                    switch (command) {
	                        case window.SVGPathSeg.PATHSEG_MOVETO_REL:
	                            return new window.SVGPathSegMovetoRel(owningPathSegList, this._parseNumber(), this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_MOVETO_ABS:
	                            return new window.SVGPathSegMovetoAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_LINETO_REL:
	                            return new window.SVGPathSegLinetoRel(owningPathSegList, this._parseNumber(), this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_LINETO_ABS:
	                            return new window.SVGPathSegLinetoAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL:
	                            return new window.SVGPathSegLinetoHorizontalRel(owningPathSegList, this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS:
	                            return new window.SVGPathSegLinetoHorizontalAbs(owningPathSegList, this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL:
	                            return new window.SVGPathSegLinetoVerticalRel(owningPathSegList, this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS:
	                            return new window.SVGPathSegLinetoVerticalAbs(owningPathSegList, this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_CLOSEPATH:
	                            this._skipOptionalSpaces();
	                            return new window.SVGPathSegClosePath(owningPathSegList);
	                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL:
	                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
	                            return new window.SVGPathSegCurvetoCubicRel(owningPathSegList, points.x, points.y, points.x1, points.y1, points.x2, points.y2);
	                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
	                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
	                            return new window.SVGPathSegCurvetoCubicAbs(owningPathSegList, points.x, points.y, points.x1, points.y1, points.x2, points.y2);
	                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL:
	                            var points = { x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
	                            return new window.SVGPathSegCurvetoCubicSmoothRel(owningPathSegList, points.x, points.y, points.x2, points.y2);
	                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS:
	                            var points = { x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
	                            return new window.SVGPathSegCurvetoCubicSmoothAbs(owningPathSegList, points.x, points.y, points.x2, points.y2);
	                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL:
	                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
	                            return new window.SVGPathSegCurvetoQuadraticRel(owningPathSegList, points.x, points.y, points.x1, points.y1);
	                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS:
	                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
	                            return new window.SVGPathSegCurvetoQuadraticAbs(owningPathSegList, points.x, points.y, points.x1, points.y1);
	                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL:
	                            return new window.SVGPathSegCurvetoQuadraticSmoothRel(owningPathSegList, this._parseNumber(), this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS:
	                            return new window.SVGPathSegCurvetoQuadraticSmoothAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
	                        case window.SVGPathSeg.PATHSEG_ARC_REL:
	                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), arcAngle: this._parseNumber(), arcLarge: this._parseArcFlag(), arcSweep: this._parseArcFlag(), x: this._parseNumber(), y: this._parseNumber() };
	                            return new window.SVGPathSegArcRel(owningPathSegList, points.x, points.y, points.x1, points.y1, points.arcAngle, points.arcLarge, points.arcSweep);
	                        case window.SVGPathSeg.PATHSEG_ARC_ABS:
	                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), arcAngle: this._parseNumber(), arcLarge: this._parseArcFlag(), arcSweep: this._parseArcFlag(), x: this._parseNumber(), y: this._parseNumber() };
	                            return new window.SVGPathSegArcAbs(owningPathSegList, points.x, points.y, points.x1, points.y1, points.arcAngle, points.arcLarge, points.arcSweep);
	                        default:
	                            throw "Unknown path seg type.";
	                    }
	                };
	
	                var builder = new Builder();
	                var source = new Source(string);
	
	                if (!source.initialCommandIsMoveTo()) return [];
	                while (source.hasMoreData()) {
	                    var pathSeg = source.parseSegment();
	                    if (!pathSeg) return [];
	                    builder.appendSegment(pathSeg);
	                }
	
	                return builder.pathSegList;
	            };
	        }
	    })();
	
	    // String.padEnd polyfill for IE11
	    //
	    // https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padEnd
	    if (!String.prototype.padEnd) {
	        String.prototype.padEnd = function padEnd(targetLength, padString) {
	            targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
	            padString = String(typeof padString !== 'undefined' ? padString : ' ');
	            if (this.length > targetLength) {
	                return String(this);
	            } else {
	                targetLength = targetLength - this.length;
	                if (targetLength > padString.length) {
	                    padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
	                }
	                return String(this) + padString.slice(0, targetLength);
	            }
	        };
	    }
	
	    /* jshint ignore:end */
	
	    c3_chart_fn.axis = function () {};
	    c3_chart_fn.axis.labels = function (labels) {
	        var $$ = this.internal;
	        if (arguments.length) {
	            Object.keys(labels).forEach(function (axisId) {
	                $$.axis.setLabelText(axisId, labels[axisId]);
	            });
	            $$.axis.updateLabels();
	        }
	        // TODO: return some values?
	    };
	    c3_chart_fn.axis.max = function (max) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (arguments.length) {
	            if ((typeof max === 'undefined' ? 'undefined' : _typeof(max)) === 'object') {
	                if (isValue(max.x)) {
	                    config.axis_x_max = max.x;
	                }
	                if (isValue(max.y)) {
	                    config.axis_y_max = max.y;
	                }
	                if (isValue(max.y2)) {
	                    config.axis_y2_max = max.y2;
	                }
	            } else {
	                config.axis_y_max = config.axis_y2_max = max;
	            }
	            $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true });
	        } else {
	            return {
	                x: config.axis_x_max,
	                y: config.axis_y_max,
	                y2: config.axis_y2_max
	            };
	        }
	    };
	    c3_chart_fn.axis.min = function (min) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (arguments.length) {
	            if ((typeof min === 'undefined' ? 'undefined' : _typeof(min)) === 'object') {
	                if (isValue(min.x)) {
	                    config.axis_x_min = min.x;
	                }
	                if (isValue(min.y)) {
	                    config.axis_y_min = min.y;
	                }
	                if (isValue(min.y2)) {
	                    config.axis_y2_min = min.y2;
	                }
	            } else {
	                config.axis_y_min = config.axis_y2_min = min;
	            }
	            $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true });
	        } else {
	            return {
	                x: config.axis_x_min,
	                y: config.axis_y_min,
	                y2: config.axis_y2_min
	            };
	        }
	    };
	    c3_chart_fn.axis.range = function (range) {
	        if (arguments.length) {
	            if (isDefined(range.max)) {
	                this.axis.max(range.max);
	            }
	            if (isDefined(range.min)) {
	                this.axis.min(range.min);
	            }
	        } else {
	            return {
	                max: this.axis.max(),
	                min: this.axis.min()
	            };
	        }
	    };
	
	    c3_chart_fn.category = function (i, category) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (arguments.length > 1) {
	            config.axis_x_categories[i] = category;
	            $$.redraw();
	        }
	        return config.axis_x_categories[i];
	    };
	    c3_chart_fn.categories = function (categories) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (!arguments.length) {
	            return config.axis_x_categories;
	        }
	        config.axis_x_categories = categories;
	        $$.redraw();
	        return config.axis_x_categories;
	    };
	
	    c3_chart_fn.resize = function (size) {
	        var $$ = this.internal,
	            config = $$.config;
	        config.size_width = size ? size.width : null;
	        config.size_height = size ? size.height : null;
	        this.flush();
	    };
	
	    c3_chart_fn.flush = function () {
	        var $$ = this.internal;
	        $$.updateAndRedraw({ withLegend: true, withTransition: false, withTransitionForTransform: false });
	    };
	
	    c3_chart_fn.destroy = function () {
	        var $$ = this.internal;
	
	        window.clearInterval($$.intervalForObserveInserted);
	
	        if ($$.resizeTimeout !== undefined) {
	            window.clearTimeout($$.resizeTimeout);
	        }
	
	        if (window.detachEvent) {
	            window.detachEvent('onresize', $$.resizeIfElementDisplayed);
	        } else if (window.removeEventListener) {
	            window.removeEventListener('resize', $$.resizeIfElementDisplayed);
	        } else {
	            var wrapper = window.onresize;
	            // check if no one else removed our wrapper and remove our resizeFunction from it
	            if (wrapper && wrapper.add && wrapper.remove) {
	                wrapper.remove($$.resizeFunction);
	            }
	        }
	
	        // remove the inner resize functions
	        $$.resizeFunction.remove();
	
	        $$.selectChart.classed('c3', false).html("");
	
	        // MEMO: this is needed because the reference of some elements will not be released, then memory leak will happen.
	        Object.keys($$).forEach(function (key) {
	            $$[key] = null;
	        });
	
	        return null;
	    };
	
	    // TODO: fix
	    c3_chart_fn.color = function (id) {
	        var $$ = this.internal;
	        return $$.color(id); // more patterns
	    };
	
	    c3_chart_fn.data = function (targetIds) {
	        var targets = this.internal.data.targets;
	        return typeof targetIds === 'undefined' ? targets : targets.filter(function (t) {
	            return [].concat(targetIds).indexOf(t.id) >= 0;
	        });
	    };
	    c3_chart_fn.data.shown = function (targetIds) {
	        return this.internal.filterTargetsToShow(this.data(targetIds));
	    };
	    c3_chart_fn.data.values = function (targetId) {
	        var targets,
	            values = null;
	        if (targetId) {
	            targets = this.data(targetId);
	            values = targets[0] ? targets[0].values.map(function (d) {
	                return d.value;
	            }) : null;
	        }
	        return values;
	    };
	    c3_chart_fn.data.names = function (names) {
	        this.internal.clearLegendItemTextBoxCache();
	        return this.internal.updateDataAttributes('names', names);
	    };
	    c3_chart_fn.data.colors = function (colors) {
	        return this.internal.updateDataAttributes('colors', colors);
	    };
	    c3_chart_fn.data.axes = function (axes) {
	        return this.internal.updateDataAttributes('axes', axes);
	    };
	
	    c3_chart_fn.flow = function (args) {
	        var $$ = this.internal,
	            targets,
	            data,
	            notfoundIds = [],
	            orgDataCount = $$.getMaxDataCount(),
	            dataCount,
	            domain,
	            baseTarget,
	            baseValue,
	            length = 0,
	            tail = 0,
	            diff,
	            to;
	
	        if (args.json) {
	            data = $$.convertJsonToData(args.json, args.keys);
	        } else if (args.rows) {
	            data = $$.convertRowsToData(args.rows);
	        } else if (args.columns) {
	            data = $$.convertColumnsToData(args.columns);
	        } else {
	            return;
	        }
	        targets = $$.convertDataToTargets(data, true);
	
	        // Update/Add data
	        $$.data.targets.forEach(function (t) {
	            var found = false,
	                i,
	                j;
	            for (i = 0; i < targets.length; i++) {
	                if (t.id === targets[i].id) {
	                    found = true;
	
	                    if (t.values[t.values.length - 1]) {
	                        tail = t.values[t.values.length - 1].index + 1;
	                    }
	                    length = targets[i].values.length;
	
	                    for (j = 0; j < length; j++) {
	                        targets[i].values[j].index = tail + j;
	                        if (!$$.isTimeSeries()) {
	                            targets[i].values[j].x = tail + j;
	                        }
	                    }
	                    t.values = t.values.concat(targets[i].values);
	
	                    targets.splice(i, 1);
	                    break;
	                }
	            }
	            if (!found) {
	                notfoundIds.push(t.id);
	            }
	        });
	
	        // Append null for not found targets
	        $$.data.targets.forEach(function (t) {
	            var i, j;
	            for (i = 0; i < notfoundIds.length; i++) {
	                if (t.id === notfoundIds[i]) {
	                    tail = t.values[t.values.length - 1].index + 1;
	                    for (j = 0; j < length; j++) {
	                        t.values.push({
	                            id: t.id,
	                            index: tail + j,
	                            x: $$.isTimeSeries() ? $$.getOtherTargetX(tail + j) : tail + j,
	                            value: null
	                        });
	                    }
	                }
	            }
	        });
	
	        // Generate null values for new target
	        if ($$.data.targets.length) {
	            targets.forEach(function (t) {
	                var i,
	                    missing = [];
	                for (i = $$.data.targets[0].values[0].index; i < tail; i++) {
	                    missing.push({
	                        id: t.id,
	                        index: i,
	                        x: $$.isTimeSeries() ? $$.getOtherTargetX(i) : i,
	                        value: null
	                    });
	                }
	                t.values.forEach(function (v) {
	                    v.index += tail;
	                    if (!$$.isTimeSeries()) {
	                        v.x += tail;
	                    }
	                });
	                t.values = missing.concat(t.values);
	            });
	        }
	        $$.data.targets = $$.data.targets.concat(targets); // add remained
	
	        // check data count because behavior needs to change when it's only one
	        dataCount = $$.getMaxDataCount();
	        baseTarget = $$.data.targets[0];
	        baseValue = baseTarget.values[0];
	
	        // Update length to flow if needed
	        if (isDefined(args.to)) {
	            length = 0;
	            to = $$.isTimeSeries() ? $$.parseDate(args.to) : args.to;
	            baseTarget.values.forEach(function (v) {
	                if (v.x < to) {
	                    length++;
	                }
	            });
	        } else if (isDefined(args.length)) {
	            length = args.length;
	        }
	
	        // If only one data, update the domain to flow from left edge of the chart
	        if (!orgDataCount) {
	            if ($$.isTimeSeries()) {
	                if (baseTarget.values.length > 1) {
	                    diff = baseTarget.values[baseTarget.values.length - 1].x - baseValue.x;
	                } else {
	                    diff = baseValue.x - $$.getXDomain($$.data.targets)[0];
	                }
	            } else {
	                diff = 1;
	            }
	            domain = [baseValue.x - diff, baseValue.x];
	            $$.updateXDomain(null, true, true, false, domain);
	        } else if (orgDataCount === 1) {
	            if ($$.isTimeSeries()) {
	                diff = (baseTarget.values[baseTarget.values.length - 1].x - baseValue.x) / 2;
	                domain = [new Date(+baseValue.x - diff), new Date(+baseValue.x + diff)];
	                $$.updateXDomain(null, true, true, false, domain);
	            }
	        }
	
	        // Set targets
	        $$.updateTargets($$.data.targets);
	
	        // Redraw with new targets
	        $$.redraw({
	            flow: {
	                index: baseValue.index,
	                length: length,
	                duration: isValue(args.duration) ? args.duration : $$.config.transition_duration,
	                done: args.done,
	                orgDataCount: orgDataCount
	            },
	            withLegend: true,
	            withTransition: orgDataCount > 1,
	            withTrimXDomain: false,
	            withUpdateXAxis: true
	        });
	    };
	
	    c3_chart_internal_fn.generateFlow = function (args) {
	        var $$ = this,
	            config = $$.config,
	            d3 = $$.d3;
	
	        return function () {
	            var targets = args.targets,
	                flow = args.flow,
	                drawBar = args.drawBar,
	                drawLine = args.drawLine,
	                drawArea = args.drawArea,
	                cx = args.cx,
	                cy = args.cy,
	                xv = args.xv,
	                xForText = args.xForText,
	                yForText = args.yForText,
	                duration = args.duration;
	
	            var translateX,
	                scaleX = 1,
	                transform,
	                flowIndex = flow.index,
	                flowLength = flow.length,
	                flowStart = $$.getValueOnIndex($$.data.targets[0].values, flowIndex),
	                flowEnd = $$.getValueOnIndex($$.data.targets[0].values, flowIndex + flowLength),
	                orgDomain = $$.x.domain(),
	                domain,
	                durationForFlow = flow.duration || duration,
	                done = flow.done || function () {},
	                wait = $$.generateWait();
	
	            var xgrid = $$.xgrid || d3.selectAll([]),
	                xgridLines = $$.xgridLines || d3.selectAll([]),
	                mainRegion = $$.mainRegion || d3.selectAll([]),
	                mainText = $$.mainText || d3.selectAll([]),
	                mainBar = $$.mainBar || d3.selectAll([]),
	                mainLine = $$.mainLine || d3.selectAll([]),
	                mainArea = $$.mainArea || d3.selectAll([]),
	                mainCircle = $$.mainCircle || d3.selectAll([]);
	
	            // set flag
	            $$.flowing = true;
	
	            // remove head data after rendered
	            $$.data.targets.forEach(function (d) {
	                d.values.splice(0, flowLength);
	            });
	
	            // update x domain to generate axis elements for flow
	            domain = $$.updateXDomain(targets, true, true);
	            // update elements related to x scale
	            if ($$.updateXGrid) {
	                $$.updateXGrid(true);
	            }
	
	            // generate transform to flow
	            if (!flow.orgDataCount) {
	                // if empty
	                if ($$.data.targets[0].values.length !== 1) {
	                    translateX = $$.x(orgDomain[0]) - $$.x(domain[0]);
	                } else {
	                    if ($$.isTimeSeries()) {
	                        flowStart = $$.getValueOnIndex($$.data.targets[0].values, 0);
	                        flowEnd = $$.getValueOnIndex($$.data.targets[0].values, $$.data.targets[0].values.length - 1);
	                        translateX = $$.x(flowStart.x) - $$.x(flowEnd.x);
	                    } else {
	                        translateX = diffDomain(domain) / 2;
	                    }
	                }
	            } else if (flow.orgDataCount === 1 || (flowStart && flowStart.x) === (flowEnd && flowEnd.x)) {
	                translateX = $$.x(orgDomain[0]) - $$.x(domain[0]);
	            } else {
	                if ($$.isTimeSeries()) {
	                    translateX = $$.x(orgDomain[0]) - $$.x(domain[0]);
	                } else {
	                    translateX = $$.x(flowStart.x) - $$.x(flowEnd.x);
	                }
	            }
	            scaleX = diffDomain(orgDomain) / diffDomain(domain);
	            transform = 'translate(' + translateX + ',0) scale(' + scaleX + ',1)';
	
	            $$.hideXGridFocus();
	
	            d3.transition().ease('linear').duration(durationForFlow).each(function () {
	                wait.add($$.axes.x.transition().call($$.xAxis));
	                wait.add(mainBar.transition().attr('transform', transform));
	                wait.add(mainLine.transition().attr('transform', transform));
	                wait.add(mainArea.transition().attr('transform', transform));
	                wait.add(mainCircle.transition().attr('transform', transform));
	                wait.add(mainText.transition().attr('transform', transform));
	                wait.add(mainRegion.filter($$.isRegionOnX).transition().attr('transform', transform));
	                wait.add(xgrid.transition().attr('transform', transform));
	                wait.add(xgridLines.transition().attr('transform', transform));
	            }).call(wait, function () {
	                var i,
	                    shapes = [],
	                    texts = [],
	                    eventRects = [];
	
	                // remove flowed elements
	                if (flowLength) {
	                    for (i = 0; i < flowLength; i++) {
	                        shapes.push('.' + CLASS.shape + '-' + (flowIndex + i));
	                        texts.push('.' + CLASS.text + '-' + (flowIndex + i));
	                        eventRects.push('.' + CLASS.eventRect + '-' + (flowIndex + i));
	                    }
	                    $$.svg.selectAll('.' + CLASS.shapes).selectAll(shapes).remove();
	                    $$.svg.selectAll('.' + CLASS.texts).selectAll(texts).remove();
	                    $$.svg.selectAll('.' + CLASS.eventRects).selectAll(eventRects).remove();
	                    $$.svg.select('.' + CLASS.xgrid).remove();
	                }
	
	                // draw again for removing flowed elements and reverting attr
	                xgrid.attr('transform', null).attr($$.xgridAttr);
	                xgridLines.attr('transform', null);
	                xgridLines.select('line').attr("x1", config.axis_rotated ? 0 : xv).attr("x2", config.axis_rotated ? $$.width : xv);
	                xgridLines.select('text').attr("x", config.axis_rotated ? $$.width : 0).attr("y", xv);
	                mainBar.attr('transform', null).attr("d", drawBar);
	                mainLine.attr('transform', null).attr("d", drawLine);
	                mainArea.attr('transform', null).attr("d", drawArea);
	                mainCircle.attr('transform', null).attr("cx", cx).attr("cy", cy);
	                mainText.attr('transform', null).attr('x', xForText).attr('y', yForText).style('fill-opacity', $$.opacityForText.bind($$));
	                mainRegion.attr('transform', null);
	                mainRegion.select('rect').filter($$.isRegionOnX).attr("x", $$.regionX.bind($$)).attr("width", $$.regionWidth.bind($$));
	
	                if (config.interaction_enabled) {
	                    $$.redrawEventRect();
	                }
	
	                // callback for end of flow
	                done();
	
	                $$.flowing = false;
	            });
	        };
	    };
	
	    c3_chart_fn.focus = function (targetIds) {
	        var $$ = this.internal,
	            candidates;
	
	        targetIds = $$.mapToTargetIds(targetIds);
	        candidates = $$.svg.selectAll($$.selectorTargets(targetIds.filter($$.isTargetToShow, $$))), this.revert();
	        this.defocus();
	        candidates.classed(CLASS.focused, true).classed(CLASS.defocused, false);
	        if ($$.hasArcType()) {
	            $$.expandArc(targetIds);
	        }
	        $$.toggleFocusLegend(targetIds, true);
	
	        $$.focusedTargetIds = targetIds;
	        $$.defocusedTargetIds = $$.defocusedTargetIds.filter(function (id) {
	            return targetIds.indexOf(id) < 0;
	        });
	    };
	
	    c3_chart_fn.defocus = function (targetIds) {
	        var $$ = this.internal,
	            candidates;
	
	        targetIds = $$.mapToTargetIds(targetIds);
	        candidates = $$.svg.selectAll($$.selectorTargets(targetIds.filter($$.isTargetToShow, $$))), candidates.classed(CLASS.focused, false).classed(CLASS.defocused, true);
	        if ($$.hasArcType()) {
	            $$.unexpandArc(targetIds);
	        }
	        $$.toggleFocusLegend(targetIds, false);
	
	        $$.focusedTargetIds = $$.focusedTargetIds.filter(function (id) {
	            return targetIds.indexOf(id) < 0;
	        });
	        $$.defocusedTargetIds = targetIds;
	    };
	
	    c3_chart_fn.revert = function (targetIds) {
	        var $$ = this.internal,
	            candidates;
	
	        targetIds = $$.mapToTargetIds(targetIds);
	        candidates = $$.svg.selectAll($$.selectorTargets(targetIds)); // should be for all targets
	
	        candidates.classed(CLASS.focused, false).classed(CLASS.defocused, false);
	        if ($$.hasArcType()) {
	            $$.unexpandArc(targetIds);
	        }
	        if ($$.config.legend_show) {
	            $$.showLegend(targetIds.filter($$.isLegendToShow.bind($$)));
	            $$.legend.selectAll($$.selectorLegends(targetIds)).filter(function () {
	                return $$.d3.select(this).classed(CLASS.legendItemFocused);
	            }).classed(CLASS.legendItemFocused, false);
	        }
	
	        $$.focusedTargetIds = [];
	        $$.defocusedTargetIds = [];
	    };
	
	    c3_chart_fn.xgrids = function (grids) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (!grids) {
	            return config.grid_x_lines;
	        }
	        config.grid_x_lines = grids;
	        $$.redrawWithoutRescale();
	        return config.grid_x_lines;
	    };
	    c3_chart_fn.xgrids.add = function (grids) {
	        var $$ = this.internal;
	        return this.xgrids($$.config.grid_x_lines.concat(grids ? grids : []));
	    };
	    c3_chart_fn.xgrids.remove = function (params) {
	        // TODO: multiple
	        var $$ = this.internal;
	        $$.removeGridLines(params, true);
	    };
	
	    c3_chart_fn.ygrids = function (grids) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (!grids) {
	            return config.grid_y_lines;
	        }
	        config.grid_y_lines = grids;
	        $$.redrawWithoutRescale();
	        return config.grid_y_lines;
	    };
	    c3_chart_fn.ygrids.add = function (grids) {
	        var $$ = this.internal;
	        return this.ygrids($$.config.grid_y_lines.concat(grids ? grids : []));
	    };
	    c3_chart_fn.ygrids.remove = function (params) {
	        // TODO: multiple
	        var $$ = this.internal;
	        $$.removeGridLines(params, false);
	    };
	
	    c3_chart_fn.groups = function (groups) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (isUndefined(groups)) {
	            return config.data_groups;
	        }
	        config.data_groups = groups;
	        $$.redraw();
	        return config.data_groups;
	    };
	
	    c3_chart_fn.legend = function () {};
	    c3_chart_fn.legend.show = function (targetIds) {
	        var $$ = this.internal;
	        $$.showLegend($$.mapToTargetIds(targetIds));
	        $$.updateAndRedraw({ withLegend: true });
	    };
	    c3_chart_fn.legend.hide = function (targetIds) {
	        var $$ = this.internal;
	        $$.hideLegend($$.mapToTargetIds(targetIds));
	        $$.updateAndRedraw({ withLegend: true });
	    };
	
	    c3_chart_fn.load = function (args) {
	        var $$ = this.internal,
	            config = $$.config;
	        // update xs if specified
	        if (args.xs) {
	            $$.addXs(args.xs);
	        }
	        // update names if exists
	        if ('names' in args) {
	            c3_chart_fn.data.names.bind(this)(args.names);
	        }
	        // update classes if exists
	        if ('classes' in args) {
	            Object.keys(args.classes).forEach(function (id) {
	                config.data_classes[id] = args.classes[id];
	            });
	        }
	        // update categories if exists
	        if ('categories' in args && $$.isCategorized()) {
	            config.axis_x_categories = args.categories;
	        }
	        // update axes if exists
	        if ('axes' in args) {
	            Object.keys(args.axes).forEach(function (id) {
	                config.data_axes[id] = args.axes[id];
	            });
	        }
	        // update colors if exists
	        if ('colors' in args) {
	            Object.keys(args.colors).forEach(function (id) {
	                config.data_colors[id] = args.colors[id];
	            });
	        }
	        // use cache if exists
	        if ('cacheIds' in args && $$.hasCaches(args.cacheIds)) {
	            $$.load($$.getCaches(args.cacheIds), args.done);
	            return;
	        }
	        // unload if needed
	        if ('unload' in args) {
	            // TODO: do not unload if target will load (included in url/rows/columns)
	            $$.unload($$.mapToTargetIds(typeof args.unload === 'boolean' && args.unload ? null : args.unload), function () {
	                $$.loadFromArgs(args);
	            });
	        } else {
	            $$.loadFromArgs(args);
	        }
	    };
	
	    c3_chart_fn.unload = function (args) {
	        var $$ = this.internal;
	        args = args || {};
	        if (args instanceof Array) {
	            args = { ids: args };
	        } else if (typeof args === 'string') {
	            args = { ids: [args] };
	        }
	        $$.unload($$.mapToTargetIds(args.ids), function () {
	            $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true, withLegend: true });
	            if (args.done) {
	                args.done();
	            }
	        });
	    };
	
	    c3_chart_fn.regions = function (regions) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (!regions) {
	            return config.regions;
	        }
	        config.regions = regions;
	        $$.redrawWithoutRescale();
	        return config.regions;
	    };
	    c3_chart_fn.regions.add = function (regions) {
	        var $$ = this.internal,
	            config = $$.config;
	        if (!regions) {
	            return config.regions;
	        }
	        config.regions = config.regions.concat(regions);
	        $$.redrawWithoutRescale();
	        return config.regions;
	    };
	    c3_chart_fn.regions.remove = function (options) {
	        var $$ = this.internal,
	            config = $$.config,
	            duration,
	            classes,
	            regions;
	
	        options = options || {};
	        duration = $$.getOption(options, "duration", config.transition_duration);
	        classes = $$.getOption(options, "classes", [CLASS.region]);
	
	        regions = $$.main.select('.' + CLASS.regions).selectAll(classes.map(function (c) {
	            return '.' + c;
	        }));
	        (duration ? regions.transition().duration(duration) : regions).style('opacity', 0).remove();
	
	        config.regions = config.regions.filter(function (region) {
	            var found = false;
	            if (!region['class']) {
	                return true;
	            }
	            region['class'].split(' ').forEach(function (c) {
	                if (classes.indexOf(c) >= 0) {
	                    found = true;
	                }
	            });
	            return !found;
	        });
	
	        return config.regions;
	    };
	
	    c3_chart_fn.selected = function (targetId) {
	        var $$ = this.internal,
	            d3 = $$.d3;
	        return d3.merge($$.main.selectAll('.' + CLASS.shapes + $$.getTargetSelectorSuffix(targetId)).selectAll('.' + CLASS.shape).filter(function () {
	            return d3.select(this).classed(CLASS.SELECTED);
	        }).map(function (d) {
	            return d.map(function (d) {
	                var data = d.__data__;return data.data ? data.data : data;
	            });
	        }));
	    };
	    c3_chart_fn.select = function (ids, indices, resetOther) {
	        var $$ = this.internal,
	            d3 = $$.d3,
	            config = $$.config;
	        if (!config.data_selection_enabled) {
	            return;
	        }
	        $$.main.selectAll('.' + CLASS.shapes).selectAll('.' + CLASS.shape).each(function (d, i) {
	            var shape = d3.select(this),
	                id = d.data ? d.data.id : d.id,
	                toggle = $$.getToggle(this, d).bind($$),
	                isTargetId = config.data_selection_grouped || !ids || ids.indexOf(id) >= 0,
	                isTargetIndex = !indices || indices.indexOf(i) >= 0,
	                isSelected = shape.classed(CLASS.SELECTED);
	            // line/area selection not supported yet
	            if (shape.classed(CLASS.line) || shape.classed(CLASS.area)) {
	                return;
	            }
	            if (isTargetId && isTargetIndex) {
	                if (config.data_selection_isselectable(d) && !isSelected) {
	                    toggle(true, shape.classed(CLASS.SELECTED, true), d, i);
	                }
	            } else if (isDefined(resetOther) && resetOther) {
	                if (isSelected) {
	                    toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
	                }
	            }
	        });
	    };
	    c3_chart_fn.unselect = function (ids, indices) {
	        var $$ = this.internal,
	            d3 = $$.d3,
	            config = $$.config;
	        if (!config.data_selection_enabled) {
	            return;
	        }
	        $$.main.selectAll('.' + CLASS.shapes).selectAll('.' + CLASS.shape).each(function (d, i) {
	            var shape = d3.select(this),
	                id = d.data ? d.data.id : d.id,
	                toggle = $$.getToggle(this, d).bind($$),
	                isTargetId = config.data_selection_grouped || !ids || ids.indexOf(id) >= 0,
	                isTargetIndex = !indices || indices.indexOf(i) >= 0,
	                isSelected = shape.classed(CLASS.SELECTED);
	            // line/area selection not supported yet
	            if (shape.classed(CLASS.line) || shape.classed(CLASS.area)) {
	                return;
	            }
	            if (isTargetId && isTargetIndex) {
	                if (config.data_selection_isselectable(d)) {
	                    if (isSelected) {
	                        toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
	                    }
	                }
	            }
	        });
	    };
	
	    c3_chart_fn.show = function (targetIds, options) {
	        var $$ = this.internal,
	            targets;
	
	        targetIds = $$.mapToTargetIds(targetIds);
	        options = options || {};
	
	        $$.removeHiddenTargetIds(targetIds);
	        targets = $$.svg.selectAll($$.selectorTargets(targetIds));
	
	        targets.transition().style('opacity', 1, 'important').call($$.endall, function () {
	            targets.style('opacity', null).style('opacity', 1);
	        });
	
	        if (options.withLegend) {
	            $$.showLegend(targetIds);
	        }
	
	        $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true, withLegend: true });
	    };
	
	    c3_chart_fn.hide = function (targetIds, options) {
	        var $$ = this.internal,
	            targets;
	
	        targetIds = $$.mapToTargetIds(targetIds);
	        options = options || {};
	
	        $$.addHiddenTargetIds(targetIds);
	        targets = $$.svg.selectAll($$.selectorTargets(targetIds));
	
	        targets.transition().style('opacity', 0, 'important').call($$.endall, function () {
	            targets.style('opacity', null).style('opacity', 0);
	        });
	
	        if (options.withLegend) {
	            $$.hideLegend(targetIds);
	        }
	
	        $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true, withLegend: true });
	    };
	
	    c3_chart_fn.toggle = function (targetIds, options) {
	        var that = this,
	            $$ = this.internal;
	        $$.mapToTargetIds(targetIds).forEach(function (targetId) {
	            $$.isTargetToShow(targetId) ? that.hide(targetId, options) : that.show(targetId, options);
	        });
	    };
	
	    c3_chart_fn.tooltip = function () {};
	    c3_chart_fn.tooltip.show = function (args) {
	        var $$ = this.internal,
	            index,
	            mouse;
	
	        // determine mouse position on the chart
	        if (args.mouse) {
	            mouse = args.mouse;
	        }
	
	        // determine focus data
	        if (args.data) {
	            if ($$.isMultipleX()) {
	                // if multiple xs, target point will be determined by mouse
	                mouse = [$$.x(args.data.x), $$.getYScale(args.data.id)(args.data.value)];
	                index = null;
	            } else {
	                // TODO: when tooltip_grouped = false
	                index = isValue(args.data.index) ? args.data.index : $$.getIndexByX(args.data.x);
	            }
	        } else if (typeof args.x !== 'undefined') {
	            index = $$.getIndexByX(args.x);
	        } else if (typeof args.index !== 'undefined') {
	            index = args.index;
	        }
	
	        // emulate mouse events to show
	        $$.dispatchEvent('mouseover', index, mouse);
	        $$.dispatchEvent('mousemove', index, mouse);
	
	        $$.config.tooltip_onshow.call($$, args.data);
	    };
	    c3_chart_fn.tooltip.hide = function () {
	        // TODO: get target data by checking the state of focus
	        this.internal.dispatchEvent('mouseout', 0);
	
	        this.internal.config.tooltip_onhide.call(this);
	    };
	
	    c3_chart_fn.transform = function (type, targetIds) {
	        var $$ = this.internal,
	            options = ['pie', 'donut'].indexOf(type) >= 0 ? { withTransform: true } : null;
	        $$.transformTo(targetIds, type, options);
	    };
	
	    c3_chart_internal_fn.transformTo = function (targetIds, type, optionsForRedraw) {
	        var $$ = this,
	            withTransitionForAxis = !$$.hasArcType(),
	            options = optionsForRedraw || { withTransitionForAxis: withTransitionForAxis };
	        options.withTransitionForTransform = false;
	        $$.transiting = false;
	        $$.setTargetType(targetIds, type);
	        $$.updateTargets($$.data.targets); // this is needed when transforming to arc
	        $$.updateAndRedraw(options);
	    };
	
	    c3_chart_fn.x = function (x) {
	        var $$ = this.internal;
	        if (arguments.length) {
	            $$.updateTargetX($$.data.targets, x);
	            $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true });
	        }
	        return $$.data.xs;
	    };
	    c3_chart_fn.xs = function (xs) {
	        var $$ = this.internal;
	        if (arguments.length) {
	            $$.updateTargetXs($$.data.targets, xs);
	            $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true });
	        }
	        return $$.data.xs;
	    };
	
	    c3_chart_fn.zoom = function (domain) {
	        var $$ = this.internal;
	        if (domain) {
	            if ($$.isTimeSeries()) {
	                domain = domain.map(function (x) {
	                    return $$.parseDate(x);
	                });
	            }
	            $$.brush.extent(domain);
	            $$.redraw({ withUpdateXDomain: true, withY: $$.config.zoom_rescale });
	            $$.config.zoom_onzoom.call(this, $$.x.orgDomain());
	        }
	        return $$.brush.extent();
	    };
	    c3_chart_fn.zoom.enable = function (enabled) {
	        var $$ = this.internal;
	        $$.config.zoom_enabled = enabled;
	        $$.updateAndRedraw();
	    };
	    c3_chart_fn.unzoom = function () {
	        var $$ = this.internal;
	        $$.brush.clear().update();
	        $$.redraw({ withUpdateXDomain: true });
	    };
	
	    c3_chart_fn.zoom.max = function (max) {
	        var $$ = this.internal,
	            config = $$.config,
	            d3 = $$.d3;
	        if (max === 0 || max) {
	            config.zoom_x_max = d3.max([$$.orgXDomain[1], max]);
	        } else {
	            return config.zoom_x_max;
	        }
	    };
	
	    c3_chart_fn.zoom.min = function (min) {
	        var $$ = this.internal,
	            config = $$.config,
	            d3 = $$.d3;
	        if (min === 0 || min) {
	            config.zoom_x_min = d3.min([$$.orgXDomain[0], min]);
	        } else {
	            return config.zoom_x_min;
	        }
	    };
	
	    c3_chart_fn.zoom.range = function (range) {
	        if (arguments.length) {
	            if (isDefined(range.max)) {
	                this.domain.max(range.max);
	            }
	            if (isDefined(range.min)) {
	                this.domain.min(range.min);
	            }
	        } else {
	            return {
	                max: this.domain.max(),
	                min: this.domain.min()
	            };
	        }
	    };
	
	    c3_chart_internal_fn.initPie = function () {
	        var $$ = this,
	            d3 = $$.d3;
	        $$.pie = d3.layout.pie().value(function (d) {
	            return d.values.reduce(function (a, b) {
	                return a + b.value;
	            }, 0);
	        });
	        $$.pie.sort($$.getOrderFunction() || null);
	    };
	
	    c3_chart_internal_fn.updateRadius = function () {
	        var $$ = this,
	            config = $$.config,
	            w = config.gauge_width || config.donut_width,
	            gaugeArcWidth = $$.filterTargetsToShow($$.data.targets).length * $$.config.gauge_arcs_minWidth;
	        $$.radiusExpanded = Math.min($$.arcWidth, $$.arcHeight) / 2 * ($$.hasType('gauge') ? 0.85 : 1);
	        $$.radius = $$.radiusExpanded * 0.95;
	        $$.innerRadiusRatio = w ? ($$.radius - w) / $$.radius : 0.6;
	        $$.innerRadius = $$.hasType('donut') || $$.hasType('gauge') ? $$.radius * $$.innerRadiusRatio : 0;
	        $$.gaugeArcWidth = w ? w : gaugeArcWidth <= $$.radius - $$.innerRadius ? $$.radius - $$.innerRadius : gaugeArcWidth <= $$.radius ? gaugeArcWidth : $$.radius;
	    };
	
	    c3_chart_internal_fn.updateArc = function () {
	        var $$ = this;
	        $$.svgArc = $$.getSvgArc();
	        $$.svgArcExpanded = $$.getSvgArcExpanded();
	        $$.svgArcExpandedSub = $$.getSvgArcExpanded(0.98);
	    };
	
	    c3_chart_internal_fn.updateAngle = function (d) {
	        var $$ = this,
	            config = $$.config,
	            found = false,
	            index = 0,
	            gMin,
	            gMax,
	            gTic,
	            gValue;
	
	        if (!config) {
	            return null;
	        }
	
	        $$.pie($$.filterTargetsToShow($$.data.targets)).forEach(function (t) {
	            if (!found && t.data.id === d.data.id) {
	                found = true;
	                d = t;
	                d.index = index;
	            }
	            index++;
	        });
	        if (isNaN(d.startAngle)) {
	            d.startAngle = 0;
	        }
	        if (isNaN(d.endAngle)) {
	            d.endAngle = d.startAngle;
	        }
	        if ($$.isGaugeType(d.data)) {
	            gMin = config.gauge_min;
	            gMax = config.gauge_max;
	            gTic = Math.PI * (config.gauge_fullCircle ? 2 : 1) / (gMax - gMin);
	            gValue = d.value < gMin ? 0 : d.value < gMax ? d.value - gMin : gMax - gMin;
	            d.startAngle = config.gauge_startingAngle;
	            d.endAngle = d.startAngle + gTic * gValue;
	        }
	        return found ? d : null;
	    };
	
	    c3_chart_internal_fn.getSvgArc = function () {
	        var $$ = this,
	            hasGaugeType = $$.hasType('gauge'),
	            singleArcWidth = $$.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length,
	            arc = $$.d3.svg.arc().outerRadius(function (d) {
	            return hasGaugeType ? $$.radius - singleArcWidth * d.index : $$.radius;
	        }).innerRadius(function (d) {
	            return hasGaugeType ? $$.radius - singleArcWidth * (d.index + 1) : $$.innerRadius;
	        }),
	            newArc = function newArc(d, withoutUpdate) {
	            var updated;
	            if (withoutUpdate) {
	                return arc(d);
	            } // for interpolate
	            updated = $$.updateAngle(d);
	            return updated ? arc(updated) : "M 0 0";
	        };
	        // TODO: extends all function
	        newArc.centroid = arc.centroid;
	        return newArc;
	    };
	
	    c3_chart_internal_fn.getSvgArcExpanded = function (rate) {
	        rate = rate || 1;
	        var $$ = this,
	            hasGaugeType = $$.hasType('gauge'),
	            singleArcWidth = $$.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length,
	            expandWidth = Math.min($$.radiusExpanded * rate - $$.radius, singleArcWidth * 0.8 - (1 - rate) * 100),
	            arc = $$.d3.svg.arc().outerRadius(function (d) {
	            return hasGaugeType ? $$.radius - singleArcWidth * d.index + expandWidth : $$.radiusExpanded * rate;
	        }).innerRadius(function (d) {
	            return hasGaugeType ? $$.radius - singleArcWidth * (d.index + 1) : $$.innerRadius;
	        });
	        return function (d) {
	            var updated = $$.updateAngle(d);
	            return updated ? arc(updated) : "M 0 0";
	        };
	    };
	
	    c3_chart_internal_fn.getArc = function (d, withoutUpdate, force) {
	        return force || this.isArcType(d.data) ? this.svgArc(d, withoutUpdate) : "M 0 0";
	    };
	
	    c3_chart_internal_fn.transformForArcLabel = function (d) {
	        var $$ = this,
	            config = $$.config,
	            updated = $$.updateAngle(d),
	            c,
	            x,
	            y,
	            h,
	            ratio,
	            translate = "",
	            hasGauge = $$.hasType('gauge');
	        if (updated && !hasGauge) {
	            c = this.svgArc.centroid(updated);
	            x = isNaN(c[0]) ? 0 : c[0];
	            y = isNaN(c[1]) ? 0 : c[1];
	            h = Math.sqrt(x * x + y * y);
	            if ($$.hasType('donut') && config.donut_label_ratio) {
	                ratio = isFunction(config.donut_label_ratio) ? config.donut_label_ratio(d, $$.radius, h) : config.donut_label_ratio;
	            } else if ($$.hasType('pie') && config.pie_label_ratio) {
	                ratio = isFunction(config.pie_label_ratio) ? config.pie_label_ratio(d, $$.radius, h) : config.pie_label_ratio;
	            } else {
	                ratio = $$.radius && h ? (36 / $$.radius > 0.375 ? 1.175 - 36 / $$.radius : 0.8) * $$.radius / h : 0;
	            }
	            translate = "translate(" + x * ratio + ',' + y * ratio + ")";
	        } else if (updated && hasGauge && $$.filterTargetsToShow($$.data.targets).length > 1) {
	            var y1 = Math.sin(updated.endAngle - Math.PI / 2);
	            x = Math.cos(updated.endAngle - Math.PI / 2) * ($$.radiusExpanded + 25);
	            y = y1 * ($$.radiusExpanded + 15 - Math.abs(y1 * 10)) + 3;
	            translate = "translate(" + x + ',' + y + ")";
	        }
	        return translate;
	    };
	
	    c3_chart_internal_fn.getArcRatio = function (d) {
	        var $$ = this,
	            config = $$.config,
	            whole = Math.PI * ($$.hasType('gauge') && !config.gauge_fullCircle ? 1 : 2);
	        return d ? (d.endAngle - d.startAngle) / whole : null;
	    };
	
	    c3_chart_internal_fn.convertToArcData = function (d) {
	        return this.addName({
	            id: d.data.id,
	            value: d.value,
	            ratio: this.getArcRatio(d),
	            index: d.index
	        });
	    };
	
	    c3_chart_internal_fn.textForArcLabel = function (d) {
	        var $$ = this,
	            updated,
	            value,
	            ratio,
	            id,
	            format;
	        if (!$$.shouldShowArcLabel()) {
	            return "";
	        }
	        updated = $$.updateAngle(d);
	        value = updated ? updated.value : null;
	        ratio = $$.getArcRatio(updated);
	        id = d.data.id;
	        if (!$$.hasType('gauge') && !$$.meetsArcLabelThreshold(ratio)) {
	            return "";
	        }
	        format = $$.getArcLabelFormat();
	        return format ? format(value, ratio, id) : $$.defaultArcValueFormat(value, ratio);
	    };
	
	    c3_chart_internal_fn.textForGaugeMinMax = function (value, isMax) {
	        var $$ = this,
	            format = $$.getGaugeLabelExtents();
	
	        return format ? format(value, isMax) : value;
	    };
	
	    c3_chart_internal_fn.expandArc = function (targetIds) {
	        var $$ = this,
	            interval;
	
	        // MEMO: avoid to cancel transition
	        if ($$.transiting) {
	            interval = window.setInterval(function () {
	                if (!$$.transiting) {
	                    window.clearInterval(interval);
	                    if ($$.legend.selectAll('.c3-legend-item-focused').size() > 0) {
	                        $$.expandArc(targetIds);
	                    }
	                }
	            }, 10);
	            return;
	        }
	
	        targetIds = $$.mapToTargetIds(targetIds);
	
	        $$.svg.selectAll($$.selectorTargets(targetIds, '.' + CLASS.chartArc)).each(function (d) {
	            if (!$$.shouldExpand(d.data.id)) {
	                return;
	            }
	            $$.d3.select(this).selectAll('path').transition().duration($$.expandDuration(d.data.id)).attr("d", $$.svgArcExpanded).transition().duration($$.expandDuration(d.data.id) * 2).attr("d", $$.svgArcExpandedSub).each(function (d) {
	                if ($$.isDonutType(d.data)) ;
	            });
	        });
	    };
	
	    c3_chart_internal_fn.unexpandArc = function (targetIds) {
	        var $$ = this;
	
	        if ($$.transiting) {
	            return;
	        }
	
	        targetIds = $$.mapToTargetIds(targetIds);
	
	        $$.svg.selectAll($$.selectorTargets(targetIds, '.' + CLASS.chartArc)).selectAll('path').transition().duration(function (d) {
	            return $$.expandDuration(d.data.id);
	        }).attr("d", $$.svgArc);
	        $$.svg.selectAll('.' + CLASS.arc);
	    };
	
	    c3_chart_internal_fn.expandDuration = function (id) {
	        var $$ = this,
	            config = $$.config;
	
	        if ($$.isDonutType(id)) {
	            return config.donut_expand_duration;
	        } else if ($$.isGaugeType(id)) {
	            return config.gauge_expand_duration;
	        } else if ($$.isPieType(id)) {
	            return config.pie_expand_duration;
	        } else {
	            return 50;
	        }
	    };
	
	    c3_chart_internal_fn.shouldExpand = function (id) {
	        var $$ = this,
	            config = $$.config;
	        return $$.isDonutType(id) && config.donut_expand || $$.isGaugeType(id) && config.gauge_expand || $$.isPieType(id) && config.pie_expand;
	    };
	
	    c3_chart_internal_fn.shouldShowArcLabel = function () {
	        var $$ = this,
	            config = $$.config,
	            shouldShow = true;
	        if ($$.hasType('donut')) {
	            shouldShow = config.donut_label_show;
	        } else if ($$.hasType('pie')) {
	            shouldShow = config.pie_label_show;
	        }
	        // when gauge, always true
	        return shouldShow;
	    };
	
	    c3_chart_internal_fn.meetsArcLabelThreshold = function (ratio) {
	        var $$ = this,
	            config = $$.config,
	            threshold = $$.hasType('donut') ? config.donut_label_threshold : config.pie_label_threshold;
	        return ratio >= threshold;
	    };
	
	    c3_chart_internal_fn.getArcLabelFormat = function () {
	        var $$ = this,
	            config = $$.config,
	            format = config.pie_label_format;
	        if ($$.hasType('gauge')) {
	            format = config.gauge_label_format;
	        } else if ($$.hasType('donut')) {
	            format = config.donut_label_format;
	        }
	        return format;
	    };
	
	    c3_chart_internal_fn.getGaugeLabelExtents = function () {
	        var $$ = this,
	            config = $$.config;
	        return config.gauge_label_extents;
	    };
	
	    c3_chart_internal_fn.getArcTitle = function () {
	        var $$ = this;
	        return $$.hasType('donut') ? $$.config.donut_title : "";
	    };
	
	    c3_chart_internal_fn.updateTargetsForArc = function (targets) {
	        var $$ = this,
	            main = $$.main,
	            mainPieUpdate,
	            mainPieEnter,
	            classChartArc = $$.classChartArc.bind($$),
	            classArcs = $$.classArcs.bind($$),
	            classFocus = $$.classFocus.bind($$);
	        mainPieUpdate = main.select('.' + CLASS.chartArcs).selectAll('.' + CLASS.chartArc).data($$.pie(targets)).attr("class", function (d) {
	            return classChartArc(d) + classFocus(d.data);
	        });
	        mainPieEnter = mainPieUpdate.enter().append("g").attr("class", classChartArc);
	        mainPieEnter.append('g').attr('class', classArcs);
	        mainPieEnter.append("text").attr("dy", $$.hasType('gauge') ? "-.1em" : ".35em").style("opacity", 0).style("text-anchor", "middle").style("pointer-events", "none");
	        // MEMO: can not keep same color..., but not bad to update color in redraw
	        //mainPieUpdate.exit().remove();
	    };
	
	    c3_chart_internal_fn.initArc = function () {
	        var $$ = this;
	        $$.arcs = $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartArcs).attr("transform", $$.getTranslate('arc'));
	        $$.arcs.append('text').attr('class', CLASS.chartArcsTitle).style("text-anchor", "middle").text($$.getArcTitle());
	    };
	
	    c3_chart_internal_fn.redrawArc = function (duration, durationForExit, withTransform) {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config,
	            main = $$.main,
	            mainArc,
	            backgroundArc,
	            mainArcLabelLine,
	            hasGaugeType = $$.hasType('gauge');
	        mainArc = main.selectAll('.' + CLASS.arcs).selectAll('.' + CLASS.arc).data($$.arcData.bind($$));
	        mainArc.enter().append('path').attr("class", $$.classArc.bind($$)).style("fill", function (d) {
	            return $$.color(d.data);
	        }).style("cursor", function (d) {
	            return config.interaction_enabled && config.data_selection_isselectable(d) ? "pointer" : null;
	        }).each(function (d) {
	            if ($$.isGaugeType(d.data)) {
	                d.startAngle = d.endAngle = config.gauge_startingAngle;
	            }
	            this._current = d;
	        });
	        if (hasGaugeType) {
	            mainArcLabelLine = main.selectAll('.' + CLASS.arcs).selectAll('.' + CLASS.arcLabelLine).data($$.arcData.bind($$));
	            mainArcLabelLine.enter().append('rect').attr("class", function (d) {
	                return CLASS.arcLabelLine + ' ' + CLASS.target + ' ' + CLASS.target + '-' + d.data.id;
	            });
	            if ($$.filterTargetsToShow($$.data.targets).length === 1) {
	                mainArcLabelLine.style("display", "none");
	            } else {
	                mainArcLabelLine.style("fill", function (d) {
	                    return config.color_pattern.length > 0 ? $$.levelColor(d.data.values[0].value) : $$.color(d.data);
	                }).style("display", config.gauge_labelLine_show ? "" : "none").each(function (d) {
	                    var lineLength = 0,
	                        lineThickness = 2,
	                        x = 0,
	                        y = 0,
	                        transform = "";
	                    if ($$.hiddenTargetIds.indexOf(d.data.id) < 0) {
	                        var updated = $$.updateAngle(d),
	                            innerLineLength = $$.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length * (updated.index + 1),
	                            lineAngle = updated.endAngle - Math.PI / 2,
	                            arcInnerRadius = $$.radius - innerLineLength,
	                            linePositioningAngle = lineAngle - (arcInnerRadius === 0 ? 0 : 1 / arcInnerRadius);
	                        lineLength = $$.radiusExpanded - $$.radius + innerLineLength;
	                        x = Math.cos(linePositioningAngle) * arcInnerRadius;
	                        y = Math.sin(linePositioningAngle) * arcInnerRadius;
	                        transform = "rotate(" + lineAngle * 180 / Math.PI + ", " + x + ", " + y + ")";
	                    }
	                    d3.select(this).attr({ x: x, y: y, width: lineLength, height: lineThickness, transform: transform }).style("stroke-dasharray", "0, " + (lineLength + lineThickness) + ", 0");
	                });
	            }
	        }
	        mainArc.attr("transform", function (d) {
	            return !$$.isGaugeType(d.data) && withTransform ? "scale(0)" : "";
	        }).on('mouseover', config.interaction_enabled ? function (d) {
	            var updated, arcData;
	            if ($$.transiting) {
	                // skip while transiting
	                return;
	            }
	            updated = $$.updateAngle(d);
	            if (updated) {
	                arcData = $$.convertToArcData(updated);
	                // transitions
	                $$.expandArc(updated.data.id);
	                $$.api.focus(updated.data.id);
	                $$.toggleFocusLegend(updated.data.id, true);
	                $$.config.data_onmouseover(arcData, this);
	            }
	        } : null).on('mousemove', config.interaction_enabled ? function (d) {
	            var updated = $$.updateAngle(d),
	                arcData,
	                selectedData;
	            if (updated) {
	                arcData = $$.convertToArcData(updated), selectedData = [arcData];
	                $$.showTooltip(selectedData, this);
	            }
	        } : null).on('mouseout', config.interaction_enabled ? function (d) {
	            var updated, arcData;
	            if ($$.transiting) {
	                // skip while transiting
	                return;
	            }
	            updated = $$.updateAngle(d);
	            if (updated) {
	                arcData = $$.convertToArcData(updated);
	                // transitions
	                $$.unexpandArc(updated.data.id);
	                $$.api.revert();
	                $$.revertLegend();
	                $$.hideTooltip();
	                $$.config.data_onmouseout(arcData, this);
	            }
	        } : null).on('click', config.interaction_enabled ? function (d, i) {
	            var updated = $$.updateAngle(d),
	                arcData;
	            if (updated) {
	                arcData = $$.convertToArcData(updated);
	                if ($$.toggleShape) {
	                    $$.toggleShape(this, arcData, i);
	                }
	                $$.config.data_onclick.call($$.api, arcData, this);
	            }
	        } : null).each(function () {
	            $$.transiting = true;
	        }).transition().duration(duration).attrTween("d", function (d) {
	            var updated = $$.updateAngle(d),
	                interpolate;
	            if (!updated) {
	                return function () {
	                    return "M 0 0";
	                };
	            }
	            //                if (this._current === d) {
	            //                    this._current = {
	            //                        startAngle: Math.PI*2,
	            //                        endAngle: Math.PI*2,
	            //                    };
	            //                }
	            if (isNaN(this._current.startAngle)) {
	                this._current.startAngle = 0;
	            }
	            if (isNaN(this._current.endAngle)) {
	                this._current.endAngle = this._current.startAngle;
	            }
	            interpolate = d3.interpolate(this._current, updated);
	            this._current = interpolate(0);
	            return function (t) {
	                var interpolated = interpolate(t);
	                interpolated.data = d.data; // data.id will be updated by interporator
	                return $$.getArc(interpolated, true);
	            };
	        }).attr("transform", withTransform ? "scale(1)" : "").style("fill", function (d) {
	            return $$.levelColor ? $$.levelColor(d.data.values[0].value) : $$.color(d.data.id);
	        }) // Where gauge reading color would receive customization.
	        .call($$.endall, function () {
	            $$.transiting = false;
	        });
	        mainArc.exit().transition().duration(durationForExit).style('opacity', 0).remove();
	        main.selectAll('.' + CLASS.chartArc).select('text').style("opacity", 0).attr('class', function (d) {
	            return $$.isGaugeType(d.data) ? CLASS.gaugeValue : '';
	        }).text($$.textForArcLabel.bind($$)).attr("transform", $$.transformForArcLabel.bind($$)).style('font-size', function (d) {
	            return $$.isGaugeType(d.data) && $$.filterTargetsToShow($$.data.targets).length === 1 ? Math.round($$.radius / 5) + 'px' : '';
	        }).transition().duration(duration).style("opacity", function (d) {
	            return $$.isTargetToShow(d.data.id) && $$.isArcType(d.data) ? 1 : 0;
	        });
	        main.select('.' + CLASS.chartArcsTitle).style("opacity", $$.hasType('donut') || hasGaugeType ? 1 : 0);
	
	        if (hasGaugeType) {
	            var index = 0;
	            backgroundArc = $$.arcs.select('g.' + CLASS.chartArcsBackground).selectAll('path.' + CLASS.chartArcsBackground).data($$.data.targets);
	            backgroundArc.enter().append("path");
	            backgroundArc.attr("class", function (d, i) {
	                return CLASS.chartArcsBackground + ' ' + CLASS.chartArcsBackground + '-' + i;
	            }).attr("d", function (d1) {
	                if ($$.hiddenTargetIds.indexOf(d1.id) >= 0) {
	                    return "M 0 0";
	                }
	
	                var d = {
	                    data: [{ value: config.gauge_max }],
	                    startAngle: config.gauge_startingAngle,
	                    endAngle: -1 * config.gauge_startingAngle * (config.gauge_fullCircle ? Math.PI : 1),
	                    index: index++
	                };
	                return $$.getArc(d, true, true);
	            });
	            backgroundArc.exit().remove();
	
	            $$.arcs.select('.' + CLASS.chartArcsGaugeUnit).attr("dy", ".75em").text(config.gauge_label_show ? config.gauge_units : '');
	            $$.arcs.select('.' + CLASS.chartArcsGaugeMin).attr("dx", -1 * ($$.innerRadius + ($$.radius - $$.innerRadius) / (config.gauge_fullCircle ? 1 : 2)) + "px").attr("dy", "1.2em").text(config.gauge_label_show ? $$.textForGaugeMinMax(config.gauge_min, false) : '');
	            $$.arcs.select('.' + CLASS.chartArcsGaugeMax).attr("dx", $$.innerRadius + ($$.radius - $$.innerRadius) / (config.gauge_fullCircle ? 1 : 2) + "px").attr("dy", "1.2em").text(config.gauge_label_show ? $$.textForGaugeMinMax(config.gauge_max, true) : '');
	        }
	    };
	    c3_chart_internal_fn.initGauge = function () {
	        var arcs = this.arcs;
	        if (this.hasType('gauge')) {
	            arcs.append('g').attr("class", CLASS.chartArcsBackground);
	            arcs.append("text").attr("class", CLASS.chartArcsGaugeUnit).style("text-anchor", "middle").style("pointer-events", "none");
	            arcs.append("text").attr("class", CLASS.chartArcsGaugeMin).style("text-anchor", "middle").style("pointer-events", "none");
	            arcs.append("text").attr("class", CLASS.chartArcsGaugeMax).style("text-anchor", "middle").style("pointer-events", "none");
	        }
	    };
	    c3_chart_internal_fn.getGaugeLabelHeight = function () {
	        return this.config.gauge_label_show ? 20 : 0;
	    };
	
	    c3_chart_internal_fn.hasCaches = function (ids) {
	        for (var i = 0; i < ids.length; i++) {
	            if (!(ids[i] in this.cache)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    c3_chart_internal_fn.addCache = function (id, target) {
	        this.cache[id] = this.cloneTarget(target);
	    };
	    c3_chart_internal_fn.getCaches = function (ids) {
	        var targets = [],
	            i;
	        for (i = 0; i < ids.length; i++) {
	            if (ids[i] in this.cache) {
	                targets.push(this.cloneTarget(this.cache[ids[i]]));
	            }
	        }
	        return targets;
	    };
	
	    c3_chart_internal_fn.categoryName = function (i) {
	        var config = this.config;
	        return i < config.axis_x_categories.length ? config.axis_x_categories[i] : i;
	    };
	
	    c3_chart_internal_fn.generateClass = function (prefix, targetId) {
	        return " " + prefix + " " + prefix + this.getTargetSelectorSuffix(targetId);
	    };
	    c3_chart_internal_fn.classText = function (d) {
	        return this.generateClass(CLASS.text, d.index);
	    };
	    c3_chart_internal_fn.classTexts = function (d) {
	        return this.generateClass(CLASS.texts, d.id);
	    };
	    c3_chart_internal_fn.classShape = function (d) {
	        return this.generateClass(CLASS.shape, d.index);
	    };
	    c3_chart_internal_fn.classShapes = function (d) {
	        return this.generateClass(CLASS.shapes, d.id);
	    };
	    c3_chart_internal_fn.classLine = function (d) {
	        return this.classShape(d) + this.generateClass(CLASS.line, d.id);
	    };
	    c3_chart_internal_fn.classLines = function (d) {
	        return this.classShapes(d) + this.generateClass(CLASS.lines, d.id);
	    };
	    c3_chart_internal_fn.classCircle = function (d) {
	        return this.classShape(d) + this.generateClass(CLASS.circle, d.index);
	    };
	    c3_chart_internal_fn.classCircles = function (d) {
	        return this.classShapes(d) + this.generateClass(CLASS.circles, d.id);
	    };
	    c3_chart_internal_fn.classBar = function (d) {
	        return this.classShape(d) + this.generateClass(CLASS.bar, d.index);
	    };
	    c3_chart_internal_fn.classBars = function (d) {
	        return this.classShapes(d) + this.generateClass(CLASS.bars, d.id);
	    };
	    c3_chart_internal_fn.classArc = function (d) {
	        return this.classShape(d.data) + this.generateClass(CLASS.arc, d.data.id);
	    };
	    c3_chart_internal_fn.classArcs = function (d) {
	        return this.classShapes(d.data) + this.generateClass(CLASS.arcs, d.data.id);
	    };
	    c3_chart_internal_fn.classArea = function (d) {
	        return this.classShape(d) + this.generateClass(CLASS.area, d.id);
	    };
	    c3_chart_internal_fn.classAreas = function (d) {
	        return this.classShapes(d) + this.generateClass(CLASS.areas, d.id);
	    };
	    c3_chart_internal_fn.classRegion = function (d, i) {
	        return this.generateClass(CLASS.region, i) + ' ' + ('class' in d ? d['class'] : '');
	    };
	    c3_chart_internal_fn.classEvent = function (d) {
	        return this.generateClass(CLASS.eventRect, d.index);
	    };
	    c3_chart_internal_fn.classTarget = function (id) {
	        var $$ = this;
	        var additionalClassSuffix = $$.config.data_classes[id],
	            additionalClass = '';
	        if (additionalClassSuffix) {
	            additionalClass = ' ' + CLASS.target + '-' + additionalClassSuffix;
	        }
	        return $$.generateClass(CLASS.target, id) + additionalClass;
	    };
	    c3_chart_internal_fn.classFocus = function (d) {
	        return this.classFocused(d) + this.classDefocused(d);
	    };
	    c3_chart_internal_fn.classFocused = function (d) {
	        return ' ' + (this.focusedTargetIds.indexOf(d.id) >= 0 ? CLASS.focused : '');
	    };
	    c3_chart_internal_fn.classDefocused = function (d) {
	        return ' ' + (this.defocusedTargetIds.indexOf(d.id) >= 0 ? CLASS.defocused : '');
	    };
	    c3_chart_internal_fn.classChartText = function (d) {
	        return CLASS.chartText + this.classTarget(d.id);
	    };
	    c3_chart_internal_fn.classChartLine = function (d) {
	        return CLASS.chartLine + this.classTarget(d.id);
	    };
	    c3_chart_internal_fn.classChartBar = function (d) {
	        return CLASS.chartBar + this.classTarget(d.id);
	    };
	    c3_chart_internal_fn.classChartArc = function (d) {
	        return CLASS.chartArc + this.classTarget(d.data.id);
	    };
	    c3_chart_internal_fn.getTargetSelectorSuffix = function (targetId) {
	        return targetId || targetId === 0 ? ('-' + targetId).replace(/[\s?!@#$%^&*()_=+,.<>'":;\[\]\/|~`{}\\]/g, '-') : '';
	    };
	    c3_chart_internal_fn.selectorTarget = function (id, prefix) {
	        return (prefix || '') + '.' + CLASS.target + this.getTargetSelectorSuffix(id);
	    };
	    c3_chart_internal_fn.selectorTargets = function (ids, prefix) {
	        var $$ = this;
	        ids = ids || [];
	        return ids.length ? ids.map(function (id) {
	            return $$.selectorTarget(id, prefix);
	        }) : null;
	    };
	    c3_chart_internal_fn.selectorLegend = function (id) {
	        return '.' + CLASS.legendItem + this.getTargetSelectorSuffix(id);
	    };
	    c3_chart_internal_fn.selectorLegends = function (ids) {
	        var $$ = this;
	        return ids && ids.length ? ids.map(function (id) {
	            return $$.selectorLegend(id);
	        }) : null;
	    };
	
	    c3_chart_internal_fn.getClipPath = function (id) {
	        var isIE9 = window.navigator.appVersion.toLowerCase().indexOf("msie 9.") >= 0;
	        return "url(" + (isIE9 ? "" : document.URL.split('#')[0]) + "#" + id + ")";
	    };
	    c3_chart_internal_fn.appendClip = function (parent, id) {
	        return parent.append("clipPath").attr("id", id).append("rect");
	    };
	    c3_chart_internal_fn.getAxisClipX = function (forHorizontal) {
	        // axis line width + padding for left
	        var left = Math.max(30, this.margin.left);
	        return forHorizontal ? -(1 + left) : -(left - 1);
	    };
	    c3_chart_internal_fn.getAxisClipY = function (forHorizontal) {
	        return forHorizontal ? -20 : -this.margin.top;
	    };
	    c3_chart_internal_fn.getXAxisClipX = function () {
	        var $$ = this;
	        return $$.getAxisClipX(!$$.config.axis_rotated);
	    };
	    c3_chart_internal_fn.getXAxisClipY = function () {
	        var $$ = this;
	        return $$.getAxisClipY(!$$.config.axis_rotated);
	    };
	    c3_chart_internal_fn.getYAxisClipX = function () {
	        var $$ = this;
	        return $$.config.axis_y_inner ? -1 : $$.getAxisClipX($$.config.axis_rotated);
	    };
	    c3_chart_internal_fn.getYAxisClipY = function () {
	        var $$ = this;
	        return $$.getAxisClipY($$.config.axis_rotated);
	    };
	    c3_chart_internal_fn.getAxisClipWidth = function (forHorizontal) {
	        var $$ = this,
	            left = Math.max(30, $$.margin.left),
	            right = Math.max(30, $$.margin.right);
	        // width + axis line width + padding for left/right
	        return forHorizontal ? $$.width + 2 + left + right : $$.margin.left + 20;
	    };
	    c3_chart_internal_fn.getAxisClipHeight = function (forHorizontal) {
	        // less than 20 is not enough to show the axis label 'outer' without legend
	        return (forHorizontal ? this.margin.bottom : this.margin.top + this.height) + 20;
	    };
	    c3_chart_internal_fn.getXAxisClipWidth = function () {
	        var $$ = this;
	        return $$.getAxisClipWidth(!$$.config.axis_rotated);
	    };
	    c3_chart_internal_fn.getXAxisClipHeight = function () {
	        var $$ = this;
	        return $$.getAxisClipHeight(!$$.config.axis_rotated);
	    };
	    c3_chart_internal_fn.getYAxisClipWidth = function () {
	        var $$ = this;
	        return $$.getAxisClipWidth($$.config.axis_rotated) + ($$.config.axis_y_inner ? 20 : 0);
	    };
	    c3_chart_internal_fn.getYAxisClipHeight = function () {
	        var $$ = this;
	        return $$.getAxisClipHeight($$.config.axis_rotated);
	    };
	
	    c3_chart_internal_fn.generateColor = function () {
	        var $$ = this,
	            config = $$.config,
	            d3 = $$.d3,
	            colors = config.data_colors,
	            pattern = notEmpty(config.color_pattern) ? config.color_pattern : d3.scale.category10().range(),
	            callback = config.data_color,
	            ids = [];
	
	        return function (d) {
	            var id = d.id || d.data && d.data.id || d,
	                color;
	
	            // if callback function is provided
	            if (colors[id] instanceof Function) {
	                color = colors[id](d);
	            }
	            // if specified, choose that color
	            else if (colors[id]) {
	                    color = colors[id];
	                }
	                // if not specified, choose from pattern
	                else {
	                        if (ids.indexOf(id) < 0) {
	                            ids.push(id);
	                        }
	                        color = pattern[ids.indexOf(id) % pattern.length];
	                        colors[id] = color;
	                    }
	            return callback instanceof Function ? callback(color, d) : color;
	        };
	    };
	    c3_chart_internal_fn.generateLevelColor = function () {
	        var $$ = this,
	            config = $$.config,
	            colors = config.color_pattern,
	            threshold = config.color_threshold,
	            asValue = threshold.unit === 'value',
	            values = threshold.values && threshold.values.length ? threshold.values : [],
	            max = threshold.max || 100;
	        return notEmpty(config.color_threshold) ? function (value) {
	            var i,
	                v,
	                color = colors[colors.length - 1];
	            for (i = 0; i < values.length; i++) {
	                v = asValue ? value : value * 100 / max;
	                if (v < values[i]) {
	                    color = colors[i];
	                    break;
	                }
	            }
	            return color;
	        } : null;
	    };
	
	    c3_chart_internal_fn.getDefaultConfig = function () {
	        var config = {
	            bindto: '#chart',
	            svg_classname: undefined,
	            size_width: undefined,
	            size_height: undefined,
	            padding_left: undefined,
	            padding_right: undefined,
	            padding_top: undefined,
	            padding_bottom: undefined,
	            resize_auto: true,
	            zoom_enabled: false,
	            zoom_extent: undefined,
	            zoom_privileged: false,
	            zoom_rescale: false,
	            zoom_onzoom: function zoom_onzoom() {},
	            zoom_onzoomstart: function zoom_onzoomstart() {},
	            zoom_onzoomend: function zoom_onzoomend() {},
	            zoom_x_min: undefined,
	            zoom_x_max: undefined,
	            interaction_brighten: true,
	            interaction_enabled: true,
	            onmouseover: function onmouseover() {},
	            onmouseout: function onmouseout() {},
	            onresize: function onresize() {},
	            onresized: function onresized() {},
	            oninit: function oninit() {},
	            onrendered: function onrendered() {},
	            transition_duration: 350,
	            data_x: undefined,
	            data_xs: {},
	            data_xFormat: '%Y-%m-%d',
	            data_xLocaltime: true,
	            data_xSort: true,
	            data_idConverter: function data_idConverter(id) {
	                return id;
	            },
	            data_names: {},
	            data_classes: {},
	            data_groups: [],
	            data_axes: {},
	            data_type: undefined,
	            data_types: {},
	            data_labels: {},
	            data_order: 'desc',
	            data_regions: {},
	            data_color: undefined,
	            data_colors: {},
	            data_hide: false,
	            data_filter: undefined,
	            data_selection_enabled: false,
	            data_selection_grouped: false,
	            data_selection_isselectable: function data_selection_isselectable() {
	                return true;
	            },
	            data_selection_multiple: true,
	            data_selection_draggable: false,
	            data_onclick: function data_onclick() {},
	            data_onmouseover: function data_onmouseover() {},
	            data_onmouseout: function data_onmouseout() {},
	            data_onselected: function data_onselected() {},
	            data_onunselected: function data_onunselected() {},
	            data_url: undefined,
	            data_headers: undefined,
	            data_json: undefined,
	            data_rows: undefined,
	            data_columns: undefined,
	            data_mimeType: undefined,
	            data_keys: undefined,
	            // configuration for no plot-able data supplied.
	            data_empty_label_text: "",
	            // subchart
	            subchart_show: false,
	            subchart_size_height: 60,
	            subchart_axis_x_show: true,
	            subchart_onbrush: function subchart_onbrush() {},
	            // color
	            color_pattern: [],
	            color_threshold: {},
	            // legend
	            legend_show: true,
	            legend_hide: false,
	            legend_position: 'bottom',
	            legend_inset_anchor: 'top-left',
	            legend_inset_x: 10,
	            legend_inset_y: 0,
	            legend_inset_step: undefined,
	            legend_item_onclick: undefined,
	            legend_item_onmouseover: undefined,
	            legend_item_onmouseout: undefined,
	            legend_equally: false,
	            legend_padding: 0,
	            legend_item_tile_width: 10,
	            legend_item_tile_height: 10,
	            // axis
	            axis_rotated: false,
	            axis_x_show: true,
	            axis_x_type: 'indexed',
	            axis_x_localtime: true,
	            axis_x_categories: [],
	            axis_x_tick_centered: false,
	            axis_x_tick_format: undefined,
	            axis_x_tick_culling: {},
	            axis_x_tick_culling_max: 10,
	            axis_x_tick_count: undefined,
	            axis_x_tick_fit: true,
	            axis_x_tick_values: null,
	            axis_x_tick_rotate: 0,
	            axis_x_tick_outer: true,
	            axis_x_tick_multiline: true,
	            axis_x_tick_multilineMax: 0,
	            axis_x_tick_width: null,
	            axis_x_max: undefined,
	            axis_x_min: undefined,
	            axis_x_padding: {},
	            axis_x_height: undefined,
	            axis_x_extent: undefined,
	            axis_x_label: {},
	            axis_x_inner: undefined,
	            axis_y_show: true,
	            axis_y_type: undefined,
	            axis_y_max: undefined,
	            axis_y_min: undefined,
	            axis_y_inverted: false,
	            axis_y_center: undefined,
	            axis_y_inner: undefined,
	            axis_y_label: {},
	            axis_y_tick_format: undefined,
	            axis_y_tick_outer: true,
	            axis_y_tick_values: null,
	            axis_y_tick_rotate: 0,
	            axis_y_tick_count: undefined,
	            axis_y_tick_time_value: undefined,
	            axis_y_tick_time_interval: undefined,
	            axis_y_padding: {},
	            axis_y_default: undefined,
	            axis_y2_show: false,
	            axis_y2_max: undefined,
	            axis_y2_min: undefined,
	            axis_y2_inverted: false,
	            axis_y2_center: undefined,
	            axis_y2_inner: undefined,
	            axis_y2_label: {},
	            axis_y2_tick_format: undefined,
	            axis_y2_tick_outer: true,
	            axis_y2_tick_values: null,
	            axis_y2_tick_count: undefined,
	            axis_y2_padding: {},
	            axis_y2_default: undefined,
	            // grid
	            grid_x_show: false,
	            grid_x_type: 'tick',
	            grid_x_lines: [],
	            grid_y_show: false,
	            // not used
	            // grid_y_type: 'tick',
	            grid_y_lines: [],
	            grid_y_ticks: 10,
	            grid_focus_show: true,
	            grid_lines_front: true,
	            // point - point of each data
	            point_show: true,
	            point_r: 2.5,
	            point_sensitivity: 10,
	            point_focus_expand_enabled: true,
	            point_focus_expand_r: undefined,
	            point_select_r: undefined,
	            // line
	            line_connectNull: false,
	            line_step_type: 'step',
	            // bar
	            bar_width: undefined,
	            bar_width_ratio: 0.6,
	            bar_width_max: undefined,
	            bar_zerobased: true,
	            bar_space: 0,
	            // area
	            area_zerobased: true,
	            area_above: false,
	            // pie
	            pie_label_show: true,
	            pie_label_format: undefined,
	            pie_label_threshold: 0.05,
	            pie_label_ratio: undefined,
	            pie_expand: {},
	            pie_expand_duration: 50,
	            // gauge
	            gauge_fullCircle: false,
	            gauge_label_show: true,
	            gauge_labelLine_show: true,
	            gauge_label_format: undefined,
	            gauge_min: 0,
	            gauge_max: 100,
	            gauge_startingAngle: -1 * Math.PI / 2,
	            gauge_label_extents: undefined,
	            gauge_units: undefined,
	            gauge_width: undefined,
	            gauge_arcs_minWidth: 5,
	            gauge_expand: {},
	            gauge_expand_duration: 50,
	            // donut
	            donut_label_show: true,
	            donut_label_format: undefined,
	            donut_label_threshold: 0.05,
	            donut_label_ratio: undefined,
	            donut_width: undefined,
	            donut_title: "",
	            donut_expand: {},
	            donut_expand_duration: 50,
	            // spline
	            spline_interpolation_type: 'cardinal',
	            // region - region to change style
	            regions: [],
	            // tooltip - show when mouseover on each data
	            tooltip_show: true,
	            tooltip_grouped: true,
	            tooltip_order: undefined,
	            tooltip_format_title: undefined,
	            tooltip_format_name: undefined,
	            tooltip_format_value: undefined,
	            tooltip_position: undefined,
	            tooltip_contents: function tooltip_contents(d, defaultTitleFormat, defaultValueFormat, color) {
	                return this.getTooltipContent ? this.getTooltipContent(d, defaultTitleFormat, defaultValueFormat, color) : '';
	            },
	            tooltip_init_show: false,
	            tooltip_init_x: 0,
	            tooltip_init_position: { top: '0px', left: '50px' },
	            tooltip_onshow: function tooltip_onshow() {},
	            tooltip_onhide: function tooltip_onhide() {},
	            // title
	            title_text: undefined,
	            title_padding: {
	                top: 0,
	                right: 0,
	                bottom: 0,
	                left: 0
	            },
	            title_position: 'top-center'
	        };
	
	        Object.keys(this.additionalConfig).forEach(function (key) {
	            config[key] = this.additionalConfig[key];
	        }, this);
	
	        return config;
	    };
	    c3_chart_internal_fn.additionalConfig = {};
	
	    c3_chart_internal_fn.loadConfig = function (config) {
	        var this_config = this.config,
	            target,
	            keys,
	            read;
	        function find() {
	            var key = keys.shift();
	            //        console.log("key =>", key, ", target =>", target);
	            if (key && target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && key in target) {
	                target = target[key];
	                return find();
	            } else if (!key) {
	                return target;
	            } else {
	                return undefined;
	            }
	        }
	        Object.keys(this_config).forEach(function (key) {
	            target = config;
	            keys = key.split('_');
	            read = find();
	            //        console.log("CONFIG : ", key, read);
	            if (isDefined(read)) {
	                this_config[key] = read;
	            }
	        });
	    };
	
	    c3_chart_internal_fn.convertUrlToData = function (url, mimeType, headers, keys, done) {
	        var $$ = this,
	            type = mimeType ? mimeType : 'csv';
	        var req = $$.d3.xhr(url);
	        if (headers) {
	            Object.keys(headers).forEach(function (header) {
	                req.header(header, headers[header]);
	            });
	        }
	        req.get(function (error, data) {
	            var d;
	            var dataResponse = data.response || data.responseText; // Fixes IE9 XHR issue; see #1345
	            if (!data) {
	                throw new Error(error.responseURL + ' ' + error.status + ' (' + error.statusText + ')');
	            }
	            if (type === 'json') {
	                d = $$.convertJsonToData(JSON.parse(dataResponse), keys);
	            } else if (type === 'tsv') {
	                d = $$.convertTsvToData(dataResponse);
	            } else {
	                d = $$.convertCsvToData(dataResponse);
	            }
	            done.call($$, d);
	        });
	    };
	    c3_chart_internal_fn.convertXsvToData = function (xsv, parser) {
	        var rows = parser.parseRows(xsv),
	            d;
	        if (rows.length === 1) {
	            d = [{}];
	            rows[0].forEach(function (id) {
	                d[0][id] = null;
	            });
	        } else {
	            d = parser.parse(xsv);
	        }
	        return d;
	    };
	    c3_chart_internal_fn.convertCsvToData = function (csv) {
	        return this.convertXsvToData(csv, this.d3.csv);
	    };
	    c3_chart_internal_fn.convertTsvToData = function (tsv) {
	        return this.convertXsvToData(tsv, this.d3.tsv);
	    };
	    c3_chart_internal_fn.convertJsonToData = function (json, keys) {
	        var $$ = this,
	            new_rows = [],
	            targetKeys,
	            data;
	        if (keys) {
	            // when keys specified, json would be an array that includes objects
	            if (keys.x) {
	                targetKeys = keys.value.concat(keys.x);
	                $$.config.data_x = keys.x;
	            } else {
	                targetKeys = keys.value;
	            }
	            new_rows.push(targetKeys);
	            json.forEach(function (o) {
	                var new_row = [];
	                targetKeys.forEach(function (key) {
	                    // convert undefined to null because undefined data will be removed in convertDataToTargets()
	                    var v = $$.findValueInJson(o, key);
	                    if (isUndefined(v)) {
	                        v = null;
	                    }
	                    new_row.push(v);
	                });
	                new_rows.push(new_row);
	            });
	            data = $$.convertRowsToData(new_rows);
	        } else {
	            Object.keys(json).forEach(function (key) {
	                new_rows.push([key].concat(json[key]));
	            });
	            data = $$.convertColumnsToData(new_rows);
	        }
	        return data;
	    };
	    c3_chart_internal_fn.findValueInJson = function (object, path) {
	        path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties (replace [] with .)
	        path = path.replace(/^\./, ''); // strip a leading dot
	        var pathArray = path.split('.');
	        for (var i = 0; i < pathArray.length; ++i) {
	            var k = pathArray[i];
	            if (k in object) {
	                object = object[k];
	            } else {
	                return;
	            }
	        }
	        return object;
	    };
	
	    /**
	     * Converts the rows to normalized data.
	     * @param {any[][]} rows The row data
	     * @return {Object[]}
	     */
	    c3_chart_internal_fn.convertRowsToData = function (rows) {
	        var newRows = [];
	        var keys = rows[0];
	
	        for (var i = 1; i < rows.length; i++) {
	            var newRow = {};
	            for (var j = 0; j < rows[i].length; j++) {
	                if (isUndefined(rows[i][j])) {
	                    throw new Error("Source data is missing a component at (" + i + "," + j + ")!");
	                }
	                newRow[keys[j]] = rows[i][j];
	            }
	            newRows.push(newRow);
	        }
	        return newRows;
	    };
	
	    /**
	     * Converts the columns to normalized data.
	     * @param {any[][]} columns The column data
	     * @return {Object[]}
	     */
	    c3_chart_internal_fn.convertColumnsToData = function (columns) {
	        var newRows = [];
	
	        for (var i = 0; i < columns.length; i++) {
	            var key = columns[i][0];
	            for (var j = 1; j < columns[i].length; j++) {
	                if (isUndefined(newRows[j - 1])) {
	                    newRows[j - 1] = {};
	                }
	                if (isUndefined(columns[i][j])) {
	                    throw new Error("Source data is missing a component at (" + i + "," + j + ")!");
	                }
	                newRows[j - 1][key] = columns[i][j];
	            }
	        }
	
	        return newRows;
	    };
	
	    c3_chart_internal_fn.convertDataToTargets = function (data, appendXs) {
	        var $$ = this,
	            config = $$.config,
	            ids = $$.d3.keys(data[0]).filter($$.isNotX, $$),
	            xs = $$.d3.keys(data[0]).filter($$.isX, $$),
	            targets;
	
	        // save x for update data by load when custom x and c3.x API
	        ids.forEach(function (id) {
	            var xKey = $$.getXKey(id);
	
	            if ($$.isCustomX() || $$.isTimeSeries()) {
	                // if included in input data
	                if (xs.indexOf(xKey) >= 0) {
	                    $$.data.xs[id] = (appendXs && $$.data.xs[id] ? $$.data.xs[id] : []).concat(data.map(function (d) {
	                        return d[xKey];
	                    }).filter(isValue).map(function (rawX, i) {
	                        return $$.generateTargetX(rawX, id, i);
	                    }));
	                }
	                // if not included in input data, find from preloaded data of other id's x
	                else if (config.data_x) {
	                        $$.data.xs[id] = $$.getOtherTargetXs();
	                    }
	                    // if not included in input data, find from preloaded data
	                    else if (notEmpty(config.data_xs)) {
	                            $$.data.xs[id] = $$.getXValuesOfXKey(xKey, $$.data.targets);
	                        }
	                // MEMO: if no x included, use same x of current will be used
	            } else {
	                $$.data.xs[id] = data.map(function (d, i) {
	                    return i;
	                });
	            }
	        });
	
	        // check x is defined
	        ids.forEach(function (id) {
	            if (!$$.data.xs[id]) {
	                throw new Error('x is not defined for id = "' + id + '".');
	            }
	        });
	
	        // convert to target
	        targets = ids.map(function (id, index) {
	            var convertedId = config.data_idConverter(id);
	            return {
	                id: convertedId,
	                id_org: id,
	                values: data.map(function (d, i) {
	                    var xKey = $$.getXKey(id),
	                        rawX = d[xKey],
	                        value = d[id] !== null && !isNaN(d[id]) ? +d[id] : null,
	                        x;
	                    // use x as categories if custom x and categorized
	                    if ($$.isCustomX() && $$.isCategorized() && !isUndefined(rawX)) {
	                        if (index === 0 && i === 0) {
	                            config.axis_x_categories = [];
	                        }
	                        x = config.axis_x_categories.indexOf(rawX);
	                        if (x === -1) {
	                            x = config.axis_x_categories.length;
	                            config.axis_x_categories.push(rawX);
	                        }
	                    } else {
	                        x = $$.generateTargetX(rawX, id, i);
	                    }
	                    // mark as x = undefined if value is undefined and filter to remove after mapped
	                    if (isUndefined(d[id]) || $$.data.xs[id].length <= i) {
	                        x = undefined;
	                    }
	                    return { x: x, value: value, id: convertedId };
	                }).filter(function (v) {
	                    return isDefined(v.x);
	                })
	            };
	        });
	
	        // finish targets
	        targets.forEach(function (t) {
	            var i;
	            // sort values by its x
	            if (config.data_xSort) {
	                t.values = t.values.sort(function (v1, v2) {
	                    var x1 = v1.x || v1.x === 0 ? v1.x : Infinity,
	                        x2 = v2.x || v2.x === 0 ? v2.x : Infinity;
	                    return x1 - x2;
	                });
	            }
	            // indexing each value
	            i = 0;
	            t.values.forEach(function (v) {
	                v.index = i++;
	            });
	            // this needs to be sorted because its index and value.index is identical
	            $$.data.xs[t.id].sort(function (v1, v2) {
	                return v1 - v2;
	            });
	        });
	
	        // cache information about values
	        $$.hasNegativeValue = $$.hasNegativeValueInTargets(targets);
	        $$.hasPositiveValue = $$.hasPositiveValueInTargets(targets);
	
	        // set target types
	        if (config.data_type) {
	            $$.setTargetType($$.mapToIds(targets).filter(function (id) {
	                return !(id in config.data_types);
	            }), config.data_type);
	        }
	
	        // cache as original id keyed
	        targets.forEach(function (d) {
	            $$.addCache(d.id_org, d);
	        });
	
	        return targets;
	    };
	
	    c3_chart_internal_fn.isX = function (key) {
	        var $$ = this,
	            config = $$.config;
	        return config.data_x && key === config.data_x || notEmpty(config.data_xs) && hasValue(config.data_xs, key);
	    };
	    c3_chart_internal_fn.isNotX = function (key) {
	        return !this.isX(key);
	    };
	    c3_chart_internal_fn.getXKey = function (id) {
	        var $$ = this,
	            config = $$.config;
	        return config.data_x ? config.data_x : notEmpty(config.data_xs) ? config.data_xs[id] : null;
	    };
	    c3_chart_internal_fn.getXValuesOfXKey = function (key, targets) {
	        var $$ = this,
	            xValues,
	            ids = targets && notEmpty(targets) ? $$.mapToIds(targets) : [];
	        ids.forEach(function (id) {
	            if ($$.getXKey(id) === key) {
	                xValues = $$.data.xs[id];
	            }
	        });
	        return xValues;
	    };
	    c3_chart_internal_fn.getIndexByX = function (x) {
	        var $$ = this,
	            data = $$.filterByX($$.data.targets, x);
	        return data.length ? data[0].index : null;
	    };
	    c3_chart_internal_fn.getXValue = function (id, i) {
	        var $$ = this;
	        return id in $$.data.xs && $$.data.xs[id] && isValue($$.data.xs[id][i]) ? $$.data.xs[id][i] : i;
	    };
	    c3_chart_internal_fn.getOtherTargetXs = function () {
	        var $$ = this,
	            idsForX = Object.keys($$.data.xs);
	        return idsForX.length ? $$.data.xs[idsForX[0]] : null;
	    };
	    c3_chart_internal_fn.getOtherTargetX = function (index) {
	        var xs = this.getOtherTargetXs();
	        return xs && index < xs.length ? xs[index] : null;
	    };
	    c3_chart_internal_fn.addXs = function (xs) {
	        var $$ = this;
	        Object.keys(xs).forEach(function (id) {
	            $$.config.data_xs[id] = xs[id];
	        });
	    };
	    c3_chart_internal_fn.hasMultipleX = function (xs) {
	        return this.d3.set(Object.keys(xs).map(function (id) {
	            return xs[id];
	        })).size() > 1;
	    };
	    c3_chart_internal_fn.isMultipleX = function () {
	        return notEmpty(this.config.data_xs) || !this.config.data_xSort || this.hasType('scatter');
	    };
	    c3_chart_internal_fn.addName = function (data) {
	        var $$ = this,
	            name;
	        if (data) {
	            name = $$.config.data_names[data.id];
	            data.name = name !== undefined ? name : data.id;
	        }
	        return data;
	    };
	    c3_chart_internal_fn.getValueOnIndex = function (values, index) {
	        var valueOnIndex = values.filter(function (v) {
	            return v.index === index;
	        });
	        return valueOnIndex.length ? valueOnIndex[0] : null;
	    };
	    c3_chart_internal_fn.updateTargetX = function (targets, x) {
	        var $$ = this;
	        targets.forEach(function (t) {
	            t.values.forEach(function (v, i) {
	                v.x = $$.generateTargetX(x[i], t.id, i);
	            });
	            $$.data.xs[t.id] = x;
	        });
	    };
	    c3_chart_internal_fn.updateTargetXs = function (targets, xs) {
	        var $$ = this;
	        targets.forEach(function (t) {
	            if (xs[t.id]) {
	                $$.updateTargetX([t], xs[t.id]);
	            }
	        });
	    };
	    c3_chart_internal_fn.generateTargetX = function (rawX, id, index) {
	        var $$ = this,
	            x;
	        if ($$.isTimeSeries()) {
	            x = rawX ? $$.parseDate(rawX) : $$.parseDate($$.getXValue(id, index));
	        } else if ($$.isCustomX() && !$$.isCategorized()) {
	            x = isValue(rawX) ? +rawX : $$.getXValue(id, index);
	        } else {
	            x = index;
	        }
	        return x;
	    };
	    c3_chart_internal_fn.cloneTarget = function (target) {
	        return {
	            id: target.id,
	            id_org: target.id_org,
	            values: target.values.map(function (d) {
	                return { x: d.x, value: d.value, id: d.id };
	            })
	        };
	    };
	    c3_chart_internal_fn.updateXs = function () {
	        var $$ = this;
	        if ($$.data.targets.length) {
	            $$.xs = [];
	            $$.data.targets[0].values.forEach(function (v) {
	                $$.xs[v.index] = v.x;
	            });
	        }
	    };
	    c3_chart_internal_fn.getPrevX = function (i) {
	        var x = this.xs[i - 1];
	        return typeof x !== 'undefined' ? x : null;
	    };
	    c3_chart_internal_fn.getNextX = function (i) {
	        var x = this.xs[i + 1];
	        return typeof x !== 'undefined' ? x : null;
	    };
	    c3_chart_internal_fn.getMaxDataCount = function () {
	        var $$ = this;
	        return $$.d3.max($$.data.targets, function (t) {
	            return t.values.length;
	        });
	    };
	    c3_chart_internal_fn.getMaxDataCountTarget = function (targets) {
	        var length = targets.length,
	            max = 0,
	            maxTarget;
	        if (length > 1) {
	            targets.forEach(function (t) {
	                if (t.values.length > max) {
	                    maxTarget = t;
	                    max = t.values.length;
	                }
	            });
	        } else {
	            maxTarget = length ? targets[0] : null;
	        }
	        return maxTarget;
	    };
	    c3_chart_internal_fn.getEdgeX = function (targets) {
	        var $$ = this;
	        return !targets.length ? [0, 0] : [$$.d3.min(targets, function (t) {
	            return t.values[0].x;
	        }), $$.d3.max(targets, function (t) {
	            return t.values[t.values.length - 1].x;
	        })];
	    };
	    c3_chart_internal_fn.mapToIds = function (targets) {
	        return targets.map(function (d) {
	            return d.id;
	        });
	    };
	    c3_chart_internal_fn.mapToTargetIds = function (ids) {
	        var $$ = this;
	        return ids ? [].concat(ids) : $$.mapToIds($$.data.targets);
	    };
	    c3_chart_internal_fn.hasTarget = function (targets, id) {
	        var ids = this.mapToIds(targets),
	            i;
	        for (i = 0; i < ids.length; i++) {
	            if (ids[i] === id) {
	                return true;
	            }
	        }
	        return false;
	    };
	    c3_chart_internal_fn.isTargetToShow = function (targetId) {
	        return this.hiddenTargetIds.indexOf(targetId) < 0;
	    };
	    c3_chart_internal_fn.isLegendToShow = function (targetId) {
	        return this.hiddenLegendIds.indexOf(targetId) < 0;
	    };
	    c3_chart_internal_fn.filterTargetsToShow = function (targets) {
	        var $$ = this;
	        return targets.filter(function (t) {
	            return $$.isTargetToShow(t.id);
	        });
	    };
	    c3_chart_internal_fn.mapTargetsToUniqueXs = function (targets) {
	        var $$ = this;
	        var xs = $$.d3.set($$.d3.merge(targets.map(function (t) {
	            return t.values.map(function (v) {
	                return +v.x;
	            });
	        }))).values();
	        xs = $$.isTimeSeries() ? xs.map(function (x) {
	            return new Date(+x);
	        }) : xs.map(function (x) {
	            return +x;
	        });
	        return xs.sort(function (a, b) {
	            return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	        });
	    };
	    c3_chart_internal_fn.addHiddenTargetIds = function (targetIds) {
	        targetIds = targetIds instanceof Array ? targetIds : new Array(targetIds);
	        for (var i = 0; i < targetIds.length; i++) {
	            if (this.hiddenTargetIds.indexOf(targetIds[i]) < 0) {
	                this.hiddenTargetIds = this.hiddenTargetIds.concat(targetIds[i]);
	            }
	        }
	    };
	    c3_chart_internal_fn.removeHiddenTargetIds = function (targetIds) {
	        this.hiddenTargetIds = this.hiddenTargetIds.filter(function (id) {
	            return targetIds.indexOf(id) < 0;
	        });
	    };
	    c3_chart_internal_fn.addHiddenLegendIds = function (targetIds) {
	        targetIds = targetIds instanceof Array ? targetIds : new Array(targetIds);
	        for (var i = 0; i < targetIds.length; i++) {
	            if (this.hiddenLegendIds.indexOf(targetIds[i]) < 0) {
	                this.hiddenLegendIds = this.hiddenLegendIds.concat(targetIds[i]);
	            }
	        }
	    };
	    c3_chart_internal_fn.removeHiddenLegendIds = function (targetIds) {
	        this.hiddenLegendIds = this.hiddenLegendIds.filter(function (id) {
	            return targetIds.indexOf(id) < 0;
	        });
	    };
	    c3_chart_internal_fn.getValuesAsIdKeyed = function (targets) {
	        var ys = {};
	        targets.forEach(function (t) {
	            ys[t.id] = [];
	            t.values.forEach(function (v) {
	                ys[t.id].push(v.value);
	            });
	        });
	        return ys;
	    };
	    c3_chart_internal_fn.checkValueInTargets = function (targets, checker) {
	        var ids = Object.keys(targets),
	            i,
	            j,
	            values;
	        for (i = 0; i < ids.length; i++) {
	            values = targets[ids[i]].values;
	            for (j = 0; j < values.length; j++) {
	                if (checker(values[j].value)) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    c3_chart_internal_fn.hasNegativeValueInTargets = function (targets) {
	        return this.checkValueInTargets(targets, function (v) {
	            return v < 0;
	        });
	    };
	    c3_chart_internal_fn.hasPositiveValueInTargets = function (targets) {
	        return this.checkValueInTargets(targets, function (v) {
	            return v > 0;
	        });
	    };
	    c3_chart_internal_fn.isOrderDesc = function () {
	        var config = this.config;
	        return typeof config.data_order === 'string' && config.data_order.toLowerCase() === 'desc';
	    };
	    c3_chart_internal_fn.isOrderAsc = function () {
	        var config = this.config;
	        return typeof config.data_order === 'string' && config.data_order.toLowerCase() === 'asc';
	    };
	    c3_chart_internal_fn.getOrderFunction = function () {
	        var $$ = this,
	            config = $$.config,
	            orderAsc = $$.isOrderAsc(),
	            orderDesc = $$.isOrderDesc();
	        if (orderAsc || orderDesc) {
	            return function (t1, t2) {
	                var reducer = function reducer(p, c) {
	                    return p + Math.abs(c.value);
	                };
	                var t1Sum = t1.values.reduce(reducer, 0),
	                    t2Sum = t2.values.reduce(reducer, 0);
	                return orderDesc ? t2Sum - t1Sum : t1Sum - t2Sum;
	            };
	        } else if (isFunction(config.data_order)) {
	            return config.data_order;
	        } else if (isArray(config.data_order)) {
	            var order = config.data_order;
	            return function (t1, t2) {
	                return order.indexOf(t1.id) - order.indexOf(t2.id);
	            };
	        }
	    };
	    c3_chart_internal_fn.orderTargets = function (targets) {
	        var fct = this.getOrderFunction();
	        if (fct) {
	            targets.sort(fct);
	            if (this.isOrderAsc() || this.isOrderDesc()) {
	                targets.reverse();
	            }
	        }
	        return targets;
	    };
	    c3_chart_internal_fn.filterByX = function (targets, x) {
	        return this.d3.merge(targets.map(function (t) {
	            return t.values;
	        })).filter(function (v) {
	            return v.x - x === 0;
	        });
	    };
	    c3_chart_internal_fn.filterRemoveNull = function (data) {
	        return data.filter(function (d) {
	            return isValue(d.value);
	        });
	    };
	    c3_chart_internal_fn.filterByXDomain = function (targets, xDomain) {
	        return targets.map(function (t) {
	            return {
	                id: t.id,
	                id_org: t.id_org,
	                values: t.values.filter(function (v) {
	                    return xDomain[0] <= v.x && v.x <= xDomain[1];
	                })
	            };
	        });
	    };
	    c3_chart_internal_fn.hasDataLabel = function () {
	        var config = this.config;
	        if (typeof config.data_labels === 'boolean' && config.data_labels) {
	            return true;
	        } else if (_typeof(config.data_labels) === 'object' && notEmpty(config.data_labels)) {
	            return true;
	        }
	        return false;
	    };
	    c3_chart_internal_fn.getDataLabelLength = function (min, max, key) {
	        var $$ = this,
	            lengths = [0, 0],
	            paddingCoef = 1.3;
	        $$.selectChart.select('svg').selectAll('.dummy').data([min, max]).enter().append('text').text(function (d) {
	            return $$.dataLabelFormat(d.id)(d);
	        }).each(function (d, i) {
	            lengths[i] = this.getBoundingClientRect()[key] * paddingCoef;
	        }).remove();
	        return lengths;
	    };
	    c3_chart_internal_fn.isNoneArc = function (d) {
	        return this.hasTarget(this.data.targets, d.id);
	    }, c3_chart_internal_fn.isArc = function (d) {
	        return 'data' in d && this.hasTarget(this.data.targets, d.data.id);
	    };
	    c3_chart_internal_fn.findSameXOfValues = function (values, index) {
	        var i,
	            targetX = values[index].x,
	            sames = [];
	        for (i = index - 1; i >= 0; i--) {
	            if (targetX !== values[i].x) {
	                break;
	            }
	            sames.push(values[i]);
	        }
	        for (i = index; i < values.length; i++) {
	            if (targetX !== values[i].x) {
	                break;
	            }
	            sames.push(values[i]);
	        }
	        return sames;
	    };
	
	    c3_chart_internal_fn.findClosestFromTargets = function (targets, pos) {
	        var $$ = this,
	            candidates;
	
	        // map to array of closest points of each target
	        candidates = targets.map(function (target) {
	            return $$.findClosest(target.values, pos);
	        });
	
	        // decide closest point and return
	        return $$.findClosest(candidates, pos);
	    };
	    c3_chart_internal_fn.findClosest = function (values, pos) {
	        var $$ = this,
	            minDist = $$.config.point_sensitivity,
	            closest;
	
	        // find mouseovering bar
	        values.filter(function (v) {
	            return v && $$.isBarType(v.id);
	        }).forEach(function (v) {
	            var shape = $$.main.select('.' + CLASS.bars + $$.getTargetSelectorSuffix(v.id) + ' .' + CLASS.bar + '-' + v.index).node();
	            if (!closest && $$.isWithinBar(shape)) {
	                closest = v;
	            }
	        });
	
	        // find closest point from non-bar
	        values.filter(function (v) {
	            return v && !$$.isBarType(v.id);
	        }).forEach(function (v) {
	            var d = $$.dist(v, pos);
	            if (d < minDist) {
	                minDist = d;
	                closest = v;
	            }
	        });
	
	        return closest;
	    };
	    c3_chart_internal_fn.dist = function (data, pos) {
	        var $$ = this,
	            config = $$.config,
	            xIndex = config.axis_rotated ? 1 : 0,
	            yIndex = config.axis_rotated ? 0 : 1,
	            y = $$.circleY(data, data.index),
	            x = $$.x(data.x);
	        return Math.sqrt(Math.pow(x - pos[xIndex], 2) + Math.pow(y - pos[yIndex], 2));
	    };
	    c3_chart_internal_fn.convertValuesToStep = function (values) {
	        var converted = [].concat(values),
	            i;
	
	        if (!this.isCategorized()) {
	            return values;
	        }
	
	        for (i = values.length + 1; 0 < i; i--) {
	            converted[i] = converted[i - 1];
	        }
	
	        converted[0] = {
	            x: converted[0].x - 1,
	            value: converted[0].value,
	            id: converted[0].id
	        };
	        converted[values.length + 1] = {
	            x: converted[values.length].x + 1,
	            value: converted[values.length].value,
	            id: converted[values.length].id
	        };
	
	        return converted;
	    };
	    c3_chart_internal_fn.updateDataAttributes = function (name, attrs) {
	        var $$ = this,
	            config = $$.config,
	            current = config['data_' + name];
	        if (typeof attrs === 'undefined') {
	            return current;
	        }
	        Object.keys(attrs).forEach(function (id) {
	            current[id] = attrs[id];
	        });
	        $$.redraw({ withLegend: true });
	        return current;
	    };
	
	    c3_chart_internal_fn.load = function (targets, args) {
	        var $$ = this;
	        if (targets) {
	            // filter loading targets if needed
	            if (args.filter) {
	                targets = targets.filter(args.filter);
	            }
	            // set type if args.types || args.type specified
	            if (args.type || args.types) {
	                targets.forEach(function (t) {
	                    var type = args.types && args.types[t.id] ? args.types[t.id] : args.type;
	                    $$.setTargetType(t.id, type);
	                });
	            }
	            // Update/Add data
	            $$.data.targets.forEach(function (d) {
	                for (var i = 0; i < targets.length; i++) {
	                    if (d.id === targets[i].id) {
	                        d.values = targets[i].values;
	                        targets.splice(i, 1);
	                        break;
	                    }
	                }
	            });
	            $$.data.targets = $$.data.targets.concat(targets); // add remained
	        }
	
	        // Set targets
	        $$.updateTargets($$.data.targets);
	
	        // Redraw with new targets
	        $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true, withLegend: true });
	
	        if (args.done) {
	            args.done();
	        }
	    };
	    c3_chart_internal_fn.loadFromArgs = function (args) {
	        var $$ = this;
	        if (args.data) {
	            $$.load($$.convertDataToTargets(args.data), args);
	        } else if (args.url) {
	            $$.convertUrlToData(args.url, args.mimeType, args.headers, args.keys, function (data) {
	                $$.load($$.convertDataToTargets(data), args);
	            });
	        } else if (args.json) {
	            $$.load($$.convertDataToTargets($$.convertJsonToData(args.json, args.keys)), args);
	        } else if (args.rows) {
	            $$.load($$.convertDataToTargets($$.convertRowsToData(args.rows)), args);
	        } else if (args.columns) {
	            $$.load($$.convertDataToTargets($$.convertColumnsToData(args.columns)), args);
	        } else {
	            $$.load(null, args);
	        }
	    };
	    c3_chart_internal_fn.unload = function (targetIds, done) {
	        var $$ = this;
	        if (!done) {
	            done = function done() {};
	        }
	        // filter existing target
	        targetIds = targetIds.filter(function (id) {
	            return $$.hasTarget($$.data.targets, id);
	        });
	        // If no target, call done and return
	        if (!targetIds || targetIds.length === 0) {
	            done();
	            return;
	        }
	        $$.svg.selectAll(targetIds.map(function (id) {
	            return $$.selectorTarget(id);
	        })).transition().style('opacity', 0).remove().call($$.endall, done);
	        targetIds.forEach(function (id) {
	            // Reset fadein for future load
	            $$.withoutFadeIn[id] = false;
	            // Remove target's elements
	            if ($$.legend) {
	                $$.legend.selectAll('.' + CLASS.legendItem + $$.getTargetSelectorSuffix(id)).remove();
	            }
	            // Remove target
	            $$.data.targets = $$.data.targets.filter(function (t) {
	                return t.id !== id;
	            });
	        });
	    };
	
	    c3_chart_internal_fn.getYDomainMin = function (targets) {
	        var $$ = this,
	            config = $$.config,
	            ids = $$.mapToIds(targets),
	            ys = $$.getValuesAsIdKeyed(targets),
	            j,
	            k,
	            baseId,
	            idsInGroup,
	            id,
	            hasNegativeValue;
	        if (config.data_groups.length > 0) {
	            hasNegativeValue = $$.hasNegativeValueInTargets(targets);
	            for (j = 0; j < config.data_groups.length; j++) {
	                // Determine baseId
	                idsInGroup = config.data_groups[j].filter(function (id) {
	                    return ids.indexOf(id) >= 0;
	                });
	                if (idsInGroup.length === 0) {
	                    continue;
	                }
	                baseId = idsInGroup[0];
	                // Consider negative values
	                if (hasNegativeValue && ys[baseId]) {
	                    ys[baseId].forEach(function (v, i) {
	                        ys[baseId][i] = v < 0 ? v : 0;
	                    });
	                }
	                // Compute min
	                for (k = 1; k < idsInGroup.length; k++) {
	                    id = idsInGroup[k];
	                    if (!ys[id]) {
	                        continue;
	                    }
	                    ys[id].forEach(function (v, i) {
	                        if ($$.axis.getId(id) === $$.axis.getId(baseId) && ys[baseId] && !(hasNegativeValue && +v > 0)) {
	                            ys[baseId][i] += +v;
	                        }
	                    });
	                }
	            }
	        }
	        return $$.d3.min(Object.keys(ys).map(function (key) {
	            return $$.d3.min(ys[key]);
	        }));
	    };
	    c3_chart_internal_fn.getYDomainMax = function (targets) {
	        var $$ = this,
	            config = $$.config,
	            ids = $$.mapToIds(targets),
	            ys = $$.getValuesAsIdKeyed(targets),
	            j,
	            k,
	            baseId,
	            idsInGroup,
	            id,
	            hasPositiveValue;
	        if (config.data_groups.length > 0) {
	            hasPositiveValue = $$.hasPositiveValueInTargets(targets);
	            for (j = 0; j < config.data_groups.length; j++) {
	                // Determine baseId
	                idsInGroup = config.data_groups[j].filter(function (id) {
	                    return ids.indexOf(id) >= 0;
	                });
	                if (idsInGroup.length === 0) {
	                    continue;
	                }
	                baseId = idsInGroup[0];
	                // Consider positive values
	                if (hasPositiveValue && ys[baseId]) {
	                    ys[baseId].forEach(function (v, i) {
	                        ys[baseId][i] = v > 0 ? v : 0;
	                    });
	                }
	                // Compute max
	                for (k = 1; k < idsInGroup.length; k++) {
	                    id = idsInGroup[k];
	                    if (!ys[id]) {
	                        continue;
	                    }
	                    ys[id].forEach(function (v, i) {
	                        if ($$.axis.getId(id) === $$.axis.getId(baseId) && ys[baseId] && !(hasPositiveValue && +v < 0)) {
	                            ys[baseId][i] += +v;
	                        }
	                    });
	                }
	            }
	        }
	        return $$.d3.max(Object.keys(ys).map(function (key) {
	            return $$.d3.max(ys[key]);
	        }));
	    };
	    c3_chart_internal_fn.getYDomain = function (targets, axisId, xDomain) {
	        var $$ = this,
	            config = $$.config,
	            targetsByAxisId = targets.filter(function (t) {
	            return $$.axis.getId(t.id) === axisId;
	        }),
	            yTargets = xDomain ? $$.filterByXDomain(targetsByAxisId, xDomain) : targetsByAxisId,
	            yMin = axisId === 'y2' ? config.axis_y2_min : config.axis_y_min,
	            yMax = axisId === 'y2' ? config.axis_y2_max : config.axis_y_max,
	            yDomainMin = $$.getYDomainMin(yTargets),
	            yDomainMax = $$.getYDomainMax(yTargets),
	            domain,
	            domainLength,
	            padding,
	            padding_top,
	            padding_bottom,
	            center = axisId === 'y2' ? config.axis_y2_center : config.axis_y_center,
	            yDomainAbs,
	            lengths,
	            diff,
	            ratio,
	            isAllPositive,
	            isAllNegative,
	            isZeroBased = $$.hasType('bar', yTargets) && config.bar_zerobased || $$.hasType('area', yTargets) && config.area_zerobased,
	            isInverted = axisId === 'y2' ? config.axis_y2_inverted : config.axis_y_inverted,
	            showHorizontalDataLabel = $$.hasDataLabel() && config.axis_rotated,
	            showVerticalDataLabel = $$.hasDataLabel() && !config.axis_rotated;
	
	        // MEMO: avoid inverting domain unexpectedly
	        yDomainMin = isValue(yMin) ? yMin : isValue(yMax) ? yDomainMin < yMax ? yDomainMin : yMax - 10 : yDomainMin;
	        yDomainMax = isValue(yMax) ? yMax : isValue(yMin) ? yMin < yDomainMax ? yDomainMax : yMin + 10 : yDomainMax;
	
	        if (yTargets.length === 0) {
	            // use current domain if target of axisId is none
	            return axisId === 'y2' ? $$.y2.domain() : $$.y.domain();
	        }
	        if (isNaN(yDomainMin)) {
	            // set minimum to zero when not number
	            yDomainMin = 0;
	        }
	        if (isNaN(yDomainMax)) {
	            // set maximum to have same value as yDomainMin
	            yDomainMax = yDomainMin;
	        }
	        if (yDomainMin === yDomainMax) {
	            yDomainMin < 0 ? yDomainMax = 0 : yDomainMin = 0;
	        }
	        isAllPositive = yDomainMin >= 0 && yDomainMax >= 0;
	        isAllNegative = yDomainMin <= 0 && yDomainMax <= 0;
	
	        // Cancel zerobased if axis_*_min / axis_*_max specified
	        if (isValue(yMin) && isAllPositive || isValue(yMax) && isAllNegative) {
	            isZeroBased = false;
	        }
	
	        // Bar/Area chart should be 0-based if all positive|negative
	        if (isZeroBased) {
	            if (isAllPositive) {
	                yDomainMin = 0;
	            }
	            if (isAllNegative) {
	                yDomainMax = 0;
	            }
	        }
	
	        domainLength = Math.abs(yDomainMax - yDomainMin);
	        padding = padding_top = padding_bottom = domainLength * 0.1;
	
	        if (typeof center !== 'undefined') {
	            yDomainAbs = Math.max(Math.abs(yDomainMin), Math.abs(yDomainMax));
	            yDomainMax = center + yDomainAbs;
	            yDomainMin = center - yDomainAbs;
	        }
	        // add padding for data label
	        if (showHorizontalDataLabel) {
	            lengths = $$.getDataLabelLength(yDomainMin, yDomainMax, 'width');
	            diff = diffDomain($$.y.range());
	            ratio = [lengths[0] / diff, lengths[1] / diff];
	            padding_top += domainLength * (ratio[1] / (1 - ratio[0] - ratio[1]));
	            padding_bottom += domainLength * (ratio[0] / (1 - ratio[0] - ratio[1]));
	        } else if (showVerticalDataLabel) {
	            lengths = $$.getDataLabelLength(yDomainMin, yDomainMax, 'height');
	            padding_top += $$.axis.convertPixelsToAxisPadding(lengths[1], domainLength);
	            padding_bottom += $$.axis.convertPixelsToAxisPadding(lengths[0], domainLength);
	        }
	        if (axisId === 'y' && notEmpty(config.axis_y_padding)) {
	            padding_top = $$.axis.getPadding(config.axis_y_padding, 'top', padding_top, domainLength);
	            padding_bottom = $$.axis.getPadding(config.axis_y_padding, 'bottom', padding_bottom, domainLength);
	        }
	        if (axisId === 'y2' && notEmpty(config.axis_y2_padding)) {
	            padding_top = $$.axis.getPadding(config.axis_y2_padding, 'top', padding_top, domainLength);
	            padding_bottom = $$.axis.getPadding(config.axis_y2_padding, 'bottom', padding_bottom, domainLength);
	        }
	        // Bar/Area chart should be 0-based if all positive|negative
	        if (isZeroBased) {
	            if (isAllPositive) {
	                padding_bottom = yDomainMin;
	            }
	            if (isAllNegative) {
	                padding_top = -yDomainMax;
	            }
	        }
	        domain = [yDomainMin - padding_bottom, yDomainMax + padding_top];
	        return isInverted ? domain.reverse() : domain;
	    };
	    c3_chart_internal_fn.getXDomainMin = function (targets) {
	        var $$ = this,
	            config = $$.config;
	        return isDefined(config.axis_x_min) ? $$.isTimeSeries() ? this.parseDate(config.axis_x_min) : config.axis_x_min : $$.d3.min(targets, function (t) {
	            return $$.d3.min(t.values, function (v) {
	                return v.x;
	            });
	        });
	    };
	    c3_chart_internal_fn.getXDomainMax = function (targets) {
	        var $$ = this,
	            config = $$.config;
	        return isDefined(config.axis_x_max) ? $$.isTimeSeries() ? this.parseDate(config.axis_x_max) : config.axis_x_max : $$.d3.max(targets, function (t) {
	            return $$.d3.max(t.values, function (v) {
	                return v.x;
	            });
	        });
	    };
	    c3_chart_internal_fn.getXDomainPadding = function (domain) {
	        var $$ = this,
	            config = $$.config,
	            diff = domain[1] - domain[0],
	            maxDataCount,
	            padding,
	            paddingLeft,
	            paddingRight;
	        if ($$.isCategorized()) {
	            padding = 0;
	        } else if ($$.hasType('bar')) {
	            maxDataCount = $$.getMaxDataCount();
	            padding = maxDataCount > 1 ? diff / (maxDataCount - 1) / 2 : 0.5;
	        } else {
	            padding = diff * 0.01;
	        }
	        if (_typeof(config.axis_x_padding) === 'object' && notEmpty(config.axis_x_padding)) {
	            paddingLeft = isValue(config.axis_x_padding.left) ? config.axis_x_padding.left : padding;
	            paddingRight = isValue(config.axis_x_padding.right) ? config.axis_x_padding.right : padding;
	        } else if (typeof config.axis_x_padding === 'number') {
	            paddingLeft = paddingRight = config.axis_x_padding;
	        } else {
	            paddingLeft = paddingRight = padding;
	        }
	        return { left: paddingLeft, right: paddingRight };
	    };
	    c3_chart_internal_fn.getXDomain = function (targets) {
	        var $$ = this,
	            xDomain = [$$.getXDomainMin(targets), $$.getXDomainMax(targets)],
	            firstX = xDomain[0],
	            lastX = xDomain[1],
	            padding = $$.getXDomainPadding(xDomain),
	            min = 0,
	            max = 0;
	        // show center of x domain if min and max are the same
	        if (firstX - lastX === 0 && !$$.isCategorized()) {
	            if ($$.isTimeSeries()) {
	                firstX = new Date(firstX.getTime() * 0.5);
	                lastX = new Date(lastX.getTime() * 1.5);
	            } else {
	                firstX = firstX === 0 ? 1 : firstX * 0.5;
	                lastX = lastX === 0 ? -1 : lastX * 1.5;
	            }
	        }
	        if (firstX || firstX === 0) {
	            min = $$.isTimeSeries() ? new Date(firstX.getTime() - padding.left) : firstX - padding.left;
	        }
	        if (lastX || lastX === 0) {
	            max = $$.isTimeSeries() ? new Date(lastX.getTime() + padding.right) : lastX + padding.right;
	        }
	        return [min, max];
	    };
	    c3_chart_internal_fn.updateXDomain = function (targets, withUpdateXDomain, withUpdateOrgXDomain, withTrim, domain) {
	        var $$ = this,
	            config = $$.config;
	
	        if (withUpdateOrgXDomain) {
	            $$.x.domain(domain ? domain : $$.d3.extent($$.getXDomain(targets)));
	            $$.orgXDomain = $$.x.domain();
	            if (config.zoom_enabled) {
	                $$.zoom.scale($$.x).updateScaleExtent();
	            }
	            $$.subX.domain($$.x.domain());
	            if ($$.brush) {
	                $$.brush.scale($$.subX);
	            }
	        }
	        if (withUpdateXDomain) {
	            $$.x.domain(domain ? domain : !$$.brush || $$.brush.empty() ? $$.orgXDomain : $$.brush.extent());
	            if (config.zoom_enabled) {
	                $$.zoom.scale($$.x).updateScaleExtent();
	            }
	        }
	
	        // Trim domain when too big by zoom mousemove event
	        if (withTrim) {
	            $$.x.domain($$.trimXDomain($$.x.orgDomain()));
	        }
	
	        return $$.x.domain();
	    };
	    c3_chart_internal_fn.trimXDomain = function (domain) {
	        var zoomDomain = this.getZoomDomain(),
	            min = zoomDomain[0],
	            max = zoomDomain[1];
	        if (domain[0] <= min) {
	            domain[1] = +domain[1] + (min - domain[0]);
	            domain[0] = min;
	        }
	        if (max <= domain[1]) {
	            domain[0] = +domain[0] - (domain[1] - max);
	            domain[1] = max;
	        }
	        return domain;
	    };
	
	    c3_chart_internal_fn.drag = function (mouse) {
	        var $$ = this,
	            config = $$.config,
	            main = $$.main,
	            d3 = $$.d3;
	        var sx, sy, mx, my, minX, maxX, minY, maxY;
	
	        if ($$.hasArcType()) {
	            return;
	        }
	        if (!config.data_selection_enabled) {
	            return;
	        } // do nothing if not selectable
	        if (config.zoom_enabled && !$$.zoom.altDomain) {
	            return;
	        } // skip if zoomable because of conflict drag dehavior
	        if (!config.data_selection_multiple) {
	            return;
	        } // skip when single selection because drag is used for multiple selection
	
	        sx = $$.dragStart[0];
	        sy = $$.dragStart[1];
	        mx = mouse[0];
	        my = mouse[1];
	        minX = Math.min(sx, mx);
	        maxX = Math.max(sx, mx);
	        minY = config.data_selection_grouped ? $$.margin.top : Math.min(sy, my);
	        maxY = config.data_selection_grouped ? $$.height : Math.max(sy, my);
	
	        main.select('.' + CLASS.dragarea).attr('x', minX).attr('y', minY).attr('width', maxX - minX).attr('height', maxY - minY);
	        // TODO: binary search when multiple xs
	        main.selectAll('.' + CLASS.shapes).selectAll('.' + CLASS.shape).filter(function (d) {
	            return config.data_selection_isselectable(d);
	        }).each(function (d, i) {
	            var shape = d3.select(this),
	                isSelected = shape.classed(CLASS.SELECTED),
	                isIncluded = shape.classed(CLASS.INCLUDED),
	                _x,
	                _y,
	                _w,
	                _h,
	                toggle,
	                isWithin = false,
	                box;
	            if (shape.classed(CLASS.circle)) {
	                _x = shape.attr("cx") * 1;
	                _y = shape.attr("cy") * 1;
	                toggle = $$.togglePoint;
	                isWithin = minX < _x && _x < maxX && minY < _y && _y < maxY;
	            } else if (shape.classed(CLASS.bar)) {
	                box = getPathBox(this);
	                _x = box.x;
	                _y = box.y;
	                _w = box.width;
	                _h = box.height;
	                toggle = $$.togglePath;
	                isWithin = !(maxX < _x || _x + _w < minX) && !(maxY < _y || _y + _h < minY);
	            } else {
	                // line/area selection not supported yet
	                return;
	            }
	            if (isWithin ^ isIncluded) {
	                shape.classed(CLASS.INCLUDED, !isIncluded);
	                // TODO: included/unincluded callback here
	                shape.classed(CLASS.SELECTED, !isSelected);
	                toggle.call($$, !isSelected, shape, d, i);
	            }
	        });
	    };
	
	    c3_chart_internal_fn.dragstart = function (mouse) {
	        var $$ = this,
	            config = $$.config;
	        if ($$.hasArcType()) {
	            return;
	        }
	        if (!config.data_selection_enabled) {
	            return;
	        } // do nothing if not selectable
	        $$.dragStart = mouse;
	        $$.main.select('.' + CLASS.chart).append('rect').attr('class', CLASS.dragarea).style('opacity', 0.1);
	        $$.dragging = true;
	    };
	
	    c3_chart_internal_fn.dragend = function () {
	        var $$ = this,
	            config = $$.config;
	        if ($$.hasArcType()) {
	            return;
	        }
	        if (!config.data_selection_enabled) {
	            return;
	        } // do nothing if not selectable
	        $$.main.select('.' + CLASS.dragarea).transition().duration(100).style('opacity', 0).remove();
	        $$.main.selectAll('.' + CLASS.shape).classed(CLASS.INCLUDED, false);
	        $$.dragging = false;
	    };
	
	    c3_chart_internal_fn.getYFormat = function (forArc) {
	        var $$ = this,
	            formatForY = forArc && !$$.hasType('gauge') ? $$.defaultArcValueFormat : $$.yFormat,
	            formatForY2 = forArc && !$$.hasType('gauge') ? $$.defaultArcValueFormat : $$.y2Format;
	        return function (v, ratio, id) {
	            var format = $$.axis.getId(id) === 'y2' ? formatForY2 : formatForY;
	            return format.call($$, v, ratio);
	        };
	    };
	    c3_chart_internal_fn.yFormat = function (v) {
	        var $$ = this,
	            config = $$.config,
	            format = config.axis_y_tick_format ? config.axis_y_tick_format : $$.defaultValueFormat;
	        return format(v);
	    };
	    c3_chart_internal_fn.y2Format = function (v) {
	        var $$ = this,
	            config = $$.config,
	            format = config.axis_y2_tick_format ? config.axis_y2_tick_format : $$.defaultValueFormat;
	        return format(v);
	    };
	    c3_chart_internal_fn.defaultValueFormat = function (v) {
	        return isValue(v) ? +v : "";
	    };
	    c3_chart_internal_fn.defaultArcValueFormat = function (v, ratio) {
	        return (ratio * 100).toFixed(1) + '%';
	    };
	    c3_chart_internal_fn.dataLabelFormat = function (targetId) {
	        var $$ = this,
	            data_labels = $$.config.data_labels,
	            format,
	            defaultFormat = function defaultFormat(v) {
	            return isValue(v) ? +v : "";
	        };
	        // find format according to axis id
	        if (typeof data_labels.format === 'function') {
	            format = data_labels.format;
	        } else if (_typeof(data_labels.format) === 'object') {
	            if (data_labels.format[targetId]) {
	                format = data_labels.format[targetId] === true ? defaultFormat : data_labels.format[targetId];
	            } else {
	                format = function format() {
	                    return '';
	                };
	            }
	        } else {
	            format = defaultFormat;
	        }
	        return format;
	    };
	
	    c3_chart_internal_fn.initGrid = function () {
	        var $$ = this,
	            config = $$.config,
	            d3 = $$.d3;
	        $$.grid = $$.main.append('g').attr("clip-path", $$.clipPathForGrid).attr('class', CLASS.grid);
	        if (config.grid_x_show) {
	            $$.grid.append("g").attr("class", CLASS.xgrids);
	        }
	        if (config.grid_y_show) {
	            $$.grid.append('g').attr('class', CLASS.ygrids);
	        }
	        if (config.grid_focus_show) {
	            $$.grid.append('g').attr("class", CLASS.xgridFocus).append('line').attr('class', CLASS.xgridFocus);
	        }
	        $$.xgrid = d3.selectAll([]);
	        if (!config.grid_lines_front) {
	            $$.initGridLines();
	        }
	    };
	    c3_chart_internal_fn.initGridLines = function () {
	        var $$ = this,
	            d3 = $$.d3;
	        $$.gridLines = $$.main.append('g').attr("clip-path", $$.clipPathForGrid).attr('class', CLASS.grid + ' ' + CLASS.gridLines);
	        $$.gridLines.append('g').attr("class", CLASS.xgridLines);
	        $$.gridLines.append('g').attr('class', CLASS.ygridLines);
	        $$.xgridLines = d3.selectAll([]);
	    };
	    c3_chart_internal_fn.updateXGrid = function (withoutUpdate) {
	        var $$ = this,
	            config = $$.config,
	            d3 = $$.d3,
	            xgridData = $$.generateGridData(config.grid_x_type, $$.x),
	            tickOffset = $$.isCategorized() ? $$.xAxis.tickOffset() : 0;
	
	        $$.xgridAttr = config.axis_rotated ? {
	            'x1': 0,
	            'x2': $$.width,
	            'y1': function y1(d) {
	                return $$.x(d) - tickOffset;
	            },
	            'y2': function y2(d) {
	                return $$.x(d) - tickOffset;
	            }
	        } : {
	            'x1': function x1(d) {
	                return $$.x(d) + tickOffset;
	            },
	            'x2': function x2(d) {
	                return $$.x(d) + tickOffset;
	            },
	            'y1': 0,
	            'y2': $$.height
	        };
	
	        $$.xgrid = $$.main.select('.' + CLASS.xgrids).selectAll('.' + CLASS.xgrid).data(xgridData);
	        $$.xgrid.enter().append('line').attr("class", CLASS.xgrid);
	        if (!withoutUpdate) {
	            $$.xgrid.attr($$.xgridAttr).style("opacity", function () {
	                return +d3.select(this).attr(config.axis_rotated ? 'y1' : 'x1') === (config.axis_rotated ? $$.height : 0) ? 0 : 1;
	            });
	        }
	        $$.xgrid.exit().remove();
	    };
	
	    c3_chart_internal_fn.updateYGrid = function () {
	        var $$ = this,
	            config = $$.config,
	            gridValues = $$.yAxis.tickValues() || $$.y.ticks(config.grid_y_ticks);
	        $$.ygrid = $$.main.select('.' + CLASS.ygrids).selectAll('.' + CLASS.ygrid).data(gridValues);
	        $$.ygrid.enter().append('line').attr('class', CLASS.ygrid);
	        $$.ygrid.attr("x1", config.axis_rotated ? $$.y : 0).attr("x2", config.axis_rotated ? $$.y : $$.width).attr("y1", config.axis_rotated ? 0 : $$.y).attr("y2", config.axis_rotated ? $$.height : $$.y);
	        $$.ygrid.exit().remove();
	        $$.smoothLines($$.ygrid, 'grid');
	    };
	
	    c3_chart_internal_fn.gridTextAnchor = function (d) {
	        return d.position ? d.position : "end";
	    };
	    c3_chart_internal_fn.gridTextDx = function (d) {
	        return d.position === 'start' ? 4 : d.position === 'middle' ? 0 : -4;
	    };
	    c3_chart_internal_fn.xGridTextX = function (d) {
	        return d.position === 'start' ? -this.height : d.position === 'middle' ? -this.height / 2 : 0;
	    };
	    c3_chart_internal_fn.yGridTextX = function (d) {
	        return d.position === 'start' ? 0 : d.position === 'middle' ? this.width / 2 : this.width;
	    };
	    c3_chart_internal_fn.updateGrid = function (duration) {
	        var $$ = this,
	            main = $$.main,
	            config = $$.config,
	            xgridLine,
	            ygridLine,
	            yv;
	
	        // hide if arc type
	        $$.grid.style('visibility', $$.hasArcType() ? 'hidden' : 'visible');
	
	        main.select('line.' + CLASS.xgridFocus).style("visibility", "hidden");
	        if (config.grid_x_show) {
	            $$.updateXGrid();
	        }
	        $$.xgridLines = main.select('.' + CLASS.xgridLines).selectAll('.' + CLASS.xgridLine).data(config.grid_x_lines);
	        // enter
	        xgridLine = $$.xgridLines.enter().append('g').attr("class", function (d) {
	            return CLASS.xgridLine + (d['class'] ? ' ' + d['class'] : '');
	        });
	        xgridLine.append('line').style("opacity", 0);
	        xgridLine.append('text').attr("text-anchor", $$.gridTextAnchor).attr("transform", config.axis_rotated ? "" : "rotate(-90)").attr('dx', $$.gridTextDx).attr('dy', -5).style("opacity", 0);
	        // udpate
	        // done in d3.transition() of the end of this function
	        // exit
	        $$.xgridLines.exit().transition().duration(duration).style("opacity", 0).remove();
	
	        // Y-Grid
	        if (config.grid_y_show) {
	            $$.updateYGrid();
	        }
	        $$.ygridLines = main.select('.' + CLASS.ygridLines).selectAll('.' + CLASS.ygridLine).data(config.grid_y_lines);
	        // enter
	        ygridLine = $$.ygridLines.enter().append('g').attr("class", function (d) {
	            return CLASS.ygridLine + (d['class'] ? ' ' + d['class'] : '');
	        });
	        ygridLine.append('line').style("opacity", 0);
	        ygridLine.append('text').attr("text-anchor", $$.gridTextAnchor).attr("transform", config.axis_rotated ? "rotate(-90)" : "").attr('dx', $$.gridTextDx).attr('dy', -5).style("opacity", 0);
	        // update
	        yv = $$.yv.bind($$);
	        $$.ygridLines.select('line').transition().duration(duration).attr("x1", config.axis_rotated ? yv : 0).attr("x2", config.axis_rotated ? yv : $$.width).attr("y1", config.axis_rotated ? 0 : yv).attr("y2", config.axis_rotated ? $$.height : yv).style("opacity", 1);
	        $$.ygridLines.select('text').transition().duration(duration).attr("x", config.axis_rotated ? $$.xGridTextX.bind($$) : $$.yGridTextX.bind($$)).attr("y", yv).text(function (d) {
	            return d.text;
	        }).style("opacity", 1);
	        // exit
	        $$.ygridLines.exit().transition().duration(duration).style("opacity", 0).remove();
	    };
	    c3_chart_internal_fn.redrawGrid = function (withTransition) {
	        var $$ = this,
	            config = $$.config,
	            xv = $$.xv.bind($$),
	            lines = $$.xgridLines.select('line'),
	            texts = $$.xgridLines.select('text');
	        return [(withTransition ? lines.transition() : lines).attr("x1", config.axis_rotated ? 0 : xv).attr("x2", config.axis_rotated ? $$.width : xv).attr("y1", config.axis_rotated ? xv : 0).attr("y2", config.axis_rotated ? xv : $$.height).style("opacity", 1), (withTransition ? texts.transition() : texts).attr("x", config.axis_rotated ? $$.yGridTextX.bind($$) : $$.xGridTextX.bind($$)).attr("y", xv).text(function (d) {
	            return d.text;
	        }).style("opacity", 1)];
	    };
	    c3_chart_internal_fn.showXGridFocus = function (selectedData) {
	        var $$ = this,
	            config = $$.config,
	            dataToShow = selectedData.filter(function (d) {
	            return d && isValue(d.value);
	        }),
	            focusEl = $$.main.selectAll('line.' + CLASS.xgridFocus),
	            xx = $$.xx.bind($$);
	        if (!config.tooltip_show) {
	            return;
	        }
	        // Hide when scatter plot exists
	        if ($$.hasType('scatter') || $$.hasArcType()) {
	            return;
	        }
	        focusEl.style("visibility", "visible").data([dataToShow[0]]).attr(config.axis_rotated ? 'y1' : 'x1', xx).attr(config.axis_rotated ? 'y2' : 'x2', xx);
	        $$.smoothLines(focusEl, 'grid');
	    };
	    c3_chart_internal_fn.hideXGridFocus = function () {
	        this.main.select('line.' + CLASS.xgridFocus).style("visibility", "hidden");
	    };
	    c3_chart_internal_fn.updateXgridFocus = function () {
	        var $$ = this,
	            config = $$.config;
	        $$.main.select('line.' + CLASS.xgridFocus).attr("x1", config.axis_rotated ? 0 : -10).attr("x2", config.axis_rotated ? $$.width : -10).attr("y1", config.axis_rotated ? -10 : 0).attr("y2", config.axis_rotated ? -10 : $$.height);
	    };
	    c3_chart_internal_fn.generateGridData = function (type, scale) {
	        var $$ = this,
	            gridData = [],
	            xDomain,
	            firstYear,
	            lastYear,
	            i,
	            tickNum = $$.main.select("." + CLASS.axisX).selectAll('.tick').size();
	        if (type === 'year') {
	            xDomain = $$.getXDomain();
	            firstYear = xDomain[0].getFullYear();
	            lastYear = xDomain[1].getFullYear();
	            for (i = firstYear; i <= lastYear; i++) {
	                gridData.push(new Date(i + '-01-01 00:00:00'));
	            }
	        } else {
	            gridData = scale.ticks(10);
	            if (gridData.length > tickNum) {
	                // use only int
	                gridData = gridData.filter(function (d) {
	                    return ("" + d).indexOf('.') < 0;
	                });
	            }
	        }
	        return gridData;
	    };
	    c3_chart_internal_fn.getGridFilterToRemove = function (params) {
	        return params ? function (line) {
	            var found = false;
	            [].concat(params).forEach(function (param) {
	                if ('value' in param && line.value === param.value || 'class' in param && line['class'] === param['class']) {
	                    found = true;
	                }
	            });
	            return found;
	        } : function () {
	            return true;
	        };
	    };
	    c3_chart_internal_fn.removeGridLines = function (params, forX) {
	        var $$ = this,
	            config = $$.config,
	            toRemove = $$.getGridFilterToRemove(params),
	            toShow = function toShow(line) {
	            return !toRemove(line);
	        },
	            classLines = forX ? CLASS.xgridLines : CLASS.ygridLines,
	            classLine = forX ? CLASS.xgridLine : CLASS.ygridLine;
	        $$.main.select('.' + classLines).selectAll('.' + classLine).filter(toRemove).transition().duration(config.transition_duration).style('opacity', 0).remove();
	        if (forX) {
	            config.grid_x_lines = config.grid_x_lines.filter(toShow);
	        } else {
	            config.grid_y_lines = config.grid_y_lines.filter(toShow);
	        }
	    };
	
	    c3_chart_internal_fn.initEventRect = function () {
	        var $$ = this;
	        $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.eventRects).style('fill-opacity', 0);
	    };
	    c3_chart_internal_fn.redrawEventRect = function () {
	        var $$ = this,
	            config = $$.config,
	            eventRectUpdate,
	            maxDataCountTarget,
	            isMultipleX = $$.isMultipleX();
	
	        // rects for mouseover
	        var eventRects = $$.main.select('.' + CLASS.eventRects).style('cursor', config.zoom_enabled ? config.axis_rotated ? 'ns-resize' : 'ew-resize' : null).classed(CLASS.eventRectsMultiple, isMultipleX).classed(CLASS.eventRectsSingle, !isMultipleX);
	
	        // clear old rects
	        eventRects.selectAll('.' + CLASS.eventRect).remove();
	
	        // open as public variable
	        $$.eventRect = eventRects.selectAll('.' + CLASS.eventRect);
	
	        if (isMultipleX) {
	            eventRectUpdate = $$.eventRect.data([0]);
	            // enter : only one rect will be added
	            $$.generateEventRectsForMultipleXs(eventRectUpdate.enter());
	            // update
	            $$.updateEventRect(eventRectUpdate);
	            // exit : not needed because always only one rect exists
	        } else {
	            // Set data and update $$.eventRect
	            maxDataCountTarget = $$.getMaxDataCountTarget($$.data.targets);
	            eventRects.datum(maxDataCountTarget ? maxDataCountTarget.values : []);
	            $$.eventRect = eventRects.selectAll('.' + CLASS.eventRect);
	            eventRectUpdate = $$.eventRect.data(function (d) {
	                return d;
	            });
	            // enter
	            $$.generateEventRectsForSingleX(eventRectUpdate.enter());
	            // update
	            $$.updateEventRect(eventRectUpdate);
	            // exit
	            eventRectUpdate.exit().remove();
	        }
	    };
	    c3_chart_internal_fn.updateEventRect = function (eventRectUpdate) {
	        var $$ = this,
	            config = $$.config,
	            x,
	            y,
	            w,
	            h,
	            rectW,
	            rectX;
	
	        // set update selection if null
	        eventRectUpdate = eventRectUpdate || $$.eventRect.data(function (d) {
	            return d;
	        });
	
	        if ($$.isMultipleX()) {
	            // TODO: rotated not supported yet
	            x = 0;
	            y = 0;
	            w = $$.width;
	            h = $$.height;
	        } else {
	            if (($$.isCustomX() || $$.isTimeSeries()) && !$$.isCategorized()) {
	
	                // update index for x that is used by prevX and nextX
	                $$.updateXs();
	
	                rectW = function rectW(d) {
	                    var prevX = $$.getPrevX(d.index),
	                        nextX = $$.getNextX(d.index);
	
	                    // if there this is a single data point make the eventRect full width (or height)
	                    if (prevX === null && nextX === null) {
	                        return config.axis_rotated ? $$.height : $$.width;
	                    }
	
	                    if (prevX === null) {
	                        prevX = $$.x.domain()[0];
	                    }
	                    if (nextX === null) {
	                        nextX = $$.x.domain()[1];
	                    }
	
	                    return Math.max(0, ($$.x(nextX) - $$.x(prevX)) / 2);
	                };
	                rectX = function rectX(d) {
	                    var prevX = $$.getPrevX(d.index),
	                        nextX = $$.getNextX(d.index),
	                        thisX = $$.data.xs[d.id][d.index];
	
	                    // if there this is a single data point position the eventRect at 0
	                    if (prevX === null && nextX === null) {
	                        return 0;
	                    }
	
	                    if (prevX === null) {
	                        prevX = $$.x.domain()[0];
	                    }
	
	                    return ($$.x(thisX) + $$.x(prevX)) / 2;
	                };
	            } else {
	                rectW = $$.getEventRectWidth();
	                rectX = function rectX(d) {
	                    return $$.x(d.x) - rectW / 2;
	                };
	            }
	            x = config.axis_rotated ? 0 : rectX;
	            y = config.axis_rotated ? rectX : 0;
	            w = config.axis_rotated ? $$.width : rectW;
	            h = config.axis_rotated ? rectW : $$.height;
	        }
	
	        eventRectUpdate.attr('class', $$.classEvent.bind($$)).attr("x", x).attr("y", y).attr("width", w).attr("height", h);
	    };
	    c3_chart_internal_fn.generateEventRectsForSingleX = function (eventRectEnter) {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config;
	        eventRectEnter.append("rect").attr("class", $$.classEvent.bind($$)).style("cursor", config.data_selection_enabled && config.data_selection_grouped ? "pointer" : null).on('mouseover', function (d) {
	            var index = d.index;
	
	            if ($$.dragging || $$.flowing) {
	                return;
	            } // do nothing while dragging/flowing
	            if ($$.hasArcType()) {
	                return;
	            }
	
	            // Expand shapes for selection
	            if (config.point_focus_expand_enabled) {
	                $$.expandCircles(index, null, true);
	            }
	            $$.expandBars(index, null, true);
	
	            // Call event handler
	            $$.main.selectAll('.' + CLASS.shape + '-' + index).each(function (d) {
	                config.data_onmouseover.call($$.api, d);
	            });
	        }).on('mouseout', function (d) {
	            var index = d.index;
	            if (!$$.config) {
	                return;
	            } // chart is destroyed
	            if ($$.hasArcType()) {
	                return;
	            }
	            $$.hideXGridFocus();
	            $$.hideTooltip();
	            // Undo expanded shapes
	            $$.unexpandCircles();
	            $$.unexpandBars();
	            // Call event handler
	            $$.main.selectAll('.' + CLASS.shape + '-' + index).each(function (d) {
	                config.data_onmouseout.call($$.api, d);
	            });
	        }).on('mousemove', function (d) {
	            var selectedData,
	                index = d.index,
	                eventRect = $$.svg.select('.' + CLASS.eventRect + '-' + index);
	
	            if ($$.dragging || $$.flowing) {
	                return;
	            } // do nothing while dragging/flowing
	            if ($$.hasArcType()) {
	                return;
	            }
	
	            if ($$.isStepType(d) && $$.config.line_step_type === 'step-after' && d3.mouse(this)[0] < $$.x($$.getXValue(d.id, index))) {
	                index -= 1;
	            }
	
	            // Show tooltip
	            selectedData = $$.filterTargetsToShow($$.data.targets).map(function (t) {
	                return $$.addName($$.getValueOnIndex(t.values, index));
	            });
	
	            if (config.tooltip_grouped) {
	                $$.showTooltip(selectedData, this);
	                $$.showXGridFocus(selectedData);
	            }
	
	            if (config.tooltip_grouped && (!config.data_selection_enabled || config.data_selection_grouped)) {
	                return;
	            }
	
	            $$.main.selectAll('.' + CLASS.shape + '-' + index).each(function () {
	                d3.select(this).classed(CLASS.EXPANDED, true);
	                if (config.data_selection_enabled) {
	                    eventRect.style('cursor', config.data_selection_grouped ? 'pointer' : null);
	                }
	                if (!config.tooltip_grouped) {
	                    $$.hideXGridFocus();
	                    $$.hideTooltip();
	                    if (!config.data_selection_grouped) {
	                        $$.unexpandCircles(index);
	                        $$.unexpandBars(index);
	                    }
	                }
	            }).filter(function (d) {
	                return $$.isWithinShape(this, d);
	            }).each(function (d) {
	                if (config.data_selection_enabled && (config.data_selection_grouped || config.data_selection_isselectable(d))) {
	                    eventRect.style('cursor', 'pointer');
	                }
	                if (!config.tooltip_grouped) {
	                    $$.showTooltip([d], this);
	                    $$.showXGridFocus([d]);
	                    if (config.point_focus_expand_enabled) {
	                        $$.expandCircles(index, d.id, true);
	                    }
	                    $$.expandBars(index, d.id, true);
	                }
	            });
	        }).on('click', function (d) {
	            var index = d.index;
	            if ($$.hasArcType() || !$$.toggleShape) {
	                return;
	            }
	            if ($$.cancelClick) {
	                $$.cancelClick = false;
	                return;
	            }
	            if ($$.isStepType(d) && config.line_step_type === 'step-after' && d3.mouse(this)[0] < $$.x($$.getXValue(d.id, index))) {
	                index -= 1;
	            }
	            $$.main.selectAll('.' + CLASS.shape + '-' + index).each(function (d) {
	                if (config.data_selection_grouped || $$.isWithinShape(this, d)) {
	                    $$.toggleShape(this, d, index);
	                    $$.config.data_onclick.call($$.api, d, this);
	                }
	            });
	        }).call(config.data_selection_draggable && $$.drag ? d3.behavior.drag().origin(Object).on('drag', function () {
	            $$.drag(d3.mouse(this));
	        }).on('dragstart', function () {
	            $$.dragstart(d3.mouse(this));
	        }).on('dragend', function () {
	            $$.dragend();
	        }) : function () {});
	    };
	
	    c3_chart_internal_fn.generateEventRectsForMultipleXs = function (eventRectEnter) {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config;
	
	        function mouseout() {
	            $$.svg.select('.' + CLASS.eventRect).style('cursor', null);
	            $$.hideXGridFocus();
	            $$.hideTooltip();
	            $$.unexpandCircles();
	            $$.unexpandBars();
	        }
	
	        eventRectEnter.append('rect').attr('x', 0).attr('y', 0).attr('width', $$.width).attr('height', $$.height).attr('class', CLASS.eventRect).on('mouseout', function () {
	            if (!$$.config) {
	                return;
	            } // chart is destroyed
	            if ($$.hasArcType()) {
	                return;
	            }
	            mouseout();
	        }).on('mousemove', function () {
	            var targetsToShow = $$.filterTargetsToShow($$.data.targets);
	            var mouse, closest, sameXData, selectedData;
	
	            if ($$.dragging) {
	                return;
	            } // do nothing when dragging
	            if ($$.hasArcType(targetsToShow)) {
	                return;
	            }
	
	            mouse = d3.mouse(this);
	            closest = $$.findClosestFromTargets(targetsToShow, mouse);
	
	            if ($$.mouseover && (!closest || closest.id !== $$.mouseover.id)) {
	                config.data_onmouseout.call($$.api, $$.mouseover);
	                $$.mouseover = undefined;
	            }
	
	            if (!closest) {
	                mouseout();
	                return;
	            }
	
	            if ($$.isScatterType(closest) || !config.tooltip_grouped) {
	                sameXData = [closest];
	            } else {
	                sameXData = $$.filterByX(targetsToShow, closest.x);
	            }
	
	            // show tooltip when cursor is close to some point
	            selectedData = sameXData.map(function (d) {
	                return $$.addName(d);
	            });
	            $$.showTooltip(selectedData, this);
	
	            // expand points
	            if (config.point_focus_expand_enabled) {
	                $$.expandCircles(closest.index, closest.id, true);
	            }
	            $$.expandBars(closest.index, closest.id, true);
	
	            // Show xgrid focus line
	            $$.showXGridFocus(selectedData);
	
	            // Show cursor as pointer if point is close to mouse position
	            if ($$.isBarType(closest.id) || $$.dist(closest, mouse) < config.point_sensitivity) {
	                $$.svg.select('.' + CLASS.eventRect).style('cursor', 'pointer');
	                if (!$$.mouseover) {
	                    config.data_onmouseover.call($$.api, closest);
	                    $$.mouseover = closest;
	                }
	            }
	        }).on('click', function () {
	            var targetsToShow = $$.filterTargetsToShow($$.data.targets);
	            var mouse, closest;
	            if ($$.hasArcType(targetsToShow)) {
	                return;
	            }
	
	            mouse = d3.mouse(this);
	            closest = $$.findClosestFromTargets(targetsToShow, mouse);
	            if (!closest) {
	                return;
	            }
	            // select if selection enabled
	            if ($$.isBarType(closest.id) || $$.dist(closest, mouse) < config.point_sensitivity) {
	                $$.main.selectAll('.' + CLASS.shapes + $$.getTargetSelectorSuffix(closest.id)).selectAll('.' + CLASS.shape + '-' + closest.index).each(function () {
	                    if (config.data_selection_grouped || $$.isWithinShape(this, closest)) {
	                        $$.toggleShape(this, closest, closest.index);
	                        $$.config.data_onclick.call($$.api, closest, this);
	                    }
	                });
	            }
	        }).call(config.data_selection_draggable && $$.drag ? d3.behavior.drag().origin(Object).on('drag', function () {
	            $$.drag(d3.mouse(this));
	        }).on('dragstart', function () {
	            $$.dragstart(d3.mouse(this));
	        }).on('dragend', function () {
	            $$.dragend();
	        }) : function () {});
	    };
	    c3_chart_internal_fn.dispatchEvent = function (type, index, mouse) {
	        var $$ = this,
	            selector = '.' + CLASS.eventRect + (!$$.isMultipleX() ? '-' + index : ''),
	            eventRect = $$.main.select(selector).node(),
	            box = eventRect.getBoundingClientRect(),
	            x = box.left + (mouse ? mouse[0] : 0),
	            y = box.top + (mouse ? mouse[1] : 0),
	            event = document.createEvent("MouseEvents");
	
	        event.initMouseEvent(type, true, true, window, 0, x, y, x, y, false, false, false, false, 0, null);
	        eventRect.dispatchEvent(event);
	    };
	
	    c3_chart_internal_fn.initLegend = function () {
	        var $$ = this;
	        $$.legendItemTextBox = {};
	        $$.legendHasRendered = false;
	        $$.legend = $$.svg.append("g").attr("transform", $$.getTranslate('legend'));
	        if (!$$.config.legend_show) {
	            $$.legend.style('visibility', 'hidden');
	            $$.hiddenLegendIds = $$.mapToIds($$.data.targets);
	            return;
	        }
	        // MEMO: call here to update legend box and tranlate for all
	        // MEMO: translate will be upated by this, so transform not needed in updateLegend()
	        $$.updateLegendWithDefaults();
	    };
	    c3_chart_internal_fn.updateLegendWithDefaults = function () {
	        var $$ = this;
	        $$.updateLegend($$.mapToIds($$.data.targets), { withTransform: false, withTransitionForTransform: false, withTransition: false });
	    };
	    c3_chart_internal_fn.updateSizeForLegend = function (legendHeight, legendWidth) {
	        var $$ = this,
	            config = $$.config,
	            insetLegendPosition = {
	            top: $$.isLegendTop ? $$.getCurrentPaddingTop() + config.legend_inset_y + 5.5 : $$.currentHeight - legendHeight - $$.getCurrentPaddingBottom() - config.legend_inset_y,
	            left: $$.isLegendLeft ? $$.getCurrentPaddingLeft() + config.legend_inset_x + 0.5 : $$.currentWidth - legendWidth - $$.getCurrentPaddingRight() - config.legend_inset_x + 0.5
	        };
	
	        $$.margin3 = {
	            top: $$.isLegendRight ? 0 : $$.isLegendInset ? insetLegendPosition.top : $$.currentHeight - legendHeight,
	            right: NaN,
	            bottom: 0,
	            left: $$.isLegendRight ? $$.currentWidth - legendWidth : $$.isLegendInset ? insetLegendPosition.left : 0
	        };
	    };
	    c3_chart_internal_fn.transformLegend = function (withTransition) {
	        var $$ = this;
	        (withTransition ? $$.legend.transition() : $$.legend).attr("transform", $$.getTranslate('legend'));
	    };
	    c3_chart_internal_fn.updateLegendStep = function (step) {
	        this.legendStep = step;
	    };
	    c3_chart_internal_fn.updateLegendItemWidth = function (w) {
	        this.legendItemWidth = w;
	    };
	    c3_chart_internal_fn.updateLegendItemHeight = function (h) {
	        this.legendItemHeight = h;
	    };
	    c3_chart_internal_fn.getLegendWidth = function () {
	        var $$ = this;
	        return $$.config.legend_show ? $$.isLegendRight || $$.isLegendInset ? $$.legendItemWidth * ($$.legendStep + 1) : $$.currentWidth : 0;
	    };
	    c3_chart_internal_fn.getLegendHeight = function () {
	        var $$ = this,
	            h = 0;
	        if ($$.config.legend_show) {
	            if ($$.isLegendRight) {
	                h = $$.currentHeight;
	            } else {
	                h = Math.max(20, $$.legendItemHeight) * ($$.legendStep + 1);
	            }
	        }
	        return h;
	    };
	    c3_chart_internal_fn.opacityForLegend = function (legendItem) {
	        return legendItem.classed(CLASS.legendItemHidden) ? null : 1;
	    };
	    c3_chart_internal_fn.opacityForUnfocusedLegend = function (legendItem) {
	        return legendItem.classed(CLASS.legendItemHidden) ? null : 0.3;
	    };
	    c3_chart_internal_fn.toggleFocusLegend = function (targetIds, focus) {
	        var $$ = this;
	        targetIds = $$.mapToTargetIds(targetIds);
	        $$.legend.selectAll('.' + CLASS.legendItem).filter(function (id) {
	            return targetIds.indexOf(id) >= 0;
	        }).classed(CLASS.legendItemFocused, focus).transition().duration(100).style('opacity', function () {
	            var opacity = focus ? $$.opacityForLegend : $$.opacityForUnfocusedLegend;
	            return opacity.call($$, $$.d3.select(this));
	        });
	    };
	    c3_chart_internal_fn.revertLegend = function () {
	        var $$ = this,
	            d3 = $$.d3;
	        $$.legend.selectAll('.' + CLASS.legendItem).classed(CLASS.legendItemFocused, false).transition().duration(100).style('opacity', function () {
	            return $$.opacityForLegend(d3.select(this));
	        });
	    };
	    c3_chart_internal_fn.showLegend = function (targetIds) {
	        var $$ = this,
	            config = $$.config;
	        if (!config.legend_show) {
	            config.legend_show = true;
	            $$.legend.style('visibility', 'visible');
	            if (!$$.legendHasRendered) {
	                $$.updateLegendWithDefaults();
	            }
	        }
	        $$.removeHiddenLegendIds(targetIds);
	        $$.legend.selectAll($$.selectorLegends(targetIds)).style('visibility', 'visible').transition().style('opacity', function () {
	            return $$.opacityForLegend($$.d3.select(this));
	        });
	    };
	    c3_chart_internal_fn.hideLegend = function (targetIds) {
	        var $$ = this,
	            config = $$.config;
	        if (config.legend_show && isEmpty(targetIds)) {
	            config.legend_show = false;
	            $$.legend.style('visibility', 'hidden');
	        }
	        $$.addHiddenLegendIds(targetIds);
	        $$.legend.selectAll($$.selectorLegends(targetIds)).style('opacity', 0).style('visibility', 'hidden');
	    };
	    c3_chart_internal_fn.clearLegendItemTextBoxCache = function () {
	        this.legendItemTextBox = {};
	    };
	    c3_chart_internal_fn.updateLegend = function (targetIds, options, transitions) {
	        var $$ = this,
	            config = $$.config;
	        var xForLegend, xForLegendText, xForLegendRect, yForLegend, yForLegendText, yForLegendRect, x1ForLegendTile, x2ForLegendTile, yForLegendTile;
	        var paddingTop = 4,
	            paddingRight = 10,
	            maxWidth = 0,
	            maxHeight = 0,
	            posMin = 10,
	            tileWidth = config.legend_item_tile_width + 5;
	        var l,
	            totalLength = 0,
	            offsets = {},
	            widths = {},
	            heights = {},
	            margins = [0],
	            steps = {},
	            step = 0;
	        var withTransition, withTransitionForTransform;
	        var texts, rects, tiles, background;
	
	        // Skip elements when their name is set to null
	        targetIds = targetIds.filter(function (id) {
	            return !isDefined(config.data_names[id]) || config.data_names[id] !== null;
	        });
	
	        options = options || {};
	        withTransition = getOption(options, "withTransition", true);
	        withTransitionForTransform = getOption(options, "withTransitionForTransform", true);
	
	        function getTextBox(textElement, id) {
	            if (!$$.legendItemTextBox[id]) {
	                $$.legendItemTextBox[id] = $$.getTextRect(textElement.textContent, CLASS.legendItem, textElement);
	            }
	            return $$.legendItemTextBox[id];
	        }
	
	        function updatePositions(textElement, id, index) {
	            var reset = index === 0,
	                isLast = index === targetIds.length - 1,
	                box = getTextBox(textElement, id),
	                itemWidth = box.width + tileWidth + (isLast && !($$.isLegendRight || $$.isLegendInset) ? 0 : paddingRight) + config.legend_padding,
	                itemHeight = box.height + paddingTop,
	                itemLength = $$.isLegendRight || $$.isLegendInset ? itemHeight : itemWidth,
	                areaLength = $$.isLegendRight || $$.isLegendInset ? $$.getLegendHeight() : $$.getLegendWidth(),
	                margin,
	                maxLength;
	
	            // MEMO: care about condifion of step, totalLength
	            function updateValues(id, withoutStep) {
	                if (!withoutStep) {
	                    margin = (areaLength - totalLength - itemLength) / 2;
	                    if (margin < posMin) {
	                        margin = (areaLength - itemLength) / 2;
	                        totalLength = 0;
	                        step++;
	                    }
	                }
	                steps[id] = step;
	                margins[step] = $$.isLegendInset ? 10 : margin;
	                offsets[id] = totalLength;
	                totalLength += itemLength;
	            }
	
	            if (reset) {
	                totalLength = 0;
	                step = 0;
	                maxWidth = 0;
	                maxHeight = 0;
	            }
	
	            if (config.legend_show && !$$.isLegendToShow(id)) {
	                widths[id] = heights[id] = steps[id] = offsets[id] = 0;
	                return;
	            }
	
	            widths[id] = itemWidth;
	            heights[id] = itemHeight;
	
	            if (!maxWidth || itemWidth >= maxWidth) {
	                maxWidth = itemWidth;
	            }
	            if (!maxHeight || itemHeight >= maxHeight) {
	                maxHeight = itemHeight;
	            }
	            maxLength = $$.isLegendRight || $$.isLegendInset ? maxHeight : maxWidth;
	
	            if (config.legend_equally) {
	                Object.keys(widths).forEach(function (id) {
	                    widths[id] = maxWidth;
	                });
	                Object.keys(heights).forEach(function (id) {
	                    heights[id] = maxHeight;
	                });
	                margin = (areaLength - maxLength * targetIds.length) / 2;
	                if (margin < posMin) {
	                    totalLength = 0;
	                    step = 0;
	                    targetIds.forEach(function (id) {
	                        updateValues(id);
	                    });
	                } else {
	                    updateValues(id, true);
	                }
	            } else {
	                updateValues(id);
	            }
	        }
	
	        if ($$.isLegendInset) {
	            step = config.legend_inset_step ? config.legend_inset_step : targetIds.length;
	            $$.updateLegendStep(step);
	        }
	
	        if ($$.isLegendRight) {
	            xForLegend = function xForLegend(id) {
	                return maxWidth * steps[id];
	            };
	            yForLegend = function yForLegend(id) {
	                return margins[steps[id]] + offsets[id];
	            };
	        } else if ($$.isLegendInset) {
	            xForLegend = function xForLegend(id) {
	                return maxWidth * steps[id] + 10;
	            };
	            yForLegend = function yForLegend(id) {
	                return margins[steps[id]] + offsets[id];
	            };
	        } else {
	            xForLegend = function xForLegend(id) {
	                return margins[steps[id]] + offsets[id];
	            };
	            yForLegend = function yForLegend(id) {
	                return maxHeight * steps[id];
	            };
	        }
	        xForLegendText = function xForLegendText(id, i) {
	            return xForLegend(id, i) + 4 + config.legend_item_tile_width;
	        };
	        yForLegendText = function yForLegendText(id, i) {
	            return yForLegend(id, i) + 9;
	        };
	        xForLegendRect = function xForLegendRect(id, i) {
	            return xForLegend(id, i);
	        };
	        yForLegendRect = function yForLegendRect(id, i) {
	            return yForLegend(id, i) - 5;
	        };
	        x1ForLegendTile = function x1ForLegendTile(id, i) {
	            return xForLegend(id, i) - 2;
	        };
	        x2ForLegendTile = function x2ForLegendTile(id, i) {
	            return xForLegend(id, i) - 2 + config.legend_item_tile_width;
	        };
	        yForLegendTile = function yForLegendTile(id, i) {
	            return yForLegend(id, i) + 4;
	        };
	
	        // Define g for legend area
	        l = $$.legend.selectAll('.' + CLASS.legendItem).data(targetIds).enter().append('g').attr('class', function (id) {
	            return $$.generateClass(CLASS.legendItem, id);
	        }).style('visibility', function (id) {
	            return $$.isLegendToShow(id) ? 'visible' : 'hidden';
	        }).style('cursor', 'pointer').on('click', function (id) {
	            if (config.legend_item_onclick) {
	                config.legend_item_onclick.call($$, id);
	            } else {
	                if ($$.d3.event.altKey) {
	                    $$.api.hide();
	                    $$.api.show(id);
	                } else {
	                    $$.api.toggle(id);
	                    $$.isTargetToShow(id) ? $$.api.focus(id) : $$.api.revert();
	                }
	            }
	        }).on('mouseover', function (id) {
	            if (config.legend_item_onmouseover) {
	                config.legend_item_onmouseover.call($$, id);
	            } else {
	                $$.d3.select(this).classed(CLASS.legendItemFocused, true);
	                if (!$$.transiting && $$.isTargetToShow(id)) {
	                    $$.api.focus(id);
	                }
	            }
	        }).on('mouseout', function (id) {
	            if (config.legend_item_onmouseout) {
	                config.legend_item_onmouseout.call($$, id);
	            } else {
	                $$.d3.select(this).classed(CLASS.legendItemFocused, false);
	                $$.api.revert();
	            }
	        });
	        l.append('text').text(function (id) {
	            return isDefined(config.data_names[id]) ? config.data_names[id] : id;
	        }).each(function (id, i) {
	            updatePositions(this, id, i);
	        }).style("pointer-events", "none").attr('x', $$.isLegendRight || $$.isLegendInset ? xForLegendText : -200).attr('y', $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendText);
	        l.append('rect').attr("class", CLASS.legendItemEvent).style('fill-opacity', 0).attr('x', $$.isLegendRight || $$.isLegendInset ? xForLegendRect : -200).attr('y', $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendRect);
	        l.append('line').attr('class', CLASS.legendItemTile).style('stroke', $$.color).style("pointer-events", "none").attr('x1', $$.isLegendRight || $$.isLegendInset ? x1ForLegendTile : -200).attr('y1', $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendTile).attr('x2', $$.isLegendRight || $$.isLegendInset ? x2ForLegendTile : -200).attr('y2', $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendTile).attr('stroke-width', config.legend_item_tile_height);
	
	        // Set background for inset legend
	        background = $$.legend.select('.' + CLASS.legendBackground + ' rect');
	        if ($$.isLegendInset && maxWidth > 0 && background.size() === 0) {
	            background = $$.legend.insert('g', '.' + CLASS.legendItem).attr("class", CLASS.legendBackground).append('rect');
	        }
	
	        texts = $$.legend.selectAll('text').data(targetIds).text(function (id) {
	            return isDefined(config.data_names[id]) ? config.data_names[id] : id;
	        }) // MEMO: needed for update
	        .each(function (id, i) {
	            updatePositions(this, id, i);
	        });
	        (withTransition ? texts.transition() : texts).attr('x', xForLegendText).attr('y', yForLegendText);
	
	        rects = $$.legend.selectAll('rect.' + CLASS.legendItemEvent).data(targetIds);
	        (withTransition ? rects.transition() : rects).attr('width', function (id) {
	            return widths[id];
	        }).attr('height', function (id) {
	            return heights[id];
	        }).attr('x', xForLegendRect).attr('y', yForLegendRect);
	
	        tiles = $$.legend.selectAll('line.' + CLASS.legendItemTile).data(targetIds);
	        (withTransition ? tiles.transition() : tiles).style('stroke', $$.levelColor ? function (id) {
	            return $$.levelColor($$.cache[id].values[0].value);
	        } : $$.color).attr('x1', x1ForLegendTile).attr('y1', yForLegendTile).attr('x2', x2ForLegendTile).attr('y2', yForLegendTile);
	
	        if (background) {
	            (withTransition ? background.transition() : background).attr('height', $$.getLegendHeight() - 12).attr('width', maxWidth * (step + 1) + 10);
	        }
	
	        // toggle legend state
	        $$.legend.selectAll('.' + CLASS.legendItem).classed(CLASS.legendItemHidden, function (id) {
	            return !$$.isTargetToShow(id);
	        });
	
	        // Update all to reflect change of legend
	        $$.updateLegendItemWidth(maxWidth);
	        $$.updateLegendItemHeight(maxHeight);
	        $$.updateLegendStep(step);
	        // Update size and scale
	        $$.updateSizes();
	        $$.updateScales();
	        $$.updateSvgSize();
	        // Update g positions
	        $$.transformAll(withTransitionForTransform, transitions);
	        $$.legendHasRendered = true;
	    };
	
	    c3_chart_internal_fn.initRegion = function () {
	        var $$ = this;
	        $$.region = $$.main.append('g').attr("clip-path", $$.clipPath).attr("class", CLASS.regions);
	    };
	    c3_chart_internal_fn.updateRegion = function (duration) {
	        var $$ = this,
	            config = $$.config;
	
	        // hide if arc type
	        $$.region.style('visibility', $$.hasArcType() ? 'hidden' : 'visible');
	
	        $$.mainRegion = $$.main.select('.' + CLASS.regions).selectAll('.' + CLASS.region).data(config.regions);
	        $$.mainRegion.enter().append('g').append('rect').style("fill-opacity", 0);
	        $$.mainRegion.attr('class', $$.classRegion.bind($$));
	        $$.mainRegion.exit().transition().duration(duration).style("opacity", 0).remove();
	    };
	    c3_chart_internal_fn.redrawRegion = function (withTransition) {
	        var $$ = this,
	            regions = $$.mainRegion.selectAll('rect').each(function () {
	            // data is binded to g and it's not transferred to rect (child node) automatically,
	            // then data of each rect has to be updated manually.
	            // TODO: there should be more efficient way to solve this?
	            var parentData = $$.d3.select(this.parentNode).datum();
	            $$.d3.select(this).datum(parentData);
	        }),
	            x = $$.regionX.bind($$),
	            y = $$.regionY.bind($$),
	            w = $$.regionWidth.bind($$),
	            h = $$.regionHeight.bind($$);
	        return [(withTransition ? regions.transition() : regions).attr("x", x).attr("y", y).attr("width", w).attr("height", h).style("fill-opacity", function (d) {
	            return isValue(d.opacity) ? d.opacity : 0.1;
	        })];
	    };
	    c3_chart_internal_fn.regionX = function (d) {
	        var $$ = this,
	            config = $$.config,
	            xPos,
	            yScale = d.axis === 'y' ? $$.y : $$.y2;
	        if (d.axis === 'y' || d.axis === 'y2') {
	            xPos = config.axis_rotated ? 'start' in d ? yScale(d.start) : 0 : 0;
	        } else {
	            xPos = config.axis_rotated ? 0 : 'start' in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.start) : d.start) : 0;
	        }
	        return xPos;
	    };
	    c3_chart_internal_fn.regionY = function (d) {
	        var $$ = this,
	            config = $$.config,
	            yPos,
	            yScale = d.axis === 'y' ? $$.y : $$.y2;
	        if (d.axis === 'y' || d.axis === 'y2') {
	            yPos = config.axis_rotated ? 0 : 'end' in d ? yScale(d.end) : 0;
	        } else {
	            yPos = config.axis_rotated ? 'start' in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.start) : d.start) : 0 : 0;
	        }
	        return yPos;
	    };
	    c3_chart_internal_fn.regionWidth = function (d) {
	        var $$ = this,
	            config = $$.config,
	            start = $$.regionX(d),
	            end,
	            yScale = d.axis === 'y' ? $$.y : $$.y2;
	        if (d.axis === 'y' || d.axis === 'y2') {
	            end = config.axis_rotated ? 'end' in d ? yScale(d.end) : $$.width : $$.width;
	        } else {
	            end = config.axis_rotated ? $$.width : 'end' in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.end) : d.end) : $$.width;
	        }
	        return end < start ? 0 : end - start;
	    };
	    c3_chart_internal_fn.regionHeight = function (d) {
	        var $$ = this,
	            config = $$.config,
	            start = this.regionY(d),
	            end,
	            yScale = d.axis === 'y' ? $$.y : $$.y2;
	        if (d.axis === 'y' || d.axis === 'y2') {
	            end = config.axis_rotated ? $$.height : 'start' in d ? yScale(d.start) : $$.height;
	        } else {
	            end = config.axis_rotated ? 'end' in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.end) : d.end) : $$.height : $$.height;
	        }
	        return end < start ? 0 : end - start;
	    };
	    c3_chart_internal_fn.isRegionOnX = function (d) {
	        return !d.axis || d.axis === 'x';
	    };
	
	    c3_chart_internal_fn.getScale = function (min, max, forTimeseries) {
	        return (forTimeseries ? this.d3.time.scale() : this.d3.scale.linear()).range([min, max]);
	    };
	    c3_chart_internal_fn.getX = function (min, max, domain, offset) {
	        var $$ = this,
	            scale = $$.getScale(min, max, $$.isTimeSeries()),
	            _scale = domain ? scale.domain(domain) : scale,
	            key;
	        // Define customized scale if categorized axis
	        if ($$.isCategorized()) {
	            offset = offset || function () {
	                return 0;
	            };
	            scale = function scale(d, raw) {
	                var v = _scale(d) + offset(d);
	                return raw ? v : Math.ceil(v);
	            };
	        } else {
	            scale = function scale(d, raw) {
	                var v = _scale(d);
	                return raw ? v : Math.ceil(v);
	            };
	        }
	        // define functions
	        for (key in _scale) {
	            scale[key] = _scale[key];
	        }
	        scale.orgDomain = function () {
	            return _scale.domain();
	        };
	        // define custom domain() for categorized axis
	        if ($$.isCategorized()) {
	            scale.domain = function (domain) {
	                if (!arguments.length) {
	                    domain = this.orgDomain();
	                    return [domain[0], domain[1] + 1];
	                }
	                _scale.domain(domain);
	                return scale;
	            };
	        }
	        return scale;
	    };
	    c3_chart_internal_fn.getY = function (min, max, domain) {
	        var scale = this.getScale(min, max, this.isTimeSeriesY());
	        if (domain) {
	            scale.domain(domain);
	        }
	        return scale;
	    };
	    c3_chart_internal_fn.getYScale = function (id) {
	        return this.axis.getId(id) === 'y2' ? this.y2 : this.y;
	    };
	    c3_chart_internal_fn.getSubYScale = function (id) {
	        return this.axis.getId(id) === 'y2' ? this.subY2 : this.subY;
	    };
	    c3_chart_internal_fn.updateScales = function () {
	        var $$ = this,
	            config = $$.config,
	            forInit = !$$.x;
	        // update edges
	        $$.xMin = config.axis_rotated ? 1 : 0;
	        $$.xMax = config.axis_rotated ? $$.height : $$.width;
	        $$.yMin = config.axis_rotated ? 0 : $$.height;
	        $$.yMax = config.axis_rotated ? $$.width : 1;
	        $$.subXMin = $$.xMin;
	        $$.subXMax = $$.xMax;
	        $$.subYMin = config.axis_rotated ? 0 : $$.height2;
	        $$.subYMax = config.axis_rotated ? $$.width2 : 1;
	        // update scales
	        $$.x = $$.getX($$.xMin, $$.xMax, forInit ? undefined : $$.x.orgDomain(), function () {
	            return $$.xAxis.tickOffset();
	        });
	        $$.y = $$.getY($$.yMin, $$.yMax, forInit ? config.axis_y_default : $$.y.domain());
	        $$.y2 = $$.getY($$.yMin, $$.yMax, forInit ? config.axis_y2_default : $$.y2.domain());
	        $$.subX = $$.getX($$.xMin, $$.xMax, $$.orgXDomain, function (d) {
	            return d % 1 ? 0 : $$.subXAxis.tickOffset();
	        });
	        $$.subY = $$.getY($$.subYMin, $$.subYMax, forInit ? config.axis_y_default : $$.subY.domain());
	        $$.subY2 = $$.getY($$.subYMin, $$.subYMax, forInit ? config.axis_y2_default : $$.subY2.domain());
	        // update axes
	        $$.xAxisTickFormat = $$.axis.getXAxisTickFormat();
	        $$.xAxisTickValues = $$.axis.getXAxisTickValues();
	        $$.yAxisTickValues = $$.axis.getYAxisTickValues();
	        $$.y2AxisTickValues = $$.axis.getY2AxisTickValues();
	
	        $$.xAxis = $$.axis.getXAxis($$.x, $$.xOrient, $$.xAxisTickFormat, $$.xAxisTickValues, config.axis_x_tick_outer);
	        $$.subXAxis = $$.axis.getXAxis($$.subX, $$.subXOrient, $$.xAxisTickFormat, $$.xAxisTickValues, config.axis_x_tick_outer);
	        $$.yAxis = $$.axis.getYAxis($$.y, $$.yOrient, config.axis_y_tick_format, $$.yAxisTickValues, config.axis_y_tick_outer);
	        $$.y2Axis = $$.axis.getYAxis($$.y2, $$.y2Orient, config.axis_y2_tick_format, $$.y2AxisTickValues, config.axis_y2_tick_outer);
	
	        // Set initialized scales to brush and zoom
	        if (!forInit) {
	            if ($$.brush) {
	                $$.brush.scale($$.subX);
	            }
	            if (config.zoom_enabled) {
	                $$.zoom.scale($$.x);
	            }
	        }
	        // update for arc
	        if ($$.updateArc) {
	            $$.updateArc();
	        }
	    };
	
	    c3_chart_internal_fn.selectPoint = function (target, d, i) {
	        var $$ = this,
	            config = $$.config,
	            cx = (config.axis_rotated ? $$.circleY : $$.circleX).bind($$),
	            cy = (config.axis_rotated ? $$.circleX : $$.circleY).bind($$),
	            r = $$.pointSelectR.bind($$);
	        config.data_onselected.call($$.api, d, target.node());
	        // add selected-circle on low layer g
	        $$.main.select('.' + CLASS.selectedCircles + $$.getTargetSelectorSuffix(d.id)).selectAll('.' + CLASS.selectedCircle + '-' + i).data([d]).enter().append('circle').attr("class", function () {
	            return $$.generateClass(CLASS.selectedCircle, i);
	        }).attr("cx", cx).attr("cy", cy).attr("stroke", function () {
	            return $$.color(d);
	        }).attr("r", function (d) {
	            return $$.pointSelectR(d) * 1.4;
	        }).transition().duration(100).attr("r", r);
	    };
	    c3_chart_internal_fn.unselectPoint = function (target, d, i) {
	        var $$ = this;
	        $$.config.data_onunselected.call($$.api, d, target.node());
	        // remove selected-circle from low layer g
	        $$.main.select('.' + CLASS.selectedCircles + $$.getTargetSelectorSuffix(d.id)).selectAll('.' + CLASS.selectedCircle + '-' + i).transition().duration(100).attr('r', 0).remove();
	    };
	    c3_chart_internal_fn.togglePoint = function (selected, target, d, i) {
	        selected ? this.selectPoint(target, d, i) : this.unselectPoint(target, d, i);
	    };
	    c3_chart_internal_fn.selectPath = function (target, d) {
	        var $$ = this;
	        $$.config.data_onselected.call($$, d, target.node());
	        if ($$.config.interaction_brighten) {
	            target.transition().duration(100).style("fill", function () {
	                return $$.d3.rgb($$.color(d)).brighter(0.75);
	            });
	        }
	    };
	    c3_chart_internal_fn.unselectPath = function (target, d) {
	        var $$ = this;
	        $$.config.data_onunselected.call($$, d, target.node());
	        if ($$.config.interaction_brighten) {
	            target.transition().duration(100).style("fill", function () {
	                return $$.color(d);
	            });
	        }
	    };
	    c3_chart_internal_fn.togglePath = function (selected, target, d, i) {
	        selected ? this.selectPath(target, d, i) : this.unselectPath(target, d, i);
	    };
	    c3_chart_internal_fn.getToggle = function (that, d) {
	        var $$ = this,
	            toggle;
	        if (that.nodeName === 'circle') {
	            if ($$.isStepType(d)) {
	                // circle is hidden in step chart, so treat as within the click area
	                toggle = function toggle() {}; // TODO: how to select step chart?
	            } else {
	                toggle = $$.togglePoint;
	            }
	        } else if (that.nodeName === 'path') {
	            toggle = $$.togglePath;
	        }
	        return toggle;
	    };
	    c3_chart_internal_fn.toggleShape = function (that, d, i) {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config,
	            shape = d3.select(that),
	            isSelected = shape.classed(CLASS.SELECTED),
	            toggle = $$.getToggle(that, d).bind($$);
	
	        if (config.data_selection_enabled && config.data_selection_isselectable(d)) {
	            if (!config.data_selection_multiple) {
	                $$.main.selectAll('.' + CLASS.shapes + (config.data_selection_grouped ? $$.getTargetSelectorSuffix(d.id) : "")).selectAll('.' + CLASS.shape).each(function (d, i) {
	                    var shape = d3.select(this);
	                    if (shape.classed(CLASS.SELECTED)) {
	                        toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
	                    }
	                });
	            }
	            shape.classed(CLASS.SELECTED, !isSelected);
	            toggle(!isSelected, shape, d, i);
	        }
	    };
	
	    c3_chart_internal_fn.initBar = function () {
	        var $$ = this;
	        $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartBars);
	    };
	    c3_chart_internal_fn.updateTargetsForBar = function (targets) {
	        var $$ = this,
	            config = $$.config,
	            mainBarUpdate,
	            mainBarEnter,
	            classChartBar = $$.classChartBar.bind($$),
	            classBars = $$.classBars.bind($$),
	            classFocus = $$.classFocus.bind($$);
	        mainBarUpdate = $$.main.select('.' + CLASS.chartBars).selectAll('.' + CLASS.chartBar).data(targets).attr('class', function (d) {
	            return classChartBar(d) + classFocus(d);
	        });
	        mainBarEnter = mainBarUpdate.enter().append('g').attr('class', classChartBar).style("pointer-events", "none");
	        // Bars for each data
	        mainBarEnter.append('g').attr("class", classBars).style("cursor", function (d) {
	            return config.data_selection_isselectable(d) ? "pointer" : null;
	        });
	    };
	    c3_chart_internal_fn.updateBar = function (durationForExit) {
	        var $$ = this,
	            barData = $$.barData.bind($$),
	            classBar = $$.classBar.bind($$),
	            initialOpacity = $$.initialOpacity.bind($$),
	            color = function color(d) {
	            return $$.color(d.id);
	        };
	        $$.mainBar = $$.main.selectAll('.' + CLASS.bars).selectAll('.' + CLASS.bar).data(barData);
	        $$.mainBar.enter().append('path').attr("class", classBar).style("stroke", color).style("fill", color);
	        $$.mainBar.style("opacity", initialOpacity);
	        $$.mainBar.exit().transition().duration(durationForExit).remove();
	    };
	    c3_chart_internal_fn.redrawBar = function (drawBar, withTransition) {
	        return [(withTransition ? this.mainBar.transition(Math.random().toString()) : this.mainBar).attr('d', drawBar).style("stroke", this.color).style("fill", this.color).style("opacity", 1)];
	    };
	    c3_chart_internal_fn.getBarW = function (axis, barTargetsNum) {
	        var $$ = this,
	            config = $$.config,
	            w = typeof config.bar_width === 'number' ? config.bar_width : barTargetsNum ? axis.tickInterval() * config.bar_width_ratio / barTargetsNum : 0;
	        return config.bar_width_max && w > config.bar_width_max ? config.bar_width_max : w;
	    };
	    c3_chart_internal_fn.getBars = function (i, id) {
	        var $$ = this;
	        return (id ? $$.main.selectAll('.' + CLASS.bars + $$.getTargetSelectorSuffix(id)) : $$.main).selectAll('.' + CLASS.bar + (isValue(i) ? '-' + i : ''));
	    };
	    c3_chart_internal_fn.expandBars = function (i, id, reset) {
	        var $$ = this;
	        if (reset) {
	            $$.unexpandBars();
	        }
	        $$.getBars(i, id).classed(CLASS.EXPANDED, true);
	    };
	    c3_chart_internal_fn.unexpandBars = function (i) {
	        var $$ = this;
	        $$.getBars(i).classed(CLASS.EXPANDED, false);
	    };
	    c3_chart_internal_fn.generateDrawBar = function (barIndices, isSub) {
	        var $$ = this,
	            config = $$.config,
	            getPoints = $$.generateGetBarPoints(barIndices, isSub);
	        return function (d, i) {
	            // 4 points that make a bar
	            var points = getPoints(d, i);
	
	            // switch points if axis is rotated, not applicable for sub chart
	            var indexX = config.axis_rotated ? 1 : 0;
	            var indexY = config.axis_rotated ? 0 : 1;
	
	            var path = 'M ' + points[0][indexX] + ',' + points[0][indexY] + ' ' + 'L' + points[1][indexX] + ',' + points[1][indexY] + ' ' + 'L' + points[2][indexX] + ',' + points[2][indexY] + ' ' + 'L' + points[3][indexX] + ',' + points[3][indexY] + ' ' + 'z';
	
	            return path;
	        };
	    };
	    c3_chart_internal_fn.generateGetBarPoints = function (barIndices, isSub) {
	        var $$ = this,
	            axis = isSub ? $$.subXAxis : $$.xAxis,
	            barTargetsNum = barIndices.__max__ + 1,
	            barW = $$.getBarW(axis, barTargetsNum),
	            barX = $$.getShapeX(barW, barTargetsNum, barIndices, !!isSub),
	            barY = $$.getShapeY(!!isSub),
	            barOffset = $$.getShapeOffset($$.isBarType, barIndices, !!isSub),
	            barSpaceOffset = barW * ($$.config.bar_space / 2),
	            yScale = isSub ? $$.getSubYScale : $$.getYScale;
	        return function (d, i) {
	            var y0 = yScale.call($$, d.id)(0),
	                offset = barOffset(d, i) || y0,
	                // offset is for stacked bar chart
	            posX = barX(d),
	                posY = barY(d);
	            // fix posY not to overflow opposite quadrant
	            if ($$.config.axis_rotated) {
	                if (0 < d.value && posY < y0 || d.value < 0 && y0 < posY) {
	                    posY = y0;
	                }
	            }
	            // 4 points that make a bar
	            return [[posX + barSpaceOffset, offset], [posX + barSpaceOffset, posY - (y0 - offset)], [posX + barW - barSpaceOffset, posY - (y0 - offset)], [posX + barW - barSpaceOffset, offset]];
	        };
	    };
	    c3_chart_internal_fn.isWithinBar = function (that) {
	        var mouse = this.d3.mouse(that),
	            box = that.getBoundingClientRect(),
	            seg0 = that.pathSegList.getItem(0),
	            seg1 = that.pathSegList.getItem(1),
	            x = Math.min(seg0.x, seg1.x),
	            y = Math.min(seg0.y, seg1.y),
	            w = box.width,
	            h = box.height,
	            offset = 2,
	            sx = x - offset,
	            ex = x + w + offset,
	            sy = y + h + offset,
	            ey = y - offset;
	        return sx < mouse[0] && mouse[0] < ex && ey < mouse[1] && mouse[1] < sy;
	    };
	
	    c3_chart_internal_fn.getShapeIndices = function (typeFilter) {
	        var $$ = this,
	            config = $$.config,
	            indices = {},
	            i = 0,
	            j,
	            k;
	        $$.filterTargetsToShow($$.data.targets.filter(typeFilter, $$)).forEach(function (d) {
	            for (j = 0; j < config.data_groups.length; j++) {
	                if (config.data_groups[j].indexOf(d.id) < 0) {
	                    continue;
	                }
	                for (k = 0; k < config.data_groups[j].length; k++) {
	                    if (config.data_groups[j][k] in indices) {
	                        indices[d.id] = indices[config.data_groups[j][k]];
	                        break;
	                    }
	                }
	            }
	            if (isUndefined(indices[d.id])) {
	                indices[d.id] = i++;
	            }
	        });
	        indices.__max__ = i - 1;
	        return indices;
	    };
	    c3_chart_internal_fn.getShapeX = function (offset, targetsNum, indices, isSub) {
	        var $$ = this,
	            scale = isSub ? $$.subX : $$.x;
	        return function (d) {
	            var index = d.id in indices ? indices[d.id] : 0;
	            return d.x || d.x === 0 ? scale(d.x) - offset * (targetsNum / 2 - index) : 0;
	        };
	    };
	    c3_chart_internal_fn.getShapeY = function (isSub) {
	        var $$ = this;
	        return function (d) {
	            var scale = isSub ? $$.getSubYScale(d.id) : $$.getYScale(d.id);
	            return scale(d.value);
	        };
	    };
	    c3_chart_internal_fn.getShapeOffset = function (typeFilter, indices, isSub) {
	        var $$ = this,
	            targets = $$.orderTargets($$.filterTargetsToShow($$.data.targets.filter(typeFilter, $$))),
	            targetIds = targets.map(function (t) {
	            return t.id;
	        });
	        return function (d, i) {
	            var scale = isSub ? $$.getSubYScale(d.id) : $$.getYScale(d.id),
	                y0 = scale(0),
	                offset = y0;
	            targets.forEach(function (t) {
	                var values = $$.isStepType(d) ? $$.convertValuesToStep(t.values) : t.values;
	                if (t.id === d.id || indices[t.id] !== indices[d.id]) {
	                    return;
	                }
	                if (targetIds.indexOf(t.id) < targetIds.indexOf(d.id)) {
	                    // check if the x values line up
	                    if (typeof values[i] === 'undefined' || +values[i].x !== +d.x) {
	                        // "+" for timeseries
	                        // if not, try to find the value that does line up
	                        i = -1;
	                        values.forEach(function (v, j) {
	                            if (v.x === d.x) {
	                                i = j;
	                            }
	                        });
	                    }
	                    if (i in values && values[i].value * d.value >= 0) {
	                        offset += scale(values[i].value) - y0;
	                    }
	                }
	            });
	            return offset;
	        };
	    };
	    c3_chart_internal_fn.isWithinShape = function (that, d) {
	        var $$ = this,
	            shape = $$.d3.select(that),
	            isWithin;
	        if (!$$.isTargetToShow(d.id)) {
	            isWithin = false;
	        } else if (that.nodeName === 'circle') {
	            isWithin = $$.isStepType(d) ? $$.isWithinStep(that, $$.getYScale(d.id)(d.value)) : $$.isWithinCircle(that, $$.pointSelectR(d) * 1.5);
	        } else if (that.nodeName === 'path') {
	            isWithin = shape.classed(CLASS.bar) ? $$.isWithinBar(that) : true;
	        }
	        return isWithin;
	    };
	
	    c3_chart_internal_fn.getInterpolate = function (d) {
	        var $$ = this,
	            interpolation = $$.isInterpolationType($$.config.spline_interpolation_type) ? $$.config.spline_interpolation_type : 'cardinal';
	        return $$.isSplineType(d) ? interpolation : $$.isStepType(d) ? $$.config.line_step_type : "linear";
	    };
	
	    c3_chart_internal_fn.initLine = function () {
	        var $$ = this;
	        $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartLines);
	    };
	    c3_chart_internal_fn.updateTargetsForLine = function (targets) {
	        var $$ = this,
	            config = $$.config,
	            mainLineUpdate,
	            mainLineEnter,
	            classChartLine = $$.classChartLine.bind($$),
	            classLines = $$.classLines.bind($$),
	            classAreas = $$.classAreas.bind($$),
	            classCircles = $$.classCircles.bind($$),
	            classFocus = $$.classFocus.bind($$);
	        mainLineUpdate = $$.main.select('.' + CLASS.chartLines).selectAll('.' + CLASS.chartLine).data(targets).attr('class', function (d) {
	            return classChartLine(d) + classFocus(d);
	        });
	        mainLineEnter = mainLineUpdate.enter().append('g').attr('class', classChartLine).style('opacity', 0).style("pointer-events", "none");
	        // Lines for each data
	        mainLineEnter.append('g').attr("class", classLines);
	        // Areas
	        mainLineEnter.append('g').attr('class', classAreas);
	        // Circles for each data point on lines
	        mainLineEnter.append('g').attr("class", function (d) {
	            return $$.generateClass(CLASS.selectedCircles, d.id);
	        });
	        mainLineEnter.append('g').attr("class", classCircles).style("cursor", function (d) {
	            return config.data_selection_isselectable(d) ? "pointer" : null;
	        });
	        // Update date for selected circles
	        targets.forEach(function (t) {
	            $$.main.selectAll('.' + CLASS.selectedCircles + $$.getTargetSelectorSuffix(t.id)).selectAll('.' + CLASS.selectedCircle).each(function (d) {
	                d.value = t.values[d.index].value;
	            });
	        });
	        // MEMO: can not keep same color...
	        //mainLineUpdate.exit().remove();
	    };
	    c3_chart_internal_fn.updateLine = function (durationForExit) {
	        var $$ = this;
	        $$.mainLine = $$.main.selectAll('.' + CLASS.lines).selectAll('.' + CLASS.line).data($$.lineData.bind($$));
	        $$.mainLine.enter().append('path').attr('class', $$.classLine.bind($$)).style("stroke", $$.color);
	        $$.mainLine.style("opacity", $$.initialOpacity.bind($$)).style('shape-rendering', function (d) {
	            return $$.isStepType(d) ? 'crispEdges' : '';
	        }).attr('transform', null);
	        $$.mainLine.exit().transition().duration(durationForExit).style('opacity', 0).remove();
	    };
	    c3_chart_internal_fn.redrawLine = function (drawLine, withTransition) {
	        return [(withTransition ? this.mainLine.transition(Math.random().toString()) : this.mainLine).attr("d", drawLine).style("stroke", this.color).style("opacity", 1)];
	    };
	    c3_chart_internal_fn.generateDrawLine = function (lineIndices, isSub) {
	        var $$ = this,
	            config = $$.config,
	            line = $$.d3.svg.line(),
	            getPoints = $$.generateGetLinePoints(lineIndices, isSub),
	            yScaleGetter = isSub ? $$.getSubYScale : $$.getYScale,
	            xValue = function xValue(d) {
	            return (isSub ? $$.subxx : $$.xx).call($$, d);
	        },
	            yValue = function yValue(d, i) {
	            return config.data_groups.length > 0 ? getPoints(d, i)[0][1] : yScaleGetter.call($$, d.id)(d.value);
	        };
	
	        line = config.axis_rotated ? line.x(yValue).y(xValue) : line.x(xValue).y(yValue);
	        if (!config.line_connectNull) {
	            line = line.defined(function (d) {
	                return d.value != null;
	            });
	        }
	        return function (d) {
	            var values = config.line_connectNull ? $$.filterRemoveNull(d.values) : d.values,
	                x = isSub ? $$.subX : $$.x,
	                y = yScaleGetter.call($$, d.id),
	                x0 = 0,
	                y0 = 0,
	                path;
	            if ($$.isLineType(d)) {
	                if (config.data_regions[d.id]) {
	                    path = $$.lineWithRegions(values, x, y, config.data_regions[d.id]);
	                } else {
	                    if ($$.isStepType(d)) {
	                        values = $$.convertValuesToStep(values);
	                    }
	                    path = line.interpolate($$.getInterpolate(d))(values);
	                }
	            } else {
	                if (values[0]) {
	                    x0 = x(values[0].x);
	                    y0 = y(values[0].value);
	                }
	                path = config.axis_rotated ? "M " + y0 + " " + x0 : "M " + x0 + " " + y0;
	            }
	            return path ? path : "M 0 0";
	        };
	    };
	    c3_chart_internal_fn.generateGetLinePoints = function (lineIndices, isSub) {
	        // partial duplication of generateGetBarPoints
	        var $$ = this,
	            config = $$.config,
	            lineTargetsNum = lineIndices.__max__ + 1,
	            x = $$.getShapeX(0, lineTargetsNum, lineIndices, !!isSub),
	            y = $$.getShapeY(!!isSub),
	            lineOffset = $$.getShapeOffset($$.isLineType, lineIndices, !!isSub),
	            yScale = isSub ? $$.getSubYScale : $$.getYScale;
	        return function (d, i) {
	            var y0 = yScale.call($$, d.id)(0),
	                offset = lineOffset(d, i) || y0,
	                // offset is for stacked area chart
	            posX = x(d),
	                posY = y(d);
	            // fix posY not to overflow opposite quadrant
	            if (config.axis_rotated) {
	                if (0 < d.value && posY < y0 || d.value < 0 && y0 < posY) {
	                    posY = y0;
	                }
	            }
	            // 1 point that marks the line position
	            return [[posX, posY - (y0 - offset)], [posX, posY - (y0 - offset)], // needed for compatibility
	            [posX, posY - (y0 - offset)], // needed for compatibility
	            [posX, posY - (y0 - offset)] // needed for compatibility
	            ];
	        };
	    };
	
	    c3_chart_internal_fn.lineWithRegions = function (d, x, y, _regions) {
	        var $$ = this,
	            config = $$.config,
	            prev = -1,
	            i,
	            j,
	            s = "M",
	            sWithRegion,
	            xp,
	            yp,
	            dx,
	            dy,
	            dd,
	            diff,
	            diffx2,
	            xOffset = $$.isCategorized() ? 0.5 : 0,
	            xValue,
	            yValue,
	            regions = [];
	
	        function isWithinRegions(x, regions) {
	            var i;
	            for (i = 0; i < regions.length; i++) {
	                if (regions[i].start < x && x <= regions[i].end) {
	                    return true;
	                }
	            }
	            return false;
	        }
	
	        // Check start/end of regions
	        if (isDefined(_regions)) {
	            for (i = 0; i < _regions.length; i++) {
	                regions[i] = {};
	                if (isUndefined(_regions[i].start)) {
	                    regions[i].start = d[0].x;
	                } else {
	                    regions[i].start = $$.isTimeSeries() ? $$.parseDate(_regions[i].start) : _regions[i].start;
	                }
	                if (isUndefined(_regions[i].end)) {
	                    regions[i].end = d[d.length - 1].x;
	                } else {
	                    regions[i].end = $$.isTimeSeries() ? $$.parseDate(_regions[i].end) : _regions[i].end;
	                }
	            }
	        }
	
	        // Set scales
	        xValue = config.axis_rotated ? function (d) {
	            return y(d.value);
	        } : function (d) {
	            return x(d.x);
	        };
	        yValue = config.axis_rotated ? function (d) {
	            return x(d.x);
	        } : function (d) {
	            return y(d.value);
	        };
	
	        // Define svg generator function for region
	        function generateM(points) {
	            return 'M' + points[0][0] + ' ' + points[0][1] + ' ' + points[1][0] + ' ' + points[1][1];
	        }
	        if ($$.isTimeSeries()) {
	            sWithRegion = function sWithRegion(d0, d1, j, diff) {
	                var x0 = d0.x.getTime(),
	                    x_diff = d1.x - d0.x,
	                    xv0 = new Date(x0 + x_diff * j),
	                    xv1 = new Date(x0 + x_diff * (j + diff)),
	                    points;
	                if (config.axis_rotated) {
	                    points = [[y(yp(j)), x(xv0)], [y(yp(j + diff)), x(xv1)]];
	                } else {
	                    points = [[x(xv0), y(yp(j))], [x(xv1), y(yp(j + diff))]];
	                }
	                return generateM(points);
	            };
	        } else {
	            sWithRegion = function sWithRegion(d0, d1, j, diff) {
	                var points;
	                if (config.axis_rotated) {
	                    points = [[y(yp(j), true), x(xp(j))], [y(yp(j + diff), true), x(xp(j + diff))]];
	                } else {
	                    points = [[x(xp(j), true), y(yp(j))], [x(xp(j + diff), true), y(yp(j + diff))]];
	                }
	                return generateM(points);
	            };
	        }
	
	        // Generate
	        for (i = 0; i < d.length; i++) {
	
	            // Draw as normal
	            if (isUndefined(regions) || !isWithinRegions(d[i].x, regions)) {
	                s += " " + xValue(d[i]) + " " + yValue(d[i]);
	            }
	            // Draw with region // TODO: Fix for horizotal charts
	            else {
	                    xp = $$.getScale(d[i - 1].x + xOffset, d[i].x + xOffset, $$.isTimeSeries());
	                    yp = $$.getScale(d[i - 1].value, d[i].value);
	
	                    dx = x(d[i].x) - x(d[i - 1].x);
	                    dy = y(d[i].value) - y(d[i - 1].value);
	                    dd = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
	                    diff = 2 / dd;
	                    diffx2 = diff * 2;
	
	                    for (j = diff; j <= 1; j += diffx2) {
	                        s += sWithRegion(d[i - 1], d[i], j, diff);
	                    }
	                }
	            prev = d[i].x;
	        }
	
	        return s;
	    };
	
	    c3_chart_internal_fn.updateArea = function (durationForExit) {
	        var $$ = this,
	            d3 = $$.d3;
	        $$.mainArea = $$.main.selectAll('.' + CLASS.areas).selectAll('.' + CLASS.area).data($$.lineData.bind($$));
	        $$.mainArea.enter().append('path').attr("class", $$.classArea.bind($$)).style("fill", $$.color).style("opacity", function () {
	            $$.orgAreaOpacity = +d3.select(this).style('opacity');return 0;
	        });
	        $$.mainArea.style("opacity", $$.orgAreaOpacity);
	        $$.mainArea.exit().transition().duration(durationForExit).style('opacity', 0).remove();
	    };
	    c3_chart_internal_fn.redrawArea = function (drawArea, withTransition) {
	        return [(withTransition ? this.mainArea.transition(Math.random().toString()) : this.mainArea).attr("d", drawArea).style("fill", this.color).style("opacity", this.orgAreaOpacity)];
	    };
	    c3_chart_internal_fn.generateDrawArea = function (areaIndices, isSub) {
	        var $$ = this,
	            config = $$.config,
	            area = $$.d3.svg.area(),
	            getPoints = $$.generateGetAreaPoints(areaIndices, isSub),
	            yScaleGetter = isSub ? $$.getSubYScale : $$.getYScale,
	            xValue = function xValue(d) {
	            return (isSub ? $$.subxx : $$.xx).call($$, d);
	        },
	            value0 = function value0(d, i) {
	            return config.data_groups.length > 0 ? getPoints(d, i)[0][1] : yScaleGetter.call($$, d.id)($$.getAreaBaseValue(d.id));
	        },
	            value1 = function value1(d, i) {
	            return config.data_groups.length > 0 ? getPoints(d, i)[1][1] : yScaleGetter.call($$, d.id)(d.value);
	        };
	
	        area = config.axis_rotated ? area.x0(value0).x1(value1).y(xValue) : area.x(xValue).y0(config.area_above ? 0 : value0).y1(value1);
	        if (!config.line_connectNull) {
	            area = area.defined(function (d) {
	                return d.value !== null;
	            });
	        }
	
	        return function (d) {
	            var values = config.line_connectNull ? $$.filterRemoveNull(d.values) : d.values,
	                x0 = 0,
	                y0 = 0,
	                path;
	            if ($$.isAreaType(d)) {
	                if ($$.isStepType(d)) {
	                    values = $$.convertValuesToStep(values);
	                }
	                path = area.interpolate($$.getInterpolate(d))(values);
	            } else {
	                if (values[0]) {
	                    x0 = $$.x(values[0].x);
	                    y0 = $$.getYScale(d.id)(values[0].value);
	                }
	                path = config.axis_rotated ? "M " + y0 + " " + x0 : "M " + x0 + " " + y0;
	            }
	            return path ? path : "M 0 0";
	        };
	    };
	    c3_chart_internal_fn.getAreaBaseValue = function () {
	        return 0;
	    };
	    c3_chart_internal_fn.generateGetAreaPoints = function (areaIndices, isSub) {
	        // partial duplication of generateGetBarPoints
	        var $$ = this,
	            config = $$.config,
	            areaTargetsNum = areaIndices.__max__ + 1,
	            x = $$.getShapeX(0, areaTargetsNum, areaIndices, !!isSub),
	            y = $$.getShapeY(!!isSub),
	            areaOffset = $$.getShapeOffset($$.isAreaType, areaIndices, !!isSub),
	            yScale = isSub ? $$.getSubYScale : $$.getYScale;
	        return function (d, i) {
	            var y0 = yScale.call($$, d.id)(0),
	                offset = areaOffset(d, i) || y0,
	                // offset is for stacked area chart
	            posX = x(d),
	                posY = y(d);
	            // fix posY not to overflow opposite quadrant
	            if (config.axis_rotated) {
	                if (0 < d.value && posY < y0 || d.value < 0 && y0 < posY) {
	                    posY = y0;
	                }
	            }
	            // 1 point that marks the area position
	            return [[posX, offset], [posX, posY - (y0 - offset)], [posX, posY - (y0 - offset)], // needed for compatibility
	            [posX, offset] // needed for compatibility
	            ];
	        };
	    };
	
	    c3_chart_internal_fn.updateCircle = function () {
	        var $$ = this;
	        $$.mainCircle = $$.main.selectAll('.' + CLASS.circles).selectAll('.' + CLASS.circle).data($$.lineOrScatterData.bind($$));
	        $$.mainCircle.enter().append("circle").attr("class", $$.classCircle.bind($$)).attr("r", $$.pointR.bind($$)).style("fill", $$.color);
	        $$.mainCircle.style("opacity", $$.initialOpacityForCircle.bind($$));
	        $$.mainCircle.exit().remove();
	    };
	    c3_chart_internal_fn.redrawCircle = function (cx, cy, withTransition) {
	        var selectedCircles = this.main.selectAll('.' + CLASS.selectedCircle);
	        return [(withTransition ? this.mainCircle.transition(Math.random().toString()) : this.mainCircle).style('opacity', this.opacityForCircle.bind(this)).style("fill", this.color).attr("cx", cx).attr("cy", cy), (withTransition ? selectedCircles.transition(Math.random().toString()) : selectedCircles).attr("cx", cx).attr("cy", cy)];
	    };
	    c3_chart_internal_fn.circleX = function (d) {
	        return d.x || d.x === 0 ? this.x(d.x) : null;
	    };
	    c3_chart_internal_fn.updateCircleY = function () {
	        var $$ = this,
	            lineIndices,
	            getPoints;
	        if ($$.config.data_groups.length > 0) {
	            lineIndices = $$.getShapeIndices($$.isLineType), getPoints = $$.generateGetLinePoints(lineIndices);
	            $$.circleY = function (d, i) {
	                return getPoints(d, i)[0][1];
	            };
	        } else {
	            $$.circleY = function (d) {
	                return $$.getYScale(d.id)(d.value);
	            };
	        }
	    };
	    c3_chart_internal_fn.getCircles = function (i, id) {
	        var $$ = this;
	        return (id ? $$.main.selectAll('.' + CLASS.circles + $$.getTargetSelectorSuffix(id)) : $$.main).selectAll('.' + CLASS.circle + (isValue(i) ? '-' + i : ''));
	    };
	    c3_chart_internal_fn.expandCircles = function (i, id, reset) {
	        var $$ = this,
	            r = $$.pointExpandedR.bind($$);
	        if (reset) {
	            $$.unexpandCircles();
	        }
	        $$.getCircles(i, id).classed(CLASS.EXPANDED, true).attr('r', r);
	    };
	    c3_chart_internal_fn.unexpandCircles = function (i) {
	        var $$ = this,
	            r = $$.pointR.bind($$);
	        $$.getCircles(i).filter(function () {
	            return $$.d3.select(this).classed(CLASS.EXPANDED);
	        }).classed(CLASS.EXPANDED, false).attr('r', r);
	    };
	    c3_chart_internal_fn.pointR = function (d) {
	        var $$ = this,
	            config = $$.config;
	        return $$.isStepType(d) ? 0 : isFunction(config.point_r) ? config.point_r(d) : config.point_r;
	    };
	    c3_chart_internal_fn.pointExpandedR = function (d) {
	        var $$ = this,
	            config = $$.config;
	        if (config.point_focus_expand_enabled) {
	            return isFunction(config.point_focus_expand_r) ? config.point_focus_expand_r(d) : config.point_focus_expand_r ? config.point_focus_expand_r : $$.pointR(d) * 1.75;
	        } else {
	            return $$.pointR(d);
	        }
	    };
	    c3_chart_internal_fn.pointSelectR = function (d) {
	        var $$ = this,
	            config = $$.config;
	        return isFunction(config.point_select_r) ? config.point_select_r(d) : config.point_select_r ? config.point_select_r : $$.pointR(d) * 4;
	    };
	    c3_chart_internal_fn.isWithinCircle = function (that, r) {
	        var d3 = this.d3,
	            mouse = d3.mouse(that),
	            d3_this = d3.select(that),
	            cx = +d3_this.attr("cx"),
	            cy = +d3_this.attr("cy");
	        return Math.sqrt(Math.pow(cx - mouse[0], 2) + Math.pow(cy - mouse[1], 2)) < r;
	    };
	    c3_chart_internal_fn.isWithinStep = function (that, y) {
	        return Math.abs(y - this.d3.mouse(that)[1]) < 30;
	    };
	
	    c3_chart_internal_fn.getCurrentWidth = function () {
	        var $$ = this,
	            config = $$.config;
	        return config.size_width ? config.size_width : $$.getParentWidth();
	    };
	    c3_chart_internal_fn.getCurrentHeight = function () {
	        var $$ = this,
	            config = $$.config,
	            h = config.size_height ? config.size_height : $$.getParentHeight();
	        return h > 0 ? h : 320 / ($$.hasType('gauge') && !config.gauge_fullCircle ? 2 : 1);
	    };
	    c3_chart_internal_fn.getCurrentPaddingTop = function () {
	        var $$ = this,
	            config = $$.config,
	            padding = isValue(config.padding_top) ? config.padding_top : 0;
	        if ($$.title && $$.title.node()) {
	            padding += $$.getTitlePadding();
	        }
	        return padding;
	    };
	    c3_chart_internal_fn.getCurrentPaddingBottom = function () {
	        var config = this.config;
	        return isValue(config.padding_bottom) ? config.padding_bottom : 0;
	    };
	    c3_chart_internal_fn.getCurrentPaddingLeft = function (withoutRecompute) {
	        var $$ = this,
	            config = $$.config;
	        if (isValue(config.padding_left)) {
	            return config.padding_left;
	        } else if (config.axis_rotated) {
	            return !config.axis_x_show || config.axis_x_inner ? 1 : Math.max(ceil10($$.getAxisWidthByAxisId('x', withoutRecompute)), 40);
	        } else if (!config.axis_y_show || config.axis_y_inner) {
	            // && !config.axis_rotated
	            return $$.axis.getYAxisLabelPosition().isOuter ? 30 : 1;
	        } else {
	            return ceil10($$.getAxisWidthByAxisId('y', withoutRecompute));
	        }
	    };
	    c3_chart_internal_fn.getCurrentPaddingRight = function () {
	        var $$ = this,
	            config = $$.config,
	            defaultPadding = 10,
	            legendWidthOnRight = $$.isLegendRight ? $$.getLegendWidth() + 20 : 0;
	        if (isValue(config.padding_right)) {
	            return config.padding_right + 1; // 1 is needed not to hide tick line
	        } else if (config.axis_rotated) {
	            return defaultPadding + legendWidthOnRight;
	        } else if (!config.axis_y2_show || config.axis_y2_inner) {
	            // && !config.axis_rotated
	            return 2 + legendWidthOnRight + ($$.axis.getY2AxisLabelPosition().isOuter ? 20 : 0);
	        } else {
	            return ceil10($$.getAxisWidthByAxisId('y2')) + legendWidthOnRight;
	        }
	    };
	
	    c3_chart_internal_fn.getParentRectValue = function (key) {
	        var parent = this.selectChart.node(),
	            v;
	        while (parent && parent.tagName !== 'BODY') {
	            try {
	                v = parent.getBoundingClientRect()[key];
	            } catch (e) {
	                if (key === 'width') {
	                    // In IE in certain cases getBoundingClientRect
	                    // will cause an "unspecified error"
	                    v = parent.offsetWidth;
	                }
	            }
	            if (v) {
	                break;
	            }
	            parent = parent.parentNode;
	        }
	        return v;
	    };
	    c3_chart_internal_fn.getParentWidth = function () {
	        return this.getParentRectValue('width');
	    };
	    c3_chart_internal_fn.getParentHeight = function () {
	        var h = this.selectChart.style('height');
	        return h.indexOf('px') > 0 ? +h.replace('px', '') : 0;
	    };
	
	    c3_chart_internal_fn.getSvgLeft = function (withoutRecompute) {
	        var $$ = this,
	            config = $$.config,
	            hasLeftAxisRect = config.axis_rotated || !config.axis_rotated && !config.axis_y_inner,
	            leftAxisClass = config.axis_rotated ? CLASS.axisX : CLASS.axisY,
	            leftAxis = $$.main.select('.' + leftAxisClass).node(),
	            svgRect = leftAxis && hasLeftAxisRect ? leftAxis.getBoundingClientRect() : { right: 0 },
	            chartRect = $$.selectChart.node().getBoundingClientRect(),
	            hasArc = $$.hasArcType(),
	            svgLeft = svgRect.right - chartRect.left - (hasArc ? 0 : $$.getCurrentPaddingLeft(withoutRecompute));
	        return svgLeft > 0 ? svgLeft : 0;
	    };
	
	    c3_chart_internal_fn.getAxisWidthByAxisId = function (id, withoutRecompute) {
	        var $$ = this,
	            position = $$.axis.getLabelPositionById(id);
	        return $$.axis.getMaxTickWidth(id, withoutRecompute) + (position.isInner ? 20 : 40);
	    };
	    c3_chart_internal_fn.getHorizontalAxisHeight = function (axisId) {
	        var $$ = this,
	            config = $$.config,
	            h = 30;
	        if (axisId === 'x' && !config.axis_x_show) {
	            return 8;
	        }
	        if (axisId === 'x' && config.axis_x_height) {
	            return config.axis_x_height;
	        }
	        if (axisId === 'y' && !config.axis_y_show) {
	            return config.legend_show && !$$.isLegendRight && !$$.isLegendInset ? 10 : 1;
	        }
	        if (axisId === 'y2' && !config.axis_y2_show) {
	            return $$.rotated_padding_top;
	        }
	        // Calculate x axis height when tick rotated
	        if (axisId === 'x' && !config.axis_rotated && config.axis_x_tick_rotate) {
	            h = 30 + $$.axis.getMaxTickWidth(axisId) * Math.cos(Math.PI * (90 - config.axis_x_tick_rotate) / 180);
	        }
	        // Calculate y axis height when tick rotated
	        if (axisId === 'y' && config.axis_rotated && config.axis_y_tick_rotate) {
	            h = 30 + $$.axis.getMaxTickWidth(axisId) * Math.cos(Math.PI * (90 - config.axis_y_tick_rotate) / 180);
	        }
	        return h + ($$.axis.getLabelPositionById(axisId).isInner ? 0 : 10) + (axisId === 'y2' ? -10 : 0);
	    };
	
	    c3_chart_internal_fn.getEventRectWidth = function () {
	        return Math.max(0, this.xAxis.tickInterval());
	    };
	
	    c3_chart_internal_fn.initBrush = function () {
	        var $$ = this,
	            d3 = $$.d3;
	        $$.brush = d3.svg.brush().on("brush", function () {
	            $$.redrawForBrush();
	        });
	        $$.brush.update = function () {
	            if ($$.context) {
	                $$.context.select('.' + CLASS.brush).call(this);
	            }
	            return this;
	        };
	        $$.brush.scale = function (scale) {
	            return $$.config.axis_rotated ? this.y(scale) : this.x(scale);
	        };
	    };
	    c3_chart_internal_fn.initSubchart = function () {
	        var $$ = this,
	            config = $$.config,
	            context = $$.context = $$.svg.append("g").attr("transform", $$.getTranslate('context')),
	            visibility = config.subchart_show ? 'visible' : 'hidden';
	
	        context.style('visibility', visibility);
	
	        // Define g for chart area
	        context.append('g').attr("clip-path", $$.clipPathForSubchart).attr('class', CLASS.chart);
	
	        // Define g for bar chart area
	        context.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartBars);
	
	        // Define g for line chart area
	        context.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartLines);
	
	        // Add extent rect for Brush
	        context.append("g").attr("clip-path", $$.clipPath).attr("class", CLASS.brush).call($$.brush);
	
	        // ATTENTION: This must be called AFTER chart added
	        // Add Axis
	        $$.axes.subx = context.append("g").attr("class", CLASS.axisX).attr("transform", $$.getTranslate('subx')).attr("clip-path", config.axis_rotated ? "" : $$.clipPathForXAxis).style("visibility", config.subchart_axis_x_show ? visibility : 'hidden');
	    };
	    c3_chart_internal_fn.updateTargetsForSubchart = function (targets) {
	        var $$ = this,
	            context = $$.context,
	            config = $$.config,
	            contextLineEnter,
	            contextLineUpdate,
	            contextBarEnter,
	            contextBarUpdate,
	            classChartBar = $$.classChartBar.bind($$),
	            classBars = $$.classBars.bind($$),
	            classChartLine = $$.classChartLine.bind($$),
	            classLines = $$.classLines.bind($$),
	            classAreas = $$.classAreas.bind($$);
	
	        if (config.subchart_show) {
	            //-- Bar --//
	            contextBarUpdate = context.select('.' + CLASS.chartBars).selectAll('.' + CLASS.chartBar).data(targets).attr('class', classChartBar);
	            contextBarEnter = contextBarUpdate.enter().append('g').style('opacity', 0).attr('class', classChartBar);
	            // Bars for each data
	            contextBarEnter.append('g').attr("class", classBars);
	
	            //-- Line --//
	            contextLineUpdate = context.select('.' + CLASS.chartLines).selectAll('.' + CLASS.chartLine).data(targets).attr('class', classChartLine);
	            contextLineEnter = contextLineUpdate.enter().append('g').style('opacity', 0).attr('class', classChartLine);
	            // Lines for each data
	            contextLineEnter.append("g").attr("class", classLines);
	            // Area
	            contextLineEnter.append("g").attr("class", classAreas);
	
	            //-- Brush --//
	            context.selectAll('.' + CLASS.brush + ' rect').attr(config.axis_rotated ? "width" : "height", config.axis_rotated ? $$.width2 : $$.height2);
	        }
	    };
	    c3_chart_internal_fn.updateBarForSubchart = function (durationForExit) {
	        var $$ = this;
	        $$.contextBar = $$.context.selectAll('.' + CLASS.bars).selectAll('.' + CLASS.bar).data($$.barData.bind($$));
	        $$.contextBar.enter().append('path').attr("class", $$.classBar.bind($$)).style("stroke", 'none').style("fill", $$.color);
	        $$.contextBar.style("opacity", $$.initialOpacity.bind($$));
	        $$.contextBar.exit().transition().duration(durationForExit).style('opacity', 0).remove();
	    };
	    c3_chart_internal_fn.redrawBarForSubchart = function (drawBarOnSub, withTransition, duration) {
	        (withTransition ? this.contextBar.transition(Math.random().toString()).duration(duration) : this.contextBar).attr('d', drawBarOnSub).style('opacity', 1);
	    };
	    c3_chart_internal_fn.updateLineForSubchart = function (durationForExit) {
	        var $$ = this;
	        $$.contextLine = $$.context.selectAll('.' + CLASS.lines).selectAll('.' + CLASS.line).data($$.lineData.bind($$));
	        $$.contextLine.enter().append('path').attr('class', $$.classLine.bind($$)).style('stroke', $$.color);
	        $$.contextLine.style("opacity", $$.initialOpacity.bind($$));
	        $$.contextLine.exit().transition().duration(durationForExit).style('opacity', 0).remove();
	    };
	    c3_chart_internal_fn.redrawLineForSubchart = function (drawLineOnSub, withTransition, duration) {
	        (withTransition ? this.contextLine.transition(Math.random().toString()).duration(duration) : this.contextLine).attr("d", drawLineOnSub).style('opacity', 1);
	    };
	    c3_chart_internal_fn.updateAreaForSubchart = function (durationForExit) {
	        var $$ = this,
	            d3 = $$.d3;
	        $$.contextArea = $$.context.selectAll('.' + CLASS.areas).selectAll('.' + CLASS.area).data($$.lineData.bind($$));
	        $$.contextArea.enter().append('path').attr("class", $$.classArea.bind($$)).style("fill", $$.color).style("opacity", function () {
	            $$.orgAreaOpacity = +d3.select(this).style('opacity');return 0;
	        });
	        $$.contextArea.style("opacity", 0);
	        $$.contextArea.exit().transition().duration(durationForExit).style('opacity', 0).remove();
	    };
	    c3_chart_internal_fn.redrawAreaForSubchart = function (drawAreaOnSub, withTransition, duration) {
	        (withTransition ? this.contextArea.transition(Math.random().toString()).duration(duration) : this.contextArea).attr("d", drawAreaOnSub).style("fill", this.color).style("opacity", this.orgAreaOpacity);
	    };
	    c3_chart_internal_fn.redrawSubchart = function (withSubchart, transitions, duration, durationForExit, areaIndices, barIndices, lineIndices) {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config,
	            drawAreaOnSub,
	            drawBarOnSub,
	            drawLineOnSub;
	
	        $$.context.style('visibility', config.subchart_show ? 'visible' : 'hidden');
	
	        // subchart
	        if (config.subchart_show) {
	            // reflect main chart to extent on subchart if zoomed
	            if (d3.event && d3.event.type === 'zoom') {
	                $$.brush.extent($$.x.orgDomain()).update();
	            }
	            // update subchart elements if needed
	            if (withSubchart) {
	
	                // extent rect
	                if (!$$.brush.empty()) {
	                    $$.brush.extent($$.x.orgDomain()).update();
	                }
	                // setup drawer - MEMO: this must be called after axis updated
	                drawAreaOnSub = $$.generateDrawArea(areaIndices, true);
	                drawBarOnSub = $$.generateDrawBar(barIndices, true);
	                drawLineOnSub = $$.generateDrawLine(lineIndices, true);
	
	                $$.updateBarForSubchart(duration);
	                $$.updateLineForSubchart(duration);
	                $$.updateAreaForSubchart(duration);
	
	                $$.redrawBarForSubchart(drawBarOnSub, duration, duration);
	                $$.redrawLineForSubchart(drawLineOnSub, duration, duration);
	                $$.redrawAreaForSubchart(drawAreaOnSub, duration, duration);
	            }
	        }
	    };
	    c3_chart_internal_fn.redrawForBrush = function () {
	        var $$ = this,
	            x = $$.x;
	        $$.redraw({
	            withTransition: false,
	            withY: $$.config.zoom_rescale,
	            withSubchart: false,
	            withUpdateXDomain: true,
	            withDimension: false
	        });
	        $$.config.subchart_onbrush.call($$.api, x.orgDomain());
	    };
	    c3_chart_internal_fn.transformContext = function (withTransition, transitions) {
	        var $$ = this,
	            subXAxis;
	        if (transitions && transitions.axisSubX) {
	            subXAxis = transitions.axisSubX;
	        } else {
	            subXAxis = $$.context.select('.' + CLASS.axisX);
	            if (withTransition) {
	                subXAxis = subXAxis.transition();
	            }
	        }
	        $$.context.attr("transform", $$.getTranslate('context'));
	        subXAxis.attr("transform", $$.getTranslate('subx'));
	    };
	    c3_chart_internal_fn.getDefaultExtent = function () {
	        var $$ = this,
	            config = $$.config,
	            extent = isFunction(config.axis_x_extent) ? config.axis_x_extent($$.getXDomain($$.data.targets)) : config.axis_x_extent;
	        if ($$.isTimeSeries()) {
	            extent = [$$.parseDate(extent[0]), $$.parseDate(extent[1])];
	        }
	        return extent;
	    };
	
	    c3_chart_internal_fn.initText = function () {
	        var $$ = this;
	        $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartTexts);
	        $$.mainText = $$.d3.selectAll([]);
	    };
	    c3_chart_internal_fn.updateTargetsForText = function (targets) {
	        var $$ = this,
	            mainTextUpdate,
	            mainTextEnter,
	            classChartText = $$.classChartText.bind($$),
	            classTexts = $$.classTexts.bind($$),
	            classFocus = $$.classFocus.bind($$);
	        mainTextUpdate = $$.main.select('.' + CLASS.chartTexts).selectAll('.' + CLASS.chartText).data(targets).attr('class', function (d) {
	            return classChartText(d) + classFocus(d);
	        });
	        mainTextEnter = mainTextUpdate.enter().append('g').attr('class', classChartText).style('opacity', 0).style("pointer-events", "none");
	        mainTextEnter.append('g').attr('class', classTexts);
	    };
	    c3_chart_internal_fn.updateText = function (durationForExit) {
	        var $$ = this,
	            config = $$.config,
	            barOrLineData = $$.barOrLineData.bind($$),
	            classText = $$.classText.bind($$);
	        $$.mainText = $$.main.selectAll('.' + CLASS.texts).selectAll('.' + CLASS.text).data(barOrLineData);
	        $$.mainText.enter().append('text').attr("class", classText).attr('text-anchor', function (d) {
	            return config.axis_rotated ? d.value < 0 ? 'end' : 'start' : 'middle';
	        }).style("stroke", 'none').style("fill", function (d) {
	            return $$.color(d);
	        }).style("fill-opacity", 0);
	        $$.mainText.text(function (d, i, j) {
	            return $$.dataLabelFormat(d.id)(d.value, d.id, i, j);
	        });
	        $$.mainText.exit().transition().duration(durationForExit).style('fill-opacity', 0).remove();
	    };
	    c3_chart_internal_fn.redrawText = function (xForText, yForText, forFlow, withTransition) {
	        return [(withTransition ? this.mainText.transition() : this.mainText).attr('x', xForText).attr('y', yForText).style("fill", this.color).style("fill-opacity", forFlow ? 0 : this.opacityForText.bind(this))];
	    };
	    c3_chart_internal_fn.getTextRect = function (text, cls, element) {
	        var dummy = this.d3.select('body').append('div').classed('c3', true),
	            svg = dummy.append("svg").style('visibility', 'hidden').style('position', 'fixed').style('top', 0).style('left', 0),
	            font = this.d3.select(element).style('font'),
	            rect;
	        svg.selectAll('.dummy').data([text]).enter().append('text').classed(cls ? cls : "", true).style('font', font).text(text).each(function () {
	            rect = this.getBoundingClientRect();
	        });
	        dummy.remove();
	        return rect;
	    };
	    c3_chart_internal_fn.generateXYForText = function (areaIndices, barIndices, lineIndices, forX) {
	        var $$ = this,
	            getAreaPoints = $$.generateGetAreaPoints(areaIndices, false),
	            getBarPoints = $$.generateGetBarPoints(barIndices, false),
	            getLinePoints = $$.generateGetLinePoints(lineIndices, false),
	            getter = forX ? $$.getXForText : $$.getYForText;
	        return function (d, i) {
	            var getPoints = $$.isAreaType(d) ? getAreaPoints : $$.isBarType(d) ? getBarPoints : getLinePoints;
	            return getter.call($$, getPoints(d, i), d, this);
	        };
	    };
	    c3_chart_internal_fn.getXForText = function (points, d, textElement) {
	        var $$ = this,
	            box = textElement.getBoundingClientRect(),
	            xPos,
	            padding;
	        if ($$.config.axis_rotated) {
	            padding = $$.isBarType(d) ? 4 : 6;
	            xPos = points[2][1] + padding * (d.value < 0 ? -1 : 1);
	        } else {
	            xPos = $$.hasType('bar') ? (points[2][0] + points[0][0]) / 2 : points[0][0];
	        }
	        // show labels regardless of the domain if value is null
	        if (d.value === null) {
	            if (xPos > $$.width) {
	                xPos = $$.width - box.width;
	            } else if (xPos < 0) {
	                xPos = 4;
	            }
	        }
	        return xPos;
	    };
	    c3_chart_internal_fn.getYForText = function (points, d, textElement) {
	        var $$ = this,
	            box = textElement.getBoundingClientRect(),
	            yPos;
	        if ($$.config.axis_rotated) {
	            yPos = (points[0][0] + points[2][0] + box.height * 0.6) / 2;
	        } else {
	            yPos = points[2][1];
	            if (d.value < 0 || d.value === 0 && !$$.hasPositiveValue) {
	                yPos += box.height;
	                if ($$.isBarType(d) && $$.isSafari()) {
	                    yPos -= 3;
	                } else if (!$$.isBarType(d) && $$.isChrome()) {
	                    yPos += 3;
	                }
	            } else {
	                yPos += $$.isBarType(d) ? -3 : -6;
	            }
	        }
	        // show labels regardless of the domain if value is null
	        if (d.value === null && !$$.config.axis_rotated) {
	            if (yPos < box.height) {
	                yPos = box.height;
	            } else if (yPos > this.height) {
	                yPos = this.height - 4;
	            }
	        }
	        return yPos;
	    };
	
	    c3_chart_internal_fn.initTitle = function () {
	        var $$ = this;
	        $$.title = $$.svg.append("text").text($$.config.title_text).attr("class", $$.CLASS.title);
	    };
	    c3_chart_internal_fn.redrawTitle = function () {
	        var $$ = this;
	        $$.title.attr("x", $$.xForTitle.bind($$)).attr("y", $$.yForTitle.bind($$));
	    };
	    c3_chart_internal_fn.xForTitle = function () {
	        var $$ = this,
	            config = $$.config,
	            position = config.title_position || 'left',
	            x;
	        if (position.indexOf('right') >= 0) {
	            x = $$.currentWidth - $$.getTextRect($$.title.node().textContent, $$.CLASS.title, $$.title.node()).width - config.title_padding.right;
	        } else if (position.indexOf('center') >= 0) {
	            x = ($$.currentWidth - $$.getTextRect($$.title.node().textContent, $$.CLASS.title, $$.title.node()).width) / 2;
	        } else {
	            // left
	            x = config.title_padding.left;
	        }
	        return x;
	    };
	    c3_chart_internal_fn.yForTitle = function () {
	        var $$ = this;
	        return $$.config.title_padding.top + $$.getTextRect($$.title.node().textContent, $$.CLASS.title, $$.title.node()).height;
	    };
	    c3_chart_internal_fn.getTitlePadding = function () {
	        var $$ = this;
	        return $$.yForTitle() + $$.config.title_padding.bottom;
	    };
	
	    c3_chart_internal_fn.initTooltip = function () {
	        var $$ = this,
	            config = $$.config,
	            i;
	        $$.tooltip = $$.selectChart.style("position", "relative").append("div").attr('class', CLASS.tooltipContainer).style("position", "absolute").style("pointer-events", "none").style("display", "none");
	        // Show tooltip if needed
	        if (config.tooltip_init_show) {
	            if ($$.isTimeSeries() && isString(config.tooltip_init_x)) {
	                config.tooltip_init_x = $$.parseDate(config.tooltip_init_x);
	                for (i = 0; i < $$.data.targets[0].values.length; i++) {
	                    if ($$.data.targets[0].values[i].x - config.tooltip_init_x === 0) {
	                        break;
	                    }
	                }
	                config.tooltip_init_x = i;
	            }
	            $$.tooltip.html(config.tooltip_contents.call($$, $$.data.targets.map(function (d) {
	                return $$.addName(d.values[config.tooltip_init_x]);
	            }), $$.axis.getXAxisTickFormat(), $$.getYFormat($$.hasArcType()), $$.color));
	            $$.tooltip.style("top", config.tooltip_init_position.top).style("left", config.tooltip_init_position.left).style("display", "block");
	        }
	    };
	    c3_chart_internal_fn.getTooltipSortFunction = function () {
	        var $$ = this,
	            config = $$.config;
	
	        if (config.data_groups.length === 0 || config.tooltip_order !== undefined) {
	            // if data are not grouped or if an order is specified
	            // for the tooltip values we sort them by their values
	
	            var order = config.tooltip_order;
	            if (order === undefined) {
	                order = config.data_order;
	            }
	
	            var valueOf = function valueOf(obj) {
	                return obj ? obj.value : null;
	            };
	
	            // if data are not grouped, we sort them by their value
	            if (isString(order) && order.toLowerCase() === 'asc') {
	                return function (a, b) {
	                    return valueOf(a) - valueOf(b);
	                };
	            } else if (isString(order) && order.toLowerCase() === 'desc') {
	                return function (a, b) {
	                    return valueOf(b) - valueOf(a);
	                };
	            } else if (isFunction(order)) {
	
	                // if the function is from data_order we need
	                // to wrap the returned function in order to format
	                // the sorted value to the expected format
	
	                var sortFunction = order;
	
	                if (config.tooltip_order === undefined) {
	                    sortFunction = function sortFunction(a, b) {
	                        return order(a ? {
	                            id: a.id,
	                            values: [a]
	                        } : null, b ? {
	                            id: b.id,
	                            values: [b]
	                        } : null);
	                    };
	                }
	
	                return sortFunction;
	            } else if (isArray(order)) {
	                return function (a, b) {
	                    return order.indexOf(a.id) - order.indexOf(b.id);
	                };
	            }
	        } else {
	            // if data are grouped, we follow the order of grouped targets
	            var ids = $$.orderTargets($$.data.targets).map(function (i) {
	                return i.id;
	            });
	
	            // if it was either asc or desc we need to invert the order
	            // returned by orderTargets
	            if ($$.isOrderAsc() || $$.isOrderDesc()) {
	                ids = ids.reverse();
	            }
	
	            return function (a, b) {
	                return ids.indexOf(a.id) - ids.indexOf(b.id);
	            };
	        }
	    };
	    c3_chart_internal_fn.getTooltipContent = function (d, defaultTitleFormat, defaultValueFormat, color) {
	        var $$ = this,
	            config = $$.config,
	            titleFormat = config.tooltip_format_title || defaultTitleFormat,
	            nameFormat = config.tooltip_format_name || function (name) {
	            return name;
	        },
	            valueFormat = config.tooltip_format_value || defaultValueFormat,
	            text,
	            i,
	            title,
	            value,
	            name,
	            bgcolor;
	
	        var tooltipSortFunction = this.getTooltipSortFunction();
	        if (tooltipSortFunction) {
	            d.sort(tooltipSortFunction);
	        }
	
	        for (i = 0; i < d.length; i++) {
	            if (!(d[i] && (d[i].value || d[i].value === 0))) {
	                continue;
	            }
	
	            if (!text) {
	                title = sanitise(titleFormat ? titleFormat(d[i].x) : d[i].x);
	                text = "<table class='" + $$.CLASS.tooltip + "'>" + (title || title === 0 ? "<tr><th colspan='2'>" + title + "</th></tr>" : "");
	            }
	
	            value = sanitise(valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index, d));
	            if (value !== undefined) {
	                // Skip elements when their name is set to null
	                if (d[i].name === null) {
	                    continue;
	                }
	                name = sanitise(nameFormat(d[i].name, d[i].ratio, d[i].id, d[i].index));
	                bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : color(d[i].id);
	
	                text += "<tr class='" + $$.CLASS.tooltipName + "-" + $$.getTargetSelectorSuffix(d[i].id) + "'>";
	                text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + name + "</td>";
	                text += "<td class='value'>" + value + "</td>";
	                text += "</tr>";
	            }
	        }
	        return text + "</table>";
	    };
	    c3_chart_internal_fn.tooltipPosition = function (dataToShow, tWidth, tHeight, element) {
	        var $$ = this,
	            config = $$.config,
	            d3 = $$.d3;
	        var svgLeft, tooltipLeft, tooltipRight, tooltipTop, chartRight;
	        var forArc = $$.hasArcType(),
	            mouse = d3.mouse(element);
	        // Determin tooltip position
	        if (forArc) {
	            tooltipLeft = ($$.width - ($$.isLegendRight ? $$.getLegendWidth() : 0)) / 2 + mouse[0];
	            tooltipTop = ($$.hasType('gauge') ? $$.height : $$.height / 2) + mouse[1] + 20;
	        } else {
	            svgLeft = $$.getSvgLeft(true);
	            if (config.axis_rotated) {
	                tooltipLeft = svgLeft + mouse[0] + 100;
	                tooltipRight = tooltipLeft + tWidth;
	                chartRight = $$.currentWidth - $$.getCurrentPaddingRight();
	                tooltipTop = $$.x(dataToShow[0].x) + 20;
	            } else {
	                tooltipLeft = svgLeft + $$.getCurrentPaddingLeft(true) + $$.x(dataToShow[0].x) + 20;
	                tooltipRight = tooltipLeft + tWidth;
	                chartRight = svgLeft + $$.currentWidth - $$.getCurrentPaddingRight();
	                tooltipTop = mouse[1] + 15;
	            }
	
	            if (tooltipRight > chartRight) {
	                // 20 is needed for Firefox to keep tooltip width
	                tooltipLeft -= tooltipRight - chartRight + 20;
	            }
	            if (tooltipTop + tHeight > $$.currentHeight) {
	                tooltipTop -= tHeight + 30;
	            }
	        }
	        if (tooltipTop < 0) {
	            tooltipTop = 0;
	        }
	        return { top: tooltipTop, left: tooltipLeft };
	    };
	    c3_chart_internal_fn.showTooltip = function (selectedData, element) {
	        var $$ = this,
	            config = $$.config;
	        var tWidth, tHeight, position;
	        var forArc = $$.hasArcType(),
	            dataToShow = selectedData.filter(function (d) {
	            return d && isValue(d.value);
	        }),
	            positionFunction = config.tooltip_position || c3_chart_internal_fn.tooltipPosition;
	        if (dataToShow.length === 0 || !config.tooltip_show) {
	            return;
	        }
	        $$.tooltip.html(config.tooltip_contents.call($$, selectedData, $$.axis.getXAxisTickFormat(), $$.getYFormat(forArc), $$.color)).style("display", "block");
	
	        // Get tooltip dimensions
	        tWidth = $$.tooltip.property('offsetWidth');
	        tHeight = $$.tooltip.property('offsetHeight');
	
	        position = positionFunction.call(this, dataToShow, tWidth, tHeight, element);
	        // Set tooltip
	        $$.tooltip.style("top", position.top + "px").style("left", position.left + 'px');
	    };
	    c3_chart_internal_fn.hideTooltip = function () {
	        this.tooltip.style("display", "none");
	    };
	
	    c3_chart_internal_fn.setTargetType = function (targetIds, type) {
	        var $$ = this,
	            config = $$.config;
	        $$.mapToTargetIds(targetIds).forEach(function (id) {
	            $$.withoutFadeIn[id] = type === config.data_types[id];
	            config.data_types[id] = type;
	        });
	        if (!targetIds) {
	            config.data_type = type;
	        }
	    };
	    c3_chart_internal_fn.hasType = function (type, targets) {
	        var $$ = this,
	            types = $$.config.data_types,
	            has = false;
	        targets = targets || $$.data.targets;
	        if (targets && targets.length) {
	            targets.forEach(function (target) {
	                var t = types[target.id];
	                if (t && t.indexOf(type) >= 0 || !t && type === 'line') {
	                    has = true;
	                }
	            });
	        } else if (Object.keys(types).length) {
	            Object.keys(types).forEach(function (id) {
	                if (types[id] === type) {
	                    has = true;
	                }
	            });
	        } else {
	            has = $$.config.data_type === type;
	        }
	        return has;
	    };
	    c3_chart_internal_fn.hasArcType = function (targets) {
	        return this.hasType('pie', targets) || this.hasType('donut', targets) || this.hasType('gauge', targets);
	    };
	    c3_chart_internal_fn.isLineType = function (d) {
	        var config = this.config,
	            id = isString(d) ? d : d.id;
	        return !config.data_types[id] || ['line', 'spline', 'area', 'area-spline', 'step', 'area-step'].indexOf(config.data_types[id]) >= 0;
	    };
	    c3_chart_internal_fn.isStepType = function (d) {
	        var id = isString(d) ? d : d.id;
	        return ['step', 'area-step'].indexOf(this.config.data_types[id]) >= 0;
	    };
	    c3_chart_internal_fn.isSplineType = function (d) {
	        var id = isString(d) ? d : d.id;
	        return ['spline', 'area-spline'].indexOf(this.config.data_types[id]) >= 0;
	    };
	    c3_chart_internal_fn.isAreaType = function (d) {
	        var id = isString(d) ? d : d.id;
	        return ['area', 'area-spline', 'area-step'].indexOf(this.config.data_types[id]) >= 0;
	    };
	    c3_chart_internal_fn.isBarType = function (d) {
	        var id = isString(d) ? d : d.id;
	        return this.config.data_types[id] === 'bar';
	    };
	    c3_chart_internal_fn.isScatterType = function (d) {
	        var id = isString(d) ? d : d.id;
	        return this.config.data_types[id] === 'scatter';
	    };
	    c3_chart_internal_fn.isPieType = function (d) {
	        var id = isString(d) ? d : d.id;
	        return this.config.data_types[id] === 'pie';
	    };
	    c3_chart_internal_fn.isGaugeType = function (d) {
	        var id = isString(d) ? d : d.id;
	        return this.config.data_types[id] === 'gauge';
	    };
	    c3_chart_internal_fn.isDonutType = function (d) {
	        var id = isString(d) ? d : d.id;
	        return this.config.data_types[id] === 'donut';
	    };
	    c3_chart_internal_fn.isArcType = function (d) {
	        return this.isPieType(d) || this.isDonutType(d) || this.isGaugeType(d);
	    };
	    c3_chart_internal_fn.lineData = function (d) {
	        return this.isLineType(d) ? [d] : [];
	    };
	    c3_chart_internal_fn.arcData = function (d) {
	        return this.isArcType(d.data) ? [d] : [];
	    };
	    /* not used
	     function scatterData(d) {
	     return isScatterType(d) ? d.values : [];
	     }
	     */
	    c3_chart_internal_fn.barData = function (d) {
	        return this.isBarType(d) ? d.values : [];
	    };
	    c3_chart_internal_fn.lineOrScatterData = function (d) {
	        return this.isLineType(d) || this.isScatterType(d) ? d.values : [];
	    };
	    c3_chart_internal_fn.barOrLineData = function (d) {
	        return this.isBarType(d) || this.isLineType(d) ? d.values : [];
	    };
	    c3_chart_internal_fn.isInterpolationType = function (type) {
	        return ['linear', 'linear-closed', 'basis', 'basis-open', 'basis-closed', 'bundle', 'cardinal', 'cardinal-open', 'cardinal-closed', 'monotone'].indexOf(type) >= 0;
	    };
	
	    c3_chart_internal_fn.isSafari = function () {
	        var ua = window.navigator.userAgent;
	        return ua.indexOf('Safari') >= 0 && ua.indexOf('Chrome') < 0;
	    };
	    c3_chart_internal_fn.isChrome = function () {
	        var ua = window.navigator.userAgent;
	        return ua.indexOf('Chrome') >= 0;
	    };
	
	    c3_chart_internal_fn.initZoom = function () {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config,
	            startEvent;
	
	        $$.zoom = d3.behavior.zoom().on("zoomstart", function () {
	            startEvent = d3.event.sourceEvent;
	            $$.zoom.altDomain = d3.event.sourceEvent.altKey ? $$.x.orgDomain() : null;
	            config.zoom_onzoomstart.call($$.api, d3.event.sourceEvent);
	        }).on("zoom", function () {
	            $$.redrawForZoom.call($$);
	        }).on('zoomend', function () {
	            var event = d3.event.sourceEvent;
	            // if click, do nothing. otherwise, click interaction will be canceled.
	            if (event && startEvent.clientX === event.clientX && startEvent.clientY === event.clientY) {
	                return;
	            }
	            $$.redrawEventRect();
	            $$.updateZoom();
	            config.zoom_onzoomend.call($$.api, $$.x.orgDomain());
	        });
	        $$.zoom.scale = function (scale) {
	            return config.axis_rotated ? this.y(scale) : this.x(scale);
	        };
	        $$.zoom.orgScaleExtent = function () {
	            var extent = config.zoom_extent ? config.zoom_extent : [1, 10];
	            return [extent[0], Math.max($$.getMaxDataCount() / extent[1], extent[1])];
	        };
	        $$.zoom.updateScaleExtent = function () {
	            var ratio = diffDomain($$.x.orgDomain()) / diffDomain($$.getZoomDomain()),
	                extent = this.orgScaleExtent();
	            this.scaleExtent([extent[0] * ratio, extent[1] * ratio]);
	            return this;
	        };
	    };
	    c3_chart_internal_fn.getZoomDomain = function () {
	        var $$ = this,
	            config = $$.config,
	            d3 = $$.d3,
	            min = d3.min([$$.orgXDomain[0], config.zoom_x_min]),
	            max = d3.max([$$.orgXDomain[1], config.zoom_x_max]);
	        return [min, max];
	    };
	    c3_chart_internal_fn.updateZoom = function () {
	        var $$ = this,
	            z = $$.config.zoom_enabled ? $$.zoom : function () {};
	        $$.main.select('.' + CLASS.zoomRect).call(z).on("dblclick.zoom", null);
	        $$.main.selectAll('.' + CLASS.eventRect).call(z).on("dblclick.zoom", null);
	    };
	    c3_chart_internal_fn.redrawForZoom = function () {
	        var $$ = this,
	            d3 = $$.d3,
	            config = $$.config,
	            zoom = $$.zoom,
	            x = $$.x;
	        if (!config.zoom_enabled) {
	            return;
	        }
	        if ($$.filterTargetsToShow($$.data.targets).length === 0) {
	            return;
	        }
	        if (d3.event.sourceEvent.type === 'mousemove' && zoom.altDomain) {
	            x.domain(zoom.altDomain);
	            zoom.scale(x).updateScaleExtent();
	            return;
	        }
	        if ($$.isCategorized() && x.orgDomain()[0] === $$.orgXDomain[0]) {
	            x.domain([$$.orgXDomain[0] - 1e-10, x.orgDomain()[1]]);
	        }
	        $$.redraw({
	            withTransition: false,
	            withY: config.zoom_rescale,
	            withSubchart: false,
	            withEventRect: false,
	            withDimension: false
	        });
	        if (d3.event.sourceEvent.type === 'mousemove') {
	            $$.cancelClick = true;
	        }
	        config.zoom_onzoom.call($$.api, x.orgDomain());
	    };
	
	    return c3;
	
	})));


/***/ }),

/***/ 1248:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1249);
	__webpack_require__(1338);

/***/ }),

/***/ 1249:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	* @version: 2.1.27
	* @author: Dan Grossman http://www.dangrossman.info/
	* @copyright: Copyright (c) 2012-2017 Dan Grossman. All rights reserved.
	* @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
	* @website: http://www.daterangepicker.com/
	*/
	// Follow the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
	(function (root, factory) {
	    if (true) {
	        // AMD. Make globaly available as well
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1250), __webpack_require__(112)], __WEBPACK_AMD_DEFINE_RESULT__ = function (moment, jquery) {
	            if (!jquery.fn) jquery.fn = {}; // webpack server rendering
	            return factory(moment, jquery);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        // Node / Browserify
	        //isomorphic issue
	        var jQuery = (typeof window != 'undefined') ? window.jQuery : undefined;
	        if (!jQuery) {
	            jQuery = require('jquery');
	            if (!jQuery.fn) jQuery.fn = {};
	        }
	        var moment = (typeof window != 'undefined' && typeof window.moment != 'undefined') ? window.moment : require('moment');
	        module.exports = factory(moment, jQuery);
	    } else {
	        // Browser globals
	        root.daterangepicker = factory(root.moment, root.jQuery);
	    }
	}(this, function(moment, $) {
	    var DateRangePicker = function(element, options, cb) {
	
	        //default settings for options
	        this.parentEl = 'body';
	        this.element = $(element);
	        this.startDate = moment().startOf('day');
	        this.endDate = moment().endOf('day');
	        this.minDate = false;
	        this.maxDate = false;
	        this.dateLimit = false;
	        this.autoApply = false;
	        this.singleDatePicker = false;
	        this.showDropdowns = false;
	        this.showWeekNumbers = false;
	        this.showISOWeekNumbers = false;
	        this.showCustomRangeLabel = true;
	        this.timePicker = false;
	        this.timePicker24Hour = false;
	        this.timePickerIncrement = 1;
	        this.timePickerSeconds = false;
	        this.linkedCalendars = true;
	        this.autoUpdateInput = true;
	        this.alwaysShowCalendars = false;
	        this.ranges = {};
	
	        this.opens = 'right';
	        if (this.element.hasClass('pull-right'))
	            this.opens = 'left';
	
	        this.drops = 'down';
	        if (this.element.hasClass('dropup'))
	            this.drops = 'up';
	
	        this.buttonClasses = 'btn btn-sm';
	        this.applyClass = 'btn-success';
	        this.cancelClass = 'btn-default';
	
	        this.locale = {
	            direction: 'ltr',
	            format: moment.localeData().longDateFormat('L'),
	            separator: ' - ',
	            applyLabel: 'Apply',
	            cancelLabel: 'Cancel',
	            weekLabel: 'W',
	            customRangeLabel: 'Custom Range',
	            daysOfWeek: moment.weekdaysMin(),
	            monthNames: moment.monthsShort(),
	            firstDay: moment.localeData().firstDayOfWeek()
	        };
	
	        this.callback = function() { };
	
	        //some state information
	        this.isShowing = false;
	        this.leftCalendar = {};
	        this.rightCalendar = {};
	
	        //custom options from user
	        if (typeof options !== 'object' || options === null)
	            options = {};
	
	        //allow setting options with data attributes
	        //data-api options will be overwritten with custom javascript options
	        options = $.extend(this.element.data(), options);
	
	        //html template for the picker UI
	        if (typeof options.template !== 'string' && !(options.template instanceof $))
	            options.template = '<div class="daterangepicker dropdown-menu">' +
	                '<div class="calendar left">' +
	                    '<div class="daterangepicker_input">' +
	                      '<input class="input-mini form-control" type="text" name="daterangepicker_start" value="" />' +
	                      '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
	                      '<div class="calendar-time">' +
	                        '<div></div>' +
	                        '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
	                      '</div>' +
	                    '</div>' +
	                    '<div class="calendar-table"></div>' +
	                '</div>' +
	                '<div class="calendar right">' +
	                    '<div class="daterangepicker_input">' +
	                      '<input class="input-mini form-control" type="text" name="daterangepicker_end" value="" />' +
	                      '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
	                      '<div class="calendar-time">' +
	                        '<div></div>' +
	                        '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
	                      '</div>' +
	                    '</div>' +
	                    '<div class="calendar-table"></div>' +
	                '</div>' +
	                '<div class="ranges">' +
	                    '<div class="range_inputs">' +
	                        '<button class="applyBtn" disabled="disabled" type="button"></button> ' +
	                        '<button class="cancelBtn" type="button"></button>' +
	                    '</div>' +
	                '</div>' +
	            '</div>';
	
	        this.parentEl = (options.parentEl && $(options.parentEl).length) ? $(options.parentEl) : $(this.parentEl);
	        this.container = $(options.template).appendTo(this.parentEl);
	
	        //
	        // handle all the possible options overriding defaults
	        //
	
	        if (typeof options.locale === 'object') {
	
	            if (typeof options.locale.direction === 'string')
	                this.locale.direction = options.locale.direction;
	
	            if (typeof options.locale.format === 'string')
	                this.locale.format = options.locale.format;
	
	            if (typeof options.locale.separator === 'string')
	                this.locale.separator = options.locale.separator;
	
	            if (typeof options.locale.daysOfWeek === 'object')
	                this.locale.daysOfWeek = options.locale.daysOfWeek.slice();
	
	            if (typeof options.locale.monthNames === 'object')
	              this.locale.monthNames = options.locale.monthNames.slice();
	
	            if (typeof options.locale.firstDay === 'number')
	              this.locale.firstDay = options.locale.firstDay;
	
	            if (typeof options.locale.applyLabel === 'string')
	              this.locale.applyLabel = options.locale.applyLabel;
	
	            if (typeof options.locale.cancelLabel === 'string')
	              this.locale.cancelLabel = options.locale.cancelLabel;
	
	            if (typeof options.locale.weekLabel === 'string')
	              this.locale.weekLabel = options.locale.weekLabel;
	
	            if (typeof options.locale.customRangeLabel === 'string'){
	                //Support unicode chars in the custom range name.
	                var elem = document.createElement('textarea');
	                elem.innerHTML = options.locale.customRangeLabel;
	                var rangeHtml = elem.value;
	                this.locale.customRangeLabel = rangeHtml;
	            }
	        }
	        this.container.addClass(this.locale.direction);
	
	        if (typeof options.startDate === 'string')
	            this.startDate = moment(options.startDate, this.locale.format);
	
	        if (typeof options.endDate === 'string')
	            this.endDate = moment(options.endDate, this.locale.format);
	
	        if (typeof options.minDate === 'string')
	            this.minDate = moment(options.minDate, this.locale.format);
	
	        if (typeof options.maxDate === 'string')
	            this.maxDate = moment(options.maxDate, this.locale.format);
	
	        if (typeof options.startDate === 'object')
	            this.startDate = moment(options.startDate);
	
	        if (typeof options.endDate === 'object')
	            this.endDate = moment(options.endDate);
	
	        if (typeof options.minDate === 'object')
	            this.minDate = moment(options.minDate);
	
	        if (typeof options.maxDate === 'object')
	            this.maxDate = moment(options.maxDate);
	
	        // sanity check for bad options
	        if (this.minDate && this.startDate.isBefore(this.minDate))
	            this.startDate = this.minDate.clone();
	
	        // sanity check for bad options
	        if (this.maxDate && this.endDate.isAfter(this.maxDate))
	            this.endDate = this.maxDate.clone();
	
	        if (typeof options.applyClass === 'string')
	            this.applyClass = options.applyClass;
	
	        if (typeof options.cancelClass === 'string')
	            this.cancelClass = options.cancelClass;
	
	        if (typeof options.dateLimit === 'object')
	            this.dateLimit = options.dateLimit;
	
	        if (typeof options.opens === 'string')
	            this.opens = options.opens;
	
	        if (typeof options.drops === 'string')
	            this.drops = options.drops;
	
	        if (typeof options.showWeekNumbers === 'boolean')
	            this.showWeekNumbers = options.showWeekNumbers;
	
	        if (typeof options.showISOWeekNumbers === 'boolean')
	            this.showISOWeekNumbers = options.showISOWeekNumbers;
	
	        if (typeof options.buttonClasses === 'string')
	            this.buttonClasses = options.buttonClasses;
	
	        if (typeof options.buttonClasses === 'object')
	            this.buttonClasses = options.buttonClasses.join(' ');
	
	        if (typeof options.showDropdowns === 'boolean')
	            this.showDropdowns = options.showDropdowns;
	
	        if (typeof options.showCustomRangeLabel === 'boolean')
	            this.showCustomRangeLabel = options.showCustomRangeLabel;
	
	        if (typeof options.singleDatePicker === 'boolean') {
	            this.singleDatePicker = options.singleDatePicker;
	            if (this.singleDatePicker)
	                this.endDate = this.startDate.clone();
	        }
	
	        if (typeof options.timePicker === 'boolean')
	            this.timePicker = options.timePicker;
	
	        if (typeof options.timePickerSeconds === 'boolean')
	            this.timePickerSeconds = options.timePickerSeconds;
	
	        if (typeof options.timePickerIncrement === 'number')
	            this.timePickerIncrement = options.timePickerIncrement;
	
	        if (typeof options.timePicker24Hour === 'boolean')
	            this.timePicker24Hour = options.timePicker24Hour;
	
	        if (typeof options.autoApply === 'boolean')
	            this.autoApply = options.autoApply;
	
	        if (typeof options.autoUpdateInput === 'boolean')
	            this.autoUpdateInput = options.autoUpdateInput;
	
	        if (typeof options.linkedCalendars === 'boolean')
	            this.linkedCalendars = options.linkedCalendars;
	
	        if (typeof options.isInvalidDate === 'function')
	            this.isInvalidDate = options.isInvalidDate;
	
	        if (typeof options.isCustomDate === 'function')
	            this.isCustomDate = options.isCustomDate;
	
	        if (typeof options.alwaysShowCalendars === 'boolean')
	            this.alwaysShowCalendars = options.alwaysShowCalendars;
	
	        // update day names order to firstDay
	        if (this.locale.firstDay != 0) {
	            var iterator = this.locale.firstDay;
	            while (iterator > 0) {
	                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
	                iterator--;
	            }
	        }
	
	        var start, end, range;
	
	        //if no start/end dates set, check if an input element contains initial values
	        if (typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined') {
	            if ($(this.element).is('input[type=text]')) {
	                var val = $(this.element).val(),
	                    split = val.split(this.locale.separator);
	
	                start = end = null;
	
	                if (split.length == 2) {
	                    start = moment(split[0], this.locale.format);
	                    end = moment(split[1], this.locale.format);
	                } else if (this.singleDatePicker && val !== "") {
	                    start = moment(val, this.locale.format);
	                    end = moment(val, this.locale.format);
	                }
	                if (start !== null && end !== null) {
	                    this.setStartDate(start);
	                    this.setEndDate(end);
	                }
	            }
	        }
	
	        if (typeof options.ranges === 'object') {
	            for (range in options.ranges) {
	
	                if (typeof options.ranges[range][0] === 'string')
	                    start = moment(options.ranges[range][0], this.locale.format);
	                else
	                    start = moment(options.ranges[range][0]);
	
	                if (typeof options.ranges[range][1] === 'string')
	                    end = moment(options.ranges[range][1], this.locale.format);
	                else
	                    end = moment(options.ranges[range][1]);
	
	                // If the start or end date exceed those allowed by the minDate or dateLimit
	                // options, shorten the range to the allowable period.
	                if (this.minDate && start.isBefore(this.minDate))
	                    start = this.minDate.clone();
	
	                var maxDate = this.maxDate;
	                if (this.dateLimit && maxDate && start.clone().add(this.dateLimit).isAfter(maxDate))
	                    maxDate = start.clone().add(this.dateLimit);
	                if (maxDate && end.isAfter(maxDate))
	                    end = maxDate.clone();
	
	                // If the end of the range is before the minimum or the start of the range is
	                // after the maximum, don't display this range option at all.
	                if ((this.minDate && end.isBefore(this.minDate, this.timepicker ? 'minute' : 'day')) 
	                  || (maxDate && start.isAfter(maxDate, this.timepicker ? 'minute' : 'day')))
	                    continue;
	
	                //Support unicode chars in the range names.
	                var elem = document.createElement('textarea');
	                elem.innerHTML = range;
	                var rangeHtml = elem.value;
	
	                this.ranges[rangeHtml] = [start, end];
	            }
	
	            var list = '<ul>';
	            for (range in this.ranges) {
	                list += '<li data-range-key="' + range + '">' + range + '</li>';
	            }
	            if (this.showCustomRangeLabel) {
	                list += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + '</li>';
	            }
	            list += '</ul>';
	            this.container.find('.ranges').prepend(list);
	        }
	
	        if (typeof cb === 'function') {
	            this.callback = cb;
	        }
	
	        if (!this.timePicker) {
	            this.startDate = this.startDate.startOf('day');
	            this.endDate = this.endDate.endOf('day');
	            this.container.find('.calendar-time').hide();
	        }
	
	        //can't be used together for now
	        if (this.timePicker && this.autoApply)
	            this.autoApply = false;
	
	        if (this.autoApply && typeof options.ranges !== 'object') {
	            this.container.find('.ranges').hide();
	        } else if (this.autoApply) {
	            this.container.find('.applyBtn, .cancelBtn').addClass('hide');
	        }
	
	        if (this.singleDatePicker) {
	            this.container.addClass('single');
	            this.container.find('.calendar.left').addClass('single');
	            this.container.find('.calendar.left').show();
	            this.container.find('.calendar.right').hide();
	            this.container.find('.daterangepicker_input input, .daterangepicker_input > i').hide();
	            if (this.timePicker) {
	                this.container.find('.ranges ul').hide();
	            } else {
	                this.container.find('.ranges').hide();
	            }
	        }
	
	        if ((typeof options.ranges === 'undefined' && !this.singleDatePicker) || this.alwaysShowCalendars) {
	            this.container.addClass('show-calendar');
	        }
	
	        this.container.addClass('opens' + this.opens);
	
	        //swap the position of the predefined ranges if opens right
	        if (typeof options.ranges !== 'undefined' && this.opens == 'right') {
	            this.container.find('.ranges').prependTo( this.container.find('.calendar.left').parent() );
	        }
	
	        //apply CSS classes and labels to buttons
	        this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
	        if (this.applyClass.length)
	            this.container.find('.applyBtn').addClass(this.applyClass);
	        if (this.cancelClass.length)
	            this.container.find('.cancelBtn').addClass(this.cancelClass);
	        this.container.find('.applyBtn').html(this.locale.applyLabel);
	        this.container.find('.cancelBtn').html(this.locale.cancelLabel);
	
	        //
	        // event listeners
	        //
	
	        this.container.find('.calendar')
	            .on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this))
	            .on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
	            .on('mousedown.daterangepicker', 'td.available', $.proxy(this.clickDate, this))
	            .on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this))
	            .on('mouseleave.daterangepicker', 'td.available', $.proxy(this.updateFormInputs, this))
	            .on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this))
	            .on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this))
	            .on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this))
	            .on('click.daterangepicker', '.daterangepicker_input input', $.proxy(this.showCalendars, this))
	            .on('focus.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsFocused, this))
	            .on('blur.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsBlurred, this))
	            .on('change.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsChanged, this))
	            .on('keydown.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsKeydown, this));
	
	        this.container.find('.ranges')
	            .on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this))
	            .on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this))
	            .on('click.daterangepicker', 'li', $.proxy(this.clickRange, this))
	            .on('mouseenter.daterangepicker', 'li', $.proxy(this.hoverRange, this))
	            .on('mouseleave.daterangepicker', 'li', $.proxy(this.updateFormInputs, this));
	
	        if (this.element.is('input') || this.element.is('button')) {
	            this.element.on({
	                'click.daterangepicker': $.proxy(this.show, this),
	                'focus.daterangepicker': $.proxy(this.show, this),
	                'keyup.daterangepicker': $.proxy(this.elementChanged, this),
	                'keydown.daterangepicker': $.proxy(this.keydown, this) //IE 11 compatibility
	            });
	        } else {
	            this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
	            this.element.on('keydown.daterangepicker', $.proxy(this.toggle, this));
	        }
	
	        //
	        // if attached to a text input, set the initial value
	        //
	
	        if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
	            this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
	            this.element.trigger('change');
	        } else if (this.element.is('input') && this.autoUpdateInput) {
	            this.element.val(this.startDate.format(this.locale.format));
	            this.element.trigger('change');
	        }
	
	    };
	
	    DateRangePicker.prototype = {
	
	        constructor: DateRangePicker,
	
	        setStartDate: function(startDate) {
	            if (typeof startDate === 'string')
	                this.startDate = moment(startDate, this.locale.format);
	
	            if (typeof startDate === 'object')
	                this.startDate = moment(startDate);
	
	            if (!this.timePicker)
	                this.startDate = this.startDate.startOf('day');
	
	            if (this.timePicker && this.timePickerIncrement)
	                this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	
	            if (this.minDate && this.startDate.isBefore(this.minDate)) {
	                this.startDate = this.minDate.clone();
	                if (this.timePicker && this.timePickerIncrement)
	                    this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	            }
	
	            if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
	                this.startDate = this.maxDate.clone();
	                if (this.timePicker && this.timePickerIncrement)
	                    this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	            }
	
	            if (!this.isShowing)
	                this.updateElement();
	
	            this.updateMonthsInView();
	        },
	
	        setEndDate: function(endDate) {
	            if (typeof endDate === 'string')
	                this.endDate = moment(endDate, this.locale.format);
	
	            if (typeof endDate === 'object')
	                this.endDate = moment(endDate);
	
	            if (!this.timePicker)
	                this.endDate = this.endDate.add(1,'d').startOf('day').subtract(1,'second');
	
	            if (this.timePicker && this.timePickerIncrement)
	                this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	
	            if (this.endDate.isBefore(this.startDate))
	                this.endDate = this.startDate.clone();
	
	            if (this.maxDate && this.endDate.isAfter(this.maxDate))
	                this.endDate = this.maxDate.clone();
	
	            if (this.dateLimit && this.startDate.clone().add(this.dateLimit).isBefore(this.endDate))
	                this.endDate = this.startDate.clone().add(this.dateLimit);
	
	            this.previousRightTime = this.endDate.clone();
	
	            if (!this.isShowing)
	                this.updateElement();
	
	            this.updateMonthsInView();
	        },
	
	        isInvalidDate: function() {
	            return false;
	        },
	
	        isCustomDate: function() {
	            return false;
	        },
	
	        updateView: function() {
	            if (this.timePicker) {
	                this.renderTimePicker('left');
	                this.renderTimePicker('right');
	                if (!this.endDate) {
	                    this.container.find('.right .calendar-time select').attr('disabled', 'disabled').addClass('disabled');
	                } else {
	                    this.container.find('.right .calendar-time select').removeAttr('disabled').removeClass('disabled');
	                }
	            }
	            if (this.endDate) {
	                this.container.find('input[name="daterangepicker_end"]').removeClass('active');
	                this.container.find('input[name="daterangepicker_start"]').addClass('active');
	            } else {
	                this.container.find('input[name="daterangepicker_end"]').addClass('active');
	                this.container.find('input[name="daterangepicker_start"]').removeClass('active');
	            }
	            this.updateMonthsInView();
	            this.updateCalendars();
	            this.updateFormInputs();
	        },
	
	        updateMonthsInView: function() {
	            if (this.endDate) {
	
	                //if both dates are visible already, do nothing
	                if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month &&
	                    (this.startDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
	                    &&
	                    (this.endDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
	                    ) {
	                    return;
	                }
	
	                this.leftCalendar.month = this.startDate.clone().date(2);
	                if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) {
	                    this.rightCalendar.month = this.endDate.clone().date(2);
	                } else {
	                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
	                }
	
	            } else {
	                if (this.leftCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM')) {
	                    this.leftCalendar.month = this.startDate.clone().date(2);
	                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
	                }
	            }
	            if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
	              this.rightCalendar.month = this.maxDate.clone().date(2);
	              this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
	            }
	        },
	
	        updateCalendars: function() {
	
	            if (this.timePicker) {
	                var hour, minute, second;
	                if (this.endDate) {
	                    hour = parseInt(this.container.find('.left .hourselect').val(), 10);
	                    minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
	                    second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.left .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                } else {
	                    hour = parseInt(this.container.find('.right .hourselect').val(), 10);
	                    minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
	                    second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.right .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                }
	                this.leftCalendar.month.hour(hour).minute(minute).second(second);
	                this.rightCalendar.month.hour(hour).minute(minute).second(second);
	            }
	
	            this.renderCalendar('left');
	            this.renderCalendar('right');
	
	            //highlight any predefined range matching the current start and end dates
	            this.container.find('.ranges li').removeClass('active');
	            if (this.endDate == null) return;
	
	            this.calculateChosenLabel();
	        },
	
	        renderCalendar: function(side) {
	
	            //
	            // Build the matrix of dates that will populate the calendar
	            //
	
	            var calendar = side == 'left' ? this.leftCalendar : this.rightCalendar;
	            var month = calendar.month.month();
	            var year = calendar.month.year();
	            var hour = calendar.month.hour();
	            var minute = calendar.month.minute();
	            var second = calendar.month.second();
	            var daysInMonth = moment([year, month]).daysInMonth();
	            var firstDay = moment([year, month, 1]);
	            var lastDay = moment([year, month, daysInMonth]);
	            var lastMonth = moment(firstDay).subtract(1, 'month').month();
	            var lastYear = moment(firstDay).subtract(1, 'month').year();
	            var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
	            var dayOfWeek = firstDay.day();
	
	            //initialize a 6 rows x 7 columns array for the calendar
	            var calendar = [];
	            calendar.firstDay = firstDay;
	            calendar.lastDay = lastDay;
	
	            for (var i = 0; i < 6; i++) {
	                calendar[i] = [];
	            }
	
	            //populate the calendar with date objects
	            var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
	            if (startDay > daysInLastMonth)
	                startDay -= 7;
	
	            if (dayOfWeek == this.locale.firstDay)
	                startDay = daysInLastMonth - 6;
	
	            var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);
	
	            var col, row;
	            for (var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')) {
	                if (i > 0 && col % 7 === 0) {
	                    col = 0;
	                    row++;
	                }
	                calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
	                curDate.hour(12);
	
	                if (this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side == 'left') {
	                    calendar[row][col] = this.minDate.clone();
	                }
	
	                if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side == 'right') {
	                    calendar[row][col] = this.maxDate.clone();
	                }
	
	            }
	
	            //make the calendar object available to hoverDate/clickDate
	            if (side == 'left') {
	                this.leftCalendar.calendar = calendar;
	            } else {
	                this.rightCalendar.calendar = calendar;
	            }
	
	            //
	            // Display the calendar
	            //
	
	            var minDate = side == 'left' ? this.minDate : this.startDate;
	            var maxDate = this.maxDate;
	            var selected = side == 'left' ? this.startDate : this.endDate;
	            var arrow = this.locale.direction == 'ltr' ? {left: 'chevron-left', right: 'chevron-right'} : {left: 'chevron-right', right: 'chevron-left'};
	
	            var html = '<table class="table-condensed">';
	            html += '<thead>';
	            html += '<tr>';
	
	            // add empty cell for week number
	            if (this.showWeekNumbers || this.showISOWeekNumbers)
	                html += '<th></th>';
	
	            if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == 'left')) {
	                html += '<th class="prev available"><i class="fa fa-' + arrow.left + ' glyphicon glyphicon-' + arrow.left + '"></i></th>';
	            } else {
	                html += '<th></th>';
	            }
	
	            var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");
	
	            if (this.showDropdowns) {
	                var currentMonth = calendar[1][1].month();
	                var currentYear = calendar[1][1].year();
	                var maxYear = (maxDate && maxDate.year()) || (currentYear + 5);
	                var minYear = (minDate && minDate.year()) || (currentYear - 50);
	                var inMinYear = currentYear == minYear;
	                var inMaxYear = currentYear == maxYear;
	
	                var monthHtml = '<select class="monthselect">';
	                for (var m = 0; m < 12; m++) {
	                    if ((!inMinYear || m >= minDate.month()) && (!inMaxYear || m <= maxDate.month())) {
	                        monthHtml += "<option value='" + m + "'" +
	                            (m === currentMonth ? " selected='selected'" : "") +
	                            ">" + this.locale.monthNames[m] + "</option>";
	                    } else {
	                        monthHtml += "<option value='" + m + "'" +
	                            (m === currentMonth ? " selected='selected'" : "") +
	                            " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
	                    }
	                }
	                monthHtml += "</select>";
	
	                var yearHtml = '<select class="yearselect">';
	                for (var y = minYear; y <= maxYear; y++) {
	                    yearHtml += '<option value="' + y + '"' +
	                        (y === currentYear ? ' selected="selected"' : '') +
	                        '>' + y + '</option>';
	                }
	                yearHtml += '</select>';
	
	                dateHtml = monthHtml + yearHtml;
	            }
	
	            html += '<th colspan="5" class="month">' + dateHtml + '</th>';
	            if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == 'right' || this.singleDatePicker)) {
	                html += '<th class="next available"><i class="fa fa-' + arrow.right + ' glyphicon glyphicon-' + arrow.right + '"></i></th>';
	            } else {
	                html += '<th></th>';
	            }
	
	            html += '</tr>';
	            html += '<tr>';
	
	            // add week number label
	            if (this.showWeekNumbers || this.showISOWeekNumbers)
	                html += '<th class="week">' + this.locale.weekLabel + '</th>';
	
	            $.each(this.locale.daysOfWeek, function(index, dayOfWeek) {
	                html += '<th>' + dayOfWeek + '</th>';
	            });
	
	            html += '</tr>';
	            html += '</thead>';
	            html += '<tbody>';
	
	            //adjust maxDate to reflect the dateLimit setting in order to
	            //grey out end dates beyond the dateLimit
	            if (this.endDate == null && this.dateLimit) {
	                var maxLimit = this.startDate.clone().add(this.dateLimit).endOf('day');
	                if (!maxDate || maxLimit.isBefore(maxDate)) {
	                    maxDate = maxLimit;
	                }
	            }
	
	            for (var row = 0; row < 6; row++) {
	                html += '<tr>';
	
	                // add week number
	                if (this.showWeekNumbers)
	                    html += '<td class="week">' + calendar[row][0].week() + '</td>';
	                else if (this.showISOWeekNumbers)
	                    html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';
	
	                for (var col = 0; col < 7; col++) {
	
	                    var classes = [];
	
	                    //highlight today's date
	                    if (calendar[row][col].isSame(new Date(), "day"))
	                        classes.push('today');
	
	                    //highlight weekends
	                    if (calendar[row][col].isoWeekday() > 5)
	                        classes.push('weekend');
	
	                    //grey out the dates in other months displayed at beginning and end of this calendar
	                    if (calendar[row][col].month() != calendar[1][1].month())
	                        classes.push('off');
	
	                    //don't allow selection of dates before the minimum date
	                    if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day'))
	                        classes.push('off', 'disabled');
	
	                    //don't allow selection of dates after the maximum date
	                    if (maxDate && calendar[row][col].isAfter(maxDate, 'day'))
	                        classes.push('off', 'disabled');
	
	                    //don't allow selection of date if a custom function decides it's invalid
	                    if (this.isInvalidDate(calendar[row][col]))
	                        classes.push('off', 'disabled');
	
	                    //highlight the currently selected start date
	                    if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD'))
	                        classes.push('active', 'start-date');
	
	                    //highlight the currently selected end date
	                    if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD'))
	                        classes.push('active', 'end-date');
	
	                    //highlight dates in-between the selected dates
	                    if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate)
	                        classes.push('in-range');
	
	                    //apply custom classes for this date
	                    var isCustom = this.isCustomDate(calendar[row][col]);
	                    if (isCustom !== false) {
	                        if (typeof isCustom === 'string')
	                            classes.push(isCustom);
	                        else
	                            Array.prototype.push.apply(classes, isCustom);
	                    }
	
	                    var cname = '', disabled = false;
	                    for (var i = 0; i < classes.length; i++) {
	                        cname += classes[i] + ' ';
	                        if (classes[i] == 'disabled')
	                            disabled = true;
	                    }
	                    if (!disabled)
	                        cname += 'available';
	
	                    html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';
	
	                }
	                html += '</tr>';
	            }
	
	            html += '</tbody>';
	            html += '</table>';
	
	            this.container.find('.calendar.' + side + ' .calendar-table').html(html);
	
	        },
	
	        renderTimePicker: function(side) {
	
	            // Don't bother updating the time picker if it's currently disabled
	            // because an end date hasn't been clicked yet
	            if (side == 'right' && !this.endDate) return;
	
	            var html, selected, minDate, maxDate = this.maxDate;
	
	            if (this.dateLimit && (!this.maxDate || this.startDate.clone().add(this.dateLimit).isAfter(this.maxDate)))
	                maxDate = this.startDate.clone().add(this.dateLimit);
	
	            if (side == 'left') {
	                selected = this.startDate.clone();
	                minDate = this.minDate;
	            } else if (side == 'right') {
	                selected = this.endDate.clone();
	                minDate = this.startDate;
	
	                //Preserve the time already selected
	                var timeSelector = this.container.find('.calendar.right .calendar-time div');
	                if (timeSelector.html() != '') {
	
	                    selected.hour(timeSelector.find('.hourselect option:selected').val() || selected.hour());
	                    selected.minute(timeSelector.find('.minuteselect option:selected').val() || selected.minute());
	                    selected.second(timeSelector.find('.secondselect option:selected').val() || selected.second());
	
	                    if (!this.timePicker24Hour) {
	                        var ampm = timeSelector.find('.ampmselect option:selected').val();
	                        if (ampm === 'PM' && selected.hour() < 12)
	                            selected.hour(selected.hour() + 12);
	                        if (ampm === 'AM' && selected.hour() === 12)
	                            selected.hour(0);
	                    }
	
	                }
	
	                if (selected.isBefore(this.startDate))
	                    selected = this.startDate.clone();
	
	                if (maxDate && selected.isAfter(maxDate))
	                    selected = maxDate.clone();
	
	            }
	
	            //
	            // hours
	            //
	
	            html = '<select class="hourselect">';
	
	            var start = this.timePicker24Hour ? 0 : 1;
	            var end = this.timePicker24Hour ? 23 : 12;
	
	            for (var i = start; i <= end; i++) {
	                var i_in_24 = i;
	                if (!this.timePicker24Hour)
	                    i_in_24 = selected.hour() >= 12 ? (i == 12 ? 12 : i + 12) : (i == 12 ? 0 : i);
	
	                var time = selected.clone().hour(i_in_24);
	                var disabled = false;
	                if (minDate && time.minute(59).isBefore(minDate))
	                    disabled = true;
	                if (maxDate && time.minute(0).isAfter(maxDate))
	                    disabled = true;
	
	                if (i_in_24 == selected.hour() && !disabled) {
	                    html += '<option value="' + i + '" selected="selected">' + i + '</option>';
	                } else if (disabled) {
	                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
	                } else {
	                    html += '<option value="' + i + '">' + i + '</option>';
	                }
	            }
	
	            html += '</select> ';
	
	            //
	            // minutes
	            //
	
	            html += ': <select class="minuteselect">';
	
	            for (var i = 0; i < 60; i += this.timePickerIncrement) {
	                var padded = i < 10 ? '0' + i : i;
	                var time = selected.clone().minute(i);
	
	                var disabled = false;
	                if (minDate && time.second(59).isBefore(minDate))
	                    disabled = true;
	                if (maxDate && time.second(0).isAfter(maxDate))
	                    disabled = true;
	
	                if (selected.minute() == i && !disabled) {
	                    html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
	                } else if (disabled) {
	                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
	                } else {
	                    html += '<option value="' + i + '">' + padded + '</option>';
	                }
	            }
	
	            html += '</select> ';
	
	            //
	            // seconds
	            //
	
	            if (this.timePickerSeconds) {
	                html += ': <select class="secondselect">';
	
	                for (var i = 0; i < 60; i++) {
	                    var padded = i < 10 ? '0' + i : i;
	                    var time = selected.clone().second(i);
	
	                    var disabled = false;
	                    if (minDate && time.isBefore(minDate))
	                        disabled = true;
	                    if (maxDate && time.isAfter(maxDate))
	                        disabled = true;
	
	                    if (selected.second() == i && !disabled) {
	                        html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
	                    } else if (disabled) {
	                        html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
	                    } else {
	                        html += '<option value="' + i + '">' + padded + '</option>';
	                    }
	                }
	
	                html += '</select> ';
	            }
	
	            //
	            // AM/PM
	            //
	
	            if (!this.timePicker24Hour) {
	                html += '<select class="ampmselect">';
	
	                var am_html = '';
	                var pm_html = '';
	
	                if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate))
	                    am_html = ' disabled="disabled" class="disabled"';
	
	                if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate))
	                    pm_html = ' disabled="disabled" class="disabled"';
	
	                if (selected.hour() >= 12) {
	                    html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
	                } else {
	                    html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
	                }
	
	                html += '</select>';
	            }
	
	            this.container.find('.calendar.' + side + ' .calendar-time div').html(html);
	
	        },
	
	        updateFormInputs: function() {
	
	            //ignore mouse movements while an above-calendar text input has focus
	            if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
	                return;
	
	            this.container.find('input[name=daterangepicker_start]').val(this.startDate.format(this.locale.format));
	            if (this.endDate)
	                this.container.find('input[name=daterangepicker_end]').val(this.endDate.format(this.locale.format));
	
	            if (this.singleDatePicker || (this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate)))) {
	                this.container.find('button.applyBtn').removeAttr('disabled');
	            } else {
	                this.container.find('button.applyBtn').attr('disabled', 'disabled');
	            }
	
	        },
	
	        move: function() {
	            var parentOffset = { top: 0, left: 0 },
	                containerTop;
	            var parentRightEdge = $(window).width();
	            if (!this.parentEl.is('body')) {
	                parentOffset = {
	                    top: this.parentEl.offset().top - this.parentEl.scrollTop(),
	                    left: this.parentEl.offset().left - this.parentEl.scrollLeft()
	                };
	                parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
	            }
	
	            if (this.drops == 'up')
	                containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
	            else
	                containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
	            this.container[this.drops == 'up' ? 'addClass' : 'removeClass']('dropup');
	
	            if (this.opens == 'left') {
	                this.container.css({
	                    top: containerTop,
	                    right: parentRightEdge - this.element.offset().left - this.element.outerWidth(),
	                    left: 'auto'
	                });
	                if (this.container.offset().left < 0) {
	                    this.container.css({
	                        right: 'auto',
	                        left: 9
	                    });
	                }
	            } else if (this.opens == 'center') {
	                this.container.css({
	                    top: containerTop,
	                    left: this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2
	                            - this.container.outerWidth() / 2,
	                    right: 'auto'
	                });
	                if (this.container.offset().left < 0) {
	                    this.container.css({
	                        right: 'auto',
	                        left: 9
	                    });
	                }
	            } else {
	                this.container.css({
	                    top: containerTop,
	                    left: this.element.offset().left - parentOffset.left,
	                    right: 'auto'
	                });
	                if (this.container.offset().left + this.container.outerWidth() > $(window).width()) {
	                    this.container.css({
	                        left: 'auto',
	                        right: 0
	                    });
	                }
	            }
	        },
	
	        show: function(e) {
	            if (this.isShowing) return;
	
	            // Create a click proxy that is private to this instance of datepicker, for unbinding
	            this._outsideClickProxy = $.proxy(function(e) { this.outsideClick(e); }, this);
	
	            // Bind global datepicker mousedown for hiding and
	            $(document)
	              .on('mousedown.daterangepicker', this._outsideClickProxy)
	              // also support mobile devices
	              .on('touchend.daterangepicker', this._outsideClickProxy)
	              // also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
	              .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)
	              // and also close when focus changes to outside the picker (eg. tabbing between controls)
	              .on('focusin.daterangepicker', this._outsideClickProxy);
	
	            // Reposition the picker if the window is resized while it's open
	            $(window).on('resize.daterangepicker', $.proxy(function(e) { this.move(e); }, this));
	
	            this.oldStartDate = this.startDate.clone();
	            this.oldEndDate = this.endDate.clone();
	            this.previousRightTime = this.endDate.clone();
	
	            this.updateView();
	            this.container.show();
	            this.move();
	            this.element.trigger('show.daterangepicker', this);
	            this.isShowing = true;
	        },
	
	        hide: function(e) {
	            if (!this.isShowing) return;
	
	            //incomplete date selection, revert to last values
	            if (!this.endDate) {
	                this.startDate = this.oldStartDate.clone();
	                this.endDate = this.oldEndDate.clone();
	            }
	
	            //if a new date range was selected, invoke the user callback function
	            if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
	                this.callback(this.startDate, this.endDate, this.chosenLabel);
	
	            //if picker is attached to a text input, update it
	            this.updateElement();
	
	            $(document).off('.daterangepicker');
	            $(window).off('.daterangepicker');
	            this.container.hide();
	            this.element.trigger('hide.daterangepicker', this);
	            this.isShowing = false;
	        },
	
	        toggle: function(e) {
	            if (this.isShowing) {
	                this.hide();
	            } else {
	                this.show();
	            }
	        },
	
	        outsideClick: function(e) {
	            var target = $(e.target);
	            // if the page is clicked anywhere except within the daterangerpicker/button
	            // itself then call this.hide()
	            if (
	                // ie modal dialog fix
	                e.type == "focusin" ||
	                target.closest(this.element).length ||
	                target.closest(this.container).length ||
	                target.closest('.calendar-table').length
	                ) return;
	            this.hide();
	            this.element.trigger('outsideClick.daterangepicker', this);
	        },
	
	        showCalendars: function() {
	            this.container.addClass('show-calendar');
	            this.move();
	            this.element.trigger('showCalendar.daterangepicker', this);
	        },
	
	        hideCalendars: function() {
	            this.container.removeClass('show-calendar');
	            this.element.trigger('hideCalendar.daterangepicker', this);
	        },
	
	        hoverRange: function(e) {
	
	            //ignore mouse movements while an above-calendar text input has focus
	            if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
	                return;
	
	            var label = e.target.getAttribute('data-range-key');
	
	            if (label == this.locale.customRangeLabel) {
	                this.updateView();
	            } else {
	                var dates = this.ranges[label];
	                this.container.find('input[name=daterangepicker_start]').val(dates[0].format(this.locale.format));
	                this.container.find('input[name=daterangepicker_end]').val(dates[1].format(this.locale.format));
	            }
	
	        },
	
	        clickRange: function(e) {
	            var label = e.target.getAttribute('data-range-key');
	            this.chosenLabel = label;
	            if (label == this.locale.customRangeLabel) {
	                this.showCalendars();
	            } else {
	                var dates = this.ranges[label];
	                this.startDate = dates[0];
	                this.endDate = dates[1];
	
	                if (!this.timePicker) {
	                    this.startDate.startOf('day');
	                    this.endDate.endOf('day');
	                }
	
	                if (!this.alwaysShowCalendars)
	                    this.hideCalendars();
	                this.clickApply();
	            }
	        },
	
	        clickPrev: function(e) {
	            var cal = $(e.target).parents('.calendar');
	            if (cal.hasClass('left')) {
	                this.leftCalendar.month.subtract(1, 'month');
	                if (this.linkedCalendars)
	                    this.rightCalendar.month.subtract(1, 'month');
	            } else {
	                this.rightCalendar.month.subtract(1, 'month');
	            }
	            this.updateCalendars();
	        },
	
	        clickNext: function(e) {
	            var cal = $(e.target).parents('.calendar');
	            if (cal.hasClass('left')) {
	                this.leftCalendar.month.add(1, 'month');
	            } else {
	                this.rightCalendar.month.add(1, 'month');
	                if (this.linkedCalendars)
	                    this.leftCalendar.month.add(1, 'month');
	            }
	            this.updateCalendars();
	        },
	
	        hoverDate: function(e) {
	
	            //ignore mouse movements while an above-calendar text input has focus
	            //if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
	            //    return;
	
	            //ignore dates that can't be selected
	            if (!$(e.target).hasClass('available')) return;
	
	            //have the text inputs above calendars reflect the date being hovered over
	            var title = $(e.target).attr('data-title');
	            var row = title.substr(1, 1);
	            var col = title.substr(3, 1);
	            var cal = $(e.target).parents('.calendar');
	            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
	
	            if (this.endDate && !this.container.find('input[name=daterangepicker_start]').is(":focus")) {
	                this.container.find('input[name=daterangepicker_start]').val(date.format(this.locale.format));
	            } else if (!this.endDate && !this.container.find('input[name=daterangepicker_end]').is(":focus")) {
	                this.container.find('input[name=daterangepicker_end]').val(date.format(this.locale.format));
	            }
	
	            //highlight the dates between the start date and the date being hovered as a potential end date
	            var leftCalendar = this.leftCalendar;
	            var rightCalendar = this.rightCalendar;
	            var startDate = this.startDate;
	            if (!this.endDate) {
	                this.container.find('.calendar tbody td').each(function(index, el) {
	
	                    //skip week numbers, only look at dates
	                    if ($(el).hasClass('week')) return;
	
	                    var title = $(el).attr('data-title');
	                    var row = title.substr(1, 1);
	                    var col = title.substr(3, 1);
	                    var cal = $(el).parents('.calendar');
	                    var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];
	
	                    if ((dt.isAfter(startDate) && dt.isBefore(date)) || dt.isSame(date, 'day')) {
	                        $(el).addClass('in-range');
	                    } else {
	                        $(el).removeClass('in-range');
	                    }
	
	                });
	            }
	
	        },
	
	        clickDate: function(e) {
	
	            if (!$(e.target).hasClass('available')) return;
	
	            var title = $(e.target).attr('data-title');
	            var row = title.substr(1, 1);
	            var col = title.substr(3, 1);
	            var cal = $(e.target).parents('.calendar');
	            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
	
	            //
	            // this function needs to do a few things:
	            // * alternate between selecting a start and end date for the range,
	            // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
	            // * if autoapply is enabled, and an end date was chosen, apply the selection
	            // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
	            // * if one of the inputs above the calendars was focused, cancel that manual input
	            //
	
	            if (this.endDate || date.isBefore(this.startDate, 'day')) { //picking start
	                if (this.timePicker) {
	                    var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.left .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                    var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
	                    var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
	                    date = date.clone().hour(hour).minute(minute).second(second);
	                }
	                this.endDate = null;
	                this.setStartDate(date.clone());
	            } else if (!this.endDate && date.isBefore(this.startDate)) {
	                //special case: clicking the same date for start/end,
	                //but the time of the end date is before the start date
	                this.setEndDate(this.startDate.clone());
	            } else { // picking end
	                if (this.timePicker) {
	                    var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.right .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                    var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
	                    var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
	                    date = date.clone().hour(hour).minute(minute).second(second);
	                }
	                this.setEndDate(date.clone());
	                if (this.autoApply) {
	                  this.calculateChosenLabel();
	                  this.clickApply();
	                }
	            }
	
	            if (this.singleDatePicker) {
	                this.setEndDate(this.startDate);
	                if (!this.timePicker)
	                    this.clickApply();
	            }
	
	            this.updateView();
	
	            //This is to cancel the blur event handler if the mouse was in one of the inputs
	            e.stopPropagation();
	
	        },
	
	        calculateChosenLabel: function () {
	            var customRange = true;
	            var i = 0;
	            for (var range in this.ranges) {
	              if (this.timePicker) {
	                    var format = this.timePickerSeconds ? "YYYY-MM-DD hh:mm:ss" : "YYYY-MM-DD hh:mm";
	                    //ignore times when comparing dates if time picker seconds is not enabled
	                    if (this.startDate.format(format) == this.ranges[range][0].format(format) && this.endDate.format(format) == this.ranges[range][1].format(format)) {
	                        customRange = false;
	                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
	                        break;
	                    }
	                } else {
	                    //ignore times when comparing dates if time picker is not enabled
	                    if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
	                        customRange = false;
	                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
	                        break;
	                    }
	                }
	                i++;
	            }
	            if (customRange) {
	                if (this.showCustomRangeLabel) {
	                    this.chosenLabel = this.container.find('.ranges li:last').addClass('active').html();
	                } else {
	                    this.chosenLabel = null;
	                }
	                this.showCalendars();
	            }
	        },
	
	        clickApply: function(e) {
	            this.hide();
	            this.element.trigger('apply.daterangepicker', this);
	        },
	
	        clickCancel: function(e) {
	            this.startDate = this.oldStartDate;
	            this.endDate = this.oldEndDate;
	            this.hide();
	            this.element.trigger('cancel.daterangepicker', this);
	        },
	
	        monthOrYearChanged: function(e) {
	            var isLeft = $(e.target).closest('.calendar').hasClass('left'),
	                leftOrRight = isLeft ? 'left' : 'right',
	                cal = this.container.find('.calendar.'+leftOrRight);
	
	            // Month must be Number for new moment versions
	            var month = parseInt(cal.find('.monthselect').val(), 10);
	            var year = cal.find('.yearselect').val();
	
	            if (!isLeft) {
	                if (year < this.startDate.year() || (year == this.startDate.year() && month < this.startDate.month())) {
	                    month = this.startDate.month();
	                    year = this.startDate.year();
	                }
	            }
	
	            if (this.minDate) {
	                if (year < this.minDate.year() || (year == this.minDate.year() && month < this.minDate.month())) {
	                    month = this.minDate.month();
	                    year = this.minDate.year();
	                }
	            }
	
	            if (this.maxDate) {
	                if (year > this.maxDate.year() || (year == this.maxDate.year() && month > this.maxDate.month())) {
	                    month = this.maxDate.month();
	                    year = this.maxDate.year();
	                }
	            }
	
	            if (isLeft) {
	                this.leftCalendar.month.month(month).year(year);
	                if (this.linkedCalendars)
	                    this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
	            } else {
	                this.rightCalendar.month.month(month).year(year);
	                if (this.linkedCalendars)
	                    this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
	            }
	            this.updateCalendars();
	        },
	
	        timeChanged: function(e) {
	
	            var cal = $(e.target).closest('.calendar'),
	                isLeft = cal.hasClass('left');
	
	            var hour = parseInt(cal.find('.hourselect').val(), 10);
	            var minute = parseInt(cal.find('.minuteselect').val(), 10);
	            var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;
	
	            if (!this.timePicker24Hour) {
	                var ampm = cal.find('.ampmselect').val();
	                if (ampm === 'PM' && hour < 12)
	                    hour += 12;
	                if (ampm === 'AM' && hour === 12)
	                    hour = 0;
	            }
	
	            if (isLeft) {
	                var start = this.startDate.clone();
	                start.hour(hour);
	                start.minute(minute);
	                start.second(second);
	                this.setStartDate(start);
	                if (this.singleDatePicker) {
	                    this.endDate = this.startDate.clone();
	                } else if (this.endDate && this.endDate.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
	                    this.setEndDate(start.clone());
	                }
	            } else if (this.endDate) {
	                var end = this.endDate.clone();
	                end.hour(hour);
	                end.minute(minute);
	                end.second(second);
	                this.setEndDate(end);
	            }
	
	            //update the calendars so all clickable dates reflect the new time component
	            this.updateCalendars();
	
	            //update the form inputs above the calendars with the new time
	            this.updateFormInputs();
	
	            //re-render the time pickers because changing one selection can affect what's enabled in another
	            this.renderTimePicker('left');
	            this.renderTimePicker('right');
	
	        },
	
	        formInputsChanged: function(e) {
	            var isRight = $(e.target).closest('.calendar').hasClass('right');
	            var start = moment(this.container.find('input[name="daterangepicker_start"]').val(), this.locale.format);
	            var end = moment(this.container.find('input[name="daterangepicker_end"]').val(), this.locale.format);
	
	            if (start.isValid() && end.isValid()) {
	
	                if (isRight && end.isBefore(start))
	                    start = end.clone();
	
	                this.setStartDate(start);
	                this.setEndDate(end);
	
	                if (isRight) {
	                    this.container.find('input[name="daterangepicker_start"]').val(this.startDate.format(this.locale.format));
	                } else {
	                    this.container.find('input[name="daterangepicker_end"]').val(this.endDate.format(this.locale.format));
	                }
	
	            }
	
	            this.updateView();
	        },
	
	        formInputsFocused: function(e) {
	
	            // Highlight the focused input
	            this.container.find('input[name="daterangepicker_start"], input[name="daterangepicker_end"]').removeClass('active');
	            $(e.target).addClass('active');
	
	            // Set the state such that if the user goes back to using a mouse, 
	            // the calendars are aware we're selecting the end of the range, not
	            // the start. This allows someone to edit the end of a date range without
	            // re-selecting the beginning, by clicking on the end date input then
	            // using the calendar.
	            var isRight = $(e.target).closest('.calendar').hasClass('right');
	            if (isRight) {
	                this.endDate = null;
	                this.setStartDate(this.startDate.clone());
	                this.updateView();
	            }
	
	        },
	
	        formInputsBlurred: function(e) {
	
	            // this function has one purpose right now: if you tab from the first
	            // text input to the second in the UI, the endDate is nulled so that
	            // you can click another, but if you tab out without clicking anything
	            // or changing the input value, the old endDate should be retained
	
	            if (!this.endDate) {
	                var val = this.container.find('input[name="daterangepicker_end"]').val();
	                var end = moment(val, this.locale.format);
	                if (end.isValid()) {
	                    this.setEndDate(end);
	                    this.updateView();
	                }
	            }
	
	        },
	
	        formInputsKeydown: function(e) {
	            // This function ensures that if the 'enter' key was pressed in the input, then the calendars
	            // are updated with the startDate and endDate.
	            // This behaviour is automatic in Chrome/Firefox/Edge but not in IE 11 hence why this exists.
	            // Other browsers and versions of IE are untested and the behaviour is unknown.
	            if (e.keyCode === 13) {
	                // Prevent the calendar from being updated twice on Chrome/Firefox/Edge
	                e.preventDefault(); 
	                this.formInputsChanged(e);
	            }
	        },
	
	
	        elementChanged: function() {
	            if (!this.element.is('input')) return;
	            if (!this.element.val().length) return;
	
	            var dateString = this.element.val().split(this.locale.separator),
	                start = null,
	                end = null;
	
	            if (dateString.length === 2) {
	                start = moment(dateString[0], this.locale.format);
	                end = moment(dateString[1], this.locale.format);
	            }
	
	            if (this.singleDatePicker || start === null || end === null) {
	                start = moment(this.element.val(), this.locale.format);
	                end = start;
	            }
	
	            if (!start.isValid() || !end.isValid()) return;
	
	            this.setStartDate(start);
	            this.setEndDate(end);
	            this.updateView();
	        },
	
	        keydown: function(e) {
	            //hide on tab or enter
	            if ((e.keyCode === 9) || (e.keyCode === 13)) {
	                this.hide();
	            }
	
	            //hide on esc and prevent propagation
	            if (e.keyCode === 27) {
	                e.preventDefault();
	                e.stopPropagation();
	
	                this.hide();
	            }
	        },
	
	        updateElement: function() {
	            if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
	                this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
	                this.element.trigger('change');
	            } else if (this.element.is('input') && this.autoUpdateInput) {
	                this.element.val(this.startDate.format(this.locale.format));
	                this.element.trigger('change');
	            }
	        },
	
	        remove: function() {
	            this.container.remove();
	            this.element.off('.daterangepicker');
	            this.element.removeData();
	        }
	
	    };
	
	    $.fn.daterangepicker = function(options, callback) {
	        var implementOptions = $.extend(true, {}, $.fn.daterangepicker.defaultOptions, options);
	        this.each(function() {
	            var el = $(this);
	            if (el.data('daterangepicker'))
	                el.data('daterangepicker').remove();
	            el.data('daterangepicker', new DateRangePicker(el, implementOptions, callback));
	        });
	        return this;
	    };
	
	    return DateRangePicker;
	
	}));


/***/ }),

/***/ 1250:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1251);

/***/ }),

/***/ 1251:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.10.6
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, function () { 'use strict';
	
	    var hookCallback;
	
	    function utils_hooks__hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function create_utc__createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    function valid__isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            m._isValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated;
	
	            if (m._strict) {
	                m._isValid = m._isValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        return m._isValid;
	    }
	
	    function valid__createInvalid (flags) {
	        var m = create_utc__createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    var momentProperties = utils_hooks__hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (typeof from._isAMomentObject !== 'undefined') {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (typeof from._i !== 'undefined') {
	            to._i = from._i;
	        }
	        if (typeof from._f !== 'undefined') {
	            to._f = from._f;
	        }
	        if (typeof from._l !== 'undefined') {
	            to._l = from._l;
	        }
	        if (typeof from._strict !== 'undefined') {
	            to._strict = from._strict;
	        }
	        if (typeof from._tzm !== 'undefined') {
	            to._tzm = from._tzm;
	        }
	        if (typeof from._isUTC !== 'undefined') {
	            to._isUTC = from._isUTC;
	        }
	        if (typeof from._offset !== 'undefined') {
	            to._offset = from._offset;
	        }
	        if (typeof from._pf !== 'undefined') {
	            to._pf = getParsingFlags(from);
	        }
	        if (typeof from._locale !== 'undefined') {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (typeof val !== 'undefined') {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            utils_hooks__hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            return Math.ceil(number);
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function Locale() {
	    }
	
	    var locales = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && typeof module !== 'undefined' &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                __webpack_require__(1252)("./" + name);
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                locale_locales__getSetGlobalLocale(oldLocale);
	            } catch (e) { }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function locale_locales__getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (typeof values === 'undefined') {
	                data = locale_locales__getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, values) {
	        if (values !== null) {
	            values.abbr = name;
	            locales[name] = locales[name] || new Locale();
	            locales[name].set(values);
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    // returns locale data
	    function locale_locales__getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                get_set__set(this, unit, value);
	                utils_hooks__hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get_set__get(this, unit);
	            }
	        };
	    }
	
	    function get_set__get (mom, unit) {
	        return mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]();
	    }
	
	    function get_set__set (mom, unit, value) {
	        return mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	
	    // MOMENTS
	
	    function getSet (units, value) {
	        var unit;
	        if (typeof units === 'object') {
	            for (unit in units) {
	                this.set(unit, units[unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (typeof this[units] === 'function') {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '';
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	    var regexes = {};
	
	    function isFunction (sth) {
	        // https://github.com/moment/moment/issues/2325
	        return typeof sth === 'function' &&
	            Object.prototype.toString.call(sth) === '[object Function]';
	    }
	
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (typeof callback === 'number') {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  matchWord);
	    addRegexToken('MMMM', matchWord);
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m) {
	        return this._months[m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m) {
	        return this._monthsShort[m.month()];
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        // TODO: Move this out of here!
	        if (typeof value === 'string') {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (typeof value !== 'number') {
	                return mom;
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            utils_hooks__hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get_set__get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    function warn(msg) {
	        if (utils_hooks__hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (firstTime) {
	                warn(msg + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    utils_hooks__hooks.suppressDeprecationWarnings = false;
	
	    var from_string__isoRegex = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d{2}-\d{2}/],
	        ['YYYY-MM-DD', /\d{4}-\d{2}-\d{2}/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d{2}-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d{2}/],
	        ['YYYY-DDD', /\d{4}-\d{3}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /(T| )\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss', /(T| )\d\d:\d\d:\d\d/],
	        ['HH:mm', /(T| )\d\d:\d\d/],
	        ['HH', /(T| )\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = from_string__isoRegex.exec(string);
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(string)) {
	                    config._f = isoDates[i][0];
	                    break;
	                }
	            }
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(string)) {
	                    // match[6] should be 'T' or space
	                    config._f += (match[6] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (string.match(matchOffset)) {
	                config._f += 'Z';
	            }
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    utils_hooks__hooks.createFromInputFallback = deprecate(
	        'moment construction falls back to js Date. This is ' +
	        'discouraged and will be removed in upcoming major ' +
	        'release. Please refer to ' +
	        'https://github.com/moment/moment/issues/1407 for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    function createDate (y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        //the date constructor doesn't accept years < 1970
	        if (y < 1970) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	        if (y < 1970) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    utils_hooks__hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', false);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // firstDayOfWeek       0 = sun, 6 = sat
	    //                      the day of the week that starts the week
	    //                      (usually sunday or monday)
	    // firstDayOfWeekOfYear 0 = sun, 6 = sat
	    //                      the first week is the week that contains the first
	    //                      of this day of the week
	    //                      (eg. ISO weeks use thursday (4))
	    function weekOfYear(mom, firstDayOfWeek, firstDayOfWeekOfYear) {
	        var end = firstDayOfWeekOfYear - firstDayOfWeek,
	            daysToDayOfWeek = firstDayOfWeekOfYear - mom.day(),
	            adjustedMoment;
	
	
	        if (daysToDayOfWeek > end) {
	            daysToDayOfWeek -= 7;
	        }
	
	        if (daysToDayOfWeek < end - 7) {
	            daysToDayOfWeek += 7;
	        }
	
	        adjustedMoment = local__createLocal(mom).add(daysToDayOfWeek, 'd');
	        return {
	            week: Math.ceil(adjustedMoment.dayOfYear() / 7),
	            year: adjustedMoment.year()
	        };
	    }
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, firstDayOfWeekOfYear, firstDayOfWeek) {
	        var week1Jan = 6 + firstDayOfWeek - firstDayOfWeekOfYear, janX = createUTCDate(year, 0, 1 + week1Jan), d = janX.getUTCDay(), dayOfYear;
	        if (d < firstDayOfWeek) {
	            d += 7;
	        }
	
	        weekday = weekday != null ? 1 * weekday : firstDayOfWeek;
	
	        dayOfYear = 1 + week1Jan + 7 * (week - 1) - d + weekday;
	
	        return {
	            year: dayOfYear > 0 ? year : year - 1,
	            dayOfYear: dayOfYear > 0 ?  dayOfYear : daysInYear(year - 1) + dayOfYear
	        };
	    }
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        var now = new Date();
	        if (config._useUTC) {
	            return [now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()];
	        }
	        return [now.getFullYear(), now.getMonth(), now.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
	            week = defaults(w.w, 1);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < dow) {
	                    ++week;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, doy, dow);
	
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	
	    utils_hooks__hooks.ISO_8601 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === utils_hooks__hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (getParsingFlags(config).bigHour === true &&
	                config._a[HOUR] <= 12 &&
	                config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!valid__isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = [i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond];
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || locale_locales__getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return valid__createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else if (isDate(input)) {
	            config._d = input;
	        } else {
	            configFromInput(config);
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (input === undefined) {
	            config._d = new Date();
	        } else if (isDate(input)) {
	            config._d = new Date(+input);
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (typeof(input) === 'object') {
	            configFromObject(config);
	        } else if (typeof(input) === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function local__createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	         'moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
	         function () {
	             var other = local__createLocal.apply(null, arguments);
	             return other < this ? this : other;
	         }
	     );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            return other > this ? this : other;
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return local__createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 36e5; // 1000 * 60 * 60
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = locale_locales__getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchOffset);
	    addRegexToken('ZZ', matchOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(string) {
	        var matches = ((string || '').match(matchOffset) || []);
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? +input : +local__createLocal(input)) - (+res);
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(+res._d + diff);
	            utils_hooks__hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return local__createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    utils_hooks__hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(input);
	            }
	            if (Math.abs(input) < 16) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    utils_hooks__hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm) {
	            this.utcOffset(this._tzm);
	        } else if (typeof this._i === 'string') {
	            this.utcOffset(offsetFromString(this._i));
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        input = input ? local__createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (typeof this._isDSTShifted !== 'undefined') {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return !this._isUTC;
	    }
	
	    function isUtcOffset () {
	        return this._isUTC;
	    }
	
	    function isUtc () {
	        return this._isUTC && this._offset === 0;
	    }
	
	    var aspNetRegex = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    var create__isoRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;
	
	    function create__createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])        * sign,
	                h  : toInt(match[HOUR])        * sign,
	                m  : toInt(match[MINUTE])      * sign,
	                s  : toInt(match[SECOND])      * sign,
	                ms : toInt(match[MILLISECOND]) * sign
	            };
	        } else if (!!(match = create__isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                d : parseIso(match[4], sign),
	                h : parseIso(match[5], sign),
	                m : parseIso(match[6], sign),
	                s : parseIso(match[7], sign),
	                w : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    create__createDuration.fn = Duration.prototype;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = create__createDuration(val, period);
	            add_subtract__addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = duration._days,
	            months = duration._months;
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(+mom._d + milliseconds * isAdding);
	        }
	        if (days) {
	            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            utils_hooks__hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add_subtract__add      = createAdder(1, 'add');
	    var add_subtract__subtract = createAdder(-1, 'subtract');
	
	    function moment_calendar__calendar (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || local__createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            diff = this.diff(sod, 'days', true),
	            format = diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	        return this.format(formats && formats[format] || this.localeData().calendar(format, this, local__createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var inputMs;
	        units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this > +input;
	        } else {
	            inputMs = isMoment(input) ? +input : +local__createLocal(input);
	            return inputMs < +this.clone().startOf(units);
	        }
	    }
	
	    function isBefore (input, units) {
	        var inputMs;
	        units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this < +input;
	        } else {
	            inputMs = isMoment(input) ? +input : +local__createLocal(input);
	            return +this.clone().endOf(units) < inputMs;
	        }
	    }
	
	    function isBetween (from, to, units) {
	        return this.isAfter(from, units) && this.isBefore(to, units);
	    }
	
	    function isSame (input, units) {
	        var inputMs;
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this === +input;
	        } else {
	            inputMs = +local__createLocal(input);
	            return +(this.clone().startOf(units)) <= inputMs && inputMs <= +(this.clone().endOf(units));
	        }
	    }
	
	    function diff (input, units, asFloat) {
	        var that = cloneWithOffset(input, this),
	            zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4,
	            delta, output;
	
	        units = normalizeUnits(units);
	
	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	                units === 'minute' ? delta / 6e4 : // 1000 * 60
	                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	                delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        return -(wholeMonthDiff + adjust);
	    }
	
	    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function moment_format__toISOString () {
	        var m = this.clone().utc();
	        if (0 < m.year() && m.year() <= 9999) {
	            if ('function' === typeof Date.prototype.toISOString) {
	                // native implementation is ~50x faster, use it when we can
	                return this.toDate().toISOString();
	            } else {
	                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        } else {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    }
	
	    function format (inputString) {
	        var output = formatMoment(this, inputString || utils_hooks__hooks.defaultFormat);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	        return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(local__createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	        return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(local__createLocal(), withoutSuffix);
	    }
	
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = locale_locales__getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function to_type__valueOf () {
	        return +this._d - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(+this / 1000);
	    }
	
	    function toDate () {
	        return this._offset ? new Date(+this) : this._d;
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function moment_valid__isValid () {
	        return valid__isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // HELPERS
	
	    function weeksInYear(year, dow, doy) {
	        return weekOfYear(local__createLocal([year, 11, 31 + dow - doy]), dow, doy).week;
	    }
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        var year = weekOfYear(this, this.localeData()._week.dow, this.localeData()._week.doy).year;
	        return input == null ? year : this.add((input - year), 'y');
	    }
	
	    function getSetISOWeekYear (input) {
	        var year = weekOfYear(this, 1, 4).year;
	        return input == null ? year : this.add((input - year), 'y');
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    addFormatToken('Q', 0, 0, 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   matchWord);
	    addRegexToken('ddd',  matchWord);
	    addRegexToken('dddd', matchWord);
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config) {
	        var weekday = config._locale.weekdaysParse(input);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m) {
	        return this._weekdays[m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return this._weekdaysShort[m.day()];
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return this._weekdaysMin[m.day()];
	    }
	
	    function localeWeekdaysParse (weekdayName) {
	        var i, mom, regex;
	
	        this._weekdaysParse = this._weekdaysParse || [];
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            if (!this._weekdaysParse[i]) {
	                mom = local__createLocal([2000, 1]).day(i);
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, function () {
	        return this.hours() % 12 || 12;
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var momentPrototype__proto = Moment.prototype;
	
	    momentPrototype__proto.add          = add_subtract__add;
	    momentPrototype__proto.calendar     = moment_calendar__calendar;
	    momentPrototype__proto.clone        = clone;
	    momentPrototype__proto.diff         = diff;
	    momentPrototype__proto.endOf        = endOf;
	    momentPrototype__proto.format       = format;
	    momentPrototype__proto.from         = from;
	    momentPrototype__proto.fromNow      = fromNow;
	    momentPrototype__proto.to           = to;
	    momentPrototype__proto.toNow        = toNow;
	    momentPrototype__proto.get          = getSet;
	    momentPrototype__proto.invalidAt    = invalidAt;
	    momentPrototype__proto.isAfter      = isAfter;
	    momentPrototype__proto.isBefore     = isBefore;
	    momentPrototype__proto.isBetween    = isBetween;
	    momentPrototype__proto.isSame       = isSame;
	    momentPrototype__proto.isValid      = moment_valid__isValid;
	    momentPrototype__proto.lang         = lang;
	    momentPrototype__proto.locale       = locale;
	    momentPrototype__proto.localeData   = localeData;
	    momentPrototype__proto.max          = prototypeMax;
	    momentPrototype__proto.min          = prototypeMin;
	    momentPrototype__proto.parsingFlags = parsingFlags;
	    momentPrototype__proto.set          = getSet;
	    momentPrototype__proto.startOf      = startOf;
	    momentPrototype__proto.subtract     = add_subtract__subtract;
	    momentPrototype__proto.toArray      = toArray;
	    momentPrototype__proto.toObject     = toObject;
	    momentPrototype__proto.toDate       = toDate;
	    momentPrototype__proto.toISOString  = moment_format__toISOString;
	    momentPrototype__proto.toJSON       = moment_format__toISOString;
	    momentPrototype__proto.toString     = toString;
	    momentPrototype__proto.unix         = unix;
	    momentPrototype__proto.valueOf      = to_type__valueOf;
	
	    // Year
	    momentPrototype__proto.year       = getSetYear;
	    momentPrototype__proto.isLeapYear = getIsLeapYear;
	
	    // Week Year
	    momentPrototype__proto.weekYear    = getSetWeekYear;
	    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
	
	    // Quarter
	    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
	
	    // Month
	    momentPrototype__proto.month       = getSetMonth;
	    momentPrototype__proto.daysInMonth = getDaysInMonth;
	
	    // Week
	    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
	    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
	    momentPrototype__proto.weeksInYear    = getWeeksInYear;
	    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
	
	    // Day
	    momentPrototype__proto.date       = getSetDayOfMonth;
	    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
	    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
	    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
	    momentPrototype__proto.dayOfYear  = getSetDayOfYear;
	
	    // Hour
	    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
	
	    // Minute
	    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
	
	    // Second
	    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
	
	    // Millisecond
	    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
	
	    // Offset
	    momentPrototype__proto.utcOffset            = getSetOffset;
	    momentPrototype__proto.utc                  = setOffsetToUTC;
	    momentPrototype__proto.local                = setOffsetToLocal;
	    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
	    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    momentPrototype__proto.isDST                = isDaylightSavingTime;
	    momentPrototype__proto.isDSTShifted         = isDaylightSavingTimeShifted;
	    momentPrototype__proto.isLocal              = isLocal;
	    momentPrototype__proto.isUtcOffset          = isUtcOffset;
	    momentPrototype__proto.isUtc                = isUtc;
	    momentPrototype__proto.isUTC                = isUtc;
	
	    // Timezone
	    momentPrototype__proto.zoneAbbr = getZoneAbbr;
	    momentPrototype__proto.zoneName = getZoneName;
	
	    // Deprecations
	    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);
	
	    var momentPrototype = momentPrototype__proto;
	
	    function moment__createUnix (input) {
	        return local__createLocal(input * 1000);
	    }
	
	    function moment__createInZone () {
	        return local__createLocal.apply(null, arguments).parseZone();
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function locale_calendar__calendar (key, mom, now) {
	        var output = this._calendar[key];
	        return typeof output === 'function' ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (typeof output === 'function') ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return typeof format === 'function' ? format(output) : format.replace(/%s/i, output);
	    }
	
	    function locale_set__set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (typeof prop === 'function') {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _ordinalParseLenient.
	        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	    }
	
	    var prototype__proto = Locale.prototype;
	
	    prototype__proto._calendar       = defaultCalendar;
	    prototype__proto.calendar        = locale_calendar__calendar;
	    prototype__proto._longDateFormat = defaultLongDateFormat;
	    prototype__proto.longDateFormat  = longDateFormat;
	    prototype__proto._invalidDate    = defaultInvalidDate;
	    prototype__proto.invalidDate     = invalidDate;
	    prototype__proto._ordinal        = defaultOrdinal;
	    prototype__proto.ordinal         = ordinal;
	    prototype__proto._ordinalParse   = defaultOrdinalParse;
	    prototype__proto.preparse        = preParsePostFormat;
	    prototype__proto.postformat      = preParsePostFormat;
	    prototype__proto._relativeTime   = defaultRelativeTime;
	    prototype__proto.relativeTime    = relative__relativeTime;
	    prototype__proto.pastFuture      = pastFuture;
	    prototype__proto.set             = locale_set__set;
	
	    // Month
	    prototype__proto.months       =        localeMonths;
	    prototype__proto._months      = defaultLocaleMonths;
	    prototype__proto.monthsShort  =        localeMonthsShort;
	    prototype__proto._monthsShort = defaultLocaleMonthsShort;
	    prototype__proto.monthsParse  =        localeMonthsParse;
	
	    // Week
	    prototype__proto.week = localeWeek;
	    prototype__proto._week = defaultLocaleWeek;
	    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
	    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
	
	    // Day of Week
	    prototype__proto.weekdays       =        localeWeekdays;
	    prototype__proto._weekdays      = defaultLocaleWeekdays;
	    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
	    prototype__proto._weekdaysMin   = defaultLocaleWeekdaysMin;
	    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
	    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
	    prototype__proto.weekdaysParse  =        localeWeekdaysParse;
	
	    // Hours
	    prototype__proto.isPM = localeIsPM;
	    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
	    prototype__proto.meridiem = localeMeridiem;
	
	    function lists__get (format, index, field, setter) {
	        var locale = locale_locales__getLocale();
	        var utc = create_utc__createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function list (format, index, field, count, setter) {
	        if (typeof format === 'number') {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return lists__get(format, index, field, setter);
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < count; i++) {
	            out[i] = lists__get(format, i, field, setter);
	        }
	        return out;
	    }
	
	    function lists__listMonths (format, index) {
	        return list(format, index, 'months', 12, 'month');
	    }
	
	    function lists__listMonthsShort (format, index) {
	        return list(format, index, 'monthsShort', 12, 'month');
	    }
	
	    function lists__listWeekdays (format, index) {
	        return list(format, index, 'weekdays', 7, 'day');
	    }
	
	    function lists__listWeekdaysShort (format, index) {
	        return list(format, index, 'weekdaysShort', 7, 'day');
	    }
	
	    function lists__listWeekdaysMin (format, index) {
	        return list(format, index, 'weekdaysMin', 7, 'day');
	    }
	
	    locale_locales__getSetGlobalLocale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
	    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
	
	    var mathAbs = Math.abs;
	
	    function duration_abs__abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function duration_add_subtract__addSubtract (duration, input, value, direction) {
	        var other = create__createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function duration_add_subtract__add (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function duration_add_subtract__subtract (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function duration_as__valueOf () {
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function duration_get__get (units) {
	        units = normalizeUnits(units);
	        return this[units + 's']();
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this._data[name];
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        s: 45,  // seconds to minute
	        m: 45,  // minutes to hour
	        h: 22,  // hours to day
	        d: 26,  // days to month
	        M: 11   // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
	        var duration = create__createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds < thresholds.s && ['s', seconds]  ||
	                minutes === 1          && ['m']           ||
	                minutes < thresholds.m && ['mm', minutes] ||
	                hours   === 1          && ['h']           ||
	                hours   < thresholds.h && ['hh', hours]   ||
	                days    === 1          && ['d']           ||
	                days    < thresholds.d && ['dd', days]    ||
	                months  === 1          && ['M']           ||
	                months  < thresholds.M && ['MM', months]  ||
	                years   === 1          && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        var locale = this.localeData();
	        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var iso_string__abs = Math.abs;
	
	    function iso_string__toISOString() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        var seconds = iso_string__abs(this._milliseconds) / 1000;
	        var days         = iso_string__abs(this._days);
	        var months       = iso_string__abs(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        return (total < 0 ? '-' : '') +
	            'P' +
	            (Y ? Y + 'Y' : '') +
	            (M ? M + 'M' : '') +
	            (D ? D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? h + 'H' : '') +
	            (m ? m + 'M' : '') +
	            (s ? s + 'S' : '');
	    }
	
	    var duration_prototype__proto = Duration.prototype;
	
	    duration_prototype__proto.abs            = duration_abs__abs;
	    duration_prototype__proto.add            = duration_add_subtract__add;
	    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
	    duration_prototype__proto.as             = as;
	    duration_prototype__proto.asMilliseconds = asMilliseconds;
	    duration_prototype__proto.asSeconds      = asSeconds;
	    duration_prototype__proto.asMinutes      = asMinutes;
	    duration_prototype__proto.asHours        = asHours;
	    duration_prototype__proto.asDays         = asDays;
	    duration_prototype__proto.asWeeks        = asWeeks;
	    duration_prototype__proto.asMonths       = asMonths;
	    duration_prototype__proto.asYears        = asYears;
	    duration_prototype__proto.valueOf        = duration_as__valueOf;
	    duration_prototype__proto._bubble        = bubble;
	    duration_prototype__proto.get            = duration_get__get;
	    duration_prototype__proto.milliseconds   = milliseconds;
	    duration_prototype__proto.seconds        = seconds;
	    duration_prototype__proto.minutes        = minutes;
	    duration_prototype__proto.hours          = hours;
	    duration_prototype__proto.days           = days;
	    duration_prototype__proto.weeks          = weeks;
	    duration_prototype__proto.months         = months;
	    duration_prototype__proto.years          = years;
	    duration_prototype__proto.humanize       = humanize;
	    duration_prototype__proto.toISOString    = iso_string__toISOString;
	    duration_prototype__proto.toString       = iso_string__toISOString;
	    duration_prototype__proto.toJSON         = iso_string__toISOString;
	    duration_prototype__proto.locale         = locale;
	    duration_prototype__proto.localeData     = localeData;
	
	    // Deprecations
	    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
	    duration_prototype__proto.lang = lang;
	
	    // Side effect imports
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    utils_hooks__hooks.version = '2.10.6';
	
	    setHookCallback(local__createLocal);
	
	    utils_hooks__hooks.fn                    = momentPrototype;
	    utils_hooks__hooks.min                   = min;
	    utils_hooks__hooks.max                   = max;
	    utils_hooks__hooks.utc                   = create_utc__createUTC;
	    utils_hooks__hooks.unix                  = moment__createUnix;
	    utils_hooks__hooks.months                = lists__listMonths;
	    utils_hooks__hooks.isDate                = isDate;
	    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
	    utils_hooks__hooks.invalid               = valid__createInvalid;
	    utils_hooks__hooks.duration              = create__createDuration;
	    utils_hooks__hooks.isMoment              = isMoment;
	    utils_hooks__hooks.weekdays              = lists__listWeekdays;
	    utils_hooks__hooks.parseZone             = moment__createInZone;
	    utils_hooks__hooks.localeData            = locale_locales__getLocale;
	    utils_hooks__hooks.isDuration            = isDuration;
	    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
	    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
	    utils_hooks__hooks.defineLocale          = defineLocale;
	    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
	    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
	    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
	
	    var _moment = utils_hooks__hooks;
	
	    return _moment;
	
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1036)(module)))

/***/ }),

/***/ 1252:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 1253,
		"./af.js": 1253,
		"./ar": 1254,
		"./ar-ma": 1255,
		"./ar-ma.js": 1255,
		"./ar-sa": 1256,
		"./ar-sa.js": 1256,
		"./ar-tn": 1257,
		"./ar-tn.js": 1257,
		"./ar.js": 1254,
		"./az": 1258,
		"./az.js": 1258,
		"./be": 1259,
		"./be.js": 1259,
		"./bg": 1260,
		"./bg.js": 1260,
		"./bn": 1261,
		"./bn.js": 1261,
		"./bo": 1262,
		"./bo.js": 1262,
		"./br": 1263,
		"./br.js": 1263,
		"./bs": 1264,
		"./bs.js": 1264,
		"./ca": 1265,
		"./ca.js": 1265,
		"./cs": 1266,
		"./cs.js": 1266,
		"./cv": 1267,
		"./cv.js": 1267,
		"./cy": 1268,
		"./cy.js": 1268,
		"./da": 1269,
		"./da.js": 1269,
		"./de": 1270,
		"./de-at": 1271,
		"./de-at.js": 1271,
		"./de.js": 1270,
		"./el": 1272,
		"./el.js": 1272,
		"./en-au": 1273,
		"./en-au.js": 1273,
		"./en-ca": 1274,
		"./en-ca.js": 1274,
		"./en-gb": 1275,
		"./en-gb.js": 1275,
		"./eo": 1276,
		"./eo.js": 1276,
		"./es": 1277,
		"./es.js": 1277,
		"./et": 1278,
		"./et.js": 1278,
		"./eu": 1279,
		"./eu.js": 1279,
		"./fa": 1280,
		"./fa.js": 1280,
		"./fi": 1281,
		"./fi.js": 1281,
		"./fo": 1282,
		"./fo.js": 1282,
		"./fr": 1283,
		"./fr-ca": 1284,
		"./fr-ca.js": 1284,
		"./fr.js": 1283,
		"./fy": 1285,
		"./fy.js": 1285,
		"./gl": 1286,
		"./gl.js": 1286,
		"./he": 1287,
		"./he.js": 1287,
		"./hi": 1288,
		"./hi.js": 1288,
		"./hr": 1289,
		"./hr.js": 1289,
		"./hu": 1290,
		"./hu.js": 1290,
		"./hy-am": 1291,
		"./hy-am.js": 1291,
		"./id": 1292,
		"./id.js": 1292,
		"./is": 1293,
		"./is.js": 1293,
		"./it": 1294,
		"./it.js": 1294,
		"./ja": 1295,
		"./ja.js": 1295,
		"./jv": 1296,
		"./jv.js": 1296,
		"./ka": 1297,
		"./ka.js": 1297,
		"./km": 1298,
		"./km.js": 1298,
		"./ko": 1299,
		"./ko.js": 1299,
		"./lb": 1300,
		"./lb.js": 1300,
		"./lt": 1301,
		"./lt.js": 1301,
		"./lv": 1302,
		"./lv.js": 1302,
		"./me": 1303,
		"./me.js": 1303,
		"./mk": 1304,
		"./mk.js": 1304,
		"./ml": 1305,
		"./ml.js": 1305,
		"./mr": 1306,
		"./mr.js": 1306,
		"./ms": 1307,
		"./ms-my": 1308,
		"./ms-my.js": 1308,
		"./ms.js": 1307,
		"./my": 1309,
		"./my.js": 1309,
		"./nb": 1310,
		"./nb.js": 1310,
		"./ne": 1311,
		"./ne.js": 1311,
		"./nl": 1312,
		"./nl.js": 1312,
		"./nn": 1313,
		"./nn.js": 1313,
		"./pl": 1314,
		"./pl.js": 1314,
		"./pt": 1315,
		"./pt-br": 1316,
		"./pt-br.js": 1316,
		"./pt.js": 1315,
		"./ro": 1317,
		"./ro.js": 1317,
		"./ru": 1318,
		"./ru.js": 1318,
		"./si": 1319,
		"./si.js": 1319,
		"./sk": 1320,
		"./sk.js": 1320,
		"./sl": 1321,
		"./sl.js": 1321,
		"./sq": 1322,
		"./sq.js": 1322,
		"./sr": 1323,
		"./sr-cyrl": 1324,
		"./sr-cyrl.js": 1324,
		"./sr.js": 1323,
		"./sv": 1325,
		"./sv.js": 1325,
		"./ta": 1326,
		"./ta.js": 1326,
		"./th": 1327,
		"./th.js": 1327,
		"./tl-ph": 1328,
		"./tl-ph.js": 1328,
		"./tr": 1329,
		"./tr.js": 1329,
		"./tzl": 1330,
		"./tzl.js": 1330,
		"./tzm": 1331,
		"./tzm-latn": 1332,
		"./tzm-latn.js": 1332,
		"./tzm.js": 1331,
		"./uk": 1333,
		"./uk.js": 1333,
		"./uz": 1334,
		"./uz.js": 1334,
		"./vi": 1335,
		"./vi.js": 1335,
		"./zh-cn": 1336,
		"./zh-cn.js": 1336,
		"./zh-tw": 1337,
		"./zh-tw.js": 1337
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1252;


/***/ }),

/***/ 1253:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : afrikaans (af)
	//! author : Werner Mollentze : https://github.com/wernerm
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	}));

/***/ }),

/***/ 1254:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! Locale: Arabic (ar)
	//! Author: Abdel Said: https://github.com/abdelsaid
	//! Changes in months, weekdays: Ahmed Elkhatib
	//! Native plural forms: forabi https://github.com/forabi
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'كانون الثاني يناير',
	        'شباط فبراير',
	        'آذار مارس',
	        'نيسان أبريل',
	        'أيار مايو',
	        'حزيران يونيو',
	        'تموز يوليو',
	        'آب أغسطس',
	        'أيلول سبتمبر',
	        'تشرين الأول أكتوبر',
	        'تشرين الثاني نوفمبر',
	        'كانون الأول ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	
	}));

/***/ }),

/***/ 1255:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Moroccan Arabic (ar-ma)
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_ma = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_ma;
	
	}));

/***/ }),

/***/ 1256:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic Saudi Arabia (ar-sa)
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var ar_sa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_sa;
	
	}));

/***/ }),

/***/ 1257:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  : Tunisian Arabic (ar-tn)
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_tn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ar_tn;
	
	}));

/***/ }),

/***/ 1258:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : azerbaijani (az)
	//! author : topchiyev : https://github.com/topchiyev
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	
	}));

/***/ }),

/***/ 1259:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : belarusian (be)
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_'),
	            'accusative': 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_')
	        },
	        nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return months[nounCase][m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            'accusative': 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_')
	        },
	        nounCase = (/\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/).test(format) ?
	            'accusative' :
	            'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	
	    var be = moment.defineLocale('be', {
	        months : monthsCaseReplace,
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        ordinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	
	}));

/***/ }),

/***/ 1260:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : bulgarian (bg)
	//! author : Krasen Borisov : https://github.com/kraz
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	
	}));

/***/ }),

/***/ 1261:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (bn)
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেবুয়ারী_মার্চ_এপ্রিল_মে_জুন_জুলাই_অগাস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপর_মে_জুন_জুল_অগ_সেপ্ট_অক্টো_নভ_ডিসেম্'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পত্তিবার_শুক্রুবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পত্তি_শুক্রু_শনি'.split('_'),
	        weekdaysMin : 'রব_সম_মঙ্গ_বু_ব্রিহ_শু_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কএক সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকেল|রাত/,
	        isPM: function (input) {
	            return /^(দুপুর|বিকেল|রাত)$/.test(input);
	        },
	        //Bengali is a vast language its spoken
	        //in different forms in various parts of the world.
	        //I have just generalized with most common one used
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকেল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	
	}));

/***/ }),

/***/ 1262:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : tibetan (bo)
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        isPM: function (input) {
	            return /^(ཉིན་གུང|དགོང་དག|མཚན་མོ)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	
	}));

/***/ }),

/***/ 1263:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : breton (br)
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        ordinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	}));

/***/ }),

/***/ 1264:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : bosnian (bs)
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	
	}));

/***/ }),

/***/ 1265:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : catalan (ca)
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'LT:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	}));

/***/ }),

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : czech (cs)
	//! author : petrbela : https://github.com/petrbela
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	}));

/***/ }),

/***/ 1267:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : chuvash (cv)
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        ordinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	
	}));

/***/ }),

/***/ 1268:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh (cy)
	//! author : Robert Allen
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	}));

/***/ }),

/***/ 1269:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : danish (da)
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[I dag kl.] LT',
	            nextDay : '[I morgen kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[I går kl.] LT',
	            lastWeek : '[sidste] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	}));

/***/ }),

/***/ 1270:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : german (de)
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[Morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[Gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	}));

/***/ }),

/***/ 1271:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : austrian german (de-at)
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de_at = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[Morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[Gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de_at;
	
	}));

/***/ }),

/***/ 1272:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : modern greek (el)
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (typeof output === 'function') {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        ordinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	}));

/***/ }),

/***/ 1273:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : australian english (en-au)
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_au = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_au;
	
	}));

/***/ }),

/***/ 1274:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : canadian english (en-ca)
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ca = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM, YYYY',
	            LLL : 'D MMMM, YYYY h:mm A',
	            LLLL : 'dddd, D MMMM, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return en_ca;
	
	}));

/***/ }),

/***/ 1275:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : great britain english (en-gb)
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_gb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_gb;
	
	}));

/***/ }),

/***/ 1276:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : esperanto (eo)
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	        weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-an de] MMMM, YYYY',
	            LLL : 'D[-an de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'je %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        ordinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	
	}));

/***/ }),

/***/ 1277:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : spanish (es)
	//! author : Julio Napurí : https://github.com/julionc
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'Ene._Feb._Mar._Abr._May._Jun._Jul._Ago._Sep._Oct._Nov._Dic.'.split('_'),
	        monthsShort = 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_');
	
	    var es = moment.defineLocale('es', {
	        months : 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        weekdays : 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_'),
	        weekdaysShort : 'Dom._Lun._Mar._Mié._Jue._Vie._Sáb.'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Mi_Ju_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	}));

/***/ }),

/***/ 1278:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : estonian (et)
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	}));

/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : euskara (eu)
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	
	}));

/***/ }),

/***/ 1280:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian (fa)
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چندین ثانیه',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        ordinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	
	}));

/***/ }),

/***/ 1281:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : finnish (fi)
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	}));

/***/ }),

/***/ 1282:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : faroese (fo)
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	}));

/***/ }),

/***/ 1283:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : french (fr)
	//! author : John Fischer : https://github.com/jfroffice
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : '');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	}));

/***/ }),

/***/ 1284:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : canadian french (fr-ca)
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ca = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        }
	    });
	
	    return fr_ca;
	
	}));

/***/ }),

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : frisian (fy)
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	}));

/***/ }),

/***/ 1286:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : galician (gl)
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro'.split('_'),
	        monthsShort : 'Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.'.split('_'),
	        weekdays : 'Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado'.split('_'),
	        weekdaysShort : 'Dom._Lun._Mar._Mér._Xov._Ven._Sáb.'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Mé_Xo_Ve_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str === 'uns segundos') {
	                    return 'nuns segundos';
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return gl;
	
	}));

/***/ }),

/***/ 1287:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew (he)
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        }
	    });
	
	    return he;
	
	}));

/***/ }),

/***/ 1288:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hindi (hi)
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	
	}));

/***/ }),

/***/ 1289:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hrvatski (hr)
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_'),
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	
	}));

/***/ }),

/***/ 1290:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hungarian (hu)
	//! author : Adam Brunner : https://github.com/adambrunner
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number,
	            suffix;
	        switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hu;
	
	}));

/***/ }),

/***/ 1291:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian (hy-am)
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_'),
	            'accusative': 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_')
	        },
	        nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return months[nounCase][m.month()];
	    }
	    function monthsShortCaseReplace(m, format) {
	        var monthsShort = 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_');
	        return monthsShort[m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_');
	        return weekdays[m.day()];
	    }
	
	    var hy_am = moment.defineLocale('hy-am', {
	        months : monthsCaseReplace,
	        monthsShort : monthsShortCaseReplace,
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hy_am;
	
	}));

/***/ }),

/***/ 1292:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Indonesia (id)
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	
	}));

/***/ }),

/***/ 1293:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : icelandic (is)
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	}));

/***/ }),

/***/ 1294:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : italian (it)
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	        weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	        weekdaysMin : 'D_L_Ma_Me_G_V_S'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	}));

/***/ }),

/***/ 1295:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : japanese (ja)
	//! author : LI Long : https://github.com/baryon
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'Ah時m分',
	            LTS : 'Ah時m分s秒',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah時m分',
	            LLLL : 'YYYY年M月D日Ah時m分 dddd'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : '[来週]dddd LT',
	            lastDay : '[昨日] LT',
	            lastWeek : '[前週]dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	}));

/***/ }),

/***/ 1296:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Boso Jowo (jv)
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	
	}));

/***/ }),

/***/ 1297:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian (ka)
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            'accusative': 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        nounCase = (/D[oD] *MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return months[nounCase][m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            'accusative': 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_')
	        },
	        nounCase = (/(წინა|შემდეგ)/).test(format) ?
	            'accusative' :
	            'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	
	    var ka = moment.defineLocale('ka', {
	        months : monthsCaseReplace,
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	}));

/***/ }),

/***/ 1298:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : khmer (km)
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មិនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        monthsShort: 'មករា_កុម្ភៈ_មិនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនៈ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	}));

/***/ }),

/***/ 1299:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : korean (ko)
	//!
	//! authors
	//!
	//! - Kyungwook, Park : https://github.com/kyungw00k
	//! - Jeeeyul Lee <jeeeyul@gmail.com>
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h시 m분',
	            LTS : 'A h시 m분 s초',
	            L : 'YYYY.MM.DD',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h시 m분',
	            LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇초',
	            ss : '%d초',
	            m : '일분',
	            mm : '%d분',
	            h : '한시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한달',
	            MM : '%d달',
	            y : '일년',
	            yy : '%d년'
	        },
	        ordinalParse : /\d{1,2}일/,
	        ordinal : '%d일',
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	}));

/***/ }),

/***/ 1300:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish (lb)
	//! author : mweimerskirch : https://github.com/mweimerskirch, David Raison : https://github.com/kwisatz
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	}));

/***/ }),

/***/ 1301:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian (lt)
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    },
	    weekDays = 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_');
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function monthsCaseReplace(m, format) {
	        var months = {
	                'nominative': 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	                'accusative': 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_')
	            },
	            nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
	                'accusative' :
	                'nominative';
	        return months[nounCase][m.month()];
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    function relativeWeekDay(moment, format) {
	        var nominative = format.indexOf('dddd HH:mm') === -1,
	            weekDay = weekDays[moment.day()];
	        return nominative ? weekDay : weekDay.substring(0, weekDay.length - 2) + 'į';
	    }
	
	    var lt = moment.defineLocale('lt', {
	        months : monthsCaseReplace,
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : relativeWeekDay,
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	}));

/***/ }),

/***/ 1302:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : latvian (lv)
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	}));

/***/ }),

/***/ 1303:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin (me)
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'],
	        monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun', 'jul', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
	        weekdays: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota'],
	        weekdaysShort: ['ned.', 'pon.', 'uto.', 'sri.', 'čet.', 'pet.', 'sub.'],
	        weekdaysMin: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	
	}));

/***/ }),

/***/ 1304:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : macedonian (mk)
	//! author : Borislav Mickov : https://github.com/B0k0
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : 'dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Во изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Во изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	
	}));

/***/ }),

/***/ 1305:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : malayalam (ml)
	//! author : Floyd Pink : https://github.com/floydpink
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        isPM : function (input) {
	            return /^(ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	}));

/***/ }),

/***/ 1306:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi (mr)
	//! author : Harshad Kale : https://github.com/kalehv
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s नंतर',
	            past : '%s पूर्वी',
	            s : 'सेकंद',
	            m: 'एक मिनिट',
	            mm: '%d मिनिटे',
	            h : 'एक तास',
	            hh : '%d तास',
	            d : 'एक दिवस',
	            dd : '%d दिवस',
	            M : 'एक महिना',
	            MM : '%d महिने',
	            y : 'एक वर्ष',
	            yy : '%d वर्षे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	
	}));

/***/ }),

/***/ 1307:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Malaysia (ms-MY)
	//! author : Weldan Jamili : https://github.com/weldan
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	
	}));

/***/ }),

/***/ 1308:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Malaysia (ms-MY)
	//! author : Weldan Jamili : https://github.com/weldan
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms_my = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms_my;
	
	}));

/***/ }),

/***/ 1309:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese (my)
	//! author : Squar team, mysquar.com
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	
	}));

/***/ }),

/***/ 1310:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : norwegian bokmål (nb)
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tirs_ons_tors_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'H.mm',
	            LTS : 'H.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H.mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] H.mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'for %s siden',
	            s : 'noen sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	}));

/***/ }),

/***/ 1311:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : nepali/nepalese
	//! author : suvash : https://github.com/suvash
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आइ._सो._मङ्_बु._बि._शु._श.'.split('_'),
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राती|बिहान|दिउँसो|बेलुका|साँझ|राती/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 3 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'बेलुका' || meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राती';
	            } else if (hour < 10) {
	                return 'बिहान';
	            } else if (hour < 15) {
	                return 'दिउँसो';
	            } else if (hour < 18) {
	                return 'बेलुका';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राती';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोली] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडी',
	            s : 'केही समय',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	
	}));

/***/ }),

/***/ 1312:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : dutch (nl)
	//! author : Joris Röling : https://github.com/jjupiter
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	}));

/***/ }),

/***/ 1313:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : norwegian nynorsk (nn)
	//! author : https://github.com/mechuwind
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'for %s sidan',
	            s : 'nokre sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	}));

/***/ }),

/***/ 1314:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : polish (pl)
	//! author : Rafal Hirsz : https://github.com/evoL
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'nie_pon_wt_śr_czw_pt_sb'.split('_'),
	        weekdaysMin : 'N_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: '[W] dddd [o] LT',
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	}));

/***/ }),

/***/ 1315:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : portuguese (pt)
	//! author : Jefferson : https://github.com/jalex79
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	}));

/***/ }),

/***/ 1316:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : brazilian portuguese (pt-br)
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt_br = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : '%s atrás',
	            s : 'poucos segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return pt_br;
	
	}));

/***/ }),

/***/ 1317:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : romanian (ro)
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	
	}));

/***/ }),

/***/ 1318:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : russian (ru)
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	            'accusative': 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_')
	        },
	        nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return months[nounCase][m.month()];
	    }
	    function monthsShortCaseReplace(m, format) {
	        var monthsShort = {
	            'nominative': 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	            'accusative': 'янв_фев_мар_апр_мая_июня_июля_авг_сен_окт_ноя_дек'.split('_')
	        },
	        nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return monthsShort[nounCase][m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            'accusative': 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_')
	        },
	        nounCase = (/\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/).test(format) ?
	            'accusative' :
	            'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	
	    var ru = moment.defineLocale('ru', {
	        months : monthsCaseReplace,
	        monthsShort : monthsShortCaseReplace,
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[й|я]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i],
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня в] LT',
	            nextDay: '[Завтра в] LT',
	            lastDay: '[Вчера в] LT',
	            nextWeek: function () {
	                return this.day() === 2 ? '[Во] dddd [в] LT' : '[В] dddd [в] LT';
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ru;
	
	}));

/***/ }),

/***/ 1319:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese (si)
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        ordinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	}));

/***/ }),

/***/ 1320:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : slovak (sk)
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	}));

/***/ }),

/***/ 1321:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : slovenian (sl)
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	
	}));

/***/ }),

/***/ 1322:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian (sq)
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author: Menelion Elensúle: https://github.com/Oire (tests)
	//! author : Oerd Cukalla : https://github.com/oerd (fixes)
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	}));

/***/ }),

/***/ 1323:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian-latin (sr)
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'],
	        monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun', 'jul', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
	        weekdays: ['nedelja', 'ponedeljak', 'utorak', 'sreda', 'četvrtak', 'petak', 'subota'],
	        weekdaysShort: ['ned.', 'pon.', 'uto.', 'sre.', 'čet.', 'pet.', 'sub.'],
	        weekdaysMin: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	
	}));

/***/ }),

/***/ 1324:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian-cyrillic (sr-cyrl)
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr_cyrl = moment.defineLocale('sr-cyrl', {
	        months: ['јануар', 'фебруар', 'март', 'април', 'мај', 'јун', 'јул', 'август', 'септембар', 'октобар', 'новембар', 'децембар'],
	        monthsShort: ['јан.', 'феб.', 'мар.', 'апр.', 'мај', 'јун', 'јул', 'авг.', 'сеп.', 'окт.', 'нов.', 'дец.'],
	        weekdays: ['недеља', 'понедељак', 'уторак', 'среда', 'четвртак', 'петак', 'субота'],
	        weekdaysShort: ['нед.', 'пон.', 'уто.', 'сре.', 'чет.', 'пет.', 'суб.'],
	        weekdaysMin: ['не', 'по', 'ут', 'ср', 'че', 'пе', 'су'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr_cyrl;
	
	}));

/***/ }),

/***/ 1325:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : swedish (sv)
	//! author : Jens Alm : https://github.com/ulmus
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	}));

/***/ }),

/***/ 1326:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : tamil (ta)
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        ordinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	
	}));

/***/ }),

/***/ 1327:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : thai (th)
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'มกรา_กุมภา_มีนา_เมษา_พฤษภา_มิถุนา_กรกฎา_สิงหา_กันยา_ตุลา_พฤศจิกา_ธันวา'.split('_'),
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        longDateFormat : {
	            LT : 'H นาฬิกา m นาที',
	            LTS : 'H นาฬิกา m นาที s วินาที',
	            L : 'YYYY/MM/DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H นาฬิกา m นาที',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H นาฬิกา m นาที'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	}));

/***/ }),

/***/ 1328:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog/Filipino (tl-ph)
	//! author : Dan Hagman
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tl_ph = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ngayon sa] LT',
	            nextDay: '[Bukas sa] LT',
	            nextWeek: 'dddd [sa] LT',
	            lastDay: '[Kahapon sa] LT',
	            lastWeek: 'dddd [huling linggo] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tl_ph;
	
	}));

/***/ }),

/***/ 1329:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : turkish (tr)
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[haftaya] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen hafta] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '\'ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	
	}));

/***/ }),

/***/ 1330:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : talossan (tzl)
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v with the help of Iustì Canun
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'LT.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY LT',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY LT'
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', ' ' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', ' ' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', ' ' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', ' ' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', ' ' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1].trim());
	    }
	
	    return tzl;
	
	}));

/***/ }),

/***/ 1331:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Morocco Central Atlas Tamaziɣt (tzm)
	//! author : Abdel Said : https://github.com/abdelsaid
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	}));

/***/ }),

/***/ 1332:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Morocco Central Atlas Tamaziɣt in Latin (tzm-latn)
	//! author : Abdel Said : https://github.com/abdelsaid
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm_latn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm_latn;
	
	}));

/***/ }),

/***/ 1333:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : ukrainian (uk)
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'хвилина_хвилини_хвилин',
	            'hh': 'година_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_'),
	            'accusative': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_')
	        },
	        nounCase = (/D[oD]? *MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return months[nounCase][m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        },
	        nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : monthsCaseReplace,
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	
	}));

/***/ }),

/***/ 1334:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : uzbek (uz)
	//! author : Sardor Muminov : https://github.com/muminoff
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	}));

/***/ }),

/***/ 1335:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : vietnamese (vi)
	//! author : Bang Nguyen : https://github.com/bangnk
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	}));

/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : chinese (zh-cn)
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_cn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah点mm分',
	            LTS : 'Ah点m分s秒',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah点mm分',
	            LLLL : 'YYYY年MMMD日ddddAh点mm分',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah点mm分',
	            llll : 'YYYY年MMMD日ddddAh点mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : function () {
	                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	            },
	            nextDay : function () {
	                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	            },
	            lastDay : function () {
	                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	            },
	            nextWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() - startOfWeek.unix() >= 7 * 24 * 3600 ? '[下]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            lastWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            sameElse : 'LL'
	        },
	        ordinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zh_cn;
	
	}));

/***/ }),

/***/ 1337:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : traditional chinese (zh-tw)
	//! author : Ben : https://github.com/ben-lin
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1251)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_tw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah點mm分',
	            LTS : 'Ah點m分s秒',
	            L : 'YYYY年MMMD日',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah點mm分',
	            LLLL : 'YYYY年MMMD日ddddAh點mm分',
	            l : 'YYYY年MMMD日',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah點mm分',
	            llll : 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            m : '一分鐘',
	            mm : '%d分鐘',
	            h : '一小時',
	            hh : '%d小時',
	            d : '一天',
	            dd : '%d天',
	            M : '一個月',
	            MM : '%d個月',
	            y : '一年',
	            yy : '%d年'
	        }
	    });
	
	    return zh_tw;
	
	}));

/***/ }),

/***/ 1338:
983

/******/ })));


// WEBPACK FOOTER //
// vendor.bundle.js